
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirebc01"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirebc01"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("cKvYK", function(module, exports) {
"use strict";

module.exports = (parcelRequire("getKs"));

});
parcelRegister("getKs", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $bd15078e983a2521$export$ffb0004e005737fa, (v) => $bd15078e983a2521$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $bd15078e983a2521$export$34b9dba7ce09269b, (v) => $bd15078e983a2521$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $bd15078e983a2521$export$25062201e9e25d76, (v) => $bd15078e983a2521$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bd15078e983a2521$export$ffb0004e005737fa;
var $bd15078e983a2521$export$34b9dba7ce09269b;
var $bd15078e983a2521$export$25062201e9e25d76;
"use strict";

var $kc00y = parcelRequire("kc00y");
var $bd15078e983a2521$var$k = Symbol.for("react.element"), $bd15078e983a2521$var$l = Symbol.for("react.fragment"), $bd15078e983a2521$var$m = Object.prototype.hasOwnProperty, $bd15078e983a2521$var$n = $kc00y.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $bd15078e983a2521$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $bd15078e983a2521$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$bd15078e983a2521$var$m.call(a, b) && !$bd15078e983a2521$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $bd15078e983a2521$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $bd15078e983a2521$var$n.current
    };
}
$bd15078e983a2521$export$ffb0004e005737fa = $bd15078e983a2521$var$l;
$bd15078e983a2521$export$34b9dba7ce09269b = $bd15078e983a2521$var$q;
$bd15078e983a2521$export$25062201e9e25d76 = $bd15078e983a2521$var$q;

});
parcelRegister("kc00y", function(module, exports) {
"use strict";

module.exports = (parcelRequire("2gdtR"));

});
parcelRegister("2gdtR", function(module, exports) {

$parcel$export(module.exports, "Children", () => $1a57885a3215e64f$export$dca3b0875bd9a954, (v) => $1a57885a3215e64f$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $1a57885a3215e64f$export$16fa2f45be04daa8, (v) => $1a57885a3215e64f$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $1a57885a3215e64f$export$ffb0004e005737fa, (v) => $1a57885a3215e64f$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $1a57885a3215e64f$export$e2c29f18771995cb, (v) => $1a57885a3215e64f$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $1a57885a3215e64f$export$221d75b3f55bb0bd, (v) => $1a57885a3215e64f$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $1a57885a3215e64f$export$5f8d39834fd61797, (v) => $1a57885a3215e64f$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $1a57885a3215e64f$export$74bf444e3cd11ea5, (v) => $1a57885a3215e64f$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $1a57885a3215e64f$export$ae55be85d98224ed, (v) => $1a57885a3215e64f$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "act", () => $1a57885a3215e64f$export$3ba232387fd5d6dd, (v) => $1a57885a3215e64f$export$3ba232387fd5d6dd = v);
$parcel$export(module.exports, "cloneElement", () => $1a57885a3215e64f$export$e530037191fcd5d7, (v) => $1a57885a3215e64f$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $1a57885a3215e64f$export$fd42f52fd3ae1109, (v) => $1a57885a3215e64f$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $1a57885a3215e64f$export$c8a8987d4410bf2d, (v) => $1a57885a3215e64f$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $1a57885a3215e64f$export$d38cd72104c1f0e9, (v) => $1a57885a3215e64f$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $1a57885a3215e64f$export$7d1e3a5e95ceca43, (v) => $1a57885a3215e64f$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $1a57885a3215e64f$export$257a8862b851cb5b, (v) => $1a57885a3215e64f$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $1a57885a3215e64f$export$a8257692ac88316c, (v) => $1a57885a3215e64f$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $1a57885a3215e64f$export$488013bae63b21da, (v) => $1a57885a3215e64f$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $1a57885a3215e64f$export$7c73462e0d25e514, (v) => $1a57885a3215e64f$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $1a57885a3215e64f$export$7568632d0d33d16d, (v) => $1a57885a3215e64f$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $1a57885a3215e64f$export$88948ce120ea2619, (v) => $1a57885a3215e64f$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $1a57885a3215e64f$export$35808ee640e87ca7, (v) => $1a57885a3215e64f$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $1a57885a3215e64f$export$fae74005e78b1a27, (v) => $1a57885a3215e64f$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $1a57885a3215e64f$export$dc8fbce3eb94dc1e, (v) => $1a57885a3215e64f$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $1a57885a3215e64f$export$6a7bc4e911dc01cf, (v) => $1a57885a3215e64f$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $1a57885a3215e64f$export$6d9c69b0de29b591, (v) => $1a57885a3215e64f$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $1a57885a3215e64f$export$f680877a34711e37, (v) => $1a57885a3215e64f$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $1a57885a3215e64f$export$d5a552a76deda3c2, (v) => $1a57885a3215e64f$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $1a57885a3215e64f$export$aaabe4eda9ed9969, (v) => $1a57885a3215e64f$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $1a57885a3215e64f$export$e5c5a5f917a5871c, (v) => $1a57885a3215e64f$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $1a57885a3215e64f$export$1538c33de8887b59, (v) => $1a57885a3215e64f$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $1a57885a3215e64f$export$13e3392192263954, (v) => $1a57885a3215e64f$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $1a57885a3215e64f$export$b8f5890fc79d6aca, (v) => $1a57885a3215e64f$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $1a57885a3215e64f$export$60241385465d0a34, (v) => $1a57885a3215e64f$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $1a57885a3215e64f$export$306c0aa65ff9ec16, (v) => $1a57885a3215e64f$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $1a57885a3215e64f$export$7b286972b8d8ccbf, (v) => $1a57885a3215e64f$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $1a57885a3215e64f$export$83d89fbfd8236492, (v) => $1a57885a3215e64f$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1a57885a3215e64f$export$dca3b0875bd9a954;
var $1a57885a3215e64f$export$16fa2f45be04daa8;
var $1a57885a3215e64f$export$ffb0004e005737fa;
var $1a57885a3215e64f$export$e2c29f18771995cb;
var $1a57885a3215e64f$export$221d75b3f55bb0bd;
var $1a57885a3215e64f$export$5f8d39834fd61797;
var $1a57885a3215e64f$export$74bf444e3cd11ea5;
var $1a57885a3215e64f$export$ae55be85d98224ed;
var $1a57885a3215e64f$export$3ba232387fd5d6dd;
var $1a57885a3215e64f$export$e530037191fcd5d7;
var $1a57885a3215e64f$export$fd42f52fd3ae1109;
var $1a57885a3215e64f$export$c8a8987d4410bf2d;
var $1a57885a3215e64f$export$d38cd72104c1f0e9;
var $1a57885a3215e64f$export$7d1e3a5e95ceca43;
var $1a57885a3215e64f$export$257a8862b851cb5b;
var $1a57885a3215e64f$export$a8257692ac88316c;
var $1a57885a3215e64f$export$488013bae63b21da;
var $1a57885a3215e64f$export$7c73462e0d25e514;
var $1a57885a3215e64f$export$7568632d0d33d16d;
var $1a57885a3215e64f$export$88948ce120ea2619;
var $1a57885a3215e64f$export$35808ee640e87ca7;
var $1a57885a3215e64f$export$fae74005e78b1a27;
var $1a57885a3215e64f$export$dc8fbce3eb94dc1e;
var $1a57885a3215e64f$export$6a7bc4e911dc01cf;
var $1a57885a3215e64f$export$6d9c69b0de29b591;
var $1a57885a3215e64f$export$f680877a34711e37;
var $1a57885a3215e64f$export$d5a552a76deda3c2;
var $1a57885a3215e64f$export$aaabe4eda9ed9969;
var $1a57885a3215e64f$export$e5c5a5f917a5871c;
var $1a57885a3215e64f$export$1538c33de8887b59;
var $1a57885a3215e64f$export$13e3392192263954;
var $1a57885a3215e64f$export$b8f5890fc79d6aca;
var $1a57885a3215e64f$export$60241385465d0a34;
var $1a57885a3215e64f$export$306c0aa65ff9ec16;
var $1a57885a3215e64f$export$7b286972b8d8ccbf;
var $1a57885a3215e64f$export$83d89fbfd8236492;
"use strict";
var $1a57885a3215e64f$var$l = Symbol.for("react.element"), $1a57885a3215e64f$var$n = Symbol.for("react.portal"), $1a57885a3215e64f$var$p = Symbol.for("react.fragment"), $1a57885a3215e64f$var$q = Symbol.for("react.strict_mode"), $1a57885a3215e64f$var$r = Symbol.for("react.profiler"), $1a57885a3215e64f$var$t = Symbol.for("react.provider"), $1a57885a3215e64f$var$u = Symbol.for("react.context"), $1a57885a3215e64f$var$v = Symbol.for("react.forward_ref"), $1a57885a3215e64f$var$w = Symbol.for("react.suspense"), $1a57885a3215e64f$var$x = Symbol.for("react.memo"), $1a57885a3215e64f$var$y = Symbol.for("react.lazy"), $1a57885a3215e64f$var$z = Symbol.iterator;
function $1a57885a3215e64f$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $1a57885a3215e64f$var$z && a[$1a57885a3215e64f$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $1a57885a3215e64f$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $1a57885a3215e64f$var$C = Object.assign, $1a57885a3215e64f$var$D = {};
function $1a57885a3215e64f$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1a57885a3215e64f$var$D;
    this.updater = e || $1a57885a3215e64f$var$B;
}
$1a57885a3215e64f$var$E.prototype.isReactComponent = {};
$1a57885a3215e64f$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$1a57885a3215e64f$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $1a57885a3215e64f$var$F() {}
$1a57885a3215e64f$var$F.prototype = $1a57885a3215e64f$var$E.prototype;
function $1a57885a3215e64f$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1a57885a3215e64f$var$D;
    this.updater = e || $1a57885a3215e64f$var$B;
}
var $1a57885a3215e64f$var$H = $1a57885a3215e64f$var$G.prototype = new $1a57885a3215e64f$var$F;
$1a57885a3215e64f$var$H.constructor = $1a57885a3215e64f$var$G;
$1a57885a3215e64f$var$C($1a57885a3215e64f$var$H, $1a57885a3215e64f$var$E.prototype);
$1a57885a3215e64f$var$H.isPureReactComponent = !0;
var $1a57885a3215e64f$var$I = Array.isArray, $1a57885a3215e64f$var$J = Object.prototype.hasOwnProperty, $1a57885a3215e64f$var$K = {
    current: null
}, $1a57885a3215e64f$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1a57885a3215e64f$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$1a57885a3215e64f$var$J.call(b, d) && !$1a57885a3215e64f$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $1a57885a3215e64f$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $1a57885a3215e64f$var$K.current
    };
}
function $1a57885a3215e64f$var$N(a, b) {
    return {
        $$typeof: $1a57885a3215e64f$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $1a57885a3215e64f$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1a57885a3215e64f$var$l;
}
function $1a57885a3215e64f$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $1a57885a3215e64f$var$P = /\/+/g;
function $1a57885a3215e64f$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $1a57885a3215e64f$var$escape("" + a.key) : b.toString(36);
}
function $1a57885a3215e64f$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $1a57885a3215e64f$var$l:
                case $1a57885a3215e64f$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $1a57885a3215e64f$var$Q(h, 0) : d, $1a57885a3215e64f$var$I(c) ? (e = "", null != a && (e = a.replace($1a57885a3215e64f$var$P, "$&/") + "/"), $1a57885a3215e64f$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($1a57885a3215e64f$var$O(c) && (c = $1a57885a3215e64f$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($1a57885a3215e64f$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($1a57885a3215e64f$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $1a57885a3215e64f$var$Q(k, g);
        h += $1a57885a3215e64f$var$R(k, b, e, f, c);
    }
    else if (f = $1a57885a3215e64f$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $1a57885a3215e64f$var$Q(k, g++), h += $1a57885a3215e64f$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $1a57885a3215e64f$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $1a57885a3215e64f$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $1a57885a3215e64f$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $1a57885a3215e64f$var$U = {
    current: null
}, $1a57885a3215e64f$var$V = {
    transition: null
}, $1a57885a3215e64f$var$W = {
    ReactCurrentDispatcher: $1a57885a3215e64f$var$U,
    ReactCurrentBatchConfig: $1a57885a3215e64f$var$V,
    ReactCurrentOwner: $1a57885a3215e64f$var$K
};
function $1a57885a3215e64f$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$1a57885a3215e64f$export$dca3b0875bd9a954 = {
    map: $1a57885a3215e64f$var$S,
    forEach: function(a, b, e) {
        $1a57885a3215e64f$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $1a57885a3215e64f$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $1a57885a3215e64f$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$1a57885a3215e64f$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$1a57885a3215e64f$export$16fa2f45be04daa8 = $1a57885a3215e64f$var$E;
$1a57885a3215e64f$export$ffb0004e005737fa = $1a57885a3215e64f$var$p;
$1a57885a3215e64f$export$e2c29f18771995cb = $1a57885a3215e64f$var$r;
$1a57885a3215e64f$export$221d75b3f55bb0bd = $1a57885a3215e64f$var$G;
$1a57885a3215e64f$export$5f8d39834fd61797 = $1a57885a3215e64f$var$q;
$1a57885a3215e64f$export$74bf444e3cd11ea5 = $1a57885a3215e64f$var$w;
$1a57885a3215e64f$export$ae55be85d98224ed = $1a57885a3215e64f$var$W;
$1a57885a3215e64f$export$3ba232387fd5d6dd = $1a57885a3215e64f$var$X;
$1a57885a3215e64f$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $1a57885a3215e64f$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $1a57885a3215e64f$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$1a57885a3215e64f$var$J.call(b, f) && !$1a57885a3215e64f$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $1a57885a3215e64f$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$1a57885a3215e64f$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $1a57885a3215e64f$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $1a57885a3215e64f$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$1a57885a3215e64f$export$c8a8987d4410bf2d = $1a57885a3215e64f$var$M;
$1a57885a3215e64f$export$d38cd72104c1f0e9 = function(a) {
    var b = $1a57885a3215e64f$var$M.bind(null, a);
    b.type = a;
    return b;
};
$1a57885a3215e64f$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$1a57885a3215e64f$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $1a57885a3215e64f$var$v,
        render: a
    };
};
$1a57885a3215e64f$export$a8257692ac88316c = $1a57885a3215e64f$var$O;
$1a57885a3215e64f$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $1a57885a3215e64f$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $1a57885a3215e64f$var$T
    };
};
$1a57885a3215e64f$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $1a57885a3215e64f$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$1a57885a3215e64f$export$7568632d0d33d16d = function(a) {
    var b = $1a57885a3215e64f$var$V.transition;
    $1a57885a3215e64f$var$V.transition = {};
    try {
        a();
    } finally{
        $1a57885a3215e64f$var$V.transition = b;
    }
};
$1a57885a3215e64f$export$88948ce120ea2619 = $1a57885a3215e64f$var$X;
$1a57885a3215e64f$export$35808ee640e87ca7 = function(a, b) {
    return $1a57885a3215e64f$var$U.current.useCallback(a, b);
};
$1a57885a3215e64f$export$fae74005e78b1a27 = function(a) {
    return $1a57885a3215e64f$var$U.current.useContext(a);
};
$1a57885a3215e64f$export$dc8fbce3eb94dc1e = function() {};
$1a57885a3215e64f$export$6a7bc4e911dc01cf = function(a) {
    return $1a57885a3215e64f$var$U.current.useDeferredValue(a);
};
$1a57885a3215e64f$export$6d9c69b0de29b591 = function(a, b) {
    return $1a57885a3215e64f$var$U.current.useEffect(a, b);
};
$1a57885a3215e64f$export$f680877a34711e37 = function() {
    return $1a57885a3215e64f$var$U.current.useId();
};
$1a57885a3215e64f$export$d5a552a76deda3c2 = function(a, b, e) {
    return $1a57885a3215e64f$var$U.current.useImperativeHandle(a, b, e);
};
$1a57885a3215e64f$export$aaabe4eda9ed9969 = function(a, b) {
    return $1a57885a3215e64f$var$U.current.useInsertionEffect(a, b);
};
$1a57885a3215e64f$export$e5c5a5f917a5871c = function(a, b) {
    return $1a57885a3215e64f$var$U.current.useLayoutEffect(a, b);
};
$1a57885a3215e64f$export$1538c33de8887b59 = function(a, b) {
    return $1a57885a3215e64f$var$U.current.useMemo(a, b);
};
$1a57885a3215e64f$export$13e3392192263954 = function(a, b, e) {
    return $1a57885a3215e64f$var$U.current.useReducer(a, b, e);
};
$1a57885a3215e64f$export$b8f5890fc79d6aca = function(a) {
    return $1a57885a3215e64f$var$U.current.useRef(a);
};
$1a57885a3215e64f$export$60241385465d0a34 = function(a) {
    return $1a57885a3215e64f$var$U.current.useState(a);
};
$1a57885a3215e64f$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $1a57885a3215e64f$var$U.current.useSyncExternalStore(a, b, e);
};
$1a57885a3215e64f$export$7b286972b8d8ccbf = function() {
    return $1a57885a3215e64f$var$U.current.useTransition();
};
$1a57885a3215e64f$export$83d89fbfd8236492 = "18.3.1";

});




parcelRegister("cJHfb", function(module, exports) {

$parcel$export(module.exports, "createRoot", () => $945b3b548e437ca7$export$882461b6382ed46c, (v) => $945b3b548e437ca7$export$882461b6382ed46c = v);
$parcel$export(module.exports, "hydrateRoot", () => $945b3b548e437ca7$export$757ceba2d55c277e, (v) => $945b3b548e437ca7$export$757ceba2d55c277e = v);
var $945b3b548e437ca7$export$882461b6382ed46c;
var $945b3b548e437ca7$export$757ceba2d55c277e;
"use strict";

var $cn1Kz = parcelRequire("cn1Kz");
var $945b3b548e437ca7$var$i;
$945b3b548e437ca7$export$882461b6382ed46c = $cn1Kz.createRoot;
$945b3b548e437ca7$export$757ceba2d55c277e = $cn1Kz.hydrateRoot;

});
parcelRegister("cn1Kz", function(module, exports) {
"use strict";
function $9018fd8b87cabbb7$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($9018fd8b87cabbb7$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$9018fd8b87cabbb7$var$checkDCE();

module.exports = (parcelRequire("63uH6"));

});
parcelRegister("63uH6", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $468ad51c3551a14d$export$ae55be85d98224ed, (v) => $468ad51c3551a14d$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $468ad51c3551a14d$export$d39a5bbd09211389, (v) => $468ad51c3551a14d$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $468ad51c3551a14d$export$882461b6382ed46c, (v) => $468ad51c3551a14d$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $468ad51c3551a14d$export$466bfc07425424d5, (v) => $468ad51c3551a14d$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $468ad51c3551a14d$export$cd75ccfd720a3cd4, (v) => $468ad51c3551a14d$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $468ad51c3551a14d$export$fa8d919ba61d84db, (v) => $468ad51c3551a14d$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $468ad51c3551a14d$export$757ceba2d55c277e, (v) => $468ad51c3551a14d$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $468ad51c3551a14d$export$b3890eb0ae9dca99, (v) => $468ad51c3551a14d$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $468ad51c3551a14d$export$502457920280e6be, (v) => $468ad51c3551a14d$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $468ad51c3551a14d$export$c78a37762a8d58e1, (v) => $468ad51c3551a14d$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $468ad51c3551a14d$export$dc54d992c10e8a18, (v) => $468ad51c3551a14d$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $468ad51c3551a14d$export$83d89fbfd8236492, (v) => $468ad51c3551a14d$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $468ad51c3551a14d$export$ae55be85d98224ed;
var $468ad51c3551a14d$export$d39a5bbd09211389;
var $468ad51c3551a14d$export$882461b6382ed46c;
var $468ad51c3551a14d$export$466bfc07425424d5;
var $468ad51c3551a14d$export$cd75ccfd720a3cd4;
var $468ad51c3551a14d$export$fa8d919ba61d84db;
var $468ad51c3551a14d$export$757ceba2d55c277e;
var $468ad51c3551a14d$export$b3890eb0ae9dca99;
var $468ad51c3551a14d$export$502457920280e6be;
var $468ad51c3551a14d$export$c78a37762a8d58e1;
var $468ad51c3551a14d$export$dc54d992c10e8a18;
var $468ad51c3551a14d$export$83d89fbfd8236492;
"use strict";

var $kc00y = parcelRequire("kc00y");

var $cV2f0 = parcelRequire("cV2f0");
function $468ad51c3551a14d$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $468ad51c3551a14d$var$da = new Set, $468ad51c3551a14d$var$ea = {};
function $468ad51c3551a14d$var$fa(a, b) {
    $468ad51c3551a14d$var$ha(a, b);
    $468ad51c3551a14d$var$ha(a + "Capture", b);
}
function $468ad51c3551a14d$var$ha(a, b) {
    $468ad51c3551a14d$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$468ad51c3551a14d$var$da.add(b[a]);
}
var $468ad51c3551a14d$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $468ad51c3551a14d$var$ja = Object.prototype.hasOwnProperty, $468ad51c3551a14d$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $468ad51c3551a14d$var$la = {}, $468ad51c3551a14d$var$ma = {};
function $468ad51c3551a14d$var$oa(a) {
    if ($468ad51c3551a14d$var$ja.call($468ad51c3551a14d$var$ma, a)) return !0;
    if ($468ad51c3551a14d$var$ja.call($468ad51c3551a14d$var$la, a)) return !1;
    if ($468ad51c3551a14d$var$ka.test(a)) return $468ad51c3551a14d$var$ma[a] = !0;
    $468ad51c3551a14d$var$la[a] = !0;
    return !1;
}
function $468ad51c3551a14d$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $468ad51c3551a14d$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $468ad51c3551a14d$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $468ad51c3551a14d$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $468ad51c3551a14d$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $468ad51c3551a14d$var$z[a] = new $468ad51c3551a14d$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $468ad51c3551a14d$var$z[b] = new $468ad51c3551a14d$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $468ad51c3551a14d$var$z[a] = new $468ad51c3551a14d$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $468ad51c3551a14d$var$z[a] = new $468ad51c3551a14d$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $468ad51c3551a14d$var$z[a] = new $468ad51c3551a14d$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $468ad51c3551a14d$var$z[a] = new $468ad51c3551a14d$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $468ad51c3551a14d$var$z[a] = new $468ad51c3551a14d$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $468ad51c3551a14d$var$z[a] = new $468ad51c3551a14d$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $468ad51c3551a14d$var$z[a] = new $468ad51c3551a14d$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $468ad51c3551a14d$var$ra = /[\-:]([a-z])/g;
function $468ad51c3551a14d$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($468ad51c3551a14d$var$ra, $468ad51c3551a14d$var$sa);
    $468ad51c3551a14d$var$z[b] = new $468ad51c3551a14d$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($468ad51c3551a14d$var$ra, $468ad51c3551a14d$var$sa);
    $468ad51c3551a14d$var$z[b] = new $468ad51c3551a14d$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($468ad51c3551a14d$var$ra, $468ad51c3551a14d$var$sa);
    $468ad51c3551a14d$var$z[b] = new $468ad51c3551a14d$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $468ad51c3551a14d$var$z[a] = new $468ad51c3551a14d$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$468ad51c3551a14d$var$z.xlinkHref = new $468ad51c3551a14d$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $468ad51c3551a14d$var$z[a] = new $468ad51c3551a14d$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $468ad51c3551a14d$var$ta(a, b, c, d) {
    var e = $468ad51c3551a14d$var$z.hasOwnProperty(b) ? $468ad51c3551a14d$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $468ad51c3551a14d$var$qa(b, c, e, d) && (c = null), d || null === e ? $468ad51c3551a14d$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $468ad51c3551a14d$var$ua = $kc00y.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $468ad51c3551a14d$var$va = Symbol.for("react.element"), $468ad51c3551a14d$var$wa = Symbol.for("react.portal"), $468ad51c3551a14d$var$ya = Symbol.for("react.fragment"), $468ad51c3551a14d$var$za = Symbol.for("react.strict_mode"), $468ad51c3551a14d$var$Aa = Symbol.for("react.profiler"), $468ad51c3551a14d$var$Ba = Symbol.for("react.provider"), $468ad51c3551a14d$var$Ca = Symbol.for("react.context"), $468ad51c3551a14d$var$Da = Symbol.for("react.forward_ref"), $468ad51c3551a14d$var$Ea = Symbol.for("react.suspense"), $468ad51c3551a14d$var$Fa = Symbol.for("react.suspense_list"), $468ad51c3551a14d$var$Ga = Symbol.for("react.memo"), $468ad51c3551a14d$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $468ad51c3551a14d$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $468ad51c3551a14d$var$Ja = Symbol.iterator;
function $468ad51c3551a14d$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $468ad51c3551a14d$var$Ja && a[$468ad51c3551a14d$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $468ad51c3551a14d$var$A = Object.assign, $468ad51c3551a14d$var$La;
function $468ad51c3551a14d$var$Ma(a) {
    if (void 0 === $468ad51c3551a14d$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $468ad51c3551a14d$var$La = b && b[1] || "";
    }
    return "\n" + $468ad51c3551a14d$var$La + a;
}
var $468ad51c3551a14d$var$Na = !1;
function $468ad51c3551a14d$var$Oa(a, b) {
    if (!a || $468ad51c3551a14d$var$Na) return "";
    $468ad51c3551a14d$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $468ad51c3551a14d$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $468ad51c3551a14d$var$Ma(a) : "";
}
function $468ad51c3551a14d$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $468ad51c3551a14d$var$Ma(a.type);
        case 16:
            return $468ad51c3551a14d$var$Ma("Lazy");
        case 13:
            return $468ad51c3551a14d$var$Ma("Suspense");
        case 19:
            return $468ad51c3551a14d$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $468ad51c3551a14d$var$Oa(a.type, !1), a;
        case 11:
            return a = $468ad51c3551a14d$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $468ad51c3551a14d$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $468ad51c3551a14d$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $468ad51c3551a14d$var$ya:
            return "Fragment";
        case $468ad51c3551a14d$var$wa:
            return "Portal";
        case $468ad51c3551a14d$var$Aa:
            return "Profiler";
        case $468ad51c3551a14d$var$za:
            return "StrictMode";
        case $468ad51c3551a14d$var$Ea:
            return "Suspense";
        case $468ad51c3551a14d$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $468ad51c3551a14d$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $468ad51c3551a14d$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $468ad51c3551a14d$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $468ad51c3551a14d$var$Ga:
            return b = a.displayName || null, null !== b ? b : $468ad51c3551a14d$var$Qa(a.type) || "Memo";
        case $468ad51c3551a14d$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $468ad51c3551a14d$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $468ad51c3551a14d$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $468ad51c3551a14d$var$Qa(b);
        case 8:
            return b === $468ad51c3551a14d$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $468ad51c3551a14d$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $468ad51c3551a14d$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $468ad51c3551a14d$var$Ua(a) {
    var b = $468ad51c3551a14d$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $468ad51c3551a14d$var$Va(a) {
    a._valueTracker || (a._valueTracker = $468ad51c3551a14d$var$Ua(a));
}
function $468ad51c3551a14d$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $468ad51c3551a14d$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $468ad51c3551a14d$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $468ad51c3551a14d$var$Ya(a, b) {
    var c = b.checked;
    return $468ad51c3551a14d$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $468ad51c3551a14d$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $468ad51c3551a14d$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $468ad51c3551a14d$var$ab(a, b) {
    b = b.checked;
    null != b && $468ad51c3551a14d$var$ta(a, "checked", b, !1);
}
function $468ad51c3551a14d$var$bb(a, b) {
    $468ad51c3551a14d$var$ab(a, b);
    var c = $468ad51c3551a14d$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $468ad51c3551a14d$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $468ad51c3551a14d$var$cb(a, b.type, $468ad51c3551a14d$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $468ad51c3551a14d$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $468ad51c3551a14d$var$cb(a, b, c) {
    if ("number" !== b || $468ad51c3551a14d$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $468ad51c3551a14d$var$eb = Array.isArray;
function $468ad51c3551a14d$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $468ad51c3551a14d$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $468ad51c3551a14d$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($468ad51c3551a14d$var$p(91));
    return $468ad51c3551a14d$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $468ad51c3551a14d$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($468ad51c3551a14d$var$p(92));
            if ($468ad51c3551a14d$var$eb(c)) {
                if (1 < c.length) throw Error($468ad51c3551a14d$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $468ad51c3551a14d$var$Sa(c)
    };
}
function $468ad51c3551a14d$var$ib(a, b) {
    var c = $468ad51c3551a14d$var$Sa(b.value), d = $468ad51c3551a14d$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $468ad51c3551a14d$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $468ad51c3551a14d$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $468ad51c3551a14d$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $468ad51c3551a14d$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $468ad51c3551a14d$var$mb, $468ad51c3551a14d$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $468ad51c3551a14d$var$mb = $468ad51c3551a14d$var$mb || document.createElement("div");
        $468ad51c3551a14d$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $468ad51c3551a14d$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $468ad51c3551a14d$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $468ad51c3551a14d$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $468ad51c3551a14d$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($468ad51c3551a14d$var$pb).forEach(function(a) {
    $468ad51c3551a14d$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $468ad51c3551a14d$var$pb[b] = $468ad51c3551a14d$var$pb[a];
    });
});
function $468ad51c3551a14d$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $468ad51c3551a14d$var$pb.hasOwnProperty(a) && $468ad51c3551a14d$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $468ad51c3551a14d$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $468ad51c3551a14d$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $468ad51c3551a14d$var$tb = $468ad51c3551a14d$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $468ad51c3551a14d$var$ub(a, b) {
    if (b) {
        if ($468ad51c3551a14d$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($468ad51c3551a14d$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($468ad51c3551a14d$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($468ad51c3551a14d$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($468ad51c3551a14d$var$p(62));
    }
}
function $468ad51c3551a14d$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $468ad51c3551a14d$var$wb = null;
function $468ad51c3551a14d$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $468ad51c3551a14d$var$yb = null, $468ad51c3551a14d$var$zb = null, $468ad51c3551a14d$var$Ab = null;
function $468ad51c3551a14d$var$Bb(a) {
    if (a = $468ad51c3551a14d$var$Cb(a)) {
        if ("function" !== typeof $468ad51c3551a14d$var$yb) throw Error($468ad51c3551a14d$var$p(280));
        var b = a.stateNode;
        b && (b = $468ad51c3551a14d$var$Db(b), $468ad51c3551a14d$var$yb(a.stateNode, a.type, b));
    }
}
function $468ad51c3551a14d$var$Eb(a) {
    $468ad51c3551a14d$var$zb ? $468ad51c3551a14d$var$Ab ? $468ad51c3551a14d$var$Ab.push(a) : $468ad51c3551a14d$var$Ab = [
        a
    ] : $468ad51c3551a14d$var$zb = a;
}
function $468ad51c3551a14d$var$Fb() {
    if ($468ad51c3551a14d$var$zb) {
        var a = $468ad51c3551a14d$var$zb, b = $468ad51c3551a14d$var$Ab;
        $468ad51c3551a14d$var$Ab = $468ad51c3551a14d$var$zb = null;
        $468ad51c3551a14d$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$468ad51c3551a14d$var$Bb(b[a]);
    }
}
function $468ad51c3551a14d$var$Gb(a, b) {
    return a(b);
}
function $468ad51c3551a14d$var$Hb() {}
var $468ad51c3551a14d$var$Ib = !1;
function $468ad51c3551a14d$var$Jb(a, b, c) {
    if ($468ad51c3551a14d$var$Ib) return a(b, c);
    $468ad51c3551a14d$var$Ib = !0;
    try {
        return $468ad51c3551a14d$var$Gb(a, b, c);
    } finally{
        if ($468ad51c3551a14d$var$Ib = !1, null !== $468ad51c3551a14d$var$zb || null !== $468ad51c3551a14d$var$Ab) $468ad51c3551a14d$var$Hb(), $468ad51c3551a14d$var$Fb();
    }
}
function $468ad51c3551a14d$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $468ad51c3551a14d$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($468ad51c3551a14d$var$p(231, b, typeof c));
    return c;
}
var $468ad51c3551a14d$var$Lb = !1;
if ($468ad51c3551a14d$var$ia) try {
    var $468ad51c3551a14d$var$Mb = {};
    Object.defineProperty($468ad51c3551a14d$var$Mb, "passive", {
        get: function() {
            $468ad51c3551a14d$var$Lb = !0;
        }
    });
    window.addEventListener("test", $468ad51c3551a14d$var$Mb, $468ad51c3551a14d$var$Mb);
    window.removeEventListener("test", $468ad51c3551a14d$var$Mb, $468ad51c3551a14d$var$Mb);
} catch (a) {
    $468ad51c3551a14d$var$Lb = !1;
}
function $468ad51c3551a14d$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $468ad51c3551a14d$var$Ob = !1, $468ad51c3551a14d$var$Pb = null, $468ad51c3551a14d$var$Qb = !1, $468ad51c3551a14d$var$Rb = null, $468ad51c3551a14d$var$Sb = {
    onError: function(a) {
        $468ad51c3551a14d$var$Ob = !0;
        $468ad51c3551a14d$var$Pb = a;
    }
};
function $468ad51c3551a14d$var$Tb(a, b, c, d, e, f, g, h, k) {
    $468ad51c3551a14d$var$Ob = !1;
    $468ad51c3551a14d$var$Pb = null;
    $468ad51c3551a14d$var$Nb.apply($468ad51c3551a14d$var$Sb, arguments);
}
function $468ad51c3551a14d$var$Ub(a, b, c, d, e, f, g, h, k) {
    $468ad51c3551a14d$var$Tb.apply(this, arguments);
    if ($468ad51c3551a14d$var$Ob) {
        if ($468ad51c3551a14d$var$Ob) {
            var l = $468ad51c3551a14d$var$Pb;
            $468ad51c3551a14d$var$Ob = !1;
            $468ad51c3551a14d$var$Pb = null;
        } else throw Error($468ad51c3551a14d$var$p(198));
        $468ad51c3551a14d$var$Qb || ($468ad51c3551a14d$var$Qb = !0, $468ad51c3551a14d$var$Rb = l);
    }
}
function $468ad51c3551a14d$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $468ad51c3551a14d$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $468ad51c3551a14d$var$Xb(a) {
    if ($468ad51c3551a14d$var$Vb(a) !== a) throw Error($468ad51c3551a14d$var$p(188));
}
function $468ad51c3551a14d$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $468ad51c3551a14d$var$Vb(a);
        if (null === b) throw Error($468ad51c3551a14d$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $468ad51c3551a14d$var$Xb(e), a;
                if (f === d) return $468ad51c3551a14d$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($468ad51c3551a14d$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($468ad51c3551a14d$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($468ad51c3551a14d$var$p(190));
    }
    if (3 !== c.tag) throw Error($468ad51c3551a14d$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $468ad51c3551a14d$var$Zb(a) {
    a = $468ad51c3551a14d$var$Yb(a);
    return null !== a ? $468ad51c3551a14d$var$$b(a) : null;
}
function $468ad51c3551a14d$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $468ad51c3551a14d$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $468ad51c3551a14d$var$ac = $cV2f0.unstable_scheduleCallback, $468ad51c3551a14d$var$bc = $cV2f0.unstable_cancelCallback, $468ad51c3551a14d$var$cc = $cV2f0.unstable_shouldYield, $468ad51c3551a14d$var$dc = $cV2f0.unstable_requestPaint, $468ad51c3551a14d$var$B = $cV2f0.unstable_now, $468ad51c3551a14d$var$ec = $cV2f0.unstable_getCurrentPriorityLevel, $468ad51c3551a14d$var$fc = $cV2f0.unstable_ImmediatePriority, $468ad51c3551a14d$var$gc = $cV2f0.unstable_UserBlockingPriority, $468ad51c3551a14d$var$hc = $cV2f0.unstable_NormalPriority, $468ad51c3551a14d$var$ic = $cV2f0.unstable_LowPriority, $468ad51c3551a14d$var$jc = $cV2f0.unstable_IdlePriority, $468ad51c3551a14d$var$kc = null, $468ad51c3551a14d$var$lc = null;
function $468ad51c3551a14d$var$mc(a) {
    if ($468ad51c3551a14d$var$lc && "function" === typeof $468ad51c3551a14d$var$lc.onCommitFiberRoot) try {
        $468ad51c3551a14d$var$lc.onCommitFiberRoot($468ad51c3551a14d$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $468ad51c3551a14d$var$oc = Math.clz32 ? Math.clz32 : $468ad51c3551a14d$var$nc, $468ad51c3551a14d$var$pc = Math.log, $468ad51c3551a14d$var$qc = Math.LN2;
function $468ad51c3551a14d$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($468ad51c3551a14d$var$pc(a) / $468ad51c3551a14d$var$qc | 0) | 0;
}
var $468ad51c3551a14d$var$rc = 64, $468ad51c3551a14d$var$sc = 4194304;
function $468ad51c3551a14d$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $468ad51c3551a14d$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $468ad51c3551a14d$var$tc(h) : (f &= g, 0 !== f && (d = $468ad51c3551a14d$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $468ad51c3551a14d$var$tc(g) : 0 !== f && (d = $468ad51c3551a14d$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $468ad51c3551a14d$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $468ad51c3551a14d$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $468ad51c3551a14d$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $468ad51c3551a14d$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $468ad51c3551a14d$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $468ad51c3551a14d$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $468ad51c3551a14d$var$yc() {
    var a = $468ad51c3551a14d$var$rc;
    $468ad51c3551a14d$var$rc <<= 1;
    0 === ($468ad51c3551a14d$var$rc & 4194240) && ($468ad51c3551a14d$var$rc = 64);
    return a;
}
function $468ad51c3551a14d$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $468ad51c3551a14d$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $468ad51c3551a14d$var$oc(b);
    a[b] = c;
}
function $468ad51c3551a14d$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $468ad51c3551a14d$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $468ad51c3551a14d$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $468ad51c3551a14d$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $468ad51c3551a14d$var$C = 0;
function $468ad51c3551a14d$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $468ad51c3551a14d$var$Ec, $468ad51c3551a14d$var$Fc, $468ad51c3551a14d$var$Gc, $468ad51c3551a14d$var$Hc, $468ad51c3551a14d$var$Ic, $468ad51c3551a14d$var$Jc = !1, $468ad51c3551a14d$var$Kc = [], $468ad51c3551a14d$var$Lc = null, $468ad51c3551a14d$var$Mc = null, $468ad51c3551a14d$var$Nc = null, $468ad51c3551a14d$var$Oc = new Map, $468ad51c3551a14d$var$Pc = new Map, $468ad51c3551a14d$var$Qc = [], $468ad51c3551a14d$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $468ad51c3551a14d$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $468ad51c3551a14d$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $468ad51c3551a14d$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $468ad51c3551a14d$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $468ad51c3551a14d$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $468ad51c3551a14d$var$Pc.delete(b.pointerId);
    }
}
function $468ad51c3551a14d$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $468ad51c3551a14d$var$Cb(b), null !== b && $468ad51c3551a14d$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $468ad51c3551a14d$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $468ad51c3551a14d$var$Lc = $468ad51c3551a14d$var$Tc($468ad51c3551a14d$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $468ad51c3551a14d$var$Mc = $468ad51c3551a14d$var$Tc($468ad51c3551a14d$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $468ad51c3551a14d$var$Nc = $468ad51c3551a14d$var$Tc($468ad51c3551a14d$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $468ad51c3551a14d$var$Oc.set(f, $468ad51c3551a14d$var$Tc($468ad51c3551a14d$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $468ad51c3551a14d$var$Pc.set(f, $468ad51c3551a14d$var$Tc($468ad51c3551a14d$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $468ad51c3551a14d$var$Vc(a) {
    var b = $468ad51c3551a14d$var$Wc(a.target);
    if (null !== b) {
        var c = $468ad51c3551a14d$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $468ad51c3551a14d$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $468ad51c3551a14d$var$Ic(a.priority, function() {
                        $468ad51c3551a14d$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $468ad51c3551a14d$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $468ad51c3551a14d$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $468ad51c3551a14d$var$wb = d;
            c.target.dispatchEvent(d);
            $468ad51c3551a14d$var$wb = null;
        } else return b = $468ad51c3551a14d$var$Cb(c), null !== b && $468ad51c3551a14d$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $468ad51c3551a14d$var$Zc(a, b, c) {
    $468ad51c3551a14d$var$Xc(a) && c.delete(b);
}
function $468ad51c3551a14d$var$$c() {
    $468ad51c3551a14d$var$Jc = !1;
    null !== $468ad51c3551a14d$var$Lc && $468ad51c3551a14d$var$Xc($468ad51c3551a14d$var$Lc) && ($468ad51c3551a14d$var$Lc = null);
    null !== $468ad51c3551a14d$var$Mc && $468ad51c3551a14d$var$Xc($468ad51c3551a14d$var$Mc) && ($468ad51c3551a14d$var$Mc = null);
    null !== $468ad51c3551a14d$var$Nc && $468ad51c3551a14d$var$Xc($468ad51c3551a14d$var$Nc) && ($468ad51c3551a14d$var$Nc = null);
    $468ad51c3551a14d$var$Oc.forEach($468ad51c3551a14d$var$Zc);
    $468ad51c3551a14d$var$Pc.forEach($468ad51c3551a14d$var$Zc);
}
function $468ad51c3551a14d$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $468ad51c3551a14d$var$Jc || ($468ad51c3551a14d$var$Jc = !0, $cV2f0.unstable_scheduleCallback($cV2f0.unstable_NormalPriority, $468ad51c3551a14d$var$$c)));
}
function $468ad51c3551a14d$var$bd(a) {
    function b(b) {
        return $468ad51c3551a14d$var$ad(b, a);
    }
    if (0 < $468ad51c3551a14d$var$Kc.length) {
        $468ad51c3551a14d$var$ad($468ad51c3551a14d$var$Kc[0], a);
        for(var c = 1; c < $468ad51c3551a14d$var$Kc.length; c++){
            var d = $468ad51c3551a14d$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $468ad51c3551a14d$var$Lc && $468ad51c3551a14d$var$ad($468ad51c3551a14d$var$Lc, a);
    null !== $468ad51c3551a14d$var$Mc && $468ad51c3551a14d$var$ad($468ad51c3551a14d$var$Mc, a);
    null !== $468ad51c3551a14d$var$Nc && $468ad51c3551a14d$var$ad($468ad51c3551a14d$var$Nc, a);
    $468ad51c3551a14d$var$Oc.forEach(b);
    $468ad51c3551a14d$var$Pc.forEach(b);
    for(c = 0; c < $468ad51c3551a14d$var$Qc.length; c++)d = $468ad51c3551a14d$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $468ad51c3551a14d$var$Qc.length && (c = $468ad51c3551a14d$var$Qc[0], null === c.blockedOn);)$468ad51c3551a14d$var$Vc(c), null === c.blockedOn && $468ad51c3551a14d$var$Qc.shift();
}
var $468ad51c3551a14d$var$cd = $468ad51c3551a14d$var$ua.ReactCurrentBatchConfig, $468ad51c3551a14d$var$dd = !0;
function $468ad51c3551a14d$var$ed(a, b, c, d) {
    var e = $468ad51c3551a14d$var$C, f = $468ad51c3551a14d$var$cd.transition;
    $468ad51c3551a14d$var$cd.transition = null;
    try {
        $468ad51c3551a14d$var$C = 1, $468ad51c3551a14d$var$fd(a, b, c, d);
    } finally{
        $468ad51c3551a14d$var$C = e, $468ad51c3551a14d$var$cd.transition = f;
    }
}
function $468ad51c3551a14d$var$gd(a, b, c, d) {
    var e = $468ad51c3551a14d$var$C, f = $468ad51c3551a14d$var$cd.transition;
    $468ad51c3551a14d$var$cd.transition = null;
    try {
        $468ad51c3551a14d$var$C = 4, $468ad51c3551a14d$var$fd(a, b, c, d);
    } finally{
        $468ad51c3551a14d$var$C = e, $468ad51c3551a14d$var$cd.transition = f;
    }
}
function $468ad51c3551a14d$var$fd(a, b, c, d) {
    if ($468ad51c3551a14d$var$dd) {
        var e = $468ad51c3551a14d$var$Yc(a, b, c, d);
        if (null === e) $468ad51c3551a14d$var$hd(a, b, d, $468ad51c3551a14d$var$id, c), $468ad51c3551a14d$var$Sc(a, d);
        else if ($468ad51c3551a14d$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($468ad51c3551a14d$var$Sc(a, d), b & 4 && -1 < $468ad51c3551a14d$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $468ad51c3551a14d$var$Cb(e);
                null !== f && $468ad51c3551a14d$var$Ec(f);
                f = $468ad51c3551a14d$var$Yc(a, b, c, d);
                null === f && $468ad51c3551a14d$var$hd(a, b, d, $468ad51c3551a14d$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $468ad51c3551a14d$var$hd(a, b, d, null, c);
    }
}
var $468ad51c3551a14d$var$id = null;
function $468ad51c3551a14d$var$Yc(a, b, c, d) {
    $468ad51c3551a14d$var$id = null;
    a = $468ad51c3551a14d$var$xb(d);
    a = $468ad51c3551a14d$var$Wc(a);
    if (null !== a) {
        if (b = $468ad51c3551a14d$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $468ad51c3551a14d$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $468ad51c3551a14d$var$id = a;
    return null;
}
function $468ad51c3551a14d$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($468ad51c3551a14d$var$ec()){
                case $468ad51c3551a14d$var$fc:
                    return 1;
                case $468ad51c3551a14d$var$gc:
                    return 4;
                case $468ad51c3551a14d$var$hc:
                case $468ad51c3551a14d$var$ic:
                    return 16;
                case $468ad51c3551a14d$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $468ad51c3551a14d$var$kd = null, $468ad51c3551a14d$var$ld = null, $468ad51c3551a14d$var$md = null;
function $468ad51c3551a14d$var$nd() {
    if ($468ad51c3551a14d$var$md) return $468ad51c3551a14d$var$md;
    var a, b = $468ad51c3551a14d$var$ld, c = b.length, d, e = "value" in $468ad51c3551a14d$var$kd ? $468ad51c3551a14d$var$kd.value : $468ad51c3551a14d$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $468ad51c3551a14d$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $468ad51c3551a14d$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $468ad51c3551a14d$var$pd() {
    return !0;
}
function $468ad51c3551a14d$var$qd() {
    return !1;
}
function $468ad51c3551a14d$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $468ad51c3551a14d$var$pd : $468ad51c3551a14d$var$qd;
        this.isPropagationStopped = $468ad51c3551a14d$var$qd;
        return this;
    }
    $468ad51c3551a14d$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $468ad51c3551a14d$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $468ad51c3551a14d$var$pd);
        },
        persist: function() {},
        isPersistent: $468ad51c3551a14d$var$pd
    });
    return b;
}
var $468ad51c3551a14d$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $468ad51c3551a14d$var$td = $468ad51c3551a14d$var$rd($468ad51c3551a14d$var$sd), $468ad51c3551a14d$var$ud = $468ad51c3551a14d$var$A({}, $468ad51c3551a14d$var$sd, {
    view: 0,
    detail: 0
}), $468ad51c3551a14d$var$vd = $468ad51c3551a14d$var$rd($468ad51c3551a14d$var$ud), $468ad51c3551a14d$var$wd, $468ad51c3551a14d$var$xd, $468ad51c3551a14d$var$yd, $468ad51c3551a14d$var$Ad = $468ad51c3551a14d$var$A({}, $468ad51c3551a14d$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $468ad51c3551a14d$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $468ad51c3551a14d$var$yd && ($468ad51c3551a14d$var$yd && "mousemove" === a.type ? ($468ad51c3551a14d$var$wd = a.screenX - $468ad51c3551a14d$var$yd.screenX, $468ad51c3551a14d$var$xd = a.screenY - $468ad51c3551a14d$var$yd.screenY) : $468ad51c3551a14d$var$xd = $468ad51c3551a14d$var$wd = 0, $468ad51c3551a14d$var$yd = a);
        return $468ad51c3551a14d$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $468ad51c3551a14d$var$xd;
    }
}), $468ad51c3551a14d$var$Bd = $468ad51c3551a14d$var$rd($468ad51c3551a14d$var$Ad), $468ad51c3551a14d$var$Cd = $468ad51c3551a14d$var$A({}, $468ad51c3551a14d$var$Ad, {
    dataTransfer: 0
}), $468ad51c3551a14d$var$Dd = $468ad51c3551a14d$var$rd($468ad51c3551a14d$var$Cd), $468ad51c3551a14d$var$Ed = $468ad51c3551a14d$var$A({}, $468ad51c3551a14d$var$ud, {
    relatedTarget: 0
}), $468ad51c3551a14d$var$Fd = $468ad51c3551a14d$var$rd($468ad51c3551a14d$var$Ed), $468ad51c3551a14d$var$Gd = $468ad51c3551a14d$var$A({}, $468ad51c3551a14d$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $468ad51c3551a14d$var$Hd = $468ad51c3551a14d$var$rd($468ad51c3551a14d$var$Gd), $468ad51c3551a14d$var$Id = $468ad51c3551a14d$var$A({}, $468ad51c3551a14d$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $468ad51c3551a14d$var$Jd = $468ad51c3551a14d$var$rd($468ad51c3551a14d$var$Id), $468ad51c3551a14d$var$Kd = $468ad51c3551a14d$var$A({}, $468ad51c3551a14d$var$sd, {
    data: 0
}), $468ad51c3551a14d$var$Ld = $468ad51c3551a14d$var$rd($468ad51c3551a14d$var$Kd), $468ad51c3551a14d$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $468ad51c3551a14d$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $468ad51c3551a14d$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $468ad51c3551a14d$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $468ad51c3551a14d$var$Od[a]) ? !!b[a] : !1;
}
function $468ad51c3551a14d$var$zd() {
    return $468ad51c3551a14d$var$Pd;
}
var $468ad51c3551a14d$var$Qd = $468ad51c3551a14d$var$A({}, $468ad51c3551a14d$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $468ad51c3551a14d$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $468ad51c3551a14d$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $468ad51c3551a14d$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $468ad51c3551a14d$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $468ad51c3551a14d$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $468ad51c3551a14d$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $468ad51c3551a14d$var$Rd = $468ad51c3551a14d$var$rd($468ad51c3551a14d$var$Qd), $468ad51c3551a14d$var$Sd = $468ad51c3551a14d$var$A({}, $468ad51c3551a14d$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $468ad51c3551a14d$var$Td = $468ad51c3551a14d$var$rd($468ad51c3551a14d$var$Sd), $468ad51c3551a14d$var$Ud = $468ad51c3551a14d$var$A({}, $468ad51c3551a14d$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $468ad51c3551a14d$var$zd
}), $468ad51c3551a14d$var$Vd = $468ad51c3551a14d$var$rd($468ad51c3551a14d$var$Ud), $468ad51c3551a14d$var$Wd = $468ad51c3551a14d$var$A({}, $468ad51c3551a14d$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $468ad51c3551a14d$var$Xd = $468ad51c3551a14d$var$rd($468ad51c3551a14d$var$Wd), $468ad51c3551a14d$var$Yd = $468ad51c3551a14d$var$A({}, $468ad51c3551a14d$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $468ad51c3551a14d$var$Zd = $468ad51c3551a14d$var$rd($468ad51c3551a14d$var$Yd), $468ad51c3551a14d$var$$d = [
    9,
    13,
    27,
    32
], $468ad51c3551a14d$var$ae = $468ad51c3551a14d$var$ia && "CompositionEvent" in window, $468ad51c3551a14d$var$be = null;
$468ad51c3551a14d$var$ia && "documentMode" in document && ($468ad51c3551a14d$var$be = document.documentMode);
var $468ad51c3551a14d$var$ce = $468ad51c3551a14d$var$ia && "TextEvent" in window && !$468ad51c3551a14d$var$be, $468ad51c3551a14d$var$de = $468ad51c3551a14d$var$ia && (!$468ad51c3551a14d$var$ae || $468ad51c3551a14d$var$be && 8 < $468ad51c3551a14d$var$be && 11 >= $468ad51c3551a14d$var$be), $468ad51c3551a14d$var$ee = String.fromCharCode(32), $468ad51c3551a14d$var$fe = !1;
function $468ad51c3551a14d$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $468ad51c3551a14d$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $468ad51c3551a14d$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $468ad51c3551a14d$var$ie = !1;
function $468ad51c3551a14d$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $468ad51c3551a14d$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $468ad51c3551a14d$var$fe = !0;
            return $468ad51c3551a14d$var$ee;
        case "textInput":
            return a = b.data, a === $468ad51c3551a14d$var$ee && $468ad51c3551a14d$var$fe ? null : a;
        default:
            return null;
    }
}
function $468ad51c3551a14d$var$ke(a, b) {
    if ($468ad51c3551a14d$var$ie) return "compositionend" === a || !$468ad51c3551a14d$var$ae && $468ad51c3551a14d$var$ge(a, b) ? (a = $468ad51c3551a14d$var$nd(), $468ad51c3551a14d$var$md = $468ad51c3551a14d$var$ld = $468ad51c3551a14d$var$kd = null, $468ad51c3551a14d$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $468ad51c3551a14d$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $468ad51c3551a14d$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $468ad51c3551a14d$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$468ad51c3551a14d$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $468ad51c3551a14d$var$ne(a, b, c, d) {
    $468ad51c3551a14d$var$Eb(d);
    b = $468ad51c3551a14d$var$oe(b, "onChange");
    0 < b.length && (c = new $468ad51c3551a14d$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $468ad51c3551a14d$var$pe = null, $468ad51c3551a14d$var$qe = null;
function $468ad51c3551a14d$var$re(a) {
    $468ad51c3551a14d$var$se(a, 0);
}
function $468ad51c3551a14d$var$te(a) {
    var b = $468ad51c3551a14d$var$ue(a);
    if ($468ad51c3551a14d$var$Wa(b)) return a;
}
function $468ad51c3551a14d$var$ve(a, b) {
    if ("change" === a) return b;
}
var $468ad51c3551a14d$var$we = !1;
if ($468ad51c3551a14d$var$ia) {
    var $468ad51c3551a14d$var$xe;
    if ($468ad51c3551a14d$var$ia) {
        var $468ad51c3551a14d$var$ye = "oninput" in document;
        if (!$468ad51c3551a14d$var$ye) {
            var $468ad51c3551a14d$var$ze = document.createElement("div");
            $468ad51c3551a14d$var$ze.setAttribute("oninput", "return;");
            $468ad51c3551a14d$var$ye = "function" === typeof $468ad51c3551a14d$var$ze.oninput;
        }
        $468ad51c3551a14d$var$xe = $468ad51c3551a14d$var$ye;
    } else $468ad51c3551a14d$var$xe = !1;
    $468ad51c3551a14d$var$we = $468ad51c3551a14d$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $468ad51c3551a14d$var$Ae() {
    $468ad51c3551a14d$var$pe && ($468ad51c3551a14d$var$pe.detachEvent("onpropertychange", $468ad51c3551a14d$var$Be), $468ad51c3551a14d$var$qe = $468ad51c3551a14d$var$pe = null);
}
function $468ad51c3551a14d$var$Be(a) {
    if ("value" === a.propertyName && $468ad51c3551a14d$var$te($468ad51c3551a14d$var$qe)) {
        var b = [];
        $468ad51c3551a14d$var$ne(b, $468ad51c3551a14d$var$qe, a, $468ad51c3551a14d$var$xb(a));
        $468ad51c3551a14d$var$Jb($468ad51c3551a14d$var$re, b);
    }
}
function $468ad51c3551a14d$var$Ce(a, b, c) {
    "focusin" === a ? ($468ad51c3551a14d$var$Ae(), $468ad51c3551a14d$var$pe = b, $468ad51c3551a14d$var$qe = c, $468ad51c3551a14d$var$pe.attachEvent("onpropertychange", $468ad51c3551a14d$var$Be)) : "focusout" === a && $468ad51c3551a14d$var$Ae();
}
function $468ad51c3551a14d$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $468ad51c3551a14d$var$te($468ad51c3551a14d$var$qe);
}
function $468ad51c3551a14d$var$Ee(a, b) {
    if ("click" === a) return $468ad51c3551a14d$var$te(b);
}
function $468ad51c3551a14d$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $468ad51c3551a14d$var$te(b);
}
function $468ad51c3551a14d$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $468ad51c3551a14d$var$He = "function" === typeof Object.is ? Object.is : $468ad51c3551a14d$var$Ge;
function $468ad51c3551a14d$var$Ie(a, b) {
    if ($468ad51c3551a14d$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$468ad51c3551a14d$var$ja.call(b, e) || !$468ad51c3551a14d$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $468ad51c3551a14d$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $468ad51c3551a14d$var$Ke(a, b) {
    var c = $468ad51c3551a14d$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $468ad51c3551a14d$var$Je(c);
    }
}
function $468ad51c3551a14d$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $468ad51c3551a14d$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $468ad51c3551a14d$var$Me() {
    for(var a = window, b = $468ad51c3551a14d$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $468ad51c3551a14d$var$Xa(a.document);
    }
    return b;
}
function $468ad51c3551a14d$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $468ad51c3551a14d$var$Oe(a) {
    var b = $468ad51c3551a14d$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $468ad51c3551a14d$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $468ad51c3551a14d$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $468ad51c3551a14d$var$Ke(c, f);
                var g = $468ad51c3551a14d$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $468ad51c3551a14d$var$Pe = $468ad51c3551a14d$var$ia && "documentMode" in document && 11 >= document.documentMode, $468ad51c3551a14d$var$Qe = null, $468ad51c3551a14d$var$Re = null, $468ad51c3551a14d$var$Se = null, $468ad51c3551a14d$var$Te = !1;
function $468ad51c3551a14d$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $468ad51c3551a14d$var$Te || null == $468ad51c3551a14d$var$Qe || $468ad51c3551a14d$var$Qe !== $468ad51c3551a14d$var$Xa(d) || (d = $468ad51c3551a14d$var$Qe, "selectionStart" in d && $468ad51c3551a14d$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $468ad51c3551a14d$var$Se && $468ad51c3551a14d$var$Ie($468ad51c3551a14d$var$Se, d) || ($468ad51c3551a14d$var$Se = d, d = $468ad51c3551a14d$var$oe($468ad51c3551a14d$var$Re, "onSelect"), 0 < d.length && (b = new $468ad51c3551a14d$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $468ad51c3551a14d$var$Qe)));
}
function $468ad51c3551a14d$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $468ad51c3551a14d$var$We = {
    animationend: $468ad51c3551a14d$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $468ad51c3551a14d$var$Ve("Animation", "AnimationIteration"),
    animationstart: $468ad51c3551a14d$var$Ve("Animation", "AnimationStart"),
    transitionend: $468ad51c3551a14d$var$Ve("Transition", "TransitionEnd")
}, $468ad51c3551a14d$var$Xe = {}, $468ad51c3551a14d$var$Ye = {};
$468ad51c3551a14d$var$ia && ($468ad51c3551a14d$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $468ad51c3551a14d$var$We.animationend.animation, delete $468ad51c3551a14d$var$We.animationiteration.animation, delete $468ad51c3551a14d$var$We.animationstart.animation), "TransitionEvent" in window || delete $468ad51c3551a14d$var$We.transitionend.transition);
function $468ad51c3551a14d$var$Ze(a) {
    if ($468ad51c3551a14d$var$Xe[a]) return $468ad51c3551a14d$var$Xe[a];
    if (!$468ad51c3551a14d$var$We[a]) return a;
    var b = $468ad51c3551a14d$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $468ad51c3551a14d$var$Ye) return $468ad51c3551a14d$var$Xe[a] = b[c];
    return a;
}
var $468ad51c3551a14d$var$$e = $468ad51c3551a14d$var$Ze("animationend"), $468ad51c3551a14d$var$af = $468ad51c3551a14d$var$Ze("animationiteration"), $468ad51c3551a14d$var$bf = $468ad51c3551a14d$var$Ze("animationstart"), $468ad51c3551a14d$var$cf = $468ad51c3551a14d$var$Ze("transitionend"), $468ad51c3551a14d$var$df = new Map, $468ad51c3551a14d$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $468ad51c3551a14d$var$ff(a, b) {
    $468ad51c3551a14d$var$df.set(a, b);
    $468ad51c3551a14d$var$fa(b, [
        a
    ]);
}
for(var $468ad51c3551a14d$var$gf = 0; $468ad51c3551a14d$var$gf < $468ad51c3551a14d$var$ef.length; $468ad51c3551a14d$var$gf++){
    var $468ad51c3551a14d$var$hf = $468ad51c3551a14d$var$ef[$468ad51c3551a14d$var$gf], $468ad51c3551a14d$var$jf = $468ad51c3551a14d$var$hf.toLowerCase(), $468ad51c3551a14d$var$kf = $468ad51c3551a14d$var$hf[0].toUpperCase() + $468ad51c3551a14d$var$hf.slice(1);
    $468ad51c3551a14d$var$ff($468ad51c3551a14d$var$jf, "on" + $468ad51c3551a14d$var$kf);
}
$468ad51c3551a14d$var$ff($468ad51c3551a14d$var$$e, "onAnimationEnd");
$468ad51c3551a14d$var$ff($468ad51c3551a14d$var$af, "onAnimationIteration");
$468ad51c3551a14d$var$ff($468ad51c3551a14d$var$bf, "onAnimationStart");
$468ad51c3551a14d$var$ff("dblclick", "onDoubleClick");
$468ad51c3551a14d$var$ff("focusin", "onFocus");
$468ad51c3551a14d$var$ff("focusout", "onBlur");
$468ad51c3551a14d$var$ff($468ad51c3551a14d$var$cf, "onTransitionEnd");
$468ad51c3551a14d$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$468ad51c3551a14d$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$468ad51c3551a14d$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$468ad51c3551a14d$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$468ad51c3551a14d$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$468ad51c3551a14d$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$468ad51c3551a14d$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$468ad51c3551a14d$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$468ad51c3551a14d$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$468ad51c3551a14d$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $468ad51c3551a14d$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $468ad51c3551a14d$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($468ad51c3551a14d$var$lf));
function $468ad51c3551a14d$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $468ad51c3551a14d$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $468ad51c3551a14d$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $468ad51c3551a14d$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $468ad51c3551a14d$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($468ad51c3551a14d$var$Qb) throw a = $468ad51c3551a14d$var$Rb, $468ad51c3551a14d$var$Qb = !1, $468ad51c3551a14d$var$Rb = null, a;
}
function $468ad51c3551a14d$var$D(a, b) {
    var c = b[$468ad51c3551a14d$var$of];
    void 0 === c && (c = b[$468ad51c3551a14d$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($468ad51c3551a14d$var$pf(b, a, 2, !1), c.add(d));
}
function $468ad51c3551a14d$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $468ad51c3551a14d$var$pf(c, a, d, b);
}
var $468ad51c3551a14d$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $468ad51c3551a14d$var$sf(a) {
    if (!a[$468ad51c3551a14d$var$rf]) {
        a[$468ad51c3551a14d$var$rf] = !0;
        $468ad51c3551a14d$var$da.forEach(function(b) {
            "selectionchange" !== b && ($468ad51c3551a14d$var$mf.has(b) || $468ad51c3551a14d$var$qf(b, !1, a), $468ad51c3551a14d$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$468ad51c3551a14d$var$rf] || (b[$468ad51c3551a14d$var$rf] = !0, $468ad51c3551a14d$var$qf("selectionchange", !1, b));
    }
}
function $468ad51c3551a14d$var$pf(a, b, c, d) {
    switch($468ad51c3551a14d$var$jd(b)){
        case 1:
            var e = $468ad51c3551a14d$var$ed;
            break;
        case 4:
            e = $468ad51c3551a14d$var$gd;
            break;
        default:
            e = $468ad51c3551a14d$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$468ad51c3551a14d$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $468ad51c3551a14d$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $468ad51c3551a14d$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $468ad51c3551a14d$var$Jb(function() {
        var d = f, e = $468ad51c3551a14d$var$xb(c), g = [];
        a: {
            var h = $468ad51c3551a14d$var$df.get(a);
            if (void 0 !== h) {
                var k = $468ad51c3551a14d$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $468ad51c3551a14d$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $468ad51c3551a14d$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $468ad51c3551a14d$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $468ad51c3551a14d$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $468ad51c3551a14d$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $468ad51c3551a14d$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $468ad51c3551a14d$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $468ad51c3551a14d$var$Vd;
                        break;
                    case $468ad51c3551a14d$var$$e:
                    case $468ad51c3551a14d$var$af:
                    case $468ad51c3551a14d$var$bf:
                        k = $468ad51c3551a14d$var$Hd;
                        break;
                    case $468ad51c3551a14d$var$cf:
                        k = $468ad51c3551a14d$var$Xd;
                        break;
                    case "scroll":
                        k = $468ad51c3551a14d$var$vd;
                        break;
                    case "wheel":
                        k = $468ad51c3551a14d$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $468ad51c3551a14d$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $468ad51c3551a14d$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $468ad51c3551a14d$var$Kb(w, x), null != F && t.push($468ad51c3551a14d$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $468ad51c3551a14d$var$wb && (n = c.relatedTarget || c.fromElement) && ($468ad51c3551a14d$var$Wc(n) || n[$468ad51c3551a14d$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $468ad51c3551a14d$var$Wc(n) : null, null !== n && (J = $468ad51c3551a14d$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $468ad51c3551a14d$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $468ad51c3551a14d$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $468ad51c3551a14d$var$ue(k);
                        u = null == n ? h : $468ad51c3551a14d$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $468ad51c3551a14d$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $468ad51c3551a14d$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $468ad51c3551a14d$var$vf(F))u++;
                            for(; 0 < w - u;)t = $468ad51c3551a14d$var$vf(t), w--;
                            for(; 0 < u - w;)x = $468ad51c3551a14d$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $468ad51c3551a14d$var$vf(t);
                                x = $468ad51c3551a14d$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $468ad51c3551a14d$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $468ad51c3551a14d$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $468ad51c3551a14d$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $468ad51c3551a14d$var$ve;
                else if ($468ad51c3551a14d$var$me(h)) {
                    if ($468ad51c3551a14d$var$we) na = $468ad51c3551a14d$var$Fe;
                    else {
                        na = $468ad51c3551a14d$var$De;
                        var xa = $468ad51c3551a14d$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $468ad51c3551a14d$var$Ee);
                if (na && (na = na(a, d))) {
                    $468ad51c3551a14d$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $468ad51c3551a14d$var$cb(h, "number", h.value);
            }
            xa = d ? $468ad51c3551a14d$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($468ad51c3551a14d$var$me(xa) || "true" === xa.contentEditable) $468ad51c3551a14d$var$Qe = xa, $468ad51c3551a14d$var$Re = d, $468ad51c3551a14d$var$Se = null;
                    break;
                case "focusout":
                    $468ad51c3551a14d$var$Se = $468ad51c3551a14d$var$Re = $468ad51c3551a14d$var$Qe = null;
                    break;
                case "mousedown":
                    $468ad51c3551a14d$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $468ad51c3551a14d$var$Te = !1;
                    $468ad51c3551a14d$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($468ad51c3551a14d$var$Pe) break;
                case "keydown":
                case "keyup":
                    $468ad51c3551a14d$var$Ue(g, c, e);
            }
            var $a;
            if ($468ad51c3551a14d$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $468ad51c3551a14d$var$ie ? $468ad51c3551a14d$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($468ad51c3551a14d$var$de && "ko" !== c.locale && ($468ad51c3551a14d$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $468ad51c3551a14d$var$ie && ($a = $468ad51c3551a14d$var$nd()) : ($468ad51c3551a14d$var$kd = e, $468ad51c3551a14d$var$ld = "value" in $468ad51c3551a14d$var$kd ? $468ad51c3551a14d$var$kd.value : $468ad51c3551a14d$var$kd.textContent, $468ad51c3551a14d$var$ie = !0)), xa = $468ad51c3551a14d$var$oe(d, ba), 0 < xa.length && (ba = new $468ad51c3551a14d$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $468ad51c3551a14d$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $468ad51c3551a14d$var$ce ? $468ad51c3551a14d$var$je(a, c) : $468ad51c3551a14d$var$ke(a, c)) d = $468ad51c3551a14d$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $468ad51c3551a14d$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $468ad51c3551a14d$var$se(g, b);
    });
}
function $468ad51c3551a14d$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $468ad51c3551a14d$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $468ad51c3551a14d$var$Kb(a, c), null != f && d.unshift($468ad51c3551a14d$var$tf(a, f, e)), f = $468ad51c3551a14d$var$Kb(a, b), null != f && d.push($468ad51c3551a14d$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $468ad51c3551a14d$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $468ad51c3551a14d$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $468ad51c3551a14d$var$Kb(c, f), null != k && g.unshift($468ad51c3551a14d$var$tf(c, k, h))) : e || (k = $468ad51c3551a14d$var$Kb(c, f), null != k && g.push($468ad51c3551a14d$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $468ad51c3551a14d$var$xf = /\r\n?/g, $468ad51c3551a14d$var$yf = /\u0000|\uFFFD/g;
function $468ad51c3551a14d$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($468ad51c3551a14d$var$xf, "\n").replace($468ad51c3551a14d$var$yf, "");
}
function $468ad51c3551a14d$var$Af(a, b, c) {
    b = $468ad51c3551a14d$var$zf(b);
    if ($468ad51c3551a14d$var$zf(a) !== b && c) throw Error($468ad51c3551a14d$var$p(425));
}
function $468ad51c3551a14d$var$Bf() {}
var $468ad51c3551a14d$var$Cf = null, $468ad51c3551a14d$var$Df = null;
function $468ad51c3551a14d$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $468ad51c3551a14d$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $468ad51c3551a14d$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $468ad51c3551a14d$var$Hf = "function" === typeof Promise ? Promise : void 0, $468ad51c3551a14d$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $468ad51c3551a14d$var$Hf ? function(a) {
    return $468ad51c3551a14d$var$Hf.resolve(null).then(a).catch($468ad51c3551a14d$var$If);
} : $468ad51c3551a14d$var$Ff;
function $468ad51c3551a14d$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $468ad51c3551a14d$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $468ad51c3551a14d$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $468ad51c3551a14d$var$bd(b);
}
function $468ad51c3551a14d$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $468ad51c3551a14d$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $468ad51c3551a14d$var$Nf = Math.random().toString(36).slice(2), $468ad51c3551a14d$var$Of = "__reactFiber$" + $468ad51c3551a14d$var$Nf, $468ad51c3551a14d$var$Pf = "__reactProps$" + $468ad51c3551a14d$var$Nf, $468ad51c3551a14d$var$uf = "__reactContainer$" + $468ad51c3551a14d$var$Nf, $468ad51c3551a14d$var$of = "__reactEvents$" + $468ad51c3551a14d$var$Nf, $468ad51c3551a14d$var$Qf = "__reactListeners$" + $468ad51c3551a14d$var$Nf, $468ad51c3551a14d$var$Rf = "__reactHandles$" + $468ad51c3551a14d$var$Nf;
function $468ad51c3551a14d$var$Wc(a) {
    var b = a[$468ad51c3551a14d$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$468ad51c3551a14d$var$uf] || c[$468ad51c3551a14d$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $468ad51c3551a14d$var$Mf(a); null !== a;){
                if (c = a[$468ad51c3551a14d$var$Of]) return c;
                a = $468ad51c3551a14d$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $468ad51c3551a14d$var$Cb(a) {
    a = a[$468ad51c3551a14d$var$Of] || a[$468ad51c3551a14d$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $468ad51c3551a14d$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($468ad51c3551a14d$var$p(33));
}
function $468ad51c3551a14d$var$Db(a) {
    return a[$468ad51c3551a14d$var$Pf] || null;
}
var $468ad51c3551a14d$var$Sf = [], $468ad51c3551a14d$var$Tf = -1;
function $468ad51c3551a14d$var$Uf(a) {
    return {
        current: a
    };
}
function $468ad51c3551a14d$var$E(a) {
    0 > $468ad51c3551a14d$var$Tf || (a.current = $468ad51c3551a14d$var$Sf[$468ad51c3551a14d$var$Tf], $468ad51c3551a14d$var$Sf[$468ad51c3551a14d$var$Tf] = null, $468ad51c3551a14d$var$Tf--);
}
function $468ad51c3551a14d$var$G(a, b) {
    $468ad51c3551a14d$var$Tf++;
    $468ad51c3551a14d$var$Sf[$468ad51c3551a14d$var$Tf] = a.current;
    a.current = b;
}
var $468ad51c3551a14d$var$Vf = {}, $468ad51c3551a14d$var$H = $468ad51c3551a14d$var$Uf($468ad51c3551a14d$var$Vf), $468ad51c3551a14d$var$Wf = $468ad51c3551a14d$var$Uf(!1), $468ad51c3551a14d$var$Xf = $468ad51c3551a14d$var$Vf;
function $468ad51c3551a14d$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $468ad51c3551a14d$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $468ad51c3551a14d$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $468ad51c3551a14d$var$$f() {
    $468ad51c3551a14d$var$E($468ad51c3551a14d$var$Wf);
    $468ad51c3551a14d$var$E($468ad51c3551a14d$var$H);
}
function $468ad51c3551a14d$var$ag(a, b, c) {
    if ($468ad51c3551a14d$var$H.current !== $468ad51c3551a14d$var$Vf) throw Error($468ad51c3551a14d$var$p(168));
    $468ad51c3551a14d$var$G($468ad51c3551a14d$var$H, b);
    $468ad51c3551a14d$var$G($468ad51c3551a14d$var$Wf, c);
}
function $468ad51c3551a14d$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($468ad51c3551a14d$var$p(108, $468ad51c3551a14d$var$Ra(a) || "Unknown", e));
    return $468ad51c3551a14d$var$A({}, c, d);
}
function $468ad51c3551a14d$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $468ad51c3551a14d$var$Vf;
    $468ad51c3551a14d$var$Xf = $468ad51c3551a14d$var$H.current;
    $468ad51c3551a14d$var$G($468ad51c3551a14d$var$H, a);
    $468ad51c3551a14d$var$G($468ad51c3551a14d$var$Wf, $468ad51c3551a14d$var$Wf.current);
    return !0;
}
function $468ad51c3551a14d$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($468ad51c3551a14d$var$p(169));
    c ? (a = $468ad51c3551a14d$var$bg(a, b, $468ad51c3551a14d$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $468ad51c3551a14d$var$E($468ad51c3551a14d$var$Wf), $468ad51c3551a14d$var$E($468ad51c3551a14d$var$H), $468ad51c3551a14d$var$G($468ad51c3551a14d$var$H, a)) : $468ad51c3551a14d$var$E($468ad51c3551a14d$var$Wf);
    $468ad51c3551a14d$var$G($468ad51c3551a14d$var$Wf, c);
}
var $468ad51c3551a14d$var$eg = null, $468ad51c3551a14d$var$fg = !1, $468ad51c3551a14d$var$gg = !1;
function $468ad51c3551a14d$var$hg(a) {
    null === $468ad51c3551a14d$var$eg ? $468ad51c3551a14d$var$eg = [
        a
    ] : $468ad51c3551a14d$var$eg.push(a);
}
function $468ad51c3551a14d$var$ig(a) {
    $468ad51c3551a14d$var$fg = !0;
    $468ad51c3551a14d$var$hg(a);
}
function $468ad51c3551a14d$var$jg() {
    if (!$468ad51c3551a14d$var$gg && null !== $468ad51c3551a14d$var$eg) {
        $468ad51c3551a14d$var$gg = !0;
        var a = 0, b = $468ad51c3551a14d$var$C;
        try {
            var c = $468ad51c3551a14d$var$eg;
            for($468ad51c3551a14d$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $468ad51c3551a14d$var$eg = null;
            $468ad51c3551a14d$var$fg = !1;
        } catch (e) {
            throw null !== $468ad51c3551a14d$var$eg && ($468ad51c3551a14d$var$eg = $468ad51c3551a14d$var$eg.slice(a + 1)), $468ad51c3551a14d$var$ac($468ad51c3551a14d$var$fc, $468ad51c3551a14d$var$jg), e;
        } finally{
            $468ad51c3551a14d$var$C = b, $468ad51c3551a14d$var$gg = !1;
        }
    }
    return null;
}
var $468ad51c3551a14d$var$kg = [], $468ad51c3551a14d$var$lg = 0, $468ad51c3551a14d$var$mg = null, $468ad51c3551a14d$var$ng = 0, $468ad51c3551a14d$var$og = [], $468ad51c3551a14d$var$pg = 0, $468ad51c3551a14d$var$qg = null, $468ad51c3551a14d$var$rg = 1, $468ad51c3551a14d$var$sg = "";
function $468ad51c3551a14d$var$tg(a, b) {
    $468ad51c3551a14d$var$kg[$468ad51c3551a14d$var$lg++] = $468ad51c3551a14d$var$ng;
    $468ad51c3551a14d$var$kg[$468ad51c3551a14d$var$lg++] = $468ad51c3551a14d$var$mg;
    $468ad51c3551a14d$var$mg = a;
    $468ad51c3551a14d$var$ng = b;
}
function $468ad51c3551a14d$var$ug(a, b, c) {
    $468ad51c3551a14d$var$og[$468ad51c3551a14d$var$pg++] = $468ad51c3551a14d$var$rg;
    $468ad51c3551a14d$var$og[$468ad51c3551a14d$var$pg++] = $468ad51c3551a14d$var$sg;
    $468ad51c3551a14d$var$og[$468ad51c3551a14d$var$pg++] = $468ad51c3551a14d$var$qg;
    $468ad51c3551a14d$var$qg = a;
    var d = $468ad51c3551a14d$var$rg;
    a = $468ad51c3551a14d$var$sg;
    var e = 32 - $468ad51c3551a14d$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $468ad51c3551a14d$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $468ad51c3551a14d$var$rg = 1 << 32 - $468ad51c3551a14d$var$oc(b) + e | c << e | d;
        $468ad51c3551a14d$var$sg = f + a;
    } else $468ad51c3551a14d$var$rg = 1 << f | c << e | d, $468ad51c3551a14d$var$sg = a;
}
function $468ad51c3551a14d$var$vg(a) {
    null !== a.return && ($468ad51c3551a14d$var$tg(a, 1), $468ad51c3551a14d$var$ug(a, 1, 0));
}
function $468ad51c3551a14d$var$wg(a) {
    for(; a === $468ad51c3551a14d$var$mg;)$468ad51c3551a14d$var$mg = $468ad51c3551a14d$var$kg[--$468ad51c3551a14d$var$lg], $468ad51c3551a14d$var$kg[$468ad51c3551a14d$var$lg] = null, $468ad51c3551a14d$var$ng = $468ad51c3551a14d$var$kg[--$468ad51c3551a14d$var$lg], $468ad51c3551a14d$var$kg[$468ad51c3551a14d$var$lg] = null;
    for(; a === $468ad51c3551a14d$var$qg;)$468ad51c3551a14d$var$qg = $468ad51c3551a14d$var$og[--$468ad51c3551a14d$var$pg], $468ad51c3551a14d$var$og[$468ad51c3551a14d$var$pg] = null, $468ad51c3551a14d$var$sg = $468ad51c3551a14d$var$og[--$468ad51c3551a14d$var$pg], $468ad51c3551a14d$var$og[$468ad51c3551a14d$var$pg] = null, $468ad51c3551a14d$var$rg = $468ad51c3551a14d$var$og[--$468ad51c3551a14d$var$pg], $468ad51c3551a14d$var$og[$468ad51c3551a14d$var$pg] = null;
}
var $468ad51c3551a14d$var$xg = null, $468ad51c3551a14d$var$yg = null, $468ad51c3551a14d$var$I = !1, $468ad51c3551a14d$var$zg = null;
function $468ad51c3551a14d$var$Ag(a, b) {
    var c = $468ad51c3551a14d$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $468ad51c3551a14d$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $468ad51c3551a14d$var$xg = a, $468ad51c3551a14d$var$yg = $468ad51c3551a14d$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $468ad51c3551a14d$var$xg = a, $468ad51c3551a14d$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $468ad51c3551a14d$var$qg ? {
                id: $468ad51c3551a14d$var$rg,
                overflow: $468ad51c3551a14d$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $468ad51c3551a14d$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $468ad51c3551a14d$var$xg = a, $468ad51c3551a14d$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $468ad51c3551a14d$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $468ad51c3551a14d$var$Eg(a) {
    if ($468ad51c3551a14d$var$I) {
        var b = $468ad51c3551a14d$var$yg;
        if (b) {
            var c = b;
            if (!$468ad51c3551a14d$var$Cg(a, b)) {
                if ($468ad51c3551a14d$var$Dg(a)) throw Error($468ad51c3551a14d$var$p(418));
                b = $468ad51c3551a14d$var$Lf(c.nextSibling);
                var d = $468ad51c3551a14d$var$xg;
                b && $468ad51c3551a14d$var$Cg(a, b) ? $468ad51c3551a14d$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $468ad51c3551a14d$var$I = !1, $468ad51c3551a14d$var$xg = a);
            }
        } else {
            if ($468ad51c3551a14d$var$Dg(a)) throw Error($468ad51c3551a14d$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $468ad51c3551a14d$var$I = !1;
            $468ad51c3551a14d$var$xg = a;
        }
    }
}
function $468ad51c3551a14d$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $468ad51c3551a14d$var$xg = a;
}
function $468ad51c3551a14d$var$Gg(a) {
    if (a !== $468ad51c3551a14d$var$xg) return !1;
    if (!$468ad51c3551a14d$var$I) return $468ad51c3551a14d$var$Fg(a), $468ad51c3551a14d$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$468ad51c3551a14d$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $468ad51c3551a14d$var$yg)) {
        if ($468ad51c3551a14d$var$Dg(a)) throw $468ad51c3551a14d$var$Hg(), Error($468ad51c3551a14d$var$p(418));
        for(; b;)$468ad51c3551a14d$var$Ag(a, b), b = $468ad51c3551a14d$var$Lf(b.nextSibling);
    }
    $468ad51c3551a14d$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($468ad51c3551a14d$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $468ad51c3551a14d$var$yg = $468ad51c3551a14d$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $468ad51c3551a14d$var$yg = null;
        }
    } else $468ad51c3551a14d$var$yg = $468ad51c3551a14d$var$xg ? $468ad51c3551a14d$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $468ad51c3551a14d$var$Hg() {
    for(var a = $468ad51c3551a14d$var$yg; a;)a = $468ad51c3551a14d$var$Lf(a.nextSibling);
}
function $468ad51c3551a14d$var$Ig() {
    $468ad51c3551a14d$var$yg = $468ad51c3551a14d$var$xg = null;
    $468ad51c3551a14d$var$I = !1;
}
function $468ad51c3551a14d$var$Jg(a) {
    null === $468ad51c3551a14d$var$zg ? $468ad51c3551a14d$var$zg = [
        a
    ] : $468ad51c3551a14d$var$zg.push(a);
}
var $468ad51c3551a14d$var$Kg = $468ad51c3551a14d$var$ua.ReactCurrentBatchConfig;
function $468ad51c3551a14d$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($468ad51c3551a14d$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($468ad51c3551a14d$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($468ad51c3551a14d$var$p(284));
        if (!c._owner) throw Error($468ad51c3551a14d$var$p(290, a));
    }
    return a;
}
function $468ad51c3551a14d$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($468ad51c3551a14d$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $468ad51c3551a14d$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $468ad51c3551a14d$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $468ad51c3551a14d$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $468ad51c3551a14d$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $468ad51c3551a14d$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $468ad51c3551a14d$var$Ha && $468ad51c3551a14d$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $468ad51c3551a14d$var$Lg(a, b, c), d.return = a, d;
        d = $468ad51c3551a14d$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $468ad51c3551a14d$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $468ad51c3551a14d$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $468ad51c3551a14d$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $468ad51c3551a14d$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $468ad51c3551a14d$var$va:
                    return c = $468ad51c3551a14d$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $468ad51c3551a14d$var$Lg(a, null, b), c.return = a, c;
                case $468ad51c3551a14d$var$wa:
                    return b = $468ad51c3551a14d$var$Sg(b, a.mode, c), b.return = a, b;
                case $468ad51c3551a14d$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($468ad51c3551a14d$var$eb(b) || $468ad51c3551a14d$var$Ka(b)) return b = $468ad51c3551a14d$var$Tg(b, a.mode, c, null), b.return = a, b;
            $468ad51c3551a14d$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $468ad51c3551a14d$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $468ad51c3551a14d$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $468ad51c3551a14d$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($468ad51c3551a14d$var$eb(c) || $468ad51c3551a14d$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $468ad51c3551a14d$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $468ad51c3551a14d$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $468ad51c3551a14d$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $468ad51c3551a14d$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($468ad51c3551a14d$var$eb(d) || $468ad51c3551a14d$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $468ad51c3551a14d$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $468ad51c3551a14d$var$I && $468ad51c3551a14d$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $468ad51c3551a14d$var$I && $468ad51c3551a14d$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $468ad51c3551a14d$var$I && $468ad51c3551a14d$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $468ad51c3551a14d$var$Ka(h);
        if ("function" !== typeof l) throw Error($468ad51c3551a14d$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($468ad51c3551a14d$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $468ad51c3551a14d$var$I && $468ad51c3551a14d$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $468ad51c3551a14d$var$I && $468ad51c3551a14d$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $468ad51c3551a14d$var$I && $468ad51c3551a14d$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $468ad51c3551a14d$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $468ad51c3551a14d$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $468ad51c3551a14d$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $468ad51c3551a14d$var$Ha && $468ad51c3551a14d$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $468ad51c3551a14d$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $468ad51c3551a14d$var$ya ? (d = $468ad51c3551a14d$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $468ad51c3551a14d$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $468ad51c3551a14d$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $468ad51c3551a14d$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $468ad51c3551a14d$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $468ad51c3551a14d$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($468ad51c3551a14d$var$eb(f)) return n(a, d, f, h);
            if ($468ad51c3551a14d$var$Ka(f)) return t(a, d, f, h);
            $468ad51c3551a14d$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $468ad51c3551a14d$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $468ad51c3551a14d$var$Ug = $468ad51c3551a14d$var$Og(!0), $468ad51c3551a14d$var$Vg = $468ad51c3551a14d$var$Og(!1), $468ad51c3551a14d$var$Wg = $468ad51c3551a14d$var$Uf(null), $468ad51c3551a14d$var$Xg = null, $468ad51c3551a14d$var$Yg = null, $468ad51c3551a14d$var$Zg = null;
function $468ad51c3551a14d$var$$g() {
    $468ad51c3551a14d$var$Zg = $468ad51c3551a14d$var$Yg = $468ad51c3551a14d$var$Xg = null;
}
function $468ad51c3551a14d$var$ah(a) {
    var b = $468ad51c3551a14d$var$Wg.current;
    $468ad51c3551a14d$var$E($468ad51c3551a14d$var$Wg);
    a._currentValue = b;
}
function $468ad51c3551a14d$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $468ad51c3551a14d$var$ch(a, b) {
    $468ad51c3551a14d$var$Xg = a;
    $468ad51c3551a14d$var$Zg = $468ad51c3551a14d$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($468ad51c3551a14d$var$dh = !0), a.firstContext = null);
}
function $468ad51c3551a14d$var$eh(a) {
    var b = a._currentValue;
    if ($468ad51c3551a14d$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $468ad51c3551a14d$var$Yg) {
            if (null === $468ad51c3551a14d$var$Xg) throw Error($468ad51c3551a14d$var$p(308));
            $468ad51c3551a14d$var$Yg = a;
            $468ad51c3551a14d$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $468ad51c3551a14d$var$Yg = $468ad51c3551a14d$var$Yg.next = a;
    }
    return b;
}
var $468ad51c3551a14d$var$fh = null;
function $468ad51c3551a14d$var$gh(a) {
    null === $468ad51c3551a14d$var$fh ? $468ad51c3551a14d$var$fh = [
        a
    ] : $468ad51c3551a14d$var$fh.push(a);
}
function $468ad51c3551a14d$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $468ad51c3551a14d$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $468ad51c3551a14d$var$ih(a, d);
}
function $468ad51c3551a14d$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $468ad51c3551a14d$var$jh = !1;
function $468ad51c3551a14d$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $468ad51c3551a14d$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $468ad51c3551a14d$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $468ad51c3551a14d$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($468ad51c3551a14d$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $468ad51c3551a14d$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $468ad51c3551a14d$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $468ad51c3551a14d$var$ih(a, c);
}
function $468ad51c3551a14d$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $468ad51c3551a14d$var$Cc(a, c);
    }
}
function $468ad51c3551a14d$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $468ad51c3551a14d$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $468ad51c3551a14d$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $468ad51c3551a14d$var$A({}, q, r);
                            break a;
                        case 2:
                            $468ad51c3551a14d$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $468ad51c3551a14d$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $468ad51c3551a14d$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($468ad51c3551a14d$var$p(191, e));
            e.call(d);
        }
    }
}
var $468ad51c3551a14d$var$th = {}, $468ad51c3551a14d$var$uh = $468ad51c3551a14d$var$Uf($468ad51c3551a14d$var$th), $468ad51c3551a14d$var$vh = $468ad51c3551a14d$var$Uf($468ad51c3551a14d$var$th), $468ad51c3551a14d$var$wh = $468ad51c3551a14d$var$Uf($468ad51c3551a14d$var$th);
function $468ad51c3551a14d$var$xh(a) {
    if (a === $468ad51c3551a14d$var$th) throw Error($468ad51c3551a14d$var$p(174));
    return a;
}
function $468ad51c3551a14d$var$yh(a, b) {
    $468ad51c3551a14d$var$G($468ad51c3551a14d$var$wh, b);
    $468ad51c3551a14d$var$G($468ad51c3551a14d$var$vh, a);
    $468ad51c3551a14d$var$G($468ad51c3551a14d$var$uh, $468ad51c3551a14d$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $468ad51c3551a14d$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $468ad51c3551a14d$var$lb(b, a);
    }
    $468ad51c3551a14d$var$E($468ad51c3551a14d$var$uh);
    $468ad51c3551a14d$var$G($468ad51c3551a14d$var$uh, b);
}
function $468ad51c3551a14d$var$zh() {
    $468ad51c3551a14d$var$E($468ad51c3551a14d$var$uh);
    $468ad51c3551a14d$var$E($468ad51c3551a14d$var$vh);
    $468ad51c3551a14d$var$E($468ad51c3551a14d$var$wh);
}
function $468ad51c3551a14d$var$Ah(a) {
    $468ad51c3551a14d$var$xh($468ad51c3551a14d$var$wh.current);
    var b = $468ad51c3551a14d$var$xh($468ad51c3551a14d$var$uh.current);
    var c = $468ad51c3551a14d$var$lb(b, a.type);
    b !== c && ($468ad51c3551a14d$var$G($468ad51c3551a14d$var$vh, a), $468ad51c3551a14d$var$G($468ad51c3551a14d$var$uh, c));
}
function $468ad51c3551a14d$var$Bh(a) {
    $468ad51c3551a14d$var$vh.current === a && ($468ad51c3551a14d$var$E($468ad51c3551a14d$var$uh), $468ad51c3551a14d$var$E($468ad51c3551a14d$var$vh));
}
var $468ad51c3551a14d$var$L = $468ad51c3551a14d$var$Uf(0);
function $468ad51c3551a14d$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $468ad51c3551a14d$var$Dh = [];
function $468ad51c3551a14d$var$Eh() {
    for(var a = 0; a < $468ad51c3551a14d$var$Dh.length; a++)$468ad51c3551a14d$var$Dh[a]._workInProgressVersionPrimary = null;
    $468ad51c3551a14d$var$Dh.length = 0;
}
var $468ad51c3551a14d$var$Fh = $468ad51c3551a14d$var$ua.ReactCurrentDispatcher, $468ad51c3551a14d$var$Gh = $468ad51c3551a14d$var$ua.ReactCurrentBatchConfig, $468ad51c3551a14d$var$Hh = 0, $468ad51c3551a14d$var$M = null, $468ad51c3551a14d$var$N = null, $468ad51c3551a14d$var$O = null, $468ad51c3551a14d$var$Ih = !1, $468ad51c3551a14d$var$Jh = !1, $468ad51c3551a14d$var$Kh = 0, $468ad51c3551a14d$var$Lh = 0;
function $468ad51c3551a14d$var$P() {
    throw Error($468ad51c3551a14d$var$p(321));
}
function $468ad51c3551a14d$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$468ad51c3551a14d$var$He(a[c], b[c])) return !1;
    return !0;
}
function $468ad51c3551a14d$var$Nh(a, b, c, d, e, f) {
    $468ad51c3551a14d$var$Hh = f;
    $468ad51c3551a14d$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $468ad51c3551a14d$var$Fh.current = null === a || null === a.memoizedState ? $468ad51c3551a14d$var$Oh : $468ad51c3551a14d$var$Ph;
    a = c(d, e);
    if ($468ad51c3551a14d$var$Jh) {
        f = 0;
        do {
            $468ad51c3551a14d$var$Jh = !1;
            $468ad51c3551a14d$var$Kh = 0;
            if (25 <= f) throw Error($468ad51c3551a14d$var$p(301));
            f += 1;
            $468ad51c3551a14d$var$O = $468ad51c3551a14d$var$N = null;
            b.updateQueue = null;
            $468ad51c3551a14d$var$Fh.current = $468ad51c3551a14d$var$Qh;
            a = c(d, e);
        }while ($468ad51c3551a14d$var$Jh);
    }
    $468ad51c3551a14d$var$Fh.current = $468ad51c3551a14d$var$Rh;
    b = null !== $468ad51c3551a14d$var$N && null !== $468ad51c3551a14d$var$N.next;
    $468ad51c3551a14d$var$Hh = 0;
    $468ad51c3551a14d$var$O = $468ad51c3551a14d$var$N = $468ad51c3551a14d$var$M = null;
    $468ad51c3551a14d$var$Ih = !1;
    if (b) throw Error($468ad51c3551a14d$var$p(300));
    return a;
}
function $468ad51c3551a14d$var$Sh() {
    var a = 0 !== $468ad51c3551a14d$var$Kh;
    $468ad51c3551a14d$var$Kh = 0;
    return a;
}
function $468ad51c3551a14d$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $468ad51c3551a14d$var$O ? $468ad51c3551a14d$var$M.memoizedState = $468ad51c3551a14d$var$O = a : $468ad51c3551a14d$var$O = $468ad51c3551a14d$var$O.next = a;
    return $468ad51c3551a14d$var$O;
}
function $468ad51c3551a14d$var$Uh() {
    if (null === $468ad51c3551a14d$var$N) {
        var a = $468ad51c3551a14d$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $468ad51c3551a14d$var$N.next;
    var b = null === $468ad51c3551a14d$var$O ? $468ad51c3551a14d$var$M.memoizedState : $468ad51c3551a14d$var$O.next;
    if (null !== b) $468ad51c3551a14d$var$O = b, $468ad51c3551a14d$var$N = a;
    else {
        if (null === a) throw Error($468ad51c3551a14d$var$p(310));
        $468ad51c3551a14d$var$N = a;
        a = {
            memoizedState: $468ad51c3551a14d$var$N.memoizedState,
            baseState: $468ad51c3551a14d$var$N.baseState,
            baseQueue: $468ad51c3551a14d$var$N.baseQueue,
            queue: $468ad51c3551a14d$var$N.queue,
            next: null
        };
        null === $468ad51c3551a14d$var$O ? $468ad51c3551a14d$var$M.memoizedState = $468ad51c3551a14d$var$O = a : $468ad51c3551a14d$var$O = $468ad51c3551a14d$var$O.next = a;
    }
    return $468ad51c3551a14d$var$O;
}
function $468ad51c3551a14d$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $468ad51c3551a14d$var$Wh(a) {
    var b = $468ad51c3551a14d$var$Uh(), c = b.queue;
    if (null === c) throw Error($468ad51c3551a14d$var$p(311));
    c.lastRenderedReducer = a;
    var d = $468ad51c3551a14d$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($468ad51c3551a14d$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $468ad51c3551a14d$var$M.lanes |= m;
                $468ad51c3551a14d$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $468ad51c3551a14d$var$He(d, b.memoizedState) || ($468ad51c3551a14d$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $468ad51c3551a14d$var$M.lanes |= f, $468ad51c3551a14d$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $468ad51c3551a14d$var$Xh(a) {
    var b = $468ad51c3551a14d$var$Uh(), c = b.queue;
    if (null === c) throw Error($468ad51c3551a14d$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $468ad51c3551a14d$var$He(f, b.memoizedState) || ($468ad51c3551a14d$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $468ad51c3551a14d$var$Yh() {}
function $468ad51c3551a14d$var$Zh(a, b) {
    var c = $468ad51c3551a14d$var$M, d = $468ad51c3551a14d$var$Uh(), e = b(), f = !$468ad51c3551a14d$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $468ad51c3551a14d$var$dh = !0);
    d = d.queue;
    $468ad51c3551a14d$var$$h($468ad51c3551a14d$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $468ad51c3551a14d$var$O && $468ad51c3551a14d$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $468ad51c3551a14d$var$bi(9, $468ad51c3551a14d$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $468ad51c3551a14d$var$Q) throw Error($468ad51c3551a14d$var$p(349));
        0 !== ($468ad51c3551a14d$var$Hh & 30) || $468ad51c3551a14d$var$di(c, b, e);
    }
    return e;
}
function $468ad51c3551a14d$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $468ad51c3551a14d$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $468ad51c3551a14d$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $468ad51c3551a14d$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $468ad51c3551a14d$var$ei(b) && $468ad51c3551a14d$var$fi(a);
}
function $468ad51c3551a14d$var$ai(a, b, c) {
    return c(function() {
        $468ad51c3551a14d$var$ei(b) && $468ad51c3551a14d$var$fi(a);
    });
}
function $468ad51c3551a14d$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$468ad51c3551a14d$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $468ad51c3551a14d$var$fi(a) {
    var b = $468ad51c3551a14d$var$ih(a, 1);
    null !== b && $468ad51c3551a14d$var$gi(b, a, 1, -1);
}
function $468ad51c3551a14d$var$hi(a) {
    var b = $468ad51c3551a14d$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $468ad51c3551a14d$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $468ad51c3551a14d$var$ii.bind(null, $468ad51c3551a14d$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $468ad51c3551a14d$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $468ad51c3551a14d$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $468ad51c3551a14d$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $468ad51c3551a14d$var$ji() {
    return $468ad51c3551a14d$var$Uh().memoizedState;
}
function $468ad51c3551a14d$var$ki(a, b, c, d) {
    var e = $468ad51c3551a14d$var$Th();
    $468ad51c3551a14d$var$M.flags |= a;
    e.memoizedState = $468ad51c3551a14d$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $468ad51c3551a14d$var$li(a, b, c, d) {
    var e = $468ad51c3551a14d$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $468ad51c3551a14d$var$N) {
        var g = $468ad51c3551a14d$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $468ad51c3551a14d$var$Mh(d, g.deps)) {
            e.memoizedState = $468ad51c3551a14d$var$bi(b, c, f, d);
            return;
        }
    }
    $468ad51c3551a14d$var$M.flags |= a;
    e.memoizedState = $468ad51c3551a14d$var$bi(1 | b, c, f, d);
}
function $468ad51c3551a14d$var$mi(a, b) {
    return $468ad51c3551a14d$var$ki(8390656, 8, a, b);
}
function $468ad51c3551a14d$var$$h(a, b) {
    return $468ad51c3551a14d$var$li(2048, 8, a, b);
}
function $468ad51c3551a14d$var$ni(a, b) {
    return $468ad51c3551a14d$var$li(4, 2, a, b);
}
function $468ad51c3551a14d$var$oi(a, b) {
    return $468ad51c3551a14d$var$li(4, 4, a, b);
}
function $468ad51c3551a14d$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $468ad51c3551a14d$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $468ad51c3551a14d$var$li(4, 4, $468ad51c3551a14d$var$pi.bind(null, b, a), c);
}
function $468ad51c3551a14d$var$ri() {}
function $468ad51c3551a14d$var$si(a, b) {
    var c = $468ad51c3551a14d$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $468ad51c3551a14d$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $468ad51c3551a14d$var$ti(a, b) {
    var c = $468ad51c3551a14d$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $468ad51c3551a14d$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $468ad51c3551a14d$var$ui(a, b, c) {
    if (0 === ($468ad51c3551a14d$var$Hh & 21)) return a.baseState && (a.baseState = !1, $468ad51c3551a14d$var$dh = !0), a.memoizedState = c;
    $468ad51c3551a14d$var$He(c, b) || (c = $468ad51c3551a14d$var$yc(), $468ad51c3551a14d$var$M.lanes |= c, $468ad51c3551a14d$var$rh |= c, a.baseState = !0);
    return b;
}
function $468ad51c3551a14d$var$vi(a, b) {
    var c = $468ad51c3551a14d$var$C;
    $468ad51c3551a14d$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $468ad51c3551a14d$var$Gh.transition;
    $468ad51c3551a14d$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $468ad51c3551a14d$var$C = c, $468ad51c3551a14d$var$Gh.transition = d;
    }
}
function $468ad51c3551a14d$var$wi() {
    return $468ad51c3551a14d$var$Uh().memoizedState;
}
function $468ad51c3551a14d$var$xi(a, b, c) {
    var d = $468ad51c3551a14d$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($468ad51c3551a14d$var$zi(a)) $468ad51c3551a14d$var$Ai(b, c);
    else if (c = $468ad51c3551a14d$var$hh(a, b, c, d), null !== c) {
        var e = $468ad51c3551a14d$var$R();
        $468ad51c3551a14d$var$gi(c, a, d, e);
        $468ad51c3551a14d$var$Bi(c, b, d);
    }
}
function $468ad51c3551a14d$var$ii(a, b, c) {
    var d = $468ad51c3551a14d$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($468ad51c3551a14d$var$zi(a)) $468ad51c3551a14d$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($468ad51c3551a14d$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $468ad51c3551a14d$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $468ad51c3551a14d$var$hh(a, b, e, d);
        null !== c && (e = $468ad51c3551a14d$var$R(), $468ad51c3551a14d$var$gi(c, a, d, e), $468ad51c3551a14d$var$Bi(c, b, d));
    }
}
function $468ad51c3551a14d$var$zi(a) {
    var b = a.alternate;
    return a === $468ad51c3551a14d$var$M || null !== b && b === $468ad51c3551a14d$var$M;
}
function $468ad51c3551a14d$var$Ai(a, b) {
    $468ad51c3551a14d$var$Jh = $468ad51c3551a14d$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $468ad51c3551a14d$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $468ad51c3551a14d$var$Cc(a, c);
    }
}
var $468ad51c3551a14d$var$Rh = {
    readContext: $468ad51c3551a14d$var$eh,
    useCallback: $468ad51c3551a14d$var$P,
    useContext: $468ad51c3551a14d$var$P,
    useEffect: $468ad51c3551a14d$var$P,
    useImperativeHandle: $468ad51c3551a14d$var$P,
    useInsertionEffect: $468ad51c3551a14d$var$P,
    useLayoutEffect: $468ad51c3551a14d$var$P,
    useMemo: $468ad51c3551a14d$var$P,
    useReducer: $468ad51c3551a14d$var$P,
    useRef: $468ad51c3551a14d$var$P,
    useState: $468ad51c3551a14d$var$P,
    useDebugValue: $468ad51c3551a14d$var$P,
    useDeferredValue: $468ad51c3551a14d$var$P,
    useTransition: $468ad51c3551a14d$var$P,
    useMutableSource: $468ad51c3551a14d$var$P,
    useSyncExternalStore: $468ad51c3551a14d$var$P,
    useId: $468ad51c3551a14d$var$P,
    unstable_isNewReconciler: !1
}, $468ad51c3551a14d$var$Oh = {
    readContext: $468ad51c3551a14d$var$eh,
    useCallback: function(a, b) {
        $468ad51c3551a14d$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $468ad51c3551a14d$var$eh,
    useEffect: $468ad51c3551a14d$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $468ad51c3551a14d$var$ki(4194308, 4, $468ad51c3551a14d$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $468ad51c3551a14d$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $468ad51c3551a14d$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $468ad51c3551a14d$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $468ad51c3551a14d$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $468ad51c3551a14d$var$xi.bind(null, $468ad51c3551a14d$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $468ad51c3551a14d$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $468ad51c3551a14d$var$hi,
    useDebugValue: $468ad51c3551a14d$var$ri,
    useDeferredValue: function(a) {
        return $468ad51c3551a14d$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $468ad51c3551a14d$var$hi(!1), b = a[0];
        a = $468ad51c3551a14d$var$vi.bind(null, a[1]);
        $468ad51c3551a14d$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $468ad51c3551a14d$var$M, e = $468ad51c3551a14d$var$Th();
        if ($468ad51c3551a14d$var$I) {
            if (void 0 === c) throw Error($468ad51c3551a14d$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $468ad51c3551a14d$var$Q) throw Error($468ad51c3551a14d$var$p(349));
            0 !== ($468ad51c3551a14d$var$Hh & 30) || $468ad51c3551a14d$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $468ad51c3551a14d$var$mi($468ad51c3551a14d$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $468ad51c3551a14d$var$bi(9, $468ad51c3551a14d$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $468ad51c3551a14d$var$Th(), b = $468ad51c3551a14d$var$Q.identifierPrefix;
        if ($468ad51c3551a14d$var$I) {
            var c = $468ad51c3551a14d$var$sg;
            var d = $468ad51c3551a14d$var$rg;
            c = (d & ~(1 << 32 - $468ad51c3551a14d$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $468ad51c3551a14d$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $468ad51c3551a14d$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $468ad51c3551a14d$var$Ph = {
    readContext: $468ad51c3551a14d$var$eh,
    useCallback: $468ad51c3551a14d$var$si,
    useContext: $468ad51c3551a14d$var$eh,
    useEffect: $468ad51c3551a14d$var$$h,
    useImperativeHandle: $468ad51c3551a14d$var$qi,
    useInsertionEffect: $468ad51c3551a14d$var$ni,
    useLayoutEffect: $468ad51c3551a14d$var$oi,
    useMemo: $468ad51c3551a14d$var$ti,
    useReducer: $468ad51c3551a14d$var$Wh,
    useRef: $468ad51c3551a14d$var$ji,
    useState: function() {
        return $468ad51c3551a14d$var$Wh($468ad51c3551a14d$var$Vh);
    },
    useDebugValue: $468ad51c3551a14d$var$ri,
    useDeferredValue: function(a) {
        var b = $468ad51c3551a14d$var$Uh();
        return $468ad51c3551a14d$var$ui(b, $468ad51c3551a14d$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $468ad51c3551a14d$var$Wh($468ad51c3551a14d$var$Vh)[0], b = $468ad51c3551a14d$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $468ad51c3551a14d$var$Yh,
    useSyncExternalStore: $468ad51c3551a14d$var$Zh,
    useId: $468ad51c3551a14d$var$wi,
    unstable_isNewReconciler: !1
}, $468ad51c3551a14d$var$Qh = {
    readContext: $468ad51c3551a14d$var$eh,
    useCallback: $468ad51c3551a14d$var$si,
    useContext: $468ad51c3551a14d$var$eh,
    useEffect: $468ad51c3551a14d$var$$h,
    useImperativeHandle: $468ad51c3551a14d$var$qi,
    useInsertionEffect: $468ad51c3551a14d$var$ni,
    useLayoutEffect: $468ad51c3551a14d$var$oi,
    useMemo: $468ad51c3551a14d$var$ti,
    useReducer: $468ad51c3551a14d$var$Xh,
    useRef: $468ad51c3551a14d$var$ji,
    useState: function() {
        return $468ad51c3551a14d$var$Xh($468ad51c3551a14d$var$Vh);
    },
    useDebugValue: $468ad51c3551a14d$var$ri,
    useDeferredValue: function(a) {
        var b = $468ad51c3551a14d$var$Uh();
        return null === $468ad51c3551a14d$var$N ? b.memoizedState = a : $468ad51c3551a14d$var$ui(b, $468ad51c3551a14d$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $468ad51c3551a14d$var$Xh($468ad51c3551a14d$var$Vh)[0], b = $468ad51c3551a14d$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $468ad51c3551a14d$var$Yh,
    useSyncExternalStore: $468ad51c3551a14d$var$Zh,
    useId: $468ad51c3551a14d$var$wi,
    unstable_isNewReconciler: !1
};
function $468ad51c3551a14d$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $468ad51c3551a14d$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $468ad51c3551a14d$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $468ad51c3551a14d$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $468ad51c3551a14d$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $468ad51c3551a14d$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $468ad51c3551a14d$var$R(), e = $468ad51c3551a14d$var$yi(a), f = $468ad51c3551a14d$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $468ad51c3551a14d$var$nh(a, f, e);
        null !== b && ($468ad51c3551a14d$var$gi(b, a, e, d), $468ad51c3551a14d$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $468ad51c3551a14d$var$R(), e = $468ad51c3551a14d$var$yi(a), f = $468ad51c3551a14d$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $468ad51c3551a14d$var$nh(a, f, e);
        null !== b && ($468ad51c3551a14d$var$gi(b, a, e, d), $468ad51c3551a14d$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $468ad51c3551a14d$var$R(), d = $468ad51c3551a14d$var$yi(a), e = $468ad51c3551a14d$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $468ad51c3551a14d$var$nh(a, e, d);
        null !== b && ($468ad51c3551a14d$var$gi(b, a, d, c), $468ad51c3551a14d$var$oh(b, a, d));
    }
};
function $468ad51c3551a14d$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$468ad51c3551a14d$var$Ie(c, d) || !$468ad51c3551a14d$var$Ie(e, f) : !0;
}
function $468ad51c3551a14d$var$Gi(a, b, c) {
    var d = !1, e = $468ad51c3551a14d$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $468ad51c3551a14d$var$eh(f) : (e = $468ad51c3551a14d$var$Zf(b) ? $468ad51c3551a14d$var$Xf : $468ad51c3551a14d$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $468ad51c3551a14d$var$Yf(a, e) : $468ad51c3551a14d$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $468ad51c3551a14d$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $468ad51c3551a14d$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $468ad51c3551a14d$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $468ad51c3551a14d$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $468ad51c3551a14d$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $468ad51c3551a14d$var$eh(f) : (f = $468ad51c3551a14d$var$Zf(b) ? $468ad51c3551a14d$var$Xf : $468ad51c3551a14d$var$H.current, e.context = $468ad51c3551a14d$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($468ad51c3551a14d$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $468ad51c3551a14d$var$Ei.enqueueReplaceState(e, e.state, null), $468ad51c3551a14d$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $468ad51c3551a14d$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $468ad51c3551a14d$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $468ad51c3551a14d$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $468ad51c3551a14d$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $468ad51c3551a14d$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $468ad51c3551a14d$var$Ni(a, b, c) {
    c = $468ad51c3551a14d$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $468ad51c3551a14d$var$Oi || ($468ad51c3551a14d$var$Oi = !0, $468ad51c3551a14d$var$Pi = d);
        $468ad51c3551a14d$var$Li(a, b);
    };
    return c;
}
function $468ad51c3551a14d$var$Qi(a, b, c) {
    c = $468ad51c3551a14d$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $468ad51c3551a14d$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $468ad51c3551a14d$var$Li(a, b);
        "function" !== typeof d && (null === $468ad51c3551a14d$var$Ri ? $468ad51c3551a14d$var$Ri = new Set([
            this
        ]) : $468ad51c3551a14d$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $468ad51c3551a14d$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $468ad51c3551a14d$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $468ad51c3551a14d$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $468ad51c3551a14d$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $468ad51c3551a14d$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $468ad51c3551a14d$var$mh(-1, 1), b.tag = 2, $468ad51c3551a14d$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $468ad51c3551a14d$var$Wi = $468ad51c3551a14d$var$ua.ReactCurrentOwner, $468ad51c3551a14d$var$dh = !1;
function $468ad51c3551a14d$var$Xi(a, b, c, d) {
    b.child = null === a ? $468ad51c3551a14d$var$Vg(b, null, c, d) : $468ad51c3551a14d$var$Ug(b, a.child, c, d);
}
function $468ad51c3551a14d$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $468ad51c3551a14d$var$ch(b, e);
    d = $468ad51c3551a14d$var$Nh(a, b, c, d, f, e);
    c = $468ad51c3551a14d$var$Sh();
    if (null !== a && !$468ad51c3551a14d$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $468ad51c3551a14d$var$Zi(a, b, e);
    $468ad51c3551a14d$var$I && c && $468ad51c3551a14d$var$vg(b);
    b.flags |= 1;
    $468ad51c3551a14d$var$Xi(a, b, d, e);
    return b.child;
}
function $468ad51c3551a14d$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$468ad51c3551a14d$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $468ad51c3551a14d$var$bj(a, b, f, d, e);
        a = $468ad51c3551a14d$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $468ad51c3551a14d$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $468ad51c3551a14d$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $468ad51c3551a14d$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $468ad51c3551a14d$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($468ad51c3551a14d$var$Ie(f, d) && a.ref === b.ref) {
            if ($468ad51c3551a14d$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($468ad51c3551a14d$var$dh = !0);
            else return b.lanes = a.lanes, $468ad51c3551a14d$var$Zi(a, b, e);
        }
    }
    return $468ad51c3551a14d$var$cj(a, b, c, d, e);
}
function $468ad51c3551a14d$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $468ad51c3551a14d$var$G($468ad51c3551a14d$var$ej, $468ad51c3551a14d$var$fj), $468ad51c3551a14d$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $468ad51c3551a14d$var$G($468ad51c3551a14d$var$ej, $468ad51c3551a14d$var$fj), $468ad51c3551a14d$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $468ad51c3551a14d$var$G($468ad51c3551a14d$var$ej, $468ad51c3551a14d$var$fj);
            $468ad51c3551a14d$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $468ad51c3551a14d$var$G($468ad51c3551a14d$var$ej, $468ad51c3551a14d$var$fj), $468ad51c3551a14d$var$fj |= d;
    $468ad51c3551a14d$var$Xi(a, b, e, c);
    return b.child;
}
function $468ad51c3551a14d$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $468ad51c3551a14d$var$cj(a, b, c, d, e) {
    var f = $468ad51c3551a14d$var$Zf(c) ? $468ad51c3551a14d$var$Xf : $468ad51c3551a14d$var$H.current;
    f = $468ad51c3551a14d$var$Yf(b, f);
    $468ad51c3551a14d$var$ch(b, e);
    c = $468ad51c3551a14d$var$Nh(a, b, c, d, f, e);
    d = $468ad51c3551a14d$var$Sh();
    if (null !== a && !$468ad51c3551a14d$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $468ad51c3551a14d$var$Zi(a, b, e);
    $468ad51c3551a14d$var$I && d && $468ad51c3551a14d$var$vg(b);
    b.flags |= 1;
    $468ad51c3551a14d$var$Xi(a, b, c, e);
    return b.child;
}
function $468ad51c3551a14d$var$hj(a, b, c, d, e) {
    if ($468ad51c3551a14d$var$Zf(c)) {
        var f = !0;
        $468ad51c3551a14d$var$cg(b);
    } else f = !1;
    $468ad51c3551a14d$var$ch(b, e);
    if (null === b.stateNode) $468ad51c3551a14d$var$ij(a, b), $468ad51c3551a14d$var$Gi(b, c, d), $468ad51c3551a14d$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $468ad51c3551a14d$var$eh(l) : (l = $468ad51c3551a14d$var$Zf(c) ? $468ad51c3551a14d$var$Xf : $468ad51c3551a14d$var$H.current, l = $468ad51c3551a14d$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $468ad51c3551a14d$var$Hi(b, g, d, l);
        $468ad51c3551a14d$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $468ad51c3551a14d$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $468ad51c3551a14d$var$Wf.current || $468ad51c3551a14d$var$jh ? ("function" === typeof m && ($468ad51c3551a14d$var$Di(b, c, m, d), k = b.memoizedState), (h = $468ad51c3551a14d$var$jh || $468ad51c3551a14d$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $468ad51c3551a14d$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $468ad51c3551a14d$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $468ad51c3551a14d$var$eh(k) : (k = $468ad51c3551a14d$var$Zf(c) ? $468ad51c3551a14d$var$Xf : $468ad51c3551a14d$var$H.current, k = $468ad51c3551a14d$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $468ad51c3551a14d$var$Hi(b, g, d, k);
        $468ad51c3551a14d$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $468ad51c3551a14d$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $468ad51c3551a14d$var$Wf.current || $468ad51c3551a14d$var$jh ? ("function" === typeof y && ($468ad51c3551a14d$var$Di(b, c, y, d), n = b.memoizedState), (l = $468ad51c3551a14d$var$jh || $468ad51c3551a14d$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $468ad51c3551a14d$var$jj(a, b, c, d, f, e);
}
function $468ad51c3551a14d$var$jj(a, b, c, d, e, f) {
    $468ad51c3551a14d$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $468ad51c3551a14d$var$dg(b, c, !1), $468ad51c3551a14d$var$Zi(a, b, f);
    d = b.stateNode;
    $468ad51c3551a14d$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $468ad51c3551a14d$var$Ug(b, a.child, null, f), b.child = $468ad51c3551a14d$var$Ug(b, null, h, f)) : $468ad51c3551a14d$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $468ad51c3551a14d$var$dg(b, c, !0);
    return b.child;
}
function $468ad51c3551a14d$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $468ad51c3551a14d$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $468ad51c3551a14d$var$ag(a, b.context, !1);
    $468ad51c3551a14d$var$yh(a, b.containerInfo);
}
function $468ad51c3551a14d$var$lj(a, b, c, d, e) {
    $468ad51c3551a14d$var$Ig();
    $468ad51c3551a14d$var$Jg(e);
    b.flags |= 256;
    $468ad51c3551a14d$var$Xi(a, b, c, d);
    return b.child;
}
var $468ad51c3551a14d$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $468ad51c3551a14d$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $468ad51c3551a14d$var$oj(a, b, c) {
    var d = b.pendingProps, e = $468ad51c3551a14d$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $468ad51c3551a14d$var$G($468ad51c3551a14d$var$L, e & 1);
    if (null === a) {
        $468ad51c3551a14d$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $468ad51c3551a14d$var$pj(g, d, 0, null), a = $468ad51c3551a14d$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $468ad51c3551a14d$var$nj(c), b.memoizedState = $468ad51c3551a14d$var$mj, a) : $468ad51c3551a14d$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $468ad51c3551a14d$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $468ad51c3551a14d$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $468ad51c3551a14d$var$Pg(h, f) : (f = $468ad51c3551a14d$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $468ad51c3551a14d$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $468ad51c3551a14d$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $468ad51c3551a14d$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $468ad51c3551a14d$var$qj(a, b) {
    b = $468ad51c3551a14d$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $468ad51c3551a14d$var$sj(a, b, c, d) {
    null !== d && $468ad51c3551a14d$var$Jg(d);
    $468ad51c3551a14d$var$Ug(b, a.child, null, c);
    a = $468ad51c3551a14d$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $468ad51c3551a14d$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $468ad51c3551a14d$var$Ki(Error($468ad51c3551a14d$var$p(422))), $468ad51c3551a14d$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $468ad51c3551a14d$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $468ad51c3551a14d$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $468ad51c3551a14d$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $468ad51c3551a14d$var$nj(g);
        b.memoizedState = $468ad51c3551a14d$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $468ad51c3551a14d$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($468ad51c3551a14d$var$p(419));
        d = $468ad51c3551a14d$var$Ki(f, d, void 0);
        return $468ad51c3551a14d$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($468ad51c3551a14d$var$dh || h) {
        d = $468ad51c3551a14d$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $468ad51c3551a14d$var$ih(a, e), $468ad51c3551a14d$var$gi(d, a, e, -1));
        }
        $468ad51c3551a14d$var$tj();
        d = $468ad51c3551a14d$var$Ki(Error($468ad51c3551a14d$var$p(421)));
        return $468ad51c3551a14d$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $468ad51c3551a14d$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $468ad51c3551a14d$var$yg = $468ad51c3551a14d$var$Lf(e.nextSibling);
    $468ad51c3551a14d$var$xg = b;
    $468ad51c3551a14d$var$I = !0;
    $468ad51c3551a14d$var$zg = null;
    null !== a && ($468ad51c3551a14d$var$og[$468ad51c3551a14d$var$pg++] = $468ad51c3551a14d$var$rg, $468ad51c3551a14d$var$og[$468ad51c3551a14d$var$pg++] = $468ad51c3551a14d$var$sg, $468ad51c3551a14d$var$og[$468ad51c3551a14d$var$pg++] = $468ad51c3551a14d$var$qg, $468ad51c3551a14d$var$rg = a.id, $468ad51c3551a14d$var$sg = a.overflow, $468ad51c3551a14d$var$qg = b);
    b = $468ad51c3551a14d$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $468ad51c3551a14d$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $468ad51c3551a14d$var$bh(a.return, b, c);
}
function $468ad51c3551a14d$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $468ad51c3551a14d$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $468ad51c3551a14d$var$Xi(a, b, d.children, c);
    d = $468ad51c3551a14d$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $468ad51c3551a14d$var$vj(a, c, b);
            else if (19 === a.tag) $468ad51c3551a14d$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $468ad51c3551a14d$var$G($468ad51c3551a14d$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $468ad51c3551a14d$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $468ad51c3551a14d$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $468ad51c3551a14d$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $468ad51c3551a14d$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $468ad51c3551a14d$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $468ad51c3551a14d$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $468ad51c3551a14d$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $468ad51c3551a14d$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($468ad51c3551a14d$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $468ad51c3551a14d$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $468ad51c3551a14d$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $468ad51c3551a14d$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $468ad51c3551a14d$var$kj(b);
            $468ad51c3551a14d$var$Ig();
            break;
        case 5:
            $468ad51c3551a14d$var$Ah(b);
            break;
        case 1:
            $468ad51c3551a14d$var$Zf(b.type) && $468ad51c3551a14d$var$cg(b);
            break;
        case 4:
            $468ad51c3551a14d$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $468ad51c3551a14d$var$G($468ad51c3551a14d$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $468ad51c3551a14d$var$G($468ad51c3551a14d$var$L, $468ad51c3551a14d$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $468ad51c3551a14d$var$oj(a, b, c);
                $468ad51c3551a14d$var$G($468ad51c3551a14d$var$L, $468ad51c3551a14d$var$L.current & 1);
                a = $468ad51c3551a14d$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $468ad51c3551a14d$var$G($468ad51c3551a14d$var$L, $468ad51c3551a14d$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $468ad51c3551a14d$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $468ad51c3551a14d$var$G($468ad51c3551a14d$var$L, $468ad51c3551a14d$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $468ad51c3551a14d$var$dj(a, b, c);
    }
    return $468ad51c3551a14d$var$Zi(a, b, c);
}
var $468ad51c3551a14d$var$zj, $468ad51c3551a14d$var$Aj, $468ad51c3551a14d$var$Bj, $468ad51c3551a14d$var$Cj;
$468ad51c3551a14d$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$468ad51c3551a14d$var$Aj = function() {};
$468ad51c3551a14d$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $468ad51c3551a14d$var$xh($468ad51c3551a14d$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $468ad51c3551a14d$var$Ya(a, e);
                d = $468ad51c3551a14d$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $468ad51c3551a14d$var$A({}, e, {
                    value: void 0
                });
                d = $468ad51c3551a14d$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $468ad51c3551a14d$var$gb(a, e);
                d = $468ad51c3551a14d$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $468ad51c3551a14d$var$Bf);
        }
        $468ad51c3551a14d$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($468ad51c3551a14d$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($468ad51c3551a14d$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $468ad51c3551a14d$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$468ad51c3551a14d$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $468ad51c3551a14d$var$Dj(a, b) {
    if (!$468ad51c3551a14d$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $468ad51c3551a14d$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $468ad51c3551a14d$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $468ad51c3551a14d$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $468ad51c3551a14d$var$S(b), null;
        case 1:
            return $468ad51c3551a14d$var$Zf(b.type) && $468ad51c3551a14d$var$$f(), $468ad51c3551a14d$var$S(b), null;
        case 3:
            d = b.stateNode;
            $468ad51c3551a14d$var$zh();
            $468ad51c3551a14d$var$E($468ad51c3551a14d$var$Wf);
            $468ad51c3551a14d$var$E($468ad51c3551a14d$var$H);
            $468ad51c3551a14d$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $468ad51c3551a14d$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $468ad51c3551a14d$var$zg && ($468ad51c3551a14d$var$Fj($468ad51c3551a14d$var$zg), $468ad51c3551a14d$var$zg = null));
            $468ad51c3551a14d$var$Aj(a, b);
            $468ad51c3551a14d$var$S(b);
            return null;
        case 5:
            $468ad51c3551a14d$var$Bh(b);
            var e = $468ad51c3551a14d$var$xh($468ad51c3551a14d$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $468ad51c3551a14d$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($468ad51c3551a14d$var$p(166));
                    $468ad51c3551a14d$var$S(b);
                    return null;
                }
                a = $468ad51c3551a14d$var$xh($468ad51c3551a14d$var$uh.current);
                if ($468ad51c3551a14d$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$468ad51c3551a14d$var$Of] = b;
                    d[$468ad51c3551a14d$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $468ad51c3551a14d$var$D("cancel", d);
                            $468ad51c3551a14d$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $468ad51c3551a14d$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $468ad51c3551a14d$var$lf.length; e++)$468ad51c3551a14d$var$D($468ad51c3551a14d$var$lf[e], d);
                            break;
                        case "source":
                            $468ad51c3551a14d$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $468ad51c3551a14d$var$D("error", d);
                            $468ad51c3551a14d$var$D("load", d);
                            break;
                        case "details":
                            $468ad51c3551a14d$var$D("toggle", d);
                            break;
                        case "input":
                            $468ad51c3551a14d$var$Za(d, f);
                            $468ad51c3551a14d$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $468ad51c3551a14d$var$D("invalid", d);
                            break;
                        case "textarea":
                            $468ad51c3551a14d$var$hb(d, f), $468ad51c3551a14d$var$D("invalid", d);
                    }
                    $468ad51c3551a14d$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $468ad51c3551a14d$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $468ad51c3551a14d$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $468ad51c3551a14d$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $468ad51c3551a14d$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $468ad51c3551a14d$var$Va(d);
                            $468ad51c3551a14d$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $468ad51c3551a14d$var$Va(d);
                            $468ad51c3551a14d$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $468ad51c3551a14d$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $468ad51c3551a14d$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$468ad51c3551a14d$var$Of] = b;
                    a[$468ad51c3551a14d$var$Pf] = d;
                    $468ad51c3551a14d$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $468ad51c3551a14d$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $468ad51c3551a14d$var$D("cancel", a);
                                $468ad51c3551a14d$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $468ad51c3551a14d$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $468ad51c3551a14d$var$lf.length; e++)$468ad51c3551a14d$var$D($468ad51c3551a14d$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $468ad51c3551a14d$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $468ad51c3551a14d$var$D("error", a);
                                $468ad51c3551a14d$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $468ad51c3551a14d$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $468ad51c3551a14d$var$Za(a, d);
                                e = $468ad51c3551a14d$var$Ya(a, d);
                                $468ad51c3551a14d$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $468ad51c3551a14d$var$A({}, d, {
                                    value: void 0
                                });
                                $468ad51c3551a14d$var$D("invalid", a);
                                break;
                            case "textarea":
                                $468ad51c3551a14d$var$hb(a, d);
                                e = $468ad51c3551a14d$var$gb(a, d);
                                $468ad51c3551a14d$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $468ad51c3551a14d$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $468ad51c3551a14d$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $468ad51c3551a14d$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $468ad51c3551a14d$var$ob(a, k) : "number" === typeof k && $468ad51c3551a14d$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($468ad51c3551a14d$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $468ad51c3551a14d$var$D("scroll", a) : null != k && $468ad51c3551a14d$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $468ad51c3551a14d$var$Va(a);
                                $468ad51c3551a14d$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $468ad51c3551a14d$var$Va(a);
                                $468ad51c3551a14d$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $468ad51c3551a14d$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $468ad51c3551a14d$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $468ad51c3551a14d$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $468ad51c3551a14d$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $468ad51c3551a14d$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $468ad51c3551a14d$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($468ad51c3551a14d$var$p(166));
                c = $468ad51c3551a14d$var$xh($468ad51c3551a14d$var$wh.current);
                $468ad51c3551a14d$var$xh($468ad51c3551a14d$var$uh.current);
                if ($468ad51c3551a14d$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$468ad51c3551a14d$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $468ad51c3551a14d$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $468ad51c3551a14d$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $468ad51c3551a14d$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$468ad51c3551a14d$var$Of] = b, b.stateNode = d;
            }
            $468ad51c3551a14d$var$S(b);
            return null;
        case 13:
            $468ad51c3551a14d$var$E($468ad51c3551a14d$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($468ad51c3551a14d$var$I && null !== $468ad51c3551a14d$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $468ad51c3551a14d$var$Hg(), $468ad51c3551a14d$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $468ad51c3551a14d$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($468ad51c3551a14d$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($468ad51c3551a14d$var$p(317));
                        f[$468ad51c3551a14d$var$Of] = b;
                    } else $468ad51c3551a14d$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $468ad51c3551a14d$var$S(b);
                    f = !1;
                } else null !== $468ad51c3551a14d$var$zg && ($468ad51c3551a14d$var$Fj($468ad51c3551a14d$var$zg), $468ad51c3551a14d$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($468ad51c3551a14d$var$L.current & 1) ? 0 === $468ad51c3551a14d$var$T && ($468ad51c3551a14d$var$T = 3) : $468ad51c3551a14d$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $468ad51c3551a14d$var$S(b);
            return null;
        case 4:
            return $468ad51c3551a14d$var$zh(), $468ad51c3551a14d$var$Aj(a, b), null === a && $468ad51c3551a14d$var$sf(b.stateNode.containerInfo), $468ad51c3551a14d$var$S(b), null;
        case 10:
            return $468ad51c3551a14d$var$ah(b.type._context), $468ad51c3551a14d$var$S(b), null;
        case 17:
            return $468ad51c3551a14d$var$Zf(b.type) && $468ad51c3551a14d$var$$f(), $468ad51c3551a14d$var$S(b), null;
        case 19:
            $468ad51c3551a14d$var$E($468ad51c3551a14d$var$L);
            f = b.memoizedState;
            if (null === f) return $468ad51c3551a14d$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $468ad51c3551a14d$var$Dj(f, !1);
                else {
                    if (0 !== $468ad51c3551a14d$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $468ad51c3551a14d$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $468ad51c3551a14d$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $468ad51c3551a14d$var$G($468ad51c3551a14d$var$L, $468ad51c3551a14d$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $468ad51c3551a14d$var$B() > $468ad51c3551a14d$var$Gj && (b.flags |= 128, d = !0, $468ad51c3551a14d$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $468ad51c3551a14d$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $468ad51c3551a14d$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$468ad51c3551a14d$var$I) return $468ad51c3551a14d$var$S(b), null;
                    } else 2 * $468ad51c3551a14d$var$B() - f.renderingStartTime > $468ad51c3551a14d$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $468ad51c3551a14d$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $468ad51c3551a14d$var$B(), b.sibling = null, c = $468ad51c3551a14d$var$L.current, $468ad51c3551a14d$var$G($468ad51c3551a14d$var$L, d ? c & 1 | 2 : c & 1), b;
            $468ad51c3551a14d$var$S(b);
            return null;
        case 22:
        case 23:
            return $468ad51c3551a14d$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($468ad51c3551a14d$var$fj & 1073741824) && ($468ad51c3551a14d$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $468ad51c3551a14d$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($468ad51c3551a14d$var$p(156, b.tag));
}
function $468ad51c3551a14d$var$Ij(a, b) {
    $468ad51c3551a14d$var$wg(b);
    switch(b.tag){
        case 1:
            return $468ad51c3551a14d$var$Zf(b.type) && $468ad51c3551a14d$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $468ad51c3551a14d$var$zh(), $468ad51c3551a14d$var$E($468ad51c3551a14d$var$Wf), $468ad51c3551a14d$var$E($468ad51c3551a14d$var$H), $468ad51c3551a14d$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $468ad51c3551a14d$var$Bh(b), null;
        case 13:
            $468ad51c3551a14d$var$E($468ad51c3551a14d$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($468ad51c3551a14d$var$p(340));
                $468ad51c3551a14d$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $468ad51c3551a14d$var$E($468ad51c3551a14d$var$L), null;
        case 4:
            return $468ad51c3551a14d$var$zh(), null;
        case 10:
            return $468ad51c3551a14d$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $468ad51c3551a14d$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $468ad51c3551a14d$var$Jj = !1, $468ad51c3551a14d$var$U = !1, $468ad51c3551a14d$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $468ad51c3551a14d$var$V = null;
function $468ad51c3551a14d$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $468ad51c3551a14d$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $468ad51c3551a14d$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $468ad51c3551a14d$var$W(a, b, d);
    }
}
var $468ad51c3551a14d$var$Nj = !1;
function $468ad51c3551a14d$var$Oj(a, b) {
    $468ad51c3551a14d$var$Cf = $468ad51c3551a14d$var$dd;
    a = $468ad51c3551a14d$var$Me();
    if ($468ad51c3551a14d$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $468ad51c3551a14d$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $468ad51c3551a14d$var$dd = !1;
    for($468ad51c3551a14d$var$V = b; null !== $468ad51c3551a14d$var$V;)if (b = $468ad51c3551a14d$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $468ad51c3551a14d$var$V = a;
    else for(; null !== $468ad51c3551a14d$var$V;){
        b = $468ad51c3551a14d$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $468ad51c3551a14d$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($468ad51c3551a14d$var$p(163));
            }
        } catch (F) {
            $468ad51c3551a14d$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $468ad51c3551a14d$var$V = a;
            break;
        }
        $468ad51c3551a14d$var$V = b.return;
    }
    n = $468ad51c3551a14d$var$Nj;
    $468ad51c3551a14d$var$Nj = !1;
    return n;
}
function $468ad51c3551a14d$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $468ad51c3551a14d$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $468ad51c3551a14d$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $468ad51c3551a14d$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $468ad51c3551a14d$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $468ad51c3551a14d$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$468ad51c3551a14d$var$Of], delete b[$468ad51c3551a14d$var$Pf], delete b[$468ad51c3551a14d$var$of], delete b[$468ad51c3551a14d$var$Qf], delete b[$468ad51c3551a14d$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $468ad51c3551a14d$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $468ad51c3551a14d$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $468ad51c3551a14d$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $468ad51c3551a14d$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $468ad51c3551a14d$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($468ad51c3551a14d$var$Vj(a, b, c), a = a.sibling; null !== a;)$468ad51c3551a14d$var$Vj(a, b, c), a = a.sibling;
}
function $468ad51c3551a14d$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($468ad51c3551a14d$var$Wj(a, b, c), a = a.sibling; null !== a;)$468ad51c3551a14d$var$Wj(a, b, c), a = a.sibling;
}
var $468ad51c3551a14d$var$X = null, $468ad51c3551a14d$var$Xj = !1;
function $468ad51c3551a14d$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$468ad51c3551a14d$var$Zj(a, b, c), c = c.sibling;
}
function $468ad51c3551a14d$var$Zj(a, b, c) {
    if ($468ad51c3551a14d$var$lc && "function" === typeof $468ad51c3551a14d$var$lc.onCommitFiberUnmount) try {
        $468ad51c3551a14d$var$lc.onCommitFiberUnmount($468ad51c3551a14d$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $468ad51c3551a14d$var$U || $468ad51c3551a14d$var$Lj(c, b);
        case 6:
            var d = $468ad51c3551a14d$var$X, e = $468ad51c3551a14d$var$Xj;
            $468ad51c3551a14d$var$X = null;
            $468ad51c3551a14d$var$Yj(a, b, c);
            $468ad51c3551a14d$var$X = d;
            $468ad51c3551a14d$var$Xj = e;
            null !== $468ad51c3551a14d$var$X && ($468ad51c3551a14d$var$Xj ? (a = $468ad51c3551a14d$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $468ad51c3551a14d$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $468ad51c3551a14d$var$X && ($468ad51c3551a14d$var$Xj ? (a = $468ad51c3551a14d$var$X, c = c.stateNode, 8 === a.nodeType ? $468ad51c3551a14d$var$Kf(a.parentNode, c) : 1 === a.nodeType && $468ad51c3551a14d$var$Kf(a, c), $468ad51c3551a14d$var$bd(a)) : $468ad51c3551a14d$var$Kf($468ad51c3551a14d$var$X, c.stateNode));
            break;
        case 4:
            d = $468ad51c3551a14d$var$X;
            e = $468ad51c3551a14d$var$Xj;
            $468ad51c3551a14d$var$X = c.stateNode.containerInfo;
            $468ad51c3551a14d$var$Xj = !0;
            $468ad51c3551a14d$var$Yj(a, b, c);
            $468ad51c3551a14d$var$X = d;
            $468ad51c3551a14d$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$468ad51c3551a14d$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $468ad51c3551a14d$var$Mj(c, b, g) : 0 !== (f & 4) && $468ad51c3551a14d$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $468ad51c3551a14d$var$Yj(a, b, c);
            break;
        case 1:
            if (!$468ad51c3551a14d$var$U && ($468ad51c3551a14d$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $468ad51c3551a14d$var$W(c, b, h);
            }
            $468ad51c3551a14d$var$Yj(a, b, c);
            break;
        case 21:
            $468ad51c3551a14d$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($468ad51c3551a14d$var$U = (d = $468ad51c3551a14d$var$U) || null !== c.memoizedState, $468ad51c3551a14d$var$Yj(a, b, c), $468ad51c3551a14d$var$U = d) : $468ad51c3551a14d$var$Yj(a, b, c);
            break;
        default:
            $468ad51c3551a14d$var$Yj(a, b, c);
    }
}
function $468ad51c3551a14d$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $468ad51c3551a14d$var$Kj);
        b.forEach(function(b) {
            var d = $468ad51c3551a14d$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $468ad51c3551a14d$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $468ad51c3551a14d$var$X = h.stateNode;
                        $468ad51c3551a14d$var$Xj = !1;
                        break a;
                    case 3:
                        $468ad51c3551a14d$var$X = h.stateNode.containerInfo;
                        $468ad51c3551a14d$var$Xj = !0;
                        break a;
                    case 4:
                        $468ad51c3551a14d$var$X = h.stateNode.containerInfo;
                        $468ad51c3551a14d$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $468ad51c3551a14d$var$X) throw Error($468ad51c3551a14d$var$p(160));
            $468ad51c3551a14d$var$Zj(f, g, e);
            $468ad51c3551a14d$var$X = null;
            $468ad51c3551a14d$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $468ad51c3551a14d$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$468ad51c3551a14d$var$dk(b, a), b = b.sibling;
}
function $468ad51c3551a14d$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $468ad51c3551a14d$var$ck(b, a);
            $468ad51c3551a14d$var$ek(a);
            if (d & 4) {
                try {
                    $468ad51c3551a14d$var$Pj(3, a, a.return), $468ad51c3551a14d$var$Qj(3, a);
                } catch (t) {
                    $468ad51c3551a14d$var$W(a, a.return, t);
                }
                try {
                    $468ad51c3551a14d$var$Pj(5, a, a.return);
                } catch (t) {
                    $468ad51c3551a14d$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $468ad51c3551a14d$var$ck(b, a);
            $468ad51c3551a14d$var$ek(a);
            d & 512 && null !== c && $468ad51c3551a14d$var$Lj(c, c.return);
            break;
        case 5:
            $468ad51c3551a14d$var$ck(b, a);
            $468ad51c3551a14d$var$ek(a);
            d & 512 && null !== c && $468ad51c3551a14d$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $468ad51c3551a14d$var$ob(e, "");
                } catch (t) {
                    $468ad51c3551a14d$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $468ad51c3551a14d$var$ab(e, f);
                    $468ad51c3551a14d$var$vb(h, g);
                    var l = $468ad51c3551a14d$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $468ad51c3551a14d$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $468ad51c3551a14d$var$nb(e, q) : "children" === m ? $468ad51c3551a14d$var$ob(e, q) : $468ad51c3551a14d$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $468ad51c3551a14d$var$bb(e, f);
                            break;
                        case "textarea":
                            $468ad51c3551a14d$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $468ad51c3551a14d$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $468ad51c3551a14d$var$fb(e, !!f.multiple, f.defaultValue, !0) : $468ad51c3551a14d$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$468ad51c3551a14d$var$Pf] = f;
                } catch (t) {
                    $468ad51c3551a14d$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $468ad51c3551a14d$var$ck(b, a);
            $468ad51c3551a14d$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($468ad51c3551a14d$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $468ad51c3551a14d$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $468ad51c3551a14d$var$ck(b, a);
            $468ad51c3551a14d$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $468ad51c3551a14d$var$bd(b.containerInfo);
            } catch (t) {
                $468ad51c3551a14d$var$W(a, a.return, t);
            }
            break;
        case 4:
            $468ad51c3551a14d$var$ck(b, a);
            $468ad51c3551a14d$var$ek(a);
            break;
        case 13:
            $468ad51c3551a14d$var$ck(b, a);
            $468ad51c3551a14d$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($468ad51c3551a14d$var$fk = $468ad51c3551a14d$var$B()));
            d & 4 && $468ad51c3551a14d$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($468ad51c3551a14d$var$U = (l = $468ad51c3551a14d$var$U) || m, $468ad51c3551a14d$var$ck(b, a), $468ad51c3551a14d$var$U = l) : $468ad51c3551a14d$var$ck(b, a);
            $468ad51c3551a14d$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($468ad51c3551a14d$var$V = a, m = a.child; null !== m;){
                    for(q = $468ad51c3551a14d$var$V = m; null !== $468ad51c3551a14d$var$V;){
                        r = $468ad51c3551a14d$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $468ad51c3551a14d$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $468ad51c3551a14d$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $468ad51c3551a14d$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $468ad51c3551a14d$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $468ad51c3551a14d$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $468ad51c3551a14d$var$V = y) : $468ad51c3551a14d$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $468ad51c3551a14d$var$rb("display", g));
                            } catch (t) {
                                $468ad51c3551a14d$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $468ad51c3551a14d$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $468ad51c3551a14d$var$ck(b, a);
            $468ad51c3551a14d$var$ek(a);
            d & 4 && $468ad51c3551a14d$var$ak(a);
            break;
        case 21:
            break;
        default:
            $468ad51c3551a14d$var$ck(b, a), $468ad51c3551a14d$var$ek(a);
    }
}
function $468ad51c3551a14d$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($468ad51c3551a14d$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($468ad51c3551a14d$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($468ad51c3551a14d$var$ob(e, ""), d.flags &= -33);
                    var f = $468ad51c3551a14d$var$Uj(a);
                    $468ad51c3551a14d$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $468ad51c3551a14d$var$Uj(a);
                    $468ad51c3551a14d$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($468ad51c3551a14d$var$p(161));
            }
        } catch (k) {
            $468ad51c3551a14d$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $468ad51c3551a14d$var$hk(a, b, c) {
    $468ad51c3551a14d$var$V = a;
    $468ad51c3551a14d$var$ik(a, b, c);
}
function $468ad51c3551a14d$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $468ad51c3551a14d$var$V;){
        var e = $468ad51c3551a14d$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $468ad51c3551a14d$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $468ad51c3551a14d$var$U;
                h = $468ad51c3551a14d$var$Jj;
                var l = $468ad51c3551a14d$var$U;
                $468ad51c3551a14d$var$Jj = g;
                if (($468ad51c3551a14d$var$U = k) && !l) for($468ad51c3551a14d$var$V = e; null !== $468ad51c3551a14d$var$V;)g = $468ad51c3551a14d$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $468ad51c3551a14d$var$jk(e) : null !== k ? (k.return = g, $468ad51c3551a14d$var$V = k) : $468ad51c3551a14d$var$jk(e);
                for(; null !== f;)$468ad51c3551a14d$var$V = f, $468ad51c3551a14d$var$ik(f, b, c), f = f.sibling;
                $468ad51c3551a14d$var$V = e;
                $468ad51c3551a14d$var$Jj = h;
                $468ad51c3551a14d$var$U = l;
            }
            $468ad51c3551a14d$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $468ad51c3551a14d$var$V = f) : $468ad51c3551a14d$var$kk(a, b, c);
    }
}
function $468ad51c3551a14d$var$kk(a) {
    for(; null !== $468ad51c3551a14d$var$V;){
        var b = $468ad51c3551a14d$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $468ad51c3551a14d$var$U || $468ad51c3551a14d$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$468ad51c3551a14d$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $468ad51c3551a14d$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $468ad51c3551a14d$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $468ad51c3551a14d$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $468ad51c3551a14d$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($468ad51c3551a14d$var$p(163));
                }
                $468ad51c3551a14d$var$U || b.flags & 512 && $468ad51c3551a14d$var$Rj(b);
            } catch (r) {
                $468ad51c3551a14d$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $468ad51c3551a14d$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $468ad51c3551a14d$var$V = c;
            break;
        }
        $468ad51c3551a14d$var$V = b.return;
    }
}
function $468ad51c3551a14d$var$gk(a) {
    for(; null !== $468ad51c3551a14d$var$V;){
        var b = $468ad51c3551a14d$var$V;
        if (b === a) {
            $468ad51c3551a14d$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $468ad51c3551a14d$var$V = c;
            break;
        }
        $468ad51c3551a14d$var$V = b.return;
    }
}
function $468ad51c3551a14d$var$jk(a) {
    for(; null !== $468ad51c3551a14d$var$V;){
        var b = $468ad51c3551a14d$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $468ad51c3551a14d$var$Qj(4, b);
                    } catch (k) {
                        $468ad51c3551a14d$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $468ad51c3551a14d$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $468ad51c3551a14d$var$Rj(b);
                    } catch (k) {
                        $468ad51c3551a14d$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $468ad51c3551a14d$var$Rj(b);
                    } catch (k) {
                        $468ad51c3551a14d$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $468ad51c3551a14d$var$W(b, b.return, k);
        }
        if (b === a) {
            $468ad51c3551a14d$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $468ad51c3551a14d$var$V = h;
            break;
        }
        $468ad51c3551a14d$var$V = b.return;
    }
}
var $468ad51c3551a14d$var$lk = Math.ceil, $468ad51c3551a14d$var$mk = $468ad51c3551a14d$var$ua.ReactCurrentDispatcher, $468ad51c3551a14d$var$nk = $468ad51c3551a14d$var$ua.ReactCurrentOwner, $468ad51c3551a14d$var$ok = $468ad51c3551a14d$var$ua.ReactCurrentBatchConfig, $468ad51c3551a14d$var$K = 0, $468ad51c3551a14d$var$Q = null, $468ad51c3551a14d$var$Y = null, $468ad51c3551a14d$var$Z = 0, $468ad51c3551a14d$var$fj = 0, $468ad51c3551a14d$var$ej = $468ad51c3551a14d$var$Uf(0), $468ad51c3551a14d$var$T = 0, $468ad51c3551a14d$var$pk = null, $468ad51c3551a14d$var$rh = 0, $468ad51c3551a14d$var$qk = 0, $468ad51c3551a14d$var$rk = 0, $468ad51c3551a14d$var$sk = null, $468ad51c3551a14d$var$tk = null, $468ad51c3551a14d$var$fk = 0, $468ad51c3551a14d$var$Gj = Infinity, $468ad51c3551a14d$var$uk = null, $468ad51c3551a14d$var$Oi = !1, $468ad51c3551a14d$var$Pi = null, $468ad51c3551a14d$var$Ri = null, $468ad51c3551a14d$var$vk = !1, $468ad51c3551a14d$var$wk = null, $468ad51c3551a14d$var$xk = 0, $468ad51c3551a14d$var$yk = 0, $468ad51c3551a14d$var$zk = null, $468ad51c3551a14d$var$Ak = -1, $468ad51c3551a14d$var$Bk = 0;
function $468ad51c3551a14d$var$R() {
    return 0 !== ($468ad51c3551a14d$var$K & 6) ? $468ad51c3551a14d$var$B() : -1 !== $468ad51c3551a14d$var$Ak ? $468ad51c3551a14d$var$Ak : $468ad51c3551a14d$var$Ak = $468ad51c3551a14d$var$B();
}
function $468ad51c3551a14d$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($468ad51c3551a14d$var$K & 2) && 0 !== $468ad51c3551a14d$var$Z) return $468ad51c3551a14d$var$Z & -$468ad51c3551a14d$var$Z;
    if (null !== $468ad51c3551a14d$var$Kg.transition) return 0 === $468ad51c3551a14d$var$Bk && ($468ad51c3551a14d$var$Bk = $468ad51c3551a14d$var$yc()), $468ad51c3551a14d$var$Bk;
    a = $468ad51c3551a14d$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $468ad51c3551a14d$var$jd(a.type);
    return a;
}
function $468ad51c3551a14d$var$gi(a, b, c, d) {
    if (50 < $468ad51c3551a14d$var$yk) throw $468ad51c3551a14d$var$yk = 0, $468ad51c3551a14d$var$zk = null, Error($468ad51c3551a14d$var$p(185));
    $468ad51c3551a14d$var$Ac(a, c, d);
    if (0 === ($468ad51c3551a14d$var$K & 2) || a !== $468ad51c3551a14d$var$Q) a === $468ad51c3551a14d$var$Q && (0 === ($468ad51c3551a14d$var$K & 2) && ($468ad51c3551a14d$var$qk |= c), 4 === $468ad51c3551a14d$var$T && $468ad51c3551a14d$var$Ck(a, $468ad51c3551a14d$var$Z)), $468ad51c3551a14d$var$Dk(a, d), 1 === c && 0 === $468ad51c3551a14d$var$K && 0 === (b.mode & 1) && ($468ad51c3551a14d$var$Gj = $468ad51c3551a14d$var$B() + 500, $468ad51c3551a14d$var$fg && $468ad51c3551a14d$var$jg());
}
function $468ad51c3551a14d$var$Dk(a, b) {
    var c = a.callbackNode;
    $468ad51c3551a14d$var$wc(a, b);
    var d = $468ad51c3551a14d$var$uc(a, a === $468ad51c3551a14d$var$Q ? $468ad51c3551a14d$var$Z : 0);
    if (0 === d) null !== c && $468ad51c3551a14d$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $468ad51c3551a14d$var$bc(c);
        if (1 === b) 0 === a.tag ? $468ad51c3551a14d$var$ig($468ad51c3551a14d$var$Ek.bind(null, a)) : $468ad51c3551a14d$var$hg($468ad51c3551a14d$var$Ek.bind(null, a)), $468ad51c3551a14d$var$Jf(function() {
            0 === ($468ad51c3551a14d$var$K & 6) && $468ad51c3551a14d$var$jg();
        }), c = null;
        else {
            switch($468ad51c3551a14d$var$Dc(d)){
                case 1:
                    c = $468ad51c3551a14d$var$fc;
                    break;
                case 4:
                    c = $468ad51c3551a14d$var$gc;
                    break;
                case 16:
                    c = $468ad51c3551a14d$var$hc;
                    break;
                case 536870912:
                    c = $468ad51c3551a14d$var$jc;
                    break;
                default:
                    c = $468ad51c3551a14d$var$hc;
            }
            c = $468ad51c3551a14d$var$Fk(c, $468ad51c3551a14d$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $468ad51c3551a14d$var$Gk(a, b) {
    $468ad51c3551a14d$var$Ak = -1;
    $468ad51c3551a14d$var$Bk = 0;
    if (0 !== ($468ad51c3551a14d$var$K & 6)) throw Error($468ad51c3551a14d$var$p(327));
    var c = a.callbackNode;
    if ($468ad51c3551a14d$var$Hk() && a.callbackNode !== c) return null;
    var d = $468ad51c3551a14d$var$uc(a, a === $468ad51c3551a14d$var$Q ? $468ad51c3551a14d$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $468ad51c3551a14d$var$Ik(a, d);
    else {
        b = d;
        var e = $468ad51c3551a14d$var$K;
        $468ad51c3551a14d$var$K |= 2;
        var f = $468ad51c3551a14d$var$Jk();
        if ($468ad51c3551a14d$var$Q !== a || $468ad51c3551a14d$var$Z !== b) $468ad51c3551a14d$var$uk = null, $468ad51c3551a14d$var$Gj = $468ad51c3551a14d$var$B() + 500, $468ad51c3551a14d$var$Kk(a, b);
        for(;;)try {
            $468ad51c3551a14d$var$Lk();
            break;
        } catch (h) {
            $468ad51c3551a14d$var$Mk(a, h);
        }
        $468ad51c3551a14d$var$$g();
        $468ad51c3551a14d$var$mk.current = f;
        $468ad51c3551a14d$var$K = e;
        null !== $468ad51c3551a14d$var$Y ? b = 0 : ($468ad51c3551a14d$var$Q = null, $468ad51c3551a14d$var$Z = 0, b = $468ad51c3551a14d$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $468ad51c3551a14d$var$xc(a), 0 !== e && (d = e, b = $468ad51c3551a14d$var$Nk(a, e)));
        if (1 === b) throw c = $468ad51c3551a14d$var$pk, $468ad51c3551a14d$var$Kk(a, 0), $468ad51c3551a14d$var$Ck(a, d), $468ad51c3551a14d$var$Dk(a, $468ad51c3551a14d$var$B()), c;
        if (6 === b) $468ad51c3551a14d$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$468ad51c3551a14d$var$Ok(e) && (b = $468ad51c3551a14d$var$Ik(a, d), 2 === b && (f = $468ad51c3551a14d$var$xc(a), 0 !== f && (d = f, b = $468ad51c3551a14d$var$Nk(a, f))), 1 === b)) throw c = $468ad51c3551a14d$var$pk, $468ad51c3551a14d$var$Kk(a, 0), $468ad51c3551a14d$var$Ck(a, d), $468ad51c3551a14d$var$Dk(a, $468ad51c3551a14d$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($468ad51c3551a14d$var$p(345));
                case 2:
                    $468ad51c3551a14d$var$Pk(a, $468ad51c3551a14d$var$tk, $468ad51c3551a14d$var$uk);
                    break;
                case 3:
                    $468ad51c3551a14d$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $468ad51c3551a14d$var$fk + 500 - $468ad51c3551a14d$var$B(), 10 < b)) {
                        if (0 !== $468ad51c3551a14d$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $468ad51c3551a14d$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $468ad51c3551a14d$var$Ff($468ad51c3551a14d$var$Pk.bind(null, a, $468ad51c3551a14d$var$tk, $468ad51c3551a14d$var$uk), b);
                        break;
                    }
                    $468ad51c3551a14d$var$Pk(a, $468ad51c3551a14d$var$tk, $468ad51c3551a14d$var$uk);
                    break;
                case 4:
                    $468ad51c3551a14d$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $468ad51c3551a14d$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $468ad51c3551a14d$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $468ad51c3551a14d$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $468ad51c3551a14d$var$Ff($468ad51c3551a14d$var$Pk.bind(null, a, $468ad51c3551a14d$var$tk, $468ad51c3551a14d$var$uk), d);
                        break;
                    }
                    $468ad51c3551a14d$var$Pk(a, $468ad51c3551a14d$var$tk, $468ad51c3551a14d$var$uk);
                    break;
                case 5:
                    $468ad51c3551a14d$var$Pk(a, $468ad51c3551a14d$var$tk, $468ad51c3551a14d$var$uk);
                    break;
                default:
                    throw Error($468ad51c3551a14d$var$p(329));
            }
        }
    }
    $468ad51c3551a14d$var$Dk(a, $468ad51c3551a14d$var$B());
    return a.callbackNode === c ? $468ad51c3551a14d$var$Gk.bind(null, a) : null;
}
function $468ad51c3551a14d$var$Nk(a, b) {
    var c = $468ad51c3551a14d$var$sk;
    a.current.memoizedState.isDehydrated && ($468ad51c3551a14d$var$Kk(a, b).flags |= 256);
    a = $468ad51c3551a14d$var$Ik(a, b);
    2 !== a && (b = $468ad51c3551a14d$var$tk, $468ad51c3551a14d$var$tk = c, null !== b && $468ad51c3551a14d$var$Fj(b));
    return a;
}
function $468ad51c3551a14d$var$Fj(a) {
    null === $468ad51c3551a14d$var$tk ? $468ad51c3551a14d$var$tk = a : $468ad51c3551a14d$var$tk.push.apply($468ad51c3551a14d$var$tk, a);
}
function $468ad51c3551a14d$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$468ad51c3551a14d$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $468ad51c3551a14d$var$Ck(a, b) {
    b &= ~$468ad51c3551a14d$var$rk;
    b &= ~$468ad51c3551a14d$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $468ad51c3551a14d$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $468ad51c3551a14d$var$Ek(a) {
    if (0 !== ($468ad51c3551a14d$var$K & 6)) throw Error($468ad51c3551a14d$var$p(327));
    $468ad51c3551a14d$var$Hk();
    var b = $468ad51c3551a14d$var$uc(a, 0);
    if (0 === (b & 1)) return $468ad51c3551a14d$var$Dk(a, $468ad51c3551a14d$var$B()), null;
    var c = $468ad51c3551a14d$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $468ad51c3551a14d$var$xc(a);
        0 !== d && (b = d, c = $468ad51c3551a14d$var$Nk(a, d));
    }
    if (1 === c) throw c = $468ad51c3551a14d$var$pk, $468ad51c3551a14d$var$Kk(a, 0), $468ad51c3551a14d$var$Ck(a, b), $468ad51c3551a14d$var$Dk(a, $468ad51c3551a14d$var$B()), c;
    if (6 === c) throw Error($468ad51c3551a14d$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $468ad51c3551a14d$var$Pk(a, $468ad51c3551a14d$var$tk, $468ad51c3551a14d$var$uk);
    $468ad51c3551a14d$var$Dk(a, $468ad51c3551a14d$var$B());
    return null;
}
function $468ad51c3551a14d$var$Qk(a, b) {
    var c = $468ad51c3551a14d$var$K;
    $468ad51c3551a14d$var$K |= 1;
    try {
        return a(b);
    } finally{
        $468ad51c3551a14d$var$K = c, 0 === $468ad51c3551a14d$var$K && ($468ad51c3551a14d$var$Gj = $468ad51c3551a14d$var$B() + 500, $468ad51c3551a14d$var$fg && $468ad51c3551a14d$var$jg());
    }
}
function $468ad51c3551a14d$var$Rk(a) {
    null !== $468ad51c3551a14d$var$wk && 0 === $468ad51c3551a14d$var$wk.tag && 0 === ($468ad51c3551a14d$var$K & 6) && $468ad51c3551a14d$var$Hk();
    var b = $468ad51c3551a14d$var$K;
    $468ad51c3551a14d$var$K |= 1;
    var c = $468ad51c3551a14d$var$ok.transition, d = $468ad51c3551a14d$var$C;
    try {
        if ($468ad51c3551a14d$var$ok.transition = null, $468ad51c3551a14d$var$C = 1, a) return a();
    } finally{
        $468ad51c3551a14d$var$C = d, $468ad51c3551a14d$var$ok.transition = c, $468ad51c3551a14d$var$K = b, 0 === ($468ad51c3551a14d$var$K & 6) && $468ad51c3551a14d$var$jg();
    }
}
function $468ad51c3551a14d$var$Hj() {
    $468ad51c3551a14d$var$fj = $468ad51c3551a14d$var$ej.current;
    $468ad51c3551a14d$var$E($468ad51c3551a14d$var$ej);
}
function $468ad51c3551a14d$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $468ad51c3551a14d$var$Gf(c));
    if (null !== $468ad51c3551a14d$var$Y) for(c = $468ad51c3551a14d$var$Y.return; null !== c;){
        var d = c;
        $468ad51c3551a14d$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $468ad51c3551a14d$var$$f();
                break;
            case 3:
                $468ad51c3551a14d$var$zh();
                $468ad51c3551a14d$var$E($468ad51c3551a14d$var$Wf);
                $468ad51c3551a14d$var$E($468ad51c3551a14d$var$H);
                $468ad51c3551a14d$var$Eh();
                break;
            case 5:
                $468ad51c3551a14d$var$Bh(d);
                break;
            case 4:
                $468ad51c3551a14d$var$zh();
                break;
            case 13:
                $468ad51c3551a14d$var$E($468ad51c3551a14d$var$L);
                break;
            case 19:
                $468ad51c3551a14d$var$E($468ad51c3551a14d$var$L);
                break;
            case 10:
                $468ad51c3551a14d$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $468ad51c3551a14d$var$Hj();
        }
        c = c.return;
    }
    $468ad51c3551a14d$var$Q = a;
    $468ad51c3551a14d$var$Y = a = $468ad51c3551a14d$var$Pg(a.current, null);
    $468ad51c3551a14d$var$Z = $468ad51c3551a14d$var$fj = b;
    $468ad51c3551a14d$var$T = 0;
    $468ad51c3551a14d$var$pk = null;
    $468ad51c3551a14d$var$rk = $468ad51c3551a14d$var$qk = $468ad51c3551a14d$var$rh = 0;
    $468ad51c3551a14d$var$tk = $468ad51c3551a14d$var$sk = null;
    if (null !== $468ad51c3551a14d$var$fh) {
        for(b = 0; b < $468ad51c3551a14d$var$fh.length; b++)if (c = $468ad51c3551a14d$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $468ad51c3551a14d$var$fh = null;
    }
    return a;
}
function $468ad51c3551a14d$var$Mk(a, b) {
    do {
        var c = $468ad51c3551a14d$var$Y;
        try {
            $468ad51c3551a14d$var$$g();
            $468ad51c3551a14d$var$Fh.current = $468ad51c3551a14d$var$Rh;
            if ($468ad51c3551a14d$var$Ih) {
                for(var d = $468ad51c3551a14d$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $468ad51c3551a14d$var$Ih = !1;
            }
            $468ad51c3551a14d$var$Hh = 0;
            $468ad51c3551a14d$var$O = $468ad51c3551a14d$var$N = $468ad51c3551a14d$var$M = null;
            $468ad51c3551a14d$var$Jh = !1;
            $468ad51c3551a14d$var$Kh = 0;
            $468ad51c3551a14d$var$nk.current = null;
            if (null === c || null === c.return) {
                $468ad51c3551a14d$var$T = 1;
                $468ad51c3551a14d$var$pk = b;
                $468ad51c3551a14d$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $468ad51c3551a14d$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $468ad51c3551a14d$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $468ad51c3551a14d$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $468ad51c3551a14d$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $468ad51c3551a14d$var$Si(f, l, b);
                            $468ad51c3551a14d$var$tj();
                            break a;
                        }
                        k = Error($468ad51c3551a14d$var$p(426));
                    }
                } else if ($468ad51c3551a14d$var$I && h.mode & 1) {
                    var J = $468ad51c3551a14d$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $468ad51c3551a14d$var$Vi(J, g, h, f, b);
                        $468ad51c3551a14d$var$Jg($468ad51c3551a14d$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $468ad51c3551a14d$var$Ji(k, h);
                4 !== $468ad51c3551a14d$var$T && ($468ad51c3551a14d$var$T = 2);
                null === $468ad51c3551a14d$var$sk ? $468ad51c3551a14d$var$sk = [
                    f
                ] : $468ad51c3551a14d$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $468ad51c3551a14d$var$Ni(f, k, b);
                            $468ad51c3551a14d$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $468ad51c3551a14d$var$Ri || !$468ad51c3551a14d$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $468ad51c3551a14d$var$Qi(f, h, b);
                                $468ad51c3551a14d$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $468ad51c3551a14d$var$Sk(c);
        } catch (na) {
            b = na;
            $468ad51c3551a14d$var$Y === c && null !== c && ($468ad51c3551a14d$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $468ad51c3551a14d$var$Jk() {
    var a = $468ad51c3551a14d$var$mk.current;
    $468ad51c3551a14d$var$mk.current = $468ad51c3551a14d$var$Rh;
    return null === a ? $468ad51c3551a14d$var$Rh : a;
}
function $468ad51c3551a14d$var$tj() {
    if (0 === $468ad51c3551a14d$var$T || 3 === $468ad51c3551a14d$var$T || 2 === $468ad51c3551a14d$var$T) $468ad51c3551a14d$var$T = 4;
    null === $468ad51c3551a14d$var$Q || 0 === ($468ad51c3551a14d$var$rh & 268435455) && 0 === ($468ad51c3551a14d$var$qk & 268435455) || $468ad51c3551a14d$var$Ck($468ad51c3551a14d$var$Q, $468ad51c3551a14d$var$Z);
}
function $468ad51c3551a14d$var$Ik(a, b) {
    var c = $468ad51c3551a14d$var$K;
    $468ad51c3551a14d$var$K |= 2;
    var d = $468ad51c3551a14d$var$Jk();
    if ($468ad51c3551a14d$var$Q !== a || $468ad51c3551a14d$var$Z !== b) $468ad51c3551a14d$var$uk = null, $468ad51c3551a14d$var$Kk(a, b);
    for(;;)try {
        $468ad51c3551a14d$var$Tk();
        break;
    } catch (e) {
        $468ad51c3551a14d$var$Mk(a, e);
    }
    $468ad51c3551a14d$var$$g();
    $468ad51c3551a14d$var$K = c;
    $468ad51c3551a14d$var$mk.current = d;
    if (null !== $468ad51c3551a14d$var$Y) throw Error($468ad51c3551a14d$var$p(261));
    $468ad51c3551a14d$var$Q = null;
    $468ad51c3551a14d$var$Z = 0;
    return $468ad51c3551a14d$var$T;
}
function $468ad51c3551a14d$var$Tk() {
    for(; null !== $468ad51c3551a14d$var$Y;)$468ad51c3551a14d$var$Uk($468ad51c3551a14d$var$Y);
}
function $468ad51c3551a14d$var$Lk() {
    for(; null !== $468ad51c3551a14d$var$Y && !$468ad51c3551a14d$var$cc();)$468ad51c3551a14d$var$Uk($468ad51c3551a14d$var$Y);
}
function $468ad51c3551a14d$var$Uk(a) {
    var b = $468ad51c3551a14d$var$Vk(a.alternate, a, $468ad51c3551a14d$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $468ad51c3551a14d$var$Sk(a) : $468ad51c3551a14d$var$Y = b;
    $468ad51c3551a14d$var$nk.current = null;
}
function $468ad51c3551a14d$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $468ad51c3551a14d$var$Ej(c, b, $468ad51c3551a14d$var$fj), null !== c) {
                $468ad51c3551a14d$var$Y = c;
                return;
            }
        } else {
            c = $468ad51c3551a14d$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $468ad51c3551a14d$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $468ad51c3551a14d$var$T = 6;
                $468ad51c3551a14d$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $468ad51c3551a14d$var$Y = b;
            return;
        }
        $468ad51c3551a14d$var$Y = b = a;
    }while (null !== b);
    0 === $468ad51c3551a14d$var$T && ($468ad51c3551a14d$var$T = 5);
}
function $468ad51c3551a14d$var$Pk(a, b, c) {
    var d = $468ad51c3551a14d$var$C, e = $468ad51c3551a14d$var$ok.transition;
    try {
        $468ad51c3551a14d$var$ok.transition = null, $468ad51c3551a14d$var$C = 1, $468ad51c3551a14d$var$Wk(a, b, c, d);
    } finally{
        $468ad51c3551a14d$var$ok.transition = e, $468ad51c3551a14d$var$C = d;
    }
    return null;
}
function $468ad51c3551a14d$var$Wk(a, b, c, d) {
    do $468ad51c3551a14d$var$Hk();
    while (null !== $468ad51c3551a14d$var$wk);
    if (0 !== ($468ad51c3551a14d$var$K & 6)) throw Error($468ad51c3551a14d$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($468ad51c3551a14d$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $468ad51c3551a14d$var$Bc(a, f);
    a === $468ad51c3551a14d$var$Q && ($468ad51c3551a14d$var$Y = $468ad51c3551a14d$var$Q = null, $468ad51c3551a14d$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $468ad51c3551a14d$var$vk || ($468ad51c3551a14d$var$vk = !0, $468ad51c3551a14d$var$Fk($468ad51c3551a14d$var$hc, function() {
        $468ad51c3551a14d$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $468ad51c3551a14d$var$ok.transition;
        $468ad51c3551a14d$var$ok.transition = null;
        var g = $468ad51c3551a14d$var$C;
        $468ad51c3551a14d$var$C = 1;
        var h = $468ad51c3551a14d$var$K;
        $468ad51c3551a14d$var$K |= 4;
        $468ad51c3551a14d$var$nk.current = null;
        $468ad51c3551a14d$var$Oj(a, c);
        $468ad51c3551a14d$var$dk(c, a);
        $468ad51c3551a14d$var$Oe($468ad51c3551a14d$var$Df);
        $468ad51c3551a14d$var$dd = !!$468ad51c3551a14d$var$Cf;
        $468ad51c3551a14d$var$Df = $468ad51c3551a14d$var$Cf = null;
        a.current = c;
        $468ad51c3551a14d$var$hk(c, a, e);
        $468ad51c3551a14d$var$dc();
        $468ad51c3551a14d$var$K = h;
        $468ad51c3551a14d$var$C = g;
        $468ad51c3551a14d$var$ok.transition = f;
    } else a.current = c;
    $468ad51c3551a14d$var$vk && ($468ad51c3551a14d$var$vk = !1, $468ad51c3551a14d$var$wk = a, $468ad51c3551a14d$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($468ad51c3551a14d$var$Ri = null);
    $468ad51c3551a14d$var$mc(c.stateNode, d);
    $468ad51c3551a14d$var$Dk(a, $468ad51c3551a14d$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($468ad51c3551a14d$var$Oi) throw $468ad51c3551a14d$var$Oi = !1, a = $468ad51c3551a14d$var$Pi, $468ad51c3551a14d$var$Pi = null, a;
    0 !== ($468ad51c3551a14d$var$xk & 1) && 0 !== a.tag && $468ad51c3551a14d$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $468ad51c3551a14d$var$zk ? $468ad51c3551a14d$var$yk++ : ($468ad51c3551a14d$var$yk = 0, $468ad51c3551a14d$var$zk = a) : $468ad51c3551a14d$var$yk = 0;
    $468ad51c3551a14d$var$jg();
    return null;
}
function $468ad51c3551a14d$var$Hk() {
    if (null !== $468ad51c3551a14d$var$wk) {
        var a = $468ad51c3551a14d$var$Dc($468ad51c3551a14d$var$xk), b = $468ad51c3551a14d$var$ok.transition, c = $468ad51c3551a14d$var$C;
        try {
            $468ad51c3551a14d$var$ok.transition = null;
            $468ad51c3551a14d$var$C = 16 > a ? 16 : a;
            if (null === $468ad51c3551a14d$var$wk) var d = !1;
            else {
                a = $468ad51c3551a14d$var$wk;
                $468ad51c3551a14d$var$wk = null;
                $468ad51c3551a14d$var$xk = 0;
                if (0 !== ($468ad51c3551a14d$var$K & 6)) throw Error($468ad51c3551a14d$var$p(331));
                var e = $468ad51c3551a14d$var$K;
                $468ad51c3551a14d$var$K |= 4;
                for($468ad51c3551a14d$var$V = a.current; null !== $468ad51c3551a14d$var$V;){
                    var f = $468ad51c3551a14d$var$V, g = f.child;
                    if (0 !== ($468ad51c3551a14d$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($468ad51c3551a14d$var$V = l; null !== $468ad51c3551a14d$var$V;){
                                    var m = $468ad51c3551a14d$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $468ad51c3551a14d$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $468ad51c3551a14d$var$V = q;
                                    else for(; null !== $468ad51c3551a14d$var$V;){
                                        m = $468ad51c3551a14d$var$V;
                                        var r = m.sibling, y = m.return;
                                        $468ad51c3551a14d$var$Sj(m);
                                        if (m === l) {
                                            $468ad51c3551a14d$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $468ad51c3551a14d$var$V = r;
                                            break;
                                        }
                                        $468ad51c3551a14d$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $468ad51c3551a14d$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $468ad51c3551a14d$var$V = g;
                    else b: for(; null !== $468ad51c3551a14d$var$V;){
                        f = $468ad51c3551a14d$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $468ad51c3551a14d$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $468ad51c3551a14d$var$V = x;
                            break b;
                        }
                        $468ad51c3551a14d$var$V = f.return;
                    }
                }
                var w = a.current;
                for($468ad51c3551a14d$var$V = w; null !== $468ad51c3551a14d$var$V;){
                    g = $468ad51c3551a14d$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $468ad51c3551a14d$var$V = u;
                    else b: for(g = w; null !== $468ad51c3551a14d$var$V;){
                        h = $468ad51c3551a14d$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $468ad51c3551a14d$var$Qj(9, h);
                            }
                        } catch (na) {
                            $468ad51c3551a14d$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $468ad51c3551a14d$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $468ad51c3551a14d$var$V = F;
                            break b;
                        }
                        $468ad51c3551a14d$var$V = h.return;
                    }
                }
                $468ad51c3551a14d$var$K = e;
                $468ad51c3551a14d$var$jg();
                if ($468ad51c3551a14d$var$lc && "function" === typeof $468ad51c3551a14d$var$lc.onPostCommitFiberRoot) try {
                    $468ad51c3551a14d$var$lc.onPostCommitFiberRoot($468ad51c3551a14d$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $468ad51c3551a14d$var$C = c, $468ad51c3551a14d$var$ok.transition = b;
        }
    }
    return !1;
}
function $468ad51c3551a14d$var$Xk(a, b, c) {
    b = $468ad51c3551a14d$var$Ji(c, b);
    b = $468ad51c3551a14d$var$Ni(a, b, 1);
    a = $468ad51c3551a14d$var$nh(a, b, 1);
    b = $468ad51c3551a14d$var$R();
    null !== a && ($468ad51c3551a14d$var$Ac(a, 1, b), $468ad51c3551a14d$var$Dk(a, b));
}
function $468ad51c3551a14d$var$W(a, b, c) {
    if (3 === a.tag) $468ad51c3551a14d$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $468ad51c3551a14d$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $468ad51c3551a14d$var$Ri || !$468ad51c3551a14d$var$Ri.has(d))) {
                a = $468ad51c3551a14d$var$Ji(c, a);
                a = $468ad51c3551a14d$var$Qi(b, a, 1);
                b = $468ad51c3551a14d$var$nh(b, a, 1);
                a = $468ad51c3551a14d$var$R();
                null !== b && ($468ad51c3551a14d$var$Ac(b, 1, a), $468ad51c3551a14d$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $468ad51c3551a14d$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $468ad51c3551a14d$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $468ad51c3551a14d$var$Q === a && ($468ad51c3551a14d$var$Z & c) === c && (4 === $468ad51c3551a14d$var$T || 3 === $468ad51c3551a14d$var$T && ($468ad51c3551a14d$var$Z & 130023424) === $468ad51c3551a14d$var$Z && 500 > $468ad51c3551a14d$var$B() - $468ad51c3551a14d$var$fk ? $468ad51c3551a14d$var$Kk(a, 0) : $468ad51c3551a14d$var$rk |= c);
    $468ad51c3551a14d$var$Dk(a, b);
}
function $468ad51c3551a14d$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $468ad51c3551a14d$var$sc, $468ad51c3551a14d$var$sc <<= 1, 0 === ($468ad51c3551a14d$var$sc & 130023424) && ($468ad51c3551a14d$var$sc = 4194304)));
    var c = $468ad51c3551a14d$var$R();
    a = $468ad51c3551a14d$var$ih(a, b);
    null !== a && ($468ad51c3551a14d$var$Ac(a, b, c), $468ad51c3551a14d$var$Dk(a, c));
}
function $468ad51c3551a14d$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $468ad51c3551a14d$var$Yk(a, c);
}
function $468ad51c3551a14d$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($468ad51c3551a14d$var$p(314));
    }
    null !== d && d.delete(b);
    $468ad51c3551a14d$var$Yk(a, c);
}
var $468ad51c3551a14d$var$Vk;
$468ad51c3551a14d$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $468ad51c3551a14d$var$Wf.current) $468ad51c3551a14d$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $468ad51c3551a14d$var$dh = !1, $468ad51c3551a14d$var$yj(a, b, c);
            $468ad51c3551a14d$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $468ad51c3551a14d$var$dh = !1, $468ad51c3551a14d$var$I && 0 !== (b.flags & 1048576) && $468ad51c3551a14d$var$ug(b, $468ad51c3551a14d$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $468ad51c3551a14d$var$ij(a, b);
            a = b.pendingProps;
            var e = $468ad51c3551a14d$var$Yf(b, $468ad51c3551a14d$var$H.current);
            $468ad51c3551a14d$var$ch(b, c);
            e = $468ad51c3551a14d$var$Nh(null, b, d, a, e, c);
            var f = $468ad51c3551a14d$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $468ad51c3551a14d$var$Zf(d) ? (f = !0, $468ad51c3551a14d$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $468ad51c3551a14d$var$kh(b), e.updater = $468ad51c3551a14d$var$Ei, b.stateNode = e, e._reactInternals = b, $468ad51c3551a14d$var$Ii(b, d, a, c), b = $468ad51c3551a14d$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $468ad51c3551a14d$var$I && f && $468ad51c3551a14d$var$vg(b), $468ad51c3551a14d$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $468ad51c3551a14d$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $468ad51c3551a14d$var$Zk(d);
                a = $468ad51c3551a14d$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $468ad51c3551a14d$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $468ad51c3551a14d$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $468ad51c3551a14d$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $468ad51c3551a14d$var$$i(null, b, d, $468ad51c3551a14d$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($468ad51c3551a14d$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $468ad51c3551a14d$var$Ci(d, e), $468ad51c3551a14d$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $468ad51c3551a14d$var$Ci(d, e), $468ad51c3551a14d$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $468ad51c3551a14d$var$kj(b);
                if (null === a) throw Error($468ad51c3551a14d$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $468ad51c3551a14d$var$lh(a, b);
                $468ad51c3551a14d$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $468ad51c3551a14d$var$Ji(Error($468ad51c3551a14d$var$p(423)), b);
                        b = $468ad51c3551a14d$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $468ad51c3551a14d$var$Ji(Error($468ad51c3551a14d$var$p(424)), b);
                        b = $468ad51c3551a14d$var$lj(a, b, d, c, e);
                        break a;
                    } else for($468ad51c3551a14d$var$yg = $468ad51c3551a14d$var$Lf(b.stateNode.containerInfo.firstChild), $468ad51c3551a14d$var$xg = b, $468ad51c3551a14d$var$I = !0, $468ad51c3551a14d$var$zg = null, c = $468ad51c3551a14d$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $468ad51c3551a14d$var$Ig();
                    if (d === e) {
                        b = $468ad51c3551a14d$var$Zi(a, b, c);
                        break a;
                    }
                    $468ad51c3551a14d$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $468ad51c3551a14d$var$Ah(b), null === a && $468ad51c3551a14d$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $468ad51c3551a14d$var$Ef(d, e) ? g = null : null !== f && $468ad51c3551a14d$var$Ef(d, f) && (b.flags |= 32), $468ad51c3551a14d$var$gj(a, b), $468ad51c3551a14d$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $468ad51c3551a14d$var$Eg(b), null;
        case 13:
            return $468ad51c3551a14d$var$oj(a, b, c);
        case 4:
            return $468ad51c3551a14d$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $468ad51c3551a14d$var$Ug(b, null, d, c) : $468ad51c3551a14d$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $468ad51c3551a14d$var$Ci(d, e), $468ad51c3551a14d$var$Yi(a, b, d, e, c);
        case 7:
            return $468ad51c3551a14d$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $468ad51c3551a14d$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $468ad51c3551a14d$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $468ad51c3551a14d$var$G($468ad51c3551a14d$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($468ad51c3551a14d$var$He(f.value, g)) {
                        if (f.children === e.children && !$468ad51c3551a14d$var$Wf.current) {
                            b = $468ad51c3551a14d$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $468ad51c3551a14d$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $468ad51c3551a14d$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($468ad51c3551a14d$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $468ad51c3551a14d$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $468ad51c3551a14d$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $468ad51c3551a14d$var$ch(b, c), e = $468ad51c3551a14d$var$eh(e), d = d(e), b.flags |= 1, $468ad51c3551a14d$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $468ad51c3551a14d$var$Ci(d, b.pendingProps), e = $468ad51c3551a14d$var$Ci(d.type, e), $468ad51c3551a14d$var$$i(a, b, d, e, c);
        case 15:
            return $468ad51c3551a14d$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $468ad51c3551a14d$var$Ci(d, e), $468ad51c3551a14d$var$ij(a, b), b.tag = 1, $468ad51c3551a14d$var$Zf(d) ? (a = !0, $468ad51c3551a14d$var$cg(b)) : a = !1, $468ad51c3551a14d$var$ch(b, c), $468ad51c3551a14d$var$Gi(b, d, e), $468ad51c3551a14d$var$Ii(b, d, e, c), $468ad51c3551a14d$var$jj(null, b, d, !0, a, c);
        case 19:
            return $468ad51c3551a14d$var$xj(a, b, c);
        case 22:
            return $468ad51c3551a14d$var$dj(a, b, c);
    }
    throw Error($468ad51c3551a14d$var$p(156, b.tag));
};
function $468ad51c3551a14d$var$Fk(a, b) {
    return $468ad51c3551a14d$var$ac(a, b);
}
function $468ad51c3551a14d$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $468ad51c3551a14d$var$Bg(a, b, c, d) {
    return new $468ad51c3551a14d$var$$k(a, b, c, d);
}
function $468ad51c3551a14d$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $468ad51c3551a14d$var$Zk(a) {
    if ("function" === typeof a) return $468ad51c3551a14d$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $468ad51c3551a14d$var$Da) return 11;
        if (a === $468ad51c3551a14d$var$Ga) return 14;
    }
    return 2;
}
function $468ad51c3551a14d$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $468ad51c3551a14d$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $468ad51c3551a14d$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $468ad51c3551a14d$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $468ad51c3551a14d$var$ya:
            return $468ad51c3551a14d$var$Tg(c.children, e, f, b);
        case $468ad51c3551a14d$var$za:
            g = 8;
            e |= 8;
            break;
        case $468ad51c3551a14d$var$Aa:
            return a = $468ad51c3551a14d$var$Bg(12, c, b, e | 2), a.elementType = $468ad51c3551a14d$var$Aa, a.lanes = f, a;
        case $468ad51c3551a14d$var$Ea:
            return a = $468ad51c3551a14d$var$Bg(13, c, b, e), a.elementType = $468ad51c3551a14d$var$Ea, a.lanes = f, a;
        case $468ad51c3551a14d$var$Fa:
            return a = $468ad51c3551a14d$var$Bg(19, c, b, e), a.elementType = $468ad51c3551a14d$var$Fa, a.lanes = f, a;
        case $468ad51c3551a14d$var$Ia:
            return $468ad51c3551a14d$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $468ad51c3551a14d$var$Ba:
                    g = 10;
                    break a;
                case $468ad51c3551a14d$var$Ca:
                    g = 9;
                    break a;
                case $468ad51c3551a14d$var$Da:
                    g = 11;
                    break a;
                case $468ad51c3551a14d$var$Ga:
                    g = 14;
                    break a;
                case $468ad51c3551a14d$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($468ad51c3551a14d$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $468ad51c3551a14d$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $468ad51c3551a14d$var$Tg(a, b, c, d) {
    a = $468ad51c3551a14d$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $468ad51c3551a14d$var$pj(a, b, c, d) {
    a = $468ad51c3551a14d$var$Bg(22, a, d, b);
    a.elementType = $468ad51c3551a14d$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $468ad51c3551a14d$var$Qg(a, b, c) {
    a = $468ad51c3551a14d$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $468ad51c3551a14d$var$Sg(a, b, c) {
    b = $468ad51c3551a14d$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $468ad51c3551a14d$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $468ad51c3551a14d$var$zc(0);
    this.expirationTimes = $468ad51c3551a14d$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $468ad51c3551a14d$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $468ad51c3551a14d$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $468ad51c3551a14d$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $468ad51c3551a14d$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $468ad51c3551a14d$var$kh(f);
    return a;
}
function $468ad51c3551a14d$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $468ad51c3551a14d$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $468ad51c3551a14d$var$dl(a) {
    if (!a) return $468ad51c3551a14d$var$Vf;
    a = a._reactInternals;
    a: {
        if ($468ad51c3551a14d$var$Vb(a) !== a || 1 !== a.tag) throw Error($468ad51c3551a14d$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($468ad51c3551a14d$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($468ad51c3551a14d$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($468ad51c3551a14d$var$Zf(c)) return $468ad51c3551a14d$var$bg(a, c, b);
    }
    return b;
}
function $468ad51c3551a14d$var$el(a, b, c, d, e, f, g, h, k) {
    a = $468ad51c3551a14d$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $468ad51c3551a14d$var$dl(null);
    c = a.current;
    d = $468ad51c3551a14d$var$R();
    e = $468ad51c3551a14d$var$yi(c);
    f = $468ad51c3551a14d$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $468ad51c3551a14d$var$nh(c, f, e);
    a.current.lanes = e;
    $468ad51c3551a14d$var$Ac(a, e, d);
    $468ad51c3551a14d$var$Dk(a, d);
    return a;
}
function $468ad51c3551a14d$var$fl(a, b, c, d) {
    var e = b.current, f = $468ad51c3551a14d$var$R(), g = $468ad51c3551a14d$var$yi(e);
    c = $468ad51c3551a14d$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $468ad51c3551a14d$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $468ad51c3551a14d$var$nh(e, b, g);
    null !== a && ($468ad51c3551a14d$var$gi(a, e, g, f), $468ad51c3551a14d$var$oh(a, e, g));
    return g;
}
function $468ad51c3551a14d$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $468ad51c3551a14d$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $468ad51c3551a14d$var$il(a, b) {
    $468ad51c3551a14d$var$hl(a, b);
    (a = a.alternate) && $468ad51c3551a14d$var$hl(a, b);
}
function $468ad51c3551a14d$var$jl() {
    return null;
}
var $468ad51c3551a14d$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $468ad51c3551a14d$var$ll(a) {
    this._internalRoot = a;
}
$468ad51c3551a14d$var$ml.prototype.render = $468ad51c3551a14d$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($468ad51c3551a14d$var$p(409));
    $468ad51c3551a14d$var$fl(a, b, null, null);
};
$468ad51c3551a14d$var$ml.prototype.unmount = $468ad51c3551a14d$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $468ad51c3551a14d$var$Rk(function() {
            $468ad51c3551a14d$var$fl(null, a, null, null);
        });
        b[$468ad51c3551a14d$var$uf] = null;
    }
};
function $468ad51c3551a14d$var$ml(a) {
    this._internalRoot = a;
}
$468ad51c3551a14d$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $468ad51c3551a14d$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $468ad51c3551a14d$var$Qc.length && 0 !== b && b < $468ad51c3551a14d$var$Qc[c].priority; c++);
        $468ad51c3551a14d$var$Qc.splice(c, 0, a);
        0 === c && $468ad51c3551a14d$var$Vc(a);
    }
};
function $468ad51c3551a14d$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $468ad51c3551a14d$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $468ad51c3551a14d$var$pl() {}
function $468ad51c3551a14d$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $468ad51c3551a14d$var$gl(g);
                f.call(a);
            };
        }
        var g = $468ad51c3551a14d$var$el(b, d, a, 0, null, !1, !1, "", $468ad51c3551a14d$var$pl);
        a._reactRootContainer = g;
        a[$468ad51c3551a14d$var$uf] = g.current;
        $468ad51c3551a14d$var$sf(8 === a.nodeType ? a.parentNode : a);
        $468ad51c3551a14d$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $468ad51c3551a14d$var$gl(k);
            h.call(a);
        };
    }
    var k = $468ad51c3551a14d$var$bl(a, 0, !1, null, null, !1, !1, "", $468ad51c3551a14d$var$pl);
    a._reactRootContainer = k;
    a[$468ad51c3551a14d$var$uf] = k.current;
    $468ad51c3551a14d$var$sf(8 === a.nodeType ? a.parentNode : a);
    $468ad51c3551a14d$var$Rk(function() {
        $468ad51c3551a14d$var$fl(b, k, c, d);
    });
    return k;
}
function $468ad51c3551a14d$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $468ad51c3551a14d$var$gl(g);
                h.call(a);
            };
        }
        $468ad51c3551a14d$var$fl(b, g, a, e);
    } else g = $468ad51c3551a14d$var$ql(c, b, a, e, d);
    return $468ad51c3551a14d$var$gl(g);
}
$468ad51c3551a14d$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $468ad51c3551a14d$var$tc(b.pendingLanes);
                0 !== c && ($468ad51c3551a14d$var$Cc(b, c | 1), $468ad51c3551a14d$var$Dk(b, $468ad51c3551a14d$var$B()), 0 === ($468ad51c3551a14d$var$K & 6) && ($468ad51c3551a14d$var$Gj = $468ad51c3551a14d$var$B() + 500, $468ad51c3551a14d$var$jg()));
            }
            break;
        case 13:
            $468ad51c3551a14d$var$Rk(function() {
                var b = $468ad51c3551a14d$var$ih(a, 1);
                if (null !== b) {
                    var c = $468ad51c3551a14d$var$R();
                    $468ad51c3551a14d$var$gi(b, a, 1, c);
                }
            }), $468ad51c3551a14d$var$il(a, 1);
    }
};
$468ad51c3551a14d$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $468ad51c3551a14d$var$ih(a, 134217728);
        if (null !== b) {
            var c = $468ad51c3551a14d$var$R();
            $468ad51c3551a14d$var$gi(b, a, 134217728, c);
        }
        $468ad51c3551a14d$var$il(a, 134217728);
    }
};
$468ad51c3551a14d$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $468ad51c3551a14d$var$yi(a), c = $468ad51c3551a14d$var$ih(a, b);
        if (null !== c) {
            var d = $468ad51c3551a14d$var$R();
            $468ad51c3551a14d$var$gi(c, a, b, d);
        }
        $468ad51c3551a14d$var$il(a, b);
    }
};
$468ad51c3551a14d$var$Hc = function() {
    return $468ad51c3551a14d$var$C;
};
$468ad51c3551a14d$var$Ic = function(a, b) {
    var c = $468ad51c3551a14d$var$C;
    try {
        return $468ad51c3551a14d$var$C = a, b();
    } finally{
        $468ad51c3551a14d$var$C = c;
    }
};
$468ad51c3551a14d$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $468ad51c3551a14d$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $468ad51c3551a14d$var$Db(d);
                        if (!e) throw Error($468ad51c3551a14d$var$p(90));
                        $468ad51c3551a14d$var$Wa(d);
                        $468ad51c3551a14d$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $468ad51c3551a14d$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $468ad51c3551a14d$var$fb(a, !!c.multiple, b, !1);
    }
};
$468ad51c3551a14d$var$Gb = $468ad51c3551a14d$var$Qk;
$468ad51c3551a14d$var$Hb = $468ad51c3551a14d$var$Rk;
var $468ad51c3551a14d$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $468ad51c3551a14d$var$Cb,
        $468ad51c3551a14d$var$ue,
        $468ad51c3551a14d$var$Db,
        $468ad51c3551a14d$var$Eb,
        $468ad51c3551a14d$var$Fb,
        $468ad51c3551a14d$var$Qk
    ]
}, $468ad51c3551a14d$var$tl = {
    findFiberByHostInstance: $468ad51c3551a14d$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $468ad51c3551a14d$var$ul = {
    bundleType: $468ad51c3551a14d$var$tl.bundleType,
    version: $468ad51c3551a14d$var$tl.version,
    rendererPackageName: $468ad51c3551a14d$var$tl.rendererPackageName,
    rendererConfig: $468ad51c3551a14d$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $468ad51c3551a14d$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $468ad51c3551a14d$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $468ad51c3551a14d$var$tl.findFiberByHostInstance || $468ad51c3551a14d$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $468ad51c3551a14d$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$468ad51c3551a14d$var$vl.isDisabled && $468ad51c3551a14d$var$vl.supportsFiber) try {
        $468ad51c3551a14d$var$kc = $468ad51c3551a14d$var$vl.inject($468ad51c3551a14d$var$ul), $468ad51c3551a14d$var$lc = $468ad51c3551a14d$var$vl;
    } catch (a) {}
}
$468ad51c3551a14d$export$ae55be85d98224ed = $468ad51c3551a14d$var$sl;
$468ad51c3551a14d$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$468ad51c3551a14d$var$nl(b)) throw Error($468ad51c3551a14d$var$p(200));
    return $468ad51c3551a14d$var$cl(a, b, null, c);
};
$468ad51c3551a14d$export$882461b6382ed46c = function(a, b) {
    if (!$468ad51c3551a14d$var$nl(a)) throw Error($468ad51c3551a14d$var$p(299));
    var c = !1, d = "", e = $468ad51c3551a14d$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $468ad51c3551a14d$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$468ad51c3551a14d$var$uf] = b.current;
    $468ad51c3551a14d$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $468ad51c3551a14d$var$ll(b);
};
$468ad51c3551a14d$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($468ad51c3551a14d$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($468ad51c3551a14d$var$p(268, a));
    }
    a = $468ad51c3551a14d$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$468ad51c3551a14d$export$cd75ccfd720a3cd4 = function(a) {
    return $468ad51c3551a14d$var$Rk(a);
};
$468ad51c3551a14d$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$468ad51c3551a14d$var$ol(b)) throw Error($468ad51c3551a14d$var$p(200));
    return $468ad51c3551a14d$var$rl(null, a, b, !0, c);
};
$468ad51c3551a14d$export$757ceba2d55c277e = function(a, b, c) {
    if (!$468ad51c3551a14d$var$nl(a)) throw Error($468ad51c3551a14d$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $468ad51c3551a14d$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $468ad51c3551a14d$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$468ad51c3551a14d$var$uf] = b.current;
    $468ad51c3551a14d$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $468ad51c3551a14d$var$ml(b);
};
$468ad51c3551a14d$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$468ad51c3551a14d$var$ol(b)) throw Error($468ad51c3551a14d$var$p(200));
    return $468ad51c3551a14d$var$rl(null, a, b, !1, c);
};
$468ad51c3551a14d$export$502457920280e6be = function(a) {
    if (!$468ad51c3551a14d$var$ol(a)) throw Error($468ad51c3551a14d$var$p(40));
    return a._reactRootContainer ? ($468ad51c3551a14d$var$Rk(function() {
        $468ad51c3551a14d$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$468ad51c3551a14d$var$uf] = null;
        });
    }), !0) : !1;
};
$468ad51c3551a14d$export$c78a37762a8d58e1 = $468ad51c3551a14d$var$Qk;
$468ad51c3551a14d$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$468ad51c3551a14d$var$ol(c)) throw Error($468ad51c3551a14d$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($468ad51c3551a14d$var$p(38));
    return $468ad51c3551a14d$var$rl(a, b, c, !1, d);
};
$468ad51c3551a14d$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("cV2f0", function(module, exports) {
"use strict";

module.exports = (parcelRequire("jalrZ"));

});
parcelRegister("jalrZ", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $df3f9720d29043ca$export$c4744153514ff05d, (v) => $df3f9720d29043ca$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $df3f9720d29043ca$export$3e506c1ccc9cc1a7, (v) => $df3f9720d29043ca$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $df3f9720d29043ca$export$e26fe2ed2fa76875, (v) => $df3f9720d29043ca$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $df3f9720d29043ca$export$502329bbf4b505b1, (v) => $df3f9720d29043ca$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $df3f9720d29043ca$export$6e3807111c4874c4, (v) => $df3f9720d29043ca$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $df3f9720d29043ca$export$c27134553091fb3a, (v) => $df3f9720d29043ca$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $df3f9720d29043ca$export$33ee1acdc04fd2a2, (v) => $df3f9720d29043ca$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $df3f9720d29043ca$export$b00a404bbd5edef2, (v) => $df3f9720d29043ca$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $df3f9720d29043ca$export$8352ce38b91d0c62, (v) => $df3f9720d29043ca$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $df3f9720d29043ca$export$d66a1c1c77bd778b, (v) => $df3f9720d29043ca$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $df3f9720d29043ca$export$d3dfb8e4810cb555, (v) => $df3f9720d29043ca$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $df3f9720d29043ca$export$839f9183b0465a69, (v) => $df3f9720d29043ca$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $df3f9720d29043ca$export$72fdf0e06517287b, (v) => $df3f9720d29043ca$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $df3f9720d29043ca$export$4b844e58a3e414b4, (v) => $df3f9720d29043ca$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $df3f9720d29043ca$export$816d2913ae6b83b1, (v) => $df3f9720d29043ca$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $df3f9720d29043ca$export$61bcfe829111a1d0, (v) => $df3f9720d29043ca$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $df3f9720d29043ca$export$7ee8c9beb337bc3f, (v) => $df3f9720d29043ca$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $df3f9720d29043ca$export$b5836b71941fa3ed, (v) => $df3f9720d29043ca$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $df3f9720d29043ca$export$cf845f2c119da08a, (v) => $df3f9720d29043ca$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $df3f9720d29043ca$export$c4744153514ff05d;
var $df3f9720d29043ca$export$3e506c1ccc9cc1a7;
var $df3f9720d29043ca$export$e26fe2ed2fa76875;
var $df3f9720d29043ca$export$502329bbf4b505b1;
var $df3f9720d29043ca$export$6e3807111c4874c4;
var $df3f9720d29043ca$export$c27134553091fb3a;
var $df3f9720d29043ca$export$33ee1acdc04fd2a2;
var $df3f9720d29043ca$export$b00a404bbd5edef2;
var $df3f9720d29043ca$export$8352ce38b91d0c62;
var $df3f9720d29043ca$export$d66a1c1c77bd778b;
var $df3f9720d29043ca$export$d3dfb8e4810cb555;
var $df3f9720d29043ca$export$839f9183b0465a69;
var $df3f9720d29043ca$export$72fdf0e06517287b;
var $df3f9720d29043ca$export$4b844e58a3e414b4;
var $df3f9720d29043ca$export$816d2913ae6b83b1;
var $df3f9720d29043ca$export$61bcfe829111a1d0;
var $df3f9720d29043ca$export$7ee8c9beb337bc3f;
var $df3f9720d29043ca$export$b5836b71941fa3ed;
var $df3f9720d29043ca$export$cf845f2c119da08a;
"use strict";
function $df3f9720d29043ca$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $df3f9720d29043ca$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $df3f9720d29043ca$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $df3f9720d29043ca$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $df3f9720d29043ca$var$g(C, c)) n < e && 0 > $df3f9720d29043ca$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $df3f9720d29043ca$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $df3f9720d29043ca$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $df3f9720d29043ca$var$l = performance;
    $df3f9720d29043ca$export$c4744153514ff05d = function() {
        return $df3f9720d29043ca$var$l.now();
    };
} else {
    var $df3f9720d29043ca$var$p = Date, $df3f9720d29043ca$var$q = $df3f9720d29043ca$var$p.now();
    $df3f9720d29043ca$export$c4744153514ff05d = function() {
        return $df3f9720d29043ca$var$p.now() - $df3f9720d29043ca$var$q;
    };
}
var $df3f9720d29043ca$var$r = [], $df3f9720d29043ca$var$t = [], $df3f9720d29043ca$var$u = 1, $df3f9720d29043ca$var$v = null, $df3f9720d29043ca$var$y = 3, $df3f9720d29043ca$var$z = !1, $df3f9720d29043ca$var$A = !1, $df3f9720d29043ca$var$B = !1, $df3f9720d29043ca$var$D = "function" === typeof setTimeout ? setTimeout : null, $df3f9720d29043ca$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $df3f9720d29043ca$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $df3f9720d29043ca$var$G(a) {
    for(var b = $df3f9720d29043ca$var$h($df3f9720d29043ca$var$t); null !== b;){
        if (null === b.callback) $df3f9720d29043ca$var$k($df3f9720d29043ca$var$t);
        else if (b.startTime <= a) $df3f9720d29043ca$var$k($df3f9720d29043ca$var$t), b.sortIndex = b.expirationTime, $df3f9720d29043ca$var$f($df3f9720d29043ca$var$r, b);
        else break;
        b = $df3f9720d29043ca$var$h($df3f9720d29043ca$var$t);
    }
}
function $df3f9720d29043ca$var$H(a) {
    $df3f9720d29043ca$var$B = !1;
    $df3f9720d29043ca$var$G(a);
    if (!$df3f9720d29043ca$var$A) {
        if (null !== $df3f9720d29043ca$var$h($df3f9720d29043ca$var$r)) $df3f9720d29043ca$var$A = !0, $df3f9720d29043ca$var$I($df3f9720d29043ca$var$J);
        else {
            var b = $df3f9720d29043ca$var$h($df3f9720d29043ca$var$t);
            null !== b && $df3f9720d29043ca$var$K($df3f9720d29043ca$var$H, b.startTime - a);
        }
    }
}
function $df3f9720d29043ca$var$J(a, b) {
    $df3f9720d29043ca$var$A = !1;
    $df3f9720d29043ca$var$B && ($df3f9720d29043ca$var$B = !1, $df3f9720d29043ca$var$E($df3f9720d29043ca$var$L), $df3f9720d29043ca$var$L = -1);
    $df3f9720d29043ca$var$z = !0;
    var c = $df3f9720d29043ca$var$y;
    try {
        $df3f9720d29043ca$var$G(b);
        for($df3f9720d29043ca$var$v = $df3f9720d29043ca$var$h($df3f9720d29043ca$var$r); null !== $df3f9720d29043ca$var$v && (!($df3f9720d29043ca$var$v.expirationTime > b) || a && !$df3f9720d29043ca$var$M());){
            var d = $df3f9720d29043ca$var$v.callback;
            if ("function" === typeof d) {
                $df3f9720d29043ca$var$v.callback = null;
                $df3f9720d29043ca$var$y = $df3f9720d29043ca$var$v.priorityLevel;
                var e = d($df3f9720d29043ca$var$v.expirationTime <= b);
                b = $df3f9720d29043ca$export$c4744153514ff05d();
                "function" === typeof e ? $df3f9720d29043ca$var$v.callback = e : $df3f9720d29043ca$var$v === $df3f9720d29043ca$var$h($df3f9720d29043ca$var$r) && $df3f9720d29043ca$var$k($df3f9720d29043ca$var$r);
                $df3f9720d29043ca$var$G(b);
            } else $df3f9720d29043ca$var$k($df3f9720d29043ca$var$r);
            $df3f9720d29043ca$var$v = $df3f9720d29043ca$var$h($df3f9720d29043ca$var$r);
        }
        if (null !== $df3f9720d29043ca$var$v) var w = !0;
        else {
            var m = $df3f9720d29043ca$var$h($df3f9720d29043ca$var$t);
            null !== m && $df3f9720d29043ca$var$K($df3f9720d29043ca$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $df3f9720d29043ca$var$v = null, $df3f9720d29043ca$var$y = c, $df3f9720d29043ca$var$z = !1;
    }
}
var $df3f9720d29043ca$var$N = !1, $df3f9720d29043ca$var$O = null, $df3f9720d29043ca$var$L = -1, $df3f9720d29043ca$var$P = 5, $df3f9720d29043ca$var$Q = -1;
function $df3f9720d29043ca$var$M() {
    return $df3f9720d29043ca$export$c4744153514ff05d() - $df3f9720d29043ca$var$Q < $df3f9720d29043ca$var$P ? !1 : !0;
}
function $df3f9720d29043ca$var$R() {
    if (null !== $df3f9720d29043ca$var$O) {
        var a = $df3f9720d29043ca$export$c4744153514ff05d();
        $df3f9720d29043ca$var$Q = a;
        var b = !0;
        try {
            b = $df3f9720d29043ca$var$O(!0, a);
        } finally{
            b ? $df3f9720d29043ca$var$S() : ($df3f9720d29043ca$var$N = !1, $df3f9720d29043ca$var$O = null);
        }
    } else $df3f9720d29043ca$var$N = !1;
}
var $df3f9720d29043ca$var$S;
if ("function" === typeof $df3f9720d29043ca$var$F) $df3f9720d29043ca$var$S = function() {
    $df3f9720d29043ca$var$F($df3f9720d29043ca$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $df3f9720d29043ca$var$T = new MessageChannel, $df3f9720d29043ca$var$U = $df3f9720d29043ca$var$T.port2;
    $df3f9720d29043ca$var$T.port1.onmessage = $df3f9720d29043ca$var$R;
    $df3f9720d29043ca$var$S = function() {
        $df3f9720d29043ca$var$U.postMessage(null);
    };
} else $df3f9720d29043ca$var$S = function() {
    $df3f9720d29043ca$var$D($df3f9720d29043ca$var$R, 0);
};
function $df3f9720d29043ca$var$I(a) {
    $df3f9720d29043ca$var$O = a;
    $df3f9720d29043ca$var$N || ($df3f9720d29043ca$var$N = !0, $df3f9720d29043ca$var$S());
}
function $df3f9720d29043ca$var$K(a, b) {
    $df3f9720d29043ca$var$L = $df3f9720d29043ca$var$D(function() {
        a($df3f9720d29043ca$export$c4744153514ff05d());
    }, b);
}
$df3f9720d29043ca$export$3e506c1ccc9cc1a7 = 5;
$df3f9720d29043ca$export$e26fe2ed2fa76875 = 1;
$df3f9720d29043ca$export$502329bbf4b505b1 = 4;
$df3f9720d29043ca$export$6e3807111c4874c4 = 3;
$df3f9720d29043ca$export$c27134553091fb3a = null;
$df3f9720d29043ca$export$33ee1acdc04fd2a2 = 2;
$df3f9720d29043ca$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$df3f9720d29043ca$export$8352ce38b91d0c62 = function() {
    $df3f9720d29043ca$var$A || $df3f9720d29043ca$var$z || ($df3f9720d29043ca$var$A = !0, $df3f9720d29043ca$var$I($df3f9720d29043ca$var$J));
};
$df3f9720d29043ca$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $df3f9720d29043ca$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$df3f9720d29043ca$export$d3dfb8e4810cb555 = function() {
    return $df3f9720d29043ca$var$y;
};
$df3f9720d29043ca$export$839f9183b0465a69 = function() {
    return $df3f9720d29043ca$var$h($df3f9720d29043ca$var$r);
};
$df3f9720d29043ca$export$72fdf0e06517287b = function(a) {
    switch($df3f9720d29043ca$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $df3f9720d29043ca$var$y;
    }
    var c = $df3f9720d29043ca$var$y;
    $df3f9720d29043ca$var$y = b;
    try {
        return a();
    } finally{
        $df3f9720d29043ca$var$y = c;
    }
};
$df3f9720d29043ca$export$4b844e58a3e414b4 = function() {};
$df3f9720d29043ca$export$816d2913ae6b83b1 = function() {};
$df3f9720d29043ca$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $df3f9720d29043ca$var$y;
    $df3f9720d29043ca$var$y = a;
    try {
        return b();
    } finally{
        $df3f9720d29043ca$var$y = c;
    }
};
$df3f9720d29043ca$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $df3f9720d29043ca$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $df3f9720d29043ca$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $df3f9720d29043ca$var$f($df3f9720d29043ca$var$t, a), null === $df3f9720d29043ca$var$h($df3f9720d29043ca$var$r) && a === $df3f9720d29043ca$var$h($df3f9720d29043ca$var$t) && ($df3f9720d29043ca$var$B ? ($df3f9720d29043ca$var$E($df3f9720d29043ca$var$L), $df3f9720d29043ca$var$L = -1) : $df3f9720d29043ca$var$B = !0, $df3f9720d29043ca$var$K($df3f9720d29043ca$var$H, c - d))) : (a.sortIndex = e, $df3f9720d29043ca$var$f($df3f9720d29043ca$var$r, a), $df3f9720d29043ca$var$A || $df3f9720d29043ca$var$z || ($df3f9720d29043ca$var$A = !0, $df3f9720d29043ca$var$I($df3f9720d29043ca$var$J)));
    return a;
};
$df3f9720d29043ca$export$b5836b71941fa3ed = $df3f9720d29043ca$var$M;
$df3f9720d29043ca$export$cf845f2c119da08a = function(a) {
    var b = $df3f9720d29043ca$var$y;
    return function() {
        var c = $df3f9720d29043ca$var$y;
        $df3f9720d29043ca$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $df3f9720d29043ca$var$y = c;
        }
    };
};

});





parcelRegister("w7gBZ", function(module, exports) {

$parcel$export(module.exports, "BrowserRouter", () => $0608a055a17e1a05$export$9ba4e89fdfa1fc54);
$parcel$export(module.exports, "NavLink", () => $0608a055a17e1a05$export$b0d92dbee9b5b60d);
$parcel$export(module.exports, "useLocation", () => (parcelRequire("aw9wE")).useLocation);
$parcel$export(module.exports, "useNavigate", () => (parcelRequire("aw9wE")).useNavigate);
/**
 * React Router DOM v6.27.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $kc00y = parcelRequire("kc00y");

var $cn1Kz = parcelRequire("cn1Kz");

var $8K3mn = parcelRequire("8K3mn");
var $aw9wE = parcelRequire("aw9wE");

var $8K3mn = parcelRequire("8K3mn");
function $0608a055a17e1a05$var$_extends() {
    $0608a055a17e1a05$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0608a055a17e1a05$var$_extends.apply(this, arguments);
}
function $0608a055a17e1a05$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $0608a055a17e1a05$var$defaultMethod = "get";
const $0608a055a17e1a05$var$defaultEncType = "application/x-www-form-urlencoded";
function $0608a055a17e1a05$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $0608a055a17e1a05$var$isButtonElement(object) {
    return $0608a055a17e1a05$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $0608a055a17e1a05$var$isFormElement(object) {
    return $0608a055a17e1a05$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $0608a055a17e1a05$var$isInputElement(object) {
    return $0608a055a17e1a05$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $0608a055a17e1a05$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $0608a055a17e1a05$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$0608a055a17e1a05$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $0608a055a17e1a05$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $0608a055a17e1a05$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $0608a055a17e1a05$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $0608a055a17e1a05$var$_formDataSupportsSubmitter = null;
function $0608a055a17e1a05$var$isFormDataSubmitterSupported() {
    if ($0608a055a17e1a05$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $0608a055a17e1a05$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $0608a055a17e1a05$var$_formDataSupportsSubmitter = true;
    }
    return $0608a055a17e1a05$var$_formDataSupportsSubmitter;
}
const $0608a055a17e1a05$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $0608a055a17e1a05$var$getFormEncType(encType) {
    if (encType != null && !$0608a055a17e1a05$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $0608a055a17e1a05$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($0608a055a17e1a05$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $8K3mn.stripBasename)(attr, basename) : null;
        method = target.getAttribute("method") || $0608a055a17e1a05$var$defaultMethod;
        encType = $0608a055a17e1a05$var$getFormEncType(target.getAttribute("enctype")) || $0608a055a17e1a05$var$defaultEncType;
        formData = new FormData(target);
    } else if ($0608a055a17e1a05$var$isButtonElement(target) || $0608a055a17e1a05$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $8K3mn.stripBasename)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $0608a055a17e1a05$var$defaultMethod;
        encType = $0608a055a17e1a05$var$getFormEncType(target.getAttribute("formenctype")) || $0608a055a17e1a05$var$getFormEncType(form.getAttribute("enctype")) || $0608a055a17e1a05$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$0608a055a17e1a05$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($0608a055a17e1a05$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $0608a055a17e1a05$var$defaultMethod;
        action = null;
        encType = $0608a055a17e1a05$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $0608a055a17e1a05$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], $0608a055a17e1a05$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], $0608a055a17e1a05$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $0608a055a17e1a05$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $0608a055a17e1a05$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $0608a055a17e1a05$export$1f3f55432a00e06d(routes, opts) {
    return (0, $8K3mn.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $0608a055a17e1a05$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $8K3mn.createBrowserHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $0608a055a17e1a05$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $aw9wE.UNSAFE_mapRouteProperties),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $0608a055a17e1a05$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $8K3mn.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $0608a055a17e1a05$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $8K3mn.createHashHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $0608a055a17e1a05$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $aw9wE.UNSAFE_mapRouteProperties),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $0608a055a17e1a05$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $0608a055a17e1a05$var$_extends({}, state, {
        errors: $0608a055a17e1a05$var$deserializeErrors(state.errors)
    });
    return state;
}
function $0608a055a17e1a05$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $8K3mn.UNSAFE_ErrorResponseImpl)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $0608a055a17e1a05$export$7ad602f0e94e62d1 = /*#__PURE__*/ $kc00y.createContext({
    isTransitioning: false
});
const $0608a055a17e1a05$export$148fd98d095596d4 = /*#__PURE__*/ $kc00y.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $0608a055a17e1a05$var$START_TRANSITION = "startTransition";
const $0608a055a17e1a05$var$startTransitionImpl = $kc00y[$0608a055a17e1a05$var$START_TRANSITION];
const $0608a055a17e1a05$var$FLUSH_SYNC = "flushSync";
const $0608a055a17e1a05$var$flushSyncImpl = $cn1Kz[$0608a055a17e1a05$var$FLUSH_SYNC];
const $0608a055a17e1a05$var$USE_ID = "useId";
const $0608a055a17e1a05$var$useIdImpl = $kc00y[$0608a055a17e1a05$var$USE_ID];
function $0608a055a17e1a05$var$startTransitionSafe(cb) {
    if ($0608a055a17e1a05$var$startTransitionImpl) $0608a055a17e1a05$var$startTransitionImpl(cb);
    else cb();
}
function $0608a055a17e1a05$var$flushSyncSafe(cb) {
    if ($0608a055a17e1a05$var$flushSyncImpl) $0608a055a17e1a05$var$flushSyncImpl(cb);
    else cb();
}
class $0608a055a17e1a05$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $0608a055a17e1a05$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $kc00y.useState(router.state);
    let [pendingState, setPendingState] = $kc00y.useState();
    let [vtContext, setVtContext] = $kc00y.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $kc00y.useState();
    let [transition, setTransition] = $kc00y.useState();
    let [interruption, setInterruption] = $kc00y.useState();
    let fetcherData = $kc00y.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $kc00y.useCallback((cb)=>{
        if (v7_startTransition) $0608a055a17e1a05$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $kc00y.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts } = _ref2;
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $0608a055a17e1a05$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $0608a055a17e1a05$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $0608a055a17e1a05$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $0608a055a17e1a05$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $0608a055a17e1a05$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $kc00y.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $kc00y.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $0608a055a17e1a05$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $kc00y.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $kc00y.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $kc00y.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $kc00y.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $kc00y.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $kc00y.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $kc00y.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $kc00y.createElement($kc00y.Fragment, null, /*#__PURE__*/ $kc00y.createElement((0, $aw9wE.UNSAFE_DataRouterContext).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $kc00y.createElement((0, $aw9wE.UNSAFE_DataRouterStateContext).Provider, {
        value: state
    }, /*#__PURE__*/ $kc00y.createElement($0608a055a17e1a05$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $kc00y.createElement($0608a055a17e1a05$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $kc00y.createElement((0, $aw9wE.Router), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $kc00y.createElement($0608a055a17e1a05$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $0608a055a17e1a05$var$MemoizedDataRoutes = /*#__PURE__*/ $kc00y.memo($0608a055a17e1a05$var$DataRoutes);
function $0608a055a17e1a05$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $aw9wE.UNSAFE_useRoutesImpl)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $0608a055a17e1a05$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $kc00y.useRef();
    if (historyRef.current == null) historyRef.current = (0, $8K3mn.createBrowserHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $kc00y.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $kc00y.useCallback((newState)=>{
        v7_startTransition && $0608a055a17e1a05$var$startTransitionImpl ? $0608a055a17e1a05$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $kc00y.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $kc00y.createElement((0, $aw9wE.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $0608a055a17e1a05$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $kc00y.useRef();
    if (historyRef.current == null) historyRef.current = (0, $8K3mn.createHashHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $kc00y.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $kc00y.useCallback((newState)=>{
        v7_startTransition && $0608a055a17e1a05$var$startTransitionImpl ? $0608a055a17e1a05$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $kc00y.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $kc00y.createElement((0, $aw9wE.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $0608a055a17e1a05$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $kc00y.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $kc00y.useCallback((newState)=>{
        v7_startTransition && $0608a055a17e1a05$var$startTransitionImpl ? $0608a055a17e1a05$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $kc00y.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $kc00y.createElement((0, $aw9wE.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $0608a055a17e1a05$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $0608a055a17e1a05$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $0608a055a17e1a05$export$a6c7ac8248d6e38a = /*#__PURE__*/ $kc00y.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref7, rest = $0608a055a17e1a05$var$_objectWithoutPropertiesLoose(_ref7, $0608a055a17e1a05$var$_excluded);
    let { basename: basename } = $kc00y.useContext((0, $aw9wE.UNSAFE_NavigationContext));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $0608a055a17e1a05$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($0608a055a17e1a05$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $8K3mn.stripBasename)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $aw9wE.useHref)(to, {
        relative: relative
    });
    let internalOnClick = $0608a055a17e1a05$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $kc00y.createElement("a", $0608a055a17e1a05$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $0608a055a17e1a05$export$b0d92dbee9b5b60d = /*#__PURE__*/ $kc00y.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children } = _ref8, rest = $0608a055a17e1a05$var$_objectWithoutPropertiesLoose(_ref8, $0608a055a17e1a05$var$_excluded2);
    let path = (0, $aw9wE.useResolvedPath)(to, {
        relative: rest.relative
    });
    let location = (0, $aw9wE.useLocation)();
    let routerState = $kc00y.useContext((0, $aw9wE.UNSAFE_DataRouterStateContext));
    let { navigator: navigator, basename: basename } = $kc00y.useContext((0, $aw9wE.UNSAFE_NavigationContext));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $0608a055a17e1a05$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $8K3mn.stripBasename)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $kc00y.createElement($0608a055a17e1a05$export$a6c7ac8248d6e38a, $0608a055a17e1a05$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $0608a055a17e1a05$export$a7fed597f4b8afd8 = /*#__PURE__*/ $kc00y.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $0608a055a17e1a05$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref9, props = $0608a055a17e1a05$var$_objectWithoutPropertiesLoose(_ref9, $0608a055a17e1a05$var$_excluded3);
    let submit = $0608a055a17e1a05$export$47c85c6e3a081d3();
    let formAction = $0608a055a17e1a05$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /*#__PURE__*/ $kc00y.createElement("form", $0608a055a17e1a05$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $0608a055a17e1a05$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $0608a055a17e1a05$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $0608a055a17e1a05$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($0608a055a17e1a05$var$DataRouterHook || ($0608a055a17e1a05$var$DataRouterHook = {}));
var $0608a055a17e1a05$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($0608a055a17e1a05$var$DataRouterStateHook || ($0608a055a17e1a05$var$DataRouterStateHook = {}));
// Internal hooks
function $0608a055a17e1a05$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $0608a055a17e1a05$var$useDataRouterContext(hookName) {
    let ctx = $kc00y.useContext((0, $aw9wE.UNSAFE_DataRouterContext));
    !ctx && (0, $8K3mn.UNSAFE_invariant)(false);
    return ctx;
}
function $0608a055a17e1a05$var$useDataRouterState(hookName) {
    let state = $kc00y.useContext((0, $aw9wE.UNSAFE_DataRouterStateContext));
    !state && (0, $8K3mn.UNSAFE_invariant)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $0608a055a17e1a05$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $aw9wE.useNavigate)();
    let location = (0, $aw9wE.useLocation)();
    let path = (0, $aw9wE.useResolvedPath)(to, {
        relative: relative
    });
    return $kc00y.useCallback((event)=>{
        if ($0608a055a17e1a05$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $8K3mn.createPath)(location) === (0, $8K3mn.createPath)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $0608a055a17e1a05$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $kc00y.useRef($0608a055a17e1a05$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $kc00y.useRef(false);
    let location = (0, $aw9wE.useLocation)();
    let searchParams = $kc00y.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $0608a055a17e1a05$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $aw9wE.useNavigate)();
    let setSearchParams = $kc00y.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $0608a055a17e1a05$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $0608a055a17e1a05$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $0608a055a17e1a05$var$fetcherId = 0;
let $0608a055a17e1a05$var$getUniqueFetcherId = ()=>"__" + String(++$0608a055a17e1a05$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $0608a055a17e1a05$export$47c85c6e3a081d3() {
    let { router: router } = $0608a055a17e1a05$var$useDataRouterContext($0608a055a17e1a05$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $kc00y.useContext((0, $aw9wE.UNSAFE_NavigationContext));
    let currentRouteId = (0, $aw9wE.UNSAFE_useRouteId)();
    return $kc00y.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $0608a055a17e1a05$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $0608a055a17e1a05$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $0608a055a17e1a05$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $0608a055a17e1a05$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $kc00y.useContext((0, $aw9wE.UNSAFE_NavigationContext));
    let routeContext = $kc00y.useContext((0, $aw9wE.UNSAFE_RouteContext));
    !routeContext && (0, $8K3mn.UNSAFE_invariant)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $0608a055a17e1a05$var$_extends({}, (0, $aw9wE.useResolvedPath)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $aw9wE.useLocation)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $8K3mn.joinPaths)([
        basename,
        path.pathname
    ]);
    return (0, $8K3mn.createPath)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $0608a055a17e1a05$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $0608a055a17e1a05$var$useDataRouterContext($0608a055a17e1a05$var$DataRouterHook.UseFetcher);
    let state = $0608a055a17e1a05$var$useDataRouterState($0608a055a17e1a05$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $kc00y.useContext($0608a055a17e1a05$export$148fd98d095596d4);
    let route = $kc00y.useContext((0, $aw9wE.UNSAFE_RouteContext));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $8K3mn.UNSAFE_invariant)(false);
    !route && (0, $8K3mn.UNSAFE_invariant)(false);
    !(routeId != null) && (0, $8K3mn.UNSAFE_invariant)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $0608a055a17e1a05$var$useIdImpl ? $0608a055a17e1a05$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $kc00y.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($0608a055a17e1a05$var$getUniqueFetcherId());
    // Registration/cleanup
    $kc00y.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $kc00y.useCallback((href, opts)=>{
        !routeId && (0, $8K3mn.UNSAFE_invariant)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $0608a055a17e1a05$export$47c85c6e3a081d3();
    let submit = $kc00y.useCallback((target, opts)=>{
        submitImpl(target, $0608a055a17e1a05$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $kc00y.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $kc00y.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $kc00y.createElement($0608a055a17e1a05$export$a7fed597f4b8afd8, $0608a055a17e1a05$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $8K3mn.IDLE_FETCHER);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $kc00y.useMemo(()=>$0608a055a17e1a05$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $0608a055a17e1a05$export$fa996778a3a31087() {
    let state = $0608a055a17e1a05$var$useDataRouterState($0608a055a17e1a05$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $0608a055a17e1a05$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $0608a055a17e1a05$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $0608a055a17e1a05$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $0608a055a17e1a05$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $0608a055a17e1a05$var$useDataRouterContext($0608a055a17e1a05$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $0608a055a17e1a05$var$useDataRouterState($0608a055a17e1a05$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $kc00y.useContext((0, $aw9wE.UNSAFE_NavigationContext));
    let location = (0, $aw9wE.useLocation)();
    let matches = (0, $aw9wE.useMatches)();
    let navigation = (0, $aw9wE.useNavigation)();
    // Trigger manual scroll restoration while we're active
    $kc00y.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $0608a055a17e1a05$var$usePageHide($kc00y.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $0608a055a17e1a05$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $0608a055a17e1a05$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($0608a055a17e1a05$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $kc00y.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $0608a055a17e1a05$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $0608a055a17e1a05$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $kc00y.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($0608a055a17e1a05$var$_extends({}, location, {
                    pathname: (0, $8K3mn.stripBasename)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($0608a055a17e1a05$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $kc00y.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $0608a055a17e1a05$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $kc00y.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $0608a055a17e1a05$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $kc00y.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $0608a055a17e1a05$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $aw9wE.useBlocker)(when);
    $kc00y.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $kc00y.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $0608a055a17e1a05$export$e262bd1977bea848(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $kc00y.useContext($0608a055a17e1a05$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $8K3mn.UNSAFE_invariant)(false);
    let { basename: basename } = $0608a055a17e1a05$var$useDataRouterContext($0608a055a17e1a05$var$DataRouterHook.useViewTransitionState);
    let path = (0, $aw9wE.useResolvedPath)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $8K3mn.stripBasename)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $8K3mn.stripBasename)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $8K3mn.matchPath)(path.pathname, nextPath) != null || (0, $8K3mn.matchPath)(path.pathname, currentPath) != null;
}

});
parcelRegister("8K3mn", function(module, exports) {

$parcel$export(module.exports, "Action", () => $65d539d52291a3d6$export$e19cd5f9376f8cee);
$parcel$export(module.exports, "createMemoryHistory", () => $65d539d52291a3d6$export$2b76ad033c6e6d08);
$parcel$export(module.exports, "createPath", () => $65d539d52291a3d6$export$fe53371bee54353d);
$parcel$export(module.exports, "parsePath", () => $65d539d52291a3d6$export$8ccf933b0513f8d0);
$parcel$export(module.exports, "createBrowserHistory", () => $65d539d52291a3d6$export$719fc203c4e16dee);
$parcel$export(module.exports, "createHashHistory", () => $65d539d52291a3d6$export$b71fdd3798280242);
$parcel$export(module.exports, "UNSAFE_invariant", () => $65d539d52291a3d6$export$3e9cee6b33872309);
$parcel$export(module.exports, "matchRoutes", () => $65d539d52291a3d6$export$2708184779ceb39d);
$parcel$export(module.exports, "stripBasename", () => $65d539d52291a3d6$export$b69e3301ce081aa3);
$parcel$export(module.exports, "UNSAFE_decodePath", () => $65d539d52291a3d6$export$30d21fd6d7295f52);
$parcel$export(module.exports, "UNSAFE_convertRouteMatchToUiMatch", () => $65d539d52291a3d6$export$b3fac024fad9e8ff);
$parcel$export(module.exports, "joinPaths", () => $65d539d52291a3d6$export$86d9a7913e44197e);
$parcel$export(module.exports, "matchPath", () => $65d539d52291a3d6$export$81336c211d5ff295);
$parcel$export(module.exports, "UNSAFE_getResolveToMatches", () => $65d539d52291a3d6$export$a5784978eca585fa);
$parcel$export(module.exports, "resolveTo", () => $65d539d52291a3d6$export$cae722b0cc860f13);
$parcel$export(module.exports, "AbortedDeferredError", () => $65d539d52291a3d6$export$42a99a7a4bc0e76a);
$parcel$export(module.exports, "UNSAFE_ErrorResponseImpl", () => $65d539d52291a3d6$export$6c6580e81da25755);
$parcel$export(module.exports, "isRouteErrorResponse", () => $65d539d52291a3d6$export$972111febbeef05b);
$parcel$export(module.exports, "IDLE_FETCHER", () => $65d539d52291a3d6$export$52eace9c284d3585);
$parcel$export(module.exports, "IDLE_BLOCKER", () => $65d539d52291a3d6$export$386d57f03f0b2883);
$parcel$export(module.exports, "createRouter", () => $65d539d52291a3d6$export$baddd0131ee8c05b);
/**
 * @remix-run/router v1.20.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $65d539d52291a3d6$var$_extends() {
    $65d539d52291a3d6$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $65d539d52291a3d6$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $65d539d52291a3d6$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($65d539d52291a3d6$export$e19cd5f9376f8cee || ($65d539d52291a3d6$export$e19cd5f9376f8cee = {}));
const $65d539d52291a3d6$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $65d539d52291a3d6$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $65d539d52291a3d6$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $65d539d52291a3d6$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $65d539d52291a3d6$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $65d539d52291a3d6$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $65d539d52291a3d6$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $65d539d52291a3d6$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $65d539d52291a3d6$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $65d539d52291a3d6$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $65d539d52291a3d6$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $65d539d52291a3d6$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $65d539d52291a3d6$export$fe53371bee54353d(to);
    }
    return $65d539d52291a3d6$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $65d539d52291a3d6$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $65d539d52291a3d6$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $65d539d52291a3d6$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $65d539d52291a3d6$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $65d539d52291a3d6$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $65d539d52291a3d6$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $65d539d52291a3d6$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $65d539d52291a3d6$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $65d539d52291a3d6$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $65d539d52291a3d6$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $65d539d52291a3d6$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $65d539d52291a3d6$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $65d539d52291a3d6$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $65d539d52291a3d6$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $65d539d52291a3d6$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $65d539d52291a3d6$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $65d539d52291a3d6$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $65d539d52291a3d6$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($65d539d52291a3d6$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $65d539d52291a3d6$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $65d539d52291a3d6$export$e19cd5f9376f8cee.Push;
        let location = $65d539d52291a3d6$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $65d539d52291a3d6$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $65d539d52291a3d6$export$e19cd5f9376f8cee.Replace;
        let location = $65d539d52291a3d6$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $65d539d52291a3d6$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $65d539d52291a3d6$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $65d539d52291a3d6$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($65d539d52291a3d6$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($65d539d52291a3d6$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $65d539d52291a3d6$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($65d539d52291a3d6$var$ResultType || ($65d539d52291a3d6$var$ResultType = {}));
const $65d539d52291a3d6$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $65d539d52291a3d6$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $65d539d52291a3d6$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $65d539d52291a3d6$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $65d539d52291a3d6$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($65d539d52291a3d6$var$isIndexRoute(route)) {
            let indexRoute = $65d539d52291a3d6$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $65d539d52291a3d6$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $65d539d52291a3d6$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $65d539d52291a3d6$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $65d539d52291a3d6$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $65d539d52291a3d6$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $65d539d52291a3d6$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $65d539d52291a3d6$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $65d539d52291a3d6$var$flattenRoutes(routes);
    $65d539d52291a3d6$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $65d539d52291a3d6$export$30d21fd6d7295f52(pathname);
        matches = $65d539d52291a3d6$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $65d539d52291a3d6$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $65d539d52291a3d6$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $65d539d52291a3d6$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $65d539d52291a3d6$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $65d539d52291a3d6$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $65d539d52291a3d6$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $65d539d52291a3d6$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $65d539d52291a3d6$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $65d539d52291a3d6$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $65d539d52291a3d6$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $65d539d52291a3d6$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $65d539d52291a3d6$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $65d539d52291a3d6$var$paramRe = /^:[\w-]+$/;
const $65d539d52291a3d6$var$dynamicSegmentValue = 3;
const $65d539d52291a3d6$var$indexRouteValue = 2;
const $65d539d52291a3d6$var$emptySegmentValue = 1;
const $65d539d52291a3d6$var$staticSegmentValue = 10;
const $65d539d52291a3d6$var$splatPenalty = -2;
const $65d539d52291a3d6$var$isSplat = (s)=>s === "*";
function $65d539d52291a3d6$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($65d539d52291a3d6$var$isSplat)) initialScore += $65d539d52291a3d6$var$splatPenalty;
    if (index) initialScore += $65d539d52291a3d6$var$indexRouteValue;
    return segments.filter((s)=>!$65d539d52291a3d6$var$isSplat(s)).reduce((score, segment)=>score + ($65d539d52291a3d6$var$paramRe.test(segment) ? $65d539d52291a3d6$var$dynamicSegmentValue : segment === "" ? $65d539d52291a3d6$var$emptySegmentValue : $65d539d52291a3d6$var$staticSegmentValue), initialScore);
}
function $65d539d52291a3d6$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $65d539d52291a3d6$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $65d539d52291a3d6$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $65d539d52291a3d6$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $65d539d52291a3d6$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $65d539d52291a3d6$export$a5c6d149b50c1d86($65d539d52291a3d6$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $65d539d52291a3d6$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $65d539d52291a3d6$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $65d539d52291a3d6$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $65d539d52291a3d6$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $65d539d52291a3d6$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $65d539d52291a3d6$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $65d539d52291a3d6$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $65d539d52291a3d6$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $65d539d52291a3d6$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $65d539d52291a3d6$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $65d539d52291a3d6$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $65d539d52291a3d6$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $65d539d52291a3d6$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $65d539d52291a3d6$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $65d539d52291a3d6$var$normalizeSearch(search),
        hash: $65d539d52291a3d6$var$normalizeHash(hash)
    };
}
function $65d539d52291a3d6$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $65d539d52291a3d6$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $65d539d52291a3d6$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $65d539d52291a3d6$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $65d539d52291a3d6$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $65d539d52291a3d6$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $65d539d52291a3d6$export$8ccf933b0513f8d0(toArg);
    else {
        to = $65d539d52291a3d6$var$_extends({}, toArg);
        $65d539d52291a3d6$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $65d539d52291a3d6$var$getInvalidPathError("?", "pathname", "search", to));
        $65d539d52291a3d6$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $65d539d52291a3d6$var$getInvalidPathError("#", "pathname", "hash", to));
        $65d539d52291a3d6$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $65d539d52291a3d6$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $65d539d52291a3d6$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $65d539d52291a3d6$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $65d539d52291a3d6$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $65d539d52291a3d6$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $65d539d52291a3d6$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $65d539d52291a3d6$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $65d539d52291a3d6$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $65d539d52291a3d6$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $65d539d52291a3d6$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $65d539d52291a3d6$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $65d539d52291a3d6$export$4051a07651545597(data, init) {
    return new $65d539d52291a3d6$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $65d539d52291a3d6$export$42a99a7a4bc0e76a extends Error {
}
class $65d539d52291a3d6$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $65d539d52291a3d6$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $65d539d52291a3d6$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $65d539d52291a3d6$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $65d539d52291a3d6$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $65d539d52291a3d6$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $65d539d52291a3d6$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $65d539d52291a3d6$var$unwrapTrackedPromise(value) {
    if (!$65d539d52291a3d6$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $65d539d52291a3d6$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $65d539d52291a3d6$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $65d539d52291a3d6$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $65d539d52291a3d6$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $65d539d52291a3d6$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $65d539d52291a3d6$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $65d539d52291a3d6$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $65d539d52291a3d6$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $65d539d52291a3d6$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $65d539d52291a3d6$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $65d539d52291a3d6$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $65d539d52291a3d6$var$validMutationMethods = new Set($65d539d52291a3d6$var$validMutationMethodsArr);
const $65d539d52291a3d6$var$validRequestMethodsArr = [
    "get",
    ...$65d539d52291a3d6$var$validMutationMethodsArr
];
const $65d539d52291a3d6$var$validRequestMethods = new Set($65d539d52291a3d6$var$validRequestMethodsArr);
const $65d539d52291a3d6$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $65d539d52291a3d6$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $65d539d52291a3d6$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $65d539d52291a3d6$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $65d539d52291a3d6$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $65d539d52291a3d6$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $65d539d52291a3d6$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $65d539d52291a3d6$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $65d539d52291a3d6$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $65d539d52291a3d6$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $65d539d52291a3d6$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $65d539d52291a3d6$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $65d539d52291a3d6$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $65d539d52291a3d6$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $65d539d52291a3d6$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $65d539d52291a3d6$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $65d539d52291a3d6$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) initialMatches = fogOfWar.matches;
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$65d539d52291a3d6$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$65d539d52291a3d6$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $65d539d52291a3d6$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $65d539d52291a3d6$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $65d539d52291a3d6$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $65d539d52291a3d6$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $65d539d52291a3d6$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$65d539d52291a3d6$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($65d539d52291a3d6$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $65d539d52291a3d6$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $65d539d52291a3d6$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $65d539d52291a3d6$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $65d539d52291a3d6$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $65d539d52291a3d6$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $65d539d52291a3d6$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $65d539d52291a3d6$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $65d539d52291a3d6$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $65d539d52291a3d6$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($65d539d52291a3d6$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $65d539d52291a3d6$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $65d539d52291a3d6$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $65d539d52291a3d6$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $65d539d52291a3d6$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $65d539d52291a3d6$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $65d539d52291a3d6$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $65d539d52291a3d6$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $65d539d52291a3d6$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $65d539d52291a3d6$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $65d539d52291a3d6$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $65d539d52291a3d6$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $65d539d52291a3d6$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $65d539d52291a3d6$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $65d539d52291a3d6$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $65d539d52291a3d6$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $65d539d52291a3d6$var$findNearestBoundary(matches).route.id,
            {
                type: $65d539d52291a3d6$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $65d539d52291a3d6$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($65d539d52291a3d6$var$isErrorResult(result) && $65d539d52291a3d6$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $65d539d52291a3d6$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $65d539d52291a3d6$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $65d539d52291a3d6$var$_extends({
            matches: updatedMatches || matches
        }, $65d539d52291a3d6$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $65d539d52291a3d6$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $65d539d52291a3d6$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $65d539d52291a3d6$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $65d539d52291a3d6$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $65d539d52291a3d6$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $65d539d52291a3d6$var$ResultType.error,
            error: $65d539d52291a3d6$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($65d539d52291a3d6$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $65d539d52291a3d6$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($65d539d52291a3d6$var$isDeferredResult(result)) throw $65d539d52291a3d6$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($65d539d52291a3d6$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $65d539d52291a3d6$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $65d539d52291a3d6$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $65d539d52291a3d6$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $65d539d52291a3d6$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($65d539d52291a3d6$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $65d539d52291a3d6$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $65d539d52291a3d6$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $65d539d52291a3d6$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $65d539d52291a3d6$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $65d539d52291a3d6$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $65d539d52291a3d6$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $65d539d52291a3d6$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $65d539d52291a3d6$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $65d539d52291a3d6$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $65d539d52291a3d6$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$65d539d52291a3d6$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $65d539d52291a3d6$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $65d539d52291a3d6$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $65d539d52291a3d6$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $65d539d52291a3d6$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $65d539d52291a3d6$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $65d539d52291a3d6$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $65d539d52291a3d6$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $65d539d52291a3d6$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $65d539d52291a3d6$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $65d539d52291a3d6$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, path, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $65d539d52291a3d6$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $65d539d52291a3d6$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($65d539d52291a3d6$var$isRedirectResult(actionResult) || $65d539d52291a3d6$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $65d539d52291a3d6$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($65d539d52291a3d6$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $65d539d52291a3d6$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $65d539d52291a3d6$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($65d539d52291a3d6$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($65d539d52291a3d6$var$isDeferredResult(actionResult)) throw $65d539d52291a3d6$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $65d539d52291a3d6$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $65d539d52291a3d6$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $65d539d52291a3d6$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $65d539d52291a3d6$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $65d539d52291a3d6$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $65d539d52291a3d6$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $65d539d52291a3d6$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $65d539d52291a3d6$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $65d539d52291a3d6$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $65d539d52291a3d6$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $65d539d52291a3d6$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $65d539d52291a3d6$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $65d539d52291a3d6$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $65d539d52291a3d6$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, path, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $65d539d52291a3d6$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $65d539d52291a3d6$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($65d539d52291a3d6$var$isDeferredResult(result)) result = await $65d539d52291a3d6$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $65d539d52291a3d6$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($65d539d52291a3d6$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $65d539d52291a3d6$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($65d539d52291a3d6$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $65d539d52291a3d6$export$3e9cee6b33872309(!$65d539d52291a3d6$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $65d539d52291a3d6$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $65d539d52291a3d6$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $65d539d52291a3d6$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $65d539d52291a3d6$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($65d539d52291a3d6$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $65d539d52291a3d6$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $65d539d52291a3d6$export$e19cd5f9376f8cee.Replace : $65d539d52291a3d6$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $65d539d52291a3d6$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($65d539d52291a3d6$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $65d539d52291a3d6$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $65d539d52291a3d6$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $65d539d52291a3d6$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $65d539d52291a3d6$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $65d539d52291a3d6$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($65d539d52291a3d6$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $65d539d52291a3d6$var$ResultType.redirect,
                response: $65d539d52291a3d6$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $65d539d52291a3d6$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $65d539d52291a3d6$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $65d539d52291a3d6$var$ResultType.error,
                    error: $65d539d52291a3d6$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $65d539d52291a3d6$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $65d539d52291a3d6$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $65d539d52291a3d6$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || $65d539d52291a3d6$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            let count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $65d539d52291a3d6$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $65d539d52291a3d6$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $65d539d52291a3d6$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $65d539d52291a3d6$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $65d539d52291a3d6$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $65d539d52291a3d6$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $65d539d52291a3d6$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $65d539d52291a3d6$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $65d539d52291a3d6$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $65d539d52291a3d6$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$65d539d52291a3d6$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $65d539d52291a3d6$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $65d539d52291a3d6$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    path: pathname,
                    matches: partialMatches,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $65d539d52291a3d6$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $65d539d52291a3d6$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $65d539d52291a3d6$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $65d539d52291a3d6$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $65d539d52291a3d6$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $65d539d52291a3d6$export$4d0306f8f6a4585b = Symbol("deferred");
function $65d539d52291a3d6$export$3336b097a6fbc59a(routes, opts) {
    $65d539d52291a3d6$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $65d539d52291a3d6$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $65d539d52291a3d6$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $65d539d52291a3d6$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $65d539d52291a3d6$var$createLocation("", $65d539d52291a3d6$export$fe53371bee54353d(url), null, "default");
        let matches = $65d539d52291a3d6$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$65d539d52291a3d6$var$isValidMethod(method) && method !== "HEAD") {
            let error = $65d539d52291a3d6$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $65d539d52291a3d6$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $65d539d52291a3d6$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $65d539d52291a3d6$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($65d539d52291a3d6$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $65d539d52291a3d6$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $65d539d52291a3d6$var$createLocation("", $65d539d52291a3d6$export$fe53371bee54353d(url), null, "default");
        let matches = $65d539d52291a3d6$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$65d539d52291a3d6$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $65d539d52291a3d6$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $65d539d52291a3d6$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $65d539d52291a3d6$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $65d539d52291a3d6$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $65d539d52291a3d6$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($65d539d52291a3d6$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$65d539d52291a3d6$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $65d539d52291a3d6$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($65d539d52291a3d6$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $65d539d52291a3d6$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $65d539d52291a3d6$var$isResponse(result) ? result : $65d539d52291a3d6$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($65d539d52291a3d6$var$isDataStrategyResult(e) && $65d539d52291a3d6$var$isResponse(e.result)) {
                if (e.type === $65d539d52291a3d6$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($65d539d52291a3d6$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $65d539d52291a3d6$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $65d539d52291a3d6$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $65d539d52291a3d6$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($65d539d52291a3d6$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($65d539d52291a3d6$var$isDeferredResult(result)) {
            let error = $65d539d52291a3d6$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $65d539d52291a3d6$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($65d539d52291a3d6$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($65d539d52291a3d6$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $65d539d52291a3d6$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $65d539d52291a3d6$var$_extends({}, context, {
                statusCode: $65d539d52291a3d6$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $65d539d52291a3d6$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $65d539d52291a3d6$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $65d539d52291a3d6$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $65d539d52291a3d6$var$isErrorResult(pendingActionResult[1]) ? $65d539d52291a3d6$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $65d539d52291a3d6$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $65d539d52291a3d6$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $65d539d52291a3d6$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $65d539d52291a3d6$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $65d539d52291a3d6$var$callDataStrategyImpl(dataStrategy || $65d539d52291a3d6$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($65d539d52291a3d6$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $65d539d52291a3d6$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($65d539d52291a3d6$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $65d539d52291a3d6$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $65d539d52291a3d6$export$fec11da027c70692(routes, context, error) {
    let newContext = $65d539d52291a3d6$var$_extends({}, context, {
        statusCode: $65d539d52291a3d6$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $65d539d52291a3d6$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $65d539d52291a3d6$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $65d539d52291a3d6$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $65d539d52291a3d6$export$cae722b0cc860f13(to ? to : ".", $65d539d52291a3d6$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $65d539d52291a3d6$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $65d539d52291a3d6$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $65d539d52291a3d6$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $65d539d52291a3d6$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $65d539d52291a3d6$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$65d539d52291a3d6$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$65d539d52291a3d6$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $65d539d52291a3d6$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $65d539d52291a3d6$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $65d539d52291a3d6$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$65d539d52291a3d6$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$65d539d52291a3d6$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $65d539d52291a3d6$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $65d539d52291a3d6$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $65d539d52291a3d6$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $65d539d52291a3d6$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $65d539d52291a3d6$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($65d539d52291a3d6$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $65d539d52291a3d6$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $65d539d52291a3d6$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $65d539d52291a3d6$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $65d539d52291a3d6$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $65d539d52291a3d6$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $65d539d52291a3d6$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $65d539d52291a3d6$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $65d539d52291a3d6$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $65d539d52291a3d6$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $65d539d52291a3d6$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($65d539d52291a3d6$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $65d539d52291a3d6$var$shouldRevalidateLoader(match, $65d539d52291a3d6$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $65d539d52291a3d6$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $65d539d52291a3d6$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $65d539d52291a3d6$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $65d539d52291a3d6$var$shouldRevalidateLoader(fetcherMatch, $65d539d52291a3d6$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $65d539d52291a3d6$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $65d539d52291a3d6$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $65d539d52291a3d6$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $65d539d52291a3d6$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $65d539d52291a3d6$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $65d539d52291a3d6$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$65d539d52291a3d6$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $65d539d52291a3d6$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $65d539d52291a3d6$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$65d539d52291a3d6$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $65d539d52291a3d6$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $65d539d52291a3d6$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $65d539d52291a3d6$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !$65d539d52291a3d6$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $65d539d52291a3d6$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $65d539d52291a3d6$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $65d539d52291a3d6$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $65d539d52291a3d6$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $65d539d52291a3d6$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $65d539d52291a3d6$var$ResultType.data,
                result: undefined
            });
        };
        return $65d539d52291a3d6$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $65d539d52291a3d6$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ('"' + type + '" [routeId: ' + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $65d539d52291a3d6$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $65d539d52291a3d6$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $65d539d52291a3d6$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $65d539d52291a3d6$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $65d539d52291a3d6$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $65d539d52291a3d6$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($65d539d52291a3d6$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $65d539d52291a3d6$var$ResultType.error,
                error: e
            };
        }
        if (type === $65d539d52291a3d6$var$ResultType.error) return {
            type: $65d539d52291a3d6$var$ResultType.error,
            error: new $65d539d52291a3d6$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $65d539d52291a3d6$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $65d539d52291a3d6$var$ResultType.error) {
        if ($65d539d52291a3d6$export$e0163cfdf7bc9cfa(result)) {
            var _result$init2;
            if (result.data instanceof Error) {
                var _result$init;
                return {
                    type: $65d539d52291a3d6$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status
                };
            }
            // Convert thrown data() to ErrorResponse instances
            result = new $65d539d52291a3d6$export$6c6580e81da25755(((_result$init2 = result.init) == null ? void 0 : _result$init2.status) || 500, undefined, result.data);
        }
        return {
            type: $65d539d52291a3d6$var$ResultType.error,
            error: result,
            statusCode: $65d539d52291a3d6$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($65d539d52291a3d6$export$fbcedacb60443473(result)) {
        var _result$init3, _result$init4;
        return {
            type: $65d539d52291a3d6$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init3 = result.init) == null ? void 0 : _result$init3.status,
            headers: ((_result$init4 = result.init) == null ? void 0 : _result$init4.headers) && new Headers(result.init.headers)
        };
    }
    if ($65d539d52291a3d6$export$e0163cfdf7bc9cfa(result)) {
        var _result$init5, _result$init6;
        return {
            type: $65d539d52291a3d6$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: (_result$init6 = result.init) != null && _result$init6.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $65d539d52291a3d6$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $65d539d52291a3d6$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $65d539d52291a3d6$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$65d539d52291a3d6$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $65d539d52291a3d6$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $65d539d52291a3d6$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($65d539d52291a3d6$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $65d539d52291a3d6$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $65d539d52291a3d6$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($65d539d52291a3d6$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $65d539d52291a3d6$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $65d539d52291a3d6$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $65d539d52291a3d6$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $65d539d52291a3d6$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $65d539d52291a3d6$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $65d539d52291a3d6$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $65d539d52291a3d6$export$3e9cee6b33872309(!$65d539d52291a3d6$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($65d539d52291a3d6$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $65d539d52291a3d6$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $65d539d52291a3d6$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($65d539d52291a3d6$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $65d539d52291a3d6$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $65d539d52291a3d6$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $65d539d52291a3d6$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($65d539d52291a3d6$var$isErrorResult(result)) {
            let boundaryMatch = $65d539d52291a3d6$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $65d539d52291a3d6$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($65d539d52291a3d6$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $65d539d52291a3d6$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($65d539d52291a3d6$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $65d539d52291a3d6$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $65d539d52291a3d6$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $65d539d52291a3d6$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $65d539d52291a3d6$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $65d539d52291a3d6$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $65d539d52291a3d6$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $65d539d52291a3d6$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $65d539d52291a3d6$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $65d539d52291a3d6$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $65d539d52291a3d6$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $65d539d52291a3d6$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($65d539d52291a3d6$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $65d539d52291a3d6$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $65d539d52291a3d6$export$8ccf933b0513f8d0(path) : path;
    return $65d539d52291a3d6$export$fe53371bee54353d($65d539d52291a3d6$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $65d539d52291a3d6$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $65d539d52291a3d6$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $65d539d52291a3d6$var$ResultType.data || result.type === $65d539d52291a3d6$var$ResultType.error);
}
function $65d539d52291a3d6$var$isRedirectDataStrategyResultResult(result) {
    return $65d539d52291a3d6$var$isResponse(result.result) && $65d539d52291a3d6$var$redirectStatusCodes.has(result.result.status);
}
function $65d539d52291a3d6$var$isDeferredResult(result) {
    return result.type === $65d539d52291a3d6$var$ResultType.deferred;
}
function $65d539d52291a3d6$var$isErrorResult(result) {
    return result.type === $65d539d52291a3d6$var$ResultType.error;
}
function $65d539d52291a3d6$var$isRedirectResult(result) {
    return (result && result.type) === $65d539d52291a3d6$var$ResultType.redirect;
}
function $65d539d52291a3d6$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $65d539d52291a3d6$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $65d539d52291a3d6$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $65d539d52291a3d6$var$isRedirectResponse(result) {
    if (!$65d539d52291a3d6$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $65d539d52291a3d6$var$isValidMethod(method) {
    return $65d539d52291a3d6$var$validRequestMethods.has(method.toLowerCase());
}
function $65d539d52291a3d6$var$isMutationMethod(method) {
    return $65d539d52291a3d6$var$validMutationMethods.has(method.toLowerCase());
}
async function $65d539d52291a3d6$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$65d539d52291a3d6$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($65d539d52291a3d6$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $65d539d52291a3d6$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $65d539d52291a3d6$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($65d539d52291a3d6$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $65d539d52291a3d6$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $65d539d52291a3d6$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $65d539d52291a3d6$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $65d539d52291a3d6$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $65d539d52291a3d6$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $65d539d52291a3d6$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $65d539d52291a3d6$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $65d539d52291a3d6$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $65d539d52291a3d6$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $65d539d52291a3d6$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $65d539d52291a3d6$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $65d539d52291a3d6$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $65d539d52291a3d6$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $65d539d52291a3d6$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $65d539d52291a3d6$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $65d539d52291a3d6$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $65d539d52291a3d6$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $65d539d52291a3d6$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($65d539d52291a3d6$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $65d539d52291a3d6$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($65d539d52291a3d6$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $65d539d52291a3d6$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

});

parcelRegister("aw9wE", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_DataRouterContext", () => $7a844823b04d4282$export$3add0d5dce533e2e);
$parcel$export(module.exports, "UNSAFE_DataRouterStateContext", () => $7a844823b04d4282$export$145dfa71566a64dc);
$parcel$export(module.exports, "UNSAFE_NavigationContext", () => $7a844823b04d4282$export$26749e8557646306);
$parcel$export(module.exports, "UNSAFE_RouteContext", () => $7a844823b04d4282$export$9072aa6dd1f93057);
$parcel$export(module.exports, "useHref", () => $7a844823b04d4282$export$b66bb29c5006f12f);
$parcel$export(module.exports, "useResolvedPath", () => $7a844823b04d4282$export$e75d2a2d1b3c245b);
$parcel$export(module.exports, "useLocation", () => $7a844823b04d4282$export$45d76561a5302f2b);
$parcel$export(module.exports, "useNavigate", () => $7a844823b04d4282$export$9770f232ac06a008);
$parcel$export(module.exports, "useParams", () => $7a844823b04d4282$export$99eaa27ddbbb95ef);
$parcel$export(module.exports, "useRoutes", () => $7a844823b04d4282$export$5d3fca4a98652595);
$parcel$export(module.exports, "UNSAFE_useRoutesImpl", () => $7a844823b04d4282$export$5fcee62552a12fbf);
$parcel$export(module.exports, "UNSAFE_useRouteId", () => $7a844823b04d4282$export$5fc8298006ad9e58);
$parcel$export(module.exports, "useNavigation", () => $7a844823b04d4282$export$d0fd4b7106de2769);
$parcel$export(module.exports, "useMatches", () => $7a844823b04d4282$export$2378eb7f5ff86053);
$parcel$export(module.exports, "useBlocker", () => $7a844823b04d4282$export$b273b3273281a049);
$parcel$export(module.exports, "Router", () => $7a844823b04d4282$export$55185c17a0fcbe46);
$parcel$export(module.exports, "UNSAFE_mapRouteProperties", () => $7a844823b04d4282$export$52b333d321859367);
/**
 * React Router v6.27.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $kc00y = parcelRequire("kc00y");

var $8K3mn = parcelRequire("8K3mn");
function $7a844823b04d4282$var$_extends() {
    $7a844823b04d4282$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7a844823b04d4282$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $7a844823b04d4282$export$3add0d5dce533e2e = /*#__PURE__*/ $kc00y.createContext(null);
const $7a844823b04d4282$export$145dfa71566a64dc = /*#__PURE__*/ $kc00y.createContext(null);
const $7a844823b04d4282$var$AwaitContext = /*#__PURE__*/ $kc00y.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $7a844823b04d4282$export$26749e8557646306 = /*#__PURE__*/ $kc00y.createContext(null);
const $7a844823b04d4282$export$c7914228fb69b0f5 = /*#__PURE__*/ $kc00y.createContext(null);
const $7a844823b04d4282$export$9072aa6dd1f93057 = /*#__PURE__*/ $kc00y.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $7a844823b04d4282$var$RouteErrorContext = /*#__PURE__*/ $kc00y.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $7a844823b04d4282$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$7a844823b04d4282$export$9c954a9d03d32f4a() && (0, $8K3mn.UNSAFE_invariant)(false);
    let { basename: basename, navigator: navigator } = $kc00y.useContext($7a844823b04d4282$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $7a844823b04d4282$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $8K3mn.joinPaths)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $7a844823b04d4282$export$9c954a9d03d32f4a() {
    return $kc00y.useContext($7a844823b04d4282$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $7a844823b04d4282$export$45d76561a5302f2b() {
    !$7a844823b04d4282$export$9c954a9d03d32f4a() && (0, $8K3mn.UNSAFE_invariant)(false);
    return $kc00y.useContext($7a844823b04d4282$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $7a844823b04d4282$export$1b3f31771c5d07c() {
    return $kc00y.useContext($7a844823b04d4282$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $7a844823b04d4282$export$6c330e8992e8a295(pattern) {
    !$7a844823b04d4282$export$9c954a9d03d32f4a() && (0, $8K3mn.UNSAFE_invariant)(false);
    let { pathname: pathname } = $7a844823b04d4282$export$45d76561a5302f2b();
    return $kc00y.useMemo(()=>(0, $8K3mn.matchPath)(pattern, (0, $8K3mn.UNSAFE_decodePath)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $7a844823b04d4282$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $7a844823b04d4282$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $kc00y.useContext($7a844823b04d4282$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $kc00y.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $7a844823b04d4282$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $kc00y.useContext($7a844823b04d4282$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $7a844823b04d4282$var$useNavigateStable() : $7a844823b04d4282$var$useNavigateUnstable();
}
function $7a844823b04d4282$var$useNavigateUnstable() {
    !$7a844823b04d4282$export$9c954a9d03d32f4a() && (0, $8K3mn.UNSAFE_invariant)(false);
    let dataRouterContext = $kc00y.useContext($7a844823b04d4282$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $kc00y.useContext($7a844823b04d4282$export$26749e8557646306);
    let { matches: matches } = $kc00y.useContext($7a844823b04d4282$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7a844823b04d4282$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $8K3mn.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    let activeRef = $kc00y.useRef(false);
    $7a844823b04d4282$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $kc00y.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $8K3mn.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $8K3mn.joinPaths)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $7a844823b04d4282$var$OutletContext = /*#__PURE__*/ $kc00y.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $7a844823b04d4282$export$4138103a3ae699cc() {
    return $kc00y.useContext($7a844823b04d4282$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $7a844823b04d4282$export$a3be3530d8e40d0b(context) {
    let outlet = $kc00y.useContext($7a844823b04d4282$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $kc00y.createElement($7a844823b04d4282$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $7a844823b04d4282$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $kc00y.useContext($7a844823b04d4282$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $7a844823b04d4282$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $kc00y.useContext($7a844823b04d4282$export$26749e8557646306);
    let { matches: matches } = $kc00y.useContext($7a844823b04d4282$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7a844823b04d4282$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $8K3mn.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    return $kc00y.useMemo(()=>(0, $8K3mn.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $7a844823b04d4282$export$5d3fca4a98652595(routes, locationArg) {
    return $7a844823b04d4282$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $7a844823b04d4282$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$7a844823b04d4282$export$9c954a9d03d32f4a() && (0, $8K3mn.UNSAFE_invariant)(false);
    let { navigator: navigator } = $kc00y.useContext($7a844823b04d4282$export$26749e8557646306);
    let { matches: parentMatches } = $kc00y.useContext($7a844823b04d4282$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $7a844823b04d4282$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $8K3mn.parsePath)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $8K3mn.UNSAFE_invariant)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $8K3mn.matchRoutes)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $7a844823b04d4282$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $8K3mn.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $8K3mn.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $kc00y.createElement($7a844823b04d4282$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $7a844823b04d4282$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $8K3mn.Action).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $7a844823b04d4282$var$DefaultErrorComponent() {
    let error = $7a844823b04d4282$export$ed527bf60f6e05f2();
    let message = (0, $8K3mn.isRouteErrorResponse)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $kc00y.createElement($kc00y.Fragment, null, /*#__PURE__*/ $kc00y.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $kc00y.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $kc00y.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $7a844823b04d4282$var$defaultErrorElement = /*#__PURE__*/ $kc00y.createElement($7a844823b04d4282$var$DefaultErrorComponent, null);
class $7a844823b04d4282$var$RenderErrorBoundary extends $kc00y.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $kc00y.createElement($7a844823b04d4282$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $kc00y.createElement($7a844823b04d4282$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $7a844823b04d4282$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $kc00y.useContext($7a844823b04d4282$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $kc00y.createElement($7a844823b04d4282$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $7a844823b04d4282$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $8K3mn.UNSAFE_invariant)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $7a844823b04d4282$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $7a844823b04d4282$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $kc00y.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $kc00y.createElement($7a844823b04d4282$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $kc00y.createElement($7a844823b04d4282$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $7a844823b04d4282$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($7a844823b04d4282$var$DataRouterHook || {});
var $7a844823b04d4282$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($7a844823b04d4282$var$DataRouterStateHook || {});
function $7a844823b04d4282$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $7a844823b04d4282$var$useDataRouterContext(hookName) {
    let ctx = $kc00y.useContext($7a844823b04d4282$export$3add0d5dce533e2e);
    !ctx && (0, $8K3mn.UNSAFE_invariant)(false);
    return ctx;
}
function $7a844823b04d4282$var$useDataRouterState(hookName) {
    let state = $kc00y.useContext($7a844823b04d4282$export$145dfa71566a64dc);
    !state && (0, $8K3mn.UNSAFE_invariant)(false);
    return state;
}
function $7a844823b04d4282$var$useRouteContext(hookName) {
    let route = $kc00y.useContext($7a844823b04d4282$export$9072aa6dd1f93057);
    !route && (0, $8K3mn.UNSAFE_invariant)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $7a844823b04d4282$var$useCurrentRouteId(hookName) {
    let route = $7a844823b04d4282$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $8K3mn.UNSAFE_invariant)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $7a844823b04d4282$export$5fc8298006ad9e58() {
    return $7a844823b04d4282$var$useCurrentRouteId($7a844823b04d4282$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $7a844823b04d4282$export$d0fd4b7106de2769() {
    let state = $7a844823b04d4282$var$useDataRouterState($7a844823b04d4282$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $7a844823b04d4282$export$600dc272ed516c15() {
    let dataRouterContext = $7a844823b04d4282$var$useDataRouterContext($7a844823b04d4282$var$DataRouterHook.UseRevalidator);
    let state = $7a844823b04d4282$var$useDataRouterState($7a844823b04d4282$var$DataRouterStateHook.UseRevalidator);
    return $kc00y.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $7a844823b04d4282$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $7a844823b04d4282$var$useDataRouterState($7a844823b04d4282$var$DataRouterStateHook.UseMatches);
    return $kc00y.useMemo(()=>matches.map((m)=>(0, $8K3mn.UNSAFE_convertRouteMatchToUiMatch)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $7a844823b04d4282$export$1448a5050d252c4d() {
    let state = $7a844823b04d4282$var$useDataRouterState($7a844823b04d4282$var$DataRouterStateHook.UseLoaderData);
    let routeId = $7a844823b04d4282$var$useCurrentRouteId($7a844823b04d4282$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $7a844823b04d4282$export$fd5d37484eab868d(routeId) {
    let state = $7a844823b04d4282$var$useDataRouterState($7a844823b04d4282$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $7a844823b04d4282$export$fdc00f3f26066d5e() {
    let state = $7a844823b04d4282$var$useDataRouterState($7a844823b04d4282$var$DataRouterStateHook.UseActionData);
    let routeId = $7a844823b04d4282$var$useCurrentRouteId($7a844823b04d4282$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $7a844823b04d4282$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $kc00y.useContext($7a844823b04d4282$var$RouteErrorContext);
    let state = $7a844823b04d4282$var$useDataRouterState($7a844823b04d4282$var$DataRouterStateHook.UseRouteError);
    let routeId = $7a844823b04d4282$var$useCurrentRouteId($7a844823b04d4282$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $7a844823b04d4282$export$78a72ddb39bdd145() {
    let value = $kc00y.useContext($7a844823b04d4282$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $7a844823b04d4282$export$17f53340677d5831() {
    let value = $kc00y.useContext($7a844823b04d4282$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $7a844823b04d4282$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $7a844823b04d4282$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $7a844823b04d4282$var$useDataRouterContext($7a844823b04d4282$var$DataRouterHook.UseBlocker);
    let state = $7a844823b04d4282$var$useDataRouterState($7a844823b04d4282$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $kc00y.useState("");
    let blockerFunction = $kc00y.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $7a844823b04d4282$var$_extends({}, currentLocation, {
                pathname: (0, $8K3mn.stripBasename)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $7a844823b04d4282$var$_extends({}, nextLocation, {
                pathname: (0, $8K3mn.stripBasename)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $kc00y.useEffect(()=>{
        let key = String(++$7a844823b04d4282$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $kc00y.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $8K3mn.IDLE_BLOCKER);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $7a844823b04d4282$var$useNavigateStable() {
    let { router: router } = $7a844823b04d4282$var$useDataRouterContext($7a844823b04d4282$var$DataRouterHook.UseNavigateStable);
    let id = $7a844823b04d4282$var$useCurrentRouteId($7a844823b04d4282$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $kc00y.useRef(false);
    $7a844823b04d4282$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $kc00y.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $7a844823b04d4282$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $7a844823b04d4282$var$alreadyWarned = {};
function $7a844823b04d4282$var$warningOnce(key, cond, message) {
    if (!cond && !$7a844823b04d4282$var$alreadyWarned[key]) $7a844823b04d4282$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $7a844823b04d4282$var$START_TRANSITION = "startTransition";
const $7a844823b04d4282$var$startTransitionImpl = $kc00y[$7a844823b04d4282$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $7a844823b04d4282$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $kc00y.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $kc00y.useCallback((newState)=>{
        if (v7_startTransition && $7a844823b04d4282$var$startTransitionImpl) $7a844823b04d4282$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $kc00y.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $kc00y.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $kc00y.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $kc00y.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $kc00y.createElement($kc00y.Fragment, null, /*#__PURE__*/ $kc00y.createElement($7a844823b04d4282$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $kc00y.createElement($7a844823b04d4282$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $kc00y.createElement($7a844823b04d4282$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $kc00y.createElement($7a844823b04d4282$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $7a844823b04d4282$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $7a844823b04d4282$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $7a844823b04d4282$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $kc00y.useRef();
    if (historyRef.current == null) historyRef.current = (0, $8K3mn.createMemoryHistory)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $kc00y.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $kc00y.useCallback((newState)=>{
        v7_startTransition && $7a844823b04d4282$var$startTransitionImpl ? $7a844823b04d4282$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $kc00y.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $kc00y.createElement($7a844823b04d4282$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $7a844823b04d4282$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$7a844823b04d4282$export$9c954a9d03d32f4a() && (0, $8K3mn.UNSAFE_invariant)(false);
    let { future: future, static: isStatic } = $kc00y.useContext($7a844823b04d4282$export$26749e8557646306);
    let { matches: matches } = $kc00y.useContext($7a844823b04d4282$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7a844823b04d4282$export$45d76561a5302f2b();
    let navigate = $7a844823b04d4282$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $8K3mn.resolveTo)(to, (0, $8K3mn.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $kc00y.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $7a844823b04d4282$export$910ae8079b2c2852(props) {
    return $7a844823b04d4282$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $7a844823b04d4282$export$e7b0ac011bb776c6(_props) {
    (0, $8K3mn.UNSAFE_invariant)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $7a844823b04d4282$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $8K3mn.Action).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$7a844823b04d4282$export$9c954a9d03d32f4a() && (0, $8K3mn.UNSAFE_invariant)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $kc00y.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $7a844823b04d4282$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $8K3mn.parsePath)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $kc00y.useMemo(()=>{
        let trailingPathname = (0, $8K3mn.stripBasename)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $kc00y.createElement($7a844823b04d4282$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $kc00y.createElement($7a844823b04d4282$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $7a844823b04d4282$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $7a844823b04d4282$export$5d3fca4a98652595($7a844823b04d4282$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $7a844823b04d4282$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $kc00y.createElement($7a844823b04d4282$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $kc00y.createElement($7a844823b04d4282$var$ResolveAwait, null, children));
}
var $7a844823b04d4282$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($7a844823b04d4282$var$AwaitRenderStatus || {});
const $7a844823b04d4282$var$neverSettledPromise = new Promise(()=>{});
class $7a844823b04d4282$var$AwaitErrorBoundary extends $kc00y.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $7a844823b04d4282$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $7a844823b04d4282$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $7a844823b04d4282$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $7a844823b04d4282$var$AwaitRenderStatus.error : "_data" in promise ? $7a844823b04d4282$var$AwaitRenderStatus.success : $7a844823b04d4282$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $7a844823b04d4282$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $7a844823b04d4282$var$AwaitRenderStatus.error && promise._error instanceof (0, $8K3mn.AbortedDeferredError)) // Freeze the UI by throwing a never resolved promise
        throw $7a844823b04d4282$var$neverSettledPromise;
        if (status === $7a844823b04d4282$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $7a844823b04d4282$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $kc00y.createElement($7a844823b04d4282$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $7a844823b04d4282$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $kc00y.createElement($7a844823b04d4282$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $7a844823b04d4282$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $7a844823b04d4282$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $kc00y.createElement($kc00y.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $7a844823b04d4282$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $kc00y.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $kc00y.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $kc00y.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $7a844823b04d4282$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $7a844823b04d4282$export$e7b0ac011bb776c6) && (0, $8K3mn.UNSAFE_invariant)(false);
        !(!element.props.index || !element.props.children) && (0, $8K3mn.UNSAFE_invariant)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $7a844823b04d4282$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $7a844823b04d4282$export$daf73786167a7f72(matches) {
    return $7a844823b04d4282$var$_renderMatches(matches);
}
function $7a844823b04d4282$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $kc00y.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $kc00y.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $kc00y.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $7a844823b04d4282$export$f30f7e456d254e83(routes, opts) {
    return (0, $8K3mn.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $7a844823b04d4282$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $8K3mn.createMemoryHistory)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $7a844823b04d4282$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}

});


parcelRegister("lpki3", function(module, exports) {

$parcel$export(module.exports, "default", () => $74f5f84c26cc1624$export$2e2bcd8739ae039);

var $cKvYK = parcelRequire("cKvYK");

var $lgiU2 = parcelRequire("lgiU2");

var $4DyxQ = parcelRequire("4DyxQ");
var $eRoc1 = parcelRequire("eRoc1");
var $469X3 = parcelRequire("469X3");

var $7hZVf = parcelRequire("7hZVf");

var $34hg0 = parcelRequire("34hg0");

var $dKs99 = parcelRequire("dKs99");

var $bNJBP = parcelRequire("bNJBP");

var $5TbRy = parcelRequire("5TbRy");

var $bYYyU = parcelRequire("bYYyU");

var $eVTM9 = parcelRequire("eVTM9");

var $hpOSz = parcelRequire("hpOSz");

var $c99Pn = parcelRequire("c99Pn");

var $2rucp = parcelRequire("2rucp");

var $8SRog = parcelRequire("8SRog");

var $dyxDa = parcelRequire("dyxDa");
const $74f5f84c26cc1624$var$Accueil = ()=>{
    return /*#__PURE__*/ (0, $cKvYK.jsxs)((0, $cKvYK.Fragment), {
        children: [
            /*#__PURE__*/ (0, $cKvYK.jsxs)("header", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($lgiU2)))("position-relative m-0 p-0", (0, (/*@__PURE__*/$parcel$interopDefault($dyxDa))).enteteAccueil),
                children: [
                    /*#__PURE__*/ (0, $cKvYK.jsxs)((0, $469X3.default), {
                        className: "pt-3 m-0",
                        children: [
                            /*#__PURE__*/ (0, $cKvYK.jsx)((0, $4DyxQ.default), {
                                xs: 12,
                                md: 8,
                                lg: 6,
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($lgiU2)))((0, (/*@__PURE__*/$parcel$interopDefault($dyxDa))).imgFameFamirea, "text-nowrap"),
                                children: /*#__PURE__*/ (0, $cKvYK.jsx)((0, $eRoc1.default), {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($dKs99))),
                                    alt: "Logos Fame et Famirea",
                                    fluid: true
                                })
                            }),
                            /*#__PURE__*/ (0, $cKvYK.jsx)((0, $4DyxQ.default), {
                                xs: "auto",
                                className: "ms-auto",
                                children: /*#__PURE__*/ (0, $cKvYK.jsxs)("a", {
                                    href: (0, $7hZVf.URLS).LOGIN,
                                    className: "btn btn-light rounded-pill text-dark d-flex align-items-center",
                                    children: [
                                        /*#__PURE__*/ (0, $cKvYK.jsx)("span", {
                                            className: "col-auto bg-primary px-3 py-2 rounded-pill align-items-center text-light fw-bold",
                                            children: /*#__PURE__*/ (0, $cKvYK.jsx)((0, $hpOSz.IconUser), {})
                                        }),
                                        /*#__PURE__*/ (0, $cKvYK.jsx)("span", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($lgiU2)))("col-auto ms-2 align-items-center text-uppercase", (0, (/*@__PURE__*/$parcel$interopDefault($dyxDa))).login),
                                            children: "CONNEXION"
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cKvYK.jsx)("section", {
                        className: "row m-0 ms-5",
                        children: /*#__PURE__*/ (0, $cKvYK.jsxs)("div", {
                            className: "col-xs-12 col-md-10 col-lg-5",
                            children: [
                                /*#__PURE__*/ (0, $cKvYK.jsx)("h1", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($lgiU2)))("text-uppercase mb-0 text-light fw-bold", (0, (/*@__PURE__*/$parcel$interopDefault($dyxDa))).titreAccueil),
                                    children: "FAME"
                                }),
                                /*#__PURE__*/ (0, $cKvYK.jsx)("p", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($lgiU2)))("text-light fs-5 mt-0 fw-bold", (0, (/*@__PURE__*/$parcel$interopDefault($dyxDa))).sousTitreAccueil),
                                    children: "Am\xe9liorer l\u2019exp\xe9rience des familles et des proches des patients hospitalis\xe9s en r\xe9animation"
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cKvYK.jsxs)((0, $bNJBP.MainContent), {
                children: [
                    /*#__PURE__*/ (0, $cKvYK.jsxs)("main", {
                        className: "mt-200",
                        children: [
                            /*#__PURE__*/ (0, $cKvYK.jsx)("section", {
                                className: "row top-0 my-3",
                                children: /*#__PURE__*/ (0, $cKvYK.jsx)("div", {
                                    className: "card rounded-5 col-xs-12 col-xl-10 mx-auto bg-light",
                                    children: /*#__PURE__*/ (0, $cKvYK.jsxs)("div", {
                                        className: "card-body m-3",
                                        children: [
                                            /*#__PURE__*/ (0, $cKvYK.jsx)("h2", {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($lgiU2)))("card-title text-primary h1 mb-5", (0, (/*@__PURE__*/$parcel$interopDefault($dyxDa))).firstCardTitle),
                                                children: "FAME : un projet du groupe Famir\xe9a"
                                            }),
                                            /*#__PURE__*/ (0, $cKvYK.jsxs)("p", {
                                                className: "my-5 fs-5 fw-lighter",
                                                children: [
                                                    "Famir\xe9a est un groupe de recherche pluridisciplinaire dont les \xe9tudes portent essentiellement sur l\u2019",
                                                    /*#__PURE__*/ (0, $cKvYK.jsx)("b", {
                                                        children: "exp\xe9rience des familles et des proches de patients hospitalis\xe9s en service de r\xe9animation"
                                                    }),
                                                    ", ainsi que celles des patients, des m\xe9decins et des soignants param\xe9dicaux."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $cKvYK.jsxs)("p", {
                                                className: "my-5 fs-5 fw-lighter",
                                                children: [
                                                    "Le groupe d\xe9veloppe une recherche pragmatique dans le but de mieux ",
                                                    /*#__PURE__*/ (0, $cKvYK.jsx)("b", {
                                                        children: "penser le soin et l\u2019accompagnement"
                                                    }),
                                                    " depuis plus de 25 ans."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $cKvYK.jsx)("p", {
                                                className: "my-5 fs-5 fw-lighter",
                                                children: "FAME est un projet de recherche port\xe9 par l\u2019Agence Nationale de la Recherche et pilot\xe9 par l\u2019Universit\xe9 Paris Cit\xe9, associant 61 services de r\xe9animation."
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $cKvYK.jsx)("section", {
                                className: "mt-5",
                                children: /*#__PURE__*/ (0, $cKvYK.jsx)("div", {
                                    className: "card col-xs-12 col-xl-10 mx-auto bg-light bg-transparent border-0",
                                    children: /*#__PURE__*/ (0, $cKvYK.jsxs)("div", {
                                        className: "row g-0",
                                        children: [
                                            /*#__PURE__*/ (0, $cKvYK.jsx)("div", {
                                                className: "col-3 me-3",
                                                children: /*#__PURE__*/ (0, $cKvYK.jsx)("img", {
                                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($8SRog))),
                                                    className: "img-fluid rounded-5 ",
                                                    alt: "..."
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $cKvYK.jsx)("div", {
                                                className: "col-md-8",
                                                children: /*#__PURE__*/ (0, $cKvYK.jsxs)("div", {
                                                    className: "card-body",
                                                    children: [
                                                        /*#__PURE__*/ (0, $cKvYK.jsx)("h5", {
                                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($lgiU2)))("card-title text-primary h1 mb-5"),
                                                            children: "Ligne d'\xe9coute Famir\xe9a"
                                                        }),
                                                        /*#__PURE__*/ (0, $cKvYK.jsxs)("p", {
                                                            className: "my-4 fs-5 fw-lighter",
                                                            children: [
                                                                "Cette ligne t\xe9l\xe9phonique nationale ",
                                                                /*#__PURE__*/ (0, $cKvYK.jsx)("b", {
                                                                    children: "gratuite"
                                                                }),
                                                                " ",
                                                                "s\u2019adresse aux",
                                                                " ",
                                                                /*#__PURE__*/ (0, $cKvYK.jsx)("b", {
                                                                    children: "proches de patients hospitalis\xe9s ou ayant \xe9t\xe9 hospitalis\xe9s en r\xe9animation"
                                                                }),
                                                                "."
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $cKvYK.jsxs)("p", {
                                                            className: "my-4 fs-5 fw-lighter",
                                                            children: [
                                                                "Elle a pour vocation de proposer une \xe9coute",
                                                                " ",
                                                                /*#__PURE__*/ (0, $cKvYK.jsx)("b", {
                                                                    children: "active et bienveillante"
                                                                }),
                                                                "."
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $cKvYK.jsx)("div", {
                                                            className: "" /*styles.secondCardPhoneDiv*/ ,
                                                            children: /*#__PURE__*/ (0, $cKvYK.jsx)((0, $eVTM9.default), {})
                                                        }),
                                                        /*#__PURE__*/ (0, $cKvYK.jsxs)("p", {
                                                            className: "my-4 fs-5 fw-lighter",
                                                            children: [
                                                                "Vous \xeates un proche de patient hospitalis\xe9 ou ayant \xe9t\xe9 hospitalis\xe9 en r\xe9animation ?",
                                                                " ",
                                                                /*#__PURE__*/ (0, $cKvYK.jsx)("b", {
                                                                    children: "N\u2019h\xe9sitez pas \xe0 appeler si vous avez besoin !"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $cKvYK.jsx)("section", {
                                className: "row mt-5",
                                children: /*#__PURE__*/ (0, $cKvYK.jsx)("div", {
                                    className: "card rounded-5 col-xs-12 col-xl-10 mx-auto bg-light",
                                    children: /*#__PURE__*/ (0, $cKvYK.jsxs)("div", {
                                        className: "card-body m-3",
                                        children: [
                                            /*#__PURE__*/ (0, $cKvYK.jsx)("h2", {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($lgiU2)))("card-title text-primary h1 mb-5 text-center"),
                                                children: "Consultez le livret d'accueil Famir\xe9a"
                                            }),
                                            /*#__PURE__*/ (0, $cKvYK.jsx)((0, $2rucp.default), {}),
                                            /*#__PURE__*/ (0, $cKvYK.jsx)("div", {
                                                className: "text-center mt-2",
                                                children: /*#__PURE__*/ (0, $cKvYK.jsxs)((0, $bYYyU.LinkButton), {
                                                    variant: (0, $bYYyU.VARIANTS).secondary,
                                                    href: (0, $5TbRy.default)`/api/public/ressource/telecharger-ressource/` + (0, $c99Pn.CodeLivretAccueil),
                                                    children: [
                                                        "T\xe9l\xe9charger le livret d'accueil ",
                                                        /*#__PURE__*/ (0, $cKvYK.jsx)((0, $hpOSz.IconFileDownload), {})
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cKvYK.jsx)((0, $34hg0.default), {})
                ]
            })
        ]
    });
};
var $74f5f84c26cc1624$export$2e2bcd8739ae039 = $74f5f84c26cc1624$var$Accueil;

});
parcelRegister("lgiU2", function(module, exports) {
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    "use strict";
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = "";
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === "string" || typeof arg === "number") return arg;
        if (typeof arg !== "object") return "";
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) return arg.toString();
        var classes = "";
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + " " + newClass;
        return value + newClass;
    }
    if (0, module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) // register as 'classnames', consistent with npm package name
    define("classnames", [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

});

parcelRegister("4DyxQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $360599dc87384838$export$2e2bcd8739ae039);

var $lgiU2 = parcelRequire("lgiU2");

var $kc00y = parcelRequire("kc00y");

var $9i3wr = parcelRequire("9i3wr");

var $cKvYK = parcelRequire("cKvYK");
"use client";
function $360599dc87384838$export$2ed43d61a0a9f5a3({ as: as, bsPrefix: bsPrefix, className: className, ...props }) {
    bsPrefix = (0, $9i3wr.useBootstrapPrefix)(bsPrefix, "col");
    const breakpoints = (0, $9i3wr.useBootstrapBreakpoints)();
    const minBreakpoint = (0, $9i3wr.useBootstrapMinBreakpoint)();
    const spans = [];
    const classes = [];
    breakpoints.forEach((brkPoint)=>{
        const propValue = props[brkPoint];
        delete props[brkPoint];
        let span;
        let offset;
        let order;
        if (typeof propValue === "object" && propValue != null) ({ span: span, offset: offset, order: order } = propValue);
        else span = propValue;
        const infix = brkPoint !== minBreakpoint ? `-${brkPoint}` : "";
        if (span) spans.push(span === true ? `${bsPrefix}${infix}` : `${bsPrefix}${infix}-${span}`);
        if (order != null) classes.push(`order${infix}-${order}`);
        if (offset != null) classes.push(`offset${infix}-${offset}`);
    });
    return [
        {
            ...props,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($lgiU2)))(className, ...spans, ...classes)
        },
        {
            as: as,
            bsPrefix: bsPrefix,
            spans: spans
        }
    ];
}
const $360599dc87384838$var$Col = /*#__PURE__*/ $kc00y.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
(props, ref)=>{
    const [{ className: className, ...colProps }, { as: Component = "div", bsPrefix: bsPrefix, spans: spans }] = $360599dc87384838$export$2ed43d61a0a9f5a3(props);
    return /*#__PURE__*/ (0, $cKvYK.jsx)(Component, {
        ...colProps,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($lgiU2)))(className, !spans.length && bsPrefix)
    });
});
$360599dc87384838$var$Col.displayName = "Col";
var $360599dc87384838$export$2e2bcd8739ae039 = $360599dc87384838$var$Col;

});
parcelRegister("9i3wr", function(module, exports) {

$parcel$export(module.exports, "useBootstrapPrefix", () => $6c3886f519efe212$export$7f387860ebffb32c);
$parcel$export(module.exports, "useBootstrapBreakpoints", () => $6c3886f519efe212$export$8970c8db816a5863);
$parcel$export(module.exports, "useBootstrapMinBreakpoint", () => $6c3886f519efe212$export$d926d6ef38f3fd32);
$parcel$export(module.exports, "useIsRTL", () => $6c3886f519efe212$export$35e511eefa30ac5a);

var $kc00y = parcelRequire("kc00y");

var $cKvYK = parcelRequire("cKvYK");
"use client";
const $6c3886f519efe212$export$666ad80b5007f835 = [
    "xxl",
    "xl",
    "lg",
    "md",
    "sm",
    "xs"
];
const $6c3886f519efe212$export$ff817e17bad2e091 = "xs";
const $6c3886f519efe212$var$ThemeContext = /*#__PURE__*/ $kc00y.createContext({
    prefixes: {},
    breakpoints: $6c3886f519efe212$export$666ad80b5007f835,
    minBreakpoint: $6c3886f519efe212$export$ff817e17bad2e091
});
const { Consumer: $6c3886f519efe212$export$b631efc24e9d5e2f, Provider: $6c3886f519efe212$var$Provider } = $6c3886f519efe212$var$ThemeContext;
function $6c3886f519efe212$var$ThemeProvider({ prefixes: prefixes = {}, breakpoints: breakpoints = $6c3886f519efe212$export$666ad80b5007f835, minBreakpoint: minBreakpoint = $6c3886f519efe212$export$ff817e17bad2e091, dir: dir, children: children }) {
    const contextValue = (0, $kc00y.useMemo)(()=>({
            prefixes: {
                ...prefixes
            },
            breakpoints: breakpoints,
            minBreakpoint: minBreakpoint,
            dir: dir
        }), [
        prefixes,
        breakpoints,
        minBreakpoint,
        dir
    ]);
    return /*#__PURE__*/ (0, $cKvYK.jsx)($6c3886f519efe212$var$Provider, {
        value: contextValue,
        children: children
    });
}
function $6c3886f519efe212$export$7f387860ebffb32c(prefix, defaultPrefix) {
    const { prefixes: prefixes } = (0, $kc00y.useContext)($6c3886f519efe212$var$ThemeContext);
    return prefix || prefixes[defaultPrefix] || defaultPrefix;
}
function $6c3886f519efe212$export$8970c8db816a5863() {
    const { breakpoints: breakpoints } = (0, $kc00y.useContext)($6c3886f519efe212$var$ThemeContext);
    return breakpoints;
}
function $6c3886f519efe212$export$d926d6ef38f3fd32() {
    const { minBreakpoint: minBreakpoint } = (0, $kc00y.useContext)($6c3886f519efe212$var$ThemeContext);
    return minBreakpoint;
}
function $6c3886f519efe212$export$35e511eefa30ac5a() {
    const { dir: dir } = (0, $kc00y.useContext)($6c3886f519efe212$var$ThemeContext);
    return dir === "rtl";
}
function $6c3886f519efe212$export$ce75053c20498f85(Component, opts) {
    if (typeof opts === "string") opts = {
        prefix: opts
    };
    const isClassy = Component.prototype && Component.prototype.isReactComponent;
    // If it's a functional component make sure we don't break it with a ref
    const { prefix: prefix, forwardRefAs: forwardRefAs = isClassy ? "ref" : "innerRef" } = opts;
    const Wrapped = /*#__PURE__*/ $kc00y.forwardRef(({ ...props }, ref)=>{
        props[forwardRefAs] = ref;
        const bsPrefix = $6c3886f519efe212$export$7f387860ebffb32c(props.bsPrefix, prefix);
        return /*#__PURE__*/ (0, $cKvYK.jsx)(Component, {
            ...props,
            bsPrefix: bsPrefix
        });
    });
    Wrapped.displayName = `Bootstrap(${Component.displayName || Component.name})`;
    return Wrapped;
}
var $6c3886f519efe212$export$2e2bcd8739ae039 = $6c3886f519efe212$var$ThemeProvider;

});


parcelRegister("eRoc1", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad18c81fdcf37de8$export$2e2bcd8739ae039);

var $lgiU2 = parcelRequire("lgiU2");

var $kc00y = parcelRequire("kc00y");

var $lCkAA = parcelRequire("lCkAA");

var $9i3wr = parcelRequire("9i3wr");

var $cKvYK = parcelRequire("cKvYK");
"use client";
const $ad18c81fdcf37de8$export$513805011eaa4892 = {
    /**
   * @default 'img'
   */ bsPrefix: (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).string,
    /**
   * Sets image as fluid image.
   */ fluid: (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).bool,
    /**
   * Sets image shape as rounded.
   */ rounded: (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).bool,
    /**
   * Sets image shape as circle.
   */ roundedCircle: (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).bool,
    /**
   * Sets image shape as thumbnail.
   */ thumbnail: (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).bool
};
const $ad18c81fdcf37de8$var$Image = /*#__PURE__*/ $kc00y.forwardRef(({ bsPrefix: bsPrefix, className: className, fluid: fluid = false, rounded: rounded = false, roundedCircle: roundedCircle = false, thumbnail: thumbnail = false, ...props }, ref)=>{
    bsPrefix = (0, $9i3wr.useBootstrapPrefix)(bsPrefix, "img");
    return /*#__PURE__*/ (0, $cKvYK.jsx)("img", {
        // eslint-disable-line jsx-a11y/alt-text
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($lgiU2)))(className, fluid && `${bsPrefix}-fluid`, rounded && `rounded`, roundedCircle && `rounded-circle`, thumbnail && `${bsPrefix}-thumbnail`)
    });
});
$ad18c81fdcf37de8$var$Image.displayName = "Image";
var $ad18c81fdcf37de8$export$2e2bcd8739ae039 = $ad18c81fdcf37de8$var$Image;

});
parcelRegister("lCkAA", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $fbcd1e202f3ef7b1$var$ReactIs, $fbcd1e202f3ef7b1$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("d6I2y"))();

});
parcelRegister("d6I2y", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $kB96d = parcelRequire("kB96d");
function $98adff6187843a95$var$emptyFunction() {}
function $98adff6187843a95$var$emptyFunctionWithReset() {}
$98adff6187843a95$var$emptyFunctionWithReset.resetWarningCache = $98adff6187843a95$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $kB96d) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $98adff6187843a95$var$emptyFunctionWithReset,
        resetWarningCache: $98adff6187843a95$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("kB96d", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $efee5244184ba86e$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $efee5244184ba86e$var$ReactPropTypesSecret;

});




parcelRegister("469X3", function(module, exports) {

$parcel$export(module.exports, "default", () => $2fbf711edf8913b6$export$2e2bcd8739ae039);

var $lgiU2 = parcelRequire("lgiU2");

var $kc00y = parcelRequire("kc00y");

var $9i3wr = parcelRequire("9i3wr");

var $cKvYK = parcelRequire("cKvYK");
"use client";
const $2fbf711edf8913b6$var$Row = /*#__PURE__*/ $kc00y.forwardRef(({ bsPrefix: bsPrefix, className: className, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = "div", ...props }, ref)=>{
    const decoratedBsPrefix = (0, $9i3wr.useBootstrapPrefix)(bsPrefix, "row");
    const breakpoints = (0, $9i3wr.useBootstrapBreakpoints)();
    const minBreakpoint = (0, $9i3wr.useBootstrapMinBreakpoint)();
    const sizePrefix = `${decoratedBsPrefix}-cols`;
    const classes = [];
    breakpoints.forEach((brkPoint)=>{
        const propValue = props[brkPoint];
        delete props[brkPoint];
        let cols;
        if (propValue != null && typeof propValue === "object") ({ cols: cols } = propValue);
        else cols = propValue;
        const infix = brkPoint !== minBreakpoint ? `-${brkPoint}` : "";
        if (cols != null) classes.push(`${sizePrefix}${infix}-${cols}`);
    });
    return /*#__PURE__*/ (0, $cKvYK.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($lgiU2)))(className, decoratedBsPrefix, ...classes)
    });
});
$2fbf711edf8913b6$var$Row.displayName = "Row";
var $2fbf711edf8913b6$export$2e2bcd8739ae039 = $2fbf711edf8913b6$var$Row;

});

parcelRegister("7hZVf", function(module, exports) {

$parcel$export(module.exports, "URLS", () => $7277c164f7dba85c$export$2389c26b9ec125dd);
$parcel$export(module.exports, "default", () => $7277c164f7dba85c$export$2e2bcd8739ae039);

var $cKvYK = parcelRequire("cKvYK");

var $ieSl5 = parcelRequire("ieSl5");

var $fnLqW = parcelRequire("fnLqW");

var $5TbRy = parcelRequire("5TbRy");

var $23K7B = parcelRequire("23K7B");

var $gJLDH = parcelRequire("gJLDH");

var $3fKb9 = parcelRequire("3fKb9");

var $foRY0 = parcelRequire("foRY0");

var $9dFAr = parcelRequire("9dFAr");

var $2ezz3 = parcelRequire("2ezz3");

var $lpki3 = parcelRequire("lpki3");

var $bZlx0 = parcelRequire("bZlx0");
const $7277c164f7dba85c$export$2389c26b9ec125dd = {
    ACCUEIL_PRIVE: (0, $5TbRy.default)`/app`,
    LOGIN: (0, $5TbRy.urlAuthent)("/"),
    LOGOUT: (0, $5TbRy.default)`/logout`,
    GESTION_CONTENUS: (0, $5TbRy.urlAuthent)("/gestion_contenus"),
    GESTION_UTILISATEURS: (0, $5TbRy.urlAuthent)("/gestion_utilisateurs"),
    EXPORT_DATA: (0, $5TbRy.urlAuthent)("/export_data"),
    IMPORT_UTILISATEUR: (0, $5TbRy.urlAuthent)("/import-utilisateurs"),
    UPDATE_ROLE_UTILISATEUR: (utilisateurId)=>(0, $5TbRy.urlAuthent)("/gestion_utilisateurs/" + utilisateurId),
    CREATE_ROLE_UTILISATEUR: (0, $5TbRy.urlAuthent)("/gestion_utilisateurs/create"),
    WEBGL: (0, $5TbRy.default)`/webgl/`
};
var $7277c164f7dba85c$export$2e2bcd8739ae039 = [
    {
        path: "/",
        element: /*#__PURE__*/ (0, $cKvYK.jsx)((0, $fnLqW.Authorization), {
            Component: (0, $lpki3.default),
            isPublic: true
        })
    },
    {
        path: "/app/",
        element: /*#__PURE__*/ (0, $cKvYK.jsx)((0, $fnLqW.Authorization), {
            Component: (0, $bZlx0.default),
            roles: [
                (0, $fnLqW.ADMINISTRATEUR),
                (0, $fnLqW.PROCHE)
            ]
        })
    },
    {
        path: "/app/gestion_contenus",
        element: /*#__PURE__*/ (0, $cKvYK.jsx)((0, $fnLqW.Authorization), {
            Component: (0, $3fKb9.default),
            roles: [
                (0, $fnLqW.ADMINISTRATEUR)
            ]
        })
    },
    {
        path: "/app/import-utilisateurs",
        element: /*#__PURE__*/ (0, $cKvYK.jsx)((0, $fnLqW.Authorization), {
            Component: (0, $gJLDH.default),
            roles: [
                (0, $fnLqW.ADMINISTRATEUR)
            ]
        })
    },
    {
        path: "/app/gestion_utilisateurs",
        element: /*#__PURE__*/ (0, $cKvYK.jsx)((0, $fnLqW.Authorization), {
            Component: (0, $foRY0.default),
            roles: [
                (0, $fnLqW.ADMINISTRATEUR)
            ]
        })
    },
    {
        path: "/app/gestion_utilisateurs/:utilisateurId",
        element: /*#__PURE__*/ (0, $cKvYK.jsx)((0, $fnLqW.Authorization), {
            Component: (0, $9dFAr.default),
            roles: [
                (0, $fnLqW.ADMINISTRATEUR)
            ]
        })
    },
    {
        path: "/app/gestion_utilisateurs/create",
        element: /*#__PURE__*/ (0, $cKvYK.jsx)((0, $fnLqW.Authorization), {
            Component: (0, $23K7B.default),
            roles: [
                (0, $fnLqW.ADMINISTRATEUR)
            ]
        })
    },
    {
        path: "/app/export_data",
        element: /*#__PURE__*/ (0, $cKvYK.jsx)((0, $fnLqW.Authorization), {
            Component: (0, $2ezz3.default),
            roles: [
                (0, $fnLqW.ADMINISTRATEUR)
            ]
        })
    },
    {
        path: "*",
        element: /*#__PURE__*/ (0, $cKvYK.jsx)((0, $ieSl5.default), {})
    }
];

});
parcelRegister("ieSl5", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ea9733b3f64ac5d$export$2e2bcd8739ae039);

var $cKvYK = parcelRequire("cKvYK");

var $bNJBP = parcelRequire("bNJBP");
const $5ea9733b3f64ac5d$var$NoMatch = ()=>{
    return /*#__PURE__*/ (0, $cKvYK.jsx)((0, $bNJBP.PageContent), {
        children: "La page que vous demandez n'a pas \xe9t\xe9 trouv\xe9e."
    });
};
var $5ea9733b3f64ac5d$export$2e2bcd8739ae039 = $5ea9733b3f64ac5d$var$NoMatch;

});
parcelRegister("bNJBP", function(module, exports) {

$parcel$export(module.exports, "makeTemplateComponent", () => $951ae2bf3e7ffc25$export$f4e7c40a055e6303);
$parcel$export(module.exports, "MainContainer", () => $951ae2bf3e7ffc25$export$d653589df987fd93);
$parcel$export(module.exports, "PageContainer", () => $951ae2bf3e7ffc25$export$5f86df0ee0a255b5);
$parcel$export(module.exports, "PageContent", () => $951ae2bf3e7ffc25$export$16800ac069904dff);
$parcel$export(module.exports, "PageContentFluid", () => $951ae2bf3e7ffc25$export$3db2297b5e846201);
$parcel$export(module.exports, "MainContent", () => $951ae2bf3e7ffc25$export$5c0547b091a4b556);
$parcel$export(module.exports, "ActionBar", () => $951ae2bf3e7ffc25$export$e213cebad6250b4a);
$parcel$export(module.exports, "ScrollWrapper", () => $951ae2bf3e7ffc25$export$e10b307be3c4e310);

var $cKvYK = parcelRequire("cKvYK");

var $lgiU2 = parcelRequire("lgiU2");

var $f0w9z = parcelRequire("f0w9z");
function $951ae2bf3e7ffc25$export$f4e7c40a055e6303(TagName, ...supClass) {
    const component = ({ className: className, children: children, ...rest })=>/*#__PURE__*/ (0, $cKvYK.jsx)(TagName, {
            ...rest,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($lgiU2)))(className, supClass),
            children: children
        });
    component.displayName = TagName;
    return component;
}
const $951ae2bf3e7ffc25$export$d653589df987fd93 = $951ae2bf3e7ffc25$export$f4e7c40a055e6303("div", (0, (/*@__PURE__*/$parcel$interopDefault($lgiU2)))("container-fluid p-0 m-0", (0, (/*@__PURE__*/$parcel$interopDefault($f0w9z))).mainContainer));
const $951ae2bf3e7ffc25$export$9d1b863724db83e7 = $951ae2bf3e7ffc25$export$f4e7c40a055e6303("div", (0, (/*@__PURE__*/$parcel$interopDefault($lgiU2)))((0, (/*@__PURE__*/$parcel$interopDefault($f0w9z))).adminContainer, "containvh-100 vw-100"));
const $951ae2bf3e7ffc25$export$55d2d5b64bfe8d2d = $951ae2bf3e7ffc25$export$f4e7c40a055e6303("main", (0, (/*@__PURE__*/$parcel$interopDefault($lgiU2)))((0, (/*@__PURE__*/$parcel$interopDefault($f0w9z))).adminContent, "rounded-5"));
const $951ae2bf3e7ffc25$export$5f86df0ee0a255b5 = $951ae2bf3e7ffc25$export$f4e7c40a055e6303("div", "");
const $951ae2bf3e7ffc25$export$16800ac069904dff = $951ae2bf3e7ffc25$export$f4e7c40a055e6303("main", (0, (/*@__PURE__*/$parcel$interopDefault($lgiU2)))("container col-12"));
const $951ae2bf3e7ffc25$export$3db2297b5e846201 = $951ae2bf3e7ffc25$export$f4e7c40a055e6303("main", (0, (/*@__PURE__*/$parcel$interopDefault($lgiU2)))("container-fluid col-12 m-0 p-0"));
const $951ae2bf3e7ffc25$export$5c0547b091a4b556 = $951ae2bf3e7ffc25$export$f4e7c40a055e6303("div", "container-fluid position-relative");
const $951ae2bf3e7ffc25$export$b59bdbef9ce70de2 = $951ae2bf3e7ffc25$export$f4e7c40a055e6303("div", (0, (/*@__PURE__*/$parcel$interopDefault($f0w9z))).row);
const $951ae2bf3e7ffc25$export$e213cebad6250b4a = $951ae2bf3e7ffc25$export$f4e7c40a055e6303("div", (0, (/*@__PURE__*/$parcel$interopDefault($f0w9z))).actionBar);
const $951ae2bf3e7ffc25$export$e10b307be3c4e310 = $951ae2bf3e7ffc25$export$f4e7c40a055e6303("div", "");

});
parcelRegister("f0w9z", function(module, exports) {

$parcel$export(module.exports, "adminContent", () => $aecfcc1d7dbe7fc1$export$814bbb57e5405022, (v) => $aecfcc1d7dbe7fc1$export$814bbb57e5405022 = v);
$parcel$export(module.exports, "mainContainer", () => $aecfcc1d7dbe7fc1$export$eccb60d5692f3f7d, (v) => $aecfcc1d7dbe7fc1$export$eccb60d5692f3f7d = v);
var $aecfcc1d7dbe7fc1$export$814bbb57e5405022;
var $aecfcc1d7dbe7fc1$export$eccb60d5692f3f7d;
$aecfcc1d7dbe7fc1$export$814bbb57e5405022 = `BLwvjW_adminContent`;
$aecfcc1d7dbe7fc1$export$eccb60d5692f3f7d = `BLwvjW_mainContainer`;

});



parcelRegister("fnLqW", function(module, exports) {

$parcel$export(module.exports, "ADMINISTRATEUR", () => $7ffecab0245b8ae8$export$e4d0ac0ad552b03);
$parcel$export(module.exports, "PROCHE", () => $7ffecab0245b8ae8$export$888da087a0e7801b);
$parcel$export(module.exports, "Authorization", () => $7ffecab0245b8ae8$export$552522b64eb5db81);

var $cKvYK = parcelRequire("cKvYK");

var $eqMOn = parcelRequire("eqMOn");
const $7ffecab0245b8ae8$export$e4d0ac0ad552b03 = "ADMINISTRATEUR";
const $7ffecab0245b8ae8$export$888da087a0e7801b = "PROCHE";
const $7ffecab0245b8ae8$export$7c870aeee5dc195c = "PROCHE_BD";
const $7ffecab0245b8ae8$export$d8ccbbe9187346e0 = "PROCHE_CAPSULES_VIDEO";
const $7ffecab0245b8ae8$export$1f9b77e307546b2b = "PROCHE_FIN_DE_VIE";
const $7ffecab0245b8ae8$export$14263e3e1689aa86 = "PROCHE_REALITE_VIRTUELLE";
const $7ffecab0245b8ae8$export$8622bb04f9e78f51 = "PROCHE_SOIGNANT";
const $7ffecab0245b8ae8$export$552522b64eb5db81 = ({ Component: Component, roles: roles, isPublic: isPublic = false }, props)=>{
    const { user: user } = (0, $eqMOn.useAppContext)();
    if (isPublic || user && $7ffecab0245b8ae8$var$isAuthorized(user, roles ?? [])) return /*#__PURE__*/ (0, $cKvYK.jsx)(Component, {
        ...props
    });
    return /*#__PURE__*/ (0, $cKvYK.jsx)($7ffecab0245b8ae8$var$Forbidden, {});
};
function $7ffecab0245b8ae8$var$isAuthorized(user, roles) {
    return roles.some((role)=>$7ffecab0245b8ae8$var$hasDroit(user, role));
}
function $7ffecab0245b8ae8$var$hasDroit(user, droit) {
    switch(droit){
        case $7ffecab0245b8ae8$export$e4d0ac0ad552b03:
            return user.isAdministrateur;
        case $7ffecab0245b8ae8$export$888da087a0e7801b:
            return user.isProche;
        case $7ffecab0245b8ae8$export$7c870aeee5dc195c:
            return user.isProcheBd;
        case $7ffecab0245b8ae8$export$d8ccbbe9187346e0:
            return user.isProcheCapsulesVideo;
        case $7ffecab0245b8ae8$export$1f9b77e307546b2b:
            return user.isProcheFinDeVie;
        case $7ffecab0245b8ae8$export$14263e3e1689aa86:
            return user.isProcheRealiteVirtuelle;
        case $7ffecab0245b8ae8$export$8622bb04f9e78f51:
            return user.isProcheSoignant;
        default:
            return false;
    }
}
function $7ffecab0245b8ae8$export$b1f192991093f8f0() {
    const { user: user } = (0, $eqMOn.useAppContext)();
    return {
        isAdministrateur: user?.isAdministrateur,
        isProche: user?.isProche,
        isProcheBd: user?.isProcheBd,
        isProcheCapsulesVideo: user?.isProcheCapsulesVideo,
        isProcheFinDeVie: user?.isProcheFinDeVie,
        isProcheRealiteVirtuelle: user?.isProcheRealiteVirtuelle,
        isProcheSoignant: user?.isProcheSoignant
    };
}
const $7ffecab0245b8ae8$var$Forbidden = ()=>{
    return /*#__PURE__*/ (0, $cKvYK.jsx)("div", {
        children: "Vous n'avez pas le droit d'acc\xe9der \xe0 cette page"
    });
};

});
parcelRegister("eqMOn", function(module, exports) {

$parcel$export(module.exports, "useAppContext", () => $176124a9d7d47a36$export$fdc397e486fa83e7);
$parcel$export(module.exports, "AppProvider", () => $176124a9d7d47a36$export$c7dacf3845253dcf);
/*global userInfo */ 
var $cKvYK = parcelRequire("cKvYK");

var $kc00y = parcelRequire("kc00y");

var $lCkAA = parcelRequire("lCkAA");
const $176124a9d7d47a36$var$AppContext = /*#__PURE__*/ (0, $kc00y.createContext)({});
const $176124a9d7d47a36$export$fdc397e486fa83e7 = ()=>{
    return (0, $kc00y.useContext)($176124a9d7d47a36$var$AppContext);
};
const $176124a9d7d47a36$export$c7dacf3845253dcf = ({ children: children })=>{
    return /*#__PURE__*/ (0, $cKvYK.jsx)($176124a9d7d47a36$var$AppContext.Provider, {
        value: {
            user: userInfo
        },
        children: children
    });
};
$176124a9d7d47a36$export$c7dacf3845253dcf.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).node
};

});


parcelRegister("5TbRy", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2b69e0f45866860$export$2e2bcd8739ae039);
$parcel$export(module.exports, "getFetchOptions", () => $c2b69e0f45866860$export$b163ec2f884327db);
$parcel$export(module.exports, "urlAuthent", () => $c2b69e0f45866860$export$ed349f51390e857a);

var $bVTfY = parcelRequire("bVTfY");
// Keep in sync with csrf.kt
const $c2b69e0f45866860$var$csrfTokenHeaderName = "X-XTok";
const $c2b69e0f45866860$var$csrfCookieName = location.protocol === "https:" ? "__Host-xt" : "xt";
function $c2b69e0f45866860$var$getCsrfTokenFromCookie(cookie) {
    return (0, $bVTfY.parse)(cookie)[$c2b69e0f45866860$var$csrfCookieName];
}
let $c2b69e0f45866860$var$oldCookie = document.cookie;
let $c2b69e0f45866860$var$csrfToken = $c2b69e0f45866860$var$getCsrfTokenFromCookie($c2b69e0f45866860$var$oldCookie);
function $c2b69e0f45866860$var$getCsrfToken() {
    const cookie = document.cookie;
    if (cookie !== $c2b69e0f45866860$var$oldCookie) {
        $c2b69e0f45866860$var$csrfToken = $c2b69e0f45866860$var$getCsrfTokenFromCookie(cookie);
        $c2b69e0f45866860$var$oldCookie = cookie;
    }
    return $c2b69e0f45866860$var$csrfToken;
}
function $c2b69e0f45866860$var$filterParams(obj) {
    return Object.entries(obj).filter((e)=>e[1] != null).map((v)=>typeof v[1] == "object" ? [
            v[0],
            JSON.stringify(v[1])
        ] : v);
}
function $c2b69e0f45866860$export$2e2bcd8739ae039(strings, ...values) {
    return strings.slice(1).reduce((res, string, i)=>{
        const value = values[i];
        if (typeof value == "object") res += decodeURIComponent((value instanceof URLSearchParams ? value : new URLSearchParams($c2b69e0f45866860$var$filterParams(value))).toString());
        else res += encodeURI(value);
        res = res.concat(string);
        return res;
    }, strings[0]);
}
function $c2b69e0f45866860$export$b163ec2f884327db(options = {}) {
    return {
        ...options,
        credentials: "same-origin",
        headers: {
            Accept: "*/*",
            ...options.headers,
            [$c2b69e0f45866860$var$csrfTokenHeaderName]: $c2b69e0f45866860$var$getCsrfToken()
        }
    };
}
function $c2b69e0f45866860$export$ed349f51390e857a(path, ...searchParams) {
    const pathUrl = "/app" + path;
    return searchParams.length > 0 ? $c2b69e0f45866860$export$2e2bcd8739ae039`` + pathUrl + `?${{
        ...searchParams
    }}` : $c2b69e0f45866860$export$2e2bcd8739ae039`` + pathUrl + ``;
}

});
parcelRegister("bVTfY", function(module, exports) {

$parcel$export(module.exports, "parse", () => $8affe1658947e678$export$98e6a39c04603d36, (v) => $8affe1658947e678$export$98e6a39c04603d36 = v);
/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */ /**
 * Module exports.
 * @public
 */ var $8affe1658947e678$export$98e6a39c04603d36;
var $8affe1658947e678$export$dfdc1655ccc5b9cb;
"use strict";
$8affe1658947e678$export$98e6a39c04603d36 = $8affe1658947e678$var$parse;
$8affe1658947e678$export$dfdc1655ccc5b9cb = $8affe1658947e678$var$serialize;
/**
 * Module variables.
 * @private
 */ var $8affe1658947e678$var$__toString = Object.prototype.toString;
/**
 * RegExp to match field-content in RFC 7230 sec 3.2
 *
 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
 * field-vchar   = VCHAR / obs-text
 * obs-text      = %x80-FF
 */ var $8affe1658947e678$var$fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 *
 * @param {string} str
 * @param {object} [options]
 * @return {object}
 * @public
 */ function $8affe1658947e678$var$parse(str, options) {
    if (typeof str !== "string") throw new TypeError("argument str must be a string");
    var obj = {};
    var opt = options || {};
    var dec = opt.decode || $8affe1658947e678$var$decode;
    var index = 0;
    while(index < str.length){
        var eqIdx = str.indexOf("=", index);
        // no more cookie pairs
        if (eqIdx === -1) break;
        var endIdx = str.indexOf(";", index);
        if (endIdx === -1) endIdx = str.length;
        else if (endIdx < eqIdx) {
            // backtrack on prior semicolon
            index = str.lastIndexOf(";", eqIdx - 1) + 1;
            continue;
        }
        var key = str.slice(index, eqIdx).trim();
        // only assign once
        if (undefined === obj[key]) {
            var val = str.slice(eqIdx + 1, endIdx).trim();
            // quoted values
            if (val.charCodeAt(0) === 0x22) val = val.slice(1, -1);
            obj[key] = $8affe1658947e678$var$tryDecode(val, dec);
        }
        index = endIdx + 1;
    }
    return obj;
}
/**
 * Serialize data into a cookie header.
 *
 * Serialize the a name value pair into a cookie string suitable for
 * http headers. An optional options object specified cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 *
 * @param {string} name
 * @param {string} val
 * @param {object} [options]
 * @return {string}
 * @public
 */ function $8affe1658947e678$var$serialize(name, val, options) {
    var opt = options || {};
    var enc = opt.encode || $8affe1658947e678$var$encode;
    if (typeof enc !== "function") throw new TypeError("option encode is invalid");
    if (!$8affe1658947e678$var$fieldContentRegExp.test(name)) throw new TypeError("argument name is invalid");
    var value = enc(val);
    if (value && !$8affe1658947e678$var$fieldContentRegExp.test(value)) throw new TypeError("argument val is invalid");
    var str = name + "=" + value;
    if (null != opt.maxAge) {
        var maxAge = opt.maxAge - 0;
        if (isNaN(maxAge) || !isFinite(maxAge)) throw new TypeError("option maxAge is invalid");
        str += "; Max-Age=" + Math.floor(maxAge);
    }
    if (opt.domain) {
        if (!$8affe1658947e678$var$fieldContentRegExp.test(opt.domain)) throw new TypeError("option domain is invalid");
        str += "; Domain=" + opt.domain;
    }
    if (opt.path) {
        if (!$8affe1658947e678$var$fieldContentRegExp.test(opt.path)) throw new TypeError("option path is invalid");
        str += "; Path=" + opt.path;
    }
    if (opt.expires) {
        var expires = opt.expires;
        if (!$8affe1658947e678$var$isDate(expires) || isNaN(expires.valueOf())) throw new TypeError("option expires is invalid");
        str += "; Expires=" + expires.toUTCString();
    }
    if (opt.httpOnly) str += "; HttpOnly";
    if (opt.secure) str += "; Secure";
    if (opt.partitioned) str += "; Partitioned";
    if (opt.priority) {
        var priority = typeof opt.priority === "string" ? opt.priority.toLowerCase() : opt.priority;
        switch(priority){
            case "low":
                str += "; Priority=Low";
                break;
            case "medium":
                str += "; Priority=Medium";
                break;
            case "high":
                str += "; Priority=High";
                break;
            default:
                throw new TypeError("option priority is invalid");
        }
    }
    if (opt.sameSite) {
        var sameSite = typeof opt.sameSite === "string" ? opt.sameSite.toLowerCase() : opt.sameSite;
        switch(sameSite){
            case true:
                str += "; SameSite=Strict";
                break;
            case "lax":
                str += "; SameSite=Lax";
                break;
            case "strict":
                str += "; SameSite=Strict";
                break;
            case "none":
                str += "; SameSite=None";
                break;
            default:
                throw new TypeError("option sameSite is invalid");
        }
    }
    return str;
}
/**
 * URL-decode string value. Optimized to skip native call when no %.
 *
 * @param {string} str
 * @returns {string}
 */ function $8affe1658947e678$var$decode(str) {
    return str.indexOf("%") !== -1 ? decodeURIComponent(str) : str;
}
/**
 * URL-encode value.
 *
 * @param {string} val
 * @returns {string}
 */ function $8affe1658947e678$var$encode(val) {
    return encodeURIComponent(val);
}
/**
 * Determine if value is a Date.
 *
 * @param {*} val
 * @private
 */ function $8affe1658947e678$var$isDate(val) {
    return $8affe1658947e678$var$__toString.call(val) === "[object Date]" || val instanceof Date;
}
/**
 * Try decoding a string using a decoding function.
 *
 * @param {string} str
 * @param {function} decode
 * @private
 */ function $8affe1658947e678$var$tryDecode(str, decode) {
    try {
        return decode(str);
    } catch (e) {
        return str;
    }
}

});


parcelRegister("23K7B", function(module, exports) {

$parcel$export(module.exports, "default", () => $10395dfc29b9df04$export$2e2bcd8739ae039);

var $cKvYK = parcelRequire("cKvYK");

var $ijxZJ = parcelRequire("ijxZJ");

var $gS6pX = parcelRequire("gS6pX");
const $10395dfc29b9df04$var$CreateRoleUtilisateur = ()=>{
    return /*#__PURE__*/ (0, $cKvYK.jsx)((0, $ijxZJ.default), {
        initialValues: (0, $gS6pX.getInitialValues)(null),
        validationSchema: (0, $gS6pX.validationSchemaCreate),
        isPost: true,
        submitUrl: `/api/utilisateurs/create`,
        prepareVariables: (values)=>(0, $gS6pX.prepareVariables)(null, values),
        children: /*#__PURE__*/ (0, $cKvYK.jsx)((0, $gS6pX.default), {
            isNew: true
        })
    });
};
var $10395dfc29b9df04$export$2e2bcd8739ae039 = $10395dfc29b9df04$var$CreateRoleUtilisateur;

});
parcelRegister("ijxZJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ffc34835dac9912$export$2e2bcd8739ae039);

var $cKvYK = parcelRequire("cKvYK");

var $kc00y = parcelRequire("kc00y");

var $bkJfK = parcelRequire("bkJfK");
parcelRequire("w7gBZ");
var $aw9wE = parcelRequire("aw9wE");

var $61JDm = parcelRequire("61JDm");

var $26Ddr = parcelRequire("26Ddr");

var $3BicN = parcelRequire("3BicN");
const $6ffc34835dac9912$var$resolveReject = (onSubmit, setErrorMessage, successToastMessage = "L'\xe9l\xe9ment a bien \xe9t\xe9 enregistr\xe9", errorToastMessage = "L'\xe9l\xe9ment n'a pas \xe9t\xe9 enregistr\xe9", redirectFn)=>{
    return {
        onResolve: (result)=>{
            setErrorMessage(null);
            (0, $61JDm.default).success(successToastMessage);
            onSubmit?.(result);
            redirectFn?.();
        },
        onReject: async (error)=>{
            setErrorMessage(await error.text());
            (0, $61JDm.default).error(errorToastMessage);
        }
    };
};
const $6ffc34835dac9912$var$useMyFormik = (submitUrl, isPost, onSubmit, successToastMessage, errorToastMessage, redirectUrl, isMultipartFormData)=>{
    const [errorMessage, setErrorMessage] = (0, $kc00y.useState)(null);
    const navigate = (0, $aw9wE.useNavigate)();
    const redirectFn = redirectUrl ? ()=>{
        navigate(redirectUrl);
    } : null;
    const postState = (0, $26Ddr.usePost)(submitUrl, $6ffc34835dac9912$var$resolveReject(onSubmit, setErrorMessage, successToastMessage, errorToastMessage, redirectFn));
    const putState = (0, $26Ddr.usePut)(submitUrl, $6ffc34835dac9912$var$resolveReject(onSubmit, setErrorMessage), isMultipartFormData);
    return {
        submitState: isPost ? postState : putState,
        errorMessage: errorMessage
    };
};
const $6ffc34835dac9912$var$MyFormik = (props)=>{
    const { submitState: submitState, errorMessage: errorMessage } = $6ffc34835dac9912$var$useMyFormik(props.submitUrl, props.isPost, props.onSubmit, props.successToastMessage, props.errorToastMessage, props.redirectUrl, props.isMultipartFormData ?? false);
    return /*#__PURE__*/ (0, $cKvYK.jsx)((0, $bkJfK.Formik), {
        enableReinitialize: true,
        initialValues: props.initialValues,
        initialStatus: props.initialStatus,
        validationSchema: props.validationSchema,
        onSubmit: async (values, { setSubmitting: setSubmitting })=>{
            const variables = props.prepareVariables ? props.prepareVariables(values) : values;
            try {
                await submitState.run(variables);
            } finally{
                setSubmitting(false);
            }
        },
        children: /*#__PURE__*/ (0, $cKvYK.jsxs)((0, $cKvYK.Fragment), {
            children: [
                props.afficheLog && submitState.data && submitState.data.length !== 0 && /*#__PURE__*/ (0, $cKvYK.jsxs)("div", {
                    className: props.classNameLog,
                    children: [
                        "Logs :",
                        submitState.data.map((e, index)=>/*#__PURE__*/ (0, $cKvYK.jsx)("div", {
                                children: e.libelleLog
                            }, index))
                    ]
                }),
                /*#__PURE__*/ (0, $cKvYK.jsx)((0, $3BicN.ErrorMessage), {
                    error: errorMessage
                }),
                props.children
            ]
        })
    });
};
var $6ffc34835dac9912$export$2e2bcd8739ae039 = $6ffc34835dac9912$var$MyFormik;

});
parcelRegister("bkJfK", function(module, exports) {

$parcel$export(module.exports, "useFormikContext", () => useFormikContext);
$parcel$export(module.exports, "Formik", () => Formik);
$parcel$export(module.exports, "useField", () => useField);
$parcel$export(module.exports, "Form", () => Form);

var $kMZku = parcelRequire("kMZku");

var $eBHEL = parcelRequire("eBHEL");

var $2AJmr = parcelRequire("2AJmr");

var $kc00y = parcelRequire("kc00y");

var $31ATd = parcelRequire("31ATd");

var $8I1rW = parcelRequire("8I1rW");

var $bwrOM = parcelRequire("bwrOM");

var $aCf5k = parcelRequire("aCf5k");

var $j8Bf6 = parcelRequire("j8Bf6");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
var FormikContext = /*#__PURE__*/ (0, $kc00y.createContext)(undefined);
FormikContext.displayName = "FormikContext";
var FormikProvider = FormikContext.Provider;
var FormikConsumer = FormikContext.Consumer;
function useFormikContext() {
    var formik = (0, $kc00y.useContext)(FormikContext);
    !!!formik && (0, $8I1rW.default)(false);
    return formik;
}
/** @private is the value an empty array? */ var isEmptyArray = function isEmptyArray(value) {
    return Array.isArray(value) && value.length === 0;
};
/** @private is the given object a Function? */ var isFunction = function isFunction(obj) {
    return typeof obj === "function";
};
/** @private is the given object an Object? */ var isObject = function isObject(obj) {
    return obj !== null && typeof obj === "object";
};
/** @private is the given object an integer? */ var isInteger = function isInteger(obj) {
    return String(Math.floor(Number(obj))) === obj;
};
/** @private is the given object a string? */ var isString = function isString(obj) {
    return Object.prototype.toString.call(obj) === "[object String]";
};
/** @private is the given object a NaN? */ // eslint-disable-next-line no-self-compare
var isNaN$1 = function isNaN1(obj) {
    return obj !== obj;
};
/** @private Does a React component have exactly 0 children? */ var isEmptyChildren = function isEmptyChildren(children) {
    return (0, $kc00y.Children).count(children) === 0;
};
/** @private is the given object/value a promise? */ var isPromise = function isPromise(value) {
    return isObject(value) && isFunction(value.then);
};
/** @private is the given object/value a type of synthetic event? */ var isInputEvent = function isInputEvent(value) {
    return value && isObject(value) && isObject(value.target);
};
/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?Document} doc Defaults to current document.
 * @return {Element | null}
 * @see https://github.com/facebook/fbjs/blob/master/packages/fbjs/src/core/dom/getActiveElement.js
 */ function getActiveElement(doc) {
    doc = doc || (typeof document !== "undefined" ? document : undefined);
    if (typeof doc === "undefined") return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
/**
 * Deeply get a value from an object via its path.
 */ function getIn(obj, key, def, p) {
    if (p === void 0) p = 0;
    var path = (0, $aCf5k.default)(key);
    while(obj && p < path.length)obj = obj[path[p++]];
     // check if path is not in the end
    if (p !== path.length && !obj) return def;
    return obj === undefined ? def : obj;
}
/**
 * Deeply set a value from in object via it's path. If the value at `path`
 * has changed, return a shallow copy of obj with `value` set at `path`.
 * If `value` has not changed, return the original `obj`.
 *
 * Existing objects / arrays along `path` are also shallow copied. Sibling
 * objects along path retain the same internal js reference. Since new
 * objects / arrays are only created along `path`, we can test if anything
 * changed in a nested structure by comparing the object's reference in
 * the old and new object, similar to how russian doll cache invalidation
 * works.
 *
 * In earlier versions of this function, which used cloneDeep, there were
 * issues whereby settings a nested value would mutate the parent
 * instead of creating a new object. `clone` avoids that bug making a
 * shallow copy of the objects along the update path
 * so no object is mutated in place.
 *
 * Before changing this function, please read through the following
 * discussions.
 *
 * @see https://github.com/developit/linkstate
 * @see https://github.com/jaredpalmer/formik/pull/123
 */ function setIn(obj, path, value) {
    var res = (0, $bwrOM.default)(obj); // this keeps inheritance when obj is a class
    var resVal = res;
    var i = 0;
    var pathArray = (0, $aCf5k.default)(path);
    for(; i < pathArray.length - 1; i++){
        var currentPath = pathArray[i];
        var currentObj = getIn(obj, pathArray.slice(0, i + 1));
        if (currentObj && (isObject(currentObj) || Array.isArray(currentObj))) resVal = resVal[currentPath] = (0, $bwrOM.default)(currentObj);
        else {
            var nextPath = pathArray[i + 1];
            resVal = resVal[currentPath] = isInteger(nextPath) && Number(nextPath) >= 0 ? [] : {};
        }
    } // Return original object if new value is the same as current
    if ((i === 0 ? obj : resVal)[pathArray[i]] === value) return obj;
    if (value === undefined) delete resVal[pathArray[i]];
    else resVal[pathArray[i]] = value;
     // If the path array has a single element, the loop did not run.
    // Deleting on `resVal` had no effect in this scenario, so we delete on the result instead.
    if (i === 0 && value === undefined) delete res[pathArray[i]];
    return res;
}
/**
 * Recursively a set the same value for all keys and arrays nested object, cloning
 * @param object
 * @param value
 * @param visited
 * @param response
 */ function setNestedObjectValues(object, value, visited, response) {
    if (visited === void 0) visited = new WeakMap();
    if (response === void 0) response = {};
    for(var _i = 0, _Object$keys = Object.keys(object); _i < _Object$keys.length; _i++){
        var k = _Object$keys[_i];
        var val = object[k];
        if (isObject(val)) {
            if (!visited.get(val)) {
                visited.set(val, true); // In order to keep array values consistent for both dot path  and
                // bracket syntax, we need to check if this is an array so that
                // this will output  { friends: [true] } and not { friends: { "0": true } }
                response[k] = Array.isArray(val) ? [] : {};
                setNestedObjectValues(val, value, visited, response[k]);
            }
        } else response[k] = value;
    }
    return response;
}
function formikReducer(state, msg) {
    switch(msg.type){
        case "SET_VALUES":
            return _extends({}, state, {
                values: msg.payload
            });
        case "SET_TOUCHED":
            return _extends({}, state, {
                touched: msg.payload
            });
        case "SET_ERRORS":
            if ((0, (/*@__PURE__*/$parcel$interopDefault($31ATd)))(state.errors, msg.payload)) return state;
            return _extends({}, state, {
                errors: msg.payload
            });
        case "SET_STATUS":
            return _extends({}, state, {
                status: msg.payload
            });
        case "SET_ISSUBMITTING":
            return _extends({}, state, {
                isSubmitting: msg.payload
            });
        case "SET_ISVALIDATING":
            return _extends({}, state, {
                isValidating: msg.payload
            });
        case "SET_FIELD_VALUE":
            return _extends({}, state, {
                values: setIn(state.values, msg.payload.field, msg.payload.value)
            });
        case "SET_FIELD_TOUCHED":
            return _extends({}, state, {
                touched: setIn(state.touched, msg.payload.field, msg.payload.value)
            });
        case "SET_FIELD_ERROR":
            return _extends({}, state, {
                errors: setIn(state.errors, msg.payload.field, msg.payload.value)
            });
        case "RESET_FORM":
            return _extends({}, state, msg.payload);
        case "SET_FORMIK_STATE":
            return msg.payload(state);
        case "SUBMIT_ATTEMPT":
            return _extends({}, state, {
                touched: setNestedObjectValues(state.values, true),
                isSubmitting: true,
                submitCount: state.submitCount + 1
            });
        case "SUBMIT_FAILURE":
            return _extends({}, state, {
                isSubmitting: false
            });
        case "SUBMIT_SUCCESS":
            return _extends({}, state, {
                isSubmitting: false
            });
        default:
            return state;
    }
} // Initial empty states // objects
var emptyErrors = {};
var emptyTouched = {};
function useFormik(_ref) {
    var _ref$validateOnChange = _ref.validateOnChange, validateOnChange = _ref$validateOnChange === void 0 ? true : _ref$validateOnChange, _ref$validateOnBlur = _ref.validateOnBlur, validateOnBlur = _ref$validateOnBlur === void 0 ? true : _ref$validateOnBlur, _ref$validateOnMount = _ref.validateOnMount, validateOnMount = _ref$validateOnMount === void 0 ? false : _ref$validateOnMount, isInitialValid = _ref.isInitialValid, _ref$enableReinitiali = _ref.enableReinitialize, enableReinitialize = _ref$enableReinitiali === void 0 ? false : _ref$enableReinitiali, onSubmit = _ref.onSubmit, rest = _objectWithoutPropertiesLoose(_ref, [
        "validateOnChange",
        "validateOnBlur",
        "validateOnMount",
        "isInitialValid",
        "enableReinitialize",
        "onSubmit"
    ]);
    var props = _extends({
        validateOnChange: validateOnChange,
        validateOnBlur: validateOnBlur,
        validateOnMount: validateOnMount,
        onSubmit: onSubmit
    }, rest);
    var initialValues = (0, $kc00y.useRef)(props.initialValues);
    var initialErrors = (0, $kc00y.useRef)(props.initialErrors || emptyErrors);
    var initialTouched = (0, $kc00y.useRef)(props.initialTouched || emptyTouched);
    var initialStatus = (0, $kc00y.useRef)(props.initialStatus);
    var isMounted = (0, $kc00y.useRef)(false);
    var fieldRegistry = (0, $kc00y.useRef)({});
    (0, $kc00y.useEffect)(function() {
        isMounted.current = true;
        return function() {
            isMounted.current = false;
        };
    }, []);
    var _React$useState = (0, $kc00y.useState)(0), setIteration = _React$useState[1];
    var stateRef = (0, $kc00y.useRef)({
        values: (0, $2AJmr.default)(props.initialValues),
        errors: (0, $2AJmr.default)(props.initialErrors) || emptyErrors,
        touched: (0, $2AJmr.default)(props.initialTouched) || emptyTouched,
        status: (0, $2AJmr.default)(props.initialStatus),
        isSubmitting: false,
        isValidating: false,
        submitCount: 0
    });
    var state = stateRef.current;
    var dispatch = (0, $kc00y.useCallback)(function(action) {
        var prev = stateRef.current;
        stateRef.current = formikReducer(prev, action); // force rerender
        if (prev !== stateRef.current) setIteration(function(x) {
            return x + 1;
        });
    }, []);
    var runValidateHandler = (0, $kc00y.useCallback)(function(values, field) {
        return new Promise(function(resolve, reject) {
            var maybePromisedErrors = props.validate(values, field);
            if (maybePromisedErrors == null) // use loose null check here on purpose
            resolve(emptyErrors);
            else if (isPromise(maybePromisedErrors)) maybePromisedErrors.then(function(errors) {
                resolve(errors || emptyErrors);
            }, function(actualException) {
                reject(actualException);
            });
            else resolve(maybePromisedErrors);
        });
    }, [
        props.validate
    ]);
    /**
   * Run validation against a Yup schema and optionally run a function if successful
   */ var runValidationSchema = (0, $kc00y.useCallback)(function(values, field) {
        var validationSchema = props.validationSchema;
        var schema = isFunction(validationSchema) ? validationSchema(field) : validationSchema;
        var promise = field && schema.validateAt ? schema.validateAt(field, values) : validateYupSchema(values, schema);
        return new Promise(function(resolve, reject) {
            promise.then(function() {
                resolve(emptyErrors);
            }, function(err) {
                // Yup will throw a validation error if validation fails. We catch those and
                // resolve them into Formik errors. We can sniff if something is a Yup error
                // by checking error.name.
                // @see https://github.com/jquense/yup#validationerrorerrors-string--arraystring-value-any-path-string
                if (err.name === "ValidationError") resolve(yupToFormErrors(err));
                else reject(err);
            });
        });
    }, [
        props.validationSchema
    ]);
    var runSingleFieldLevelValidation = (0, $kc00y.useCallback)(function(field, value) {
        return new Promise(function(resolve) {
            return resolve(fieldRegistry.current[field].validate(value));
        });
    }, []);
    var runFieldLevelValidations = (0, $kc00y.useCallback)(function(values) {
        var fieldKeysWithValidation = Object.keys(fieldRegistry.current).filter(function(f) {
            return isFunction(fieldRegistry.current[f].validate);
        }); // Construct an array with all of the field validation functions
        var fieldValidations = fieldKeysWithValidation.length > 0 ? fieldKeysWithValidation.map(function(f) {
            return runSingleFieldLevelValidation(f, getIn(values, f));
        }) : [
            Promise.resolve("DO_NOT_DELETE_YOU_WILL_BE_FIRED")
        ]; // use special case ;)
        return Promise.all(fieldValidations).then(function(fieldErrorsList) {
            return fieldErrorsList.reduce(function(prev, curr, index) {
                if (curr === "DO_NOT_DELETE_YOU_WILL_BE_FIRED") return prev;
                if (curr) prev = setIn(prev, fieldKeysWithValidation[index], curr);
                return prev;
            }, {});
        });
    }, [
        runSingleFieldLevelValidation
    ]); // Run all validations and return the result
    var runAllValidations = (0, $kc00y.useCallback)(function(values) {
        return Promise.all([
            runFieldLevelValidations(values),
            props.validationSchema ? runValidationSchema(values) : {},
            props.validate ? runValidateHandler(values) : {}
        ]).then(function(_ref2) {
            var fieldErrors = _ref2[0], schemaErrors = _ref2[1], validateErrors = _ref2[2];
            var combinedErrors = (0, $kMZku.default).all([
                fieldErrors,
                schemaErrors,
                validateErrors
            ], {
                arrayMerge: arrayMerge
            });
            return combinedErrors;
        });
    }, [
        props.validate,
        props.validationSchema,
        runFieldLevelValidations,
        runValidateHandler,
        runValidationSchema
    ]); // Run all validations methods and update state accordingly
    var validateFormWithHighPriority = useEventCallback(function(values) {
        if (values === void 0) values = state.values;
        dispatch({
            type: "SET_ISVALIDATING",
            payload: true
        });
        return runAllValidations(values).then(function(combinedErrors) {
            if (!!isMounted.current) {
                dispatch({
                    type: "SET_ISVALIDATING",
                    payload: false
                });
                dispatch({
                    type: "SET_ERRORS",
                    payload: combinedErrors
                });
            }
            return combinedErrors;
        });
    });
    (0, $kc00y.useEffect)(function() {
        if (validateOnMount && isMounted.current === true && (0, (/*@__PURE__*/$parcel$interopDefault($31ATd)))(initialValues.current, props.initialValues)) validateFormWithHighPriority(initialValues.current);
    }, [
        validateOnMount,
        validateFormWithHighPriority
    ]);
    var resetForm = (0, $kc00y.useCallback)(function(nextState) {
        var values = nextState && nextState.values ? nextState.values : initialValues.current;
        var errors = nextState && nextState.errors ? nextState.errors : initialErrors.current ? initialErrors.current : props.initialErrors || {};
        var touched = nextState && nextState.touched ? nextState.touched : initialTouched.current ? initialTouched.current : props.initialTouched || {};
        var status = nextState && nextState.status ? nextState.status : initialStatus.current ? initialStatus.current : props.initialStatus;
        initialValues.current = values;
        initialErrors.current = errors;
        initialTouched.current = touched;
        initialStatus.current = status;
        var dispatchFn = function dispatchFn() {
            dispatch({
                type: "RESET_FORM",
                payload: {
                    isSubmitting: !!nextState && !!nextState.isSubmitting,
                    errors: errors,
                    touched: touched,
                    status: status,
                    values: values,
                    isValidating: !!nextState && !!nextState.isValidating,
                    submitCount: !!nextState && !!nextState.submitCount && typeof nextState.submitCount === "number" ? nextState.submitCount : 0
                }
            });
        };
        if (props.onReset) {
            var maybePromisedOnReset = props.onReset(state.values, imperativeMethods);
            if (isPromise(maybePromisedOnReset)) maybePromisedOnReset.then(dispatchFn);
            else dispatchFn();
        } else dispatchFn();
    }, [
        props.initialErrors,
        props.initialStatus,
        props.initialTouched,
        props.onReset
    ]);
    (0, $kc00y.useEffect)(function() {
        if (isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($31ATd)))(initialValues.current, props.initialValues)) {
            if (enableReinitialize) {
                initialValues.current = props.initialValues;
                resetForm();
                if (validateOnMount) validateFormWithHighPriority(initialValues.current);
            }
        }
    }, [
        enableReinitialize,
        props.initialValues,
        resetForm,
        validateOnMount,
        validateFormWithHighPriority
    ]);
    (0, $kc00y.useEffect)(function() {
        if (enableReinitialize && isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($31ATd)))(initialErrors.current, props.initialErrors)) {
            initialErrors.current = props.initialErrors || emptyErrors;
            dispatch({
                type: "SET_ERRORS",
                payload: props.initialErrors || emptyErrors
            });
        }
    }, [
        enableReinitialize,
        props.initialErrors
    ]);
    (0, $kc00y.useEffect)(function() {
        if (enableReinitialize && isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($31ATd)))(initialTouched.current, props.initialTouched)) {
            initialTouched.current = props.initialTouched || emptyTouched;
            dispatch({
                type: "SET_TOUCHED",
                payload: props.initialTouched || emptyTouched
            });
        }
    }, [
        enableReinitialize,
        props.initialTouched
    ]);
    (0, $kc00y.useEffect)(function() {
        if (enableReinitialize && isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($31ATd)))(initialStatus.current, props.initialStatus)) {
            initialStatus.current = props.initialStatus;
            dispatch({
                type: "SET_STATUS",
                payload: props.initialStatus
            });
        }
    }, [
        enableReinitialize,
        props.initialStatus,
        props.initialTouched
    ]);
    var validateField = useEventCallback(function(name) {
        // This will efficiently validate a single field by avoiding state
        // changes if the validation function is synchronous. It's different from
        // what is called when using validateForm.
        if (fieldRegistry.current[name] && isFunction(fieldRegistry.current[name].validate)) {
            var value = getIn(state.values, name);
            var maybePromise = fieldRegistry.current[name].validate(value);
            if (isPromise(maybePromise)) {
                // Only flip isValidating if the function is async.
                dispatch({
                    type: "SET_ISVALIDATING",
                    payload: true
                });
                return maybePromise.then(function(x) {
                    return x;
                }).then(function(error) {
                    dispatch({
                        type: "SET_FIELD_ERROR",
                        payload: {
                            field: name,
                            value: error
                        }
                    });
                    dispatch({
                        type: "SET_ISVALIDATING",
                        payload: false
                    });
                });
            } else {
                dispatch({
                    type: "SET_FIELD_ERROR",
                    payload: {
                        field: name,
                        value: maybePromise
                    }
                });
                return Promise.resolve(maybePromise);
            }
        } else if (props.validationSchema) {
            dispatch({
                type: "SET_ISVALIDATING",
                payload: true
            });
            return runValidationSchema(state.values, name).then(function(x) {
                return x;
            }).then(function(error) {
                dispatch({
                    type: "SET_FIELD_ERROR",
                    payload: {
                        field: name,
                        value: getIn(error, name)
                    }
                });
                dispatch({
                    type: "SET_ISVALIDATING",
                    payload: false
                });
            });
        }
        return Promise.resolve();
    });
    var registerField = (0, $kc00y.useCallback)(function(name, _ref3) {
        var validate = _ref3.validate;
        fieldRegistry.current[name] = {
            validate: validate
        };
    }, []);
    var unregisterField = (0, $kc00y.useCallback)(function(name) {
        delete fieldRegistry.current[name];
    }, []);
    var setTouched = useEventCallback(function(touched, shouldValidate) {
        dispatch({
            type: "SET_TOUCHED",
            payload: touched
        });
        var willValidate = shouldValidate === undefined ? validateOnBlur : shouldValidate;
        return willValidate ? validateFormWithHighPriority(state.values) : Promise.resolve();
    });
    var setErrors = (0, $kc00y.useCallback)(function(errors) {
        dispatch({
            type: "SET_ERRORS",
            payload: errors
        });
    }, []);
    var setValues = useEventCallback(function(values, shouldValidate) {
        var resolvedValues = isFunction(values) ? values(state.values) : values;
        dispatch({
            type: "SET_VALUES",
            payload: resolvedValues
        });
        var willValidate = shouldValidate === undefined ? validateOnChange : shouldValidate;
        return willValidate ? validateFormWithHighPriority(resolvedValues) : Promise.resolve();
    });
    var setFieldError = (0, $kc00y.useCallback)(function(field, value) {
        dispatch({
            type: "SET_FIELD_ERROR",
            payload: {
                field: field,
                value: value
            }
        });
    }, []);
    var setFieldValue = useEventCallback(function(field, value, shouldValidate) {
        dispatch({
            type: "SET_FIELD_VALUE",
            payload: {
                field: field,
                value: value
            }
        });
        var willValidate = shouldValidate === undefined ? validateOnChange : shouldValidate;
        return willValidate ? validateFormWithHighPriority(setIn(state.values, field, value)) : Promise.resolve();
    });
    var executeChange = (0, $kc00y.useCallback)(function(eventOrTextValue, maybePath) {
        // By default, assume that the first argument is a string. This allows us to use
        // handleChange with React Native and React Native Web's onChangeText prop which
        // provides just the value of the input.
        var field = maybePath;
        var val = eventOrTextValue;
        var parsed; // If the first argument is not a string though, it has to be a synthetic React Event (or a fake one),
        // so we handle like we would a normal HTML change event.
        if (!isString(eventOrTextValue)) {
            // If we can, persist the event
            // @see https://reactjs.org/docs/events.html#event-pooling
            if (eventOrTextValue.persist) eventOrTextValue.persist();
            var target = eventOrTextValue.target ? eventOrTextValue.target : eventOrTextValue.currentTarget;
            var type = target.type, name = target.name, id = target.id, value = target.value, checked = target.checked, outerHTML = target.outerHTML, options = target.options, multiple = target.multiple;
            field = maybePath ? maybePath : name ? name : id;
            val = /number|range/.test(type) ? (parsed = parseFloat(value), isNaN(parsed) ? "" : parsed) : /checkbox/.test(type) // checkboxes
             ? getValueForCheckbox(getIn(state.values, field), checked, value) : options && multiple // <select multiple>
             ? getSelectedValues(options) : value;
        }
        if (field) // Set form fields by name
        setFieldValue(field, val);
    }, [
        setFieldValue,
        state.values
    ]);
    var handleChange = useEventCallback(function(eventOrPath) {
        if (isString(eventOrPath)) return function(event) {
            return executeChange(event, eventOrPath);
        };
        else executeChange(eventOrPath);
    });
    var setFieldTouched = useEventCallback(function(field, touched, shouldValidate) {
        if (touched === void 0) touched = true;
        dispatch({
            type: "SET_FIELD_TOUCHED",
            payload: {
                field: field,
                value: touched
            }
        });
        var willValidate = shouldValidate === undefined ? validateOnBlur : shouldValidate;
        return willValidate ? validateFormWithHighPriority(state.values) : Promise.resolve();
    });
    var executeBlur = (0, $kc00y.useCallback)(function(e, path) {
        if (e.persist) e.persist();
        var _e$target = e.target, name = _e$target.name, id = _e$target.id, outerHTML = _e$target.outerHTML;
        var field = path ? path : name ? name : id;
        setFieldTouched(field, true);
    }, [
        setFieldTouched
    ]);
    var handleBlur = useEventCallback(function(eventOrString) {
        if (isString(eventOrString)) return function(event) {
            return executeBlur(event, eventOrString);
        };
        else executeBlur(eventOrString);
    });
    var setFormikState = (0, $kc00y.useCallback)(function(stateOrCb) {
        if (isFunction(stateOrCb)) dispatch({
            type: "SET_FORMIK_STATE",
            payload: stateOrCb
        });
        else dispatch({
            type: "SET_FORMIK_STATE",
            payload: function payload() {
                return stateOrCb;
            }
        });
    }, []);
    var setStatus = (0, $kc00y.useCallback)(function(status) {
        dispatch({
            type: "SET_STATUS",
            payload: status
        });
    }, []);
    var setSubmitting = (0, $kc00y.useCallback)(function(isSubmitting) {
        dispatch({
            type: "SET_ISSUBMITTING",
            payload: isSubmitting
        });
    }, []);
    var submitForm = useEventCallback(function() {
        dispatch({
            type: "SUBMIT_ATTEMPT"
        });
        return validateFormWithHighPriority().then(function(combinedErrors) {
            // In case an error was thrown and passed to the resolved Promise,
            // `combinedErrors` can be an instance of an Error. We need to check
            // that and abort the submit.
            // If we don't do that, calling `Object.keys(new Error())` yields an
            // empty array, which causes the validation to pass and the form
            // to be submitted.
            var isInstanceOfError = combinedErrors instanceof Error;
            var isActuallyValid = !isInstanceOfError && Object.keys(combinedErrors).length === 0;
            if (isActuallyValid) {
                // Proceed with submit...
                //
                // To respect sync submit fns, we can't simply wrap executeSubmit in a promise and
                // _always_ dispatch SUBMIT_SUCCESS because isSubmitting would then always be false.
                // This would be fine in simple cases, but make it impossible to disable submit
                // buttons where people use callbacks or promises as side effects (which is basically
                // all of v1 Formik code). Instead, recall that we are inside of a promise chain already,
                //  so we can try/catch executeSubmit(), if it returns undefined, then just bail.
                // If there are errors, throw em. Otherwise, wrap executeSubmit in a promise and handle
                // cleanup of isSubmitting on behalf of the consumer.
                var promiseOrUndefined;
                try {
                    promiseOrUndefined = executeSubmit(); // Bail if it's sync, consumer is responsible for cleaning up
                    // via setSubmitting(false)
                    if (promiseOrUndefined === undefined) return;
                } catch (error) {
                    throw error;
                }
                return Promise.resolve(promiseOrUndefined).then(function(result) {
                    if (!!isMounted.current) dispatch({
                        type: "SUBMIT_SUCCESS"
                    });
                    return result;
                })["catch"](function(_errors) {
                    if (!!isMounted.current) {
                        dispatch({
                            type: "SUBMIT_FAILURE"
                        }); // This is a legit error rejected by the onSubmit fn
                        // so we don't want to break the promise chain
                        throw _errors;
                    }
                });
            } else if (!!isMounted.current) {
                // ^^^ Make sure Formik is still mounted before updating state
                dispatch({
                    type: "SUBMIT_FAILURE"
                }); // throw combinedErrors;
                if (isInstanceOfError) throw combinedErrors;
            }
            return;
        });
    });
    var handleSubmit = useEventCallback(function(e) {
        if (e && e.preventDefault && isFunction(e.preventDefault)) e.preventDefault();
        if (e && e.stopPropagation && isFunction(e.stopPropagation)) e.stopPropagation();
         // Warn if form submission is triggered by a <button> without a
        var activeElement;
        submitForm()["catch"](function(reason) {
            console.warn("Warning: An unhandled error was caught from submitForm()", reason);
        });
    });
    var imperativeMethods = {
        resetForm: resetForm,
        validateForm: validateFormWithHighPriority,
        validateField: validateField,
        setErrors: setErrors,
        setFieldError: setFieldError,
        setFieldTouched: setFieldTouched,
        setFieldValue: setFieldValue,
        setStatus: setStatus,
        setSubmitting: setSubmitting,
        setTouched: setTouched,
        setValues: setValues,
        setFormikState: setFormikState,
        submitForm: submitForm
    };
    var executeSubmit = useEventCallback(function() {
        return onSubmit(state.values, imperativeMethods);
    });
    var handleReset = useEventCallback(function(e) {
        if (e && e.preventDefault && isFunction(e.preventDefault)) e.preventDefault();
        if (e && e.stopPropagation && isFunction(e.stopPropagation)) e.stopPropagation();
        resetForm();
    });
    var getFieldMeta = (0, $kc00y.useCallback)(function(name) {
        return {
            value: getIn(state.values, name),
            error: getIn(state.errors, name),
            touched: !!getIn(state.touched, name),
            initialValue: getIn(initialValues.current, name),
            initialTouched: !!getIn(initialTouched.current, name),
            initialError: getIn(initialErrors.current, name)
        };
    }, [
        state.errors,
        state.touched,
        state.values
    ]);
    var getFieldHelpers = (0, $kc00y.useCallback)(function(name) {
        return {
            setValue: function setValue(value, shouldValidate) {
                return setFieldValue(name, value, shouldValidate);
            },
            setTouched: function setTouched(value, shouldValidate) {
                return setFieldTouched(name, value, shouldValidate);
            },
            setError: function setError(value) {
                return setFieldError(name, value);
            }
        };
    }, [
        setFieldValue,
        setFieldTouched,
        setFieldError
    ]);
    var getFieldProps = (0, $kc00y.useCallback)(function(nameOrOptions) {
        var isAnObject = isObject(nameOrOptions);
        var name = isAnObject ? nameOrOptions.name : nameOrOptions;
        var valueState = getIn(state.values, name);
        var field = {
            name: name,
            value: valueState,
            onChange: handleChange,
            onBlur: handleBlur
        };
        if (isAnObject) {
            var type = nameOrOptions.type, valueProp = nameOrOptions.value, is = nameOrOptions.as, multiple = nameOrOptions.multiple;
            if (type === "checkbox") {
                if (valueProp === undefined) field.checked = !!valueState;
                else {
                    field.checked = !!(Array.isArray(valueState) && ~valueState.indexOf(valueProp));
                    field.value = valueProp;
                }
            } else if (type === "radio") {
                field.checked = valueState === valueProp;
                field.value = valueProp;
            } else if (is === "select" && multiple) {
                field.value = field.value || [];
                field.multiple = true;
            }
        }
        return field;
    }, [
        handleBlur,
        handleChange,
        state.values
    ]);
    var dirty = (0, $kc00y.useMemo)(function() {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($31ATd)))(initialValues.current, state.values);
    }, [
        initialValues.current,
        state.values
    ]);
    var isValid = (0, $kc00y.useMemo)(function() {
        return typeof isInitialValid !== "undefined" ? dirty ? state.errors && Object.keys(state.errors).length === 0 : isInitialValid !== false && isFunction(isInitialValid) ? isInitialValid(props) : isInitialValid : state.errors && Object.keys(state.errors).length === 0;
    }, [
        isInitialValid,
        dirty,
        state.errors,
        props
    ]);
    var ctx = _extends({}, state, {
        initialValues: initialValues.current,
        initialErrors: initialErrors.current,
        initialTouched: initialTouched.current,
        initialStatus: initialStatus.current,
        handleBlur: handleBlur,
        handleChange: handleChange,
        handleReset: handleReset,
        handleSubmit: handleSubmit,
        resetForm: resetForm,
        setErrors: setErrors,
        setFormikState: setFormikState,
        setFieldTouched: setFieldTouched,
        setFieldValue: setFieldValue,
        setFieldError: setFieldError,
        setStatus: setStatus,
        setSubmitting: setSubmitting,
        setTouched: setTouched,
        setValues: setValues,
        submitForm: submitForm,
        validateForm: validateFormWithHighPriority,
        validateField: validateField,
        isValid: isValid,
        dirty: dirty,
        unregisterField: unregisterField,
        registerField: registerField,
        getFieldProps: getFieldProps,
        getFieldMeta: getFieldMeta,
        getFieldHelpers: getFieldHelpers,
        validateOnBlur: validateOnBlur,
        validateOnChange: validateOnChange,
        validateOnMount: validateOnMount
    });
    return ctx;
}
function Formik(props) {
    var formikbag = useFormik(props);
    var component = props.component, children = props.children, render = props.render, innerRef = props.innerRef; // This allows folks to pass a ref to <Formik />
    (0, $kc00y.useImperativeHandle)(innerRef, function() {
        return formikbag;
    });
    return (0, $kc00y.createElement)(FormikProvider, {
        value: formikbag
    }, component ? (0, $kc00y.createElement)(component, formikbag) : render ? render(formikbag) : children // children come last, always called
     ? isFunction(children) ? children(formikbag) : !isEmptyChildren(children) ? (0, $kc00y.Children).only(children) : null : null);
}
function warnAboutMissingIdentifier(_ref4) {
    var htmlContent = _ref4.htmlContent, documentationAnchorLink = _ref4.documentationAnchorLink, handlerName = _ref4.handlerName;
    console.warn("Warning: Formik called `" + handlerName + "`, but you forgot to pass an `id` or `name` attribute to your input:\n    " + htmlContent + "\n    Formik cannot determine which value to update. For more info see https://formik.org/docs/api/formik#" + documentationAnchorLink + "\n  ");
}
/**
 * Transform Yup ValidationError to a more usable object
 */ function yupToFormErrors(yupError) {
    var errors = {};
    if (yupError.inner) {
        if (yupError.inner.length === 0) return setIn(errors, yupError.path, yupError.message);
        for(var _iterator = yupError.inner, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;){
            var _ref5;
            if (_isArray) {
                if (_i >= _iterator.length) break;
                _ref5 = _iterator[_i++];
            } else {
                _i = _iterator.next();
                if (_i.done) break;
                _ref5 = _i.value;
            }
            var err = _ref5;
            if (!getIn(errors, err.path)) errors = setIn(errors, err.path, err.message);
        }
    }
    return errors;
}
/**
 * Validate a yup schema.
 */ function validateYupSchema(values, schema, sync, context) {
    if (sync === void 0) sync = false;
    var normalizedValues = prepareDataForValidation(values);
    return schema[sync ? "validateSync" : "validate"](normalizedValues, {
        abortEarly: false,
        context: context || normalizedValues
    });
}
/**
 * Recursively prepare values.
 */ function prepareDataForValidation(values) {
    var data = Array.isArray(values) ? [] : {};
    for(var k in values)if (Object.prototype.hasOwnProperty.call(values, k)) {
        var key = String(k);
        if (Array.isArray(values[key]) === true) data[key] = values[key].map(function(value) {
            if (Array.isArray(value) === true || (0, $eBHEL.default)(value)) return prepareDataForValidation(value);
            else return value !== "" ? value : undefined;
        });
        else if ((0, $eBHEL.default)(values[key])) data[key] = prepareDataForValidation(values[key]);
        else data[key] = values[key] !== "" ? values[key] : undefined;
    }
    return data;
}
/**
 * deepmerge array merging algorithm
 * https://github.com/KyleAMathews/deepmerge#combine-array
 */ function arrayMerge(target, source, options) {
    var destination = target.slice();
    source.forEach(function merge(e, i) {
        if (typeof destination[i] === "undefined") {
            var cloneRequested = options.clone !== false;
            var shouldClone = cloneRequested && options.isMergeableObject(e);
            destination[i] = shouldClone ? (0, $kMZku.default)(Array.isArray(e) ? [] : {}, e, options) : e;
        } else if (options.isMergeableObject(e)) destination[i] = (0, $kMZku.default)(target[i], e, options);
        else if (target.indexOf(e) === -1) destination.push(e);
    });
    return destination;
}
/** Return multi select values based on an array of options */ function getSelectedValues(options) {
    return Array.from(options).filter(function(el) {
        return el.selected;
    }).map(function(el) {
        return el.value;
    });
}
/** Return the next value for a checkbox */ function getValueForCheckbox(currentValue, checked, valueProp) {
    // If the current value was a boolean, return a boolean
    if (typeof currentValue === "boolean") return Boolean(checked);
     // If the currentValue was not a boolean we want to return an array
    var currentArrayOfValues = [];
    var isValueInArray = false;
    var index = -1;
    if (!Array.isArray(currentValue)) {
        // eslint-disable-next-line eqeqeq
        if (!valueProp || valueProp == "true" || valueProp == "false") return Boolean(checked);
    } else {
        // If the current value is already an array, use it
        currentArrayOfValues = currentValue;
        index = currentValue.indexOf(valueProp);
        isValueInArray = index >= 0;
    } // If the checkbox was checked and the value is not already present in the aray we want to add the new value to the array of values
    if (checked && valueProp && !isValueInArray) return currentArrayOfValues.concat(valueProp);
     // If the checkbox was unchecked and the value is not in the array, simply return the already existing array of values
    if (!isValueInArray) return currentArrayOfValues;
     // If the checkbox was unchecked and the value is in the array, remove the value and return the array
    return currentArrayOfValues.slice(0, index).concat(currentArrayOfValues.slice(index + 1));
} // React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser.
// @see https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
var useIsomorphicLayoutEffect = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined" ? (0, $kc00y.useLayoutEffect) : (0, $kc00y.useEffect);
function useEventCallback(fn) {
    var ref = (0, $kc00y.useRef)(fn); // we copy a ref to the callback scoped to the current state/props on each render
    useIsomorphicLayoutEffect(function() {
        ref.current = fn;
    });
    return (0, $kc00y.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return ref.current.apply(void 0, args);
    }, []);
}
function useField(propsOrFieldName) {
    var formik = useFormikContext();
    var getFieldProps = formik.getFieldProps, getFieldMeta = formik.getFieldMeta, getFieldHelpers = formik.getFieldHelpers, registerField = formik.registerField, unregisterField = formik.unregisterField;
    var isAnObject = isObject(propsOrFieldName); // Normalize propsOrFieldName to FieldHookConfig<Val>
    var props = isAnObject ? propsOrFieldName : {
        name: propsOrFieldName
    };
    var fieldName = props.name, validateFn = props.validate;
    (0, $kc00y.useEffect)(function() {
        if (fieldName) registerField(fieldName, {
            validate: validateFn
        });
        return function() {
            if (fieldName) unregisterField(fieldName);
        };
    }, [
        registerField,
        unregisterField,
        fieldName,
        validateFn
    ]);
    !fieldName && (0, $8I1rW.default)(false);
    var fieldHelpers = (0, $kc00y.useMemo)(function() {
        return getFieldHelpers(fieldName);
    }, [
        getFieldHelpers,
        fieldName
    ]);
    return [
        getFieldProps(props),
        getFieldMeta(fieldName),
        fieldHelpers
    ];
}
function Field(_ref) {
    var validate = _ref.validate, name = _ref.name, render = _ref.render, children = _ref.children, is = _ref.as, component = _ref.component, className = _ref.className, props = _objectWithoutPropertiesLoose(_ref, [
        "validate",
        "name",
        "render",
        "children",
        "as",
        "component",
        "className"
    ]);
    var _useFormikContext = useFormikContext(), formik = _objectWithoutPropertiesLoose(_useFormikContext, [
        "validate",
        "validationSchema"
    ]);
    var registerField = formik.registerField, unregisterField = formik.unregisterField;
    (0, $kc00y.useEffect)(function() {
        registerField(name, {
            validate: validate
        });
        return function() {
            unregisterField(name);
        };
    }, [
        registerField,
        unregisterField,
        name,
        validate
    ]);
    var field = formik.getFieldProps(_extends({
        name: name
    }, props));
    var meta = formik.getFieldMeta(name);
    var legacyBag = {
        field: field,
        form: formik
    };
    if (render) return render(_extends({}, legacyBag, {
        meta: meta
    }));
    if (isFunction(children)) return children(_extends({}, legacyBag, {
        meta: meta
    }));
    if (component) {
        // This behavior is backwards compat with earlier Formik 0.9 to 1.x
        if (typeof component === "string") {
            var innerRef = props.innerRef, rest = _objectWithoutPropertiesLoose(props, [
                "innerRef"
            ]);
            return (0, $kc00y.createElement)(component, _extends({
                ref: innerRef
            }, field, rest, {
                className: className
            }), children);
        } // We don't pass `meta` for backwards compat
        return (0, $kc00y.createElement)(component, _extends({
            field: field,
            form: formik
        }, props, {
            className: className
        }), children);
    } // default to input here so we can check for both `as` and `children` above
    var asElement = is || "input";
    if (typeof asElement === "string") {
        var _innerRef = props.innerRef, _rest = _objectWithoutPropertiesLoose(props, [
            "innerRef"
        ]);
        return (0, $kc00y.createElement)(asElement, _extends({
            ref: _innerRef
        }, field, _rest, {
            className: className
        }), children);
    }
    return (0, $kc00y.createElement)(asElement, _extends({}, field, props, {
        className: className
    }), children);
}
var Form = /*#__PURE__*/ (0, $kc00y.forwardRef)(function(props, ref) {
    // iOS needs an "action" attribute for nice input: https://stackoverflow.com/a/39485162/406725
    // We default the action to "#" in case the preventDefault fails (just updates the URL hash)
    var action = props.action, rest = _objectWithoutPropertiesLoose(props, [
        "action"
    ]);
    var _action = action != null ? action : "#";
    var _useFormikContext = useFormikContext(), handleReset = _useFormikContext.handleReset, handleSubmit = _useFormikContext.handleSubmit;
    return (0, $kc00y.createElement)("form", _extends({
        onSubmit: handleSubmit,
        ref: ref,
        onReset: handleReset,
        action: _action
    }, rest));
});
Form.displayName = "Form";
/**
 * A public higher-order component to access the imperative API
 */ function withFormik(_ref) {
    var _ref$mapPropsToValues = _ref.mapPropsToValues, mapPropsToValues = _ref$mapPropsToValues === void 0 ? function(vanillaProps) {
        var val = {};
        for(var k in vanillaProps)if (vanillaProps.hasOwnProperty(k) && typeof vanillaProps[k] !== "function") // @todo TypeScript fix
        val[k] = vanillaProps[k];
        return val;
    } : _ref$mapPropsToValues, config = _objectWithoutPropertiesLoose(_ref, [
        "mapPropsToValues"
    ]);
    return function createFormik(Component$1) {
        var componentDisplayName = Component$1.displayName || Component$1.name || Component$1.constructor && Component$1.constructor.name || "Component";
        /**
     * We need to use closures here for to provide the wrapped component's props to
     * the respective withFormik config methods.
     */ var C = /*#__PURE__*/ function(_React$Component) {
            _inheritsLoose(C, _React$Component);
            function C() {
                var _this;
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                _this = _React$Component.call.apply(_React$Component, [
                    this
                ].concat(args)) || this;
                _this.validate = function(values) {
                    return config.validate(values, _this.props);
                };
                _this.validationSchema = function() {
                    return isFunction(config.validationSchema) ? config.validationSchema(_this.props) : config.validationSchema;
                };
                _this.handleSubmit = function(values, actions) {
                    return config.handleSubmit(values, _extends({}, actions, {
                        props: _this.props
                    }));
                };
                _this.renderFormComponent = function(formikProps) {
                    return (0, $kc00y.createElement)(Component$1, _extends({}, _this.props, formikProps));
                };
                return _this;
            }
            var _proto = C.prototype;
            _proto.render = function render() {
                var _this$props = this.props, props = _objectWithoutPropertiesLoose(_this$props, [
                    "children"
                ]);
                return (0, $kc00y.createElement)(Formik, _extends({}, props, config, {
                    validate: config.validate && this.validate,
                    validationSchema: config.validationSchema && this.validationSchema,
                    initialValues: mapPropsToValues(this.props),
                    initialStatus: config.mapPropsToStatus && config.mapPropsToStatus(this.props),
                    initialErrors: config.mapPropsToErrors && config.mapPropsToErrors(this.props),
                    initialTouched: config.mapPropsToTouched && config.mapPropsToTouched(this.props),
                    onSubmit: this.handleSubmit,
                    children: this.renderFormComponent
                }));
            };
            return C;
        }((0, $kc00y.Component));
        C.displayName = "WithFormik(" + componentDisplayName + ")";
        return (0, (/*@__PURE__*/$parcel$interopDefault($j8Bf6)))(C, Component$1 // cast type to ComponentClass (even if SFC)
        );
    };
}
/**
 * Connect any component to Formik context, and inject as a prop called `formik`;
 * @param Comp React Component
 */ function connect(Comp) {
    var C = function C(props) {
        return (0, $kc00y.createElement)(FormikConsumer, null, function(formik) {
            !!!formik && (0, $8I1rW.default)(false);
            return (0, $kc00y.createElement)(Comp, _extends({}, props, {
                formik: formik
            }));
        });
    };
    var componentDisplayName = Comp.displayName || Comp.name || Comp.constructor && Comp.constructor.name || "Component"; // Assign Comp to C.WrappedComponent so we can access the inner component in tests
    // For example, <Field.WrappedComponent /> gets us <FieldInner/>
    C.WrappedComponent = Comp;
    C.displayName = "FormikConnect(" + componentDisplayName + ")";
    return (0, (/*@__PURE__*/$parcel$interopDefault($j8Bf6)))(C, Comp // cast type to ComponentClass (even if SFC)
    );
}
/**
 * Some array helpers!
 */ var move = function move(array, from, to) {
    var copy = copyArrayLike(array);
    var value = copy[from];
    copy.splice(from, 1);
    copy.splice(to, 0, value);
    return copy;
};
var swap = function swap(arrayLike, indexA, indexB) {
    var copy = copyArrayLike(arrayLike);
    var a = copy[indexA];
    copy[indexA] = copy[indexB];
    copy[indexB] = a;
    return copy;
};
var insert = function insert(arrayLike, index, value) {
    var copy = copyArrayLike(arrayLike);
    copy.splice(index, 0, value);
    return copy;
};
var replace = function replace(arrayLike, index, value) {
    var copy = copyArrayLike(arrayLike);
    copy[index] = value;
    return copy;
};
var copyArrayLike = function copyArrayLike(arrayLike) {
    if (!arrayLike) return [];
    else if (Array.isArray(arrayLike)) return [].concat(arrayLike);
    else {
        var maxIndex = Object.keys(arrayLike).map(function(key) {
            return parseInt(key);
        }).reduce(function(max, el) {
            return el > max ? el : max;
        }, 0);
        return Array.from(_extends({}, arrayLike, {
            length: maxIndex + 1
        }));
    }
};
var createAlterationHandler = function createAlterationHandler(alteration, defaultFunction) {
    var fn = typeof alteration === "function" ? alteration : defaultFunction;
    return function(data) {
        if (Array.isArray(data) || isObject(data)) {
            var clone = copyArrayLike(data);
            return fn(clone);
        } // This can be assumed to be a primitive, which
        // is a case for top level validation errors
        return data;
    };
};
var FieldArrayInner = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(FieldArrayInner, _React$Component);
    function FieldArrayInner(props) {
        var _this;
        _this = _React$Component.call(this, props) || this; // We need TypeScript generics on these, so we'll bind them in the constructor
        // @todo Fix TS 3.2.1
        _this.updateArrayField = function(fn, alterTouched, alterErrors) {
            var _this$props = _this.props, name = _this$props.name, setFormikState = _this$props.formik.setFormikState;
            setFormikState(function(prevState) {
                var updateErrors = createAlterationHandler(alterErrors, fn);
                var updateTouched = createAlterationHandler(alterTouched, fn); // values fn should be executed before updateErrors and updateTouched,
                // otherwise it causes an error with unshift.
                var values = setIn(prevState.values, name, fn(getIn(prevState.values, name)));
                var fieldError = alterErrors ? updateErrors(getIn(prevState.errors, name)) : undefined;
                var fieldTouched = alterTouched ? updateTouched(getIn(prevState.touched, name)) : undefined;
                if (isEmptyArray(fieldError)) fieldError = undefined;
                if (isEmptyArray(fieldTouched)) fieldTouched = undefined;
                return _extends({}, prevState, {
                    values: values,
                    errors: alterErrors ? setIn(prevState.errors, name, fieldError) : prevState.errors,
                    touched: alterTouched ? setIn(prevState.touched, name, fieldTouched) : prevState.touched
                });
            });
        };
        _this.push = function(value) {
            return _this.updateArrayField(function(arrayLike) {
                return [].concat(copyArrayLike(arrayLike), [
                    (0, $2AJmr.default)(value)
                ]);
            }, false, false);
        };
        _this.handlePush = function(value) {
            return function() {
                return _this.push(value);
            };
        };
        _this.swap = function(indexA, indexB) {
            return _this.updateArrayField(function(array) {
                return swap(array, indexA, indexB);
            }, true, true);
        };
        _this.handleSwap = function(indexA, indexB) {
            return function() {
                return _this.swap(indexA, indexB);
            };
        };
        _this.move = function(from, to) {
            return _this.updateArrayField(function(array) {
                return move(array, from, to);
            }, true, true);
        };
        _this.handleMove = function(from, to) {
            return function() {
                return _this.move(from, to);
            };
        };
        _this.insert = function(index, value) {
            return _this.updateArrayField(function(array) {
                return insert(array, index, value);
            }, function(array) {
                return insert(array, index, null);
            }, function(array) {
                return insert(array, index, null);
            });
        };
        _this.handleInsert = function(index, value) {
            return function() {
                return _this.insert(index, value);
            };
        };
        _this.replace = function(index, value) {
            return _this.updateArrayField(function(array) {
                return replace(array, index, value);
            }, false, false);
        };
        _this.handleReplace = function(index, value) {
            return function() {
                return _this.replace(index, value);
            };
        };
        _this.unshift = function(value) {
            var length = -1;
            _this.updateArrayField(function(array) {
                var arr = array ? [
                    value
                ].concat(array) : [
                    value
                ];
                length = arr.length;
                return arr;
            }, function(array) {
                return array ? [
                    null
                ].concat(array) : [
                    null
                ];
            }, function(array) {
                return array ? [
                    null
                ].concat(array) : [
                    null
                ];
            });
            return length;
        };
        _this.handleUnshift = function(value) {
            return function() {
                return _this.unshift(value);
            };
        };
        _this.handleRemove = function(index) {
            return function() {
                return _this.remove(index);
            };
        };
        _this.handlePop = function() {
            return function() {
                return _this.pop();
            };
        };
        _this.remove = _this.remove.bind(_assertThisInitialized(_this));
        _this.pop = _this.pop.bind(_assertThisInitialized(_this));
        return _this;
    }
    var _proto = FieldArrayInner.prototype;
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.validateOnChange && this.props.formik.validateOnChange && !(0, (/*@__PURE__*/$parcel$interopDefault($31ATd)))(getIn(prevProps.formik.values, prevProps.name), getIn(this.props.formik.values, this.props.name))) this.props.formik.validateForm(this.props.formik.values);
    };
    _proto.remove = function remove(index) {
        // We need to make sure we also remove relevant pieces of `touched` and `errors`
        var result;
        this.updateArrayField(function(array) {
            var copy = array ? copyArrayLike(array) : [];
            if (!result) result = copy[index];
            if (isFunction(copy.splice)) copy.splice(index, 1);
             // if the array only includes undefined values we have to return an empty array
            return isFunction(copy.every) ? copy.every(function(v) {
                return v === undefined;
            }) ? [] : copy : copy;
        }, true, true);
        return result;
    };
    _proto.pop = function pop() {
        // Remove relevant pieces of `touched` and `errors` too!
        var result;
        this.updateArrayField(function(array) {
            var tmp = array.slice();
            if (!result) result = tmp && tmp.pop && tmp.pop();
            return tmp;
        }, true, true);
        return result;
    };
    _proto.render = function render() {
        var arrayHelpers = {
            push: this.push,
            pop: this.pop,
            swap: this.swap,
            move: this.move,
            insert: this.insert,
            replace: this.replace,
            unshift: this.unshift,
            remove: this.remove,
            handlePush: this.handlePush,
            handlePop: this.handlePop,
            handleSwap: this.handleSwap,
            handleMove: this.handleMove,
            handleInsert: this.handleInsert,
            handleReplace: this.handleReplace,
            handleUnshift: this.handleUnshift,
            handleRemove: this.handleRemove
        };
        var _this$props2 = this.props, component = _this$props2.component, render = _this$props2.render, children = _this$props2.children, name = _this$props2.name, _this$props2$formik = _this$props2.formik, restOfFormik = _objectWithoutPropertiesLoose(_this$props2$formik, [
            "validate",
            "validationSchema"
        ]);
        var props = _extends({}, arrayHelpers, {
            form: restOfFormik,
            name: name
        });
        return component ? (0, $kc00y.createElement)(component, props) : render ? render(props) : children // children come last, always called
         ? typeof children === "function" ? children(props) : !isEmptyChildren(children) ? (0, $kc00y.Children).only(children) : null : null;
    };
    return FieldArrayInner;
}((0, $kc00y.Component));
FieldArrayInner.defaultProps = {
    validateOnChange: true
};
var FieldArray = /*#__PURE__*/ connect(FieldArrayInner);
var ErrorMessageImpl = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(ErrorMessageImpl, _React$Component);
    function ErrorMessageImpl() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = ErrorMessageImpl.prototype;
    _proto.shouldComponentUpdate = function shouldComponentUpdate(props) {
        if (getIn(this.props.formik.errors, this.props.name) !== getIn(props.formik.errors, this.props.name) || getIn(this.props.formik.touched, this.props.name) !== getIn(props.formik.touched, this.props.name) || Object.keys(this.props).length !== Object.keys(props).length) return true;
        else return false;
    };
    _proto.render = function render() {
        var _this$props = this.props, component = _this$props.component, formik = _this$props.formik, render = _this$props.render, children = _this$props.children, name = _this$props.name, rest = _objectWithoutPropertiesLoose(_this$props, [
            "component",
            "formik",
            "render",
            "children",
            "name"
        ]);
        var touch = getIn(formik.touched, name);
        var error = getIn(formik.errors, name);
        return !!touch && !!error ? render ? isFunction(render) ? render(error) : null : children ? isFunction(children) ? children(error) : null : component ? (0, $kc00y.createElement)(component, rest, error) : error : null;
    };
    return ErrorMessageImpl;
}((0, $kc00y.Component));
var ErrorMessage = /*#__PURE__*/ connect(ErrorMessageImpl);
/**
 * Custom Field component for quickly hooking into Formik
 * context and wiring up forms.
 */ var FastFieldInner = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(FastFieldInner, _React$Component);
    function FastFieldInner(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        var render = props.render, children = props.children, component = props.component, is = props.as, name = props.name;
        !!render && (0, $8I1rW.default)(false);
        !!(component && render) && (0, $8I1rW.default)(false);
        !!(is && children && isFunction(children)) && (0, $8I1rW.default)(false);
        !!(component && children && isFunction(children)) && (0, $8I1rW.default)(false);
        !!(render && children && !isEmptyChildren(children)) && (0, $8I1rW.default)(false);
        return _this;
    }
    var _proto = FastFieldInner.prototype;
    _proto.shouldComponentUpdate = function shouldComponentUpdate(props) {
        if (this.props.shouldUpdate) return this.props.shouldUpdate(props, this.props);
        else if (props.name !== this.props.name || getIn(props.formik.values, this.props.name) !== getIn(this.props.formik.values, this.props.name) || getIn(props.formik.errors, this.props.name) !== getIn(this.props.formik.errors, this.props.name) || getIn(props.formik.touched, this.props.name) !== getIn(this.props.formik.touched, this.props.name) || Object.keys(this.props).length !== Object.keys(props).length || props.formik.isSubmitting !== this.props.formik.isSubmitting) return true;
        else return false;
    };
    _proto.componentDidMount = function componentDidMount() {
        // Register the Field with the parent Formik. Parent will cycle through
        // registered Field's validate fns right prior to submit
        this.props.formik.registerField(this.props.name, {
            validate: this.props.validate
        });
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.name !== prevProps.name) {
            this.props.formik.unregisterField(prevProps.name);
            this.props.formik.registerField(this.props.name, {
                validate: this.props.validate
            });
        }
        if (this.props.validate !== prevProps.validate) this.props.formik.registerField(this.props.name, {
            validate: this.props.validate
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.props.formik.unregisterField(this.props.name);
    };
    _proto.render = function render() {
        var _this$props = this.props, name = _this$props.name, render = _this$props.render, is = _this$props.as, children = _this$props.children, component = _this$props.component, formik = _this$props.formik, props = _objectWithoutPropertiesLoose(_this$props, [
            "validate",
            "name",
            "render",
            "as",
            "children",
            "component",
            "shouldUpdate",
            "formik"
        ]);
        var restOfFormik = _objectWithoutPropertiesLoose(formik, [
            "validate",
            "validationSchema"
        ]);
        var field = formik.getFieldProps(_extends({
            name: name
        }, props));
        var meta = {
            value: getIn(formik.values, name),
            error: getIn(formik.errors, name),
            touched: !!getIn(formik.touched, name),
            initialValue: getIn(formik.initialValues, name),
            initialTouched: !!getIn(formik.initialTouched, name),
            initialError: getIn(formik.initialErrors, name)
        };
        var bag = {
            field: field,
            meta: meta,
            form: restOfFormik
        };
        if (render) return render(bag);
        if (isFunction(children)) return children(bag);
        if (component) {
            // This behavior is backwards compat with earlier Formik 0.9 to 1.x
            if (typeof component === "string") {
                var innerRef = props.innerRef, rest = _objectWithoutPropertiesLoose(props, [
                    "innerRef"
                ]);
                return (0, $kc00y.createElement)(component, _extends({
                    ref: innerRef
                }, field, rest), children);
            } // We don't pass `meta` for backwards compat
            return (0, $kc00y.createElement)(component, _extends({
                field: field,
                form: formik
            }, props), children);
        } // default to input here so we can check for both `as` and `children` above
        var asElement = is || "input";
        if (typeof asElement === "string") {
            var _innerRef = props.innerRef, _rest = _objectWithoutPropertiesLoose(props, [
                "innerRef"
            ]);
            return (0, $kc00y.createElement)(asElement, _extends({
                ref: _innerRef
            }, field, _rest), children);
        }
        return (0, $kc00y.createElement)(asElement, _extends({}, field, props), children);
    };
    return FastFieldInner;
}((0, $kc00y.Component));
var FastField = /*#__PURE__*/ connect(FastFieldInner);

});
parcelRegister("kMZku", function(module, exports) {

$parcel$export(module.exports, "default", () => $f227dd149481e5b0$export$2e2bcd8739ae039);
var $f227dd149481e5b0$var$isMergeableObject = function isMergeableObject(value) {
    return $f227dd149481e5b0$var$isNonNullObject(value) && !$f227dd149481e5b0$var$isSpecial(value);
};
function $f227dd149481e5b0$var$isNonNullObject(value) {
    return !!value && typeof value === "object";
}
function $f227dd149481e5b0$var$isSpecial(value) {
    var stringValue = Object.prototype.toString.call(value);
    return stringValue === "[object RegExp]" || stringValue === "[object Date]" || $f227dd149481e5b0$var$isReactElement(value);
}
// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var $f227dd149481e5b0$var$canUseSymbol = typeof Symbol === "function" && Symbol.for;
var $f227dd149481e5b0$var$REACT_ELEMENT_TYPE = $f227dd149481e5b0$var$canUseSymbol ? Symbol.for("react.element") : 0xeac7;
function $f227dd149481e5b0$var$isReactElement(value) {
    return value.$$typeof === $f227dd149481e5b0$var$REACT_ELEMENT_TYPE;
}
function $f227dd149481e5b0$var$emptyTarget(val) {
    return Array.isArray(val) ? [] : {};
}
function $f227dd149481e5b0$var$cloneUnlessOtherwiseSpecified(value, options) {
    return options.clone !== false && options.isMergeableObject(value) ? $f227dd149481e5b0$var$deepmerge($f227dd149481e5b0$var$emptyTarget(value), value, options) : value;
}
function $f227dd149481e5b0$var$defaultArrayMerge(target, source, options) {
    return target.concat(source).map(function(element) {
        return $f227dd149481e5b0$var$cloneUnlessOtherwiseSpecified(element, options);
    });
}
function $f227dd149481e5b0$var$mergeObject(target, source, options) {
    var destination = {};
    if (options.isMergeableObject(target)) Object.keys(target).forEach(function(key) {
        destination[key] = $f227dd149481e5b0$var$cloneUnlessOtherwiseSpecified(target[key], options);
    });
    Object.keys(source).forEach(function(key) {
        if (!options.isMergeableObject(source[key]) || !target[key]) destination[key] = $f227dd149481e5b0$var$cloneUnlessOtherwiseSpecified(source[key], options);
        else destination[key] = $f227dd149481e5b0$var$deepmerge(target[key], source[key], options);
    });
    return destination;
}
function $f227dd149481e5b0$var$deepmerge(target, source, options) {
    options = options || {};
    options.arrayMerge = options.arrayMerge || $f227dd149481e5b0$var$defaultArrayMerge;
    options.isMergeableObject = options.isMergeableObject || $f227dd149481e5b0$var$isMergeableObject;
    var sourceIsArray = Array.isArray(source);
    var targetIsArray = Array.isArray(target);
    var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
    if (!sourceAndTargetTypesMatch) return $f227dd149481e5b0$var$cloneUnlessOtherwiseSpecified(source, options);
    else if (sourceIsArray) return options.arrayMerge(target, source, options);
    else return $f227dd149481e5b0$var$mergeObject(target, source, options);
}
$f227dd149481e5b0$var$deepmerge.all = function deepmergeAll(array, options) {
    if (!Array.isArray(array)) throw new Error("first argument should be an array");
    return array.reduce(function(prev, next) {
        return $f227dd149481e5b0$var$deepmerge(prev, next, options);
    }, {});
};
var $f227dd149481e5b0$var$deepmerge_1 = $f227dd149481e5b0$var$deepmerge;
var $f227dd149481e5b0$export$2e2bcd8739ae039 = $f227dd149481e5b0$var$deepmerge_1;

});

parcelRegister("eBHEL", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa2662a89171ae10$export$2e2bcd8739ae039);

var $42LVW = parcelRequire("42LVW");

var $agrfU = parcelRequire("agrfU");

var $b8tfT = parcelRequire("b8tfT");
/** `Object#toString` result references. */ var $aa2662a89171ae10$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $aa2662a89171ae10$var$funcProto = Function.prototype, $aa2662a89171ae10$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $aa2662a89171ae10$var$funcToString = $aa2662a89171ae10$var$funcProto.toString;
/** Used to check objects for own properties. */ var $aa2662a89171ae10$var$hasOwnProperty = $aa2662a89171ae10$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $aa2662a89171ae10$var$objectCtorString = $aa2662a89171ae10$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $aa2662a89171ae10$var$isPlainObject(value) {
    if (!(0, $b8tfT.default)(value) || (0, $42LVW.default)(value) != $aa2662a89171ae10$var$objectTag) return false;
    var proto = (0, $agrfU.default)(value);
    if (proto === null) return true;
    var Ctor = $aa2662a89171ae10$var$hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && $aa2662a89171ae10$var$funcToString.call(Ctor) == $aa2662a89171ae10$var$objectCtorString;
}
var $aa2662a89171ae10$export$2e2bcd8739ae039 = $aa2662a89171ae10$var$isPlainObject;

});
parcelRegister("42LVW", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f1c87ee3d12b8f1$export$2e2bcd8739ae039);

var $cVOod = parcelRequire("cVOod");

var $edPn7 = parcelRequire("edPn7");

var $jn1Mc = parcelRequire("jn1Mc");
/** `Object#toString` result references. */ var $2f1c87ee3d12b8f1$var$nullTag = "[object Null]", $2f1c87ee3d12b8f1$var$undefinedTag = "[object Undefined]";
/** Built-in value references. */ var $2f1c87ee3d12b8f1$var$symToStringTag = (0, $cVOod.default) ? (0, $cVOod.default).toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $2f1c87ee3d12b8f1$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $2f1c87ee3d12b8f1$var$undefinedTag : $2f1c87ee3d12b8f1$var$nullTag;
    return $2f1c87ee3d12b8f1$var$symToStringTag && $2f1c87ee3d12b8f1$var$symToStringTag in Object(value) ? (0, $edPn7.default)(value) : (0, $jn1Mc.default)(value);
}
var $2f1c87ee3d12b8f1$export$2e2bcd8739ae039 = $2f1c87ee3d12b8f1$var$baseGetTag;

});
parcelRegister("cVOod", function(module, exports) {

$parcel$export(module.exports, "default", () => $96a1e53ccc652a6a$export$2e2bcd8739ae039);

var $aQKD3 = parcelRequire("aQKD3");
/** Built-in value references. */ var $96a1e53ccc652a6a$var$Symbol = (0, $aQKD3.default).Symbol;
var $96a1e53ccc652a6a$export$2e2bcd8739ae039 = $96a1e53ccc652a6a$var$Symbol;

});
parcelRegister("aQKD3", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e62ee42f28f292a$export$2e2bcd8739ae039);

var $7oxg8 = parcelRequire("7oxg8");
/** Detect free variable `self`. */ var $7e62ee42f28f292a$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $7e62ee42f28f292a$var$root = (0, $7oxg8.default) || $7e62ee42f28f292a$var$freeSelf || Function("return this")();
var $7e62ee42f28f292a$export$2e2bcd8739ae039 = $7e62ee42f28f292a$var$root;

});
parcelRegister("7oxg8", function(module, exports) {

$parcel$export(module.exports, "default", () => $562492e835c708c5$export$2e2bcd8739ae039);
/** Detect free variable `global` from Node.js. */ var $562492e835c708c5$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
var $562492e835c708c5$export$2e2bcd8739ae039 = $562492e835c708c5$var$freeGlobal;

});



parcelRegister("edPn7", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5aa20f7b95698c3$export$2e2bcd8739ae039);

var $cVOod = parcelRequire("cVOod");
/** Used for built-in method references. */ var $a5aa20f7b95698c3$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $a5aa20f7b95698c3$var$hasOwnProperty = $a5aa20f7b95698c3$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $a5aa20f7b95698c3$var$nativeObjectToString = $a5aa20f7b95698c3$var$objectProto.toString;
/** Built-in value references. */ var $a5aa20f7b95698c3$var$symToStringTag = (0, $cVOod.default) ? (0, $cVOod.default).toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $a5aa20f7b95698c3$var$getRawTag(value) {
    var isOwn = $a5aa20f7b95698c3$var$hasOwnProperty.call(value, $a5aa20f7b95698c3$var$symToStringTag), tag = value[$a5aa20f7b95698c3$var$symToStringTag];
    try {
        value[$a5aa20f7b95698c3$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $a5aa20f7b95698c3$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$a5aa20f7b95698c3$var$symToStringTag] = tag;
        else delete value[$a5aa20f7b95698c3$var$symToStringTag];
    }
    return result;
}
var $a5aa20f7b95698c3$export$2e2bcd8739ae039 = $a5aa20f7b95698c3$var$getRawTag;

});

parcelRegister("jn1Mc", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1a18b158880239c$export$2e2bcd8739ae039);
/** Used for built-in method references. */ var $e1a18b158880239c$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $e1a18b158880239c$var$nativeObjectToString = $e1a18b158880239c$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $e1a18b158880239c$var$objectToString(value) {
    return $e1a18b158880239c$var$nativeObjectToString.call(value);
}
var $e1a18b158880239c$export$2e2bcd8739ae039 = $e1a18b158880239c$var$objectToString;

});


parcelRegister("agrfU", function(module, exports) {

$parcel$export(module.exports, "default", () => $77908a6195a5b3d0$export$2e2bcd8739ae039);

var $7NogN = parcelRequire("7NogN");
/** Built-in value references. */ var $77908a6195a5b3d0$var$getPrototype = (0, $7NogN.default)(Object.getPrototypeOf, Object);
var $77908a6195a5b3d0$export$2e2bcd8739ae039 = $77908a6195a5b3d0$var$getPrototype;

});
parcelRegister("7NogN", function(module, exports) {

$parcel$export(module.exports, "default", () => $5acfef831dc6d8d3$export$2e2bcd8739ae039);
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $5acfef831dc6d8d3$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
var $5acfef831dc6d8d3$export$2e2bcd8739ae039 = $5acfef831dc6d8d3$var$overArg;

});


parcelRegister("b8tfT", function(module, exports) {

$parcel$export(module.exports, "default", () => $81b722907b378862$export$2e2bcd8739ae039);
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $81b722907b378862$var$isObjectLike(value) {
    return value != null && typeof value == "object";
}
var $81b722907b378862$export$2e2bcd8739ae039 = $81b722907b378862$var$isObjectLike;

});


parcelRegister("2AJmr", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e32214946f434bc$export$2e2bcd8739ae039);

var $bslYV = parcelRequire("bslYV");
/** Used to compose bitmasks for cloning. */ var $1e32214946f434bc$var$CLONE_DEEP_FLAG = 1, $1e32214946f434bc$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function $1e32214946f434bc$var$cloneDeep(value) {
    return (0, $bslYV.default)(value, $1e32214946f434bc$var$CLONE_DEEP_FLAG | $1e32214946f434bc$var$CLONE_SYMBOLS_FLAG);
}
var $1e32214946f434bc$export$2e2bcd8739ae039 = $1e32214946f434bc$var$cloneDeep;

});
parcelRegister("bslYV", function(module, exports) {

$parcel$export(module.exports, "default", () => $85735c5a52728133$export$2e2bcd8739ae039);

var $lFkAg = parcelRequire("lFkAg");

var $6lJDe = parcelRequire("6lJDe");

var $bmh9S = parcelRequire("bmh9S");

var $kjffV = parcelRequire("kjffV");

var $1PQuT = parcelRequire("1PQuT");

var $Irws4 = parcelRequire("Irws4");

var $fJXTB = parcelRequire("fJXTB");

var $512AJ = parcelRequire("512AJ");

var $8qOaq = parcelRequire("8qOaq");

var $lKcsa = parcelRequire("lKcsa");

var $ggB7P = parcelRequire("ggB7P");

var $fb5Xy = parcelRequire("fb5Xy");

var $35jdz = parcelRequire("35jdz");

var $6idGg = parcelRequire("6idGg");

var $ktsYn = parcelRequire("ktsYn");

var $i48KB = parcelRequire("i48KB");

var $21qzi = parcelRequire("21qzi");

var $jixRw = parcelRequire("jixRw");

var $aWBxg = parcelRequire("aWBxg");

var $7WLtA = parcelRequire("7WLtA");

var $lMs27 = parcelRequire("lMs27");

var $b8cgV = parcelRequire("b8cgV");
/** Used to compose bitmasks for cloning. */ var $85735c5a52728133$var$CLONE_DEEP_FLAG = 1, $85735c5a52728133$var$CLONE_FLAT_FLAG = 2, $85735c5a52728133$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $85735c5a52728133$var$argsTag = "[object Arguments]", $85735c5a52728133$var$arrayTag = "[object Array]", $85735c5a52728133$var$boolTag = "[object Boolean]", $85735c5a52728133$var$dateTag = "[object Date]", $85735c5a52728133$var$errorTag = "[object Error]", $85735c5a52728133$var$funcTag = "[object Function]", $85735c5a52728133$var$genTag = "[object GeneratorFunction]", $85735c5a52728133$var$mapTag = "[object Map]", $85735c5a52728133$var$numberTag = "[object Number]", $85735c5a52728133$var$objectTag = "[object Object]", $85735c5a52728133$var$regexpTag = "[object RegExp]", $85735c5a52728133$var$setTag = "[object Set]", $85735c5a52728133$var$stringTag = "[object String]", $85735c5a52728133$var$symbolTag = "[object Symbol]", $85735c5a52728133$var$weakMapTag = "[object WeakMap]";
var $85735c5a52728133$var$arrayBufferTag = "[object ArrayBuffer]", $85735c5a52728133$var$dataViewTag = "[object DataView]", $85735c5a52728133$var$float32Tag = "[object Float32Array]", $85735c5a52728133$var$float64Tag = "[object Float64Array]", $85735c5a52728133$var$int8Tag = "[object Int8Array]", $85735c5a52728133$var$int16Tag = "[object Int16Array]", $85735c5a52728133$var$int32Tag = "[object Int32Array]", $85735c5a52728133$var$uint8Tag = "[object Uint8Array]", $85735c5a52728133$var$uint8ClampedTag = "[object Uint8ClampedArray]", $85735c5a52728133$var$uint16Tag = "[object Uint16Array]", $85735c5a52728133$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $85735c5a52728133$var$cloneableTags = {};
$85735c5a52728133$var$cloneableTags[$85735c5a52728133$var$argsTag] = $85735c5a52728133$var$cloneableTags[$85735c5a52728133$var$arrayTag] = $85735c5a52728133$var$cloneableTags[$85735c5a52728133$var$arrayBufferTag] = $85735c5a52728133$var$cloneableTags[$85735c5a52728133$var$dataViewTag] = $85735c5a52728133$var$cloneableTags[$85735c5a52728133$var$boolTag] = $85735c5a52728133$var$cloneableTags[$85735c5a52728133$var$dateTag] = $85735c5a52728133$var$cloneableTags[$85735c5a52728133$var$float32Tag] = $85735c5a52728133$var$cloneableTags[$85735c5a52728133$var$float64Tag] = $85735c5a52728133$var$cloneableTags[$85735c5a52728133$var$int8Tag] = $85735c5a52728133$var$cloneableTags[$85735c5a52728133$var$int16Tag] = $85735c5a52728133$var$cloneableTags[$85735c5a52728133$var$int32Tag] = $85735c5a52728133$var$cloneableTags[$85735c5a52728133$var$mapTag] = $85735c5a52728133$var$cloneableTags[$85735c5a52728133$var$numberTag] = $85735c5a52728133$var$cloneableTags[$85735c5a52728133$var$objectTag] = $85735c5a52728133$var$cloneableTags[$85735c5a52728133$var$regexpTag] = $85735c5a52728133$var$cloneableTags[$85735c5a52728133$var$setTag] = $85735c5a52728133$var$cloneableTags[$85735c5a52728133$var$stringTag] = $85735c5a52728133$var$cloneableTags[$85735c5a52728133$var$symbolTag] = $85735c5a52728133$var$cloneableTags[$85735c5a52728133$var$uint8Tag] = $85735c5a52728133$var$cloneableTags[$85735c5a52728133$var$uint8ClampedTag] = $85735c5a52728133$var$cloneableTags[$85735c5a52728133$var$uint16Tag] = $85735c5a52728133$var$cloneableTags[$85735c5a52728133$var$uint32Tag] = true;
$85735c5a52728133$var$cloneableTags[$85735c5a52728133$var$errorTag] = $85735c5a52728133$var$cloneableTags[$85735c5a52728133$var$funcTag] = $85735c5a52728133$var$cloneableTags[$85735c5a52728133$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $85735c5a52728133$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $85735c5a52728133$var$CLONE_DEEP_FLAG, isFlat = bitmask & $85735c5a52728133$var$CLONE_FLAT_FLAG, isFull = bitmask & $85735c5a52728133$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!(0, $aWBxg.default)(value)) return value;
    var isArr = (0, $i48KB.default)(value);
    if (isArr) {
        result = (0, $35jdz.default)(value);
        if (!isDeep) return (0, $fJXTB.default)(value, result);
    } else {
        var tag = (0, $fb5Xy.default)(value), isFunc = tag == $85735c5a52728133$var$funcTag || tag == $85735c5a52728133$var$genTag;
        if ((0, $21qzi.default)(value)) return (0, $Irws4.default)(value, isDeep);
        if (tag == $85735c5a52728133$var$objectTag || tag == $85735c5a52728133$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : (0, $ktsYn.default)(value);
            if (!isDeep) return isFlat ? (0, $8qOaq.default)(value, (0, $1PQuT.default)(result, value)) : (0, $512AJ.default)(value, (0, $kjffV.default)(result, value));
        } else {
            if (!$85735c5a52728133$var$cloneableTags[tag]) return object ? value : {};
            result = (0, $6idGg.default)(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new (0, $lFkAg.default));
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ((0, $7WLtA.default)(value)) value.forEach(function(subValue) {
        result.add($85735c5a52728133$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ((0, $jixRw.default)(value)) value.forEach(function(subValue, key) {
        result.set(key, $85735c5a52728133$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? (0, $ggB7P.default) : (0, $lKcsa.default) : isFlat ? (0, $b8cgV.default) : (0, $lMs27.default);
    var props = isArr ? undefined : keysFunc(value);
    (0, $6lJDe.default)(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        (0, $bmh9S.default)(result, key, $85735c5a52728133$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
var $85735c5a52728133$export$2e2bcd8739ae039 = $85735c5a52728133$var$baseClone;

});
parcelRegister("lFkAg", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc5d64da7c4048b9$export$2e2bcd8739ae039);

var $PBKD1 = parcelRequire("PBKD1");

var $fh68K = parcelRequire("fh68K");

var $9Ayg3 = parcelRequire("9Ayg3");

var $6oJVY = parcelRequire("6oJVY");

var $2Ipyc = parcelRequire("2Ipyc");

var $jaoGy = parcelRequire("jaoGy");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $fc5d64da7c4048b9$var$Stack(entries) {
    var data = this.__data__ = new (0, $PBKD1.default)(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$fc5d64da7c4048b9$var$Stack.prototype.clear = (0, $fh68K.default);
$fc5d64da7c4048b9$var$Stack.prototype["delete"] = (0, $9Ayg3.default);
$fc5d64da7c4048b9$var$Stack.prototype.get = (0, $6oJVY.default);
$fc5d64da7c4048b9$var$Stack.prototype.has = (0, $2Ipyc.default);
$fc5d64da7c4048b9$var$Stack.prototype.set = (0, $jaoGy.default);
var $fc5d64da7c4048b9$export$2e2bcd8739ae039 = $fc5d64da7c4048b9$var$Stack;

});
parcelRegister("PBKD1", function(module, exports) {

$parcel$export(module.exports, "default", () => $09b20c1c6183aceb$export$2e2bcd8739ae039);

var $1Ugep = parcelRequire("1Ugep");

var $4vDTd = parcelRequire("4vDTd");

var $b5V4h = parcelRequire("b5V4h");

var $b8nMe = parcelRequire("b8nMe");

var $cCigt = parcelRequire("cCigt");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $09b20c1c6183aceb$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$09b20c1c6183aceb$var$ListCache.prototype.clear = (0, $1Ugep.default);
$09b20c1c6183aceb$var$ListCache.prototype["delete"] = (0, $4vDTd.default);
$09b20c1c6183aceb$var$ListCache.prototype.get = (0, $b5V4h.default);
$09b20c1c6183aceb$var$ListCache.prototype.has = (0, $b8nMe.default);
$09b20c1c6183aceb$var$ListCache.prototype.set = (0, $cCigt.default);
var $09b20c1c6183aceb$export$2e2bcd8739ae039 = $09b20c1c6183aceb$var$ListCache;

});
parcelRegister("1Ugep", function(module, exports) {

$parcel$export(module.exports, "default", () => $16379ca4287e7091$export$2e2bcd8739ae039);
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $16379ca4287e7091$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
var $16379ca4287e7091$export$2e2bcd8739ae039 = $16379ca4287e7091$var$listCacheClear;

});

parcelRegister("4vDTd", function(module, exports) {

$parcel$export(module.exports, "default", () => $3488ffe543a2677b$export$2e2bcd8739ae039);

var $289bT = parcelRequire("289bT");
/** Used for built-in method references. */ var $3488ffe543a2677b$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $3488ffe543a2677b$var$splice = $3488ffe543a2677b$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $3488ffe543a2677b$var$listCacheDelete(key) {
    var data = this.__data__, index = (0, $289bT.default)(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $3488ffe543a2677b$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
var $3488ffe543a2677b$export$2e2bcd8739ae039 = $3488ffe543a2677b$var$listCacheDelete;

});
parcelRegister("289bT", function(module, exports) {

$parcel$export(module.exports, "default", () => $18d3754113df963d$export$2e2bcd8739ae039);

var $ka1tK = parcelRequire("ka1tK");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $18d3754113df963d$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ((0, $ka1tK.default)(array[length][0], key)) return length;
    }
    return -1;
}
var $18d3754113df963d$export$2e2bcd8739ae039 = $18d3754113df963d$var$assocIndexOf;

});
parcelRegister("ka1tK", function(module, exports) {

$parcel$export(module.exports, "default", () => $ead5e37c46f2b6bc$export$2e2bcd8739ae039);
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $ead5e37c46f2b6bc$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
var $ead5e37c46f2b6bc$export$2e2bcd8739ae039 = $ead5e37c46f2b6bc$var$eq;

});



parcelRegister("b5V4h", function(module, exports) {

$parcel$export(module.exports, "default", () => $813c6ddc4e26bc27$export$2e2bcd8739ae039);

var $289bT = parcelRequire("289bT");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $813c6ddc4e26bc27$var$listCacheGet(key) {
    var data = this.__data__, index = (0, $289bT.default)(data, key);
    return index < 0 ? undefined : data[index][1];
}
var $813c6ddc4e26bc27$export$2e2bcd8739ae039 = $813c6ddc4e26bc27$var$listCacheGet;

});

parcelRegister("b8nMe", function(module, exports) {

$parcel$export(module.exports, "default", () => $81b2e2a4f10d40cc$export$2e2bcd8739ae039);

var $289bT = parcelRequire("289bT");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $81b2e2a4f10d40cc$var$listCacheHas(key) {
    return (0, $289bT.default)(this.__data__, key) > -1;
}
var $81b2e2a4f10d40cc$export$2e2bcd8739ae039 = $81b2e2a4f10d40cc$var$listCacheHas;

});

parcelRegister("cCigt", function(module, exports) {

$parcel$export(module.exports, "default", () => $92f733a1cbd298c5$export$2e2bcd8739ae039);

var $289bT = parcelRequire("289bT");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $92f733a1cbd298c5$var$listCacheSet(key, value) {
    var data = this.__data__, index = (0, $289bT.default)(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
var $92f733a1cbd298c5$export$2e2bcd8739ae039 = $92f733a1cbd298c5$var$listCacheSet;

});


parcelRegister("fh68K", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1ed34d81fdc9ca2$export$2e2bcd8739ae039);

var $PBKD1 = parcelRequire("PBKD1");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $b1ed34d81fdc9ca2$var$stackClear() {
    this.__data__ = new (0, $PBKD1.default);
    this.size = 0;
}
var $b1ed34d81fdc9ca2$export$2e2bcd8739ae039 = $b1ed34d81fdc9ca2$var$stackClear;

});

parcelRegister("9Ayg3", function(module, exports) {

$parcel$export(module.exports, "default", () => $6fb20cbe591414a1$export$2e2bcd8739ae039);
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $6fb20cbe591414a1$var$stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
var $6fb20cbe591414a1$export$2e2bcd8739ae039 = $6fb20cbe591414a1$var$stackDelete;

});

parcelRegister("6oJVY", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a889d879c36cd52$export$2e2bcd8739ae039);
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $4a889d879c36cd52$var$stackGet(key) {
    return this.__data__.get(key);
}
var $4a889d879c36cd52$export$2e2bcd8739ae039 = $4a889d879c36cd52$var$stackGet;

});

parcelRegister("2Ipyc", function(module, exports) {

$parcel$export(module.exports, "default", () => $1fa382a81714a6ea$export$2e2bcd8739ae039);
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $1fa382a81714a6ea$var$stackHas(key) {
    return this.__data__.has(key);
}
var $1fa382a81714a6ea$export$2e2bcd8739ae039 = $1fa382a81714a6ea$var$stackHas;

});

parcelRegister("jaoGy", function(module, exports) {

$parcel$export(module.exports, "default", () => $df42198290ead1e2$export$2e2bcd8739ae039);

var $PBKD1 = parcelRequire("PBKD1");

var $eHZZw = parcelRequire("eHZZw");

var $8Ufnm = parcelRequire("8Ufnm");
/** Used as the size to enable large array optimizations. */ var $df42198290ead1e2$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $df42198290ead1e2$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof (0, $PBKD1.default)) {
        var pairs = data.__data__;
        if (!(0, $eHZZw.default) || pairs.length < $df42198290ead1e2$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new (0, $8Ufnm.default)(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
var $df42198290ead1e2$export$2e2bcd8739ae039 = $df42198290ead1e2$var$stackSet;

});
parcelRegister("eHZZw", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab552b0a7f560ad9$export$2e2bcd8739ae039);

var $9IkTg = parcelRequire("9IkTg");

var $aQKD3 = parcelRequire("aQKD3");
/* Built-in method references that are verified to be native. */ var $ab552b0a7f560ad9$var$Map = (0, $9IkTg.default)((0, $aQKD3.default), "Map");
var $ab552b0a7f560ad9$export$2e2bcd8739ae039 = $ab552b0a7f560ad9$var$Map;

});
parcelRegister("9IkTg", function(module, exports) {

$parcel$export(module.exports, "default", () => $71286d7dc238b5c8$export$2e2bcd8739ae039);

var $3oFA5 = parcelRequire("3oFA5");

var $7rf8B = parcelRequire("7rf8B");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $71286d7dc238b5c8$var$getNative(object, key) {
    var value = (0, $7rf8B.default)(object, key);
    return (0, $3oFA5.default)(value) ? value : undefined;
}
var $71286d7dc238b5c8$export$2e2bcd8739ae039 = $71286d7dc238b5c8$var$getNative;

});
parcelRegister("3oFA5", function(module, exports) {

$parcel$export(module.exports, "default", () => $2793de1d576239b3$export$2e2bcd8739ae039);

var $mLztR = parcelRequire("mLztR");

var $kJ822 = parcelRequire("kJ822");

var $aWBxg = parcelRequire("aWBxg");

var $l1IED = parcelRequire("l1IED");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $2793de1d576239b3$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $2793de1d576239b3$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $2793de1d576239b3$var$funcProto = Function.prototype, $2793de1d576239b3$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $2793de1d576239b3$var$funcToString = $2793de1d576239b3$var$funcProto.toString;
/** Used to check objects for own properties. */ var $2793de1d576239b3$var$hasOwnProperty = $2793de1d576239b3$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $2793de1d576239b3$var$reIsNative = RegExp("^" + $2793de1d576239b3$var$funcToString.call($2793de1d576239b3$var$hasOwnProperty).replace($2793de1d576239b3$var$reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $2793de1d576239b3$var$baseIsNative(value) {
    if (!(0, $aWBxg.default)(value) || (0, $kJ822.default)(value)) return false;
    var pattern = (0, $mLztR.default)(value) ? $2793de1d576239b3$var$reIsNative : $2793de1d576239b3$var$reIsHostCtor;
    return pattern.test((0, $l1IED.default)(value));
}
var $2793de1d576239b3$export$2e2bcd8739ae039 = $2793de1d576239b3$var$baseIsNative;

});
parcelRegister("mLztR", function(module, exports) {

$parcel$export(module.exports, "default", () => $0446f4d9f8aac06f$export$2e2bcd8739ae039);

var $42LVW = parcelRequire("42LVW");

var $aWBxg = parcelRequire("aWBxg");
/** `Object#toString` result references. */ var $0446f4d9f8aac06f$var$asyncTag = "[object AsyncFunction]", $0446f4d9f8aac06f$var$funcTag = "[object Function]", $0446f4d9f8aac06f$var$genTag = "[object GeneratorFunction]", $0446f4d9f8aac06f$var$proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $0446f4d9f8aac06f$var$isFunction(value) {
    if (!(0, $aWBxg.default)(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = (0, $42LVW.default)(value);
    return tag == $0446f4d9f8aac06f$var$funcTag || tag == $0446f4d9f8aac06f$var$genTag || tag == $0446f4d9f8aac06f$var$asyncTag || tag == $0446f4d9f8aac06f$var$proxyTag;
}
var $0446f4d9f8aac06f$export$2e2bcd8739ae039 = $0446f4d9f8aac06f$var$isFunction;

});
parcelRegister("aWBxg", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f7c6fee675f6d2a$export$2e2bcd8739ae039);
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $7f7c6fee675f6d2a$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
var $7f7c6fee675f6d2a$export$2e2bcd8739ae039 = $7f7c6fee675f6d2a$var$isObject;

});


parcelRegister("kJ822", function(module, exports) {

$parcel$export(module.exports, "default", () => $f16e3d9a2891981c$export$2e2bcd8739ae039);

var $9W3lv = parcelRequire("9W3lv");
/** Used to detect methods masquerading as native. */ var $f16e3d9a2891981c$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec((0, $9W3lv.default) && (0, $9W3lv.default).keys && (0, $9W3lv.default).keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $f16e3d9a2891981c$var$isMasked(func) {
    return !!$f16e3d9a2891981c$var$maskSrcKey && $f16e3d9a2891981c$var$maskSrcKey in func;
}
var $f16e3d9a2891981c$export$2e2bcd8739ae039 = $f16e3d9a2891981c$var$isMasked;

});
parcelRegister("9W3lv", function(module, exports) {

$parcel$export(module.exports, "default", () => $73bc2043982af0ca$export$2e2bcd8739ae039);

var $aQKD3 = parcelRequire("aQKD3");
/** Used to detect overreaching core-js shims. */ var $73bc2043982af0ca$var$coreJsData = (0, $aQKD3.default)["__core-js_shared__"];
var $73bc2043982af0ca$export$2e2bcd8739ae039 = $73bc2043982af0ca$var$coreJsData;

});


parcelRegister("l1IED", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4ec546ab468a7dc$export$2e2bcd8739ae039);
/** Used for built-in method references. */ var $f4ec546ab468a7dc$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $f4ec546ab468a7dc$var$funcToString = $f4ec546ab468a7dc$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $f4ec546ab468a7dc$var$toSource(func) {
    if (func != null) {
        try {
            return $f4ec546ab468a7dc$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
var $f4ec546ab468a7dc$export$2e2bcd8739ae039 = $f4ec546ab468a7dc$var$toSource;

});


parcelRegister("7rf8B", function(module, exports) {

$parcel$export(module.exports, "default", () => $56a6cc0be8fd06b6$export$2e2bcd8739ae039);
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $56a6cc0be8fd06b6$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
var $56a6cc0be8fd06b6$export$2e2bcd8739ae039 = $56a6cc0be8fd06b6$var$getValue;

});



parcelRegister("8Ufnm", function(module, exports) {

$parcel$export(module.exports, "default", () => $67bf7b05312b11f0$export$2e2bcd8739ae039);

var $awj6d = parcelRequire("awj6d");

var $ax9wf = parcelRequire("ax9wf");

var $6L0Pz = parcelRequire("6L0Pz");

var $62NfI = parcelRequire("62NfI");

var $3NrLi = parcelRequire("3NrLi");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $67bf7b05312b11f0$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$67bf7b05312b11f0$var$MapCache.prototype.clear = (0, $awj6d.default);
$67bf7b05312b11f0$var$MapCache.prototype["delete"] = (0, $ax9wf.default);
$67bf7b05312b11f0$var$MapCache.prototype.get = (0, $6L0Pz.default);
$67bf7b05312b11f0$var$MapCache.prototype.has = (0, $62NfI.default);
$67bf7b05312b11f0$var$MapCache.prototype.set = (0, $3NrLi.default);
var $67bf7b05312b11f0$export$2e2bcd8739ae039 = $67bf7b05312b11f0$var$MapCache;

});
parcelRegister("awj6d", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a8bb547aedc70d2$export$2e2bcd8739ae039);

var $kWBDP = parcelRequire("kWBDP");

var $PBKD1 = parcelRequire("PBKD1");

var $eHZZw = parcelRequire("eHZZw");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $7a8bb547aedc70d2$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new (0, $kWBDP.default),
        "map": new ((0, $eHZZw.default) || (0, $PBKD1.default)),
        "string": new (0, $kWBDP.default)
    };
}
var $7a8bb547aedc70d2$export$2e2bcd8739ae039 = $7a8bb547aedc70d2$var$mapCacheClear;

});
parcelRegister("kWBDP", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3f66c3ce295bc56$export$2e2bcd8739ae039);

var $2fmLM = parcelRequire("2fmLM");

var $ic6Ds = parcelRequire("ic6Ds");

var $3fDDg = parcelRequire("3fDDg");

var $j57Yg = parcelRequire("j57Yg");

var $kbeuV = parcelRequire("kbeuV");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $f3f66c3ce295bc56$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$f3f66c3ce295bc56$var$Hash.prototype.clear = (0, $2fmLM.default);
$f3f66c3ce295bc56$var$Hash.prototype["delete"] = (0, $ic6Ds.default);
$f3f66c3ce295bc56$var$Hash.prototype.get = (0, $3fDDg.default);
$f3f66c3ce295bc56$var$Hash.prototype.has = (0, $j57Yg.default);
$f3f66c3ce295bc56$var$Hash.prototype.set = (0, $kbeuV.default);
var $f3f66c3ce295bc56$export$2e2bcd8739ae039 = $f3f66c3ce295bc56$var$Hash;

});
parcelRegister("2fmLM", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a2ea50d598846b8$export$2e2bcd8739ae039);

var $37pPU = parcelRequire("37pPU");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $1a2ea50d598846b8$var$hashClear() {
    this.__data__ = (0, $37pPU.default) ? (0, $37pPU.default)(null) : {};
    this.size = 0;
}
var $1a2ea50d598846b8$export$2e2bcd8739ae039 = $1a2ea50d598846b8$var$hashClear;

});
parcelRegister("37pPU", function(module, exports) {

$parcel$export(module.exports, "default", () => $2456111ab1cf6a6a$export$2e2bcd8739ae039);

var $9IkTg = parcelRequire("9IkTg");
/* Built-in method references that are verified to be native. */ var $2456111ab1cf6a6a$var$nativeCreate = (0, $9IkTg.default)(Object, "create");
var $2456111ab1cf6a6a$export$2e2bcd8739ae039 = $2456111ab1cf6a6a$var$nativeCreate;

});


parcelRegister("ic6Ds", function(module, exports) {

$parcel$export(module.exports, "default", () => $d3ee7e9e18d6d728$export$2e2bcd8739ae039);
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $d3ee7e9e18d6d728$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
var $d3ee7e9e18d6d728$export$2e2bcd8739ae039 = $d3ee7e9e18d6d728$var$hashDelete;

});

parcelRegister("3fDDg", function(module, exports) {

$parcel$export(module.exports, "default", () => $25e183f736d6b5c0$export$2e2bcd8739ae039);

var $37pPU = parcelRequire("37pPU");
/** Used to stand-in for `undefined` hash values. */ var $25e183f736d6b5c0$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used for built-in method references. */ var $25e183f736d6b5c0$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $25e183f736d6b5c0$var$hasOwnProperty = $25e183f736d6b5c0$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $25e183f736d6b5c0$var$hashGet(key) {
    var data = this.__data__;
    if (0, $37pPU.default) {
        var result = data[key];
        return result === $25e183f736d6b5c0$var$HASH_UNDEFINED ? undefined : result;
    }
    return $25e183f736d6b5c0$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
var $25e183f736d6b5c0$export$2e2bcd8739ae039 = $25e183f736d6b5c0$var$hashGet;

});

parcelRegister("j57Yg", function(module, exports) {

$parcel$export(module.exports, "default", () => $de44aad9a531db03$export$2e2bcd8739ae039);

var $37pPU = parcelRequire("37pPU");
/** Used for built-in method references. */ var $de44aad9a531db03$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $de44aad9a531db03$var$hasOwnProperty = $de44aad9a531db03$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $de44aad9a531db03$var$hashHas(key) {
    var data = this.__data__;
    return (0, $37pPU.default) ? data[key] !== undefined : $de44aad9a531db03$var$hasOwnProperty.call(data, key);
}
var $de44aad9a531db03$export$2e2bcd8739ae039 = $de44aad9a531db03$var$hashHas;

});

parcelRegister("kbeuV", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb1014acae03df7a$export$2e2bcd8739ae039);

var $37pPU = parcelRequire("37pPU");
/** Used to stand-in for `undefined` hash values. */ var $eb1014acae03df7a$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $eb1014acae03df7a$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = (0, $37pPU.default) && value === undefined ? $eb1014acae03df7a$var$HASH_UNDEFINED : value;
    return this;
}
var $eb1014acae03df7a$export$2e2bcd8739ae039 = $eb1014acae03df7a$var$hashSet;

});



parcelRegister("ax9wf", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ab45ec4f71c3181$export$2e2bcd8739ae039);

var $gk39t = parcelRequire("gk39t");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $7ab45ec4f71c3181$var$mapCacheDelete(key) {
    var result = (0, $gk39t.default)(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
var $7ab45ec4f71c3181$export$2e2bcd8739ae039 = $7ab45ec4f71c3181$var$mapCacheDelete;

});
parcelRegister("gk39t", function(module, exports) {

$parcel$export(module.exports, "default", () => $be20f57e3f593a86$export$2e2bcd8739ae039);

var $gSwtd = parcelRequire("gSwtd");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $be20f57e3f593a86$var$getMapData(map, key) {
    var data = map.__data__;
    return (0, $gSwtd.default)(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
var $be20f57e3f593a86$export$2e2bcd8739ae039 = $be20f57e3f593a86$var$getMapData;

});
parcelRegister("gSwtd", function(module, exports) {

$parcel$export(module.exports, "default", () => $032bc9d01653d6df$export$2e2bcd8739ae039);
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $032bc9d01653d6df$var$isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
var $032bc9d01653d6df$export$2e2bcd8739ae039 = $032bc9d01653d6df$var$isKeyable;

});



parcelRegister("6L0Pz", function(module, exports) {

$parcel$export(module.exports, "default", () => $4eb7c6d7581f095d$export$2e2bcd8739ae039);

var $gk39t = parcelRequire("gk39t");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $4eb7c6d7581f095d$var$mapCacheGet(key) {
    return (0, $gk39t.default)(this, key).get(key);
}
var $4eb7c6d7581f095d$export$2e2bcd8739ae039 = $4eb7c6d7581f095d$var$mapCacheGet;

});

parcelRegister("62NfI", function(module, exports) {

$parcel$export(module.exports, "default", () => $0122ba5ccccda5b8$export$2e2bcd8739ae039);

var $gk39t = parcelRequire("gk39t");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $0122ba5ccccda5b8$var$mapCacheHas(key) {
    return (0, $gk39t.default)(this, key).has(key);
}
var $0122ba5ccccda5b8$export$2e2bcd8739ae039 = $0122ba5ccccda5b8$var$mapCacheHas;

});

parcelRegister("3NrLi", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c3b7ba523d691e4$export$2e2bcd8739ae039);

var $gk39t = parcelRequire("gk39t");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $2c3b7ba523d691e4$var$mapCacheSet(key, value) {
    var data = (0, $gk39t.default)(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
var $2c3b7ba523d691e4$export$2e2bcd8739ae039 = $2c3b7ba523d691e4$var$mapCacheSet;

});




parcelRegister("6lJDe", function(module, exports) {

$parcel$export(module.exports, "default", () => $49f819c11a196270$export$2e2bcd8739ae039);
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $49f819c11a196270$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
var $49f819c11a196270$export$2e2bcd8739ae039 = $49f819c11a196270$var$arrayEach;

});

parcelRegister("bmh9S", function(module, exports) {

$parcel$export(module.exports, "default", () => $844f0f0b3d494fc3$export$2e2bcd8739ae039);

var $fQQT9 = parcelRequire("fQQT9");

var $ka1tK = parcelRequire("ka1tK");
/** Used for built-in method references. */ var $844f0f0b3d494fc3$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $844f0f0b3d494fc3$var$hasOwnProperty = $844f0f0b3d494fc3$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $844f0f0b3d494fc3$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($844f0f0b3d494fc3$var$hasOwnProperty.call(object, key) && (0, $ka1tK.default)(objValue, value)) || value === undefined && !(key in object)) (0, $fQQT9.default)(object, key, value);
}
var $844f0f0b3d494fc3$export$2e2bcd8739ae039 = $844f0f0b3d494fc3$var$assignValue;

});
parcelRegister("fQQT9", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8a4bce7221277e6$export$2e2bcd8739ae039);

var $ZeSOZ = parcelRequire("ZeSOZ");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $b8a4bce7221277e6$var$baseAssignValue(object, key, value) {
    if (key == "__proto__" && (0, $ZeSOZ.default)) (0, $ZeSOZ.default)(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
    });
    else object[key] = value;
}
var $b8a4bce7221277e6$export$2e2bcd8739ae039 = $b8a4bce7221277e6$var$baseAssignValue;

});
parcelRegister("ZeSOZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b813e1dea152f4d$export$2e2bcd8739ae039);

var $9IkTg = parcelRequire("9IkTg");
var $0b813e1dea152f4d$var$defineProperty = function() {
    try {
        var func = (0, $9IkTg.default)(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e) {}
}();
var $0b813e1dea152f4d$export$2e2bcd8739ae039 = $0b813e1dea152f4d$var$defineProperty;

});



parcelRegister("kjffV", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec916a7878d37bf1$export$2e2bcd8739ae039);

var $rxW2k = parcelRequire("rxW2k");

var $lMs27 = parcelRequire("lMs27");
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $ec916a7878d37bf1$var$baseAssign(object, source) {
    return object && (0, $rxW2k.default)(source, (0, $lMs27.default)(source), object);
}
var $ec916a7878d37bf1$export$2e2bcd8739ae039 = $ec916a7878d37bf1$var$baseAssign;

});
parcelRegister("rxW2k", function(module, exports) {

$parcel$export(module.exports, "default", () => $052cd8879beeb55d$export$2e2bcd8739ae039);

var $bmh9S = parcelRequire("bmh9S");

var $fQQT9 = parcelRequire("fQQT9");
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $052cd8879beeb55d$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) (0, $fQQT9.default)(object, key, newValue);
        else (0, $bmh9S.default)(object, key, newValue);
    }
    return object;
}
var $052cd8879beeb55d$export$2e2bcd8739ae039 = $052cd8879beeb55d$var$copyObject;

});

parcelRegister("lMs27", function(module, exports) {

$parcel$export(module.exports, "default", () => $fdb3d3791f7e8825$export$2e2bcd8739ae039);

var $aZiQU = parcelRequire("aZiQU");

var $9l6PS = parcelRequire("9l6PS");

var $jSv8Q = parcelRequire("jSv8Q");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $fdb3d3791f7e8825$var$keys(object) {
    return (0, $jSv8Q.default)(object) ? (0, $aZiQU.default)(object) : (0, $9l6PS.default)(object);
}
var $fdb3d3791f7e8825$export$2e2bcd8739ae039 = $fdb3d3791f7e8825$var$keys;

});
parcelRegister("aZiQU", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ffe399847513755$export$2e2bcd8739ae039);

var $jPTde = parcelRequire("jPTde");

var $6VlWq = parcelRequire("6VlWq");

var $i48KB = parcelRequire("i48KB");

var $21qzi = parcelRequire("21qzi");

var $1LaAq = parcelRequire("1LaAq");

var $1c1iX = parcelRequire("1c1iX");
/** Used for built-in method references. */ var $7ffe399847513755$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $7ffe399847513755$var$hasOwnProperty = $7ffe399847513755$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $7ffe399847513755$var$arrayLikeKeys(value, inherited) {
    var isArr = (0, $i48KB.default)(value), isArg = !isArr && (0, $6VlWq.default)(value), isBuff = !isArr && !isArg && (0, $21qzi.default)(value), isType = !isArr && !isArg && !isBuff && (0, $1c1iX.default)(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? (0, $jPTde.default)(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $7ffe399847513755$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    (0, $1LaAq.default)(key, length)))) result.push(key);
    return result;
}
var $7ffe399847513755$export$2e2bcd8739ae039 = $7ffe399847513755$var$arrayLikeKeys;

});
parcelRegister("jPTde", function(module, exports) {

$parcel$export(module.exports, "default", () => $e70d9bc4e0f977ad$export$2e2bcd8739ae039);
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $e70d9bc4e0f977ad$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
var $e70d9bc4e0f977ad$export$2e2bcd8739ae039 = $e70d9bc4e0f977ad$var$baseTimes;

});

parcelRegister("6VlWq", function(module, exports) {

$parcel$export(module.exports, "default", () => $50a916102e689610$export$2e2bcd8739ae039);

var $2rAG0 = parcelRequire("2rAG0");

var $b8tfT = parcelRequire("b8tfT");
/** Used for built-in method references. */ var $50a916102e689610$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $50a916102e689610$var$hasOwnProperty = $50a916102e689610$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $50a916102e689610$var$propertyIsEnumerable = $50a916102e689610$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $50a916102e689610$var$isArguments = (0, $2rAG0.default)(function() {
    return arguments;
}()) ? (0, $2rAG0.default) : function(value) {
    return (0, $b8tfT.default)(value) && $50a916102e689610$var$hasOwnProperty.call(value, "callee") && !$50a916102e689610$var$propertyIsEnumerable.call(value, "callee");
};
var $50a916102e689610$export$2e2bcd8739ae039 = $50a916102e689610$var$isArguments;

});
parcelRegister("2rAG0", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c7a8d9542e5bc00$export$2e2bcd8739ae039);

var $42LVW = parcelRequire("42LVW");

var $b8tfT = parcelRequire("b8tfT");
/** `Object#toString` result references. */ var $1c7a8d9542e5bc00$var$argsTag = "[object Arguments]";
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $1c7a8d9542e5bc00$var$baseIsArguments(value) {
    return (0, $b8tfT.default)(value) && (0, $42LVW.default)(value) == $1c7a8d9542e5bc00$var$argsTag;
}
var $1c7a8d9542e5bc00$export$2e2bcd8739ae039 = $1c7a8d9542e5bc00$var$baseIsArguments;

});


parcelRegister("i48KB", function(module, exports) {

$parcel$export(module.exports, "default", () => $d26f636d2950faca$export$2e2bcd8739ae039);
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $d26f636d2950faca$var$isArray = Array.isArray;
var $d26f636d2950faca$export$2e2bcd8739ae039 = $d26f636d2950faca$var$isArray;

});

parcelRegister("21qzi", function(module, exports) {

$parcel$export(module.exports, "default", () => $179048a92e445af5$export$2e2bcd8739ae039);

var $aQKD3 = parcelRequire("aQKD3");

var $8hw76 = parcelRequire("8hw76");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $aQKD3.default).Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || (0, $8hw76.default);
var $179048a92e445af5$export$2e2bcd8739ae039 = isBuffer;

});
parcelRegister("8hw76", function(module, exports) {

$parcel$export(module.exports, "default", () => $6078d25e64437bbe$export$2e2bcd8739ae039);
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $6078d25e64437bbe$var$stubFalse() {
    return false;
}
var $6078d25e64437bbe$export$2e2bcd8739ae039 = $6078d25e64437bbe$var$stubFalse;

});


parcelRegister("1LaAq", function(module, exports) {

$parcel$export(module.exports, "default", () => $148264838403bce3$export$2e2bcd8739ae039);
/** Used as references for various `Number` constants. */ var $148264838403bce3$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $148264838403bce3$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $148264838403bce3$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $148264838403bce3$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && $148264838403bce3$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
var $148264838403bce3$export$2e2bcd8739ae039 = $148264838403bce3$var$isIndex;

});

parcelRegister("1c1iX", function(module, exports) {

$parcel$export(module.exports, "default", () => $0de7ec8659d15a34$export$2e2bcd8739ae039);

var $8lkIn = parcelRequire("8lkIn");

var $gZMaq = parcelRequire("gZMaq");

var $6c0uc = parcelRequire("6c0uc");
/* Node.js helper references. */ var $0de7ec8659d15a34$var$nodeIsTypedArray = (0, $6c0uc.default) && (0, $6c0uc.default).isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $0de7ec8659d15a34$var$isTypedArray = $0de7ec8659d15a34$var$nodeIsTypedArray ? (0, $gZMaq.default)($0de7ec8659d15a34$var$nodeIsTypedArray) : (0, $8lkIn.default);
var $0de7ec8659d15a34$export$2e2bcd8739ae039 = $0de7ec8659d15a34$var$isTypedArray;

});
parcelRegister("8lkIn", function(module, exports) {

$parcel$export(module.exports, "default", () => $61305a6972738d66$export$2e2bcd8739ae039);

var $42LVW = parcelRequire("42LVW");

var $cbQxF = parcelRequire("cbQxF");

var $b8tfT = parcelRequire("b8tfT");
/** `Object#toString` result references. */ var $61305a6972738d66$var$argsTag = "[object Arguments]", $61305a6972738d66$var$arrayTag = "[object Array]", $61305a6972738d66$var$boolTag = "[object Boolean]", $61305a6972738d66$var$dateTag = "[object Date]", $61305a6972738d66$var$errorTag = "[object Error]", $61305a6972738d66$var$funcTag = "[object Function]", $61305a6972738d66$var$mapTag = "[object Map]", $61305a6972738d66$var$numberTag = "[object Number]", $61305a6972738d66$var$objectTag = "[object Object]", $61305a6972738d66$var$regexpTag = "[object RegExp]", $61305a6972738d66$var$setTag = "[object Set]", $61305a6972738d66$var$stringTag = "[object String]", $61305a6972738d66$var$weakMapTag = "[object WeakMap]";
var $61305a6972738d66$var$arrayBufferTag = "[object ArrayBuffer]", $61305a6972738d66$var$dataViewTag = "[object DataView]", $61305a6972738d66$var$float32Tag = "[object Float32Array]", $61305a6972738d66$var$float64Tag = "[object Float64Array]", $61305a6972738d66$var$int8Tag = "[object Int8Array]", $61305a6972738d66$var$int16Tag = "[object Int16Array]", $61305a6972738d66$var$int32Tag = "[object Int32Array]", $61305a6972738d66$var$uint8Tag = "[object Uint8Array]", $61305a6972738d66$var$uint8ClampedTag = "[object Uint8ClampedArray]", $61305a6972738d66$var$uint16Tag = "[object Uint16Array]", $61305a6972738d66$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values of typed arrays. */ var $61305a6972738d66$var$typedArrayTags = {};
$61305a6972738d66$var$typedArrayTags[$61305a6972738d66$var$float32Tag] = $61305a6972738d66$var$typedArrayTags[$61305a6972738d66$var$float64Tag] = $61305a6972738d66$var$typedArrayTags[$61305a6972738d66$var$int8Tag] = $61305a6972738d66$var$typedArrayTags[$61305a6972738d66$var$int16Tag] = $61305a6972738d66$var$typedArrayTags[$61305a6972738d66$var$int32Tag] = $61305a6972738d66$var$typedArrayTags[$61305a6972738d66$var$uint8Tag] = $61305a6972738d66$var$typedArrayTags[$61305a6972738d66$var$uint8ClampedTag] = $61305a6972738d66$var$typedArrayTags[$61305a6972738d66$var$uint16Tag] = $61305a6972738d66$var$typedArrayTags[$61305a6972738d66$var$uint32Tag] = true;
$61305a6972738d66$var$typedArrayTags[$61305a6972738d66$var$argsTag] = $61305a6972738d66$var$typedArrayTags[$61305a6972738d66$var$arrayTag] = $61305a6972738d66$var$typedArrayTags[$61305a6972738d66$var$arrayBufferTag] = $61305a6972738d66$var$typedArrayTags[$61305a6972738d66$var$boolTag] = $61305a6972738d66$var$typedArrayTags[$61305a6972738d66$var$dataViewTag] = $61305a6972738d66$var$typedArrayTags[$61305a6972738d66$var$dateTag] = $61305a6972738d66$var$typedArrayTags[$61305a6972738d66$var$errorTag] = $61305a6972738d66$var$typedArrayTags[$61305a6972738d66$var$funcTag] = $61305a6972738d66$var$typedArrayTags[$61305a6972738d66$var$mapTag] = $61305a6972738d66$var$typedArrayTags[$61305a6972738d66$var$numberTag] = $61305a6972738d66$var$typedArrayTags[$61305a6972738d66$var$objectTag] = $61305a6972738d66$var$typedArrayTags[$61305a6972738d66$var$regexpTag] = $61305a6972738d66$var$typedArrayTags[$61305a6972738d66$var$setTag] = $61305a6972738d66$var$typedArrayTags[$61305a6972738d66$var$stringTag] = $61305a6972738d66$var$typedArrayTags[$61305a6972738d66$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $61305a6972738d66$var$baseIsTypedArray(value) {
    return (0, $b8tfT.default)(value) && (0, $cbQxF.default)(value.length) && !!$61305a6972738d66$var$typedArrayTags[(0, $42LVW.default)(value)];
}
var $61305a6972738d66$export$2e2bcd8739ae039 = $61305a6972738d66$var$baseIsTypedArray;

});
parcelRegister("cbQxF", function(module, exports) {

$parcel$export(module.exports, "default", () => $8dff44dd4a8469a3$export$2e2bcd8739ae039);
/** Used as references for various `Number` constants. */ var $8dff44dd4a8469a3$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $8dff44dd4a8469a3$var$isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= $8dff44dd4a8469a3$var$MAX_SAFE_INTEGER;
}
var $8dff44dd4a8469a3$export$2e2bcd8739ae039 = $8dff44dd4a8469a3$var$isLength;

});


parcelRegister("gZMaq", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5f7b4d4204d7b52$export$2e2bcd8739ae039);
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $c5f7b4d4204d7b52$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
var $c5f7b4d4204d7b52$export$2e2bcd8739ae039 = $c5f7b4d4204d7b52$var$baseUnary;

});

parcelRegister("6c0uc", function(module, exports) {

$parcel$export(module.exports, "default", () => $48243d9229376f04$export$2e2bcd8739ae039);

var $7oxg8 = parcelRequire("7oxg8");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && (0, $7oxg8.default).process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
var $48243d9229376f04$export$2e2bcd8739ae039 = nodeUtil;

});



parcelRegister("9l6PS", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ccb60a80ce34991$export$2e2bcd8739ae039);

var $89J4v = parcelRequire("89J4v");

var $hGyIi = parcelRequire("hGyIi");
/** Used for built-in method references. */ var $6ccb60a80ce34991$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $6ccb60a80ce34991$var$hasOwnProperty = $6ccb60a80ce34991$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $6ccb60a80ce34991$var$baseKeys(object) {
    if (!(0, $89J4v.default)(object)) return (0, $hGyIi.default)(object);
    var result = [];
    for(var key in Object(object))if ($6ccb60a80ce34991$var$hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
var $6ccb60a80ce34991$export$2e2bcd8739ae039 = $6ccb60a80ce34991$var$baseKeys;

});
parcelRegister("89J4v", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f02204be2f703be$export$2e2bcd8739ae039);
/** Used for built-in method references. */ var $5f02204be2f703be$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $5f02204be2f703be$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || $5f02204be2f703be$var$objectProto;
    return value === proto;
}
var $5f02204be2f703be$export$2e2bcd8739ae039 = $5f02204be2f703be$var$isPrototype;

});

parcelRegister("hGyIi", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce014948c98adc89$export$2e2bcd8739ae039);

var $7NogN = parcelRequire("7NogN");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $ce014948c98adc89$var$nativeKeys = (0, $7NogN.default)(Object.keys, Object);
var $ce014948c98adc89$export$2e2bcd8739ae039 = $ce014948c98adc89$var$nativeKeys;

});


parcelRegister("jSv8Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $e78b37933ed3e1a8$export$2e2bcd8739ae039);

var $mLztR = parcelRequire("mLztR");

var $cbQxF = parcelRequire("cbQxF");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $e78b37933ed3e1a8$var$isArrayLike(value) {
    return value != null && (0, $cbQxF.default)(value.length) && !(0, $mLztR.default)(value);
}
var $e78b37933ed3e1a8$export$2e2bcd8739ae039 = $e78b37933ed3e1a8$var$isArrayLike;

});



parcelRegister("1PQuT", function(module, exports) {

$parcel$export(module.exports, "default", () => $156346bdc00dde11$export$2e2bcd8739ae039);

var $rxW2k = parcelRequire("rxW2k");

var $b8cgV = parcelRequire("b8cgV");
/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $156346bdc00dde11$var$baseAssignIn(object, source) {
    return object && (0, $rxW2k.default)(source, (0, $b8cgV.default)(source), object);
}
var $156346bdc00dde11$export$2e2bcd8739ae039 = $156346bdc00dde11$var$baseAssignIn;

});
parcelRegister("b8cgV", function(module, exports) {

$parcel$export(module.exports, "default", () => $81a9f601362b0f7a$export$2e2bcd8739ae039);

var $aZiQU = parcelRequire("aZiQU");

var $3gqvP = parcelRequire("3gqvP");

var $jSv8Q = parcelRequire("jSv8Q");
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $81a9f601362b0f7a$var$keysIn(object) {
    return (0, $jSv8Q.default)(object) ? (0, $aZiQU.default)(object, true) : (0, $3gqvP.default)(object);
}
var $81a9f601362b0f7a$export$2e2bcd8739ae039 = $81a9f601362b0f7a$var$keysIn;

});
parcelRegister("3gqvP", function(module, exports) {

$parcel$export(module.exports, "default", () => $26076e8c9655715c$export$2e2bcd8739ae039);

var $aWBxg = parcelRequire("aWBxg");

var $89J4v = parcelRequire("89J4v");

var $9fCy7 = parcelRequire("9fCy7");
/** Used for built-in method references. */ var $26076e8c9655715c$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $26076e8c9655715c$var$hasOwnProperty = $26076e8c9655715c$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $26076e8c9655715c$var$baseKeysIn(object) {
    if (!(0, $aWBxg.default)(object)) return (0, $9fCy7.default)(object);
    var isProto = (0, $89J4v.default)(object), result = [];
    for(var key in object)if (!(key == "constructor" && (isProto || !$26076e8c9655715c$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
var $26076e8c9655715c$export$2e2bcd8739ae039 = $26076e8c9655715c$var$baseKeysIn;

});
parcelRegister("9fCy7", function(module, exports) {

$parcel$export(module.exports, "default", () => $6bc36ad68c747927$export$2e2bcd8739ae039);
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $6bc36ad68c747927$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
var $6bc36ad68c747927$export$2e2bcd8739ae039 = $6bc36ad68c747927$var$nativeKeysIn;

});




parcelRegister("Irws4", function(module, exports) {

$parcel$export(module.exports, "default", () => $0859758db942a8f2$export$2e2bcd8739ae039);

var $aQKD3 = parcelRequire("aQKD3");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $aQKD3.default).Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
var $0859758db942a8f2$export$2e2bcd8739ae039 = cloneBuffer;

});

parcelRegister("fJXTB", function(module, exports) {

$parcel$export(module.exports, "default", () => $b759850802116698$export$2e2bcd8739ae039);
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $b759850802116698$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
var $b759850802116698$export$2e2bcd8739ae039 = $b759850802116698$var$copyArray;

});

parcelRegister("512AJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a6f0e58ba4d2086$export$2e2bcd8739ae039);

var $rxW2k = parcelRequire("rxW2k");

var $234iA = parcelRequire("234iA");
/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $3a6f0e58ba4d2086$var$copySymbols(source, object) {
    return (0, $rxW2k.default)(source, (0, $234iA.default)(source), object);
}
var $3a6f0e58ba4d2086$export$2e2bcd8739ae039 = $3a6f0e58ba4d2086$var$copySymbols;

});
parcelRegister("234iA", function(module, exports) {

$parcel$export(module.exports, "default", () => $17df3241a2cfbc35$export$2e2bcd8739ae039);

var $gHhgi = parcelRequire("gHhgi");

var $jT1Cc = parcelRequire("jT1Cc");
/** Used for built-in method references. */ var $17df3241a2cfbc35$var$objectProto = Object.prototype;
/** Built-in value references. */ var $17df3241a2cfbc35$var$propertyIsEnumerable = $17df3241a2cfbc35$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $17df3241a2cfbc35$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $17df3241a2cfbc35$var$getSymbols = !$17df3241a2cfbc35$var$nativeGetSymbols ? (0, $jT1Cc.default) : function(object) {
    if (object == null) return [];
    object = Object(object);
    return (0, $gHhgi.default)($17df3241a2cfbc35$var$nativeGetSymbols(object), function(symbol) {
        return $17df3241a2cfbc35$var$propertyIsEnumerable.call(object, symbol);
    });
};
var $17df3241a2cfbc35$export$2e2bcd8739ae039 = $17df3241a2cfbc35$var$getSymbols;

});
parcelRegister("gHhgi", function(module, exports) {

$parcel$export(module.exports, "default", () => $c27e0d599a7094a8$export$2e2bcd8739ae039);
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $c27e0d599a7094a8$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
var $c27e0d599a7094a8$export$2e2bcd8739ae039 = $c27e0d599a7094a8$var$arrayFilter;

});

parcelRegister("jT1Cc", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7a4681ba83cbc4b$export$2e2bcd8739ae039);
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $e7a4681ba83cbc4b$var$stubArray() {
    return [];
}
var $e7a4681ba83cbc4b$export$2e2bcd8739ae039 = $e7a4681ba83cbc4b$var$stubArray;

});



parcelRegister("8qOaq", function(module, exports) {

$parcel$export(module.exports, "default", () => $01958b025d8ad92d$export$2e2bcd8739ae039);

var $rxW2k = parcelRequire("rxW2k");

var $XPKYO = parcelRequire("XPKYO");
/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $01958b025d8ad92d$var$copySymbolsIn(source, object) {
    return (0, $rxW2k.default)(source, (0, $XPKYO.default)(source), object);
}
var $01958b025d8ad92d$export$2e2bcd8739ae039 = $01958b025d8ad92d$var$copySymbolsIn;

});
parcelRegister("XPKYO", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b3da89cff840e0a$export$2e2bcd8739ae039);

var $a1KEh = parcelRequire("a1KEh");

var $agrfU = parcelRequire("agrfU");

var $234iA = parcelRequire("234iA");

var $jT1Cc = parcelRequire("jT1Cc");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $0b3da89cff840e0a$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $0b3da89cff840e0a$var$getSymbolsIn = !$0b3da89cff840e0a$var$nativeGetSymbols ? (0, $jT1Cc.default) : function(object) {
    var result = [];
    while(object){
        (0, $a1KEh.default)(result, (0, $234iA.default)(object));
        object = (0, $agrfU.default)(object);
    }
    return result;
};
var $0b3da89cff840e0a$export$2e2bcd8739ae039 = $0b3da89cff840e0a$var$getSymbolsIn;

});
parcelRegister("a1KEh", function(module, exports) {

$parcel$export(module.exports, "default", () => $74ce2ed71c580581$export$2e2bcd8739ae039);
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $74ce2ed71c580581$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
var $74ce2ed71c580581$export$2e2bcd8739ae039 = $74ce2ed71c580581$var$arrayPush;

});



parcelRegister("lKcsa", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd478dd6414a7998$export$2e2bcd8739ae039);

var $j2Wv7 = parcelRequire("j2Wv7");

var $234iA = parcelRequire("234iA");

var $lMs27 = parcelRequire("lMs27");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $fd478dd6414a7998$var$getAllKeys(object) {
    return (0, $j2Wv7.default)(object, (0, $lMs27.default), (0, $234iA.default));
}
var $fd478dd6414a7998$export$2e2bcd8739ae039 = $fd478dd6414a7998$var$getAllKeys;

});
parcelRegister("j2Wv7", function(module, exports) {

$parcel$export(module.exports, "default", () => $dddb9544984246ec$export$2e2bcd8739ae039);

var $a1KEh = parcelRequire("a1KEh");

var $i48KB = parcelRequire("i48KB");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $dddb9544984246ec$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return (0, $i48KB.default)(object) ? result : (0, $a1KEh.default)(result, symbolsFunc(object));
}
var $dddb9544984246ec$export$2e2bcd8739ae039 = $dddb9544984246ec$var$baseGetAllKeys;

});


parcelRegister("ggB7P", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd7af0419c32cb59$export$2e2bcd8739ae039);

var $j2Wv7 = parcelRequire("j2Wv7");

var $XPKYO = parcelRequire("XPKYO");

var $b8cgV = parcelRequire("b8cgV");
/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $bd7af0419c32cb59$var$getAllKeysIn(object) {
    return (0, $j2Wv7.default)(object, (0, $b8cgV.default), (0, $XPKYO.default));
}
var $bd7af0419c32cb59$export$2e2bcd8739ae039 = $bd7af0419c32cb59$var$getAllKeysIn;

});

parcelRegister("fb5Xy", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0cc819005b2b96f$export$2e2bcd8739ae039);

var $2QS86 = parcelRequire("2QS86");

var $eHZZw = parcelRequire("eHZZw");

var $kk1ZK = parcelRequire("kk1ZK");

var $krcns = parcelRequire("krcns");

var $lxNxd = parcelRequire("lxNxd");

var $42LVW = parcelRequire("42LVW");

var $l1IED = parcelRequire("l1IED");
/** `Object#toString` result references. */ var $b0cc819005b2b96f$var$mapTag = "[object Map]", $b0cc819005b2b96f$var$objectTag = "[object Object]", $b0cc819005b2b96f$var$promiseTag = "[object Promise]", $b0cc819005b2b96f$var$setTag = "[object Set]", $b0cc819005b2b96f$var$weakMapTag = "[object WeakMap]";
var $b0cc819005b2b96f$var$dataViewTag = "[object DataView]";
/** Used to detect maps, sets, and weakmaps. */ var $b0cc819005b2b96f$var$dataViewCtorString = (0, $l1IED.default)((0, $2QS86.default)), $b0cc819005b2b96f$var$mapCtorString = (0, $l1IED.default)((0, $eHZZw.default)), $b0cc819005b2b96f$var$promiseCtorString = (0, $l1IED.default)((0, $kk1ZK.default)), $b0cc819005b2b96f$var$setCtorString = (0, $l1IED.default)((0, $krcns.default)), $b0cc819005b2b96f$var$weakMapCtorString = (0, $l1IED.default)((0, $lxNxd.default));
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $b0cc819005b2b96f$var$getTag = (0, $42LVW.default);
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((0, $2QS86.default) && $b0cc819005b2b96f$var$getTag(new (0, $2QS86.default)(new ArrayBuffer(1))) != $b0cc819005b2b96f$var$dataViewTag || (0, $eHZZw.default) && $b0cc819005b2b96f$var$getTag(new (0, $eHZZw.default)) != $b0cc819005b2b96f$var$mapTag || (0, $kk1ZK.default) && $b0cc819005b2b96f$var$getTag((0, $kk1ZK.default).resolve()) != $b0cc819005b2b96f$var$promiseTag || (0, $krcns.default) && $b0cc819005b2b96f$var$getTag(new (0, $krcns.default)) != $b0cc819005b2b96f$var$setTag || (0, $lxNxd.default) && $b0cc819005b2b96f$var$getTag(new (0, $lxNxd.default)) != $b0cc819005b2b96f$var$weakMapTag) $b0cc819005b2b96f$var$getTag = function(value) {
    var result = (0, $42LVW.default)(value), Ctor = result == $b0cc819005b2b96f$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? (0, $l1IED.default)(Ctor) : "";
    if (ctorString) switch(ctorString){
        case $b0cc819005b2b96f$var$dataViewCtorString:
            return $b0cc819005b2b96f$var$dataViewTag;
        case $b0cc819005b2b96f$var$mapCtorString:
            return $b0cc819005b2b96f$var$mapTag;
        case $b0cc819005b2b96f$var$promiseCtorString:
            return $b0cc819005b2b96f$var$promiseTag;
        case $b0cc819005b2b96f$var$setCtorString:
            return $b0cc819005b2b96f$var$setTag;
        case $b0cc819005b2b96f$var$weakMapCtorString:
            return $b0cc819005b2b96f$var$weakMapTag;
    }
    return result;
};
var $b0cc819005b2b96f$export$2e2bcd8739ae039 = $b0cc819005b2b96f$var$getTag;

});
parcelRegister("2QS86", function(module, exports) {

$parcel$export(module.exports, "default", () => $213a6d24b31fe650$export$2e2bcd8739ae039);

var $9IkTg = parcelRequire("9IkTg");

var $aQKD3 = parcelRequire("aQKD3");
/* Built-in method references that are verified to be native. */ var $213a6d24b31fe650$var$DataView = (0, $9IkTg.default)((0, $aQKD3.default), "DataView");
var $213a6d24b31fe650$export$2e2bcd8739ae039 = $213a6d24b31fe650$var$DataView;

});

parcelRegister("kk1ZK", function(module, exports) {

$parcel$export(module.exports, "default", () => $ecb7390edc524b5f$export$2e2bcd8739ae039);

var $9IkTg = parcelRequire("9IkTg");

var $aQKD3 = parcelRequire("aQKD3");
/* Built-in method references that are verified to be native. */ var $ecb7390edc524b5f$var$Promise = (0, $9IkTg.default)((0, $aQKD3.default), "Promise");
var $ecb7390edc524b5f$export$2e2bcd8739ae039 = $ecb7390edc524b5f$var$Promise;

});

parcelRegister("krcns", function(module, exports) {

$parcel$export(module.exports, "default", () => $ee0fee1f47edf278$export$2e2bcd8739ae039);

var $9IkTg = parcelRequire("9IkTg");

var $aQKD3 = parcelRequire("aQKD3");
/* Built-in method references that are verified to be native. */ var $ee0fee1f47edf278$var$Set = (0, $9IkTg.default)((0, $aQKD3.default), "Set");
var $ee0fee1f47edf278$export$2e2bcd8739ae039 = $ee0fee1f47edf278$var$Set;

});

parcelRegister("lxNxd", function(module, exports) {

$parcel$export(module.exports, "default", () => $faf31a951b8e59e2$export$2e2bcd8739ae039);

var $9IkTg = parcelRequire("9IkTg");

var $aQKD3 = parcelRequire("aQKD3");
/* Built-in method references that are verified to be native. */ var $faf31a951b8e59e2$var$WeakMap = (0, $9IkTg.default)((0, $aQKD3.default), "WeakMap");
var $faf31a951b8e59e2$export$2e2bcd8739ae039 = $faf31a951b8e59e2$var$WeakMap;

});


parcelRegister("35jdz", function(module, exports) {

$parcel$export(module.exports, "default", () => $23f0befb3445fc09$export$2e2bcd8739ae039);
/** Used for built-in method references. */ var $23f0befb3445fc09$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $23f0befb3445fc09$var$hasOwnProperty = $23f0befb3445fc09$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $23f0befb3445fc09$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == "string" && $23f0befb3445fc09$var$hasOwnProperty.call(array, "index")) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
var $23f0befb3445fc09$export$2e2bcd8739ae039 = $23f0befb3445fc09$var$initCloneArray;

});

parcelRegister("6idGg", function(module, exports) {

$parcel$export(module.exports, "default", () => $494f093575e677c6$export$2e2bcd8739ae039);

var $6Vixl = parcelRequire("6Vixl");

var $iQZjr = parcelRequire("iQZjr");

var $4PXjD = parcelRequire("4PXjD");

var $6wfIO = parcelRequire("6wfIO");

var $3gFvs = parcelRequire("3gFvs");
/** `Object#toString` result references. */ var $494f093575e677c6$var$boolTag = "[object Boolean]", $494f093575e677c6$var$dateTag = "[object Date]", $494f093575e677c6$var$mapTag = "[object Map]", $494f093575e677c6$var$numberTag = "[object Number]", $494f093575e677c6$var$regexpTag = "[object RegExp]", $494f093575e677c6$var$setTag = "[object Set]", $494f093575e677c6$var$stringTag = "[object String]", $494f093575e677c6$var$symbolTag = "[object Symbol]";
var $494f093575e677c6$var$arrayBufferTag = "[object ArrayBuffer]", $494f093575e677c6$var$dataViewTag = "[object DataView]", $494f093575e677c6$var$float32Tag = "[object Float32Array]", $494f093575e677c6$var$float64Tag = "[object Float64Array]", $494f093575e677c6$var$int8Tag = "[object Int8Array]", $494f093575e677c6$var$int16Tag = "[object Int16Array]", $494f093575e677c6$var$int32Tag = "[object Int32Array]", $494f093575e677c6$var$uint8Tag = "[object Uint8Array]", $494f093575e677c6$var$uint8ClampedTag = "[object Uint8ClampedArray]", $494f093575e677c6$var$uint16Tag = "[object Uint16Array]", $494f093575e677c6$var$uint32Tag = "[object Uint32Array]";
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $494f093575e677c6$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $494f093575e677c6$var$arrayBufferTag:
            return (0, $6Vixl.default)(object);
        case $494f093575e677c6$var$boolTag:
        case $494f093575e677c6$var$dateTag:
            return new Ctor(+object);
        case $494f093575e677c6$var$dataViewTag:
            return (0, $iQZjr.default)(object, isDeep);
        case $494f093575e677c6$var$float32Tag:
        case $494f093575e677c6$var$float64Tag:
        case $494f093575e677c6$var$int8Tag:
        case $494f093575e677c6$var$int16Tag:
        case $494f093575e677c6$var$int32Tag:
        case $494f093575e677c6$var$uint8Tag:
        case $494f093575e677c6$var$uint8ClampedTag:
        case $494f093575e677c6$var$uint16Tag:
        case $494f093575e677c6$var$uint32Tag:
            return (0, $3gFvs.default)(object, isDeep);
        case $494f093575e677c6$var$mapTag:
            return new Ctor;
        case $494f093575e677c6$var$numberTag:
        case $494f093575e677c6$var$stringTag:
            return new Ctor(object);
        case $494f093575e677c6$var$regexpTag:
            return (0, $4PXjD.default)(object);
        case $494f093575e677c6$var$setTag:
            return new Ctor;
        case $494f093575e677c6$var$symbolTag:
            return (0, $6wfIO.default)(object);
    }
}
var $494f093575e677c6$export$2e2bcd8739ae039 = $494f093575e677c6$var$initCloneByTag;

});
parcelRegister("6Vixl", function(module, exports) {

$parcel$export(module.exports, "default", () => $50a671f892951027$export$2e2bcd8739ae039);

var $8Gmev = parcelRequire("8Gmev");
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $50a671f892951027$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new (0, $8Gmev.default)(result).set(new (0, $8Gmev.default)(arrayBuffer));
    return result;
}
var $50a671f892951027$export$2e2bcd8739ae039 = $50a671f892951027$var$cloneArrayBuffer;

});
parcelRegister("8Gmev", function(module, exports) {

$parcel$export(module.exports, "default", () => $65237df6dbb80d40$export$2e2bcd8739ae039);

var $aQKD3 = parcelRequire("aQKD3");
/** Built-in value references. */ var $65237df6dbb80d40$var$Uint8Array = (0, $aQKD3.default).Uint8Array;
var $65237df6dbb80d40$export$2e2bcd8739ae039 = $65237df6dbb80d40$var$Uint8Array;

});


parcelRegister("iQZjr", function(module, exports) {

$parcel$export(module.exports, "default", () => $db9ca4bbe5e007a6$export$2e2bcd8739ae039);

var $6Vixl = parcelRequire("6Vixl");
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $db9ca4bbe5e007a6$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? (0, $6Vixl.default)(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
var $db9ca4bbe5e007a6$export$2e2bcd8739ae039 = $db9ca4bbe5e007a6$var$cloneDataView;

});

parcelRegister("4PXjD", function(module, exports) {

$parcel$export(module.exports, "default", () => $3859efb96995bb45$export$2e2bcd8739ae039);
/** Used to match `RegExp` flags from their coerced string values. */ var $3859efb96995bb45$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $3859efb96995bb45$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $3859efb96995bb45$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
var $3859efb96995bb45$export$2e2bcd8739ae039 = $3859efb96995bb45$var$cloneRegExp;

});

parcelRegister("6wfIO", function(module, exports) {

$parcel$export(module.exports, "default", () => $4bf1ed40a6950d12$export$2e2bcd8739ae039);

var $cVOod = parcelRequire("cVOod");
/** Used to convert symbols to primitives and strings. */ var $4bf1ed40a6950d12$var$symbolProto = (0, $cVOod.default) ? (0, $cVOod.default).prototype : undefined, $4bf1ed40a6950d12$var$symbolValueOf = $4bf1ed40a6950d12$var$symbolProto ? $4bf1ed40a6950d12$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $4bf1ed40a6950d12$var$cloneSymbol(symbol) {
    return $4bf1ed40a6950d12$var$symbolValueOf ? Object($4bf1ed40a6950d12$var$symbolValueOf.call(symbol)) : {};
}
var $4bf1ed40a6950d12$export$2e2bcd8739ae039 = $4bf1ed40a6950d12$var$cloneSymbol;

});

parcelRegister("3gFvs", function(module, exports) {

$parcel$export(module.exports, "default", () => $2613100373481499$export$2e2bcd8739ae039);

var $6Vixl = parcelRequire("6Vixl");
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $2613100373481499$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? (0, $6Vixl.default)(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
var $2613100373481499$export$2e2bcd8739ae039 = $2613100373481499$var$cloneTypedArray;

});


parcelRegister("ktsYn", function(module, exports) {

$parcel$export(module.exports, "default", () => $ee7cfd7d4f856c02$export$2e2bcd8739ae039);

var $aIIik = parcelRequire("aIIik");

var $agrfU = parcelRequire("agrfU");

var $89J4v = parcelRequire("89J4v");
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $ee7cfd7d4f856c02$var$initCloneObject(object) {
    return typeof object.constructor == "function" && !(0, $89J4v.default)(object) ? (0, $aIIik.default)((0, $agrfU.default)(object)) : {};
}
var $ee7cfd7d4f856c02$export$2e2bcd8739ae039 = $ee7cfd7d4f856c02$var$initCloneObject;

});
parcelRegister("aIIik", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ce05f6e03d8d303$export$2e2bcd8739ae039);

var $aWBxg = parcelRequire("aWBxg");
/** Built-in value references. */ var $7ce05f6e03d8d303$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $7ce05f6e03d8d303$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!(0, $aWBxg.default)(proto)) return {};
        if ($7ce05f6e03d8d303$var$objectCreate) return $7ce05f6e03d8d303$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
var $7ce05f6e03d8d303$export$2e2bcd8739ae039 = $7ce05f6e03d8d303$var$baseCreate;

});


parcelRegister("jixRw", function(module, exports) {

$parcel$export(module.exports, "default", () => $e0c9f71a74dc845c$export$2e2bcd8739ae039);

var $aku4y = parcelRequire("aku4y");

var $gZMaq = parcelRequire("gZMaq");

var $6c0uc = parcelRequire("6c0uc");
/* Node.js helper references. */ var $e0c9f71a74dc845c$var$nodeIsMap = (0, $6c0uc.default) && (0, $6c0uc.default).isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $e0c9f71a74dc845c$var$isMap = $e0c9f71a74dc845c$var$nodeIsMap ? (0, $gZMaq.default)($e0c9f71a74dc845c$var$nodeIsMap) : (0, $aku4y.default);
var $e0c9f71a74dc845c$export$2e2bcd8739ae039 = $e0c9f71a74dc845c$var$isMap;

});
parcelRegister("aku4y", function(module, exports) {

$parcel$export(module.exports, "default", () => $7853196328ab8ce0$export$2e2bcd8739ae039);

var $fb5Xy = parcelRequire("fb5Xy");

var $b8tfT = parcelRequire("b8tfT");
/** `Object#toString` result references. */ var $7853196328ab8ce0$var$mapTag = "[object Map]";
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $7853196328ab8ce0$var$baseIsMap(value) {
    return (0, $b8tfT.default)(value) && (0, $fb5Xy.default)(value) == $7853196328ab8ce0$var$mapTag;
}
var $7853196328ab8ce0$export$2e2bcd8739ae039 = $7853196328ab8ce0$var$baseIsMap;

});


parcelRegister("7WLtA", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c92c6fa6fa6cc9f$export$2e2bcd8739ae039);

var $cKM4D = parcelRequire("cKM4D");

var $gZMaq = parcelRequire("gZMaq");

var $6c0uc = parcelRequire("6c0uc");
/* Node.js helper references. */ var $5c92c6fa6fa6cc9f$var$nodeIsSet = (0, $6c0uc.default) && (0, $6c0uc.default).isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $5c92c6fa6fa6cc9f$var$isSet = $5c92c6fa6fa6cc9f$var$nodeIsSet ? (0, $gZMaq.default)($5c92c6fa6fa6cc9f$var$nodeIsSet) : (0, $cKM4D.default);
var $5c92c6fa6fa6cc9f$export$2e2bcd8739ae039 = $5c92c6fa6fa6cc9f$var$isSet;

});
parcelRegister("cKM4D", function(module, exports) {

$parcel$export(module.exports, "default", () => $948f125c05db9a76$export$2e2bcd8739ae039);

var $fb5Xy = parcelRequire("fb5Xy");

var $b8tfT = parcelRequire("b8tfT");
/** `Object#toString` result references. */ var $948f125c05db9a76$var$setTag = "[object Set]";
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $948f125c05db9a76$var$baseIsSet(value) {
    return (0, $b8tfT.default)(value) && (0, $fb5Xy.default)(value) == $948f125c05db9a76$var$setTag;
}
var $948f125c05db9a76$export$2e2bcd8739ae039 = $948f125c05db9a76$var$baseIsSet;

});




parcelRegister("31ATd", function(module, exports) {
"use strict";
var $233e14948c671b0f$var$isArray = Array.isArray;
var $233e14948c671b0f$var$keyList = Object.keys;
var $233e14948c671b0f$var$hasProp = Object.prototype.hasOwnProperty;
var $233e14948c671b0f$var$hasElementType = typeof Element !== "undefined";
function $233e14948c671b0f$var$equal(a, b) {
    // fast-deep-equal index.js 2.0.1
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        var arrA = $233e14948c671b0f$var$isArray(a), arrB = $233e14948c671b0f$var$isArray(b), i, length, key;
        if (arrA && arrB) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$233e14948c671b0f$var$equal(a[i], b[i])) return false;
            return true;
        }
        if (arrA != arrB) return false;
        var dateA = a instanceof Date, dateB = b instanceof Date;
        if (dateA != dateB) return false;
        if (dateA && dateB) return a.getTime() == b.getTime();
        var regexpA = a instanceof RegExp, regexpB = b instanceof RegExp;
        if (regexpA != regexpB) return false;
        if (regexpA && regexpB) return a.toString() == b.toString();
        var keys = $233e14948c671b0f$var$keyList(a);
        length = keys.length;
        if (length !== $233e14948c671b0f$var$keyList(b).length) return false;
        for(i = length; i-- !== 0;)if (!$233e14948c671b0f$var$hasProp.call(b, keys[i])) return false;
        // end fast-deep-equal
        // start react-fast-compare
        // custom handling for DOM elements
        if ($233e14948c671b0f$var$hasElementType && a instanceof Element && b instanceof Element) return a === b;
        // custom handling for React
        for(i = length; i-- !== 0;){
            key = keys[i];
            if (key === "_owner" && a.$$typeof) continue;
            else {
                // all other properties should be traversed as usual
                if (!$233e14948c671b0f$var$equal(a[key], b[key])) return false;
            }
        }
        // end react-fast-compare
        // fast-deep-equal index.js 2.0.1
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
module.exports = function exportedEqual(a, b) {
    try {
        return $233e14948c671b0f$var$equal(a, b);
    } catch (error) {
        if (error.message && error.message.match(/stack|recursion/i) || error.number === -2146828260) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn("Warning: react-fast-compare does not handle circular references.", error.name, error.message);
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};

});

parcelRegister("8I1rW", function(module, exports) {

$parcel$export(module.exports, "default", () => $65738ea8e4b9014c$export$2e2bcd8739ae039);
var $65738ea8e4b9014c$var$isProduction = true;
function $65738ea8e4b9014c$var$warning(condition, message) {
    if (!$65738ea8e4b9014c$var$isProduction) {
        if (condition) return;
        var text = "Warning: " + message;
        if (typeof console !== "undefined") console.warn(text);
        try {
            throw Error(text);
        } catch (x) {}
    }
}
var $65738ea8e4b9014c$export$2e2bcd8739ae039 = $65738ea8e4b9014c$var$warning;

});

parcelRegister("bwrOM", function(module, exports) {

$parcel$export(module.exports, "default", () => $863842eecc722445$export$2e2bcd8739ae039);

var $bslYV = parcelRequire("bslYV");
/** Used to compose bitmasks for cloning. */ var $863842eecc722445$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */ function $863842eecc722445$var$clone(value) {
    return (0, $bslYV.default)(value, $863842eecc722445$var$CLONE_SYMBOLS_FLAG);
}
var $863842eecc722445$export$2e2bcd8739ae039 = $863842eecc722445$var$clone;

});

parcelRegister("aCf5k", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ba9278d80dcc338$export$2e2bcd8739ae039);

var $95kO3 = parcelRequire("95kO3");

var $fJXTB = parcelRequire("fJXTB");

var $i48KB = parcelRequire("i48KB");

var $7N8V6 = parcelRequire("7N8V6");

var $dRovF = parcelRequire("dRovF");

var $618qE = parcelRequire("618qE");

var $fgXm3 = parcelRequire("fgXm3");
/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */ function $7ba9278d80dcc338$var$toPath(value) {
    if ((0, $i48KB.default)(value)) return (0, $95kO3.default)(value, (0, $618qE.default));
    return (0, $7N8V6.default)(value) ? [
        value
    ] : (0, $fJXTB.default)((0, $dRovF.default)((0, $fgXm3.default)(value)));
}
var $7ba9278d80dcc338$export$2e2bcd8739ae039 = $7ba9278d80dcc338$var$toPath;

});
parcelRegister("95kO3", function(module, exports) {

$parcel$export(module.exports, "default", () => $69d4b8641124f261$export$2e2bcd8739ae039);
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $69d4b8641124f261$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
var $69d4b8641124f261$export$2e2bcd8739ae039 = $69d4b8641124f261$var$arrayMap;

});

parcelRegister("7N8V6", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ac40753e9fb8ac9$export$2e2bcd8739ae039);

var $42LVW = parcelRequire("42LVW");

var $b8tfT = parcelRequire("b8tfT");
/** `Object#toString` result references. */ var $5ac40753e9fb8ac9$var$symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $5ac40753e9fb8ac9$var$isSymbol(value) {
    return typeof value == "symbol" || (0, $b8tfT.default)(value) && (0, $42LVW.default)(value) == $5ac40753e9fb8ac9$var$symbolTag;
}
var $5ac40753e9fb8ac9$export$2e2bcd8739ae039 = $5ac40753e9fb8ac9$var$isSymbol;

});

parcelRegister("dRovF", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1733cbe4dae1139$export$2e2bcd8739ae039);

var $aP4to = parcelRequire("aP4to");
/** Used to match property names within property paths. */ var $a1733cbe4dae1139$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $a1733cbe4dae1139$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $a1733cbe4dae1139$var$stringToPath = (0, $aP4to.default)(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
    string.replace($a1733cbe4dae1139$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($a1733cbe4dae1139$var$reEscapeChar, "$1") : number || match);
    });
    return result;
});
var $a1733cbe4dae1139$export$2e2bcd8739ae039 = $a1733cbe4dae1139$var$stringToPath;

});
parcelRegister("aP4to", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e12230f351caecf$export$2e2bcd8739ae039);

var $anCCf = parcelRequire("anCCf");
/** Used as the maximum memoize cache size. */ var $7e12230f351caecf$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $7e12230f351caecf$var$memoizeCapped(func) {
    var result = (0, $anCCf.default)(func, function(key) {
        if (cache.size === $7e12230f351caecf$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
var $7e12230f351caecf$export$2e2bcd8739ae039 = $7e12230f351caecf$var$memoizeCapped;

});
parcelRegister("anCCf", function(module, exports) {

$parcel$export(module.exports, "default", () => $78ea01b3b87a99a8$export$2e2bcd8739ae039);

var $8Ufnm = parcelRequire("8Ufnm");
/** Error message constants. */ var $78ea01b3b87a99a8$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $78ea01b3b87a99a8$var$memoize(func, resolver) {
    if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError($78ea01b3b87a99a8$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($78ea01b3b87a99a8$var$memoize.Cache || (0, $8Ufnm.default));
    return memoized;
}
// Expose `MapCache`.
$78ea01b3b87a99a8$var$memoize.Cache = (0, $8Ufnm.default);
var $78ea01b3b87a99a8$export$2e2bcd8739ae039 = $78ea01b3b87a99a8$var$memoize;

});



parcelRegister("618qE", function(module, exports) {

$parcel$export(module.exports, "default", () => $46195fdf4d1c7119$export$2e2bcd8739ae039);

var $7N8V6 = parcelRequire("7N8V6");
/** Used as references for various `Number` constants. */ var $46195fdf4d1c7119$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $46195fdf4d1c7119$var$toKey(value) {
    if (typeof value == "string" || (0, $7N8V6.default)(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -$46195fdf4d1c7119$var$INFINITY ? "-0" : result;
}
var $46195fdf4d1c7119$export$2e2bcd8739ae039 = $46195fdf4d1c7119$var$toKey;

});

parcelRegister("fgXm3", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1e66443af97c112$export$2e2bcd8739ae039);

var $2X29w = parcelRequire("2X29w");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $b1e66443af97c112$var$toString(value) {
    return value == null ? "" : (0, $2X29w.default)(value);
}
var $b1e66443af97c112$export$2e2bcd8739ae039 = $b1e66443af97c112$var$toString;

});
parcelRegister("2X29w", function(module, exports) {

$parcel$export(module.exports, "default", () => $2262c2f088aa8039$export$2e2bcd8739ae039);

var $cVOod = parcelRequire("cVOod");

var $95kO3 = parcelRequire("95kO3");

var $i48KB = parcelRequire("i48KB");

var $7N8V6 = parcelRequire("7N8V6");
/** Used as references for various `Number` constants. */ var $2262c2f088aa8039$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $2262c2f088aa8039$var$symbolProto = (0, $cVOod.default) ? (0, $cVOod.default).prototype : undefined, $2262c2f088aa8039$var$symbolToString = $2262c2f088aa8039$var$symbolProto ? $2262c2f088aa8039$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $2262c2f088aa8039$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if ((0, $i48KB.default)(value)) // Recursively convert values (susceptible to call stack limits).
    return (0, $95kO3.default)(value, $2262c2f088aa8039$var$baseToString) + "";
    if ((0, $7N8V6.default)(value)) return $2262c2f088aa8039$var$symbolToString ? $2262c2f088aa8039$var$symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -$2262c2f088aa8039$var$INFINITY ? "-0" : result;
}
var $2262c2f088aa8039$export$2e2bcd8739ae039 = $2262c2f088aa8039$var$baseToString;

});



parcelRegister("j8Bf6", function(module, exports) {
"use strict";

var $cbG5Y = parcelRequire("cbG5Y");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $deeba7430f1a2bbe$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $deeba7430f1a2bbe$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $deeba7430f1a2bbe$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $deeba7430f1a2bbe$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $deeba7430f1a2bbe$var$TYPE_STATICS = {};
$deeba7430f1a2bbe$var$TYPE_STATICS[$cbG5Y.ForwardRef] = $deeba7430f1a2bbe$var$FORWARD_REF_STATICS;
$deeba7430f1a2bbe$var$TYPE_STATICS[$cbG5Y.Memo] = $deeba7430f1a2bbe$var$MEMO_STATICS;
function $deeba7430f1a2bbe$var$getStatics(component) {
    // React v16.11 and below
    if ($cbG5Y.isMemo(component)) return $deeba7430f1a2bbe$var$MEMO_STATICS;
     // React v16.12 and above
    return $deeba7430f1a2bbe$var$TYPE_STATICS[component["$$typeof"]] || $deeba7430f1a2bbe$var$REACT_STATICS;
}
var $deeba7430f1a2bbe$var$defineProperty = Object.defineProperty;
var $deeba7430f1a2bbe$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $deeba7430f1a2bbe$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $deeba7430f1a2bbe$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $deeba7430f1a2bbe$var$getPrototypeOf = Object.getPrototypeOf;
var $deeba7430f1a2bbe$var$objectPrototype = Object.prototype;
function $deeba7430f1a2bbe$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($deeba7430f1a2bbe$var$objectPrototype) {
            var inheritedComponent = $deeba7430f1a2bbe$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $deeba7430f1a2bbe$var$objectPrototype) $deeba7430f1a2bbe$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $deeba7430f1a2bbe$var$getOwnPropertyNames(sourceComponent);
        if ($deeba7430f1a2bbe$var$getOwnPropertySymbols) keys = keys.concat($deeba7430f1a2bbe$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $deeba7430f1a2bbe$var$getStatics(targetComponent);
        var sourceStatics = $deeba7430f1a2bbe$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$deeba7430f1a2bbe$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $deeba7430f1a2bbe$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $deeba7430f1a2bbe$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $deeba7430f1a2bbe$var$hoistNonReactStatics;

});
parcelRegister("cbG5Y", function(module, exports) {
"use strict";

module.exports = (parcelRequire("1CR13"));

});
parcelRegister("1CR13", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $12f276ec6b21850f$export$2b8d127b894957b9, (v) => $12f276ec6b21850f$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $12f276ec6b21850f$export$cea3a54a6425200c, (v) => $12f276ec6b21850f$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $12f276ec6b21850f$export$a7c73072b1a182ae, (v) => $12f276ec6b21850f$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $12f276ec6b21850f$export$9f27bc3417b4524d, (v) => $12f276ec6b21850f$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $12f276ec6b21850f$export$db77ccec0bb4ccac, (v) => $12f276ec6b21850f$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $12f276ec6b21850f$export$8392c0c9d3dcbd35, (v) => $12f276ec6b21850f$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $12f276ec6b21850f$export$ffb0004e005737fa, (v) => $12f276ec6b21850f$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $12f276ec6b21850f$export$b624eff549462981, (v) => $12f276ec6b21850f$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $12f276ec6b21850f$export$7897aa7841a5380c, (v) => $12f276ec6b21850f$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $12f276ec6b21850f$export$602eac185826482c, (v) => $12f276ec6b21850f$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $12f276ec6b21850f$export$e2c29f18771995cb, (v) => $12f276ec6b21850f$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $12f276ec6b21850f$export$5f8d39834fd61797, (v) => $12f276ec6b21850f$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $12f276ec6b21850f$export$74bf444e3cd11ea5, (v) => $12f276ec6b21850f$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $12f276ec6b21850f$export$92387174baf9b227, (v) => $12f276ec6b21850f$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $12f276ec6b21850f$export$ec112efeb987d9c6, (v) => $12f276ec6b21850f$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $12f276ec6b21850f$export$b706b080d889d2c9, (v) => $12f276ec6b21850f$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $12f276ec6b21850f$export$5be5a87408f70ddc, (v) => $12f276ec6b21850f$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $12f276ec6b21850f$export$45a5e7f76e0caa8d, (v) => $12f276ec6b21850f$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $12f276ec6b21850f$export$455c2e768291efa6, (v) => $12f276ec6b21850f$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $12f276ec6b21850f$export$9522e17588c12572, (v) => $12f276ec6b21850f$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $12f276ec6b21850f$export$2110ac352bb060b9, (v) => $12f276ec6b21850f$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $12f276ec6b21850f$export$56885ab8b9c456ab, (v) => $12f276ec6b21850f$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $12f276ec6b21850f$export$d927fcb6adf8f9de, (v) => $12f276ec6b21850f$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $12f276ec6b21850f$export$b82d16f27459e05a, (v) => $12f276ec6b21850f$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $12f276ec6b21850f$export$522c17b4f5e123e8, (v) => $12f276ec6b21850f$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $12f276ec6b21850f$export$1aabd8a0274ecfd6, (v) => $12f276ec6b21850f$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $12f276ec6b21850f$export$9b621391a187a31a, (v) => $12f276ec6b21850f$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $12f276ec6b21850f$export$f5bbd400c2f4426f, (v) => $12f276ec6b21850f$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $12f276ec6b21850f$export$2b8d127b894957b9;
var $12f276ec6b21850f$export$cea3a54a6425200c;
var $12f276ec6b21850f$export$a7c73072b1a182ae;
var $12f276ec6b21850f$export$9f27bc3417b4524d;
var $12f276ec6b21850f$export$db77ccec0bb4ccac;
var $12f276ec6b21850f$export$8392c0c9d3dcbd35;
var $12f276ec6b21850f$export$ffb0004e005737fa;
var $12f276ec6b21850f$export$b624eff549462981;
var $12f276ec6b21850f$export$7897aa7841a5380c;
var $12f276ec6b21850f$export$602eac185826482c;
var $12f276ec6b21850f$export$e2c29f18771995cb;
var $12f276ec6b21850f$export$5f8d39834fd61797;
var $12f276ec6b21850f$export$74bf444e3cd11ea5;
var $12f276ec6b21850f$export$92387174baf9b227;
var $12f276ec6b21850f$export$ec112efeb987d9c6;
var $12f276ec6b21850f$export$b706b080d889d2c9;
var $12f276ec6b21850f$export$5be5a87408f70ddc;
var $12f276ec6b21850f$export$45a5e7f76e0caa8d;
var $12f276ec6b21850f$export$455c2e768291efa6;
var $12f276ec6b21850f$export$9522e17588c12572;
var $12f276ec6b21850f$export$2110ac352bb060b9;
var $12f276ec6b21850f$export$56885ab8b9c456ab;
var $12f276ec6b21850f$export$d927fcb6adf8f9de;
var $12f276ec6b21850f$export$b82d16f27459e05a;
var $12f276ec6b21850f$export$522c17b4f5e123e8;
var $12f276ec6b21850f$export$1aabd8a0274ecfd6;
var $12f276ec6b21850f$export$9b621391a187a31a;
var $12f276ec6b21850f$export$f5bbd400c2f4426f;
"use strict";
var $12f276ec6b21850f$var$b = "function" === typeof Symbol && Symbol.for, $12f276ec6b21850f$var$c = $12f276ec6b21850f$var$b ? Symbol.for("react.element") : 60103, $12f276ec6b21850f$var$d = $12f276ec6b21850f$var$b ? Symbol.for("react.portal") : 60106, $12f276ec6b21850f$var$e = $12f276ec6b21850f$var$b ? Symbol.for("react.fragment") : 60107, $12f276ec6b21850f$var$f = $12f276ec6b21850f$var$b ? Symbol.for("react.strict_mode") : 60108, $12f276ec6b21850f$var$g = $12f276ec6b21850f$var$b ? Symbol.for("react.profiler") : 60114, $12f276ec6b21850f$var$h = $12f276ec6b21850f$var$b ? Symbol.for("react.provider") : 60109, $12f276ec6b21850f$var$k = $12f276ec6b21850f$var$b ? Symbol.for("react.context") : 60110, $12f276ec6b21850f$var$l = $12f276ec6b21850f$var$b ? Symbol.for("react.async_mode") : 60111, $12f276ec6b21850f$var$m = $12f276ec6b21850f$var$b ? Symbol.for("react.concurrent_mode") : 60111, $12f276ec6b21850f$var$n = $12f276ec6b21850f$var$b ? Symbol.for("react.forward_ref") : 60112, $12f276ec6b21850f$var$p = $12f276ec6b21850f$var$b ? Symbol.for("react.suspense") : 60113, $12f276ec6b21850f$var$q = $12f276ec6b21850f$var$b ? Symbol.for("react.suspense_list") : 60120, $12f276ec6b21850f$var$r = $12f276ec6b21850f$var$b ? Symbol.for("react.memo") : 60115, $12f276ec6b21850f$var$t = $12f276ec6b21850f$var$b ? Symbol.for("react.lazy") : 60116, $12f276ec6b21850f$var$v = $12f276ec6b21850f$var$b ? Symbol.for("react.block") : 60121, $12f276ec6b21850f$var$w = $12f276ec6b21850f$var$b ? Symbol.for("react.fundamental") : 60117, $12f276ec6b21850f$var$x = $12f276ec6b21850f$var$b ? Symbol.for("react.responder") : 60118, $12f276ec6b21850f$var$y = $12f276ec6b21850f$var$b ? Symbol.for("react.scope") : 60119;
function $12f276ec6b21850f$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $12f276ec6b21850f$var$c:
                switch(a = a.type, a){
                    case $12f276ec6b21850f$var$l:
                    case $12f276ec6b21850f$var$m:
                    case $12f276ec6b21850f$var$e:
                    case $12f276ec6b21850f$var$g:
                    case $12f276ec6b21850f$var$f:
                    case $12f276ec6b21850f$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $12f276ec6b21850f$var$k:
                            case $12f276ec6b21850f$var$n:
                            case $12f276ec6b21850f$var$t:
                            case $12f276ec6b21850f$var$r:
                            case $12f276ec6b21850f$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $12f276ec6b21850f$var$d:
                return u;
        }
    }
}
function $12f276ec6b21850f$var$A(a) {
    return $12f276ec6b21850f$var$z(a) === $12f276ec6b21850f$var$m;
}
$12f276ec6b21850f$export$2b8d127b894957b9 = $12f276ec6b21850f$var$l;
$12f276ec6b21850f$export$cea3a54a6425200c = $12f276ec6b21850f$var$m;
$12f276ec6b21850f$export$a7c73072b1a182ae = $12f276ec6b21850f$var$k;
$12f276ec6b21850f$export$9f27bc3417b4524d = $12f276ec6b21850f$var$h;
$12f276ec6b21850f$export$db77ccec0bb4ccac = $12f276ec6b21850f$var$c;
$12f276ec6b21850f$export$8392c0c9d3dcbd35 = $12f276ec6b21850f$var$n;
$12f276ec6b21850f$export$ffb0004e005737fa = $12f276ec6b21850f$var$e;
$12f276ec6b21850f$export$b624eff549462981 = $12f276ec6b21850f$var$t;
$12f276ec6b21850f$export$7897aa7841a5380c = $12f276ec6b21850f$var$r;
$12f276ec6b21850f$export$602eac185826482c = $12f276ec6b21850f$var$d;
$12f276ec6b21850f$export$e2c29f18771995cb = $12f276ec6b21850f$var$g;
$12f276ec6b21850f$export$5f8d39834fd61797 = $12f276ec6b21850f$var$f;
$12f276ec6b21850f$export$74bf444e3cd11ea5 = $12f276ec6b21850f$var$p;
$12f276ec6b21850f$export$92387174baf9b227 = function(a) {
    return $12f276ec6b21850f$var$A(a) || $12f276ec6b21850f$var$z(a) === $12f276ec6b21850f$var$l;
};
$12f276ec6b21850f$export$ec112efeb987d9c6 = $12f276ec6b21850f$var$A;
$12f276ec6b21850f$export$b706b080d889d2c9 = function(a) {
    return $12f276ec6b21850f$var$z(a) === $12f276ec6b21850f$var$k;
};
$12f276ec6b21850f$export$5be5a87408f70ddc = function(a) {
    return $12f276ec6b21850f$var$z(a) === $12f276ec6b21850f$var$h;
};
$12f276ec6b21850f$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $12f276ec6b21850f$var$c;
};
$12f276ec6b21850f$export$455c2e768291efa6 = function(a) {
    return $12f276ec6b21850f$var$z(a) === $12f276ec6b21850f$var$n;
};
$12f276ec6b21850f$export$9522e17588c12572 = function(a) {
    return $12f276ec6b21850f$var$z(a) === $12f276ec6b21850f$var$e;
};
$12f276ec6b21850f$export$2110ac352bb060b9 = function(a) {
    return $12f276ec6b21850f$var$z(a) === $12f276ec6b21850f$var$t;
};
$12f276ec6b21850f$export$56885ab8b9c456ab = function(a) {
    return $12f276ec6b21850f$var$z(a) === $12f276ec6b21850f$var$r;
};
$12f276ec6b21850f$export$d927fcb6adf8f9de = function(a) {
    return $12f276ec6b21850f$var$z(a) === $12f276ec6b21850f$var$d;
};
$12f276ec6b21850f$export$b82d16f27459e05a = function(a) {
    return $12f276ec6b21850f$var$z(a) === $12f276ec6b21850f$var$g;
};
$12f276ec6b21850f$export$522c17b4f5e123e8 = function(a) {
    return $12f276ec6b21850f$var$z(a) === $12f276ec6b21850f$var$f;
};
$12f276ec6b21850f$export$1aabd8a0274ecfd6 = function(a) {
    return $12f276ec6b21850f$var$z(a) === $12f276ec6b21850f$var$p;
};
$12f276ec6b21850f$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $12f276ec6b21850f$var$e || a === $12f276ec6b21850f$var$m || a === $12f276ec6b21850f$var$g || a === $12f276ec6b21850f$var$f || a === $12f276ec6b21850f$var$p || a === $12f276ec6b21850f$var$q || "object" === typeof a && null !== a && (a.$$typeof === $12f276ec6b21850f$var$t || a.$$typeof === $12f276ec6b21850f$var$r || a.$$typeof === $12f276ec6b21850f$var$h || a.$$typeof === $12f276ec6b21850f$var$k || a.$$typeof === $12f276ec6b21850f$var$n || a.$$typeof === $12f276ec6b21850f$var$w || a.$$typeof === $12f276ec6b21850f$var$x || a.$$typeof === $12f276ec6b21850f$var$y || a.$$typeof === $12f276ec6b21850f$var$v);
};
$12f276ec6b21850f$export$f5bbd400c2f4426f = $12f276ec6b21850f$var$z;

});




parcelRegister("61JDm", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e4583c701a5c750$export$2e2bcd8739ae039);

var $351fG = parcelRequire("351fG");

var $lgiU2 = parcelRequire("lgiU2");


var $htkH1 = parcelRequire("htkH1");
const $8e4583c701a5c750$var$config = {
    closeButton: false,
    autoClose: 3000,
    position: "bottom-right",
    className: (0, (/*@__PURE__*/$parcel$interopDefault($htkH1))).toast,
    progressClassName: (0, (/*@__PURE__*/$parcel$interopDefault($htkH1))).progress,
    closeOnClick: true
};
var $8e4583c701a5c750$export$2e2bcd8739ae039 = {
    success: (msg)=>{
        (0, $351fG.toast).success(msg, {
            ...$8e4583c701a5c750$var$config,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($lgiU2)))($8e4583c701a5c750$var$config.className, (0, (/*@__PURE__*/$parcel$interopDefault($htkH1))).success)
        });
    },
    info: (msg)=>{
        (0, $351fG.toast).info(msg, {
            ...$8e4583c701a5c750$var$config,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($lgiU2)))($8e4583c701a5c750$var$config.className, (0, (/*@__PURE__*/$parcel$interopDefault($htkH1))).info)
        });
    },
    error: (msg)=>{
        (0, $351fG.toast).error(msg, {
            ...$8e4583c701a5c750$var$config,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($lgiU2)))($8e4583c701a5c750$var$config.className, (0, (/*@__PURE__*/$parcel$interopDefault($htkH1))).error)
        });
    }
};

});
parcelRegister("351fG", function(module, exports) {

$parcel$export(module.exports, "toast", () => $6d00ec1db968ffaa$export$b410431fab84fa58);
$parcel$export(module.exports, "ToastContainer", () => $6d00ec1db968ffaa$export$f2815235e76a62b9);

var $kc00y = parcelRequire("kc00y");

var $eGWiI = parcelRequire("eGWiI");
"use client";
const $6d00ec1db968ffaa$var$c = (e)=>"number" == typeof e && !isNaN(e), $6d00ec1db968ffaa$var$d = (e)=>"string" == typeof e, $6d00ec1db968ffaa$var$u = (e)=>"function" == typeof e, $6d00ec1db968ffaa$var$p = (e)=>$6d00ec1db968ffaa$var$d(e) || $6d00ec1db968ffaa$var$u(e) ? e : null, $6d00ec1db968ffaa$var$m = (e)=>(0, $kc00y.isValidElement)(e) || $6d00ec1db968ffaa$var$d(e) || $6d00ec1db968ffaa$var$u(e) || $6d00ec1db968ffaa$var$c(e);
function $6d00ec1db968ffaa$export$184cca501f1aed7f(e, t, n) {
    void 0 === n && (n = 300);
    const { scrollHeight: o, style: s } = e;
    requestAnimationFrame(()=>{
        s.minHeight = "initial", s.height = o + "px", s.transition = `all ${n}ms`, requestAnimationFrame(()=>{
            s.height = "0", s.padding = "0", s.margin = "0", setTimeout(t, n);
        });
    });
}
function $6d00ec1db968ffaa$export$3ff7dc44d332d222(t) {
    let { enter: a, exit: r, appendPosition: i = !1, collapse: l = !0, collapseDuration: c = 300 } = t;
    return function(t) {
        let { children: d, position: u, preventExitTransition: p, done: m, nodeRef: g, isIn: y, playToast: v } = t;
        const h = i ? `${a}--${u}` : a, T = i ? `${r}--${u}` : r, E = (0, $kc00y.useRef)(0);
        return (0, $kc00y.useLayoutEffect)(()=>{
            const e = g.current, t = h.split(" "), n = (o)=>{
                o.target === g.current && (v(), e.removeEventListener("animationend", n), e.removeEventListener("animationcancel", n), 0 === E.current && "animationcancel" !== o.type && e.classList.remove(...t));
            };
            e.classList.add(...t), e.addEventListener("animationend", n), e.addEventListener("animationcancel", n);
        }, []), (0, $kc00y.useEffect)(()=>{
            const e = g.current, t = ()=>{
                e.removeEventListener("animationend", t), l ? $6d00ec1db968ffaa$export$184cca501f1aed7f(e, m, c) : m();
            };
            y || (p ? t() : (E.current = 1, e.className += ` ${T}`, e.addEventListener("animationend", t)));
        }, [
            y
        ]), (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).Fragment, null, d);
    };
}
function $6d00ec1db968ffaa$var$y(e, t) {
    return null != e ? {
        content: e.content,
        containerId: e.props.containerId,
        id: e.props.toastId,
        theme: e.props.theme,
        type: e.props.type,
        data: e.props.data || {},
        isLoading: e.props.isLoading,
        icon: e.props.icon,
        status: t
    } : {};
}
const $6d00ec1db968ffaa$var$v = new Map;
let $6d00ec1db968ffaa$var$h = [];
const $6d00ec1db968ffaa$var$T = new Set, $6d00ec1db968ffaa$var$E = (e)=>$6d00ec1db968ffaa$var$T.forEach((t)=>t(e)), $6d00ec1db968ffaa$var$b = ()=>$6d00ec1db968ffaa$var$v.size > 0;
function $6d00ec1db968ffaa$var$I(e, t) {
    var n;
    if (t) return !(null == (n = $6d00ec1db968ffaa$var$v.get(t)) || !n.isToastActive(e));
    let o = !1;
    return $6d00ec1db968ffaa$var$v.forEach((t)=>{
        t.isToastActive(e) && (o = !0);
    }), o;
}
function $6d00ec1db968ffaa$var$_(e, t) {
    $6d00ec1db968ffaa$var$m(e) && ($6d00ec1db968ffaa$var$b() || $6d00ec1db968ffaa$var$h.push({
        content: e,
        options: t
    }), $6d00ec1db968ffaa$var$v.forEach((n)=>{
        n.buildToast(e, t);
    }));
}
function $6d00ec1db968ffaa$var$C(e, t) {
    $6d00ec1db968ffaa$var$v.forEach((n)=>{
        null != t && null != t && t.containerId ? (null == t ? void 0 : t.containerId) === n.id && n.toggle(e, null == t ? void 0 : t.id) : n.toggle(e, null == t ? void 0 : t.id);
    });
}
function $6d00ec1db968ffaa$export$b262e13ca2dd2381(e) {
    const { subscribe: o, getSnapshot: s, setProps: i } = (0, $kc00y.useRef)(function(e) {
        const n = e.containerId || 1;
        return {
            subscribe (o) {
                const s = function(e, n, o) {
                    let s = 1, r = 0, i = [], l = [], f = [], g = n;
                    const v = new Map, h = new Set, T = ()=>{
                        f = Array.from(v.values()), h.forEach((e)=>e());
                    }, E = (e)=>{
                        l = null == e ? [] : l.filter((t)=>t !== e), T();
                    }, b = (e)=>{
                        const { toastId: n, onOpen: s, updateId: a, children: r } = e.props, i = null == a;
                        e.staleId && v.delete(e.staleId), v.set(n, e), l = [
                            ...l,
                            e.props.toastId
                        ].filter((t)=>t !== e.staleId), T(), o($6d00ec1db968ffaa$var$y(e, i ? "added" : "updated")), i && $6d00ec1db968ffaa$var$u(s) && s((0, $kc00y.isValidElement)(r) && r.props);
                    };
                    return {
                        id: e,
                        props: g,
                        observe: (e)=>(h.add(e), ()=>h.delete(e)),
                        toggle: (e, t)=>{
                            v.forEach((n)=>{
                                null != t && t !== n.props.toastId || $6d00ec1db968ffaa$var$u(n.toggle) && n.toggle(e);
                            });
                        },
                        removeToast: E,
                        toasts: v,
                        clearQueue: ()=>{
                            r -= i.length, i = [];
                        },
                        buildToast: (n, l)=>{
                            if (((t)=>{
                                let { containerId: n, toastId: o, updateId: s } = t;
                                const a = n ? n !== e : 1 !== e, r = v.has(o) && null == s;
                                return a || r;
                            })(l)) return;
                            const { toastId: f, updateId: h, data: I, staleId: _, delay: C } = l, L = ()=>{
                                E(f);
                            }, N = null == h;
                            N && r++;
                            const $ = {
                                ...g,
                                style: g.toastStyle,
                                key: s++,
                                ...Object.fromEntries(Object.entries(l).filter((e)=>{
                                    let [t, n] = e;
                                    return null != n;
                                })),
                                toastId: f,
                                updateId: h,
                                data: I,
                                closeToast: L,
                                isIn: !1,
                                className: $6d00ec1db968ffaa$var$p(l.className || g.toastClassName),
                                bodyClassName: $6d00ec1db968ffaa$var$p(l.bodyClassName || g.bodyClassName),
                                progressClassName: $6d00ec1db968ffaa$var$p(l.progressClassName || g.progressClassName),
                                autoClose: !l.isLoading && (w = l.autoClose, k = g.autoClose, !1 === w || $6d00ec1db968ffaa$var$c(w) && w > 0 ? w : k),
                                deleteToast () {
                                    const e = v.get(f), { onClose: n, children: s } = e.props;
                                    $6d00ec1db968ffaa$var$u(n) && n((0, $kc00y.isValidElement)(s) && s.props), o($6d00ec1db968ffaa$var$y(e, "removed")), v.delete(f), r--, r < 0 && (r = 0), i.length > 0 ? b(i.shift()) : T();
                                }
                            };
                            var w, k;
                            $.closeButton = g.closeButton, !1 === l.closeButton || $6d00ec1db968ffaa$var$m(l.closeButton) ? $.closeButton = l.closeButton : !0 === l.closeButton && ($.closeButton = !$6d00ec1db968ffaa$var$m(g.closeButton) || g.closeButton);
                            let P = n;
                            (0, $kc00y.isValidElement)(n) && !$6d00ec1db968ffaa$var$d(n.type) ? P = (0, $kc00y.cloneElement)(n, {
                                closeToast: L,
                                toastProps: $,
                                data: I
                            }) : $6d00ec1db968ffaa$var$u(n) && (P = n({
                                closeToast: L,
                                toastProps: $,
                                data: I
                            }));
                            const M = {
                                content: P,
                                props: $,
                                staleId: _
                            };
                            g.limit && g.limit > 0 && r > g.limit && N ? i.push(M) : $6d00ec1db968ffaa$var$c(C) ? setTimeout(()=>{
                                b(M);
                            }, C) : b(M);
                        },
                        setProps (e) {
                            g = e;
                        },
                        setToggle: (e, t)=>{
                            v.get(e).toggle = t;
                        },
                        isToastActive: (e)=>l.some((t)=>t === e),
                        getSnapshot: ()=>f
                    };
                }(n, e, $6d00ec1db968ffaa$var$E);
                $6d00ec1db968ffaa$var$v.set(n, s);
                const r = s.observe(o);
                return $6d00ec1db968ffaa$var$h.forEach((e)=>$6d00ec1db968ffaa$var$_(e.content, e.options)), $6d00ec1db968ffaa$var$h = [], ()=>{
                    r(), $6d00ec1db968ffaa$var$v.delete(n);
                };
            },
            setProps (e) {
                var t;
                null == (t = $6d00ec1db968ffaa$var$v.get(n)) || t.setProps(e);
            },
            getSnapshot () {
                var e;
                return null == (e = $6d00ec1db968ffaa$var$v.get(n)) ? void 0 : e.getSnapshot();
            }
        };
    }(e)).current;
    i(e);
    const l = (0, $kc00y.useSyncExternalStore)(o, s, s);
    return {
        getToastToRender: function(t) {
            if (!l) return [];
            const n = new Map;
            return e.newestOnTop && l.reverse(), l.forEach((e)=>{
                const { position: t } = e.props;
                n.has(t) || n.set(t, []), n.get(t).push(e);
            }), Array.from(n, (e)=>t(e[0], e[1]));
        },
        isToastActive: $6d00ec1db968ffaa$var$I,
        count: null == l ? void 0 : l.length
    };
}
function $6d00ec1db968ffaa$export$a407b657d3044108(e) {
    const [t, o] = (0, $kc00y.useState)(!1), [a, r] = (0, $kc00y.useState)(!1), l = (0, $kc00y.useRef)(null), c = (0, $kc00y.useRef)({
        start: 0,
        delta: 0,
        removalDistance: 0,
        canCloseOnClick: !0,
        canDrag: !1,
        didMove: !1
    }).current, { autoClose: d, pauseOnHover: u, closeToast: p, onClick: m, closeOnClick: f } = e;
    var g, y;
    function h() {
        o(!0);
    }
    function T() {
        o(!1);
    }
    function E(n) {
        const o = l.current;
        c.canDrag && o && (c.didMove = !0, t && T(), c.delta = "x" === e.draggableDirection ? n.clientX - c.start : n.clientY - c.start, c.start !== n.clientX && (c.canCloseOnClick = !1), o.style.transform = `translate3d(${"x" === e.draggableDirection ? `${c.delta}px, var(--y)` : `0, calc(${c.delta}px + var(--y))`},0)`, o.style.opacity = "" + (1 - Math.abs(c.delta / c.removalDistance)));
    }
    function b() {
        document.removeEventListener("pointermove", E), document.removeEventListener("pointerup", b);
        const t = l.current;
        if (c.canDrag && c.didMove && t) {
            if (c.canDrag = !1, Math.abs(c.delta) > c.removalDistance) return r(!0), e.closeToast(), void e.collapseAll();
            t.style.transition = "transform 0.2s, opacity 0.2s", t.style.removeProperty("transform"), t.style.removeProperty("opacity");
        }
    }
    null == (y = $6d00ec1db968ffaa$var$v.get((g = {
        id: e.toastId,
        containerId: e.containerId,
        fn: o
    }).containerId || 1)) || y.setToggle(g.id, g.fn), (0, $kc00y.useEffect)(()=>{
        if (e.pauseOnFocusLoss) return document.hasFocus() || T(), window.addEventListener("focus", h), window.addEventListener("blur", T), ()=>{
            window.removeEventListener("focus", h), window.removeEventListener("blur", T);
        };
    }, [
        e.pauseOnFocusLoss
    ]);
    const I = {
        onPointerDown: function(t) {
            if (!0 === e.draggable || e.draggable === t.pointerType) {
                c.didMove = !1, document.addEventListener("pointermove", E), document.addEventListener("pointerup", b);
                const n = l.current;
                c.canCloseOnClick = !0, c.canDrag = !0, n.style.transition = "none", "x" === e.draggableDirection ? (c.start = t.clientX, c.removalDistance = n.offsetWidth * (e.draggablePercent / 100)) : (c.start = t.clientY, c.removalDistance = n.offsetHeight * (80 === e.draggablePercent ? 1.5 * e.draggablePercent : e.draggablePercent) / 100);
            }
        },
        onPointerUp: function(t) {
            const { top: n, bottom: o, left: s, right: a } = l.current.getBoundingClientRect();
            "touchend" !== t.nativeEvent.type && e.pauseOnHover && t.clientX >= s && t.clientX <= a && t.clientY >= n && t.clientY <= o ? T() : h();
        }
    };
    return d && u && (I.onMouseEnter = T, e.stacked || (I.onMouseLeave = h)), f && (I.onClick = (e)=>{
        m && m(e), c.canCloseOnClick && p();
    }), {
        playToast: h,
        pauseToast: T,
        isRunning: t,
        preventExitTransition: a,
        toastRef: l,
        eventHandlers: I
    };
}
function $6d00ec1db968ffaa$var$$(t) {
    let { delay: n, isRunning: o, closeToast: s, type: a = "default", hide: r, className: i, style: c, controlledProgress: d, progress: p, rtl: m, isIn: f, theme: g } = t;
    const y = r || d && 0 === p, v = {
        ...c,
        animationDuration: `${n}ms`,
        animationPlayState: o ? "running" : "paused"
    };
    d && (v.transform = `scaleX(${p})`);
    const h = (0, $eGWiI.default)("Toastify__progress-bar", d ? "Toastify__progress-bar--controlled" : "Toastify__progress-bar--animated", `Toastify__progress-bar-theme--${g}`, `Toastify__progress-bar--${a}`, {
        "Toastify__progress-bar--rtl": m
    }), T = $6d00ec1db968ffaa$var$u(i) ? i({
        rtl: m,
        type: a,
        defaultClassName: h
    }) : (0, $eGWiI.default)(h, i), E = {
        [d && p >= 1 ? "onTransitionEnd" : "onAnimationEnd"]: d && p < 1 ? null : ()=>{
            f && s();
        }
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement("div", {
        className: "Toastify__progress-bar--wrp",
        "data-hidden": y
    }, (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement("div", {
        className: `Toastify__progress-bar--bg Toastify__progress-bar-theme--${g} Toastify__progress-bar--${a}`
    }), (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement("div", {
        role: "progressbar",
        "aria-hidden": y ? "true" : "false",
        "aria-label": "notification timer",
        className: T,
        style: v,
        ...E
    }));
}
let $6d00ec1db968ffaa$var$w = 1;
const $6d00ec1db968ffaa$var$k = ()=>"" + $6d00ec1db968ffaa$var$w++;
function $6d00ec1db968ffaa$var$P(e) {
    return e && ($6d00ec1db968ffaa$var$d(e.toastId) || $6d00ec1db968ffaa$var$c(e.toastId)) ? e.toastId : $6d00ec1db968ffaa$var$k();
}
function $6d00ec1db968ffaa$var$M(e, t) {
    return $6d00ec1db968ffaa$var$_(e, t), t.toastId;
}
function $6d00ec1db968ffaa$var$x(e, t) {
    return {
        ...t,
        type: t && t.type || e,
        toastId: $6d00ec1db968ffaa$var$P(t)
    };
}
function $6d00ec1db968ffaa$var$A(e) {
    return (t, n)=>$6d00ec1db968ffaa$var$M(t, $6d00ec1db968ffaa$var$x(e, n));
}
function $6d00ec1db968ffaa$export$b410431fab84fa58(e, t) {
    return $6d00ec1db968ffaa$var$M(e, $6d00ec1db968ffaa$var$x("default", t));
}
$6d00ec1db968ffaa$export$b410431fab84fa58.loading = (e, t)=>$6d00ec1db968ffaa$var$M(e, $6d00ec1db968ffaa$var$x("default", {
        isLoading: !0,
        autoClose: !1,
        closeOnClick: !1,
        closeButton: !1,
        draggable: !1,
        ...t
    })), $6d00ec1db968ffaa$export$b410431fab84fa58.promise = function(e, t, n) {
    let o, { pending: s, error: a, success: r } = t;
    s && (o = $6d00ec1db968ffaa$var$d(s) ? $6d00ec1db968ffaa$export$b410431fab84fa58.loading(s, n) : $6d00ec1db968ffaa$export$b410431fab84fa58.loading(s.render, {
        ...n,
        ...s
    }));
    const i = {
        isLoading: null,
        autoClose: null,
        closeOnClick: null,
        closeButton: null,
        draggable: null
    }, l = (e, t, s)=>{
        if (null == t) return void $6d00ec1db968ffaa$export$b410431fab84fa58.dismiss(o);
        const a = {
            type: e,
            ...i,
            ...n,
            data: s
        }, r = $6d00ec1db968ffaa$var$d(t) ? {
            render: t
        } : t;
        return o ? $6d00ec1db968ffaa$export$b410431fab84fa58.update(o, {
            ...a,
            ...r
        }) : $6d00ec1db968ffaa$export$b410431fab84fa58(r.render, {
            ...a,
            ...r
        }), s;
    }, c = $6d00ec1db968ffaa$var$u(e) ? e() : e;
    return c.then((e)=>l("success", r, e)).catch((e)=>l("error", a, e)), c;
}, $6d00ec1db968ffaa$export$b410431fab84fa58.success = $6d00ec1db968ffaa$var$A("success"), $6d00ec1db968ffaa$export$b410431fab84fa58.info = $6d00ec1db968ffaa$var$A("info"), $6d00ec1db968ffaa$export$b410431fab84fa58.error = $6d00ec1db968ffaa$var$A("error"), $6d00ec1db968ffaa$export$b410431fab84fa58.warning = $6d00ec1db968ffaa$var$A("warning"), $6d00ec1db968ffaa$export$b410431fab84fa58.warn = $6d00ec1db968ffaa$export$b410431fab84fa58.warning, $6d00ec1db968ffaa$export$b410431fab84fa58.dark = (e, t)=>$6d00ec1db968ffaa$var$M(e, $6d00ec1db968ffaa$var$x("default", {
        theme: "dark",
        ...t
    })), $6d00ec1db968ffaa$export$b410431fab84fa58.dismiss = function(e) {
    !function(e) {
        var t;
        if ($6d00ec1db968ffaa$var$b()) {
            if (null == e || $6d00ec1db968ffaa$var$d(t = e) || $6d00ec1db968ffaa$var$c(t)) $6d00ec1db968ffaa$var$v.forEach((t)=>{
                t.removeToast(e);
            });
            else if (e && ("containerId" in e || "id" in e)) {
                const t = $6d00ec1db968ffaa$var$v.get(e.containerId);
                t ? t.removeToast(e.id) : $6d00ec1db968ffaa$var$v.forEach((t)=>{
                    t.removeToast(e.id);
                });
            }
        } else $6d00ec1db968ffaa$var$h = $6d00ec1db968ffaa$var$h.filter((t)=>null != e && t.options.toastId !== e);
    }(e);
}, $6d00ec1db968ffaa$export$b410431fab84fa58.clearWaitingQueue = function(e) {
    void 0 === e && (e = {}), $6d00ec1db968ffaa$var$v.forEach((t)=>{
        !t.props.limit || e.containerId && t.id !== e.containerId || t.clearQueue();
    });
}, $6d00ec1db968ffaa$export$b410431fab84fa58.isActive = $6d00ec1db968ffaa$var$I, $6d00ec1db968ffaa$export$b410431fab84fa58.update = function(e, t) {
    void 0 === t && (t = {});
    const n = ((e, t)=>{
        var n;
        let { containerId: o } = t;
        return null == (n = $6d00ec1db968ffaa$var$v.get(o || 1)) ? void 0 : n.toasts.get(e);
    })(e, t);
    if (n) {
        const { props: o, content: s } = n, a = {
            delay: 100,
            ...o,
            ...t,
            toastId: t.toastId || e,
            updateId: $6d00ec1db968ffaa$var$k()
        };
        a.toastId !== e && (a.staleId = e);
        const r = a.render || s;
        delete a.render, $6d00ec1db968ffaa$var$M(r, a);
    }
}, $6d00ec1db968ffaa$export$b410431fab84fa58.done = (e)=>{
    $6d00ec1db968ffaa$export$b410431fab84fa58.update(e, {
        progress: 1
    });
}, $6d00ec1db968ffaa$export$b410431fab84fa58.onChange = function(e) {
    return $6d00ec1db968ffaa$var$T.add(e), ()=>{
        $6d00ec1db968ffaa$var$T.delete(e);
    };
}, $6d00ec1db968ffaa$export$b410431fab84fa58.play = (e)=>$6d00ec1db968ffaa$var$C(!0, e), $6d00ec1db968ffaa$export$b410431fab84fa58.pause = (e)=>$6d00ec1db968ffaa$var$C(!1, e);
const $6d00ec1db968ffaa$var$O = "undefined" != typeof window ? (0, $kc00y.useLayoutEffect) : (0, $kc00y.useEffect), $6d00ec1db968ffaa$var$D = (t)=>{
    let { theme: n, type: o, isLoading: s, ...a } = t;
    return (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement("svg", {
        viewBox: "0 0 24 24",
        width: "100%",
        height: "100%",
        fill: "colored" === n ? "currentColor" : `var(--toastify-icon-color-${o})`,
        ...a
    });
}, $6d00ec1db968ffaa$export$4f13f83fd8bb1dac = {
    info: function(t) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement($6d00ec1db968ffaa$var$D, {
            ...t
        }, (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement("path", {
            d: "M12 0a12 12 0 1012 12A12.013 12.013 0 0012 0zm.25 5a1.5 1.5 0 11-1.5 1.5 1.5 1.5 0 011.5-1.5zm2.25 13.5h-4a1 1 0 010-2h.75a.25.25 0 00.25-.25v-4.5a.25.25 0 00-.25-.25h-.75a1 1 0 010-2h1a2 2 0 012 2v4.75a.25.25 0 00.25.25h.75a1 1 0 110 2z"
        }));
    },
    warning: function(t) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement($6d00ec1db968ffaa$var$D, {
            ...t
        }, (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement("path", {
            d: "M23.32 17.191L15.438 2.184C14.728.833 13.416 0 11.996 0c-1.42 0-2.733.833-3.443 2.184L.533 17.448a4.744 4.744 0 000 4.368C1.243 23.167 2.555 24 3.975 24h16.05C22.22 24 24 22.044 24 19.632c0-.904-.251-1.746-.68-2.44zm-9.622 1.46c0 1.033-.724 1.823-1.698 1.823s-1.698-.79-1.698-1.822v-.043c0-1.028.724-1.822 1.698-1.822s1.698.79 1.698 1.822v.043zm.039-12.285l-.84 8.06c-.057.581-.408.943-.897.943-.49 0-.84-.367-.896-.942l-.84-8.065c-.057-.624.25-1.095.779-1.095h1.91c.528.005.84.476.784 1.1z"
        }));
    },
    success: function(t) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement($6d00ec1db968ffaa$var$D, {
            ...t
        }, (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement("path", {
            d: "M12 0a12 12 0 1012 12A12.014 12.014 0 0012 0zm6.927 8.2l-6.845 9.289a1.011 1.011 0 01-1.43.188l-4.888-3.908a1 1 0 111.25-1.562l4.076 3.261 6.227-8.451a1 1 0 111.61 1.183z"
        }));
    },
    error: function(t) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement($6d00ec1db968ffaa$var$D, {
            ...t
        }, (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement("path", {
            d: "M11.983 0a12.206 12.206 0 00-8.51 3.653A11.8 11.8 0 000 12.207 11.779 11.779 0 0011.8 24h.214A12.111 12.111 0 0024 11.791 11.766 11.766 0 0011.983 0zM10.5 16.542a1.476 1.476 0 011.449-1.53h.027a1.527 1.527 0 011.523 1.47 1.475 1.475 0 01-1.449 1.53h-.027a1.529 1.529 0 01-1.523-1.47zM11 12.5v-6a1 1 0 012 0v6a1 1 0 11-2 0z"
        }));
    },
    spinner: function() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement("div", {
            className: "Toastify__spinner"
        });
    }
}, $6d00ec1db968ffaa$var$R = (n)=>{
    const { isRunning: o, preventExitTransition: s, toastRef: r, eventHandlers: i, playToast: c } = $6d00ec1db968ffaa$export$a407b657d3044108(n), { closeButton: d, children: p, autoClose: m, onClick: f, type: g, hideProgressBar: y, closeToast: v, transition: h, position: T, className: E, style: b, bodyClassName: I, bodyStyle: _, progressClassName: C, progressStyle: L, updateId: w, role: k, progress: P, rtl: M, toastId: x, deleteToast: A, isIn: B, isLoading: O, closeOnClick: D, theme: R } = n, S = (0, $eGWiI.default)("Toastify__toast", `Toastify__toast-theme--${R}`, `Toastify__toast--${g}`, {
        "Toastify__toast--rtl": M
    }, {
        "Toastify__toast--close-on-click": D
    }), H = $6d00ec1db968ffaa$var$u(E) ? E({
        rtl: M,
        position: T,
        type: g,
        defaultClassName: S
    }) : (0, $eGWiI.default)(S, E), F = function(e) {
        let { theme: n, type: o, isLoading: s, icon: r } = e, i = null;
        const l = {
            theme: n,
            type: o
        };
        return !1 === r || ($6d00ec1db968ffaa$var$u(r) ? i = r({
            ...l,
            isLoading: s
        }) : (0, $kc00y.isValidElement)(r) ? i = (0, $kc00y.cloneElement)(r, l) : s ? i = $6d00ec1db968ffaa$export$4f13f83fd8bb1dac.spinner() : ((e)=>e in $6d00ec1db968ffaa$export$4f13f83fd8bb1dac)(o) && (i = $6d00ec1db968ffaa$export$4f13f83fd8bb1dac[o](l))), i;
    }(n), X = !!P || !m, Y = {
        closeToast: v,
        type: g,
        theme: R
    };
    let q = null;
    return !1 === d || (q = $6d00ec1db968ffaa$var$u(d) ? d(Y) : (0, $kc00y.isValidElement)(d) ? (0, $kc00y.cloneElement)(d, Y) : function(t) {
        let { closeToast: n, theme: o, ariaLabel: s = "close" } = t;
        return (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement("button", {
            className: `Toastify__close-button Toastify__close-button--${o}`,
            type: "button",
            onClick: (e)=>{
                e.stopPropagation(), n(e);
            },
            "aria-label": s
        }, (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement("svg", {
            "aria-hidden": "true",
            viewBox: "0 0 14 16"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement("path", {
            fillRule: "evenodd",
            d: "M7.71 8.23l3.75 3.75-1.48 1.48-3.75-3.75-3.75 3.75L1 11.98l3.75-3.75L1 4.48 2.48 3l3.75 3.75L9.98 3l1.48 1.48-3.75 3.75z"
        })));
    }(Y)), (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement(h, {
        isIn: B,
        done: A,
        position: T,
        preventExitTransition: s,
        nodeRef: r,
        playToast: c
    }, (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement("div", {
        id: x,
        onClick: f,
        "data-in": B,
        className: H,
        ...i,
        style: b,
        ref: r
    }, (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement("div", {
        ...B && {
            role: k
        },
        className: $6d00ec1db968ffaa$var$u(I) ? I({
            type: g
        }) : (0, $eGWiI.default)("Toastify__toast-body", I),
        style: _
    }, null != F && (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement("div", {
        className: (0, $eGWiI.default)("Toastify__toast-icon", {
            "Toastify--animate-icon Toastify__zoom-enter": !O
        })
    }, F), (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement("div", null, p)), q, (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement($6d00ec1db968ffaa$var$$, {
        ...w && !X ? {
            key: `pb-${w}`
        } : {},
        rtl: M,
        theme: R,
        delay: m,
        isRunning: o,
        isIn: B,
        closeToast: v,
        hide: y,
        type: g,
        style: L,
        className: C,
        controlledProgress: X,
        progress: P || 0
    })));
}, $6d00ec1db968ffaa$var$S = function(e, t) {
    return void 0 === t && (t = !1), {
        enter: `Toastify--animate Toastify__${e}-enter`,
        exit: `Toastify--animate Toastify__${e}-exit`,
        appendPosition: t
    };
}, $6d00ec1db968ffaa$export$d20e79fdc3899e95 = $6d00ec1db968ffaa$export$3ff7dc44d332d222($6d00ec1db968ffaa$var$S("bounce", !0)), $6d00ec1db968ffaa$export$d8dc01b5c85a37b9 = $6d00ec1db968ffaa$export$3ff7dc44d332d222($6d00ec1db968ffaa$var$S("slide", !0)), $6d00ec1db968ffaa$export$65cfd44a2050f99 = $6d00ec1db968ffaa$export$3ff7dc44d332d222($6d00ec1db968ffaa$var$S("zoom")), $6d00ec1db968ffaa$export$4d2fae537bd90431 = $6d00ec1db968ffaa$export$3ff7dc44d332d222($6d00ec1db968ffaa$var$S("flip")), $6d00ec1db968ffaa$var$q = {
    position: "top-right",
    transition: $6d00ec1db968ffaa$export$d20e79fdc3899e95,
    autoClose: 5e3,
    closeButton: !0,
    pauseOnHover: !0,
    pauseOnFocusLoss: !0,
    draggable: "touch",
    draggablePercent: 80,
    draggableDirection: "x",
    role: "alert",
    theme: "light"
};
function $6d00ec1db968ffaa$export$f2815235e76a62b9(t) {
    let o = {
        ...$6d00ec1db968ffaa$var$q,
        ...t
    };
    const s = t.stacked, [a, r] = (0, $kc00y.useState)(!0), c = (0, $kc00y.useRef)(null), { getToastToRender: d, isToastActive: m, count: f } = $6d00ec1db968ffaa$export$b262e13ca2dd2381(o), { className: g, style: y, rtl: v, containerId: h } = o;
    function T(e) {
        const t = (0, $eGWiI.default)("Toastify__toast-container", `Toastify__toast-container--${e}`, {
            "Toastify__toast-container--rtl": v
        });
        return $6d00ec1db968ffaa$var$u(g) ? g({
            position: e,
            rtl: v,
            defaultClassName: t
        }) : (0, $eGWiI.default)(t, $6d00ec1db968ffaa$var$p(g));
    }
    function E() {
        s && (r(!0), $6d00ec1db968ffaa$export$b410431fab84fa58.play());
    }
    return $6d00ec1db968ffaa$var$O(()=>{
        if (s) {
            var e;
            const t = c.current.querySelectorAll('[data-in="true"]'), n = 12, s = null == (e = o.position) ? void 0 : e.includes("top");
            let r = 0, i = 0;
            Array.from(t).reverse().forEach((e, t)=>{
                const o = e;
                o.classList.add("Toastify__toast--stacked"), t > 0 && (o.dataset.collapsed = `${a}`), o.dataset.pos || (o.dataset.pos = s ? "top" : "bot");
                const l = r * (a ? .2 : 1) + (a ? 0 : n * t);
                o.style.setProperty("--y", `${s ? l : -1 * l}px`), o.style.setProperty("--g", `${n}`), o.style.setProperty("--s", "" + (1 - (a ? i : 0))), r += o.offsetHeight, i += .025;
            });
        }
    }, [
        a,
        f,
        s
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement("div", {
        ref: c,
        className: "Toastify",
        id: h,
        onMouseEnter: ()=>{
            s && (r(!1), $6d00ec1db968ffaa$export$b410431fab84fa58.pause());
        },
        onMouseLeave: E
    }, d((t, n)=>{
        const o = n.length ? {
            ...y
        } : {
            ...y,
            pointerEvents: "none"
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement("div", {
            className: T(t),
            style: o,
            key: `container-${t}`
        }, n.map((t)=>{
            let { content: n, props: o } = t;
            return (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement($6d00ec1db968ffaa$var$R, {
                ...o,
                stacked: s,
                collapseAll: E,
                isIn: m(o.toastId, o.containerId),
                style: o.style,
                key: `toast-${o.key}`
            }, n);
        }));
    }));
}

});
parcelRegister("eGWiI", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "clsx", () => $328c1c2632e2f292$export$4f5d2d50c9deca37);
$parcel$export(module.exports, "default", () => $328c1c2632e2f292$export$2e2bcd8739ae039);
function $328c1c2632e2f292$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $328c1c2632e2f292$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $328c1c2632e2f292$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $328c1c2632e2f292$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $328c1c2632e2f292$export$2e2bcd8739ae039 = $328c1c2632e2f292$export$4f5d2d50c9deca37;

});


parcelRegister("htkH1", function(module, exports) {

$parcel$export(module.exports, "error", () => $cb853241920141e5$export$a3bc9b8ed74fc, (v) => $cb853241920141e5$export$a3bc9b8ed74fc = v);
$parcel$export(module.exports, "info", () => $cb853241920141e5$export$a80b3bd66acc52ff, (v) => $cb853241920141e5$export$a80b3bd66acc52ff = v);
$parcel$export(module.exports, "progress", () => $cb853241920141e5$export$504d7abb21fa8c9, (v) => $cb853241920141e5$export$504d7abb21fa8c9 = v);
$parcel$export(module.exports, "success", () => $cb853241920141e5$export$fe7c49d056ea1d88, (v) => $cb853241920141e5$export$fe7c49d056ea1d88 = v);
$parcel$export(module.exports, "toast", () => $cb853241920141e5$export$b410431fab84fa58, (v) => $cb853241920141e5$export$b410431fab84fa58 = v);
var $cb853241920141e5$export$a3bc9b8ed74fc;
var $cb853241920141e5$export$a80b3bd66acc52ff;
var $cb853241920141e5$export$504d7abb21fa8c9;
var $cb853241920141e5$export$fe7c49d056ea1d88;
var $cb853241920141e5$export$b410431fab84fa58;
$cb853241920141e5$export$a3bc9b8ed74fc = `GgNKMa_error`;
$cb853241920141e5$export$a80b3bd66acc52ff = `GgNKMa_info`;
$cb853241920141e5$export$504d7abb21fa8c9 = `GgNKMa_progress`;
$cb853241920141e5$export$fe7c49d056ea1d88 = `GgNKMa_success`;
$cb853241920141e5$export$b410431fab84fa58 = `GgNKMa_toast`;

});


parcelRegister("26Ddr", function(module, exports) {

$parcel$export(module.exports, "useGet", () => $e1a769e707817ee2$export$99b32c99608275e1);
$parcel$export(module.exports, "usePost", () => $e1a769e707817ee2$export$9158e33c8d0ca687);
$parcel$export(module.exports, "useDelete", () => $e1a769e707817ee2$export$60acb8fd13afd60d);
$parcel$export(module.exports, "usePut", () => $e1a769e707817ee2$export$f378150f39d4621f);

var $aiEmM = parcelRequire("aiEmM");

var $kc00y = parcelRequire("kc00y");

var $5TbRy = parcelRequire("5TbRy");

var $7hZVf = parcelRequire("7hZVf");
const $e1a769e707817ee2$export$8ff66c70be1c563a = async (url, options = {})=>{
    if (!url) return null;
    const res = await fetch(url === decodeURIComponent(url) ? encodeURI(url) : url, options);
    if (res.status === 401) document.location.href = (0, $7hZVf.URLS).LOGIN;
    if (!res.ok) throw res;
    if (res.status === 204) return null;
    return res.text().then((text)=>{
        return text ? JSON.parse(text) : null;
    });
};
function $e1a769e707817ee2$export$99b32c99608275e1(url, asyncOptions = {}) {
    return (0, $aiEmM.useAsync)({
        ...asyncOptions,
        promiseFn: (0, $kc00y.useCallback)((props, { signal: signal })=>{
            const options = (0, $5TbRy.getFetchOptions)({
                signal: signal,
                method: "GET"
            });
            return $e1a769e707817ee2$export$8ff66c70be1c563a(url, options);
        }, [
            url
        ])
    });
}
function $e1a769e707817ee2$export$6326fb4463ae1be4(url, asyncOptions) {
    return (0, $aiEmM.useAsync)({
        ...asyncOptions,
        deferFn: (0, $kc00y.useCallback)((props, { signal: signal })=>{
            const options = (0, $5TbRy.getFetchOptions)({
                signal: signal,
                method: "GET"
            });
            return $e1a769e707817ee2$export$8ff66c70be1c563a(url, options);
        }, [
            url
        ])
    });
}
function $e1a769e707817ee2$export$9158e33c8d0ca687(url, asyncOptions = {}) {
    return (0, $aiEmM.useAsync)({
        ...asyncOptions,
        deferFn: (0, $kc00y.useCallback)((args, props, { signal: signal })=>{
            const options = (0, $5TbRy.getFetchOptions)({
                signal: signal,
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(args[0])
            });
            return $e1a769e707817ee2$export$8ff66c70be1c563a(url, options);
        }, [
            url
        ])
    });
}
function $e1a769e707817ee2$export$60acb8fd13afd60d(url, asyncOptions) {
    return (0, $aiEmM.useAsync)({
        ...asyncOptions,
        deferFn: (0, $kc00y.useCallback)((args, props, { signal: signal })=>{
            const options = (0, $5TbRy.getFetchOptions)({
                signal: signal,
                method: "DELETE"
            });
            return $e1a769e707817ee2$export$8ff66c70be1c563a(url, options);
        }, [
            url
        ])
    });
}
function $e1a769e707817ee2$export$f378150f39d4621f(url, asyncOptions = {}, isMultipartFormData) {
    return (0, $aiEmM.useAsync)({
        ...asyncOptions,
        deferFn: (0, $kc00y.useCallback)((args, props, { signal: signal })=>{
            const options = isMultipartFormData ? (0, $5TbRy.getFetchOptions)({
                signal: signal,
                method: "PUT",
                body: args[0]
            }) : (0, $5TbRy.getFetchOptions)({
                signal: signal,
                method: "PUT",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(args[0])
            });
            return $e1a769e707817ee2$export$8ff66c70be1c563a(url, options);
        }, [
            isMultipartFormData,
            url
        ])
    });
}

});
parcelRegister("aiEmM", function(module, exports) {

$parcel$export(module.exports, "useAsync", () => $77fae5be6c2b1145$export$cdf1dc76b55502e3);

var $kc00y = parcelRequire("kc00y");
/* istanbul ignore file */ /**
 * Universal global scope object. In the browser this is `self`, in Node.js and React Native it's `global`.
 * This file is excluded from coverage reporting because these globals are environment-specific so we can't test them all.
 */ const $77fae5be6c2b1145$export$af1bbc55aad4f91e = (()=>{
    if (typeof self === "object" && self.self === self) return self;
    if (typeof $parcel$global === "object" && $parcel$global.global === $parcel$global) return $parcel$global;
    if (typeof $parcel$global === "object" && $parcel$global.GLOBAL === $parcel$global) return $parcel$global;
    return {}; // fallback that relies on imported modules to be singletons
})();
/**
 * Globally available object used to connect the DevTools to all React Async instances.
 */ $77fae5be6c2b1145$export$af1bbc55aad4f91e.__REACT_ASYNC__ = $77fae5be6c2b1145$export$af1bbc55aad4f91e.__REACT_ASYNC__ || {};
const $77fae5be6c2b1145$var$noop = ()=>{};
class $77fae5be6c2b1145$var$MockAbortController {
    constructor(){
        this.abort = $77fae5be6c2b1145$var$noop;
        this.signal = {};
    }
}
let $77fae5be6c2b1145$var$PropTypes;

try {
    $77fae5be6c2b1145$var$PropTypes = (parcelRequire("lCkAA"));
} catch (e) {}
const $77fae5be6c2b1145$var$childrenFn = $77fae5be6c2b1145$var$PropTypes && $77fae5be6c2b1145$var$PropTypes.oneOfType([
    $77fae5be6c2b1145$var$PropTypes.node,
    $77fae5be6c2b1145$var$PropTypes.func
]);
const $77fae5be6c2b1145$var$stateObject = $77fae5be6c2b1145$var$PropTypes && $77fae5be6c2b1145$var$PropTypes.shape({
    initialValue: $77fae5be6c2b1145$var$PropTypes.any,
    data: $77fae5be6c2b1145$var$PropTypes.any,
    error: $77fae5be6c2b1145$var$PropTypes.instanceOf(Error),
    value: $77fae5be6c2b1145$var$PropTypes.any,
    startedAt: $77fae5be6c2b1145$var$PropTypes.instanceOf(Date),
    finishedAt: $77fae5be6c2b1145$var$PropTypes.instanceOf(Date),
    status: $77fae5be6c2b1145$var$PropTypes.oneOf([
        "initial",
        "pending",
        "fulfilled",
        "rejected"
    ]),
    isInitial: $77fae5be6c2b1145$var$PropTypes.bool,
    isPending: $77fae5be6c2b1145$var$PropTypes.bool,
    isLoading: $77fae5be6c2b1145$var$PropTypes.bool,
    isFulfilled: $77fae5be6c2b1145$var$PropTypes.bool,
    isResolved: $77fae5be6c2b1145$var$PropTypes.bool,
    isRejected: $77fae5be6c2b1145$var$PropTypes.bool,
    isSettled: $77fae5be6c2b1145$var$PropTypes.bool,
    counter: $77fae5be6c2b1145$var$PropTypes.number,
    promise: $77fae5be6c2b1145$var$PropTypes.instanceOf(Promise),
    run: $77fae5be6c2b1145$var$PropTypes.func,
    reload: $77fae5be6c2b1145$var$PropTypes.func,
    cancel: $77fae5be6c2b1145$var$PropTypes.func,
    setData: $77fae5be6c2b1145$var$PropTypes.func,
    setError: $77fae5be6c2b1145$var$PropTypes.func
});
var $77fae5be6c2b1145$var$propTypes = $77fae5be6c2b1145$var$PropTypes && {
    Async: {
        children: $77fae5be6c2b1145$var$childrenFn,
        promise: $77fae5be6c2b1145$var$PropTypes.instanceOf(Promise),
        promiseFn: $77fae5be6c2b1145$var$PropTypes.func,
        deferFn: $77fae5be6c2b1145$var$PropTypes.func,
        watch: $77fae5be6c2b1145$var$PropTypes.any,
        watchFn: $77fae5be6c2b1145$var$PropTypes.func,
        initialValue: $77fae5be6c2b1145$var$PropTypes.any,
        onResolve: $77fae5be6c2b1145$var$PropTypes.func,
        onReject: $77fae5be6c2b1145$var$PropTypes.func,
        reducer: $77fae5be6c2b1145$var$PropTypes.func,
        dispatcher: $77fae5be6c2b1145$var$PropTypes.func,
        debugLabel: $77fae5be6c2b1145$var$PropTypes.string,
        suspense: $77fae5be6c2b1145$var$PropTypes.bool
    },
    Initial: {
        children: $77fae5be6c2b1145$var$childrenFn,
        state: $77fae5be6c2b1145$var$stateObject.isRequired,
        persist: $77fae5be6c2b1145$var$PropTypes.bool
    },
    Pending: {
        children: $77fae5be6c2b1145$var$childrenFn,
        state: $77fae5be6c2b1145$var$stateObject.isRequired,
        initial: $77fae5be6c2b1145$var$PropTypes.bool
    },
    Fulfilled: {
        children: $77fae5be6c2b1145$var$childrenFn,
        state: $77fae5be6c2b1145$var$stateObject.isRequired,
        persist: $77fae5be6c2b1145$var$PropTypes.bool
    },
    Rejected: {
        children: $77fae5be6c2b1145$var$childrenFn,
        state: $77fae5be6c2b1145$var$stateObject.isRequired,
        persist: $77fae5be6c2b1145$var$PropTypes.bool
    },
    Settled: {
        children: $77fae5be6c2b1145$var$childrenFn,
        state: $77fae5be6c2b1145$var$stateObject.isRequired,
        persist: $77fae5be6c2b1145$var$PropTypes.bool
    }
};
const $77fae5be6c2b1145$var$renderFn = (children, ...args)=>{
    if (typeof children === "function") {
        const render = children;
        return render(...args);
    }
    return children;
};
/**
 * Renders only when no promise has started or completed yet.
 *
 * @prop {Function|Node} children Function (passing state) or React node
 * @prop {Object} state React Async state object
 * @prop {boolean} persist Show until we have data, even while pending (loading) or when an error occurred
 */ const $77fae5be6c2b1145$export$ef55f14ef766f494 = ({ children: children, persist: persist, state: state = {} })=>(0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).Fragment, null, state.isInitial || persist && !state.data ? $77fae5be6c2b1145$var$renderFn(children, state) : null);
/**
 * Renders only while pending (promise is loading).
 *
 * @prop {Function|Node} children Function (passing state) or React node
 * @prop {Object} state React Async state object
 * @prop {boolean} initial Show only on initial load (data is undefined)
 */ const $77fae5be6c2b1145$export$fcb4895414d32f4e = ({ children: children, initial: initial, state: state = {} })=>(0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).Fragment, null, state.isPending && (!initial || !state.value) ? $77fae5be6c2b1145$var$renderFn(children, state) : null);
/**
 * Renders only when promise is resolved.
 *
 * @prop {Function|Node} children Function (passing data and state) or React node
 * @prop {Object} state React Async state object
 * @prop {boolean} persist Show old data while pending (promise is loading)
 */ const $77fae5be6c2b1145$export$e51ea416e03c0b2 = ({ children: children, persist: persist, state: state = {} })=>(0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).Fragment, null, state.isFulfilled || persist && state.data ? $77fae5be6c2b1145$var$renderFn(children, state.data, state) : null);
/**
 * Renders only when promise is rejected.
 *
 * @prop {Function|Node} children Function (passing error and state) or React node
 * @prop {Object} state React Async state object
 * @prop {boolean} persist Show old error while pending (promise is loading)
 */ const $77fae5be6c2b1145$export$9c650b30aa842e16 = ({ children: children, persist: persist, state: state = {} })=>(0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).Fragment, null, state.isRejected || persist && state.error ? $77fae5be6c2b1145$var$renderFn(children, state.error, state) : null);
/**
 * Renders only when promise is fulfilled or rejected.
 *
 * @prop {Function|Node} children Function (passing state) or React node
 * @prop {Object} state React Async state object
 * @prop {boolean} persist Show old data or error while pending (promise is loading)
 */ const $77fae5be6c2b1145$export$6248b08a30065aab = ({ children: children, persist: persist, state: state = {} })=>(0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).Fragment, null, state.isSettled || persist && state.value ? $77fae5be6c2b1145$var$renderFn(children, state) : null);
if ($77fae5be6c2b1145$var$propTypes) {
    $77fae5be6c2b1145$export$ef55f14ef766f494.propTypes = $77fae5be6c2b1145$var$propTypes.Initial;
    $77fae5be6c2b1145$export$fcb4895414d32f4e.propTypes = $77fae5be6c2b1145$var$propTypes.Pending;
    $77fae5be6c2b1145$export$e51ea416e03c0b2.propTypes = $77fae5be6c2b1145$var$propTypes.Fulfilled;
    $77fae5be6c2b1145$export$9c650b30aa842e16.propTypes = $77fae5be6c2b1145$var$propTypes.Rejected;
    $77fae5be6c2b1145$export$6248b08a30065aab.propTypes = $77fae5be6c2b1145$var$propTypes.Settled;
}
var $77fae5be6c2b1145$export$71c2f43e23882c69;
(function(StatusTypes) {
    StatusTypes["initial"] = "initial";
    StatusTypes["pending"] = "pending";
    StatusTypes["fulfilled"] = "fulfilled";
    StatusTypes["rejected"] = "rejected";
})($77fae5be6c2b1145$export$71c2f43e23882c69 || ($77fae5be6c2b1145$export$71c2f43e23882c69 = {}));
const $77fae5be6c2b1145$var$getInitialStatus = (value, promise)=>{
    if (value instanceof Error) return $77fae5be6c2b1145$export$71c2f43e23882c69.rejected;
    if (value !== undefined) return $77fae5be6c2b1145$export$71c2f43e23882c69.fulfilled;
    if (promise) return $77fae5be6c2b1145$export$71c2f43e23882c69.pending;
    return $77fae5be6c2b1145$export$71c2f43e23882c69.initial;
};
const $77fae5be6c2b1145$var$getIdleStatus = (value)=>{
    if (value instanceof Error) return $77fae5be6c2b1145$export$71c2f43e23882c69.rejected;
    if (value !== undefined) return $77fae5be6c2b1145$export$71c2f43e23882c69.fulfilled;
    return $77fae5be6c2b1145$export$71c2f43e23882c69.initial;
};
const $77fae5be6c2b1145$var$getStatusProps = (status)=>({
        status: status,
        isInitial: status === $77fae5be6c2b1145$export$71c2f43e23882c69.initial,
        isPending: status === $77fae5be6c2b1145$export$71c2f43e23882c69.pending,
        isLoading: status === $77fae5be6c2b1145$export$71c2f43e23882c69.pending,
        isFulfilled: status === $77fae5be6c2b1145$export$71c2f43e23882c69.fulfilled,
        isResolved: status === $77fae5be6c2b1145$export$71c2f43e23882c69.fulfilled,
        isRejected: status === $77fae5be6c2b1145$export$71c2f43e23882c69.rejected,
        isSettled: status === $77fae5be6c2b1145$export$71c2f43e23882c69.fulfilled || status === $77fae5be6c2b1145$export$71c2f43e23882c69.rejected
    });
// This exists to make sure we don't hold any references to user-provided functions
// The way NeverSettle extends from Promise is complicated, but can't be done differently because Babel doesn't support
// extending built-in classes. See https://babeljs.io/docs/en/caveats/#classes
const $77fae5be6c2b1145$var$NeverSettle = function() {};
/* istanbul ignore next */ if (Object.setPrototypeOf) Object.setPrototypeOf($77fae5be6c2b1145$var$NeverSettle, Promise);
else $77fae5be6c2b1145$var$NeverSettle.__proto__ = Promise;
$77fae5be6c2b1145$var$NeverSettle.prototype = Object.assign(Object.create(Promise.prototype), {
    finally () {
        return this;
    },
    catch () {
        return this;
    },
    then () {
        return this;
    }
});
const $77fae5be6c2b1145$export$f8415f49327504d8 = new $77fae5be6c2b1145$var$NeverSettle();
var $77fae5be6c2b1145$export$1385d81a6c6bbcd4;
(function(ActionTypes) {
    ActionTypes["start"] = "start";
    ActionTypes["cancel"] = "cancel";
    ActionTypes["fulfill"] = "fulfill";
    ActionTypes["reject"] = "reject";
})($77fae5be6c2b1145$export$1385d81a6c6bbcd4 || ($77fae5be6c2b1145$export$1385d81a6c6bbcd4 = {}));
const $77fae5be6c2b1145$export$2cd8252107eb640b = ({ initialValue: initialValue, promise: promise, promiseFn: promiseFn })=>({
        initialValue: initialValue,
        data: initialValue instanceof Error ? undefined : initialValue,
        error: initialValue instanceof Error ? initialValue : undefined,
        value: initialValue,
        startedAt: promise || promiseFn ? new Date() : undefined,
        finishedAt: initialValue ? new Date() : undefined,
        ...$77fae5be6c2b1145$var$getStatusProps($77fae5be6c2b1145$var$getInitialStatus(initialValue, promise || promiseFn)),
        counter: 0,
        promise: $77fae5be6c2b1145$export$f8415f49327504d8
    });
const $77fae5be6c2b1145$export$1650419e431d3ba3 = (state, action)=>{
    switch(action.type){
        case $77fae5be6c2b1145$export$1385d81a6c6bbcd4.start:
            return {
                ...state,
                startedAt: new Date(),
                finishedAt: undefined,
                ...$77fae5be6c2b1145$var$getStatusProps($77fae5be6c2b1145$export$71c2f43e23882c69.pending),
                counter: action.meta.counter,
                promise: action.meta.promise
            };
        case $77fae5be6c2b1145$export$1385d81a6c6bbcd4.cancel:
            return {
                ...state,
                startedAt: undefined,
                finishedAt: undefined,
                ...$77fae5be6c2b1145$var$getStatusProps($77fae5be6c2b1145$var$getIdleStatus(state.error || state.data)),
                counter: action.meta.counter,
                promise: action.meta.promise
            };
        case $77fae5be6c2b1145$export$1385d81a6c6bbcd4.fulfill:
            return {
                ...state,
                data: action.payload,
                value: action.payload,
                error: undefined,
                finishedAt: new Date(),
                ...$77fae5be6c2b1145$var$getStatusProps($77fae5be6c2b1145$export$71c2f43e23882c69.fulfilled),
                promise: action.meta.promise
            };
        case $77fae5be6c2b1145$export$1385d81a6c6bbcd4.reject:
            return {
                ...state,
                error: action.payload,
                value: action.payload,
                finishedAt: new Date(),
                ...$77fae5be6c2b1145$var$getStatusProps($77fae5be6c2b1145$export$71c2f43e23882c69.rejected),
                promise: action.meta.promise
            };
        default:
            return state;
    }
};
const $77fae5be6c2b1145$export$9883d18982e679cf = (dispatch)=>(action, ...args)=>{
        dispatch(action, ...args);
        if (action.type === $77fae5be6c2b1145$export$1385d81a6c6bbcd4.start && typeof action.payload === "function") action.payload();
    };
class $77fae5be6c2b1145$var$Async extends (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).Component {
}
/**
 * createInstance allows you to create instances of Async that are bound to a specific promise.
 * A unique instance also uses its own React context for better nesting capability.
 */ function $77fae5be6c2b1145$export$99152e8d49ca4e7d(defaultOptions = {}, displayName = "Async") {
    const { Consumer: UnguardedConsumer, Provider: Provider } = (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createContext(undefined);
    function Consumer({ children: children }) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement(UnguardedConsumer, null, (value)=>{
            if (!value) throw new Error("this component should only be used within an associated <Async> component!");
            return children(value);
        });
    }
    class Async extends (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).Component {
        constructor(props){
            super(props);
            this.mounted = false;
            this.counter = 0;
            this.args = [];
            this.promise = $77fae5be6c2b1145$export$f8415f49327504d8;
            this.abortController = new $77fae5be6c2b1145$var$MockAbortController();
            this.start = this.start.bind(this);
            this.load = this.load.bind(this);
            this.run = this.run.bind(this);
            this.cancel = this.cancel.bind(this);
            this.onResolve = this.onResolve.bind(this);
            this.onReject = this.onReject.bind(this);
            this.setData = this.setData.bind(this);
            this.setError = this.setError.bind(this);
            const promise = props.promise;
            const promiseFn = props.promiseFn || defaultOptions.promiseFn;
            const initialValue = props.initialValue || defaultOptions.initialValue;
            this.state = {
                ...$77fae5be6c2b1145$export$2cd8252107eb640b({
                    initialValue: initialValue,
                    promise: promise,
                    promiseFn: promiseFn
                }),
                cancel: this.cancel,
                run: this.run,
                reload: ()=>{
                    this.load();
                    this.run(...this.args);
                },
                setData: this.setData,
                setError: this.setError
            };
            this.debugLabel = props.debugLabel || defaultOptions.debugLabel;
            const { devToolsDispatcher: devToolsDispatcher } = $77fae5be6c2b1145$export$af1bbc55aad4f91e.__REACT_ASYNC__;
            const _reducer = props.reducer || defaultOptions.reducer;
            const _dispatcher = props.dispatcher || defaultOptions.dispatcher || devToolsDispatcher;
            const reducer$1 = _reducer ? (state, action)=>_reducer(state, action, $77fae5be6c2b1145$export$1650419e431d3ba3) : $77fae5be6c2b1145$export$1650419e431d3ba3;
            const dispatch = $77fae5be6c2b1145$export$9883d18982e679cf((action, callback)=>{
                this.setState((state)=>reducer$1(state, action), callback);
            });
            this.dispatch = _dispatcher ? (action)=>_dispatcher(action, dispatch, props) : dispatch;
        }
        componentDidMount() {
            this.mounted = true;
            if (this.props.promise || !this.state.initialValue) this.load();
        }
        componentDidUpdate(prevProps) {
            const { watch: watch, watchFn: watchFn = defaultOptions.watchFn, promise: promise, promiseFn: promiseFn } = this.props;
            if (watch !== prevProps.watch) {
                if (this.counter) this.cancel();
                return this.load();
            }
            if (watchFn && watchFn({
                ...defaultOptions,
                ...this.props
            }, {
                ...defaultOptions,
                ...prevProps
            })) {
                if (this.counter) this.cancel();
                return this.load();
            }
            if (promise !== prevProps.promise) {
                if (this.counter) this.cancel();
                if (promise) return this.load();
            }
            if (promiseFn !== prevProps.promiseFn) {
                if (this.counter) this.cancel();
                if (promiseFn) return this.load();
            }
        }
        componentWillUnmount() {
            this.cancel();
            this.mounted = false;
        }
        getMeta(meta) {
            return {
                counter: this.counter,
                promise: this.promise,
                debugLabel: this.debugLabel,
                ...meta
            };
        }
        start(promiseFn) {
            if ("AbortController" in $77fae5be6c2b1145$export$af1bbc55aad4f91e) {
                this.abortController.abort();
                this.abortController = new $77fae5be6c2b1145$export$af1bbc55aad4f91e.AbortController();
            }
            this.counter++;
            return this.promise = new Promise((resolve, reject)=>{
                if (!this.mounted) return;
                const executor = ()=>promiseFn().then(resolve, reject);
                this.dispatch({
                    type: $77fae5be6c2b1145$export$1385d81a6c6bbcd4.start,
                    payload: executor,
                    meta: this.getMeta()
                });
            });
        }
        load() {
            const promise = this.props.promise;
            const promiseFn = this.props.promiseFn || defaultOptions.promiseFn;
            if (promise) this.start(()=>promise).then(this.onResolve(this.counter)).catch(this.onReject(this.counter));
            else if (promiseFn) {
                const props = {
                    ...defaultOptions,
                    ...this.props
                };
                this.start(()=>promiseFn(props, this.abortController)).then(this.onResolve(this.counter)).catch(this.onReject(this.counter));
            }
        }
        run(...args) {
            const deferFn = this.props.deferFn || defaultOptions.deferFn;
            if (deferFn) {
                this.args = args;
                const props = {
                    ...defaultOptions,
                    ...this.props
                };
                return this.start(()=>deferFn(args, props, this.abortController)).then(this.onResolve(this.counter), this.onReject(this.counter));
            }
        }
        cancel() {
            const onCancel = this.props.onCancel || defaultOptions.onCancel;
            onCancel && onCancel();
            this.counter++;
            this.abortController.abort();
            this.mounted && this.dispatch({
                type: $77fae5be6c2b1145$export$1385d81a6c6bbcd4.cancel,
                meta: this.getMeta()
            });
        }
        onResolve(counter) {
            return (data)=>{
                if (this.counter === counter) {
                    const onResolve = this.props.onResolve || defaultOptions.onResolve;
                    this.setData(data, ()=>onResolve && onResolve(data));
                }
                return data;
            };
        }
        onReject(counter) {
            return (error)=>{
                if (this.counter === counter) {
                    const onReject = this.props.onReject || defaultOptions.onReject;
                    this.setError(error, ()=>onReject && onReject(error));
                }
                return error;
            };
        }
        setData(data, callback) {
            this.mounted && this.dispatch({
                type: $77fae5be6c2b1145$export$1385d81a6c6bbcd4.fulfill,
                payload: data,
                meta: this.getMeta()
            }, callback);
            return data;
        }
        setError(error, callback) {
            this.mounted && this.dispatch({
                type: $77fae5be6c2b1145$export$1385d81a6c6bbcd4.reject,
                payload: error,
                error: true,
                meta: this.getMeta()
            }, callback);
            return error;
        }
        render() {
            const { children: children, suspense: suspense } = this.props;
            if (suspense && this.state.isPending && this.promise !== $77fae5be6c2b1145$export$f8415f49327504d8) // Rely on Suspense to handle the loading state
            throw this.promise;
            if (typeof children === "function") {
                const render = children;
                return (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement(Provider, {
                    value: this.state
                }, render(this.state));
            }
            if (children !== undefined && children !== null) return (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement(Provider, {
                value: this.state
            }, children);
            return null;
        }
    }
    if ($77fae5be6c2b1145$var$propTypes) Async.propTypes = $77fae5be6c2b1145$var$propTypes.Async;
    const AsyncInitial = (props)=>(0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement(Consumer, null, (st)=>(0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement($77fae5be6c2b1145$export$ef55f14ef766f494, Object.assign({}, props, {
                state: st
            })));
    const AsyncPending = (props)=>(0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement(Consumer, null, (st)=>(0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement($77fae5be6c2b1145$export$fcb4895414d32f4e, Object.assign({}, props, {
                state: st
            })));
    const AsyncFulfilled = (props)=>(0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement(Consumer, null, (st)=>(0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement($77fae5be6c2b1145$export$e51ea416e03c0b2, Object.assign({}, props, {
                state: st
            })));
    const AsyncRejected = (props)=>(0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement(Consumer, null, (st)=>(0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement($77fae5be6c2b1145$export$9c650b30aa842e16, Object.assign({}, props, {
                state: st
            })));
    const AsyncSettled = (props)=>(0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement(Consumer, null, (st)=>(0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement($77fae5be6c2b1145$export$6248b08a30065aab, Object.assign({}, props, {
                state: st
            })));
    AsyncInitial.displayName = `${displayName}.Initial`;
    AsyncPending.displayName = `${displayName}.Pending`;
    AsyncFulfilled.displayName = `${displayName}.Fulfilled`;
    AsyncRejected.displayName = `${displayName}.Rejected`;
    AsyncSettled.displayName = `${displayName}.Settled`;
    return Object.assign(Async, {
        displayName: displayName,
        Initial: AsyncInitial,
        Pending: AsyncPending,
        Loading: AsyncPending,
        Fulfilled: AsyncFulfilled,
        Resolved: AsyncFulfilled,
        Rejected: AsyncRejected,
        Settled: AsyncSettled
    });
}
var $77fae5be6c2b1145$export$4d3c597da532240f = $77fae5be6c2b1145$export$99152e8d49ca4e7d();
function $77fae5be6c2b1145$var$useAsync(arg1, arg2) {
    const options = typeof arg1 === "function" ? {
        ...arg2,
        promiseFn: arg1
    } : arg1;
    const counter = (0, $kc00y.useRef)(0);
    const isMounted = (0, $kc00y.useRef)(true);
    const lastArgs = (0, $kc00y.useRef)(undefined);
    const lastOptions = (0, $kc00y.useRef)(options);
    const lastPromise = (0, $kc00y.useRef)($77fae5be6c2b1145$export$f8415f49327504d8);
    const abortController = (0, $kc00y.useRef)(new $77fae5be6c2b1145$var$MockAbortController());
    const { devToolsDispatcher: devToolsDispatcher } = $77fae5be6c2b1145$export$af1bbc55aad4f91e.__REACT_ASYNC__;
    const { reducer: reducer$1, dispatcher: dispatcher = devToolsDispatcher } = options;
    const [state, _dispatch] = (0, $kc00y.useReducer)(reducer$1 ? (state, action)=>reducer$1(state, action, $77fae5be6c2b1145$export$1650419e431d3ba3) : $77fae5be6c2b1145$export$1650419e431d3ba3, options, $77fae5be6c2b1145$export$2cd8252107eb640b);
    const dispatch = (0, $kc00y.useCallback)(dispatcher ? (action)=>dispatcher(action, $77fae5be6c2b1145$export$9883d18982e679cf(_dispatch), lastOptions.current) : $77fae5be6c2b1145$export$9883d18982e679cf(_dispatch), [
        dispatcher
    ]);
    const { debugLabel: debugLabel } = options;
    const getMeta = (0, $kc00y.useCallback)((meta)=>({
            counter: counter.current,
            promise: lastPromise.current,
            debugLabel: debugLabel,
            ...meta
        }), [
        debugLabel
    ]);
    const setData = (0, $kc00y.useCallback)((data, callback = $77fae5be6c2b1145$var$noop)=>{
        if (isMounted.current) {
            dispatch({
                type: $77fae5be6c2b1145$export$1385d81a6c6bbcd4.fulfill,
                payload: data,
                meta: getMeta()
            });
            callback();
        }
        return data;
    }, [
        dispatch,
        getMeta
    ]);
    const setError = (0, $kc00y.useCallback)((error, callback = $77fae5be6c2b1145$var$noop)=>{
        if (isMounted.current) {
            dispatch({
                type: $77fae5be6c2b1145$export$1385d81a6c6bbcd4.reject,
                payload: error,
                error: true,
                meta: getMeta()
            });
            callback();
        }
        return error;
    }, [
        dispatch,
        getMeta
    ]);
    const { onResolve: onResolve, onReject: onReject } = options;
    const handleResolve = (0, $kc00y.useCallback)((count)=>(data)=>count === counter.current && setData(data, ()=>onResolve && onResolve(data)), [
        setData,
        onResolve
    ]);
    const handleReject = (0, $kc00y.useCallback)((count)=>(err)=>count === counter.current && setError(err, ()=>onReject && onReject(err)), [
        setError,
        onReject
    ]);
    const start = (0, $kc00y.useCallback)((promiseFn)=>{
        if ("AbortController" in $77fae5be6c2b1145$export$af1bbc55aad4f91e) {
            abortController.current.abort();
            abortController.current = new $77fae5be6c2b1145$export$af1bbc55aad4f91e.AbortController();
        }
        counter.current++;
        return lastPromise.current = new Promise((resolve, reject)=>{
            if (!isMounted.current) return;
            const executor = ()=>promiseFn().then(resolve, reject);
            dispatch({
                type: $77fae5be6c2b1145$export$1385d81a6c6bbcd4.start,
                payload: executor,
                meta: getMeta()
            });
        });
    }, [
        dispatch,
        getMeta
    ]);
    const { promise: promise, promiseFn: promiseFn, initialValue: initialValue } = options;
    const load = (0, $kc00y.useCallback)(()=>{
        const isPreInitialized = initialValue && counter.current === 0;
        if (promise) start(()=>promise).then(handleResolve(counter.current)).catch(handleReject(counter.current));
        else if (promiseFn && !isPreInitialized) start(()=>promiseFn(lastOptions.current, abortController.current)).then(handleResolve(counter.current)).catch(handleReject(counter.current));
    }, [
        start,
        promise,
        promiseFn,
        initialValue,
        handleResolve,
        handleReject
    ]);
    const { deferFn: deferFn } = options;
    const run = (0, $kc00y.useCallback)((...args)=>{
        if (deferFn) {
            lastArgs.current = args;
            start(()=>deferFn(args, lastOptions.current, abortController.current)).then(handleResolve(counter.current)).catch(handleReject(counter.current));
        }
    }, [
        start,
        deferFn,
        handleResolve,
        handleReject
    ]);
    const reload = (0, $kc00y.useCallback)(()=>{
        lastArgs.current ? run(...lastArgs.current) : load();
    }, [
        run,
        load
    ]);
    const { onCancel: onCancel } = options;
    const cancel = (0, $kc00y.useCallback)(()=>{
        onCancel && onCancel();
        counter.current++;
        abortController.current.abort();
        isMounted.current && dispatch({
            type: $77fae5be6c2b1145$export$1385d81a6c6bbcd4.cancel,
            meta: getMeta()
        });
    }, [
        onCancel,
        dispatch,
        getMeta
    ]);
    /* These effects should only be triggered on changes to specific props */ /* eslint-disable react-hooks/exhaustive-deps */ const { watch: watch, watchFn: watchFn } = options;
    (0, $kc00y.useEffect)(()=>{
        if (watchFn && lastOptions.current && watchFn(options, lastOptions.current)) {
            lastOptions.current = options;
            load();
        }
    });
    (0, $kc00y.useEffect)(()=>{
        lastOptions.current = options;
    }, [
        options
    ]);
    (0, $kc00y.useEffect)(()=>{
        if (counter.current) cancel();
        if (promise || promiseFn) load();
    }, [
        promise,
        promiseFn,
        watch
    ]);
    (0, $kc00y.useEffect)(()=>()=>{
            isMounted.current = false;
        }, []);
    (0, $kc00y.useEffect)(()=>()=>cancel(), []);
    /* eslint-enable react-hooks/exhaustive-deps */ (0, $kc00y.useDebugValue)(state, ({ status: status })=>`[${counter.current}] ${status}`);
    if (options.suspense && state.isPending && lastPromise.current !== $77fae5be6c2b1145$export$f8415f49327504d8) // Rely on Suspense to handle the loading state
    throw lastPromise.current;
    return (0, $kc00y.useMemo)(()=>({
            ...state,
            run: run,
            reload: reload,
            cancel: cancel,
            setData: setData,
            setError: setError
        }), [
        state,
        run,
        reload,
        cancel,
        setData,
        setError
    ]);
}
class $77fae5be6c2b1145$export$26e841bcf1aeb894 extends Error {
    constructor(response){
        super(`${response.status} ${response.statusText}`);
        this.response = response;
        /* istanbul ignore next */ if (Object.setPrototypeOf) // Not available in IE 10, but can be polyfilled
        Object.setPrototypeOf(this, $77fae5be6c2b1145$export$26e841bcf1aeb894.prototype);
    }
}
const $77fae5be6c2b1145$var$parseResponse = (accept, json)=>(res)=>{
        if (!res.ok) return Promise.reject(new $77fae5be6c2b1145$export$26e841bcf1aeb894(res));
        if (typeof json === "boolean") return json ? res.json() : res;
        return accept === "application/json" ? res.json() : res;
    };
function $77fae5be6c2b1145$var$isEvent(e) {
    return typeof e === "object" && "preventDefault" in e;
}
/**
 *
 * @param {RequestInfo} resource
 * @param {RequestInit} init
 * @param {FetchOptions} options
 * @returns {AsyncState<T, FetchRun<T>>}
 */ function $77fae5be6c2b1145$var$useAsyncFetch(resource, init, { defer: defer, json: json, ...options } = {}) {
    const method = resource.method || init && init.method;
    const headers = resource.headers || init && init.headers || {};
    const accept = headers["Accept"] || headers["accept"] || headers.get && headers.get("accept");
    const doFetch = (input, init)=>$77fae5be6c2b1145$export$af1bbc55aad4f91e.fetch(input, init).then($77fae5be6c2b1145$var$parseResponse(accept, json));
    const isDefer = typeof defer === "boolean" ? defer : [
        "POST",
        "PUT",
        "PATCH",
        "DELETE"
    ].indexOf(method) !== -1;
    const fn = isDefer ? "deferFn" : "promiseFn";
    const identity = JSON.stringify({
        resource: resource,
        init: init,
        isDefer: isDefer
    });
    const promiseFn = (0, $kc00y.useCallback)((_, { signal: signal })=>{
        return doFetch(resource, {
            signal: signal,
            ...init
        });
    }, [
        identity
    ] // eslint-disable-line react-hooks/exhaustive-deps
    );
    const deferFn = (0, $kc00y.useCallback)(function([override], _, { signal: signal }) {
        if (!override || $77fae5be6c2b1145$var$isEvent(override)) return doFetch(resource, {
            signal: signal,
            ...init
        });
        if (typeof override === "function") {
            const { resource: runResource, ...runInit } = override({
                resource: resource,
                signal: signal,
                ...init
            });
            return doFetch(runResource || resource, {
                signal: signal,
                ...runInit
            });
        }
        const { resource: runResource, ...runInit } = override;
        return doFetch(runResource || resource, {
            signal: signal,
            ...init,
            ...runInit
        });
    }, [
        identity
    ] // eslint-disable-line react-hooks/exhaustive-deps
    );
    const state = $77fae5be6c2b1145$var$useAsync({
        ...options,
        [fn]: isDefer ? deferFn : promiseFn
    });
    (0, $kc00y.useDebugValue)(state, ({ counter: counter, status: status })=>`[${counter}] ${status}`);
    return state;
}
const $77fae5be6c2b1145$var$unsupported = ()=>{
    throw new Error("useAsync requires React v16.8 or up. Upgrade your React version or use the <Async> component instead.");
};
var $77fae5be6c2b1145$export$cdf1dc76b55502e3 = (0, $kc00y.useEffect) ? $77fae5be6c2b1145$var$useAsync : $77fae5be6c2b1145$var$unsupported;
const $77fae5be6c2b1145$export$d852f5f778460fa4 = (0, $kc00y.useEffect) ? $77fae5be6c2b1145$var$useAsyncFetch : $77fae5be6c2b1145$var$unsupported;
var $77fae5be6c2b1145$export$2e2bcd8739ae039 = $77fae5be6c2b1145$export$4d3c597da532240f;

});


parcelRegister("3BicN", function(module, exports) {

$parcel$export(module.exports, "Form", () => $271088369fd04a37$export$a7fed597f4b8afd8);
$parcel$export(module.exports, "Password", () => $271088369fd04a37$export$5e47cc20a502b05f);
$parcel$export(module.exports, "Text", () => $271088369fd04a37$export$5f1af8db9871e1d6);
$parcel$export(module.exports, "TextField", () => $271088369fd04a37$export$2c73285ae9390cec);
$parcel$export(module.exports, "LargeTextField", () => $271088369fd04a37$export$b419ecf71a0c0e82);
$parcel$export(module.exports, "NumberField", () => $271088369fd04a37$export$63c5fa0b2fdccd2e);
$parcel$export(module.exports, "ErrorMessage", () => $271088369fd04a37$export$915e9e7bd4f0f96d);
$parcel$export(module.exports, "FileInput", () => $271088369fd04a37$export$b57af79a4ab2a1c6);
$parcel$export(module.exports, "CheckboxInput", () => $271088369fd04a37$export$d4e232ca161ccdd3);
$parcel$export(module.exports, "Select", () => $271088369fd04a37$export$ef9b1a59e592288f);
$parcel$export(module.exports, "SelectInput", () => $271088369fd04a37$export$d6701e98ab1a6725);
$parcel$export(module.exports, "MultiSelectInput", () => $271088369fd04a37$export$5a8f20dde0180f76);

var $cKvYK = parcelRequire("cKvYK");

var $kc00y = parcelRequire("kc00y");

var $bkJfK = parcelRequire("bkJfK");

var $lgiU2 = parcelRequire("lgiU2");

var $kXior = parcelRequire("kXior");
var $cyAAA = parcelRequire("cyAAA");
var $eM09M = parcelRequire("eM09M");

var $bNJBP = parcelRequire("bNJBP");

var $hpOSz = parcelRequire("hpOSz");

var $bYYyU = parcelRequire("bYYyU");

var $7q6Xv = parcelRequire("7q6Xv");
const $271088369fd04a37$export$a7fed597f4b8afd8 = (props)=>/*#__PURE__*/ (0, $cKvYK.jsx)((0, $bkJfK.Form), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($7q6Xv))).form,
        ...props
    });
const $271088369fd04a37$export$b04be29aa201d4f5 = (0, $bNJBP.makeTemplateComponent)("label", (0, (/*@__PURE__*/$parcel$interopDefault($7q6Xv))).label);
const $271088369fd04a37$export$f5b8910cec6cf069 = /*#__PURE__*/ (0, $kc00y.forwardRef)(({ className: className, ...rest }, ref)=>/*#__PURE__*/ (0, $cKvYK.jsx)("input", {
        ...rest,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($lgiU2)))((0, (/*@__PURE__*/$parcel$interopDefault($7q6Xv))).input, className),
        ref: ref
    }));
$271088369fd04a37$export$f5b8910cec6cf069.displayName = "Input";
const $271088369fd04a37$export$28044d9a5dbb104e = /*#__PURE__*/ (0, $kc00y.forwardRef)(({ className: className, error: error, disabled: disabled, icon: icon, submitable: submitable, ...rest }, ref)=>/*#__PURE__*/ (0, $cKvYK.jsxs)("div", {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($lgiU2)))((0, (/*@__PURE__*/$parcel$interopDefault($7q6Xv))).inputSearch, {
            [(0, (/*@__PURE__*/$parcel$interopDefault($7q6Xv))).disabled]: disabled
        }, className),
        children: [
            error && /*#__PURE__*/ (0, $cKvYK.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($7q6Xv))).icon,
                children: /*#__PURE__*/ (0, $cKvYK.jsx)((0, $hpOSz.IconError), {})
            }),
            /*#__PURE__*/ (0, $cKvYK.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($7q6Xv))).inputDiv,
                children: [
                    !submitable && /*#__PURE__*/ (0, $cKvYK.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($7q6Xv))).icon,
                        children: icon
                    }),
                    /*#__PURE__*/ (0, $cKvYK.jsx)("input", {
                        ...rest,
                        disabled: disabled,
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($7q6Xv))).input
                    }),
                    submitable && /*#__PURE__*/ (0, $cKvYK.jsx)((0, $bYYyU.default), {
                        type: (0, $bYYyU.TYPE_BUTTON).submit,
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($7q6Xv))).searchButton,
                        children: /*#__PURE__*/ (0, $cKvYK.jsx)((0, $hpOSz.IconSearch), {})
                    })
                ]
            })
        ]
    }));
$271088369fd04a37$export$28044d9a5dbb104e.displayName = "InputSearch";
const $271088369fd04a37$export$b6b6ecdb09eff2c7 = ({ label: label, value: value })=>{
    return /*#__PURE__*/ (0, $cKvYK.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($7q6Xv))).field,
        children: [
            label && /*#__PURE__*/ (0, $cKvYK.jsx)($271088369fd04a37$export$b04be29aa201d4f5, {
                children: label
            }),
            /*#__PURE__*/ (0, $cKvYK.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($7q6Xv))).valueField,
                children: /*#__PURE__*/ (0, $cKvYK.jsx)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($7q6Xv))).value,
                    children: value
                })
            })
        ]
    });
};
const $271088369fd04a37$var$Field = ({ label: label, name: name, type: type, placeholder: placeholder = "", disabled: disabled, className: className, icon: icon, submitable: submitable, ...rest })=>{
    const [field, meta] = (0, $bkJfK.useField)(name);
    const error = meta.touched ? meta.error : null;
    // Permet d'effacer le filtre recherche si on appuie sur le bouton "réinitialiser"
    field.value = field.value ?? "";
    return /*#__PURE__*/ (0, $cKvYK.jsxs)($271088369fd04a37$export$3e4181949bece6a4, {
        error: error,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($lgiU2)))((0, (/*@__PURE__*/$parcel$interopDefault($7q6Xv))).field, {
            [(0, (/*@__PURE__*/$parcel$interopDefault($7q6Xv))).noLabel]: !label
        }, className),
        children: [
            label && /*#__PURE__*/ (0, $cKvYK.jsx)($271088369fd04a37$export$b04be29aa201d4f5, {
                htmlFor: name,
                children: label
            }),
            /*#__PURE__*/ (0, $cKvYK.jsx)($271088369fd04a37$export$28044d9a5dbb104e, {
                id: name,
                type: type,
                placeholder: placeholder,
                disabled: disabled,
                icon: icon,
                submitable: submitable,
                ...field,
                ...rest,
                error: error
            })
        ]
    });
};
const $271088369fd04a37$export$5e47cc20a502b05f = ({ label: label, name: name, placeholder: placeholder = "", disabled: disabled, className: className })=>/*#__PURE__*/ (0, $cKvYK.jsx)($271088369fd04a37$var$Field, {
        label: label,
        type: "password",
        name: name,
        placeholder: placeholder,
        disabled: disabled,
        className: className
    });
const $271088369fd04a37$export$5f1af8db9871e1d6 = ({ label: label, name: name, placeholder: placeholder = "", disabled: disabled, className: className, obligatoire: obligatoire = false, submitable: submitable = false, ...rest })=>/*#__PURE__*/ (0, $cKvYK.jsx)($271088369fd04a37$var$Field, {
        label: /*#__PURE__*/ (0, $cKvYK.jsxs)((0, $cKvYK.Fragment), {
            children: [
                label,
                " ",
                obligatoire && /*#__PURE__*/ (0, $cKvYK.jsx)("span", {
                    className: "text-danger fw-bold",
                    children: "*"
                })
            ]
        }),
        type: "text",
        name: name,
        placeholder: placeholder,
        disabled: disabled,
        icon: !submitable && /*#__PURE__*/ (0, $cKvYK.jsx)((0, $hpOSz.IconSearch), {}),
        submitable: submitable,
        className: className,
        ...rest
    });
const $271088369fd04a37$export$2c73285ae9390cec = ({ name: name, placeholder: placeholder = "", disabled: disabled, ...rest })=>{
    const [field] = (0, $bkJfK.useField)(name);
    return /*#__PURE__*/ (0, $cKvYK.jsx)("input", {
        id: name,
        name: name,
        type: "text",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($7q6Xv))).textInput,
        placeholder: placeholder,
        disabled: disabled,
        ...field,
        ...rest
    });
};
const $271088369fd04a37$export$b419ecf71a0c0e82 = ({ name: name, placeholder: placeholder = "", disabled: disabled, ...rest })=>{
    const [field] = (0, $bkJfK.useField)(name);
    return /*#__PURE__*/ (0, $cKvYK.jsx)("textarea", {
        id: name,
        name: name,
        type: "text",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($7q6Xv))).largeTextInput,
        placeholder: placeholder,
        disabled: disabled,
        ...field,
        ...rest
    });
};
const $271088369fd04a37$export$63c5fa0b2fdccd2e = ({ name: name, min: min, max: max, placeholder: placeholder = "", disabled: disabled = false, onChange: onChangeCallback, className: className, ...rest })=>{
    const [field] = (0, $bkJfK.useField)(name);
    return /*#__PURE__*/ (0, $cKvYK.jsx)("input", {
        id: name,
        name: name,
        type: "number",
        min: min,
        max: max,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($lgiU2)))((0, (/*@__PURE__*/$parcel$interopDefault($7q6Xv))).numberInput, className),
        placeholder: placeholder,
        disabled: disabled,
        ...field,
        onChange: (e)=>{
            field.onChange(e);
            if (onChangeCallback) onChangeCallback(e.target.value);
        },
        ...rest
    });
};
const $271088369fd04a37$export$915e9e7bd4f0f96d = ({ error: error })=>error ? /*#__PURE__*/ (0, $cKvYK.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($7q6Xv))).errorMessage,
        children: error
    }) : null;
const $271088369fd04a37$export$3e4181949bece6a4 = ({ error: error, className: className, innerRef: innerRef, children: children, ...rest })=>/*#__PURE__*/ (0, $cKvYK.jsxs)("div", {
        ...rest,
        ref: innerRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($lgiU2)))(className, error ? (0, (/*@__PURE__*/$parcel$interopDefault($7q6Xv))).error : null),
        children: [
            children,
            /*#__PURE__*/ (0, $cKvYK.jsx)($271088369fd04a37$export$915e9e7bd4f0f96d, {
                error: error
            })
        ]
    });
const $271088369fd04a37$export$b57af79a4ab2a1c6 = ({ label: label, name: name, accept: accept, className: className })=>{
    const [field, meta] = (0, $bkJfK.useField)(name);
    const { setFieldValue: setFieldValue } = (0, $bkJfK.useFormikContext)();
    const error = meta.touched ? meta.error : null;
    return /*#__PURE__*/ (0, $cKvYK.jsx)((0, $cKvYK.Fragment), {
        children: /*#__PURE__*/ (0, $cKvYK.jsxs)($271088369fd04a37$export$3e4181949bece6a4, {
            name: name,
            error: error,
            children: [
                label && /*#__PURE__*/ (0, $cKvYK.jsxs)("label", {
                    htmlFor: name,
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($7q6Xv))).label,
                    children: [
                        label,
                        "\xa0:"
                    ]
                }),
                /*#__PURE__*/ (0, $cKvYK.jsxs)("label", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($7q6Xv))).fileInputButton,
                    children: [
                        /*#__PURE__*/ (0, $cKvYK.jsxs)("div", {
                            className: className,
                            children: [
                                field?.value?.name ?? " ",
                                " \xa0",
                                /*#__PURE__*/ (0, $cKvYK.jsx)("input", {
                                    id: name,
                                    type: "file",
                                    accept: accept,
                                    onChange: (e)=>{
                                        setFieldValue(name, e.target.files[0]);
                                    },
                                    hidden: true
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $cKvYK.jsx)("span", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($7q6Xv))).fileInputIcon,
                            children: /*#__PURE__*/ (0, $cKvYK.jsx)((0, $hpOSz.IconUpload), {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $cKvYK.jsx)($271088369fd04a37$export$915e9e7bd4f0f96d, {
                    name: name
                })
            ]
        })
    });
};
const $271088369fd04a37$export$ceb1bc6d1dff5ae8 = (0, $bNJBP.makeTemplateComponent)("div", (0, (/*@__PURE__*/$parcel$interopDefault($7q6Xv))).verticalLine);
const $271088369fd04a37$export$f99233281efd08a0 = (0, $bNJBP.makeTemplateComponent)("div", (0, (/*@__PURE__*/$parcel$interopDefault($7q6Xv))).title);
const $271088369fd04a37$export$48513f6b9f8ce62d = ({ disabled: disabled, name: name, value: value = false, className: className, ...rest })=>{
    return /*#__PURE__*/ (0, $cKvYK.jsxs)("span", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($lgiU2)))((0, (/*@__PURE__*/$parcel$interopDefault($7q6Xv))).checkbox, {
            [(0, (/*@__PURE__*/$parcel$interopDefault($7q6Xv))).disabled]: disabled
        }, className),
        children: [
            /*#__PURE__*/ (0, $cKvYK.jsx)("input", {
                id: name,
                type: "checkbox",
                ...rest,
                value: value.toString(),
                checked: value,
                disabled: disabled,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($7q6Xv))).input
            }),
            /*#__PURE__*/ (0, $cKvYK.jsx)("label", {
                htmlFor: name,
                children: /*#__PURE__*/ (0, $cKvYK.jsx)((0, $hpOSz.Toggle), {
                    toggled: value
                })
            })
        ]
    });
};
const $271088369fd04a37$export$d4e232ca161ccdd3 = ({ name: name, label: label, disabled: disabled, className: className, value: value, onChange: onChangeCallback, tooltip: tooltip })=>{
    const [field, meta] = (0, $bkJfK.useField)(name);
    const error = meta.touched ? meta.error : null;
    return /*#__PURE__*/ (0, $cKvYK.jsxs)($271088369fd04a37$export$3e4181949bece6a4, {
        error: error,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($lgiU2)))((0, (/*@__PURE__*/$parcel$interopDefault($7q6Xv))).field, {
            [(0, (/*@__PURE__*/$parcel$interopDefault($7q6Xv))).noLabel]: !label
        }, className),
        children: [
            label && /*#__PURE__*/ (0, $cKvYK.jsxs)("label", {
                htmlFor: field.name,
                children: [
                    /*#__PURE__*/ (0, $cKvYK.jsxs)("span", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($7q6Xv))).label,
                        children: [
                            label,
                            "\xa0",
                            label.trim().endsWith("?") ? "" : ":"
                        ]
                    }),
                    tooltip ?? tooltip
                ]
            }),
            /*#__PURE__*/ (0, $cKvYK.jsx)($271088369fd04a37$export$48513f6b9f8ce62d, {
                ...field,
                value: field.value ?? value,
                disabled: disabled,
                onChange: (event)=>{
                    if (onChangeCallback) onChangeCallback(event.target.checked);
                    field.onChange(event);
                }
            })
        ]
    });
};
const $271088369fd04a37$export$bc9c32a845e25197 = ({ disabled: disabled, name: name, value: value = false, className: className, ...rest })=>{
    return /*#__PURE__*/ (0, $cKvYK.jsx)("span", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($lgiU2)))((0, (/*@__PURE__*/$parcel$interopDefault($7q6Xv))).realCheckbox, {
            [(0, (/*@__PURE__*/$parcel$interopDefault($7q6Xv))).disabled]: disabled
        }, className),
        children: /*#__PURE__*/ (0, $cKvYK.jsx)("label", {
            htmlFor: name,
            children: /*#__PURE__*/ (0, $cKvYK.jsx)("input", {
                id: name,
                type: "checkbox",
                ...rest,
                value: value.toString(),
                checked: value,
                disabled: disabled,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($7q6Xv))).input
            })
        })
    });
};
const $271088369fd04a37$export$4fe74d83a05d7f38 = ({ name: name, label: label, disabled: disabled, className: className, value: value, onChange: onChangeCallback })=>{
    const [field, meta] = (0, $bkJfK.useField)(name);
    const error = meta.touched ? meta.error : null;
    return /*#__PURE__*/ (0, $cKvYK.jsxs)($271088369fd04a37$export$3e4181949bece6a4, {
        error: error,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($lgiU2)))((0, (/*@__PURE__*/$parcel$interopDefault($7q6Xv))).field, {
            [(0, (/*@__PURE__*/$parcel$interopDefault($7q6Xv))).noLabel]: !label
        }, className),
        children: [
            /*#__PURE__*/ (0, $cKvYK.jsx)($271088369fd04a37$export$bc9c32a845e25197, {
                ...field,
                value: value ?? field.value,
                disabled: disabled,
                onChange: (event)=>{
                    if (onChangeCallback) onChangeCallback(event.target.checked);
                    field.onChange(event);
                }
            }),
            label && /*#__PURE__*/ (0, $cKvYK.jsxs)("label", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($lgiU2)))((0, (/*@__PURE__*/$parcel$interopDefault($7q6Xv))).labelCheckbox),
                htmlFor: field.name,
                children: [
                    label,
                    "\xa0"
                ]
            })
        ]
    });
};
const $271088369fd04a37$var$Option = ({ data: data, ...rest })=>{
    const value = data;
    return /*#__PURE__*/ (0, $cKvYK.jsx)((0, $kXior.c).Option, {
        ...rest,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($lgiU2)))({
            [(0, (/*@__PURE__*/$parcel$interopDefault($7q6Xv))).invalide]: value.valide != null && !value.valide
        })
    });
};
// eslint-disable-next-line react/display-name
const $271088369fd04a37$var$ReactSelectInput = (name)=>(props)=>{
        return /*#__PURE__*/ (0, $cKvYK.jsx)((0, $kXior.c).Input, {
            ...props,
            name: name
        });
    };
const $271088369fd04a37$var$_SelectInput = ({ name: name, label: label, disabled: disabled, options: options, isMulti: isMulti = false, isClearable: isClearable = false, obligatoire: obligatoire = false, className: className, onChange: onChangeCallback, getOptionValue: getOptionValue = (option)=>option.id, toOptionLabelFunc: toOptionLabelFunc = (option)=>option.label, value: value, ...props })=>{
    const [field, { error: error }, { setValue: setValue, setTouched: setTouched }] = (0, $bkJfK.useField)(name);
    const Input = (0, $kc00y.useMemo)(()=>$271088369fd04a37$var$ReactSelectInput(name), [
        name
    ]);
    return /*#__PURE__*/ (0, $cKvYK.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($lgiU2)))((0, (/*@__PURE__*/$parcel$interopDefault($7q6Xv))).field, className),
        children: [
            label && /*#__PURE__*/ (0, $cKvYK.jsxs)("label", {
                htmlFor: name,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($7q6Xv))).label,
                children: [
                    label,
                    "\xa0:",
                    " ",
                    obligatoire && /*#__PURE__*/ (0, $cKvYK.jsx)("span", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($7q6Xv))).obligatoire,
                        children: "*"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cKvYK.jsxs)($271088369fd04a37$export$3e4181949bece6a4, {
                name: field.name,
                children: [
                    /*#__PURE__*/ (0, $cKvYK.jsx)($271088369fd04a37$export$ef9b1a59e592288f, {
                        menuPlacement: "auto",
                        components: {
                            Option: $271088369fd04a37$var$Option,
                            Input: Input
                        },
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($7q6Xv))).reactSelect,
                        options: options || [],
                        getOptionLabel: toOptionLabelFunc,
                        getOptionValue: getOptionValue,
                        isMulti: isMulti,
                        value: value ?? field.value,
                        onChange: (values)=>{
                            if (onChangeCallback) onChangeCallback(values);
                            setValue(values);
                        },
                        onBlur: ()=>setTouched(true),
                        isDisabled: disabled,
                        closeMenuOnSelect: !isMulti,
                        isClearable: isClearable,
                        isSearchable: true,
                        placeholder: "S\xe9lectionnez...",
                        noOptionsMessage: ()=>"Pas d'options disponibles pour cette valeur",
                        name: name,
                        ...props
                    }),
                    /*#__PURE__*/ (0, $cKvYK.jsx)($271088369fd04a37$export$915e9e7bd4f0f96d, {
                        error: error
                    })
                ]
            })
        ]
    });
};
const $271088369fd04a37$var$_Select = ({ options: options, isDisabled: isDisabled = false, isMulti: isMulti = false, isClearable: isClearable = false, isSearchable: isSearchable = false, getOptionLabel: getOptionLabel = (option)=>option.label, getOptionValue: getOptionValue = (option)=>option.id, noOptionsMessage: noOptionsMessage = ()=>"Pas d'options disponibles pour cette valeur", filterOption: filterOption = (0, $cyAAA.c)({
    ignoreCase: true,
    ignoreAccents: true,
    matchFrom: "any",
    stringify: (option)=>`${option.label}`,
    trim: true
}), onChange: onChange, value: value, defaultValue: defaultValue, className: className, placeholder: placeholder = "S\xe9lectionnez...", menuPlacement: menuPlacement = "auto", ...props })=>{
    return /*#__PURE__*/ (0, $cKvYK.jsx)((0, $eM09M.default), {
        menuPlacement: menuPlacement,
        className: className,
        classNamePrefix: "select",
        options: options || [],
        getOptionLabel: getOptionLabel,
        getOptionValue: getOptionValue,
        isMulti: isMulti,
        value: value,
        defaultValue: defaultValue,
        onChange: onChange,
        isDisabled: isDisabled,
        closeMenuOnSelect: !isMulti,
        isClearable: isClearable,
        isSearchable: isSearchable,
        placeholder: placeholder,
        noOptionsMessage: noOptionsMessage,
        filterOption: filterOption,
        ...props
    });
};
const $271088369fd04a37$export$ef9b1a59e592288f = (props)=>/*#__PURE__*/ (0, $cKvYK.jsx)($271088369fd04a37$var$_Select, {
        ...props
    });
const $271088369fd04a37$export$d6701e98ab1a6725 = (props)=>/*#__PURE__*/ (0, $cKvYK.jsx)($271088369fd04a37$var$_SelectInput, {
        ...props
    });
const $271088369fd04a37$export$5a8f20dde0180f76 = (props)=>/*#__PURE__*/ (0, $cKvYK.jsx)($271088369fd04a37$var$_SelectInput, {
        ...props,
        isMulti: true
    });
const $271088369fd04a37$export$5ae90e48adab607e = ({ children: children, label: label, disabled: disabled = false })=>{
    const { setFieldValue: setFieldValue } = (0, $bkJfK.useFormikContext)();
    // Peut être amélioré
    const names = children.flatMap((d)=>d?.props?.name).filter(Boolean);
    const clearLine = ()=>{
        names.forEach((v)=>{
            setFieldValue(v, null, true);
        });
    };
    return /*#__PURE__*/ (0, $cKvYK.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($7q6Xv))).clearableLine,
        children: [
            label && /*#__PURE__*/ (0, $cKvYK.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($7q6Xv))).label,
                children: label
            }),
            /*#__PURE__*/ (0, $cKvYK.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($7q6Xv))).clearableWrapper,
                children: [
                    children,
                    /*#__PURE__*/ (0, $cKvYK.jsxs)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($7q6Xv))).clearButton,
                        onClick: !disabled && clearLine,
                        disabled: disabled,
                        children: [
                            /*#__PURE__*/ (0, $cKvYK.jsx)((0, $hpOSz.IconClose), {}),
                            "\xa0Effacer"
                        ]
                    })
                ]
            })
        ]
    });
};
const $271088369fd04a37$export$f84500b8bd7608c8 = ({ name: name, choices: choices = [], disabled: disabled })=>{
    const [, meta, helpers] = (0, $bkJfK.useField)(name);
    const { value: values } = meta;
    const { setValue: setValue } = helpers;
    const CheckboxButton = ({ data: data })=>/*#__PURE__*/ (0, $cKvYK.jsxs)("label", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($lgiU2)))((0, (/*@__PURE__*/$parcel$interopDefault($7q6Xv))).multiCbCheckbox, {
                [(0, (/*@__PURE__*/$parcel$interopDefault($7q6Xv))).multiCbCheckboxActive]: values.map((v)=>v.id).indexOf(data.id) !== -1
            }),
            title: data.label,
            children: [
                /*#__PURE__*/ (0, $cKvYK.jsx)("input", {
                    type: "checkbox",
                    id: data.id,
                    name: data.id,
                    value: data.id,
                    disabled: disabled,
                    checked: values.map((v)=>v.id).indexOf(data.id) !== -1,
                    onClick: (e)=>{
                        setValue(e.target.checked ? [
                            ...values,
                            data
                        ] : values.filter((v)=>v.id !== data.id));
                    },
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($7q6Xv))).input
                }),
                data.label
            ]
        });
    return choices?.length > 0 ? /*#__PURE__*/ (0, $cKvYK.jsxs)((0, $cKvYK.Fragment), {
        children: [
            /*#__PURE__*/ (0, $cKvYK.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($7q6Xv))).block,
                children: [
                    choices.map((d, k)=>/*#__PURE__*/ (0, $cKvYK.jsx)(CheckboxButton, {
                            data: d
                        }, k)),
                    /*#__PURE__*/ (0, $cKvYK.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($lgiU2)))((0, (/*@__PURE__*/$parcel$interopDefault($7q6Xv))).multiCbCheckbox, {
                            [(0, (/*@__PURE__*/$parcel$interopDefault($7q6Xv))).multiCbCheckboxActive]: choices.every((value)=>values.map((v)=>v.id).includes(value.id))
                        }),
                        title: "Tous",
                        onClick: ()=>{
                            setValue(choices);
                        },
                        children: "Tous"
                    }, -1)
                ]
            }),
            /*#__PURE__*/ (0, $cKvYK.jsx)($271088369fd04a37$export$915e9e7bd4f0f96d, {
                error: meta.error
            })
        ]
    }) : null;
};
const $271088369fd04a37$export$597cf9d64aa4772 = ()=>{
    return /*#__PURE__*/ (0, $cKvYK.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($7q6Xv))).legende,
        children: [
            /*#__PURE__*/ (0, $cKvYK.jsx)("span", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($7q6Xv))).obligatoire,
                children: "*"
            }),
            "\xa0 : Champ requis"
        ]
    });
};

});
parcelRegister("kXior", function(module, exports) {

$parcel$export(module.exports, "J", () => $f41795d8de53e64c$export$b4171a6734a65d42);
$parcel$export(module.exports, "E", () => $f41795d8de53e64c$export$a9c23c6ac3fc3eca);
$parcel$export(module.exports, "H", () => $f41795d8de53e64c$export$7f8ddf7c7c20b3cd);
$parcel$export(module.exports, "G", () => $f41795d8de53e64c$export$2329c99376c9d0a4);
$parcel$export(module.exports, "I", () => $f41795d8de53e64c$export$9bb611d729802a56);
$parcel$export(module.exports, "z", () => $f41795d8de53e64c$export$df995fae86a55f06);
$parcel$export(module.exports, "A", () => $f41795d8de53e64c$export$ebd11618f299a286);
$parcel$export(module.exports, "s", () => $f41795d8de53e64c$export$2408f22a0fab9ae5);
$parcel$export(module.exports, "K", () => $f41795d8de53e64c$export$3466f893ebf79586);
$parcel$export(module.exports, "D", () => $f41795d8de53e64c$export$96f57966bedc81b4);
$parcel$export(module.exports, "C", () => $f41795d8de53e64c$export$e7094788287c5e9b);
$parcel$export(module.exports, "B", () => $f41795d8de53e64c$export$ef35774e6d314e91);
$parcel$export(module.exports, "r", () => $f41795d8de53e64c$export$43caf9889c228507);
$parcel$export(module.exports, "m", () => $f41795d8de53e64c$export$953cecd6e717a553);
$parcel$export(module.exports, "M", () => $f41795d8de53e64c$export$3a1a48c8f6ef640e);
$parcel$export(module.exports, "n", () => $f41795d8de53e64c$export$7ccc53e8f1e7dfc5);
$parcel$export(module.exports, "u", () => $f41795d8de53e64c$export$3b14a55fb2447963);
$parcel$export(module.exports, "k", () => $f41795d8de53e64c$export$342063e11d6c3cad);
$parcel$export(module.exports, "o", () => $f41795d8de53e64c$export$ae1af26003f05816);
$parcel$export(module.exports, "b", () => $f41795d8de53e64c$export$8b22cf2602fb60ce);
$parcel$export(module.exports, "y", () => $f41795d8de53e64c$export$4a5767248b18ef41);
$parcel$export(module.exports, "i", () => $f41795d8de53e64c$export$23f2a1d2818174ef);
$parcel$export(module.exports, "e", () => $f41795d8de53e64c$export$f1e1789686576879);
$parcel$export(module.exports, "a", () => $f41795d8de53e64c$export$407448d2b89b1813);
$parcel$export(module.exports, "h", () => $f41795d8de53e64c$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "l", () => $f41795d8de53e64c$export$882b5998b3b9117c);
$parcel$export(module.exports, "d", () => $f41795d8de53e64c$export$4368d992c4eafac0);
$parcel$export(module.exports, "g", () => $f41795d8de53e64c$export$39b482c5e57630a8);
$parcel$export(module.exports, "f", () => $f41795d8de53e64c$export$2d1720544b23b823);
$parcel$export(module.exports, "j", () => $f41795d8de53e64c$export$35e795649ee09318);
$parcel$export(module.exports, "p", () => $f41795d8de53e64c$export$ffb5f4729a158638);
$parcel$export(module.exports, "q", () => $f41795d8de53e64c$export$9e5f44173e64f162);
$parcel$export(module.exports, "t", () => $f41795d8de53e64c$export$625550452a3fa3ec);
$parcel$export(module.exports, "v", () => $f41795d8de53e64c$export$90a7f3efeed30595);
$parcel$export(module.exports, "w", () => $f41795d8de53e64c$export$efccba1c4a2ef57b);
$parcel$export(module.exports, "x", () => $f41795d8de53e64c$export$d141bba7fdc215a3);
$parcel$export(module.exports, "c", () => $f41795d8de53e64c$export$db3b6bfb95261072);
$parcel$export(module.exports, "F", () => $f41795d8de53e64c$export$d66501df72047452);

var $9CGAW = parcelRequire("9CGAW");

var $cGuNc = parcelRequire("cGuNc");

var $f9nE2 = parcelRequire("f9nE2");

var $jve2F = parcelRequire("jve2F");

var $lTjB2 = parcelRequire("lTjB2");

var $kpWmw = parcelRequire("kpWmw");

var $5ZCha = parcelRequire("5ZCha");

var $iCSiR = parcelRequire("iCSiR");

var $kc00y = parcelRequire("kc00y");

var $cn1Kz = parcelRequire("cn1Kz");

var $jRiwg = parcelRequire("jRiwg");

var $2llq8 = parcelRequire("2llq8");
var $f41795d8de53e64c$var$_excluded$4 = [
    "className",
    "clearValue",
    "cx",
    "getStyles",
    "getClassNames",
    "getValue",
    "hasValue",
    "isMulti",
    "isRtl",
    "options",
    "selectOption",
    "selectProps",
    "setValue",
    "theme"
];
// ==============================
// NO OP
// ==============================
var $f41795d8de53e64c$export$b4171a6734a65d42 = function noop() {};
// ==============================
// Class Name Prefixer
// ==============================
/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/ function $f41795d8de53e64c$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === "-") return prefix + name;
    else return prefix + "__" + name;
}
function $f41795d8de53e64c$export$a9c23c6ac3fc3eca(prefix, state) {
    for(var _len = arguments.length, classNameList = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)classNameList[_key - 2] = arguments[_key];
    var arr = [].concat(classNameList);
    if (state && prefix) {
        for(var key in state)if (state.hasOwnProperty(key) && state[key]) arr.push("".concat($f41795d8de53e64c$var$applyPrefixToName(prefix, key)));
    }
    return arr.filter(function(i) {
        return i;
    }).map(function(i) {
        return String(i).trim();
    }).join(" ");
}
// ==============================
// Clean Value
// ==============================
var $f41795d8de53e64c$export$7f8ddf7c7c20b3cd = function cleanValue(value) {
    if ($f41795d8de53e64c$var$isArray(value)) return value.filter(Boolean);
    if ((0, $kpWmw.default)(value) === "object" && value !== null) return [
        value
    ];
    return [];
};
// ==============================
// Clean Common Props
// ==============================
var $f41795d8de53e64c$var$cleanCommonProps = function cleanCommonProps(props) {
    //className
    props.className;
    props.clearValue;
    props.cx;
    props.getStyles;
    props.getClassNames;
    props.getValue;
    props.hasValue;
    props.isMulti;
    props.isRtl;
    props.options;
    props.selectOption;
    props.selectProps;
    props.setValue;
    props.theme;
    var innerProps = (0, $lTjB2.default)(props, $f41795d8de53e64c$var$_excluded$4);
    return (0, $9CGAW.default)({}, innerProps);
};
// ==============================
// Get Style Props
// ==============================
var $f41795d8de53e64c$var$getStyleProps = function getStyleProps(props, name, classNamesState) {
    var cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, className = props.className;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState !== null && classNamesState !== void 0 ? classNamesState : {}, getClassNames(name, props), className)
    };
};
// ==============================
// Handle Input Change
// ==============================
function $f41795d8de53e64c$export$61196ced6d74a310(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        var _newValue = onInputChange(inputValue, actionMeta);
        if (typeof _newValue === "string") return _newValue;
    }
    return inputValue;
}
// ==============================
// Scroll Helpers
// ==============================
function $f41795d8de53e64c$export$2329c99376c9d0a4(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
// Normalized Scroll Top
// ------------------------------
function $f41795d8de53e64c$var$normalizedHeight(el) {
    if ($f41795d8de53e64c$export$2329c99376c9d0a4(el)) return window.innerHeight;
    return el.clientHeight;
}
// Normalized scrollTo & scrollTop
// ------------------------------
function $f41795d8de53e64c$var$getScrollTop(el) {
    if ($f41795d8de53e64c$export$2329c99376c9d0a4(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $f41795d8de53e64c$var$scrollTo(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($f41795d8de53e64c$export$2329c99376c9d0a4(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
// Get Scroll Parent
// ------------------------------
function $f41795d8de53e64c$var$getScrollParent(element) {
    var style = getComputedStyle(element);
    var excludeStaticParent = style.position === "absolute";
    var overflowRx = /(auto|scroll)/;
    if (style.position === "fixed") return document.documentElement;
    for(var parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === "static") continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
// Animated Scroll To
// ------------------------------
/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/ function $f41795d8de53e64c$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $f41795d8de53e64c$var$animatedScrollTo(element, to) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
    var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $f41795d8de53e64c$export$b4171a6734a65d42;
    var start = $f41795d8de53e64c$var$getScrollTop(element);
    var change = to - start;
    var increment = 10;
    var currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        var val = $f41795d8de53e64c$var$easeOutCubic(currentTime, start, change, duration);
        $f41795d8de53e64c$var$scrollTo(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
// Scroll Into View
// ------------------------------
function $f41795d8de53e64c$export$9bb611d729802a56(menuEl, focusedEl) {
    var menuRect = menuEl.getBoundingClientRect();
    var focusedRect = focusedEl.getBoundingClientRect();
    var overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) $f41795d8de53e64c$var$scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) $f41795d8de53e64c$var$scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
// ==============================
// Get bounding client object
// ==============================
// cannot get keys using array notation with DOMRect
function $f41795d8de53e64c$var$getBoundingClientObj(element) {
    var rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
// ==============================
// Touch Capability Detector
// ==============================
function $f41795d8de53e64c$export$df995fae86a55f06() {
    try {
        document.createEvent("TouchEvent");
        return true;
    } catch (e) {
        return false;
    }
}
// ==============================
// Mobile Device Detector
// ==============================
function $f41795d8de53e64c$export$ebd11618f299a286() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
        return false;
    }
}
// ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
var $f41795d8de53e64c$var$passiveOptionAccessed = false;
var $f41795d8de53e64c$var$options = {
    get passive () {
        return $f41795d8de53e64c$var$passiveOptionAccessed = true;
    }
};
// check for SSR
var $f41795d8de53e64c$var$w = typeof window !== "undefined" ? window : {};
if ($f41795d8de53e64c$var$w.addEventListener && $f41795d8de53e64c$var$w.removeEventListener) {
    $f41795d8de53e64c$var$w.addEventListener("p", $f41795d8de53e64c$export$b4171a6734a65d42, $f41795d8de53e64c$var$options);
    $f41795d8de53e64c$var$w.removeEventListener("p", $f41795d8de53e64c$export$b4171a6734a65d42, false);
}
var $f41795d8de53e64c$export$2408f22a0fab9ae5 = $f41795d8de53e64c$var$passiveOptionAccessed;
function $f41795d8de53e64c$export$3466f893ebf79586(item) {
    return item != null;
}
function $f41795d8de53e64c$var$isArray(arg) {
    return Array.isArray(arg);
}
function $f41795d8de53e64c$export$96f57966bedc81b4(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}
function $f41795d8de53e64c$export$e7094788287c5e9b(singleValue) {
    return singleValue;
}
function $f41795d8de53e64c$export$ef35774e6d314e91(multiValue) {
    return multiValue;
}
var $f41795d8de53e64c$export$43caf9889c228507 = function removeProps(propsObj) {
    for(var _len2 = arguments.length, properties = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)properties[_key2 - 1] = arguments[_key2];
    var propsMap = Object.entries(propsObj).filter(function(_ref) {
        var _ref2 = (0, $jve2F.default)(_ref, 1), key = _ref2[0];
        return !properties.includes(key);
    });
    return propsMap.reduce(function(newProps, _ref3) {
        var _ref4 = (0, $jve2F.default)(_ref3, 2), key = _ref4[0], val = _ref4[1];
        newProps[key] = val;
        return newProps;
    }, {});
};
var $f41795d8de53e64c$var$_excluded$3 = [
    "children",
    "innerProps"
], $f41795d8de53e64c$var$_excluded2$1 = [
    "children",
    "innerProps"
];
function $f41795d8de53e64c$var$getMenuPlacement(_ref) {
    var preferredMaxHeight = _ref.maxHeight, menuEl = _ref.menuEl, minHeight = _ref.minHeight, preferredPlacement = _ref.placement, shouldScroll = _ref.shouldScroll, isFixedPosition = _ref.isFixedPosition, controlHeight = _ref.controlHeight;
    var scrollParent = $f41795d8de53e64c$var$getScrollParent(menuEl);
    var defaultState = {
        placement: "bottom",
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    var _scrollParent$getBoun = scrollParent.getBoundingClientRect(), scrollHeight = _scrollParent$getBoun.height;
    var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(), menuBottom = _menuEl$getBoundingCl.bottom, menuHeight = _menuEl$getBoundingCl.height, menuTop = _menuEl$getBoundingCl.top;
    var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(), containerTop = _menuEl$offsetParent$.top;
    var viewHeight = isFixedPosition ? window.innerHeight : $f41795d8de53e64c$var$normalizedHeight(scrollParent);
    var scrollTop = $f41795d8de53e64c$var$getScrollTop(scrollParent);
    var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    var viewSpaceAbove = containerTop - marginTop;
    var viewSpaceBelow = viewHeight - menuTop;
    var scrollSpaceAbove = viewSpaceAbove + scrollTop;
    var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
    var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    var scrollUp = scrollTop + menuTop - marginTop;
    var scrollDuration = 160;
    switch(preferredPlacement){
        case "auto":
        case "bottom":
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: "bottom",
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $f41795d8de53e64c$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: "bottom",
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) $f41795d8de53e64c$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: "bottom",
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === "auto" || isFixedPosition) {
                // may need to be constrained after flipping
                var _constrainedHeight = preferredMaxHeight;
                var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) _constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: "top",
                    maxHeight: _constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === "bottom") {
                if (shouldScroll) $f41795d8de53e64c$var$scrollTo(scrollParent, scrollDown);
                return {
                    placement: "bottom",
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case "top":
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: "top",
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $f41795d8de53e64c$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: "top",
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                var _constrainedHeight2 = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) $f41795d8de53e64c$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: "top",
                    maxHeight: _constrainedHeight2
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: "bottom",
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error('Invalid placement provided "'.concat(preferredPlacement, '".'));
    }
    return defaultState;
}
// Menu Component
// ------------------------------
function $f41795d8de53e64c$var$alignToControl(placement) {
    var placementToCSSProp = {
        bottom: "top",
        top: "bottom"
    };
    return placement ? placementToCSSProp[placement] : "bottom";
}
var $f41795d8de53e64c$var$coercePlacement = function coercePlacement(p) {
    return p === "auto" ? "bottom" : p;
};
var $f41795d8de53e64c$export$953cecd6e717a553 = function menuCSS(_ref2, unstyled) {
    var _objectSpread2;
    var placement = _ref2.placement, _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, spacing = _ref2$theme.spacing, colors = _ref2$theme.colors;
    return (0, $9CGAW.default)((_objectSpread2 = {
        label: "menu"
    }, (0, $iCSiR.default)(_objectSpread2, $f41795d8de53e64c$var$alignToControl(placement), "100%"), (0, $iCSiR.default)(_objectSpread2, "position", "absolute"), (0, $iCSiR.default)(_objectSpread2, "width", "100%"), (0, $iCSiR.default)(_objectSpread2, "zIndex", 1), _objectSpread2), unstyled ? {} : {
        backgroundColor: colors.neutral0,
        borderRadius: borderRadius,
        boxShadow: "0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)",
        marginBottom: spacing.menuGutter,
        marginTop: spacing.menuGutter
    });
};
var $f41795d8de53e64c$var$PortalPlacementContext = /*#__PURE__*/ (0, $kc00y.createContext)(null);
// NOTE: internal only
var $f41795d8de53e64c$export$3a1a48c8f6ef640e = function MenuPlacer(props) {
    var children = props.children, minMenuHeight = props.minMenuHeight, maxMenuHeight = props.maxMenuHeight, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, menuShouldScrollIntoView = props.menuShouldScrollIntoView, theme = props.theme;
    var _ref3 = (0, $kc00y.useContext)($f41795d8de53e64c$var$PortalPlacementContext) || {}, setPortalPlacement = _ref3.setPortalPlacement;
    var ref = (0, $kc00y.useRef)(null);
    var _useState = (0, $kc00y.useState)(maxMenuHeight), _useState2 = (0, $jve2F.default)(_useState, 2), maxHeight = _useState2[0], setMaxHeight = _useState2[1];
    var _useState3 = (0, $kc00y.useState)(null), _useState4 = (0, $jve2F.default)(_useState3, 2), placement = _useState4[0], setPlacement = _useState4[1];
    var controlHeight = theme.spacing.controlHeight;
    (0, $2llq8.default)(function() {
        var menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        var isFixedPosition = menuPosition === "fixed";
        var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        var state = $f41795d8de53e64c$var$getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement === null || setPortalPlacement === void 0 || setPortalPlacement(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: (0, $9CGAW.default)((0, $9CGAW.default)({}, props), {}, {
            placement: placement || $f41795d8de53e64c$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        })
    });
};
var $f41795d8de53e64c$var$Menu = function Menu(props) {
    var children = props.children, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $f9nE2.jsx)("div", (0, $cGuNc.default)({}, $f41795d8de53e64c$var$getStyleProps(props, "menu", {
        menu: true
    }), {
        ref: innerRef
    }, innerProps), children);
};
var $f41795d8de53e64c$var$Menu$1 = $f41795d8de53e64c$var$Menu;
// ==============================
// Menu List
// ==============================
var $f41795d8de53e64c$export$7ccc53e8f1e7dfc5 = function menuListCSS(_ref4, unstyled) {
    var maxHeight = _ref4.maxHeight, baseUnit = _ref4.theme.spacing.baseUnit;
    return (0, $9CGAW.default)({
        maxHeight: maxHeight,
        overflowY: "auto",
        position: "relative",
        // required for offset[Height, Top] > keyboard scroll
        WebkitOverflowScrolling: "touch"
    }, unstyled ? {} : {
        paddingBottom: baseUnit,
        paddingTop: baseUnit
    });
};
var $f41795d8de53e64c$var$MenuList = function MenuList(props) {
    var children = props.children, innerProps = props.innerProps, innerRef = props.innerRef, isMulti = props.isMulti;
    return (0, $f9nE2.jsx)("div", (0, $cGuNc.default)({}, $f41795d8de53e64c$var$getStyleProps(props, "menuList", {
        "menu-list": true,
        "menu-list--is-multi": isMulti
    }), {
        ref: innerRef
    }, innerProps), children);
};
// ==============================
// Menu Notices
// ==============================
var $f41795d8de53e64c$var$noticeCSS = function noticeCSS(_ref5, unstyled) {
    var _ref5$theme = _ref5.theme, baseUnit = _ref5$theme.spacing.baseUnit, colors = _ref5$theme.colors;
    return (0, $9CGAW.default)({
        textAlign: "center"
    }, unstyled ? {} : {
        color: colors.neutral40,
        padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px")
    });
};
var $f41795d8de53e64c$export$3b14a55fb2447963 = $f41795d8de53e64c$var$noticeCSS;
var $f41795d8de53e64c$export$342063e11d6c3cad = $f41795d8de53e64c$var$noticeCSS;
var $f41795d8de53e64c$var$NoOptionsMessage = function NoOptionsMessage(_ref6) {
    var _ref6$children = _ref6.children, children = _ref6$children === void 0 ? "No options" : _ref6$children, innerProps = _ref6.innerProps, restProps = (0, $lTjB2.default)(_ref6, $f41795d8de53e64c$var$_excluded$3);
    return (0, $f9nE2.jsx)("div", (0, $cGuNc.default)({}, $f41795d8de53e64c$var$getStyleProps((0, $9CGAW.default)((0, $9CGAW.default)({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), "noOptionsMessage", {
        "menu-notice": true,
        "menu-notice--no-options": true
    }), innerProps), children);
};
var $f41795d8de53e64c$var$LoadingMessage = function LoadingMessage(_ref7) {
    var _ref7$children = _ref7.children, children = _ref7$children === void 0 ? "Loading..." : _ref7$children, innerProps = _ref7.innerProps, restProps = (0, $lTjB2.default)(_ref7, $f41795d8de53e64c$var$_excluded2$1);
    return (0, $f9nE2.jsx)("div", (0, $cGuNc.default)({}, $f41795d8de53e64c$var$getStyleProps((0, $9CGAW.default)((0, $9CGAW.default)({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), "loadingMessage", {
        "menu-notice": true,
        "menu-notice--loading": true
    }), innerProps), children);
};
// ==============================
// Menu Portal
// ==============================
var $f41795d8de53e64c$export$ae1af26003f05816 = function menuPortalCSS(_ref8) {
    var rect = _ref8.rect, offset = _ref8.offset, position = _ref8.position;
    return {
        left: rect.left,
        position: position,
        top: offset,
        width: rect.width,
        zIndex: 1
    };
};
var $f41795d8de53e64c$var$MenuPortal = function MenuPortal(props) {
    var appendTo = props.appendTo, children = props.children, controlElement = props.controlElement, innerProps = props.innerProps, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition;
    var menuPortalRef = (0, $kc00y.useRef)(null);
    var cleanupRef = (0, $kc00y.useRef)(null);
    var _useState5 = (0, $kc00y.useState)($f41795d8de53e64c$var$coercePlacement(menuPlacement)), _useState6 = (0, $jve2F.default)(_useState5, 2), placement = _useState6[0], setPortalPlacement = _useState6[1];
    var portalPlacementContext = (0, $kc00y.useMemo)(function() {
        return {
            setPortalPlacement: setPortalPlacement
        };
    }, []);
    var _useState7 = (0, $kc00y.useState)(null), _useState8 = (0, $jve2F.default)(_useState7, 2), computedPosition = _useState8[0], setComputedPosition = _useState8[1];
    var updateComputedPosition = (0, $kc00y.useCallback)(function() {
        if (!controlElement) return;
        var rect = $f41795d8de53e64c$var$getBoundingClientObj(controlElement);
        var scrollDistance = menuPosition === "fixed" ? 0 : window.pageYOffset;
        var offset = rect[placement] + scrollDistance;
        if (offset !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset) || rect.left !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left) || rect.width !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width)) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width
    ]);
    (0, $2llq8.default)(function() {
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    var runAutoUpdate = (0, $kc00y.useCallback)(function() {
        if (typeof cleanupRef.current === "function") {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $jRiwg.autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: "ResizeObserver" in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $2llq8.default)(function() {
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    var setMenuPortalElement = (0, $kc00y.useCallback)(function(menuPortalElement) {
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // bail early if required elements aren't present
    if (!appendTo && menuPosition !== "fixed" || !computedPosition) return null;
    // same wrapper element whether fixed or portalled
    var menuWrapper = (0, $f9nE2.jsx)("div", (0, $cGuNc.default)({
        ref: setMenuPortalElement
    }, $f41795d8de53e64c$var$getStyleProps((0, $9CGAW.default)((0, $9CGAW.default)({}, props), {}, {
        offset: computedPosition.offset,
        position: menuPosition,
        rect: computedPosition.rect
    }), "menuPortal", {
        "menu-portal": true
    }), innerProps), children);
    return (0, $f9nE2.jsx)($f41795d8de53e64c$var$PortalPlacementContext.Provider, {
        value: portalPlacementContext
    }, appendTo ? /*#__PURE__*/ (0, $cn1Kz.createPortal)(menuWrapper, appendTo) : menuWrapper);
};
// ==============================
// Root Container
// ==============================
var $f41795d8de53e64c$export$8b22cf2602fb60ce = function containerCSS(_ref) {
    var isDisabled = _ref.isDisabled, isRtl = _ref.isRtl;
    return {
        label: "container",
        direction: isRtl ? "rtl" : undefined,
        pointerEvents: isDisabled ? "none" : undefined,
        // cancel mouse events when disabled
        position: "relative"
    };
};
var $f41795d8de53e64c$var$SelectContainer = function SelectContainer(props) {
    var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, isRtl = props.isRtl;
    return (0, $f9nE2.jsx)("div", (0, $cGuNc.default)({}, $f41795d8de53e64c$var$getStyleProps(props, "container", {
        "--is-disabled": isDisabled,
        "--is-rtl": isRtl
    }), innerProps), children);
};
// ==============================
// Value Container
// ==============================
var $f41795d8de53e64c$export$4a5767248b18ef41 = function valueContainerCSS(_ref2, unstyled) {
    var spacing = _ref2.theme.spacing, isMulti = _ref2.isMulti, hasValue = _ref2.hasValue, controlShouldRenderValue = _ref2.selectProps.controlShouldRenderValue;
    return (0, $9CGAW.default)({
        alignItems: "center",
        display: isMulti && hasValue && controlShouldRenderValue ? "flex" : "grid",
        flex: 1,
        flexWrap: "wrap",
        WebkitOverflowScrolling: "touch",
        position: "relative",
        overflow: "hidden"
    }, unstyled ? {} : {
        padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px")
    });
};
var $f41795d8de53e64c$var$ValueContainer = function ValueContainer(props) {
    var children = props.children, innerProps = props.innerProps, isMulti = props.isMulti, hasValue = props.hasValue;
    return (0, $f9nE2.jsx)("div", (0, $cGuNc.default)({}, $f41795d8de53e64c$var$getStyleProps(props, "valueContainer", {
        "value-container": true,
        "value-container--is-multi": isMulti,
        "value-container--has-value": hasValue
    }), innerProps), children);
};
// ==============================
// Indicator Container
// ==============================
var $f41795d8de53e64c$export$23f2a1d2818174ef = function indicatorsContainerCSS() {
    return {
        alignItems: "center",
        alignSelf: "stretch",
        display: "flex",
        flexShrink: 0
    };
};
var $f41795d8de53e64c$var$IndicatorsContainer = function IndicatorsContainer(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $f9nE2.jsx)("div", (0, $cGuNc.default)({}, $f41795d8de53e64c$var$getStyleProps(props, "indicatorsContainer", {
        indicators: true
    }), innerProps), children);
};
var $f41795d8de53e64c$var$_templateObject;
var $f41795d8de53e64c$var$_excluded$2 = [
    "size"
], $f41795d8de53e64c$var$_excluded2 = [
    "innerProps",
    "isRtl",
    "size"
];
function $f41795d8de53e64c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// ==============================
// Dropdown & Clear Icons
// ==============================
var $f41795d8de53e64c$var$_ref2 = {
    name: "8mmkcg",
    styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
};
var $f41795d8de53e64c$var$Svg = function Svg(_ref) {
    var size = _ref.size, props = (0, $lTjB2.default)(_ref, $f41795d8de53e64c$var$_excluded$2);
    return (0, $f9nE2.jsx)("svg", (0, $cGuNc.default)({
        height: size,
        width: size,
        viewBox: "0 0 20 20",
        "aria-hidden": "true",
        focusable: "false",
        css: $f41795d8de53e64c$var$_ref2
    }, props));
};
var $f41795d8de53e64c$var$CrossIcon = function CrossIcon(props) {
    return (0, $f9nE2.jsx)($f41795d8de53e64c$var$Svg, (0, $cGuNc.default)({
        size: 20
    }, props), (0, $f9nE2.jsx)("path", {
        d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
    }));
};
var $f41795d8de53e64c$var$DownChevron = function DownChevron(props) {
    return (0, $f9nE2.jsx)($f41795d8de53e64c$var$Svg, (0, $cGuNc.default)({
        size: 20
    }, props), (0, $f9nE2.jsx)("path", {
        d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
    }));
};
// ==============================
// Dropdown & Clear Buttons
// ==============================
var $f41795d8de53e64c$var$baseCSS = function baseCSS(_ref3, unstyled) {
    var isFocused = _ref3.isFocused, _ref3$theme = _ref3.theme, baseUnit = _ref3$theme.spacing.baseUnit, colors = _ref3$theme.colors;
    return (0, $9CGAW.default)({
        label: "indicatorContainer",
        display: "flex",
        transition: "color 150ms"
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2,
        ":hover": {
            color: isFocused ? colors.neutral80 : colors.neutral40
        }
    });
};
var $f41795d8de53e64c$export$f1e1789686576879 = $f41795d8de53e64c$var$baseCSS;
var $f41795d8de53e64c$var$DropdownIndicator = function DropdownIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $f9nE2.jsx)("div", (0, $cGuNc.default)({}, $f41795d8de53e64c$var$getStyleProps(props, "dropdownIndicator", {
        indicator: true,
        "dropdown-indicator": true
    }), innerProps), children || (0, $f9nE2.jsx)($f41795d8de53e64c$var$DownChevron, null));
};
var $f41795d8de53e64c$export$407448d2b89b1813 = $f41795d8de53e64c$var$baseCSS;
var $f41795d8de53e64c$var$ClearIndicator = function ClearIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $f9nE2.jsx)("div", (0, $cGuNc.default)({}, $f41795d8de53e64c$var$getStyleProps(props, "clearIndicator", {
        indicator: true,
        "clear-indicator": true
    }), innerProps), children || (0, $f9nE2.jsx)($f41795d8de53e64c$var$CrossIcon, null));
};
// ==============================
// Separator
// ==============================
var $f41795d8de53e64c$export$dda1d9f60106f0e9 = function indicatorSeparatorCSS(_ref4, unstyled) {
    var isDisabled = _ref4.isDisabled, _ref4$theme = _ref4.theme, baseUnit = _ref4$theme.spacing.baseUnit, colors = _ref4$theme.colors;
    return (0, $9CGAW.default)({
        label: "indicatorSeparator",
        alignSelf: "stretch",
        width: 1
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
        marginBottom: baseUnit * 2,
        marginTop: baseUnit * 2
    });
};
var $f41795d8de53e64c$var$IndicatorSeparator = function IndicatorSeparator(props) {
    var innerProps = props.innerProps;
    return (0, $f9nE2.jsx)("span", (0, $cGuNc.default)({}, innerProps, $f41795d8de53e64c$var$getStyleProps(props, "indicatorSeparator", {
        "indicator-separator": true
    })));
};
// ==============================
// Loading
// ==============================
var $f41795d8de53e64c$var$loadingDotAnimations = (0, $f9nE2.keyframes)($f41795d8de53e64c$var$_templateObject || ($f41795d8de53e64c$var$_templateObject = (0, $5ZCha.default)([
    "\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"
])));
var $f41795d8de53e64c$export$882b5998b3b9117c = function loadingIndicatorCSS(_ref5, unstyled) {
    var isFocused = _ref5.isFocused, size = _ref5.size, _ref5$theme = _ref5.theme, colors = _ref5$theme.colors, baseUnit = _ref5$theme.spacing.baseUnit;
    return (0, $9CGAW.default)({
        label: "loadingIndicator",
        display: "flex",
        transition: "color 150ms",
        alignSelf: "center",
        fontSize: size,
        lineHeight: 1,
        marginRight: size,
        textAlign: "center",
        verticalAlign: "middle"
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2
    });
};
var $f41795d8de53e64c$var$LoadingDot = function LoadingDot(_ref6) {
    var delay = _ref6.delay, offset = _ref6.offset;
    return (0, $f9nE2.jsx)("span", {
        css: /*#__PURE__*/ (0, $f9nE2.css)({
            animation: "".concat($f41795d8de53e64c$var$loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
            backgroundColor: "currentColor",
            borderRadius: "1em",
            display: "inline-block",
            marginLeft: offset ? "1em" : undefined,
            height: "1em",
            verticalAlign: "top",
            width: "1em"
        }, "", "")
    });
};
var $f41795d8de53e64c$var$LoadingIndicator = function LoadingIndicator(_ref7) {
    var innerProps = _ref7.innerProps, isRtl = _ref7.isRtl, _ref7$size = _ref7.size, size = _ref7$size === void 0 ? 4 : _ref7$size, restProps = (0, $lTjB2.default)(_ref7, $f41795d8de53e64c$var$_excluded2);
    return (0, $f9nE2.jsx)("div", (0, $cGuNc.default)({}, $f41795d8de53e64c$var$getStyleProps((0, $9CGAW.default)((0, $9CGAW.default)({}, restProps), {}, {
        innerProps: innerProps,
        isRtl: isRtl,
        size: size
    }), "loadingIndicator", {
        indicator: true,
        "loading-indicator": true
    }), innerProps), (0, $f9nE2.jsx)($f41795d8de53e64c$var$LoadingDot, {
        delay: 0,
        offset: isRtl
    }), (0, $f9nE2.jsx)($f41795d8de53e64c$var$LoadingDot, {
        delay: 160,
        offset: true
    }), (0, $f9nE2.jsx)($f41795d8de53e64c$var$LoadingDot, {
        delay: 320,
        offset: !isRtl
    }));
};
var $f41795d8de53e64c$export$4368d992c4eafac0 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, _ref$theme = _ref.theme, colors = _ref$theme.colors, borderRadius = _ref$theme.borderRadius, spacing = _ref$theme.spacing;
    return (0, $9CGAW.default)({
        label: "control",
        alignItems: "center",
        cursor: "default",
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-between",
        minHeight: spacing.controlHeight,
        outline: "0 !important",
        position: "relative",
        transition: "all 100ms"
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
        borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
        borderRadius: borderRadius,
        borderStyle: "solid",
        borderWidth: 1,
        boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : undefined,
        "&:hover": {
            borderColor: isFocused ? colors.primary : colors.neutral30
        }
    });
};
var $f41795d8de53e64c$var$Control = function Control(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, innerRef = props.innerRef, innerProps = props.innerProps, menuIsOpen = props.menuIsOpen;
    return (0, $f9nE2.jsx)("div", (0, $cGuNc.default)({
        ref: innerRef
    }, $f41795d8de53e64c$var$getStyleProps(props, "control", {
        control: true,
        "control--is-disabled": isDisabled,
        "control--is-focused": isFocused,
        "control--menu-is-open": menuIsOpen
    }), innerProps, {
        "aria-disabled": isDisabled || undefined
    }), children);
};
var $f41795d8de53e64c$var$Control$1 = $f41795d8de53e64c$var$Control;
var $f41795d8de53e64c$var$_excluded$1 = [
    "data"
];
var $f41795d8de53e64c$export$39b482c5e57630a8 = function groupCSS(_ref, unstyled) {
    var spacing = _ref.theme.spacing;
    return unstyled ? {} : {
        paddingBottom: spacing.baseUnit * 2,
        paddingTop: spacing.baseUnit * 2
    };
};
var $f41795d8de53e64c$var$Group = function Group(props) {
    var children = props.children, cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, Heading = props.Heading, headingProps = props.headingProps, innerProps = props.innerProps, label = props.label, theme = props.theme, selectProps = props.selectProps;
    return (0, $f9nE2.jsx)("div", (0, $cGuNc.default)({}, $f41795d8de53e64c$var$getStyleProps(props, "group", {
        group: true
    }), innerProps), (0, $f9nE2.jsx)(Heading, (0, $cGuNc.default)({}, headingProps, {
        selectProps: selectProps,
        theme: theme,
        getStyles: getStyles,
        getClassNames: getClassNames,
        cx: cx
    }), label), (0, $f9nE2.jsx)("div", null, children));
};
var $f41795d8de53e64c$export$2d1720544b23b823 = function groupHeadingCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, colors = _ref2$theme.colors, spacing = _ref2$theme.spacing;
    return (0, $9CGAW.default)({
        label: "group",
        cursor: "default",
        display: "block"
    }, unstyled ? {} : {
        color: colors.neutral40,
        fontSize: "75%",
        fontWeight: 500,
        marginBottom: "0.25em",
        paddingLeft: spacing.baseUnit * 3,
        paddingRight: spacing.baseUnit * 3,
        textTransform: "uppercase"
    });
};
var $f41795d8de53e64c$var$GroupHeading = function GroupHeading(props) {
    var _cleanCommonProps = $f41795d8de53e64c$var$cleanCommonProps(props);
    _cleanCommonProps.data;
    var innerProps = (0, $lTjB2.default)(_cleanCommonProps, $f41795d8de53e64c$var$_excluded$1);
    return (0, $f9nE2.jsx)("div", (0, $cGuNc.default)({}, $f41795d8de53e64c$var$getStyleProps(props, "groupHeading", {
        "group-heading": true
    }), innerProps));
};
var $f41795d8de53e64c$var$Group$1 = $f41795d8de53e64c$var$Group;
var $f41795d8de53e64c$var$_excluded = [
    "innerRef",
    "isDisabled",
    "isHidden",
    "inputClassName"
];
var $f41795d8de53e64c$export$35e795649ee09318 = function inputCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, value = _ref.value, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $9CGAW.default)((0, $9CGAW.default)({
        visibility: isDisabled ? "hidden" : "visible",
        // force css to recompute when value change due to @emotion bug.
        // We can remove it whenever the bug is fixed.
        transform: value ? "translateZ(0)" : ""
    }, $f41795d8de53e64c$var$containerStyle), unstyled ? {} : {
        margin: spacing.baseUnit / 2,
        paddingBottom: spacing.baseUnit / 2,
        paddingTop: spacing.baseUnit / 2,
        color: colors.neutral80
    });
};
var $f41795d8de53e64c$var$spacingStyle = {
    gridArea: "1 / 2",
    font: "inherit",
    minWidth: "2px",
    border: 0,
    margin: 0,
    outline: 0,
    padding: 0
};
var $f41795d8de53e64c$var$containerStyle = {
    flex: "1 1 auto",
    display: "inline-grid",
    gridArea: "1 / 1 / 2 / 3",
    gridTemplateColumns: "0 min-content",
    "&:after": (0, $9CGAW.default)({
        content: 'attr(data-value) " "',
        visibility: "hidden",
        whiteSpace: "pre"
    }, $f41795d8de53e64c$var$spacingStyle)
};
var $f41795d8de53e64c$var$inputStyle = function inputStyle(isHidden) {
    return (0, $9CGAW.default)({
        label: "input",
        color: "inherit",
        background: 0,
        opacity: isHidden ? 0 : 1,
        width: "100%"
    }, $f41795d8de53e64c$var$spacingStyle);
};
var $f41795d8de53e64c$var$Input = function Input(props) {
    var cx = props.cx, value = props.value;
    var _cleanCommonProps = $f41795d8de53e64c$var$cleanCommonProps(props), innerRef = _cleanCommonProps.innerRef, isDisabled = _cleanCommonProps.isDisabled, isHidden = _cleanCommonProps.isHidden, inputClassName = _cleanCommonProps.inputClassName, innerProps = (0, $lTjB2.default)(_cleanCommonProps, $f41795d8de53e64c$var$_excluded);
    return (0, $f9nE2.jsx)("div", (0, $cGuNc.default)({}, $f41795d8de53e64c$var$getStyleProps(props, "input", {
        "input-container": true
    }), {
        "data-value": value || ""
    }), (0, $f9nE2.jsx)("input", (0, $cGuNc.default)({
        className: cx({
            input: true
        }, inputClassName),
        ref: innerRef,
        style: $f41795d8de53e64c$var$inputStyle(isHidden),
        disabled: isDisabled
    }, innerProps)));
};
var $f41795d8de53e64c$var$Input$1 = $f41795d8de53e64c$var$Input;
var $f41795d8de53e64c$export$ffb5f4729a158638 = function multiValueCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, borderRadius = _ref$theme.borderRadius, colors = _ref$theme.colors;
    return (0, $9CGAW.default)({
        label: "multiValue",
        display: "flex",
        minWidth: 0
    }, unstyled ? {} : {
        backgroundColor: colors.neutral10,
        borderRadius: borderRadius / 2,
        margin: spacing.baseUnit / 2
    });
};
var $f41795d8de53e64c$export$9e5f44173e64f162 = function multiValueLabelCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, colors = _ref2$theme.colors, cropWithEllipsis = _ref2.cropWithEllipsis;
    return (0, $9CGAW.default)({
        overflow: "hidden",
        textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? "ellipsis" : undefined,
        whiteSpace: "nowrap"
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        color: colors.neutral80,
        fontSize: "85%",
        padding: 3,
        paddingLeft: 6
    });
};
var $f41795d8de53e64c$export$625550452a3fa3ec = function multiValueRemoveCSS(_ref3, unstyled) {
    var _ref3$theme = _ref3.theme, spacing = _ref3$theme.spacing, borderRadius = _ref3$theme.borderRadius, colors = _ref3$theme.colors, isFocused = _ref3.isFocused;
    return (0, $9CGAW.default)({
        alignItems: "center",
        display: "flex"
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        backgroundColor: isFocused ? colors.dangerLight : undefined,
        paddingLeft: spacing.baseUnit,
        paddingRight: spacing.baseUnit,
        ":hover": {
            backgroundColor: colors.dangerLight,
            color: colors.danger
        }
    });
};
var $f41795d8de53e64c$var$MultiValueGeneric = function MultiValueGeneric(_ref4) {
    var children = _ref4.children, innerProps = _ref4.innerProps;
    return (0, $f9nE2.jsx)("div", innerProps, children);
};
var $f41795d8de53e64c$var$MultiValueContainer = $f41795d8de53e64c$var$MultiValueGeneric;
var $f41795d8de53e64c$var$MultiValueLabel = $f41795d8de53e64c$var$MultiValueGeneric;
function $f41795d8de53e64c$var$MultiValueRemove(_ref5) {
    var children = _ref5.children, innerProps = _ref5.innerProps;
    return (0, $f9nE2.jsx)("div", (0, $cGuNc.default)({
        role: "button"
    }, innerProps), children || (0, $f9nE2.jsx)($f41795d8de53e64c$var$CrossIcon, {
        size: 14
    }));
}
var $f41795d8de53e64c$var$MultiValue = function MultiValue(props) {
    var children = props.children, components = props.components, data = props.data, innerProps = props.innerProps, isDisabled = props.isDisabled, removeProps = props.removeProps, selectProps = props.selectProps;
    var Container = components.Container, Label = components.Label, Remove = components.Remove;
    return (0, $f9nE2.jsx)(Container, {
        data: data,
        innerProps: (0, $9CGAW.default)((0, $9CGAW.default)({}, $f41795d8de53e64c$var$getStyleProps(props, "multiValue", {
            "multi-value": true,
            "multi-value--is-disabled": isDisabled
        })), innerProps),
        selectProps: selectProps
    }, (0, $f9nE2.jsx)(Label, {
        data: data,
        innerProps: (0, $9CGAW.default)({}, $f41795d8de53e64c$var$getStyleProps(props, "multiValueLabel", {
            "multi-value__label": true
        })),
        selectProps: selectProps
    }, children), (0, $f9nE2.jsx)(Remove, {
        data: data,
        innerProps: (0, $9CGAW.default)((0, $9CGAW.default)({}, $f41795d8de53e64c$var$getStyleProps(props, "multiValueRemove", {
            "multi-value__remove": true
        })), {}, {
            "aria-label": "Remove ".concat(children || "option")
        }, removeProps),
        selectProps: selectProps
    }));
};
var $f41795d8de53e64c$var$MultiValue$1 = $f41795d8de53e64c$var$MultiValue;
var $f41795d8de53e64c$export$90a7f3efeed30595 = function optionCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, isSelected = _ref.isSelected, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $9CGAW.default)({
        label: "option",
        cursor: "default",
        display: "block",
        fontSize: "inherit",
        width: "100%",
        userSelect: "none",
        WebkitTapHighlightColor: "rgba(0, 0, 0, 0)"
    }, unstyled ? {} : {
        backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : "transparent",
        color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : "inherit",
        padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
        // provide some affordance on touch devices
        ":active": {
            backgroundColor: !isDisabled ? isSelected ? colors.primary : colors.primary50 : undefined
        }
    });
};
var $f41795d8de53e64c$var$Option = function Option(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, isSelected = props.isSelected, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $f9nE2.jsx)("div", (0, $cGuNc.default)({}, $f41795d8de53e64c$var$getStyleProps(props, "option", {
        option: true,
        "option--is-disabled": isDisabled,
        "option--is-focused": isFocused,
        "option--is-selected": isSelected
    }), {
        ref: innerRef,
        "aria-disabled": isDisabled
    }, innerProps), children);
};
var $f41795d8de53e64c$var$Option$1 = $f41795d8de53e64c$var$Option;
var $f41795d8de53e64c$export$efccba1c4a2ef57b = function placeholderCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $9CGAW.default)({
        label: "placeholder",
        gridArea: "1 / 1 / 2 / 3"
    }, unstyled ? {} : {
        color: colors.neutral50,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $f41795d8de53e64c$var$Placeholder = function Placeholder(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $f9nE2.jsx)("div", (0, $cGuNc.default)({}, $f41795d8de53e64c$var$getStyleProps(props, "placeholder", {
        placeholder: true
    }), innerProps), children);
};
var $f41795d8de53e64c$var$Placeholder$1 = $f41795d8de53e64c$var$Placeholder;
var $f41795d8de53e64c$export$d141bba7fdc215a3 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $9CGAW.default)({
        label: "singleValue",
        gridArea: "1 / 1 / 2 / 3",
        maxWidth: "100%",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    }, unstyled ? {} : {
        color: isDisabled ? colors.neutral40 : colors.neutral80,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $f41795d8de53e64c$var$SingleValue = function SingleValue(props) {
    var children = props.children, isDisabled = props.isDisabled, innerProps = props.innerProps;
    return (0, $f9nE2.jsx)("div", (0, $cGuNc.default)({}, $f41795d8de53e64c$var$getStyleProps(props, "singleValue", {
        "single-value": true,
        "single-value--is-disabled": isDisabled
    }), innerProps), children);
};
var $f41795d8de53e64c$var$SingleValue$1 = $f41795d8de53e64c$var$SingleValue;
var $f41795d8de53e64c$export$db3b6bfb95261072 = {
    ClearIndicator: $f41795d8de53e64c$var$ClearIndicator,
    Control: $f41795d8de53e64c$var$Control$1,
    DropdownIndicator: $f41795d8de53e64c$var$DropdownIndicator,
    DownChevron: $f41795d8de53e64c$var$DownChevron,
    CrossIcon: $f41795d8de53e64c$var$CrossIcon,
    Group: $f41795d8de53e64c$var$Group$1,
    GroupHeading: $f41795d8de53e64c$var$GroupHeading,
    IndicatorsContainer: $f41795d8de53e64c$var$IndicatorsContainer,
    IndicatorSeparator: $f41795d8de53e64c$var$IndicatorSeparator,
    Input: $f41795d8de53e64c$var$Input$1,
    LoadingIndicator: $f41795d8de53e64c$var$LoadingIndicator,
    Menu: $f41795d8de53e64c$var$Menu$1,
    MenuList: $f41795d8de53e64c$var$MenuList,
    MenuPortal: $f41795d8de53e64c$var$MenuPortal,
    LoadingMessage: $f41795d8de53e64c$var$LoadingMessage,
    NoOptionsMessage: $f41795d8de53e64c$var$NoOptionsMessage,
    MultiValue: $f41795d8de53e64c$var$MultiValue$1,
    MultiValueContainer: $f41795d8de53e64c$var$MultiValueContainer,
    MultiValueLabel: $f41795d8de53e64c$var$MultiValueLabel,
    MultiValueRemove: $f41795d8de53e64c$var$MultiValueRemove,
    Option: $f41795d8de53e64c$var$Option$1,
    Placeholder: $f41795d8de53e64c$var$Placeholder$1,
    SelectContainer: $f41795d8de53e64c$var$SelectContainer,
    SingleValue: $f41795d8de53e64c$var$SingleValue$1,
    ValueContainer: $f41795d8de53e64c$var$ValueContainer
};
var $f41795d8de53e64c$export$d66501df72047452 = function defaultComponents(props) {
    return (0, $9CGAW.default)((0, $9CGAW.default)({}, $f41795d8de53e64c$export$db3b6bfb95261072), props.components);
};

});
parcelRegister("9CGAW", function(module, exports) {

$parcel$export(module.exports, "default", () => $7018b41fa193028d$export$2e2bcd8739ae039);

var $iCSiR = parcelRequire("iCSiR");
function $7018b41fa193028d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7018b41fa193028d$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7018b41fa193028d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $iCSiR.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7018b41fa193028d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

});
parcelRegister("iCSiR", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8f5e6158ecd1aab$export$2e2bcd8739ae039);

var $elOZ3 = parcelRequire("elOZ3");
function $d8f5e6158ecd1aab$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $elOZ3.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("elOZ3", function(module, exports) {

$parcel$export(module.exports, "default", () => $a72a9325d605837f$export$2e2bcd8739ae039);

var $kpWmw = parcelRequire("kpWmw");

var $bV1aK = parcelRequire("bV1aK");
function $a72a9325d605837f$export$2e2bcd8739ae039(t) {
    var i = (0, $bV1aK.default)(t, "string");
    return "symbol" == (0, $kpWmw.default)(i) ? i : i + "";
}

});
parcelRegister("kpWmw", function(module, exports) {

$parcel$export(module.exports, "default", () => $edd369f856d5b0b3$export$2e2bcd8739ae039);
function $edd369f856d5b0b3$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $edd369f856d5b0b3$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $edd369f856d5b0b3$export$2e2bcd8739ae039(o);
}

});

parcelRegister("bV1aK", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ad5ed6008435ac7$export$2e2bcd8739ae039);

var $kpWmw = parcelRequire("kpWmw");
function $8ad5ed6008435ac7$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $kpWmw.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $kpWmw.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});




parcelRegister("cGuNc", function(module, exports) {

$parcel$export(module.exports, "default", () => $93c14b0a090563ae$export$2e2bcd8739ae039);
function $93c14b0a090563ae$export$2e2bcd8739ae039() {
    return $93c14b0a090563ae$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $93c14b0a090563ae$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("f9nE2", function(module, exports) {

$parcel$export(module.exports, "css", () => $b07a099d01addcf1$export$dbf350e5966cf602);
$parcel$export(module.exports, "keyframes", () => $b07a099d01addcf1$export$d25ddfdf17c3ad3e);
$parcel$export(module.exports, "jsx", () => $b07a099d01addcf1$export$c8a8987d4410bf2d);

var $f4L7N = parcelRequire("f4L7N");

var $kc00y = parcelRequire("kc00y");

var $9GoLs = parcelRequire("9GoLs");

var $8SblK = parcelRequire("8SblK");

var $a6zDP = parcelRequire("a6zDP");
parcelRequire("d0OJ1");
parcelRequire("er9eX");
parcelRequire("ktTCU");

parcelRequire("j8Bf6");
var $b07a099d01addcf1$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $f4L7N.h).call(props, "css")) return $kc00y.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $f4L7N.E);
    createElementArgArray[1] = (0, $f4L7N.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
    return $kc00y.createElement.apply(null, createElementArgArray);
};
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $b07a099d01addcf1$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $f4L7N.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $a6zDP.serializeStyles)([
        styles
    ], undefined, $kc00y.useContext((0, $f4L7N.T)));
    if (!(0, $f4L7N.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += " " + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $kc00y.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $kc00y.useRef();
    (0, $8SblK.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false;
        var node = document.querySelector('style[data-emotion="' + key + " " + serialized.name + '"]');
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute("data-emotion", key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $8SblK.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $9GoLs.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
/* import type { Interpolation, SerializedStyles } from '@emotion/utils' */ function $b07a099d01addcf1$export$dbf350e5966cf602() /*: SerializedStyles */ {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $a6zDP.serializeStyles)(args);
}
/*
type Keyframes = {|
  name: string,
  styles: string,
  anim: 1,
  toString: () => string
|} & string
*/ var $b07a099d01addcf1$export$d25ddfdf17c3ad3e = function /*: Keyframes */ keyframes() {
    var insertable = $b07a099d01addcf1$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name;
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
/*
type ClassNameArg =
  | string
  | boolean
  | { [key: string]: boolean }
  | Array<ClassNameArg>
  | null
  | void
*/ var $b07a099d01addcf1$var$classnames = function /*: string */ classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = "";
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case "boolean":
                break;
            case "object":
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = "";
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += " ");
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += " ");
            cls += toAdd;
        }
    }
    return cls;
};
function $b07a099d01addcf1$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $9GoLs.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $b07a099d01addcf1$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    var rules = (0, $8SblK.useInsertionEffectAlwaysWithSyncFallback)(function() {
        var rules = "";
        for(var i = 0; i < serializedArr.length; i++){
            var res = (0, $9GoLs.insertStyles)(cache, serializedArr[i], false);
            if (!(0, $f4L7N.i) && res !== undefined) rules += res;
        }
        if (!(0, $f4L7N.i)) return rules;
    });
    if (!(0, $f4L7N.i) && rules.length !== 0) {
        var _ref2;
        return /*#__PURE__*/ $kc00y.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedArr.map(function(serialized) {
            return serialized.name;
        }).join(" "), _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
/*
type Props = {
  children: ({
    css: (...args: any) => string,
    cx: (...args: Array<ClassNameArg>) => string,
    theme: Object
  }) => React.Node
} */ var $b07a099d01addcf1$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $f4L7N.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        if (hasRendered && (0, $f4L7N.a)) throw new Error("css can only be used during render");
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $a6zDP.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $9GoLs.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        if (hasRendered && (0, $f4L7N.a)) throw new Error("cx can only be used during render");
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $b07a099d01addcf1$var$merge(cache.registered, css, $b07a099d01addcf1$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $kc00y.useContext((0, $f4L7N.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $kc00y.createElement($kc00y.Fragment, null, /*#__PURE__*/ $kc00y.createElement($b07a099d01addcf1$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});

});
parcelRegister("f4L7N", function(module, exports) {

$parcel$export(module.exports, "a", () => $af9bc8bdbad450a3$export$407448d2b89b1813);
$parcel$export(module.exports, "i", () => $af9bc8bdbad450a3$export$23f2a1d2818174ef);
$parcel$export(module.exports, "C", () => $af9bc8bdbad450a3$export$e7094788287c5e9b);
$parcel$export(module.exports, "w", () => $af9bc8bdbad450a3$export$efccba1c4a2ef57b);
$parcel$export(module.exports, "T", () => $af9bc8bdbad450a3$export$971d5caa766a69d7);
$parcel$export(module.exports, "h", () => $af9bc8bdbad450a3$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "c", () => $af9bc8bdbad450a3$export$db3b6bfb95261072);
$parcel$export(module.exports, "E", () => $af9bc8bdbad450a3$export$a9c23c6ac3fc3eca);

var $kc00y = parcelRequire("kc00y");

var $d0OJ1 = parcelRequire("d0OJ1");

var $cGuNc = parcelRequire("cGuNc");

var $ktTCU = parcelRequire("ktTCU");

var $3rWGO = parcelRequire("3rWGO");

var $9GoLs = parcelRequire("9GoLs");

var $a6zDP = parcelRequire("a6zDP");

var $8SblK = parcelRequire("8SblK");
var $af9bc8bdbad450a3$export$407448d2b89b1813 = false;
var $af9bc8bdbad450a3$export$23f2a1d2818174ef = typeof document !== "undefined";
/* import { type EmotionCache } from '@emotion/utils' */ var $af9bc8bdbad450a3$var$EmotionCacheContext = /* #__PURE__ */ $kc00y.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== "undefined" ? /* #__PURE__ */ (0, $d0OJ1.default)({
    key: "css"
}) : null);
var $af9bc8bdbad450a3$export$e7094788287c5e9b = $af9bc8bdbad450a3$var$EmotionCacheContext.Provider;
var $af9bc8bdbad450a3$export$71511d61b312f219 = function useEmotionCache() /*: EmotionCache | null*/ {
    return (0, $kc00y.useContext)($af9bc8bdbad450a3$var$EmotionCacheContext);
};
var $af9bc8bdbad450a3$export$efccba1c4a2ef57b = function withEmotionCache(func) /*: React.AbstractComponent<Props> */ {
    return /*#__PURE__*/ (0, $kc00y.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $kc00y.useContext)($af9bc8bdbad450a3$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$af9bc8bdbad450a3$export$23f2a1d2818174ef) $af9bc8bdbad450a3$export$efccba1c4a2ef57b = function withEmotionCache(func) /*: React.StatelessFunctionalComponent<Props> */ {
    return function(props) {
        var cache = (0, $kc00y.useContext)($af9bc8bdbad450a3$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $d0OJ1.default)({
                key: "css"
            });
            return /*#__PURE__*/ $kc00y.createElement($af9bc8bdbad450a3$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $af9bc8bdbad450a3$export$971d5caa766a69d7 = /* #__PURE__ */ $kc00y.createContext({});
var $af9bc8bdbad450a3$export$3b14a55fb2447963 = function useTheme() {
    return $kc00y.useContext($af9bc8bdbad450a3$export$971d5caa766a69d7);
};
var $af9bc8bdbad450a3$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === "function") {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $cGuNc.default)({}, outerTheme, theme);
};
var $af9bc8bdbad450a3$var$createCacheWithTheme = /* #__PURE__ */ (0, $ktTCU.default)(function(outerTheme) {
    return (0, $ktTCU.default)(function(theme) {
        return $af9bc8bdbad450a3$var$getTheme(outerTheme, theme);
    });
});
/*
type ThemeProviderProps = {
  theme: Object | (Object => Object),
  children: React.Node
}
*/ var $af9bc8bdbad450a3$export$8b22cf2602fb60ce = function ThemeProvider(props) {
    var theme = $kc00y.useContext($af9bc8bdbad450a3$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $af9bc8bdbad450a3$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $kc00y.createElement($af9bc8bdbad450a3$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $af9bc8bdbad450a3$export$4368d992c4eafac0(Component) /*: React.AbstractComponent<$Diff<Config, { theme: Object }>> */ {
    var componentName = Component.displayName || Component.name || "Component";
    var render = function render(props, ref) {
        var theme = $kc00y.useContext($af9bc8bdbad450a3$export$971d5caa766a69d7);
        return /*#__PURE__*/ $kc00y.createElement(Component, (0, $cGuNc.default)({
            theme: theme,
            ref: ref
        }, props));
    };
    var WithTheme = /*#__PURE__*/ $kc00y.forwardRef(render);
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $3rWGO.default)(WithTheme, Component);
}
var $af9bc8bdbad450a3$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $af9bc8bdbad450a3$var$typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";
var $af9bc8bdbad450a3$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if ($af9bc8bdbad450a3$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$af9bc8bdbad450a3$var$typePropName] = type; // Runtime labeling is an opt-in feature because:
    return newProps;
};
var $af9bc8bdbad450a3$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $9GoLs.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $8SblK.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $9GoLs.insertStyles)(cache, serialized, isStringTag);
    });
    if (!$af9bc8bdbad450a3$export$23f2a1d2818174ef && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += " " + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $kc00y.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $af9bc8bdbad450a3$var$Emotion = /* #__PURE__ */ $af9bc8bdbad450a3$export$efccba1c4a2ef57b(/* <any, any> */ function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === "string" && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$af9bc8bdbad450a3$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = "";
    if (typeof props.className === "string") className = (0, $9GoLs.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $a6zDP.serializeStyles)(registeredStyles, undefined, $kc00y.useContext($af9bc8bdbad450a3$export$971d5caa766a69d7));
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($af9bc8bdbad450a3$export$dda1d9f60106f0e9.call(props, key) && key !== "css" && key !== $af9bc8bdbad450a3$var$typePropName && !$af9bc8bdbad450a3$export$407448d2b89b1813) newProps[key] = props[key];
    newProps.className = className;
    if (ref) newProps.ref = ref;
    return /*#__PURE__*/ $kc00y.createElement($kc00y.Fragment, null, /*#__PURE__*/ $kc00y.createElement($af9bc8bdbad450a3$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === "string"
    }), /*#__PURE__*/ $kc00y.createElement(WrappedComponent, newProps));
});
var $af9bc8bdbad450a3$export$a9c23c6ac3fc3eca = $af9bc8bdbad450a3$var$Emotion;

});
parcelRegister("d0OJ1", function(module, exports) {

$parcel$export(module.exports, "default", () => $97929f674a12cd71$export$2e2bcd8739ae039);

var $bwmBM = parcelRequire("bwmBM");

var $4GoaH = parcelRequire("4GoaH");

var $ktTCU = parcelRequire("ktTCU");

var $gZrNl = parcelRequire("gZrNl");
var $97929f674a12cd71$var$isBrowser = typeof document !== "undefined";
var $97929f674a12cd71$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $4GoaH.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $4GoaH.token)(character)) break;
        (0, $4GoaH.next)();
    }
    return (0, $4GoaH.slice)(begin, (0, $4GoaH.position));
};
var $97929f674a12cd71$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $4GoaH.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $4GoaH.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $97929f674a12cd71$var$identifierWithPointTracking((0, $4GoaH.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $4GoaH.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $4GoaH.peek)() === 58 ? "&\f" : "";
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $4GoaH.from)(character);
    }
    while (character = (0, $4GoaH.next)());
    return parsed;
};
var $97929f674a12cd71$var$getRules = function getRules(value, points) {
    return (0, $4GoaH.dealloc)($97929f674a12cd71$var$toRules((0, $4GoaH.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $97929f674a12cd71$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $97929f674a12cd71$var$compat = function compat(element) {
    if (element.type !== "rule" || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value, parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== "rule"){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$97929f674a12cd71$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $97929f674a12cd71$var$fixedElements.set(element, true);
    var points = [];
    var rules = $97929f674a12cd71$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $97929f674a12cd71$var$removeLabel = function removeLabel(element) {
    if (element.type === "decl") {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = "";
            element.value = "";
        }
    }
};
/* eslint-disable no-fallthrough */ function $97929f674a12cd71$var$prefix(value, length) {
    switch((0, $4GoaH.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $4GoaH.WEBKIT) + "print-" + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $4GoaH.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $4GoaH.WEBKIT) + value + (0, $4GoaH.MOZ) + value + (0, $4GoaH.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $4GoaH.WEBKIT) + value + (0, $4GoaH.MS) + value + value;
        // order
        case 6165:
            return (0, $4GoaH.WEBKIT) + value + (0, $4GoaH.MS) + "flex-" + value + value;
        // align-items
        case 5187:
            return (0, $4GoaH.WEBKIT) + value + (0, $4GoaH.replace)(value, /(\w+).+(:[^]+)/, (0, $4GoaH.WEBKIT) + "box-$1$2" + (0, $4GoaH.MS) + "flex-$1$2") + value;
        // align-self
        case 5443:
            return (0, $4GoaH.WEBKIT) + value + (0, $4GoaH.MS) + "flex-item-" + (0, $4GoaH.replace)(value, /flex-|-self/, "") + value;
        // align-content
        case 4675:
            return (0, $4GoaH.WEBKIT) + value + (0, $4GoaH.MS) + "flex-line-pack" + (0, $4GoaH.replace)(value, /align-content|flex-|-self/, "") + value;
        // flex-shrink
        case 5548:
            return (0, $4GoaH.WEBKIT) + value + (0, $4GoaH.MS) + (0, $4GoaH.replace)(value, "shrink", "negative") + value;
        // flex-basis
        case 5292:
            return (0, $4GoaH.WEBKIT) + value + (0, $4GoaH.MS) + (0, $4GoaH.replace)(value, "basis", "preferred-size") + value;
        // flex-grow
        case 6060:
            return (0, $4GoaH.WEBKIT) + "box-" + (0, $4GoaH.replace)(value, "-grow", "") + (0, $4GoaH.WEBKIT) + value + (0, $4GoaH.MS) + (0, $4GoaH.replace)(value, "grow", "positive") + value;
        // transition
        case 4554:
            return (0, $4GoaH.WEBKIT) + (0, $4GoaH.replace)(value, /([^-])(transform)/g, "$1" + (0, $4GoaH.WEBKIT) + "$2") + value;
        // cursor
        case 6187:
            return (0, $4GoaH.replace)((0, $4GoaH.replace)((0, $4GoaH.replace)(value, /(zoom-|grab)/, (0, $4GoaH.WEBKIT) + "$1"), /(image-set)/, (0, $4GoaH.WEBKIT) + "$1"), value, "") + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $4GoaH.replace)(value, /(image-set\([^]*)/, (0, $4GoaH.WEBKIT) + "$1" + "$`$1");
        // justify-content
        case 4968:
            return (0, $4GoaH.replace)((0, $4GoaH.replace)(value, /(.+:)(flex-)?(.*)/, (0, $4GoaH.WEBKIT) + "box-pack:$3" + (0, $4GoaH.MS) + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + (0, $4GoaH.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $4GoaH.replace)(value, /(.+)-inline(.+)/, (0, $4GoaH.WEBKIT) + "$1$2") + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $4GoaH.strlen)(value) - 1 - length > 6) switch((0, $4GoaH.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $4GoaH.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $4GoaH.replace)(value, /(.+:)(.+)-([^]+)/, "$1" + (0, $4GoaH.WEBKIT) + "$2-$3" + "$1" + (0, $4GoaH.MOZ) + ((0, $4GoaH.charat)(value, length + 3) == 108 ? "$3" : "$2-$3")) + value;
                // (s)tretch
                case 115:
                    return ~(0, $4GoaH.indexof)(value, "stretch") ? $97929f674a12cd71$var$prefix((0, $4GoaH.replace)(value, "stretch", "fill-available"), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $4GoaH.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $4GoaH.charat)(value, (0, $4GoaH.strlen)(value) - 3 - (~(0, $4GoaH.indexof)(value, "!important") && 10))){
                // stic(k)y
                case 107:
                    return (0, $4GoaH.replace)(value, ":", ":" + (0, $4GoaH.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $4GoaH.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, "$1" + (0, $4GoaH.WEBKIT) + ((0, $4GoaH.charat)(value, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + (0, $4GoaH.WEBKIT) + "$2$3" + "$1" + (0, $4GoaH.MS) + "$2box$3") + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $4GoaH.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $4GoaH.WEBKIT) + value + (0, $4GoaH.MS) + (0, $4GoaH.replace)(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
                // vertical-r(l)
                case 108:
                    return (0, $4GoaH.WEBKIT) + value + (0, $4GoaH.MS) + (0, $4GoaH.replace)(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
                // horizontal(-)tb
                case 45:
                    return (0, $4GoaH.WEBKIT) + value + (0, $4GoaH.MS) + (0, $4GoaH.replace)(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
            }
            return (0, $4GoaH.WEBKIT) + value + (0, $4GoaH.MS) + value + value;
    }
    return value;
}
var $97929f674a12cd71$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $4GoaH.DECLARATION:
                element["return"] = $97929f674a12cd71$var$prefix(element.value, element.length);
                break;
            case 0, $4GoaH.KEYFRAMES:
                return (0, $4GoaH.serialize)([
                    (0, $4GoaH.copy)(element, {
                        value: (0, $4GoaH.replace)(element.value, "@", "@" + (0, $4GoaH.WEBKIT))
                    })
                ], callback);
            case 0, $4GoaH.RULESET:
                if (element.length) return (0, $4GoaH.combine)(element.props, function(value) {
                    switch((0, $4GoaH.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ":read-only":
                        case ":read-write":
                            return (0, $4GoaH.serialize)([
                                (0, $4GoaH.copy)(element, {
                                    props: [
                                        (0, $4GoaH.replace)(value, /:(read-\w+)/, ":" + (0, $4GoaH.MOZ) + "$1")
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case "::placeholder":
                            return (0, $4GoaH.serialize)([
                                (0, $4GoaH.copy)(element, {
                                    props: [
                                        (0, $4GoaH.replace)(value, /:(plac\w+)/, ":" + (0, $4GoaH.WEBKIT) + "input-$1")
                                    ]
                                }),
                                (0, $4GoaH.copy)(element, {
                                    props: [
                                        (0, $4GoaH.replace)(value, /:(plac\w+)/, ":" + (0, $4GoaH.MOZ) + "$1")
                                    ]
                                }),
                                (0, $4GoaH.copy)(element, {
                                    props: [
                                        (0, $4GoaH.replace)(value, /:(plac\w+)/, (0, $4GoaH.MS) + "input-$1")
                                    ]
                                })
                            ], callback);
                    }
                    return "";
                });
        }
    }
};
/* import type { StylisPlugin } from './types' */ /*
export type Options = {
  nonce?: string,
  stylisPlugins?: StylisPlugin[],
  key: string,
  container?: HTMLElement,
  speedy?: boolean,
  prepend?: boolean,
  insertionPoint?: HTMLElement
}
*/ var $97929f674a12cd71$var$getServerStylisCache = $97929f674a12cd71$var$isBrowser ? undefined : (0, $ktTCU.default)(function() {
    return (0, $gZrNl.default)(function() {
        var cache = {};
        return function(name) {
            return cache[name];
        };
    });
});
var $97929f674a12cd71$var$defaultStylisPlugins = [
    $97929f674a12cd71$var$prefixer
];
var $97929f674a12cd71$export$2e2bcd8739ae039 = function /*: EmotionCache */ createCache(options) {
    var key = options.key;
    if ($97929f674a12cd71$var$isBrowser && key === "css") {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute("data-emotion");
            if (dataEmotionAttribute.indexOf(" ") === -1) return;
            document.head.appendChild(node);
            node.setAttribute("data-s", "");
        });
    }
    var stylisPlugins = options.stylisPlugins || $97929f674a12cd71$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    /* : Node */ var nodesToHydrate = [];
    if ($97929f674a12cd71$var$isBrowser) {
        container = options.container || document.head;
        Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
        document.querySelectorAll('style[data-emotion^="' + key + ' "]'), function(node) {
            var attrib = node.getAttribute("data-emotion").split(" ");
            for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
            nodesToHydrate.push(node);
        });
    }
    var _insert;
    /*: (
  selector: string,
  serialized: SerializedStyles,
  sheet: StyleSheet,
  shouldCache: boolean
  ) => string | void */ var omnipresentPlugins = [
        $97929f674a12cd71$var$compat,
        $97929f674a12cd71$var$removeLabel
    ];
    if ($97929f674a12cd71$var$isBrowser) {
        var currentSheet;
        var finalizingPlugins = [
            (0, $4GoaH.stringify),
            (0, $4GoaH.rulesheet)(function(rule) {
                currentSheet.insert(rule);
            })
        ];
        var serializer = (0, $4GoaH.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
        var stylis = function stylis(styles) {
            return (0, $4GoaH.serialize)((0, $4GoaH.compile)(styles), serializer);
        };
        _insert = function /*: void */ insert(selector, serialized, sheet, shouldCache) {
            currentSheet = sheet;
            stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            if (shouldCache) cache.inserted[serialized.name] = true;
        };
    } else {
        var _finalizingPlugins = [
            (0, $4GoaH.stringify)
        ];
        var _serializer = (0, $4GoaH.middleware)(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));
        var _stylis = function _stylis(styles) {
            return (0, $4GoaH.serialize)((0, $4GoaH.compile)(styles), _serializer);
        };
        var serverStylisCache = $97929f674a12cd71$var$getServerStylisCache(stylisPlugins)(key);
        var getRules = function /*: string */ getRules(selector, serialized) {
            var name = serialized.name;
            if (serverStylisCache[name] === undefined) serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            return serverStylisCache[name];
        };
        _insert = function /*: string | void */ _insert(selector, serialized, sheet, shouldCache) {
            var name = serialized.name;
            var rules = getRules(selector, serialized);
            if (cache.compat === undefined) {
                // in regular mode, we don't set the styles on the inserted cache
                // since we don't need to and that would be wasting memory
                // we return them so that they are rendered in a style tag
                if (shouldCache) cache.inserted[name] = true;
                return rules;
            } else {
                // in compat mode, we put the styles on the inserted cache so
                // that emotion-server can pull out the styles
                // except when we don't want to cache it which was in Global but now
                // is nowhere but we don't want to do a major right now
                // and just in case we're going to leave the case here
                // it's also not affecting client side bundle size
                // so it's really not a big deal
                if (shouldCache) cache.inserted[name] = rules;
                else return rules;
            }
        };
    }
    var cache = {
        key: key,
        sheet: new (0, $bwmBM.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("bwmBM", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", () => $86343868ad58ebd9$export$9d753cd7ae895cce);
var $86343868ad58ebd9$var$isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function $86343868ad58ebd9$var$sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function $86343868ad58ebd9$var$createStyleElement(options) {
    var tag = document.createElement("style");
    tag.setAttribute("data-emotion", options.key);
    if (options.nonce !== undefined) tag.setAttribute("nonce", options.nonce);
    tag.appendChild(document.createTextNode(""));
    tag.setAttribute("data-s", "");
    return tag;
}
var $86343868ad58ebd9$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !$86343868ad58ebd9$var$isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($86343868ad58ebd9$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $86343868ad58ebd9$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("4GoaH", function(module, exports) {

$parcel$export(module.exports, "MS", () => $96df9a5076697fb4$export$71ad59f2e432cfe8);
$parcel$export(module.exports, "MOZ", () => $96df9a5076697fb4$export$2c0f367103c8d01c);
$parcel$export(module.exports, "WEBKIT", () => $96df9a5076697fb4$export$39dfd62a25e0fe93);
$parcel$export(module.exports, "RULESET", () => $96df9a5076697fb4$export$aa3a2e812ca8570d);
$parcel$export(module.exports, "DECLARATION", () => $96df9a5076697fb4$export$527d108ccf083c2b);
$parcel$export(module.exports, "KEYFRAMES", () => $96df9a5076697fb4$export$b44a8529a35fcb60);
$parcel$export(module.exports, "from", () => $96df9a5076697fb4$export$6788812c4e6611e6);
$parcel$export(module.exports, "hash", () => $96df9a5076697fb4$export$d6af199866bfb566);
$parcel$export(module.exports, "charat", () => $96df9a5076697fb4$export$a9db5e087081082d);
$parcel$export(module.exports, "match", () => $96df9a5076697fb4$export$4659b591c19bdf3d);
$parcel$export(module.exports, "replace", () => $96df9a5076697fb4$export$77ad94ebf1c2b9ed);
$parcel$export(module.exports, "indexof", () => $96df9a5076697fb4$export$f8e21b1e77979a08);
$parcel$export(module.exports, "strlen", () => $96df9a5076697fb4$export$36776f635604f274);
$parcel$export(module.exports, "combine", () => $96df9a5076697fb4$export$1be1fc439b849fdf);
$parcel$export(module.exports, "position", () => $96df9a5076697fb4$export$5880b8b5730aff45);
$parcel$export(module.exports, "copy", () => $96df9a5076697fb4$export$784d13d8ee351f07);
$parcel$export(module.exports, "next", () => $96df9a5076697fb4$export$48cfd1e771a65c4f);
$parcel$export(module.exports, "peek", () => $96df9a5076697fb4$export$4d3fb11e950abb9e);
$parcel$export(module.exports, "slice", () => $96df9a5076697fb4$export$58adb3bec8346d0f);
$parcel$export(module.exports, "token", () => $96df9a5076697fb4$export$9e1725a4cfeada27);
$parcel$export(module.exports, "alloc", () => $96df9a5076697fb4$export$2de70f21292aac9e);
$parcel$export(module.exports, "dealloc", () => $96df9a5076697fb4$export$45918ac1574455b1);
$parcel$export(module.exports, "delimit", () => $96df9a5076697fb4$export$410ac95b9ec204b8);
$parcel$export(module.exports, "compile", () => $96df9a5076697fb4$export$ef7acd7185315e22);
$parcel$export(module.exports, "serialize", () => $96df9a5076697fb4$export$dfdc1655ccc5b9cb);
$parcel$export(module.exports, "stringify", () => $96df9a5076697fb4$export$fac44ee5b035f737);
$parcel$export(module.exports, "middleware", () => $96df9a5076697fb4$export$5a7767152ae0305f);
$parcel$export(module.exports, "rulesheet", () => $96df9a5076697fb4$export$38bcb760f1d4871c);
var $96df9a5076697fb4$export$71ad59f2e432cfe8 = "-ms-";
var $96df9a5076697fb4$export$2c0f367103c8d01c = "-moz-";
var $96df9a5076697fb4$export$39dfd62a25e0fe93 = "-webkit-";
var $96df9a5076697fb4$export$a29989082612d0d9 = "comm";
var $96df9a5076697fb4$export$aa3a2e812ca8570d = "rule";
var $96df9a5076697fb4$export$527d108ccf083c2b = "decl";
var $96df9a5076697fb4$export$d3d35020fa5b54f0 = "@page";
var $96df9a5076697fb4$export$500415a86c544f73 = "@media";
var $96df9a5076697fb4$export$a763edbf796b780a = "@import";
var $96df9a5076697fb4$export$2790aeb8b4e5c826 = "@charset";
var $96df9a5076697fb4$export$1cc683e23b84b133 = "@viewport";
var $96df9a5076697fb4$export$9447a5efea57e862 = "@supports";
var $96df9a5076697fb4$export$ef011b4e114b1fba = "@document";
var $96df9a5076697fb4$export$6aad947bda0f3f46 = "@namespace";
var $96df9a5076697fb4$export$b44a8529a35fcb60 = "@keyframes";
var $96df9a5076697fb4$export$2c16de31893252e6 = "@font-face";
var $96df9a5076697fb4$export$3d846dd52e150c6f = "@counter-style";
var $96df9a5076697fb4$export$22314bfbb57653fe = "@font-feature-values";
var $96df9a5076697fb4$export$d773506282b3cfe6 = "@layer";
var $96df9a5076697fb4$export$2335f513bbd82c6d = Math.abs;
var $96df9a5076697fb4$export$6788812c4e6611e6 = String.fromCharCode;
var $96df9a5076697fb4$export$e6e34fd1f2686227 = Object.assign;
function $96df9a5076697fb4$export$d6af199866bfb566(e, r) {
    return $96df9a5076697fb4$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $96df9a5076697fb4$export$a9db5e087081082d(e, 0)) << 2 ^ $96df9a5076697fb4$export$a9db5e087081082d(e, 1)) << 2 ^ $96df9a5076697fb4$export$a9db5e087081082d(e, 2)) << 2 ^ $96df9a5076697fb4$export$a9db5e087081082d(e, 3) : 0;
}
function $96df9a5076697fb4$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $96df9a5076697fb4$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $96df9a5076697fb4$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $96df9a5076697fb4$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $96df9a5076697fb4$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $96df9a5076697fb4$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $96df9a5076697fb4$export$36776f635604f274(e) {
    return e.length;
}
function $96df9a5076697fb4$export$f9084667e487ed46(e) {
    return e.length;
}
function $96df9a5076697fb4$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $96df9a5076697fb4$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $96df9a5076697fb4$export$53f1d5ea8de3d7c = 1;
var $96df9a5076697fb4$export$4e0c71f277ca26b3 = 1;
var $96df9a5076697fb4$export$f24224f1c91d8156 = 0;
var $96df9a5076697fb4$export$5880b8b5730aff45 = 0;
var $96df9a5076697fb4$export$c0306caf338ac095 = 0;
var $96df9a5076697fb4$export$30a86d91af8ff6e6 = "";
function $96df9a5076697fb4$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $96df9a5076697fb4$export$53f1d5ea8de3d7c,
        column: $96df9a5076697fb4$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $96df9a5076697fb4$export$784d13d8ee351f07(e, r) {
    return $96df9a5076697fb4$export$e6e34fd1f2686227($96df9a5076697fb4$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $96df9a5076697fb4$export$eba6f6f03b0a92e7() {
    return $96df9a5076697fb4$export$c0306caf338ac095;
}
function $96df9a5076697fb4$export$232faf9add678146() {
    $96df9a5076697fb4$export$c0306caf338ac095 = $96df9a5076697fb4$export$5880b8b5730aff45 > 0 ? $96df9a5076697fb4$export$a9db5e087081082d($96df9a5076697fb4$export$30a86d91af8ff6e6, --$96df9a5076697fb4$export$5880b8b5730aff45) : 0;
    if ($96df9a5076697fb4$export$4e0c71f277ca26b3--, $96df9a5076697fb4$export$c0306caf338ac095 === 10) $96df9a5076697fb4$export$4e0c71f277ca26b3 = 1, $96df9a5076697fb4$export$53f1d5ea8de3d7c--;
    return $96df9a5076697fb4$export$c0306caf338ac095;
}
function $96df9a5076697fb4$export$48cfd1e771a65c4f() {
    $96df9a5076697fb4$export$c0306caf338ac095 = $96df9a5076697fb4$export$5880b8b5730aff45 < $96df9a5076697fb4$export$f24224f1c91d8156 ? $96df9a5076697fb4$export$a9db5e087081082d($96df9a5076697fb4$export$30a86d91af8ff6e6, $96df9a5076697fb4$export$5880b8b5730aff45++) : 0;
    if ($96df9a5076697fb4$export$4e0c71f277ca26b3++, $96df9a5076697fb4$export$c0306caf338ac095 === 10) $96df9a5076697fb4$export$4e0c71f277ca26b3 = 1, $96df9a5076697fb4$export$53f1d5ea8de3d7c++;
    return $96df9a5076697fb4$export$c0306caf338ac095;
}
function $96df9a5076697fb4$export$4d3fb11e950abb9e() {
    return $96df9a5076697fb4$export$a9db5e087081082d($96df9a5076697fb4$export$30a86d91af8ff6e6, $96df9a5076697fb4$export$5880b8b5730aff45);
}
function $96df9a5076697fb4$export$e88cb2efb12ae807() {
    return $96df9a5076697fb4$export$5880b8b5730aff45;
}
function $96df9a5076697fb4$export$58adb3bec8346d0f(e, r) {
    return $96df9a5076697fb4$export$2f35ab04d2335697($96df9a5076697fb4$export$30a86d91af8ff6e6, e, r);
}
function $96df9a5076697fb4$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $96df9a5076697fb4$export$2de70f21292aac9e(e) {
    return $96df9a5076697fb4$export$53f1d5ea8de3d7c = $96df9a5076697fb4$export$4e0c71f277ca26b3 = 1, $96df9a5076697fb4$export$f24224f1c91d8156 = $96df9a5076697fb4$export$36776f635604f274($96df9a5076697fb4$export$30a86d91af8ff6e6 = e), $96df9a5076697fb4$export$5880b8b5730aff45 = 0, [];
}
function $96df9a5076697fb4$export$45918ac1574455b1(e) {
    return $96df9a5076697fb4$export$30a86d91af8ff6e6 = "", e;
}
function $96df9a5076697fb4$export$410ac95b9ec204b8(e) {
    return $96df9a5076697fb4$export$87c2784dc9fc4ab($96df9a5076697fb4$export$58adb3bec8346d0f($96df9a5076697fb4$export$5880b8b5730aff45 - 1, $96df9a5076697fb4$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $96df9a5076697fb4$export$660b2ee2d4fb4eff(e) {
    return $96df9a5076697fb4$export$45918ac1574455b1($96df9a5076697fb4$export$5f8c09e3ae6f64e1($96df9a5076697fb4$export$2de70f21292aac9e(e)));
}
function $96df9a5076697fb4$export$7af1228ff777d175(e) {
    while($96df9a5076697fb4$export$c0306caf338ac095 = $96df9a5076697fb4$export$4d3fb11e950abb9e())if ($96df9a5076697fb4$export$c0306caf338ac095 < 33) $96df9a5076697fb4$export$48cfd1e771a65c4f();
    else break;
    return $96df9a5076697fb4$export$9e1725a4cfeada27(e) > 2 || $96df9a5076697fb4$export$9e1725a4cfeada27($96df9a5076697fb4$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $96df9a5076697fb4$export$5f8c09e3ae6f64e1(e) {
    while($96df9a5076697fb4$export$48cfd1e771a65c4f())switch($96df9a5076697fb4$export$9e1725a4cfeada27($96df9a5076697fb4$export$c0306caf338ac095)){
        case 0:
            $96df9a5076697fb4$export$10d8903dec122b9d($96df9a5076697fb4$export$c2ab62c7bf24634($96df9a5076697fb4$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $96df9a5076697fb4$export$10d8903dec122b9d($96df9a5076697fb4$export$410ac95b9ec204b8($96df9a5076697fb4$export$c0306caf338ac095), e);
            break;
        default:
            $96df9a5076697fb4$export$10d8903dec122b9d($96df9a5076697fb4$export$6788812c4e6611e6($96df9a5076697fb4$export$c0306caf338ac095), e);
    }
    return e;
}
function $96df9a5076697fb4$export$955ba06d119e085e(e, r) {
    while(--r && $96df9a5076697fb4$export$48cfd1e771a65c4f())if ($96df9a5076697fb4$export$c0306caf338ac095 < 48 || $96df9a5076697fb4$export$c0306caf338ac095 > 102 || $96df9a5076697fb4$export$c0306caf338ac095 > 57 && $96df9a5076697fb4$export$c0306caf338ac095 < 65 || $96df9a5076697fb4$export$c0306caf338ac095 > 70 && $96df9a5076697fb4$export$c0306caf338ac095 < 97) break;
    return $96df9a5076697fb4$export$58adb3bec8346d0f(e, $96df9a5076697fb4$export$e88cb2efb12ae807() + (r < 6 && $96df9a5076697fb4$export$4d3fb11e950abb9e() == 32 && $96df9a5076697fb4$export$48cfd1e771a65c4f() == 32));
}
function $96df9a5076697fb4$export$c889f2fcc19dbf12(e) {
    while($96df9a5076697fb4$export$48cfd1e771a65c4f())switch($96df9a5076697fb4$export$c0306caf338ac095){
        case e:
            return $96df9a5076697fb4$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $96df9a5076697fb4$export$c889f2fcc19dbf12($96df9a5076697fb4$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $96df9a5076697fb4$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $96df9a5076697fb4$export$48cfd1e771a65c4f();
            break;
    }
    return $96df9a5076697fb4$export$5880b8b5730aff45;
}
function $96df9a5076697fb4$export$4254d4e2b3745c4c(e, r) {
    while($96df9a5076697fb4$export$48cfd1e771a65c4f())if (e + $96df9a5076697fb4$export$c0306caf338ac095 === 57) break;
    else if (e + $96df9a5076697fb4$export$c0306caf338ac095 === 84 && $96df9a5076697fb4$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $96df9a5076697fb4$export$58adb3bec8346d0f(r, $96df9a5076697fb4$export$5880b8b5730aff45 - 1) + "*" + $96df9a5076697fb4$export$6788812c4e6611e6(e === 47 ? e : $96df9a5076697fb4$export$48cfd1e771a65c4f());
}
function $96df9a5076697fb4$export$c2ab62c7bf24634(e) {
    while(!$96df9a5076697fb4$export$9e1725a4cfeada27($96df9a5076697fb4$export$4d3fb11e950abb9e()))$96df9a5076697fb4$export$48cfd1e771a65c4f();
    return $96df9a5076697fb4$export$58adb3bec8346d0f(e, $96df9a5076697fb4$export$5880b8b5730aff45);
}
function $96df9a5076697fb4$export$ef7acd7185315e22(e) {
    return $96df9a5076697fb4$export$45918ac1574455b1($96df9a5076697fb4$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $96df9a5076697fb4$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $96df9a5076697fb4$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $96df9a5076697fb4$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $96df9a5076697fb4$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($96df9a5076697fb4$export$f8e21b1e77979a08(j += $96df9a5076697fb4$export$77ad94ebf1c2b9ed($96df9a5076697fb4$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $96df9a5076697fb4$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $96df9a5076697fb4$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $96df9a5076697fb4$export$955ba06d119e085e($96df9a5076697fb4$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($96df9a5076697fb4$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $96df9a5076697fb4$export$10d8903dec122b9d($96df9a5076697fb4$export$4a34f930e789283c($96df9a5076697fb4$export$4254d4e2b3745c4c($96df9a5076697fb4$export$48cfd1e771a65c4f(), $96df9a5076697fb4$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $96df9a5076697fb4$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $96df9a5076697fb4$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $96df9a5076697fb4$export$36776f635604f274(j) - l) $96df9a5076697fb4$export$10d8903dec122b9d(p > 32 ? $96df9a5076697fb4$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $96df9a5076697fb4$export$f8483753829ec8f3($96df9a5076697fb4$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $96df9a5076697fb4$export$10d8903dec122b9d(y = $96df9a5076697fb4$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $96df9a5076697fb4$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $96df9a5076697fb4$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $96df9a5076697fb4$export$98e6a39c04603d36(e, y, y, n && $96df9a5076697fb4$export$10d8903dec122b9d($96df9a5076697fb4$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $96df9a5076697fb4$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $96df9a5076697fb4$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $96df9a5076697fb4$export$232faf9add678146() == 125) continue;
            }
            switch(j += $96df9a5076697fb4$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($96df9a5076697fb4$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($96df9a5076697fb4$export$4d3fb11e950abb9e() === 45) j += $96df9a5076697fb4$export$410ac95b9ec204b8($96df9a5076697fb4$export$48cfd1e771a65c4f());
                    v = $96df9a5076697fb4$export$4d3fb11e950abb9e(), o = l = $96df9a5076697fb4$export$36776f635604f274(g = j += $96df9a5076697fb4$export$c2ab62c7bf24634($96df9a5076697fb4$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $96df9a5076697fb4$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $96df9a5076697fb4$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $96df9a5076697fb4$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $96df9a5076697fb4$export$2f35ab04d2335697(e, v + 1, v = $96df9a5076697fb4$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $96df9a5076697fb4$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $96df9a5076697fb4$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $96df9a5076697fb4$export$35059013cd4a06db(e, r, a, s === 0 ? $96df9a5076697fb4$export$aa3a2e812ca8570d : i, f, o, l);
}
function $96df9a5076697fb4$export$4a34f930e789283c(e, r, a) {
    return $96df9a5076697fb4$export$35059013cd4a06db(e, r, a, $96df9a5076697fb4$export$a29989082612d0d9, $96df9a5076697fb4$export$6788812c4e6611e6($96df9a5076697fb4$export$eba6f6f03b0a92e7()), $96df9a5076697fb4$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $96df9a5076697fb4$export$f8483753829ec8f3(e, r, a, n) {
    return $96df9a5076697fb4$export$35059013cd4a06db(e, r, a, $96df9a5076697fb4$export$527d108ccf083c2b, $96df9a5076697fb4$export$2f35ab04d2335697(e, 0, n), $96df9a5076697fb4$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $96df9a5076697fb4$export$82e9f45cca5ba907(n, c, s) {
    switch($96df9a5076697fb4$export$d6af199866bfb566(n, c)){
        case 5103:
            return $96df9a5076697fb4$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $96df9a5076697fb4$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $96df9a5076697fb4$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $96df9a5076697fb4$export$39dfd62a25e0fe93 + n + $96df9a5076697fb4$export$2c0f367103c8d01c + n + $96df9a5076697fb4$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($96df9a5076697fb4$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $96df9a5076697fb4$export$39dfd62a25e0fe93 + n + $96df9a5076697fb4$export$71ad59f2e432cfe8 + $96df9a5076697fb4$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $96df9a5076697fb4$export$39dfd62a25e0fe93 + n + $96df9a5076697fb4$export$71ad59f2e432cfe8 + $96df9a5076697fb4$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $96df9a5076697fb4$export$39dfd62a25e0fe93 + n + $96df9a5076697fb4$export$71ad59f2e432cfe8 + $96df9a5076697fb4$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $96df9a5076697fb4$export$39dfd62a25e0fe93 + n + $96df9a5076697fb4$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $96df9a5076697fb4$export$39dfd62a25e0fe93 + n + $96df9a5076697fb4$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $96df9a5076697fb4$export$39dfd62a25e0fe93 + n + $96df9a5076697fb4$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $96df9a5076697fb4$export$39dfd62a25e0fe93 + "box-$1$2" + $96df9a5076697fb4$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $96df9a5076697fb4$export$39dfd62a25e0fe93 + n + $96df9a5076697fb4$export$71ad59f2e432cfe8 + "flex-item-" + $96df9a5076697fb4$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$96df9a5076697fb4$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $96df9a5076697fb4$export$71ad59f2e432cfe8 + "grid-row-" + $96df9a5076697fb4$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $96df9a5076697fb4$export$39dfd62a25e0fe93 + n + $96df9a5076697fb4$export$71ad59f2e432cfe8 + "flex-line-pack" + $96df9a5076697fb4$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $96df9a5076697fb4$export$39dfd62a25e0fe93 + n + $96df9a5076697fb4$export$71ad59f2e432cfe8 + $96df9a5076697fb4$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $96df9a5076697fb4$export$39dfd62a25e0fe93 + n + $96df9a5076697fb4$export$71ad59f2e432cfe8 + $96df9a5076697fb4$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $96df9a5076697fb4$export$39dfd62a25e0fe93 + "box-" + $96df9a5076697fb4$export$77ad94ebf1c2b9ed(n, "-grow", "") + $96df9a5076697fb4$export$39dfd62a25e0fe93 + n + $96df9a5076697fb4$export$71ad59f2e432cfe8 + $96df9a5076697fb4$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $96df9a5076697fb4$export$39dfd62a25e0fe93 + $96df9a5076697fb4$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $96df9a5076697fb4$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $96df9a5076697fb4$export$77ad94ebf1c2b9ed($96df9a5076697fb4$export$77ad94ebf1c2b9ed($96df9a5076697fb4$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $96df9a5076697fb4$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $96df9a5076697fb4$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $96df9a5076697fb4$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $96df9a5076697fb4$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $96df9a5076697fb4$export$77ad94ebf1c2b9ed($96df9a5076697fb4$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $96df9a5076697fb4$export$39dfd62a25e0fe93 + "box-pack:$3" + $96df9a5076697fb4$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $96df9a5076697fb4$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$96df9a5076697fb4$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $96df9a5076697fb4$export$71ad59f2e432cfe8 + "grid-column-align" + $96df9a5076697fb4$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $96df9a5076697fb4$export$71ad59f2e432cfe8 + $96df9a5076697fb4$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $96df9a5076697fb4$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$96df9a5076697fb4$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $96df9a5076697fb4$export$71ad59f2e432cfe8 + $96df9a5076697fb4$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $96df9a5076697fb4$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$96df9a5076697fb4$export$f8e21b1e77979a08(s, "span") ? $96df9a5076697fb4$export$4659b591c19bdf3d(s, /\d+/) : +$96df9a5076697fb4$export$4659b591c19bdf3d(s, /\d+/) - +$96df9a5076697fb4$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $96df9a5076697fb4$export$71ad59f2e432cfe8 + $96df9a5076697fb4$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $96df9a5076697fb4$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $96df9a5076697fb4$export$71ad59f2e432cfe8 + $96df9a5076697fb4$export$77ad94ebf1c2b9ed($96df9a5076697fb4$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $96df9a5076697fb4$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $96df9a5076697fb4$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($96df9a5076697fb4$export$36776f635604f274(n) - 1 - c > 6) switch($96df9a5076697fb4$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($96df9a5076697fb4$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $96df9a5076697fb4$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $96df9a5076697fb4$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $96df9a5076697fb4$export$2c0f367103c8d01c + ($96df9a5076697fb4$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$96df9a5076697fb4$export$f8e21b1e77979a08(n, "stretch") ? $96df9a5076697fb4$export$82e9f45cca5ba907($96df9a5076697fb4$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $96df9a5076697fb4$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $96df9a5076697fb4$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $96df9a5076697fb4$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($96df9a5076697fb4$export$a9db5e087081082d(n, c + 6) === 121) return $96df9a5076697fb4$export$77ad94ebf1c2b9ed(n, ":", ":" + $96df9a5076697fb4$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($96df9a5076697fb4$export$a9db5e087081082d(n, $96df9a5076697fb4$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $96df9a5076697fb4$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $96df9a5076697fb4$export$39dfd62a25e0fe93 + ($96df9a5076697fb4$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $96df9a5076697fb4$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $96df9a5076697fb4$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $96df9a5076697fb4$export$77ad94ebf1c2b9ed(n, ":", ":" + $96df9a5076697fb4$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $96df9a5076697fb4$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $96df9a5076697fb4$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $96df9a5076697fb4$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $96df9a5076697fb4$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $96df9a5076697fb4$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $96df9a5076697fb4$export$a763edbf796b780a:
        case $96df9a5076697fb4$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $96df9a5076697fb4$export$a29989082612d0d9:
            return "";
        case $96df9a5076697fb4$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $96df9a5076697fb4$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $96df9a5076697fb4$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $96df9a5076697fb4$export$36776f635604f274(a = $96df9a5076697fb4$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $96df9a5076697fb4$export$5a7767152ae0305f(e) {
    var r = $96df9a5076697fb4$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $96df9a5076697fb4$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $96df9a5076697fb4$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $96df9a5076697fb4$export$527d108ccf083c2b:
                n.return = $96df9a5076697fb4$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $96df9a5076697fb4$export$b44a8529a35fcb60:
                return $96df9a5076697fb4$export$dfdc1655ccc5b9cb([
                    $96df9a5076697fb4$export$784d13d8ee351f07(n, {
                        value: $96df9a5076697fb4$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $96df9a5076697fb4$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $96df9a5076697fb4$export$aa3a2e812ca8570d:
                if (n.length) return $96df9a5076697fb4$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($96df9a5076697fb4$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $96df9a5076697fb4$export$dfdc1655ccc5b9cb([
                                $96df9a5076697fb4$export$784d13d8ee351f07(n, {
                                    props: [
                                        $96df9a5076697fb4$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $96df9a5076697fb4$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $96df9a5076697fb4$export$dfdc1655ccc5b9cb([
                                $96df9a5076697fb4$export$784d13d8ee351f07(n, {
                                    props: [
                                        $96df9a5076697fb4$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $96df9a5076697fb4$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $96df9a5076697fb4$export$784d13d8ee351f07(n, {
                                    props: [
                                        $96df9a5076697fb4$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $96df9a5076697fb4$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $96df9a5076697fb4$export$784d13d8ee351f07(n, {
                                    props: [
                                        $96df9a5076697fb4$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $96df9a5076697fb4$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $96df9a5076697fb4$export$76a88f7de6507443(e) {
    switch(e.type){
        case $96df9a5076697fb4$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $96df9a5076697fb4$export$1be1fc439b849fdf($96df9a5076697fb4$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($96df9a5076697fb4$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $96df9a5076697fb4$export$2f35ab04d2335697(r, 1, $96df9a5076697fb4$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $96df9a5076697fb4$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $96df9a5076697fb4$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $96df9a5076697fb4$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRegister("ktTCU", function(module, exports) {

$parcel$export(module.exports, "default", () => $ee91aa5afa82e349$export$2e2bcd8739ae039);
var $ee91aa5afa82e349$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRegister("gZrNl", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5e7e751a75c9674$export$2e2bcd8739ae039);
function $c5e7e751a75c9674$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("3rWGO", function(module, exports) {

$parcel$export(module.exports, "default", () => $28316b3b9c63a2bb$export$2e2bcd8739ae039);

var $j8Bf6 = parcelRequire("j8Bf6");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $28316b3b9c63a2bb$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($j8Bf6)))(targetComponent, sourceComponent);
};

});

parcelRegister("9GoLs", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", () => $70cb3f04f606651a$export$95d99596f328fd52);
$parcel$export(module.exports, "registerStyles", () => $70cb3f04f606651a$export$580009a5da2a8b4b);
$parcel$export(module.exports, "insertStyles", () => $70cb3f04f606651a$export$6f077d94b33a01aa);
var $70cb3f04f606651a$var$isBrowser = typeof document !== "undefined";
function $70cb3f04f606651a$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = "";
    classNames.split(" ").forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $70cb3f04f606651a$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $70cb3f04f606651a$var$isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $70cb3f04f606651a$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $70cb3f04f606651a$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var stylesForSSR = "";
        var current = serialized;
        do {
            var maybeStyles = cache.insert(serialized === current ? "." + className : "", current, cache.sheet, true);
            if (!$70cb3f04f606651a$var$isBrowser && maybeStyles !== undefined) stylesForSSR += maybeStyles;
            current = current.next;
        }while (current !== undefined);
        if (!$70cb3f04f606651a$var$isBrowser && stylesForSSR.length !== 0) return stylesForSSR;
    }
};

});

parcelRegister("a6zDP", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", () => $75b61c9548bf65c5$export$6321afa313b251b5);

var $693zr = parcelRequire("693zr");

var $3vp9Y = parcelRequire("3vp9Y");

var $gZrNl = parcelRequire("gZrNl");
var $75b61c9548bf65c5$var$isDevelopment = false;
var $75b61c9548bf65c5$var$hyphenateRegex = /[A-Z]|^ms/g;
var $75b61c9548bf65c5$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $75b61c9548bf65c5$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $75b61c9548bf65c5$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== "boolean";
};
var $75b61c9548bf65c5$var$processStyleName = /* #__PURE__ */ (0, $gZrNl.default)(function(styleName) {
    return $75b61c9548bf65c5$var$isCustomProperty(styleName) ? styleName : styleName.replace($75b61c9548bf65c5$var$hyphenateRegex, "-$&").toLowerCase();
});
var $75b61c9548bf65c5$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case "animation":
        case "animationName":
            if (typeof value === "string") return value.replace($75b61c9548bf65c5$var$animationRegex, function(match, p1, p2) {
                $75b61c9548bf65c5$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $75b61c9548bf65c5$var$cursor
                };
                return p1;
            });
    }
    if ((0, $3vp9Y.default)[key] !== 1 && !$75b61c9548bf65c5$var$isCustomProperty(key) && typeof value === "number" && value !== 0) return value + "px";
    return value;
};
var $75b61c9548bf65c5$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $75b61c9548bf65c5$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return "";
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case "boolean":
            return "";
        case "object":
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $75b61c9548bf65c5$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $75b61c9548bf65c5$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $75b61c9548bf65c5$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $75b61c9548bf65c5$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $75b61c9548bf65c5$var$createStringFromObject(mergedProps, registered, interpolation);
        case "function":
            if (mergedProps !== undefined) {
                var previousCursor = $75b61c9548bf65c5$var$cursor;
                var result = interpolation(mergedProps);
                $75b61c9548bf65c5$var$cursor = previousCursor;
                return $75b61c9548bf65c5$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $75b61c9548bf65c5$var$createStringFromObject(mergedProps, registered, obj) {
    var string = "";
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $75b61c9548bf65c5$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== "object") {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($75b61c9548bf65c5$var$isProcessableValue(asString)) string += $75b61c9548bf65c5$var$processStyleName(key) + ":" + $75b61c9548bf65c5$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === "NO_COMPONENT_SELECTOR" && $75b61c9548bf65c5$var$isDevelopment) throw new Error($75b61c9548bf65c5$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($75b61c9548bf65c5$var$isProcessableValue(value[_i])) string += $75b61c9548bf65c5$var$processStyleName(key) + ":" + $75b61c9548bf65c5$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $75b61c9548bf65c5$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case "animation":
                    case "animationName":
                        string += $75b61c9548bf65c5$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $75b61c9548bf65c5$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g;
// keyframes are stored on the SerializedStyles object as a linked list
var $75b61c9548bf65c5$var$cursor;
function $75b61c9548bf65c5$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = "";
    $75b61c9548bf65c5$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $75b61c9548bf65c5$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $75b61c9548bf65c5$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    }
    $75b61c9548bf65c5$var$labelPattern.lastIndex = 0;
    var identifierName = "";
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $75b61c9548bf65c5$var$labelPattern.exec(styles)) !== null)identifierName += "-" + match[1];
    var name = (0, $693zr.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $75b61c9548bf65c5$var$cursor
    };
}

});
parcelRegister("693zr", function(module, exports) {

$parcel$export(module.exports, "default", () => $47965a6342ae9429$export$2e2bcd8739ae039);
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $47965a6342ae9429$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("3vp9Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $28d7c88e62c97f40$export$2e2bcd8739ae039);
var $28d7c88e62c97f40$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});


parcelRegister("8SblK", function(module, exports) {

$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", () => $675c2baf95757496$export$db21c7ffa21794e7);
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", () => $675c2baf95757496$export$811a713a7276cb9d);

var $kc00y = parcelRequire("kc00y");
var $675c2baf95757496$var$isBrowser = typeof document !== "undefined";
var $675c2baf95757496$var$syncFallback = function syncFallback(create) {
    return create();
};
var $675c2baf95757496$var$useInsertionEffect = $kc00y.useInsertionEffect ? $kc00y.useInsertionEffect : false;
var $675c2baf95757496$export$db21c7ffa21794e7 = !$675c2baf95757496$var$isBrowser ? $675c2baf95757496$var$syncFallback : $675c2baf95757496$var$useInsertionEffect || $675c2baf95757496$var$syncFallback;
var $675c2baf95757496$export$811a713a7276cb9d = $675c2baf95757496$var$useInsertionEffect || $kc00y.useLayoutEffect;

});


parcelRegister("er9eX", function(module, exports) {
function $a82ac139658180a9$var$_extends() {
    return module.exports = $a82ac139658180a9$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $a82ac139658180a9$var$_extends.apply(null, arguments);
}
module.exports = $a82ac139658180a9$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("jve2F", function(module, exports) {

$parcel$export(module.exports, "default", () => $e32bce0b6486f581$export$2e2bcd8739ae039);

var $5ePnh = parcelRequire("5ePnh");

var $3kzgE = parcelRequire("3kzgE");

var $4NLso = parcelRequire("4NLso");

var $25mce = parcelRequire("25mce");
function $e32bce0b6486f581$export$2e2bcd8739ae039(r, e) {
    return (0, $5ePnh.default)(r) || (0, $3kzgE.default)(r, e) || (0, $4NLso.default)(r, e) || (0, $25mce.default)();
}

});
parcelRegister("5ePnh", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d061c79fe535319$export$2e2bcd8739ae039);
function $3d061c79fe535319$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("3kzgE", function(module, exports) {

$parcel$export(module.exports, "default", () => $26ce98c6b4657ff1$export$2e2bcd8739ae039);
function $26ce98c6b4657ff1$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("4NLso", function(module, exports) {

$parcel$export(module.exports, "default", () => $37f08cfaac5a1491$export$2e2bcd8739ae039);

var $eYTTt = parcelRequire("eYTTt");
function $37f08cfaac5a1491$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $eYTTt.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $eYTTt.default)(r, a) : void 0;
    }
}

});
parcelRegister("eYTTt", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae8206a272ba3b20$export$2e2bcd8739ae039);
function $ae8206a272ba3b20$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("25mce", function(module, exports) {

$parcel$export(module.exports, "default", () => $184d4418ed4065fe$export$2e2bcd8739ae039);
function $184d4418ed4065fe$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("lTjB2", function(module, exports) {

$parcel$export(module.exports, "default", () => $fefdef73d5b2b1c6$export$2e2bcd8739ae039);

var $7pbxe = parcelRequire("7pbxe");
function $fefdef73d5b2b1c6$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $7pbxe.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(r = 0; r < s.length; r++)o = s[r], t.includes(o) || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});
parcelRegister("7pbxe", function(module, exports) {

$parcel$export(module.exports, "default", () => $5643d0ce020fb17f$export$2e2bcd8739ae039);
function $5643d0ce020fb17f$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});


parcelRegister("5ZCha", function(module, exports) {

$parcel$export(module.exports, "default", () => $45d0570c5a25fbbe$export$2e2bcd8739ae039);
function $45d0570c5a25fbbe$export$2e2bcd8739ae039(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}

});

parcelRegister("jRiwg", function(module, exports) {

$parcel$export(module.exports, "platform", () => $e751552376b1c971$export$722a64dea1b767dc);
$parcel$export(module.exports, "autoUpdate", () => $e751552376b1c971$export$deee3a793edee05f);
$parcel$export(module.exports, "detectOverflow", () => $e751552376b1c971$export$37b6bde19b108ecc);
$parcel$export(module.exports, "offset", () => $e751552376b1c971$export$cc800923e997bb8);
$parcel$export(module.exports, "autoPlacement", () => $e751552376b1c971$export$91fb6ecbd551914);
$parcel$export(module.exports, "shift", () => $e751552376b1c971$export$fba63a578e423eb);
$parcel$export(module.exports, "flip", () => $e751552376b1c971$export$8a83211c878a3f1f);
$parcel$export(module.exports, "size", () => $e751552376b1c971$export$346677f925de839c);
$parcel$export(module.exports, "hide", () => $e751552376b1c971$export$fe8985bb6374093c);
$parcel$export(module.exports, "arrow", () => $e751552376b1c971$export$f2120bbfa5450bd2);
$parcel$export(module.exports, "inline", () => $e751552376b1c971$export$18c8ad048e32c7d5);
$parcel$export(module.exports, "limitShift", () => $e751552376b1c971$export$7bf07e38f3dc4b69);
$parcel$export(module.exports, "computePosition", () => $e751552376b1c971$export$48a53dcb22e581d0);
$parcel$export(module.exports, "getOverflowAncestors", () => (parcelRequire("gmW3q")).getOverflowAncestors);

var $8JdhS = parcelRequire("8JdhS");
var $d9oMY = parcelRequire("d9oMY");

var $d9oMY = parcelRequire("d9oMY");

var $gmW3q = parcelRequire("gmW3q");
function $e751552376b1c971$var$getCssDimensions(element) {
    const css = (0, $gmW3q.getComputedStyle)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $gmW3q.isHTMLElement)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $d9oMY.round)(width) !== offsetWidth || (0, $d9oMY.round)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $e751552376b1c971$var$unwrapElement(element) {
    return !(0, $gmW3q.isElement)(element) ? element.contextElement : element;
}
function $e751552376b1c971$var$getScale(element) {
    const domElement = $e751552376b1c971$var$unwrapElement(element);
    if (!(0, $gmW3q.isHTMLElement)(domElement)) return (0, $d9oMY.createCoords)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $e751552376b1c971$var$getCssDimensions(domElement);
    let x = ($ ? (0, $d9oMY.round)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $d9oMY.round)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $e751552376b1c971$var$noOffsets = /*#__PURE__*/ (0, $d9oMY.createCoords)(0);
function $e751552376b1c971$var$getVisualOffsets(element) {
    const win = (0, $gmW3q.getWindow)(element);
    if (!(0, $gmW3q.isWebKit)() || !win.visualViewport) return $e751552376b1c971$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $e751552376b1c971$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $gmW3q.getWindow)(element)) return false;
    return isFixed;
}
function $e751552376b1c971$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $e751552376b1c971$var$unwrapElement(element);
    let scale = (0, $d9oMY.createCoords)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $gmW3q.isElement)(offsetParent)) scale = $e751552376b1c971$var$getScale(offsetParent);
        } else scale = $e751552376b1c971$var$getScale(element);
    }
    const visualOffsets = $e751552376b1c971$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $e751552376b1c971$var$getVisualOffsets(domElement) : (0, $d9oMY.createCoords)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $gmW3q.getWindow)(domElement);
        const offsetWin = offsetParent && (0, $gmW3q.isElement)(offsetParent) ? (0, $gmW3q.getWindow)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = (0, $gmW3q.getFrameElement)(currentWin);
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = $e751552376b1c971$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $gmW3q.getComputedStyle)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $gmW3q.getWindow)(currentIFrame);
            currentIFrame = (0, $gmW3q.getFrameElement)(currentWin);
        }
    }
    return (0, $d9oMY.rectToClientRect)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
function $e751552376b1c971$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === "fixed";
    const documentElement = (0, $gmW3q.getDocumentElement)(offsetParent);
    const topLayer = elements ? (0, $gmW3q.isTopLayer)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $d9oMY.createCoords)(1);
    const offsets = (0, $d9oMY.createCoords)(0);
    const isOffsetParentAnElement = (0, $gmW3q.isHTMLElement)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $gmW3q.getNodeName)(offsetParent) !== "body" || (0, $gmW3q.isOverflowElement)(documentElement)) scroll = (0, $gmW3q.getNodeScroll)(offsetParent);
        if ((0, $gmW3q.isHTMLElement)(offsetParent)) {
            const offsetRect = $e751552376b1c971$var$getBoundingClientRect(offsetParent);
            scale = $e751552376b1c971$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y
    };
}
function $e751552376b1c971$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function $e751552376b1c971$var$getWindowScrollBarX(element, rect) {
    const leftScroll = (0, $gmW3q.getNodeScroll)(element).scrollLeft;
    if (!rect) return $e751552376b1c971$var$getBoundingClientRect((0, $gmW3q.getDocumentElement)(element)).left + leftScroll;
    return rect.left + leftScroll;
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $e751552376b1c971$var$getDocumentRect(element) {
    const html = (0, $gmW3q.getDocumentElement)(element);
    const scroll = (0, $gmW3q.getNodeScroll)(element);
    const body = element.ownerDocument.body;
    const width = (0, $d9oMY.max)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $d9oMY.max)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $e751552376b1c971$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $gmW3q.getComputedStyle)(body).direction === "rtl") x += (0, $d9oMY.max)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $e751552376b1c971$var$getViewportRect(element, strategy) {
    const win = (0, $gmW3q.getWindow)(element);
    const html = (0, $gmW3q.getDocumentElement)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $gmW3q.isWebKit)();
        if (!visualViewportBased || visualViewportBased && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $e751552376b1c971$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $e751552376b1c971$var$getBoundingClientRect(element, true, strategy === "fixed");
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $gmW3q.isHTMLElement)(element) ? $e751552376b1c971$var$getScale(element) : (0, $d9oMY.createCoords)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $e751552376b1c971$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === "viewport") rect = $e751552376b1c971$var$getViewportRect(element, strategy);
    else if (clippingAncestor === "document") rect = $e751552376b1c971$var$getDocumentRect((0, $gmW3q.getDocumentElement)(element));
    else if ((0, $gmW3q.isElement)(clippingAncestor)) rect = $e751552376b1c971$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $e751552376b1c971$var$getVisualOffsets(element);
        rect = {
            ...clippingAncestor,
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y
        };
    }
    return (0, $d9oMY.rectToClientRect)(rect);
}
function $e751552376b1c971$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $gmW3q.getParentNode)(element);
    if (parentNode === stopNode || !(0, $gmW3q.isElement)(parentNode) || (0, $gmW3q.isLastTraversableNode)(parentNode)) return false;
    return (0, $gmW3q.getComputedStyle)(parentNode).position === "fixed" || $e751552376b1c971$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $e751552376b1c971$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $gmW3q.getOverflowAncestors)(element, [], false).filter((el)=>(0, $gmW3q.isElement)(el) && (0, $gmW3q.getNodeName)(el) !== "body");
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $gmW3q.getComputedStyle)(element).position === "fixed";
    let currentNode = elementIsFixed ? (0, $gmW3q.getParentNode)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $gmW3q.isElement)(currentNode) && !(0, $gmW3q.isLastTraversableNode)(currentNode)){
        const computedStyle = (0, $gmW3q.getComputedStyle)(currentNode);
        const currentNodeIsContaining = (0, $gmW3q.isContainingBlock)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === "fixed") currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === "static" && !!currentContainingBlockComputedStyle && [
            "absolute",
            "fixed"
        ].includes(currentContainingBlockComputedStyle.position) || (0, $gmW3q.isOverflowElement)(currentNode) && !currentNodeIsContaining && $e751552376b1c971$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $gmW3q.getParentNode)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $e751552376b1c971$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === "clippingAncestors" ? (0, $gmW3q.isTopLayer)(element) ? [] : $e751552376b1c971$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $e751552376b1c971$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = (0, $d9oMY.max)(rect.top, accRect.top);
        accRect.right = (0, $d9oMY.min)(rect.right, accRect.right);
        accRect.bottom = (0, $d9oMY.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $d9oMY.max)(rect.left, accRect.left);
        return accRect;
    }, $e751552376b1c971$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function $e751552376b1c971$var$getDimensions(element) {
    const { width: width, height: height } = $e751552376b1c971$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $e751552376b1c971$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $gmW3q.isHTMLElement)(offsetParent);
    const documentElement = (0, $gmW3q.getDocumentElement)(offsetParent);
    const isFixed = strategy === "fixed";
    const rect = $e751552376b1c971$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $d9oMY.createCoords)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $gmW3q.getNodeName)(offsetParent) !== "body" || (0, $gmW3q.isOverflowElement)(documentElement)) scroll = (0, $gmW3q.getNodeScroll)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $e751552376b1c971$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
        // Firefox with layout.scrollbar.side = 3 in about:config to test this.
        offsets.x = $e751552376b1c971$var$getWindowScrollBarX(documentElement);
    }
    let htmlX = 0;
    let htmlY = 0;
    if (documentElement && !isOffsetParentAnElement && !isFixed) {
        const htmlRect = documentElement.getBoundingClientRect();
        htmlY = htmlRect.top + scroll.scrollTop;
        htmlX = htmlRect.left + scroll.scrollLeft - // RTL <body> scrollbar.
        $e751552376b1c971$var$getWindowScrollBarX(documentElement, htmlRect);
    }
    const x = rect.left + scroll.scrollLeft - offsets.x - htmlX;
    const y = rect.top + scroll.scrollTop - offsets.y - htmlY;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $e751552376b1c971$var$isStaticPositioned(element) {
    return (0, $gmW3q.getComputedStyle)(element).position === "static";
}
function $e751552376b1c971$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $gmW3q.isHTMLElement)(element) || (0, $gmW3q.getComputedStyle)(element).position === "fixed") return null;
    if (polyfill) return polyfill(element);
    let rawOffsetParent = element.offsetParent;
    // Firefox returns the <html> element as the offsetParent if it's non-static,
    // while Chrome and Safari return the <body> element. The <body> element must
    // be used to perform the correct calculations even if the <html> element is
    // non-static.
    if ((0, $gmW3q.getDocumentElement)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $e751552376b1c971$var$getOffsetParent(element, polyfill) {
    const win = (0, $gmW3q.getWindow)(element);
    if ((0, $gmW3q.isTopLayer)(element)) return win;
    if (!(0, $gmW3q.isHTMLElement)(element)) {
        let svgOffsetParent = (0, $gmW3q.getParentNode)(element);
        while(svgOffsetParent && !(0, $gmW3q.isLastTraversableNode)(svgOffsetParent)){
            if ((0, $gmW3q.isElement)(svgOffsetParent) && !$e751552376b1c971$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, $gmW3q.getParentNode)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = $e751552376b1c971$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $gmW3q.isTableElement)(offsetParent) && $e751552376b1c971$var$isStaticPositioned(offsetParent))offsetParent = $e751552376b1c971$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, $gmW3q.isLastTraversableNode)(offsetParent) && $e751552376b1c971$var$isStaticPositioned(offsetParent) && !(0, $gmW3q.isContainingBlock)(offsetParent)) return win;
    return offsetParent || (0, $gmW3q.getContainingBlock)(element) || win;
}
const $e751552376b1c971$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $e751552376b1c971$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: $e751552376b1c971$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function $e751552376b1c971$var$isRTL(element) {
    return (0, $gmW3q.getComputedStyle)(element).direction === "rtl";
}
const $e751552376b1c971$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $e751552376b1c971$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $gmW3q.getDocumentElement,
    getClippingRect: $e751552376b1c971$var$getClippingRect,
    getOffsetParent: $e751552376b1c971$var$getOffsetParent,
    getElementRects: $e751552376b1c971$var$getElementRects,
    getClientRects: $e751552376b1c971$var$getClientRects,
    getDimensions: $e751552376b1c971$var$getDimensions,
    getScale: $e751552376b1c971$var$getScale,
    isElement: $gmW3q.isElement,
    isRTL: $e751552376b1c971$var$isRTL
};
// https://samthor.au/2021/observing-dom/
function $e751552376b1c971$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $gmW3q.getDocumentElement)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const { left: left, top: top, width: width, height: height } = element.getBoundingClientRect();
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $d9oMY.floor)(top);
        const insetRight = (0, $d9oMY.floor)(root.clientWidth - (left + width));
        const insetBottom = (0, $d9oMY.floor)(root.clientHeight - (top + height));
        const insetLeft = (0, $d9oMY.floor)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $d9oMY.max)(0, (0, $d9oMY.min)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped, the ratio is 0. Throttle the refresh
                // to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $e751552376b1c971$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === "function", layoutShift: layoutShift = typeof IntersectionObserver === "function", animationFrame: animationFrame = false } = options;
    const referenceEl = $e751552376b1c971$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $gmW3q.getOverflowAncestors)(referenceEl) : [],
        ...(0, $gmW3q.getOverflowAncestors)(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener("scroll", update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener("resize", update);
    });
    const cleanupIo = referenceEl && layoutShift ? $e751552376b1c971$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $e751552376b1c971$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $e751552376b1c971$var$getBoundingClientRect(reference);
        if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener("scroll", update);
            ancestorResize && ancestor.removeEventListener("resize", update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const $e751552376b1c971$export$37b6bde19b108ecc = (0, $8JdhS.detectOverflow);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $e751552376b1c971$export$cc800923e997bb8 = (0, $8JdhS.offset);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $e751552376b1c971$export$91fb6ecbd551914 = (0, $8JdhS.autoPlacement);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $e751552376b1c971$export$fba63a578e423eb = (0, $8JdhS.shift);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $e751552376b1c971$export$8a83211c878a3f1f = (0, $8JdhS.flip);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $e751552376b1c971$export$346677f925de839c = (0, $8JdhS.size);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $e751552376b1c971$export$fe8985bb6374093c = (0, $8JdhS.hide);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $e751552376b1c971$export$f2120bbfa5450bd2 = (0, $8JdhS.arrow);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $e751552376b1c971$export$18c8ad048e32c7d5 = (0, $8JdhS.inline);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $e751552376b1c971$export$7bf07e38f3dc4b69 = (0, $8JdhS.limitShift);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $e751552376b1c971$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $e751552376b1c971$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $8JdhS.computePosition)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};

});
parcelRegister("8JdhS", function(module, exports) {

$parcel$export(module.exports, "computePosition", () => $65acd543265b7833$export$48a53dcb22e581d0);
$parcel$export(module.exports, "detectOverflow", () => $65acd543265b7833$export$37b6bde19b108ecc);
$parcel$export(module.exports, "arrow", () => $65acd543265b7833$export$f2120bbfa5450bd2);
$parcel$export(module.exports, "autoPlacement", () => $65acd543265b7833$export$91fb6ecbd551914);
$parcel$export(module.exports, "flip", () => $65acd543265b7833$export$8a83211c878a3f1f);
$parcel$export(module.exports, "hide", () => $65acd543265b7833$export$fe8985bb6374093c);
$parcel$export(module.exports, "inline", () => $65acd543265b7833$export$18c8ad048e32c7d5);
$parcel$export(module.exports, "offset", () => $65acd543265b7833$export$cc800923e997bb8);
$parcel$export(module.exports, "shift", () => $65acd543265b7833$export$fba63a578e423eb);
$parcel$export(module.exports, "limitShift", () => $65acd543265b7833$export$7bf07e38f3dc4b69);
$parcel$export(module.exports, "size", () => $65acd543265b7833$export$346677f925de839c);
$parcel$export(module.exports, "rectToClientRect", () => (parcelRequire("d9oMY")).rectToClientRect);

var $d9oMY = parcelRequire("d9oMY");
function $65acd543265b7833$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $d9oMY.getSideAxis)(placement);
    const alignmentAxis = (0, $d9oMY.getAlignmentAxis)(placement);
    const alignLength = (0, $d9oMY.getAxisLength)(alignmentAxis);
    const side = (0, $d9oMY.getSide)(placement);
    const isVertical = sideAxis === "y";
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case "top":
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case "bottom":
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case "right":
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case "left":
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $d9oMY.getAlignment)(placement)){
        case "start":
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case "end":
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $65acd543265b7833$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = "bottom", strategy: strategy = "absolute", middleware: middleware = [], platform: platform } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $65acd543265b7833$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name: name, fn: fn } = validMiddleware[i];
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = {
            ...middlewareData,
            [name]: {
                ...middlewareData[name],
                ...data
            }
        };
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === "object") {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $65acd543265b7833$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $65acd543265b7833$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = "clippingAncestors", rootBoundary: rootBoundary = "viewport", elementContext: elementContext = "floating", altBoundary: altBoundary = false, padding: padding = 0 } = (0, $d9oMY.evaluate)(options, state);
    const paddingObject = (0, $d9oMY.getPaddingObject)(padding);
    const altContext = elementContext === "floating" ? "reference" : "floating";
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $d9oMY.rectToClientRect)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === "floating" ? {
        x: x,
        y: y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $d9oMY.rectToClientRect)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $65acd543265b7833$export$f2120bbfa5450bd2 = (options)=>({
        name: "arrow",
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $d9oMY.evaluate)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $d9oMY.getPaddingObject)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $d9oMY.getAlignmentAxis)(placement);
            const length = (0, $d9oMY.getAxisLength)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === "y";
            const minProp = isYAxis ? "top" : "left";
            const maxProp = isYAxis ? "bottom" : "right";
            const clientProp = isYAxis ? "clientHeight" : "clientWidth";
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $d9oMY.min)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $d9oMY.min)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $d9oMY.clamp)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $d9oMY.getAlignment)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $65acd543265b7833$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $d9oMY.getAlignment)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $d9oMY.getAlignment)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $d9oMY.getSide)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $d9oMY.getAlignment)(placement) === alignment || (autoAlignment ? (0, $d9oMY.getOppositeAlignmentPlacement)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $65acd543265b7833$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "autoPlacement",
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $d9oMY.placements), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $d9oMY.evaluate)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $d9oMY.placements) ? $65acd543265b7833$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await $65acd543265b7833$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $d9oMY.getAlignmentSides)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $d9oMY.getSide)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $d9oMY.getAlignment)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $d9oMY.getAlignment)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $65acd543265b7833$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: "flip",
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = "bestFit", fallbackAxisSideDirection: fallbackAxisSideDirection = "none", flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $d9oMY.evaluate)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $d9oMY.getSide)(placement);
            const initialSideAxis = (0, $d9oMY.getSideAxis)(initialPlacement);
            const isBasePlacement = (0, $d9oMY.getSide)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $d9oMY.getOppositePlacement)(initialPlacement)
            ] : (0, $d9oMY.getExpandedPlacements)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== "none";
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, $d9oMY.getOppositeAxisPlacements)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await $65acd543265b7833$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $d9oMY.getAlignmentSides)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) // Try next placement and re-run the lifecycle.
                return {
                    data: {
                        index: nextIndex,
                        overflows: overflowsData
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case "bestFit":
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, $d9oMY.getSideAxis)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === "y";
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case "initialPlacement":
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $65acd543265b7833$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $65acd543265b7833$var$isAnySideFullyClipped(overflow) {
    return (0, $d9oMY.sides).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $65acd543265b7833$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "hide",
        options: options,
        async fn (state) {
            const { rects: rects } = state;
            const { strategy: strategy = "referenceHidden", ...detectOverflowOptions } = (0, $d9oMY.evaluate)(options, state);
            switch(strategy){
                case "referenceHidden":
                    {
                        const overflow = await $65acd543265b7833$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            elementContext: "reference"
                        });
                        const offsets = $65acd543265b7833$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $65acd543265b7833$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case "escaped":
                    {
                        const overflow = await $65acd543265b7833$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $65acd543265b7833$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $65acd543265b7833$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $65acd543265b7833$var$getBoundingRect(rects) {
    const minX = (0, $d9oMY.min)(...rects.map((rect)=>rect.left));
    const minY = (0, $d9oMY.min)(...rects.map((rect)=>rect.top));
    const maxX = (0, $d9oMY.max)(...rects.map((rect)=>rect.right));
    const maxY = (0, $d9oMY.max)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $65acd543265b7833$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $d9oMY.rectToClientRect)($65acd543265b7833$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $65acd543265b7833$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "inline",
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $d9oMY.evaluate)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $65acd543265b7833$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $d9oMY.rectToClientRect)($65acd543265b7833$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $d9oMY.getPaddingObject)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $d9oMY.getSideAxis)(placement) === "y") {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $d9oMY.getSide)(placement) === "top";
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $d9oMY.getSide)(placement) === "left";
                    const maxRight = (0, $d9oMY.max)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $d9oMY.min)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $65acd543265b7833$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $d9oMY.getSide)(placement);
    const alignment = (0, $d9oMY.getAlignment)(placement);
    const isVertical = (0, $d9oMY.getSideAxis)(placement) === "y";
    const mainAxisMulti = [
        "left",
        "top"
    ].includes(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $d9oMY.evaluate)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === "number" ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: rawValue.mainAxis || 0,
        crossAxis: rawValue.crossAxis || 0,
        alignmentAxis: rawValue.alignmentAxis
    };
    if (alignment && typeof alignmentAxis === "number") crossAxis = alignment === "end" ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $65acd543265b7833$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: "offset",
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $65acd543265b7833$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement: placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $65acd543265b7833$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: "shift",
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $d9oMY.evaluate)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await $65acd543265b7833$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const crossAxis = (0, $d9oMY.getSideAxis)((0, $d9oMY.getSide)(placement));
            const mainAxis = (0, $d9oMY.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === "y" ? "top" : "left";
                const maxSide = mainAxis === "y" ? "bottom" : "right";
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $d9oMY.clamp)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === "y" ? "top" : "left";
                const maxSide = crossAxis === "y" ? "bottom" : "right";
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $d9oMY.clamp)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y,
                    enabled: {
                        [mainAxis]: checkMainAxis,
                        [crossAxis]: checkCrossAxis
                    }
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $65acd543265b7833$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $d9oMY.evaluate)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $d9oMY.getSideAxis)(placement);
            const mainAxis = (0, $d9oMY.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $d9oMY.evaluate)(offset, state);
            const computedOffset = typeof rawOffset === "number" ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === "y" ? "height" : "width";
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === "y" ? "width" : "height";
                const isOriginSide = [
                    "top",
                    "left"
                ].includes((0, $d9oMY.getSide)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $65acd543265b7833$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "size",
        options: options,
        async fn (state) {
            var _state$middlewareData, _state$middlewareData2;
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $d9oMY.evaluate)(options, state);
            const overflow = await $65acd543265b7833$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const side = (0, $d9oMY.getSide)(placement);
            const alignment = (0, $d9oMY.getAlignment)(placement);
            const isYAxis = (0, $d9oMY.getSideAxis)(placement) === "y";
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === "top" || side === "bottom") {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? "start" : "end") ? "left" : "right";
            } else {
                widthSide = side;
                heightSide = alignment === "end" ? "top" : "bottom";
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, $d9oMY.min)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, $d9oMY.min)(width - overflow[widthSide], maximumClippingWidth);
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) availableWidth = maximumClippingWidth;
            if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) availableHeight = maximumClippingHeight;
            if (noShift && !alignment) {
                const xMin = (0, $d9oMY.max)(overflow.left, 0);
                const xMax = (0, $d9oMY.max)(overflow.right, 0);
                const yMin = (0, $d9oMY.max)(overflow.top, 0);
                const yMax = (0, $d9oMY.max)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $d9oMY.max)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $d9oMY.max)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};

});
parcelRegister("d9oMY", function(module, exports) {

$parcel$export(module.exports, "sides", () => $992f582e50986bd2$export$832b6fa47fa053d2);
$parcel$export(module.exports, "placements", () => $992f582e50986bd2$export$803cd8101b6c182b);
$parcel$export(module.exports, "min", () => $992f582e50986bd2$export$96ec731ed4dcb222);
$parcel$export(module.exports, "max", () => $992f582e50986bd2$export$8960430cfd85939f);
$parcel$export(module.exports, "round", () => $992f582e50986bd2$export$2077e0241d6afd3c);
$parcel$export(module.exports, "floor", () => $992f582e50986bd2$export$a3fe094919f356fd);
$parcel$export(module.exports, "createCoords", () => $992f582e50986bd2$export$a397704b5e280835);
$parcel$export(module.exports, "clamp", () => $992f582e50986bd2$export$7d15b64cf5a3a4c4);
$parcel$export(module.exports, "evaluate", () => $992f582e50986bd2$export$fef61f332f2c0afc);
$parcel$export(module.exports, "getSide", () => $992f582e50986bd2$export$3c915306cb7fc97a);
$parcel$export(module.exports, "getAlignment", () => $992f582e50986bd2$export$f0989780f32bfcda);
$parcel$export(module.exports, "getOppositeAxis", () => $992f582e50986bd2$export$8a000a963141ac32);
$parcel$export(module.exports, "getAxisLength", () => $992f582e50986bd2$export$320bd9d53520c68a);
$parcel$export(module.exports, "getSideAxis", () => $992f582e50986bd2$export$f28e8f882010718a);
$parcel$export(module.exports, "getAlignmentAxis", () => $992f582e50986bd2$export$2b57e0052a6d6d4c);
$parcel$export(module.exports, "getAlignmentSides", () => $992f582e50986bd2$export$be42861551f17911);
$parcel$export(module.exports, "getOppositePlacement", () => $992f582e50986bd2$export$9c5e28bad23365fa);
$parcel$export(module.exports, "getExpandedPlacements", () => $992f582e50986bd2$export$496432a3699e50b1);
$parcel$export(module.exports, "getOppositeAlignmentPlacement", () => $992f582e50986bd2$export$2b182c584985588b);
$parcel$export(module.exports, "getOppositeAxisPlacements", () => $992f582e50986bd2$export$a9b6fb18fd92c3ec);
$parcel$export(module.exports, "getPaddingObject", () => $992f582e50986bd2$export$598c291c29bc2e71);
$parcel$export(module.exports, "rectToClientRect", () => $992f582e50986bd2$export$ee05aea0aeecbad4);
/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ const $992f582e50986bd2$export$832b6fa47fa053d2 = [
    "top",
    "right",
    "bottom",
    "left"
];
const $992f582e50986bd2$export$27b07d8a310ed8b5 = [
    "start",
    "end"
];
const $992f582e50986bd2$export$803cd8101b6c182b = /*#__PURE__*/ $992f582e50986bd2$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $992f582e50986bd2$export$27b07d8a310ed8b5[0], side + "-" + $992f582e50986bd2$export$27b07d8a310ed8b5[1]), []);
const $992f582e50986bd2$export$96ec731ed4dcb222 = Math.min;
const $992f582e50986bd2$export$8960430cfd85939f = Math.max;
const $992f582e50986bd2$export$2077e0241d6afd3c = Math.round;
const $992f582e50986bd2$export$a3fe094919f356fd = Math.floor;
const $992f582e50986bd2$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $992f582e50986bd2$var$oppositeSideMap = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
const $992f582e50986bd2$var$oppositeAlignmentMap = {
    start: "end",
    end: "start"
};
function $992f582e50986bd2$export$7d15b64cf5a3a4c4(start, value, end) {
    return $992f582e50986bd2$export$8960430cfd85939f(start, $992f582e50986bd2$export$96ec731ed4dcb222(value, end));
}
function $992f582e50986bd2$export$fef61f332f2c0afc(value, param) {
    return typeof value === "function" ? value(param) : value;
}
function $992f582e50986bd2$export$3c915306cb7fc97a(placement) {
    return placement.split("-")[0];
}
function $992f582e50986bd2$export$f0989780f32bfcda(placement) {
    return placement.split("-")[1];
}
function $992f582e50986bd2$export$8a000a963141ac32(axis) {
    return axis === "x" ? "y" : "x";
}
function $992f582e50986bd2$export$320bd9d53520c68a(axis) {
    return axis === "y" ? "height" : "width";
}
function $992f582e50986bd2$export$f28e8f882010718a(placement) {
    return [
        "top",
        "bottom"
    ].includes($992f582e50986bd2$export$3c915306cb7fc97a(placement)) ? "y" : "x";
}
function $992f582e50986bd2$export$2b57e0052a6d6d4c(placement) {
    return $992f582e50986bd2$export$8a000a963141ac32($992f582e50986bd2$export$f28e8f882010718a(placement));
}
function $992f582e50986bd2$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $992f582e50986bd2$export$f0989780f32bfcda(placement);
    const alignmentAxis = $992f582e50986bd2$export$2b57e0052a6d6d4c(placement);
    const length = $992f582e50986bd2$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $992f582e50986bd2$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $992f582e50986bd2$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $992f582e50986bd2$export$496432a3699e50b1(placement) {
    const oppositePlacement = $992f582e50986bd2$export$9c5e28bad23365fa(placement);
    return [
        $992f582e50986bd2$export$2b182c584985588b(placement),
        oppositePlacement,
        $992f582e50986bd2$export$2b182c584985588b(oppositePlacement)
    ];
}
function $992f582e50986bd2$export$2b182c584985588b(placement) {
    return placement.replace(/start|end/g, (alignment)=>$992f582e50986bd2$var$oppositeAlignmentMap[alignment]);
}
function $992f582e50986bd2$var$getSideList(side, isStart, rtl) {
    const lr = [
        "left",
        "right"
    ];
    const rl = [
        "right",
        "left"
    ];
    const tb = [
        "top",
        "bottom"
    ];
    const bt = [
        "bottom",
        "top"
    ];
    switch(side){
        case "top":
        case "bottom":
            if (rtl) return isStart ? rl : lr;
            return isStart ? lr : rl;
        case "left":
        case "right":
            return isStart ? tb : bt;
        default:
            return [];
    }
}
function $992f582e50986bd2$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $992f582e50986bd2$export$f0989780f32bfcda(placement);
    let list = $992f582e50986bd2$var$getSideList($992f582e50986bd2$export$3c915306cb7fc97a(placement), direction === "start", rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($992f582e50986bd2$export$2b182c584985588b));
    }
    return list;
}
function $992f582e50986bd2$export$9c5e28bad23365fa(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>$992f582e50986bd2$var$oppositeSideMap[side]);
}
function $992f582e50986bd2$export$1c66dbf1a9e34223(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $992f582e50986bd2$export$598c291c29bc2e71(padding) {
    return typeof padding !== "number" ? $992f582e50986bd2$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $992f582e50986bd2$export$ee05aea0aeecbad4(rect) {
    const { x: x, y: y, width: width, height: height } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}

});


parcelRegister("gmW3q", function(module, exports) {

$parcel$export(module.exports, "getNodeName", () => $beabbbc26ce8dd61$export$651544f548703224);
$parcel$export(module.exports, "getWindow", () => $beabbbc26ce8dd61$export$38b2d434cce3ea22);
$parcel$export(module.exports, "getDocumentElement", () => $beabbbc26ce8dd61$export$e495491855dc5418);
$parcel$export(module.exports, "isElement", () => $beabbbc26ce8dd61$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isHTMLElement", () => $beabbbc26ce8dd61$export$1b3bfaa9684536aa);
$parcel$export(module.exports, "isShadowRoot", () => $beabbbc26ce8dd61$export$af51f0f06c0f328a);
$parcel$export(module.exports, "isOverflowElement", () => $beabbbc26ce8dd61$export$989e911fa9af580a);
$parcel$export(module.exports, "getComputedStyle", () => $beabbbc26ce8dd61$export$3735103072e4a80);
$parcel$export(module.exports, "isTableElement", () => $beabbbc26ce8dd61$export$71535ffaa902797f);
$parcel$export(module.exports, "isTopLayer", () => $beabbbc26ce8dd61$export$89e651af02346cd4);
$parcel$export(module.exports, "isContainingBlock", () => $beabbbc26ce8dd61$export$d6c4e8150c35fed1);
$parcel$export(module.exports, "isWebKit", () => $beabbbc26ce8dd61$export$78551043582a6a98);
$parcel$export(module.exports, "getContainingBlock", () => $beabbbc26ce8dd61$export$940d8225183e1404);
$parcel$export(module.exports, "getParentNode", () => $beabbbc26ce8dd61$export$4e12058fc4d51d56);
$parcel$export(module.exports, "isLastTraversableNode", () => $beabbbc26ce8dd61$export$d1162fb0b6d4cd51);
$parcel$export(module.exports, "getNodeScroll", () => $beabbbc26ce8dd61$export$dc8fc79fa2800137);
$parcel$export(module.exports, "getOverflowAncestors", () => $beabbbc26ce8dd61$export$3b57c1601291186b);
$parcel$export(module.exports, "getFrameElement", () => $beabbbc26ce8dd61$export$7bf1f8740e3e34af);
function $beabbbc26ce8dd61$var$hasWindow() {
    return typeof window !== "undefined";
}
function $beabbbc26ce8dd61$export$651544f548703224(node) {
    if ($beabbbc26ce8dd61$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || "").toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return "#document";
}
function $beabbbc26ce8dd61$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $beabbbc26ce8dd61$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($beabbbc26ce8dd61$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $beabbbc26ce8dd61$export$8ee0fc9ee280b4ee(value) {
    if (!$beabbbc26ce8dd61$var$hasWindow()) return false;
    return value instanceof Node || value instanceof $beabbbc26ce8dd61$export$38b2d434cce3ea22(value).Node;
}
function $beabbbc26ce8dd61$export$45a5e7f76e0caa8d(value) {
    if (!$beabbbc26ce8dd61$var$hasWindow()) return false;
    return value instanceof Element || value instanceof $beabbbc26ce8dd61$export$38b2d434cce3ea22(value).Element;
}
function $beabbbc26ce8dd61$export$1b3bfaa9684536aa(value) {
    if (!$beabbbc26ce8dd61$var$hasWindow()) return false;
    return value instanceof HTMLElement || value instanceof $beabbbc26ce8dd61$export$38b2d434cce3ea22(value).HTMLElement;
}
function $beabbbc26ce8dd61$export$af51f0f06c0f328a(value) {
    if (!$beabbbc26ce8dd61$var$hasWindow() || typeof ShadowRoot === "undefined") return false;
    return value instanceof ShadowRoot || value instanceof $beabbbc26ce8dd61$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $beabbbc26ce8dd61$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $beabbbc26ce8dd61$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
        "inline",
        "contents"
    ].includes(display);
}
function $beabbbc26ce8dd61$export$71535ffaa902797f(element) {
    return [
        "table",
        "td",
        "th"
    ].includes($beabbbc26ce8dd61$export$651544f548703224(element));
}
function $beabbbc26ce8dd61$export$89e651af02346cd4(element) {
    return [
        ":popover-open",
        ":modal"
    ].some((selector)=>{
        try {
            return element.matches(selector);
        } catch (e) {
            return false;
        }
    });
}
function $beabbbc26ce8dd61$export$d6c4e8150c35fed1(elementOrCss) {
    const webkit = $beabbbc26ce8dd61$export$78551043582a6a98();
    const css = $beabbbc26ce8dd61$export$45a5e7f76e0caa8d(elementOrCss) ? $beabbbc26ce8dd61$export$3735103072e4a80(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    return css.transform !== "none" || css.perspective !== "none" || (css.containerType ? css.containerType !== "normal" : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== "none" : false) || !webkit && (css.filter ? css.filter !== "none" : false) || [
        "transform",
        "perspective",
        "filter"
    ].some((value)=>(css.willChange || "").includes(value)) || [
        "paint",
        "layout",
        "strict",
        "content"
    ].some((value)=>(css.contain || "").includes(value));
}
function $beabbbc26ce8dd61$export$940d8225183e1404(element) {
    let currentNode = $beabbbc26ce8dd61$export$4e12058fc4d51d56(element);
    while($beabbbc26ce8dd61$export$1b3bfaa9684536aa(currentNode) && !$beabbbc26ce8dd61$export$d1162fb0b6d4cd51(currentNode)){
        if ($beabbbc26ce8dd61$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else if ($beabbbc26ce8dd61$export$89e651af02346cd4(currentNode)) return null;
        currentNode = $beabbbc26ce8dd61$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $beabbbc26ce8dd61$export$78551043582a6a98() {
    if (typeof CSS === "undefined" || !CSS.supports) return false;
    return CSS.supports("-webkit-backdrop-filter", "none");
}
function $beabbbc26ce8dd61$export$d1162fb0b6d4cd51(node) {
    return [
        "html",
        "body",
        "#document"
    ].includes($beabbbc26ce8dd61$export$651544f548703224(node));
}
function $beabbbc26ce8dd61$export$3735103072e4a80(element) {
    return $beabbbc26ce8dd61$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $beabbbc26ce8dd61$export$dc8fc79fa2800137(element) {
    if ($beabbbc26ce8dd61$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function $beabbbc26ce8dd61$export$4e12058fc4d51d56(node) {
    if ($beabbbc26ce8dd61$export$651544f548703224(node) === "html") return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $beabbbc26ce8dd61$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $beabbbc26ce8dd61$export$e495491855dc5418(node);
    return $beabbbc26ce8dd61$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $beabbbc26ce8dd61$export$7cd01a57c8ca906c(node) {
    const parentNode = $beabbbc26ce8dd61$export$4e12058fc4d51d56(node);
    if ($beabbbc26ce8dd61$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($beabbbc26ce8dd61$export$1b3bfaa9684536aa(parentNode) && $beabbbc26ce8dd61$export$989e911fa9af580a(parentNode)) return parentNode;
    return $beabbbc26ce8dd61$export$7cd01a57c8ca906c(parentNode);
}
function $beabbbc26ce8dd61$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $beabbbc26ce8dd61$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $beabbbc26ce8dd61$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) {
        const frameElement = $beabbbc26ce8dd61$export$7bf1f8740e3e34af(win);
        return list.concat(win, win.visualViewport || [], $beabbbc26ce8dd61$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $beabbbc26ce8dd61$export$3b57c1601291186b(frameElement) : []);
    }
    return list.concat(scrollableAncestor, $beabbbc26ce8dd61$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}
function $beabbbc26ce8dd61$export$7bf1f8740e3e34af(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}

});


parcelRegister("2llq8", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b4e289d81b1b97d$export$2e2bcd8739ae039);

var $kc00y = parcelRequire("kc00y");
var $1b4e289d81b1b97d$var$index = (0, $kc00y.useLayoutEffect);
var $1b4e289d81b1b97d$export$2e2bcd8739ae039 = $1b4e289d81b1b97d$var$index;

});


parcelRegister("cyAAA", function(module, exports) {

$parcel$export(module.exports, "c", () => $92450adb7721f685$export$db3b6bfb95261072);
$parcel$export(module.exports, "S", () => $92450adb7721f685$export$25ce5a424b770e84);

var $cGuNc = parcelRequire("cGuNc");

var $9CGAW = parcelRequire("9CGAW");

var $9gCub = parcelRequire("9gCub");

var $eFvpO = parcelRequire("eFvpO");

var $jLEtS = parcelRequire("jLEtS");

var $35KA5 = parcelRequire("35KA5");

var $4n3CF = parcelRequire("4n3CF");

var $kc00y = parcelRequire("kc00y");

var $kXior = parcelRequire("kXior");

var $f9nE2 = parcelRequire("f9nE2");

var $1SPyn = parcelRequire("1SPyn");

var $lTjB2 = parcelRequire("lTjB2");
function $92450adb7721f685$var$_EMOTION_STRINGIFIED_CSS_ERROR__$2() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Assistive text to describe visual elements. Hidden for sighted users.
var $92450adb7721f685$var$_ref = {
    name: "7pg0cj-a11yText",
    styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
};
var $92450adb7721f685$var$A11yText = function A11yText(props) {
    return (0, $f9nE2.jsx)("span", (0, $cGuNc.default)({
        css: $92450adb7721f685$var$_ref
    }, props));
};
var $92450adb7721f685$var$A11yText$1 = $92450adb7721f685$var$A11yText;
var $92450adb7721f685$var$defaultAriaLiveMessages = {
    guidance: function guidance(props) {
        var isSearchable = props.isSearchable, isMulti = props.isMulti, tabSelectsValue = props.tabSelectsValue, context = props.context, isInitialFocus = props.isInitialFocus;
        switch(context){
            case "menu":
                return "Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu".concat(tabSelectsValue ? ", press Tab to select the option and exit the menu" : "", ".");
            case "input":
                return isInitialFocus ? "".concat(props["aria-label"] || "Select", " is focused ").concat(isSearchable ? ",type to refine list" : "", ", press Down to open the menu, ").concat(isMulti ? " press left to focus selected values" : "") : "";
            case "value":
                return "Use left and right to toggle between focused values, press Backspace to remove the currently focused value";
            default:
                return "";
        }
    },
    onChange: function onChange(props) {
        var action = props.action, _props$label = props.label, label = _props$label === void 0 ? "" : _props$label, labels = props.labels, isDisabled = props.isDisabled;
        switch(action){
            case "deselect-option":
            case "pop-value":
            case "remove-value":
                return "option ".concat(label, ", deselected.");
            case "clear":
                return "All selected options have been cleared.";
            case "initial-input-focus":
                return "option".concat(labels.length > 1 ? "s" : "", " ").concat(labels.join(","), ", selected.");
            case "select-option":
                return isDisabled ? "option ".concat(label, " is disabled. Select another option.") : "option ".concat(label, ", selected.");
            default:
                return "";
        }
    },
    onFocus: function onFocus(props) {
        var context = props.context, focused = props.focused, options = props.options, _props$label2 = props.label, label = _props$label2 === void 0 ? "" : _props$label2, selectValue = props.selectValue, isDisabled = props.isDisabled, isSelected = props.isSelected, isAppleDevice = props.isAppleDevice;
        var getArrayIndex = function getArrayIndex(arr, item) {
            return arr && arr.length ? "".concat(arr.indexOf(item) + 1, " of ").concat(arr.length) : "";
        };
        if (context === "value" && selectValue) return "value ".concat(label, " focused, ").concat(getArrayIndex(selectValue, focused), ".");
        if (context === "menu" && isAppleDevice) {
            var disabled = isDisabled ? " disabled" : "";
            var status = "".concat(isSelected ? " selected" : "").concat(disabled);
            return "".concat(label).concat(status, ", ").concat(getArrayIndex(options, focused), ".");
        }
        return "";
    },
    onFilter: function onFilter(props) {
        var inputValue = props.inputValue, resultsMessage = props.resultsMessage;
        return "".concat(resultsMessage).concat(inputValue ? " for search term " + inputValue : "", ".");
    }
};
var $92450adb7721f685$var$LiveRegion = function LiveRegion(props) {
    var ariaSelection = props.ariaSelection, focusedOption = props.focusedOption, focusedValue = props.focusedValue, focusableOptions = props.focusableOptions, isFocused = props.isFocused, selectValue = props.selectValue, selectProps = props.selectProps, id = props.id, isAppleDevice = props.isAppleDevice;
    var ariaLiveMessages = selectProps.ariaLiveMessages, getOptionLabel = selectProps.getOptionLabel, inputValue = selectProps.inputValue, isMulti = selectProps.isMulti, isOptionDisabled = selectProps.isOptionDisabled, isSearchable = selectProps.isSearchable, menuIsOpen = selectProps.menuIsOpen, options = selectProps.options, screenReaderStatus = selectProps.screenReaderStatus, tabSelectsValue = selectProps.tabSelectsValue, isLoading = selectProps.isLoading;
    var ariaLabel = selectProps["aria-label"];
    var ariaLive = selectProps["aria-live"];
    // Update aria live message configuration when prop changes
    var messages = (0, $kc00y.useMemo)(function() {
        return (0, $9CGAW.default)((0, $9CGAW.default)({}, $92450adb7721f685$var$defaultAriaLiveMessages), ariaLiveMessages || {});
    }, [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    var ariaSelected = (0, $kc00y.useMemo)(function() {
        var message = "";
        if (ariaSelection && messages.onChange) {
            var option = ariaSelection.option, selectedOptions = ariaSelection.options, removedValue = ariaSelection.removedValue, removedValues = ariaSelection.removedValues, value = ariaSelection.value;
            // select-option when !isMulti does not return option so we assume selected option is value
            var asOption = function asOption(val) {
                return !Array.isArray(val) ? val : null;
            };
            // If there is just one item from the action then get its label
            var selected = removedValue || option || asOption(value);
            var label = selected ? getOptionLabel(selected) : "";
            // If there are multiple items from the action then return an array of labels
            var multiSelected = selectedOptions || removedValues || undefined;
            var labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            var onChangeProps = (0, $9CGAW.default)({
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels
            }, ariaSelection);
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel
    ]);
    var ariaFocused = (0, $kc00y.useMemo)(function() {
        var focusMsg = "";
        var focused = focusedOption || focusedValue;
        var isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
        if (focused && messages.onFocus) {
            var onFocusProps = {
                focused: focused,
                label: getOptionLabel(focused),
                isDisabled: isOptionDisabled(focused, selectValue),
                isSelected: isSelected,
                options: focusableOptions,
                context: focused === focusedOption ? "menu" : "value",
                selectValue: selectValue,
                isAppleDevice: isAppleDevice
            };
            focusMsg = messages.onFocus(onFocusProps);
        }
        return focusMsg;
    }, [
        focusedOption,
        focusedValue,
        getOptionLabel,
        isOptionDisabled,
        messages,
        focusableOptions,
        selectValue,
        isAppleDevice
    ]);
    var ariaResults = (0, $kc00y.useMemo)(function() {
        var resultsMsg = "";
        if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
            var resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus,
        isLoading
    ]);
    var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === "initial-input-focus";
    var ariaGuidance = (0, $kc00y.useMemo)(function() {
        var guidanceMsg = "";
        if (messages.guidance) {
            var context = focusedValue ? "value" : menuIsOpen ? "menu" : "input";
            guidanceMsg = messages.guidance({
                "aria-label": ariaLabel,
                context: context,
                isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
                isMulti: isMulti,
                isSearchable: isSearchable,
                tabSelectsValue: tabSelectsValue,
                isInitialFocus: isInitialFocus
            });
        }
        return guidanceMsg;
    }, [
        ariaLabel,
        focusedOption,
        focusedValue,
        isMulti,
        isOptionDisabled,
        isSearchable,
        menuIsOpen,
        messages,
        selectValue,
        tabSelectsValue,
        isInitialFocus
    ]);
    var ScreenReaderText = (0, $f9nE2.jsx)((0, $kc00y.Fragment), null, (0, $f9nE2.jsx)("span", {
        id: "aria-selection"
    }, ariaSelected), (0, $f9nE2.jsx)("span", {
        id: "aria-focused"
    }, ariaFocused), (0, $f9nE2.jsx)("span", {
        id: "aria-results"
    }, ariaResults), (0, $f9nE2.jsx)("span", {
        id: "aria-guidance"
    }, ariaGuidance));
    return (0, $f9nE2.jsx)((0, $kc00y.Fragment), null, (0, $f9nE2.jsx)($92450adb7721f685$var$A11yText$1, {
        id: id
    }, isInitialFocus && ScreenReaderText), (0, $f9nE2.jsx)($92450adb7721f685$var$A11yText$1, {
        "aria-live": ariaLive,
        "aria-atomic": "false",
        "aria-relevant": "additions text",
        role: "log"
    }, isFocused && !isInitialFocus && ScreenReaderText));
};
var $92450adb7721f685$var$LiveRegion$1 = $92450adb7721f685$var$LiveRegion;
var $92450adb7721f685$var$diacritics = [
    {
        base: "A",
        letters: "A\u24B6\uFF21\xc0\xc1\xc2\u1EA6\u1EA4\u1EAA\u1EA8\xc3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xc4\u01DE\u1EA2\xc5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
    },
    {
        base: "AA",
        letters: "\uA732"
    },
    {
        base: "AE",
        letters: "\xc6\u01FC\u01E2"
    },
    {
        base: "AO",
        letters: "\uA734"
    },
    {
        base: "AU",
        letters: "\uA736"
    },
    {
        base: "AV",
        letters: "\uA738\uA73A"
    },
    {
        base: "AY",
        letters: "\uA73C"
    },
    {
        base: "B",
        letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
    },
    {
        base: "C",
        letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xc7\u1E08\u0187\u023B\uA73E"
    },
    {
        base: "D",
        letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
    },
    {
        base: "DZ",
        letters: "\u01F1\u01C4"
    },
    {
        base: "Dz",
        letters: "\u01F2\u01C5"
    },
    {
        base: "E",
        letters: "E\u24BA\uFF25\xc8\xc9\xca\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xcb\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
    },
    {
        base: "F",
        letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
    },
    {
        base: "G",
        letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
    },
    {
        base: "H",
        letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
    },
    {
        base: "I",
        letters: "I\u24BE\uFF29\xcc\xcd\xce\u0128\u012A\u012C\u0130\xcf\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
    },
    {
        base: "J",
        letters: "J\u24BF\uFF2A\u0134\u0248"
    },
    {
        base: "K",
        letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
    },
    {
        base: "L",
        letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
    },
    {
        base: "LJ",
        letters: "\u01C7"
    },
    {
        base: "Lj",
        letters: "\u01C8"
    },
    {
        base: "M",
        letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
    },
    {
        base: "N",
        letters: "N\u24C3\uFF2E\u01F8\u0143\xd1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
    },
    {
        base: "NJ",
        letters: "\u01CA"
    },
    {
        base: "Nj",
        letters: "\u01CB"
    },
    {
        base: "O",
        letters: "O\u24C4\uFF2F\xd2\xd3\xd4\u1ED2\u1ED0\u1ED6\u1ED4\xd5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xd6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xd8\u01FE\u0186\u019F\uA74A\uA74C"
    },
    {
        base: "OI",
        letters: "\u01A2"
    },
    {
        base: "OO",
        letters: "\uA74E"
    },
    {
        base: "OU",
        letters: "\u0222"
    },
    {
        base: "P",
        letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
    },
    {
        base: "Q",
        letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
    },
    {
        base: "R",
        letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
    },
    {
        base: "S",
        letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
    },
    {
        base: "T",
        letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
    },
    {
        base: "TZ",
        letters: "\uA728"
    },
    {
        base: "U",
        letters: "U\u24CA\uFF35\xd9\xda\xdb\u0168\u1E78\u016A\u1E7A\u016C\xdc\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
    },
    {
        base: "V",
        letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
    },
    {
        base: "VY",
        letters: "\uA760"
    },
    {
        base: "W",
        letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
    },
    {
        base: "X",
        letters: "X\u24CD\uFF38\u1E8A\u1E8C"
    },
    {
        base: "Y",
        letters: "Y\u24CE\uFF39\u1EF2\xdd\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
    },
    {
        base: "Z",
        letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
    },
    {
        base: "a",
        letters: "a\u24D0\uFF41\u1E9A\xe0\xe1\xe2\u1EA7\u1EA5\u1EAB\u1EA9\xe3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xe4\u01DF\u1EA3\xe5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
    },
    {
        base: "aa",
        letters: "\uA733"
    },
    {
        base: "ae",
        letters: "\xe6\u01FD\u01E3"
    },
    {
        base: "ao",
        letters: "\uA735"
    },
    {
        base: "au",
        letters: "\uA737"
    },
    {
        base: "av",
        letters: "\uA739\uA73B"
    },
    {
        base: "ay",
        letters: "\uA73D"
    },
    {
        base: "b",
        letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
    },
    {
        base: "c",
        letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xe7\u1E09\u0188\u023C\uA73F\u2184"
    },
    {
        base: "d",
        letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
    },
    {
        base: "dz",
        letters: "\u01F3\u01C6"
    },
    {
        base: "e",
        letters: "e\u24D4\uFF45\xe8\xe9\xea\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xeb\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
    },
    {
        base: "f",
        letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
    },
    {
        base: "g",
        letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
    },
    {
        base: "h",
        letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
    },
    {
        base: "hv",
        letters: "\u0195"
    },
    {
        base: "i",
        letters: "i\u24D8\uFF49\xec\xed\xee\u0129\u012B\u012D\xef\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
    },
    {
        base: "j",
        letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
    },
    {
        base: "k",
        letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
    },
    {
        base: "l",
        letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
    },
    {
        base: "lj",
        letters: "\u01C9"
    },
    {
        base: "m",
        letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
    },
    {
        base: "n",
        letters: "n\u24DD\uFF4E\u01F9\u0144\xf1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
    },
    {
        base: "nj",
        letters: "\u01CC"
    },
    {
        base: "o",
        letters: "o\u24DE\uFF4F\xf2\xf3\xf4\u1ED3\u1ED1\u1ED7\u1ED5\xf5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xf6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xf8\u01FF\u0254\uA74B\uA74D\u0275"
    },
    {
        base: "oi",
        letters: "\u01A3"
    },
    {
        base: "ou",
        letters: "\u0223"
    },
    {
        base: "oo",
        letters: "\uA74F"
    },
    {
        base: "p",
        letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
    },
    {
        base: "q",
        letters: "q\u24E0\uFF51\u024B\uA757\uA759"
    },
    {
        base: "r",
        letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
    },
    {
        base: "s",
        letters: "s\u24E2\uFF53\xdf\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
    },
    {
        base: "t",
        letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
    },
    {
        base: "tz",
        letters: "\uA729"
    },
    {
        base: "u",
        letters: "u\u24E4\uFF55\xf9\xfa\xfb\u0169\u1E79\u016B\u1E7B\u016D\xfc\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
    },
    {
        base: "v",
        letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
    },
    {
        base: "vy",
        letters: "\uA761"
    },
    {
        base: "w",
        letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
    },
    {
        base: "x",
        letters: "x\u24E7\uFF58\u1E8B\u1E8D"
    },
    {
        base: "y",
        letters: "y\u24E8\uFF59\u1EF3\xfd\u0177\u1EF9\u0233\u1E8F\xff\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
    },
    {
        base: "z",
        letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
    }
];
var $92450adb7721f685$var$anyDiacritic = new RegExp("[" + $92450adb7721f685$var$diacritics.map(function(d) {
    return d.letters;
}).join("") + "]", "g");
var $92450adb7721f685$var$diacriticToBase = {};
for(var $92450adb7721f685$var$i = 0; $92450adb7721f685$var$i < $92450adb7721f685$var$diacritics.length; $92450adb7721f685$var$i++){
    var $92450adb7721f685$var$diacritic = $92450adb7721f685$var$diacritics[$92450adb7721f685$var$i];
    for(var $92450adb7721f685$var$j = 0; $92450adb7721f685$var$j < $92450adb7721f685$var$diacritic.letters.length; $92450adb7721f685$var$j++)$92450adb7721f685$var$diacriticToBase[$92450adb7721f685$var$diacritic.letters[$92450adb7721f685$var$j]] = $92450adb7721f685$var$diacritic.base;
}
var $92450adb7721f685$var$stripDiacritics = function stripDiacritics(str) {
    return str.replace($92450adb7721f685$var$anyDiacritic, function(match) {
        return $92450adb7721f685$var$diacriticToBase[match];
    });
};
var $92450adb7721f685$var$memoizedStripDiacriticsForInput = (0, $1SPyn.default)($92450adb7721f685$var$stripDiacritics);
var $92450adb7721f685$var$trimString = function trimString(str) {
    return str.replace(/^\s+|\s+$/g, "");
};
var $92450adb7721f685$var$defaultStringify = function defaultStringify(option) {
    return "".concat(option.label, " ").concat(option.value);
};
var $92450adb7721f685$export$db3b6bfb95261072 = function createFilter(config) {
    return function(option, rawInput) {
        // eslint-disable-next-line no-underscore-dangle
        if (option.data.__isNew__) return true;
        var _ignoreCase$ignoreAcc = (0, $9CGAW.default)({
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $92450adb7721f685$var$defaultStringify,
            trim: true,
            matchFrom: "any"
        }, config), ignoreCase = _ignoreCase$ignoreAcc.ignoreCase, ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents, stringify = _ignoreCase$ignoreAcc.stringify, trim = _ignoreCase$ignoreAcc.trim, matchFrom = _ignoreCase$ignoreAcc.matchFrom;
        var input = trim ? $92450adb7721f685$var$trimString(rawInput) : rawInput;
        var candidate = trim ? $92450adb7721f685$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $92450adb7721f685$var$memoizedStripDiacriticsForInput(input);
            candidate = $92450adb7721f685$var$stripDiacritics(candidate);
        }
        return matchFrom === "start" ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };
};
var $92450adb7721f685$var$_excluded = [
    "innerRef"
];
function $92450adb7721f685$var$DummyInput(_ref) {
    var innerRef = _ref.innerRef, props = (0, $lTjB2.default)(_ref, $92450adb7721f685$var$_excluded);
    // Remove animation props not meant for HTML elements
    var filteredProps = (0, $kXior.r)(props, "onExited", "in", "enter", "exit", "appear");
    return (0, $f9nE2.jsx)("input", (0, $cGuNc.default)({
        ref: innerRef
    }, filteredProps, {
        css: /*#__PURE__*/ (0, $f9nE2.css)({
            label: "dummyInput",
            // get rid of any default styles
            background: 0,
            border: 0,
            // important! this hides the flashing cursor
            caretColor: "transparent",
            fontSize: "inherit",
            gridArea: "1 / 1 / 2 / 3",
            outline: 0,
            padding: 0,
            // important! without `width` browsers won't allow focus
            width: 1,
            // remove cursor on desktop
            color: "transparent",
            // remove cursor on mobile whilst maintaining "scroll into view" behaviour
            left: -100,
            opacity: 0,
            position: "relative",
            transform: "scale(.01)"
        }, "", "")
    }));
}
var $92450adb7721f685$var$cancelScroll = function cancelScroll(event) {
    if (event.cancelable) event.preventDefault();
    event.stopPropagation();
};
function $92450adb7721f685$var$useScrollCapture(_ref) {
    var isEnabled = _ref.isEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var isBottom = (0, $kc00y.useRef)(false);
    var isTop = (0, $kc00y.useRef)(false);
    var touchStart = (0, $kc00y.useRef)(0);
    var scrollTarget = (0, $kc00y.useRef)(null);
    var handleEventDelta = (0, $kc00y.useCallback)(function(event, delta) {
        if (scrollTarget.current === null) return;
        var _scrollTarget$current = scrollTarget.current, scrollTop = _scrollTarget$current.scrollTop, scrollHeight = _scrollTarget$current.scrollHeight, clientHeight = _scrollTarget$current.clientHeight;
        var target = scrollTarget.current;
        var isDeltaPositive = delta > 0;
        var availableScroll = scrollHeight - clientHeight - scrollTop;
        var shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) $92450adb7721f685$var$cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    var onWheel = (0, $kc00y.useCallback)(function(event) {
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    var onTouchStart = (0, $kc00y.useCallback)(function(event) {
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    var onTouchMove = (0, $kc00y.useCallback)(function(event) {
        var deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    var startListening = (0, $kc00y.useCallback)(function(el) {
        // bail early if no element is available to attach to
        if (!el) return;
        var notPassive = (0, $kXior.s) ? {
            passive: false
        } : false;
        el.addEventListener("wheel", onWheel, notPassive);
        el.addEventListener("touchstart", onTouchStart, notPassive);
        el.addEventListener("touchmove", onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    var stopListening = (0, $kc00y.useCallback)(function(el) {
        // bail early if no element is available to detach from
        if (!el) return;
        el.removeEventListener("wheel", onWheel, false);
        el.removeEventListener("touchstart", onTouchStart, false);
        el.removeEventListener("touchmove", onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $kc00y.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        startListening(element);
        return function() {
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
var $92450adb7721f685$var$STYLE_KEYS = [
    "boxSizing",
    "height",
    "overflow",
    "paddingRight",
    "position"
];
var $92450adb7721f685$var$LOCK_STYLES = {
    boxSizing: "border-box",
    // account for possible declaration `width: 100%;` on body
    overflow: "hidden",
    position: "relative",
    height: "100%"
};
function $92450adb7721f685$var$preventTouchMove(e) {
    e.preventDefault();
}
function $92450adb7721f685$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $92450adb7721f685$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $92450adb7721f685$var$isTouchDevice() {
    return "ontouchstart" in window || navigator.maxTouchPoints;
}
var $92450adb7721f685$var$canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
var $92450adb7721f685$var$activeScrollLocks = 0;
var $92450adb7721f685$var$listenerOptions = {
    capture: false,
    passive: false
};
function $92450adb7721f685$var$useScrollLock(_ref) {
    var isEnabled = _ref.isEnabled, _ref$accountForScroll = _ref.accountForScrollbars, accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
    var originalStyles = (0, $kc00y.useRef)({});
    var scrollTarget = (0, $kc00y.useRef)(null);
    var addScrollLock = (0, $kc00y.useCallback)(function(touchScrollTarget) {
        if (!$92450adb7721f685$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $92450adb7721f685$var$STYLE_KEYS.forEach(function(key) {
            var val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $92450adb7721f685$var$activeScrollLocks < 1) {
            var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            var clientWidth = document.body ? document.body.clientWidth : 0;
            var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($92450adb7721f685$var$LOCK_STYLES).forEach(function(key) {
                var val = $92450adb7721f685$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = "".concat(adjustedPadding, "px");
        }
        // account for touch devices
        if (target && $92450adb7721f685$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            target.addEventListener("touchmove", $92450adb7721f685$var$preventTouchMove, $92450adb7721f685$var$listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                touchScrollTarget.addEventListener("touchstart", $92450adb7721f685$var$preventInertiaScroll, $92450adb7721f685$var$listenerOptions);
                touchScrollTarget.addEventListener("touchmove", $92450adb7721f685$var$allowTouchMove, $92450adb7721f685$var$listenerOptions);
            }
        }
        // increment active scroll locks
        $92450adb7721f685$var$activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    var removeScrollLock = (0, $kc00y.useCallback)(function(touchScrollTarget) {
        if (!$92450adb7721f685$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        // safely decrement active scroll locks
        $92450adb7721f685$var$activeScrollLocks = Math.max($92450adb7721f685$var$activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && $92450adb7721f685$var$activeScrollLocks < 1) $92450adb7721f685$var$STYLE_KEYS.forEach(function(key) {
            var val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && $92450adb7721f685$var$isTouchDevice()) {
            target.removeEventListener("touchmove", $92450adb7721f685$var$preventTouchMove, $92450adb7721f685$var$listenerOptions);
            if (touchScrollTarget) {
                touchScrollTarget.removeEventListener("touchstart", $92450adb7721f685$var$preventInertiaScroll, $92450adb7721f685$var$listenerOptions);
                touchScrollTarget.removeEventListener("touchmove", $92450adb7721f685$var$allowTouchMove, $92450adb7721f685$var$listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, $kc00y.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        addScrollLock(element);
        return function() {
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
function $92450adb7721f685$var$_EMOTION_STRINGIFIED_CSS_ERROR__$1() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $92450adb7721f685$var$blurSelectInput = function blurSelectInput(event) {
    var element = event.target;
    return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
};
var $92450adb7721f685$var$_ref2$1 = {
    name: "1kfdb0e",
    styles: "position:fixed;left:0;bottom:0;right:0;top:0"
};
function $92450adb7721f685$var$ScrollManager(_ref) {
    var children = _ref.children, lockEnabled = _ref.lockEnabled, _ref$captureEnabled = _ref.captureEnabled, captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var setScrollCaptureTarget = $92450adb7721f685$var$useScrollCapture({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    var setScrollLockTarget = $92450adb7721f685$var$useScrollLock({
        isEnabled: lockEnabled
    });
    var targetRef = function targetRef(element) {
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return (0, $f9nE2.jsx)((0, $kc00y.Fragment), null, lockEnabled && (0, $f9nE2.jsx)("div", {
        onClick: $92450adb7721f685$var$blurSelectInput,
        css: $92450adb7721f685$var$_ref2$1
    }), children(targetRef));
}
function $92450adb7721f685$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $92450adb7721f685$var$_ref2 = {
    name: "1a0ro4n-requiredInput",
    styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
};
var $92450adb7721f685$var$RequiredInput = function RequiredInput(_ref) {
    var name = _ref.name, onFocus = _ref.onFocus;
    return (0, $f9nE2.jsx)("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        onFocus: onFocus,
        css: $92450adb7721f685$var$_ref2,
        value: "",
        onChange: function onChange() {}
    });
};
var $92450adb7721f685$var$RequiredInput$1 = $92450adb7721f685$var$RequiredInput;
/// <reference types="user-agent-data-types" />
function $92450adb7721f685$var$testPlatform(re) {
    var _window$navigator$use;
    return typeof window !== "undefined" && window.navigator != null ? re.test(((_window$navigator$use = window.navigator["userAgentData"]) === null || _window$navigator$use === void 0 ? void 0 : _window$navigator$use.platform) || window.navigator.platform) : false;
}
function $92450adb7721f685$var$isIPhone() {
    return $92450adb7721f685$var$testPlatform(/^iPhone/i);
}
function $92450adb7721f685$var$isMac() {
    return $92450adb7721f685$var$testPlatform(/^Mac/i);
}
function $92450adb7721f685$var$isIPad() {
    return $92450adb7721f685$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    $92450adb7721f685$var$isMac() && navigator.maxTouchPoints > 1;
}
function $92450adb7721f685$var$isIOS() {
    return $92450adb7721f685$var$isIPhone() || $92450adb7721f685$var$isIPad();
}
function $92450adb7721f685$var$isAppleDevice() {
    return $92450adb7721f685$var$isMac() || $92450adb7721f685$var$isIOS();
}
var $92450adb7721f685$var$formatGroupLabel = function formatGroupLabel(group) {
    return group.label;
};
var $92450adb7721f685$export$8b22cf2602fb60ce = function getOptionLabel(option) {
    return option.label;
};
var $92450adb7721f685$export$39b482c5e57630a8 = function getOptionValue(option) {
    return option.value;
};
var $92450adb7721f685$var$isOptionDisabled = function isOptionDisabled(option) {
    return !!option.isDisabled;
};
var $92450adb7721f685$var$defaultStyles = {
    clearIndicator: (0, $kXior.a),
    container: (0, $kXior.b),
    control: (0, $kXior.d),
    dropdownIndicator: (0, $kXior.e),
    group: (0, $kXior.g),
    groupHeading: (0, $kXior.f),
    indicatorsContainer: (0, $kXior.i),
    indicatorSeparator: (0, $kXior.h),
    input: (0, $kXior.j),
    loadingIndicator: (0, $kXior.l),
    loadingMessage: (0, $kXior.k),
    menu: (0, $kXior.m),
    menuList: (0, $kXior.n),
    menuPortal: (0, $kXior.o),
    multiValue: (0, $kXior.p),
    multiValueLabel: (0, $kXior.q),
    multiValueRemove: (0, $kXior.t),
    noOptionsMessage: (0, $kXior.u),
    option: (0, $kXior.v),
    placeholder: (0, $kXior.w),
    singleValue: (0, $kXior.x),
    valueContainer: (0, $kXior.y)
};
// Merge Utility
// Allows consumers to extend a base Select with additional styles
function $92450adb7721f685$export$953cecd6e717a553(source) {
    var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // initialize with source styles
    var styles = (0, $9CGAW.default)({}, source);
    // massage in target styles
    Object.keys(target).forEach(function(keyAsString) {
        var key = keyAsString;
        if (source[key]) styles[key] = function(rsCss, props) {
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}
var $92450adb7721f685$var$colors = {
    primary: "#2684FF",
    primary75: "#4C9AFF",
    primary50: "#B2D4FF",
    primary25: "#DEEBFF",
    danger: "#DE350B",
    dangerLight: "#FFBDAD",
    neutral0: "hsl(0, 0%, 100%)",
    neutral5: "hsl(0, 0%, 95%)",
    neutral10: "hsl(0, 0%, 90%)",
    neutral20: "hsl(0, 0%, 80%)",
    neutral30: "hsl(0, 0%, 70%)",
    neutral40: "hsl(0, 0%, 60%)",
    neutral50: "hsl(0, 0%, 50%)",
    neutral60: "hsl(0, 0%, 40%)",
    neutral70: "hsl(0, 0%, 30%)",
    neutral80: "hsl(0, 0%, 20%)",
    neutral90: "hsl(0, 0%, 10%)"
};
var $92450adb7721f685$var$borderRadius = 4;
// Used to calculate consistent margin/padding on elements
var $92450adb7721f685$var$baseUnit = 4;
// The minimum height of the control
var $92450adb7721f685$var$controlHeight = 38;
// The amount of space between the control and menu */
var $92450adb7721f685$var$menuGutter = $92450adb7721f685$var$baseUnit * 2;
var $92450adb7721f685$var$spacing = {
    baseUnit: $92450adb7721f685$var$baseUnit,
    controlHeight: $92450adb7721f685$var$controlHeight,
    menuGutter: $92450adb7721f685$var$menuGutter
};
var $92450adb7721f685$export$4368d992c4eafac0 = {
    borderRadius: $92450adb7721f685$var$borderRadius,
    colors: $92450adb7721f685$var$colors,
    spacing: $92450adb7721f685$var$spacing
};
var $92450adb7721f685$export$407448d2b89b1813 = {
    "aria-live": "polite",
    backspaceRemovesValue: true,
    blurInputOnSelect: (0, $kXior.z)(),
    captureMenuScroll: !(0, $kXior.z)(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: $92450adb7721f685$export$db3b6bfb95261072(),
    formatGroupLabel: $92450adb7721f685$var$formatGroupLabel,
    getOptionLabel: $92450adb7721f685$export$8b22cf2602fb60ce,
    getOptionValue: $92450adb7721f685$export$39b482c5e57630a8,
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: $92450adb7721f685$var$isOptionDisabled,
    loadingMessage: function loadingMessage() {
        return "Loading...";
    },
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: "bottom",
    menuPosition: "absolute",
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !(0, $kXior.A)(),
    noOptionsMessage: function noOptionsMessage() {
        return "No options";
    },
    openMenuOnFocus: false,
    openMenuOnClick: true,
    options: [],
    pageSize: 5,
    placeholder: "Select...",
    screenReaderStatus: function screenReaderStatus(_ref) {
        var count = _ref.count;
        return "".concat(count, " result").concat(count !== 1 ? "s" : "", " available");
    },
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    unstyled: false
};
function $92450adb7721f685$var$toCategorizedOption(props, option, selectValue, index) {
    var isDisabled = $92450adb7721f685$var$_isOptionDisabled(props, option, selectValue);
    var isSelected = $92450adb7721f685$var$_isOptionSelected(props, option, selectValue);
    var label = $92450adb7721f685$var$getOptionLabel(props, option);
    var value = $92450adb7721f685$var$getOptionValue(props, option);
    return {
        type: "option",
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $92450adb7721f685$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map(function(groupOrOption, groupOrOptionIndex) {
        if ("options" in groupOrOption) {
            var categorizedOptions = groupOrOption.options.map(function(option, optionIndex) {
                return $92450adb7721f685$var$toCategorizedOption(props, option, selectValue, optionIndex);
            }).filter(function(categorizedOption) {
                return $92450adb7721f685$var$isFocusable(props, categorizedOption);
            });
            return categorizedOptions.length > 0 ? {
                type: "group",
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        var categorizedOption = $92450adb7721f685$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $92450adb7721f685$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter((0, $kXior.K));
}
function $92450adb7721f685$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === "group") optionsAccumulator.push.apply(optionsAccumulator, (0, $4n3CF.default)(categorizedOption.options.map(function(option) {
            return option.data;
        })));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $92450adb7721f685$var$buildFocusableOptionsWithIds(categorizedOptions, optionId) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === "group") optionsAccumulator.push.apply(optionsAccumulator, (0, $4n3CF.default)(categorizedOption.options.map(function(option) {
            return {
                data: option.data,
                id: "".concat(optionId, "-").concat(categorizedOption.index, "-").concat(option.index)
            };
        })));
        else optionsAccumulator.push({
            data: categorizedOption.data,
            id: "".concat(optionId, "-").concat(categorizedOption.index)
        });
        return optionsAccumulator;
    }, []);
}
function $92450adb7721f685$var$buildFocusableOptions(props, selectValue) {
    return $92450adb7721f685$var$buildFocusableOptionsFromCategorizedOptions($92450adb7721f685$var$buildCategorizedOptions(props, selectValue));
}
function $92450adb7721f685$var$isFocusable(props, categorizedOption) {
    var _props$inputValue = props.inputValue, inputValue = _props$inputValue === void 0 ? "" : _props$inputValue;
    var data = categorizedOption.data, isSelected = categorizedOption.isSelected, label = categorizedOption.label, value = categorizedOption.value;
    return (!$92450adb7721f685$var$shouldHideSelectedOptions(props) || !isSelected) && $92450adb7721f685$var$_filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $92450adb7721f685$var$getNextFocusedValue(state, nextSelectValue) {
    var focusedValue = state.focusedValue, lastSelectValue = state.selectValue;
    var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $92450adb7721f685$var$getNextFocusedOption(state, options) {
    var lastFocusedOption = state.focusedOption;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
var $92450adb7721f685$var$getFocusedOptionId = function getFocusedOptionId(focusableOptionsWithIds, focusedOption) {
    var _focusableOptionsWith;
    var focusedOptionId = (_focusableOptionsWith = focusableOptionsWithIds.find(function(option) {
        return option.data === focusedOption;
    })) === null || _focusableOptionsWith === void 0 ? void 0 : _focusableOptionsWith.id;
    return focusedOptionId || null;
};
var $92450adb7721f685$var$getOptionLabel = function getOptionLabel(props, data) {
    return props.getOptionLabel(data);
};
var $92450adb7721f685$var$getOptionValue = function getOptionValue(props, data) {
    return props.getOptionValue(data);
};
function $92450adb7721f685$var$_isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === "function" ? props.isOptionDisabled(option, selectValue) : false;
}
function $92450adb7721f685$var$_isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === "function") return props.isOptionSelected(option, selectValue);
    var candidate = $92450adb7721f685$var$getOptionValue(props, option);
    return selectValue.some(function(i) {
        return $92450adb7721f685$var$getOptionValue(props, i) === candidate;
    });
}
function $92450adb7721f685$var$_filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
var $92450adb7721f685$var$shouldHideSelectedOptions = function shouldHideSelectedOptions(props) {
    var hideSelectedOptions = props.hideSelectedOptions, isMulti = props.isMulti;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
var $92450adb7721f685$var$instanceId = 1;
var $92450adb7721f685$export$25ce5a424b770e84 = /*#__PURE__*/ function(_Component) {
    (0, $jLEtS.default)(Select, _Component);
    var _super = (0, $35KA5.default)(Select);
    // Misc. Instance Properties
    // ------------------------------
    // TODO
    // Refs
    // ------------------------------
    // Lifecycle
    // ------------------------------
    function Select(_props) {
        var _this;
        (0, $9gCub.default)(this, Select);
        _this = _super.call(this, _props);
        _this.state = {
            ariaSelection: null,
            focusedOption: null,
            focusedOptionId: null,
            focusableOptionsWithIds: [],
            focusedValue: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined,
            instancePrefix: ""
        };
        _this.blockOptionHover = false;
        _this.isComposing = false;
        _this.commonProps = void 0;
        _this.initialTouchX = 0;
        _this.initialTouchY = 0;
        _this.openAfterFocus = false;
        _this.scrollToFocusedOptionOnUpdate = false;
        _this.userIsDragging = void 0;
        _this.isAppleDevice = $92450adb7721f685$var$isAppleDevice();
        _this.controlRef = null;
        _this.getControlRef = function(ref) {
            _this.controlRef = ref;
        };
        _this.focusedOptionRef = null;
        _this.getFocusedOptionRef = function(ref) {
            _this.focusedOptionRef = ref;
        };
        _this.menuListRef = null;
        _this.getMenuListRef = function(ref) {
            _this.menuListRef = ref;
        };
        _this.inputRef = null;
        _this.getInputRef = function(ref) {
            _this.inputRef = ref;
        };
        _this.focus = _this.focusInput;
        _this.blur = _this.blurInput;
        _this.onChange = function(newValue, actionMeta) {
            var _this$props = _this.props, onChange = _this$props.onChange, name = _this$props.name;
            actionMeta.name = name;
            _this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        };
        _this.setValue = function(newValue, action, option) {
            var _this$props2 = _this.props, closeMenuOnSelect = _this$props2.closeMenuOnSelect, isMulti = _this$props2.isMulti, inputValue = _this$props2.inputValue;
            _this.onInputChange("", {
                action: "set-value",
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            _this.setState({
                clearFocusValueOnUpdate: true
            });
            _this.onChange(newValue, {
                action: action,
                option: option
            });
        };
        _this.selectOption = function(newValue) {
            var _this$props3 = _this.props, blurInputOnSelect = _this$props3.blurInputOnSelect, isMulti = _this$props3.isMulti, name = _this$props3.name;
            var selectValue = _this.state.selectValue;
            var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);
            var isDisabled = _this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                var candidate = _this.getOptionValue(newValue);
                _this.setValue((0, $kXior.B)(selectValue.filter(function(i) {
                    return _this.getOptionValue(i) !== candidate;
                })), "deselect-option", newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) _this.setValue((0, $kXior.B)([].concat((0, $4n3CF.default)(selectValue), [
                    newValue
                ])), "select-option", newValue);
                else _this.setValue((0, $kXior.C)(newValue), "select-option");
            } else {
                _this.ariaOnChange((0, $kXior.C)(newValue), {
                    action: "select-option",
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) _this.blurInput();
        };
        _this.removeValue = function(removedValue) {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var candidate = _this.getOptionValue(removedValue);
            var newValueArray = selectValue.filter(function(i) {
                return _this.getOptionValue(i) !== candidate;
            });
            var newValue = (0, $kXior.D)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: "remove-value",
                removedValue: removedValue
            });
            _this.focusInput();
        };
        _this.clearValue = function() {
            var selectValue = _this.state.selectValue;
            _this.onChange((0, $kXior.D)(_this.props.isMulti, [], null), {
                action: "clear",
                removedValues: selectValue
            });
        };
        _this.popValue = function() {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var lastSelectedValue = selectValue[selectValue.length - 1];
            var newValueArray = selectValue.slice(0, selectValue.length - 1);
            var newValue = (0, $kXior.D)(isMulti, newValueArray, newValueArray[0] || null);
            if (lastSelectedValue) _this.onChange(newValue, {
                action: "pop-value",
                removedValue: lastSelectedValue
            });
        };
        _this.getFocusedOptionId = function(focusedOption) {
            return $92450adb7721f685$var$getFocusedOptionId(_this.state.focusableOptionsWithIds, focusedOption);
        };
        _this.getFocusableOptionsWithIds = function() {
            return $92450adb7721f685$var$buildFocusableOptionsWithIds($92450adb7721f685$var$buildCategorizedOptions(_this.props, _this.state.selectValue), _this.getElementId("option"));
        };
        _this.getValue = function() {
            return _this.state.selectValue;
        };
        _this.cx = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return (0, $kXior.E).apply(void 0, [
                _this.props.classNamePrefix
            ].concat(args));
        };
        _this.getOptionLabel = function(data) {
            return $92450adb7721f685$var$getOptionLabel(_this.props, data);
        };
        _this.getOptionValue = function(data) {
            return $92450adb7721f685$var$getOptionValue(_this.props, data);
        };
        _this.getStyles = function(key, props) {
            var unstyled = _this.props.unstyled;
            var base = $92450adb7721f685$var$defaultStyles[key](props, unstyled);
            base.boxSizing = "border-box";
            var custom = _this.props.styles[key];
            return custom ? custom(base, props) : base;
        };
        _this.getClassNames = function(key, props) {
            var _this$props$className, _this$props$className2;
            return (_this$props$className = (_this$props$className2 = _this.props.classNames)[key]) === null || _this$props$className === void 0 ? void 0 : _this$props$className.call(_this$props$className2, props);
        };
        _this.getElementId = function(element) {
            return "".concat(_this.state.instancePrefix, "-").concat(element);
        };
        _this.getComponents = function() {
            return (0, $kXior.F)(_this.props);
        };
        _this.buildCategorizedOptions = function() {
            return $92450adb7721f685$var$buildCategorizedOptions(_this.props, _this.state.selectValue);
        };
        _this.getCategorizedOptions = function() {
            return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
        };
        _this.buildFocusableOptions = function() {
            return $92450adb7721f685$var$buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
        };
        _this.getFocusableOptions = function() {
            return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
        };
        _this.ariaOnChange = function(value, actionMeta) {
            _this.setState({
                ariaSelection: (0, $9CGAW.default)({
                    value: value
                }, actionMeta)
            });
        };
        _this.onMenuMouseDown = function(event) {
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            _this.focusInput();
        };
        _this.onMenuMouseMove = function(event) {
            _this.blockOptionHover = false;
        };
        _this.onControlMouseDown = function(event) {
            // Event captured by dropdown indicator
            if (event.defaultPrevented) return;
            var openMenuOnClick = _this.props.openMenuOnClick;
            if (!_this.state.isFocused) {
                if (openMenuOnClick) _this.openAfterFocus = true;
                _this.focusInput();
            } else if (!_this.props.menuIsOpen) {
                if (openMenuOnClick) _this.openMenu("first");
            } else if (event.target.tagName !== "INPUT" && event.target.tagName !== "TEXTAREA") _this.onMenuClose();
            if (event.target.tagName !== "INPUT" && event.target.tagName !== "TEXTAREA") event.preventDefault();
        };
        _this.onDropdownIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === "mousedown" && event.button !== 0) return;
            if (_this.props.isDisabled) return;
            var _this$props4 = _this.props, isMulti = _this$props4.isMulti, menuIsOpen = _this$props4.menuIsOpen;
            _this.focusInput();
            if (menuIsOpen) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            } else _this.openMenu("first");
            event.preventDefault();
        };
        _this.onClearIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === "mousedown" && event.button !== 0) return;
            _this.clearValue();
            event.preventDefault();
            _this.openAfterFocus = false;
            if (event.type === "touchend") _this.focusInput();
            else setTimeout(function() {
                return _this.focusInput();
            });
        };
        _this.onScroll = function(event) {
            if (typeof _this.props.closeMenuOnScroll === "boolean") {
                if (event.target instanceof HTMLElement && (0, $kXior.G)(event.target)) _this.props.onMenuClose();
            } else if (typeof _this.props.closeMenuOnScroll === "function") {
                if (_this.props.closeMenuOnScroll(event)) _this.props.onMenuClose();
            }
        };
        _this.onCompositionStart = function() {
            _this.isComposing = true;
        };
        _this.onCompositionEnd = function() {
            _this.isComposing = false;
        };
        _this.onTouchStart = function(_ref2) {
            var touches = _ref2.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            _this.initialTouchX = touch.clientX;
            _this.initialTouchY = touch.clientY;
            _this.userIsDragging = false;
        };
        _this.onTouchMove = function(_ref3) {
            var touches = _ref3.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
            var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
            var moveThreshold = 5;
            _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        };
        _this.onTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) _this.blurInput();
            // reset move vars
            _this.initialTouchX = 0;
            _this.initialTouchY = 0;
        };
        _this.onControlTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onControlMouseDown(event);
        };
        _this.onClearIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onClearIndicatorMouseDown(event);
        };
        _this.onDropdownIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onDropdownIndicatorMouseDown(event);
        };
        _this.handleInputChange = function(event) {
            var prevInputValue = _this.props.inputValue;
            var inputValue = event.currentTarget.value;
            _this.setState({
                inputIsHiddenAfterUpdate: false
            });
            _this.onInputChange(inputValue, {
                action: "input-change",
                prevInputValue: prevInputValue
            });
            if (!_this.props.menuIsOpen) _this.onMenuOpen();
        };
        _this.onInputFocus = function(event) {
            if (_this.props.onFocus) _this.props.onFocus(event);
            _this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (_this.openAfterFocus || _this.props.openMenuOnFocus) _this.openMenu("first");
            _this.openAfterFocus = false;
        };
        _this.onInputBlur = function(event) {
            var prevInputValue = _this.props.inputValue;
            if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
                _this.inputRef.focus();
                return;
            }
            if (_this.props.onBlur) _this.props.onBlur(event);
            _this.onInputChange("", {
                action: "input-blur",
                prevInputValue: prevInputValue
            });
            _this.onMenuClose();
            _this.setState({
                focusedValue: null,
                isFocused: false
            });
        };
        _this.onOptionHover = function(focusedOption) {
            if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) return;
            var options = _this.getFocusableOptions();
            var focusedOptionIndex = options.indexOf(focusedOption);
            _this.setState({
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionIndex > -1 ? _this.getFocusedOptionId(focusedOption) : null
            });
        };
        _this.shouldHideSelectedOptions = function() {
            return $92450adb7721f685$var$shouldHideSelectedOptions(_this.props);
        };
        _this.onValueInputFocus = function(e) {
            e.preventDefault();
            e.stopPropagation();
            _this.focus();
        };
        _this.onKeyDown = function(event) {
            var _this$props5 = _this.props, isMulti = _this$props5.isMulti, backspaceRemovesValue = _this$props5.backspaceRemovesValue, escapeClearsValue = _this$props5.escapeClearsValue, inputValue = _this$props5.inputValue, isClearable = _this$props5.isClearable, isDisabled = _this$props5.isDisabled, menuIsOpen = _this$props5.menuIsOpen, onKeyDown = _this$props5.onKeyDown, tabSelectsValue = _this$props5.tabSelectsValue, openMenuOnFocus = _this$props5.openMenuOnFocus;
            var _this$state = _this.state, focusedOption = _this$state.focusedOption, focusedValue = _this$state.focusedValue, selectValue = _this$state.selectValue;
            if (isDisabled) return;
            if (typeof onKeyDown === "function") {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            _this.blockOptionHover = true;
            switch(event.key){
                case "ArrowLeft":
                    if (!isMulti || inputValue) return;
                    _this.focusValue("previous");
                    break;
                case "ArrowRight":
                    if (!isMulti || inputValue) return;
                    _this.focusValue("next");
                    break;
                case "Delete":
                case "Backspace":
                    if (inputValue) return;
                    if (focusedValue) _this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) _this.popValue();
                        else if (isClearable) _this.clearValue();
                    }
                    break;
                case "Tab":
                    if (_this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) return;
                    _this.selectOption(focusedOption);
                    break;
                case "Enter":
                    if (event.keyCode === 229) break;
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (_this.isComposing) return;
                        _this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case "Escape":
                    if (menuIsOpen) {
                        _this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        _this.onInputChange("", {
                            action: "menu-close",
                            prevInputValue: inputValue
                        });
                        _this.onMenuClose();
                    } else if (isClearable && escapeClearsValue) _this.clearValue();
                    break;
                case " ":
                    // space
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        _this.openMenu("first");
                        break;
                    }
                    if (!focusedOption) return;
                    _this.selectOption(focusedOption);
                    break;
                case "ArrowUp":
                    if (menuIsOpen) _this.focusOption("up");
                    else _this.openMenu("last");
                    break;
                case "ArrowDown":
                    if (menuIsOpen) _this.focusOption("down");
                    else _this.openMenu("first");
                    break;
                case "PageUp":
                    if (!menuIsOpen) return;
                    _this.focusOption("pageup");
                    break;
                case "PageDown":
                    if (!menuIsOpen) return;
                    _this.focusOption("pagedown");
                    break;
                case "Home":
                    if (!menuIsOpen) return;
                    _this.focusOption("first");
                    break;
                case "End":
                    if (!menuIsOpen) return;
                    _this.focusOption("last");
                    break;
                default:
                    return;
            }
            event.preventDefault();
        };
        _this.state.instancePrefix = "react-select-" + (_this.props.instanceId || ++$92450adb7721f685$var$instanceId);
        _this.state.selectValue = (0, $kXior.H)(_props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (_props.menuIsOpen && _this.state.selectValue.length) {
            var focusableOptionsWithIds = _this.getFocusableOptionsWithIds();
            var focusableOptions = _this.buildFocusableOptions();
            var optionIndex = focusableOptions.indexOf(_this.state.selectValue[0]);
            _this.state.focusableOptionsWithIds = focusableOptionsWithIds;
            _this.state.focusedOption = focusableOptions[optionIndex];
            _this.state.focusedOptionId = $92450adb7721f685$var$getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
        }
        return _this;
    }
    (0, $eFvpO.default)(Select, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.startListeningComposition();
                this.startListeningToTouch();
                if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
                document.addEventListener("scroll", this.onScroll, true);
                if (this.props.autoFocus) this.focusInput();
                // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
                if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, $kXior.I)(this.menuListRef, this.focusedOptionRef);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props6 = this.props, isDisabled = _this$props6.isDisabled, menuIsOpen = _this$props6.menuIsOpen;
                var isFocused = this.state.isFocused;
                if (// ensure focus is restored correctly when the control becomes enabled
                isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
                isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
                if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: false
                }, this.onMenuClose);
                else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: true
                });
                // scroll the focused option into view if necessary
                if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                    (0, $kXior.I)(this.menuListRef, this.focusedOptionRef);
                    this.scrollToFocusedOptionOnUpdate = false;
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.stopListeningComposition();
                this.stopListeningToTouch();
                document.removeEventListener("scroll", this.onScroll, true);
            }
        },
        {
            key: "onMenuOpen",
            value: function onMenuOpen() {
                this.props.onMenuOpen();
            }
        },
        {
            key: "onMenuClose",
            value: function onMenuClose() {
                this.onInputChange("", {
                    action: "menu-close",
                    prevInputValue: this.props.inputValue
                });
                this.props.onMenuClose();
            }
        },
        {
            key: "onInputChange",
            value: function onInputChange(newValue, actionMeta) {
                this.props.onInputChange(newValue, actionMeta);
            }
        },
        {
            key: "focusInput",
            value: function focusInput() {
                if (!this.inputRef) return;
                this.inputRef.focus();
            }
        },
        {
            key: "blurInput",
            value: function blurInput() {
                if (!this.inputRef) return;
                this.inputRef.blur();
            }
        },
        {
            key: "openMenu",
            value: function openMenu(focusOption) {
                var _this2 = this;
                var _this$state2 = this.state, selectValue = _this$state2.selectValue, isFocused = _this$state2.isFocused;
                var focusableOptions = this.buildFocusableOptions();
                var openAtIndex = focusOption === "first" ? 0 : focusableOptions.length - 1;
                if (!this.props.isMulti) {
                    var selectedIndex = focusableOptions.indexOf(selectValue[0]);
                    if (selectedIndex > -1) openAtIndex = selectedIndex;
                }
                // only scroll if the menu isn't already open
                this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
                this.setState({
                    inputIsHiddenAfterUpdate: false,
                    focusedValue: null,
                    focusedOption: focusableOptions[openAtIndex],
                    focusedOptionId: this.getFocusedOptionId(focusableOptions[openAtIndex])
                }, function() {
                    return _this2.onMenuOpen();
                });
            }
        },
        {
            key: "focusValue",
            value: function focusValue(direction) {
                var _this$state3 = this.state, selectValue = _this$state3.selectValue, focusedValue = _this$state3.focusedValue;
                // Only multiselects support value focusing
                if (!this.props.isMulti) return;
                this.setState({
                    focusedOption: null
                });
                var focusedIndex = selectValue.indexOf(focusedValue);
                if (!focusedValue) focusedIndex = -1;
                var lastIndex = selectValue.length - 1;
                var nextFocus = -1;
                if (!selectValue.length) return;
                switch(direction){
                    case "previous":
                        if (focusedIndex === 0) // don't cycle from the start to the end
                        nextFocus = 0;
                        else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                        nextFocus = lastIndex;
                        else nextFocus = focusedIndex - 1;
                        break;
                    case "next":
                        if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                        break;
                }
                this.setState({
                    inputIsHidden: nextFocus !== -1,
                    focusedValue: selectValue[nextFocus]
                });
            }
        },
        {
            key: "focusOption",
            value: function focusOption() {
                var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "first";
                var pageSize = this.props.pageSize;
                var focusedOption = this.state.focusedOption;
                var options = this.getFocusableOptions();
                if (!options.length) return;
                var nextFocus = 0; // handles 'first'
                var focusedIndex = options.indexOf(focusedOption);
                if (!focusedOption) focusedIndex = -1;
                if (direction === "up") nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
                else if (direction === "down") nextFocus = (focusedIndex + 1) % options.length;
                else if (direction === "pageup") {
                    nextFocus = focusedIndex - pageSize;
                    if (nextFocus < 0) nextFocus = 0;
                } else if (direction === "pagedown") {
                    nextFocus = focusedIndex + pageSize;
                    if (nextFocus > options.length - 1) nextFocus = options.length - 1;
                } else if (direction === "last") nextFocus = options.length - 1;
                this.scrollToFocusedOptionOnUpdate = true;
                this.setState({
                    focusedOption: options[nextFocus],
                    focusedValue: null,
                    focusedOptionId: this.getFocusedOptionId(options[nextFocus])
                });
            }
        },
        {
            key: "getTheme",
            value: // ==============================
            // Getters
            // ==============================
            function getTheme() {
                // Use the default theme if there are no customisations.
                if (!this.props.theme) return $92450adb7721f685$export$4368d992c4eafac0;
                // If the theme prop is a function, assume the function
                // knows how to merge the passed-in default theme with
                // its own modifications.
                if (typeof this.props.theme === "function") return this.props.theme($92450adb7721f685$export$4368d992c4eafac0);
                // Otherwise, if a plain theme object was passed in,
                // overlay it with the default theme.
                return (0, $9CGAW.default)((0, $9CGAW.default)({}, $92450adb7721f685$export$4368d992c4eafac0), this.props.theme);
            }
        },
        {
            key: "getCommonProps",
            value: function getCommonProps() {
                var clearValue = this.clearValue, cx = this.cx, getStyles = this.getStyles, getClassNames = this.getClassNames, getValue = this.getValue, selectOption = this.selectOption, setValue = this.setValue, props = this.props;
                var isMulti = props.isMulti, isRtl = props.isRtl, options = props.options;
                var hasValue = this.hasValue();
                return {
                    clearValue: clearValue,
                    cx: cx,
                    getStyles: getStyles,
                    getClassNames: getClassNames,
                    getValue: getValue,
                    hasValue: hasValue,
                    isMulti: isMulti,
                    isRtl: isRtl,
                    options: options,
                    selectOption: selectOption,
                    selectProps: props,
                    setValue: setValue,
                    theme: this.getTheme()
                };
            }
        },
        {
            key: "hasValue",
            value: function hasValue() {
                var selectValue = this.state.selectValue;
                return selectValue.length > 0;
            }
        },
        {
            key: "hasOptions",
            value: function hasOptions() {
                return !!this.getFocusableOptions().length;
            }
        },
        {
            key: "isClearable",
            value: function isClearable() {
                var _this$props7 = this.props, isClearable = _this$props7.isClearable, isMulti = _this$props7.isMulti;
                // single select, by default, IS NOT clearable
                // multi select, by default, IS clearable
                if (isClearable === undefined) return isMulti;
                return isClearable;
            }
        },
        {
            key: "isOptionDisabled",
            value: function isOptionDisabled(option, selectValue) {
                return $92450adb7721f685$var$_isOptionDisabled(this.props, option, selectValue);
            }
        },
        {
            key: "isOptionSelected",
            value: function isOptionSelected(option, selectValue) {
                return $92450adb7721f685$var$_isOptionSelected(this.props, option, selectValue);
            }
        },
        {
            key: "filterOption",
            value: function filterOption(option, inputValue) {
                return $92450adb7721f685$var$_filterOption(this.props, option, inputValue);
            }
        },
        {
            key: "formatOptionLabel",
            value: function formatOptionLabel(data, context) {
                if (typeof this.props.formatOptionLabel === "function") {
                    var _inputValue = this.props.inputValue;
                    var _selectValue = this.state.selectValue;
                    return this.props.formatOptionLabel(data, {
                        context: context,
                        inputValue: _inputValue,
                        selectValue: _selectValue
                    });
                } else return this.getOptionLabel(data);
            }
        },
        {
            key: "formatGroupLabel",
            value: function formatGroupLabel(data) {
                return this.props.formatGroupLabel(data);
            }
        },
        {
            key: "startListeningComposition",
            value: // ==============================
            // Composition Handlers
            // ==============================
            function startListeningComposition() {
                if (document && document.addEventListener) {
                    document.addEventListener("compositionstart", this.onCompositionStart, false);
                    document.addEventListener("compositionend", this.onCompositionEnd, false);
                }
            }
        },
        {
            key: "stopListeningComposition",
            value: function stopListeningComposition() {
                if (document && document.removeEventListener) {
                    document.removeEventListener("compositionstart", this.onCompositionStart);
                    document.removeEventListener("compositionend", this.onCompositionEnd);
                }
            }
        },
        {
            key: "startListeningToTouch",
            value: // ==============================
            // Touch Handlers
            // ==============================
            function startListeningToTouch() {
                if (document && document.addEventListener) {
                    document.addEventListener("touchstart", this.onTouchStart, false);
                    document.addEventListener("touchmove", this.onTouchMove, false);
                    document.addEventListener("touchend", this.onTouchEnd, false);
                }
            }
        },
        {
            key: "stopListeningToTouch",
            value: function stopListeningToTouch() {
                if (document && document.removeEventListener) {
                    document.removeEventListener("touchstart", this.onTouchStart);
                    document.removeEventListener("touchmove", this.onTouchMove);
                    document.removeEventListener("touchend", this.onTouchEnd);
                }
            }
        },
        {
            key: "renderInput",
            value: // ==============================
            // Renderers
            // ==============================
            function renderInput() {
                var _this$props8 = this.props, isDisabled = _this$props8.isDisabled, isSearchable = _this$props8.isSearchable, inputId = _this$props8.inputId, inputValue = _this$props8.inputValue, tabIndex = _this$props8.tabIndex, form = _this$props8.form, menuIsOpen = _this$props8.menuIsOpen, required = _this$props8.required;
                var _this$getComponents = this.getComponents(), Input = _this$getComponents.Input;
                var _this$state4 = this.state, inputIsHidden = _this$state4.inputIsHidden, ariaSelection = _this$state4.ariaSelection;
                var commonProps = this.commonProps;
                var id = inputId || this.getElementId("input");
                // aria attributes makes the JSX "noisy", separated for clarity
                var ariaAttributes = (0, $9CGAW.default)((0, $9CGAW.default)((0, $9CGAW.default)({
                    "aria-autocomplete": "list",
                    "aria-expanded": menuIsOpen,
                    "aria-haspopup": true,
                    "aria-errormessage": this.props["aria-errormessage"],
                    "aria-invalid": this.props["aria-invalid"],
                    "aria-label": this.props["aria-label"],
                    "aria-labelledby": this.props["aria-labelledby"],
                    "aria-required": required,
                    role: "combobox",
                    "aria-activedescendant": this.isAppleDevice ? undefined : this.state.focusedOptionId || ""
                }, menuIsOpen && {
                    "aria-controls": this.getElementId("listbox")
                }), !isSearchable && {
                    "aria-readonly": true
                }), this.hasValue() ? (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === "initial-input-focus" && {
                    "aria-describedby": this.getElementId("live-region")
                } : {
                    "aria-describedby": this.getElementId("placeholder")
                });
                if (!isSearchable) // use a dummy input to maintain focus/blur functionality
                return /*#__PURE__*/ $kc00y.createElement($92450adb7721f685$var$DummyInput, (0, $cGuNc.default)({
                    id: id,
                    innerRef: this.getInputRef,
                    onBlur: this.onInputBlur,
                    onChange: (0, $kXior.J),
                    onFocus: this.onInputFocus,
                    disabled: isDisabled,
                    tabIndex: tabIndex,
                    inputMode: "none",
                    form: form,
                    value: ""
                }, ariaAttributes));
                return /*#__PURE__*/ $kc00y.createElement(Input, (0, $cGuNc.default)({}, commonProps, {
                    autoCapitalize: "none",
                    autoComplete: "off",
                    autoCorrect: "off",
                    id: id,
                    innerRef: this.getInputRef,
                    isDisabled: isDisabled,
                    isHidden: inputIsHidden,
                    onBlur: this.onInputBlur,
                    onChange: this.handleInputChange,
                    onFocus: this.onInputFocus,
                    spellCheck: "false",
                    tabIndex: tabIndex,
                    form: form,
                    type: "text",
                    value: inputValue
                }, ariaAttributes));
            }
        },
        {
            key: "renderPlaceholderOrValue",
            value: function renderPlaceholderOrValue() {
                var _this3 = this;
                var _this$getComponents2 = this.getComponents(), MultiValue = _this$getComponents2.MultiValue, MultiValueContainer = _this$getComponents2.MultiValueContainer, MultiValueLabel = _this$getComponents2.MultiValueLabel, MultiValueRemove = _this$getComponents2.MultiValueRemove, SingleValue = _this$getComponents2.SingleValue, Placeholder = _this$getComponents2.Placeholder;
                var commonProps = this.commonProps;
                var _this$props9 = this.props, controlShouldRenderValue = _this$props9.controlShouldRenderValue, isDisabled = _this$props9.isDisabled, isMulti = _this$props9.isMulti, inputValue = _this$props9.inputValue, placeholder = _this$props9.placeholder;
                var _this$state5 = this.state, selectValue = _this$state5.selectValue, focusedValue = _this$state5.focusedValue, isFocused = _this$state5.isFocused;
                if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ $kc00y.createElement(Placeholder, (0, $cGuNc.default)({}, commonProps, {
                    key: "placeholder",
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    innerProps: {
                        id: this.getElementId("placeholder")
                    }
                }), placeholder);
                if (isMulti) return selectValue.map(function(opt, index) {
                    var isOptionFocused = opt === focusedValue;
                    var key = "".concat(_this3.getOptionLabel(opt), "-").concat(_this3.getOptionValue(opt));
                    return /*#__PURE__*/ $kc00y.createElement(MultiValue, (0, $cGuNc.default)({}, commonProps, {
                        components: {
                            Container: MultiValueContainer,
                            Label: MultiValueLabel,
                            Remove: MultiValueRemove
                        },
                        isFocused: isOptionFocused,
                        isDisabled: isDisabled,
                        key: key,
                        index: index,
                        removeProps: {
                            onClick: function onClick() {
                                return _this3.removeValue(opt);
                            },
                            onTouchEnd: function onTouchEnd() {
                                return _this3.removeValue(opt);
                            },
                            onMouseDown: function onMouseDown(e) {
                                e.preventDefault();
                            }
                        },
                        data: opt
                    }), _this3.formatOptionLabel(opt, "value"));
                });
                if (inputValue) return null;
                var singleValue = selectValue[0];
                return /*#__PURE__*/ $kc00y.createElement(SingleValue, (0, $cGuNc.default)({}, commonProps, {
                    data: singleValue,
                    isDisabled: isDisabled
                }), this.formatOptionLabel(singleValue, "value"));
            }
        },
        {
            key: "renderClearIndicator",
            value: function renderClearIndicator() {
                var _this$getComponents3 = this.getComponents(), ClearIndicator = _this$getComponents3.ClearIndicator;
                var commonProps = this.commonProps;
                var _this$props10 = this.props, isDisabled = _this$props10.isDisabled, isLoading = _this$props10.isLoading;
                var isFocused = this.state.isFocused;
                if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
                var innerProps = {
                    onMouseDown: this.onClearIndicatorMouseDown,
                    onTouchEnd: this.onClearIndicatorTouchEnd,
                    "aria-hidden": "true"
                };
                return /*#__PURE__*/ $kc00y.createElement(ClearIndicator, (0, $cGuNc.default)({}, commonProps, {
                    innerProps: innerProps,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderLoadingIndicator",
            value: function renderLoadingIndicator() {
                var _this$getComponents4 = this.getComponents(), LoadingIndicator = _this$getComponents4.LoadingIndicator;
                var commonProps = this.commonProps;
                var _this$props11 = this.props, isDisabled = _this$props11.isDisabled, isLoading = _this$props11.isLoading;
                var isFocused = this.state.isFocused;
                if (!LoadingIndicator || !isLoading) return null;
                var innerProps = {
                    "aria-hidden": "true"
                };
                return /*#__PURE__*/ $kc00y.createElement(LoadingIndicator, (0, $cGuNc.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderIndicatorSeparator",
            value: function renderIndicatorSeparator() {
                var _this$getComponents5 = this.getComponents(), DropdownIndicator = _this$getComponents5.DropdownIndicator, IndicatorSeparator = _this$getComponents5.IndicatorSeparator;
                // separator doesn't make sense without the dropdown indicator
                if (!DropdownIndicator || !IndicatorSeparator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                return /*#__PURE__*/ $kc00y.createElement(IndicatorSeparator, (0, $cGuNc.default)({}, commonProps, {
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderDropdownIndicator",
            value: function renderDropdownIndicator() {
                var _this$getComponents6 = this.getComponents(), DropdownIndicator = _this$getComponents6.DropdownIndicator;
                if (!DropdownIndicator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                var innerProps = {
                    onMouseDown: this.onDropdownIndicatorMouseDown,
                    onTouchEnd: this.onDropdownIndicatorTouchEnd,
                    "aria-hidden": "true"
                };
                return /*#__PURE__*/ $kc00y.createElement(DropdownIndicator, (0, $cGuNc.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderMenu",
            value: function renderMenu() {
                var _this4 = this;
                var _this$getComponents7 = this.getComponents(), Group = _this$getComponents7.Group, GroupHeading = _this$getComponents7.GroupHeading, Menu = _this$getComponents7.Menu, MenuList = _this$getComponents7.MenuList, MenuPortal = _this$getComponents7.MenuPortal, LoadingMessage = _this$getComponents7.LoadingMessage, NoOptionsMessage = _this$getComponents7.NoOptionsMessage, Option = _this$getComponents7.Option;
                var commonProps = this.commonProps;
                var focusedOption = this.state.focusedOption;
                var _this$props12 = this.props, captureMenuScroll = _this$props12.captureMenuScroll, inputValue = _this$props12.inputValue, isLoading = _this$props12.isLoading, loadingMessage = _this$props12.loadingMessage, minMenuHeight = _this$props12.minMenuHeight, maxMenuHeight = _this$props12.maxMenuHeight, menuIsOpen = _this$props12.menuIsOpen, menuPlacement = _this$props12.menuPlacement, menuPosition = _this$props12.menuPosition, menuPortalTarget = _this$props12.menuPortalTarget, menuShouldBlockScroll = _this$props12.menuShouldBlockScroll, menuShouldScrollIntoView = _this$props12.menuShouldScrollIntoView, noOptionsMessage = _this$props12.noOptionsMessage, onMenuScrollToTop = _this$props12.onMenuScrollToTop, onMenuScrollToBottom = _this$props12.onMenuScrollToBottom;
                if (!menuIsOpen) return null;
                // TODO: Internal Option Type here
                var render = function render(props, id) {
                    var type = props.type, data = props.data, isDisabled = props.isDisabled, isSelected = props.isSelected, label = props.label, value = props.value;
                    var isFocused = focusedOption === data;
                    var onHover = isDisabled ? undefined : function() {
                        return _this4.onOptionHover(data);
                    };
                    var onSelect = isDisabled ? undefined : function() {
                        return _this4.selectOption(data);
                    };
                    var optionId = "".concat(_this4.getElementId("option"), "-").concat(id);
                    var innerProps = {
                        id: optionId,
                        onClick: onSelect,
                        onMouseMove: onHover,
                        onMouseOver: onHover,
                        tabIndex: -1,
                        role: "option",
                        "aria-selected": _this4.isAppleDevice ? undefined : isSelected // is not supported on Apple devices
                    };
                    return /*#__PURE__*/ $kc00y.createElement(Option, (0, $cGuNc.default)({}, commonProps, {
                        innerProps: innerProps,
                        data: data,
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        key: optionId,
                        label: label,
                        type: type,
                        value: value,
                        isFocused: isFocused,
                        innerRef: isFocused ? _this4.getFocusedOptionRef : undefined
                    }), _this4.formatOptionLabel(props.data, "menu"));
                };
                var menuUI;
                if (this.hasOptions()) menuUI = this.getCategorizedOptions().map(function(item) {
                    if (item.type === "group") {
                        var _data = item.data, options = item.options, groupIndex = item.index;
                        var groupId = "".concat(_this4.getElementId("group"), "-").concat(groupIndex);
                        var headingId = "".concat(groupId, "-heading");
                        return /*#__PURE__*/ $kc00y.createElement(Group, (0, $cGuNc.default)({}, commonProps, {
                            key: groupId,
                            data: _data,
                            options: options,
                            Heading: GroupHeading,
                            headingProps: {
                                id: headingId,
                                data: item.data
                            },
                            label: _this4.formatGroupLabel(item.data)
                        }), item.options.map(function(option) {
                            return render(option, "".concat(groupIndex, "-").concat(option.index));
                        }));
                    } else if (item.type === "option") return render(item, "".concat(item.index));
                });
                else if (isLoading) {
                    var message = loadingMessage({
                        inputValue: inputValue
                    });
                    if (message === null) return null;
                    menuUI = /*#__PURE__*/ $kc00y.createElement(LoadingMessage, commonProps, message);
                } else {
                    var _message = noOptionsMessage({
                        inputValue: inputValue
                    });
                    if (_message === null) return null;
                    menuUI = /*#__PURE__*/ $kc00y.createElement(NoOptionsMessage, commonProps, _message);
                }
                var menuPlacementProps = {
                    minMenuHeight: minMenuHeight,
                    maxMenuHeight: maxMenuHeight,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition,
                    menuShouldScrollIntoView: menuShouldScrollIntoView
                };
                var menuElement = /*#__PURE__*/ $kc00y.createElement((0, $kXior.M), (0, $cGuNc.default)({}, commonProps, menuPlacementProps), function(_ref4) {
                    var ref = _ref4.ref, _ref4$placerProps = _ref4.placerProps, placement = _ref4$placerProps.placement, maxHeight = _ref4$placerProps.maxHeight;
                    return /*#__PURE__*/ $kc00y.createElement(Menu, (0, $cGuNc.default)({}, commonProps, menuPlacementProps, {
                        innerRef: ref,
                        innerProps: {
                            onMouseDown: _this4.onMenuMouseDown,
                            onMouseMove: _this4.onMenuMouseMove
                        },
                        isLoading: isLoading,
                        placement: placement
                    }), /*#__PURE__*/ $kc00y.createElement($92450adb7721f685$var$ScrollManager, {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll
                    }, function(scrollTargetRef) {
                        return /*#__PURE__*/ $kc00y.createElement(MenuList, (0, $cGuNc.default)({}, commonProps, {
                            innerRef: function innerRef(instance) {
                                _this4.getMenuListRef(instance);
                                scrollTargetRef(instance);
                            },
                            innerProps: {
                                role: "listbox",
                                "aria-multiselectable": commonProps.isMulti,
                                id: _this4.getElementId("listbox")
                            },
                            isLoading: isLoading,
                            maxHeight: maxHeight,
                            focusedOption: focusedOption
                        }), menuUI);
                    }));
                });
                // positioning behaviour is almost identical for portalled and fixed,
                // so we use the same component. the actual portalling logic is forked
                // within the component based on `menuPosition`
                return menuPortalTarget || menuPosition === "fixed" ? /*#__PURE__*/ $kc00y.createElement(MenuPortal, (0, $cGuNc.default)({}, commonProps, {
                    appendTo: menuPortalTarget,
                    controlElement: this.controlRef,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition
                }), menuElement) : menuElement;
            }
        },
        {
            key: "renderFormField",
            value: function renderFormField() {
                var _this5 = this;
                var _this$props13 = this.props, delimiter = _this$props13.delimiter, isDisabled = _this$props13.isDisabled, isMulti = _this$props13.isMulti, name = _this$props13.name, required = _this$props13.required;
                var selectValue = this.state.selectValue;
                if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ $kc00y.createElement($92450adb7721f685$var$RequiredInput$1, {
                    name: name,
                    onFocus: this.onValueInputFocus
                });
                if (!name || isDisabled) return;
                if (isMulti) {
                    if (delimiter) {
                        var value = selectValue.map(function(opt) {
                            return _this5.getOptionValue(opt);
                        }).join(delimiter);
                        return /*#__PURE__*/ $kc00y.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: value
                        });
                    } else {
                        var input = selectValue.length > 0 ? selectValue.map(function(opt, i) {
                            return /*#__PURE__*/ $kc00y.createElement("input", {
                                key: "i-".concat(i),
                                name: name,
                                type: "hidden",
                                value: _this5.getOptionValue(opt)
                            });
                        }) : /*#__PURE__*/ $kc00y.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: ""
                        });
                        return /*#__PURE__*/ $kc00y.createElement("div", null, input);
                    }
                } else {
                    var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : "";
                    return /*#__PURE__*/ $kc00y.createElement("input", {
                        name: name,
                        type: "hidden",
                        value: _value
                    });
                }
            }
        },
        {
            key: "renderLiveRegion",
            value: function renderLiveRegion() {
                var commonProps = this.commonProps;
                var _this$state6 = this.state, ariaSelection = _this$state6.ariaSelection, focusedOption = _this$state6.focusedOption, focusedValue = _this$state6.focusedValue, isFocused = _this$state6.isFocused, selectValue = _this$state6.selectValue;
                var focusableOptions = this.getFocusableOptions();
                return /*#__PURE__*/ $kc00y.createElement($92450adb7721f685$var$LiveRegion$1, (0, $cGuNc.default)({}, commonProps, {
                    id: this.getElementId("live-region"),
                    ariaSelection: ariaSelection,
                    focusedOption: focusedOption,
                    focusedValue: focusedValue,
                    isFocused: isFocused,
                    selectValue: selectValue,
                    focusableOptions: focusableOptions,
                    isAppleDevice: this.isAppleDevice
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$getComponents8 = this.getComponents(), Control = _this$getComponents8.Control, IndicatorsContainer = _this$getComponents8.IndicatorsContainer, SelectContainer = _this$getComponents8.SelectContainer, ValueContainer = _this$getComponents8.ValueContainer;
                var _this$props14 = this.props, className = _this$props14.className, id = _this$props14.id, isDisabled = _this$props14.isDisabled, menuIsOpen = _this$props14.menuIsOpen;
                var isFocused = this.state.isFocused;
                var commonProps = this.commonProps = this.getCommonProps();
                return /*#__PURE__*/ $kc00y.createElement(SelectContainer, (0, $cGuNc.default)({}, commonProps, {
                    className: className,
                    innerProps: {
                        id: id,
                        onKeyDown: this.onKeyDown
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }), this.renderLiveRegion(), /*#__PURE__*/ $kc00y.createElement(Control, (0, $cGuNc.default)({}, commonProps, {
                    innerRef: this.getControlRef,
                    innerProps: {
                        onMouseDown: this.onControlMouseDown,
                        onTouchEnd: this.onControlTouchEnd
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    menuIsOpen: menuIsOpen
                }), /*#__PURE__*/ $kc00y.createElement(ValueContainer, (0, $cGuNc.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/ $kc00y.createElement(IndicatorsContainer, (0, $cGuNc.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                var prevProps = state.prevProps, clearFocusValueOnUpdate = state.clearFocusValueOnUpdate, inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate, ariaSelection = state.ariaSelection, isFocused = state.isFocused, prevWasFocused = state.prevWasFocused, instancePrefix = state.instancePrefix;
                var options = props.options, value = props.value, menuIsOpen = props.menuIsOpen, inputValue = props.inputValue, isMulti = props.isMulti;
                var selectValue = (0, $kXior.H)(value);
                var newMenuOptionsState = {};
                if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
                    var focusableOptions = menuIsOpen ? $92450adb7721f685$var$buildFocusableOptions(props, selectValue) : [];
                    var focusableOptionsWithIds = menuIsOpen ? $92450adb7721f685$var$buildFocusableOptionsWithIds($92450adb7721f685$var$buildCategorizedOptions(props, selectValue), "".concat(instancePrefix, "-option")) : [];
                    var focusedValue = clearFocusValueOnUpdate ? $92450adb7721f685$var$getNextFocusedValue(state, selectValue) : null;
                    var focusedOption = $92450adb7721f685$var$getNextFocusedOption(state, focusableOptions);
                    var focusedOptionId = $92450adb7721f685$var$getFocusedOptionId(focusableOptionsWithIds, focusedOption);
                    newMenuOptionsState = {
                        selectValue: selectValue,
                        focusedOption: focusedOption,
                        focusedOptionId: focusedOptionId,
                        focusableOptionsWithIds: focusableOptionsWithIds,
                        focusedValue: focusedValue,
                        clearFocusValueOnUpdate: false
                    };
                }
                // some updates should toggle the state of the input visibility
                var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
                    inputIsHidden: inputIsHiddenAfterUpdate,
                    inputIsHiddenAfterUpdate: undefined
                } : {};
                var newAriaSelection = ariaSelection;
                var hasKeptFocus = isFocused && prevWasFocused;
                if (isFocused && !hasKeptFocus) {
                    // If `value` or `defaultValue` props are not empty then announce them
                    // when the Select is initially focused
                    newAriaSelection = {
                        value: (0, $kXior.D)(isMulti, selectValue, selectValue[0] || null),
                        options: selectValue,
                        action: "initial-input-focus"
                    };
                    hasKeptFocus = !prevWasFocused;
                }
                // If the 'initial-input-focus' action has been set already
                // then reset the ariaSelection to null
                if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === "initial-input-focus") newAriaSelection = null;
                return (0, $9CGAW.default)((0, $9CGAW.default)((0, $9CGAW.default)({}, newMenuOptionsState), newInputIsHiddenState), {}, {
                    prevProps: props,
                    ariaSelection: newAriaSelection,
                    prevWasFocused: hasKeptFocus
                });
            }
        }
    ]);
    return Select;
}((0, $kc00y.Component));
$92450adb7721f685$export$25ce5a424b770e84.defaultProps = $92450adb7721f685$export$407448d2b89b1813;

});
parcelRegister("9gCub", function(module, exports) {

$parcel$export(module.exports, "default", () => $6bf37624bc91922d$export$2e2bcd8739ae039);
function $6bf37624bc91922d$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("eFvpO", function(module, exports) {

$parcel$export(module.exports, "default", () => $aadd4372416ec2f2$export$2e2bcd8739ae039);

var $elOZ3 = parcelRequire("elOZ3");
function $aadd4372416ec2f2$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $elOZ3.default)(o.key), o);
    }
}
function $aadd4372416ec2f2$export$2e2bcd8739ae039(e, r, t) {
    return r && $aadd4372416ec2f2$var$_defineProperties(e.prototype, r), t && $aadd4372416ec2f2$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});

parcelRegister("jLEtS", function(module, exports) {

$parcel$export(module.exports, "default", () => $e641cec65e374bd1$export$2e2bcd8739ae039);

var $ltfqF = parcelRequire("ltfqF");
function $e641cec65e374bd1$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $ltfqF.default)(t, e);
}

});
parcelRegister("ltfqF", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa18464dbdd601aa$export$2e2bcd8739ae039);
function $fa18464dbdd601aa$export$2e2bcd8739ae039(t, e) {
    return $fa18464dbdd601aa$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $fa18464dbdd601aa$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("35KA5", function(module, exports) {

$parcel$export(module.exports, "default", () => $2405f8bb9d24fc8e$export$2e2bcd8739ae039);

var $ejiwC = parcelRequire("ejiwC");

var $136ue = parcelRequire("136ue");

var $7F6Iz = parcelRequire("7F6Iz");
function $2405f8bb9d24fc8e$export$2e2bcd8739ae039(t) {
    var r = (0, $136ue.default)();
    return function() {
        var e, o = (0, $ejiwC.default)(t);
        if (r) {
            var s = (0, $ejiwC.default)(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, $7F6Iz.default)(this, e);
    };
}

});
parcelRegister("ejiwC", function(module, exports) {

$parcel$export(module.exports, "default", () => $a6b135ba5b9f3850$export$2e2bcd8739ae039);
function $a6b135ba5b9f3850$export$2e2bcd8739ae039(t) {
    return $a6b135ba5b9f3850$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $a6b135ba5b9f3850$export$2e2bcd8739ae039(t);
}

});

parcelRegister("136ue", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c3b1a627100fd12$export$2e2bcd8739ae039);
function $0c3b1a627100fd12$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($0c3b1a627100fd12$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}

});

parcelRegister("7F6Iz", function(module, exports) {

$parcel$export(module.exports, "default", () => $594192c53952fdd8$export$2e2bcd8739ae039);

var $kpWmw = parcelRequire("kpWmw");

var $bhPYM = parcelRequire("bhPYM");
function $594192c53952fdd8$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $kpWmw.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $bhPYM.default)(t);
}

});
parcelRegister("bhPYM", function(module, exports) {

$parcel$export(module.exports, "default", () => $83799a442ebf2b68$export$2e2bcd8739ae039);
function $83799a442ebf2b68$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});



parcelRegister("4n3CF", function(module, exports) {

$parcel$export(module.exports, "default", () => $32ec1eca796f107d$export$2e2bcd8739ae039);

var $2coni = parcelRequire("2coni");

var $9YM1t = parcelRequire("9YM1t");

var $4NLso = parcelRequire("4NLso");

var $fl2rw = parcelRequire("fl2rw");
function $32ec1eca796f107d$export$2e2bcd8739ae039(r) {
    return (0, $2coni.default)(r) || (0, $9YM1t.default)(r) || (0, $4NLso.default)(r) || (0, $fl2rw.default)();
}

});
parcelRegister("2coni", function(module, exports) {

$parcel$export(module.exports, "default", () => $199f9c14216dc199$export$2e2bcd8739ae039);

var $eYTTt = parcelRequire("eYTTt");
function $199f9c14216dc199$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $eYTTt.default)(r);
}

});

parcelRegister("9YM1t", function(module, exports) {

$parcel$export(module.exports, "default", () => $743ef7f3ff7bcd2c$export$2e2bcd8739ae039);
function $743ef7f3ff7bcd2c$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("fl2rw", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2aab6461fb2c999$export$2e2bcd8739ae039);
function $b2aab6461fb2c999$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("1SPyn", function(module, exports) {

$parcel$export(module.exports, "default", () => $15f2d30d717d6fe1$export$2e2bcd8739ae039);
var $15f2d30d717d6fe1$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === "number" && value !== value;
};
function $15f2d30d717d6fe1$var$isEqual(first, second) {
    if (first === second) return true;
    if ($15f2d30d717d6fe1$var$safeIsNaN(first) && $15f2d30d717d6fe1$var$safeIsNaN(second)) return true;
    return false;
}
function $15f2d30d717d6fe1$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$15f2d30d717d6fe1$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $15f2d30d717d6fe1$export$2e2bcd8739ae039(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $15f2d30d717d6fe1$var$areInputsEqual;
    var cache = null;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (cache && cache.lastThis === this && isEqual(newArgs, cache.lastArgs)) return cache.lastResult;
        var lastResult = resultFn.apply(this, newArgs);
        cache = {
            lastResult: lastResult,
            lastArgs: newArgs,
            lastThis: this
        };
        return lastResult;
    }
    memoized.clear = function clear() {
        cache = null;
    };
    return memoized;
}

});


parcelRegister("eM09M", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac15ab874ad2390c$export$2e2bcd8739ae039);

var $1Db9c = parcelRequire("1Db9c");

var $cGuNc = parcelRequire("cGuNc");

var $kc00y = parcelRequire("kc00y");

var $cyAAA = parcelRequire("cyAAA");

var $f4L7N = parcelRequire("f4L7N");

var $d0OJ1 = parcelRequire("d0OJ1");

var $kXior = parcelRequire("kXior");
parcelRequire("hAFP2");
parcelRequire("9LOdT");
parcelRequire("4FW7R");
parcelRequire("kdObC");
parcelRequire("hcalg");
parcelRequire("7y7MC");
parcelRequire("jNv6Z");
parcelRequire("ka2wb");

parcelRequire("fVcyP");
parcelRequire("jJWyQ");
parcelRequire("hocAw");
parcelRequire("cn1Kz");

parcelRequire("2llq8");
var $ac15ab874ad2390c$var$StateManagedSelect = /*#__PURE__*/ (0, $kc00y.forwardRef)(function(props, ref) {
    var baseSelectProps = (0, $1Db9c.u)(props);
    return /*#__PURE__*/ $kc00y.createElement((0, $cyAAA.S), (0, $cGuNc.default)({
        ref: ref
    }, baseSelectProps));
});
var $ac15ab874ad2390c$export$2e2bcd8739ae039 = $ac15ab874ad2390c$var$StateManagedSelect;
var $ac15ab874ad2390c$export$a7deb1594c5ce10e = function(_ref) {
    var nonce = _ref.nonce, children = _ref.children, cacheKey = _ref.cacheKey;
    var emotionCache = (0, $kc00y.useMemo)(function() {
        return (0, $d0OJ1.default)({
            key: cacheKey,
            nonce: nonce
        });
    }, [
        cacheKey,
        nonce
    ]);
    return /*#__PURE__*/ $kc00y.createElement((0, $f4L7N.C), {
        value: emotionCache
    }, children);
};

});
parcelRegister("1Db9c", function(module, exports) {

$parcel$export(module.exports, "u", () => $13021495c1d5bd05$export$3b14a55fb2447963);

var $9CGAW = parcelRequire("9CGAW");

var $jve2F = parcelRequire("jve2F");

var $lTjB2 = parcelRequire("lTjB2");

var $kc00y = parcelRequire("kc00y");
var $13021495c1d5bd05$var$_excluded = [
    "defaultInputValue",
    "defaultMenuIsOpen",
    "defaultValue",
    "inputValue",
    "menuIsOpen",
    "onChange",
    "onInputChange",
    "onMenuClose",
    "onMenuOpen",
    "value"
];
function $13021495c1d5bd05$export$3b14a55fb2447963(_ref) {
    var _ref$defaultInputValu = _ref.defaultInputValue, defaultInputValue = _ref$defaultInputValu === void 0 ? "" : _ref$defaultInputValu, _ref$defaultMenuIsOpe = _ref.defaultMenuIsOpen, defaultMenuIsOpen = _ref$defaultMenuIsOpe === void 0 ? false : _ref$defaultMenuIsOpe, _ref$defaultValue = _ref.defaultValue, defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue, propsInputValue = _ref.inputValue, propsMenuIsOpen = _ref.menuIsOpen, propsOnChange = _ref.onChange, propsOnInputChange = _ref.onInputChange, propsOnMenuClose = _ref.onMenuClose, propsOnMenuOpen = _ref.onMenuOpen, propsValue = _ref.value, restSelectProps = (0, $lTjB2.default)(_ref, $13021495c1d5bd05$var$_excluded);
    var _useState = (0, $kc00y.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue), _useState2 = (0, $jve2F.default)(_useState, 2), stateInputValue = _useState2[0], setStateInputValue = _useState2[1];
    var _useState3 = (0, $kc00y.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen), _useState4 = (0, $jve2F.default)(_useState3, 2), stateMenuIsOpen = _useState4[0], setStateMenuIsOpen = _useState4[1];
    var _useState5 = (0, $kc00y.useState)(propsValue !== undefined ? propsValue : defaultValue), _useState6 = (0, $jve2F.default)(_useState5, 2), stateValue = _useState6[0], setStateValue = _useState6[1];
    var onChange = (0, $kc00y.useCallback)(function(value, actionMeta) {
        if (typeof propsOnChange === "function") propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    var onInputChange = (0, $kc00y.useCallback)(function(value, actionMeta) {
        var newValue;
        if (typeof propsOnInputChange === "function") newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    var onMenuOpen = (0, $kc00y.useCallback)(function() {
        if (typeof propsOnMenuOpen === "function") propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    var onMenuClose = (0, $kc00y.useCallback)(function() {
        if (typeof propsOnMenuClose === "function") propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    var inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    var menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    var value = propsValue !== undefined ? propsValue : stateValue;
    return (0, $9CGAW.default)((0, $9CGAW.default)({}, restSelectProps), {}, {
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    });
}

});

parcelRegister("hAFP2", function(module, exports) {

var $hocAw = parcelRequire("hocAw");
function $cce63d7f01db7964$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $cce63d7f01db7964$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $cce63d7f01db7964$var$ownKeys(Object(t), !0).forEach(function(r) {
            $hocAw(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $cce63d7f01db7964$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
module.exports = $cce63d7f01db7964$var$_objectSpread2, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("hocAw", function(module, exports) {

var $1P3u1 = parcelRequire("1P3u1");
function $03445caa73b4730f$var$_defineProperty(e, r, t) {
    return (r = $1P3u1(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
module.exports = $03445caa73b4730f$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("1P3u1", function(module, exports) {

var $fVcyP = parcelRequire("fVcyP");
var $153d418f00b85638$var$_typeof = $fVcyP.default;

var $hID5n = parcelRequire("hID5n");
function $153d418f00b85638$var$toPropertyKey(t) {
    var i = $hID5n(t, "string");
    return "symbol" == $153d418f00b85638$var$_typeof(i) ? i : i + "";
}
module.exports = $153d418f00b85638$var$toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("fVcyP", function(module, exports) {
function $b975ec30bc1ea712$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $b975ec30bc1ea712$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $b975ec30bc1ea712$var$_typeof(o);
}
module.exports = $b975ec30bc1ea712$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("hID5n", function(module, exports) {

var $fVcyP = parcelRequire("fVcyP");
var $ce64dd5d7b311d26$var$_typeof = $fVcyP.default;
function $ce64dd5d7b311d26$var$toPrimitive(t, r) {
    if ("object" != $ce64dd5d7b311d26$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $ce64dd5d7b311d26$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = $ce64dd5d7b311d26$var$toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});




parcelRegister("9LOdT", function(module, exports) {

var $1qKYB = parcelRequire("1qKYB");

var $8qfZt = parcelRequire("8qfZt");

var $iriHA = parcelRequire("iriHA");

var $2VgVA = parcelRequire("2VgVA");
function $71cf7616ebda30a5$var$_slicedToArray(r, e) {
    return $1qKYB(r) || $8qfZt(r, e) || $iriHA(r, e) || $2VgVA();
}
module.exports = $71cf7616ebda30a5$var$_slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("1qKYB", function(module, exports) {
function $10aca8b7a246f62b$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
module.exports = $10aca8b7a246f62b$var$_arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("8qfZt", function(module, exports) {
function $01951d8ba4a7bb31$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
module.exports = $01951d8ba4a7bb31$var$_iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("iriHA", function(module, exports) {

var $2T7tm = parcelRequire("2T7tm");
function $d6c9416e8f31f9bb$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $2T7tm(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $2T7tm(r, a) : void 0;
    }
}
module.exports = $d6c9416e8f31f9bb$var$_unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("2T7tm", function(module, exports) {
function $21a683b3d4c8b236$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
module.exports = $21a683b3d4c8b236$var$_arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("2VgVA", function(module, exports) {
function $220e0920d83126f8$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $220e0920d83126f8$var$_nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("4FW7R", function(module, exports) {

var $ayk1R = parcelRequire("ayk1R");
function $3678145a06945e72$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $ayk1R(e, t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(r = 0; r < s.length; r++)o = s[r], t.includes(o) || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
module.exports = $3678145a06945e72$var$_objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("ayk1R", function(module, exports) {
function $7aec9db8cc2ca170$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = $7aec9db8cc2ca170$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("kdObC", function(module, exports) {
function $eb8bf3835a202303$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
module.exports = $eb8bf3835a202303$var$_classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("hcalg", function(module, exports) {

var $1P3u1 = parcelRequire("1P3u1");
function $c84b946174cde732$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $1P3u1(o.key), o);
    }
}
function $c84b946174cde732$var$_createClass(e, r, t) {
    return r && $c84b946174cde732$var$_defineProperties(e.prototype, r), t && $c84b946174cde732$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
module.exports = $c84b946174cde732$var$_createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("7y7MC", function(module, exports) {

var $azu3r = parcelRequire("azu3r");
function $57f1bef943053855$var$_inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && $azu3r(t, e);
}
module.exports = $57f1bef943053855$var$_inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("azu3r", function(module, exports) {
function $7b247c7a449b5c3a$var$_setPrototypeOf(t, e) {
    return module.exports = $7b247c7a449b5c3a$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $7b247c7a449b5c3a$var$_setPrototypeOf(t, e);
}
module.exports = $7b247c7a449b5c3a$var$_setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("jNv6Z", function(module, exports) {

var $2A3rZ = parcelRequire("2A3rZ");

var $3QqFj = parcelRequire("3QqFj");

var $3tiFo = parcelRequire("3tiFo");
function $e69aba0cbe4998ef$var$_createSuper(t) {
    var r = $3QqFj();
    return function() {
        var e, o = $2A3rZ(t);
        if (r) {
            var s = $2A3rZ(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return $3tiFo(this, e);
    };
}
module.exports = $e69aba0cbe4998ef$var$_createSuper, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("2A3rZ", function(module, exports) {
function $1e119ec65caabdbb$var$_getPrototypeOf(t) {
    return module.exports = $1e119ec65caabdbb$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $1e119ec65caabdbb$var$_getPrototypeOf(t);
}
module.exports = $1e119ec65caabdbb$var$_getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("3QqFj", function(module, exports) {
function $2ccae999fc5e7ba5$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (module.exports = $2ccae999fc5e7ba5$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $2ccae999fc5e7ba5$var$_isNativeReflectConstruct, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("3tiFo", function(module, exports) {

var $fVcyP = parcelRequire("fVcyP");
var $28728f57ae0b935d$var$_typeof = $fVcyP.default;

var $hAQhi = parcelRequire("hAQhi");
function $28728f57ae0b935d$var$_possibleConstructorReturn(t, e) {
    if (e && ("object" == $28728f57ae0b935d$var$_typeof(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return $hAQhi(t);
}
module.exports = $28728f57ae0b935d$var$_possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("hAQhi", function(module, exports) {
function $ccee59c42e4c6aff$var$_assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
module.exports = $ccee59c42e4c6aff$var$_assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("ka2wb", function(module, exports) {

var $8guKM = parcelRequire("8guKM");

var $6VFTB = parcelRequire("6VFTB");

var $iriHA = parcelRequire("iriHA");

var $hz3dE = parcelRequire("hz3dE");
function $ead6b1dbe6432833$var$_toConsumableArray(r) {
    return $8guKM(r) || $6VFTB(r) || $iriHA(r) || $hz3dE();
}
module.exports = $ead6b1dbe6432833$var$_toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("8guKM", function(module, exports) {

var $2T7tm = parcelRequire("2T7tm");
function $6047ac60b9f408ab$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $2T7tm(r);
}
module.exports = $6047ac60b9f408ab$var$_arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("6VFTB", function(module, exports) {
function $50b89095b5e4ca73$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
module.exports = $50b89095b5e4ca73$var$_iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("hz3dE", function(module, exports) {
function $cc9833d5aab497bd$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $cc9833d5aab497bd$var$_nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("jJWyQ", function(module, exports) {
function $e5efa54c95abeff3$var$_taggedTemplateLiteral(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}
module.exports = $e5efa54c95abeff3$var$_taggedTemplateLiteral, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("hpOSz", function(module, exports) {

$parcel$export(module.exports, "IconDelete", () => $5d60de8669fb33be$export$4d4e10ce882b8153);
$parcel$export(module.exports, "IconEdit", () => $5d60de8669fb33be$export$b51dd496211ae105);
$parcel$export(module.exports, "IconReplace", () => $5d60de8669fb33be$export$10f80189a986a34c);
$parcel$export(module.exports, "IconChevronDown", () => $5d60de8669fb33be$export$59f995884fc5e26a);
$parcel$export(module.exports, "IconChevronUp", () => $5d60de8669fb33be$export$744aedc8c31adee6);
$parcel$export(module.exports, "IconClose", () => $5d60de8669fb33be$export$e04bcc6127e699bf);
$parcel$export(module.exports, "IconError", () => $5d60de8669fb33be$export$66493327321323ad);
$parcel$export(module.exports, "IconCoucou", () => $5d60de8669fb33be$export$e6912b1db0955562);
$parcel$export(module.exports, "IconUpload", () => $5d60de8669fb33be$export$c6eac4a96cce5a2d);
$parcel$export(module.exports, "IconSave", () => $5d60de8669fb33be$export$b79f423a6f8a39be);
$parcel$export(module.exports, "IconGraduationCap", () => $5d60de8669fb33be$export$f6a6462deb3d3a49);
$parcel$export(module.exports, "IconPlay", () => $5d60de8669fb33be$export$4b2505a64d1f53bd);
$parcel$export(module.exports, "IconPower", () => $5d60de8669fb33be$export$370c443564d2be7c);
$parcel$export(module.exports, "IconHouseWindow", () => $5d60de8669fb33be$export$4c4fef1f3d1bc30e);
$parcel$export(module.exports, "IconLoading", () => $5d60de8669fb33be$export$56037a7cca3845e9);
$parcel$export(module.exports, "IconTable", () => $5d60de8669fb33be$export$84f497075f5b07be);
$parcel$export(module.exports, "IconFileExport", () => $5d60de8669fb33be$export$ba1e479511afc8fe);
$parcel$export(module.exports, "IconSearch", () => $5d60de8669fb33be$export$2be804e19c04baed);
$parcel$export(module.exports, "IconUsers", () => $5d60de8669fb33be$export$3c1e2245cb0ad1c7);
$parcel$export(module.exports, "IconCalendarDay", () => $5d60de8669fb33be$export$4c67f77382d9d269);
$parcel$export(module.exports, "IconFileDownload", () => $5d60de8669fb33be$export$65f0ca6531c3aeb6);
$parcel$export(module.exports, "IconUser", () => $5d60de8669fb33be$export$19b17a93dd1982ba);
$parcel$export(module.exports, "IconUserPen", () => $5d60de8669fb33be$export$8b29f8713a30f844);
$parcel$export(module.exports, "IconAddUsers", () => $5d60de8669fb33be$export$6895306589516cd4);
$parcel$export(module.exports, "IconAddUser", () => $5d60de8669fb33be$export$ebb77858007c2b45);
$parcel$export(module.exports, "IconExport", () => $5d60de8669fb33be$export$4a5ccdc9878f4668);
$parcel$export(module.exports, "IconInfo", () => $5d60de8669fb33be$export$340bfce9b4df026b);
$parcel$export(module.exports, "IconPhone", () => $5d60de8669fb33be$export$261fc039d6751d0e);
$parcel$export(module.exports, "IconBookCopy", () => $5d60de8669fb33be$export$9839bd2ab9a1cab1);
$parcel$export(module.exports, "Toggle", () => $5d60de8669fb33be$export$bea8ebba691c5813);
$parcel$export(module.exports, "IconOverview", () => $5d60de8669fb33be$export$d7cfde09abbb52ee);
$parcel$export(module.exports, "IconCheck", () => $5d60de8669fb33be$export$41713cd023818a26);
$parcel$export(module.exports, "IconCross", () => $5d60de8669fb33be$export$e4cc67793f5d3538);

var $cKvYK = parcelRequire("cKvYK");

const $5d60de8669fb33be$export$bbf803f6a2a59274 = ()=>/*#__PURE__*/ (0, $cKvYK.jsx)("i", {
        className: "fi fi-rr-home"
    });
const $5d60de8669fb33be$export$4d4e10ce882b8153 = ()=>/*#__PURE__*/ (0, $cKvYK.jsx)("i", {
        className: "fi fi-br-trash"
    });
const $5d60de8669fb33be$export$c69f659cef60c58b = ()=>/*#__PURE__*/ (0, $cKvYK.jsx)("i", {
        className: "fi fi-rr-power"
    });
const $5d60de8669fb33be$export$b51dd496211ae105 = ()=>/*#__PURE__*/ (0, $cKvYK.jsx)("i", {
        className: "fi fi-br-pencil"
    });
const $5d60de8669fb33be$export$10f80189a986a34c = ()=>/*#__PURE__*/ (0, $cKvYK.jsx)("i", {
        className: "fi fi-br-replace"
    });
const $5d60de8669fb33be$export$59f995884fc5e26a = ()=>/*#__PURE__*/ (0, $cKvYK.jsx)("i", {
        className: "fi fi-br-angle-small-down"
    });
const $5d60de8669fb33be$export$744aedc8c31adee6 = ()=>/*#__PURE__*/ (0, $cKvYK.jsx)("i", {
        className: "fi fi-br-angle-small-up"
    });
const $5d60de8669fb33be$export$e04bcc6127e699bf = ()=>/*#__PURE__*/ (0, $cKvYK.jsx)("i", {
        className: "fi fi-rr-cross"
    });
const $5d60de8669fb33be$export$66493327321323ad = ()=>/*#__PURE__*/ (0, $cKvYK.jsx)("i", {
        className: "fi fi-rr-cross"
    });
const $5d60de8669fb33be$export$e2df95fe2abd6d02 = ()=>/*#__PURE__*/ (0, $cKvYK.jsx)("i", {
        className: "fi fi-br-arrow-right"
    });
const $5d60de8669fb33be$export$e6912b1db0955562 = ()=>/*#__PURE__*/ (0, $cKvYK.jsx)("i", {
        className: "fi fi-br-hand-wave"
    });
const $5d60de8669fb33be$export$c6eac4a96cce5a2d = ()=>/*#__PURE__*/ (0, $cKvYK.jsx)("i", {
        className: "fi fi-br-upload"
    });
const $5d60de8669fb33be$export$b79f423a6f8a39be = ()=>/*#__PURE__*/ (0, $cKvYK.jsx)("i", {
        className: "fi fi-br-disk"
    });
const $5d60de8669fb33be$export$f6a6462deb3d3a49 = ()=>/*#__PURE__*/ (0, $cKvYK.jsx)("i", {
        className: "fi fi-br-graduation-cap"
    });
const $5d60de8669fb33be$export$4b2505a64d1f53bd = ()=>/*#__PURE__*/ (0, $cKvYK.jsx)("i", {
        className: "fi fi-sr-play-alt"
    });
const $5d60de8669fb33be$export$370c443564d2be7c = ()=>/*#__PURE__*/ (0, $cKvYK.jsx)("i", {
        className: "fi fi-br-power"
    });
const $5d60de8669fb33be$export$4c4fef1f3d1bc30e = ()=>/*#__PURE__*/ (0, $cKvYK.jsx)("i", {
        className: "fi fi-br-house-window"
    });
const $5d60de8669fb33be$export$56037a7cca3845e9 = ()=>/*#__PURE__*/ (0, $cKvYK.jsx)("i", {
        className: "fi fi-br-loading"
    });
const $5d60de8669fb33be$export$84f497075f5b07be = ()=>/*#__PURE__*/ (0, $cKvYK.jsx)("i", {
        className: "fi fi-br-table"
    });
const $5d60de8669fb33be$export$ba1e479511afc8fe = ()=>/*#__PURE__*/ (0, $cKvYK.jsx)("i", {
        className: "fi fi-br-file-export"
    });
const $5d60de8669fb33be$export$2be804e19c04baed = ()=>/*#__PURE__*/ (0, $cKvYK.jsx)("i", {
        className: "fi fi-br-search"
    });
const $5d60de8669fb33be$export$3c1e2245cb0ad1c7 = ()=>/*#__PURE__*/ (0, $cKvYK.jsx)("i", {
        className: "fi fi-br-users-gear"
    });
const $5d60de8669fb33be$export$4c67f77382d9d269 = ()=>/*#__PURE__*/ (0, $cKvYK.jsx)("i", {
        className: "fi fi-br-calendar-day"
    });
const $5d60de8669fb33be$export$65f0ca6531c3aeb6 = ()=>/*#__PURE__*/ (0, $cKvYK.jsx)("i", {
        className: "fi fi-br-file-download"
    });
const $5d60de8669fb33be$export$19b17a93dd1982ba = ()=>/*#__PURE__*/ (0, $cKvYK.jsx)("i", {
        className: "fi fi-br-user"
    });
const $5d60de8669fb33be$export$8b29f8713a30f844 = ()=>/*#__PURE__*/ (0, $cKvYK.jsx)("i", {
        className: "fi fi-br-user-pen"
    });
const $5d60de8669fb33be$export$6895306589516cd4 = ()=>/*#__PURE__*/ (0, $cKvYK.jsx)("i", {
        className: "fi fi-br-users-medical"
    });
const $5d60de8669fb33be$export$ebb77858007c2b45 = ()=>/*#__PURE__*/ (0, $cKvYK.jsx)("i", {
        className: "fi fi-br-user-add"
    });
const $5d60de8669fb33be$export$4a5ccdc9878f4668 = ()=>/*#__PURE__*/ (0, $cKvYK.jsx)("i", {
        className: "fi fi-br-file-export"
    });
const $5d60de8669fb33be$export$340bfce9b4df026b = ()=>/*#__PURE__*/ (0, $cKvYK.jsx)("i", {
        className: "fi fi-br-info"
    });
const $5d60de8669fb33be$export$261fc039d6751d0e = ()=>/*#__PURE__*/ (0, $cKvYK.jsx)("i", {
        className: "fi fi-br-phone-call"
    });
const $5d60de8669fb33be$export$9839bd2ab9a1cab1 = ()=>/*#__PURE__*/ (0, $cKvYK.jsx)("i", {
        className: "fi fi-br-book-copy"
    });
const $5d60de8669fb33be$export$bea8ebba691c5813 = ({ toggled: toggled = false })=>/*#__PURE__*/ (0, $cKvYK.jsx)("i", {
        className: toggled ? "fi fi-rr-toggle-on" : "fi fi-rr-toggle-off"
    });
const $5d60de8669fb33be$export$d7cfde09abbb52ee = ()=>/*#__PURE__*/ (0, $cKvYK.jsx)("i", {
        className: "fi fi-br-overview"
    });
const $5d60de8669fb33be$export$41713cd023818a26 = ()=>/*#__PURE__*/ (0, $cKvYK.jsx)("i", {
        className: "fi fi-br-check"
    });
const $5d60de8669fb33be$export$e4cc67793f5d3538 = ()=>/*#__PURE__*/ (0, $cKvYK.jsx)("i", {
        className: "fi fi-br-cross-small"
    });

});

parcelRegister("bYYyU", function(module, exports) {

$parcel$export(module.exports, "VARIANTS", () => $d8982dc335f711bb$export$1232696672e1505c);
$parcel$export(module.exports, "TYPE_BUTTON", () => $d8982dc335f711bb$export$324d92f8c11376d5);
$parcel$export(module.exports, "default", () => $d8982dc335f711bb$export$2e2bcd8739ae039);
$parcel$export(module.exports, "LinkButton", () => $d8982dc335f711bb$export$29d11c0fe2fc51d8);

var $cKvYK = parcelRequire("cKvYK");

var $lgiU2 = parcelRequire("lgiU2");

var $34UOG = parcelRequire("34UOG");
var $d8982dc335f711bb$export$1232696672e1505c;
(function(VARIANTS) {
    VARIANTS["primary"] = "primary";
    VARIANTS["secondary"] = "secondary";
    VARIANTS["info"] = "info";
    VARIANTS["success"] = "success";
    VARIANTS["error"] = "error";
    VARIANTS["warning"] = "warning";
})($d8982dc335f711bb$export$1232696672e1505c || ($d8982dc335f711bb$export$1232696672e1505c = {}));
var $d8982dc335f711bb$export$324d92f8c11376d5;
(function(TYPE_BUTTON) {
    TYPE_BUTTON[TYPE_BUTTON["button"] = 0] = "button";
    TYPE_BUTTON[TYPE_BUTTON["submit"] = 1] = "submit";
    TYPE_BUTTON[TYPE_BUTTON["reset"] = 2] = "reset";
})($d8982dc335f711bb$export$324d92f8c11376d5 || ($d8982dc335f711bb$export$324d92f8c11376d5 = {}));
const $d8982dc335f711bb$var$Button = ({ type: type = 0, variant: variant = "primary", children: children, className: className, ...rest })=>/*#__PURE__*/ (0, $cKvYK.jsx)("button", {
        ...rest,
        type: $d8982dc335f711bb$export$324d92f8c11376d5[type],
        className: (0, (/*@__PURE__*/$parcel$interopDefault($lgiU2)))((0, (/*@__PURE__*/$parcel$interopDefault($34UOG))).button, (0, (/*@__PURE__*/$parcel$interopDefault($34UOG)))[$d8982dc335f711bb$export$1232696672e1505c[variant]], className),
        children: children
    });
var $d8982dc335f711bb$export$2e2bcd8739ae039 = $d8982dc335f711bb$var$Button;
const $d8982dc335f711bb$export$29d11c0fe2fc51d8 = ({ className: className, variant: variant = "primary", href: href, children: children, ...rest })=>{
    return /*#__PURE__*/ (0, $cKvYK.jsx)("a", {
        ...rest,
        href: href,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($lgiU2)))("btn btn-" + [
            variant
        ] + " rounded-pill p-3 text-light text-uppercase", className),
        children: children
    });
};

});
parcelRegister("34UOG", function(module, exports) {

$parcel$export(module.exports, "button", () => $23ddd1663f104454$export$2ba01fb71ed41cb6, (v) => $23ddd1663f104454$export$2ba01fb71ed41cb6 = v);
$parcel$export(module.exports, "buttonLink", () => $23ddd1663f104454$export$a2da573beea6475e, (v) => $23ddd1663f104454$export$a2da573beea6475e = v);
$parcel$export(module.exports, "error", () => $23ddd1663f104454$export$a3bc9b8ed74fc, (v) => $23ddd1663f104454$export$a3bc9b8ed74fc = v);
$parcel$export(module.exports, "info", () => $23ddd1663f104454$export$a80b3bd66acc52ff, (v) => $23ddd1663f104454$export$a80b3bd66acc52ff = v);
$parcel$export(module.exports, "primary", () => $23ddd1663f104454$export$9ad721cf3b3debe0, (v) => $23ddd1663f104454$export$9ad721cf3b3debe0 = v);
$parcel$export(module.exports, "secondary", () => $23ddd1663f104454$export$745c6f71a1e0e6f7, (v) => $23ddd1663f104454$export$745c6f71a1e0e6f7 = v);
$parcel$export(module.exports, "secondaryInverse", () => $23ddd1663f104454$export$bcd0a71b11cd1b88, (v) => $23ddd1663f104454$export$bcd0a71b11cd1b88 = v);
$parcel$export(module.exports, "success", () => $23ddd1663f104454$export$fe7c49d056ea1d88, (v) => $23ddd1663f104454$export$fe7c49d056ea1d88 = v);
$parcel$export(module.exports, "warning", () => $23ddd1663f104454$export$491112666e282270, (v) => $23ddd1663f104454$export$491112666e282270 = v);
var $23ddd1663f104454$export$2ba01fb71ed41cb6;
var $23ddd1663f104454$export$a2da573beea6475e;
var $23ddd1663f104454$export$a3bc9b8ed74fc;
var $23ddd1663f104454$export$a80b3bd66acc52ff;
var $23ddd1663f104454$export$9ad721cf3b3debe0;
var $23ddd1663f104454$export$745c6f71a1e0e6f7;
var $23ddd1663f104454$export$bcd0a71b11cd1b88;
var $23ddd1663f104454$export$fe7c49d056ea1d88;
var $23ddd1663f104454$export$491112666e282270;
$23ddd1663f104454$export$2ba01fb71ed41cb6 = `SkXb5a_button`;
$23ddd1663f104454$export$a2da573beea6475e = `SkXb5a_buttonLink`;
$23ddd1663f104454$export$a3bc9b8ed74fc = `SkXb5a_error`;
$23ddd1663f104454$export$a80b3bd66acc52ff = `SkXb5a_info`;
$23ddd1663f104454$export$9ad721cf3b3debe0 = `SkXb5a_primary`;
$23ddd1663f104454$export$745c6f71a1e0e6f7 = `SkXb5a_secondary`;
$23ddd1663f104454$export$bcd0a71b11cd1b88 = `SkXb5a_secondaryInverse`;
$23ddd1663f104454$export$fe7c49d056ea1d88 = `SkXb5a_success`;
$23ddd1663f104454$export$491112666e282270 = `SkXb5a_warning`;

});


parcelRegister("7q6Xv", function(module, exports) {

$parcel$export(module.exports, "autocomplete", () => $56705bf4c5b973df$export$485ded5f26ebe08d, (v) => $56705bf4c5b973df$export$485ded5f26ebe08d = v);
$parcel$export(module.exports, "checkbox", () => $56705bf4c5b973df$export$b07e517d22efa1ca, (v) => $56705bf4c5b973df$export$b07e517d22efa1ca = v);
$parcel$export(module.exports, "clearButton", () => $56705bf4c5b973df$export$52aab205873de00, (v) => $56705bf4c5b973df$export$52aab205873de00 = v);
$parcel$export(module.exports, "clearableWrapper", () => $56705bf4c5b973df$export$914809e608013582, (v) => $56705bf4c5b973df$export$914809e608013582 = v);
$parcel$export(module.exports, "disabled", () => $56705bf4c5b973df$export$683472f6198a076e, (v) => $56705bf4c5b973df$export$683472f6198a076e = v);
$parcel$export(module.exports, "error", () => $56705bf4c5b973df$export$a3bc9b8ed74fc, (v) => $56705bf4c5b973df$export$a3bc9b8ed74fc = v);
$parcel$export(module.exports, "errorMessage", () => $56705bf4c5b973df$export$493b5823483d2c4e, (v) => $56705bf4c5b973df$export$493b5823483d2c4e = v);
$parcel$export(module.exports, "field", () => $56705bf4c5b973df$export$e0f35d825088c098, (v) => $56705bf4c5b973df$export$e0f35d825088c098 = v);
$parcel$export(module.exports, "fileInputButton", () => $56705bf4c5b973df$export$41cee58a5aa44fbc, (v) => $56705bf4c5b973df$export$41cee58a5aa44fbc = v);
$parcel$export(module.exports, "fileInputIcon", () => $56705bf4c5b973df$export$c76a31ed7ba5d9cf, (v) => $56705bf4c5b973df$export$c76a31ed7ba5d9cf = v);
$parcel$export(module.exports, "form", () => $56705bf4c5b973df$export$6210fa4921d2a466, (v) => $56705bf4c5b973df$export$6210fa4921d2a466 = v);
$parcel$export(module.exports, "icon", () => $56705bf4c5b973df$export$1ca1ec8b29a4ce27, (v) => $56705bf4c5b973df$export$1ca1ec8b29a4ce27 = v);
$parcel$export(module.exports, "input", () => $56705bf4c5b973df$export$b7e3ae3d7c15e42e, (v) => $56705bf4c5b973df$export$b7e3ae3d7c15e42e = v);
$parcel$export(module.exports, "inputDiv", () => $56705bf4c5b973df$export$a1036b42523c9fe8, (v) => $56705bf4c5b973df$export$a1036b42523c9fe8 = v);
$parcel$export(module.exports, "inputSearch", () => $56705bf4c5b973df$export$f78c4432585bf2ac, (v) => $56705bf4c5b973df$export$f78c4432585bf2ac = v);
$parcel$export(module.exports, "isActive", () => $56705bf4c5b973df$export$39e04e72f972b885, (v) => $56705bf4c5b973df$export$39e04e72f972b885 = v);
$parcel$export(module.exports, "isSelected", () => $56705bf4c5b973df$export$e4d153b3e021fb47, (v) => $56705bf4c5b973df$export$e4d153b3e021fb47 = v);
$parcel$export(module.exports, "item", () => $56705bf4c5b973df$export$7061c75fc5af8b7e, (v) => $56705bf4c5b973df$export$7061c75fc5af8b7e = v);
$parcel$export(module.exports, "label", () => $56705bf4c5b973df$export$1237798dc640739a, (v) => $56705bf4c5b973df$export$1237798dc640739a = v);
$parcel$export(module.exports, "labelCheckbox", () => $56705bf4c5b973df$export$344f17102956e4bc, (v) => $56705bf4c5b973df$export$344f17102956e4bc = v);
$parcel$export(module.exports, "largeTextInput", () => $56705bf4c5b973df$export$72e207023b13ed8, (v) => $56705bf4c5b973df$export$72e207023b13ed8 = v);
$parcel$export(module.exports, "legende", () => $56705bf4c5b973df$export$bffb63aff2fb9aad, (v) => $56705bf4c5b973df$export$bffb63aff2fb9aad = v);
$parcel$export(module.exports, "menu", () => $56705bf4c5b973df$export$b1e5508a851be14d, (v) => $56705bf4c5b973df$export$b1e5508a851be14d = v);
$parcel$export(module.exports, "multiCbCheckbox", () => $56705bf4c5b973df$export$588ca39cdadad083, (v) => $56705bf4c5b973df$export$588ca39cdadad083 = v);
$parcel$export(module.exports, "multiCbCheckboxActive", () => $56705bf4c5b973df$export$bb9d80110e47f9a8, (v) => $56705bf4c5b973df$export$bb9d80110e47f9a8 = v);
$parcel$export(module.exports, "notResolved", () => $56705bf4c5b973df$export$147a12733591c014, (v) => $56705bf4c5b973df$export$147a12733591c014 = v);
$parcel$export(module.exports, "numberInput", () => $56705bf4c5b973df$export$f9673d71791176c6, (v) => $56705bf4c5b973df$export$f9673d71791176c6 = v);
$parcel$export(module.exports, "obligatoire", () => $56705bf4c5b973df$export$70baf9ce46a106db, (v) => $56705bf4c5b973df$export$70baf9ce46a106db = v);
$parcel$export(module.exports, "reactSelect", () => $56705bf4c5b973df$export$d4b5f7d1d71beeb6, (v) => $56705bf4c5b973df$export$d4b5f7d1d71beeb6 = v);
$parcel$export(module.exports, "realCheckbox", () => $56705bf4c5b973df$export$46cf8f370a6a4e59, (v) => $56705bf4c5b973df$export$46cf8f370a6a4e59 = v);
$parcel$export(module.exports, "searchButton", () => $56705bf4c5b973df$export$29722c1eaadfd899, (v) => $56705bf4c5b973df$export$29722c1eaadfd899 = v);
$parcel$export(module.exports, "select", () => $56705bf4c5b973df$export$2e6c959c16ff56b8, (v) => $56705bf4c5b973df$export$2e6c959c16ff56b8 = v);
$parcel$export(module.exports, "textInput", () => $56705bf4c5b973df$export$181ff85155496734, (v) => $56705bf4c5b973df$export$181ff85155496734 = v);
$parcel$export(module.exports, "title", () => $56705bf4c5b973df$export$fb184b623420d9be, (v) => $56705bf4c5b973df$export$fb184b623420d9be = v);
$parcel$export(module.exports, "value", () => $56705bf4c5b973df$export$2ab9a8f9f1186f14, (v) => $56705bf4c5b973df$export$2ab9a8f9f1186f14 = v);
$parcel$export(module.exports, "valueField", () => $56705bf4c5b973df$export$214f6431972bd837, (v) => $56705bf4c5b973df$export$214f6431972bd837 = v);
$parcel$export(module.exports, "verticalLine", () => $56705bf4c5b973df$export$65259e741b4c5370, (v) => $56705bf4c5b973df$export$65259e741b4c5370 = v);
var $56705bf4c5b973df$export$485ded5f26ebe08d;
var $56705bf4c5b973df$export$b07e517d22efa1ca;
var $56705bf4c5b973df$export$52aab205873de00;
var $56705bf4c5b973df$export$914809e608013582;
var $56705bf4c5b973df$export$683472f6198a076e;
var $56705bf4c5b973df$export$a3bc9b8ed74fc;
var $56705bf4c5b973df$export$493b5823483d2c4e;
var $56705bf4c5b973df$export$e0f35d825088c098;
var $56705bf4c5b973df$export$41cee58a5aa44fbc;
var $56705bf4c5b973df$export$c76a31ed7ba5d9cf;
var $56705bf4c5b973df$export$6210fa4921d2a466;
var $56705bf4c5b973df$export$1ca1ec8b29a4ce27;
var $56705bf4c5b973df$export$b7e3ae3d7c15e42e;
var $56705bf4c5b973df$export$a1036b42523c9fe8;
var $56705bf4c5b973df$export$f78c4432585bf2ac;
var $56705bf4c5b973df$export$39e04e72f972b885;
var $56705bf4c5b973df$export$e4d153b3e021fb47;
var $56705bf4c5b973df$export$7061c75fc5af8b7e;
var $56705bf4c5b973df$export$1237798dc640739a;
var $56705bf4c5b973df$export$344f17102956e4bc;
var $56705bf4c5b973df$export$72e207023b13ed8;
var $56705bf4c5b973df$export$bffb63aff2fb9aad;
var $56705bf4c5b973df$export$b1e5508a851be14d;
var $56705bf4c5b973df$export$588ca39cdadad083;
var $56705bf4c5b973df$export$bb9d80110e47f9a8;
var $56705bf4c5b973df$export$147a12733591c014;
var $56705bf4c5b973df$export$f9673d71791176c6;
var $56705bf4c5b973df$export$70baf9ce46a106db;
var $56705bf4c5b973df$export$d4b5f7d1d71beeb6;
var $56705bf4c5b973df$export$46cf8f370a6a4e59;
var $56705bf4c5b973df$export$29722c1eaadfd899;
var $56705bf4c5b973df$export$2e6c959c16ff56b8;
var $56705bf4c5b973df$export$181ff85155496734;
var $56705bf4c5b973df$export$fb184b623420d9be;
var $56705bf4c5b973df$export$2ab9a8f9f1186f14;
var $56705bf4c5b973df$export$214f6431972bd837;
var $56705bf4c5b973df$export$65259e741b4c5370;
$56705bf4c5b973df$export$485ded5f26ebe08d = `upAz_W_autocomplete`;
$56705bf4c5b973df$export$b07e517d22efa1ca = `upAz_W_checkbox`;
$56705bf4c5b973df$export$52aab205873de00 = `upAz_W_clearButton`;
$56705bf4c5b973df$export$914809e608013582 = `upAz_W_clearableWrapper`;
$56705bf4c5b973df$export$683472f6198a076e = `upAz_W_disabled`;
$56705bf4c5b973df$export$a3bc9b8ed74fc = `upAz_W_error`;
$56705bf4c5b973df$export$493b5823483d2c4e = `upAz_W_errorMessage`;
$56705bf4c5b973df$export$e0f35d825088c098 = `upAz_W_field`;
$56705bf4c5b973df$export$41cee58a5aa44fbc = `upAz_W_fileInputButton`;
$56705bf4c5b973df$export$c76a31ed7ba5d9cf = `upAz_W_fileInputIcon`;
$56705bf4c5b973df$export$6210fa4921d2a466 = `upAz_W_form`;
$56705bf4c5b973df$export$1ca1ec8b29a4ce27 = `upAz_W_icon`;
$56705bf4c5b973df$export$b7e3ae3d7c15e42e = `upAz_W_input`;
$56705bf4c5b973df$export$a1036b42523c9fe8 = `upAz_W_inputDiv`;
$56705bf4c5b973df$export$f78c4432585bf2ac = `upAz_W_inputSearch`;
$56705bf4c5b973df$export$39e04e72f972b885 = `upAz_W_isActive`;
$56705bf4c5b973df$export$e4d153b3e021fb47 = `upAz_W_isSelected`;
$56705bf4c5b973df$export$7061c75fc5af8b7e = `upAz_W_item`;
$56705bf4c5b973df$export$1237798dc640739a = `upAz_W_label`;
$56705bf4c5b973df$export$344f17102956e4bc = `upAz_W_labelCheckbox`;
$56705bf4c5b973df$export$72e207023b13ed8 = `upAz_W_largeTextInput`;
$56705bf4c5b973df$export$bffb63aff2fb9aad = `upAz_W_legende`;
$56705bf4c5b973df$export$b1e5508a851be14d = `upAz_W_menu`;
$56705bf4c5b973df$export$588ca39cdadad083 = `upAz_W_multiCbCheckbox`;
$56705bf4c5b973df$export$bb9d80110e47f9a8 = `upAz_W_multiCbCheckboxActive`;
$56705bf4c5b973df$export$147a12733591c014 = `upAz_W_notResolved`;
$56705bf4c5b973df$export$f9673d71791176c6 = `upAz_W_numberInput`;
$56705bf4c5b973df$export$70baf9ce46a106db = `upAz_W_obligatoire`;
$56705bf4c5b973df$export$d4b5f7d1d71beeb6 = `upAz_W_reactSelect`;
$56705bf4c5b973df$export$46cf8f370a6a4e59 = `upAz_W_realCheckbox`;
$56705bf4c5b973df$export$29722c1eaadfd899 = `upAz_W_searchButton`;
$56705bf4c5b973df$export$2e6c959c16ff56b8 = `upAz_W_select`;
$56705bf4c5b973df$export$181ff85155496734 = `upAz_W_textInput`;
$56705bf4c5b973df$export$fb184b623420d9be = `upAz_W_title`;
$56705bf4c5b973df$export$2ab9a8f9f1186f14 = `upAz_W_value`;
$56705bf4c5b973df$export$214f6431972bd837 = `upAz_W_valueField`;
$56705bf4c5b973df$export$65259e741b4c5370 = `upAz_W_verticalLine`;

});



parcelRegister("gS6pX", function(module, exports) {

$parcel$export(module.exports, "getInitialValues", () => $ba1c4499888a9b03$export$a5cab80145b70e98);
$parcel$export(module.exports, "validationSchema", () => $ba1c4499888a9b03$export$c084437b5e3206cd);
$parcel$export(module.exports, "validationSchemaCreate", () => $ba1c4499888a9b03$export$193926a16525233);
$parcel$export(module.exports, "prepareVariables", () => $ba1c4499888a9b03$export$f97400759cfd946);
$parcel$export(module.exports, "default", () => $ba1c4499888a9b03$export$2e2bcd8739ae039);

var $cKvYK = parcelRequire("cKvYK");

var $bkJfK = parcelRequire("bkJfK");
parcelRequire("11UFl");
var $1ZTZh = parcelRequire("1ZTZh");

var $khgMO = parcelRequire("khgMO");

var $3BicN = parcelRequire("3BicN");

var $7hZVf = parcelRequire("7hZVf");

var $5TbRy = parcelRequire("5TbRy");

var $26Ddr = parcelRequire("26Ddr");

var $cFqbd = parcelRequire("cFqbd");

var $bNJBP = parcelRequire("bNJBP");

var $4VCRM = parcelRequire("4VCRM");

var $hpOSz = parcelRequire("hpOSz");
const $ba1c4499888a9b03$export$a5cab80145b70e98 = (data)=>({
        username: data?.username ?? null,
        listRole: data?.listRole ?? null
    });
const $ba1c4499888a9b03$export$c084437b5e3206cd = (0, $1ZTZh.create)({
    username: (0, $cFqbd.requiredString),
    listRole: (0, $cFqbd.requiredArray)
});
const $ba1c4499888a9b03$export$193926a16525233 = (0, $1ZTZh.create)({
    username: (0, $cFqbd.requiredString),
    listRole: (0, $cFqbd.requiredArray),
    utilisateurPassword: (0, $cFqbd.requiredString)
});
const $ba1c4499888a9b03$export$f97400759cfd946 = (data, values)=>({
        utilisateurId: data?.utilisateurId,
        username: values.username,
        listRole: values?.listRole,
        utilisateurPassword: values?.utilisateurPassword
    });
const $ba1c4499888a9b03$var$RoleUtilisateur = ({ isNew: isNew = false })=>{
    const { isSubmitting: isSubmitting } = (0, $bkJfK.useFormikContext)();
    const roles = (0, $26Ddr.useGet)((0, $5TbRy.default)`/api/roles/`);
    return /*#__PURE__*/ (0, $cKvYK.jsx)((0, $bNJBP.PageContent), {
        children: /*#__PURE__*/ (0, $cKvYK.jsxs)((0, $3BicN.Form), {
            children: [
                /*#__PURE__*/ (0, $cKvYK.jsx)((0, $4VCRM.default), {
                    icon: /*#__PURE__*/ (0, $cKvYK.jsx)((0, $hpOSz.IconUserPen), {}),
                    title: isNew ? "Cr\xe9ation d'un utilisateur" : "Mise \xe0 jour d'un utilisateur"
                }),
                /*#__PURE__*/ (0, $cKvYK.jsx)("br", {}),
                /*#__PURE__*/ (0, $cKvYK.jsx)((0, $3BicN.Text), {
                    label: "Identifiant",
                    name: "username",
                    disabled: isSubmitting || !isNew
                }),
                /*#__PURE__*/ (0, $cKvYK.jsx)((0, $3BicN.MultiSelectInput), {
                    label: "R\xf4les",
                    name: "listRole",
                    disabled: isSubmitting,
                    options: roles?.data ?? [],
                    getOptionValue: (r)=>r.roleId,
                    toOptionLabelFunc: (r)=>r.roleLibelle,
                    isClearable: false
                }),
                isNew && /*#__PURE__*/ (0, $cKvYK.jsx)((0, $3BicN.Password), {
                    label: "Mot de passe temporaire de l'utilisateur",
                    name: "utilisateurPassword",
                    placeholder: "Mot de passe"
                }),
                /*#__PURE__*/ (0, $cKvYK.jsxs)((0, $bNJBP.ActionBar), {
                    children: [
                        /*#__PURE__*/ (0, $cKvYK.jsx)((0, $khgMO.default), {
                            href: (0, $7hZVf.URLS).GESTION_UTILISATEURS,
                            variant: "primary",
                            className: "rounded-pill m-2 p-2",
                            children: "Retour"
                        }),
                        /*#__PURE__*/ (0, $cKvYK.jsx)((0, $khgMO.default), {
                            type: "submit",
                            variant: "primary-100",
                            className: "rounded-pill m-2 p-2",
                            children: "Valider"
                        })
                    ]
                })
            ]
        })
    });
};
var $ba1c4499888a9b03$export$2e2bcd8739ae039 = $ba1c4499888a9b03$var$RoleUtilisateur;

});
parcelRegister("11UFl", function(module, exports) {

$parcel$export(module.exports, "mixed", () => (parcelRequire("eBJfs")).create);
$parcel$export(module.exports, "bool", () => (parcelRequire("5hWhW")).create);
$parcel$export(module.exports, "string", () => (parcelRequire("ukLGy")).create);
$parcel$export(module.exports, "number", () => (parcelRequire("2rGWI")).create);
$parcel$export(module.exports, "date", () => (parcelRequire("8Fw82")).create);
$parcel$export(module.exports, "object", () => (parcelRequire("1ZTZh")).create);
$parcel$export(module.exports, "array", () => (parcelRequire("9686H")).create);

var $eBJfs = parcelRequire("eBJfs");

var $5hWhW = parcelRequire("5hWhW");

var $ukLGy = parcelRequire("ukLGy");

var $2rGWI = parcelRequire("2rGWI");

var $8Fw82 = parcelRequire("8Fw82");

var $1ZTZh = parcelRequire("1ZTZh");

var $9686H = parcelRequire("9686H");

var $fGxXP = parcelRequire("fGxXP");

var $9HeTq = parcelRequire("9HeTq");

var $41aWH = parcelRequire("41aWH");

var $b9Jng = parcelRequire("b9Jng");

var $93uAf = parcelRequire("93uAf");

var $fgPD0 = parcelRequire("fgPD0");

var $8Cojz = parcelRequire("8Cojz");
function $0c01d71d2434c7c3$export$20be359f745f973c(schemaType, name, fn) {
    if (!schemaType || !(0, $93uAf.default)(schemaType.prototype)) throw new TypeError("You must provide a yup schema constructor function");
    if (typeof name !== "string") throw new TypeError("A Method name must be provided");
    if (typeof fn !== "function") throw new TypeError("Method function must be provided");
    schemaType.prototype[name] = fn;
}

});
parcelRegister("eBJfs", function(module, exports) {

$parcel$export(module.exports, "create", () => $aa279ec1bee0dcbc$export$185802fd694ee1f5);

var $8Cojz = parcelRequire("8Cojz");
const $aa279ec1bee0dcbc$var$Mixed = (0, $8Cojz.default);
var $aa279ec1bee0dcbc$export$2e2bcd8739ae039 = $aa279ec1bee0dcbc$var$Mixed;
function $aa279ec1bee0dcbc$export$185802fd694ee1f5() {
    return new $aa279ec1bee0dcbc$var$Mixed();
} // XXX: this is using the Base schema so that `addMethod(mixed)` works as a base class
$aa279ec1bee0dcbc$export$185802fd694ee1f5.prototype = $aa279ec1bee0dcbc$var$Mixed.prototype;

});
parcelRegister("8Cojz", function(module, exports) {

$parcel$export(module.exports, "default", () => $6464bbb49cb4ea42$export$2e2bcd8739ae039);

var $7swS7 = parcelRequire("7swS7");

var $dZq6i = parcelRequire("dZq6i");

var $kvZAX = parcelRequire("kvZAX");

var $epCOP = parcelRequire("epCOP");

var $fYFLY = parcelRequire("fYFLY");

var $6J2zD = parcelRequire("6J2zD");

var $fGxXP = parcelRequire("fGxXP");

var $b9Jng = parcelRequire("b9Jng");

var $41aWH = parcelRequire("41aWH");

var $7dTXW = parcelRequire("7dTXW");

var $d1E9x = parcelRequire("d1E9x");
function $6464bbb49cb4ea42$var$_extends() {
    $6464bbb49cb4ea42$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6464bbb49cb4ea42$var$_extends.apply(this, arguments);
}
class $6464bbb49cb4ea42$export$2e2bcd8739ae039 {
    constructor(options){
        this.deps = [];
        this.tests = void 0;
        this.transforms = void 0;
        this.conditions = [];
        this._mutate = void 0;
        this._typeError = void 0;
        this._whitelist = new (0, $7dTXW.default)();
        this._blacklist = new (0, $7dTXW.default)();
        this.exclusiveTests = Object.create(null);
        this.spec = void 0;
        this.tests = [];
        this.transforms = [];
        this.withMutation(()=>{
            this.typeError((0, $dZq6i.mixed).notType);
        });
        this.type = (options == null ? void 0 : options.type) || "mixed";
        this.spec = $6464bbb49cb4ea42$var$_extends({
            strip: false,
            strict: false,
            abortEarly: true,
            recursive: true,
            nullable: false,
            presence: "optional"
        }, options == null ? void 0 : options.spec);
    }
    get _type() {
        return this.type;
    }
    _typeCheck(_value) {
        return true;
    }
    clone(spec) {
        if (this._mutate) {
            if (spec) Object.assign(this.spec, spec);
            return this;
        } // if the nested value is a schema we can skip cloning, since
        // they are already immutable
        const next = Object.create(Object.getPrototypeOf(this)); // @ts-expect-error this is readonly
        next.type = this.type;
        next._typeError = this._typeError;
        next._whitelistError = this._whitelistError;
        next._blacklistError = this._blacklistError;
        next._whitelist = this._whitelist.clone();
        next._blacklist = this._blacklist.clone();
        next.exclusiveTests = $6464bbb49cb4ea42$var$_extends({}, this.exclusiveTests); // @ts-expect-error this is readonly
        next.deps = [
            ...this.deps
        ];
        next.conditions = [
            ...this.conditions
        ];
        next.tests = [
            ...this.tests
        ];
        next.transforms = [
            ...this.transforms
        ];
        next.spec = (0, $7swS7.default)($6464bbb49cb4ea42$var$_extends({}, this.spec, spec));
        return next;
    }
    label(label) {
        let next = this.clone();
        next.spec.label = label;
        return next;
    }
    meta(...args) {
        if (args.length === 0) return this.spec.meta;
        let next = this.clone();
        next.spec.meta = Object.assign(next.spec.meta || {}, args[0]);
        return next;
    }
    //   TCast,
    //   TContext,
    //   TOutput
    // > {
    //   return this as any;
    // }
    withMutation(fn) {
        let before = this._mutate;
        this._mutate = true;
        let result = fn(this);
        this._mutate = before;
        return result;
    }
    concat(schema) {
        if (!schema || schema === this) return this;
        if (schema.type !== this.type && this.type !== "mixed") throw new TypeError(`You cannot \`concat()\` schema's of different types: ${this.type} and ${schema.type}`);
        let base = this;
        let combined = schema.clone();
        const mergedSpec = $6464bbb49cb4ea42$var$_extends({}, base.spec, combined.spec); // if (combined.spec.nullable === UNSET)
        //   mergedSpec.nullable = base.spec.nullable;
        // if (combined.spec.presence === UNSET)
        //   mergedSpec.presence = base.spec.presence;
        combined.spec = mergedSpec;
        combined._typeError || (combined._typeError = base._typeError);
        combined._whitelistError || (combined._whitelistError = base._whitelistError);
        combined._blacklistError || (combined._blacklistError = base._blacklistError); // manually merge the blacklist/whitelist (the other `schema` takes
        // precedence in case of conflicts)
        combined._whitelist = base._whitelist.merge(schema._whitelist, schema._blacklist);
        combined._blacklist = base._blacklist.merge(schema._blacklist, schema._whitelist); // start with the current tests
        combined.tests = base.tests;
        combined.exclusiveTests = base.exclusiveTests; // manually add the new tests to ensure
        // the deduping logic is consistent
        combined.withMutation((next)=>{
            schema.tests.forEach((fn)=>{
                next.test(fn.OPTIONS);
            });
        });
        combined.transforms = [
            ...base.transforms,
            ...combined.transforms
        ];
        return combined;
    }
    isType(v) {
        if (this.spec.nullable && v === null) return true;
        return this._typeCheck(v);
    }
    resolve(options) {
        let schema = this;
        if (schema.conditions.length) {
            let conditions = schema.conditions;
            schema = schema.clone();
            schema.conditions = [];
            schema = conditions.reduce((schema, condition)=>condition.resolve(schema, options), schema);
            schema = schema.resolve(options);
        }
        return schema;
    }
    /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {*=} options.parent
   * @param {*=} options.context
   */ cast(value, options = {}) {
        let resolvedSchema = this.resolve($6464bbb49cb4ea42$var$_extends({
            value: value
        }, options));
        let result = resolvedSchema._cast(value, options);
        if (value !== undefined && options.assert !== false && resolvedSchema.isType(result) !== true) {
            let formattedValue = (0, $6J2zD.default)(value);
            let formattedResult = (0, $6J2zD.default)(result);
            throw new TypeError(`The value of ${options.path || "field"} could not be cast to a value ` + `that satisfies the schema type: "${resolvedSchema._type}". \n\n` + `attempted value: ${formattedValue} \n` + (formattedResult !== formattedValue ? `result of cast: ${formattedResult}` : ""));
        }
        return result;
    }
    _cast(rawValue, _options) {
        let value = rawValue === undefined ? rawValue : this.transforms.reduce((value, fn)=>fn.call(this, value, rawValue, this), rawValue);
        if (value === undefined) value = this.getDefault();
        return value;
    }
    _validate(_value, options = {}, cb) {
        let { sync: sync, path: path, from: from = [], originalValue: originalValue = _value, strict: strict = this.spec.strict, abortEarly: abortEarly = this.spec.abortEarly } = options;
        let value = _value;
        if (!strict) // this._validating = true;
        value = this._cast(value, $6464bbb49cb4ea42$var$_extends({
            assert: false
        }, options)); // this._validating = false;
         // value is cast, we can check if it meets type requirements
        let args = {
            value: value,
            path: path,
            options: options,
            originalValue: originalValue,
            schema: this,
            label: this.spec.label,
            sync: sync,
            from: from
        };
        let initialTests = [];
        if (this._typeError) initialTests.push(this._typeError);
        let finalTests = [];
        if (this._whitelistError) finalTests.push(this._whitelistError);
        if (this._blacklistError) finalTests.push(this._blacklistError);
        (0, $epCOP.default)({
            args: args,
            value: value,
            path: path,
            sync: sync,
            tests: initialTests,
            endEarly: abortEarly
        }, (err)=>{
            if (err) return void cb(err, value);
            (0, $epCOP.default)({
                tests: this.tests.concat(finalTests),
                args: args,
                path: path,
                sync: sync,
                value: value,
                endEarly: abortEarly
            }, cb);
        });
    }
    validate(value, options, maybeCb) {
        let schema = this.resolve($6464bbb49cb4ea42$var$_extends({}, options, {
            value: value
        })); // callback case is for nested validations
        return typeof maybeCb === "function" ? schema._validate(value, options, maybeCb) : new Promise((resolve, reject)=>schema._validate(value, options, (err, value)=>{
                if (err) reject(err);
                else resolve(value);
            }));
    }
    validateSync(value, options) {
        let schema = this.resolve($6464bbb49cb4ea42$var$_extends({}, options, {
            value: value
        }));
        let result;
        schema._validate(value, $6464bbb49cb4ea42$var$_extends({}, options, {
            sync: true
        }), (err, value)=>{
            if (err) throw err;
            result = value;
        });
        return result;
    }
    isValid(value, options) {
        return this.validate(value, options).then(()=>true, (err)=>{
            if ((0, $41aWH.default).isError(err)) return false;
            throw err;
        });
    }
    isValidSync(value, options) {
        try {
            this.validateSync(value, options);
            return true;
        } catch (err) {
            if ((0, $41aWH.default).isError(err)) return false;
            throw err;
        }
    }
    _getDefault() {
        let defaultValue = this.spec.default;
        if (defaultValue == null) return defaultValue;
        return typeof defaultValue === "function" ? defaultValue.call(this) : (0, $7swS7.default)(defaultValue);
    }
    getDefault(options) {
        let schema = this.resolve(options || {});
        return schema._getDefault();
    }
    default(def) {
        if (arguments.length === 0) return this._getDefault();
        let next = this.clone({
            default: def
        });
        return next;
    }
    strict(isStrict = true) {
        let next = this.clone();
        next.spec.strict = isStrict;
        return next;
    }
    _isPresent(value) {
        return value != null;
    }
    defined(message = (0, $dZq6i.mixed).defined) {
        return this.test({
            message: message,
            name: "defined",
            exclusive: true,
            test (value) {
                return value !== undefined;
            }
        });
    }
    required(message = (0, $dZq6i.mixed).required) {
        return this.clone({
            presence: "required"
        }).withMutation((s)=>s.test({
                message: message,
                name: "required",
                exclusive: true,
                test (value) {
                    return this.schema._isPresent(value);
                }
            }));
    }
    notRequired() {
        let next = this.clone({
            presence: "optional"
        });
        next.tests = next.tests.filter((test)=>test.OPTIONS.name !== "required");
        return next;
    }
    nullable(isNullable = true) {
        let next = this.clone({
            nullable: isNullable !== false
        });
        return next;
    }
    transform(fn) {
        let next = this.clone();
        next.transforms.push(fn);
        return next;
    }
    /**
   * Adds a test function to the schema's queue of tests.
   * tests can be exclusive or non-exclusive.
   *
   * - exclusive tests, will replace any existing tests of the same name.
   * - non-exclusive: can be stacked
   *
   * If a non-exclusive test is added to a schema with an exclusive test of the same name
   * the exclusive test is removed and further tests of the same name will be stacked.
   *
   * If an exclusive test is added to a schema with non-exclusive tests of the same name
   * the previous tests are removed and further tests of the same name will replace each other.
   */ test(...args) {
        let opts;
        if (args.length === 1) {
            if (typeof args[0] === "function") opts = {
                test: args[0]
            };
            else opts = args[0];
        } else if (args.length === 2) opts = {
            name: args[0],
            test: args[1]
        };
        else opts = {
            name: args[0],
            message: args[1],
            test: args[2]
        };
        if (opts.message === undefined) opts.message = (0, $dZq6i.mixed).default;
        if (typeof opts.test !== "function") throw new TypeError("`test` is a required parameters");
        let next = this.clone();
        let validate = (0, $fYFLY.default)(opts);
        let isExclusive = opts.exclusive || opts.name && next.exclusiveTests[opts.name] === true;
        if (opts.exclusive) {
            if (!opts.name) throw new TypeError("Exclusive tests must provide a unique `name` identifying the test");
        }
        if (opts.name) next.exclusiveTests[opts.name] = !!opts.exclusive;
        next.tests = next.tests.filter((fn)=>{
            if (fn.OPTIONS.name === opts.name) {
                if (isExclusive) return false;
                if (fn.OPTIONS.test === validate.OPTIONS.test) return false;
            }
            return true;
        });
        next.tests.push(validate);
        return next;
    }
    when(keys, options) {
        if (!Array.isArray(keys) && typeof keys !== "string") {
            options = keys;
            keys = ".";
        }
        let next = this.clone();
        let deps = (0, $d1E9x.default)(keys).map((key)=>new (0, $fGxXP.default)(key));
        deps.forEach((dep)=>{
            // @ts-ignore
            if (dep.isSibling) next.deps.push(dep.key);
        });
        next.conditions.push(new (0, $kvZAX.default)(deps, options));
        return next;
    }
    typeError(message) {
        let next = this.clone();
        next._typeError = (0, $fYFLY.default)({
            message: message,
            name: "typeError",
            test (value) {
                if (value !== undefined && !this.schema.isType(value)) return this.createError({
                    params: {
                        type: this.schema._type
                    }
                });
                return true;
            }
        });
        return next;
    }
    oneOf(enums, message = (0, $dZq6i.mixed).oneOf) {
        let next = this.clone();
        enums.forEach((val)=>{
            next._whitelist.add(val);
            next._blacklist.delete(val);
        });
        next._whitelistError = (0, $fYFLY.default)({
            message: message,
            name: "oneOf",
            test (value) {
                if (value === undefined) return true;
                let valids = this.schema._whitelist;
                let resolved = valids.resolveAll(this.resolve);
                return resolved.includes(value) ? true : this.createError({
                    params: {
                        values: valids.toArray().join(", "),
                        resolved: resolved
                    }
                });
            }
        });
        return next;
    }
    notOneOf(enums, message = (0, $dZq6i.mixed).notOneOf) {
        let next = this.clone();
        enums.forEach((val)=>{
            next._blacklist.add(val);
            next._whitelist.delete(val);
        });
        next._blacklistError = (0, $fYFLY.default)({
            message: message,
            name: "notOneOf",
            test (value) {
                let invalids = this.schema._blacklist;
                let resolved = invalids.resolveAll(this.resolve);
                if (resolved.includes(value)) return this.createError({
                    params: {
                        values: invalids.toArray().join(", "),
                        resolved: resolved
                    }
                });
                return true;
            }
        });
        return next;
    }
    strip(strip = true) {
        let next = this.clone();
        next.spec.strip = strip;
        return next;
    }
    describe() {
        const next = this.clone();
        const { label: label, meta: meta } = next.spec;
        const description = {
            meta: meta,
            label: label,
            type: next.type,
            oneOf: next._whitelist.describe(),
            notOneOf: next._blacklist.describe(),
            tests: next.tests.map((fn)=>({
                    name: fn.OPTIONS.name,
                    params: fn.OPTIONS.params
                })).filter((n, idx, list)=>list.findIndex((c)=>c.name === n.name) === idx)
        };
        return description;
    }
} // eslint-disable-next-line @typescript-eslint/no-unused-vars
// @ts-expect-error
$6464bbb49cb4ea42$export$2e2bcd8739ae039.prototype.__isYupSchema__ = true;
for (const method of [
    "validate",
    "validateSync"
])$6464bbb49cb4ea42$export$2e2bcd8739ae039.prototype[`${method}At`] = function(path, value, options = {}) {
    const { parent: parent, parentPath: parentPath, schema: schema } = (0, $b9Jng.getIn)(this, path, value, options.context);
    return schema[method](parent && parent[parentPath], $6464bbb49cb4ea42$var$_extends({}, options, {
        parent: parent,
        path: path
    }));
};
for (const alias of [
    "equals",
    "is"
])$6464bbb49cb4ea42$export$2e2bcd8739ae039.prototype[alias] = $6464bbb49cb4ea42$export$2e2bcd8739ae039.prototype.oneOf;
for (const alias of [
    "not",
    "nope"
])$6464bbb49cb4ea42$export$2e2bcd8739ae039.prototype[alias] = $6464bbb49cb4ea42$export$2e2bcd8739ae039.prototype.notOneOf;
$6464bbb49cb4ea42$export$2e2bcd8739ae039.prototype.optional = $6464bbb49cb4ea42$export$2e2bcd8739ae039.prototype.notRequired;

});
parcelRegister("7swS7", function(module, exports) {

$parcel$export(module.exports, "default", () => $56e4a59f723d7fa9$export$2e2bcd8739ae039);
// ES6 Map
var $56e4a59f723d7fa9$var$map;
try {
    $56e4a59f723d7fa9$var$map = Map;
} catch (_) {}
var $56e4a59f723d7fa9$var$set;
// ES6 Set
try {
    $56e4a59f723d7fa9$var$set = Set;
} catch (_) {}
function $56e4a59f723d7fa9$var$baseClone(src, circulars, clones) {
    // Null/undefined/functions/etc
    if (!src || typeof src !== "object" || typeof src === "function") return src;
    // DOM Node
    if (src.nodeType && "cloneNode" in src) return src.cloneNode(true);
    // Date
    if (src instanceof Date) return new Date(src.getTime());
    // RegExp
    if (src instanceof RegExp) return new RegExp(src);
    // Arrays
    if (Array.isArray(src)) return src.map($56e4a59f723d7fa9$export$2e2bcd8739ae039);
    // ES6 Maps
    if ($56e4a59f723d7fa9$var$map && src instanceof $56e4a59f723d7fa9$var$map) return new Map(Array.from(src.entries()));
    // ES6 Sets
    if ($56e4a59f723d7fa9$var$set && src instanceof $56e4a59f723d7fa9$var$set) return new Set(Array.from(src.values()));
    // Object
    if (src instanceof Object) {
        circulars.push(src);
        var obj = Object.create(src);
        clones.push(obj);
        for(var key in src){
            var idx = circulars.findIndex(function(i) {
                return i === src[key];
            });
            obj[key] = idx > -1 ? clones[idx] : $56e4a59f723d7fa9$var$baseClone(src[key], circulars, clones);
        }
        return obj;
    }
    // ???
    return src;
}
function $56e4a59f723d7fa9$export$2e2bcd8739ae039(src) {
    return $56e4a59f723d7fa9$var$baseClone(src, [], []);
}

});

parcelRegister("dZq6i", function(module, exports) {

$parcel$export(module.exports, "mixed", () => $a2f537e375d5217f$export$9b30b6294c1449a8);
$parcel$export(module.exports, "string", () => $a2f537e375d5217f$export$22b082955e083ec3);
$parcel$export(module.exports, "number", () => $a2f537e375d5217f$export$98e628dec113755e);
$parcel$export(module.exports, "date", () => $a2f537e375d5217f$export$324d90190a8b822a);
$parcel$export(module.exports, "boolean", () => $a2f537e375d5217f$export$4a21f16c33752377);
$parcel$export(module.exports, "object", () => $a2f537e375d5217f$export$be5493f9613cbbe);
$parcel$export(module.exports, "array", () => $a2f537e375d5217f$export$2f23118c22fb2630);
$parcel$export(module.exports, "default", () => $a2f537e375d5217f$export$2e2bcd8739ae039);

var $6J2zD = parcelRequire("6J2zD");
let $a2f537e375d5217f$export$9b30b6294c1449a8 = {
    default: "${path} is invalid",
    required: "${path} is a required field",
    oneOf: "${path} must be one of the following values: ${values}",
    notOneOf: "${path} must not be one of the following values: ${values}",
    notType: ({ path: path, type: type, value: value, originalValue: originalValue })=>{
        let isCast = originalValue != null && originalValue !== value;
        let msg = `${path} must be a \`${type}\` type, ` + `but the final value was: \`${(0, $6J2zD.default)(value, true)}\`` + (isCast ? ` (cast from the value \`${(0, $6J2zD.default)(originalValue, true)}\`).` : ".");
        if (value === null) msg += `\n If "null" is intended as an empty value be sure to mark the schema as \`.nullable()\``;
        return msg;
    },
    defined: "${path} must be defined"
};
let $a2f537e375d5217f$export$22b082955e083ec3 = {
    length: "${path} must be exactly ${length} characters",
    min: "${path} must be at least ${min} characters",
    max: "${path} must be at most ${max} characters",
    matches: '${path} must match the following: "${regex}"',
    email: "${path} must be a valid email",
    url: "${path} must be a valid URL",
    uuid: "${path} must be a valid UUID",
    trim: "${path} must be a trimmed string",
    lowercase: "${path} must be a lowercase string",
    uppercase: "${path} must be a upper case string"
};
let $a2f537e375d5217f$export$98e628dec113755e = {
    min: "${path} must be greater than or equal to ${min}",
    max: "${path} must be less than or equal to ${max}",
    lessThan: "${path} must be less than ${less}",
    moreThan: "${path} must be greater than ${more}",
    positive: "${path} must be a positive number",
    negative: "${path} must be a negative number",
    integer: "${path} must be an integer"
};
let $a2f537e375d5217f$export$324d90190a8b822a = {
    min: "${path} field must be later than ${min}",
    max: "${path} field must be at earlier than ${max}"
};
let $a2f537e375d5217f$export$4a21f16c33752377 = {
    isValue: "${path} field must be ${value}"
};
let $a2f537e375d5217f$export$be5493f9613cbbe = {
    noUnknown: "${path} field has unspecified keys: ${unknown}"
};
let $a2f537e375d5217f$export$2f23118c22fb2630 = {
    min: "${path} field must have at least ${min} items",
    max: "${path} field must have less than or equal to ${max} items",
    length: "${path} must have ${length} items"
};
var $a2f537e375d5217f$export$2e2bcd8739ae039 = Object.assign(Object.create(null), {
    mixed: $a2f537e375d5217f$export$9b30b6294c1449a8,
    string: $a2f537e375d5217f$export$22b082955e083ec3,
    number: $a2f537e375d5217f$export$98e628dec113755e,
    date: $a2f537e375d5217f$export$324d90190a8b822a,
    object: $a2f537e375d5217f$export$be5493f9613cbbe,
    array: $a2f537e375d5217f$export$2f23118c22fb2630,
    boolean: $a2f537e375d5217f$export$4a21f16c33752377
});

});
parcelRegister("6J2zD", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e58f129f23a825c$export$2e2bcd8739ae039);
const $4e58f129f23a825c$var$toString = Object.prototype.toString;
const $4e58f129f23a825c$var$errorToString = Error.prototype.toString;
const $4e58f129f23a825c$var$regExpToString = RegExp.prototype.toString;
const $4e58f129f23a825c$var$symbolToString = typeof Symbol !== "undefined" ? Symbol.prototype.toString : ()=>"";
const $4e58f129f23a825c$var$SYMBOL_REGEXP = /^Symbol\((.*)\)(.*)$/;
function $4e58f129f23a825c$var$printNumber(val) {
    if (val != +val) return "NaN";
    const isNegativeZero = val === 0 && 1 / val < 0;
    return isNegativeZero ? "-0" : "" + val;
}
function $4e58f129f23a825c$var$printSimpleValue(val, quoteStrings = false) {
    if (val == null || val === true || val === false) return "" + val;
    const typeOf = typeof val;
    if (typeOf === "number") return $4e58f129f23a825c$var$printNumber(val);
    if (typeOf === "string") return quoteStrings ? `"${val}"` : val;
    if (typeOf === "function") return "[Function " + (val.name || "anonymous") + "]";
    if (typeOf === "symbol") return $4e58f129f23a825c$var$symbolToString.call(val).replace($4e58f129f23a825c$var$SYMBOL_REGEXP, "Symbol($1)");
    const tag = $4e58f129f23a825c$var$toString.call(val).slice(8, -1);
    if (tag === "Date") return isNaN(val.getTime()) ? "" + val : val.toISOString(val);
    if (tag === "Error" || val instanceof Error) return "[" + $4e58f129f23a825c$var$errorToString.call(val) + "]";
    if (tag === "RegExp") return $4e58f129f23a825c$var$regExpToString.call(val);
    return null;
}
function $4e58f129f23a825c$export$2e2bcd8739ae039(value, quoteStrings) {
    let result = $4e58f129f23a825c$var$printSimpleValue(value, quoteStrings);
    if (result !== null) return result;
    return JSON.stringify(value, function(key, value) {
        let result = $4e58f129f23a825c$var$printSimpleValue(this[key], quoteStrings);
        if (result !== null) return result;
        return value;
    }, 2);
}

});


parcelRegister("kvZAX", function(module, exports) {

$parcel$export(module.exports, "default", () => $eef67b6becae94b1$export$2e2bcd8739ae039);

var $2xkoI = parcelRequire("2xkoI");

var $93uAf = parcelRequire("93uAf");
class $eef67b6becae94b1$var$Condition {
    constructor(refs, options){
        this.fn = void 0;
        this.refs = refs;
        this.refs = refs;
        if (typeof options === "function") {
            this.fn = options;
            return;
        }
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($2xkoI)))(options, "is")) throw new TypeError("`is:` is required for `when()` conditions");
        if (!options.then && !options.otherwise) throw new TypeError("either `then:` or `otherwise:` is required for `when()` conditions");
        let { is: is, then: then, otherwise: otherwise } = options;
        let check = typeof is === "function" ? is : (...values)=>values.every((value)=>value === is);
        this.fn = function(...args) {
            let options = args.pop();
            let schema = args.pop();
            let branch = check(...args) ? then : otherwise;
            if (!branch) return undefined;
            if (typeof branch === "function") return branch(schema);
            return schema.concat(branch.resolve(options));
        };
    }
    resolve(base, options) {
        let values = this.refs.map((ref)=>ref.getValue(options == null ? void 0 : options.value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context));
        let schema = this.fn.apply(base, values.concat(base, options));
        if (schema === undefined || schema === base) return base;
        if (!(0, $93uAf.default)(schema)) throw new TypeError("conditions must return a schema object");
        return schema.resolve(options);
    }
}
var $eef67b6becae94b1$export$2e2bcd8739ae039 = $eef67b6becae94b1$var$Condition;

});
parcelRegister("2xkoI", function(module, exports) {

var $daVZy = parcelRequire("daVZy");

var $7tSIP = parcelRequire("7tSIP");
/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */ function $1d8e7c60639ddced$var$has(object, path) {
    return object != null && $7tSIP(object, path, $daVZy);
}
module.exports = $1d8e7c60639ddced$var$has;

});
parcelRegister("daVZy", function(module, exports) {
/** Used for built-in method references. */ var $9979317a2f205a00$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $9979317a2f205a00$var$hasOwnProperty = $9979317a2f205a00$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $9979317a2f205a00$var$baseHas(object, key) {
    return object != null && $9979317a2f205a00$var$hasOwnProperty.call(object, key);
}
module.exports = $9979317a2f205a00$var$baseHas;

});

parcelRegister("7tSIP", function(module, exports) {

var $fGOSB = parcelRequire("fGOSB");

var $8dyim = parcelRequire("8dyim");

var $hpEZE = parcelRequire("hpEZE");

var $i24fP = parcelRequire("i24fP");

var $9gutI = parcelRequire("9gutI");

var $kA8d7 = parcelRequire("kA8d7");
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $5725b07e272e9361$var$hasPath(object, path, hasFunc) {
    path = $fGOSB(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $kA8d7(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $9gutI(length) && $i24fP(key, length) && ($hpEZE(object) || $8dyim(object));
}
module.exports = $5725b07e272e9361$var$hasPath;

});
parcelRegister("fGOSB", function(module, exports) {

var $hpEZE = parcelRequire("hpEZE");

var $cOCZW = parcelRequire("cOCZW");

var $eOjNN = parcelRequire("eOjNN");

var $kxrBi = parcelRequire("kxrBi");
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $b6c23ee455a130b8$var$castPath(value, object) {
    if ($hpEZE(value)) return value;
    return $cOCZW(value, object) ? [
        value
    ] : $eOjNN($kxrBi(value));
}
module.exports = $b6c23ee455a130b8$var$castPath;

});
parcelRegister("hpEZE", function(module, exports) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $cad491e76cd05f73$var$isArray = Array.isArray;
module.exports = $cad491e76cd05f73$var$isArray;

});

parcelRegister("cOCZW", function(module, exports) {

var $hpEZE = parcelRequire("hpEZE");

var $fhilJ = parcelRequire("fhilJ");
/** Used to match property names within property paths. */ var $954867be717ad1e3$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $954867be717ad1e3$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $954867be717ad1e3$var$isKey(value, object) {
    if ($hpEZE(value)) return false;
    var type = typeof value;
    if (type == "number" || type == "symbol" || type == "boolean" || value == null || $fhilJ(value)) return true;
    return $954867be717ad1e3$var$reIsPlainProp.test(value) || !$954867be717ad1e3$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
module.exports = $954867be717ad1e3$var$isKey;

});
parcelRegister("fhilJ", function(module, exports) {

var $8bnAA = parcelRequire("8bnAA");

var $6ELvy = parcelRequire("6ELvy");
/** `Object#toString` result references. */ var $b1f6ad631fec7816$var$symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $b1f6ad631fec7816$var$isSymbol(value) {
    return typeof value == "symbol" || $6ELvy(value) && $8bnAA(value) == $b1f6ad631fec7816$var$symbolTag;
}
module.exports = $b1f6ad631fec7816$var$isSymbol;

});
parcelRegister("8bnAA", function(module, exports) {

var $862yO = parcelRequire("862yO");

var $5deKO = parcelRequire("5deKO");

var $7HhhI = parcelRequire("7HhhI");
/** `Object#toString` result references. */ var $5f51a61a51e539bd$var$nullTag = "[object Null]", $5f51a61a51e539bd$var$undefinedTag = "[object Undefined]";
/** Built-in value references. */ var $5f51a61a51e539bd$var$symToStringTag = $862yO ? $862yO.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $5f51a61a51e539bd$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $5f51a61a51e539bd$var$undefinedTag : $5f51a61a51e539bd$var$nullTag;
    return $5f51a61a51e539bd$var$symToStringTag && $5f51a61a51e539bd$var$symToStringTag in Object(value) ? $5deKO(value) : $7HhhI(value);
}
module.exports = $5f51a61a51e539bd$var$baseGetTag;

});
parcelRegister("862yO", function(module, exports) {

var $l0bD9 = parcelRequire("l0bD9");
/** Built-in value references. */ var $01856ef27c55d238$var$Symbol = $l0bD9.Symbol;
module.exports = $01856ef27c55d238$var$Symbol;

});
parcelRegister("l0bD9", function(module, exports) {

var $yFHVP = parcelRequire("yFHVP");
/** Detect free variable `self`. */ var $f4a29e9dda23359c$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $f4a29e9dda23359c$var$root = $yFHVP || $f4a29e9dda23359c$var$freeSelf || Function("return this")();
module.exports = $f4a29e9dda23359c$var$root;

});
parcelRegister("yFHVP", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $068387589ee40f8e$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $068387589ee40f8e$var$freeGlobal;

});



parcelRegister("5deKO", function(module, exports) {

var $862yO = parcelRequire("862yO");
/** Used for built-in method references. */ var $3cb99c7cd692700a$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $3cb99c7cd692700a$var$hasOwnProperty = $3cb99c7cd692700a$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $3cb99c7cd692700a$var$nativeObjectToString = $3cb99c7cd692700a$var$objectProto.toString;
/** Built-in value references. */ var $3cb99c7cd692700a$var$symToStringTag = $862yO ? $862yO.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $3cb99c7cd692700a$var$getRawTag(value) {
    var isOwn = $3cb99c7cd692700a$var$hasOwnProperty.call(value, $3cb99c7cd692700a$var$symToStringTag), tag = value[$3cb99c7cd692700a$var$symToStringTag];
    try {
        value[$3cb99c7cd692700a$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $3cb99c7cd692700a$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$3cb99c7cd692700a$var$symToStringTag] = tag;
        else delete value[$3cb99c7cd692700a$var$symToStringTag];
    }
    return result;
}
module.exports = $3cb99c7cd692700a$var$getRawTag;

});

parcelRegister("7HhhI", function(module, exports) {
/** Used for built-in method references. */ var $59a9f4f4f0450696$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $59a9f4f4f0450696$var$nativeObjectToString = $59a9f4f4f0450696$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $59a9f4f4f0450696$var$objectToString(value) {
    return $59a9f4f4f0450696$var$nativeObjectToString.call(value);
}
module.exports = $59a9f4f4f0450696$var$objectToString;

});


parcelRegister("6ELvy", function(module, exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $4d8b5495933ce821$var$isObjectLike(value) {
    return value != null && typeof value == "object";
}
module.exports = $4d8b5495933ce821$var$isObjectLike;

});



parcelRegister("eOjNN", function(module, exports) {

var $fCyMy = parcelRequire("fCyMy");
/** Used to match property names within property paths. */ var $ac85187e81f860ee$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $ac85187e81f860ee$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $ac85187e81f860ee$var$stringToPath = $fCyMy(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
    string.replace($ac85187e81f860ee$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($ac85187e81f860ee$var$reEscapeChar, "$1") : number || match);
    });
    return result;
});
module.exports = $ac85187e81f860ee$var$stringToPath;

});
parcelRegister("fCyMy", function(module, exports) {

var $kxWvK = parcelRequire("kxWvK");
/** Used as the maximum memoize cache size. */ var $b5f5629fa6d9d400$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $b5f5629fa6d9d400$var$memoizeCapped(func) {
    var result = $kxWvK(func, function(key) {
        if (cache.size === $b5f5629fa6d9d400$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
module.exports = $b5f5629fa6d9d400$var$memoizeCapped;

});
parcelRegister("kxWvK", function(module, exports) {

var $9K2Ru = parcelRequire("9K2Ru");
/** Error message constants. */ var $ef5446c917110b8e$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $ef5446c917110b8e$var$memoize(func, resolver) {
    if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError($ef5446c917110b8e$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($ef5446c917110b8e$var$memoize.Cache || $9K2Ru);
    return memoized;
}
// Expose `MapCache`.
$ef5446c917110b8e$var$memoize.Cache = $9K2Ru;
module.exports = $ef5446c917110b8e$var$memoize;

});
parcelRegister("9K2Ru", function(module, exports) {

var $jX6B2 = parcelRequire("jX6B2");

var $4rrZX = parcelRequire("4rrZX");

var $9cTlb = parcelRequire("9cTlb");

var $lvADH = parcelRequire("lvADH");

var $fKBZ1 = parcelRequire("fKBZ1");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $717aa139c65a0e58$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$717aa139c65a0e58$var$MapCache.prototype.clear = $jX6B2;
$717aa139c65a0e58$var$MapCache.prototype["delete"] = $4rrZX;
$717aa139c65a0e58$var$MapCache.prototype.get = $9cTlb;
$717aa139c65a0e58$var$MapCache.prototype.has = $lvADH;
$717aa139c65a0e58$var$MapCache.prototype.set = $fKBZ1;
module.exports = $717aa139c65a0e58$var$MapCache;

});
parcelRegister("jX6B2", function(module, exports) {

var $bmgGY = parcelRequire("bmgGY");

var $1i6tm = parcelRequire("1i6tm");

var $3CaUB = parcelRequire("3CaUB");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $e868a4e9a2549a02$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new $bmgGY,
        "map": new ($3CaUB || $1i6tm),
        "string": new $bmgGY
    };
}
module.exports = $e868a4e9a2549a02$var$mapCacheClear;

});
parcelRegister("bmgGY", function(module, exports) {

var $kQ7zs = parcelRequire("kQ7zs");

var $f9Nqd = parcelRequire("f9Nqd");

var $CYuR0 = parcelRequire("CYuR0");

var $dH9ZV = parcelRequire("dH9ZV");

var $brIzq = parcelRequire("brIzq");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $844eb279bba27a69$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$844eb279bba27a69$var$Hash.prototype.clear = $kQ7zs;
$844eb279bba27a69$var$Hash.prototype["delete"] = $f9Nqd;
$844eb279bba27a69$var$Hash.prototype.get = $CYuR0;
$844eb279bba27a69$var$Hash.prototype.has = $dH9ZV;
$844eb279bba27a69$var$Hash.prototype.set = $brIzq;
module.exports = $844eb279bba27a69$var$Hash;

});
parcelRegister("kQ7zs", function(module, exports) {

var $k8X0M = parcelRequire("k8X0M");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $f2be89648b359b4d$var$hashClear() {
    this.__data__ = $k8X0M ? $k8X0M(null) : {};
    this.size = 0;
}
module.exports = $f2be89648b359b4d$var$hashClear;

});
parcelRegister("k8X0M", function(module, exports) {

var $3qlcx = parcelRequire("3qlcx");
/* Built-in method references that are verified to be native. */ var $eaa254769df38883$var$nativeCreate = $3qlcx(Object, "create");
module.exports = $eaa254769df38883$var$nativeCreate;

});
parcelRegister("3qlcx", function(module, exports) {

var $cbsSC = parcelRequire("cbsSC");

var $ki5p6 = parcelRequire("ki5p6");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $27e43eed88cf0c36$var$getNative(object, key) {
    var value = $ki5p6(object, key);
    return $cbsSC(value) ? value : undefined;
}
module.exports = $27e43eed88cf0c36$var$getNative;

});
parcelRegister("cbsSC", function(module, exports) {

var $65ZBk = parcelRequire("65ZBk");

var $1Gm82 = parcelRequire("1Gm82");

var $dXwJf = parcelRequire("dXwJf");

var $jskQ3 = parcelRequire("jskQ3");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $8decea1773c3e375$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $8decea1773c3e375$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $8decea1773c3e375$var$funcProto = Function.prototype, $8decea1773c3e375$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $8decea1773c3e375$var$funcToString = $8decea1773c3e375$var$funcProto.toString;
/** Used to check objects for own properties. */ var $8decea1773c3e375$var$hasOwnProperty = $8decea1773c3e375$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $8decea1773c3e375$var$reIsNative = RegExp("^" + $8decea1773c3e375$var$funcToString.call($8decea1773c3e375$var$hasOwnProperty).replace($8decea1773c3e375$var$reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $8decea1773c3e375$var$baseIsNative(value) {
    if (!$dXwJf(value) || $1Gm82(value)) return false;
    var pattern = $65ZBk(value) ? $8decea1773c3e375$var$reIsNative : $8decea1773c3e375$var$reIsHostCtor;
    return pattern.test($jskQ3(value));
}
module.exports = $8decea1773c3e375$var$baseIsNative;

});
parcelRegister("65ZBk", function(module, exports) {

var $8bnAA = parcelRequire("8bnAA");

var $dXwJf = parcelRequire("dXwJf");
/** `Object#toString` result references. */ var $4702fe6983b9b5ba$var$asyncTag = "[object AsyncFunction]", $4702fe6983b9b5ba$var$funcTag = "[object Function]", $4702fe6983b9b5ba$var$genTag = "[object GeneratorFunction]", $4702fe6983b9b5ba$var$proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $4702fe6983b9b5ba$var$isFunction(value) {
    if (!$dXwJf(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $8bnAA(value);
    return tag == $4702fe6983b9b5ba$var$funcTag || tag == $4702fe6983b9b5ba$var$genTag || tag == $4702fe6983b9b5ba$var$asyncTag || tag == $4702fe6983b9b5ba$var$proxyTag;
}
module.exports = $4702fe6983b9b5ba$var$isFunction;

});
parcelRegister("dXwJf", function(module, exports) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $a29a2c55ab4cc703$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
module.exports = $a29a2c55ab4cc703$var$isObject;

});


parcelRegister("1Gm82", function(module, exports) {

var $cCRpv = parcelRequire("cCRpv");
/** Used to detect methods masquerading as native. */ var $139ae0fa59367bd7$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($cCRpv && $cCRpv.keys && $cCRpv.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $139ae0fa59367bd7$var$isMasked(func) {
    return !!$139ae0fa59367bd7$var$maskSrcKey && $139ae0fa59367bd7$var$maskSrcKey in func;
}
module.exports = $139ae0fa59367bd7$var$isMasked;

});
parcelRegister("cCRpv", function(module, exports) {

var $l0bD9 = parcelRequire("l0bD9");
/** Used to detect overreaching core-js shims. */ var $931276d7ddb7db46$var$coreJsData = $l0bD9["__core-js_shared__"];
module.exports = $931276d7ddb7db46$var$coreJsData;

});


parcelRegister("jskQ3", function(module, exports) {
/** Used for built-in method references. */ var $e2a0cbf6ac123ac7$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $e2a0cbf6ac123ac7$var$funcToString = $e2a0cbf6ac123ac7$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $e2a0cbf6ac123ac7$var$toSource(func) {
    if (func != null) {
        try {
            return $e2a0cbf6ac123ac7$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
module.exports = $e2a0cbf6ac123ac7$var$toSource;

});


parcelRegister("ki5p6", function(module, exports) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $ec59ae30cb33b0c2$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
module.exports = $ec59ae30cb33b0c2$var$getValue;

});




parcelRegister("f9Nqd", function(module, exports) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $b08e086eba10bdc2$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $b08e086eba10bdc2$var$hashDelete;

});

parcelRegister("CYuR0", function(module, exports) {

var $k8X0M = parcelRequire("k8X0M");
/** Used to stand-in for `undefined` hash values. */ var $07527a18ff6fa6aa$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used for built-in method references. */ var $07527a18ff6fa6aa$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $07527a18ff6fa6aa$var$hasOwnProperty = $07527a18ff6fa6aa$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $07527a18ff6fa6aa$var$hashGet(key) {
    var data = this.__data__;
    if ($k8X0M) {
        var result = data[key];
        return result === $07527a18ff6fa6aa$var$HASH_UNDEFINED ? undefined : result;
    }
    return $07527a18ff6fa6aa$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
module.exports = $07527a18ff6fa6aa$var$hashGet;

});

parcelRegister("dH9ZV", function(module, exports) {

var $k8X0M = parcelRequire("k8X0M");
/** Used for built-in method references. */ var $9f870bd9c140e672$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $9f870bd9c140e672$var$hasOwnProperty = $9f870bd9c140e672$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $9f870bd9c140e672$var$hashHas(key) {
    var data = this.__data__;
    return $k8X0M ? data[key] !== undefined : $9f870bd9c140e672$var$hasOwnProperty.call(data, key);
}
module.exports = $9f870bd9c140e672$var$hashHas;

});

parcelRegister("brIzq", function(module, exports) {

var $k8X0M = parcelRequire("k8X0M");
/** Used to stand-in for `undefined` hash values. */ var $8554ca153fd524ee$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $8554ca153fd524ee$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $k8X0M && value === undefined ? $8554ca153fd524ee$var$HASH_UNDEFINED : value;
    return this;
}
module.exports = $8554ca153fd524ee$var$hashSet;

});


parcelRegister("1i6tm", function(module, exports) {

var $7iOeV = parcelRequire("7iOeV");

var $8wEvV = parcelRequire("8wEvV");

var $7JGiX = parcelRequire("7JGiX");

var $fJigb = parcelRequire("fJigb");

var $gZMil = parcelRequire("gZMil");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $0f0c7e2ecaee8fed$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$0f0c7e2ecaee8fed$var$ListCache.prototype.clear = $7iOeV;
$0f0c7e2ecaee8fed$var$ListCache.prototype["delete"] = $8wEvV;
$0f0c7e2ecaee8fed$var$ListCache.prototype.get = $7JGiX;
$0f0c7e2ecaee8fed$var$ListCache.prototype.has = $fJigb;
$0f0c7e2ecaee8fed$var$ListCache.prototype.set = $gZMil;
module.exports = $0f0c7e2ecaee8fed$var$ListCache;

});
parcelRegister("7iOeV", function(module, exports) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $55112f6a975523d8$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
module.exports = $55112f6a975523d8$var$listCacheClear;

});

parcelRegister("8wEvV", function(module, exports) {

var $jwR8T = parcelRequire("jwR8T");
/** Used for built-in method references. */ var $6350bd1bc100482f$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $6350bd1bc100482f$var$splice = $6350bd1bc100482f$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $6350bd1bc100482f$var$listCacheDelete(key) {
    var data = this.__data__, index = $jwR8T(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $6350bd1bc100482f$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
module.exports = $6350bd1bc100482f$var$listCacheDelete;

});
parcelRegister("jwR8T", function(module, exports) {

var $9xwlJ = parcelRequire("9xwlJ");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $e37a3a78acf2ad32$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($9xwlJ(array[length][0], key)) return length;
    }
    return -1;
}
module.exports = $e37a3a78acf2ad32$var$assocIndexOf;

});
parcelRegister("9xwlJ", function(module, exports) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $6f204a0c73820a06$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
module.exports = $6f204a0c73820a06$var$eq;

});



parcelRegister("7JGiX", function(module, exports) {

var $jwR8T = parcelRequire("jwR8T");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $5a1d8d32ab9961bf$var$listCacheGet(key) {
    var data = this.__data__, index = $jwR8T(data, key);
    return index < 0 ? undefined : data[index][1];
}
module.exports = $5a1d8d32ab9961bf$var$listCacheGet;

});

parcelRegister("fJigb", function(module, exports) {

var $jwR8T = parcelRequire("jwR8T");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $b7393905d32d1284$var$listCacheHas(key) {
    return $jwR8T(this.__data__, key) > -1;
}
module.exports = $b7393905d32d1284$var$listCacheHas;

});

parcelRegister("gZMil", function(module, exports) {

var $jwR8T = parcelRequire("jwR8T");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $c5f7ce3330d79213$var$listCacheSet(key, value) {
    var data = this.__data__, index = $jwR8T(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
module.exports = $c5f7ce3330d79213$var$listCacheSet;

});


parcelRegister("3CaUB", function(module, exports) {

var $3qlcx = parcelRequire("3qlcx");

var $l0bD9 = parcelRequire("l0bD9");
/* Built-in method references that are verified to be native. */ var $2a1d6292bb9ac916$var$Map = $3qlcx($l0bD9, "Map");
module.exports = $2a1d6292bb9ac916$var$Map;

});


parcelRegister("4rrZX", function(module, exports) {

var $eahQn = parcelRequire("eahQn");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $33bf66f136ae315b$var$mapCacheDelete(key) {
    var result = $eahQn(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $33bf66f136ae315b$var$mapCacheDelete;

});
parcelRegister("eahQn", function(module, exports) {

var $cf7g7 = parcelRequire("cf7g7");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $a4ffd74639bc95f7$var$getMapData(map, key) {
    var data = map.__data__;
    return $cf7g7(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
module.exports = $a4ffd74639bc95f7$var$getMapData;

});
parcelRegister("cf7g7", function(module, exports) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $8e9c8436a04846f4$var$isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
module.exports = $8e9c8436a04846f4$var$isKeyable;

});



parcelRegister("9cTlb", function(module, exports) {

var $eahQn = parcelRequire("eahQn");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $6b40298f28243090$var$mapCacheGet(key) {
    return $eahQn(this, key).get(key);
}
module.exports = $6b40298f28243090$var$mapCacheGet;

});

parcelRegister("lvADH", function(module, exports) {

var $eahQn = parcelRequire("eahQn");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $fa88ea0d88bf865b$var$mapCacheHas(key) {
    return $eahQn(this, key).has(key);
}
module.exports = $fa88ea0d88bf865b$var$mapCacheHas;

});

parcelRegister("fKBZ1", function(module, exports) {

var $eahQn = parcelRequire("eahQn");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $b7789d912539ab17$var$mapCacheSet(key, value) {
    var data = $eahQn(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
module.exports = $b7789d912539ab17$var$mapCacheSet;

});





parcelRegister("kxrBi", function(module, exports) {

var $3Dau6 = parcelRequire("3Dau6");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $ef3c4c9cef030b58$var$toString(value) {
    return value == null ? "" : $3Dau6(value);
}
module.exports = $ef3c4c9cef030b58$var$toString;

});
parcelRegister("3Dau6", function(module, exports) {

var $862yO = parcelRequire("862yO");

var $1xLa8 = parcelRequire("1xLa8");

var $hpEZE = parcelRequire("hpEZE");

var $fhilJ = parcelRequire("fhilJ");
/** Used as references for various `Number` constants. */ var $2a4d259cedb16b85$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $2a4d259cedb16b85$var$symbolProto = $862yO ? $862yO.prototype : undefined, $2a4d259cedb16b85$var$symbolToString = $2a4d259cedb16b85$var$symbolProto ? $2a4d259cedb16b85$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $2a4d259cedb16b85$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if ($hpEZE(value)) // Recursively convert values (susceptible to call stack limits).
    return $1xLa8(value, $2a4d259cedb16b85$var$baseToString) + "";
    if ($fhilJ(value)) return $2a4d259cedb16b85$var$symbolToString ? $2a4d259cedb16b85$var$symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -$2a4d259cedb16b85$var$INFINITY ? "-0" : result;
}
module.exports = $2a4d259cedb16b85$var$baseToString;

});
parcelRegister("1xLa8", function(module, exports) {
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $11fd74fb20c3fc90$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
module.exports = $11fd74fb20c3fc90$var$arrayMap;

});




parcelRegister("8dyim", function(module, exports) {

var $7kpcm = parcelRequire("7kpcm");

var $6ELvy = parcelRequire("6ELvy");
/** Used for built-in method references. */ var $5fba23f1ba3a1950$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $5fba23f1ba3a1950$var$hasOwnProperty = $5fba23f1ba3a1950$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $5fba23f1ba3a1950$var$propertyIsEnumerable = $5fba23f1ba3a1950$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $5fba23f1ba3a1950$var$isArguments = $7kpcm(function() {
    return arguments;
}()) ? $7kpcm : function(value) {
    return $6ELvy(value) && $5fba23f1ba3a1950$var$hasOwnProperty.call(value, "callee") && !$5fba23f1ba3a1950$var$propertyIsEnumerable.call(value, "callee");
};
module.exports = $5fba23f1ba3a1950$var$isArguments;

});
parcelRegister("7kpcm", function(module, exports) {

var $8bnAA = parcelRequire("8bnAA");

var $6ELvy = parcelRequire("6ELvy");
/** `Object#toString` result references. */ var $555df28768f370cd$var$argsTag = "[object Arguments]";
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $555df28768f370cd$var$baseIsArguments(value) {
    return $6ELvy(value) && $8bnAA(value) == $555df28768f370cd$var$argsTag;
}
module.exports = $555df28768f370cd$var$baseIsArguments;

});


parcelRegister("i24fP", function(module, exports) {
/** Used as references for various `Number` constants. */ var $d20bb6b929d245f9$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $d20bb6b929d245f9$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $d20bb6b929d245f9$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $d20bb6b929d245f9$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && $d20bb6b929d245f9$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
module.exports = $d20bb6b929d245f9$var$isIndex;

});

parcelRegister("9gutI", function(module, exports) {
/** Used as references for various `Number` constants. */ var $6bed400a97e4eb2b$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $6bed400a97e4eb2b$var$isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= $6bed400a97e4eb2b$var$MAX_SAFE_INTEGER;
}
module.exports = $6bed400a97e4eb2b$var$isLength;

});

parcelRegister("kA8d7", function(module, exports) {

var $fhilJ = parcelRequire("fhilJ");
/** Used as references for various `Number` constants. */ var $efbd89eb1456e9dc$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $efbd89eb1456e9dc$var$toKey(value) {
    if (typeof value == "string" || $fhilJ(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -$efbd89eb1456e9dc$var$INFINITY ? "-0" : result;
}
module.exports = $efbd89eb1456e9dc$var$toKey;

});



parcelRegister("93uAf", function(module, exports) {

$parcel$export(module.exports, "default", () => $697c1e288decc2c9$export$2e2bcd8739ae039);
const $697c1e288decc2c9$var$isSchema = (obj)=>obj && obj.__isYupSchema__;
var $697c1e288decc2c9$export$2e2bcd8739ae039 = $697c1e288decc2c9$var$isSchema;

});


parcelRegister("epCOP", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7e1831eee4e2bd5$export$2e2bcd8739ae039);

var $41aWH = parcelRequire("41aWH");
const $a7e1831eee4e2bd5$var$once = (cb)=>{
    let fired = false;
    return (...args)=>{
        if (fired) return;
        fired = true;
        cb(...args);
    };
};
function $a7e1831eee4e2bd5$export$2e2bcd8739ae039(options, cb) {
    let { endEarly: endEarly, tests: tests, args: args, value: value, errors: errors, sort: sort, path: path } = options;
    let callback = $a7e1831eee4e2bd5$var$once(cb);
    let count = tests.length;
    const nestedErrors = [];
    errors = errors ? errors : [];
    if (!count) return errors.length ? callback(new (0, $41aWH.default)(errors, value, path)) : callback(null, value);
    for(let i = 0; i < tests.length; i++){
        const test = tests[i];
        test(args, function finishTestRun(err) {
            if (err) {
                // always return early for non validation errors
                if (!(0, $41aWH.default).isError(err)) return callback(err, value);
                if (endEarly) {
                    err.value = value;
                    return callback(err, value);
                }
                nestedErrors.push(err);
            }
            if (--count <= 0) {
                if (nestedErrors.length) {
                    if (sort) nestedErrors.sort(sort); //show parent errors after the nested ones: name.first, name
                    if (errors.length) nestedErrors.push(...errors);
                    errors = nestedErrors;
                }
                if (errors.length) {
                    callback(new (0, $41aWH.default)(errors, value, path), value);
                    return;
                }
                callback(null, value);
            }
        });
    }
}

});
parcelRegister("41aWH", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ecfbf038f5494bb$export$2e2bcd8739ae039);

var $6J2zD = parcelRequire("6J2zD");

var $d1E9x = parcelRequire("d1E9x");
function $2ecfbf038f5494bb$var$_extends() {
    $2ecfbf038f5494bb$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $2ecfbf038f5494bb$var$_extends.apply(this, arguments);
}
let $2ecfbf038f5494bb$var$strReg = /\$\{\s*(\w+)\s*\}/g;
class $2ecfbf038f5494bb$export$2e2bcd8739ae039 extends Error {
    static formatError(message, params) {
        const path = params.label || params.path || "this";
        if (path !== params.path) params = $2ecfbf038f5494bb$var$_extends({}, params, {
            path: path
        });
        if (typeof message === "string") return message.replace($2ecfbf038f5494bb$var$strReg, (_, key)=>(0, $6J2zD.default)(params[key]));
        if (typeof message === "function") return message(params);
        return message;
    }
    static isError(err) {
        return err && err.name === "ValidationError";
    }
    constructor(errorOrErrors, value, field, type){
        super();
        this.value = void 0;
        this.path = void 0;
        this.type = void 0;
        this.errors = void 0;
        this.params = void 0;
        this.inner = void 0;
        this.name = "ValidationError";
        this.value = value;
        this.path = field;
        this.type = type;
        this.errors = [];
        this.inner = [];
        (0, $d1E9x.default)(errorOrErrors).forEach((err)=>{
            if ($2ecfbf038f5494bb$export$2e2bcd8739ae039.isError(err)) {
                this.errors.push(...err.errors);
                this.inner = this.inner.concat(err.inner.length ? err.inner : err);
            } else this.errors.push(err);
        });
        this.message = this.errors.length > 1 ? `${this.errors.length} errors occurred` : this.errors[0];
        if (Error.captureStackTrace) Error.captureStackTrace(this, $2ecfbf038f5494bb$export$2e2bcd8739ae039);
    }
}

});
parcelRegister("d1E9x", function(module, exports) {

$parcel$export(module.exports, "default", () => $97ba83da411eb87e$export$2e2bcd8739ae039);
function $97ba83da411eb87e$export$2e2bcd8739ae039(value) {
    return value == null ? [] : [].concat(value);
}

});



parcelRegister("fYFLY", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba1cdcd5fd8f474c$export$2e2bcd8739ae039);

var $cvX5D = parcelRequire("cvX5D");

var $41aWH = parcelRequire("41aWH");

var $fGxXP = parcelRequire("fGxXP");
function $ba1cdcd5fd8f474c$var$_extends() {
    $ba1cdcd5fd8f474c$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ba1cdcd5fd8f474c$var$_extends.apply(this, arguments);
}
function $ba1cdcd5fd8f474c$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $ba1cdcd5fd8f474c$export$2e2bcd8739ae039(config) {
    function validate(_ref, cb) {
        let { value: value, path: path = "", label: label, options: options, originalValue: originalValue, sync: sync } = _ref, rest = $ba1cdcd5fd8f474c$var$_objectWithoutPropertiesLoose(_ref, [
            "value",
            "path",
            "label",
            "options",
            "originalValue",
            "sync"
        ]);
        const { name: name, test: test, params: params, message: message } = config;
        let { parent: parent, context: context } = options;
        function resolve(item) {
            return (0, $fGxXP.default).isRef(item) ? item.getValue(value, parent, context) : item;
        }
        function createError(overrides = {}) {
            const nextParams = (0, (/*@__PURE__*/$parcel$interopDefault($cvX5D)))($ba1cdcd5fd8f474c$var$_extends({
                value: value,
                originalValue: originalValue,
                label: label,
                path: overrides.path || path
            }, params, overrides.params), resolve);
            const error = new (0, $41aWH.default)((0, $41aWH.default).formatError(overrides.message || message, nextParams), value, nextParams.path, overrides.type || name);
            error.params = nextParams;
            return error;
        }
        let ctx = $ba1cdcd5fd8f474c$var$_extends({
            path: path,
            parent: parent,
            type: name,
            createError: createError,
            resolve: resolve,
            options: options,
            originalValue: originalValue
        }, rest);
        if (!sync) {
            try {
                Promise.resolve(test.call(ctx, value, ctx)).then((validOrError)=>{
                    if ((0, $41aWH.default).isError(validOrError)) cb(validOrError);
                    else if (!validOrError) cb(createError());
                    else cb(null, validOrError);
                }).catch(cb);
            } catch (err) {
                cb(err);
            }
            return;
        }
        let result;
        try {
            var _ref2;
            result = test.call(ctx, value, ctx);
            if (typeof ((_ref2 = result) == null ? void 0 : _ref2.then) === "function") throw new Error(`Validation test of type: "${ctx.type}" returned a Promise during a synchronous validate. ` + `This test will finish after the validate call has returned`);
        } catch (err) {
            cb(err);
            return;
        }
        if ((0, $41aWH.default).isError(result)) cb(result);
        else if (!result) cb(createError());
        else cb(null, result);
    }
    validate.OPTIONS = config;
    return validate;
}

});
parcelRegister("cvX5D", function(module, exports) {

var $4zie7 = parcelRequire("4zie7");

var $cFuT8 = parcelRequire("cFuT8");

var $6QQby = parcelRequire("6QQby");
/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */ function $91c63753c5463e59$var$mapValues(object, iteratee) {
    var result = {};
    iteratee = $6QQby(iteratee, 3);
    $cFuT8(object, function(value, key, object) {
        $4zie7(result, key, iteratee(value, key, object));
    });
    return result;
}
module.exports = $91c63753c5463e59$var$mapValues;

});
parcelRegister("4zie7", function(module, exports) {

var $bVW0L = parcelRequire("bVW0L");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $353891c29a6ee0b3$var$baseAssignValue(object, key, value) {
    if (key == "__proto__" && $bVW0L) $bVW0L(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
    });
    else object[key] = value;
}
module.exports = $353891c29a6ee0b3$var$baseAssignValue;

});
parcelRegister("bVW0L", function(module, exports) {

var $3qlcx = parcelRequire("3qlcx");
var $8b02046962f7ec36$var$defineProperty = function() {
    try {
        var func = $3qlcx(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e) {}
}();
module.exports = $8b02046962f7ec36$var$defineProperty;

});


parcelRegister("cFuT8", function(module, exports) {

var $gGCGR = parcelRequire("gGCGR");

var $ebPNH = parcelRequire("ebPNH");
/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $93914620faa00ba5$var$baseForOwn(object, iteratee) {
    return object && $gGCGR(object, iteratee, $ebPNH);
}
module.exports = $93914620faa00ba5$var$baseForOwn;

});
parcelRegister("gGCGR", function(module, exports) {

var $8EBAD = parcelRequire("8EBAD");
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $c25e94a8c74f8aaf$var$baseFor = $8EBAD();
module.exports = $c25e94a8c74f8aaf$var$baseFor;

});
parcelRegister("8EBAD", function(module, exports) {
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $64cf37bdeb1d7bbc$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
module.exports = $64cf37bdeb1d7bbc$var$createBaseFor;

});


parcelRegister("ebPNH", function(module, exports) {

var $2Iuzq = parcelRequire("2Iuzq");

var $jyK4z = parcelRequire("jyK4z");

var $1pGq0 = parcelRequire("1pGq0");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $a54a46468d157d45$var$keys(object) {
    return $1pGq0(object) ? $2Iuzq(object) : $jyK4z(object);
}
module.exports = $a54a46468d157d45$var$keys;

});
parcelRegister("2Iuzq", function(module, exports) {

var $3gEo0 = parcelRequire("3gEo0");

var $8dyim = parcelRequire("8dyim");

var $hpEZE = parcelRequire("hpEZE");

var $4Hm80 = parcelRequire("4Hm80");

var $i24fP = parcelRequire("i24fP");

var $4pZAf = parcelRequire("4pZAf");
/** Used for built-in method references. */ var $1fa7677313f2e3d6$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $1fa7677313f2e3d6$var$hasOwnProperty = $1fa7677313f2e3d6$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $1fa7677313f2e3d6$var$arrayLikeKeys(value, inherited) {
    var isArr = $hpEZE(value), isArg = !isArr && $8dyim(value), isBuff = !isArr && !isArg && $4Hm80(value), isType = !isArr && !isArg && !isBuff && $4pZAf(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $3gEo0(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $1fa7677313f2e3d6$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    $i24fP(key, length)))) result.push(key);
    return result;
}
module.exports = $1fa7677313f2e3d6$var$arrayLikeKeys;

});
parcelRegister("3gEo0", function(module, exports) {
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $261231901f3c2074$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
module.exports = $261231901f3c2074$var$baseTimes;

});

parcelRegister("4Hm80", function(module, exports) {

var $l0bD9 = parcelRequire("l0bD9");

var $f5s3N = parcelRequire("f5s3N");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $l0bD9.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $f5s3N;
module.exports = isBuffer;

});
parcelRegister("f5s3N", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $afbd16d33288dc82$var$stubFalse() {
    return false;
}
module.exports = $afbd16d33288dc82$var$stubFalse;

});


parcelRegister("4pZAf", function(module, exports) {

var $k23E6 = parcelRequire("k23E6");

var $EcTds = parcelRequire("EcTds");

var $h5EzN = parcelRequire("h5EzN");
/* Node.js helper references. */ var $33794475c19c9ade$var$nodeIsTypedArray = $h5EzN && $h5EzN.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $33794475c19c9ade$var$isTypedArray = $33794475c19c9ade$var$nodeIsTypedArray ? $EcTds($33794475c19c9ade$var$nodeIsTypedArray) : $k23E6;
module.exports = $33794475c19c9ade$var$isTypedArray;

});
parcelRegister("k23E6", function(module, exports) {

var $8bnAA = parcelRequire("8bnAA");

var $9gutI = parcelRequire("9gutI");

var $6ELvy = parcelRequire("6ELvy");
/** `Object#toString` result references. */ var $e956d28e435d053c$var$argsTag = "[object Arguments]", $e956d28e435d053c$var$arrayTag = "[object Array]", $e956d28e435d053c$var$boolTag = "[object Boolean]", $e956d28e435d053c$var$dateTag = "[object Date]", $e956d28e435d053c$var$errorTag = "[object Error]", $e956d28e435d053c$var$funcTag = "[object Function]", $e956d28e435d053c$var$mapTag = "[object Map]", $e956d28e435d053c$var$numberTag = "[object Number]", $e956d28e435d053c$var$objectTag = "[object Object]", $e956d28e435d053c$var$regexpTag = "[object RegExp]", $e956d28e435d053c$var$setTag = "[object Set]", $e956d28e435d053c$var$stringTag = "[object String]", $e956d28e435d053c$var$weakMapTag = "[object WeakMap]";
var $e956d28e435d053c$var$arrayBufferTag = "[object ArrayBuffer]", $e956d28e435d053c$var$dataViewTag = "[object DataView]", $e956d28e435d053c$var$float32Tag = "[object Float32Array]", $e956d28e435d053c$var$float64Tag = "[object Float64Array]", $e956d28e435d053c$var$int8Tag = "[object Int8Array]", $e956d28e435d053c$var$int16Tag = "[object Int16Array]", $e956d28e435d053c$var$int32Tag = "[object Int32Array]", $e956d28e435d053c$var$uint8Tag = "[object Uint8Array]", $e956d28e435d053c$var$uint8ClampedTag = "[object Uint8ClampedArray]", $e956d28e435d053c$var$uint16Tag = "[object Uint16Array]", $e956d28e435d053c$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values of typed arrays. */ var $e956d28e435d053c$var$typedArrayTags = {};
$e956d28e435d053c$var$typedArrayTags[$e956d28e435d053c$var$float32Tag] = $e956d28e435d053c$var$typedArrayTags[$e956d28e435d053c$var$float64Tag] = $e956d28e435d053c$var$typedArrayTags[$e956d28e435d053c$var$int8Tag] = $e956d28e435d053c$var$typedArrayTags[$e956d28e435d053c$var$int16Tag] = $e956d28e435d053c$var$typedArrayTags[$e956d28e435d053c$var$int32Tag] = $e956d28e435d053c$var$typedArrayTags[$e956d28e435d053c$var$uint8Tag] = $e956d28e435d053c$var$typedArrayTags[$e956d28e435d053c$var$uint8ClampedTag] = $e956d28e435d053c$var$typedArrayTags[$e956d28e435d053c$var$uint16Tag] = $e956d28e435d053c$var$typedArrayTags[$e956d28e435d053c$var$uint32Tag] = true;
$e956d28e435d053c$var$typedArrayTags[$e956d28e435d053c$var$argsTag] = $e956d28e435d053c$var$typedArrayTags[$e956d28e435d053c$var$arrayTag] = $e956d28e435d053c$var$typedArrayTags[$e956d28e435d053c$var$arrayBufferTag] = $e956d28e435d053c$var$typedArrayTags[$e956d28e435d053c$var$boolTag] = $e956d28e435d053c$var$typedArrayTags[$e956d28e435d053c$var$dataViewTag] = $e956d28e435d053c$var$typedArrayTags[$e956d28e435d053c$var$dateTag] = $e956d28e435d053c$var$typedArrayTags[$e956d28e435d053c$var$errorTag] = $e956d28e435d053c$var$typedArrayTags[$e956d28e435d053c$var$funcTag] = $e956d28e435d053c$var$typedArrayTags[$e956d28e435d053c$var$mapTag] = $e956d28e435d053c$var$typedArrayTags[$e956d28e435d053c$var$numberTag] = $e956d28e435d053c$var$typedArrayTags[$e956d28e435d053c$var$objectTag] = $e956d28e435d053c$var$typedArrayTags[$e956d28e435d053c$var$regexpTag] = $e956d28e435d053c$var$typedArrayTags[$e956d28e435d053c$var$setTag] = $e956d28e435d053c$var$typedArrayTags[$e956d28e435d053c$var$stringTag] = $e956d28e435d053c$var$typedArrayTags[$e956d28e435d053c$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $e956d28e435d053c$var$baseIsTypedArray(value) {
    return $6ELvy(value) && $9gutI(value.length) && !!$e956d28e435d053c$var$typedArrayTags[$8bnAA(value)];
}
module.exports = $e956d28e435d053c$var$baseIsTypedArray;

});

parcelRegister("EcTds", function(module, exports) {
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $078dbc24e0a31283$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
module.exports = $078dbc24e0a31283$var$baseUnary;

});

parcelRegister("h5EzN", function(module, exports) {

var $yFHVP = parcelRequire("yFHVP");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $yFHVP.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
module.exports = nodeUtil;

});



parcelRegister("jyK4z", function(module, exports) {

var $d3SUJ = parcelRequire("d3SUJ");

var $0ETP3 = parcelRequire("0ETP3");
/** Used for built-in method references. */ var $e3d4ee66f47c8377$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $e3d4ee66f47c8377$var$hasOwnProperty = $e3d4ee66f47c8377$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $e3d4ee66f47c8377$var$baseKeys(object) {
    if (!$d3SUJ(object)) return $0ETP3(object);
    var result = [];
    for(var key in Object(object))if ($e3d4ee66f47c8377$var$hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
module.exports = $e3d4ee66f47c8377$var$baseKeys;

});
parcelRegister("d3SUJ", function(module, exports) {
/** Used for built-in method references. */ var $982626f49644a83b$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $982626f49644a83b$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || $982626f49644a83b$var$objectProto;
    return value === proto;
}
module.exports = $982626f49644a83b$var$isPrototype;

});

parcelRegister("0ETP3", function(module, exports) {

var $WkMTD = parcelRequire("WkMTD");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $001fb9f684202d7d$var$nativeKeys = $WkMTD(Object.keys, Object);
module.exports = $001fb9f684202d7d$var$nativeKeys;

});
parcelRegister("WkMTD", function(module, exports) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $0af58ae393a25ccb$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
module.exports = $0af58ae393a25ccb$var$overArg;

});



parcelRegister("1pGq0", function(module, exports) {

var $65ZBk = parcelRequire("65ZBk");

var $9gutI = parcelRequire("9gutI");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $107907a76758af29$var$isArrayLike(value) {
    return value != null && $9gutI(value.length) && !$65ZBk(value);
}
module.exports = $107907a76758af29$var$isArrayLike;

});



parcelRegister("6QQby", function(module, exports) {

var $2h5wd = parcelRequire("2h5wd");

var $kkq0Y = parcelRequire("kkq0Y");

var $e3EMk = parcelRequire("e3EMk");

var $hpEZE = parcelRequire("hpEZE");

var $87Kwr = parcelRequire("87Kwr");
/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $4fd014525f4883b2$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == "function") return value;
    if (value == null) return $e3EMk;
    if (typeof value == "object") return $hpEZE(value) ? $kkq0Y(value[0], value[1]) : $2h5wd(value);
    return $87Kwr(value);
}
module.exports = $4fd014525f4883b2$var$baseIteratee;

});
parcelRegister("2h5wd", function(module, exports) {

var $8reMm = parcelRequire("8reMm");

var $5rOOj = parcelRequire("5rOOj");

var $8DhCW = parcelRequire("8DhCW");
/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $1a817331b5ff6d58$var$baseMatches(source) {
    var matchData = $5rOOj(source);
    if (matchData.length == 1 && matchData[0][2]) return $8DhCW(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || $8reMm(object, source, matchData);
    };
}
module.exports = $1a817331b5ff6d58$var$baseMatches;

});
parcelRegister("8reMm", function(module, exports) {

var $cQcc0 = parcelRequire("cQcc0");

var $53LO5 = parcelRequire("53LO5");
/** Used to compose bitmasks for value comparisons. */ var $624c4f2173a21472$var$COMPARE_PARTIAL_FLAG = 1, $624c4f2173a21472$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $624c4f2173a21472$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new $cQcc0;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? $53LO5(srcValue, objValue, $624c4f2173a21472$var$COMPARE_PARTIAL_FLAG | $624c4f2173a21472$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
module.exports = $624c4f2173a21472$var$baseIsMatch;

});
parcelRegister("cQcc0", function(module, exports) {

var $1i6tm = parcelRequire("1i6tm");

var $7zixV = parcelRequire("7zixV");

var $8wRNE = parcelRequire("8wRNE");

var $bzltf = parcelRequire("bzltf");

var $ab5gg = parcelRequire("ab5gg");

var $iFLJE = parcelRequire("iFLJE");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $9593cc8ce783ea4d$var$Stack(entries) {
    var data = this.__data__ = new $1i6tm(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$9593cc8ce783ea4d$var$Stack.prototype.clear = $7zixV;
$9593cc8ce783ea4d$var$Stack.prototype["delete"] = $8wRNE;
$9593cc8ce783ea4d$var$Stack.prototype.get = $bzltf;
$9593cc8ce783ea4d$var$Stack.prototype.has = $ab5gg;
$9593cc8ce783ea4d$var$Stack.prototype.set = $iFLJE;
module.exports = $9593cc8ce783ea4d$var$Stack;

});
parcelRegister("7zixV", function(module, exports) {

var $1i6tm = parcelRequire("1i6tm");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $582a302d96321722$var$stackClear() {
    this.__data__ = new $1i6tm;
    this.size = 0;
}
module.exports = $582a302d96321722$var$stackClear;

});

parcelRegister("8wRNE", function(module, exports) {
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $635b0b6f0ed6bd93$var$stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
module.exports = $635b0b6f0ed6bd93$var$stackDelete;

});

parcelRegister("bzltf", function(module, exports) {
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $86c39e3cc59dd193$var$stackGet(key) {
    return this.__data__.get(key);
}
module.exports = $86c39e3cc59dd193$var$stackGet;

});

parcelRegister("ab5gg", function(module, exports) {
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $768f033a2d3acb00$var$stackHas(key) {
    return this.__data__.has(key);
}
module.exports = $768f033a2d3acb00$var$stackHas;

});

parcelRegister("iFLJE", function(module, exports) {

var $1i6tm = parcelRequire("1i6tm");

var $3CaUB = parcelRequire("3CaUB");

var $9K2Ru = parcelRequire("9K2Ru");
/** Used as the size to enable large array optimizations. */ var $d98115914a608902$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $d98115914a608902$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $1i6tm) {
        var pairs = data.__data__;
        if (!$3CaUB || pairs.length < $d98115914a608902$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $9K2Ru(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
module.exports = $d98115914a608902$var$stackSet;

});


parcelRegister("53LO5", function(module, exports) {

var $28K7w = parcelRequire("28K7w");

var $6ELvy = parcelRequire("6ELvy");
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $3af2510205f3c1b2$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$6ELvy(value) && !$6ELvy(other)) return value !== value && other !== other;
    return $28K7w(value, other, bitmask, customizer, $3af2510205f3c1b2$var$baseIsEqual, stack);
}
module.exports = $3af2510205f3c1b2$var$baseIsEqual;

});
parcelRegister("28K7w", function(module, exports) {

var $cQcc0 = parcelRequire("cQcc0");

var $kquNj = parcelRequire("kquNj");

var $e32NE = parcelRequire("e32NE");

var $812FE = parcelRequire("812FE");

var $d9ApZ = parcelRequire("d9ApZ");

var $hpEZE = parcelRequire("hpEZE");

var $4Hm80 = parcelRequire("4Hm80");

var $4pZAf = parcelRequire("4pZAf");
/** Used to compose bitmasks for value comparisons. */ var $18f01aacdcd752ba$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $18f01aacdcd752ba$var$argsTag = "[object Arguments]", $18f01aacdcd752ba$var$arrayTag = "[object Array]", $18f01aacdcd752ba$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $18f01aacdcd752ba$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $18f01aacdcd752ba$var$hasOwnProperty = $18f01aacdcd752ba$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $18f01aacdcd752ba$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $hpEZE(object), othIsArr = $hpEZE(other), objTag = objIsArr ? $18f01aacdcd752ba$var$arrayTag : $d9ApZ(object), othTag = othIsArr ? $18f01aacdcd752ba$var$arrayTag : $d9ApZ(other);
    objTag = objTag == $18f01aacdcd752ba$var$argsTag ? $18f01aacdcd752ba$var$objectTag : objTag;
    othTag = othTag == $18f01aacdcd752ba$var$argsTag ? $18f01aacdcd752ba$var$objectTag : othTag;
    var objIsObj = objTag == $18f01aacdcd752ba$var$objectTag, othIsObj = othTag == $18f01aacdcd752ba$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $4Hm80(object)) {
        if (!$4Hm80(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $cQcc0);
        return objIsArr || $4pZAf(object) ? $kquNj(object, other, bitmask, customizer, equalFunc, stack) : $e32NE(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $18f01aacdcd752ba$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $18f01aacdcd752ba$var$hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && $18f01aacdcd752ba$var$hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $cQcc0);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $cQcc0);
    return $812FE(object, other, bitmask, customizer, equalFunc, stack);
}
module.exports = $18f01aacdcd752ba$var$baseIsEqualDeep;

});
parcelRegister("kquNj", function(module, exports) {

var $9oIJv = parcelRequire("9oIJv");

var $JBCmy = parcelRequire("JBCmy");

var $iXape = parcelRequire("iXape");
/** Used to compose bitmasks for value comparisons. */ var $edee1f7a34a1498e$var$COMPARE_PARTIAL_FLAG = 1, $edee1f7a34a1498e$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $edee1f7a34a1498e$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $edee1f7a34a1498e$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $edee1f7a34a1498e$var$COMPARE_UNORDERED_FLAG ? new $9oIJv : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$JBCmy(other, function(othValue, othIndex) {
                if (!$iXape(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
module.exports = $edee1f7a34a1498e$var$equalArrays;

});
parcelRegister("9oIJv", function(module, exports) {

var $9K2Ru = parcelRequire("9K2Ru");

var $7zCbB = parcelRequire("7zCbB");

var $jkLBR = parcelRequire("jkLBR");
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $6d790dfd53cfd24b$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $9K2Ru;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$6d790dfd53cfd24b$var$SetCache.prototype.add = $6d790dfd53cfd24b$var$SetCache.prototype.push = $7zCbB;
$6d790dfd53cfd24b$var$SetCache.prototype.has = $jkLBR;
module.exports = $6d790dfd53cfd24b$var$SetCache;

});
parcelRegister("7zCbB", function(module, exports) {
/** Used to stand-in for `undefined` hash values. */ var $58396c48529e025e$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $58396c48529e025e$var$setCacheAdd(value) {
    this.__data__.set(value, $58396c48529e025e$var$HASH_UNDEFINED);
    return this;
}
module.exports = $58396c48529e025e$var$setCacheAdd;

});

parcelRegister("jkLBR", function(module, exports) {
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $e134d0dbde8122c4$var$setCacheHas(value) {
    return this.__data__.has(value);
}
module.exports = $e134d0dbde8122c4$var$setCacheHas;

});


parcelRegister("JBCmy", function(module, exports) {
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $0891622fc8e2afc8$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
module.exports = $0891622fc8e2afc8$var$arraySome;

});

parcelRegister("iXape", function(module, exports) {
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $dcc5cf19c94b788d$var$cacheHas(cache, key) {
    return cache.has(key);
}
module.exports = $dcc5cf19c94b788d$var$cacheHas;

});


parcelRegister("e32NE", function(module, exports) {

var $862yO = parcelRequire("862yO");

var $cjPak = parcelRequire("cjPak");

var $9xwlJ = parcelRequire("9xwlJ");

var $kquNj = parcelRequire("kquNj");

var $Ozwd6 = parcelRequire("Ozwd6");

var $eQUNp = parcelRequire("eQUNp");
/** Used to compose bitmasks for value comparisons. */ var $a3a3847b689e308c$var$COMPARE_PARTIAL_FLAG = 1, $a3a3847b689e308c$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $a3a3847b689e308c$var$boolTag = "[object Boolean]", $a3a3847b689e308c$var$dateTag = "[object Date]", $a3a3847b689e308c$var$errorTag = "[object Error]", $a3a3847b689e308c$var$mapTag = "[object Map]", $a3a3847b689e308c$var$numberTag = "[object Number]", $a3a3847b689e308c$var$regexpTag = "[object RegExp]", $a3a3847b689e308c$var$setTag = "[object Set]", $a3a3847b689e308c$var$stringTag = "[object String]", $a3a3847b689e308c$var$symbolTag = "[object Symbol]";
var $a3a3847b689e308c$var$arrayBufferTag = "[object ArrayBuffer]", $a3a3847b689e308c$var$dataViewTag = "[object DataView]";
/** Used to convert symbols to primitives and strings. */ var $a3a3847b689e308c$var$symbolProto = $862yO ? $862yO.prototype : undefined, $a3a3847b689e308c$var$symbolValueOf = $a3a3847b689e308c$var$symbolProto ? $a3a3847b689e308c$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $a3a3847b689e308c$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $a3a3847b689e308c$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $a3a3847b689e308c$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $cjPak(object), new $cjPak(other))) return false;
            return true;
        case $a3a3847b689e308c$var$boolTag:
        case $a3a3847b689e308c$var$dateTag:
        case $a3a3847b689e308c$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $9xwlJ(+object, +other);
        case $a3a3847b689e308c$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $a3a3847b689e308c$var$regexpTag:
        case $a3a3847b689e308c$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case $a3a3847b689e308c$var$mapTag:
            var convert = $Ozwd6;
        case $a3a3847b689e308c$var$setTag:
            var isPartial = bitmask & $a3a3847b689e308c$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $eQUNp);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $a3a3847b689e308c$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $kquNj(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object);
            return result;
        case $a3a3847b689e308c$var$symbolTag:
            if ($a3a3847b689e308c$var$symbolValueOf) return $a3a3847b689e308c$var$symbolValueOf.call(object) == $a3a3847b689e308c$var$symbolValueOf.call(other);
    }
    return false;
}
module.exports = $a3a3847b689e308c$var$equalByTag;

});
parcelRegister("cjPak", function(module, exports) {

var $l0bD9 = parcelRequire("l0bD9");
/** Built-in value references. */ var $8f7ef2c8a51a6766$var$Uint8Array = $l0bD9.Uint8Array;
module.exports = $8f7ef2c8a51a6766$var$Uint8Array;

});

parcelRegister("Ozwd6", function(module, exports) {
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $098038dd6638a7c0$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
module.exports = $098038dd6638a7c0$var$mapToArray;

});

parcelRegister("eQUNp", function(module, exports) {
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $ad01fa7f8dd6ec69$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
module.exports = $ad01fa7f8dd6ec69$var$setToArray;

});


parcelRegister("812FE", function(module, exports) {

var $13r7m = parcelRequire("13r7m");
/** Used to compose bitmasks for value comparisons. */ var $5d607d1c6f63e09a$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $5d607d1c6f63e09a$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $5d607d1c6f63e09a$var$hasOwnProperty = $5d607d1c6f63e09a$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $5d607d1c6f63e09a$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $5d607d1c6f63e09a$var$COMPARE_PARTIAL_FLAG, objProps = $13r7m(object), objLength = objProps.length, othProps = $13r7m(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $5d607d1c6f63e09a$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
module.exports = $5d607d1c6f63e09a$var$equalObjects;

});
parcelRegister("13r7m", function(module, exports) {

var $dRvHP = parcelRequire("dRvHP");

var $egeix = parcelRequire("egeix");

var $ebPNH = parcelRequire("ebPNH");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $0c4b1b498d71a6a7$var$getAllKeys(object) {
    return $dRvHP(object, $ebPNH, $egeix);
}
module.exports = $0c4b1b498d71a6a7$var$getAllKeys;

});
parcelRegister("dRvHP", function(module, exports) {

var $7whWk = parcelRequire("7whWk");

var $hpEZE = parcelRequire("hpEZE");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $a178d1bc8165d5f1$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $hpEZE(object) ? result : $7whWk(result, symbolsFunc(object));
}
module.exports = $a178d1bc8165d5f1$var$baseGetAllKeys;

});
parcelRegister("7whWk", function(module, exports) {
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $57997007557d029a$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
module.exports = $57997007557d029a$var$arrayPush;

});


parcelRegister("egeix", function(module, exports) {

var $k16Wg = parcelRequire("k16Wg");

var $jyZtg = parcelRequire("jyZtg");
/** Used for built-in method references. */ var $a61da693e053c8e4$var$objectProto = Object.prototype;
/** Built-in value references. */ var $a61da693e053c8e4$var$propertyIsEnumerable = $a61da693e053c8e4$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $a61da693e053c8e4$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $a61da693e053c8e4$var$getSymbols = !$a61da693e053c8e4$var$nativeGetSymbols ? $jyZtg : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $k16Wg($a61da693e053c8e4$var$nativeGetSymbols(object), function(symbol) {
        return $a61da693e053c8e4$var$propertyIsEnumerable.call(object, symbol);
    });
};
module.exports = $a61da693e053c8e4$var$getSymbols;

});
parcelRegister("k16Wg", function(module, exports) {
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $e929488206ea7999$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
module.exports = $e929488206ea7999$var$arrayFilter;

});

parcelRegister("jyZtg", function(module, exports) {
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $e3e0e02e88c5ac4b$var$stubArray() {
    return [];
}
module.exports = $e3e0e02e88c5ac4b$var$stubArray;

});




parcelRegister("d9ApZ", function(module, exports) {

var $aLMsn = parcelRequire("aLMsn");

var $3CaUB = parcelRequire("3CaUB");

var $8to89 = parcelRequire("8to89");

var $atnOk = parcelRequire("atnOk");

var $9TNzp = parcelRequire("9TNzp");

var $8bnAA = parcelRequire("8bnAA");

var $jskQ3 = parcelRequire("jskQ3");
/** `Object#toString` result references. */ var $99385d88027d2d31$var$mapTag = "[object Map]", $99385d88027d2d31$var$objectTag = "[object Object]", $99385d88027d2d31$var$promiseTag = "[object Promise]", $99385d88027d2d31$var$setTag = "[object Set]", $99385d88027d2d31$var$weakMapTag = "[object WeakMap]";
var $99385d88027d2d31$var$dataViewTag = "[object DataView]";
/** Used to detect maps, sets, and weakmaps. */ var $99385d88027d2d31$var$dataViewCtorString = $jskQ3($aLMsn), $99385d88027d2d31$var$mapCtorString = $jskQ3($3CaUB), $99385d88027d2d31$var$promiseCtorString = $jskQ3($8to89), $99385d88027d2d31$var$setCtorString = $jskQ3($atnOk), $99385d88027d2d31$var$weakMapCtorString = $jskQ3($9TNzp);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $99385d88027d2d31$var$getTag = $8bnAA;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($aLMsn && $99385d88027d2d31$var$getTag(new $aLMsn(new ArrayBuffer(1))) != $99385d88027d2d31$var$dataViewTag || $3CaUB && $99385d88027d2d31$var$getTag(new $3CaUB) != $99385d88027d2d31$var$mapTag || $8to89 && $99385d88027d2d31$var$getTag($8to89.resolve()) != $99385d88027d2d31$var$promiseTag || $atnOk && $99385d88027d2d31$var$getTag(new $atnOk) != $99385d88027d2d31$var$setTag || $9TNzp && $99385d88027d2d31$var$getTag(new $9TNzp) != $99385d88027d2d31$var$weakMapTag) $99385d88027d2d31$var$getTag = function(value) {
    var result = $8bnAA(value), Ctor = result == $99385d88027d2d31$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $jskQ3(Ctor) : "";
    if (ctorString) switch(ctorString){
        case $99385d88027d2d31$var$dataViewCtorString:
            return $99385d88027d2d31$var$dataViewTag;
        case $99385d88027d2d31$var$mapCtorString:
            return $99385d88027d2d31$var$mapTag;
        case $99385d88027d2d31$var$promiseCtorString:
            return $99385d88027d2d31$var$promiseTag;
        case $99385d88027d2d31$var$setCtorString:
            return $99385d88027d2d31$var$setTag;
        case $99385d88027d2d31$var$weakMapCtorString:
            return $99385d88027d2d31$var$weakMapTag;
    }
    return result;
};
module.exports = $99385d88027d2d31$var$getTag;

});
parcelRegister("aLMsn", function(module, exports) {

var $3qlcx = parcelRequire("3qlcx");

var $l0bD9 = parcelRequire("l0bD9");
/* Built-in method references that are verified to be native. */ var $7d73e1a74198ce5a$var$DataView = $3qlcx($l0bD9, "DataView");
module.exports = $7d73e1a74198ce5a$var$DataView;

});

parcelRegister("8to89", function(module, exports) {

var $3qlcx = parcelRequire("3qlcx");

var $l0bD9 = parcelRequire("l0bD9");
/* Built-in method references that are verified to be native. */ var $62b3bffe756fe6ea$var$Promise = $3qlcx($l0bD9, "Promise");
module.exports = $62b3bffe756fe6ea$var$Promise;

});

parcelRegister("atnOk", function(module, exports) {

var $3qlcx = parcelRequire("3qlcx");

var $l0bD9 = parcelRequire("l0bD9");
/* Built-in method references that are verified to be native. */ var $79ff1523cf65f7b0$var$Set = $3qlcx($l0bD9, "Set");
module.exports = $79ff1523cf65f7b0$var$Set;

});

parcelRegister("9TNzp", function(module, exports) {

var $3qlcx = parcelRequire("3qlcx");

var $l0bD9 = parcelRequire("l0bD9");
/* Built-in method references that are verified to be native. */ var $734fb3b54d223b76$var$WeakMap = $3qlcx($l0bD9, "WeakMap");
module.exports = $734fb3b54d223b76$var$WeakMap;

});





parcelRegister("5rOOj", function(module, exports) {

var $cDp4p = parcelRequire("cDp4p");

var $ebPNH = parcelRequire("ebPNH");
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $3f76e34b8ef22070$var$getMatchData(object) {
    var result = $ebPNH(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            $cDp4p(value)
        ];
    }
    return result;
}
module.exports = $3f76e34b8ef22070$var$getMatchData;

});
parcelRegister("cDp4p", function(module, exports) {

var $dXwJf = parcelRequire("dXwJf");
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $932c92f4c27d9643$var$isStrictComparable(value) {
    return value === value && !$dXwJf(value);
}
module.exports = $932c92f4c27d9643$var$isStrictComparable;

});


parcelRegister("8DhCW", function(module, exports) {
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $648fa39c02b34c9c$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
module.exports = $648fa39c02b34c9c$var$matchesStrictComparable;

});


parcelRegister("kkq0Y", function(module, exports) {

var $53LO5 = parcelRequire("53LO5");

var $boT2p = parcelRequire("boT2p");

var $bOC5Z = parcelRequire("bOC5Z");

var $cOCZW = parcelRequire("cOCZW");

var $cDp4p = parcelRequire("cDp4p");

var $8DhCW = parcelRequire("8DhCW");

var $kA8d7 = parcelRequire("kA8d7");
/** Used to compose bitmasks for value comparisons. */ var $ecc9dadd02f7f941$var$COMPARE_PARTIAL_FLAG = 1, $ecc9dadd02f7f941$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $ecc9dadd02f7f941$var$baseMatchesProperty(path, srcValue) {
    if ($cOCZW(path) && $cDp4p(srcValue)) return $8DhCW($kA8d7(path), srcValue);
    return function(object) {
        var objValue = $boT2p(object, path);
        return objValue === undefined && objValue === srcValue ? $bOC5Z(object, path) : $53LO5(srcValue, objValue, $ecc9dadd02f7f941$var$COMPARE_PARTIAL_FLAG | $ecc9dadd02f7f941$var$COMPARE_UNORDERED_FLAG);
    };
}
module.exports = $ecc9dadd02f7f941$var$baseMatchesProperty;

});
parcelRegister("boT2p", function(module, exports) {

var $68ZmT = parcelRequire("68ZmT");
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $84cca0f67b24512c$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $68ZmT(object, path);
    return result === undefined ? defaultValue : result;
}
module.exports = $84cca0f67b24512c$var$get;

});
parcelRegister("68ZmT", function(module, exports) {

var $fGOSB = parcelRequire("fGOSB");

var $kA8d7 = parcelRequire("kA8d7");
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $479317e3912d4d3d$var$baseGet(object, path) {
    path = $fGOSB(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$kA8d7(path[index++])];
    return index && index == length ? object : undefined;
}
module.exports = $479317e3912d4d3d$var$baseGet;

});


parcelRegister("bOC5Z", function(module, exports) {

var $7MQ6Z = parcelRequire("7MQ6Z");

var $7tSIP = parcelRequire("7tSIP");
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $89a1ea363485a2e0$var$hasIn(object, path) {
    return object != null && $7tSIP(object, path, $7MQ6Z);
}
module.exports = $89a1ea363485a2e0$var$hasIn;

});
parcelRegister("7MQ6Z", function(module, exports) {
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $5ab570672ec12cd2$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
module.exports = $5ab570672ec12cd2$var$baseHasIn;

});



parcelRegister("e3EMk", function(module, exports) {
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $a3c0fa493674321d$var$identity(value) {
    return value;
}
module.exports = $a3c0fa493674321d$var$identity;

});

parcelRegister("87Kwr", function(module, exports) {

var $lUKZu = parcelRequire("lUKZu");

var $avtO5 = parcelRequire("avtO5");

var $cOCZW = parcelRequire("cOCZW");

var $kA8d7 = parcelRequire("kA8d7");
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $5ea3108285863f3e$var$property(path) {
    return $cOCZW(path) ? $lUKZu($kA8d7(path)) : $avtO5(path);
}
module.exports = $5ea3108285863f3e$var$property;

});
parcelRegister("lUKZu", function(module, exports) {
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $ff434755b0560a59$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
module.exports = $ff434755b0560a59$var$baseProperty;

});

parcelRegister("avtO5", function(module, exports) {

var $68ZmT = parcelRequire("68ZmT");
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $7a63eba704041830$var$basePropertyDeep(path) {
    return function(object) {
        return $68ZmT(object, path);
    };
}
module.exports = $7a63eba704041830$var$basePropertyDeep;

});




parcelRegister("fGxXP", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6b51fca705de18f$export$2e2bcd8739ae039);

var $7Spqi = parcelRequire("7Spqi");
const $b6b51fca705de18f$var$prefixes = {
    context: "$",
    value: "."
};
function $b6b51fca705de18f$export$185802fd694ee1f5(key, options) {
    return new $b6b51fca705de18f$export$2e2bcd8739ae039(key, options);
}
class $b6b51fca705de18f$export$2e2bcd8739ae039 {
    constructor(key, options = {}){
        this.key = void 0;
        this.isContext = void 0;
        this.isValue = void 0;
        this.isSibling = void 0;
        this.path = void 0;
        this.getter = void 0;
        this.map = void 0;
        if (typeof key !== "string") throw new TypeError("ref must be a string, got: " + key);
        this.key = key.trim();
        if (key === "") throw new TypeError("ref must be a non-empty string");
        this.isContext = this.key[0] === $b6b51fca705de18f$var$prefixes.context;
        this.isValue = this.key[0] === $b6b51fca705de18f$var$prefixes.value;
        this.isSibling = !this.isContext && !this.isValue;
        let prefix = this.isContext ? $b6b51fca705de18f$var$prefixes.context : this.isValue ? $b6b51fca705de18f$var$prefixes.value : "";
        this.path = this.key.slice(prefix.length);
        this.getter = this.path && (0, $7Spqi.getter)(this.path, true);
        this.map = options.map;
    }
    getValue(value, parent, context) {
        let result = this.isContext ? context : this.isValue ? value : parent;
        if (this.getter) result = this.getter(result || {});
        if (this.map) result = this.map(result);
        return result;
    }
    /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {Object=} options.context
   * @param {Object=} options.parent
   */ cast(value, options) {
        return this.getValue(value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context);
    }
    resolve() {
        return this;
    }
    describe() {
        return {
            type: "ref",
            key: this.key
        };
    }
    toString() {
        return `Ref(${this.key})`;
    }
    static isRef(value) {
        return value && value.__isYupRef;
    }
} // @ts-ignore
$b6b51fca705de18f$export$2e2bcd8739ae039.prototype.__isYupRef = true;

});
parcelRegister("7Spqi", function(module, exports) {
/**
 * Based on Kendo UI Core expression code <https://github.com/telerik/kendo-ui-core#license-information>
 */ "use strict";
function $5bc14c0fe9940240$var$Cache(maxSize) {
    this._maxSize = maxSize;
    this.clear();
}
$5bc14c0fe9940240$var$Cache.prototype.clear = function() {
    this._size = 0;
    this._values = Object.create(null);
};
$5bc14c0fe9940240$var$Cache.prototype.get = function(key) {
    return this._values[key];
};
$5bc14c0fe9940240$var$Cache.prototype.set = function(key, value) {
    this._size >= this._maxSize && this.clear();
    if (!(key in this._values)) this._size++;
    return this._values[key] = value;
};
var $5bc14c0fe9940240$var$SPLIT_REGEX = /[^.^\]^[]+|(?=\[\]|\.\.)/g, $5bc14c0fe9940240$var$DIGIT_REGEX = /^\d+$/, $5bc14c0fe9940240$var$LEAD_DIGIT_REGEX = /^\d/, $5bc14c0fe9940240$var$SPEC_CHAR_REGEX = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g, $5bc14c0fe9940240$var$CLEAN_QUOTES_REGEX = /^\s*(['"]?)(.*?)(\1)\s*$/, $5bc14c0fe9940240$var$MAX_CACHE_SIZE = 512;
var $5bc14c0fe9940240$var$pathCache = new $5bc14c0fe9940240$var$Cache($5bc14c0fe9940240$var$MAX_CACHE_SIZE), $5bc14c0fe9940240$var$setCache = new $5bc14c0fe9940240$var$Cache($5bc14c0fe9940240$var$MAX_CACHE_SIZE), $5bc14c0fe9940240$var$getCache = new $5bc14c0fe9940240$var$Cache($5bc14c0fe9940240$var$MAX_CACHE_SIZE);
var $5bc14c0fe9940240$var$config;
module.exports = {
    Cache: $5bc14c0fe9940240$var$Cache,
    split: $5bc14c0fe9940240$var$split,
    normalizePath: $5bc14c0fe9940240$var$normalizePath,
    setter: function(path) {
        var parts = $5bc14c0fe9940240$var$normalizePath(path);
        return $5bc14c0fe9940240$var$setCache.get(path) || $5bc14c0fe9940240$var$setCache.set(path, function setter(obj, value) {
            var index = 0;
            var len = parts.length;
            var data = obj;
            while(index < len - 1){
                var part = parts[index];
                if (part === "__proto__" || part === "constructor" || part === "prototype") return obj;
                data = data[parts[index++]];
            }
            data[parts[index]] = value;
        });
    },
    getter: function(path, safe) {
        var parts = $5bc14c0fe9940240$var$normalizePath(path);
        return $5bc14c0fe9940240$var$getCache.get(path) || $5bc14c0fe9940240$var$getCache.set(path, function getter(data) {
            var index = 0, len = parts.length;
            while(index < len){
                if (data != null || !safe) data = data[parts[index++]];
                else return;
            }
            return data;
        });
    },
    join: function(segments) {
        return segments.reduce(function(path, part) {
            return path + ($5bc14c0fe9940240$var$isQuoted(part) || $5bc14c0fe9940240$var$DIGIT_REGEX.test(part) ? "[" + part + "]" : (path ? "." : "") + part);
        }, "");
    },
    forEach: function(path, cb, thisArg) {
        $5bc14c0fe9940240$var$forEach(Array.isArray(path) ? path : $5bc14c0fe9940240$var$split(path), cb, thisArg);
    }
};
function $5bc14c0fe9940240$var$normalizePath(path) {
    return $5bc14c0fe9940240$var$pathCache.get(path) || $5bc14c0fe9940240$var$pathCache.set(path, $5bc14c0fe9940240$var$split(path).map(function(part) {
        return part.replace($5bc14c0fe9940240$var$CLEAN_QUOTES_REGEX, "$2");
    }));
}
function $5bc14c0fe9940240$var$split(path) {
    return path.match($5bc14c0fe9940240$var$SPLIT_REGEX) || [
        ""
    ];
}
function $5bc14c0fe9940240$var$forEach(parts, iter, thisArg) {
    var len = parts.length, part, idx, isArray, isBracket;
    for(idx = 0; idx < len; idx++){
        part = parts[idx];
        if (part) {
            if ($5bc14c0fe9940240$var$shouldBeQuoted(part)) part = '"' + part + '"';
            isBracket = $5bc14c0fe9940240$var$isQuoted(part);
            isArray = !isBracket && /^\d+$/.test(part);
            iter.call(thisArg, part, isBracket, isArray, idx, parts);
        }
    }
}
function $5bc14c0fe9940240$var$isQuoted(str) {
    return typeof str === "string" && str && [
        "'",
        '"'
    ].indexOf(str.charAt(0)) !== -1;
}
function $5bc14c0fe9940240$var$hasLeadingNumber(part) {
    return part.match($5bc14c0fe9940240$var$LEAD_DIGIT_REGEX) && !part.match($5bc14c0fe9940240$var$DIGIT_REGEX);
}
function $5bc14c0fe9940240$var$hasSpecialChars(part) {
    return $5bc14c0fe9940240$var$SPEC_CHAR_REGEX.test(part);
}
function $5bc14c0fe9940240$var$shouldBeQuoted(part) {
    return !$5bc14c0fe9940240$var$isQuoted(part) && ($5bc14c0fe9940240$var$hasLeadingNumber(part) || $5bc14c0fe9940240$var$hasSpecialChars(part));
}

});



parcelRegister("b9Jng", function(module, exports) {

$parcel$export(module.exports, "getIn", () => $81f3bb54f502614a$export$c52e5867d5879e24);

var $7Spqi = parcelRequire("7Spqi");
let $81f3bb54f502614a$var$trim = (part)=>part.substr(0, part.length - 1).substr(1);
function $81f3bb54f502614a$export$c52e5867d5879e24(schema, path, value, context = value) {
    let parent, lastPart, lastPartDebug; // root path: ''
    if (!path) return {
        parent: parent,
        parentPath: path,
        schema: schema
    };
    (0, $7Spqi.forEach)(path, (_part, isBracket, isArray)=>{
        let part = isBracket ? $81f3bb54f502614a$var$trim(_part) : _part;
        schema = schema.resolve({
            context: context,
            parent: parent,
            value: value
        });
        if (schema.innerType) {
            let idx = isArray ? parseInt(part, 10) : 0;
            if (value && idx >= value.length) throw new Error(`Yup.reach cannot resolve an array item at index: ${_part}, in the path: ${path}. ` + `because there is no value at that index. `);
            parent = value;
            value = value && value[idx];
            schema = schema.innerType;
        } // sometimes the array index part of a path doesn't exist: "nested.arr.child"
        // in these cases the current part is the next schema and should be processed
        // in this iteration. For cases where the index signature is included this
        // check will fail and we'll handle the `child` part on the next iteration like normal
        if (!isArray) {
            if (!schema.fields || !schema.fields[part]) throw new Error(`The schema does not contain the path: ${path}. ` + `(failed at: ${lastPartDebug} which is a type: "${schema._type}")`);
            parent = value;
            value = value && value[part];
            schema = schema.fields[part];
        }
        lastPart = part;
        lastPartDebug = isBracket ? "[" + _part + "]" : "." + _part;
    });
    return {
        schema: schema,
        parent: parent,
        parentPath: lastPart
    };
}
const $81f3bb54f502614a$var$reach = (obj, path, value, context)=>$81f3bb54f502614a$export$c52e5867d5879e24(obj, path, value, context).schema;
var $81f3bb54f502614a$export$2e2bcd8739ae039 = $81f3bb54f502614a$var$reach;

});

parcelRegister("7dTXW", function(module, exports) {

$parcel$export(module.exports, "default", () => $542528eebac1e48b$export$2e2bcd8739ae039);

var $fGxXP = parcelRequire("fGxXP");
class $542528eebac1e48b$export$2e2bcd8739ae039 {
    constructor(){
        this.list = void 0;
        this.refs = void 0;
        this.list = new Set();
        this.refs = new Map();
    }
    get size() {
        return this.list.size + this.refs.size;
    }
    describe() {
        const description = [];
        for (const item of this.list)description.push(item);
        for (const [, ref] of this.refs)description.push(ref.describe());
        return description;
    }
    toArray() {
        return Array.from(this.list).concat(Array.from(this.refs.values()));
    }
    resolveAll(resolve) {
        return this.toArray().reduce((acc, e)=>acc.concat((0, $fGxXP.default).isRef(e) ? resolve(e) : e), []);
    }
    add(value) {
        (0, $fGxXP.default).isRef(value) ? this.refs.set(value.key, value) : this.list.add(value);
    }
    delete(value) {
        (0, $fGxXP.default).isRef(value) ? this.refs.delete(value.key) : this.list.delete(value);
    }
    clone() {
        const next = new $542528eebac1e48b$export$2e2bcd8739ae039();
        next.list = new Set(this.list);
        next.refs = new Map(this.refs);
        return next;
    }
    merge(newItems, removeItems) {
        const next = this.clone();
        newItems.list.forEach((value)=>next.add(value));
        newItems.refs.forEach((value)=>next.add(value));
        removeItems.list.forEach((value)=>next.delete(value));
        removeItems.refs.forEach((value)=>next.delete(value));
        return next;
    }
}

});



parcelRegister("5hWhW", function(module, exports) {

$parcel$export(module.exports, "create", () => $3d9bc128860d2767$export$185802fd694ee1f5);

var $8Cojz = parcelRequire("8Cojz");

var $dZq6i = parcelRequire("dZq6i");

var $etiuQ = parcelRequire("etiuQ");
function $3d9bc128860d2767$export$185802fd694ee1f5() {
    return new $3d9bc128860d2767$export$2e2bcd8739ae039();
}
class $3d9bc128860d2767$export$2e2bcd8739ae039 extends (0, $8Cojz.default) {
    constructor(){
        super({
            type: "boolean"
        });
        this.withMutation(()=>{
            this.transform(function(value) {
                if (!this.isType(value)) {
                    if (/^(true|1)$/i.test(String(value))) return true;
                    if (/^(false|0)$/i.test(String(value))) return false;
                }
                return value;
            });
        });
    }
    _typeCheck(v) {
        if (v instanceof Boolean) v = v.valueOf();
        return typeof v === "boolean";
    }
    isTrue(message = (0, $dZq6i.boolean).isValue) {
        return this.test({
            message: message,
            name: "is-value",
            exclusive: true,
            params: {
                value: "true"
            },
            test (value) {
                return (0, $etiuQ.default)(value) || value === true;
            }
        });
    }
    isFalse(message = (0, $dZq6i.boolean).isValue) {
        return this.test({
            message: message,
            name: "is-value",
            exclusive: true,
            params: {
                value: "false"
            },
            test (value) {
                return (0, $etiuQ.default)(value) || value === false;
            }
        });
    }
}
$3d9bc128860d2767$export$185802fd694ee1f5.prototype = $3d9bc128860d2767$export$2e2bcd8739ae039.prototype;

});
parcelRegister("etiuQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a8921f1dec5d32b7$export$2e2bcd8739ae039);
const $a8921f1dec5d32b7$var$isAbsent = (value)=>value == null;
var $a8921f1dec5d32b7$export$2e2bcd8739ae039 = $a8921f1dec5d32b7$var$isAbsent;

});


parcelRegister("ukLGy", function(module, exports) {

$parcel$export(module.exports, "create", () => $05b2e9928d0809ca$export$185802fd694ee1f5);

var $dZq6i = parcelRequire("dZq6i");

var $etiuQ = parcelRequire("etiuQ");

var $8Cojz = parcelRequire("8Cojz");
let $05b2e9928d0809ca$var$rEmail = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i; // eslint-disable-next-line
let $05b2e9928d0809ca$var$rUrl = /^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i; // eslint-disable-next-line
let $05b2e9928d0809ca$var$rUUID = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
let $05b2e9928d0809ca$var$isTrimmed = (value)=>(0, $etiuQ.default)(value) || value === value.trim();
let $05b2e9928d0809ca$var$objStringTag = ({}).toString();
function $05b2e9928d0809ca$export$185802fd694ee1f5() {
    return new $05b2e9928d0809ca$export$2e2bcd8739ae039();
}
class $05b2e9928d0809ca$export$2e2bcd8739ae039 extends (0, $8Cojz.default) {
    constructor(){
        super({
            type: "string"
        });
        this.withMutation(()=>{
            this.transform(function(value) {
                if (this.isType(value)) return value;
                if (Array.isArray(value)) return value;
                const strValue = value != null && value.toString ? value.toString() : value;
                if (strValue === $05b2e9928d0809ca$var$objStringTag) return value;
                return strValue;
            });
        });
    }
    _typeCheck(value) {
        if (value instanceof String) value = value.valueOf();
        return typeof value === "string";
    }
    _isPresent(value) {
        return super._isPresent(value) && !!value.length;
    }
    length(length, message = (0, $dZq6i.string).length) {
        return this.test({
            message: message,
            name: "length",
            exclusive: true,
            params: {
                length: length
            },
            test (value) {
                return (0, $etiuQ.default)(value) || value.length === this.resolve(length);
            }
        });
    }
    min(min, message = (0, $dZq6i.string).min) {
        return this.test({
            message: message,
            name: "min",
            exclusive: true,
            params: {
                min: min
            },
            test (value) {
                return (0, $etiuQ.default)(value) || value.length >= this.resolve(min);
            }
        });
    }
    max(max, message = (0, $dZq6i.string).max) {
        return this.test({
            name: "max",
            exclusive: true,
            message: message,
            params: {
                max: max
            },
            test (value) {
                return (0, $etiuQ.default)(value) || value.length <= this.resolve(max);
            }
        });
    }
    matches(regex, options) {
        let excludeEmptyString = false;
        let message;
        let name;
        if (options) {
            if (typeof options === "object") ({ excludeEmptyString: excludeEmptyString = false, message: message, name: name } = options);
            else message = options;
        }
        return this.test({
            name: name || "matches",
            message: message || (0, $dZq6i.string).matches,
            params: {
                regex: regex
            },
            test: (value)=>(0, $etiuQ.default)(value) || value === "" && excludeEmptyString || value.search(regex) !== -1
        });
    }
    email(message = (0, $dZq6i.string).email) {
        return this.matches($05b2e9928d0809ca$var$rEmail, {
            name: "email",
            message: message,
            excludeEmptyString: true
        });
    }
    url(message = (0, $dZq6i.string).url) {
        return this.matches($05b2e9928d0809ca$var$rUrl, {
            name: "url",
            message: message,
            excludeEmptyString: true
        });
    }
    uuid(message = (0, $dZq6i.string).uuid) {
        return this.matches($05b2e9928d0809ca$var$rUUID, {
            name: "uuid",
            message: message,
            excludeEmptyString: false
        });
    }
    ensure() {
        return this.default("").transform((val)=>val === null ? "" : val);
    }
    trim(message = (0, $dZq6i.string).trim) {
        return this.transform((val)=>val != null ? val.trim() : val).test({
            message: message,
            name: "trim",
            test: $05b2e9928d0809ca$var$isTrimmed
        });
    }
    lowercase(message = (0, $dZq6i.string).lowercase) {
        return this.transform((value)=>!(0, $etiuQ.default)(value) ? value.toLowerCase() : value).test({
            message: message,
            name: "string_case",
            exclusive: true,
            test: (value)=>(0, $etiuQ.default)(value) || value === value.toLowerCase()
        });
    }
    uppercase(message = (0, $dZq6i.string).uppercase) {
        return this.transform((value)=>!(0, $etiuQ.default)(value) ? value.toUpperCase() : value).test({
            message: message,
            name: "string_case",
            exclusive: true,
            test: (value)=>(0, $etiuQ.default)(value) || value === value.toUpperCase()
        });
    }
}
$05b2e9928d0809ca$export$185802fd694ee1f5.prototype = $05b2e9928d0809ca$export$2e2bcd8739ae039.prototype; //
 // String Interfaces
 //

});

parcelRegister("2rGWI", function(module, exports) {

$parcel$export(module.exports, "create", () => $1c7f6a94081b1747$export$185802fd694ee1f5);

var $dZq6i = parcelRequire("dZq6i");

var $etiuQ = parcelRequire("etiuQ");

var $8Cojz = parcelRequire("8Cojz");
let $1c7f6a94081b1747$var$isNaN = (value)=>value != +value;
function $1c7f6a94081b1747$export$185802fd694ee1f5() {
    return new $1c7f6a94081b1747$export$2e2bcd8739ae039();
}
class $1c7f6a94081b1747$export$2e2bcd8739ae039 extends (0, $8Cojz.default) {
    constructor(){
        super({
            type: "number"
        });
        this.withMutation(()=>{
            this.transform(function(value) {
                let parsed = value;
                if (typeof parsed === "string") {
                    parsed = parsed.replace(/\s/g, "");
                    if (parsed === "") return NaN; // don't use parseFloat to avoid positives on alpha-numeric strings
                    parsed = +parsed;
                }
                if (this.isType(parsed)) return parsed;
                return parseFloat(parsed);
            });
        });
    }
    _typeCheck(value) {
        if (value instanceof Number) value = value.valueOf();
        return typeof value === "number" && !$1c7f6a94081b1747$var$isNaN(value);
    }
    min(min, message = (0, $dZq6i.number).min) {
        return this.test({
            message: message,
            name: "min",
            exclusive: true,
            params: {
                min: min
            },
            test (value) {
                return (0, $etiuQ.default)(value) || value >= this.resolve(min);
            }
        });
    }
    max(max, message = (0, $dZq6i.number).max) {
        return this.test({
            message: message,
            name: "max",
            exclusive: true,
            params: {
                max: max
            },
            test (value) {
                return (0, $etiuQ.default)(value) || value <= this.resolve(max);
            }
        });
    }
    lessThan(less, message = (0, $dZq6i.number).lessThan) {
        return this.test({
            message: message,
            name: "max",
            exclusive: true,
            params: {
                less: less
            },
            test (value) {
                return (0, $etiuQ.default)(value) || value < this.resolve(less);
            }
        });
    }
    moreThan(more, message = (0, $dZq6i.number).moreThan) {
        return this.test({
            message: message,
            name: "min",
            exclusive: true,
            params: {
                more: more
            },
            test (value) {
                return (0, $etiuQ.default)(value) || value > this.resolve(more);
            }
        });
    }
    positive(msg = (0, $dZq6i.number).positive) {
        return this.moreThan(0, msg);
    }
    negative(msg = (0, $dZq6i.number).negative) {
        return this.lessThan(0, msg);
    }
    integer(message = (0, $dZq6i.number).integer) {
        return this.test({
            name: "integer",
            message: message,
            test: (val)=>(0, $etiuQ.default)(val) || Number.isInteger(val)
        });
    }
    truncate() {
        return this.transform((value)=>!(0, $etiuQ.default)(value) ? value | 0 : value);
    }
    round(method) {
        var _method;
        let avail = [
            "ceil",
            "floor",
            "round",
            "trunc"
        ];
        method = ((_method = method) == null ? void 0 : _method.toLowerCase()) || "round"; // this exists for symemtry with the new Math.trunc
        if (method === "trunc") return this.truncate();
        if (avail.indexOf(method.toLowerCase()) === -1) throw new TypeError("Only valid options for round() are: " + avail.join(", "));
        return this.transform((value)=>!(0, $etiuQ.default)(value) ? Math[method](value) : value);
    }
}
$1c7f6a94081b1747$export$185802fd694ee1f5.prototype = $1c7f6a94081b1747$export$2e2bcd8739ae039.prototype; //
 // Number Interfaces
 //

});

parcelRegister("8Fw82", function(module, exports) {

$parcel$export(module.exports, "create", () => $64fb132aa05b76dd$export$185802fd694ee1f5);
// @ts-ignore

var $aV745 = parcelRequire("aV745");

var $dZq6i = parcelRequire("dZq6i");

var $etiuQ = parcelRequire("etiuQ");

var $fGxXP = parcelRequire("fGxXP");

var $8Cojz = parcelRequire("8Cojz");
let $64fb132aa05b76dd$var$invalidDate = new Date("");
let $64fb132aa05b76dd$var$isDate = (obj)=>Object.prototype.toString.call(obj) === "[object Date]";
function $64fb132aa05b76dd$export$185802fd694ee1f5() {
    return new $64fb132aa05b76dd$export$2e2bcd8739ae039();
}
class $64fb132aa05b76dd$export$2e2bcd8739ae039 extends (0, $8Cojz.default) {
    constructor(){
        super({
            type: "date"
        });
        this.withMutation(()=>{
            this.transform(function(value) {
                if (this.isType(value)) return value;
                value = (0, $aV745.default)(value); // 0 is a valid timestamp equivalent to 1970-01-01T00:00:00Z(unix epoch) or before.
                return !isNaN(value) ? new Date(value) : $64fb132aa05b76dd$var$invalidDate;
            });
        });
    }
    _typeCheck(v) {
        return $64fb132aa05b76dd$var$isDate(v) && !isNaN(v.getTime());
    }
    prepareParam(ref, name) {
        let param;
        if (!(0, $fGxXP.default).isRef(ref)) {
            let cast = this.cast(ref);
            if (!this._typeCheck(cast)) throw new TypeError(`\`${name}\` must be a Date or a value that can be \`cast()\` to a Date`);
            param = cast;
        } else param = ref;
        return param;
    }
    min(min, message = (0, $dZq6i.date).min) {
        let limit = this.prepareParam(min, "min");
        return this.test({
            message: message,
            name: "min",
            exclusive: true,
            params: {
                min: min
            },
            test (value) {
                return (0, $etiuQ.default)(value) || value >= this.resolve(limit);
            }
        });
    }
    max(max, message = (0, $dZq6i.date).max) {
        let limit = this.prepareParam(max, "max");
        return this.test({
            message: message,
            name: "max",
            exclusive: true,
            params: {
                max: max
            },
            test (value) {
                return (0, $etiuQ.default)(value) || value <= this.resolve(limit);
            }
        });
    }
}
$64fb132aa05b76dd$export$2e2bcd8739ae039.INVALID_DATE = $64fb132aa05b76dd$var$invalidDate;
$64fb132aa05b76dd$export$185802fd694ee1f5.prototype = $64fb132aa05b76dd$export$2e2bcd8739ae039.prototype;
$64fb132aa05b76dd$export$185802fd694ee1f5.INVALID_DATE = $64fb132aa05b76dd$var$invalidDate;

});
parcelRegister("aV745", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f34b532e1bdb684$export$2e2bcd8739ae039);
/* eslint-disable */ /**
 *
 * Date.parse with progressive enhancement for ISO 8601 <https://github.com/csnover/js-iso8601>
 * NON-CONFORMANT EDITION.
 * © 2011 Colin Snover <http://zetafleet.com>
 * Released under MIT license.
 */ //              1 YYYY                 2 MM        3 DD              4 HH     5 mm        6 ss            7 msec         8 Z 9 ±    10 tzHH    11 tzmm
var $7f34b532e1bdb684$var$isoReg = /^(\d{4}|[+\-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,\.](\d{1,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/;
function $7f34b532e1bdb684$export$2e2bcd8739ae039(date) {
    var numericKeys = [
        1,
        4,
        5,
        6,
        7,
        10,
        11
    ], minutesOffset = 0, timestamp, struct;
    if (struct = $7f34b532e1bdb684$var$isoReg.exec(date)) {
        // avoid NaN timestamps caused by “undefined” values being passed to Date.UTC
        for(var i = 0, k; k = numericKeys[i]; ++i)struct[k] = +struct[k] || 0; // allow undefined days and months
        struct[2] = (+struct[2] || 1) - 1;
        struct[3] = +struct[3] || 1; // allow arbitrary sub-second precision beyond milliseconds
        struct[7] = struct[7] ? String(struct[7]).substr(0, 3) : 0; // timestamps without timezone identifiers should be considered local time
        if ((struct[8] === undefined || struct[8] === "") && (struct[9] === undefined || struct[9] === "")) timestamp = +new Date(struct[1], struct[2], struct[3], struct[4], struct[5], struct[6], struct[7]);
        else {
            if (struct[8] !== "Z" && struct[9] !== undefined) {
                minutesOffset = struct[10] * 60 + struct[11];
                if (struct[9] === "+") minutesOffset = 0 - minutesOffset;
            }
            timestamp = Date.UTC(struct[1], struct[2], struct[3], struct[4], struct[5] + minutesOffset, struct[6], struct[7]);
        }
    } else timestamp = Date.parse ? Date.parse(date) : NaN;
    return timestamp;
}

});


parcelRegister("1ZTZh", function(module, exports) {

$parcel$export(module.exports, "create", () => $1746eadb3fc51b1f$export$185802fd694ee1f5);

var $2xkoI = parcelRequire("2xkoI");

var $k8qkR = parcelRequire("k8qkR");

var $2NzVt = parcelRequire("2NzVt");

var $4wCub = parcelRequire("4wCub");

var $cvX5D = parcelRequire("cvX5D");

var $7Spqi = parcelRequire("7Spqi");

var $dZq6i = parcelRequire("dZq6i");

var $dTw9i = parcelRequire("dTw9i");

var $5sWN4 = parcelRequire("5sWN4");

var $epCOP = parcelRequire("epCOP");

var $41aWH = parcelRequire("41aWH");

var $8Cojz = parcelRequire("8Cojz");
function $1746eadb3fc51b1f$var$_extends() {
    $1746eadb3fc51b1f$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1746eadb3fc51b1f$var$_extends.apply(this, arguments);
}
let $1746eadb3fc51b1f$var$isObject = (obj)=>Object.prototype.toString.call(obj) === "[object Object]";
function $1746eadb3fc51b1f$var$unknown(ctx, value) {
    let known = Object.keys(ctx.fields);
    return Object.keys(value).filter((key)=>known.indexOf(key) === -1);
}
const $1746eadb3fc51b1f$var$defaultSort = (0, $5sWN4.default)([]);
class $1746eadb3fc51b1f$export$2e2bcd8739ae039 extends (0, $8Cojz.default) {
    constructor(spec){
        super({
            type: "object"
        });
        this.fields = Object.create(null);
        this._sortErrors = $1746eadb3fc51b1f$var$defaultSort;
        this._nodes = [];
        this._excludedEdges = [];
        this.withMutation(()=>{
            this.transform(function coerce(value) {
                if (typeof value === "string") try {
                    value = JSON.parse(value);
                } catch (err) {
                    value = null;
                }
                if (this.isType(value)) return value;
                return null;
            });
            if (spec) this.shape(spec);
        });
    }
    _typeCheck(value) {
        return $1746eadb3fc51b1f$var$isObject(value) || typeof value === "function";
    }
    _cast(_value, options = {}) {
        var _options$stripUnknown;
        let value = super._cast(_value, options); //should ignore nulls here
        if (value === undefined) return this.getDefault();
        if (!this._typeCheck(value)) return value;
        let fields = this.fields;
        let strip = (_options$stripUnknown = options.stripUnknown) != null ? _options$stripUnknown : this.spec.noUnknown;
        let props = this._nodes.concat(Object.keys(value).filter((v)=>this._nodes.indexOf(v) === -1));
        let intermediateValue = {}; // is filled during the transform below
        let innerOptions = $1746eadb3fc51b1f$var$_extends({}, options, {
            parent: intermediateValue,
            __validating: options.__validating || false
        });
        let isChanged = false;
        for (const prop of props){
            let field = fields[prop];
            let exists = (0, (/*@__PURE__*/$parcel$interopDefault($2xkoI)))(value, prop);
            if (field) {
                let fieldValue;
                let inputValue = value[prop]; // safe to mutate since this is fired in sequence
                innerOptions.path = (options.path ? `${options.path}.` : "") + prop; // innerOptions.value = value[prop];
                field = field.resolve({
                    value: inputValue,
                    context: options.context,
                    parent: intermediateValue
                });
                let fieldSpec = "spec" in field ? field.spec : undefined;
                let strict = fieldSpec == null ? void 0 : fieldSpec.strict;
                if (fieldSpec == null ? void 0 : fieldSpec.strip) {
                    isChanged = isChanged || prop in value;
                    continue;
                }
                fieldValue = !options.__validating || !strict ? field.cast(value[prop], innerOptions) : value[prop];
                if (fieldValue !== undefined) intermediateValue[prop] = fieldValue;
            } else if (exists && !strip) intermediateValue[prop] = value[prop];
            if (intermediateValue[prop] !== value[prop]) isChanged = true;
        }
        return isChanged ? intermediateValue : value;
    }
    _validate(_value, opts = {}, callback) {
        let errors = [];
        let { sync: sync, from: from = [], originalValue: originalValue = _value, abortEarly: abortEarly = this.spec.abortEarly, recursive: recursive = this.spec.recursive } = opts;
        from = [
            {
                schema: this,
                value: originalValue
            },
            ...from
        ]; // this flag is needed for handling `strict` correctly in the context of
        // validation vs just casting. e.g strict() on a field is only used when validating
        opts.__validating = true;
        opts.originalValue = originalValue;
        opts.from = from;
        super._validate(_value, opts, (err, value)=>{
            if (err) {
                if (!(0, $41aWH.default).isError(err) || abortEarly) return void callback(err, value);
                errors.push(err);
            }
            if (!recursive || !$1746eadb3fc51b1f$var$isObject(value)) {
                callback(errors[0] || null, value);
                return;
            }
            originalValue = originalValue || value;
            let tests = this._nodes.map((key)=>(_, cb)=>{
                    let path = key.indexOf(".") === -1 ? (opts.path ? `${opts.path}.` : "") + key : `${opts.path || ""}["${key}"]`;
                    let field = this.fields[key];
                    if (field && "validate" in field) {
                        field.validate(value[key], $1746eadb3fc51b1f$var$_extends({}, opts, {
                            path: // @ts-ignore
                            path,
                            from: from,
                            // inner fields are always strict:
                            // 1. this isn't strict so the casting will also have cast inner values
                            // 2. this is strict in which case the nested values weren't cast either
                            strict: true,
                            parent: value,
                            originalValue: originalValue[key]
                        }), cb);
                        return;
                    }
                    cb(null);
                });
            (0, $epCOP.default)({
                sync: sync,
                tests: tests,
                value: value,
                errors: errors,
                endEarly: abortEarly,
                sort: this._sortErrors,
                path: opts.path
            }, callback);
        });
    }
    clone(spec) {
        const next = super.clone(spec);
        next.fields = $1746eadb3fc51b1f$var$_extends({}, this.fields);
        next._nodes = this._nodes;
        next._excludedEdges = this._excludedEdges;
        next._sortErrors = this._sortErrors;
        return next;
    }
    concat(schema) {
        let next = super.concat(schema);
        let nextFields = next.fields;
        for (let [field, schemaOrRef] of Object.entries(this.fields)){
            const target = nextFields[field];
            if (target === undefined) nextFields[field] = schemaOrRef;
            else if (target instanceof (0, $8Cojz.default) && schemaOrRef instanceof (0, $8Cojz.default)) nextFields[field] = schemaOrRef.concat(target);
        }
        return next.withMutation(()=>next.shape(nextFields, this._excludedEdges));
    }
    getDefaultFromShape() {
        let dft = {};
        this._nodes.forEach((key)=>{
            const field = this.fields[key];
            dft[key] = "default" in field ? field.getDefault() : undefined;
        });
        return dft;
    }
    _getDefault() {
        if ("default" in this.spec) return super._getDefault();
         // if there is no default set invent one
        if (!this._nodes.length) return undefined;
        return this.getDefaultFromShape();
    }
    shape(additions, excludes = []) {
        let next = this.clone();
        let fields = Object.assign(next.fields, additions);
        next.fields = fields;
        next._sortErrors = (0, $5sWN4.default)(Object.keys(fields));
        if (excludes.length) {
            // this is a convenience for when users only supply a single pair
            if (!Array.isArray(excludes[0])) excludes = [
                excludes
            ];
            next._excludedEdges = [
                ...next._excludedEdges,
                ...excludes
            ];
        }
        next._nodes = (0, $dTw9i.default)(fields, next._excludedEdges);
        return next;
    }
    pick(keys) {
        const picked = {};
        for (const key of keys)if (this.fields[key]) picked[key] = this.fields[key];
        return this.clone().withMutation((next)=>{
            next.fields = {};
            return next.shape(picked);
        });
    }
    omit(keys) {
        const next = this.clone();
        const fields = next.fields;
        next.fields = {};
        for (const key of keys)delete fields[key];
        return next.withMutation(()=>next.shape(fields));
    }
    from(from, to, alias) {
        let fromGetter = (0, $7Spqi.getter)(from, true);
        return this.transform((obj)=>{
            if (obj == null) return obj;
            let newObj = obj;
            if ((0, (/*@__PURE__*/$parcel$interopDefault($2xkoI)))(obj, from)) {
                newObj = $1746eadb3fc51b1f$var$_extends({}, obj);
                if (!alias) delete newObj[from];
                newObj[to] = fromGetter(obj);
            }
            return newObj;
        });
    }
    noUnknown(noAllow = true, message = (0, $dZq6i.object).noUnknown) {
        if (typeof noAllow === "string") {
            message = noAllow;
            noAllow = true;
        }
        let next = this.test({
            name: "noUnknown",
            exclusive: true,
            message: message,
            test (value) {
                if (value == null) return true;
                const unknownKeys = $1746eadb3fc51b1f$var$unknown(this.schema, value);
                return !noAllow || unknownKeys.length === 0 || this.createError({
                    params: {
                        unknown: unknownKeys.join(", ")
                    }
                });
            }
        });
        next.spec.noUnknown = noAllow;
        return next;
    }
    unknown(allow = true, message = (0, $dZq6i.object).noUnknown) {
        return this.noUnknown(!allow, message);
    }
    transformKeys(fn) {
        return this.transform((obj)=>obj && (0, (/*@__PURE__*/$parcel$interopDefault($4wCub)))(obj, (_, key)=>fn(key)));
    }
    camelCase() {
        return this.transformKeys((0, (/*@__PURE__*/$parcel$interopDefault($2NzVt))));
    }
    snakeCase() {
        return this.transformKeys((0, (/*@__PURE__*/$parcel$interopDefault($k8qkR))));
    }
    constantCase() {
        return this.transformKeys((key)=>(0, (/*@__PURE__*/$parcel$interopDefault($k8qkR)))(key).toUpperCase());
    }
    describe() {
        let base = super.describe();
        base.fields = (0, (/*@__PURE__*/$parcel$interopDefault($cvX5D)))(this.fields, (value)=>value.describe());
        return base;
    }
}
function $1746eadb3fc51b1f$export$185802fd694ee1f5(spec) {
    return new $1746eadb3fc51b1f$export$2e2bcd8739ae039(spec);
}
$1746eadb3fc51b1f$export$185802fd694ee1f5.prototype = $1746eadb3fc51b1f$export$2e2bcd8739ae039.prototype;

});
parcelRegister("k8qkR", function(module, exports) {

var $2e5Q4 = parcelRequire("2e5Q4");
/**
 * Converts `string` to
 * [snake case](https://en.wikipedia.org/wiki/Snake_case).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the snake cased string.
 * @example
 *
 * _.snakeCase('Foo Bar');
 * // => 'foo_bar'
 *
 * _.snakeCase('fooBar');
 * // => 'foo_bar'
 *
 * _.snakeCase('--FOO-BAR--');
 * // => 'foo_bar'
 */ var $ea88fbafa02950be$var$snakeCase = $2e5Q4(function(result, word, index) {
    return result + (index ? "_" : "") + word.toLowerCase();
});
module.exports = $ea88fbafa02950be$var$snakeCase;

});
parcelRegister("2e5Q4", function(module, exports) {

var $1U98m = parcelRequire("1U98m");

var $i1C3O = parcelRequire("i1C3O");

var $TWhTa = parcelRequire("TWhTa");
/** Used to compose unicode capture groups. */ var $19f16b0accf78713$var$rsApos = "['\u2019]";
/** Used to match apostrophes. */ var $19f16b0accf78713$var$reApos = RegExp($19f16b0accf78713$var$rsApos, "g");
/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */ function $19f16b0accf78713$var$createCompounder(callback) {
    return function(string) {
        return $1U98m($TWhTa($i1C3O(string).replace($19f16b0accf78713$var$reApos, "")), callback, "");
    };
}
module.exports = $19f16b0accf78713$var$createCompounder;

});
parcelRegister("1U98m", function(module, exports) {
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */ function $16321b35ee1bf4f8$var$arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1, length = array == null ? 0 : array.length;
    if (initAccum && length) accumulator = array[++index];
    while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
    return accumulator;
}
module.exports = $16321b35ee1bf4f8$var$arrayReduce;

});

parcelRegister("i1C3O", function(module, exports) {

var $8e60B = parcelRequire("8e60B");

var $kxrBi = parcelRequire("kxrBi");
/** Used to match Latin Unicode letters (excluding mathematical operators). */ var $d1f5d7ffb319126c$var$reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
/** Used to compose unicode character classes. */ var $d1f5d7ffb319126c$var$rsComboMarksRange = "\\u0300-\\u036f", $d1f5d7ffb319126c$var$reComboHalfMarksRange = "\\ufe20-\\ufe2f", $d1f5d7ffb319126c$var$rsComboSymbolsRange = "\\u20d0-\\u20ff", $d1f5d7ffb319126c$var$rsComboRange = $d1f5d7ffb319126c$var$rsComboMarksRange + $d1f5d7ffb319126c$var$reComboHalfMarksRange + $d1f5d7ffb319126c$var$rsComboSymbolsRange;
/** Used to compose unicode capture groups. */ var $d1f5d7ffb319126c$var$rsCombo = "[" + $d1f5d7ffb319126c$var$rsComboRange + "]";
/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */ var $d1f5d7ffb319126c$var$reComboMark = RegExp($d1f5d7ffb319126c$var$rsCombo, "g");
/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */ function $d1f5d7ffb319126c$var$deburr(string) {
    string = $kxrBi(string);
    return string && string.replace($d1f5d7ffb319126c$var$reLatin, $8e60B).replace($d1f5d7ffb319126c$var$reComboMark, "");
}
module.exports = $d1f5d7ffb319126c$var$deburr;

});
parcelRegister("8e60B", function(module, exports) {

var $jyJs0 = parcelRequire("jyJs0");
/** Used to map Latin Unicode letters to basic Latin letters. */ var $5fd44abafd282542$var$deburredLetters = {
    // Latin-1 Supplement block.
    "\xc0": "A",
    "\xc1": "A",
    "\xc2": "A",
    "\xc3": "A",
    "\xc4": "A",
    "\xc5": "A",
    "\xe0": "a",
    "\xe1": "a",
    "\xe2": "a",
    "\xe3": "a",
    "\xe4": "a",
    "\xe5": "a",
    "\xc7": "C",
    "\xe7": "c",
    "\xd0": "D",
    "\xf0": "d",
    "\xc8": "E",
    "\xc9": "E",
    "\xca": "E",
    "\xcb": "E",
    "\xe8": "e",
    "\xe9": "e",
    "\xea": "e",
    "\xeb": "e",
    "\xcc": "I",
    "\xcd": "I",
    "\xce": "I",
    "\xcf": "I",
    "\xec": "i",
    "\xed": "i",
    "\xee": "i",
    "\xef": "i",
    "\xd1": "N",
    "\xf1": "n",
    "\xd2": "O",
    "\xd3": "O",
    "\xd4": "O",
    "\xd5": "O",
    "\xd6": "O",
    "\xd8": "O",
    "\xf2": "o",
    "\xf3": "o",
    "\xf4": "o",
    "\xf5": "o",
    "\xf6": "o",
    "\xf8": "o",
    "\xd9": "U",
    "\xda": "U",
    "\xdb": "U",
    "\xdc": "U",
    "\xf9": "u",
    "\xfa": "u",
    "\xfb": "u",
    "\xfc": "u",
    "\xdd": "Y",
    "\xfd": "y",
    "\xff": "y",
    "\xc6": "Ae",
    "\xe6": "ae",
    "\xde": "Th",
    "\xfe": "th",
    "\xdf": "ss",
    // Latin Extended-A block.
    "\u0100": "A",
    "\u0102": "A",
    "\u0104": "A",
    "\u0101": "a",
    "\u0103": "a",
    "\u0105": "a",
    "\u0106": "C",
    "\u0108": "C",
    "\u010A": "C",
    "\u010C": "C",
    "\u0107": "c",
    "\u0109": "c",
    "\u010B": "c",
    "\u010D": "c",
    "\u010E": "D",
    "\u0110": "D",
    "\u010F": "d",
    "\u0111": "d",
    "\u0112": "E",
    "\u0114": "E",
    "\u0116": "E",
    "\u0118": "E",
    "\u011A": "E",
    "\u0113": "e",
    "\u0115": "e",
    "\u0117": "e",
    "\u0119": "e",
    "\u011B": "e",
    "\u011C": "G",
    "\u011E": "G",
    "\u0120": "G",
    "\u0122": "G",
    "\u011D": "g",
    "\u011F": "g",
    "\u0121": "g",
    "\u0123": "g",
    "\u0124": "H",
    "\u0126": "H",
    "\u0125": "h",
    "\u0127": "h",
    "\u0128": "I",
    "\u012A": "I",
    "\u012C": "I",
    "\u012E": "I",
    "\u0130": "I",
    "\u0129": "i",
    "\u012B": "i",
    "\u012D": "i",
    "\u012F": "i",
    "\u0131": "i",
    "\u0134": "J",
    "\u0135": "j",
    "\u0136": "K",
    "\u0137": "k",
    "\u0138": "k",
    "\u0139": "L",
    "\u013B": "L",
    "\u013D": "L",
    "\u013F": "L",
    "\u0141": "L",
    "\u013A": "l",
    "\u013C": "l",
    "\u013E": "l",
    "\u0140": "l",
    "\u0142": "l",
    "\u0143": "N",
    "\u0145": "N",
    "\u0147": "N",
    "\u014A": "N",
    "\u0144": "n",
    "\u0146": "n",
    "\u0148": "n",
    "\u014B": "n",
    "\u014C": "O",
    "\u014E": "O",
    "\u0150": "O",
    "\u014D": "o",
    "\u014F": "o",
    "\u0151": "o",
    "\u0154": "R",
    "\u0156": "R",
    "\u0158": "R",
    "\u0155": "r",
    "\u0157": "r",
    "\u0159": "r",
    "\u015A": "S",
    "\u015C": "S",
    "\u015E": "S",
    "\u0160": "S",
    "\u015B": "s",
    "\u015D": "s",
    "\u015F": "s",
    "\u0161": "s",
    "\u0162": "T",
    "\u0164": "T",
    "\u0166": "T",
    "\u0163": "t",
    "\u0165": "t",
    "\u0167": "t",
    "\u0168": "U",
    "\u016A": "U",
    "\u016C": "U",
    "\u016E": "U",
    "\u0170": "U",
    "\u0172": "U",
    "\u0169": "u",
    "\u016B": "u",
    "\u016D": "u",
    "\u016F": "u",
    "\u0171": "u",
    "\u0173": "u",
    "\u0174": "W",
    "\u0175": "w",
    "\u0176": "Y",
    "\u0177": "y",
    "\u0178": "Y",
    "\u0179": "Z",
    "\u017B": "Z",
    "\u017D": "Z",
    "\u017A": "z",
    "\u017C": "z",
    "\u017E": "z",
    "\u0132": "IJ",
    "\u0133": "ij",
    "\u0152": "Oe",
    "\u0153": "oe",
    "\u0149": "'n",
    "\u017F": "s"
};
/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */ var $5fd44abafd282542$var$deburrLetter = $jyJs0($5fd44abafd282542$var$deburredLetters);
module.exports = $5fd44abafd282542$var$deburrLetter;

});
parcelRegister("jyJs0", function(module, exports) {
/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */ function $e3d472d8f5718783$var$basePropertyOf(object) {
    return function(key) {
        return object == null ? undefined : object[key];
    };
}
module.exports = $e3d472d8f5718783$var$basePropertyOf;

});



parcelRegister("TWhTa", function(module, exports) {

var $emt7R = parcelRequire("emt7R");

var $7tMkE = parcelRequire("7tMkE");

var $kxrBi = parcelRequire("kxrBi");

var $85NOU = parcelRequire("85NOU");
/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */ function $0a8259dbbb1c9b3e$var$words(string, pattern, guard) {
    string = $kxrBi(string);
    pattern = guard ? undefined : pattern;
    if (pattern === undefined) return $7tMkE(string) ? $85NOU(string) : $emt7R(string);
    return string.match(pattern) || [];
}
module.exports = $0a8259dbbb1c9b3e$var$words;

});
parcelRegister("emt7R", function(module, exports) {
/** Used to match words composed of alphanumeric characters. */ var $a749b6899623b9b3$var$reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $a749b6899623b9b3$var$asciiWords(string) {
    return string.match($a749b6899623b9b3$var$reAsciiWord) || [];
}
module.exports = $a749b6899623b9b3$var$asciiWords;

});

parcelRegister("7tMkE", function(module, exports) {
/** Used to detect strings that need a more robust regexp to match words. */ var $5720bb904e6f127f$var$reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */ function $5720bb904e6f127f$var$hasUnicodeWord(string) {
    return $5720bb904e6f127f$var$reHasUnicodeWord.test(string);
}
module.exports = $5720bb904e6f127f$var$hasUnicodeWord;

});

parcelRegister("85NOU", function(module, exports) {
/** Used to compose unicode character classes. */ var $5e456f9e90fbbeae$var$rsAstralRange = "\ud800-\udfff", $5e456f9e90fbbeae$var$rsComboMarksRange = "\\u0300-\\u036f", $5e456f9e90fbbeae$var$reComboHalfMarksRange = "\\ufe20-\\ufe2f", $5e456f9e90fbbeae$var$rsComboSymbolsRange = "\\u20d0-\\u20ff", $5e456f9e90fbbeae$var$rsComboRange = $5e456f9e90fbbeae$var$rsComboMarksRange + $5e456f9e90fbbeae$var$reComboHalfMarksRange + $5e456f9e90fbbeae$var$rsComboSymbolsRange, $5e456f9e90fbbeae$var$rsDingbatRange = "\\u2700-\\u27bf", $5e456f9e90fbbeae$var$rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", $5e456f9e90fbbeae$var$rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", $5e456f9e90fbbeae$var$rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", $5e456f9e90fbbeae$var$rsPunctuationRange = "\\u2000-\\u206f", $5e456f9e90fbbeae$var$rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", $5e456f9e90fbbeae$var$rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", $5e456f9e90fbbeae$var$rsVarRange = "\\ufe0e\\ufe0f", $5e456f9e90fbbeae$var$rsBreakRange = $5e456f9e90fbbeae$var$rsMathOpRange + $5e456f9e90fbbeae$var$rsNonCharRange + $5e456f9e90fbbeae$var$rsPunctuationRange + $5e456f9e90fbbeae$var$rsSpaceRange;
/** Used to compose unicode capture groups. */ var $5e456f9e90fbbeae$var$rsApos = "['\u2019]", $5e456f9e90fbbeae$var$rsBreak = "[" + $5e456f9e90fbbeae$var$rsBreakRange + "]", $5e456f9e90fbbeae$var$rsCombo = "[" + $5e456f9e90fbbeae$var$rsComboRange + "]", $5e456f9e90fbbeae$var$rsDigits = "\\d+", $5e456f9e90fbbeae$var$rsDingbat = "[" + $5e456f9e90fbbeae$var$rsDingbatRange + "]", $5e456f9e90fbbeae$var$rsLower = "[" + $5e456f9e90fbbeae$var$rsLowerRange + "]", $5e456f9e90fbbeae$var$rsMisc = "[^" + $5e456f9e90fbbeae$var$rsAstralRange + $5e456f9e90fbbeae$var$rsBreakRange + $5e456f9e90fbbeae$var$rsDigits + $5e456f9e90fbbeae$var$rsDingbatRange + $5e456f9e90fbbeae$var$rsLowerRange + $5e456f9e90fbbeae$var$rsUpperRange + "]", $5e456f9e90fbbeae$var$rsFitz = "\ud83c[\udffb-\udfff]", $5e456f9e90fbbeae$var$rsModifier = "(?:" + $5e456f9e90fbbeae$var$rsCombo + "|" + $5e456f9e90fbbeae$var$rsFitz + ")", $5e456f9e90fbbeae$var$rsNonAstral = "[^" + $5e456f9e90fbbeae$var$rsAstralRange + "]", $5e456f9e90fbbeae$var$rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", $5e456f9e90fbbeae$var$rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", $5e456f9e90fbbeae$var$rsUpper = "[" + $5e456f9e90fbbeae$var$rsUpperRange + "]", $5e456f9e90fbbeae$var$rsZWJ = "\\u200d";
/** Used to compose unicode regexes. */ var $5e456f9e90fbbeae$var$rsMiscLower = "(?:" + $5e456f9e90fbbeae$var$rsLower + "|" + $5e456f9e90fbbeae$var$rsMisc + ")", $5e456f9e90fbbeae$var$rsMiscUpper = "(?:" + $5e456f9e90fbbeae$var$rsUpper + "|" + $5e456f9e90fbbeae$var$rsMisc + ")", $5e456f9e90fbbeae$var$rsOptContrLower = "(?:" + $5e456f9e90fbbeae$var$rsApos + "(?:d|ll|m|re|s|t|ve))?", $5e456f9e90fbbeae$var$rsOptContrUpper = "(?:" + $5e456f9e90fbbeae$var$rsApos + "(?:D|LL|M|RE|S|T|VE))?", $5e456f9e90fbbeae$var$reOptMod = $5e456f9e90fbbeae$var$rsModifier + "?", $5e456f9e90fbbeae$var$rsOptVar = "[" + $5e456f9e90fbbeae$var$rsVarRange + "]?", $5e456f9e90fbbeae$var$rsOptJoin = "(?:" + $5e456f9e90fbbeae$var$rsZWJ + "(?:" + [
    $5e456f9e90fbbeae$var$rsNonAstral,
    $5e456f9e90fbbeae$var$rsRegional,
    $5e456f9e90fbbeae$var$rsSurrPair
].join("|") + ")" + $5e456f9e90fbbeae$var$rsOptVar + $5e456f9e90fbbeae$var$reOptMod + ")*", $5e456f9e90fbbeae$var$rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", $5e456f9e90fbbeae$var$rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", $5e456f9e90fbbeae$var$rsSeq = $5e456f9e90fbbeae$var$rsOptVar + $5e456f9e90fbbeae$var$reOptMod + $5e456f9e90fbbeae$var$rsOptJoin, $5e456f9e90fbbeae$var$rsEmoji = "(?:" + [
    $5e456f9e90fbbeae$var$rsDingbat,
    $5e456f9e90fbbeae$var$rsRegional,
    $5e456f9e90fbbeae$var$rsSurrPair
].join("|") + ")" + $5e456f9e90fbbeae$var$rsSeq;
/** Used to match complex or compound words. */ var $5e456f9e90fbbeae$var$reUnicodeWord = RegExp([
    $5e456f9e90fbbeae$var$rsUpper + "?" + $5e456f9e90fbbeae$var$rsLower + "+" + $5e456f9e90fbbeae$var$rsOptContrLower + "(?=" + [
        $5e456f9e90fbbeae$var$rsBreak,
        $5e456f9e90fbbeae$var$rsUpper,
        "$"
    ].join("|") + ")",
    $5e456f9e90fbbeae$var$rsMiscUpper + "+" + $5e456f9e90fbbeae$var$rsOptContrUpper + "(?=" + [
        $5e456f9e90fbbeae$var$rsBreak,
        $5e456f9e90fbbeae$var$rsUpper + $5e456f9e90fbbeae$var$rsMiscLower,
        "$"
    ].join("|") + ")",
    $5e456f9e90fbbeae$var$rsUpper + "?" + $5e456f9e90fbbeae$var$rsMiscLower + "+" + $5e456f9e90fbbeae$var$rsOptContrLower,
    $5e456f9e90fbbeae$var$rsUpper + "+" + $5e456f9e90fbbeae$var$rsOptContrUpper,
    $5e456f9e90fbbeae$var$rsOrdUpper,
    $5e456f9e90fbbeae$var$rsOrdLower,
    $5e456f9e90fbbeae$var$rsDigits,
    $5e456f9e90fbbeae$var$rsEmoji
].join("|"), "g");
/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $5e456f9e90fbbeae$var$unicodeWords(string) {
    return string.match($5e456f9e90fbbeae$var$reUnicodeWord) || [];
}
module.exports = $5e456f9e90fbbeae$var$unicodeWords;

});




parcelRegister("2NzVt", function(module, exports) {

var $kvxyR = parcelRequire("kvxyR");

var $2e5Q4 = parcelRequire("2e5Q4");
/**
 * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the camel cased string.
 * @example
 *
 * _.camelCase('Foo Bar');
 * // => 'fooBar'
 *
 * _.camelCase('--foo-bar--');
 * // => 'fooBar'
 *
 * _.camelCase('__FOO_BAR__');
 * // => 'fooBar'
 */ var $209c068481afe985$var$camelCase = $2e5Q4(function(result, word, index) {
    word = word.toLowerCase();
    return result + (index ? $kvxyR(word) : word);
});
module.exports = $209c068481afe985$var$camelCase;

});
parcelRegister("kvxyR", function(module, exports) {

var $kxrBi = parcelRequire("kxrBi");

var $6EpHH = parcelRequire("6EpHH");
/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */ function $eee0bc764d83bf07$var$capitalize(string) {
    return $6EpHH($kxrBi(string).toLowerCase());
}
module.exports = $eee0bc764d83bf07$var$capitalize;

});
parcelRegister("6EpHH", function(module, exports) {

var $82Es0 = parcelRequire("82Es0");
/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */ var $4d7a6abf5367db43$var$upperFirst = $82Es0("toUpperCase");
module.exports = $4d7a6abf5367db43$var$upperFirst;

});
parcelRegister("82Es0", function(module, exports) {

var $9RXcR = parcelRequire("9RXcR");

var $8OIxj = parcelRequire("8OIxj");

var $k9G2Q = parcelRequire("k9G2Q");

var $kxrBi = parcelRequire("kxrBi");
/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */ function $5dade347371df575$var$createCaseFirst(methodName) {
    return function(string) {
        string = $kxrBi(string);
        var strSymbols = $8OIxj(string) ? $k9G2Q(string) : undefined;
        var chr = strSymbols ? strSymbols[0] : string.charAt(0);
        var trailing = strSymbols ? $9RXcR(strSymbols, 1).join("") : string.slice(1);
        return chr[methodName]() + trailing;
    };
}
module.exports = $5dade347371df575$var$createCaseFirst;

});
parcelRegister("9RXcR", function(module, exports) {

var $6nyrM = parcelRequire("6nyrM");
/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */ function $72f6fd759786f5ce$var$castSlice(array, start, end) {
    var length = array.length;
    end = end === undefined ? length : end;
    return !start && end >= length ? array : $6nyrM(array, start, end);
}
module.exports = $72f6fd759786f5ce$var$castSlice;

});
parcelRegister("6nyrM", function(module, exports) {
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function $4a4f9c836cb000a1$var$baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
module.exports = $4a4f9c836cb000a1$var$baseSlice;

});


parcelRegister("8OIxj", function(module, exports) {
/** Used to compose unicode character classes. */ var $66b58a36bd1c707b$var$rsAstralRange = "\ud800-\udfff", $66b58a36bd1c707b$var$rsComboMarksRange = "\\u0300-\\u036f", $66b58a36bd1c707b$var$reComboHalfMarksRange = "\\ufe20-\\ufe2f", $66b58a36bd1c707b$var$rsComboSymbolsRange = "\\u20d0-\\u20ff", $66b58a36bd1c707b$var$rsComboRange = $66b58a36bd1c707b$var$rsComboMarksRange + $66b58a36bd1c707b$var$reComboHalfMarksRange + $66b58a36bd1c707b$var$rsComboSymbolsRange, $66b58a36bd1c707b$var$rsVarRange = "\\ufe0e\\ufe0f";
/** Used to compose unicode capture groups. */ var $66b58a36bd1c707b$var$rsZWJ = "\\u200d";
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var $66b58a36bd1c707b$var$reHasUnicode = RegExp("[" + $66b58a36bd1c707b$var$rsZWJ + $66b58a36bd1c707b$var$rsAstralRange + $66b58a36bd1c707b$var$rsComboRange + $66b58a36bd1c707b$var$rsVarRange + "]");
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */ function $66b58a36bd1c707b$var$hasUnicode(string) {
    return $66b58a36bd1c707b$var$reHasUnicode.test(string);
}
module.exports = $66b58a36bd1c707b$var$hasUnicode;

});

parcelRegister("k9G2Q", function(module, exports) {

var $5pLth = parcelRequire("5pLth");

var $8OIxj = parcelRequire("8OIxj");

var $9uxQB = parcelRequire("9uxQB");
/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $eac543289eb3e7d5$var$stringToArray(string) {
    return $8OIxj(string) ? $9uxQB(string) : $5pLth(string);
}
module.exports = $eac543289eb3e7d5$var$stringToArray;

});
parcelRegister("5pLth", function(module, exports) {
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $3f141c57b0c3b24b$var$asciiToArray(string) {
    return string.split("");
}
module.exports = $3f141c57b0c3b24b$var$asciiToArray;

});

parcelRegister("9uxQB", function(module, exports) {
/** Used to compose unicode character classes. */ var $6e912bcd98f604c6$var$rsAstralRange = "\ud800-\udfff", $6e912bcd98f604c6$var$rsComboMarksRange = "\\u0300-\\u036f", $6e912bcd98f604c6$var$reComboHalfMarksRange = "\\ufe20-\\ufe2f", $6e912bcd98f604c6$var$rsComboSymbolsRange = "\\u20d0-\\u20ff", $6e912bcd98f604c6$var$rsComboRange = $6e912bcd98f604c6$var$rsComboMarksRange + $6e912bcd98f604c6$var$reComboHalfMarksRange + $6e912bcd98f604c6$var$rsComboSymbolsRange, $6e912bcd98f604c6$var$rsVarRange = "\\ufe0e\\ufe0f";
/** Used to compose unicode capture groups. */ var $6e912bcd98f604c6$var$rsAstral = "[" + $6e912bcd98f604c6$var$rsAstralRange + "]", $6e912bcd98f604c6$var$rsCombo = "[" + $6e912bcd98f604c6$var$rsComboRange + "]", $6e912bcd98f604c6$var$rsFitz = "\ud83c[\udffb-\udfff]", $6e912bcd98f604c6$var$rsModifier = "(?:" + $6e912bcd98f604c6$var$rsCombo + "|" + $6e912bcd98f604c6$var$rsFitz + ")", $6e912bcd98f604c6$var$rsNonAstral = "[^" + $6e912bcd98f604c6$var$rsAstralRange + "]", $6e912bcd98f604c6$var$rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", $6e912bcd98f604c6$var$rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", $6e912bcd98f604c6$var$rsZWJ = "\\u200d";
/** Used to compose unicode regexes. */ var $6e912bcd98f604c6$var$reOptMod = $6e912bcd98f604c6$var$rsModifier + "?", $6e912bcd98f604c6$var$rsOptVar = "[" + $6e912bcd98f604c6$var$rsVarRange + "]?", $6e912bcd98f604c6$var$rsOptJoin = "(?:" + $6e912bcd98f604c6$var$rsZWJ + "(?:" + [
    $6e912bcd98f604c6$var$rsNonAstral,
    $6e912bcd98f604c6$var$rsRegional,
    $6e912bcd98f604c6$var$rsSurrPair
].join("|") + ")" + $6e912bcd98f604c6$var$rsOptVar + $6e912bcd98f604c6$var$reOptMod + ")*", $6e912bcd98f604c6$var$rsSeq = $6e912bcd98f604c6$var$rsOptVar + $6e912bcd98f604c6$var$reOptMod + $6e912bcd98f604c6$var$rsOptJoin, $6e912bcd98f604c6$var$rsSymbol = "(?:" + [
    $6e912bcd98f604c6$var$rsNonAstral + $6e912bcd98f604c6$var$rsCombo + "?",
    $6e912bcd98f604c6$var$rsCombo,
    $6e912bcd98f604c6$var$rsRegional,
    $6e912bcd98f604c6$var$rsSurrPair,
    $6e912bcd98f604c6$var$rsAstral
].join("|") + ")";
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $6e912bcd98f604c6$var$reUnicode = RegExp($6e912bcd98f604c6$var$rsFitz + "(?=" + $6e912bcd98f604c6$var$rsFitz + ")|" + $6e912bcd98f604c6$var$rsSymbol + $6e912bcd98f604c6$var$rsSeq, "g");
/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $6e912bcd98f604c6$var$unicodeToArray(string) {
    return string.match($6e912bcd98f604c6$var$reUnicode) || [];
}
module.exports = $6e912bcd98f604c6$var$unicodeToArray;

});






parcelRegister("4wCub", function(module, exports) {

var $4zie7 = parcelRequire("4zie7");

var $cFuT8 = parcelRequire("cFuT8");

var $6QQby = parcelRequire("6QQby");
/**
 * The opposite of `_.mapValues`; this method creates an object with the
 * same values as `object` and keys generated by running each own enumerable
 * string keyed property of `object` thru `iteratee`. The iteratee is invoked
 * with three arguments: (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 3.8.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapValues
 * @example
 *
 * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
 *   return key + value;
 * });
 * // => { 'a1': 1, 'b2': 2 }
 */ function $34b8010f96e0a0bf$var$mapKeys(object, iteratee) {
    var result = {};
    iteratee = $6QQby(iteratee, 3);
    $cFuT8(object, function(value, key, object) {
        $4zie7(result, iteratee(value, key, object), value);
    });
    return result;
}
module.exports = $34b8010f96e0a0bf$var$mapKeys;

});

parcelRegister("dTw9i", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1d9598194ffd0f1$export$2e2bcd8739ae039);

var $2xkoI = parcelRequire("2xkoI");

var $joRcI = parcelRequire("joRcI");

var $7Spqi = parcelRequire("7Spqi");

var $fGxXP = parcelRequire("fGxXP");

var $93uAf = parcelRequire("93uAf");
function $a1d9598194ffd0f1$export$2e2bcd8739ae039(fields, excludedEdges = []) {
    let edges = [];
    let nodes = new Set();
    let excludes = new Set(excludedEdges.map(([a, b])=>`${a}-${b}`));
    function addNode(depPath, key) {
        let node = (0, $7Spqi.split)(depPath)[0];
        nodes.add(node);
        if (!excludes.has(`${key}-${node}`)) edges.push([
            key,
            node
        ]);
    }
    for(const key in fields)if ((0, (/*@__PURE__*/$parcel$interopDefault($2xkoI)))(fields, key)) {
        let value = fields[key];
        nodes.add(key);
        if ((0, $fGxXP.default).isRef(value) && value.isSibling) addNode(value.path, key);
        else if ((0, $93uAf.default)(value) && "deps" in value) value.deps.forEach((path)=>addNode(path, key));
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($joRcI))).array(Array.from(nodes), edges).reverse();
}

});
parcelRegister("joRcI", function(module, exports) {
/**
 * Topological sorting function
 *
 * @param {Array} edges
 * @returns {Array}
 */ module.exports = function(edges) {
    return $e1f9876d5f29f67a$var$toposort($e1f9876d5f29f67a$var$uniqueNodes(edges), edges);
};
module.exports.array = $e1f9876d5f29f67a$var$toposort;
function $e1f9876d5f29f67a$var$toposort(nodes, edges) {
    var cursor = nodes.length, sorted = new Array(cursor), visited = {}, i = cursor, outgoingEdges = $e1f9876d5f29f67a$var$makeOutgoingEdges(edges), nodesHash = $e1f9876d5f29f67a$var$makeNodesHash(nodes);
    // check for unknown nodes
    edges.forEach(function(edge) {
        if (!nodesHash.has(edge[0]) || !nodesHash.has(edge[1])) throw new Error("Unknown node. There is an unknown node in the supplied edges.");
    });
    while(i--)if (!visited[i]) visit(nodes[i], i, new Set());
    return sorted;
    function visit(node, i, predecessors) {
        if (predecessors.has(node)) {
            var nodeRep;
            try {
                nodeRep = ", node was:" + JSON.stringify(node);
            } catch (e) {
                nodeRep = "";
            }
            throw new Error("Cyclic dependency" + nodeRep);
        }
        if (!nodesHash.has(node)) throw new Error("Found unknown node. Make sure to provided all involved nodes. Unknown node: " + JSON.stringify(node));
        if (visited[i]) return;
        visited[i] = true;
        var outgoing = outgoingEdges.get(node) || new Set();
        outgoing = Array.from(outgoing);
        if (i = outgoing.length) {
            predecessors.add(node);
            do {
                var child = outgoing[--i];
                visit(child, nodesHash.get(child), predecessors);
            }while (i);
            predecessors.delete(node);
        }
        sorted[--cursor] = node;
    }
}
function $e1f9876d5f29f67a$var$uniqueNodes(arr) {
    var res = new Set();
    for(var i = 0, len = arr.length; i < len; i++){
        var edge = arr[i];
        res.add(edge[0]);
        res.add(edge[1]);
    }
    return Array.from(res);
}
function $e1f9876d5f29f67a$var$makeOutgoingEdges(arr) {
    var edges = new Map();
    for(var i = 0, len = arr.length; i < len; i++){
        var edge = arr[i];
        if (!edges.has(edge[0])) edges.set(edge[0], new Set());
        if (!edges.has(edge[1])) edges.set(edge[1], new Set());
        edges.get(edge[0]).add(edge[1]);
    }
    return edges;
}
function $e1f9876d5f29f67a$var$makeNodesHash(arr) {
    var res = new Map();
    for(var i = 0, len = arr.length; i < len; i++)res.set(arr[i], i);
    return res;
}

});


parcelRegister("5sWN4", function(module, exports) {

$parcel$export(module.exports, "default", () => $3fad2bd6193dea7a$export$2e2bcd8739ae039);
function $3fad2bd6193dea7a$var$findIndex(arr, err) {
    let idx = Infinity;
    arr.some((key, ii)=>{
        var _err$path;
        if (((_err$path = err.path) == null ? void 0 : _err$path.indexOf(key)) !== -1) {
            idx = ii;
            return true;
        }
    });
    return idx;
}
function $3fad2bd6193dea7a$export$2e2bcd8739ae039(keys) {
    return (a, b)=>{
        return $3fad2bd6193dea7a$var$findIndex(keys, a) - $3fad2bd6193dea7a$var$findIndex(keys, b);
    };
}

});


parcelRegister("9686H", function(module, exports) {

$parcel$export(module.exports, "create", () => $69faf682c7c05d9d$export$185802fd694ee1f5);

var $etiuQ = parcelRequire("etiuQ");

var $93uAf = parcelRequire("93uAf");

var $6J2zD = parcelRequire("6J2zD");

var $dZq6i = parcelRequire("dZq6i");

var $epCOP = parcelRequire("epCOP");

var $41aWH = parcelRequire("41aWH");

var $8Cojz = parcelRequire("8Cojz");
function $69faf682c7c05d9d$var$_extends() {
    $69faf682c7c05d9d$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $69faf682c7c05d9d$var$_extends.apply(this, arguments);
}
function $69faf682c7c05d9d$export$185802fd694ee1f5(type) {
    return new $69faf682c7c05d9d$export$2e2bcd8739ae039(type);
}
class $69faf682c7c05d9d$export$2e2bcd8739ae039 extends (0, $8Cojz.default) {
    constructor(type){
        super({
            type: "array"
        }); // `undefined` specifically means uninitialized, as opposed to
        // "no subtype"
        this.innerType = void 0;
        this.innerType = type;
        this.withMutation(()=>{
            this.transform(function(values) {
                if (typeof values === "string") try {
                    values = JSON.parse(values);
                } catch (err) {
                    values = null;
                }
                return this.isType(values) ? values : null;
            });
        });
    }
    _typeCheck(v) {
        return Array.isArray(v);
    }
    get _subType() {
        return this.innerType;
    }
    _cast(_value, _opts) {
        const value = super._cast(_value, _opts); //should ignore nulls here
        if (!this._typeCheck(value) || !this.innerType) return value;
        let isChanged = false;
        const castArray = value.map((v, idx)=>{
            const castElement = this.innerType.cast(v, $69faf682c7c05d9d$var$_extends({}, _opts, {
                path: `${_opts.path || ""}[${idx}]`
            }));
            if (castElement !== v) isChanged = true;
            return castElement;
        });
        return isChanged ? castArray : value;
    }
    _validate(_value, options = {}, callback) {
        var _options$abortEarly, _options$recursive;
        let errors = [];
        let sync = options.sync;
        let path = options.path;
        let innerType = this.innerType;
        let endEarly = (_options$abortEarly = options.abortEarly) != null ? _options$abortEarly : this.spec.abortEarly;
        let recursive = (_options$recursive = options.recursive) != null ? _options$recursive : this.spec.recursive;
        let originalValue = options.originalValue != null ? options.originalValue : _value;
        super._validate(_value, options, (err, value)=>{
            if (err) {
                if (!(0, $41aWH.default).isError(err) || endEarly) return void callback(err, value);
                errors.push(err);
            }
            if (!recursive || !innerType || !this._typeCheck(value)) {
                callback(errors[0] || null, value);
                return;
            }
            originalValue = originalValue || value; // #950 Ensure that sparse array empty slots are validated
            let tests = new Array(value.length);
            for(let idx = 0; idx < value.length; idx++){
                let item = value[idx];
                let path = `${options.path || ""}[${idx}]`; // object._validate note for isStrict explanation
                let innerOptions = $69faf682c7c05d9d$var$_extends({}, options, {
                    path: path,
                    strict: true,
                    parent: value,
                    index: idx,
                    originalValue: originalValue[idx]
                });
                tests[idx] = (_, cb)=>innerType.validate(item, innerOptions, cb);
            }
            (0, $epCOP.default)({
                sync: sync,
                path: path,
                value: value,
                errors: errors,
                endEarly: endEarly,
                tests: tests
            }, callback);
        });
    }
    clone(spec) {
        const next = super.clone(spec);
        next.innerType = this.innerType;
        return next;
    }
    concat(schema) {
        let next = super.concat(schema);
        next.innerType = this.innerType;
        if (schema.innerType) next.innerType = next.innerType ? next.innerType.concat(schema.innerType) : schema.innerType;
        return next;
    }
    of(schema) {
        // FIXME: this should return a new instance of array without the default to be
        let next = this.clone();
        if (!(0, $93uAf.default)(schema)) throw new TypeError("`array.of()` sub-schema must be a valid yup schema not: " + (0, $6J2zD.default)(schema)); // FIXME(ts):
        next.innerType = schema;
        return next;
    }
    length(length, message = (0, $dZq6i.array).length) {
        return this.test({
            message: message,
            name: "length",
            exclusive: true,
            params: {
                length: length
            },
            test (value) {
                return (0, $etiuQ.default)(value) || value.length === this.resolve(length);
            }
        });
    }
    min(min, message) {
        message = message || (0, $dZq6i.array).min;
        return this.test({
            message: message,
            name: "min",
            exclusive: true,
            params: {
                min: min
            },
            // FIXME(ts): Array<typeof T>
            test (value) {
                return (0, $etiuQ.default)(value) || value.length >= this.resolve(min);
            }
        });
    }
    max(max, message) {
        message = message || (0, $dZq6i.array).max;
        return this.test({
            message: message,
            name: "max",
            exclusive: true,
            params: {
                max: max
            },
            test (value) {
                return (0, $etiuQ.default)(value) || value.length <= this.resolve(max);
            }
        });
    }
    ensure() {
        return this.default(()=>[]).transform((val, original)=>{
            // We don't want to return `null` for nullable schema
            if (this._typeCheck(val)) return val;
            return original == null ? [] : [].concat(original);
        });
    }
    compact(rejector) {
        let reject = !rejector ? (v)=>!!v : (v, i, a)=>!rejector(v, i, a);
        return this.transform((values)=>values != null ? values.filter(reject) : values);
    }
    describe() {
        let base = super.describe();
        if (this.innerType) base.innerType = this.innerType.describe();
        return base;
    }
    nullable(isNullable = true) {
        return super.nullable(isNullable);
    }
    defined() {
        return super.defined();
    }
    required(msg) {
        return super.required(msg);
    }
}
$69faf682c7c05d9d$export$185802fd694ee1f5.prototype = $69faf682c7c05d9d$export$2e2bcd8739ae039.prototype; //
 // Interfaces
 //

});

parcelRegister("9HeTq", function(module, exports) {

var $93uAf = parcelRequire("93uAf");
function $70f3aea40eb7a776$export$185802fd694ee1f5(builder) {
    return new $70f3aea40eb7a776$var$Lazy(builder);
}
class $70f3aea40eb7a776$var$Lazy {
    constructor(builder){
        this.type = "lazy";
        this.__isYupSchema__ = true;
        this.__inputType = void 0;
        this.__outputType = void 0;
        this._resolve = (value, options = {})=>{
            let schema = this.builder(value, options);
            if (!(0, $93uAf.default)(schema)) throw new TypeError("lazy() functions must return a valid schema");
            return schema.resolve(options);
        };
        this.builder = builder;
    }
    resolve(options) {
        return this._resolve(options.value, options);
    }
    cast(value, options) {
        return this._resolve(value, options).cast(value, options);
    }
    validate(value, options, maybeCb) {
        // @ts-expect-error missing public callback on type
        return this._resolve(value, options).validate(value, options, maybeCb);
    }
    validateSync(value, options) {
        return this._resolve(value, options).validateSync(value, options);
    }
    validateAt(path, value, options) {
        return this._resolve(value, options).validateAt(path, value, options);
    }
    validateSyncAt(path, value, options) {
        return this._resolve(value, options).validateSyncAt(path, value, options);
    }
    describe() {
        return null;
    }
    isValid(value, options) {
        return this._resolve(value, options).isValid(value, options);
    }
    isValidSync(value, options) {
        return this._resolve(value, options).isValidSync(value, options);
    }
}
var $70f3aea40eb7a776$export$2e2bcd8739ae039 = $70f3aea40eb7a776$var$Lazy;

});

parcelRegister("fgPD0", function(module, exports) {

var $dZq6i = parcelRequire("dZq6i");
function $b1e065ee38909183$export$2e2bcd8739ae039(custom) {
    Object.keys(custom).forEach((type)=>{
        // @ts-ignore
        Object.keys(custom[type]).forEach((method)=>{
            // @ts-ignore
            (0, $dZq6i.default)[type][method] = custom[type][method];
        });
    });
}

});


parcelRegister("khgMO", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec326a924dcbf351$export$2e2bcd8739ae039);

var $lgiU2 = parcelRequire("lgiU2");

var $kc00y = parcelRequire("kc00y");

var $hFscA = parcelRequire("hFscA");

var $9i3wr = parcelRequire("9i3wr");

var $cKvYK = parcelRequire("cKvYK");
"use client";
const $ec326a924dcbf351$var$Button = /*#__PURE__*/ $kc00y.forwardRef(({ as: as, bsPrefix: bsPrefix, variant: variant = "primary", size: size, active: active = false, disabled: disabled = false, className: className, ...props }, ref)=>{
    const prefix = (0, $9i3wr.useBootstrapPrefix)(bsPrefix, "btn");
    const [buttonProps, { tagName: tagName }] = (0, $hFscA.useButtonProps)({
        tagName: as,
        disabled: disabled,
        ...props
    });
    const Component = tagName;
    return /*#__PURE__*/ (0, $cKvYK.jsx)(Component, {
        ...buttonProps,
        ...props,
        ref: ref,
        disabled: disabled,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($lgiU2)))(className, prefix, active && "active", variant && `${prefix}-${variant}`, size && `${prefix}-${size}`, props.href && disabled && "disabled")
    });
});
$ec326a924dcbf351$var$Button.displayName = "Button";
var $ec326a924dcbf351$export$2e2bcd8739ae039 = $ec326a924dcbf351$var$Button;

});
parcelRegister("hFscA", function(module, exports) {

$parcel$export(module.exports, "useButtonProps", () => $cdcc2451955840fb$export$a0ee72f2c720a5c3);
$parcel$export(module.exports, "default", () => $cdcc2451955840fb$export$2e2bcd8739ae039);

var $kc00y = parcelRequire("kc00y");

var $cKvYK = parcelRequire("cKvYK");
const $cdcc2451955840fb$var$_excluded = [
    "as",
    "disabled"
];
function $cdcc2451955840fb$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $cdcc2451955840fb$export$72369ab2cc99204b(href) {
    return !href || href.trim() === "#";
}
function $cdcc2451955840fb$export$a0ee72f2c720a5c3({ tagName: tagName, disabled: disabled, href: href, target: target, rel: rel, role: role, onClick: onClick, tabIndex: tabIndex = 0, type: type }) {
    if (!tagName) {
        if (href != null || target != null || rel != null) tagName = "a";
        else tagName = "button";
    }
    const meta = {
        tagName: tagName
    };
    if (tagName === "button") return [
        {
            type: type || "button",
            disabled: disabled
        },
        meta
    ];
    const handleClick = (event)=>{
        if (disabled || tagName === "a" && $cdcc2451955840fb$export$72369ab2cc99204b(href)) event.preventDefault();
        if (disabled) {
            event.stopPropagation();
            return;
        }
        onClick == null || onClick(event);
    };
    const handleKeyDown = (event)=>{
        if (event.key === " ") {
            event.preventDefault();
            handleClick(event);
        }
    };
    if (tagName === "a") {
        // Ensure there's a href so Enter can trigger anchor button.
        href || (href = "#");
        if (disabled) href = undefined;
    }
    return [
        {
            role: role != null ? role : "button",
            // explicitly undefined so that it overrides the props disabled in a spread
            // e.g. <Tag {...props} {...hookProps} />
            disabled: undefined,
            tabIndex: disabled ? undefined : tabIndex,
            href: href,
            target: tagName === "a" ? target : undefined,
            "aria-disabled": !disabled ? undefined : disabled,
            rel: tagName === "a" ? rel : undefined,
            onClick: handleClick,
            onKeyDown: handleKeyDown
        },
        meta
    ];
}
const $cdcc2451955840fb$var$Button = /*#__PURE__*/ $kc00y.forwardRef((_ref, ref)=>{
    let { as: asProp, disabled: disabled } = _ref, props = $cdcc2451955840fb$var$_objectWithoutPropertiesLoose(_ref, $cdcc2451955840fb$var$_excluded);
    const [buttonProps, { tagName: Component }] = $cdcc2451955840fb$export$a0ee72f2c720a5c3(Object.assign({
        tagName: asProp,
        disabled: disabled
    }, props));
    return /*#__PURE__*/ (0, $cKvYK.jsx)(Component, Object.assign({}, props, buttonProps, {
        ref: ref
    }));
});
$cdcc2451955840fb$var$Button.displayName = "Button";
var $cdcc2451955840fb$export$2e2bcd8739ae039 = $cdcc2451955840fb$var$Button;

});


parcelRegister("cFqbd", function(module, exports) {

$parcel$export(module.exports, "requiredString", () => $43679815e2490278$export$8bc4fdb2734276ba);
$parcel$export(module.exports, "requiredArray", () => $43679815e2490278$export$6e10f2f70d298df6);
$parcel$export(module.exports, "requiredFile", () => $43679815e2490278$export$ec3358fdc98c6c51);
parcelRequire("11UFl");
var $9686H = parcelRequire("9686H");
var $5hWhW = parcelRequire("5hWhW");
var $8Fw82 = parcelRequire("8Fw82");
var $eBJfs = parcelRequire("eBJfs");
var $2rGWI = parcelRequire("2rGWI");
var $ukLGy = parcelRequire("ukLGy");
function $43679815e2490278$var$requiredIf(test, validator) {
    return test ? validator.required("Ce champ est requis.") : validator;
}
const $43679815e2490278$export$8bc4fdb2734276ba = $43679815e2490278$var$requiredIf(true, (0, $ukLGy.create)());
const $43679815e2490278$export$f25be618b434f50b = $43679815e2490278$var$requiredIf(true, (0, $ukLGy.create)().email("Format de l'adresse e-mail non valide."));
const $43679815e2490278$export$98e628dec113755e = (0, $2rGWI.create)().typeError("Ce champ doit \xeatre un nombre.");
const $43679815e2490278$export$d73626444d3ce57a = $43679815e2490278$var$requiredIf(true, $43679815e2490278$export$98e628dec113755e);
const $43679815e2490278$export$4a21f16c33752377 = (0, $5hWhW.create)().typeError("Ce champ doit \xeatre un bool\xe9en.");
const $43679815e2490278$export$87bba3bb7a1f4285 = $43679815e2490278$var$requiredIf(true, $43679815e2490278$export$4a21f16c33752377);
const $43679815e2490278$export$24a1e2b92fa94c07 = $43679815e2490278$export$98e628dec113755e.min(0, "Ce champ doit \xeatre sup\xe9rieur ou \xe9gal \xe0 0.");
const $43679815e2490278$export$67e44a5301f37174 = $43679815e2490278$export$24a1e2b92fa94c07.integer("Ce champ doit \xeatre un entier");
const $43679815e2490278$export$a3560dfa62c7efe0 = $43679815e2490278$export$24a1e2b92fa94c07.max(100, "Ce champ doit inf\xe9rieur ou \xe9gal \xe0 100.");
const $43679815e2490278$export$ce12259c7522d9ef = $43679815e2490278$var$requiredIf(true, $43679815e2490278$export$a3560dfa62c7efe0);
const $43679815e2490278$export$aaf3892c2a415141 = $43679815e2490278$export$8bc4fdb2734276ba.min(8, "Doit contenir au moins 8 caract\xe8res").matches(/[a-z]/, "Doit contenir au moins une lettre minuscule").matches(/[A-Z]/, "Doit contenir au moins une lettre majuscule").matches(/[0-9]/, "Doit contenir au moins un chiffre");
const $43679815e2490278$export$6e10f2f70d298df6 = $43679815e2490278$var$requiredIf(true, (0, $9686H.create)().ensure().min(1, "Ce champ doit comporter au moins 1 valeur."));
const $43679815e2490278$export$324d90190a8b822a = (0, $8Fw82.create)().typeError("Format de date invalide");
const $43679815e2490278$export$5cbf64e9c4f743ca = $43679815e2490278$var$requiredIf(true, $43679815e2490278$export$324d90190a8b822a);
const $43679815e2490278$export$ec3358fdc98c6c51 = (0, $eBJfs.create)().required("Fichier requis");

});

parcelRegister("4VCRM", function(module, exports) {

$parcel$export(module.exports, "default", () => $85d631e74bf2c0d1$export$2e2bcd8739ae039);

var $cKvYK = parcelRequire("cKvYK");

var $lgiU2 = parcelRequire("lgiU2");

var $469X3 = parcelRequire("469X3");

var $apLCT = parcelRequire("apLCT");
const $85d631e74bf2c0d1$var$PageTitle = ({ title: title, icon: icon, right: right })=>{
    return /*#__PURE__*/ (0, $cKvYK.jsxs)((0, $469X3.default), {
        children: [
            /*#__PURE__*/ (0, $cKvYK.jsxs)("h1", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($lgiU2)))((0, (/*@__PURE__*/$parcel$interopDefault($apLCT))).title, "text-primary-100 mb-4"),
                children: [
                    /*#__PURE__*/ (0, $cKvYK.jsx)("span", {
                        className: "me-2 text-primary",
                        children: icon
                    }),
                    title
                ]
            }),
            right ? /*#__PURE__*/ (0, $cKvYK.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($apLCT))).right,
                children: right
            }) : ""
        ]
    });
};
var $85d631e74bf2c0d1$export$2e2bcd8739ae039 = $85d631e74bf2c0d1$var$PageTitle;

});
parcelRegister("apLCT", function(module, exports) {

$parcel$export(module.exports, "title", () => $79512ec135febe63$export$fb184b623420d9be, (v) => $79512ec135febe63$export$fb184b623420d9be = v);
var $79512ec135febe63$export$fb184b623420d9be;
$79512ec135febe63$export$fb184b623420d9be = `jr0R8W_title`;

});




parcelRegister("gJLDH", function(module, exports) {

$parcel$export(module.exports, "default", () => $90a15ef6ac5f0ffb$export$2e2bcd8739ae039);

var $cKvYK = parcelRequire("cKvYK");

var $bkJfK = parcelRequire("bkJfK");

var $fBRzF = parcelRequire("fBRzF");
parcelRequire("11UFl");
var $1ZTZh = parcelRequire("1ZTZh");

var $cywK3 = parcelRequire("cywK3");

var $5TbRy = parcelRequire("5TbRy");

var $cFqbd = parcelRequire("cFqbd");

var $3BicN = parcelRequire("3BicN");

var $26Ddr = parcelRequire("26Ddr");

var $bNJBP = parcelRequire("bNJBP");

var $4VCRM = parcelRequire("4VCRM");

var $hpOSz = parcelRequire("hpOSz");

var $dbHqx = parcelRequire("dbHqx");
const $90a15ef6ac5f0ffb$var$getInitialValues = ()=>({
        file: undefined
    });
const $90a15ef6ac5f0ffb$var$validationSchema = (0, $1ZTZh.create)({
    file: (0, $cFqbd.requiredFile)
});
const $90a15ef6ac5f0ffb$var$prepareVariables = (values)=>{
    const formData = new FormData();
    formData.append("file", values.file);
    return formData;
};
const $90a15ef6ac5f0ffb$var$ImportUtilisateurs = ()=>{
    const roles = (0, $26Ddr.useGet)((0, $5TbRy.default)`/api/roles/`, {});
    if (!roles.isResolved) return;
    return /*#__PURE__*/ (0, $cKvYK.jsxs)((0, $cKvYK.Fragment), {
        children: [
            /*#__PURE__*/ (0, $cKvYK.jsx)((0, $4VCRM.default), {
                title: "Import des donn\xe9es utilisateurs",
                icon: /*#__PURE__*/ (0, $cKvYK.jsx)((0, $hpOSz.IconExport), {})
            }),
            /*#__PURE__*/ (0, $cKvYK.jsx)((0, $bNJBP.PageContent), {
                children: /*#__PURE__*/ (0, $cKvYK.jsx)((0, $bNJBP.ScrollWrapper), {
                    children: /*#__PURE__*/ (0, $cKvYK.jsx)((0, $cywK3.default), {
                        getInitialValues: $90a15ef6ac5f0ffb$var$getInitialValues,
                        prepareVariables: $90a15ef6ac5f0ffb$var$prepareVariables,
                        validationSchema: $90a15ef6ac5f0ffb$var$validationSchema,
                        steps: [
                            {
                                title: "Introduction",
                                content: /*#__PURE__*/ (0, $cKvYK.jsxs)("div", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($dbHqx))).instruction,
                                    children: [
                                        "Chaque \xe9tape vous permet d'int\xe9grer des donn\xe9es li\xe9es aux utilisateurs. Certaines \xe9tapes sont obligatoires, d'autres non (pr\xe9sence du bouton \"Ignorer\").",
                                        /*#__PURE__*/ (0, $cKvYK.jsx)("br", {}),
                                        "A chaque \xe9tape, l'ic\xf4ne\xa0",
                                        /*#__PURE__*/ (0, $cKvYK.jsx)("span", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($dbHqx))).icon,
                                            children: /*#__PURE__*/ (0, $cKvYK.jsx)((0, $hpOSz.IconExport), {})
                                        }),
                                        " ",
                                        "vous permet de t\xe9l\xe9charger un fichier CSV d'exemple, vide, et le remplir avant de l'envoyer."
                                    ]
                                }),
                                useFormik: false,
                                skippable: false
                            },
                            {
                                title: "Import des utilisateurs",
                                content: /*#__PURE__*/ (0, $cKvYK.jsxs)((0, $cKvYK.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $cKvYK.jsxs)("div", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($dbHqx))).iconEtape,
                                            children: [
                                                /*#__PURE__*/ (0, $cKvYK.jsx)("a", {
                                                    "data-tooltip-id": "utilisateurs",
                                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($dbHqx))).export,
                                                    children: /*#__PURE__*/ (0, $cKvYK.jsx)((0, $hpOSz.IconInfo), {})
                                                }),
                                                /*#__PURE__*/ (0, $cKvYK.jsx)("a", {
                                                    href: (0, $5TbRy.default)`/api/imports/empty-file-utilisateurs`,
                                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($dbHqx))).export,
                                                    children: /*#__PURE__*/ (0, $cKvYK.jsx)((0, $hpOSz.IconExport), {})
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $cKvYK.jsx)((0, $fBRzF.Tooltip), {
                                            id: "utilisateurs",
                                            place: "left",
                                            children: /*#__PURE__*/ (0, $cKvYK.jsxs)("span", {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($dbHqx))).detail,
                                                children: [
                                                    /*#__PURE__*/ (0, $cKvYK.jsx)("span", {
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($dbHqx))).title,
                                                        children: "Colonnes attendues :"
                                                    }),
                                                    " ",
                                                    /*#__PURE__*/ (0, $cKvYK.jsx)("br", {}),
                                                    "username ",
                                                    /*#__PURE__*/ (0, $cKvYK.jsx)("span", {
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($dbHqx))).obligatoire,
                                                        children: "*"
                                                    }),
                                                    " ",
                                                    /*#__PURE__*/ (0, $cKvYK.jsx)("br", {}),
                                                    "email",
                                                    /*#__PURE__*/ (0, $cKvYK.jsx)("br", {}),
                                                    "password ",
                                                    /*#__PURE__*/ (0, $cKvYK.jsx)("span", {
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($dbHqx))).obligatoire,
                                                        children: "*"
                                                    }),
                                                    " ",
                                                    /*#__PURE__*/ (0, $cKvYK.jsx)("br", {}),
                                                    /*#__PURE__*/ (0, $cKvYK.jsx)("br", {}),
                                                    /*#__PURE__*/ (0, $cKvYK.jsx)("span", {
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($dbHqx))).obligatoire,
                                                        children: "*"
                                                    }),
                                                    " : obligatoire"
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $cKvYK.jsx)($90a15ef6ac5f0ffb$var$FormImportUtilisateursRoles, {})
                                    ]
                                }),
                                useFormik: true,
                                submitUrl: (0, $5TbRy.default)`/api/imports/import-utilisateurs`,
                                skippable: true
                            },
                            {
                                title: "Import des r\xf4les",
                                content: /*#__PURE__*/ (0, $cKvYK.jsxs)((0, $cKvYK.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $cKvYK.jsxs)("div", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($dbHqx))).iconEtape,
                                            children: [
                                                /*#__PURE__*/ (0, $cKvYK.jsx)("a", {
                                                    "data-tooltip-id": "roles",
                                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($dbHqx))).export,
                                                    children: /*#__PURE__*/ (0, $cKvYK.jsx)((0, $hpOSz.IconInfo), {})
                                                }),
                                                /*#__PURE__*/ (0, $cKvYK.jsx)("a", {
                                                    href: (0, $5TbRy.default)`/api/imports/empty-file-roles`,
                                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($dbHqx))).export,
                                                    children: /*#__PURE__*/ (0, $cKvYK.jsx)((0, $hpOSz.IconExport), {})
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $cKvYK.jsx)((0, $fBRzF.Tooltip), {
                                            id: "roles",
                                            place: "left",
                                            children: /*#__PURE__*/ (0, $cKvYK.jsxs)("span", {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($dbHqx))).detail,
                                                children: [
                                                    /*#__PURE__*/ (0, $cKvYK.jsx)("span", {
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($dbHqx))).title,
                                                        children: "Colonnes attendues :"
                                                    }),
                                                    " ",
                                                    /*#__PURE__*/ (0, $cKvYK.jsx)("br", {}),
                                                    "code ",
                                                    /*#__PURE__*/ (0, $cKvYK.jsx)("span", {
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($dbHqx))).obligatoire,
                                                        children: "*"
                                                    }),
                                                    /*#__PURE__*/ (0, $cKvYK.jsx)("br", {}),
                                                    "libelle ",
                                                    /*#__PURE__*/ (0, $cKvYK.jsx)("span", {
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($dbHqx))).obligatoire,
                                                        children: "*"
                                                    }),
                                                    /*#__PURE__*/ (0, $cKvYK.jsx)("br", {}),
                                                    /*#__PURE__*/ (0, $cKvYK.jsx)("br", {}),
                                                    /*#__PURE__*/ (0, $cKvYK.jsx)("span", {
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($dbHqx))).obligatoire,
                                                        children: "*"
                                                    }),
                                                    " : obligatoire"
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $cKvYK.jsxs)("div", {
                                            children: [
                                                "Les r\xf4les suivants sont d\xe9j\xe0 en base :",
                                                " ",
                                                /*#__PURE__*/ (0, $cKvYK.jsx)("ul", {
                                                    children: roles?.data?.map((etl, key)=>/*#__PURE__*/ (0, $cKvYK.jsxs)("li", {
                                                            children: [
                                                                etl.roleCode,
                                                                " (",
                                                                etl.roleLibelle,
                                                                ")"
                                                            ]
                                                        }, key))
                                                }),
                                                /*#__PURE__*/ (0, $cKvYK.jsx)("br", {}),
                                                "Si vous ne voulez pas ajouter d'autres r\xf4les, vous pouvez ignorer cette \xe9tape.",
                                                /*#__PURE__*/ (0, $cKvYK.jsx)("br", {})
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $cKvYK.jsx)($90a15ef6ac5f0ffb$var$FormImportUtilisateursRoles, {})
                                    ]
                                }),
                                useFormik: true,
                                submitUrl: (0, $5TbRy.default)`/api/imports/import-roles`,
                                skippable: true
                            },
                            {
                                title: "Import des liens utilisateurs / r\xf4les",
                                content: /*#__PURE__*/ (0, $cKvYK.jsxs)((0, $cKvYK.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $cKvYK.jsxs)("div", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($dbHqx))).iconEtape,
                                            children: [
                                                /*#__PURE__*/ (0, $cKvYK.jsx)("a", {
                                                    "data-tooltip-id": "utilisateurs-roles",
                                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($dbHqx))).export,
                                                    children: /*#__PURE__*/ (0, $cKvYK.jsx)((0, $hpOSz.IconInfo), {})
                                                }),
                                                /*#__PURE__*/ (0, $cKvYK.jsx)("a", {
                                                    href: (0, $5TbRy.default)`/api/imports/empty-file-utilisateurs-roles`,
                                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($dbHqx))).export,
                                                    children: /*#__PURE__*/ (0, $cKvYK.jsx)((0, $hpOSz.IconExport), {})
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $cKvYK.jsx)((0, $fBRzF.Tooltip), {
                                            id: "utilisateurs-roles",
                                            place: "left",
                                            children: /*#__PURE__*/ (0, $cKvYK.jsxs)("span", {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($dbHqx))).detail,
                                                children: [
                                                    /*#__PURE__*/ (0, $cKvYK.jsx)("span", {
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($dbHqx))).title,
                                                        children: "Colonnes attendues :"
                                                    }),
                                                    " ",
                                                    /*#__PURE__*/ (0, $cKvYK.jsx)("br", {}),
                                                    "roleCode ",
                                                    /*#__PURE__*/ (0, $cKvYK.jsx)("span", {
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($dbHqx))).obligatoire,
                                                        children: "*"
                                                    }),
                                                    /*#__PURE__*/ (0, $cKvYK.jsx)("br", {}),
                                                    "username ",
                                                    /*#__PURE__*/ (0, $cKvYK.jsx)("span", {
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($dbHqx))).obligatoire,
                                                        children: "*"
                                                    }),
                                                    /*#__PURE__*/ (0, $cKvYK.jsx)("br", {}),
                                                    /*#__PURE__*/ (0, $cKvYK.jsx)("br", {}),
                                                    /*#__PURE__*/ (0, $cKvYK.jsx)("span", {
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($dbHqx))).obligatoire,
                                                        children: "*"
                                                    }),
                                                    " : obligatoire"
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $cKvYK.jsx)($90a15ef6ac5f0ffb$var$FormImportUtilisateursRoles, {})
                                    ]
                                }),
                                useFormik: true,
                                submitUrl: (0, $5TbRy.default)`/api/imports/import-utilisateurs-roles`,
                                skippable: false
                            },
                            {
                                title: "Imports termin\xe9s",
                                content: /*#__PURE__*/ (0, $cKvYK.jsx)("div", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($dbHqx))).instruction,
                                    children: "Les utilisateurs / r\xf4les ont \xe9t\xe9 import\xe9s."
                                }),
                                useFormik: false,
                                skippable: false
                            }
                        ]
                    })
                })
            })
        ]
    });
};
var $90a15ef6ac5f0ffb$export$2e2bcd8739ae039 = $90a15ef6ac5f0ffb$var$ImportUtilisateurs;
const $90a15ef6ac5f0ffb$var$FormImportUtilisateursRoles = ()=>{
    const { setFieldValue: setFieldValue } = (0, $bkJfK.useFormikContext)();
    return /*#__PURE__*/ (0, $cKvYK.jsx)((0, $cKvYK.Fragment), {
        children: /*#__PURE__*/ (0, $cKvYK.jsx)((0, $3BicN.FileInput), {
            name: "file",
            label: "Choisissez un fichier csv",
            accept: ".csv",
            onChange: (e)=>{
                setFieldValue("file", e.target.files[0]);
            },
            className: undefined
        })
    });
};

});
parcelRegister("fBRzF", function(module, exports) {

$parcel$export(module.exports, "Tooltip", () => $b3ac8be866894793$export$28c660c63b792dea);
/*
* React Tooltip
* {@link https://github.com/ReactTooltip/react-tooltip}
* @copyright ReactTooltip Team
* @license MIT
*/ 
var $kc00y = parcelRequire("kc00y");

var $jRiwg = parcelRequire("jRiwg");

var $lgiU2 = parcelRequire("lgiU2");

var $ec262 = parcelRequire("ec262");
const $b3ac8be866894793$var$h = "react-tooltip-core-styles", $b3ac8be866894793$var$w = "react-tooltip-base-styles", $b3ac8be866894793$var$b = {
    core: !1,
    base: !1
};
function $b3ac8be866894793$var$S({ css: e, id: t = $b3ac8be866894793$var$w, type: o = "base", ref: r }) {
    var l, n;
    if (!e || "undefined" == typeof document || $b3ac8be866894793$var$b[o]) return;
    if ("core" === o && "undefined" != typeof $ec262 && (null === (l = null === $ec262 || void 0 === $ec262 ? void 0 : $ec262.env) || void 0 === l ? void 0 : l.REACT_TOOLTIP_DISABLE_CORE_STYLES)) return;
    if ("base" !== o && "undefined" != typeof $ec262 && (null === (n = null === $ec262 || void 0 === $ec262 ? void 0 : $ec262.env) || void 0 === n ? void 0 : n.REACT_TOOLTIP_DISABLE_BASE_STYLES)) return;
    "core" === o && (t = $b3ac8be866894793$var$h), r || (r = {});
    const { insertAt: c } = r;
    if (document.getElementById(t)) return void console.warn(`[react-tooltip] Element with id '${t}' already exists. Call \`removeStyle()\` first`);
    const i = document.head || document.getElementsByTagName("head")[0], s = document.createElement("style");
    s.id = t, s.type = "text/css", "top" === c && i.firstChild ? i.insertBefore(s, i.firstChild) : i.appendChild(s), s.styleSheet ? s.styleSheet.cssText = e : s.appendChild(document.createTextNode(e)), $b3ac8be866894793$var$b[o] = !0;
}
function $b3ac8be866894793$export$afe978aceb0adefd({ type: e = "base", id: t = $b3ac8be866894793$var$w } = {}) {
    if (!$b3ac8be866894793$var$b[e]) return;
    "core" === e && (t = $b3ac8be866894793$var$h);
    const o = document.getElementById(t);
    "style" === (null == o ? void 0 : o.tagName) ? null == o || o.remove() : console.warn(`[react-tooltip] Failed to remove 'style' element with id '${t}'. Call \`injectStyle()\` first`), $b3ac8be866894793$var$b[e] = !1;
}
const $b3ac8be866894793$var$g = async ({ elementReference: e = null, tooltipReference: t = null, tooltipArrowReference: o = null, place: r = "top", offset: l = 10, strategy: n = "absolute", middlewares: c = [
    (0, $jRiwg.offset)(Number(l)),
    (0, $jRiwg.flip)({
        fallbackAxisSideDirection: "start"
    }),
    (0, $jRiwg.shift)({
        padding: 5
    })
], border: i })=>{
    if (!e) return {
        tooltipStyles: {},
        tooltipArrowStyles: {},
        place: r
    };
    if (null === t) return {
        tooltipStyles: {},
        tooltipArrowStyles: {},
        place: r
    };
    const s = c;
    return o ? (s.push((0, $jRiwg.arrow)({
        element: o,
        padding: 5
    })), (0, $jRiwg.computePosition)(e, t, {
        placement: r,
        strategy: n,
        middleware: s
    }).then(({ x: e, y: t, placement: o, middlewareData: r })=>{
        var l, n;
        const c = {
            left: `${e}px`,
            top: `${t}px`,
            border: i
        }, { x: s, y: a } = null !== (l = r.arrow) && void 0 !== l ? l : {
            x: 0,
            y: 0
        }, u = null !== (n = ({
            top: "bottom",
            right: "left",
            bottom: "top",
            left: "right"
        })[o.split("-")[0]]) && void 0 !== n ? n : "bottom", d = i && {
            borderBottom: i,
            borderRight: i
        };
        let p = 0;
        if (i) {
            const e = `${i}`.match(/(\d+)px/);
            p = (null == e ? void 0 : e[1]) ? Number(e[1]) : 1;
        }
        return {
            tooltipStyles: c,
            tooltipArrowStyles: {
                left: null != s ? `${s}px` : "",
                top: null != a ? `${a}px` : "",
                right: "",
                bottom: "",
                ...d,
                [u]: `-${4 + p}px`
            },
            place: o
        };
    })) : (0, $jRiwg.computePosition)(e, t, {
        placement: "bottom",
        strategy: n,
        middleware: s
    }).then(({ x: e, y: t, placement: o })=>({
            tooltipStyles: {
                left: `${e}px`,
                top: `${t}px`
            },
            tooltipArrowStyles: {},
            place: o
        }));
}, $b3ac8be866894793$var$A = (e, t)=>!("CSS" in window && "supports" in window.CSS) || window.CSS.supports(e, t), $b3ac8be866894793$var$_ = (e, t, o)=>{
    let r = null;
    const l = function(...l) {
        const n = ()=>{
            r = null, o || e.apply(this, l);
        };
        o && !r && (e.apply(this, l), r = setTimeout(n, t)), o || (r && clearTimeout(r), r = setTimeout(n, t));
    };
    return l.cancel = ()=>{
        r && (clearTimeout(r), r = null);
    }, l;
}, $b3ac8be866894793$var$O = (e)=>null !== e && !Array.isArray(e) && "object" == typeof e, $b3ac8be866894793$var$T = (e, t)=>{
    if (e === t) return !0;
    if (Array.isArray(e) && Array.isArray(t)) return e.length === t.length && e.every((e, o)=>$b3ac8be866894793$var$T(e, t[o]));
    if (Array.isArray(e) !== Array.isArray(t)) return !1;
    if (!$b3ac8be866894793$var$O(e) || !$b3ac8be866894793$var$O(t)) return e === t;
    const o = Object.keys(e), r = Object.keys(t);
    return o.length === r.length && o.every((o)=>$b3ac8be866894793$var$T(e[o], t[o]));
}, $b3ac8be866894793$var$k = (e)=>{
    if (!(e instanceof HTMLElement || e instanceof SVGElement)) return !1;
    const t = getComputedStyle(e);
    return [
        "overflow",
        "overflow-x",
        "overflow-y"
    ].some((e)=>{
        const o = t.getPropertyValue(e);
        return "auto" === o || "scroll" === o;
    });
}, $b3ac8be866894793$var$C = (e)=>{
    if (!e) return null;
    let t = e.parentElement;
    for(; t;){
        if ($b3ac8be866894793$var$k(t)) return t;
        t = t.parentElement;
    }
    return document.scrollingElement || document.documentElement;
}, $b3ac8be866894793$var$L = "undefined" != typeof window ? (0, $kc00y.useLayoutEffect) : (0, $kc00y.useEffect), $b3ac8be866894793$var$R = "DEFAULT_TOOLTIP_ID", $b3ac8be866894793$var$x = {
    anchorRefs: new Set,
    activeAnchor: {
        current: null
    },
    attach: ()=>{},
    detach: ()=>{},
    setActiveAnchor: ()=>{}
}, $b3ac8be866894793$var$N = (0, $kc00y.createContext)({
    getTooltipData: ()=>$b3ac8be866894793$var$x
}), $b3ac8be866894793$export$f78649fb9ca566b8 = ({ children: t })=>{
    const [o, r] = (0, $kc00y.useState)({
        [$b3ac8be866894793$var$R]: new Set
    }), [i, s] = (0, $kc00y.useState)({
        [$b3ac8be866894793$var$R]: {
            current: null
        }
    }), a = (e, ...t)=>{
        r((o)=>{
            var r;
            const l = null !== (r = o[e]) && void 0 !== r ? r : new Set;
            return t.forEach((e)=>l.add(e)), {
                ...o,
                [e]: new Set(l)
            };
        });
    }, u = (e, ...t)=>{
        r((o)=>{
            const r = o[e];
            return r ? (t.forEach((e)=>r.delete(e)), {
                ...o
            }) : o;
        });
    }, d = (0, $kc00y.useCallback)((e = $b3ac8be866894793$var$R)=>{
        var t, r;
        return {
            anchorRefs: null !== (t = o[e]) && void 0 !== t ? t : new Set,
            activeAnchor: null !== (r = i[e]) && void 0 !== r ? r : {
                current: null
            },
            attach: (...t)=>a(e, ...t),
            detach: (...t)=>u(e, ...t),
            setActiveAnchor: (t)=>((e, t)=>{
                    s((o)=>{
                        var r;
                        return (null === (r = o[e]) || void 0 === r ? void 0 : r.current) === t.current ? o : {
                            ...o,
                            [e]: t
                        };
                    });
                })(e, t)
        };
    }, [
        o,
        i,
        a,
        u
    ]), p = (0, $kc00y.useMemo)(()=>({
            getTooltipData: d
        }), [
        d
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement($b3ac8be866894793$var$N.Provider, {
        value: p
    }, t);
};
function $b3ac8be866894793$var$I(e = $b3ac8be866894793$var$R) {
    return (0, $kc00y.useContext)($b3ac8be866894793$var$N).getTooltipData(e);
}
const $b3ac8be866894793$export$57a09c4864b20b90 = ({ tooltipId: t, children: r, className: l, place: n, content: c, html: i, variant: a, offset: u, wrapper: d, events: p, positionStrategy: v, delayShow: m, delayHide: f })=>{
    const { attach: h, detach: w } = $b3ac8be866894793$var$I(t), b = (0, $kc00y.useRef)(null);
    return (0, $kc00y.useEffect)(()=>(h(b), ()=>{
            w(b);
        }), []), (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement("span", {
        ref: b,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($lgiU2)))("react-tooltip-wrapper", l),
        "data-tooltip-place": n,
        "data-tooltip-content": c,
        "data-tooltip-html": i,
        "data-tooltip-variant": a,
        "data-tooltip-offset": u,
        "data-tooltip-wrapper": d,
        "data-tooltip-events": p,
        "data-tooltip-position-strategy": v,
        "data-tooltip-delay-show": m,
        "data-tooltip-delay-hide": f
    }, r);
};
var $b3ac8be866894793$var$B = {
    tooltip: "core-styles-module_tooltip__3vRRp",
    fixed: "core-styles-module_fixed__pcSol",
    arrow: "core-styles-module_arrow__cvMwQ",
    noArrow: "core-styles-module_noArrow__xock6",
    clickable: "core-styles-module_clickable__ZuTTB",
    show: "core-styles-module_show__Nt9eE",
    closing: "core-styles-module_closing__sGnxF"
}, $b3ac8be866894793$var$z = {
    tooltip: "styles-module_tooltip__mnnfp",
    arrow: "styles-module_arrow__K0L3T",
    dark: "styles-module_dark__xNqje",
    light: "styles-module_light__Z6W-X",
    success: "styles-module_success__A2AKt",
    warning: "styles-module_warning__SCK0X",
    error: "styles-module_error__JvumD",
    info: "styles-module_info__BWdHW"
};
const $b3ac8be866894793$var$D = ({ forwardRef: t, id: r, className: c, classNameArrow: i, variant: u = "dark", anchorId: d, anchorSelect: p, place: v = "top", offset: m = 10, events: h = [
    "hover"
], openOnClick: w = !1, positionStrategy: b = "absolute", middlewares: S, wrapper: E, delayShow: A = 0, delayHide: O = 0, float: k = !1, hidden: R = !1, noArrow: x = !1, clickable: N = !1, closeOnEsc: $ = !1, closeOnScroll: j = !1, closeOnResize: D = !1, openEvents: q, closeEvents: H, globalCloseEvents: M, imperativeModeOnly: W, style: P, position: V, afterShow: F, afterHide: K, content: U, contentWrapperRef: X, isOpen: Y, defaultIsOpen: G = !1, setIsOpen: Z, activeAnchor: J, setActiveAnchor: Q, border: ee, opacity: te, arrowColor: oe, role: re = "tooltip" })=>{
    var le;
    const ne = (0, $kc00y.useRef)(null), ce = (0, $kc00y.useRef)(null), ie = (0, $kc00y.useRef)(null), se = (0, $kc00y.useRef)(null), ae = (0, $kc00y.useRef)(null), [ue, de] = (0, $kc00y.useState)({
        tooltipStyles: {},
        tooltipArrowStyles: {},
        place: v
    }), [pe, ve] = (0, $kc00y.useState)(!1), [me, fe] = (0, $kc00y.useState)(!1), [ye, he] = (0, $kc00y.useState)(null), we = (0, $kc00y.useRef)(!1), be = (0, $kc00y.useRef)(null), { anchorRefs: Se, setActiveAnchor: Ee } = $b3ac8be866894793$var$I(r), ge = (0, $kc00y.useRef)(!1), [Ae, _e] = (0, $kc00y.useState)([]), Oe = (0, $kc00y.useRef)(!1), Te = w || h.includes("click"), ke = Te || (null == q ? void 0 : q.click) || (null == q ? void 0 : q.dblclick) || (null == q ? void 0 : q.mousedown), Ce = q ? {
        ...q
    } : {
        mouseenter: !0,
        focus: !0,
        click: !1,
        dblclick: !1,
        mousedown: !1
    };
    !q && Te && Object.assign(Ce, {
        mouseenter: !1,
        focus: !1,
        click: !0
    });
    const Le = H ? {
        ...H
    } : {
        mouseleave: !0,
        blur: !0,
        click: !1,
        dblclick: !1,
        mouseup: !1
    };
    !H && Te && Object.assign(Le, {
        mouseleave: !1,
        blur: !1
    });
    const Re = M ? {
        ...M
    } : {
        escape: $ || !1,
        scroll: j || !1,
        resize: D || !1,
        clickOutsideAnchor: ke || !1
    };
    W && (Object.assign(Ce, {
        mouseenter: !1,
        focus: !1,
        click: !1,
        dblclick: !1,
        mousedown: !1
    }), Object.assign(Le, {
        mouseleave: !1,
        blur: !1,
        click: !1,
        dblclick: !1,
        mouseup: !1
    }), Object.assign(Re, {
        escape: !1,
        scroll: !1,
        resize: !1,
        clickOutsideAnchor: !1
    })), $b3ac8be866894793$var$L(()=>(Oe.current = !0, ()=>{
            Oe.current = !1;
        }), []);
    const xe = (e)=>{
        Oe.current && (e && fe(!0), setTimeout(()=>{
            Oe.current && (null == Z || Z(e), void 0 === Y && ve(e));
        }, 10));
    };
    (0, $kc00y.useEffect)(()=>{
        if (void 0 === Y) return ()=>null;
        Y && fe(!0);
        const e = setTimeout(()=>{
            ve(Y);
        }, 10);
        return ()=>{
            clearTimeout(e);
        };
    }, [
        Y
    ]), (0, $kc00y.useEffect)(()=>{
        if (pe !== we.current) {
            if (ae.current && clearTimeout(ae.current), we.current = pe, pe) null == F || F();
            else {
                const e = ((e)=>{
                    const t = e.match(/^([\d.]+)(ms|s)$/);
                    if (!t) return 0;
                    const [, o, r] = t;
                    return Number(o) * ("ms" === r ? 1 : 1e3);
                })(getComputedStyle(document.body).getPropertyValue("--rt-transition-show-delay"));
                ae.current = setTimeout(()=>{
                    fe(!1), he(null), null == K || K();
                }, e + 25);
            }
        }
    }, [
        pe
    ]);
    const Ne = (e)=>{
        de((t)=>$b3ac8be866894793$var$T(t, e) ? t : e);
    }, $e = (e = A)=>{
        ie.current && clearTimeout(ie.current), me ? xe(!0) : ie.current = setTimeout(()=>{
            xe(!0);
        }, e);
    }, Ie = (e = O)=>{
        se.current && clearTimeout(se.current), se.current = setTimeout(()=>{
            ge.current || xe(!1);
        }, e);
    }, je = (e)=>{
        var t;
        if (!e) return;
        const o = null !== (t = e.currentTarget) && void 0 !== t ? t : e.target;
        if (!(null == o ? void 0 : o.isConnected)) return Q(null), void Ee({
            current: null
        });
        A ? $e() : xe(!0), Q(o), Ee({
            current: o
        }), se.current && clearTimeout(se.current);
    }, Be = ()=>{
        N ? Ie(O || 100) : O ? Ie() : xe(!1), ie.current && clearTimeout(ie.current);
    }, ze = ({ x: e, y: t })=>{
        var o;
        const r = {
            getBoundingClientRect: ()=>({
                    x: e,
                    y: t,
                    width: 0,
                    height: 0,
                    top: t,
                    left: e,
                    right: e,
                    bottom: t
                })
        };
        $b3ac8be866894793$var$g({
            place: null !== (o = null == ye ? void 0 : ye.place) && void 0 !== o ? o : v,
            offset: m,
            elementReference: r,
            tooltipReference: ne.current,
            tooltipArrowReference: ce.current,
            strategy: b,
            middlewares: S,
            border: ee
        }).then((e)=>{
            Ne(e);
        });
    }, De = (e)=>{
        if (!e) return;
        const t = e, o = {
            x: t.clientX,
            y: t.clientY
        };
        ze(o), be.current = o;
    }, qe = (e)=>{
        var t;
        if (!pe) return;
        const o = e.target;
        if (!o.isConnected) return;
        if (null === (t = ne.current) || void 0 === t ? void 0 : t.contains(o)) return;
        [
            document.querySelector(`[id='${d}']`),
            ...Ae
        ].some((e)=>null == e ? void 0 : e.contains(o)) || (xe(!1), ie.current && clearTimeout(ie.current));
    }, He = $b3ac8be866894793$var$_(je, 50, !0), Me = $b3ac8be866894793$var$_(Be, 50, !0), We = (e)=>{
        Me.cancel(), He(e);
    }, Pe = ()=>{
        He.cancel(), Me();
    }, Ve = (0, $kc00y.useCallback)(()=>{
        var e, t;
        const o = null !== (e = null == ye ? void 0 : ye.position) && void 0 !== e ? e : V;
        o ? ze(o) : k ? be.current && ze(be.current) : (null == J ? void 0 : J.isConnected) && $b3ac8be866894793$var$g({
            place: null !== (t = null == ye ? void 0 : ye.place) && void 0 !== t ? t : v,
            offset: m,
            elementReference: J,
            tooltipReference: ne.current,
            tooltipArrowReference: ce.current,
            strategy: b,
            middlewares: S,
            border: ee
        }).then((e)=>{
            Oe.current && Ne(e);
        });
    }, [
        pe,
        J,
        U,
        P,
        v,
        null == ye ? void 0 : ye.place,
        m,
        b,
        V,
        null == ye ? void 0 : ye.position,
        k
    ]);
    (0, $kc00y.useEffect)(()=>{
        var e, t;
        const o = new Set(Se);
        Ae.forEach((e)=>{
            o.add({
                current: e
            });
        });
        const r = document.querySelector(`[id='${d}']`);
        r && o.add({
            current: r
        });
        const l = ()=>{
            xe(!1);
        }, n = $b3ac8be866894793$var$C(J), c = $b3ac8be866894793$var$C(ne.current);
        Re.scroll && (window.addEventListener("scroll", l), null == n || n.addEventListener("scroll", l), null == c || c.addEventListener("scroll", l));
        let i = null;
        Re.resize ? window.addEventListener("resize", l) : J && ne.current && (i = (0, $jRiwg.autoUpdate)(J, ne.current, Ve, {
            ancestorResize: !0,
            elementResize: !0,
            layoutShift: !0
        }));
        const s = (e)=>{
            "Escape" === e.key && xe(!1);
        };
        Re.escape && window.addEventListener("keydown", s), Re.clickOutsideAnchor && window.addEventListener("click", qe);
        const a = [], u = (e)=>{
            pe && (null == e ? void 0 : e.target) === J || je(e);
        }, p = (e)=>{
            pe && (null == e ? void 0 : e.target) === J && Be();
        }, v = [
            "mouseenter",
            "mouseleave",
            "focus",
            "blur"
        ], m = [
            "click",
            "dblclick",
            "mousedown",
            "mouseup"
        ];
        Object.entries(Ce).forEach(([e, t])=>{
            t && (v.includes(e) ? a.push({
                event: e,
                listener: We
            }) : m.includes(e) && a.push({
                event: e,
                listener: u
            }));
        }), Object.entries(Le).forEach(([e, t])=>{
            t && (v.includes(e) ? a.push({
                event: e,
                listener: Pe
            }) : m.includes(e) && a.push({
                event: e,
                listener: p
            }));
        }), k && a.push({
            event: "pointermove",
            listener: De
        });
        const y = ()=>{
            ge.current = !0;
        }, h = ()=>{
            ge.current = !1, Be();
        };
        return N && !ke && (null === (e = ne.current) || void 0 === e || e.addEventListener("mouseenter", y), null === (t = ne.current) || void 0 === t || t.addEventListener("mouseleave", h)), a.forEach(({ event: e, listener: t })=>{
            o.forEach((o)=>{
                var r;
                null === (r = o.current) || void 0 === r || r.addEventListener(e, t);
            });
        }), ()=>{
            var e, t;
            Re.scroll && (window.removeEventListener("scroll", l), null == n || n.removeEventListener("scroll", l), null == c || c.removeEventListener("scroll", l)), Re.resize ? window.removeEventListener("resize", l) : null == i || i(), Re.clickOutsideAnchor && window.removeEventListener("click", qe), Re.escape && window.removeEventListener("keydown", s), N && !ke && (null === (e = ne.current) || void 0 === e || e.removeEventListener("mouseenter", y), null === (t = ne.current) || void 0 === t || t.removeEventListener("mouseleave", h)), a.forEach(({ event: e, listener: t })=>{
                o.forEach((o)=>{
                    var r;
                    null === (r = o.current) || void 0 === r || r.removeEventListener(e, t);
                });
            });
        };
    }, [
        J,
        Ve,
        me,
        Se,
        Ae,
        q,
        H,
        M,
        Te,
        A,
        O
    ]), (0, $kc00y.useEffect)(()=>{
        var e, t;
        let o = null !== (t = null !== (e = null == ye ? void 0 : ye.anchorSelect) && void 0 !== e ? e : p) && void 0 !== t ? t : "";
        !o && r && (o = `[data-tooltip-id='${r}']`);
        const l = new MutationObserver((e)=>{
            const t = [], l = [];
            e.forEach((e)=>{
                if ("attributes" === e.type && "data-tooltip-id" === e.attributeName) e.target.getAttribute("data-tooltip-id") === r ? t.push(e.target) : e.oldValue === r && l.push(e.target);
                if ("childList" === e.type) {
                    if (J) {
                        const t = [
                            ...e.removedNodes
                        ].filter((e)=>1 === e.nodeType);
                        if (o) try {
                            l.push(...t.filter((e)=>e.matches(o))), l.push(...t.flatMap((e)=>[
                                    ...e.querySelectorAll(o)
                                ]));
                        } catch (e) {}
                        t.some((e)=>{
                            var t;
                            return !!(null === (t = null == e ? void 0 : e.contains) || void 0 === t ? void 0 : t.call(e, J)) && (fe(!1), xe(!1), Q(null), ie.current && clearTimeout(ie.current), se.current && clearTimeout(se.current), !0);
                        });
                    }
                    if (o) try {
                        const r = [
                            ...e.addedNodes
                        ].filter((e)=>1 === e.nodeType);
                        t.push(...r.filter((e)=>e.matches(o))), t.push(...r.flatMap((e)=>[
                                ...e.querySelectorAll(o)
                            ]));
                    } catch (e) {}
                }
            }), (t.length || l.length) && _e((e)=>[
                    ...e.filter((e)=>!l.includes(e)),
                    ...t
                ]);
        });
        return l.observe(document.body, {
            childList: !0,
            subtree: !0,
            attributes: !0,
            attributeFilter: [
                "data-tooltip-id"
            ],
            attributeOldValue: !0
        }), ()=>{
            l.disconnect();
        };
    }, [
        r,
        p,
        null == ye ? void 0 : ye.anchorSelect,
        J
    ]), (0, $kc00y.useEffect)(()=>{
        Ve();
    }, [
        Ve
    ]), (0, $kc00y.useEffect)(()=>{
        if (!(null == X ? void 0 : X.current)) return ()=>null;
        const e = new ResizeObserver(()=>{
            setTimeout(()=>Ve());
        });
        return e.observe(X.current), ()=>{
            e.disconnect();
        };
    }, [
        U,
        null == X ? void 0 : X.current
    ]), (0, $kc00y.useEffect)(()=>{
        var e;
        const t = document.querySelector(`[id='${d}']`), o = [
            ...Ae,
            t
        ];
        J && o.includes(J) || Q(null !== (e = Ae[0]) && void 0 !== e ? e : t);
    }, [
        d,
        Ae,
        J
    ]), (0, $kc00y.useEffect)(()=>(G && xe(!0), ()=>{
            ie.current && clearTimeout(ie.current), se.current && clearTimeout(se.current);
        }), []), (0, $kc00y.useEffect)(()=>{
        var e;
        let t = null !== (e = null == ye ? void 0 : ye.anchorSelect) && void 0 !== e ? e : p;
        if (!t && r && (t = `[data-tooltip-id='${r}']`), t) try {
            const e = Array.from(document.querySelectorAll(t));
            _e(e);
        } catch (e) {
            _e([]);
        }
    }, [
        r,
        p,
        null == ye ? void 0 : ye.anchorSelect
    ]), (0, $kc00y.useEffect)(()=>{
        ie.current && (clearTimeout(ie.current), $e(A));
    }, [
        A
    ]);
    const Fe = null !== (le = null == ye ? void 0 : ye.content) && void 0 !== le ? le : U, Ke = pe && Object.keys(ue.tooltipStyles).length > 0;
    return (0, $kc00y.useImperativeHandle)(t, ()=>({
            open: (e)=>{
                if (null == e ? void 0 : e.anchorSelect) try {
                    document.querySelector(e.anchorSelect);
                } catch (t) {
                    return void console.warn(`[react-tooltip] "${e.anchorSelect}" is not a valid CSS selector`);
                }
                he(null != e ? e : null), (null == e ? void 0 : e.delay) ? $e(e.delay) : xe(!0);
            },
            close: (e)=>{
                (null == e ? void 0 : e.delay) ? Ie(e.delay) : xe(!1);
            },
            activeAnchor: J,
            place: ue.place,
            isOpen: Boolean(me && !R && Fe && Ke)
        })), me && !R && Fe ? (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement(E, {
        id: r,
        role: re,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($lgiU2)))("react-tooltip", $b3ac8be866894793$var$B.tooltip, $b3ac8be866894793$var$z.tooltip, $b3ac8be866894793$var$z[u], c, `react-tooltip__place-${ue.place}`, $b3ac8be866894793$var$B[Ke ? "show" : "closing"], Ke ? "react-tooltip__show" : "react-tooltip__closing", "fixed" === b && $b3ac8be866894793$var$B.fixed, N && $b3ac8be866894793$var$B.clickable),
        onTransitionEnd: (e)=>{
            ae.current && clearTimeout(ae.current), pe || "opacity" !== e.propertyName || (fe(!1), he(null), null == K || K());
        },
        style: {
            ...P,
            ...ue.tooltipStyles,
            opacity: void 0 !== te && Ke ? te : void 0
        },
        ref: ne
    }, Fe, (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement(E, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($lgiU2)))("react-tooltip-arrow", $b3ac8be866894793$var$B.arrow, $b3ac8be866894793$var$z.arrow, i, x && $b3ac8be866894793$var$B.noArrow),
        style: {
            ...ue.tooltipArrowStyles,
            background: oe ? `linear-gradient(to right bottom, transparent 50%, ${oe} 50%)` : void 0
        },
        ref: ce
    })) : null;
}, $b3ac8be866894793$var$q = ({ content: t })=>(0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement("span", {
        dangerouslySetInnerHTML: {
            __html: t
        }
    }), $b3ac8be866894793$export$28c660c63b792dea = (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).forwardRef(({ id: t, anchorId: r, anchorSelect: n, content: c, html: i, render: a, className: u, classNameArrow: d, variant: p = "dark", place: v = "top", offset: m = 10, wrapper: f = "div", children: h = null, events: w = [
    "hover"
], openOnClick: b = !1, positionStrategy: S = "absolute", middlewares: E, delayShow: g = 0, delayHide: _ = 0, float: O = !1, hidden: T = !1, noArrow: k = !1, clickable: C = !1, closeOnEsc: L = !1, closeOnScroll: R = !1, closeOnResize: x = !1, openEvents: N, closeEvents: $, globalCloseEvents: j, imperativeModeOnly: B = !1, style: z, position: H, isOpen: M, defaultIsOpen: W = !1, disableStyleInjection: P = !1, border: V, opacity: F, arrowColor: K, setIsOpen: U, afterShow: X, afterHide: Y, role: G = "tooltip" }, Z)=>{
    const [J, Q] = (0, $kc00y.useState)(c), [ee, te] = (0, $kc00y.useState)(i), [oe, re] = (0, $kc00y.useState)(v), [le, ne] = (0, $kc00y.useState)(p), [ce, ie] = (0, $kc00y.useState)(m), [se, ae] = (0, $kc00y.useState)(g), [ue, de] = (0, $kc00y.useState)(_), [pe, ve] = (0, $kc00y.useState)(O), [me, fe] = (0, $kc00y.useState)(T), [ye, he] = (0, $kc00y.useState)(f), [we, be] = (0, $kc00y.useState)(w), [Se, Ee] = (0, $kc00y.useState)(S), [ge, Ae] = (0, $kc00y.useState)(null), [_e, Oe] = (0, $kc00y.useState)(null), Te = (0, $kc00y.useRef)(P), { anchorRefs: ke, activeAnchor: Ce } = $b3ac8be866894793$var$I(t), Le = (e)=>null == e ? void 0 : e.getAttributeNames().reduce((t, o)=>{
            var r;
            if (o.startsWith("data-tooltip-")) t[o.replace(/^data-tooltip-/, "")] = null !== (r = null == e ? void 0 : e.getAttribute(o)) && void 0 !== r ? r : null;
            return t;
        }, {}), Re = (e)=>{
        const t = {
            place: (e)=>{
                var t;
                re(null !== (t = e) && void 0 !== t ? t : v);
            },
            content: (e)=>{
                Q(null != e ? e : c);
            },
            html: (e)=>{
                te(null != e ? e : i);
            },
            variant: (e)=>{
                var t;
                ne(null !== (t = e) && void 0 !== t ? t : p);
            },
            offset: (e)=>{
                ie(null === e ? m : Number(e));
            },
            wrapper: (e)=>{
                var t;
                he(null !== (t = e) && void 0 !== t ? t : f);
            },
            events: (e)=>{
                const t = null == e ? void 0 : e.split(" ");
                be(null != t ? t : w);
            },
            "position-strategy": (e)=>{
                var t;
                Ee(null !== (t = e) && void 0 !== t ? t : S);
            },
            "delay-show": (e)=>{
                ae(null === e ? g : Number(e));
            },
            "delay-hide": (e)=>{
                de(null === e ? _ : Number(e));
            },
            float: (e)=>{
                ve(null === e ? O : "true" === e);
            },
            hidden: (e)=>{
                fe(null === e ? T : "true" === e);
            },
            "class-name": (e)=>{
                Ae(e);
            }
        };
        Object.values(t).forEach((e)=>e(null)), Object.entries(e).forEach(([e, o])=>{
            var r;
            null === (r = t[e]) || void 0 === r || r.call(t, o);
        });
    };
    (0, $kc00y.useEffect)(()=>{
        Q(c);
    }, [
        c
    ]), (0, $kc00y.useEffect)(()=>{
        te(i);
    }, [
        i
    ]), (0, $kc00y.useEffect)(()=>{
        re(v);
    }, [
        v
    ]), (0, $kc00y.useEffect)(()=>{
        ne(p);
    }, [
        p
    ]), (0, $kc00y.useEffect)(()=>{
        ie(m);
    }, [
        m
    ]), (0, $kc00y.useEffect)(()=>{
        ae(g);
    }, [
        g
    ]), (0, $kc00y.useEffect)(()=>{
        de(_);
    }, [
        _
    ]), (0, $kc00y.useEffect)(()=>{
        ve(O);
    }, [
        O
    ]), (0, $kc00y.useEffect)(()=>{
        fe(T);
    }, [
        T
    ]), (0, $kc00y.useEffect)(()=>{
        Ee(S);
    }, [
        S
    ]), (0, $kc00y.useEffect)(()=>{
        Te.current !== P && console.warn("[react-tooltip] Do not change `disableStyleInjection` dynamically.");
    }, [
        P
    ]), (0, $kc00y.useEffect)(()=>{
        "undefined" != typeof window && window.dispatchEvent(new CustomEvent("react-tooltip-inject-styles", {
            detail: {
                disableCore: "core" === P,
                disableBase: P
            }
        }));
    }, []), (0, $kc00y.useEffect)(()=>{
        var e;
        const o = new Set(ke);
        let l = n;
        if (!l && t && (l = `[data-tooltip-id='${t}']`), l) try {
            document.querySelectorAll(l).forEach((e)=>{
                o.add({
                    current: e
                });
            });
        } catch (e) {
            console.warn(`[react-tooltip] "${l}" is not a valid CSS selector`);
        }
        const c = document.querySelector(`[id='${r}']`);
        if (c && o.add({
            current: c
        }), !o.size) return ()=>null;
        const i = null !== (e = null != _e ? _e : c) && void 0 !== e ? e : Ce.current, s = new MutationObserver((e)=>{
            e.forEach((e)=>{
                var t;
                if (!i || "attributes" !== e.type || !(null === (t = e.attributeName) || void 0 === t ? void 0 : t.startsWith("data-tooltip-"))) return;
                const o = Le(i);
                Re(o);
            });
        }), a = {
            attributes: !0,
            childList: !1,
            subtree: !1
        };
        if (i) {
            const e = Le(i);
            Re(e), s.observe(i, a);
        }
        return ()=>{
            s.disconnect();
        };
    }, [
        ke,
        Ce,
        _e,
        r,
        n
    ]), (0, $kc00y.useEffect)(()=>{
        (null == z ? void 0 : z.border) && console.warn("[react-tooltip] Do not set `style.border`. Use `border` prop instead."), V && !$b3ac8be866894793$var$A("border", `${V}`) && console.warn(`[react-tooltip] "${V}" is not a valid \`border\`.`), (null == z ? void 0 : z.opacity) && console.warn("[react-tooltip] Do not set `style.opacity`. Use `opacity` prop instead."), F && !$b3ac8be866894793$var$A("opacity", `${F}`) && console.warn(`[react-tooltip] "${F}" is not a valid \`opacity\`.`);
    }, []);
    let xe = h;
    const Ne = (0, $kc00y.useRef)(null);
    if (a) {
        const t = a({
            content: (null == _e ? void 0 : _e.getAttribute("data-tooltip-content")) || J || null,
            activeAnchor: _e
        });
        xe = t ? (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement("div", {
            ref: Ne,
            className: "react-tooltip-content-wrapper"
        }, t) : null;
    } else J && (xe = J);
    ee && (xe = (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement($b3ac8be866894793$var$q, {
        content: ee
    }));
    const $e = {
        forwardRef: Z,
        id: t,
        anchorId: r,
        anchorSelect: n,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($lgiU2)))(u, ge),
        classNameArrow: d,
        content: xe,
        contentWrapperRef: Ne,
        place: oe,
        variant: le,
        offset: ce,
        wrapper: ye,
        events: we,
        openOnClick: b,
        positionStrategy: Se,
        middlewares: E,
        delayShow: se,
        delayHide: ue,
        float: pe,
        hidden: me,
        noArrow: k,
        clickable: C,
        closeOnEsc: L,
        closeOnScroll: R,
        closeOnResize: x,
        openEvents: N,
        closeEvents: $,
        globalCloseEvents: j,
        imperativeModeOnly: B,
        style: z,
        position: H,
        isOpen: M,
        defaultIsOpen: W,
        border: V,
        opacity: F,
        arrowColor: K,
        setIsOpen: U,
        afterShow: X,
        afterHide: Y,
        activeAnchor: _e,
        setActiveAnchor: (e)=>Oe(e),
        role: G
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement($b3ac8be866894793$var$D, {
        ...$e
    });
});
"undefined" != typeof window && window.addEventListener("react-tooltip-inject-styles", (e)=>{
    e.detail.disableCore || $b3ac8be866894793$var$S({
        css: `:root{--rt-color-white:#fff;--rt-color-dark:#222;--rt-color-success:#8dc572;--rt-color-error:#be6464;--rt-color-warning:#f0ad4e;--rt-color-info:#337ab7;--rt-opacity:0.9;--rt-transition-show-delay:0.15s;--rt-transition-closing-delay:0.15s}.core-styles-module_tooltip__3vRRp{position:absolute;top:0;left:0;pointer-events:none;opacity:0;will-change:opacity}.core-styles-module_fixed__pcSol{position:fixed}.core-styles-module_arrow__cvMwQ{position:absolute;background:inherit}.core-styles-module_noArrow__xock6{display:none}.core-styles-module_clickable__ZuTTB{pointer-events:auto}.core-styles-module_show__Nt9eE{opacity:var(--rt-opacity);transition:opacity var(--rt-transition-show-delay)ease-out}.core-styles-module_closing__sGnxF{opacity:0;transition:opacity var(--rt-transition-closing-delay)ease-in}`,
        type: "core"
    }), e.detail.disableBase || $b3ac8be866894793$var$S({
        css: `
.styles-module_tooltip__mnnfp{padding:8px 16px;border-radius:3px;font-size:90%;width:max-content}.styles-module_arrow__K0L3T{width:8px;height:8px}[class*='react-tooltip__place-top']>.styles-module_arrow__K0L3T{transform:rotate(45deg)}[class*='react-tooltip__place-right']>.styles-module_arrow__K0L3T{transform:rotate(135deg)}[class*='react-tooltip__place-bottom']>.styles-module_arrow__K0L3T{transform:rotate(225deg)}[class*='react-tooltip__place-left']>.styles-module_arrow__K0L3T{transform:rotate(315deg)}.styles-module_dark__xNqje{background:var(--rt-color-dark);color:var(--rt-color-white)}.styles-module_light__Z6W-X{background-color:var(--rt-color-white);color:var(--rt-color-dark)}.styles-module_success__A2AKt{background-color:var(--rt-color-success);color:var(--rt-color-white)}.styles-module_warning__SCK0X{background-color:var(--rt-color-warning);color:var(--rt-color-white)}.styles-module_error__JvumD{background-color:var(--rt-color-error);color:var(--rt-color-white)}.styles-module_info__BWdHW{background-color:var(--rt-color-info);color:var(--rt-color-white)}`,
        type: "base"
    });
});

});
parcelRegister("ec262", function(module, exports) {
// shim for using process in browser
var $a553cffd36fe3594$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $a553cffd36fe3594$var$cachedSetTimeout;
var $a553cffd36fe3594$var$cachedClearTimeout;
function $a553cffd36fe3594$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $a553cffd36fe3594$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $a553cffd36fe3594$var$cachedSetTimeout = setTimeout;
        else $a553cffd36fe3594$var$cachedSetTimeout = $a553cffd36fe3594$var$defaultSetTimout;
    } catch (e) {
        $a553cffd36fe3594$var$cachedSetTimeout = $a553cffd36fe3594$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $a553cffd36fe3594$var$cachedClearTimeout = clearTimeout;
        else $a553cffd36fe3594$var$cachedClearTimeout = $a553cffd36fe3594$var$defaultClearTimeout;
    } catch (e) {
        $a553cffd36fe3594$var$cachedClearTimeout = $a553cffd36fe3594$var$defaultClearTimeout;
    }
})();
function $a553cffd36fe3594$var$runTimeout(fun) {
    if ($a553cffd36fe3594$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($a553cffd36fe3594$var$cachedSetTimeout === $a553cffd36fe3594$var$defaultSetTimout || !$a553cffd36fe3594$var$cachedSetTimeout) && setTimeout) {
        $a553cffd36fe3594$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $a553cffd36fe3594$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $a553cffd36fe3594$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $a553cffd36fe3594$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $a553cffd36fe3594$var$runClearTimeout(marker) {
    if ($a553cffd36fe3594$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($a553cffd36fe3594$var$cachedClearTimeout === $a553cffd36fe3594$var$defaultClearTimeout || !$a553cffd36fe3594$var$cachedClearTimeout) && clearTimeout) {
        $a553cffd36fe3594$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $a553cffd36fe3594$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $a553cffd36fe3594$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $a553cffd36fe3594$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $a553cffd36fe3594$var$queue = [];
var $a553cffd36fe3594$var$draining = false;
var $a553cffd36fe3594$var$currentQueue;
var $a553cffd36fe3594$var$queueIndex = -1;
function $a553cffd36fe3594$var$cleanUpNextTick() {
    if (!$a553cffd36fe3594$var$draining || !$a553cffd36fe3594$var$currentQueue) return;
    $a553cffd36fe3594$var$draining = false;
    if ($a553cffd36fe3594$var$currentQueue.length) $a553cffd36fe3594$var$queue = $a553cffd36fe3594$var$currentQueue.concat($a553cffd36fe3594$var$queue);
    else $a553cffd36fe3594$var$queueIndex = -1;
    if ($a553cffd36fe3594$var$queue.length) $a553cffd36fe3594$var$drainQueue();
}
function $a553cffd36fe3594$var$drainQueue() {
    if ($a553cffd36fe3594$var$draining) return;
    var timeout = $a553cffd36fe3594$var$runTimeout($a553cffd36fe3594$var$cleanUpNextTick);
    $a553cffd36fe3594$var$draining = true;
    var len = $a553cffd36fe3594$var$queue.length;
    while(len){
        $a553cffd36fe3594$var$currentQueue = $a553cffd36fe3594$var$queue;
        $a553cffd36fe3594$var$queue = [];
        while(++$a553cffd36fe3594$var$queueIndex < len)if ($a553cffd36fe3594$var$currentQueue) $a553cffd36fe3594$var$currentQueue[$a553cffd36fe3594$var$queueIndex].run();
        $a553cffd36fe3594$var$queueIndex = -1;
        len = $a553cffd36fe3594$var$queue.length;
    }
    $a553cffd36fe3594$var$currentQueue = null;
    $a553cffd36fe3594$var$draining = false;
    $a553cffd36fe3594$var$runClearTimeout(timeout);
}
$a553cffd36fe3594$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $a553cffd36fe3594$var$queue.push(new $a553cffd36fe3594$var$Item(fun, args));
    if ($a553cffd36fe3594$var$queue.length === 1 && !$a553cffd36fe3594$var$draining) $a553cffd36fe3594$var$runTimeout($a553cffd36fe3594$var$drainQueue);
};
// v8 likes predictible objects
function $a553cffd36fe3594$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$a553cffd36fe3594$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$a553cffd36fe3594$var$process.title = "browser";
$a553cffd36fe3594$var$process.browser = true;
$a553cffd36fe3594$var$process.env = {};
$a553cffd36fe3594$var$process.argv = [];
$a553cffd36fe3594$var$process.version = ""; // empty string to avoid regexp issues
$a553cffd36fe3594$var$process.versions = {};
function $a553cffd36fe3594$var$noop() {}
$a553cffd36fe3594$var$process.on = $a553cffd36fe3594$var$noop;
$a553cffd36fe3594$var$process.addListener = $a553cffd36fe3594$var$noop;
$a553cffd36fe3594$var$process.once = $a553cffd36fe3594$var$noop;
$a553cffd36fe3594$var$process.off = $a553cffd36fe3594$var$noop;
$a553cffd36fe3594$var$process.removeListener = $a553cffd36fe3594$var$noop;
$a553cffd36fe3594$var$process.removeAllListeners = $a553cffd36fe3594$var$noop;
$a553cffd36fe3594$var$process.emit = $a553cffd36fe3594$var$noop;
$a553cffd36fe3594$var$process.prependListener = $a553cffd36fe3594$var$noop;
$a553cffd36fe3594$var$process.prependOnceListener = $a553cffd36fe3594$var$noop;
$a553cffd36fe3594$var$process.listeners = function(name) {
    return [];
};
$a553cffd36fe3594$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$a553cffd36fe3594$var$process.cwd = function() {
    return "/";
};
$a553cffd36fe3594$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$a553cffd36fe3594$var$process.umask = function() {
    return 0;
};

});


parcelRegister("cywK3", function(module, exports) {

$parcel$export(module.exports, "default", () => $6dd388b6bfc4a518$export$2e2bcd8739ae039);

var $cKvYK = parcelRequire("cKvYK");

var $lgiU2 = parcelRequire("lgiU2");

var $kc00y = parcelRequire("kc00y");

var $bkJfK = parcelRequire("bkJfK");

var $ijxZJ = parcelRequire("ijxZJ");

var $bYYyU = parcelRequire("bYYyU");

var $jR0Gp = parcelRequire("jR0Gp");
const $6dd388b6bfc4a518$var$Stepper = ({ steps: steps, getInitialValues: getInitialValues, prepareVariables: prepareVariables, validationSchema: validationSchema })=>{
    const [activeStep, setActiveStep] = (0, $kc00y.useState)(steps[0]);
    const [previousStep, setPreviousStep] = (0, $kc00y.useState)(null);
    const [nextStep, setNextStep] = (0, $kc00y.useState)(steps[1] ?? null);
    const [, setIconActiveStep] = (0, $kc00y.useState)(null);
    return /*#__PURE__*/ (0, $cKvYK.jsx)("div", {
        children: steps.map((step, key)=>/*#__PURE__*/ (0, $cKvYK.jsx)("div", {
                children: /*#__PURE__*/ (0, $cKvYK.jsx)($6dd388b6bfc4a518$export$fd55ce593607084a, {
                    step: step,
                    steps: steps,
                    activeStep: activeStep,
                    previousStep: previousStep,
                    nextStep: nextStep,
                    setActiveStep: setActiveStep,
                    setPreviousStep: setPreviousStep,
                    setNextStep: setNextStep,
                    getInitialValues: getInitialValues,
                    prepareVariables: prepareVariables,
                    validationSchema: validationSchema,
                    setIconActiveStep: setIconActiveStep
                })
            }, key))
    });
};
var $6dd388b6bfc4a518$export$2e2bcd8739ae039 = $6dd388b6bfc4a518$var$Stepper;
const $6dd388b6bfc4a518$export$fd55ce593607084a = ({ step: step, steps: steps, activeStep: activeStep, previousStep: previousStep, nextStep: nextStep, setActiveStep: setActiveStep, setPreviousStep: setPreviousStep, setNextStep: setNextStep, getInitialValues: getInitialValues, prepareVariables: prepareVariables, validationSchema: validationSchema, setIconActiveStep: setIconActiveStep })=>{
    const { title: title, content: content, useFormik: useFormik, submitUrl: submitUrl, skippable: skippable, icon: icon } = step;
    return /*#__PURE__*/ (0, $cKvYK.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $cKvYK.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($jR0Gp))).header,
                children: [
                    /*#__PURE__*/ (0, $cKvYK.jsxs)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($jR0Gp))).align,
                        children: [
                            /*#__PURE__*/ (0, $cKvYK.jsx)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($lgiU2)))((0, (/*@__PURE__*/$parcel$interopDefault($jR0Gp))).index, {
                                    [(0, (/*@__PURE__*/$parcel$interopDefault($jR0Gp))).active]: activeStep === step
                                }),
                                children: steps.findIndex((e)=>e === step) + 1
                            }),
                            /*#__PURE__*/ (0, $cKvYK.jsxs)("h2", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($jR0Gp))).title,
                                children: [
                                    title,
                                    " ",
                                    icon
                                ]
                            })
                        ]
                    }),
                    activeStep === step && skippable && /*#__PURE__*/ (0, $cKvYK.jsx)((0, $bYYyU.default), {
                        variant: (0, $bYYyU.VARIANTS).primary,
                        onClick: ()=>{
                            setActiveStep(nextStep);
                            setPreviousStep(activeStep);
                            setNextStep(steps.findIndex((s)=>s === activeStep) + 2 <= steps.length - 1 ? steps[steps.findIndex((s)=>s === activeStep) + 2] : null);
                            step.icon = /*#__PURE__*/ (0, $cKvYK.jsx)("span", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($jR0Gp))).nok,
                                children: " \u274C"
                            });
                            setIconActiveStep(/*#__PURE__*/ (0, $cKvYK.jsx)("span", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($jR0Gp))).nok,
                                children: " \u274C"
                            }));
                        },
                        children: "Ignorer cette \xe9tape"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cKvYK.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($jR0Gp))).container,
                children: /*#__PURE__*/ (0, $cKvYK.jsx)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($jR0Gp))).borderLeft,
                    children: activeStep === step && /*#__PURE__*/ (0, $cKvYK.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($jR0Gp))).open,
                        children: useFormik === true ? /*#__PURE__*/ (0, $cKvYK.jsx)((0, $ijxZJ.default), {
                            initialValues: getInitialValues(),
                            validationSchema: validationSchema,
                            prepareVariables: prepareVariables,
                            submitUrl: submitUrl,
                            isMultipartFormData: true,
                            onSubmit: ()=>{
                                setActiveStep(nextStep);
                                setPreviousStep(activeStep);
                                setNextStep(steps.findIndex((s)=>s === activeStep) + 2 <= steps.length - 1 ? steps[steps.findIndex((s)=>s === activeStep) + 2] : null);
                                step.icon = /*#__PURE__*/ (0, $cKvYK.jsx)("span", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($jR0Gp))).ok,
                                    children: "\u2713"
                                });
                                setIconActiveStep(/*#__PURE__*/ (0, $cKvYK.jsx)((0, $cKvYK.Fragment), {
                                    children: "\u2713"
                                }));
                            },
                            initialStatus: undefined,
                            isPost: false,
                            redirectUrl: "",
                            afficheLog: true,
                            children: /*#__PURE__*/ (0, $cKvYK.jsxs)((0, $bkJfK.Form), {
                                children: [
                                    content,
                                    /*#__PURE__*/ (0, $cKvYK.jsxs)("nav", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($jR0Gp))).navigation,
                                        children: [
                                            /*#__PURE__*/ (0, $cKvYK.jsx)((0, $bYYyU.default), {
                                                variant: (0, $bYYyU.VARIANTS).primary,
                                                onClick: ()=>{
                                                    setActiveStep(previousStep);
                                                    setPreviousStep(steps.findIndex((s)=>s === activeStep) - 2 >= 0 ? steps[steps.findIndex((e)=>e === activeStep) - 2] : null);
                                                    setNextStep(activeStep);
                                                },
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($jR0Gp))).precedent,
                                                disabled: steps.findIndex((e)=>e === activeStep) - 1 < 0,
                                                children: "Pr\xe9c\xe9dent"
                                            }),
                                            /*#__PURE__*/ (0, $cKvYK.jsx)((0, $bYYyU.default), {
                                                variant: (0, $bYYyU.VARIANTS).primary,
                                                type: (0, $bYYyU.TYPE_BUTTON).submit,
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($jR0Gp))).suivant,
                                                disabled: steps.findIndex((e)=>e === activeStep) + 1 >= steps.length,
                                                children: "Suivant"
                                            })
                                        ]
                                    })
                                ]
                            })
                        }) : !useFormik ? /*#__PURE__*/ (0, $cKvYK.jsxs)((0, $cKvYK.Fragment), {
                            children: [
                                content,
                                /*#__PURE__*/ (0, $cKvYK.jsxs)("nav", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($jR0Gp))).navigation,
                                    children: [
                                        steps.findIndex((e)=>e === activeStep) - 1 > 0 || steps.findIndex((e)=>e === activeStep) === steps.length - 1 && /*#__PURE__*/ (0, $cKvYK.jsx)((0, $bYYyU.default), {
                                            variant: (0, $bYYyU.VARIANTS).primary,
                                            onClick: ()=>{
                                                setActiveStep(previousStep);
                                                setPreviousStep(steps.findIndex((s)=>s === activeStep) - 2 >= 0 ? steps[steps.findIndex((e)=>e === activeStep) - 2] : null);
                                                setNextStep(activeStep);
                                            },
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($jR0Gp))).precedent,
                                            disabled: steps.findIndex((e)=>e === activeStep) - 1 < 0,
                                            children: "Pr\xe9c\xe9dent"
                                        }),
                                        steps.findIndex((e)=>e === activeStep) + 1 < steps.length && /*#__PURE__*/ (0, $cKvYK.jsx)((0, $bYYyU.default), {
                                            variant: (0, $bYYyU.VARIANTS).primary,
                                            onClick: ()=>{
                                                setActiveStep(nextStep);
                                                setPreviousStep(activeStep);
                                                setNextStep(steps.findIndex((s)=>s === activeStep) + 2 <= steps.length - 1 ? steps[steps.findIndex((s)=>s === activeStep) + 2] : null);
                                                step.icon = /*#__PURE__*/ (0, $cKvYK.jsx)("span", {
                                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($jR0Gp))).ok,
                                                    children: "\u2713"
                                                });
                                                setIconActiveStep(/*#__PURE__*/ (0, $cKvYK.jsx)((0, $cKvYK.Fragment), {
                                                    children: "\u2713"
                                                }));
                                            },
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($jR0Gp))).suivant,
                                            disabled: steps.findIndex((e)=>e === activeStep) + 1 >= steps.length,
                                            children: "Suivant"
                                        })
                                    ]
                                })
                            ]
                        }) : ""
                    })
                })
            })
        ]
    });
};

});
parcelRegister("jR0Gp", function(module, exports) {

$parcel$export(module.exports, "active", () => $e7437f354adfc546$export$89da14300d534261, (v) => $e7437f354adfc546$export$89da14300d534261 = v);
$parcel$export(module.exports, "align", () => $e7437f354adfc546$export$9ea32abc1be18076, (v) => $e7437f354adfc546$export$9ea32abc1be18076 = v);
$parcel$export(module.exports, "borderLeft", () => $e7437f354adfc546$export$47658cca1a909427, (v) => $e7437f354adfc546$export$47658cca1a909427 = v);
$parcel$export(module.exports, "container", () => $e7437f354adfc546$export$34e0f9847d4c02dd, (v) => $e7437f354adfc546$export$34e0f9847d4c02dd = v);
$parcel$export(module.exports, "header", () => $e7437f354adfc546$export$38e42c68cf43b5d4, (v) => $e7437f354adfc546$export$38e42c68cf43b5d4 = v);
$parcel$export(module.exports, "index", () => $e7437f354adfc546$export$b610b8812bbcded9, (v) => $e7437f354adfc546$export$b610b8812bbcded9 = v);
$parcel$export(module.exports, "navigation", () => $e7437f354adfc546$export$428e7c787d57587d, (v) => $e7437f354adfc546$export$428e7c787d57587d = v);
$parcel$export(module.exports, "nok", () => $e7437f354adfc546$export$49f06f24404ef71, (v) => $e7437f354adfc546$export$49f06f24404ef71 = v);
$parcel$export(module.exports, "ok", () => $e7437f354adfc546$export$dcb8b3f0e2de7e49, (v) => $e7437f354adfc546$export$dcb8b3f0e2de7e49 = v);
$parcel$export(module.exports, "open", () => $e7437f354adfc546$export$3ce6949f20cea765, (v) => $e7437f354adfc546$export$3ce6949f20cea765 = v);
$parcel$export(module.exports, "title", () => $e7437f354adfc546$export$fb184b623420d9be, (v) => $e7437f354adfc546$export$fb184b623420d9be = v);
var $e7437f354adfc546$export$89da14300d534261;
var $e7437f354adfc546$export$9ea32abc1be18076;
var $e7437f354adfc546$export$47658cca1a909427;
var $e7437f354adfc546$export$34e0f9847d4c02dd;
var $e7437f354adfc546$export$38e42c68cf43b5d4;
var $e7437f354adfc546$export$b610b8812bbcded9;
var $e7437f354adfc546$export$428e7c787d57587d;
var $e7437f354adfc546$export$49f06f24404ef71;
var $e7437f354adfc546$export$dcb8b3f0e2de7e49;
var $e7437f354adfc546$export$3ce6949f20cea765;
var $e7437f354adfc546$export$fb184b623420d9be;
$e7437f354adfc546$export$89da14300d534261 = `caH9FW_active`;
$e7437f354adfc546$export$9ea32abc1be18076 = `caH9FW_align`;
$e7437f354adfc546$export$47658cca1a909427 = `caH9FW_borderLeft`;
$e7437f354adfc546$export$34e0f9847d4c02dd = `caH9FW_container`;
$e7437f354adfc546$export$38e42c68cf43b5d4 = `caH9FW_header`;
$e7437f354adfc546$export$b610b8812bbcded9 = `caH9FW_index`;
$e7437f354adfc546$export$428e7c787d57587d = `caH9FW_navigation`;
$e7437f354adfc546$export$49f06f24404ef71 = `caH9FW_nok`;
$e7437f354adfc546$export$dcb8b3f0e2de7e49 = `caH9FW_ok`;
$e7437f354adfc546$export$3ce6949f20cea765 = `caH9FW_open`;
$e7437f354adfc546$export$fb184b623420d9be = `caH9FW_title`;

});


parcelRegister("dbHqx", function(module, exports) {

$parcel$export(module.exports, "content", () => $999dfd2919e47798$export$a7db06668cad9adb, (v) => $999dfd2919e47798$export$a7db06668cad9adb = v);
$parcel$export(module.exports, "detail", () => $999dfd2919e47798$export$13a2d28b88853ef2, (v) => $999dfd2919e47798$export$13a2d28b88853ef2 = v);
$parcel$export(module.exports, "export", () => $999dfd2919e47798$export$5faec355c22dc11f, (v) => $999dfd2919e47798$export$5faec355c22dc11f = v);
$parcel$export(module.exports, "icon", () => $999dfd2919e47798$export$1ca1ec8b29a4ce27, (v) => $999dfd2919e47798$export$1ca1ec8b29a4ce27 = v);
$parcel$export(module.exports, "iconEtape", () => $999dfd2919e47798$export$28e24e8077259aa5, (v) => $999dfd2919e47798$export$28e24e8077259aa5 = v);
$parcel$export(module.exports, "instruction", () => $999dfd2919e47798$export$76e224aa2fb0aee8, (v) => $999dfd2919e47798$export$76e224aa2fb0aee8 = v);
$parcel$export(module.exports, "obligatoire", () => $999dfd2919e47798$export$70baf9ce46a106db, (v) => $999dfd2919e47798$export$70baf9ce46a106db = v);
$parcel$export(module.exports, "pagetitle", () => $999dfd2919e47798$export$86a7b0cc2e253e5c, (v) => $999dfd2919e47798$export$86a7b0cc2e253e5c = v);
$parcel$export(module.exports, "title", () => $999dfd2919e47798$export$fb184b623420d9be, (v) => $999dfd2919e47798$export$fb184b623420d9be = v);
var $999dfd2919e47798$export$a7db06668cad9adb;
var $999dfd2919e47798$export$13a2d28b88853ef2;
var $999dfd2919e47798$export$5faec355c22dc11f;
var $999dfd2919e47798$export$1ca1ec8b29a4ce27;
var $999dfd2919e47798$export$28e24e8077259aa5;
var $999dfd2919e47798$export$76e224aa2fb0aee8;
var $999dfd2919e47798$export$70baf9ce46a106db;
var $999dfd2919e47798$export$86a7b0cc2e253e5c;
var $999dfd2919e47798$export$fb184b623420d9be;
$999dfd2919e47798$export$a7db06668cad9adb = `mk8HsG_content`;
$999dfd2919e47798$export$13a2d28b88853ef2 = `mk8HsG_detail`;
$999dfd2919e47798$export$5faec355c22dc11f = `mk8HsG_export`;
$999dfd2919e47798$export$1ca1ec8b29a4ce27 = `mk8HsG_icon`;
$999dfd2919e47798$export$28e24e8077259aa5 = `mk8HsG_iconEtape`;
$999dfd2919e47798$export$76e224aa2fb0aee8 = `mk8HsG_instruction`;
$999dfd2919e47798$export$70baf9ce46a106db = `mk8HsG_obligatoire`;
$999dfd2919e47798$export$86a7b0cc2e253e5c = `mk8HsG_pagetitle`;
$999dfd2919e47798$export$fb184b623420d9be = `mk8HsG_title`;

});


parcelRegister("3fKb9", function(module, exports) {

$parcel$export(module.exports, "default", () => $a03342d797a27540$export$2e2bcd8739ae039);

var $cKvYK = parcelRequire("cKvYK");

var $5TbRy = parcelRequire("5TbRy");

var $bNJBP = parcelRequire("bNJBP");

var $4VCRM = parcelRequire("4VCRM");

var $hpOSz = parcelRequire("hpOSz");

var $evPIN = parcelRequire("evPIN");

var $6Sma1 = parcelRequire("6Sma1");

var $hplX1 = parcelRequire("hplX1");

var $8p7Tx = parcelRequire("8p7Tx");

var $aiICO = parcelRequire("aiICO");
const $a03342d797a27540$var$GestionRessources = ()=>{
    return /*#__PURE__*/ (0, $cKvYK.jsxs)((0, $cKvYK.Fragment), {
        children: [
            /*#__PURE__*/ (0, $cKvYK.jsx)((0, $4VCRM.default), {
                icon: /*#__PURE__*/ (0, $cKvYK.jsx)((0, $hpOSz.IconBookCopy), {}),
                title: "Gestion des contenus"
            }),
            /*#__PURE__*/ (0, $cKvYK.jsx)((0, $bNJBP.PageContent), {
                children: /*#__PURE__*/ (0, $cKvYK.jsx)((0, $evPIN.default), {
                    idName: "ressources",
                    query: (0, $5TbRy.default)`/api/ressource/`,
                    filterComponent: /*#__PURE__*/ (0, $cKvYK.jsx)((0, $8p7Tx.default), {}),
                    initialFilterValues: (0, $8p7Tx.initialFilterValues),
                    filterValuesToVariable: (0, $8p7Tx.filterValuesToVariable),
                    columns: [
                        {
                            Header: "Code",
                            accessor: "ressourceCode",
                            sortField: "ressourceCode"
                        },
                        {
                            Header: "Titre",
                            accessor: "ressourceLibelle",
                            sortField: "ressourceLibelle"
                        },
                        {
                            Header: "Type de contenu",
                            accessor: "typeRessourceLibelle",
                            sortField: "typeRessourceLibelle"
                        },
                        {
                            Header: "Nom du fichier",
                            accessor: "ressourceNomFichier",
                            sortField: "ressourceNomFichier"
                        },
                        {
                            Header: "Action",
                            accessor: ({ ressourceCode: ressourceCode, typeRessourceCode: typeRessourceCode, ressourcePrivee: ressourcePrivee, ressourceId: ressourceId, ressourceLibelle: ressourceLibelle, ressourceDescription: ressourceDescription, typeRessourceId: typeRessourceId, ressourceTelechargeable: ressourceTelechargeable })=>{
                                return {
                                    ressourceCode: ressourceCode,
                                    typeRessourceCode: typeRessourceCode,
                                    ressourcePrivee: ressourcePrivee,
                                    ressourceId: ressourceId,
                                    ressourceLibelle: ressourceLibelle,
                                    ressourceDescription: ressourceDescription,
                                    typeRessourceId: typeRessourceId,
                                    ressourceTelechargeable: ressourceTelechargeable
                                };
                            },
                            Cell: (row)=>{
                                return /*#__PURE__*/ (0, $cKvYK.jsx)((0, $cKvYK.Fragment), {
                                    children: /*#__PURE__*/ (0, $cKvYK.jsxs)("div", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($aiICO))).buttonsDiv,
                                        children: [
                                            /*#__PURE__*/ (0, $cKvYK.jsx)((0, $6Sma1.PreviewColumn), {
                                                ressourceCode: row.value.ressourceCode,
                                                ressourceType: row.value.typeRessourceCode,
                                                ressourcePrivee: row.value.ressourcePrivee
                                            }),
                                            /*#__PURE__*/ (0, $cKvYK.jsx)((0, $hplX1.default), {
                                                ressourceId: row.value.ressourceId,
                                                ressourceLibelle: row.value.ressourceLibelle,
                                                ressourceDescription: row.value.ressourceDescription,
                                                typeRessourceId: row.value.typeRessourceId,
                                                typeRessource: row.value.typeRessource,
                                                file: row.value.file,
                                                previewFile: row.value.previewFile,
                                                ressourceTelechargeable: row.value.ressourceTelechargeable
                                            })
                                        ]
                                    })
                                });
                            },
                            width: 100
                        }
                    ]
                })
            })
        ]
    });
};
var $a03342d797a27540$export$2e2bcd8739ae039 = $a03342d797a27540$var$GestionRessources;

});
parcelRegister("evPIN", function(module, exports) {

$parcel$export(module.exports, "default", () => $160f1b027cee3d2c$export$2e2bcd8739ae039);

var $cKvYK = parcelRequire("cKvYK");

var $kc00y = parcelRequire("kc00y");
parcelRequire("w7gBZ");
var $aw9wE = parcelRequire("aw9wE");

var $bkJfK = parcelRequire("bkJfK");

var $cw5lu = parcelRequire("cw5lu");

var $c67Lz = parcelRequire("c67Lz");

var $3WzC8 = parcelRequire("3WzC8");

var $lSohi = parcelRequire("lSohi");

var $e2QwP = parcelRequire("e2QwP");

var $YTww9 = parcelRequire("YTww9");
const $160f1b027cee3d2c$var$useHistoryPush = (filterByState, sortByState, paginationState, filterValuesToVariable)=>{
    const navigate = (0, $aw9wE.useNavigate)();
    const location = (0, $aw9wE.useLocation)();
    const [, setFilterBy] = filterByState;
    const [sortBy] = sortByState;
    const [pagination, setPagination] = paginationState;
    const historyPush = (values)=>{
        const f = filterValuesToVariable(values);
        const filter = Object.values(f).filter(Boolean).length ? JSON.stringify(f) : null;
        const sort = Object.values(sortBy).filter(Boolean).length ? JSON.stringify(sortBy) : null;
        const searchParams = new URLSearchParams(document.location?.search);
        if (filter !== searchParams.get("filterBy") || sort !== searchParams.get("sortBy")) {
            if (filter) searchParams.set("filterBy", filter);
            else searchParams.delete("filterBy");
            if (sort) searchParams.set("sortBy", sort);
            else searchParams.delete("sortBy");
            searchParams.set("limit", pagination.limit);
            searchParams.set("offset", pagination.offset ?? "0");
            navigate({
                pathname: location.pathname,
                search: decodeURIComponent(searchParams.toString())
            });
            setFilterBy(filterValuesToVariable(values));
            // Si on change de filtres, on se remet à la première page
            setPagination({
                offset: 0,
                limit: pagination.limit
            });
        } else if (searchParams.get("offset") !== pagination.offset.toString() || searchParams.get("limit") !== pagination.limit.toString()) {
            searchParams.set("limit", pagination.limit);
            searchParams.set("offset", pagination.offset ?? "0");
            navigate({
                pathname: location.pathname,
                search: decodeURIComponent(searchParams.toString())
            }, {
                replace: true
            });
        }
    };
    return [
        historyPush
    ];
};
const $160f1b027cee3d2c$export$5da34dbeeb302c0 = ({ filterComponent: filterComponent, filterValuesToVariable: filterValuesToVariable, watchedValues: watchedValues = [], initializer: initializer, filterByState: filterByState, sortByState: sortByState, paginationState: paginationState, historyPush: historyPush, isAutoSubmit: isAutoSubmit })=>{
    const location = (0, $aw9wE.useLocation)();
    const { values: values, setValues: setValues } = (0, $bkJfK.useFormikContext)();
    const [, setFilterBy] = filterByState;
    const [sortBy, setSortBy] = sortByState;
    const [pagination, setPagination] = paginationState;
    const { callback: debounceSearch } = (0, $cw5lu.default)(()=>historyPush(values), 500);
    (0, $kc00y.useEffect)(()=>{
        if (isAutoSubmit) debounceSearch();
    }, [
        isAutoSubmit,
        values,
        debounceSearch
    ]);
    (0, $kc00y.useEffect)(()=>{
        historyPush(values);
    }, [
        sortBy,
        pagination.offset,
        pagination.limit,
        ...watchedValues
    ]);
    (0, $kc00y.useEffect)(()=>{
        const searchParams = new URLSearchParams(document.location?.search);
        const filterByParams = searchParams.get("filterBy");
        const sortByParams = searchParams.get("sortBy");
        const offsetParams = searchParams.get("offset");
        const limitParams = searchParams.get("limit");
        if (filterByParams || !filterByParams && values) {
            const filteredValues = filterValuesToVariable(values);
            const filter = Object.values(filteredValues).filter(Boolean).length ? JSON.stringify(filteredValues) : null;
            if (filter !== filterByParams) {
                initializer && setValues(initializer(JSON.parse(filterByParams) ?? {}));
                setFilterBy(filteredValues);
            }
        }
        if (sortByParams || !sortByParams && sortBy) {
            const sort = Object.values(sortBy).filter(Boolean).length ? JSON.stringify(sortBy) : null;
            if (sort !== sortByParams) setSortBy(JSON.parse(sortByParams) ?? {});
        }
        if (offsetParams && limitParams && (offsetParams !== pagination.offset.toString() || limitParams !== pagination.limit.toString())) setPagination({
            offset: offsetParams,
            limit: limitParams
        });
    }, [
        location
    ]);
    return /*#__PURE__*/ (0, $cKvYK.jsx)((0, $cKvYK.Fragment), {
        children: filterComponent
    });
};
const $160f1b027cee3d2c$var$QueryTableWithFilter = ({ initialFilterValues: initialFilterValues, initializer: initializer = (data)=>data, filterValuesToVariable: filterValuesToVariable, watchedValues: watchedValues = [], trClassName: trClassName, nomPage: nomPage, filterComponent: filterComponent, titreSticky: titreSticky, stickyRight: stickyRight, isAutoSubmit: isAutoSubmit = true, ...props })=>{
    const initialValues = {
        ...initialFilterValues,
        ...initializer((0, $c67Lz.default)()["filterBy"] ?? {})
    };
    const [filterBy, setFilterBy] = (0, $kc00y.useState)(filterValuesToVariable(initialValues));
    const [sortBy, setSortBy] = (0, $e2QwP.useSortBy)();
    const [pagination, setPagination] = (0, $lSohi.usePaginationState)();
    const [historyPush] = $160f1b027cee3d2c$var$useHistoryPush([
        filterBy,
        setFilterBy
    ], [
        sortBy,
        setSortBy
    ], [
        pagination,
        setPagination
    ], filterValuesToVariable);
    return /*#__PURE__*/ (0, $cKvYK.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($YTww9))).queryTableFilterWrapper,
        children: /*#__PURE__*/ (0, $cKvYK.jsx)((0, $bkJfK.Formik), {
            initialValues: initialValues,
            validateOnChange: false,
            validateOnBlur: false,
            onSubmit: (values)=>{
                historyPush(values);
            },
            children: /*#__PURE__*/ (0, $cKvYK.jsxs)((0, $cKvYK.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $cKvYK.jsx)($160f1b027cee3d2c$export$5da34dbeeb302c0, {
                        ...props,
                        filterByState: [
                            filterBy,
                            setFilterBy
                        ],
                        sortByState: [
                            sortBy,
                            setSortBy
                        ],
                        paginationState: [
                            pagination,
                            setPagination
                        ],
                        filterValuesToVariable: filterValuesToVariable,
                        watchedValues: watchedValues,
                        initializer: (values)=>{
                            return {
                                ...initialFilterValues,
                                ...initializer(values)
                            };
                        },
                        filterComponent: filterComponent,
                        historyPush: historyPush,
                        isAutoSubmit: isAutoSubmit
                    }),
                    /*#__PURE__*/ (0, $cKvYK.jsx)((0, $3WzC8._QueryTable), {
                        filterBy: filterBy,
                        sortByState: [
                            sortBy,
                            setSortBy
                        ],
                        paginationState: [
                            pagination,
                            setPagination
                        ],
                        trClassName: trClassName,
                        nomPage: nomPage,
                        titreSticky: titreSticky,
                        stickyRight: stickyRight === "Filter" ? filterComponent : stickyRight,
                        ...props
                    })
                ]
            })
        })
    });
};
var $160f1b027cee3d2c$export$2e2bcd8739ae039 = $160f1b027cee3d2c$var$QueryTableWithFilter;

});
parcelRegister("cw5lu", function(module, exports) {

$parcel$export(module.exports, "default", () => $025a028f546f69bb$export$2e2bcd8739ae039);

var $kc00y = parcelRequire("kc00y");
function $025a028f546f69bb$export$2e2bcd8739ae039(func, wait, options) {
    var _this = this;
    var lastCallTime = (0, $kc00y.useRef)(null);
    var lastInvokeTime = (0, $kc00y.useRef)(0);
    var timerId = (0, $kc00y.useRef)(null);
    var lastArgs = (0, $kc00y.useRef)([]);
    var lastThis = (0, $kc00y.useRef)();
    var result = (0, $kc00y.useRef)();
    var funcRef = (0, $kc00y.useRef)(func);
    var mounted = (0, $kc00y.useRef)(true);
    funcRef.current = func;
    // Bypass `requestAnimationFrame` by explicitly setting `wait=0`.
    var useRAF = !wait && wait !== 0 && typeof window !== "undefined";
    if (typeof func !== "function") throw new TypeError("Expected a function");
    wait = +wait || 0;
    options = options || {};
    var leading = !!options.leading;
    var trailing = "trailing" in options ? !!options.trailing : true; // `true` by default
    var maxing = "maxWait" in options;
    var maxWait = maxing ? Math.max(+options.maxWait || 0, wait) : null;
    var invokeFunc = (0, $kc00y.useCallback)(function(time) {
        var args = lastArgs.current;
        var thisArg = lastThis.current;
        lastArgs.current = lastThis.current = null;
        lastInvokeTime.current = time;
        return result.current = funcRef.current.apply(thisArg, args);
    }, []);
    var startTimer = (0, $kc00y.useCallback)(function(pendingFunc, wait) {
        if (useRAF) cancelAnimationFrame(timerId.current);
        timerId.current = useRAF ? requestAnimationFrame(pendingFunc) : setTimeout(pendingFunc, wait);
    }, [
        useRAF
    ]);
    var shouldInvoke = (0, $kc00y.useCallback)(function(time) {
        if (!mounted.current) return false;
        var timeSinceLastCall = time - lastCallTime.current;
        var timeSinceLastInvoke = time - lastInvokeTime.current;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return !lastCallTime.current || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }, [
        maxWait,
        maxing,
        wait
    ]);
    var trailingEdge = (0, $kc00y.useCallback)(function(time) {
        timerId.current = null;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs.current) return invokeFunc(time);
        lastArgs.current = lastThis.current = null;
        return result.current;
    }, [
        invokeFunc,
        trailing
    ]);
    var timerExpired = (0, $kc00y.useCallback)(function() {
        var time = Date.now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // https://github.com/xnimorz/use-debounce/issues/97
        if (!mounted.current) return;
        // Remaining wait calculation
        var timeSinceLastCall = time - lastCallTime.current;
        var timeSinceLastInvoke = time - lastInvokeTime.current;
        var timeWaiting = wait - timeSinceLastCall;
        var remainingWait = maxing ? Math.min(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
        // Restart the timer
        startTimer(timerExpired, remainingWait);
    }, [
        maxWait,
        maxing,
        shouldInvoke,
        startTimer,
        trailingEdge,
        wait
    ]);
    var cancel = (0, $kc00y.useCallback)(function() {
        if (timerId.current) useRAF ? cancelAnimationFrame(timerId.current) : clearTimeout(timerId.current);
        lastInvokeTime.current = 0;
        lastArgs.current = lastCallTime.current = lastThis.current = timerId.current = null;
    }, [
        useRAF
    ]);
    var flush = (0, $kc00y.useCallback)(function() {
        return !timerId.current ? result.current : trailingEdge(Date.now());
    }, [
        trailingEdge
    ]);
    (0, $kc00y.useEffect)(function() {
        mounted.current = true;
        return function() {
            mounted.current = false;
        };
    }, []);
    var debounced = (0, $kc00y.useCallback)(function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var time = Date.now();
        var isInvoking = shouldInvoke(time);
        lastArgs.current = args;
        lastThis.current = _this;
        lastCallTime.current = time;
        if (isInvoking) {
            if (!timerId.current && mounted.current) {
                // Reset any `maxWait` timer.
                lastInvokeTime.current = lastCallTime.current;
                // Start the timer for the trailing edge.
                startTimer(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(lastCallTime.current) : result.current;
            }
            if (maxing) {
                // Handle invocations in a tight loop.
                startTimer(timerExpired, wait);
                return invokeFunc(lastCallTime.current);
            }
        }
        if (!timerId.current) startTimer(timerExpired, wait);
        return result.current;
    }, [
        invokeFunc,
        leading,
        maxing,
        shouldInvoke,
        startTimer,
        timerExpired,
        wait
    ]);
    var pending = (0, $kc00y.useCallback)(function() {
        return !!timerId.current;
    }, []);
    var debouncedState = (0, $kc00y.useMemo)(function() {
        return {
            callback: debounced,
            cancel: cancel,
            flush: flush,
            pending: pending
        };
    }, [
        debounced,
        cancel,
        flush,
        pending
    ]);
    return debouncedState;
}

});

parcelRegister("c67Lz", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b2aae3726d68067$export$2e2bcd8739ae039);
parcelRequire("w7gBZ");
var $aw9wE = parcelRequire("aw9wE");
const $2b2aae3726d68067$var$useQueryParams = ()=>{
    const { search: search } = (0, $aw9wE.useLocation)();
    const searchParams = new URLSearchParams(search);
    const res = [];
    searchParams.forEach((value, key)=>{
        let val;
        try {
            val = JSON.parse(value);
        } catch (e) {
            val = value;
        }
        res[key] = val;
    });
    return res;
};
var $2b2aae3726d68067$export$2e2bcd8739ae039 = $2b2aae3726d68067$var$useQueryParams;

});

parcelRegister("3WzC8", function(module, exports) {

$parcel$export(module.exports, "_QueryTable", () => $a73c1764856bdb30$export$81f68e7e6c951ce9);

var $cKvYK = parcelRequire("cKvYK");

var $kc00y = parcelRequire("kc00y");

var $26Ddr = parcelRequire("26Ddr");

var $5TbRy = parcelRequire("5TbRy");

var $e2QwP = parcelRequire("e2QwP");

var $lSohi = parcelRequire("lSohi");
const $a73c1764856bdb30$export$81f68e7e6c951ce9 = ({ query: query, queryParams: queryParams, asyncOptions: asyncOptions, getList: getList = (data)=>data?.list, getCount: getCount = (data)=>data?.count, filterBy: filterBy = {}, parentState: parentState, sortByState: sortByState, paginationState: paginationState, trClassName: trClassName, nomPage: nomPage, ...props })=>{
    const [pagination] = paginationState;
    // FIXME : trouver une meilleure solution pour gérer le retour en arrière
    const [sortBy] = sortByState;
    const [tableState, setTableState] = (0, $kc00y.useState)([]);
    const { isRejected: isRejected, isLoading: isLoading, data: data, run: run } = parentState ? parentState : // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $26Ddr.usePost)(queryParams ? query + "?" + (0, $5TbRy.default)`${queryParams}` : query, asyncOptions);
    const firstMount = (0, $kc00y.useRef)(true);
    const fetchData = ()=>{
        // on ne veut pas relancer un chargement immédiatement si on passe un state parent
        if (firstMount.current) {
            firstMount.current = false;
            if (parentState) return;
        }
        if (JSON.stringify(tableState) !== JSON.stringify([
            filterBy,
            sortBy,
            pagination.limit,
            pagination.offset
        ])) {
            setTableState([
                filterBy,
                sortBy,
                pagination.limit,
                pagination.offset
            ]);
            if (pagination.limit >= 0 && pagination.offset >= 0) run({
                limit: pagination.limit,
                offset: pagination.offset,
                filterBy: filterBy,
                sortBy: sortBy
            });
        }
    };
    (0, $kc00y.useEffect)(()=>{
        fetchData();
    }, [
        filterBy,
        sortBy,
        pagination.limit,
        pagination.offset
    ]);
    if (isRejected) return /*#__PURE__*/ (0, $cKvYK.jsx)("div", {
        children: "Une erreur est servenue."
    });
    return /*#__PURE__*/ (0, $cKvYK.jsx)((0, $e2QwP.default), {
        manual: true,
        showPagination: true,
        paginationState: paginationState,
        sortByState: sortByState,
        isLoading: isLoading,
        data: getList(data),
        count: getCount(data),
        trClassName: trClassName,
        nomPage: nomPage,
        ...props
    });
};
const $a73c1764856bdb30$var$QueryTable = ({ query: query, queryParams: queryParams, asyncOptions: asyncOptions, getList: getList = (data)=>data?.list, getCount: getCount = (data)=>data?.count, parentState: parentState, sortByState: sortByState, ...props })=>{
    return /*#__PURE__*/ (0, $cKvYK.jsx)($a73c1764856bdb30$export$81f68e7e6c951ce9, {
        query: query,
        queryParams: queryParams,
        getList: getList,
        getCount: getCount,
        parentState: parentState,
        asyncOptions: asyncOptions,
        sortByState: sortByState,
        paginationState: (0, $lSohi.usePaginationState)(),
        ...props
    });
};
var $a73c1764856bdb30$export$2e2bcd8739ae039 = $a73c1764856bdb30$var$QueryTable;

});
parcelRegister("e2QwP", function(module, exports) {

$parcel$export(module.exports, "useSortBy", () => $217828a0f2b9f545$export$769dcabd4dad14b5);
$parcel$export(module.exports, "default", () => $217828a0f2b9f545$export$2e2bcd8739ae039);

var $cKvYK = parcelRequire("cKvYK");

var $kc00y = parcelRequire("kc00y");

var $lgiU2 = parcelRequire("lgiU2");
parcelRequire("w7gBZ");
var $aw9wE = parcelRequire("aw9wE");

var $bNJBP = parcelRequire("bNJBP");

var $3RY61 = parcelRequire("3RY61");

var $hpOSz = parcelRequire("hpOSz");

var $c67Lz = parcelRequire("c67Lz");

var $lSohi = parcelRequire("lSohi");

var $YTww9 = parcelRequire("YTww9");
const $217828a0f2b9f545$var$TableComponent = (0, $bNJBP.makeTemplateComponent)("table", (0, (/*@__PURE__*/$parcel$interopDefault($YTww9))).table);
const $217828a0f2b9f545$var$THeadComponent = (0, $bNJBP.makeTemplateComponent)("thead", (0, (/*@__PURE__*/$parcel$interopDefault($YTww9))).thead);
const $217828a0f2b9f545$var$ThComponent = (0, $bNJBP.makeTemplateComponent)("th", (0, (/*@__PURE__*/$parcel$interopDefault($YTww9))).th);
const $217828a0f2b9f545$var$TBodyComponent = (0, $bNJBP.makeTemplateComponent)("tbody", (0, (/*@__PURE__*/$parcel$interopDefault($YTww9))).tbody);
const $217828a0f2b9f545$var$TrComponent = (0, $bNJBP.makeTemplateComponent)("tr", (0, (/*@__PURE__*/$parcel$interopDefault($YTww9))).tr);
const $217828a0f2b9f545$var$TdComponent = (0, $bNJBP.makeTemplateComponent)("td", (0, (/*@__PURE__*/$parcel$interopDefault($YTww9))).td);
const $217828a0f2b9f545$export$769dcabd4dad14b5 = ()=>{
    const { sortBy: init = {} } = (0, $c67Lz.default)();
    const [sortBy, setSortBy] = (0, $kc00y.useState)(init);
    return [
        sortBy,
        setSortBy
    ];
};
const $217828a0f2b9f545$var$Table = ({ data: data, columns: columns = [], idName: idName = "id", showPagination: showPagination = false, paginationState: paginationState, count: count, sortByState: sortByState, isLoading: isLoading = false, className: className })=>{
    const getIdForKey = (row, append = "")=>row[idName] + "" + append;
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const [sortBy, setSortBy] = sortByState ?? $217828a0f2b9f545$export$769dcabd4dad14b5();
    const [pagination, setPaginationTemp] = paginationState ?? (0, $lSohi.usePaginationState)(); // eslint-disable-line react-hooks/rules-of-hooks
    let setPagination = setPaginationTemp;
    if (!paginationState) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const navigate = (0, $aw9wE.useNavigate)();
        setPagination = ({ offset: offset, limit: limit })=>{
            setPaginationTemp({
                limit: limit,
                offset: offset
            });
            navigate({
                ...location,
                search: (0, $lSohi.setOffsetToSearchParams)(location.search, limit, offset)
            });
        };
    }
    const makeRow = (row)=>{
        return /*#__PURE__*/ (0, $cKvYK.jsx)($217828a0f2b9f545$var$TrComponent, {
            children: columns.map((column, j)=>makeCell(column, row, getIdForKey(row, j)))
        }, getIdForKey(row));
    };
    const makeCell = (column, row, key)=>{
        const { Cell: Cell, accessor: accessor, className: className, width: width } = column;
        let res = null;
        let acc = null;
        if (typeof accessor === "function") acc = accessor(row);
        else acc = row[accessor];
        if (Cell) res = /*#__PURE__*/ (0, $cKvYK.jsx)(Cell, {
            value: acc,
            original: row
        });
        else res = acc;
        return /*#__PURE__*/ (0, $cKvYK.jsx)($217828a0f2b9f545$var$TdComponent, {
            className: className,
            style: {
                width: width
            },
            children: res
        }, key);
    };
    const makeHeader = (column, key)=>{
        const { Header: Header, sortField: sortField, classNameHeader: classNameHeader, width: width } = column;
        return /*#__PURE__*/ (0, $cKvYK.jsx)($217828a0f2b9f545$var$ThComponent, {
            className: classNameHeader,
            style: {
                width: width
            },
            children: /*#__PURE__*/ (0, $cKvYK.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($YTww9))).headerWrapper,
                children: [
                    /*#__PURE__*/ (0, $cKvYK.jsxs)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($YTww9))).sortWrapper,
                        children: [
                            /*#__PURE__*/ (0, $cKvYK.jsx)("div", {
                                onClick: ()=>{
                                    if (!sortField) return;
                                    // Si on appuie une nouvelle fois sur la flèche, on réinitialise le tableau
                                    if (sortBy[sortField] === "1") setSortBy({});
                                    else {
                                        const asc = [];
                                        asc[sortField] = "1";
                                        setSortBy({
                                            ...asc
                                        });
                                    }
                                },
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($lgiU2)))({
                                    [(0, (/*@__PURE__*/$parcel$interopDefault($YTww9))).sort]: sortField,
                                    [(0, (/*@__PURE__*/$parcel$interopDefault($YTww9))).noSort]: !sortField,
                                    [(0, (/*@__PURE__*/$parcel$interopDefault($YTww9))).sortActive]: sortBy[sortField] === "1"
                                }),
                                children: /*#__PURE__*/ (0, $cKvYK.jsx)((0, $hpOSz.IconChevronUp), {})
                            }),
                            /*#__PURE__*/ (0, $cKvYK.jsx)("div", {
                                onClick: ()=>{
                                    if (!sortField) return;
                                    // Si on appuie une nouvelle fois sur la flèche, on réinitialise le tableau
                                    if (sortBy[sortField] === "-1") setSortBy({});
                                    else {
                                        const desc = [];
                                        desc[sortField] = "-1";
                                        setSortBy({
                                            ...desc
                                        });
                                    }
                                },
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($lgiU2)))({
                                    [(0, (/*@__PURE__*/$parcel$interopDefault($YTww9))).sort]: sortField,
                                    [(0, (/*@__PURE__*/$parcel$interopDefault($YTww9))).noSort]: !sortField,
                                    [(0, (/*@__PURE__*/$parcel$interopDefault($YTww9))).sortActive]: sortBy[sortField] === "-1"
                                }),
                                children: /*#__PURE__*/ (0, $cKvYK.jsx)((0, $hpOSz.IconChevronDown), {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cKvYK.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($YTww9))).headerTitle,
                        children: Header
                    })
                ]
            })
        }, key);
    };
    return /*#__PURE__*/ (0, $cKvYK.jsx)((0, $bNJBP.ScrollWrapper), {
        children: /*#__PURE__*/ (0, $cKvYK.jsxs)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($YTww9))).tableWrapper,
            children: [
                /*#__PURE__*/ (0, $cKvYK.jsxs)($217828a0f2b9f545$var$TableComponent, {
                    className: className,
                    children: [
                        /*#__PURE__*/ (0, $cKvYK.jsx)($217828a0f2b9f545$var$THeadComponent, {
                            children: columns.map((column, i)=>makeHeader(column, i))
                        }),
                        !isLoading && data?.length > 0 && /*#__PURE__*/ (0, $cKvYK.jsx)($217828a0f2b9f545$var$TBodyComponent, {
                            children: data?.map(makeRow)
                        })
                    ]
                }),
                showPagination && data?.length > 0 && /*#__PURE__*/ (0, $cKvYK.jsx)((0, $lSohi.default), {
                    isLoading: isLoading,
                    count: count,
                    paginationState: [
                        pagination,
                        setPagination
                    ],
                    dataLength: data?.length
                }),
                isLoading && /*#__PURE__*/ (0, $cKvYK.jsx)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($YTww9))).noData,
                    children: /*#__PURE__*/ (0, $cKvYK.jsx)((0, $3RY61.default), {})
                }),
                !isLoading && data?.length === 0 && /*#__PURE__*/ (0, $cKvYK.jsx)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($YTww9))).noData,
                    children: "Aucune donn\xe9e"
                })
            ]
        })
    });
};
var $217828a0f2b9f545$export$2e2bcd8739ae039 = $217828a0f2b9f545$var$Table;

});
parcelRegister("3RY61", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f4e7060e0aad2d1$export$2e2bcd8739ae039);

var $cKvYK = parcelRequire("cKvYK");

var $lgiU2 = parcelRequire("lgiU2");

var $hpOSz = parcelRequire("hpOSz");

var $cDpmY = parcelRequire("cDpmY");
const $8f4e7060e0aad2d1$var$Loading = ({ className: className, ...rest })=>/*#__PURE__*/ (0, $cKvYK.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($lgiU2)))((0, (/*@__PURE__*/$parcel$interopDefault($cDpmY))).loading, className),
        ...rest,
        children: /*#__PURE__*/ (0, $cKvYK.jsx)("div", {
            children: /*#__PURE__*/ (0, $cKvYK.jsx)((0, $hpOSz.IconLoading), {})
        })
    });
var $8f4e7060e0aad2d1$export$2e2bcd8739ae039 = $8f4e7060e0aad2d1$var$Loading;

});
parcelRegister("cDpmY", function(module, exports) {

$parcel$export(module.exports, "loading", () => $932cce6b58aa6e82$export$46c1c92549715335, (v) => $932cce6b58aa6e82$export$46c1c92549715335 = v);
var $932cce6b58aa6e82$export$46c1c92549715335;
$932cce6b58aa6e82$export$46c1c92549715335 = `kgV_RW_loading`;

});


parcelRegister("lSohi", function(module, exports) {

$parcel$export(module.exports, "usePaginationState", () => $db9474cb38abd572$export$f9468bb008747ceb);
$parcel$export(module.exports, "setOffsetToSearchParams", () => $db9474cb38abd572$export$12d7c70bb59bfd22);
$parcel$export(module.exports, "default", () => $db9474cb38abd572$export$2e2bcd8739ae039);

var $cKvYK = parcelRequire("cKvYK");

var $kc00y = parcelRequire("kc00y");

var $lgiU2 = parcelRequire("lgiU2");

var $3BicN = parcelRequire("3BicN");

var $c67Lz = parcelRequire("c67Lz");

var $acaRf = parcelRequire("acaRf");
const $db9474cb38abd572$var$PAGINATION = [
    10,
    25,
    50,
    100
];
const $db9474cb38abd572$var$PAGINATION_DEFAULT = 10;
const $db9474cb38abd572$var$PAGINATION_KEY = "itemsPerPage";
const $db9474cb38abd572$var$PAGINATION_VALUES = $db9474cb38abd572$var$PAGINATION.map((data)=>{
    return {
        value: data,
        label: data
    };
});
const $db9474cb38abd572$var$usePaginationInLocalStorage = ()=>{
    const [itemsPerPage, setItemsPerPage] = (0, $kc00y.useState)(localStorage.getItem($db9474cb38abd572$var$PAGINATION_KEY) || $db9474cb38abd572$var$PAGINATION_DEFAULT);
    (0, $kc00y.useEffect)(()=>{
        localStorage.setItem($db9474cb38abd572$var$PAGINATION_KEY, itemsPerPage);
    }, [
        itemsPerPage
    ]);
    return [
        itemsPerPage,
        setItemsPerPage
    ];
};
const $db9474cb38abd572$export$f9468bb008747ceb = ()=>{
    const { limit: l, offset: o = 0 } = (0, $c67Lz.default)();
    let val = l;
    if (l === undefined) val = localStorage.getItem($db9474cb38abd572$var$PAGINATION_KEY) || $db9474cb38abd572$var$PAGINATION_DEFAULT;
    const [pagination, setPagination] = (0, $kc00y.useState)({
        limit: val,
        offset: o
    });
    const setValue = ({ limit: limit, offset: offset })=>{
        const l = parseInt(limit);
        const o = parseInt(offset);
        setPagination({
            limit: !isNaN(l) ? l : localStorage.getItem($db9474cb38abd572$var$PAGINATION_KEY) || $db9474cb38abd572$var$PAGINATION_DEFAULT,
            offset: !isNaN(o) ? o : 0
        });
    };
    return [
        pagination,
        setValue
    ];
};
const $db9474cb38abd572$export$f80c710216eae131 = ({ total: total, offset: offset })=>{
    const [itemsPerPage, setItemsPerPage] = $db9474cb38abd572$var$usePaginationInLocalStorage();
    const maxPage = Math.ceil(total / itemsPerPage);
    const currentPage = Math.trunc(offset / itemsPerPage);
    return {
        itemsPerPage: itemsPerPage,
        setItemsPerPage: setItemsPerPage,
        currentPage: currentPage,
        total: total,
        canPrevious: currentPage > 0,
        canNext: currentPage < maxPage - 1,
        getVisiblePages () {
            if (maxPage < 7) return [
                1,
                2,
                3,
                4,
                5,
                6
            ].filter((page)=>page <= maxPage);
            else {
                if (currentPage >= 0 && currentPage > 4 && currentPage + 2 < maxPage) return [
                    1,
                    currentPage - 1,
                    currentPage,
                    currentPage + 1,
                    maxPage
                ];
                else if (currentPage >= 0 && currentPage > 4 && currentPage + 2 >= maxPage) return [
                    1,
                    maxPage - 3,
                    maxPage - 2,
                    maxPage - 1,
                    maxPage
                ];
                else return [
                    1,
                    2,
                    3,
                    4,
                    5,
                    maxPage
                ];
            }
        }
    };
};
const $db9474cb38abd572$export$12d7c70bb59bfd22 = (search, itemsPerPage, offset)=>{
    const searchParams = new URLSearchParams(search);
    searchParams.set("offset", offset < 0 ? 0 : offset);
    searchParams.set("limit", itemsPerPage);
    return decodeURIComponent(searchParams.toString());
};
const $db9474cb38abd572$var$DisabledLink = (props)=>{
    return /*#__PURE__*/ (0, $cKvYK.jsx)("span", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($lgiU2)))((0, (/*@__PURE__*/$parcel$interopDefault($acaRf))).linkA, (0, (/*@__PURE__*/$parcel$interopDefault($acaRf))).disabled),
        ...props
    });
};
const $db9474cb38abd572$var$Pagination = ({ className: className, isLoading: isLoading, previousText: previousText = /*#__PURE__*/ (0, $cKvYK.jsx)((0, $cKvYK.Fragment), {
    children: "<"
}), nextText: nextText = /*#__PURE__*/ (0, $cKvYK.jsx)((0, $cKvYK.Fragment), {
    children: ">"
}), count: count, paginationState: paginationState, dataLength: dataLength })=>{
    const [pagination, setPagination] = paginationState;
    (0, $kc00y.useEffect)(()=>{
        if (pagination.offset >= count) setPagination({
            offset: 0,
            limit: pagination.limit
        });
    }, []);
    const { canPrevious: canPrevious, canNext: canNext, getVisiblePages: getVisiblePages, currentPage: currentPage, itemsPerPage: itemsPerPage, setItemsPerPage: setItemsPerPage } = $db9474cb38abd572$export$f80c710216eae131({
        total: count,
        offset: pagination.offset
    });
    return /*#__PURE__*/ (0, $cKvYK.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($lgiU2)))(className, (0, (/*@__PURE__*/$parcel$interopDefault($acaRf))).pagination),
        children: [
            /*#__PURE__*/ (0, $cKvYK.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($acaRf))).resultsDisplayed,
                children: dataLength > 0 && /*#__PURE__*/ (0, $cKvYK.jsxs)((0, $cKvYK.Fragment), {
                    children: [
                        "Affichage des r\xe9sultats ",
                        itemsPerPage * currentPage + 1,
                        " \xe0",
                        " ",
                        currentPage > 0 ? itemsPerPage * (currentPage + 1) - (itemsPerPage - dataLength) : dataLength,
                        "\xa0sur ",
                        count
                    ]
                })
            }),
            /*#__PURE__*/ (0, $cKvYK.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($acaRf))).paginationBlock,
                children: /*#__PURE__*/ (0, $cKvYK.jsxs)("ol", {
                    children: [
                        /*#__PURE__*/ (0, $cKvYK.jsx)("li", {
                            children: canPrevious && !isLoading ? /*#__PURE__*/ (0, $cKvYK.jsx)("a", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($lgiU2)))((0, (/*@__PURE__*/$parcel$interopDefault($acaRf))).navigate),
                                onClick: ()=>{
                                    setPagination({
                                        limit: itemsPerPage,
                                        offset: parseInt(pagination.offset) + itemsPerPage * -1
                                    });
                                },
                                children: previousText
                            }) : /*#__PURE__*/ (0, $cKvYK.jsx)($db9474cb38abd572$var$DisabledLink, {
                                children: previousText
                            })
                        }),
                        getVisiblePages().map((val, i, array)=>{
                            const page = val - 1;
                            return /*#__PURE__*/ (0, $cKvYK.jsx)("li", {
                                children: !isLoading ? /*#__PURE__*/ (0, $cKvYK.jsxs)("span", {
                                    type: "button",
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($lgiU2)))((0, (/*@__PURE__*/$parcel$interopDefault($acaRf))).linkA, {
                                        [(0, (/*@__PURE__*/$parcel$interopDefault($acaRf))).active]: currentPage === page
                                    }),
                                    onClick: ()=>{
                                        setPagination({
                                            limit: itemsPerPage,
                                            offset: itemsPerPage * page
                                        });
                                    },
                                    children: [
                                        array[i - 1] + 1 < val ? /*#__PURE__*/ (0, $cKvYK.jsx)("span", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($acaRf))).pointille,
                                            children: "........... "
                                        }) : "",
                                        val
                                    ]
                                }, i) : /*#__PURE__*/ (0, $cKvYK.jsxs)($db9474cb38abd572$var$DisabledLink, {
                                    children: [
                                        array[i - 1] + 1 < val ? /*#__PURE__*/ (0, $cKvYK.jsx)("span", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($acaRf))).pointille,
                                            children: "........... "
                                        }) : "",
                                        val
                                    ]
                                })
                            }, i);
                        }),
                        /*#__PURE__*/ (0, $cKvYK.jsx)("li", {
                            children: canNext && !isLoading ? /*#__PURE__*/ (0, $cKvYK.jsx)("span", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($lgiU2)))((0, (/*@__PURE__*/$parcel$interopDefault($acaRf))).navigate),
                                onClick: ()=>{
                                    setPagination({
                                        limit: itemsPerPage,
                                        offset: parseInt(pagination.offset) + itemsPerPage * 1
                                    });
                                },
                                children: nextText
                            }) : /*#__PURE__*/ (0, $cKvYK.jsx)($db9474cb38abd572$var$DisabledLink, {
                                children: nextText
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $cKvYK.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($acaRf))).pageSizeOptions,
                children: dataLength > 0 && /*#__PURE__*/ (0, $cKvYK.jsxs)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($acaRf))).paginationLabel,
                    children: [
                        "R\xe9sultats par page :",
                        /*#__PURE__*/ (0, $cKvYK.jsx)((0, $3BicN.Select), {
                            value: $db9474cb38abd572$var$PAGINATION_VALUES.find((data)=>data.value === itemsPerPage) || {
                                value: itemsPerPage,
                                label: itemsPerPage
                            },
                            options: $db9474cb38abd572$var$PAGINATION_VALUES,
                            getOptionLabel: ({ label: label })=>label,
                            getOptionValue: ({ value: value })=>value,
                            onChange: ({ value: value })=>{
                                setItemsPerPage(value);
                                setPagination({
                                    limit: value,
                                    offset: 0
                                });
                            },
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($acaRf))).itemPerPage,
                            placeholder: "S\xe9lectionnez une valeur...",
                            menuPlacement: "top"
                        })
                    ]
                })
            })
        ]
    });
};
var $db9474cb38abd572$export$2e2bcd8739ae039 = $db9474cb38abd572$var$Pagination;

});
parcelRegister("acaRf", function(module, exports) {

$parcel$export(module.exports, "active", () => $76c372857f8c3c9a$export$89da14300d534261, (v) => $76c372857f8c3c9a$export$89da14300d534261 = v);
$parcel$export(module.exports, "center", () => $76c372857f8c3c9a$export$3481c78889e8fbe8, (v) => $76c372857f8c3c9a$export$3481c78889e8fbe8 = v);
$parcel$export(module.exports, "disabled", () => $76c372857f8c3c9a$export$683472f6198a076e, (v) => $76c372857f8c3c9a$export$683472f6198a076e = v);
$parcel$export(module.exports, "itemPerPage", () => $76c372857f8c3c9a$export$2be7d4251b278816, (v) => $76c372857f8c3c9a$export$2be7d4251b278816 = v);
$parcel$export(module.exports, "linkA", () => $76c372857f8c3c9a$export$a816aac1accc5e89, (v) => $76c372857f8c3c9a$export$a816aac1accc5e89 = v);
$parcel$export(module.exports, "navigate", () => $76c372857f8c3c9a$export$ff7962acd6052c28, (v) => $76c372857f8c3c9a$export$ff7962acd6052c28 = v);
$parcel$export(module.exports, "navigateDisable", () => $76c372857f8c3c9a$export$716d724ac4b9b0bb, (v) => $76c372857f8c3c9a$export$716d724ac4b9b0bb = v);
$parcel$export(module.exports, "pageSizeOptions", () => $76c372857f8c3c9a$export$5e848d0f0b9d35d3, (v) => $76c372857f8c3c9a$export$5e848d0f0b9d35d3 = v);
$parcel$export(module.exports, "pagination", () => $76c372857f8c3c9a$export$22fa394f3ba39578, (v) => $76c372857f8c3c9a$export$22fa394f3ba39578 = v);
$parcel$export(module.exports, "paginationBlock", () => $76c372857f8c3c9a$export$2f588562fd8b106c, (v) => $76c372857f8c3c9a$export$2f588562fd8b106c = v);
$parcel$export(module.exports, "paginationLabel", () => $76c372857f8c3c9a$export$a941b4b1b0ba7fbd, (v) => $76c372857f8c3c9a$export$a941b4b1b0ba7fbd = v);
$parcel$export(module.exports, "pointille", () => $76c372857f8c3c9a$export$ccdd9dc094b7bbfc, (v) => $76c372857f8c3c9a$export$ccdd9dc094b7bbfc = v);
$parcel$export(module.exports, "resultsDisplayed", () => $76c372857f8c3c9a$export$ac45ee1695a98816, (v) => $76c372857f8c3c9a$export$ac45ee1695a98816 = v);
var $76c372857f8c3c9a$export$89da14300d534261;
var $76c372857f8c3c9a$export$3481c78889e8fbe8;
var $76c372857f8c3c9a$export$683472f6198a076e;
var $76c372857f8c3c9a$export$2be7d4251b278816;
var $76c372857f8c3c9a$export$a816aac1accc5e89;
var $76c372857f8c3c9a$export$ff7962acd6052c28;
var $76c372857f8c3c9a$export$716d724ac4b9b0bb;
var $76c372857f8c3c9a$export$5e848d0f0b9d35d3;
var $76c372857f8c3c9a$export$22fa394f3ba39578;
var $76c372857f8c3c9a$export$2f588562fd8b106c;
var $76c372857f8c3c9a$export$a941b4b1b0ba7fbd;
var $76c372857f8c3c9a$export$ccdd9dc094b7bbfc;
var $76c372857f8c3c9a$export$ac45ee1695a98816;
$76c372857f8c3c9a$export$89da14300d534261 = `dkB0Zq_active`;
$76c372857f8c3c9a$export$3481c78889e8fbe8 = `dkB0Zq_center`;
$76c372857f8c3c9a$export$683472f6198a076e = `dkB0Zq_disabled`;
$76c372857f8c3c9a$export$2be7d4251b278816 = `dkB0Zq_itemPerPage`;
$76c372857f8c3c9a$export$a816aac1accc5e89 = `dkB0Zq_linkA`;
$76c372857f8c3c9a$export$ff7962acd6052c28 = `dkB0Zq_navigate`;
$76c372857f8c3c9a$export$716d724ac4b9b0bb = `dkB0Zq_navigateDisable`;
$76c372857f8c3c9a$export$5e848d0f0b9d35d3 = `dkB0Zq_pageSizeOptions`;
$76c372857f8c3c9a$export$22fa394f3ba39578 = `dkB0Zq_pagination`;
$76c372857f8c3c9a$export$2f588562fd8b106c = `dkB0Zq_paginationBlock`;
$76c372857f8c3c9a$export$a941b4b1b0ba7fbd = `dkB0Zq_paginationLabel`;
$76c372857f8c3c9a$export$ccdd9dc094b7bbfc = `dkB0Zq_pointille`;
$76c372857f8c3c9a$export$ac45ee1695a98816 = `dkB0Zq_resultsDisplayed`;

});


parcelRegister("YTww9", function(module, exports) {

$parcel$export(module.exports, "headerTitle", () => $0b70ac84541ee957$export$15c60d712917cee6, (v) => $0b70ac84541ee957$export$15c60d712917cee6 = v);
$parcel$export(module.exports, "headerWrapper", () => $0b70ac84541ee957$export$33ec9fcec07f6e7f, (v) => $0b70ac84541ee957$export$33ec9fcec07f6e7f = v);
$parcel$export(module.exports, "middle", () => $0b70ac84541ee957$export$848500358616d9e6, (v) => $0b70ac84541ee957$export$848500358616d9e6 = v);
$parcel$export(module.exports, "noData", () => $0b70ac84541ee957$export$d0b56ec104a7253e, (v) => $0b70ac84541ee957$export$d0b56ec104a7253e = v);
$parcel$export(module.exports, "noSort", () => $0b70ac84541ee957$export$76f3f533b70e4afc, (v) => $0b70ac84541ee957$export$76f3f533b70e4afc = v);
$parcel$export(module.exports, "queryTableFilterWrapper", () => $0b70ac84541ee957$export$bab42cd91463a0da, (v) => $0b70ac84541ee957$export$bab42cd91463a0da = v);
$parcel$export(module.exports, "right", () => $0b70ac84541ee957$export$79ffe56a765070d2, (v) => $0b70ac84541ee957$export$79ffe56a765070d2 = v);
$parcel$export(module.exports, "scrollWrapper", () => $0b70ac84541ee957$export$adf92944f5ab76db, (v) => $0b70ac84541ee957$export$adf92944f5ab76db = v);
$parcel$export(module.exports, "sort", () => $0b70ac84541ee957$export$97db5808d8f88186, (v) => $0b70ac84541ee957$export$97db5808d8f88186 = v);
$parcel$export(module.exports, "sortActive", () => $0b70ac84541ee957$export$455a77922391a8cc, (v) => $0b70ac84541ee957$export$455a77922391a8cc = v);
$parcel$export(module.exports, "sortWrapper", () => $0b70ac84541ee957$export$8427e1cdd60dbd47, (v) => $0b70ac84541ee957$export$8427e1cdd60dbd47 = v);
$parcel$export(module.exports, "table", () => $0b70ac84541ee957$export$9852986a3ec5f6a0, (v) => $0b70ac84541ee957$export$9852986a3ec5f6a0 = v);
$parcel$export(module.exports, "tableWrapper", () => $0b70ac84541ee957$export$e7d47881ec916f76, (v) => $0b70ac84541ee957$export$e7d47881ec916f76 = v);
$parcel$export(module.exports, "tbody", () => $0b70ac84541ee957$export$7cdd536eaa8f163c, (v) => $0b70ac84541ee957$export$7cdd536eaa8f163c = v);
$parcel$export(module.exports, "td", () => $0b70ac84541ee957$export$2beef8af2014e5c6, (v) => $0b70ac84541ee957$export$2beef8af2014e5c6 = v);
$parcel$export(module.exports, "thead", () => $0b70ac84541ee957$export$e3f32a5920890b82, (v) => $0b70ac84541ee957$export$e3f32a5920890b82 = v);
$parcel$export(module.exports, "tr", () => $0b70ac84541ee957$export$72451b88a72ad9c2, (v) => $0b70ac84541ee957$export$72451b88a72ad9c2 = v);
var $0b70ac84541ee957$export$15c60d712917cee6;
var $0b70ac84541ee957$export$33ec9fcec07f6e7f;
var $0b70ac84541ee957$export$848500358616d9e6;
var $0b70ac84541ee957$export$d0b56ec104a7253e;
var $0b70ac84541ee957$export$76f3f533b70e4afc;
var $0b70ac84541ee957$export$bab42cd91463a0da;
var $0b70ac84541ee957$export$79ffe56a765070d2;
var $0b70ac84541ee957$export$adf92944f5ab76db;
var $0b70ac84541ee957$export$97db5808d8f88186;
var $0b70ac84541ee957$export$455a77922391a8cc;
var $0b70ac84541ee957$export$8427e1cdd60dbd47;
var $0b70ac84541ee957$export$9852986a3ec5f6a0;
var $0b70ac84541ee957$export$e7d47881ec916f76;
var $0b70ac84541ee957$export$7cdd536eaa8f163c;
var $0b70ac84541ee957$export$2beef8af2014e5c6;
var $0b70ac84541ee957$export$e3f32a5920890b82;
var $0b70ac84541ee957$export$72451b88a72ad9c2;
$0b70ac84541ee957$export$15c60d712917cee6 = `_3qKp0q_headerTitle`;
$0b70ac84541ee957$export$33ec9fcec07f6e7f = `_3qKp0q_headerWrapper`;
$0b70ac84541ee957$export$848500358616d9e6 = `_3qKp0q_middle`;
$0b70ac84541ee957$export$d0b56ec104a7253e = `_3qKp0q_noData`;
$0b70ac84541ee957$export$76f3f533b70e4afc = `_3qKp0q_noSort`;
$0b70ac84541ee957$export$bab42cd91463a0da = `_3qKp0q_queryTableFilterWrapper`;
$0b70ac84541ee957$export$79ffe56a765070d2 = `_3qKp0q_right`;
$0b70ac84541ee957$export$adf92944f5ab76db = `_3qKp0q_scrollWrapper`;
$0b70ac84541ee957$export$97db5808d8f88186 = `_3qKp0q_sort`;
$0b70ac84541ee957$export$455a77922391a8cc = `_3qKp0q_sortActive`;
$0b70ac84541ee957$export$8427e1cdd60dbd47 = `_3qKp0q_sortWrapper`;
$0b70ac84541ee957$export$9852986a3ec5f6a0 = `_3qKp0q_table`;
$0b70ac84541ee957$export$e7d47881ec916f76 = `_3qKp0q_tableWrapper`;
$0b70ac84541ee957$export$7cdd536eaa8f163c = `_3qKp0q_tbody`;
$0b70ac84541ee957$export$2beef8af2014e5c6 = `_3qKp0q_td`;
$0b70ac84541ee957$export$e3f32a5920890b82 = `_3qKp0q_thead`;
$0b70ac84541ee957$export$72451b88a72ad9c2 = `_3qKp0q_tr`;

});




parcelRegister("6Sma1", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa38a3ffff7aa8eb$export$2e2bcd8739ae039);
$parcel$export(module.exports, "ActiveDesactiveColumn", () => $fa38a3ffff7aa8eb$export$39562e462f751021);
$parcel$export(module.exports, "PreviewColumn", () => $fa38a3ffff7aa8eb$export$3e3de4f2f155d4ac);

var $cKvYK = parcelRequire("cKvYK");

var $lgiU2 = parcelRequire("lgiU2");

var $bYYyU = parcelRequire("bYYyU");

var $hpOSz = parcelRequire("hpOSz");

var $6PpiQ = parcelRequire("6PpiQ");

var $3Yazj = parcelRequire("3Yazj");

var $dZjxw = parcelRequire("dZjxw");

var $au7pA = parcelRequire("au7pA");

var $i2wlK = parcelRequire("i2wlK");
const $fa38a3ffff7aa8eb$var$EditColumn = ({ to: to, canEdit: canEdit = false, canEditFunction: canEditFunction, title: title = true, ...option })=>({
        // eslint-disable-next-line react/display-name
        Cell: (row)=>{
            const canEditValue = canEditFunction ? canEditFunction(row.value) : canEdit;
            return /*#__PURE__*/ (0, $cKvYK.jsx)((0, $cKvYK.Fragment), {
                children: canEditValue && /*#__PURE__*/ (0, $cKvYK.jsxs)("a", {
                    href: to(row.value),
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($i2wlK))).link,
                    children: [
                        /*#__PURE__*/ (0, $cKvYK.jsx)((0, $hpOSz.IconEdit), {}),
                        title && /*#__PURE__*/ (0, $cKvYK.jsx)((0, $cKvYK.Fragment), {
                            children: "\xa0Modifier"
                        })
                    ]
                })
            });
        },
        width: title ? 140 : 90,
        ...option
    });
var $fa38a3ffff7aa8eb$export$2e2bcd8739ae039 = $fa38a3ffff7aa8eb$var$EditColumn;
const $fa38a3ffff7aa8eb$export$ad76ec2c15e9c66f = ({ path: path, reload: reload, title: title = true, canSuppress: canSuppress = false, canSuppressFunction: canSuppressFunction, header: header, content: content, ...options })=>({
        // eslint-disable-next-line react/display-name
        Cell: (row)=>{
            const { visible: visible, show: show, close: close } = (0, $dZjxw.useModal)();
            const query = `${path}${row.value}`;
            const canSuppressValue = canSuppressFunction ? canSuppressFunction(row.value) : canSuppress;
            return /*#__PURE__*/ (0, $cKvYK.jsx)((0, $cKvYK.Fragment), {
                children: canSuppressValue && /*#__PURE__*/ (0, $cKvYK.jsxs)((0, $cKvYK.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $cKvYK.jsxs)((0, $bYYyU.default), {
                            onClick: show,
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($lgiU2)))((0, (/*@__PURE__*/$parcel$interopDefault($i2wlK))).cellButton, (0, (/*@__PURE__*/$parcel$interopDefault($i2wlK))).deleteCell),
                            children: [
                                /*#__PURE__*/ (0, $cKvYK.jsx)((0, $hpOSz.IconDelete), {}),
                                title && /*#__PURE__*/ (0, $cKvYK.jsx)((0, $cKvYK.Fragment), {
                                    children: "\xa0Supprimer"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $cKvYK.jsx)((0, $3Yazj.default), {
                            visible: visible,
                            closeModal: close,
                            header: header,
                            content: content,
                            query: query,
                            onDelete: ()=>reload ? reload() : window.location.reload()
                        })
                    ]
                })
            });
        },
        width: title ? 160 : 90,
        ...options
    });
const $fa38a3ffff7aa8eb$export$39562e462f751021 = ({ path: path, reload: reload, title: title = true, canDesactive: canDesactive = false, canDesactiveFunction: canDesactiveFunction, headerActif: headerActif, contentActif: contentActif, headerInactif: headerInactif, contentInactif: contentInactif, ...options })=>({
        // eslint-disable-next-line react/display-name
        Cell: (row)=>{
            const { visible: visible, show: show, close: close } = (0, $dZjxw.useModal)();
            const query = `${path}${row.value}`;
            const canDesactiveValue = canDesactiveFunction ? canDesactiveFunction(row.value) : canDesactive;
            const active = row.original.actif;
            return /*#__PURE__*/ (0, $cKvYK.jsx)((0, $cKvYK.Fragment), {
                children: canDesactiveValue && /*#__PURE__*/ (0, $cKvYK.jsxs)((0, $cKvYK.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $cKvYK.jsxs)((0, $bYYyU.default), {
                            onClick: show,
                            className: active ? (0, (/*@__PURE__*/$parcel$interopDefault($lgiU2)))((0, (/*@__PURE__*/$parcel$interopDefault($i2wlK))).cellButton, (0, (/*@__PURE__*/$parcel$interopDefault($i2wlK))).deleteCell) : (0, (/*@__PURE__*/$parcel$interopDefault($lgiU2)))((0, (/*@__PURE__*/$parcel$interopDefault($i2wlK))).cellButton, (0, (/*@__PURE__*/$parcel$interopDefault($i2wlK))).activeCell),
                            children: [
                                !active ? /*#__PURE__*/ (0, $cKvYK.jsx)((0, $hpOSz.IconCheck), {}) : /*#__PURE__*/ (0, $cKvYK.jsx)((0, $hpOSz.IconCross), {}),
                                title && /*#__PURE__*/ (0, $cKvYK.jsxs)((0, $cKvYK.Fragment), {
                                    children: [
                                        "\xa0",
                                        !active ? "Activer" : "D\xe9sactiver"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $cKvYK.jsx)((0, $6PpiQ.default), {
                            visible: visible,
                            closeModal: close,
                            header: active ? headerActif : headerInactif,
                            content: active ? contentActif : contentInactif,
                            query: query,
                            onConfirm: ()=>reload ? reload() : window.location.reload()
                        })
                    ]
                })
            });
        },
        width: title ? 160 : 90,
        ...options
    });
const $fa38a3ffff7aa8eb$export$3e3de4f2f155d4ac = ({ ressourceCode: ressourceCode, ressourceType: ressourceType, ressourcePrivee: ressourcePrivee })=>{
    // eslint-disable-next-line react/display-name
    const { visible: visible, show: show, close: close } = (0, $dZjxw.useModal)();
    return /*#__PURE__*/ (0, $cKvYK.jsxs)((0, $cKvYK.Fragment), {
        children: [
            /*#__PURE__*/ (0, $cKvYK.jsx)((0, $bYYyU.default), {
                onClick: show,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($lgiU2)))((0, (/*@__PURE__*/$parcel$interopDefault($i2wlK))).cellButton, (0, (/*@__PURE__*/$parcel$interopDefault($i2wlK))).previewCell),
                children: /*#__PURE__*/ (0, $cKvYK.jsx)((0, $hpOSz.IconOverview), {})
            }),
            /*#__PURE__*/ (0, $cKvYK.jsx)((0, $au7pA.default), {
                visible: visible,
                closeModal: close,
                ressourceCode: ressourceCode,
                ressourceType: ressourceType,
                ressourcePrivee: ressourcePrivee
            })
        ]
    });
};

});
parcelRegister("6PpiQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1bd49df7b35aa38$export$2e2bcd8739ae039);

var $cKvYK = parcelRequire("cKvYK");

var $61JDm = parcelRequire("61JDm");

var $26Ddr = parcelRequire("26Ddr");

var $dZjxw = parcelRequire("dZjxw");

var $11vsd = parcelRequire("11vsd");
const $c1bd49df7b35aa38$var$ConfirmModalBody = ({ query: query, id: id, closeModal: closeModal, onConfirm: onConfirm, content: content, href: href })=>{
    const action = (0, $26Ddr.usePost)(id ? `${query}/${id}` : `${query}`, {
        onResolve: (res)=>{
            onConfirm && onConfirm(res);
            (0, $61JDm.default).success("L'action a \xe9t\xe9 ex\xe9cut\xe9e avec succ\xe8s");
            closeModal();
        },
        onReject: async (error)=>{
            (0, $61JDm.default).error(/*#__PURE__*/ (0, $cKvYK.jsxs)((0, $cKvYK.Fragment), {
                children: [
                    "Erreur lors de l'ex\xe9cution de l'action",
                    " \xa0: ",
                    error.text
                ]
            }));
            closeModal();
        }
    });
    return /*#__PURE__*/ (0, $cKvYK.jsxs)((0, $cKvYK.Fragment), {
        children: [
            /*#__PURE__*/ (0, $cKvYK.jsx)((0, $dZjxw.Content), {
                children: content ?? "Confirmer ?"
            }),
            /*#__PURE__*/ (0, $cKvYK.jsxs)((0, $dZjxw.ActionBar), {
                children: [
                    /*#__PURE__*/ (0, $cKvYK.jsx)("button", {
                        onClick: closeModal,
                        children: "Annuler"
                    }),
                    /*#__PURE__*/ (0, $cKvYK.jsx)("a", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($11vsd))).active,
                        onClick: async ()=>{
                            // Si on a un href, on n'est pas en post
                            if (href === null) try {
                                await action.run();
                            } catch (e) {
                                (0, $61JDm.default).error(/*#__PURE__*/ (0, $cKvYK.jsxs)((0, $cKvYK.Fragment), {
                                    children: [
                                        "Erreur lors de l'ex\xe9cution de l'action",
                                        " \xa0:",
                                        " ",
                                        e.message
                                    ]
                                }));
                            }
                            else closeModal();
                        },
                        href: href,
                        children: "Valider"
                    })
                ]
            })
        ]
    });
};
const $c1bd49df7b35aa38$var$ConfirmModal = ({ visible: visible, closeModal: closeModal, header: header = "Confirmation", query: query, id: id, onConfirm: onConfirm, content: content, href: href = null })=>{
    return /*#__PURE__*/ (0, $cKvYK.jsx)((0, $dZjxw.default), {
        visible: visible,
        header: header,
        closeModal: closeModal,
        children: /*#__PURE__*/ (0, $cKvYK.jsx)($c1bd49df7b35aa38$var$ConfirmModalBody, {
            query: query,
            id: id,
            closeModal: closeModal,
            onConfirm: onConfirm,
            content: content,
            href: href
        })
    });
};
var $c1bd49df7b35aa38$export$2e2bcd8739ae039 = $c1bd49df7b35aa38$var$ConfirmModal;

});
parcelRegister("dZjxw", function(module, exports) {

$parcel$export(module.exports, "useModal", () => $a5226fe8e84703ac$export$33ffd74ebf07f060);
$parcel$export(module.exports, "ActionBar", () => $a5226fe8e84703ac$export$e213cebad6250b4a);
$parcel$export(module.exports, "Content", () => $a5226fe8e84703ac$export$7c6e2c02157bb7d2);
$parcel$export(module.exports, "default", () => $a5226fe8e84703ac$export$2e2bcd8739ae039);

var $cKvYK = parcelRequire("cKvYK");

var $kc00y = parcelRequire("kc00y");

var $cn1Kz = parcelRequire("cn1Kz");

var $11vsd = parcelRequire("11vsd");
function $a5226fe8e84703ac$export$33ffd74ebf07f060(defaultVisible = false) {
    const [visible, setVisible] = (0, $kc00y.useState)(defaultVisible);
    const [value, setValue] = (0, $kc00y.useState)(null);
    function show(value = null) {
        document.body.style.overflow = "hidden";
        document.getElementById("root").style.filter = "blur(6px)";
        setVisible(true);
        setValue(value);
    }
    function close() {
        document.body.style.overflow = "";
        document.getElementById("root").style.filter = "";
        setVisible(false);
        setValue(null);
    }
    return {
        visible: visible,
        value: value,
        show: show,
        close: close
    };
}
const $a5226fe8e84703ac$var$createRoot = ()=>{
    const root = document.createElement("div");
    root.classList.add("modal-root");
    return root;
};
const $a5226fe8e84703ac$var$Modal = ({ children: children, header: header, closeModal: closeModal, visible: visible })=>{
    const container = (0, $kc00y.useRef)($a5226fe8e84703ac$var$createRoot());
    (0, $kc00y.useEffect)(()=>{
        if (visible) {
            document.body.appendChild(container.current);
            document.onkeydown = (e)=>{
                if (e.key === "Escape") {
                    e.preventDefault();
                    closeModal && closeModal(e);
                }
            };
        } else container.current.remove();
    }, [
        visible
    ]);
    return !visible ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cn1Kz))).createPortal(/*#__PURE__*/ (0, $cKvYK.jsxs)("custom-modal", {
        onCancel: (e)=>{
            e.preventDefault();
            closeModal && closeModal(e);
        },
        children: [
            /*#__PURE__*/ (0, $cKvYK.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($11vsd))).modalHeader,
                children: [
                    header,
                    closeModal && /*#__PURE__*/ (0, $cKvYK.jsx)("span", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($11vsd))).modalClose,
                        onClick: closeModal,
                        children: "\u2715"
                    })
                ]
            }),
            children
        ]
    }), container.current);
};
const $a5226fe8e84703ac$export$e213cebad6250b4a = (props)=>/*#__PURE__*/ (0, $cKvYK.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($11vsd))).actionBar,
        ...props
    });
const $a5226fe8e84703ac$export$7c6e2c02157bb7d2 = (props)=>/*#__PURE__*/ (0, $cKvYK.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($11vsd))).modalContent,
        ...props
    });
var $a5226fe8e84703ac$export$2e2bcd8739ae039 = $a5226fe8e84703ac$var$Modal;
class $a5226fe8e84703ac$var$ModalElement extends HTMLElement {
    constructor(){
        super();
    }
    connectedCallback() {
        this._render();
    }
    _render() {
        const container = document.createElement("div");
        container.innerHTML = `
      <style>
        .wrapper {
          justify-content: center;
          display: flex;
          position: fixed;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(30, 61, 58, 0.5);
          z-index: 10000;
          overflow-y: scroll;
        }
        .modal-box {
          display: block;
          min-width: 700px;
          max-width: 100%;
          max-height: 100%;
          margin: auto;
        }
        .modal-inner {
          display: block;
          background-color: #fff;
          border-radius: 32px;
          padding: 32px;
          margin: 15px;
          box-shadow: 0px 3px 5px #00000029;
        }
      </style>
      <div class="wrapper">
        <div class="modal-box">
          <div class="modal-inner">
            <slot></slot>
          </div>
        </div>
      </div>`;
        const shadowRoot = this.attachShadow({
            mode: "open"
        });
        shadowRoot.appendChild(container);
    }
}
window.customElements.define("custom-modal", $a5226fe8e84703ac$var$ModalElement);

});
parcelRegister("11vsd", function(module, exports) {

$parcel$export(module.exports, "actionBar", () => $0bee488caaed56c5$export$795623e8105ba10a, (v) => $0bee488caaed56c5$export$795623e8105ba10a = v);
$parcel$export(module.exports, "active", () => $0bee488caaed56c5$export$89da14300d534261, (v) => $0bee488caaed56c5$export$89da14300d534261 = v);
$parcel$export(module.exports, "closeButton", () => $0bee488caaed56c5$export$efe229eab43a9869, (v) => $0bee488caaed56c5$export$efe229eab43a9869 = v);
$parcel$export(module.exports, "modalClose", () => $0bee488caaed56c5$export$6abdc2947a758b6a, (v) => $0bee488caaed56c5$export$6abdc2947a758b6a = v);
$parcel$export(module.exports, "modalContent", () => $0bee488caaed56c5$export$add244bda2f9423c, (v) => $0bee488caaed56c5$export$add244bda2f9423c = v);
$parcel$export(module.exports, "modalHeader", () => $0bee488caaed56c5$export$3099d0daead893d3, (v) => $0bee488caaed56c5$export$3099d0daead893d3 = v);
var $0bee488caaed56c5$export$795623e8105ba10a;
var $0bee488caaed56c5$export$89da14300d534261;
var $0bee488caaed56c5$export$efe229eab43a9869;
var $0bee488caaed56c5$export$6abdc2947a758b6a;
var $0bee488caaed56c5$export$add244bda2f9423c;
var $0bee488caaed56c5$export$3099d0daead893d3;
$0bee488caaed56c5$export$795623e8105ba10a = `KYCa1W_actionBar`;
$0bee488caaed56c5$export$89da14300d534261 = `KYCa1W_active`;
$0bee488caaed56c5$export$efe229eab43a9869 = `KYCa1W_closeButton`;
$0bee488caaed56c5$export$6abdc2947a758b6a = `KYCa1W_modalClose`;
$0bee488caaed56c5$export$add244bda2f9423c = `KYCa1W_modalContent`;
$0bee488caaed56c5$export$3099d0daead893d3 = `KYCa1W_modalHeader`;

});



parcelRegister("3Yazj", function(module, exports) {

$parcel$export(module.exports, "default", () => $9017e0e969546b3f$export$2e2bcd8739ae039);

var $cKvYK = parcelRequire("cKvYK");

var $26Ddr = parcelRequire("26Ddr");

var $61JDm = parcelRequire("61JDm");

var $dZjxw = parcelRequire("dZjxw");

var $11vsd = parcelRequire("11vsd");
const $9017e0e969546b3f$var$DeleteModalBody = ({ query: query, id: id, closeModal: closeModal, onDelete: onDelete, content: content })=>{
    const del = (0, $26Ddr.useDelete)(id ? `${query}/${id}` : `${query}`, {
        onResolve: (res)=>{
            onDelete && onDelete(res);
            (0, $61JDm.default).success("L'\xe9l\xe9ment a bien \xe9t\xe9 supprim\xe9");
            closeModal();
        },
        onReject: async (error)=>{
            (0, $61JDm.default).error(/*#__PURE__*/ (0, $cKvYK.jsxs)((0, $cKvYK.Fragment), {
                children: [
                    "Erreur lors de la suppression de l'\xe9l\xe9ment",
                    " \xa0:",
                    " ",
                    await error.text()
                ]
            }));
            closeModal();
        }
    });
    return /*#__PURE__*/ (0, $cKvYK.jsxs)((0, $cKvYK.Fragment), {
        children: [
            /*#__PURE__*/ (0, $cKvYK.jsx)((0, $dZjxw.Content), {
                children: content
            }),
            /*#__PURE__*/ (0, $cKvYK.jsxs)((0, $dZjxw.ActionBar), {
                children: [
                    /*#__PURE__*/ (0, $cKvYK.jsx)("button", {
                        onClick: closeModal,
                        children: "Annuler"
                    }),
                    /*#__PURE__*/ (0, $cKvYK.jsx)("button", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($11vsd))).active,
                        onClick: async ()=>{
                            try {
                                await del.run();
                            } catch (e) {
                                (0, $61JDm.default).error(/*#__PURE__*/ (0, $cKvYK.jsxs)((0, $cKvYK.Fragment), {
                                    children: [
                                        "Erreur lors de la suppression de l'\xe9l\xe9ment",
                                        " \xa0:",
                                        " ",
                                        e.message
                                    ]
                                }));
                            }
                        },
                        children: "Valider"
                    })
                ]
            })
        ]
    });
};
const $9017e0e969546b3f$var$DeleteModal = ({ visible: visible, closeModal: closeModal, header: header = "Suppression d'un \xe9l\xe9ment", query: query, id: id, onDelete: onDelete, content: content = "Voulez-vous supprimer cet \xe9lement ?" })=>{
    return /*#__PURE__*/ (0, $cKvYK.jsx)((0, $dZjxw.default), {
        visible: visible,
        header: header,
        closeModal: closeModal,
        children: /*#__PURE__*/ (0, $cKvYK.jsx)($9017e0e969546b3f$var$DeleteModalBody, {
            query: query,
            id: id,
            closeModal: closeModal,
            onDelete: onDelete,
            content: content
        })
    });
};
var $9017e0e969546b3f$export$2e2bcd8739ae039 = $9017e0e969546b3f$var$DeleteModal;

});

parcelRegister("au7pA", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ab4e9a75cb9a4e8$export$2e2bcd8739ae039);

var $cKvYK = parcelRequire("cKvYK");

var $hkaOh = parcelRequire("hkaOh");

var $dZjxw = parcelRequire("dZjxw");
const $5ab4e9a75cb9a4e8$var$PreviewRessourceModal = ({ visible: visible, closeModal: closeModal, header: header, ressourceCode: ressourceCode, ressourceType: ressourceType, ressourcePrivee: ressourcePrivee })=>{
    return /*#__PURE__*/ (0, $cKvYK.jsx)((0, $dZjxw.default), {
        closeModal: closeModal,
        header: header,
        visible: visible,
        children: /*#__PURE__*/ (0, $cKvYK.jsx)("div", {
            children: /*#__PURE__*/ (0, $cKvYK.jsx)((0, $hkaOh.default), {
                code: ressourceCode,
                type: ressourceType,
                prive: ressourcePrivee
            })
        })
    });
};
var $5ab4e9a75cb9a4e8$export$2e2bcd8739ae039 = $5ab4e9a75cb9a4e8$var$PreviewRessourceModal;

});
parcelRegister("hkaOh", function(module, exports) {

$parcel$export(module.exports, "default", () => $99fd95e98ee6d0e9$export$2e2bcd8739ae039);

var $cKvYK = parcelRequire("cKvYK");

var $26Ddr = parcelRequire("26Ddr");

var $5TbRy = parcelRequire("5TbRy");

var $jeWlR = parcelRequire("jeWlR");
/**
 * Composant React représentant une ressource.
 * Ce composant affiche une ressource sous plusieurs formes (PDF, VIDEO...), en fonction du type spécifié.
 * La ressource peut être téléchargeable ou non, et est définie par une entité RessourceEntity.
 */ const $99fd95e98ee6d0e9$var$RessourceByCode = ({ code: code, type: type, prive: prive = true })=>{
    //si on veut un ressource public il faut le préciser
    const ressource = (0, $26Ddr.useGet)(prive ? (0, $5TbRy.default)`/api/ressource/get-ressource/` + code : (0, $5TbRy.default)`/api/public/ressource/get-ressource/` + code, {});
    if (!ressource.isResolved) return;
    return /*#__PURE__*/ (0, $cKvYK.jsx)((0, $jeWlR.default), {
        ressource: {
            url: ressource.data?.url,
            telechargeable: ressource.data?.telechargeable,
            soustitre: ressource.data?.soustitre
        },
        type: type
    });
};
var $99fd95e98ee6d0e9$export$2e2bcd8739ae039 = $99fd95e98ee6d0e9$var$RessourceByCode;

});
parcelRegister("jeWlR", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c4837ffe0cf15a7$export$2e2bcd8739ae039);

var $cKvYK = parcelRequire("cKvYK");

var $lgiU2 = parcelRequire("lgiU2");

var $7hZVf = parcelRequire("7hZVf");

var $l1428 = parcelRequire("l1428");

var $bYYyU = parcelRequire("bYYyU");

var $3RY61 = parcelRequire("3RY61");

var $aEZts = parcelRequire("aEZts");

var $9V8Ui = parcelRequire("9V8Ui");

var $gMzJI = parcelRequire("gMzJI");
/**
 * Composant React représentant une ressource.
 * Ce composant affiche une ressource sous plusieurs formes (PDF, VIDEO...), en fonction du type spécifié.
 * La ressource peut être téléchargeable ou non, et est définie par une entité RessourceEntity.
 */ const $8c4837ffe0cf15a7$var$Ressource = ({ ressource: { url: url, telechargeable: telechargeable = false, soustitre: soustitre }, type: type })=>{
    if (url == null) return /*#__PURE__*/ (0, $cKvYK.jsx)((0, $3RY61.default), {});
    switch(type){
        case (0, $l1428.default).VIDEO:
            return /*#__PURE__*/ (0, $cKvYK.jsx)((0, $9V8Ui.default), {
                telechargeable: telechargeable,
                url: url,
                soustitre: soustitre
            });
        case (0, $l1428.default).WEBGL:
            return /*#__PURE__*/ (0, $cKvYK.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($lgiU2)))((0, (/*@__PURE__*/$parcel$interopDefault($gMzJI))).center, (0, (/*@__PURE__*/$parcel$interopDefault($gMzJI))).height100),
                children: [
                    /*#__PURE__*/ (0, $cKvYK.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($gMzJI))).entete,
                        children: "R\xe9alit\xe9 virtuelle (2D)"
                    }),
                    "En cliquant sur le bouton, un nouvel onglet va s'ouvrir et vous permettra d'acc\xe9der \xe0 la ressource.",
                    /*#__PURE__*/ (0, $cKvYK.jsx)("br", {}),
                    "Le premier chargement de la page peut prendre plusieurs minutes.",
                    /*#__PURE__*/ (0, $cKvYK.jsx)("br", {}),
                    "Une fois le premier chargement fait, l\u2019acc\xe8s \xe0 cette page sera plus rapide. Merci de votre compr\xe9hension",
                    /*#__PURE__*/ (0, $cKvYK.jsx)("br", {}),
                    /*#__PURE__*/ (0, $cKvYK.jsx)("p", {
                        className: "text-muted fst-italic mt-3",
                        children: "La r\xe9alit\xe9 virtuelle n'est disponible ni sur mobile ni sur tablette."
                    }),
                    /*#__PURE__*/ (0, $cKvYK.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($gMzJI))).btnWebGl,
                        children: /*#__PURE__*/ (0, $cKvYK.jsx)((0, $bYYyU.LinkButton), {
                            href: (0, $7hZVf.URLS).WEBGL,
                            target: "_blank",
                            variant: (0, $bYYyU.VARIANTS).primary,
                            children: "Acc\xe9der \xe0 la ressource"
                        })
                    })
                ]
            });
        case (0, $l1428.default).BD:
        case (0, $l1428.default).PDF:
            return /*#__PURE__*/ (0, $cKvYK.jsx)((0, $aEZts.default), {
                url: url,
                telechargeable: telechargeable
            });
    }
};
var $8c4837ffe0cf15a7$export$2e2bcd8739ae039 = $8c4837ffe0cf15a7$var$Ressource;

});
parcelRegister("l1428", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c3e435c48bca7b8$export$2e2bcd8739ae039);
/**
 * Enumération définissant les types de ressources disponibles.
 */ var $2c3e435c48bca7b8$var$TYPE_RESSOURCE;
(function(TYPE_RESSOURCE) {
    TYPE_RESSOURCE["PDF"] = "PDF";
    TYPE_RESSOURCE["VIDEO"] = "VIDEO";
    TYPE_RESSOURCE["BD"] = "BD";
    TYPE_RESSOURCE["WEBGL"] = "WEBGL";
    TYPE_RESSOURCE["LINK"] = "LINK";
})($2c3e435c48bca7b8$var$TYPE_RESSOURCE || ($2c3e435c48bca7b8$var$TYPE_RESSOURCE = {}));
var $2c3e435c48bca7b8$export$2e2bcd8739ae039 = $2c3e435c48bca7b8$var$TYPE_RESSOURCE;

});

parcelRegister("aEZts", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f6fc2f43d7051c7$export$2e2bcd8739ae039);

var $cKvYK = parcelRequire("cKvYK");
parcelRequire("kc00y");

var $iSqLj = parcelRequire("iSqLj");
parcelRequire("hDZuH");
var $5rX9H = parcelRequire("5rX9H");

var $6eW0i = parcelRequire("6eW0i");



var $lgiU2 = parcelRequire("lgiU2");

var $4DyxQ = parcelRequire("4DyxQ");
var $469X3 = parcelRequire("469X3");

var $8pJh9 = parcelRequire("8pJh9");

var $iMAUV = parcelRequire("iMAUV");
const $8f6fc2f43d7051c7$var$renderError = ()=>{
    return /*#__PURE__*/ (0, $cKvYK.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($iMAUV))).containerError,
        children: /*#__PURE__*/ (0, $cKvYK.jsx)("p", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($iMAUV))).errorPdf,
            children: "Erreur lors du chargement du document"
        })
    });
};
const $8f6fc2f43d7051c7$var$ViewWithToolbar = ({ url: url, telechargeable: telechargeable = false })=>{
    const renderToolbar = (Toolbar)=>/*#__PURE__*/ (0, $cKvYK.jsx)(Toolbar, {
            children: (slots)=>{
                const { CurrentPageInput: CurrentPageInput, Download: Download, Print: Print, EnterFullScreen: EnterFullScreen, GoToNextPage: GoToNextPage, GoToPreviousPage: GoToPreviousPage, NumberOfPages: NumberOfPages, ShowSearchPopover: ShowSearchPopover, Zoom: Zoom, ZoomIn: ZoomIn, ZoomOut: ZoomOut } = slots;
                return /*#__PURE__*/ (0, $cKvYK.jsxs)((0, $469X3.default), {
                    children: [
                        /*#__PURE__*/ (0, $cKvYK.jsx)((0, $4DyxQ.default), {
                            className: "p-1",
                            children: /*#__PURE__*/ (0, $cKvYK.jsx)(ShowSearchPopover, {})
                        }),
                        /*#__PURE__*/ (0, $cKvYK.jsx)((0, $4DyxQ.default), {
                            className: "p-1",
                            children: /*#__PURE__*/ (0, $cKvYK.jsx)(ZoomOut, {})
                        }),
                        /*#__PURE__*/ (0, $cKvYK.jsx)((0, $4DyxQ.default), {
                            className: "p-1",
                            children: /*#__PURE__*/ (0, $cKvYK.jsx)(Zoom, {})
                        }),
                        /*#__PURE__*/ (0, $cKvYK.jsx)((0, $4DyxQ.default), {
                            className: "p-1",
                            children: /*#__PURE__*/ (0, $cKvYK.jsx)(ZoomIn, {})
                        }),
                        /*#__PURE__*/ (0, $cKvYK.jsx)((0, $4DyxQ.default), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($lgiU2)))((0, (/*@__PURE__*/$parcel$interopDefault($iMAUV))).btnRightPdf),
                            children: /*#__PURE__*/ (0, $cKvYK.jsx)(GoToPreviousPage, {})
                        }),
                        /*#__PURE__*/ (0, $cKvYK.jsxs)((0, $4DyxQ.default), {
                            className: "p-1",
                            children: [
                                /*#__PURE__*/ (0, $cKvYK.jsx)(CurrentPageInput, {}),
                                " / ",
                                /*#__PURE__*/ (0, $cKvYK.jsx)(NumberOfPages, {})
                            ]
                        }),
                        /*#__PURE__*/ (0, $cKvYK.jsx)((0, $4DyxQ.default), {
                            className: "p-1",
                            children: /*#__PURE__*/ (0, $cKvYK.jsx)(GoToNextPage, {})
                        }),
                        /*#__PURE__*/ (0, $cKvYK.jsx)((0, $4DyxQ.default), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($lgiU2)))((0, (/*@__PURE__*/$parcel$interopDefault($iMAUV))).btnRightPdf),
                            children: /*#__PURE__*/ (0, $cKvYK.jsx)(EnterFullScreen, {})
                        }),
                        telechargeable ? /*#__PURE__*/ (0, $cKvYK.jsxs)((0, $cKvYK.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $cKvYK.jsx)((0, $4DyxQ.default), {
                                    className: "p-1",
                                    children: /*#__PURE__*/ (0, $cKvYK.jsx)(Download, {})
                                }),
                                /*#__PURE__*/ (0, $cKvYK.jsx)((0, $4DyxQ.default), {
                                    className: "p-1",
                                    children: /*#__PURE__*/ (0, $cKvYK.jsx)(Print, {})
                                })
                            ]
                        }) : ""
                    ]
                });
            }
        });
    const defaultLayoutPluginInstance = (0, $iSqLj.defaultLayoutPlugin)({
        renderToolbar: renderToolbar
    });
    return /*#__PURE__*/ (0, $cKvYK.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($lgiU2)))((0, (/*@__PURE__*/$parcel$interopDefault($iMAUV))).worker, "px-0 px-md-2 px-lg-4"),
        children: /*#__PURE__*/ (0, $cKvYK.jsx)((0, $6eW0i.Worker), {
            workerUrl: `https://unpkg.com/pdfjs-dist@${(0, $5rX9H.default).version}/build/pdf.worker.min.js`,
            children: /*#__PURE__*/ (0, $cKvYK.jsx)("div", {
                className: "h-100 ",
                children: /*#__PURE__*/ (0, $cKvYK.jsx)((0, $6eW0i.Viewer), {
                    localization: (0, (/*@__PURE__*/$parcel$interopDefault($8pJh9))),
                    fileUrl: url,
                    plugins: [
                        defaultLayoutPluginInstance
                    ],
                    renderError: $8f6fc2f43d7051c7$var$renderError,
                    renderLoader: (percentages)=>/*#__PURE__*/ (0, $cKvYK.jsx)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($iMAUV))).progressBar,
                            children: /*#__PURE__*/ (0, $cKvYK.jsx)((0, $6eW0i.ProgressBar), {
                                progress: Math.round(percentages)
                            })
                        })
                })
            })
        })
    });
};
var $8f6fc2f43d7051c7$export$2e2bcd8739ae039 = $8f6fc2f43d7051c7$var$ViewWithToolbar;

});
parcelRegister("iSqLj", function(module, exports) {
/**
 * A React component to view a PDF document
 *
 * @see https://react-pdf-viewer.dev
 * @license https://react-pdf-viewer.dev/license
 * @copyright 2019-2023 Nguyen Huu Phuoc <me@phuoc.ng>
 */ "use strict";

module.exports = (parcelRequire("9IyMH"));

});
parcelRegister("9IyMH", function(module, exports) {

$parcel$export(module.exports, "BookmarkIcon", () => $71333496249819dd$export$93cb139c864b0aec, (v) => $71333496249819dd$export$93cb139c864b0aec = v);
$parcel$export(module.exports, "FileIcon", () => $71333496249819dd$export$8c1a3d13e85d78b7, (v) => $71333496249819dd$export$8c1a3d13e85d78b7 = v);
$parcel$export(module.exports, "ThumbnailIcon", () => $71333496249819dd$export$d61fb49b3a4eebd4, (v) => $71333496249819dd$export$d61fb49b3a4eebd4 = v);
$parcel$export(module.exports, "defaultLayoutPlugin", () => $71333496249819dd$export$f0ab1f6c1f39c4ee, (v) => $71333496249819dd$export$f0ab1f6c1f39c4ee = v);
$parcel$export(module.exports, "setInitialTabFromPageMode", () => $71333496249819dd$export$2ce7629f42bfdc0e, (v) => $71333496249819dd$export$2ce7629f42bfdc0e = v);
var $71333496249819dd$export$93cb139c864b0aec;
var $71333496249819dd$export$8c1a3d13e85d78b7;
var $71333496249819dd$export$d61fb49b3a4eebd4;
var $71333496249819dd$export$f0ab1f6c1f39c4ee;
var $71333496249819dd$export$2ce7629f42bfdc0e;
"use strict";

var $6eW0i = parcelRequire("6eW0i");

var $kc00y = parcelRequire("kc00y");

var $bpdtR = parcelRequire("bpdtR");

var $dCkkg = parcelRequire("dCkkg");

var $3vW7T = parcelRequire("3vW7T");

var $gmUVm = parcelRequire("gmUVm");
function $71333496249819dd$var$l(e) {
    var t = Object.create(null);
    return e && Object.keys(e).forEach(function(n) {
        if ("default" !== n) {
            var a = Object.getOwnPropertyDescriptor(e, n);
            Object.defineProperty(t, n, a.get ? a : {
                enumerable: !0,
                get: function() {
                    return e[n];
                }
            });
        }
    }), t.default = e, Object.freeze(t);
}
var $71333496249819dd$var$u = $71333496249819dd$var$l($kc00y), $71333496249819dd$var$c = function() {
    return $71333496249819dd$var$u.createElement($6eW0i.Icon, {
        size: 16
    }, $71333496249819dd$var$u.createElement("path", {
        d: "M11.5,1.5h11c0.552,0,1,0.448,1,1v20c0,0.552-0.448,1-1,1h-21c-0.552,0-1-0.448-1-1v-20c0-0.552,0.448-1,1-1h3\n            M11.5,10.5c0,0.55-0.3,0.661-0.659,0.248L8,7.5l-2.844,3.246c-0.363,0.414-0.659,0.3-0.659-0.247v-9c0-0.552,0.448-1,1-1h5\n            c0.552,0,1,0.448,1,1L11.5,10.5z\n            M14.5,6.499h6\n            M14.5,10.499h6\n            M3.5,14.499h17\n            M3.5,18.499h16.497"
    }));
}, $71333496249819dd$var$i = function() {
    return $71333496249819dd$var$i = Object.assign || function(e) {
        for(var t, n = 1, a = arguments.length; n < a; n++)for(var r in t = arguments[n])Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
        return e;
    }, $71333496249819dd$var$i.apply(this, arguments);
}, $71333496249819dd$var$s = function() {
    return $71333496249819dd$var$u.createElement($6eW0i.Icon, {
        size: 16
    }, $71333496249819dd$var$u.createElement("path", {
        d: "M7.618,15.345l8.666-8.666c0.78-0.812,2.071-0.838,2.883-0.058s0.838,2.071,0.058,2.883\n            c-0.019,0.02-0.038,0.039-0.058,0.058L7.461,21.305c-1.593,1.593-4.175,1.592-5.767,0s-1.592-4.175,0-5.767c0,0,0,0,0,0\n            L13.928,3.305c2.189-2.19,5.739-2.19,7.929-0.001s2.19,5.739,0,7.929l0,0L13.192,19.9"
    }));
}, $71333496249819dd$var$d = function() {
    return $71333496249819dd$var$u.createElement($6eW0i.Icon, {
        size: 16
    }, $71333496249819dd$var$u.createElement("path", {
        d: "M10.5,9.5c0,0.552-0.448,1-1,1h-8c-0.552,0-1-0.448-1-1v-8c0-0.552,0.448-1,1-1h8c0.552,0,1,0.448,1,1V9.5z\n            M23.5,9.5c0,0.552-0.448,1-1,1h-8c-0.552,0-1-0.448-1-1v-8c0-0.552,0.448-1,1-1h8c0.552,0,1,0.448,1,1V9.5z\n            M10.5,22.5 c0,0.552-0.448,1-1,1h-8c-0.552,0-1-0.448-1-1v-8c0-0.552,0.448-1,1-1h8c0.552,0,1,0.448,1,1V22.5z\n            M23.5,22.5c0,0.552-0.448,1-1,1 h-8c-0.552,0-1-0.448-1-1v-8c0-0.552,0.448-1,1-1h8c0.552,0,1,0.448,1,1V22.5z"
    }));
}, $71333496249819dd$var$b = {
    left: 8,
    top: 0
}, $71333496249819dd$var$f = {
    left: -8,
    top: 0
}, $71333496249819dd$var$m = function(t) {
    var n = t.attachmentTabContent, a = t.bookmarkTabContent, r = t.store, o = t.thumbnailTabContent, l = t.tabs, i = $71333496249819dd$var$u.useRef(), m = $71333496249819dd$var$u.useContext($6eW0i.LocalizationContext).l10n, h = $71333496249819dd$var$u.useState(r.get("isCurrentTabOpened") || !1), p = h[0], v = h[1], y = $71333496249819dd$var$u.useState(Math.max(r.get("currentTab") || 0, 0)), g = y[0], T = y[1], _ = $71333496249819dd$var$u.useContext($6eW0i.ThemeContext).direction === $6eW0i.TextDirection.RightToLeft, E = [
        {
            content: o,
            icon: $71333496249819dd$var$u.createElement($71333496249819dd$var$d, null),
            title: m && m.defaultLayout ? m.defaultLayout.thumbnail : "Thumbnail"
        },
        {
            content: a,
            icon: $71333496249819dd$var$u.createElement($71333496249819dd$var$c, null),
            title: m && m.defaultLayout ? m.defaultLayout.bookmark : "Bookmark"
        },
        {
            content: n,
            icon: $71333496249819dd$var$u.createElement($71333496249819dd$var$s, null),
            title: m && m.defaultLayout ? m.defaultLayout.attachment : "Attachment"
        }
    ], L = l ? l(E) : E, k = function(e) {
        e >= 0 && e <= L.length - 1 && (r.update("isCurrentTabOpened", !0), T(e));
    }, C = function(e) {
        v(e);
    };
    return $71333496249819dd$var$u.useEffect(function() {
        return r.subscribe("currentTab", k), r.subscribe("isCurrentTabOpened", C), function() {
            r.unsubscribe("currentTab", k), r.unsubscribe("isCurrentTabOpened", C);
        };
    }, []), 0 === L.length ? $71333496249819dd$var$u.createElement($71333496249819dd$var$u.Fragment, null) : $71333496249819dd$var$u.createElement($71333496249819dd$var$u.Fragment, null, $71333496249819dd$var$u.createElement("div", {
        "data-testid": "default-layout__sidebar",
        className: $6eW0i.classNames({
            "rpv-default-layout__sidebar": !0,
            "rpv-default-layout__sidebar--opened": p,
            "rpv-default-layout__sidebar--ltr": !_,
            "rpv-default-layout__sidebar--rtl": _
        }),
        ref: i
    }, $71333496249819dd$var$u.createElement("div", {
        className: "rpv-default-layout__sidebar-tabs"
    }, $71333496249819dd$var$u.createElement("div", {
        className: "rpv-default-layout__sidebar-headers",
        role: "tablist",
        "aria-orientation": "vertical"
    }, L.map(function(t, n) {
        return $71333496249819dd$var$u.createElement("div", {
            "aria-controls": "rpv-default-layout__sidebar-content",
            "aria-selected": g === n,
            key: n,
            className: "rpv-default-layout__sidebar-header",
            id: "rpv-default-layout__sidebar-tab-".concat(n),
            role: "tab"
        }, $71333496249819dd$var$u.createElement($6eW0i.Tooltip, {
            ariaControlsSuffix: "default-layout-sidebar-tab-".concat(n),
            position: _ ? $6eW0i.Position.LeftCenter : $6eW0i.Position.RightCenter,
            target: $71333496249819dd$var$u.createElement($6eW0i.MinimalButton, {
                ariaLabel: t.title,
                isSelected: g === n,
                onClick: function() {
                    return function(e) {
                        if (g === e) {
                            r.update("isCurrentTabOpened", !r.get("isCurrentTabOpened"));
                            var t = i.current;
                            t && t.style.width && t.style.removeProperty("width");
                        } else r.update("currentTab", e);
                    }(n);
                }
            }, t.icon),
            content: function() {
                return t.title;
            },
            offset: _ ? $71333496249819dd$var$f : $71333496249819dd$var$b
        }));
    })), $71333496249819dd$var$u.createElement("div", {
        "aria-labelledby": "rpv-default-layout__sidebar-tab-".concat(g),
        id: "rpv-default-layout__sidebar-content",
        className: $6eW0i.classNames({
            "rpv-default-layout__sidebar-content": !0,
            "rpv-default-layout__sidebar-content--opened": p,
            "rpv-default-layout__sidebar-content--ltr": !_,
            "rpv-default-layout__sidebar-content--rtl": _
        }),
        role: "tabpanel",
        tabIndex: -1
    }, L[g].content))), p && $71333496249819dd$var$u.createElement($6eW0i.Splitter, {
        constrain: function(e) {
            return e.firstHalfPercentage >= 20 && e.firstHalfPercentage <= 80;
        }
    }));
};
$71333496249819dd$export$93cb139c864b0aec = $71333496249819dd$var$c, $71333496249819dd$export$8c1a3d13e85d78b7 = $71333496249819dd$var$s, $71333496249819dd$export$d61fb49b3a4eebd4 = $71333496249819dd$var$d, $71333496249819dd$export$f0ab1f6c1f39c4ee = function(t) {
    var l = $71333496249819dd$var$u.useMemo(function() {
        return $6eW0i.createStore({
            isCurrentTabOpened: !1,
            currentTab: 0
        });
    }, []), c = $bpdtR.attachmentPlugin(), s = $dCkkg.bookmarkPlugin(), d = $3vW7T.thumbnailPlugin(t ? t.thumbnailPlugin : {}), b = $gmUVm.toolbarPlugin(t ? t.toolbarPlugin : {}), f = c.Attachments, h = s.Bookmarks, p = d.Thumbnails, v = b.Toolbar, y = t ? t.sidebarTabs : function(e) {
        return e;
    }, g = [
        c,
        s,
        d,
        b
    ];
    return {
        attachmentPluginInstance: c,
        bookmarkPluginInstance: s,
        thumbnailPluginInstance: d,
        toolbarPluginInstance: b,
        activateTab: function(e) {
            l.update("currentTab", e);
        },
        toggleTab: function(e) {
            var t = l.get("currentTab");
            l.update("isCurrentTabOpened", !l.get("isCurrentTabOpened")), t !== e && l.update("currentTab", e);
        },
        install: function(e) {
            g.forEach(function(t) {
                t.install && t.install(e);
            });
        },
        renderPageLayer: function(e) {
            return $71333496249819dd$var$u.createElement($71333496249819dd$var$u.Fragment, null, g.map(function(t, n) {
                return t.renderPageLayer ? $71333496249819dd$var$u.createElement($71333496249819dd$var$u.Fragment, {
                    key: n
                }, t.renderPageLayer(e)) : $71333496249819dd$var$u.createElement($71333496249819dd$var$u.Fragment, {
                    key: n
                }, $71333496249819dd$var$u.createElement($71333496249819dd$var$u.Fragment, null));
            }));
        },
        renderViewer: function(n) {
            var a = n.slot;
            g.forEach(function(e) {
                e.renderViewer && (a = e.renderViewer($71333496249819dd$var$i($71333496249819dd$var$i({}, n), {
                    slot: a
                })));
            });
            var r = a.subSlot && a.subSlot.attrs ? {
                className: a.subSlot.attrs.className,
                "data-testid": a.subSlot.attrs["data-testid"],
                ref: a.subSlot.attrs.ref,
                style: a.subSlot.attrs.style
            } : {};
            return a.children = $71333496249819dd$var$u.createElement("div", {
                className: "rpv-default-layout__container"
            }, $71333496249819dd$var$u.createElement("div", {
                "data-testid": "default-layout__main",
                className: $6eW0i.classNames({
                    "rpv-default-layout__main": !0,
                    "rpv-default-layout__main--rtl": n.themeContext.direction === $6eW0i.TextDirection.RightToLeft
                })
            }, $71333496249819dd$var$u.createElement($71333496249819dd$var$m, {
                attachmentTabContent: $71333496249819dd$var$u.createElement(f, null),
                bookmarkTabContent: $71333496249819dd$var$u.createElement(h, null),
                store: l,
                thumbnailTabContent: $71333496249819dd$var$u.createElement(p, null),
                tabs: y
            }), $71333496249819dd$var$u.createElement("div", {
                className: "rpv-default-layout__body",
                "data-testid": "default-layout__body"
            }, $71333496249819dd$var$u.createElement("div", {
                className: "rpv-default-layout__toolbar"
            }, t && t.renderToolbar ? t.renderToolbar(v) : $71333496249819dd$var$u.createElement(v, null)), $71333496249819dd$var$u.createElement("div", $71333496249819dd$var$i({}, r), a.subSlot.children))), a.children), a.subSlot.attrs = {}, a.subSlot.children = $71333496249819dd$var$u.createElement($71333496249819dd$var$u.Fragment, null), a;
        },
        uninstall: function(e) {
            g.forEach(function(t) {
                t.uninstall && t.uninstall(e);
            });
        },
        onDocumentLoad: function(e) {
            g.forEach(function(t) {
                t.onDocumentLoad && t.onDocumentLoad(e);
            }), t && t.setInitialTab && t.setInitialTab(e.doc).then(function(e) {
                l.update("currentTab", e), l.update("isCurrentTabOpened", !0);
            });
        },
        onAnnotationLayerRender: function(e) {
            g.forEach(function(t) {
                t.onAnnotationLayerRender && t.onAnnotationLayerRender(e);
            });
        },
        onTextLayerRender: function(e) {
            g.forEach(function(t) {
                t.onTextLayerRender && t.onTextLayerRender(e);
            });
        },
        onViewerStateChange: function(e) {
            var t = e;
            return g.forEach(function(e) {
                e.onViewerStateChange && (t = e.onViewerStateChange(t));
            }), t;
        }
    };
}, $71333496249819dd$export$2ce7629f42bfdc0e = function(t) {
    return new Promise(function(n, a) {
        t.getPageMode().then(function(t) {
            if (t) switch(t){
                case $6eW0i.PageMode.Attachments:
                    n(2);
                    break;
                case $6eW0i.PageMode.Bookmarks:
                    n(1);
                    break;
                case $6eW0i.PageMode.Thumbnails:
                    n(0);
                    break;
                default:
                    n(-1);
            }
            else n(-1);
        });
    });
};

});
parcelRegister("6eW0i", function(module, exports) {
/**
 * A React component to view a PDF document
 *
 * @see https://react-pdf-viewer.dev
 * @license https://react-pdf-viewer.dev/license
 * @copyright 2019-2023 Nguyen Huu Phuoc <me@phuoc.ng>
 */ "use strict";

module.exports = (parcelRequire("d1ZNn"));

});
parcelRegister("d1ZNn", function(module, exports) {

$parcel$export(module.exports, "AnnotationType", () => $97cb4d9d55c58c9c$export$f50c3066a53a6f2c, (v) => $97cb4d9d55c58c9c$export$f50c3066a53a6f2c = v);
$parcel$export(module.exports, "TextDirection", () => $97cb4d9d55c58c9c$export$63e1cbbb2c6e2c2, (v) => $97cb4d9d55c58c9c$export$63e1cbbb2c6e2c2 = v);
$parcel$export(module.exports, "ToggleStatus", () => $97cb4d9d55c58c9c$export$8f9a8eb37555b53e, (v) => $97cb4d9d55c58c9c$export$8f9a8eb37555b53e = v);
$parcel$export(module.exports, "Position", () => $97cb4d9d55c58c9c$export$13807d9ee5a34a42, (v) => $97cb4d9d55c58c9c$export$13807d9ee5a34a42 = v);
$parcel$export(module.exports, "FullScreenMode", () => $97cb4d9d55c58c9c$export$8245e75d48f7b7d8, (v) => $97cb4d9d55c58c9c$export$8245e75d48f7b7d8 = v);
$parcel$export(module.exports, "LayerRenderStatus", () => $97cb4d9d55c58c9c$export$44b6e2a92a1c449f, (v) => $97cb4d9d55c58c9c$export$44b6e2a92a1c449f = v);
$parcel$export(module.exports, "PageMode", () => $97cb4d9d55c58c9c$export$6ea4b0c62affbe44, (v) => $97cb4d9d55c58c9c$export$6ea4b0c62affbe44 = v);
$parcel$export(module.exports, "PasswordStatus", () => $97cb4d9d55c58c9c$export$51a8e1495775a8d0, (v) => $97cb4d9d55c58c9c$export$51a8e1495775a8d0 = v);
$parcel$export(module.exports, "RotateDirection", () => $97cb4d9d55c58c9c$export$9506977ce2a96a5b, (v) => $97cb4d9d55c58c9c$export$9506977ce2a96a5b = v);
$parcel$export(module.exports, "ScrollMode", () => $97cb4d9d55c58c9c$export$c8345932c0874cf8, (v) => $97cb4d9d55c58c9c$export$c8345932c0874cf8 = v);
$parcel$export(module.exports, "SpecialZoomLevel", () => $97cb4d9d55c58c9c$export$d3c2ac82f24f6349, (v) => $97cb4d9d55c58c9c$export$d3c2ac82f24f6349 = v);
$parcel$export(module.exports, "ViewMode", () => $97cb4d9d55c58c9c$export$53ec42062883b2d4, (v) => $97cb4d9d55c58c9c$export$53ec42062883b2d4 = v);
$parcel$export(module.exports, "Button", () => $97cb4d9d55c58c9c$export$353f5b6fc5456de1, (v) => $97cb4d9d55c58c9c$export$353f5b6fc5456de1 = v);
$parcel$export(module.exports, "Icon", () => $97cb4d9d55c58c9c$export$f04a61298a47a40f, (v) => $97cb4d9d55c58c9c$export$f04a61298a47a40f = v);
$parcel$export(module.exports, "LazyRender", () => $97cb4d9d55c58c9c$export$b50f6188b08ba944, (v) => $97cb4d9d55c58c9c$export$b50f6188b08ba944 = v);
$parcel$export(module.exports, "LocalizationContext", () => $97cb4d9d55c58c9c$export$51216bcc3983e55d, (v) => $97cb4d9d55c58c9c$export$51216bcc3983e55d = v);
$parcel$export(module.exports, "Menu", () => $97cb4d9d55c58c9c$export$d9b273488cd8ce6f, (v) => $97cb4d9d55c58c9c$export$d9b273488cd8ce6f = v);
$parcel$export(module.exports, "MenuDivider", () => $97cb4d9d55c58c9c$export$acb07b4664ac227c, (v) => $97cb4d9d55c58c9c$export$acb07b4664ac227c = v);
$parcel$export(module.exports, "MenuItem", () => $97cb4d9d55c58c9c$export$2ce376c2cc3355c8, (v) => $97cb4d9d55c58c9c$export$2ce376c2cc3355c8 = v);
$parcel$export(module.exports, "MinimalButton", () => $97cb4d9d55c58c9c$export$8df1b561423ecb3c, (v) => $97cb4d9d55c58c9c$export$8df1b561423ecb3c = v);
$parcel$export(module.exports, "Modal", () => $97cb4d9d55c58c9c$export$2b77a92f1a5ad772, (v) => $97cb4d9d55c58c9c$export$2b77a92f1a5ad772 = v);
$parcel$export(module.exports, "Popover", () => $97cb4d9d55c58c9c$export$5b6b19405a83ff9d, (v) => $97cb4d9d55c58c9c$export$5b6b19405a83ff9d = v);
$parcel$export(module.exports, "PrimaryButton", () => $97cb4d9d55c58c9c$export$ac16a6a04d9b7c84, (v) => $97cb4d9d55c58c9c$export$ac16a6a04d9b7c84 = v);
$parcel$export(module.exports, "ProgressBar", () => $97cb4d9d55c58c9c$export$c17561cb55d4db30, (v) => $97cb4d9d55c58c9c$export$c17561cb55d4db30 = v);
$parcel$export(module.exports, "Separator", () => $97cb4d9d55c58c9c$export$1ff3c3f08ae963c0, (v) => $97cb4d9d55c58c9c$export$1ff3c3f08ae963c0 = v);
$parcel$export(module.exports, "Spinner", () => $97cb4d9d55c58c9c$export$7f7cbe89f1eacd2, (v) => $97cb4d9d55c58c9c$export$7f7cbe89f1eacd2 = v);
$parcel$export(module.exports, "Splitter", () => $97cb4d9d55c58c9c$export$980082fdfafd21f8, (v) => $97cb4d9d55c58c9c$export$980082fdfafd21f8 = v);
$parcel$export(module.exports, "TextBox", () => $97cb4d9d55c58c9c$export$10e6f4f66014ee2d, (v) => $97cb4d9d55c58c9c$export$10e6f4f66014ee2d = v);
$parcel$export(module.exports, "ThemeContext", () => $97cb4d9d55c58c9c$export$2c657da244d00bd6, (v) => $97cb4d9d55c58c9c$export$2c657da244d00bd6 = v);
$parcel$export(module.exports, "Tooltip", () => $97cb4d9d55c58c9c$export$28c660c63b792dea, (v) => $97cb4d9d55c58c9c$export$28c660c63b792dea = v);
$parcel$export(module.exports, "Viewer", () => $97cb4d9d55c58c9c$export$2ec4afd9b3c16a85, (v) => $97cb4d9d55c58c9c$export$2ec4afd9b3c16a85 = v);
$parcel$export(module.exports, "Worker", () => $97cb4d9d55c58c9c$export$5ff70a18b7b7760a, (v) => $97cb4d9d55c58c9c$export$5ff70a18b7b7760a = v);
$parcel$export(module.exports, "chunk", () => $97cb4d9d55c58c9c$export$5f7ec48d69707ddd, (v) => $97cb4d9d55c58c9c$export$5f7ec48d69707ddd = v);
$parcel$export(module.exports, "classNames", () => $97cb4d9d55c58c9c$export$ce4ab0c55987d1ff, (v) => $97cb4d9d55c58c9c$export$ce4ab0c55987d1ff = v);
$parcel$export(module.exports, "createStore", () => $97cb4d9d55c58c9c$export$f51a9068ac82ea43, (v) => $97cb4d9d55c58c9c$export$f51a9068ac82ea43 = v);
$parcel$export(module.exports, "getDestination", () => $97cb4d9d55c58c9c$export$be071a6ef30bc5f7, (v) => $97cb4d9d55c58c9c$export$be071a6ef30bc5f7 = v);
$parcel$export(module.exports, "getPage", () => $97cb4d9d55c58c9c$export$c2a6433281518c91, (v) => $97cb4d9d55c58c9c$export$c2a6433281518c91 = v);
$parcel$export(module.exports, "isFullScreenEnabled", () => $97cb4d9d55c58c9c$export$33f0dd73c33219f6, (v) => $97cb4d9d55c58c9c$export$33f0dd73c33219f6 = v);
$parcel$export(module.exports, "isMac", () => $97cb4d9d55c58c9c$export$9ac100e40613ea10, (v) => $97cb4d9d55c58c9c$export$9ac100e40613ea10 = v);
$parcel$export(module.exports, "useDebounceCallback", () => $97cb4d9d55c58c9c$export$40ae01be0011c1e6, (v) => $97cb4d9d55c58c9c$export$40ae01be0011c1e6 = v);
$parcel$export(module.exports, "useIntersectionObserver", () => $97cb4d9d55c58c9c$export$a7395f9832c00176, (v) => $97cb4d9d55c58c9c$export$a7395f9832c00176 = v);
$parcel$export(module.exports, "useIsMounted", () => $97cb4d9d55c58c9c$export$80c2a3957bcb42ea, (v) => $97cb4d9d55c58c9c$export$80c2a3957bcb42ea = v);
$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $97cb4d9d55c58c9c$export$700979bc83e7db82, (v) => $97cb4d9d55c58c9c$export$700979bc83e7db82 = v);
$parcel$export(module.exports, "usePrevious", () => $97cb4d9d55c58c9c$export$5cae361ad82dce8b, (v) => $97cb4d9d55c58c9c$export$5cae361ad82dce8b = v);
$parcel$export(module.exports, "useRenderQueue", () => $97cb4d9d55c58c9c$export$435179e768913a4f, (v) => $97cb4d9d55c58c9c$export$435179e768913a4f = v);
var $97cb4d9d55c58c9c$export$f50c3066a53a6f2c;
var $97cb4d9d55c58c9c$export$63e1cbbb2c6e2c2;
var $97cb4d9d55c58c9c$export$8f9a8eb37555b53e;
var $97cb4d9d55c58c9c$export$13807d9ee5a34a42;
var $97cb4d9d55c58c9c$export$8245e75d48f7b7d8;
var $97cb4d9d55c58c9c$export$44b6e2a92a1c449f;
var $97cb4d9d55c58c9c$export$6ea4b0c62affbe44;
var $97cb4d9d55c58c9c$export$51a8e1495775a8d0;
var $97cb4d9d55c58c9c$export$9506977ce2a96a5b;
var $97cb4d9d55c58c9c$export$c8345932c0874cf8;
var $97cb4d9d55c58c9c$export$d3c2ac82f24f6349;
var $97cb4d9d55c58c9c$export$53ec42062883b2d4;
var $97cb4d9d55c58c9c$export$353f5b6fc5456de1;
var $97cb4d9d55c58c9c$export$f04a61298a47a40f;
var $97cb4d9d55c58c9c$export$b50f6188b08ba944;
var $97cb4d9d55c58c9c$export$51216bcc3983e55d;
var $97cb4d9d55c58c9c$export$d9b273488cd8ce6f;
var $97cb4d9d55c58c9c$export$acb07b4664ac227c;
var $97cb4d9d55c58c9c$export$2ce376c2cc3355c8;
var $97cb4d9d55c58c9c$export$8df1b561423ecb3c;
var $97cb4d9d55c58c9c$export$2b77a92f1a5ad772;
var $97cb4d9d55c58c9c$export$5b6b19405a83ff9d;
var $97cb4d9d55c58c9c$export$ac16a6a04d9b7c84;
var $97cb4d9d55c58c9c$export$c17561cb55d4db30;
var $97cb4d9d55c58c9c$export$1ff3c3f08ae963c0;
var $97cb4d9d55c58c9c$export$7f7cbe89f1eacd2;
var $97cb4d9d55c58c9c$export$980082fdfafd21f8;
var $97cb4d9d55c58c9c$export$10e6f4f66014ee2d;
var $97cb4d9d55c58c9c$export$2c657da244d00bd6;
var $97cb4d9d55c58c9c$export$28c660c63b792dea;
var $97cb4d9d55c58c9c$export$2ec4afd9b3c16a85;
var $97cb4d9d55c58c9c$export$5ff70a18b7b7760a;
var $97cb4d9d55c58c9c$export$5f7ec48d69707ddd;
var $97cb4d9d55c58c9c$export$ce4ab0c55987d1ff;
var $97cb4d9d55c58c9c$export$f51a9068ac82ea43;
var $97cb4d9d55c58c9c$export$be071a6ef30bc5f7;
var $97cb4d9d55c58c9c$export$c2a6433281518c91;
var $97cb4d9d55c58c9c$export$33f0dd73c33219f6;
var $97cb4d9d55c58c9c$export$9ac100e40613ea10;
var $97cb4d9d55c58c9c$export$40ae01be0011c1e6;
var $97cb4d9d55c58c9c$export$a7395f9832c00176;
var $97cb4d9d55c58c9c$export$80c2a3957bcb42ea;
var $97cb4d9d55c58c9c$export$700979bc83e7db82;
var $97cb4d9d55c58c9c$export$5cae361ad82dce8b;
var $97cb4d9d55c58c9c$export$435179e768913a4f;
"use strict";

var $kc00y = parcelRequire("kc00y");

var $633OE = parcelRequire("633OE");
function $97cb4d9d55c58c9c$var$n(e) {
    var t = Object.create(null);
    return e && Object.keys(e).forEach(function(n) {
        if ("default" !== n) {
            var r = Object.getOwnPropertyDescriptor(e, n);
            Object.defineProperty(t, n, r.get ? r : {
                enumerable: !0,
                get: function() {
                    return e[n];
                }
            });
        }
    }), t.default = e, Object.freeze(t);
}
var $97cb4d9d55c58c9c$var$r, $97cb4d9d55c58c9c$var$o = $97cb4d9d55c58c9c$var$n($kc00y), $97cb4d9d55c58c9c$var$a = $97cb4d9d55c58c9c$var$n($633OE);
$97cb4d9d55c58c9c$export$f50c3066a53a6f2c = void 0, ($97cb4d9d55c58c9c$var$r = $97cb4d9d55c58c9c$export$f50c3066a53a6f2c || ($97cb4d9d55c58c9c$export$f50c3066a53a6f2c = {}))[$97cb4d9d55c58c9c$var$r.Text = 1] = "Text", $97cb4d9d55c58c9c$var$r[$97cb4d9d55c58c9c$var$r.Link = 2] = "Link", $97cb4d9d55c58c9c$var$r[$97cb4d9d55c58c9c$var$r.FreeText = 3] = "FreeText", $97cb4d9d55c58c9c$var$r[$97cb4d9d55c58c9c$var$r.Line = 4] = "Line", $97cb4d9d55c58c9c$var$r[$97cb4d9d55c58c9c$var$r.Square = 5] = "Square", $97cb4d9d55c58c9c$var$r[$97cb4d9d55c58c9c$var$r.Circle = 6] = "Circle", $97cb4d9d55c58c9c$var$r[$97cb4d9d55c58c9c$var$r.Polygon = 7] = "Polygon", $97cb4d9d55c58c9c$var$r[$97cb4d9d55c58c9c$var$r.Polyline = 8] = "Polyline", $97cb4d9d55c58c9c$var$r[$97cb4d9d55c58c9c$var$r.Highlight = 9] = "Highlight", $97cb4d9d55c58c9c$var$r[$97cb4d9d55c58c9c$var$r.Underline = 10] = "Underline", $97cb4d9d55c58c9c$var$r[$97cb4d9d55c58c9c$var$r.Squiggly = 11] = "Squiggly", $97cb4d9d55c58c9c$var$r[$97cb4d9d55c58c9c$var$r.StrikeOut = 12] = "StrikeOut", $97cb4d9d55c58c9c$var$r[$97cb4d9d55c58c9c$var$r.Stamp = 13] = "Stamp", $97cb4d9d55c58c9c$var$r[$97cb4d9d55c58c9c$var$r.Caret = 14] = "Caret", $97cb4d9d55c58c9c$var$r[$97cb4d9d55c58c9c$var$r.Ink = 15] = "Ink", $97cb4d9d55c58c9c$var$r[$97cb4d9d55c58c9c$var$r.Popup = 16] = "Popup", $97cb4d9d55c58c9c$var$r[$97cb4d9d55c58c9c$var$r.FileAttachment = 17] = "FileAttachment";
var $97cb4d9d55c58c9c$var$i = function(e, t) {
    return $97cb4d9d55c58c9c$var$i = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(e, t) {
        e.__proto__ = t;
    } || function(e, t) {
        for(var n in t)Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }, $97cb4d9d55c58c9c$var$i(e, t);
};
function $97cb4d9d55c58c9c$var$c(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    function n() {
        this.constructor = e;
    }
    $97cb4d9d55c58c9c$var$i(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n);
}
var $97cb4d9d55c58c9c$var$s, $97cb4d9d55c58c9c$var$l = function() {
    return $97cb4d9d55c58c9c$var$l = Object.assign || function(e) {
        for(var t, n = 1, r = arguments.length; n < r; n++)for(var o in t = arguments[n])Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
    }, $97cb4d9d55c58c9c$var$l.apply(this, arguments);
};
$97cb4d9d55c58c9c$export$63e1cbbb2c6e2c2 = void 0, ($97cb4d9d55c58c9c$var$s = $97cb4d9d55c58c9c$export$63e1cbbb2c6e2c2 || ($97cb4d9d55c58c9c$export$63e1cbbb2c6e2c2 = {})).RightToLeft = "RTL", $97cb4d9d55c58c9c$var$s.LeftToRight = "LTR";
var $97cb4d9d55c58c9c$var$u, $97cb4d9d55c58c9c$var$p = $97cb4d9d55c58c9c$var$o.createContext({
    currentTheme: "light",
    direction: $97cb4d9d55c58c9c$export$63e1cbbb2c6e2c2.LeftToRight,
    setCurrentTheme: function() {}
}), $97cb4d9d55c58c9c$var$d = function(e) {
    var t = [];
    return Object.keys(e).forEach(function(n) {
        n && e[n] && t.push(n);
    }), t.join(" ");
}, $97cb4d9d55c58c9c$var$f = "undefined" != typeof window ? $97cb4d9d55c58c9c$var$o.useLayoutEffect : $97cb4d9d55c58c9c$var$o.useEffect, $97cb4d9d55c58c9c$var$g = function(e) {
    var t = $97cb4d9d55c58c9c$var$o.useRef(null), n = e.once, r = e.threshold, a = e.onVisibilityChanged;
    return $97cb4d9d55c58c9c$var$f(function() {
        var e = t.current;
        if (e) {
            var o = new IntersectionObserver(function(t) {
                t.forEach(function(t) {
                    var r = t.isIntersecting, i = t.intersectionRatio;
                    a({
                        isVisible: r,
                        ratio: i
                    }), r && n && (o.unobserve(e), o.disconnect());
                });
            }, {
                threshold: r || 0
            });
            return o.observe(e), function() {
                o.unobserve(e), o.disconnect();
            };
        }
    }, []), t;
}, $97cb4d9d55c58c9c$var$v = function(e) {
    var t = e.children, n = e.ignoreDirection, r = void 0 !== n && n, a = e.size, i = void 0 === a ? 24 : a, c = $97cb4d9d55c58c9c$var$o.useContext($97cb4d9d55c58c9c$var$p).direction, s = !r && c === $97cb4d9d55c58c9c$export$63e1cbbb2c6e2c2.RightToLeft, l = "".concat(i || 24, "px");
    return $97cb4d9d55c58c9c$var$o.createElement("svg", {
        "aria-hidden": "true",
        className: $97cb4d9d55c58c9c$var$d({
            "rpv-core__icon": !0,
            "rpv-core__icon--rtl": s
        }),
        focusable: "false",
        height: l,
        viewBox: "0 0 24 24",
        width: l
    }, t);
}, $97cb4d9d55c58c9c$var$h = function() {
    return $97cb4d9d55c58c9c$var$o.createElement($97cb4d9d55c58c9c$var$v, {
        size: 16
    }, $97cb4d9d55c58c9c$var$o.createElement("path", {
        d: "M23.5,0.499l-16.5,23l-6.5-6.5"
    }));
}, $97cb4d9d55c58c9c$var$m = function(e) {
    var t = e.children, n = e.testId, r = e.onClick, a = $97cb4d9d55c58c9c$var$o.useContext($97cb4d9d55c58c9c$var$p).direction === $97cb4d9d55c58c9c$export$63e1cbbb2c6e2c2.RightToLeft, i = n ? {
        "data-testid": n
    } : {};
    return $97cb4d9d55c58c9c$var$o.createElement("button", $97cb4d9d55c58c9c$var$l({
        className: $97cb4d9d55c58c9c$var$d({
            "rpv-core__primary-button": !0,
            "rpv-core__primary-button--rtl": a
        }),
        type: "button",
        onClick: r
    }, i), t);
}, $97cb4d9d55c58c9c$var$x = function(e) {
    var t = e.size, n = void 0 === t ? "4rem" : t, r = e.testId, a = $97cb4d9d55c58c9c$var$o.useState(!1), i = a[0], c = a[1], s = r ? {
        "data-testid": r
    } : {}, u = $97cb4d9d55c58c9c$var$g({
        onVisibilityChanged: function(e) {
            c(e.isVisible);
        }
    });
    return $97cb4d9d55c58c9c$var$o.createElement("div", $97cb4d9d55c58c9c$var$l({}, s, {
        className: $97cb4d9d55c58c9c$var$d({
            "rpv-core__spinner": !0,
            "rpv-core__spinner--animating": i
        }),
        ref: u,
        style: {
            height: n,
            width: n
        }
    }));
}, $97cb4d9d55c58c9c$var$w = function(e) {
    var t = e.ariaLabel, n = void 0 === t ? "" : t, r = e.autoFocus, a = void 0 !== r && r, i = e.placeholder, c = void 0 === i ? "" : i, s = e.testId, u = e.type, g = void 0 === u ? "text" : u, v = e.value, h = void 0 === v ? "" : v, m = e.onChange, x = e.onKeyDown, w = void 0 === x ? function() {} : x, E = $97cb4d9d55c58c9c$var$o.useContext($97cb4d9d55c58c9c$var$p).direction, b = $97cb4d9d55c58c9c$var$o.useRef(), y = E === $97cb4d9d55c58c9c$export$63e1cbbb2c6e2c2.RightToLeft, S = {
        ref: b,
        "data-testid": "",
        "aria-label": n,
        className: $97cb4d9d55c58c9c$var$d({
            "rpv-core__textbox": !0,
            "rpv-core__textbox--rtl": y
        }),
        placeholder: c,
        value: h,
        onChange: function(e) {
            return m(e.target.value);
        },
        onKeyDown: w
    };
    return s && (S["data-testid"] = s), $97cb4d9d55c58c9c$var$f(function() {
        if (a) {
            var e = b.current;
            if (e) {
                var t = window.scrollX, n = window.scrollY;
                e.focus(), window.scrollTo(t, n);
            }
        }
    }, []), "text" === g ? $97cb4d9d55c58c9c$var$o.createElement("input", $97cb4d9d55c58c9c$var$l({
        type: "text"
    }, S)) : $97cb4d9d55c58c9c$var$o.createElement("input", $97cb4d9d55c58c9c$var$l({
        type: "password"
    }, S));
};
!function(e) {
    e[e.ExitFullScreen = 0] = "ExitFullScreen", e[e.FullScreenChange = 1] = "FullScreenChange", e[e.FullScreenElement = 2] = "FullScreenElement", e[e.FullScreenEnabled = 3] = "FullScreenEnabled", e[e.RequestFullScreen = 4] = "RequestFullScreen";
}($97cb4d9d55c58c9c$var$u || ($97cb4d9d55c58c9c$var$u = {}));
var $97cb4d9d55c58c9c$var$E, $97cb4d9d55c58c9c$var$b = {
    ExitFullScreen: "exitFullscreen",
    FullScreenChange: "fullscreenchange",
    FullScreenElement: "fullscreenElement",
    FullScreenEnabled: "fullscreenEnabled",
    RequestFullScreen: "requestFullscreen"
}, $97cb4d9d55c58c9c$var$y = {
    ExitFullScreen: "webkitExitFullscreen",
    FullScreenChange: "webkitfullscreenchange",
    FullScreenElement: "webkitFullscreenElement",
    FullScreenEnabled: "webkitFullscreenEnabled",
    RequestFullScreen: "webkitRequestFullscreen"
}, $97cb4d9d55c58c9c$var$S = {
    ExitFullScreen: "msExitFullscreen",
    FullScreenChange: "msFullscreenChange",
    FullScreenElement: "msFullscreenElement",
    FullScreenEnabled: "msFullscreenEnabled",
    RequestFullScreen: "msRequestFullscreen"
}, $97cb4d9d55c58c9c$var$_ = "undefined" != typeof window, $97cb4d9d55c58c9c$var$P = $97cb4d9d55c58c9c$var$_ && ($97cb4d9d55c58c9c$var$u.FullScreenEnabled in document && $97cb4d9d55c58c9c$var$b || $97cb4d9d55c58c9c$var$y.FullScreenEnabled in document && $97cb4d9d55c58c9c$var$y || $97cb4d9d55c58c9c$var$S.FullScreenEnabled in document && $97cb4d9d55c58c9c$var$S) || $97cb4d9d55c58c9c$var$b, $97cb4d9d55c58c9c$var$R = function() {
    return $97cb4d9d55c58c9c$var$_ && $97cb4d9d55c58c9c$var$P.FullScreenEnabled in document && !0 === document[$97cb4d9d55c58c9c$var$P.FullScreenEnabled];
}, $97cb4d9d55c58c9c$var$M = function(e) {
    return $97cb4d9d55c58c9c$var$_ ? e[$97cb4d9d55c58c9c$var$P.ExitFullScreen]() : Promise.resolve({});
}, $97cb4d9d55c58c9c$var$k = function() {
    return $97cb4d9d55c58c9c$var$_ ? document[$97cb4d9d55c58c9c$var$P.FullScreenElement] : null;
}, $97cb4d9d55c58c9c$var$C = function(e, t) {
    var n = $97cb4d9d55c58c9c$var$o.useRef(), r = function() {
        n.current && clearTimeout(n.current);
    };
    return $97cb4d9d55c58c9c$var$o.useEffect(function() {
        return function() {
            return r();
        };
    }, []), $97cb4d9d55c58c9c$var$o.useCallback(function() {
        for(var o = [], a = 0; a < arguments.length; a++)o[a] = arguments[a];
        r(), n.current = setTimeout(function() {
            e.apply(void 0, o);
        }, t);
    }, [
        e,
        t
    ]);
}, $97cb4d9d55c58c9c$var$T = function() {
    var e = $97cb4d9d55c58c9c$var$o.useRef(!1);
    return $97cb4d9d55c58c9c$var$o.useEffect(function() {
        return e.current = !0, function() {
            e.current = !1;
        };
    }, []), e;
}, $97cb4d9d55c58c9c$var$L = function(e) {
    var t = $97cb4d9d55c58c9c$var$o.useRef(e);
    return $97cb4d9d55c58c9c$var$o.useEffect(function() {
        t.current = e;
    }, [
        e
    ]), t.current;
};
!function(e) {
    e.NotRenderedYet = "NotRenderedYet", e.Rendering = "Rendering", e.Rendered = "Rendered";
}($97cb4d9d55c58c9c$var$E || ($97cb4d9d55c58c9c$var$E = {}));
var $97cb4d9d55c58c9c$var$O, $97cb4d9d55c58c9c$var$F = -9999, $97cb4d9d55c58c9c$var$D = function(e) {
    var t = e.doc, n = t.numPages, r = t.loadingTask.docId, a = $97cb4d9d55c58c9c$var$o.useMemo(function() {
        return Array(n).fill(null).map(function(e, t) {
            return {
                pageIndex: t,
                renderStatus: $97cb4d9d55c58c9c$var$E.NotRenderedYet,
                visibility: $97cb4d9d55c58c9c$var$F
            };
        });
    }, [
        r
    ]), i = $97cb4d9d55c58c9c$var$o.useRef({
        currentRenderingPage: -1,
        startRange: 0,
        endRange: n - 1,
        visibilities: a
    }), c = function(e, t) {
        i.current.visibilities[e].visibility = t;
    };
    return {
        getHighestPriorityPage: function() {
            var e = i.current.visibilities.slice(i.current.startRange, i.current.endRange + 1).filter(function(e) {
                return e.visibility > $97cb4d9d55c58c9c$var$F;
            });
            if (!e.length) return -1;
            for(var t = e[0].pageIndex, r = e[e.length - 1].pageIndex, o = e.length, a = 0; a < o; a++){
                if (e[a].renderStatus === $97cb4d9d55c58c9c$var$E.Rendering) return -1;
                if (e[a].renderStatus === $97cb4d9d55c58c9c$var$E.NotRenderedYet) return e[a].pageIndex;
            }
            return r + 1 < n && i.current.visibilities[r + 1].renderStatus !== $97cb4d9d55c58c9c$var$E.Rendered ? r + 1 : t - 1 >= 0 && i.current.visibilities[t - 1].renderStatus !== $97cb4d9d55c58c9c$var$E.Rendered ? t - 1 : -1;
        },
        isInRange: function(e) {
            return e >= i.current.startRange && e <= i.current.endRange;
        },
        markNotRendered: function() {
            for(var e = 0; e < n; e++)i.current.visibilities[e].renderStatus = $97cb4d9d55c58c9c$var$E.NotRenderedYet;
        },
        markRendered: function(e) {
            i.current.visibilities[e].renderStatus = $97cb4d9d55c58c9c$var$E.Rendered;
        },
        markRendering: function(e) {
            -1 !== i.current.currentRenderingPage && i.current.currentRenderingPage !== e && i.current.visibilities[i.current.currentRenderingPage].renderStatus === $97cb4d9d55c58c9c$var$E.Rendering && (i.current.visibilities[i.current.currentRenderingPage].renderStatus = $97cb4d9d55c58c9c$var$E.NotRenderedYet), i.current.visibilities[e].renderStatus = $97cb4d9d55c58c9c$var$E.Rendering, i.current.currentRenderingPage = e;
        },
        setOutOfRange: function(e) {
            c(e, $97cb4d9d55c58c9c$var$F);
        },
        setRange: function(e, t) {
            i.current.startRange = e, i.current.endRange = t;
            for(var r = 0; r < n; r++)(r < e || r > t) && (i.current.visibilities[r].visibility = $97cb4d9d55c58c9c$var$F, i.current.visibilities[r].renderStatus = $97cb4d9d55c58c9c$var$E.NotRenderedYet);
        },
        setVisibility: c
    };
}, $97cb4d9d55c58c9c$var$I = {
    core: {
        askingPassword: {
            requirePasswordToOpen: "This document requires a password to open",
            submit: "Submit"
        },
        wrongPassword: {
            tryAgain: "The password is wrong. Please try again"
        },
        pageLabel: "Page {{pageIndex}}"
    }
}, $97cb4d9d55c58c9c$var$A = $97cb4d9d55c58c9c$var$o.createContext({
    l10n: $97cb4d9d55c58c9c$var$I,
    setL10n: function() {}
}), $97cb4d9d55c58c9c$var$H = 0, $97cb4d9d55c58c9c$var$N = function() {
    return $97cb4d9d55c58c9c$var$H++;
}, $97cb4d9d55c58c9c$var$V = function(e, t, n) {
    var r = function(e) {
        var r = t.current;
        if (r) {
            var o = e.target;
            if (o instanceof Element && o.shadowRoot) {
                var a = e.composedPath();
                a.length > 0 && !r.contains(a[0]) && n();
            } else r.contains(o) || n();
        }
    };
    $97cb4d9d55c58c9c$var$o.useEffect(function() {
        if (e) {
            var t = {
                capture: !0
            };
            return document.addEventListener("click", r, t), function() {
                document.removeEventListener("click", r, t);
            };
        }
    }, []);
}, $97cb4d9d55c58c9c$var$z = function(e) {
    var t = function(t) {
        "Escape" === t.key && e();
    };
    $97cb4d9d55c58c9c$var$o.useEffect(function() {
        return document.addEventListener("keyup", t), function() {
            document.removeEventListener("keyup", t);
        };
    }, []);
}, $97cb4d9d55c58c9c$var$B = function(e) {
    var t = e.ariaControlsSuffix, n = e.children, r = e.closeOnClickOutside, a = e.closeOnEscape, i = e.onToggle, c = $97cb4d9d55c58c9c$var$o.useRef(), s = $97cb4d9d55c58c9c$var$o.useContext($97cb4d9d55c58c9c$var$p).direction === $97cb4d9d55c58c9c$export$63e1cbbb2c6e2c2.RightToLeft;
    return $97cb4d9d55c58c9c$var$o.useEffect(function() {
        var e = window.getComputedStyle(document.body).overflow;
        return document.body.style.overflow = "hidden", function() {
            document.body.style.overflow = e;
        };
    }, []), $97cb4d9d55c58c9c$var$z(function() {
        c.current && a && i();
    }), $97cb4d9d55c58c9c$var$V(r, c, i), $97cb4d9d55c58c9c$var$f(function() {
        var e = c.current;
        if (e) {
            var t = .75 * document.body.clientHeight;
            e.getBoundingClientRect().height >= t && (e.style.overflow = "auto", e.style.maxHeight = "".concat(t, "px"));
        }
    }, []), $97cb4d9d55c58c9c$var$o.createElement("div", {
        "aria-modal": "true",
        className: $97cb4d9d55c58c9c$var$d({
            "rpv-core__modal-body": !0,
            "rpv-core__modal-body--rtl": s
        }),
        id: "rpv-core__modal-body-".concat(t),
        ref: c,
        role: "dialog",
        tabIndex: -1
    }, n);
}, $97cb4d9d55c58c9c$var$W = function(e) {
    var t = e.children;
    return $97cb4d9d55c58c9c$var$o.createElement("div", {
        className: "rpv-core__modal-overlay"
    }, t);
};
$97cb4d9d55c58c9c$export$8f9a8eb37555b53e = void 0, ($97cb4d9d55c58c9c$var$O = $97cb4d9d55c58c9c$export$8f9a8eb37555b53e || ($97cb4d9d55c58c9c$export$8f9a8eb37555b53e = {})).Close = "Close", $97cb4d9d55c58c9c$var$O.Open = "Open", $97cb4d9d55c58c9c$var$O.Toggle = "Toggle";
var $97cb4d9d55c58c9c$var$j, $97cb4d9d55c58c9c$var$q = function(e) {
    var t = $97cb4d9d55c58c9c$var$o.useState(e), n = t[0], r = t[1];
    return {
        opened: n,
        toggle: function(e) {
            switch(e){
                case $97cb4d9d55c58c9c$export$8f9a8eb37555b53e.Close:
                    r(!1);
                    break;
                case $97cb4d9d55c58c9c$export$8f9a8eb37555b53e.Open:
                    r(!0);
                    break;
                case $97cb4d9d55c58c9c$export$8f9a8eb37555b53e.Toggle:
                default:
                    r(function(e) {
                        return !e;
                    });
            }
        }
    };
}, $97cb4d9d55c58c9c$var$U = function(e) {
    var t = e.content, n = e.isOpened, r = void 0 !== n && n, a = e.target, i = $97cb4d9d55c58c9c$var$q(r), c = i.opened, s = i.toggle;
    return $97cb4d9d55c58c9c$var$o.createElement($97cb4d9d55c58c9c$var$o.Fragment, null, a && a(s, c), c && t(s));
};
$97cb4d9d55c58c9c$export$13807d9ee5a34a42 = void 0, ($97cb4d9d55c58c9c$var$j = $97cb4d9d55c58c9c$export$13807d9ee5a34a42 || ($97cb4d9d55c58c9c$export$13807d9ee5a34a42 = {})).TopLeft = "TOP_LEFT", $97cb4d9d55c58c9c$var$j.TopCenter = "TOP_CENTER", $97cb4d9d55c58c9c$var$j.TopRight = "TOP_RIGHT", $97cb4d9d55c58c9c$var$j.RightTop = "RIGHT_TOP", $97cb4d9d55c58c9c$var$j.RightCenter = "RIGHT_CENTER", $97cb4d9d55c58c9c$var$j.RightBottom = "RIGHT_BOTTOM", $97cb4d9d55c58c9c$var$j.BottomLeft = "BOTTOM_LEFT", $97cb4d9d55c58c9c$var$j.BottomCenter = "BOTTOM_CENTER", $97cb4d9d55c58c9c$var$j.BottomRight = "BOTTOM_RIGHT", $97cb4d9d55c58c9c$var$j.LeftTop = "LEFT_TOP", $97cb4d9d55c58c9c$var$j.LeftCenter = "LEFT_CENTER", $97cb4d9d55c58c9c$var$j.LeftBottom = "LEFT_BOTTOM";
var $97cb4d9d55c58c9c$var$Z, $97cb4d9d55c58c9c$var$J, $97cb4d9d55c58c9c$var$G, $97cb4d9d55c58c9c$var$Y, $97cb4d9d55c58c9c$var$K, $97cb4d9d55c58c9c$var$X, $97cb4d9d55c58c9c$var$Q, $97cb4d9d55c58c9c$var$$, $97cb4d9d55c58c9c$var$ee = function(e, t, n, r, o) {
    $97cb4d9d55c58c9c$var$f(function() {
        var a = t.current, i = e.current, c = n.current;
        if (i && a && c) {
            var s = c.getBoundingClientRect(), l = function(e, t, n, r) {
                var o = t.getBoundingClientRect(), a = e.getBoundingClientRect(), i = a.height, c = a.width, s = 0, l = 0;
                switch(n){
                    case $97cb4d9d55c58c9c$export$13807d9ee5a34a42.TopLeft:
                        s = o.top - i, l = o.left;
                        break;
                    case $97cb4d9d55c58c9c$export$13807d9ee5a34a42.TopCenter:
                        s = o.top - i, l = o.left + o.width / 2 - c / 2;
                        break;
                    case $97cb4d9d55c58c9c$export$13807d9ee5a34a42.TopRight:
                        s = o.top - i, l = o.left + o.width - c;
                        break;
                    case $97cb4d9d55c58c9c$export$13807d9ee5a34a42.RightTop:
                        s = o.top, l = o.left + o.width;
                        break;
                    case $97cb4d9d55c58c9c$export$13807d9ee5a34a42.RightCenter:
                        s = o.top + o.height / 2 - i / 2, l = o.left + o.width;
                        break;
                    case $97cb4d9d55c58c9c$export$13807d9ee5a34a42.RightBottom:
                        s = o.top + o.height - i, l = o.left + o.width;
                        break;
                    case $97cb4d9d55c58c9c$export$13807d9ee5a34a42.BottomLeft:
                        s = o.top + o.height, l = o.left;
                        break;
                    case $97cb4d9d55c58c9c$export$13807d9ee5a34a42.BottomCenter:
                        s = o.top + o.height, l = o.left + o.width / 2 - c / 2;
                        break;
                    case $97cb4d9d55c58c9c$export$13807d9ee5a34a42.BottomRight:
                        s = o.top + o.height, l = o.left + o.width - c;
                        break;
                    case $97cb4d9d55c58c9c$export$13807d9ee5a34a42.LeftTop:
                        s = o.top, l = o.left - c;
                        break;
                    case $97cb4d9d55c58c9c$export$13807d9ee5a34a42.LeftCenter:
                        s = o.top + o.height / 2 - i / 2, l = o.left - c;
                        break;
                    case $97cb4d9d55c58c9c$export$13807d9ee5a34a42.LeftBottom:
                        s = o.top + o.height - i, l = o.left - c;
                }
                return {
                    left: l + (r.left || 0),
                    top: s + (r.top || 0)
                };
            }(i, a, r, o), u = l.top, p = l.left;
            i.style.top = "".concat(u - s.top, "px"), i.style.left = "".concat(p - s.left, "px");
        }
    }, []);
}, $97cb4d9d55c58c9c$var$te = function(e) {
    var t, n = e.customClassName, r = e.position;
    return $97cb4d9d55c58c9c$var$o.createElement("div", {
        className: $97cb4d9d55c58c9c$var$d((t = {
            "rpv-core__arrow": !0,
            "rpv-core__arrow--tl": r === $97cb4d9d55c58c9c$export$13807d9ee5a34a42.TopLeft,
            "rpv-core__arrow--tc": r === $97cb4d9d55c58c9c$export$13807d9ee5a34a42.TopCenter,
            "rpv-core__arrow--tr": r === $97cb4d9d55c58c9c$export$13807d9ee5a34a42.TopRight,
            "rpv-core__arrow--rt": r === $97cb4d9d55c58c9c$export$13807d9ee5a34a42.RightTop,
            "rpv-core__arrow--rc": r === $97cb4d9d55c58c9c$export$13807d9ee5a34a42.RightCenter,
            "rpv-core__arrow--rb": r === $97cb4d9d55c58c9c$export$13807d9ee5a34a42.RightBottom,
            "rpv-core__arrow--bl": r === $97cb4d9d55c58c9c$export$13807d9ee5a34a42.BottomLeft,
            "rpv-core__arrow--bc": r === $97cb4d9d55c58c9c$export$13807d9ee5a34a42.BottomCenter,
            "rpv-core__arrow--br": r === $97cb4d9d55c58c9c$export$13807d9ee5a34a42.BottomRight,
            "rpv-core__arrow--lt": r === $97cb4d9d55c58c9c$export$13807d9ee5a34a42.LeftTop,
            "rpv-core__arrow--lc": r === $97cb4d9d55c58c9c$export$13807d9ee5a34a42.LeftCenter,
            "rpv-core__arrow--lb": r === $97cb4d9d55c58c9c$export$13807d9ee5a34a42.LeftBottom
        }, t["".concat(n)] = "" !== n, t))
    });
}, $97cb4d9d55c58c9c$var$ne = function(e) {
    var t = e.ariaControlsSuffix, n = e.children, r = e.closeOnClickOutside, a = e.offset, i = e.position, c = e.targetRef, s = e.onClose, l = $97cb4d9d55c58c9c$var$o.useRef(), u = $97cb4d9d55c58c9c$var$o.useRef(), g = $97cb4d9d55c58c9c$var$o.useRef(), v = $97cb4d9d55c58c9c$var$o.useContext($97cb4d9d55c58c9c$var$p).direction === $97cb4d9d55c58c9c$export$63e1cbbb2c6e2c2.RightToLeft;
    $97cb4d9d55c58c9c$var$V(r, l, s), $97cb4d9d55c58c9c$var$ee(l, c, g, i, a), $97cb4d9d55c58c9c$var$f(function() {
        var e = u.current;
        if (e) {
            var t = .75 * document.body.clientHeight;
            e.getBoundingClientRect().height >= t && (e.style.overflow = "auto", e.style.maxHeight = "".concat(t, "px"));
        }
    }, []);
    var h = "rpv-core__popover-body-inner-".concat(t);
    return $97cb4d9d55c58c9c$var$o.createElement($97cb4d9d55c58c9c$var$o.Fragment, null, $97cb4d9d55c58c9c$var$o.createElement("div", {
        ref: g,
        style: {
            left: 0,
            position: "absolute",
            top: 0
        }
    }), $97cb4d9d55c58c9c$var$o.createElement("div", {
        "aria-describedby": h,
        className: $97cb4d9d55c58c9c$var$d({
            "rpv-core__popover-body": !0,
            "rpv-core__popover-body--rtl": v
        }),
        id: "rpv-core__popover-body-".concat(t),
        ref: l,
        role: "dialog",
        tabIndex: -1
    }, $97cb4d9d55c58c9c$var$o.createElement($97cb4d9d55c58c9c$var$te, {
        customClassName: "rpv-core__popover-body-arrow",
        position: i
    }), $97cb4d9d55c58c9c$var$o.createElement("div", {
        id: h,
        ref: u
    }, n)));
}, $97cb4d9d55c58c9c$var$re = function(e) {
    var t = e.closeOnEscape, n = e.onClose, r = $97cb4d9d55c58c9c$var$o.useRef();
    return $97cb4d9d55c58c9c$var$z(function() {
        r.current && t && n();
    }), $97cb4d9d55c58c9c$var$o.createElement("div", {
        className: "rpv-core__popover-overlay",
        ref: r
    });
}, $97cb4d9d55c58c9c$var$oe = function(e) {
    var t = e.ariaControlsSuffix, n = e.children, r = e.contentRef, a = e.offset, i = e.position, c = e.targetRef, s = $97cb4d9d55c58c9c$var$o.useRef(), l = $97cb4d9d55c58c9c$var$o.useContext($97cb4d9d55c58c9c$var$p).direction === $97cb4d9d55c58c9c$export$63e1cbbb2c6e2c2.RightToLeft;
    return $97cb4d9d55c58c9c$var$ee(r, c, s, i, a), $97cb4d9d55c58c9c$var$o.createElement($97cb4d9d55c58c9c$var$o.Fragment, null, $97cb4d9d55c58c9c$var$o.createElement("div", {
        ref: s,
        style: {
            left: 0,
            position: "absolute",
            top: 0
        }
    }), $97cb4d9d55c58c9c$var$o.createElement("div", {
        className: $97cb4d9d55c58c9c$var$d({
            "rpv-core__tooltip-body": !0,
            "rpv-core__tooltip-body--rtl": l
        }),
        id: "rpv-core__tooltip-body-".concat(t),
        ref: r,
        role: "tooltip"
    }, $97cb4d9d55c58c9c$var$o.createElement($97cb4d9d55c58c9c$var$te, {
        customClassName: "rpv-core__tooltip-body-arrow",
        position: i
    }), $97cb4d9d55c58c9c$var$o.createElement("div", {
        className: "rpv-core__tooltip-body-content"
    }, n)));
};
$97cb4d9d55c58c9c$export$8245e75d48f7b7d8 = void 0, ($97cb4d9d55c58c9c$var$Z = $97cb4d9d55c58c9c$export$8245e75d48f7b7d8 || ($97cb4d9d55c58c9c$export$8245e75d48f7b7d8 = {})).Normal = "Normal", $97cb4d9d55c58c9c$var$Z.Entering = "Entering", $97cb4d9d55c58c9c$var$Z.Entered = "Entered", $97cb4d9d55c58c9c$var$Z.EnteredCompletely = "EnteredCompletely", $97cb4d9d55c58c9c$var$Z.Exitting = "Exitting", $97cb4d9d55c58c9c$var$Z.Exited = "Exited", $97cb4d9d55c58c9c$export$44b6e2a92a1c449f = void 0, ($97cb4d9d55c58c9c$var$J = $97cb4d9d55c58c9c$export$44b6e2a92a1c449f || ($97cb4d9d55c58c9c$export$44b6e2a92a1c449f = {}))[$97cb4d9d55c58c9c$var$J.PreRender = 0] = "PreRender", $97cb4d9d55c58c9c$var$J[$97cb4d9d55c58c9c$var$J.DidRender = 1] = "DidRender", $97cb4d9d55c58c9c$export$6ea4b0c62affbe44 = void 0, ($97cb4d9d55c58c9c$var$G = $97cb4d9d55c58c9c$export$6ea4b0c62affbe44 || ($97cb4d9d55c58c9c$export$6ea4b0c62affbe44 = {})).Attachments = "UseAttachments", $97cb4d9d55c58c9c$var$G.Bookmarks = "UseOutlines", $97cb4d9d55c58c9c$var$G.ContentGroup = "UseOC", $97cb4d9d55c58c9c$var$G.Default = "UserNone", $97cb4d9d55c58c9c$var$G.FullScreen = "FullScreen", $97cb4d9d55c58c9c$var$G.Thumbnails = "UseThumbs", $97cb4d9d55c58c9c$export$51a8e1495775a8d0 = void 0, ($97cb4d9d55c58c9c$var$Y = $97cb4d9d55c58c9c$export$51a8e1495775a8d0 || ($97cb4d9d55c58c9c$export$51a8e1495775a8d0 = {})).RequiredPassword = "RequiredPassword", $97cb4d9d55c58c9c$var$Y.WrongPassword = "WrongPassword", $97cb4d9d55c58c9c$export$9506977ce2a96a5b = void 0, ($97cb4d9d55c58c9c$var$K = $97cb4d9d55c58c9c$export$9506977ce2a96a5b || ($97cb4d9d55c58c9c$export$9506977ce2a96a5b = {})).Backward = "Backward", $97cb4d9d55c58c9c$var$K.Forward = "Forward", $97cb4d9d55c58c9c$export$c8345932c0874cf8 = void 0, ($97cb4d9d55c58c9c$var$X = $97cb4d9d55c58c9c$export$c8345932c0874cf8 || ($97cb4d9d55c58c9c$export$c8345932c0874cf8 = {})).Page = "Page", $97cb4d9d55c58c9c$var$X.Horizontal = "Horizontal", $97cb4d9d55c58c9c$var$X.Vertical = "Vertical", $97cb4d9d55c58c9c$var$X.Wrapped = "Wrapped", $97cb4d9d55c58c9c$export$d3c2ac82f24f6349 = void 0, ($97cb4d9d55c58c9c$var$Q = $97cb4d9d55c58c9c$export$d3c2ac82f24f6349 || ($97cb4d9d55c58c9c$export$d3c2ac82f24f6349 = {})).ActualSize = "ActualSize", $97cb4d9d55c58c9c$var$Q.PageFit = "PageFit", $97cb4d9d55c58c9c$var$Q.PageWidth = "PageWidth", $97cb4d9d55c58c9c$export$53ec42062883b2d4 = void 0, ($97cb4d9d55c58c9c$var$$ = $97cb4d9d55c58c9c$export$53ec42062883b2d4 || ($97cb4d9d55c58c9c$export$53ec42062883b2d4 = {})).DualPage = "DualPage", $97cb4d9d55c58c9c$var$$.DualPageWithCover = "DualPageWithCover", $97cb4d9d55c58c9c$var$$.SinglePage = "SinglePage";
var $97cb4d9d55c58c9c$var$ae, $97cb4d9d55c58c9c$var$ie = function(e, t) {
    return e.reduce(function(e, n, r) {
        return r % t ? e[e.length - 1].push(n) : e.push([
            n
        ]), e;
    }, []);
}, $97cb4d9d55c58c9c$var$ce = function(e, t) {
    switch(t[1].name){
        case "XYZ":
            return {
                bottomOffset: function(e, n) {
                    return null === t[3] ? n : t[3];
                },
                leftOffset: function(e, n) {
                    return null === t[2] ? 0 : t[2];
                },
                pageIndex: e,
                scaleTo: t[4]
            };
        case "Fit":
        case "FitB":
            return {
                bottomOffset: 0,
                leftOffset: 0,
                pageIndex: e,
                scaleTo: $97cb4d9d55c58c9c$export$d3c2ac82f24f6349.PageFit
            };
        case "FitH":
        case "FitBH":
            return {
                bottomOffset: t[2],
                leftOffset: 0,
                pageIndex: e,
                scaleTo: $97cb4d9d55c58c9c$export$d3c2ac82f24f6349.PageWidth
            };
        default:
            return {
                bottomOffset: 0,
                leftOffset: 0,
                pageIndex: e,
                scaleTo: 1
            };
    }
}, $97cb4d9d55c58c9c$var$se = new Map, $97cb4d9d55c58c9c$var$le = new Map, $97cb4d9d55c58c9c$var$ue = function(e, t) {
    return "".concat(e.loadingTask.docId, "___").concat(t.num, "R").concat(0 === t.gen ? "" : t.gen);
}, $97cb4d9d55c58c9c$var$pe = function(e, t, n) {
    $97cb4d9d55c58c9c$var$se.set($97cb4d9d55c58c9c$var$ue(e, t), n);
}, $97cb4d9d55c58c9c$var$de = function(e, t) {
    if (!e) return Promise.reject("The document is not loaded yet");
    var n = "".concat(e.loadingTask.docId, "___").concat(t), r = $97cb4d9d55c58c9c$var$le.get(n);
    return r ? Promise.resolve(r) : new Promise(function(r, o) {
        e.getPage(t + 1).then(function(o) {
            $97cb4d9d55c58c9c$var$le.set(n, o), o.ref && $97cb4d9d55c58c9c$var$pe(e, o.ref, t), r(o);
        });
    });
}, $97cb4d9d55c58c9c$var$fe = function(e, t) {
    return new Promise(function(n) {
        new Promise(function(n) {
            "string" == typeof t ? e.getDestination(t).then(function(e) {
                n(e);
            }) : n(t);
        }).then(function(r) {
            if ("object" == typeof r[0] && null !== r[0]) {
                var o = r[0], a = function(e, t) {
                    var n = $97cb4d9d55c58c9c$var$ue(e, t);
                    return $97cb4d9d55c58c9c$var$se.has(n) ? $97cb4d9d55c58c9c$var$se.get(n) : null;
                }(e, o);
                null === a ? e.getPageIndex(o).then(function(r) {
                    $97cb4d9d55c58c9c$var$pe(e, o, r), $97cb4d9d55c58c9c$var$fe(e, t).then(function(e) {
                        return n(e);
                    });
                }) : n($97cb4d9d55c58c9c$var$ce(a, r));
            } else {
                var i = $97cb4d9d55c58c9c$var$ce(r[0], r);
                n(i);
            }
        });
    });
};
!function(e) {
    e[e.Solid = 1] = "Solid", e[e.Dashed = 2] = "Dashed", e[e.Beveled = 3] = "Beveled", e[e.Inset = 4] = "Inset", e[e.Underline = 5] = "Underline";
}($97cb4d9d55c58c9c$var$ae || ($97cb4d9d55c58c9c$var$ae = {}));
var $97cb4d9d55c58c9c$var$ge, $97cb4d9d55c58c9c$var$ve = new RegExp("^D:(\\d{4})(\\d{2})?(\\d{2})?(\\d{2})?(\\d{2})?(\\d{2})?([Z|+|-])?(\\d{2})?'?(\\d{2})?'?"), $97cb4d9d55c58c9c$var$he = function(e, t, n, r) {
    var o = parseInt(e, 10);
    return o >= t && o <= n ? o : r;
}, $97cb4d9d55c58c9c$var$me = function(e) {
    return e.contentsObj ? e.contentsObj.str : e.contents || "";
}, $97cb4d9d55c58c9c$var$xe = function(e) {
    return e.titleObj ? e.titleObj.str : e.title || "";
}, $97cb4d9d55c58c9c$var$we = function(e) {
    var t = e.annotation, n = $97cb4d9d55c58c9c$var$o.useContext($97cb4d9d55c58c9c$var$p).direction, r = $97cb4d9d55c58c9c$var$xe(t), a = $97cb4d9d55c58c9c$var$me(t), i = n === $97cb4d9d55c58c9c$export$63e1cbbb2c6e2c2.RightToLeft, c = $97cb4d9d55c58c9c$var$o.useRef(), s = "";
    if (t.modificationDate) {
        var l = function(e) {
            var t = $97cb4d9d55c58c9c$var$ve.exec(e);
            if (!t) return null;
            var n = parseInt(t[1], 10), r = $97cb4d9d55c58c9c$var$he(t[2], 1, 12, 1) - 1, o = $97cb4d9d55c58c9c$var$he(t[3], 1, 31, 1), a = $97cb4d9d55c58c9c$var$he(t[4], 0, 23, 0), i = $97cb4d9d55c58c9c$var$he(t[5], 0, 59, 0), c = $97cb4d9d55c58c9c$var$he(t[6], 0, 59, 0), s = t[7] || "Z", l = $97cb4d9d55c58c9c$var$he(t[8], 0, 23, 0), u = $97cb4d9d55c58c9c$var$he(t[9], 0, 59, 0);
            switch(s){
                case "-":
                    a += l, i += u;
                    break;
                case "+":
                    a -= l, i -= u;
            }
            return new Date(Date.UTC(n, r, o, a, i, c));
        }(t.modificationDate);
        s = l ? "".concat(l.toLocaleDateString(), ", ").concat(l.toLocaleTimeString()) : "";
    }
    return $97cb4d9d55c58c9c$var$o.useLayoutEffect(function() {
        if (c.current) {
            var e = document.querySelector('[data-annotation-id="'.concat(t.id, '"]'));
            if (e) {
                var n = e;
                return n.style.zIndex += 1, function() {
                    n.style.zIndex = "".concat(parseInt(n.style.zIndex, 10) - 1);
                };
            }
        }
    }, []), $97cb4d9d55c58c9c$var$o.createElement("div", {
        ref: c,
        className: $97cb4d9d55c58c9c$var$d({
            "rpv-core__annotation-popup-wrapper": !0,
            "rpv-core__annotation-popup-wrapper--rtl": i
        }),
        style: {
            top: t.annotationType === $97cb4d9d55c58c9c$export$f50c3066a53a6f2c.Popup ? "" : "100%"
        }
    }, r && $97cb4d9d55c58c9c$var$o.createElement($97cb4d9d55c58c9c$var$o.Fragment, null, $97cb4d9d55c58c9c$var$o.createElement("div", {
        className: $97cb4d9d55c58c9c$var$d({
            "rpv-core__annotation-popup-title": !0,
            "rpv-core__annotation-popup-title--ltr": !i,
            "rpv-core__annotation-popup-title--rtl": i
        })
    }, r), $97cb4d9d55c58c9c$var$o.createElement("div", {
        className: "rpv-core__annotation-popup-date"
    }, s)), a && $97cb4d9d55c58c9c$var$o.createElement("div", {
        className: "rpv-core__annotation-popup-content"
    }, a.split("\n").map(function(e, t) {
        return $97cb4d9d55c58c9c$var$o.createElement($97cb4d9d55c58c9c$var$o.Fragment, {
            key: t
        }, e, $97cb4d9d55c58c9c$var$o.createElement("br", null));
    })));
};
!function(e) {
    e.Click = "Click", e.Hover = "Hover";
}($97cb4d9d55c58c9c$var$ge || ($97cb4d9d55c58c9c$var$ge = {}));
var $97cb4d9d55c58c9c$var$Ee, $97cb4d9d55c58c9c$var$be = function(e) {
    var t, n = e.annotation, r = e.children, a = e.ignoreBorder, i = e.hasPopup, c = e.isRenderable, s = e.page, l = e.viewport, u = n.rect, p = function() {
        var e = $97cb4d9d55c58c9c$var$q(!1), t = e.opened, n = e.toggle, r = $97cb4d9d55c58c9c$var$o.useState($97cb4d9d55c58c9c$var$ge.Hover), a = r[0], i = r[1];
        return {
            opened: t,
            closeOnHover: function() {
                a === $97cb4d9d55c58c9c$var$ge.Hover && n($97cb4d9d55c58c9c$export$8f9a8eb37555b53e.Close);
            },
            openOnHover: function() {
                a === $97cb4d9d55c58c9c$var$ge.Hover && n($97cb4d9d55c58c9c$export$8f9a8eb37555b53e.Open);
            },
            toggleOnClick: function() {
                switch(a){
                    case $97cb4d9d55c58c9c$var$ge.Click:
                        t && i($97cb4d9d55c58c9c$var$ge.Hover), n($97cb4d9d55c58c9c$export$8f9a8eb37555b53e.Toggle);
                        break;
                    case $97cb4d9d55c58c9c$var$ge.Hover:
                        i($97cb4d9d55c58c9c$var$ge.Click), n($97cb4d9d55c58c9c$export$8f9a8eb37555b53e.Open);
                }
            }
        };
    }(), d = p.closeOnHover, f = p.opened, g = p.openOnHover, v = p.toggleOnClick, h = (t = [
        u[0],
        s.view[3] + s.view[1] - u[1],
        u[2],
        s.view[3] + s.view[1] - u[3]
    ], [
        Math.min(t[0], t[2]),
        Math.min(t[1], t[3]),
        Math.max(t[0], t[2]),
        Math.max(t[1], t[3])
    ]), m = u[2] - u[0], x = u[3] - u[1], w = {
        borderColor: "",
        borderRadius: "",
        borderStyle: "",
        borderWidth: ""
    };
    if (!a && n.borderStyle.width > 0) {
        switch(n.borderStyle.style){
            case $97cb4d9d55c58c9c$var$ae.Dashed:
                w.borderStyle = "dashed";
                break;
            case $97cb4d9d55c58c9c$var$ae.Solid:
                w.borderStyle = "solid";
                break;
            case $97cb4d9d55c58c9c$var$ae.Underline:
                w = Object.assign({
                    borderBottomStyle: "solid"
                }, w);
            case $97cb4d9d55c58c9c$var$ae.Beveled:
            case $97cb4d9d55c58c9c$var$ae.Inset:
        }
        var E = n.borderStyle.width;
        w.borderWidth = "".concat(E, "px"), n.borderStyle.style !== $97cb4d9d55c58c9c$var$ae.Underline && (m -= 2 * E, x -= 2 * E);
        var b = n.borderStyle, y = b.horizontalCornerRadius, S = b.verticalCornerRadius;
        (y > 0 || S > 0) && (w.borderRadius = "".concat(y, "px / ").concat(S, "px")), n.color ? w.borderColor = "rgb(".concat(0 | n.color[0], ", ").concat(0 | n.color[1], ", ").concat(0 | n.color[2], ")") : w.borderWidth = "0";
    }
    return $97cb4d9d55c58c9c$var$o.createElement($97cb4d9d55c58c9c$var$o.Fragment, null, c && r({
        popup: {
            opened: f,
            closeOnHover: d,
            openOnHover: g,
            toggleOnClick: v
        },
        slot: {
            attrs: {
                style: Object.assign({
                    height: "".concat(x, "px"),
                    left: "".concat(h[0], "px"),
                    top: "".concat(h[1], "px"),
                    transform: "matrix(".concat(l.transform.join(","), ")"),
                    transformOrigin: "-".concat(h[0], "px -").concat(h[1], "px"),
                    width: "".concat(m, "px")
                }, w)
            },
            children: $97cb4d9d55c58c9c$var$o.createElement($97cb4d9d55c58c9c$var$o.Fragment, null, i && f && $97cb4d9d55c58c9c$var$o.createElement($97cb4d9d55c58c9c$var$we, {
                annotation: n
            }))
        }
    }));
}, $97cb4d9d55c58c9c$var$ye = function(e) {
    var t = e.annotation, n = e.page, r = e.viewport, a = !1 === t.hasPopup, i = $97cb4d9d55c58c9c$var$xe(t), c = $97cb4d9d55c58c9c$var$me(t), s = !!(t.hasPopup || i || c);
    return $97cb4d9d55c58c9c$var$o.createElement($97cb4d9d55c58c9c$var$be, {
        annotation: t,
        hasPopup: a,
        ignoreBorder: !0,
        isRenderable: s,
        page: n,
        viewport: r
    }, function(e) {
        return $97cb4d9d55c58c9c$var$o.createElement("div", $97cb4d9d55c58c9c$var$l({}, e.slot.attrs, {
            className: "rpv-core__annotation rpv-core__annotation--caret",
            "data-annotation-id": t.id,
            onClick: e.popup.toggleOnClick,
            onMouseEnter: e.popup.openOnHover,
            onMouseLeave: e.popup.closeOnHover
        }), e.slot.children);
    });
}, $97cb4d9d55c58c9c$var$Se = function(e) {
    var t = e.annotation, n = e.page, r = e.viewport, a = !1 === t.hasPopup, i = $97cb4d9d55c58c9c$var$xe(t), c = $97cb4d9d55c58c9c$var$me(t), s = !!(t.hasPopup || i || c), u = t.rect, p = u[2] - u[0], d = u[3] - u[1], f = t.borderStyle.width;
    return $97cb4d9d55c58c9c$var$o.createElement($97cb4d9d55c58c9c$var$be, {
        annotation: t,
        hasPopup: a,
        ignoreBorder: !0,
        isRenderable: s,
        page: n,
        viewport: r
    }, function(e) {
        return $97cb4d9d55c58c9c$var$o.createElement("div", $97cb4d9d55c58c9c$var$l({}, e.slot.attrs, {
            className: "rpv-core__annotation rpv-core__annotation--circle",
            "data-annotation-id": t.id,
            onClick: e.popup.toggleOnClick,
            onMouseEnter: e.popup.openOnHover,
            onMouseLeave: e.popup.closeOnHover
        }), $97cb4d9d55c58c9c$var$o.createElement("svg", {
            height: "".concat(d, "px"),
            preserveAspectRatio: "none",
            version: "1.1",
            viewBox: "0 0 ".concat(p, " ").concat(d),
            width: "".concat(p, "px")
        }, $97cb4d9d55c58c9c$var$o.createElement("circle", {
            cy: d / 2,
            fill: "none",
            rx: p / 2 - f / 2,
            ry: d / 2 - f / 2,
            stroke: "transparent",
            strokeWidth: f || 1
        })), e.slot.children);
    });
}, $97cb4d9d55c58c9c$var$_e = function(e) {
    var t = e.annotation, n = e.page, r = e.viewport, a = $97cb4d9d55c58c9c$var$xe(t), i = $97cb4d9d55c58c9c$var$me(t), c = !(!1 !== t.hasPopup || !a && !i), s = function() {
        var e, n, r, o, a = t.file;
        a && (e = a.filename, n = a.content, r = "string" == typeof n ? "" : URL.createObjectURL(new Blob([
            n
        ], {
            type: ""
        })), (o = document.createElement("a")).style.display = "none", o.href = r || e, o.setAttribute("download", function(e) {
            var t = e.split("/").pop();
            return t ? t.split("#")[0].split("?")[0] : e;
        }(e)), document.body.appendChild(o), o.click(), document.body.removeChild(o), r && URL.revokeObjectURL(r));
    };
    return $97cb4d9d55c58c9c$var$o.createElement($97cb4d9d55c58c9c$var$be, {
        annotation: t,
        hasPopup: c,
        ignoreBorder: !0,
        isRenderable: !0,
        page: n,
        viewport: r
    }, function(e) {
        return $97cb4d9d55c58c9c$var$o.createElement("div", $97cb4d9d55c58c9c$var$l({}, e.slot.attrs, {
            className: "rpv-core__annotation rpv-core__annotation--file-attachment",
            "data-annotation-id": t.id,
            onClick: e.popup.toggleOnClick,
            onDoubleClick: s,
            onMouseEnter: e.popup.openOnHover,
            onMouseLeave: e.popup.closeOnHover
        }), e.slot.children);
    });
}, $97cb4d9d55c58c9c$var$Pe = function(e) {
    var t = e.annotation, n = e.page, r = e.viewport, a = !1 === t.hasPopup, i = $97cb4d9d55c58c9c$var$xe(t), c = $97cb4d9d55c58c9c$var$me(t), s = !!(t.hasPopup || i || c);
    return $97cb4d9d55c58c9c$var$o.createElement($97cb4d9d55c58c9c$var$be, {
        annotation: t,
        hasPopup: a,
        ignoreBorder: !0,
        isRenderable: s,
        page: n,
        viewport: r
    }, function(e) {
        return $97cb4d9d55c58c9c$var$o.createElement("div", $97cb4d9d55c58c9c$var$l({}, e.slot.attrs, {
            className: "rpv-core__annotation rpv-core__annotation--free-text",
            "data-annotation-id": t.id,
            onClick: e.popup.toggleOnClick,
            onMouseEnter: e.popup.openOnHover,
            onMouseLeave: e.popup.closeOnHover
        }), e.slot.children);
    });
}, $97cb4d9d55c58c9c$var$Re = function(e) {
    var t = e.annotation, n = e.page, r = e.viewport, a = $97cb4d9d55c58c9c$var$xe(t), i = $97cb4d9d55c58c9c$var$me(t), c = !(!a && !i), s = !t.parentType || -1 !== [
        "Circle",
        "Ink",
        "Line",
        "Polygon",
        "PolyLine",
        "Square"
    ].indexOf(t.parentType);
    return $97cb4d9d55c58c9c$var$f(function() {
        if (t.parentId) {
            var e = document.querySelector('[data-annotation-id="'.concat(t.parentId, '"]')), n = document.querySelector('[data-annotation-id="'.concat(t.id, '"]'));
            if (e && n) {
                var r = parseFloat(e.style.left), o = parseFloat(e.style.top) + parseFloat(e.style.height);
                n.style.left = "".concat(r, "px"), n.style.top = "".concat(o, "px"), n.style.transformOrigin = "-".concat(r, "px -").concat(o, "px");
            }
        }
    }, []), $97cb4d9d55c58c9c$var$o.createElement($97cb4d9d55c58c9c$var$be, {
        annotation: t,
        hasPopup: s,
        ignoreBorder: !1,
        isRenderable: c,
        page: n,
        viewport: r
    }, function(e) {
        return $97cb4d9d55c58c9c$var$o.createElement("div", $97cb4d9d55c58c9c$var$l({}, e.slot.attrs, {
            className: "rpv-core__annotation rpv-core__annotation--popup",
            "data-annotation-id": t.id
        }), $97cb4d9d55c58c9c$var$o.createElement($97cb4d9d55c58c9c$var$we, {
            annotation: t
        }));
    });
}, $97cb4d9d55c58c9c$var$Me = function(e) {
    var t = e.annotation, n = e.childAnnotation, r = e.page, a = e.viewport, i = !1 === t.hasPopup, c = $97cb4d9d55c58c9c$var$xe(t), s = $97cb4d9d55c58c9c$var$me(t), u = !!(t.hasPopup || c || s);
    if (t.quadPoints && t.quadPoints.length > 0) {
        var p = t.quadPoints.map(function(e) {
            return Object.assign({}, t, {
                rect: [
                    e[2].x,
                    e[2].y,
                    e[1].x,
                    e[1].y
                ],
                quadPoints: []
            });
        });
        return $97cb4d9d55c58c9c$var$o.createElement($97cb4d9d55c58c9c$var$o.Fragment, null, p.map(function(e, t) {
            return $97cb4d9d55c58c9c$var$o.createElement($97cb4d9d55c58c9c$var$Me, {
                key: t,
                annotation: e,
                childAnnotation: n,
                page: r,
                viewport: a
            });
        }));
    }
    return $97cb4d9d55c58c9c$var$o.createElement($97cb4d9d55c58c9c$var$be, {
        annotation: t,
        hasPopup: i,
        ignoreBorder: !0,
        isRenderable: u,
        page: r,
        viewport: a
    }, function(e) {
        return $97cb4d9d55c58c9c$var$o.createElement($97cb4d9d55c58c9c$var$o.Fragment, null, $97cb4d9d55c58c9c$var$o.createElement("div", $97cb4d9d55c58c9c$var$l({}, e.slot.attrs, {
            className: "rpv-core__annotation rpv-core__annotation--highlight",
            "data-annotation-id": t.id,
            onClick: e.popup.toggleOnClick,
            onMouseEnter: e.popup.openOnHover,
            onMouseLeave: e.popup.closeOnHover
        }), e.slot.children), n && n.annotationType === $97cb4d9d55c58c9c$export$f50c3066a53a6f2c.Popup && e.popup.opened && $97cb4d9d55c58c9c$var$o.createElement($97cb4d9d55c58c9c$var$Re, {
            annotation: n,
            page: r,
            viewport: a
        }));
    });
}, $97cb4d9d55c58c9c$var$ke = function(e) {
    var t = e.annotation, n = e.page, r = e.viewport, a = !1 === t.hasPopup, i = $97cb4d9d55c58c9c$var$xe(t), c = $97cb4d9d55c58c9c$var$me(t), s = !!(t.hasPopup || i || c), u = t.rect, p = u[2] - u[0], d = u[3] - u[1], f = t.borderStyle.width;
    return $97cb4d9d55c58c9c$var$o.createElement($97cb4d9d55c58c9c$var$be, {
        annotation: t,
        hasPopup: a,
        ignoreBorder: !0,
        isRenderable: s,
        page: n,
        viewport: r
    }, function(e) {
        return $97cb4d9d55c58c9c$var$o.createElement("div", $97cb4d9d55c58c9c$var$l({}, e.slot.attrs, {
            className: "rpv-core__annotation rpv-core__annotation--ink",
            "data-annotation-id": t.id,
            onClick: e.popup.toggleOnClick,
            onMouseEnter: e.popup.openOnHover,
            onMouseLeave: e.popup.closeOnHover
        }), t.inkLists && t.inkLists.length && $97cb4d9d55c58c9c$var$o.createElement("svg", {
            height: "".concat(d, "px"),
            preserveAspectRatio: "none",
            version: "1.1",
            viewBox: "0 0 ".concat(p, " ").concat(d),
            width: "".concat(p, "px")
        }, t.inkLists.map(function(e, t) {
            return $97cb4d9d55c58c9c$var$o.createElement("polyline", {
                key: t,
                fill: "none",
                stroke: "transparent",
                strokeWidth: f || 1,
                points: e.map(function(e) {
                    return "".concat(e.x - u[0], ",").concat(u[3] - e.y);
                }).join(" ")
            });
        })), e.slot.children);
    });
}, $97cb4d9d55c58c9c$var$Ce = function(e) {
    var t = e.annotation, n = e.page, r = e.viewport, a = !1 === t.hasPopup, i = $97cb4d9d55c58c9c$var$xe(t), c = $97cb4d9d55c58c9c$var$me(t), s = !!(t.hasPopup || i || c), u = t.rect, p = u[2] - u[0], d = u[3] - u[1], f = t.borderStyle.width;
    return $97cb4d9d55c58c9c$var$o.createElement($97cb4d9d55c58c9c$var$be, {
        annotation: t,
        hasPopup: a,
        ignoreBorder: !0,
        isRenderable: s,
        page: n,
        viewport: r
    }, function(e) {
        return $97cb4d9d55c58c9c$var$o.createElement("div", $97cb4d9d55c58c9c$var$l({}, e.slot.attrs, {
            className: "rpv-core__annotation rpv-core__annotation--line",
            "data-annotation-id": t.id,
            onClick: e.popup.toggleOnClick,
            onMouseEnter: e.popup.openOnHover,
            onMouseLeave: e.popup.closeOnHover
        }), $97cb4d9d55c58c9c$var$o.createElement("svg", {
            height: "".concat(d, "px"),
            preserveAspectRatio: "none",
            version: "1.1",
            viewBox: "0 0 ".concat(p, " ").concat(d),
            width: "".concat(p, "px")
        }, $97cb4d9d55c58c9c$var$o.createElement("line", {
            stroke: "transparent",
            strokeWidth: f || 1,
            x1: u[2] - t.lineCoordinates[0],
            x2: u[2] - t.lineCoordinates[2],
            y1: u[3] - t.lineCoordinates[1],
            y2: u[3] - t.lineCoordinates[3]
        })), e.slot.children);
    });
}, $97cb4d9d55c58c9c$var$Te = /^([^\w]*)(javascript|data|vbscript)/im, $97cb4d9d55c58c9c$var$Le = /&#(\w+)(^\w|;)?/g, $97cb4d9d55c58c9c$var$Oe = /[\u0000-\u001F\u007F-\u009F\u2000-\u200D\uFEFF]/gim, $97cb4d9d55c58c9c$var$Fe = /^([^:]+):/gm, $97cb4d9d55c58c9c$var$De = function(e, t) {
    void 0 === t && (t = "about:blank");
    var n, r = (n = e || "", n.replace($97cb4d9d55c58c9c$var$Le, function(e, t) {
        return String.fromCharCode(t);
    })).replace($97cb4d9d55c58c9c$var$Oe, "").trim();
    if (!r) return t;
    var o = r[0];
    if ("." === o || "/" === o) return r;
    var a = r.match($97cb4d9d55c58c9c$var$Fe);
    if (!a) return r;
    var i = a[0];
    return $97cb4d9d55c58c9c$var$Te.test(i) ? t : r;
}, $97cb4d9d55c58c9c$var$Ie = function(e) {
    var t, n = e.annotation, r = e.annotationContainerRef, a = e.doc, i = e.outlines, c = e.page, s = e.pageIndex, u = e.scale, p = e.viewport, d = e.onExecuteNamedAction, f = e.onJumpFromLinkAnnotation, g = e.onJumpToDest, v = $97cb4d9d55c58c9c$var$o.useRef(), h = i && i.length && n.dest && "string" == typeof n.dest ? null === (t = i.find(function(e) {
        return e.dest === n.dest;
    })) || void 0 === t ? void 0 : t.title : "", m = !!(n.url || n.dest || n.action || n.unsafeUrl), x = {};
    if (n.url || n.unsafeUrl) {
        var w = $97cb4d9d55c58c9c$var$De(n.url || n.unsafeUrl, "");
        w ? x = {
            "data-target": "external",
            href: w,
            rel: "noopener noreferrer nofollow",
            target: n.newWindow ? "_blank" : "",
            title: w
        } : m = !1;
    } else x = {
        href: "",
        "data-annotation-link": n.id,
        onClick: function(e) {
            e.preventDefault(), n.action ? d(n.action) : $97cb4d9d55c58c9c$var$fe(a, n.dest).then(function(e) {
                var t = v.current, n = r.current;
                if (t && n) {
                    var o = t.getBoundingClientRect();
                    n.style.setProperty("height", "100%"), n.style.setProperty("width", "100%");
                    var a = n.getBoundingClientRect();
                    n.style.removeProperty("height"), n.style.removeProperty("width");
                    var i = (o.left - a.left) / u, c = (a.bottom - o.bottom + o.height) / u;
                    f({
                        bottomOffset: c,
                        label: h,
                        leftOffset: i,
                        pageIndex: s
                    });
                }
                g(e);
            });
        }
    };
    return h && (x = Object.assign({}, x, {
        title: h,
        "aria-label": h
    })), $97cb4d9d55c58c9c$var$o.createElement($97cb4d9d55c58c9c$var$be, {
        annotation: n,
        hasPopup: !1,
        ignoreBorder: !1,
        isRenderable: m,
        page: c,
        viewport: p
    }, function(e) {
        return $97cb4d9d55c58c9c$var$o.createElement("div", $97cb4d9d55c58c9c$var$l({}, e.slot.attrs, {
            className: "rpv-core__annotation rpv-core__annotation--link",
            "data-annotation-id": n.id,
            "data-testid": "core__annotation--link-".concat(n.id)
        }), $97cb4d9d55c58c9c$var$o.createElement("a", $97cb4d9d55c58c9c$var$l({
            ref: v
        }, x)));
    });
}, $97cb4d9d55c58c9c$var$Ae = function(e) {
    var t = e.annotation, n = e.page, r = e.viewport, a = !1 === t.hasPopup, i = $97cb4d9d55c58c9c$var$xe(t), c = $97cb4d9d55c58c9c$var$me(t), s = !!(t.hasPopup || i || c), u = t.rect, p = u[2] - u[0], d = u[3] - u[1], f = t.borderStyle.width;
    return $97cb4d9d55c58c9c$var$o.createElement($97cb4d9d55c58c9c$var$be, {
        annotation: t,
        hasPopup: a,
        ignoreBorder: !0,
        isRenderable: s,
        page: n,
        viewport: r
    }, function(e) {
        return $97cb4d9d55c58c9c$var$o.createElement("div", $97cb4d9d55c58c9c$var$l({}, e.slot.attrs, {
            className: "rpv-core__annotation rpv-core__annotation--polygon",
            "data-annotation-id": t.id,
            onClick: e.popup.toggleOnClick,
            onMouseEnter: e.popup.openOnHover,
            onMouseLeave: e.popup.closeOnHover
        }), t.vertices && t.vertices.length && $97cb4d9d55c58c9c$var$o.createElement("svg", {
            height: "".concat(d, "px"),
            preserveAspectRatio: "none",
            version: "1.1",
            viewBox: "0 0 ".concat(p, " ").concat(d),
            width: "".concat(p, "px")
        }, $97cb4d9d55c58c9c$var$o.createElement("polygon", {
            fill: "none",
            stroke: "transparent",
            strokeWidth: f || 1,
            points: t.vertices.map(function(e) {
                return "".concat(e.x - u[0], ",").concat(u[3] - e.y);
            }).join(" ")
        })), e.slot.children);
    });
}, $97cb4d9d55c58c9c$var$He = function(e) {
    var t = e.annotation, n = e.page, r = e.viewport, a = !1 === t.hasPopup, i = $97cb4d9d55c58c9c$var$xe(t), c = $97cb4d9d55c58c9c$var$me(t), s = !!(t.hasPopup || i || c), u = t.rect, p = u[2] - u[0], d = u[3] - u[1], f = t.borderStyle.width;
    return $97cb4d9d55c58c9c$var$o.createElement($97cb4d9d55c58c9c$var$be, {
        annotation: t,
        hasPopup: a,
        ignoreBorder: !0,
        isRenderable: s,
        page: n,
        viewport: r
    }, function(e) {
        return $97cb4d9d55c58c9c$var$o.createElement("div", $97cb4d9d55c58c9c$var$l({}, e.slot.attrs, {
            className: "rpv-core__annotation rpv-core__annotation--polyline",
            "data-annotation-id": t.id,
            onClick: e.popup.toggleOnClick,
            onMouseEnter: e.popup.openOnHover,
            onMouseLeave: e.popup.closeOnHover
        }), t.vertices && t.vertices.length && $97cb4d9d55c58c9c$var$o.createElement("svg", {
            height: "".concat(d, "px"),
            preserveAspectRatio: "none",
            version: "1.1",
            viewBox: "0 0 ".concat(p, " ").concat(d),
            width: "".concat(p, "px")
        }, $97cb4d9d55c58c9c$var$o.createElement("polyline", {
            fill: "none",
            stroke: "transparent",
            strokeWidth: f || 1,
            points: t.vertices.map(function(e) {
                return "".concat(e.x - u[0], ",").concat(u[3] - e.y);
            }).join(" ")
        })), e.slot.children);
    });
}, $97cb4d9d55c58c9c$var$Ne = function(e) {
    var t = e.annotation, n = e.page, r = e.viewport, a = !1 === t.hasPopup, i = $97cb4d9d55c58c9c$var$xe(t), c = $97cb4d9d55c58c9c$var$me(t), s = !!(t.hasPopup || i || c), u = t.rect, p = u[2] - u[0], d = u[3] - u[1], f = t.borderStyle.width;
    return $97cb4d9d55c58c9c$var$o.createElement($97cb4d9d55c58c9c$var$be, {
        annotation: t,
        hasPopup: a,
        ignoreBorder: !0,
        isRenderable: s,
        page: n,
        viewport: r
    }, function(e) {
        return $97cb4d9d55c58c9c$var$o.createElement("div", $97cb4d9d55c58c9c$var$l({}, e.slot.attrs, {
            className: "rpv-core__annotation rpv-core__annotation--square",
            "data-annotation-id": t.id,
            onClick: e.popup.toggleOnClick,
            onMouseEnter: e.popup.openOnHover,
            onMouseLeave: e.popup.closeOnHover
        }), $97cb4d9d55c58c9c$var$o.createElement("svg", {
            height: "".concat(d, "px"),
            preserveAspectRatio: "none",
            version: "1.1",
            viewBox: "0 0 ".concat(p, " ").concat(d),
            width: "".concat(p, "px")
        }, $97cb4d9d55c58c9c$var$o.createElement("rect", {
            height: d - f,
            fill: "none",
            stroke: "transparent",
            strokeWidth: f || 1,
            x: f / 2,
            y: f / 2,
            width: p - f
        })), e.slot.children);
    });
}, $97cb4d9d55c58c9c$var$Ve = function(e) {
    var t = e.annotation, n = e.page, r = e.viewport, a = !1 === t.hasPopup, i = $97cb4d9d55c58c9c$var$xe(t), c = $97cb4d9d55c58c9c$var$me(t), s = !!(t.hasPopup || i || c);
    return $97cb4d9d55c58c9c$var$o.createElement($97cb4d9d55c58c9c$var$be, {
        annotation: t,
        hasPopup: a,
        ignoreBorder: !0,
        isRenderable: s,
        page: n,
        viewport: r
    }, function(e) {
        return $97cb4d9d55c58c9c$var$o.createElement("div", $97cb4d9d55c58c9c$var$l({}, e.slot.attrs, {
            className: "rpv-core__annotation rpv-core__annotation--squiggly",
            "data-annotation-id": t.id,
            onClick: e.popup.toggleOnClick,
            onMouseEnter: e.popup.openOnHover,
            onMouseLeave: e.popup.closeOnHover
        }), e.slot.children);
    });
}, $97cb4d9d55c58c9c$var$ze = function(e) {
    var t = e.annotation, n = e.page, r = e.viewport, a = !1 === t.hasPopup, i = $97cb4d9d55c58c9c$var$xe(t), c = $97cb4d9d55c58c9c$var$me(t), s = !!(t.hasPopup || i || c);
    return $97cb4d9d55c58c9c$var$o.createElement($97cb4d9d55c58c9c$var$be, {
        annotation: t,
        hasPopup: a,
        ignoreBorder: !0,
        isRenderable: s,
        page: n,
        viewport: r
    }, function(e) {
        return $97cb4d9d55c58c9c$var$o.createElement("div", $97cb4d9d55c58c9c$var$l({}, e.slot.attrs, {
            className: "rpv-core__annotation rpv-core__annotation--stamp",
            "data-annotation-id": t.id,
            onClick: e.popup.toggleOnClick,
            onMouseEnter: e.popup.openOnHover,
            onMouseLeave: e.popup.closeOnHover
        }), e.slot.children);
    });
}, $97cb4d9d55c58c9c$var$Be = function(e) {
    var t = e.annotation, n = e.page, r = e.viewport, a = !1 === t.hasPopup, i = $97cb4d9d55c58c9c$var$xe(t), c = $97cb4d9d55c58c9c$var$me(t), s = !!(t.hasPopup || i || c);
    return $97cb4d9d55c58c9c$var$o.createElement($97cb4d9d55c58c9c$var$be, {
        annotation: t,
        hasPopup: a,
        ignoreBorder: !0,
        isRenderable: s,
        page: n,
        viewport: r
    }, function(e) {
        return $97cb4d9d55c58c9c$var$o.createElement("div", $97cb4d9d55c58c9c$var$l({}, e.slot.attrs, {
            className: "rpv-core__annotation rpv-core__annotation--strike-out",
            "data-annotation-id": t.id,
            onClick: e.popup.toggleOnClick,
            onMouseEnter: e.popup.openOnHover,
            onMouseLeave: e.popup.closeOnHover
        }), e.slot.children);
    });
}, $97cb4d9d55c58c9c$var$We = function() {
    return $97cb4d9d55c58c9c$var$o.createElement($97cb4d9d55c58c9c$var$v, {
        size: 16
    }, $97cb4d9d55c58c9c$var$o.createElement("path", {
        d: "M.5,16.5a1,1,0,0,0,1,1h2v4l4-4h15a1,1,0,0,0,1-1V3.5a1,1,0,0,0-1-1H1.5a1,1,0,0,0-1,1Z"
    }), $97cb4d9d55c58c9c$var$o.createElement("path", {
        d: "M7.25,9.75A.25.25,0,1,1,7,10a.25.25,0,0,1,.25-.25"
    }), $97cb4d9d55c58c9c$var$o.createElement("path", {
        d: "M12,9.75a.25.25,0,1,1-.25.25A.25.25,0,0,1,12,9.75"
    }), $97cb4d9d55c58c9c$var$o.createElement("path", {
        d: "M16.75,9.75a.25.25,0,1,1-.25.25.25.25,0,0,1,.25-.25"
    }));
}, $97cb4d9d55c58c9c$var$je = function() {
    return $97cb4d9d55c58c9c$var$o.createElement($97cb4d9d55c58c9c$var$v, {
        size: 16
    }, $97cb4d9d55c58c9c$var$o.createElement("path", {
        d: "M0.500 12.001 A11.500 11.500 0 1 0 23.500 12.001 A11.500 11.500 0 1 0 0.500 12.001 Z"
    }), $97cb4d9d55c58c9c$var$o.createElement("path", {
        d: "M6.000 12.001 A6.000 6.000 0 1 0 18.000 12.001 A6.000 6.000 0 1 0 6.000 12.001 Z"
    }), $97cb4d9d55c58c9c$var$o.createElement("path", {
        d: "M21.423 5.406L17.415 9.414"
    }), $97cb4d9d55c58c9c$var$o.createElement("path", {
        d: "M14.587 6.585L18.607 2.565"
    }), $97cb4d9d55c58c9c$var$o.createElement("path", {
        d: "M5.405 21.424L9.413 17.416"
    }), $97cb4d9d55c58c9c$var$o.createElement("path", {
        d: "M6.585 14.588L2.577 18.596"
    }), $97cb4d9d55c58c9c$var$o.createElement("path", {
        d: "M18.602 21.419L14.595 17.412"
    }), $97cb4d9d55c58c9c$var$o.createElement("path", {
        d: "M17.419 14.58L21.428 18.589"
    }), $97cb4d9d55c58c9c$var$o.createElement("path", {
        d: "M2.582 5.399L6.588 9.406"
    }), $97cb4d9d55c58c9c$var$o.createElement("path", {
        d: "M9.421 6.581L5.412 2.572"
    }));
}, $97cb4d9d55c58c9c$var$qe = function() {
    return $97cb4d9d55c58c9c$var$o.createElement($97cb4d9d55c58c9c$var$v, {
        size: 16
    }, $97cb4d9d55c58c9c$var$o.createElement("path", {
        d: "M4.000 18.500 A1.500 1.500 0 1 0 7.000 18.500 A1.500 1.500 0 1 0 4.000 18.500 Z"
    }), $97cb4d9d55c58c9c$var$o.createElement("path", {
        d: "M20.5.5l-9.782,9.783a7,7,0,1,0,3,3L17,10h1.5V8.5L19,8h1.5V6.5L21,6h1.5V4.5l1-1V.5Z"
    }));
}, $97cb4d9d55c58c9c$var$Ue = function() {
    return $97cb4d9d55c58c9c$var$o.createElement($97cb4d9d55c58c9c$var$v, {
        size: 16
    }, $97cb4d9d55c58c9c$var$o.createElement("path", {
        d: "M2.000 2.500 L22.000 2.500 L22.000 23.500 L2.000 23.500 Z"
    }), $97cb4d9d55c58c9c$var$o.createElement("path", {
        d: "M6 4.5L6 0.5"
    }), $97cb4d9d55c58c9c$var$o.createElement("path", {
        d: "M18 4.5L18 0.5"
    }), $97cb4d9d55c58c9c$var$o.createElement("path", {
        d: "M10 4.5L10 0.5"
    }), $97cb4d9d55c58c9c$var$o.createElement("path", {
        d: "M14 4.5L14 0.5"
    }));
}, $97cb4d9d55c58c9c$var$Ze = function() {
    return $97cb4d9d55c58c9c$var$o.createElement($97cb4d9d55c58c9c$var$v, {
        size: 16
    }, $97cb4d9d55c58c9c$var$o.createElement("path", {
        d: "M17.5 0.498L17.5 23.498"
    }), $97cb4d9d55c58c9c$var$o.createElement("path", {
        d: "M10.5 0.498L10.5 23.498"
    }), $97cb4d9d55c58c9c$var$o.createElement("path", {
        d: "M23.5.5H6.5a6,6,0,0,0,0,12h4"
    }));
}, $97cb4d9d55c58c9c$var$Je = function() {
    return $97cb4d9d55c58c9c$var$o.createElement($97cb4d9d55c58c9c$var$v, {
        size: 16
    }, $97cb4d9d55c58c9c$var$o.createElement("path", {
        d: "M2.5 22.995L12 6.005 21.5 22.995 2.5 22.995z"
    }));
}, $97cb4d9d55c58c9c$var$Ge = function(e) {
    var t = e.annotation, n = e.childAnnotation, r = e.page, a = e.viewport, i = !1 === t.hasPopup, c = $97cb4d9d55c58c9c$var$xe(t), s = $97cb4d9d55c58c9c$var$me(t), u = !!(t.hasPopup || c || s), p = t.name ? t.name.toLowerCase() : "";
    return $97cb4d9d55c58c9c$var$o.createElement($97cb4d9d55c58c9c$var$be, {
        annotation: t,
        hasPopup: i,
        ignoreBorder: !1,
        isRenderable: u,
        page: r,
        viewport: a
    }, function(e) {
        return $97cb4d9d55c58c9c$var$o.createElement($97cb4d9d55c58c9c$var$o.Fragment, null, $97cb4d9d55c58c9c$var$o.createElement("div", $97cb4d9d55c58c9c$var$l({}, e.slot.attrs, {
            className: "rpv-core__annotation rpv-core__annotation--text",
            "data-annotation-id": t.id,
            onClick: e.popup.toggleOnClick,
            onMouseEnter: e.popup.openOnHover,
            onMouseLeave: e.popup.closeOnHover
        }), p && $97cb4d9d55c58c9c$var$o.createElement("div", {
            className: "rpv-core__annotation-text-icon"
        }, "check" === p && $97cb4d9d55c58c9c$var$o.createElement($97cb4d9d55c58c9c$var$h, null), "comment" === p && $97cb4d9d55c58c9c$var$o.createElement($97cb4d9d55c58c9c$var$We, null), "help" === p && $97cb4d9d55c58c9c$var$o.createElement($97cb4d9d55c58c9c$var$je, null), "insert" === p && $97cb4d9d55c58c9c$var$o.createElement($97cb4d9d55c58c9c$var$Je, null), "key" === p && $97cb4d9d55c58c9c$var$o.createElement($97cb4d9d55c58c9c$var$qe, null), "note" === p && $97cb4d9d55c58c9c$var$o.createElement($97cb4d9d55c58c9c$var$Ue, null), ("newparagraph" === p || "paragraph" === p) && $97cb4d9d55c58c9c$var$o.createElement($97cb4d9d55c58c9c$var$Ze, null)), e.slot.children), n && n.annotationType === $97cb4d9d55c58c9c$export$f50c3066a53a6f2c.Popup && e.popup.opened && $97cb4d9d55c58c9c$var$o.createElement($97cb4d9d55c58c9c$var$Re, {
            annotation: n,
            page: r,
            viewport: a
        }));
    });
}, $97cb4d9d55c58c9c$var$Ye = function(e) {
    var t = e.annotation, n = e.page, r = e.viewport, a = !1 === t.hasPopup, i = $97cb4d9d55c58c9c$var$xe(t), c = $97cb4d9d55c58c9c$var$me(t), s = !!(t.hasPopup || i || c);
    return $97cb4d9d55c58c9c$var$o.createElement($97cb4d9d55c58c9c$var$be, {
        annotation: t,
        hasPopup: a,
        ignoreBorder: !0,
        isRenderable: s,
        page: n,
        viewport: r
    }, function(e) {
        return $97cb4d9d55c58c9c$var$o.createElement("div", $97cb4d9d55c58c9c$var$l({}, e.slot.attrs, {
            className: "rpv-core__annotation rpv-core__annotation--underline",
            "data-annotation-id": t.id,
            onClick: e.popup.toggleOnClick,
            onMouseEnter: e.popup.openOnHover,
            onMouseLeave: e.popup.closeOnHover
        }), e.slot.children);
    });
}, $97cb4d9d55c58c9c$var$Ke = function(e) {
    var t = e.annotations, n = e.doc, r = e.outlines, a = e.page, i = e.pageIndex, c = e.plugins, s = e.rotation, l = e.scale, u = e.onExecuteNamedAction, p = e.onJumpFromLinkAnnotation, d = e.onJumpToDest, g = $97cb4d9d55c58c9c$var$o.useRef(), v = a.getViewport({
        rotation: s,
        scale: l
    }).clone({
        dontFlip: !0
    }), h = t.filter(function(e) {
        return !e.parentId;
    });
    return $97cb4d9d55c58c9c$var$f(function() {
        var e = g.current;
        e && c.forEach(function(t) {
            t.onAnnotationLayerRender && t.onAnnotationLayerRender({
                annotations: h,
                container: e,
                pageIndex: i,
                rotation: s,
                scale: l
            });
        });
    }, []), $97cb4d9d55c58c9c$var$o.createElement("div", {
        ref: g,
        className: "rpv-core__annotation-layer",
        "data-testid": "core__annotation-layer-".concat(i)
    }, h.map(function(e) {
        var c = t.find(function(t) {
            return t.parentId === e.id;
        });
        switch(e.annotationType){
            case $97cb4d9d55c58c9c$export$f50c3066a53a6f2c.Caret:
                return $97cb4d9d55c58c9c$var$o.createElement($97cb4d9d55c58c9c$var$ye, {
                    key: e.id,
                    annotation: e,
                    page: a,
                    viewport: v
                });
            case $97cb4d9d55c58c9c$export$f50c3066a53a6f2c.Circle:
                return $97cb4d9d55c58c9c$var$o.createElement($97cb4d9d55c58c9c$var$Se, {
                    key: e.id,
                    annotation: e,
                    page: a,
                    viewport: v
                });
            case $97cb4d9d55c58c9c$export$f50c3066a53a6f2c.FileAttachment:
                return $97cb4d9d55c58c9c$var$o.createElement($97cb4d9d55c58c9c$var$_e, {
                    key: e.id,
                    annotation: e,
                    page: a,
                    viewport: v
                });
            case $97cb4d9d55c58c9c$export$f50c3066a53a6f2c.FreeText:
                return $97cb4d9d55c58c9c$var$o.createElement($97cb4d9d55c58c9c$var$Pe, {
                    key: e.id,
                    annotation: e,
                    page: a,
                    viewport: v
                });
            case $97cb4d9d55c58c9c$export$f50c3066a53a6f2c.Highlight:
                return $97cb4d9d55c58c9c$var$o.createElement($97cb4d9d55c58c9c$var$Me, {
                    key: e.id,
                    annotation: e,
                    childAnnotation: c,
                    page: a,
                    viewport: v
                });
            case $97cb4d9d55c58c9c$export$f50c3066a53a6f2c.Ink:
                return $97cb4d9d55c58c9c$var$o.createElement($97cb4d9d55c58c9c$var$ke, {
                    key: e.id,
                    annotation: e,
                    page: a,
                    viewport: v
                });
            case $97cb4d9d55c58c9c$export$f50c3066a53a6f2c.Line:
                return $97cb4d9d55c58c9c$var$o.createElement($97cb4d9d55c58c9c$var$Ce, {
                    key: e.id,
                    annotation: e,
                    page: a,
                    viewport: v
                });
            case $97cb4d9d55c58c9c$export$f50c3066a53a6f2c.Link:
                return $97cb4d9d55c58c9c$var$o.createElement($97cb4d9d55c58c9c$var$Ie, {
                    key: e.id,
                    annotation: e,
                    annotationContainerRef: g,
                    doc: n,
                    outlines: r,
                    page: a,
                    pageIndex: i,
                    scale: l,
                    viewport: v,
                    onExecuteNamedAction: u,
                    onJumpFromLinkAnnotation: p,
                    onJumpToDest: d
                });
            case $97cb4d9d55c58c9c$export$f50c3066a53a6f2c.Polygon:
                return $97cb4d9d55c58c9c$var$o.createElement($97cb4d9d55c58c9c$var$Ae, {
                    key: e.id,
                    annotation: e,
                    page: a,
                    viewport: v
                });
            case $97cb4d9d55c58c9c$export$f50c3066a53a6f2c.Polyline:
                return $97cb4d9d55c58c9c$var$o.createElement($97cb4d9d55c58c9c$var$He, {
                    key: e.id,
                    annotation: e,
                    page: a,
                    viewport: v
                });
            case $97cb4d9d55c58c9c$export$f50c3066a53a6f2c.Popup:
                return $97cb4d9d55c58c9c$var$o.createElement($97cb4d9d55c58c9c$var$Re, {
                    key: e.id,
                    annotation: e,
                    page: a,
                    viewport: v
                });
            case $97cb4d9d55c58c9c$export$f50c3066a53a6f2c.Square:
                return $97cb4d9d55c58c9c$var$o.createElement($97cb4d9d55c58c9c$var$Ne, {
                    key: e.id,
                    annotation: e,
                    page: a,
                    viewport: v
                });
            case $97cb4d9d55c58c9c$export$f50c3066a53a6f2c.Squiggly:
                return $97cb4d9d55c58c9c$var$o.createElement($97cb4d9d55c58c9c$var$Ve, {
                    key: e.id,
                    annotation: e,
                    page: a,
                    viewport: v
                });
            case $97cb4d9d55c58c9c$export$f50c3066a53a6f2c.Stamp:
                return $97cb4d9d55c58c9c$var$o.createElement($97cb4d9d55c58c9c$var$ze, {
                    key: e.id,
                    annotation: e,
                    page: a,
                    viewport: v
                });
            case $97cb4d9d55c58c9c$export$f50c3066a53a6f2c.StrikeOut:
                return $97cb4d9d55c58c9c$var$o.createElement($97cb4d9d55c58c9c$var$Be, {
                    key: e.id,
                    annotation: e,
                    page: a,
                    viewport: v
                });
            case $97cb4d9d55c58c9c$export$f50c3066a53a6f2c.Text:
                return $97cb4d9d55c58c9c$var$o.createElement($97cb4d9d55c58c9c$var$Ge, {
                    key: e.id,
                    annotation: e,
                    childAnnotation: c,
                    page: a,
                    viewport: v
                });
            case $97cb4d9d55c58c9c$export$f50c3066a53a6f2c.Underline:
                return $97cb4d9d55c58c9c$var$o.createElement($97cb4d9d55c58c9c$var$Ye, {
                    key: e.id,
                    annotation: e,
                    page: a,
                    viewport: v
                });
            default:
                return $97cb4d9d55c58c9c$var$o.createElement($97cb4d9d55c58c9c$var$o.Fragment, {
                    key: e.id
                });
        }
    }));
}, $97cb4d9d55c58c9c$var$Xe = function(e) {
    var t = e.page, n = e.renderAnnotations, r = $97cb4d9d55c58c9c$var$T(), a = $97cb4d9d55c58c9c$var$o.useState({
        loading: !0,
        annotations: []
    }), i = a[0], c = a[1];
    return $97cb4d9d55c58c9c$var$o.useEffect(function() {
        t.getAnnotations({
            intent: "display"
        }).then(function(e) {
            r.current && c({
                loading: !1,
                annotations: e
            });
        });
    }, []), i.loading ? $97cb4d9d55c58c9c$var$o.createElement($97cb4d9d55c58c9c$var$o.Fragment, null) : n(i.annotations);
}, $97cb4d9d55c58c9c$var$Qe = function(e) {
    var t = e.doc, n = e.outlines, r = e.page, a = e.pageIndex, i = e.plugins, c = e.rotation, s = e.scale, l = e.onExecuteNamedAction, u = e.onJumpFromLinkAnnotation, p = e.onJumpToDest;
    return $97cb4d9d55c58c9c$var$o.createElement($97cb4d9d55c58c9c$var$Xe, {
        page: r,
        renderAnnotations: function(e) {
            return $97cb4d9d55c58c9c$var$o.createElement($97cb4d9d55c58c9c$var$Ke, {
                annotations: e,
                doc: t,
                outlines: n,
                page: r,
                pageIndex: a,
                plugins: i,
                rotation: c,
                scale: s,
                onExecuteNamedAction: l,
                onJumpFromLinkAnnotation: u,
                onJumpToDest: p
            });
        }
    });
}, $97cb4d9d55c58c9c$var$$e = function(e, t) {
    var n = e % t;
    return 0 === n ? e : Math.floor(e - n);
}, $97cb4d9d55c58c9c$var$et = function(e) {
    var t = e.canvasLayerRef, n = e.height, r = e.page, a = e.pageIndex, i = e.plugins, c = e.rotation, s = e.scale, l = e.width, u = e.onRenderCanvasCompleted, p = $97cb4d9d55c58c9c$var$o.useRef();
    return $97cb4d9d55c58c9c$var$f(function() {
        var e = p.current;
        e && e.cancel();
        var n = t.current;
        n.removeAttribute("data-testid"), i.forEach(function(e) {
            e.onCanvasLayerRender && e.onCanvasLayerRender({
                ele: n,
                pageIndex: a,
                rotation: c,
                scale: s,
                status: $97cb4d9d55c58c9c$export$44b6e2a92a1c449f.PreRender
            });
        });
        var o = r.getViewport({
            rotation: c,
            scale: s
        }), l = window.devicePixelRatio || 1, d = Math.sqrt(16777216 / (o.width * o.height)), f = l > d;
        f ? n.style.transform = "scale(1, 1)" : n.style.removeProperty("transform");
        var g = Math.min(d, l), v = function(e, t) {
            var n, r;
            if (Math.floor(e) === e) return [
                e,
                1
            ];
            var o = 1 / e;
            if (o > t) return [
                1,
                t
            ];
            if (Math.floor(o) === o) return [
                1,
                o
            ];
            for(var a = e > 1 ? o : e, i = 0, c = 1, s = 1, l = 1;;){
                var u = i + s, p = c + l;
                if (p > t) break;
                a <= u / p ? (s = (n = [
                    u,
                    p
                ])[0], l = n[1]) : (i = (r = [
                    u,
                    p
                ])[0], c = r[1]);
            }
            return a < (i / c + s / l) / 2 ? a === e ? [
                i,
                c
            ] : [
                c,
                i
            ] : a === e ? [
                s,
                l
            ] : [
                l,
                s
            ];
        }(g, 8), h = v[0], m = v[1];
        n.width = $97cb4d9d55c58c9c$var$$e(o.width * g, h), n.height = $97cb4d9d55c58c9c$var$$e(o.height * g, h), n.style.width = "".concat($97cb4d9d55c58c9c$var$$e(o.width, m), "px"), n.style.height = "".concat($97cb4d9d55c58c9c$var$$e(o.height, m), "px"), n.hidden = !0;
        var x = n.getContext("2d", {
            alpha: !1
        }), w = f || 1 !== l ? [
            g,
            0,
            0,
            g,
            0,
            0
        ] : null;
        return p.current = r.render({
            canvasContext: x,
            transform: w,
            viewport: o
        }), p.current.promise.then(function() {
            n.hidden = !1, n.setAttribute("data-testid", "core__canvas-layer-".concat(a)), i.forEach(function(e) {
                e.onCanvasLayerRender && e.onCanvasLayerRender({
                    ele: n,
                    pageIndex: a,
                    rotation: c,
                    scale: s,
                    status: $97cb4d9d55c58c9c$export$44b6e2a92a1c449f.DidRender
                });
            }), u();
        }, function() {
            u();
        }), function() {
            n && (n.width = 0, n.height = 0);
        };
    }, []), $97cb4d9d55c58c9c$var$o.createElement("div", {
        className: "rpv-core__canvas-layer",
        style: {
            height: "".concat(n, "px"),
            width: "".concat(l, "px")
        }
    }, $97cb4d9d55c58c9c$var$o.createElement("canvas", {
        ref: t
    }));
}, $97cb4d9d55c58c9c$var$tt = function(e) {
    var t = e.height, n = e.page, r = e.rotation, i = e.scale, c = e.width, s = $97cb4d9d55c58c9c$var$o.useRef();
    return $97cb4d9d55c58c9c$var$f(function() {
        var e = s.current, o = n.getViewport({
            rotation: r,
            scale: i
        });
        n.getOperatorList().then(function(r) {
            !function() {
                var e = s.current;
                e && (e.innerHTML = "");
            }(), new $97cb4d9d55c58c9c$var$a.SVGGraphics(n.commonObjs, n.objs).getSVG(r, o).then(function(n) {
                n.style.height = "".concat(t, "px"), n.style.width = "".concat(c, "px"), e.appendChild(n);
            });
        });
    }, []), $97cb4d9d55c58c9c$var$o.createElement("div", {
        className: "rpv-core__svg-layer",
        ref: s
    });
}, $97cb4d9d55c58c9c$var$nt = function(e) {
    var t = e.containerRef, n = e.page, r = e.pageIndex, i = e.plugins, c = e.rotation, s = e.scale, l = e.onRenderTextCompleted, u = $97cb4d9d55c58c9c$var$o.useRef(), p = function() {
        var e = t.current;
        e && ([].slice.call(e.querySelectorAll(".rpv-core__text-layer-text")).forEach(function(t) {
            return e.removeChild(t);
        }), [].slice.call(e.querySelectorAll('br[role="presentation"]')).forEach(function(t) {
            return e.removeChild(t);
        }));
    };
    return $97cb4d9d55c58c9c$var$f(function() {
        var e = u.current;
        e && e.cancel();
        var o = t.current;
        if (o) {
            o.removeAttribute("data-testid");
            var d = n.getViewport({
                rotation: c,
                scale: s
            });
            return i.forEach(function(e) {
                e.onTextLayerRender && e.onTextLayerRender({
                    ele: o,
                    pageIndex: r,
                    scale: s,
                    status: $97cb4d9d55c58c9c$export$44b6e2a92a1c449f.PreRender
                });
            }), n.getTextContent().then(function(e) {
                p(), u.current = $97cb4d9d55c58c9c$var$a.renderTextLayer({
                    container: o,
                    textContent: e,
                    textContentSource: e,
                    viewport: d
                }), u.current.promise.then(function() {
                    o.setAttribute("data-testid", "core__text-layer-".concat(r)), [].slice.call(o.children).forEach(function(e) {
                        e.classList.contains("rpv-core__text-layer-text--not") || e.classList.add("rpv-core__text-layer-text");
                    }), i.forEach(function(e) {
                        e.onTextLayerRender && e.onTextLayerRender({
                            ele: o,
                            pageIndex: r,
                            scale: s,
                            status: $97cb4d9d55c58c9c$export$44b6e2a92a1c449f.DidRender
                        });
                    }), l();
                }, function() {
                    o.removeAttribute("data-testid"), l();
                });
            }), function() {
                var e;
                p(), null === (e = u.current) || void 0 === e || e.cancel();
            };
        }
    }, []), $97cb4d9d55c58c9c$var$o.createElement("div", {
        className: "rpv-core__text-layer",
        ref: t
    });
}, $97cb4d9d55c58c9c$var$rt = function(e) {
    var t = e.doc, n = e.measureRef, r = e.outlines, a = e.pageIndex, i = e.pageRotation, c = e.pageSize, s = e.plugins, l = e.renderPage, u = e.renderQueueKey, p = e.rotation, f = e.scale, g = e.shouldRender, v = e.viewMode, h = e.onExecuteNamedAction, m = e.onJumpFromLinkAnnotation, w = e.onJumpToDest, E = e.onRenderCompleted, b = e.onRotatePage, y = $97cb4d9d55c58c9c$var$T(), S = $97cb4d9d55c58c9c$var$o.useState(null), _ = S[0], P = S[1], R = $97cb4d9d55c58c9c$var$o.useState(!1), M = R[0], k = R[1], C = $97cb4d9d55c58c9c$var$o.useState(!1), L = C[0], O = C[1], F = $97cb4d9d55c58c9c$var$o.useRef(), D = $97cb4d9d55c58c9c$var$o.useRef(), I = Math.abs(p + i) % 180 == 0, A = c.pageWidth * f, H = c.pageHeight * f, N = I ? A : H, V = I ? H : A, z = (c.rotation + p + i) % 360, B = $97cb4d9d55c58c9c$var$o.useRef(0), W = l || function(e) {
        return $97cb4d9d55c58c9c$var$o.createElement($97cb4d9d55c58c9c$var$o.Fragment, null, e.canvasLayer.children, e.textLayer.children, e.annotationLayer.children);
    };
    return $97cb4d9d55c58c9c$var$o.useEffect(function() {
        P(null), k(!1), O(!1);
    }, [
        i,
        p,
        f
    ]), $97cb4d9d55c58c9c$var$o.useEffect(function() {
        g && y.current && !_ && $97cb4d9d55c58c9c$var$de(t, a).then(function(e) {
            y.current && (B.current = u, P(e));
        });
    }, [
        g,
        _
    ]), $97cb4d9d55c58c9c$var$o.useEffect(function() {
        M && L && (u !== B.current ? (P(null), k(!1), O(!1)) : E(a));
    }, [
        M,
        L
    ]), $97cb4d9d55c58c9c$var$o.createElement("div", {
        className: $97cb4d9d55c58c9c$var$d({
            "rpv-core__page-layer": !0,
            "rpv-core__page-layer--dual": v === $97cb4d9d55c58c9c$export$53ec42062883b2d4.DualPage,
            "rpv-core__page-layer--dual-cover": v === $97cb4d9d55c58c9c$export$53ec42062883b2d4.DualPageWithCover,
            "rpv-core__page-layer--single": v === $97cb4d9d55c58c9c$export$53ec42062883b2d4.SinglePage
        }),
        "data-testid": "core__page-layer-".concat(a),
        ref: n,
        style: {
            height: "".concat(V, "px"),
            width: "".concat(N, "px")
        }
    }, _ ? $97cb4d9d55c58c9c$var$o.createElement($97cb4d9d55c58c9c$var$o.Fragment, null, W({
        annotationLayer: {
            attrs: {},
            children: $97cb4d9d55c58c9c$var$o.createElement($97cb4d9d55c58c9c$var$Qe, {
                doc: t,
                outlines: r,
                page: _,
                pageIndex: a,
                plugins: s,
                rotation: z,
                scale: f,
                onExecuteNamedAction: h,
                onJumpFromLinkAnnotation: m,
                onJumpToDest: w
            })
        },
        canvasLayer: {
            attrs: {},
            children: $97cb4d9d55c58c9c$var$o.createElement($97cb4d9d55c58c9c$var$et, {
                canvasLayerRef: F,
                height: V,
                page: _,
                pageIndex: a,
                plugins: s,
                rotation: z,
                scale: f,
                width: N,
                onRenderCanvasCompleted: function() {
                    y.current && k(!0);
                }
            })
        },
        canvasLayerRendered: M,
        doc: t,
        height: V,
        pageIndex: a,
        rotation: z,
        scale: f,
        svgLayer: {
            attrs: {},
            children: $97cb4d9d55c58c9c$var$o.createElement($97cb4d9d55c58c9c$var$tt, {
                height: V,
                page: _,
                rotation: z,
                scale: f,
                width: N
            })
        },
        textLayer: {
            attrs: {},
            children: $97cb4d9d55c58c9c$var$o.createElement($97cb4d9d55c58c9c$var$nt, {
                containerRef: D,
                page: _,
                pageIndex: a,
                plugins: s,
                rotation: z,
                scale: f,
                onRenderTextCompleted: function() {
                    y.current && O(!0);
                }
            })
        },
        textLayerRendered: L,
        width: N,
        markRendered: E,
        onRotatePage: function(e) {
            return b(a, e);
        }
    }), s.map(function(e, n) {
        return e.renderPageLayer ? $97cb4d9d55c58c9c$var$o.createElement($97cb4d9d55c58c9c$var$o.Fragment, {
            key: n
        }, e.renderPageLayer({
            canvasLayerRef: F,
            canvasLayerRendered: M,
            doc: t,
            height: V,
            pageIndex: a,
            rotation: z,
            scale: f,
            textLayerRef: D,
            textLayerRendered: L,
            width: N
        })) : $97cb4d9d55c58c9c$var$o.createElement($97cb4d9d55c58c9c$var$o.Fragment, {
            key: n
        });
    })) : $97cb4d9d55c58c9c$var$o.createElement($97cb4d9d55c58c9c$var$x, {
        testId: "core__page-layer-loading-".concat(a)
    }));
}, $97cb4d9d55c58c9c$var$ot = function(e, t) {
    var n = t.rect;
    return e.height !== n.height || e.width !== n.width ? n : e;
};
!function(e) {
    e.Horizontal = "Horizontal", e.Vertical = "Vertical", e.Both = "Both";
}($97cb4d9d55c58c9c$var$Ee || ($97cb4d9d55c58c9c$var$Ee = {}));
var $97cb4d9d55c58c9c$var$at = function(e) {
    return 1 - Math.pow(1 - e, 4);
}, $97cb4d9d55c58c9c$var$it = 1e-4, $97cb4d9d55c58c9c$var$ct = {
    left: 0,
    top: 0
}, $97cb4d9d55c58c9c$var$st = {
    capture: !1,
    passive: !0
}, $97cb4d9d55c58c9c$var$lt = function(e) {
    var t = e.elementRef, n = e.enableSmoothScroll, r = e.isRtl, a = e.scrollDirection, i = e.onSmoothScroll, c = $97cb4d9d55c58c9c$var$o.useState($97cb4d9d55c58c9c$var$ct), s = c[0], l = c[1], u = $97cb4d9d55c58c9c$var$o.useState(t.current), p = u[0], d = u[1], g = r ? -1 : 1, v = $97cb4d9d55c58c9c$var$o.useRef(a);
    v.current = a;
    var h = $97cb4d9d55c58c9c$var$o.useRef($97cb4d9d55c58c9c$var$ct), m = $97cb4d9d55c58c9c$var$o.useRef(!0), x = $97cb4d9d55c58c9c$var$o.useCallback(function() {
        m.current = !0, n && l(h.current), i(!1);
    }, []), w = $97cb4d9d55c58c9c$var$o.useCallback(function() {
        if (p) {
            switch(v.current){
                case $97cb4d9d55c58c9c$var$Ee.Horizontal:
                    h.current = {
                        left: g * p.scrollLeft,
                        top: 0
                    };
                    break;
                case $97cb4d9d55c58c9c$var$Ee.Both:
                    h.current = {
                        left: g * p.scrollLeft,
                        top: p.scrollTop
                    };
                    break;
                case $97cb4d9d55c58c9c$var$Ee.Vertical:
                default:
                    h.current = {
                        left: 0,
                        top: p.scrollTop
                    };
            }
            n && !m.current || l(h.current);
        }
    }, [
        p
    ]);
    $97cb4d9d55c58c9c$var$f(function() {
        d(t.current);
    }), $97cb4d9d55c58c9c$var$f(function() {
        if (p) return p.addEventListener("scroll", w, $97cb4d9d55c58c9c$var$st), function() {
            p.removeEventListener("scroll", w, $97cb4d9d55c58c9c$var$st);
        };
    }, [
        p
    ]);
    var E = $97cb4d9d55c58c9c$var$o.useCallback(function(e, n) {
        var r = t.current;
        if (!r) return Promise.resolve();
        var o = {
            left: 0,
            top: 0
        };
        switch(v.current){
            case $97cb4d9d55c58c9c$var$Ee.Horizontal:
                o.left = g * e.left;
                break;
            case $97cb4d9d55c58c9c$var$Ee.Both:
                o.left = g * e.left, o.top = e.top;
                break;
            case $97cb4d9d55c58c9c$var$Ee.Vertical:
            default:
                o.top = e.top;
        }
        return n ? (m.current = !1, i(!0), new Promise(function(e, t) {
            !function(e, t, n, r, o, a) {
                void 0 === o && (o = function(e) {
                    return e;
                }), void 0 === a && (a = function() {});
                var i = 0, c = 0, s = !1;
                switch(t){
                    case $97cb4d9d55c58c9c$var$Ee.Horizontal:
                        c = e.scrollLeft, i = 0;
                    case $97cb4d9d55c58c9c$var$Ee.Both:
                        c = e.scrollLeft, i = e.scrollTop;
                        break;
                    case $97cb4d9d55c58c9c$var$Ee.Vertical:
                    default:
                        c = 0, i = e.scrollTop;
                }
                var l = function() {
                    s || (s = !0, e.scrollLeft = n.left, e.scrollTop = n.top, a());
                };
                if (Math.abs(i - n.top) <= $97cb4d9d55c58c9c$var$it && t === $97cb4d9d55c58c9c$var$Ee.Vertical) l();
                else if (Math.abs(c - n.left) <= $97cb4d9d55c58c9c$var$it && t === $97cb4d9d55c58c9c$var$Ee.Horizontal) l();
                else {
                    var u, p = -1, d = c - n.left, f = i - n.top, g = function(a) {
                        -1 === p && (p = a);
                        var v = a - p, h = Math.min(v / r, 1), m = o(h), x = {
                            left: c - d * m,
                            top: i - f * m
                        };
                        switch(t){
                            case $97cb4d9d55c58c9c$var$Ee.Horizontal:
                                e.scrollLeft = x.left;
                                break;
                            case $97cb4d9d55c58c9c$var$Ee.Both:
                                e.scrollLeft = x.left, e.scrollTop = x.top;
                                break;
                            case $97cb4d9d55c58c9c$var$Ee.Vertical:
                            default:
                                e.scrollTop = x.top;
                        }
                        Math.abs(x.top - n.top) <= $97cb4d9d55c58c9c$var$it && Math.abs(x.left - n.left) <= $97cb4d9d55c58c9c$var$it && !s && (window.cancelAnimationFrame(u), l()), v < r ? u = window.requestAnimationFrame(g) : window.cancelAnimationFrame(u);
                    };
                    u = window.requestAnimationFrame(g);
                }
            }(r, v.current, o, 400, $97cb4d9d55c58c9c$var$at, function() {
                x(), e();
            });
        })) : new Promise(function(e, t) {
            switch(v.current){
                case $97cb4d9d55c58c9c$var$Ee.Horizontal:
                    r.scrollLeft = o.left;
                    break;
                case $97cb4d9d55c58c9c$var$Ee.Both:
                    r.scrollLeft = o.left, r.scrollTop = o.top;
                    break;
                case $97cb4d9d55c58c9c$var$Ee.Vertical:
                default:
                    r.scrollTop = o.top;
            }
            e();
        });
    }, [
        t
    ]);
    return {
        scrollOffset: s,
        scrollTo: E
    };
}, $97cb4d9d55c58c9c$var$ut = function(e, t, n) {
    return Math.max(e, Math.min(n, t));
}, $97cb4d9d55c58c9c$var$pt = function(e, t) {
    if (t !== $97cb4d9d55c58c9c$export$53ec42062883b2d4.DualPageWithCover) return 0;
    if (!function(e) {
        var t = e.length;
        if (1 === t) return !1;
        for(var n = 1; n < t; n++)if (e[n].height !== e[0].height || e[n].width !== e[0].width) return !0;
        return !1;
    }(e)) return 2 * e[0].width;
    var n = $97cb4d9d55c58c9c$var$ie(e.slice(1), 2).map(function(e) {
        return 2 === e.length ? e[0].width + e[1].width : e[0].width;
    }), r = [
        e[0].width
    ].concat(n);
    return Math.max.apply(Math, r);
}, $97cb4d9d55c58c9c$var$dt = {
    left: 0,
    top: 0
}, $97cb4d9d55c58c9c$var$ft = {
    left: 0,
    top: 0
}, $97cb4d9d55c58c9c$var$gt = {
    left: 0,
    top: 0
}, $97cb4d9d55c58c9c$var$vt = {
    left: 0,
    top: 0
}, $97cb4d9d55c58c9c$var$ht = {
    height: 0,
    width: 0
}, $97cb4d9d55c58c9c$var$mt = {
    left: 0,
    top: 0
}, $97cb4d9d55c58c9c$var$xt = "data-virtual-index", $97cb4d9d55c58c9c$var$wt = [
    0,
    .1,
    .2,
    .3,
    .4,
    .5,
    .6,
    .7,
    .8,
    .9,
    1
], $97cb4d9d55c58c9c$var$Et = function(e) {
    var t = e.enableSmoothScroll, n = e.isRtl, r = e.numberOfItems, a = e.parentRef, i = e.setRenderRange, c = e.sizes, s = e.scrollMode, u = e.viewMode, p = $97cb4d9d55c58c9c$var$o.useState(!1), d = p[0], g = p[1], v = $97cb4d9d55c58c9c$var$o.useCallback(function(e) {
        return g(e);
    }, []), h = $97cb4d9d55c58c9c$var$o.useRef(s);
    h.current = s;
    var m = $97cb4d9d55c58c9c$var$o.useRef(u);
    m.current = u;
    var x = s === $97cb4d9d55c58c9c$export$c8345932c0874cf8.Wrapped || u === $97cb4d9d55c58c9c$export$53ec42062883b2d4.DualPageWithCover || u === $97cb4d9d55c58c9c$export$53ec42062883b2d4.DualPage ? $97cb4d9d55c58c9c$var$Ee.Both : s === $97cb4d9d55c58c9c$export$c8345932c0874cf8.Horizontal ? $97cb4d9d55c58c9c$var$Ee.Horizontal : $97cb4d9d55c58c9c$var$Ee.Vertical, w = $97cb4d9d55c58c9c$var$lt({
        elementRef: a,
        enableSmoothScroll: t,
        isRtl: n,
        scrollDirection: x,
        onSmoothScroll: v
    }), E = w.scrollOffset, b = w.scrollTo, y = function(e) {
        var t = e.elementRef, n = $97cb4d9d55c58c9c$var$o.useState(t.current), r = n[0], a = n[1], i = $97cb4d9d55c58c9c$var$o.useRef(!1), c = $97cb4d9d55c58c9c$var$o.useReducer($97cb4d9d55c58c9c$var$ot, {
            height: 0,
            width: 0
        }), s = c[0], l = c[1];
        return $97cb4d9d55c58c9c$var$f(function() {
            t.current !== r && a(t.current);
        }), $97cb4d9d55c58c9c$var$f(function() {
            if (r && !i.current) {
                i.current = !0;
                var e = r.getBoundingClientRect(), t = e.height, n = e.width;
                l({
                    rect: {
                        height: t,
                        width: n
                    }
                });
            }
        }, [
            r
        ]), $97cb4d9d55c58c9c$var$o.useEffect(function() {
            if (r) {
                var e = new ResizeObserver(function(e, t) {
                    e.forEach(function(e) {
                        if (e.target === r) {
                            var t = e.contentRect, n = t.height, o = t.width;
                            l({
                                rect: {
                                    height: n,
                                    width: o
                                }
                            });
                        }
                    });
                });
                return e.observe(r), function() {
                    e.unobserve(r);
                };
            }
        }, [
            r
        ]), s;
    }({
        elementRef: a
    }), S = $97cb4d9d55c58c9c$var$o.useRef({
        scrollOffset: $97cb4d9d55c58c9c$var$mt,
        measurements: []
    });
    S.current.scrollOffset = E;
    var _ = $97cb4d9d55c58c9c$var$o.useMemo(function() {
        return Array(r).fill(-1);
    }, []), P = $97cb4d9d55c58c9c$var$o.useState(_), R = P[0], M = P[1], k = $97cb4d9d55c58c9c$var$o.useMemo(function() {
        var e = new IntersectionObserver(function(e) {
            e.forEach(function(e) {
                var t = e.isIntersecting ? e.intersectionRatio : -1, n = e.target.getAttribute($97cb4d9d55c58c9c$var$xt);
                if (n) {
                    var o = parseInt(n, 10);
                    0 <= o && o < r && M(function(e) {
                        return e[o] = t, function(e, t, n) {
                            if (n || 2 === arguments.length) for(var r, o = 0, a = t.length; o < a; o++)!r && o in t || (r || (r = Array.prototype.slice.call(t, 0, o)), r[o] = t[o]);
                            return e.concat(r || Array.prototype.slice.call(t));
                        }([], e, !0);
                    });
                }
            });
        }, {
            threshold: $97cb4d9d55c58c9c$var$wt
        });
        return e;
    }, []), C = $97cb4d9d55c58c9c$var$o.useMemo(function() {
        return s === $97cb4d9d55c58c9c$export$c8345932c0874cf8.Page && u === $97cb4d9d55c58c9c$export$53ec42062883b2d4.SinglePage ? function(e, t, n) {
            for(var r = [], o = 0; o < e; o++){
                var a = {
                    height: Math.max(t.height, n[o].height),
                    width: Math.max(t.width, n[o].width)
                }, i = 0 === o ? $97cb4d9d55c58c9c$var$vt : r[o - 1].end, c = {
                    left: i.left + a.width,
                    top: i.top + a.height
                };
                r[o] = {
                    index: o,
                    start: i,
                    size: a,
                    end: c,
                    visibility: -1
                };
            }
            return r;
        }(r, y, c) : u === $97cb4d9d55c58c9c$export$53ec42062883b2d4.DualPageWithCover ? function(e, t, n, r) {
            for(var o = [], a = 0, i = 0, c = $97cb4d9d55c58c9c$var$gt, s = 0; s < e; s++){
                var l = 0 === s ? {
                    height: r === $97cb4d9d55c58c9c$export$c8345932c0874cf8.Page ? Math.max(t.height, n[s].height) : n[s].height,
                    width: r === $97cb4d9d55c58c9c$export$c8345932c0874cf8.Page ? Math.max(t.width, n[s].width) : n[s].width
                } : {
                    height: r === $97cb4d9d55c58c9c$export$c8345932c0874cf8.Page ? Math.max(t.height, n[s].height) : n[s].height,
                    width: Math.max(t.width / 2, n[s].width)
                };
                r === $97cb4d9d55c58c9c$export$c8345932c0874cf8.Page ? c = 0 === s ? $97cb4d9d55c58c9c$var$gt : {
                    left: s % 2 == 0 ? l.width : 0,
                    top: Math.floor((s - 1) / 2) * l.height + o[0].end.top
                } : 0 === s ? (c = $97cb4d9d55c58c9c$var$gt, a = n[0].height, i = 0) : s % 2 == 1 ? (c = {
                    left: 0,
                    top: a += i
                }, i = s === e - 1 ? n[s].height : Math.max(n[s].height, n[s + 1].height)) : c = {
                    left: o[s - 1].end.left,
                    top: a
                };
                var u = {
                    left: c.left + l.width,
                    top: c.top + l.height
                };
                o[s] = {
                    index: s,
                    start: c,
                    size: l,
                    end: u,
                    visibility: -1
                };
            }
            return o;
        }(r, y, c, s) : u === $97cb4d9d55c58c9c$export$53ec42062883b2d4.DualPage ? function(e, t, n, r) {
            for(var o = [], a = 0, i = 0, c = $97cb4d9d55c58c9c$var$ft, s = 0; s < e; s++){
                var l = {
                    height: r === $97cb4d9d55c58c9c$export$c8345932c0874cf8.Page ? Math.max(t.height, n[s].height) : n[s].height,
                    width: Math.max(t.width / 2, n[s].width)
                };
                r === $97cb4d9d55c58c9c$export$c8345932c0874cf8.Page ? c = {
                    left: s % 2 == 0 ? 0 : l.width,
                    top: Math.floor(s / 2) * l.height
                } : s % 2 == 0 ? (c = {
                    left: 0,
                    top: a += i
                }, i = s === e - 1 ? n[s].height : Math.max(n[s].height, n[s + 1].height)) : c = {
                    left: o[s - 1].end.left,
                    top: a
                };
                var u = {
                    left: c.left + l.width,
                    top: c.top + l.height
                };
                o[s] = {
                    index: s,
                    start: c,
                    size: l,
                    end: u,
                    visibility: -1
                };
            }
            return o;
        }(r, y, c, s) : function(e, t, n, r) {
            for(var o = [], a = 0, i = {
                left: 0,
                top: 0
            }, c = 0, s = $97cb4d9d55c58c9c$var$dt, l = 0; l < e; l++){
                var u = n[l];
                if (0 === l) a = u.width, i = {
                    left: 0,
                    top: 0
                }, c = u.height;
                else switch(r){
                    case $97cb4d9d55c58c9c$export$c8345932c0874cf8.Wrapped:
                        (a += u.width) < t.width ? (s = {
                            left: o[l - 1].end.left,
                            top: i.top
                        }, c = Math.max(c, u.height)) : (a = u.width, i = {
                            left: (s = {
                                left: i.left,
                                top: i.top + c
                            }).left,
                            top: s.top
                        }, c = u.height);
                        break;
                    case $97cb4d9d55c58c9c$export$c8345932c0874cf8.Horizontal:
                    case $97cb4d9d55c58c9c$export$c8345932c0874cf8.Vertical:
                    default:
                        s = o[l - 1].end;
                }
                var p = {
                    left: s.left + u.width,
                    top: s.top + u.height
                };
                o[l] = {
                    index: l,
                    start: s,
                    size: u,
                    end: p,
                    visibility: -1
                };
            }
            return o;
        }(r, y, c, s);
    }, [
        s,
        c,
        u,
        y
    ]), T = C[r - 1] ? {
        height: C[r - 1].end.top,
        width: C[r - 1].end.left
    } : $97cb4d9d55c58c9c$var$ht;
    S.current.measurements = C;
    var L = $97cb4d9d55c58c9c$var$o.useMemo(function() {
        var e = function(e, t, n, r) {
            var o = 0;
            switch(e){
                case $97cb4d9d55c58c9c$var$Ee.Horizontal:
                    o = r.left;
                    break;
                case $97cb4d9d55c58c9c$var$Ee.Vertical:
                default:
                    o = r.top;
            }
            var a = t.length - 1, i = function(e, t, n, r) {
                for(; e <= t;){
                    var o = (e + t) / 2 | 0, a = r(o);
                    if (a < n) e = o + 1;
                    else {
                        if (!(a > n)) return o;
                        t = o - 1;
                    }
                }
                return e > 0 ? e - 1 : 0;
            }(0, a, o, function(n) {
                switch(e){
                    case $97cb4d9d55c58c9c$var$Ee.Horizontal:
                        return t[n].start.left;
                    case $97cb4d9d55c58c9c$var$Ee.Both:
                    case $97cb4d9d55c58c9c$var$Ee.Vertical:
                    default:
                        return t[n].start.top;
                }
            });
            if (e === $97cb4d9d55c58c9c$var$Ee.Both) for(var c = t[i].start.top; i - 1 >= 0 && t[i - 1].start.top === c && t[i - 1].start.left >= r.left;)i--;
            for(var s = i; s <= a;){
                var l = {
                    top: t[s].start.top - r.top,
                    left: t[s].start.left - r.left
                }, u = {
                    height: n.height - l.top,
                    width: n.width - l.left
                };
                if (e === $97cb4d9d55c58c9c$var$Ee.Horizontal && u.width < 0) break;
                if (e === $97cb4d9d55c58c9c$var$Ee.Vertical && u.height < 0) break;
                if (e === $97cb4d9d55c58c9c$var$Ee.Both && (u.width < 0 || u.height < 0)) break;
                s++;
            }
            return {
                start: i,
                end: s
            };
        }(x, C, y, E), t = e.start, n = e.end, o = R.slice($97cb4d9d55c58c9c$var$ut(0, r, t), $97cb4d9d55c58c9c$var$ut(0, r, n)), a = t + o.reduce(function(e, t, n, r) {
            return t > r[e] ? n : e;
        }, 0), c = a = $97cb4d9d55c58c9c$var$ut(0, r - 1, a), s = i({
            endPage: n,
            numPages: r,
            startPage: t
        }), l = s.startPage, p = s.endPage;
        switch(l = Math.max(l, 0), p = Math.min(p, r - 1), u){
            case $97cb4d9d55c58c9c$export$53ec42062883b2d4.DualPageWithCover:
                a > 0 && (c = a % 2 == 1 ? a : a - 1), l = 0 === l ? 0 : l % 2 == 1 ? l : l - 1, r - (p = p % 2 == 1 ? p - 1 : p) <= 2 && (p = r - 1);
                break;
            case $97cb4d9d55c58c9c$export$53ec42062883b2d4.DualPage:
                c = a % 2 == 0 ? a : a - 1, l = l % 2 == 0 ? l : l - 1, p = p % 2 == 1 ? p : p - 1;
                break;
            case $97cb4d9d55c58c9c$export$53ec42062883b2d4.SinglePage:
            default:
                c = a;
        }
        return {
            startPage: l,
            endPage: p,
            maxVisbilityIndex: c
        };
    }, [
        C,
        y,
        E,
        u,
        R
    ]), O = L.startPage, F = L.endPage, D = L.maxVisbilityIndex, I = $97cb4d9d55c58c9c$var$o.useMemo(function() {
        for(var e = [], t = function(t) {
            var n = C[t], r = $97cb4d9d55c58c9c$var$l($97cb4d9d55c58c9c$var$l({}, n), {
                visibility: void 0 !== R[t] ? R[t] : -1,
                measureRef: function(e) {
                    e && (e.setAttribute($97cb4d9d55c58c9c$var$xt, "".concat(t)), k.observe(e));
                }
            });
            e.push(r);
        }, n = O; n <= F; n++)t(n);
        return e;
    }, [
        O,
        F,
        R,
        C
    ]), A = $97cb4d9d55c58c9c$var$o.useCallback(function(e, n) {
        var o = S.current.measurements[$97cb4d9d55c58c9c$var$ut(0, r - 1, e)], a = h.current === $97cb4d9d55c58c9c$export$c8345932c0874cf8.Page ? $97cb4d9d55c58c9c$var$mt : n;
        return o ? b({
            left: a.left + o.start.left,
            top: a.top + o.start.top
        }, t) : Promise.resolve();
    }, [
        b,
        t
    ]), H = $97cb4d9d55c58c9c$var$o.useCallback(function(e, t) {
        var n = S.current.measurements, r = n[e].start, o = n.find(function(e) {
            return e.start.top - r.top > 1e-12;
        });
        if (!o) return Promise.resolve();
        var a = o.index;
        switch(m.current){
            case $97cb4d9d55c58c9c$export$53ec42062883b2d4.DualPage:
                a = a % 2 == 0 ? a : a + 1;
                break;
            case $97cb4d9d55c58c9c$export$53ec42062883b2d4.DualPageWithCover:
                a = a % 2 == 1 ? a : a + 1;
        }
        return A(a, t);
    }, []), N = $97cb4d9d55c58c9c$var$o.useCallback(function(e, t) {
        for(var n = S.current.measurements, o = n[e].start, a = e, i = !1, c = r - 1; c >= 0; c--)if (o.top - n[c].start.top > 1e-12) {
            i = !0, a = n[c].index;
            break;
        }
        if (!i) return Promise.resolve();
        switch(m.current){
            case $97cb4d9d55c58c9c$export$53ec42062883b2d4.DualPage:
                a = a % 2 == 0 ? a : a - 1;
                break;
            case $97cb4d9d55c58c9c$export$53ec42062883b2d4.DualPageWithCover:
                a = a % 2 == 0 ? a - 1 : a;
        }
        return a === e && (a = e - 1), A(a, t);
    }, []), V = $97cb4d9d55c58c9c$var$o.useCallback(function(e, t) {
        if (m.current === $97cb4d9d55c58c9c$export$53ec42062883b2d4.DualPageWithCover || m.current === $97cb4d9d55c58c9c$export$53ec42062883b2d4.DualPage) return H(e, t);
        switch(h.current){
            case $97cb4d9d55c58c9c$export$c8345932c0874cf8.Wrapped:
                return H(e, t);
            case $97cb4d9d55c58c9c$export$c8345932c0874cf8.Horizontal:
            case $97cb4d9d55c58c9c$export$c8345932c0874cf8.Vertical:
            default:
                return A(e + 1, t);
        }
    }, []), z = $97cb4d9d55c58c9c$var$o.useCallback(function(e, t) {
        if (m.current === $97cb4d9d55c58c9c$export$53ec42062883b2d4.DualPageWithCover || m.current === $97cb4d9d55c58c9c$export$53ec42062883b2d4.DualPage) return N(e, t);
        switch(h.current){
            case $97cb4d9d55c58c9c$export$c8345932c0874cf8.Wrapped:
                return N(e, t);
            case $97cb4d9d55c58c9c$export$c8345932c0874cf8.Horizontal:
            case $97cb4d9d55c58c9c$export$c8345932c0874cf8.Vertical:
            default:
                return A(e - 1, t);
        }
    }, []), B = $97cb4d9d55c58c9c$var$o.useCallback(function() {
        return function(e, t) {
            switch(t){
                case $97cb4d9d55c58c9c$export$c8345932c0874cf8.Horizontal:
                    return {
                        position: "relative",
                        height: "100%",
                        width: "".concat(e.width, "px")
                    };
                case $97cb4d9d55c58c9c$export$c8345932c0874cf8.Vertical:
                default:
                    return {
                        position: "relative",
                        height: "".concat(e.height, "px"),
                        width: "100%"
                    };
            }
        }(T, h.current);
    }, [
        T
    ]), W = $97cb4d9d55c58c9c$var$o.useCallback(function(e) {
        return function(e, t, n) {
            return n !== $97cb4d9d55c58c9c$export$c8345932c0874cf8.Page ? {} : {
                height: "".concat(t.height, "px"),
                width: "100%",
                position: "absolute",
                top: 0,
                transform: "translateY(".concat(e.start.top, "px)")
            };
        }(e, y, h.current);
    }, [
        y
    ]), j = $97cb4d9d55c58c9c$var$o.useCallback(function(e) {
        return function(e, t, n, r, o) {
            var a, i, c, s, l, u, p, d = t ? "right" : "left", f = t ? -1 : 1, g = n.length, v = e.start.left * f, h = e.size, m = h.height, x = h.width;
            if (r === $97cb4d9d55c58c9c$export$53ec42062883b2d4.DualPageWithCover) {
                var w = o === $97cb4d9d55c58c9c$export$c8345932c0874cf8.Page ? 0 : e.start.top;
                return 0 === e.index || g % 2 == 0 && e.index === g - 1 ? ((a = {
                    height: "".concat(m, "px"),
                    minWidth: "".concat($97cb4d9d55c58c9c$var$pt(n, r), "px"),
                    width: "100%"
                })[d] = 0, a.position = "absolute", a.top = 0, a.transform = "translate(".concat(v, "px, ").concat(w, "px)"), a) : ((i = {
                    height: "".concat(m, "px"),
                    width: "".concat(x, "px")
                })[d] = 0, i.position = "absolute", i.top = 0, i.transform = "translate(".concat(v, "px, ").concat(w, "px)"), i);
            }
            if (r === $97cb4d9d55c58c9c$export$53ec42062883b2d4.DualPage) return (c = {
                height: "".concat(m, "px"),
                width: "".concat(x, "px")
            })[d] = 0, c.position = "absolute", c.top = 0, c.transform = "translate(".concat(v, "px, ").concat(o === $97cb4d9d55c58c9c$export$c8345932c0874cf8.Page ? 0 : e.start.top, "px)"), c;
            switch(o){
                case $97cb4d9d55c58c9c$export$c8345932c0874cf8.Horizontal:
                    return (s = {
                        height: "100%",
                        width: "".concat(x, "px")
                    })[d] = 0, s.position = "absolute", s.top = 0, s.transform = "translateX(".concat(v, "px)"), s;
                case $97cb4d9d55c58c9c$export$c8345932c0874cf8.Page:
                    return (l = {
                        height: "".concat(m, "px"),
                        width: "".concat(x, "px")
                    })[d] = 0, l.position = "absolute", l.top = 0, l;
                case $97cb4d9d55c58c9c$export$c8345932c0874cf8.Wrapped:
                    return (u = {
                        height: "".concat(m, "px"),
                        width: "".concat(x, "px")
                    })[d] = 0, u.position = "absolute", u.top = 0, u.transform = "translate(".concat(v, "px, ").concat(e.start.top, "px)"), u;
                case $97cb4d9d55c58c9c$export$c8345932c0874cf8.Vertical:
                default:
                    return (p = {
                        height: "".concat(m, "px"),
                        width: "100%"
                    })[d] = 0, p.position = "absolute", p.top = 0, p.transform = "translateY(".concat(e.start.top, "px)"), p;
            }
        }(e, n, c, m.current, h.current);
    }, [
        n,
        c
    ]), q = $97cb4d9d55c58c9c$var$o.useCallback(function(e, t) {
        var n = S.current, o = n.measurements, a = n.scrollOffset, i = o[$97cb4d9d55c58c9c$var$ut(0, r - 1, t)];
        if (i) {
            var c = h.current === $97cb4d9d55c58c9c$export$c8345932c0874cf8.Page ? {
                left: i.start.left,
                top: i.start.top
            } : {
                left: a.left * e,
                top: a.top * e
            };
            return b(c, !1);
        }
        return Promise.resolve();
    }, []);
    return $97cb4d9d55c58c9c$var$o.useEffect(function() {
        return function() {
            k.disconnect();
        };
    }, []), {
        boundingClientRect: y,
        isSmoothScrolling: d,
        startPage: O,
        endPage: F,
        maxVisbilityIndex: D,
        virtualItems: I,
        getContainerStyles: B,
        getItemContainerStyles: W,
        getItemStyles: j,
        scrollToItem: A,
        scrollToNextItem: V,
        scrollToPreviousItem: z,
        zoom: q
    };
}, $97cb4d9d55c58c9c$var$bt = function(e, t, n, r, o, a) {
    var i = n;
    switch(!0){
        case o === $97cb4d9d55c58c9c$export$53ec42062883b2d4.DualPageWithCover && a >= 3:
        case o === $97cb4d9d55c58c9c$export$53ec42062883b2d4.DualPage && a >= 3:
            i = 2 * n;
            break;
        default:
            i = n;
    }
    switch(r){
        case $97cb4d9d55c58c9c$export$d3c2ac82f24f6349.ActualSize:
            return 1;
        case $97cb4d9d55c58c9c$export$d3c2ac82f24f6349.PageFit:
            return Math.min((e.clientWidth - 17) / i, (e.clientHeight - 16) / t);
        case $97cb4d9d55c58c9c$export$d3c2ac82f24f6349.PageWidth:
            return (e.clientWidth - 17) / i;
    }
}, $97cb4d9d55c58c9c$var$yt = function(e) {
    var t, n, r = e.getCurrentPage, a = (t = 50, n = $97cb4d9d55c58c9c$var$o.useRef([]), $97cb4d9d55c58c9c$var$o.useEffect(function() {
        return function() {
            n.current = [];
        };
    }, []), {
        push: function(e) {
            var r = n.current;
            r.length + 1 > t && r.shift(), r.push(e), n.current = r;
        },
        map: function(e) {
            return n.current.map(function(t) {
                return e(t);
            });
        },
        pop: function() {
            var e = n.current;
            if (0 === e.length) return null;
            var t = e.pop();
            return n.current = e, t;
        }
    }), i = function(e) {
        var t = $97cb4d9d55c58c9c$var$o.useRef([]);
        return $97cb4d9d55c58c9c$var$o.useEffect(function() {
            return function() {
                t.current = [];
            };
        }, []), {
            dequeue: function() {
                var e = t.current;
                if (0 === e.length) return null;
                var n = e.shift();
                return t.current = e, n || null;
            },
            enqueue: function(n) {
                var r = t.current;
                r.length + 1 > e && r.pop(), t.current = [
                    n
                ].concat(r);
            },
            map: function(e) {
                return t.current.map(function(t) {
                    return e(t);
                });
            }
        };
    }(50), c = function() {
        var e = i.dequeue();
        return e && a.push(e), e && e.pageIndex === r() ? c() : e;
    }, s = function() {
        var e = a.pop();
        return e && i.enqueue(e), e && e.pageIndex === r() ? s() : e;
    }, l = $97cb4d9d55c58c9c$var$o.useCallback(function(e) {
        a.push(e);
    }, []);
    return {
        getNextDestination: c,
        getPreviousDestination: s,
        markVisitedDestination: l
    };
}, $97cb4d9d55c58c9c$var$St = function(e) {
    var t = [];
    return e.map(function(e) {
        t = t.concat(e).concat(function(e) {
            var t = [];
            return e.items && e.items.length > 0 && (t = t.concat($97cb4d9d55c58c9c$var$St(e.items))), t;
        }(e));
    }), t;
}, $97cb4d9d55c58c9c$var$_t = {
    capture: !1,
    passive: !0
}, $97cb4d9d55c58c9c$var$Pt = {
    height: 0,
    width: 0
}, $97cb4d9d55c58c9c$var$Rt = {
    height: 0,
    width: 0
}, $97cb4d9d55c58c9c$var$Mt = function(e) {
    var t = e.getCurrentPage, n = e.getCurrentScrollMode, r = e.jumpToPage, a = e.targetRef, i = $97cb4d9d55c58c9c$var$o.useState($97cb4d9d55c58c9c$export$8245e75d48f7b7d8.Normal), c = i[0], s = i[1], l = function() {
        var e = $97cb4d9d55c58c9c$var$o.useState($97cb4d9d55c58c9c$var$Pt), t = e[0], n = e[1], r = $97cb4d9d55c58c9c$var$C(function() {
            n({
                height: window.innerHeight,
                width: window.innerWidth
            });
        }, 100);
        return $97cb4d9d55c58c9c$var$f(function() {
            return window.addEventListener("resize", r, $97cb4d9d55c58c9c$var$_t), function() {
                window.removeEventListener("resize", r, $97cb4d9d55c58c9c$var$_t);
            };
        }, []), t;
    }(), u = $97cb4d9d55c58c9c$var$o.useState($97cb4d9d55c58c9c$var$Rt), p = u[0], d = u[1], g = $97cb4d9d55c58c9c$var$o.useRef($97cb4d9d55c58c9c$var$Rt), v = $97cb4d9d55c58c9c$var$o.useRef(t()), h = $97cb4d9d55c58c9c$var$o.useRef($97cb4d9d55c58c9c$var$Rt), m = $97cb4d9d55c58c9c$var$o.useState(a.current), x = m[0], w = m[1], E = $97cb4d9d55c58c9c$var$o.useRef();
    $97cb4d9d55c58c9c$var$f(function() {
        a.current !== x && w(a.current);
    }, []), $97cb4d9d55c58c9c$var$f(function() {
        if (x) {
            var e = new ResizeObserver(function(e) {
                e.forEach(function(e) {
                    var t = e.target.getBoundingClientRect(), n = t.height, r = t.width;
                    d({
                        height: n,
                        width: r
                    });
                });
            });
            return e.observe(x), function() {
                e.unobserve(x), e.disconnect();
            };
        }
    }, [
        x
    ]);
    var b = $97cb4d9d55c58c9c$var$o.useCallback(function(e) {
        var t = $97cb4d9d55c58c9c$var$k();
        return t && t !== e ? (s($97cb4d9d55c58c9c$export$8245e75d48f7b7d8.Normal), $97cb4d9d55c58c9c$var$M(t)) : Promise.resolve();
    }, []), y = $97cb4d9d55c58c9c$var$o.useCallback(function(e) {
        e && $97cb4d9d55c58c9c$var$R() && (w(e), b(e).then(function() {
            E.current = e, s($97cb4d9d55c58c9c$export$8245e75d48f7b7d8.Entering), function(e) {
                $97cb4d9d55c58c9c$var$_ && e[$97cb4d9d55c58c9c$var$P.RequestFullScreen]();
            }(e);
        }));
    }, []), S = $97cb4d9d55c58c9c$var$o.useCallback(function() {
        $97cb4d9d55c58c9c$var$k() && (s($97cb4d9d55c58c9c$export$8245e75d48f7b7d8.Exitting), $97cb4d9d55c58c9c$var$M(document));
    }, []), T = $97cb4d9d55c58c9c$var$o.useCallback(function() {
        x && $97cb4d9d55c58c9c$var$k() !== x && s($97cb4d9d55c58c9c$export$8245e75d48f7b7d8.Exitting);
    }, [
        x
    ]);
    return $97cb4d9d55c58c9c$var$o.useEffect(function() {
        switch(c){
            case $97cb4d9d55c58c9c$export$8245e75d48f7b7d8.Entering:
                E.current && (E.current.style.backgroundColor = "var(--rpv-core__full-screen-target-background-color)"), v.current = t(), g.current = {
                    height: window.innerHeight,
                    width: window.innerWidth
                };
                break;
            case $97cb4d9d55c58c9c$export$8245e75d48f7b7d8.Entered:
                n() === $97cb4d9d55c58c9c$export$c8345932c0874cf8.Page ? r(v.current).then(function() {
                    s($97cb4d9d55c58c9c$export$8245e75d48f7b7d8.EnteredCompletely);
                }) : s($97cb4d9d55c58c9c$export$8245e75d48f7b7d8.EnteredCompletely);
                break;
            case $97cb4d9d55c58c9c$export$8245e75d48f7b7d8.Exitting:
                E.current && (E.current.style.backgroundColor = "", E.current = null), v.current = t();
                break;
            case $97cb4d9d55c58c9c$export$8245e75d48f7b7d8.Exited:
                s($97cb4d9d55c58c9c$export$8245e75d48f7b7d8.Normal), n() === $97cb4d9d55c58c9c$export$c8345932c0874cf8.Page && r(v.current);
        }
    }, [
        c
    ]), $97cb4d9d55c58c9c$var$o.useEffect(function() {
        if (c !== $97cb4d9d55c58c9c$export$8245e75d48f7b7d8.Normal) return c === $97cb4d9d55c58c9c$export$8245e75d48f7b7d8.Entering && l.height === p.height && l.width === p.width && l.height > 0 && l.width > 0 && (0 === h.current.height || l.height == h.current.height) ? (h.current = {
            height: window.innerHeight,
            width: window.innerWidth
        }, void s($97cb4d9d55c58c9c$export$8245e75d48f7b7d8.Entered)) : void (c === $97cb4d9d55c58c9c$export$8245e75d48f7b7d8.Exitting && g.current.height === l.height && g.current.width === l.width && l.height > 0 && l.width > 0 && s($97cb4d9d55c58c9c$export$8245e75d48f7b7d8.Exited));
    }, [
        c,
        l,
        p
    ]), $97cb4d9d55c58c9c$var$o.useEffect(function() {
        var e;
        return e = T, $97cb4d9d55c58c9c$var$_ && document.addEventListener($97cb4d9d55c58c9c$var$P.FullScreenChange, e), function() {
            !function(e) {
                $97cb4d9d55c58c9c$var$_ && document.removeEventListener($97cb4d9d55c58c9c$var$P.FullScreenChange, e);
            }(T);
        };
    }, [
        x
    ]), {
        enterFullScreenMode: y,
        exitFullScreenMode: S,
        fullScreenMode: c
    };
}, $97cb4d9d55c58c9c$var$kt = {
    buildPageStyles: function() {
        return {};
    },
    transformSize: function(e) {
        return e.size;
    }
}, $97cb4d9d55c58c9c$var$Ct = {
    left: 0,
    top: 0
}, $97cb4d9d55c58c9c$var$Tt = function(e) {
    var t = e.currentFile, n = e.defaultScale, r = e.doc, a = e.enableSmoothScroll, i = e.initialPage, c = e.initialRotation, s = e.initialScale, u = e.pageLayout, g = e.pageSizes, v = e.plugins, h = e.renderPage, m = e.scrollMode, x = e.setRenderRange, w = e.viewMode, E = e.viewerState, b = e.onDocumentLoad, y = e.onOpenFile, S = e.onPageChange, _ = e.onRotate, P = e.onRotatePage, R = e.onZoom, M = r.numPages, k = r.loadingTask.docId, O = $97cb4d9d55c58c9c$var$o.useContext($97cb4d9d55c58c9c$var$A).l10n, F = $97cb4d9d55c58c9c$var$o.useContext($97cb4d9d55c58c9c$var$p), I = F.direction === $97cb4d9d55c58c9c$export$63e1cbbb2c6e2c2.RightToLeft, H = $97cb4d9d55c58c9c$var$o.useRef(), N = $97cb4d9d55c58c9c$var$o.useRef(), V = $97cb4d9d55c58c9c$var$o.useState(i), z = V[0], B = V[1], W = $97cb4d9d55c58c9c$var$o.useRef(null), j = $97cb4d9d55c58c9c$var$yt({
        getCurrentPage: function() {
            return me.current.pageIndex;
        }
    }), q = $97cb4d9d55c58c9c$var$o.useState(c), U = q[0], Z = q[1], J = $97cb4d9d55c58c9c$var$L(U), G = $97cb4d9d55c58c9c$var$o.useState(!1), Y = G[0], K = G[1], X = $97cb4d9d55c58c9c$var$o.useState(new Map), Q = X[0], $ = X[1], ee = $97cb4d9d55c58c9c$var$o.useState(m), te = ee[0], ne = ee[1], re = $97cb4d9d55c58c9c$var$L(te), oe = $97cb4d9d55c58c9c$var$o.useState(w), ae = oe[0], ce = oe[1], ue = $97cb4d9d55c58c9c$var$L(ae), pe = function(e) {
        var t = $97cb4d9d55c58c9c$var$T(), n = $97cb4d9d55c58c9c$var$o.useState([]), r = n[0], a = n[1];
        return $97cb4d9d55c58c9c$var$o.useEffect(function() {
            e.getOutline().then(function(e) {
                if (t.current && null !== e) {
                    var n = $97cb4d9d55c58c9c$var$St(e);
                    a(n);
                }
            });
        }, []), r;
    }(r), fe = $97cb4d9d55c58c9c$var$o.useState(s), ge = fe[0], ve = fe[1], he = $97cb4d9d55c58c9c$var$L(ge), me = $97cb4d9d55c58c9c$var$o.useRef(E), xe = $97cb4d9d55c58c9c$var$o.useRef("string" == typeof n ? n : null), we = $97cb4d9d55c58c9c$var$o.useRef(-1), Ee = $97cb4d9d55c58c9c$var$o.useRef(-1), be = $97cb4d9d55c58c9c$var$o.useRef(i), ye = $97cb4d9d55c58c9c$var$Mt({
        getCurrentPage: function() {
            return me.current.pageIndex;
        },
        getCurrentScrollMode: function() {
            return me.current.scrollMode;
        },
        jumpToPage: function(e) {
            return je(e);
        },
        targetRef: N
    }), Se = $97cb4d9d55c58c9c$var$o.useState(-1), _e = Se[0], Pe = Se[1], Re = $97cb4d9d55c58c9c$var$o.useState(0), Me = Re[0], ke = Re[1], Ce = $97cb4d9d55c58c9c$var$D({
        doc: r
    });
    $97cb4d9d55c58c9c$var$o.useEffect(function() {
        return function() {
            $97cb4d9d55c58c9c$var$se.clear(), $97cb4d9d55c58c9c$var$le.clear();
        };
    }, [
        k
    ]);
    var Te = $97cb4d9d55c58c9c$var$o.useMemo(function() {
        return Object.assign({}, $97cb4d9d55c58c9c$var$kt, u);
    }, []), Le = $97cb4d9d55c58c9c$var$o.useMemo(function() {
        return Array(M).fill(0).map(function(e, t) {
            var n = [
                g[t].pageHeight,
                g[t].pageWidth
            ], r = Math.abs(U) % 180 == 0 ? {
                height: n[0],
                width: n[1]
            } : {
                height: n[1],
                width: n[0]
            }, o = {
                height: r.height * ge,
                width: r.width * ge
            };
            return Te.transformSize({
                numPages: M,
                pageIndex: t,
                size: o
            });
        });
    }, [
        U,
        ge
    ]), Oe = $97cb4d9d55c58c9c$var$Et({
        enableSmoothScroll: a,
        isRtl: I,
        numberOfItems: M,
        parentRef: N,
        scrollMode: te,
        setRenderRange: x,
        sizes: Le,
        viewMode: ae
    }), Fe = $97cb4d9d55c58c9c$var$C(function() {
        !xe.current || me.current.fullScreenMode !== $97cb4d9d55c58c9c$export$8245e75d48f7b7d8.Normal || i > 0 && be.current === i || Ke(xe.current);
    }, 200);
    !function(e) {
        var t = e.targetRef, n = e.onResize;
        $97cb4d9d55c58c9c$var$f(function() {
            var e = new ResizeObserver(function(e) {
                e.forEach(function(e) {
                    n(e.target);
                });
            }), r = t.current;
            if (r) return e.observe(r), function() {
                e.unobserve(r);
            };
        }, []);
    }({
        targetRef: N,
        onResize: Fe
    });
    var De = function(e) {
        var t = e;
        v.forEach(function(e) {
            e.onViewerStateChange && (t = e.onViewerStateChange(t));
        }), me.current = t;
    }, Ie = function() {
        return N.current;
    }, Ae = function() {
        return me.current;
    }, He = $97cb4d9d55c58c9c$var$o.useCallback(function(e) {
        j.markVisitedDestination(e);
    }, []), Ne = $97cb4d9d55c58c9c$var$o.useCallback(function(e) {
        var t = e.pageIndex, n = e.bottomOffset, o = e.leftOffset, a = e.scaleTo, i = N.current, c = me.current;
        return i && c ? new Promise(function(e, s) {
            $97cb4d9d55c58c9c$var$de(r, t).then(function(r) {
                var s = r.getViewport({
                    scale: 1
                }), l = 0, u = ("function" == typeof n ? n(s.width, s.height) : n) || 0, p = ("function" == typeof o ? o(s.width, s.height) : o) || 0, d = c.scale;
                switch(a){
                    case $97cb4d9d55c58c9c$export$d3c2ac82f24f6349.PageFit:
                        l = 0, p = 0, Ke($97cb4d9d55c58c9c$export$d3c2ac82f24f6349.PageFit);
                        break;
                    case $97cb4d9d55c58c9c$export$d3c2ac82f24f6349.PageWidth:
                        d = $97cb4d9d55c58c9c$var$bt(i, g[t].pageHeight, g[t].pageWidth, $97cb4d9d55c58c9c$export$d3c2ac82f24f6349.PageWidth, w, M), l = (s.height - u) * d, p *= d, Ke(d);
                        break;
                    default:
                        l = (s.height - u) * d, p *= d;
                }
                switch(c.scrollMode){
                    case $97cb4d9d55c58c9c$export$c8345932c0874cf8.Horizontal:
                        Oe.scrollToItem(t, {
                            left: p,
                            top: 0
                        }).then(function() {
                            e();
                        });
                        break;
                    case $97cb4d9d55c58c9c$export$c8345932c0874cf8.Vertical:
                    default:
                        Oe.scrollToItem(t, {
                            left: 0,
                            top: l
                        }).then(function() {
                            e();
                        });
                }
            });
        }) : Promise.resolve();
    }, []), Ve = $97cb4d9d55c58c9c$var$o.useCallback(function(e) {
        return j.markVisitedDestination(e), Ne(e);
    }, []), ze = $97cb4d9d55c58c9c$var$o.useCallback(function() {
        var e = j.getNextDestination();
        return e ? Ne(e) : Promise.resolve();
    }, []), Be = $97cb4d9d55c58c9c$var$o.useCallback(function() {
        var e = j.getPreviousDestination();
        return e ? Ne(e) : Promise.resolve();
    }, []), We = $97cb4d9d55c58c9c$var$o.useCallback(function() {
        return Oe.scrollToNextItem(me.current.pageIndex, $97cb4d9d55c58c9c$var$Ct);
    }, []), je = $97cb4d9d55c58c9c$var$o.useCallback(function(e) {
        return 0 <= e && e < M ? Oe.scrollToItem(e, $97cb4d9d55c58c9c$var$Ct) : Promise.resolve();
    }, []), qe = $97cb4d9d55c58c9c$var$o.useCallback(function() {
        return Oe.scrollToPreviousItem(me.current.pageIndex, $97cb4d9d55c58c9c$var$Ct);
    }, []), Ue = $97cb4d9d55c58c9c$var$o.useCallback(function(e) {
        var t, n;
        "pdf" === (t = e.name, n = t.split(/\./).pop(), n ? n.toLowerCase() : "").toLowerCase() && new Promise(function(t) {
            var n = new FileReader;
            n.readAsArrayBuffer(e), n.onload = function() {
                var e = new Uint8Array(n.result);
                t(e);
            };
        }).then(function(t) {
            y(e.name, t);
        });
    }, [
        y
    ]), Ze = $97cb4d9d55c58c9c$var$o.useCallback(function(e) {
        var t = e === $97cb4d9d55c58c9c$export$9506977ce2a96a5b.Backward ? -90 : 90, n = me.current.rotation, o = 360 === n || -360 === n ? t : n + t;
        Ce.markNotRendered(), Z(o), De($97cb4d9d55c58c9c$var$l($97cb4d9d55c58c9c$var$l({}, me.current), {
            rotation: o
        })), _({
            direction: e,
            doc: r,
            rotation: o
        });
    }, []), Je = $97cb4d9d55c58c9c$var$o.useCallback(function(e, t) {
        var n = t === $97cb4d9d55c58c9c$export$9506977ce2a96a5b.Backward ? -90 : 90, o = me.current.pagesRotation, a = (o.has(e) ? o.get(e) : c) + n, i = o.set(e, a);
        $(i), K(function(e) {
            return !e;
        }), De($97cb4d9d55c58c9c$var$l($97cb4d9d55c58c9c$var$l({}, me.current), {
            pagesRotation: i,
            rotatedPage: e
        })), P({
            direction: t,
            doc: r,
            pageIndex: e,
            rotation: a
        }), Ce.markRendering(e), Pe(e);
    }, []), Ge = $97cb4d9d55c58c9c$var$o.useCallback(function(e) {
        De($97cb4d9d55c58c9c$var$l($97cb4d9d55c58c9c$var$l({}, me.current), {
            scrollMode: e
        })), ne(e);
    }, []), Ye = $97cb4d9d55c58c9c$var$o.useCallback(function(e) {
        De($97cb4d9d55c58c9c$var$l($97cb4d9d55c58c9c$var$l({}, me.current), {
            viewMode: e
        })), ce(e);
    }, []), Ke = $97cb4d9d55c58c9c$var$o.useCallback(function(e) {
        var t = N.current, n = me.current.pageIndex;
        if (!(n < 0 || n >= M)) {
            var o = g[n].pageHeight, a = g[n].pageWidth, i = t ? "string" == typeof e ? $97cb4d9d55c58c9c$var$bt(t, o, a, e, me.current.viewMode, M) : e : 1;
            xe.current = "string" == typeof e ? e : null, i !== me.current.scale && (ke(function(e) {
                return e + 1;
            }), Ce.markNotRendered(), ve(i), R({
                doc: r,
                scale: i
            }), De($97cb4d9d55c58c9c$var$l($97cb4d9d55c58c9c$var$l({}, me.current), {
                scale: i
            })));
        }
    }, []), Xe = $97cb4d9d55c58c9c$var$o.useCallback(function(e) {
        ye.enterFullScreenMode(e);
    }, []), Qe = $97cb4d9d55c58c9c$var$o.useCallback(function() {
        ye.exitFullScreenMode();
    }, []);
    $97cb4d9d55c58c9c$var$o.useEffect(function() {
        De($97cb4d9d55c58c9c$var$l($97cb4d9d55c58c9c$var$l({}, me.current), {
            fullScreenMode: ye.fullScreenMode
        }));
    }, [
        ye.fullScreenMode
    ]), $97cb4d9d55c58c9c$var$o.useEffect(function() {
        var e = {
            enterFullScreenMode: Xe,
            exitFullScreenMode: Qe,
            getPagesContainer: Ie,
            getViewerState: Ae,
            jumpToDestination: Ve,
            jumpToNextDestination: ze,
            jumpToPreviousDestination: Be,
            jumpToNextPage: We,
            jumpToPreviousPage: qe,
            jumpToPage: je,
            openFile: Ue,
            rotate: Ze,
            rotatePage: Je,
            setViewerState: De,
            switchScrollMode: Ge,
            switchViewMode: Ye,
            zoom: Ke
        };
        return v.forEach(function(t) {
            t.install && t.install(e);
        }), function() {
            v.forEach(function(t) {
                t.uninstall && t.uninstall(e);
            });
        };
    }, [
        k
    ]), $97cb4d9d55c58c9c$var$o.useEffect(function() {
        b({
            doc: r,
            file: t
        }), v.forEach(function(e) {
            e.onDocumentLoad && e.onDocumentLoad({
                doc: r,
                file: t
            });
        });
    }, [
        k
    ]);
    var $e, et, tt, nt = Oe.boundingClientRect;
    $e = function() {
        i && je(i);
    }, et = nt.height > 0 && nt.width > 0, tt = $97cb4d9d55c58c9c$var$o.useRef(!1), $97cb4d9d55c58c9c$var$f(function() {
        et && !tt.current && (tt.current = !0, $e());
    }, [
        $e,
        et
    ]), $97cb4d9d55c58c9c$var$f(function() {
        var e = me.current.pageIndex;
        e > -1 && re !== te && Oe.scrollToItem(e, $97cb4d9d55c58c9c$var$Ct).then(function() {
            ye.fullScreenMode === $97cb4d9d55c58c9c$export$8245e75d48f7b7d8.EnteredCompletely && (a || Ce.markNotRendered(), we.current = -1);
        });
    }, [
        te
    ]), $97cb4d9d55c58c9c$var$f(function() {
        var e = me.current.pageIndex;
        e > -1 && J !== U && Oe.scrollToItem(e, $97cb4d9d55c58c9c$var$Ct);
    }, [
        U
    ]), $97cb4d9d55c58c9c$var$f(function() {
        0 != he && he != me.current.scale && Oe.zoom(me.current.scale / he, me.current.pageIndex).then(function() {
            ye.fullScreenMode === $97cb4d9d55c58c9c$export$8245e75d48f7b7d8.EnteredCompletely && (Ee.current = -1);
        });
    }, [
        ge
    ]), $97cb4d9d55c58c9c$var$f(function() {
        if (ue !== me.current.viewMode) {
            var e = Oe.startPage, t = Oe.endPage, n = Oe.virtualItems;
            Ce.markNotRendered(), Ce.setRange(e, t);
            for(var r = function(e) {
                var t = n.find(function(t) {
                    return t.index === e;
                });
                t && Ce.setVisibility(e, t.visibility);
            }, o = e; o <= t; o++)r(o);
            at();
        }
    }, [
        ae
    ]), $97cb4d9d55c58c9c$var$f(function() {
        var e = me.current.pageIndex;
        e > -1 && ue !== ae && Oe.scrollToItem(e, $97cb4d9d55c58c9c$var$Ct);
    }, [
        ae
    ]), $97cb4d9d55c58c9c$var$f(function() {
        var e = me.current.pageIndex;
        e > 0 && e === i && be.current === i && xe.current && (be.current = -1, Ke(xe.current));
    }, [
        z
    ]), $97cb4d9d55c58c9c$var$o.useEffect(function() {
        Oe.isSmoothScrolling || null !== W.current && W.current === z || (W.current = z, S({
            currentPage: z,
            doc: r
        }));
    }, [
        z,
        Oe.isSmoothScrolling
    ]), $97cb4d9d55c58c9c$var$o.useEffect(function() {
        ye.fullScreenMode === $97cb4d9d55c58c9c$export$8245e75d48f7b7d8.Entering && me.current.scrollMode === $97cb4d9d55c58c9c$export$c8345932c0874cf8.Page && (we.current = me.current.pageIndex), ye.fullScreenMode === $97cb4d9d55c58c9c$export$8245e75d48f7b7d8.EnteredCompletely && me.current.scrollMode === $97cb4d9d55c58c9c$export$c8345932c0874cf8.Page && a && (we.current = -1), ye.fullScreenMode === $97cb4d9d55c58c9c$export$8245e75d48f7b7d8.EnteredCompletely && xe.current && (Ee.current = me.current.pageIndex, Ke(xe.current));
    }, [
        ye.fullScreenMode
    ]), $97cb4d9d55c58c9c$var$o.useEffect(function() {
        if (ye.fullScreenMode !== $97cb4d9d55c58c9c$export$8245e75d48f7b7d8.Entering && ye.fullScreenMode !== $97cb4d9d55c58c9c$export$8245e75d48f7b7d8.Exitting && !Oe.isSmoothScrolling) {
            var e = Oe.startPage, t = Oe.endPage, n = Oe.maxVisbilityIndex, r = Oe.virtualItems, o = n, a = ye.fullScreenMode === $97cb4d9d55c58c9c$export$8245e75d48f7b7d8.Entered || ye.fullScreenMode === $97cb4d9d55c58c9c$export$8245e75d48f7b7d8.EnteredCompletely;
            if (!(a && o !== we.current && we.current > -1 || a && o !== Ee.current && Ee.current > -1)) {
                B(o), De($97cb4d9d55c58c9c$var$l($97cb4d9d55c58c9c$var$l({}, me.current), {
                    pageIndex: o
                })), Ce.setRange(e, t);
                for(var i = function(e) {
                    var t = r.find(function(t) {
                        return t.index === e;
                    });
                    t && Ce.setVisibility(e, t.visibility);
                }, c = e; c <= t; c++)i(c);
                at();
            }
        }
    }, [
        Oe.startPage,
        Oe.endPage,
        Oe.isSmoothScrolling,
        Oe.maxVisbilityIndex,
        ye.fullScreenMode,
        Y,
        U,
        ge
    ]);
    var ot = $97cb4d9d55c58c9c$var$o.useCallback(function(e) {
        Ce.markRendered(e), at();
    }, [
        Me
    ]), at = function() {
        var e = Ce.getHighestPriorityPage();
        e > -1 && Ce.isInRange(e) && (Ce.markRendering(e), Pe(e));
    }, it = function(e) {
        var t = z - 1, n = z + 1;
        switch(e){
            case "FirstPage":
                je(0);
                break;
            case "LastPage":
                je(M - 1);
                break;
            case "NextPage":
                n < M && je(n);
                break;
            case "PrevPage":
                t >= 0 && je(t);
        }
    }, ct = $97cb4d9d55c58c9c$var$o.useCallback(function() {
        var e = Oe.virtualItems, t = [];
        switch(ae){
            case $97cb4d9d55c58c9c$export$53ec42062883b2d4.DualPage:
                t = $97cb4d9d55c58c9c$var$ie(e, 2);
                break;
            case $97cb4d9d55c58c9c$export$53ec42062883b2d4.DualPageWithCover:
                e.length && (t = 0 === e[0].index ? [
                    [
                        e[0]
                    ]
                ].concat($97cb4d9d55c58c9c$var$ie(e.slice(1), 2)) : $97cb4d9d55c58c9c$var$ie(e, 2));
                break;
            case $97cb4d9d55c58c9c$export$53ec42062883b2d4.SinglePage:
            default:
                t = $97cb4d9d55c58c9c$var$ie(e, 1);
        }
        var n = O && O.core ? O.core.pageLabel : "Page {{pageIndex}}", a = {
            attrs: {
                className: "rpv-core__inner-container",
                "data-testid": "core__inner-container",
                ref: H,
                style: {
                    height: "100%"
                }
            },
            children: $97cb4d9d55c58c9c$var$o.createElement($97cb4d9d55c58c9c$var$o.Fragment, null),
            subSlot: {
                attrs: {
                    "data-testid": "core__inner-pages",
                    className: $97cb4d9d55c58c9c$var$d({
                        "rpv-core__inner-pages": !0,
                        "rpv-core__inner-pages--horizontal": te === $97cb4d9d55c58c9c$export$c8345932c0874cf8.Horizontal,
                        "rpv-core__inner-pages--rtl": I,
                        "rpv-core__inner-pages--single": te === $97cb4d9d55c58c9c$export$c8345932c0874cf8.Page,
                        "rpv-core__inner-pages--vertical": te === $97cb4d9d55c58c9c$export$c8345932c0874cf8.Vertical,
                        "rpv-core__inner-pages--wrapped": te === $97cb4d9d55c58c9c$export$c8345932c0874cf8.Wrapped
                    }),
                    ref: N,
                    style: {
                        height: "100%",
                        position: "relative"
                    }
                },
                children: $97cb4d9d55c58c9c$var$o.createElement("div", {
                    "data-testid": "core__inner-current-page-".concat(z),
                    style: Object.assign({
                        "--scale-factor": ge
                    }, Oe.getContainerStyles())
                }, t.map(function(e) {
                    return $97cb4d9d55c58c9c$var$o.createElement("div", {
                        className: $97cb4d9d55c58c9c$var$d({
                            "rpv-core__inner-page-container": !0,
                            "rpv-core__inner-page-container--single": te === $97cb4d9d55c58c9c$export$c8345932c0874cf8.Page
                        }),
                        style: Oe.getItemContainerStyles(e[0]),
                        key: "".concat(e[0].index, "-").concat(ae)
                    }, e.map(function(e) {
                        var t = ae === $97cb4d9d55c58c9c$export$53ec42062883b2d4.DualPageWithCover && (0 === e.index || M % 2 == 0 && e.index === M - 1);
                        return $97cb4d9d55c58c9c$var$o.createElement("div", {
                            "aria-label": n.replace("{{pageIndex}}", "".concat(e.index + 1)),
                            className: $97cb4d9d55c58c9c$var$d({
                                "rpv-core__inner-page": !0,
                                "rpv-core__inner-page--dual-even": ae === $97cb4d9d55c58c9c$export$53ec42062883b2d4.DualPage && e.index % 2 == 0,
                                "rpv-core__inner-page--dual-odd": ae === $97cb4d9d55c58c9c$export$53ec42062883b2d4.DualPage && e.index % 2 == 1,
                                "rpv-core__inner-page--dual-cover": t,
                                "rpv-core__inner-page--dual-cover-even": ae === $97cb4d9d55c58c9c$export$53ec42062883b2d4.DualPageWithCover && !t && e.index % 2 == 0,
                                "rpv-core__inner-page--dual-cover-odd": ae === $97cb4d9d55c58c9c$export$53ec42062883b2d4.DualPageWithCover && !t && e.index % 2 == 1,
                                "rpv-core__inner-page--single": ae === $97cb4d9d55c58c9c$export$53ec42062883b2d4.SinglePage && te === $97cb4d9d55c58c9c$export$c8345932c0874cf8.Page
                            }),
                            role: "region",
                            key: "".concat(e.index, "-").concat(ae),
                            style: Object.assign({}, Oe.getItemStyles(e), Te.buildPageStyles({
                                numPages: M,
                                pageIndex: e.index,
                                scrollMode: te,
                                viewMode: ae
                            }))
                        }, $97cb4d9d55c58c9c$var$o.createElement($97cb4d9d55c58c9c$var$rt, {
                            doc: r,
                            measureRef: e.measureRef,
                            outlines: pe,
                            pageIndex: e.index,
                            pageRotation: Q.has(e.index) ? Q.get(e.index) : 0,
                            pageSize: g[e.index],
                            plugins: v,
                            renderPage: h,
                            renderQueueKey: Me,
                            rotation: U,
                            scale: ge,
                            shouldRender: _e === e.index,
                            viewMode: ae,
                            onExecuteNamedAction: it,
                            onJumpFromLinkAnnotation: He,
                            onJumpToDest: Ve,
                            onRenderCompleted: ot,
                            onRotatePage: Je
                        }));
                    }));
                }))
            }
        };
        return v.forEach(function(e) {
            e.renderViewer && (a = e.renderViewer({
                containerRef: H,
                doc: r,
                pagesContainerRef: N,
                pagesRotation: Q,
                pageSizes: g,
                rotation: U,
                slot: a,
                themeContext: F,
                jumpToPage: je,
                openFile: Ue,
                rotate: Ze,
                rotatePage: Je,
                switchScrollMode: Ge,
                switchViewMode: Ye,
                zoom: Ke
            }));
        }), a;
    }, [
        v,
        Oe
    ]), st = $97cb4d9d55c58c9c$var$o.useCallback(function(e) {
        return $97cb4d9d55c58c9c$var$o.createElement("div", $97cb4d9d55c58c9c$var$l({}, e.attrs, {
            style: e.attrs && e.attrs.style ? e.attrs.style : {}
        }), e.children, e.subSlot && st(e.subSlot));
    }, []);
    return st(ct());
}, $97cb4d9d55c58c9c$var$Lt = [
    .1,
    .2,
    .3,
    .4,
    .5,
    .6,
    .7,
    .8,
    .9,
    1,
    1.1,
    1.3,
    1.5,
    1.7,
    1.9,
    2.1,
    2.4,
    2.7,
    3,
    3.3,
    3.7,
    4.1,
    4.6,
    5.1,
    5.7,
    6.3,
    7,
    7.7,
    8.5,
    9.4,
    10
], $97cb4d9d55c58c9c$var$Ot = function(e) {
    var t = e.defaultScale, n = e.doc, r = e.render, a = e.scrollMode, i = e.viewMode, c = $97cb4d9d55c58c9c$var$o.useRef(), s = $97cb4d9d55c58c9c$var$o.useState({
        pageSizes: [],
        scale: 0
    }), l = s[0], u = s[1];
    return $97cb4d9d55c58c9c$var$o.useLayoutEffect(function() {
        var e = Array(n.numPages).fill(0).map(function(e, t) {
            return new Promise(function(e, r) {
                $97cb4d9d55c58c9c$var$de(n, t).then(function(t) {
                    var n = t.getViewport({
                        scale: 1
                    });
                    e({
                        pageHeight: n.height,
                        pageWidth: n.width,
                        rotation: n.rotation
                    });
                });
            });
        });
        Promise.all(e).then(function(e) {
            var r = c.current;
            if (r && 0 !== e.length) {
                var o = e[0].pageWidth, s = e[0].pageHeight, l = r.parentElement, p = (l.clientWidth - 45) / o, d = (l.clientHeight - 45) / s, f = p;
                switch(a){
                    case $97cb4d9d55c58c9c$export$c8345932c0874cf8.Horizontal:
                        f = Math.min(p, d);
                        break;
                    case $97cb4d9d55c58c9c$export$c8345932c0874cf8.Vertical:
                    default:
                        f = p;
                }
                var g, v, h = t ? "string" == typeof t ? $97cb4d9d55c58c9c$var$bt(l, s, o, t, i, n.numPages) : t : (g = f, -1 === (v = $97cb4d9d55c58c9c$var$Lt.findIndex(function(e) {
                    return e >= g;
                })) || 0 === v ? g : $97cb4d9d55c58c9c$var$Lt[v - 1]);
                u({
                    pageSizes: e,
                    scale: h
                });
            }
        });
    }, [
        n.loadingTask.docId
    ]), 0 === l.pageSizes.length || 0 === l.scale ? $97cb4d9d55c58c9c$var$o.createElement("div", {
        className: "rpv-core__page-size-calculator",
        "data-testid": "core__page-size-calculating",
        ref: c
    }, $97cb4d9d55c58c9c$var$o.createElement($97cb4d9d55c58c9c$var$x, null)) : r(l.pageSizes, l.scale);
}, $97cb4d9d55c58c9c$var$Ft = function() {}, $97cb4d9d55c58c9c$var$Dt = function(e) {
    function t(t, n) {
        var r = e.call(this) || this;
        return r.verifyPassword = t, r.passwordStatus = n, r;
    }
    return $97cb4d9d55c58c9c$var$c(t, e), t;
}($97cb4d9d55c58c9c$var$Ft), $97cb4d9d55c58c9c$var$It = function(e) {
    var t = e.passwordStatus, n = e.renderProtectedView, r = e.verifyPassword, a = e.onDocumentAskPassword, i = $97cb4d9d55c58c9c$var$o.useContext($97cb4d9d55c58c9c$var$A).l10n, c = $97cb4d9d55c58c9c$var$o.useState(""), s = c[0], l = c[1], u = $97cb4d9d55c58c9c$var$o.useContext($97cb4d9d55c58c9c$var$p).direction === $97cb4d9d55c58c9c$export$63e1cbbb2c6e2c2.RightToLeft, f = function() {
        return r(s);
    };
    return $97cb4d9d55c58c9c$var$o.useEffect(function() {
        a && a({
            verifyPassword: r
        });
    }, []), n ? n({
        passwordStatus: t,
        verifyPassword: r
    }) : $97cb4d9d55c58c9c$var$o.createElement("div", {
        className: "rpv-core__asking-password-wrapper"
    }, $97cb4d9d55c58c9c$var$o.createElement("div", {
        className: $97cb4d9d55c58c9c$var$d({
            "rpv-core__asking-password": !0,
            "rpv-core__asking-password--rtl": u
        })
    }, $97cb4d9d55c58c9c$var$o.createElement("div", {
        className: "rpv-core__asking-password-message"
    }, t === $97cb4d9d55c58c9c$export$51a8e1495775a8d0.RequiredPassword && i.core.askingPassword.requirePasswordToOpen, t === $97cb4d9d55c58c9c$export$51a8e1495775a8d0.WrongPassword && i.core.wrongPassword.tryAgain), $97cb4d9d55c58c9c$var$o.createElement("div", {
        className: "rpv-core__asking-password-body"
    }, $97cb4d9d55c58c9c$var$o.createElement("div", {
        className: $97cb4d9d55c58c9c$var$d({
            "rpv-core__asking-password-input": !0,
            "rpv-core__asking-password-input--ltr": !u,
            "rpv-core__asking-password-input--rtl": u
        })
    }, $97cb4d9d55c58c9c$var$o.createElement($97cb4d9d55c58c9c$var$w, {
        testId: "core__asking-password-input",
        type: "password",
        value: s,
        onChange: l,
        onKeyDown: function(e) {
            "Enter" === e.key && f();
        }
    })), $97cb4d9d55c58c9c$var$o.createElement($97cb4d9d55c58c9c$var$m, {
        onClick: f
    }, i.core.askingPassword.submit))));
}, $97cb4d9d55c58c9c$var$At = function(e) {
    function t(t) {
        var n = e.call(this) || this;
        return n.doc = t, n;
    }
    return $97cb4d9d55c58c9c$var$c(t, e), t;
}($97cb4d9d55c58c9c$var$Ft), $97cb4d9d55c58c9c$var$Ht = function(e) {
    function t(t) {
        var n = e.call(this) || this;
        return n.error = t, n;
    }
    return $97cb4d9d55c58c9c$var$c(t, e), t;
}($97cb4d9d55c58c9c$var$Ft), $97cb4d9d55c58c9c$var$Nt = function(e) {
    function t(t) {
        var n = e.call(this) || this;
        return n.percentages = t, n;
    }
    return $97cb4d9d55c58c9c$var$c(t, e), t;
}($97cb4d9d55c58c9c$var$Ft), $97cb4d9d55c58c9c$var$Vt = function(e) {
    var t = e.characterMap, n = e.file, r = e.httpHeaders, i = e.render, c = e.renderError, s = e.renderLoader, l = e.renderProtectedView, u = e.transformGetDocumentParams, f = e.withCredentials, g = e.onDocumentAskPassword, v = $97cb4d9d55c58c9c$var$o.useContext($97cb4d9d55c58c9c$var$p).direction === $97cb4d9d55c58c9c$export$63e1cbbb2c6e2c2.RightToLeft, h = $97cb4d9d55c58c9c$var$o.useState(new $97cb4d9d55c58c9c$var$Nt(0)), m = h[0], w = h[1], E = $97cb4d9d55c58c9c$var$o.useRef(""), b = $97cb4d9d55c58c9c$var$T();
    return $97cb4d9d55c58c9c$var$o.useEffect(function() {
        E.current = "", w(new $97cb4d9d55c58c9c$var$Nt(0));
        var e = new $97cb4d9d55c58c9c$var$a.PDFWorker({
            name: "PDFWorker_".concat(Date.now())
        }), o = Object.assign({
            httpHeaders: r,
            withCredentials: f,
            worker: e
        }, "string" == typeof n ? {
            url: n
        } : {
            data: n
        }, t ? {
            cMapUrl: t.url,
            cMapPacked: t.isCompressed
        } : {}), i = u ? u(o) : o, c = $97cb4d9d55c58c9c$var$a.getDocument(i);
        return c.onPassword = function(e, t) {
            switch(t){
                case $97cb4d9d55c58c9c$var$a.PasswordResponses.NEED_PASSWORD:
                    b.current && w(new $97cb4d9d55c58c9c$var$Dt(e, $97cb4d9d55c58c9c$export$51a8e1495775a8d0.RequiredPassword));
                    break;
                case $97cb4d9d55c58c9c$var$a.PasswordResponses.INCORRECT_PASSWORD:
                    b.current && w(new $97cb4d9d55c58c9c$var$Dt(e, $97cb4d9d55c58c9c$export$51a8e1495775a8d0.WrongPassword));
            }
        }, c.onProgress = function(e) {
            var t = e.total > 0 ? Math.min(100, 100 * e.loaded / e.total) : 100;
            b.current && "" === E.current && w(new $97cb4d9d55c58c9c$var$Nt(t));
        }, c.promise.then(function(e) {
            E.current = e.loadingTask.docId, b.current && w(new $97cb4d9d55c58c9c$var$At(e));
        }, function(t) {
            return b.current && !e.destroyed && w(new $97cb4d9d55c58c9c$var$Ht({
                message: t.message || "Cannot load document",
                name: t.name
            }));
        }), function() {
            c.destroy(), e.destroy();
        };
    }, [
        n
    ]), m instanceof $97cb4d9d55c58c9c$var$Dt ? $97cb4d9d55c58c9c$var$o.createElement($97cb4d9d55c58c9c$var$It, {
        passwordStatus: m.passwordStatus,
        renderProtectedView: l,
        verifyPassword: m.verifyPassword,
        onDocumentAskPassword: g
    }) : m instanceof $97cb4d9d55c58c9c$var$At ? i(m.doc) : m instanceof $97cb4d9d55c58c9c$var$Ht ? c ? c(m.error) : $97cb4d9d55c58c9c$var$o.createElement("div", {
        className: $97cb4d9d55c58c9c$var$d({
            "rpv-core__doc-error": !0,
            "rpv-core__doc-error--rtl": v
        })
    }, $97cb4d9d55c58c9c$var$o.createElement("div", {
        className: "rpv-core__doc-error-text"
    }, m.error.message)) : $97cb4d9d55c58c9c$var$o.createElement("div", {
        "data-testid": "core__doc-loading",
        className: $97cb4d9d55c58c9c$var$d({
            "rpv-core__doc-loading": !0,
            "rpv-core__doc-loading--rtl": v
        })
    }, s ? s(m.percentages) : $97cb4d9d55c58c9c$var$o.createElement($97cb4d9d55c58c9c$var$x, null));
}, $97cb4d9d55c58c9c$var$zt = function(e, t) {
    var n = $97cb4d9d55c58c9c$var$o.useMemo(function() {
        return "auto" === e ? "undefined" != typeof window && window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light" : e;
    }, []), r = $97cb4d9d55c58c9c$var$o.useState(n), a = r[0], i = r[1], c = $97cb4d9d55c58c9c$var$L(a);
    return $97cb4d9d55c58c9c$var$o.useEffect(function() {
        if ("auto" === e) {
            var t = window.matchMedia("(prefers-color-scheme: dark)"), n = function(e) {
                i(e.matches ? "dark" : "light");
            };
            return t.addEventListener("change", n), function() {
                return t.removeEventListener("change", n);
            };
        }
    }, []), $97cb4d9d55c58c9c$var$o.useEffect(function() {
        a !== c && t && t(a);
    }, [
        a
    ]), $97cb4d9d55c58c9c$var$o.useEffect(function() {
        e !== a && i(e);
    }, [
        e
    ]), {
        currentTheme: a,
        setCurrentTheme: i
    };
}, $97cb4d9d55c58c9c$var$Bt = function(e) {
    return {
        startPage: e.startPage - 3,
        endPage: e.endPage + 3
    };
};
$97cb4d9d55c58c9c$export$353f5b6fc5456de1 = function(e) {
    var t = e.children, n = e.testId, r = e.onClick, a = $97cb4d9d55c58c9c$var$o.useContext($97cb4d9d55c58c9c$var$p).direction === $97cb4d9d55c58c9c$export$63e1cbbb2c6e2c2.RightToLeft, i = n ? {
        "data-testid": n
    } : {};
    return $97cb4d9d55c58c9c$var$o.createElement("button", $97cb4d9d55c58c9c$var$l({
        className: $97cb4d9d55c58c9c$var$d({
            "rpv-core__button": !0,
            "rpv-core__button--rtl": a
        }),
        type: "button",
        onClick: r
    }, i), t);
}, $97cb4d9d55c58c9c$export$f04a61298a47a40f = $97cb4d9d55c58c9c$var$v, $97cb4d9d55c58c9c$export$b50f6188b08ba944 = function(e) {
    var t = e.attrs, n = e.children, r = e.testId, a = $97cb4d9d55c58c9c$var$o.useState(!1), i = a[0], c = a[1], s = r ? $97cb4d9d55c58c9c$var$l($97cb4d9d55c58c9c$var$l({}, t), {
        "data-testid": r
    }) : t, u = $97cb4d9d55c58c9c$var$g({
        once: !0,
        onVisibilityChanged: function(e) {
            e.isVisible && c(!0);
        }
    });
    return $97cb4d9d55c58c9c$var$o.createElement("div", $97cb4d9d55c58c9c$var$l({
        ref: u
    }, s), i && n);
}, $97cb4d9d55c58c9c$export$51216bcc3983e55d = $97cb4d9d55c58c9c$var$A, $97cb4d9d55c58c9c$export$d9b273488cd8ce6f = function(e) {
    var t = e.children, n = $97cb4d9d55c58c9c$var$o.useRef(), r = $97cb4d9d55c58c9c$var$o.useRef([]), a = $97cb4d9d55c58c9c$var$o.useContext($97cb4d9d55c58c9c$var$p).direction === $97cb4d9d55c58c9c$export$63e1cbbb2c6e2c2.RightToLeft, i = function(e) {
        if (n.current) switch(e.key){
            case "Tab":
                e.preventDefault();
                break;
            case "ArrowDown":
                e.preventDefault(), c(function(e, t) {
                    return t + 1;
                });
                break;
            case "ArrowUp":
                e.preventDefault(), c(function(e, t) {
                    return t - 1;
                });
                break;
            case "End":
                e.preventDefault(), c(function(e, t) {
                    return e.length - 1;
                });
                break;
            case "Home":
                e.preventDefault(), c(function(e, t) {
                    return 0;
                });
        }
    }, c = function(e) {
        if (n.current) {
            var t = r.current, o = t.findIndex(function(e) {
                return "0" === e.getAttribute("tabindex");
            }), a = Math.min(t.length - 1, Math.max(0, e(t, o)));
            o >= 0 && o <= t.length - 1 && t[o].setAttribute("tabindex", "-1"), t[a].setAttribute("tabindex", "0"), t[a].focus();
        }
    };
    return $97cb4d9d55c58c9c$var$f(function() {
        var e = n.current;
        if (e) {
            var t = function(e) {
                var t = [];
                return e.querySelectorAll('.rpv-core__menu-item[role="menuitem"]').forEach(function(n) {
                    if (n instanceof HTMLElement) {
                        var r = n.parentElement;
                        (r === e || "none" !== window.getComputedStyle(r).display) && t.push(n);
                    }
                }), t;
            }(e);
            r.current = t;
        }
    }, []), $97cb4d9d55c58c9c$var$f(function() {
        return document.addEventListener("keydown", i), function() {
            document.removeEventListener("keydown", i);
        };
    }, []), $97cb4d9d55c58c9c$var$o.createElement("div", {
        ref: n,
        "aria-orientation": "vertical",
        className: $97cb4d9d55c58c9c$var$d({
            "rpv-core__menu": !0,
            "rpv-core__menu--rtl": a
        }),
        role: "menu",
        tabIndex: 0
    }, t);
}, $97cb4d9d55c58c9c$export$acb07b4664ac227c = function() {
    return $97cb4d9d55c58c9c$var$o.createElement("div", {
        "aria-orientation": "horizontal",
        className: "rpv-core__menu-divider",
        role: "separator"
    });
}, $97cb4d9d55c58c9c$export$2ce376c2cc3355c8 = function(e) {
    var t = e.checked, n = void 0 !== t && t, r = e.children, a = e.icon, i = void 0 === a ? null : a, c = e.isDisabled, s = void 0 !== c && c, u = e.testId, f = e.onClick, g = $97cb4d9d55c58c9c$var$o.useContext($97cb4d9d55c58c9c$var$p).direction === $97cb4d9d55c58c9c$export$63e1cbbb2c6e2c2.RightToLeft, v = u ? {
        "data-testid": u
    } : {};
    return $97cb4d9d55c58c9c$var$o.createElement("button", $97cb4d9d55c58c9c$var$l({
        className: $97cb4d9d55c58c9c$var$d({
            "rpv-core__menu-item": !0,
            "rpv-core__menu-item--disabled": s,
            "rpv-core__menu-item--ltr": !g,
            "rpv-core__menu-item--rtl": g
        }),
        role: "menuitem",
        tabIndex: -1,
        type: "button",
        onClick: f
    }, v), $97cb4d9d55c58c9c$var$o.createElement("div", {
        className: $97cb4d9d55c58c9c$var$d({
            "rpv-core__menu-item-icon": !0,
            "rpv-core__menu-item-icon--ltr": !g,
            "rpv-core__menu-item-icon--rtl": g
        })
    }, i), $97cb4d9d55c58c9c$var$o.createElement("div", {
        className: $97cb4d9d55c58c9c$var$d({
            "rpv-core__menu-item-label": !0,
            "rpv-core__menu-item-label--ltr": !g,
            "rpv-core__menu-item-label--rtl": g
        })
    }, r), $97cb4d9d55c58c9c$var$o.createElement("div", {
        className: $97cb4d9d55c58c9c$var$d({
            "rpv-core__menu-item-check": !0,
            "rpv-core__menu-item-check--ltr": !g,
            "rpv-core__menu-item-check--rtl": g
        })
    }, n && $97cb4d9d55c58c9c$var$o.createElement($97cb4d9d55c58c9c$var$h, null)));
}, $97cb4d9d55c58c9c$export$8df1b561423ecb3c = function(e) {
    var t = e.ariaLabel, n = void 0 === t ? "" : t, r = e.ariaKeyShortcuts, a = void 0 === r ? "" : r, i = e.children, c = e.isDisabled, s = void 0 !== c && c, u = e.isSelected, f = void 0 !== u && u, g = e.testId, v = e.onClick, h = $97cb4d9d55c58c9c$var$o.useContext($97cb4d9d55c58c9c$var$p).direction === $97cb4d9d55c58c9c$export$63e1cbbb2c6e2c2.RightToLeft, m = g ? {
        "data-testid": g
    } : {};
    return $97cb4d9d55c58c9c$var$o.createElement("button", $97cb4d9d55c58c9c$var$l({
        "aria-label": n
    }, a && {
        "aria-keyshortcuts": a
    }, s && {
        "aria-disabled": !0
    }, {
        className: $97cb4d9d55c58c9c$var$d({
            "rpv-core__minimal-button": !0,
            "rpv-core__minimal-button--disabled": s,
            "rpv-core__minimal-button--rtl": h,
            "rpv-core__minimal-button--selected": f
        }),
        type: "button",
        onClick: v
    }, m), i);
}, $97cb4d9d55c58c9c$export$2b77a92f1a5ad772 = function(e) {
    var t = e.ariaControlsSuffix, n = e.closeOnClickOutside, r = e.closeOnEscape, a = e.content, i = e.isOpened, c = void 0 !== i && i, s = e.target, l = t || "".concat($97cb4d9d55c58c9c$var$N());
    return $97cb4d9d55c58c9c$var$o.createElement($97cb4d9d55c58c9c$var$U, {
        target: s ? function(e, t) {
            return $97cb4d9d55c58c9c$var$o.createElement("div", {
                "aria-expanded": t ? "true" : "false",
                "aria-haspopup": "dialog",
                "aria-controls": "rpv-core__modal-body-".concat(l)
            }, s(e, t));
        } : null,
        content: function(e) {
            return $97cb4d9d55c58c9c$var$o.createElement($97cb4d9d55c58c9c$var$W, null, $97cb4d9d55c58c9c$var$o.createElement($97cb4d9d55c58c9c$var$B, {
                ariaControlsSuffix: l,
                closeOnClickOutside: n,
                closeOnEscape: r,
                onToggle: e
            }, a(e)));
        },
        isOpened: c
    });
}, $97cb4d9d55c58c9c$export$5b6b19405a83ff9d = function(e) {
    var t = e.ariaHasPopup, n = void 0 === t ? "dialog" : t, r = e.ariaControlsSuffix, a = e.closeOnClickOutside, i = e.closeOnEscape, c = e.content, s = e.lockScroll, l = void 0 === s || s, u = e.offset, p = e.position, d = e.target, f = $97cb4d9d55c58c9c$var$q(!1), g = f.opened, v = f.toggle, h = $97cb4d9d55c58c9c$var$o.useRef(), m = $97cb4d9d55c58c9c$var$o.useMemo(function() {
        return r || "".concat($97cb4d9d55c58c9c$var$N());
    }, []);
    return $97cb4d9d55c58c9c$var$o.createElement("div", {
        ref: h,
        "aria-expanded": g ? "true" : "false",
        "aria-haspopup": n,
        "aria-controls": "rpv-core__popver-body-".concat(m)
    }, d(v, g), g && $97cb4d9d55c58c9c$var$o.createElement($97cb4d9d55c58c9c$var$o.Fragment, null, l && $97cb4d9d55c58c9c$var$o.createElement($97cb4d9d55c58c9c$var$re, {
        closeOnEscape: i,
        onClose: v
    }), $97cb4d9d55c58c9c$var$o.createElement($97cb4d9d55c58c9c$var$ne, {
        ariaControlsSuffix: m,
        closeOnClickOutside: a,
        offset: u,
        position: p,
        targetRef: h,
        onClose: v
    }, c(v))));
}, $97cb4d9d55c58c9c$export$ac16a6a04d9b7c84 = $97cb4d9d55c58c9c$var$m, $97cb4d9d55c58c9c$export$c17561cb55d4db30 = function(e) {
    var t = e.progress, n = $97cb4d9d55c58c9c$var$o.useContext($97cb4d9d55c58c9c$var$p).direction === $97cb4d9d55c58c9c$export$63e1cbbb2c6e2c2.RightToLeft;
    return $97cb4d9d55c58c9c$var$o.createElement("div", {
        className: $97cb4d9d55c58c9c$var$d({
            "rpv-core__progress-bar": !0,
            "rpv-core__progress-bar--rtl": n
        })
    }, $97cb4d9d55c58c9c$var$o.createElement("div", {
        className: "rpv-core__progress-bar-progress",
        style: {
            width: "".concat(t, "%")
        }
    }, t, "%"));
}, $97cb4d9d55c58c9c$export$1ff3c3f08ae963c0 = function() {
    return $97cb4d9d55c58c9c$var$o.createElement("div", {
        className: "rpv-core__separator"
    });
}, $97cb4d9d55c58c9c$export$7f7cbe89f1eacd2 = $97cb4d9d55c58c9c$var$x, $97cb4d9d55c58c9c$export$980082fdfafd21f8 = function(e) {
    var t = e.constrain, n = $97cb4d9d55c58c9c$var$o.useContext($97cb4d9d55c58c9c$var$p).direction === $97cb4d9d55c58c9c$export$63e1cbbb2c6e2c2.RightToLeft, r = $97cb4d9d55c58c9c$var$o.useRef(), a = $97cb4d9d55c58c9c$var$o.useRef(), i = $97cb4d9d55c58c9c$var$o.useRef(), c = $97cb4d9d55c58c9c$var$o.useRef(0), s = $97cb4d9d55c58c9c$var$o.useRef(0), l = $97cb4d9d55c58c9c$var$o.useRef(0), u = $97cb4d9d55c58c9c$var$o.useRef(0), d = {
        capture: !0
    }, f = function(e) {
        var o = r.current, s = a.current, p = i.current;
        if (o && s && p) {
            var d = u.current, f = e.clientX - c.current, g = l.current + (n ? -f : f), v = o.parentElement.getBoundingClientRect().width, h = 100 * g / v;
            if (o.classList.add("rpv-core__splitter--resizing"), t) {
                var m = v - g - d;
                if (!t({
                    firstHalfPercentage: h,
                    firstHalfSize: g,
                    secondHalfPercentage: 100 * m / v,
                    secondHalfSize: m
                })) return;
            }
            s.style.width = "".concat(h, "%"), document.body.classList.add("rpv-core__splitter-body--resizing"), s.classList.add("rpv-core__splitter-sibling--resizing"), p.classList.add("rpv-core__splitter-sibling--resizing");
        }
    }, g = function(e) {
        var t = r.current, n = a.current, o = i.current;
        t && n && o && (document.body.classList.remove("rpv-core__splitter-body--resizing"), t.classList.remove("rpv-core__splitter--resizing"), n.classList.remove("rpv-core__splitter-sibling--resizing"), o.classList.remove("rpv-core__splitter-sibling--resizing"), document.removeEventListener("mousemove", f, d), document.removeEventListener("mouseup", g, d));
    };
    return $97cb4d9d55c58c9c$var$o.useEffect(function() {
        var e = r.current;
        e && (u.current = e.getBoundingClientRect().width, a.current = e.previousElementSibling, i.current = e.nextElementSibling);
    }, []), $97cb4d9d55c58c9c$var$o.createElement("div", {
        ref: r,
        className: "rpv-core__splitter",
        onMouseDown: function(e) {
            var t = a.current;
            t && (c.current = e.clientX, s.current = e.clientY, l.current = t.getBoundingClientRect().width, document.addEventListener("mousemove", f, d), document.addEventListener("mouseup", g, d));
        }
    });
}, $97cb4d9d55c58c9c$export$10e6f4f66014ee2d = $97cb4d9d55c58c9c$var$w, $97cb4d9d55c58c9c$export$2c657da244d00bd6 = $97cb4d9d55c58c9c$var$p, $97cb4d9d55c58c9c$export$28c660c63b792dea = function(e) {
    var t = e.ariaControlsSuffix, n = e.content, r = e.offset, a = e.position, i = e.target, c = $97cb4d9d55c58c9c$var$q(!1), s = c.opened, l = c.toggle, u = $97cb4d9d55c58c9c$var$o.useRef(), p = $97cb4d9d55c58c9c$var$o.useRef(), d = $97cb4d9d55c58c9c$var$o.useMemo(function() {
        return t || "".concat($97cb4d9d55c58c9c$var$N());
    }, []);
    $97cb4d9d55c58c9c$var$z(function() {
        u.current && document.activeElement && u.current.contains(document.activeElement) && g();
    });
    var f = function() {
        l($97cb4d9d55c58c9c$export$8f9a8eb37555b53e.Open);
    }, g = function() {
        l($97cb4d9d55c58c9c$export$8f9a8eb37555b53e.Close);
    };
    return $97cb4d9d55c58c9c$var$o.createElement($97cb4d9d55c58c9c$var$o.Fragment, null, $97cb4d9d55c58c9c$var$o.createElement("div", {
        ref: u,
        "aria-describedby": "rpv-core__tooltip-body-".concat(d),
        onBlur: function(e) {
            e.relatedTarget instanceof HTMLElement && e.currentTarget.parentElement && e.currentTarget.parentElement.contains(e.relatedTarget) ? p.current && (p.current.style.display = "none") : g();
        },
        onFocus: f,
        onMouseEnter: f,
        onMouseLeave: g
    }, i), s && $97cb4d9d55c58c9c$var$o.createElement($97cb4d9d55c58c9c$var$oe, {
        ariaControlsSuffix: d,
        contentRef: p,
        offset: r,
        position: a,
        targetRef: u
    }, n()));
}, $97cb4d9d55c58c9c$export$2ec4afd9b3c16a85 = function(e) {
    var t = e.characterMap, n = e.defaultScale, r = e.enableSmoothScroll, a = void 0 === r || r, i = e.fileUrl, c = e.httpHeaders, s = void 0 === c ? {} : c, l = e.initialPage, u = void 0 === l ? 0 : l, d = e.pageLayout, f = e.initialRotation, v = void 0 === f ? 0 : f, h = e.localization, m = e.plugins, x = void 0 === m ? [] : m, w = e.renderError, E = e.renderLoader, b = e.renderPage, y = e.renderProtectedView, S = e.scrollMode, _ = void 0 === S ? $97cb4d9d55c58c9c$export$c8345932c0874cf8.Vertical : S, P = e.setRenderRange, R = void 0 === P ? $97cb4d9d55c58c9c$var$Bt : P, M = e.transformGetDocumentParams, k = e.theme, C = void 0 === k ? {
        direction: $97cb4d9d55c58c9c$export$63e1cbbb2c6e2c2.LeftToRight,
        theme: "light"
    } : k, T = e.viewMode, O = void 0 === T ? $97cb4d9d55c58c9c$export$53ec42062883b2d4.SinglePage : T, F = e.withCredentials, D = void 0 !== F && F, H = e.onDocumentAskPassword, N = e.onDocumentLoad, V = void 0 === N ? function() {} : N, z = e.onPageChange, B = void 0 === z ? function() {} : z, W = e.onRotate, j = void 0 === W ? function() {} : W, q = e.onRotatePage, U = void 0 === q ? function() {} : q, Z = e.onSwitchTheme, J = void 0 === Z ? function() {} : Z, G = e.onZoom, Y = void 0 === G ? function() {} : G, K = $97cb4d9d55c58c9c$var$o.useState({
        data: i,
        name: "string" == typeof i ? i : "",
        shouldLoad: !1
    }), X = K[0], Q = K[1], $ = function(e, t) {
        Q({
            data: t,
            name: e,
            shouldLoad: !0
        });
    }, ee = $97cb4d9d55c58c9c$var$o.useState(!1), te = ee[0], ne = ee[1], re = $97cb4d9d55c58c9c$var$L(X);
    $97cb4d9d55c58c9c$var$o.useEffect(function() {
        var e, t, n, r;
        e = re.data, r = typeof (t = i), "string" === (n = typeof e) && "string" === r && e === t || "object" === n && "object" === r && e.length === t.length && e.every(function(e, n) {
            return e === t[n];
        }) || Q({
            data: i,
            name: "string" == typeof i ? i : "",
            shouldLoad: te
        });
    }, [
        i,
        te
    ]);
    var oe = $97cb4d9d55c58c9c$var$g({
        onVisibilityChanged: function(e) {
            ne(e.isVisible), e.isVisible && Q(function(e) {
                return Object.assign({}, e, {
                    shouldLoad: !0
                });
            });
        }
    }), ae = "string" == typeof C ? {
        direction: $97cb4d9d55c58c9c$export$63e1cbbb2c6e2c2.LeftToRight,
        theme: C
    } : C, ie = $97cb4d9d55c58c9c$var$o.useState(h || $97cb4d9d55c58c9c$var$I), ce = ie[0], se = ie[1], le = {
        l10n: ce,
        setL10n: se
    }, ue = Object.assign({}, {
        direction: ae.direction
    }, $97cb4d9d55c58c9c$var$zt(ae.theme || "light", J));
    return $97cb4d9d55c58c9c$var$o.useEffect(function() {
        h && se(h);
    }, [
        h
    ]), $97cb4d9d55c58c9c$var$o.createElement($97cb4d9d55c58c9c$var$A.Provider, {
        value: le
    }, $97cb4d9d55c58c9c$var$o.createElement($97cb4d9d55c58c9c$var$p.Provider, {
        value: ue
    }, $97cb4d9d55c58c9c$var$o.createElement("div", {
        ref: oe,
        className: "rpv-core__viewer rpv-core__viewer--".concat(ue.currentTheme),
        "data-testid": "core__viewer",
        style: {
            height: "100%",
            width: "100%"
        }
    }, X.shouldLoad && $97cb4d9d55c58c9c$var$o.createElement($97cb4d9d55c58c9c$var$Vt, {
        characterMap: t,
        file: X.data,
        httpHeaders: s,
        render: function(e) {
            return $97cb4d9d55c58c9c$var$o.createElement($97cb4d9d55c58c9c$var$Ot, {
                defaultScale: n,
                doc: e,
                render: function(t, r) {
                    return $97cb4d9d55c58c9c$var$o.createElement($97cb4d9d55c58c9c$var$Tt, {
                        currentFile: {
                            data: X.data,
                            name: X.name
                        },
                        defaultScale: n,
                        doc: e,
                        enableSmoothScroll: a,
                        initialPage: u,
                        initialRotation: v,
                        initialScale: r,
                        pageLayout: d,
                        pageSizes: t,
                        plugins: x,
                        renderPage: b,
                        scrollMode: _,
                        setRenderRange: R,
                        viewMode: O,
                        viewerState: {
                            file: X,
                            fullScreenMode: $97cb4d9d55c58c9c$export$8245e75d48f7b7d8.Normal,
                            pageIndex: -1,
                            pageHeight: t[0].pageHeight,
                            pageWidth: t[0].pageWidth,
                            pagesRotation: new Map,
                            rotation: v,
                            scale: r,
                            scrollMode: _,
                            viewMode: O
                        },
                        onDocumentLoad: V,
                        onOpenFile: $,
                        onPageChange: B,
                        onRotate: j,
                        onRotatePage: U,
                        onZoom: Y
                    });
                },
                scrollMode: _,
                viewMode: O
            });
        },
        renderError: w,
        renderLoader: E,
        renderProtectedView: y,
        transformGetDocumentParams: M,
        withCredentials: D,
        onDocumentAskPassword: H
    }))));
}, $97cb4d9d55c58c9c$export$5ff70a18b7b7760a = function(e) {
    var t = e.children, n = e.workerUrl;
    return $97cb4d9d55c58c9c$var$a.GlobalWorkerOptions.workerSrc = n, $97cb4d9d55c58c9c$var$o.createElement($97cb4d9d55c58c9c$var$o.Fragment, null, t);
}, $97cb4d9d55c58c9c$export$5f7ec48d69707ddd = $97cb4d9d55c58c9c$var$ie, $97cb4d9d55c58c9c$export$ce4ab0c55987d1ff = $97cb4d9d55c58c9c$var$d, $97cb4d9d55c58c9c$export$f51a9068ac82ea43 = function(e) {
    var t = e || {}, n = {}, r = function(e, r) {
        var o;
        t = $97cb4d9d55c58c9c$var$l($97cb4d9d55c58c9c$var$l({}, t), ((o = {})[e] = r, o)), (n[e] || []).forEach(function(n) {
            return n(t[e]);
        });
    }, o = function(e) {
        return t[e];
    };
    return {
        subscribe: function(e, t) {
            n[e] = (n[e] || []).concat(t);
        },
        unsubscribe: function(e, t) {
            n[e] = (n[e] || []).filter(function(e) {
                return e !== t;
            });
        },
        update: function(e, t) {
            r(e, t);
        },
        updateCurrentValue: function(e, t) {
            var n = o(e);
            void 0 !== n && r(e, t(n));
        },
        get: function(e) {
            return o(e);
        }
    };
}, $97cb4d9d55c58c9c$export$be071a6ef30bc5f7 = $97cb4d9d55c58c9c$var$fe, $97cb4d9d55c58c9c$export$c2a6433281518c91 = $97cb4d9d55c58c9c$var$de, $97cb4d9d55c58c9c$export$33f0dd73c33219f6 = $97cb4d9d55c58c9c$var$R, $97cb4d9d55c58c9c$export$9ac100e40613ea10 = function() {
    return "undefined" != typeof window && /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform);
}, $97cb4d9d55c58c9c$export$40ae01be0011c1e6 = $97cb4d9d55c58c9c$var$C, $97cb4d9d55c58c9c$export$a7395f9832c00176 = $97cb4d9d55c58c9c$var$g, $97cb4d9d55c58c9c$export$80c2a3957bcb42ea = $97cb4d9d55c58c9c$var$T, $97cb4d9d55c58c9c$export$700979bc83e7db82 = $97cb4d9d55c58c9c$var$f, $97cb4d9d55c58c9c$export$5cae361ad82dce8b = $97cb4d9d55c58c9c$var$L, $97cb4d9d55c58c9c$export$435179e768913a4f = $97cb4d9d55c58c9c$var$D;

});
parcelRegister("633OE", function(module, exports) {

var $ec262 = parcelRequire("ec262");

var $4qF7V = parcelRequire("4qF7V");
var $4675fba6b4f309a4$require$Buffer = $4qF7V.Buffer;










/**
 * @licstart The following is the entire license notice for the
 * JavaScript code in this page
 *
 * Copyright 2023 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * @licend The above is the entire license notice for the
 * JavaScript code in this page
 */ (function webpackUniversalModuleDefinition(root, factory) {
    module.exports = root.pdfjsLib = factory();
})(globalThis, ()=>{
    return /******/ (()=>{
        /******/ "use strict";
        /******/ var __webpack_modules__ = [
            ,
            /* 1 */ /***/ (__unused_webpack_module, exports)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.VerbosityLevel = exports.Util = exports.UnknownErrorException = exports.UnexpectedResponseException = exports.TextRenderingMode = exports.RenderingIntentFlag = exports.PromiseCapability = exports.PermissionFlag = exports.PasswordResponses = exports.PasswordException = exports.PageActionEventType = exports.OPS = exports.MissingPDFException = exports.MAX_IMAGE_SIZE_TO_CACHE = exports.LINE_FACTOR = exports.LINE_DESCENT_FACTOR = exports.InvalidPDFException = exports.ImageKind = exports.IDENTITY_MATRIX = exports.FormatError = exports.FeatureTest = exports.FONT_IDENTITY_MATRIX = exports.DocumentActionEventType = exports.CMapCompressionType = exports.BaseException = exports.BASELINE_FACTOR = exports.AnnotationType = exports.AnnotationReplyType = exports.AnnotationPrefix = exports.AnnotationMode = exports.AnnotationFlag = exports.AnnotationFieldFlag = exports.AnnotationEditorType = exports.AnnotationEditorPrefix = exports.AnnotationEditorParamsType = exports.AnnotationBorderStyleType = exports.AnnotationActionEventType = exports.AbortException = void 0;
                exports.assert = assert;
                exports.bytesToString = bytesToString;
                exports.createValidAbsoluteUrl = createValidAbsoluteUrl;
                exports.getModificationDate = getModificationDate;
                exports.getUuid = getUuid;
                exports.getVerbosityLevel = getVerbosityLevel;
                exports.info = info;
                exports.isArrayBuffer = isArrayBuffer;
                exports.isArrayEqual = isArrayEqual;
                exports.isNodeJS = void 0;
                exports.normalizeUnicode = normalizeUnicode;
                exports.objectFromMap = objectFromMap;
                exports.objectSize = objectSize;
                exports.setVerbosityLevel = setVerbosityLevel;
                exports.shadow = shadow;
                exports.string32 = string32;
                exports.stringToBytes = stringToBytes;
                exports.stringToPDFString = stringToPDFString;
                exports.stringToUTF8String = stringToUTF8String;
                exports.unreachable = unreachable;
                exports.utf8StringToString = utf8StringToString;
                exports.warn = warn;
                const isNodeJS = typeof $ec262 === "object" && $ec262 + "" === "[object process]" && !$ec262.versions.nw && !($ec262.versions.electron && $ec262.type && $ec262.type !== "browser");
                exports.isNodeJS = isNodeJS;
                const IDENTITY_MATRIX = [
                    1,
                    0,
                    0,
                    1,
                    0,
                    0
                ];
                exports.IDENTITY_MATRIX = IDENTITY_MATRIX;
                const FONT_IDENTITY_MATRIX = [
                    0.001,
                    0,
                    0,
                    0.001,
                    0,
                    0
                ];
                exports.FONT_IDENTITY_MATRIX = FONT_IDENTITY_MATRIX;
                const MAX_IMAGE_SIZE_TO_CACHE = 10e6;
                exports.MAX_IMAGE_SIZE_TO_CACHE = MAX_IMAGE_SIZE_TO_CACHE;
                const LINE_FACTOR = 1.35;
                exports.LINE_FACTOR = LINE_FACTOR;
                const LINE_DESCENT_FACTOR = 0.35;
                exports.LINE_DESCENT_FACTOR = LINE_DESCENT_FACTOR;
                const BASELINE_FACTOR = LINE_DESCENT_FACTOR / LINE_FACTOR;
                exports.BASELINE_FACTOR = BASELINE_FACTOR;
                const RenderingIntentFlag = {
                    ANY: 0x01,
                    DISPLAY: 0x02,
                    PRINT: 0x04,
                    SAVE: 0x08,
                    ANNOTATIONS_FORMS: 0x10,
                    ANNOTATIONS_STORAGE: 0x20,
                    ANNOTATIONS_DISABLE: 0x40,
                    OPLIST: 0x100
                };
                exports.RenderingIntentFlag = RenderingIntentFlag;
                const AnnotationMode = {
                    DISABLE: 0,
                    ENABLE: 1,
                    ENABLE_FORMS: 2,
                    ENABLE_STORAGE: 3
                };
                exports.AnnotationMode = AnnotationMode;
                const AnnotationEditorPrefix = "pdfjs_internal_editor_";
                exports.AnnotationEditorPrefix = AnnotationEditorPrefix;
                const AnnotationEditorType = {
                    DISABLE: -1,
                    NONE: 0,
                    FREETEXT: 3,
                    STAMP: 13,
                    INK: 15
                };
                exports.AnnotationEditorType = AnnotationEditorType;
                const AnnotationEditorParamsType = {
                    RESIZE: 1,
                    CREATE: 2,
                    FREETEXT_SIZE: 11,
                    FREETEXT_COLOR: 12,
                    FREETEXT_OPACITY: 13,
                    INK_COLOR: 21,
                    INK_THICKNESS: 22,
                    INK_OPACITY: 23
                };
                exports.AnnotationEditorParamsType = AnnotationEditorParamsType;
                const PermissionFlag = {
                    PRINT: 0x04,
                    MODIFY_CONTENTS: 0x08,
                    COPY: 0x10,
                    MODIFY_ANNOTATIONS: 0x20,
                    FILL_INTERACTIVE_FORMS: 0x100,
                    COPY_FOR_ACCESSIBILITY: 0x200,
                    ASSEMBLE: 0x400,
                    PRINT_HIGH_QUALITY: 0x800
                };
                exports.PermissionFlag = PermissionFlag;
                const TextRenderingMode = {
                    FILL: 0,
                    STROKE: 1,
                    FILL_STROKE: 2,
                    INVISIBLE: 3,
                    FILL_ADD_TO_PATH: 4,
                    STROKE_ADD_TO_PATH: 5,
                    FILL_STROKE_ADD_TO_PATH: 6,
                    ADD_TO_PATH: 7,
                    FILL_STROKE_MASK: 3,
                    ADD_TO_PATH_FLAG: 4
                };
                exports.TextRenderingMode = TextRenderingMode;
                const ImageKind = {
                    GRAYSCALE_1BPP: 1,
                    RGB_24BPP: 2,
                    RGBA_32BPP: 3
                };
                exports.ImageKind = ImageKind;
                const AnnotationType = {
                    TEXT: 1,
                    LINK: 2,
                    FREETEXT: 3,
                    LINE: 4,
                    SQUARE: 5,
                    CIRCLE: 6,
                    POLYGON: 7,
                    POLYLINE: 8,
                    HIGHLIGHT: 9,
                    UNDERLINE: 10,
                    SQUIGGLY: 11,
                    STRIKEOUT: 12,
                    STAMP: 13,
                    CARET: 14,
                    INK: 15,
                    POPUP: 16,
                    FILEATTACHMENT: 17,
                    SOUND: 18,
                    MOVIE: 19,
                    WIDGET: 20,
                    SCREEN: 21,
                    PRINTERMARK: 22,
                    TRAPNET: 23,
                    WATERMARK: 24,
                    THREED: 25,
                    REDACT: 26
                };
                exports.AnnotationType = AnnotationType;
                const AnnotationReplyType = {
                    GROUP: "Group",
                    REPLY: "R"
                };
                exports.AnnotationReplyType = AnnotationReplyType;
                const AnnotationFlag = {
                    INVISIBLE: 0x01,
                    HIDDEN: 0x02,
                    PRINT: 0x04,
                    NOZOOM: 0x08,
                    NOROTATE: 0x10,
                    NOVIEW: 0x20,
                    READONLY: 0x40,
                    LOCKED: 0x80,
                    TOGGLENOVIEW: 0x100,
                    LOCKEDCONTENTS: 0x200
                };
                exports.AnnotationFlag = AnnotationFlag;
                const AnnotationFieldFlag = {
                    READONLY: 0x0000001,
                    REQUIRED: 0x0000002,
                    NOEXPORT: 0x0000004,
                    MULTILINE: 0x0001000,
                    PASSWORD: 0x0002000,
                    NOTOGGLETOOFF: 0x0004000,
                    RADIO: 0x0008000,
                    PUSHBUTTON: 0x0010000,
                    COMBO: 0x0020000,
                    EDIT: 0x0040000,
                    SORT: 0x0080000,
                    FILESELECT: 0x0100000,
                    MULTISELECT: 0x0200000,
                    DONOTSPELLCHECK: 0x0400000,
                    DONOTSCROLL: 0x0800000,
                    COMB: 0x1000000,
                    RICHTEXT: 0x2000000,
                    RADIOSINUNISON: 0x2000000,
                    COMMITONSELCHANGE: 0x4000000
                };
                exports.AnnotationFieldFlag = AnnotationFieldFlag;
                const AnnotationBorderStyleType = {
                    SOLID: 1,
                    DASHED: 2,
                    BEVELED: 3,
                    INSET: 4,
                    UNDERLINE: 5
                };
                exports.AnnotationBorderStyleType = AnnotationBorderStyleType;
                const AnnotationActionEventType = {
                    E: "Mouse Enter",
                    X: "Mouse Exit",
                    D: "Mouse Down",
                    U: "Mouse Up",
                    Fo: "Focus",
                    Bl: "Blur",
                    PO: "PageOpen",
                    PC: "PageClose",
                    PV: "PageVisible",
                    PI: "PageInvisible",
                    K: "Keystroke",
                    F: "Format",
                    V: "Validate",
                    C: "Calculate"
                };
                exports.AnnotationActionEventType = AnnotationActionEventType;
                const DocumentActionEventType = {
                    WC: "WillClose",
                    WS: "WillSave",
                    DS: "DidSave",
                    WP: "WillPrint",
                    DP: "DidPrint"
                };
                exports.DocumentActionEventType = DocumentActionEventType;
                const PageActionEventType = {
                    O: "PageOpen",
                    C: "PageClose"
                };
                exports.PageActionEventType = PageActionEventType;
                const VerbosityLevel = {
                    ERRORS: 0,
                    WARNINGS: 1,
                    INFOS: 5
                };
                exports.VerbosityLevel = VerbosityLevel;
                const CMapCompressionType = {
                    NONE: 0,
                    BINARY: 1
                };
                exports.CMapCompressionType = CMapCompressionType;
                const OPS = {
                    dependency: 1,
                    setLineWidth: 2,
                    setLineCap: 3,
                    setLineJoin: 4,
                    setMiterLimit: 5,
                    setDash: 6,
                    setRenderingIntent: 7,
                    setFlatness: 8,
                    setGState: 9,
                    save: 10,
                    restore: 11,
                    transform: 12,
                    moveTo: 13,
                    lineTo: 14,
                    curveTo: 15,
                    curveTo2: 16,
                    curveTo3: 17,
                    closePath: 18,
                    rectangle: 19,
                    stroke: 20,
                    closeStroke: 21,
                    fill: 22,
                    eoFill: 23,
                    fillStroke: 24,
                    eoFillStroke: 25,
                    closeFillStroke: 26,
                    closeEOFillStroke: 27,
                    endPath: 28,
                    clip: 29,
                    eoClip: 30,
                    beginText: 31,
                    endText: 32,
                    setCharSpacing: 33,
                    setWordSpacing: 34,
                    setHScale: 35,
                    setLeading: 36,
                    setFont: 37,
                    setTextRenderingMode: 38,
                    setTextRise: 39,
                    moveText: 40,
                    setLeadingMoveText: 41,
                    setTextMatrix: 42,
                    nextLine: 43,
                    showText: 44,
                    showSpacedText: 45,
                    nextLineShowText: 46,
                    nextLineSetSpacingShowText: 47,
                    setCharWidth: 48,
                    setCharWidthAndBounds: 49,
                    setStrokeColorSpace: 50,
                    setFillColorSpace: 51,
                    setStrokeColor: 52,
                    setStrokeColorN: 53,
                    setFillColor: 54,
                    setFillColorN: 55,
                    setStrokeGray: 56,
                    setFillGray: 57,
                    setStrokeRGBColor: 58,
                    setFillRGBColor: 59,
                    setStrokeCMYKColor: 60,
                    setFillCMYKColor: 61,
                    shadingFill: 62,
                    beginInlineImage: 63,
                    beginImageData: 64,
                    endInlineImage: 65,
                    paintXObject: 66,
                    markPoint: 67,
                    markPointProps: 68,
                    beginMarkedContent: 69,
                    beginMarkedContentProps: 70,
                    endMarkedContent: 71,
                    beginCompat: 72,
                    endCompat: 73,
                    paintFormXObjectBegin: 74,
                    paintFormXObjectEnd: 75,
                    beginGroup: 76,
                    endGroup: 77,
                    beginAnnotation: 80,
                    endAnnotation: 81,
                    paintImageMaskXObject: 83,
                    paintImageMaskXObjectGroup: 84,
                    paintImageXObject: 85,
                    paintInlineImageXObject: 86,
                    paintInlineImageXObjectGroup: 87,
                    paintImageXObjectRepeat: 88,
                    paintImageMaskXObjectRepeat: 89,
                    paintSolidColorImageMask: 90,
                    constructPath: 91
                };
                exports.OPS = OPS;
                const PasswordResponses = {
                    NEED_PASSWORD: 1,
                    INCORRECT_PASSWORD: 2
                };
                exports.PasswordResponses = PasswordResponses;
                let verbosity = VerbosityLevel.WARNINGS;
                function setVerbosityLevel(level) {
                    if (Number.isInteger(level)) verbosity = level;
                }
                function getVerbosityLevel() {
                    return verbosity;
                }
                function info(msg) {
                    if (verbosity >= VerbosityLevel.INFOS) console.log(`Info: ${msg}`);
                }
                function warn(msg) {
                    if (verbosity >= VerbosityLevel.WARNINGS) console.log(`Warning: ${msg}`);
                }
                function unreachable(msg) {
                    throw new Error(msg);
                }
                function assert(cond, msg) {
                    if (!cond) unreachable(msg);
                }
                function _isValidProtocol(url) {
                    switch(url?.protocol){
                        case "http:":
                        case "https:":
                        case "ftp:":
                        case "mailto:":
                        case "tel:":
                            return true;
                        default:
                            return false;
                    }
                }
                function createValidAbsoluteUrl(url, baseUrl = null, options = null) {
                    if (!url) return null;
                    try {
                        if (options && typeof url === "string") {
                            if (options.addDefaultProtocol && url.startsWith("www.")) {
                                const dots = url.match(/\./g);
                                if (dots?.length >= 2) url = `http://${url}`;
                            }
                            if (options.tryConvertEncoding) try {
                                url = stringToUTF8String(url);
                            } catch  {}
                        }
                        const absoluteUrl = baseUrl ? new URL(url, baseUrl) : new URL(url);
                        if (_isValidProtocol(absoluteUrl)) return absoluteUrl;
                    } catch  {}
                    return null;
                }
                function shadow(obj, prop, value, nonSerializable = false) {
                    Object.defineProperty(obj, prop, {
                        value: value,
                        enumerable: !nonSerializable,
                        configurable: true,
                        writable: false
                    });
                    return value;
                }
                const BaseException = function BaseExceptionClosure() {
                    function BaseException(message, name) {
                        if (this.constructor === BaseException) unreachable("Cannot initialize BaseException.");
                        this.message = message;
                        this.name = name;
                    }
                    BaseException.prototype = new Error();
                    BaseException.constructor = BaseException;
                    return BaseException;
                }();
                exports.BaseException = BaseException;
                class PasswordException extends BaseException {
                    constructor(msg, code){
                        super(msg, "PasswordException");
                        this.code = code;
                    }
                }
                exports.PasswordException = PasswordException;
                class UnknownErrorException extends BaseException {
                    constructor(msg, details){
                        super(msg, "UnknownErrorException");
                        this.details = details;
                    }
                }
                exports.UnknownErrorException = UnknownErrorException;
                class InvalidPDFException extends BaseException {
                    constructor(msg){
                        super(msg, "InvalidPDFException");
                    }
                }
                exports.InvalidPDFException = InvalidPDFException;
                class MissingPDFException extends BaseException {
                    constructor(msg){
                        super(msg, "MissingPDFException");
                    }
                }
                exports.MissingPDFException = MissingPDFException;
                class UnexpectedResponseException extends BaseException {
                    constructor(msg, status){
                        super(msg, "UnexpectedResponseException");
                        this.status = status;
                    }
                }
                exports.UnexpectedResponseException = UnexpectedResponseException;
                class FormatError extends BaseException {
                    constructor(msg){
                        super(msg, "FormatError");
                    }
                }
                exports.FormatError = FormatError;
                class AbortException extends BaseException {
                    constructor(msg){
                        super(msg, "AbortException");
                    }
                }
                exports.AbortException = AbortException;
                function bytesToString(bytes) {
                    if (typeof bytes !== "object" || bytes?.length === undefined) unreachable("Invalid argument for bytesToString");
                    const length = bytes.length;
                    const MAX_ARGUMENT_COUNT = 8192;
                    if (length < MAX_ARGUMENT_COUNT) return String.fromCharCode.apply(null, bytes);
                    const strBuf = [];
                    for(let i = 0; i < length; i += MAX_ARGUMENT_COUNT){
                        const chunkEnd = Math.min(i + MAX_ARGUMENT_COUNT, length);
                        const chunk = bytes.subarray(i, chunkEnd);
                        strBuf.push(String.fromCharCode.apply(null, chunk));
                    }
                    return strBuf.join("");
                }
                function stringToBytes(str) {
                    if (typeof str !== "string") unreachable("Invalid argument for stringToBytes");
                    const length = str.length;
                    const bytes = new Uint8Array(length);
                    for(let i = 0; i < length; ++i)bytes[i] = str.charCodeAt(i) & 0xff;
                    return bytes;
                }
                function string32(value) {
                    return String.fromCharCode(value >> 24 & 0xff, value >> 16 & 0xff, value >> 8 & 0xff, value & 0xff);
                }
                function objectSize(obj) {
                    return Object.keys(obj).length;
                }
                function objectFromMap(map) {
                    const obj = Object.create(null);
                    for (const [key, value] of map)obj[key] = value;
                    return obj;
                }
                function isLittleEndian() {
                    const buffer8 = new Uint8Array(4);
                    buffer8[0] = 1;
                    const view32 = new Uint32Array(buffer8.buffer, 0, 1);
                    return view32[0] === 1;
                }
                function isEvalSupported() {
                    try {
                        new Function("");
                        return true;
                    } catch  {
                        return false;
                    }
                }
                class FeatureTest {
                    static get isLittleEndian() {
                        return shadow(this, "isLittleEndian", isLittleEndian());
                    }
                    static get isEvalSupported() {
                        return shadow(this, "isEvalSupported", isEvalSupported());
                    }
                    static get isOffscreenCanvasSupported() {
                        return shadow(this, "isOffscreenCanvasSupported", typeof OffscreenCanvas !== "undefined");
                    }
                    static get platform() {
                        if (typeof navigator === "undefined") return shadow(this, "platform", {
                            isWin: false,
                            isMac: false
                        });
                        return shadow(this, "platform", {
                            isWin: navigator.platform.includes("Win"),
                            isMac: navigator.platform.includes("Mac")
                        });
                    }
                    static get isCSSRoundSupported() {
                        return shadow(this, "isCSSRoundSupported", globalThis.CSS?.supports?.("width: round(1.5px, 1px)"));
                    }
                }
                exports.FeatureTest = FeatureTest;
                const hexNumbers = [
                    ...Array(256).keys()
                ].map((n)=>n.toString(16).padStart(2, "0"));
                class Util {
                    static makeHexColor(r, g, b) {
                        return `#${hexNumbers[r]}${hexNumbers[g]}${hexNumbers[b]}`;
                    }
                    static scaleMinMax(transform, minMax) {
                        let temp;
                        if (transform[0]) {
                            if (transform[0] < 0) {
                                temp = minMax[0];
                                minMax[0] = minMax[1];
                                minMax[1] = temp;
                            }
                            minMax[0] *= transform[0];
                            minMax[1] *= transform[0];
                            if (transform[3] < 0) {
                                temp = minMax[2];
                                minMax[2] = minMax[3];
                                minMax[3] = temp;
                            }
                            minMax[2] *= transform[3];
                            minMax[3] *= transform[3];
                        } else {
                            temp = minMax[0];
                            minMax[0] = minMax[2];
                            minMax[2] = temp;
                            temp = minMax[1];
                            minMax[1] = minMax[3];
                            minMax[3] = temp;
                            if (transform[1] < 0) {
                                temp = minMax[2];
                                minMax[2] = minMax[3];
                                minMax[3] = temp;
                            }
                            minMax[2] *= transform[1];
                            minMax[3] *= transform[1];
                            if (transform[2] < 0) {
                                temp = minMax[0];
                                minMax[0] = minMax[1];
                                minMax[1] = temp;
                            }
                            minMax[0] *= transform[2];
                            minMax[1] *= transform[2];
                        }
                        minMax[0] += transform[4];
                        minMax[1] += transform[4];
                        minMax[2] += transform[5];
                        minMax[3] += transform[5];
                    }
                    static transform(m1, m2) {
                        return [
                            m1[0] * m2[0] + m1[2] * m2[1],
                            m1[1] * m2[0] + m1[3] * m2[1],
                            m1[0] * m2[2] + m1[2] * m2[3],
                            m1[1] * m2[2] + m1[3] * m2[3],
                            m1[0] * m2[4] + m1[2] * m2[5] + m1[4],
                            m1[1] * m2[4] + m1[3] * m2[5] + m1[5]
                        ];
                    }
                    static applyTransform(p, m) {
                        const xt = p[0] * m[0] + p[1] * m[2] + m[4];
                        const yt = p[0] * m[1] + p[1] * m[3] + m[5];
                        return [
                            xt,
                            yt
                        ];
                    }
                    static applyInverseTransform(p, m) {
                        const d = m[0] * m[3] - m[1] * m[2];
                        const xt = (p[0] * m[3] - p[1] * m[2] + m[2] * m[5] - m[4] * m[3]) / d;
                        const yt = (-p[0] * m[1] + p[1] * m[0] + m[4] * m[1] - m[5] * m[0]) / d;
                        return [
                            xt,
                            yt
                        ];
                    }
                    static getAxialAlignedBoundingBox(r, m) {
                        const p1 = this.applyTransform(r, m);
                        const p2 = this.applyTransform(r.slice(2, 4), m);
                        const p3 = this.applyTransform([
                            r[0],
                            r[3]
                        ], m);
                        const p4 = this.applyTransform([
                            r[2],
                            r[1]
                        ], m);
                        return [
                            Math.min(p1[0], p2[0], p3[0], p4[0]),
                            Math.min(p1[1], p2[1], p3[1], p4[1]),
                            Math.max(p1[0], p2[0], p3[0], p4[0]),
                            Math.max(p1[1], p2[1], p3[1], p4[1])
                        ];
                    }
                    static inverseTransform(m) {
                        const d = m[0] * m[3] - m[1] * m[2];
                        return [
                            m[3] / d,
                            -m[1] / d,
                            -m[2] / d,
                            m[0] / d,
                            (m[2] * m[5] - m[4] * m[3]) / d,
                            (m[4] * m[1] - m[5] * m[0]) / d
                        ];
                    }
                    static singularValueDecompose2dScale(m) {
                        const transpose = [
                            m[0],
                            m[2],
                            m[1],
                            m[3]
                        ];
                        const a = m[0] * transpose[0] + m[1] * transpose[2];
                        const b = m[0] * transpose[1] + m[1] * transpose[3];
                        const c = m[2] * transpose[0] + m[3] * transpose[2];
                        const d = m[2] * transpose[1] + m[3] * transpose[3];
                        const first = (a + d) / 2;
                        const second = Math.sqrt((a + d) ** 2 - 4 * (a * d - c * b)) / 2;
                        const sx = first + second || 1;
                        const sy = first - second || 1;
                        return [
                            Math.sqrt(sx),
                            Math.sqrt(sy)
                        ];
                    }
                    static normalizeRect(rect) {
                        const r = rect.slice(0);
                        if (rect[0] > rect[2]) {
                            r[0] = rect[2];
                            r[2] = rect[0];
                        }
                        if (rect[1] > rect[3]) {
                            r[1] = rect[3];
                            r[3] = rect[1];
                        }
                        return r;
                    }
                    static intersect(rect1, rect2) {
                        const xLow = Math.max(Math.min(rect1[0], rect1[2]), Math.min(rect2[0], rect2[2]));
                        const xHigh = Math.min(Math.max(rect1[0], rect1[2]), Math.max(rect2[0], rect2[2]));
                        if (xLow > xHigh) return null;
                        const yLow = Math.max(Math.min(rect1[1], rect1[3]), Math.min(rect2[1], rect2[3]));
                        const yHigh = Math.min(Math.max(rect1[1], rect1[3]), Math.max(rect2[1], rect2[3]));
                        if (yLow > yHigh) return null;
                        return [
                            xLow,
                            yLow,
                            xHigh,
                            yHigh
                        ];
                    }
                    static bezierBoundingBox(x0, y0, x1, y1, x2, y2, x3, y3) {
                        const tvalues = [], bounds = [
                            [],
                            []
                        ];
                        let a, b, c, t, t1, t2, b2ac, sqrtb2ac;
                        for(let i = 0; i < 2; ++i){
                            if (i === 0) {
                                b = 6 * x0 - 12 * x1 + 6 * x2;
                                a = -3 * x0 + 9 * x1 - 9 * x2 + 3 * x3;
                                c = 3 * x1 - 3 * x0;
                            } else {
                                b = 6 * y0 - 12 * y1 + 6 * y2;
                                a = -3 * y0 + 9 * y1 - 9 * y2 + 3 * y3;
                                c = 3 * y1 - 3 * y0;
                            }
                            if (Math.abs(a) < 1e-12) {
                                if (Math.abs(b) < 1e-12) continue;
                                t = -c / b;
                                if (0 < t && t < 1) tvalues.push(t);
                                continue;
                            }
                            b2ac = b * b - 4 * c * a;
                            sqrtb2ac = Math.sqrt(b2ac);
                            if (b2ac < 0) continue;
                            t1 = (-b + sqrtb2ac) / (2 * a);
                            if (0 < t1 && t1 < 1) tvalues.push(t1);
                            t2 = (-b - sqrtb2ac) / (2 * a);
                            if (0 < t2 && t2 < 1) tvalues.push(t2);
                        }
                        let j = tvalues.length, mt;
                        const jlen = j;
                        while(j--){
                            t = tvalues[j];
                            mt = 1 - t;
                            bounds[0][j] = mt * mt * mt * x0 + 3 * mt * mt * t * x1 + 3 * mt * t * t * x2 + t * t * t * x3;
                            bounds[1][j] = mt * mt * mt * y0 + 3 * mt * mt * t * y1 + 3 * mt * t * t * y2 + t * t * t * y3;
                        }
                        bounds[0][jlen] = x0;
                        bounds[1][jlen] = y0;
                        bounds[0][jlen + 1] = x3;
                        bounds[1][jlen + 1] = y3;
                        bounds[0].length = bounds[1].length = jlen + 2;
                        return [
                            Math.min(...bounds[0]),
                            Math.min(...bounds[1]),
                            Math.max(...bounds[0]),
                            Math.max(...bounds[1])
                        ];
                    }
                }
                exports.Util = Util;
                const PDFStringTranslateTable = [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0x2d8,
                    0x2c7,
                    0x2c6,
                    0x2d9,
                    0x2dd,
                    0x2db,
                    0x2da,
                    0x2dc,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0x2022,
                    0x2020,
                    0x2021,
                    0x2026,
                    0x2014,
                    0x2013,
                    0x192,
                    0x2044,
                    0x2039,
                    0x203a,
                    0x2212,
                    0x2030,
                    0x201e,
                    0x201c,
                    0x201d,
                    0x2018,
                    0x2019,
                    0x201a,
                    0x2122,
                    0xfb01,
                    0xfb02,
                    0x141,
                    0x152,
                    0x160,
                    0x178,
                    0x17d,
                    0x131,
                    0x142,
                    0x153,
                    0x161,
                    0x17e,
                    0,
                    0x20ac
                ];
                function stringToPDFString(str) {
                    if (str[0] >= "\xef") {
                        let encoding;
                        if (str[0] === "\xfe" && str[1] === "\xff") encoding = "utf-16be";
                        else if (str[0] === "\xff" && str[1] === "\xfe") encoding = "utf-16le";
                        else if (str[0] === "\xef" && str[1] === "\xbb" && str[2] === "\xbf") encoding = "utf-8";
                        if (encoding) try {
                            const decoder = new TextDecoder(encoding, {
                                fatal: true
                            });
                            const buffer = stringToBytes(str);
                            return decoder.decode(buffer);
                        } catch (ex) {
                            warn(`stringToPDFString: "${ex}".`);
                        }
                    }
                    const strBuf = [];
                    for(let i = 0, ii = str.length; i < ii; i++){
                        const code = PDFStringTranslateTable[str.charCodeAt(i)];
                        strBuf.push(code ? String.fromCharCode(code) : str.charAt(i));
                    }
                    return strBuf.join("");
                }
                function stringToUTF8String(str) {
                    return decodeURIComponent(escape(str));
                }
                function utf8StringToString(str) {
                    return unescape(encodeURIComponent(str));
                }
                function isArrayBuffer(v) {
                    return typeof v === "object" && v?.byteLength !== undefined;
                }
                function isArrayEqual(arr1, arr2) {
                    if (arr1.length !== arr2.length) return false;
                    for(let i = 0, ii = arr1.length; i < ii; i++){
                        if (arr1[i] !== arr2[i]) return false;
                    }
                    return true;
                }
                function getModificationDate(date = new Date()) {
                    const buffer = [
                        date.getUTCFullYear().toString(),
                        (date.getUTCMonth() + 1).toString().padStart(2, "0"),
                        date.getUTCDate().toString().padStart(2, "0"),
                        date.getUTCHours().toString().padStart(2, "0"),
                        date.getUTCMinutes().toString().padStart(2, "0"),
                        date.getUTCSeconds().toString().padStart(2, "0")
                    ];
                    return buffer.join("");
                }
                class PromiseCapability {
                    #settled = false;
                    constructor(){
                        this.promise = new Promise((resolve, reject)=>{
                            this.resolve = (data)=>{
                                this.#settled = true;
                                resolve(data);
                            };
                            this.reject = (reason)=>{
                                this.#settled = true;
                                reject(reason);
                            };
                        });
                    }
                    get settled() {
                        return this.#settled;
                    }
                }
                exports.PromiseCapability = PromiseCapability;
                let NormalizeRegex = null;
                let NormalizationMap = null;
                function normalizeUnicode(str) {
                    if (!NormalizeRegex) {
                        NormalizeRegex = /([\u00a0\u00b5\u037e\u0eb3\u2000-\u200a\u202f\u2126\ufb00-\ufb04\ufb06\ufb20-\ufb36\ufb38-\ufb3c\ufb3e\ufb40-\ufb41\ufb43-\ufb44\ufb46-\ufba1\ufba4-\ufba9\ufbae-\ufbb1\ufbd3-\ufbdc\ufbde-\ufbe7\ufbea-\ufbf8\ufbfc-\ufbfd\ufc00-\ufc5d\ufc64-\ufcf1\ufcf5-\ufd3d\ufd88\ufdf4\ufdfa-\ufdfb\ufe71\ufe77\ufe79\ufe7b\ufe7d]+)|(\ufb05+)/gu;
                        NormalizationMap = new Map([
                            [
                                "\uFB05",
                                "\u017Ft"
                            ]
                        ]);
                    }
                    return str.replaceAll(NormalizeRegex, (_, p1, p2)=>{
                        return p1 ? p1.normalize("NFKC") : NormalizationMap.get(p2);
                    });
                }
                function getUuid() {
                    if (typeof crypto !== "undefined" && typeof crypto?.randomUUID === "function") return crypto.randomUUID();
                    const buf = new Uint8Array(32);
                    if (typeof crypto !== "undefined" && typeof crypto?.getRandomValues === "function") crypto.getRandomValues(buf);
                    else for(let i = 0; i < 32; i++)buf[i] = Math.floor(Math.random() * 255);
                    return bytesToString(buf);
                }
                const AnnotationPrefix = "pdfjs_internal_id_";
                exports.AnnotationPrefix = AnnotationPrefix;
            /***/ },
            /* 2 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.RenderTask = exports.PDFWorkerUtil = exports.PDFWorker = exports.PDFPageProxy = exports.PDFDocumentProxy = exports.PDFDocumentLoadingTask = exports.PDFDataRangeTransport = exports.LoopbackPort = exports.DefaultStandardFontDataFactory = exports.DefaultFilterFactory = exports.DefaultCanvasFactory = exports.DefaultCMapReaderFactory = void 0;
                Object.defineProperty(exports, "SVGGraphics", {
                    enumerable: true,
                    get: function() {
                        return _displaySvg.SVGGraphics;
                    }
                });
                exports.build = void 0;
                exports.getDocument = getDocument;
                exports.version = void 0;
                var _util = __w_pdfjs_require__(1);
                var _annotation_storage = __w_pdfjs_require__(3);
                var _display_utils = __w_pdfjs_require__(6);
                var _font_loader = __w_pdfjs_require__(9);
                var _displayNode_utils = __w_pdfjs_require__(10);
                var _canvas = __w_pdfjs_require__(11);
                var _worker_options = __w_pdfjs_require__(14);
                var _message_handler = __w_pdfjs_require__(15);
                var _metadata = __w_pdfjs_require__(16);
                var _optional_content_config = __w_pdfjs_require__(17);
                var _transport_stream = __w_pdfjs_require__(18);
                var _displayFetch_stream = __w_pdfjs_require__(19);
                var _displayNetwork = __w_pdfjs_require__(22);
                var _displayNode_stream = __w_pdfjs_require__(23);
                var _displaySvg = __w_pdfjs_require__(24);
                var _xfa_text = __w_pdfjs_require__(25);
                const DEFAULT_RANGE_CHUNK_SIZE = 65536;
                const RENDERING_CANCELLED_TIMEOUT = 100;
                const DELAYED_CLEANUP_TIMEOUT = 5000;
                const DefaultCanvasFactory = _util.isNodeJS ? _displayNode_utils.NodeCanvasFactory : _display_utils.DOMCanvasFactory;
                exports.DefaultCanvasFactory = DefaultCanvasFactory;
                const DefaultCMapReaderFactory = _util.isNodeJS ? _displayNode_utils.NodeCMapReaderFactory : _display_utils.DOMCMapReaderFactory;
                exports.DefaultCMapReaderFactory = DefaultCMapReaderFactory;
                const DefaultFilterFactory = _util.isNodeJS ? _displayNode_utils.NodeFilterFactory : _display_utils.DOMFilterFactory;
                exports.DefaultFilterFactory = DefaultFilterFactory;
                const DefaultStandardFontDataFactory = _util.isNodeJS ? _displayNode_utils.NodeStandardFontDataFactory : _display_utils.DOMStandardFontDataFactory;
                exports.DefaultStandardFontDataFactory = DefaultStandardFontDataFactory;
                function getDocument(src) {
                    if (typeof src === "string" || src instanceof URL) src = {
                        url: src
                    };
                    else if ((0, _util.isArrayBuffer)(src)) src = {
                        data: src
                    };
                    if (typeof src !== "object") throw new Error("Invalid parameter in getDocument, need parameter object.");
                    if (!src.url && !src.data && !src.range) throw new Error("Invalid parameter object: need either .data, .range or .url");
                    const task = new PDFDocumentLoadingTask();
                    const { docId } = task;
                    const url = src.url ? getUrlProp(src.url) : null;
                    const data = src.data ? getDataProp(src.data) : null;
                    const httpHeaders = src.httpHeaders || null;
                    const withCredentials = src.withCredentials === true;
                    const password = src.password ?? null;
                    const rangeTransport = src.range instanceof PDFDataRangeTransport ? src.range : null;
                    const rangeChunkSize = Number.isInteger(src.rangeChunkSize) && src.rangeChunkSize > 0 ? src.rangeChunkSize : DEFAULT_RANGE_CHUNK_SIZE;
                    let worker = src.worker instanceof PDFWorker ? src.worker : null;
                    const verbosity = src.verbosity;
                    const docBaseUrl = typeof src.docBaseUrl === "string" && !(0, _display_utils.isDataScheme)(src.docBaseUrl) ? src.docBaseUrl : null;
                    const cMapUrl = typeof src.cMapUrl === "string" ? src.cMapUrl : null;
                    const cMapPacked = src.cMapPacked !== false;
                    const CMapReaderFactory = src.CMapReaderFactory || DefaultCMapReaderFactory;
                    const standardFontDataUrl = typeof src.standardFontDataUrl === "string" ? src.standardFontDataUrl : null;
                    const StandardFontDataFactory = src.StandardFontDataFactory || DefaultStandardFontDataFactory;
                    const ignoreErrors = src.stopAtErrors !== true;
                    const maxImageSize = Number.isInteger(src.maxImageSize) && src.maxImageSize > -1 ? src.maxImageSize : -1;
                    const isEvalSupported = src.isEvalSupported !== false;
                    const isOffscreenCanvasSupported = typeof src.isOffscreenCanvasSupported === "boolean" ? src.isOffscreenCanvasSupported : !_util.isNodeJS;
                    const canvasMaxAreaInBytes = Number.isInteger(src.canvasMaxAreaInBytes) ? src.canvasMaxAreaInBytes : -1;
                    const disableFontFace = typeof src.disableFontFace === "boolean" ? src.disableFontFace : _util.isNodeJS;
                    const fontExtraProperties = src.fontExtraProperties === true;
                    const enableXfa = src.enableXfa === true;
                    const ownerDocument = src.ownerDocument || globalThis.document;
                    const disableRange = src.disableRange === true;
                    const disableStream = src.disableStream === true;
                    const disableAutoFetch = src.disableAutoFetch === true;
                    const pdfBug = src.pdfBug === true;
                    const length = rangeTransport ? rangeTransport.length : src.length ?? NaN;
                    const useSystemFonts = typeof src.useSystemFonts === "boolean" ? src.useSystemFonts : !_util.isNodeJS && !disableFontFace;
                    const useWorkerFetch = typeof src.useWorkerFetch === "boolean" ? src.useWorkerFetch : CMapReaderFactory === _display_utils.DOMCMapReaderFactory && StandardFontDataFactory === _display_utils.DOMStandardFontDataFactory && cMapUrl && standardFontDataUrl && (0, _display_utils.isValidFetchUrl)(cMapUrl, document.baseURI) && (0, _display_utils.isValidFetchUrl)(standardFontDataUrl, document.baseURI);
                    const canvasFactory = src.canvasFactory || new DefaultCanvasFactory({
                        ownerDocument: ownerDocument
                    });
                    const filterFactory = src.filterFactory || new DefaultFilterFactory({
                        docId: docId,
                        ownerDocument: ownerDocument
                    });
                    const styleElement = null;
                    (0, _util.setVerbosityLevel)(verbosity);
                    const transportFactory = {
                        canvasFactory: canvasFactory,
                        filterFactory: filterFactory
                    };
                    if (!useWorkerFetch) {
                        transportFactory.cMapReaderFactory = new CMapReaderFactory({
                            baseUrl: cMapUrl,
                            isCompressed: cMapPacked
                        });
                        transportFactory.standardFontDataFactory = new StandardFontDataFactory({
                            baseUrl: standardFontDataUrl
                        });
                    }
                    if (!worker) {
                        const workerParams = {
                            verbosity: verbosity,
                            port: _worker_options.GlobalWorkerOptions.workerPort
                        };
                        worker = workerParams.port ? PDFWorker.fromPort(workerParams) : new PDFWorker(workerParams);
                        task._worker = worker;
                    }
                    const fetchDocParams = {
                        docId: docId,
                        apiVersion: "3.11.174",
                        data: data,
                        password: password,
                        disableAutoFetch: disableAutoFetch,
                        rangeChunkSize: rangeChunkSize,
                        length: length,
                        docBaseUrl: docBaseUrl,
                        enableXfa: enableXfa,
                        evaluatorOptions: {
                            maxImageSize: maxImageSize,
                            disableFontFace: disableFontFace,
                            ignoreErrors: ignoreErrors,
                            isEvalSupported: isEvalSupported,
                            isOffscreenCanvasSupported: isOffscreenCanvasSupported,
                            canvasMaxAreaInBytes: canvasMaxAreaInBytes,
                            fontExtraProperties: fontExtraProperties,
                            useSystemFonts: useSystemFonts,
                            cMapUrl: useWorkerFetch ? cMapUrl : null,
                            standardFontDataUrl: useWorkerFetch ? standardFontDataUrl : null
                        }
                    };
                    const transportParams = {
                        ignoreErrors: ignoreErrors,
                        isEvalSupported: isEvalSupported,
                        disableFontFace: disableFontFace,
                        fontExtraProperties: fontExtraProperties,
                        enableXfa: enableXfa,
                        ownerDocument: ownerDocument,
                        disableAutoFetch: disableAutoFetch,
                        pdfBug: pdfBug,
                        styleElement: styleElement
                    };
                    worker.promise.then(function() {
                        if (task.destroyed) throw new Error("Loading aborted");
                        const workerIdPromise = _fetchDocument(worker, fetchDocParams);
                        const networkStreamPromise = new Promise(function(resolve) {
                            let networkStream;
                            if (rangeTransport) networkStream = new _transport_stream.PDFDataTransportStream({
                                length: length,
                                initialData: rangeTransport.initialData,
                                progressiveDone: rangeTransport.progressiveDone,
                                contentDispositionFilename: rangeTransport.contentDispositionFilename,
                                disableRange: disableRange,
                                disableStream: disableStream
                            }, rangeTransport);
                            else if (!data) {
                                const createPDFNetworkStream = (params)=>{
                                    if (_util.isNodeJS) return new _displayNode_stream.PDFNodeStream(params);
                                    return (0, _display_utils.isValidFetchUrl)(params.url) ? new _displayFetch_stream.PDFFetchStream(params) : new _displayNetwork.PDFNetworkStream(params);
                                };
                                networkStream = createPDFNetworkStream({
                                    url: url,
                                    length: length,
                                    httpHeaders: httpHeaders,
                                    withCredentials: withCredentials,
                                    rangeChunkSize: rangeChunkSize,
                                    disableRange: disableRange,
                                    disableStream: disableStream
                                });
                            }
                            resolve(networkStream);
                        });
                        return Promise.all([
                            workerIdPromise,
                            networkStreamPromise
                        ]).then(function([workerId, networkStream]) {
                            if (task.destroyed) throw new Error("Loading aborted");
                            const messageHandler = new _message_handler.MessageHandler(docId, workerId, worker.port);
                            const transport = new WorkerTransport(messageHandler, task, networkStream, transportParams, transportFactory);
                            task._transport = transport;
                            messageHandler.send("Ready", null);
                        });
                    }).catch(task._capability.reject);
                    return task;
                }
                async function _fetchDocument(worker, source) {
                    if (worker.destroyed) throw new Error("Worker was destroyed");
                    const workerId = await worker.messageHandler.sendWithPromise("GetDocRequest", source, source.data ? [
                        source.data.buffer
                    ] : null);
                    if (worker.destroyed) throw new Error("Worker was destroyed");
                    return workerId;
                }
                function getUrlProp(val) {
                    if (val instanceof URL) return val.href;
                    try {
                        return new URL(val, window.location).href;
                    } catch  {
                        if (_util.isNodeJS && typeof val === "string") return val;
                    }
                    throw new Error("Invalid PDF url data: either string or URL-object is expected in the url property.");
                }
                function getDataProp(val) {
                    if (_util.isNodeJS && typeof $4675fba6b4f309a4$require$Buffer !== "undefined" && val instanceof $4675fba6b4f309a4$require$Buffer) throw new Error("Please provide binary data as `Uint8Array`, rather than `Buffer`.");
                    if (val instanceof Uint8Array && val.byteLength === val.buffer.byteLength) return val;
                    if (typeof val === "string") return (0, _util.stringToBytes)(val);
                    if (typeof val === "object" && !isNaN(val?.length) || (0, _util.isArrayBuffer)(val)) return new Uint8Array(val);
                    throw new Error("Invalid PDF binary data: either TypedArray, string, or array-like object is expected in the data property.");
                }
                class PDFDocumentLoadingTask {
                    static #docId = 0;
                    constructor(){
                        this._capability = new _util.PromiseCapability();
                        this._transport = null;
                        this._worker = null;
                        this.docId = `d${PDFDocumentLoadingTask.#docId++}`;
                        this.destroyed = false;
                        this.onPassword = null;
                        this.onProgress = null;
                    }
                    get promise() {
                        return this._capability.promise;
                    }
                    async destroy() {
                        this.destroyed = true;
                        try {
                            if (this._worker?.port) this._worker._pendingDestroy = true;
                            await this._transport?.destroy();
                        } catch (ex) {
                            if (this._worker?.port) delete this._worker._pendingDestroy;
                            throw ex;
                        }
                        this._transport = null;
                        if (this._worker) {
                            this._worker.destroy();
                            this._worker = null;
                        }
                    }
                }
                exports.PDFDocumentLoadingTask = PDFDocumentLoadingTask;
                class PDFDataRangeTransport {
                    constructor(length, initialData, progressiveDone = false, contentDispositionFilename = null){
                        this.length = length;
                        this.initialData = initialData;
                        this.progressiveDone = progressiveDone;
                        this.contentDispositionFilename = contentDispositionFilename;
                        this._rangeListeners = [];
                        this._progressListeners = [];
                        this._progressiveReadListeners = [];
                        this._progressiveDoneListeners = [];
                        this._readyCapability = new _util.PromiseCapability();
                    }
                    addRangeListener(listener) {
                        this._rangeListeners.push(listener);
                    }
                    addProgressListener(listener) {
                        this._progressListeners.push(listener);
                    }
                    addProgressiveReadListener(listener) {
                        this._progressiveReadListeners.push(listener);
                    }
                    addProgressiveDoneListener(listener) {
                        this._progressiveDoneListeners.push(listener);
                    }
                    onDataRange(begin, chunk) {
                        for (const listener of this._rangeListeners)listener(begin, chunk);
                    }
                    onDataProgress(loaded, total) {
                        this._readyCapability.promise.then(()=>{
                            for (const listener of this._progressListeners)listener(loaded, total);
                        });
                    }
                    onDataProgressiveRead(chunk) {
                        this._readyCapability.promise.then(()=>{
                            for (const listener of this._progressiveReadListeners)listener(chunk);
                        });
                    }
                    onDataProgressiveDone() {
                        this._readyCapability.promise.then(()=>{
                            for (const listener of this._progressiveDoneListeners)listener();
                        });
                    }
                    transportReady() {
                        this._readyCapability.resolve();
                    }
                    requestDataRange(begin, end) {
                        (0, _util.unreachable)("Abstract method PDFDataRangeTransport.requestDataRange");
                    }
                    abort() {}
                }
                exports.PDFDataRangeTransport = PDFDataRangeTransport;
                class PDFDocumentProxy {
                    constructor(pdfInfo, transport){
                        this._pdfInfo = pdfInfo;
                        this._transport = transport;
                        Object.defineProperty(this, "getJavaScript", {
                            value: ()=>{
                                (0, _display_utils.deprecated)("`PDFDocumentProxy.getJavaScript`, please use `PDFDocumentProxy.getJSActions` instead.");
                                return this.getJSActions().then((js)=>{
                                    if (!js) return js;
                                    const jsArr = [];
                                    for(const name in js)jsArr.push(...js[name]);
                                    return jsArr;
                                });
                            }
                        });
                    }
                    get annotationStorage() {
                        return this._transport.annotationStorage;
                    }
                    get filterFactory() {
                        return this._transport.filterFactory;
                    }
                    get numPages() {
                        return this._pdfInfo.numPages;
                    }
                    get fingerprints() {
                        return this._pdfInfo.fingerprints;
                    }
                    get isPureXfa() {
                        return (0, _util.shadow)(this, "isPureXfa", !!this._transport._htmlForXfa);
                    }
                    get allXfaHtml() {
                        return this._transport._htmlForXfa;
                    }
                    getPage(pageNumber) {
                        return this._transport.getPage(pageNumber);
                    }
                    getPageIndex(ref) {
                        return this._transport.getPageIndex(ref);
                    }
                    getDestinations() {
                        return this._transport.getDestinations();
                    }
                    getDestination(id) {
                        return this._transport.getDestination(id);
                    }
                    getPageLabels() {
                        return this._transport.getPageLabels();
                    }
                    getPageLayout() {
                        return this._transport.getPageLayout();
                    }
                    getPageMode() {
                        return this._transport.getPageMode();
                    }
                    getViewerPreferences() {
                        return this._transport.getViewerPreferences();
                    }
                    getOpenAction() {
                        return this._transport.getOpenAction();
                    }
                    getAttachments() {
                        return this._transport.getAttachments();
                    }
                    getJSActions() {
                        return this._transport.getDocJSActions();
                    }
                    getOutline() {
                        return this._transport.getOutline();
                    }
                    getOptionalContentConfig() {
                        return this._transport.getOptionalContentConfig();
                    }
                    getPermissions() {
                        return this._transport.getPermissions();
                    }
                    getMetadata() {
                        return this._transport.getMetadata();
                    }
                    getMarkInfo() {
                        return this._transport.getMarkInfo();
                    }
                    getData() {
                        return this._transport.getData();
                    }
                    saveDocument() {
                        return this._transport.saveDocument();
                    }
                    getDownloadInfo() {
                        return this._transport.downloadInfoCapability.promise;
                    }
                    cleanup(keepLoadedFonts = false) {
                        return this._transport.startCleanup(keepLoadedFonts || this.isPureXfa);
                    }
                    destroy() {
                        return this.loadingTask.destroy();
                    }
                    get loadingParams() {
                        return this._transport.loadingParams;
                    }
                    get loadingTask() {
                        return this._transport.loadingTask;
                    }
                    getFieldObjects() {
                        return this._transport.getFieldObjects();
                    }
                    hasJSActions() {
                        return this._transport.hasJSActions();
                    }
                    getCalculationOrderIds() {
                        return this._transport.getCalculationOrderIds();
                    }
                }
                exports.PDFDocumentProxy = PDFDocumentProxy;
                class PDFPageProxy {
                    #delayedCleanupTimeout = null;
                    #pendingCleanup = false;
                    constructor(pageIndex, pageInfo, transport, pdfBug = false){
                        this._pageIndex = pageIndex;
                        this._pageInfo = pageInfo;
                        this._transport = transport;
                        this._stats = pdfBug ? new _display_utils.StatTimer() : null;
                        this._pdfBug = pdfBug;
                        this.commonObjs = transport.commonObjs;
                        this.objs = new PDFObjects();
                        this._maybeCleanupAfterRender = false;
                        this._intentStates = new Map();
                        this.destroyed = false;
                    }
                    get pageNumber() {
                        return this._pageIndex + 1;
                    }
                    get rotate() {
                        return this._pageInfo.rotate;
                    }
                    get ref() {
                        return this._pageInfo.ref;
                    }
                    get userUnit() {
                        return this._pageInfo.userUnit;
                    }
                    get view() {
                        return this._pageInfo.view;
                    }
                    getViewport({ scale, rotation = this.rotate, offsetX = 0, offsetY = 0, dontFlip = false } = {}) {
                        return new _display_utils.PageViewport({
                            viewBox: this.view,
                            scale: scale,
                            rotation: rotation,
                            offsetX: offsetX,
                            offsetY: offsetY,
                            dontFlip: dontFlip
                        });
                    }
                    getAnnotations({ intent = "display" } = {}) {
                        const intentArgs = this._transport.getRenderingIntent(intent);
                        return this._transport.getAnnotations(this._pageIndex, intentArgs.renderingIntent);
                    }
                    getJSActions() {
                        return this._transport.getPageJSActions(this._pageIndex);
                    }
                    get filterFactory() {
                        return this._transport.filterFactory;
                    }
                    get isPureXfa() {
                        return (0, _util.shadow)(this, "isPureXfa", !!this._transport._htmlForXfa);
                    }
                    async getXfa() {
                        return this._transport._htmlForXfa?.children[this._pageIndex] || null;
                    }
                    render({ canvasContext, viewport, intent = "display", annotationMode = _util.AnnotationMode.ENABLE, transform = null, background = null, optionalContentConfigPromise = null, annotationCanvasMap = null, pageColors = null, printAnnotationStorage = null }) {
                        this._stats?.time("Overall");
                        const intentArgs = this._transport.getRenderingIntent(intent, annotationMode, printAnnotationStorage);
                        this.#pendingCleanup = false;
                        this.#abortDelayedCleanup();
                        if (!optionalContentConfigPromise) optionalContentConfigPromise = this._transport.getOptionalContentConfig();
                        let intentState = this._intentStates.get(intentArgs.cacheKey);
                        if (!intentState) {
                            intentState = Object.create(null);
                            this._intentStates.set(intentArgs.cacheKey, intentState);
                        }
                        if (intentState.streamReaderCancelTimeout) {
                            clearTimeout(intentState.streamReaderCancelTimeout);
                            intentState.streamReaderCancelTimeout = null;
                        }
                        const intentPrint = !!(intentArgs.renderingIntent & _util.RenderingIntentFlag.PRINT);
                        if (!intentState.displayReadyCapability) {
                            intentState.displayReadyCapability = new _util.PromiseCapability();
                            intentState.operatorList = {
                                fnArray: [],
                                argsArray: [],
                                lastChunk: false,
                                separateAnnots: null
                            };
                            this._stats?.time("Page Request");
                            this._pumpOperatorList(intentArgs);
                        }
                        const complete = (error)=>{
                            intentState.renderTasks.delete(internalRenderTask);
                            if (this._maybeCleanupAfterRender || intentPrint) this.#pendingCleanup = true;
                            this.#tryCleanup(!intentPrint);
                            if (error) {
                                internalRenderTask.capability.reject(error);
                                this._abortOperatorList({
                                    intentState: intentState,
                                    reason: error instanceof Error ? error : new Error(error)
                                });
                            } else internalRenderTask.capability.resolve();
                            this._stats?.timeEnd("Rendering");
                            this._stats?.timeEnd("Overall");
                        };
                        const internalRenderTask = new InternalRenderTask({
                            callback: complete,
                            params: {
                                canvasContext: canvasContext,
                                viewport: viewport,
                                transform: transform,
                                background: background
                            },
                            objs: this.objs,
                            commonObjs: this.commonObjs,
                            annotationCanvasMap: annotationCanvasMap,
                            operatorList: intentState.operatorList,
                            pageIndex: this._pageIndex,
                            canvasFactory: this._transport.canvasFactory,
                            filterFactory: this._transport.filterFactory,
                            useRequestAnimationFrame: !intentPrint,
                            pdfBug: this._pdfBug,
                            pageColors: pageColors
                        });
                        (intentState.renderTasks ||= new Set()).add(internalRenderTask);
                        const renderTask = internalRenderTask.task;
                        Promise.all([
                            intentState.displayReadyCapability.promise,
                            optionalContentConfigPromise
                        ]).then(([transparency, optionalContentConfig])=>{
                            if (this.destroyed) {
                                complete();
                                return;
                            }
                            this._stats?.time("Rendering");
                            internalRenderTask.initializeGraphics({
                                transparency: transparency,
                                optionalContentConfig: optionalContentConfig
                            });
                            internalRenderTask.operatorListChanged();
                        }).catch(complete);
                        return renderTask;
                    }
                    getOperatorList({ intent = "display", annotationMode = _util.AnnotationMode.ENABLE, printAnnotationStorage = null } = {}) {
                        function operatorListChanged() {
                            if (intentState.operatorList.lastChunk) {
                                intentState.opListReadCapability.resolve(intentState.operatorList);
                                intentState.renderTasks.delete(opListTask);
                            }
                        }
                        const intentArgs = this._transport.getRenderingIntent(intent, annotationMode, printAnnotationStorage, true);
                        let intentState = this._intentStates.get(intentArgs.cacheKey);
                        if (!intentState) {
                            intentState = Object.create(null);
                            this._intentStates.set(intentArgs.cacheKey, intentState);
                        }
                        let opListTask;
                        if (!intentState.opListReadCapability) {
                            opListTask = Object.create(null);
                            opListTask.operatorListChanged = operatorListChanged;
                            intentState.opListReadCapability = new _util.PromiseCapability();
                            (intentState.renderTasks ||= new Set()).add(opListTask);
                            intentState.operatorList = {
                                fnArray: [],
                                argsArray: [],
                                lastChunk: false,
                                separateAnnots: null
                            };
                            this._stats?.time("Page Request");
                            this._pumpOperatorList(intentArgs);
                        }
                        return intentState.opListReadCapability.promise;
                    }
                    streamTextContent({ includeMarkedContent = false, disableNormalization = false } = {}) {
                        const TEXT_CONTENT_CHUNK_SIZE = 100;
                        return this._transport.messageHandler.sendWithStream("GetTextContent", {
                            pageIndex: this._pageIndex,
                            includeMarkedContent: includeMarkedContent === true,
                            disableNormalization: disableNormalization === true
                        }, {
                            highWaterMark: TEXT_CONTENT_CHUNK_SIZE,
                            size (textContent) {
                                return textContent.items.length;
                            }
                        });
                    }
                    getTextContent(params = {}) {
                        if (this._transport._htmlForXfa) return this.getXfa().then((xfa)=>{
                            return _xfa_text.XfaText.textContent(xfa);
                        });
                        const readableStream = this.streamTextContent(params);
                        return new Promise(function(resolve, reject) {
                            function pump() {
                                reader.read().then(function({ value, done }) {
                                    if (done) {
                                        resolve(textContent);
                                        return;
                                    }
                                    Object.assign(textContent.styles, value.styles);
                                    textContent.items.push(...value.items);
                                    pump();
                                }, reject);
                            }
                            const reader = readableStream.getReader();
                            const textContent = {
                                items: [],
                                styles: Object.create(null)
                            };
                            pump();
                        });
                    }
                    getStructTree() {
                        return this._transport.getStructTree(this._pageIndex);
                    }
                    _destroy() {
                        this.destroyed = true;
                        const waitOn = [];
                        for (const intentState of this._intentStates.values()){
                            this._abortOperatorList({
                                intentState: intentState,
                                reason: new Error("Page was destroyed."),
                                force: true
                            });
                            if (intentState.opListReadCapability) continue;
                            for (const internalRenderTask of intentState.renderTasks){
                                waitOn.push(internalRenderTask.completed);
                                internalRenderTask.cancel();
                            }
                        }
                        this.objs.clear();
                        this.#pendingCleanup = false;
                        this.#abortDelayedCleanup();
                        return Promise.all(waitOn);
                    }
                    cleanup(resetStats = false) {
                        this.#pendingCleanup = true;
                        const success = this.#tryCleanup(false);
                        if (resetStats && success) this._stats &&= new _display_utils.StatTimer();
                        return success;
                    }
                    #tryCleanup(delayed = false) {
                        this.#abortDelayedCleanup();
                        if (!this.#pendingCleanup || this.destroyed) return false;
                        if (delayed) {
                            this.#delayedCleanupTimeout = setTimeout(()=>{
                                this.#delayedCleanupTimeout = null;
                                this.#tryCleanup(false);
                            }, DELAYED_CLEANUP_TIMEOUT);
                            return false;
                        }
                        for (const { renderTasks, operatorList } of this._intentStates.values()){
                            if (renderTasks.size > 0 || !operatorList.lastChunk) return false;
                        }
                        this._intentStates.clear();
                        this.objs.clear();
                        this.#pendingCleanup = false;
                        return true;
                    }
                    #abortDelayedCleanup() {
                        if (this.#delayedCleanupTimeout) {
                            clearTimeout(this.#delayedCleanupTimeout);
                            this.#delayedCleanupTimeout = null;
                        }
                    }
                    _startRenderPage(transparency, cacheKey) {
                        const intentState = this._intentStates.get(cacheKey);
                        if (!intentState) return;
                        this._stats?.timeEnd("Page Request");
                        intentState.displayReadyCapability?.resolve(transparency);
                    }
                    _renderPageChunk(operatorListChunk, intentState) {
                        for(let i = 0, ii = operatorListChunk.length; i < ii; i++){
                            intentState.operatorList.fnArray.push(operatorListChunk.fnArray[i]);
                            intentState.operatorList.argsArray.push(operatorListChunk.argsArray[i]);
                        }
                        intentState.operatorList.lastChunk = operatorListChunk.lastChunk;
                        intentState.operatorList.separateAnnots = operatorListChunk.separateAnnots;
                        for (const internalRenderTask of intentState.renderTasks)internalRenderTask.operatorListChanged();
                        if (operatorListChunk.lastChunk) this.#tryCleanup(true);
                    }
                    _pumpOperatorList({ renderingIntent, cacheKey, annotationStorageSerializable }) {
                        const { map, transfers } = annotationStorageSerializable;
                        const readableStream = this._transport.messageHandler.sendWithStream("GetOperatorList", {
                            pageIndex: this._pageIndex,
                            intent: renderingIntent,
                            cacheKey: cacheKey,
                            annotationStorage: map
                        }, transfers);
                        const reader = readableStream.getReader();
                        const intentState = this._intentStates.get(cacheKey);
                        intentState.streamReader = reader;
                        const pump = ()=>{
                            reader.read().then(({ value, done })=>{
                                if (done) {
                                    intentState.streamReader = null;
                                    return;
                                }
                                if (this._transport.destroyed) return;
                                this._renderPageChunk(value, intentState);
                                pump();
                            }, (reason)=>{
                                intentState.streamReader = null;
                                if (this._transport.destroyed) return;
                                if (intentState.operatorList) {
                                    intentState.operatorList.lastChunk = true;
                                    for (const internalRenderTask of intentState.renderTasks)internalRenderTask.operatorListChanged();
                                    this.#tryCleanup(true);
                                }
                                if (intentState.displayReadyCapability) intentState.displayReadyCapability.reject(reason);
                                else if (intentState.opListReadCapability) intentState.opListReadCapability.reject(reason);
                                else throw reason;
                            });
                        };
                        pump();
                    }
                    _abortOperatorList({ intentState, reason, force = false }) {
                        if (!intentState.streamReader) return;
                        if (intentState.streamReaderCancelTimeout) {
                            clearTimeout(intentState.streamReaderCancelTimeout);
                            intentState.streamReaderCancelTimeout = null;
                        }
                        if (!force) {
                            if (intentState.renderTasks.size > 0) return;
                            if (reason instanceof _display_utils.RenderingCancelledException) {
                                let delay = RENDERING_CANCELLED_TIMEOUT;
                                if (reason.extraDelay > 0 && reason.extraDelay < 1000) delay += reason.extraDelay;
                                intentState.streamReaderCancelTimeout = setTimeout(()=>{
                                    intentState.streamReaderCancelTimeout = null;
                                    this._abortOperatorList({
                                        intentState: intentState,
                                        reason: reason,
                                        force: true
                                    });
                                }, delay);
                                return;
                            }
                        }
                        intentState.streamReader.cancel(new _util.AbortException(reason.message)).catch(()=>{});
                        intentState.streamReader = null;
                        if (this._transport.destroyed) return;
                        for (const [curCacheKey, curIntentState] of this._intentStates)if (curIntentState === intentState) {
                            this._intentStates.delete(curCacheKey);
                            break;
                        }
                        this.cleanup();
                    }
                    get stats() {
                        return this._stats;
                    }
                }
                exports.PDFPageProxy = PDFPageProxy;
                class LoopbackPort {
                    #listeners = new Set();
                    #deferred = Promise.resolve();
                    postMessage(obj, transfer) {
                        const event = {
                            data: structuredClone(obj, transfer ? {
                                transfer: transfer
                            } : null)
                        };
                        this.#deferred.then(()=>{
                            for (const listener of this.#listeners)listener.call(this, event);
                        });
                    }
                    addEventListener(name, listener) {
                        this.#listeners.add(listener);
                    }
                    removeEventListener(name, listener) {
                        this.#listeners.delete(listener);
                    }
                    terminate() {
                        this.#listeners.clear();
                    }
                }
                exports.LoopbackPort = LoopbackPort;
                const PDFWorkerUtil = {
                    isWorkerDisabled: false,
                    fallbackWorkerSrc: null,
                    fakeWorkerId: 0
                };
                exports.PDFWorkerUtil = PDFWorkerUtil;
                if (_util.isNodeJS && true) {
                    PDFWorkerUtil.isWorkerDisabled = true;
                    PDFWorkerUtil.fallbackWorkerSrc = "./pdf.worker.js";
                } else if (typeof document === "object") {
                    const pdfjsFilePath = document?.currentScript?.src;
                    if (pdfjsFilePath) PDFWorkerUtil.fallbackWorkerSrc = pdfjsFilePath.replace(/(\.(?:min\.)?js)(\?.*)?$/i, ".worker$1$2");
                }
                PDFWorkerUtil.isSameOrigin = function(baseUrl, otherUrl) {
                    let base;
                    try {
                        base = new URL(baseUrl);
                        if (!base.origin || base.origin === "null") return false;
                    } catch  {
                        return false;
                    }
                    const other = new URL(otherUrl, base);
                    return base.origin === other.origin;
                };
                PDFWorkerUtil.createCDNWrapper = function(url) {
                    const wrapper = `importScripts("${url}");`;
                    return URL.createObjectURL(new Blob([
                        wrapper
                    ]));
                };
                class PDFWorker {
                    static #workerPorts;
                    constructor({ name = null, port = null, verbosity = (0, _util.getVerbosityLevel)() } = {}){
                        this.name = name;
                        this.destroyed = false;
                        this.verbosity = verbosity;
                        this._readyCapability = new _util.PromiseCapability();
                        this._port = null;
                        this._webWorker = null;
                        this._messageHandler = null;
                        if (port) {
                            if (PDFWorker.#workerPorts?.has(port)) throw new Error("Cannot use more than one PDFWorker per port.");
                            (PDFWorker.#workerPorts ||= new WeakMap()).set(port, this);
                            this._initializeFromPort(port);
                            return;
                        }
                        this._initialize();
                    }
                    get promise() {
                        return this._readyCapability.promise;
                    }
                    get port() {
                        return this._port;
                    }
                    get messageHandler() {
                        return this._messageHandler;
                    }
                    _initializeFromPort(port) {
                        this._port = port;
                        this._messageHandler = new _message_handler.MessageHandler("main", "worker", port);
                        this._messageHandler.on("ready", function() {});
                        this._readyCapability.resolve();
                        this._messageHandler.send("configure", {
                            verbosity: this.verbosity
                        });
                    }
                    _initialize() {
                        if (!PDFWorkerUtil.isWorkerDisabled && !PDFWorker._mainThreadWorkerMessageHandler) {
                            let { workerSrc } = PDFWorker;
                            try {
                                if (!PDFWorkerUtil.isSameOrigin(window.location.href, workerSrc)) workerSrc = PDFWorkerUtil.createCDNWrapper(new URL(workerSrc, window.location).href);
                                const worker = new Worker(workerSrc);
                                const messageHandler = new _message_handler.MessageHandler("main", "worker", worker);
                                const terminateEarly = ()=>{
                                    worker.removeEventListener("error", onWorkerError);
                                    messageHandler.destroy();
                                    worker.terminate();
                                    if (this.destroyed) this._readyCapability.reject(new Error("Worker was destroyed"));
                                    else this._setupFakeWorker();
                                };
                                const onWorkerError = ()=>{
                                    if (!this._webWorker) terminateEarly();
                                };
                                worker.addEventListener("error", onWorkerError);
                                messageHandler.on("test", (data)=>{
                                    worker.removeEventListener("error", onWorkerError);
                                    if (this.destroyed) {
                                        terminateEarly();
                                        return;
                                    }
                                    if (data) {
                                        this._messageHandler = messageHandler;
                                        this._port = worker;
                                        this._webWorker = worker;
                                        this._readyCapability.resolve();
                                        messageHandler.send("configure", {
                                            verbosity: this.verbosity
                                        });
                                    } else {
                                        this._setupFakeWorker();
                                        messageHandler.destroy();
                                        worker.terminate();
                                    }
                                });
                                messageHandler.on("ready", (data)=>{
                                    worker.removeEventListener("error", onWorkerError);
                                    if (this.destroyed) {
                                        terminateEarly();
                                        return;
                                    }
                                    try {
                                        sendTest();
                                    } catch  {
                                        this._setupFakeWorker();
                                    }
                                });
                                const sendTest = ()=>{
                                    const testObj = new Uint8Array();
                                    messageHandler.send("test", testObj, [
                                        testObj.buffer
                                    ]);
                                };
                                sendTest();
                                return;
                            } catch  {
                                (0, _util.info)("The worker has been disabled.");
                            }
                        }
                        this._setupFakeWorker();
                    }
                    _setupFakeWorker() {
                        if (!PDFWorkerUtil.isWorkerDisabled) {
                            (0, _util.warn)("Setting up fake worker.");
                            PDFWorkerUtil.isWorkerDisabled = true;
                        }
                        PDFWorker._setupFakeWorkerGlobal.then((WorkerMessageHandler)=>{
                            if (this.destroyed) {
                                this._readyCapability.reject(new Error("Worker was destroyed"));
                                return;
                            }
                            const port = new LoopbackPort();
                            this._port = port;
                            const id = `fake${PDFWorkerUtil.fakeWorkerId++}`;
                            const workerHandler = new _message_handler.MessageHandler(id + "_worker", id, port);
                            WorkerMessageHandler.setup(workerHandler, port);
                            const messageHandler = new _message_handler.MessageHandler(id, id + "_worker", port);
                            this._messageHandler = messageHandler;
                            this._readyCapability.resolve();
                            messageHandler.send("configure", {
                                verbosity: this.verbosity
                            });
                        }).catch((reason)=>{
                            this._readyCapability.reject(new Error(`Setting up fake worker failed: "${reason.message}".`));
                        });
                    }
                    destroy() {
                        this.destroyed = true;
                        if (this._webWorker) {
                            this._webWorker.terminate();
                            this._webWorker = null;
                        }
                        PDFWorker.#workerPorts?.delete(this._port);
                        this._port = null;
                        if (this._messageHandler) {
                            this._messageHandler.destroy();
                            this._messageHandler = null;
                        }
                    }
                    static fromPort(params) {
                        if (!params?.port) throw new Error("PDFWorker.fromPort - invalid method signature.");
                        const cachedPort = this.#workerPorts?.get(params.port);
                        if (cachedPort) {
                            if (cachedPort._pendingDestroy) throw new Error("PDFWorker.fromPort - the worker is being destroyed.\nPlease remember to await `PDFDocumentLoadingTask.destroy()`-calls.");
                            return cachedPort;
                        }
                        return new PDFWorker(params);
                    }
                    static get workerSrc() {
                        if (_worker_options.GlobalWorkerOptions.workerSrc) return _worker_options.GlobalWorkerOptions.workerSrc;
                        if (PDFWorkerUtil.fallbackWorkerSrc !== null) {
                            if (!_util.isNodeJS) (0, _display_utils.deprecated)('No "GlobalWorkerOptions.workerSrc" specified.');
                            return PDFWorkerUtil.fallbackWorkerSrc;
                        }
                        throw new Error('No "GlobalWorkerOptions.workerSrc" specified.');
                    }
                    static get _mainThreadWorkerMessageHandler() {
                        try {
                            return globalThis.pdfjsWorker?.WorkerMessageHandler || null;
                        } catch  {
                            return null;
                        }
                    }
                    static get _setupFakeWorkerGlobal() {
                        const loader = async ()=>{
                            const mainWorkerMessageHandler = this._mainThreadWorkerMessageHandler;
                            if (mainWorkerMessageHandler) return mainWorkerMessageHandler;
                            if (_util.isNodeJS && true) {
                                const worker = eval("require")(this.workerSrc);
                                return worker.WorkerMessageHandler;
                            }
                            await (0, _display_utils.loadScript)(this.workerSrc);
                            return window.pdfjsWorker.WorkerMessageHandler;
                        };
                        return (0, _util.shadow)(this, "_setupFakeWorkerGlobal", loader());
                    }
                }
                exports.PDFWorker = PDFWorker;
                class WorkerTransport {
                    #methodPromises = new Map();
                    #pageCache = new Map();
                    #pagePromises = new Map();
                    #passwordCapability = null;
                    constructor(messageHandler, loadingTask, networkStream, params, factory){
                        this.messageHandler = messageHandler;
                        this.loadingTask = loadingTask;
                        this.commonObjs = new PDFObjects();
                        this.fontLoader = new _font_loader.FontLoader({
                            ownerDocument: params.ownerDocument,
                            styleElement: params.styleElement
                        });
                        this._params = params;
                        this.canvasFactory = factory.canvasFactory;
                        this.filterFactory = factory.filterFactory;
                        this.cMapReaderFactory = factory.cMapReaderFactory;
                        this.standardFontDataFactory = factory.standardFontDataFactory;
                        this.destroyed = false;
                        this.destroyCapability = null;
                        this._networkStream = networkStream;
                        this._fullReader = null;
                        this._lastProgress = null;
                        this.downloadInfoCapability = new _util.PromiseCapability();
                        this.setupMessageHandler();
                    }
                    #cacheSimpleMethod(name, data = null) {
                        const cachedPromise = this.#methodPromises.get(name);
                        if (cachedPromise) return cachedPromise;
                        const promise = this.messageHandler.sendWithPromise(name, data);
                        this.#methodPromises.set(name, promise);
                        return promise;
                    }
                    get annotationStorage() {
                        return (0, _util.shadow)(this, "annotationStorage", new _annotation_storage.AnnotationStorage());
                    }
                    getRenderingIntent(intent, annotationMode = _util.AnnotationMode.ENABLE, printAnnotationStorage = null, isOpList = false) {
                        let renderingIntent = _util.RenderingIntentFlag.DISPLAY;
                        let annotationStorageSerializable = _annotation_storage.SerializableEmpty;
                        switch(intent){
                            case "any":
                                renderingIntent = _util.RenderingIntentFlag.ANY;
                                break;
                            case "display":
                                break;
                            case "print":
                                renderingIntent = _util.RenderingIntentFlag.PRINT;
                                break;
                            default:
                                (0, _util.warn)(`getRenderingIntent - invalid intent: ${intent}`);
                        }
                        switch(annotationMode){
                            case _util.AnnotationMode.DISABLE:
                                renderingIntent += _util.RenderingIntentFlag.ANNOTATIONS_DISABLE;
                                break;
                            case _util.AnnotationMode.ENABLE:
                                break;
                            case _util.AnnotationMode.ENABLE_FORMS:
                                renderingIntent += _util.RenderingIntentFlag.ANNOTATIONS_FORMS;
                                break;
                            case _util.AnnotationMode.ENABLE_STORAGE:
                                renderingIntent += _util.RenderingIntentFlag.ANNOTATIONS_STORAGE;
                                const annotationStorage = renderingIntent & _util.RenderingIntentFlag.PRINT && printAnnotationStorage instanceof _annotation_storage.PrintAnnotationStorage ? printAnnotationStorage : this.annotationStorage;
                                annotationStorageSerializable = annotationStorage.serializable;
                                break;
                            default:
                                (0, _util.warn)(`getRenderingIntent - invalid annotationMode: ${annotationMode}`);
                        }
                        if (isOpList) renderingIntent += _util.RenderingIntentFlag.OPLIST;
                        return {
                            renderingIntent: renderingIntent,
                            cacheKey: `${renderingIntent}_${annotationStorageSerializable.hash}`,
                            annotationStorageSerializable: annotationStorageSerializable
                        };
                    }
                    destroy() {
                        if (this.destroyCapability) return this.destroyCapability.promise;
                        this.destroyed = true;
                        this.destroyCapability = new _util.PromiseCapability();
                        this.#passwordCapability?.reject(new Error("Worker was destroyed during onPassword callback"));
                        const waitOn = [];
                        for (const page of this.#pageCache.values())waitOn.push(page._destroy());
                        this.#pageCache.clear();
                        this.#pagePromises.clear();
                        if (this.hasOwnProperty("annotationStorage")) this.annotationStorage.resetModified();
                        const terminated = this.messageHandler.sendWithPromise("Terminate", null);
                        waitOn.push(terminated);
                        Promise.all(waitOn).then(()=>{
                            this.commonObjs.clear();
                            this.fontLoader.clear();
                            this.#methodPromises.clear();
                            this.filterFactory.destroy();
                            this._networkStream?.cancelAllRequests(new _util.AbortException("Worker was terminated."));
                            if (this.messageHandler) {
                                this.messageHandler.destroy();
                                this.messageHandler = null;
                            }
                            this.destroyCapability.resolve();
                        }, this.destroyCapability.reject);
                        return this.destroyCapability.promise;
                    }
                    setupMessageHandler() {
                        const { messageHandler, loadingTask } = this;
                        messageHandler.on("GetReader", (data, sink)=>{
                            (0, _util.assert)(this._networkStream, "GetReader - no `IPDFStream` instance available.");
                            this._fullReader = this._networkStream.getFullReader();
                            this._fullReader.onProgress = (evt)=>{
                                this._lastProgress = {
                                    loaded: evt.loaded,
                                    total: evt.total
                                };
                            };
                            sink.onPull = ()=>{
                                this._fullReader.read().then(function({ value, done }) {
                                    if (done) {
                                        sink.close();
                                        return;
                                    }
                                    (0, _util.assert)(value instanceof ArrayBuffer, "GetReader - expected an ArrayBuffer.");
                                    sink.enqueue(new Uint8Array(value), 1, [
                                        value
                                    ]);
                                }).catch((reason)=>{
                                    sink.error(reason);
                                });
                            };
                            sink.onCancel = (reason)=>{
                                this._fullReader.cancel(reason);
                                sink.ready.catch((readyReason)=>{
                                    if (this.destroyed) return;
                                    throw readyReason;
                                });
                            };
                        });
                        messageHandler.on("ReaderHeadersReady", (data)=>{
                            const headersCapability = new _util.PromiseCapability();
                            const fullReader = this._fullReader;
                            fullReader.headersReady.then(()=>{
                                if (!fullReader.isStreamingSupported || !fullReader.isRangeSupported) {
                                    if (this._lastProgress) loadingTask.onProgress?.(this._lastProgress);
                                    fullReader.onProgress = (evt)=>{
                                        loadingTask.onProgress?.({
                                            loaded: evt.loaded,
                                            total: evt.total
                                        });
                                    };
                                }
                                headersCapability.resolve({
                                    isStreamingSupported: fullReader.isStreamingSupported,
                                    isRangeSupported: fullReader.isRangeSupported,
                                    contentLength: fullReader.contentLength
                                });
                            }, headersCapability.reject);
                            return headersCapability.promise;
                        });
                        messageHandler.on("GetRangeReader", (data, sink)=>{
                            (0, _util.assert)(this._networkStream, "GetRangeReader - no `IPDFStream` instance available.");
                            const rangeReader = this._networkStream.getRangeReader(data.begin, data.end);
                            if (!rangeReader) {
                                sink.close();
                                return;
                            }
                            sink.onPull = ()=>{
                                rangeReader.read().then(function({ value, done }) {
                                    if (done) {
                                        sink.close();
                                        return;
                                    }
                                    (0, _util.assert)(value instanceof ArrayBuffer, "GetRangeReader - expected an ArrayBuffer.");
                                    sink.enqueue(new Uint8Array(value), 1, [
                                        value
                                    ]);
                                }).catch((reason)=>{
                                    sink.error(reason);
                                });
                            };
                            sink.onCancel = (reason)=>{
                                rangeReader.cancel(reason);
                                sink.ready.catch((readyReason)=>{
                                    if (this.destroyed) return;
                                    throw readyReason;
                                });
                            };
                        });
                        messageHandler.on("GetDoc", ({ pdfInfo })=>{
                            this._numPages = pdfInfo.numPages;
                            this._htmlForXfa = pdfInfo.htmlForXfa;
                            delete pdfInfo.htmlForXfa;
                            loadingTask._capability.resolve(new PDFDocumentProxy(pdfInfo, this));
                        });
                        messageHandler.on("DocException", function(ex) {
                            let reason;
                            switch(ex.name){
                                case "PasswordException":
                                    reason = new _util.PasswordException(ex.message, ex.code);
                                    break;
                                case "InvalidPDFException":
                                    reason = new _util.InvalidPDFException(ex.message);
                                    break;
                                case "MissingPDFException":
                                    reason = new _util.MissingPDFException(ex.message);
                                    break;
                                case "UnexpectedResponseException":
                                    reason = new _util.UnexpectedResponseException(ex.message, ex.status);
                                    break;
                                case "UnknownErrorException":
                                    reason = new _util.UnknownErrorException(ex.message, ex.details);
                                    break;
                                default:
                                    (0, _util.unreachable)("DocException - expected a valid Error.");
                            }
                            loadingTask._capability.reject(reason);
                        });
                        messageHandler.on("PasswordRequest", (exception)=>{
                            this.#passwordCapability = new _util.PromiseCapability();
                            if (loadingTask.onPassword) {
                                const updatePassword = (password)=>{
                                    if (password instanceof Error) this.#passwordCapability.reject(password);
                                    else this.#passwordCapability.resolve({
                                        password: password
                                    });
                                };
                                try {
                                    loadingTask.onPassword(updatePassword, exception.code);
                                } catch (ex) {
                                    this.#passwordCapability.reject(ex);
                                }
                            } else this.#passwordCapability.reject(new _util.PasswordException(exception.message, exception.code));
                            return this.#passwordCapability.promise;
                        });
                        messageHandler.on("DataLoaded", (data)=>{
                            loadingTask.onProgress?.({
                                loaded: data.length,
                                total: data.length
                            });
                            this.downloadInfoCapability.resolve(data);
                        });
                        messageHandler.on("StartRenderPage", (data)=>{
                            if (this.destroyed) return;
                            const page = this.#pageCache.get(data.pageIndex);
                            page._startRenderPage(data.transparency, data.cacheKey);
                        });
                        messageHandler.on("commonobj", ([id, type, exportedData])=>{
                            if (this.destroyed) return;
                            if (this.commonObjs.has(id)) return;
                            switch(type){
                                case "Font":
                                    const params = this._params;
                                    if ("error" in exportedData) {
                                        const exportedError = exportedData.error;
                                        (0, _util.warn)(`Error during font loading: ${exportedError}`);
                                        this.commonObjs.resolve(id, exportedError);
                                        break;
                                    }
                                    const inspectFont = params.pdfBug && globalThis.FontInspector?.enabled ? (font, url)=>globalThis.FontInspector.fontAdded(font, url) : null;
                                    const font = new _font_loader.FontFaceObject(exportedData, {
                                        isEvalSupported: params.isEvalSupported,
                                        disableFontFace: params.disableFontFace,
                                        ignoreErrors: params.ignoreErrors,
                                        inspectFont: inspectFont
                                    });
                                    this.fontLoader.bind(font).catch((reason)=>{
                                        return messageHandler.sendWithPromise("FontFallback", {
                                            id: id
                                        });
                                    }).finally(()=>{
                                        if (!params.fontExtraProperties && font.data) font.data = null;
                                        this.commonObjs.resolve(id, font);
                                    });
                                    break;
                                case "FontPath":
                                case "Image":
                                case "Pattern":
                                    this.commonObjs.resolve(id, exportedData);
                                    break;
                                default:
                                    throw new Error(`Got unknown common object type ${type}`);
                            }
                        });
                        messageHandler.on("obj", ([id, pageIndex, type, imageData])=>{
                            if (this.destroyed) return;
                            const pageProxy = this.#pageCache.get(pageIndex);
                            if (pageProxy.objs.has(id)) return;
                            switch(type){
                                case "Image":
                                    pageProxy.objs.resolve(id, imageData);
                                    if (imageData) {
                                        let length;
                                        if (imageData.bitmap) {
                                            const { width, height } = imageData;
                                            length = width * height * 4;
                                        } else length = imageData.data?.length || 0;
                                        if (length > _util.MAX_IMAGE_SIZE_TO_CACHE) pageProxy._maybeCleanupAfterRender = true;
                                    }
                                    break;
                                case "Pattern":
                                    pageProxy.objs.resolve(id, imageData);
                                    break;
                                default:
                                    throw new Error(`Got unknown object type ${type}`);
                            }
                        });
                        messageHandler.on("DocProgress", (data)=>{
                            if (this.destroyed) return;
                            loadingTask.onProgress?.({
                                loaded: data.loaded,
                                total: data.total
                            });
                        });
                        messageHandler.on("FetchBuiltInCMap", (data)=>{
                            if (this.destroyed) return Promise.reject(new Error("Worker was destroyed."));
                            if (!this.cMapReaderFactory) return Promise.reject(new Error("CMapReaderFactory not initialized, see the `useWorkerFetch` parameter."));
                            return this.cMapReaderFactory.fetch(data);
                        });
                        messageHandler.on("FetchStandardFontData", (data)=>{
                            if (this.destroyed) return Promise.reject(new Error("Worker was destroyed."));
                            if (!this.standardFontDataFactory) return Promise.reject(new Error("StandardFontDataFactory not initialized, see the `useWorkerFetch` parameter."));
                            return this.standardFontDataFactory.fetch(data);
                        });
                    }
                    getData() {
                        return this.messageHandler.sendWithPromise("GetData", null);
                    }
                    saveDocument() {
                        if (this.annotationStorage.size <= 0) (0, _util.warn)("saveDocument called while `annotationStorage` is empty, please use the getData-method instead.");
                        const { map, transfers } = this.annotationStorage.serializable;
                        return this.messageHandler.sendWithPromise("SaveDocument", {
                            isPureXfa: !!this._htmlForXfa,
                            numPages: this._numPages,
                            annotationStorage: map,
                            filename: this._fullReader?.filename ?? null
                        }, transfers).finally(()=>{
                            this.annotationStorage.resetModified();
                        });
                    }
                    getPage(pageNumber) {
                        if (!Number.isInteger(pageNumber) || pageNumber <= 0 || pageNumber > this._numPages) return Promise.reject(new Error("Invalid page request."));
                        const pageIndex = pageNumber - 1, cachedPromise = this.#pagePromises.get(pageIndex);
                        if (cachedPromise) return cachedPromise;
                        const promise = this.messageHandler.sendWithPromise("GetPage", {
                            pageIndex: pageIndex
                        }).then((pageInfo)=>{
                            if (this.destroyed) throw new Error("Transport destroyed");
                            const page = new PDFPageProxy(pageIndex, pageInfo, this, this._params.pdfBug);
                            this.#pageCache.set(pageIndex, page);
                            return page;
                        });
                        this.#pagePromises.set(pageIndex, promise);
                        return promise;
                    }
                    getPageIndex(ref) {
                        if (typeof ref !== "object" || ref === null || !Number.isInteger(ref.num) || ref.num < 0 || !Number.isInteger(ref.gen) || ref.gen < 0) return Promise.reject(new Error("Invalid pageIndex request."));
                        return this.messageHandler.sendWithPromise("GetPageIndex", {
                            num: ref.num,
                            gen: ref.gen
                        });
                    }
                    getAnnotations(pageIndex, intent) {
                        return this.messageHandler.sendWithPromise("GetAnnotations", {
                            pageIndex: pageIndex,
                            intent: intent
                        });
                    }
                    getFieldObjects() {
                        return this.#cacheSimpleMethod("GetFieldObjects");
                    }
                    hasJSActions() {
                        return this.#cacheSimpleMethod("HasJSActions");
                    }
                    getCalculationOrderIds() {
                        return this.messageHandler.sendWithPromise("GetCalculationOrderIds", null);
                    }
                    getDestinations() {
                        return this.messageHandler.sendWithPromise("GetDestinations", null);
                    }
                    getDestination(id) {
                        if (typeof id !== "string") return Promise.reject(new Error("Invalid destination request."));
                        return this.messageHandler.sendWithPromise("GetDestination", {
                            id: id
                        });
                    }
                    getPageLabels() {
                        return this.messageHandler.sendWithPromise("GetPageLabels", null);
                    }
                    getPageLayout() {
                        return this.messageHandler.sendWithPromise("GetPageLayout", null);
                    }
                    getPageMode() {
                        return this.messageHandler.sendWithPromise("GetPageMode", null);
                    }
                    getViewerPreferences() {
                        return this.messageHandler.sendWithPromise("GetViewerPreferences", null);
                    }
                    getOpenAction() {
                        return this.messageHandler.sendWithPromise("GetOpenAction", null);
                    }
                    getAttachments() {
                        return this.messageHandler.sendWithPromise("GetAttachments", null);
                    }
                    getDocJSActions() {
                        return this.#cacheSimpleMethod("GetDocJSActions");
                    }
                    getPageJSActions(pageIndex) {
                        return this.messageHandler.sendWithPromise("GetPageJSActions", {
                            pageIndex: pageIndex
                        });
                    }
                    getStructTree(pageIndex) {
                        return this.messageHandler.sendWithPromise("GetStructTree", {
                            pageIndex: pageIndex
                        });
                    }
                    getOutline() {
                        return this.messageHandler.sendWithPromise("GetOutline", null);
                    }
                    getOptionalContentConfig() {
                        return this.messageHandler.sendWithPromise("GetOptionalContentConfig", null).then((results)=>{
                            return new _optional_content_config.OptionalContentConfig(results);
                        });
                    }
                    getPermissions() {
                        return this.messageHandler.sendWithPromise("GetPermissions", null);
                    }
                    getMetadata() {
                        const name = "GetMetadata", cachedPromise = this.#methodPromises.get(name);
                        if (cachedPromise) return cachedPromise;
                        const promise = this.messageHandler.sendWithPromise(name, null).then((results)=>{
                            return {
                                info: results[0],
                                metadata: results[1] ? new _metadata.Metadata(results[1]) : null,
                                contentDispositionFilename: this._fullReader?.filename ?? null,
                                contentLength: this._fullReader?.contentLength ?? null
                            };
                        });
                        this.#methodPromises.set(name, promise);
                        return promise;
                    }
                    getMarkInfo() {
                        return this.messageHandler.sendWithPromise("GetMarkInfo", null);
                    }
                    async startCleanup(keepLoadedFonts = false) {
                        if (this.destroyed) return;
                        await this.messageHandler.sendWithPromise("Cleanup", null);
                        for (const page of this.#pageCache.values()){
                            const cleanupSuccessful = page.cleanup();
                            if (!cleanupSuccessful) throw new Error(`startCleanup: Page ${page.pageNumber} is currently rendering.`);
                        }
                        this.commonObjs.clear();
                        if (!keepLoadedFonts) this.fontLoader.clear();
                        this.#methodPromises.clear();
                        this.filterFactory.destroy(true);
                    }
                    get loadingParams() {
                        const { disableAutoFetch, enableXfa } = this._params;
                        return (0, _util.shadow)(this, "loadingParams", {
                            disableAutoFetch: disableAutoFetch,
                            enableXfa: enableXfa
                        });
                    }
                }
                class PDFObjects {
                    #objs = Object.create(null);
                    #ensureObj(objId) {
                        return this.#objs[objId] ||= {
                            capability: new _util.PromiseCapability(),
                            data: null
                        };
                    }
                    get(objId, callback = null) {
                        if (callback) {
                            const obj = this.#ensureObj(objId);
                            obj.capability.promise.then(()=>callback(obj.data));
                            return null;
                        }
                        const obj = this.#objs[objId];
                        if (!obj?.capability.settled) throw new Error(`Requesting object that isn't resolved yet ${objId}.`);
                        return obj.data;
                    }
                    has(objId) {
                        const obj = this.#objs[objId];
                        return obj?.capability.settled || false;
                    }
                    resolve(objId, data = null) {
                        const obj = this.#ensureObj(objId);
                        obj.data = data;
                        obj.capability.resolve();
                    }
                    clear() {
                        for(const objId in this.#objs){
                            const { data } = this.#objs[objId];
                            data?.bitmap?.close();
                        }
                        this.#objs = Object.create(null);
                    }
                }
                class RenderTask {
                    #internalRenderTask = null;
                    constructor(internalRenderTask){
                        this.#internalRenderTask = internalRenderTask;
                        this.onContinue = null;
                    }
                    get promise() {
                        return this.#internalRenderTask.capability.promise;
                    }
                    cancel(extraDelay = 0) {
                        this.#internalRenderTask.cancel(null, extraDelay);
                    }
                    get separateAnnots() {
                        const { separateAnnots } = this.#internalRenderTask.operatorList;
                        if (!separateAnnots) return false;
                        const { annotationCanvasMap } = this.#internalRenderTask;
                        return separateAnnots.form || separateAnnots.canvas && annotationCanvasMap?.size > 0;
                    }
                }
                exports.RenderTask = RenderTask;
                class InternalRenderTask {
                    static #canvasInUse = new WeakSet();
                    constructor({ callback, params, objs, commonObjs, annotationCanvasMap, operatorList, pageIndex, canvasFactory, filterFactory, useRequestAnimationFrame = false, pdfBug = false, pageColors = null }){
                        this.callback = callback;
                        this.params = params;
                        this.objs = objs;
                        this.commonObjs = commonObjs;
                        this.annotationCanvasMap = annotationCanvasMap;
                        this.operatorListIdx = null;
                        this.operatorList = operatorList;
                        this._pageIndex = pageIndex;
                        this.canvasFactory = canvasFactory;
                        this.filterFactory = filterFactory;
                        this._pdfBug = pdfBug;
                        this.pageColors = pageColors;
                        this.running = false;
                        this.graphicsReadyCallback = null;
                        this.graphicsReady = false;
                        this._useRequestAnimationFrame = useRequestAnimationFrame === true && typeof window !== "undefined";
                        this.cancelled = false;
                        this.capability = new _util.PromiseCapability();
                        this.task = new RenderTask(this);
                        this._cancelBound = this.cancel.bind(this);
                        this._continueBound = this._continue.bind(this);
                        this._scheduleNextBound = this._scheduleNext.bind(this);
                        this._nextBound = this._next.bind(this);
                        this._canvas = params.canvasContext.canvas;
                    }
                    get completed() {
                        return this.capability.promise.catch(function() {});
                    }
                    initializeGraphics({ transparency = false, optionalContentConfig }) {
                        if (this.cancelled) return;
                        if (this._canvas) {
                            if (InternalRenderTask.#canvasInUse.has(this._canvas)) throw new Error("Cannot use the same canvas during multiple render() operations. Use different canvas or ensure previous operations were cancelled or completed.");
                            InternalRenderTask.#canvasInUse.add(this._canvas);
                        }
                        if (this._pdfBug && globalThis.StepperManager?.enabled) {
                            this.stepper = globalThis.StepperManager.create(this._pageIndex);
                            this.stepper.init(this.operatorList);
                            this.stepper.nextBreakPoint = this.stepper.getNextBreakPoint();
                        }
                        const { canvasContext, viewport, transform, background } = this.params;
                        this.gfx = new _canvas.CanvasGraphics(canvasContext, this.commonObjs, this.objs, this.canvasFactory, this.filterFactory, {
                            optionalContentConfig: optionalContentConfig
                        }, this.annotationCanvasMap, this.pageColors);
                        this.gfx.beginDrawing({
                            transform: transform,
                            viewport: viewport,
                            transparency: transparency,
                            background: background
                        });
                        this.operatorListIdx = 0;
                        this.graphicsReady = true;
                        this.graphicsReadyCallback?.();
                    }
                    cancel(error = null, extraDelay = 0) {
                        this.running = false;
                        this.cancelled = true;
                        this.gfx?.endDrawing();
                        InternalRenderTask.#canvasInUse.delete(this._canvas);
                        this.callback(error || new _display_utils.RenderingCancelledException(`Rendering cancelled, page ${this._pageIndex + 1}`, extraDelay));
                    }
                    operatorListChanged() {
                        if (!this.graphicsReady) {
                            this.graphicsReadyCallback ||= this._continueBound;
                            return;
                        }
                        this.stepper?.updateOperatorList(this.operatorList);
                        if (this.running) return;
                        this._continue();
                    }
                    _continue() {
                        this.running = true;
                        if (this.cancelled) return;
                        if (this.task.onContinue) this.task.onContinue(this._scheduleNextBound);
                        else this._scheduleNext();
                    }
                    _scheduleNext() {
                        if (this._useRequestAnimationFrame) window.requestAnimationFrame(()=>{
                            this._nextBound().catch(this._cancelBound);
                        });
                        else Promise.resolve().then(this._nextBound).catch(this._cancelBound);
                    }
                    async _next() {
                        if (this.cancelled) return;
                        this.operatorListIdx = this.gfx.executeOperatorList(this.operatorList, this.operatorListIdx, this._continueBound, this.stepper);
                        if (this.operatorListIdx === this.operatorList.argsArray.length) {
                            this.running = false;
                            if (this.operatorList.lastChunk) {
                                this.gfx.endDrawing();
                                InternalRenderTask.#canvasInUse.delete(this._canvas);
                                this.callback();
                            }
                        }
                    }
                }
                const version = "3.11.174";
                exports.version = version;
                const build = "ce8716743";
                exports.build = build;
            /***/ },
            /* 3 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.SerializableEmpty = exports.PrintAnnotationStorage = exports.AnnotationStorage = void 0;
                var _util = __w_pdfjs_require__(1);
                var _editor = __w_pdfjs_require__(4);
                var _murmurhash = __w_pdfjs_require__(8);
                const SerializableEmpty = Object.freeze({
                    map: null,
                    hash: "",
                    transfers: undefined
                });
                exports.SerializableEmpty = SerializableEmpty;
                class AnnotationStorage {
                    #modified = false;
                    #storage = new Map();
                    constructor(){
                        this.onSetModified = null;
                        this.onResetModified = null;
                        this.onAnnotationEditor = null;
                    }
                    getValue(key, defaultValue) {
                        const value = this.#storage.get(key);
                        if (value === undefined) return defaultValue;
                        return Object.assign(defaultValue, value);
                    }
                    getRawValue(key) {
                        return this.#storage.get(key);
                    }
                    remove(key) {
                        this.#storage.delete(key);
                        if (this.#storage.size === 0) this.resetModified();
                        if (typeof this.onAnnotationEditor === "function") {
                            for (const value of this.#storage.values()){
                                if (value instanceof _editor.AnnotationEditor) return;
                            }
                            this.onAnnotationEditor(null);
                        }
                    }
                    setValue(key, value) {
                        const obj = this.#storage.get(key);
                        let modified = false;
                        if (obj !== undefined) {
                            for (const [entry, val] of Object.entries(value))if (obj[entry] !== val) {
                                modified = true;
                                obj[entry] = val;
                            }
                        } else {
                            modified = true;
                            this.#storage.set(key, value);
                        }
                        if (modified) this.#setModified();
                        if (value instanceof _editor.AnnotationEditor && typeof this.onAnnotationEditor === "function") this.onAnnotationEditor(value.constructor._type);
                    }
                    has(key) {
                        return this.#storage.has(key);
                    }
                    getAll() {
                        return this.#storage.size > 0 ? (0, _util.objectFromMap)(this.#storage) : null;
                    }
                    setAll(obj) {
                        for (const [key, val] of Object.entries(obj))this.setValue(key, val);
                    }
                    get size() {
                        return this.#storage.size;
                    }
                    #setModified() {
                        if (!this.#modified) {
                            this.#modified = true;
                            if (typeof this.onSetModified === "function") this.onSetModified();
                        }
                    }
                    resetModified() {
                        if (this.#modified) {
                            this.#modified = false;
                            if (typeof this.onResetModified === "function") this.onResetModified();
                        }
                    }
                    get print() {
                        return new PrintAnnotationStorage(this);
                    }
                    get serializable() {
                        if (this.#storage.size === 0) return SerializableEmpty;
                        const map = new Map(), hash = new _murmurhash.MurmurHash3_64(), transfers = [];
                        const context = Object.create(null);
                        let hasBitmap = false;
                        for (const [key, val] of this.#storage){
                            const serialized = val instanceof _editor.AnnotationEditor ? val.serialize(false, context) : val;
                            if (serialized) {
                                map.set(key, serialized);
                                hash.update(`${key}:${JSON.stringify(serialized)}`);
                                hasBitmap ||= !!serialized.bitmap;
                            }
                        }
                        if (hasBitmap) {
                            for (const value of map.values())if (value.bitmap) transfers.push(value.bitmap);
                        }
                        return map.size > 0 ? {
                            map: map,
                            hash: hash.hexdigest(),
                            transfers: transfers
                        } : SerializableEmpty;
                    }
                }
                exports.AnnotationStorage = AnnotationStorage;
                class PrintAnnotationStorage extends AnnotationStorage {
                    #serializable;
                    constructor(parent){
                        super();
                        const { map, hash, transfers } = parent.serializable;
                        const clone = structuredClone(map, transfers ? {
                            transfer: transfers
                        } : null);
                        this.#serializable = {
                            map: clone,
                            hash: hash,
                            transfers: transfers
                        };
                    }
                    get print() {
                        (0, _util.unreachable)("Should not call PrintAnnotationStorage.print");
                    }
                    get serializable() {
                        return this.#serializable;
                    }
                }
                exports.PrintAnnotationStorage = PrintAnnotationStorage;
            /***/ },
            /* 4 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.AnnotationEditor = void 0;
                var _tools = __w_pdfjs_require__(5);
                var _util = __w_pdfjs_require__(1);
                var _display_utils = __w_pdfjs_require__(6);
                class AnnotationEditor {
                    #altText = "";
                    #altTextDecorative = false;
                    #altTextButton = null;
                    #altTextTooltip = null;
                    #altTextTooltipTimeout = null;
                    #keepAspectRatio = false;
                    #resizersDiv = null;
                    #boundFocusin = this.focusin.bind(this);
                    #boundFocusout = this.focusout.bind(this);
                    #hasBeenClicked = false;
                    #isEditing = false;
                    #isInEditMode = false;
                    _initialOptions = Object.create(null);
                    _uiManager = null;
                    _focusEventsAllowed = true;
                    _l10nPromise = null;
                    #isDraggable = false;
                    #zIndex = AnnotationEditor._zIndex++;
                    static _borderLineWidth = -1;
                    static _colorManager = new _tools.ColorManager();
                    static _zIndex = 1;
                    static SMALL_EDITOR_SIZE = 0;
                    constructor(parameters){
                        if (this.constructor === AnnotationEditor) (0, _util.unreachable)("Cannot initialize AnnotationEditor.");
                        this.parent = parameters.parent;
                        this.id = parameters.id;
                        this.width = this.height = null;
                        this.pageIndex = parameters.parent.pageIndex;
                        this.name = parameters.name;
                        this.div = null;
                        this._uiManager = parameters.uiManager;
                        this.annotationElementId = null;
                        this._willKeepAspectRatio = false;
                        this._initialOptions.isCentered = parameters.isCentered;
                        this._structTreeParentId = null;
                        const { rotation, rawDims: { pageWidth, pageHeight, pageX, pageY } } = this.parent.viewport;
                        this.rotation = rotation;
                        this.pageRotation = (360 + rotation - this._uiManager.viewParameters.rotation) % 360;
                        this.pageDimensions = [
                            pageWidth,
                            pageHeight
                        ];
                        this.pageTranslation = [
                            pageX,
                            pageY
                        ];
                        const [width, height] = this.parentDimensions;
                        this.x = parameters.x / width;
                        this.y = parameters.y / height;
                        this.isAttachedToDOM = false;
                        this.deleted = false;
                    }
                    get editorType() {
                        return Object.getPrototypeOf(this).constructor._type;
                    }
                    static get _defaultLineColor() {
                        return (0, _util.shadow)(this, "_defaultLineColor", this._colorManager.getHexCode("CanvasText"));
                    }
                    static deleteAnnotationElement(editor) {
                        const fakeEditor = new FakeEditor({
                            id: editor.parent.getNextId(),
                            parent: editor.parent,
                            uiManager: editor._uiManager
                        });
                        fakeEditor.annotationElementId = editor.annotationElementId;
                        fakeEditor.deleted = true;
                        fakeEditor._uiManager.addToAnnotationStorage(fakeEditor);
                    }
                    static initialize(l10n, options = null) {
                        AnnotationEditor._l10nPromise ||= new Map([
                            "editor_alt_text_button_label",
                            "editor_alt_text_edit_button_label",
                            "editor_alt_text_decorative_tooltip"
                        ].map((str)=>[
                                str,
                                l10n.get(str)
                            ]));
                        if (options?.strings) for (const str of options.strings)AnnotationEditor._l10nPromise.set(str, l10n.get(str));
                        if (AnnotationEditor._borderLineWidth !== -1) return;
                        const style = getComputedStyle(document.documentElement);
                        AnnotationEditor._borderLineWidth = parseFloat(style.getPropertyValue("--outline-width")) || 0;
                    }
                    static updateDefaultParams(_type, _value) {}
                    static get defaultPropertiesToUpdate() {
                        return [];
                    }
                    static isHandlingMimeForPasting(mime) {
                        return false;
                    }
                    static paste(item, parent) {
                        (0, _util.unreachable)("Not implemented");
                    }
                    get propertiesToUpdate() {
                        return [];
                    }
                    get _isDraggable() {
                        return this.#isDraggable;
                    }
                    set _isDraggable(value) {
                        this.#isDraggable = value;
                        this.div?.classList.toggle("draggable", value);
                    }
                    center() {
                        const [pageWidth, pageHeight] = this.pageDimensions;
                        switch(this.parentRotation){
                            case 90:
                                this.x -= this.height * pageHeight / (pageWidth * 2);
                                this.y += this.width * pageWidth / (pageHeight * 2);
                                break;
                            case 180:
                                this.x += this.width / 2;
                                this.y += this.height / 2;
                                break;
                            case 270:
                                this.x += this.height * pageHeight / (pageWidth * 2);
                                this.y -= this.width * pageWidth / (pageHeight * 2);
                                break;
                            default:
                                this.x -= this.width / 2;
                                this.y -= this.height / 2;
                                break;
                        }
                        this.fixAndSetPosition();
                    }
                    addCommands(params) {
                        this._uiManager.addCommands(params);
                    }
                    get currentLayer() {
                        return this._uiManager.currentLayer;
                    }
                    setInBackground() {
                        this.div.style.zIndex = 0;
                    }
                    setInForeground() {
                        this.div.style.zIndex = this.#zIndex;
                    }
                    setParent(parent) {
                        if (parent !== null) {
                            this.pageIndex = parent.pageIndex;
                            this.pageDimensions = parent.pageDimensions;
                        }
                        this.parent = parent;
                    }
                    focusin(event) {
                        if (!this._focusEventsAllowed) return;
                        if (!this.#hasBeenClicked) this.parent.setSelected(this);
                        else this.#hasBeenClicked = false;
                    }
                    focusout(event) {
                        if (!this._focusEventsAllowed) return;
                        if (!this.isAttachedToDOM) return;
                        const target = event.relatedTarget;
                        if (target?.closest(`#${this.id}`)) return;
                        event.preventDefault();
                        if (!this.parent?.isMultipleSelection) this.commitOrRemove();
                    }
                    commitOrRemove() {
                        if (this.isEmpty()) this.remove();
                        else this.commit();
                    }
                    commit() {
                        this.addToAnnotationStorage();
                    }
                    addToAnnotationStorage() {
                        this._uiManager.addToAnnotationStorage(this);
                    }
                    setAt(x, y, tx, ty) {
                        const [width, height] = this.parentDimensions;
                        [tx, ty] = this.screenToPageTranslation(tx, ty);
                        this.x = (x + tx) / width;
                        this.y = (y + ty) / height;
                        this.fixAndSetPosition();
                    }
                    #translate([width, height], x, y) {
                        [x, y] = this.screenToPageTranslation(x, y);
                        this.x += x / width;
                        this.y += y / height;
                        this.fixAndSetPosition();
                    }
                    translate(x, y) {
                        this.#translate(this.parentDimensions, x, y);
                    }
                    translateInPage(x, y) {
                        this.#translate(this.pageDimensions, x, y);
                        this.div.scrollIntoView({
                            block: "nearest"
                        });
                    }
                    drag(tx, ty) {
                        const [parentWidth, parentHeight] = this.parentDimensions;
                        this.x += tx / parentWidth;
                        this.y += ty / parentHeight;
                        if (this.parent && (this.x < 0 || this.x > 1 || this.y < 0 || this.y > 1)) {
                            const { x, y } = this.div.getBoundingClientRect();
                            if (this.parent.findNewParent(this, x, y)) {
                                this.x -= Math.floor(this.x);
                                this.y -= Math.floor(this.y);
                            }
                        }
                        let { x, y } = this;
                        const [bx, by] = this.#getBaseTranslation();
                        x += bx;
                        y += by;
                        this.div.style.left = `${(100 * x).toFixed(2)}%`;
                        this.div.style.top = `${(100 * y).toFixed(2)}%`;
                        this.div.scrollIntoView({
                            block: "nearest"
                        });
                    }
                    #getBaseTranslation() {
                        const [parentWidth, parentHeight] = this.parentDimensions;
                        const { _borderLineWidth } = AnnotationEditor;
                        const x = _borderLineWidth / parentWidth;
                        const y = _borderLineWidth / parentHeight;
                        switch(this.rotation){
                            case 90:
                                return [
                                    -x,
                                    y
                                ];
                            case 180:
                                return [
                                    x,
                                    y
                                ];
                            case 270:
                                return [
                                    x,
                                    -y
                                ];
                            default:
                                return [
                                    -x,
                                    -y
                                ];
                        }
                    }
                    fixAndSetPosition() {
                        const [pageWidth, pageHeight] = this.pageDimensions;
                        let { x, y, width, height } = this;
                        width *= pageWidth;
                        height *= pageHeight;
                        x *= pageWidth;
                        y *= pageHeight;
                        switch(this.rotation){
                            case 0:
                                x = Math.max(0, Math.min(pageWidth - width, x));
                                y = Math.max(0, Math.min(pageHeight - height, y));
                                break;
                            case 90:
                                x = Math.max(0, Math.min(pageWidth - height, x));
                                y = Math.min(pageHeight, Math.max(width, y));
                                break;
                            case 180:
                                x = Math.min(pageWidth, Math.max(width, x));
                                y = Math.min(pageHeight, Math.max(height, y));
                                break;
                            case 270:
                                x = Math.min(pageWidth, Math.max(height, x));
                                y = Math.max(0, Math.min(pageHeight - width, y));
                                break;
                        }
                        this.x = x /= pageWidth;
                        this.y = y /= pageHeight;
                        const [bx, by] = this.#getBaseTranslation();
                        x += bx;
                        y += by;
                        const { style } = this.div;
                        style.left = `${(100 * x).toFixed(2)}%`;
                        style.top = `${(100 * y).toFixed(2)}%`;
                        this.moveInDOM();
                    }
                    static #rotatePoint(x, y, angle) {
                        switch(angle){
                            case 90:
                                return [
                                    y,
                                    -x
                                ];
                            case 180:
                                return [
                                    -x,
                                    -y
                                ];
                            case 270:
                                return [
                                    -y,
                                    x
                                ];
                            default:
                                return [
                                    x,
                                    y
                                ];
                        }
                    }
                    screenToPageTranslation(x, y) {
                        return AnnotationEditor.#rotatePoint(x, y, this.parentRotation);
                    }
                    pageTranslationToScreen(x, y) {
                        return AnnotationEditor.#rotatePoint(x, y, 360 - this.parentRotation);
                    }
                    #getRotationMatrix(rotation) {
                        switch(rotation){
                            case 90:
                                {
                                    const [pageWidth, pageHeight] = this.pageDimensions;
                                    return [
                                        0,
                                        -pageWidth / pageHeight,
                                        pageHeight / pageWidth,
                                        0
                                    ];
                                }
                            case 180:
                                return [
                                    -1,
                                    0,
                                    0,
                                    -1
                                ];
                            case 270:
                                {
                                    const [pageWidth, pageHeight] = this.pageDimensions;
                                    return [
                                        0,
                                        pageWidth / pageHeight,
                                        -pageHeight / pageWidth,
                                        0
                                    ];
                                }
                            default:
                                return [
                                    1,
                                    0,
                                    0,
                                    1
                                ];
                        }
                    }
                    get parentScale() {
                        return this._uiManager.viewParameters.realScale;
                    }
                    get parentRotation() {
                        return (this._uiManager.viewParameters.rotation + this.pageRotation) % 360;
                    }
                    get parentDimensions() {
                        const { parentScale, pageDimensions: [pageWidth, pageHeight] } = this;
                        const scaledWidth = pageWidth * parentScale;
                        const scaledHeight = pageHeight * parentScale;
                        return _util.FeatureTest.isCSSRoundSupported ? [
                            Math.round(scaledWidth),
                            Math.round(scaledHeight)
                        ] : [
                            scaledWidth,
                            scaledHeight
                        ];
                    }
                    setDims(width, height) {
                        const [parentWidth, parentHeight] = this.parentDimensions;
                        this.div.style.width = `${(100 * width / parentWidth).toFixed(2)}%`;
                        if (!this.#keepAspectRatio) this.div.style.height = `${(100 * height / parentHeight).toFixed(2)}%`;
                        this.#altTextButton?.classList.toggle("small", width < AnnotationEditor.SMALL_EDITOR_SIZE || height < AnnotationEditor.SMALL_EDITOR_SIZE);
                    }
                    fixDims() {
                        const { style } = this.div;
                        const { height, width } = style;
                        const widthPercent = width.endsWith("%");
                        const heightPercent = !this.#keepAspectRatio && height.endsWith("%");
                        if (widthPercent && heightPercent) return;
                        const [parentWidth, parentHeight] = this.parentDimensions;
                        if (!widthPercent) style.width = `${(100 * parseFloat(width) / parentWidth).toFixed(2)}%`;
                        if (!this.#keepAspectRatio && !heightPercent) style.height = `${(100 * parseFloat(height) / parentHeight).toFixed(2)}%`;
                    }
                    getInitialTranslation() {
                        return [
                            0,
                            0
                        ];
                    }
                    #createResizers() {
                        if (this.#resizersDiv) return;
                        this.#resizersDiv = document.createElement("div");
                        this.#resizersDiv.classList.add("resizers");
                        const classes = [
                            "topLeft",
                            "topRight",
                            "bottomRight",
                            "bottomLeft"
                        ];
                        if (!this._willKeepAspectRatio) classes.push("topMiddle", "middleRight", "bottomMiddle", "middleLeft");
                        for (const name of classes){
                            const div = document.createElement("div");
                            this.#resizersDiv.append(div);
                            div.classList.add("resizer", name);
                            div.addEventListener("pointerdown", this.#resizerPointerdown.bind(this, name));
                            div.addEventListener("contextmenu", _display_utils.noContextMenu);
                        }
                        this.div.prepend(this.#resizersDiv);
                    }
                    #resizerPointerdown(name, event) {
                        event.preventDefault();
                        const { isMac } = _util.FeatureTest.platform;
                        if (event.button !== 0 || event.ctrlKey && isMac) return;
                        const boundResizerPointermove = this.#resizerPointermove.bind(this, name);
                        const savedDraggable = this._isDraggable;
                        this._isDraggable = false;
                        const pointerMoveOptions = {
                            passive: true,
                            capture: true
                        };
                        window.addEventListener("pointermove", boundResizerPointermove, pointerMoveOptions);
                        const savedX = this.x;
                        const savedY = this.y;
                        const savedWidth = this.width;
                        const savedHeight = this.height;
                        const savedParentCursor = this.parent.div.style.cursor;
                        const savedCursor = this.div.style.cursor;
                        this.div.style.cursor = this.parent.div.style.cursor = window.getComputedStyle(event.target).cursor;
                        const pointerUpCallback = ()=>{
                            this._isDraggable = savedDraggable;
                            window.removeEventListener("pointerup", pointerUpCallback);
                            window.removeEventListener("blur", pointerUpCallback);
                            window.removeEventListener("pointermove", boundResizerPointermove, pointerMoveOptions);
                            this.parent.div.style.cursor = savedParentCursor;
                            this.div.style.cursor = savedCursor;
                            const newX = this.x;
                            const newY = this.y;
                            const newWidth = this.width;
                            const newHeight = this.height;
                            if (newX === savedX && newY === savedY && newWidth === savedWidth && newHeight === savedHeight) return;
                            this.addCommands({
                                cmd: ()=>{
                                    this.width = newWidth;
                                    this.height = newHeight;
                                    this.x = newX;
                                    this.y = newY;
                                    const [parentWidth, parentHeight] = this.parentDimensions;
                                    this.setDims(parentWidth * newWidth, parentHeight * newHeight);
                                    this.fixAndSetPosition();
                                },
                                undo: ()=>{
                                    this.width = savedWidth;
                                    this.height = savedHeight;
                                    this.x = savedX;
                                    this.y = savedY;
                                    const [parentWidth, parentHeight] = this.parentDimensions;
                                    this.setDims(parentWidth * savedWidth, parentHeight * savedHeight);
                                    this.fixAndSetPosition();
                                },
                                mustExec: true
                            });
                        };
                        window.addEventListener("pointerup", pointerUpCallback);
                        window.addEventListener("blur", pointerUpCallback);
                    }
                    #resizerPointermove(name, event) {
                        const [parentWidth, parentHeight] = this.parentDimensions;
                        const savedX = this.x;
                        const savedY = this.y;
                        const savedWidth = this.width;
                        const savedHeight = this.height;
                        const minWidth = AnnotationEditor.MIN_SIZE / parentWidth;
                        const minHeight = AnnotationEditor.MIN_SIZE / parentHeight;
                        const round = (x)=>Math.round(x * 10000) / 10000;
                        const rotationMatrix = this.#getRotationMatrix(this.rotation);
                        const transf = (x, y)=>[
                                rotationMatrix[0] * x + rotationMatrix[2] * y,
                                rotationMatrix[1] * x + rotationMatrix[3] * y
                            ];
                        const invRotationMatrix = this.#getRotationMatrix(360 - this.rotation);
                        const invTransf = (x, y)=>[
                                invRotationMatrix[0] * x + invRotationMatrix[2] * y,
                                invRotationMatrix[1] * x + invRotationMatrix[3] * y
                            ];
                        let getPoint;
                        let getOpposite;
                        let isDiagonal = false;
                        let isHorizontal = false;
                        switch(name){
                            case "topLeft":
                                isDiagonal = true;
                                getPoint = (w, h)=>[
                                        0,
                                        0
                                    ];
                                getOpposite = (w, h)=>[
                                        w,
                                        h
                                    ];
                                break;
                            case "topMiddle":
                                getPoint = (w, h)=>[
                                        w / 2,
                                        0
                                    ];
                                getOpposite = (w, h)=>[
                                        w / 2,
                                        h
                                    ];
                                break;
                            case "topRight":
                                isDiagonal = true;
                                getPoint = (w, h)=>[
                                        w,
                                        0
                                    ];
                                getOpposite = (w, h)=>[
                                        0,
                                        h
                                    ];
                                break;
                            case "middleRight":
                                isHorizontal = true;
                                getPoint = (w, h)=>[
                                        w,
                                        h / 2
                                    ];
                                getOpposite = (w, h)=>[
                                        0,
                                        h / 2
                                    ];
                                break;
                            case "bottomRight":
                                isDiagonal = true;
                                getPoint = (w, h)=>[
                                        w,
                                        h
                                    ];
                                getOpposite = (w, h)=>[
                                        0,
                                        0
                                    ];
                                break;
                            case "bottomMiddle":
                                getPoint = (w, h)=>[
                                        w / 2,
                                        h
                                    ];
                                getOpposite = (w, h)=>[
                                        w / 2,
                                        0
                                    ];
                                break;
                            case "bottomLeft":
                                isDiagonal = true;
                                getPoint = (w, h)=>[
                                        0,
                                        h
                                    ];
                                getOpposite = (w, h)=>[
                                        w,
                                        0
                                    ];
                                break;
                            case "middleLeft":
                                isHorizontal = true;
                                getPoint = (w, h)=>[
                                        0,
                                        h / 2
                                    ];
                                getOpposite = (w, h)=>[
                                        w,
                                        h / 2
                                    ];
                                break;
                        }
                        const point = getPoint(savedWidth, savedHeight);
                        const oppositePoint = getOpposite(savedWidth, savedHeight);
                        let transfOppositePoint = transf(...oppositePoint);
                        const oppositeX = round(savedX + transfOppositePoint[0]);
                        const oppositeY = round(savedY + transfOppositePoint[1]);
                        let ratioX = 1;
                        let ratioY = 1;
                        let [deltaX, deltaY] = this.screenToPageTranslation(event.movementX, event.movementY);
                        [deltaX, deltaY] = invTransf(deltaX / parentWidth, deltaY / parentHeight);
                        if (isDiagonal) {
                            const oldDiag = Math.hypot(savedWidth, savedHeight);
                            ratioX = ratioY = Math.max(Math.min(Math.hypot(oppositePoint[0] - point[0] - deltaX, oppositePoint[1] - point[1] - deltaY) / oldDiag, 1 / savedWidth, 1 / savedHeight), minWidth / savedWidth, minHeight / savedHeight);
                        } else if (isHorizontal) ratioX = Math.max(minWidth, Math.min(1, Math.abs(oppositePoint[0] - point[0] - deltaX))) / savedWidth;
                        else ratioY = Math.max(minHeight, Math.min(1, Math.abs(oppositePoint[1] - point[1] - deltaY))) / savedHeight;
                        const newWidth = round(savedWidth * ratioX);
                        const newHeight = round(savedHeight * ratioY);
                        transfOppositePoint = transf(...getOpposite(newWidth, newHeight));
                        const newX = oppositeX - transfOppositePoint[0];
                        const newY = oppositeY - transfOppositePoint[1];
                        this.width = newWidth;
                        this.height = newHeight;
                        this.x = newX;
                        this.y = newY;
                        this.setDims(parentWidth * newWidth, parentHeight * newHeight);
                        this.fixAndSetPosition();
                    }
                    async addAltTextButton() {
                        if (this.#altTextButton) return;
                        const altText = this.#altTextButton = document.createElement("button");
                        altText.className = "altText";
                        const msg = await AnnotationEditor._l10nPromise.get("editor_alt_text_button_label");
                        altText.textContent = msg;
                        altText.setAttribute("aria-label", msg);
                        altText.tabIndex = "0";
                        altText.addEventListener("contextmenu", _display_utils.noContextMenu);
                        altText.addEventListener("pointerdown", (event)=>event.stopPropagation());
                        altText.addEventListener("click", (event)=>{
                            event.preventDefault();
                            this._uiManager.editAltText(this);
                        }, {
                            capture: true
                        });
                        altText.addEventListener("keydown", (event)=>{
                            if (event.target === altText && event.key === "Enter") {
                                event.preventDefault();
                                this._uiManager.editAltText(this);
                            }
                        });
                        this.#setAltTextButtonState();
                        this.div.append(altText);
                        if (!AnnotationEditor.SMALL_EDITOR_SIZE) {
                            const PERCENT = 40;
                            AnnotationEditor.SMALL_EDITOR_SIZE = Math.min(128, Math.round(altText.getBoundingClientRect().width * (1 + PERCENT / 100)));
                        }
                    }
                    async #setAltTextButtonState() {
                        const button = this.#altTextButton;
                        if (!button) return;
                        if (!this.#altText && !this.#altTextDecorative) {
                            button.classList.remove("done");
                            this.#altTextTooltip?.remove();
                            return;
                        }
                        AnnotationEditor._l10nPromise.get("editor_alt_text_edit_button_label").then((msg)=>{
                            button.setAttribute("aria-label", msg);
                        });
                        let tooltip = this.#altTextTooltip;
                        if (!tooltip) {
                            this.#altTextTooltip = tooltip = document.createElement("span");
                            tooltip.className = "tooltip";
                            tooltip.setAttribute("role", "tooltip");
                            const id = tooltip.id = `alt-text-tooltip-${this.id}`;
                            button.setAttribute("aria-describedby", id);
                            const DELAY_TO_SHOW_TOOLTIP = 100;
                            button.addEventListener("mouseenter", ()=>{
                                this.#altTextTooltipTimeout = setTimeout(()=>{
                                    this.#altTextTooltipTimeout = null;
                                    this.#altTextTooltip.classList.add("show");
                                    this._uiManager._eventBus.dispatch("reporttelemetry", {
                                        source: this,
                                        details: {
                                            type: "editing",
                                            subtype: this.editorType,
                                            data: {
                                                action: "alt_text_tooltip"
                                            }
                                        }
                                    });
                                }, DELAY_TO_SHOW_TOOLTIP);
                            });
                            button.addEventListener("mouseleave", ()=>{
                                clearTimeout(this.#altTextTooltipTimeout);
                                this.#altTextTooltipTimeout = null;
                                this.#altTextTooltip?.classList.remove("show");
                            });
                        }
                        button.classList.add("done");
                        tooltip.innerText = this.#altTextDecorative ? await AnnotationEditor._l10nPromise.get("editor_alt_text_decorative_tooltip") : this.#altText;
                        if (!tooltip.parentNode) button.append(tooltip);
                    }
                    getClientDimensions() {
                        return this.div.getBoundingClientRect();
                    }
                    get altTextData() {
                        return {
                            altText: this.#altText,
                            decorative: this.#altTextDecorative
                        };
                    }
                    set altTextData({ altText, decorative }) {
                        if (this.#altText === altText && this.#altTextDecorative === decorative) return;
                        this.#altText = altText;
                        this.#altTextDecorative = decorative;
                        this.#setAltTextButtonState();
                    }
                    render() {
                        this.div = document.createElement("div");
                        this.div.setAttribute("data-editor-rotation", (360 - this.rotation) % 360);
                        this.div.className = this.name;
                        this.div.setAttribute("id", this.id);
                        this.div.setAttribute("tabIndex", 0);
                        this.setInForeground();
                        this.div.addEventListener("focusin", this.#boundFocusin);
                        this.div.addEventListener("focusout", this.#boundFocusout);
                        const [parentWidth, parentHeight] = this.parentDimensions;
                        if (this.parentRotation % 180 !== 0) {
                            this.div.style.maxWidth = `${(100 * parentHeight / parentWidth).toFixed(2)}%`;
                            this.div.style.maxHeight = `${(100 * parentWidth / parentHeight).toFixed(2)}%`;
                        }
                        const [tx, ty] = this.getInitialTranslation();
                        this.translate(tx, ty);
                        (0, _tools.bindEvents)(this, this.div, [
                            "pointerdown"
                        ]);
                        return this.div;
                    }
                    pointerdown(event) {
                        const { isMac } = _util.FeatureTest.platform;
                        if (event.button !== 0 || event.ctrlKey && isMac) {
                            event.preventDefault();
                            return;
                        }
                        this.#hasBeenClicked = true;
                        this.#setUpDragSession(event);
                    }
                    #setUpDragSession(event) {
                        if (!this._isDraggable) return;
                        const isSelected = this._uiManager.isSelected(this);
                        this._uiManager.setUpDragSession();
                        let pointerMoveOptions, pointerMoveCallback;
                        if (isSelected) {
                            pointerMoveOptions = {
                                passive: true,
                                capture: true
                            };
                            pointerMoveCallback = (e)=>{
                                const [tx, ty] = this.screenToPageTranslation(e.movementX, e.movementY);
                                this._uiManager.dragSelectedEditors(tx, ty);
                            };
                            window.addEventListener("pointermove", pointerMoveCallback, pointerMoveOptions);
                        }
                        const pointerUpCallback = ()=>{
                            window.removeEventListener("pointerup", pointerUpCallback);
                            window.removeEventListener("blur", pointerUpCallback);
                            if (isSelected) window.removeEventListener("pointermove", pointerMoveCallback, pointerMoveOptions);
                            this.#hasBeenClicked = false;
                            if (!this._uiManager.endDragSession()) {
                                const { isMac } = _util.FeatureTest.platform;
                                if (event.ctrlKey && !isMac || event.shiftKey || event.metaKey && isMac) this.parent.toggleSelected(this);
                                else this.parent.setSelected(this);
                            }
                        };
                        window.addEventListener("pointerup", pointerUpCallback);
                        window.addEventListener("blur", pointerUpCallback);
                    }
                    moveInDOM() {
                        this.parent?.moveEditorInDOM(this);
                    }
                    _setParentAndPosition(parent, x, y) {
                        parent.changeParent(this);
                        this.x = x;
                        this.y = y;
                        this.fixAndSetPosition();
                    }
                    getRect(tx, ty) {
                        const scale = this.parentScale;
                        const [pageWidth, pageHeight] = this.pageDimensions;
                        const [pageX, pageY] = this.pageTranslation;
                        const shiftX = tx / scale;
                        const shiftY = ty / scale;
                        const x = this.x * pageWidth;
                        const y = this.y * pageHeight;
                        const width = this.width * pageWidth;
                        const height = this.height * pageHeight;
                        switch(this.rotation){
                            case 0:
                                return [
                                    x + shiftX + pageX,
                                    pageHeight - y - shiftY - height + pageY,
                                    x + shiftX + width + pageX,
                                    pageHeight - y - shiftY + pageY
                                ];
                            case 90:
                                return [
                                    x + shiftY + pageX,
                                    pageHeight - y + shiftX + pageY,
                                    x + shiftY + height + pageX,
                                    pageHeight - y + shiftX + width + pageY
                                ];
                            case 180:
                                return [
                                    x - shiftX - width + pageX,
                                    pageHeight - y + shiftY + pageY,
                                    x - shiftX + pageX,
                                    pageHeight - y + shiftY + height + pageY
                                ];
                            case 270:
                                return [
                                    x - shiftY - height + pageX,
                                    pageHeight - y - shiftX - width + pageY,
                                    x - shiftY + pageX,
                                    pageHeight - y - shiftX + pageY
                                ];
                            default:
                                throw new Error("Invalid rotation");
                        }
                    }
                    getRectInCurrentCoords(rect, pageHeight) {
                        const [x1, y1, x2, y2] = rect;
                        const width = x2 - x1;
                        const height = y2 - y1;
                        switch(this.rotation){
                            case 0:
                                return [
                                    x1,
                                    pageHeight - y2,
                                    width,
                                    height
                                ];
                            case 90:
                                return [
                                    x1,
                                    pageHeight - y1,
                                    height,
                                    width
                                ];
                            case 180:
                                return [
                                    x2,
                                    pageHeight - y1,
                                    width,
                                    height
                                ];
                            case 270:
                                return [
                                    x2,
                                    pageHeight - y2,
                                    height,
                                    width
                                ];
                            default:
                                throw new Error("Invalid rotation");
                        }
                    }
                    onceAdded() {}
                    isEmpty() {
                        return false;
                    }
                    enableEditMode() {
                        this.#isInEditMode = true;
                    }
                    disableEditMode() {
                        this.#isInEditMode = false;
                    }
                    isInEditMode() {
                        return this.#isInEditMode;
                    }
                    shouldGetKeyboardEvents() {
                        return false;
                    }
                    needsToBeRebuilt() {
                        return this.div && !this.isAttachedToDOM;
                    }
                    rebuild() {
                        this.div?.addEventListener("focusin", this.#boundFocusin);
                        this.div?.addEventListener("focusout", this.#boundFocusout);
                    }
                    serialize(isForCopying = false, context = null) {
                        (0, _util.unreachable)("An editor must be serializable");
                    }
                    static deserialize(data, parent, uiManager) {
                        const editor = new this.prototype.constructor({
                            parent: parent,
                            id: parent.getNextId(),
                            uiManager: uiManager
                        });
                        editor.rotation = data.rotation;
                        const [pageWidth, pageHeight] = editor.pageDimensions;
                        const [x, y, width, height] = editor.getRectInCurrentCoords(data.rect, pageHeight);
                        editor.x = x / pageWidth;
                        editor.y = y / pageHeight;
                        editor.width = width / pageWidth;
                        editor.height = height / pageHeight;
                        return editor;
                    }
                    remove() {
                        this.div.removeEventListener("focusin", this.#boundFocusin);
                        this.div.removeEventListener("focusout", this.#boundFocusout);
                        if (!this.isEmpty()) this.commit();
                        if (this.parent) this.parent.remove(this);
                        else this._uiManager.removeEditor(this);
                        this.#altTextButton?.remove();
                        this.#altTextButton = null;
                        this.#altTextTooltip = null;
                    }
                    get isResizable() {
                        return false;
                    }
                    makeResizable() {
                        if (this.isResizable) {
                            this.#createResizers();
                            this.#resizersDiv.classList.remove("hidden");
                        }
                    }
                    select() {
                        this.makeResizable();
                        this.div?.classList.add("selectedEditor");
                    }
                    unselect() {
                        this.#resizersDiv?.classList.add("hidden");
                        this.div?.classList.remove("selectedEditor");
                        if (this.div?.contains(document.activeElement)) this._uiManager.currentLayer.div.focus();
                    }
                    updateParams(type, value) {}
                    disableEditing() {
                        if (this.#altTextButton) this.#altTextButton.hidden = true;
                    }
                    enableEditing() {
                        if (this.#altTextButton) this.#altTextButton.hidden = false;
                    }
                    enterInEditMode() {}
                    get contentDiv() {
                        return this.div;
                    }
                    get isEditing() {
                        return this.#isEditing;
                    }
                    set isEditing(value) {
                        this.#isEditing = value;
                        if (!this.parent) return;
                        if (value) {
                            this.parent.setSelected(this);
                            this.parent.setActiveEditor(this);
                        } else this.parent.setActiveEditor(null);
                    }
                    setAspectRatio(width, height) {
                        this.#keepAspectRatio = true;
                        const aspectRatio = width / height;
                        const { style } = this.div;
                        style.aspectRatio = aspectRatio;
                        style.height = "auto";
                    }
                    static get MIN_SIZE() {
                        return 16;
                    }
                }
                exports.AnnotationEditor = AnnotationEditor;
                class FakeEditor extends AnnotationEditor {
                    constructor(params){
                        super(params);
                        this.annotationElementId = params.annotationElementId;
                        this.deleted = true;
                    }
                    serialize() {
                        return {
                            id: this.annotationElementId,
                            deleted: true,
                            pageIndex: this.pageIndex
                        };
                    }
                }
            /***/ },
            /* 5 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.KeyboardManager = exports.CommandManager = exports.ColorManager = exports.AnnotationEditorUIManager = void 0;
                exports.bindEvents = bindEvents;
                exports.opacityToHex = opacityToHex;
                var _util = __w_pdfjs_require__(1);
                var _display_utils = __w_pdfjs_require__(6);
                function bindEvents(obj, element, names) {
                    for (const name of names)element.addEventListener(name, obj[name].bind(obj));
                }
                function opacityToHex(opacity) {
                    return Math.round(Math.min(255, Math.max(1, 255 * opacity))).toString(16).padStart(2, "0");
                }
                class IdManager {
                    #id = 0;
                    getId() {
                        return `${_util.AnnotationEditorPrefix}${this.#id++}`;
                    }
                }
                class ImageManager {
                    #baseId = (0, _util.getUuid)();
                    #id = 0;
                    #cache = null;
                    static get _isSVGFittingCanvas() {
                        const svg = `data:image/svg+xml;charset=UTF-8,<svg viewBox="0 0 1 1" width="1" height="1" xmlns="http://www.w3.org/2000/svg"><rect width="1" height="1" style="fill:red;"/></svg>`;
                        const canvas = new OffscreenCanvas(1, 3);
                        const ctx = canvas.getContext("2d");
                        const image = new Image();
                        image.src = svg;
                        const promise = image.decode().then(()=>{
                            ctx.drawImage(image, 0, 0, 1, 1, 0, 0, 1, 3);
                            return new Uint32Array(ctx.getImageData(0, 0, 1, 1).data.buffer)[0] === 0;
                        });
                        return (0, _util.shadow)(this, "_isSVGFittingCanvas", promise);
                    }
                    async #get(key, rawData) {
                        this.#cache ||= new Map();
                        let data = this.#cache.get(key);
                        if (data === null) return null;
                        if (data?.bitmap) {
                            data.refCounter += 1;
                            return data;
                        }
                        try {
                            data ||= {
                                bitmap: null,
                                id: `image_${this.#baseId}_${this.#id++}`,
                                refCounter: 0,
                                isSvg: false
                            };
                            let image;
                            if (typeof rawData === "string") {
                                data.url = rawData;
                                const response = await fetch(rawData);
                                if (!response.ok) throw new Error(response.statusText);
                                image = await response.blob();
                            } else image = data.file = rawData;
                            if (image.type === "image/svg+xml") {
                                const mustRemoveAspectRatioPromise = ImageManager._isSVGFittingCanvas;
                                const fileReader = new FileReader();
                                const imageElement = new Image();
                                const imagePromise = new Promise((resolve, reject)=>{
                                    imageElement.onload = ()=>{
                                        data.bitmap = imageElement;
                                        data.isSvg = true;
                                        resolve();
                                    };
                                    fileReader.onload = async ()=>{
                                        const url = data.svgUrl = fileReader.result;
                                        imageElement.src = await mustRemoveAspectRatioPromise ? `${url}#svgView(preserveAspectRatio(none))` : url;
                                    };
                                    imageElement.onerror = fileReader.onerror = reject;
                                });
                                fileReader.readAsDataURL(image);
                                await imagePromise;
                            } else data.bitmap = await createImageBitmap(image);
                            data.refCounter = 1;
                        } catch (e) {
                            console.error(e);
                            data = null;
                        }
                        this.#cache.set(key, data);
                        if (data) this.#cache.set(data.id, data);
                        return data;
                    }
                    async getFromFile(file) {
                        const { lastModified, name, size, type } = file;
                        return this.#get(`${lastModified}_${name}_${size}_${type}`, file);
                    }
                    async getFromUrl(url) {
                        return this.#get(url, url);
                    }
                    async getFromId(id) {
                        this.#cache ||= new Map();
                        const data = this.#cache.get(id);
                        if (!data) return null;
                        if (data.bitmap) {
                            data.refCounter += 1;
                            return data;
                        }
                        if (data.file) return this.getFromFile(data.file);
                        return this.getFromUrl(data.url);
                    }
                    getSvgUrl(id) {
                        const data = this.#cache.get(id);
                        if (!data?.isSvg) return null;
                        return data.svgUrl;
                    }
                    deleteId(id) {
                        this.#cache ||= new Map();
                        const data = this.#cache.get(id);
                        if (!data) return;
                        data.refCounter -= 1;
                        if (data.refCounter !== 0) return;
                        data.bitmap = null;
                    }
                    isValidId(id) {
                        return id.startsWith(`image_${this.#baseId}_`);
                    }
                }
                class CommandManager {
                    #commands = [];
                    #locked = false;
                    #maxSize;
                    #position = -1;
                    constructor(maxSize = 128){
                        this.#maxSize = maxSize;
                    }
                    add({ cmd, undo, mustExec, type = NaN, overwriteIfSameType = false, keepUndo = false }) {
                        if (mustExec) cmd();
                        if (this.#locked) return;
                        const save = {
                            cmd: cmd,
                            undo: undo,
                            type: type
                        };
                        if (this.#position === -1) {
                            if (this.#commands.length > 0) this.#commands.length = 0;
                            this.#position = 0;
                            this.#commands.push(save);
                            return;
                        }
                        if (overwriteIfSameType && this.#commands[this.#position].type === type) {
                            if (keepUndo) save.undo = this.#commands[this.#position].undo;
                            this.#commands[this.#position] = save;
                            return;
                        }
                        const next = this.#position + 1;
                        if (next === this.#maxSize) this.#commands.splice(0, 1);
                        else {
                            this.#position = next;
                            if (next < this.#commands.length) this.#commands.splice(next);
                        }
                        this.#commands.push(save);
                    }
                    undo() {
                        if (this.#position === -1) return;
                        this.#locked = true;
                        this.#commands[this.#position].undo();
                        this.#locked = false;
                        this.#position -= 1;
                    }
                    redo() {
                        if (this.#position < this.#commands.length - 1) {
                            this.#position += 1;
                            this.#locked = true;
                            this.#commands[this.#position].cmd();
                            this.#locked = false;
                        }
                    }
                    hasSomethingToUndo() {
                        return this.#position !== -1;
                    }
                    hasSomethingToRedo() {
                        return this.#position < this.#commands.length - 1;
                    }
                    destroy() {
                        this.#commands = null;
                    }
                }
                exports.CommandManager = CommandManager;
                class KeyboardManager {
                    constructor(callbacks){
                        this.buffer = [];
                        this.callbacks = new Map();
                        this.allKeys = new Set();
                        const { isMac } = _util.FeatureTest.platform;
                        for (const [keys, callback, options = {}] of callbacks)for (const key of keys){
                            const isMacKey = key.startsWith("mac+");
                            if (isMac && isMacKey) {
                                this.callbacks.set(key.slice(4), {
                                    callback: callback,
                                    options: options
                                });
                                this.allKeys.add(key.split("+").at(-1));
                            } else if (!isMac && !isMacKey) {
                                this.callbacks.set(key, {
                                    callback: callback,
                                    options: options
                                });
                                this.allKeys.add(key.split("+").at(-1));
                            }
                        }
                    }
                    #serialize(event) {
                        if (event.altKey) this.buffer.push("alt");
                        if (event.ctrlKey) this.buffer.push("ctrl");
                        if (event.metaKey) this.buffer.push("meta");
                        if (event.shiftKey) this.buffer.push("shift");
                        this.buffer.push(event.key);
                        const str = this.buffer.join("+");
                        this.buffer.length = 0;
                        return str;
                    }
                    exec(self, event) {
                        if (!this.allKeys.has(event.key)) return;
                        const info = this.callbacks.get(this.#serialize(event));
                        if (!info) return;
                        const { callback, options: { bubbles = false, args = [], checker = null } } = info;
                        if (checker && !checker(self, event)) return;
                        callback.bind(self, ...args)();
                        if (!bubbles) {
                            event.stopPropagation();
                            event.preventDefault();
                        }
                    }
                }
                exports.KeyboardManager = KeyboardManager;
                class ColorManager {
                    static _colorsMapping = new Map([
                        [
                            "CanvasText",
                            [
                                0,
                                0,
                                0
                            ]
                        ],
                        [
                            "Canvas",
                            [
                                255,
                                255,
                                255
                            ]
                        ]
                    ]);
                    get _colors() {
                        const colors = new Map([
                            [
                                "CanvasText",
                                null
                            ],
                            [
                                "Canvas",
                                null
                            ]
                        ]);
                        (0, _display_utils.getColorValues)(colors);
                        return (0, _util.shadow)(this, "_colors", colors);
                    }
                    convert(color) {
                        const rgb = (0, _display_utils.getRGB)(color);
                        if (!window.matchMedia("(forced-colors: active)").matches) return rgb;
                        for (const [name, RGB] of this._colors){
                            if (RGB.every((x, i)=>x === rgb[i])) return ColorManager._colorsMapping.get(name);
                        }
                        return rgb;
                    }
                    getHexCode(name) {
                        const rgb = this._colors.get(name);
                        if (!rgb) return name;
                        return _util.Util.makeHexColor(...rgb);
                    }
                }
                exports.ColorManager = ColorManager;
                class AnnotationEditorUIManager {
                    #activeEditor = null;
                    #allEditors = new Map();
                    #allLayers = new Map();
                    #altTextManager = null;
                    #annotationStorage = null;
                    #commandManager = new CommandManager();
                    #currentPageIndex = 0;
                    #deletedAnnotationsElementIds = new Set();
                    #draggingEditors = null;
                    #editorTypes = null;
                    #editorsToRescale = new Set();
                    #filterFactory = null;
                    #idManager = new IdManager();
                    #isEnabled = false;
                    #isWaiting = false;
                    #lastActiveElement = null;
                    #mode = _util.AnnotationEditorType.NONE;
                    #selectedEditors = new Set();
                    #pageColors = null;
                    #boundBlur = this.blur.bind(this);
                    #boundFocus = this.focus.bind(this);
                    #boundCopy = this.copy.bind(this);
                    #boundCut = this.cut.bind(this);
                    #boundPaste = this.paste.bind(this);
                    #boundKeydown = this.keydown.bind(this);
                    #boundOnEditingAction = this.onEditingAction.bind(this);
                    #boundOnPageChanging = this.onPageChanging.bind(this);
                    #boundOnScaleChanging = this.onScaleChanging.bind(this);
                    #boundOnRotationChanging = this.onRotationChanging.bind(this);
                    #previousStates = {
                        isEditing: false,
                        isEmpty: true,
                        hasSomethingToUndo: false,
                        hasSomethingToRedo: false,
                        hasSelectedEditor: false
                    };
                    #translation = [
                        0,
                        0
                    ];
                    #translationTimeoutId = null;
                    #container = null;
                    #viewer = null;
                    static TRANSLATE_SMALL = 1;
                    static TRANSLATE_BIG = 10;
                    static get _keyboardManager() {
                        const proto = AnnotationEditorUIManager.prototype;
                        const arrowChecker = (self)=>{
                            const { activeElement } = document;
                            return activeElement && self.#container.contains(activeElement) && self.hasSomethingToControl();
                        };
                        const small = this.TRANSLATE_SMALL;
                        const big = this.TRANSLATE_BIG;
                        return (0, _util.shadow)(this, "_keyboardManager", new KeyboardManager([
                            [
                                [
                                    "ctrl+a",
                                    "mac+meta+a"
                                ],
                                proto.selectAll
                            ],
                            [
                                [
                                    "ctrl+z",
                                    "mac+meta+z"
                                ],
                                proto.undo
                            ],
                            [
                                [
                                    "ctrl+y",
                                    "ctrl+shift+z",
                                    "mac+meta+shift+z",
                                    "ctrl+shift+Z",
                                    "mac+meta+shift+Z"
                                ],
                                proto.redo
                            ],
                            [
                                [
                                    "Backspace",
                                    "alt+Backspace",
                                    "ctrl+Backspace",
                                    "shift+Backspace",
                                    "mac+Backspace",
                                    "mac+alt+Backspace",
                                    "mac+ctrl+Backspace",
                                    "Delete",
                                    "ctrl+Delete",
                                    "shift+Delete",
                                    "mac+Delete"
                                ],
                                proto.delete
                            ],
                            [
                                [
                                    "Escape",
                                    "mac+Escape"
                                ],
                                proto.unselectAll
                            ],
                            [
                                [
                                    "ArrowLeft",
                                    "mac+ArrowLeft"
                                ],
                                proto.translateSelectedEditors,
                                {
                                    args: [
                                        -small,
                                        0
                                    ],
                                    checker: arrowChecker
                                }
                            ],
                            [
                                [
                                    "ctrl+ArrowLeft",
                                    "mac+shift+ArrowLeft"
                                ],
                                proto.translateSelectedEditors,
                                {
                                    args: [
                                        -big,
                                        0
                                    ],
                                    checker: arrowChecker
                                }
                            ],
                            [
                                [
                                    "ArrowRight",
                                    "mac+ArrowRight"
                                ],
                                proto.translateSelectedEditors,
                                {
                                    args: [
                                        small,
                                        0
                                    ],
                                    checker: arrowChecker
                                }
                            ],
                            [
                                [
                                    "ctrl+ArrowRight",
                                    "mac+shift+ArrowRight"
                                ],
                                proto.translateSelectedEditors,
                                {
                                    args: [
                                        big,
                                        0
                                    ],
                                    checker: arrowChecker
                                }
                            ],
                            [
                                [
                                    "ArrowUp",
                                    "mac+ArrowUp"
                                ],
                                proto.translateSelectedEditors,
                                {
                                    args: [
                                        0,
                                        -small
                                    ],
                                    checker: arrowChecker
                                }
                            ],
                            [
                                [
                                    "ctrl+ArrowUp",
                                    "mac+shift+ArrowUp"
                                ],
                                proto.translateSelectedEditors,
                                {
                                    args: [
                                        0,
                                        -big
                                    ],
                                    checker: arrowChecker
                                }
                            ],
                            [
                                [
                                    "ArrowDown",
                                    "mac+ArrowDown"
                                ],
                                proto.translateSelectedEditors,
                                {
                                    args: [
                                        0,
                                        small
                                    ],
                                    checker: arrowChecker
                                }
                            ],
                            [
                                [
                                    "ctrl+ArrowDown",
                                    "mac+shift+ArrowDown"
                                ],
                                proto.translateSelectedEditors,
                                {
                                    args: [
                                        0,
                                        big
                                    ],
                                    checker: arrowChecker
                                }
                            ]
                        ]));
                    }
                    constructor(container, viewer, altTextManager, eventBus, pdfDocument, pageColors){
                        this.#container = container;
                        this.#viewer = viewer;
                        this.#altTextManager = altTextManager;
                        this._eventBus = eventBus;
                        this._eventBus._on("editingaction", this.#boundOnEditingAction);
                        this._eventBus._on("pagechanging", this.#boundOnPageChanging);
                        this._eventBus._on("scalechanging", this.#boundOnScaleChanging);
                        this._eventBus._on("rotationchanging", this.#boundOnRotationChanging);
                        this.#annotationStorage = pdfDocument.annotationStorage;
                        this.#filterFactory = pdfDocument.filterFactory;
                        this.#pageColors = pageColors;
                        this.viewParameters = {
                            realScale: _display_utils.PixelsPerInch.PDF_TO_CSS_UNITS,
                            rotation: 0
                        };
                    }
                    destroy() {
                        this.#removeKeyboardManager();
                        this.#removeFocusManager();
                        this._eventBus._off("editingaction", this.#boundOnEditingAction);
                        this._eventBus._off("pagechanging", this.#boundOnPageChanging);
                        this._eventBus._off("scalechanging", this.#boundOnScaleChanging);
                        this._eventBus._off("rotationchanging", this.#boundOnRotationChanging);
                        for (const layer of this.#allLayers.values())layer.destroy();
                        this.#allLayers.clear();
                        this.#allEditors.clear();
                        this.#editorsToRescale.clear();
                        this.#activeEditor = null;
                        this.#selectedEditors.clear();
                        this.#commandManager.destroy();
                        this.#altTextManager.destroy();
                    }
                    get hcmFilter() {
                        return (0, _util.shadow)(this, "hcmFilter", this.#pageColors ? this.#filterFactory.addHCMFilter(this.#pageColors.foreground, this.#pageColors.background) : "none");
                    }
                    get direction() {
                        return (0, _util.shadow)(this, "direction", getComputedStyle(this.#container).direction);
                    }
                    editAltText(editor) {
                        this.#altTextManager?.editAltText(this, editor);
                    }
                    onPageChanging({ pageNumber }) {
                        this.#currentPageIndex = pageNumber - 1;
                    }
                    focusMainContainer() {
                        this.#container.focus();
                    }
                    findParent(x, y) {
                        for (const layer of this.#allLayers.values()){
                            const { x: layerX, y: layerY, width, height } = layer.div.getBoundingClientRect();
                            if (x >= layerX && x <= layerX + width && y >= layerY && y <= layerY + height) return layer;
                        }
                        return null;
                    }
                    disableUserSelect(value = false) {
                        this.#viewer.classList.toggle("noUserSelect", value);
                    }
                    addShouldRescale(editor) {
                        this.#editorsToRescale.add(editor);
                    }
                    removeShouldRescale(editor) {
                        this.#editorsToRescale.delete(editor);
                    }
                    onScaleChanging({ scale }) {
                        this.commitOrRemove();
                        this.viewParameters.realScale = scale * _display_utils.PixelsPerInch.PDF_TO_CSS_UNITS;
                        for (const editor of this.#editorsToRescale)editor.onScaleChanging();
                    }
                    onRotationChanging({ pagesRotation }) {
                        this.commitOrRemove();
                        this.viewParameters.rotation = pagesRotation;
                    }
                    addToAnnotationStorage(editor) {
                        if (!editor.isEmpty() && this.#annotationStorage && !this.#annotationStorage.has(editor.id)) this.#annotationStorage.setValue(editor.id, editor);
                    }
                    #addFocusManager() {
                        window.addEventListener("focus", this.#boundFocus);
                        window.addEventListener("blur", this.#boundBlur);
                    }
                    #removeFocusManager() {
                        window.removeEventListener("focus", this.#boundFocus);
                        window.removeEventListener("blur", this.#boundBlur);
                    }
                    blur() {
                        if (!this.hasSelection) return;
                        const { activeElement } = document;
                        for (const editor of this.#selectedEditors)if (editor.div.contains(activeElement)) {
                            this.#lastActiveElement = [
                                editor,
                                activeElement
                            ];
                            editor._focusEventsAllowed = false;
                            break;
                        }
                    }
                    focus() {
                        if (!this.#lastActiveElement) return;
                        const [lastEditor, lastActiveElement] = this.#lastActiveElement;
                        this.#lastActiveElement = null;
                        lastActiveElement.addEventListener("focusin", ()=>{
                            lastEditor._focusEventsAllowed = true;
                        }, {
                            once: true
                        });
                        lastActiveElement.focus();
                    }
                    #addKeyboardManager() {
                        window.addEventListener("keydown", this.#boundKeydown, {
                            capture: true
                        });
                    }
                    #removeKeyboardManager() {
                        window.removeEventListener("keydown", this.#boundKeydown, {
                            capture: true
                        });
                    }
                    #addCopyPasteListeners() {
                        document.addEventListener("copy", this.#boundCopy);
                        document.addEventListener("cut", this.#boundCut);
                        document.addEventListener("paste", this.#boundPaste);
                    }
                    #removeCopyPasteListeners() {
                        document.removeEventListener("copy", this.#boundCopy);
                        document.removeEventListener("cut", this.#boundCut);
                        document.removeEventListener("paste", this.#boundPaste);
                    }
                    addEditListeners() {
                        this.#addKeyboardManager();
                        this.#addCopyPasteListeners();
                    }
                    removeEditListeners() {
                        this.#removeKeyboardManager();
                        this.#removeCopyPasteListeners();
                    }
                    copy(event) {
                        event.preventDefault();
                        this.#activeEditor?.commitOrRemove();
                        if (!this.hasSelection) return;
                        const editors = [];
                        for (const editor of this.#selectedEditors){
                            const serialized = editor.serialize(true);
                            if (serialized) editors.push(serialized);
                        }
                        if (editors.length === 0) return;
                        event.clipboardData.setData("application/pdfjs", JSON.stringify(editors));
                    }
                    cut(event) {
                        this.copy(event);
                        this.delete();
                    }
                    paste(event) {
                        event.preventDefault();
                        const { clipboardData } = event;
                        for (const item of clipboardData.items){
                            for (const editorType of this.#editorTypes)if (editorType.isHandlingMimeForPasting(item.type)) {
                                editorType.paste(item, this.currentLayer);
                                return;
                            }
                        }
                        let data = clipboardData.getData("application/pdfjs");
                        if (!data) return;
                        try {
                            data = JSON.parse(data);
                        } catch (ex) {
                            (0, _util.warn)(`paste: "${ex.message}".`);
                            return;
                        }
                        if (!Array.isArray(data)) return;
                        this.unselectAll();
                        const layer = this.currentLayer;
                        try {
                            const newEditors = [];
                            for (const editor of data){
                                const deserializedEditor = layer.deserialize(editor);
                                if (!deserializedEditor) return;
                                newEditors.push(deserializedEditor);
                            }
                            const cmd = ()=>{
                                for (const editor of newEditors)this.#addEditorToLayer(editor);
                                this.#selectEditors(newEditors);
                            };
                            const undo = ()=>{
                                for (const editor of newEditors)editor.remove();
                            };
                            this.addCommands({
                                cmd: cmd,
                                undo: undo,
                                mustExec: true
                            });
                        } catch (ex) {
                            (0, _util.warn)(`paste: "${ex.message}".`);
                        }
                    }
                    keydown(event) {
                        if (!this.getActive()?.shouldGetKeyboardEvents()) AnnotationEditorUIManager._keyboardManager.exec(this, event);
                    }
                    onEditingAction(details) {
                        if ([
                            "undo",
                            "redo",
                            "delete",
                            "selectAll"
                        ].includes(details.name)) this[details.name]();
                    }
                    #dispatchUpdateStates(details) {
                        const hasChanged = Object.entries(details).some(([key, value])=>this.#previousStates[key] !== value);
                        if (hasChanged) this._eventBus.dispatch("annotationeditorstateschanged", {
                            source: this,
                            details: Object.assign(this.#previousStates, details)
                        });
                    }
                    #dispatchUpdateUI(details) {
                        this._eventBus.dispatch("annotationeditorparamschanged", {
                            source: this,
                            details: details
                        });
                    }
                    setEditingState(isEditing) {
                        if (isEditing) {
                            this.#addFocusManager();
                            this.#addKeyboardManager();
                            this.#addCopyPasteListeners();
                            this.#dispatchUpdateStates({
                                isEditing: this.#mode !== _util.AnnotationEditorType.NONE,
                                isEmpty: this.#isEmpty(),
                                hasSomethingToUndo: this.#commandManager.hasSomethingToUndo(),
                                hasSomethingToRedo: this.#commandManager.hasSomethingToRedo(),
                                hasSelectedEditor: false
                            });
                        } else {
                            this.#removeFocusManager();
                            this.#removeKeyboardManager();
                            this.#removeCopyPasteListeners();
                            this.#dispatchUpdateStates({
                                isEditing: false
                            });
                            this.disableUserSelect(false);
                        }
                    }
                    registerEditorTypes(types) {
                        if (this.#editorTypes) return;
                        this.#editorTypes = types;
                        for (const editorType of this.#editorTypes)this.#dispatchUpdateUI(editorType.defaultPropertiesToUpdate);
                    }
                    getId() {
                        return this.#idManager.getId();
                    }
                    get currentLayer() {
                        return this.#allLayers.get(this.#currentPageIndex);
                    }
                    getLayer(pageIndex) {
                        return this.#allLayers.get(pageIndex);
                    }
                    get currentPageIndex() {
                        return this.#currentPageIndex;
                    }
                    addLayer(layer) {
                        this.#allLayers.set(layer.pageIndex, layer);
                        if (this.#isEnabled) layer.enable();
                        else layer.disable();
                    }
                    removeLayer(layer) {
                        this.#allLayers.delete(layer.pageIndex);
                    }
                    updateMode(mode, editId = null) {
                        if (this.#mode === mode) return;
                        this.#mode = mode;
                        if (mode === _util.AnnotationEditorType.NONE) {
                            this.setEditingState(false);
                            this.#disableAll();
                            return;
                        }
                        this.setEditingState(true);
                        this.#enableAll();
                        this.unselectAll();
                        for (const layer of this.#allLayers.values())layer.updateMode(mode);
                        if (!editId) return;
                        for (const editor of this.#allEditors.values())if (editor.annotationElementId === editId) {
                            this.setSelected(editor);
                            editor.enterInEditMode();
                            break;
                        }
                    }
                    updateToolbar(mode) {
                        if (mode === this.#mode) return;
                        this._eventBus.dispatch("switchannotationeditormode", {
                            source: this,
                            mode: mode
                        });
                    }
                    updateParams(type, value) {
                        if (!this.#editorTypes) return;
                        if (type === _util.AnnotationEditorParamsType.CREATE) {
                            this.currentLayer.addNewEditor(type);
                            return;
                        }
                        for (const editor of this.#selectedEditors)editor.updateParams(type, value);
                        for (const editorType of this.#editorTypes)editorType.updateDefaultParams(type, value);
                    }
                    enableWaiting(mustWait = false) {
                        if (this.#isWaiting === mustWait) return;
                        this.#isWaiting = mustWait;
                        for (const layer of this.#allLayers.values()){
                            if (mustWait) layer.disableClick();
                            else layer.enableClick();
                            layer.div.classList.toggle("waiting", mustWait);
                        }
                    }
                    #enableAll() {
                        if (!this.#isEnabled) {
                            this.#isEnabled = true;
                            for (const layer of this.#allLayers.values())layer.enable();
                        }
                    }
                    #disableAll() {
                        this.unselectAll();
                        if (this.#isEnabled) {
                            this.#isEnabled = false;
                            for (const layer of this.#allLayers.values())layer.disable();
                        }
                    }
                    getEditors(pageIndex) {
                        const editors = [];
                        for (const editor of this.#allEditors.values())if (editor.pageIndex === pageIndex) editors.push(editor);
                        return editors;
                    }
                    getEditor(id) {
                        return this.#allEditors.get(id);
                    }
                    addEditor(editor) {
                        this.#allEditors.set(editor.id, editor);
                    }
                    removeEditor(editor) {
                        this.#allEditors.delete(editor.id);
                        this.unselect(editor);
                        if (!editor.annotationElementId || !this.#deletedAnnotationsElementIds.has(editor.annotationElementId)) this.#annotationStorage?.remove(editor.id);
                    }
                    addDeletedAnnotationElement(editor) {
                        this.#deletedAnnotationsElementIds.add(editor.annotationElementId);
                        editor.deleted = true;
                    }
                    isDeletedAnnotationElement(annotationElementId) {
                        return this.#deletedAnnotationsElementIds.has(annotationElementId);
                    }
                    removeDeletedAnnotationElement(editor) {
                        this.#deletedAnnotationsElementIds.delete(editor.annotationElementId);
                        editor.deleted = false;
                    }
                    #addEditorToLayer(editor) {
                        const layer = this.#allLayers.get(editor.pageIndex);
                        if (layer) layer.addOrRebuild(editor);
                        else this.addEditor(editor);
                    }
                    setActiveEditor(editor) {
                        if (this.#activeEditor === editor) return;
                        this.#activeEditor = editor;
                        if (editor) this.#dispatchUpdateUI(editor.propertiesToUpdate);
                    }
                    toggleSelected(editor) {
                        if (this.#selectedEditors.has(editor)) {
                            this.#selectedEditors.delete(editor);
                            editor.unselect();
                            this.#dispatchUpdateStates({
                                hasSelectedEditor: this.hasSelection
                            });
                            return;
                        }
                        this.#selectedEditors.add(editor);
                        editor.select();
                        this.#dispatchUpdateUI(editor.propertiesToUpdate);
                        this.#dispatchUpdateStates({
                            hasSelectedEditor: true
                        });
                    }
                    setSelected(editor) {
                        for (const ed of this.#selectedEditors)if (ed !== editor) ed.unselect();
                        this.#selectedEditors.clear();
                        this.#selectedEditors.add(editor);
                        editor.select();
                        this.#dispatchUpdateUI(editor.propertiesToUpdate);
                        this.#dispatchUpdateStates({
                            hasSelectedEditor: true
                        });
                    }
                    isSelected(editor) {
                        return this.#selectedEditors.has(editor);
                    }
                    unselect(editor) {
                        editor.unselect();
                        this.#selectedEditors.delete(editor);
                        this.#dispatchUpdateStates({
                            hasSelectedEditor: this.hasSelection
                        });
                    }
                    get hasSelection() {
                        return this.#selectedEditors.size !== 0;
                    }
                    undo() {
                        this.#commandManager.undo();
                        this.#dispatchUpdateStates({
                            hasSomethingToUndo: this.#commandManager.hasSomethingToUndo(),
                            hasSomethingToRedo: true,
                            isEmpty: this.#isEmpty()
                        });
                    }
                    redo() {
                        this.#commandManager.redo();
                        this.#dispatchUpdateStates({
                            hasSomethingToUndo: true,
                            hasSomethingToRedo: this.#commandManager.hasSomethingToRedo(),
                            isEmpty: this.#isEmpty()
                        });
                    }
                    addCommands(params) {
                        this.#commandManager.add(params);
                        this.#dispatchUpdateStates({
                            hasSomethingToUndo: true,
                            hasSomethingToRedo: false,
                            isEmpty: this.#isEmpty()
                        });
                    }
                    #isEmpty() {
                        if (this.#allEditors.size === 0) return true;
                        if (this.#allEditors.size === 1) {
                            for (const editor of this.#allEditors.values())return editor.isEmpty();
                        }
                        return false;
                    }
                    delete() {
                        this.commitOrRemove();
                        if (!this.hasSelection) return;
                        const editors = [
                            ...this.#selectedEditors
                        ];
                        const cmd = ()=>{
                            for (const editor of editors)editor.remove();
                        };
                        const undo = ()=>{
                            for (const editor of editors)this.#addEditorToLayer(editor);
                        };
                        this.addCommands({
                            cmd: cmd,
                            undo: undo,
                            mustExec: true
                        });
                    }
                    commitOrRemove() {
                        this.#activeEditor?.commitOrRemove();
                    }
                    hasSomethingToControl() {
                        return this.#activeEditor || this.hasSelection;
                    }
                    #selectEditors(editors) {
                        this.#selectedEditors.clear();
                        for (const editor of editors){
                            if (editor.isEmpty()) continue;
                            this.#selectedEditors.add(editor);
                            editor.select();
                        }
                        this.#dispatchUpdateStates({
                            hasSelectedEditor: true
                        });
                    }
                    selectAll() {
                        for (const editor of this.#selectedEditors)editor.commit();
                        this.#selectEditors(this.#allEditors.values());
                    }
                    unselectAll() {
                        if (this.#activeEditor) {
                            this.#activeEditor.commitOrRemove();
                            return;
                        }
                        if (!this.hasSelection) return;
                        for (const editor of this.#selectedEditors)editor.unselect();
                        this.#selectedEditors.clear();
                        this.#dispatchUpdateStates({
                            hasSelectedEditor: false
                        });
                    }
                    translateSelectedEditors(x, y, noCommit = false) {
                        if (!noCommit) this.commitOrRemove();
                        if (!this.hasSelection) return;
                        this.#translation[0] += x;
                        this.#translation[1] += y;
                        const [totalX, totalY] = this.#translation;
                        const editors = [
                            ...this.#selectedEditors
                        ];
                        const TIME_TO_WAIT = 1000;
                        if (this.#translationTimeoutId) clearTimeout(this.#translationTimeoutId);
                        this.#translationTimeoutId = setTimeout(()=>{
                            this.#translationTimeoutId = null;
                            this.#translation[0] = this.#translation[1] = 0;
                            this.addCommands({
                                cmd: ()=>{
                                    for (const editor of editors)if (this.#allEditors.has(editor.id)) editor.translateInPage(totalX, totalY);
                                },
                                undo: ()=>{
                                    for (const editor of editors)if (this.#allEditors.has(editor.id)) editor.translateInPage(-totalX, -totalY);
                                },
                                mustExec: false
                            });
                        }, TIME_TO_WAIT);
                        for (const editor of editors)editor.translateInPage(x, y);
                    }
                    setUpDragSession() {
                        if (!this.hasSelection) return;
                        this.disableUserSelect(true);
                        this.#draggingEditors = new Map();
                        for (const editor of this.#selectedEditors)this.#draggingEditors.set(editor, {
                            savedX: editor.x,
                            savedY: editor.y,
                            savedPageIndex: editor.pageIndex,
                            newX: 0,
                            newY: 0,
                            newPageIndex: -1
                        });
                    }
                    endDragSession() {
                        if (!this.#draggingEditors) return false;
                        this.disableUserSelect(false);
                        const map = this.#draggingEditors;
                        this.#draggingEditors = null;
                        let mustBeAddedInUndoStack = false;
                        for (const [{ x, y, pageIndex }, value] of map){
                            value.newX = x;
                            value.newY = y;
                            value.newPageIndex = pageIndex;
                            mustBeAddedInUndoStack ||= x !== value.savedX || y !== value.savedY || pageIndex !== value.savedPageIndex;
                        }
                        if (!mustBeAddedInUndoStack) return false;
                        const move = (editor, x, y, pageIndex)=>{
                            if (this.#allEditors.has(editor.id)) {
                                const parent = this.#allLayers.get(pageIndex);
                                if (parent) editor._setParentAndPosition(parent, x, y);
                                else {
                                    editor.pageIndex = pageIndex;
                                    editor.x = x;
                                    editor.y = y;
                                }
                            }
                        };
                        this.addCommands({
                            cmd: ()=>{
                                for (const [editor, { newX, newY, newPageIndex }] of map)move(editor, newX, newY, newPageIndex);
                            },
                            undo: ()=>{
                                for (const [editor, { savedX, savedY, savedPageIndex }] of map)move(editor, savedX, savedY, savedPageIndex);
                            },
                            mustExec: true
                        });
                        return true;
                    }
                    dragSelectedEditors(tx, ty) {
                        if (!this.#draggingEditors) return;
                        for (const editor of this.#draggingEditors.keys())editor.drag(tx, ty);
                    }
                    rebuild(editor) {
                        if (editor.parent === null) {
                            const parent = this.getLayer(editor.pageIndex);
                            if (parent) {
                                parent.changeParent(editor);
                                parent.addOrRebuild(editor);
                            } else {
                                this.addEditor(editor);
                                this.addToAnnotationStorage(editor);
                                editor.rebuild();
                            }
                        } else editor.parent.addOrRebuild(editor);
                    }
                    isActive(editor) {
                        return this.#activeEditor === editor;
                    }
                    getActive() {
                        return this.#activeEditor;
                    }
                    getMode() {
                        return this.#mode;
                    }
                    get imageManager() {
                        return (0, _util.shadow)(this, "imageManager", new ImageManager());
                    }
                }
                exports.AnnotationEditorUIManager = AnnotationEditorUIManager;
            /***/ },
            /* 6 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.StatTimer = exports.RenderingCancelledException = exports.PixelsPerInch = exports.PageViewport = exports.PDFDateString = exports.DOMStandardFontDataFactory = exports.DOMSVGFactory = exports.DOMFilterFactory = exports.DOMCanvasFactory = exports.DOMCMapReaderFactory = void 0;
                exports.deprecated = deprecated;
                exports.getColorValues = getColorValues;
                exports.getCurrentTransform = getCurrentTransform;
                exports.getCurrentTransformInverse = getCurrentTransformInverse;
                exports.getFilenameFromUrl = getFilenameFromUrl;
                exports.getPdfFilenameFromUrl = getPdfFilenameFromUrl;
                exports.getRGB = getRGB;
                exports.getXfaPageViewport = getXfaPageViewport;
                exports.isDataScheme = isDataScheme;
                exports.isPdfFile = isPdfFile;
                exports.isValidFetchUrl = isValidFetchUrl;
                exports.loadScript = loadScript;
                exports.noContextMenu = noContextMenu;
                exports.setLayerDimensions = setLayerDimensions;
                var _base_factory = __w_pdfjs_require__(7);
                var _util = __w_pdfjs_require__(1);
                const SVG_NS = "http://www.w3.org/2000/svg";
                class PixelsPerInch {
                    static CSS = 96.0;
                    static PDF = 72.0;
                    static PDF_TO_CSS_UNITS = this.CSS / this.PDF;
                }
                exports.PixelsPerInch = PixelsPerInch;
                class DOMFilterFactory extends _base_factory.BaseFilterFactory {
                    #_cache;
                    #_defs;
                    #docId;
                    #document;
                    #hcmFilter;
                    #hcmKey;
                    #hcmUrl;
                    #hcmHighlightFilter;
                    #hcmHighlightKey;
                    #hcmHighlightUrl;
                    #id = 0;
                    constructor({ docId, ownerDocument = globalThis.document } = {}){
                        super();
                        this.#docId = docId;
                        this.#document = ownerDocument;
                    }
                    get #cache() {
                        return this.#_cache ||= new Map();
                    }
                    get #defs() {
                        if (!this.#_defs) {
                            const div = this.#document.createElement("div");
                            const { style } = div;
                            style.visibility = "hidden";
                            style.contain = "strict";
                            style.width = style.height = 0;
                            style.position = "absolute";
                            style.top = style.left = 0;
                            style.zIndex = -1;
                            const svg = this.#document.createElementNS(SVG_NS, "svg");
                            svg.setAttribute("width", 0);
                            svg.setAttribute("height", 0);
                            this.#_defs = this.#document.createElementNS(SVG_NS, "defs");
                            div.append(svg);
                            svg.append(this.#_defs);
                            this.#document.body.append(div);
                        }
                        return this.#_defs;
                    }
                    addFilter(maps) {
                        if (!maps) return "none";
                        let value = this.#cache.get(maps);
                        if (value) return value;
                        let tableR, tableG, tableB, key;
                        if (maps.length === 1) {
                            const mapR = maps[0];
                            const buffer = new Array(256);
                            for(let i = 0; i < 256; i++)buffer[i] = mapR[i] / 255;
                            key = tableR = tableG = tableB = buffer.join(",");
                        } else {
                            const [mapR, mapG, mapB] = maps;
                            const bufferR = new Array(256);
                            const bufferG = new Array(256);
                            const bufferB = new Array(256);
                            for(let i = 0; i < 256; i++){
                                bufferR[i] = mapR[i] / 255;
                                bufferG[i] = mapG[i] / 255;
                                bufferB[i] = mapB[i] / 255;
                            }
                            tableR = bufferR.join(",");
                            tableG = bufferG.join(",");
                            tableB = bufferB.join(",");
                            key = `${tableR}${tableG}${tableB}`;
                        }
                        value = this.#cache.get(key);
                        if (value) {
                            this.#cache.set(maps, value);
                            return value;
                        }
                        const id = `g_${this.#docId}_transfer_map_${this.#id++}`;
                        const url = `url(#${id})`;
                        this.#cache.set(maps, url);
                        this.#cache.set(key, url);
                        const filter = this.#createFilter(id);
                        this.#addTransferMapConversion(tableR, tableG, tableB, filter);
                        return url;
                    }
                    addHCMFilter(fgColor, bgColor) {
                        const key = `${fgColor}-${bgColor}`;
                        if (this.#hcmKey === key) return this.#hcmUrl;
                        this.#hcmKey = key;
                        this.#hcmUrl = "none";
                        this.#hcmFilter?.remove();
                        if (!fgColor || !bgColor) return this.#hcmUrl;
                        const fgRGB = this.#getRGB(fgColor);
                        fgColor = _util.Util.makeHexColor(...fgRGB);
                        const bgRGB = this.#getRGB(bgColor);
                        bgColor = _util.Util.makeHexColor(...bgRGB);
                        this.#defs.style.color = "";
                        if (fgColor === "#000000" && bgColor === "#ffffff" || fgColor === bgColor) return this.#hcmUrl;
                        const map = new Array(256);
                        for(let i = 0; i <= 255; i++){
                            const x = i / 255;
                            map[i] = x <= 0.03928 ? x / 12.92 : ((x + 0.055) / 1.055) ** 2.4;
                        }
                        const table = map.join(",");
                        const id = `g_${this.#docId}_hcm_filter`;
                        const filter = this.#hcmHighlightFilter = this.#createFilter(id);
                        this.#addTransferMapConversion(table, table, table, filter);
                        this.#addGrayConversion(filter);
                        const getSteps = (c, n)=>{
                            const start = fgRGB[c] / 255;
                            const end = bgRGB[c] / 255;
                            const arr = new Array(n + 1);
                            for(let i = 0; i <= n; i++)arr[i] = start + i / n * (end - start);
                            return arr.join(",");
                        };
                        this.#addTransferMapConversion(getSteps(0, 5), getSteps(1, 5), getSteps(2, 5), filter);
                        this.#hcmUrl = `url(#${id})`;
                        return this.#hcmUrl;
                    }
                    addHighlightHCMFilter(fgColor, bgColor, newFgColor, newBgColor) {
                        const key = `${fgColor}-${bgColor}-${newFgColor}-${newBgColor}`;
                        if (this.#hcmHighlightKey === key) return this.#hcmHighlightUrl;
                        this.#hcmHighlightKey = key;
                        this.#hcmHighlightUrl = "none";
                        this.#hcmHighlightFilter?.remove();
                        if (!fgColor || !bgColor) return this.#hcmHighlightUrl;
                        const [fgRGB, bgRGB] = [
                            fgColor,
                            bgColor
                        ].map(this.#getRGB.bind(this));
                        let fgGray = Math.round(0.2126 * fgRGB[0] + 0.7152 * fgRGB[1] + 0.0722 * fgRGB[2]);
                        let bgGray = Math.round(0.2126 * bgRGB[0] + 0.7152 * bgRGB[1] + 0.0722 * bgRGB[2]);
                        let [newFgRGB, newBgRGB] = [
                            newFgColor,
                            newBgColor
                        ].map(this.#getRGB.bind(this));
                        if (bgGray < fgGray) [fgGray, bgGray, newFgRGB, newBgRGB] = [
                            bgGray,
                            fgGray,
                            newBgRGB,
                            newFgRGB
                        ];
                        this.#defs.style.color = "";
                        const getSteps = (fg, bg, n)=>{
                            const arr = new Array(256);
                            const step = (bgGray - fgGray) / n;
                            const newStart = fg / 255;
                            const newStep = (bg - fg) / (255 * n);
                            let prev = 0;
                            for(let i = 0; i <= n; i++){
                                const k = Math.round(fgGray + i * step);
                                const value = newStart + i * newStep;
                                for(let j = prev; j <= k; j++)arr[j] = value;
                                prev = k + 1;
                            }
                            for(let i = prev; i < 256; i++)arr[i] = arr[prev - 1];
                            return arr.join(",");
                        };
                        const id = `g_${this.#docId}_hcm_highlight_filter`;
                        const filter = this.#hcmHighlightFilter = this.#createFilter(id);
                        this.#addGrayConversion(filter);
                        this.#addTransferMapConversion(getSteps(newFgRGB[0], newBgRGB[0], 5), getSteps(newFgRGB[1], newBgRGB[1], 5), getSteps(newFgRGB[2], newBgRGB[2], 5), filter);
                        this.#hcmHighlightUrl = `url(#${id})`;
                        return this.#hcmHighlightUrl;
                    }
                    destroy(keepHCM = false) {
                        if (keepHCM && (this.#hcmUrl || this.#hcmHighlightUrl)) return;
                        if (this.#_defs) {
                            this.#_defs.parentNode.parentNode.remove();
                            this.#_defs = null;
                        }
                        if (this.#_cache) {
                            this.#_cache.clear();
                            this.#_cache = null;
                        }
                        this.#id = 0;
                    }
                    #addGrayConversion(filter) {
                        const feColorMatrix = this.#document.createElementNS(SVG_NS, "feColorMatrix");
                        feColorMatrix.setAttribute("type", "matrix");
                        feColorMatrix.setAttribute("values", "0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0 0 0 1 0");
                        filter.append(feColorMatrix);
                    }
                    #createFilter(id) {
                        const filter = this.#document.createElementNS(SVG_NS, "filter");
                        filter.setAttribute("color-interpolation-filters", "sRGB");
                        filter.setAttribute("id", id);
                        this.#defs.append(filter);
                        return filter;
                    }
                    #appendFeFunc(feComponentTransfer, func, table) {
                        const feFunc = this.#document.createElementNS(SVG_NS, func);
                        feFunc.setAttribute("type", "discrete");
                        feFunc.setAttribute("tableValues", table);
                        feComponentTransfer.append(feFunc);
                    }
                    #addTransferMapConversion(rTable, gTable, bTable, filter) {
                        const feComponentTransfer = this.#document.createElementNS(SVG_NS, "feComponentTransfer");
                        filter.append(feComponentTransfer);
                        this.#appendFeFunc(feComponentTransfer, "feFuncR", rTable);
                        this.#appendFeFunc(feComponentTransfer, "feFuncG", gTable);
                        this.#appendFeFunc(feComponentTransfer, "feFuncB", bTable);
                    }
                    #getRGB(color) {
                        this.#defs.style.color = color;
                        return getRGB(getComputedStyle(this.#defs).getPropertyValue("color"));
                    }
                }
                exports.DOMFilterFactory = DOMFilterFactory;
                class DOMCanvasFactory extends _base_factory.BaseCanvasFactory {
                    constructor({ ownerDocument = globalThis.document } = {}){
                        super();
                        this._document = ownerDocument;
                    }
                    _createCanvas(width, height) {
                        const canvas = this._document.createElement("canvas");
                        canvas.width = width;
                        canvas.height = height;
                        return canvas;
                    }
                }
                exports.DOMCanvasFactory = DOMCanvasFactory;
                async function fetchData(url, asTypedArray = false) {
                    if (isValidFetchUrl(url, document.baseURI)) {
                        const response = await fetch(url);
                        if (!response.ok) throw new Error(response.statusText);
                        return asTypedArray ? new Uint8Array(await response.arrayBuffer()) : (0, _util.stringToBytes)(await response.text());
                    }
                    return new Promise((resolve, reject)=>{
                        const request = new XMLHttpRequest();
                        request.open("GET", url, true);
                        if (asTypedArray) request.responseType = "arraybuffer";
                        request.onreadystatechange = ()=>{
                            if (request.readyState !== XMLHttpRequest.DONE) return;
                            if (request.status === 200 || request.status === 0) {
                                let data;
                                if (asTypedArray && request.response) data = new Uint8Array(request.response);
                                else if (!asTypedArray && request.responseText) data = (0, _util.stringToBytes)(request.responseText);
                                if (data) {
                                    resolve(data);
                                    return;
                                }
                            }
                            reject(new Error(request.statusText));
                        };
                        request.send(null);
                    });
                }
                class DOMCMapReaderFactory extends _base_factory.BaseCMapReaderFactory {
                    _fetchData(url, compressionType) {
                        return fetchData(url, this.isCompressed).then((data)=>{
                            return {
                                cMapData: data,
                                compressionType: compressionType
                            };
                        });
                    }
                }
                exports.DOMCMapReaderFactory = DOMCMapReaderFactory;
                class DOMStandardFontDataFactory extends _base_factory.BaseStandardFontDataFactory {
                    _fetchData(url) {
                        return fetchData(url, true);
                    }
                }
                exports.DOMStandardFontDataFactory = DOMStandardFontDataFactory;
                class DOMSVGFactory extends _base_factory.BaseSVGFactory {
                    _createSVG(type) {
                        return document.createElementNS(SVG_NS, type);
                    }
                }
                exports.DOMSVGFactory = DOMSVGFactory;
                class PageViewport {
                    constructor({ viewBox, scale, rotation, offsetX = 0, offsetY = 0, dontFlip = false }){
                        this.viewBox = viewBox;
                        this.scale = scale;
                        this.rotation = rotation;
                        this.offsetX = offsetX;
                        this.offsetY = offsetY;
                        const centerX = (viewBox[2] + viewBox[0]) / 2;
                        const centerY = (viewBox[3] + viewBox[1]) / 2;
                        let rotateA, rotateB, rotateC, rotateD;
                        rotation %= 360;
                        if (rotation < 0) rotation += 360;
                        switch(rotation){
                            case 180:
                                rotateA = -1;
                                rotateB = 0;
                                rotateC = 0;
                                rotateD = 1;
                                break;
                            case 90:
                                rotateA = 0;
                                rotateB = 1;
                                rotateC = 1;
                                rotateD = 0;
                                break;
                            case 270:
                                rotateA = 0;
                                rotateB = -1;
                                rotateC = -1;
                                rotateD = 0;
                                break;
                            case 0:
                                rotateA = 1;
                                rotateB = 0;
                                rotateC = 0;
                                rotateD = -1;
                                break;
                            default:
                                throw new Error("PageViewport: Invalid rotation, must be a multiple of 90 degrees.");
                        }
                        if (dontFlip) {
                            rotateC = -rotateC;
                            rotateD = -rotateD;
                        }
                        let offsetCanvasX, offsetCanvasY;
                        let width, height;
                        if (rotateA === 0) {
                            offsetCanvasX = Math.abs(centerY - viewBox[1]) * scale + offsetX;
                            offsetCanvasY = Math.abs(centerX - viewBox[0]) * scale + offsetY;
                            width = (viewBox[3] - viewBox[1]) * scale;
                            height = (viewBox[2] - viewBox[0]) * scale;
                        } else {
                            offsetCanvasX = Math.abs(centerX - viewBox[0]) * scale + offsetX;
                            offsetCanvasY = Math.abs(centerY - viewBox[1]) * scale + offsetY;
                            width = (viewBox[2] - viewBox[0]) * scale;
                            height = (viewBox[3] - viewBox[1]) * scale;
                        }
                        this.transform = [
                            rotateA * scale,
                            rotateB * scale,
                            rotateC * scale,
                            rotateD * scale,
                            offsetCanvasX - rotateA * scale * centerX - rotateC * scale * centerY,
                            offsetCanvasY - rotateB * scale * centerX - rotateD * scale * centerY
                        ];
                        this.width = width;
                        this.height = height;
                    }
                    get rawDims() {
                        const { viewBox } = this;
                        return (0, _util.shadow)(this, "rawDims", {
                            pageWidth: viewBox[2] - viewBox[0],
                            pageHeight: viewBox[3] - viewBox[1],
                            pageX: viewBox[0],
                            pageY: viewBox[1]
                        });
                    }
                    clone({ scale = this.scale, rotation = this.rotation, offsetX = this.offsetX, offsetY = this.offsetY, dontFlip = false } = {}) {
                        return new PageViewport({
                            viewBox: this.viewBox.slice(),
                            scale: scale,
                            rotation: rotation,
                            offsetX: offsetX,
                            offsetY: offsetY,
                            dontFlip: dontFlip
                        });
                    }
                    convertToViewportPoint(x, y) {
                        return _util.Util.applyTransform([
                            x,
                            y
                        ], this.transform);
                    }
                    convertToViewportRectangle(rect) {
                        const topLeft = _util.Util.applyTransform([
                            rect[0],
                            rect[1]
                        ], this.transform);
                        const bottomRight = _util.Util.applyTransform([
                            rect[2],
                            rect[3]
                        ], this.transform);
                        return [
                            topLeft[0],
                            topLeft[1],
                            bottomRight[0],
                            bottomRight[1]
                        ];
                    }
                    convertToPdfPoint(x, y) {
                        return _util.Util.applyInverseTransform([
                            x,
                            y
                        ], this.transform);
                    }
                }
                exports.PageViewport = PageViewport;
                class RenderingCancelledException extends _util.BaseException {
                    constructor(msg, extraDelay = 0){
                        super(msg, "RenderingCancelledException");
                        this.extraDelay = extraDelay;
                    }
                }
                exports.RenderingCancelledException = RenderingCancelledException;
                function isDataScheme(url) {
                    const ii = url.length;
                    let i = 0;
                    while(i < ii && url[i].trim() === "")i++;
                    return url.substring(i, i + 5).toLowerCase() === "data:";
                }
                function isPdfFile(filename) {
                    return typeof filename === "string" && /\.pdf$/i.test(filename);
                }
                function getFilenameFromUrl(url, onlyStripPath = false) {
                    if (!onlyStripPath) [url] = url.split(/[#?]/, 1);
                    return url.substring(url.lastIndexOf("/") + 1);
                }
                function getPdfFilenameFromUrl(url, defaultFilename = "document.pdf") {
                    if (typeof url !== "string") return defaultFilename;
                    if (isDataScheme(url)) {
                        (0, _util.warn)('getPdfFilenameFromUrl: ignore "data:"-URL for performance reasons.');
                        return defaultFilename;
                    }
                    const reURI = /^(?:(?:[^:]+:)?\/\/[^/]+)?([^?#]*)(\?[^#]*)?(#.*)?$/;
                    const reFilename = /[^/?#=]+\.pdf\b(?!.*\.pdf\b)/i;
                    const splitURI = reURI.exec(url);
                    let suggestedFilename = reFilename.exec(splitURI[1]) || reFilename.exec(splitURI[2]) || reFilename.exec(splitURI[3]);
                    if (suggestedFilename) {
                        suggestedFilename = suggestedFilename[0];
                        if (suggestedFilename.includes("%")) try {
                            suggestedFilename = reFilename.exec(decodeURIComponent(suggestedFilename))[0];
                        } catch  {}
                    }
                    return suggestedFilename || defaultFilename;
                }
                class StatTimer {
                    started = Object.create(null);
                    times = [];
                    time(name) {
                        if (name in this.started) (0, _util.warn)(`Timer is already running for ${name}`);
                        this.started[name] = Date.now();
                    }
                    timeEnd(name) {
                        if (!(name in this.started)) (0, _util.warn)(`Timer has not been started for ${name}`);
                        this.times.push({
                            name: name,
                            start: this.started[name],
                            end: Date.now()
                        });
                        delete this.started[name];
                    }
                    toString() {
                        const outBuf = [];
                        let longest = 0;
                        for (const { name } of this.times)longest = Math.max(name.length, longest);
                        for (const { name, start, end } of this.times)outBuf.push(`${name.padEnd(longest)} ${end - start}ms\n`);
                        return outBuf.join("");
                    }
                }
                exports.StatTimer = StatTimer;
                function isValidFetchUrl(url, baseUrl) {
                    try {
                        const { protocol } = baseUrl ? new URL(url, baseUrl) : new URL(url);
                        return protocol === "http:" || protocol === "https:";
                    } catch  {
                        return false;
                    }
                }
                function noContextMenu(e) {
                    e.preventDefault();
                }
                function loadScript(src, removeScriptElement = false) {
                    return new Promise((resolve, reject)=>{
                        const script = document.createElement("script");
                        script.src = src;
                        script.onload = function(evt) {
                            if (removeScriptElement) script.remove();
                            resolve(evt);
                        };
                        script.onerror = function() {
                            reject(new Error(`Cannot load script at: ${script.src}`));
                        };
                        (document.head || document.documentElement).append(script);
                    });
                }
                function deprecated(details) {
                    console.log("Deprecated API usage: " + details);
                }
                let pdfDateStringRegex;
                class PDFDateString {
                    static toDateObject(input) {
                        if (!input || typeof input !== "string") return null;
                        pdfDateStringRegex ||= new RegExp("^D:(\\d{4})(\\d{2})?(\\d{2})?(\\d{2})?(\\d{2})?(\\d{2})?([Z|+|-])?(\\d{2})?'?(\\d{2})?'?");
                        const matches = pdfDateStringRegex.exec(input);
                        if (!matches) return null;
                        const year = parseInt(matches[1], 10);
                        let month = parseInt(matches[2], 10);
                        month = month >= 1 && month <= 12 ? month - 1 : 0;
                        let day = parseInt(matches[3], 10);
                        day = day >= 1 && day <= 31 ? day : 1;
                        let hour = parseInt(matches[4], 10);
                        hour = hour >= 0 && hour <= 23 ? hour : 0;
                        let minute = parseInt(matches[5], 10);
                        minute = minute >= 0 && minute <= 59 ? minute : 0;
                        let second = parseInt(matches[6], 10);
                        second = second >= 0 && second <= 59 ? second : 0;
                        const universalTimeRelation = matches[7] || "Z";
                        let offsetHour = parseInt(matches[8], 10);
                        offsetHour = offsetHour >= 0 && offsetHour <= 23 ? offsetHour : 0;
                        let offsetMinute = parseInt(matches[9], 10) || 0;
                        offsetMinute = offsetMinute >= 0 && offsetMinute <= 59 ? offsetMinute : 0;
                        if (universalTimeRelation === "-") {
                            hour += offsetHour;
                            minute += offsetMinute;
                        } else if (universalTimeRelation === "+") {
                            hour -= offsetHour;
                            minute -= offsetMinute;
                        }
                        return new Date(Date.UTC(year, month, day, hour, minute, second));
                    }
                }
                exports.PDFDateString = PDFDateString;
                function getXfaPageViewport(xfaPage, { scale = 1, rotation = 0 }) {
                    const { width, height } = xfaPage.attributes.style;
                    const viewBox = [
                        0,
                        0,
                        parseInt(width),
                        parseInt(height)
                    ];
                    return new PageViewport({
                        viewBox: viewBox,
                        scale: scale,
                        rotation: rotation
                    });
                }
                function getRGB(color) {
                    if (color.startsWith("#")) {
                        const colorRGB = parseInt(color.slice(1), 16);
                        return [
                            (colorRGB & 0xff0000) >> 16,
                            (colorRGB & 0x00ff00) >> 8,
                            colorRGB & 0x0000ff
                        ];
                    }
                    if (color.startsWith("rgb(")) return color.slice(4, -1).split(",").map((x)=>parseInt(x));
                    if (color.startsWith("rgba(")) return color.slice(5, -1).split(",").map((x)=>parseInt(x)).slice(0, 3);
                    (0, _util.warn)(`Not a valid color format: "${color}"`);
                    return [
                        0,
                        0,
                        0
                    ];
                }
                function getColorValues(colors) {
                    const span = document.createElement("span");
                    span.style.visibility = "hidden";
                    document.body.append(span);
                    for (const name of colors.keys()){
                        span.style.color = name;
                        const computedColor = window.getComputedStyle(span).color;
                        colors.set(name, getRGB(computedColor));
                    }
                    span.remove();
                }
                function getCurrentTransform(ctx) {
                    const { a, b, c, d, e, f } = ctx.getTransform();
                    return [
                        a,
                        b,
                        c,
                        d,
                        e,
                        f
                    ];
                }
                function getCurrentTransformInverse(ctx) {
                    const { a, b, c, d, e, f } = ctx.getTransform().invertSelf();
                    return [
                        a,
                        b,
                        c,
                        d,
                        e,
                        f
                    ];
                }
                function setLayerDimensions(div, viewport, mustFlip = false, mustRotate = true) {
                    if (viewport instanceof PageViewport) {
                        const { pageWidth, pageHeight } = viewport.rawDims;
                        const { style } = div;
                        const useRound = _util.FeatureTest.isCSSRoundSupported;
                        const w = `var(--scale-factor) * ${pageWidth}px`, h = `var(--scale-factor) * ${pageHeight}px`;
                        const widthStr = useRound ? `round(${w}, 1px)` : `calc(${w})`, heightStr = useRound ? `round(${h}, 1px)` : `calc(${h})`;
                        if (!mustFlip || viewport.rotation % 180 === 0) {
                            style.width = widthStr;
                            style.height = heightStr;
                        } else {
                            style.width = heightStr;
                            style.height = widthStr;
                        }
                    }
                    if (mustRotate) div.setAttribute("data-main-rotation", viewport.rotation);
                }
            /***/ },
            /* 7 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.BaseStandardFontDataFactory = exports.BaseSVGFactory = exports.BaseFilterFactory = exports.BaseCanvasFactory = exports.BaseCMapReaderFactory = void 0;
                var _util = __w_pdfjs_require__(1);
                class BaseFilterFactory {
                    constructor(){
                        if (this.constructor === BaseFilterFactory) (0, _util.unreachable)("Cannot initialize BaseFilterFactory.");
                    }
                    addFilter(maps) {
                        return "none";
                    }
                    addHCMFilter(fgColor, bgColor) {
                        return "none";
                    }
                    addHighlightHCMFilter(fgColor, bgColor, newFgColor, newBgColor) {
                        return "none";
                    }
                    destroy(keepHCM = false) {}
                }
                exports.BaseFilterFactory = BaseFilterFactory;
                class BaseCanvasFactory {
                    constructor(){
                        if (this.constructor === BaseCanvasFactory) (0, _util.unreachable)("Cannot initialize BaseCanvasFactory.");
                    }
                    create(width, height) {
                        if (width <= 0 || height <= 0) throw new Error("Invalid canvas size");
                        const canvas = this._createCanvas(width, height);
                        return {
                            canvas: canvas,
                            context: canvas.getContext("2d")
                        };
                    }
                    reset(canvasAndContext, width, height) {
                        if (!canvasAndContext.canvas) throw new Error("Canvas is not specified");
                        if (width <= 0 || height <= 0) throw new Error("Invalid canvas size");
                        canvasAndContext.canvas.width = width;
                        canvasAndContext.canvas.height = height;
                    }
                    destroy(canvasAndContext) {
                        if (!canvasAndContext.canvas) throw new Error("Canvas is not specified");
                        canvasAndContext.canvas.width = 0;
                        canvasAndContext.canvas.height = 0;
                        canvasAndContext.canvas = null;
                        canvasAndContext.context = null;
                    }
                    _createCanvas(width, height) {
                        (0, _util.unreachable)("Abstract method `_createCanvas` called.");
                    }
                }
                exports.BaseCanvasFactory = BaseCanvasFactory;
                class BaseCMapReaderFactory {
                    constructor({ baseUrl = null, isCompressed = true }){
                        if (this.constructor === BaseCMapReaderFactory) (0, _util.unreachable)("Cannot initialize BaseCMapReaderFactory.");
                        this.baseUrl = baseUrl;
                        this.isCompressed = isCompressed;
                    }
                    async fetch({ name }) {
                        if (!this.baseUrl) throw new Error('The CMap "baseUrl" parameter must be specified, ensure that the "cMapUrl" and "cMapPacked" API parameters are provided.');
                        if (!name) throw new Error("CMap name must be specified.");
                        const url = this.baseUrl + name + (this.isCompressed ? ".bcmap" : "");
                        const compressionType = this.isCompressed ? _util.CMapCompressionType.BINARY : _util.CMapCompressionType.NONE;
                        return this._fetchData(url, compressionType).catch((reason)=>{
                            throw new Error(`Unable to load ${this.isCompressed ? "binary " : ""}CMap at: ${url}`);
                        });
                    }
                    _fetchData(url, compressionType) {
                        (0, _util.unreachable)("Abstract method `_fetchData` called.");
                    }
                }
                exports.BaseCMapReaderFactory = BaseCMapReaderFactory;
                class BaseStandardFontDataFactory {
                    constructor({ baseUrl = null }){
                        if (this.constructor === BaseStandardFontDataFactory) (0, _util.unreachable)("Cannot initialize BaseStandardFontDataFactory.");
                        this.baseUrl = baseUrl;
                    }
                    async fetch({ filename }) {
                        if (!this.baseUrl) throw new Error('The standard font "baseUrl" parameter must be specified, ensure that the "standardFontDataUrl" API parameter is provided.');
                        if (!filename) throw new Error("Font filename must be specified.");
                        const url = `${this.baseUrl}${filename}`;
                        return this._fetchData(url).catch((reason)=>{
                            throw new Error(`Unable to load font data at: ${url}`);
                        });
                    }
                    _fetchData(url) {
                        (0, _util.unreachable)("Abstract method `_fetchData` called.");
                    }
                }
                exports.BaseStandardFontDataFactory = BaseStandardFontDataFactory;
                class BaseSVGFactory {
                    constructor(){
                        if (this.constructor === BaseSVGFactory) (0, _util.unreachable)("Cannot initialize BaseSVGFactory.");
                    }
                    create(width, height, skipDimensions = false) {
                        if (width <= 0 || height <= 0) throw new Error("Invalid SVG dimensions");
                        const svg = this._createSVG("svg:svg");
                        svg.setAttribute("version", "1.1");
                        if (!skipDimensions) {
                            svg.setAttribute("width", `${width}px`);
                            svg.setAttribute("height", `${height}px`);
                        }
                        svg.setAttribute("preserveAspectRatio", "none");
                        svg.setAttribute("viewBox", `0 0 ${width} ${height}`);
                        return svg;
                    }
                    createElement(type) {
                        if (typeof type !== "string") throw new Error("Invalid SVG element type");
                        return this._createSVG(type);
                    }
                    _createSVG(type) {
                        (0, _util.unreachable)("Abstract method `_createSVG` called.");
                    }
                }
                exports.BaseSVGFactory = BaseSVGFactory;
            /***/ },
            /* 8 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.MurmurHash3_64 = void 0;
                var _util = __w_pdfjs_require__(1);
                const SEED = 0xc3d2e1f0;
                const MASK_HIGH = 0xffff0000;
                const MASK_LOW = 0xffff;
                class MurmurHash3_64 {
                    constructor(seed){
                        this.h1 = seed ? seed & 0xffffffff : SEED;
                        this.h2 = seed ? seed & 0xffffffff : SEED;
                    }
                    update(input) {
                        let data, length;
                        if (typeof input === "string") {
                            data = new Uint8Array(input.length * 2);
                            length = 0;
                            for(let i = 0, ii = input.length; i < ii; i++){
                                const code = input.charCodeAt(i);
                                if (code <= 0xff) data[length++] = code;
                                else {
                                    data[length++] = code >>> 8;
                                    data[length++] = code & 0xff;
                                }
                            }
                        } else if ((0, _util.isArrayBuffer)(input)) {
                            data = input.slice();
                            length = data.byteLength;
                        } else throw new Error("Wrong data format in MurmurHash3_64_update. Input must be a string or array.");
                        const blockCounts = length >> 2;
                        const tailLength = length - blockCounts * 4;
                        const dataUint32 = new Uint32Array(data.buffer, 0, blockCounts);
                        let k1 = 0, k2 = 0;
                        let h1 = this.h1, h2 = this.h2;
                        const C1 = 0xcc9e2d51, C2 = 0x1b873593;
                        const C1_LOW = C1 & MASK_LOW, C2_LOW = C2 & MASK_LOW;
                        for(let i = 0; i < blockCounts; i++)if (i & 1) {
                            k1 = dataUint32[i];
                            k1 = k1 * C1 & MASK_HIGH | k1 * C1_LOW & MASK_LOW;
                            k1 = k1 << 15 | k1 >>> 17;
                            k1 = k1 * C2 & MASK_HIGH | k1 * C2_LOW & MASK_LOW;
                            h1 ^= k1;
                            h1 = h1 << 13 | h1 >>> 19;
                            h1 = h1 * 5 + 0xe6546b64;
                        } else {
                            k2 = dataUint32[i];
                            k2 = k2 * C1 & MASK_HIGH | k2 * C1_LOW & MASK_LOW;
                            k2 = k2 << 15 | k2 >>> 17;
                            k2 = k2 * C2 & MASK_HIGH | k2 * C2_LOW & MASK_LOW;
                            h2 ^= k2;
                            h2 = h2 << 13 | h2 >>> 19;
                            h2 = h2 * 5 + 0xe6546b64;
                        }
                        k1 = 0;
                        switch(tailLength){
                            case 3:
                                k1 ^= data[blockCounts * 4 + 2] << 16;
                            case 2:
                                k1 ^= data[blockCounts * 4 + 1] << 8;
                            case 1:
                                k1 ^= data[blockCounts * 4];
                                k1 = k1 * C1 & MASK_HIGH | k1 * C1_LOW & MASK_LOW;
                                k1 = k1 << 15 | k1 >>> 17;
                                k1 = k1 * C2 & MASK_HIGH | k1 * C2_LOW & MASK_LOW;
                                if (blockCounts & 1) h1 ^= k1;
                                else h2 ^= k1;
                        }
                        this.h1 = h1;
                        this.h2 = h2;
                    }
                    hexdigest() {
                        let h1 = this.h1, h2 = this.h2;
                        h1 ^= h2 >>> 1;
                        h1 = h1 * 0xed558ccd & MASK_HIGH | h1 * 0x8ccd & MASK_LOW;
                        h2 = h2 * 0xff51afd7 & MASK_HIGH | ((h2 << 16 | h1 >>> 16) * 0xafd7ed55 & MASK_HIGH) >>> 16;
                        h1 ^= h2 >>> 1;
                        h1 = h1 * 0x1a85ec53 & MASK_HIGH | h1 * 0xec53 & MASK_LOW;
                        h2 = h2 * 0xc4ceb9fe & MASK_HIGH | ((h2 << 16 | h1 >>> 16) * 0xb9fe1a85 & MASK_HIGH) >>> 16;
                        h1 ^= h2 >>> 1;
                        return (h1 >>> 0).toString(16).padStart(8, "0") + (h2 >>> 0).toString(16).padStart(8, "0");
                    }
                }
                exports.MurmurHash3_64 = MurmurHash3_64;
            /***/ },
            /* 9 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.FontLoader = exports.FontFaceObject = void 0;
                var _util = __w_pdfjs_require__(1);
                class FontLoader {
                    #systemFonts = new Set();
                    constructor({ ownerDocument = globalThis.document, styleElement = null }){
                        this._document = ownerDocument;
                        this.nativeFontFaces = new Set();
                        this.styleElement = null;
                        this.loadingRequests = [];
                        this.loadTestFontId = 0;
                    }
                    addNativeFontFace(nativeFontFace) {
                        this.nativeFontFaces.add(nativeFontFace);
                        this._document.fonts.add(nativeFontFace);
                    }
                    removeNativeFontFace(nativeFontFace) {
                        this.nativeFontFaces.delete(nativeFontFace);
                        this._document.fonts.delete(nativeFontFace);
                    }
                    insertRule(rule) {
                        if (!this.styleElement) {
                            this.styleElement = this._document.createElement("style");
                            this._document.documentElement.getElementsByTagName("head")[0].append(this.styleElement);
                        }
                        const styleSheet = this.styleElement.sheet;
                        styleSheet.insertRule(rule, styleSheet.cssRules.length);
                    }
                    clear() {
                        for (const nativeFontFace of this.nativeFontFaces)this._document.fonts.delete(nativeFontFace);
                        this.nativeFontFaces.clear();
                        this.#systemFonts.clear();
                        if (this.styleElement) {
                            this.styleElement.remove();
                            this.styleElement = null;
                        }
                    }
                    async loadSystemFont(info) {
                        if (!info || this.#systemFonts.has(info.loadedName)) return;
                        (0, _util.assert)(!this.disableFontFace, "loadSystemFont shouldn't be called when `disableFontFace` is set.");
                        if (this.isFontLoadingAPISupported) {
                            const { loadedName, src, style } = info;
                            const fontFace = new FontFace(loadedName, src, style);
                            this.addNativeFontFace(fontFace);
                            try {
                                await fontFace.load();
                                this.#systemFonts.add(loadedName);
                            } catch  {
                                (0, _util.warn)(`Cannot load system font: ${info.baseFontName}, installing it could help to improve PDF rendering.`);
                                this.removeNativeFontFace(fontFace);
                            }
                            return;
                        }
                        (0, _util.unreachable)("Not implemented: loadSystemFont without the Font Loading API.");
                    }
                    async bind(font) {
                        if (font.attached || font.missingFile && !font.systemFontInfo) return;
                        font.attached = true;
                        if (font.systemFontInfo) {
                            await this.loadSystemFont(font.systemFontInfo);
                            return;
                        }
                        if (this.isFontLoadingAPISupported) {
                            const nativeFontFace = font.createNativeFontFace();
                            if (nativeFontFace) {
                                this.addNativeFontFace(nativeFontFace);
                                try {
                                    await nativeFontFace.loaded;
                                } catch (ex) {
                                    (0, _util.warn)(`Failed to load font '${nativeFontFace.family}': '${ex}'.`);
                                    font.disableFontFace = true;
                                    throw ex;
                                }
                            }
                            return;
                        }
                        const rule = font.createFontFaceRule();
                        if (rule) {
                            this.insertRule(rule);
                            if (this.isSyncFontLoadingSupported) return;
                            await new Promise((resolve)=>{
                                const request = this._queueLoadingCallback(resolve);
                                this._prepareFontLoadEvent(font, request);
                            });
                        }
                    }
                    get isFontLoadingAPISupported() {
                        const hasFonts = !!this._document?.fonts;
                        return (0, _util.shadow)(this, "isFontLoadingAPISupported", hasFonts);
                    }
                    get isSyncFontLoadingSupported() {
                        let supported = false;
                        if (_util.isNodeJS) supported = true;
                        else if (typeof navigator !== "undefined" && /Mozilla\/5.0.*?rv:\d+.*? Gecko/.test(navigator.userAgent)) supported = true;
                        return (0, _util.shadow)(this, "isSyncFontLoadingSupported", supported);
                    }
                    _queueLoadingCallback(callback) {
                        function completeRequest() {
                            (0, _util.assert)(!request.done, "completeRequest() cannot be called twice.");
                            request.done = true;
                            while(loadingRequests.length > 0 && loadingRequests[0].done){
                                const otherRequest = loadingRequests.shift();
                                setTimeout(otherRequest.callback, 0);
                            }
                        }
                        const { loadingRequests } = this;
                        const request = {
                            done: false,
                            complete: completeRequest,
                            callback: callback
                        };
                        loadingRequests.push(request);
                        return request;
                    }
                    get _loadTestFont() {
                        const testFont = atob("T1RUTwALAIAAAwAwQ0ZGIDHtZg4AAAOYAAAAgUZGVE1lkzZwAAAEHAAAABxHREVGABQAFQAABDgAAAAeT1MvMlYNYwkAAAEgAAAAYGNtYXABDQLUAAACNAAAAUJoZWFk/xVFDQAAALwAAAA2aGhlYQdkA+oAAAD0AAAAJGhtdHgD6AAAAAAEWAAAAAZtYXhwAAJQAAAAARgAAAAGbmFtZVjmdH4AAAGAAAAAsXBvc3T/hgAzAAADeAAAACAAAQAAAAEAALZRFsRfDzz1AAsD6AAAAADOBOTLAAAAAM4KHDwAAAAAA+gDIQAAAAgAAgAAAAAAAAABAAADIQAAAFoD6AAAAAAD6AABAAAAAAAAAAAAAAAAAAAAAQAAUAAAAgAAAAQD6AH0AAUAAAKKArwAAACMAooCvAAAAeAAMQECAAACAAYJAAAAAAAAAAAAAQAAAAAAAAAAAAAAAFBmRWQAwAAuAC4DIP84AFoDIQAAAAAAAQAAAAAAAAAAACAAIAABAAAADgCuAAEAAAAAAAAAAQAAAAEAAAAAAAEAAQAAAAEAAAAAAAIAAQAAAAEAAAAAAAMAAQAAAAEAAAAAAAQAAQAAAAEAAAAAAAUAAQAAAAEAAAAAAAYAAQAAAAMAAQQJAAAAAgABAAMAAQQJAAEAAgABAAMAAQQJAAIAAgABAAMAAQQJAAMAAgABAAMAAQQJAAQAAgABAAMAAQQJAAUAAgABAAMAAQQJAAYAAgABWABYAAAAAAAAAwAAAAMAAAAcAAEAAAAAADwAAwABAAAAHAAEACAAAAAEAAQAAQAAAC7//wAAAC7////TAAEAAAAAAAABBgAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAAAAAAAD/gwAyAAAAAQAAAAAAAAAAAAAAAAAAAAABAAQEAAEBAQJYAAEBASH4DwD4GwHEAvgcA/gXBIwMAYuL+nz5tQXkD5j3CBLnEQACAQEBIVhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYAAABAQAADwACAQEEE/t3Dov6fAH6fAT+fPp8+nwHDosMCvm1Cvm1DAz6fBQAAAAAAAABAAAAAMmJbzEAAAAAzgTjFQAAAADOBOQpAAEAAAAAAAAADAAUAAQAAAABAAAAAgABAAAAAAAAAAAD6AAAAAAAAA==");
                        return (0, _util.shadow)(this, "_loadTestFont", testFont);
                    }
                    _prepareFontLoadEvent(font, request) {
                        function int32(data, offset) {
                            return data.charCodeAt(offset) << 24 | data.charCodeAt(offset + 1) << 16 | data.charCodeAt(offset + 2) << 8 | data.charCodeAt(offset + 3) & 0xff;
                        }
                        function spliceString(s, offset, remove, insert) {
                            const chunk1 = s.substring(0, offset);
                            const chunk2 = s.substring(offset + remove);
                            return chunk1 + insert + chunk2;
                        }
                        let i, ii;
                        const canvas = this._document.createElement("canvas");
                        canvas.width = 1;
                        canvas.height = 1;
                        const ctx = canvas.getContext("2d");
                        let called = 0;
                        function isFontReady(name, callback) {
                            if (++called > 30) {
                                (0, _util.warn)("Load test font never loaded.");
                                callback();
                                return;
                            }
                            ctx.font = "30px " + name;
                            ctx.fillText(".", 0, 20);
                            const imageData = ctx.getImageData(0, 0, 1, 1);
                            if (imageData.data[3] > 0) {
                                callback();
                                return;
                            }
                            setTimeout(isFontReady.bind(null, name, callback));
                        }
                        const loadTestFontId = `lt${Date.now()}${this.loadTestFontId++}`;
                        let data = this._loadTestFont;
                        const COMMENT_OFFSET = 976;
                        data = spliceString(data, COMMENT_OFFSET, loadTestFontId.length, loadTestFontId);
                        const CFF_CHECKSUM_OFFSET = 16;
                        const XXXX_VALUE = 0x58585858;
                        let checksum = int32(data, CFF_CHECKSUM_OFFSET);
                        for(i = 0, ii = loadTestFontId.length - 3; i < ii; i += 4)checksum = checksum - XXXX_VALUE + int32(loadTestFontId, i) | 0;
                        if (i < loadTestFontId.length) checksum = checksum - XXXX_VALUE + int32(loadTestFontId + "XXX", i) | 0;
                        data = spliceString(data, CFF_CHECKSUM_OFFSET, 4, (0, _util.string32)(checksum));
                        const url = `url(data:font/opentype;base64,${btoa(data)});`;
                        const rule = `@font-face {font-family:"${loadTestFontId}";src:${url}}`;
                        this.insertRule(rule);
                        const div = this._document.createElement("div");
                        div.style.visibility = "hidden";
                        div.style.width = div.style.height = "10px";
                        div.style.position = "absolute";
                        div.style.top = div.style.left = "0px";
                        for (const name of [
                            font.loadedName,
                            loadTestFontId
                        ]){
                            const span = this._document.createElement("span");
                            span.textContent = "Hi";
                            span.style.fontFamily = name;
                            div.append(span);
                        }
                        this._document.body.append(div);
                        isFontReady(loadTestFontId, ()=>{
                            div.remove();
                            request.complete();
                        });
                    }
                }
                exports.FontLoader = FontLoader;
                class FontFaceObject {
                    constructor(translatedData, { isEvalSupported = true, disableFontFace = false, ignoreErrors = false, inspectFont = null }){
                        this.compiledGlyphs = Object.create(null);
                        for(const i in translatedData)this[i] = translatedData[i];
                        this.isEvalSupported = isEvalSupported !== false;
                        this.disableFontFace = disableFontFace === true;
                        this.ignoreErrors = ignoreErrors === true;
                        this._inspectFont = inspectFont;
                    }
                    createNativeFontFace() {
                        if (!this.data || this.disableFontFace) return null;
                        let nativeFontFace;
                        if (!this.cssFontInfo) nativeFontFace = new FontFace(this.loadedName, this.data, {});
                        else {
                            const css = {
                                weight: this.cssFontInfo.fontWeight
                            };
                            if (this.cssFontInfo.italicAngle) css.style = `oblique ${this.cssFontInfo.italicAngle}deg`;
                            nativeFontFace = new FontFace(this.cssFontInfo.fontFamily, this.data, css);
                        }
                        this._inspectFont?.(this);
                        return nativeFontFace;
                    }
                    createFontFaceRule() {
                        if (!this.data || this.disableFontFace) return null;
                        const data = (0, _util.bytesToString)(this.data);
                        const url = `url(data:${this.mimetype};base64,${btoa(data)});`;
                        let rule;
                        if (!this.cssFontInfo) rule = `@font-face {font-family:"${this.loadedName}";src:${url}}`;
                        else {
                            let css = `font-weight: ${this.cssFontInfo.fontWeight};`;
                            if (this.cssFontInfo.italicAngle) css += `font-style: oblique ${this.cssFontInfo.italicAngle}deg;`;
                            rule = `@font-face {font-family:"${this.cssFontInfo.fontFamily}";${css}src:${url}}`;
                        }
                        this._inspectFont?.(this, url);
                        return rule;
                    }
                    getPathGenerator(objs, character) {
                        if (this.compiledGlyphs[character] !== undefined) return this.compiledGlyphs[character];
                        let cmds;
                        try {
                            cmds = objs.get(this.loadedName + "_path_" + character);
                        } catch (ex) {
                            if (!this.ignoreErrors) throw ex;
                            (0, _util.warn)(`getPathGenerator - ignoring character: "${ex}".`);
                            return this.compiledGlyphs[character] = function(c, size) {};
                        }
                        if (this.isEvalSupported && _util.FeatureTest.isEvalSupported) {
                            const jsBuf = [];
                            for (const current of cmds){
                                const args = current.args !== undefined ? current.args.join(",") : "";
                                jsBuf.push("c.", current.cmd, "(", args, ");\n");
                            }
                            return this.compiledGlyphs[character] = new Function("c", "size", jsBuf.join(""));
                        }
                        return this.compiledGlyphs[character] = function(c, size) {
                            for (const current of cmds){
                                if (current.cmd === "scale") current.args = [
                                    size,
                                    -size
                                ];
                                c[current.cmd].apply(c, current.args);
                            }
                        };
                    }
                }
                exports.FontFaceObject = FontFaceObject;
            /***/ },
            /* 10 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.NodeStandardFontDataFactory = exports.NodeFilterFactory = exports.NodeCanvasFactory = exports.NodeCMapReaderFactory = void 0;
                var _base_factory = __w_pdfjs_require__(7);
                var _util = __w_pdfjs_require__(1);
                const fetchData = function(url) {
                    return new Promise((resolve, reject)=>{
                        const fs = (parcelRequire("7NlT1"));
                        fs.readFile(url, (error, data)=>{
                            if (error || !data) {
                                reject(new Error(error));
                                return;
                            }
                            resolve(new Uint8Array(data));
                        });
                    });
                };
                class NodeFilterFactory extends _base_factory.BaseFilterFactory {
                }
                exports.NodeFilterFactory = NodeFilterFactory;
                class NodeCanvasFactory extends _base_factory.BaseCanvasFactory {
                    _createCanvas(width, height) {
                        const Canvas = (parcelRequire("7NlT1"));
                        return Canvas.createCanvas(width, height);
                    }
                }
                exports.NodeCanvasFactory = NodeCanvasFactory;
                class NodeCMapReaderFactory extends _base_factory.BaseCMapReaderFactory {
                    _fetchData(url, compressionType) {
                        return fetchData(url).then((data)=>{
                            return {
                                cMapData: data,
                                compressionType: compressionType
                            };
                        });
                    }
                }
                exports.NodeCMapReaderFactory = NodeCMapReaderFactory;
                class NodeStandardFontDataFactory extends _base_factory.BaseStandardFontDataFactory {
                    _fetchData(url) {
                        return fetchData(url);
                    }
                }
                exports.NodeStandardFontDataFactory = NodeStandardFontDataFactory;
            /***/ },
            /* 11 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.CanvasGraphics = void 0;
                var _util = __w_pdfjs_require__(1);
                var _display_utils = __w_pdfjs_require__(6);
                var _pattern_helper = __w_pdfjs_require__(12);
                var _image_utils = __w_pdfjs_require__(13);
                const MIN_FONT_SIZE = 16;
                const MAX_FONT_SIZE = 100;
                const MAX_GROUP_SIZE = 4096;
                const EXECUTION_TIME = 15;
                const EXECUTION_STEPS = 10;
                const MAX_SIZE_TO_COMPILE = 1000;
                const FULL_CHUNK_HEIGHT = 16;
                function mirrorContextOperations(ctx, destCtx) {
                    if (ctx._removeMirroring) throw new Error("Context is already forwarding operations.");
                    ctx.__originalSave = ctx.save;
                    ctx.__originalRestore = ctx.restore;
                    ctx.__originalRotate = ctx.rotate;
                    ctx.__originalScale = ctx.scale;
                    ctx.__originalTranslate = ctx.translate;
                    ctx.__originalTransform = ctx.transform;
                    ctx.__originalSetTransform = ctx.setTransform;
                    ctx.__originalResetTransform = ctx.resetTransform;
                    ctx.__originalClip = ctx.clip;
                    ctx.__originalMoveTo = ctx.moveTo;
                    ctx.__originalLineTo = ctx.lineTo;
                    ctx.__originalBezierCurveTo = ctx.bezierCurveTo;
                    ctx.__originalRect = ctx.rect;
                    ctx.__originalClosePath = ctx.closePath;
                    ctx.__originalBeginPath = ctx.beginPath;
                    ctx._removeMirroring = ()=>{
                        ctx.save = ctx.__originalSave;
                        ctx.restore = ctx.__originalRestore;
                        ctx.rotate = ctx.__originalRotate;
                        ctx.scale = ctx.__originalScale;
                        ctx.translate = ctx.__originalTranslate;
                        ctx.transform = ctx.__originalTransform;
                        ctx.setTransform = ctx.__originalSetTransform;
                        ctx.resetTransform = ctx.__originalResetTransform;
                        ctx.clip = ctx.__originalClip;
                        ctx.moveTo = ctx.__originalMoveTo;
                        ctx.lineTo = ctx.__originalLineTo;
                        ctx.bezierCurveTo = ctx.__originalBezierCurveTo;
                        ctx.rect = ctx.__originalRect;
                        ctx.closePath = ctx.__originalClosePath;
                        ctx.beginPath = ctx.__originalBeginPath;
                        delete ctx._removeMirroring;
                    };
                    ctx.save = function ctxSave() {
                        destCtx.save();
                        this.__originalSave();
                    };
                    ctx.restore = function ctxRestore() {
                        destCtx.restore();
                        this.__originalRestore();
                    };
                    ctx.translate = function ctxTranslate(x, y) {
                        destCtx.translate(x, y);
                        this.__originalTranslate(x, y);
                    };
                    ctx.scale = function ctxScale(x, y) {
                        destCtx.scale(x, y);
                        this.__originalScale(x, y);
                    };
                    ctx.transform = function ctxTransform(a, b, c, d, e, f) {
                        destCtx.transform(a, b, c, d, e, f);
                        this.__originalTransform(a, b, c, d, e, f);
                    };
                    ctx.setTransform = function ctxSetTransform(a, b, c, d, e, f) {
                        destCtx.setTransform(a, b, c, d, e, f);
                        this.__originalSetTransform(a, b, c, d, e, f);
                    };
                    ctx.resetTransform = function ctxResetTransform() {
                        destCtx.resetTransform();
                        this.__originalResetTransform();
                    };
                    ctx.rotate = function ctxRotate(angle) {
                        destCtx.rotate(angle);
                        this.__originalRotate(angle);
                    };
                    ctx.clip = function ctxRotate(rule) {
                        destCtx.clip(rule);
                        this.__originalClip(rule);
                    };
                    ctx.moveTo = function(x, y) {
                        destCtx.moveTo(x, y);
                        this.__originalMoveTo(x, y);
                    };
                    ctx.lineTo = function(x, y) {
                        destCtx.lineTo(x, y);
                        this.__originalLineTo(x, y);
                    };
                    ctx.bezierCurveTo = function(cp1x, cp1y, cp2x, cp2y, x, y) {
                        destCtx.bezierCurveTo(cp1x, cp1y, cp2x, cp2y, x, y);
                        this.__originalBezierCurveTo(cp1x, cp1y, cp2x, cp2y, x, y);
                    };
                    ctx.rect = function(x, y, width, height) {
                        destCtx.rect(x, y, width, height);
                        this.__originalRect(x, y, width, height);
                    };
                    ctx.closePath = function() {
                        destCtx.closePath();
                        this.__originalClosePath();
                    };
                    ctx.beginPath = function() {
                        destCtx.beginPath();
                        this.__originalBeginPath();
                    };
                }
                class CachedCanvases {
                    constructor(canvasFactory){
                        this.canvasFactory = canvasFactory;
                        this.cache = Object.create(null);
                    }
                    getCanvas(id, width, height) {
                        let canvasEntry;
                        if (this.cache[id] !== undefined) {
                            canvasEntry = this.cache[id];
                            this.canvasFactory.reset(canvasEntry, width, height);
                        } else {
                            canvasEntry = this.canvasFactory.create(width, height);
                            this.cache[id] = canvasEntry;
                        }
                        return canvasEntry;
                    }
                    delete(id) {
                        delete this.cache[id];
                    }
                    clear() {
                        for(const id in this.cache){
                            const canvasEntry = this.cache[id];
                            this.canvasFactory.destroy(canvasEntry);
                            delete this.cache[id];
                        }
                    }
                }
                function drawImageAtIntegerCoords(ctx, srcImg, srcX, srcY, srcW, srcH, destX, destY, destW, destH) {
                    const [a, b, c, d, tx, ty] = (0, _display_utils.getCurrentTransform)(ctx);
                    if (b === 0 && c === 0) {
                        const tlX = destX * a + tx;
                        const rTlX = Math.round(tlX);
                        const tlY = destY * d + ty;
                        const rTlY = Math.round(tlY);
                        const brX = (destX + destW) * a + tx;
                        const rWidth = Math.abs(Math.round(brX) - rTlX) || 1;
                        const brY = (destY + destH) * d + ty;
                        const rHeight = Math.abs(Math.round(brY) - rTlY) || 1;
                        ctx.setTransform(Math.sign(a), 0, 0, Math.sign(d), rTlX, rTlY);
                        ctx.drawImage(srcImg, srcX, srcY, srcW, srcH, 0, 0, rWidth, rHeight);
                        ctx.setTransform(a, b, c, d, tx, ty);
                        return [
                            rWidth,
                            rHeight
                        ];
                    }
                    if (a === 0 && d === 0) {
                        const tlX = destY * c + tx;
                        const rTlX = Math.round(tlX);
                        const tlY = destX * b + ty;
                        const rTlY = Math.round(tlY);
                        const brX = (destY + destH) * c + tx;
                        const rWidth = Math.abs(Math.round(brX) - rTlX) || 1;
                        const brY = (destX + destW) * b + ty;
                        const rHeight = Math.abs(Math.round(brY) - rTlY) || 1;
                        ctx.setTransform(0, Math.sign(b), Math.sign(c), 0, rTlX, rTlY);
                        ctx.drawImage(srcImg, srcX, srcY, srcW, srcH, 0, 0, rHeight, rWidth);
                        ctx.setTransform(a, b, c, d, tx, ty);
                        return [
                            rHeight,
                            rWidth
                        ];
                    }
                    ctx.drawImage(srcImg, srcX, srcY, srcW, srcH, destX, destY, destW, destH);
                    const scaleX = Math.hypot(a, b);
                    const scaleY = Math.hypot(c, d);
                    return [
                        scaleX * destW,
                        scaleY * destH
                    ];
                }
                function compileType3Glyph(imgData) {
                    const { width, height } = imgData;
                    if (width > MAX_SIZE_TO_COMPILE || height > MAX_SIZE_TO_COMPILE) return null;
                    const POINT_TO_PROCESS_LIMIT = 1000;
                    const POINT_TYPES = new Uint8Array([
                        0,
                        2,
                        4,
                        0,
                        1,
                        0,
                        5,
                        4,
                        8,
                        10,
                        0,
                        8,
                        0,
                        2,
                        1,
                        0
                    ]);
                    const width1 = width + 1;
                    let points = new Uint8Array(width1 * (height + 1));
                    let i, j, j0;
                    const lineSize = width + 7 & -8;
                    let data = new Uint8Array(lineSize * height), pos = 0;
                    for (const elem of imgData.data){
                        let mask = 128;
                        while(mask > 0){
                            data[pos++] = elem & mask ? 0 : 255;
                            mask >>= 1;
                        }
                    }
                    let count = 0;
                    pos = 0;
                    if (data[pos] !== 0) {
                        points[0] = 1;
                        ++count;
                    }
                    for(j = 1; j < width; j++){
                        if (data[pos] !== data[pos + 1]) {
                            points[j] = data[pos] ? 2 : 1;
                            ++count;
                        }
                        pos++;
                    }
                    if (data[pos] !== 0) {
                        points[j] = 2;
                        ++count;
                    }
                    for(i = 1; i < height; i++){
                        pos = i * lineSize;
                        j0 = i * width1;
                        if (data[pos - lineSize] !== data[pos]) {
                            points[j0] = data[pos] ? 1 : 8;
                            ++count;
                        }
                        let sum = (data[pos] ? 4 : 0) + (data[pos - lineSize] ? 8 : 0);
                        for(j = 1; j < width; j++){
                            sum = (sum >> 2) + (data[pos + 1] ? 4 : 0) + (data[pos - lineSize + 1] ? 8 : 0);
                            if (POINT_TYPES[sum]) {
                                points[j0 + j] = POINT_TYPES[sum];
                                ++count;
                            }
                            pos++;
                        }
                        if (data[pos - lineSize] !== data[pos]) {
                            points[j0 + j] = data[pos] ? 2 : 4;
                            ++count;
                        }
                        if (count > POINT_TO_PROCESS_LIMIT) return null;
                    }
                    pos = lineSize * (height - 1);
                    j0 = i * width1;
                    if (data[pos] !== 0) {
                        points[j0] = 8;
                        ++count;
                    }
                    for(j = 1; j < width; j++){
                        if (data[pos] !== data[pos + 1]) {
                            points[j0 + j] = data[pos] ? 4 : 8;
                            ++count;
                        }
                        pos++;
                    }
                    if (data[pos] !== 0) {
                        points[j0 + j] = 4;
                        ++count;
                    }
                    if (count > POINT_TO_PROCESS_LIMIT) return null;
                    const steps = new Int32Array([
                        0,
                        width1,
                        -1,
                        0,
                        -width1,
                        0,
                        0,
                        0,
                        1
                    ]);
                    const path = new Path2D();
                    for(i = 0; count && i <= height; i++){
                        let p = i * width1;
                        const end = p + width;
                        while(p < end && !points[p])p++;
                        if (p === end) continue;
                        path.moveTo(p % width1, i);
                        const p0 = p;
                        let type = points[p];
                        do {
                            const step = steps[type];
                            do p += step;
                            while (!points[p]);
                            const pp = points[p];
                            if (pp !== 5 && pp !== 10) {
                                type = pp;
                                points[p] = 0;
                            } else {
                                type = pp & 0x33 * type >> 4;
                                points[p] &= type >> 2 | type << 2;
                            }
                            path.lineTo(p % width1, p / width1 | 0);
                            if (!points[p]) --count;
                        }while (p0 !== p);
                        --i;
                    }
                    data = null;
                    points = null;
                    const drawOutline = function(c) {
                        c.save();
                        c.scale(1 / width, -1 / height);
                        c.translate(0, -height);
                        c.fill(path);
                        c.beginPath();
                        c.restore();
                    };
                    return drawOutline;
                }
                class CanvasExtraState {
                    constructor(width, height){
                        this.alphaIsShape = false;
                        this.fontSize = 0;
                        this.fontSizeScale = 1;
                        this.textMatrix = _util.IDENTITY_MATRIX;
                        this.textMatrixScale = 1;
                        this.fontMatrix = _util.FONT_IDENTITY_MATRIX;
                        this.leading = 0;
                        this.x = 0;
                        this.y = 0;
                        this.lineX = 0;
                        this.lineY = 0;
                        this.charSpacing = 0;
                        this.wordSpacing = 0;
                        this.textHScale = 1;
                        this.textRenderingMode = _util.TextRenderingMode.FILL;
                        this.textRise = 0;
                        this.fillColor = "#000000";
                        this.strokeColor = "#000000";
                        this.patternFill = false;
                        this.fillAlpha = 1;
                        this.strokeAlpha = 1;
                        this.lineWidth = 1;
                        this.activeSMask = null;
                        this.transferMaps = "none";
                        this.startNewPathAndClipBox([
                            0,
                            0,
                            width,
                            height
                        ]);
                    }
                    clone() {
                        const clone = Object.create(this);
                        clone.clipBox = this.clipBox.slice();
                        return clone;
                    }
                    setCurrentPoint(x, y) {
                        this.x = x;
                        this.y = y;
                    }
                    updatePathMinMax(transform, x, y) {
                        [x, y] = _util.Util.applyTransform([
                            x,
                            y
                        ], transform);
                        this.minX = Math.min(this.minX, x);
                        this.minY = Math.min(this.minY, y);
                        this.maxX = Math.max(this.maxX, x);
                        this.maxY = Math.max(this.maxY, y);
                    }
                    updateRectMinMax(transform, rect) {
                        const p1 = _util.Util.applyTransform(rect, transform);
                        const p2 = _util.Util.applyTransform(rect.slice(2), transform);
                        this.minX = Math.min(this.minX, p1[0], p2[0]);
                        this.minY = Math.min(this.minY, p1[1], p2[1]);
                        this.maxX = Math.max(this.maxX, p1[0], p2[0]);
                        this.maxY = Math.max(this.maxY, p1[1], p2[1]);
                    }
                    updateScalingPathMinMax(transform, minMax) {
                        _util.Util.scaleMinMax(transform, minMax);
                        this.minX = Math.min(this.minX, minMax[0]);
                        this.maxX = Math.max(this.maxX, minMax[1]);
                        this.minY = Math.min(this.minY, minMax[2]);
                        this.maxY = Math.max(this.maxY, minMax[3]);
                    }
                    updateCurvePathMinMax(transform, x0, y0, x1, y1, x2, y2, x3, y3, minMax) {
                        const box = _util.Util.bezierBoundingBox(x0, y0, x1, y1, x2, y2, x3, y3);
                        if (minMax) {
                            minMax[0] = Math.min(minMax[0], box[0], box[2]);
                            minMax[1] = Math.max(minMax[1], box[0], box[2]);
                            minMax[2] = Math.min(minMax[2], box[1], box[3]);
                            minMax[3] = Math.max(minMax[3], box[1], box[3]);
                            return;
                        }
                        this.updateRectMinMax(transform, box);
                    }
                    getPathBoundingBox(pathType = _pattern_helper.PathType.FILL, transform = null) {
                        const box = [
                            this.minX,
                            this.minY,
                            this.maxX,
                            this.maxY
                        ];
                        if (pathType === _pattern_helper.PathType.STROKE) {
                            if (!transform) (0, _util.unreachable)("Stroke bounding box must include transform.");
                            const scale = _util.Util.singularValueDecompose2dScale(transform);
                            const xStrokePad = scale[0] * this.lineWidth / 2;
                            const yStrokePad = scale[1] * this.lineWidth / 2;
                            box[0] -= xStrokePad;
                            box[1] -= yStrokePad;
                            box[2] += xStrokePad;
                            box[3] += yStrokePad;
                        }
                        return box;
                    }
                    updateClipFromPath() {
                        const intersect = _util.Util.intersect(this.clipBox, this.getPathBoundingBox());
                        this.startNewPathAndClipBox(intersect || [
                            0,
                            0,
                            0,
                            0
                        ]);
                    }
                    isEmptyClip() {
                        return this.minX === Infinity;
                    }
                    startNewPathAndClipBox(box) {
                        this.clipBox = box;
                        this.minX = Infinity;
                        this.minY = Infinity;
                        this.maxX = 0;
                        this.maxY = 0;
                    }
                    getClippedPathBoundingBox(pathType = _pattern_helper.PathType.FILL, transform = null) {
                        return _util.Util.intersect(this.clipBox, this.getPathBoundingBox(pathType, transform));
                    }
                }
                function putBinaryImageData(ctx, imgData) {
                    if (typeof ImageData !== "undefined" && imgData instanceof ImageData) {
                        ctx.putImageData(imgData, 0, 0);
                        return;
                    }
                    const height = imgData.height, width = imgData.width;
                    const partialChunkHeight = height % FULL_CHUNK_HEIGHT;
                    const fullChunks = (height - partialChunkHeight) / FULL_CHUNK_HEIGHT;
                    const totalChunks = partialChunkHeight === 0 ? fullChunks : fullChunks + 1;
                    const chunkImgData = ctx.createImageData(width, FULL_CHUNK_HEIGHT);
                    let srcPos = 0, destPos;
                    const src = imgData.data;
                    const dest = chunkImgData.data;
                    let i, j, thisChunkHeight, elemsInThisChunk;
                    if (imgData.kind === _util.ImageKind.GRAYSCALE_1BPP) {
                        const srcLength = src.byteLength;
                        const dest32 = new Uint32Array(dest.buffer, 0, dest.byteLength >> 2);
                        const dest32DataLength = dest32.length;
                        const fullSrcDiff = width + 7 >> 3;
                        const white = 0xffffffff;
                        const black = _util.FeatureTest.isLittleEndian ? 0xff000000 : 0x000000ff;
                        for(i = 0; i < totalChunks; i++){
                            thisChunkHeight = i < fullChunks ? FULL_CHUNK_HEIGHT : partialChunkHeight;
                            destPos = 0;
                            for(j = 0; j < thisChunkHeight; j++){
                                const srcDiff = srcLength - srcPos;
                                let k = 0;
                                const kEnd = srcDiff > fullSrcDiff ? width : srcDiff * 8 - 7;
                                const kEndUnrolled = kEnd & -8;
                                let mask = 0;
                                let srcByte = 0;
                                for(; k < kEndUnrolled; k += 8){
                                    srcByte = src[srcPos++];
                                    dest32[destPos++] = srcByte & 128 ? white : black;
                                    dest32[destPos++] = srcByte & 64 ? white : black;
                                    dest32[destPos++] = srcByte & 32 ? white : black;
                                    dest32[destPos++] = srcByte & 16 ? white : black;
                                    dest32[destPos++] = srcByte & 8 ? white : black;
                                    dest32[destPos++] = srcByte & 4 ? white : black;
                                    dest32[destPos++] = srcByte & 2 ? white : black;
                                    dest32[destPos++] = srcByte & 1 ? white : black;
                                }
                                for(; k < kEnd; k++){
                                    if (mask === 0) {
                                        srcByte = src[srcPos++];
                                        mask = 128;
                                    }
                                    dest32[destPos++] = srcByte & mask ? white : black;
                                    mask >>= 1;
                                }
                            }
                            while(destPos < dest32DataLength)dest32[destPos++] = 0;
                            ctx.putImageData(chunkImgData, 0, i * FULL_CHUNK_HEIGHT);
                        }
                    } else if (imgData.kind === _util.ImageKind.RGBA_32BPP) {
                        j = 0;
                        elemsInThisChunk = width * FULL_CHUNK_HEIGHT * 4;
                        for(i = 0; i < fullChunks; i++){
                            dest.set(src.subarray(srcPos, srcPos + elemsInThisChunk));
                            srcPos += elemsInThisChunk;
                            ctx.putImageData(chunkImgData, 0, j);
                            j += FULL_CHUNK_HEIGHT;
                        }
                        if (i < totalChunks) {
                            elemsInThisChunk = width * partialChunkHeight * 4;
                            dest.set(src.subarray(srcPos, srcPos + elemsInThisChunk));
                            ctx.putImageData(chunkImgData, 0, j);
                        }
                    } else if (imgData.kind === _util.ImageKind.RGB_24BPP) {
                        thisChunkHeight = FULL_CHUNK_HEIGHT;
                        elemsInThisChunk = width * thisChunkHeight;
                        for(i = 0; i < totalChunks; i++){
                            if (i >= fullChunks) {
                                thisChunkHeight = partialChunkHeight;
                                elemsInThisChunk = width * thisChunkHeight;
                            }
                            destPos = 0;
                            for(j = elemsInThisChunk; j--;){
                                dest[destPos++] = src[srcPos++];
                                dest[destPos++] = src[srcPos++];
                                dest[destPos++] = src[srcPos++];
                                dest[destPos++] = 255;
                            }
                            ctx.putImageData(chunkImgData, 0, i * FULL_CHUNK_HEIGHT);
                        }
                    } else throw new Error(`bad image kind: ${imgData.kind}`);
                }
                function putBinaryImageMask(ctx, imgData) {
                    if (imgData.bitmap) {
                        ctx.drawImage(imgData.bitmap, 0, 0);
                        return;
                    }
                    const height = imgData.height, width = imgData.width;
                    const partialChunkHeight = height % FULL_CHUNK_HEIGHT;
                    const fullChunks = (height - partialChunkHeight) / FULL_CHUNK_HEIGHT;
                    const totalChunks = partialChunkHeight === 0 ? fullChunks : fullChunks + 1;
                    const chunkImgData = ctx.createImageData(width, FULL_CHUNK_HEIGHT);
                    let srcPos = 0;
                    const src = imgData.data;
                    const dest = chunkImgData.data;
                    for(let i = 0; i < totalChunks; i++){
                        const thisChunkHeight = i < fullChunks ? FULL_CHUNK_HEIGHT : partialChunkHeight;
                        ({ srcPos } = (0, _image_utils.convertBlackAndWhiteToRGBA)({
                            src: src,
                            srcPos: srcPos,
                            dest: dest,
                            width: width,
                            height: thisChunkHeight,
                            nonBlackColor: 0
                        }));
                        ctx.putImageData(chunkImgData, 0, i * FULL_CHUNK_HEIGHT);
                    }
                }
                function copyCtxState(sourceCtx, destCtx) {
                    const properties = [
                        "strokeStyle",
                        "fillStyle",
                        "fillRule",
                        "globalAlpha",
                        "lineWidth",
                        "lineCap",
                        "lineJoin",
                        "miterLimit",
                        "globalCompositeOperation",
                        "font",
                        "filter"
                    ];
                    for (const property of properties)if (sourceCtx[property] !== undefined) destCtx[property] = sourceCtx[property];
                    if (sourceCtx.setLineDash !== undefined) {
                        destCtx.setLineDash(sourceCtx.getLineDash());
                        destCtx.lineDashOffset = sourceCtx.lineDashOffset;
                    }
                }
                function resetCtxToDefault(ctx) {
                    ctx.strokeStyle = ctx.fillStyle = "#000000";
                    ctx.fillRule = "nonzero";
                    ctx.globalAlpha = 1;
                    ctx.lineWidth = 1;
                    ctx.lineCap = "butt";
                    ctx.lineJoin = "miter";
                    ctx.miterLimit = 10;
                    ctx.globalCompositeOperation = "source-over";
                    ctx.font = "10px sans-serif";
                    if (ctx.setLineDash !== undefined) {
                        ctx.setLineDash([]);
                        ctx.lineDashOffset = 0;
                    }
                    if (!_util.isNodeJS) {
                        const { filter } = ctx;
                        if (filter !== "none" && filter !== "") ctx.filter = "none";
                    }
                }
                function composeSMaskBackdrop(bytes, r0, g0, b0) {
                    const length = bytes.length;
                    for(let i = 3; i < length; i += 4){
                        const alpha = bytes[i];
                        if (alpha === 0) {
                            bytes[i - 3] = r0;
                            bytes[i - 2] = g0;
                            bytes[i - 1] = b0;
                        } else if (alpha < 255) {
                            const alpha_ = 255 - alpha;
                            bytes[i - 3] = bytes[i - 3] * alpha + r0 * alpha_ >> 8;
                            bytes[i - 2] = bytes[i - 2] * alpha + g0 * alpha_ >> 8;
                            bytes[i - 1] = bytes[i - 1] * alpha + b0 * alpha_ >> 8;
                        }
                    }
                }
                function composeSMaskAlpha(maskData, layerData, transferMap) {
                    const length = maskData.length;
                    const scale = 1 / 255;
                    for(let i = 3; i < length; i += 4){
                        const alpha = transferMap ? transferMap[maskData[i]] : maskData[i];
                        layerData[i] = layerData[i] * alpha * scale | 0;
                    }
                }
                function composeSMaskLuminosity(maskData, layerData, transferMap) {
                    const length = maskData.length;
                    for(let i = 3; i < length; i += 4){
                        const y = maskData[i - 3] * 77 + maskData[i - 2] * 152 + maskData[i - 1] * 28;
                        layerData[i] = transferMap ? layerData[i] * transferMap[y >> 8] >> 8 : layerData[i] * y >> 16;
                    }
                }
                function genericComposeSMask(maskCtx, layerCtx, width, height, subtype, backdrop, transferMap, layerOffsetX, layerOffsetY, maskOffsetX, maskOffsetY) {
                    const hasBackdrop = !!backdrop;
                    const r0 = hasBackdrop ? backdrop[0] : 0;
                    const g0 = hasBackdrop ? backdrop[1] : 0;
                    const b0 = hasBackdrop ? backdrop[2] : 0;
                    const composeFn = subtype === "Luminosity" ? composeSMaskLuminosity : composeSMaskAlpha;
                    const PIXELS_TO_PROCESS = 1048576;
                    const chunkSize = Math.min(height, Math.ceil(PIXELS_TO_PROCESS / width));
                    for(let row = 0; row < height; row += chunkSize){
                        const chunkHeight = Math.min(chunkSize, height - row);
                        const maskData = maskCtx.getImageData(layerOffsetX - maskOffsetX, row + (layerOffsetY - maskOffsetY), width, chunkHeight);
                        const layerData = layerCtx.getImageData(layerOffsetX, row + layerOffsetY, width, chunkHeight);
                        if (hasBackdrop) composeSMaskBackdrop(maskData.data, r0, g0, b0);
                        composeFn(maskData.data, layerData.data, transferMap);
                        layerCtx.putImageData(layerData, layerOffsetX, row + layerOffsetY);
                    }
                }
                function composeSMask(ctx, smask, layerCtx, layerBox) {
                    const layerOffsetX = layerBox[0];
                    const layerOffsetY = layerBox[1];
                    const layerWidth = layerBox[2] - layerOffsetX;
                    const layerHeight = layerBox[3] - layerOffsetY;
                    if (layerWidth === 0 || layerHeight === 0) return;
                    genericComposeSMask(smask.context, layerCtx, layerWidth, layerHeight, smask.subtype, smask.backdrop, smask.transferMap, layerOffsetX, layerOffsetY, smask.offsetX, smask.offsetY);
                    ctx.save();
                    ctx.globalAlpha = 1;
                    ctx.globalCompositeOperation = "source-over";
                    ctx.setTransform(1, 0, 0, 1, 0, 0);
                    ctx.drawImage(layerCtx.canvas, 0, 0);
                    ctx.restore();
                }
                function getImageSmoothingEnabled(transform, interpolate) {
                    const scale = _util.Util.singularValueDecompose2dScale(transform);
                    scale[0] = Math.fround(scale[0]);
                    scale[1] = Math.fround(scale[1]);
                    const actualScale = Math.fround((globalThis.devicePixelRatio || 1) * _display_utils.PixelsPerInch.PDF_TO_CSS_UNITS);
                    if (interpolate !== undefined) return interpolate;
                    else if (scale[0] <= actualScale || scale[1] <= actualScale) return true;
                    return false;
                }
                const LINE_CAP_STYLES = [
                    "butt",
                    "round",
                    "square"
                ];
                const LINE_JOIN_STYLES = [
                    "miter",
                    "round",
                    "bevel"
                ];
                const NORMAL_CLIP = {};
                const EO_CLIP = {};
                class CanvasGraphics {
                    constructor(canvasCtx, commonObjs, objs, canvasFactory, filterFactory, { optionalContentConfig, markedContentStack = null }, annotationCanvasMap, pageColors){
                        this.ctx = canvasCtx;
                        this.current = new CanvasExtraState(this.ctx.canvas.width, this.ctx.canvas.height);
                        this.stateStack = [];
                        this.pendingClip = null;
                        this.pendingEOFill = false;
                        this.res = null;
                        this.xobjs = null;
                        this.commonObjs = commonObjs;
                        this.objs = objs;
                        this.canvasFactory = canvasFactory;
                        this.filterFactory = filterFactory;
                        this.groupStack = [];
                        this.processingType3 = null;
                        this.baseTransform = null;
                        this.baseTransformStack = [];
                        this.groupLevel = 0;
                        this.smaskStack = [];
                        this.smaskCounter = 0;
                        this.tempSMask = null;
                        this.suspendedCtx = null;
                        this.contentVisible = true;
                        this.markedContentStack = markedContentStack || [];
                        this.optionalContentConfig = optionalContentConfig;
                        this.cachedCanvases = new CachedCanvases(this.canvasFactory);
                        this.cachedPatterns = new Map();
                        this.annotationCanvasMap = annotationCanvasMap;
                        this.viewportScale = 1;
                        this.outputScaleX = 1;
                        this.outputScaleY = 1;
                        this.pageColors = pageColors;
                        this._cachedScaleForStroking = [
                            -1,
                            0
                        ];
                        this._cachedGetSinglePixelWidth = null;
                        this._cachedBitmapsMap = new Map();
                    }
                    getObject(data, fallback = null) {
                        if (typeof data === "string") return data.startsWith("g_") ? this.commonObjs.get(data) : this.objs.get(data);
                        return fallback;
                    }
                    beginDrawing({ transform, viewport, transparency = false, background = null }) {
                        const width = this.ctx.canvas.width;
                        const height = this.ctx.canvas.height;
                        const savedFillStyle = this.ctx.fillStyle;
                        this.ctx.fillStyle = background || "#ffffff";
                        this.ctx.fillRect(0, 0, width, height);
                        this.ctx.fillStyle = savedFillStyle;
                        if (transparency) {
                            const transparentCanvas = this.cachedCanvases.getCanvas("transparent", width, height);
                            this.compositeCtx = this.ctx;
                            this.transparentCanvas = transparentCanvas.canvas;
                            this.ctx = transparentCanvas.context;
                            this.ctx.save();
                            this.ctx.transform(...(0, _display_utils.getCurrentTransform)(this.compositeCtx));
                        }
                        this.ctx.save();
                        resetCtxToDefault(this.ctx);
                        if (transform) {
                            this.ctx.transform(...transform);
                            this.outputScaleX = transform[0];
                            this.outputScaleY = transform[0];
                        }
                        this.ctx.transform(...viewport.transform);
                        this.viewportScale = viewport.scale;
                        this.baseTransform = (0, _display_utils.getCurrentTransform)(this.ctx);
                    }
                    executeOperatorList(operatorList, executionStartIdx, continueCallback, stepper) {
                        const argsArray = operatorList.argsArray;
                        const fnArray = operatorList.fnArray;
                        let i = executionStartIdx || 0;
                        const argsArrayLen = argsArray.length;
                        if (argsArrayLen === i) return i;
                        const chunkOperations = argsArrayLen - i > EXECUTION_STEPS && typeof continueCallback === "function";
                        const endTime = chunkOperations ? Date.now() + EXECUTION_TIME : 0;
                        let steps = 0;
                        const commonObjs = this.commonObjs;
                        const objs = this.objs;
                        let fnId;
                        while(true){
                            if (stepper !== undefined && i === stepper.nextBreakPoint) {
                                stepper.breakIt(i, continueCallback);
                                return i;
                            }
                            fnId = fnArray[i];
                            if (fnId !== _util.OPS.dependency) this[fnId].apply(this, argsArray[i]);
                            else for (const depObjId of argsArray[i]){
                                const objsPool = depObjId.startsWith("g_") ? commonObjs : objs;
                                if (!objsPool.has(depObjId)) {
                                    objsPool.get(depObjId, continueCallback);
                                    return i;
                                }
                            }
                            i++;
                            if (i === argsArrayLen) return i;
                            if (chunkOperations && ++steps > EXECUTION_STEPS) {
                                if (Date.now() > endTime) {
                                    continueCallback();
                                    return i;
                                }
                                steps = 0;
                            }
                        }
                    }
                    #restoreInitialState() {
                        while(this.stateStack.length || this.inSMaskMode)this.restore();
                        this.ctx.restore();
                        if (this.transparentCanvas) {
                            this.ctx = this.compositeCtx;
                            this.ctx.save();
                            this.ctx.setTransform(1, 0, 0, 1, 0, 0);
                            this.ctx.drawImage(this.transparentCanvas, 0, 0);
                            this.ctx.restore();
                            this.transparentCanvas = null;
                        }
                    }
                    endDrawing() {
                        this.#restoreInitialState();
                        this.cachedCanvases.clear();
                        this.cachedPatterns.clear();
                        for (const cache of this._cachedBitmapsMap.values()){
                            for (const canvas of cache.values())if (typeof HTMLCanvasElement !== "undefined" && canvas instanceof HTMLCanvasElement) canvas.width = canvas.height = 0;
                            cache.clear();
                        }
                        this._cachedBitmapsMap.clear();
                        this.#drawFilter();
                    }
                    #drawFilter() {
                        if (this.pageColors) {
                            const hcmFilterId = this.filterFactory.addHCMFilter(this.pageColors.foreground, this.pageColors.background);
                            if (hcmFilterId !== "none") {
                                const savedFilter = this.ctx.filter;
                                this.ctx.filter = hcmFilterId;
                                this.ctx.drawImage(this.ctx.canvas, 0, 0);
                                this.ctx.filter = savedFilter;
                            }
                        }
                    }
                    _scaleImage(img, inverseTransform) {
                        const width = img.width;
                        const height = img.height;
                        let widthScale = Math.max(Math.hypot(inverseTransform[0], inverseTransform[1]), 1);
                        let heightScale = Math.max(Math.hypot(inverseTransform[2], inverseTransform[3]), 1);
                        let paintWidth = width, paintHeight = height;
                        let tmpCanvasId = "prescale1";
                        let tmpCanvas, tmpCtx;
                        while(widthScale > 2 && paintWidth > 1 || heightScale > 2 && paintHeight > 1){
                            let newWidth = paintWidth, newHeight = paintHeight;
                            if (widthScale > 2 && paintWidth > 1) {
                                newWidth = paintWidth >= 16384 ? Math.floor(paintWidth / 2) - 1 || 1 : Math.ceil(paintWidth / 2);
                                widthScale /= paintWidth / newWidth;
                            }
                            if (heightScale > 2 && paintHeight > 1) {
                                newHeight = paintHeight >= 16384 ? Math.floor(paintHeight / 2) - 1 || 1 : Math.ceil(paintHeight) / 2;
                                heightScale /= paintHeight / newHeight;
                            }
                            tmpCanvas = this.cachedCanvases.getCanvas(tmpCanvasId, newWidth, newHeight);
                            tmpCtx = tmpCanvas.context;
                            tmpCtx.clearRect(0, 0, newWidth, newHeight);
                            tmpCtx.drawImage(img, 0, 0, paintWidth, paintHeight, 0, 0, newWidth, newHeight);
                            img = tmpCanvas.canvas;
                            paintWidth = newWidth;
                            paintHeight = newHeight;
                            tmpCanvasId = tmpCanvasId === "prescale1" ? "prescale2" : "prescale1";
                        }
                        return {
                            img: img,
                            paintWidth: paintWidth,
                            paintHeight: paintHeight
                        };
                    }
                    _createMaskCanvas(img) {
                        const ctx = this.ctx;
                        const { width, height } = img;
                        const fillColor = this.current.fillColor;
                        const isPatternFill = this.current.patternFill;
                        const currentTransform = (0, _display_utils.getCurrentTransform)(ctx);
                        let cache, cacheKey, scaled, maskCanvas;
                        if ((img.bitmap || img.data) && img.count > 1) {
                            const mainKey = img.bitmap || img.data.buffer;
                            cacheKey = JSON.stringify(isPatternFill ? currentTransform : [
                                currentTransform.slice(0, 4),
                                fillColor
                            ]);
                            cache = this._cachedBitmapsMap.get(mainKey);
                            if (!cache) {
                                cache = new Map();
                                this._cachedBitmapsMap.set(mainKey, cache);
                            }
                            const cachedImage = cache.get(cacheKey);
                            if (cachedImage && !isPatternFill) {
                                const offsetX = Math.round(Math.min(currentTransform[0], currentTransform[2]) + currentTransform[4]);
                                const offsetY = Math.round(Math.min(currentTransform[1], currentTransform[3]) + currentTransform[5]);
                                return {
                                    canvas: cachedImage,
                                    offsetX: offsetX,
                                    offsetY: offsetY
                                };
                            }
                            scaled = cachedImage;
                        }
                        if (!scaled) {
                            maskCanvas = this.cachedCanvases.getCanvas("maskCanvas", width, height);
                            putBinaryImageMask(maskCanvas.context, img);
                        }
                        let maskToCanvas = _util.Util.transform(currentTransform, [
                            1 / width,
                            0,
                            0,
                            -1 / height,
                            0,
                            0
                        ]);
                        maskToCanvas = _util.Util.transform(maskToCanvas, [
                            1,
                            0,
                            0,
                            1,
                            0,
                            -height
                        ]);
                        const cord1 = _util.Util.applyTransform([
                            0,
                            0
                        ], maskToCanvas);
                        const cord2 = _util.Util.applyTransform([
                            width,
                            height
                        ], maskToCanvas);
                        const rect = _util.Util.normalizeRect([
                            cord1[0],
                            cord1[1],
                            cord2[0],
                            cord2[1]
                        ]);
                        const drawnWidth = Math.round(rect[2] - rect[0]) || 1;
                        const drawnHeight = Math.round(rect[3] - rect[1]) || 1;
                        const fillCanvas = this.cachedCanvases.getCanvas("fillCanvas", drawnWidth, drawnHeight);
                        const fillCtx = fillCanvas.context;
                        const offsetX = Math.min(cord1[0], cord2[0]);
                        const offsetY = Math.min(cord1[1], cord2[1]);
                        fillCtx.translate(-offsetX, -offsetY);
                        fillCtx.transform(...maskToCanvas);
                        if (!scaled) {
                            scaled = this._scaleImage(maskCanvas.canvas, (0, _display_utils.getCurrentTransformInverse)(fillCtx));
                            scaled = scaled.img;
                            if (cache && isPatternFill) cache.set(cacheKey, scaled);
                        }
                        fillCtx.imageSmoothingEnabled = getImageSmoothingEnabled((0, _display_utils.getCurrentTransform)(fillCtx), img.interpolate);
                        drawImageAtIntegerCoords(fillCtx, scaled, 0, 0, scaled.width, scaled.height, 0, 0, width, height);
                        fillCtx.globalCompositeOperation = "source-in";
                        const inverse = _util.Util.transform((0, _display_utils.getCurrentTransformInverse)(fillCtx), [
                            1,
                            0,
                            0,
                            1,
                            -offsetX,
                            -offsetY
                        ]);
                        fillCtx.fillStyle = isPatternFill ? fillColor.getPattern(ctx, this, inverse, _pattern_helper.PathType.FILL) : fillColor;
                        fillCtx.fillRect(0, 0, width, height);
                        if (cache && !isPatternFill) {
                            this.cachedCanvases.delete("fillCanvas");
                            cache.set(cacheKey, fillCanvas.canvas);
                        }
                        return {
                            canvas: fillCanvas.canvas,
                            offsetX: Math.round(offsetX),
                            offsetY: Math.round(offsetY)
                        };
                    }
                    setLineWidth(width) {
                        if (width !== this.current.lineWidth) this._cachedScaleForStroking[0] = -1;
                        this.current.lineWidth = width;
                        this.ctx.lineWidth = width;
                    }
                    setLineCap(style) {
                        this.ctx.lineCap = LINE_CAP_STYLES[style];
                    }
                    setLineJoin(style) {
                        this.ctx.lineJoin = LINE_JOIN_STYLES[style];
                    }
                    setMiterLimit(limit) {
                        this.ctx.miterLimit = limit;
                    }
                    setDash(dashArray, dashPhase) {
                        const ctx = this.ctx;
                        if (ctx.setLineDash !== undefined) {
                            ctx.setLineDash(dashArray);
                            ctx.lineDashOffset = dashPhase;
                        }
                    }
                    setRenderingIntent(intent) {}
                    setFlatness(flatness) {}
                    setGState(states) {
                        for (const [key, value] of states)switch(key){
                            case "LW":
                                this.setLineWidth(value);
                                break;
                            case "LC":
                                this.setLineCap(value);
                                break;
                            case "LJ":
                                this.setLineJoin(value);
                                break;
                            case "ML":
                                this.setMiterLimit(value);
                                break;
                            case "D":
                                this.setDash(value[0], value[1]);
                                break;
                            case "RI":
                                this.setRenderingIntent(value);
                                break;
                            case "FL":
                                this.setFlatness(value);
                                break;
                            case "Font":
                                this.setFont(value[0], value[1]);
                                break;
                            case "CA":
                                this.current.strokeAlpha = value;
                                break;
                            case "ca":
                                this.current.fillAlpha = value;
                                this.ctx.globalAlpha = value;
                                break;
                            case "BM":
                                this.ctx.globalCompositeOperation = value;
                                break;
                            case "SMask":
                                this.current.activeSMask = value ? this.tempSMask : null;
                                this.tempSMask = null;
                                this.checkSMaskState();
                                break;
                            case "TR":
                                this.ctx.filter = this.current.transferMaps = this.filterFactory.addFilter(value);
                                break;
                        }
                    }
                    get inSMaskMode() {
                        return !!this.suspendedCtx;
                    }
                    checkSMaskState() {
                        const inSMaskMode = this.inSMaskMode;
                        if (this.current.activeSMask && !inSMaskMode) this.beginSMaskMode();
                        else if (!this.current.activeSMask && inSMaskMode) this.endSMaskMode();
                    }
                    beginSMaskMode() {
                        if (this.inSMaskMode) throw new Error("beginSMaskMode called while already in smask mode");
                        const drawnWidth = this.ctx.canvas.width;
                        const drawnHeight = this.ctx.canvas.height;
                        const cacheId = "smaskGroupAt" + this.groupLevel;
                        const scratchCanvas = this.cachedCanvases.getCanvas(cacheId, drawnWidth, drawnHeight);
                        this.suspendedCtx = this.ctx;
                        this.ctx = scratchCanvas.context;
                        const ctx = this.ctx;
                        ctx.setTransform(...(0, _display_utils.getCurrentTransform)(this.suspendedCtx));
                        copyCtxState(this.suspendedCtx, ctx);
                        mirrorContextOperations(ctx, this.suspendedCtx);
                        this.setGState([
                            [
                                "BM",
                                "source-over"
                            ],
                            [
                                "ca",
                                1
                            ],
                            [
                                "CA",
                                1
                            ]
                        ]);
                    }
                    endSMaskMode() {
                        if (!this.inSMaskMode) throw new Error("endSMaskMode called while not in smask mode");
                        this.ctx._removeMirroring();
                        copyCtxState(this.ctx, this.suspendedCtx);
                        this.ctx = this.suspendedCtx;
                        this.suspendedCtx = null;
                    }
                    compose(dirtyBox) {
                        if (!this.current.activeSMask) return;
                        if (!dirtyBox) dirtyBox = [
                            0,
                            0,
                            this.ctx.canvas.width,
                            this.ctx.canvas.height
                        ];
                        else {
                            dirtyBox[0] = Math.floor(dirtyBox[0]);
                            dirtyBox[1] = Math.floor(dirtyBox[1]);
                            dirtyBox[2] = Math.ceil(dirtyBox[2]);
                            dirtyBox[3] = Math.ceil(dirtyBox[3]);
                        }
                        const smask = this.current.activeSMask;
                        const suspendedCtx = this.suspendedCtx;
                        composeSMask(suspendedCtx, smask, this.ctx, dirtyBox);
                        this.ctx.save();
                        this.ctx.setTransform(1, 0, 0, 1, 0, 0);
                        this.ctx.clearRect(0, 0, this.ctx.canvas.width, this.ctx.canvas.height);
                        this.ctx.restore();
                    }
                    save() {
                        if (this.inSMaskMode) {
                            copyCtxState(this.ctx, this.suspendedCtx);
                            this.suspendedCtx.save();
                        } else this.ctx.save();
                        const old = this.current;
                        this.stateStack.push(old);
                        this.current = old.clone();
                    }
                    restore() {
                        if (this.stateStack.length === 0 && this.inSMaskMode) this.endSMaskMode();
                        if (this.stateStack.length !== 0) {
                            this.current = this.stateStack.pop();
                            if (this.inSMaskMode) {
                                this.suspendedCtx.restore();
                                copyCtxState(this.suspendedCtx, this.ctx);
                            } else this.ctx.restore();
                            this.checkSMaskState();
                            this.pendingClip = null;
                            this._cachedScaleForStroking[0] = -1;
                            this._cachedGetSinglePixelWidth = null;
                        }
                    }
                    transform(a, b, c, d, e, f) {
                        this.ctx.transform(a, b, c, d, e, f);
                        this._cachedScaleForStroking[0] = -1;
                        this._cachedGetSinglePixelWidth = null;
                    }
                    constructPath(ops, args, minMax) {
                        const ctx = this.ctx;
                        const current = this.current;
                        let x = current.x, y = current.y;
                        let startX, startY;
                        const currentTransform = (0, _display_utils.getCurrentTransform)(ctx);
                        const isScalingMatrix = currentTransform[0] === 0 && currentTransform[3] === 0 || currentTransform[1] === 0 && currentTransform[2] === 0;
                        const minMaxForBezier = isScalingMatrix ? minMax.slice(0) : null;
                        for(let i = 0, j = 0, ii = ops.length; i < ii; i++)switch(ops[i] | 0){
                            case _util.OPS.rectangle:
                                x = args[j++];
                                y = args[j++];
                                const width = args[j++];
                                const height = args[j++];
                                const xw = x + width;
                                const yh = y + height;
                                ctx.moveTo(x, y);
                                if (width === 0 || height === 0) ctx.lineTo(xw, yh);
                                else {
                                    ctx.lineTo(xw, y);
                                    ctx.lineTo(xw, yh);
                                    ctx.lineTo(x, yh);
                                }
                                if (!isScalingMatrix) current.updateRectMinMax(currentTransform, [
                                    x,
                                    y,
                                    xw,
                                    yh
                                ]);
                                ctx.closePath();
                                break;
                            case _util.OPS.moveTo:
                                x = args[j++];
                                y = args[j++];
                                ctx.moveTo(x, y);
                                if (!isScalingMatrix) current.updatePathMinMax(currentTransform, x, y);
                                break;
                            case _util.OPS.lineTo:
                                x = args[j++];
                                y = args[j++];
                                ctx.lineTo(x, y);
                                if (!isScalingMatrix) current.updatePathMinMax(currentTransform, x, y);
                                break;
                            case _util.OPS.curveTo:
                                startX = x;
                                startY = y;
                                x = args[j + 4];
                                y = args[j + 5];
                                ctx.bezierCurveTo(args[j], args[j + 1], args[j + 2], args[j + 3], x, y);
                                current.updateCurvePathMinMax(currentTransform, startX, startY, args[j], args[j + 1], args[j + 2], args[j + 3], x, y, minMaxForBezier);
                                j += 6;
                                break;
                            case _util.OPS.curveTo2:
                                startX = x;
                                startY = y;
                                ctx.bezierCurveTo(x, y, args[j], args[j + 1], args[j + 2], args[j + 3]);
                                current.updateCurvePathMinMax(currentTransform, startX, startY, x, y, args[j], args[j + 1], args[j + 2], args[j + 3], minMaxForBezier);
                                x = args[j + 2];
                                y = args[j + 3];
                                j += 4;
                                break;
                            case _util.OPS.curveTo3:
                                startX = x;
                                startY = y;
                                x = args[j + 2];
                                y = args[j + 3];
                                ctx.bezierCurveTo(args[j], args[j + 1], x, y, x, y);
                                current.updateCurvePathMinMax(currentTransform, startX, startY, args[j], args[j + 1], x, y, x, y, minMaxForBezier);
                                j += 4;
                                break;
                            case _util.OPS.closePath:
                                ctx.closePath();
                                break;
                        }
                        if (isScalingMatrix) current.updateScalingPathMinMax(currentTransform, minMaxForBezier);
                        current.setCurrentPoint(x, y);
                    }
                    closePath() {
                        this.ctx.closePath();
                    }
                    stroke(consumePath = true) {
                        const ctx = this.ctx;
                        const strokeColor = this.current.strokeColor;
                        ctx.globalAlpha = this.current.strokeAlpha;
                        if (this.contentVisible) {
                            if (typeof strokeColor === "object" && strokeColor?.getPattern) {
                                ctx.save();
                                ctx.strokeStyle = strokeColor.getPattern(ctx, this, (0, _display_utils.getCurrentTransformInverse)(ctx), _pattern_helper.PathType.STROKE);
                                this.rescaleAndStroke(false);
                                ctx.restore();
                            } else this.rescaleAndStroke(true);
                        }
                        if (consumePath) this.consumePath(this.current.getClippedPathBoundingBox());
                        ctx.globalAlpha = this.current.fillAlpha;
                    }
                    closeStroke() {
                        this.closePath();
                        this.stroke();
                    }
                    fill(consumePath = true) {
                        const ctx = this.ctx;
                        const fillColor = this.current.fillColor;
                        const isPatternFill = this.current.patternFill;
                        let needRestore = false;
                        if (isPatternFill) {
                            ctx.save();
                            ctx.fillStyle = fillColor.getPattern(ctx, this, (0, _display_utils.getCurrentTransformInverse)(ctx), _pattern_helper.PathType.FILL);
                            needRestore = true;
                        }
                        const intersect = this.current.getClippedPathBoundingBox();
                        if (this.contentVisible && intersect !== null) {
                            if (this.pendingEOFill) {
                                ctx.fill("evenodd");
                                this.pendingEOFill = false;
                            } else ctx.fill();
                        }
                        if (needRestore) ctx.restore();
                        if (consumePath) this.consumePath(intersect);
                    }
                    eoFill() {
                        this.pendingEOFill = true;
                        this.fill();
                    }
                    fillStroke() {
                        this.fill(false);
                        this.stroke(false);
                        this.consumePath();
                    }
                    eoFillStroke() {
                        this.pendingEOFill = true;
                        this.fillStroke();
                    }
                    closeFillStroke() {
                        this.closePath();
                        this.fillStroke();
                    }
                    closeEOFillStroke() {
                        this.pendingEOFill = true;
                        this.closePath();
                        this.fillStroke();
                    }
                    endPath() {
                        this.consumePath();
                    }
                    clip() {
                        this.pendingClip = NORMAL_CLIP;
                    }
                    eoClip() {
                        this.pendingClip = EO_CLIP;
                    }
                    beginText() {
                        this.current.textMatrix = _util.IDENTITY_MATRIX;
                        this.current.textMatrixScale = 1;
                        this.current.x = this.current.lineX = 0;
                        this.current.y = this.current.lineY = 0;
                    }
                    endText() {
                        const paths = this.pendingTextPaths;
                        const ctx = this.ctx;
                        if (paths === undefined) {
                            ctx.beginPath();
                            return;
                        }
                        ctx.save();
                        ctx.beginPath();
                        for (const path of paths){
                            ctx.setTransform(...path.transform);
                            ctx.translate(path.x, path.y);
                            path.addToPath(ctx, path.fontSize);
                        }
                        ctx.restore();
                        ctx.clip();
                        ctx.beginPath();
                        delete this.pendingTextPaths;
                    }
                    setCharSpacing(spacing) {
                        this.current.charSpacing = spacing;
                    }
                    setWordSpacing(spacing) {
                        this.current.wordSpacing = spacing;
                    }
                    setHScale(scale) {
                        this.current.textHScale = scale / 100;
                    }
                    setLeading(leading) {
                        this.current.leading = -leading;
                    }
                    setFont(fontRefName, size) {
                        const fontObj = this.commonObjs.get(fontRefName);
                        const current = this.current;
                        if (!fontObj) throw new Error(`Can't find font for ${fontRefName}`);
                        current.fontMatrix = fontObj.fontMatrix || _util.FONT_IDENTITY_MATRIX;
                        if (current.fontMatrix[0] === 0 || current.fontMatrix[3] === 0) (0, _util.warn)("Invalid font matrix for font " + fontRefName);
                        if (size < 0) {
                            size = -size;
                            current.fontDirection = -1;
                        } else current.fontDirection = 1;
                        this.current.font = fontObj;
                        this.current.fontSize = size;
                        if (fontObj.isType3Font) return;
                        const name = fontObj.loadedName || "sans-serif";
                        const typeface = fontObj.systemFontInfo?.css || `"${name}", ${fontObj.fallbackName}`;
                        let bold = "normal";
                        if (fontObj.black) bold = "900";
                        else if (fontObj.bold) bold = "bold";
                        const italic = fontObj.italic ? "italic" : "normal";
                        let browserFontSize = size;
                        if (size < MIN_FONT_SIZE) browserFontSize = MIN_FONT_SIZE;
                        else if (size > MAX_FONT_SIZE) browserFontSize = MAX_FONT_SIZE;
                        this.current.fontSizeScale = size / browserFontSize;
                        this.ctx.font = `${italic} ${bold} ${browserFontSize}px ${typeface}`;
                    }
                    setTextRenderingMode(mode) {
                        this.current.textRenderingMode = mode;
                    }
                    setTextRise(rise) {
                        this.current.textRise = rise;
                    }
                    moveText(x, y) {
                        this.current.x = this.current.lineX += x;
                        this.current.y = this.current.lineY += y;
                    }
                    setLeadingMoveText(x, y) {
                        this.setLeading(-y);
                        this.moveText(x, y);
                    }
                    setTextMatrix(a, b, c, d, e, f) {
                        this.current.textMatrix = [
                            a,
                            b,
                            c,
                            d,
                            e,
                            f
                        ];
                        this.current.textMatrixScale = Math.hypot(a, b);
                        this.current.x = this.current.lineX = 0;
                        this.current.y = this.current.lineY = 0;
                    }
                    nextLine() {
                        this.moveText(0, this.current.leading);
                    }
                    paintChar(character, x, y, patternTransform) {
                        const ctx = this.ctx;
                        const current = this.current;
                        const font = current.font;
                        const textRenderingMode = current.textRenderingMode;
                        const fontSize = current.fontSize / current.fontSizeScale;
                        const fillStrokeMode = textRenderingMode & _util.TextRenderingMode.FILL_STROKE_MASK;
                        const isAddToPathSet = !!(textRenderingMode & _util.TextRenderingMode.ADD_TO_PATH_FLAG);
                        const patternFill = current.patternFill && !font.missingFile;
                        let addToPath;
                        if (font.disableFontFace || isAddToPathSet || patternFill) addToPath = font.getPathGenerator(this.commonObjs, character);
                        if (font.disableFontFace || patternFill) {
                            ctx.save();
                            ctx.translate(x, y);
                            ctx.beginPath();
                            addToPath(ctx, fontSize);
                            if (patternTransform) ctx.setTransform(...patternTransform);
                            if (fillStrokeMode === _util.TextRenderingMode.FILL || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) ctx.fill();
                            if (fillStrokeMode === _util.TextRenderingMode.STROKE || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) ctx.stroke();
                            ctx.restore();
                        } else {
                            if (fillStrokeMode === _util.TextRenderingMode.FILL || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) ctx.fillText(character, x, y);
                            if (fillStrokeMode === _util.TextRenderingMode.STROKE || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) ctx.strokeText(character, x, y);
                        }
                        if (isAddToPathSet) {
                            const paths = this.pendingTextPaths ||= [];
                            paths.push({
                                transform: (0, _display_utils.getCurrentTransform)(ctx),
                                x: x,
                                y: y,
                                fontSize: fontSize,
                                addToPath: addToPath
                            });
                        }
                    }
                    get isFontSubpixelAAEnabled() {
                        const { context: ctx } = this.cachedCanvases.getCanvas("isFontSubpixelAAEnabled", 10, 10);
                        ctx.scale(1.5, 1);
                        ctx.fillText("I", 0, 10);
                        const data = ctx.getImageData(0, 0, 10, 10).data;
                        let enabled = false;
                        for(let i = 3; i < data.length; i += 4)if (data[i] > 0 && data[i] < 255) {
                            enabled = true;
                            break;
                        }
                        return (0, _util.shadow)(this, "isFontSubpixelAAEnabled", enabled);
                    }
                    showText(glyphs) {
                        const current = this.current;
                        const font = current.font;
                        if (font.isType3Font) return this.showType3Text(glyphs);
                        const fontSize = current.fontSize;
                        if (fontSize === 0) return undefined;
                        const ctx = this.ctx;
                        const fontSizeScale = current.fontSizeScale;
                        const charSpacing = current.charSpacing;
                        const wordSpacing = current.wordSpacing;
                        const fontDirection = current.fontDirection;
                        const textHScale = current.textHScale * fontDirection;
                        const glyphsLength = glyphs.length;
                        const vertical = font.vertical;
                        const spacingDir = vertical ? 1 : -1;
                        const defaultVMetrics = font.defaultVMetrics;
                        const widthAdvanceScale = fontSize * current.fontMatrix[0];
                        const simpleFillText = current.textRenderingMode === _util.TextRenderingMode.FILL && !font.disableFontFace && !current.patternFill;
                        ctx.save();
                        ctx.transform(...current.textMatrix);
                        ctx.translate(current.x, current.y + current.textRise);
                        if (fontDirection > 0) ctx.scale(textHScale, -1);
                        else ctx.scale(textHScale, 1);
                        let patternTransform;
                        if (current.patternFill) {
                            ctx.save();
                            const pattern = current.fillColor.getPattern(ctx, this, (0, _display_utils.getCurrentTransformInverse)(ctx), _pattern_helper.PathType.FILL);
                            patternTransform = (0, _display_utils.getCurrentTransform)(ctx);
                            ctx.restore();
                            ctx.fillStyle = pattern;
                        }
                        let lineWidth = current.lineWidth;
                        const scale = current.textMatrixScale;
                        if (scale === 0 || lineWidth === 0) {
                            const fillStrokeMode = current.textRenderingMode & _util.TextRenderingMode.FILL_STROKE_MASK;
                            if (fillStrokeMode === _util.TextRenderingMode.STROKE || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) lineWidth = this.getSinglePixelWidth();
                        } else lineWidth /= scale;
                        if (fontSizeScale !== 1.0) {
                            ctx.scale(fontSizeScale, fontSizeScale);
                            lineWidth /= fontSizeScale;
                        }
                        ctx.lineWidth = lineWidth;
                        if (font.isInvalidPDFjsFont) {
                            const chars = [];
                            let width = 0;
                            for (const glyph of glyphs){
                                chars.push(glyph.unicode);
                                width += glyph.width;
                            }
                            ctx.fillText(chars.join(""), 0, 0);
                            current.x += width * widthAdvanceScale * textHScale;
                            ctx.restore();
                            this.compose();
                            return undefined;
                        }
                        let x = 0, i;
                        for(i = 0; i < glyphsLength; ++i){
                            const glyph = glyphs[i];
                            if (typeof glyph === "number") {
                                x += spacingDir * glyph * fontSize / 1000;
                                continue;
                            }
                            let restoreNeeded = false;
                            const spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing;
                            const character = glyph.fontChar;
                            const accent = glyph.accent;
                            let scaledX, scaledY;
                            let width = glyph.width;
                            if (vertical) {
                                const vmetric = glyph.vmetric || defaultVMetrics;
                                const vx = -(glyph.vmetric ? vmetric[1] : width * 0.5) * widthAdvanceScale;
                                const vy = vmetric[2] * widthAdvanceScale;
                                width = vmetric ? -vmetric[0] : width;
                                scaledX = vx / fontSizeScale;
                                scaledY = (x + vy) / fontSizeScale;
                            } else {
                                scaledX = x / fontSizeScale;
                                scaledY = 0;
                            }
                            if (font.remeasure && width > 0) {
                                const measuredWidth = ctx.measureText(character).width * 1000 / fontSize * fontSizeScale;
                                if (width < measuredWidth && this.isFontSubpixelAAEnabled) {
                                    const characterScaleX = width / measuredWidth;
                                    restoreNeeded = true;
                                    ctx.save();
                                    ctx.scale(characterScaleX, 1);
                                    scaledX /= characterScaleX;
                                } else if (width !== measuredWidth) scaledX += (width - measuredWidth) / 2000 * fontSize / fontSizeScale;
                            }
                            if (this.contentVisible && (glyph.isInFont || font.missingFile)) {
                                if (simpleFillText && !accent) ctx.fillText(character, scaledX, scaledY);
                                else {
                                    this.paintChar(character, scaledX, scaledY, patternTransform);
                                    if (accent) {
                                        const scaledAccentX = scaledX + fontSize * accent.offset.x / fontSizeScale;
                                        const scaledAccentY = scaledY - fontSize * accent.offset.y / fontSizeScale;
                                        this.paintChar(accent.fontChar, scaledAccentX, scaledAccentY, patternTransform);
                                    }
                                }
                            }
                            const charWidth = vertical ? width * widthAdvanceScale - spacing * fontDirection : width * widthAdvanceScale + spacing * fontDirection;
                            x += charWidth;
                            if (restoreNeeded) ctx.restore();
                        }
                        if (vertical) current.y -= x;
                        else current.x += x * textHScale;
                        ctx.restore();
                        this.compose();
                        return undefined;
                    }
                    showType3Text(glyphs) {
                        const ctx = this.ctx;
                        const current = this.current;
                        const font = current.font;
                        const fontSize = current.fontSize;
                        const fontDirection = current.fontDirection;
                        const spacingDir = font.vertical ? 1 : -1;
                        const charSpacing = current.charSpacing;
                        const wordSpacing = current.wordSpacing;
                        const textHScale = current.textHScale * fontDirection;
                        const fontMatrix = current.fontMatrix || _util.FONT_IDENTITY_MATRIX;
                        const glyphsLength = glyphs.length;
                        const isTextInvisible = current.textRenderingMode === _util.TextRenderingMode.INVISIBLE;
                        let i, glyph, width, spacingLength;
                        if (isTextInvisible || fontSize === 0) return;
                        this._cachedScaleForStroking[0] = -1;
                        this._cachedGetSinglePixelWidth = null;
                        ctx.save();
                        ctx.transform(...current.textMatrix);
                        ctx.translate(current.x, current.y);
                        ctx.scale(textHScale, fontDirection);
                        for(i = 0; i < glyphsLength; ++i){
                            glyph = glyphs[i];
                            if (typeof glyph === "number") {
                                spacingLength = spacingDir * glyph * fontSize / 1000;
                                this.ctx.translate(spacingLength, 0);
                                current.x += spacingLength * textHScale;
                                continue;
                            }
                            const spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing;
                            const operatorList = font.charProcOperatorList[glyph.operatorListId];
                            if (!operatorList) {
                                (0, _util.warn)(`Type3 character "${glyph.operatorListId}" is not available.`);
                                continue;
                            }
                            if (this.contentVisible) {
                                this.processingType3 = glyph;
                                this.save();
                                ctx.scale(fontSize, fontSize);
                                ctx.transform(...fontMatrix);
                                this.executeOperatorList(operatorList);
                                this.restore();
                            }
                            const transformed = _util.Util.applyTransform([
                                glyph.width,
                                0
                            ], fontMatrix);
                            width = transformed[0] * fontSize + spacing;
                            ctx.translate(width, 0);
                            current.x += width * textHScale;
                        }
                        ctx.restore();
                        this.processingType3 = null;
                    }
                    setCharWidth(xWidth, yWidth) {}
                    setCharWidthAndBounds(xWidth, yWidth, llx, lly, urx, ury) {
                        this.ctx.rect(llx, lly, urx - llx, ury - lly);
                        this.ctx.clip();
                        this.endPath();
                    }
                    getColorN_Pattern(IR) {
                        let pattern;
                        if (IR[0] === "TilingPattern") {
                            const color = IR[1];
                            const baseTransform = this.baseTransform || (0, _display_utils.getCurrentTransform)(this.ctx);
                            const canvasGraphicsFactory = {
                                createCanvasGraphics: (ctx)=>{
                                    return new CanvasGraphics(ctx, this.commonObjs, this.objs, this.canvasFactory, this.filterFactory, {
                                        optionalContentConfig: this.optionalContentConfig,
                                        markedContentStack: this.markedContentStack
                                    });
                                }
                            };
                            pattern = new _pattern_helper.TilingPattern(IR, color, this.ctx, canvasGraphicsFactory, baseTransform);
                        } else pattern = this._getPattern(IR[1], IR[2]);
                        return pattern;
                    }
                    setStrokeColorN() {
                        this.current.strokeColor = this.getColorN_Pattern(arguments);
                    }
                    setFillColorN() {
                        this.current.fillColor = this.getColorN_Pattern(arguments);
                        this.current.patternFill = true;
                    }
                    setStrokeRGBColor(r, g, b) {
                        const color = _util.Util.makeHexColor(r, g, b);
                        this.ctx.strokeStyle = color;
                        this.current.strokeColor = color;
                    }
                    setFillRGBColor(r, g, b) {
                        const color = _util.Util.makeHexColor(r, g, b);
                        this.ctx.fillStyle = color;
                        this.current.fillColor = color;
                        this.current.patternFill = false;
                    }
                    _getPattern(objId, matrix = null) {
                        let pattern;
                        if (this.cachedPatterns.has(objId)) pattern = this.cachedPatterns.get(objId);
                        else {
                            pattern = (0, _pattern_helper.getShadingPattern)(this.getObject(objId));
                            this.cachedPatterns.set(objId, pattern);
                        }
                        if (matrix) pattern.matrix = matrix;
                        return pattern;
                    }
                    shadingFill(objId) {
                        if (!this.contentVisible) return;
                        const ctx = this.ctx;
                        this.save();
                        const pattern = this._getPattern(objId);
                        ctx.fillStyle = pattern.getPattern(ctx, this, (0, _display_utils.getCurrentTransformInverse)(ctx), _pattern_helper.PathType.SHADING);
                        const inv = (0, _display_utils.getCurrentTransformInverse)(ctx);
                        if (inv) {
                            const { width, height } = ctx.canvas;
                            const [x0, y0, x1, y1] = _util.Util.getAxialAlignedBoundingBox([
                                0,
                                0,
                                width,
                                height
                            ], inv);
                            this.ctx.fillRect(x0, y0, x1 - x0, y1 - y0);
                        } else this.ctx.fillRect(-10000000000, -10000000000, 2e10, 2e10);
                        this.compose(this.current.getClippedPathBoundingBox());
                        this.restore();
                    }
                    beginInlineImage() {
                        (0, _util.unreachable)("Should not call beginInlineImage");
                    }
                    beginImageData() {
                        (0, _util.unreachable)("Should not call beginImageData");
                    }
                    paintFormXObjectBegin(matrix, bbox) {
                        if (!this.contentVisible) return;
                        this.save();
                        this.baseTransformStack.push(this.baseTransform);
                        if (Array.isArray(matrix) && matrix.length === 6) this.transform(...matrix);
                        this.baseTransform = (0, _display_utils.getCurrentTransform)(this.ctx);
                        if (bbox) {
                            const width = bbox[2] - bbox[0];
                            const height = bbox[3] - bbox[1];
                            this.ctx.rect(bbox[0], bbox[1], width, height);
                            this.current.updateRectMinMax((0, _display_utils.getCurrentTransform)(this.ctx), bbox);
                            this.clip();
                            this.endPath();
                        }
                    }
                    paintFormXObjectEnd() {
                        if (!this.contentVisible) return;
                        this.restore();
                        this.baseTransform = this.baseTransformStack.pop();
                    }
                    beginGroup(group) {
                        if (!this.contentVisible) return;
                        this.save();
                        if (this.inSMaskMode) {
                            this.endSMaskMode();
                            this.current.activeSMask = null;
                        }
                        const currentCtx = this.ctx;
                        if (!group.isolated) (0, _util.info)("TODO: Support non-isolated groups.");
                        if (group.knockout) (0, _util.warn)("Knockout groups not supported.");
                        const currentTransform = (0, _display_utils.getCurrentTransform)(currentCtx);
                        if (group.matrix) currentCtx.transform(...group.matrix);
                        if (!group.bbox) throw new Error("Bounding box is required.");
                        let bounds = _util.Util.getAxialAlignedBoundingBox(group.bbox, (0, _display_utils.getCurrentTransform)(currentCtx));
                        const canvasBounds = [
                            0,
                            0,
                            currentCtx.canvas.width,
                            currentCtx.canvas.height
                        ];
                        bounds = _util.Util.intersect(bounds, canvasBounds) || [
                            0,
                            0,
                            0,
                            0
                        ];
                        const offsetX = Math.floor(bounds[0]);
                        const offsetY = Math.floor(bounds[1]);
                        let drawnWidth = Math.max(Math.ceil(bounds[2]) - offsetX, 1);
                        let drawnHeight = Math.max(Math.ceil(bounds[3]) - offsetY, 1);
                        let scaleX = 1, scaleY = 1;
                        if (drawnWidth > MAX_GROUP_SIZE) {
                            scaleX = drawnWidth / MAX_GROUP_SIZE;
                            drawnWidth = MAX_GROUP_SIZE;
                        }
                        if (drawnHeight > MAX_GROUP_SIZE) {
                            scaleY = drawnHeight / MAX_GROUP_SIZE;
                            drawnHeight = MAX_GROUP_SIZE;
                        }
                        this.current.startNewPathAndClipBox([
                            0,
                            0,
                            drawnWidth,
                            drawnHeight
                        ]);
                        let cacheId = "groupAt" + this.groupLevel;
                        if (group.smask) cacheId += "_smask_" + this.smaskCounter++ % 2;
                        const scratchCanvas = this.cachedCanvases.getCanvas(cacheId, drawnWidth, drawnHeight);
                        const groupCtx = scratchCanvas.context;
                        groupCtx.scale(1 / scaleX, 1 / scaleY);
                        groupCtx.translate(-offsetX, -offsetY);
                        groupCtx.transform(...currentTransform);
                        if (group.smask) this.smaskStack.push({
                            canvas: scratchCanvas.canvas,
                            context: groupCtx,
                            offsetX: offsetX,
                            offsetY: offsetY,
                            scaleX: scaleX,
                            scaleY: scaleY,
                            subtype: group.smask.subtype,
                            backdrop: group.smask.backdrop,
                            transferMap: group.smask.transferMap || null,
                            startTransformInverse: null
                        });
                        else {
                            currentCtx.setTransform(1, 0, 0, 1, 0, 0);
                            currentCtx.translate(offsetX, offsetY);
                            currentCtx.scale(scaleX, scaleY);
                            currentCtx.save();
                        }
                        copyCtxState(currentCtx, groupCtx);
                        this.ctx = groupCtx;
                        this.setGState([
                            [
                                "BM",
                                "source-over"
                            ],
                            [
                                "ca",
                                1
                            ],
                            [
                                "CA",
                                1
                            ]
                        ]);
                        this.groupStack.push(currentCtx);
                        this.groupLevel++;
                    }
                    endGroup(group) {
                        if (!this.contentVisible) return;
                        this.groupLevel--;
                        const groupCtx = this.ctx;
                        const ctx = this.groupStack.pop();
                        this.ctx = ctx;
                        this.ctx.imageSmoothingEnabled = false;
                        if (group.smask) {
                            this.tempSMask = this.smaskStack.pop();
                            this.restore();
                        } else {
                            this.ctx.restore();
                            const currentMtx = (0, _display_utils.getCurrentTransform)(this.ctx);
                            this.restore();
                            this.ctx.save();
                            this.ctx.setTransform(...currentMtx);
                            const dirtyBox = _util.Util.getAxialAlignedBoundingBox([
                                0,
                                0,
                                groupCtx.canvas.width,
                                groupCtx.canvas.height
                            ], currentMtx);
                            this.ctx.drawImage(groupCtx.canvas, 0, 0);
                            this.ctx.restore();
                            this.compose(dirtyBox);
                        }
                    }
                    beginAnnotation(id, rect, transform, matrix, hasOwnCanvas) {
                        this.#restoreInitialState();
                        resetCtxToDefault(this.ctx);
                        this.ctx.save();
                        this.save();
                        if (this.baseTransform) this.ctx.setTransform(...this.baseTransform);
                        if (Array.isArray(rect) && rect.length === 4) {
                            const width = rect[2] - rect[0];
                            const height = rect[3] - rect[1];
                            if (hasOwnCanvas && this.annotationCanvasMap) {
                                transform = transform.slice();
                                transform[4] -= rect[0];
                                transform[5] -= rect[1];
                                rect = rect.slice();
                                rect[0] = rect[1] = 0;
                                rect[2] = width;
                                rect[3] = height;
                                const [scaleX, scaleY] = _util.Util.singularValueDecompose2dScale((0, _display_utils.getCurrentTransform)(this.ctx));
                                const { viewportScale } = this;
                                const canvasWidth = Math.ceil(width * this.outputScaleX * viewportScale);
                                const canvasHeight = Math.ceil(height * this.outputScaleY * viewportScale);
                                this.annotationCanvas = this.canvasFactory.create(canvasWidth, canvasHeight);
                                const { canvas, context } = this.annotationCanvas;
                                this.annotationCanvasMap.set(id, canvas);
                                this.annotationCanvas.savedCtx = this.ctx;
                                this.ctx = context;
                                this.ctx.save();
                                this.ctx.setTransform(scaleX, 0, 0, -scaleY, 0, height * scaleY);
                                resetCtxToDefault(this.ctx);
                            } else {
                                resetCtxToDefault(this.ctx);
                                this.ctx.rect(rect[0], rect[1], width, height);
                                this.ctx.clip();
                                this.endPath();
                            }
                        }
                        this.current = new CanvasExtraState(this.ctx.canvas.width, this.ctx.canvas.height);
                        this.transform(...transform);
                        this.transform(...matrix);
                    }
                    endAnnotation() {
                        if (this.annotationCanvas) {
                            this.ctx.restore();
                            this.#drawFilter();
                            this.ctx = this.annotationCanvas.savedCtx;
                            delete this.annotationCanvas.savedCtx;
                            delete this.annotationCanvas;
                        }
                    }
                    paintImageMaskXObject(img) {
                        if (!this.contentVisible) return;
                        const count = img.count;
                        img = this.getObject(img.data, img);
                        img.count = count;
                        const ctx = this.ctx;
                        const glyph = this.processingType3;
                        if (glyph) {
                            if (glyph.compiled === undefined) glyph.compiled = compileType3Glyph(img);
                            if (glyph.compiled) {
                                glyph.compiled(ctx);
                                return;
                            }
                        }
                        const mask = this._createMaskCanvas(img);
                        const maskCanvas = mask.canvas;
                        ctx.save();
                        ctx.setTransform(1, 0, 0, 1, 0, 0);
                        ctx.drawImage(maskCanvas, mask.offsetX, mask.offsetY);
                        ctx.restore();
                        this.compose();
                    }
                    paintImageMaskXObjectRepeat(img, scaleX, skewX = 0, skewY = 0, scaleY, positions) {
                        if (!this.contentVisible) return;
                        img = this.getObject(img.data, img);
                        const ctx = this.ctx;
                        ctx.save();
                        const currentTransform = (0, _display_utils.getCurrentTransform)(ctx);
                        ctx.transform(scaleX, skewX, skewY, scaleY, 0, 0);
                        const mask = this._createMaskCanvas(img);
                        ctx.setTransform(1, 0, 0, 1, mask.offsetX - currentTransform[4], mask.offsetY - currentTransform[5]);
                        for(let i = 0, ii = positions.length; i < ii; i += 2){
                            const trans = _util.Util.transform(currentTransform, [
                                scaleX,
                                skewX,
                                skewY,
                                scaleY,
                                positions[i],
                                positions[i + 1]
                            ]);
                            const [x, y] = _util.Util.applyTransform([
                                0,
                                0
                            ], trans);
                            ctx.drawImage(mask.canvas, x, y);
                        }
                        ctx.restore();
                        this.compose();
                    }
                    paintImageMaskXObjectGroup(images) {
                        if (!this.contentVisible) return;
                        const ctx = this.ctx;
                        const fillColor = this.current.fillColor;
                        const isPatternFill = this.current.patternFill;
                        for (const image of images){
                            const { data, width, height, transform } = image;
                            const maskCanvas = this.cachedCanvases.getCanvas("maskCanvas", width, height);
                            const maskCtx = maskCanvas.context;
                            maskCtx.save();
                            const img = this.getObject(data, image);
                            putBinaryImageMask(maskCtx, img);
                            maskCtx.globalCompositeOperation = "source-in";
                            maskCtx.fillStyle = isPatternFill ? fillColor.getPattern(maskCtx, this, (0, _display_utils.getCurrentTransformInverse)(ctx), _pattern_helper.PathType.FILL) : fillColor;
                            maskCtx.fillRect(0, 0, width, height);
                            maskCtx.restore();
                            ctx.save();
                            ctx.transform(...transform);
                            ctx.scale(1, -1);
                            drawImageAtIntegerCoords(ctx, maskCanvas.canvas, 0, 0, width, height, 0, -1, 1, 1);
                            ctx.restore();
                        }
                        this.compose();
                    }
                    paintImageXObject(objId) {
                        if (!this.contentVisible) return;
                        const imgData = this.getObject(objId);
                        if (!imgData) {
                            (0, _util.warn)("Dependent image isn't ready yet");
                            return;
                        }
                        this.paintInlineImageXObject(imgData);
                    }
                    paintImageXObjectRepeat(objId, scaleX, scaleY, positions) {
                        if (!this.contentVisible) return;
                        const imgData = this.getObject(objId);
                        if (!imgData) {
                            (0, _util.warn)("Dependent image isn't ready yet");
                            return;
                        }
                        const width = imgData.width;
                        const height = imgData.height;
                        const map = [];
                        for(let i = 0, ii = positions.length; i < ii; i += 2)map.push({
                            transform: [
                                scaleX,
                                0,
                                0,
                                scaleY,
                                positions[i],
                                positions[i + 1]
                            ],
                            x: 0,
                            y: 0,
                            w: width,
                            h: height
                        });
                        this.paintInlineImageXObjectGroup(imgData, map);
                    }
                    applyTransferMapsToCanvas(ctx) {
                        if (this.current.transferMaps !== "none") {
                            ctx.filter = this.current.transferMaps;
                            ctx.drawImage(ctx.canvas, 0, 0);
                            ctx.filter = "none";
                        }
                        return ctx.canvas;
                    }
                    applyTransferMapsToBitmap(imgData) {
                        if (this.current.transferMaps === "none") return imgData.bitmap;
                        const { bitmap, width, height } = imgData;
                        const tmpCanvas = this.cachedCanvases.getCanvas("inlineImage", width, height);
                        const tmpCtx = tmpCanvas.context;
                        tmpCtx.filter = this.current.transferMaps;
                        tmpCtx.drawImage(bitmap, 0, 0);
                        tmpCtx.filter = "none";
                        return tmpCanvas.canvas;
                    }
                    paintInlineImageXObject(imgData) {
                        if (!this.contentVisible) return;
                        const width = imgData.width;
                        const height = imgData.height;
                        const ctx = this.ctx;
                        this.save();
                        if (!_util.isNodeJS) {
                            const { filter } = ctx;
                            if (filter !== "none" && filter !== "") ctx.filter = "none";
                        }
                        ctx.scale(1 / width, -1 / height);
                        let imgToPaint;
                        if (imgData.bitmap) imgToPaint = this.applyTransferMapsToBitmap(imgData);
                        else if (typeof HTMLElement === "function" && imgData instanceof HTMLElement || !imgData.data) imgToPaint = imgData;
                        else {
                            const tmpCanvas = this.cachedCanvases.getCanvas("inlineImage", width, height);
                            const tmpCtx = tmpCanvas.context;
                            putBinaryImageData(tmpCtx, imgData);
                            imgToPaint = this.applyTransferMapsToCanvas(tmpCtx);
                        }
                        const scaled = this._scaleImage(imgToPaint, (0, _display_utils.getCurrentTransformInverse)(ctx));
                        ctx.imageSmoothingEnabled = getImageSmoothingEnabled((0, _display_utils.getCurrentTransform)(ctx), imgData.interpolate);
                        drawImageAtIntegerCoords(ctx, scaled.img, 0, 0, scaled.paintWidth, scaled.paintHeight, 0, -height, width, height);
                        this.compose();
                        this.restore();
                    }
                    paintInlineImageXObjectGroup(imgData, map) {
                        if (!this.contentVisible) return;
                        const ctx = this.ctx;
                        let imgToPaint;
                        if (imgData.bitmap) imgToPaint = imgData.bitmap;
                        else {
                            const w = imgData.width;
                            const h = imgData.height;
                            const tmpCanvas = this.cachedCanvases.getCanvas("inlineImage", w, h);
                            const tmpCtx = tmpCanvas.context;
                            putBinaryImageData(tmpCtx, imgData);
                            imgToPaint = this.applyTransferMapsToCanvas(tmpCtx);
                        }
                        for (const entry of map){
                            ctx.save();
                            ctx.transform(...entry.transform);
                            ctx.scale(1, -1);
                            drawImageAtIntegerCoords(ctx, imgToPaint, entry.x, entry.y, entry.w, entry.h, 0, -1, 1, 1);
                            ctx.restore();
                        }
                        this.compose();
                    }
                    paintSolidColorImageMask() {
                        if (!this.contentVisible) return;
                        this.ctx.fillRect(0, 0, 1, 1);
                        this.compose();
                    }
                    markPoint(tag) {}
                    markPointProps(tag, properties) {}
                    beginMarkedContent(tag) {
                        this.markedContentStack.push({
                            visible: true
                        });
                    }
                    beginMarkedContentProps(tag, properties) {
                        if (tag === "OC") this.markedContentStack.push({
                            visible: this.optionalContentConfig.isVisible(properties)
                        });
                        else this.markedContentStack.push({
                            visible: true
                        });
                        this.contentVisible = this.isContentVisible();
                    }
                    endMarkedContent() {
                        this.markedContentStack.pop();
                        this.contentVisible = this.isContentVisible();
                    }
                    beginCompat() {}
                    endCompat() {}
                    consumePath(clipBox) {
                        const isEmpty = this.current.isEmptyClip();
                        if (this.pendingClip) this.current.updateClipFromPath();
                        if (!this.pendingClip) this.compose(clipBox);
                        const ctx = this.ctx;
                        if (this.pendingClip) {
                            if (!isEmpty) {
                                if (this.pendingClip === EO_CLIP) ctx.clip("evenodd");
                                else ctx.clip();
                            }
                            this.pendingClip = null;
                        }
                        this.current.startNewPathAndClipBox(this.current.clipBox);
                        ctx.beginPath();
                    }
                    getSinglePixelWidth() {
                        if (!this._cachedGetSinglePixelWidth) {
                            const m = (0, _display_utils.getCurrentTransform)(this.ctx);
                            if (m[1] === 0 && m[2] === 0) this._cachedGetSinglePixelWidth = 1 / Math.min(Math.abs(m[0]), Math.abs(m[3]));
                            else {
                                const absDet = Math.abs(m[0] * m[3] - m[2] * m[1]);
                                const normX = Math.hypot(m[0], m[2]);
                                const normY = Math.hypot(m[1], m[3]);
                                this._cachedGetSinglePixelWidth = Math.max(normX, normY) / absDet;
                            }
                        }
                        return this._cachedGetSinglePixelWidth;
                    }
                    getScaleForStroking() {
                        if (this._cachedScaleForStroking[0] === -1) {
                            const { lineWidth } = this.current;
                            const { a, b, c, d } = this.ctx.getTransform();
                            let scaleX, scaleY;
                            if (b === 0 && c === 0) {
                                const normX = Math.abs(a);
                                const normY = Math.abs(d);
                                if (normX === normY) {
                                    if (lineWidth === 0) scaleX = scaleY = 1 / normX;
                                    else {
                                        const scaledLineWidth = normX * lineWidth;
                                        scaleX = scaleY = scaledLineWidth < 1 ? 1 / scaledLineWidth : 1;
                                    }
                                } else if (lineWidth === 0) {
                                    scaleX = 1 / normX;
                                    scaleY = 1 / normY;
                                } else {
                                    const scaledXLineWidth = normX * lineWidth;
                                    const scaledYLineWidth = normY * lineWidth;
                                    scaleX = scaledXLineWidth < 1 ? 1 / scaledXLineWidth : 1;
                                    scaleY = scaledYLineWidth < 1 ? 1 / scaledYLineWidth : 1;
                                }
                            } else {
                                const absDet = Math.abs(a * d - b * c);
                                const normX = Math.hypot(a, b);
                                const normY = Math.hypot(c, d);
                                if (lineWidth === 0) {
                                    scaleX = normY / absDet;
                                    scaleY = normX / absDet;
                                } else {
                                    const baseArea = lineWidth * absDet;
                                    scaleX = normY > baseArea ? normY / baseArea : 1;
                                    scaleY = normX > baseArea ? normX / baseArea : 1;
                                }
                            }
                            this._cachedScaleForStroking[0] = scaleX;
                            this._cachedScaleForStroking[1] = scaleY;
                        }
                        return this._cachedScaleForStroking;
                    }
                    rescaleAndStroke(saveRestore) {
                        const { ctx } = this;
                        const { lineWidth } = this.current;
                        const [scaleX, scaleY] = this.getScaleForStroking();
                        ctx.lineWidth = lineWidth || 1;
                        if (scaleX === 1 && scaleY === 1) {
                            ctx.stroke();
                            return;
                        }
                        const dashes = ctx.getLineDash();
                        if (saveRestore) ctx.save();
                        ctx.scale(scaleX, scaleY);
                        if (dashes.length > 0) {
                            const scale = Math.max(scaleX, scaleY);
                            ctx.setLineDash(dashes.map((x)=>x / scale));
                            ctx.lineDashOffset /= scale;
                        }
                        ctx.stroke();
                        if (saveRestore) ctx.restore();
                    }
                    isContentVisible() {
                        for(let i = this.markedContentStack.length - 1; i >= 0; i--){
                            if (!this.markedContentStack[i].visible) return false;
                        }
                        return true;
                    }
                }
                exports.CanvasGraphics = CanvasGraphics;
                for(const op in _util.OPS)if (CanvasGraphics.prototype[op] !== undefined) CanvasGraphics.prototype[_util.OPS[op]] = CanvasGraphics.prototype[op];
            /***/ },
            /* 12 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.TilingPattern = exports.PathType = void 0;
                exports.getShadingPattern = getShadingPattern;
                var _util = __w_pdfjs_require__(1);
                var _display_utils = __w_pdfjs_require__(6);
                const PathType = {
                    FILL: "Fill",
                    STROKE: "Stroke",
                    SHADING: "Shading"
                };
                exports.PathType = PathType;
                function applyBoundingBox(ctx, bbox) {
                    if (!bbox) return;
                    const width = bbox[2] - bbox[0];
                    const height = bbox[3] - bbox[1];
                    const region = new Path2D();
                    region.rect(bbox[0], bbox[1], width, height);
                    ctx.clip(region);
                }
                class BaseShadingPattern {
                    constructor(){
                        if (this.constructor === BaseShadingPattern) (0, _util.unreachable)("Cannot initialize BaseShadingPattern.");
                    }
                    getPattern() {
                        (0, _util.unreachable)("Abstract method `getPattern` called.");
                    }
                }
                class RadialAxialShadingPattern extends BaseShadingPattern {
                    constructor(IR){
                        super();
                        this._type = IR[1];
                        this._bbox = IR[2];
                        this._colorStops = IR[3];
                        this._p0 = IR[4];
                        this._p1 = IR[5];
                        this._r0 = IR[6];
                        this._r1 = IR[7];
                        this.matrix = null;
                    }
                    _createGradient(ctx) {
                        let grad;
                        if (this._type === "axial") grad = ctx.createLinearGradient(this._p0[0], this._p0[1], this._p1[0], this._p1[1]);
                        else if (this._type === "radial") grad = ctx.createRadialGradient(this._p0[0], this._p0[1], this._r0, this._p1[0], this._p1[1], this._r1);
                        for (const colorStop of this._colorStops)grad.addColorStop(colorStop[0], colorStop[1]);
                        return grad;
                    }
                    getPattern(ctx, owner, inverse, pathType) {
                        let pattern;
                        if (pathType === PathType.STROKE || pathType === PathType.FILL) {
                            const ownerBBox = owner.current.getClippedPathBoundingBox(pathType, (0, _display_utils.getCurrentTransform)(ctx)) || [
                                0,
                                0,
                                0,
                                0
                            ];
                            const width = Math.ceil(ownerBBox[2] - ownerBBox[0]) || 1;
                            const height = Math.ceil(ownerBBox[3] - ownerBBox[1]) || 1;
                            const tmpCanvas = owner.cachedCanvases.getCanvas("pattern", width, height, true);
                            const tmpCtx = tmpCanvas.context;
                            tmpCtx.clearRect(0, 0, tmpCtx.canvas.width, tmpCtx.canvas.height);
                            tmpCtx.beginPath();
                            tmpCtx.rect(0, 0, tmpCtx.canvas.width, tmpCtx.canvas.height);
                            tmpCtx.translate(-ownerBBox[0], -ownerBBox[1]);
                            inverse = _util.Util.transform(inverse, [
                                1,
                                0,
                                0,
                                1,
                                ownerBBox[0],
                                ownerBBox[1]
                            ]);
                            tmpCtx.transform(...owner.baseTransform);
                            if (this.matrix) tmpCtx.transform(...this.matrix);
                            applyBoundingBox(tmpCtx, this._bbox);
                            tmpCtx.fillStyle = this._createGradient(tmpCtx);
                            tmpCtx.fill();
                            pattern = ctx.createPattern(tmpCanvas.canvas, "no-repeat");
                            const domMatrix = new DOMMatrix(inverse);
                            pattern.setTransform(domMatrix);
                        } else {
                            applyBoundingBox(ctx, this._bbox);
                            pattern = this._createGradient(ctx);
                        }
                        return pattern;
                    }
                }
                function drawTriangle(data, context, p1, p2, p3, c1, c2, c3) {
                    const coords = context.coords, colors = context.colors;
                    const bytes = data.data, rowSize = data.width * 4;
                    let tmp;
                    if (coords[p1 + 1] > coords[p2 + 1]) {
                        tmp = p1;
                        p1 = p2;
                        p2 = tmp;
                        tmp = c1;
                        c1 = c2;
                        c2 = tmp;
                    }
                    if (coords[p2 + 1] > coords[p3 + 1]) {
                        tmp = p2;
                        p2 = p3;
                        p3 = tmp;
                        tmp = c2;
                        c2 = c3;
                        c3 = tmp;
                    }
                    if (coords[p1 + 1] > coords[p2 + 1]) {
                        tmp = p1;
                        p1 = p2;
                        p2 = tmp;
                        tmp = c1;
                        c1 = c2;
                        c2 = tmp;
                    }
                    const x1 = (coords[p1] + context.offsetX) * context.scaleX;
                    const y1 = (coords[p1 + 1] + context.offsetY) * context.scaleY;
                    const x2 = (coords[p2] + context.offsetX) * context.scaleX;
                    const y2 = (coords[p2 + 1] + context.offsetY) * context.scaleY;
                    const x3 = (coords[p3] + context.offsetX) * context.scaleX;
                    const y3 = (coords[p3 + 1] + context.offsetY) * context.scaleY;
                    if (y1 >= y3) return;
                    const c1r = colors[c1], c1g = colors[c1 + 1], c1b = colors[c1 + 2];
                    const c2r = colors[c2], c2g = colors[c2 + 1], c2b = colors[c2 + 2];
                    const c3r = colors[c3], c3g = colors[c3 + 1], c3b = colors[c3 + 2];
                    const minY = Math.round(y1), maxY = Math.round(y3);
                    let xa, car, cag, cab;
                    let xb, cbr, cbg, cbb;
                    for(let y = minY; y <= maxY; y++){
                        if (y < y2) {
                            const k = y < y1 ? 0 : (y1 - y) / (y1 - y2);
                            xa = x1 - (x1 - x2) * k;
                            car = c1r - (c1r - c2r) * k;
                            cag = c1g - (c1g - c2g) * k;
                            cab = c1b - (c1b - c2b) * k;
                        } else {
                            let k;
                            if (y > y3) k = 1;
                            else if (y2 === y3) k = 0;
                            else k = (y2 - y) / (y2 - y3);
                            xa = x2 - (x2 - x3) * k;
                            car = c2r - (c2r - c3r) * k;
                            cag = c2g - (c2g - c3g) * k;
                            cab = c2b - (c2b - c3b) * k;
                        }
                        let k;
                        if (y < y1) k = 0;
                        else if (y > y3) k = 1;
                        else k = (y1 - y) / (y1 - y3);
                        xb = x1 - (x1 - x3) * k;
                        cbr = c1r - (c1r - c3r) * k;
                        cbg = c1g - (c1g - c3g) * k;
                        cbb = c1b - (c1b - c3b) * k;
                        const x1_ = Math.round(Math.min(xa, xb));
                        const x2_ = Math.round(Math.max(xa, xb));
                        let j = rowSize * y + x1_ * 4;
                        for(let x = x1_; x <= x2_; x++){
                            k = (xa - x) / (xa - xb);
                            if (k < 0) k = 0;
                            else if (k > 1) k = 1;
                            bytes[j++] = car - (car - cbr) * k | 0;
                            bytes[j++] = cag - (cag - cbg) * k | 0;
                            bytes[j++] = cab - (cab - cbb) * k | 0;
                            bytes[j++] = 255;
                        }
                    }
                }
                function drawFigure(data, figure, context) {
                    const ps = figure.coords;
                    const cs = figure.colors;
                    let i, ii;
                    switch(figure.type){
                        case "lattice":
                            const verticesPerRow = figure.verticesPerRow;
                            const rows = Math.floor(ps.length / verticesPerRow) - 1;
                            const cols = verticesPerRow - 1;
                            for(i = 0; i < rows; i++){
                                let q = i * verticesPerRow;
                                for(let j = 0; j < cols; j++, q++){
                                    drawTriangle(data, context, ps[q], ps[q + 1], ps[q + verticesPerRow], cs[q], cs[q + 1], cs[q + verticesPerRow]);
                                    drawTriangle(data, context, ps[q + verticesPerRow + 1], ps[q + 1], ps[q + verticesPerRow], cs[q + verticesPerRow + 1], cs[q + 1], cs[q + verticesPerRow]);
                                }
                            }
                            break;
                        case "triangles":
                            for(i = 0, ii = ps.length; i < ii; i += 3)drawTriangle(data, context, ps[i], ps[i + 1], ps[i + 2], cs[i], cs[i + 1], cs[i + 2]);
                            break;
                        default:
                            throw new Error("illegal figure");
                    }
                }
                class MeshShadingPattern extends BaseShadingPattern {
                    constructor(IR){
                        super();
                        this._coords = IR[2];
                        this._colors = IR[3];
                        this._figures = IR[4];
                        this._bounds = IR[5];
                        this._bbox = IR[7];
                        this._background = IR[8];
                        this.matrix = null;
                    }
                    _createMeshCanvas(combinedScale, backgroundColor, cachedCanvases) {
                        const EXPECTED_SCALE = 1.1;
                        const MAX_PATTERN_SIZE = 3000;
                        const BORDER_SIZE = 2;
                        const offsetX = Math.floor(this._bounds[0]);
                        const offsetY = Math.floor(this._bounds[1]);
                        const boundsWidth = Math.ceil(this._bounds[2]) - offsetX;
                        const boundsHeight = Math.ceil(this._bounds[3]) - offsetY;
                        const width = Math.min(Math.ceil(Math.abs(boundsWidth * combinedScale[0] * EXPECTED_SCALE)), MAX_PATTERN_SIZE);
                        const height = Math.min(Math.ceil(Math.abs(boundsHeight * combinedScale[1] * EXPECTED_SCALE)), MAX_PATTERN_SIZE);
                        const scaleX = boundsWidth / width;
                        const scaleY = boundsHeight / height;
                        const context = {
                            coords: this._coords,
                            colors: this._colors,
                            offsetX: -offsetX,
                            offsetY: -offsetY,
                            scaleX: 1 / scaleX,
                            scaleY: 1 / scaleY
                        };
                        const paddedWidth = width + BORDER_SIZE * 2;
                        const paddedHeight = height + BORDER_SIZE * 2;
                        const tmpCanvas = cachedCanvases.getCanvas("mesh", paddedWidth, paddedHeight, false);
                        const tmpCtx = tmpCanvas.context;
                        const data = tmpCtx.createImageData(width, height);
                        if (backgroundColor) {
                            const bytes = data.data;
                            for(let i = 0, ii = bytes.length; i < ii; i += 4){
                                bytes[i] = backgroundColor[0];
                                bytes[i + 1] = backgroundColor[1];
                                bytes[i + 2] = backgroundColor[2];
                                bytes[i + 3] = 255;
                            }
                        }
                        for (const figure of this._figures)drawFigure(data, figure, context);
                        tmpCtx.putImageData(data, BORDER_SIZE, BORDER_SIZE);
                        const canvas = tmpCanvas.canvas;
                        return {
                            canvas: canvas,
                            offsetX: offsetX - BORDER_SIZE * scaleX,
                            offsetY: offsetY - BORDER_SIZE * scaleY,
                            scaleX: scaleX,
                            scaleY: scaleY
                        };
                    }
                    getPattern(ctx, owner, inverse, pathType) {
                        applyBoundingBox(ctx, this._bbox);
                        let scale;
                        if (pathType === PathType.SHADING) scale = _util.Util.singularValueDecompose2dScale((0, _display_utils.getCurrentTransform)(ctx));
                        else {
                            scale = _util.Util.singularValueDecompose2dScale(owner.baseTransform);
                            if (this.matrix) {
                                const matrixScale = _util.Util.singularValueDecompose2dScale(this.matrix);
                                scale = [
                                    scale[0] * matrixScale[0],
                                    scale[1] * matrixScale[1]
                                ];
                            }
                        }
                        const temporaryPatternCanvas = this._createMeshCanvas(scale, pathType === PathType.SHADING ? null : this._background, owner.cachedCanvases);
                        if (pathType !== PathType.SHADING) {
                            ctx.setTransform(...owner.baseTransform);
                            if (this.matrix) ctx.transform(...this.matrix);
                        }
                        ctx.translate(temporaryPatternCanvas.offsetX, temporaryPatternCanvas.offsetY);
                        ctx.scale(temporaryPatternCanvas.scaleX, temporaryPatternCanvas.scaleY);
                        return ctx.createPattern(temporaryPatternCanvas.canvas, "no-repeat");
                    }
                }
                class DummyShadingPattern extends BaseShadingPattern {
                    getPattern() {
                        return "hotpink";
                    }
                }
                function getShadingPattern(IR) {
                    switch(IR[0]){
                        case "RadialAxial":
                            return new RadialAxialShadingPattern(IR);
                        case "Mesh":
                            return new MeshShadingPattern(IR);
                        case "Dummy":
                            return new DummyShadingPattern();
                    }
                    throw new Error(`Unknown IR type: ${IR[0]}`);
                }
                const PaintType = {
                    COLORED: 1,
                    UNCOLORED: 2
                };
                class TilingPattern {
                    static MAX_PATTERN_SIZE = 3000;
                    constructor(IR, color, ctx, canvasGraphicsFactory, baseTransform){
                        this.operatorList = IR[2];
                        this.matrix = IR[3] || [
                            1,
                            0,
                            0,
                            1,
                            0,
                            0
                        ];
                        this.bbox = IR[4];
                        this.xstep = IR[5];
                        this.ystep = IR[6];
                        this.paintType = IR[7];
                        this.tilingType = IR[8];
                        this.color = color;
                        this.ctx = ctx;
                        this.canvasGraphicsFactory = canvasGraphicsFactory;
                        this.baseTransform = baseTransform;
                    }
                    createPatternCanvas(owner) {
                        const operatorList = this.operatorList;
                        const bbox = this.bbox;
                        const xstep = this.xstep;
                        const ystep = this.ystep;
                        const paintType = this.paintType;
                        const tilingType = this.tilingType;
                        const color = this.color;
                        const canvasGraphicsFactory = this.canvasGraphicsFactory;
                        (0, _util.info)("TilingType: " + tilingType);
                        const x0 = bbox[0], y0 = bbox[1], x1 = bbox[2], y1 = bbox[3];
                        const matrixScale = _util.Util.singularValueDecompose2dScale(this.matrix);
                        const curMatrixScale = _util.Util.singularValueDecompose2dScale(this.baseTransform);
                        const combinedScale = [
                            matrixScale[0] * curMatrixScale[0],
                            matrixScale[1] * curMatrixScale[1]
                        ];
                        const dimx = this.getSizeAndScale(xstep, this.ctx.canvas.width, combinedScale[0]);
                        const dimy = this.getSizeAndScale(ystep, this.ctx.canvas.height, combinedScale[1]);
                        const tmpCanvas = owner.cachedCanvases.getCanvas("pattern", dimx.size, dimy.size, true);
                        const tmpCtx = tmpCanvas.context;
                        const graphics = canvasGraphicsFactory.createCanvasGraphics(tmpCtx);
                        graphics.groupLevel = owner.groupLevel;
                        this.setFillAndStrokeStyleToContext(graphics, paintType, color);
                        let adjustedX0 = x0;
                        let adjustedY0 = y0;
                        let adjustedX1 = x1;
                        let adjustedY1 = y1;
                        if (x0 < 0) {
                            adjustedX0 = 0;
                            adjustedX1 += Math.abs(x0);
                        }
                        if (y0 < 0) {
                            adjustedY0 = 0;
                            adjustedY1 += Math.abs(y0);
                        }
                        tmpCtx.translate(-(dimx.scale * adjustedX0), -(dimy.scale * adjustedY0));
                        graphics.transform(dimx.scale, 0, 0, dimy.scale, 0, 0);
                        tmpCtx.save();
                        this.clipBbox(graphics, adjustedX0, adjustedY0, adjustedX1, adjustedY1);
                        graphics.baseTransform = (0, _display_utils.getCurrentTransform)(graphics.ctx);
                        graphics.executeOperatorList(operatorList);
                        graphics.endDrawing();
                        return {
                            canvas: tmpCanvas.canvas,
                            scaleX: dimx.scale,
                            scaleY: dimy.scale,
                            offsetX: adjustedX0,
                            offsetY: adjustedY0
                        };
                    }
                    getSizeAndScale(step, realOutputSize, scale) {
                        step = Math.abs(step);
                        const maxSize = Math.max(TilingPattern.MAX_PATTERN_SIZE, realOutputSize);
                        let size = Math.ceil(step * scale);
                        if (size >= maxSize) size = maxSize;
                        else scale = size / step;
                        return {
                            scale: scale,
                            size: size
                        };
                    }
                    clipBbox(graphics, x0, y0, x1, y1) {
                        const bboxWidth = x1 - x0;
                        const bboxHeight = y1 - y0;
                        graphics.ctx.rect(x0, y0, bboxWidth, bboxHeight);
                        graphics.current.updateRectMinMax((0, _display_utils.getCurrentTransform)(graphics.ctx), [
                            x0,
                            y0,
                            x1,
                            y1
                        ]);
                        graphics.clip();
                        graphics.endPath();
                    }
                    setFillAndStrokeStyleToContext(graphics, paintType, color) {
                        const context = graphics.ctx, current = graphics.current;
                        switch(paintType){
                            case PaintType.COLORED:
                                const ctx = this.ctx;
                                context.fillStyle = ctx.fillStyle;
                                context.strokeStyle = ctx.strokeStyle;
                                current.fillColor = ctx.fillStyle;
                                current.strokeColor = ctx.strokeStyle;
                                break;
                            case PaintType.UNCOLORED:
                                const cssColor = _util.Util.makeHexColor(color[0], color[1], color[2]);
                                context.fillStyle = cssColor;
                                context.strokeStyle = cssColor;
                                current.fillColor = cssColor;
                                current.strokeColor = cssColor;
                                break;
                            default:
                                throw new _util.FormatError(`Unsupported paint type: ${paintType}`);
                        }
                    }
                    getPattern(ctx, owner, inverse, pathType) {
                        let matrix = inverse;
                        if (pathType !== PathType.SHADING) {
                            matrix = _util.Util.transform(matrix, owner.baseTransform);
                            if (this.matrix) matrix = _util.Util.transform(matrix, this.matrix);
                        }
                        const temporaryPatternCanvas = this.createPatternCanvas(owner);
                        let domMatrix = new DOMMatrix(matrix);
                        domMatrix = domMatrix.translate(temporaryPatternCanvas.offsetX, temporaryPatternCanvas.offsetY);
                        domMatrix = domMatrix.scale(1 / temporaryPatternCanvas.scaleX, 1 / temporaryPatternCanvas.scaleY);
                        const pattern = ctx.createPattern(temporaryPatternCanvas.canvas, "repeat");
                        pattern.setTransform(domMatrix);
                        return pattern;
                    }
                }
                exports.TilingPattern = TilingPattern;
            /***/ },
            /* 13 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.convertBlackAndWhiteToRGBA = convertBlackAndWhiteToRGBA;
                exports.convertToRGBA = convertToRGBA;
                exports.grayToRGBA = grayToRGBA;
                var _util = __w_pdfjs_require__(1);
                function convertToRGBA(params) {
                    switch(params.kind){
                        case _util.ImageKind.GRAYSCALE_1BPP:
                            return convertBlackAndWhiteToRGBA(params);
                        case _util.ImageKind.RGB_24BPP:
                            return convertRGBToRGBA(params);
                    }
                    return null;
                }
                function convertBlackAndWhiteToRGBA({ src, srcPos = 0, dest, width, height, nonBlackColor = 0xffffffff, inverseDecode = false }) {
                    const black = _util.FeatureTest.isLittleEndian ? 0xff000000 : 0x000000ff;
                    const [zeroMapping, oneMapping] = inverseDecode ? [
                        nonBlackColor,
                        black
                    ] : [
                        black,
                        nonBlackColor
                    ];
                    const widthInSource = width >> 3;
                    const widthRemainder = width & 7;
                    const srcLength = src.length;
                    dest = new Uint32Array(dest.buffer);
                    let destPos = 0;
                    for(let i = 0; i < height; i++){
                        for(const max = srcPos + widthInSource; srcPos < max; srcPos++){
                            const elem = srcPos < srcLength ? src[srcPos] : 255;
                            dest[destPos++] = elem & 128 ? oneMapping : zeroMapping;
                            dest[destPos++] = elem & 64 ? oneMapping : zeroMapping;
                            dest[destPos++] = elem & 32 ? oneMapping : zeroMapping;
                            dest[destPos++] = elem & 16 ? oneMapping : zeroMapping;
                            dest[destPos++] = elem & 8 ? oneMapping : zeroMapping;
                            dest[destPos++] = elem & 4 ? oneMapping : zeroMapping;
                            dest[destPos++] = elem & 2 ? oneMapping : zeroMapping;
                            dest[destPos++] = elem & 1 ? oneMapping : zeroMapping;
                        }
                        if (widthRemainder === 0) continue;
                        const elem = srcPos < srcLength ? src[srcPos++] : 255;
                        for(let j = 0; j < widthRemainder; j++)dest[destPos++] = elem & 1 << 7 - j ? oneMapping : zeroMapping;
                    }
                    return {
                        srcPos: srcPos,
                        destPos: destPos
                    };
                }
                function convertRGBToRGBA({ src, srcPos = 0, dest, destPos = 0, width, height }) {
                    let i = 0;
                    const len32 = src.length >> 2;
                    const src32 = new Uint32Array(src.buffer, srcPos, len32);
                    if (_util.FeatureTest.isLittleEndian) {
                        for(; i < len32 - 2; i += 3, destPos += 4){
                            const s1 = src32[i];
                            const s2 = src32[i + 1];
                            const s3 = src32[i + 2];
                            dest[destPos] = s1 | 0xff000000;
                            dest[destPos + 1] = s1 >>> 24 | s2 << 8 | 0xff000000;
                            dest[destPos + 2] = s2 >>> 16 | s3 << 16 | 0xff000000;
                            dest[destPos + 3] = s3 >>> 8 | 0xff000000;
                        }
                        for(let j = i * 4, jj = src.length; j < jj; j += 3)dest[destPos++] = src[j] | src[j + 1] << 8 | src[j + 2] << 16 | 0xff000000;
                    } else {
                        for(; i < len32 - 2; i += 3, destPos += 4){
                            const s1 = src32[i];
                            const s2 = src32[i + 1];
                            const s3 = src32[i + 2];
                            dest[destPos] = s1 | 0xff;
                            dest[destPos + 1] = s1 << 24 | s2 >>> 8 | 0xff;
                            dest[destPos + 2] = s2 << 16 | s3 >>> 16 | 0xff;
                            dest[destPos + 3] = s3 << 8 | 0xff;
                        }
                        for(let j = i * 4, jj = src.length; j < jj; j += 3)dest[destPos++] = src[j] << 24 | src[j + 1] << 16 | src[j + 2] << 8 | 0xff;
                    }
                    return {
                        srcPos: srcPos,
                        destPos: destPos
                    };
                }
                function grayToRGBA(src, dest) {
                    if (_util.FeatureTest.isLittleEndian) for(let i = 0, ii = src.length; i < ii; i++)dest[i] = src[i] * 0x10101 | 0xff000000;
                    else for(let i = 0, ii = src.length; i < ii; i++)dest[i] = src[i] * 0x1010100 | 0x000000ff;
                }
            /***/ },
            /* 14 */ /***/ (__unused_webpack_module, exports)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.GlobalWorkerOptions = void 0;
                const GlobalWorkerOptions = Object.create(null);
                exports.GlobalWorkerOptions = GlobalWorkerOptions;
                GlobalWorkerOptions.workerPort = null;
                GlobalWorkerOptions.workerSrc = "";
            /***/ },
            /* 15 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.MessageHandler = void 0;
                var _util = __w_pdfjs_require__(1);
                const CallbackKind = {
                    UNKNOWN: 0,
                    DATA: 1,
                    ERROR: 2
                };
                const StreamKind = {
                    UNKNOWN: 0,
                    CANCEL: 1,
                    CANCEL_COMPLETE: 2,
                    CLOSE: 3,
                    ENQUEUE: 4,
                    ERROR: 5,
                    PULL: 6,
                    PULL_COMPLETE: 7,
                    START_COMPLETE: 8
                };
                function wrapReason(reason) {
                    if (!(reason instanceof Error || typeof reason === "object" && reason !== null)) (0, _util.unreachable)('wrapReason: Expected "reason" to be a (possibly cloned) Error.');
                    switch(reason.name){
                        case "AbortException":
                            return new _util.AbortException(reason.message);
                        case "MissingPDFException":
                            return new _util.MissingPDFException(reason.message);
                        case "PasswordException":
                            return new _util.PasswordException(reason.message, reason.code);
                        case "UnexpectedResponseException":
                            return new _util.UnexpectedResponseException(reason.message, reason.status);
                        case "UnknownErrorException":
                            return new _util.UnknownErrorException(reason.message, reason.details);
                        default:
                            return new _util.UnknownErrorException(reason.message, reason.toString());
                    }
                }
                class MessageHandler {
                    constructor(sourceName, targetName, comObj){
                        this.sourceName = sourceName;
                        this.targetName = targetName;
                        this.comObj = comObj;
                        this.callbackId = 1;
                        this.streamId = 1;
                        this.streamSinks = Object.create(null);
                        this.streamControllers = Object.create(null);
                        this.callbackCapabilities = Object.create(null);
                        this.actionHandler = Object.create(null);
                        this._onComObjOnMessage = (event)=>{
                            const data = event.data;
                            if (data.targetName !== this.sourceName) return;
                            if (data.stream) {
                                this.#processStreamMessage(data);
                                return;
                            }
                            if (data.callback) {
                                const callbackId = data.callbackId;
                                const capability = this.callbackCapabilities[callbackId];
                                if (!capability) throw new Error(`Cannot resolve callback ${callbackId}`);
                                delete this.callbackCapabilities[callbackId];
                                if (data.callback === CallbackKind.DATA) capability.resolve(data.data);
                                else if (data.callback === CallbackKind.ERROR) capability.reject(wrapReason(data.reason));
                                else throw new Error("Unexpected callback case");
                                return;
                            }
                            const action = this.actionHandler[data.action];
                            if (!action) throw new Error(`Unknown action from worker: ${data.action}`);
                            if (data.callbackId) {
                                const cbSourceName = this.sourceName;
                                const cbTargetName = data.sourceName;
                                new Promise(function(resolve) {
                                    resolve(action(data.data));
                                }).then(function(result) {
                                    comObj.postMessage({
                                        sourceName: cbSourceName,
                                        targetName: cbTargetName,
                                        callback: CallbackKind.DATA,
                                        callbackId: data.callbackId,
                                        data: result
                                    });
                                }, function(reason) {
                                    comObj.postMessage({
                                        sourceName: cbSourceName,
                                        targetName: cbTargetName,
                                        callback: CallbackKind.ERROR,
                                        callbackId: data.callbackId,
                                        reason: wrapReason(reason)
                                    });
                                });
                                return;
                            }
                            if (data.streamId) {
                                this.#createStreamSink(data);
                                return;
                            }
                            action(data.data);
                        };
                        comObj.addEventListener("message", this._onComObjOnMessage);
                    }
                    on(actionName, handler) {
                        const ah = this.actionHandler;
                        if (ah[actionName]) throw new Error(`There is already an actionName called "${actionName}"`);
                        ah[actionName] = handler;
                    }
                    send(actionName, data, transfers) {
                        this.comObj.postMessage({
                            sourceName: this.sourceName,
                            targetName: this.targetName,
                            action: actionName,
                            data: data
                        }, transfers);
                    }
                    sendWithPromise(actionName, data, transfers) {
                        const callbackId = this.callbackId++;
                        const capability = new _util.PromiseCapability();
                        this.callbackCapabilities[callbackId] = capability;
                        try {
                            this.comObj.postMessage({
                                sourceName: this.sourceName,
                                targetName: this.targetName,
                                action: actionName,
                                callbackId: callbackId,
                                data: data
                            }, transfers);
                        } catch (ex) {
                            capability.reject(ex);
                        }
                        return capability.promise;
                    }
                    sendWithStream(actionName, data, queueingStrategy, transfers) {
                        const streamId = this.streamId++, sourceName = this.sourceName, targetName = this.targetName, comObj = this.comObj;
                        return new ReadableStream({
                            start: (controller)=>{
                                const startCapability = new _util.PromiseCapability();
                                this.streamControllers[streamId] = {
                                    controller: controller,
                                    startCall: startCapability,
                                    pullCall: null,
                                    cancelCall: null,
                                    isClosed: false
                                };
                                comObj.postMessage({
                                    sourceName: sourceName,
                                    targetName: targetName,
                                    action: actionName,
                                    streamId: streamId,
                                    data: data,
                                    desiredSize: controller.desiredSize
                                }, transfers);
                                return startCapability.promise;
                            },
                            pull: (controller)=>{
                                const pullCapability = new _util.PromiseCapability();
                                this.streamControllers[streamId].pullCall = pullCapability;
                                comObj.postMessage({
                                    sourceName: sourceName,
                                    targetName: targetName,
                                    stream: StreamKind.PULL,
                                    streamId: streamId,
                                    desiredSize: controller.desiredSize
                                });
                                return pullCapability.promise;
                            },
                            cancel: (reason)=>{
                                (0, _util.assert)(reason instanceof Error, "cancel must have a valid reason");
                                const cancelCapability = new _util.PromiseCapability();
                                this.streamControllers[streamId].cancelCall = cancelCapability;
                                this.streamControllers[streamId].isClosed = true;
                                comObj.postMessage({
                                    sourceName: sourceName,
                                    targetName: targetName,
                                    stream: StreamKind.CANCEL,
                                    streamId: streamId,
                                    reason: wrapReason(reason)
                                });
                                return cancelCapability.promise;
                            }
                        }, queueingStrategy);
                    }
                    #createStreamSink(data) {
                        const streamId = data.streamId, sourceName = this.sourceName, targetName = data.sourceName, comObj = this.comObj;
                        const self = this, action = this.actionHandler[data.action];
                        const streamSink = {
                            enqueue (chunk, size = 1, transfers) {
                                if (this.isCancelled) return;
                                const lastDesiredSize = this.desiredSize;
                                this.desiredSize -= size;
                                if (lastDesiredSize > 0 && this.desiredSize <= 0) {
                                    this.sinkCapability = new _util.PromiseCapability();
                                    this.ready = this.sinkCapability.promise;
                                }
                                comObj.postMessage({
                                    sourceName: sourceName,
                                    targetName: targetName,
                                    stream: StreamKind.ENQUEUE,
                                    streamId: streamId,
                                    chunk: chunk
                                }, transfers);
                            },
                            close () {
                                if (this.isCancelled) return;
                                this.isCancelled = true;
                                comObj.postMessage({
                                    sourceName: sourceName,
                                    targetName: targetName,
                                    stream: StreamKind.CLOSE,
                                    streamId: streamId
                                });
                                delete self.streamSinks[streamId];
                            },
                            error (reason) {
                                (0, _util.assert)(reason instanceof Error, "error must have a valid reason");
                                if (this.isCancelled) return;
                                this.isCancelled = true;
                                comObj.postMessage({
                                    sourceName: sourceName,
                                    targetName: targetName,
                                    stream: StreamKind.ERROR,
                                    streamId: streamId,
                                    reason: wrapReason(reason)
                                });
                            },
                            sinkCapability: new _util.PromiseCapability(),
                            onPull: null,
                            onCancel: null,
                            isCancelled: false,
                            desiredSize: data.desiredSize,
                            ready: null
                        };
                        streamSink.sinkCapability.resolve();
                        streamSink.ready = streamSink.sinkCapability.promise;
                        this.streamSinks[streamId] = streamSink;
                        new Promise(function(resolve) {
                            resolve(action(data.data, streamSink));
                        }).then(function() {
                            comObj.postMessage({
                                sourceName: sourceName,
                                targetName: targetName,
                                stream: StreamKind.START_COMPLETE,
                                streamId: streamId,
                                success: true
                            });
                        }, function(reason) {
                            comObj.postMessage({
                                sourceName: sourceName,
                                targetName: targetName,
                                stream: StreamKind.START_COMPLETE,
                                streamId: streamId,
                                reason: wrapReason(reason)
                            });
                        });
                    }
                    #processStreamMessage(data) {
                        const streamId = data.streamId, sourceName = this.sourceName, targetName = data.sourceName, comObj = this.comObj;
                        const streamController = this.streamControllers[streamId], streamSink = this.streamSinks[streamId];
                        switch(data.stream){
                            case StreamKind.START_COMPLETE:
                                if (data.success) streamController.startCall.resolve();
                                else streamController.startCall.reject(wrapReason(data.reason));
                                break;
                            case StreamKind.PULL_COMPLETE:
                                if (data.success) streamController.pullCall.resolve();
                                else streamController.pullCall.reject(wrapReason(data.reason));
                                break;
                            case StreamKind.PULL:
                                if (!streamSink) {
                                    comObj.postMessage({
                                        sourceName: sourceName,
                                        targetName: targetName,
                                        stream: StreamKind.PULL_COMPLETE,
                                        streamId: streamId,
                                        success: true
                                    });
                                    break;
                                }
                                if (streamSink.desiredSize <= 0 && data.desiredSize > 0) streamSink.sinkCapability.resolve();
                                streamSink.desiredSize = data.desiredSize;
                                new Promise(function(resolve) {
                                    resolve(streamSink.onPull?.());
                                }).then(function() {
                                    comObj.postMessage({
                                        sourceName: sourceName,
                                        targetName: targetName,
                                        stream: StreamKind.PULL_COMPLETE,
                                        streamId: streamId,
                                        success: true
                                    });
                                }, function(reason) {
                                    comObj.postMessage({
                                        sourceName: sourceName,
                                        targetName: targetName,
                                        stream: StreamKind.PULL_COMPLETE,
                                        streamId: streamId,
                                        reason: wrapReason(reason)
                                    });
                                });
                                break;
                            case StreamKind.ENQUEUE:
                                (0, _util.assert)(streamController, "enqueue should have stream controller");
                                if (streamController.isClosed) break;
                                streamController.controller.enqueue(data.chunk);
                                break;
                            case StreamKind.CLOSE:
                                (0, _util.assert)(streamController, "close should have stream controller");
                                if (streamController.isClosed) break;
                                streamController.isClosed = true;
                                streamController.controller.close();
                                this.#deleteStreamController(streamController, streamId);
                                break;
                            case StreamKind.ERROR:
                                (0, _util.assert)(streamController, "error should have stream controller");
                                streamController.controller.error(wrapReason(data.reason));
                                this.#deleteStreamController(streamController, streamId);
                                break;
                            case StreamKind.CANCEL_COMPLETE:
                                if (data.success) streamController.cancelCall.resolve();
                                else streamController.cancelCall.reject(wrapReason(data.reason));
                                this.#deleteStreamController(streamController, streamId);
                                break;
                            case StreamKind.CANCEL:
                                if (!streamSink) break;
                                new Promise(function(resolve) {
                                    resolve(streamSink.onCancel?.(wrapReason(data.reason)));
                                }).then(function() {
                                    comObj.postMessage({
                                        sourceName: sourceName,
                                        targetName: targetName,
                                        stream: StreamKind.CANCEL_COMPLETE,
                                        streamId: streamId,
                                        success: true
                                    });
                                }, function(reason) {
                                    comObj.postMessage({
                                        sourceName: sourceName,
                                        targetName: targetName,
                                        stream: StreamKind.CANCEL_COMPLETE,
                                        streamId: streamId,
                                        reason: wrapReason(reason)
                                    });
                                });
                                streamSink.sinkCapability.reject(wrapReason(data.reason));
                                streamSink.isCancelled = true;
                                delete this.streamSinks[streamId];
                                break;
                            default:
                                throw new Error("Unexpected stream case");
                        }
                    }
                    async #deleteStreamController(streamController, streamId) {
                        await Promise.allSettled([
                            streamController.startCall?.promise,
                            streamController.pullCall?.promise,
                            streamController.cancelCall?.promise
                        ]);
                        delete this.streamControllers[streamId];
                    }
                    destroy() {
                        this.comObj.removeEventListener("message", this._onComObjOnMessage);
                    }
                }
                exports.MessageHandler = MessageHandler;
            /***/ },
            /* 16 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.Metadata = void 0;
                var _util = __w_pdfjs_require__(1);
                class Metadata {
                    #metadataMap;
                    #data;
                    constructor({ parsedData, rawData }){
                        this.#metadataMap = parsedData;
                        this.#data = rawData;
                    }
                    getRaw() {
                        return this.#data;
                    }
                    get(name) {
                        return this.#metadataMap.get(name) ?? null;
                    }
                    getAll() {
                        return (0, _util.objectFromMap)(this.#metadataMap);
                    }
                    has(name) {
                        return this.#metadataMap.has(name);
                    }
                }
                exports.Metadata = Metadata;
            /***/ },
            /* 17 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.OptionalContentConfig = void 0;
                var _util = __w_pdfjs_require__(1);
                var _murmurhash = __w_pdfjs_require__(8);
                const INTERNAL = Symbol("INTERNAL");
                class OptionalContentGroup {
                    #visible = true;
                    constructor(name, intent){
                        this.name = name;
                        this.intent = intent;
                    }
                    get visible() {
                        return this.#visible;
                    }
                    _setVisible(internal, visible) {
                        if (internal !== INTERNAL) (0, _util.unreachable)("Internal method `_setVisible` called.");
                        this.#visible = visible;
                    }
                }
                class OptionalContentConfig {
                    #cachedGetHash = null;
                    #groups = new Map();
                    #initialHash = null;
                    #order = null;
                    constructor(data){
                        this.name = null;
                        this.creator = null;
                        if (data === null) return;
                        this.name = data.name;
                        this.creator = data.creator;
                        this.#order = data.order;
                        for (const group of data.groups)this.#groups.set(group.id, new OptionalContentGroup(group.name, group.intent));
                        if (data.baseState === "OFF") for (const group of this.#groups.values())group._setVisible(INTERNAL, false);
                        for (const on of data.on)this.#groups.get(on)._setVisible(INTERNAL, true);
                        for (const off of data.off)this.#groups.get(off)._setVisible(INTERNAL, false);
                        this.#initialHash = this.getHash();
                    }
                    #evaluateVisibilityExpression(array) {
                        const length = array.length;
                        if (length < 2) return true;
                        const operator = array[0];
                        for(let i = 1; i < length; i++){
                            const element = array[i];
                            let state;
                            if (Array.isArray(element)) state = this.#evaluateVisibilityExpression(element);
                            else if (this.#groups.has(element)) state = this.#groups.get(element).visible;
                            else {
                                (0, _util.warn)(`Optional content group not found: ${element}`);
                                return true;
                            }
                            switch(operator){
                                case "And":
                                    if (!state) return false;
                                    break;
                                case "Or":
                                    if (state) return true;
                                    break;
                                case "Not":
                                    return !state;
                                default:
                                    return true;
                            }
                        }
                        return operator === "And";
                    }
                    isVisible(group) {
                        if (this.#groups.size === 0) return true;
                        if (!group) {
                            (0, _util.warn)("Optional content group not defined.");
                            return true;
                        }
                        if (group.type === "OCG") {
                            if (!this.#groups.has(group.id)) {
                                (0, _util.warn)(`Optional content group not found: ${group.id}`);
                                return true;
                            }
                            return this.#groups.get(group.id).visible;
                        } else if (group.type === "OCMD") {
                            if (group.expression) return this.#evaluateVisibilityExpression(group.expression);
                            if (!group.policy || group.policy === "AnyOn") {
                                for (const id of group.ids){
                                    if (!this.#groups.has(id)) {
                                        (0, _util.warn)(`Optional content group not found: ${id}`);
                                        return true;
                                    }
                                    if (this.#groups.get(id).visible) return true;
                                }
                                return false;
                            } else if (group.policy === "AllOn") {
                                for (const id of group.ids){
                                    if (!this.#groups.has(id)) {
                                        (0, _util.warn)(`Optional content group not found: ${id}`);
                                        return true;
                                    }
                                    if (!this.#groups.get(id).visible) return false;
                                }
                                return true;
                            } else if (group.policy === "AnyOff") {
                                for (const id of group.ids){
                                    if (!this.#groups.has(id)) {
                                        (0, _util.warn)(`Optional content group not found: ${id}`);
                                        return true;
                                    }
                                    if (!this.#groups.get(id).visible) return true;
                                }
                                return false;
                            } else if (group.policy === "AllOff") {
                                for (const id of group.ids){
                                    if (!this.#groups.has(id)) {
                                        (0, _util.warn)(`Optional content group not found: ${id}`);
                                        return true;
                                    }
                                    if (this.#groups.get(id).visible) return false;
                                }
                                return true;
                            }
                            (0, _util.warn)(`Unknown optional content policy ${group.policy}.`);
                            return true;
                        }
                        (0, _util.warn)(`Unknown group type ${group.type}.`);
                        return true;
                    }
                    setVisibility(id, visible = true) {
                        if (!this.#groups.has(id)) {
                            (0, _util.warn)(`Optional content group not found: ${id}`);
                            return;
                        }
                        this.#groups.get(id)._setVisible(INTERNAL, !!visible);
                        this.#cachedGetHash = null;
                    }
                    get hasInitialVisibility() {
                        return this.#initialHash === null || this.getHash() === this.#initialHash;
                    }
                    getOrder() {
                        if (!this.#groups.size) return null;
                        if (this.#order) return this.#order.slice();
                        return [
                            ...this.#groups.keys()
                        ];
                    }
                    getGroups() {
                        return this.#groups.size > 0 ? (0, _util.objectFromMap)(this.#groups) : null;
                    }
                    getGroup(id) {
                        return this.#groups.get(id) || null;
                    }
                    getHash() {
                        if (this.#cachedGetHash !== null) return this.#cachedGetHash;
                        const hash = new _murmurhash.MurmurHash3_64();
                        for (const [id, group] of this.#groups)hash.update(`${id}:${group.visible}`);
                        return this.#cachedGetHash = hash.hexdigest();
                    }
                }
                exports.OptionalContentConfig = OptionalContentConfig;
            /***/ },
            /* 18 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.PDFDataTransportStream = void 0;
                var _util = __w_pdfjs_require__(1);
                var _display_utils = __w_pdfjs_require__(6);
                class PDFDataTransportStream {
                    constructor({ length, initialData, progressiveDone = false, contentDispositionFilename = null, disableRange = false, disableStream = false }, pdfDataRangeTransport){
                        (0, _util.assert)(pdfDataRangeTransport, 'PDFDataTransportStream - missing required "pdfDataRangeTransport" argument.');
                        this._queuedChunks = [];
                        this._progressiveDone = progressiveDone;
                        this._contentDispositionFilename = contentDispositionFilename;
                        if (initialData?.length > 0) {
                            const buffer = initialData instanceof Uint8Array && initialData.byteLength === initialData.buffer.byteLength ? initialData.buffer : new Uint8Array(initialData).buffer;
                            this._queuedChunks.push(buffer);
                        }
                        this._pdfDataRangeTransport = pdfDataRangeTransport;
                        this._isStreamingSupported = !disableStream;
                        this._isRangeSupported = !disableRange;
                        this._contentLength = length;
                        this._fullRequestReader = null;
                        this._rangeReaders = [];
                        this._pdfDataRangeTransport.addRangeListener((begin, chunk)=>{
                            this._onReceiveData({
                                begin: begin,
                                chunk: chunk
                            });
                        });
                        this._pdfDataRangeTransport.addProgressListener((loaded, total)=>{
                            this._onProgress({
                                loaded: loaded,
                                total: total
                            });
                        });
                        this._pdfDataRangeTransport.addProgressiveReadListener((chunk)=>{
                            this._onReceiveData({
                                chunk: chunk
                            });
                        });
                        this._pdfDataRangeTransport.addProgressiveDoneListener(()=>{
                            this._onProgressiveDone();
                        });
                        this._pdfDataRangeTransport.transportReady();
                    }
                    _onReceiveData({ begin, chunk }) {
                        const buffer = chunk instanceof Uint8Array && chunk.byteLength === chunk.buffer.byteLength ? chunk.buffer : new Uint8Array(chunk).buffer;
                        if (begin === undefined) {
                            if (this._fullRequestReader) this._fullRequestReader._enqueue(buffer);
                            else this._queuedChunks.push(buffer);
                        } else {
                            const found = this._rangeReaders.some(function(rangeReader) {
                                if (rangeReader._begin !== begin) return false;
                                rangeReader._enqueue(buffer);
                                return true;
                            });
                            (0, _util.assert)(found, "_onReceiveData - no `PDFDataTransportStreamRangeReader` instance found.");
                        }
                    }
                    get _progressiveDataLength() {
                        return this._fullRequestReader?._loaded ?? 0;
                    }
                    _onProgress(evt) {
                        if (evt.total === undefined) this._rangeReaders[0]?.onProgress?.({
                            loaded: evt.loaded
                        });
                        else this._fullRequestReader?.onProgress?.({
                            loaded: evt.loaded,
                            total: evt.total
                        });
                    }
                    _onProgressiveDone() {
                        this._fullRequestReader?.progressiveDone();
                        this._progressiveDone = true;
                    }
                    _removeRangeReader(reader) {
                        const i = this._rangeReaders.indexOf(reader);
                        if (i >= 0) this._rangeReaders.splice(i, 1);
                    }
                    getFullReader() {
                        (0, _util.assert)(!this._fullRequestReader, "PDFDataTransportStream.getFullReader can only be called once.");
                        const queuedChunks = this._queuedChunks;
                        this._queuedChunks = null;
                        return new PDFDataTransportStreamReader(this, queuedChunks, this._progressiveDone, this._contentDispositionFilename);
                    }
                    getRangeReader(begin, end) {
                        if (end <= this._progressiveDataLength) return null;
                        const reader = new PDFDataTransportStreamRangeReader(this, begin, end);
                        this._pdfDataRangeTransport.requestDataRange(begin, end);
                        this._rangeReaders.push(reader);
                        return reader;
                    }
                    cancelAllRequests(reason) {
                        this._fullRequestReader?.cancel(reason);
                        for (const reader of this._rangeReaders.slice(0))reader.cancel(reason);
                        this._pdfDataRangeTransport.abort();
                    }
                }
                exports.PDFDataTransportStream = PDFDataTransportStream;
                class PDFDataTransportStreamReader {
                    constructor(stream, queuedChunks, progressiveDone = false, contentDispositionFilename = null){
                        this._stream = stream;
                        this._done = progressiveDone || false;
                        this._filename = (0, _display_utils.isPdfFile)(contentDispositionFilename) ? contentDispositionFilename : null;
                        this._queuedChunks = queuedChunks || [];
                        this._loaded = 0;
                        for (const chunk of this._queuedChunks)this._loaded += chunk.byteLength;
                        this._requests = [];
                        this._headersReady = Promise.resolve();
                        stream._fullRequestReader = this;
                        this.onProgress = null;
                    }
                    _enqueue(chunk) {
                        if (this._done) return;
                        if (this._requests.length > 0) {
                            const requestCapability = this._requests.shift();
                            requestCapability.resolve({
                                value: chunk,
                                done: false
                            });
                        } else this._queuedChunks.push(chunk);
                        this._loaded += chunk.byteLength;
                    }
                    get headersReady() {
                        return this._headersReady;
                    }
                    get filename() {
                        return this._filename;
                    }
                    get isRangeSupported() {
                        return this._stream._isRangeSupported;
                    }
                    get isStreamingSupported() {
                        return this._stream._isStreamingSupported;
                    }
                    get contentLength() {
                        return this._stream._contentLength;
                    }
                    async read() {
                        if (this._queuedChunks.length > 0) {
                            const chunk = this._queuedChunks.shift();
                            return {
                                value: chunk,
                                done: false
                            };
                        }
                        if (this._done) return {
                            value: undefined,
                            done: true
                        };
                        const requestCapability = new _util.PromiseCapability();
                        this._requests.push(requestCapability);
                        return requestCapability.promise;
                    }
                    cancel(reason) {
                        this._done = true;
                        for (const requestCapability of this._requests)requestCapability.resolve({
                            value: undefined,
                            done: true
                        });
                        this._requests.length = 0;
                    }
                    progressiveDone() {
                        if (this._done) return;
                        this._done = true;
                    }
                }
                class PDFDataTransportStreamRangeReader {
                    constructor(stream, begin, end){
                        this._stream = stream;
                        this._begin = begin;
                        this._end = end;
                        this._queuedChunk = null;
                        this._requests = [];
                        this._done = false;
                        this.onProgress = null;
                    }
                    _enqueue(chunk) {
                        if (this._done) return;
                        if (this._requests.length === 0) this._queuedChunk = chunk;
                        else {
                            const requestsCapability = this._requests.shift();
                            requestsCapability.resolve({
                                value: chunk,
                                done: false
                            });
                            for (const requestCapability of this._requests)requestCapability.resolve({
                                value: undefined,
                                done: true
                            });
                            this._requests.length = 0;
                        }
                        this._done = true;
                        this._stream._removeRangeReader(this);
                    }
                    get isStreamingSupported() {
                        return false;
                    }
                    async read() {
                        if (this._queuedChunk) {
                            const chunk = this._queuedChunk;
                            this._queuedChunk = null;
                            return {
                                value: chunk,
                                done: false
                            };
                        }
                        if (this._done) return {
                            value: undefined,
                            done: true
                        };
                        const requestCapability = new _util.PromiseCapability();
                        this._requests.push(requestCapability);
                        return requestCapability.promise;
                    }
                    cancel(reason) {
                        this._done = true;
                        for (const requestCapability of this._requests)requestCapability.resolve({
                            value: undefined,
                            done: true
                        });
                        this._requests.length = 0;
                        this._stream._removeRangeReader(this);
                    }
                }
            /***/ },
            /* 19 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.PDFFetchStream = void 0;
                var _util = __w_pdfjs_require__(1);
                var _network_utils = __w_pdfjs_require__(20);
                function createFetchOptions(headers, withCredentials, abortController) {
                    return {
                        method: "GET",
                        headers: headers,
                        signal: abortController.signal,
                        mode: "cors",
                        credentials: withCredentials ? "include" : "same-origin",
                        redirect: "follow"
                    };
                }
                function createHeaders(httpHeaders) {
                    const headers = new Headers();
                    for(const property in httpHeaders){
                        const value = httpHeaders[property];
                        if (value === undefined) continue;
                        headers.append(property, value);
                    }
                    return headers;
                }
                function getArrayBuffer(val) {
                    if (val instanceof Uint8Array) return val.buffer;
                    if (val instanceof ArrayBuffer) return val;
                    (0, _util.warn)(`getArrayBuffer - unexpected data format: ${val}`);
                    return new Uint8Array(val).buffer;
                }
                class PDFFetchStream {
                    constructor(source){
                        this.source = source;
                        this.isHttp = /^https?:/i.test(source.url);
                        this.httpHeaders = this.isHttp && source.httpHeaders || {};
                        this._fullRequestReader = null;
                        this._rangeRequestReaders = [];
                    }
                    get _progressiveDataLength() {
                        return this._fullRequestReader?._loaded ?? 0;
                    }
                    getFullReader() {
                        (0, _util.assert)(!this._fullRequestReader, "PDFFetchStream.getFullReader can only be called once.");
                        this._fullRequestReader = new PDFFetchStreamReader(this);
                        return this._fullRequestReader;
                    }
                    getRangeReader(begin, end) {
                        if (end <= this._progressiveDataLength) return null;
                        const reader = new PDFFetchStreamRangeReader(this, begin, end);
                        this._rangeRequestReaders.push(reader);
                        return reader;
                    }
                    cancelAllRequests(reason) {
                        this._fullRequestReader?.cancel(reason);
                        for (const reader of this._rangeRequestReaders.slice(0))reader.cancel(reason);
                    }
                }
                exports.PDFFetchStream = PDFFetchStream;
                class PDFFetchStreamReader {
                    constructor(stream){
                        this._stream = stream;
                        this._reader = null;
                        this._loaded = 0;
                        this._filename = null;
                        const source = stream.source;
                        this._withCredentials = source.withCredentials || false;
                        this._contentLength = source.length;
                        this._headersCapability = new _util.PromiseCapability();
                        this._disableRange = source.disableRange || false;
                        this._rangeChunkSize = source.rangeChunkSize;
                        if (!this._rangeChunkSize && !this._disableRange) this._disableRange = true;
                        this._abortController = new AbortController();
                        this._isStreamingSupported = !source.disableStream;
                        this._isRangeSupported = !source.disableRange;
                        this._headers = createHeaders(this._stream.httpHeaders);
                        const url = source.url;
                        fetch(url, createFetchOptions(this._headers, this._withCredentials, this._abortController)).then((response)=>{
                            if (!(0, _network_utils.validateResponseStatus)(response.status)) throw (0, _network_utils.createResponseStatusError)(response.status, url);
                            this._reader = response.body.getReader();
                            this._headersCapability.resolve();
                            const getResponseHeader = (name)=>{
                                return response.headers.get(name);
                            };
                            const { allowRangeRequests, suggestedLength } = (0, _network_utils.validateRangeRequestCapabilities)({
                                getResponseHeader: getResponseHeader,
                                isHttp: this._stream.isHttp,
                                rangeChunkSize: this._rangeChunkSize,
                                disableRange: this._disableRange
                            });
                            this._isRangeSupported = allowRangeRequests;
                            this._contentLength = suggestedLength || this._contentLength;
                            this._filename = (0, _network_utils.extractFilenameFromHeader)(getResponseHeader);
                            if (!this._isStreamingSupported && this._isRangeSupported) this.cancel(new _util.AbortException("Streaming is disabled."));
                        }).catch(this._headersCapability.reject);
                        this.onProgress = null;
                    }
                    get headersReady() {
                        return this._headersCapability.promise;
                    }
                    get filename() {
                        return this._filename;
                    }
                    get contentLength() {
                        return this._contentLength;
                    }
                    get isRangeSupported() {
                        return this._isRangeSupported;
                    }
                    get isStreamingSupported() {
                        return this._isStreamingSupported;
                    }
                    async read() {
                        await this._headersCapability.promise;
                        const { value, done } = await this._reader.read();
                        if (done) return {
                            value: value,
                            done: done
                        };
                        this._loaded += value.byteLength;
                        this.onProgress?.({
                            loaded: this._loaded,
                            total: this._contentLength
                        });
                        return {
                            value: getArrayBuffer(value),
                            done: false
                        };
                    }
                    cancel(reason) {
                        this._reader?.cancel(reason);
                        this._abortController.abort();
                    }
                }
                class PDFFetchStreamRangeReader {
                    constructor(stream, begin, end){
                        this._stream = stream;
                        this._reader = null;
                        this._loaded = 0;
                        const source = stream.source;
                        this._withCredentials = source.withCredentials || false;
                        this._readCapability = new _util.PromiseCapability();
                        this._isStreamingSupported = !source.disableStream;
                        this._abortController = new AbortController();
                        this._headers = createHeaders(this._stream.httpHeaders);
                        this._headers.append("Range", `bytes=${begin}-${end - 1}`);
                        const url = source.url;
                        fetch(url, createFetchOptions(this._headers, this._withCredentials, this._abortController)).then((response)=>{
                            if (!(0, _network_utils.validateResponseStatus)(response.status)) throw (0, _network_utils.createResponseStatusError)(response.status, url);
                            this._readCapability.resolve();
                            this._reader = response.body.getReader();
                        }).catch(this._readCapability.reject);
                        this.onProgress = null;
                    }
                    get isStreamingSupported() {
                        return this._isStreamingSupported;
                    }
                    async read() {
                        await this._readCapability.promise;
                        const { value, done } = await this._reader.read();
                        if (done) return {
                            value: value,
                            done: done
                        };
                        this._loaded += value.byteLength;
                        this.onProgress?.({
                            loaded: this._loaded
                        });
                        return {
                            value: getArrayBuffer(value),
                            done: false
                        };
                    }
                    cancel(reason) {
                        this._reader?.cancel(reason);
                        this._abortController.abort();
                    }
                }
            /***/ },
            /* 20 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.createResponseStatusError = createResponseStatusError;
                exports.extractFilenameFromHeader = extractFilenameFromHeader;
                exports.validateRangeRequestCapabilities = validateRangeRequestCapabilities;
                exports.validateResponseStatus = validateResponseStatus;
                var _util = __w_pdfjs_require__(1);
                var _content_disposition = __w_pdfjs_require__(21);
                var _display_utils = __w_pdfjs_require__(6);
                function validateRangeRequestCapabilities({ getResponseHeader, isHttp, rangeChunkSize, disableRange }) {
                    const returnValues = {
                        allowRangeRequests: false,
                        suggestedLength: undefined
                    };
                    const length = parseInt(getResponseHeader("Content-Length"), 10);
                    if (!Number.isInteger(length)) return returnValues;
                    returnValues.suggestedLength = length;
                    if (length <= 2 * rangeChunkSize) return returnValues;
                    if (disableRange || !isHttp) return returnValues;
                    if (getResponseHeader("Accept-Ranges") !== "bytes") return returnValues;
                    const contentEncoding = getResponseHeader("Content-Encoding") || "identity";
                    if (contentEncoding !== "identity") return returnValues;
                    returnValues.allowRangeRequests = true;
                    return returnValues;
                }
                function extractFilenameFromHeader(getResponseHeader) {
                    const contentDisposition = getResponseHeader("Content-Disposition");
                    if (contentDisposition) {
                        let filename = (0, _content_disposition.getFilenameFromContentDispositionHeader)(contentDisposition);
                        if (filename.includes("%")) try {
                            filename = decodeURIComponent(filename);
                        } catch  {}
                        if ((0, _display_utils.isPdfFile)(filename)) return filename;
                    }
                    return null;
                }
                function createResponseStatusError(status, url) {
                    if (status === 404 || status === 0 && url.startsWith("file:")) return new _util.MissingPDFException('Missing PDF "' + url + '".');
                    return new _util.UnexpectedResponseException(`Unexpected server response (${status}) while retrieving PDF "${url}".`, status);
                }
                function validateResponseStatus(status) {
                    return status === 200 || status === 206;
                }
            /***/ },
            /* 21 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.getFilenameFromContentDispositionHeader = getFilenameFromContentDispositionHeader;
                var _util = __w_pdfjs_require__(1);
                function getFilenameFromContentDispositionHeader(contentDisposition) {
                    let needsEncodingFixup = true;
                    let tmp = toParamRegExp("filename\\*", "i").exec(contentDisposition);
                    if (tmp) {
                        tmp = tmp[1];
                        let filename = rfc2616unquote(tmp);
                        filename = unescape(filename);
                        filename = rfc5987decode(filename);
                        filename = rfc2047decode(filename);
                        return fixupEncoding(filename);
                    }
                    tmp = rfc2231getparam(contentDisposition);
                    if (tmp) {
                        const filename = rfc2047decode(tmp);
                        return fixupEncoding(filename);
                    }
                    tmp = toParamRegExp("filename", "i").exec(contentDisposition);
                    if (tmp) {
                        tmp = tmp[1];
                        let filename = rfc2616unquote(tmp);
                        filename = rfc2047decode(filename);
                        return fixupEncoding(filename);
                    }
                    function toParamRegExp(attributePattern, flags) {
                        return new RegExp("(?:^|;)\\s*" + attributePattern + "\\s*=\\s*" + "(" + '[^";\\s][^;\\s]*' + "|" + '"(?:[^"\\\\]|\\\\"?)+"?' + ")", flags);
                    }
                    function textdecode(encoding, value) {
                        if (encoding) {
                            if (!/^[\x00-\xFF]+$/.test(value)) return value;
                            try {
                                const decoder = new TextDecoder(encoding, {
                                    fatal: true
                                });
                                const buffer = (0, _util.stringToBytes)(value);
                                value = decoder.decode(buffer);
                                needsEncodingFixup = false;
                            } catch  {}
                        }
                        return value;
                    }
                    function fixupEncoding(value) {
                        if (needsEncodingFixup && /[\x80-\xff]/.test(value)) {
                            value = textdecode("utf-8", value);
                            if (needsEncodingFixup) value = textdecode("iso-8859-1", value);
                        }
                        return value;
                    }
                    function rfc2231getparam(contentDispositionStr) {
                        const matches = [];
                        let match;
                        const iter = toParamRegExp("filename\\*((?!0\\d)\\d+)(\\*?)", "ig");
                        while((match = iter.exec(contentDispositionStr)) !== null){
                            let [, n, quot, part] = match;
                            n = parseInt(n, 10);
                            if (n in matches) {
                                if (n === 0) break;
                                continue;
                            }
                            matches[n] = [
                                quot,
                                part
                            ];
                        }
                        const parts = [];
                        for(let n = 0; n < matches.length; ++n){
                            if (!(n in matches)) break;
                            let [quot, part] = matches[n];
                            part = rfc2616unquote(part);
                            if (quot) {
                                part = unescape(part);
                                if (n === 0) part = rfc5987decode(part);
                            }
                            parts.push(part);
                        }
                        return parts.join("");
                    }
                    function rfc2616unquote(value) {
                        if (value.startsWith('"')) {
                            const parts = value.slice(1).split('\\"');
                            for(let i = 0; i < parts.length; ++i){
                                const quotindex = parts[i].indexOf('"');
                                if (quotindex !== -1) {
                                    parts[i] = parts[i].slice(0, quotindex);
                                    parts.length = i + 1;
                                }
                                parts[i] = parts[i].replaceAll(/\\(.)/g, "$1");
                            }
                            value = parts.join('"');
                        }
                        return value;
                    }
                    function rfc5987decode(extvalue) {
                        const encodingend = extvalue.indexOf("'");
                        if (encodingend === -1) return extvalue;
                        const encoding = extvalue.slice(0, encodingend);
                        const langvalue = extvalue.slice(encodingend + 1);
                        const value = langvalue.replace(/^[^']*'/, "");
                        return textdecode(encoding, value);
                    }
                    function rfc2047decode(value) {
                        if (!value.startsWith("=?") || /[\x00-\x19\x80-\xff]/.test(value)) return value;
                        return value.replaceAll(/=\?([\w-]*)\?([QqBb])\?((?:[^?]|\?(?!=))*)\?=/g, function(matches, charset, encoding, text) {
                            if (encoding === "q" || encoding === "Q") {
                                text = text.replaceAll("_", " ");
                                text = text.replaceAll(/=([0-9a-fA-F]{2})/g, function(match, hex) {
                                    return String.fromCharCode(parseInt(hex, 16));
                                });
                                return textdecode(charset, text);
                            }
                            try {
                                text = atob(text);
                            } catch  {}
                            return textdecode(charset, text);
                        });
                    }
                    return "";
                }
            /***/ },
            /* 22 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.PDFNetworkStream = void 0;
                var _util = __w_pdfjs_require__(1);
                var _network_utils = __w_pdfjs_require__(20);
                const OK_RESPONSE = 200;
                const PARTIAL_CONTENT_RESPONSE = 206;
                function getArrayBuffer(xhr) {
                    const data = xhr.response;
                    if (typeof data !== "string") return data;
                    return (0, _util.stringToBytes)(data).buffer;
                }
                class NetworkManager {
                    constructor(url, args = {}){
                        this.url = url;
                        this.isHttp = /^https?:/i.test(url);
                        this.httpHeaders = this.isHttp && args.httpHeaders || Object.create(null);
                        this.withCredentials = args.withCredentials || false;
                        this.currXhrId = 0;
                        this.pendingRequests = Object.create(null);
                    }
                    requestRange(begin, end, listeners) {
                        const args = {
                            begin: begin,
                            end: end
                        };
                        for(const prop in listeners)args[prop] = listeners[prop];
                        return this.request(args);
                    }
                    requestFull(listeners) {
                        return this.request(listeners);
                    }
                    request(args) {
                        const xhr = new XMLHttpRequest();
                        const xhrId = this.currXhrId++;
                        const pendingRequest = this.pendingRequests[xhrId] = {
                            xhr: xhr
                        };
                        xhr.open("GET", this.url);
                        xhr.withCredentials = this.withCredentials;
                        for(const property in this.httpHeaders){
                            const value = this.httpHeaders[property];
                            if (value === undefined) continue;
                            xhr.setRequestHeader(property, value);
                        }
                        if (this.isHttp && "begin" in args && "end" in args) {
                            xhr.setRequestHeader("Range", `bytes=${args.begin}-${args.end - 1}`);
                            pendingRequest.expectedStatus = PARTIAL_CONTENT_RESPONSE;
                        } else pendingRequest.expectedStatus = OK_RESPONSE;
                        xhr.responseType = "arraybuffer";
                        if (args.onError) xhr.onerror = function(evt) {
                            args.onError(xhr.status);
                        };
                        xhr.onreadystatechange = this.onStateChange.bind(this, xhrId);
                        xhr.onprogress = this.onProgress.bind(this, xhrId);
                        pendingRequest.onHeadersReceived = args.onHeadersReceived;
                        pendingRequest.onDone = args.onDone;
                        pendingRequest.onError = args.onError;
                        pendingRequest.onProgress = args.onProgress;
                        xhr.send(null);
                        return xhrId;
                    }
                    onProgress(xhrId, evt) {
                        const pendingRequest = this.pendingRequests[xhrId];
                        if (!pendingRequest) return;
                        pendingRequest.onProgress?.(evt);
                    }
                    onStateChange(xhrId, evt) {
                        const pendingRequest = this.pendingRequests[xhrId];
                        if (!pendingRequest) return;
                        const xhr = pendingRequest.xhr;
                        if (xhr.readyState >= 2 && pendingRequest.onHeadersReceived) {
                            pendingRequest.onHeadersReceived();
                            delete pendingRequest.onHeadersReceived;
                        }
                        if (xhr.readyState !== 4) return;
                        if (!(xhrId in this.pendingRequests)) return;
                        delete this.pendingRequests[xhrId];
                        if (xhr.status === 0 && this.isHttp) {
                            pendingRequest.onError?.(xhr.status);
                            return;
                        }
                        const xhrStatus = xhr.status || OK_RESPONSE;
                        const ok_response_on_range_request = xhrStatus === OK_RESPONSE && pendingRequest.expectedStatus === PARTIAL_CONTENT_RESPONSE;
                        if (!ok_response_on_range_request && xhrStatus !== pendingRequest.expectedStatus) {
                            pendingRequest.onError?.(xhr.status);
                            return;
                        }
                        const chunk = getArrayBuffer(xhr);
                        if (xhrStatus === PARTIAL_CONTENT_RESPONSE) {
                            const rangeHeader = xhr.getResponseHeader("Content-Range");
                            const matches = /bytes (\d+)-(\d+)\/(\d+)/.exec(rangeHeader);
                            pendingRequest.onDone({
                                begin: parseInt(matches[1], 10),
                                chunk: chunk
                            });
                        } else if (chunk) pendingRequest.onDone({
                            begin: 0,
                            chunk: chunk
                        });
                        else pendingRequest.onError?.(xhr.status);
                    }
                    getRequestXhr(xhrId) {
                        return this.pendingRequests[xhrId].xhr;
                    }
                    isPendingRequest(xhrId) {
                        return xhrId in this.pendingRequests;
                    }
                    abortRequest(xhrId) {
                        const xhr = this.pendingRequests[xhrId].xhr;
                        delete this.pendingRequests[xhrId];
                        xhr.abort();
                    }
                }
                class PDFNetworkStream {
                    constructor(source){
                        this._source = source;
                        this._manager = new NetworkManager(source.url, {
                            httpHeaders: source.httpHeaders,
                            withCredentials: source.withCredentials
                        });
                        this._rangeChunkSize = source.rangeChunkSize;
                        this._fullRequestReader = null;
                        this._rangeRequestReaders = [];
                    }
                    _onRangeRequestReaderClosed(reader) {
                        const i = this._rangeRequestReaders.indexOf(reader);
                        if (i >= 0) this._rangeRequestReaders.splice(i, 1);
                    }
                    getFullReader() {
                        (0, _util.assert)(!this._fullRequestReader, "PDFNetworkStream.getFullReader can only be called once.");
                        this._fullRequestReader = new PDFNetworkStreamFullRequestReader(this._manager, this._source);
                        return this._fullRequestReader;
                    }
                    getRangeReader(begin, end) {
                        const reader = new PDFNetworkStreamRangeRequestReader(this._manager, begin, end);
                        reader.onClosed = this._onRangeRequestReaderClosed.bind(this);
                        this._rangeRequestReaders.push(reader);
                        return reader;
                    }
                    cancelAllRequests(reason) {
                        this._fullRequestReader?.cancel(reason);
                        for (const reader of this._rangeRequestReaders.slice(0))reader.cancel(reason);
                    }
                }
                exports.PDFNetworkStream = PDFNetworkStream;
                class PDFNetworkStreamFullRequestReader {
                    constructor(manager, source){
                        this._manager = manager;
                        const args = {
                            onHeadersReceived: this._onHeadersReceived.bind(this),
                            onDone: this._onDone.bind(this),
                            onError: this._onError.bind(this),
                            onProgress: this._onProgress.bind(this)
                        };
                        this._url = source.url;
                        this._fullRequestId = manager.requestFull(args);
                        this._headersReceivedCapability = new _util.PromiseCapability();
                        this._disableRange = source.disableRange || false;
                        this._contentLength = source.length;
                        this._rangeChunkSize = source.rangeChunkSize;
                        if (!this._rangeChunkSize && !this._disableRange) this._disableRange = true;
                        this._isStreamingSupported = false;
                        this._isRangeSupported = false;
                        this._cachedChunks = [];
                        this._requests = [];
                        this._done = false;
                        this._storedError = undefined;
                        this._filename = null;
                        this.onProgress = null;
                    }
                    _onHeadersReceived() {
                        const fullRequestXhrId = this._fullRequestId;
                        const fullRequestXhr = this._manager.getRequestXhr(fullRequestXhrId);
                        const getResponseHeader = (name)=>{
                            return fullRequestXhr.getResponseHeader(name);
                        };
                        const { allowRangeRequests, suggestedLength } = (0, _network_utils.validateRangeRequestCapabilities)({
                            getResponseHeader: getResponseHeader,
                            isHttp: this._manager.isHttp,
                            rangeChunkSize: this._rangeChunkSize,
                            disableRange: this._disableRange
                        });
                        if (allowRangeRequests) this._isRangeSupported = true;
                        this._contentLength = suggestedLength || this._contentLength;
                        this._filename = (0, _network_utils.extractFilenameFromHeader)(getResponseHeader);
                        if (this._isRangeSupported) this._manager.abortRequest(fullRequestXhrId);
                        this._headersReceivedCapability.resolve();
                    }
                    _onDone(data) {
                        if (data) {
                            if (this._requests.length > 0) {
                                const requestCapability = this._requests.shift();
                                requestCapability.resolve({
                                    value: data.chunk,
                                    done: false
                                });
                            } else this._cachedChunks.push(data.chunk);
                        }
                        this._done = true;
                        if (this._cachedChunks.length > 0) return;
                        for (const requestCapability of this._requests)requestCapability.resolve({
                            value: undefined,
                            done: true
                        });
                        this._requests.length = 0;
                    }
                    _onError(status) {
                        this._storedError = (0, _network_utils.createResponseStatusError)(status, this._url);
                        this._headersReceivedCapability.reject(this._storedError);
                        for (const requestCapability of this._requests)requestCapability.reject(this._storedError);
                        this._requests.length = 0;
                        this._cachedChunks.length = 0;
                    }
                    _onProgress(evt) {
                        this.onProgress?.({
                            loaded: evt.loaded,
                            total: evt.lengthComputable ? evt.total : this._contentLength
                        });
                    }
                    get filename() {
                        return this._filename;
                    }
                    get isRangeSupported() {
                        return this._isRangeSupported;
                    }
                    get isStreamingSupported() {
                        return this._isStreamingSupported;
                    }
                    get contentLength() {
                        return this._contentLength;
                    }
                    get headersReady() {
                        return this._headersReceivedCapability.promise;
                    }
                    async read() {
                        if (this._storedError) throw this._storedError;
                        if (this._cachedChunks.length > 0) {
                            const chunk = this._cachedChunks.shift();
                            return {
                                value: chunk,
                                done: false
                            };
                        }
                        if (this._done) return {
                            value: undefined,
                            done: true
                        };
                        const requestCapability = new _util.PromiseCapability();
                        this._requests.push(requestCapability);
                        return requestCapability.promise;
                    }
                    cancel(reason) {
                        this._done = true;
                        this._headersReceivedCapability.reject(reason);
                        for (const requestCapability of this._requests)requestCapability.resolve({
                            value: undefined,
                            done: true
                        });
                        this._requests.length = 0;
                        if (this._manager.isPendingRequest(this._fullRequestId)) this._manager.abortRequest(this._fullRequestId);
                        this._fullRequestReader = null;
                    }
                }
                class PDFNetworkStreamRangeRequestReader {
                    constructor(manager, begin, end){
                        this._manager = manager;
                        const args = {
                            onDone: this._onDone.bind(this),
                            onError: this._onError.bind(this),
                            onProgress: this._onProgress.bind(this)
                        };
                        this._url = manager.url;
                        this._requestId = manager.requestRange(begin, end, args);
                        this._requests = [];
                        this._queuedChunk = null;
                        this._done = false;
                        this._storedError = undefined;
                        this.onProgress = null;
                        this.onClosed = null;
                    }
                    _close() {
                        this.onClosed?.(this);
                    }
                    _onDone(data) {
                        const chunk = data.chunk;
                        if (this._requests.length > 0) {
                            const requestCapability = this._requests.shift();
                            requestCapability.resolve({
                                value: chunk,
                                done: false
                            });
                        } else this._queuedChunk = chunk;
                        this._done = true;
                        for (const requestCapability of this._requests)requestCapability.resolve({
                            value: undefined,
                            done: true
                        });
                        this._requests.length = 0;
                        this._close();
                    }
                    _onError(status) {
                        this._storedError = (0, _network_utils.createResponseStatusError)(status, this._url);
                        for (const requestCapability of this._requests)requestCapability.reject(this._storedError);
                        this._requests.length = 0;
                        this._queuedChunk = null;
                    }
                    _onProgress(evt) {
                        if (!this.isStreamingSupported) this.onProgress?.({
                            loaded: evt.loaded
                        });
                    }
                    get isStreamingSupported() {
                        return false;
                    }
                    async read() {
                        if (this._storedError) throw this._storedError;
                        if (this._queuedChunk !== null) {
                            const chunk = this._queuedChunk;
                            this._queuedChunk = null;
                            return {
                                value: chunk,
                                done: false
                            };
                        }
                        if (this._done) return {
                            value: undefined,
                            done: true
                        };
                        const requestCapability = new _util.PromiseCapability();
                        this._requests.push(requestCapability);
                        return requestCapability.promise;
                    }
                    cancel(reason) {
                        this._done = true;
                        for (const requestCapability of this._requests)requestCapability.resolve({
                            value: undefined,
                            done: true
                        });
                        this._requests.length = 0;
                        if (this._manager.isPendingRequest(this._requestId)) this._manager.abortRequest(this._requestId);
                        this._close();
                    }
                }
            /***/ },
            /* 23 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.PDFNodeStream = void 0;
                var _util = __w_pdfjs_require__(1);
                var _network_utils = __w_pdfjs_require__(20);
                const fileUriRegex = /^file:\/\/\/[a-zA-Z]:\//;
                function parseUrl(sourceUrl) {
                    const url = (parcelRequire("7NlT1"));
                    const parsedUrl = url.parse(sourceUrl);
                    if (parsedUrl.protocol === "file:" || parsedUrl.host) return parsedUrl;
                    if (/^[a-z]:[/\\]/i.test(sourceUrl)) return url.parse(`file:///${sourceUrl}`);
                    if (!parsedUrl.host) parsedUrl.protocol = "file:";
                    return parsedUrl;
                }
                class PDFNodeStream {
                    constructor(source){
                        this.source = source;
                        this.url = parseUrl(source.url);
                        this.isHttp = this.url.protocol === "http:" || this.url.protocol === "https:";
                        this.isFsUrl = this.url.protocol === "file:";
                        this.httpHeaders = this.isHttp && source.httpHeaders || {};
                        this._fullRequestReader = null;
                        this._rangeRequestReaders = [];
                    }
                    get _progressiveDataLength() {
                        return this._fullRequestReader?._loaded ?? 0;
                    }
                    getFullReader() {
                        (0, _util.assert)(!this._fullRequestReader, "PDFNodeStream.getFullReader can only be called once.");
                        this._fullRequestReader = this.isFsUrl ? new PDFNodeStreamFsFullReader(this) : new PDFNodeStreamFullReader(this);
                        return this._fullRequestReader;
                    }
                    getRangeReader(start, end) {
                        if (end <= this._progressiveDataLength) return null;
                        const rangeReader = this.isFsUrl ? new PDFNodeStreamFsRangeReader(this, start, end) : new PDFNodeStreamRangeReader(this, start, end);
                        this._rangeRequestReaders.push(rangeReader);
                        return rangeReader;
                    }
                    cancelAllRequests(reason) {
                        this._fullRequestReader?.cancel(reason);
                        for (const reader of this._rangeRequestReaders.slice(0))reader.cancel(reason);
                    }
                }
                exports.PDFNodeStream = PDFNodeStream;
                class BaseFullReader {
                    constructor(stream){
                        this._url = stream.url;
                        this._done = false;
                        this._storedError = null;
                        this.onProgress = null;
                        const source = stream.source;
                        this._contentLength = source.length;
                        this._loaded = 0;
                        this._filename = null;
                        this._disableRange = source.disableRange || false;
                        this._rangeChunkSize = source.rangeChunkSize;
                        if (!this._rangeChunkSize && !this._disableRange) this._disableRange = true;
                        this._isStreamingSupported = !source.disableStream;
                        this._isRangeSupported = !source.disableRange;
                        this._readableStream = null;
                        this._readCapability = new _util.PromiseCapability();
                        this._headersCapability = new _util.PromiseCapability();
                    }
                    get headersReady() {
                        return this._headersCapability.promise;
                    }
                    get filename() {
                        return this._filename;
                    }
                    get contentLength() {
                        return this._contentLength;
                    }
                    get isRangeSupported() {
                        return this._isRangeSupported;
                    }
                    get isStreamingSupported() {
                        return this._isStreamingSupported;
                    }
                    async read() {
                        await this._readCapability.promise;
                        if (this._done) return {
                            value: undefined,
                            done: true
                        };
                        if (this._storedError) throw this._storedError;
                        const chunk = this._readableStream.read();
                        if (chunk === null) {
                            this._readCapability = new _util.PromiseCapability();
                            return this.read();
                        }
                        this._loaded += chunk.length;
                        this.onProgress?.({
                            loaded: this._loaded,
                            total: this._contentLength
                        });
                        const buffer = new Uint8Array(chunk).buffer;
                        return {
                            value: buffer,
                            done: false
                        };
                    }
                    cancel(reason) {
                        if (!this._readableStream) {
                            this._error(reason);
                            return;
                        }
                        this._readableStream.destroy(reason);
                    }
                    _error(reason) {
                        this._storedError = reason;
                        this._readCapability.resolve();
                    }
                    _setReadableStream(readableStream) {
                        this._readableStream = readableStream;
                        readableStream.on("readable", ()=>{
                            this._readCapability.resolve();
                        });
                        readableStream.on("end", ()=>{
                            readableStream.destroy();
                            this._done = true;
                            this._readCapability.resolve();
                        });
                        readableStream.on("error", (reason)=>{
                            this._error(reason);
                        });
                        if (!this._isStreamingSupported && this._isRangeSupported) this._error(new _util.AbortException("streaming is disabled"));
                        if (this._storedError) this._readableStream.destroy(this._storedError);
                    }
                }
                class BaseRangeReader {
                    constructor(stream){
                        this._url = stream.url;
                        this._done = false;
                        this._storedError = null;
                        this.onProgress = null;
                        this._loaded = 0;
                        this._readableStream = null;
                        this._readCapability = new _util.PromiseCapability();
                        const source = stream.source;
                        this._isStreamingSupported = !source.disableStream;
                    }
                    get isStreamingSupported() {
                        return this._isStreamingSupported;
                    }
                    async read() {
                        await this._readCapability.promise;
                        if (this._done) return {
                            value: undefined,
                            done: true
                        };
                        if (this._storedError) throw this._storedError;
                        const chunk = this._readableStream.read();
                        if (chunk === null) {
                            this._readCapability = new _util.PromiseCapability();
                            return this.read();
                        }
                        this._loaded += chunk.length;
                        this.onProgress?.({
                            loaded: this._loaded
                        });
                        const buffer = new Uint8Array(chunk).buffer;
                        return {
                            value: buffer,
                            done: false
                        };
                    }
                    cancel(reason) {
                        if (!this._readableStream) {
                            this._error(reason);
                            return;
                        }
                        this._readableStream.destroy(reason);
                    }
                    _error(reason) {
                        this._storedError = reason;
                        this._readCapability.resolve();
                    }
                    _setReadableStream(readableStream) {
                        this._readableStream = readableStream;
                        readableStream.on("readable", ()=>{
                            this._readCapability.resolve();
                        });
                        readableStream.on("end", ()=>{
                            readableStream.destroy();
                            this._done = true;
                            this._readCapability.resolve();
                        });
                        readableStream.on("error", (reason)=>{
                            this._error(reason);
                        });
                        if (this._storedError) this._readableStream.destroy(this._storedError);
                    }
                }
                function createRequestOptions(parsedUrl, headers) {
                    return {
                        protocol: parsedUrl.protocol,
                        auth: parsedUrl.auth,
                        host: parsedUrl.hostname,
                        port: parsedUrl.port,
                        path: parsedUrl.path,
                        method: "GET",
                        headers: headers
                    };
                }
                class PDFNodeStreamFullReader extends BaseFullReader {
                    constructor(stream){
                        super(stream);
                        const handleResponse = (response)=>{
                            if (response.statusCode === 404) {
                                const error = new _util.MissingPDFException(`Missing PDF "${this._url}".`);
                                this._storedError = error;
                                this._headersCapability.reject(error);
                                return;
                            }
                            this._headersCapability.resolve();
                            this._setReadableStream(response);
                            const getResponseHeader = (name)=>{
                                return this._readableStream.headers[name.toLowerCase()];
                            };
                            const { allowRangeRequests, suggestedLength } = (0, _network_utils.validateRangeRequestCapabilities)({
                                getResponseHeader: getResponseHeader,
                                isHttp: stream.isHttp,
                                rangeChunkSize: this._rangeChunkSize,
                                disableRange: this._disableRange
                            });
                            this._isRangeSupported = allowRangeRequests;
                            this._contentLength = suggestedLength || this._contentLength;
                            this._filename = (0, _network_utils.extractFilenameFromHeader)(getResponseHeader);
                        };
                        this._request = null;
                        if (this._url.protocol === "http:") {
                            const http = (parcelRequire("7NlT1"));
                            this._request = http.request(createRequestOptions(this._url, stream.httpHeaders), handleResponse);
                        } else {
                            const https = (parcelRequire("7NlT1"));
                            this._request = https.request(createRequestOptions(this._url, stream.httpHeaders), handleResponse);
                        }
                        this._request.on("error", (reason)=>{
                            this._storedError = reason;
                            this._headersCapability.reject(reason);
                        });
                        this._request.end();
                    }
                }
                class PDFNodeStreamRangeReader extends BaseRangeReader {
                    constructor(stream, start, end){
                        super(stream);
                        this._httpHeaders = {};
                        for(const property in stream.httpHeaders){
                            const value = stream.httpHeaders[property];
                            if (value === undefined) continue;
                            this._httpHeaders[property] = value;
                        }
                        this._httpHeaders.Range = `bytes=${start}-${end - 1}`;
                        const handleResponse = (response)=>{
                            if (response.statusCode === 404) {
                                const error = new _util.MissingPDFException(`Missing PDF "${this._url}".`);
                                this._storedError = error;
                                return;
                            }
                            this._setReadableStream(response);
                        };
                        this._request = null;
                        if (this._url.protocol === "http:") {
                            const http = (parcelRequire("7NlT1"));
                            this._request = http.request(createRequestOptions(this._url, this._httpHeaders), handleResponse);
                        } else {
                            const https = (parcelRequire("7NlT1"));
                            this._request = https.request(createRequestOptions(this._url, this._httpHeaders), handleResponse);
                        }
                        this._request.on("error", (reason)=>{
                            this._storedError = reason;
                        });
                        this._request.end();
                    }
                }
                class PDFNodeStreamFsFullReader extends BaseFullReader {
                    constructor(stream){
                        super(stream);
                        let path = decodeURIComponent(this._url.path);
                        if (fileUriRegex.test(this._url.href)) path = path.replace(/^\//, "");
                        const fs = (parcelRequire("7NlT1"));
                        fs.lstat(path, (error, stat)=>{
                            if (error) {
                                if (error.code === "ENOENT") error = new _util.MissingPDFException(`Missing PDF "${path}".`);
                                this._storedError = error;
                                this._headersCapability.reject(error);
                                return;
                            }
                            this._contentLength = stat.size;
                            this._setReadableStream(fs.createReadStream(path));
                            this._headersCapability.resolve();
                        });
                    }
                }
                class PDFNodeStreamFsRangeReader extends BaseRangeReader {
                    constructor(stream, start, end){
                        super(stream);
                        let path = decodeURIComponent(this._url.path);
                        if (fileUriRegex.test(this._url.href)) path = path.replace(/^\//, "");
                        const fs = (parcelRequire("7NlT1"));
                        this._setReadableStream(fs.createReadStream(path, {
                            start: start,
                            end: end - 1
                        }));
                    }
                }
            /***/ },
            /* 24 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.SVGGraphics = void 0;
                var _display_utils = __w_pdfjs_require__(6);
                var _util = __w_pdfjs_require__(1);
                const SVG_DEFAULTS = {
                    fontStyle: "normal",
                    fontWeight: "normal",
                    fillColor: "#000000"
                };
                const XML_NS = "http://www.w3.org/XML/1998/namespace";
                const XLINK_NS = "http://www.w3.org/1999/xlink";
                const LINE_CAP_STYLES = [
                    "butt",
                    "round",
                    "square"
                ];
                const LINE_JOIN_STYLES = [
                    "miter",
                    "round",
                    "bevel"
                ];
                const createObjectURL = function(data, contentType = "", forceDataSchema = false) {
                    if (URL.createObjectURL && typeof Blob !== "undefined" && !forceDataSchema) return URL.createObjectURL(new Blob([
                        data
                    ], {
                        type: contentType
                    }));
                    const digits = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
                    let buffer = `data:${contentType};base64,`;
                    for(let i = 0, ii = data.length; i < ii; i += 3){
                        const b1 = data[i] & 0xff;
                        const b2 = data[i + 1] & 0xff;
                        const b3 = data[i + 2] & 0xff;
                        const d1 = b1 >> 2, d2 = (b1 & 3) << 4 | b2 >> 4;
                        const d3 = i + 1 < ii ? (b2 & 0xf) << 2 | b3 >> 6 : 64;
                        const d4 = i + 2 < ii ? b3 & 0x3f : 64;
                        buffer += digits[d1] + digits[d2] + digits[d3] + digits[d4];
                    }
                    return buffer;
                };
                const convertImgDataToPng = function() {
                    const PNG_HEADER = new Uint8Array([
                        0x89,
                        0x50,
                        0x4e,
                        0x47,
                        0x0d,
                        0x0a,
                        0x1a,
                        0x0a
                    ]);
                    const CHUNK_WRAPPER_SIZE = 12;
                    const crcTable = new Int32Array(256);
                    for(let i = 0; i < 256; i++){
                        let c = i;
                        for(let h = 0; h < 8; h++)c = c & 1 ? 0xedb88320 ^ c >> 1 & 0x7fffffff : c >> 1 & 0x7fffffff;
                        crcTable[i] = c;
                    }
                    function crc32(data, start, end) {
                        let crc = -1;
                        for(let i = start; i < end; i++){
                            const a = (crc ^ data[i]) & 0xff;
                            const b = crcTable[a];
                            crc = crc >>> 8 ^ b;
                        }
                        return crc ^ -1;
                    }
                    function writePngChunk(type, body, data, offset) {
                        let p = offset;
                        const len = body.length;
                        data[p] = len >> 24 & 0xff;
                        data[p + 1] = len >> 16 & 0xff;
                        data[p + 2] = len >> 8 & 0xff;
                        data[p + 3] = len & 0xff;
                        p += 4;
                        data[p] = type.charCodeAt(0) & 0xff;
                        data[p + 1] = type.charCodeAt(1) & 0xff;
                        data[p + 2] = type.charCodeAt(2) & 0xff;
                        data[p + 3] = type.charCodeAt(3) & 0xff;
                        p += 4;
                        data.set(body, p);
                        p += body.length;
                        const crc = crc32(data, offset + 4, p);
                        data[p] = crc >> 24 & 0xff;
                        data[p + 1] = crc >> 16 & 0xff;
                        data[p + 2] = crc >> 8 & 0xff;
                        data[p + 3] = crc & 0xff;
                    }
                    function adler32(data, start, end) {
                        let a = 1;
                        let b = 0;
                        for(let i = start; i < end; ++i){
                            a = (a + (data[i] & 0xff)) % 65521;
                            b = (b + a) % 65521;
                        }
                        return b << 16 | a;
                    }
                    function deflateSync(literals) {
                        if (!_util.isNodeJS) return deflateSyncUncompressed(literals);
                        try {
                            const input = parseInt($ec262.versions.node) >= 8 ? literals : $4675fba6b4f309a4$require$Buffer.from(literals);
                            const output = (parcelRequire("7NlT1")).deflateSync(input, {
                                level: 9
                            });
                            return output instanceof Uint8Array ? output : new Uint8Array(output);
                        } catch (e) {
                            (0, _util.warn)("Not compressing PNG because zlib.deflateSync is unavailable: " + e);
                        }
                        return deflateSyncUncompressed(literals);
                    }
                    function deflateSyncUncompressed(literals) {
                        let len = literals.length;
                        const maxBlockLength = 0xffff;
                        const deflateBlocks = Math.ceil(len / maxBlockLength);
                        const idat = new Uint8Array(2 + len + deflateBlocks * 5 + 4);
                        let pi = 0;
                        idat[pi++] = 0x78;
                        idat[pi++] = 0x9c;
                        let pos = 0;
                        while(len > maxBlockLength){
                            idat[pi++] = 0x00;
                            idat[pi++] = 0xff;
                            idat[pi++] = 0xff;
                            idat[pi++] = 0x00;
                            idat[pi++] = 0x00;
                            idat.set(literals.subarray(pos, pos + maxBlockLength), pi);
                            pi += maxBlockLength;
                            pos += maxBlockLength;
                            len -= maxBlockLength;
                        }
                        idat[pi++] = 0x01;
                        idat[pi++] = len & 0xff;
                        idat[pi++] = len >> 8 & 0xff;
                        idat[pi++] = ~len & 255;
                        idat[pi++] = (~len & 0xffff) >> 8 & 0xff;
                        idat.set(literals.subarray(pos), pi);
                        pi += literals.length - pos;
                        const adler = adler32(literals, 0, literals.length);
                        idat[pi++] = adler >> 24 & 0xff;
                        idat[pi++] = adler >> 16 & 0xff;
                        idat[pi++] = adler >> 8 & 0xff;
                        idat[pi++] = adler & 0xff;
                        return idat;
                    }
                    function encode(imgData, kind, forceDataSchema, isMask) {
                        const width = imgData.width;
                        const height = imgData.height;
                        let bitDepth, colorType, lineSize;
                        const bytes = imgData.data;
                        switch(kind){
                            case _util.ImageKind.GRAYSCALE_1BPP:
                                colorType = 0;
                                bitDepth = 1;
                                lineSize = width + 7 >> 3;
                                break;
                            case _util.ImageKind.RGB_24BPP:
                                colorType = 2;
                                bitDepth = 8;
                                lineSize = width * 3;
                                break;
                            case _util.ImageKind.RGBA_32BPP:
                                colorType = 6;
                                bitDepth = 8;
                                lineSize = width * 4;
                                break;
                            default:
                                throw new Error("invalid format");
                        }
                        const literals = new Uint8Array((1 + lineSize) * height);
                        let offsetLiterals = 0, offsetBytes = 0;
                        for(let y = 0; y < height; ++y){
                            literals[offsetLiterals++] = 0;
                            literals.set(bytes.subarray(offsetBytes, offsetBytes + lineSize), offsetLiterals);
                            offsetBytes += lineSize;
                            offsetLiterals += lineSize;
                        }
                        if (kind === _util.ImageKind.GRAYSCALE_1BPP && isMask) {
                            offsetLiterals = 0;
                            for(let y = 0; y < height; y++){
                                offsetLiterals++;
                                for(let i = 0; i < lineSize; i++)literals[offsetLiterals++] ^= 0xff;
                            }
                        }
                        const ihdr = new Uint8Array([
                            width >> 24 & 0xff,
                            width >> 16 & 0xff,
                            width >> 8 & 0xff,
                            width & 0xff,
                            height >> 24 & 0xff,
                            height >> 16 & 0xff,
                            height >> 8 & 0xff,
                            height & 0xff,
                            bitDepth,
                            colorType,
                            0x00,
                            0x00,
                            0x00
                        ]);
                        const idat = deflateSync(literals);
                        const pngLength = PNG_HEADER.length + CHUNK_WRAPPER_SIZE * 3 + ihdr.length + idat.length;
                        const data = new Uint8Array(pngLength);
                        let offset = 0;
                        data.set(PNG_HEADER, offset);
                        offset += PNG_HEADER.length;
                        writePngChunk("IHDR", ihdr, data, offset);
                        offset += CHUNK_WRAPPER_SIZE + ihdr.length;
                        writePngChunk("IDATA", idat, data, offset);
                        offset += CHUNK_WRAPPER_SIZE + idat.length;
                        writePngChunk("IEND", new Uint8Array(0), data, offset);
                        return createObjectURL(data, "image/png", forceDataSchema);
                    }
                    return function convertImgDataToPng(imgData, forceDataSchema, isMask) {
                        const kind = imgData.kind === undefined ? _util.ImageKind.GRAYSCALE_1BPP : imgData.kind;
                        return encode(imgData, kind, forceDataSchema, isMask);
                    };
                }();
                class SVGExtraState {
                    constructor(){
                        this.fontSizeScale = 1;
                        this.fontWeight = SVG_DEFAULTS.fontWeight;
                        this.fontSize = 0;
                        this.textMatrix = _util.IDENTITY_MATRIX;
                        this.fontMatrix = _util.FONT_IDENTITY_MATRIX;
                        this.leading = 0;
                        this.textRenderingMode = _util.TextRenderingMode.FILL;
                        this.textMatrixScale = 1;
                        this.x = 0;
                        this.y = 0;
                        this.lineX = 0;
                        this.lineY = 0;
                        this.charSpacing = 0;
                        this.wordSpacing = 0;
                        this.textHScale = 1;
                        this.textRise = 0;
                        this.fillColor = SVG_DEFAULTS.fillColor;
                        this.strokeColor = "#000000";
                        this.fillAlpha = 1;
                        this.strokeAlpha = 1;
                        this.lineWidth = 1;
                        this.lineJoin = "";
                        this.lineCap = "";
                        this.miterLimit = 0;
                        this.dashArray = [];
                        this.dashPhase = 0;
                        this.dependencies = [];
                        this.activeClipUrl = null;
                        this.clipGroup = null;
                        this.maskId = "";
                    }
                    clone() {
                        return Object.create(this);
                    }
                    setCurrentPoint(x, y) {
                        this.x = x;
                        this.y = y;
                    }
                }
                function opListToTree(opList) {
                    let opTree = [];
                    const tmp = [];
                    for (const opListElement of opList){
                        if (opListElement.fn === "save") {
                            opTree.push({
                                fnId: 92,
                                fn: "group",
                                items: []
                            });
                            tmp.push(opTree);
                            opTree = opTree.at(-1).items;
                            continue;
                        }
                        if (opListElement.fn === "restore") opTree = tmp.pop();
                        else opTree.push(opListElement);
                    }
                    return opTree;
                }
                function pf(value) {
                    if (Number.isInteger(value)) return value.toString();
                    const s = value.toFixed(10);
                    let i = s.length - 1;
                    if (s[i] !== "0") return s;
                    do i--;
                    while (s[i] === "0");
                    return s.substring(0, s[i] === "." ? i : i + 1);
                }
                function pm(m) {
                    if (m[4] === 0 && m[5] === 0) {
                        if (m[1] === 0 && m[2] === 0) {
                            if (m[0] === 1 && m[3] === 1) return "";
                            return `scale(${pf(m[0])} ${pf(m[3])})`;
                        }
                        if (m[0] === m[3] && m[1] === -m[2]) {
                            const a = Math.acos(m[0]) * 180 / Math.PI;
                            return `rotate(${pf(a)})`;
                        }
                    } else if (m[0] === 1 && m[1] === 0 && m[2] === 0 && m[3] === 1) return `translate(${pf(m[4])} ${pf(m[5])})`;
                    return `matrix(${pf(m[0])} ${pf(m[1])} ${pf(m[2])} ${pf(m[3])} ${pf(m[4])} ` + `${pf(m[5])})`;
                }
                let clipCount = 0;
                let maskCount = 0;
                let shadingCount = 0;
                class SVGGraphics {
                    constructor(commonObjs, objs, forceDataSchema = false){
                        (0, _display_utils.deprecated)("The SVG back-end is no longer maintained and *may* be removed in the future.");
                        this.svgFactory = new _display_utils.DOMSVGFactory();
                        this.current = new SVGExtraState();
                        this.transformMatrix = _util.IDENTITY_MATRIX;
                        this.transformStack = [];
                        this.extraStack = [];
                        this.commonObjs = commonObjs;
                        this.objs = objs;
                        this.pendingClip = null;
                        this.pendingEOFill = false;
                        this.embedFonts = false;
                        this.embeddedFonts = Object.create(null);
                        this.cssStyle = null;
                        this.forceDataSchema = !!forceDataSchema;
                        this._operatorIdMapping = [];
                        for(const op in _util.OPS)this._operatorIdMapping[_util.OPS[op]] = op;
                    }
                    getObject(data, fallback = null) {
                        if (typeof data === "string") return data.startsWith("g_") ? this.commonObjs.get(data) : this.objs.get(data);
                        return fallback;
                    }
                    save() {
                        this.transformStack.push(this.transformMatrix);
                        const old = this.current;
                        this.extraStack.push(old);
                        this.current = old.clone();
                    }
                    restore() {
                        this.transformMatrix = this.transformStack.pop();
                        this.current = this.extraStack.pop();
                        this.pendingClip = null;
                        this.tgrp = null;
                    }
                    group(items) {
                        this.save();
                        this.executeOpTree(items);
                        this.restore();
                    }
                    loadDependencies(operatorList) {
                        const fnArray = operatorList.fnArray;
                        const argsArray = operatorList.argsArray;
                        for(let i = 0, ii = fnArray.length; i < ii; i++){
                            if (fnArray[i] !== _util.OPS.dependency) continue;
                            for (const obj of argsArray[i]){
                                const objsPool = obj.startsWith("g_") ? this.commonObjs : this.objs;
                                const promise = new Promise((resolve)=>{
                                    objsPool.get(obj, resolve);
                                });
                                this.current.dependencies.push(promise);
                            }
                        }
                        return Promise.all(this.current.dependencies);
                    }
                    transform(a, b, c, d, e, f) {
                        const transformMatrix = [
                            a,
                            b,
                            c,
                            d,
                            e,
                            f
                        ];
                        this.transformMatrix = _util.Util.transform(this.transformMatrix, transformMatrix);
                        this.tgrp = null;
                    }
                    getSVG(operatorList, viewport) {
                        this.viewport = viewport;
                        const svgElement = this._initialize(viewport);
                        return this.loadDependencies(operatorList).then(()=>{
                            this.transformMatrix = _util.IDENTITY_MATRIX;
                            this.executeOpTree(this.convertOpList(operatorList));
                            return svgElement;
                        });
                    }
                    convertOpList(operatorList) {
                        const operatorIdMapping = this._operatorIdMapping;
                        const argsArray = operatorList.argsArray;
                        const fnArray = operatorList.fnArray;
                        const opList = [];
                        for(let i = 0, ii = fnArray.length; i < ii; i++){
                            const fnId = fnArray[i];
                            opList.push({
                                fnId: fnId,
                                fn: operatorIdMapping[fnId],
                                args: argsArray[i]
                            });
                        }
                        return opListToTree(opList);
                    }
                    executeOpTree(opTree) {
                        for (const opTreeElement of opTree){
                            const fn = opTreeElement.fn;
                            const fnId = opTreeElement.fnId;
                            const args = opTreeElement.args;
                            switch(fnId | 0){
                                case _util.OPS.beginText:
                                    this.beginText();
                                    break;
                                case _util.OPS.dependency:
                                    break;
                                case _util.OPS.setLeading:
                                    this.setLeading(args);
                                    break;
                                case _util.OPS.setLeadingMoveText:
                                    this.setLeadingMoveText(args[0], args[1]);
                                    break;
                                case _util.OPS.setFont:
                                    this.setFont(args);
                                    break;
                                case _util.OPS.showText:
                                    this.showText(args[0]);
                                    break;
                                case _util.OPS.showSpacedText:
                                    this.showText(args[0]);
                                    break;
                                case _util.OPS.endText:
                                    this.endText();
                                    break;
                                case _util.OPS.moveText:
                                    this.moveText(args[0], args[1]);
                                    break;
                                case _util.OPS.setCharSpacing:
                                    this.setCharSpacing(args[0]);
                                    break;
                                case _util.OPS.setWordSpacing:
                                    this.setWordSpacing(args[0]);
                                    break;
                                case _util.OPS.setHScale:
                                    this.setHScale(args[0]);
                                    break;
                                case _util.OPS.setTextMatrix:
                                    this.setTextMatrix(args[0], args[1], args[2], args[3], args[4], args[5]);
                                    break;
                                case _util.OPS.setTextRise:
                                    this.setTextRise(args[0]);
                                    break;
                                case _util.OPS.setTextRenderingMode:
                                    this.setTextRenderingMode(args[0]);
                                    break;
                                case _util.OPS.setLineWidth:
                                    this.setLineWidth(args[0]);
                                    break;
                                case _util.OPS.setLineJoin:
                                    this.setLineJoin(args[0]);
                                    break;
                                case _util.OPS.setLineCap:
                                    this.setLineCap(args[0]);
                                    break;
                                case _util.OPS.setMiterLimit:
                                    this.setMiterLimit(args[0]);
                                    break;
                                case _util.OPS.setFillRGBColor:
                                    this.setFillRGBColor(args[0], args[1], args[2]);
                                    break;
                                case _util.OPS.setStrokeRGBColor:
                                    this.setStrokeRGBColor(args[0], args[1], args[2]);
                                    break;
                                case _util.OPS.setStrokeColorN:
                                    this.setStrokeColorN(args);
                                    break;
                                case _util.OPS.setFillColorN:
                                    this.setFillColorN(args);
                                    break;
                                case _util.OPS.shadingFill:
                                    this.shadingFill(args[0]);
                                    break;
                                case _util.OPS.setDash:
                                    this.setDash(args[0], args[1]);
                                    break;
                                case _util.OPS.setRenderingIntent:
                                    this.setRenderingIntent(args[0]);
                                    break;
                                case _util.OPS.setFlatness:
                                    this.setFlatness(args[0]);
                                    break;
                                case _util.OPS.setGState:
                                    this.setGState(args[0]);
                                    break;
                                case _util.OPS.fill:
                                    this.fill();
                                    break;
                                case _util.OPS.eoFill:
                                    this.eoFill();
                                    break;
                                case _util.OPS.stroke:
                                    this.stroke();
                                    break;
                                case _util.OPS.fillStroke:
                                    this.fillStroke();
                                    break;
                                case _util.OPS.eoFillStroke:
                                    this.eoFillStroke();
                                    break;
                                case _util.OPS.clip:
                                    this.clip("nonzero");
                                    break;
                                case _util.OPS.eoClip:
                                    this.clip("evenodd");
                                    break;
                                case _util.OPS.paintSolidColorImageMask:
                                    this.paintSolidColorImageMask();
                                    break;
                                case _util.OPS.paintImageXObject:
                                    this.paintImageXObject(args[0]);
                                    break;
                                case _util.OPS.paintInlineImageXObject:
                                    this.paintInlineImageXObject(args[0]);
                                    break;
                                case _util.OPS.paintImageMaskXObject:
                                    this.paintImageMaskXObject(args[0]);
                                    break;
                                case _util.OPS.paintFormXObjectBegin:
                                    this.paintFormXObjectBegin(args[0], args[1]);
                                    break;
                                case _util.OPS.paintFormXObjectEnd:
                                    this.paintFormXObjectEnd();
                                    break;
                                case _util.OPS.closePath:
                                    this.closePath();
                                    break;
                                case _util.OPS.closeStroke:
                                    this.closeStroke();
                                    break;
                                case _util.OPS.closeFillStroke:
                                    this.closeFillStroke();
                                    break;
                                case _util.OPS.closeEOFillStroke:
                                    this.closeEOFillStroke();
                                    break;
                                case _util.OPS.nextLine:
                                    this.nextLine();
                                    break;
                                case _util.OPS.transform:
                                    this.transform(args[0], args[1], args[2], args[3], args[4], args[5]);
                                    break;
                                case _util.OPS.constructPath:
                                    this.constructPath(args[0], args[1]);
                                    break;
                                case _util.OPS.endPath:
                                    this.endPath();
                                    break;
                                case 92:
                                    this.group(opTreeElement.items);
                                    break;
                                default:
                                    (0, _util.warn)(`Unimplemented operator ${fn}`);
                                    break;
                            }
                        }
                    }
                    setWordSpacing(wordSpacing) {
                        this.current.wordSpacing = wordSpacing;
                    }
                    setCharSpacing(charSpacing) {
                        this.current.charSpacing = charSpacing;
                    }
                    nextLine() {
                        this.moveText(0, this.current.leading);
                    }
                    setTextMatrix(a, b, c, d, e, f) {
                        const current = this.current;
                        current.textMatrix = current.lineMatrix = [
                            a,
                            b,
                            c,
                            d,
                            e,
                            f
                        ];
                        current.textMatrixScale = Math.hypot(a, b);
                        current.x = current.lineX = 0;
                        current.y = current.lineY = 0;
                        current.xcoords = [];
                        current.ycoords = [];
                        current.tspan = this.svgFactory.createElement("svg:tspan");
                        current.tspan.setAttributeNS(null, "font-family", current.fontFamily);
                        current.tspan.setAttributeNS(null, "font-size", `${pf(current.fontSize)}px`);
                        current.tspan.setAttributeNS(null, "y", pf(-current.y));
                        current.txtElement = this.svgFactory.createElement("svg:text");
                        current.txtElement.append(current.tspan);
                    }
                    beginText() {
                        const current = this.current;
                        current.x = current.lineX = 0;
                        current.y = current.lineY = 0;
                        current.textMatrix = _util.IDENTITY_MATRIX;
                        current.lineMatrix = _util.IDENTITY_MATRIX;
                        current.textMatrixScale = 1;
                        current.tspan = this.svgFactory.createElement("svg:tspan");
                        current.txtElement = this.svgFactory.createElement("svg:text");
                        current.txtgrp = this.svgFactory.createElement("svg:g");
                        current.xcoords = [];
                        current.ycoords = [];
                    }
                    moveText(x, y) {
                        const current = this.current;
                        current.x = current.lineX += x;
                        current.y = current.lineY += y;
                        current.xcoords = [];
                        current.ycoords = [];
                        current.tspan = this.svgFactory.createElement("svg:tspan");
                        current.tspan.setAttributeNS(null, "font-family", current.fontFamily);
                        current.tspan.setAttributeNS(null, "font-size", `${pf(current.fontSize)}px`);
                        current.tspan.setAttributeNS(null, "y", pf(-current.y));
                    }
                    showText(glyphs) {
                        const current = this.current;
                        const font = current.font;
                        const fontSize = current.fontSize;
                        if (fontSize === 0) return;
                        const fontSizeScale = current.fontSizeScale;
                        const charSpacing = current.charSpacing;
                        const wordSpacing = current.wordSpacing;
                        const fontDirection = current.fontDirection;
                        const textHScale = current.textHScale * fontDirection;
                        const vertical = font.vertical;
                        const spacingDir = vertical ? 1 : -1;
                        const defaultVMetrics = font.defaultVMetrics;
                        const widthAdvanceScale = fontSize * current.fontMatrix[0];
                        let x = 0;
                        for (const glyph of glyphs){
                            if (glyph === null) {
                                x += fontDirection * wordSpacing;
                                continue;
                            } else if (typeof glyph === "number") {
                                x += spacingDir * glyph * fontSize / 1000;
                                continue;
                            }
                            const spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing;
                            const character = glyph.fontChar;
                            let scaledX, scaledY;
                            let width = glyph.width;
                            if (vertical) {
                                let vx;
                                const vmetric = glyph.vmetric || defaultVMetrics;
                                vx = glyph.vmetric ? vmetric[1] : width * 0.5;
                                vx = -vx * widthAdvanceScale;
                                const vy = vmetric[2] * widthAdvanceScale;
                                width = vmetric ? -vmetric[0] : width;
                                scaledX = vx / fontSizeScale;
                                scaledY = (x + vy) / fontSizeScale;
                            } else {
                                scaledX = x / fontSizeScale;
                                scaledY = 0;
                            }
                            if (glyph.isInFont || font.missingFile) {
                                current.xcoords.push(current.x + scaledX);
                                if (vertical) current.ycoords.push(-current.y + scaledY);
                                current.tspan.textContent += character;
                            }
                            const charWidth = vertical ? width * widthAdvanceScale - spacing * fontDirection : width * widthAdvanceScale + spacing * fontDirection;
                            x += charWidth;
                        }
                        current.tspan.setAttributeNS(null, "x", current.xcoords.map(pf).join(" "));
                        if (vertical) current.tspan.setAttributeNS(null, "y", current.ycoords.map(pf).join(" "));
                        else current.tspan.setAttributeNS(null, "y", pf(-current.y));
                        if (vertical) current.y -= x;
                        else current.x += x * textHScale;
                        current.tspan.setAttributeNS(null, "font-family", current.fontFamily);
                        current.tspan.setAttributeNS(null, "font-size", `${pf(current.fontSize)}px`);
                        if (current.fontStyle !== SVG_DEFAULTS.fontStyle) current.tspan.setAttributeNS(null, "font-style", current.fontStyle);
                        if (current.fontWeight !== SVG_DEFAULTS.fontWeight) current.tspan.setAttributeNS(null, "font-weight", current.fontWeight);
                        const fillStrokeMode = current.textRenderingMode & _util.TextRenderingMode.FILL_STROKE_MASK;
                        if (fillStrokeMode === _util.TextRenderingMode.FILL || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
                            if (current.fillColor !== SVG_DEFAULTS.fillColor) current.tspan.setAttributeNS(null, "fill", current.fillColor);
                            if (current.fillAlpha < 1) current.tspan.setAttributeNS(null, "fill-opacity", current.fillAlpha);
                        } else if (current.textRenderingMode === _util.TextRenderingMode.ADD_TO_PATH) current.tspan.setAttributeNS(null, "fill", "transparent");
                        else current.tspan.setAttributeNS(null, "fill", "none");
                        if (fillStrokeMode === _util.TextRenderingMode.STROKE || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
                            const lineWidthScale = 1 / (current.textMatrixScale || 1);
                            this._setStrokeAttributes(current.tspan, lineWidthScale);
                        }
                        let textMatrix = current.textMatrix;
                        if (current.textRise !== 0) {
                            textMatrix = textMatrix.slice();
                            textMatrix[5] += current.textRise;
                        }
                        current.txtElement.setAttributeNS(null, "transform", `${pm(textMatrix)} scale(${pf(textHScale)}, -1)`);
                        current.txtElement.setAttributeNS(XML_NS, "xml:space", "preserve");
                        current.txtElement.append(current.tspan);
                        current.txtgrp.append(current.txtElement);
                        this._ensureTransformGroup().append(current.txtElement);
                    }
                    setLeadingMoveText(x, y) {
                        this.setLeading(-y);
                        this.moveText(x, y);
                    }
                    addFontStyle(fontObj) {
                        if (!fontObj.data) throw new Error('addFontStyle: No font data available, ensure that the "fontExtraProperties" API parameter is set.');
                        if (!this.cssStyle) {
                            this.cssStyle = this.svgFactory.createElement("svg:style");
                            this.cssStyle.setAttributeNS(null, "type", "text/css");
                            this.defs.append(this.cssStyle);
                        }
                        const url = createObjectURL(fontObj.data, fontObj.mimetype, this.forceDataSchema);
                        this.cssStyle.textContent += `@font-face { font-family: "${fontObj.loadedName}";` + ` src: url(${url}); }\n`;
                    }
                    setFont(details) {
                        const current = this.current;
                        const fontObj = this.commonObjs.get(details[0]);
                        let size = details[1];
                        current.font = fontObj;
                        if (this.embedFonts && !fontObj.missingFile && !this.embeddedFonts[fontObj.loadedName]) {
                            this.addFontStyle(fontObj);
                            this.embeddedFonts[fontObj.loadedName] = fontObj;
                        }
                        current.fontMatrix = fontObj.fontMatrix || _util.FONT_IDENTITY_MATRIX;
                        let bold = "normal";
                        if (fontObj.black) bold = "900";
                        else if (fontObj.bold) bold = "bold";
                        const italic = fontObj.italic ? "italic" : "normal";
                        if (size < 0) {
                            size = -size;
                            current.fontDirection = -1;
                        } else current.fontDirection = 1;
                        current.fontSize = size;
                        current.fontFamily = fontObj.loadedName;
                        current.fontWeight = bold;
                        current.fontStyle = italic;
                        current.tspan = this.svgFactory.createElement("svg:tspan");
                        current.tspan.setAttributeNS(null, "y", pf(-current.y));
                        current.xcoords = [];
                        current.ycoords = [];
                    }
                    endText() {
                        const current = this.current;
                        if (current.textRenderingMode & _util.TextRenderingMode.ADD_TO_PATH_FLAG && current.txtElement?.hasChildNodes()) {
                            current.element = current.txtElement;
                            this.clip("nonzero");
                            this.endPath();
                        }
                    }
                    setLineWidth(width) {
                        if (width > 0) this.current.lineWidth = width;
                    }
                    setLineCap(style) {
                        this.current.lineCap = LINE_CAP_STYLES[style];
                    }
                    setLineJoin(style) {
                        this.current.lineJoin = LINE_JOIN_STYLES[style];
                    }
                    setMiterLimit(limit) {
                        this.current.miterLimit = limit;
                    }
                    setStrokeAlpha(strokeAlpha) {
                        this.current.strokeAlpha = strokeAlpha;
                    }
                    setStrokeRGBColor(r, g, b) {
                        this.current.strokeColor = _util.Util.makeHexColor(r, g, b);
                    }
                    setFillAlpha(fillAlpha) {
                        this.current.fillAlpha = fillAlpha;
                    }
                    setFillRGBColor(r, g, b) {
                        this.current.fillColor = _util.Util.makeHexColor(r, g, b);
                        this.current.tspan = this.svgFactory.createElement("svg:tspan");
                        this.current.xcoords = [];
                        this.current.ycoords = [];
                    }
                    setStrokeColorN(args) {
                        this.current.strokeColor = this._makeColorN_Pattern(args);
                    }
                    setFillColorN(args) {
                        this.current.fillColor = this._makeColorN_Pattern(args);
                    }
                    shadingFill(args) {
                        const { width, height } = this.viewport;
                        const inv = _util.Util.inverseTransform(this.transformMatrix);
                        const [x0, y0, x1, y1] = _util.Util.getAxialAlignedBoundingBox([
                            0,
                            0,
                            width,
                            height
                        ], inv);
                        const rect = this.svgFactory.createElement("svg:rect");
                        rect.setAttributeNS(null, "x", x0);
                        rect.setAttributeNS(null, "y", y0);
                        rect.setAttributeNS(null, "width", x1 - x0);
                        rect.setAttributeNS(null, "height", y1 - y0);
                        rect.setAttributeNS(null, "fill", this._makeShadingPattern(args));
                        if (this.current.fillAlpha < 1) rect.setAttributeNS(null, "fill-opacity", this.current.fillAlpha);
                        this._ensureTransformGroup().append(rect);
                    }
                    _makeColorN_Pattern(args) {
                        if (args[0] === "TilingPattern") return this._makeTilingPattern(args);
                        return this._makeShadingPattern(args);
                    }
                    _makeTilingPattern(args) {
                        const color = args[1];
                        const operatorList = args[2];
                        const matrix = args[3] || _util.IDENTITY_MATRIX;
                        const [x0, y0, x1, y1] = args[4];
                        const xstep = args[5];
                        const ystep = args[6];
                        const paintType = args[7];
                        const tilingId = `shading${shadingCount++}`;
                        const [tx0, ty0, tx1, ty1] = _util.Util.normalizeRect([
                            ..._util.Util.applyTransform([
                                x0,
                                y0
                            ], matrix),
                            ..._util.Util.applyTransform([
                                x1,
                                y1
                            ], matrix)
                        ]);
                        const [xscale, yscale] = _util.Util.singularValueDecompose2dScale(matrix);
                        const txstep = xstep * xscale;
                        const tystep = ystep * yscale;
                        const tiling = this.svgFactory.createElement("svg:pattern");
                        tiling.setAttributeNS(null, "id", tilingId);
                        tiling.setAttributeNS(null, "patternUnits", "userSpaceOnUse");
                        tiling.setAttributeNS(null, "width", txstep);
                        tiling.setAttributeNS(null, "height", tystep);
                        tiling.setAttributeNS(null, "x", `${tx0}`);
                        tiling.setAttributeNS(null, "y", `${ty0}`);
                        const svg = this.svg;
                        const transformMatrix = this.transformMatrix;
                        const fillColor = this.current.fillColor;
                        const strokeColor = this.current.strokeColor;
                        const bbox = this.svgFactory.create(tx1 - tx0, ty1 - ty0);
                        this.svg = bbox;
                        this.transformMatrix = matrix;
                        if (paintType === 2) {
                            const cssColor = _util.Util.makeHexColor(...color);
                            this.current.fillColor = cssColor;
                            this.current.strokeColor = cssColor;
                        }
                        this.executeOpTree(this.convertOpList(operatorList));
                        this.svg = svg;
                        this.transformMatrix = transformMatrix;
                        this.current.fillColor = fillColor;
                        this.current.strokeColor = strokeColor;
                        tiling.append(bbox.childNodes[0]);
                        this.defs.append(tiling);
                        return `url(#${tilingId})`;
                    }
                    _makeShadingPattern(args) {
                        if (typeof args === "string") args = this.objs.get(args);
                        switch(args[0]){
                            case "RadialAxial":
                                const shadingId = `shading${shadingCount++}`;
                                const colorStops = args[3];
                                let gradient;
                                switch(args[1]){
                                    case "axial":
                                        const point0 = args[4];
                                        const point1 = args[5];
                                        gradient = this.svgFactory.createElement("svg:linearGradient");
                                        gradient.setAttributeNS(null, "id", shadingId);
                                        gradient.setAttributeNS(null, "gradientUnits", "userSpaceOnUse");
                                        gradient.setAttributeNS(null, "x1", point0[0]);
                                        gradient.setAttributeNS(null, "y1", point0[1]);
                                        gradient.setAttributeNS(null, "x2", point1[0]);
                                        gradient.setAttributeNS(null, "y2", point1[1]);
                                        break;
                                    case "radial":
                                        const focalPoint = args[4];
                                        const circlePoint = args[5];
                                        const focalRadius = args[6];
                                        const circleRadius = args[7];
                                        gradient = this.svgFactory.createElement("svg:radialGradient");
                                        gradient.setAttributeNS(null, "id", shadingId);
                                        gradient.setAttributeNS(null, "gradientUnits", "userSpaceOnUse");
                                        gradient.setAttributeNS(null, "cx", circlePoint[0]);
                                        gradient.setAttributeNS(null, "cy", circlePoint[1]);
                                        gradient.setAttributeNS(null, "r", circleRadius);
                                        gradient.setAttributeNS(null, "fx", focalPoint[0]);
                                        gradient.setAttributeNS(null, "fy", focalPoint[1]);
                                        gradient.setAttributeNS(null, "fr", focalRadius);
                                        break;
                                    default:
                                        throw new Error(`Unknown RadialAxial type: ${args[1]}`);
                                }
                                for (const colorStop of colorStops){
                                    const stop = this.svgFactory.createElement("svg:stop");
                                    stop.setAttributeNS(null, "offset", colorStop[0]);
                                    stop.setAttributeNS(null, "stop-color", colorStop[1]);
                                    gradient.append(stop);
                                }
                                this.defs.append(gradient);
                                return `url(#${shadingId})`;
                            case "Mesh":
                                (0, _util.warn)("Unimplemented pattern Mesh");
                                return null;
                            case "Dummy":
                                return "hotpink";
                            default:
                                throw new Error(`Unknown IR type: ${args[0]}`);
                        }
                    }
                    setDash(dashArray, dashPhase) {
                        this.current.dashArray = dashArray;
                        this.current.dashPhase = dashPhase;
                    }
                    constructPath(ops, args) {
                        const current = this.current;
                        let x = current.x, y = current.y;
                        let d = [];
                        let j = 0;
                        for (const op of ops)switch(op | 0){
                            case _util.OPS.rectangle:
                                x = args[j++];
                                y = args[j++];
                                const width = args[j++];
                                const height = args[j++];
                                const xw = x + width;
                                const yh = y + height;
                                d.push("M", pf(x), pf(y), "L", pf(xw), pf(y), "L", pf(xw), pf(yh), "L", pf(x), pf(yh), "Z");
                                break;
                            case _util.OPS.moveTo:
                                x = args[j++];
                                y = args[j++];
                                d.push("M", pf(x), pf(y));
                                break;
                            case _util.OPS.lineTo:
                                x = args[j++];
                                y = args[j++];
                                d.push("L", pf(x), pf(y));
                                break;
                            case _util.OPS.curveTo:
                                x = args[j + 4];
                                y = args[j + 5];
                                d.push("C", pf(args[j]), pf(args[j + 1]), pf(args[j + 2]), pf(args[j + 3]), pf(x), pf(y));
                                j += 6;
                                break;
                            case _util.OPS.curveTo2:
                                d.push("C", pf(x), pf(y), pf(args[j]), pf(args[j + 1]), pf(args[j + 2]), pf(args[j + 3]));
                                x = args[j + 2];
                                y = args[j + 3];
                                j += 4;
                                break;
                            case _util.OPS.curveTo3:
                                x = args[j + 2];
                                y = args[j + 3];
                                d.push("C", pf(args[j]), pf(args[j + 1]), pf(x), pf(y), pf(x), pf(y));
                                j += 4;
                                break;
                            case _util.OPS.closePath:
                                d.push("Z");
                                break;
                        }
                        d = d.join(" ");
                        if (current.path && ops.length > 0 && ops[0] !== _util.OPS.rectangle && ops[0] !== _util.OPS.moveTo) d = current.path.getAttributeNS(null, "d") + d;
                        else {
                            current.path = this.svgFactory.createElement("svg:path");
                            this._ensureTransformGroup().append(current.path);
                        }
                        current.path.setAttributeNS(null, "d", d);
                        current.path.setAttributeNS(null, "fill", "none");
                        current.element = current.path;
                        current.setCurrentPoint(x, y);
                    }
                    endPath() {
                        const current = this.current;
                        current.path = null;
                        if (!this.pendingClip) return;
                        if (!current.element) {
                            this.pendingClip = null;
                            return;
                        }
                        const clipId = `clippath${clipCount++}`;
                        const clipPath = this.svgFactory.createElement("svg:clipPath");
                        clipPath.setAttributeNS(null, "id", clipId);
                        clipPath.setAttributeNS(null, "transform", pm(this.transformMatrix));
                        const clipElement = current.element.cloneNode(true);
                        if (this.pendingClip === "evenodd") clipElement.setAttributeNS(null, "clip-rule", "evenodd");
                        else clipElement.setAttributeNS(null, "clip-rule", "nonzero");
                        this.pendingClip = null;
                        clipPath.append(clipElement);
                        this.defs.append(clipPath);
                        if (current.activeClipUrl) {
                            current.clipGroup = null;
                            for (const prev of this.extraStack)prev.clipGroup = null;
                            clipPath.setAttributeNS(null, "clip-path", current.activeClipUrl);
                        }
                        current.activeClipUrl = `url(#${clipId})`;
                        this.tgrp = null;
                    }
                    clip(type) {
                        this.pendingClip = type;
                    }
                    closePath() {
                        const current = this.current;
                        if (current.path) {
                            const d = `${current.path.getAttributeNS(null, "d")}Z`;
                            current.path.setAttributeNS(null, "d", d);
                        }
                    }
                    setLeading(leading) {
                        this.current.leading = -leading;
                    }
                    setTextRise(textRise) {
                        this.current.textRise = textRise;
                    }
                    setTextRenderingMode(textRenderingMode) {
                        this.current.textRenderingMode = textRenderingMode;
                    }
                    setHScale(scale) {
                        this.current.textHScale = scale / 100;
                    }
                    setRenderingIntent(intent) {}
                    setFlatness(flatness) {}
                    setGState(states) {
                        for (const [key, value] of states)switch(key){
                            case "LW":
                                this.setLineWidth(value);
                                break;
                            case "LC":
                                this.setLineCap(value);
                                break;
                            case "LJ":
                                this.setLineJoin(value);
                                break;
                            case "ML":
                                this.setMiterLimit(value);
                                break;
                            case "D":
                                this.setDash(value[0], value[1]);
                                break;
                            case "RI":
                                this.setRenderingIntent(value);
                                break;
                            case "FL":
                                this.setFlatness(value);
                                break;
                            case "Font":
                                this.setFont(value);
                                break;
                            case "CA":
                                this.setStrokeAlpha(value);
                                break;
                            case "ca":
                                this.setFillAlpha(value);
                                break;
                            default:
                                (0, _util.warn)(`Unimplemented graphic state operator ${key}`);
                                break;
                        }
                    }
                    fill() {
                        const current = this.current;
                        if (current.element) {
                            current.element.setAttributeNS(null, "fill", current.fillColor);
                            current.element.setAttributeNS(null, "fill-opacity", current.fillAlpha);
                            this.endPath();
                        }
                    }
                    stroke() {
                        const current = this.current;
                        if (current.element) {
                            this._setStrokeAttributes(current.element);
                            current.element.setAttributeNS(null, "fill", "none");
                            this.endPath();
                        }
                    }
                    _setStrokeAttributes(element, lineWidthScale = 1) {
                        const current = this.current;
                        let dashArray = current.dashArray;
                        if (lineWidthScale !== 1 && dashArray.length > 0) dashArray = dashArray.map(function(value) {
                            return lineWidthScale * value;
                        });
                        element.setAttributeNS(null, "stroke", current.strokeColor);
                        element.setAttributeNS(null, "stroke-opacity", current.strokeAlpha);
                        element.setAttributeNS(null, "stroke-miterlimit", pf(current.miterLimit));
                        element.setAttributeNS(null, "stroke-linecap", current.lineCap);
                        element.setAttributeNS(null, "stroke-linejoin", current.lineJoin);
                        element.setAttributeNS(null, "stroke-width", pf(lineWidthScale * current.lineWidth) + "px");
                        element.setAttributeNS(null, "stroke-dasharray", dashArray.map(pf).join(" "));
                        element.setAttributeNS(null, "stroke-dashoffset", pf(lineWidthScale * current.dashPhase) + "px");
                    }
                    eoFill() {
                        this.current.element?.setAttributeNS(null, "fill-rule", "evenodd");
                        this.fill();
                    }
                    fillStroke() {
                        this.stroke();
                        this.fill();
                    }
                    eoFillStroke() {
                        this.current.element?.setAttributeNS(null, "fill-rule", "evenodd");
                        this.fillStroke();
                    }
                    closeStroke() {
                        this.closePath();
                        this.stroke();
                    }
                    closeFillStroke() {
                        this.closePath();
                        this.fillStroke();
                    }
                    closeEOFillStroke() {
                        this.closePath();
                        this.eoFillStroke();
                    }
                    paintSolidColorImageMask() {
                        const rect = this.svgFactory.createElement("svg:rect");
                        rect.setAttributeNS(null, "x", "0");
                        rect.setAttributeNS(null, "y", "0");
                        rect.setAttributeNS(null, "width", "1px");
                        rect.setAttributeNS(null, "height", "1px");
                        rect.setAttributeNS(null, "fill", this.current.fillColor);
                        this._ensureTransformGroup().append(rect);
                    }
                    paintImageXObject(objId) {
                        const imgData = this.getObject(objId);
                        if (!imgData) {
                            (0, _util.warn)(`Dependent image with object ID ${objId} is not ready yet`);
                            return;
                        }
                        this.paintInlineImageXObject(imgData);
                    }
                    paintInlineImageXObject(imgData, mask) {
                        const width = imgData.width;
                        const height = imgData.height;
                        const imgSrc = convertImgDataToPng(imgData, this.forceDataSchema, !!mask);
                        const cliprect = this.svgFactory.createElement("svg:rect");
                        cliprect.setAttributeNS(null, "x", "0");
                        cliprect.setAttributeNS(null, "y", "0");
                        cliprect.setAttributeNS(null, "width", pf(width));
                        cliprect.setAttributeNS(null, "height", pf(height));
                        this.current.element = cliprect;
                        this.clip("nonzero");
                        const imgEl = this.svgFactory.createElement("svg:image");
                        imgEl.setAttributeNS(XLINK_NS, "xlink:href", imgSrc);
                        imgEl.setAttributeNS(null, "x", "0");
                        imgEl.setAttributeNS(null, "y", pf(-height));
                        imgEl.setAttributeNS(null, "width", pf(width) + "px");
                        imgEl.setAttributeNS(null, "height", pf(height) + "px");
                        imgEl.setAttributeNS(null, "transform", `scale(${pf(1 / width)} ${pf(-1 / height)})`);
                        if (mask) mask.append(imgEl);
                        else this._ensureTransformGroup().append(imgEl);
                    }
                    paintImageMaskXObject(img) {
                        const imgData = this.getObject(img.data, img);
                        if (imgData.bitmap) {
                            (0, _util.warn)("paintImageMaskXObject: ImageBitmap support is not implemented, ensure that the `isOffscreenCanvasSupported` API parameter is disabled.");
                            return;
                        }
                        const current = this.current;
                        const width = imgData.width;
                        const height = imgData.height;
                        const fillColor = current.fillColor;
                        current.maskId = `mask${maskCount++}`;
                        const mask = this.svgFactory.createElement("svg:mask");
                        mask.setAttributeNS(null, "id", current.maskId);
                        const rect = this.svgFactory.createElement("svg:rect");
                        rect.setAttributeNS(null, "x", "0");
                        rect.setAttributeNS(null, "y", "0");
                        rect.setAttributeNS(null, "width", pf(width));
                        rect.setAttributeNS(null, "height", pf(height));
                        rect.setAttributeNS(null, "fill", fillColor);
                        rect.setAttributeNS(null, "mask", `url(#${current.maskId})`);
                        this.defs.append(mask);
                        this._ensureTransformGroup().append(rect);
                        this.paintInlineImageXObject(imgData, mask);
                    }
                    paintFormXObjectBegin(matrix, bbox) {
                        if (Array.isArray(matrix) && matrix.length === 6) this.transform(matrix[0], matrix[1], matrix[2], matrix[3], matrix[4], matrix[5]);
                        if (bbox) {
                            const width = bbox[2] - bbox[0];
                            const height = bbox[3] - bbox[1];
                            const cliprect = this.svgFactory.createElement("svg:rect");
                            cliprect.setAttributeNS(null, "x", bbox[0]);
                            cliprect.setAttributeNS(null, "y", bbox[1]);
                            cliprect.setAttributeNS(null, "width", pf(width));
                            cliprect.setAttributeNS(null, "height", pf(height));
                            this.current.element = cliprect;
                            this.clip("nonzero");
                            this.endPath();
                        }
                    }
                    paintFormXObjectEnd() {}
                    _initialize(viewport) {
                        const svg = this.svgFactory.create(viewport.width, viewport.height);
                        const definitions = this.svgFactory.createElement("svg:defs");
                        svg.append(definitions);
                        this.defs = definitions;
                        const rootGroup = this.svgFactory.createElement("svg:g");
                        rootGroup.setAttributeNS(null, "transform", pm(viewport.transform));
                        svg.append(rootGroup);
                        this.svg = rootGroup;
                        return svg;
                    }
                    _ensureClipGroup() {
                        if (!this.current.clipGroup) {
                            const clipGroup = this.svgFactory.createElement("svg:g");
                            clipGroup.setAttributeNS(null, "clip-path", this.current.activeClipUrl);
                            this.svg.append(clipGroup);
                            this.current.clipGroup = clipGroup;
                        }
                        return this.current.clipGroup;
                    }
                    _ensureTransformGroup() {
                        if (!this.tgrp) {
                            this.tgrp = this.svgFactory.createElement("svg:g");
                            this.tgrp.setAttributeNS(null, "transform", pm(this.transformMatrix));
                            if (this.current.activeClipUrl) this._ensureClipGroup().append(this.tgrp);
                            else this.svg.append(this.tgrp);
                        }
                        return this.tgrp;
                    }
                }
                exports.SVGGraphics = SVGGraphics;
            /***/ },
            /* 25 */ /***/ (__unused_webpack_module, exports)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.XfaText = void 0;
                class XfaText {
                    static textContent(xfa) {
                        const items = [];
                        const output = {
                            items: items,
                            styles: Object.create(null)
                        };
                        function walk(node) {
                            if (!node) return;
                            let str = null;
                            const name = node.name;
                            if (name === "#text") str = node.value;
                            else if (!XfaText.shouldBuildText(name)) return;
                            else if (node?.attributes?.textContent) str = node.attributes.textContent;
                            else if (node.value) str = node.value;
                            if (str !== null) items.push({
                                str: str
                            });
                            if (!node.children) return;
                            for (const child of node.children)walk(child);
                        }
                        walk(xfa);
                        return output;
                    }
                    static shouldBuildText(name) {
                        return !(name === "textarea" || name === "input" || name === "option" || name === "select");
                    }
                }
                exports.XfaText = XfaText;
            /***/ },
            /* 26 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.TextLayerRenderTask = void 0;
                exports.renderTextLayer = renderTextLayer;
                exports.updateTextLayer = updateTextLayer;
                var _util = __w_pdfjs_require__(1);
                var _display_utils = __w_pdfjs_require__(6);
                const MAX_TEXT_DIVS_TO_RENDER = 100000;
                const DEFAULT_FONT_SIZE = 30;
                const DEFAULT_FONT_ASCENT = 0.8;
                const ascentCache = new Map();
                function getCtx(size, isOffscreenCanvasSupported) {
                    let ctx;
                    if (isOffscreenCanvasSupported && _util.FeatureTest.isOffscreenCanvasSupported) ctx = new OffscreenCanvas(size, size).getContext("2d", {
                        alpha: false
                    });
                    else {
                        const canvas = document.createElement("canvas");
                        canvas.width = canvas.height = size;
                        ctx = canvas.getContext("2d", {
                            alpha: false
                        });
                    }
                    return ctx;
                }
                function getAscent(fontFamily, isOffscreenCanvasSupported) {
                    const cachedAscent = ascentCache.get(fontFamily);
                    if (cachedAscent) return cachedAscent;
                    const ctx = getCtx(DEFAULT_FONT_SIZE, isOffscreenCanvasSupported);
                    ctx.font = `${DEFAULT_FONT_SIZE}px ${fontFamily}`;
                    const metrics = ctx.measureText("");
                    let ascent = metrics.fontBoundingBoxAscent;
                    let descent = Math.abs(metrics.fontBoundingBoxDescent);
                    if (ascent) {
                        const ratio = ascent / (ascent + descent);
                        ascentCache.set(fontFamily, ratio);
                        ctx.canvas.width = ctx.canvas.height = 0;
                        return ratio;
                    }
                    ctx.strokeStyle = "red";
                    ctx.clearRect(0, 0, DEFAULT_FONT_SIZE, DEFAULT_FONT_SIZE);
                    ctx.strokeText("g", 0, 0);
                    let pixels = ctx.getImageData(0, 0, DEFAULT_FONT_SIZE, DEFAULT_FONT_SIZE).data;
                    descent = 0;
                    for(let i = pixels.length - 1 - 3; i >= 0; i -= 4)if (pixels[i] > 0) {
                        descent = Math.ceil(i / 4 / DEFAULT_FONT_SIZE);
                        break;
                    }
                    ctx.clearRect(0, 0, DEFAULT_FONT_SIZE, DEFAULT_FONT_SIZE);
                    ctx.strokeText("A", 0, DEFAULT_FONT_SIZE);
                    pixels = ctx.getImageData(0, 0, DEFAULT_FONT_SIZE, DEFAULT_FONT_SIZE).data;
                    ascent = 0;
                    for(let i = 0, ii = pixels.length; i < ii; i += 4)if (pixels[i] > 0) {
                        ascent = DEFAULT_FONT_SIZE - Math.floor(i / 4 / DEFAULT_FONT_SIZE);
                        break;
                    }
                    ctx.canvas.width = ctx.canvas.height = 0;
                    if (ascent) {
                        const ratio = ascent / (ascent + descent);
                        ascentCache.set(fontFamily, ratio);
                        return ratio;
                    }
                    ascentCache.set(fontFamily, DEFAULT_FONT_ASCENT);
                    return DEFAULT_FONT_ASCENT;
                }
                function appendText(task, geom, styles) {
                    const textDiv = document.createElement("span");
                    const textDivProperties = {
                        angle: 0,
                        canvasWidth: 0,
                        hasText: geom.str !== "",
                        hasEOL: geom.hasEOL,
                        fontSize: 0
                    };
                    task._textDivs.push(textDiv);
                    const tx = _util.Util.transform(task._transform, geom.transform);
                    let angle = Math.atan2(tx[1], tx[0]);
                    const style = styles[geom.fontName];
                    if (style.vertical) angle += Math.PI / 2;
                    const fontHeight = Math.hypot(tx[2], tx[3]);
                    const fontAscent = fontHeight * getAscent(style.fontFamily, task._isOffscreenCanvasSupported);
                    let left, top;
                    if (angle === 0) {
                        left = tx[4];
                        top = tx[5] - fontAscent;
                    } else {
                        left = tx[4] + fontAscent * Math.sin(angle);
                        top = tx[5] - fontAscent * Math.cos(angle);
                    }
                    const scaleFactorStr = "calc(var(--scale-factor)*";
                    const divStyle = textDiv.style;
                    if (task._container === task._rootContainer) {
                        divStyle.left = `${(100 * left / task._pageWidth).toFixed(2)}%`;
                        divStyle.top = `${(100 * top / task._pageHeight).toFixed(2)}%`;
                    } else {
                        divStyle.left = `${scaleFactorStr}${left.toFixed(2)}px)`;
                        divStyle.top = `${scaleFactorStr}${top.toFixed(2)}px)`;
                    }
                    divStyle.fontSize = `${scaleFactorStr}${fontHeight.toFixed(2)}px)`;
                    divStyle.fontFamily = style.fontFamily;
                    textDivProperties.fontSize = fontHeight;
                    textDiv.setAttribute("role", "presentation");
                    textDiv.textContent = geom.str;
                    textDiv.dir = geom.dir;
                    if (task._fontInspectorEnabled) textDiv.dataset.fontName = geom.fontName;
                    if (angle !== 0) textDivProperties.angle = angle * (180 / Math.PI);
                    let shouldScaleText = false;
                    if (geom.str.length > 1) shouldScaleText = true;
                    else if (geom.str !== " " && geom.transform[0] !== geom.transform[3]) {
                        const absScaleX = Math.abs(geom.transform[0]), absScaleY = Math.abs(geom.transform[3]);
                        if (absScaleX !== absScaleY && Math.max(absScaleX, absScaleY) / Math.min(absScaleX, absScaleY) > 1.5) shouldScaleText = true;
                    }
                    if (shouldScaleText) textDivProperties.canvasWidth = style.vertical ? geom.height : geom.width;
                    task._textDivProperties.set(textDiv, textDivProperties);
                    if (task._isReadableStream) task._layoutText(textDiv);
                }
                function layout(params) {
                    const { div, scale, properties, ctx, prevFontSize, prevFontFamily } = params;
                    const { style } = div;
                    let transform = "";
                    if (properties.canvasWidth !== 0 && properties.hasText) {
                        const { fontFamily } = style;
                        const { canvasWidth, fontSize } = properties;
                        if (prevFontSize !== fontSize || prevFontFamily !== fontFamily) {
                            ctx.font = `${fontSize * scale}px ${fontFamily}`;
                            params.prevFontSize = fontSize;
                            params.prevFontFamily = fontFamily;
                        }
                        const { width } = ctx.measureText(div.textContent);
                        if (width > 0) transform = `scaleX(${canvasWidth * scale / width})`;
                    }
                    if (properties.angle !== 0) transform = `rotate(${properties.angle}deg) ${transform}`;
                    if (transform.length > 0) style.transform = transform;
                }
                function render(task) {
                    if (task._canceled) return;
                    const textDivs = task._textDivs;
                    const capability = task._capability;
                    const textDivsLength = textDivs.length;
                    if (textDivsLength > MAX_TEXT_DIVS_TO_RENDER) {
                        capability.resolve();
                        return;
                    }
                    if (!task._isReadableStream) for (const textDiv of textDivs)task._layoutText(textDiv);
                    capability.resolve();
                }
                class TextLayerRenderTask {
                    constructor({ textContentSource, container, viewport, textDivs, textDivProperties, textContentItemsStr, isOffscreenCanvasSupported }){
                        this._textContentSource = textContentSource;
                        this._isReadableStream = textContentSource instanceof ReadableStream;
                        this._container = this._rootContainer = container;
                        this._textDivs = textDivs || [];
                        this._textContentItemsStr = textContentItemsStr || [];
                        this._isOffscreenCanvasSupported = isOffscreenCanvasSupported;
                        this._fontInspectorEnabled = !!globalThis.FontInspector?.enabled;
                        this._reader = null;
                        this._textDivProperties = textDivProperties || new WeakMap();
                        this._canceled = false;
                        this._capability = new _util.PromiseCapability();
                        this._layoutTextParams = {
                            prevFontSize: null,
                            prevFontFamily: null,
                            div: null,
                            scale: viewport.scale * (globalThis.devicePixelRatio || 1),
                            properties: null,
                            ctx: getCtx(0, isOffscreenCanvasSupported)
                        };
                        const { pageWidth, pageHeight, pageX, pageY } = viewport.rawDims;
                        this._transform = [
                            1,
                            0,
                            0,
                            -1,
                            -pageX,
                            pageY + pageHeight
                        ];
                        this._pageWidth = pageWidth;
                        this._pageHeight = pageHeight;
                        (0, _display_utils.setLayerDimensions)(container, viewport);
                        this._capability.promise.finally(()=>{
                            this._layoutTextParams = null;
                        }).catch(()=>{});
                    }
                    get promise() {
                        return this._capability.promise;
                    }
                    cancel() {
                        this._canceled = true;
                        if (this._reader) {
                            this._reader.cancel(new _util.AbortException("TextLayer task cancelled.")).catch(()=>{});
                            this._reader = null;
                        }
                        this._capability.reject(new _util.AbortException("TextLayer task cancelled."));
                    }
                    _processItems(items, styleCache) {
                        for (const item of items){
                            if (item.str === undefined) {
                                if (item.type === "beginMarkedContentProps" || item.type === "beginMarkedContent") {
                                    const parent = this._container;
                                    this._container = document.createElement("span");
                                    this._container.classList.add("markedContent");
                                    if (item.id !== null) this._container.setAttribute("id", `${item.id}`);
                                    parent.append(this._container);
                                } else if (item.type === "endMarkedContent") this._container = this._container.parentNode;
                                continue;
                            }
                            this._textContentItemsStr.push(item.str);
                            appendText(this, item, styleCache);
                        }
                    }
                    _layoutText(textDiv) {
                        const textDivProperties = this._layoutTextParams.properties = this._textDivProperties.get(textDiv);
                        this._layoutTextParams.div = textDiv;
                        layout(this._layoutTextParams);
                        if (textDivProperties.hasText) this._container.append(textDiv);
                        if (textDivProperties.hasEOL) {
                            const br = document.createElement("br");
                            br.setAttribute("role", "presentation");
                            this._container.append(br);
                        }
                    }
                    _render() {
                        const capability = new _util.PromiseCapability();
                        let styleCache = Object.create(null);
                        if (this._isReadableStream) {
                            const pump = ()=>{
                                this._reader.read().then(({ value, done })=>{
                                    if (done) {
                                        capability.resolve();
                                        return;
                                    }
                                    Object.assign(styleCache, value.styles);
                                    this._processItems(value.items, styleCache);
                                    pump();
                                }, capability.reject);
                            };
                            this._reader = this._textContentSource.getReader();
                            pump();
                        } else if (this._textContentSource) {
                            const { items, styles } = this._textContentSource;
                            this._processItems(items, styles);
                            capability.resolve();
                        } else throw new Error('No "textContentSource" parameter specified.');
                        capability.promise.then(()=>{
                            styleCache = null;
                            render(this);
                        }, this._capability.reject);
                    }
                }
                exports.TextLayerRenderTask = TextLayerRenderTask;
                function renderTextLayer(params) {
                    if (!params.textContentSource && (params.textContent || params.textContentStream)) {
                        (0, _display_utils.deprecated)("The TextLayerRender `textContent`/`textContentStream` parameters will be removed in the future, please use `textContentSource` instead.");
                        params.textContentSource = params.textContent || params.textContentStream;
                    }
                    const { container, viewport } = params;
                    const style = getComputedStyle(container);
                    const visibility = style.getPropertyValue("visibility");
                    const scaleFactor = parseFloat(style.getPropertyValue("--scale-factor"));
                    if (visibility === "visible" && (!scaleFactor || Math.abs(scaleFactor - viewport.scale) > 1e-5)) console.error("The `--scale-factor` CSS-variable must be set, to the same value as `viewport.scale`, either on the `container`-element itself or higher up in the DOM.");
                    const task = new TextLayerRenderTask(params);
                    task._render();
                    return task;
                }
                function updateTextLayer({ container, viewport, textDivs, textDivProperties, isOffscreenCanvasSupported, mustRotate = true, mustRescale = true }) {
                    if (mustRotate) (0, _display_utils.setLayerDimensions)(container, {
                        rotation: viewport.rotation
                    });
                    if (mustRescale) {
                        const ctx = getCtx(0, isOffscreenCanvasSupported);
                        const scale = viewport.scale * (globalThis.devicePixelRatio || 1);
                        const params = {
                            prevFontSize: null,
                            prevFontFamily: null,
                            div: null,
                            scale: scale,
                            properties: null,
                            ctx: ctx
                        };
                        for (const div of textDivs){
                            params.properties = textDivProperties.get(div);
                            params.div = div;
                            layout(params);
                        }
                    }
                }
            /***/ },
            /* 27 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.AnnotationEditorLayer = void 0;
                var _util = __w_pdfjs_require__(1);
                var _editor = __w_pdfjs_require__(4);
                var _freetext = __w_pdfjs_require__(28);
                var _ink = __w_pdfjs_require__(33);
                var _display_utils = __w_pdfjs_require__(6);
                var _stamp = __w_pdfjs_require__(34);
                class AnnotationEditorLayer {
                    #accessibilityManager;
                    #allowClick = false;
                    #annotationLayer = null;
                    #boundPointerup = this.pointerup.bind(this);
                    #boundPointerdown = this.pointerdown.bind(this);
                    #editors = new Map();
                    #hadPointerDown = false;
                    #isCleaningUp = false;
                    #isDisabling = false;
                    #uiManager;
                    static _initialized = false;
                    constructor({ uiManager, pageIndex, div, accessibilityManager, annotationLayer, viewport, l10n }){
                        const editorTypes = [
                            _freetext.FreeTextEditor,
                            _ink.InkEditor,
                            _stamp.StampEditor
                        ];
                        if (!AnnotationEditorLayer._initialized) {
                            AnnotationEditorLayer._initialized = true;
                            for (const editorType of editorTypes)editorType.initialize(l10n);
                        }
                        uiManager.registerEditorTypes(editorTypes);
                        this.#uiManager = uiManager;
                        this.pageIndex = pageIndex;
                        this.div = div;
                        this.#accessibilityManager = accessibilityManager;
                        this.#annotationLayer = annotationLayer;
                        this.viewport = viewport;
                        this.#uiManager.addLayer(this);
                    }
                    get isEmpty() {
                        return this.#editors.size === 0;
                    }
                    updateToolbar(mode) {
                        this.#uiManager.updateToolbar(mode);
                    }
                    updateMode(mode = this.#uiManager.getMode()) {
                        this.#cleanup();
                        if (mode === _util.AnnotationEditorType.INK) {
                            this.addInkEditorIfNeeded(false);
                            this.disableClick();
                        } else this.enableClick();
                        if (mode !== _util.AnnotationEditorType.NONE) {
                            this.div.classList.toggle("freeTextEditing", mode === _util.AnnotationEditorType.FREETEXT);
                            this.div.classList.toggle("inkEditing", mode === _util.AnnotationEditorType.INK);
                            this.div.classList.toggle("stampEditing", mode === _util.AnnotationEditorType.STAMP);
                            this.div.hidden = false;
                        }
                    }
                    addInkEditorIfNeeded(isCommitting) {
                        if (!isCommitting && this.#uiManager.getMode() !== _util.AnnotationEditorType.INK) return;
                        if (!isCommitting) {
                            for (const editor of this.#editors.values())if (editor.isEmpty()) {
                                editor.setInBackground();
                                return;
                            }
                        }
                        const editor = this.#createAndAddNewEditor({
                            offsetX: 0,
                            offsetY: 0
                        }, false);
                        editor.setInBackground();
                    }
                    setEditingState(isEditing) {
                        this.#uiManager.setEditingState(isEditing);
                    }
                    addCommands(params) {
                        this.#uiManager.addCommands(params);
                    }
                    enable() {
                        this.div.style.pointerEvents = "auto";
                        const annotationElementIds = new Set();
                        for (const editor of this.#editors.values()){
                            editor.enableEditing();
                            if (editor.annotationElementId) annotationElementIds.add(editor.annotationElementId);
                        }
                        if (!this.#annotationLayer) return;
                        const editables = this.#annotationLayer.getEditableAnnotations();
                        for (const editable of editables){
                            editable.hide();
                            if (this.#uiManager.isDeletedAnnotationElement(editable.data.id)) continue;
                            if (annotationElementIds.has(editable.data.id)) continue;
                            const editor = this.deserialize(editable);
                            if (!editor) continue;
                            this.addOrRebuild(editor);
                            editor.enableEditing();
                        }
                    }
                    disable() {
                        this.#isDisabling = true;
                        this.div.style.pointerEvents = "none";
                        const hiddenAnnotationIds = new Set();
                        for (const editor of this.#editors.values()){
                            editor.disableEditing();
                            if (!editor.annotationElementId || editor.serialize() !== null) {
                                hiddenAnnotationIds.add(editor.annotationElementId);
                                continue;
                            }
                            this.getEditableAnnotation(editor.annotationElementId)?.show();
                            editor.remove();
                        }
                        if (this.#annotationLayer) {
                            const editables = this.#annotationLayer.getEditableAnnotations();
                            for (const editable of editables){
                                const { id } = editable.data;
                                if (hiddenAnnotationIds.has(id) || this.#uiManager.isDeletedAnnotationElement(id)) continue;
                                editable.show();
                            }
                        }
                        this.#cleanup();
                        if (this.isEmpty) this.div.hidden = true;
                        this.#isDisabling = false;
                    }
                    getEditableAnnotation(id) {
                        return this.#annotationLayer?.getEditableAnnotation(id) || null;
                    }
                    setActiveEditor(editor) {
                        const currentActive = this.#uiManager.getActive();
                        if (currentActive === editor) return;
                        this.#uiManager.setActiveEditor(editor);
                    }
                    enableClick() {
                        this.div.addEventListener("pointerdown", this.#boundPointerdown);
                        this.div.addEventListener("pointerup", this.#boundPointerup);
                    }
                    disableClick() {
                        this.div.removeEventListener("pointerdown", this.#boundPointerdown);
                        this.div.removeEventListener("pointerup", this.#boundPointerup);
                    }
                    attach(editor) {
                        this.#editors.set(editor.id, editor);
                        const { annotationElementId } = editor;
                        if (annotationElementId && this.#uiManager.isDeletedAnnotationElement(annotationElementId)) this.#uiManager.removeDeletedAnnotationElement(editor);
                    }
                    detach(editor) {
                        this.#editors.delete(editor.id);
                        this.#accessibilityManager?.removePointerInTextLayer(editor.contentDiv);
                        if (!this.#isDisabling && editor.annotationElementId) this.#uiManager.addDeletedAnnotationElement(editor);
                    }
                    remove(editor) {
                        this.detach(editor);
                        this.#uiManager.removeEditor(editor);
                        if (editor.div.contains(document.activeElement)) setTimeout(()=>{
                            this.#uiManager.focusMainContainer();
                        }, 0);
                        editor.div.remove();
                        editor.isAttachedToDOM = false;
                        if (!this.#isCleaningUp) this.addInkEditorIfNeeded(false);
                    }
                    changeParent(editor) {
                        if (editor.parent === this) return;
                        if (editor.annotationElementId) {
                            this.#uiManager.addDeletedAnnotationElement(editor.annotationElementId);
                            _editor.AnnotationEditor.deleteAnnotationElement(editor);
                            editor.annotationElementId = null;
                        }
                        this.attach(editor);
                        editor.parent?.detach(editor);
                        editor.setParent(this);
                        if (editor.div && editor.isAttachedToDOM) {
                            editor.div.remove();
                            this.div.append(editor.div);
                        }
                    }
                    add(editor) {
                        this.changeParent(editor);
                        this.#uiManager.addEditor(editor);
                        this.attach(editor);
                        if (!editor.isAttachedToDOM) {
                            const div = editor.render();
                            this.div.append(div);
                            editor.isAttachedToDOM = true;
                        }
                        editor.fixAndSetPosition();
                        editor.onceAdded();
                        this.#uiManager.addToAnnotationStorage(editor);
                    }
                    moveEditorInDOM(editor) {
                        if (!editor.isAttachedToDOM) return;
                        const { activeElement } = document;
                        if (editor.div.contains(activeElement)) {
                            editor._focusEventsAllowed = false;
                            setTimeout(()=>{
                                if (!editor.div.contains(document.activeElement)) {
                                    editor.div.addEventListener("focusin", ()=>{
                                        editor._focusEventsAllowed = true;
                                    }, {
                                        once: true
                                    });
                                    activeElement.focus();
                                } else editor._focusEventsAllowed = true;
                            }, 0);
                        }
                        editor._structTreeParentId = this.#accessibilityManager?.moveElementInDOM(this.div, editor.div, editor.contentDiv, true);
                    }
                    addOrRebuild(editor) {
                        if (editor.needsToBeRebuilt()) editor.rebuild();
                        else this.add(editor);
                    }
                    addUndoableEditor(editor) {
                        const cmd = ()=>editor._uiManager.rebuild(editor);
                        const undo = ()=>{
                            editor.remove();
                        };
                        this.addCommands({
                            cmd: cmd,
                            undo: undo,
                            mustExec: false
                        });
                    }
                    getNextId() {
                        return this.#uiManager.getId();
                    }
                    #createNewEditor(params) {
                        switch(this.#uiManager.getMode()){
                            case _util.AnnotationEditorType.FREETEXT:
                                return new _freetext.FreeTextEditor(params);
                            case _util.AnnotationEditorType.INK:
                                return new _ink.InkEditor(params);
                            case _util.AnnotationEditorType.STAMP:
                                return new _stamp.StampEditor(params);
                        }
                        return null;
                    }
                    pasteEditor(mode, params) {
                        this.#uiManager.updateToolbar(mode);
                        this.#uiManager.updateMode(mode);
                        const { offsetX, offsetY } = this.#getCenterPoint();
                        const id = this.getNextId();
                        const editor = this.#createNewEditor({
                            parent: this,
                            id: id,
                            x: offsetX,
                            y: offsetY,
                            uiManager: this.#uiManager,
                            isCentered: true,
                            ...params
                        });
                        if (editor) this.add(editor);
                    }
                    deserialize(data) {
                        switch(data.annotationType ?? data.annotationEditorType){
                            case _util.AnnotationEditorType.FREETEXT:
                                return _freetext.FreeTextEditor.deserialize(data, this, this.#uiManager);
                            case _util.AnnotationEditorType.INK:
                                return _ink.InkEditor.deserialize(data, this, this.#uiManager);
                            case _util.AnnotationEditorType.STAMP:
                                return _stamp.StampEditor.deserialize(data, this, this.#uiManager);
                        }
                        return null;
                    }
                    #createAndAddNewEditor(event, isCentered) {
                        const id = this.getNextId();
                        const editor = this.#createNewEditor({
                            parent: this,
                            id: id,
                            x: event.offsetX,
                            y: event.offsetY,
                            uiManager: this.#uiManager,
                            isCentered: isCentered
                        });
                        if (editor) this.add(editor);
                        return editor;
                    }
                    #getCenterPoint() {
                        const { x, y, width, height } = this.div.getBoundingClientRect();
                        const tlX = Math.max(0, x);
                        const tlY = Math.max(0, y);
                        const brX = Math.min(window.innerWidth, x + width);
                        const brY = Math.min(window.innerHeight, y + height);
                        const centerX = (tlX + brX) / 2 - x;
                        const centerY = (tlY + brY) / 2 - y;
                        const [offsetX, offsetY] = this.viewport.rotation % 180 === 0 ? [
                            centerX,
                            centerY
                        ] : [
                            centerY,
                            centerX
                        ];
                        return {
                            offsetX: offsetX,
                            offsetY: offsetY
                        };
                    }
                    addNewEditor() {
                        this.#createAndAddNewEditor(this.#getCenterPoint(), true);
                    }
                    setSelected(editor) {
                        this.#uiManager.setSelected(editor);
                    }
                    toggleSelected(editor) {
                        this.#uiManager.toggleSelected(editor);
                    }
                    isSelected(editor) {
                        return this.#uiManager.isSelected(editor);
                    }
                    unselect(editor) {
                        this.#uiManager.unselect(editor);
                    }
                    pointerup(event) {
                        const { isMac } = _util.FeatureTest.platform;
                        if (event.button !== 0 || event.ctrlKey && isMac) return;
                        if (event.target !== this.div) return;
                        if (!this.#hadPointerDown) return;
                        this.#hadPointerDown = false;
                        if (!this.#allowClick) {
                            this.#allowClick = true;
                            return;
                        }
                        if (this.#uiManager.getMode() === _util.AnnotationEditorType.STAMP) {
                            this.#uiManager.unselectAll();
                            return;
                        }
                        this.#createAndAddNewEditor(event, false);
                    }
                    pointerdown(event) {
                        if (this.#hadPointerDown) {
                            this.#hadPointerDown = false;
                            return;
                        }
                        const { isMac } = _util.FeatureTest.platform;
                        if (event.button !== 0 || event.ctrlKey && isMac) return;
                        if (event.target !== this.div) return;
                        this.#hadPointerDown = true;
                        const editor = this.#uiManager.getActive();
                        this.#allowClick = !editor || editor.isEmpty();
                    }
                    findNewParent(editor, x, y) {
                        const layer = this.#uiManager.findParent(x, y);
                        if (layer === null || layer === this) return false;
                        layer.changeParent(editor);
                        return true;
                    }
                    destroy() {
                        if (this.#uiManager.getActive()?.parent === this) {
                            this.#uiManager.commitOrRemove();
                            this.#uiManager.setActiveEditor(null);
                        }
                        for (const editor of this.#editors.values()){
                            this.#accessibilityManager?.removePointerInTextLayer(editor.contentDiv);
                            editor.setParent(null);
                            editor.isAttachedToDOM = false;
                            editor.div.remove();
                        }
                        this.div = null;
                        this.#editors.clear();
                        this.#uiManager.removeLayer(this);
                    }
                    #cleanup() {
                        this.#isCleaningUp = true;
                        for (const editor of this.#editors.values())if (editor.isEmpty()) editor.remove();
                        this.#isCleaningUp = false;
                    }
                    render({ viewport }) {
                        this.viewport = viewport;
                        (0, _display_utils.setLayerDimensions)(this.div, viewport);
                        for (const editor of this.#uiManager.getEditors(this.pageIndex))this.add(editor);
                        this.updateMode();
                    }
                    update({ viewport }) {
                        this.#uiManager.commitOrRemove();
                        this.viewport = viewport;
                        (0, _display_utils.setLayerDimensions)(this.div, {
                            rotation: viewport.rotation
                        });
                        this.updateMode();
                    }
                    get pageDimensions() {
                        const { pageWidth, pageHeight } = this.viewport.rawDims;
                        return [
                            pageWidth,
                            pageHeight
                        ];
                    }
                }
                exports.AnnotationEditorLayer = AnnotationEditorLayer;
            /***/ },
            /* 28 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.FreeTextEditor = void 0;
                var _util = __w_pdfjs_require__(1);
                var _tools = __w_pdfjs_require__(5);
                var _editor = __w_pdfjs_require__(4);
                var _annotation_layer = __w_pdfjs_require__(29);
                class FreeTextEditor extends _editor.AnnotationEditor {
                    #boundEditorDivBlur = this.editorDivBlur.bind(this);
                    #boundEditorDivFocus = this.editorDivFocus.bind(this);
                    #boundEditorDivInput = this.editorDivInput.bind(this);
                    #boundEditorDivKeydown = this.editorDivKeydown.bind(this);
                    #color;
                    #content = "";
                    #editorDivId = `${this.id}-editor`;
                    #fontSize;
                    #initialData = null;
                    static _freeTextDefaultContent = "";
                    static _internalPadding = 0;
                    static _defaultColor = null;
                    static _defaultFontSize = 10;
                    static get _keyboardManager() {
                        const proto = FreeTextEditor.prototype;
                        const arrowChecker = (self)=>self.isEmpty();
                        const small = _tools.AnnotationEditorUIManager.TRANSLATE_SMALL;
                        const big = _tools.AnnotationEditorUIManager.TRANSLATE_BIG;
                        return (0, _util.shadow)(this, "_keyboardManager", new _tools.KeyboardManager([
                            [
                                [
                                    "ctrl+s",
                                    "mac+meta+s",
                                    "ctrl+p",
                                    "mac+meta+p"
                                ],
                                proto.commitOrRemove,
                                {
                                    bubbles: true
                                }
                            ],
                            [
                                [
                                    "ctrl+Enter",
                                    "mac+meta+Enter",
                                    "Escape",
                                    "mac+Escape"
                                ],
                                proto.commitOrRemove
                            ],
                            [
                                [
                                    "ArrowLeft",
                                    "mac+ArrowLeft"
                                ],
                                proto._translateEmpty,
                                {
                                    args: [
                                        -small,
                                        0
                                    ],
                                    checker: arrowChecker
                                }
                            ],
                            [
                                [
                                    "ctrl+ArrowLeft",
                                    "mac+shift+ArrowLeft"
                                ],
                                proto._translateEmpty,
                                {
                                    args: [
                                        -big,
                                        0
                                    ],
                                    checker: arrowChecker
                                }
                            ],
                            [
                                [
                                    "ArrowRight",
                                    "mac+ArrowRight"
                                ],
                                proto._translateEmpty,
                                {
                                    args: [
                                        small,
                                        0
                                    ],
                                    checker: arrowChecker
                                }
                            ],
                            [
                                [
                                    "ctrl+ArrowRight",
                                    "mac+shift+ArrowRight"
                                ],
                                proto._translateEmpty,
                                {
                                    args: [
                                        big,
                                        0
                                    ],
                                    checker: arrowChecker
                                }
                            ],
                            [
                                [
                                    "ArrowUp",
                                    "mac+ArrowUp"
                                ],
                                proto._translateEmpty,
                                {
                                    args: [
                                        0,
                                        -small
                                    ],
                                    checker: arrowChecker
                                }
                            ],
                            [
                                [
                                    "ctrl+ArrowUp",
                                    "mac+shift+ArrowUp"
                                ],
                                proto._translateEmpty,
                                {
                                    args: [
                                        0,
                                        -big
                                    ],
                                    checker: arrowChecker
                                }
                            ],
                            [
                                [
                                    "ArrowDown",
                                    "mac+ArrowDown"
                                ],
                                proto._translateEmpty,
                                {
                                    args: [
                                        0,
                                        small
                                    ],
                                    checker: arrowChecker
                                }
                            ],
                            [
                                [
                                    "ctrl+ArrowDown",
                                    "mac+shift+ArrowDown"
                                ],
                                proto._translateEmpty,
                                {
                                    args: [
                                        0,
                                        big
                                    ],
                                    checker: arrowChecker
                                }
                            ]
                        ]));
                    }
                    static _type = "freetext";
                    constructor(params){
                        super({
                            ...params,
                            name: "freeTextEditor"
                        });
                        this.#color = params.color || FreeTextEditor._defaultColor || _editor.AnnotationEditor._defaultLineColor;
                        this.#fontSize = params.fontSize || FreeTextEditor._defaultFontSize;
                    }
                    static initialize(l10n) {
                        _editor.AnnotationEditor.initialize(l10n, {
                            strings: [
                                "free_text2_default_content",
                                "editor_free_text2_aria_label"
                            ]
                        });
                        const style = getComputedStyle(document.documentElement);
                        this._internalPadding = parseFloat(style.getPropertyValue("--freetext-padding"));
                    }
                    static updateDefaultParams(type, value) {
                        switch(type){
                            case _util.AnnotationEditorParamsType.FREETEXT_SIZE:
                                FreeTextEditor._defaultFontSize = value;
                                break;
                            case _util.AnnotationEditorParamsType.FREETEXT_COLOR:
                                FreeTextEditor._defaultColor = value;
                                break;
                        }
                    }
                    updateParams(type, value) {
                        switch(type){
                            case _util.AnnotationEditorParamsType.FREETEXT_SIZE:
                                this.#updateFontSize(value);
                                break;
                            case _util.AnnotationEditorParamsType.FREETEXT_COLOR:
                                this.#updateColor(value);
                                break;
                        }
                    }
                    static get defaultPropertiesToUpdate() {
                        return [
                            [
                                _util.AnnotationEditorParamsType.FREETEXT_SIZE,
                                FreeTextEditor._defaultFontSize
                            ],
                            [
                                _util.AnnotationEditorParamsType.FREETEXT_COLOR,
                                FreeTextEditor._defaultColor || _editor.AnnotationEditor._defaultLineColor
                            ]
                        ];
                    }
                    get propertiesToUpdate() {
                        return [
                            [
                                _util.AnnotationEditorParamsType.FREETEXT_SIZE,
                                this.#fontSize
                            ],
                            [
                                _util.AnnotationEditorParamsType.FREETEXT_COLOR,
                                this.#color
                            ]
                        ];
                    }
                    #updateFontSize(fontSize) {
                        const setFontsize = (size)=>{
                            this.editorDiv.style.fontSize = `calc(${size}px * var(--scale-factor))`;
                            this.translate(0, -(size - this.#fontSize) * this.parentScale);
                            this.#fontSize = size;
                            this.#setEditorDimensions();
                        };
                        const savedFontsize = this.#fontSize;
                        this.addCommands({
                            cmd: ()=>{
                                setFontsize(fontSize);
                            },
                            undo: ()=>{
                                setFontsize(savedFontsize);
                            },
                            mustExec: true,
                            type: _util.AnnotationEditorParamsType.FREETEXT_SIZE,
                            overwriteIfSameType: true,
                            keepUndo: true
                        });
                    }
                    #updateColor(color) {
                        const savedColor = this.#color;
                        this.addCommands({
                            cmd: ()=>{
                                this.#color = this.editorDiv.style.color = color;
                            },
                            undo: ()=>{
                                this.#color = this.editorDiv.style.color = savedColor;
                            },
                            mustExec: true,
                            type: _util.AnnotationEditorParamsType.FREETEXT_COLOR,
                            overwriteIfSameType: true,
                            keepUndo: true
                        });
                    }
                    _translateEmpty(x, y) {
                        this._uiManager.translateSelectedEditors(x, y, true);
                    }
                    getInitialTranslation() {
                        const scale = this.parentScale;
                        return [
                            -FreeTextEditor._internalPadding * scale,
                            -(FreeTextEditor._internalPadding + this.#fontSize) * scale
                        ];
                    }
                    rebuild() {
                        if (!this.parent) return;
                        super.rebuild();
                        if (this.div === null) return;
                        if (!this.isAttachedToDOM) this.parent.add(this);
                    }
                    enableEditMode() {
                        if (this.isInEditMode()) return;
                        this.parent.setEditingState(false);
                        this.parent.updateToolbar(_util.AnnotationEditorType.FREETEXT);
                        super.enableEditMode();
                        this.overlayDiv.classList.remove("enabled");
                        this.editorDiv.contentEditable = true;
                        this._isDraggable = false;
                        this.div.removeAttribute("aria-activedescendant");
                        this.editorDiv.addEventListener("keydown", this.#boundEditorDivKeydown);
                        this.editorDiv.addEventListener("focus", this.#boundEditorDivFocus);
                        this.editorDiv.addEventListener("blur", this.#boundEditorDivBlur);
                        this.editorDiv.addEventListener("input", this.#boundEditorDivInput);
                    }
                    disableEditMode() {
                        if (!this.isInEditMode()) return;
                        this.parent.setEditingState(true);
                        super.disableEditMode();
                        this.overlayDiv.classList.add("enabled");
                        this.editorDiv.contentEditable = false;
                        this.div.setAttribute("aria-activedescendant", this.#editorDivId);
                        this._isDraggable = true;
                        this.editorDiv.removeEventListener("keydown", this.#boundEditorDivKeydown);
                        this.editorDiv.removeEventListener("focus", this.#boundEditorDivFocus);
                        this.editorDiv.removeEventListener("blur", this.#boundEditorDivBlur);
                        this.editorDiv.removeEventListener("input", this.#boundEditorDivInput);
                        this.div.focus({
                            preventScroll: true
                        });
                        this.isEditing = false;
                        this.parent.div.classList.add("freeTextEditing");
                    }
                    focusin(event) {
                        if (!this._focusEventsAllowed) return;
                        super.focusin(event);
                        if (event.target !== this.editorDiv) this.editorDiv.focus();
                    }
                    onceAdded() {
                        if (this.width) {
                            this.#cheatInitialRect();
                            return;
                        }
                        this.enableEditMode();
                        this.editorDiv.focus();
                        if (this._initialOptions?.isCentered) this.center();
                        this._initialOptions = null;
                    }
                    isEmpty() {
                        return !this.editorDiv || this.editorDiv.innerText.trim() === "";
                    }
                    remove() {
                        this.isEditing = false;
                        if (this.parent) {
                            this.parent.setEditingState(true);
                            this.parent.div.classList.add("freeTextEditing");
                        }
                        super.remove();
                    }
                    #extractText() {
                        const divs = this.editorDiv.getElementsByTagName("div");
                        if (divs.length === 0) return this.editorDiv.innerText;
                        const buffer = [];
                        for (const div of divs)buffer.push(div.innerText.replace(/\r\n?|\n/, ""));
                        return buffer.join("\n");
                    }
                    #setEditorDimensions() {
                        const [parentWidth, parentHeight] = this.parentDimensions;
                        let rect;
                        if (this.isAttachedToDOM) rect = this.div.getBoundingClientRect();
                        else {
                            const { currentLayer, div } = this;
                            const savedDisplay = div.style.display;
                            div.style.display = "hidden";
                            currentLayer.div.append(this.div);
                            rect = div.getBoundingClientRect();
                            div.remove();
                            div.style.display = savedDisplay;
                        }
                        if (this.rotation % 180 === this.parentRotation % 180) {
                            this.width = rect.width / parentWidth;
                            this.height = rect.height / parentHeight;
                        } else {
                            this.width = rect.height / parentWidth;
                            this.height = rect.width / parentHeight;
                        }
                        this.fixAndSetPosition();
                    }
                    commit() {
                        if (!this.isInEditMode()) return;
                        super.commit();
                        this.disableEditMode();
                        const savedText = this.#content;
                        const newText = this.#content = this.#extractText().trimEnd();
                        if (savedText === newText) return;
                        const setText = (text)=>{
                            this.#content = text;
                            if (!text) {
                                this.remove();
                                return;
                            }
                            this.#setContent();
                            this._uiManager.rebuild(this);
                            this.#setEditorDimensions();
                        };
                        this.addCommands({
                            cmd: ()=>{
                                setText(newText);
                            },
                            undo: ()=>{
                                setText(savedText);
                            },
                            mustExec: false
                        });
                        this.#setEditorDimensions();
                    }
                    shouldGetKeyboardEvents() {
                        return this.isInEditMode();
                    }
                    enterInEditMode() {
                        this.enableEditMode();
                        this.editorDiv.focus();
                    }
                    dblclick(event) {
                        this.enterInEditMode();
                    }
                    keydown(event) {
                        if (event.target === this.div && event.key === "Enter") {
                            this.enterInEditMode();
                            event.preventDefault();
                        }
                    }
                    editorDivKeydown(event) {
                        FreeTextEditor._keyboardManager.exec(this, event);
                    }
                    editorDivFocus(event) {
                        this.isEditing = true;
                    }
                    editorDivBlur(event) {
                        this.isEditing = false;
                    }
                    editorDivInput(event) {
                        this.parent.div.classList.toggle("freeTextEditing", this.isEmpty());
                    }
                    disableEditing() {
                        this.editorDiv.setAttribute("role", "comment");
                        this.editorDiv.removeAttribute("aria-multiline");
                    }
                    enableEditing() {
                        this.editorDiv.setAttribute("role", "textbox");
                        this.editorDiv.setAttribute("aria-multiline", true);
                    }
                    render() {
                        if (this.div) return this.div;
                        let baseX, baseY;
                        if (this.width) {
                            baseX = this.x;
                            baseY = this.y;
                        }
                        super.render();
                        this.editorDiv = document.createElement("div");
                        this.editorDiv.className = "internal";
                        this.editorDiv.setAttribute("id", this.#editorDivId);
                        this.enableEditing();
                        _editor.AnnotationEditor._l10nPromise.get("editor_free_text2_aria_label").then((msg)=>this.editorDiv?.setAttribute("aria-label", msg));
                        _editor.AnnotationEditor._l10nPromise.get("free_text2_default_content").then((msg)=>this.editorDiv?.setAttribute("default-content", msg));
                        this.editorDiv.contentEditable = true;
                        const { style } = this.editorDiv;
                        style.fontSize = `calc(${this.#fontSize}px * var(--scale-factor))`;
                        style.color = this.#color;
                        this.div.append(this.editorDiv);
                        this.overlayDiv = document.createElement("div");
                        this.overlayDiv.classList.add("overlay", "enabled");
                        this.div.append(this.overlayDiv);
                        (0, _tools.bindEvents)(this, this.div, [
                            "dblclick",
                            "keydown"
                        ]);
                        if (this.width) {
                            const [parentWidth, parentHeight] = this.parentDimensions;
                            if (this.annotationElementId) {
                                const { position } = this.#initialData;
                                let [tx, ty] = this.getInitialTranslation();
                                [tx, ty] = this.pageTranslationToScreen(tx, ty);
                                const [pageWidth, pageHeight] = this.pageDimensions;
                                const [pageX, pageY] = this.pageTranslation;
                                let posX, posY;
                                switch(this.rotation){
                                    case 0:
                                        posX = baseX + (position[0] - pageX) / pageWidth;
                                        posY = baseY + this.height - (position[1] - pageY) / pageHeight;
                                        break;
                                    case 90:
                                        posX = baseX + (position[0] - pageX) / pageWidth;
                                        posY = baseY - (position[1] - pageY) / pageHeight;
                                        [tx, ty] = [
                                            ty,
                                            -tx
                                        ];
                                        break;
                                    case 180:
                                        posX = baseX - this.width + (position[0] - pageX) / pageWidth;
                                        posY = baseY - (position[1] - pageY) / pageHeight;
                                        [tx, ty] = [
                                            -tx,
                                            -ty
                                        ];
                                        break;
                                    case 270:
                                        posX = baseX + (position[0] - pageX - this.height * pageHeight) / pageWidth;
                                        posY = baseY + (position[1] - pageY - this.width * pageWidth) / pageHeight;
                                        [tx, ty] = [
                                            -ty,
                                            tx
                                        ];
                                        break;
                                }
                                this.setAt(posX * parentWidth, posY * parentHeight, tx, ty);
                            } else this.setAt(baseX * parentWidth, baseY * parentHeight, this.width * parentWidth, this.height * parentHeight);
                            this.#setContent();
                            this._isDraggable = true;
                            this.editorDiv.contentEditable = false;
                        } else {
                            this._isDraggable = false;
                            this.editorDiv.contentEditable = true;
                        }
                        return this.div;
                    }
                    #setContent() {
                        this.editorDiv.replaceChildren();
                        if (!this.#content) return;
                        for (const line of this.#content.split("\n")){
                            const div = document.createElement("div");
                            div.append(line ? document.createTextNode(line) : document.createElement("br"));
                            this.editorDiv.append(div);
                        }
                    }
                    get contentDiv() {
                        return this.editorDiv;
                    }
                    static deserialize(data, parent, uiManager) {
                        let initialData = null;
                        if (data instanceof _annotation_layer.FreeTextAnnotationElement) {
                            const { data: { defaultAppearanceData: { fontSize, fontColor }, rect, rotation, id }, textContent, textPosition, parent: { page: { pageNumber } } } = data;
                            if (!textContent || textContent.length === 0) return null;
                            initialData = data = {
                                annotationType: _util.AnnotationEditorType.FREETEXT,
                                color: Array.from(fontColor),
                                fontSize: fontSize,
                                value: textContent.join("\n"),
                                position: textPosition,
                                pageIndex: pageNumber - 1,
                                rect: rect,
                                rotation: rotation,
                                id: id,
                                deleted: false
                            };
                        }
                        const editor = super.deserialize(data, parent, uiManager);
                        editor.#fontSize = data.fontSize;
                        editor.#color = _util.Util.makeHexColor(...data.color);
                        editor.#content = data.value;
                        editor.annotationElementId = data.id || null;
                        editor.#initialData = initialData;
                        return editor;
                    }
                    serialize(isForCopying = false) {
                        if (this.isEmpty()) return null;
                        if (this.deleted) return {
                            pageIndex: this.pageIndex,
                            id: this.annotationElementId,
                            deleted: true
                        };
                        const padding = FreeTextEditor._internalPadding * this.parentScale;
                        const rect = this.getRect(padding, padding);
                        const color = _editor.AnnotationEditor._colorManager.convert(this.isAttachedToDOM ? getComputedStyle(this.editorDiv).color : this.#color);
                        const serialized = {
                            annotationType: _util.AnnotationEditorType.FREETEXT,
                            color: color,
                            fontSize: this.#fontSize,
                            value: this.#content,
                            pageIndex: this.pageIndex,
                            rect: rect,
                            rotation: this.rotation,
                            structTreeParentId: this._structTreeParentId
                        };
                        if (isForCopying) return serialized;
                        if (this.annotationElementId && !this.#hasElementChanged(serialized)) return null;
                        serialized.id = this.annotationElementId;
                        return serialized;
                    }
                    #hasElementChanged(serialized) {
                        const { value, fontSize, color, rect, pageIndex } = this.#initialData;
                        return serialized.value !== value || serialized.fontSize !== fontSize || serialized.rect.some((x, i)=>Math.abs(x - rect[i]) >= 1) || serialized.color.some((c, i)=>c !== color[i]) || serialized.pageIndex !== pageIndex;
                    }
                    #cheatInitialRect(delayed = false) {
                        if (!this.annotationElementId) return;
                        this.#setEditorDimensions();
                        if (!delayed && (this.width === 0 || this.height === 0)) {
                            setTimeout(()=>this.#cheatInitialRect(true), 0);
                            return;
                        }
                        const padding = FreeTextEditor._internalPadding * this.parentScale;
                        this.#initialData.rect = this.getRect(padding, padding);
                    }
                }
                exports.FreeTextEditor = FreeTextEditor;
            /***/ },
            /* 29 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.StampAnnotationElement = exports.InkAnnotationElement = exports.FreeTextAnnotationElement = exports.AnnotationLayer = void 0;
                var _util = __w_pdfjs_require__(1);
                var _display_utils = __w_pdfjs_require__(6);
                var _annotation_storage = __w_pdfjs_require__(3);
                var _scripting_utils = __w_pdfjs_require__(30);
                var _displayL10n_utils = __w_pdfjs_require__(31);
                var _xfa_layer = __w_pdfjs_require__(32);
                const DEFAULT_TAB_INDEX = 1000;
                const DEFAULT_FONT_SIZE = 9;
                const GetElementsByNameSet = new WeakSet();
                function getRectDims(rect) {
                    return {
                        width: rect[2] - rect[0],
                        height: rect[3] - rect[1]
                    };
                }
                class AnnotationElementFactory {
                    static create(parameters) {
                        const subtype = parameters.data.annotationType;
                        switch(subtype){
                            case _util.AnnotationType.LINK:
                                return new LinkAnnotationElement(parameters);
                            case _util.AnnotationType.TEXT:
                                return new TextAnnotationElement(parameters);
                            case _util.AnnotationType.WIDGET:
                                const fieldType = parameters.data.fieldType;
                                switch(fieldType){
                                    case "Tx":
                                        return new TextWidgetAnnotationElement(parameters);
                                    case "Btn":
                                        if (parameters.data.radioButton) return new RadioButtonWidgetAnnotationElement(parameters);
                                        else if (parameters.data.checkBox) return new CheckboxWidgetAnnotationElement(parameters);
                                        return new PushButtonWidgetAnnotationElement(parameters);
                                    case "Ch":
                                        return new ChoiceWidgetAnnotationElement(parameters);
                                    case "Sig":
                                        return new SignatureWidgetAnnotationElement(parameters);
                                }
                                return new WidgetAnnotationElement(parameters);
                            case _util.AnnotationType.POPUP:
                                return new PopupAnnotationElement(parameters);
                            case _util.AnnotationType.FREETEXT:
                                return new FreeTextAnnotationElement(parameters);
                            case _util.AnnotationType.LINE:
                                return new LineAnnotationElement(parameters);
                            case _util.AnnotationType.SQUARE:
                                return new SquareAnnotationElement(parameters);
                            case _util.AnnotationType.CIRCLE:
                                return new CircleAnnotationElement(parameters);
                            case _util.AnnotationType.POLYLINE:
                                return new PolylineAnnotationElement(parameters);
                            case _util.AnnotationType.CARET:
                                return new CaretAnnotationElement(parameters);
                            case _util.AnnotationType.INK:
                                return new InkAnnotationElement(parameters);
                            case _util.AnnotationType.POLYGON:
                                return new PolygonAnnotationElement(parameters);
                            case _util.AnnotationType.HIGHLIGHT:
                                return new HighlightAnnotationElement(parameters);
                            case _util.AnnotationType.UNDERLINE:
                                return new UnderlineAnnotationElement(parameters);
                            case _util.AnnotationType.SQUIGGLY:
                                return new SquigglyAnnotationElement(parameters);
                            case _util.AnnotationType.STRIKEOUT:
                                return new StrikeOutAnnotationElement(parameters);
                            case _util.AnnotationType.STAMP:
                                return new StampAnnotationElement(parameters);
                            case _util.AnnotationType.FILEATTACHMENT:
                                return new FileAttachmentAnnotationElement(parameters);
                            default:
                                return new AnnotationElement(parameters);
                        }
                    }
                }
                class AnnotationElement {
                    #hasBorder = false;
                    constructor(parameters, { isRenderable = false, ignoreBorder = false, createQuadrilaterals = false } = {}){
                        this.isRenderable = isRenderable;
                        this.data = parameters.data;
                        this.layer = parameters.layer;
                        this.linkService = parameters.linkService;
                        this.downloadManager = parameters.downloadManager;
                        this.imageResourcesPath = parameters.imageResourcesPath;
                        this.renderForms = parameters.renderForms;
                        this.svgFactory = parameters.svgFactory;
                        this.annotationStorage = parameters.annotationStorage;
                        this.enableScripting = parameters.enableScripting;
                        this.hasJSActions = parameters.hasJSActions;
                        this._fieldObjects = parameters.fieldObjects;
                        this.parent = parameters.parent;
                        if (isRenderable) this.container = this._createContainer(ignoreBorder);
                        if (createQuadrilaterals) this._createQuadrilaterals();
                    }
                    static _hasPopupData({ titleObj, contentsObj, richText }) {
                        return !!(titleObj?.str || contentsObj?.str || richText?.str);
                    }
                    get hasPopupData() {
                        return AnnotationElement._hasPopupData(this.data);
                    }
                    _createContainer(ignoreBorder) {
                        const { data, parent: { page, viewport } } = this;
                        const container = document.createElement("section");
                        container.setAttribute("data-annotation-id", data.id);
                        if (!(this instanceof WidgetAnnotationElement)) container.tabIndex = DEFAULT_TAB_INDEX;
                        container.style.zIndex = this.parent.zIndex++;
                        if (this.data.popupRef) container.setAttribute("aria-haspopup", "dialog");
                        if (data.noRotate) container.classList.add("norotate");
                        const { pageWidth, pageHeight, pageX, pageY } = viewport.rawDims;
                        if (!data.rect || this instanceof PopupAnnotationElement) {
                            const { rotation } = data;
                            if (!data.hasOwnCanvas && rotation !== 0) this.setRotation(rotation, container);
                            return container;
                        }
                        const { width, height } = getRectDims(data.rect);
                        const rect = _util.Util.normalizeRect([
                            data.rect[0],
                            page.view[3] - data.rect[1] + page.view[1],
                            data.rect[2],
                            page.view[3] - data.rect[3] + page.view[1]
                        ]);
                        if (!ignoreBorder && data.borderStyle.width > 0) {
                            container.style.borderWidth = `${data.borderStyle.width}px`;
                            const horizontalRadius = data.borderStyle.horizontalCornerRadius;
                            const verticalRadius = data.borderStyle.verticalCornerRadius;
                            if (horizontalRadius > 0 || verticalRadius > 0) {
                                const radius = `calc(${horizontalRadius}px * var(--scale-factor)) / calc(${verticalRadius}px * var(--scale-factor))`;
                                container.style.borderRadius = radius;
                            } else if (this instanceof RadioButtonWidgetAnnotationElement) {
                                const radius = `calc(${width}px * var(--scale-factor)) / calc(${height}px * var(--scale-factor))`;
                                container.style.borderRadius = radius;
                            }
                            switch(data.borderStyle.style){
                                case _util.AnnotationBorderStyleType.SOLID:
                                    container.style.borderStyle = "solid";
                                    break;
                                case _util.AnnotationBorderStyleType.DASHED:
                                    container.style.borderStyle = "dashed";
                                    break;
                                case _util.AnnotationBorderStyleType.BEVELED:
                                    (0, _util.warn)("Unimplemented border style: beveled");
                                    break;
                                case _util.AnnotationBorderStyleType.INSET:
                                    (0, _util.warn)("Unimplemented border style: inset");
                                    break;
                                case _util.AnnotationBorderStyleType.UNDERLINE:
                                    container.style.borderBottomStyle = "solid";
                                    break;
                                default:
                                    break;
                            }
                            const borderColor = data.borderColor || null;
                            if (borderColor) {
                                this.#hasBorder = true;
                                container.style.borderColor = _util.Util.makeHexColor(borderColor[0] | 0, borderColor[1] | 0, borderColor[2] | 0);
                            } else container.style.borderWidth = 0;
                        }
                        container.style.left = `${100 * (rect[0] - pageX) / pageWidth}%`;
                        container.style.top = `${100 * (rect[1] - pageY) / pageHeight}%`;
                        const { rotation } = data;
                        if (data.hasOwnCanvas || rotation === 0) {
                            container.style.width = `${100 * width / pageWidth}%`;
                            container.style.height = `${100 * height / pageHeight}%`;
                        } else this.setRotation(rotation, container);
                        return container;
                    }
                    setRotation(angle, container = this.container) {
                        if (!this.data.rect) return;
                        const { pageWidth, pageHeight } = this.parent.viewport.rawDims;
                        const { width, height } = getRectDims(this.data.rect);
                        let elementWidth, elementHeight;
                        if (angle % 180 === 0) {
                            elementWidth = 100 * width / pageWidth;
                            elementHeight = 100 * height / pageHeight;
                        } else {
                            elementWidth = 100 * height / pageWidth;
                            elementHeight = 100 * width / pageHeight;
                        }
                        container.style.width = `${elementWidth}%`;
                        container.style.height = `${elementHeight}%`;
                        container.setAttribute("data-main-rotation", (360 - angle) % 360);
                    }
                    get _commonActions() {
                        const setColor = (jsName, styleName, event)=>{
                            const color = event.detail[jsName];
                            const colorType = color[0];
                            const colorArray = color.slice(1);
                            event.target.style[styleName] = _scripting_utils.ColorConverters[`${colorType}_HTML`](colorArray);
                            this.annotationStorage.setValue(this.data.id, {
                                [styleName]: _scripting_utils.ColorConverters[`${colorType}_rgb`](colorArray)
                            });
                        };
                        return (0, _util.shadow)(this, "_commonActions", {
                            display: (event)=>{
                                const { display } = event.detail;
                                const hidden = display % 2 === 1;
                                this.container.style.visibility = hidden ? "hidden" : "visible";
                                this.annotationStorage.setValue(this.data.id, {
                                    noView: hidden,
                                    noPrint: display === 1 || display === 2
                                });
                            },
                            print: (event)=>{
                                this.annotationStorage.setValue(this.data.id, {
                                    noPrint: !event.detail.print
                                });
                            },
                            hidden: (event)=>{
                                const { hidden } = event.detail;
                                this.container.style.visibility = hidden ? "hidden" : "visible";
                                this.annotationStorage.setValue(this.data.id, {
                                    noPrint: hidden,
                                    noView: hidden
                                });
                            },
                            focus: (event)=>{
                                setTimeout(()=>event.target.focus({
                                        preventScroll: false
                                    }), 0);
                            },
                            userName: (event)=>{
                                event.target.title = event.detail.userName;
                            },
                            readonly: (event)=>{
                                event.target.disabled = event.detail.readonly;
                            },
                            required: (event)=>{
                                this._setRequired(event.target, event.detail.required);
                            },
                            bgColor: (event)=>{
                                setColor("bgColor", "backgroundColor", event);
                            },
                            fillColor: (event)=>{
                                setColor("fillColor", "backgroundColor", event);
                            },
                            fgColor: (event)=>{
                                setColor("fgColor", "color", event);
                            },
                            textColor: (event)=>{
                                setColor("textColor", "color", event);
                            },
                            borderColor: (event)=>{
                                setColor("borderColor", "borderColor", event);
                            },
                            strokeColor: (event)=>{
                                setColor("strokeColor", "borderColor", event);
                            },
                            rotation: (event)=>{
                                const angle = event.detail.rotation;
                                this.setRotation(angle);
                                this.annotationStorage.setValue(this.data.id, {
                                    rotation: angle
                                });
                            }
                        });
                    }
                    _dispatchEventFromSandbox(actions, jsEvent) {
                        const commonActions = this._commonActions;
                        for (const name of Object.keys(jsEvent.detail)){
                            const action = actions[name] || commonActions[name];
                            action?.(jsEvent);
                        }
                    }
                    _setDefaultPropertiesFromJS(element) {
                        if (!this.enableScripting) return;
                        const storedData = this.annotationStorage.getRawValue(this.data.id);
                        if (!storedData) return;
                        const commonActions = this._commonActions;
                        for (const [actionName, detail] of Object.entries(storedData)){
                            const action = commonActions[actionName];
                            if (action) {
                                const eventProxy = {
                                    detail: {
                                        [actionName]: detail
                                    },
                                    target: element
                                };
                                action(eventProxy);
                                delete storedData[actionName];
                            }
                        }
                    }
                    _createQuadrilaterals() {
                        if (!this.container) return;
                        const { quadPoints } = this.data;
                        if (!quadPoints) return;
                        const [rectBlX, rectBlY, rectTrX, rectTrY] = this.data.rect;
                        if (quadPoints.length === 1) {
                            const [, { x: trX, y: trY }, { x: blX, y: blY }] = quadPoints[0];
                            if (rectTrX === trX && rectTrY === trY && rectBlX === blX && rectBlY === blY) return;
                        }
                        const { style } = this.container;
                        let svgBuffer;
                        if (this.#hasBorder) {
                            const { borderColor, borderWidth } = style;
                            style.borderWidth = 0;
                            svgBuffer = [
                                "url('data:image/svg+xml;utf8,",
                                `<svg xmlns="http://www.w3.org/2000/svg"`,
                                ` preserveAspectRatio="none" viewBox="0 0 1 1">`,
                                `<g fill="transparent" stroke="${borderColor}" stroke-width="${borderWidth}">`
                            ];
                            this.container.classList.add("hasBorder");
                        }
                        const width = rectTrX - rectBlX;
                        const height = rectTrY - rectBlY;
                        const { svgFactory } = this;
                        const svg = svgFactory.createElement("svg");
                        svg.classList.add("quadrilateralsContainer");
                        svg.setAttribute("width", 0);
                        svg.setAttribute("height", 0);
                        const defs = svgFactory.createElement("defs");
                        svg.append(defs);
                        const clipPath = svgFactory.createElement("clipPath");
                        const id = `clippath_${this.data.id}`;
                        clipPath.setAttribute("id", id);
                        clipPath.setAttribute("clipPathUnits", "objectBoundingBox");
                        defs.append(clipPath);
                        for (const [, { x: trX, y: trY }, { x: blX, y: blY }] of quadPoints){
                            const rect = svgFactory.createElement("rect");
                            const x = (blX - rectBlX) / width;
                            const y = (rectTrY - trY) / height;
                            const rectWidth = (trX - blX) / width;
                            const rectHeight = (trY - blY) / height;
                            rect.setAttribute("x", x);
                            rect.setAttribute("y", y);
                            rect.setAttribute("width", rectWidth);
                            rect.setAttribute("height", rectHeight);
                            clipPath.append(rect);
                            svgBuffer?.push(`<rect vector-effect="non-scaling-stroke" x="${x}" y="${y}" width="${rectWidth}" height="${rectHeight}"/>`);
                        }
                        if (this.#hasBorder) {
                            svgBuffer.push(`</g></svg>')`);
                            style.backgroundImage = svgBuffer.join("");
                        }
                        this.container.append(svg);
                        this.container.style.clipPath = `url(#${id})`;
                    }
                    _createPopup() {
                        const { container, data } = this;
                        container.setAttribute("aria-haspopup", "dialog");
                        const popup = new PopupAnnotationElement({
                            data: {
                                color: data.color,
                                titleObj: data.titleObj,
                                modificationDate: data.modificationDate,
                                contentsObj: data.contentsObj,
                                richText: data.richText,
                                parentRect: data.rect,
                                borderStyle: 0,
                                id: `popup_${data.id}`,
                                rotation: data.rotation
                            },
                            parent: this.parent,
                            elements: [
                                this
                            ]
                        });
                        this.parent.div.append(popup.render());
                    }
                    render() {
                        (0, _util.unreachable)("Abstract method `AnnotationElement.render` called");
                    }
                    _getElementsByName(name, skipId = null) {
                        const fields = [];
                        if (this._fieldObjects) {
                            const fieldObj = this._fieldObjects[name];
                            if (fieldObj) for (const { page, id, exportValues } of fieldObj){
                                if (page === -1) continue;
                                if (id === skipId) continue;
                                const exportValue = typeof exportValues === "string" ? exportValues : null;
                                const domElement = document.querySelector(`[data-element-id="${id}"]`);
                                if (domElement && !GetElementsByNameSet.has(domElement)) {
                                    (0, _util.warn)(`_getElementsByName - element not allowed: ${id}`);
                                    continue;
                                }
                                fields.push({
                                    id: id,
                                    exportValue: exportValue,
                                    domElement: domElement
                                });
                            }
                            return fields;
                        }
                        for (const domElement of document.getElementsByName(name)){
                            const { exportValue } = domElement;
                            const id = domElement.getAttribute("data-element-id");
                            if (id === skipId) continue;
                            if (!GetElementsByNameSet.has(domElement)) continue;
                            fields.push({
                                id: id,
                                exportValue: exportValue,
                                domElement: domElement
                            });
                        }
                        return fields;
                    }
                    show() {
                        if (this.container) this.container.hidden = false;
                        this.popup?.maybeShow();
                    }
                    hide() {
                        if (this.container) this.container.hidden = true;
                        this.popup?.forceHide();
                    }
                    getElementsToTriggerPopup() {
                        return this.container;
                    }
                    addHighlightArea() {
                        const triggers = this.getElementsToTriggerPopup();
                        if (Array.isArray(triggers)) for (const element of triggers)element.classList.add("highlightArea");
                        else triggers.classList.add("highlightArea");
                    }
                    _editOnDoubleClick() {
                        const { annotationEditorType: mode, data: { id: editId } } = this;
                        this.container.addEventListener("dblclick", ()=>{
                            this.linkService.eventBus?.dispatch("switchannotationeditormode", {
                                source: this,
                                mode: mode,
                                editId: editId
                            });
                        });
                    }
                }
                class LinkAnnotationElement extends AnnotationElement {
                    constructor(parameters, options = null){
                        super(parameters, {
                            isRenderable: true,
                            ignoreBorder: !!options?.ignoreBorder,
                            createQuadrilaterals: true
                        });
                        this.isTooltipOnly = parameters.data.isTooltipOnly;
                    }
                    render() {
                        const { data, linkService } = this;
                        const link = document.createElement("a");
                        link.setAttribute("data-element-id", data.id);
                        let isBound = false;
                        if (data.url) {
                            linkService.addLinkAttributes(link, data.url, data.newWindow);
                            isBound = true;
                        } else if (data.action) {
                            this._bindNamedAction(link, data.action);
                            isBound = true;
                        } else if (data.attachment) {
                            this._bindAttachment(link, data.attachment);
                            isBound = true;
                        } else if (data.setOCGState) {
                            this.#bindSetOCGState(link, data.setOCGState);
                            isBound = true;
                        } else if (data.dest) {
                            this._bindLink(link, data.dest);
                            isBound = true;
                        } else {
                            if (data.actions && (data.actions.Action || data.actions["Mouse Up"] || data.actions["Mouse Down"]) && this.enableScripting && this.hasJSActions) {
                                this._bindJSAction(link, data);
                                isBound = true;
                            }
                            if (data.resetForm) {
                                this._bindResetFormAction(link, data.resetForm);
                                isBound = true;
                            } else if (this.isTooltipOnly && !isBound) {
                                this._bindLink(link, "");
                                isBound = true;
                            }
                        }
                        this.container.classList.add("linkAnnotation");
                        if (isBound) this.container.append(link);
                        return this.container;
                    }
                    #setInternalLink() {
                        this.container.setAttribute("data-internal-link", "");
                    }
                    _bindLink(link, destination) {
                        link.href = this.linkService.getDestinationHash(destination);
                        link.onclick = ()=>{
                            if (destination) this.linkService.goToDestination(destination);
                            return false;
                        };
                        if (destination || destination === "") this.#setInternalLink();
                    }
                    _bindNamedAction(link, action) {
                        link.href = this.linkService.getAnchorUrl("");
                        link.onclick = ()=>{
                            this.linkService.executeNamedAction(action);
                            return false;
                        };
                        this.#setInternalLink();
                    }
                    _bindAttachment(link, attachment) {
                        link.href = this.linkService.getAnchorUrl("");
                        link.onclick = ()=>{
                            this.downloadManager?.openOrDownloadData(this.container, attachment.content, attachment.filename);
                            return false;
                        };
                        this.#setInternalLink();
                    }
                    #bindSetOCGState(link, action) {
                        link.href = this.linkService.getAnchorUrl("");
                        link.onclick = ()=>{
                            this.linkService.executeSetOCGState(action);
                            return false;
                        };
                        this.#setInternalLink();
                    }
                    _bindJSAction(link, data) {
                        link.href = this.linkService.getAnchorUrl("");
                        const map = new Map([
                            [
                                "Action",
                                "onclick"
                            ],
                            [
                                "Mouse Up",
                                "onmouseup"
                            ],
                            [
                                "Mouse Down",
                                "onmousedown"
                            ]
                        ]);
                        for (const name of Object.keys(data.actions)){
                            const jsName = map.get(name);
                            if (!jsName) continue;
                            link[jsName] = ()=>{
                                this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                                    source: this,
                                    detail: {
                                        id: data.id,
                                        name: name
                                    }
                                });
                                return false;
                            };
                        }
                        if (!link.onclick) link.onclick = ()=>false;
                        this.#setInternalLink();
                    }
                    _bindResetFormAction(link, resetForm) {
                        const otherClickAction = link.onclick;
                        if (!otherClickAction) link.href = this.linkService.getAnchorUrl("");
                        this.#setInternalLink();
                        if (!this._fieldObjects) {
                            (0, _util.warn)(`_bindResetFormAction - "resetForm" action not supported, ` + "ensure that the `fieldObjects` parameter is provided.");
                            if (!otherClickAction) link.onclick = ()=>false;
                            return;
                        }
                        link.onclick = ()=>{
                            otherClickAction?.();
                            const { fields: resetFormFields, refs: resetFormRefs, include } = resetForm;
                            const allFields = [];
                            if (resetFormFields.length !== 0 || resetFormRefs.length !== 0) {
                                const fieldIds = new Set(resetFormRefs);
                                for (const fieldName of resetFormFields){
                                    const fields = this._fieldObjects[fieldName] || [];
                                    for (const { id } of fields)fieldIds.add(id);
                                }
                                for (const fields of Object.values(this._fieldObjects)){
                                    for (const field of fields)if (fieldIds.has(field.id) === include) allFields.push(field);
                                }
                            } else for (const fields of Object.values(this._fieldObjects))allFields.push(...fields);
                            const storage = this.annotationStorage;
                            const allIds = [];
                            for (const field of allFields){
                                const { id } = field;
                                allIds.push(id);
                                switch(field.type){
                                    case "text":
                                        {
                                            const value = field.defaultValue || "";
                                            storage.setValue(id, {
                                                value: value
                                            });
                                            break;
                                        }
                                    case "checkbox":
                                    case "radiobutton":
                                        {
                                            const value = field.defaultValue === field.exportValues;
                                            storage.setValue(id, {
                                                value: value
                                            });
                                            break;
                                        }
                                    case "combobox":
                                    case "listbox":
                                        {
                                            const value = field.defaultValue || "";
                                            storage.setValue(id, {
                                                value: value
                                            });
                                            break;
                                        }
                                    default:
                                        continue;
                                }
                                const domElement = document.querySelector(`[data-element-id="${id}"]`);
                                if (!domElement) continue;
                                else if (!GetElementsByNameSet.has(domElement)) {
                                    (0, _util.warn)(`_bindResetFormAction - element not allowed: ${id}`);
                                    continue;
                                }
                                domElement.dispatchEvent(new Event("resetform"));
                            }
                            if (this.enableScripting) this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                                source: this,
                                detail: {
                                    id: "app",
                                    ids: allIds,
                                    name: "ResetForm"
                                }
                            });
                            return false;
                        };
                    }
                }
                class TextAnnotationElement extends AnnotationElement {
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: true
                        });
                    }
                    render() {
                        this.container.classList.add("textAnnotation");
                        const image = document.createElement("img");
                        image.src = this.imageResourcesPath + "annotation-" + this.data.name.toLowerCase() + ".svg";
                        image.alt = "[{{type}} Annotation]";
                        image.dataset.l10nId = "text_annotation_type";
                        image.dataset.l10nArgs = JSON.stringify({
                            type: this.data.name
                        });
                        if (!this.data.popupRef && this.hasPopupData) this._createPopup();
                        this.container.append(image);
                        return this.container;
                    }
                }
                class WidgetAnnotationElement extends AnnotationElement {
                    render() {
                        if (this.data.alternativeText) this.container.title = this.data.alternativeText;
                        return this.container;
                    }
                    showElementAndHideCanvas(element) {
                        if (this.data.hasOwnCanvas) {
                            if (element.previousSibling?.nodeName === "CANVAS") element.previousSibling.hidden = true;
                            element.hidden = false;
                        }
                    }
                    _getKeyModifier(event) {
                        const { isWin, isMac } = _util.FeatureTest.platform;
                        return isWin && event.ctrlKey || isMac && event.metaKey;
                    }
                    _setEventListener(element, elementData, baseName, eventName, valueGetter) {
                        if (baseName.includes("mouse")) element.addEventListener(baseName, (event)=>{
                            this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                                source: this,
                                detail: {
                                    id: this.data.id,
                                    name: eventName,
                                    value: valueGetter(event),
                                    shift: event.shiftKey,
                                    modifier: this._getKeyModifier(event)
                                }
                            });
                        });
                        else element.addEventListener(baseName, (event)=>{
                            if (baseName === "blur") {
                                if (!elementData.focused || !event.relatedTarget) return;
                                elementData.focused = false;
                            } else if (baseName === "focus") {
                                if (elementData.focused) return;
                                elementData.focused = true;
                            }
                            if (!valueGetter) return;
                            this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                                source: this,
                                detail: {
                                    id: this.data.id,
                                    name: eventName,
                                    value: valueGetter(event)
                                }
                            });
                        });
                    }
                    _setEventListeners(element, elementData, names, getter) {
                        for (const [baseName, eventName] of names)if (eventName === "Action" || this.data.actions?.[eventName]) {
                            if (eventName === "Focus" || eventName === "Blur") elementData ||= {
                                focused: false
                            };
                            this._setEventListener(element, elementData, baseName, eventName, getter);
                            if (eventName === "Focus" && !this.data.actions?.Blur) this._setEventListener(element, elementData, "blur", "Blur", null);
                            else if (eventName === "Blur" && !this.data.actions?.Focus) this._setEventListener(element, elementData, "focus", "Focus", null);
                        }
                    }
                    _setBackgroundColor(element) {
                        const color = this.data.backgroundColor || null;
                        element.style.backgroundColor = color === null ? "transparent" : _util.Util.makeHexColor(color[0], color[1], color[2]);
                    }
                    _setTextStyle(element) {
                        const TEXT_ALIGNMENT = [
                            "left",
                            "center",
                            "right"
                        ];
                        const { fontColor } = this.data.defaultAppearanceData;
                        const fontSize = this.data.defaultAppearanceData.fontSize || DEFAULT_FONT_SIZE;
                        const style = element.style;
                        let computedFontSize;
                        const BORDER_SIZE = 2;
                        const roundToOneDecimal = (x)=>Math.round(10 * x) / 10;
                        if (this.data.multiLine) {
                            const height = Math.abs(this.data.rect[3] - this.data.rect[1] - BORDER_SIZE);
                            const numberOfLines = Math.round(height / (_util.LINE_FACTOR * fontSize)) || 1;
                            const lineHeight = height / numberOfLines;
                            computedFontSize = Math.min(fontSize, roundToOneDecimal(lineHeight / _util.LINE_FACTOR));
                        } else {
                            const height = Math.abs(this.data.rect[3] - this.data.rect[1] - BORDER_SIZE);
                            computedFontSize = Math.min(fontSize, roundToOneDecimal(height / _util.LINE_FACTOR));
                        }
                        style.fontSize = `calc(${computedFontSize}px * var(--scale-factor))`;
                        style.color = _util.Util.makeHexColor(fontColor[0], fontColor[1], fontColor[2]);
                        if (this.data.textAlignment !== null) style.textAlign = TEXT_ALIGNMENT[this.data.textAlignment];
                    }
                    _setRequired(element, isRequired) {
                        if (isRequired) element.setAttribute("required", true);
                        else element.removeAttribute("required");
                        element.setAttribute("aria-required", isRequired);
                    }
                }
                class TextWidgetAnnotationElement extends WidgetAnnotationElement {
                    constructor(parameters){
                        const isRenderable = parameters.renderForms || !parameters.data.hasAppearance && !!parameters.data.fieldValue;
                        super(parameters, {
                            isRenderable: isRenderable
                        });
                    }
                    setPropertyOnSiblings(base, key, value, keyInStorage) {
                        const storage = this.annotationStorage;
                        for (const element of this._getElementsByName(base.name, base.id)){
                            if (element.domElement) element.domElement[key] = value;
                            storage.setValue(element.id, {
                                [keyInStorage]: value
                            });
                        }
                    }
                    render() {
                        const storage = this.annotationStorage;
                        const id = this.data.id;
                        this.container.classList.add("textWidgetAnnotation");
                        let element = null;
                        if (this.renderForms) {
                            const storedData = storage.getValue(id, {
                                value: this.data.fieldValue
                            });
                            let textContent = storedData.value || "";
                            const maxLen = storage.getValue(id, {
                                charLimit: this.data.maxLen
                            }).charLimit;
                            if (maxLen && textContent.length > maxLen) textContent = textContent.slice(0, maxLen);
                            let fieldFormattedValues = storedData.formattedValue || this.data.textContent?.join("\n") || null;
                            if (fieldFormattedValues && this.data.comb) fieldFormattedValues = fieldFormattedValues.replaceAll(/\s+/g, "");
                            const elementData = {
                                userValue: textContent,
                                formattedValue: fieldFormattedValues,
                                lastCommittedValue: null,
                                commitKey: 1,
                                focused: false
                            };
                            if (this.data.multiLine) {
                                element = document.createElement("textarea");
                                element.textContent = fieldFormattedValues ?? textContent;
                                if (this.data.doNotScroll) element.style.overflowY = "hidden";
                            } else {
                                element = document.createElement("input");
                                element.type = "text";
                                element.setAttribute("value", fieldFormattedValues ?? textContent);
                                if (this.data.doNotScroll) element.style.overflowX = "hidden";
                            }
                            if (this.data.hasOwnCanvas) element.hidden = true;
                            GetElementsByNameSet.add(element);
                            element.setAttribute("data-element-id", id);
                            element.disabled = this.data.readOnly;
                            element.name = this.data.fieldName;
                            element.tabIndex = DEFAULT_TAB_INDEX;
                            this._setRequired(element, this.data.required);
                            if (maxLen) element.maxLength = maxLen;
                            element.addEventListener("input", (event)=>{
                                storage.setValue(id, {
                                    value: event.target.value
                                });
                                this.setPropertyOnSiblings(element, "value", event.target.value, "value");
                                elementData.formattedValue = null;
                            });
                            element.addEventListener("resetform", (event)=>{
                                const defaultValue = this.data.defaultFieldValue ?? "";
                                element.value = elementData.userValue = defaultValue;
                                elementData.formattedValue = null;
                            });
                            let blurListener = (event)=>{
                                const { formattedValue } = elementData;
                                if (formattedValue !== null && formattedValue !== undefined) event.target.value = formattedValue;
                                event.target.scrollLeft = 0;
                            };
                            if (this.enableScripting && this.hasJSActions) {
                                element.addEventListener("focus", (event)=>{
                                    if (elementData.focused) return;
                                    const { target } = event;
                                    if (elementData.userValue) target.value = elementData.userValue;
                                    elementData.lastCommittedValue = target.value;
                                    elementData.commitKey = 1;
                                    elementData.focused = true;
                                });
                                element.addEventListener("updatefromsandbox", (jsEvent)=>{
                                    this.showElementAndHideCanvas(jsEvent.target);
                                    const actions = {
                                        value (event) {
                                            elementData.userValue = event.detail.value ?? "";
                                            storage.setValue(id, {
                                                value: elementData.userValue.toString()
                                            });
                                            event.target.value = elementData.userValue;
                                        },
                                        formattedValue (event) {
                                            const { formattedValue } = event.detail;
                                            elementData.formattedValue = formattedValue;
                                            if (formattedValue !== null && formattedValue !== undefined && event.target !== document.activeElement) event.target.value = formattedValue;
                                            storage.setValue(id, {
                                                formattedValue: formattedValue
                                            });
                                        },
                                        selRange (event) {
                                            event.target.setSelectionRange(...event.detail.selRange);
                                        },
                                        charLimit: (event)=>{
                                            const { charLimit } = event.detail;
                                            const { target } = event;
                                            if (charLimit === 0) {
                                                target.removeAttribute("maxLength");
                                                return;
                                            }
                                            target.setAttribute("maxLength", charLimit);
                                            let value = elementData.userValue;
                                            if (!value || value.length <= charLimit) return;
                                            value = value.slice(0, charLimit);
                                            target.value = elementData.userValue = value;
                                            storage.setValue(id, {
                                                value: value
                                            });
                                            this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                                                source: this,
                                                detail: {
                                                    id: id,
                                                    name: "Keystroke",
                                                    value: value,
                                                    willCommit: true,
                                                    commitKey: 1,
                                                    selStart: target.selectionStart,
                                                    selEnd: target.selectionEnd
                                                }
                                            });
                                        }
                                    };
                                    this._dispatchEventFromSandbox(actions, jsEvent);
                                });
                                element.addEventListener("keydown", (event)=>{
                                    elementData.commitKey = 1;
                                    let commitKey = -1;
                                    if (event.key === "Escape") commitKey = 0;
                                    else if (event.key === "Enter" && !this.data.multiLine) commitKey = 2;
                                    else if (event.key === "Tab") elementData.commitKey = 3;
                                    if (commitKey === -1) return;
                                    const { value } = event.target;
                                    if (elementData.lastCommittedValue === value) return;
                                    elementData.lastCommittedValue = value;
                                    elementData.userValue = value;
                                    this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                                        source: this,
                                        detail: {
                                            id: id,
                                            name: "Keystroke",
                                            value: value,
                                            willCommit: true,
                                            commitKey: commitKey,
                                            selStart: event.target.selectionStart,
                                            selEnd: event.target.selectionEnd
                                        }
                                    });
                                });
                                const _blurListener = blurListener;
                                blurListener = null;
                                element.addEventListener("blur", (event)=>{
                                    if (!elementData.focused || !event.relatedTarget) return;
                                    elementData.focused = false;
                                    const { value } = event.target;
                                    elementData.userValue = value;
                                    if (elementData.lastCommittedValue !== value) this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                                        source: this,
                                        detail: {
                                            id: id,
                                            name: "Keystroke",
                                            value: value,
                                            willCommit: true,
                                            commitKey: elementData.commitKey,
                                            selStart: event.target.selectionStart,
                                            selEnd: event.target.selectionEnd
                                        }
                                    });
                                    _blurListener(event);
                                });
                                if (this.data.actions?.Keystroke) element.addEventListener("beforeinput", (event)=>{
                                    elementData.lastCommittedValue = null;
                                    const { data, target } = event;
                                    const { value, selectionStart, selectionEnd } = target;
                                    let selStart = selectionStart, selEnd = selectionEnd;
                                    switch(event.inputType){
                                        case "deleteWordBackward":
                                            {
                                                const match = value.substring(0, selectionStart).match(/\w*[^\w]*$/);
                                                if (match) selStart -= match[0].length;
                                                break;
                                            }
                                        case "deleteWordForward":
                                            {
                                                const match = value.substring(selectionStart).match(/^[^\w]*\w*/);
                                                if (match) selEnd += match[0].length;
                                                break;
                                            }
                                        case "deleteContentBackward":
                                            if (selectionStart === selectionEnd) selStart -= 1;
                                            break;
                                        case "deleteContentForward":
                                            if (selectionStart === selectionEnd) selEnd += 1;
                                            break;
                                    }
                                    event.preventDefault();
                                    this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                                        source: this,
                                        detail: {
                                            id: id,
                                            name: "Keystroke",
                                            value: value,
                                            change: data || "",
                                            willCommit: false,
                                            selStart: selStart,
                                            selEnd: selEnd
                                        }
                                    });
                                });
                                this._setEventListeners(element, elementData, [
                                    [
                                        "focus",
                                        "Focus"
                                    ],
                                    [
                                        "blur",
                                        "Blur"
                                    ],
                                    [
                                        "mousedown",
                                        "Mouse Down"
                                    ],
                                    [
                                        "mouseenter",
                                        "Mouse Enter"
                                    ],
                                    [
                                        "mouseleave",
                                        "Mouse Exit"
                                    ],
                                    [
                                        "mouseup",
                                        "Mouse Up"
                                    ]
                                ], (event)=>event.target.value);
                            }
                            if (blurListener) element.addEventListener("blur", blurListener);
                            if (this.data.comb) {
                                const fieldWidth = this.data.rect[2] - this.data.rect[0];
                                const combWidth = fieldWidth / maxLen;
                                element.classList.add("comb");
                                element.style.letterSpacing = `calc(${combWidth}px * var(--scale-factor) - 1ch)`;
                            }
                        } else {
                            element = document.createElement("div");
                            element.textContent = this.data.fieldValue;
                            element.style.verticalAlign = "middle";
                            element.style.display = "table-cell";
                        }
                        this._setTextStyle(element);
                        this._setBackgroundColor(element);
                        this._setDefaultPropertiesFromJS(element);
                        this.container.append(element);
                        return this.container;
                    }
                }
                class SignatureWidgetAnnotationElement extends WidgetAnnotationElement {
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: !!parameters.data.hasOwnCanvas
                        });
                    }
                }
                class CheckboxWidgetAnnotationElement extends WidgetAnnotationElement {
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: parameters.renderForms
                        });
                    }
                    render() {
                        const storage = this.annotationStorage;
                        const data = this.data;
                        const id = data.id;
                        let value = storage.getValue(id, {
                            value: data.exportValue === data.fieldValue
                        }).value;
                        if (typeof value === "string") {
                            value = value !== "Off";
                            storage.setValue(id, {
                                value: value
                            });
                        }
                        this.container.classList.add("buttonWidgetAnnotation", "checkBox");
                        const element = document.createElement("input");
                        GetElementsByNameSet.add(element);
                        element.setAttribute("data-element-id", id);
                        element.disabled = data.readOnly;
                        this._setRequired(element, this.data.required);
                        element.type = "checkbox";
                        element.name = data.fieldName;
                        if (value) element.setAttribute("checked", true);
                        element.setAttribute("exportValue", data.exportValue);
                        element.tabIndex = DEFAULT_TAB_INDEX;
                        element.addEventListener("change", (event)=>{
                            const { name, checked } = event.target;
                            for (const checkbox of this._getElementsByName(name, id)){
                                const curChecked = checked && checkbox.exportValue === data.exportValue;
                                if (checkbox.domElement) checkbox.domElement.checked = curChecked;
                                storage.setValue(checkbox.id, {
                                    value: curChecked
                                });
                            }
                            storage.setValue(id, {
                                value: checked
                            });
                        });
                        element.addEventListener("resetform", (event)=>{
                            const defaultValue = data.defaultFieldValue || "Off";
                            event.target.checked = defaultValue === data.exportValue;
                        });
                        if (this.enableScripting && this.hasJSActions) {
                            element.addEventListener("updatefromsandbox", (jsEvent)=>{
                                const actions = {
                                    value (event) {
                                        event.target.checked = event.detail.value !== "Off";
                                        storage.setValue(id, {
                                            value: event.target.checked
                                        });
                                    }
                                };
                                this._dispatchEventFromSandbox(actions, jsEvent);
                            });
                            this._setEventListeners(element, null, [
                                [
                                    "change",
                                    "Validate"
                                ],
                                [
                                    "change",
                                    "Action"
                                ],
                                [
                                    "focus",
                                    "Focus"
                                ],
                                [
                                    "blur",
                                    "Blur"
                                ],
                                [
                                    "mousedown",
                                    "Mouse Down"
                                ],
                                [
                                    "mouseenter",
                                    "Mouse Enter"
                                ],
                                [
                                    "mouseleave",
                                    "Mouse Exit"
                                ],
                                [
                                    "mouseup",
                                    "Mouse Up"
                                ]
                            ], (event)=>event.target.checked);
                        }
                        this._setBackgroundColor(element);
                        this._setDefaultPropertiesFromJS(element);
                        this.container.append(element);
                        return this.container;
                    }
                }
                class RadioButtonWidgetAnnotationElement extends WidgetAnnotationElement {
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: parameters.renderForms
                        });
                    }
                    render() {
                        this.container.classList.add("buttonWidgetAnnotation", "radioButton");
                        const storage = this.annotationStorage;
                        const data = this.data;
                        const id = data.id;
                        let value = storage.getValue(id, {
                            value: data.fieldValue === data.buttonValue
                        }).value;
                        if (typeof value === "string") {
                            value = value !== data.buttonValue;
                            storage.setValue(id, {
                                value: value
                            });
                        }
                        const element = document.createElement("input");
                        GetElementsByNameSet.add(element);
                        element.setAttribute("data-element-id", id);
                        element.disabled = data.readOnly;
                        this._setRequired(element, this.data.required);
                        element.type = "radio";
                        element.name = data.fieldName;
                        if (value) element.setAttribute("checked", true);
                        element.tabIndex = DEFAULT_TAB_INDEX;
                        element.addEventListener("change", (event)=>{
                            const { name, checked } = event.target;
                            for (const radio of this._getElementsByName(name, id))storage.setValue(radio.id, {
                                value: false
                            });
                            storage.setValue(id, {
                                value: checked
                            });
                        });
                        element.addEventListener("resetform", (event)=>{
                            const defaultValue = data.defaultFieldValue;
                            event.target.checked = defaultValue !== null && defaultValue !== undefined && defaultValue === data.buttonValue;
                        });
                        if (this.enableScripting && this.hasJSActions) {
                            const pdfButtonValue = data.buttonValue;
                            element.addEventListener("updatefromsandbox", (jsEvent)=>{
                                const actions = {
                                    value: (event)=>{
                                        const checked = pdfButtonValue === event.detail.value;
                                        for (const radio of this._getElementsByName(event.target.name)){
                                            const curChecked = checked && radio.id === id;
                                            if (radio.domElement) radio.domElement.checked = curChecked;
                                            storage.setValue(radio.id, {
                                                value: curChecked
                                            });
                                        }
                                    }
                                };
                                this._dispatchEventFromSandbox(actions, jsEvent);
                            });
                            this._setEventListeners(element, null, [
                                [
                                    "change",
                                    "Validate"
                                ],
                                [
                                    "change",
                                    "Action"
                                ],
                                [
                                    "focus",
                                    "Focus"
                                ],
                                [
                                    "blur",
                                    "Blur"
                                ],
                                [
                                    "mousedown",
                                    "Mouse Down"
                                ],
                                [
                                    "mouseenter",
                                    "Mouse Enter"
                                ],
                                [
                                    "mouseleave",
                                    "Mouse Exit"
                                ],
                                [
                                    "mouseup",
                                    "Mouse Up"
                                ]
                            ], (event)=>event.target.checked);
                        }
                        this._setBackgroundColor(element);
                        this._setDefaultPropertiesFromJS(element);
                        this.container.append(element);
                        return this.container;
                    }
                }
                class PushButtonWidgetAnnotationElement extends LinkAnnotationElement {
                    constructor(parameters){
                        super(parameters, {
                            ignoreBorder: parameters.data.hasAppearance
                        });
                    }
                    render() {
                        const container = super.render();
                        container.classList.add("buttonWidgetAnnotation", "pushButton");
                        if (this.data.alternativeText) container.title = this.data.alternativeText;
                        const linkElement = container.lastChild;
                        if (this.enableScripting && this.hasJSActions && linkElement) {
                            this._setDefaultPropertiesFromJS(linkElement);
                            linkElement.addEventListener("updatefromsandbox", (jsEvent)=>{
                                this._dispatchEventFromSandbox({}, jsEvent);
                            });
                        }
                        return container;
                    }
                }
                class ChoiceWidgetAnnotationElement extends WidgetAnnotationElement {
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: parameters.renderForms
                        });
                    }
                    render() {
                        this.container.classList.add("choiceWidgetAnnotation");
                        const storage = this.annotationStorage;
                        const id = this.data.id;
                        const storedData = storage.getValue(id, {
                            value: this.data.fieldValue
                        });
                        const selectElement = document.createElement("select");
                        GetElementsByNameSet.add(selectElement);
                        selectElement.setAttribute("data-element-id", id);
                        selectElement.disabled = this.data.readOnly;
                        this._setRequired(selectElement, this.data.required);
                        selectElement.name = this.data.fieldName;
                        selectElement.tabIndex = DEFAULT_TAB_INDEX;
                        let addAnEmptyEntry = this.data.combo && this.data.options.length > 0;
                        if (!this.data.combo) {
                            selectElement.size = this.data.options.length;
                            if (this.data.multiSelect) selectElement.multiple = true;
                        }
                        selectElement.addEventListener("resetform", (event)=>{
                            const defaultValue = this.data.defaultFieldValue;
                            for (const option of selectElement.options)option.selected = option.value === defaultValue;
                        });
                        for (const option of this.data.options){
                            const optionElement = document.createElement("option");
                            optionElement.textContent = option.displayValue;
                            optionElement.value = option.exportValue;
                            if (storedData.value.includes(option.exportValue)) {
                                optionElement.setAttribute("selected", true);
                                addAnEmptyEntry = false;
                            }
                            selectElement.append(optionElement);
                        }
                        let removeEmptyEntry = null;
                        if (addAnEmptyEntry) {
                            const noneOptionElement = document.createElement("option");
                            noneOptionElement.value = " ";
                            noneOptionElement.setAttribute("hidden", true);
                            noneOptionElement.setAttribute("selected", true);
                            selectElement.prepend(noneOptionElement);
                            removeEmptyEntry = ()=>{
                                noneOptionElement.remove();
                                selectElement.removeEventListener("input", removeEmptyEntry);
                                removeEmptyEntry = null;
                            };
                            selectElement.addEventListener("input", removeEmptyEntry);
                        }
                        const getValue = (isExport)=>{
                            const name = isExport ? "value" : "textContent";
                            const { options, multiple } = selectElement;
                            if (!multiple) return options.selectedIndex === -1 ? null : options[options.selectedIndex][name];
                            return Array.prototype.filter.call(options, (option)=>option.selected).map((option)=>option[name]);
                        };
                        let selectedValues = getValue(false);
                        const getItems = (event)=>{
                            const options = event.target.options;
                            return Array.prototype.map.call(options, (option)=>{
                                return {
                                    displayValue: option.textContent,
                                    exportValue: option.value
                                };
                            });
                        };
                        if (this.enableScripting && this.hasJSActions) {
                            selectElement.addEventListener("updatefromsandbox", (jsEvent)=>{
                                const actions = {
                                    value (event) {
                                        removeEmptyEntry?.();
                                        const value = event.detail.value;
                                        const values = new Set(Array.isArray(value) ? value : [
                                            value
                                        ]);
                                        for (const option of selectElement.options)option.selected = values.has(option.value);
                                        storage.setValue(id, {
                                            value: getValue(true)
                                        });
                                        selectedValues = getValue(false);
                                    },
                                    multipleSelection (event) {
                                        selectElement.multiple = true;
                                    },
                                    remove (event) {
                                        const options = selectElement.options;
                                        const index = event.detail.remove;
                                        options[index].selected = false;
                                        selectElement.remove(index);
                                        if (options.length > 0) {
                                            const i = Array.prototype.findIndex.call(options, (option)=>option.selected);
                                            if (i === -1) options[0].selected = true;
                                        }
                                        storage.setValue(id, {
                                            value: getValue(true),
                                            items: getItems(event)
                                        });
                                        selectedValues = getValue(false);
                                    },
                                    clear (event) {
                                        while(selectElement.length !== 0)selectElement.remove(0);
                                        storage.setValue(id, {
                                            value: null,
                                            items: []
                                        });
                                        selectedValues = getValue(false);
                                    },
                                    insert (event) {
                                        const { index, displayValue, exportValue } = event.detail.insert;
                                        const selectChild = selectElement.children[index];
                                        const optionElement = document.createElement("option");
                                        optionElement.textContent = displayValue;
                                        optionElement.value = exportValue;
                                        if (selectChild) selectChild.before(optionElement);
                                        else selectElement.append(optionElement);
                                        storage.setValue(id, {
                                            value: getValue(true),
                                            items: getItems(event)
                                        });
                                        selectedValues = getValue(false);
                                    },
                                    items (event) {
                                        const { items } = event.detail;
                                        while(selectElement.length !== 0)selectElement.remove(0);
                                        for (const item of items){
                                            const { displayValue, exportValue } = item;
                                            const optionElement = document.createElement("option");
                                            optionElement.textContent = displayValue;
                                            optionElement.value = exportValue;
                                            selectElement.append(optionElement);
                                        }
                                        if (selectElement.options.length > 0) selectElement.options[0].selected = true;
                                        storage.setValue(id, {
                                            value: getValue(true),
                                            items: getItems(event)
                                        });
                                        selectedValues = getValue(false);
                                    },
                                    indices (event) {
                                        const indices = new Set(event.detail.indices);
                                        for (const option of event.target.options)option.selected = indices.has(option.index);
                                        storage.setValue(id, {
                                            value: getValue(true)
                                        });
                                        selectedValues = getValue(false);
                                    },
                                    editable (event) {
                                        event.target.disabled = !event.detail.editable;
                                    }
                                };
                                this._dispatchEventFromSandbox(actions, jsEvent);
                            });
                            selectElement.addEventListener("input", (event)=>{
                                const exportValue = getValue(true);
                                storage.setValue(id, {
                                    value: exportValue
                                });
                                event.preventDefault();
                                this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                                    source: this,
                                    detail: {
                                        id: id,
                                        name: "Keystroke",
                                        value: selectedValues,
                                        changeEx: exportValue,
                                        willCommit: false,
                                        commitKey: 1,
                                        keyDown: false
                                    }
                                });
                            });
                            this._setEventListeners(selectElement, null, [
                                [
                                    "focus",
                                    "Focus"
                                ],
                                [
                                    "blur",
                                    "Blur"
                                ],
                                [
                                    "mousedown",
                                    "Mouse Down"
                                ],
                                [
                                    "mouseenter",
                                    "Mouse Enter"
                                ],
                                [
                                    "mouseleave",
                                    "Mouse Exit"
                                ],
                                [
                                    "mouseup",
                                    "Mouse Up"
                                ],
                                [
                                    "input",
                                    "Action"
                                ],
                                [
                                    "input",
                                    "Validate"
                                ]
                            ], (event)=>event.target.value);
                        } else selectElement.addEventListener("input", function(event) {
                            storage.setValue(id, {
                                value: getValue(true)
                            });
                        });
                        if (this.data.combo) this._setTextStyle(selectElement);
                        this._setBackgroundColor(selectElement);
                        this._setDefaultPropertiesFromJS(selectElement);
                        this.container.append(selectElement);
                        return this.container;
                    }
                }
                class PopupAnnotationElement extends AnnotationElement {
                    constructor(parameters){
                        const { data, elements } = parameters;
                        super(parameters, {
                            isRenderable: AnnotationElement._hasPopupData(data)
                        });
                        this.elements = elements;
                    }
                    render() {
                        this.container.classList.add("popupAnnotation");
                        const popup = new PopupElement({
                            container: this.container,
                            color: this.data.color,
                            titleObj: this.data.titleObj,
                            modificationDate: this.data.modificationDate,
                            contentsObj: this.data.contentsObj,
                            richText: this.data.richText,
                            rect: this.data.rect,
                            parentRect: this.data.parentRect || null,
                            parent: this.parent,
                            elements: this.elements,
                            open: this.data.open
                        });
                        const elementIds = [];
                        for (const element of this.elements){
                            element.popup = popup;
                            elementIds.push(element.data.id);
                            element.addHighlightArea();
                        }
                        this.container.setAttribute("aria-controls", elementIds.map((id)=>`${_util.AnnotationPrefix}${id}`).join(","));
                        return this.container;
                    }
                }
                class PopupElement {
                    #dateTimePromise = null;
                    #boundKeyDown = this.#keyDown.bind(this);
                    #boundHide = this.#hide.bind(this);
                    #boundShow = this.#show.bind(this);
                    #boundToggle = this.#toggle.bind(this);
                    #color = null;
                    #container = null;
                    #contentsObj = null;
                    #elements = null;
                    #parent = null;
                    #parentRect = null;
                    #pinned = false;
                    #popup = null;
                    #rect = null;
                    #richText = null;
                    #titleObj = null;
                    #wasVisible = false;
                    constructor({ container, color, elements, titleObj, modificationDate, contentsObj, richText, parent, rect, parentRect, open }){
                        this.#container = container;
                        this.#titleObj = titleObj;
                        this.#contentsObj = contentsObj;
                        this.#richText = richText;
                        this.#parent = parent;
                        this.#color = color;
                        this.#rect = rect;
                        this.#parentRect = parentRect;
                        this.#elements = elements;
                        const dateObject = _display_utils.PDFDateString.toDateObject(modificationDate);
                        if (dateObject) this.#dateTimePromise = parent.l10n.get("annotation_date_string", {
                            date: dateObject.toLocaleDateString(),
                            time: dateObject.toLocaleTimeString()
                        });
                        this.trigger = elements.flatMap((e)=>e.getElementsToTriggerPopup());
                        for (const element of this.trigger){
                            element.addEventListener("click", this.#boundToggle);
                            element.addEventListener("mouseenter", this.#boundShow);
                            element.addEventListener("mouseleave", this.#boundHide);
                            element.classList.add("popupTriggerArea");
                        }
                        for (const element of elements)element.container?.addEventListener("keydown", this.#boundKeyDown);
                        this.#container.hidden = true;
                        if (open) this.#toggle();
                    }
                    render() {
                        if (this.#popup) return;
                        const { page: { view }, viewport: { rawDims: { pageWidth, pageHeight, pageX, pageY } } } = this.#parent;
                        const popup = this.#popup = document.createElement("div");
                        popup.className = "popup";
                        if (this.#color) {
                            const baseColor = popup.style.outlineColor = _util.Util.makeHexColor(...this.#color);
                            if (CSS.supports("background-color", "color-mix(in srgb, red 30%, white)")) popup.style.backgroundColor = `color-mix(in srgb, ${baseColor} 30%, white)`;
                            else {
                                const BACKGROUND_ENLIGHT = 0.7;
                                popup.style.backgroundColor = _util.Util.makeHexColor(...this.#color.map((c)=>Math.floor(BACKGROUND_ENLIGHT * (255 - c) + c)));
                            }
                        }
                        const header = document.createElement("span");
                        header.className = "header";
                        const title = document.createElement("h1");
                        header.append(title);
                        ({ dir: title.dir, str: title.textContent } = this.#titleObj);
                        popup.append(header);
                        if (this.#dateTimePromise) {
                            const modificationDate = document.createElement("span");
                            modificationDate.classList.add("popupDate");
                            this.#dateTimePromise.then((localized)=>{
                                modificationDate.textContent = localized;
                            });
                            header.append(modificationDate);
                        }
                        const contentsObj = this.#contentsObj;
                        const richText = this.#richText;
                        if (richText?.str && (!contentsObj?.str || contentsObj.str === richText.str)) {
                            _xfa_layer.XfaLayer.render({
                                xfaHtml: richText.html,
                                intent: "richText",
                                div: popup
                            });
                            popup.lastChild.classList.add("richText", "popupContent");
                        } else {
                            const contents = this._formatContents(contentsObj);
                            popup.append(contents);
                        }
                        let useParentRect = !!this.#parentRect;
                        let rect = useParentRect ? this.#parentRect : this.#rect;
                        for (const element of this.#elements)if (!rect || _util.Util.intersect(element.data.rect, rect) !== null) {
                            rect = element.data.rect;
                            useParentRect = true;
                            break;
                        }
                        const normalizedRect = _util.Util.normalizeRect([
                            rect[0],
                            view[3] - rect[1] + view[1],
                            rect[2],
                            view[3] - rect[3] + view[1]
                        ]);
                        const HORIZONTAL_SPACE_AFTER_ANNOTATION = 5;
                        const parentWidth = useParentRect ? rect[2] - rect[0] + HORIZONTAL_SPACE_AFTER_ANNOTATION : 0;
                        const popupLeft = normalizedRect[0] + parentWidth;
                        const popupTop = normalizedRect[1];
                        const { style } = this.#container;
                        style.left = `${100 * (popupLeft - pageX) / pageWidth}%`;
                        style.top = `${100 * (popupTop - pageY) / pageHeight}%`;
                        this.#container.append(popup);
                    }
                    _formatContents({ str, dir }) {
                        const p = document.createElement("p");
                        p.classList.add("popupContent");
                        p.dir = dir;
                        const lines = str.split(/(?:\r\n?|\n)/);
                        for(let i = 0, ii = lines.length; i < ii; ++i){
                            const line = lines[i];
                            p.append(document.createTextNode(line));
                            if (i < ii - 1) p.append(document.createElement("br"));
                        }
                        return p;
                    }
                    #keyDown(event) {
                        if (event.altKey || event.shiftKey || event.ctrlKey || event.metaKey) return;
                        if (event.key === "Enter" || event.key === "Escape" && this.#pinned) this.#toggle();
                    }
                    #toggle() {
                        this.#pinned = !this.#pinned;
                        if (this.#pinned) {
                            this.#show();
                            this.#container.addEventListener("click", this.#boundToggle);
                            this.#container.addEventListener("keydown", this.#boundKeyDown);
                        } else {
                            this.#hide();
                            this.#container.removeEventListener("click", this.#boundToggle);
                            this.#container.removeEventListener("keydown", this.#boundKeyDown);
                        }
                    }
                    #show() {
                        if (!this.#popup) this.render();
                        if (!this.isVisible) {
                            this.#container.hidden = false;
                            this.#container.style.zIndex = parseInt(this.#container.style.zIndex) + 1000;
                        } else if (this.#pinned) this.#container.classList.add("focused");
                    }
                    #hide() {
                        this.#container.classList.remove("focused");
                        if (this.#pinned || !this.isVisible) return;
                        this.#container.hidden = true;
                        this.#container.style.zIndex = parseInt(this.#container.style.zIndex) - 1000;
                    }
                    forceHide() {
                        this.#wasVisible = this.isVisible;
                        if (!this.#wasVisible) return;
                        this.#container.hidden = true;
                    }
                    maybeShow() {
                        if (!this.#wasVisible) return;
                        this.#wasVisible = false;
                        this.#container.hidden = false;
                    }
                    get isVisible() {
                        return this.#container.hidden === false;
                    }
                }
                class FreeTextAnnotationElement extends AnnotationElement {
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: true,
                            ignoreBorder: true
                        });
                        this.textContent = parameters.data.textContent;
                        this.textPosition = parameters.data.textPosition;
                        this.annotationEditorType = _util.AnnotationEditorType.FREETEXT;
                    }
                    render() {
                        this.container.classList.add("freeTextAnnotation");
                        if (this.textContent) {
                            const content = document.createElement("div");
                            content.classList.add("annotationTextContent");
                            content.setAttribute("role", "comment");
                            for (const line of this.textContent){
                                const lineSpan = document.createElement("span");
                                lineSpan.textContent = line;
                                content.append(lineSpan);
                            }
                            this.container.append(content);
                        }
                        if (!this.data.popupRef && this.hasPopupData) this._createPopup();
                        this._editOnDoubleClick();
                        return this.container;
                    }
                }
                exports.FreeTextAnnotationElement = FreeTextAnnotationElement;
                class LineAnnotationElement extends AnnotationElement {
                    #line = null;
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: true,
                            ignoreBorder: true
                        });
                    }
                    render() {
                        this.container.classList.add("lineAnnotation");
                        const data = this.data;
                        const { width, height } = getRectDims(data.rect);
                        const svg = this.svgFactory.create(width, height, true);
                        const line = this.#line = this.svgFactory.createElement("svg:line");
                        line.setAttribute("x1", data.rect[2] - data.lineCoordinates[0]);
                        line.setAttribute("y1", data.rect[3] - data.lineCoordinates[1]);
                        line.setAttribute("x2", data.rect[2] - data.lineCoordinates[2]);
                        line.setAttribute("y2", data.rect[3] - data.lineCoordinates[3]);
                        line.setAttribute("stroke-width", data.borderStyle.width || 1);
                        line.setAttribute("stroke", "transparent");
                        line.setAttribute("fill", "transparent");
                        svg.append(line);
                        this.container.append(svg);
                        if (!data.popupRef && this.hasPopupData) this._createPopup();
                        return this.container;
                    }
                    getElementsToTriggerPopup() {
                        return this.#line;
                    }
                    addHighlightArea() {
                        this.container.classList.add("highlightArea");
                    }
                }
                class SquareAnnotationElement extends AnnotationElement {
                    #square = null;
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: true,
                            ignoreBorder: true
                        });
                    }
                    render() {
                        this.container.classList.add("squareAnnotation");
                        const data = this.data;
                        const { width, height } = getRectDims(data.rect);
                        const svg = this.svgFactory.create(width, height, true);
                        const borderWidth = data.borderStyle.width;
                        const square = this.#square = this.svgFactory.createElement("svg:rect");
                        square.setAttribute("x", borderWidth / 2);
                        square.setAttribute("y", borderWidth / 2);
                        square.setAttribute("width", width - borderWidth);
                        square.setAttribute("height", height - borderWidth);
                        square.setAttribute("stroke-width", borderWidth || 1);
                        square.setAttribute("stroke", "transparent");
                        square.setAttribute("fill", "transparent");
                        svg.append(square);
                        this.container.append(svg);
                        if (!data.popupRef && this.hasPopupData) this._createPopup();
                        return this.container;
                    }
                    getElementsToTriggerPopup() {
                        return this.#square;
                    }
                    addHighlightArea() {
                        this.container.classList.add("highlightArea");
                    }
                }
                class CircleAnnotationElement extends AnnotationElement {
                    #circle = null;
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: true,
                            ignoreBorder: true
                        });
                    }
                    render() {
                        this.container.classList.add("circleAnnotation");
                        const data = this.data;
                        const { width, height } = getRectDims(data.rect);
                        const svg = this.svgFactory.create(width, height, true);
                        const borderWidth = data.borderStyle.width;
                        const circle = this.#circle = this.svgFactory.createElement("svg:ellipse");
                        circle.setAttribute("cx", width / 2);
                        circle.setAttribute("cy", height / 2);
                        circle.setAttribute("rx", width / 2 - borderWidth / 2);
                        circle.setAttribute("ry", height / 2 - borderWidth / 2);
                        circle.setAttribute("stroke-width", borderWidth || 1);
                        circle.setAttribute("stroke", "transparent");
                        circle.setAttribute("fill", "transparent");
                        svg.append(circle);
                        this.container.append(svg);
                        if (!data.popupRef && this.hasPopupData) this._createPopup();
                        return this.container;
                    }
                    getElementsToTriggerPopup() {
                        return this.#circle;
                    }
                    addHighlightArea() {
                        this.container.classList.add("highlightArea");
                    }
                }
                class PolylineAnnotationElement extends AnnotationElement {
                    #polyline = null;
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: true,
                            ignoreBorder: true
                        });
                        this.containerClassName = "polylineAnnotation";
                        this.svgElementName = "svg:polyline";
                    }
                    render() {
                        this.container.classList.add(this.containerClassName);
                        const data = this.data;
                        const { width, height } = getRectDims(data.rect);
                        const svg = this.svgFactory.create(width, height, true);
                        let points = [];
                        for (const coordinate of data.vertices){
                            const x = coordinate.x - data.rect[0];
                            const y = data.rect[3] - coordinate.y;
                            points.push(x + "," + y);
                        }
                        points = points.join(" ");
                        const polyline = this.#polyline = this.svgFactory.createElement(this.svgElementName);
                        polyline.setAttribute("points", points);
                        polyline.setAttribute("stroke-width", data.borderStyle.width || 1);
                        polyline.setAttribute("stroke", "transparent");
                        polyline.setAttribute("fill", "transparent");
                        svg.append(polyline);
                        this.container.append(svg);
                        if (!data.popupRef && this.hasPopupData) this._createPopup();
                        return this.container;
                    }
                    getElementsToTriggerPopup() {
                        return this.#polyline;
                    }
                    addHighlightArea() {
                        this.container.classList.add("highlightArea");
                    }
                }
                class PolygonAnnotationElement extends PolylineAnnotationElement {
                    constructor(parameters){
                        super(parameters);
                        this.containerClassName = "polygonAnnotation";
                        this.svgElementName = "svg:polygon";
                    }
                }
                class CaretAnnotationElement extends AnnotationElement {
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: true,
                            ignoreBorder: true
                        });
                    }
                    render() {
                        this.container.classList.add("caretAnnotation");
                        if (!this.data.popupRef && this.hasPopupData) this._createPopup();
                        return this.container;
                    }
                }
                class InkAnnotationElement extends AnnotationElement {
                    #polylines = [];
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: true,
                            ignoreBorder: true
                        });
                        this.containerClassName = "inkAnnotation";
                        this.svgElementName = "svg:polyline";
                        this.annotationEditorType = _util.AnnotationEditorType.INK;
                    }
                    render() {
                        this.container.classList.add(this.containerClassName);
                        const data = this.data;
                        const { width, height } = getRectDims(data.rect);
                        const svg = this.svgFactory.create(width, height, true);
                        for (const inkList of data.inkLists){
                            let points = [];
                            for (const coordinate of inkList){
                                const x = coordinate.x - data.rect[0];
                                const y = data.rect[3] - coordinate.y;
                                points.push(`${x},${y}`);
                            }
                            points = points.join(" ");
                            const polyline = this.svgFactory.createElement(this.svgElementName);
                            this.#polylines.push(polyline);
                            polyline.setAttribute("points", points);
                            polyline.setAttribute("stroke-width", data.borderStyle.width || 1);
                            polyline.setAttribute("stroke", "transparent");
                            polyline.setAttribute("fill", "transparent");
                            if (!data.popupRef && this.hasPopupData) this._createPopup();
                            svg.append(polyline);
                        }
                        this.container.append(svg);
                        return this.container;
                    }
                    getElementsToTriggerPopup() {
                        return this.#polylines;
                    }
                    addHighlightArea() {
                        this.container.classList.add("highlightArea");
                    }
                }
                exports.InkAnnotationElement = InkAnnotationElement;
                class HighlightAnnotationElement extends AnnotationElement {
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: true,
                            ignoreBorder: true,
                            createQuadrilaterals: true
                        });
                    }
                    render() {
                        if (!this.data.popupRef && this.hasPopupData) this._createPopup();
                        this.container.classList.add("highlightAnnotation");
                        return this.container;
                    }
                }
                class UnderlineAnnotationElement extends AnnotationElement {
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: true,
                            ignoreBorder: true,
                            createQuadrilaterals: true
                        });
                    }
                    render() {
                        if (!this.data.popupRef && this.hasPopupData) this._createPopup();
                        this.container.classList.add("underlineAnnotation");
                        return this.container;
                    }
                }
                class SquigglyAnnotationElement extends AnnotationElement {
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: true,
                            ignoreBorder: true,
                            createQuadrilaterals: true
                        });
                    }
                    render() {
                        if (!this.data.popupRef && this.hasPopupData) this._createPopup();
                        this.container.classList.add("squigglyAnnotation");
                        return this.container;
                    }
                }
                class StrikeOutAnnotationElement extends AnnotationElement {
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: true,
                            ignoreBorder: true,
                            createQuadrilaterals: true
                        });
                    }
                    render() {
                        if (!this.data.popupRef && this.hasPopupData) this._createPopup();
                        this.container.classList.add("strikeoutAnnotation");
                        return this.container;
                    }
                }
                class StampAnnotationElement extends AnnotationElement {
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: true,
                            ignoreBorder: true
                        });
                    }
                    render() {
                        this.container.classList.add("stampAnnotation");
                        if (!this.data.popupRef && this.hasPopupData) this._createPopup();
                        return this.container;
                    }
                }
                exports.StampAnnotationElement = StampAnnotationElement;
                class FileAttachmentAnnotationElement extends AnnotationElement {
                    #trigger = null;
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: true
                        });
                        const { filename, content } = this.data.file;
                        this.filename = (0, _display_utils.getFilenameFromUrl)(filename, true);
                        this.content = content;
                        this.linkService.eventBus?.dispatch("fileattachmentannotation", {
                            source: this,
                            filename: filename,
                            content: content
                        });
                    }
                    render() {
                        this.container.classList.add("fileAttachmentAnnotation");
                        const { container, data } = this;
                        let trigger;
                        if (data.hasAppearance || data.fillAlpha === 0) trigger = document.createElement("div");
                        else {
                            trigger = document.createElement("img");
                            trigger.src = `${this.imageResourcesPath}annotation-${/paperclip/i.test(data.name) ? "paperclip" : "pushpin"}.svg`;
                            if (data.fillAlpha && data.fillAlpha < 1) trigger.style = `filter: opacity(${Math.round(data.fillAlpha * 100)}%);`;
                        }
                        trigger.addEventListener("dblclick", this.#download.bind(this));
                        this.#trigger = trigger;
                        const { isMac } = _util.FeatureTest.platform;
                        container.addEventListener("keydown", (evt)=>{
                            if (evt.key === "Enter" && (isMac ? evt.metaKey : evt.ctrlKey)) this.#download();
                        });
                        if (!data.popupRef && this.hasPopupData) this._createPopup();
                        else trigger.classList.add("popupTriggerArea");
                        container.append(trigger);
                        return container;
                    }
                    getElementsToTriggerPopup() {
                        return this.#trigger;
                    }
                    addHighlightArea() {
                        this.container.classList.add("highlightArea");
                    }
                    #download() {
                        this.downloadManager?.openOrDownloadData(this.container, this.content, this.filename);
                    }
                }
                class AnnotationLayer {
                    #accessibilityManager = null;
                    #annotationCanvasMap = null;
                    #editableAnnotations = new Map();
                    constructor({ div, accessibilityManager, annotationCanvasMap, l10n, page, viewport }){
                        this.div = div;
                        this.#accessibilityManager = accessibilityManager;
                        this.#annotationCanvasMap = annotationCanvasMap;
                        this.l10n = l10n;
                        this.page = page;
                        this.viewport = viewport;
                        this.zIndex = 0;
                        this.l10n ||= _displayL10n_utils.NullL10n;
                    }
                    #appendElement(element, id) {
                        const contentElement = element.firstChild || element;
                        contentElement.id = `${_util.AnnotationPrefix}${id}`;
                        this.div.append(element);
                        this.#accessibilityManager?.moveElementInDOM(this.div, element, contentElement, false);
                    }
                    async render(params) {
                        const { annotations } = params;
                        const layer = this.div;
                        (0, _display_utils.setLayerDimensions)(layer, this.viewport);
                        const popupToElements = new Map();
                        const elementParams = {
                            data: null,
                            layer: layer,
                            linkService: params.linkService,
                            downloadManager: params.downloadManager,
                            imageResourcesPath: params.imageResourcesPath || "",
                            renderForms: params.renderForms !== false,
                            svgFactory: new _display_utils.DOMSVGFactory(),
                            annotationStorage: params.annotationStorage || new _annotation_storage.AnnotationStorage(),
                            enableScripting: params.enableScripting === true,
                            hasJSActions: params.hasJSActions,
                            fieldObjects: params.fieldObjects,
                            parent: this,
                            elements: null
                        };
                        for (const data of annotations){
                            if (data.noHTML) continue;
                            const isPopupAnnotation = data.annotationType === _util.AnnotationType.POPUP;
                            if (!isPopupAnnotation) {
                                const { width, height } = getRectDims(data.rect);
                                if (width <= 0 || height <= 0) continue;
                            } else {
                                const elements = popupToElements.get(data.id);
                                if (!elements) continue;
                                elementParams.elements = elements;
                            }
                            elementParams.data = data;
                            const element = AnnotationElementFactory.create(elementParams);
                            if (!element.isRenderable) continue;
                            if (!isPopupAnnotation && data.popupRef) {
                                const elements = popupToElements.get(data.popupRef);
                                if (!elements) popupToElements.set(data.popupRef, [
                                    element
                                ]);
                                else elements.push(element);
                            }
                            if (element.annotationEditorType > 0) this.#editableAnnotations.set(element.data.id, element);
                            const rendered = element.render();
                            if (data.hidden) rendered.style.visibility = "hidden";
                            this.#appendElement(rendered, data.id);
                        }
                        this.#setAnnotationCanvasMap();
                        await this.l10n.translate(layer);
                    }
                    update({ viewport }) {
                        const layer = this.div;
                        this.viewport = viewport;
                        (0, _display_utils.setLayerDimensions)(layer, {
                            rotation: viewport.rotation
                        });
                        this.#setAnnotationCanvasMap();
                        layer.hidden = false;
                    }
                    #setAnnotationCanvasMap() {
                        if (!this.#annotationCanvasMap) return;
                        const layer = this.div;
                        for (const [id, canvas] of this.#annotationCanvasMap){
                            const element = layer.querySelector(`[data-annotation-id="${id}"]`);
                            if (!element) continue;
                            const { firstChild } = element;
                            if (!firstChild) element.append(canvas);
                            else if (firstChild.nodeName === "CANVAS") firstChild.replaceWith(canvas);
                            else firstChild.before(canvas);
                        }
                        this.#annotationCanvasMap.clear();
                    }
                    getEditableAnnotations() {
                        return Array.from(this.#editableAnnotations.values());
                    }
                    getEditableAnnotation(id) {
                        return this.#editableAnnotations.get(id);
                    }
                }
                exports.AnnotationLayer = AnnotationLayer;
            /***/ },
            /* 30 */ /***/ (__unused_webpack_module, exports)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.ColorConverters = void 0;
                function makeColorComp(n) {
                    return Math.floor(Math.max(0, Math.min(1, n)) * 255).toString(16).padStart(2, "0");
                }
                function scaleAndClamp(x) {
                    return Math.max(0, Math.min(255, 255 * x));
                }
                class ColorConverters {
                    static CMYK_G([c, y, m, k]) {
                        return [
                            "G",
                            1 - Math.min(1, 0.3 * c + 0.59 * m + 0.11 * y + k)
                        ];
                    }
                    static G_CMYK([g]) {
                        return [
                            "CMYK",
                            0,
                            0,
                            0,
                            1 - g
                        ];
                    }
                    static G_RGB([g]) {
                        return [
                            "RGB",
                            g,
                            g,
                            g
                        ];
                    }
                    static G_rgb([g]) {
                        g = scaleAndClamp(g);
                        return [
                            g,
                            g,
                            g
                        ];
                    }
                    static G_HTML([g]) {
                        const G = makeColorComp(g);
                        return `#${G}${G}${G}`;
                    }
                    static RGB_G([r, g, b]) {
                        return [
                            "G",
                            0.3 * r + 0.59 * g + 0.11 * b
                        ];
                    }
                    static RGB_rgb(color) {
                        return color.map(scaleAndClamp);
                    }
                    static RGB_HTML(color) {
                        return `#${color.map(makeColorComp).join("")}`;
                    }
                    static T_HTML() {
                        return "#00000000";
                    }
                    static T_rgb() {
                        return [
                            null
                        ];
                    }
                    static CMYK_RGB([c, y, m, k]) {
                        return [
                            "RGB",
                            1 - Math.min(1, c + k),
                            1 - Math.min(1, m + k),
                            1 - Math.min(1, y + k)
                        ];
                    }
                    static CMYK_rgb([c, y, m, k]) {
                        return [
                            scaleAndClamp(1 - Math.min(1, c + k)),
                            scaleAndClamp(1 - Math.min(1, m + k)),
                            scaleAndClamp(1 - Math.min(1, y + k))
                        ];
                    }
                    static CMYK_HTML(components) {
                        const rgb = this.CMYK_RGB(components).slice(1);
                        return this.RGB_HTML(rgb);
                    }
                    static RGB_CMYK([r, g, b]) {
                        const c = 1 - r;
                        const m = 1 - g;
                        const y = 1 - b;
                        const k = Math.min(c, m, y);
                        return [
                            "CMYK",
                            c,
                            m,
                            y,
                            k
                        ];
                    }
                }
                exports.ColorConverters = ColorConverters;
            /***/ },
            /* 31 */ /***/ (__unused_webpack_module, exports)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.NullL10n = void 0;
                exports.getL10nFallback = getL10nFallback;
                const DEFAULT_L10N_STRINGS = {
                    of_pages: "of {{pagesCount}}",
                    page_of_pages: "({{pageNumber}} of {{pagesCount}})",
                    document_properties_kb: "{{size_kb}} KB ({{size_b}} bytes)",
                    document_properties_mb: "{{size_mb}} MB ({{size_b}} bytes)",
                    document_properties_date_string: "{{date}}, {{time}}",
                    document_properties_page_size_unit_inches: "in",
                    document_properties_page_size_unit_millimeters: "mm",
                    document_properties_page_size_orientation_portrait: "portrait",
                    document_properties_page_size_orientation_landscape: "landscape",
                    document_properties_page_size_name_a3: "A3",
                    document_properties_page_size_name_a4: "A4",
                    document_properties_page_size_name_letter: "Letter",
                    document_properties_page_size_name_legal: "Legal",
                    document_properties_page_size_dimension_string: "{{width}} \xd7 {{height}} {{unit}} ({{orientation}})",
                    document_properties_page_size_dimension_name_string: "{{width}} \xd7 {{height}} {{unit}} ({{name}}, {{orientation}})",
                    document_properties_linearized_yes: "Yes",
                    document_properties_linearized_no: "No",
                    additional_layers: "Additional Layers",
                    page_landmark: "Page {{page}}",
                    thumb_page_title: "Page {{page}}",
                    thumb_page_canvas: "Thumbnail of Page {{page}}",
                    find_reached_top: "Reached top of document, continued from bottom",
                    find_reached_bottom: "Reached end of document, continued from top",
                    "find_match_count[one]": "{{current}} of {{total}} match",
                    "find_match_count[other]": "{{current}} of {{total}} matches",
                    "find_match_count_limit[one]": "More than {{limit}} match",
                    "find_match_count_limit[other]": "More than {{limit}} matches",
                    find_not_found: "Phrase not found",
                    page_scale_width: "Page Width",
                    page_scale_fit: "Page Fit",
                    page_scale_auto: "Automatic Zoom",
                    page_scale_actual: "Actual Size",
                    page_scale_percent: "{{scale}}%",
                    loading_error: "An error occurred while loading the PDF.",
                    invalid_file_error: "Invalid or corrupted PDF file.",
                    missing_file_error: "Missing PDF file.",
                    unexpected_response_error: "Unexpected server response.",
                    rendering_error: "An error occurred while rendering the page.",
                    annotation_date_string: "{{date}}, {{time}}",
                    printing_not_supported: "Warning: Printing is not fully supported by this browser.",
                    printing_not_ready: "Warning: The PDF is not fully loaded for printing.",
                    web_fonts_disabled: "Web fonts are disabled: unable to use embedded PDF fonts.",
                    free_text2_default_content: "Start typing\u2026",
                    editor_free_text2_aria_label: "Text Editor",
                    editor_ink2_aria_label: "Draw Editor",
                    editor_ink_canvas_aria_label: "User-created image",
                    editor_alt_text_button_label: "Alt text",
                    editor_alt_text_edit_button_label: "Edit alt text",
                    editor_alt_text_decorative_tooltip: "Marked as decorative"
                };
                DEFAULT_L10N_STRINGS.print_progress_percent = "{{progress}}%";
                function getL10nFallback(key, args) {
                    switch(key){
                        case "find_match_count":
                            key = `find_match_count[${args.total === 1 ? "one" : "other"}]`;
                            break;
                        case "find_match_count_limit":
                            key = `find_match_count_limit[${args.limit === 1 ? "one" : "other"}]`;
                            break;
                    }
                    return DEFAULT_L10N_STRINGS[key] || "";
                }
                function formatL10nValue(text, args) {
                    if (!args) return text;
                    return text.replaceAll(/\{\{\s*(\w+)\s*\}\}/g, (all, name)=>{
                        return name in args ? args[name] : "{{" + name + "}}";
                    });
                }
                const NullL10n = {
                    async getLanguage () {
                        return "en-us";
                    },
                    async getDirection () {
                        return "ltr";
                    },
                    async get (key, args = null, fallback = getL10nFallback(key, args)) {
                        return formatL10nValue(fallback, args);
                    },
                    async translate (element) {}
                };
                exports.NullL10n = NullL10n;
            /***/ },
            /* 32 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.XfaLayer = void 0;
                var _xfa_text = __w_pdfjs_require__(25);
                class XfaLayer {
                    static setupStorage(html, id, element, storage, intent) {
                        const storedData = storage.getValue(id, {
                            value: null
                        });
                        switch(element.name){
                            case "textarea":
                                if (storedData.value !== null) html.textContent = storedData.value;
                                if (intent === "print") break;
                                html.addEventListener("input", (event)=>{
                                    storage.setValue(id, {
                                        value: event.target.value
                                    });
                                });
                                break;
                            case "input":
                                if (element.attributes.type === "radio" || element.attributes.type === "checkbox") {
                                    if (storedData.value === element.attributes.xfaOn) html.setAttribute("checked", true);
                                    else if (storedData.value === element.attributes.xfaOff) html.removeAttribute("checked");
                                    if (intent === "print") break;
                                    html.addEventListener("change", (event)=>{
                                        storage.setValue(id, {
                                            value: event.target.checked ? event.target.getAttribute("xfaOn") : event.target.getAttribute("xfaOff")
                                        });
                                    });
                                } else {
                                    if (storedData.value !== null) html.setAttribute("value", storedData.value);
                                    if (intent === "print") break;
                                    html.addEventListener("input", (event)=>{
                                        storage.setValue(id, {
                                            value: event.target.value
                                        });
                                    });
                                }
                                break;
                            case "select":
                                if (storedData.value !== null) {
                                    html.setAttribute("value", storedData.value);
                                    for (const option of element.children){
                                        if (option.attributes.value === storedData.value) option.attributes.selected = true;
                                        else if (option.attributes.hasOwnProperty("selected")) delete option.attributes.selected;
                                    }
                                }
                                html.addEventListener("input", (event)=>{
                                    const options = event.target.options;
                                    const value = options.selectedIndex === -1 ? "" : options[options.selectedIndex].value;
                                    storage.setValue(id, {
                                        value: value
                                    });
                                });
                                break;
                        }
                    }
                    static setAttributes({ html, element, storage = null, intent, linkService }) {
                        const { attributes } = element;
                        const isHTMLAnchorElement = html instanceof HTMLAnchorElement;
                        if (attributes.type === "radio") attributes.name = `${attributes.name}-${intent}`;
                        for (const [key, value] of Object.entries(attributes)){
                            if (value === null || value === undefined) continue;
                            switch(key){
                                case "class":
                                    if (value.length) html.setAttribute(key, value.join(" "));
                                    break;
                                case "dataId":
                                    break;
                                case "id":
                                    html.setAttribute("data-element-id", value);
                                    break;
                                case "style":
                                    Object.assign(html.style, value);
                                    break;
                                case "textContent":
                                    html.textContent = value;
                                    break;
                                default:
                                    if (!isHTMLAnchorElement || key !== "href" && key !== "newWindow") html.setAttribute(key, value);
                            }
                        }
                        if (isHTMLAnchorElement) linkService.addLinkAttributes(html, attributes.href, attributes.newWindow);
                        if (storage && attributes.dataId) this.setupStorage(html, attributes.dataId, element, storage);
                    }
                    static render(parameters) {
                        const storage = parameters.annotationStorage;
                        const linkService = parameters.linkService;
                        const root = parameters.xfaHtml;
                        const intent = parameters.intent || "display";
                        const rootHtml = document.createElement(root.name);
                        if (root.attributes) this.setAttributes({
                            html: rootHtml,
                            element: root,
                            intent: intent,
                            linkService: linkService
                        });
                        const stack = [
                            [
                                root,
                                -1,
                                rootHtml
                            ]
                        ];
                        const rootDiv = parameters.div;
                        rootDiv.append(rootHtml);
                        if (parameters.viewport) {
                            const transform = `matrix(${parameters.viewport.transform.join(",")})`;
                            rootDiv.style.transform = transform;
                        }
                        if (intent !== "richText") rootDiv.setAttribute("class", "xfaLayer xfaFont");
                        const textDivs = [];
                        while(stack.length > 0){
                            const [parent, i, html] = stack.at(-1);
                            if (i + 1 === parent.children.length) {
                                stack.pop();
                                continue;
                            }
                            const child = parent.children[++stack.at(-1)[1]];
                            if (child === null) continue;
                            const { name } = child;
                            if (name === "#text") {
                                const node = document.createTextNode(child.value);
                                textDivs.push(node);
                                html.append(node);
                                continue;
                            }
                            const childHtml = child?.attributes?.xmlns ? document.createElementNS(child.attributes.xmlns, name) : document.createElement(name);
                            html.append(childHtml);
                            if (child.attributes) this.setAttributes({
                                html: childHtml,
                                element: child,
                                storage: storage,
                                intent: intent,
                                linkService: linkService
                            });
                            if (child.children && child.children.length > 0) stack.push([
                                child,
                                -1,
                                childHtml
                            ]);
                            else if (child.value) {
                                const node = document.createTextNode(child.value);
                                if (_xfa_text.XfaText.shouldBuildText(name)) textDivs.push(node);
                                childHtml.append(node);
                            }
                        }
                        for (const el of rootDiv.querySelectorAll(".xfaNonInteractive input, .xfaNonInteractive textarea"))el.setAttribute("readOnly", true);
                        return {
                            textDivs: textDivs
                        };
                    }
                    static update(parameters) {
                        const transform = `matrix(${parameters.viewport.transform.join(",")})`;
                        parameters.div.style.transform = transform;
                        parameters.div.hidden = false;
                    }
                }
                exports.XfaLayer = XfaLayer;
            /***/ },
            /* 33 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.InkEditor = void 0;
                var _util = __w_pdfjs_require__(1);
                var _editor = __w_pdfjs_require__(4);
                var _annotation_layer = __w_pdfjs_require__(29);
                var _display_utils = __w_pdfjs_require__(6);
                var _tools = __w_pdfjs_require__(5);
                class InkEditor extends _editor.AnnotationEditor {
                    #baseHeight = 0;
                    #baseWidth = 0;
                    #boundCanvasPointermove = this.canvasPointermove.bind(this);
                    #boundCanvasPointerleave = this.canvasPointerleave.bind(this);
                    #boundCanvasPointerup = this.canvasPointerup.bind(this);
                    #boundCanvasPointerdown = this.canvasPointerdown.bind(this);
                    #currentPath2D = new Path2D();
                    #disableEditing = false;
                    #hasSomethingToDraw = false;
                    #isCanvasInitialized = false;
                    #observer = null;
                    #realWidth = 0;
                    #realHeight = 0;
                    #requestFrameCallback = null;
                    static _defaultColor = null;
                    static _defaultOpacity = 1;
                    static _defaultThickness = 1;
                    static _type = "ink";
                    constructor(params){
                        super({
                            ...params,
                            name: "inkEditor"
                        });
                        this.color = params.color || null;
                        this.thickness = params.thickness || null;
                        this.opacity = params.opacity || null;
                        this.paths = [];
                        this.bezierPath2D = [];
                        this.allRawPaths = [];
                        this.currentPath = [];
                        this.scaleFactor = 1;
                        this.translationX = this.translationY = 0;
                        this.x = 0;
                        this.y = 0;
                        this._willKeepAspectRatio = true;
                    }
                    static initialize(l10n) {
                        _editor.AnnotationEditor.initialize(l10n, {
                            strings: [
                                "editor_ink_canvas_aria_label",
                                "editor_ink2_aria_label"
                            ]
                        });
                    }
                    static updateDefaultParams(type, value) {
                        switch(type){
                            case _util.AnnotationEditorParamsType.INK_THICKNESS:
                                InkEditor._defaultThickness = value;
                                break;
                            case _util.AnnotationEditorParamsType.INK_COLOR:
                                InkEditor._defaultColor = value;
                                break;
                            case _util.AnnotationEditorParamsType.INK_OPACITY:
                                InkEditor._defaultOpacity = value / 100;
                                break;
                        }
                    }
                    updateParams(type, value) {
                        switch(type){
                            case _util.AnnotationEditorParamsType.INK_THICKNESS:
                                this.#updateThickness(value);
                                break;
                            case _util.AnnotationEditorParamsType.INK_COLOR:
                                this.#updateColor(value);
                                break;
                            case _util.AnnotationEditorParamsType.INK_OPACITY:
                                this.#updateOpacity(value);
                                break;
                        }
                    }
                    static get defaultPropertiesToUpdate() {
                        return [
                            [
                                _util.AnnotationEditorParamsType.INK_THICKNESS,
                                InkEditor._defaultThickness
                            ],
                            [
                                _util.AnnotationEditorParamsType.INK_COLOR,
                                InkEditor._defaultColor || _editor.AnnotationEditor._defaultLineColor
                            ],
                            [
                                _util.AnnotationEditorParamsType.INK_OPACITY,
                                Math.round(InkEditor._defaultOpacity * 100)
                            ]
                        ];
                    }
                    get propertiesToUpdate() {
                        return [
                            [
                                _util.AnnotationEditorParamsType.INK_THICKNESS,
                                this.thickness || InkEditor._defaultThickness
                            ],
                            [
                                _util.AnnotationEditorParamsType.INK_COLOR,
                                this.color || InkEditor._defaultColor || _editor.AnnotationEditor._defaultLineColor
                            ],
                            [
                                _util.AnnotationEditorParamsType.INK_OPACITY,
                                Math.round(100 * (this.opacity ?? InkEditor._defaultOpacity))
                            ]
                        ];
                    }
                    #updateThickness(thickness) {
                        const savedThickness = this.thickness;
                        this.addCommands({
                            cmd: ()=>{
                                this.thickness = thickness;
                                this.#fitToContent();
                            },
                            undo: ()=>{
                                this.thickness = savedThickness;
                                this.#fitToContent();
                            },
                            mustExec: true,
                            type: _util.AnnotationEditorParamsType.INK_THICKNESS,
                            overwriteIfSameType: true,
                            keepUndo: true
                        });
                    }
                    #updateColor(color) {
                        const savedColor = this.color;
                        this.addCommands({
                            cmd: ()=>{
                                this.color = color;
                                this.#redraw();
                            },
                            undo: ()=>{
                                this.color = savedColor;
                                this.#redraw();
                            },
                            mustExec: true,
                            type: _util.AnnotationEditorParamsType.INK_COLOR,
                            overwriteIfSameType: true,
                            keepUndo: true
                        });
                    }
                    #updateOpacity(opacity) {
                        opacity /= 100;
                        const savedOpacity = this.opacity;
                        this.addCommands({
                            cmd: ()=>{
                                this.opacity = opacity;
                                this.#redraw();
                            },
                            undo: ()=>{
                                this.opacity = savedOpacity;
                                this.#redraw();
                            },
                            mustExec: true,
                            type: _util.AnnotationEditorParamsType.INK_OPACITY,
                            overwriteIfSameType: true,
                            keepUndo: true
                        });
                    }
                    rebuild() {
                        if (!this.parent) return;
                        super.rebuild();
                        if (this.div === null) return;
                        if (!this.canvas) {
                            this.#createCanvas();
                            this.#createObserver();
                        }
                        if (!this.isAttachedToDOM) {
                            this.parent.add(this);
                            this.#setCanvasDims();
                        }
                        this.#fitToContent();
                    }
                    remove() {
                        if (this.canvas === null) return;
                        if (!this.isEmpty()) this.commit();
                        this.canvas.width = this.canvas.height = 0;
                        this.canvas.remove();
                        this.canvas = null;
                        this.#observer.disconnect();
                        this.#observer = null;
                        super.remove();
                    }
                    setParent(parent) {
                        if (!this.parent && parent) this._uiManager.removeShouldRescale(this);
                        else if (this.parent && parent === null) this._uiManager.addShouldRescale(this);
                        super.setParent(parent);
                    }
                    onScaleChanging() {
                        const [parentWidth, parentHeight] = this.parentDimensions;
                        const width = this.width * parentWidth;
                        const height = this.height * parentHeight;
                        this.setDimensions(width, height);
                    }
                    enableEditMode() {
                        if (this.#disableEditing || this.canvas === null) return;
                        super.enableEditMode();
                        this._isDraggable = false;
                        this.canvas.addEventListener("pointerdown", this.#boundCanvasPointerdown);
                    }
                    disableEditMode() {
                        if (!this.isInEditMode() || this.canvas === null) return;
                        super.disableEditMode();
                        this._isDraggable = !this.isEmpty();
                        this.div.classList.remove("editing");
                        this.canvas.removeEventListener("pointerdown", this.#boundCanvasPointerdown);
                    }
                    onceAdded() {
                        this._isDraggable = !this.isEmpty();
                    }
                    isEmpty() {
                        return this.paths.length === 0 || this.paths.length === 1 && this.paths[0].length === 0;
                    }
                    #getInitialBBox() {
                        const { parentRotation, parentDimensions: [width, height] } = this;
                        switch(parentRotation){
                            case 90:
                                return [
                                    0,
                                    height,
                                    height,
                                    width
                                ];
                            case 180:
                                return [
                                    width,
                                    height,
                                    width,
                                    height
                                ];
                            case 270:
                                return [
                                    width,
                                    0,
                                    height,
                                    width
                                ];
                            default:
                                return [
                                    0,
                                    0,
                                    width,
                                    height
                                ];
                        }
                    }
                    #setStroke() {
                        const { ctx, color, opacity, thickness, parentScale, scaleFactor } = this;
                        ctx.lineWidth = thickness * parentScale / scaleFactor;
                        ctx.lineCap = "round";
                        ctx.lineJoin = "round";
                        ctx.miterLimit = 10;
                        ctx.strokeStyle = `${color}${(0, _tools.opacityToHex)(opacity)}`;
                    }
                    #startDrawing(x, y) {
                        this.canvas.addEventListener("contextmenu", _display_utils.noContextMenu);
                        this.canvas.addEventListener("pointerleave", this.#boundCanvasPointerleave);
                        this.canvas.addEventListener("pointermove", this.#boundCanvasPointermove);
                        this.canvas.addEventListener("pointerup", this.#boundCanvasPointerup);
                        this.canvas.removeEventListener("pointerdown", this.#boundCanvasPointerdown);
                        this.isEditing = true;
                        if (!this.#isCanvasInitialized) {
                            this.#isCanvasInitialized = true;
                            this.#setCanvasDims();
                            this.thickness ||= InkEditor._defaultThickness;
                            this.color ||= InkEditor._defaultColor || _editor.AnnotationEditor._defaultLineColor;
                            this.opacity ??= InkEditor._defaultOpacity;
                        }
                        this.currentPath.push([
                            x,
                            y
                        ]);
                        this.#hasSomethingToDraw = false;
                        this.#setStroke();
                        this.#requestFrameCallback = ()=>{
                            this.#drawPoints();
                            if (this.#requestFrameCallback) window.requestAnimationFrame(this.#requestFrameCallback);
                        };
                        window.requestAnimationFrame(this.#requestFrameCallback);
                    }
                    #draw(x, y) {
                        const [lastX, lastY] = this.currentPath.at(-1);
                        if (this.currentPath.length > 1 && x === lastX && y === lastY) return;
                        const currentPath = this.currentPath;
                        let path2D = this.#currentPath2D;
                        currentPath.push([
                            x,
                            y
                        ]);
                        this.#hasSomethingToDraw = true;
                        if (currentPath.length <= 2) {
                            path2D.moveTo(...currentPath[0]);
                            path2D.lineTo(x, y);
                            return;
                        }
                        if (currentPath.length === 3) {
                            this.#currentPath2D = path2D = new Path2D();
                            path2D.moveTo(...currentPath[0]);
                        }
                        this.#makeBezierCurve(path2D, ...currentPath.at(-3), ...currentPath.at(-2), x, y);
                    }
                    #endPath() {
                        if (this.currentPath.length === 0) return;
                        const lastPoint = this.currentPath.at(-1);
                        this.#currentPath2D.lineTo(...lastPoint);
                    }
                    #stopDrawing(x, y) {
                        this.#requestFrameCallback = null;
                        x = Math.min(Math.max(x, 0), this.canvas.width);
                        y = Math.min(Math.max(y, 0), this.canvas.height);
                        this.#draw(x, y);
                        this.#endPath();
                        let bezier;
                        if (this.currentPath.length !== 1) bezier = this.#generateBezierPoints();
                        else {
                            const xy = [
                                x,
                                y
                            ];
                            bezier = [
                                [
                                    xy,
                                    xy.slice(),
                                    xy.slice(),
                                    xy
                                ]
                            ];
                        }
                        const path2D = this.#currentPath2D;
                        const currentPath = this.currentPath;
                        this.currentPath = [];
                        this.#currentPath2D = new Path2D();
                        const cmd = ()=>{
                            this.allRawPaths.push(currentPath);
                            this.paths.push(bezier);
                            this.bezierPath2D.push(path2D);
                            this.rebuild();
                        };
                        const undo = ()=>{
                            this.allRawPaths.pop();
                            this.paths.pop();
                            this.bezierPath2D.pop();
                            if (this.paths.length === 0) this.remove();
                            else {
                                if (!this.canvas) {
                                    this.#createCanvas();
                                    this.#createObserver();
                                }
                                this.#fitToContent();
                            }
                        };
                        this.addCommands({
                            cmd: cmd,
                            undo: undo,
                            mustExec: true
                        });
                    }
                    #drawPoints() {
                        if (!this.#hasSomethingToDraw) return;
                        this.#hasSomethingToDraw = false;
                        const thickness = Math.ceil(this.thickness * this.parentScale);
                        const lastPoints = this.currentPath.slice(-3);
                        const x = lastPoints.map((xy)=>xy[0]);
                        const y = lastPoints.map((xy)=>xy[1]);
                        const xMin = Math.min(...x) - thickness;
                        const xMax = Math.max(...x) + thickness;
                        const yMin = Math.min(...y) - thickness;
                        const yMax = Math.max(...y) + thickness;
                        const { ctx } = this;
                        ctx.save();
                        ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
                        for (const path of this.bezierPath2D)ctx.stroke(path);
                        ctx.stroke(this.#currentPath2D);
                        ctx.restore();
                    }
                    #makeBezierCurve(path2D, x0, y0, x1, y1, x2, y2) {
                        const prevX = (x0 + x1) / 2;
                        const prevY = (y0 + y1) / 2;
                        const x3 = (x1 + x2) / 2;
                        const y3 = (y1 + y2) / 2;
                        path2D.bezierCurveTo(prevX + 2 * (x1 - prevX) / 3, prevY + 2 * (y1 - prevY) / 3, x3 + 2 * (x1 - x3) / 3, y3 + 2 * (y1 - y3) / 3, x3, y3);
                    }
                    #generateBezierPoints() {
                        const path = this.currentPath;
                        if (path.length <= 2) return [
                            [
                                path[0],
                                path[0],
                                path.at(-1),
                                path.at(-1)
                            ]
                        ];
                        const bezierPoints = [];
                        let i;
                        let [x0, y0] = path[0];
                        for(i = 1; i < path.length - 2; i++){
                            const [x1, y1] = path[i];
                            const [x2, y2] = path[i + 1];
                            const x3 = (x1 + x2) / 2;
                            const y3 = (y1 + y2) / 2;
                            const control1 = [
                                x0 + 2 * (x1 - x0) / 3,
                                y0 + 2 * (y1 - y0) / 3
                            ];
                            const control2 = [
                                x3 + 2 * (x1 - x3) / 3,
                                y3 + 2 * (y1 - y3) / 3
                            ];
                            bezierPoints.push([
                                [
                                    x0,
                                    y0
                                ],
                                control1,
                                control2,
                                [
                                    x3,
                                    y3
                                ]
                            ]);
                            [x0, y0] = [
                                x3,
                                y3
                            ];
                        }
                        const [x1, y1] = path[i];
                        const [x2, y2] = path[i + 1];
                        const control1 = [
                            x0 + 2 * (x1 - x0) / 3,
                            y0 + 2 * (y1 - y0) / 3
                        ];
                        const control2 = [
                            x2 + 2 * (x1 - x2) / 3,
                            y2 + 2 * (y1 - y2) / 3
                        ];
                        bezierPoints.push([
                            [
                                x0,
                                y0
                            ],
                            control1,
                            control2,
                            [
                                x2,
                                y2
                            ]
                        ]);
                        return bezierPoints;
                    }
                    #redraw() {
                        if (this.isEmpty()) {
                            this.#updateTransform();
                            return;
                        }
                        this.#setStroke();
                        const { canvas, ctx } = this;
                        ctx.setTransform(1, 0, 0, 1, 0, 0);
                        ctx.clearRect(0, 0, canvas.width, canvas.height);
                        this.#updateTransform();
                        for (const path of this.bezierPath2D)ctx.stroke(path);
                    }
                    commit() {
                        if (this.#disableEditing) return;
                        super.commit();
                        this.isEditing = false;
                        this.disableEditMode();
                        this.setInForeground();
                        this.#disableEditing = true;
                        this.div.classList.add("disabled");
                        this.#fitToContent(true);
                        this.makeResizable();
                        this.parent.addInkEditorIfNeeded(true);
                        this.moveInDOM();
                        this.div.focus({
                            preventScroll: true
                        });
                    }
                    focusin(event) {
                        if (!this._focusEventsAllowed) return;
                        super.focusin(event);
                        this.enableEditMode();
                    }
                    canvasPointerdown(event) {
                        if (event.button !== 0 || !this.isInEditMode() || this.#disableEditing) return;
                        this.setInForeground();
                        event.preventDefault();
                        if (event.type !== "mouse") this.div.focus();
                        this.#startDrawing(event.offsetX, event.offsetY);
                    }
                    canvasPointermove(event) {
                        event.preventDefault();
                        this.#draw(event.offsetX, event.offsetY);
                    }
                    canvasPointerup(event) {
                        event.preventDefault();
                        this.#endDrawing(event);
                    }
                    canvasPointerleave(event) {
                        this.#endDrawing(event);
                    }
                    #endDrawing(event) {
                        this.canvas.removeEventListener("pointerleave", this.#boundCanvasPointerleave);
                        this.canvas.removeEventListener("pointermove", this.#boundCanvasPointermove);
                        this.canvas.removeEventListener("pointerup", this.#boundCanvasPointerup);
                        this.canvas.addEventListener("pointerdown", this.#boundCanvasPointerdown);
                        setTimeout(()=>{
                            this.canvas.removeEventListener("contextmenu", _display_utils.noContextMenu);
                        }, 10);
                        this.#stopDrawing(event.offsetX, event.offsetY);
                        this.addToAnnotationStorage();
                        this.setInBackground();
                    }
                    #createCanvas() {
                        this.canvas = document.createElement("canvas");
                        this.canvas.width = this.canvas.height = 0;
                        this.canvas.className = "inkEditorCanvas";
                        _editor.AnnotationEditor._l10nPromise.get("editor_ink_canvas_aria_label").then((msg)=>this.canvas?.setAttribute("aria-label", msg));
                        this.div.append(this.canvas);
                        this.ctx = this.canvas.getContext("2d");
                    }
                    #createObserver() {
                        this.#observer = new ResizeObserver((entries)=>{
                            const rect = entries[0].contentRect;
                            if (rect.width && rect.height) this.setDimensions(rect.width, rect.height);
                        });
                        this.#observer.observe(this.div);
                    }
                    get isResizable() {
                        return !this.isEmpty() && this.#disableEditing;
                    }
                    render() {
                        if (this.div) return this.div;
                        let baseX, baseY;
                        if (this.width) {
                            baseX = this.x;
                            baseY = this.y;
                        }
                        super.render();
                        _editor.AnnotationEditor._l10nPromise.get("editor_ink2_aria_label").then((msg)=>this.div?.setAttribute("aria-label", msg));
                        const [x, y, w, h] = this.#getInitialBBox();
                        this.setAt(x, y, 0, 0);
                        this.setDims(w, h);
                        this.#createCanvas();
                        if (this.width) {
                            const [parentWidth, parentHeight] = this.parentDimensions;
                            this.setAspectRatio(this.width * parentWidth, this.height * parentHeight);
                            this.setAt(baseX * parentWidth, baseY * parentHeight, this.width * parentWidth, this.height * parentHeight);
                            this.#isCanvasInitialized = true;
                            this.#setCanvasDims();
                            this.setDims(this.width * parentWidth, this.height * parentHeight);
                            this.#redraw();
                            this.div.classList.add("disabled");
                        } else {
                            this.div.classList.add("editing");
                            this.enableEditMode();
                        }
                        this.#createObserver();
                        return this.div;
                    }
                    #setCanvasDims() {
                        if (!this.#isCanvasInitialized) return;
                        const [parentWidth, parentHeight] = this.parentDimensions;
                        this.canvas.width = Math.ceil(this.width * parentWidth);
                        this.canvas.height = Math.ceil(this.height * parentHeight);
                        this.#updateTransform();
                    }
                    setDimensions(width, height) {
                        const roundedWidth = Math.round(width);
                        const roundedHeight = Math.round(height);
                        if (this.#realWidth === roundedWidth && this.#realHeight === roundedHeight) return;
                        this.#realWidth = roundedWidth;
                        this.#realHeight = roundedHeight;
                        this.canvas.style.visibility = "hidden";
                        const [parentWidth, parentHeight] = this.parentDimensions;
                        this.width = width / parentWidth;
                        this.height = height / parentHeight;
                        this.fixAndSetPosition();
                        if (this.#disableEditing) this.#setScaleFactor(width, height);
                        this.#setCanvasDims();
                        this.#redraw();
                        this.canvas.style.visibility = "visible";
                        this.fixDims();
                    }
                    #setScaleFactor(width, height) {
                        const padding = this.#getPadding();
                        const scaleFactorW = (width - padding) / this.#baseWidth;
                        const scaleFactorH = (height - padding) / this.#baseHeight;
                        this.scaleFactor = Math.min(scaleFactorW, scaleFactorH);
                    }
                    #updateTransform() {
                        const padding = this.#getPadding() / 2;
                        this.ctx.setTransform(this.scaleFactor, 0, 0, this.scaleFactor, this.translationX * this.scaleFactor + padding, this.translationY * this.scaleFactor + padding);
                    }
                    static #buildPath2D(bezier) {
                        const path2D = new Path2D();
                        for(let i = 0, ii = bezier.length; i < ii; i++){
                            const [first, control1, control2, second] = bezier[i];
                            if (i === 0) path2D.moveTo(...first);
                            path2D.bezierCurveTo(control1[0], control1[1], control2[0], control2[1], second[0], second[1]);
                        }
                        return path2D;
                    }
                    static #toPDFCoordinates(points, rect, rotation) {
                        const [blX, blY, trX, trY] = rect;
                        switch(rotation){
                            case 0:
                                for(let i = 0, ii = points.length; i < ii; i += 2){
                                    points[i] += blX;
                                    points[i + 1] = trY - points[i + 1];
                                }
                                break;
                            case 90:
                                for(let i = 0, ii = points.length; i < ii; i += 2){
                                    const x = points[i];
                                    points[i] = points[i + 1] + blX;
                                    points[i + 1] = x + blY;
                                }
                                break;
                            case 180:
                                for(let i = 0, ii = points.length; i < ii; i += 2){
                                    points[i] = trX - points[i];
                                    points[i + 1] += blY;
                                }
                                break;
                            case 270:
                                for(let i = 0, ii = points.length; i < ii; i += 2){
                                    const x = points[i];
                                    points[i] = trX - points[i + 1];
                                    points[i + 1] = trY - x;
                                }
                                break;
                            default:
                                throw new Error("Invalid rotation");
                        }
                        return points;
                    }
                    static #fromPDFCoordinates(points, rect, rotation) {
                        const [blX, blY, trX, trY] = rect;
                        switch(rotation){
                            case 0:
                                for(let i = 0, ii = points.length; i < ii; i += 2){
                                    points[i] -= blX;
                                    points[i + 1] = trY - points[i + 1];
                                }
                                break;
                            case 90:
                                for(let i = 0, ii = points.length; i < ii; i += 2){
                                    const x = points[i];
                                    points[i] = points[i + 1] - blY;
                                    points[i + 1] = x - blX;
                                }
                                break;
                            case 180:
                                for(let i = 0, ii = points.length; i < ii; i += 2){
                                    points[i] = trX - points[i];
                                    points[i + 1] -= blY;
                                }
                                break;
                            case 270:
                                for(let i = 0, ii = points.length; i < ii; i += 2){
                                    const x = points[i];
                                    points[i] = trY - points[i + 1];
                                    points[i + 1] = trX - x;
                                }
                                break;
                            default:
                                throw new Error("Invalid rotation");
                        }
                        return points;
                    }
                    #serializePaths(s, tx, ty, rect) {
                        const paths = [];
                        const padding = this.thickness / 2;
                        const shiftX = s * tx + padding;
                        const shiftY = s * ty + padding;
                        for (const bezier of this.paths){
                            const buffer = [];
                            const points = [];
                            for(let j = 0, jj = bezier.length; j < jj; j++){
                                const [first, control1, control2, second] = bezier[j];
                                const p10 = s * first[0] + shiftX;
                                const p11 = s * first[1] + shiftY;
                                const p20 = s * control1[0] + shiftX;
                                const p21 = s * control1[1] + shiftY;
                                const p30 = s * control2[0] + shiftX;
                                const p31 = s * control2[1] + shiftY;
                                const p40 = s * second[0] + shiftX;
                                const p41 = s * second[1] + shiftY;
                                if (j === 0) {
                                    buffer.push(p10, p11);
                                    points.push(p10, p11);
                                }
                                buffer.push(p20, p21, p30, p31, p40, p41);
                                points.push(p20, p21);
                                if (j === jj - 1) points.push(p40, p41);
                            }
                            paths.push({
                                bezier: InkEditor.#toPDFCoordinates(buffer, rect, this.rotation),
                                points: InkEditor.#toPDFCoordinates(points, rect, this.rotation)
                            });
                        }
                        return paths;
                    }
                    #getBbox() {
                        let xMin = Infinity;
                        let xMax = -Infinity;
                        let yMin = Infinity;
                        let yMax = -Infinity;
                        for (const path of this.paths)for (const [first, control1, control2, second] of path){
                            const bbox = _util.Util.bezierBoundingBox(...first, ...control1, ...control2, ...second);
                            xMin = Math.min(xMin, bbox[0]);
                            yMin = Math.min(yMin, bbox[1]);
                            xMax = Math.max(xMax, bbox[2]);
                            yMax = Math.max(yMax, bbox[3]);
                        }
                        return [
                            xMin,
                            yMin,
                            xMax,
                            yMax
                        ];
                    }
                    #getPadding() {
                        return this.#disableEditing ? Math.ceil(this.thickness * this.parentScale) : 0;
                    }
                    #fitToContent(firstTime = false) {
                        if (this.isEmpty()) return;
                        if (!this.#disableEditing) {
                            this.#redraw();
                            return;
                        }
                        const bbox = this.#getBbox();
                        const padding = this.#getPadding();
                        this.#baseWidth = Math.max(_editor.AnnotationEditor.MIN_SIZE, bbox[2] - bbox[0]);
                        this.#baseHeight = Math.max(_editor.AnnotationEditor.MIN_SIZE, bbox[3] - bbox[1]);
                        const width = Math.ceil(padding + this.#baseWidth * this.scaleFactor);
                        const height = Math.ceil(padding + this.#baseHeight * this.scaleFactor);
                        const [parentWidth, parentHeight] = this.parentDimensions;
                        this.width = width / parentWidth;
                        this.height = height / parentHeight;
                        this.setAspectRatio(width, height);
                        const prevTranslationX = this.translationX;
                        const prevTranslationY = this.translationY;
                        this.translationX = -bbox[0];
                        this.translationY = -bbox[1];
                        this.#setCanvasDims();
                        this.#redraw();
                        this.#realWidth = width;
                        this.#realHeight = height;
                        this.setDims(width, height);
                        const unscaledPadding = firstTime ? padding / this.scaleFactor / 2 : 0;
                        this.translate(prevTranslationX - this.translationX - unscaledPadding, prevTranslationY - this.translationY - unscaledPadding);
                    }
                    static deserialize(data, parent, uiManager) {
                        if (data instanceof _annotation_layer.InkAnnotationElement) return null;
                        const editor = super.deserialize(data, parent, uiManager);
                        editor.thickness = data.thickness;
                        editor.color = _util.Util.makeHexColor(...data.color);
                        editor.opacity = data.opacity;
                        const [pageWidth, pageHeight] = editor.pageDimensions;
                        const width = editor.width * pageWidth;
                        const height = editor.height * pageHeight;
                        const scaleFactor = editor.parentScale;
                        const padding = data.thickness / 2;
                        editor.#disableEditing = true;
                        editor.#realWidth = Math.round(width);
                        editor.#realHeight = Math.round(height);
                        const { paths, rect, rotation } = data;
                        for (let { bezier } of paths){
                            bezier = InkEditor.#fromPDFCoordinates(bezier, rect, rotation);
                            const path = [];
                            editor.paths.push(path);
                            let p0 = scaleFactor * (bezier[0] - padding);
                            let p1 = scaleFactor * (bezier[1] - padding);
                            for(let i = 2, ii = bezier.length; i < ii; i += 6){
                                const p10 = scaleFactor * (bezier[i] - padding);
                                const p11 = scaleFactor * (bezier[i + 1] - padding);
                                const p20 = scaleFactor * (bezier[i + 2] - padding);
                                const p21 = scaleFactor * (bezier[i + 3] - padding);
                                const p30 = scaleFactor * (bezier[i + 4] - padding);
                                const p31 = scaleFactor * (bezier[i + 5] - padding);
                                path.push([
                                    [
                                        p0,
                                        p1
                                    ],
                                    [
                                        p10,
                                        p11
                                    ],
                                    [
                                        p20,
                                        p21
                                    ],
                                    [
                                        p30,
                                        p31
                                    ]
                                ]);
                                p0 = p30;
                                p1 = p31;
                            }
                            const path2D = this.#buildPath2D(path);
                            editor.bezierPath2D.push(path2D);
                        }
                        const bbox = editor.#getBbox();
                        editor.#baseWidth = Math.max(_editor.AnnotationEditor.MIN_SIZE, bbox[2] - bbox[0]);
                        editor.#baseHeight = Math.max(_editor.AnnotationEditor.MIN_SIZE, bbox[3] - bbox[1]);
                        editor.#setScaleFactor(width, height);
                        return editor;
                    }
                    serialize() {
                        if (this.isEmpty()) return null;
                        const rect = this.getRect(0, 0);
                        const color = _editor.AnnotationEditor._colorManager.convert(this.ctx.strokeStyle);
                        return {
                            annotationType: _util.AnnotationEditorType.INK,
                            color: color,
                            thickness: this.thickness,
                            opacity: this.opacity,
                            paths: this.#serializePaths(this.scaleFactor / this.parentScale, this.translationX, this.translationY, rect),
                            pageIndex: this.pageIndex,
                            rect: rect,
                            rotation: this.rotation,
                            structTreeParentId: this._structTreeParentId
                        };
                    }
                }
                exports.InkEditor = InkEditor;
            /***/ },
            /* 34 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.StampEditor = void 0;
                var _util = __w_pdfjs_require__(1);
                var _editor = __w_pdfjs_require__(4);
                var _display_utils = __w_pdfjs_require__(6);
                var _annotation_layer = __w_pdfjs_require__(29);
                class StampEditor extends _editor.AnnotationEditor {
                    #bitmap = null;
                    #bitmapId = null;
                    #bitmapPromise = null;
                    #bitmapUrl = null;
                    #bitmapFile = null;
                    #canvas = null;
                    #observer = null;
                    #resizeTimeoutId = null;
                    #isSvg = false;
                    #hasBeenAddedInUndoStack = false;
                    static _type = "stamp";
                    constructor(params){
                        super({
                            ...params,
                            name: "stampEditor"
                        });
                        this.#bitmapUrl = params.bitmapUrl;
                        this.#bitmapFile = params.bitmapFile;
                    }
                    static initialize(l10n) {
                        _editor.AnnotationEditor.initialize(l10n);
                    }
                    static get supportedTypes() {
                        const types = [
                            "apng",
                            "avif",
                            "bmp",
                            "gif",
                            "jpeg",
                            "png",
                            "svg+xml",
                            "webp",
                            "x-icon"
                        ];
                        return (0, _util.shadow)(this, "supportedTypes", types.map((type)=>`image/${type}`));
                    }
                    static get supportedTypesStr() {
                        return (0, _util.shadow)(this, "supportedTypesStr", this.supportedTypes.join(","));
                    }
                    static isHandlingMimeForPasting(mime) {
                        return this.supportedTypes.includes(mime);
                    }
                    static paste(item, parent) {
                        parent.pasteEditor(_util.AnnotationEditorType.STAMP, {
                            bitmapFile: item.getAsFile()
                        });
                    }
                    #getBitmapFetched(data, fromId = false) {
                        if (!data) {
                            this.remove();
                            return;
                        }
                        this.#bitmap = data.bitmap;
                        if (!fromId) {
                            this.#bitmapId = data.id;
                            this.#isSvg = data.isSvg;
                        }
                        this.#createCanvas();
                    }
                    #getBitmapDone() {
                        this.#bitmapPromise = null;
                        this._uiManager.enableWaiting(false);
                        if (this.#canvas) this.div.focus();
                    }
                    #getBitmap() {
                        if (this.#bitmapId) {
                            this._uiManager.enableWaiting(true);
                            this._uiManager.imageManager.getFromId(this.#bitmapId).then((data)=>this.#getBitmapFetched(data, true)).finally(()=>this.#getBitmapDone());
                            return;
                        }
                        if (this.#bitmapUrl) {
                            const url = this.#bitmapUrl;
                            this.#bitmapUrl = null;
                            this._uiManager.enableWaiting(true);
                            this.#bitmapPromise = this._uiManager.imageManager.getFromUrl(url).then((data)=>this.#getBitmapFetched(data)).finally(()=>this.#getBitmapDone());
                            return;
                        }
                        if (this.#bitmapFile) {
                            const file = this.#bitmapFile;
                            this.#bitmapFile = null;
                            this._uiManager.enableWaiting(true);
                            this.#bitmapPromise = this._uiManager.imageManager.getFromFile(file).then((data)=>this.#getBitmapFetched(data)).finally(()=>this.#getBitmapDone());
                            return;
                        }
                        const input = document.createElement("input");
                        input.type = "file";
                        input.accept = StampEditor.supportedTypesStr;
                        this.#bitmapPromise = new Promise((resolve)=>{
                            input.addEventListener("change", async ()=>{
                                if (!input.files || input.files.length === 0) this.remove();
                                else {
                                    this._uiManager.enableWaiting(true);
                                    const data = await this._uiManager.imageManager.getFromFile(input.files[0]);
                                    this.#getBitmapFetched(data);
                                }
                                resolve();
                            });
                            input.addEventListener("cancel", ()=>{
                                this.remove();
                                resolve();
                            });
                        }).finally(()=>this.#getBitmapDone());
                        input.click();
                    }
                    remove() {
                        if (this.#bitmapId) {
                            this.#bitmap = null;
                            this._uiManager.imageManager.deleteId(this.#bitmapId);
                            this.#canvas?.remove();
                            this.#canvas = null;
                            this.#observer?.disconnect();
                            this.#observer = null;
                        }
                        super.remove();
                    }
                    rebuild() {
                        if (!this.parent) {
                            if (this.#bitmapId) this.#getBitmap();
                            return;
                        }
                        super.rebuild();
                        if (this.div === null) return;
                        if (this.#bitmapId) this.#getBitmap();
                        if (!this.isAttachedToDOM) this.parent.add(this);
                    }
                    onceAdded() {
                        this._isDraggable = true;
                        this.div.focus();
                    }
                    isEmpty() {
                        return !(this.#bitmapPromise || this.#bitmap || this.#bitmapUrl || this.#bitmapFile);
                    }
                    get isResizable() {
                        return true;
                    }
                    render() {
                        if (this.div) return this.div;
                        let baseX, baseY;
                        if (this.width) {
                            baseX = this.x;
                            baseY = this.y;
                        }
                        super.render();
                        this.div.hidden = true;
                        if (this.#bitmap) this.#createCanvas();
                        else this.#getBitmap();
                        if (this.width) {
                            const [parentWidth, parentHeight] = this.parentDimensions;
                            this.setAt(baseX * parentWidth, baseY * parentHeight, this.width * parentWidth, this.height * parentHeight);
                        }
                        return this.div;
                    }
                    #createCanvas() {
                        const { div } = this;
                        let { width, height } = this.#bitmap;
                        const [pageWidth, pageHeight] = this.pageDimensions;
                        const MAX_RATIO = 0.75;
                        if (this.width) {
                            width = this.width * pageWidth;
                            height = this.height * pageHeight;
                        } else if (width > MAX_RATIO * pageWidth || height > MAX_RATIO * pageHeight) {
                            const factor = Math.min(MAX_RATIO * pageWidth / width, MAX_RATIO * pageHeight / height);
                            width *= factor;
                            height *= factor;
                        }
                        const [parentWidth, parentHeight] = this.parentDimensions;
                        this.setDims(width * parentWidth / pageWidth, height * parentHeight / pageHeight);
                        this._uiManager.enableWaiting(false);
                        const canvas = this.#canvas = document.createElement("canvas");
                        div.append(canvas);
                        div.hidden = false;
                        this.#drawBitmap(width, height);
                        this.#createObserver();
                        if (!this.#hasBeenAddedInUndoStack) {
                            this.parent.addUndoableEditor(this);
                            this.#hasBeenAddedInUndoStack = true;
                        }
                        this._uiManager._eventBus.dispatch("reporttelemetry", {
                            source: this,
                            details: {
                                type: "editing",
                                subtype: this.editorType,
                                data: {
                                    action: "inserted_image"
                                }
                            }
                        });
                        this.addAltTextButton();
                    }
                    #setDimensions(width, height) {
                        const [parentWidth, parentHeight] = this.parentDimensions;
                        this.width = width / parentWidth;
                        this.height = height / parentHeight;
                        this.setDims(width, height);
                        if (this._initialOptions?.isCentered) this.center();
                        else this.fixAndSetPosition();
                        this._initialOptions = null;
                        if (this.#resizeTimeoutId !== null) clearTimeout(this.#resizeTimeoutId);
                        const TIME_TO_WAIT = 200;
                        this.#resizeTimeoutId = setTimeout(()=>{
                            this.#resizeTimeoutId = null;
                            this.#drawBitmap(width, height);
                        }, TIME_TO_WAIT);
                    }
                    #scaleBitmap(width, height) {
                        const { width: bitmapWidth, height: bitmapHeight } = this.#bitmap;
                        let newWidth = bitmapWidth;
                        let newHeight = bitmapHeight;
                        let bitmap = this.#bitmap;
                        while(newWidth > 2 * width || newHeight > 2 * height){
                            const prevWidth = newWidth;
                            const prevHeight = newHeight;
                            if (newWidth > 2 * width) newWidth = newWidth >= 16384 ? Math.floor(newWidth / 2) - 1 : Math.ceil(newWidth / 2);
                            if (newHeight > 2 * height) newHeight = newHeight >= 16384 ? Math.floor(newHeight / 2) - 1 : Math.ceil(newHeight / 2);
                            const offscreen = new OffscreenCanvas(newWidth, newHeight);
                            const ctx = offscreen.getContext("2d");
                            ctx.drawImage(bitmap, 0, 0, prevWidth, prevHeight, 0, 0, newWidth, newHeight);
                            bitmap = offscreen.transferToImageBitmap();
                        }
                        return bitmap;
                    }
                    #drawBitmap(width, height) {
                        width = Math.ceil(width);
                        height = Math.ceil(height);
                        const canvas = this.#canvas;
                        if (!canvas || canvas.width === width && canvas.height === height) return;
                        canvas.width = width;
                        canvas.height = height;
                        const bitmap = this.#isSvg ? this.#bitmap : this.#scaleBitmap(width, height);
                        const ctx = canvas.getContext("2d");
                        ctx.filter = this._uiManager.hcmFilter;
                        ctx.drawImage(bitmap, 0, 0, bitmap.width, bitmap.height, 0, 0, width, height);
                    }
                    #serializeBitmap(toUrl) {
                        if (toUrl) {
                            if (this.#isSvg) {
                                const url = this._uiManager.imageManager.getSvgUrl(this.#bitmapId);
                                if (url) return url;
                            }
                            const canvas = document.createElement("canvas");
                            ({ width: canvas.width, height: canvas.height } = this.#bitmap);
                            const ctx = canvas.getContext("2d");
                            ctx.drawImage(this.#bitmap, 0, 0);
                            return canvas.toDataURL();
                        }
                        if (this.#isSvg) {
                            const [pageWidth, pageHeight] = this.pageDimensions;
                            const width = Math.round(this.width * pageWidth * _display_utils.PixelsPerInch.PDF_TO_CSS_UNITS);
                            const height = Math.round(this.height * pageHeight * _display_utils.PixelsPerInch.PDF_TO_CSS_UNITS);
                            const offscreen = new OffscreenCanvas(width, height);
                            const ctx = offscreen.getContext("2d");
                            ctx.drawImage(this.#bitmap, 0, 0, this.#bitmap.width, this.#bitmap.height, 0, 0, width, height);
                            return offscreen.transferToImageBitmap();
                        }
                        return structuredClone(this.#bitmap);
                    }
                    #createObserver() {
                        this.#observer = new ResizeObserver((entries)=>{
                            const rect = entries[0].contentRect;
                            if (rect.width && rect.height) this.#setDimensions(rect.width, rect.height);
                        });
                        this.#observer.observe(this.div);
                    }
                    static deserialize(data, parent, uiManager) {
                        if (data instanceof _annotation_layer.StampAnnotationElement) return null;
                        const editor = super.deserialize(data, parent, uiManager);
                        const { rect, bitmapUrl, bitmapId, isSvg, accessibilityData } = data;
                        if (bitmapId && uiManager.imageManager.isValidId(bitmapId)) editor.#bitmapId = bitmapId;
                        else editor.#bitmapUrl = bitmapUrl;
                        editor.#isSvg = isSvg;
                        const [parentWidth, parentHeight] = editor.pageDimensions;
                        editor.width = (rect[2] - rect[0]) / parentWidth;
                        editor.height = (rect[3] - rect[1]) / parentHeight;
                        if (accessibilityData) editor.altTextData = accessibilityData;
                        return editor;
                    }
                    serialize(isForCopying = false, context = null) {
                        if (this.isEmpty()) return null;
                        const serialized = {
                            annotationType: _util.AnnotationEditorType.STAMP,
                            bitmapId: this.#bitmapId,
                            pageIndex: this.pageIndex,
                            rect: this.getRect(0, 0),
                            rotation: this.rotation,
                            isSvg: this.#isSvg,
                            structTreeParentId: this._structTreeParentId
                        };
                        if (isForCopying) {
                            serialized.bitmapUrl = this.#serializeBitmap(true);
                            serialized.accessibilityData = this.altTextData;
                            return serialized;
                        }
                        const { decorative, altText } = this.altTextData;
                        if (!decorative && altText) serialized.accessibilityData = {
                            type: "Figure",
                            alt: altText
                        };
                        if (context === null) return serialized;
                        context.stamps ||= new Map();
                        const area = this.#isSvg ? (serialized.rect[2] - serialized.rect[0]) * (serialized.rect[3] - serialized.rect[1]) : null;
                        if (!context.stamps.has(this.#bitmapId)) {
                            context.stamps.set(this.#bitmapId, {
                                area: area,
                                serialized: serialized
                            });
                            serialized.bitmap = this.#serializeBitmap(false);
                        } else if (this.#isSvg) {
                            const prevData = context.stamps.get(this.#bitmapId);
                            if (area > prevData.area) {
                                prevData.area = area;
                                prevData.serialized.bitmap.close();
                                prevData.serialized.bitmap = this.#serializeBitmap(false);
                            }
                        }
                        return serialized;
                    }
                }
                exports.StampEditor = StampEditor;
            /***/ }
        ];
        /************************************************************************/ /******/ // The module cache
        /******/ var __webpack_module_cache__ = {};
        /******/ /******/ // The require function
        /******/ function __w_pdfjs_require__(moduleId) {
            /******/ // Check if module is in cache
            /******/ var cachedModule = __webpack_module_cache__[moduleId];
            /******/ if (cachedModule !== undefined) /******/ return cachedModule.exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = __webpack_module_cache__[moduleId] = {
                /******/ // no module.id needed
                /******/ // no module.loaded needed
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ __webpack_modules__[moduleId](module1, module1.exports, __w_pdfjs_require__);
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /************************************************************************/ var __webpack_exports__ = {};
        // This entry need to be wrapped in an IIFE because it need to be isolated against other modules in the chunk.
        (()=>{
            var exports = __webpack_exports__;
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            Object.defineProperty(exports, "AbortException", {
                enumerable: true,
                get: function() {
                    return _util.AbortException;
                }
            });
            Object.defineProperty(exports, "AnnotationEditorLayer", {
                enumerable: true,
                get: function() {
                    return _annotation_editor_layer.AnnotationEditorLayer;
                }
            });
            Object.defineProperty(exports, "AnnotationEditorParamsType", {
                enumerable: true,
                get: function() {
                    return _util.AnnotationEditorParamsType;
                }
            });
            Object.defineProperty(exports, "AnnotationEditorType", {
                enumerable: true,
                get: function() {
                    return _util.AnnotationEditorType;
                }
            });
            Object.defineProperty(exports, "AnnotationEditorUIManager", {
                enumerable: true,
                get: function() {
                    return _tools.AnnotationEditorUIManager;
                }
            });
            Object.defineProperty(exports, "AnnotationLayer", {
                enumerable: true,
                get: function() {
                    return _annotation_layer.AnnotationLayer;
                }
            });
            Object.defineProperty(exports, "AnnotationMode", {
                enumerable: true,
                get: function() {
                    return _util.AnnotationMode;
                }
            });
            Object.defineProperty(exports, "CMapCompressionType", {
                enumerable: true,
                get: function() {
                    return _util.CMapCompressionType;
                }
            });
            Object.defineProperty(exports, "DOMSVGFactory", {
                enumerable: true,
                get: function() {
                    return _display_utils.DOMSVGFactory;
                }
            });
            Object.defineProperty(exports, "FeatureTest", {
                enumerable: true,
                get: function() {
                    return _util.FeatureTest;
                }
            });
            Object.defineProperty(exports, "GlobalWorkerOptions", {
                enumerable: true,
                get: function() {
                    return _worker_options.GlobalWorkerOptions;
                }
            });
            Object.defineProperty(exports, "ImageKind", {
                enumerable: true,
                get: function() {
                    return _util.ImageKind;
                }
            });
            Object.defineProperty(exports, "InvalidPDFException", {
                enumerable: true,
                get: function() {
                    return _util.InvalidPDFException;
                }
            });
            Object.defineProperty(exports, "MissingPDFException", {
                enumerable: true,
                get: function() {
                    return _util.MissingPDFException;
                }
            });
            Object.defineProperty(exports, "OPS", {
                enumerable: true,
                get: function() {
                    return _util.OPS;
                }
            });
            Object.defineProperty(exports, "PDFDataRangeTransport", {
                enumerable: true,
                get: function() {
                    return _api.PDFDataRangeTransport;
                }
            });
            Object.defineProperty(exports, "PDFDateString", {
                enumerable: true,
                get: function() {
                    return _display_utils.PDFDateString;
                }
            });
            Object.defineProperty(exports, "PDFWorker", {
                enumerable: true,
                get: function() {
                    return _api.PDFWorker;
                }
            });
            Object.defineProperty(exports, "PasswordResponses", {
                enumerable: true,
                get: function() {
                    return _util.PasswordResponses;
                }
            });
            Object.defineProperty(exports, "PermissionFlag", {
                enumerable: true,
                get: function() {
                    return _util.PermissionFlag;
                }
            });
            Object.defineProperty(exports, "PixelsPerInch", {
                enumerable: true,
                get: function() {
                    return _display_utils.PixelsPerInch;
                }
            });
            Object.defineProperty(exports, "PromiseCapability", {
                enumerable: true,
                get: function() {
                    return _util.PromiseCapability;
                }
            });
            Object.defineProperty(exports, "RenderingCancelledException", {
                enumerable: true,
                get: function() {
                    return _display_utils.RenderingCancelledException;
                }
            });
            Object.defineProperty(exports, "SVGGraphics", {
                enumerable: true,
                get: function() {
                    return _api.SVGGraphics;
                }
            });
            Object.defineProperty(exports, "UnexpectedResponseException", {
                enumerable: true,
                get: function() {
                    return _util.UnexpectedResponseException;
                }
            });
            Object.defineProperty(exports, "Util", {
                enumerable: true,
                get: function() {
                    return _util.Util;
                }
            });
            Object.defineProperty(exports, "VerbosityLevel", {
                enumerable: true,
                get: function() {
                    return _util.VerbosityLevel;
                }
            });
            Object.defineProperty(exports, "XfaLayer", {
                enumerable: true,
                get: function() {
                    return _xfa_layer.XfaLayer;
                }
            });
            Object.defineProperty(exports, "build", {
                enumerable: true,
                get: function() {
                    return _api.build;
                }
            });
            Object.defineProperty(exports, "createValidAbsoluteUrl", {
                enumerable: true,
                get: function() {
                    return _util.createValidAbsoluteUrl;
                }
            });
            Object.defineProperty(exports, "getDocument", {
                enumerable: true,
                get: function() {
                    return _api.getDocument;
                }
            });
            Object.defineProperty(exports, "getFilenameFromUrl", {
                enumerable: true,
                get: function() {
                    return _display_utils.getFilenameFromUrl;
                }
            });
            Object.defineProperty(exports, "getPdfFilenameFromUrl", {
                enumerable: true,
                get: function() {
                    return _display_utils.getPdfFilenameFromUrl;
                }
            });
            Object.defineProperty(exports, "getXfaPageViewport", {
                enumerable: true,
                get: function() {
                    return _display_utils.getXfaPageViewport;
                }
            });
            Object.defineProperty(exports, "isDataScheme", {
                enumerable: true,
                get: function() {
                    return _display_utils.isDataScheme;
                }
            });
            Object.defineProperty(exports, "isPdfFile", {
                enumerable: true,
                get: function() {
                    return _display_utils.isPdfFile;
                }
            });
            Object.defineProperty(exports, "loadScript", {
                enumerable: true,
                get: function() {
                    return _display_utils.loadScript;
                }
            });
            Object.defineProperty(exports, "noContextMenu", {
                enumerable: true,
                get: function() {
                    return _display_utils.noContextMenu;
                }
            });
            Object.defineProperty(exports, "normalizeUnicode", {
                enumerable: true,
                get: function() {
                    return _util.normalizeUnicode;
                }
            });
            Object.defineProperty(exports, "renderTextLayer", {
                enumerable: true,
                get: function() {
                    return _text_layer.renderTextLayer;
                }
            });
            Object.defineProperty(exports, "setLayerDimensions", {
                enumerable: true,
                get: function() {
                    return _display_utils.setLayerDimensions;
                }
            });
            Object.defineProperty(exports, "shadow", {
                enumerable: true,
                get: function() {
                    return _util.shadow;
                }
            });
            Object.defineProperty(exports, "updateTextLayer", {
                enumerable: true,
                get: function() {
                    return _text_layer.updateTextLayer;
                }
            });
            Object.defineProperty(exports, "version", {
                enumerable: true,
                get: function() {
                    return _api.version;
                }
            });
            var _util = __w_pdfjs_require__(1);
            var _api = __w_pdfjs_require__(2);
            var _display_utils = __w_pdfjs_require__(6);
            var _text_layer = __w_pdfjs_require__(26);
            var _annotation_editor_layer = __w_pdfjs_require__(27);
            var _tools = __w_pdfjs_require__(5);
            var _annotation_layer = __w_pdfjs_require__(29);
            var _worker_options = __w_pdfjs_require__(14);
            var _xfa_layer = __w_pdfjs_require__(32);
            const pdfjsVersion = "3.11.174";
            const pdfjsBuild = "ce8716743";
        })();
        /******/ return __webpack_exports__;
    /******/ })();
});

});
parcelRegister("4qF7V", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $33997e13a98a2b72$export$a143d493d941bafc, (v) => $33997e13a98a2b72$export$a143d493d941bafc = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $33997e13a98a2b72$export$f99ded8fe4b79145, (v) => $33997e13a98a2b72$export$f99ded8fe4b79145 = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $33997e13a98a2b72$export$a143d493d941bafc;
var $33997e13a98a2b72$export$e4cf37d7f6fb9e0a;
var $33997e13a98a2b72$export$f99ded8fe4b79145;
var $33997e13a98a2b72$export$599f31c3813fae4d;
"use strict";

var $RIsAv = parcelRequire("RIsAv");

var $3rPX4 = parcelRequire("3rPX4");
const $33997e13a98a2b72$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$33997e13a98a2b72$export$a143d493d941bafc = $33997e13a98a2b72$var$Buffer;
$33997e13a98a2b72$export$e4cf37d7f6fb9e0a = $33997e13a98a2b72$var$SlowBuffer;
$33997e13a98a2b72$export$f99ded8fe4b79145 = 50;
const $33997e13a98a2b72$var$K_MAX_LENGTH = 0x7fffffff;
$33997e13a98a2b72$export$599f31c3813fae4d = $33997e13a98a2b72$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $33997e13a98a2b72$var$Buffer.TYPED_ARRAY_SUPPORT = $33997e13a98a2b72$var$typedArraySupport();
if (!$33997e13a98a2b72$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $33997e13a98a2b72$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($33997e13a98a2b72$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$33997e13a98a2b72$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($33997e13a98a2b72$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$33997e13a98a2b72$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $33997e13a98a2b72$var$createBuffer(length) {
    if (length > $33997e13a98a2b72$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $33997e13a98a2b72$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $33997e13a98a2b72$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $33997e13a98a2b72$var$allocUnsafe(arg);
    }
    return $33997e13a98a2b72$var$from(arg, encodingOrOffset, length);
}
$33997e13a98a2b72$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $33997e13a98a2b72$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $33997e13a98a2b72$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $33997e13a98a2b72$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($33997e13a98a2b72$var$isInstance(value, ArrayBuffer) || value && $33997e13a98a2b72$var$isInstance(value.buffer, ArrayBuffer)) return $33997e13a98a2b72$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($33997e13a98a2b72$var$isInstance(value, SharedArrayBuffer) || value && $33997e13a98a2b72$var$isInstance(value.buffer, SharedArrayBuffer))) return $33997e13a98a2b72$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $33997e13a98a2b72$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $33997e13a98a2b72$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $33997e13a98a2b72$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $33997e13a98a2b72$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $33997e13a98a2b72$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($33997e13a98a2b72$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($33997e13a98a2b72$var$Buffer, Uint8Array);
function $33997e13a98a2b72$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $33997e13a98a2b72$var$alloc(size, fill, encoding) {
    $33997e13a98a2b72$var$assertSize(size);
    if (size <= 0) return $33997e13a98a2b72$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $33997e13a98a2b72$var$createBuffer(size).fill(fill, encoding) : $33997e13a98a2b72$var$createBuffer(size).fill(fill);
    return $33997e13a98a2b72$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $33997e13a98a2b72$var$Buffer.alloc = function(size, fill, encoding) {
    return $33997e13a98a2b72$var$alloc(size, fill, encoding);
};
function $33997e13a98a2b72$var$allocUnsafe(size) {
    $33997e13a98a2b72$var$assertSize(size);
    return $33997e13a98a2b72$var$createBuffer(size < 0 ? 0 : $33997e13a98a2b72$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $33997e13a98a2b72$var$Buffer.allocUnsafe = function(size) {
    return $33997e13a98a2b72$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $33997e13a98a2b72$var$Buffer.allocUnsafeSlow = function(size) {
    return $33997e13a98a2b72$var$allocUnsafe(size);
};
function $33997e13a98a2b72$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$33997e13a98a2b72$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $33997e13a98a2b72$var$byteLength(string, encoding) | 0;
    let buf = $33997e13a98a2b72$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $33997e13a98a2b72$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $33997e13a98a2b72$var$checked(array.length) | 0;
    const buf = $33997e13a98a2b72$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $33997e13a98a2b72$var$fromArrayView(arrayView) {
    if ($33997e13a98a2b72$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $33997e13a98a2b72$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $33997e13a98a2b72$var$fromArrayLike(arrayView);
}
function $33997e13a98a2b72$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $33997e13a98a2b72$var$Buffer.prototype);
    return buf;
}
function $33997e13a98a2b72$var$fromObject(obj) {
    if ($33997e13a98a2b72$var$Buffer.isBuffer(obj)) {
        const len = $33997e13a98a2b72$var$checked(obj.length) | 0;
        const buf = $33997e13a98a2b72$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $33997e13a98a2b72$var$numberIsNaN(obj.length)) return $33997e13a98a2b72$var$createBuffer(0);
        return $33997e13a98a2b72$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $33997e13a98a2b72$var$fromArrayLike(obj.data);
}
function $33997e13a98a2b72$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $33997e13a98a2b72$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $33997e13a98a2b72$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $33997e13a98a2b72$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $33997e13a98a2b72$var$Buffer.alloc(+length);
}
$33997e13a98a2b72$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $33997e13a98a2b72$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$33997e13a98a2b72$var$Buffer.compare = function compare(a, b) {
    if ($33997e13a98a2b72$var$isInstance(a, Uint8Array)) a = $33997e13a98a2b72$var$Buffer.from(a, a.offset, a.byteLength);
    if ($33997e13a98a2b72$var$isInstance(b, Uint8Array)) b = $33997e13a98a2b72$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$33997e13a98a2b72$var$Buffer.isBuffer(a) || !$33997e13a98a2b72$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$33997e13a98a2b72$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$33997e13a98a2b72$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $33997e13a98a2b72$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $33997e13a98a2b72$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($33997e13a98a2b72$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$33997e13a98a2b72$var$Buffer.isBuffer(buf)) buf = $33997e13a98a2b72$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$33997e13a98a2b72$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $33997e13a98a2b72$var$byteLength(string, encoding) {
    if ($33997e13a98a2b72$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $33997e13a98a2b72$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $33997e13a98a2b72$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $33997e13a98a2b72$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $33997e13a98a2b72$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$33997e13a98a2b72$var$Buffer.byteLength = $33997e13a98a2b72$var$byteLength;
function $33997e13a98a2b72$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $33997e13a98a2b72$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $33997e13a98a2b72$var$utf8Slice(this, start, end);
        case "ascii":
            return $33997e13a98a2b72$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $33997e13a98a2b72$var$latin1Slice(this, start, end);
        case "base64":
            return $33997e13a98a2b72$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $33997e13a98a2b72$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$33997e13a98a2b72$var$Buffer.prototype._isBuffer = true;
function $33997e13a98a2b72$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$33997e13a98a2b72$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$33997e13a98a2b72$var$swap(this, i, i + 1);
    return this;
};
$33997e13a98a2b72$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $33997e13a98a2b72$var$swap(this, i, i + 3);
        $33997e13a98a2b72$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$33997e13a98a2b72$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $33997e13a98a2b72$var$swap(this, i, i + 7);
        $33997e13a98a2b72$var$swap(this, i + 1, i + 6);
        $33997e13a98a2b72$var$swap(this, i + 2, i + 5);
        $33997e13a98a2b72$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$33997e13a98a2b72$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $33997e13a98a2b72$var$utf8Slice(this, 0, length);
    return $33997e13a98a2b72$var$slowToString.apply(this, arguments);
};
$33997e13a98a2b72$var$Buffer.prototype.toLocaleString = $33997e13a98a2b72$var$Buffer.prototype.toString;
$33997e13a98a2b72$var$Buffer.prototype.equals = function equals(b) {
    if (!$33997e13a98a2b72$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $33997e13a98a2b72$var$Buffer.compare(this, b) === 0;
};
$33997e13a98a2b72$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $33997e13a98a2b72$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($33997e13a98a2b72$var$customInspectSymbol) $33997e13a98a2b72$var$Buffer.prototype[$33997e13a98a2b72$var$customInspectSymbol] = $33997e13a98a2b72$var$Buffer.prototype.inspect;
$33997e13a98a2b72$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($33997e13a98a2b72$var$isInstance(target, Uint8Array)) target = $33997e13a98a2b72$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$33997e13a98a2b72$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $33997e13a98a2b72$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($33997e13a98a2b72$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $33997e13a98a2b72$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($33997e13a98a2b72$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $33997e13a98a2b72$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $33997e13a98a2b72$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $33997e13a98a2b72$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$33997e13a98a2b72$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$33997e13a98a2b72$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $33997e13a98a2b72$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$33997e13a98a2b72$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $33997e13a98a2b72$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $33997e13a98a2b72$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($33997e13a98a2b72$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $33997e13a98a2b72$var$utf8Write(buf, string, offset, length) {
    return $33997e13a98a2b72$var$blitBuffer($33997e13a98a2b72$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $33997e13a98a2b72$var$asciiWrite(buf, string, offset, length) {
    return $33997e13a98a2b72$var$blitBuffer($33997e13a98a2b72$var$asciiToBytes(string), buf, offset, length);
}
function $33997e13a98a2b72$var$base64Write(buf, string, offset, length) {
    return $33997e13a98a2b72$var$blitBuffer($33997e13a98a2b72$var$base64ToBytes(string), buf, offset, length);
}
function $33997e13a98a2b72$var$ucs2Write(buf, string, offset, length) {
    return $33997e13a98a2b72$var$blitBuffer($33997e13a98a2b72$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$33997e13a98a2b72$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $33997e13a98a2b72$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $33997e13a98a2b72$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $33997e13a98a2b72$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $33997e13a98a2b72$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $33997e13a98a2b72$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$33997e13a98a2b72$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $33997e13a98a2b72$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $RIsAv.fromByteArray(buf);
    else return $RIsAv.fromByteArray(buf.slice(start, end));
}
function $33997e13a98a2b72$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $33997e13a98a2b72$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $33997e13a98a2b72$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $33997e13a98a2b72$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $33997e13a98a2b72$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $33997e13a98a2b72$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $33997e13a98a2b72$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $33997e13a98a2b72$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $33997e13a98a2b72$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $33997e13a98a2b72$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $33997e13a98a2b72$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$33997e13a98a2b72$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $33997e13a98a2b72$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $33997e13a98a2b72$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$33997e13a98a2b72$var$Buffer.prototype.readUintLE = $33997e13a98a2b72$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $33997e13a98a2b72$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$33997e13a98a2b72$var$Buffer.prototype.readUintBE = $33997e13a98a2b72$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $33997e13a98a2b72$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$33997e13a98a2b72$var$Buffer.prototype.readUint8 = $33997e13a98a2b72$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $33997e13a98a2b72$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$33997e13a98a2b72$var$Buffer.prototype.readUint16LE = $33997e13a98a2b72$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $33997e13a98a2b72$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$33997e13a98a2b72$var$Buffer.prototype.readUint16BE = $33997e13a98a2b72$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $33997e13a98a2b72$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$33997e13a98a2b72$var$Buffer.prototype.readUint32LE = $33997e13a98a2b72$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $33997e13a98a2b72$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$33997e13a98a2b72$var$Buffer.prototype.readUint32BE = $33997e13a98a2b72$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $33997e13a98a2b72$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$33997e13a98a2b72$var$Buffer.prototype.readBigUInt64LE = $33997e13a98a2b72$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $33997e13a98a2b72$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $33997e13a98a2b72$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$33997e13a98a2b72$var$Buffer.prototype.readBigUInt64BE = $33997e13a98a2b72$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $33997e13a98a2b72$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $33997e13a98a2b72$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$33997e13a98a2b72$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $33997e13a98a2b72$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$33997e13a98a2b72$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $33997e13a98a2b72$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$33997e13a98a2b72$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $33997e13a98a2b72$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$33997e13a98a2b72$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $33997e13a98a2b72$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$33997e13a98a2b72$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $33997e13a98a2b72$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$33997e13a98a2b72$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $33997e13a98a2b72$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$33997e13a98a2b72$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $33997e13a98a2b72$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$33997e13a98a2b72$var$Buffer.prototype.readBigInt64LE = $33997e13a98a2b72$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $33997e13a98a2b72$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $33997e13a98a2b72$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$33997e13a98a2b72$var$Buffer.prototype.readBigInt64BE = $33997e13a98a2b72$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $33997e13a98a2b72$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $33997e13a98a2b72$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$33997e13a98a2b72$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $33997e13a98a2b72$var$checkOffset(offset, 4, this.length);
    return $3rPX4.read(this, offset, true, 23, 4);
};
$33997e13a98a2b72$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $33997e13a98a2b72$var$checkOffset(offset, 4, this.length);
    return $3rPX4.read(this, offset, false, 23, 4);
};
$33997e13a98a2b72$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $33997e13a98a2b72$var$checkOffset(offset, 8, this.length);
    return $3rPX4.read(this, offset, true, 52, 8);
};
$33997e13a98a2b72$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $33997e13a98a2b72$var$checkOffset(offset, 8, this.length);
    return $3rPX4.read(this, offset, false, 52, 8);
};
function $33997e13a98a2b72$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$33997e13a98a2b72$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$33997e13a98a2b72$var$Buffer.prototype.writeUintLE = $33997e13a98a2b72$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $33997e13a98a2b72$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$33997e13a98a2b72$var$Buffer.prototype.writeUintBE = $33997e13a98a2b72$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $33997e13a98a2b72$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$33997e13a98a2b72$var$Buffer.prototype.writeUint8 = $33997e13a98a2b72$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $33997e13a98a2b72$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$33997e13a98a2b72$var$Buffer.prototype.writeUint16LE = $33997e13a98a2b72$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $33997e13a98a2b72$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$33997e13a98a2b72$var$Buffer.prototype.writeUint16BE = $33997e13a98a2b72$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $33997e13a98a2b72$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$33997e13a98a2b72$var$Buffer.prototype.writeUint32LE = $33997e13a98a2b72$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $33997e13a98a2b72$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$33997e13a98a2b72$var$Buffer.prototype.writeUint32BE = $33997e13a98a2b72$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $33997e13a98a2b72$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $33997e13a98a2b72$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $33997e13a98a2b72$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $33997e13a98a2b72$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $33997e13a98a2b72$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$33997e13a98a2b72$var$Buffer.prototype.writeBigUInt64LE = $33997e13a98a2b72$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $33997e13a98a2b72$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$33997e13a98a2b72$var$Buffer.prototype.writeBigUInt64BE = $33997e13a98a2b72$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $33997e13a98a2b72$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$33997e13a98a2b72$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $33997e13a98a2b72$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$33997e13a98a2b72$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $33997e13a98a2b72$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$33997e13a98a2b72$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $33997e13a98a2b72$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$33997e13a98a2b72$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $33997e13a98a2b72$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$33997e13a98a2b72$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $33997e13a98a2b72$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$33997e13a98a2b72$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $33997e13a98a2b72$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$33997e13a98a2b72$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $33997e13a98a2b72$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$33997e13a98a2b72$var$Buffer.prototype.writeBigInt64LE = $33997e13a98a2b72$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $33997e13a98a2b72$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$33997e13a98a2b72$var$Buffer.prototype.writeBigInt64BE = $33997e13a98a2b72$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $33997e13a98a2b72$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $33997e13a98a2b72$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $33997e13a98a2b72$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $33997e13a98a2b72$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $3rPX4.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$33997e13a98a2b72$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $33997e13a98a2b72$var$writeFloat(this, value, offset, true, noAssert);
};
$33997e13a98a2b72$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $33997e13a98a2b72$var$writeFloat(this, value, offset, false, noAssert);
};
function $33997e13a98a2b72$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $33997e13a98a2b72$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $3rPX4.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$33997e13a98a2b72$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $33997e13a98a2b72$var$writeDouble(this, value, offset, true, noAssert);
};
$33997e13a98a2b72$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $33997e13a98a2b72$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$33997e13a98a2b72$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$33997e13a98a2b72$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$33997e13a98a2b72$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$33997e13a98a2b72$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $33997e13a98a2b72$var$Buffer.isBuffer(val) ? val : $33997e13a98a2b72$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $33997e13a98a2b72$var$errors = {};
function $33997e13a98a2b72$var$E(sym, getMessage, Base) {
    $33997e13a98a2b72$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$33997e13a98a2b72$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$33997e13a98a2b72$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$33997e13a98a2b72$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $33997e13a98a2b72$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $33997e13a98a2b72$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $33997e13a98a2b72$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $33997e13a98a2b72$var$checkBounds(buf, offset, byteLength) {
    $33997e13a98a2b72$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $33997e13a98a2b72$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $33997e13a98a2b72$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $33997e13a98a2b72$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $33997e13a98a2b72$var$checkBounds(buf, offset, byteLength);
}
function $33997e13a98a2b72$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $33997e13a98a2b72$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $33997e13a98a2b72$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $33997e13a98a2b72$var$validateNumber(value, type);
        throw new $33997e13a98a2b72$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $33997e13a98a2b72$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $33997e13a98a2b72$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $33997e13a98a2b72$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $33997e13a98a2b72$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($33997e13a98a2b72$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $33997e13a98a2b72$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $33997e13a98a2b72$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $33997e13a98a2b72$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $33997e13a98a2b72$var$base64ToBytes(str) {
    return $RIsAv.toByteArray($33997e13a98a2b72$var$base64clean(str));
}
function $33997e13a98a2b72$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $33997e13a98a2b72$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $33997e13a98a2b72$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $33997e13a98a2b72$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $33997e13a98a2b72$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $33997e13a98a2b72$var$BufferBigIntNotDefined : fn;
}
function $33997e13a98a2b72$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}

});
parcelRegister("RIsAv", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $0a1770335400cc9d$export$d622b2ad8d90c771, (v) => $0a1770335400cc9d$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $0a1770335400cc9d$export$6100ba28696e12de, (v) => $0a1770335400cc9d$export$6100ba28696e12de = v);
var $0a1770335400cc9d$export$a48f0734ac7c2329;
var $0a1770335400cc9d$export$d622b2ad8d90c771;
var $0a1770335400cc9d$export$6100ba28696e12de;
"use strict";
$0a1770335400cc9d$export$a48f0734ac7c2329 = $0a1770335400cc9d$var$byteLength;
$0a1770335400cc9d$export$d622b2ad8d90c771 = $0a1770335400cc9d$var$toByteArray;
$0a1770335400cc9d$export$6100ba28696e12de = $0a1770335400cc9d$var$fromByteArray;
var $0a1770335400cc9d$var$lookup = [];
var $0a1770335400cc9d$var$revLookup = [];
var $0a1770335400cc9d$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $0a1770335400cc9d$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $0a1770335400cc9d$var$i = 0, $0a1770335400cc9d$var$len = $0a1770335400cc9d$var$code.length; $0a1770335400cc9d$var$i < $0a1770335400cc9d$var$len; ++$0a1770335400cc9d$var$i){
    $0a1770335400cc9d$var$lookup[$0a1770335400cc9d$var$i] = $0a1770335400cc9d$var$code[$0a1770335400cc9d$var$i];
    $0a1770335400cc9d$var$revLookup[$0a1770335400cc9d$var$code.charCodeAt($0a1770335400cc9d$var$i)] = $0a1770335400cc9d$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$0a1770335400cc9d$var$revLookup["-".charCodeAt(0)] = 62;
$0a1770335400cc9d$var$revLookup["_".charCodeAt(0)] = 63;
function $0a1770335400cc9d$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $0a1770335400cc9d$var$byteLength(b64) {
    var lens = $0a1770335400cc9d$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $0a1770335400cc9d$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $0a1770335400cc9d$var$toByteArray(b64) {
    var tmp;
    var lens = $0a1770335400cc9d$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $0a1770335400cc9d$var$Arr($0a1770335400cc9d$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $0a1770335400cc9d$var$revLookup[b64.charCodeAt(i)] << 18 | $0a1770335400cc9d$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $0a1770335400cc9d$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $0a1770335400cc9d$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $0a1770335400cc9d$var$revLookup[b64.charCodeAt(i)] << 2 | $0a1770335400cc9d$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $0a1770335400cc9d$var$revLookup[b64.charCodeAt(i)] << 10 | $0a1770335400cc9d$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $0a1770335400cc9d$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $0a1770335400cc9d$var$tripletToBase64(num) {
    return $0a1770335400cc9d$var$lookup[num >> 18 & 0x3F] + $0a1770335400cc9d$var$lookup[num >> 12 & 0x3F] + $0a1770335400cc9d$var$lookup[num >> 6 & 0x3F] + $0a1770335400cc9d$var$lookup[num & 0x3F];
}
function $0a1770335400cc9d$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($0a1770335400cc9d$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $0a1770335400cc9d$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($0a1770335400cc9d$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($0a1770335400cc9d$var$lookup[tmp >> 2] + $0a1770335400cc9d$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($0a1770335400cc9d$var$lookup[tmp >> 10] + $0a1770335400cc9d$var$lookup[tmp >> 4 & 0x3F] + $0a1770335400cc9d$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRegister("3rPX4", function(module, exports) {

$parcel$export(module.exports, "read", () => $282c3139d9299a00$export$aafa59e2e03f2942, (v) => $282c3139d9299a00$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $282c3139d9299a00$export$68d8715fc104d294, (v) => $282c3139d9299a00$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $282c3139d9299a00$export$aafa59e2e03f2942;
var $282c3139d9299a00$export$68d8715fc104d294;
$282c3139d9299a00$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$282c3139d9299a00$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("7NlT1", function(module, exports) {
"use strict";

});




parcelRegister("bpdtR", function(module, exports) {
/**
 * A React component to view a PDF document
 *
 * @see https://react-pdf-viewer.dev
 * @license https://react-pdf-viewer.dev/license
 * @copyright 2019-2023 Nguyen Huu Phuoc <me@phuoc.ng>
 */ "use strict";

module.exports = (parcelRequire("huA0a"));

});
parcelRegister("huA0a", function(module, exports) {

$parcel$export(module.exports, "attachmentPlugin", () => $cbc12a3051d68122$export$92ead0c4b5f8ead6, (v) => $cbc12a3051d68122$export$92ead0c4b5f8ead6 = v);
var $cbc12a3051d68122$export$92ead0c4b5f8ead6;
"use strict";

var $6eW0i = parcelRequire("6eW0i");
function $cbc12a3051d68122$var$t(e) {
    var t = Object.create(null);
    return e && Object.keys(e).forEach(function(n) {
        if ("default" !== n) {
            var a = Object.getOwnPropertyDescriptor(e, n);
            Object.defineProperty(t, n, a.get ? a : {
                enumerable: !0,
                get: function() {
                    return e[n];
                }
            });
        }
    }), t.default = e, Object.freeze(t);
}

var $cbc12a3051d68122$var$n = $cbc12a3051d68122$var$t((parcelRequire("kc00y"))), $cbc12a3051d68122$var$a = function(t) {
    var a = t.files, r = $cbc12a3051d68122$var$n.useRef(), c = $cbc12a3051d68122$var$n.useContext($6eW0i.LocalizationContext).l10n, i = $cbc12a3051d68122$var$n.useContext($6eW0i.ThemeContext).direction === $6eW0i.TextDirection.RightToLeft, o = $cbc12a3051d68122$var$n.useRef([]), u = c && c.attachment ? c.attachment.clickToDownload : "Click to download", l = function(e) {
        var t = r.current, n = [].slice.call(t.getElementsByClassName("rpv-attachment__item"));
        if (0 !== n.length) {
            n.forEach(function(e) {
                return e.setAttribute("tabindex", "-1");
            });
            var a = document.activeElement, c = n[Math.min(n.length - 1, Math.max(0, e(n, a)))];
            c.setAttribute("tabindex", "0"), c.focus();
        }
    };
    return $6eW0i.useIsomorphicLayoutEffect(function() {
        var e = r.current;
        if (e) {
            var t = [].slice.call(e.getElementsByClassName("rpv-attachment__item"));
            if (o.current = t, t.length > 0) {
                var n = t[0];
                n.focus(), n.setAttribute("tabindex", "0");
            }
        }
    }, []), $cbc12a3051d68122$var$n.createElement("div", {
        "data-testid": "attachment__list",
        className: $6eW0i.classNames({
            "rpv-attachment__list": !0,
            "rpv-attachment__list--rtl": i
        }),
        ref: r,
        tabIndex: -1,
        onKeyDown: function(e) {
            switch(e.key){
                case "ArrowDown":
                    e.preventDefault(), l(function(e, t) {
                        return e.indexOf(t) + 1;
                    });
                    break;
                case "ArrowUp":
                    e.preventDefault(), l(function(e, t) {
                        return e.indexOf(t) - 1;
                    });
                    break;
                case "End":
                    e.preventDefault(), l(function(e, t) {
                        return e.length - 1;
                    });
                    break;
                case "Home":
                    e.preventDefault(), l(function(e, t) {
                        return 0;
                    });
            }
        }
    }, a.map(function(e) {
        return $cbc12a3051d68122$var$n.createElement("button", {
            className: "rpv-attachment__item",
            key: e.fileName,
            tabIndex: -1,
            title: u,
            type: "button",
            onClick: function() {
                var t, n, a, r;
                return t = e.fileName, n = e.data, a = "string" == typeof n ? "" : URL.createObjectURL(new Blob([
                    n
                ], {
                    type: ""
                })), (r = document.createElement("a")).style.display = "none", r.href = a || t, r.setAttribute("download", function(e) {
                    var t = e.split("/").pop();
                    return t ? t.split("#")[0].split("?")[0] : e;
                }(t)), document.body.appendChild(r), r.click(), document.body.removeChild(r), void (a && URL.revokeObjectURL(a));
            }
        }, e.fileName);
    }));
}, $cbc12a3051d68122$var$r = function(t) {
    var r = t.doc, c = $cbc12a3051d68122$var$n.useContext($6eW0i.LocalizationContext).l10n, i = $cbc12a3051d68122$var$n.useContext($6eW0i.ThemeContext).direction === $6eW0i.TextDirection.RightToLeft, o = c && c.attachment ? c.attachment.noAttachment : "There is no attachment", u = $cbc12a3051d68122$var$n.useState({
        files: [],
        isLoaded: !1
    }), l = u[0], s = u[1];
    return $cbc12a3051d68122$var$n.useEffect(function() {
        r.getAttachments().then(function(e) {
            var t = e ? Object.keys(e).map(function(t) {
                return {
                    data: e[t].content,
                    fileName: e[t].filename
                };
            }) : [];
            s({
                files: t,
                isLoaded: !0
            });
        });
    }, [
        r
    ]), l.isLoaded ? 0 === l.files.length ? $cbc12a3051d68122$var$n.createElement("div", {
        "data-testid": "attachment__empty",
        className: $6eW0i.classNames({
            "rpv-attachment__empty": !0,
            "rpv-attachment__empty--rtl": i
        })
    }, o) : $cbc12a3051d68122$var$n.createElement($cbc12a3051d68122$var$a, {
        files: l.files
    }) : $cbc12a3051d68122$var$n.createElement($6eW0i.Spinner, null);
}, $cbc12a3051d68122$var$c = function(t) {
    var a = t.store, c = $cbc12a3051d68122$var$n.useState(a.get("doc")), i = c[0], o = c[1], u = function(e) {
        o(e);
    };
    return $cbc12a3051d68122$var$n.useEffect(function() {
        return a.subscribe("doc", u), function() {
            a.unsubscribe("doc", u);
        };
    }, []), i ? $cbc12a3051d68122$var$n.createElement($cbc12a3051d68122$var$r, {
        doc: i
    }) : $cbc12a3051d68122$var$n.createElement("div", {
        className: "rpv-attachment__loader"
    }, $cbc12a3051d68122$var$n.createElement($6eW0i.Spinner, null));
};
$cbc12a3051d68122$export$92ead0c4b5f8ead6 = function() {
    var t = $cbc12a3051d68122$var$n.useMemo(function() {
        return $6eW0i.createStore({});
    }, []);
    return {
        onDocumentLoad: function(e) {
            t.update("doc", e.doc);
        },
        Attachments: function() {
            return $cbc12a3051d68122$var$n.createElement($cbc12a3051d68122$var$c, {
                store: t
            });
        }
    };
};

});


parcelRegister("dCkkg", function(module, exports) {
/**
 * A React component to view a PDF document
 *
 * @see https://react-pdf-viewer.dev
 * @license https://react-pdf-viewer.dev/license
 * @copyright 2019-2023 Nguyen Huu Phuoc <me@phuoc.ng>
 */ "use strict";

module.exports = (parcelRequire("hMtem"));

});
parcelRegister("hMtem", function(module, exports) {

$parcel$export(module.exports, "DownArrowIcon", () => $cf1d97ef675cf9da$export$85ac33870499f48b, (v) => $cf1d97ef675cf9da$export$85ac33870499f48b = v);
$parcel$export(module.exports, "RightArrowIcon", () => $cf1d97ef675cf9da$export$fec93b5f1e2bccb4, (v) => $cf1d97ef675cf9da$export$fec93b5f1e2bccb4 = v);
$parcel$export(module.exports, "bookmarkPlugin", () => $cf1d97ef675cf9da$export$ff90129e0992e857, (v) => $cf1d97ef675cf9da$export$ff90129e0992e857 = v);
var $cf1d97ef675cf9da$export$85ac33870499f48b;
var $cf1d97ef675cf9da$export$fec93b5f1e2bccb4;
var $cf1d97ef675cf9da$export$ff90129e0992e857;
"use strict";

var $6eW0i = parcelRequire("6eW0i");
function $cf1d97ef675cf9da$var$t(e) {
    var t = Object.create(null);
    return e && Object.keys(e).forEach(function(r) {
        if ("default" !== r) {
            var o = Object.getOwnPropertyDescriptor(e, r);
            Object.defineProperty(t, r, o.get ? o : {
                enumerable: !0,
                get: function() {
                    return e[r];
                }
            });
        }
    }), t.default = e, Object.freeze(t);
}
var $cf1d97ef675cf9da$var$r;

var $cf1d97ef675cf9da$var$o = $cf1d97ef675cf9da$var$t((parcelRequire("kc00y"))), $cf1d97ef675cf9da$var$n = function() {
    return $cf1d97ef675cf9da$var$n = Object.assign || function(e) {
        for(var t, r = 1, o = arguments.length; r < o; r++)for(var n in t = arguments[r])Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        return e;
    }, $cf1d97ef675cf9da$var$n.apply(this, arguments);
}, $cf1d97ef675cf9da$var$a = function() {
    return $cf1d97ef675cf9da$var$o.createElement($6eW0i.Icon, {
        size: 16
    }, $cf1d97ef675cf9da$var$o.createElement("path", {
        d: "M6.427,8.245A.5.5,0,0,1,6.862,7.5H17.138a.5.5,0,0,1,.435.749l-5.139,9a.5.5,0,0,1-.868,0Z"
    }));
}, $cf1d97ef675cf9da$var$i = function() {
    return $cf1d97ef675cf9da$var$o.createElement($6eW0i.Icon, {
        size: 16
    }, $cf1d97ef675cf9da$var$o.createElement("path", {
        d: "M9.248,17.572a.5.5,0,0,1-.748-.434V6.862a.5.5,0,0,1,.748-.434l8.992,5.138a.5.5,0,0,1,0,.868Z"
    }));
}, $cf1d97ef675cf9da$var$c = function(t) {
    var r = t.bookmark, c = t.depth, l = t.doc, s = t.index, u = t.isBookmarkExpanded, k = t.numberOfSiblings, d = t.pathFromRoot, p = t.renderBookmarkItem, f = t.store, b = d ? "".concat(d, ".").concat(s) : "".concat(s), v = $cf1d97ef675cf9da$var$o.useMemo(function() {
        return function(e) {
            var t = e.count, r = e.items;
            if (t >= 0) return !1;
            var o = r.length;
            if (0 === o) return !1;
            for(var n = r.concat([]); n.length > 0;){
                var a = n.shift(), i = a.items;
                a.count && i && a.count > 0 && i.length > 0 && (o += i.length, n = n.concat(i));
            }
            return Math.abs(t) === o;
        }(r);
    }, [
        r
    ]), E = f.get("bookmarkExpandedMap"), g = u ? u({
        bookmark: r,
        doc: l,
        depth: c,
        index: s
    }) : E.has(b) ? E.get(b) : !v, h = $cf1d97ef675cf9da$var$o.useState(g), _ = h[0], x = h[1], B = r.items && r.items.length > 0, I = function() {
        var e = !_;
        f.updateCurrentValue("bookmarkExpandedMap", function(t) {
            return t.set(b, e);
        }), x(e);
    }, y = function() {
        var t = r.dest, o = f.get("jumpToDestination");
        $6eW0i.getDestination(l, t).then(function(e) {
            o && o($cf1d97ef675cf9da$var$n({
                label: r.title
            }, e));
        });
    }, w = function() {
        B && r.dest && y();
    }, C = function() {
        !B && r.dest && y();
    }, D = function(e, t) {
        return $cf1d97ef675cf9da$var$o.createElement("div", {
            className: "rpv-bookmark__item",
            style: {
                paddingLeft: "".concat(1.25 * c, "rem")
            },
            onClick: e
        }, t);
    }, N = function(e, t) {
        return B ? $cf1d97ef675cf9da$var$o.createElement("span", {
            className: "rpv-bookmark__toggle",
            "data-testid": "bookmark__toggle-".concat(c, "-").concat(s),
            onClick: I
        }, _ ? e : t) : $cf1d97ef675cf9da$var$o.createElement("span", {
            className: "rpv-bookmark__toggle"
        });
    }, R = function(e) {
        return r.url ? $cf1d97ef675cf9da$var$o.createElement("a", {
            className: "rpv-bookmark__title",
            href: r.url,
            rel: "noopener noreferrer nofollow",
            target: r.newWindow ? "_blank" : ""
        }, r.title) : $cf1d97ef675cf9da$var$o.createElement("div", {
            className: "rpv-bookmark__title",
            "aria-label": r.title,
            onClick: e
        }, r.title);
    };
    return $cf1d97ef675cf9da$var$o.createElement("li", {
        "aria-expanded": _ ? "true" : "false",
        "aria-label": r.title,
        "aria-level": c + 1,
        "aria-posinset": s + 1,
        "aria-setsize": k,
        role: "treeitem",
        tabIndex: -1
    }, p ? p({
        bookmark: r,
        depth: c,
        hasSubItems: B,
        index: s,
        isExpanded: _,
        path: b,
        defaultRenderItem: D,
        defaultRenderTitle: R,
        defaultRenderToggle: N,
        onClickItem: C,
        onClickTitle: w,
        onToggleSubItems: I
    }) : D(C, $cf1d97ef675cf9da$var$o.createElement($cf1d97ef675cf9da$var$o.Fragment, null, N($cf1d97ef675cf9da$var$o.createElement($cf1d97ef675cf9da$var$a, null), $cf1d97ef675cf9da$var$o.createElement($cf1d97ef675cf9da$var$i, null)), R(w))), B && _ && $cf1d97ef675cf9da$var$o.createElement($cf1d97ef675cf9da$var$m, {
        bookmarks: r.items,
        depth: c + 1,
        doc: l,
        isBookmarkExpanded: u,
        isRoot: !1,
        pathFromRoot: b,
        renderBookmarkItem: p,
        store: f
    }));
}, $cf1d97ef675cf9da$var$m = function(e) {
    var t = e.bookmarks, r = e.depth, n = void 0 === r ? 0 : r, a = e.doc, i = e.isBookmarkExpanded, m = e.isRoot, l = e.pathFromRoot, s = e.renderBookmarkItem, u = e.store;
    return $cf1d97ef675cf9da$var$o.createElement("ul", {
        className: "rpv-bookmark__list",
        role: m ? "tree" : "group",
        tabIndex: -1
    }, t.map(function(e, r) {
        return $cf1d97ef675cf9da$var$o.createElement($cf1d97ef675cf9da$var$c, {
            bookmark: e,
            depth: n,
            doc: a,
            index: r,
            isBookmarkExpanded: i,
            key: r,
            numberOfSiblings: t.length,
            pathFromRoot: l,
            renderBookmarkItem: s,
            store: u
        });
    }));
};
!function(e) {
    e[e.Collapse = 0] = "Collapse", e[e.Expand = 1] = "Expand";
}($cf1d97ef675cf9da$var$r || ($cf1d97ef675cf9da$var$r = {}));
var $cf1d97ef675cf9da$var$l = function(e) {
    var t = e.bookmarks, n = e.doc, a = e.isBookmarkExpanded, i = e.renderBookmarkItem, c = e.store, l = $cf1d97ef675cf9da$var$o.useRef(), s = function(e) {
        var t = l.current;
        if (t && e.target instanceof HTMLElement && t.contains(e.target)) switch(e.key){
            case "ArrowDown":
                e.preventDefault(), k(function(e, t) {
                    return e.indexOf(t) + 1;
                });
                break;
            case "ArrowLeft":
                e.preventDefault(), d($cf1d97ef675cf9da$var$r.Collapse);
                break;
            case "ArrowRight":
                e.preventDefault(), d($cf1d97ef675cf9da$var$r.Expand);
                break;
            case "ArrowUp":
                e.preventDefault, k(function(e, t) {
                    return e.indexOf(t) - 1;
                });
                break;
            case "End":
                e.preventDefault(), k(function(e, t) {
                    return e.length - 1;
                });
                break;
            case " ":
            case "Enter":
            case "Space":
                e.preventDefault(), u();
                break;
            case "Home":
                e.preventDefault(), k(function(e, t) {
                    return 0;
                });
        }
    }, u = function() {
        var e = document.activeElement.closest(".rpv-bookmark__item").querySelector(".rpv-bookmark__title");
        e && e.click();
    }, k = function(e) {
        var t = l.current, r = [].slice.call(t.getElementsByClassName("rpv-bookmark__item"));
        if (0 !== r.length) {
            var o = document.activeElement, n = r[Math.min(r.length - 1, Math.max(0, e(r, o)))];
            o.setAttribute("tabindex", "-1"), n.setAttribute("tabindex", "0"), n.focus();
        }
    }, d = function(e) {
        var t = l.current;
        if (0 !== [].slice.call(t.getElementsByClassName("rpv-bookmark__item")).length) {
            var o = document.activeElement.closest(".rpv-bookmark__item"), n = e === $cf1d97ef675cf9da$var$r.Collapse ? "true" : "false";
            if (o && o.parentElement.getAttribute("aria-expanded") === n) {
                var a = o.querySelector(".rpv-bookmark__toggle");
                a && a.click();
            }
        }
    };
    return $cf1d97ef675cf9da$var$o.useEffect(function() {
        return document.addEventListener("keydown", s), function() {
            document.removeEventListener("keydown", s);
        };
    }, []), $cf1d97ef675cf9da$var$o.useEffect(function() {
        var e = l.current;
        if (e) {
            var t = [].slice.call(e.getElementsByClassName("rpv-bookmark__item"));
            t.length > 0 && (t[0].focus(), t[0].setAttribute("tabindex", "0"));
        }
    }, []), $cf1d97ef675cf9da$var$o.createElement("div", {
        ref: l
    }, $cf1d97ef675cf9da$var$o.createElement($cf1d97ef675cf9da$var$m, {
        bookmarks: t,
        depth: 0,
        doc: n,
        isBookmarkExpanded: a,
        isRoot: !0,
        pathFromRoot: "",
        renderBookmarkItem: i,
        store: c
    }));
}, $cf1d97ef675cf9da$var$s = function(t) {
    var r = t.doc, n = t.isBookmarkExpanded, a = t.renderBookmarkItem, i = t.store, c = $cf1d97ef675cf9da$var$o.useContext($6eW0i.LocalizationContext).l10n, m = $cf1d97ef675cf9da$var$o.useContext($6eW0i.ThemeContext).direction === $6eW0i.TextDirection.RightToLeft, s = $cf1d97ef675cf9da$var$o.useState({
        isLoaded: !1,
        items: []
    }), u = s[0], k = s[1];
    return $cf1d97ef675cf9da$var$o.useEffect(function() {
        k({
            isLoaded: !1,
            items: []
        }), r.getOutline().then(function(e) {
            k({
                isLoaded: !0,
                items: e || []
            });
        });
    }, [
        r
    ]), u.isLoaded ? 0 === u.items.length ? $cf1d97ef675cf9da$var$o.createElement("div", {
        "data-testid": "bookmark__empty",
        className: $6eW0i.classNames({
            "rpv-bookmark__empty": !0,
            "rpv-bookmark__empty--rtl": m
        })
    }, c && c.bookmark ? c.bookmark.noBookmark : "There is no bookmark") : $cf1d97ef675cf9da$var$o.createElement("div", {
        "data-testid": "bookmark__container",
        className: $6eW0i.classNames({
            "rpv-bookmark__container": !0,
            "rpv-bookmark__container--rtl": m
        })
    }, $cf1d97ef675cf9da$var$o.createElement($cf1d97ef675cf9da$var$l, {
        bookmarks: u.items,
        doc: r,
        isBookmarkExpanded: n,
        renderBookmarkItem: a,
        store: i
    })) : $cf1d97ef675cf9da$var$o.createElement("div", {
        className: "rpv-bookmark__loader"
    }, $cf1d97ef675cf9da$var$o.createElement($6eW0i.Spinner, null));
}, $cf1d97ef675cf9da$var$u = function(t) {
    var r = t.isBookmarkExpanded, n = t.renderBookmarkItem, a = t.store, i = $cf1d97ef675cf9da$var$o.useState(a.get("doc")), c = i[0], m = i[1], l = function(e) {
        m(e);
    };
    return $cf1d97ef675cf9da$var$o.useEffect(function() {
        return a.subscribe("doc", l), function() {
            a.unsubscribe("doc", l);
        };
    }, []), c ? $cf1d97ef675cf9da$var$o.createElement($cf1d97ef675cf9da$var$s, {
        doc: c,
        isBookmarkExpanded: r,
        renderBookmarkItem: n,
        store: a
    }) : $cf1d97ef675cf9da$var$o.createElement("div", {
        className: "rpv-bookmark__loader"
    }, $cf1d97ef675cf9da$var$o.createElement($6eW0i.Spinner, null));
};
$cf1d97ef675cf9da$export$85ac33870499f48b = $cf1d97ef675cf9da$var$a, $cf1d97ef675cf9da$export$fec93b5f1e2bccb4 = $cf1d97ef675cf9da$var$i, $cf1d97ef675cf9da$export$ff90129e0992e857 = function() {
    var t = $cf1d97ef675cf9da$var$o.useMemo(function() {
        return $6eW0i.createStore({
            bookmarkExpandedMap: new Map
        });
    }, []);
    return {
        install: function(e) {
            t.update("jumpToDestination", e.jumpToDestination);
        },
        onDocumentLoad: function(e) {
            t.update("doc", e.doc);
        },
        Bookmarks: function(e) {
            return $cf1d97ef675cf9da$var$o.createElement($cf1d97ef675cf9da$var$u, {
                isBookmarkExpanded: null == e ? void 0 : e.isBookmarkExpanded,
                renderBookmarkItem: null == e ? void 0 : e.renderBookmarkItem,
                store: t
            });
        }
    };
};

});


parcelRegister("3vW7T", function(module, exports) {
/**
 * A React component to view a PDF document
 *
 * @see https://react-pdf-viewer.dev
 * @license https://react-pdf-viewer.dev/license
 * @copyright 2019-2023 Nguyen Huu Phuoc <me@phuoc.ng>
 */ "use strict";

module.exports = (parcelRequire("8tm17"));

});
parcelRegister("8tm17", function(module, exports) {

$parcel$export(module.exports, "ThumbnailDirection", () => $62b21c508e360f33$export$89a0353aa2a7813, (v) => $62b21c508e360f33$export$89a0353aa2a7813 = v);
$parcel$export(module.exports, "thumbnailPlugin", () => $62b21c508e360f33$export$e906a958693f3d0e, (v) => $62b21c508e360f33$export$e906a958693f3d0e = v);
var $62b21c508e360f33$export$89a0353aa2a7813;
var $62b21c508e360f33$export$e906a958693f3d0e;
"use strict";

var $6eW0i = parcelRequire("6eW0i");
function $62b21c508e360f33$var$t(e) {
    var t = Object.create(null);
    return e && Object.keys(e).forEach(function(n) {
        if ("default" !== n) {
            var a = Object.getOwnPropertyDescriptor(e, n);
            Object.defineProperty(t, n, a.get ? a : {
                enumerable: !0,
                get: function() {
                    return e[n];
                }
            });
        }
    }), t.default = e, Object.freeze(t);
}
var $62b21c508e360f33$var$n;

var $62b21c508e360f33$var$a = $62b21c508e360f33$var$t((parcelRequire("kc00y")));
$62b21c508e360f33$export$89a0353aa2a7813 = void 0, ($62b21c508e360f33$var$n = $62b21c508e360f33$export$89a0353aa2a7813 || ($62b21c508e360f33$export$89a0353aa2a7813 = {})).Horizontal = "Horizontal", $62b21c508e360f33$var$n.Vertical = "Vertical";
var $62b21c508e360f33$var$i = function() {
    return $62b21c508e360f33$var$i = Object.assign || function(e) {
        for(var t, n = 1, a = arguments.length; n < a; n++)for(var i in t = arguments[n])Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
        return e;
    }, $62b21c508e360f33$var$i.apply(this, arguments);
}, $62b21c508e360f33$var$r = function(t) {
    var n = t.doc, i = t.getPageIndex, r = t.renderSpinner, o = t.store, u = t.width, c = n.numPages, l = i ? i({
        numPages: c
    }) : 0, s = Math.max(0, Math.min(l, c - 1)), d = o.get("pagesRotation") || new Map, g = d.has(s) ? d.get(s) : 0, h = $62b21c508e360f33$var$a.useState(""), m = h[0], b = h[1], p = $6eW0i.useIsMounted(), f = $62b21c508e360f33$var$a.useRef(), v = $62b21c508e360f33$var$a.useState(o.get("rotation") || 0), _ = v[0], P = v[1], w = $62b21c508e360f33$var$a.useState(g), E = w[0], x = w[1], R = $62b21c508e360f33$var$a.useState(!1), C = R[0], S = R[1], M = function(e) {
        var t = e.has(s) ? e.get(s) : 0;
        x(t);
    }, I = function(e) {
        P(e);
    }, V = $6eW0i.useIntersectionObserver({
        onVisibilityChanged: function(e) {
            S(e.isVisible);
        }
    });
    return $62b21c508e360f33$var$a.useEffect(function() {
        if (C) {
            var t = V.current;
            t && (b(""), $6eW0i.getPage(n, s).then(function(e) {
                var n = e.getViewport({
                    scale: 1
                }), a = (n.rotation + _ + E) % 360, i = Math.abs(_ + E) % 180 == 0, r = i ? n.width : n.height, o = i ? n.height : n.width, c = document.createElement("canvas"), l = c.getContext("2d", {
                    alpha: !1
                }), s = t.clientWidth, d = t.clientHeight, g = u ? u / r : Math.min(s / r, d / o), h = g * r, m = g * o;
                c.height = m, c.width = h, c.style.opacity = "0";
                var v = e.getViewport({
                    rotation: a,
                    scale: g
                });
                f.current = e.render({
                    canvasContext: l,
                    viewport: v
                }), f.current.promise.then(function() {
                    p.current && b(c.toDataURL()), c.width = 0, c.height = 0;
                }, function() {});
            }));
        }
    }, [
        E,
        C
    ]), $62b21c508e360f33$var$a.useEffect(function() {
        return o.subscribe("pagesRotation", M), o.subscribe("rotation", I), function() {
            o.unsubscribe("pagesRotation", M), o.unsubscribe("rotation", I);
        };
    }, []), $62b21c508e360f33$var$a.useEffect(function() {
        return function() {
            var e;
            null === (e = f.current) || void 0 === e || e.cancel();
        };
    }, []), $62b21c508e360f33$var$a.createElement("div", {
        ref: V,
        className: "rpv-thumbnail__cover-inner",
        "data-testid": "thumbnail__cover-inner"
    }, m ? $62b21c508e360f33$var$a.createElement("img", {
        className: "rpv-thumbnail__cover-image",
        "data-testid": "thumbnail__cover-image",
        src: m
    }) : $62b21c508e360f33$var$a.createElement("div", {
        className: "rpv-thumbnail__cover-loader",
        "data-testid": "thumbnail__cover-loader"
    }, r ? r() : $62b21c508e360f33$var$a.createElement($6eW0i.Spinner, null)));
}, $62b21c508e360f33$var$o = function(t) {
    var n = t.getPageIndex, i = t.renderSpinner, o = t.store, u = t.width, c = $62b21c508e360f33$var$a.useState(o.get("doc")), l = c[0], s = c[1], d = function(e) {
        s(e);
    };
    return $62b21c508e360f33$var$a.useEffect(function() {
        return o.subscribe("doc", d), function() {
            o.unsubscribe("doc", d);
        };
    }, []), $62b21c508e360f33$var$a.createElement("div", {
        className: "rpv-thumbnail__cover"
    }, l ? $62b21c508e360f33$var$a.createElement($62b21c508e360f33$var$r, {
        doc: l,
        getPageIndex: n,
        renderSpinner: i,
        store: o,
        width: u
    }) : $62b21c508e360f33$var$a.createElement("div", {
        className: "rpv-thumbnail__cover-loader"
    }, i ? i() : $62b21c508e360f33$var$a.createElement($6eW0i.Spinner, null)));
}, $62b21c508e360f33$var$u = function() {
    return $62b21c508e360f33$var$a.createElement($6eW0i.Spinner, null);
}, $62b21c508e360f33$var$c = $62b21c508e360f33$var$a.createContext({
    renderSpinner: $62b21c508e360f33$var$u
}), $62b21c508e360f33$var$l = function(t) {
    var n = t.children, i = t.doc, r = $6eW0i.useIsMounted(), o = $62b21c508e360f33$var$a.useState({
        loading: !0,
        labels: []
    }), u = o[0], c = o[1];
    return $62b21c508e360f33$var$a.useEffect(function() {
        i.getPageLabels().then(function(e) {
            r.current && c({
                loading: !1,
                labels: e || []
            });
        });
    }, [
        i.loadingTask.docId
    ]), u.loading ? $62b21c508e360f33$var$a.createElement($62b21c508e360f33$var$a.Fragment, null) : n(u.labels);
}, $62b21c508e360f33$var$s = function(t) {
    var n = t.page, i = t.pageHeight, r = t.pageIndex, o = t.pageWidth, u = t.rotation, l = t.thumbnailHeight, s = t.thumbnailWidth, d = t.onRenderCompleted, g = $62b21c508e360f33$var$a.useContext($6eW0i.LocalizationContext).l10n, h = $62b21c508e360f33$var$a.useRef(), m = $62b21c508e360f33$var$a.useState(""), b = m[0], p = m[1], f = g && g.thumbnail ? g.thumbnail.thumbnailLabel : "Thumbnail of page {{pageIndex}}";
    return $62b21c508e360f33$var$a.useEffect(function() {
        var e = h.current;
        e && e.cancel();
        var t = document.createElement("canvas"), a = t.getContext("2d", {
            alpha: !1
        }), c = s, l = c / (o / i), g = c / o;
        t.height = l, t.width = c, t.style.height = "".concat(l, "px"), t.style.width = "".concat(c, "px");
        var m = n.getViewport({
            rotation: u,
            scale: g
        });
        return h.current = n.render({
            canvasContext: a,
            viewport: m
        }), h.current.promise.then(function() {
            p(t.toDataURL()), d(r);
        }, function() {
            d(r);
        }), function() {
            var e;
            null === (e = h.current) || void 0 === e || e.cancel();
        };
    }, [
        u
    ]), b ? $62b21c508e360f33$var$a.createElement("img", {
        "aria-label": f.replace("{{pageIndex}}", "".concat(r + 1)),
        src: b,
        height: "".concat(l, "px"),
        width: "".concat(s, "px")
    }) : $62b21c508e360f33$var$a.useContext($62b21c508e360f33$var$c).renderSpinner();
}, $62b21c508e360f33$var$d = function(t) {
    var n = t.doc, i = t.pageHeight, r = t.pageIndex, o = t.pageRotation, u = t.pageWidth, l = t.rotation, d = t.shouldRender, g = t.thumbnailWidth, h = t.onRenderCompleted, m = t.onVisibilityChanged, b = $6eW0i.useIsMounted(), p = $62b21c508e360f33$var$a.useState({
        height: i,
        page: null,
        viewportRotation: 0,
        width: u
    }), f = p[0], v = p[1], _ = f.page, P = f.height, w = f.width, E = w / P, x = Math.abs(l + o) % 180 == 0, R = x ? g : g / E, C = x ? g / E : g;
    $62b21c508e360f33$var$a.useEffect(function() {
        d && $6eW0i.getPage(n, r).then(function(e) {
            var t = e.getViewport({
                scale: 1
            });
            b.current && v({
                height: t.height,
                page: e,
                viewportRotation: t.rotation,
                width: t.width
            });
        });
    }, [
        d
    ]);
    var S = (f.viewportRotation + l + o) % 360, M = $6eW0i.useIntersectionObserver({
        onVisibilityChanged: function(e) {
            m(r, e);
        }
    });
    return $62b21c508e360f33$var$a.createElement("div", {
        className: "rpv-thumbnail__container",
        "data-testid": "thumbnail__container-".concat(r),
        ref: M,
        style: {
            height: "".concat(C, "px"),
            width: "".concat(R, "px")
        }
    }, _ ? $62b21c508e360f33$var$a.createElement($62b21c508e360f33$var$s, {
        page: _,
        pageHeight: x ? P : w,
        pageIndex: r,
        pageWidth: x ? w : P,
        rotation: S,
        thumbnailHeight: C,
        thumbnailWidth: R,
        onRenderCompleted: h
    }) : $62b21c508e360f33$var$a.useContext($62b21c508e360f33$var$c).renderSpinner());
}, $62b21c508e360f33$var$g = function(t) {
    var n = t.currentPage, i = t.doc, r = t.labels, o = t.pagesRotation, u = t.pageHeight, c = t.pageWidth, l = t.renderCurrentPageLabel, s = t.renderThumbnailItem, g = t.rotatedPage, h = t.rotation, m = t.thumbnailDirection, b = t.thumbnailWidth, p = t.viewMode, f = t.onJumpToPage, v = t.onRotatePage, _ = i.numPages, P = i.loadingTask.docId, w = $62b21c508e360f33$var$a.useRef(null), E = $62b21c508e360f33$var$a.useRef([]), x = $62b21c508e360f33$var$a.useState(n), R = x[0], C = x[1], S = $62b21c508e360f33$var$a.useContext($6eW0i.ThemeContext).direction === $6eW0i.TextDirection.RightToLeft, M = $62b21c508e360f33$var$a.useState(-1), I = M[0], V = M[1], y = $6eW0i.useIsMounted(), D = $6eW0i.usePrevious(p), T = $62b21c508e360f33$var$a.useRef(!1), W = $6eW0i.useRenderQueue({
        doc: i
    }), k = $62b21c508e360f33$var$a.useMemo(function() {
        return Array(_).fill(0).map(function(e, t) {
            return t;
        });
    }, [
        P
    ]), L = $62b21c508e360f33$var$a.useMemo(function() {
        switch(p){
            case $6eW0i.ViewMode.DualPage:
                return $6eW0i.chunk(k, 2);
            case $6eW0i.ViewMode.DualPageWithCover:
                return [
                    [
                        k[0]
                    ]
                ].concat($6eW0i.chunk(k.slice(1), 2));
            case $6eW0i.ViewMode.SinglePage:
            default:
                return $6eW0i.chunk(k, 1);
        }
    }, [
        P,
        p
    ]), H = function() {
        if (w.current) {
            var e = E.current, t = R + 1;
            t < e.length && (R >= 0 && e[R].setAttribute("tabindex", "-1"), C(t));
        }
    }, N = function() {
        if (w.current) {
            var e = E.current, t = R - 1;
            t >= 0 && (R >= 0 && e[R].setAttribute("tabindex", "-1"), C(t));
        }
    }, O = function() {
        R >= 0 && R < _ && f(R);
    };
    $6eW0i.useIsomorphicLayoutEffect(function() {
        var e = w.current;
        e && (E.current = Array.from(e.querySelectorAll(".rpv-thumbnail__item")));
    }, [
        p
    ]), $62b21c508e360f33$var$a.useEffect(function() {
        var e = E.current;
        if (!(0 === e.length || R < 0 || R > e.length)) {
            var t = e[R];
            t.setAttribute("tabindex", "0"), t.focus();
        }
    }, [
        R
    ]), $6eW0i.useIsomorphicLayoutEffect(function() {
        var e = w.current, t = E.current;
        if (!(!e || 0 === t.length || n < 0 || n > t.length)) {
            var a = t[n].closest(".rpv-thumbnail__items");
            a && (m === $62b21c508e360f33$export$89a0353aa2a7813.Vertical ? function(e, t) {
                var n = e.getBoundingClientRect().top - t.getBoundingClientRect().top, a = e.clientHeight, i = t.clientHeight;
                n < 0 ? t.scrollTop += n : n + a <= i || (t.scrollTop += n + a - i);
            }(a, e) : function(e, t) {
                var n = e.getBoundingClientRect().left - t.getBoundingClientRect().left, a = e.clientWidth, i = t.clientWidth;
                n < 0 ? t.scrollLeft += n : n + a <= i || (t.scrollLeft += n + a - i);
            }(a, e));
        }
    }, [
        n,
        m
    ]);
    var j = $62b21c508e360f33$var$a.useCallback(function(e) {
        y.current && (W.markRendered(e), T.current = !1, z());
    }, [
        P
    ]), A = $62b21c508e360f33$var$a.useCallback(function(e, t) {
        t.isVisible ? W.setVisibility(e, t.ratio) : W.setOutOfRange(e), z();
    }, [
        P
    ]), z = $62b21c508e360f33$var$a.useCallback(function() {
        if (!T.current) {
            var e = W.getHighestPriorityPage();
            e > -1 && (W.markRendering(e), T.current = !0, V(e));
        }
    }, [
        P
    ]);
    $62b21c508e360f33$var$a.useEffect(function() {
        g >= 0 && (W.markRendering(g), T.current = !0, V(g));
    }, [
        P,
        g
    ]), $6eW0i.useIsomorphicLayoutEffect(function() {
        D !== p && (W.markNotRendered(), z());
    }, [
        p
    ]);
    return $62b21c508e360f33$var$a.createElement("div", {
        ref: w,
        "data-testid": "thumbnail__list",
        className: $6eW0i.classNames({
            "rpv-thumbnail__list": !0,
            "rpv-thumbnail__list--horizontal": m === $62b21c508e360f33$export$89a0353aa2a7813.Horizontal,
            "rpv-thumbnail__list--rtl": S,
            "rpv-thumbnail__list--vertical": m === $62b21c508e360f33$export$89a0353aa2a7813.Vertical
        }),
        onKeyDown: function(e) {
            switch(e.key){
                case "ArrowDown":
                    H();
                    break;
                case "ArrowUp":
                    N();
                    break;
                case "Enter":
                    O();
            }
        }
    }, L.map(function(t, g) {
        var m = !1;
        switch(p){
            case $6eW0i.ViewMode.DualPage:
                m = n === 2 * g || n === 2 * g + 1;
                break;
            case $6eW0i.ViewMode.DualPageWithCover:
                m = 0 === n && 0 === g || g > 0 && n === 2 * g - 1 || g > 0 && n === 2 * g;
                break;
            case $6eW0i.ViewMode.SinglePage:
            default:
                m = n === g;
        }
        return $62b21c508e360f33$var$a.createElement("div", {
            className: $6eW0i.classNames({
                "rpv-thumbnail__items": !0,
                "rpv-thumbnail__items--dual": p === $6eW0i.ViewMode.DualPage,
                "rpv-thumbnail__items--dual-cover": p === $6eW0i.ViewMode.DualPageWithCover,
                "rpv-thumbnail__items--single": p === $6eW0i.ViewMode.SinglePage,
                "rpv-thumbnail__items--selected": m
            }),
            key: "".concat(g, "___").concat(p)
        }, t.map(function(t) {
            return function(t) {
                var g = p === $6eW0i.ViewMode.DualPageWithCover && (0 === t || _ % 2 == 0 && t === _ - 1), m = "".concat(i.loadingTask.docId, "___").concat(t), P = r.length === _ ? r[t] : "".concat(t + 1), w = l ? l({
                    currentPage: n,
                    pageIndex: t,
                    numPages: _,
                    pageLabel: P
                }) : P, E = o.has(t) ? o.get(t) : 0, x = $62b21c508e360f33$var$a.createElement($62b21c508e360f33$var$d, {
                    doc: i,
                    pageHeight: u,
                    pageIndex: t,
                    pageRotation: E,
                    pageWidth: c,
                    rotation: h,
                    shouldRender: I === t,
                    thumbnailWidth: b,
                    onRenderCompleted: j,
                    onVisibilityChanged: A
                });
                return s ? s({
                    currentPage: n,
                    key: m,
                    numPages: _,
                    pageIndex: t,
                    renderPageLabel: $62b21c508e360f33$var$a.createElement($62b21c508e360f33$var$a.Fragment, null, w),
                    renderPageThumbnail: x,
                    onJumpToPage: function() {
                        return f(t);
                    },
                    onRotatePage: function(e) {
                        return v(t, e);
                    }
                }) : $62b21c508e360f33$var$a.createElement("div", {
                    key: m
                }, $62b21c508e360f33$var$a.createElement("div", {
                    className: $6eW0i.classNames({
                        "rpv-thumbnail__item": !0,
                        "rpv-thumbnail__item--dual-even": p === $6eW0i.ViewMode.DualPage && t % 2 == 0,
                        "rpv-thumbnail__item--dual-odd": p === $6eW0i.ViewMode.DualPage && t % 2 == 1,
                        "rpv-thumbnail__item--dual-cover": g,
                        "rpv-thumbnail__item--dual-cover-even": p === $6eW0i.ViewMode.DualPageWithCover && !g && t % 2 == 0,
                        "rpv-thumbnail__item--dual-cover-odd": p === $6eW0i.ViewMode.DualPageWithCover && !g && t % 2 == 1,
                        "rpv-thumbnail__item--single": p === $6eW0i.ViewMode.SinglePage,
                        "rpv-thumbnail__item--selected": n === t
                    }),
                    role: "button",
                    tabIndex: n === t ? 0 : -1,
                    onClick: function() {
                        return f(t);
                    }
                }, x), $62b21c508e360f33$var$a.createElement("div", {
                    "data-testid": "thumbnail__label-".concat(t),
                    className: "rpv-thumbnail__label"
                }, w));
            }(t);
        }));
    }));
}, $62b21c508e360f33$var$h = function(t) {
    var n = t.renderCurrentPageLabel, i = t.renderThumbnailItem, r = t.store, o = t.thumbnailDirection, u = t.thumbnailWidth, s = $62b21c508e360f33$var$a.useState(r.get("doc")), d = s[0], h = s[1], m = $62b21c508e360f33$var$a.useState(r.get("currentPage") || 0), b = m[0], p = m[1], f = $62b21c508e360f33$var$a.useState(r.get("pageHeight") || 0), v = f[0], _ = f[1], P = $62b21c508e360f33$var$a.useState(r.get("pageWidth") || 0), w = P[0], E = P[1], x = $62b21c508e360f33$var$a.useState(r.get("rotation") || 0), R = x[0], C = x[1], S = $62b21c508e360f33$var$a.useState(r.get("pagesRotation") || new Map), M = S[0], I = S[1], V = $62b21c508e360f33$var$a.useState(r.get("rotatedPage") || -1), y = V[0], D = V[1], T = $62b21c508e360f33$var$a.useState(r.get("viewMode")), W = T[0], k = T[1], L = function(e) {
        p(e);
    }, H = function(e) {
        h(e);
    }, N = function(e) {
        _(e);
    }, O = function(e) {
        E(e);
    }, j = function(e) {
        C(e);
    }, A = function(e) {
        I(e);
    }, z = function(e) {
        D(e);
    }, B = function(e) {
        k(e);
    }, q = function(e) {
        var t = r.get("jumpToPage");
        t && t(e);
    }, J = function(e, t) {
        r.get("rotatePage")(e, t);
    };
    return $62b21c508e360f33$var$a.useEffect(function() {
        return r.subscribe("doc", H), r.subscribe("pageHeight", N), r.subscribe("pageWidth", O), r.subscribe("rotatedPage", z), r.subscribe("rotation", j), r.subscribe("pagesRotation", A), r.subscribe("viewMode", B), function() {
            r.unsubscribe("doc", H), r.unsubscribe("pageHeight", N), r.unsubscribe("pageWidth", O), r.unsubscribe("rotatedPage", z), r.unsubscribe("rotation", j), r.unsubscribe("pagesRotation", A), r.unsubscribe("viewMode", B);
        };
    }, []), $6eW0i.useIsomorphicLayoutEffect(function() {
        return r.subscribe("currentPage", L), function() {
            r.unsubscribe("currentPage", L);
        };
    }, []), d ? $62b21c508e360f33$var$a.createElement($6eW0i.LazyRender, {
        testId: "thumbnail__list-container",
        attrs: {
            className: "rpv-thumbnail__list-container"
        }
    }, $62b21c508e360f33$var$a.createElement($62b21c508e360f33$var$l, {
        doc: d
    }, function(e) {
        return $62b21c508e360f33$var$a.createElement($62b21c508e360f33$var$g, {
            currentPage: b,
            doc: d,
            labels: e,
            pagesRotation: M,
            pageHeight: v,
            pageWidth: w,
            renderCurrentPageLabel: n,
            renderThumbnailItem: i,
            rotatedPage: y,
            rotation: R,
            thumbnailDirection: o,
            thumbnailWidth: u,
            viewMode: W,
            onJumpToPage: q,
            onRotatePage: J
        });
    })) : $62b21c508e360f33$var$a.createElement("div", {
        "data-testid": "thumbnail-list__loader",
        className: "rpv-thumbnail__loader"
    }, $62b21c508e360f33$var$a.useContext($62b21c508e360f33$var$c).renderSpinner());
};
$62b21c508e360f33$export$e906a958693f3d0e = function(t) {
    var n = $62b21c508e360f33$var$a.useMemo(function() {
        return $6eW0i.createStore({
            rotatePage: function() {},
            viewMode: $6eW0i.ViewMode.SinglePage
        });
    }, []), r = $62b21c508e360f33$var$a.useState(""), l = r[0], s = r[1];
    return {
        install: function(e) {
            n.update("jumpToPage", e.jumpToPage), n.update("rotatePage", e.rotatePage);
        },
        onDocumentLoad: function(e) {
            s(e.doc.loadingTask.docId), n.update("doc", e.doc);
        },
        onViewerStateChange: function(e) {
            return n.update("currentPage", e.pageIndex), n.update("pagesRotation", e.pagesRotation), n.update("pageHeight", e.pageHeight), n.update("pageWidth", e.pageWidth), n.update("rotation", e.rotation), n.update("rotatedPage", e.rotatedPage), n.update("viewMode", e.viewMode), e;
        },
        Cover: function(e) {
            return $62b21c508e360f33$var$a.createElement($62b21c508e360f33$var$o, $62b21c508e360f33$var$i({}, e, {
                renderSpinner: null == t ? void 0 : t.renderSpinner,
                store: n
            }));
        },
        Thumbnails: $62b21c508e360f33$var$a.useCallback(function(e) {
            return $62b21c508e360f33$var$a.createElement($62b21c508e360f33$var$c.Provider, {
                value: {
                    renderSpinner: (null == t ? void 0 : t.renderSpinner) || $62b21c508e360f33$var$u
                }
            }, $62b21c508e360f33$var$a.createElement($62b21c508e360f33$var$h, {
                renderCurrentPageLabel: null == t ? void 0 : t.renderCurrentPageLabel,
                renderThumbnailItem: null == e ? void 0 : e.renderThumbnailItem,
                store: n,
                thumbnailDirection: (null == e ? void 0 : e.thumbnailDirection) || $62b21c508e360f33$export$89a0353aa2a7813.Vertical,
                thumbnailWidth: (null == t ? void 0 : t.thumbnailWidth) || 100
            }));
        }, [
            l
        ])
    };
};

});


parcelRegister("gmUVm", function(module, exports) {
/**
 * A React component to view a PDF document
 *
 * @see https://react-pdf-viewer.dev
 * @license https://react-pdf-viewer.dev/license
 * @copyright 2019-2023 Nguyen Huu Phuoc <me@phuoc.ng>
 */ "use strict";

module.exports = (parcelRequire("54wdE"));

});
parcelRegister("54wdE", function(module, exports) {

$parcel$export(module.exports, "MoreActionsPopover", () => $3b16518d398f0aca$export$c440f8bdea8d21ab, (v) => $3b16518d398f0aca$export$c440f8bdea8d21ab = v);
$parcel$export(module.exports, "MoreIcon", () => $3b16518d398f0aca$export$b3275b74ff1b7092, (v) => $3b16518d398f0aca$export$b3275b74ff1b7092 = v);
$parcel$export(module.exports, "toolbarPlugin", () => $3b16518d398f0aca$export$2235d7d328f4404b, (v) => $3b16518d398f0aca$export$2235d7d328f4404b = v);
var $3b16518d398f0aca$export$c440f8bdea8d21ab;
var $3b16518d398f0aca$export$b3275b74ff1b7092;
var $3b16518d398f0aca$export$2235d7d328f4404b;
"use strict";

var $6eW0i = parcelRequire("6eW0i");

var $hTCLA = parcelRequire("hTCLA");

var $kc00y = parcelRequire("kc00y");

var $2ZIsE = parcelRequire("2ZIsE");

var $hdrSh = parcelRequire("hdrSh");

var $jGGRT = parcelRequire("jGGRT");

var $eSZE0 = parcelRequire("eSZE0");

var $OvUAV = parcelRequire("OvUAV");

var $ebXBL = parcelRequire("ebXBL");

var $hMzN7 = parcelRequire("hMzN7");

var $9q7c7 = parcelRequire("9q7c7");

var $2B2g9 = parcelRequire("2B2g9");

var $5QSSA = parcelRequire("5QSSA");

var $dn2na = parcelRequire("dn2na");
function $3b16518d398f0aca$var$v(e) {
    var t = Object.create(null);
    return e && Object.keys(e).forEach(function(r) {
        if ("default" !== r) {
            var n = Object.getOwnPropertyDescriptor(e, r);
            Object.defineProperty(t, r, n.get ? n : {
                enumerable: !0,
                get: function() {
                    return e[r];
                }
            });
        }
    }), t.default = e, Object.freeze(t);
}
var $3b16518d398f0aca$var$_ = $3b16518d398f0aca$var$v($kc00y), $3b16518d398f0aca$var$E = function() {
    return $3b16518d398f0aca$var$_.createElement($6eW0i.Icon, {
        size: 16
    }, $3b16518d398f0aca$var$_.createElement("path", {
        d: "M12,0.5c1.381,0,2.5,1.119,2.5,2.5S13.381,5.5,12,5.5S9.5,4.381,9.5,3S10.619,0.5,12,0.5z\n            M12,9.5\n            c1.381,0,2.5,1.119,2.5,2.5s-1.119,2.5-2.5,2.5S9.5,13.381,9.5,12S10.619,9.5,12,9.5z\n            M12,18.5c1.381,0,2.5,1.119,2.5,2.5\n            s-1.119,2.5-2.5,2.5S9.5,22.381,9.5,21S10.619,18.5,12,18.5z"
    }));
}, $3b16518d398f0aca$var$g = {
    left: 0,
    top: 8
}, $3b16518d398f0aca$var$P = function(r) {
    var n = r.toolbarSlot, o = $3b16518d398f0aca$var$_.useContext($6eW0i.LocalizationContext).l10n, a = $3b16518d398f0aca$var$_.useContext($6eW0i.ThemeContext).direction === $6eW0i.TextDirection.RightToLeft ? $6eW0i.Position.BottomLeft : $6eW0i.Position.BottomRight, l = n.DownloadMenuItem, i = n.EnterFullScreenMenuItem, c = n.GoToFirstPageMenuItem, m = n.GoToLastPageMenuItem, u = n.GoToNextPageMenuItem, s = n.GoToPreviousPageMenuItem, d = n.OpenMenuItem, p = n.PrintMenuItem, v = n.RotateBackwardMenuItem, P = n.RotateForwardMenuItem, M = n.ShowPropertiesMenuItem, h = n.SwitchScrollModeMenuItem, f = n.SwitchSelectionModeMenuItem, S = n.SwitchViewModeMenuItem, I = n.SwitchThemeMenuItem;
    return $3b16518d398f0aca$var$_.createElement($6eW0i.Popover, {
        ariaControlsSuffix: "toolbar-more-actions",
        ariaHasPopup: "menu",
        position: a,
        target: function(t, r) {
            var n = o && o.toolbar ? o.toolbar.moreActions : "More actions";
            return $3b16518d398f0aca$var$_.createElement($6eW0i.Tooltip, {
                ariaControlsSuffix: "toolbar-more-actions",
                position: a,
                target: $3b16518d398f0aca$var$_.createElement($6eW0i.MinimalButton, {
                    ariaLabel: n,
                    isSelected: r,
                    testId: "toolbar__more-actions-popover-target",
                    onClick: t
                }, $3b16518d398f0aca$var$_.createElement($3b16518d398f0aca$var$E, null)),
                content: function() {
                    return n;
                },
                offset: $3b16518d398f0aca$var$g
            });
        },
        content: function(r) {
            return $3b16518d398f0aca$var$_.createElement($6eW0i.Menu, null, $3b16518d398f0aca$var$_.createElement("div", {
                className: "rpv-core__display--block rpv-core__display--hidden-medium"
            }, $3b16518d398f0aca$var$_.createElement(I, {
                onClick: r
            })), $3b16518d398f0aca$var$_.createElement("div", {
                className: "rpv-core__display--block rpv-core__display--hidden-medium"
            }, $3b16518d398f0aca$var$_.createElement(i, {
                onClick: r
            })), $3b16518d398f0aca$var$_.createElement("div", {
                className: "rpv-core__display--block rpv-core__display--hidden-medium"
            }, $3b16518d398f0aca$var$_.createElement(d, null)), $3b16518d398f0aca$var$_.createElement("div", {
                className: "rpv-core__display--block rpv-core__display--hidden-medium"
            }, $3b16518d398f0aca$var$_.createElement(p, {
                onClick: r
            })), $3b16518d398f0aca$var$_.createElement("div", {
                className: "rpv-core__display--block rpv-core__display--hidden-medium"
            }, $3b16518d398f0aca$var$_.createElement(l, {
                onClick: r
            })), $3b16518d398f0aca$var$_.createElement("div", {
                className: "rpv-core__display--block rpv-core__display--hidden-medium"
            }, $3b16518d398f0aca$var$_.createElement($6eW0i.MenuDivider, null)), $3b16518d398f0aca$var$_.createElement(c, {
                onClick: r
            }), $3b16518d398f0aca$var$_.createElement("div", {
                className: "rpv-core__display--block rpv-core__display--hidden-medium"
            }, $3b16518d398f0aca$var$_.createElement(s, {
                onClick: r
            })), $3b16518d398f0aca$var$_.createElement("div", {
                className: "rpv-core__display--block rpv-core__display--hidden-medium"
            }, $3b16518d398f0aca$var$_.createElement(u, {
                onClick: r
            })), $3b16518d398f0aca$var$_.createElement(m, {
                onClick: r
            }), $3b16518d398f0aca$var$_.createElement($6eW0i.MenuDivider, null), $3b16518d398f0aca$var$_.createElement(P, {
                onClick: r
            }), $3b16518d398f0aca$var$_.createElement(v, {
                onClick: r
            }), $3b16518d398f0aca$var$_.createElement($6eW0i.MenuDivider, null), $3b16518d398f0aca$var$_.createElement(f, {
                mode: $hTCLA.SelectionMode.Text,
                onClick: r
            }), $3b16518d398f0aca$var$_.createElement(f, {
                mode: $hTCLA.SelectionMode.Hand,
                onClick: r
            }), $3b16518d398f0aca$var$_.createElement($6eW0i.MenuDivider, null), $3b16518d398f0aca$var$_.createElement(h, {
                mode: $6eW0i.ScrollMode.Page,
                onClick: r
            }), $3b16518d398f0aca$var$_.createElement(h, {
                mode: $6eW0i.ScrollMode.Vertical,
                onClick: r
            }), $3b16518d398f0aca$var$_.createElement(h, {
                mode: $6eW0i.ScrollMode.Horizontal,
                onClick: r
            }), $3b16518d398f0aca$var$_.createElement(h, {
                mode: $6eW0i.ScrollMode.Wrapped,
                onClick: r
            }), $3b16518d398f0aca$var$_.createElement($6eW0i.MenuDivider, null), $3b16518d398f0aca$var$_.createElement("div", {
                className: "rpv-core__display--hidden rpv-core__display--block-small"
            }, $3b16518d398f0aca$var$_.createElement(S, {
                mode: $6eW0i.ViewMode.SinglePage,
                onClick: r
            })), $3b16518d398f0aca$var$_.createElement("div", {
                className: "rpv-core__display--hidden rpv-core__display--block-small"
            }, $3b16518d398f0aca$var$_.createElement(S, {
                mode: $6eW0i.ViewMode.DualPage,
                onClick: r
            })), $3b16518d398f0aca$var$_.createElement("div", {
                className: "rpv-core__display--hidden rpv-core__display--block-small"
            }, $3b16518d398f0aca$var$_.createElement(S, {
                mode: $6eW0i.ViewMode.DualPageWithCover,
                onClick: r
            })), $3b16518d398f0aca$var$_.createElement("div", {
                className: "rpv-core__display--hidden rpv-core__display--block-small"
            }, $3b16518d398f0aca$var$_.createElement($6eW0i.MenuDivider, null)), $3b16518d398f0aca$var$_.createElement(M, {
                onClick: r
            }));
        },
        offset: $3b16518d398f0aca$var$g,
        closeOnClickOutside: !0,
        closeOnEscape: !0
    });
}, $3b16518d398f0aca$var$M = function() {
    return $3b16518d398f0aca$var$M = Object.assign || function(e) {
        for(var t, r = 1, n = arguments.length; r < n; r++)for(var o in t = arguments[r])Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
    }, $3b16518d398f0aca$var$M.apply(this, arguments);
}, $3b16518d398f0aca$var$h = function(t) {
    return function(r) {
        var n = $3b16518d398f0aca$var$_.useMemo(function() {
            return t(r);
        }, []), o = $3b16518d398f0aca$var$_.useContext($6eW0i.ThemeContext).direction === $6eW0i.TextDirection.RightToLeft, a = n.CurrentPageInput, l = n.Download, i = n.EnterFullScreen, c = n.GoToNextPage, m = n.GoToPreviousPage, u = n.NumberOfPages, s = n.Open, d = n.Print, p = n.ShowSearchPopover, v = n.SwitchTheme, E = n.Zoom, g = n.ZoomIn, M = n.ZoomOut;
        return $3b16518d398f0aca$var$_.createElement("div", {
            "data-testid": "toolbar",
            className: $6eW0i.classNames({
                "rpv-toolbar": !0,
                "rpv-toolbar--rtl": o
            }),
            role: "toolbar",
            "aria-orientation": "horizontal"
        }, $3b16518d398f0aca$var$_.createElement("div", {
            className: "rpv-toolbar__left"
        }, $3b16518d398f0aca$var$_.createElement("div", {
            className: "rpv-toolbar__item"
        }, $3b16518d398f0aca$var$_.createElement(p, null)), $3b16518d398f0aca$var$_.createElement("div", {
            className: "rpv-core__display--hidden rpv-core__display--block-small"
        }, $3b16518d398f0aca$var$_.createElement("div", {
            className: "rpv-toolbar__item"
        }, $3b16518d398f0aca$var$_.createElement(m, null))), $3b16518d398f0aca$var$_.createElement("div", {
            className: "rpv-toolbar__item"
        }, $3b16518d398f0aca$var$_.createElement(a, null), $3b16518d398f0aca$var$_.createElement("span", {
            className: "rpv-toolbar__label"
        }, $3b16518d398f0aca$var$_.createElement(u, null))), $3b16518d398f0aca$var$_.createElement("div", {
            className: "rpv-core__display--hidden rpv-core__display--block-small"
        }, $3b16518d398f0aca$var$_.createElement("div", {
            className: "rpv-toolbar__item"
        }, $3b16518d398f0aca$var$_.createElement(c, null)))), $3b16518d398f0aca$var$_.createElement("div", {
            className: "rpv-toolbar__center"
        }, $3b16518d398f0aca$var$_.createElement("div", {
            className: "rpv-toolbar__item"
        }, $3b16518d398f0aca$var$_.createElement(M, null)), $3b16518d398f0aca$var$_.createElement("div", {
            className: "rpv-core__display--hidden rpv-core__display--block-small"
        }, $3b16518d398f0aca$var$_.createElement("div", {
            className: "rpv-toolbar__item"
        }, $3b16518d398f0aca$var$_.createElement(E, null))), $3b16518d398f0aca$var$_.createElement("div", {
            className: "rpv-toolbar__item"
        }, $3b16518d398f0aca$var$_.createElement(g, null))), $3b16518d398f0aca$var$_.createElement("div", {
            className: "rpv-toolbar__right"
        }, $3b16518d398f0aca$var$_.createElement("div", {
            className: "rpv-core__display--hidden rpv-core__display--block-medium"
        }, $3b16518d398f0aca$var$_.createElement("div", {
            className: "rpv-toolbar__item"
        }, $3b16518d398f0aca$var$_.createElement(v, null))), $3b16518d398f0aca$var$_.createElement("div", {
            className: "rpv-core__display--hidden rpv-core__display--block-medium"
        }, $3b16518d398f0aca$var$_.createElement("div", {
            className: "rpv-toolbar__item"
        }, $3b16518d398f0aca$var$_.createElement(i, null))), $3b16518d398f0aca$var$_.createElement("div", {
            className: "rpv-core__display--hidden rpv-core__display--block-medium"
        }, $3b16518d398f0aca$var$_.createElement("div", {
            className: "rpv-toolbar__item"
        }, $3b16518d398f0aca$var$_.createElement(s, null))), $3b16518d398f0aca$var$_.createElement("div", {
            className: "rpv-core__display--hidden rpv-core__display--block-medium"
        }, $3b16518d398f0aca$var$_.createElement("div", {
            className: "rpv-toolbar__item"
        }, $3b16518d398f0aca$var$_.createElement(l, null))), $3b16518d398f0aca$var$_.createElement("div", {
            className: "rpv-core__display--hidden rpv-core__display--block-medium"
        }, $3b16518d398f0aca$var$_.createElement("div", {
            className: "rpv-toolbar__item"
        }, $3b16518d398f0aca$var$_.createElement(d, null))), $3b16518d398f0aca$var$_.createElement("div", {
            className: "rpv-toolbar__item"
        }, $3b16518d398f0aca$var$_.createElement($3b16518d398f0aca$var$P, {
            toolbarSlot: n
        }))));
    };
}, $3b16518d398f0aca$var$f = function(e) {
    var t = e.NumberOfPages;
    return Object.assign({}, e, {
        NumberOfPages: function() {
            return $3b16518d398f0aca$var$_.createElement($3b16518d398f0aca$var$_.Fragment, null, "/ ", $3b16518d398f0aca$var$_.createElement(t, null));
        }
    });
}, $3b16518d398f0aca$var$S = function(e) {
    return $3b16518d398f0aca$var$h($3b16518d398f0aca$var$f)(e);
}, $3b16518d398f0aca$var$I = function(e) {
    var t = e.children, r = e.slot;
    return (t || $3b16518d398f0aca$var$S)(r);
};
$3b16518d398f0aca$export$c440f8bdea8d21ab = $3b16518d398f0aca$var$P, $3b16518d398f0aca$export$b3275b74ff1b7092 = $3b16518d398f0aca$var$E, $3b16518d398f0aca$export$2235d7d328f4404b = function(e) {
    var r = $2ZIsE.fullScreenPlugin(e ? e.fullScreenPlugin : {}), v = $hdrSh.getFilePlugin(e ? e.getFilePlugin : {}), E = $jGGRT.openPlugin(e ? e.openPlugin : {}), g = $eSZE0.pageNavigationPlugin(e ? e.pageNavigationPlugin : {}), P = $OvUAV.printPlugin(e ? e.printPlugin : {}), f = $ebXBL.propertiesPlugin(), S = $hMzN7.rotatePlugin(), b = $9q7c7.scrollModePlugin(), w = $2B2g9.searchPlugin(e ? e.searchPlugin : {}), y = $hTCLA.selectionModePlugin(e ? e.selectionModePlugin : {}), N = $5QSSA.themePlugin(), k = $dn2na.zoomPlugin(e ? e.zoomPlugin : {}), C = [
        r,
        v,
        E,
        g,
        P,
        f,
        S,
        b,
        w,
        y,
        N,
        k
    ], T = $3b16518d398f0aca$var$_.useCallback(function(e) {
        var t = r.EnterFullScreen, n = r.EnterFullScreenMenuItem, o = v.Download, a = v.DownloadMenuItem, l = E.Open, i = E.OpenMenuItem, c = g.CurrentPageInput, m = g.CurrentPageLabel, u = g.GoToFirstPage, s = g.GoToFirstPageMenuItem, d = g.GoToLastPage, p = g.GoToLastPageMenuItem, h = g.GoToNextPage, C = g.GoToNextPageMenuItem, T = g.GoToPreviousPage, O = g.GoToPreviousPageMenuItem, L = g.NumberOfPages, x = P.Print, G = P.PrintMenuItem, D = f.ShowProperties, F = f.ShowPropertiesMenuItem, R = S.Rotate, V = S.RotateBackwardMenuItem, q = S.RotateForwardMenuItem, Z = b.SwitchScrollMode, z = b.SwitchScrollModeMenuItem, j = b.SwitchViewMode, B = b.SwitchViewModeMenuItem, A = w.Search, H = w.ShowSearchPopover, W = y.SwitchSelectionMode, J = y.SwitchSelectionModeMenuItem, K = N.SwitchTheme, Q = N.SwitchThemeMenuItem, U = k.CurrentScale, X = k.Zoom, Y = k.ZoomIn, $ = k.ZoomInMenuItem, ee = k.ZoomOut, te = k.ZoomOutMenuItem;
        return $3b16518d398f0aca$var$_.createElement($3b16518d398f0aca$var$I, $3b16518d398f0aca$var$M({}, e, {
            slot: {
                CurrentPageInput: c,
                CurrentPageLabel: m,
                CurrentScale: U,
                Download: o,
                DownloadMenuItem: a,
                EnterFullScreen: t,
                EnterFullScreenMenuItem: n,
                GoToFirstPage: u,
                GoToFirstPageMenuItem: s,
                GoToLastPage: d,
                GoToLastPageMenuItem: p,
                GoToNextPage: h,
                GoToNextPageMenuItem: C,
                GoToPreviousPage: T,
                GoToPreviousPageMenuItem: O,
                NumberOfPages: L,
                Open: l,
                OpenMenuItem: i,
                Print: x,
                PrintMenuItem: G,
                Rotate: R,
                RotateBackwardMenuItem: V,
                RotateForwardMenuItem: q,
                Search: A,
                ShowProperties: D,
                ShowPropertiesMenuItem: F,
                ShowSearchPopover: H,
                SwitchScrollMode: Z,
                SwitchScrollModeMenuItem: z,
                SwitchSelectionMode: W,
                SwitchSelectionModeMenuItem: J,
                SwitchViewMode: j,
                SwitchViewModeMenuItem: B,
                SwitchTheme: K,
                SwitchThemeMenuItem: Q,
                Zoom: X,
                ZoomIn: Y,
                ZoomInMenuItem: $,
                ZoomOut: ee,
                ZoomOutMenuItem: te
            }
        }));
    }, []);
    return {
        fullScreenPluginInstance: r,
        getFilePluginInstance: v,
        openPluginInstance: E,
        pageNavigationPluginInstance: g,
        printPluginInstance: P,
        propertiesPluginInstance: f,
        rotatePluginInstance: S,
        scrollModePluginInstance: b,
        searchPluginInstance: w,
        selectionModePluginInstance: y,
        themePluginInstance: N,
        zoomPluginInstance: k,
        install: function(e) {
            C.forEach(function(t) {
                t.install && t.install(e);
            });
        },
        renderPageLayer: function(e) {
            return $3b16518d398f0aca$var$_.createElement($3b16518d398f0aca$var$_.Fragment, null, C.map(function(t, r) {
                return t.renderPageLayer ? $3b16518d398f0aca$var$_.createElement($3b16518d398f0aca$var$_.Fragment, {
                    key: r
                }, t.renderPageLayer(e)) : $3b16518d398f0aca$var$_.createElement($3b16518d398f0aca$var$_.Fragment, {
                    key: r
                });
            }));
        },
        renderViewer: function(e) {
            var t = e.slot;
            return C.forEach(function(r) {
                r.renderViewer && (t = r.renderViewer($3b16518d398f0aca$var$M($3b16518d398f0aca$var$M({}, e), {
                    slot: t
                })));
            }), t;
        },
        uninstall: function(e) {
            C.forEach(function(t) {
                t.uninstall && t.uninstall(e);
            });
        },
        onDocumentLoad: function(e) {
            C.forEach(function(t) {
                t.onDocumentLoad && t.onDocumentLoad(e);
            });
        },
        onAnnotationLayerRender: function(e) {
            C.forEach(function(t) {
                t.onAnnotationLayerRender && t.onAnnotationLayerRender(e);
            });
        },
        onTextLayerRender: function(e) {
            C.forEach(function(t) {
                t.onTextLayerRender && t.onTextLayerRender(e);
            });
        },
        onViewerStateChange: function(e) {
            var t = e;
            return C.forEach(function(e) {
                e.onViewerStateChange && (t = e.onViewerStateChange(t));
            }), t;
        },
        renderDefaultToolbar: $3b16518d398f0aca$var$h,
        Toolbar: T
    };
};

});
parcelRegister("hTCLA", function(module, exports) {
/**
 * A React component to view a PDF document
 *
 * @see https://react-pdf-viewer.dev
 * @license https://react-pdf-viewer.dev/license
 * @copyright 2019-2023 Nguyen Huu Phuoc <me@phuoc.ng>
 */ "use strict";

module.exports = (parcelRequire("fotAb"));

});
parcelRegister("fotAb", function(module, exports) {

$parcel$export(module.exports, "SelectionMode", () => $b3500b6633028c9d$export$91484609d16ec765, (v) => $b3500b6633028c9d$export$91484609d16ec765 = v);
$parcel$export(module.exports, "HandToolIcon", () => $b3500b6633028c9d$export$462bc50cae93bda5, (v) => $b3500b6633028c9d$export$462bc50cae93bda5 = v);
$parcel$export(module.exports, "TextSelectionIcon", () => $b3500b6633028c9d$export$1807f06f8336a9d6, (v) => $b3500b6633028c9d$export$1807f06f8336a9d6 = v);
$parcel$export(module.exports, "selectionModePlugin", () => $b3500b6633028c9d$export$c35187bfc4883253, (v) => $b3500b6633028c9d$export$c35187bfc4883253 = v);
var $b3500b6633028c9d$export$91484609d16ec765;
var $b3500b6633028c9d$export$462bc50cae93bda5;
var $b3500b6633028c9d$export$1807f06f8336a9d6;
var $b3500b6633028c9d$export$c35187bfc4883253;
"use strict";

var $6eW0i = parcelRequire("6eW0i");
function $b3500b6633028c9d$var$t(e) {
    var t = Object.create(null);
    return e && Object.keys(e).forEach(function(n) {
        if ("default" !== n) {
            var o = Object.getOwnPropertyDescriptor(e, n);
            Object.defineProperty(t, n, o.get ? o : {
                enumerable: !0,
                get: function() {
                    return e[n];
                }
            });
        }
    }), t.default = e, Object.freeze(t);
}
var $b3500b6633028c9d$var$n;

var $b3500b6633028c9d$var$o = $b3500b6633028c9d$var$t((parcelRequire("kc00y"))), $b3500b6633028c9d$var$c = function() {
    return $b3500b6633028c9d$var$o.createElement($6eW0i.Icon, {
        size: 16
    }, $b3500b6633028c9d$var$o.createElement("path", {
        d: "M11.5,5.5v-2C11.5,2.672,12.172,2,13,2s1.5,0.672,1.5,1.5v2 M14.5,11.5v-6C14.5,4.672,15.172,4,16,4\n            c0.828,0,1.5,0.672,1.5,1.5v3 M17.5,13V8.5C17.5,7.672,18.172,7,19,7s1.5,0.672,1.5,1.5v10c0,2.761-2.239,5-5,5h-3.335\n            c-1.712-0.001-3.305-0.876-4.223-2.321C6.22,18.467,4.083,14,4.083,14c-0.378-0.545-0.242-1.292,0.303-1.67\n            c0.446-0.309,1.044-0.281,1.458,0.07L8.5,15.5v-10C8.5,4.672,9.172,4,10,4s1.5,0.672,1.5,1.5v6"
    }));
}, $b3500b6633028c9d$var$r = function() {
    return $b3500b6633028c9d$var$r = Object.assign || function(e) {
        for(var t, n = 1, o = arguments.length; n < o; n++)for(var c in t = arguments[n])Object.prototype.hasOwnProperty.call(t, c) && (e[c] = t[c]);
        return e;
    }, $b3500b6633028c9d$var$r.apply(this, arguments);
};
$b3500b6633028c9d$export$91484609d16ec765 = void 0, ($b3500b6633028c9d$var$n = $b3500b6633028c9d$export$91484609d16ec765 || ($b3500b6633028c9d$export$91484609d16ec765 = {})).Hand = "Hand", $b3500b6633028c9d$var$n.Text = "Text";
var $b3500b6633028c9d$var$i = function() {
    return $b3500b6633028c9d$var$o.createElement($6eW0i.Icon, {
        size: 16
    }, $b3500b6633028c9d$var$o.createElement("path", {
        d: "M13.675,11.671l2.941-2.941c0.195-0.196,0.195-0.512-0.001-0.707C16.563,7.971,16.5,7.931,16.43,7.906\n            L4.168,3.527C3.908,3.434,3.622,3.57,3.529,3.83c-0.039,0.109-0.039,0.228,0,0.336l4.379,12.262\n            c0.093,0.26,0.379,0.396,0.639,0.303c0.07-0.025,0.133-0.065,0.185-0.117l2.943-2.943l6.146,6.146c0.195,0.195,0.512,0.195,0.707,0\n            l1.293-1.293c0.195-0.195,0.195-0.512,0-0.707L13.675,11.671z"
    }));
}, $b3500b6633028c9d$var$l = function(t) {
    var n = t.children, r = t.mode, l = t.onClick, s = $b3500b6633028c9d$var$o.useContext($6eW0i.LocalizationContext).l10n, u = "", a = $b3500b6633028c9d$var$o.createElement($b3500b6633028c9d$var$i, null);
    switch(r){
        case $b3500b6633028c9d$export$91484609d16ec765.Hand:
            u = s && s.selectionMode ? s.selectionMode.handTool : "Hand tool", a = $b3500b6633028c9d$var$o.createElement($b3500b6633028c9d$var$c, null);
            break;
        case $b3500b6633028c9d$export$91484609d16ec765.Text:
        default:
            u = s && s.selectionMode ? s.selectionMode.textSelectionTool : "Text selection tool", a = $b3500b6633028c9d$var$o.createElement($b3500b6633028c9d$var$i, null);
    }
    return n({
        icon: a,
        label: u,
        onClick: l
    });
}, $b3500b6633028c9d$var$s = {
    left: 0,
    top: 8
}, $b3500b6633028c9d$var$u = function(t) {
    var n = t.isSelected, c = t.mode, r = t.onClick, i = "";
    switch(c){
        case $b3500b6633028c9d$export$91484609d16ec765.Hand:
            i = "selection-mode__hand-button";
            break;
        case $b3500b6633028c9d$export$91484609d16ec765.Text:
        default:
            i = "selection-mode__text-button";
    }
    return $b3500b6633028c9d$var$o.createElement($b3500b6633028c9d$var$l, {
        mode: c,
        onClick: r
    }, function(t) {
        return $b3500b6633028c9d$var$o.createElement($6eW0i.Tooltip, {
            ariaControlsSuffix: "selection-mode-switch",
            position: $6eW0i.Position.BottomCenter,
            target: $b3500b6633028c9d$var$o.createElement($6eW0i.MinimalButton, {
                ariaLabel: t.label,
                isSelected: n,
                testId: i,
                onClick: t.onClick
            }, t.icon),
            content: function() {
                return t.label;
            },
            offset: $b3500b6633028c9d$var$s
        });
    });
}, $b3500b6633028c9d$var$a = function(e) {
    var t = e.children, n = e.mode, c = e.store, r = n === c.get("selectionMode");
    return (t || function(e) {
        return $b3500b6633028c9d$var$o.createElement($b3500b6633028c9d$var$u, {
            isSelected: r,
            mode: e.mode,
            onClick: e.onClick
        });
    })({
        isSelected: r,
        mode: n,
        onClick: function() {
            return c.update("selectionMode", n);
        }
    });
}, $b3500b6633028c9d$var$d = function(t) {
    var n = t.isSelected, c = t.mode, r = t.onClick, i = "";
    switch(c){
        case $b3500b6633028c9d$export$91484609d16ec765.Hand:
            i = "selection-mode__hand-menu";
            break;
        case $b3500b6633028c9d$export$91484609d16ec765.Text:
        default:
            i = "selection-mode__text-menu";
    }
    return $b3500b6633028c9d$var$o.createElement($b3500b6633028c9d$var$l, {
        mode: c,
        onClick: r
    }, function(t) {
        return $b3500b6633028c9d$var$o.createElement($6eW0i.MenuItem, {
            checked: n,
            icon: t.icon,
            testId: i,
            onClick: t.onClick
        }, t.label);
    });
}, $b3500b6633028c9d$var$m = function(e) {
    var t = e.store, n = $b3500b6633028c9d$var$o.useRef(null), c = $b3500b6633028c9d$var$o.useState($b3500b6633028c9d$export$91484609d16ec765.Text), r = c[0], i = c[1], l = $b3500b6633028c9d$var$o.useRef({
        top: 0,
        left: 0,
        x: 0,
        y: 0
    }), s = function(e) {
        var t = n.current;
        t && (t.scrollTop = l.current.top - (e.clientY - l.current.y), t.scrollLeft = l.current.left - (e.clientX - l.current.x));
    }, u = function() {
        var e = n.current;
        e && (e.classList.add("rpv-selection-mode__grab"), e.classList.remove("rpv-selection-mode__grabbing"), document.removeEventListener("mousemove", s), document.removeEventListener("mouseup", u));
    }, a = function(e) {
        var t = n.current;
        t && r !== $b3500b6633028c9d$export$91484609d16ec765.Text && (t.classList.remove("rpv-selection-mode__grab"), t.classList.add("rpv-selection-mode__grabbing"), e.preventDefault(), e.stopPropagation(), l.current = {
            left: t.scrollLeft,
            top: t.scrollTop,
            x: e.clientX,
            y: e.clientY
        }, document.addEventListener("mousemove", s), document.addEventListener("mouseup", u));
    }, d = function(e) {
        n.current = e();
    }, m = function(e) {
        i(e);
    };
    return $b3500b6633028c9d$var$o.useEffect(function() {
        var e = n.current;
        if (e) return r === $b3500b6633028c9d$export$91484609d16ec765.Hand ? e.classList.add("rpv-selection-mode__grab") : e.classList.remove("rpv-selection-mode__grab"), e.addEventListener("mousedown", a), function() {
            e.removeEventListener("mousedown", a);
        };
    }, [
        r
    ]), $b3500b6633028c9d$var$o.useEffect(function() {
        return t.subscribe("getPagesContainer", d), t.subscribe("selectionMode", m), function() {
            t.unsubscribe("getPagesContainer", d), t.unsubscribe("selectionMode", m);
        };
    }, []), $b3500b6633028c9d$var$o.createElement($b3500b6633028c9d$var$o.Fragment, null);
};
$b3500b6633028c9d$export$462bc50cae93bda5 = $b3500b6633028c9d$var$c, $b3500b6633028c9d$export$1807f06f8336a9d6 = $b3500b6633028c9d$var$i, $b3500b6633028c9d$export$c35187bfc4883253 = function(t) {
    var n = $b3500b6633028c9d$var$o.useMemo(function() {
        return $6eW0i.createStore();
    }, []), c = function(e) {
        return $b3500b6633028c9d$var$o.createElement($b3500b6633028c9d$var$a, $b3500b6633028c9d$var$r({}, e, {
            store: n
        }));
    };
    return {
        install: function(e) {
            n.update("selectionMode", t && t.selectionMode ? t.selectionMode : $b3500b6633028c9d$export$91484609d16ec765.Text), n.update("getPagesContainer", e.getPagesContainer);
        },
        renderViewer: function(e) {
            var t = e.slot;
            return t.subSlot && t.subSlot.children && (t.subSlot.children = $b3500b6633028c9d$var$o.createElement($b3500b6633028c9d$var$o.Fragment, null, $b3500b6633028c9d$var$o.createElement($b3500b6633028c9d$var$m, {
                store: n
            }), t.subSlot.children)), t;
        },
        SwitchSelectionMode: c,
        SwitchSelectionModeButton: function(e) {
            return $b3500b6633028c9d$var$o.createElement(c, {
                mode: e.mode
            }, function(e) {
                return $b3500b6633028c9d$var$o.createElement($b3500b6633028c9d$var$u, {
                    isSelected: e.isSelected,
                    mode: e.mode,
                    onClick: function() {
                        e.onClick();
                    }
                });
            });
        },
        SwitchSelectionModeMenuItem: function(e) {
            return $b3500b6633028c9d$var$o.createElement(c, {
                mode: e.mode
            }, function(t) {
                return $b3500b6633028c9d$var$o.createElement($b3500b6633028c9d$var$d, {
                    isSelected: t.isSelected,
                    mode: t.mode,
                    onClick: function() {
                        t.onClick(), e.onClick();
                    }
                });
            });
        }
    };
};

});


parcelRegister("2ZIsE", function(module, exports) {
/**
 * A React component to view a PDF document
 *
 * @see https://react-pdf-viewer.dev
 * @license https://react-pdf-viewer.dev/license
 * @copyright 2019-2023 Nguyen Huu Phuoc <me@phuoc.ng>
 */ "use strict";

module.exports = (parcelRequire("lDyVs"));

});
parcelRegister("lDyVs", function(module, exports) {

$parcel$export(module.exports, "ExitFullScreenIcon", () => $0410a688685fac59$export$7e82c66e763fb043, (v) => $0410a688685fac59$export$7e82c66e763fb043 = v);
$parcel$export(module.exports, "FullScreenIcon", () => $0410a688685fac59$export$1c6234f82454e187, (v) => $0410a688685fac59$export$1c6234f82454e187 = v);
$parcel$export(module.exports, "fullScreenPlugin", () => $0410a688685fac59$export$f817507596d18262, (v) => $0410a688685fac59$export$f817507596d18262 = v);
var $0410a688685fac59$export$7e82c66e763fb043;
var $0410a688685fac59$export$1c6234f82454e187;
var $0410a688685fac59$export$f817507596d18262;
"use strict";

var $6eW0i = parcelRequire("6eW0i");
function $0410a688685fac59$var$t(e) {
    var t = Object.create(null);
    return e && Object.keys(e).forEach(function(n) {
        if ("default" !== n) {
            var r = Object.getOwnPropertyDescriptor(e, n);
            Object.defineProperty(t, n, r.get ? r : {
                enumerable: !0,
                get: function() {
                    return e[n];
                }
            });
        }
    }), t.default = e, Object.freeze(t);
}

var $0410a688685fac59$var$n = $0410a688685fac59$var$t((parcelRequire("kc00y"))), $0410a688685fac59$var$r = function() {
    return $0410a688685fac59$var$n.createElement($6eW0i.Icon, {
        size: 16
    }, $0410a688685fac59$var$n.createElement("path", {
        d: "M11.5 23.499L11.5 14.499"
    }), $0410a688685fac59$var$n.createElement("path", {
        d: "M7.5 18.499L11.5 14.499 15.5 18.499"
    }), $0410a688685fac59$var$n.createElement("path", {
        d: "M11.5 1.499L11.5 10.499"
    }), $0410a688685fac59$var$n.createElement("path", {
        d: "M7.5 6.499L11.5 10.499 15.5 6.499"
    }), $0410a688685fac59$var$n.createElement("path", {
        d: "M20.5 12.499L1.5 12.499"
    }));
}, $0410a688685fac59$var$l = function() {
    return $0410a688685fac59$var$n.createElement($6eW0i.Icon, {
        size: 16
    }, $0410a688685fac59$var$n.createElement("path", {
        d: "M0.5 12L23.5 12"
    }), $0410a688685fac59$var$n.createElement("path", {
        d: "M11.5 1L11.5 23"
    }), $0410a688685fac59$var$n.createElement("path", {
        d: "M8.5 4L11.5 1 14.5 4"
    }), $0410a688685fac59$var$n.createElement("path", {
        d: "M20.5 9L23.5 12 20.5 15"
    }), $0410a688685fac59$var$n.createElement("path", {
        d: "M3.5 15L0.5 12 3.5 9"
    }), $0410a688685fac59$var$n.createElement("path", {
        d: "M14.5 20L11.5 23 8.5 20"
    }));
}, $0410a688685fac59$var$c = function() {
    return $0410a688685fac59$var$c = Object.assign || function(e) {
        for(var t, n = 1, r = arguments.length; n < r; n++)for(var l in t = arguments[n])Object.prototype.hasOwnProperty.call(t, l) && (e[l] = t[l]);
        return e;
    }, $0410a688685fac59$var$c.apply(this, arguments);
}, $0410a688685fac59$var$u = {
    left: 0,
    top: 8
}, $0410a688685fac59$var$o = function(t) {
    var r = t.enableShortcuts, c = t.onClick, o = $0410a688685fac59$var$n.useContext($6eW0i.LocalizationContext).l10n, i = o && o.fullScreen ? o.fullScreen.enterFullScreen : "Full screen", a = r ? $6eW0i.isMac() ? "Meta+Ctrl+F" : "F11" : "";
    return $0410a688685fac59$var$n.createElement($6eW0i.Tooltip, {
        ariaControlsSuffix: "full-screen-enter",
        position: $6eW0i.Position.BottomCenter,
        target: $0410a688685fac59$var$n.createElement($6eW0i.MinimalButton, {
            ariaKeyShortcuts: a,
            ariaLabel: i,
            isDisabled: !$6eW0i.isFullScreenEnabled(),
            testId: "full-screen__enter-button",
            onClick: c
        }, $0410a688685fac59$var$n.createElement($0410a688685fac59$var$l, null)),
        content: function() {
            return i;
        },
        offset: $0410a688685fac59$var$u
    });
}, $0410a688685fac59$var$i = {
    left: 0,
    top: 8
}, $0410a688685fac59$var$a = function(t) {
    var l = t.onClick, c = $0410a688685fac59$var$n.useContext($6eW0i.LocalizationContext).l10n, u = c && c.fullScreen ? c.fullScreen.exitFullScreen : "Exit full screen";
    return $0410a688685fac59$var$n.createElement($6eW0i.Tooltip, {
        ariaControlsSuffix: "full-screen-exit",
        position: $6eW0i.Position.BottomCenter,
        target: $0410a688685fac59$var$n.createElement($6eW0i.MinimalButton, {
            ariaKeyShortcuts: "Esc",
            ariaLabel: u,
            testId: "full-screen__exit-button-with-tooltip",
            onClick: l
        }, $0410a688685fac59$var$n.createElement($0410a688685fac59$var$r, null)),
        content: function() {
            return u;
        },
        offset: $0410a688685fac59$var$i
    });
}, $0410a688685fac59$var$f = function(t, r) {
    var l = $0410a688685fac59$var$n.useState(r.get("fullScreenMode")), c = l[0], u = l[1], o = $0410a688685fac59$var$n.useCallback(function(e) {
        u(e);
    }, []);
    return $0410a688685fac59$var$n.useEffect(function() {
        return r.subscribe("fullScreenMode", o), function() {
            r.unsubscribe("fullScreenMode", o);
        };
    }, []), {
        enterFullScreen: function() {
            var e = r.get("getPagesContainer");
            if (e) {
                var n = t(e());
                r.get("enterFullScreenMode")(n);
            }
        },
        exitFullScreen: function() {
            r.get("exitFullScreenMode")();
        },
        isFullScreen: c === $6eW0i.FullScreenMode.Entering || c === $6eW0i.FullScreenMode.EnteredCompletely
    };
}, $0410a688685fac59$var$s = function(e) {
    var t = e.children, r = e.enableShortcuts, l = e.getFullScreenTarget, c = e.store, u = $0410a688685fac59$var$f(l, c), i = u.enterFullScreen, s = u.exitFullScreen, S = u.isFullScreen;
    return (t || function(e) {
        return S ? $0410a688685fac59$var$n.createElement($0410a688685fac59$var$a, {
            onClick: e.onClick
        }) : $0410a688685fac59$var$n.createElement($0410a688685fac59$var$o, {
            enableShortcuts: r,
            onClick: e.onClick
        });
    })({
        onClick: S ? s : i
    });
}, $0410a688685fac59$var$S = function(t) {
    var r = t.onClick, c = $0410a688685fac59$var$n.useContext($6eW0i.LocalizationContext).l10n, u = c && c.fullScreen ? c.fullScreen.enterFullScreen : "Full screen";
    return $0410a688685fac59$var$n.createElement($6eW0i.MenuItem, {
        icon: $0410a688685fac59$var$n.createElement($0410a688685fac59$var$l, null),
        isDisabled: !$6eW0i.isFullScreenEnabled(),
        testId: "full-screen__enter-menu",
        onClick: r
    }, u);
}, $0410a688685fac59$var$d = function(t) {
    var l = t.onClick, c = $0410a688685fac59$var$n.useContext($6eW0i.LocalizationContext).l10n, u = $0410a688685fac59$var$n.useContext($6eW0i.ThemeContext).direction === $6eW0i.TextDirection.RightToLeft, o = c && c.fullScreen ? c.fullScreen.exitFullScreen : "Exit full screen";
    return $0410a688685fac59$var$n.createElement("div", {
        className: $6eW0i.classNames({
            "rpv-full-screen__exit-button": !0,
            "rpv-full-screen__exit-button--ltr": !u,
            "rpv-full-screen__exit-button--rtl": u
        })
    }, $0410a688685fac59$var$n.createElement($6eW0i.MinimalButton, {
        ariaLabel: o,
        testId: "full-screen__exit-button",
        onClick: l
    }, $0410a688685fac59$var$n.createElement($0410a688685fac59$var$r, null)));
}, $0410a688685fac59$var$m = function(e) {
    var t = e.children, r = e.getFullScreenTarget, l = e.store, c = $0410a688685fac59$var$f(r, l), u = c.enterFullScreen, o = c.exitFullScreen, i = c.isFullScreen;
    return i && (t || function(e) {
        return $0410a688685fac59$var$n.createElement($0410a688685fac59$var$d, {
            onClick: e.onClick
        });
    })({
        onClick: i ? o : u
    });
}, $0410a688685fac59$var$E = function(t) {
    var r = t.store, l = t.onEnterFullScreen, c = t.onExitFullScreen, u = $0410a688685fac59$var$n.useState(r.get("fullScreenMode")), o = u[0], i = u[1], a = $0410a688685fac59$var$n.useCallback(function(e) {
        i(e);
    }, []);
    return $0410a688685fac59$var$n.useEffect(function() {
        switch(o){
            case $6eW0i.FullScreenMode.EnteredCompletely:
                l(r.get("zoom"));
                break;
            case $6eW0i.FullScreenMode.Exited:
                c(r.get("zoom"));
        }
    }, [
        o
    ]), $0410a688685fac59$var$n.useEffect(function() {
        return r.subscribe("fullScreenMode", a), function() {
            r.unsubscribe("fullScreenMode", a);
        };
    }, []), (o === $6eW0i.FullScreenMode.Entering || o === $6eW0i.FullScreenMode.Entered) && $0410a688685fac59$var$n.createElement("div", {
        className: "rpv-full-screen__overlay"
    }, $0410a688685fac59$var$n.createElement($6eW0i.Spinner, null));
}, $0410a688685fac59$var$F = function(t) {
    var r = t.containerRef, l = t.getFullScreenTarget, c = t.store, u = $0410a688685fac59$var$f(l, c).enterFullScreen, o = function(t) {
        if (!t.shiftKey && !t.altKey && ($6eW0i.isMac() ? t.metaKey && t.ctrlKey && "f" === t.key : "F11" === t.key)) {
            var n = r.current;
            n && document.activeElement && n.contains(document.activeElement) && (t.preventDefault(), u());
        }
    };
    return $0410a688685fac59$var$n.useEffect(function() {
        if (r.current) return document.addEventListener("keydown", o), function() {
            document.removeEventListener("keydown", o);
        };
    }, [
        r.current
    ]), $0410a688685fac59$var$n.createElement($0410a688685fac59$var$n.Fragment, null);
};
$0410a688685fac59$export$7e82c66e763fb043 = $0410a688685fac59$var$r, $0410a688685fac59$export$1c6234f82454e187 = $0410a688685fac59$var$l, $0410a688685fac59$export$f817507596d18262 = function(t) {
    var r = (null == t ? void 0 : t.getFullScreenTarget) || function(e) {
        return e;
    }, l = $0410a688685fac59$var$n.useMemo(function() {
        return Object.assign({}, {
            enableShortcuts: !0,
            onEnterFullScreen: function() {},
            onExitFullScreen: function() {}
        }, t);
    }, []), u = $0410a688685fac59$var$n.useMemo(function() {
        return $6eW0i.createStore({
            enterFullScreenMode: function() {},
            exitFullScreenMode: function() {},
            fullScreenMode: $6eW0i.FullScreenMode.Normal,
            zoom: function() {}
        });
    }, []), i = function(e) {
        return $0410a688685fac59$var$n.createElement($0410a688685fac59$var$s, $0410a688685fac59$var$c({}, e, {
            enableShortcuts: l.enableShortcuts,
            getFullScreenTarget: r,
            store: u
        }));
    }, a = function() {
        return $0410a688685fac59$var$n.createElement($0410a688685fac59$var$m, {
            getFullScreenTarget: r,
            store: u
        }, null == t ? void 0 : t.renderExitFullScreenButton);
    };
    return {
        install: function(e) {
            u.update("enterFullScreenMode", e.enterFullScreenMode), u.update("exitFullScreenMode", e.exitFullScreenMode), u.update("getPagesContainer", e.getPagesContainer), u.update("zoom", e.zoom);
        },
        onViewerStateChange: function(e) {
            return u.update("fullScreenMode", e.fullScreenMode), e;
        },
        renderViewer: function(e) {
            var t = e.slot;
            return t.subSlot && (t.subSlot.children = $0410a688685fac59$var$n.createElement($0410a688685fac59$var$n.Fragment, null, l.enableShortcuts && $0410a688685fac59$var$n.createElement($0410a688685fac59$var$F, {
                containerRef: e.containerRef,
                getFullScreenTarget: r,
                store: u
            }), $0410a688685fac59$var$n.createElement($0410a688685fac59$var$E, {
                store: u,
                onEnterFullScreen: l.onEnterFullScreen,
                onExitFullScreen: l.onExitFullScreen
            }), $0410a688685fac59$var$n.createElement(a, null), t.subSlot.children)), t;
        },
        EnterFullScreen: i,
        EnterFullScreenButton: function() {
            return $0410a688685fac59$var$n.createElement(i, null, function(e) {
                return $0410a688685fac59$var$n.createElement($0410a688685fac59$var$o, $0410a688685fac59$var$c({
                    enableShortcuts: l.enableShortcuts
                }, e));
            });
        },
        EnterFullScreenMenuItem: function(e) {
            return $0410a688685fac59$var$n.createElement(i, null, function(t) {
                return $0410a688685fac59$var$n.createElement($0410a688685fac59$var$S, {
                    onClick: function() {
                        t.onClick(), e.onClick();
                    }
                });
            });
        }
    };
};

});


parcelRegister("hdrSh", function(module, exports) {
/**
 * A React component to view a PDF document
 *
 * @see https://react-pdf-viewer.dev
 * @license https://react-pdf-viewer.dev/license
 * @copyright 2019-2023 Nguyen Huu Phuoc <me@phuoc.ng>
 */ "use strict";

module.exports = (parcelRequire("bI6da"));

});
parcelRegister("bI6da", function(module, exports) {

$parcel$export(module.exports, "DownloadIcon", () => $88689f38439ed571$export$4e54df4252b4a99c, (v) => $88689f38439ed571$export$4e54df4252b4a99c = v);
$parcel$export(module.exports, "getFilePlugin", () => $88689f38439ed571$export$84c1e7a931abc066, (v) => $88689f38439ed571$export$84c1e7a931abc066 = v);
var $88689f38439ed571$export$4e54df4252b4a99c;
var $88689f38439ed571$export$84c1e7a931abc066;
"use strict";

var $6eW0i = parcelRequire("6eW0i");
function $88689f38439ed571$var$t(e) {
    var t = Object.create(null);
    return e && Object.keys(e).forEach(function(n) {
        if ("default" !== n) {
            var o = Object.getOwnPropertyDescriptor(e, n);
            Object.defineProperty(t, n, o.get ? o : {
                enumerable: !0,
                get: function() {
                    return e[n];
                }
            });
        }
    }), t.default = e, Object.freeze(t);
}

var $88689f38439ed571$var$n = $88689f38439ed571$var$t((parcelRequire("kc00y"))), $88689f38439ed571$var$o = function() {
    return $88689f38439ed571$var$n.createElement($6eW0i.Icon, {
        size: 16
    }, $88689f38439ed571$var$n.createElement("path", {
        d: "M5.5,11.5c-.275,0-.341.159-.146.354l6.292,6.293a.5.5,0,0,0,.709,0l6.311-6.275c.2-.193.13-.353-.145-.355L15.5,11.5V1.5a1,1,0,0,0-1-1h-5a1,1,0,0,0-1,1V11a.5.5,0,0,1-.5.5Z"
    }), $88689f38439ed571$var$n.createElement("path", {
        d: "M23.5,18.5v4a1,1,0,0,1-1,1H1.5a1,1,0,0,1-1-1v-4"
    }));
}, $88689f38439ed571$var$r = function() {
    return $88689f38439ed571$var$r = Object.assign || function(e) {
        for(var t, n = 1, o = arguments.length; n < o; n++)for(var r in t = arguments[n])Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
        return e;
    }, $88689f38439ed571$var$r.apply(this, arguments);
}, $88689f38439ed571$var$i = {
    left: 0,
    top: 8
}, $88689f38439ed571$var$a = function(t) {
    var r = t.onClick, a = $88689f38439ed571$var$n.useContext($6eW0i.LocalizationContext).l10n, c = a && a.download ? a.download.download : "Download";
    return $88689f38439ed571$var$n.createElement($6eW0i.Tooltip, {
        ariaControlsSuffix: "get-file",
        position: $6eW0i.Position.BottomCenter,
        target: $88689f38439ed571$var$n.createElement($6eW0i.MinimalButton, {
            ariaLabel: c,
            testId: "get-file__download-button",
            onClick: r
        }, $88689f38439ed571$var$n.createElement($88689f38439ed571$var$o, null)),
        content: function() {
            return c;
        },
        offset: $88689f38439ed571$var$i
    });
}, $88689f38439ed571$var$c = function(e, t) {
    var n = document.createElement("a");
    n.style.display = "none", n.href = e, n.setAttribute("download", t), document.body.appendChild(n), n.click(), document.body.removeChild(n);
}, $88689f38439ed571$var$l = function(e, t, n) {
    var o = URL.createObjectURL(new Blob([
        e
    ], {
        type: n
    }));
    $88689f38439ed571$var$c(o, t), o && URL.revokeObjectURL(o);
}, $88689f38439ed571$var$u = function(e, t) {
    e.getData().then(function(e) {
        /iphone|ipod|ipad/i.test(navigator.userAgent) && !/CriOS/i.test(navigator.userAgent) ? $88689f38439ed571$var$l(e, t, "application/octet-stream") : /iphone|ipod|ipad/i.test(navigator.userAgent) && /CriOS/i.test(navigator.userAgent) ? $88689f38439ed571$var$c("data:application/pdf;base64,".concat(function(e) {
            return btoa(Array(e.length).fill("").map(function(t, n) {
                return String.fromCharCode(e[n]);
            }).join(""));
        }(e)), t) : $88689f38439ed571$var$l(e, t, "application/pdf");
    });
}, $88689f38439ed571$var$f = function(e) {
    var t = e.children, o = e.fileNameGenerator, r = e.store, i = $88689f38439ed571$var$n.useState(r.get("file")), c = i[0], l = i[1], f = $88689f38439ed571$var$n.useState(r.get("doc")), d = f[0], s = f[1], p = function(e) {
        s(e);
    }, m = function(e) {
        l(e);
    };
    $88689f38439ed571$var$n.useEffect(function() {
        return r.subscribe("doc", p), r.subscribe("file", m), function() {
            r.subscribe("doc", p), r.unsubscribe("file", m);
        };
    }, []);
    return (t || function(e) {
        return $88689f38439ed571$var$n.createElement($88689f38439ed571$var$a, {
            onClick: e.onClick
        });
    })({
        onClick: function() {
            d && c && $88689f38439ed571$var$u(d, o(c));
        }
    });
}, $88689f38439ed571$var$d = function(t) {
    var r = t.onClick, i = $88689f38439ed571$var$n.useContext($6eW0i.LocalizationContext).l10n, a = i && i.download ? i.download.download : "Download";
    return $88689f38439ed571$var$n.createElement($6eW0i.MenuItem, {
        icon: $88689f38439ed571$var$n.createElement($88689f38439ed571$var$o, null),
        testId: "get-file__download-menu",
        onClick: r
    }, a);
};
$88689f38439ed571$export$4e54df4252b4a99c = $88689f38439ed571$var$o, $88689f38439ed571$export$84c1e7a931abc066 = function(t) {
    var o = $88689f38439ed571$var$n.useMemo(function() {
        return $6eW0i.createStore({});
    }, []), i = function(e) {
        var t, n;
        return e.name ? (t = e.name, (n = t.split("/").pop()) ? n.split("#")[0].split("?")[0] : t) : "document.pdf";
    }, c = function(e) {
        return $88689f38439ed571$var$n.createElement($88689f38439ed571$var$f, $88689f38439ed571$var$r({}, e, {
            fileNameGenerator: t && t.fileNameGenerator || i,
            store: o
        }));
    };
    return {
        onDocumentLoad: function(e) {
            o.update("doc", e.doc), o.update("file", e.file);
        },
        Download: c,
        DownloadButton: function() {
            return $88689f38439ed571$var$n.createElement(c, null, function(e) {
                return $88689f38439ed571$var$n.createElement($88689f38439ed571$var$a, $88689f38439ed571$var$r({}, e));
            });
        },
        DownloadMenuItem: function(e) {
            return $88689f38439ed571$var$n.createElement(c, null, function(t) {
                return $88689f38439ed571$var$n.createElement($88689f38439ed571$var$d, {
                    onClick: function() {
                        t.onClick(), e.onClick();
                    }
                });
            });
        }
    };
};

});


parcelRegister("jGGRT", function(module, exports) {
/**
 * A React component to view a PDF document
 *
 * @see https://react-pdf-viewer.dev
 * @license https://react-pdf-viewer.dev/license
 * @copyright 2019-2023 Nguyen Huu Phuoc <me@phuoc.ng>
 */ "use strict";

module.exports = (parcelRequire("6zvP0"));

});
parcelRegister("6zvP0", function(module, exports) {

$parcel$export(module.exports, "OpenFileIcon", () => $4c8eb213694cdd3b$export$4210d43af5d1c0cd, (v) => $4c8eb213694cdd3b$export$4210d43af5d1c0cd = v);
$parcel$export(module.exports, "openPlugin", () => $4c8eb213694cdd3b$export$60f78747898abed5, (v) => $4c8eb213694cdd3b$export$60f78747898abed5 = v);
var $4c8eb213694cdd3b$export$4210d43af5d1c0cd;
var $4c8eb213694cdd3b$export$60f78747898abed5;
"use strict";

var $6eW0i = parcelRequire("6eW0i");
function $4c8eb213694cdd3b$var$t(e) {
    var t = Object.create(null);
    return e && Object.keys(e).forEach(function(n) {
        if ("default" !== n) {
            var r = Object.getOwnPropertyDescriptor(e, n);
            Object.defineProperty(t, n, r.get ? r : {
                enumerable: !0,
                get: function() {
                    return e[n];
                }
            });
        }
    }), t.default = e, Object.freeze(t);
}

var $4c8eb213694cdd3b$var$n = $4c8eb213694cdd3b$var$t((parcelRequire("kc00y"))), $4c8eb213694cdd3b$var$r = function() {
    return $4c8eb213694cdd3b$var$n.createElement($6eW0i.Icon, {
        size: 16
    }, $4c8eb213694cdd3b$var$n.createElement("path", {
        d: "M18.5,7.5c.275,0,.341-.159.146-.354L12.354.854a.5.5,0,0,0-.708,0L5.354,7.147c-.2.195-.129.354.146.354h3v10a1,1,0,0,0,1,1h5a1,1,0,0,0,1-1V7.5Z"
    }), $4c8eb213694cdd3b$var$n.createElement("path", {
        d: "M23.5,18.5v4a1,1,0,0,1-1,1H1.5a1,1,0,0,1-1-1v-4"
    }));
}, $4c8eb213694cdd3b$var$o = function() {
    return $4c8eb213694cdd3b$var$o = Object.assign || function(e) {
        for(var t, n = 1, r = arguments.length; n < r; n++)for(var o in t = arguments[n])Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
    }, $4c8eb213694cdd3b$var$o.apply(this, arguments);
}, $4c8eb213694cdd3b$var$i = function(e) {
    var t = $4c8eb213694cdd3b$var$n.useRef(), r = function() {
        var n = t.current;
        n && (n.click(), e.get("triggerOpenFile") && e.update("triggerOpenFile", !1));
    }, o = function(e) {
        e && r();
    };
    return $4c8eb213694cdd3b$var$n.useEffect(function() {
        return e.subscribe("triggerOpenFile", o), function() {
            e.unsubscribe("triggerOpenFile", o);
        };
    }, []), {
        inputRef: t,
        openFile: r
    };
}, $4c8eb213694cdd3b$var$c = {
    left: 0,
    top: 8
}, $4c8eb213694cdd3b$var$u = function(t) {
    var o = t.enableShortcuts, u = t.store, a = t.onClick, l = $4c8eb213694cdd3b$var$n.useContext($6eW0i.LocalizationContext).l10n, p = l && l.open ? l.open.openFile : "Open file", f = $4c8eb213694cdd3b$var$i(u), s = f.inputRef, m = f.openFile, v = o ? $6eW0i.isMac() ? "Meta+O" : "Ctrl+O" : "";
    return $4c8eb213694cdd3b$var$n.createElement($6eW0i.Tooltip, {
        ariaControlsSuffix: "open",
        position: $6eW0i.Position.BottomCenter,
        target: $4c8eb213694cdd3b$var$n.createElement("div", {
            className: "rpv-open__input-wrapper"
        }, $4c8eb213694cdd3b$var$n.createElement("input", {
            accept: ".pdf",
            ref: s,
            className: "rpv-open__input",
            multiple: !1,
            tabIndex: -1,
            title: "",
            type: "file",
            onChange: a
        }), $4c8eb213694cdd3b$var$n.createElement($6eW0i.MinimalButton, {
            ariaKeyShortcuts: v,
            ariaLabel: p,
            testId: "open__button",
            onClick: m
        }, $4c8eb213694cdd3b$var$n.createElement($4c8eb213694cdd3b$var$r, null))),
        content: function() {
            return p;
        },
        offset: $4c8eb213694cdd3b$var$c
    });
}, $4c8eb213694cdd3b$var$a = function(e) {
    var t = e.children, r = e.enableShortcuts, o = e.store;
    return (t || function(e) {
        return $4c8eb213694cdd3b$var$n.createElement($4c8eb213694cdd3b$var$u, {
            enableShortcuts: r,
            store: o,
            onClick: e.onClick
        });
    })({
        onClick: function(e) {
            var t = e.target.files;
            if (t && t.length) {
                var n = o.get("openFile");
                n && n(t[0]);
            }
        }
    });
}, $4c8eb213694cdd3b$var$l = function(t) {
    var o = t.store, c = t.onClick, u = $4c8eb213694cdd3b$var$n.useContext($6eW0i.LocalizationContext).l10n, a = u && u.open ? u.open.openFile : "Open file", l = $4c8eb213694cdd3b$var$i(o), p = l.inputRef, f = l.openFile;
    return $4c8eb213694cdd3b$var$n.createElement($6eW0i.MenuItem, {
        icon: $4c8eb213694cdd3b$var$n.createElement($4c8eb213694cdd3b$var$r, null),
        testId: "open__menu",
        onClick: f
    }, $4c8eb213694cdd3b$var$n.createElement("div", {
        className: "rpv-open__input-wrapper"
    }, $4c8eb213694cdd3b$var$n.createElement("input", {
        accept: ".pdf",
        ref: p,
        className: "rpv-open__input",
        multiple: !1,
        tabIndex: -1,
        title: "",
        type: "file",
        onChange: c
    }), a));
}, $4c8eb213694cdd3b$var$p = function(t) {
    var r = t.containerRef, o = t.store, i = function(t) {
        if (!t.shiftKey && !t.altKey && "o" === t.key && ($6eW0i.isMac() ? t.metaKey : t.ctrlKey)) {
            var n = r.current;
            n && document.activeElement && n.contains(document.activeElement) && (t.preventDefault(), o.update("triggerOpenFile", !0));
        }
    };
    return $4c8eb213694cdd3b$var$n.useEffect(function() {
        if (r.current) return document.addEventListener("keydown", i), function() {
            document.removeEventListener("keydown", i);
        };
    }, [
        r.current
    ]), $4c8eb213694cdd3b$var$n.createElement($4c8eb213694cdd3b$var$n.Fragment, null);
};
$4c8eb213694cdd3b$export$4210d43af5d1c0cd = $4c8eb213694cdd3b$var$r, $4c8eb213694cdd3b$export$60f78747898abed5 = function(t) {
    var r = $4c8eb213694cdd3b$var$n.useMemo(function() {
        return Object.assign({}, {
            enableShortcuts: !0
        }, t);
    }, []), i = $4c8eb213694cdd3b$var$n.useMemo(function() {
        return $6eW0i.createStore({});
    }, []), c = function(e) {
        return $4c8eb213694cdd3b$var$n.createElement($4c8eb213694cdd3b$var$a, $4c8eb213694cdd3b$var$o({
            enableShortcuts: r.enableShortcuts
        }, e, {
            store: i
        }));
    };
    return {
        install: function(e) {
            i.update("openFile", e.openFile);
        },
        renderViewer: function(e) {
            var t = e.slot, c = {
                children: $4c8eb213694cdd3b$var$n.createElement($4c8eb213694cdd3b$var$n.Fragment, null, r.enableShortcuts && $4c8eb213694cdd3b$var$n.createElement($4c8eb213694cdd3b$var$p, {
                    containerRef: e.containerRef,
                    store: i
                }), t.children)
            };
            return $4c8eb213694cdd3b$var$o($4c8eb213694cdd3b$var$o({}, t), c);
        },
        Open: c,
        OpenButton: function() {
            return $4c8eb213694cdd3b$var$n.createElement(c, null);
        },
        OpenMenuItem: function() {
            return $4c8eb213694cdd3b$var$n.createElement(c, null, function(e) {
                return $4c8eb213694cdd3b$var$n.createElement($4c8eb213694cdd3b$var$l, {
                    store: i,
                    onClick: e.onClick
                });
            });
        }
    };
};

});


parcelRegister("eSZE0", function(module, exports) {
/**
 * A React component to view a PDF document
 *
 * @see https://react-pdf-viewer.dev
 * @license https://react-pdf-viewer.dev/license
 * @copyright 2019-2023 Nguyen Huu Phuoc <me@phuoc.ng>
 */ "use strict";

module.exports = (parcelRequire("l8Lq6"));

});
parcelRegister("l8Lq6", function(module, exports) {

$parcel$export(module.exports, "DownArrowIcon", () => $f63f20f02bfd85e8$export$85ac33870499f48b, (v) => $f63f20f02bfd85e8$export$85ac33870499f48b = v);
$parcel$export(module.exports, "NextIcon", () => $f63f20f02bfd85e8$export$3da0e0ec94bd4ce1, (v) => $f63f20f02bfd85e8$export$3da0e0ec94bd4ce1 = v);
$parcel$export(module.exports, "PreviousIcon", () => $f63f20f02bfd85e8$export$d05925e1c7f3f136, (v) => $f63f20f02bfd85e8$export$d05925e1c7f3f136 = v);
$parcel$export(module.exports, "UpArrowIcon", () => $f63f20f02bfd85e8$export$b676c0ee3a871594, (v) => $f63f20f02bfd85e8$export$b676c0ee3a871594 = v);
$parcel$export(module.exports, "pageNavigationPlugin", () => $f63f20f02bfd85e8$export$eae9110288555cd2, (v) => $f63f20f02bfd85e8$export$eae9110288555cd2 = v);
var $f63f20f02bfd85e8$export$85ac33870499f48b;
var $f63f20f02bfd85e8$export$3da0e0ec94bd4ce1;
var $f63f20f02bfd85e8$export$d05925e1c7f3f136;
var $f63f20f02bfd85e8$export$b676c0ee3a871594;
var $f63f20f02bfd85e8$export$eae9110288555cd2;
"use strict";

var $6eW0i = parcelRequire("6eW0i");
function $f63f20f02bfd85e8$var$t(e) {
    var t = Object.create(null);
    return e && Object.keys(e).forEach(function(n) {
        if ("default" !== n) {
            var a = Object.getOwnPropertyDescriptor(e, n);
            Object.defineProperty(t, n, a.get ? a : {
                enumerable: !0,
                get: function() {
                    return e[n];
                }
            });
        }
    }), t.default = e, Object.freeze(t);
}

var $f63f20f02bfd85e8$var$n = $f63f20f02bfd85e8$var$t((parcelRequire("kc00y"))), $f63f20f02bfd85e8$var$a = function() {
    return $f63f20f02bfd85e8$var$n.createElement($6eW0i.Icon, {
        size: 16
    }, $f63f20f02bfd85e8$var$n.createElement("path", {
        d: "M2.32,2.966h19.452c0.552,0.001,1,0.449,0.999,1.001c0,0.182-0.05,0.36-0.144,0.516L12.9,20.552\n            c-0.286,0.472-0.901,0.624-1.373,0.338c-0.138-0.084-0.254-0.2-0.338-0.338L1.465,4.483C1.179,4.01,1.331,3.396,1.804,3.11\n            C1.96,3.016,2.138,2.966,2.32,2.966z"
    }));
}, $f63f20f02bfd85e8$var$r = function() {
    return $f63f20f02bfd85e8$var$n.createElement($6eW0i.Icon, {
        size: 16
    }, $f63f20f02bfd85e8$var$n.createElement("path", {
        d: "M0.541,5.627L11.666,18.2c0.183,0.207,0.499,0.226,0.706,0.043c0.015-0.014,0.03-0.028,0.043-0.043\n            L23.541,5.627"
    }));
}, $f63f20f02bfd85e8$var$o = function() {
    return $f63f20f02bfd85e8$var$o = Object.assign || function(e) {
        for(var t, n = 1, a = arguments.length; n < a; n++)for(var r in t = arguments[n])Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
        return e;
    }, $f63f20f02bfd85e8$var$o.apply(this, arguments);
}, $f63f20f02bfd85e8$var$i = function(t) {
    var a = $f63f20f02bfd85e8$var$n.useState(t.get("currentPage") || 0), r = a[0], o = a[1], i = function(e) {
        o(e);
    };
    return $6eW0i.useIsomorphicLayoutEffect(function() {
        return t.subscribe("currentPage", i), function() {
            t.unsubscribe("currentPage", i);
        };
    }, []), {
        currentPage: r
    };
}, $f63f20f02bfd85e8$var$u = function(e) {
    var t = $f63f20f02bfd85e8$var$n.useState(e.get("numberOfPages") || 0), a = t[0], r = t[1], o = function(e) {
        r(e);
    };
    return $f63f20f02bfd85e8$var$n.useEffect(function() {
        return e.subscribe("numberOfPages", o), function() {
            e.unsubscribe("numberOfPages", o);
        };
    }, []), {
        numberOfPages: a
    };
}, $f63f20f02bfd85e8$var$c = function(t) {
    var a = t.store, r = $f63f20f02bfd85e8$var$n.useContext($6eW0i.LocalizationContext).l10n, o = $f63f20f02bfd85e8$var$n.useState("1"), c = o[0], l = o[1], s = $f63f20f02bfd85e8$var$i(a).currentPage, g = $f63f20f02bfd85e8$var$u(a).numberOfPages;
    $f63f20f02bfd85e8$var$n.useEffect(function() {
        return l("".concat(s + 1));
    }, [
        s
    ]);
    var f = function(e) {
        var t = a.get("jumpToPage");
        t && t(e);
    }, m = r && r.pageNavigation ? r.pageNavigation.enterPageNumber : "Enter a page number";
    return $f63f20f02bfd85e8$var$n.createElement("span", {
        className: "rpv-page-navigation__current-page-input"
    }, $f63f20f02bfd85e8$var$n.createElement($6eW0i.TextBox, {
        ariaLabel: m,
        testId: "page-navigation__current-page-input",
        type: "text",
        value: c,
        onChange: l,
        onKeyDown: function(e) {
            switch(e.key){
                case "ArrowUp":
                    (a = s - 1) >= 0 && (l("".concat(a + 1)), f(a));
                    break;
                case "ArrowDown":
                    (n = s + 1) < g && (l("".concat(n + 1)), f(n));
                    break;
                case "Enter":
                    t = parseInt(c, 10), "" === c || t < 1 || t > g ? l("".concat(s + 1)) : f(t - 1);
            }
            var t, n, a;
        }
    }));
}, $f63f20f02bfd85e8$var$l = function(t) {
    var a = t.children, r = t.doc, o = $6eW0i.useIsMounted(), i = $f63f20f02bfd85e8$var$n.useState({
        loading: !0,
        labels: []
    }), u = i[0], c = i[1];
    return $f63f20f02bfd85e8$var$n.useEffect(function() {
        r.getPageLabels().then(function(e) {
            o.current && c({
                loading: !1,
                labels: e || []
            });
        });
    }, [
        r.loadingTask.docId
    ]), u.loading ? $f63f20f02bfd85e8$var$n.createElement($f63f20f02bfd85e8$var$n.Fragment, null) : a(u.labels);
}, $f63f20f02bfd85e8$var$s = function(e) {
    var t = e.children, a = e.store, r = function(e) {
        var t = $f63f20f02bfd85e8$var$n.useState(e.get("doc")), a = t[0], r = t[1], o = function(e) {
            r(e);
        };
        return $f63f20f02bfd85e8$var$n.useEffect(function() {
            return e.subscribe("doc", o), function() {
                e.unsubscribe("doc", o);
            };
        }, []), a;
    }(a), o = $f63f20f02bfd85e8$var$i(a).currentPage, c = $f63f20f02bfd85e8$var$u(a).numberOfPages, s = t || function(e) {
        return $f63f20f02bfd85e8$var$n.createElement($f63f20f02bfd85e8$var$n.Fragment, null, e.currentPage + 1);
    };
    return r ? $f63f20f02bfd85e8$var$n.createElement($f63f20f02bfd85e8$var$l, {
        doc: r
    }, function(e) {
        var t = e.length === c && c > 0 ? e[o] : "";
        return s({
            currentPage: o,
            numberOfPages: c,
            pageLabel: t
        });
    }) : $f63f20f02bfd85e8$var$n.createElement($f63f20f02bfd85e8$var$n.Fragment, null);
}, $f63f20f02bfd85e8$var$g = function() {
    return $f63f20f02bfd85e8$var$n.createElement($6eW0i.Icon, {
        size: 16
    }, $f63f20f02bfd85e8$var$n.createElement("path", {
        d: "M21.783,21.034H2.332c-0.552,0-1-0.448-1-1c0-0.182,0.05-0.361,0.144-0.517L11.2,3.448\n            c0.286-0.472,0.901-0.624,1.373-0.338c0.138,0.084,0.254,0.2,0.338,0.338l9.726,16.069c0.286,0.473,0.134,1.087-0.339,1.373\n            C22.143,20.984,21.965,21.034,21.783,21.034z"
    }));
}, $f63f20f02bfd85e8$var$f = {
    left: 0,
    top: 8
}, $f63f20f02bfd85e8$var$m = function(t) {
    var a = t.isDisabled, r = t.onClick, o = $f63f20f02bfd85e8$var$n.useContext($6eW0i.LocalizationContext).l10n, i = o && o.pageNavigation ? o.pageNavigation.goToFirstPage : "First page";
    return $f63f20f02bfd85e8$var$n.createElement($6eW0i.Tooltip, {
        ariaControlsSuffix: "page-navigation-first",
        position: $6eW0i.Position.BottomCenter,
        target: $f63f20f02bfd85e8$var$n.createElement($6eW0i.MinimalButton, {
            ariaLabel: i,
            isDisabled: a,
            testId: "page-navigation__first-button",
            onClick: r
        }, $f63f20f02bfd85e8$var$n.createElement($f63f20f02bfd85e8$var$g, null)),
        content: function() {
            return i;
        },
        offset: $f63f20f02bfd85e8$var$f
    });
}, $f63f20f02bfd85e8$var$p = function(e) {
    var t = e.children, a = e.store;
    return (t || function(e) {
        return $f63f20f02bfd85e8$var$n.createElement($f63f20f02bfd85e8$var$m, {
            isDisabled: e.isDisabled,
            onClick: e.onClick
        });
    })({
        isDisabled: 0 === $f63f20f02bfd85e8$var$i(a).currentPage,
        onClick: function() {
            var e = a.get("jumpToPage");
            e && e(0);
        }
    });
}, $f63f20f02bfd85e8$var$v = function(t) {
    var a = t.isDisabled, r = t.onClick, o = $f63f20f02bfd85e8$var$n.useContext($6eW0i.LocalizationContext).l10n, i = o && o.pageNavigation ? o.pageNavigation.goToFirstPage : "First page";
    return $f63f20f02bfd85e8$var$n.createElement($6eW0i.MenuItem, {
        icon: $f63f20f02bfd85e8$var$n.createElement($f63f20f02bfd85e8$var$g, null),
        isDisabled: a,
        testId: "page-navigation__first-menu",
        onClick: r
    }, i);
}, $f63f20f02bfd85e8$var$d = {
    left: 0,
    top: 8
}, $f63f20f02bfd85e8$var$P = function(t) {
    var r = t.isDisabled, o = t.onClick, i = $f63f20f02bfd85e8$var$n.useContext($6eW0i.LocalizationContext).l10n, u = i && i.pageNavigation ? i.pageNavigation.goToLastPage : "Last page";
    return $f63f20f02bfd85e8$var$n.createElement($6eW0i.Tooltip, {
        ariaControlsSuffix: "page-navigation-last",
        position: $6eW0i.Position.BottomCenter,
        target: $f63f20f02bfd85e8$var$n.createElement($6eW0i.MinimalButton, {
            ariaLabel: u,
            isDisabled: r,
            testId: "page-navigation__last-button",
            onClick: o
        }, $f63f20f02bfd85e8$var$n.createElement($f63f20f02bfd85e8$var$a, null)),
        content: function() {
            return u;
        },
        offset: $f63f20f02bfd85e8$var$d
    });
}, $f63f20f02bfd85e8$var$b = function(e) {
    var t = e.children, a = e.store, r = $f63f20f02bfd85e8$var$i(a).currentPage, o = $f63f20f02bfd85e8$var$u(a).numberOfPages;
    return (t || function(e) {
        return $f63f20f02bfd85e8$var$n.createElement($f63f20f02bfd85e8$var$P, {
            isDisabled: e.isDisabled,
            onClick: e.onClick
        });
    })({
        isDisabled: r + 1 >= o,
        onClick: function() {
            var e = a.get("jumpToPage");
            e && e(o - 1);
        }
    });
}, $f63f20f02bfd85e8$var$E = function(t) {
    var r = t.isDisabled, o = t.onClick, i = $f63f20f02bfd85e8$var$n.useContext($6eW0i.LocalizationContext).l10n, u = i && i.pageNavigation ? i.pageNavigation.goToLastPage : "Last page";
    return $f63f20f02bfd85e8$var$n.createElement($6eW0i.MenuItem, {
        icon: $f63f20f02bfd85e8$var$n.createElement($f63f20f02bfd85e8$var$a, null),
        isDisabled: r,
        testId: "page-navigation__last-menu",
        onClick: o
    }, u);
}, $f63f20f02bfd85e8$var$C = {
    left: 0,
    top: 8
}, $f63f20f02bfd85e8$var$D = function(t) {
    var a = t.isDisabled, o = t.onClick, i = $f63f20f02bfd85e8$var$n.useContext($6eW0i.LocalizationContext).l10n, u = i && i.pageNavigation ? i.pageNavigation.goToNextPage : "Next page";
    return $f63f20f02bfd85e8$var$n.createElement($6eW0i.Tooltip, {
        ariaControlsSuffix: "page-navigation-next",
        position: $6eW0i.Position.BottomCenter,
        target: $f63f20f02bfd85e8$var$n.createElement($6eW0i.MinimalButton, {
            ariaLabel: u,
            isDisabled: a,
            testId: "page-navigation__next-button",
            onClick: o
        }, $f63f20f02bfd85e8$var$n.createElement($f63f20f02bfd85e8$var$r, null)),
        content: function() {
            return u;
        },
        offset: $f63f20f02bfd85e8$var$C
    });
}, $f63f20f02bfd85e8$var$k = function(e) {
    var t = e.children, a = e.store;
    return (t || function(e) {
        return $f63f20f02bfd85e8$var$n.createElement($f63f20f02bfd85e8$var$D, {
            onClick: e.onClick,
            isDisabled: e.isDisabled
        });
    })({
        isDisabled: $f63f20f02bfd85e8$var$i(a).currentPage + 1 >= $f63f20f02bfd85e8$var$u(a).numberOfPages,
        onClick: function() {
            var e = a.get("jumpToNextPage");
            e && e();
        }
    });
}, $f63f20f02bfd85e8$var$T = function(t) {
    var a = t.isDisabled, o = t.onClick, i = $f63f20f02bfd85e8$var$n.useContext($6eW0i.LocalizationContext).l10n, u = i && i.pageNavigation ? i.pageNavigation.goToNextPage : "Next page";
    return $f63f20f02bfd85e8$var$n.createElement($6eW0i.MenuItem, {
        icon: $f63f20f02bfd85e8$var$n.createElement($f63f20f02bfd85e8$var$r, null),
        isDisabled: a,
        testId: "page-navigation__next-menu",
        onClick: o
    }, u);
}, $f63f20f02bfd85e8$var$x = function() {
    return $f63f20f02bfd85e8$var$n.createElement($6eW0i.Icon, {
        size: 16
    }, $f63f20f02bfd85e8$var$n.createElement("path", {
        d: "M23.535,18.373L12.409,5.8c-0.183-0.207-0.499-0.226-0.706-0.043C11.688,5.77,11.674,5.785,11.66,5.8\n            L0.535,18.373"
    }));
}, $f63f20f02bfd85e8$var$L = {
    left: 0,
    top: 8
}, $f63f20f02bfd85e8$var$N = function(t) {
    var a = t.isDisabled, r = t.onClick, o = $f63f20f02bfd85e8$var$n.useContext($6eW0i.LocalizationContext).l10n, i = o && o.pageNavigation ? o.pageNavigation.goToPreviousPage : "Previous page";
    return $f63f20f02bfd85e8$var$n.createElement($6eW0i.Tooltip, {
        ariaControlsSuffix: "page-navigation-previous",
        position: $6eW0i.Position.BottomCenter,
        target: $f63f20f02bfd85e8$var$n.createElement($6eW0i.MinimalButton, {
            ariaLabel: i,
            isDisabled: a,
            testId: "page-navigation__previous-button",
            onClick: r
        }, $f63f20f02bfd85e8$var$n.createElement($f63f20f02bfd85e8$var$x, null)),
        content: function() {
            return i;
        },
        offset: $f63f20f02bfd85e8$var$L
    });
}, $f63f20f02bfd85e8$var$j = function(e) {
    var t = e.store;
    return (e.children || function(e) {
        return $f63f20f02bfd85e8$var$n.createElement($f63f20f02bfd85e8$var$N, {
            isDisabled: e.isDisabled,
            onClick: e.onClick
        });
    })({
        isDisabled: $f63f20f02bfd85e8$var$i(t).currentPage <= 0,
        onClick: function() {
            var e = t.get("jumpToPreviousPage");
            e && e();
        }
    });
}, $f63f20f02bfd85e8$var$I = function(t) {
    var a = t.isDisabled, r = t.onClick, o = $f63f20f02bfd85e8$var$n.useContext($6eW0i.LocalizationContext).l10n, i = o && o.pageNavigation ? o.pageNavigation.goToPreviousPage : "Previous page";
    return $f63f20f02bfd85e8$var$n.createElement($6eW0i.MenuItem, {
        icon: $f63f20f02bfd85e8$var$n.createElement($f63f20f02bfd85e8$var$x, null),
        isDisabled: a,
        testId: "page-navigation__previous-menu",
        onClick: r
    }, i);
}, $f63f20f02bfd85e8$var$h = function(e) {
    var t = e.children, a = e.store, r = $f63f20f02bfd85e8$var$u(a).numberOfPages;
    return t ? t({
        numberOfPages: r
    }) : $f63f20f02bfd85e8$var$n.createElement($f63f20f02bfd85e8$var$n.Fragment, null, r);
}, $f63f20f02bfd85e8$var$y = function(t) {
    var a = t.containerRef, r = t.numPages, o = t.store, u = $f63f20f02bfd85e8$var$i(o).currentPage, c = $f63f20f02bfd85e8$var$n.useRef(u);
    c.current = u;
    var l = $f63f20f02bfd85e8$var$n.useRef(!1), s = function() {
        l.current = !0;
    }, g = function() {
        l.current = !1;
    }, f = function(t) {
        var n = a.current, i = l.current || document.activeElement && n.contains(document.activeElement);
        if (n && i) {
            var u, s, g = t.altKey && "ArrowDown" === t.key || !t.shiftKey && !t.altKey && "PageDown" === t.key, f = t.altKey && "ArrowUp" === t.key || !t.shiftKey && !t.altKey && "PageUp" === t.key;
            if (g) return t.preventDefault(), u = o.get("jumpToPage"), s = c.current + 1, void (u && s < r && u(s));
            if (f) return t.preventDefault(), void function() {
                var e = o.get("jumpToPage"), t = c.current - 1;
                e && t >= 0 && e(t);
            }();
            if ($6eW0i.isMac() ? t.metaKey && !t.ctrlKey : t.altKey) switch(t.key){
                case "ArrowLeft":
                    t.preventDefault(), function() {
                        var e = o.get("jumpToPreviousDestination");
                        e && e();
                    }();
                    break;
                case "ArrowRight":
                    t.preventDefault(), function() {
                        var e = o.get("jumpToNextDestination");
                        e && e();
                    }();
            }
        }
    };
    return $f63f20f02bfd85e8$var$n.useEffect(function() {
        var e = a.current;
        if (e) return document.addEventListener("keydown", f), e.addEventListener("mouseenter", s), e.addEventListener("mouseleave", g), function() {
            document.removeEventListener("keydown", f), e.removeEventListener("mouseenter", s), e.removeEventListener("mouseleave", g);
        };
    }, [
        a.current
    ]), $f63f20f02bfd85e8$var$n.createElement($f63f20f02bfd85e8$var$n.Fragment, null);
};
$f63f20f02bfd85e8$export$85ac33870499f48b = $f63f20f02bfd85e8$var$a, $f63f20f02bfd85e8$export$3da0e0ec94bd4ce1 = $f63f20f02bfd85e8$var$r, $f63f20f02bfd85e8$export$d05925e1c7f3f136 = $f63f20f02bfd85e8$var$x, $f63f20f02bfd85e8$export$b676c0ee3a871594 = $f63f20f02bfd85e8$var$g, $f63f20f02bfd85e8$export$eae9110288555cd2 = function(t) {
    var a = $f63f20f02bfd85e8$var$n.useMemo(function() {
        return Object.assign({}, {
            enableShortcuts: !0
        }, t);
    }, []), r = $f63f20f02bfd85e8$var$n.useMemo(function() {
        return $6eW0i.createStore();
    }, []), i = function(e) {
        return $f63f20f02bfd85e8$var$n.createElement($f63f20f02bfd85e8$var$p, $f63f20f02bfd85e8$var$o({}, e, {
            store: r
        }));
    }, u = function(e) {
        return $f63f20f02bfd85e8$var$n.createElement($f63f20f02bfd85e8$var$b, $f63f20f02bfd85e8$var$o({}, e, {
            store: r
        }));
    }, l = function(e) {
        return $f63f20f02bfd85e8$var$n.createElement($f63f20f02bfd85e8$var$k, $f63f20f02bfd85e8$var$o({}, e, {
            store: r
        }));
    }, g = function(e) {
        return $f63f20f02bfd85e8$var$n.createElement($f63f20f02bfd85e8$var$j, $f63f20f02bfd85e8$var$o({}, e, {
            store: r
        }));
    };
    return {
        install: function(e) {
            r.update("jumpToDestination", e.jumpToDestination), r.update("jumpToNextDestination", e.jumpToNextDestination), r.update("jumpToNextPage", e.jumpToNextPage), r.update("jumpToPage", e.jumpToPage), r.update("jumpToPreviousDestination", e.jumpToPreviousDestination), r.update("jumpToPreviousPage", e.jumpToPreviousPage);
        },
        renderViewer: function(e) {
            var t = e.slot;
            if (!a.enableShortcuts) return t;
            var i = {
                children: $f63f20f02bfd85e8$var$n.createElement($f63f20f02bfd85e8$var$n.Fragment, null, $f63f20f02bfd85e8$var$n.createElement($f63f20f02bfd85e8$var$y, {
                    containerRef: e.containerRef,
                    numPages: e.doc.numPages,
                    store: r
                }), t.children)
            };
            return $f63f20f02bfd85e8$var$o($f63f20f02bfd85e8$var$o({}, t), i);
        },
        onDocumentLoad: function(e) {
            r.update("doc", e.doc), r.update("numberOfPages", e.doc.numPages);
        },
        onViewerStateChange: function(e) {
            return r.update("currentPage", e.pageIndex), e;
        },
        jumpToNextPage: function() {
            var e = r.get("jumpToNextPage");
            e && e();
        },
        jumpToPage: function(e) {
            var t = r.get("jumpToPage");
            t && t(e);
        },
        jumpToPreviousPage: function() {
            var e = r.get("jumpToPreviousPage");
            e && e();
        },
        CurrentPageInput: function() {
            return $f63f20f02bfd85e8$var$n.createElement($f63f20f02bfd85e8$var$c, {
                store: r
            });
        },
        CurrentPageLabel: function(e) {
            return $f63f20f02bfd85e8$var$n.createElement($f63f20f02bfd85e8$var$s, $f63f20f02bfd85e8$var$o({}, e, {
                store: r
            }));
        },
        GoToFirstPage: i,
        GoToFirstPageButton: function() {
            return $f63f20f02bfd85e8$var$n.createElement(i, null, function(e) {
                return $f63f20f02bfd85e8$var$n.createElement($f63f20f02bfd85e8$var$m, $f63f20f02bfd85e8$var$o({}, e));
            });
        },
        GoToFirstPageMenuItem: function(e) {
            return $f63f20f02bfd85e8$var$n.createElement(i, null, function(t) {
                return $f63f20f02bfd85e8$var$n.createElement($f63f20f02bfd85e8$var$v, {
                    isDisabled: t.isDisabled,
                    onClick: function() {
                        t.onClick(), e.onClick();
                    }
                });
            });
        },
        GoToLastPage: u,
        GoToLastPageButton: function() {
            return $f63f20f02bfd85e8$var$n.createElement(u, null, function(e) {
                return $f63f20f02bfd85e8$var$n.createElement($f63f20f02bfd85e8$var$P, $f63f20f02bfd85e8$var$o({}, e));
            });
        },
        GoToLastPageMenuItem: function(e) {
            return $f63f20f02bfd85e8$var$n.createElement(u, null, function(t) {
                return $f63f20f02bfd85e8$var$n.createElement($f63f20f02bfd85e8$var$E, {
                    isDisabled: t.isDisabled,
                    onClick: function() {
                        t.onClick(), e.onClick();
                    }
                });
            });
        },
        GoToNextPage: l,
        GoToNextPageButton: function() {
            return $f63f20f02bfd85e8$var$n.createElement(l, null, function(e) {
                return $f63f20f02bfd85e8$var$n.createElement($f63f20f02bfd85e8$var$D, $f63f20f02bfd85e8$var$o({}, e));
            });
        },
        GoToNextPageMenuItem: function(e) {
            return $f63f20f02bfd85e8$var$n.createElement(l, null, function(t) {
                return $f63f20f02bfd85e8$var$n.createElement($f63f20f02bfd85e8$var$T, {
                    isDisabled: t.isDisabled,
                    onClick: function() {
                        t.onClick(), e.onClick();
                    }
                });
            });
        },
        GoToPreviousPage: g,
        GoToPreviousPageButton: function() {
            return $f63f20f02bfd85e8$var$n.createElement(g, null, function(e) {
                return $f63f20f02bfd85e8$var$n.createElement($f63f20f02bfd85e8$var$N, $f63f20f02bfd85e8$var$o({}, e));
            });
        },
        GoToPreviousPageMenuItem: function(e) {
            return $f63f20f02bfd85e8$var$n.createElement(g, null, function(t) {
                return $f63f20f02bfd85e8$var$n.createElement($f63f20f02bfd85e8$var$I, {
                    isDisabled: t.isDisabled,
                    onClick: function() {
                        t.onClick(), e.onClick();
                    }
                });
            });
        },
        NumberOfPages: function(e) {
            return $f63f20f02bfd85e8$var$n.createElement($f63f20f02bfd85e8$var$h, $f63f20f02bfd85e8$var$o({}, e, {
                store: r
            }));
        }
    };
};

});


parcelRegister("OvUAV", function(module, exports) {
/**
 * A React component to view a PDF document
 *
 * @see https://react-pdf-viewer.dev
 * @license https://react-pdf-viewer.dev/license
 * @copyright 2019-2023 Nguyen Huu Phuoc <me@phuoc.ng>
 */ "use strict";

module.exports = (parcelRequire("jB35M"));

});
parcelRegister("jB35M", function(module, exports) {

$parcel$export(module.exports, "PrintIcon", () => $03ae839911475a72$export$45339094dab73a8e, (v) => $03ae839911475a72$export$45339094dab73a8e = v);
$parcel$export(module.exports, "getAllPagesNumbers", () => $03ae839911475a72$export$3a962ec71823be06, (v) => $03ae839911475a72$export$3a962ec71823be06 = v);
$parcel$export(module.exports, "getCustomPagesNumbers", () => $03ae839911475a72$export$2fc1739599c001ea, (v) => $03ae839911475a72$export$2fc1739599c001ea = v);
$parcel$export(module.exports, "getEvenPagesNumbers", () => $03ae839911475a72$export$f55aaa50e3323166, (v) => $03ae839911475a72$export$f55aaa50e3323166 = v);
$parcel$export(module.exports, "getOddPagesNumbers", () => $03ae839911475a72$export$f2235e5c52a5935, (v) => $03ae839911475a72$export$f2235e5c52a5935 = v);
$parcel$export(module.exports, "printPlugin", () => $03ae839911475a72$export$5ce4865ff6828c3f, (v) => $03ae839911475a72$export$5ce4865ff6828c3f = v);
var $03ae839911475a72$export$45339094dab73a8e;
var $03ae839911475a72$export$3a962ec71823be06;
var $03ae839911475a72$export$2fc1739599c001ea;
var $03ae839911475a72$export$f55aaa50e3323166;
var $03ae839911475a72$export$f2235e5c52a5935;
var $03ae839911475a72$export$5ce4865ff6828c3f;

var $ec262 = parcelRequire("ec262");
"use strict";

var $6eW0i = parcelRequire("6eW0i");

var $kc00y = parcelRequire("kc00y");

var $cn1Kz = parcelRequire("cn1Kz");
function $03ae839911475a72$var$r(e) {
    var t = Object.create(null);
    return e && Object.keys(e).forEach(function(n) {
        if ("default" !== n) {
            var r = Object.getOwnPropertyDescriptor(e, n);
            Object.defineProperty(t, n, r.get ? r : {
                enumerable: !0,
                get: function() {
                    return e[n];
                }
            });
        }
    }), t.default = e, Object.freeze(t);
}
var $03ae839911475a72$var$o, $03ae839911475a72$var$a = $03ae839911475a72$var$r($kc00y), $03ae839911475a72$var$i = function() {
    return $03ae839911475a72$var$a.createElement($6eW0i.Icon, {
        size: 16
    }, $03ae839911475a72$var$a.createElement("path", {
        d: "M7.5,19.499h9 M7.5,16.499h9 M5.5,16.5h-3c-1.103-0.003-1.997-0.897-2-2v-6c0.003-1.103,0.897-1.997,2-2h19\n            c1.103,0.003,1.997,0.897,2,2v6c-0.003,1.103-0.897,1.997-2,2h-3\n            M5.5,4.5v-4h9.586c0.265,0,0.52,0.105,0.707,0.293l2.414,2.414\n            C18.395,3.394,18.5,3.649,18.5,3.914V4.5\n            M18.5,22.5c0,0.552-0.448,1-1,1h-11c-0.552,0-1-0.448-1-1v-9h13V22.5z\n            M3.5,8.499\n            c0.552,0,1,0.448,1,1s-0.448,1-1,1s-1-0.448-1-1S2.948,8.499,3.5,8.499z\n            M14.5,0.499v4h4"
    }));
}, $03ae839911475a72$var$c = function() {
    return $03ae839911475a72$var$c = Object.assign || function(e) {
        for(var t, n = 1, r = arguments.length; n < r; n++)for(var o in t = arguments[n])Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
    }, $03ae839911475a72$var$c.apply(this, arguments);
}, $03ae839911475a72$var$u = {
    left: 0,
    top: 8
}, $03ae839911475a72$var$s = function(t) {
    var n = t.enableShortcuts, r = t.onClick, o = $03ae839911475a72$var$a.useContext($6eW0i.LocalizationContext).l10n, c = o && o.print ? o.print.print : "Print", s = n ? $6eW0i.isMac() ? "Meta+P" : "Ctrl+P" : "";
    return $03ae839911475a72$var$a.createElement($6eW0i.Tooltip, {
        ariaControlsSuffix: "print",
        position: $6eW0i.Position.BottomCenter,
        target: $03ae839911475a72$var$a.createElement($6eW0i.MinimalButton, {
            ariaKeyShortcuts: s,
            ariaLabel: c,
            testId: "print__button",
            onClick: r
        }, $03ae839911475a72$var$a.createElement($03ae839911475a72$var$i, null)),
        content: function() {
            return c;
        },
        offset: $03ae839911475a72$var$u
    });
};
!function(e) {
    e.CheckingPermission = "CheckingPermission", e.Inactive = "Inactive", e.Preparing = "Preparing", e.Cancelled = "Cancelled", e.Ready = "Ready";
}($03ae839911475a72$var$o || ($03ae839911475a72$var$o = {}));
var $03ae839911475a72$var$l = function(e) {
    var t = e.children, n = e.enableShortcuts, r = e.store;
    return (t || $03ae839911475a72$var$s)({
        enableShortcuts: n,
        onClick: function() {
            r.update("printStatus", $03ae839911475a72$var$o.CheckingPermission);
        }
    });
}, $03ae839911475a72$var$p = function(t) {
    var n = t.doc, r = t.store, i = $03ae839911475a72$var$a.useContext($6eW0i.LocalizationContext).l10n, c = $03ae839911475a72$var$a.useState(!0), u = c[0], s = c[1];
    return $03ae839911475a72$var$a.useEffect(function() {
        n.getPermissions().then(function(e) {
            null === e || e.includes(4) || e.includes(2048) ? r.update("printStatus", $03ae839911475a72$var$o.Preparing) : s(!1);
        });
    }, []), u ? $03ae839911475a72$var$a.createElement($03ae839911475a72$var$a.Fragment, null) : $03ae839911475a72$var$a.createElement($6eW0i.Modal, {
        ariaControlsSuffix: "print-permission",
        closeOnClickOutside: !1,
        closeOnEscape: !1,
        content: function(t) {
            return $03ae839911475a72$var$a.createElement($03ae839911475a72$var$a.Fragment, null, $03ae839911475a72$var$a.createElement("div", {
                className: "rpv-print__permission-body"
            }, i && i.print ? i.print.disallowPrint : "The document does not allow to print"), $03ae839911475a72$var$a.createElement("div", {
                className: "rpv-print__permission-footer"
            }, $03ae839911475a72$var$a.createElement($6eW0i.Button, {
                onClick: function() {
                    t(), r.update("printStatus", $03ae839911475a72$var$o.Cancelled);
                }
            }, i && i.print ? i.print.close : "Close")));
        },
        isOpened: !0
    });
}, $03ae839911475a72$var$m = function(t) {
    var n = t.numLoadedPages, r = t.numPages, o = t.onCancel, i = $03ae839911475a72$var$a.useContext($6eW0i.LocalizationContext).l10n, c = $03ae839911475a72$var$a.useContext($6eW0i.ThemeContext).direction === $6eW0i.TextDirection.RightToLeft, u = Math.floor(100 * n / r);
    return $03ae839911475a72$var$a.createElement("div", {
        className: "rpv-print__progress"
    }, $03ae839911475a72$var$a.createElement("div", {
        className: $6eW0i.classNames({
            "rpv-print__progress-body": !0,
            "rpv-print__progress-body--rtl": c
        })
    }, $03ae839911475a72$var$a.createElement("div", {
        className: "rpv-print__progress-message"
    }, i && i.print ? i.print.preparingDocument : "Preparing document ..."), $03ae839911475a72$var$a.createElement("div", {
        className: "rpv-print__progress-bar"
    }, $03ae839911475a72$var$a.createElement($6eW0i.ProgressBar, {
        progress: u
    })), $03ae839911475a72$var$a.createElement($6eW0i.Button, {
        onClick: o
    }, i && i.print ? i.print.cancel : "Cancel")));
}, $03ae839911475a72$var$d = function(t) {
    var n = t.canvas, r = t.page, o = t.pageHeight, i = t.pageIndex, c = t.pageWidth, u = t.rotation, s = t.onLoad, l = $6eW0i.useIsMounted(), p = $03ae839911475a72$var$a.useRef(), m = $03ae839911475a72$var$a.useState(""), d = m[0], f = m[1], g = $03ae839911475a72$var$a.useMemo(function() {
        return "undefined" != typeof $ec262 && false;
    }, []);
    return $03ae839911475a72$var$a.useEffect(function() {
        var e = p.current;
        e && e.cancel();
        var t = 150 / 72;
        n.height = Math.floor(o * t), n.width = Math.floor(c * t);
        var a = n.getContext("2d");
        a.save(), a.fillStyle = "rgb(255, 255, 255)", a.fillRect(0, 0, n.width, n.height), a.restore();
        var i = r.getViewport({
            rotation: u,
            scale: 1
        });
        p.current = r.render({
            canvasContext: a,
            intent: "print",
            transform: [
                t,
                0,
                0,
                t,
                0,
                0
            ],
            viewport: i
        }), p.current.promise.then(function() {
            "toBlob" in n && "createObjectURL" in URL ? n.toBlob(function(e) {
                l.current && f(URL.createObjectURL(e)), g && s();
            }) : (l.current && f(n.toDataURL()), g && s());
        }, function() {});
    }, []), d && $03ae839911475a72$var$a.createElement("div", {
        className: "rpv-print__page"
    }, $03ae839911475a72$var$a.createElement("img", {
        "data-testid": "print__thumbnail-".concat(i),
        src: d,
        onLoad: function() {
            g || s();
        }
    }));
}, $03ae839911475a72$var$f = function(t) {
    var n = t.canvas, r = t.doc, o = t.pageIndex, i = t.pageRotation, c = t.pageSize, u = t.rotation, s = t.shouldRender, l = t.onLoad, p = $6eW0i.useIsMounted(), m = $03ae839911475a72$var$a.useState(null), f = m[0], g = m[1], v = Math.abs(u + i) % 180 == 0;
    $03ae839911475a72$var$a.useEffect(function() {
        s && $6eW0i.getPage(r, o).then(function(e) {
            p.current && g(e);
        });
    }, [
        s
    ]);
    var h = (c.rotation + u + i) % 360;
    return f && $03ae839911475a72$var$a.createElement($03ae839911475a72$var$d, {
        canvas: n,
        page: f,
        pageHeight: v ? c.pageHeight : c.pageWidth,
        pageIndex: o,
        pageWidth: v ? c.pageWidth : c.pageHeight,
        rotation: h,
        onLoad: l
    });
}, $03ae839911475a72$var$g = function(e) {
    var t = e.doc, r = e.numLoadedPages, i = e.pagesRotation, c = e.pageSizes, u = e.printPages, s = e.printStatus, l = e.rotation, p = e.onCancel, m = e.onLoad, d = $03ae839911475a72$var$a.useMemo(function() {
        return document.createElement("canvas");
    }, []), g = $03ae839911475a72$var$a.useMemo(function() {
        var e = document.querySelector(".rpv-print__zone");
        if (e) return e;
        var t = document.createElement("div");
        return t.classList.add("rpv-print__zone"), t.setAttribute("data-testid", "print__zone"), document.body.appendChild(t), t;
    }, []);
    $03ae839911475a72$var$a.useEffect(function() {
        s === $03ae839911475a72$var$o.Ready && (document.documentElement.classList.add("rpv-print__html-printing"), document.body.classList.add("rpv-print__body-printing"), window.print());
        var e = function() {
            if (s === $03ae839911475a72$var$o.Ready) {
                document.documentElement.classList.remove("rpv-print__html-printing"), document.body.classList.remove("rpv-print__body-printing");
                var t = document.querySelectorAll(".rpv-print__zone");
                t && t.forEach(function(e) {
                    e.parentElement.removeChild(e);
                }), d.height = 0, d.width = 0, document.removeEventListener("mousemove", e), p();
            }
        };
        return document.addEventListener("mousemove", e), function() {
            return document.removeEventListener("mousemove", e);
        };
    }, [
        s
    ]);
    var v = c[0].pageHeight, h = c[0].pageWidth;
    return $cn1Kz.createPortal($03ae839911475a72$var$a.createElement($03ae839911475a72$var$a.Fragment, null, u.map(function(e, n) {
        return $03ae839911475a72$var$a.createElement($03ae839911475a72$var$f, {
            key: e,
            canvas: d,
            doc: t,
            pageIndex: e,
            pageRotation: i.has(e) ? i.get(e) : 0,
            pageSize: c[e],
            rotation: l,
            shouldRender: n === r,
            onLoad: m
        });
    }), $03ae839911475a72$var$a.createElement("style", {
        dangerouslySetInnerHTML: {
            __html: "@page { size: ".concat(h, "pt ").concat(v, "pt }")
        }
    })), g);
}, $03ae839911475a72$var$v = function(e) {
    var t = e.doc, n = e.pagesRotation, r = e.pageSizes, i = e.renderProgressBar, c = e.rotation, u = e.setPages, s = e.store, l = $03ae839911475a72$var$a.useState($03ae839911475a72$var$o.Inactive), d = l[0], f = l[1], v = $03ae839911475a72$var$a.useState(0), h = v[0], E = v[1], P = $03ae839911475a72$var$a.useMemo(function() {
        var e = t.numPages;
        return u(t).filter(function(t) {
            return t >= 0 && t < e;
        });
    }, [
        t,
        u
    ]), C = P.length, b = function() {
        E(0), f($03ae839911475a72$var$o.Inactive);
    }, _ = function(e) {
        return f(e);
    };
    return $03ae839911475a72$var$a.useEffect(function() {
        return s.subscribe("printStatus", _), function() {
            s.unsubscribe("printStatus", _);
        };
    }, []), $03ae839911475a72$var$a.createElement($03ae839911475a72$var$a.Fragment, null, d === $03ae839911475a72$var$o.CheckingPermission && $03ae839911475a72$var$a.createElement($03ae839911475a72$var$p, {
        doc: t,
        store: s
    }), d === $03ae839911475a72$var$o.Preparing && (i ? i(h, C, b) : $03ae839911475a72$var$a.createElement($03ae839911475a72$var$m, {
        numLoadedPages: h,
        numPages: C,
        onCancel: b
    })), (d === $03ae839911475a72$var$o.Preparing || d === $03ae839911475a72$var$o.Ready) && h <= C && $03ae839911475a72$var$a.createElement($03ae839911475a72$var$g, {
        doc: t,
        numLoadedPages: h,
        pagesRotation: n,
        pageSizes: r,
        printPages: P,
        printStatus: d,
        rotation: c,
        onCancel: b,
        onLoad: function() {
            var e = h + 1;
            e <= C && (E(e), e === C && f($03ae839911475a72$var$o.Ready));
        }
    }));
}, $03ae839911475a72$var$h = function(t) {
    var n = t.onClick, r = $03ae839911475a72$var$a.useContext($6eW0i.LocalizationContext).l10n, o = r && r.print ? r.print.print : "Print";
    return $03ae839911475a72$var$a.createElement($6eW0i.MenuItem, {
        icon: $03ae839911475a72$var$a.createElement($03ae839911475a72$var$i, null),
        testId: "print__menu",
        onClick: n
    }, o);
}, $03ae839911475a72$var$E = function(t) {
    var n = t.containerRef, r = t.store, i = function(t) {
        if (!t.shiftKey && !t.altKey && "p" === t.key && ($6eW0i.isMac() ? t.metaKey : t.ctrlKey)) {
            var a = n.current;
            a && document.activeElement && a.contains(document.activeElement) && (t.preventDefault(), r.update("printStatus", $03ae839911475a72$var$o.Preparing));
        }
    };
    return $03ae839911475a72$var$a.useEffect(function() {
        if (n.current) return document.addEventListener("keydown", i), function() {
            document.removeEventListener("keydown", i);
        };
    }, [
        n.current
    ]), $03ae839911475a72$var$a.createElement($03ae839911475a72$var$a.Fragment, null);
};
$03ae839911475a72$export$45339094dab73a8e = $03ae839911475a72$var$i, $03ae839911475a72$export$3a962ec71823be06 = function(e) {
    return Array(e.numPages).fill(0).map(function(e, t) {
        return t;
    });
}, $03ae839911475a72$export$2fc1739599c001ea = function(e) {
    return function(t) {
        var n, r = [];
        return e.replace(/\s+/g, "").split(",").forEach(function(e) {
            var t, n, o = e.split("-").map(function(e) {
                return parseInt(e, 10);
            }).filter(function(e) {
                return Number.isInteger(e);
            });
            1 === o.length ? r.push(o[0] - 1) : 2 === o.length && r.push.apply(r, (t = o[0] - 1, n = o[1] - 1, Array(n - t + 1).fill(0).map(function(e, n) {
                return t + n;
            })));
        }), (n = r, n.filter(function(e) {
            return n.indexOf(e) === n.lastIndexOf(e);
        })).filter(function(e) {
            return e >= 0 && e < t.numPages;
        });
    };
}, $03ae839911475a72$export$f55aaa50e3323166 = function(e) {
    return Array(e.numPages).fill(0).map(function(e, t) {
        return t;
    }).filter(function(e) {
        return (e + 1) % 2 == 0;
    });
}, $03ae839911475a72$export$f2235e5c52a5935 = function(e) {
    return Array(e.numPages).fill(0).map(function(e, t) {
        return t;
    }).filter(function(e) {
        return (e + 1) % 2 == 1;
    });
}, $03ae839911475a72$export$5ce4865ff6828c3f = function(t) {
    var n = $03ae839911475a72$var$a.useMemo(function() {
        return Object.assign({}, {
            enableShortcuts: !0,
            setPages: function(e) {
                return Array(e.numPages).fill(0).map(function(e, t) {
                    return t;
                });
            }
        }, t);
    }, []), r = $03ae839911475a72$var$a.useMemo(function() {
        return $6eW0i.createStore({
            printStatus: $03ae839911475a72$var$o.Inactive
        });
    }, []), i = function(e) {
        return $03ae839911475a72$var$a.createElement($03ae839911475a72$var$l, $03ae839911475a72$var$c({
            enableShortcuts: n.enableShortcuts
        }, e, {
            store: r
        }));
    };
    return {
        print: function() {
            r.update("printStatus", $03ae839911475a72$var$o.CheckingPermission);
        },
        renderViewer: function(e) {
            var o = e.slot, i = {
                children: $03ae839911475a72$var$a.createElement($03ae839911475a72$var$a.Fragment, null, n.enableShortcuts && $03ae839911475a72$var$a.createElement($03ae839911475a72$var$E, {
                    containerRef: e.containerRef,
                    store: r
                }), $03ae839911475a72$var$a.createElement($03ae839911475a72$var$v, {
                    doc: e.doc,
                    pagesRotation: e.pagesRotation,
                    pageSizes: e.pageSizes,
                    renderProgressBar: null == t ? void 0 : t.renderProgressBar,
                    rotation: e.rotation,
                    setPages: n.setPages,
                    store: r
                }), o.children)
            };
            return $03ae839911475a72$var$c($03ae839911475a72$var$c({}, o), i);
        },
        Print: i,
        PrintButton: function() {
            return $03ae839911475a72$var$a.createElement(i, null, function(e) {
                return $03ae839911475a72$var$a.createElement($03ae839911475a72$var$s, $03ae839911475a72$var$c({}, e));
            });
        },
        PrintMenuItem: function(e) {
            return $03ae839911475a72$var$a.createElement(i, null, function(t) {
                return $03ae839911475a72$var$a.createElement($03ae839911475a72$var$h, {
                    onClick: function() {
                        t.onClick(), e.onClick();
                    }
                });
            });
        },
        setPages: function(e) {
            n.setPages = e;
        }
    };
};

});


parcelRegister("ebXBL", function(module, exports) {
/**
 * A React component to view a PDF document
 *
 * @see https://react-pdf-viewer.dev
 * @license https://react-pdf-viewer.dev/license
 * @copyright 2019-2023 Nguyen Huu Phuoc <me@phuoc.ng>
 */ "use strict";

module.exports = (parcelRequire("1r6KL"));

});
parcelRegister("1r6KL", function(module, exports) {

$parcel$export(module.exports, "InfoIcon", () => $10bd8d1d0d803952$export$2957fc44b3d2481, (v) => $10bd8d1d0d803952$export$2957fc44b3d2481 = v);
$parcel$export(module.exports, "propertiesPlugin", () => $10bd8d1d0d803952$export$be7edecef5d53862, (v) => $10bd8d1d0d803952$export$be7edecef5d53862 = v);
var $10bd8d1d0d803952$export$2957fc44b3d2481;
var $10bd8d1d0d803952$export$be7edecef5d53862;
"use strict";

var $6eW0i = parcelRequire("6eW0i");
function $10bd8d1d0d803952$var$t(e) {
    var t = Object.create(null);
    return e && Object.keys(e).forEach(function(r) {
        if ("default" !== r) {
            var n = Object.getOwnPropertyDescriptor(e, r);
            Object.defineProperty(t, r, n.get ? n : {
                enumerable: !0,
                get: function() {
                    return e[r];
                }
            });
        }
    }), t.default = e, Object.freeze(t);
}

var $10bd8d1d0d803952$var$r = $10bd8d1d0d803952$var$t((parcelRequire("kc00y"))), $10bd8d1d0d803952$var$n = function() {
    return $10bd8d1d0d803952$var$r.createElement($6eW0i.Icon, {
        size: 16
    }, $10bd8d1d0d803952$var$r.createElement("path", {
        d: "M12,1.001c6.075,0,11,4.925,11,11s-4.925,11-11,11s-11-4.925-11-11S5.925,1.001,12,1.001z\n            M14.5,17.005H13\n            c-0.552,0-1-0.448-1-1v-6.5c0-0.276-0.224-0.5-0.5-0.5H10\n            M11.745,6.504L11.745,6.504\n            M11.745,6.5c-0.138,0-0.25,0.112-0.25,0.25\n            S11.607,7,11.745,7s0.25-0.112,0.25-0.25S11.883,6.5,11.745,6.5"
    }));
}, $10bd8d1d0d803952$var$o = function() {
    return $10bd8d1d0d803952$var$o = Object.assign || function(e) {
        for(var t, r = 1, n = arguments.length; r < n; r++)for(var o in t = arguments[r])Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
    }, $10bd8d1d0d803952$var$o.apply(this, arguments);
}, $10bd8d1d0d803952$var$a = function(t) {
    var n = t.doc, o = t.render, a = $10bd8d1d0d803952$var$r.useState(), i = a[0], l = a[1];
    return $10bd8d1d0d803952$var$r.useEffect(function() {
        n.getMetadata().then(function(e) {
            return Promise.resolve(e);
        }).then(function(e) {
            return n.getDownloadInfo().then(function(t) {
                return Promise.resolve({
                    fileName: e.contentDispositionFilename || "",
                    info: e.info,
                    length: t.length
                });
            });
        }).then(function(e) {
            l(e);
        });
    }, []), i ? o(i) : $10bd8d1d0d803952$var$r.createElement("div", {
        className: "rpv-properties__loader"
    }, $10bd8d1d0d803952$var$r.createElement($6eW0i.Spinner, null));
}, $10bd8d1d0d803952$var$i = function(t) {
    var n = t.label, o = t.value, a = $10bd8d1d0d803952$var$r.useContext($6eW0i.ThemeContext).direction === $6eW0i.TextDirection.RightToLeft;
    return $10bd8d1d0d803952$var$r.createElement("dl", {
        className: $6eW0i.classNames({
            "rpv-properties__item": !0,
            "rpv-properties__item--rtl": a
        })
    }, $10bd8d1d0d803952$var$r.createElement("dt", {
        className: "rpv-properties__item-label"
    }, n, ":"), $10bd8d1d0d803952$var$r.createElement("dd", {
        className: "rpv-properties__item-value"
    }, o || "-"));
}, $10bd8d1d0d803952$var$l = new RegExp("^D:(\\d{4})(\\d{2})?(\\d{2})?(\\d{2})?(\\d{2})?(\\d{2})?([Z|+|-])?(\\d{2})?'?(\\d{2})?'?"), $10bd8d1d0d803952$var$c = function(e, t, r, n) {
    var o = parseInt(e, 10);
    return o >= t && o <= r ? o : n;
}, $10bd8d1d0d803952$var$p = function(t) {
    var n = t.doc, o = t.fileName, p = t.onToggle, s = $10bd8d1d0d803952$var$r.useContext($6eW0i.LocalizationContext).l10n, u = function(e) {
        var t = function(e) {
            var t = $10bd8d1d0d803952$var$l.exec(e);
            if (!t) return null;
            var r = parseInt(t[1], 10), n = $10bd8d1d0d803952$var$c(t[2], 1, 12, 1) - 1, o = $10bd8d1d0d803952$var$c(t[3], 1, 31, 1), a = $10bd8d1d0d803952$var$c(t[4], 0, 23, 0), i = $10bd8d1d0d803952$var$c(t[5], 0, 59, 0), p = $10bd8d1d0d803952$var$c(t[6], 0, 59, 0), s = t[7] || "Z", u = $10bd8d1d0d803952$var$c(t[8], 0, 23, 0), m = $10bd8d1d0d803952$var$c(t[9], 0, 59, 0);
            switch(s){
                case "-":
                    a += u, i += m;
                    break;
                case "+":
                    a -= u, i -= m;
            }
            return new Date(Date.UTC(r, n, o, a, i, p));
        }(e);
        return t ? "".concat(t.toLocaleDateString(), ", ").concat(t.toLocaleTimeString()) : "";
    };
    return $10bd8d1d0d803952$var$r.createElement("div", {
        className: "rpv-properties__modal"
    }, $10bd8d1d0d803952$var$r.createElement($10bd8d1d0d803952$var$a, {
        doc: n,
        render: function(t) {
            var a, l, c, p;
            return $10bd8d1d0d803952$var$r.createElement($10bd8d1d0d803952$var$r.Fragment, null, $10bd8d1d0d803952$var$r.createElement("div", {
                className: "rpv-properties__modal-section"
            }, $10bd8d1d0d803952$var$r.createElement($10bd8d1d0d803952$var$i, {
                label: s && s.properties ? s.properties.fileName : "File name",
                value: t.fileName || (c = o, p = c.split("/").pop(), p ? p.split("#")[0].split("?")[0] : c)
            }), $10bd8d1d0d803952$var$r.createElement($10bd8d1d0d803952$var$i, {
                label: s && s.properties ? s.properties.fileSize : "File size",
                value: (a = t.length, l = Math.floor(Math.log(a) / Math.log(1024)), "".concat((a / Math.pow(1024, l)).toFixed(2), " ").concat([
                    "B",
                    "kB",
                    "MB",
                    "GB",
                    "TB"
                ][l]))
            })), $10bd8d1d0d803952$var$r.createElement($6eW0i.Separator, null), $10bd8d1d0d803952$var$r.createElement("div", {
                className: "rpv-properties__modal-section"
            }, $10bd8d1d0d803952$var$r.createElement($10bd8d1d0d803952$var$i, {
                label: s && s.properties ? s.properties.title : "Title",
                value: t.info.Title
            }), $10bd8d1d0d803952$var$r.createElement($10bd8d1d0d803952$var$i, {
                label: s && s.properties ? s.properties.author : "Author",
                value: t.info.Author
            }), $10bd8d1d0d803952$var$r.createElement($10bd8d1d0d803952$var$i, {
                label: s && s.properties ? s.properties.subject : "Subject",
                value: t.info.Subject
            }), $10bd8d1d0d803952$var$r.createElement($10bd8d1d0d803952$var$i, {
                label: s && s.properties ? s.properties.keywords : "Keywords",
                value: t.info.Keywords
            }), $10bd8d1d0d803952$var$r.createElement($10bd8d1d0d803952$var$i, {
                label: s && s.properties ? s.properties.creator : "Creator",
                value: t.info.Creator
            }), $10bd8d1d0d803952$var$r.createElement($10bd8d1d0d803952$var$i, {
                label: s && s.properties ? s.properties.creationDate : "Creation date",
                value: u(t.info.CreationDate)
            }), $10bd8d1d0d803952$var$r.createElement($10bd8d1d0d803952$var$i, {
                label: s && s.properties ? s.properties.modificationDate : "Modification date",
                value: u(t.info.ModDate)
            })), $10bd8d1d0d803952$var$r.createElement($6eW0i.Separator, null), $10bd8d1d0d803952$var$r.createElement("div", {
                className: "rpv-properties__modal-section"
            }, $10bd8d1d0d803952$var$r.createElement($10bd8d1d0d803952$var$i, {
                label: s && s.properties ? s.properties.pdfProducer : "PDF producer",
                value: t.info.Producer
            }), $10bd8d1d0d803952$var$r.createElement($10bd8d1d0d803952$var$i, {
                label: s && s.properties ? s.properties.pdfVersion : "PDF version",
                value: t.info.PDFFormatVersion
            }), $10bd8d1d0d803952$var$r.createElement($10bd8d1d0d803952$var$i, {
                label: s && s.properties ? s.properties.pageCount : "Page count",
                value: "".concat(n.numPages)
            })));
        }
    }), $10bd8d1d0d803952$var$r.createElement("div", {
        className: "rpv-properties__modal-footer"
    }, $10bd8d1d0d803952$var$r.createElement($6eW0i.Button, {
        onClick: p
    }, s && s.properties ? s.properties.close : "Close")));
}, $10bd8d1d0d803952$var$s = {
    left: 0,
    top: 8
}, $10bd8d1d0d803952$var$u = function(t) {
    var o = t.onClick, a = $10bd8d1d0d803952$var$r.useContext($6eW0i.LocalizationContext).l10n, i = a && a.properties ? a.properties.showProperties : "Show properties";
    return $10bd8d1d0d803952$var$r.createElement($6eW0i.Tooltip, {
        ariaControlsSuffix: "properties",
        position: $6eW0i.Position.BottomCenter,
        target: $10bd8d1d0d803952$var$r.createElement($6eW0i.MinimalButton, {
            ariaLabel: i,
            testId: "properties__button",
            onClick: o
        }, $10bd8d1d0d803952$var$r.createElement($10bd8d1d0d803952$var$n, null)),
        content: function() {
            return i;
        },
        offset: $10bd8d1d0d803952$var$s
    });
}, $10bd8d1d0d803952$var$m = function(t) {
    var n = t.children, a = t.store, i = function(e) {
        var t = $10bd8d1d0d803952$var$r.useState(e.get("doc")), n = t[0], o = t[1], a = function(e) {
            o(e);
        };
        return $10bd8d1d0d803952$var$r.useEffect(function() {
            return e.subscribe("doc", a), function() {
                e.unsubscribe("doc", a);
            };
        }, []), {
            currentDoc: n
        };
    }(a).currentDoc, l = a.get("fileName") || "", c = n || function(e) {
        return $10bd8d1d0d803952$var$r.createElement($10bd8d1d0d803952$var$u, $10bd8d1d0d803952$var$o({}, e));
    };
    return i ? $10bd8d1d0d803952$var$r.createElement($6eW0i.Modal, {
        ariaControlsSuffix: "properties",
        target: function(e) {
            return c({
                onClick: e
            });
        },
        content: function(e) {
            return $10bd8d1d0d803952$var$r.createElement($10bd8d1d0d803952$var$p, {
                doc: i,
                fileName: l,
                onToggle: e
            });
        },
        closeOnClickOutside: !0,
        closeOnEscape: !0
    }) : $10bd8d1d0d803952$var$r.createElement($10bd8d1d0d803952$var$r.Fragment, null);
}, $10bd8d1d0d803952$var$f = function(t) {
    var o = t.onClick, a = $10bd8d1d0d803952$var$r.useContext($6eW0i.LocalizationContext).l10n, i = a && a.properties ? a.properties.showProperties : "Show properties";
    return $10bd8d1d0d803952$var$r.createElement($6eW0i.MenuItem, {
        icon: $10bd8d1d0d803952$var$r.createElement($10bd8d1d0d803952$var$n, null),
        testId: "properties__menu",
        onClick: o
    }, i);
};
$10bd8d1d0d803952$export$2957fc44b3d2481 = $10bd8d1d0d803952$var$n, $10bd8d1d0d803952$export$be7edecef5d53862 = function() {
    var t = $10bd8d1d0d803952$var$r.useMemo(function() {
        return $6eW0i.createStore({
            fileName: ""
        });
    }, []), n = function(e) {
        return $10bd8d1d0d803952$var$r.createElement($10bd8d1d0d803952$var$m, $10bd8d1d0d803952$var$o({}, e, {
            store: t
        }));
    };
    return {
        onDocumentLoad: function(e) {
            t.update("doc", e.doc);
        },
        onViewerStateChange: function(e) {
            return t.update("fileName", e.file.name), e;
        },
        ShowProperties: n,
        ShowPropertiesButton: function() {
            return $10bd8d1d0d803952$var$r.createElement($10bd8d1d0d803952$var$m, {
                store: t
            });
        },
        ShowPropertiesMenuItem: function(e) {
            return $10bd8d1d0d803952$var$r.createElement(n, null, function(e) {
                return $10bd8d1d0d803952$var$r.createElement($10bd8d1d0d803952$var$f, $10bd8d1d0d803952$var$o({}, e));
            });
        }
    };
};

});


parcelRegister("hMzN7", function(module, exports) {
/**
 * A React component to view a PDF document
 *
 * @see https://react-pdf-viewer.dev
 * @license https://react-pdf-viewer.dev/license
 * @copyright 2019-2023 Nguyen Huu Phuoc <me@phuoc.ng>
 */ "use strict";

module.exports = (parcelRequire("7QXZb"));

});
parcelRegister("7QXZb", function(module, exports) {

$parcel$export(module.exports, "RotateBackwardIcon", () => $5b7beba5ca2e719b$export$685676340cd244ea, (v) => $5b7beba5ca2e719b$export$685676340cd244ea = v);
$parcel$export(module.exports, "RotateForwardIcon", () => $5b7beba5ca2e719b$export$d8b4baa983e1effd, (v) => $5b7beba5ca2e719b$export$d8b4baa983e1effd = v);
$parcel$export(module.exports, "rotatePlugin", () => $5b7beba5ca2e719b$export$32c70e21a2c21c5f, (v) => $5b7beba5ca2e719b$export$32c70e21a2c21c5f = v);
var $5b7beba5ca2e719b$export$685676340cd244ea;
var $5b7beba5ca2e719b$export$d8b4baa983e1effd;
var $5b7beba5ca2e719b$export$32c70e21a2c21c5f;
"use strict";

var $6eW0i = parcelRequire("6eW0i");
function $5b7beba5ca2e719b$var$e(t) {
    var e = Object.create(null);
    return t && Object.keys(t).forEach(function(r) {
        if ("default" !== r) {
            var n = Object.getOwnPropertyDescriptor(t, r);
            Object.defineProperty(e, r, n.get ? n : {
                enumerable: !0,
                get: function() {
                    return t[r];
                }
            });
        }
    }), e.default = t, Object.freeze(e);
}

var $5b7beba5ca2e719b$var$r = $5b7beba5ca2e719b$var$e((parcelRequire("kc00y"))), $5b7beba5ca2e719b$var$n = function() {
    return $5b7beba5ca2e719b$var$r.createElement($6eW0i.Icon, {
        ignoreDirection: !0,
        size: 16
    }, $5b7beba5ca2e719b$var$r.createElement("path", {
        d: "M3.434,10.537c0.141-0.438,0.316-0.864,0.523-1.274\n            M3.069,14.425C3.023,14.053,3,13.679,3,13.305 c0-0.291,0.014-0.579,0.041-0.863\n            M4.389,18.111c-0.341-0.539-0.623-1.112-0.843-1.711\n            M7.163,20.9 c-0.543-0.345-1.048-0.747-1.506-1.2\n            M10.98,22.248c-0.65-0.074-1.29-0.218-1.909-0.431\n            M10,4.25h2 c4.987,0.015,9.017,4.069,9.003,9.055c-0.013,4.581-3.456,8.426-8.008,8.945\n            M13.5,1.75L10,4.25l3.5,2.5"
    }));
}, $5b7beba5ca2e719b$var$o = function() {
    return $5b7beba5ca2e719b$var$r.createElement($6eW0i.Icon, {
        ignoreDirection: !0,
        size: 16
    }, $5b7beba5ca2e719b$var$r.createElement("path", {
        d: "M20.566,10.537c-0.141-0.438-0.316-0.864-0.523-1.274\n            M20.931,14.425C20.977,14.053,21,13.679,21,13.305 c0-0.291-0.014-0.579-0.041-0.863\n            M19.611,18.111c0.341-0.539,0.624-1.114,0.843-1.713\n            M16.837,20.9 c0.543-0.345,1.048-0.747,1.506-1.2\n            M13.02,22.248c0.65-0.074,1.29-0.218,1.909-0.431\n            M14,4.25h-2 c-4.987,0.015-9.017,4.069-9.003,9.055c0.013,4.581,3.456,8.426,8.008,8.945\n            M10.5,1.75l3.5,2.5l-3.5,2.5"
    }));
}, $5b7beba5ca2e719b$var$c = function() {
    return $5b7beba5ca2e719b$var$c = Object.assign || function(t) {
        for(var e, r = 1, n = arguments.length; r < n; r++)for(var o in e = arguments[r])Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
        return t;
    }, $5b7beba5ca2e719b$var$c.apply(this, arguments);
}, $5b7beba5ca2e719b$var$a = {
    left: 0,
    top: 8
}, $5b7beba5ca2e719b$var$i = function(e) {
    var c = e.direction, i = e.onClick, u = $5b7beba5ca2e719b$var$r.useContext($6eW0i.LocalizationContext).l10n, l = u && u.rotate ? u.rotate.rotateBackward : "Rotate counterclockwise", d = u && u.rotate ? u.rotate.rotateForward : "Rotate clockwise", f = c === $6eW0i.RotateDirection.Backward ? l : d, k = c === $6eW0i.RotateDirection.Backward ? $5b7beba5ca2e719b$var$r.createElement($5b7beba5ca2e719b$var$n, null) : $5b7beba5ca2e719b$var$r.createElement($5b7beba5ca2e719b$var$o, null);
    return $5b7beba5ca2e719b$var$r.createElement($6eW0i.Tooltip, {
        ariaControlsSuffix: "rotate",
        position: $6eW0i.Position.BottomCenter,
        target: $5b7beba5ca2e719b$var$r.createElement($6eW0i.MinimalButton, {
            ariaLabel: f,
            testId: c === $6eW0i.RotateDirection.Backward ? "rotate__backward-button" : "rotate__forward-button",
            onClick: i
        }, k),
        content: function() {
            return f;
        },
        offset: $5b7beba5ca2e719b$var$a
    });
}, $5b7beba5ca2e719b$var$u = function(t) {
    var e = t.children, n = t.direction, o = t.store;
    return (e || function(t) {
        return $5b7beba5ca2e719b$var$r.createElement($5b7beba5ca2e719b$var$i, {
            direction: t.direction,
            onClick: t.onClick
        });
    })({
        direction: n,
        onClick: function() {
            var t = o.get("rotate");
            t && t(n);
        }
    });
}, $5b7beba5ca2e719b$var$l = function(e) {
    var c = e.direction, a = e.onClick, i = $5b7beba5ca2e719b$var$r.useContext($6eW0i.LocalizationContext).l10n, u = i && i.rotate ? i.rotate.rotateBackward : "Rotate counterclockwise", l = i && i.rotate ? i.rotate.rotateForward : "Rotate clockwise", d = c === $6eW0i.RotateDirection.Backward ? u : l, f = c === $6eW0i.RotateDirection.Backward ? $5b7beba5ca2e719b$var$r.createElement($5b7beba5ca2e719b$var$n, null) : $5b7beba5ca2e719b$var$r.createElement($5b7beba5ca2e719b$var$o, null);
    return $5b7beba5ca2e719b$var$r.createElement($6eW0i.MenuItem, {
        icon: f,
        testId: c === $6eW0i.RotateDirection.Backward ? "rotate__backward-menu" : "rotate__forward-menu",
        onClick: a
    }, d);
}, $5b7beba5ca2e719b$var$d = function(t) {
    var e = t.children, r = t.store;
    return e({
        onRotatePage: function(t, e) {
            var n = r.get("rotatePage");
            n && n(t, e);
        }
    });
};
$5b7beba5ca2e719b$export$685676340cd244ea = $5b7beba5ca2e719b$var$n, $5b7beba5ca2e719b$export$d8b4baa983e1effd = $5b7beba5ca2e719b$var$o, $5b7beba5ca2e719b$export$32c70e21a2c21c5f = function() {
    var e = $5b7beba5ca2e719b$var$r.useMemo(function() {
        return $6eW0i.createStore();
    }, []), n = function(t) {
        return $5b7beba5ca2e719b$var$r.createElement($5b7beba5ca2e719b$var$u, $5b7beba5ca2e719b$var$c({}, t, {
            store: e
        }));
    };
    return {
        install: function(t) {
            e.update("rotate", t.rotate), e.update("rotatePage", t.rotatePage);
        },
        Rotate: n,
        RotateBackwardButton: function() {
            return $5b7beba5ca2e719b$var$r.createElement(n, {
                direction: $6eW0i.RotateDirection.Backward
            }, function(t) {
                return $5b7beba5ca2e719b$var$r.createElement($5b7beba5ca2e719b$var$i, $5b7beba5ca2e719b$var$c({}, t));
            });
        },
        RotateBackwardMenuItem: function(e) {
            return $5b7beba5ca2e719b$var$r.createElement(n, {
                direction: $6eW0i.RotateDirection.Backward
            }, function(t) {
                return $5b7beba5ca2e719b$var$r.createElement($5b7beba5ca2e719b$var$l, {
                    direction: t.direction,
                    onClick: function() {
                        t.onClick(), e.onClick();
                    }
                });
            });
        },
        RotateForwardButton: function() {
            return $5b7beba5ca2e719b$var$r.createElement(n, {
                direction: $6eW0i.RotateDirection.Forward
            }, function(t) {
                return $5b7beba5ca2e719b$var$r.createElement($5b7beba5ca2e719b$var$i, $5b7beba5ca2e719b$var$c({}, t));
            });
        },
        RotateForwardMenuItem: function(e) {
            return $5b7beba5ca2e719b$var$r.createElement(n, {
                direction: $6eW0i.RotateDirection.Forward
            }, function(t) {
                return $5b7beba5ca2e719b$var$r.createElement($5b7beba5ca2e719b$var$l, {
                    direction: t.direction,
                    onClick: function() {
                        t.onClick(), e.onClick();
                    }
                });
            });
        },
        RotatePage: function(t) {
            return $5b7beba5ca2e719b$var$r.createElement($5b7beba5ca2e719b$var$d, $5b7beba5ca2e719b$var$c({}, t, {
                store: e
            }));
        }
    };
};

});


parcelRegister("9q7c7", function(module, exports) {
/**
 * A React component to view a PDF document
 *
 * @see https://react-pdf-viewer.dev
 * @license https://react-pdf-viewer.dev/license
 * @copyright 2019-2023 Nguyen Huu Phuoc <me@phuoc.ng>
 */ "use strict";

module.exports = (parcelRequire("c5O2G"));

});
parcelRegister("c5O2G", function(module, exports) {

$parcel$export(module.exports, "DualPageCoverViewModeIcon", () => $8cdcc50928e40d71$export$869c80bdcb9b3162, (v) => $8cdcc50928e40d71$export$869c80bdcb9b3162 = v);
$parcel$export(module.exports, "DualPageViewModeIcon", () => $8cdcc50928e40d71$export$8aef0f51c674f4e7, (v) => $8cdcc50928e40d71$export$8aef0f51c674f4e7 = v);
$parcel$export(module.exports, "HorizontalScrollingIcon", () => $8cdcc50928e40d71$export$dceed8f027679c95, (v) => $8cdcc50928e40d71$export$dceed8f027679c95 = v);
$parcel$export(module.exports, "PageScrollingIcon", () => $8cdcc50928e40d71$export$d708fd9366e42819, (v) => $8cdcc50928e40d71$export$d708fd9366e42819 = v);
$parcel$export(module.exports, "VerticalScrollingIcon", () => $8cdcc50928e40d71$export$3eb489432cc3ae40, (v) => $8cdcc50928e40d71$export$3eb489432cc3ae40 = v);
$parcel$export(module.exports, "WrappedScrollingIcon", () => $8cdcc50928e40d71$export$3367e6bf6a5c1af, (v) => $8cdcc50928e40d71$export$3367e6bf6a5c1af = v);
$parcel$export(module.exports, "scrollModePlugin", () => $8cdcc50928e40d71$export$139b33d69bfdb3f4, (v) => $8cdcc50928e40d71$export$139b33d69bfdb3f4 = v);
var $8cdcc50928e40d71$export$869c80bdcb9b3162;
var $8cdcc50928e40d71$export$8aef0f51c674f4e7;
var $8cdcc50928e40d71$export$dceed8f027679c95;
var $8cdcc50928e40d71$export$d708fd9366e42819;
var $8cdcc50928e40d71$export$3eb489432cc3ae40;
var $8cdcc50928e40d71$export$3367e6bf6a5c1af;
var $8cdcc50928e40d71$export$139b33d69bfdb3f4;
"use strict";

var $6eW0i = parcelRequire("6eW0i");
function $8cdcc50928e40d71$var$o(e) {
    var o = Object.create(null);
    return e && Object.keys(e).forEach(function(t) {
        if ("default" !== t) {
            var l = Object.getOwnPropertyDescriptor(e, t);
            Object.defineProperty(o, t, l.get ? l : {
                enumerable: !0,
                get: function() {
                    return e[t];
                }
            });
        }
    }), o.default = e, Object.freeze(o);
}

var $8cdcc50928e40d71$var$t = $8cdcc50928e40d71$var$o((parcelRequire("kc00y"))), $8cdcc50928e40d71$var$l = function() {
    return $8cdcc50928e40d71$var$t.createElement($6eW0i.Icon, {
        size: 16
    }, $8cdcc50928e40d71$var$t.createElement("rect", {
        x: "0.5",
        y: "0.497",
        width: "22",
        height: "22",
        rx: "1",
        ry: "1"
    }), $8cdcc50928e40d71$var$t.createElement("line", {
        x1: "0.5",
        y1: "6.497",
        x2: "22.5",
        y2: "6.497"
    }), $8cdcc50928e40d71$var$t.createElement("line", {
        x1: "11.5",
        y1: "6.497",
        x2: "11.5",
        y2: "22.497"
    }));
}, $8cdcc50928e40d71$var$c = function() {
    return $8cdcc50928e40d71$var$t.createElement($6eW0i.Icon, {
        size: 16
    }, $8cdcc50928e40d71$var$t.createElement("rect", {
        x: "0.5",
        y: "0.497",
        width: "22",
        height: "22",
        rx: "1",
        ry: "1"
    }), $8cdcc50928e40d71$var$t.createElement("line", {
        x1: "11.5",
        y1: "0.497",
        x2: "11.5",
        y2: "22.497"
    }));
}, $8cdcc50928e40d71$var$n = function() {
    return $8cdcc50928e40d71$var$t.createElement($6eW0i.Icon, {
        size: 16
    }, $8cdcc50928e40d71$var$t.createElement("path", {
        d: "M6.5,21.5c0,0.552-0.448,1-1,1h-4c-0.552,0-1-0.448-1-1v-20c0-0.552,0.448-1,1-1h4c0.552,0,1,0.448,1,1V21.5z\n            M14.5,21.5c0,0.552-0.448,1-1,1h-4c-0.552,0-1-0.448-1-1v-20c0-0.552,0.448-1,1-1h4c0.552,0,1,0.448,1,1V21.5z\n            M22.5,21.5 c0,0.552-0.448,1-1,1h-4c-0.552,0-1-0.448-1-1v-20c0-0.552,0.448-1,1-1h4c0.552,0,1,0.448,1,1V21.5z"
    }));
}, $8cdcc50928e40d71$var$r = function() {
    return $8cdcc50928e40d71$var$t.createElement($6eW0i.Icon, {
        size: 16
    }, $8cdcc50928e40d71$var$t.createElement("rect", {
        x: "0.5",
        y: "0.497",
        width: "22",
        height: "22",
        rx: "1",
        ry: "1"
    }));
}, $8cdcc50928e40d71$var$i = function() {
    return $8cdcc50928e40d71$var$i = Object.assign || function(e) {
        for(var o, t = 1, l = arguments.length; t < l; t++)for(var c in o = arguments[t])Object.prototype.hasOwnProperty.call(o, c) && (e[c] = o[c]);
        return e;
    }, $8cdcc50928e40d71$var$i.apply(this, arguments);
}, $8cdcc50928e40d71$var$a = function(o, t) {
    o.get("switchScrollMode")(t);
    var l = o.get("viewMode");
    t !== $6eW0i.ScrollMode.Horizontal && t !== $6eW0i.ScrollMode.Wrapped || l === $6eW0i.ViewMode.SinglePage || o.get("switchViewMode")($6eW0i.ViewMode.SinglePage);
}, $8cdcc50928e40d71$var$d = function() {
    return $8cdcc50928e40d71$var$t.createElement($6eW0i.Icon, {
        size: 16
    }, $8cdcc50928e40d71$var$t.createElement("path", {
        d: "M23.5,5.5c0,0.552-0.448,1-1,1h-21c-0.552,0-1-0.448-1-1v-3c0-0.552,0.448-1,1-1h21c0.552,0,1,0.448,1,1V5.5z\n            M23.5,13.5c0,0.552-0.448,1-1,1h-21c-0.552,0-1-0.448-1-1v-3c0-0.552,0.448-1,1-1h21c0.552,0,1,0.448,1,1V13.5z\n            M23.5,21.5 c0,0.552-0.448,1-1,1h-21c-0.552,0-1-0.448-1-1v-3c0-0.552,0.448-1,1-1h21c0.552,0,1,0.448,1,1V21.5z"
    }));
}, $8cdcc50928e40d71$var$s = function() {
    return $8cdcc50928e40d71$var$t.createElement($6eW0i.Icon, {
        size: 16
    }, $8cdcc50928e40d71$var$t.createElement("path", {
        d: "M10.5,9.5c0,0.552-0.448,1-1,1h-8c-0.552,0-1-0.448-1-1v-8c0-0.552,0.448-1,1-1h8c0.552,0,1,0.448,1,1V9.5z\n            M23.5,9.5c0,0.552-0.448,1-1,1h-8c-0.552,0-1-0.448-1-1v-8c0-0.552,0.448-1,1-1h8c0.552,0,1,0.448,1,1V9.5z\n            M10.5,22.5 c0,0.552-0.448,1-1,1h-8c-0.552,0-1-0.448-1-1v-8c0-0.552,0.448-1,1-1h8c0.552,0,1,0.448,1,1V22.5z\n            M23.5,22.5c0,0.552-0.448,1-1,1 h-8c-0.552,0-1-0.448-1-1v-8c0-0.552,0.448-1,1-1h8c0.552,0,1,0.448,1,1V22.5z"
    }));
}, $8cdcc50928e40d71$var$u = function(o) {
    var l = o.children, c = o.mode, i = o.onClick, a = $8cdcc50928e40d71$var$t.useContext($6eW0i.LocalizationContext).l10n, u = "", m = $8cdcc50928e40d71$var$t.createElement($8cdcc50928e40d71$var$d, null);
    switch(c){
        case $6eW0i.ScrollMode.Horizontal:
            u = a && a.scrollMode ? a.scrollMode.horizontalScrolling : "Horizontal scrolling", m = $8cdcc50928e40d71$var$t.createElement($8cdcc50928e40d71$var$n, null);
            break;
        case $6eW0i.ScrollMode.Page:
            u = a && a.scrollMode ? a.scrollMode.pageScrolling : "Page scrolling", m = $8cdcc50928e40d71$var$t.createElement($8cdcc50928e40d71$var$r, null);
            break;
        case $6eW0i.ScrollMode.Wrapped:
            u = a && a.scrollMode ? a.scrollMode.wrappedScrolling : "Wrapped scrolling", m = $8cdcc50928e40d71$var$t.createElement($8cdcc50928e40d71$var$s, null);
            break;
        case $6eW0i.ScrollMode.Vertical:
        default:
            u = a && a.scrollMode ? a.scrollMode.verticalScrolling : "Vertical scrolling", m = $8cdcc50928e40d71$var$t.createElement($8cdcc50928e40d71$var$d, null);
    }
    return l({
        icon: m,
        label: u,
        onClick: i
    });
}, $8cdcc50928e40d71$var$m = {
    left: 0,
    top: 8
}, $8cdcc50928e40d71$var$M = function(o) {
    var l = o.isDisabled, c = o.isSelected, n = o.mode, r = o.onClick, i = "";
    switch(n){
        case $6eW0i.ScrollMode.Horizontal:
            i = "scroll-mode__horizontal-button";
            break;
        case $6eW0i.ScrollMode.Page:
            i = "scroll-mode__page-button";
            break;
        case $6eW0i.ScrollMode.Wrapped:
            i = "scroll-mode__wrapped-button";
            break;
        case $6eW0i.ScrollMode.Vertical:
        default:
            i = "scroll-mode__vertical-button";
    }
    return $8cdcc50928e40d71$var$t.createElement($8cdcc50928e40d71$var$u, {
        mode: n,
        onClick: r
    }, function(o) {
        return $8cdcc50928e40d71$var$t.createElement($6eW0i.Tooltip, {
            ariaControlsSuffix: "scroll-mode-switch",
            position: $6eW0i.Position.BottomCenter,
            target: $8cdcc50928e40d71$var$t.createElement($6eW0i.MinimalButton, {
                ariaLabel: o.label,
                isDisabled: l,
                isSelected: c,
                testId: i,
                onClick: o.onClick
            }, o.icon),
            content: function() {
                return o.label;
            },
            offset: $8cdcc50928e40d71$var$m
        });
    });
}, $8cdcc50928e40d71$var$f = function(o) {
    var l = $8cdcc50928e40d71$var$t.useState(o.get("scrollMode") || $6eW0i.ScrollMode.Vertical), c = l[0], n = l[1], r = function(e) {
        n(e);
    };
    return $8cdcc50928e40d71$var$t.useEffect(function() {
        return o.subscribe("scrollMode", r), function() {
            o.unsubscribe("scrollMode", r);
        };
    }, []), {
        scrollMode: c
    };
}, $8cdcc50928e40d71$var$w = function(o) {
    var l = $8cdcc50928e40d71$var$t.useState(o.get("viewMode") || $6eW0i.ViewMode.SinglePage), c = l[0], n = l[1], r = function(e) {
        n(e);
    };
    return $8cdcc50928e40d71$var$t.useEffect(function() {
        return o.subscribe("viewMode", r), function() {
            o.unsubscribe("viewMode", r);
        };
    }, []), {
        viewMode: c
    };
}, $8cdcc50928e40d71$var$S = function(o) {
    var l = o.children, c = o.mode, n = o.store, r = $8cdcc50928e40d71$var$w(n).viewMode, i = $8cdcc50928e40d71$var$f(n).scrollMode === c, d = (c === $6eW0i.ScrollMode.Horizontal || c === $6eW0i.ScrollMode.Wrapped) && r !== $6eW0i.ViewMode.SinglePage;
    return (l || function(e) {
        return $8cdcc50928e40d71$var$t.createElement($8cdcc50928e40d71$var$M, {
            isDisabled: d,
            isSelected: i,
            mode: e.mode,
            onClick: e.onClick
        });
    })({
        isDisabled: d,
        isSelected: i,
        mode: c,
        onClick: function() {
            $8cdcc50928e40d71$var$a(n, c);
        }
    });
}, $8cdcc50928e40d71$var$g = function(o) {
    var l = o.isDisabled, c = o.isSelected, n = o.mode, r = o.onClick, i = "";
    switch(n){
        case $6eW0i.ScrollMode.Horizontal:
            i = "scroll-mode__horizontal-menu";
            break;
        case $6eW0i.ScrollMode.Page:
            i = "scroll-mode__page-menu";
            break;
        case $6eW0i.ScrollMode.Wrapped:
            i = "scroll-mode__wrapped-menu";
            break;
        case $6eW0i.ScrollMode.Vertical:
        default:
            i = "scroll-mode__vertical-menu";
    }
    return $8cdcc50928e40d71$var$t.createElement($8cdcc50928e40d71$var$u, {
        mode: n,
        onClick: r
    }, function(o) {
        return $8cdcc50928e40d71$var$t.createElement($6eW0i.MenuItem, {
            checked: c,
            icon: o.icon,
            isDisabled: l,
            testId: i,
            onClick: o.onClick
        }, o.label);
    });
}, $8cdcc50928e40d71$var$h = function(o, t) {
    o.get("switchViewMode")(t);
    var l = o.get("scrollMode");
    l !== $6eW0i.ScrollMode.Horizontal && l !== $6eW0i.ScrollMode.Wrapped || t === $6eW0i.ViewMode.SinglePage || o.get("switchScrollMode")($6eW0i.ScrollMode.Vertical);
}, $8cdcc50928e40d71$var$b = function(o) {
    var n = o.children, i = o.mode, a = o.onClick, d = $8cdcc50928e40d71$var$t.useContext($6eW0i.LocalizationContext).l10n, s = "", u = $8cdcc50928e40d71$var$t.createElement($8cdcc50928e40d71$var$r, null);
    switch(i){
        case $6eW0i.ViewMode.DualPage:
            s = d && d.scrollMode ? d.scrollMode.dualPage : "Dual page", u = $8cdcc50928e40d71$var$t.createElement($8cdcc50928e40d71$var$c, null);
            break;
        case $6eW0i.ViewMode.DualPageWithCover:
            s = d && d.scrollMode ? d.scrollMode.dualPageCover : "Dual page with cover", u = $8cdcc50928e40d71$var$t.createElement($8cdcc50928e40d71$var$l, null);
            break;
        case $6eW0i.ViewMode.SinglePage:
        default:
            s = d && d.scrollMode ? d.scrollMode.singlePage : "Single page", u = $8cdcc50928e40d71$var$t.createElement($8cdcc50928e40d71$var$r, null);
    }
    return n({
        icon: u,
        label: s,
        onClick: a
    });
}, $8cdcc50928e40d71$var$p = {
    left: 0,
    top: 8
}, $8cdcc50928e40d71$var$v = function(o) {
    var l = o.isDisabled, c = o.isSelected, n = o.mode, r = o.onClick, i = "";
    switch(n){
        case $6eW0i.ViewMode.DualPage:
            i = "view-mode__dual-button";
            break;
        case $6eW0i.ViewMode.DualPageWithCover:
            i = "view-mode__dual-cover-button";
            break;
        case $6eW0i.ViewMode.SinglePage:
        default:
            i = "view-mode__single-button";
    }
    return $8cdcc50928e40d71$var$t.createElement($8cdcc50928e40d71$var$b, {
        mode: n,
        onClick: r
    }, function(o) {
        return $8cdcc50928e40d71$var$t.createElement($6eW0i.Tooltip, {
            ariaControlsSuffix: "view-mode-switch",
            position: $6eW0i.Position.BottomCenter,
            target: $8cdcc50928e40d71$var$t.createElement($6eW0i.MinimalButton, {
                ariaLabel: o.label,
                isDisabled: l,
                isSelected: c,
                testId: i,
                onClick: o.onClick
            }, o.icon),
            content: function() {
                return o.label;
            },
            offset: $8cdcc50928e40d71$var$p
        });
    });
}, $8cdcc50928e40d71$var$k = function(o) {
    var l = o.children, c = o.mode, n = o.store, r = $8cdcc50928e40d71$var$w(n).viewMode, i = $8cdcc50928e40d71$var$f(n).scrollMode, a = r === c, d = (i === $6eW0i.ScrollMode.Horizontal || i === $6eW0i.ScrollMode.Wrapped) && c !== $6eW0i.ViewMode.SinglePage;
    return (l || function(e) {
        return $8cdcc50928e40d71$var$t.createElement($8cdcc50928e40d71$var$v, {
            isDisabled: d,
            isSelected: a,
            mode: e.mode,
            onClick: e.onClick
        });
    })({
        isDisabled: d,
        isSelected: a,
        mode: c,
        onClick: function() {
            $8cdcc50928e40d71$var$h(n, c);
        }
    });
}, $8cdcc50928e40d71$var$C = function(o) {
    var l = o.isDisabled, c = o.isSelected, n = o.mode, r = o.onClick, i = "";
    switch(n){
        case $6eW0i.ViewMode.DualPage:
            i = "view-mode__dual-menu";
            break;
        case $6eW0i.ViewMode.DualPageWithCover:
            i = "view-mode__dual-cover-menu";
            break;
        case $6eW0i.ViewMode.SinglePage:
        default:
            i = "view-mode__single-menu";
    }
    return $8cdcc50928e40d71$var$t.createElement($8cdcc50928e40d71$var$b, {
        mode: n,
        onClick: r
    }, function(o) {
        return $8cdcc50928e40d71$var$t.createElement($6eW0i.MenuItem, {
            checked: c,
            icon: o.icon,
            isDisabled: l,
            testId: i,
            onClick: o.onClick
        }, o.label);
    });
};
$8cdcc50928e40d71$export$869c80bdcb9b3162 = $8cdcc50928e40d71$var$l, $8cdcc50928e40d71$export$8aef0f51c674f4e7 = $8cdcc50928e40d71$var$c, $8cdcc50928e40d71$export$dceed8f027679c95 = $8cdcc50928e40d71$var$n, $8cdcc50928e40d71$export$d708fd9366e42819 = $8cdcc50928e40d71$var$r, $8cdcc50928e40d71$export$3eb489432cc3ae40 = $8cdcc50928e40d71$var$d, $8cdcc50928e40d71$export$3367e6bf6a5c1af = $8cdcc50928e40d71$var$s, $8cdcc50928e40d71$export$139b33d69bfdb3f4 = function() {
    var o = $8cdcc50928e40d71$var$t.useMemo(function() {
        return $6eW0i.createStore({
            scrollMode: $6eW0i.ScrollMode.Vertical,
            viewMode: $6eW0i.ViewMode.SinglePage,
            switchScrollMode: function() {},
            switchViewMode: function() {}
        });
    }, []), l = function(e) {
        return $8cdcc50928e40d71$var$t.createElement($8cdcc50928e40d71$var$S, $8cdcc50928e40d71$var$i({}, e, {
            store: o
        }));
    }, c = function(e) {
        return $8cdcc50928e40d71$var$t.createElement($8cdcc50928e40d71$var$k, $8cdcc50928e40d71$var$i({}, e, {
            store: o
        }));
    };
    return {
        install: function(e) {
            o.update("switchScrollMode", e.switchScrollMode), o.update("switchViewMode", e.switchViewMode);
        },
        onViewerStateChange: function(e) {
            return o.update("scrollMode", e.scrollMode), o.update("viewMode", e.viewMode), e;
        },
        switchScrollMode: function(e) {
            $8cdcc50928e40d71$var$a(o, e);
        },
        switchViewMode: function(e) {
            $8cdcc50928e40d71$var$h(o, e);
        },
        SwitchScrollMode: l,
        SwitchScrollModeButton: function(e) {
            return $8cdcc50928e40d71$var$t.createElement(l, {
                mode: e.mode
            }, function(e) {
                return $8cdcc50928e40d71$var$t.createElement($8cdcc50928e40d71$var$M, {
                    isDisabled: e.isDisabled,
                    isSelected: e.isSelected,
                    mode: e.mode,
                    onClick: function() {
                        e.onClick();
                    }
                });
            });
        },
        SwitchScrollModeMenuItem: function(e) {
            return $8cdcc50928e40d71$var$t.createElement(l, {
                mode: e.mode
            }, function(o) {
                return $8cdcc50928e40d71$var$t.createElement($8cdcc50928e40d71$var$g, {
                    isDisabled: o.isDisabled,
                    isSelected: o.isSelected,
                    mode: o.mode,
                    onClick: function() {
                        o.onClick(), e.onClick();
                    }
                });
            });
        },
        SwitchViewMode: c,
        SwitchViewModeButton: function(e) {
            return $8cdcc50928e40d71$var$t.createElement(c, {
                mode: e.mode
            }, function(e) {
                return $8cdcc50928e40d71$var$t.createElement($8cdcc50928e40d71$var$v, {
                    isDisabled: e.isDisabled,
                    isSelected: e.isSelected,
                    mode: e.mode,
                    onClick: function() {
                        e.onClick();
                    }
                });
            });
        },
        SwitchViewModeMenuItem: function(e) {
            return $8cdcc50928e40d71$var$t.createElement(c, {
                mode: e.mode
            }, function(o) {
                return $8cdcc50928e40d71$var$t.createElement($8cdcc50928e40d71$var$C, {
                    isDisabled: o.isDisabled,
                    isSelected: o.isSelected,
                    mode: o.mode,
                    onClick: function() {
                        o.onClick(), e.onClick();
                    }
                });
            });
        }
    };
};

});


parcelRegister("2B2g9", function(module, exports) {
/**
 * A React component to view a PDF document
 *
 * @see https://react-pdf-viewer.dev
 * @license https://react-pdf-viewer.dev/license
 * @copyright 2019-2023 Nguyen Huu Phuoc <me@phuoc.ng>
 */ "use strict";

module.exports = (parcelRequire("hV2Ut"));

});
parcelRegister("hV2Ut", function(module, exports) {

$parcel$export(module.exports, "NextIcon", () => $d0ba04666a27e8ba$export$3da0e0ec94bd4ce1, (v) => $d0ba04666a27e8ba$export$3da0e0ec94bd4ce1 = v);
$parcel$export(module.exports, "PreviousIcon", () => $d0ba04666a27e8ba$export$d05925e1c7f3f136, (v) => $d0ba04666a27e8ba$export$d05925e1c7f3f136 = v);
$parcel$export(module.exports, "SearchIcon", () => $d0ba04666a27e8ba$export$82eafebb825fc23f, (v) => $d0ba04666a27e8ba$export$82eafebb825fc23f = v);
$parcel$export(module.exports, "searchPlugin", () => $d0ba04666a27e8ba$export$4d3c2ba10ce0baf1, (v) => $d0ba04666a27e8ba$export$4d3c2ba10ce0baf1 = v);
var $d0ba04666a27e8ba$export$3da0e0ec94bd4ce1;
var $d0ba04666a27e8ba$export$d05925e1c7f3f136;
var $d0ba04666a27e8ba$export$82eafebb825fc23f;
var $d0ba04666a27e8ba$export$4d3c2ba10ce0baf1;
"use strict";

var $6eW0i = parcelRequire("6eW0i");
function $d0ba04666a27e8ba$var$t(e) {
    var t = Object.create(null);
    return e && Object.keys(e).forEach(function(r) {
        if ("default" !== r) {
            var n = Object.getOwnPropertyDescriptor(e, r);
            Object.defineProperty(t, r, n.get ? n : {
                enumerable: !0,
                get: function() {
                    return e[r];
                }
            });
        }
    }), t.default = e, Object.freeze(t);
}

var $d0ba04666a27e8ba$var$r = $d0ba04666a27e8ba$var$t((parcelRequire("kc00y"))), $d0ba04666a27e8ba$var$n = function() {
    return $d0ba04666a27e8ba$var$r.createElement($6eW0i.Icon, {
        size: 16
    }, $d0ba04666a27e8ba$var$r.createElement("path", {
        d: "M0.541,5.627L11.666,18.2c0.183,0.207,0.499,0.226,0.706,0.043c0.015-0.014,0.03-0.028,0.043-0.043\n            L23.541,5.627"
    }));
}, $d0ba04666a27e8ba$var$o = function() {
    return $d0ba04666a27e8ba$var$r.createElement($6eW0i.Icon, {
        size: 16
    }, $d0ba04666a27e8ba$var$r.createElement("path", {
        d: "M23.535,18.373L12.409,5.8c-0.183-0.207-0.499-0.226-0.706-0.043C11.688,5.77,11.674,5.785,11.66,5.8\n            L0.535,18.373"
    }));
}, $d0ba04666a27e8ba$var$a = function() {
    return $d0ba04666a27e8ba$var$r.createElement($6eW0i.Icon, {
        ignoreDirection: !0,
        size: 16
    }, $d0ba04666a27e8ba$var$r.createElement("path", {
        d: "M10.5,0.5c5.523,0,10,4.477,10,10s-4.477,10-10,10s-10-4.477-10-10S4.977,0.5,10.5,0.5z\n            M23.5,23.5\n            l-5.929-5.929"
    }));
}, $d0ba04666a27e8ba$var$c = function() {
    return $d0ba04666a27e8ba$var$c = Object.assign || function(e) {
        for(var t, r = 1, n = arguments.length; r < n; r++)for(var o in t = arguments[r])Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
    }, $d0ba04666a27e8ba$var$c.apply(this, arguments);
}, $d0ba04666a27e8ba$var$u = {
    keyword: "",
    regExp: new RegExp(" "),
    wholeWords: !1
}, $d0ba04666a27e8ba$var$i = function(e) {
    return {
        left: "".concat(e.left, "%"),
        top: "".concat(e.top, "%"),
        height: "".concat(e.height, "%"),
        width: "".concat(e.width, "%")
    };
}, $d0ba04666a27e8ba$var$s = function(t) {
    var n = t.index, o = t.area, a = t.onHighlightKeyword, c = $d0ba04666a27e8ba$var$r.useRef();
    return $6eW0i.useIsomorphicLayoutEffect(function() {
        var e = c.current;
        a && e && a({
            highlightEle: e,
            keyword: o.keyword
        });
    }, []), $d0ba04666a27e8ba$var$r.createElement("div", {
        className: "rpv-search__highlight",
        "data-index": n,
        ref: c,
        style: $d0ba04666a27e8ba$var$i(o),
        title: o.keywordStr.trim()
    });
}, $d0ba04666a27e8ba$var$l = function(e) {
    var t = e.parentNode;
    t && t.removeChild(e);
}, $d0ba04666a27e8ba$var$h = function(e) {
    var t = e.parentNode;
    if (t) {
        var r = document.createRange();
        r.selectNodeContents(e), function(e, t) {
            $d0ba04666a27e8ba$var$l(e);
            var r = t.parentNode;
            r && r.insertBefore(e, t), $d0ba04666a27e8ba$var$l(t);
        }(r.extractContents(), e), t.normalize();
    }
}, $d0ba04666a27e8ba$var$d = function(e, t) {
    return e.top < t.top ? -1 : e.top > t.top ? 1 : e.left < t.left ? -1 : e.left > t.left ? 1 : 0;
}, $d0ba04666a27e8ba$var$f = function(t) {
    var n = t.numPages, o = t.pageIndex, a = t.renderHighlights, c = t.store, l = t.onHighlightKeyword, f = $d0ba04666a27e8ba$var$r.useRef(), p = $d0ba04666a27e8ba$var$r.useCallback(function(e) {
        return $d0ba04666a27e8ba$var$r.createElement($d0ba04666a27e8ba$var$r.Fragment, null, e.highlightAreas.map(function(e, t) {
            return $d0ba04666a27e8ba$var$r.createElement($d0ba04666a27e8ba$var$s, {
                index: t,
                key: t,
                area: e,
                onHighlightKeyword: l
            });
        }));
    }, []), g = a || p, m = $d0ba04666a27e8ba$var$r.useState(c.get("matchPosition")), v = m[0], x = m[1], y = $d0ba04666a27e8ba$var$r.useState(c.get("keyword") || [
        $d0ba04666a27e8ba$var$u
    ]), E = y[0], w = y[1], b = $d0ba04666a27e8ba$var$r.useState({
        pageIndex: o,
        scale: 1,
        status: $6eW0i.LayerRenderStatus.PreRender
    }), k = b[0], S = b[1], C = $d0ba04666a27e8ba$var$r.useRef(null), P = $d0ba04666a27e8ba$var$r.useRef([]), _ = $d0ba04666a27e8ba$var$r.useState([]), I = _[0], T = _[1], M = function() {
        return !0;
    }, R = $d0ba04666a27e8ba$var$r.useCallback(function() {
        return c.get("targetPageFilter") || M;
    }, [
        c.get("targetPageFilter")
    ]), L = function(e) {
        var t = P.current;
        if (0 === t.length) return [];
        var r = [], a = [].slice.call(e.querySelectorAll(".rpv-core__text-layer-text")), c = t.map(function(e) {
            return e.char;
        }).join("");
        return E.forEach(function(u) {
            var i = u.keyword;
            if (i.trim()) {
                for(var s, l = -1 === u.regExp.flags.indexOf("g") ? new RegExp(u.regExp, "".concat(u.regExp.flags, "g")) : u.regExp, d = []; null !== (s = l.exec(c));)d.push({
                    keyword: l,
                    startIndex: s.index,
                    endIndex: l.lastIndex
                });
                d.map(function(e) {
                    return {
                        keyword: e.keyword,
                        indexes: t.slice(e.startIndex, e.endIndex)
                    };
                }).forEach(function(t) {
                    var c = t.indexes.reduce(function(e, t) {
                        return e[t.spanIndex] = (e[t.spanIndex] || []).concat([
                            t
                        ]), e;
                    }, {});
                    Object.values(c).forEach(function(c) {
                        if (1 !== c.length || "" !== c[0].char.trim()) {
                            var s = u.wholeWords ? c.slice(1, -1) : c, l = function(e, t, r, a, c) {
                                var u = document.createRange(), i = a.firstChild;
                                if (!i || i.nodeType !== Node.TEXT_NODE) return null;
                                var s = i.textContent.length, l = c[0].charIndexInSpan, d = 1 === c.length ? l : c[c.length - 1].charIndexInSpan;
                                if (l > s || d + 1 > s) return null;
                                u.setStart(i, l), u.setEnd(i, d + 1);
                                var f = document.createElement("span");
                                u.surroundContents(f);
                                var p = f.getBoundingClientRect(), g = r.getBoundingClientRect(), m = g.height, v = g.width, x = 100 * (p.left - g.left) / v, y = 100 * (p.top - g.top) / m, E = 100 * p.height / m, w = 100 * p.width / v;
                                return $d0ba04666a27e8ba$var$h(f), {
                                    keyword: t,
                                    keywordStr: e,
                                    numPages: n,
                                    pageIndex: o,
                                    left: x,
                                    top: y,
                                    height: E,
                                    width: w,
                                    pageHeight: m,
                                    pageWidth: v
                                };
                            }(i, t.keyword, e, a[s[0].spanIndex], s);
                            l && r.push(l);
                        }
                    });
                });
            }
        }), r.sort($d0ba04666a27e8ba$var$d);
    }, j = function(e) {
        e && e.length > 0 && w(e);
    }, N = function(e) {
        return x(e);
    }, K = function(e) {
        if (e.has(o)) {
            var t = e.get(o);
            t && S({
                ele: t.ele,
                pageIndex: o,
                scale: t.scale,
                status: t.status
            });
        }
    }, O = function() {
        return 0 === E.length || 1 === E.length && "" === E[0].keyword.trim();
    };
    return $d0ba04666a27e8ba$var$r.useEffect(function() {
        if (!O() && k.status === $6eW0i.LayerRenderStatus.DidRender && !P.current.length) {
            var t = k.ele, r = [].slice.call(t.querySelectorAll(".rpv-core__text-layer-text")).map(function(e) {
                return e.textContent;
            }).reduce(function(e, t, r) {
                return e.concat(t.split("").map(function(e, t) {
                    return {
                        char: e,
                        charIndexInSpan: t,
                        spanIndex: r
                    };
                }));
            }, [
                {
                    char: "",
                    charIndexInSpan: 0,
                    spanIndex: 0
                }
            ]).slice(1);
            P.current = r;
        }
    }, [
        E,
        k.status
    ]), $d0ba04666a27e8ba$var$r.useEffect(function() {
        if (!O() && k.ele && k.status === $6eW0i.LayerRenderStatus.DidRender && R()({
            pageIndex: o,
            numPages: n
        })) {
            var t = k.ele, r = L(t);
            T(r);
        }
    }, [
        E,
        v,
        k.status,
        P.current
    ]), $d0ba04666a27e8ba$var$r.useEffect(function() {
        O() && k.ele && k.status === $6eW0i.LayerRenderStatus.DidRender && T([]);
    }, [
        E,
        k.status
    ]), $d0ba04666a27e8ba$var$r.useEffect(function() {
        if (0 !== I.length) {
            var t = f.current;
            if (v.pageIndex === o && t && k.status === $6eW0i.LayerRenderStatus.DidRender) {
                var r = t.querySelector('.rpv-search__highlight[data-index="'.concat(v.matchIndex, '"]'));
                if (r) {
                    var n = function(e, t) {
                        for(var r = e.offsetTop, n = e.offsetLeft, o = e.parentElement; o && o !== t;)r += o.offsetTop, n += o.offsetLeft, o = o.parentElement;
                        return {
                            left: n,
                            top: r
                        };
                    }(r, t), a = n.left, u = n.top, i = c.get("jumpToDestination");
                    i && (i({
                        pageIndex: o,
                        bottomOffset: (t.getBoundingClientRect().height - u) / k.scale,
                        leftOffset: a / k.scale,
                        scaleTo: k.scale
                    }), C.current && C.current.classList.remove("rpv-search__highlight--current"), C.current = r, r.classList.add("rpv-search__highlight--current"));
                }
            }
        }
    }, [
        I,
        v
    ]), $d0ba04666a27e8ba$var$r.useEffect(function() {
        return c.subscribe("keyword", j), c.subscribe("matchPosition", N), c.subscribe("renderStatus", K), function() {
            c.unsubscribe("keyword", j), c.unsubscribe("matchPosition", N), c.unsubscribe("renderStatus", K);
        };
    }, []), $d0ba04666a27e8ba$var$r.createElement("div", {
        className: "rpv-search__highlights",
        "data-testid": "search__highlights-".concat(o),
        ref: f
    }, g({
        getCssProperties: $d0ba04666a27e8ba$var$i,
        highlightAreas: I
    }));
}, $d0ba04666a27e8ba$var$p = function(e) {
    var t, r = e.wholeWords ? " ".concat(e.keyword, " ") : e.keyword, n = e.matchCase ? "g" : "gi";
    return {
        keyword: e.keyword,
        regExp: new RegExp((t = r, t.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")), n),
        wholeWords: e.wholeWords || !1
    };
}, $d0ba04666a27e8ba$var$g = function(e, t, r) {
    return e instanceof RegExp ? {
        keyword: e.source,
        regExp: e,
        wholeWords: r || !1
    } : "string" == typeof e ? "" === e ? $d0ba04666a27e8ba$var$u : $d0ba04666a27e8ba$var$p({
        keyword: e,
        matchCase: t || !1,
        wholeWords: r || !1
    }) : (void 0 !== t && (e.matchCase = t), void 0 !== r && (e.wholeWords = r), $d0ba04666a27e8ba$var$p(e));
}, $d0ba04666a27e8ba$var$m = function(t) {
    var n, o = t.get("initialKeyword"), a = $d0ba04666a27e8ba$var$r.useMemo(function() {
        if (o && 1 === o.length) {
            var e = $d0ba04666a27e8ba$var$g(o[0]);
            return {
                matchCase: -1 === e.regExp.flags.indexOf("i"),
                wholeWords: e.wholeWords
            };
        }
        return {
            matchCase: !1,
            wholeWords: !1
        };
    }, []), c = function(e) {
        var t = $d0ba04666a27e8ba$var$r.useRef(e.get("doc")), n = function(e) {
            t.current = e;
        };
        return $d0ba04666a27e8ba$var$r.useEffect(function() {
            return e.subscribe("doc", n), function() {
                e.unsubscribe("doc", n);
            };
        }, []), t;
    }(t), i = $d0ba04666a27e8ba$var$r.useState(o), s = i[0], l = i[1], h = $d0ba04666a27e8ba$var$r.useState([]), d = h[0], f = h[1], p = $d0ba04666a27e8ba$var$r.useState(0), m = p[0], v = p[1], x = $d0ba04666a27e8ba$var$r.useState(a.matchCase), y = x[0], E = x[1], w = $d0ba04666a27e8ba$var$r.useRef([]), b = $d0ba04666a27e8ba$var$r.useState(a.wholeWords), k = b[0], S = b[1], C = function() {
        return !0;
    }, P = $d0ba04666a27e8ba$var$r.useCallback(function() {
        return t.get("targetPageFilter") || C;
    }, [
        t.get("targetPageFilter")
    ]), _ = function(e) {
        var t = d.length;
        if (0 === s.length || 0 === t) return null;
        var r = e === t + 1 ? 1 : Math.max(1, Math.min(t, e));
        return v(r), T(d[r - 1]);
    }, I = function(e) {
        return l("" === e ? [] : [
            e
        ]);
    }, T = function(e) {
        var r = t.get("jumpToPage");
        return r && r(e.pageIndex), t.update("matchPosition", {
            matchIndex: e.matchIndex,
            pageIndex: e.pageIndex
        }), e;
    }, M = function(r, n, o) {
        var a = c.current;
        if (!a) return Promise.resolve([]);
        var u = a.numPages, i = r.map(function(e) {
            return $d0ba04666a27e8ba$var$g(e, n, o);
        });
        return t.update("keyword", i), v(0), f([]), new Promise(function(t, r) {
            var n = 0 === w.current.length ? (function() {
                var t = c.current;
                if (!t) return Promise.resolve([]);
                var r = Array(t.numPages).fill(0).map(function(r, n) {
                    return $6eW0i.getPage(t, n).then(function(e) {
                        return e.getTextContent();
                    }).then(function(e) {
                        var t = e.items.map(function(e) {
                            return e.str || "";
                        }).join("");
                        return Promise.resolve({
                            pageContent: t,
                            pageIndex: n
                        });
                    });
                });
                return Promise.all(r).then(function(e) {
                    return e.sort(function(e, t) {
                        return e.pageIndex - t.pageIndex;
                    }), Promise.resolve(e.map(function(e) {
                        return e.pageContent;
                    }));
                });
            })().then(function(e) {
                return w.current = e, Promise.resolve(e);
            }) : Promise.resolve(w.current);
            n.then(function(e) {
                var r = [];
                e.forEach(function(e, t) {
                    P()({
                        pageIndex: t,
                        numPages: u
                    }) && i.forEach(function(n) {
                        for(var o, a = 0; null !== (o = n.regExp.exec(e));)r.push({
                            keyword: n.regExp,
                            matchIndex: a,
                            pageIndex: t,
                            pageText: e,
                            startIndex: o.index,
                            endIndex: n.regExp.lastIndex
                        }), a++;
                    });
                }), f(r), r.length > 0 && (v(1), T(r[0])), t(r);
            });
        });
    };
    return $d0ba04666a27e8ba$var$r.useEffect(function() {
        w.current = [];
    }, [
        c.current
    ]), {
        clearKeyword: function() {
            t.update("keyword", [
                $d0ba04666a27e8ba$var$u
            ]), I(""), v(0), f([]), E(!1), S(!1);
        },
        changeMatchCase: function(e) {
            E(e), s.length > 0 && M(s, e, k);
        },
        changeWholeWords: function(e) {
            S(e), s.length > 0 && M(s, y, e);
        },
        currentMatch: m,
        jumpToMatch: _,
        jumpToNextMatch: function() {
            return _(m + 1);
        },
        jumpToPreviousMatch: function() {
            return _(m - 1);
        },
        keywords: s,
        matchCase: y,
        numberOfMatches: d.length,
        wholeWords: k,
        search: function() {
            return M(s, y, k);
        },
        searchFor: M,
        setKeywords: l,
        keyword: 0 === s.length ? "" : (n = s[0], n instanceof RegExp ? n.source : "string" == typeof n ? n : n.keyword),
        setKeyword: I,
        setTargetPages: function(e) {
            t.update("targetPageFilter", e);
        }
    };
}, $d0ba04666a27e8ba$var$v = function(e) {
    var t = e.children, n = e.store, o = $d0ba04666a27e8ba$var$m(n), a = $d0ba04666a27e8ba$var$r.useState(!1), u = a[0], i = a[1], s = function(e) {
        return i(!0);
    };
    return $d0ba04666a27e8ba$var$r.useEffect(function() {
        return n.subscribe("doc", s), function() {
            n.unsubscribe("doc", s);
        };
    }, []), t($d0ba04666a27e8ba$var$c($d0ba04666a27e8ba$var$c({}, o), {
        isDocumentLoaded: u
    }));
}, $d0ba04666a27e8ba$var$x = function(t) {
    var n = t.containerRef, o = t.store, a = $d0ba04666a27e8ba$var$r.useRef(!1), c = function() {
        a.current = !0;
    }, u = function() {
        a.current = !1;
    }, i = function(t) {
        var r = n.current;
        r && (t.shiftKey || t.altKey || "f" !== t.key || ($6eW0i.isMac() ? t.metaKey && !t.ctrlKey : t.ctrlKey) && (a.current || document.activeElement && r.contains(document.activeElement)) && (t.preventDefault(), o.update("areShortcutsPressed", !0)));
    };
    return $d0ba04666a27e8ba$var$r.useEffect(function() {
        var e = n.current;
        if (e) return document.addEventListener("keydown", i), e.addEventListener("mouseenter", c), e.addEventListener("mouseleave", u), function() {
            document.removeEventListener("keydown", i), e.removeEventListener("mouseenter", c), e.removeEventListener("mouseleave", u);
        };
    }, [
        n.current
    ]), $d0ba04666a27e8ba$var$r.createElement($d0ba04666a27e8ba$var$r.Fragment, null);
}, $d0ba04666a27e8ba$var$y = {
    left: 0,
    top: 8
}, $d0ba04666a27e8ba$var$E = function(t) {
    var a = t.store, c = t.onToggle, u = $d0ba04666a27e8ba$var$r.useContext($6eW0i.LocalizationContext).l10n, i = $d0ba04666a27e8ba$var$r.useContext($6eW0i.ThemeContext).direction, s = $d0ba04666a27e8ba$var$r.useState(!1), l = s[0], h = s[1], d = $d0ba04666a27e8ba$var$r.useState(!1), f = d[0], p = d[1], g = i === $6eW0i.TextDirection.RightToLeft, v = $d0ba04666a27e8ba$var$m(a), x = v.clearKeyword, E = v.changeMatchCase, w = v.changeWholeWords, b = v.currentMatch, k = v.jumpToNextMatch, S = v.jumpToPreviousMatch, C = v.keyword, P = v.matchCase, _ = v.numberOfMatches, I = v.wholeWords, T = v.search, M = v.setKeyword, R = function(e) {
        h(!0), T().then(function(t) {
            h(!1), p(!0), e && e();
        });
    };
    $d0ba04666a27e8ba$var$r.useEffect(function() {
        var e = a.get("initialKeyword");
        e && 1 === e.length && C && R(function() {
            a.update("initialKeyword", []);
        });
    }, []);
    var L = u && u.search ? u.search.enterToSearch : "Enter to search", j = u && u.search ? u.search.previousMatch : "Previous match", N = u && u.search ? u.search.nextMatch : "Next match", K = u && u.search ? u.search.close : "Close";
    return $d0ba04666a27e8ba$var$r.createElement("div", {
        className: "rpv-search__popover"
    }, $d0ba04666a27e8ba$var$r.createElement("div", {
        className: "rpv-search__popover-input-counter"
    }, $d0ba04666a27e8ba$var$r.createElement($6eW0i.TextBox, {
        ariaLabel: L,
        autoFocus: !0,
        placeholder: L,
        type: "text",
        value: C,
        onChange: function(e) {
            p(!1), M(e);
        },
        onKeyDown: function(e) {
            "Enter" === e.key && C && (f ? k() : R());
        }
    }), $d0ba04666a27e8ba$var$r.createElement("div", {
        className: $6eW0i.classNames({
            "rpv-search__popover-counter": !0,
            "rpv-search__popover-counter--ltr": !g,
            "rpv-search__popover-counter--rtl": g
        })
    }, l && $d0ba04666a27e8ba$var$r.createElement($6eW0i.Spinner, {
        testId: "search__popover-searching",
        size: "1rem"
    }), !l && $d0ba04666a27e8ba$var$r.createElement("span", {
        "data-testid": "search__popover-num-matches"
    }, b, "/", _))), $d0ba04666a27e8ba$var$r.createElement("label", {
        className: "rpv-search__popover-label"
    }, $d0ba04666a27e8ba$var$r.createElement("input", {
        className: "rpv-search__popover-label-checkbox",
        "data-testid": "search__popover-match-case",
        checked: P,
        type: "checkbox",
        onChange: function(e) {
            p(!1), E(e.target.checked);
        }
    }), " ", u && u.search ? u.search.matchCase : "Match case"), $d0ba04666a27e8ba$var$r.createElement("label", {
        className: "rpv-search__popover-label"
    }, $d0ba04666a27e8ba$var$r.createElement("input", {
        className: "rpv-search__popover-label-checkbox",
        checked: I,
        "data-testid": "search__popover-whole-words",
        type: "checkbox",
        onChange: function(e) {
            p(!1), w(e.target.checked);
        }
    }), " ", u && u.search ? u.search.wholeWords : "Whole words"), $d0ba04666a27e8ba$var$r.createElement("div", {
        className: "rpv-search__popover-footer"
    }, $d0ba04666a27e8ba$var$r.createElement("div", {
        className: "rpv-search__popover-footer-item"
    }, $d0ba04666a27e8ba$var$r.createElement($6eW0i.Tooltip, {
        ariaControlsSuffix: "search-previous-match",
        position: g ? $6eW0i.Position.BottomRight : $6eW0i.Position.BottomCenter,
        target: $d0ba04666a27e8ba$var$r.createElement($6eW0i.MinimalButton, {
            ariaLabel: j,
            isDisabled: b <= 1,
            onClick: S
        }, $d0ba04666a27e8ba$var$r.createElement($d0ba04666a27e8ba$var$o, null)),
        content: function() {
            return j;
        },
        offset: $d0ba04666a27e8ba$var$y
    })), $d0ba04666a27e8ba$var$r.createElement("div", {
        className: "rpv-search__popover-footer-item"
    }, $d0ba04666a27e8ba$var$r.createElement($6eW0i.Tooltip, {
        ariaControlsSuffix: "search-next-match",
        position: $6eW0i.Position.BottomCenter,
        target: $d0ba04666a27e8ba$var$r.createElement($6eW0i.MinimalButton, {
            ariaLabel: N,
            isDisabled: b > _ - 1,
            onClick: k
        }, $d0ba04666a27e8ba$var$r.createElement($d0ba04666a27e8ba$var$n, null)),
        content: function() {
            return N;
        },
        offset: $d0ba04666a27e8ba$var$y
    })), $d0ba04666a27e8ba$var$r.createElement("div", {
        className: $6eW0i.classNames({
            "rpv-search__popover-footer-button": !0,
            "rpv-search__popover-footer-button--ltr": !g,
            "rpv-search__popover-footer-button--rtl": g
        })
    }, $d0ba04666a27e8ba$var$r.createElement($6eW0i.Button, {
        onClick: function() {
            c(), x();
        }
    }, K))));
}, $d0ba04666a27e8ba$var$w = function(t) {
    var n = t.children, o = t.onClick, c = $d0ba04666a27e8ba$var$r.useContext($6eW0i.LocalizationContext).l10n, u = c && c.search ? c.search.search : "Search";
    return n({
        icon: $d0ba04666a27e8ba$var$r.createElement($d0ba04666a27e8ba$var$a, null),
        label: u,
        onClick: o
    });
}, $d0ba04666a27e8ba$var$b = {
    left: 0,
    top: 8
}, $d0ba04666a27e8ba$var$k = function(t) {
    var n = t.enableShortcuts, o = t.store, a = t.onClick, c = n ? $6eW0i.isMac() ? "Meta+F" : "Ctrl+F" : "", u = function(e) {
        e && a();
    };
    return $d0ba04666a27e8ba$var$r.useEffect(function() {
        return o.subscribe("areShortcutsPressed", u), function() {
            o.unsubscribe("areShortcutsPressed", u);
        };
    }, []), $d0ba04666a27e8ba$var$r.createElement($d0ba04666a27e8ba$var$w, {
        onClick: a
    }, function(t) {
        return $d0ba04666a27e8ba$var$r.createElement($6eW0i.Tooltip, {
            ariaControlsSuffix: "search-popover",
            position: $6eW0i.Position.BottomCenter,
            target: $d0ba04666a27e8ba$var$r.createElement($6eW0i.MinimalButton, {
                ariaKeyShortcuts: c,
                ariaLabel: t.label,
                testId: "search__popover-button",
                onClick: a
            }, t.icon),
            content: function() {
                return t.label;
            },
            offset: $d0ba04666a27e8ba$var$b
        });
    });
}, $d0ba04666a27e8ba$var$S = {
    left: 0,
    top: 8
}, $d0ba04666a27e8ba$var$C = function(t) {
    var n = t.children, o = t.enableShortcuts, a = t.store, u = $d0ba04666a27e8ba$var$r.useContext($6eW0i.ThemeContext).direction === $6eW0i.TextDirection.RightToLeft ? $6eW0i.Position.BottomRight : $6eW0i.Position.BottomLeft, i = n || function(e) {
        return $d0ba04666a27e8ba$var$r.createElement($d0ba04666a27e8ba$var$k, $d0ba04666a27e8ba$var$c({
            enableShortcuts: o,
            store: a
        }, e));
    };
    return $d0ba04666a27e8ba$var$r.createElement($6eW0i.Popover, {
        ariaControlsSuffix: "search",
        lockScroll: !1,
        position: u,
        target: function(e) {
            return i({
                onClick: e
            });
        },
        content: function(e) {
            return $d0ba04666a27e8ba$var$r.createElement($d0ba04666a27e8ba$var$E, {
                store: a,
                onToggle: e
            });
        },
        offset: $d0ba04666a27e8ba$var$S,
        closeOnClickOutside: !1,
        closeOnEscape: !0
    });
}, $d0ba04666a27e8ba$var$P = function(e) {
    return Array.isArray(e) ? e.map(function(e) {
        return $d0ba04666a27e8ba$var$g(e);
    }) : [
        $d0ba04666a27e8ba$var$g(e)
    ];
};
$d0ba04666a27e8ba$export$3da0e0ec94bd4ce1 = $d0ba04666a27e8ba$var$n, $d0ba04666a27e8ba$export$d05925e1c7f3f136 = $d0ba04666a27e8ba$var$o, $d0ba04666a27e8ba$export$82eafebb825fc23f = $d0ba04666a27e8ba$var$a, $d0ba04666a27e8ba$export$4d3c2ba10ce0baf1 = function(t) {
    var n = $d0ba04666a27e8ba$var$r.useMemo(function() {
        return Object.assign({}, {
            enableShortcuts: !0,
            onHighlightKeyword: function() {}
        }, t);
    }, []), o = $d0ba04666a27e8ba$var$r.useMemo(function() {
        return $6eW0i.createStore({
            initialKeyword: t && t.keyword ? Array.isArray(t.keyword) ? t.keyword : [
                t.keyword
            ] : [],
            keyword: t && t.keyword ? $d0ba04666a27e8ba$var$P(t.keyword) : [
                $d0ba04666a27e8ba$var$u
            ],
            matchPosition: {
                matchIndex: -1,
                pageIndex: -1
            },
            renderStatus: new Map
        });
    }, []), a = $d0ba04666a27e8ba$var$m(o), i = a.clearKeyword, s = a.jumpToMatch, l = a.jumpToNextMatch, h = a.jumpToPreviousMatch, d = a.searchFor, p = a.setKeywords, g = a.setTargetPages, y = function(e) {
        return $d0ba04666a27e8ba$var$r.createElement($d0ba04666a27e8ba$var$C, $d0ba04666a27e8ba$var$c({
            enableShortcuts: n.enableShortcuts
        }, e, {
            store: o
        }));
    };
    return {
        install: function(e) {
            var r = t && t.keyword ? Array.isArray(t.keyword) ? t.keyword : [
                t.keyword
            ] : [], n = t && t.keyword ? $d0ba04666a27e8ba$var$P(t.keyword) : [
                $d0ba04666a27e8ba$var$u
            ];
            o.update("initialKeyword", r), o.update("jumpToDestination", e.jumpToDestination), o.update("jumpToPage", e.jumpToPage), o.update("keyword", n);
        },
        renderPageLayer: function(e) {
            return $d0ba04666a27e8ba$var$r.createElement($d0ba04666a27e8ba$var$f, {
                key: e.pageIndex,
                numPages: e.doc.numPages,
                pageIndex: e.pageIndex,
                renderHighlights: null == t ? void 0 : t.renderHighlights,
                store: o,
                onHighlightKeyword: n.onHighlightKeyword
            });
        },
        renderViewer: function(e) {
            var t = e.slot;
            return t.subSlot && (t.subSlot.children = $d0ba04666a27e8ba$var$r.createElement($d0ba04666a27e8ba$var$r.Fragment, null, n.enableShortcuts && $d0ba04666a27e8ba$var$r.createElement($d0ba04666a27e8ba$var$x, {
                containerRef: e.containerRef,
                store: o
            }), t.subSlot.children)), t;
        },
        uninstall: function(e) {
            var t = o.get("renderStatus");
            t && t.clear();
        },
        onDocumentLoad: function(e) {
            o.update("doc", e.doc);
        },
        onTextLayerRender: function(e) {
            var t = o.get("renderStatus");
            t && (t = t.set(e.pageIndex, e), o.update("renderStatus", t));
        },
        Search: function(e) {
            return $d0ba04666a27e8ba$var$r.createElement($d0ba04666a27e8ba$var$v, $d0ba04666a27e8ba$var$c({}, e, {
                store: o
            }));
        },
        ShowSearchPopover: y,
        ShowSearchPopoverButton: function() {
            return $d0ba04666a27e8ba$var$r.createElement(y, null, function(e) {
                return $d0ba04666a27e8ba$var$r.createElement($d0ba04666a27e8ba$var$k, $d0ba04666a27e8ba$var$c({
                    enableShortcuts: n.enableShortcuts,
                    store: o
                }, e));
            });
        },
        clearHighlights: function() {
            i();
        },
        highlight: function(e) {
            var t = Array.isArray(e) ? e : [
                e
            ];
            return p(t), d(t);
        },
        jumpToMatch: s,
        jumpToNextMatch: l,
        jumpToPreviousMatch: h,
        setTargetPages: g
    };
};

});


parcelRegister("5QSSA", function(module, exports) {
/**
 * A React component to view a PDF document
 *
 * @see https://react-pdf-viewer.dev
 * @license https://react-pdf-viewer.dev/license
 * @copyright 2019-2023 Nguyen Huu Phuoc <me@phuoc.ng>
 */ "use strict";

module.exports = (parcelRequire("hoT1H"));

});
parcelRegister("hoT1H", function(module, exports) {

$parcel$export(module.exports, "DarkIcon", () => $caaf5cab75568e97$export$263613686aa7dfc, (v) => $caaf5cab75568e97$export$263613686aa7dfc = v);
$parcel$export(module.exports, "LightIcon", () => $caaf5cab75568e97$export$82acdd66a4e4bf90, (v) => $caaf5cab75568e97$export$82acdd66a4e4bf90 = v);
$parcel$export(module.exports, "themePlugin", () => $caaf5cab75568e97$export$89d5f1367a34b7b2, (v) => $caaf5cab75568e97$export$89d5f1367a34b7b2 = v);
var $caaf5cab75568e97$export$263613686aa7dfc;
var $caaf5cab75568e97$export$82acdd66a4e4bf90;
var $caaf5cab75568e97$export$89d5f1367a34b7b2;
"use strict";

var $6eW0i = parcelRequire("6eW0i");
function $caaf5cab75568e97$var$t(e) {
    var t = Object.create(null);
    return e && Object.keys(e).forEach(function(n) {
        if ("default" !== n) {
            var r = Object.getOwnPropertyDescriptor(e, n);
            Object.defineProperty(t, n, r.get ? r : {
                enumerable: !0,
                get: function() {
                    return e[n];
                }
            });
        }
    }), t.default = e, Object.freeze(t);
}

var $caaf5cab75568e97$var$n = $caaf5cab75568e97$var$t((parcelRequire("kc00y"))), $caaf5cab75568e97$var$r = function() {
    return $caaf5cab75568e97$var$n.createElement($6eW0i.Icon, {
        size: 16
    }, $caaf5cab75568e97$var$n.createElement("path", {
        d: "M19.5,15.106l2.4-2.4a1,1,0,0,0,0-1.414l-2.4-2.4V5.5a1,1,0,0,0-1-1H15.106l-2.4-2.4a1,1,0,0,0-1.414,0l-2.4,2.4H5.5a1,1,0,0,0-1,1V8.894l-2.4,2.4a1,1,0,0,0,0,1.414l2.4,2.4V18.5a1,1,0,0,0,1,1H8.894l2.4,2.4a1,1,0,0,0,1.414,0l2.4-2.4H18.5a1,1,0,0,0,1-1Z"
    }), $caaf5cab75568e97$var$n.createElement("path", {
        d: "M10,6.349a6,6,0,0,1,0,11.3,6,6,0,1,0,0-11.3Z"
    }));
}, $caaf5cab75568e97$var$c = function() {
    return $caaf5cab75568e97$var$n.createElement($6eW0i.Icon, {
        size: 16
    }, $caaf5cab75568e97$var$n.createElement("path", {
        d: "M19.491,15.106l2.4-2.4a1,1,0,0,0,0-1.414l-2.4-2.4V5.5a1,1,0,0,0-1-1H15.1L12.7,2.1a1,1,0,0,0-1.414,0l-2.4,2.4H5.491a1,1,0,0,0-1,1V8.894l-2.4,2.4a1,1,0,0,0,0,1.414l2.4,2.4V18.5a1,1,0,0,0,1,1H8.885l2.4,2.4a1,1,0,0,0,1.414,0l2.4-2.4h3.394a1,1,0,0,0,1-1Z"
    }), $caaf5cab75568e97$var$n.createElement("path", {
        d: "M11.491,6c4,0,6,2.686,6,6s-2,6-6,6Z"
    }));
}, $caaf5cab75568e97$var$o = function() {
    return $caaf5cab75568e97$var$o = Object.assign || function(e) {
        for(var t, n = 1, r = arguments.length; n < r; n++)for(var c in t = arguments[n])Object.prototype.hasOwnProperty.call(t, c) && (e[c] = t[c]);
        return e;
    }, $caaf5cab75568e97$var$o.apply(this, arguments);
}, $caaf5cab75568e97$var$a = {
    left: 0,
    top: 8
}, $caaf5cab75568e97$var$i = function(t) {
    var o = t.onClick, i = $caaf5cab75568e97$var$n.useContext($6eW0i.ThemeContext), l = $caaf5cab75568e97$var$n.useContext($6eW0i.LocalizationContext).l10n, u = "dark" === i.currentTheme, h = l && l.theme ? u ? l.theme.switchLightTheme : l.theme.switchDarkTheme : u ? "Switch to the light theme" : "Switch to the dark theme";
    return $caaf5cab75568e97$var$n.createElement($6eW0i.Tooltip, {
        ariaControlsSuffix: "theme-switch",
        position: $6eW0i.Position.BottomCenter,
        target: $caaf5cab75568e97$var$n.createElement($6eW0i.MinimalButton, {
            ariaLabel: h,
            testId: "theme__switch-button",
            onClick: o
        }, u ? $caaf5cab75568e97$var$n.createElement($caaf5cab75568e97$var$c, null) : $caaf5cab75568e97$var$n.createElement($caaf5cab75568e97$var$r, null)),
        content: function() {
            return h;
        },
        offset: $caaf5cab75568e97$var$a
    });
}, $caaf5cab75568e97$var$l = function(t) {
    var r = t.children, c = $caaf5cab75568e97$var$n.useContext($6eW0i.ThemeContext);
    return (r || function(e) {
        return $caaf5cab75568e97$var$n.createElement($caaf5cab75568e97$var$i, {
            onClick: e.onClick
        });
    })({
        onClick: function() {
            return c.setCurrentTheme("dark" === c.currentTheme ? "light" : "dark");
        }
    });
}, $caaf5cab75568e97$var$u = function(t) {
    var o = t.onClick, a = $caaf5cab75568e97$var$n.useContext($6eW0i.ThemeContext), i = $caaf5cab75568e97$var$n.useContext($6eW0i.LocalizationContext).l10n, l = "dark" === a.currentTheme, u = i && i.theme ? l ? i.theme.switchLightTheme : i.theme.switchDarkTheme : l ? "Switch to the light theme" : "Switch to the dark theme";
    return $caaf5cab75568e97$var$n.createElement($6eW0i.MenuItem, {
        icon: l ? $caaf5cab75568e97$var$n.createElement($caaf5cab75568e97$var$c, null) : $caaf5cab75568e97$var$n.createElement($caaf5cab75568e97$var$r, null),
        testId: "theme__switch-menu",
        onClick: o
    }, u);
};
$caaf5cab75568e97$export$263613686aa7dfc = $caaf5cab75568e97$var$r, $caaf5cab75568e97$export$82acdd66a4e4bf90 = $caaf5cab75568e97$var$c, $caaf5cab75568e97$export$89d5f1367a34b7b2 = function() {
    var e = function(e) {
        return $caaf5cab75568e97$var$n.createElement($caaf5cab75568e97$var$l, $caaf5cab75568e97$var$o({}, e));
    };
    return {
        SwitchTheme: e,
        SwitchThemeButton: function() {
            return $caaf5cab75568e97$var$n.createElement(e, null, function(e) {
                return $caaf5cab75568e97$var$n.createElement($caaf5cab75568e97$var$i, $caaf5cab75568e97$var$o({}, e));
            });
        },
        SwitchThemeMenuItem: function(t) {
            return $caaf5cab75568e97$var$n.createElement(e, null, function(e) {
                return $caaf5cab75568e97$var$n.createElement($caaf5cab75568e97$var$u, {
                    onClick: function() {
                        e.onClick(), t.onClick();
                    }
                });
            });
        }
    };
};

});


parcelRegister("dn2na", function(module, exports) {
/**
 * A React component to view a PDF document
 *
 * @see https://react-pdf-viewer.dev
 * @license https://react-pdf-viewer.dev/license
 * @copyright 2019-2023 Nguyen Huu Phuoc <me@phuoc.ng>
 */ "use strict";

module.exports = (parcelRequire("3gCwE"));

});
parcelRegister("3gCwE", function(module, exports) {

$parcel$export(module.exports, "ZoomInIcon", () => $2610c0173d90a6bc$export$418cedbcfc990387, (v) => $2610c0173d90a6bc$export$418cedbcfc990387 = v);
$parcel$export(module.exports, "ZoomOutIcon", () => $2610c0173d90a6bc$export$fbd55a4c69e8e024, (v) => $2610c0173d90a6bc$export$fbd55a4c69e8e024 = v);
$parcel$export(module.exports, "zoomPlugin", () => $2610c0173d90a6bc$export$c015fb504902f4d8, (v) => $2610c0173d90a6bc$export$c015fb504902f4d8 = v);
var $2610c0173d90a6bc$export$418cedbcfc990387;
var $2610c0173d90a6bc$export$fbd55a4c69e8e024;
var $2610c0173d90a6bc$export$c015fb504902f4d8;
"use strict";

var $6eW0i = parcelRequire("6eW0i");
function $2610c0173d90a6bc$var$t(e) {
    var t = Object.create(null);
    return e && Object.keys(e).forEach(function(n) {
        if ("default" !== n) {
            var o = Object.getOwnPropertyDescriptor(e, n);
            Object.defineProperty(t, n, o.get ? o : {
                enumerable: !0,
                get: function() {
                    return e[n];
                }
            });
        }
    }), t.default = e, Object.freeze(t);
}

var $2610c0173d90a6bc$var$n = $2610c0173d90a6bc$var$t((parcelRequire("kc00y"))), $2610c0173d90a6bc$var$o = function() {
    return $2610c0173d90a6bc$var$n.createElement($6eW0i.Icon, {
        ignoreDirection: !0,
        size: 16
    }, $2610c0173d90a6bc$var$n.createElement("path", {
        d: "M10.5,0.499c5.523,0,10,4.477,10,10s-4.477,10-10,10s-10-4.477-10-10S4.977,0.499,10.5,0.499z\n            M23.5,23.499\n            l-5.929-5.929\n            M5.5,10.499h10\n            M10.5,5.499v10"
    }));
}, $2610c0173d90a6bc$var$r = function() {
    return $2610c0173d90a6bc$var$n.createElement($6eW0i.Icon, {
        ignoreDirection: !0,
        size: 16
    }, $2610c0173d90a6bc$var$n.createElement("path", {
        d: "M10.5,0.499c5.523,0,10,4.477,10,10s-4.477,10-10,10s-10-4.477-10-10S4.977,0.499,10.5,0.499z\n            M23.5,23.499\n            l-5.929-5.929\n            M5.5,10.499h10"
    }));
}, $2610c0173d90a6bc$var$c = function() {
    return $2610c0173d90a6bc$var$c = Object.assign || function(e) {
        for(var t, n = 1, o = arguments.length; n < o; n++)for(var r in t = arguments[n])Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
        return e;
    }, $2610c0173d90a6bc$var$c.apply(this, arguments);
}, $2610c0173d90a6bc$var$a = function(e) {
    var t = $2610c0173d90a6bc$var$n.useState(e.get("scale") || 0), o = t[0], r = t[1], c = function(e) {
        r(e);
    };
    return $2610c0173d90a6bc$var$n.useEffect(function() {
        return e.subscribe("scale", c), function() {
            e.unsubscribe("scale", c);
        };
    }, []), {
        scale: o
    };
}, $2610c0173d90a6bc$var$u = function(e) {
    var t = e.children, o = e.store;
    return (t || function(e) {
        return $2610c0173d90a6bc$var$n.createElement($2610c0173d90a6bc$var$n.Fragment, null, "".concat(Math.round(100 * e.scale), "%"));
    })({
        scale: $2610c0173d90a6bc$var$a(o).scale
    });
}, $2610c0173d90a6bc$var$l = {
    passive: !1
}, $2610c0173d90a6bc$var$i = null, $2610c0173d90a6bc$var$s = function(t) {
    var o = t.pagesContainerRef, r = t.store, c = $6eW0i.useDebounceCallback(function(e) {
        var t = r.get("zoom");
        t && t(e);
    }, 40), a = function(e) {
        if (e.ctrlKey) {
            e.preventDefault();
            var t = e.target.getBoundingClientRect(), n = 1 - e.deltaY / 100, o = e.clientX - t.left, a = e.clientY - t.top, u = r.get("scale"), l = ($2610c0173d90a6bc$var$i || ($2610c0173d90a6bc$var$i = document.createElementNS("http://www.w3.org/2000/svg", "svg"))).createSVGMatrix().translate(o, a).scale(n).translate(-o, -a).scale(u);
            c(l.a);
        }
    };
    return $6eW0i.useIsomorphicLayoutEffect(function() {
        var e = o.current;
        if (e) return e.addEventListener("wheel", a, $2610c0173d90a6bc$var$l), function() {
            e.removeEventListener("wheel", a);
        };
    }, []), $2610c0173d90a6bc$var$n.createElement($2610c0173d90a6bc$var$n.Fragment, null);
}, $2610c0173d90a6bc$var$m = [
    .1,
    .2,
    .3,
    .4,
    .5,
    .6,
    .7,
    .8,
    .9,
    1,
    1.1,
    1.3,
    1.5,
    1.7,
    1.9,
    2.1,
    2.4,
    2.7,
    3,
    3.3,
    3.7,
    4.1,
    4.6,
    5.1,
    5.7,
    6.3,
    7,
    7.7,
    8.5,
    9.4,
    10
], $2610c0173d90a6bc$var$f = function(e) {
    return $2610c0173d90a6bc$var$m.find(function(t) {
        return t > e;
    }) || e;
}, $2610c0173d90a6bc$var$v = function(e) {
    var t = $2610c0173d90a6bc$var$m.findIndex(function(t) {
        return t >= e;
    });
    return -1 === t || 0 === t ? e : $2610c0173d90a6bc$var$m[t - 1];
}, $2610c0173d90a6bc$var$p = function(t) {
    var o = t.containerRef, r = t.store, c = function(t) {
        if (!t.shiftKey && !t.altKey && ($6eW0i.isMac() ? t.metaKey : t.ctrlKey)) {
            var n = o.current;
            if (n && document.activeElement && n.contains(document.activeElement)) {
                var c = r.get("zoom");
                if (c) {
                    var a = r.get("scale") || 1, u = 1;
                    switch(t.key){
                        case "-":
                            u = $2610c0173d90a6bc$var$v(a);
                            break;
                        case "=":
                            u = $2610c0173d90a6bc$var$f(a);
                            break;
                        case "0":
                            u = 1;
                            break;
                        default:
                            u = a;
                    }
                    u !== a && (t.preventDefault(), c(u));
                }
            }
        }
    };
    return $2610c0173d90a6bc$var$n.useEffect(function() {
        if (o.current) return document.addEventListener("keydown", c), function() {
            document.removeEventListener("keydown", c);
        };
    }, [
        o.current
    ]), $2610c0173d90a6bc$var$n.createElement($2610c0173d90a6bc$var$n.Fragment, null);
}, $2610c0173d90a6bc$var$z = [
    .5,
    .75,
    1,
    1.25,
    1.5,
    2,
    3,
    4
], $2610c0173d90a6bc$var$E = {
    left: 0,
    top: 8
}, $2610c0173d90a6bc$var$d = function(t) {
    var o = t.levels, r = void 0 === o ? $2610c0173d90a6bc$var$z : o, c = t.scale, a = t.onZoom, u = $2610c0173d90a6bc$var$n.useContext($6eW0i.LocalizationContext).l10n, l = $2610c0173d90a6bc$var$n.useContext($6eW0i.ThemeContext).direction === $6eW0i.TextDirection.RightToLeft, i = u && u.zoom ? u.zoom.zoomDocument : "Zoom document";
    return $2610c0173d90a6bc$var$n.createElement($6eW0i.Popover, {
        ariaControlsSuffix: "zoom",
        ariaHasPopup: "menu",
        position: $6eW0i.Position.BottomCenter,
        target: function(t) {
            return $2610c0173d90a6bc$var$n.createElement($6eW0i.MinimalButton, {
                ariaLabel: i,
                testId: "zoom__popover-target",
                onClick: function() {
                    t();
                }
            }, $2610c0173d90a6bc$var$n.createElement("span", {
                className: "rpv-zoom__popover-target"
            }, $2610c0173d90a6bc$var$n.createElement("span", {
                "data-testid": "zoom__popover-target-scale",
                className: $6eW0i.classNames({
                    "rpv-zoom__popover-target-scale": !0,
                    "rpv-zoom__popover-target-scale--ltr": !l,
                    "rpv-zoom__popover-target-scale--rtl": l
                })
            }, Math.round(100 * c), "%"), $2610c0173d90a6bc$var$n.createElement("span", {
                className: "rpv-zoom__popover-target-arrow"
            })));
        },
        content: function(t) {
            return $2610c0173d90a6bc$var$n.createElement($6eW0i.Menu, null, Object.keys($6eW0i.SpecialZoomLevel).map(function(o) {
                var r = o;
                return $2610c0173d90a6bc$var$n.createElement($6eW0i.MenuItem, {
                    key: r,
                    onClick: function() {
                        t(), a(r);
                    }
                }, function(t) {
                    switch(t){
                        case $6eW0i.SpecialZoomLevel.ActualSize:
                            return u && u.zoom ? u.zoom.actualSize : "Actual size";
                        case $6eW0i.SpecialZoomLevel.PageFit:
                            return u && u.zoom ? u.zoom.pageFit : "Page fit";
                        case $6eW0i.SpecialZoomLevel.PageWidth:
                            return u && u.zoom ? u.zoom.pageWidth : "Page width";
                    }
                }(r));
            }), $2610c0173d90a6bc$var$n.createElement($6eW0i.MenuDivider, null), r.map(function(o) {
                return $2610c0173d90a6bc$var$n.createElement($6eW0i.MenuItem, {
                    key: o,
                    onClick: function() {
                        t(), a(o);
                    }
                }, "".concat(Math.round(100 * o), "%"));
            }));
        },
        offset: $2610c0173d90a6bc$var$E,
        closeOnClickOutside: !0,
        closeOnEscape: !0
    });
}, $2610c0173d90a6bc$var$g = function(e) {
    var t = e.children, o = e.levels, r = e.store;
    return (t || function(e) {
        return $2610c0173d90a6bc$var$n.createElement($2610c0173d90a6bc$var$d, {
            levels: o,
            scale: e.scale,
            onZoom: e.onZoom
        });
    })({
        scale: $2610c0173d90a6bc$var$a(r).scale,
        onZoom: function(e) {
            var t = r.get("zoom");
            t && t(e);
        }
    });
}, $2610c0173d90a6bc$var$C = {
    left: 0,
    top: 8
}, $2610c0173d90a6bc$var$h = function(t) {
    var r = t.enableShortcuts, c = t.onClick, a = $2610c0173d90a6bc$var$n.useContext($6eW0i.LocalizationContext).l10n, u = a && a.zoom ? a.zoom.zoomIn : "Zoom in", l = r ? $6eW0i.isMac() ? "Meta+=" : "Ctrl+=" : "";
    return $2610c0173d90a6bc$var$n.createElement($6eW0i.Tooltip, {
        ariaControlsSuffix: "zoom-in",
        position: $6eW0i.Position.BottomCenter,
        target: $2610c0173d90a6bc$var$n.createElement($6eW0i.MinimalButton, {
            ariaKeyShortcuts: l,
            ariaLabel: u,
            testId: "zoom__in-button",
            onClick: c
        }, $2610c0173d90a6bc$var$n.createElement($2610c0173d90a6bc$var$o, null)),
        content: function() {
            return u;
        },
        offset: $2610c0173d90a6bc$var$C
    });
}, $2610c0173d90a6bc$var$b = function(e) {
    var t = e.children, n = e.enableShortcuts, o = e.store, r = $2610c0173d90a6bc$var$a(o).scale;
    return (t || $2610c0173d90a6bc$var$h)({
        enableShortcuts: n,
        onClick: function() {
            var e = o.get("zoom");
            e && e($2610c0173d90a6bc$var$f(r));
        }
    });
}, $2610c0173d90a6bc$var$k = function(t) {
    var r = t.onClick, c = $2610c0173d90a6bc$var$n.useContext($6eW0i.LocalizationContext).l10n, a = c && c.zoom ? c.zoom.zoomIn : "Zoom in";
    return $2610c0173d90a6bc$var$n.createElement($6eW0i.MenuItem, {
        icon: $2610c0173d90a6bc$var$n.createElement($2610c0173d90a6bc$var$o, null),
        testId: "zoom__in-menu",
        onClick: r
    }, a);
}, $2610c0173d90a6bc$var$S = {
    left: 0,
    top: 8
}, $2610c0173d90a6bc$var$M = function(t) {
    var o = t.enableShortcuts, c = t.onClick, a = $2610c0173d90a6bc$var$n.useContext($6eW0i.LocalizationContext).l10n, u = a && a.zoom ? a.zoom.zoomOut : "Zoom out", l = o ? $6eW0i.isMac() ? "Meta+-" : "Ctrl+-" : "";
    return $2610c0173d90a6bc$var$n.createElement($6eW0i.Tooltip, {
        ariaControlsSuffix: "zoom-out",
        position: $6eW0i.Position.BottomCenter,
        target: $2610c0173d90a6bc$var$n.createElement($6eW0i.MinimalButton, {
            ariaKeyShortcuts: l,
            ariaLabel: u,
            testId: "zoom__out-button",
            onClick: c
        }, $2610c0173d90a6bc$var$n.createElement($2610c0173d90a6bc$var$r, null)),
        content: function() {
            return u;
        },
        offset: $2610c0173d90a6bc$var$S
    });
}, $2610c0173d90a6bc$var$I = function(e) {
    var t = e.children, n = e.enableShortcuts, o = e.store, r = $2610c0173d90a6bc$var$a(o).scale;
    return (t || $2610c0173d90a6bc$var$M)({
        enableShortcuts: n,
        onClick: function() {
            var e = o.get("zoom");
            e && e($2610c0173d90a6bc$var$v(r));
        }
    });
}, $2610c0173d90a6bc$var$Z = function(t) {
    var o = t.onClick, c = $2610c0173d90a6bc$var$n.useContext($6eW0i.LocalizationContext).l10n, a = c && c.zoom ? c.zoom.zoomOut : "Zoom out";
    return $2610c0173d90a6bc$var$n.createElement($6eW0i.MenuItem, {
        icon: $2610c0173d90a6bc$var$n.createElement($2610c0173d90a6bc$var$r, null),
        testId: "zoom__out-menu",
        onClick: o
    }, a);
};
$2610c0173d90a6bc$export$418cedbcfc990387 = $2610c0173d90a6bc$var$o, $2610c0173d90a6bc$export$fbd55a4c69e8e024 = $2610c0173d90a6bc$var$r, $2610c0173d90a6bc$export$c015fb504902f4d8 = function(t) {
    var o = $2610c0173d90a6bc$var$n.useMemo(function() {
        return Object.assign({}, {
            enableShortcuts: !0
        }, t);
    }, []), r = $2610c0173d90a6bc$var$n.useMemo(function() {
        return $6eW0i.createStore({});
    }, []), a = function(e) {
        return $2610c0173d90a6bc$var$n.createElement($2610c0173d90a6bc$var$b, $2610c0173d90a6bc$var$c({
            enableShortcuts: o.enableShortcuts
        }, e, {
            store: r
        }));
    }, l = function(e) {
        return $2610c0173d90a6bc$var$n.createElement($2610c0173d90a6bc$var$I, $2610c0173d90a6bc$var$c({
            enableShortcuts: o.enableShortcuts
        }, e, {
            store: r
        }));
    }, i = function(e) {
        return $2610c0173d90a6bc$var$n.createElement($2610c0173d90a6bc$var$g, $2610c0173d90a6bc$var$c({}, e, {
            store: r
        }));
    };
    return {
        renderViewer: function(e) {
            var t = e.slot;
            if (!o.enableShortcuts) return t;
            var a = {
                children: $2610c0173d90a6bc$var$n.createElement($2610c0173d90a6bc$var$n.Fragment, null, $2610c0173d90a6bc$var$n.createElement($2610c0173d90a6bc$var$p, {
                    containerRef: e.containerRef,
                    store: r
                }), $2610c0173d90a6bc$var$n.createElement($2610c0173d90a6bc$var$s, {
                    pagesContainerRef: e.pagesContainerRef,
                    store: r
                }), t.children)
            };
            return $2610c0173d90a6bc$var$c($2610c0173d90a6bc$var$c({}, t), a);
        },
        install: function(e) {
            r.update("zoom", e.zoom);
        },
        onViewerStateChange: function(e) {
            return r.update("scale", e.scale), e;
        },
        zoomTo: function(e) {
            var t = r.get("zoom");
            t && t(e);
        },
        CurrentScale: function(e) {
            return $2610c0173d90a6bc$var$n.createElement($2610c0173d90a6bc$var$u, $2610c0173d90a6bc$var$c({}, e, {
                store: r
            }));
        },
        ZoomIn: a,
        ZoomInButton: function() {
            return $2610c0173d90a6bc$var$n.createElement(a, null, function(e) {
                return $2610c0173d90a6bc$var$n.createElement($2610c0173d90a6bc$var$h, $2610c0173d90a6bc$var$c({}, e));
            });
        },
        ZoomInMenuItem: function(e) {
            return $2610c0173d90a6bc$var$n.createElement(a, null, function(t) {
                return $2610c0173d90a6bc$var$n.createElement($2610c0173d90a6bc$var$k, {
                    onClick: function() {
                        t.onClick(), e.onClick();
                    }
                });
            });
        },
        ZoomOut: l,
        ZoomOutButton: function() {
            return $2610c0173d90a6bc$var$n.createElement(l, null, function(e) {
                return $2610c0173d90a6bc$var$n.createElement($2610c0173d90a6bc$var$M, $2610c0173d90a6bc$var$c({}, e));
            });
        },
        ZoomOutMenuItem: function(e) {
            return $2610c0173d90a6bc$var$n.createElement(l, null, function(t) {
                return $2610c0173d90a6bc$var$n.createElement($2610c0173d90a6bc$var$Z, {
                    onClick: function() {
                        t.onClick(), e.onClick();
                    }
                });
            });
        },
        Zoom: i,
        ZoomPopover: function(e) {
            return $2610c0173d90a6bc$var$n.createElement(i, null, function(t) {
                return $2610c0173d90a6bc$var$n.createElement($2610c0173d90a6bc$var$d, $2610c0173d90a6bc$var$c({
                    levels: null == e ? void 0 : e.levels
                }, t));
            });
        }
    };
};

});






parcelRegister("hDZuH", function(module, exports) {

$parcel$export(module.exports, "pdfjs", () => (parcelRequire("5rX9H")).default);

var $5rX9H = parcelRequire("5rX9H");









var $9fqrE = parcelRequire("9fqrE");
(0, $9fqrE.displayWorkerWarning)();
(0, $5rX9H.default).GlobalWorkerOptions.workerSrc = "pdf.worker.js";

});
parcelRegister("5rX9H", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f7d5c6844f554db$export$2e2bcd8739ae039);

var $633OE = parcelRequire("633OE");
const $3f7d5c6844f554db$var$pdfjs = "default" in $633OE ? $633OE["default"] : $633OE;
var $3f7d5c6844f554db$export$2e2bcd8739ae039 = $3f7d5c6844f554db$var$pdfjs;

});

parcelRegister("9fqrE", function(module, exports) {

$parcel$export(module.exports, "displayWorkerWarning", () => $6bba072f5e56fcf4$export$e7ec4a9e2d586a77);

var $3ORyC = parcelRequire("3ORyC");

var $8pxIL = parcelRequire("8pxIL");
const $6bba072f5e56fcf4$export$4e09c449d6c407f7 = typeof document !== "undefined";
const $6bba072f5e56fcf4$export$d528e4159a0e221e = $6bba072f5e56fcf4$export$4e09c449d6c407f7 && window.location.protocol === "file:";
function $6bba072f5e56fcf4$export$4e62c701997796c1(variable) {
    return typeof variable !== "undefined";
}
function $6bba072f5e56fcf4$export$ef8866826b0b1f6d(variable) {
    return $6bba072f5e56fcf4$export$4e62c701997796c1(variable) && variable !== null;
}
function $6bba072f5e56fcf4$export$844ec244b1367d54(variable) {
    return typeof variable === "string";
}
function $6bba072f5e56fcf4$export$9dd3754ae86f0017(variable) {
    return variable instanceof ArrayBuffer;
}
function $6bba072f5e56fcf4$export$5bcd6e94ed871c88(variable) {
    (0, $3ORyC.default)($6bba072f5e56fcf4$export$4e09c449d6c407f7, "isBlob can only be used in a browser environment");
    return variable instanceof Blob;
}
function $6bba072f5e56fcf4$export$4d82193ef6a8d75c(variable) {
    return $6bba072f5e56fcf4$export$844ec244b1367d54(variable) && /^data:/.test(variable);
}
function $6bba072f5e56fcf4$export$c1553384119518c3(dataURI) {
    (0, $3ORyC.default)($6bba072f5e56fcf4$export$4d82193ef6a8d75c(dataURI), "Invalid data URI.");
    const [headersString = "", dataString = ""] = dataURI.split(",");
    const headers = headersString.split(";");
    if (headers.indexOf("base64") !== -1) return atob(dataString);
    return unescape(dataString);
}
function $6bba072f5e56fcf4$export$cf4a949e5ad681d() {
    return $6bba072f5e56fcf4$export$4e09c449d6c407f7 && window.devicePixelRatio || 1;
}
const $6bba072f5e56fcf4$var$allowFileAccessFromFilesTip = "On Chromium based browsers, you can use --allow-file-access-from-files flag for debugging purposes.";
function $6bba072f5e56fcf4$export$84884c3182d1bdda() {
    (0, (/*@__PURE__*/$parcel$interopDefault($8pxIL)))(!$6bba072f5e56fcf4$export$d528e4159a0e221e, `Loading PDF as base64 strings/URLs may not work on protocols other than HTTP/HTTPS. ${$6bba072f5e56fcf4$var$allowFileAccessFromFilesTip}`);
}
function $6bba072f5e56fcf4$export$e7ec4a9e2d586a77() {
    (0, (/*@__PURE__*/$parcel$interopDefault($8pxIL)))(!$6bba072f5e56fcf4$export$d528e4159a0e221e, `Loading PDF.js worker may not work on protocols other than HTTP/HTTPS. ${$6bba072f5e56fcf4$var$allowFileAccessFromFilesTip}`);
}
function $6bba072f5e56fcf4$export$b8c3f1dffc289352(runningTask) {
    if (runningTask && runningTask.cancel) runningTask.cancel();
}
function $6bba072f5e56fcf4$export$8cc3f6b8d58bdda0(page, scale) {
    Object.defineProperty(page, "width", {
        get () {
            return this.view[2] * scale;
        },
        configurable: true
    });
    Object.defineProperty(page, "height", {
        get () {
            return this.view[3] * scale;
        },
        configurable: true
    });
    Object.defineProperty(page, "originalWidth", {
        get () {
            return this.view[2];
        },
        configurable: true
    });
    Object.defineProperty(page, "originalHeight", {
        get () {
            return this.view[3];
        },
        configurable: true
    });
    return page;
}
function $6bba072f5e56fcf4$export$99075c4d008e6ab1(error) {
    return error.name === "RenderingCancelledException";
}
function $6bba072f5e56fcf4$export$21fedb3a7a137f3d(file) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.onload = ()=>{
            if (!reader.result) return reject(new Error("Error while reading a file."));
            resolve(reader.result);
        };
        reader.onerror = (event)=>{
            if (!event.target) return reject(new Error("Error while reading a file."));
            const { error: error } = event.target;
            if (!error) return reject(new Error("Error while reading a file."));
            switch(error.code){
                case error.NOT_FOUND_ERR:
                    return reject(new Error("Error while reading a file: File not found."));
                case error.SECURITY_ERR:
                    return reject(new Error("Error while reading a file: Security error."));
                case error.ABORT_ERR:
                    return reject(new Error("Error while reading a file: Aborted."));
                default:
                    return reject(new Error("Error while reading a file."));
            }
        };
        reader.readAsArrayBuffer(file);
    });
}

});
parcelRegister("3ORyC", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c7f95f8418cde01$export$2e2bcd8739ae039);
var $2c7f95f8418cde01$var$isProduction = true;
var $2c7f95f8418cde01$var$prefix = "Invariant failed";
function $2c7f95f8418cde01$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($2c7f95f8418cde01$var$isProduction) throw new Error($2c7f95f8418cde01$var$prefix);
    var provided = typeof message === "function" ? message() : message;
    var value = provided ? "".concat($2c7f95f8418cde01$var$prefix, ": ").concat(provided) : $2c7f95f8418cde01$var$prefix;
    throw new Error(value);
}

});

parcelRegister("8pxIL", function(module, exports) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $61fad0cb6b7e8586$var$__DEV__ = false;
var $61fad0cb6b7e8586$var$warning = function() {};
if ($61fad0cb6b7e8586$var$__DEV__) {
    var $61fad0cb6b7e8586$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = "Warning: " + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== "undefined") console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $61fad0cb6b7e8586$var$warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $61fad0cb6b7e8586$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
module.exports = $61fad0cb6b7e8586$var$warning;

});



parcelRegister("8pJh9", function(module, exports) {
module.exports = JSON.parse('{"attachment":{"clickToDownload":"Appuyez pour t\xe9l\xe9charger","noAttachment":"Pas d\u2019attachement"},"bookmark":{"noBookmark":"Pas de signet"},"core":{"askingPassword":{"requirePasswordToOpen":"Exiger un mot de passe pour ouvrir","submit":"Soumettre"},"wrongPassword":{"submit":"Soumettre","tryAgain":"Mauvais mot de passe. Veuillez r\xe9essayer."},"pageLabel":"Page {{pageIndex}}"},"defaultLayout":{"attachment":"Attachement","bookmark":"Signet","thumbnail":"Miniature"},"download":{"download":"T\xe9l\xe9charger"},"drop":{"dragDropFile":"Tirer et d\xe9poser le document de PDF ici"},"fullScreen":{"enterFullScreen":"Plein \xe9cran","exitFullScreen":"Sortir du mode plein \xe9cran"},"localeSwitcher":{"switchLocale":"Changer le lieu"},"open":{"openFile":"Ouvrir le fichier"},"pageNavigation":{"enterPageNumber":"Entrer le num\xe9ro de page","goToFirstPage":"Premi\xe8re page","goToLastPage":"Derni\xe8re page","goToNextPage":"Page suivante","goToPreviousPage":"Page pr\xe9c\xe9dente"},"print":{"cancel":"Annuler","preparingDocument":"Pr\xe9paration du document...","print":"Imprimer"},"properties":{"author":"Auteur","close":"Fermer","creationDate":"Date de cr\xe9ation","creator":"Cr\xe9ateur","fileName":"Nom de fichier","fileSize":"Taille du fichier","keywords":"Mots-cl\xe9s","modificationDate":"Date de modification","pageCount":"Nombre de page","pdfProducer":"Cr\xe9er un fichier pdf","pdfVersion":"Version PDF","showProperties":"Afficher les propri\xe9t\xe9s","subject":"Sujet","title":"Titre"},"rotate":{"rotateBackward":"Tourner en arri\xe8re","rotateForward":"Tourner en avant"},"scrollMode":{"horizontalScrolling":"D\xe9filement horizontal","verticalScrolling":"D\xe9filement vertical","wrappedScrolling":"D\xe9filement de nombreuses pages"},"search":{"close":"Fermer","enterToSearch":"Appuyez Enter pour rechercher","matchCase":"Distinguer la minuscule et majuscule","nextMatch":"R\xe9sultat suivant","previousMatch":"R\xe9sultat pr\xe9c\xe9dent","search":"Rechercher","wholeWords":"Mots entiers"},"selectionMode":{"handTool":"\xc0 la main","textSelectionTool":"Outil de s\xe9lection de texte"},"theme":{"switchDarkTheme":"Changer vers le th\xe8me sombre","switchLightTheme":"Changer vers le th\xe8me clair"},"thumbnail":{"thumbnailLabel":"Miniature de la page {{pageIndex}}"},"toolbar":{"moreActions":"Autres actions"},"zoom":{"actualSize":"Taille actuelle","pageFit":"Adapter \xe0 la page","pageWidth":"Largeur de page","zoomDocument":"Agrandir le document","zoomIn":"Agrandir","zoomOut":"R\xe9duire"}}');

});

parcelRegister("iMAUV", function(module, exports) {

$parcel$export(module.exports, "btnRightPdf", () => $dac958ae323e2944$export$ec1360348a48262, (v) => $dac958ae323e2944$export$ec1360348a48262 = v);
$parcel$export(module.exports, "containerError", () => $dac958ae323e2944$export$b42883fa2b07538b, (v) => $dac958ae323e2944$export$b42883fa2b07538b = v);
$parcel$export(module.exports, "errorPdf", () => $dac958ae323e2944$export$d4e5d41b172d90c1, (v) => $dac958ae323e2944$export$d4e5d41b172d90c1 = v);
$parcel$export(module.exports, "height100", () => $dac958ae323e2944$export$80fb4f491e8b3f15, (v) => $dac958ae323e2944$export$80fb4f491e8b3f15 = v);
$parcel$export(module.exports, "progressBar", () => $dac958ae323e2944$export$9d1298853f0e77f7, (v) => $dac958ae323e2944$export$9d1298853f0e77f7 = v);
$parcel$export(module.exports, "worker", () => $dac958ae323e2944$export$9cc6e40b2e68ccfb, (v) => $dac958ae323e2944$export$9cc6e40b2e68ccfb = v);
var $dac958ae323e2944$export$ec1360348a48262;
var $dac958ae323e2944$export$b42883fa2b07538b;
var $dac958ae323e2944$export$d4e5d41b172d90c1;
var $dac958ae323e2944$export$80fb4f491e8b3f15;
var $dac958ae323e2944$export$9d1298853f0e77f7;
var $dac958ae323e2944$export$9cc6e40b2e68ccfb;
$dac958ae323e2944$export$ec1360348a48262 = `YiQWCq_btnRightPdf`;
$dac958ae323e2944$export$b42883fa2b07538b = `YiQWCq_containerError`;
$dac958ae323e2944$export$d4e5d41b172d90c1 = `YiQWCq_errorPdf`;
$dac958ae323e2944$export$80fb4f491e8b3f15 = `YiQWCq_height100`;
$dac958ae323e2944$export$9d1298853f0e77f7 = `YiQWCq_progressBar`;
$dac958ae323e2944$export$9cc6e40b2e68ccfb = `YiQWCq_worker`;

});


parcelRegister("9V8Ui", function(module, exports) {

$parcel$export(module.exports, "default", () => $511c5036b93d52fb$export$2e2bcd8739ae039);

var $cKvYK = parcelRequire("cKvYK");
parcelRequire("cMFVi");
/**
 * Composante React représentant un lecteur vidéo avec des fonctionnalités de contrôle.
 *
 * @param {string} url L'URL de la vidéo à afficher.
 * @param {boolean} telechargeable Indique si la vidéo est téléchargeable ou non.
 * @param {string} soustitre URI des sous_titres
 * @returns {JSX.Element} Un élément JSX représentant le lecteur vidéo.
 */ const $511c5036b93d52fb$var$CapsuleVideo = ({ url: url, telechargeable: telechargeable, soustitre: soustitre })=>{
    return /*#__PURE__*/ (0, $cKvYK.jsx)((0, $cKvYK.Fragment), {
        children: /*#__PURE__*/ (0, $cKvYK.jsxs)("video", {
            controls: true,
            controlsList: !telechargeable ? "nodownload" : "",
            name: "media",
            children: [
                /*#__PURE__*/ (0, $cKvYK.jsx)("source", {
                    src: url,
                    type: "video/mp4"
                }),
                /*#__PURE__*/ (0, $cKvYK.jsx)("track", {
                    default: true,
                    kind: "subtitles",
                    srcLang: "fr",
                    src: soustitre
                })
            ]
        })
    });
};
var $511c5036b93d52fb$export$2e2bcd8739ae039 = $511c5036b93d52fb$var$CapsuleVideo;

});
parcelRegister("cMFVi", function(module, exports) {

});


parcelRegister("gMzJI", function(module, exports) {

$parcel$export(module.exports, "btnWebGl", () => $c37cd98643dd0f2e$export$d21f854e62be8373, (v) => $c37cd98643dd0f2e$export$d21f854e62be8373 = v);
$parcel$export(module.exports, "center", () => $c37cd98643dd0f2e$export$3481c78889e8fbe8, (v) => $c37cd98643dd0f2e$export$3481c78889e8fbe8 = v);
$parcel$export(module.exports, "entete", () => $c37cd98643dd0f2e$export$88c48f6a3db17950, (v) => $c37cd98643dd0f2e$export$88c48f6a3db17950 = v);
$parcel$export(module.exports, "height100", () => $c37cd98643dd0f2e$export$80fb4f491e8b3f15, (v) => $c37cd98643dd0f2e$export$80fb4f491e8b3f15 = v);
var $c37cd98643dd0f2e$export$d21f854e62be8373;
var $c37cd98643dd0f2e$export$3481c78889e8fbe8;
var $c37cd98643dd0f2e$export$88c48f6a3db17950;
var $c37cd98643dd0f2e$export$80fb4f491e8b3f15;
$c37cd98643dd0f2e$export$d21f854e62be8373 = `W0BDrG_btnWebGl`;
$c37cd98643dd0f2e$export$3481c78889e8fbe8 = `W0BDrG_center`;
$c37cd98643dd0f2e$export$88c48f6a3db17950 = `W0BDrG_entete`;
$c37cd98643dd0f2e$export$80fb4f491e8b3f15 = `W0BDrG_height100`;

});




parcelRegister("i2wlK", function(module, exports) {

$parcel$export(module.exports, "activeCell", () => $d22181dd24303bd8$export$99b867379f642df2, (v) => $d22181dd24303bd8$export$99b867379f642df2 = v);
$parcel$export(module.exports, "cellButton", () => $d22181dd24303bd8$export$dd94d7ecfe010714, (v) => $d22181dd24303bd8$export$dd94d7ecfe010714 = v);
$parcel$export(module.exports, "deleteCell", () => $d22181dd24303bd8$export$6e37d353cc5629c9, (v) => $d22181dd24303bd8$export$6e37d353cc5629c9 = v);
$parcel$export(module.exports, "link", () => $d22181dd24303bd8$export$9c30223ca0a664fb, (v) => $d22181dd24303bd8$export$9c30223ca0a664fb = v);
$parcel$export(module.exports, "previewCell", () => $d22181dd24303bd8$export$ef2c6efdcd47bc05, (v) => $d22181dd24303bd8$export$ef2c6efdcd47bc05 = v);
var $d22181dd24303bd8$export$99b867379f642df2;
var $d22181dd24303bd8$export$dd94d7ecfe010714;
var $d22181dd24303bd8$export$6e37d353cc5629c9;
var $d22181dd24303bd8$export$9c30223ca0a664fb;
var $d22181dd24303bd8$export$ef2c6efdcd47bc05;
$d22181dd24303bd8$export$99b867379f642df2 = `XbPK6a_activeCell`;
$d22181dd24303bd8$export$dd94d7ecfe010714 = `XbPK6a_cellButton`;
$d22181dd24303bd8$export$6e37d353cc5629c9 = `XbPK6a_deleteCell`;
$d22181dd24303bd8$export$9c30223ca0a664fb = `XbPK6a_link`;
$d22181dd24303bd8$export$ef2c6efdcd47bc05 = `XbPK6a_previewCell`;

});


parcelRegister("hplX1", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2fe1aa11b30f083$export$2e2bcd8739ae039);

var $cKvYK = parcelRequire("cKvYK");

var $lgiU2 = parcelRequire("lgiU2");

var $5TbRy = parcelRequire("5TbRy");

var $26Ddr = parcelRequire("26Ddr");

var $bYYyU = parcelRequire("bYYyU");

var $3BicN = parcelRequire("3BicN");

var $hpOSz = parcelRequire("hpOSz");

var $ja4el = parcelRequire("ja4el");

var $dZjxw = parcelRequire("dZjxw");

var $iQGzH = parcelRequire("iQGzH");
const $c2fe1aa11b30f083$export$a5cab80145b70e98 = (data)=>({
        ressourceId: data?.ressourceId ?? null,
        ressourceLibelle: data?.ressourceLibelle ?? "",
        ressourceDescription: data?.ressourceDescription ?? "",
        typeRessource: data?.typeRessource,
        ressourceTelechargeable: data?.ressourceTelechargeable,
        previewFile: undefined,
        file: undefined
    });
const $c2fe1aa11b30f083$export$f97400759cfd946 = (data, values)=>{
    const formData = new FormData();
    formData.append("previewFile", values.previewFile ?? null);
    formData.append("file", values.file ?? null);
    formData.append("ressourceId", values.ressourceId);
    formData.append("ressourceLibelle", values.ressourceLibelle);
    formData.append("ressourceDescription", values.ressourceDescription);
    formData.append("typeRessourceId", values.typeRessource.typeRessourceId);
    formData.append("ressourceTelechargeable", values.ressourceTelechargeable);
    return formData;
};
const $c2fe1aa11b30f083$var$EditRessource = ({ ressourceId: ressourceId, ressourceLibelle: ressourceLibelle, ressourceDescription: ressourceDescription, typeRessourceId: typeRessourceId, ressourceTelechargeable: ressourceTelechargeable })=>{
    const { visible: visible, show: show, close: close } = (0, $dZjxw.useModal)();
    const typeRessourceState = (0, $26Ddr.useGet)((0, $5TbRy.default)`/api/type-ressource`);
    const typeRessource = typeRessourceState?.data?.list.find((e)=>e.typeRessourceId === typeRessourceId);
    const initValue = {
        ressourceId: ressourceId,
        ressourceLibelle: ressourceLibelle,
        ressourceDescription: ressourceDescription,
        typeRessource: typeRessource,
        ressourceTelechargeable: ressourceTelechargeable
    };
    return typeRessource != null && /*#__PURE__*/ (0, $cKvYK.jsxs)((0, $cKvYK.Fragment), {
        children: [
            /*#__PURE__*/ (0, $cKvYK.jsx)((0, $bYYyU.default), {
                onClick: show,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($lgiU2)))((0, (/*@__PURE__*/$parcel$interopDefault($iQGzH))).cellButton, (0, (/*@__PURE__*/$parcel$interopDefault($iQGzH))).previewCell),
                children: /*#__PURE__*/ (0, $cKvYK.jsx)((0, $hpOSz.IconReplace), {})
            }),
            /*#__PURE__*/ (0, $cKvYK.jsxs)((0, $ja4el.default), {
                visible: visible,
                closeModal: close,
                loadData: false,
                isPost: false,
                id: ressourceId,
                query: (0, $5TbRy.default)`/api/ressource/${ressourceId}/edit`,
                prepareVariables: $c2fe1aa11b30f083$export$f97400759cfd946,
                getInitialValues: $c2fe1aa11b30f083$export$a5cab80145b70e98(initValue),
                onSubmit: ()=>window.location.reload(false),
                header: "Modifier le contenu",
                submitLabel: /*#__PURE__*/ (0, $cKvYK.jsxs)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($iQGzH))).iconSave,
                    children: [
                        "Enregistrer les modifications \xa0 ",
                        /*#__PURE__*/ (0, $cKvYK.jsx)((0, $hpOSz.IconSave), {})
                    ]
                }),
                isMultipartFormData: true,
                children: [
                    /*#__PURE__*/ (0, $cKvYK.jsxs)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($iQGzH))).titleComponent,
                        children: [
                            /*#__PURE__*/ (0, $cKvYK.jsx)("label", {
                                htmlFor: "ressourceLibelle",
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($iQGzH))).titleInput,
                                children: "Titre :"
                            }),
                            /*#__PURE__*/ (0, $cKvYK.jsx)((0, $3BicN.TextField), {
                                placeholder: ressourceLibelle,
                                id: "ressourceLibelle",
                                name: "ressourceLibelle"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cKvYK.jsx)("label", {
                        htmlFor: "ressourceDescription",
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($iQGzH))).description,
                        children: "Description :"
                    }),
                    /*#__PURE__*/ (0, $cKvYK.jsx)((0, $3BicN.LargeTextField), {
                        placeholder: ressourceDescription,
                        id: "ressourceDescription",
                        name: "ressourceDescription",
                        rows: "5",
                        cols: "40"
                    }),
                    /*#__PURE__*/ (0, $cKvYK.jsx)((0, $3BicN.SelectInput), {
                        label: "Type de contenu",
                        name: "typeRessource",
                        options: typeRessourceState.value?.list,
                        getOptionValue: (t)=>t.typeRessourceId,
                        toOptionLabelFunc: (t)=>t?.typeRessourceLibelle,
                        isClearable: false,
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($iQGzH))).selectInput
                    }),
                    /*#__PURE__*/ (0, $cKvYK.jsx)((0, $3BicN.CheckboxInput), {
                        label: "Le fichier sera t-il t\xe9l\xe9chargeable ?",
                        name: "ressourceTelechargeable",
                        value: ressourceTelechargeable
                    }),
                    /*#__PURE__*/ (0, $cKvYK.jsx)((0, $3BicN.FileInput), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($iQGzH))).inputLabel,
                        name: "previewFile",
                        label: "Modifier l'image de preview",
                        accept: ".png, .jpg, .jpeg"
                    }),
                    /*#__PURE__*/ (0, $cKvYK.jsx)((0, $3BicN.FileInput), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($iQGzH))).inputLabel,
                        name: "file",
                        label: "Importer votre contenu",
                        accept: ".wav, .mp4, .png, .jpg, .jpeg, .pdf"
                    })
                ]
            })
        ]
    });
};
var $c2fe1aa11b30f083$export$2e2bcd8739ae039 = $c2fe1aa11b30f083$var$EditRessource;

});
parcelRegister("ja4el", function(module, exports) {

$parcel$export(module.exports, "default", () => $4fca9b9af43f2eb3$export$2e2bcd8739ae039);

var $cKvYK = parcelRequire("cKvYK");

var $bHtBB = parcelRequire("bHtBB");

var $26Ddr = parcelRequire("26Ddr");

var $ijxZJ = parcelRequire("ijxZJ");

var $3BicN = parcelRequire("3BicN");

var $61JDm = parcelRequire("61JDm");

var $dZjxw = parcelRequire("dZjxw");

var $11vsd = parcelRequire("11vsd");
const $4fca9b9af43f2eb3$var$EditModalBody = ({ prepareVariables: prepareVariables, getInitialValues: getInitialValues, query: query, loadData: // loadData = données "à charger ou non" -> si true alors on fait un useGet pour avoir les valeurs
loadData, id: id, validationSchema: validationSchema, isPost: isPost = true, canModify: canModify, onSubmit: onSubmit, closeModal: closeModal, children: children, submitLabel: submitLabel, isMultipartFormData: isMultipartFormData = false })=>{
    const isAdd = id == null;
    const submitUrl = query;
    let initialData = {};
    if (!isAdd && loadData) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const editState = (0, $26Ddr.useGet)(submitUrl);
        const { isResolved: isResolved, data: data = {} } = editState;
        if (!isResolved) return /*#__PURE__*/ (0, $cKvYK.jsx)((0, $bHtBB.default), {
            state: editState
        });
        if (!data) {
            (0, $61JDm.default).error("Une erreur est survenue lors de la r\xe9cup\xe9ration des donn\xe9es.");
            closeModal();
        }
        initialData = data;
    }
    return /*#__PURE__*/ (0, $cKvYK.jsx)((0, $ijxZJ.default), {
        validationSchema: validationSchema,
        isPost: isPost,
        initialValues: !loadData ? getInitialValues : getInitialValues ? getInitialValues(initialData) : initialData,
        submitUrl: submitUrl,
        onSubmit: (data)=>{
            onSubmit && onSubmit(data);
            closeModal();
        },
        prepareVariables: (values)=>isAdd ? prepareVariables(values) : prepareVariables(id, values),
        isMultipartFormData: isMultipartFormData,
        children: /*#__PURE__*/ (0, $cKvYK.jsxs)((0, $3BicN.Form), {
            children: [
                /*#__PURE__*/ (0, $cKvYK.jsx)((0, $dZjxw.Content), {
                    children: children
                }),
                /*#__PURE__*/ (0, $cKvYK.jsx)((0, $dZjxw.ActionBar), {
                    children: canModify ? /*#__PURE__*/ (0, $cKvYK.jsxs)((0, $cKvYK.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $cKvYK.jsx)("button", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($11vsd))).closeButton,
                                onClick: (e)=>{
                                    e.preventDefault();
                                    closeModal();
                                },
                                children: "Annuler"
                            }),
                            /*#__PURE__*/ (0, $cKvYK.jsx)("button", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($11vsd))).active,
                                type: "submit",
                                children: submitLabel ?? "Valider"
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $cKvYK.jsx)("button", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($11vsd))).active,
                        onClick: closeModal,
                        children: "Fermer"
                    })
                })
            ]
        })
    });
};
const $4fca9b9af43f2eb3$var$EditModal = ({ visible: visible, closeModal: closeModal, header: header, query: query, loadData: loadData, id: id, children: children, validationSchema: validationSchema, isPost: isPost = true, onSubmit: onSubmit, prepareVariables: prepareVariables = (values)=>({
        values: values
    }), getInitialValues: getInitialValues, canModify: canModify = true, submitLabel: submitLabel, isMultipartFormData: isMultipartFormData = false })=>{
    return /*#__PURE__*/ (0, $cKvYK.jsx)((0, $dZjxw.default), {
        visible: visible,
        header: header,
        closeModal: closeModal,
        children: /*#__PURE__*/ (0, $cKvYK.jsx)($4fca9b9af43f2eb3$var$EditModalBody, {
            canModify: canModify,
            query: query,
            loadData: loadData,
            id: id,
            validationSchema: validationSchema,
            isPost: isPost,
            onSubmit: onSubmit,
            closeModal: closeModal,
            prepareVariables: prepareVariables,
            getInitialValues: getInitialValues,
            submitLabel: submitLabel,
            isMultipartFormData: isMultipartFormData,
            children: children
        })
    });
};
var $4fca9b9af43f2eb3$export$2e2bcd8739ae039 = $4fca9b9af43f2eb3$var$EditModal;

});
parcelRegister("bHtBB", function(module, exports) {

$parcel$export(module.exports, "default", () => $4653b3a4941aface$export$2e2bcd8739ae039);

var $cKvYK = parcelRequire("cKvYK");

var $3RY61 = parcelRequire("3RY61");

var $iSOlq = parcelRequire("iSOlq");
const $4653b3a4941aface$var$LoadingOrError = ({ state: state })=>{
    if (Array.isArray(state)) {
        if (state.find(({ isLoading: isLoading })=>isLoading)) return /*#__PURE__*/ (0, $cKvYK.jsx)((0, $3RY61.default), {});
        else if (state.find(({ isRejected: isRejected })=>isRejected)) return /*#__PURE__*/ (0, $cKvYK.jsx)((0, $iSOlq.default), {
            error: state.map(({ error: error })=>error)
        });
        else return null;
    } else {
        if (state.isLoading) return /*#__PURE__*/ (0, $cKvYK.jsx)((0, $3RY61.default), {});
        else if (state.isRejected) return /*#__PURE__*/ (0, $cKvYK.jsx)((0, $iSOlq.default), {
            error: state.error
        });
        else return null;
    }
};
var $4653b3a4941aface$export$2e2bcd8739ae039 = $4653b3a4941aface$var$LoadingOrError;

});
parcelRegister("iSOlq", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ccfb6715ccec8e4$export$2e2bcd8739ae039);

var $cKvYK = parcelRequire("cKvYK");

var $28A5g = parcelRequire("28A5g");
const $9ccfb6715ccec8e4$var$ApiErrorMessage = ({ error: error, message: message = "Une erreur est survenue :" })=>{
    const errorMessage = Array.isArray(error) ? error.map((error)=>error.statusText).filter(Boolean).join(", ") : error.statusText;
    return /*#__PURE__*/ (0, $cKvYK.jsx)((0, $28A5g.default), {
        type: "error",
        message: `${message} ${errorMessage}`
    });
};
var $9ccfb6715ccec8e4$export$2e2bcd8739ae039 = $9ccfb6715ccec8e4$var$ApiErrorMessage;

});
parcelRegister("28A5g", function(module, exports) {

$parcel$export(module.exports, "default", () => $d67392b698dafac5$export$2e2bcd8739ae039);

var $cKvYK = parcelRequire("cKvYK");

var $lgiU2 = parcelRequire("lgiU2");

var $6Ot8n = parcelRequire("6Ot8n");
const $d67392b698dafac5$var$Message = ({ message: message, type: type })=>{
    if (!message) return null;
    return /*#__PURE__*/ (0, $cKvYK.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($lgiU2)))((0, (/*@__PURE__*/$parcel$interopDefault($6Ot8n))).message, (0, (/*@__PURE__*/$parcel$interopDefault($6Ot8n)))[type]),
        children: message
    });
};
var $d67392b698dafac5$var$TYPE_MESSAGE;
(function(TYPE_MESSAGE) {
    TYPE_MESSAGE[TYPE_MESSAGE["info"] = 0] = "info";
    TYPE_MESSAGE[TYPE_MESSAGE["success"] = 1] = "success";
    TYPE_MESSAGE[TYPE_MESSAGE["error"] = 2] = "error";
    TYPE_MESSAGE[TYPE_MESSAGE["warning"] = 3] = "warning";
})($d67392b698dafac5$var$TYPE_MESSAGE || ($d67392b698dafac5$var$TYPE_MESSAGE = {}));
var $d67392b698dafac5$export$2e2bcd8739ae039 = $d67392b698dafac5$var$Message;

});
parcelRegister("6Ot8n", function(module, exports) {

$parcel$export(module.exports, "error", () => $4f5e02fef943de84$export$a3bc9b8ed74fc, (v) => $4f5e02fef943de84$export$a3bc9b8ed74fc = v);
$parcel$export(module.exports, "info", () => $4f5e02fef943de84$export$a80b3bd66acc52ff, (v) => $4f5e02fef943de84$export$a80b3bd66acc52ff = v);
$parcel$export(module.exports, "message", () => $4f5e02fef943de84$export$a8ecead220dd38a6, (v) => $4f5e02fef943de84$export$a8ecead220dd38a6 = v);
$parcel$export(module.exports, "success", () => $4f5e02fef943de84$export$fe7c49d056ea1d88, (v) => $4f5e02fef943de84$export$fe7c49d056ea1d88 = v);
$parcel$export(module.exports, "warning", () => $4f5e02fef943de84$export$491112666e282270, (v) => $4f5e02fef943de84$export$491112666e282270 = v);
var $4f5e02fef943de84$export$a3bc9b8ed74fc;
var $4f5e02fef943de84$export$a80b3bd66acc52ff;
var $4f5e02fef943de84$export$a8ecead220dd38a6;
var $4f5e02fef943de84$export$fe7c49d056ea1d88;
var $4f5e02fef943de84$export$491112666e282270;
$4f5e02fef943de84$export$a3bc9b8ed74fc = `yTUXNW_error`;
$4f5e02fef943de84$export$a80b3bd66acc52ff = `yTUXNW_info`;
$4f5e02fef943de84$export$a8ecead220dd38a6 = `yTUXNW_message`;
$4f5e02fef943de84$export$fe7c49d056ea1d88 = `yTUXNW_success`;
$4f5e02fef943de84$export$491112666e282270 = `yTUXNW_warning`;

});





parcelRegister("iQGzH", function(module, exports) {

$parcel$export(module.exports, "button", () => $db8e1bd04e14a575$export$2ba01fb71ed41cb6, (v) => $db8e1bd04e14a575$export$2ba01fb71ed41cb6 = v);
$parcel$export(module.exports, "close", () => $db8e1bd04e14a575$export$8360e631d277ea4d, (v) => $db8e1bd04e14a575$export$8360e631d277ea4d = v);
$parcel$export(module.exports, "description", () => $db8e1bd04e14a575$export$6d59db4903f20f7d, (v) => $db8e1bd04e14a575$export$6d59db4903f20f7d = v);
$parcel$export(module.exports, "iconSave", () => $db8e1bd04e14a575$export$f84293d3bf7eab2d, (v) => $db8e1bd04e14a575$export$f84293d3bf7eab2d = v);
$parcel$export(module.exports, "previewCell", () => $db8e1bd04e14a575$export$ef2c6efdcd47bc05, (v) => $db8e1bd04e14a575$export$ef2c6efdcd47bc05 = v);
$parcel$export(module.exports, "reactSelect", () => $db8e1bd04e14a575$export$d4b5f7d1d71beeb6, (v) => $db8e1bd04e14a575$export$d4b5f7d1d71beeb6 = v);
$parcel$export(module.exports, "selectInput", () => $db8e1bd04e14a575$export$4f502711de93d534, (v) => $db8e1bd04e14a575$export$4f502711de93d534 = v);
$parcel$export(module.exports, "titleComponent", () => $db8e1bd04e14a575$export$9679d59b88da709e, (v) => $db8e1bd04e14a575$export$9679d59b88da709e = v);
$parcel$export(module.exports, "titleInput", () => $db8e1bd04e14a575$export$298cb88e8196ab50, (v) => $db8e1bd04e14a575$export$298cb88e8196ab50 = v);
var $db8e1bd04e14a575$export$2ba01fb71ed41cb6;
var $db8e1bd04e14a575$export$8360e631d277ea4d;
var $db8e1bd04e14a575$export$6d59db4903f20f7d;
var $db8e1bd04e14a575$export$f84293d3bf7eab2d;
var $db8e1bd04e14a575$export$ef2c6efdcd47bc05;
var $db8e1bd04e14a575$export$d4b5f7d1d71beeb6;
var $db8e1bd04e14a575$export$4f502711de93d534;
var $db8e1bd04e14a575$export$9679d59b88da709e;
var $db8e1bd04e14a575$export$298cb88e8196ab50;
$db8e1bd04e14a575$export$2ba01fb71ed41cb6 = `t2aT8a_button`;
$db8e1bd04e14a575$export$8360e631d277ea4d = `t2aT8a_close`;
$db8e1bd04e14a575$export$6d59db4903f20f7d = `t2aT8a_description`;
$db8e1bd04e14a575$export$f84293d3bf7eab2d = `t2aT8a_iconSave`;
$db8e1bd04e14a575$export$ef2c6efdcd47bc05 = `t2aT8a_previewCell`;
$db8e1bd04e14a575$export$d4b5f7d1d71beeb6 = `t2aT8a_reactSelect`;
$db8e1bd04e14a575$export$4f502711de93d534 = `t2aT8a_selectInput`;
$db8e1bd04e14a575$export$9679d59b88da709e = `t2aT8a_titleComponent`;
$db8e1bd04e14a575$export$298cb88e8196ab50 = `t2aT8a_titleInput`;

});


parcelRegister("8p7Tx", function(module, exports) {

$parcel$export(module.exports, "initialFilterValues", () => $4c1bec2a3009a10a$export$102a5bde4d4c9834);
$parcel$export(module.exports, "filterValuesToVariable", () => $4c1bec2a3009a10a$export$6f2fda70fe261d2e);
$parcel$export(module.exports, "default", () => $4c1bec2a3009a10a$export$2e2bcd8739ae039);

var $cKvYK = parcelRequire("cKvYK");

var $fZS5j = parcelRequire("fZS5j");

var $aiICO = parcelRequire("aiICO");
const $4c1bec2a3009a10a$export$102a5bde4d4c9834 = {
    ressourceLibelle: ""
};
const $4c1bec2a3009a10a$export$6f2fda70fe261d2e = ({ ressourceLibelle: ressourceLibelle })=>{
    const filter = {};
    if (ressourceLibelle != null && ressourceLibelle.trim() !== "") filter.ressourceLibelle = ressourceLibelle;
    return filter;
};
const $4c1bec2a3009a10a$var$FiltreRessources = ()=>{
    return /*#__PURE__*/ (0, $cKvYK.jsx)((0, $fZS5j.default), {
        children: /*#__PURE__*/ (0, $cKvYK.jsx)((0, $fZS5j.FilterFields), {
            children: /*#__PURE__*/ (0, $cKvYK.jsx)((0, $fZS5j.FilterRow), {
                children: /*#__PURE__*/ (0, $cKvYK.jsx)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($aiICO))).filterItem,
                    children: /*#__PURE__*/ (0, $cKvYK.jsx)((0, $fZS5j.FilterText), {
                        label: "",
                        "aria-labelledby": "recherche-ressource",
                        placeholder: "Rechercher par titre...",
                        name: "ressourceLibelle"
                    })
                })
            })
        })
    });
};
var $4c1bec2a3009a10a$export$2e2bcd8739ae039 = $4c1bec2a3009a10a$var$FiltreRessources;

});
parcelRegister("fZS5j", function(module, exports) {

$parcel$export(module.exports, "default", () => $c63cc53a9be5bc28$export$2e2bcd8739ae039);
$parcel$export(module.exports, "FilterFields", () => $c63cc53a9be5bc28$export$e38c2fbdcbc20613);
$parcel$export(module.exports, "FilterRow", () => $c63cc53a9be5bc28$export$e9b6b83ea1258694);
$parcel$export(module.exports, "FilterText", () => $c63cc53a9be5bc28$export$90af02fae19763f9);
$parcel$export(module.exports, "FilterNumber", () => $c63cc53a9be5bc28$export$1e76be4e5260ba73);
$parcel$export(module.exports, "FilterMultiSelect", () => $c63cc53a9be5bc28$export$f7235c4a2781a7fe);

var $cKvYK = parcelRequire("cKvYK");

var $4DyxQ = parcelRequire("4DyxQ");
var $469X3 = parcelRequire("469X3");

var $lgiU2 = parcelRequire("lgiU2");

var $3BicN = parcelRequire("3BicN");

var $bNJBP = parcelRequire("bNJBP");

var $9uP0g = parcelRequire("9uP0g");
const $c63cc53a9be5bc28$var$Filter = ({ children: children, right: right })=>{
    return /*#__PURE__*/ (0, $cKvYK.jsx)("div", {
        children: /*#__PURE__*/ (0, $cKvYK.jsx)($c63cc53a9be5bc28$export$7db8a919102c471b, {
            children: /*#__PURE__*/ (0, $cKvYK.jsxs)((0, $469X3.default), {
                className: "mb-3",
                children: [
                    children && /*#__PURE__*/ (0, $cKvYK.jsx)((0, $4DyxQ.default), {
                        xs: 12,
                        className: "d-flex flex-row justify-content-center",
                        children: /*#__PURE__*/ (0, $cKvYK.jsx)((0, $469X3.default), {
                            className: "text-center",
                            children: children
                        })
                    }),
                    right && /*#__PURE__*/ (0, $cKvYK.jsx)((0, $4DyxQ.default), {
                        xs: 12,
                        className: "d-flex flex-row justify-content-center",
                        children: /*#__PURE__*/ (0, $cKvYK.jsx)((0, $469X3.default), {
                            className: "text-center",
                            children: right
                        })
                    })
                ]
            })
        })
    });
};
var $c63cc53a9be5bc28$export$2e2bcd8739ae039 = $c63cc53a9be5bc28$var$Filter;
const $c63cc53a9be5bc28$export$7db8a919102c471b = (props)=>/*#__PURE__*/ (0, $cKvYK.jsx)((0, $3BicN.Form), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9uP0g))).filterForm,
        ...props
    });
const $c63cc53a9be5bc28$export$e38c2fbdcbc20613 = (0, $bNJBP.makeTemplateComponent)("div", (0, (/*@__PURE__*/$parcel$interopDefault($9uP0g))).filterFields);
const $c63cc53a9be5bc28$export$3f99c39fb9e91707 = (0, $bNJBP.makeTemplateComponent)("div", (0, (/*@__PURE__*/$parcel$interopDefault($9uP0g))).filterButtons);
const $c63cc53a9be5bc28$export$e9b6b83ea1258694 = (0, $bNJBP.makeTemplateComponent)("div", (0, (/*@__PURE__*/$parcel$interopDefault($9uP0g))).filterRow);
const $c63cc53a9be5bc28$var$FilterInput = ({ children: children, label: label, className: className })=>/*#__PURE__*/ (0, $cKvYK.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($lgiU2)))((0, (/*@__PURE__*/$parcel$interopDefault($9uP0g))).filter_group, className),
        children: [
            /*#__PURE__*/ (0, $cKvYK.jsx)("label", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($9uP0g))).label,
                children: label
            }),
            children
        ]
    });
const $c63cc53a9be5bc28$export$90af02fae19763f9 = ({ label: label, submitable: submitable, ...rest })=>/*#__PURE__*/ (0, $cKvYK.jsx)($c63cc53a9be5bc28$var$FilterInput, {
        label: label,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9uP0g))).filterText,
        children: /*#__PURE__*/ (0, $cKvYK.jsx)((0, $3BicN.Text), {
            ...rest,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($9uP0g))).filterInput,
            submitable: submitable
        })
    });
const $c63cc53a9be5bc28$export$1e76be4e5260ba73 = ({ label: label, ...rest })=>/*#__PURE__*/ (0, $cKvYK.jsx)($c63cc53a9be5bc28$var$FilterInput, {
        label: label,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9uP0g))).filterNumber,
        children: /*#__PURE__*/ (0, $cKvYK.jsx)((0, $3BicN.NumberField), {
            ...rest,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($9uP0g))).filterInput
        })
    });
const $c63cc53a9be5bc28$export$92fd2cf1e922f57b = ({ label: label, ...rest })=>/*#__PURE__*/ (0, $cKvYK.jsx)($c63cc53a9be5bc28$var$FilterInput, {
        label: label,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9uP0g))).filterSelect,
        children: /*#__PURE__*/ (0, $cKvYK.jsx)((0, $3BicN.SelectInput), {
            ...rest,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($9uP0g))).filterInput
        })
    });
const $c63cc53a9be5bc28$export$f7235c4a2781a7fe = ({ label: label, ...rest })=>/*#__PURE__*/ (0, $cKvYK.jsx)($c63cc53a9be5bc28$var$FilterInput, {
        label: label,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9uP0g))).filterSelect,
        children: /*#__PURE__*/ (0, $cKvYK.jsx)((0, $3BicN.MultiSelectInput), {
            ...rest,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($9uP0g))).filterInput
        })
    });
const $c63cc53a9be5bc28$export$95ded5967d9cd22d = (props)=>/*#__PURE__*/ (0, $cKvYK.jsx)($c63cc53a9be5bc28$export$92fd2cf1e922f57b, {
        ...props,
        options: [
            {
                id: true,
                label: "Oui"
            },
            {
                id: false,
                label: "Non"
            }
        ],
        toOptionLabelFunc: (e)=>e.label
    });

});
parcelRegister("9uP0g", function(module, exports) {

$parcel$export(module.exports, "filterButtons", () => $6e9e7a9af2addca0$export$4c396c7e5aec5550, (v) => $6e9e7a9af2addca0$export$4c396c7e5aec5550 = v);
$parcel$export(module.exports, "filterDropdownButton", () => $6e9e7a9af2addca0$export$6803a1bcaac90369, (v) => $6e9e7a9af2addca0$export$6803a1bcaac90369 = v);
$parcel$export(module.exports, "filterDropdownPanel", () => $6e9e7a9af2addca0$export$b547056c89124b8d, (v) => $6e9e7a9af2addca0$export$b547056c89124b8d = v);
$parcel$export(module.exports, "filterFields", () => $6e9e7a9af2addca0$export$488edbb91e4d1f17, (v) => $6e9e7a9af2addca0$export$488edbb91e4d1f17 = v);
$parcel$export(module.exports, "filterForm", () => $6e9e7a9af2addca0$export$7bc7d430bde1a148, (v) => $6e9e7a9af2addca0$export$7bc7d430bde1a148 = v);
$parcel$export(module.exports, "filterInput", () => $6e9e7a9af2addca0$export$4f512692da3ee37d, (v) => $6e9e7a9af2addca0$export$4f512692da3ee37d = v);
$parcel$export(module.exports, "filterNumber", () => $6e9e7a9af2addca0$export$3f5d7ef337b5c928, (v) => $6e9e7a9af2addca0$export$3f5d7ef337b5c928 = v);
$parcel$export(module.exports, "filterRow", () => $6e9e7a9af2addca0$export$58c9fd6b8a6e3f69, (v) => $6e9e7a9af2addca0$export$58c9fd6b8a6e3f69 = v);
$parcel$export(module.exports, "filterSelect", () => $6e9e7a9af2addca0$export$3fd87dc5a8e4b986, (v) => $6e9e7a9af2addca0$export$3fd87dc5a8e4b986 = v);
$parcel$export(module.exports, "filterText", () => $6e9e7a9af2addca0$export$dac863774b2ab841, (v) => $6e9e7a9af2addca0$export$dac863774b2ab841 = v);
$parcel$export(module.exports, "filter_group", () => $6e9e7a9af2addca0$export$d93d15aa419508e, (v) => $6e9e7a9af2addca0$export$d93d15aa419508e = v);
$parcel$export(module.exports, "filters", () => $6e9e7a9af2addca0$export$82462a21aead86ed, (v) => $6e9e7a9af2addca0$export$82462a21aead86ed = v);
$parcel$export(module.exports, "label", () => $6e9e7a9af2addca0$export$1237798dc640739a, (v) => $6e9e7a9af2addca0$export$1237798dc640739a = v);
$parcel$export(module.exports, "left", () => $6e9e7a9af2addca0$export$eabcd2c8791e7bf4, (v) => $6e9e7a9af2addca0$export$eabcd2c8791e7bf4 = v);
$parcel$export(module.exports, "mainFilterContent", () => $6e9e7a9af2addca0$export$a88f7f04d9296417, (v) => $6e9e7a9af2addca0$export$a88f7f04d9296417 = v);
$parcel$export(module.exports, "open", () => $6e9e7a9af2addca0$export$3ce6949f20cea765, (v) => $6e9e7a9af2addca0$export$3ce6949f20cea765 = v);
$parcel$export(module.exports, "right", () => $6e9e7a9af2addca0$export$79ffe56a765070d2, (v) => $6e9e7a9af2addca0$export$79ffe56a765070d2 = v);
var $6e9e7a9af2addca0$export$4c396c7e5aec5550;
var $6e9e7a9af2addca0$export$6803a1bcaac90369;
var $6e9e7a9af2addca0$export$b547056c89124b8d;
var $6e9e7a9af2addca0$export$488edbb91e4d1f17;
var $6e9e7a9af2addca0$export$7bc7d430bde1a148;
var $6e9e7a9af2addca0$export$4f512692da3ee37d;
var $6e9e7a9af2addca0$export$3f5d7ef337b5c928;
var $6e9e7a9af2addca0$export$58c9fd6b8a6e3f69;
var $6e9e7a9af2addca0$export$3fd87dc5a8e4b986;
var $6e9e7a9af2addca0$export$dac863774b2ab841;
var $6e9e7a9af2addca0$export$d93d15aa419508e;
var $6e9e7a9af2addca0$export$82462a21aead86ed;
var $6e9e7a9af2addca0$export$1237798dc640739a;
var $6e9e7a9af2addca0$export$eabcd2c8791e7bf4;
var $6e9e7a9af2addca0$export$a88f7f04d9296417;
var $6e9e7a9af2addca0$export$3ce6949f20cea765;
var $6e9e7a9af2addca0$export$79ffe56a765070d2;
$6e9e7a9af2addca0$export$4c396c7e5aec5550 = `l563Ma_filterButtons`;
$6e9e7a9af2addca0$export$6803a1bcaac90369 = `l563Ma_filterDropdownButton`;
$6e9e7a9af2addca0$export$b547056c89124b8d = `l563Ma_filterDropdownPanel`;
$6e9e7a9af2addca0$export$488edbb91e4d1f17 = `l563Ma_filterFields`;
$6e9e7a9af2addca0$export$7bc7d430bde1a148 = `l563Ma_filterForm`;
$6e9e7a9af2addca0$export$4f512692da3ee37d = `l563Ma_filterInput`;
$6e9e7a9af2addca0$export$3f5d7ef337b5c928 = `l563Ma_filterNumber`;
$6e9e7a9af2addca0$export$58c9fd6b8a6e3f69 = `l563Ma_filterRow`;
$6e9e7a9af2addca0$export$3fd87dc5a8e4b986 = `l563Ma_filterSelect`;
$6e9e7a9af2addca0$export$dac863774b2ab841 = `l563Ma_filterText`;
$6e9e7a9af2addca0$export$d93d15aa419508e = `l563Ma_filter_group`;
$6e9e7a9af2addca0$export$82462a21aead86ed = `l563Ma_filters`;
$6e9e7a9af2addca0$export$1237798dc640739a = `l563Ma_label`;
$6e9e7a9af2addca0$export$eabcd2c8791e7bf4 = `l563Ma_left`;
$6e9e7a9af2addca0$export$a88f7f04d9296417 = `l563Ma_mainFilterContent`;
$6e9e7a9af2addca0$export$3ce6949f20cea765 = `l563Ma_open`;
$6e9e7a9af2addca0$export$79ffe56a765070d2 = `l563Ma_right`;

});


parcelRegister("aiICO", function(module, exports) {

$parcel$export(module.exports, "buttonsDiv", () => $77fe337083b49567$export$f08d8e7ed913fbf, (v) => $77fe337083b49567$export$f08d8e7ed913fbf = v);
$parcel$export(module.exports, "previewCell", () => $77fe337083b49567$export$ef2c6efdcd47bc05, (v) => $77fe337083b49567$export$ef2c6efdcd47bc05 = v);
var $77fe337083b49567$export$f08d8e7ed913fbf;
var $77fe337083b49567$export$ef2c6efdcd47bc05;
$77fe337083b49567$export$f08d8e7ed913fbf = `Ip2QGG_buttonsDiv`;
$77fe337083b49567$export$ef2c6efdcd47bc05 = `Ip2QGG_previewCell`;

});



parcelRegister("foRY0", function(module, exports) {

$parcel$export(module.exports, "default", () => $354e33e4c6f40dab$export$2e2bcd8739ae039);

var $cKvYK = parcelRequire("cKvYK");

var $7hZVf = parcelRequire("7hZVf");

var $eqMOn = parcelRequire("eqMOn");

var $bNJBP = parcelRequire("bNJBP");

var $4VCRM = parcelRequire("4VCRM");

var $hpOSz = parcelRequire("hpOSz");

var $6Sma1 = parcelRequire("6Sma1");

var $evPIN = parcelRequire("evPIN");

var $5TbRy = parcelRequire("5TbRy");

var $c319f = parcelRequire("c319f");
const $354e33e4c6f40dab$var$ListUtilisateurs = ()=>{
    const { user: user } = (0, $eqMOn.useAppContext)();
    return /*#__PURE__*/ (0, $cKvYK.jsxs)((0, $cKvYK.Fragment), {
        children: [
            /*#__PURE__*/ (0, $cKvYK.jsx)((0, $4VCRM.default), {
                icon: /*#__PURE__*/ (0, $cKvYK.jsx)((0, $hpOSz.IconUsers), {}),
                title: "Gestion des utilisateurs"
            }),
            /*#__PURE__*/ (0, $cKvYK.jsx)((0, $bNJBP.PageContent), {
                children: /*#__PURE__*/ (0, $cKvYK.jsx)((0, $evPIN.default), {
                    idName: "utilisateurs",
                    query: (0, $5TbRy.default)`/api/utilisateurs`,
                    filterComponent: /*#__PURE__*/ (0, $cKvYK.jsx)((0, $cKvYK.Fragment), {
                        children: /*#__PURE__*/ (0, $cKvYK.jsx)((0, $c319f.default), {})
                    }),
                    initialFilterValues: (0, $c319f.initialFilterValues),
                    filterValuesToVariable: (0, $c319f.filterValuesToVariable),
                    columns: [
                        {
                            Header: "Identifiant",
                            accessor: "username",
                            sortField: "username"
                        },
                        {
                            Header: "R\xf4les",
                            accessor: ({ listRole: listRole })=>{
                                return {
                                    listRole: listRole
                                };
                            },
                            // eslint-disable-next-line react/display-name
                            Cell: (row)=>{
                                return /*#__PURE__*/ (0, $cKvYK.jsx)("div", {
                                    children: row.value.listRole.map((e)=>e.roleLibelle).join(", ")
                                });
                            },
                            sortField: "roleUtilisateur"
                        },
                        ...user.isAdministrateur ? [
                            (0, $6Sma1.default)({
                                to: (utilisateurId)=>(0, $7hZVf.URLS).UPDATE_ROLE_UTILISATEUR(utilisateurId),
                                title: true,
                                accessor: "utilisateurId",
                                canEditFunction: (value)=>{
                                    return user.idUtilisateur === value ? false : true;
                                }
                            }),
                            (0, $6Sma1.ActiveDesactiveColumn)({
                                path: (0, $5TbRy.default)`/api/utilisateurs/inactif/`,
                                title: true,
                                headerActif: "D\xe9sactiver l'utilisateur",
                                headerInactif: "Activer l'utilisateur",
                                contentActif: "Voulez-vous vraiment d\xe9sactiver cet utilisateur ?",
                                contentInactif: "Voulez-vous vraiment activer cet utilisateur ?",
                                canDesactiveFunction: (value)=>{
                                    return user.idUtilisateur === value ? false : true;
                                },
                                accessor: "utilisateurId"
                            })
                        ] : []
                    ]
                })
            })
        ]
    });
};
var $354e33e4c6f40dab$export$2e2bcd8739ae039 = $354e33e4c6f40dab$var$ListUtilisateurs;

});
parcelRegister("c319f", function(module, exports) {

$parcel$export(module.exports, "initialFilterValues", () => $006586254668b37a$export$102a5bde4d4c9834);
$parcel$export(module.exports, "filterValuesToVariable", () => $006586254668b37a$export$6f2fda70fe261d2e);
$parcel$export(module.exports, "default", () => $006586254668b37a$export$2e2bcd8739ae039);

var $cKvYK = parcelRequire("cKvYK");

var $4DyxQ = parcelRequire("4DyxQ");

var $fZS5j = parcelRequire("fZS5j");

var $26Ddr = parcelRequire("26Ddr");

var $5TbRy = parcelRequire("5TbRy");

var $bYYyU = parcelRequire("bYYyU");

var $7hZVf = parcelRequire("7hZVf");

var $hpOSz = parcelRequire("hpOSz");
const $006586254668b37a$export$102a5bde4d4c9834 = {
    utilisateurUsername: "",
    rolesIds: null
};
const $006586254668b37a$export$6f2fda70fe261d2e = ({ utilisateurUsername: utilisateurUsername, roles: roles })=>{
    const filter = {};
    if (utilisateurUsername != null && utilisateurUsername.trim() !== "") filter.utilisateurUsername = utilisateurUsername;
    if (roles != null && roles.length > 0) filter.rolesIds = roles.map((e)=>e.roleId);
    return filter;
};
const $006586254668b37a$var$FilterUtilisateurs = ()=>{
    const stateListRole = (0, $26Ddr.useGet)((0, $5TbRy.default)`/api/roles/`);
    return /*#__PURE__*/ (0, $cKvYK.jsx)((0, $fZS5j.default), {
        right: /*#__PURE__*/ (0, $cKvYK.jsxs)((0, $cKvYK.Fragment), {
            children: [
                /*#__PURE__*/ (0, $cKvYK.jsx)((0, $4DyxQ.default), {
                    className: "my-auto",
                    children: /*#__PURE__*/ (0, $cKvYK.jsxs)((0, $bYYyU.LinkButton), {
                        href: (0, $7hZVf.URLS).CREATE_ROLE_UTILISATEUR,
                        variant: (0, $bYYyU.VARIANTS).secondary,
                        className: "text-nowrap",
                        children: [
                            /*#__PURE__*/ (0, $cKvYK.jsx)((0, $hpOSz.IconAddUser), {}),
                            " Ajouter un utilisateur"
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $cKvYK.jsx)((0, $4DyxQ.default), {
                    className: "my-auto",
                    children: /*#__PURE__*/ (0, $cKvYK.jsxs)((0, $bYYyU.LinkButton), {
                        href: (0, $7hZVf.URLS).IMPORT_UTILISATEUR,
                        variant: (0, $bYYyU.VARIANTS).secondary,
                        className: "text-nowrap",
                        children: [
                            /*#__PURE__*/ (0, $cKvYK.jsx)((0, $hpOSz.IconAddUsers), {}),
                            " Importer des utilisateurs"
                        ]
                    })
                })
            ]
        }),
        children: /*#__PURE__*/ (0, $cKvYK.jsxs)((0, $cKvYK.Fragment), {
            children: [
                /*#__PURE__*/ (0, $cKvYK.jsxs)((0, $4DyxQ.default), {
                    className: "my-auto",
                    children: [
                        /*#__PURE__*/ (0, $cKvYK.jsx)((0, $fZS5j.FilterText), {
                            label: "",
                            "aria-labelledby": "recherche-utilisateur",
                            placeholder: "Recherche un utilisateur",
                            name: "utilisateurUsername"
                        }),
                        /*#__PURE__*/ (0, $cKvYK.jsx)("p", {
                            id: "recherche-utilisateur",
                            className: "d-none",
                            children: "Rechercher un utilisateur"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $cKvYK.jsxs)((0, $4DyxQ.default), {
                    className: "my-auto",
                    children: [
                        /*#__PURE__*/ (0, $cKvYK.jsx)((0, $fZS5j.FilterMultiSelect), {
                            label: "",
                            "aria-labelledby": "filtrer-roles",
                            name: "roles",
                            placeholder: "Filtrer par r\xf4les",
                            options: stateListRole.value,
                            getOptionValue: (r)=>r.roleId,
                            toOptionLabelFunc: (r)=>r.roleLibelle,
                            isClearable: true
                        }),
                        /*#__PURE__*/ (0, $cKvYK.jsx)("p", {
                            id: "filtrer-roles",
                            className: "d-none",
                            children: "Filtrer par r\xf4les"
                        })
                    ]
                })
            ]
        })
    });
};
var $006586254668b37a$export$2e2bcd8739ae039 = $006586254668b37a$var$FilterUtilisateurs;

});


parcelRegister("9dFAr", function(module, exports) {

$parcel$export(module.exports, "default", () => $49376474de4228ea$export$2e2bcd8739ae039);

var $cKvYK = parcelRequire("cKvYK");

var $aw9wE = parcelRequire("aw9wE");

var $ijxZJ = parcelRequire("ijxZJ");

var $26Ddr = parcelRequire("26Ddr");

var $5TbRy = parcelRequire("5TbRy");

var $gS6pX = parcelRequire("gS6pX");
const $49376474de4228ea$var$UpdateRoleUtilisateur = ()=>{
    const { utilisateurId: utilisateurId } = (0, $aw9wE.useParams)();
    const utilisateurRoleState = (0, $26Ddr.useGet)((0, $5TbRy.default)`/api/utilisateurs/${utilisateurId}`);
    if (!utilisateurRoleState.isResolved) return;
    const { data: data } = utilisateurRoleState;
    return /*#__PURE__*/ (0, $cKvYK.jsx)((0, $ijxZJ.default), {
        initialValues: (0, $gS6pX.getInitialValues)(data),
        validationSchema: (0, $gS6pX.validationSchema),
        isPost: true,
        submitUrl: `/api/utilisateurs/${utilisateurId}`,
        prepareVariables: (values)=>(0, $gS6pX.prepareVariables)(data, values),
        children: /*#__PURE__*/ (0, $cKvYK.jsx)((0, $gS6pX.default), {
            isNew: false
        })
    });
};
var $49376474de4228ea$export$2e2bcd8739ae039 = $49376474de4228ea$var$UpdateRoleUtilisateur;

});

parcelRegister("2ezz3", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1de3b6399c19d22$export$2e2bcd8739ae039);

var $cKvYK = parcelRequire("cKvYK");

var $l6nxk = parcelRequire("l6nxk");

var $bNJBP = parcelRequire("bNJBP");

var $4VCRM = parcelRequire("4VCRM");

var $hpOSz = parcelRequire("hpOSz");

var $evPIN = parcelRequire("evPIN");

var $5TbRy = parcelRequire("5TbRy");

var $c67Lz = parcelRequire("c67Lz");

var $bUEub = parcelRequire("bUEub");
const $b1de3b6399c19d22$var$ExportLogConnexion = ()=>{
    const { filterBy: filterBy = [], sortBy: sortBy = [] } = (0, $c67Lz.default)();
    return /*#__PURE__*/ (0, $cKvYK.jsxs)((0, $cKvYK.Fragment), {
        children: [
            /*#__PURE__*/ (0, $cKvYK.jsx)((0, $4VCRM.default), {
                icon: /*#__PURE__*/ (0, $cKvYK.jsx)((0, $hpOSz.IconTable), {}),
                title: "Export des donn\xe9es"
            }),
            /*#__PURE__*/ (0, $cKvYK.jsx)((0, $bNJBP.PageContent), {
                children: /*#__PURE__*/ (0, $cKvYK.jsx)((0, $evPIN.default), {
                    isAutoSubmit: false,
                    idName: "connexionLogs",
                    query: (0, $5TbRy.default)`/api/exportLogConnexion/logs`,
                    filterComponent: /*#__PURE__*/ (0, $cKvYK.jsx)((0, $bUEub.default), {
                        filterBy: filterBy,
                        sortBy: sortBy
                    }),
                    initialFilterValues: (0, $bUEub.initialFilterValues),
                    filterValuesToVariable: (0, $bUEub.filterValuesToVariable),
                    columns: [
                        {
                            Header: "Identifiant",
                            accessor: "utilisateurUsername",
                            sortField: "utilisateurUsername"
                        },
                        {
                            Header: "R\xf4les",
                            accessor: "roleLibelle",
                            sortField: "roleUtilisateur"
                        },
                        {
                            Header: "Connexion",
                            accessor: ({ connexionDate: connexionDate })=>(0, $l6nxk.default)(connexionDate, "dd/MM/yyyy HH:mm"),
                            sortField: "connexionDate"
                        },
                        {
                            Header: "D\xe9connexion",
                            accessor: ({ deconnexionDate: deconnexionDate })=>deconnexionDate ? (0, $l6nxk.default)(deconnexionDate, "dd/MM/yyyy HH:mm") : null,
                            sortField: "deconnexionDate"
                        },
                        {
                            Header: "Dur\xe9e",
                            accessor: "formatedDuree",
                            sortField: "duree"
                        },
                        {
                            Header: "Contenus visit\xe9s",
                            accessor: ({ ressourcesConsultees: ressourcesConsultees })=>{
                                return {
                                    ressourcesConsultees: ressourcesConsultees
                                };
                            },
                            Cell: (row)=>{
                                return /*#__PURE__*/ (0, $cKvYK.jsx)("div", {
                                    children: row.value.ressourcesConsultees.map((e)=>e.ressourceLibelle).join(", ")
                                });
                            }
                        }
                    ]
                })
            })
        ]
    });
};
var $b1de3b6399c19d22$export$2e2bcd8739ae039 = $b1de3b6399c19d22$var$ExportLogConnexion;

});
parcelRegister("l6nxk", function(module, exports) {

$parcel$export(module.exports, "default", () => $de614a9312ac9d3d$export$2e2bcd8739ae039);

var $hkBw5 = parcelRequire("hkBw5");

var $lVZSl = parcelRequire("lVZSl");

var $f3Lp2 = parcelRequire("f3Lp2");

var $hLHKY = parcelRequire("hLHKY");

var $3zhEP = parcelRequire("3zhEP");

var $4m7Rs = parcelRequire("4m7Rs");

var $j23m7 = parcelRequire("j23m7");
// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const $de614a9312ac9d3d$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
const $de614a9312ac9d3d$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
const $de614a9312ac9d3d$var$escapedStringRegExp = /^'([^]*?)'?$/;
const $de614a9312ac9d3d$var$doubleQuoteRegExp = /''/g;
const $de614a9312ac9d3d$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $de614a9312ac9d3d$export$3ae94a2503e890a1(date, formatStr, options) {
    const defaultOptions = (0, $lVZSl.getDefaultOptions)();
    const locale = options?.locale ?? defaultOptions.locale ?? (0, $hkBw5.enUS);
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const originalDate = (0, $j23m7.toDate)(date);
    if (!(0, $4m7Rs.isValid)(originalDate)) throw new RangeError("Invalid time value");
    let parts = formatStr.match($de614a9312ac9d3d$var$longFormattingTokensRegExp).map((substring)=>{
        const firstCharacter = substring[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
            const longFormatter = (0, $hLHKY.longFormatters)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($de614a9312ac9d3d$var$formattingTokensRegExp).map((substring)=>{
        // Replace two single quote characters with one single quote character
        if (substring === "''") return {
            isToken: false,
            value: "'"
        };
        const firstCharacter = substring[0];
        if (firstCharacter === "'") return {
            isToken: false,
            value: $de614a9312ac9d3d$var$cleanEscapedString(substring)
        };
        if ((0, $f3Lp2.formatters)[firstCharacter]) return {
            isToken: true,
            value: substring
        };
        if (firstCharacter.match($de614a9312ac9d3d$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return {
            isToken: false,
            value: substring
        };
    });
    // invoke localize preprocessor (only for french locales at the moment)
    if (locale.localize.preprocessor) parts = locale.localize.preprocessor(originalDate, parts);
    const formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    return parts.map((part)=>{
        if (!part.isToken) return part.value;
        const token = part.value;
        if (!options?.useAdditionalWeekYearTokens && (0, $3zhEP.isProtectedWeekYearToken)(token) || !options?.useAdditionalDayOfYearTokens && (0, $3zhEP.isProtectedDayOfYearToken)(token)) (0, $3zhEP.warnOrThrowProtectedError)(token, formatStr, String(date));
        const formatter = (0, $f3Lp2.formatters)[token[0]];
        return formatter(originalDate, token, locale.localize, formatterOptions);
    }).join("");
}
function $de614a9312ac9d3d$var$cleanEscapedString(input) {
    const matched = input.match($de614a9312ac9d3d$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($de614a9312ac9d3d$var$doubleQuoteRegExp, "'");
}
var // Fallback for modularized imports:
$de614a9312ac9d3d$export$2e2bcd8739ae039 = $de614a9312ac9d3d$export$3ae94a2503e890a1;

});
parcelRegister("hkBw5", function(module, exports) {

$parcel$export(module.exports, "enUS", () => $68904599b0b1a04d$export$137380d9ce54f7f);

var $5tJbO = parcelRequire("5tJbO");

var $kY8pR = parcelRequire("kY8pR");

var $4XuUz = parcelRequire("4XuUz");

var $fVkEs = parcelRequire("fVkEs");

var $fTBUm = parcelRequire("fTBUm");
const $68904599b0b1a04d$export$137380d9ce54f7f = {
    code: "en-US",
    formatDistance: (0, $5tJbO.formatDistance),
    formatLong: (0, $kY8pR.formatLong),
    formatRelative: (0, $4XuUz.formatRelative),
    localize: (0, $fVkEs.localize),
    match: (0, $fTBUm.match),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var // Fallback for modularized imports:
$68904599b0b1a04d$export$2e2bcd8739ae039 = $68904599b0b1a04d$export$137380d9ce54f7f;

});
parcelRegister("5tJbO", function(module, exports) {

$parcel$export(module.exports, "formatDistance", () => $65e568eb2e1f3ca2$export$2c14ff85d6318973);
const $65e568eb2e1f3ca2$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
const $65e568eb2e1f3ca2$export$2c14ff85d6318973 = (token, count, options)=>{
    let result;
    const tokenValue = $65e568eb2e1f3ca2$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};

});

parcelRegister("kY8pR", function(module, exports) {

$parcel$export(module.exports, "formatLong", () => $79634567770d478c$export$cbf60ecb96cbb82f);

var $7Dxlf = parcelRequire("7Dxlf");
const $79634567770d478c$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
const $79634567770d478c$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $79634567770d478c$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $79634567770d478c$export$cbf60ecb96cbb82f = {
    date: (0, $7Dxlf.buildFormatLongFn)({
        formats: $79634567770d478c$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $7Dxlf.buildFormatLongFn)({
        formats: $79634567770d478c$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $7Dxlf.buildFormatLongFn)({
        formats: $79634567770d478c$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});
parcelRegister("7Dxlf", function(module, exports) {

$parcel$export(module.exports, "buildFormatLongFn", () => $a5a30e2105a08691$export$38e44e97ce4dbb7d);
function $a5a30e2105a08691$export$38e44e97ce4dbb7d(args) {
    return (options = {})=>{
        // TODO: Remove String()
        const width = options.width ? String(options.width) : args.defaultWidth;
        const format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}

});


parcelRegister("4XuUz", function(module, exports) {

$parcel$export(module.exports, "formatRelative", () => $11d050d5d4872962$export$8fbbfd65594f46a0);
const $11d050d5d4872962$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
const $11d050d5d4872962$export$8fbbfd65594f46a0 = (token, _date, _baseDate, _options)=>$11d050d5d4872962$var$formatRelativeLocale[token];

});

parcelRegister("fVkEs", function(module, exports) {

$parcel$export(module.exports, "localize", () => $ea4f099f40f948a8$export$b3bd0bc58e36cd63);

var $cJ3Ig = parcelRequire("cJ3Ig");
const $ea4f099f40f948a8$var$eraValues = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
const $ea4f099f40f948a8$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const $ea4f099f40f948a8$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
const $ea4f099f40f948a8$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
const $ea4f099f40f948a8$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
const $ea4f099f40f948a8$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
const $ea4f099f40f948a8$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    const rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
    }
    return number + "th";
};
const $ea4f099f40f948a8$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $ea4f099f40f948a8$var$ordinalNumber,
    era: (0, $cJ3Ig.buildLocalizeFn)({
        values: $ea4f099f40f948a8$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $cJ3Ig.buildLocalizeFn)({
        values: $ea4f099f40f948a8$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $cJ3Ig.buildLocalizeFn)({
        values: $ea4f099f40f948a8$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $cJ3Ig.buildLocalizeFn)({
        values: $ea4f099f40f948a8$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $cJ3Ig.buildLocalizeFn)({
        values: $ea4f099f40f948a8$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $ea4f099f40f948a8$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});
parcelRegister("cJ3Ig", function(module, exports) {

$parcel$export(module.exports, "buildLocalizeFn", () => $7a8f89edcd417b0e$export$63596d6ee8878b25);
/* eslint-disable no-unused-vars */ /**
 * The localize function argument callback which allows to convert raw value to
 * the actual type.
 *
 * @param value - The value to convert
 *
 * @returns The converted value
 */ /**
 * The map of localized values for each width.
 */ /**
 * The index type of the locale unit value. It types conversion of units of
 * values that don't start at 0 (i.e. quarters).
 */ /**
 * Converts the unit value to the tuple of values.
 */ /**
 * The tuple of localized era values. The first element represents BC,
 * the second element represents AD.
 */ /**
 * The tuple of localized quarter values. The first element represents Q1.
 */ /**
 * The tuple of localized day values. The first element represents Sunday.
 */ /**
 * The tuple of localized month values. The first element represents January.
 */ function $7a8f89edcd417b0e$export$63596d6ee8878b25(args) {
    return (value, options)=>{
        const context = options?.context ? String(options.context) : "standalone";
        let valuesArray;
        if (context === "formatting" && args.formattingValues) {
            const defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            const width = options?.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            const defaultWidth = args.defaultWidth;
            const width = options?.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[width] || args.values[defaultWidth];
        }
        const index = args.argumentCallback ? args.argumentCallback(value) : value;
        // @ts-expect-error - For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}

});


parcelRegister("fTBUm", function(module, exports) {

$parcel$export(module.exports, "match", () => $883ac70080548e26$export$4659b591c19bdf3d);

var $iypC7 = parcelRequire("iypC7");

var $bxAmt = parcelRequire("bxAmt");
const $883ac70080548e26$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
const $883ac70080548e26$var$parseOrdinalNumberPattern = /\d+/i;
const $883ac70080548e26$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
const $883ac70080548e26$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
const $883ac70080548e26$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
const $883ac70080548e26$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $883ac70080548e26$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
const $883ac70080548e26$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $883ac70080548e26$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
const $883ac70080548e26$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
const $883ac70080548e26$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
const $883ac70080548e26$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
const $883ac70080548e26$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $bxAmt.buildMatchPatternFn)({
        matchPattern: $883ac70080548e26$var$matchOrdinalNumberPattern,
        parsePattern: $883ac70080548e26$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $iypC7.buildMatchFn)({
        matchPatterns: $883ac70080548e26$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $883ac70080548e26$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $iypC7.buildMatchFn)({
        matchPatterns: $883ac70080548e26$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $883ac70080548e26$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $iypC7.buildMatchFn)({
        matchPatterns: $883ac70080548e26$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $883ac70080548e26$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $iypC7.buildMatchFn)({
        matchPatterns: $883ac70080548e26$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $883ac70080548e26$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $iypC7.buildMatchFn)({
        matchPatterns: $883ac70080548e26$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $883ac70080548e26$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});
parcelRegister("iypC7", function(module, exports) {

$parcel$export(module.exports, "buildMatchFn", () => $d6559435d2361a76$export$1430a0f35710914d);
function $d6559435d2361a76$export$1430a0f35710914d(args) {
    return (string, options = {})=>{
        const width = options.width;
        const matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        const matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        const key = Array.isArray(parsePatterns) ? $d6559435d2361a76$var$findIndex(parsePatterns, (pattern)=>pattern.test(matchedString)) : $d6559435d2361a76$var$findKey(parsePatterns, (pattern)=>pattern.test(matchedString));
        let value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $d6559435d2361a76$var$findKey(object, predicate) {
    for(const key in object){
        if (Object.prototype.hasOwnProperty.call(object, key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $d6559435d2361a76$var$findIndex(array, predicate) {
    for(let key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}

});

parcelRegister("bxAmt", function(module, exports) {

$parcel$export(module.exports, "buildMatchPatternFn", () => $e6e6a55b57b3017f$export$fdaf2fd6d7edde95);
function $e6e6a55b57b3017f$export$fdaf2fd6d7edde95(args) {
    return (string, options = {})=>{
        const matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        let value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}

});



parcelRegister("lVZSl", function(module, exports) {

$parcel$export(module.exports, "getDefaultOptions", () => $085078f5da2370ca$export$430a3269e24b912e);
let $085078f5da2370ca$var$defaultOptions = {};
function $085078f5da2370ca$export$430a3269e24b912e() {
    return $085078f5da2370ca$var$defaultOptions;
}
function $085078f5da2370ca$export$95365be1b0704abc(newOptions) {
    $085078f5da2370ca$var$defaultOptions = newOptions;
}

});

parcelRegister("f3Lp2", function(module, exports) {

$parcel$export(module.exports, "formatters", () => $2e9eea8aa22a7409$export$fe98a034cfb96d55);

var $lSCzG = parcelRequire("lSCzG");

var $bwgGY = parcelRequire("bwgGY");

var $5iQfp = parcelRequire("5iQfp");

var $2knb9 = parcelRequire("2knb9");

var $e8Oa4 = parcelRequire("e8Oa4");

var $dF9D7 = parcelRequire("dF9D7");

var $nIkU6 = parcelRequire("nIkU6");
const $2e9eea8aa22a7409$var$dayPeriodEnum = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
};
const $2e9eea8aa22a7409$export$fe98a034cfb96d55 = {
    // Era
    G: function(date, token, localize) {
        const era = date.getFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return localize.era(era, {
                    width: "abbreviated"
                });
            // A, B
            case "GGGGG":
                return localize.era(era, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return localize.era(era, {
                    width: "wide"
                });
        }
    },
    // Year
    y: function(date, token, localize) {
        // Ordinal number
        if (token === "yo") {
            const signedYear = date.getFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            const year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: "year"
            });
        }
        return (0, $nIkU6.lightFormatters).y(date, token);
    },
    // Local week-numbering year
    Y: function(date, token, localize, options) {
        const signedWeekYear = (0, $e8Oa4.getWeekYear)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        const weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === "YY") {
            const twoDigitYear = weekYear % 100;
            return (0, $dF9D7.addLeadingZeros)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === "Yo") return localize.ordinalNumber(weekYear, {
            unit: "year"
        });
        // Padding
        return (0, $dF9D7.addLeadingZeros)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function(date, token) {
        const isoWeekYear = (0, $5iQfp.getISOWeekYear)(date);
        // Padding
        return (0, $dF9D7.addLeadingZeros)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function(date, token) {
        const year = date.getFullYear();
        return (0, $dF9D7.addLeadingZeros)(year, token.length);
    },
    // Quarter
    Q: function(date, token, localize) {
        const quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "Q":
                return String(quarter);
            // 01, 02, 03, 04
            case "QQ":
                return (0, $dF9D7.addLeadingZeros)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone quarter
    q: function(date, token, localize) {
        const quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "q":
                return String(quarter);
            // 01, 02, 03, 04
            case "qq":
                return (0, $dF9D7.addLeadingZeros)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Month
    M: function(date, token, localize) {
        const month = date.getMonth();
        switch(token){
            case "M":
            case "MM":
                return (0, $nIkU6.lightFormatters).M(date, token);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "MMM":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return localize.month(month, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone month
    L: function(date, token, localize) {
        const month = date.getMonth();
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return String(month + 1);
            // 01, 02, ..., 12
            case "LL":
                return (0, $dF9D7.addLeadingZeros)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "LLL":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return localize.month(month, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Local week of year
    w: function(date, token, localize, options) {
        const week = (0, $2knb9.getWeek)(date, options);
        if (token === "wo") return localize.ordinalNumber(week, {
            unit: "week"
        });
        return (0, $dF9D7.addLeadingZeros)(week, token.length);
    },
    // ISO week of year
    I: function(date, token, localize) {
        const isoWeek = (0, $bwgGY.getISOWeek)(date);
        if (token === "Io") return localize.ordinalNumber(isoWeek, {
            unit: "week"
        });
        return (0, $dF9D7.addLeadingZeros)(isoWeek, token.length);
    },
    // Day of the month
    d: function(date, token, localize) {
        if (token === "do") return localize.ordinalNumber(date.getDate(), {
            unit: "date"
        });
        return (0, $nIkU6.lightFormatters).d(date, token);
    },
    // Day of year
    D: function(date, token, localize) {
        const dayOfYear = (0, $lSCzG.getDayOfYear)(date);
        if (token === "Do") return localize.ordinalNumber(dayOfYear, {
            unit: "dayOfYear"
        });
        return (0, $dF9D7.addLeadingZeros)(dayOfYear, token.length);
    },
    // Day of week
    E: function(date, token, localize) {
        const dayOfWeek = date.getDay();
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Local day of week
    e: function(date, token, localize, options) {
        const dayOfWeek = date.getDay();
        const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case "e":
                return String(localDayOfWeek);
            // Padded numerical value
            case "ee":
                return (0, $dF9D7.addLeadingZeros)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case "eo":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "eee":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone local day of week
    c: function(date, token, localize, options) {
        const dayOfWeek = date.getDay();
        const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case "c":
                return String(localDayOfWeek);
            // Padded numerical value
            case "cc":
                return (0, $dF9D7.addLeadingZeros)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case "co":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "ccc":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // ISO day of week
    i: function(date, token, localize) {
        const dayOfWeek = date.getDay();
        const isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case "i":
                return String(isoDayOfWeek);
            // 02
            case "ii":
                return (0, $dF9D7.addLeadingZeros)(isoDayOfWeek, token.length);
            // 2nd
            case "io":
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "iiiii":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "iiiiii":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "iiii":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM or PM
    a: function(date, token, localize) {
        const hours = date.getHours();
        const dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "aaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "aaaaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM, PM, midnight, noon
    b: function(date, token, localize) {
        const hours = date.getHours();
        let dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $2e9eea8aa22a7409$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $2e9eea8aa22a7409$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "b":
            case "bb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "bbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "bbbbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function(date, token, localize) {
        const hours = date.getHours();
        let dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $2e9eea8aa22a7409$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $2e9eea8aa22a7409$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $2e9eea8aa22a7409$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $2e9eea8aa22a7409$var$dayPeriodEnum.night;
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "BBBBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Hour [1-12]
    h: function(date, token, localize) {
        if (token === "ho") {
            let hours = date.getHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: "hour"
            });
        }
        return (0, $nIkU6.lightFormatters).h(date, token);
    },
    // Hour [0-23]
    H: function(date, token, localize) {
        if (token === "Ho") return localize.ordinalNumber(date.getHours(), {
            unit: "hour"
        });
        return (0, $nIkU6.lightFormatters).H(date, token);
    },
    // Hour [0-11]
    K: function(date, token, localize) {
        const hours = date.getHours() % 12;
        if (token === "Ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $dF9D7.addLeadingZeros)(hours, token.length);
    },
    // Hour [1-24]
    k: function(date, token, localize) {
        let hours = date.getHours();
        if (hours === 0) hours = 24;
        if (token === "ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $dF9D7.addLeadingZeros)(hours, token.length);
    },
    // Minute
    m: function(date, token, localize) {
        if (token === "mo") return localize.ordinalNumber(date.getMinutes(), {
            unit: "minute"
        });
        return (0, $nIkU6.lightFormatters).m(date, token);
    },
    // Second
    s: function(date, token, localize) {
        if (token === "so") return localize.ordinalNumber(date.getSeconds(), {
            unit: "second"
        });
        return (0, $nIkU6.lightFormatters).s(date, token);
    },
    // Fraction of second
    S: function(date, token) {
        return (0, $nIkU6.lightFormatters).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        if (timezoneOffset === 0) return "Z";
        switch(token){
            // Hours and optional minutes
            case "X":
                return $2e9eea8aa22a7409$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case "XXXX":
            case "XX":
                return $2e9eea8aa22a7409$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case "XXXXX":
            case "XXX":
            default:
                return $2e9eea8aa22a7409$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case "x":
                return $2e9eea8aa22a7409$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case "xxxx":
            case "xx":
                return $2e9eea8aa22a7409$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case "xxxxx":
            case "xxx":
            default:
                return $2e9eea8aa22a7409$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (GMT)
    O: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + $2e9eea8aa22a7409$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "OOOO":
            default:
                return "GMT" + $2e9eea8aa22a7409$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "z":
            case "zz":
            case "zzz":
                return "GMT" + $2e9eea8aa22a7409$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "zzzz":
            default:
                return "GMT" + $2e9eea8aa22a7409$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Seconds timestamp
    t: function(date, token, _localize) {
        const timestamp = Math.trunc(date.getTime() / 1000);
        return (0, $dF9D7.addLeadingZeros)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function(date, token, _localize) {
        const timestamp = date.getTime();
        return (0, $dF9D7.addLeadingZeros)(timestamp, token.length);
    }
};
function $2e9eea8aa22a7409$var$formatTimezoneShort(offset, delimiter = "") {
    const sign = offset > 0 ? "-" : "+";
    const absOffset = Math.abs(offset);
    const hours = Math.trunc(absOffset / 60);
    const minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    return sign + String(hours) + delimiter + (0, $dF9D7.addLeadingZeros)(minutes, 2);
}
function $2e9eea8aa22a7409$var$formatTimezoneWithOptionalMinutes(offset, delimiter) {
    if (offset % 60 === 0) {
        const sign = offset > 0 ? "-" : "+";
        return sign + (0, $dF9D7.addLeadingZeros)(Math.abs(offset) / 60, 2);
    }
    return $2e9eea8aa22a7409$var$formatTimezone(offset, delimiter);
}
function $2e9eea8aa22a7409$var$formatTimezone(offset, delimiter = "") {
    const sign = offset > 0 ? "-" : "+";
    const absOffset = Math.abs(offset);
    const hours = (0, $dF9D7.addLeadingZeros)(Math.trunc(absOffset / 60), 2);
    const minutes = (0, $dF9D7.addLeadingZeros)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}

});
parcelRegister("lSCzG", function(module, exports) {

$parcel$export(module.exports, "getDayOfYear", () => $4100fc0787f2c967$export$d3b42cd8452deec);

var $fdNNo = parcelRequire("fdNNo");

var $2T478 = parcelRequire("2T478");

var $j23m7 = parcelRequire("j23m7");
function $4100fc0787f2c967$export$d3b42cd8452deec(date) {
    const _date = (0, $j23m7.toDate)(date);
    const diff = (0, $fdNNo.differenceInCalendarDays)(_date, (0, $2T478.startOfYear)(_date));
    const dayOfYear = diff + 1;
    return dayOfYear;
}
var // Fallback for modularized imports:
$4100fc0787f2c967$export$2e2bcd8739ae039 = $4100fc0787f2c967$export$d3b42cd8452deec;

});
parcelRegister("fdNNo", function(module, exports) {

$parcel$export(module.exports, "differenceInCalendarDays", () => $5b0a8b5498f30c40$export$4a02e9c37dab4871);

var $10XiK = parcelRequire("10XiK");

var $fHsbD = parcelRequire("fHsbD");

var $4mqp7 = parcelRequire("4mqp7");
function $5b0a8b5498f30c40$export$4a02e9c37dab4871(dateLeft, dateRight) {
    const startOfDayLeft = (0, $fHsbD.startOfDay)(dateLeft);
    const startOfDayRight = (0, $fHsbD.startOfDay)(dateRight);
    const timestampLeft = +startOfDayLeft - (0, $4mqp7.getTimezoneOffsetInMilliseconds)(startOfDayLeft);
    const timestampRight = +startOfDayRight - (0, $4mqp7.getTimezoneOffsetInMilliseconds)(startOfDayRight);
    // Round the number of days to the nearest integer because the number of
    // milliseconds in a day is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round((timestampLeft - timestampRight) / (0, $10XiK.millisecondsInDay));
}
var // Fallback for modularized imports:
$5b0a8b5498f30c40$export$2e2bcd8739ae039 = $5b0a8b5498f30c40$export$4a02e9c37dab4871;

});
parcelRegister("10XiK", function(module, exports) {

$parcel$export(module.exports, "millisecondsInWeek", () => $b28dba470be53dfd$export$4fad13613e88edc8);
$parcel$export(module.exports, "millisecondsInDay", () => $b28dba470be53dfd$export$b76b1809a2898f9a);
/**
 * @module constants
 * @summary Useful constants
 * @description
 * Collection of useful date constants.
 *
 * The constants could be imported from `date-fns/constants`:
 *
 * ```ts
 * import { maxTime, minTime } from "./constants/date-fns/constants";
 *
 * function isAllowedTime(time) {
 *   return time <= maxTime && time >= minTime;
 * }
 * ```
 */ /**
 * @constant
 * @name daysInWeek
 * @summary Days in 1 week.
 */ const $b28dba470be53dfd$export$dfd9b671c89acc8e = 7;
const $b28dba470be53dfd$export$3913210603d8e9ae = 365.2425;
const $b28dba470be53dfd$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
const $b28dba470be53dfd$export$4dec998e48f9c246 = -$b28dba470be53dfd$export$81caae6e1cc7a622;
const $b28dba470be53dfd$export$4fad13613e88edc8 = 604800000;
const $b28dba470be53dfd$export$b76b1809a2898f9a = 86400000;
const $b28dba470be53dfd$export$91246f0b9bd9beff = 60000;
const $b28dba470be53dfd$export$7f72910d6dfd237a = 3600000;
const $b28dba470be53dfd$export$397c2d5776aa9055 = 1000;
const $b28dba470be53dfd$export$3633035e63cee86a = 525600;
const $b28dba470be53dfd$export$ab7da2ccd1075c38 = 43200;
const $b28dba470be53dfd$export$2423174df8cd3cd2 = 1440;
const $b28dba470be53dfd$export$f2f5ae5a8e2d8f9f = 60;
const $b28dba470be53dfd$export$3c58128db900d44e = 3;
const $b28dba470be53dfd$export$80d7e435f744f319 = 12;
const $b28dba470be53dfd$export$4db7641526e3241f = 4;
const $b28dba470be53dfd$export$698aec755e92c695 = 3600;
const $b28dba470be53dfd$export$a77c1a7ebebe2a5a = 60;
const $b28dba470be53dfd$export$815a9362476d2fe3 = $b28dba470be53dfd$export$698aec755e92c695 * 24;
const $b28dba470be53dfd$export$34804a017b31e2fe = $b28dba470be53dfd$export$815a9362476d2fe3 * 7;
const $b28dba470be53dfd$export$7271e9e3478110d1 = $b28dba470be53dfd$export$815a9362476d2fe3 * $b28dba470be53dfd$export$3913210603d8e9ae;
const $b28dba470be53dfd$export$8e6600bbdee7dabb = $b28dba470be53dfd$export$7271e9e3478110d1 / 12;
const $b28dba470be53dfd$export$be1dccf2de902d31 = $b28dba470be53dfd$export$8e6600bbdee7dabb * 3;

});

parcelRegister("fHsbD", function(module, exports) {

$parcel$export(module.exports, "startOfDay", () => $8b34c824a6bf632d$export$63fa379ae8a9ba2);

var $j23m7 = parcelRequire("j23m7");
function $8b34c824a6bf632d$export$63fa379ae8a9ba2(date) {
    const _date = (0, $j23m7.toDate)(date);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$8b34c824a6bf632d$export$2e2bcd8739ae039 = $8b34c824a6bf632d$export$63fa379ae8a9ba2;

});
parcelRegister("j23m7", function(module, exports) {

$parcel$export(module.exports, "toDate", () => $386d172ea480c0e1$export$e67a095c620b86fe);
/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param argument - The value to convert
 *
 * @returns The parsed date in the local time zone
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */ function $386d172ea480c0e1$export$e67a095c620b86fe(argument) {
    const argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || typeof argument === "object" && argStr === "[object Date]") // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new argument.constructor(+argument);
    else if (typeof argument === "number" || argStr === "[object Number]" || typeof argument === "string" || argStr === "[object String]") // TODO: Can we get rid of as?
    return new Date(argument);
    else // TODO: Can we get rid of as?
    return new Date(NaN);
}
var // Fallback for modularized imports:
$386d172ea480c0e1$export$2e2bcd8739ae039 = $386d172ea480c0e1$export$e67a095c620b86fe;

});


parcelRegister("4mqp7", function(module, exports) {

$parcel$export(module.exports, "getTimezoneOffsetInMilliseconds", () => $0c83f512fd3e319d$export$113002b5eff6e430);

var $j23m7 = parcelRequire("j23m7");
function $0c83f512fd3e319d$export$113002b5eff6e430(date) {
    const _date = (0, $j23m7.toDate)(date);
    const utcDate = new Date(Date.UTC(_date.getFullYear(), _date.getMonth(), _date.getDate(), _date.getHours(), _date.getMinutes(), _date.getSeconds(), _date.getMilliseconds()));
    utcDate.setUTCFullYear(_date.getFullYear());
    return +date - +utcDate;
}

});


parcelRegister("2T478", function(module, exports) {

$parcel$export(module.exports, "startOfYear", () => $5c4fc3db557399dd$export$f91e89d3d0406102);

var $j23m7 = parcelRequire("j23m7");

var $nokyu = parcelRequire("nokyu");
function $5c4fc3db557399dd$export$f91e89d3d0406102(date) {
    const cleanDate = (0, $j23m7.toDate)(date);
    const _date = (0, $nokyu.constructFrom)(date, 0);
    _date.setFullYear(cleanDate.getFullYear(), 0, 1);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$5c4fc3db557399dd$export$2e2bcd8739ae039 = $5c4fc3db557399dd$export$f91e89d3d0406102;

});
parcelRegister("nokyu", function(module, exports) {

$parcel$export(module.exports, "constructFrom", () => $80a6354f2c2e2f49$export$ead8a1812b171991);
/**
 * @name constructFrom
 * @category Generic Helpers
 * @summary Constructs a date using the reference date and the value
 *
 * @description
 * The function constructs a new date using the constructor from the reference
 * date and the given value. It helps to build generic functions that accept
 * date extensions.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The reference date to take constructor from
 * @param value - The value to create the date
 *
 * @returns Date initialized using the given date and value
 *
 * @example
 * import { constructFrom } from 'date-fns'
 *
 * // A function that clones a date preserving the original type
 * function cloneDate<DateType extends Date(date: DateType): DateType {
 *   return constructFrom(
 *     date, // Use contrustor from the given date
 *     date.getTime() // Use the date value to create a new date
 *   )
 * }
 */ function $80a6354f2c2e2f49$export$ead8a1812b171991(date, value) {
    if (date instanceof Date) return new date.constructor(value);
    else return new Date(value);
}
var // Fallback for modularized imports:
$80a6354f2c2e2f49$export$2e2bcd8739ae039 = $80a6354f2c2e2f49$export$ead8a1812b171991;

});



parcelRegister("bwgGY", function(module, exports) {

$parcel$export(module.exports, "getISOWeek", () => $cd15e13d4e2dd14c$export$7cabdc5698b63e2f);

var $10XiK = parcelRequire("10XiK");

var $1fYZR = parcelRequire("1fYZR");

var $i6DA0 = parcelRequire("i6DA0");

var $j23m7 = parcelRequire("j23m7");
function $cd15e13d4e2dd14c$export$7cabdc5698b63e2f(date) {
    const _date = (0, $j23m7.toDate)(date);
    const diff = +(0, $1fYZR.startOfISOWeek)(_date) - +(0, $i6DA0.startOfISOWeekYear)(_date);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / (0, $10XiK.millisecondsInWeek)) + 1;
}
var // Fallback for modularized imports:
$cd15e13d4e2dd14c$export$2e2bcd8739ae039 = $cd15e13d4e2dd14c$export$7cabdc5698b63e2f;

});
parcelRegister("1fYZR", function(module, exports) {

$parcel$export(module.exports, "startOfISOWeek", () => $346a5a61b6f000ac$export$6173213f95a4431e);

var $89RpU = parcelRequire("89RpU");
function $346a5a61b6f000ac$export$6173213f95a4431e(date) {
    return (0, $89RpU.startOfWeek)(date, {
        weekStartsOn: 1
    });
}
var // Fallback for modularized imports:
$346a5a61b6f000ac$export$2e2bcd8739ae039 = $346a5a61b6f000ac$export$6173213f95a4431e;

});
parcelRegister("89RpU", function(module, exports) {

$parcel$export(module.exports, "startOfWeek", () => $44efbf224505eb39$export$42c81a444fbfb5d4);

var $j23m7 = parcelRequire("j23m7");

var $lVZSl = parcelRequire("lVZSl");
function $44efbf224505eb39$export$42c81a444fbfb5d4(date, options) {
    const defaultOptions = (0, $lVZSl.getDefaultOptions)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, $j23m7.toDate)(date);
    const day = _date.getDay();
    const diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    _date.setDate(_date.getDate() - diff);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$44efbf224505eb39$export$2e2bcd8739ae039 = $44efbf224505eb39$export$42c81a444fbfb5d4;

});


parcelRegister("i6DA0", function(module, exports) {

$parcel$export(module.exports, "startOfISOWeekYear", () => $3207ae096bef49df$export$236bdfa374eb69a9);

var $5iQfp = parcelRequire("5iQfp");

var $1fYZR = parcelRequire("1fYZR");

var $nokyu = parcelRequire("nokyu");
function $3207ae096bef49df$export$236bdfa374eb69a9(date) {
    const year = (0, $5iQfp.getISOWeekYear)(date);
    const fourthOfJanuary = (0, $nokyu.constructFrom)(date, 0);
    fourthOfJanuary.setFullYear(year, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    return (0, $1fYZR.startOfISOWeek)(fourthOfJanuary);
}
var // Fallback for modularized imports:
$3207ae096bef49df$export$2e2bcd8739ae039 = $3207ae096bef49df$export$236bdfa374eb69a9;

});
parcelRegister("5iQfp", function(module, exports) {

$parcel$export(module.exports, "getISOWeekYear", () => $8d09decf4e01b99c$export$3dbc52535f6f8fcc);

var $nokyu = parcelRequire("nokyu");

var $1fYZR = parcelRequire("1fYZR");

var $j23m7 = parcelRequire("j23m7");
function $8d09decf4e01b99c$export$3dbc52535f6f8fcc(date) {
    const _date = (0, $j23m7.toDate)(date);
    const year = _date.getFullYear();
    const fourthOfJanuaryOfNextYear = (0, $nokyu.constructFrom)(date, 0);
    fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
    const startOfNextYear = (0, $1fYZR.startOfISOWeek)(fourthOfJanuaryOfNextYear);
    const fourthOfJanuaryOfThisYear = (0, $nokyu.constructFrom)(date, 0);
    fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
    const startOfThisYear = (0, $1fYZR.startOfISOWeek)(fourthOfJanuaryOfThisYear);
    if (_date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (_date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}
var // Fallback for modularized imports:
$8d09decf4e01b99c$export$2e2bcd8739ae039 = $8d09decf4e01b99c$export$3dbc52535f6f8fcc;

});



parcelRegister("2knb9", function(module, exports) {

$parcel$export(module.exports, "getWeek", () => $599dc4040aef11cc$export$efe19b760242b2fc);

var $10XiK = parcelRequire("10XiK");

var $89RpU = parcelRequire("89RpU");

var $8IEpQ = parcelRequire("8IEpQ");

var $j23m7 = parcelRequire("j23m7");
function $599dc4040aef11cc$export$efe19b760242b2fc(date, options) {
    const _date = (0, $j23m7.toDate)(date);
    const diff = +(0, $89RpU.startOfWeek)(_date, options) - +(0, $8IEpQ.startOfWeekYear)(_date, options);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / (0, $10XiK.millisecondsInWeek)) + 1;
}
var // Fallback for modularized imports:
$599dc4040aef11cc$export$2e2bcd8739ae039 = $599dc4040aef11cc$export$efe19b760242b2fc;

});
parcelRegister("8IEpQ", function(module, exports) {

$parcel$export(module.exports, "startOfWeekYear", () => $5f3a9ee934986032$export$bb7b45bb8e74da0f);

var $nokyu = parcelRequire("nokyu");

var $e8Oa4 = parcelRequire("e8Oa4");

var $89RpU = parcelRequire("89RpU");

var $lVZSl = parcelRequire("lVZSl");
function $5f3a9ee934986032$export$bb7b45bb8e74da0f(date, options) {
    const defaultOptions = (0, $lVZSl.getDefaultOptions)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const year = (0, $e8Oa4.getWeekYear)(date, options);
    const firstWeek = (0, $nokyu.constructFrom)(date, 0);
    firstWeek.setFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setHours(0, 0, 0, 0);
    const _date = (0, $89RpU.startOfWeek)(firstWeek, options);
    return _date;
}
var // Fallback for modularized imports:
$5f3a9ee934986032$export$2e2bcd8739ae039 = $5f3a9ee934986032$export$bb7b45bb8e74da0f;

});
parcelRegister("e8Oa4", function(module, exports) {

$parcel$export(module.exports, "getWeekYear", () => $d179c23585ed2d50$export$12d572480ceb6e58);

var $nokyu = parcelRequire("nokyu");

var $89RpU = parcelRequire("89RpU");

var $j23m7 = parcelRequire("j23m7");

var $lVZSl = parcelRequire("lVZSl");
function $d179c23585ed2d50$export$12d572480ceb6e58(date, options) {
    const _date = (0, $j23m7.toDate)(date);
    const year = _date.getFullYear();
    const defaultOptions = (0, $lVZSl.getDefaultOptions)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const firstWeekOfNextYear = (0, $nokyu.constructFrom)(date, 0);
    firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setHours(0, 0, 0, 0);
    const startOfNextYear = (0, $89RpU.startOfWeek)(firstWeekOfNextYear, options);
    const firstWeekOfThisYear = (0, $nokyu.constructFrom)(date, 0);
    firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setHours(0, 0, 0, 0);
    const startOfThisYear = (0, $89RpU.startOfWeek)(firstWeekOfThisYear, options);
    if (_date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (_date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}
var // Fallback for modularized imports:
$d179c23585ed2d50$export$2e2bcd8739ae039 = $d179c23585ed2d50$export$12d572480ceb6e58;

});



parcelRegister("dF9D7", function(module, exports) {

$parcel$export(module.exports, "addLeadingZeros", () => $eba387da7aa4f33f$export$c8306e720e213c0f);
function $eba387da7aa4f33f$export$c8306e720e213c0f(number, targetLength) {
    const sign = number < 0 ? "-" : "";
    const output = Math.abs(number).toString().padStart(targetLength, "0");
    return sign + output;
}

});

parcelRegister("nIkU6", function(module, exports) {

$parcel$export(module.exports, "lightFormatters", () => $797475ed76bb0947$export$b0d4b338e1516f13);

var $dF9D7 = parcelRequire("dF9D7");
const $797475ed76bb0947$export$b0d4b338e1516f13 = {
    // Year
    y (date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        const signedYear = date.getFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        const year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $dF9D7.addLeadingZeros)(token === "yy" ? year % 100 : year, token.length);
    },
    // Month
    M (date, token) {
        const month = date.getMonth();
        return token === "M" ? String(month + 1) : (0, $dF9D7.addLeadingZeros)(month + 1, 2);
    },
    // Day of the month
    d (date, token) {
        return (0, $dF9D7.addLeadingZeros)(date.getDate(), token.length);
    },
    // AM or PM
    a (date, token) {
        const dayPeriodEnumValue = date.getHours() / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return dayPeriodEnumValue.toUpperCase();
            case "aaa":
                return dayPeriodEnumValue;
            case "aaaaa":
                return dayPeriodEnumValue[0];
            case "aaaa":
            default:
                return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
        }
    },
    // Hour [1-12]
    h (date, token) {
        return (0, $dF9D7.addLeadingZeros)(date.getHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H (date, token) {
        return (0, $dF9D7.addLeadingZeros)(date.getHours(), token.length);
    },
    // Minute
    m (date, token) {
        return (0, $dF9D7.addLeadingZeros)(date.getMinutes(), token.length);
    },
    // Second
    s (date, token) {
        return (0, $dF9D7.addLeadingZeros)(date.getSeconds(), token.length);
    },
    // Fraction of second
    S (date, token) {
        const numberOfDigits = token.length;
        const milliseconds = date.getMilliseconds();
        const fractionalSeconds = Math.trunc(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $dF9D7.addLeadingZeros)(fractionalSeconds, token.length);
    }
};

});


parcelRegister("hLHKY", function(module, exports) {

$parcel$export(module.exports, "longFormatters", () => $f2549db5f0f5bb77$export$70cc8fd02856fd58);
const $f2549db5f0f5bb77$var$dateLongFormatter = (pattern, formatLong)=>{
    switch(pattern){
        case "P":
            return formatLong.date({
                width: "short"
            });
        case "PP":
            return formatLong.date({
                width: "medium"
            });
        case "PPP":
            return formatLong.date({
                width: "long"
            });
        case "PPPP":
        default:
            return formatLong.date({
                width: "full"
            });
    }
};
const $f2549db5f0f5bb77$var$timeLongFormatter = (pattern, formatLong)=>{
    switch(pattern){
        case "p":
            return formatLong.time({
                width: "short"
            });
        case "pp":
            return formatLong.time({
                width: "medium"
            });
        case "ppp":
            return formatLong.time({
                width: "long"
            });
        case "pppp":
        default:
            return formatLong.time({
                width: "full"
            });
    }
};
const $f2549db5f0f5bb77$var$dateTimeLongFormatter = (pattern, formatLong)=>{
    const matchResult = pattern.match(/(P+)(p+)?/) || [];
    const datePattern = matchResult[1];
    const timePattern = matchResult[2];
    if (!timePattern) return $f2549db5f0f5bb77$var$dateLongFormatter(pattern, formatLong);
    let dateTimeFormat;
    switch(datePattern){
        case "P":
            dateTimeFormat = formatLong.dateTime({
                width: "short"
            });
            break;
        case "PP":
            dateTimeFormat = formatLong.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            dateTimeFormat = formatLong.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            dateTimeFormat = formatLong.dateTime({
                width: "full"
            });
            break;
    }
    return dateTimeFormat.replace("{{date}}", $f2549db5f0f5bb77$var$dateLongFormatter(datePattern, formatLong)).replace("{{time}}", $f2549db5f0f5bb77$var$timeLongFormatter(timePattern, formatLong));
};
const $f2549db5f0f5bb77$export$70cc8fd02856fd58 = {
    p: $f2549db5f0f5bb77$var$timeLongFormatter,
    P: $f2549db5f0f5bb77$var$dateTimeLongFormatter
};

});

parcelRegister("3zhEP", function(module, exports) {

$parcel$export(module.exports, "isProtectedDayOfYearToken", () => $d22b904188a85cff$export$c6cc36aa33304772);
$parcel$export(module.exports, "isProtectedWeekYearToken", () => $d22b904188a85cff$export$c6b49d6dceb604a1);
$parcel$export(module.exports, "warnOrThrowProtectedError", () => $d22b904188a85cff$export$f5f38f90ecaaf879);
const $d22b904188a85cff$var$dayOfYearTokenRE = /^D+$/;
const $d22b904188a85cff$var$weekYearTokenRE = /^Y+$/;
const $d22b904188a85cff$var$throwTokens = [
    "D",
    "DD",
    "YY",
    "YYYY"
];
function $d22b904188a85cff$export$c6cc36aa33304772(token) {
    return $d22b904188a85cff$var$dayOfYearTokenRE.test(token);
}
function $d22b904188a85cff$export$c6b49d6dceb604a1(token) {
    return $d22b904188a85cff$var$weekYearTokenRE.test(token);
}
function $d22b904188a85cff$export$f5f38f90ecaaf879(token, format, input) {
    const _message = $d22b904188a85cff$var$message(token, format, input);
    console.warn(_message);
    if ($d22b904188a85cff$var$throwTokens.includes(token)) throw new RangeError(_message);
}
function $d22b904188a85cff$var$message(token, format, input) {
    const subject = token[0] === "Y" ? "years" : "days of the month";
    return `Use \`${token.toLowerCase()}\` instead of \`${token}\` (in \`${format}\`) for formatting ${subject} to the input \`${input}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}

});

parcelRegister("4m7Rs", function(module, exports) {

$parcel$export(module.exports, "isValid", () => $25365db812f861da$export$1ea939691cdc45b8);

var $aecpk = parcelRequire("aecpk");

var $j23m7 = parcelRequire("j23m7");
function $25365db812f861da$export$1ea939691cdc45b8(date) {
    if (!(0, $aecpk.isDate)(date) && typeof date !== "number") return false;
    const _date = (0, $j23m7.toDate)(date);
    return !isNaN(Number(_date));
}
var // Fallback for modularized imports:
$25365db812f861da$export$2e2bcd8739ae039 = $25365db812f861da$export$1ea939691cdc45b8;

});
parcelRegister("aecpk", function(module, exports) {

$parcel$export(module.exports, "isDate", () => $c07a8f9c6df691bf$export$871608497c498473);
/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param value - The value to check
 *
 * @returns True if the given value is a date
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */ function $c07a8f9c6df691bf$export$871608497c498473(value) {
    return value instanceof Date || typeof value === "object" && Object.prototype.toString.call(value) === "[object Date]";
}
var // Fallback for modularized imports:
$c07a8f9c6df691bf$export$2e2bcd8739ae039 = $c07a8f9c6df691bf$export$871608497c498473;

});



parcelRegister("bUEub", function(module, exports) {

$parcel$export(module.exports, "initialFilterValues", () => $e38a15cad2dc5e00$export$102a5bde4d4c9834);
$parcel$export(module.exports, "filterValuesToVariable", () => $e38a15cad2dc5e00$export$6f2fda70fe261d2e);
$parcel$export(module.exports, "default", () => $e38a15cad2dc5e00$export$2e2bcd8739ae039);

var $cKvYK = parcelRequire("cKvYK");

var $l6nxk = parcelRequire("l6nxk");

var $bkJfK = parcelRequire("bkJfK");

var $4DyxQ = parcelRequire("4DyxQ");
var $469X3 = parcelRequire("469X3");

var $26Ddr = parcelRequire("26Ddr");

var $bMnYC = parcelRequire("bMnYC");

var $2bv1f = parcelRequire("2bv1f");

var $5TbRy = parcelRequire("5TbRy");

var $fZS5j = parcelRequire("fZS5j");

var $bYYyU = parcelRequire("bYYyU");

var $hpOSz = parcelRequire("hpOSz");

var $3BicN = parcelRequire("3BicN");
const $e38a15cad2dc5e00$export$102a5bde4d4c9834 = {
    utilisateurUsername: "",
    utilisateursIds: null,
    rolesIds: null,
    dateDebut: null,
    dateFin: null,
    dureeMin: null,
    dureeMax: null,
    ressourcesConsulteesCodes: null
};
const $e38a15cad2dc5e00$export$6f2fda70fe261d2e = ({ utilisateurUsername: utilisateurUsername, utilisateurs: utilisateurs, roles: roles, dateDebut: dateDebut, dateFin: dateFin, dureeMin: dureeMin, dureeMax: dureeMax, ressourcesConsultees: ressourcesConsultees })=>{
    const filter = {};
    if (utilisateurUsername != null && utilisateurUsername.trim() !== "") filter.utilisateurUsername = utilisateurUsername;
    if (utilisateurs != null && utilisateurs.length > 0) filter.utilisateursIds = utilisateurs.map((e)=>e.utilisateurId);
    if (roles != null && roles.length > 0) filter.rolesIds = roles.map((e)=>e.roleId);
    if (dateDebut != null) filter.dateDebut = (0, $l6nxk.default)(new Date(dateDebut), "yyyy-MM-dd");
    if (dateFin != null) filter.dateFin = (0, $l6nxk.default)(new Date(dateFin), "yyyy-MM-dd");
    if (dureeMin != null && dureeMin !== "") filter.dureeMin = dureeMin;
    if (dureeMax != null && dureeMax !== "") filter.dureeMax = dureeMax;
    if (ressourcesConsultees != null && ressourcesConsultees.length > 0) filter.ressourcesConsulteesCodes = ressourcesConsultees.map((e)=>e.ressourceCode);
    return filter;
};
const $e38a15cad2dc5e00$var$FilterLogConnexion = ({ filterBy: filterBy, sortBy: sortBy })=>{
    const stateListUtilisateur = (0, $26Ddr.useGet)((0, $5TbRy.default)`/api/utilisateurs/getAll`);
    const stateListRole = (0, $26Ddr.useGet)((0, $5TbRy.default)`/api/roles/`);
    const stateListRessources = (0, $26Ddr.useGet)((0, $5TbRy.default)`/api/ressource/getAllRessourcesToFilter`);
    const { setFieldValue: setFieldValue, values: values, setValues: setValues } = (0, $bkJfK.useFormikContext)();
    return /*#__PURE__*/ (0, $cKvYK.jsx)((0, $fZS5j.default), {
        children: /*#__PURE__*/ (0, $cKvYK.jsxs)((0, $469X3.default), {
            children: [
                /*#__PURE__*/ (0, $cKvYK.jsxs)((0, $4DyxQ.default), {
                    xs: 6,
                    children: [
                        /*#__PURE__*/ (0, $cKvYK.jsx)((0, $fZS5j.FilterText), {
                            label: "",
                            "aria-labelledby": "recherche-utilisateur",
                            placeholder: "Recherche un utilisateur",
                            name: "utilisateurUsername",
                            submitable: true
                        }),
                        /*#__PURE__*/ (0, $cKvYK.jsx)("p", {
                            id: "recherche-utilisateur",
                            className: "d-none",
                            children: "Rechercher un utilisateur"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $cKvYK.jsx)((0, $4DyxQ.default), {
                    xs: 6,
                    className: "text-center d-flex flex-column justify-content-center",
                    children: /*#__PURE__*/ (0, $cKvYK.jsxs)((0, $bYYyU.LinkButton), {
                        href: (0, $5TbRy.default)`/api/exportLogConnexion/export-csv?${{
                            // filterBy
                            utilisateurUsername: filterBy.utilisateurUsername,
                            utilisateursIds: filterBy.utilisateursIds,
                            rolesIds: filterBy.rolesIds,
                            dateDebut: filterBy.dateDebut,
                            dateFin: filterBy.dateFin,
                            dureeMin: filterBy.dureeMin,
                            dureeMax: filterBy.dureeMax,
                            ressourcesConsulteesCodes: filterBy.ressourcesConsulteesCodes,
                            // sortBy
                            utilisateurIdsSort: sortBy.utilisateurUsername,
                            connexionDate: sortBy.connexionDate,
                            deconnexionDate: sortBy.deconnexionDate,
                            duree: sortBy.duree
                        }}`,
                        className: "text-center mx-auto",
                        children: [
                            "Tout exporter\xa0",
                            /*#__PURE__*/ (0, $cKvYK.jsx)((0, $hpOSz.IconFileExport), {})
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $cKvYK.jsx)((0, $4DyxQ.default), {
                    className: "mb-3 text-center",
                    children: /*#__PURE__*/ (0, $cKvYK.jsx)((0, $bMnYC.default), {
                        title: "Filtrer les donn\xe9es",
                        content: /*#__PURE__*/ (0, $cKvYK.jsxs)((0, $469X3.default), {
                            children: [
                                /*#__PURE__*/ (0, $cKvYK.jsxs)((0, $4DyxQ.default), {
                                    children: [
                                        /*#__PURE__*/ (0, $cKvYK.jsx)("p", {
                                            id: "filter-identifiant-user",
                                            children: "Identifiant"
                                        }),
                                        /*#__PURE__*/ (0, $cKvYK.jsx)((0, $3BicN.MultiSelectInput), {
                                            label: "",
                                            "aria-labelledby": "filter-identifiant-user",
                                            name: "utilisateurs",
                                            placeholder: "Tous",
                                            options: stateListUtilisateur.value,
                                            getOptionValue: (u)=>u.utilisateurId,
                                            toOptionLabelFunc: (u)=>u.utilisateurUsername,
                                            isClearable: true
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $cKvYK.jsxs)((0, $4DyxQ.default), {
                                    children: [
                                        /*#__PURE__*/ (0, $cKvYK.jsx)("p", {
                                            id: "filter-roles",
                                            children: "R\xf4les"
                                        }),
                                        /*#__PURE__*/ (0, $cKvYK.jsx)((0, $3BicN.MultiSelectInput), {
                                            label: "",
                                            "aria-labelledby": "filter-roles",
                                            name: "roles",
                                            placeholder: "Tous",
                                            options: stateListRole.value,
                                            getOptionValue: (u)=>u.roleId,
                                            toOptionLabelFunc: (u)=>u.roleLibelle,
                                            isClearable: true
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $cKvYK.jsx)((0, $469X3.default), {
                                    children: /*#__PURE__*/ (0, $cKvYK.jsx)("p", {
                                        children: "Date des \xe9v\xe9nements"
                                    })
                                }),
                                /*#__PURE__*/ (0, $cKvYK.jsxs)((0, $469X3.default), {
                                    children: [
                                        /*#__PURE__*/ (0, $cKvYK.jsxs)((0, $4DyxQ.default), {
                                            children: [
                                                /*#__PURE__*/ (0, $cKvYK.jsx)("p", {
                                                    id: "filter-date-debut",
                                                    children: "Date de d\xe9but des \xe9venements"
                                                }),
                                                /*#__PURE__*/ (0, $cKvYK.jsx)((0, $2bv1f.default), {
                                                    "aria-labelledby": "filter-date-debut",
                                                    onChangeHandler: (date)=>setFieldValue("dateDebut", date),
                                                    startDate: values?.dateDebut ? new Date(values.dateDebut) : null,
                                                    selectsRange: false,
                                                    maxDate: values?.dateFin ?? undefined,
                                                    defaultMessage: "A partir du ..."
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $cKvYK.jsxs)((0, $4DyxQ.default), {
                                            children: [
                                                /*#__PURE__*/ (0, $cKvYK.jsx)("p", {
                                                    id: "filter-date-fin",
                                                    children: "Date de fin des \xe9venements"
                                                }),
                                                /*#__PURE__*/ (0, $cKvYK.jsx)((0, $2bv1f.default), {
                                                    "aria-labelledby": "filter-date-fin",
                                                    onChangeHandler: (date)=>setFieldValue("dateFin", date),
                                                    startDate: values?.dateFin ? new Date(values.dateFin) : null,
                                                    selectsRange: false,
                                                    minDate: values?.dateDebut ?? undefined,
                                                    defaultMessage: "Jusqu'\xe0 ..."
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $cKvYK.jsxs)((0, $469X3.default), {
                                    children: [
                                        /*#__PURE__*/ (0, $cKvYK.jsx)((0, $4DyxQ.default), {
                                            xs: 12,
                                            children: /*#__PURE__*/ (0, $cKvYK.jsx)("p", {
                                                id: "filter-duree",
                                                children: "Dur\xe9e (en minutes)"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $cKvYK.jsxs)((0, $4DyxQ.default), {
                                            children: [
                                                /*#__PURE__*/ (0, $cKvYK.jsx)("p", {
                                                    id: "filter-duree-min",
                                                    children: "Dur\xe9e minimum d'une session en minutes"
                                                }),
                                                /*#__PURE__*/ (0, $cKvYK.jsx)((0, $fZS5j.FilterNumber), {
                                                    "aria-labelledby": "filter-duree-min",
                                                    name: "dureeMin",
                                                    min: 0,
                                                    placeholder: "Min",
                                                    disabled: false,
                                                    onBlur: (value)=>{
                                                        const valeur = value.target.value;
                                                        if (valeur && values.dureeMax && values.dureeMax < valeur) setValues({
                                                            ...values,
                                                            dureeMin: values.dureeMax
                                                        });
                                                    }
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $cKvYK.jsxs)((0, $4DyxQ.default), {
                                            children: [
                                                /*#__PURE__*/ (0, $cKvYK.jsx)("p", {
                                                    id: "filter-duree-max",
                                                    children: "Dur\xe9e maximum d'une session en minutes"
                                                }),
                                                /*#__PURE__*/ (0, $cKvYK.jsx)((0, $fZS5j.FilterNumber), {
                                                    "aria-labelledby": "filter-duree-max",
                                                    name: "dureeMax",
                                                    min: 1,
                                                    placeholder: "Max",
                                                    disabled: false,
                                                    onBlur: (value)=>{
                                                        const valeur = value.target.value;
                                                        if (valeur && values.dureeMin && values.dureeMin > valeur) setValues({
                                                            ...values,
                                                            dureeMax: values.dureeMin
                                                        });
                                                    }
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $cKvYK.jsx)((0, $469X3.default), {
                                    children: /*#__PURE__*/ (0, $cKvYK.jsxs)((0, $4DyxQ.default), {
                                        children: [
                                            /*#__PURE__*/ (0, $cKvYK.jsx)("p", {
                                                id: "filter-ressources-consultees",
                                                children: "Ressources consult\xe9es"
                                            }),
                                            /*#__PURE__*/ (0, $cKvYK.jsx)((0, $3BicN.MultiSelectInput), {
                                                label: "",
                                                "aria-labelledby": "filter-ressources-consultees",
                                                name: "ressourcesConsultees",
                                                placeholder: "Toutes",
                                                options: stateListRessources.value,
                                                getOptionValue: (u)=>u.ressourceCode,
                                                toOptionLabelFunc: (u)=>u.ressourceLibelle,
                                                isClearable: true
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $cKvYK.jsx)((0, $4DyxQ.default), {
                                    xs: "auto",
                                    className: "mx-auto",
                                    children: /*#__PURE__*/ (0, $cKvYK.jsx)((0, $bYYyU.default), {
                                        type: (0, $bYYyU.TYPE_BUTTON).submit,
                                        className: "text-center",
                                        children: "Valider les filtres"
                                    })
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
};
var $e38a15cad2dc5e00$export$2e2bcd8739ae039 = $e38a15cad2dc5e00$var$FilterLogConnexion;

});
parcelRegister("bMnYC", function(module, exports) {

$parcel$export(module.exports, "default", () => $5dd3972b159847ba$export$2e2bcd8739ae039);

var $cKvYK = parcelRequire("cKvYK");

var $khgMO = parcelRequire("khgMO");

var $kc00y = parcelRequire("kc00y");

var $hpOSz = parcelRequire("hpOSz");
const $5dd3972b159847ba$var$Accordion = ({ title: title, content: content })=>{
    const [isActive, setIsActive] = (0, $kc00y.useState)(false);
    return /*#__PURE__*/ (0, $cKvYK.jsxs)((0, $cKvYK.Fragment), {
        children: [
            /*#__PURE__*/ (0, $cKvYK.jsx)((0, $khgMO.default), {
                variant: "outline-success",
                className: "rounded-pill p-3 mb-2",
                onClick: ()=>setIsActive(!isActive),
                children: /*#__PURE__*/ (0, $cKvYK.jsxs)("div", {
                    children: [
                        title,
                        " ",
                        isActive ? /*#__PURE__*/ (0, $cKvYK.jsx)((0, $hpOSz.IconChevronUp), {}) : /*#__PURE__*/ (0, $cKvYK.jsx)((0, $hpOSz.IconChevronDown), {})
                    ]
                })
            }),
            isActive && /*#__PURE__*/ (0, $cKvYK.jsx)("div", {
                className: "mt-1 bg-light p-2 rounded-5 p-3",
                children: content
            })
        ]
    });
};
var $5dd3972b159847ba$export$2e2bcd8739ae039 = $5dd3972b159847ba$var$Accordion;

});

parcelRegister("2bv1f", function(module, exports) {

$parcel$export(module.exports, "default", () => $38c3dafb9656d22b$export$2e2bcd8739ae039);

var $cKvYK = parcelRequire("cKvYK");

var $A1zjj = parcelRequire("A1zjj");

var $lgiU2 = parcelRequire("lgiU2");

var $g4eyu = parcelRequire("g4eyu");

var $kc00y = parcelRequire("kc00y");

var $hpOSz = parcelRequire("hpOSz");

var $bYYyU = parcelRequire("bYYyU");

var $dcbq4 = parcelRequire("dcbq4");


const $38c3dafb9656d22b$var$DateSelect = ({ startDate: initialStartDate, endDate: initialEndDate, onChangeHandler: onChangeHandler, className: className, selectsRange: selectsRange = true, minDate: minDate, maxDate: maxDate, defaultMessage: defaultMessage, disabled: disabled = false, required: required = false })=>{
    (0, $g4eyu.registerLocale)("fr", (0, $A1zjj.default));
    const [hasChanged, setHasChanged] = (0, $kc00y.useState)(false);
    const [startDate, setStartDate] = (0, $kc00y.useState)(initialStartDate);
    const [endDate, setEndDate] = (0, $kc00y.useState)(initialEndDate);
    const onChange = (dates)=>{
        if (selectsRange) {
            const [startDate, endDate] = dates;
            setHasChanged(true);
            setStartDate(startDate);
            setEndDate(endDate);
        } else {
            setHasChanged(true);
            setStartDate(dates);
        }
    };
    (0, $kc00y.useEffect)(()=>{
        if (initialStartDate?.getTime() !== startDate?.getTime()) setStartDate(initialStartDate);
    }, [
        initialStartDate
    ]);
    (0, $kc00y.useEffect)(()=>{
        if (initialEndDate?.getTime() !== endDate?.getTime()) setEndDate(initialEndDate);
    }, [
        initialEndDate
    ]);
    const [ref, setRef] = (0, $kc00y.useState)(false);
    const closeCalendar = ()=>{
        ref.setOpen(false);
    };
    const onClose = ()=>{
        if (!hasChanged) return;
        setHasChanged(false);
        onChangeHandler(startDate, endDate);
    };
    // eslint-disable-next-line react/display-name
    const DateSelectInput = /*#__PURE__*/ (0, $kc00y.forwardRef)(({ onClick: onClick }, ref)=>/*#__PURE__*/ (0, $cKvYK.jsxs)("div", {
            className: className,
            children: [
                /*#__PURE__*/ (0, $cKvYK.jsxs)((0, $bYYyU.default), {
                    onClick: onClick,
                    ref: ref,
                    className: startDate || endDate ? (0, (/*@__PURE__*/$parcel$interopDefault($lgiU2)))((0, {}).select, (0, {}).before) : (0, {}).button,
                    disabled: disabled,
                    children: [
                        /*#__PURE__*/ (0, $cKvYK.jsx)((0, $hpOSz.IconCalendarDay), {}),
                        "\xa0",
                        /*#__PURE__*/ (0, $cKvYK.jsx)((0, $dcbq4.DateRange), {
                            start: startDate,
                            end: endDate,
                            defaultMessage: defaultMessage
                        })
                    ]
                }),
                (startDate || endDate) && /*#__PURE__*/ (0, $cKvYK.jsx)((0, $bYYyU.default), {
                    onClick: ()=>{
                        setStartDate(undefined);
                        setEndDate(undefined);
                        onChangeHandler(undefined, undefined);
                    },
                    className: (0, {}).delete,
                    disabled: disabled,
                    children: "\u2715"
                })
            ]
        }));
    return /*#__PURE__*/ (0, $cKvYK.jsxs)("div", {
        className: (0, {}).align,
        children: [
            /*#__PURE__*/ (0, $cKvYK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g4eyu))), {
                ref: (r)=>{
                    setRef(r);
                },
                locale: "fr",
                todayButton: "Aujourd'hui",
                onChange: onChange,
                customInput: /*#__PURE__*/ (0, $cKvYK.jsx)(DateSelectInput, {}),
                selected: startDate,
                startDate: startDate,
                endDate: endDate,
                shouldCloseOnSelect: false,
                onCalendarClose: onClose,
                selectsRange: selectsRange,
                minDate: minDate,
                maxDate: maxDate,
                disabled: disabled,
                popperClassName: (0, {}).picker,
                children: /*#__PURE__*/ (0, $cKvYK.jsx)((0, $bYYyU.default), {
                    className: (0, {}).appliquer,
                    variant: "primary",
                    onClick: closeCalendar,
                    children: "Appliquer"
                })
            }),
            required && /*#__PURE__*/ (0, $cKvYK.jsx)("span", {
                className: (0, {}).obligatoire,
                children: "*"
            })
        ]
    });
};
var $38c3dafb9656d22b$export$2e2bcd8739ae039 = $38c3dafb9656d22b$var$DateSelect;

});
parcelRegister("A1zjj", function(module, exports) {

$parcel$export(module.exports, "default", () => $c75bbcb68987fc70$export$2e2bcd8739ae039);

var $huOzP = parcelRequire("huOzP");

var $25nsr = parcelRequire("25nsr");

var $ktNjB = parcelRequire("ktNjB");

var $2rb2i = parcelRequire("2rb2i");

var $jV0Rl = parcelRequire("jV0Rl");
const $c75bbcb68987fc70$export$acb2a88f7d552ebf = {
    code: "fr",
    formatDistance: (0, $huOzP.formatDistance),
    formatLong: (0, $25nsr.formatLong),
    formatRelative: (0, $ktNjB.formatRelative),
    localize: (0, $2rb2i.localize),
    match: (0, $jV0Rl.match),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var // Fallback for modularized imports:
$c75bbcb68987fc70$export$2e2bcd8739ae039 = $c75bbcb68987fc70$export$acb2a88f7d552ebf;

});
parcelRegister("huOzP", function(module, exports) {

$parcel$export(module.exports, "formatDistance", () => $943abf4cf0b03353$export$2c14ff85d6318973);
const $943abf4cf0b03353$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "moins d\u2019une seconde",
        other: "moins de {{count}} secondes"
    },
    xSeconds: {
        one: "1 seconde",
        other: "{{count}} secondes"
    },
    halfAMinute: "30 secondes",
    lessThanXMinutes: {
        one: "moins d\u2019une minute",
        other: "moins de {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "environ 1 heure",
        other: "environ {{count}} heures"
    },
    xHours: {
        one: "1 heure",
        other: "{{count}} heures"
    },
    xDays: {
        one: "1 jour",
        other: "{{count}} jours"
    },
    aboutXWeeks: {
        one: "environ 1 semaine",
        other: "environ {{count}} semaines"
    },
    xWeeks: {
        one: "1 semaine",
        other: "{{count}} semaines"
    },
    aboutXMonths: {
        one: "environ 1 mois",
        other: "environ {{count}} mois"
    },
    xMonths: {
        one: "1 mois",
        other: "{{count}} mois"
    },
    aboutXYears: {
        one: "environ 1 an",
        other: "environ {{count}} ans"
    },
    xYears: {
        one: "1 an",
        other: "{{count}} ans"
    },
    overXYears: {
        one: "plus d\u2019un an",
        other: "plus de {{count}} ans"
    },
    almostXYears: {
        one: "presqu\u2019un an",
        other: "presque {{count}} ans"
    }
};
const $943abf4cf0b03353$export$2c14ff85d6318973 = (token, count, options)=>{
    let result;
    const form = $943abf4cf0b03353$var$formatDistanceLocale[token];
    if (typeof form === "string") result = form;
    else if (count === 1) result = form.one;
    else result = form.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "dans " + result;
        else return "il y a " + result;
    }
    return result;
};

});

parcelRegister("25nsr", function(module, exports) {

$parcel$export(module.exports, "formatLong", () => $fafbe32bf166d333$export$cbf60ecb96cbb82f);

var $7Dxlf = parcelRequire("7Dxlf");
const $fafbe32bf166d333$var$dateFormats = {
    full: "EEEE d MMMM y",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "dd/MM/y"
};
const $fafbe32bf166d333$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $fafbe32bf166d333$var$dateTimeFormats = {
    full: "{{date}} '\xe0' {{time}}",
    long: "{{date}} '\xe0' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $fafbe32bf166d333$export$cbf60ecb96cbb82f = {
    date: (0, $7Dxlf.buildFormatLongFn)({
        formats: $fafbe32bf166d333$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $7Dxlf.buildFormatLongFn)({
        formats: $fafbe32bf166d333$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $7Dxlf.buildFormatLongFn)({
        formats: $fafbe32bf166d333$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("ktNjB", function(module, exports) {

$parcel$export(module.exports, "formatRelative", () => $99b3ccfba322b6fa$export$8fbbfd65594f46a0);
const $99b3ccfba322b6fa$var$formatRelativeLocale = {
    lastWeek: "eeee 'dernier \xe0' p",
    yesterday: "'hier \xe0' p",
    today: "'aujourd\u2019hui \xe0' p",
    tomorrow: "'demain \xe0' p'",
    nextWeek: "eeee 'prochain \xe0' p",
    other: "P"
};
const $99b3ccfba322b6fa$export$8fbbfd65594f46a0 = (token, _date, _baseDate, _options)=>$99b3ccfba322b6fa$var$formatRelativeLocale[token];

});

parcelRegister("2rb2i", function(module, exports) {

$parcel$export(module.exports, "localize", () => $656d44e7ef71865c$export$b3bd0bc58e36cd63);

var $cJ3Ig = parcelRequire("cJ3Ig");
const $656d44e7ef71865c$var$eraValues = {
    narrow: [
        "av. J.-C",
        "ap. J.-C"
    ],
    abbreviated: [
        "av. J.-C",
        "ap. J.-C"
    ],
    wide: [
        "avant J\xe9sus-Christ",
        "apr\xe8s J\xe9sus-Christ"
    ]
};
const $656d44e7ef71865c$var$quarterValues = {
    narrow: [
        "T1",
        "T2",
        "T3",
        "T4"
    ],
    abbreviated: [
        "1er trim.",
        "2\xe8me trim.",
        "3\xe8me trim.",
        "4\xe8me trim."
    ],
    wide: [
        "1er trimestre",
        "2\xe8me trimestre",
        "3\xe8me trimestre",
        "4\xe8me trimestre"
    ]
};
const $656d44e7ef71865c$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "janv.",
        "f\xe9vr.",
        "mars",
        "avr.",
        "mai",
        "juin",
        "juil.",
        "ao\xfbt",
        "sept.",
        "oct.",
        "nov.",
        "d\xe9c."
    ],
    wide: [
        "janvier",
        "f\xe9vrier",
        "mars",
        "avril",
        "mai",
        "juin",
        "juillet",
        "ao\xfbt",
        "septembre",
        "octobre",
        "novembre",
        "d\xe9cembre"
    ]
};
const $656d44e7ef71865c$var$dayValues = {
    narrow: [
        "D",
        "L",
        "M",
        "M",
        "J",
        "V",
        "S"
    ],
    short: [
        "di",
        "lu",
        "ma",
        "me",
        "je",
        "ve",
        "sa"
    ],
    abbreviated: [
        "dim.",
        "lun.",
        "mar.",
        "mer.",
        "jeu.",
        "ven.",
        "sam."
    ],
    wide: [
        "dimanche",
        "lundi",
        "mardi",
        "mercredi",
        "jeudi",
        "vendredi",
        "samedi"
    ]
};
const $656d44e7ef71865c$var$dayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "minuit",
        noon: "midi",
        morning: "mat.",
        afternoon: "ap.m.",
        evening: "soir",
        night: "mat."
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "minuit",
        noon: "midi",
        morning: "matin",
        afternoon: "apr\xe8s-midi",
        evening: "soir",
        night: "matin"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "minuit",
        noon: "midi",
        morning: "du matin",
        afternoon: "de l\u2019apr\xe8s-midi",
        evening: "du soir",
        night: "du matin"
    }
};
const $656d44e7ef71865c$var$ordinalNumber = (dirtyNumber, options)=>{
    const number = Number(dirtyNumber);
    const unit = options?.unit;
    if (number === 0) return "0";
    const feminineUnits = [
        "year",
        "week",
        "hour",
        "minute",
        "second"
    ];
    let suffix;
    if (number === 1) suffix = unit && feminineUnits.includes(unit) ? "\xe8re" : "er";
    else suffix = "\xe8me";
    return number + suffix;
};
const $656d44e7ef71865c$var$LONG_MONTHS_TOKENS = [
    "MMM",
    "MMMM"
];
const $656d44e7ef71865c$export$b3bd0bc58e36cd63 = {
    preprocessor: (date, parts)=>{
        // Replaces the `do` tokens with `d` when used with long month tokens and the day of the month is greater than one.
        // Use case "do MMMM" => 1er août, 29 août
        // see https://github.com/date-fns/date-fns/issues/1391
        if (date.getDate() === 1) return parts;
        const hasLongMonthToken = parts.some((part)=>part.isToken && $656d44e7ef71865c$var$LONG_MONTHS_TOKENS.includes(part.value));
        if (!hasLongMonthToken) return parts;
        return parts.map((part)=>part.isToken && part.value === "do" ? {
                isToken: true,
                value: "d"
            } : part);
    },
    ordinalNumber: $656d44e7ef71865c$var$ordinalNumber,
    era: (0, $cJ3Ig.buildLocalizeFn)({
        values: $656d44e7ef71865c$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $cJ3Ig.buildLocalizeFn)({
        values: $656d44e7ef71865c$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $cJ3Ig.buildLocalizeFn)({
        values: $656d44e7ef71865c$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $cJ3Ig.buildLocalizeFn)({
        values: $656d44e7ef71865c$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $cJ3Ig.buildLocalizeFn)({
        values: $656d44e7ef71865c$var$dayPeriodValues,
        defaultWidth: "wide"
    })
};

});

parcelRegister("jV0Rl", function(module, exports) {

$parcel$export(module.exports, "match", () => $45a357fe39a07ed0$export$4659b591c19bdf3d);

var $iypC7 = parcelRequire("iypC7");

var $bxAmt = parcelRequire("bxAmt");
const $45a357fe39a07ed0$var$matchOrdinalNumberPattern = /^(\d+)(ième|ère|ème|er|e)?/i;
const $45a357fe39a07ed0$var$parseOrdinalNumberPattern = /\d+/i;
const $45a357fe39a07ed0$var$matchEraPatterns = {
    narrow: /^(av\.J\.C|ap\.J\.C|ap\.J\.-C)/i,
    abbreviated: /^(av\.J\.-C|av\.J-C|apr\.J\.-C|apr\.J-C|ap\.J-C)/i,
    wide: /^(avant Jésus-Christ|après Jésus-Christ)/i
};
const $45a357fe39a07ed0$var$parseEraPatterns = {
    any: [
        /^av/i,
        /^ap/i
    ]
};
const $45a357fe39a07ed0$var$matchQuarterPatterns = {
    narrow: /^T?[1234]/i,
    abbreviated: /^[1234](er|ème|e)? trim\.?/i,
    wide: /^[1234](er|ème|e)? trimestre/i
};
const $45a357fe39a07ed0$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $45a357fe39a07ed0$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(janv|févr|mars|avr|mai|juin|juill|juil|août|sept|oct|nov|déc)\.?/i,
    wide: /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i
};
const $45a357fe39a07ed0$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^av/i,
        /^ma/i,
        /^juin/i,
        /^juil/i,
        /^ao/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $45a357fe39a07ed0$var$matchDayPatterns = {
    narrow: /^[lmjvsd]/i,
    short: /^(di|lu|ma|me|je|ve|sa)/i,
    abbreviated: /^(dim|lun|mar|mer|jeu|ven|sam)\.?/i,
    wide: /^(dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi)/i
};
const $45a357fe39a07ed0$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^j/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^di/i,
        /^lu/i,
        /^ma/i,
        /^me/i,
        /^je/i,
        /^ve/i,
        /^sa/i
    ]
};
const $45a357fe39a07ed0$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|minuit|midi|mat\.?|ap\.?m\.?|soir|nuit)/i,
    any: /^([ap]\.?\s?m\.?|du matin|de l'après[-\s]midi|du soir|de la nuit)/i
};
const $45a357fe39a07ed0$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^min/i,
        noon: /^mid/i,
        morning: /mat/i,
        afternoon: /ap/i,
        evening: /soir/i,
        night: /nuit/i
    }
};
const $45a357fe39a07ed0$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $bxAmt.buildMatchPatternFn)({
        matchPattern: $45a357fe39a07ed0$var$matchOrdinalNumberPattern,
        parsePattern: $45a357fe39a07ed0$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value)
    }),
    era: (0, $iypC7.buildMatchFn)({
        matchPatterns: $45a357fe39a07ed0$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $45a357fe39a07ed0$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $iypC7.buildMatchFn)({
        matchPatterns: $45a357fe39a07ed0$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $45a357fe39a07ed0$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $iypC7.buildMatchFn)({
        matchPatterns: $45a357fe39a07ed0$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $45a357fe39a07ed0$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $iypC7.buildMatchFn)({
        matchPatterns: $45a357fe39a07ed0$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $45a357fe39a07ed0$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $iypC7.buildMatchFn)({
        matchPatterns: $45a357fe39a07ed0$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $45a357fe39a07ed0$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("g4eyu", function(module, exports) {
/*!
  react-datepicker v6.9.0
  https://github.com/Hacker0x01/react-datepicker
  Released under the MIT License.
*/ 
































































!function(e, t) {
    t(module.exports, (parcelRequire("kc00y")), (parcelRequire("lCkAA")), (parcelRequire("eGWiI")), (parcelRequire("lXTbz")), (parcelRequire("gwJip")), (parcelRequire("dmAUx")), (parcelRequire("hB2gy")), (parcelRequire("2s8DN")), (parcelRequire("jKYo1")), (parcelRequire("41ovE")), (parcelRequire("9qaFH")), (parcelRequire("53mjM")), (parcelRequire("f17A2")), (parcelRequire("04GVu")), (parcelRequire("l05JD")), (parcelRequire("e04FR")), (parcelRequire("gRtvC")), (parcelRequire("3kUAA")), (parcelRequire("2zELa")), (parcelRequire("gtzUl")), (parcelRequire("l5B1g")), (parcelRequire("4uPa5")), (parcelRequire("jBSa0")), (parcelRequire("730vp")), (parcelRequire("kTdkQ")), (parcelRequire("dQGvM")), (parcelRequire("dmBSy")), (parcelRequire("3ynSJ")), (parcelRequire("aLgYk")), (parcelRequire("bNJqN")), (parcelRequire("gnwRT")), (parcelRequire("03Fkt")), (parcelRequire("9N6zy")), (parcelRequire("h7pJ2")), (parcelRequire("hM1St")), (parcelRequire("3Mprz")), (parcelRequire("hzJYa")), (parcelRequire("lVxGX")), (parcelRequire("4j185")), (parcelRequire("2RSNs")), (parcelRequire("lPouQ")), (parcelRequire("aSLbu")), (parcelRequire("biOJg")), (parcelRequire("1c3d7")), (parcelRequire("icgCh")), (parcelRequire("lU13w")), (parcelRequire("eKR0J")), (parcelRequire("3pk6v")), (parcelRequire("igoTU")), (parcelRequire("36H1l")), (parcelRequire("iROfp")), (parcelRequire("4q5v8")), (parcelRequire("jjrXQ")), (parcelRequire("gjoJZ")), (parcelRequire("3MRYq")), (parcelRequire("4t8V5")), (parcelRequire("1PA9H")), (parcelRequire("26OhI")), (parcelRequire("foHqe")), (parcelRequire("lu2oh")), (parcelRequire("iJNol")), (parcelRequire("8mGSD")), (parcelRequire("cn1Kz")), (parcelRequire("cfq7u")), (parcelRequire("4YV2O")));
}(module.exports, function(e, t, r, n, a, o, s, i, p, c, l, d, u, h, f, m, y, g, v, D, k, w, b, S, M, C, _, Y, E, P, N, O, x, I, T, R, L, F, A, W, Q, K, q, B, H, j, V, U, $, z, G, J, X, Z, ee, te, re, ne, ae, oe, se, ie, pe, ce, le, de) {
    "use strict";
    function ue(e) {
        return e && "object" == typeof e && "default" in e ? e : {
            default: e
        };
    }
    var he = ue(t), fe = ue(pe), me = ue(ce);
    function ye(e, t, r) {
        return t = Ee(t), function(e, t) {
            if (t && ("object" == typeof t || "function" == typeof t)) return t;
            if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
            return function(e) {
                if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return e;
            }(e);
        }(e, ge() ? Reflect.construct(t, r || [], Ee(e).constructor) : t.apply(e, r));
    }
    function ge() {
        try {
            var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        } catch (e) {}
        return (ge = function() {
            return !!e;
        })();
    }
    function ve(e, t) {
        var r = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(e);
            t && (n = n.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), r.push.apply(r, n);
        }
        return r;
    }
    function De(e) {
        for(var t = 1; t < arguments.length; t++){
            var r = null != arguments[t] ? arguments[t] : {};
            t % 2 ? ve(Object(r), !0).forEach(function(t) {
                Ce(e, t, r[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ve(Object(r)).forEach(function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
            });
        }
        return e;
    }
    function ke(e) {
        var t = function(e, t) {
            if ("object" != typeof e || !e) return e;
            var r = e[Symbol.toPrimitive];
            if (void 0 !== r) {
                var n = r.call(e, t || "default");
                if ("object" != typeof n) return n;
                throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return ("string" === t ? String : Number)(e);
        }(e, "string");
        return "symbol" == typeof t ? t : t + "";
    }
    function we(e) {
        return we = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e;
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        }, we(e);
    }
    function be(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function Se(e, t) {
        for(var r = 0; r < t.length; r++){
            var n = t[r];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, ke(n.key), n);
        }
    }
    function Me(e, t, r) {
        return t && Se(e.prototype, t), r && Se(e, r), Object.defineProperty(e, "prototype", {
            writable: !1
        }), e;
    }
    function Ce(e, t, r) {
        return (t = ke(t)) in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = r, e;
    }
    function _e() {
        return _e = Object.assign ? Object.assign.bind() : function(e) {
            for(var t = 1; t < arguments.length; t++){
                var r = arguments[t];
                for(var n in r)Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
            }
            return e;
        }, _e.apply(this, arguments);
    }
    function Ye(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
            constructor: {
                value: e,
                writable: !0,
                configurable: !0
            }
        }), Object.defineProperty(e, "prototype", {
            writable: !1
        }), t && Pe(e, t);
    }
    function Ee(e) {
        return Ee = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
            return e.__proto__ || Object.getPrototypeOf(e);
        }, Ee(e);
    }
    function Pe(e, t) {
        return Pe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
            return e.__proto__ = t, e;
        }, Pe(e, t);
    }
    function Ne(e) {
        return function(e) {
            if (Array.isArray(e)) return Oe(e);
        }(e) || function(e) {
            if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
        }(e) || function(e, t) {
            if (!e) return;
            if ("string" == typeof e) return Oe(e, t);
            var r = Object.prototype.toString.call(e).slice(8, -1);
            "Object" === r && e.constructor && (r = e.constructor.name);
            if ("Map" === r || "Set" === r) return Array.from(e);
            if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Oe(e, t);
        }(e) || function() {
            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }();
    }
    function Oe(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for(var r = 0, n = new Array(t); r < t; r++)n[r] = e[r];
        return n;
    }
    var xe = 12, Ie = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
    function Te(e) {
        var t = e ? "string" == typeof e || e instanceof String ? se.parseISO(e) : ae.toDate(e) : new Date;
        return Re(t) ? t : null;
    }
    function Re(e, t) {
        return t = t || new Date("1/1/1000"), o.isValid(e) && !re.isBefore(e, t);
    }
    function Le(e, t, r) {
        if ("en" === r) return s.format(e, t, {
            useAdditionalWeekYearTokens: !0,
            useAdditionalDayOfYearTokens: !0
        });
        var n = Je(r);
        return r && !n && console.warn('A locale object was not found for the provided string ["'.concat(r, '"].')), !n && Ge() && Je(Ge()) && (n = Je(Ge())), s.format(e, t, {
            locale: n || null,
            useAdditionalWeekYearTokens: !0,
            useAdditionalDayOfYearTokens: !0
        });
    }
    function Fe(e, t) {
        var r = t.dateFormat, n = t.locale;
        return e && Le(e, Array.isArray(r) ? r[0] : r, n) || "";
    }
    function Ae(e, t) {
        var r = t.hour, n = void 0 === r ? 0 : r, a = t.minute, o = void 0 === a ? 0 : a, s = t.second, i = void 0 === s ? 0 : s;
        return O.setHours(N.setMinutes(P.setSeconds(e, i), o), n);
    }
    function We(e, t, r) {
        var n = Je(t || Ge());
        return q.startOfWeek(e, {
            locale: n,
            weekStartsOn: r
        });
    }
    function Qe(e) {
        return B.startOfMonth(e);
    }
    function Ke(e) {
        return j.startOfYear(e);
    }
    function qe(e) {
        return H.startOfQuarter(e);
    }
    function Be() {
        return K.startOfDay(Te());
    }
    function He(e, t) {
        return e && t ? Z.isSameYear(e, t) : !e && !t;
    }
    function je(e, t) {
        return e && t ? X.isSameMonth(e, t) : !e && !t;
    }
    function Ve(e, t) {
        return e && t ? ee.isSameQuarter(e, t) : !e && !t;
    }
    function Ue(e, t) {
        return e && t ? J.isSameDay(e, t) : !e && !t;
    }
    function $e(e, t) {
        return e && t ? G.isEqual(e, t) : !e && !t;
    }
    function ze(e, t, r) {
        var n, a = K.startOfDay(t), o = V.endOfDay(r);
        try {
            n = ne.isWithinInterval(e, {
                start: a,
                end: o
            });
        } catch (e) {
            n = !1;
        }
        return n;
    }
    function Ge() {
        return ("undefined" != typeof window ? window : globalThis).__localeId__;
    }
    function Je(e) {
        if ("string" == typeof e) {
            var t = "undefined" != typeof window ? window : globalThis;
            return t.__localeData__ ? t.__localeData__[e] : null;
        }
        return e;
    }
    function Xe(e, t) {
        return Le(x.setMonth(Te(), e), "LLLL", t);
    }
    function Ze(e, t) {
        return Le(x.setMonth(Te(), e), "LLL", t);
    }
    function et(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, n = t.maxDate, a = t.excludeDates, o = t.excludeDateIntervals, s = t.includeDates, i = t.includeDateIntervals, p = t.filterDate;
        return pt(e, {
            minDate: r,
            maxDate: n
        }) || a && a.some(function(t) {
            return Ue(e, t.date ? t.date : t);
        }) || o && o.some(function(t) {
            var r = t.start, n = t.end;
            return ne.isWithinInterval(e, {
                start: r,
                end: n
            });
        }) || s && !s.some(function(t) {
            return Ue(e, t);
        }) || i && !i.some(function(t) {
            var r = t.start, n = t.end;
            return ne.isWithinInterval(e, {
                start: r,
                end: n
            });
        }) || p && !p(Te(e)) || !1;
    }
    function tt(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.excludeDates, n = t.excludeDateIntervals;
        return n && n.length > 0 ? n.some(function(t) {
            var r = t.start, n = t.end;
            return ne.isWithinInterval(e, {
                start: r,
                end: n
            });
        }) : r && r.some(function(t) {
            return Ue(e, t.date ? t.date : t);
        }) || !1;
    }
    function rt(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, n = t.maxDate, a = t.excludeDates, o = t.includeDates, s = t.filterDate;
        return pt(e, {
            minDate: B.startOfMonth(r),
            maxDate: $.endOfMonth(n)
        }) || a && a.some(function(t) {
            return je(e, t);
        }) || o && !o.some(function(t) {
            return je(e, t);
        }) || s && !s(Te(e)) || !1;
    }
    function nt(e, t, r, n) {
        var a = Y.getYear(e), o = C.getMonth(e), s = Y.getYear(t), i = C.getMonth(t), p = Y.getYear(n);
        return a === s && a === p ? o <= r && r <= i : a < s ? p === a && o <= r || p === s && i >= r || p < s && p > a : void 0;
    }
    function at(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, n = t.maxDate, a = t.excludeDates, o = t.includeDates, s = t.filterDate;
        return pt(e, {
            minDate: r,
            maxDate: n
        }) || a && a.some(function(t) {
            return Ve(e, t);
        }) || o && !o.some(function(t) {
            return Ve(e, t);
        }) || s && !s(Te(e)) || !1;
    }
    function ot(e, t, r) {
        if (!o.isValid(t) || !o.isValid(r)) return !1;
        var n = Y.getYear(t), a = Y.getYear(r);
        return n <= e && a >= e;
    }
    function st(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, n = t.maxDate, a = t.excludeDates, o = t.includeDates, s = t.filterDate, i = new Date(e, 0, 1);
        return pt(i, {
            minDate: j.startOfYear(r),
            maxDate: z.endOfYear(n)
        }) || a && a.some(function(e) {
            return He(i, e);
        }) || o && !o.some(function(e) {
            return He(i, e);
        }) || s && !s(Te(i)) || !1;
    }
    function it(e, t, r, n) {
        var a = Y.getYear(e), o = _.getQuarter(e), s = Y.getYear(t), i = _.getQuarter(t), p = Y.getYear(n);
        return a === s && a === p ? o <= r && r <= i : a < s ? p === a && o <= r || p === s && i >= r || p < s && p > a : void 0;
    }
    function pt(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, n = t.maxDate;
        return r && F.differenceInCalendarDays(e, r) < 0 || n && F.differenceInCalendarDays(e, n) > 0;
    }
    function ct(e, t) {
        return t.some(function(t) {
            return w.getHours(t) === w.getHours(e) && k.getMinutes(t) === k.getMinutes(e) && D.getSeconds(t) === D.getSeconds(e);
        });
    }
    function lt(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.excludeTimes, n = t.includeTimes, a = t.filterTime;
        return r && ct(e, r) || n && !ct(e, n) || a && !a(e) || !1;
    }
    function dt(e, t) {
        var r = t.minTime, n = t.maxTime;
        if (!r || !n) throw new Error("Both minTime and maxTime props required");
        var a = Te();
        a = O.setHours(a, w.getHours(e)), a = N.setMinutes(a, k.getMinutes(e)), a = P.setSeconds(a, D.getSeconds(e));
        var o = Te();
        o = O.setHours(o, w.getHours(r)), o = N.setMinutes(o, k.getMinutes(r)), o = P.setSeconds(o, D.getSeconds(r));
        var s, i = Te();
        i = O.setHours(i, w.getHours(n)), i = N.setMinutes(i, k.getMinutes(n)), i = P.setSeconds(i, D.getSeconds(n));
        try {
            s = !ne.isWithinInterval(a, {
                start: o,
                end: i
            });
        } catch (e) {
            s = !1;
        }
        return s;
    }
    function ut(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, n = t.includeDates, a = y.subMonths(e, 1);
        return r && A.differenceInCalendarMonths(r, a) > 0 || n && n.every(function(e) {
            return A.differenceInCalendarMonths(e, a) > 0;
        }) || !1;
    }
    function ht(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.maxDate, n = t.includeDates, a = d.addMonths(e, 1);
        return r && A.differenceInCalendarMonths(a, r) > 0 || n && n.every(function(e) {
            return A.differenceInCalendarMonths(a, e) > 0;
        }) || !1;
    }
    function ft(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, n = t.includeDates, a = v.subYears(e, 1);
        return r && W.differenceInCalendarYears(r, a) > 0 || n && n.every(function(e) {
            return W.differenceInCalendarYears(e, a) > 0;
        }) || !1;
    }
    function mt(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.maxDate, n = t.includeDates, a = h.addYears(e, 1);
        return r && W.differenceInCalendarYears(a, r) > 0 || n && n.every(function(e) {
            return W.differenceInCalendarYears(a, e) > 0;
        }) || !1;
    }
    function yt(e) {
        var t = e.minDate, r = e.includeDates;
        if (r && t) {
            var n = r.filter(function(e) {
                return F.differenceInCalendarDays(e, t) >= 0;
            });
            return R.min(n);
        }
        return r ? R.min(r) : t;
    }
    function gt(e) {
        var t = e.maxDate, r = e.includeDates;
        if (r && t) {
            var n = r.filter(function(e) {
                return F.differenceInCalendarDays(e, t) <= 0;
            });
            return L.max(n);
        }
        return r ? L.max(r) : t;
    }
    function vt() {
        for(var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "react-datepicker__day--highlighted", r = new Map, n = 0, o = e.length; n < o; n++){
            var s = e[n];
            if (a.isDate(s)) {
                var i = Le(s, "MM.dd.yyyy"), p = r.get(i) || [];
                p.includes(t) || (p.push(t), r.set(i, p));
            } else if ("object" === we(s)) {
                var c = Object.keys(s), l = c[0], d = s[c[0]];
                if ("string" == typeof l && d.constructor === Array) for(var u = 0, h = d.length; u < h; u++){
                    var f = Le(d[u], "MM.dd.yyyy"), m = r.get(f) || [];
                    m.includes(l) || (m.push(l), r.set(f, m));
                }
            }
        }
        return r;
    }
    function Dt() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "react-datepicker__day--holidays", r = new Map;
        return e.forEach(function(e) {
            var n = e.date, o = e.holidayName;
            if (a.isDate(n)) {
                var s = Le(n, "MM.dd.yyyy"), i = r.get(s) || {};
                if (!("className" in i) || i.className !== t || (p = i.holidayNames, c = [
                    o
                ], p.length !== c.length || !p.every(function(e, t) {
                    return e === c[t];
                }))) {
                    var p, c;
                    i.className = t;
                    var l = i.holidayNames;
                    i.holidayNames = l ? [].concat(Ne(l), [
                        o
                    ]) : [
                        o
                    ], r.set(s, i);
                }
            }
        }), r;
    }
    function kt(e, t, r, n, a) {
        for(var o = a.length, s = [], c = 0; c < o; c++){
            var l = e;
            l = p.addHours(l, w.getHours(a[c])), l = i.addMinutes(l, k.getMinutes(a[c])), l = ie.addSeconds(l, D.getSeconds(a[c]));
            var d = i.addMinutes(e, (r + 1) * n);
            te.isAfter(l, t) && re.isBefore(l, d) && s.push(a[c]);
        }
        return s;
    }
    function wt(e) {
        return e < 10 ? "0".concat(e) : "".concat(e);
    }
    function bt(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : xe, r = Math.ceil(Y.getYear(e) / t) * t;
        return {
            startPeriod: r - (t - 1),
            endPeriod: r
        };
    }
    function St(e) {
        var t = e.getSeconds(), r = e.getMilliseconds();
        return ae.toDate(e.getTime() - 1e3 * t - r);
    }
    function Mt(e) {
        if (!a.isDate(e)) throw new Error("Invalid date");
        var t = new Date(e);
        return t.setHours(0, 0, 0, 0), t;
    }
    function Ct(e, t) {
        if (!a.isDate(e) || !a.isDate(t)) throw new Error("Invalid date received");
        var r = Mt(e), n = Mt(t);
        return re.isBefore(r, n);
    }
    function _t(e) {
        return " " === e.key;
    }
    function Yt(e, t, r, n) {
        for(var a = [], o = 0; o < 2 * t + 1; o++){
            var s = e + t - o, i = !0;
            r && (i = Y.getYear(r) <= s), n && i && (i = Y.getYear(n) >= s), i && a.push(s);
        }
        return a;
    }
    var Et = function(e) {
        function r(e) {
            var n;
            be(this, r), Ce(n = ye(this, r, [
                e
            ]), "renderOptions", function() {
                var e = n.props.year, t = n.state.yearsList.map(function(t) {
                    return he.default.createElement("div", {
                        className: e === t ? "react-datepicker__year-option react-datepicker__year-option--selected_year" : "react-datepicker__year-option",
                        key: t,
                        onClick: n.onChange.bind(n, t),
                        "aria-selected": e === t ? "true" : void 0
                    }, e === t ? he.default.createElement("span", {
                        className: "react-datepicker__year-option--selected"
                    }, "\u2713") : "", t);
                }), r = n.props.minDate ? Y.getYear(n.props.minDate) : null, a = n.props.maxDate ? Y.getYear(n.props.maxDate) : null;
                return a && n.state.yearsList.find(function(e) {
                    return e === a;
                }) || t.unshift(he.default.createElement("div", {
                    className: "react-datepicker__year-option",
                    key: "upcoming",
                    onClick: n.incrementYears
                }, he.default.createElement("a", {
                    className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming"
                }))), r && n.state.yearsList.find(function(e) {
                    return e === r;
                }) || t.push(he.default.createElement("div", {
                    className: "react-datepicker__year-option",
                    key: "previous",
                    onClick: n.decrementYears
                }, he.default.createElement("a", {
                    className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous"
                }))), t;
            }), Ce(n, "onChange", function(e) {
                n.props.onChange(e);
            }), Ce(n, "handleClickOutside", function() {
                n.props.onCancel();
            }), Ce(n, "shiftYears", function(e) {
                var t = n.state.yearsList.map(function(t) {
                    return t + e;
                });
                n.setState({
                    yearsList: t
                });
            }), Ce(n, "incrementYears", function() {
                return n.shiftYears(1);
            }), Ce(n, "decrementYears", function() {
                return n.shiftYears(-1);
            });
            var a = e.yearDropdownItemNumber, o = e.scrollableYearDropdown, s = a || (o ? 10 : 5);
            return n.state = {
                yearsList: Yt(n.props.year, s, n.props.minDate, n.props.maxDate)
            }, n.dropdownRef = t.createRef(), n;
        }
        return Ye(r, e), Me(r, [
            {
                key: "componentDidMount",
                value: function() {
                    var e = this.dropdownRef.current;
                    if (e) {
                        var t = e.children ? Array.from(e.children) : null, r = t ? t.find(function(e) {
                            return e.ariaSelected;
                        }) : null;
                        e.scrollTop = r ? r.offsetTop + (r.clientHeight - e.clientHeight) / 2 : (e.scrollHeight - e.clientHeight) / 2;
                    }
                }
            },
            {
                key: "render",
                value: function() {
                    var e = n.clsx({
                        "react-datepicker__year-dropdown": !0,
                        "react-datepicker__year-dropdown--scrollable": this.props.scrollableYearDropdown
                    });
                    return he.default.createElement("div", {
                        className: e,
                        ref: this.dropdownRef
                    }, this.renderOptions());
                }
            }
        ]);
    }(he.default.Component), Pt = fe.default(Et), Nt = function(e) {
        function t() {
            var e;
            be(this, t);
            for(var r = arguments.length, n = new Array(r), a = 0; a < r; a++)n[a] = arguments[a];
            return Ce(e = ye(this, t, [].concat(n)), "state", {
                dropdownVisible: !1
            }), Ce(e, "renderSelectOptions", function() {
                for(var t = e.props.minDate ? Y.getYear(e.props.minDate) : 1900, r = e.props.maxDate ? Y.getYear(e.props.maxDate) : 2100, n = [], a = t; a <= r; a++)n.push(he.default.createElement("option", {
                    key: a,
                    value: a
                }, a));
                return n;
            }), Ce(e, "onSelectChange", function(t) {
                e.onChange(t.target.value);
            }), Ce(e, "renderSelectMode", function() {
                return he.default.createElement("select", {
                    value: e.props.year,
                    className: "react-datepicker__year-select",
                    onChange: e.onSelectChange
                }, e.renderSelectOptions());
            }), Ce(e, "renderReadView", function(t) {
                return he.default.createElement("div", {
                    key: "read",
                    style: {
                        visibility: t ? "visible" : "hidden"
                    },
                    className: "react-datepicker__year-read-view",
                    onClick: function(t) {
                        return e.toggleDropdown(t);
                    }
                }, he.default.createElement("span", {
                    className: "react-datepicker__year-read-view--down-arrow"
                }), he.default.createElement("span", {
                    className: "react-datepicker__year-read-view--selected-year"
                }, e.props.year));
            }), Ce(e, "renderDropdown", function() {
                return he.default.createElement(Pt, {
                    key: "dropdown",
                    year: e.props.year,
                    onChange: e.onChange,
                    onCancel: e.toggleDropdown,
                    minDate: e.props.minDate,
                    maxDate: e.props.maxDate,
                    scrollableYearDropdown: e.props.scrollableYearDropdown,
                    yearDropdownItemNumber: e.props.yearDropdownItemNumber
                });
            }), Ce(e, "renderScrollMode", function() {
                var t = e.state.dropdownVisible, r = [
                    e.renderReadView(!t)
                ];
                return t && r.unshift(e.renderDropdown()), r;
            }), Ce(e, "onChange", function(t) {
                e.toggleDropdown(), t !== e.props.year && e.props.onChange(t);
            }), Ce(e, "toggleDropdown", function(t) {
                e.setState({
                    dropdownVisible: !e.state.dropdownVisible
                }, function() {
                    e.props.adjustDateOnChange && e.handleYearChange(e.props.date, t);
                });
            }), Ce(e, "handleYearChange", function(t, r) {
                e.onSelect(t, r), e.setOpen();
            }), Ce(e, "onSelect", function(t, r) {
                e.props.onSelect && e.props.onSelect(t, r);
            }), Ce(e, "setOpen", function() {
                e.props.setOpen && e.props.setOpen(!0);
            }), e;
        }
        return Ye(t, e), Me(t, [
            {
                key: "render",
                value: function() {
                    var e;
                    switch(this.props.dropdownMode){
                        case "scroll":
                            e = this.renderScrollMode();
                            break;
                        case "select":
                            e = this.renderSelectMode();
                    }
                    return he.default.createElement("div", {
                        className: "react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--".concat(this.props.dropdownMode)
                    }, e);
                }
            }
        ]);
    }(he.default.Component), Ot = function(e) {
        function t() {
            var e;
            be(this, t);
            for(var r = arguments.length, n = new Array(r), a = 0; a < r; a++)n[a] = arguments[a];
            return Ce(e = ye(this, t, [].concat(n)), "isSelectedMonth", function(t) {
                return e.props.month === t;
            }), Ce(e, "renderOptions", function() {
                return e.props.monthNames.map(function(t, r) {
                    return he.default.createElement("div", {
                        className: e.isSelectedMonth(r) ? "react-datepicker__month-option react-datepicker__month-option--selected_month" : "react-datepicker__month-option",
                        key: t,
                        onClick: e.onChange.bind(e, r),
                        "aria-selected": e.isSelectedMonth(r) ? "true" : void 0
                    }, e.isSelectedMonth(r) ? he.default.createElement("span", {
                        className: "react-datepicker__month-option--selected"
                    }, "\u2713") : "", t);
                });
            }), Ce(e, "onChange", function(t) {
                return e.props.onChange(t);
            }), Ce(e, "handleClickOutside", function() {
                return e.props.onCancel();
            }), e;
        }
        return Ye(t, e), Me(t, [
            {
                key: "render",
                value: function() {
                    return he.default.createElement("div", {
                        className: "react-datepicker__month-dropdown"
                    }, this.renderOptions());
                }
            }
        ]);
    }(he.default.Component), xt = fe.default(Ot), It = function(e) {
        function t() {
            var e;
            be(this, t);
            for(var r = arguments.length, n = new Array(r), a = 0; a < r; a++)n[a] = arguments[a];
            return Ce(e = ye(this, t, [].concat(n)), "state", {
                dropdownVisible: !1
            }), Ce(e, "renderSelectOptions", function(e) {
                return e.map(function(e, t) {
                    return he.default.createElement("option", {
                        key: t,
                        value: t
                    }, e);
                });
            }), Ce(e, "renderSelectMode", function(t) {
                return he.default.createElement("select", {
                    value: e.props.month,
                    className: "react-datepicker__month-select",
                    onChange: function(t) {
                        return e.onChange(t.target.value);
                    }
                }, e.renderSelectOptions(t));
            }), Ce(e, "renderReadView", function(t, r) {
                return he.default.createElement("div", {
                    key: "read",
                    style: {
                        visibility: t ? "visible" : "hidden"
                    },
                    className: "react-datepicker__month-read-view",
                    onClick: e.toggleDropdown
                }, he.default.createElement("span", {
                    className: "react-datepicker__month-read-view--down-arrow"
                }), he.default.createElement("span", {
                    className: "react-datepicker__month-read-view--selected-month"
                }, r[e.props.month]));
            }), Ce(e, "renderDropdown", function(t) {
                return he.default.createElement(xt, {
                    key: "dropdown",
                    month: e.props.month,
                    monthNames: t,
                    onChange: e.onChange,
                    onCancel: e.toggleDropdown
                });
            }), Ce(e, "renderScrollMode", function(t) {
                var r = e.state.dropdownVisible, n = [
                    e.renderReadView(!r, t)
                ];
                return r && n.unshift(e.renderDropdown(t)), n;
            }), Ce(e, "onChange", function(t) {
                e.toggleDropdown(), t !== e.props.month && e.props.onChange(t);
            }), Ce(e, "toggleDropdown", function() {
                return e.setState({
                    dropdownVisible: !e.state.dropdownVisible
                });
            }), e;
        }
        return Ye(t, e), Me(t, [
            {
                key: "render",
                value: function() {
                    var e, t = this, r = [
                        0,
                        1,
                        2,
                        3,
                        4,
                        5,
                        6,
                        7,
                        8,
                        9,
                        10,
                        11
                    ].map(this.props.useShortMonthInDropdown ? function(e) {
                        return Ze(e, t.props.locale);
                    } : function(e) {
                        return Xe(e, t.props.locale);
                    });
                    switch(this.props.dropdownMode){
                        case "scroll":
                            e = this.renderScrollMode(r);
                            break;
                        case "select":
                            e = this.renderSelectMode(r);
                    }
                    return he.default.createElement("div", {
                        className: "react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--".concat(this.props.dropdownMode)
                    }, e);
                }
            }
        ]);
    }(he.default.Component);
    function Tt(e, t) {
        for(var r = [], n = Qe(e), a = Qe(t); !te.isAfter(n, a);)r.push(Te(n)), n = d.addMonths(n, 1);
        return r;
    }
    var Rt = function(e) {
        function t(e) {
            var r;
            return be(this, t), Ce(r = ye(this, t, [
                e
            ]), "renderOptions", function() {
                return r.state.monthYearsList.map(function(e) {
                    var t = E.getTime(e), n = He(r.props.date, e) && je(r.props.date, e);
                    return he.default.createElement("div", {
                        className: n ? "react-datepicker__month-year-option--selected_month-year" : "react-datepicker__month-year-option",
                        key: t,
                        onClick: r.onChange.bind(r, t),
                        "aria-selected": n ? "true" : void 0
                    }, n ? he.default.createElement("span", {
                        className: "react-datepicker__month-year-option--selected"
                    }, "\u2713") : "", Le(e, r.props.dateFormat, r.props.locale));
                });
            }), Ce(r, "onChange", function(e) {
                return r.props.onChange(e);
            }), Ce(r, "handleClickOutside", function() {
                r.props.onCancel();
            }), r.state = {
                monthYearsList: Tt(r.props.minDate, r.props.maxDate)
            }, r;
        }
        return Ye(t, e), Me(t, [
            {
                key: "render",
                value: function() {
                    var e = n.clsx({
                        "react-datepicker__month-year-dropdown": !0,
                        "react-datepicker__month-year-dropdown--scrollable": this.props.scrollableMonthYearDropdown
                    });
                    return he.default.createElement("div", {
                        className: e
                    }, this.renderOptions());
                }
            }
        ]);
    }(he.default.Component), Lt = fe.default(Rt), Ft = function(e) {
        function t() {
            var e;
            be(this, t);
            for(var r = arguments.length, n = new Array(r), a = 0; a < r; a++)n[a] = arguments[a];
            return Ce(e = ye(this, t, [].concat(n)), "state", {
                dropdownVisible: !1
            }), Ce(e, "renderSelectOptions", function() {
                for(var t = Qe(e.props.minDate), r = Qe(e.props.maxDate), n = []; !te.isAfter(t, r);){
                    var a = E.getTime(t);
                    n.push(he.default.createElement("option", {
                        key: a,
                        value: a
                    }, Le(t, e.props.dateFormat, e.props.locale))), t = d.addMonths(t, 1);
                }
                return n;
            }), Ce(e, "onSelectChange", function(t) {
                e.onChange(t.target.value);
            }), Ce(e, "renderSelectMode", function() {
                return he.default.createElement("select", {
                    value: E.getTime(Qe(e.props.date)),
                    className: "react-datepicker__month-year-select",
                    onChange: e.onSelectChange
                }, e.renderSelectOptions());
            }), Ce(e, "renderReadView", function(t) {
                var r = Le(e.props.date, e.props.dateFormat, e.props.locale);
                return he.default.createElement("div", {
                    key: "read",
                    style: {
                        visibility: t ? "visible" : "hidden"
                    },
                    className: "react-datepicker__month-year-read-view",
                    onClick: function(t) {
                        return e.toggleDropdown(t);
                    }
                }, he.default.createElement("span", {
                    className: "react-datepicker__month-year-read-view--down-arrow"
                }), he.default.createElement("span", {
                    className: "react-datepicker__month-year-read-view--selected-month-year"
                }, r));
            }), Ce(e, "renderDropdown", function() {
                return he.default.createElement(Lt, {
                    key: "dropdown",
                    date: e.props.date,
                    dateFormat: e.props.dateFormat,
                    onChange: e.onChange,
                    onCancel: e.toggleDropdown,
                    minDate: e.props.minDate,
                    maxDate: e.props.maxDate,
                    scrollableMonthYearDropdown: e.props.scrollableMonthYearDropdown,
                    locale: e.props.locale
                });
            }), Ce(e, "renderScrollMode", function() {
                var t = e.state.dropdownVisible, r = [
                    e.renderReadView(!t)
                ];
                return t && r.unshift(e.renderDropdown()), r;
            }), Ce(e, "onChange", function(t) {
                e.toggleDropdown();
                var r = Te(parseInt(t));
                He(e.props.date, r) && je(e.props.date, r) || e.props.onChange(r);
            }), Ce(e, "toggleDropdown", function() {
                return e.setState({
                    dropdownVisible: !e.state.dropdownVisible
                });
            }), e;
        }
        return Ye(t, e), Me(t, [
            {
                key: "render",
                value: function() {
                    var e;
                    switch(this.props.dropdownMode){
                        case "scroll":
                            e = this.renderScrollMode();
                            break;
                        case "select":
                            e = this.renderSelectMode();
                    }
                    return he.default.createElement("div", {
                        className: "react-datepicker__month-year-dropdown-container react-datepicker__month-year-dropdown-container--".concat(this.props.dropdownMode)
                    }, e);
                }
            }
        ]);
    }(he.default.Component), At = function(e) {
        function t() {
            var e;
            be(this, t);
            for(var r = arguments.length, a = new Array(r), o = 0; o < r; o++)a[o] = arguments[o];
            return Ce(e = ye(this, t, [].concat(a)), "dayEl", he.default.createRef()), Ce(e, "handleClick", function(t) {
                !e.isDisabled() && e.props.onClick && e.props.onClick(t);
            }), Ce(e, "handleMouseEnter", function(t) {
                !e.isDisabled() && e.props.onMouseEnter && e.props.onMouseEnter(t);
            }), Ce(e, "handleOnKeyDown", function(t) {
                " " === t.key && (t.preventDefault(), t.key = "Enter"), e.props.handleOnKeyDown(t);
            }), Ce(e, "isSameDay", function(t) {
                return Ue(e.props.day, t);
            }), Ce(e, "isKeyboardSelected", function() {
                var t;
                return !e.props.disabledKeyboardNavigation && !(e.props.selectsMultiple ? null === (t = e.props.selectedDates) || void 0 === t ? void 0 : t.some(function(t) {
                    return e.isSameDayOrWeek(t);
                }) : e.isSameDayOrWeek(e.props.selected)) && e.isSameDayOrWeek(e.props.preSelection);
            }), Ce(e, "isDisabled", function() {
                return et(e.props.day, e.props);
            }), Ce(e, "isExcluded", function() {
                return tt(e.props.day, e.props);
            }), Ce(e, "isStartOfWeek", function() {
                return Ue(e.props.day, We(e.props.day, e.props.locale, e.props.calendarStartDay));
            }), Ce(e, "isSameWeek", function(t) {
                return e.props.showWeekPicker && Ue(t, We(e.props.day, e.props.locale, e.props.calendarStartDay));
            }), Ce(e, "isSameDayOrWeek", function(t) {
                return e.isSameDay(t) || e.isSameWeek(t);
            }), Ce(e, "getHighLightedClass", function() {
                var t = e.props, r = t.day, n = t.highlightDates;
                if (!n) return !1;
                var a = Le(r, "MM.dd.yyyy");
                return n.get(a);
            }), Ce(e, "getHolidaysClass", function() {
                var t = e.props, r = t.day, n = t.holidays;
                if (!n) return !1;
                var a = Le(r, "MM.dd.yyyy");
                return n.has(a) ? [
                    n.get(a).className
                ] : void 0;
            }), Ce(e, "isInRange", function() {
                var t = e.props, r = t.day, n = t.startDate, a = t.endDate;
                return !(!n || !a) && ze(r, n, a);
            }), Ce(e, "isInSelectingRange", function() {
                var t, r = e.props, n = r.day, a = r.selectsStart, o = r.selectsEnd, s = r.selectsRange, i = r.selectsDisabledDaysInRange, p = r.startDate, c = r.endDate, l = null !== (t = e.props.selectingDate) && void 0 !== t ? t : e.props.preSelection;
                return !(!(a || o || s) || !l || !i && e.isDisabled()) && (a && c && (re.isBefore(l, c) || $e(l, c)) ? ze(n, l, c) : (o && p && (te.isAfter(l, p) || $e(l, p)) || !(!s || !p || c || !te.isAfter(l, p) && !$e(l, p))) && ze(n, p, l));
            }), Ce(e, "isSelectingRangeStart", function() {
                var t;
                if (!e.isInSelectingRange()) return !1;
                var r = e.props, n = r.day, a = r.startDate, o = r.selectsStart, s = null !== (t = e.props.selectingDate) && void 0 !== t ? t : e.props.preSelection;
                return Ue(n, o ? s : a);
            }), Ce(e, "isSelectingRangeEnd", function() {
                var t;
                if (!e.isInSelectingRange()) return !1;
                var r = e.props, n = r.day, a = r.endDate, o = r.selectsEnd, s = r.selectsRange, i = null !== (t = e.props.selectingDate) && void 0 !== t ? t : e.props.preSelection;
                return Ue(n, o || s ? i : a);
            }), Ce(e, "isRangeStart", function() {
                var t = e.props, r = t.day, n = t.startDate, a = t.endDate;
                return !(!n || !a) && Ue(n, r);
            }), Ce(e, "isRangeEnd", function() {
                var t = e.props, r = t.day, n = t.startDate, a = t.endDate;
                return !(!n || !a) && Ue(a, r);
            }), Ce(e, "isWeekend", function() {
                var t = b.getDay(e.props.day);
                return 0 === t || 6 === t;
            }), Ce(e, "isAfterMonth", function() {
                return void 0 !== e.props.month && (e.props.month + 1) % 12 === C.getMonth(e.props.day);
            }), Ce(e, "isBeforeMonth", function() {
                return void 0 !== e.props.month && (C.getMonth(e.props.day) + 1) % 12 === e.props.month;
            }), Ce(e, "isCurrentDay", function() {
                return e.isSameDay(Te());
            }), Ce(e, "isSelected", function() {
                var t;
                return e.props.selectsMultiple ? null === (t = e.props.selectedDates) || void 0 === t ? void 0 : t.some(function(t) {
                    return e.isSameDayOrWeek(t);
                }) : e.isSameDayOrWeek(e.props.selected);
            }), Ce(e, "getClassNames", function(t) {
                var r, a = e.props.dayClassName ? e.props.dayClassName(t) : void 0;
                return n.clsx("react-datepicker__day", a, "react-datepicker__day--" + Le(e.props.day, "ddd", r), {
                    "react-datepicker__day--disabled": e.isDisabled(),
                    "react-datepicker__day--excluded": e.isExcluded(),
                    "react-datepicker__day--selected": e.isSelected(),
                    "react-datepicker__day--keyboard-selected": e.isKeyboardSelected(),
                    "react-datepicker__day--range-start": e.isRangeStart(),
                    "react-datepicker__day--range-end": e.isRangeEnd(),
                    "react-datepicker__day--in-range": e.isInRange(),
                    "react-datepicker__day--in-selecting-range": e.isInSelectingRange(),
                    "react-datepicker__day--selecting-range-start": e.isSelectingRangeStart(),
                    "react-datepicker__day--selecting-range-end": e.isSelectingRangeEnd(),
                    "react-datepicker__day--today": e.isCurrentDay(),
                    "react-datepicker__day--weekend": e.isWeekend(),
                    "react-datepicker__day--outside-month": e.isAfterMonth() || e.isBeforeMonth()
                }, e.getHighLightedClass("react-datepicker__day--highlighted"), e.getHolidaysClass());
            }), Ce(e, "getAriaLabel", function() {
                var t = e.props, r = t.day, n = t.ariaLabelPrefixWhenEnabled, a = void 0 === n ? "Choose" : n, o = t.ariaLabelPrefixWhenDisabled, s = void 0 === o ? "Not available" : o, i = e.isDisabled() || e.isExcluded() ? s : a;
                return "".concat(i, " ").concat(Le(r, "PPPP", e.props.locale));
            }), Ce(e, "getTitle", function() {
                var t = e.props, r = t.day, n = t.holidays, a = void 0 === n ? new Map : n, o = t.excludeDates, s = Le(r, "MM.dd.yyyy"), i = [];
                return a.has(s) && i.push.apply(i, Ne(a.get(s).holidayNames)), e.isExcluded() && i.push(null == o ? void 0 : o.filter(function(e) {
                    return Ue(e.date ? e.date : e, r);
                }).map(function(e) {
                    return e.message;
                })), i.join(", ");
            }), Ce(e, "getTabIndex", function(t, r) {
                var n = t || e.props.selected, a = r || e.props.preSelection;
                return (!e.props.showWeekPicker || !e.props.showWeekNumber && e.isStartOfWeek()) && (e.isKeyboardSelected() || e.isSameDay(n) && Ue(a, n)) ? 0 : -1;
            }), Ce(e, "handleFocusDay", function() {
                var t, r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, n = !1;
                0 === e.getTabIndex() && !r.isInputFocused && e.isSameDay(e.props.preSelection) && (document.activeElement && document.activeElement !== document.body || (n = !0), e.props.inline && !e.props.shouldFocusDayInline && (n = !1), e.props.containerRef && e.props.containerRef.current && e.props.containerRef.current.contains(document.activeElement) && document.activeElement.classList.contains("react-datepicker__day") && (n = !0), e.props.monthShowsDuplicateDaysEnd && e.isAfterMonth() && (n = !1), e.props.monthShowsDuplicateDaysStart && e.isBeforeMonth() && (n = !1)), n && (null === (t = e.dayEl.current) || void 0 === t || t.focus({
                    preventScroll: !0
                }));
            }), Ce(e, "renderDayContents", function() {
                return e.props.monthShowsDuplicateDaysEnd && e.isAfterMonth() || e.props.monthShowsDuplicateDaysStart && e.isBeforeMonth() ? null : e.props.renderDayContents ? e.props.renderDayContents(S.getDate(e.props.day), e.props.day) : S.getDate(e.props.day);
            }), Ce(e, "render", function() {
                return he.default.createElement("div", {
                    ref: e.dayEl,
                    className: e.getClassNames(e.props.day),
                    onKeyDown: e.handleOnKeyDown,
                    onClick: e.handleClick,
                    onMouseEnter: e.props.usePointerEvent ? void 0 : e.handleMouseEnter,
                    onPointerEnter: e.props.usePointerEvent ? e.handleMouseEnter : void 0,
                    tabIndex: e.getTabIndex(),
                    "aria-label": e.getAriaLabel(),
                    role: "option",
                    title: e.getTitle(),
                    "aria-disabled": e.isDisabled(),
                    "aria-current": e.isCurrentDay() ? "date" : void 0,
                    "aria-selected": e.isSelected() || e.isInRange()
                }, e.renderDayContents(), "" !== e.getTitle() && he.default.createElement("span", {
                    className: "overlay"
                }, e.getTitle()));
            }), e;
        }
        return Ye(t, e), Me(t, [
            {
                key: "componentDidMount",
                value: function() {
                    this.handleFocusDay();
                }
            },
            {
                key: "componentDidUpdate",
                value: function(e) {
                    this.handleFocusDay(e);
                }
            }
        ]);
    }(he.default.Component), Wt = function(e) {
        function t() {
            var e;
            be(this, t);
            for(var r = arguments.length, n = new Array(r), a = 0; a < r; a++)n[a] = arguments[a];
            return Ce(e = ye(this, t, [].concat(n)), "weekNumberEl", he.default.createRef()), Ce(e, "handleClick", function(t) {
                e.props.onClick && e.props.onClick(t);
            }), Ce(e, "handleOnKeyDown", function(t) {
                " " === t.key && (t.preventDefault(), t.key = "Enter"), e.props.handleOnKeyDown(t);
            }), Ce(e, "isKeyboardSelected", function() {
                return !e.props.disabledKeyboardNavigation && !Ue(e.props.date, e.props.selected) && Ue(e.props.date, e.props.preSelection);
            }), Ce(e, "getTabIndex", function() {
                return e.props.showWeekPicker && e.props.showWeekNumber && (e.isKeyboardSelected() || Ue(e.props.date, e.props.selected) && Ue(e.props.preSelection, e.props.selected)) ? 0 : -1;
            }), Ce(e, "handleFocusWeekNumber", function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, r = !1;
                0 === e.getTabIndex() && !t.isInputFocused && Ue(e.props.date, e.props.preSelection) && (document.activeElement && document.activeElement !== document.body || (r = !0), e.props.inline && !e.props.shouldFocusDayInline && (r = !1), e.props.containerRef && e.props.containerRef.current && e.props.containerRef.current.contains(document.activeElement) && document.activeElement && document.activeElement.classList.contains("react-datepicker__week-number") && (r = !0)), r && e.weekNumberEl.current && e.weekNumberEl.current.focus({
                    preventScroll: !0
                });
            }), e;
        }
        return Ye(t, e), Me(t, [
            {
                key: "componentDidMount",
                value: function() {
                    this.handleFocusWeekNumber();
                }
            },
            {
                key: "componentDidUpdate",
                value: function(e) {
                    this.handleFocusWeekNumber(e);
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this.props, t = e.weekNumber, r = e.ariaLabelPrefix, a = void 0 === r ? "week " : r, o = e.onClick, s = {
                        "react-datepicker__week-number": !0,
                        "react-datepicker__week-number--clickable": !!o,
                        "react-datepicker__week-number--selected": !!o && Ue(this.props.date, this.props.selected),
                        "react-datepicker__week-number--keyboard-selected": this.isKeyboardSelected()
                    };
                    return he.default.createElement("div", {
                        ref: this.weekNumberEl,
                        className: n.clsx(s),
                        "aria-label": "".concat(a, " ").concat(this.props.weekNumber),
                        onClick: this.handleClick,
                        onKeyDown: this.handleOnKeyDown,
                        tabIndex: this.getTabIndex()
                    }, t);
                }
            }
        ], [
            {
                key: "defaultProps",
                get: function() {
                    return {
                        ariaLabelPrefix: "week "
                    };
                }
            }
        ]);
    }(he.default.Component), Qt = function(e) {
        function t() {
            var e;
            be(this, t);
            for(var r = arguments.length, n = new Array(r), a = 0; a < r; a++)n[a] = arguments[a];
            return Ce(e = ye(this, t, [].concat(n)), "handleDayClick", function(t, r) {
                e.props.onDayClick && e.props.onDayClick(t, r);
            }), Ce(e, "handleDayMouseEnter", function(t) {
                e.props.onDayMouseEnter && e.props.onDayMouseEnter(t);
            }), Ce(e, "handleWeekClick", function(t, r, n) {
                "function" == typeof e.props.onWeekSelect && e.props.onWeekSelect(t, r, n), e.props.showWeekPicker && e.handleDayClick(t, n), e.props.shouldCloseOnSelect && e.props.setOpen(!1);
            }), Ce(e, "formatWeekNumber", function(t) {
                return e.props.formatWeekNumber ? e.props.formatWeekNumber(t) : function(e, t) {
                    var r = t && Je(t) || Ge() && Je(Ge());
                    return M.getISOWeek(e, r ? {
                        locale: r
                    } : null);
                }(t);
            }), Ce(e, "renderDays", function() {
                var t = e.startOfWeek(), r = [], n = e.formatWeekNumber(t);
                if (e.props.showWeekNumber) {
                    var a = e.props.onWeekSelect || e.props.showWeekPicker ? e.handleWeekClick.bind(e, t, n) : void 0;
                    r.push(he.default.createElement(Wt, {
                        key: "W",
                        weekNumber: n,
                        date: t,
                        onClick: a,
                        selected: e.props.selected,
                        preSelection: e.props.preSelection,
                        ariaLabelPrefix: e.props.ariaLabelPrefix,
                        showWeekPicker: e.props.showWeekPicker,
                        showWeekNumber: e.props.showWeekNumber,
                        disabledKeyboardNavigation: e.props.disabledKeyboardNavigation,
                        handleOnKeyDown: e.props.handleOnKeyDown,
                        isInputFocused: e.props.isInputFocused,
                        containerRef: e.props.containerRef
                    }));
                }
                return r.concat([
                    0,
                    1,
                    2,
                    3,
                    4,
                    5,
                    6
                ].map(function(r) {
                    var n = c.addDays(t, r);
                    return he.default.createElement(At, {
                        ariaLabelPrefixWhenEnabled: e.props.chooseDayAriaLabelPrefix,
                        ariaLabelPrefixWhenDisabled: e.props.disabledDayAriaLabelPrefix,
                        key: n.valueOf(),
                        day: n,
                        month: e.props.month,
                        onClick: e.handleDayClick.bind(e, n),
                        usePointerEvent: e.props.usePointerEvent,
                        onMouseEnter: e.handleDayMouseEnter.bind(e, n),
                        minDate: e.props.minDate,
                        maxDate: e.props.maxDate,
                        calendarStartDay: e.props.calendarStartDay,
                        excludeDates: e.props.excludeDates,
                        excludeDateIntervals: e.props.excludeDateIntervals,
                        includeDates: e.props.includeDates,
                        includeDateIntervals: e.props.includeDateIntervals,
                        highlightDates: e.props.highlightDates,
                        holidays: e.props.holidays,
                        selectingDate: e.props.selectingDate,
                        filterDate: e.props.filterDate,
                        preSelection: e.props.preSelection,
                        selected: e.props.selected,
                        selectsStart: e.props.selectsStart,
                        selectsEnd: e.props.selectsEnd,
                        selectsRange: e.props.selectsRange,
                        showWeekPicker: e.props.showWeekPicker,
                        showWeekNumber: e.props.showWeekNumber,
                        selectsDisabledDaysInRange: e.props.selectsDisabledDaysInRange,
                        selectsMultiple: e.props.selectsMultiple,
                        selectedDates: e.props.selectedDates,
                        startDate: e.props.startDate,
                        endDate: e.props.endDate,
                        dayClassName: e.props.dayClassName,
                        renderDayContents: e.props.renderDayContents,
                        disabledKeyboardNavigation: e.props.disabledKeyboardNavigation,
                        handleOnKeyDown: e.props.handleOnKeyDown,
                        isInputFocused: e.props.isInputFocused,
                        containerRef: e.props.containerRef,
                        inline: e.props.inline,
                        shouldFocusDayInline: e.props.shouldFocusDayInline,
                        monthShowsDuplicateDaysEnd: e.props.monthShowsDuplicateDaysEnd,
                        monthShowsDuplicateDaysStart: e.props.monthShowsDuplicateDaysStart,
                        locale: e.props.locale
                    });
                }));
            }), Ce(e, "startOfWeek", function() {
                return We(e.props.day, e.props.locale, e.props.calendarStartDay);
            }), Ce(e, "isKeyboardSelected", function() {
                return !e.props.disabledKeyboardNavigation && !Ue(e.startOfWeek(), e.props.selected) && Ue(e.startOfWeek(), e.props.preSelection);
            }), e;
        }
        return Ye(t, e), Me(t, [
            {
                key: "render",
                value: function() {
                    var e = {
                        "react-datepicker__week": !0,
                        "react-datepicker__week--selected": Ue(this.startOfWeek(), this.props.selected),
                        "react-datepicker__week--keyboard-selected": this.isKeyboardSelected()
                    };
                    return he.default.createElement("div", {
                        className: n.clsx(e)
                    }, this.renderDays());
                }
            }
        ], [
            {
                key: "defaultProps",
                get: function() {
                    return {
                        shouldCloseOnSelect: !0
                    };
                }
            }
        ]);
    }(he.default.Component), Kt = "two_columns", qt = "three_columns", Bt = "four_columns", Ht = Ce(Ce(Ce({}, Kt, {
        grid: [
            [
                0,
                1
            ],
            [
                2,
                3
            ],
            [
                4,
                5
            ],
            [
                6,
                7
            ],
            [
                8,
                9
            ],
            [
                10,
                11
            ]
        ],
        verticalNavigationOffset: 2
    }), qt, {
        grid: [
            [
                0,
                1,
                2
            ],
            [
                3,
                4,
                5
            ],
            [
                6,
                7,
                8
            ],
            [
                9,
                10,
                11
            ]
        ],
        verticalNavigationOffset: 3
    }), Bt, {
        grid: [
            [
                0,
                1,
                2,
                3
            ],
            [
                4,
                5,
                6,
                7
            ],
            [
                8,
                9,
                10,
                11
            ]
        ],
        verticalNavigationOffset: 4
    });
    function jt(e, t) {
        return e ? Bt : t ? Kt : qt;
    }
    var Vt = function(e) {
        function t() {
            var e;
            be(this, t);
            for(var r = arguments.length, a = new Array(r), o = 0; o < r; o++)a[o] = arguments[o];
            return Ce(e = ye(this, t, [].concat(a)), "MONTH_REFS", Ne(Array(12)).map(function() {
                return he.default.createRef();
            })), Ce(e, "QUARTER_REFS", Ne(Array(4)).map(function() {
                return he.default.createRef();
            })), Ce(e, "isDisabled", function(t) {
                return et(t, e.props);
            }), Ce(e, "isExcluded", function(t) {
                return tt(t, e.props);
            }), Ce(e, "handleDayClick", function(t, r) {
                e.props.onDayClick && e.props.onDayClick(t, r, e.props.orderInDisplay);
            }), Ce(e, "handleDayMouseEnter", function(t) {
                e.props.onDayMouseEnter && e.props.onDayMouseEnter(t);
            }), Ce(e, "handleMouseLeave", function() {
                e.props.onMouseLeave && e.props.onMouseLeave();
            }), Ce(e, "isRangeStartMonth", function(t) {
                var r = e.props, n = r.day, a = r.startDate, o = r.endDate;
                return !(!a || !o) && je(x.setMonth(n, t), a);
            }), Ce(e, "isRangeStartQuarter", function(t) {
                var r = e.props, n = r.day, a = r.startDate, o = r.endDate;
                return !(!a || !o) && Ve(I.setQuarter(n, t), a);
            }), Ce(e, "isRangeEndMonth", function(t) {
                var r = e.props, n = r.day, a = r.startDate, o = r.endDate;
                return !(!a || !o) && je(x.setMonth(n, t), o);
            }), Ce(e, "isRangeEndQuarter", function(t) {
                var r = e.props, n = r.day, a = r.startDate, o = r.endDate;
                return !(!a || !o) && Ve(I.setQuarter(n, t), o);
            }), Ce(e, "isInSelectingRangeMonth", function(t) {
                var r, n = e.props, a = n.day, o = n.selectsStart, s = n.selectsEnd, i = n.selectsRange, p = n.startDate, c = n.endDate, l = null !== (r = e.props.selectingDate) && void 0 !== r ? r : e.props.preSelection;
                return !(!(o || s || i) || !l) && (o && c ? nt(l, c, t, a) : (s && p || !(!i || !p || c)) && nt(p, l, t, a));
            }), Ce(e, "isSelectingMonthRangeStart", function(t) {
                var r;
                if (!e.isInSelectingRangeMonth(t)) return !1;
                var n = e.props, a = n.day, o = n.startDate, s = n.selectsStart, i = x.setMonth(a, t), p = null !== (r = e.props.selectingDate) && void 0 !== r ? r : e.props.preSelection;
                return je(i, s ? p : o);
            }), Ce(e, "isSelectingMonthRangeEnd", function(t) {
                var r;
                if (!e.isInSelectingRangeMonth(t)) return !1;
                var n = e.props, a = n.day, o = n.endDate, s = n.selectsEnd, i = n.selectsRange, p = x.setMonth(a, t), c = null !== (r = e.props.selectingDate) && void 0 !== r ? r : e.props.preSelection;
                return je(p, s || i ? c : o);
            }), Ce(e, "isInSelectingRangeQuarter", function(t) {
                var r, n = e.props, a = n.day, o = n.selectsStart, s = n.selectsEnd, i = n.selectsRange, p = n.startDate, c = n.endDate, l = null !== (r = e.props.selectingDate) && void 0 !== r ? r : e.props.preSelection;
                return !(!(o || s || i) || !l) && (o && c ? it(l, c, t, a) : (s && p || !(!i || !p || c)) && it(p, l, t, a));
            }), Ce(e, "isWeekInMonth", function(t) {
                var r = e.props.day, n = c.addDays(t, 6);
                return je(t, r) || je(n, r);
            }), Ce(e, "isCurrentMonth", function(e, t) {
                return Y.getYear(e) === Y.getYear(Te()) && t === C.getMonth(Te());
            }), Ce(e, "isCurrentQuarter", function(e, t) {
                return Y.getYear(e) === Y.getYear(Te()) && t === _.getQuarter(Te());
            }), Ce(e, "isSelectedMonth", function(e, t, r) {
                return C.getMonth(r) === t && Y.getYear(e) === Y.getYear(r);
            }), Ce(e, "isSelectedQuarter", function(e, t, r) {
                return _.getQuarter(e) === t && Y.getYear(e) === Y.getYear(r);
            }), Ce(e, "renderWeeks", function() {
                for(var t = [], r = e.props.fixedHeight, n = 0, a = !1, o = We(Qe(e.props.day), e.props.locale, e.props.calendarStartDay), s = e.props.showWeekPicker ? We(e.props.selected, e.props.locale, e.props.calendarStartDay) : e.props.selected, i = e.props.showWeekPicker ? We(e.props.preSelection, e.props.locale, e.props.calendarStartDay) : e.props.preSelection; t.push(he.default.createElement(Qt, {
                    ariaLabelPrefix: e.props.weekAriaLabelPrefix,
                    chooseDayAriaLabelPrefix: e.props.chooseDayAriaLabelPrefix,
                    disabledDayAriaLabelPrefix: e.props.disabledDayAriaLabelPrefix,
                    key: n,
                    day: o,
                    month: C.getMonth(e.props.day),
                    onDayClick: e.handleDayClick,
                    usePointerEvent: e.props.usePointerEvent,
                    onDayMouseEnter: e.handleDayMouseEnter,
                    onWeekSelect: e.props.onWeekSelect,
                    formatWeekNumber: e.props.formatWeekNumber,
                    locale: e.props.locale,
                    minDate: e.props.minDate,
                    maxDate: e.props.maxDate,
                    excludeDates: e.props.excludeDates,
                    excludeDateIntervals: e.props.excludeDateIntervals,
                    includeDates: e.props.includeDates,
                    includeDateIntervals: e.props.includeDateIntervals,
                    inline: e.props.inline,
                    shouldFocusDayInline: e.props.shouldFocusDayInline,
                    highlightDates: e.props.highlightDates,
                    holidays: e.props.holidays,
                    selectingDate: e.props.selectingDate,
                    filterDate: e.props.filterDate,
                    preSelection: i,
                    selected: s,
                    selectsStart: e.props.selectsStart,
                    selectsEnd: e.props.selectsEnd,
                    selectsRange: e.props.selectsRange,
                    selectsDisabledDaysInRange: e.props.selectsDisabledDaysInRange,
                    selectsMultiple: e.props.selectsMultiple,
                    selectedDates: e.props.selectedDates,
                    showWeekNumber: e.props.showWeekNumbers,
                    showWeekPicker: e.props.showWeekPicker,
                    startDate: e.props.startDate,
                    endDate: e.props.endDate,
                    dayClassName: e.props.dayClassName,
                    setOpen: e.props.setOpen,
                    shouldCloseOnSelect: e.props.shouldCloseOnSelect,
                    disabledKeyboardNavigation: e.props.disabledKeyboardNavigation,
                    renderDayContents: e.props.renderDayContents,
                    handleOnKeyDown: e.props.handleOnKeyDown,
                    isInputFocused: e.props.isInputFocused,
                    containerRef: e.props.containerRef,
                    calendarStartDay: e.props.calendarStartDay,
                    monthShowsDuplicateDaysEnd: e.props.monthShowsDuplicateDaysEnd,
                    monthShowsDuplicateDaysStart: e.props.monthShowsDuplicateDaysStart
                })), !a;){
                    n++, o = l.addWeeks(o, 1);
                    var p = r && n >= 6, c = !r && !e.isWeekInMonth(o);
                    if (p || c) {
                        if (!e.props.peekNextMonth) break;
                        a = !0;
                    }
                }
                return t;
            }), Ce(e, "onMonthClick", function(t, r) {
                var n = x.setMonth(e.props.day, r);
                rt(n, e.props) || e.handleDayClick(Qe(n), t);
            }), Ce(e, "onMonthMouseEnter", function(t) {
                var r = x.setMonth(e.props.day, t);
                rt(r, e.props) || e.handleDayMouseEnter(Qe(r));
            }), Ce(e, "handleMonthNavigation", function(t, r) {
                e.isDisabled(r) || e.isExcluded(r) || (e.props.setPreSelection(r), e.MONTH_REFS[t].current && e.MONTH_REFS[t].current.focus());
            }), Ce(e, "onMonthKeyDown", function(t, r) {
                var n = e.props, a = n.selected, o = n.preSelection, s = n.disabledKeyboardNavigation, i = n.showTwoColumnMonthYearPicker, p = n.showFourColumnMonthYearPicker, c = n.setPreSelection, l = n.handleOnMonthKeyDown, u = t.key;
                if ("Tab" !== u && t.preventDefault(), !s) {
                    var h = jt(p, i), f = Ht[h].verticalNavigationOffset, m = Ht[h].grid;
                    switch(u){
                        case "Enter":
                            e.onMonthClick(t, r), c(a);
                            break;
                        case "ArrowRight":
                            e.handleMonthNavigation(11 === r ? 0 : r + 1, d.addMonths(o, 1));
                            break;
                        case "ArrowLeft":
                            e.handleMonthNavigation(0 === r ? 11 : r - 1, y.subMonths(o, 1));
                            break;
                        case "ArrowUp":
                            e.handleMonthNavigation(m[0].includes(r) ? r + 12 - f : r - f, y.subMonths(o, f));
                            break;
                        case "ArrowDown":
                            e.handleMonthNavigation(m[m.length - 1].includes(r) ? r - 12 + f : r + f, d.addMonths(o, f));
                    }
                }
                l && l(t);
            }), Ce(e, "onQuarterClick", function(t, r) {
                var n = I.setQuarter(e.props.day, r);
                at(n, e.props) || e.handleDayClick(qe(n), t);
            }), Ce(e, "onQuarterMouseEnter", function(t) {
                var r = I.setQuarter(e.props.day, t);
                at(r, e.props) || e.handleDayMouseEnter(qe(r));
            }), Ce(e, "handleQuarterNavigation", function(t, r) {
                e.isDisabled(r) || e.isExcluded(r) || (e.props.setPreSelection(r), e.QUARTER_REFS[t - 1].current && e.QUARTER_REFS[t - 1].current.focus());
            }), Ce(e, "onQuarterKeyDown", function(t, r) {
                var n = t.key;
                if (!e.props.disabledKeyboardNavigation) switch(n){
                    case "Enter":
                        e.onQuarterClick(t, r), e.props.setPreSelection(e.props.selected);
                        break;
                    case "ArrowRight":
                        e.handleQuarterNavigation(4 === r ? 1 : r + 1, u.addQuarters(e.props.preSelection, 1));
                        break;
                    case "ArrowLeft":
                        e.handleQuarterNavigation(1 === r ? 4 : r - 1, g.subQuarters(e.props.preSelection, 1));
                }
            }), Ce(e, "isMonthDisabled", function(t) {
                var r = e.props, n = r.day, a = r.minDate, o = r.maxDate, s = r.excludeDates, i = r.includeDates, p = x.setMonth(n, t);
                return (a || o || s || i) && rt(p, e.props);
            }), Ce(e, "getMonthClassNames", function(t) {
                var r = e.props, a = r.day, o = r.startDate, s = r.endDate, i = r.selected, p = r.preSelection, c = r.monthClassName, l = c ? c(x.setMonth(a, t)) : void 0;
                return n.clsx("react-datepicker__month-text", "react-datepicker__month-".concat(t), l, {
                    "react-datepicker__month-text--disabled": e.isMonthDisabled(t),
                    "react-datepicker__month-text--selected": e.isSelectedMonth(a, t, i),
                    "react-datepicker__month-text--keyboard-selected": !e.props.disabledKeyboardNavigation && e.isSelectedMonth(a, t, p),
                    "react-datepicker__month-text--in-selecting-range": e.isInSelectingRangeMonth(t),
                    "react-datepicker__month-text--in-range": nt(o, s, t, a),
                    "react-datepicker__month-text--range-start": e.isRangeStartMonth(t),
                    "react-datepicker__month-text--range-end": e.isRangeEndMonth(t),
                    "react-datepicker__month-text--selecting-range-start": e.isSelectingMonthRangeStart(t),
                    "react-datepicker__month-text--selecting-range-end": e.isSelectingMonthRangeEnd(t),
                    "react-datepicker__month-text--today": e.isCurrentMonth(a, t)
                });
            }), Ce(e, "getTabIndex", function(t) {
                var r = C.getMonth(e.props.preSelection);
                return e.props.disabledKeyboardNavigation || t !== r ? "-1" : "0";
            }), Ce(e, "getQuarterTabIndex", function(t) {
                var r = _.getQuarter(e.props.preSelection);
                return e.props.disabledKeyboardNavigation || t !== r ? "-1" : "0";
            }), Ce(e, "getAriaLabel", function(t) {
                var r = e.props, n = r.chooseDayAriaLabelPrefix, a = void 0 === n ? "Choose" : n, o = r.disabledDayAriaLabelPrefix, s = void 0 === o ? "Not available" : o, i = r.day, p = r.locale, c = x.setMonth(i, t), l = e.isDisabled(c) || e.isExcluded(c) ? s : a;
                return "".concat(l, " ").concat(Le(c, "MMMM yyyy", p));
            }), Ce(e, "getQuarterClassNames", function(t) {
                var r = e.props, a = r.day, o = r.startDate, s = r.endDate, i = r.selected, p = r.minDate, c = r.maxDate, l = r.preSelection, d = r.disabledKeyboardNavigation;
                return n.clsx("react-datepicker__quarter-text", "react-datepicker__quarter-".concat(t), {
                    "react-datepicker__quarter-text--disabled": (p || c) && at(I.setQuarter(a, t), e.props),
                    "react-datepicker__quarter-text--selected": e.isSelectedQuarter(a, t, i),
                    "react-datepicker__quarter-text--keyboard-selected": !d && e.isSelectedQuarter(a, t, l),
                    "react-datepicker__quarter-text--in-selecting-range": e.isInSelectingRangeQuarter(t),
                    "react-datepicker__quarter-text--in-range": it(o, s, t, a),
                    "react-datepicker__quarter-text--range-start": e.isRangeStartQuarter(t),
                    "react-datepicker__quarter-text--range-end": e.isRangeEndQuarter(t)
                });
            }), Ce(e, "getMonthContent", function(t) {
                var r = e.props, n = r.showFullMonthYearPicker, a = r.renderMonthContent, o = r.locale, s = r.day, i = Ze(t, o), p = Xe(t, o);
                return a ? a(t, i, p, s) : n ? p : i;
            }), Ce(e, "getQuarterContent", function(t) {
                var r = e.props, n = r.renderQuarterContent, a = function(e, t) {
                    return Le(I.setQuarter(Te(), e), "QQQ", t);
                }(t, r.locale);
                return n ? n(t, a) : a;
            }), Ce(e, "renderMonths", function() {
                var t = e.props, r = t.showTwoColumnMonthYearPicker, n = t.showFourColumnMonthYearPicker, a = t.day, o = t.selected;
                return Ht[jt(n, r)].grid.map(function(t, r) {
                    return he.default.createElement("div", {
                        className: "react-datepicker__month-wrapper",
                        key: r
                    }, t.map(function(t, r) {
                        return he.default.createElement("div", {
                            ref: e.MONTH_REFS[t],
                            key: r,
                            onClick: function(r) {
                                e.onMonthClick(r, t);
                            },
                            onKeyDown: function(r) {
                                _t(r) && (r.preventDefault(), r.key = "Enter"), e.onMonthKeyDown(r, t);
                            },
                            onMouseEnter: e.props.usePointerEvent ? void 0 : function() {
                                return e.onMonthMouseEnter(t);
                            },
                            onPointerEnter: e.props.usePointerEvent ? function() {
                                return e.onMonthMouseEnter(t);
                            } : void 0,
                            tabIndex: e.getTabIndex(t),
                            className: e.getMonthClassNames(t),
                            "aria-disabled": e.isMonthDisabled(t),
                            role: "option",
                            "aria-label": e.getAriaLabel(t),
                            "aria-current": e.isCurrentMonth(a, t) ? "date" : void 0,
                            "aria-selected": e.isSelectedMonth(a, t, o)
                        }, e.getMonthContent(t));
                    }));
                });
            }), Ce(e, "renderQuarters", function() {
                var t = e.props, r = t.day, n = t.selected;
                return he.default.createElement("div", {
                    className: "react-datepicker__quarter-wrapper"
                }, [
                    1,
                    2,
                    3,
                    4
                ].map(function(t, a) {
                    return he.default.createElement("div", {
                        key: a,
                        ref: e.QUARTER_REFS[a],
                        role: "option",
                        onClick: function(r) {
                            e.onQuarterClick(r, t);
                        },
                        onKeyDown: function(r) {
                            e.onQuarterKeyDown(r, t);
                        },
                        onMouseEnter: e.props.usePointerEvent ? void 0 : function() {
                            return e.onQuarterMouseEnter(t);
                        },
                        onPointerEnter: e.props.usePointerEvent ? function() {
                            return e.onQuarterMouseEnter(t);
                        } : void 0,
                        className: e.getQuarterClassNames(t),
                        "aria-selected": e.isSelectedQuarter(r, t, n),
                        tabIndex: e.getQuarterTabIndex(t),
                        "aria-current": e.isCurrentQuarter(r, t) ? "date" : void 0
                    }, e.getQuarterContent(t));
                }));
            }), Ce(e, "getClassNames", function() {
                var t = e.props, r = t.selectingDate, a = t.selectsStart, o = t.selectsEnd, s = t.showMonthYearPicker, i = t.showQuarterYearPicker, p = t.showWeekPicker;
                return n.clsx("react-datepicker__month", {
                    "react-datepicker__month--selecting-range": r && (a || o)
                }, {
                    "react-datepicker__monthPicker": s
                }, {
                    "react-datepicker__quarterPicker": i
                }, {
                    "react-datepicker__weekPicker": p
                });
            }), e;
        }
        return Ye(t, e), Me(t, [
            {
                key: "render",
                value: function() {
                    var e = this.props, t = e.showMonthYearPicker, r = e.showQuarterYearPicker, n = e.day, a = e.ariaLabelPrefix, o = void 0 === a ? "Month " : a, s = o ? o.trim() + " " : "";
                    return he.default.createElement("div", {
                        className: this.getClassNames(),
                        onMouseLeave: this.props.usePointerEvent ? void 0 : this.handleMouseLeave,
                        onPointerLeave: this.props.usePointerEvent ? this.handleMouseLeave : void 0,
                        "aria-label": "".concat(s).concat(Le(n, "MMMM, yyyy", this.props.locale)),
                        role: "listbox"
                    }, t ? this.renderMonths() : r ? this.renderQuarters() : this.renderWeeks());
                }
            }
        ]);
    }(he.default.Component), Ut = function(e) {
        function t() {
            var e;
            be(this, t);
            for(var r = arguments.length, n = new Array(r), a = 0; a < r; a++)n[a] = arguments[a];
            return Ce(e = ye(this, t, [].concat(n)), "state", {
                height: null
            }), Ce(e, "scrollToTheSelectedTime", function() {
                requestAnimationFrame(function() {
                    e.list && (e.list.scrollTop = e.centerLi && t.calcCenterPosition(e.props.monthRef ? e.props.monthRef.clientHeight - e.header.clientHeight : e.list.clientHeight, e.centerLi));
                });
            }), Ce(e, "handleClick", function(t) {
                (e.props.minTime || e.props.maxTime) && dt(t, e.props) || (e.props.excludeTimes || e.props.includeTimes || e.props.filterTime) && lt(t, e.props) || e.props.onChange(t);
            }), Ce(e, "isSelectedTime", function(t) {
                var r, n;
                return e.props.selected && (r = e.props.selected, n = t, St(r).getTime() === St(n).getTime());
            }), Ce(e, "isDisabledTime", function(t) {
                return (e.props.minTime || e.props.maxTime) && dt(t, e.props) || (e.props.excludeTimes || e.props.includeTimes || e.props.filterTime) && lt(t, e.props);
            }), Ce(e, "liClasses", function(t) {
                var r = [
                    "react-datepicker__time-list-item",
                    e.props.timeClassName ? e.props.timeClassName(t) : void 0
                ];
                return e.isSelectedTime(t) && r.push("react-datepicker__time-list-item--selected"), e.isDisabledTime(t) && r.push("react-datepicker__time-list-item--disabled"), e.props.injectTimes && (3600 * w.getHours(t) + 60 * k.getMinutes(t) + ie.getSeconds(t)) % (60 * e.props.intervals) != 0 && r.push("react-datepicker__time-list-item--injected"), r.join(" ");
            }), Ce(e, "handleOnKeyDown", function(t, r) {
                " " === t.key && (t.preventDefault(), t.key = "Enter"), "ArrowUp" !== t.key && "ArrowLeft" !== t.key || !t.target.previousSibling || (t.preventDefault(), t.target.previousSibling.focus()), "ArrowDown" !== t.key && "ArrowRight" !== t.key || !t.target.nextSibling || (t.preventDefault(), t.target.nextSibling.focus()), "Enter" === t.key && e.handleClick(r), e.props.handleOnKeyDown(t);
            }), Ce(e, "renderTimes", function() {
                for(var t, r = [], n = e.props.format ? e.props.format : "p", a = e.props.intervals, o = e.props.selected || e.props.openToDate || Te(), s = (t = o, K.startOfDay(t)), p = e.props.injectTimes && e.props.injectTimes.sort(function(e, t) {
                    return e - t;
                }), c = 60 * function(e) {
                    var t = new Date(e.getFullYear(), e.getMonth(), e.getDate()), r = new Date(e.getFullYear(), e.getMonth(), e.getDate(), 24);
                    return Math.round((+r - +t) / 36e5);
                }(o), l = c / a, d = 0; d < l; d++){
                    var u = i.addMinutes(s, d * a);
                    if (r.push(u), p) {
                        var h = kt(s, u, d, a, p);
                        r = r.concat(h);
                    }
                }
                var f = r.reduce(function(e, t) {
                    return t.getTime() <= o.getTime() ? t : e;
                }, r[0]);
                return r.map(function(t, r) {
                    return he.default.createElement("li", {
                        key: r,
                        onClick: e.handleClick.bind(e, t),
                        className: e.liClasses(t),
                        ref: function(r) {
                            t === f && (e.centerLi = r);
                        },
                        onKeyDown: function(r) {
                            e.handleOnKeyDown(r, t);
                        },
                        tabIndex: t === f ? 0 : -1,
                        role: "option",
                        "aria-selected": e.isSelectedTime(t) ? "true" : void 0,
                        "aria-disabled": e.isDisabledTime(t) ? "true" : void 0
                    }, Le(t, n, e.props.locale));
                });
            }), e;
        }
        return Ye(t, e), Me(t, [
            {
                key: "componentDidMount",
                value: function() {
                    this.scrollToTheSelectedTime(), this.props.monthRef && this.header && this.setState({
                        height: this.props.monthRef.clientHeight - this.header.clientHeight
                    });
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this, t = this.state.height;
                    return he.default.createElement("div", {
                        className: "react-datepicker__time-container ".concat(this.props.todayButton ? "react-datepicker__time-container--with-today-button" : "")
                    }, he.default.createElement("div", {
                        className: "react-datepicker__header react-datepicker__header--time ".concat(this.props.showTimeSelectOnly ? "react-datepicker__header--time--only" : ""),
                        ref: function(t) {
                            e.header = t;
                        }
                    }, he.default.createElement("div", {
                        className: "react-datepicker-time__header"
                    }, this.props.timeCaption)), he.default.createElement("div", {
                        className: "react-datepicker__time"
                    }, he.default.createElement("div", {
                        className: "react-datepicker__time-box"
                    }, he.default.createElement("ul", {
                        className: "react-datepicker__time-list",
                        ref: function(t) {
                            e.list = t;
                        },
                        style: t ? {
                            height: t
                        } : {},
                        role: "listbox",
                        "aria-label": this.props.timeCaption
                    }, this.renderTimes()))));
                }
            }
        ], [
            {
                key: "defaultProps",
                get: function() {
                    return {
                        intervals: 30,
                        onTimeChange: function() {},
                        todayButton: null,
                        timeCaption: "Time"
                    };
                }
            }
        ]);
    }(he.default.Component);
    Ce(Ut, "calcCenterPosition", function(e, t) {
        return t.offsetTop - (e / 2 - t.clientHeight / 2);
    });
    var $t = function(e) {
        function t(e) {
            var r;
            return be(this, t), Ce(r = ye(this, t, [
                e
            ]), "YEAR_REFS", Ne(Array(r.props.yearItemNumber)).map(function() {
                return he.default.createRef();
            })), Ce(r, "isDisabled", function(e) {
                return et(e, r.props);
            }), Ce(r, "isExcluded", function(e) {
                return tt(e, r.props);
            }), Ce(r, "selectingDate", function() {
                var e;
                return null !== (e = r.props.selectingDate) && void 0 !== e ? e : r.props.preSelection;
            }), Ce(r, "updateFocusOnPaginate", function(e) {
                var t = (function() {
                    this.YEAR_REFS[e].current.focus();
                }).bind(r);
                window.requestAnimationFrame(t);
            }), Ce(r, "handleYearClick", function(e, t) {
                r.props.onDayClick && r.props.onDayClick(e, t);
            }), Ce(r, "handleYearNavigation", function(e, t) {
                var n = r.props, a = n.date, o = n.yearItemNumber, s = bt(a, o).startPeriod;
                r.isDisabled(t) || r.isExcluded(t) || (r.props.setPreSelection(t), e - s < 0 ? r.updateFocusOnPaginate(o - (s - e)) : e - s >= o ? r.updateFocusOnPaginate(Math.abs(o - (e - s))) : r.YEAR_REFS[e - s].current.focus());
            }), Ce(r, "isSameDay", function(e, t) {
                return Ue(e, t);
            }), Ce(r, "isCurrentYear", function(e) {
                return e === Y.getYear(Te());
            }), Ce(r, "isRangeStart", function(e) {
                return r.props.startDate && r.props.endDate && He(T.setYear(Te(), e), r.props.startDate);
            }), Ce(r, "isRangeEnd", function(e) {
                return r.props.startDate && r.props.endDate && He(T.setYear(Te(), e), r.props.endDate);
            }), Ce(r, "isInRange", function(e) {
                return ot(e, r.props.startDate, r.props.endDate);
            }), Ce(r, "isInSelectingRange", function(e) {
                var t = r.props, n = t.selectsStart, a = t.selectsEnd, o = t.selectsRange, s = t.startDate, i = t.endDate;
                return !(!(n || a || o) || !r.selectingDate()) && (n && i ? ot(e, r.selectingDate(), i) : (a && s || !(!o || !s || i)) && ot(e, s, r.selectingDate()));
            }), Ce(r, "isSelectingRangeStart", function(e) {
                if (!r.isInSelectingRange(e)) return !1;
                var t = r.props, n = t.startDate, a = t.selectsStart, o = T.setYear(Te(), e);
                return He(o, a ? r.selectingDate() : n);
            }), Ce(r, "isSelectingRangeEnd", function(e) {
                if (!r.isInSelectingRange(e)) return !1;
                var t = r.props, n = t.endDate, a = t.selectsEnd, o = t.selectsRange, s = T.setYear(Te(), e);
                return He(s, a || o ? r.selectingDate() : n);
            }), Ce(r, "isKeyboardSelected", function(e) {
                var t = Ke(T.setYear(r.props.date, e));
                return !r.props.disabledKeyboardNavigation && !r.props.inline && !Ue(t, Ke(r.props.selected)) && Ue(t, Ke(r.props.preSelection));
            }), Ce(r, "onYearClick", function(e, t) {
                var n = r.props.date;
                r.handleYearClick(Ke(T.setYear(n, t)), e);
            }), Ce(r, "onYearKeyDown", function(e, t) {
                var n = e.key, a = r.props, o = a.date, s = a.yearItemNumber, i = a.handleOnKeyDown;
                if ("Tab" !== n && e.preventDefault(), !r.props.disabledKeyboardNavigation) switch(n){
                    case "Enter":
                        r.onYearClick(e, t), r.props.setPreSelection(r.props.selected);
                        break;
                    case "ArrowRight":
                        r.handleYearNavigation(t + 1, h.addYears(r.props.preSelection, 1));
                        break;
                    case "ArrowLeft":
                        r.handleYearNavigation(t - 1, v.subYears(r.props.preSelection, 1));
                        break;
                    case "ArrowUp":
                        var p = bt(o, s).startPeriod, c = 3, l = t - c;
                        if (l < p) {
                            var d = s % c;
                            t >= p && t < p + d ? c = d : c += d, l = t - c;
                        }
                        r.handleYearNavigation(l, v.subYears(r.props.preSelection, c));
                        break;
                    case "ArrowDown":
                        var u = bt(o, s).endPeriod, f = 3, m = t + f;
                        if (m > u) {
                            var y = s % f;
                            t <= u && t > u - y ? f = y : f += y, m = t + f;
                        }
                        r.handleYearNavigation(m, h.addYears(r.props.preSelection, f));
                }
                i && i(e);
            }), Ce(r, "getYearClassNames", function(e) {
                var t = r.props, a = t.date, o = t.minDate, s = t.maxDate, i = t.selected, p = t.excludeDates, c = t.includeDates, l = t.filterDate, d = t.yearClassName;
                return n.clsx("react-datepicker__year-text", "react-datepicker__year-".concat(e), d ? d(T.setYear(a, e)) : void 0, {
                    "react-datepicker__year-text--selected": e === Y.getYear(i),
                    "react-datepicker__year-text--disabled": (o || s || p || c || l) && st(e, r.props),
                    "react-datepicker__year-text--keyboard-selected": r.isKeyboardSelected(e),
                    "react-datepicker__year-text--range-start": r.isRangeStart(e),
                    "react-datepicker__year-text--range-end": r.isRangeEnd(e),
                    "react-datepicker__year-text--in-range": r.isInRange(e),
                    "react-datepicker__year-text--in-selecting-range": r.isInSelectingRange(e),
                    "react-datepicker__year-text--selecting-range-start": r.isSelectingRangeStart(e),
                    "react-datepicker__year-text--selecting-range-end": r.isSelectingRangeEnd(e),
                    "react-datepicker__year-text--today": r.isCurrentYear(e)
                });
            }), Ce(r, "getYearTabIndex", function(e) {
                return r.props.disabledKeyboardNavigation ? "-1" : e === Y.getYear(r.props.preSelection) ? "0" : "-1";
            }), Ce(r, "getYearContainerClassNames", function() {
                var e = r.props, t = e.selectingDate, a = e.selectsStart, o = e.selectsEnd, s = e.selectsRange;
                return n.clsx("react-datepicker__year", {
                    "react-datepicker__year--selecting-range": t && (a || o || s)
                });
            }), Ce(r, "getYearContent", function(e) {
                return r.props.renderYearContent ? r.props.renderYearContent(e) : e;
            }), r;
        }
        return Ye(t, e), Me(t, [
            {
                key: "render",
                value: function() {
                    for(var e = this, t = [], r = this.props, n = r.date, a = r.yearItemNumber, o = r.onYearMouseEnter, s = r.onYearMouseLeave, i = bt(n, a), p = i.startPeriod, c = i.endPeriod, l = function(r) {
                        t.push(he.default.createElement("div", {
                            ref: e.YEAR_REFS[r - p],
                            onClick: function(t) {
                                e.onYearClick(t, r);
                            },
                            onKeyDown: function(t) {
                                _t(t) && (t.preventDefault(), t.key = "Enter"), e.onYearKeyDown(t, r);
                            },
                            tabIndex: e.getYearTabIndex(r),
                            className: e.getYearClassNames(r),
                            onMouseEnter: e.props.usePointerEvent ? void 0 : function(e) {
                                return o(e, r);
                            },
                            onPointerEnter: e.props.usePointerEvent ? function(e) {
                                return o(e, r);
                            } : void 0,
                            onMouseLeave: e.props.usePointerEvent ? void 0 : function(e) {
                                return s(e, r);
                            },
                            onPointerLeave: e.props.usePointerEvent ? function(e) {
                                return s(e, r);
                            } : void 0,
                            key: r,
                            "aria-current": e.isCurrentYear(r) ? "date" : void 0
                        }, e.getYearContent(r)));
                    }, d = p; d <= c; d++)l(d);
                    return he.default.createElement("div", {
                        className: this.getYearContainerClassNames()
                    }, he.default.createElement("div", {
                        className: "react-datepicker__year-wrapper",
                        onMouseLeave: this.props.usePointerEvent ? void 0 : this.props.clearSelectingDate,
                        onPointerLeave: this.props.usePointerEvent ? this.props.clearSelectingDate : void 0
                    }, t));
                }
            }
        ]);
    }(he.default.Component), zt = function(e) {
        function t(e) {
            var r;
            return be(this, t), Ce(r = ye(this, t, [
                e
            ]), "onTimeChange", function(e) {
                r.setState({
                    time: e
                });
                var t = r.props.date, n = t instanceof Date && !isNaN(t) ? t : new Date;
                n.setHours(e.split(":")[0]), n.setMinutes(e.split(":")[1]), r.props.onChange(n);
            }), Ce(r, "renderTimeInput", function() {
                var e = r.state.time, t = r.props, n = t.date, a = t.timeString, o = t.customTimeInput;
                return o ? he.default.cloneElement(o, {
                    date: n,
                    value: e,
                    onChange: r.onTimeChange
                }) : he.default.createElement("input", {
                    type: "time",
                    className: "react-datepicker-time__input",
                    placeholder: "Time",
                    name: "time-input",
                    required: !0,
                    value: e,
                    onChange: function(e) {
                        r.onTimeChange(e.target.value || a);
                    }
                });
            }), r.state = {
                time: r.props.timeString
            }, r;
        }
        return Ye(t, e), Me(t, [
            {
                key: "render",
                value: function() {
                    return he.default.createElement("div", {
                        className: "react-datepicker__input-time-container"
                    }, he.default.createElement("div", {
                        className: "react-datepicker-time__caption"
                    }, this.props.timeInputLabel), he.default.createElement("div", {
                        className: "react-datepicker-time__input-container"
                    }, he.default.createElement("div", {
                        className: "react-datepicker-time__input"
                    }, this.renderTimeInput())));
                }
            }
        ], [
            {
                key: "getDerivedStateFromProps",
                value: function(e, t) {
                    return e.timeString !== t.time ? {
                        time: e.timeString
                    } : null;
                }
            }
        ]);
    }(he.default.Component);
    function Gt(e) {
        var t = e.showTimeSelectOnly, r = void 0 !== t && t, n = e.showTime, a = void 0 !== n && n, o = e.className, s = e.children, i = r ? "Choose Time" : "Choose Date".concat(a ? " and Time" : "");
        return he.default.createElement("div", {
            className: o,
            role: "dialog",
            "aria-label": i,
            "aria-modal": "true"
        }, s);
    }
    var Jt = [
        "react-datepicker__year-select",
        "react-datepicker__month-select",
        "react-datepicker__month-year-select"
    ], Xt = function(e) {
        function t(e) {
            var r;
            return be(this, t), Ce(r = ye(this, t, [
                e
            ]), "handleClickOutside", function(e) {
                r.props.onClickOutside(e);
            }), Ce(r, "setClickOutsideRef", function() {
                return r.containerRef.current;
            }), Ce(r, "handleDropdownFocus", function(e) {
                (function() {
                    var e = ((arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}).className || "").split(/\s+/);
                    return Jt.some(function(t) {
                        return e.indexOf(t) >= 0;
                    });
                })(e.target) && r.props.onDropdownFocus();
            }), Ce(r, "getDateInView", function() {
                var e = r.props, t = e.preSelection, n = e.selected, a = e.openToDate, o = yt(r.props), s = gt(r.props), i = Te(), p = a || n || t;
                return p || (o && re.isBefore(i, o) ? o : s && te.isAfter(i, s) ? s : i);
            }), Ce(r, "increaseMonth", function() {
                r.setState(function(e) {
                    var t = e.date;
                    return {
                        date: d.addMonths(t, 1)
                    };
                }, function() {
                    return r.handleMonthChange(r.state.date);
                });
            }), Ce(r, "decreaseMonth", function() {
                r.setState(function(e) {
                    var t = e.date;
                    return {
                        date: y.subMonths(t, 1)
                    };
                }, function() {
                    return r.handleMonthChange(r.state.date);
                });
            }), Ce(r, "handleDayClick", function(e, t, n) {
                r.props.onSelect(e, t, n), r.props.setPreSelection && r.props.setPreSelection(e);
            }), Ce(r, "handleDayMouseEnter", function(e) {
                r.setState({
                    selectingDate: e
                }), r.props.onDayMouseEnter && r.props.onDayMouseEnter(e);
            }), Ce(r, "handleMonthMouseLeave", function() {
                r.setState({
                    selectingDate: null
                }), r.props.onMonthMouseLeave && r.props.onMonthMouseLeave();
            }), Ce(r, "handleYearMouseEnter", function(e, t) {
                r.setState({
                    selectingDate: T.setYear(Te(), t)
                }), r.props.onYearMouseEnter && r.props.onYearMouseEnter(e, t);
            }), Ce(r, "handleYearMouseLeave", function(e, t) {
                r.props.onYearMouseLeave && r.props.onYearMouseLeave(e, t);
            }), Ce(r, "handleYearChange", function(e) {
                r.props.onYearChange && (r.props.onYearChange(e), r.setState({
                    isRenderAriaLiveMessage: !0
                })), r.props.adjustDateOnChange && (r.props.onSelect && r.props.onSelect(e), r.props.setOpen && r.props.setOpen(!0)), r.props.setPreSelection && r.props.setPreSelection(e);
            }), Ce(r, "handleMonthChange", function(e) {
                r.handleCustomMonthChange(e), r.props.adjustDateOnChange && (r.props.onSelect && r.props.onSelect(e), r.props.setOpen && r.props.setOpen(!0)), r.props.setPreSelection && r.props.setPreSelection(e);
            }), Ce(r, "handleCustomMonthChange", function(e) {
                r.props.onMonthChange && (r.props.onMonthChange(e), r.setState({
                    isRenderAriaLiveMessage: !0
                }));
            }), Ce(r, "handleMonthYearChange", function(e) {
                r.handleYearChange(e), r.handleMonthChange(e);
            }), Ce(r, "changeYear", function(e) {
                r.setState(function(t) {
                    var r = t.date;
                    return {
                        date: T.setYear(r, e)
                    };
                }, function() {
                    return r.handleYearChange(r.state.date);
                });
            }), Ce(r, "changeMonth", function(e) {
                r.setState(function(t) {
                    var r = t.date;
                    return {
                        date: x.setMonth(r, e)
                    };
                }, function() {
                    return r.handleMonthChange(r.state.date);
                });
            }), Ce(r, "changeMonthYear", function(e) {
                r.setState(function(t) {
                    var r = t.date;
                    return {
                        date: T.setYear(x.setMonth(r, C.getMonth(e)), Y.getYear(e))
                    };
                }, function() {
                    return r.handleMonthYearChange(r.state.date);
                });
            }), Ce(r, "header", function() {
                var e = We(arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : r.state.date, r.props.locale, r.props.calendarStartDay), t = [];
                return r.props.showWeekNumbers && t.push(he.default.createElement("div", {
                    key: "W",
                    className: "react-datepicker__day-name"
                }, r.props.weekLabel || "#")), t.concat([
                    0,
                    1,
                    2,
                    3,
                    4,
                    5,
                    6
                ].map(function(t) {
                    var a = c.addDays(e, t), o = r.formatWeekday(a, r.props.locale), s = r.props.weekDayClassName ? r.props.weekDayClassName(a) : void 0;
                    return he.default.createElement("div", {
                        key: t,
                        "aria-label": Le(a, "EEEE", r.props.locale),
                        className: n.clsx("react-datepicker__day-name", s)
                    }, o);
                }));
            }), Ce(r, "formatWeekday", function(e, t) {
                return r.props.formatWeekDay ? function(e, t, r) {
                    return t(Le(e, "EEEE", r));
                }(e, r.props.formatWeekDay, t) : r.props.useWeekdaysShort ? function(e, t) {
                    return Le(e, "EEE", t);
                }(e, t) : function(e, t) {
                    return Le(e, "EEEEEE", t);
                }(e, t);
            }), Ce(r, "decreaseYear", function() {
                r.setState(function(e) {
                    var t = e.date;
                    return {
                        date: v.subYears(t, r.props.showYearPicker ? r.props.yearItemNumber : 1)
                    };
                }, function() {
                    return r.handleYearChange(r.state.date);
                });
            }), Ce(r, "clearSelectingDate", function() {
                r.setState({
                    selectingDate: null
                });
            }), Ce(r, "renderPreviousButton", function() {
                if (!r.props.renderCustomHeader) {
                    var e;
                    switch(!0){
                        case r.props.showMonthYearPicker:
                            e = ft(r.state.date, r.props);
                            break;
                        case r.props.showYearPicker:
                            e = function(e) {
                                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, n = t.yearItemNumber, a = void 0 === n ? xe : n, o = bt(Ke(v.subYears(e, a)), a).endPeriod, s = r && Y.getYear(r);
                                return s && s > o || !1;
                            }(r.state.date, r.props);
                            break;
                        case r.props.showQuarterYearPicker:
                            e = function(e) {
                                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, n = t.includeDates, a = j.startOfYear(e), o = g.subQuarters(a, 1);
                                return r && Q.differenceInCalendarQuarters(r, o) > 0 || n && n.every(function(e) {
                                    return Q.differenceInCalendarQuarters(e, o) > 0;
                                }) || !1;
                            }(r.state.date, r.props);
                            break;
                        default:
                            e = ut(r.state.date, r.props);
                    }
                    if ((r.props.forceShowMonthNavigation || r.props.showDisabledMonthNavigation || !e) && !r.props.showTimeSelectOnly) {
                        var t = [
                            "react-datepicker__navigation",
                            "react-datepicker__navigation--previous"
                        ], n = r.decreaseMonth;
                        (r.props.showMonthYearPicker || r.props.showQuarterYearPicker || r.props.showYearPicker) && (n = r.decreaseYear), e && r.props.showDisabledMonthNavigation && (t.push("react-datepicker__navigation--previous--disabled"), n = null);
                        var a = r.props.showMonthYearPicker || r.props.showQuarterYearPicker || r.props.showYearPicker, o = r.props, s = o.previousMonthButtonLabel, i = o.previousYearButtonLabel, p = r.props, c = p.previousMonthAriaLabel, l = void 0 === c ? "string" == typeof s ? s : "Previous Month" : c, d = p.previousYearAriaLabel, u = void 0 === d ? "string" == typeof i ? i : "Previous Year" : d;
                        return he.default.createElement("button", {
                            type: "button",
                            className: t.join(" "),
                            onClick: n,
                            onKeyDown: r.props.handleOnKeyDown,
                            "aria-label": a ? u : l
                        }, he.default.createElement("span", {
                            className: [
                                "react-datepicker__navigation-icon",
                                "react-datepicker__navigation-icon--previous"
                            ].join(" ")
                        }, a ? r.props.previousYearButtonLabel : r.props.previousMonthButtonLabel));
                    }
                }
            }), Ce(r, "increaseYear", function() {
                r.setState(function(e) {
                    var t = e.date;
                    return {
                        date: h.addYears(t, r.props.showYearPicker ? r.props.yearItemNumber : 1)
                    };
                }, function() {
                    return r.handleYearChange(r.state.date);
                });
            }), Ce(r, "renderNextButton", function() {
                if (!r.props.renderCustomHeader) {
                    var e;
                    switch(!0){
                        case r.props.showMonthYearPicker:
                            e = mt(r.state.date, r.props);
                            break;
                        case r.props.showYearPicker:
                            e = function(e) {
                                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.maxDate, n = t.yearItemNumber, a = void 0 === n ? xe : n, o = bt(h.addYears(e, a), a).startPeriod, s = r && Y.getYear(r);
                                return s && s < o || !1;
                            }(r.state.date, r.props);
                            break;
                        case r.props.showQuarterYearPicker:
                            e = function(e) {
                                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.maxDate, n = t.includeDates, a = z.endOfYear(e), o = u.addQuarters(a, 1);
                                return r && Q.differenceInCalendarQuarters(o, r) > 0 || n && n.every(function(e) {
                                    return Q.differenceInCalendarQuarters(o, e) > 0;
                                }) || !1;
                            }(r.state.date, r.props);
                            break;
                        default:
                            e = ht(r.state.date, r.props);
                    }
                    if ((r.props.forceShowMonthNavigation || r.props.showDisabledMonthNavigation || !e) && !r.props.showTimeSelectOnly) {
                        var t = [
                            "react-datepicker__navigation",
                            "react-datepicker__navigation--next"
                        ];
                        r.props.showTimeSelect && t.push("react-datepicker__navigation--next--with-time"), r.props.todayButton && t.push("react-datepicker__navigation--next--with-today-button");
                        var n = r.increaseMonth;
                        (r.props.showMonthYearPicker || r.props.showQuarterYearPicker || r.props.showYearPicker) && (n = r.increaseYear), e && r.props.showDisabledMonthNavigation && (t.push("react-datepicker__navigation--next--disabled"), n = null);
                        var a = r.props.showMonthYearPicker || r.props.showQuarterYearPicker || r.props.showYearPicker, o = r.props, s = o.nextMonthButtonLabel, i = o.nextYearButtonLabel, p = r.props, c = p.nextMonthAriaLabel, l = void 0 === c ? "string" == typeof s ? s : "Next Month" : c, d = p.nextYearAriaLabel, f = void 0 === d ? "string" == typeof i ? i : "Next Year" : d;
                        return he.default.createElement("button", {
                            type: "button",
                            className: t.join(" "),
                            onClick: n,
                            onKeyDown: r.props.handleOnKeyDown,
                            "aria-label": a ? f : l
                        }, he.default.createElement("span", {
                            className: [
                                "react-datepicker__navigation-icon",
                                "react-datepicker__navigation-icon--next"
                            ].join(" ")
                        }, a ? r.props.nextYearButtonLabel : r.props.nextMonthButtonLabel));
                    }
                }
            }), Ce(r, "renderCurrentMonth", function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : r.state.date, t = [
                    "react-datepicker__current-month"
                ];
                return r.props.showYearDropdown && t.push("react-datepicker__current-month--hasYearDropdown"), r.props.showMonthDropdown && t.push("react-datepicker__current-month--hasMonthDropdown"), r.props.showMonthYearDropdown && t.push("react-datepicker__current-month--hasMonthYearDropdown"), he.default.createElement("div", {
                    className: t.join(" ")
                }, Le(e, r.props.dateFormat, r.props.locale));
            }), Ce(r, "renderYearDropdown", function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                if (r.props.showYearDropdown && !e) return he.default.createElement(Nt, {
                    adjustDateOnChange: r.props.adjustDateOnChange,
                    date: r.state.date,
                    onSelect: r.props.onSelect,
                    setOpen: r.props.setOpen,
                    dropdownMode: r.props.dropdownMode,
                    onChange: r.changeYear,
                    minDate: r.props.minDate,
                    maxDate: r.props.maxDate,
                    year: Y.getYear(r.state.date),
                    scrollableYearDropdown: r.props.scrollableYearDropdown,
                    yearDropdownItemNumber: r.props.yearDropdownItemNumber
                });
            }), Ce(r, "renderMonthDropdown", function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                if (r.props.showMonthDropdown && !e) return he.default.createElement(It, {
                    dropdownMode: r.props.dropdownMode,
                    locale: r.props.locale,
                    onChange: r.changeMonth,
                    month: C.getMonth(r.state.date),
                    useShortMonthInDropdown: r.props.useShortMonthInDropdown
                });
            }), Ce(r, "renderMonthYearDropdown", function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                if (r.props.showMonthYearDropdown && !e) return he.default.createElement(Ft, {
                    dropdownMode: r.props.dropdownMode,
                    locale: r.props.locale,
                    dateFormat: r.props.dateFormat,
                    onChange: r.changeMonthYear,
                    minDate: r.props.minDate,
                    maxDate: r.props.maxDate,
                    date: r.state.date,
                    scrollableMonthYearDropdown: r.props.scrollableMonthYearDropdown
                });
            }), Ce(r, "handleTodayButtonClick", function(e) {
                r.props.onSelect(Be(), e), r.props.setPreSelection && r.props.setPreSelection(Be());
            }), Ce(r, "renderTodayButton", function() {
                if (r.props.todayButton && !r.props.showTimeSelectOnly) return he.default.createElement("div", {
                    className: "react-datepicker__today-button",
                    onClick: function(e) {
                        return r.handleTodayButtonClick(e);
                    }
                }, r.props.todayButton);
            }), Ce(r, "renderDefaultHeader", function(e) {
                var t = e.monthDate, n = e.i;
                return he.default.createElement("div", {
                    className: "react-datepicker__header ".concat(r.props.showTimeSelect ? "react-datepicker__header--has-time-select" : "")
                }, r.renderCurrentMonth(t), he.default.createElement("div", {
                    className: "react-datepicker__header__dropdown react-datepicker__header__dropdown--".concat(r.props.dropdownMode),
                    onFocus: r.handleDropdownFocus
                }, r.renderMonthDropdown(0 !== n), r.renderMonthYearDropdown(0 !== n), r.renderYearDropdown(0 !== n)), he.default.createElement("div", {
                    className: "react-datepicker__day-names"
                }, r.header(t)));
            }), Ce(r, "renderCustomHeader", function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = e.monthDate, n = e.i;
                if (r.props.showTimeSelect && !r.state.monthContainer || r.props.showTimeSelectOnly) return null;
                var a = ut(r.state.date, r.props), o = ht(r.state.date, r.props), s = ft(r.state.date, r.props), i = mt(r.state.date, r.props), p = !r.props.showMonthYearPicker && !r.props.showQuarterYearPicker && !r.props.showYearPicker;
                return he.default.createElement("div", {
                    className: "react-datepicker__header react-datepicker__header--custom",
                    onFocus: r.props.onDropdownFocus
                }, r.props.renderCustomHeader(De(De({}, r.state), {}, {
                    customHeaderCount: n,
                    monthDate: t,
                    changeMonth: r.changeMonth,
                    changeYear: r.changeYear,
                    decreaseMonth: r.decreaseMonth,
                    increaseMonth: r.increaseMonth,
                    decreaseYear: r.decreaseYear,
                    increaseYear: r.increaseYear,
                    prevMonthButtonDisabled: a,
                    nextMonthButtonDisabled: o,
                    prevYearButtonDisabled: s,
                    nextYearButtonDisabled: i
                })), p && he.default.createElement("div", {
                    className: "react-datepicker__day-names"
                }, r.header(t)));
            }), Ce(r, "renderYearHeader", function(e) {
                var t = e.monthDate, n = r.props, a = n.showYearPicker, o = bt(t, n.yearItemNumber), s = o.startPeriod, i = o.endPeriod;
                return he.default.createElement("div", {
                    className: "react-datepicker__header react-datepicker-year-header"
                }, a ? "".concat(s, " - ").concat(i) : Y.getYear(t));
            }), Ce(r, "renderHeader", function(e) {
                switch(!0){
                    case void 0 !== r.props.renderCustomHeader:
                        return r.renderCustomHeader(e);
                    case r.props.showMonthYearPicker || r.props.showQuarterYearPicker || r.props.showYearPicker:
                        return r.renderYearHeader(e);
                    default:
                        return r.renderDefaultHeader(e);
                }
            }), Ce(r, "renderMonths", function() {
                var e;
                if (!r.props.showTimeSelectOnly && !r.props.showYearPicker) {
                    for(var t = [], n = r.props.showPreviousMonths ? r.props.monthsShown - 1 : 0, a = r.props.showMonthYearPicker || r.props.showQuarterYearPicker ? h.addYears(r.state.date, n) : y.subMonths(r.state.date, n), o = null !== (e = r.props.monthSelectedIn) && void 0 !== e ? e : n, s = 0; s < r.props.monthsShown; ++s){
                        var i = s - o + n, p = r.props.showMonthYearPicker || r.props.showQuarterYearPicker ? h.addYears(a, i) : d.addMonths(a, i), c = "month-".concat(s), l = s < r.props.monthsShown - 1, u = s > 0;
                        t.push(he.default.createElement("div", {
                            key: c,
                            ref: function(e) {
                                r.monthContainer = e;
                            },
                            className: "react-datepicker__month-container"
                        }, r.renderHeader({
                            monthDate: p,
                            i: s
                        }), he.default.createElement(Vt, {
                            chooseDayAriaLabelPrefix: r.props.chooseDayAriaLabelPrefix,
                            disabledDayAriaLabelPrefix: r.props.disabledDayAriaLabelPrefix,
                            weekAriaLabelPrefix: r.props.weekAriaLabelPrefix,
                            ariaLabelPrefix: r.props.monthAriaLabelPrefix,
                            onChange: r.changeMonthYear,
                            day: p,
                            dayClassName: r.props.dayClassName,
                            calendarStartDay: r.props.calendarStartDay,
                            monthClassName: r.props.monthClassName,
                            onDayClick: r.handleDayClick,
                            handleOnKeyDown: r.props.handleOnDayKeyDown,
                            handleOnMonthKeyDown: r.props.handleOnKeyDown,
                            usePointerEvent: r.props.usePointerEvent,
                            onDayMouseEnter: r.handleDayMouseEnter,
                            onMouseLeave: r.handleMonthMouseLeave,
                            onWeekSelect: r.props.onWeekSelect,
                            orderInDisplay: s,
                            formatWeekNumber: r.props.formatWeekNumber,
                            locale: r.props.locale,
                            minDate: r.props.minDate,
                            maxDate: r.props.maxDate,
                            excludeDates: r.props.excludeDates,
                            excludeDateIntervals: r.props.excludeDateIntervals,
                            highlightDates: r.props.highlightDates,
                            holidays: r.props.holidays,
                            selectingDate: r.state.selectingDate,
                            includeDates: r.props.includeDates,
                            includeDateIntervals: r.props.includeDateIntervals,
                            inline: r.props.inline,
                            shouldFocusDayInline: r.props.shouldFocusDayInline,
                            fixedHeight: r.props.fixedHeight,
                            filterDate: r.props.filterDate,
                            preSelection: r.props.preSelection,
                            setPreSelection: r.props.setPreSelection,
                            selected: r.props.selected,
                            selectsStart: r.props.selectsStart,
                            selectsEnd: r.props.selectsEnd,
                            selectsRange: r.props.selectsRange,
                            selectsDisabledDaysInRange: r.props.selectsDisabledDaysInRange,
                            selectsMultiple: r.props.selectsMultiple,
                            selectedDates: r.props.selectedDates,
                            showWeekNumbers: r.props.showWeekNumbers,
                            startDate: r.props.startDate,
                            endDate: r.props.endDate,
                            peekNextMonth: r.props.peekNextMonth,
                            setOpen: r.props.setOpen,
                            shouldCloseOnSelect: r.props.shouldCloseOnSelect,
                            renderDayContents: r.props.renderDayContents,
                            renderMonthContent: r.props.renderMonthContent,
                            renderQuarterContent: r.props.renderQuarterContent,
                            renderYearContent: r.props.renderYearContent,
                            disabledKeyboardNavigation: r.props.disabledKeyboardNavigation,
                            showMonthYearPicker: r.props.showMonthYearPicker,
                            showFullMonthYearPicker: r.props.showFullMonthYearPicker,
                            showTwoColumnMonthYearPicker: r.props.showTwoColumnMonthYearPicker,
                            showFourColumnMonthYearPicker: r.props.showFourColumnMonthYearPicker,
                            showYearPicker: r.props.showYearPicker,
                            showQuarterYearPicker: r.props.showQuarterYearPicker,
                            showWeekPicker: r.props.showWeekPicker,
                            isInputFocused: r.props.isInputFocused,
                            containerRef: r.containerRef,
                            monthShowsDuplicateDaysEnd: l,
                            monthShowsDuplicateDaysStart: u
                        })));
                    }
                    return t;
                }
            }), Ce(r, "renderYears", function() {
                if (!r.props.showTimeSelectOnly) return r.props.showYearPicker ? he.default.createElement("div", {
                    className: "react-datepicker__year--container"
                }, r.renderHeader({
                    monthDate: r.state.date
                }), he.default.createElement($t, _e({
                    onDayClick: r.handleDayClick,
                    selectingDate: r.state.selectingDate,
                    clearSelectingDate: r.clearSelectingDate,
                    date: r.state.date
                }, r.props, {
                    onYearMouseEnter: r.handleYearMouseEnter,
                    onYearMouseLeave: r.handleYearMouseLeave
                }))) : void 0;
            }), Ce(r, "renderTimeSection", function() {
                if (r.props.showTimeSelect && (r.state.monthContainer || r.props.showTimeSelectOnly)) return he.default.createElement(Ut, {
                    selected: r.props.selected,
                    openToDate: r.props.openToDate,
                    onChange: r.props.onTimeChange,
                    timeClassName: r.props.timeClassName,
                    format: r.props.timeFormat,
                    includeTimes: r.props.includeTimes,
                    intervals: r.props.timeIntervals,
                    minTime: r.props.minTime,
                    maxTime: r.props.maxTime,
                    excludeTimes: r.props.excludeTimes,
                    filterTime: r.props.filterTime,
                    timeCaption: r.props.timeCaption,
                    todayButton: r.props.todayButton,
                    showMonthDropdown: r.props.showMonthDropdown,
                    showMonthYearDropdown: r.props.showMonthYearDropdown,
                    showYearDropdown: r.props.showYearDropdown,
                    withPortal: r.props.withPortal,
                    monthRef: r.state.monthContainer,
                    injectTimes: r.props.injectTimes,
                    locale: r.props.locale,
                    handleOnKeyDown: r.props.handleOnKeyDown,
                    showTimeSelectOnly: r.props.showTimeSelectOnly
                });
            }), Ce(r, "renderInputTimeSection", function() {
                var e = new Date(r.props.selected), t = Re(e) && Boolean(r.props.selected) ? "".concat(wt(e.getHours()), ":").concat(wt(e.getMinutes())) : "";
                if (r.props.showTimeInput) return he.default.createElement(zt, {
                    date: e,
                    timeString: t,
                    timeInputLabel: r.props.timeInputLabel,
                    onChange: r.props.onTimeChange,
                    customTimeInput: r.props.customTimeInput
                });
            }), Ce(r, "renderAriaLiveRegion", function() {
                var e, t = bt(r.state.date, r.props.yearItemNumber), n = t.startPeriod, a = t.endPeriod;
                return e = r.props.showYearPicker ? "".concat(n, " - ").concat(a) : r.props.showMonthYearPicker || r.props.showQuarterYearPicker ? Y.getYear(r.state.date) : "".concat(Xe(C.getMonth(r.state.date), r.props.locale), " ").concat(Y.getYear(r.state.date)), he.default.createElement("span", {
                    role: "alert",
                    "aria-live": "polite",
                    className: "react-datepicker__aria-live"
                }, r.state.isRenderAriaLiveMessage && e);
            }), Ce(r, "renderChildren", function() {
                if (r.props.children) return he.default.createElement("div", {
                    className: "react-datepicker__children-container"
                }, r.props.children);
            }), r.containerRef = he.default.createRef(), r.state = {
                date: r.getDateInView(),
                selectingDate: null,
                monthContainer: null,
                isRenderAriaLiveMessage: !1
            }, r;
        }
        return Ye(t, e), Me(t, [
            {
                key: "componentDidMount",
                value: function() {
                    var e = this;
                    this.props.showTimeSelect && (this.assignMonthContainer = void e.setState({
                        monthContainer: e.monthContainer
                    }));
                }
            },
            {
                key: "componentDidUpdate",
                value: function(e) {
                    var t = this;
                    if (!this.props.preSelection || Ue(this.props.preSelection, e.preSelection) && this.props.monthSelectedIn === e.monthSelectedIn) this.props.openToDate && !Ue(this.props.openToDate, e.openToDate) && this.setState({
                        date: this.props.openToDate
                    });
                    else {
                        var r = !je(this.state.date, this.props.preSelection);
                        this.setState({
                            date: this.props.preSelection
                        }, function() {
                            return r && t.handleCustomMonthChange(t.state.date);
                        });
                    }
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this.props.container || Gt;
                    return he.default.createElement("div", {
                        style: {
                            display: "contents"
                        },
                        ref: this.containerRef
                    }, he.default.createElement(e, {
                        className: n.clsx("react-datepicker", this.props.className, {
                            "react-datepicker--time-only": this.props.showTimeSelectOnly
                        }),
                        showTime: this.props.showTimeSelect || this.props.showTimeInput,
                        showTimeSelectOnly: this.props.showTimeSelectOnly
                    }, this.renderAriaLiveRegion(), this.renderPreviousButton(), this.renderNextButton(), this.renderMonths(), this.renderYears(), this.renderTodayButton(), this.renderTimeSection(), this.renderInputTimeSection(), this.renderChildren()));
                }
            }
        ], [
            {
                key: "defaultProps",
                get: function() {
                    return {
                        onDropdownFocus: function() {},
                        monthsShown: 1,
                        forceShowMonthNavigation: !1,
                        timeCaption: "Time",
                        previousYearButtonLabel: "Previous Year",
                        nextYearButtonLabel: "Next Year",
                        previousMonthButtonLabel: "Previous Month",
                        nextMonthButtonLabel: "Next Month",
                        customTimeInput: null,
                        yearItemNumber: xe
                    };
                }
            }
        ]);
    }(he.default.Component), Zt = function(e) {
        var t = e.icon, r = e.className, n = void 0 === r ? "" : r, a = e.onClick, o = "react-datepicker__calendar-icon";
        return he.default.isValidElement(t) ? he.default.cloneElement(t, {
            className: "".concat(t.props.className || "", " ").concat(o, " ").concat(n),
            onClick: function(e) {
                "function" == typeof t.props.onClick && t.props.onClick(e), "function" == typeof a && a(e);
            }
        }) : "string" == typeof t ? he.default.createElement("i", {
            className: "".concat(o, " ").concat(t, " ").concat(n),
            "aria-hidden": "true",
            onClick: a
        }) : he.default.createElement("svg", {
            className: "".concat(o, " ").concat(n),
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 448 512",
            onClick: a
        }, he.default.createElement("path", {
            d: "M96 32V64H48C21.5 64 0 85.5 0 112v48H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192H0V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V192z"
        }));
    }, er = function(e) {
        function t(e) {
            var r;
            return be(this, t), (r = ye(this, t, [
                e
            ])).el = document.createElement("div"), r;
        }
        return Ye(t, e), Me(t, [
            {
                key: "componentDidMount",
                value: function() {
                    this.portalRoot = (this.props.portalHost || document).getElementById(this.props.portalId), this.portalRoot || (this.portalRoot = document.createElement("div"), this.portalRoot.setAttribute("id", this.props.portalId), (this.props.portalHost || document.body).appendChild(this.portalRoot)), this.portalRoot.appendChild(this.el);
                }
            },
            {
                key: "componentWillUnmount",
                value: function() {
                    this.portalRoot.removeChild(this.el);
                }
            },
            {
                key: "render",
                value: function() {
                    return me.default.createPortal(this.props.children, this.el);
                }
            }
        ]);
    }(he.default.Component), tr = function(e) {
        return !e.disabled && -1 !== e.tabIndex;
    }, rr = function(e) {
        function t(e) {
            var r;
            return be(this, t), Ce(r = ye(this, t, [
                e
            ]), "getTabChildren", function() {
                return Array.prototype.slice.call(r.tabLoopRef.current.querySelectorAll("[tabindex], a, button, input, select, textarea"), 1, -1).filter(tr);
            }), Ce(r, "handleFocusStart", function() {
                var e = r.getTabChildren();
                e && e.length > 1 && e[e.length - 1].focus();
            }), Ce(r, "handleFocusEnd", function() {
                var e = r.getTabChildren();
                e && e.length > 1 && e[0].focus();
            }), r.tabLoopRef = he.default.createRef(), r;
        }
        return Ye(t, e), Me(t, [
            {
                key: "render",
                value: function() {
                    return this.props.enableTabLoop ? he.default.createElement("div", {
                        className: "react-datepicker__tab-loop",
                        ref: this.tabLoopRef
                    }, he.default.createElement("div", {
                        className: "react-datepicker__tab-loop__start",
                        tabIndex: "0",
                        onFocus: this.handleFocusStart
                    }), this.props.children, he.default.createElement("div", {
                        className: "react-datepicker__tab-loop__end",
                        tabIndex: "0",
                        onFocus: this.handleFocusEnd
                    })) : this.props.children;
                }
            }
        ], [
            {
                key: "defaultProps",
                get: function() {
                    return {
                        enableTabLoop: !0
                    };
                }
            }
        ]);
    }(he.default.Component);
    var nr, ar = function(e) {
        function t() {
            return be(this, t), ye(this, t, arguments);
        }
        return Ye(t, e), Me(t, [
            {
                key: "render",
                value: function() {
                    var e, t = this.props, r = t.className, a = t.wrapperClassName, o = t.hidePopper, s = t.popperComponent, i = t.targetComponent, p = t.enableTabLoop, c = t.popperOnKeyDown, l = t.portalId, d = t.portalHost, u = t.popperProps, h = t.showArrow;
                    if (!o) {
                        var f = n.clsx("react-datepicker-popper", r);
                        e = he.default.createElement(rr, {
                            enableTabLoop: p
                        }, he.default.createElement("div", {
                            ref: u.refs.setFloating,
                            style: u.floatingStyles,
                            className: f,
                            "data-placement": u.placement,
                            onKeyDown: c
                        }, s, h && he.default.createElement(le.FloatingArrow, {
                            ref: u.arrowRef,
                            context: u.context,
                            fill: "currentColor",
                            strokeWidth: 1,
                            height: 8,
                            width: 16,
                            style: {
                                transform: "translateY(-1px)"
                            },
                            className: "react-datepicker__triangle"
                        })));
                    }
                    this.props.popperContainer && (e = he.default.createElement(this.props.popperContainer, {}, e)), l && !o && (e = he.default.createElement(er, {
                        portalId: l,
                        portalHost: d
                    }, e));
                    var m = n.clsx("react-datepicker-wrapper", a);
                    return he.default.createElement(he.default.Fragment, null, he.default.createElement("div", {
                        ref: u.refs.setReference,
                        className: m
                    }, i), e);
                }
            }
        ], [
            {
                key: "defaultProps",
                get: function() {
                    return {
                        hidePopper: !0
                    };
                }
            }
        ]);
    }(he.default.Component), or = (nr = ar, function(e) {
        var t = De(De({}, e), {}, {
            popperModifiers: e.popperModifiers || [],
            popperProps: e.popperProps || {},
            hidePopper: "boolean" != typeof e.hidePopper || e.hidePopper
        }), r = he.default.useRef(), n = le.useFloating(De({
            open: !t.hidePopper,
            whileElementsMounted: le.autoUpdate,
            placement: t.popperPlacement,
            middleware: [
                le.flip({
                    padding: 15
                }),
                le.offset(10),
                le.arrow({
                    element: r
                })
            ].concat(Ne(t.popperModifiers))
        }, t.popperProps));
        return he.default.createElement(nr, _e({}, t, {
            popperProps: De(De({}, n), {}, {
                arrowRef: r
            })
        }));
    }), sr = "react-datepicker-ignore-onclickoutside", ir = fe.default(Xt);
    var pr = "Date input not valid.", cr = function(e) {
        function t(e) {
            var r;
            return be(this, t), Ce(r = ye(this, t, [
                e
            ]), "getPreSelection", function() {
                return r.props.openToDate ? r.props.openToDate : r.props.selectsEnd && r.props.startDate ? r.props.startDate : r.props.selectsStart && r.props.endDate ? r.props.endDate : Te();
            }), Ce(r, "modifyHolidays", function() {
                var e;
                return null === (e = r.props.holidays) || void 0 === e ? void 0 : e.reduce(function(e, t) {
                    var r = new Date(t.date);
                    return o.isValid(r) ? [].concat(Ne(e), [
                        De(De({}, t), {}, {
                            date: r
                        })
                    ]) : e;
                }, []);
            }), Ce(r, "calcInitialState", function() {
                var e, t = r.getPreSelection(), n = yt(r.props), a = gt(r.props), o = n && re.isBefore(t, K.startOfDay(n)) ? n : a && te.isAfter(t, V.endOfDay(a)) ? a : t;
                return {
                    open: r.props.startOpen || !1,
                    preventFocus: !1,
                    preSelection: null !== (e = r.props.selectsRange ? r.props.startDate : r.props.selected) && void 0 !== e ? e : o,
                    highlightDates: vt(r.props.highlightDates),
                    focused: !1,
                    shouldFocusDayInline: !1,
                    isRenderAriaLiveMessage: !1
                };
            }), Ce(r, "clearPreventFocusTimeout", function() {
                r.preventFocusTimeout && clearTimeout(r.preventFocusTimeout);
            }), Ce(r, "setFocus", function() {
                r.input && r.input.focus && r.input.focus({
                    preventScroll: !0
                });
            }), Ce(r, "setBlur", function() {
                r.input && r.input.blur && r.input.blur(), r.cancelFocusInput();
            }), Ce(r, "setOpen", function(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                r.setState({
                    open: e,
                    preSelection: e && r.state.open ? r.state.preSelection : r.calcInitialState().preSelection,
                    lastPreSelectChange: dr
                }, function() {
                    e || r.setState(function(e) {
                        return {
                            focused: !!t && e.focused
                        };
                    }, function() {
                        !t && r.setBlur(), r.setState({
                            inputValue: null
                        });
                    });
                });
            }), Ce(r, "inputOk", function() {
                return a.isDate(r.state.preSelection);
            }), Ce(r, "isCalendarOpen", function() {
                return void 0 === r.props.open ? r.state.open && !r.props.disabled && !r.props.readOnly : r.props.open;
            }), Ce(r, "handleFocus", function(e) {
                r.state.preventFocus || (r.props.onFocus(e), r.props.preventOpenOnFocus || r.props.readOnly || r.setOpen(!0)), r.setState({
                    focused: !0
                });
            }), Ce(r, "sendFocusBackToInput", function() {
                r.preventFocusTimeout && r.clearPreventFocusTimeout(), r.setState({
                    preventFocus: !0
                }, function() {
                    r.preventFocusTimeout = setTimeout(function() {
                        r.setFocus(), r.setState({
                            preventFocus: !1
                        });
                    });
                });
            }), Ce(r, "cancelFocusInput", function() {
                clearTimeout(r.inputFocusTimeout), r.inputFocusTimeout = null;
            }), Ce(r, "deferFocusInput", function() {
                r.cancelFocusInput(), r.inputFocusTimeout = setTimeout(function() {
                    return r.setFocus();
                }, 1);
            }), Ce(r, "handleDropdownFocus", function() {
                r.cancelFocusInput();
            }), Ce(r, "handleBlur", function(e) {
                (!r.state.open || r.props.withPortal || r.props.showTimeInput) && r.props.onBlur(e), r.setState({
                    focused: !1
                });
            }), Ce(r, "handleCalendarClickOutside", function(e) {
                r.props.inline || r.setOpen(!1), r.props.onClickOutside(e), r.props.withPortal && e.preventDefault();
            }), Ce(r, "handleChange", function() {
                for(var e = arguments.length, t = new Array(e), n = 0; n < e; n++)t[n] = arguments[n];
                var a = t[0];
                if (!r.props.onChangeRaw || (r.props.onChangeRaw.apply(r, t), "function" == typeof a.isDefaultPrevented && !a.isDefaultPrevented())) {
                    r.setState({
                        inputValue: a.target.value,
                        lastPreSelectChange: lr
                    });
                    var o, i, p, c, l, d, u, h, f = (o = a.target.value, i = r.props.dateFormat, p = r.props.locale, c = r.props.strictParsing, l = r.props.minDate, d = null, u = Je(p) || Je(Ge()), h = !0, Array.isArray(i) ? (i.forEach(function(e) {
                        var t = oe.parse(o, e, new Date, {
                            locale: u,
                            useAdditionalWeekYearTokens: !0,
                            useAdditionalDayOfYearTokens: !0
                        });
                        c && (h = Re(t, l) && o === Le(t, e, p)), Re(t, l) && h && (d = t);
                    }), d) : (d = oe.parse(o, i, new Date, {
                        locale: u,
                        useAdditionalWeekYearTokens: !0,
                        useAdditionalDayOfYearTokens: !0
                    }), c ? h = Re(d) && o === Le(d, i, p) : Re(d) || (i = i.match(Ie).map(function(e) {
                        var t = e[0];
                        if ("p" === t || "P" === t) {
                            var r = s.longFormatters[t];
                            return u ? r(e, u.formatLong) : t;
                        }
                        return e;
                    }).join(""), o.length > 0 && (d = oe.parse(o, i.slice(0, o.length), new Date, {
                        useAdditionalWeekYearTokens: !0,
                        useAdditionalDayOfYearTokens: !0
                    })), Re(d) || (d = new Date(o))), Re(d) && h ? d : null));
                    r.props.showTimeSelectOnly && r.props.selected && f && !Ue(f, r.props.selected) && (f = de.set(r.props.selected, {
                        hours: w.getHours(f),
                        minutes: k.getMinutes(f),
                        seconds: D.getSeconds(f)
                    })), !f && a.target.value || r.setSelected(f, a, !0);
                }
            }), Ce(r, "handleSelect", function(e, t, n) {
                if (r.props.shouldCloseOnSelect && !r.props.showTimeSelect && r.sendFocusBackToInput(), r.props.onChangeRaw && r.props.onChangeRaw(t), r.setSelected(e, t, !1, n), r.props.showDateSelect && r.setState({
                    isRenderAriaLiveMessage: !0
                }), !r.props.shouldCloseOnSelect || r.props.showTimeSelect) r.setPreSelection(e);
                else if (!r.props.inline) {
                    r.props.selectsRange || r.setOpen(!1);
                    var a = r.props, o = a.startDate, s = a.endDate;
                    !o || s || !r.props.swapRange && Ct(e, o) || r.setOpen(!1);
                }
            }), Ce(r, "setSelected", function(e, t, n, a) {
                var o = e;
                if (r.props.showYearPicker) {
                    if (null !== o && st(Y.getYear(o), r.props)) return;
                } else if (r.props.showMonthYearPicker) {
                    if (null !== o && rt(o, r.props)) return;
                } else if (null !== o && et(o, r.props)) return;
                var s = r.props, i = s.onChange, p = s.selectsRange, c = s.startDate, l = s.endDate, d = s.selectsMultiple, u = s.selectedDates, h = s.minTime, f = s.swapRange;
                if (!$e(r.props.selected, o) || r.props.allowSameDay || p || d) {
                    if (null !== o && (!r.props.selected || n && (r.props.showTimeSelect || r.props.showTimeSelectOnly || r.props.showTimeInput) || (o = Ae(o, {
                        hour: w.getHours(r.props.selected),
                        minute: k.getMinutes(r.props.selected),
                        second: D.getSeconds(r.props.selected)
                    })), n || !r.props.showTimeSelect && !r.props.showTimeSelectOnly || h && (o = Ae(o, {
                        hour: h.getHours(),
                        minute: h.getMinutes(),
                        second: h.getSeconds()
                    })), r.props.inline || r.setState({
                        preSelection: o
                    }), r.props.focusSelectedMonth || r.setState({
                        monthSelectedIn: a
                    })), p) {
                        var m = c && !l, y = c && l;
                        !c && !l ? i([
                            o,
                            null
                        ], t) : m && (null === o ? i([
                            null,
                            null
                        ], t) : Ct(o, c) ? i(f ? [
                            o,
                            c
                        ] : [
                            o,
                            null
                        ], t) : i([
                            c,
                            o
                        ], t)), y && i([
                            o,
                            null
                        ], t);
                    } else if (d) {
                        if (null != u && u.length) {
                            if (u.some(function(e) {
                                return Ue(e, o);
                            })) i(u.filter(function(e) {
                                return !Ue(e, o);
                            }), t);
                            else i([].concat(Ne(u), [
                                o
                            ]), t);
                        } else i([
                            o
                        ], t);
                    } else i(o, t);
                }
                n || (r.props.onSelect(o, t), r.setState({
                    inputValue: null
                }));
            }), Ce(r, "setPreSelection", function(e) {
                var t = void 0 !== r.props.minDate, n = void 0 !== r.props.maxDate, a = !0;
                if (e) {
                    var o = K.startOfDay(e);
                    if (t && n) a = ze(e, r.props.minDate, r.props.maxDate);
                    else if (t) {
                        var s = K.startOfDay(r.props.minDate);
                        a = te.isAfter(e, s) || $e(o, s);
                    } else if (n) {
                        var i = V.endOfDay(r.props.maxDate);
                        a = re.isBefore(e, i) || $e(o, i);
                    }
                }
                a && r.setState({
                    preSelection: e
                });
            }), Ce(r, "toggleCalendar", function() {
                r.setOpen(!r.state.open);
            }), Ce(r, "handleTimeChange", function(e) {
                var t = r.props.selected ? r.props.selected : r.getPreSelection(), n = r.props.selected ? e : Ae(t, {
                    hour: w.getHours(e),
                    minute: k.getMinutes(e)
                });
                r.setState({
                    preSelection: n
                }), r.props.onChange(n), r.props.shouldCloseOnSelect && (r.sendFocusBackToInput(), r.setOpen(!1)), r.props.showTimeInput && r.setOpen(!0), (r.props.showTimeSelectOnly || r.props.showTimeSelect) && r.setState({
                    isRenderAriaLiveMessage: !0
                }), r.setState({
                    inputValue: null
                });
            }), Ce(r, "onInputClick", function() {
                r.props.disabled || r.props.readOnly || r.setOpen(!0), r.props.onInputClick();
            }), Ce(r, "onInputKeyDown", function(e) {
                r.props.onKeyDown(e);
                var t = e.key;
                if (r.state.open || r.props.inline || r.props.preventOpenOnFocus) {
                    if (r.state.open) {
                        if ("ArrowDown" === t || "ArrowUp" === t) {
                            e.preventDefault();
                            var n = r.props.showWeekPicker && r.props.showWeekNumbers ? '.react-datepicker__week-number[tabindex="0"]' : r.props.showFullMonthYearPicker || r.props.showMonthYearPicker ? '.react-datepicker__month-text[tabindex="0"]' : '.react-datepicker__day[tabindex="0"]', a = r.calendar.componentNode && r.calendar.componentNode.querySelector(n);
                            return void (a && a.focus({
                                preventScroll: !0
                            }));
                        }
                        var o = Te(r.state.preSelection);
                        "Enter" === t ? (e.preventDefault(), r.inputOk() && r.state.lastPreSelectChange === dr ? (r.handleSelect(o, e), !r.props.shouldCloseOnSelect && r.setPreSelection(o)) : r.setOpen(!1)) : "Escape" === t ? (e.preventDefault(), r.sendFocusBackToInput(), r.setOpen(!1)) : "Tab" === t && r.setOpen(!1), r.inputOk() || r.props.onInputError({
                            code: 1,
                            msg: pr
                        });
                    }
                } else "ArrowDown" !== t && "ArrowUp" !== t && "Enter" !== t || r.onInputClick();
            }), Ce(r, "onPortalKeyDown", function(e) {
                "Escape" === e.key && (e.preventDefault(), r.setState({
                    preventFocus: !0
                }, function() {
                    r.setOpen(!1), setTimeout(function() {
                        r.setFocus(), r.setState({
                            preventFocus: !1
                        });
                    });
                }));
            }), Ce(r, "onDayKeyDown", function(e) {
                r.props.onKeyDown(e);
                var t, n = e.key, a = e.shiftKey, o = Te(r.state.preSelection);
                if ("Enter" === n) e.preventDefault(), r.handleSelect(o, e), !r.props.shouldCloseOnSelect && r.setPreSelection(o);
                else if ("Escape" === n) e.preventDefault(), r.setOpen(!1), r.inputOk() || r.props.onInputError({
                    code: 1,
                    msg: pr
                });
                else if (!r.props.disabledKeyboardNavigation) {
                    var s;
                    switch(n){
                        case "ArrowLeft":
                            s = r.props.showWeekPicker ? m.subWeeks(o, 1) : f.subDays(o, 1);
                            break;
                        case "ArrowRight":
                            s = r.props.showWeekPicker ? l.addWeeks(o, 1) : c.addDays(o, 1);
                            break;
                        case "ArrowUp":
                            s = m.subWeeks(o, 1);
                            break;
                        case "ArrowDown":
                            s = l.addWeeks(o, 1);
                            break;
                        case "PageUp":
                            s = a ? v.subYears(o, 1) : y.subMonths(o, 1);
                            break;
                        case "PageDown":
                            s = a ? h.addYears(o, 1) : d.addMonths(o, 1);
                            break;
                        case "Home":
                            s = We(o, r.props.locale, r.props.calendarStartDay);
                            break;
                        case "End":
                            t = o, s = U.endOfWeek(t);
                            break;
                        default:
                            s = null;
                    }
                    if (!s) return void (r.props.onInputError && r.props.onInputError({
                        code: 1,
                        msg: pr
                    }));
                    if (e.preventDefault(), r.setState({
                        lastPreSelectChange: dr
                    }), r.props.adjustDateOnChange && r.setSelected(s), r.setPreSelection(s), r.props.inline) {
                        var i = C.getMonth(o), p = C.getMonth(s), u = Y.getYear(o), g = Y.getYear(s);
                        i !== p || u !== g ? r.setState({
                            shouldFocusDayInline: !0
                        }) : r.setState({
                            shouldFocusDayInline: !1
                        });
                    }
                }
            }), Ce(r, "onPopperKeyDown", function(e) {
                "Escape" === e.key && (e.preventDefault(), r.sendFocusBackToInput());
            }), Ce(r, "onClearClick", function(e) {
                e && e.preventDefault && e.preventDefault(), r.sendFocusBackToInput(), r.props.selectsRange ? r.props.onChange([
                    null,
                    null
                ], e) : r.props.onChange(null, e), r.setState({
                    inputValue: null
                });
            }), Ce(r, "clear", function() {
                r.onClearClick();
            }), Ce(r, "onScroll", function(e) {
                "boolean" == typeof r.props.closeOnScroll && r.props.closeOnScroll ? e.target !== document && e.target !== document.documentElement && e.target !== document.body || r.setOpen(!1) : "function" == typeof r.props.closeOnScroll && r.props.closeOnScroll(e) && r.setOpen(!1);
            }), Ce(r, "renderCalendar", function() {
                return r.props.inline || r.isCalendarOpen() ? he.default.createElement(ir, {
                    ref: function(e) {
                        r.calendar = e;
                    },
                    locale: r.props.locale,
                    calendarStartDay: r.props.calendarStartDay,
                    chooseDayAriaLabelPrefix: r.props.chooseDayAriaLabelPrefix,
                    disabledDayAriaLabelPrefix: r.props.disabledDayAriaLabelPrefix,
                    weekAriaLabelPrefix: r.props.weekAriaLabelPrefix,
                    monthAriaLabelPrefix: r.props.monthAriaLabelPrefix,
                    adjustDateOnChange: r.props.adjustDateOnChange,
                    setOpen: r.setOpen,
                    shouldCloseOnSelect: r.props.shouldCloseOnSelect,
                    dateFormat: r.props.dateFormatCalendar,
                    useWeekdaysShort: r.props.useWeekdaysShort,
                    formatWeekDay: r.props.formatWeekDay,
                    dropdownMode: r.props.dropdownMode,
                    selected: r.props.selected,
                    preSelection: r.state.preSelection,
                    onSelect: r.handleSelect,
                    onWeekSelect: r.props.onWeekSelect,
                    openToDate: r.props.openToDate,
                    minDate: r.props.minDate,
                    maxDate: r.props.maxDate,
                    selectsStart: r.props.selectsStart,
                    selectsEnd: r.props.selectsEnd,
                    selectsRange: r.props.selectsRange,
                    selectsMultiple: r.props.selectsMultiple,
                    selectedDates: r.props.selectedDates,
                    startDate: r.props.startDate,
                    endDate: r.props.endDate,
                    excludeDates: r.props.excludeDates,
                    excludeDateIntervals: r.props.excludeDateIntervals,
                    filterDate: r.props.filterDate,
                    onClickOutside: r.handleCalendarClickOutside,
                    formatWeekNumber: r.props.formatWeekNumber,
                    highlightDates: r.state.highlightDates,
                    holidays: Dt(r.modifyHolidays()),
                    includeDates: r.props.includeDates,
                    includeDateIntervals: r.props.includeDateIntervals,
                    includeTimes: r.props.includeTimes,
                    injectTimes: r.props.injectTimes,
                    inline: r.props.inline,
                    shouldFocusDayInline: r.state.shouldFocusDayInline,
                    peekNextMonth: r.props.peekNextMonth,
                    showMonthDropdown: r.props.showMonthDropdown,
                    showPreviousMonths: r.props.showPreviousMonths,
                    useShortMonthInDropdown: r.props.useShortMonthInDropdown,
                    showMonthYearDropdown: r.props.showMonthYearDropdown,
                    showWeekNumbers: r.props.showWeekNumbers,
                    showYearDropdown: r.props.showYearDropdown,
                    withPortal: r.props.withPortal,
                    forceShowMonthNavigation: r.props.forceShowMonthNavigation,
                    showDisabledMonthNavigation: r.props.showDisabledMonthNavigation,
                    scrollableYearDropdown: r.props.scrollableYearDropdown,
                    scrollableMonthYearDropdown: r.props.scrollableMonthYearDropdown,
                    todayButton: r.props.todayButton,
                    weekLabel: r.props.weekLabel,
                    outsideClickIgnoreClass: sr,
                    fixedHeight: r.props.fixedHeight,
                    monthsShown: r.props.monthsShown,
                    monthSelectedIn: r.state.monthSelectedIn,
                    onDropdownFocus: r.handleDropdownFocus,
                    onMonthChange: r.props.onMonthChange,
                    onYearChange: r.props.onYearChange,
                    dayClassName: r.props.dayClassName,
                    weekDayClassName: r.props.weekDayClassName,
                    monthClassName: r.props.monthClassName,
                    timeClassName: r.props.timeClassName,
                    showDateSelect: r.props.showDateSelect,
                    showTimeSelect: r.props.showTimeSelect,
                    showTimeSelectOnly: r.props.showTimeSelectOnly,
                    onTimeChange: r.handleTimeChange,
                    timeFormat: r.props.timeFormat,
                    timeIntervals: r.props.timeIntervals,
                    minTime: r.props.minTime,
                    maxTime: r.props.maxTime,
                    excludeTimes: r.props.excludeTimes,
                    filterTime: r.props.filterTime,
                    timeCaption: r.props.timeCaption,
                    className: r.props.calendarClassName,
                    container: r.props.calendarContainer,
                    yearItemNumber: r.props.yearItemNumber,
                    yearDropdownItemNumber: r.props.yearDropdownItemNumber,
                    previousMonthAriaLabel: r.props.previousMonthAriaLabel,
                    previousMonthButtonLabel: r.props.previousMonthButtonLabel,
                    nextMonthAriaLabel: r.props.nextMonthAriaLabel,
                    nextMonthButtonLabel: r.props.nextMonthButtonLabel,
                    previousYearAriaLabel: r.props.previousYearAriaLabel,
                    previousYearButtonLabel: r.props.previousYearButtonLabel,
                    nextYearAriaLabel: r.props.nextYearAriaLabel,
                    nextYearButtonLabel: r.props.nextYearButtonLabel,
                    timeInputLabel: r.props.timeInputLabel,
                    disabledKeyboardNavigation: r.props.disabledKeyboardNavigation,
                    renderCustomHeader: r.props.renderCustomHeader,
                    popperProps: r.props.popperProps,
                    renderDayContents: r.props.renderDayContents,
                    renderMonthContent: r.props.renderMonthContent,
                    renderQuarterContent: r.props.renderQuarterContent,
                    renderYearContent: r.props.renderYearContent,
                    onDayMouseEnter: r.props.onDayMouseEnter,
                    onMonthMouseLeave: r.props.onMonthMouseLeave,
                    onYearMouseEnter: r.props.onYearMouseEnter,
                    onYearMouseLeave: r.props.onYearMouseLeave,
                    selectsDisabledDaysInRange: r.props.selectsDisabledDaysInRange,
                    showTimeInput: r.props.showTimeInput,
                    showMonthYearPicker: r.props.showMonthYearPicker,
                    showFullMonthYearPicker: r.props.showFullMonthYearPicker,
                    showTwoColumnMonthYearPicker: r.props.showTwoColumnMonthYearPicker,
                    showFourColumnMonthYearPicker: r.props.showFourColumnMonthYearPicker,
                    showYearPicker: r.props.showYearPicker,
                    showQuarterYearPicker: r.props.showQuarterYearPicker,
                    showWeekPicker: r.props.showWeekPicker,
                    excludeScrollbar: r.props.excludeScrollbar,
                    handleOnKeyDown: r.props.onKeyDown,
                    handleOnDayKeyDown: r.onDayKeyDown,
                    isInputFocused: r.state.focused,
                    customTimeInput: r.props.customTimeInput,
                    setPreSelection: r.setPreSelection,
                    usePointerEvent: r.props.usePointerEvent,
                    yearClassName: r.props.yearClassName
                }, r.props.children) : null;
            }), Ce(r, "renderAriaLiveRegion", function() {
                var e, t = r.props, n = t.dateFormat, a = t.locale, o = r.props.showTimeInput || r.props.showTimeSelect ? "PPPPp" : "PPPP";
                return e = r.props.selectsRange ? "Selected start date: ".concat(Fe(r.props.startDate, {
                    dateFormat: o,
                    locale: a
                }), ". ").concat(r.props.endDate ? "End date: " + Fe(r.props.endDate, {
                    dateFormat: o,
                    locale: a
                }) : "") : r.props.showTimeSelectOnly ? "Selected time: ".concat(Fe(r.props.selected, {
                    dateFormat: n,
                    locale: a
                })) : r.props.showYearPicker ? "Selected year: ".concat(Fe(r.props.selected, {
                    dateFormat: "yyyy",
                    locale: a
                })) : r.props.showMonthYearPicker ? "Selected month: ".concat(Fe(r.props.selected, {
                    dateFormat: "MMMM yyyy",
                    locale: a
                })) : r.props.showQuarterYearPicker ? "Selected quarter: ".concat(Fe(r.props.selected, {
                    dateFormat: "yyyy, QQQ",
                    locale: a
                })) : "Selected date: ".concat(Fe(r.props.selected, {
                    dateFormat: o,
                    locale: a
                })), he.default.createElement("span", {
                    role: "alert",
                    "aria-live": "polite",
                    className: "react-datepicker__aria-live"
                }, e);
            }), Ce(r, "renderDateInput", function() {
                var e, t = n.clsx(r.props.className, Ce({}, sr, r.state.open)), a = r.props.customInput || he.default.createElement("input", {
                    type: "text"
                }), o = r.props.customInputRef || "ref", s = "string" == typeof r.props.value ? r.props.value : "string" == typeof r.state.inputValue ? r.state.inputValue : r.props.selectsRange ? function(e, t, r) {
                    if (!e) return "";
                    var n = Fe(e, r), a = t ? Fe(t, r) : "";
                    return "".concat(n, " - ").concat(a);
                }(r.props.startDate, r.props.endDate, r.props) : r.props.selectsMultiple ? function(e, t) {
                    if (null == e || !e.length) return "";
                    var r = Fe(e[0], t);
                    if (1 === e.length) return r;
                    if (2 === e.length) {
                        var n = Fe(e[1], t);
                        return "".concat(r, ", ").concat(n);
                    }
                    var a = e.length - 1;
                    return "".concat(r, " (+").concat(a, ")");
                }(r.props.selectedDates, r.props) : Fe(r.props.selected, r.props);
                return he.default.cloneElement(a, (Ce(Ce(Ce(Ce(Ce(Ce(Ce(Ce(Ce(Ce(e = {}, o, function(e) {
                    r.input = e;
                }), "value", s), "onBlur", r.handleBlur), "onChange", r.handleChange), "onClick", r.onInputClick), "onFocus", r.handleFocus), "onKeyDown", r.onInputKeyDown), "id", r.props.id), "name", r.props.name), "form", r.props.form), Ce(Ce(Ce(Ce(Ce(Ce(Ce(Ce(Ce(Ce(e, "autoFocus", r.props.autoFocus), "placeholder", r.props.placeholderText), "disabled", r.props.disabled), "autoComplete", r.props.autoComplete), "className", n.clsx(a.props.className, t)), "title", r.props.title), "readOnly", r.props.readOnly), "required", r.props.required), "tabIndex", r.props.tabIndex), "aria-describedby", r.props.ariaDescribedBy), Ce(Ce(Ce(e, "aria-invalid", r.props.ariaInvalid), "aria-labelledby", r.props.ariaLabelledBy), "aria-required", r.props.ariaRequired)));
            }), Ce(r, "renderClearButton", function() {
                var e = r.props, t = e.isClearable, a = e.disabled, o = e.selected, s = e.startDate, i = e.endDate, p = e.clearButtonTitle, c = e.clearButtonClassName, l = void 0 === c ? "" : c, d = e.ariaLabelClose, u = void 0 === d ? "Close" : d, h = e.selectedDates;
                return t && (null != o || null != s || null != i || null != h && h.length) ? he.default.createElement("button", {
                    type: "button",
                    className: n.clsx("react-datepicker__close-icon", l, {
                        "react-datepicker__close-icon--disabled": a
                    }),
                    disabled: a,
                    "aria-label": u,
                    onClick: r.onClearClick,
                    title: p,
                    tabIndex: -1
                }) : null;
            }), r.state = r.calcInitialState(), r.preventFocusTimeout = null, r;
        }
        return Ye(t, e), Me(t, [
            {
                key: "componentDidMount",
                value: function() {
                    window.addEventListener("scroll", this.onScroll, !0);
                }
            },
            {
                key: "componentDidUpdate",
                value: function(e, t) {
                    var r, n;
                    e.inline && (r = e.selected, n = this.props.selected, r && n ? C.getMonth(r) !== C.getMonth(n) || Y.getYear(r) !== Y.getYear(n) : r !== n) && this.setPreSelection(this.props.selected), void 0 !== this.state.monthSelectedIn && e.monthsShown !== this.props.monthsShown && this.setState({
                        monthSelectedIn: 0
                    }), e.highlightDates !== this.props.highlightDates && this.setState({
                        highlightDates: vt(this.props.highlightDates)
                    }), t.focused || $e(e.selected, this.props.selected) || this.setState({
                        inputValue: null
                    }), t.open !== this.state.open && (!1 === t.open && !0 === this.state.open && this.props.onCalendarOpen(), !0 === t.open && !1 === this.state.open && this.props.onCalendarClose());
                }
            },
            {
                key: "componentWillUnmount",
                value: function() {
                    this.clearPreventFocusTimeout(), window.removeEventListener("scroll", this.onScroll, !0);
                }
            },
            {
                key: "renderInputContainer",
                value: function() {
                    var e = this.props, t = e.showIcon, r = e.icon, n = e.calendarIconClassname, a = e.toggleCalendarOnIconClick, o = this.state.open;
                    return he.default.createElement("div", {
                        className: "react-datepicker__input-container".concat(t ? " react-datepicker__view-calendar-icon" : "")
                    }, t && he.default.createElement(Zt, _e({
                        icon: r,
                        className: "".concat(n, " ").concat(o && "react-datepicker-ignore-onclickoutside")
                    }, a ? {
                        onClick: this.toggleCalendar
                    } : null)), this.state.isRenderAriaLiveMessage && this.renderAriaLiveRegion(), this.renderDateInput(), this.renderClearButton());
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this.renderCalendar();
                    if (this.props.inline) return e;
                    if (this.props.withPortal) {
                        var t = this.state.open ? he.default.createElement(rr, {
                            enableTabLoop: this.props.enableTabLoop
                        }, he.default.createElement("div", {
                            className: "react-datepicker__portal",
                            tabIndex: -1,
                            onKeyDown: this.onPortalKeyDown
                        }, e)) : null;
                        return this.state.open && this.props.portalId && (t = he.default.createElement(er, {
                            portalId: this.props.portalId,
                            portalHost: this.props.portalHost
                        }, t)), he.default.createElement("div", null, this.renderInputContainer(), t);
                    }
                    return he.default.createElement(or, {
                        className: this.props.popperClassName,
                        wrapperClassName: this.props.wrapperClassName,
                        hidePopper: !this.isCalendarOpen(),
                        portalId: this.props.portalId,
                        portalHost: this.props.portalHost,
                        popperModifiers: this.props.popperModifiers,
                        targetComponent: this.renderInputContainer(),
                        popperContainer: this.props.popperContainer,
                        popperComponent: e,
                        popperPlacement: this.props.popperPlacement,
                        popperProps: this.props.popperProps,
                        popperOnKeyDown: this.onPopperKeyDown,
                        enableTabLoop: this.props.enableTabLoop,
                        showArrow: this.props.showPopperArrow
                    });
                }
            }
        ], [
            {
                key: "defaultProps",
                get: function() {
                    return {
                        allowSameDay: !1,
                        dateFormat: "MM/dd/yyyy",
                        dateFormatCalendar: "LLLL yyyy",
                        onChange: function() {},
                        disabled: !1,
                        disabledKeyboardNavigation: !1,
                        dropdownMode: "scroll",
                        onFocus: function() {},
                        onBlur: function() {},
                        onKeyDown: function() {},
                        onInputClick: function() {},
                        onSelect: function() {},
                        onClickOutside: function() {},
                        onMonthChange: function() {},
                        onCalendarOpen: function() {},
                        onCalendarClose: function() {},
                        preventOpenOnFocus: !1,
                        onYearChange: function() {},
                        onInputError: function() {},
                        monthsShown: 1,
                        readOnly: !1,
                        withPortal: !1,
                        selectsDisabledDaysInRange: !1,
                        shouldCloseOnSelect: !0,
                        showTimeSelect: !1,
                        showTimeInput: !1,
                        showPreviousMonths: !1,
                        showMonthYearPicker: !1,
                        showFullMonthYearPicker: !1,
                        showTwoColumnMonthYearPicker: !1,
                        showFourColumnMonthYearPicker: !1,
                        showYearPicker: !1,
                        showQuarterYearPicker: !1,
                        showWeekPicker: !1,
                        strictParsing: !1,
                        swapRange: !1,
                        timeIntervals: 30,
                        timeCaption: "Time",
                        previousMonthAriaLabel: "Previous Month",
                        previousMonthButtonLabel: "Previous Month",
                        nextMonthAriaLabel: "Next Month",
                        nextMonthButtonLabel: "Next Month",
                        previousYearAriaLabel: "Previous Year",
                        previousYearButtonLabel: "Previous Year",
                        nextYearAriaLabel: "Next Year",
                        nextYearButtonLabel: "Next Year",
                        timeInputLabel: "Time",
                        enableTabLoop: !0,
                        yearItemNumber: xe,
                        focusSelectedMonth: !1,
                        showPopperArrow: !0,
                        excludeScrollbar: !0,
                        customTimeInput: null,
                        calendarStartDay: void 0,
                        toggleCalendarOnIconClick: !1,
                        usePointerEvent: !1
                    };
                }
            }
        ]);
    }(he.default.Component), lr = "input", dr = "navigate";
    e.CalendarContainer = Gt, e.default = cr, e.getDefaultLocale = Ge, e.registerLocale = function(e, t) {
        var r = "undefined" != typeof window ? window : globalThis;
        r.__localeData__ || (r.__localeData__ = {}), r.__localeData__[e] = t;
    }, e.setDefaultLocale = function(e) {
        ("undefined" != typeof window ? window : globalThis).__localeId__ = e;
    }, Object.defineProperty(e, "__esModule", {
        value: !0
    });
});

});
parcelRegister("lXTbz", function(module, exports) {

$parcel$export(module.exports, "isDate", () => $ffd9ea5b580152f8$export$871608497c498473, (v) => $ffd9ea5b580152f8$export$871608497c498473 = v);
var $ffd9ea5b580152f8$export$871608497c498473;
"use strict";
$ffd9ea5b580152f8$export$871608497c498473 = $ffd9ea5b580152f8$var$isDate; /**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param value - The value to check
 *
 * @returns True if the given value is a date
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */ 
function $ffd9ea5b580152f8$var$isDate(value) {
    return value instanceof Date || typeof value === "object" && Object.prototype.toString.call(value) === "[object Date]";
}

});

parcelRegister("gwJip", function(module, exports) {

$parcel$export(module.exports, "isValid", () => $c082c553d4c367ee$export$1ea939691cdc45b8, (v) => $c082c553d4c367ee$export$1ea939691cdc45b8 = v);
var $c082c553d4c367ee$export$1ea939691cdc45b8;
"use strict";
$c082c553d4c367ee$export$1ea939691cdc45b8 = $c082c553d4c367ee$var$isValid;

var $lXTbz = parcelRequire("lXTbz");

var $26OhI = parcelRequire("26OhI");
/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate](https://date-fns.org/docs/toDate)
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is valid
 *
 * @example
 * // For the valid date:
 * const result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * const result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isValid(new Date(''))
 * //=> false
 */ function $c082c553d4c367ee$var$isValid(date) {
    if (!(0, $lXTbz.isDate)(date) && typeof date !== "number") return false;
    const _date = (0, $26OhI.toDate)(date);
    return !isNaN(Number(_date));
}

});
parcelRegister("26OhI", function(module, exports) {

$parcel$export(module.exports, "toDate", () => $189325ccd94be08c$export$e67a095c620b86fe, (v) => $189325ccd94be08c$export$e67a095c620b86fe = v);
var $189325ccd94be08c$export$e67a095c620b86fe;
"use strict";
$189325ccd94be08c$export$e67a095c620b86fe = $189325ccd94be08c$var$toDate;
/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param argument - The value to convert
 *
 * @returns The parsed date in the local time zone
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */ function $189325ccd94be08c$var$toDate(argument) {
    const argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || typeof argument === "object" && argStr === "[object Date]") // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new argument.constructor(+argument);
    else if (typeof argument === "number" || argStr === "[object Number]" || typeof argument === "string" || argStr === "[object String]") // TODO: Can we get rid of as?
    return new Date(argument);
    else // TODO: Can we get rid of as?
    return new Date(NaN);
}

});


parcelRegister("dmAUx", function(module, exports) {
"use strict";
module.exports.format = module.exports.formatDate = $9ba9f62958b08ac9$var$format;
Object.defineProperty(module.exports, "formatters", {
    enumerable: true,
    get: function() {
        return $6thOP.formatters;
    }
});
Object.defineProperty(module.exports, "longFormatters", {
    enumerable: true,
    get: function() {
        return $i59tm.longFormatters;
    }
});

var $5hxJz = parcelRequire("5hxJz");

var $2Hkrd = parcelRequire("2Hkrd");

var $6thOP = parcelRequire("6thOP");

var $i59tm = parcelRequire("i59tm");

var $eKdof = parcelRequire("eKdof");

var $gwJip = parcelRequire("gwJip");

var $26OhI = parcelRequire("26OhI");
// Rexports of internal for libraries to use.
// See: https://github.com/date-fns/date-fns/issues/3638#issuecomment-1877082874
// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const $9ba9f62958b08ac9$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
const $9ba9f62958b08ac9$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
const $9ba9f62958b08ac9$var$escapedStringRegExp = /^'([^]*?)'?$/;
const $9ba9f62958b08ac9$var$doubleQuoteRegExp = /''/g;
const $9ba9f62958b08ac9$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * The {@link format} function options.
 */ /**
 * @name format
 * @alias formatDate
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear](https://date-fns.org/docs/getISOWeekYear)
 *    and [getWeekYear](https://date-fns.org/docs/getWeekYear)).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param format - The string of tokens
 * @param options - An object with options
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 * @throws `options.locale` must contain `localize` property
 * @throws `options.locale` must contain `formatLong` property
 * @throws use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * const result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * const result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */ function $9ba9f62958b08ac9$var$format(date, formatStr, options) {
    const defaultOptions = (0, $2Hkrd.getDefaultOptions)();
    const locale = options?.locale ?? defaultOptions.locale ?? $5hxJz.defaultLocale;
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const originalDate = (0, $26OhI.toDate)(date);
    if (!(0, $gwJip.isValid)(originalDate)) throw new RangeError("Invalid time value");
    let parts = formatStr.match($9ba9f62958b08ac9$var$longFormattingTokensRegExp).map((substring)=>{
        const firstCharacter = substring[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
            const longFormatter = $i59tm.longFormatters[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($9ba9f62958b08ac9$var$formattingTokensRegExp).map((substring)=>{
        // Replace two single quote characters with one single quote character
        if (substring === "''") return {
            isToken: false,
            value: "'"
        };
        const firstCharacter = substring[0];
        if (firstCharacter === "'") return {
            isToken: false,
            value: $9ba9f62958b08ac9$var$cleanEscapedString(substring)
        };
        if ($6thOP.formatters[firstCharacter]) return {
            isToken: true,
            value: substring
        };
        if (firstCharacter.match($9ba9f62958b08ac9$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return {
            isToken: false,
            value: substring
        };
    });
    // invoke localize preprocessor (only for french locales at the moment)
    if (locale.localize.preprocessor) parts = locale.localize.preprocessor(originalDate, parts);
    const formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    return parts.map((part)=>{
        if (!part.isToken) return part.value;
        const token = part.value;
        if (!options?.useAdditionalWeekYearTokens && (0, $eKdof.isProtectedWeekYearToken)(token) || !options?.useAdditionalDayOfYearTokens && (0, $eKdof.isProtectedDayOfYearToken)(token)) (0, $eKdof.warnOrThrowProtectedError)(token, formatStr, String(date));
        const formatter = $6thOP.formatters[token[0]];
        return formatter(originalDate, token, locale.localize, formatterOptions);
    }).join("");
}
function $9ba9f62958b08ac9$var$cleanEscapedString(input) {
    const matched = input.match($9ba9f62958b08ac9$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($9ba9f62958b08ac9$var$doubleQuoteRegExp, "'");
}

});
parcelRegister("5hxJz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "defaultLocale", {
    enumerable: true,
    get: function() {
        return $7JvkD.enUS;
    }
});

var $7JvkD = parcelRequire("7JvkD");

});
parcelRegister("7JvkD", function(module, exports) {

$parcel$export(module.exports, "enUS", () => $5a150a3bcfb37384$export$137380d9ce54f7f, (v) => $5a150a3bcfb37384$export$137380d9ce54f7f = v);
var $5a150a3bcfb37384$export$137380d9ce54f7f;
"use strict";
$5a150a3bcfb37384$export$137380d9ce54f7f = void 0;

var $hddxq = parcelRequire("hddxq");

var $3DYbV = parcelRequire("3DYbV");

var $95gYI = parcelRequire("95gYI");

var $jVchr = parcelRequire("jVchr");

var $0CxMZ = parcelRequire("0CxMZ");
/**
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp](https://github.com/kossnocorp)
 * @author Lesha Koss [@leshakoss](https://github.com/leshakoss)
 */ const $5a150a3bcfb37384$var$enUS = $5a150a3bcfb37384$export$137380d9ce54f7f = {
    code: "en-US",
    formatDistance: $hddxq.formatDistance,
    formatLong: $3DYbV.formatLong,
    formatRelative: $95gYI.formatRelative,
    localize: $jVchr.localize,
    match: $0CxMZ.match,
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("hddxq", function(module, exports) {

$parcel$export(module.exports, "formatDistance", () => $c87e26f22dbceec5$export$2c14ff85d6318973, (v) => $c87e26f22dbceec5$export$2c14ff85d6318973 = v);
var $c87e26f22dbceec5$export$2c14ff85d6318973;
"use strict";
$c87e26f22dbceec5$export$2c14ff85d6318973 = void 0;
const $c87e26f22dbceec5$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
const $c87e26f22dbceec5$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $c87e26f22dbceec5$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};
$c87e26f22dbceec5$export$2c14ff85d6318973 = $c87e26f22dbceec5$var$formatDistance;

});

parcelRegister("3DYbV", function(module, exports) {

$parcel$export(module.exports, "formatLong", () => $2a73b4587096bd96$export$cbf60ecb96cbb82f, (v) => $2a73b4587096bd96$export$cbf60ecb96cbb82f = v);
var $2a73b4587096bd96$export$cbf60ecb96cbb82f;
"use strict";
$2a73b4587096bd96$export$cbf60ecb96cbb82f = void 0;

var $d1S8X = parcelRequire("d1S8X");
const $2a73b4587096bd96$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
const $2a73b4587096bd96$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $2a73b4587096bd96$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $2a73b4587096bd96$var$formatLong = $2a73b4587096bd96$export$cbf60ecb96cbb82f = {
    date: (0, $d1S8X.buildFormatLongFn)({
        formats: $2a73b4587096bd96$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $d1S8X.buildFormatLongFn)({
        formats: $2a73b4587096bd96$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $d1S8X.buildFormatLongFn)({
        formats: $2a73b4587096bd96$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});
parcelRegister("d1S8X", function(module, exports) {

$parcel$export(module.exports, "buildFormatLongFn", () => $97c55e21245bf6af$export$38e44e97ce4dbb7d, (v) => $97c55e21245bf6af$export$38e44e97ce4dbb7d = v);
var $97c55e21245bf6af$export$38e44e97ce4dbb7d;
"use strict";
$97c55e21245bf6af$export$38e44e97ce4dbb7d = $97c55e21245bf6af$var$buildFormatLongFn;
function $97c55e21245bf6af$var$buildFormatLongFn(args) {
    return (options = {})=>{
        // TODO: Remove String()
        const width = options.width ? String(options.width) : args.defaultWidth;
        const format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}

});


parcelRegister("95gYI", function(module, exports) {

$parcel$export(module.exports, "formatRelative", () => $69d1c03a8f0bcb15$export$8fbbfd65594f46a0, (v) => $69d1c03a8f0bcb15$export$8fbbfd65594f46a0 = v);
var $69d1c03a8f0bcb15$export$8fbbfd65594f46a0;
"use strict";
$69d1c03a8f0bcb15$export$8fbbfd65594f46a0 = void 0;
const $69d1c03a8f0bcb15$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
const $69d1c03a8f0bcb15$var$formatRelative = (token, _date, _baseDate, _options)=>$69d1c03a8f0bcb15$var$formatRelativeLocale[token];
$69d1c03a8f0bcb15$export$8fbbfd65594f46a0 = $69d1c03a8f0bcb15$var$formatRelative;

});

parcelRegister("jVchr", function(module, exports) {

$parcel$export(module.exports, "localize", () => $e80cddcf5ec54ef9$export$b3bd0bc58e36cd63, (v) => $e80cddcf5ec54ef9$export$b3bd0bc58e36cd63 = v);
var $e80cddcf5ec54ef9$export$b3bd0bc58e36cd63;
"use strict";
$e80cddcf5ec54ef9$export$b3bd0bc58e36cd63 = void 0;

var $cqSMX = parcelRequire("cqSMX");
const $e80cddcf5ec54ef9$var$eraValues = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
const $e80cddcf5ec54ef9$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const $e80cddcf5ec54ef9$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
const $e80cddcf5ec54ef9$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
const $e80cddcf5ec54ef9$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
const $e80cddcf5ec54ef9$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
const $e80cddcf5ec54ef9$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    const rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
    }
    return number + "th";
};
const $e80cddcf5ec54ef9$var$localize = $e80cddcf5ec54ef9$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $e80cddcf5ec54ef9$var$ordinalNumber,
    era: (0, $cqSMX.buildLocalizeFn)({
        values: $e80cddcf5ec54ef9$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $cqSMX.buildLocalizeFn)({
        values: $e80cddcf5ec54ef9$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $cqSMX.buildLocalizeFn)({
        values: $e80cddcf5ec54ef9$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $cqSMX.buildLocalizeFn)({
        values: $e80cddcf5ec54ef9$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $cqSMX.buildLocalizeFn)({
        values: $e80cddcf5ec54ef9$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $e80cddcf5ec54ef9$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});
parcelRegister("cqSMX", function(module, exports) {

$parcel$export(module.exports, "buildLocalizeFn", () => $90d2699d90bb2336$export$63596d6ee8878b25, (v) => $90d2699d90bb2336$export$63596d6ee8878b25 = v);
var $90d2699d90bb2336$export$63596d6ee8878b25;
"use strict";
$90d2699d90bb2336$export$63596d6ee8878b25 = $90d2699d90bb2336$var$buildLocalizeFn; /* eslint-disable no-unused-vars */ 
/**
 * The localize function argument callback which allows to convert raw value to
 * the actual type.
 *
 * @param value - The value to convert
 *
 * @returns The converted value
 */ /**
 * The map of localized values for each width.
 */ /**
 * The index type of the locale unit value. It types conversion of units of
 * values that don't start at 0 (i.e. quarters).
 */ /**
 * Converts the unit value to the tuple of values.
 */ /**
 * The tuple of localized era values. The first element represents BC,
 * the second element represents AD.
 */ /**
 * The tuple of localized quarter values. The first element represents Q1.
 */ /**
 * The tuple of localized day values. The first element represents Sunday.
 */ /**
 * The tuple of localized month values. The first element represents January.
 */ function $90d2699d90bb2336$var$buildLocalizeFn(args) {
    return (value, options)=>{
        const context = options?.context ? String(options.context) : "standalone";
        let valuesArray;
        if (context === "formatting" && args.formattingValues) {
            const defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            const width = options?.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            const defaultWidth = args.defaultWidth;
            const width = options?.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[width] || args.values[defaultWidth];
        }
        const index = args.argumentCallback ? args.argumentCallback(value) : value;
        // @ts-expect-error - For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}

});


parcelRegister("0CxMZ", function(module, exports) {

$parcel$export(module.exports, "match", () => $001de63c280f5a47$export$4659b591c19bdf3d, (v) => $001de63c280f5a47$export$4659b591c19bdf3d = v);
var $001de63c280f5a47$export$4659b591c19bdf3d;
"use strict";
$001de63c280f5a47$export$4659b591c19bdf3d = void 0;

var $3G8uD = parcelRequire("3G8uD");

var $khfIO = parcelRequire("khfIO");
const $001de63c280f5a47$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
const $001de63c280f5a47$var$parseOrdinalNumberPattern = /\d+/i;
const $001de63c280f5a47$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
const $001de63c280f5a47$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
const $001de63c280f5a47$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
const $001de63c280f5a47$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $001de63c280f5a47$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
const $001de63c280f5a47$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $001de63c280f5a47$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
const $001de63c280f5a47$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
const $001de63c280f5a47$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
const $001de63c280f5a47$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
const $001de63c280f5a47$var$match = $001de63c280f5a47$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $khfIO.buildMatchPatternFn)({
        matchPattern: $001de63c280f5a47$var$matchOrdinalNumberPattern,
        parsePattern: $001de63c280f5a47$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $3G8uD.buildMatchFn)({
        matchPatterns: $001de63c280f5a47$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $001de63c280f5a47$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $3G8uD.buildMatchFn)({
        matchPatterns: $001de63c280f5a47$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $001de63c280f5a47$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $3G8uD.buildMatchFn)({
        matchPatterns: $001de63c280f5a47$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $001de63c280f5a47$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $3G8uD.buildMatchFn)({
        matchPatterns: $001de63c280f5a47$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $001de63c280f5a47$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $3G8uD.buildMatchFn)({
        matchPatterns: $001de63c280f5a47$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $001de63c280f5a47$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});
parcelRegister("3G8uD", function(module, exports) {

$parcel$export(module.exports, "buildMatchFn", () => $2adbe1e330f72e54$export$1430a0f35710914d, (v) => $2adbe1e330f72e54$export$1430a0f35710914d = v);
var $2adbe1e330f72e54$export$1430a0f35710914d;
"use strict";
$2adbe1e330f72e54$export$1430a0f35710914d = $2adbe1e330f72e54$var$buildMatchFn;
function $2adbe1e330f72e54$var$buildMatchFn(args) {
    return (string, options = {})=>{
        const width = options.width;
        const matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        const matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        const key = Array.isArray(parsePatterns) ? $2adbe1e330f72e54$var$findIndex(parsePatterns, (pattern)=>pattern.test(matchedString)) : $2adbe1e330f72e54$var$findKey(parsePatterns, (pattern)=>pattern.test(matchedString));
        let value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $2adbe1e330f72e54$var$findKey(object, predicate) {
    for(const key in object){
        if (Object.prototype.hasOwnProperty.call(object, key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $2adbe1e330f72e54$var$findIndex(array, predicate) {
    for(let key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}

});

parcelRegister("khfIO", function(module, exports) {

$parcel$export(module.exports, "buildMatchPatternFn", () => $ec319733e12d7439$export$fdaf2fd6d7edde95, (v) => $ec319733e12d7439$export$fdaf2fd6d7edde95 = v);
var $ec319733e12d7439$export$fdaf2fd6d7edde95;
"use strict";
$ec319733e12d7439$export$fdaf2fd6d7edde95 = $ec319733e12d7439$var$buildMatchPatternFn;
function $ec319733e12d7439$var$buildMatchPatternFn(args) {
    return (string, options = {})=>{
        const matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        let value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}

});




parcelRegister("2Hkrd", function(module, exports) {

$parcel$export(module.exports, "getDefaultOptions", () => $1f6f737b74a6aaae$export$430a3269e24b912e, (v) => $1f6f737b74a6aaae$export$430a3269e24b912e = v);
$parcel$export(module.exports, "setDefaultOptions", () => $1f6f737b74a6aaae$export$95365be1b0704abc, (v) => $1f6f737b74a6aaae$export$95365be1b0704abc = v);
var $1f6f737b74a6aaae$export$430a3269e24b912e;
var $1f6f737b74a6aaae$export$95365be1b0704abc;
"use strict";
$1f6f737b74a6aaae$export$430a3269e24b912e = $1f6f737b74a6aaae$var$getDefaultOptions;
$1f6f737b74a6aaae$export$95365be1b0704abc = $1f6f737b74a6aaae$var$setDefaultOptions;
let $1f6f737b74a6aaae$var$defaultOptions = {};
function $1f6f737b74a6aaae$var$getDefaultOptions() {
    return $1f6f737b74a6aaae$var$defaultOptions;
}
function $1f6f737b74a6aaae$var$setDefaultOptions(newOptions) {
    $1f6f737b74a6aaae$var$defaultOptions = newOptions;
}

});

parcelRegister("6thOP", function(module, exports) {

$parcel$export(module.exports, "formatters", () => $4b6345f265fce384$export$fe98a034cfb96d55, (v) => $4b6345f265fce384$export$fe98a034cfb96d55 = v);
var $4b6345f265fce384$export$fe98a034cfb96d55;
"use strict";
$4b6345f265fce384$export$fe98a034cfb96d55 = void 0;

var $gnX0t = parcelRequire("gnX0t");

var $730vp = parcelRequire("730vp");

var $lepTe = parcelRequire("lepTe");

var $g2WV7 = parcelRequire("g2WV7");

var $51wqx = parcelRequire("51wqx");

var $cPWeo = parcelRequire("cPWeo");

var $lhoHr = parcelRequire("lhoHr");
const $4b6345f265fce384$var$dayPeriodEnum = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ const $4b6345f265fce384$var$formatters = $4b6345f265fce384$export$fe98a034cfb96d55 = {
    // Era
    G: function(date, token, localize) {
        const era = date.getFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return localize.era(era, {
                    width: "abbreviated"
                });
            // A, B
            case "GGGGG":
                return localize.era(era, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return localize.era(era, {
                    width: "wide"
                });
        }
    },
    // Year
    y: function(date, token, localize) {
        // Ordinal number
        if (token === "yo") {
            const signedYear = date.getFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            const year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: "year"
            });
        }
        return $lhoHr.lightFormatters.y(date, token);
    },
    // Local week-numbering year
    Y: function(date, token, localize, options) {
        const signedWeekYear = (0, $51wqx.getWeekYear)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        const weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === "YY") {
            const twoDigitYear = weekYear % 100;
            return (0, $cPWeo.addLeadingZeros)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === "Yo") return localize.ordinalNumber(weekYear, {
            unit: "year"
        });
        // Padding
        return (0, $cPWeo.addLeadingZeros)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function(date, token) {
        const isoWeekYear = (0, $lepTe.getISOWeekYear)(date);
        // Padding
        return (0, $cPWeo.addLeadingZeros)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function(date, token) {
        const year = date.getFullYear();
        return (0, $cPWeo.addLeadingZeros)(year, token.length);
    },
    // Quarter
    Q: function(date, token, localize) {
        const quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "Q":
                return String(quarter);
            // 01, 02, 03, 04
            case "QQ":
                return (0, $cPWeo.addLeadingZeros)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone quarter
    q: function(date, token, localize) {
        const quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "q":
                return String(quarter);
            // 01, 02, 03, 04
            case "qq":
                return (0, $cPWeo.addLeadingZeros)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Month
    M: function(date, token, localize) {
        const month = date.getMonth();
        switch(token){
            case "M":
            case "MM":
                return $lhoHr.lightFormatters.M(date, token);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "MMM":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return localize.month(month, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone month
    L: function(date, token, localize) {
        const month = date.getMonth();
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return String(month + 1);
            // 01, 02, ..., 12
            case "LL":
                return (0, $cPWeo.addLeadingZeros)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "LLL":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return localize.month(month, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Local week of year
    w: function(date, token, localize, options) {
        const week = (0, $g2WV7.getWeek)(date, options);
        if (token === "wo") return localize.ordinalNumber(week, {
            unit: "week"
        });
        return (0, $cPWeo.addLeadingZeros)(week, token.length);
    },
    // ISO week of year
    I: function(date, token, localize) {
        const isoWeek = (0, $730vp.getISOWeek)(date);
        if (token === "Io") return localize.ordinalNumber(isoWeek, {
            unit: "week"
        });
        return (0, $cPWeo.addLeadingZeros)(isoWeek, token.length);
    },
    // Day of the month
    d: function(date, token, localize) {
        if (token === "do") return localize.ordinalNumber(date.getDate(), {
            unit: "date"
        });
        return $lhoHr.lightFormatters.d(date, token);
    },
    // Day of year
    D: function(date, token, localize) {
        const dayOfYear = (0, $gnX0t.getDayOfYear)(date);
        if (token === "Do") return localize.ordinalNumber(dayOfYear, {
            unit: "dayOfYear"
        });
        return (0, $cPWeo.addLeadingZeros)(dayOfYear, token.length);
    },
    // Day of week
    E: function(date, token, localize) {
        const dayOfWeek = date.getDay();
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Local day of week
    e: function(date, token, localize, options) {
        const dayOfWeek = date.getDay();
        const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case "e":
                return String(localDayOfWeek);
            // Padded numerical value
            case "ee":
                return (0, $cPWeo.addLeadingZeros)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case "eo":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "eee":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone local day of week
    c: function(date, token, localize, options) {
        const dayOfWeek = date.getDay();
        const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case "c":
                return String(localDayOfWeek);
            // Padded numerical value
            case "cc":
                return (0, $cPWeo.addLeadingZeros)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case "co":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "ccc":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // ISO day of week
    i: function(date, token, localize) {
        const dayOfWeek = date.getDay();
        const isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case "i":
                return String(isoDayOfWeek);
            // 02
            case "ii":
                return (0, $cPWeo.addLeadingZeros)(isoDayOfWeek, token.length);
            // 2nd
            case "io":
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "iiiii":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "iiiiii":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "iiii":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM or PM
    a: function(date, token, localize) {
        const hours = date.getHours();
        const dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "aaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "aaaaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM, PM, midnight, noon
    b: function(date, token, localize) {
        const hours = date.getHours();
        let dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $4b6345f265fce384$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $4b6345f265fce384$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "b":
            case "bb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "bbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "bbbbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function(date, token, localize) {
        const hours = date.getHours();
        let dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $4b6345f265fce384$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $4b6345f265fce384$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $4b6345f265fce384$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $4b6345f265fce384$var$dayPeriodEnum.night;
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "BBBBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Hour [1-12]
    h: function(date, token, localize) {
        if (token === "ho") {
            let hours = date.getHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: "hour"
            });
        }
        return $lhoHr.lightFormatters.h(date, token);
    },
    // Hour [0-23]
    H: function(date, token, localize) {
        if (token === "Ho") return localize.ordinalNumber(date.getHours(), {
            unit: "hour"
        });
        return $lhoHr.lightFormatters.H(date, token);
    },
    // Hour [0-11]
    K: function(date, token, localize) {
        const hours = date.getHours() % 12;
        if (token === "Ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $cPWeo.addLeadingZeros)(hours, token.length);
    },
    // Hour [1-24]
    k: function(date, token, localize) {
        let hours = date.getHours();
        if (hours === 0) hours = 24;
        if (token === "ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $cPWeo.addLeadingZeros)(hours, token.length);
    },
    // Minute
    m: function(date, token, localize) {
        if (token === "mo") return localize.ordinalNumber(date.getMinutes(), {
            unit: "minute"
        });
        return $lhoHr.lightFormatters.m(date, token);
    },
    // Second
    s: function(date, token, localize) {
        if (token === "so") return localize.ordinalNumber(date.getSeconds(), {
            unit: "second"
        });
        return $lhoHr.lightFormatters.s(date, token);
    },
    // Fraction of second
    S: function(date, token) {
        return $lhoHr.lightFormatters.S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        if (timezoneOffset === 0) return "Z";
        switch(token){
            // Hours and optional minutes
            case "X":
                return $4b6345f265fce384$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case "XXXX":
            case "XX":
                return $4b6345f265fce384$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case "XXXXX":
            case "XXX":
            default:
                return $4b6345f265fce384$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case "x":
                return $4b6345f265fce384$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case "xxxx":
            case "xx":
                return $4b6345f265fce384$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case "xxxxx":
            case "xxx":
            default:
                return $4b6345f265fce384$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (GMT)
    O: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + $4b6345f265fce384$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "OOOO":
            default:
                return "GMT" + $4b6345f265fce384$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "z":
            case "zz":
            case "zzz":
                return "GMT" + $4b6345f265fce384$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "zzzz":
            default:
                return "GMT" + $4b6345f265fce384$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Seconds timestamp
    t: function(date, token, _localize) {
        const timestamp = Math.trunc(date.getTime() / 1000);
        return (0, $cPWeo.addLeadingZeros)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function(date, token, _localize) {
        const timestamp = date.getTime();
        return (0, $cPWeo.addLeadingZeros)(timestamp, token.length);
    }
};
function $4b6345f265fce384$var$formatTimezoneShort(offset, delimiter = "") {
    const sign = offset > 0 ? "-" : "+";
    const absOffset = Math.abs(offset);
    const hours = Math.trunc(absOffset / 60);
    const minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    return sign + String(hours) + delimiter + (0, $cPWeo.addLeadingZeros)(minutes, 2);
}
function $4b6345f265fce384$var$formatTimezoneWithOptionalMinutes(offset, delimiter) {
    if (offset % 60 === 0) {
        const sign = offset > 0 ? "-" : "+";
        return sign + (0, $cPWeo.addLeadingZeros)(Math.abs(offset) / 60, 2);
    }
    return $4b6345f265fce384$var$formatTimezone(offset, delimiter);
}
function $4b6345f265fce384$var$formatTimezone(offset, delimiter = "") {
    const sign = offset > 0 ? "-" : "+";
    const absOffset = Math.abs(offset);
    const hours = (0, $cPWeo.addLeadingZeros)(Math.trunc(absOffset / 60), 2);
    const minutes = (0, $cPWeo.addLeadingZeros)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}

});
parcelRegister("gnX0t", function(module, exports) {

$parcel$export(module.exports, "getDayOfYear", () => $bedc90cefbca22ba$export$d3b42cd8452deec, (v) => $bedc90cefbca22ba$export$d3b42cd8452deec = v);
var $bedc90cefbca22ba$export$d3b42cd8452deec;
"use strict";
$bedc90cefbca22ba$export$d3b42cd8452deec = $bedc90cefbca22ba$var$getDayOfYear;

var $hzJYa = parcelRequire("hzJYa");

var $icgCh = parcelRequire("icgCh");

var $26OhI = parcelRequire("26OhI");
/**
 * @name getDayOfYear
 * @category Day Helpers
 * @summary Get the day of the year of the given date.
 *
 * @description
 * Get the day of the year of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The day of year
 *
 * @example
 * // Which day of the year is 2 July 2014?
 * const result = getDayOfYear(new Date(2014, 6, 2))
 * //=> 183
 */ function $bedc90cefbca22ba$var$getDayOfYear(date) {
    const _date = (0, $26OhI.toDate)(date);
    const diff = (0, $hzJYa.differenceInCalendarDays)(_date, (0, $icgCh.startOfYear)(_date));
    const dayOfYear = diff + 1;
    return dayOfYear;
}

});
parcelRegister("hzJYa", function(module, exports) {

$parcel$export(module.exports, "differenceInCalendarDays", () => $ccb95d21e55ad71e$export$4a02e9c37dab4871, (v) => $ccb95d21e55ad71e$export$4a02e9c37dab4871 = v);
var $ccb95d21e55ad71e$export$4a02e9c37dab4871;
"use strict";
$ccb95d21e55ad71e$export$4a02e9c37dab4871 = $ccb95d21e55ad71e$var$differenceInCalendarDays;

var $4IrbU = parcelRequire("4IrbU");

var $lPouQ = parcelRequire("lPouQ");

var $6f1d3 = parcelRequire("6f1d3");
/**
 * @name differenceInCalendarDays
 * @category Day Helpers
 * @summary Get the number of calendar days between the given dates.
 *
 * @description
 * Get the number of calendar days between the given dates. This means that the times are removed
 * from the dates and then the difference in days is calculated.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of calendar days
 *
 * @example
 * // How many calendar days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * const result = differenceInCalendarDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 366
 * // How many calendar days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * const result = differenceInCalendarDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 1
 */ function $ccb95d21e55ad71e$var$differenceInCalendarDays(dateLeft, dateRight) {
    const startOfDayLeft = (0, $lPouQ.startOfDay)(dateLeft);
    const startOfDayRight = (0, $lPouQ.startOfDay)(dateRight);
    const timestampLeft = +startOfDayLeft - (0, $6f1d3.getTimezoneOffsetInMilliseconds)(startOfDayLeft);
    const timestampRight = +startOfDayRight - (0, $6f1d3.getTimezoneOffsetInMilliseconds)(startOfDayRight);
    // Round the number of days to the nearest integer because the number of
    // milliseconds in a day is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round((timestampLeft - timestampRight) / $4IrbU.millisecondsInDay);
}

});
parcelRegister("4IrbU", function(module, exports) {

$parcel$export(module.exports, "secondsInYear", () => $36f05d0f10127335$export$7271e9e3478110d1, (v) => $36f05d0f10127335$export$7271e9e3478110d1 = v);
$parcel$export(module.exports, "secondsInWeek", () => $36f05d0f10127335$export$34804a017b31e2fe, (v) => $36f05d0f10127335$export$34804a017b31e2fe = v);
$parcel$export(module.exports, "secondsInQuarter", () => $36f05d0f10127335$export$be1dccf2de902d31, (v) => $36f05d0f10127335$export$be1dccf2de902d31 = v);
$parcel$export(module.exports, "secondsInMonth", () => $36f05d0f10127335$export$8e6600bbdee7dabb, (v) => $36f05d0f10127335$export$8e6600bbdee7dabb = v);
$parcel$export(module.exports, "secondsInMinute", () => $36f05d0f10127335$export$a77c1a7ebebe2a5a, (v) => $36f05d0f10127335$export$a77c1a7ebebe2a5a = v);
$parcel$export(module.exports, "secondsInHour", () => $36f05d0f10127335$export$698aec755e92c695, (v) => $36f05d0f10127335$export$698aec755e92c695 = v);
$parcel$export(module.exports, "secondsInDay", () => $36f05d0f10127335$export$815a9362476d2fe3, (v) => $36f05d0f10127335$export$815a9362476d2fe3 = v);
$parcel$export(module.exports, "quartersInYear", () => $36f05d0f10127335$export$4db7641526e3241f, (v) => $36f05d0f10127335$export$4db7641526e3241f = v);
$parcel$export(module.exports, "monthsInYear", () => $36f05d0f10127335$export$80d7e435f744f319, (v) => $36f05d0f10127335$export$80d7e435f744f319 = v);
$parcel$export(module.exports, "monthsInQuarter", () => $36f05d0f10127335$export$3c58128db900d44e, (v) => $36f05d0f10127335$export$3c58128db900d44e = v);
$parcel$export(module.exports, "minutesInYear", () => $36f05d0f10127335$export$3633035e63cee86a, (v) => $36f05d0f10127335$export$3633035e63cee86a = v);
$parcel$export(module.exports, "minutesInMonth", () => $36f05d0f10127335$export$ab7da2ccd1075c38, (v) => $36f05d0f10127335$export$ab7da2ccd1075c38 = v);
$parcel$export(module.exports, "minutesInHour", () => $36f05d0f10127335$export$f2f5ae5a8e2d8f9f, (v) => $36f05d0f10127335$export$f2f5ae5a8e2d8f9f = v);
$parcel$export(module.exports, "minutesInDay", () => $36f05d0f10127335$export$2423174df8cd3cd2, (v) => $36f05d0f10127335$export$2423174df8cd3cd2 = v);
$parcel$export(module.exports, "millisecondsInWeek", () => $36f05d0f10127335$export$4fad13613e88edc8, (v) => $36f05d0f10127335$export$4fad13613e88edc8 = v);
$parcel$export(module.exports, "millisecondsInSecond", () => $36f05d0f10127335$export$397c2d5776aa9055, (v) => $36f05d0f10127335$export$397c2d5776aa9055 = v);
$parcel$export(module.exports, "millisecondsInMinute", () => $36f05d0f10127335$export$91246f0b9bd9beff, (v) => $36f05d0f10127335$export$91246f0b9bd9beff = v);
$parcel$export(module.exports, "millisecondsInHour", () => $36f05d0f10127335$export$7f72910d6dfd237a, (v) => $36f05d0f10127335$export$7f72910d6dfd237a = v);
$parcel$export(module.exports, "millisecondsInDay", () => $36f05d0f10127335$export$b76b1809a2898f9a, (v) => $36f05d0f10127335$export$b76b1809a2898f9a = v);
$parcel$export(module.exports, "daysInYear", () => $36f05d0f10127335$export$3913210603d8e9ae, (v) => $36f05d0f10127335$export$3913210603d8e9ae = v);
$parcel$export(module.exports, "daysInWeek", () => $36f05d0f10127335$export$dfd9b671c89acc8e, (v) => $36f05d0f10127335$export$dfd9b671c89acc8e = v);
var $36f05d0f10127335$export$7271e9e3478110d1;
var $36f05d0f10127335$export$34804a017b31e2fe;
var $36f05d0f10127335$export$be1dccf2de902d31;
var $36f05d0f10127335$export$8e6600bbdee7dabb;
var $36f05d0f10127335$export$a77c1a7ebebe2a5a;
var $36f05d0f10127335$export$698aec755e92c695;
var $36f05d0f10127335$export$815a9362476d2fe3;
var $36f05d0f10127335$export$4db7641526e3241f;
var $36f05d0f10127335$export$80d7e435f744f319;
var $36f05d0f10127335$export$3c58128db900d44e;
var $36f05d0f10127335$export$3633035e63cee86a;
var $36f05d0f10127335$export$ab7da2ccd1075c38;
var $36f05d0f10127335$export$f2f5ae5a8e2d8f9f;
var $36f05d0f10127335$export$2423174df8cd3cd2;
var $36f05d0f10127335$export$4dec998e48f9c246;
var $36f05d0f10127335$export$4fad13613e88edc8;
var $36f05d0f10127335$export$397c2d5776aa9055;
var $36f05d0f10127335$export$91246f0b9bd9beff;
var $36f05d0f10127335$export$7f72910d6dfd237a;
var $36f05d0f10127335$export$b76b1809a2898f9a;
var $36f05d0f10127335$export$81caae6e1cc7a622;
var $36f05d0f10127335$export$3913210603d8e9ae;
var $36f05d0f10127335$export$dfd9b671c89acc8e;
"use strict";
$36f05d0f10127335$export$7271e9e3478110d1 = $36f05d0f10127335$export$34804a017b31e2fe = $36f05d0f10127335$export$be1dccf2de902d31 = $36f05d0f10127335$export$8e6600bbdee7dabb = $36f05d0f10127335$export$a77c1a7ebebe2a5a = $36f05d0f10127335$export$698aec755e92c695 = $36f05d0f10127335$export$815a9362476d2fe3 = $36f05d0f10127335$export$4db7641526e3241f = $36f05d0f10127335$export$80d7e435f744f319 = $36f05d0f10127335$export$3c58128db900d44e = $36f05d0f10127335$export$3633035e63cee86a = $36f05d0f10127335$export$ab7da2ccd1075c38 = $36f05d0f10127335$export$f2f5ae5a8e2d8f9f = $36f05d0f10127335$export$2423174df8cd3cd2 = $36f05d0f10127335$export$4dec998e48f9c246 = $36f05d0f10127335$export$4fad13613e88edc8 = $36f05d0f10127335$export$397c2d5776aa9055 = $36f05d0f10127335$export$91246f0b9bd9beff = $36f05d0f10127335$export$7f72910d6dfd237a = $36f05d0f10127335$export$b76b1809a2898f9a = $36f05d0f10127335$export$81caae6e1cc7a622 = $36f05d0f10127335$export$3913210603d8e9ae = $36f05d0f10127335$export$dfd9b671c89acc8e = void 0; /**
 * @module constants
 * @summary Useful constants
 * @description
 * Collection of useful date constants.
 *
 * The constants could be imported from `date-fns/constants`:
 *
 * ```ts
 * import { maxTime, minTime } from "date-fns/constants";
 *
 * function isAllowedTime(time) {
 *   return time <= maxTime && time >= minTime;
 * }
 * ```
 */ 
/**
 * @constant
 * @name daysInWeek
 * @summary Days in 1 week.
 */ const $36f05d0f10127335$var$daysInWeek = $36f05d0f10127335$export$dfd9b671c89acc8e = 7;
/**
 * @constant
 * @name daysInYear
 * @summary Days in 1 year.
 *
 * @description
 * How many days in a year.
 *
 * One years equals 365.2425 days according to the formula:
 *
 * > Leap year occures every 4 years, except for years that are divisable by 100 and not divisable by 400.
 * > 1 mean year = (365+1/4-1/100+1/400) days = 365.2425 days
 */ const $36f05d0f10127335$var$daysInYear = $36f05d0f10127335$export$3913210603d8e9ae = 365.2425;
/**
 * @constant
 * @name maxTime
 * @summary Maximum allowed time.
 *
 * @example
 * import { maxTime } from "date-fns/constants";
 *
 * const isValid = 8640000000000001 <= maxTime;
 * //=> false
 *
 * new Date(8640000000000001);
 * //=> Invalid Date
 */ const $36f05d0f10127335$var$maxTime = $36f05d0f10127335$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
/**
 * @constant
 * @name minTime
 * @summary Minimum allowed time.
 *
 * @example
 * import { minTime } from "date-fns/constants";
 *
 * const isValid = -8640000000000001 >= minTime;
 * //=> false
 *
 * new Date(-8640000000000001)
 * //=> Invalid Date
 */ const $36f05d0f10127335$var$minTime = $36f05d0f10127335$export$4dec998e48f9c246 = -$36f05d0f10127335$var$maxTime;
/**
 * @constant
 * @name millisecondsInWeek
 * @summary Milliseconds in 1 week.
 */ const $36f05d0f10127335$var$millisecondsInWeek = $36f05d0f10127335$export$4fad13613e88edc8 = 604800000;
/**
 * @constant
 * @name millisecondsInDay
 * @summary Milliseconds in 1 day.
 */ const $36f05d0f10127335$var$millisecondsInDay = $36f05d0f10127335$export$b76b1809a2898f9a = 86400000;
/**
 * @constant
 * @name millisecondsInMinute
 * @summary Milliseconds in 1 minute
 */ const $36f05d0f10127335$var$millisecondsInMinute = $36f05d0f10127335$export$91246f0b9bd9beff = 60000;
/**
 * @constant
 * @name millisecondsInHour
 * @summary Milliseconds in 1 hour
 */ const $36f05d0f10127335$var$millisecondsInHour = $36f05d0f10127335$export$7f72910d6dfd237a = 3600000;
/**
 * @constant
 * @name millisecondsInSecond
 * @summary Milliseconds in 1 second
 */ const $36f05d0f10127335$var$millisecondsInSecond = $36f05d0f10127335$export$397c2d5776aa9055 = 1000;
/**
 * @constant
 * @name minutesInYear
 * @summary Minutes in 1 year.
 */ const $36f05d0f10127335$var$minutesInYear = $36f05d0f10127335$export$3633035e63cee86a = 525600;
/**
 * @constant
 * @name minutesInMonth
 * @summary Minutes in 1 month.
 */ const $36f05d0f10127335$var$minutesInMonth = $36f05d0f10127335$export$ab7da2ccd1075c38 = 43200;
/**
 * @constant
 * @name minutesInDay
 * @summary Minutes in 1 day.
 */ const $36f05d0f10127335$var$minutesInDay = $36f05d0f10127335$export$2423174df8cd3cd2 = 1440;
/**
 * @constant
 * @name minutesInHour
 * @summary Minutes in 1 hour.
 */ const $36f05d0f10127335$var$minutesInHour = $36f05d0f10127335$export$f2f5ae5a8e2d8f9f = 60;
/**
 * @constant
 * @name monthsInQuarter
 * @summary Months in 1 quarter.
 */ const $36f05d0f10127335$var$monthsInQuarter = $36f05d0f10127335$export$3c58128db900d44e = 3;
/**
 * @constant
 * @name monthsInYear
 * @summary Months in 1 year.
 */ const $36f05d0f10127335$var$monthsInYear = $36f05d0f10127335$export$80d7e435f744f319 = 12;
/**
 * @constant
 * @name quartersInYear
 * @summary Quarters in 1 year
 */ const $36f05d0f10127335$var$quartersInYear = $36f05d0f10127335$export$4db7641526e3241f = 4;
/**
 * @constant
 * @name secondsInHour
 * @summary Seconds in 1 hour.
 */ const $36f05d0f10127335$var$secondsInHour = $36f05d0f10127335$export$698aec755e92c695 = 3600;
/**
 * @constant
 * @name secondsInMinute
 * @summary Seconds in 1 minute.
 */ const $36f05d0f10127335$var$secondsInMinute = $36f05d0f10127335$export$a77c1a7ebebe2a5a = 60;
/**
 * @constant
 * @name secondsInDay
 * @summary Seconds in 1 day.
 */ const $36f05d0f10127335$var$secondsInDay = $36f05d0f10127335$export$815a9362476d2fe3 = $36f05d0f10127335$var$secondsInHour * 24;
/**
 * @constant
 * @name secondsInWeek
 * @summary Seconds in 1 week.
 */ const $36f05d0f10127335$var$secondsInWeek = $36f05d0f10127335$export$34804a017b31e2fe = $36f05d0f10127335$var$secondsInDay * 7;
/**
 * @constant
 * @name secondsInYear
 * @summary Seconds in 1 year.
 */ const $36f05d0f10127335$var$secondsInYear = $36f05d0f10127335$export$7271e9e3478110d1 = $36f05d0f10127335$var$secondsInDay * $36f05d0f10127335$var$daysInYear;
/**
 * @constant
 * @name secondsInMonth
 * @summary Seconds in 1 month
 */ const $36f05d0f10127335$var$secondsInMonth = $36f05d0f10127335$export$8e6600bbdee7dabb = $36f05d0f10127335$var$secondsInYear / 12;
/**
 * @constant
 * @name secondsInQuarter
 * @summary Seconds in 1 quarter.
 */ const $36f05d0f10127335$var$secondsInQuarter = $36f05d0f10127335$export$be1dccf2de902d31 = $36f05d0f10127335$var$secondsInMonth * 3;

});

parcelRegister("lPouQ", function(module, exports) {

$parcel$export(module.exports, "startOfDay", () => $fe415ce3b30833bb$export$63fa379ae8a9ba2, (v) => $fe415ce3b30833bb$export$63fa379ae8a9ba2 = v);
var $fe415ce3b30833bb$export$63fa379ae8a9ba2;
"use strict";
$fe415ce3b30833bb$export$63fa379ae8a9ba2 = $fe415ce3b30833bb$var$startOfDay;

var $26OhI = parcelRequire("26OhI");
/**
 * @name startOfDay
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a day
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * const result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */ function $fe415ce3b30833bb$var$startOfDay(date) {
    const _date = (0, $26OhI.toDate)(date);
    _date.setHours(0, 0, 0, 0);
    return _date;
}

});

parcelRegister("6f1d3", function(module, exports) {

$parcel$export(module.exports, "getTimezoneOffsetInMilliseconds", () => $48b514f78dfee153$export$113002b5eff6e430, (v) => $48b514f78dfee153$export$113002b5eff6e430 = v);
var $48b514f78dfee153$export$113002b5eff6e430;
"use strict";
$48b514f78dfee153$export$113002b5eff6e430 = $48b514f78dfee153$var$getTimezoneOffsetInMilliseconds;

var $26OhI = parcelRequire("26OhI");
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $48b514f78dfee153$var$getTimezoneOffsetInMilliseconds(date) {
    const _date = (0, $26OhI.toDate)(date);
    const utcDate = new Date(Date.UTC(_date.getFullYear(), _date.getMonth(), _date.getDate(), _date.getHours(), _date.getMinutes(), _date.getSeconds(), _date.getMilliseconds()));
    utcDate.setUTCFullYear(_date.getFullYear());
    return +date - +utcDate;
}

});


parcelRegister("icgCh", function(module, exports) {

$parcel$export(module.exports, "startOfYear", () => $d3f63cae10dd2b8a$export$f91e89d3d0406102, (v) => $d3f63cae10dd2b8a$export$f91e89d3d0406102 = v);
var $d3f63cae10dd2b8a$export$f91e89d3d0406102;
"use strict";
$d3f63cae10dd2b8a$export$f91e89d3d0406102 = $d3f63cae10dd2b8a$var$startOfYear;

var $26OhI = parcelRequire("26OhI");

var $CS8DB = parcelRequire("CS8DB");
/**
 * @name startOfYear
 * @category Year Helpers
 * @summary Return the start of a year for the given date.
 *
 * @description
 * Return the start of a year for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a year
 *
 * @example
 * // The start of a year for 2 September 2014 11:55:00:
 * const result = startOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Jan 01 2014 00:00:00
 */ function $d3f63cae10dd2b8a$var$startOfYear(date) {
    const cleanDate = (0, $26OhI.toDate)(date);
    const _date = (0, $CS8DB.constructFrom)(date, 0);
    _date.setFullYear(cleanDate.getFullYear(), 0, 1);
    _date.setHours(0, 0, 0, 0);
    return _date;
}

});
parcelRegister("CS8DB", function(module, exports) {

$parcel$export(module.exports, "constructFrom", () => $074d8b7777dc6b36$export$ead8a1812b171991, (v) => $074d8b7777dc6b36$export$ead8a1812b171991 = v);
var $074d8b7777dc6b36$export$ead8a1812b171991;
"use strict";
$074d8b7777dc6b36$export$ead8a1812b171991 = $074d8b7777dc6b36$var$constructFrom;
/**
 * @name constructFrom
 * @category Generic Helpers
 * @summary Constructs a date using the reference date and the value
 *
 * @description
 * The function constructs a new date using the constructor from the reference
 * date and the given value. It helps to build generic functions that accept
 * date extensions.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The reference date to take constructor from
 * @param value - The value to create the date
 *
 * @returns Date initialized using the given date and value
 *
 * @example
 * import { constructFrom } from 'date-fns'
 *
 * // A function that clones a date preserving the original type
 * function cloneDate<DateType extends Date(date: DateType): DateType {
 *   return constructFrom(
 *     date, // Use contrustor from the given date
 *     date.getTime() // Use the date value to create a new date
 *   )
 * }
 */ function $074d8b7777dc6b36$var$constructFrom(date, value) {
    if (date instanceof Date) return new date.constructor(value);
    else return new Date(value);
}

});



parcelRegister("730vp", function(module, exports) {

$parcel$export(module.exports, "getISOWeek", () => $52193498aabd8019$export$7cabdc5698b63e2f, (v) => $52193498aabd8019$export$7cabdc5698b63e2f = v);
var $52193498aabd8019$export$7cabdc5698b63e2f;
"use strict";
$52193498aabd8019$export$7cabdc5698b63e2f = $52193498aabd8019$var$getISOWeek;

var $4IrbU = parcelRequire("4IrbU");

var $77HoA = parcelRequire("77HoA");

var $hxisM = parcelRequire("hxisM");

var $26OhI = parcelRequire("26OhI");
/**
 * @name getISOWeek
 * @category ISO Week Helpers
 * @summary Get the ISO week of the given date.
 *
 * @description
 * Get the ISO week of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The ISO week
 *
 * @example
 * // Which week of the ISO-week numbering year is 2 January 2005?
 * const result = getISOWeek(new Date(2005, 0, 2))
 * //=> 53
 */ function $52193498aabd8019$var$getISOWeek(date) {
    const _date = (0, $26OhI.toDate)(date);
    const diff = +(0, $77HoA.startOfISOWeek)(_date) - +(0, $hxisM.startOfISOWeekYear)(_date);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / $4IrbU.millisecondsInWeek) + 1;
}

});
parcelRegister("77HoA", function(module, exports) {

$parcel$export(module.exports, "startOfISOWeek", () => $52fad94cb6aed986$export$6173213f95a4431e, (v) => $52fad94cb6aed986$export$6173213f95a4431e = v);
var $52fad94cb6aed986$export$6173213f95a4431e;
"use strict";
$52fad94cb6aed986$export$6173213f95a4431e = $52fad94cb6aed986$var$startOfISOWeek;

var $aSLbu = parcelRequire("aSLbu");
/**
 * @name startOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the start of an ISO week for the given date.
 *
 * @description
 * Return the start of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of an ISO week
 *
 * @example
 * // The start of an ISO week for 2 September 2014 11:55:00:
 * const result = startOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */ function $52fad94cb6aed986$var$startOfISOWeek(date) {
    return (0, $aSLbu.startOfWeek)(date, {
        weekStartsOn: 1
    });
}

});
parcelRegister("aSLbu", function(module, exports) {

$parcel$export(module.exports, "startOfWeek", () => $7ec38c5e4ca45b81$export$42c81a444fbfb5d4, (v) => $7ec38c5e4ca45b81$export$42c81a444fbfb5d4 = v);
var $7ec38c5e4ca45b81$export$42c81a444fbfb5d4;
"use strict";
$7ec38c5e4ca45b81$export$42c81a444fbfb5d4 = $7ec38c5e4ca45b81$var$startOfWeek;

var $26OhI = parcelRequire("26OhI");

var $2Hkrd = parcelRequire("2Hkrd");
/**
 * The {@link startOfWeek} function options.
 */ /**
 * @name startOfWeek
 * @category Week Helpers
 * @summary Return the start of a week for the given date.
 *
 * @description
 * Return the start of a week for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The start of a week
 *
 * @example
 * // The start of a week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Mon Sep 01 2014 00:00:00
 */ function $7ec38c5e4ca45b81$var$startOfWeek(date, options) {
    const defaultOptions = (0, $2Hkrd.getDefaultOptions)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, $26OhI.toDate)(date);
    const day = _date.getDay();
    const diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    _date.setDate(_date.getDate() - diff);
    _date.setHours(0, 0, 0, 0);
    return _date;
}

});


parcelRegister("hxisM", function(module, exports) {

$parcel$export(module.exports, "startOfISOWeekYear", () => $cc43d7264d8a3ccc$export$236bdfa374eb69a9, (v) => $cc43d7264d8a3ccc$export$236bdfa374eb69a9 = v);
var $cc43d7264d8a3ccc$export$236bdfa374eb69a9;
"use strict";
$cc43d7264d8a3ccc$export$236bdfa374eb69a9 = $cc43d7264d8a3ccc$var$startOfISOWeekYear;

var $lepTe = parcelRequire("lepTe");

var $77HoA = parcelRequire("77HoA");

var $CS8DB = parcelRequire("CS8DB");
/**
 * @name startOfISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the start of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the start of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of an ISO week-numbering year
 *
 * @example
 * // The start of an ISO week-numbering year for 2 July 2005:
 * const result = startOfISOWeekYear(new Date(2005, 6, 2))
 * //=> Mon Jan 03 2005 00:00:00
 */ function $cc43d7264d8a3ccc$var$startOfISOWeekYear(date) {
    const year = (0, $lepTe.getISOWeekYear)(date);
    const fourthOfJanuary = (0, $CS8DB.constructFrom)(date, 0);
    fourthOfJanuary.setFullYear(year, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    return (0, $77HoA.startOfISOWeek)(fourthOfJanuary);
}

});
parcelRegister("lepTe", function(module, exports) {

$parcel$export(module.exports, "getISOWeekYear", () => $f74efcf6cf1c76a4$export$3dbc52535f6f8fcc, (v) => $f74efcf6cf1c76a4$export$3dbc52535f6f8fcc = v);
var $f74efcf6cf1c76a4$export$3dbc52535f6f8fcc;
"use strict";
$f74efcf6cf1c76a4$export$3dbc52535f6f8fcc = $f74efcf6cf1c76a4$var$getISOWeekYear;

var $CS8DB = parcelRequire("CS8DB");

var $77HoA = parcelRequire("77HoA");

var $26OhI = parcelRequire("26OhI");
/**
 * @name getISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the ISO week-numbering year of the given date.
 *
 * @description
 * Get the ISO week-numbering year of the given date,
 * which always starts 3 days before the year's first Thursday.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The ISO week-numbering year
 *
 * @example
 * // Which ISO-week numbering year is 2 January 2005?
 * const result = getISOWeekYear(new Date(2005, 0, 2))
 * //=> 2004
 */ function $f74efcf6cf1c76a4$var$getISOWeekYear(date) {
    const _date = (0, $26OhI.toDate)(date);
    const year = _date.getFullYear();
    const fourthOfJanuaryOfNextYear = (0, $CS8DB.constructFrom)(date, 0);
    fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
    const startOfNextYear = (0, $77HoA.startOfISOWeek)(fourthOfJanuaryOfNextYear);
    const fourthOfJanuaryOfThisYear = (0, $CS8DB.constructFrom)(date, 0);
    fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
    const startOfThisYear = (0, $77HoA.startOfISOWeek)(fourthOfJanuaryOfThisYear);
    if (_date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (_date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

});



parcelRegister("g2WV7", function(module, exports) {

$parcel$export(module.exports, "getWeek", () => $baea89970e06eb9a$export$efe19b760242b2fc, (v) => $baea89970e06eb9a$export$efe19b760242b2fc = v);
var $baea89970e06eb9a$export$efe19b760242b2fc;
"use strict";
$baea89970e06eb9a$export$efe19b760242b2fc = $baea89970e06eb9a$var$getWeek;

var $4IrbU = parcelRequire("4IrbU");

var $aSLbu = parcelRequire("aSLbu");

var $fjV92 = parcelRequire("fjV92");

var $26OhI = parcelRequire("26OhI");
/**
 * The {@link getWeek} function options.
 */ /**
 * @name getWeek
 * @category Week Helpers
 * @summary Get the local week index of the given date.
 *
 * @description
 * Get the local week index of the given date.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options
 *
 * @returns The week
 *
 * @example
 * // Which week of the local week numbering year is 2 January 2005 with default options?
 * const result = getWeek(new Date(2005, 0, 2))
 * //=> 2
 *
 * @example
 * // Which week of the local week numbering year is 2 January 2005,
 * // if Monday is the first day of the week,
 * // and the first week of the year always contains 4 January?
 * const result = getWeek(new Date(2005, 0, 2), {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> 53
 */ function $baea89970e06eb9a$var$getWeek(date, options) {
    const _date = (0, $26OhI.toDate)(date);
    const diff = +(0, $aSLbu.startOfWeek)(_date, options) - +(0, $fjV92.startOfWeekYear)(_date, options);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / $4IrbU.millisecondsInWeek) + 1;
}

});
parcelRegister("fjV92", function(module, exports) {

$parcel$export(module.exports, "startOfWeekYear", () => $b274f52451d13ce5$export$bb7b45bb8e74da0f, (v) => $b274f52451d13ce5$export$bb7b45bb8e74da0f = v);
var $b274f52451d13ce5$export$bb7b45bb8e74da0f;
"use strict";
$b274f52451d13ce5$export$bb7b45bb8e74da0f = $b274f52451d13ce5$var$startOfWeekYear;

var $CS8DB = parcelRequire("CS8DB");

var $51wqx = parcelRequire("51wqx");

var $aSLbu = parcelRequire("aSLbu");

var $2Hkrd = parcelRequire("2Hkrd");
/**
 * The {@link startOfWeekYear} function options.
 */ /**
 * @name startOfWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Return the start of a local week-numbering year for the given date.
 *
 * @description
 * Return the start of a local week-numbering year.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The start of a week-numbering year
 *
 * @example
 * // The start of an a week-numbering year for 2 July 2005 with default settings:
 * const result = startOfWeekYear(new Date(2005, 6, 2))
 * //=> Sun Dec 26 2004 00:00:00
 *
 * @example
 * // The start of a week-numbering year for 2 July 2005
 * // if Monday is the first day of week
 * // and 4 January is always in the first week of the year:
 * const result = startOfWeekYear(new Date(2005, 6, 2), {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> Mon Jan 03 2005 00:00:00
 */ function $b274f52451d13ce5$var$startOfWeekYear(date, options) {
    const defaultOptions = (0, $2Hkrd.getDefaultOptions)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const year = (0, $51wqx.getWeekYear)(date, options);
    const firstWeek = (0, $CS8DB.constructFrom)(date, 0);
    firstWeek.setFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setHours(0, 0, 0, 0);
    const _date = (0, $aSLbu.startOfWeek)(firstWeek, options);
    return _date;
}

});
parcelRegister("51wqx", function(module, exports) {

$parcel$export(module.exports, "getWeekYear", () => $3a863317cd2bc168$export$12d572480ceb6e58, (v) => $3a863317cd2bc168$export$12d572480ceb6e58 = v);
var $3a863317cd2bc168$export$12d572480ceb6e58;
"use strict";
$3a863317cd2bc168$export$12d572480ceb6e58 = $3a863317cd2bc168$var$getWeekYear;

var $CS8DB = parcelRequire("CS8DB");

var $aSLbu = parcelRequire("aSLbu");

var $26OhI = parcelRequire("26OhI");

var $2Hkrd = parcelRequire("2Hkrd");
/**
 * The {@link getWeekYear} function options.
 */ /**
 * @name getWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Get the local week-numbering year of the given date.
 *
 * @description
 * Get the local week-numbering year of the given date.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options.
 *
 * @returns The local week-numbering year
 *
 * @example
 * // Which week numbering year is 26 December 2004 with the default settings?
 * const result = getWeekYear(new Date(2004, 11, 26))
 * //=> 2005
 *
 * @example
 * // Which week numbering year is 26 December 2004 if week starts on Saturday?
 * const result = getWeekYear(new Date(2004, 11, 26), { weekStartsOn: 6 })
 * //=> 2004
 *
 * @example
 * // Which week numbering year is 26 December 2004 if the first week contains 4 January?
 * const result = getWeekYear(new Date(2004, 11, 26), { firstWeekContainsDate: 4 })
 * //=> 2004
 */ function $3a863317cd2bc168$var$getWeekYear(date, options) {
    const _date = (0, $26OhI.toDate)(date);
    const year = _date.getFullYear();
    const defaultOptions = (0, $2Hkrd.getDefaultOptions)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const firstWeekOfNextYear = (0, $CS8DB.constructFrom)(date, 0);
    firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setHours(0, 0, 0, 0);
    const startOfNextYear = (0, $aSLbu.startOfWeek)(firstWeekOfNextYear, options);
    const firstWeekOfThisYear = (0, $CS8DB.constructFrom)(date, 0);
    firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setHours(0, 0, 0, 0);
    const startOfThisYear = (0, $aSLbu.startOfWeek)(firstWeekOfThisYear, options);
    if (_date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (_date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

});



parcelRegister("cPWeo", function(module, exports) {

$parcel$export(module.exports, "addLeadingZeros", () => $95876af0000dbf17$export$c8306e720e213c0f, (v) => $95876af0000dbf17$export$c8306e720e213c0f = v);
var $95876af0000dbf17$export$c8306e720e213c0f;
"use strict";
$95876af0000dbf17$export$c8306e720e213c0f = $95876af0000dbf17$var$addLeadingZeros;
function $95876af0000dbf17$var$addLeadingZeros(number, targetLength) {
    const sign = number < 0 ? "-" : "";
    const output = Math.abs(number).toString().padStart(targetLength, "0");
    return sign + output;
}

});

parcelRegister("lhoHr", function(module, exports) {

$parcel$export(module.exports, "lightFormatters", () => $f7de5855c1609b7d$export$b0d4b338e1516f13, (v) => $f7de5855c1609b7d$export$b0d4b338e1516f13 = v);
var $f7de5855c1609b7d$export$b0d4b338e1516f13;
"use strict";
$f7de5855c1609b7d$export$b0d4b338e1516f13 = void 0;

var $cPWeo = parcelRequire("cPWeo");
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ const $f7de5855c1609b7d$var$lightFormatters = $f7de5855c1609b7d$export$b0d4b338e1516f13 = {
    // Year
    y (date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        const signedYear = date.getFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        const year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $cPWeo.addLeadingZeros)(token === "yy" ? year % 100 : year, token.length);
    },
    // Month
    M (date, token) {
        const month = date.getMonth();
        return token === "M" ? String(month + 1) : (0, $cPWeo.addLeadingZeros)(month + 1, 2);
    },
    // Day of the month
    d (date, token) {
        return (0, $cPWeo.addLeadingZeros)(date.getDate(), token.length);
    },
    // AM or PM
    a (date, token) {
        const dayPeriodEnumValue = date.getHours() / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return dayPeriodEnumValue.toUpperCase();
            case "aaa":
                return dayPeriodEnumValue;
            case "aaaaa":
                return dayPeriodEnumValue[0];
            case "aaaa":
            default:
                return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
        }
    },
    // Hour [1-12]
    h (date, token) {
        return (0, $cPWeo.addLeadingZeros)(date.getHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H (date, token) {
        return (0, $cPWeo.addLeadingZeros)(date.getHours(), token.length);
    },
    // Minute
    m (date, token) {
        return (0, $cPWeo.addLeadingZeros)(date.getMinutes(), token.length);
    },
    // Second
    s (date, token) {
        return (0, $cPWeo.addLeadingZeros)(date.getSeconds(), token.length);
    },
    // Fraction of second
    S (date, token) {
        const numberOfDigits = token.length;
        const milliseconds = date.getMilliseconds();
        const fractionalSeconds = Math.trunc(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $cPWeo.addLeadingZeros)(fractionalSeconds, token.length);
    }
};

});


parcelRegister("i59tm", function(module, exports) {

$parcel$export(module.exports, "longFormatters", () => $d2a00aabe10bd762$export$70cc8fd02856fd58, (v) => $d2a00aabe10bd762$export$70cc8fd02856fd58 = v);
var $d2a00aabe10bd762$export$70cc8fd02856fd58;
"use strict";
$d2a00aabe10bd762$export$70cc8fd02856fd58 = void 0;
const $d2a00aabe10bd762$var$dateLongFormatter = (pattern, formatLong)=>{
    switch(pattern){
        case "P":
            return formatLong.date({
                width: "short"
            });
        case "PP":
            return formatLong.date({
                width: "medium"
            });
        case "PPP":
            return formatLong.date({
                width: "long"
            });
        case "PPPP":
        default:
            return formatLong.date({
                width: "full"
            });
    }
};
const $d2a00aabe10bd762$var$timeLongFormatter = (pattern, formatLong)=>{
    switch(pattern){
        case "p":
            return formatLong.time({
                width: "short"
            });
        case "pp":
            return formatLong.time({
                width: "medium"
            });
        case "ppp":
            return formatLong.time({
                width: "long"
            });
        case "pppp":
        default:
            return formatLong.time({
                width: "full"
            });
    }
};
const $d2a00aabe10bd762$var$dateTimeLongFormatter = (pattern, formatLong)=>{
    const matchResult = pattern.match(/(P+)(p+)?/) || [];
    const datePattern = matchResult[1];
    const timePattern = matchResult[2];
    if (!timePattern) return $d2a00aabe10bd762$var$dateLongFormatter(pattern, formatLong);
    let dateTimeFormat;
    switch(datePattern){
        case "P":
            dateTimeFormat = formatLong.dateTime({
                width: "short"
            });
            break;
        case "PP":
            dateTimeFormat = formatLong.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            dateTimeFormat = formatLong.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            dateTimeFormat = formatLong.dateTime({
                width: "full"
            });
            break;
    }
    return dateTimeFormat.replace("{{date}}", $d2a00aabe10bd762$var$dateLongFormatter(datePattern, formatLong)).replace("{{time}}", $d2a00aabe10bd762$var$timeLongFormatter(timePattern, formatLong));
};
const $d2a00aabe10bd762$var$longFormatters = $d2a00aabe10bd762$export$70cc8fd02856fd58 = {
    p: $d2a00aabe10bd762$var$timeLongFormatter,
    P: $d2a00aabe10bd762$var$dateTimeLongFormatter
};

});

parcelRegister("eKdof", function(module, exports) {

$parcel$export(module.exports, "isProtectedDayOfYearToken", () => $abbfbf913ae779f8$export$c6cc36aa33304772, (v) => $abbfbf913ae779f8$export$c6cc36aa33304772 = v);
$parcel$export(module.exports, "isProtectedWeekYearToken", () => $abbfbf913ae779f8$export$c6b49d6dceb604a1, (v) => $abbfbf913ae779f8$export$c6b49d6dceb604a1 = v);
$parcel$export(module.exports, "warnOrThrowProtectedError", () => $abbfbf913ae779f8$export$f5f38f90ecaaf879, (v) => $abbfbf913ae779f8$export$f5f38f90ecaaf879 = v);
var $abbfbf913ae779f8$export$c6cc36aa33304772;
var $abbfbf913ae779f8$export$c6b49d6dceb604a1;
var $abbfbf913ae779f8$export$f5f38f90ecaaf879;
"use strict";
$abbfbf913ae779f8$export$c6cc36aa33304772 = $abbfbf913ae779f8$var$isProtectedDayOfYearToken;
$abbfbf913ae779f8$export$c6b49d6dceb604a1 = $abbfbf913ae779f8$var$isProtectedWeekYearToken;
$abbfbf913ae779f8$export$f5f38f90ecaaf879 = $abbfbf913ae779f8$var$warnOrThrowProtectedError;
const $abbfbf913ae779f8$var$dayOfYearTokenRE = /^D+$/;
const $abbfbf913ae779f8$var$weekYearTokenRE = /^Y+$/;
const $abbfbf913ae779f8$var$throwTokens = [
    "D",
    "DD",
    "YY",
    "YYYY"
];
function $abbfbf913ae779f8$var$isProtectedDayOfYearToken(token) {
    return $abbfbf913ae779f8$var$dayOfYearTokenRE.test(token);
}
function $abbfbf913ae779f8$var$isProtectedWeekYearToken(token) {
    return $abbfbf913ae779f8$var$weekYearTokenRE.test(token);
}
function $abbfbf913ae779f8$var$warnOrThrowProtectedError(token, format, input) {
    const _message = $abbfbf913ae779f8$var$message(token, format, input);
    console.warn(_message);
    if ($abbfbf913ae779f8$var$throwTokens.includes(token)) throw new RangeError(_message);
}
function $abbfbf913ae779f8$var$message(token, format, input) {
    const subject = token[0] === "Y" ? "years" : "days of the month";
    return `Use \`${token.toLowerCase()}\` instead of \`${token}\` (in \`${format}\`) for formatting ${subject} to the input \`${input}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}

});


parcelRegister("hB2gy", function(module, exports) {

$parcel$export(module.exports, "addMinutes", () => $ccf7a65729afdbb7$export$2287e3d29250119e, (v) => $ccf7a65729afdbb7$export$2287e3d29250119e = v);
var $ccf7a65729afdbb7$export$2287e3d29250119e;
"use strict";
$ccf7a65729afdbb7$export$2287e3d29250119e = $ccf7a65729afdbb7$var$addMinutes;

var $90YsH = parcelRequire("90YsH");

var $4IrbU = parcelRequire("4IrbU");
/**
 * @name addMinutes
 * @category Minute Helpers
 * @summary Add the specified number of minutes to the given date.
 *
 * @description
 * Add the specified number of minutes to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of minutes to be added.
 *
 * @returns The new date with the minutes added
 *
 * @example
 * // Add 30 minutes to 10 July 2014 12:00:00:
 * const result = addMinutes(new Date(2014, 6, 10, 12, 0), 30)
 * //=> Thu Jul 10 2014 12:30:00
 */ function $ccf7a65729afdbb7$var$addMinutes(date, amount) {
    return (0, $90YsH.addMilliseconds)(date, amount * $4IrbU.millisecondsInMinute);
}

});
parcelRegister("90YsH", function(module, exports) {

$parcel$export(module.exports, "addMilliseconds", () => $01b198d51ca4ed87$export$baf757aaf0c95c94, (v) => $01b198d51ca4ed87$export$baf757aaf0c95c94 = v);
var $01b198d51ca4ed87$export$baf757aaf0c95c94;
"use strict";
$01b198d51ca4ed87$export$baf757aaf0c95c94 = $01b198d51ca4ed87$var$addMilliseconds;

var $26OhI = parcelRequire("26OhI");

var $CS8DB = parcelRequire("CS8DB");
/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of milliseconds to be added.
 *
 * @returns The new date with the milliseconds added
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */ function $01b198d51ca4ed87$var$addMilliseconds(date, amount) {
    const timestamp = +(0, $26OhI.toDate)(date);
    return (0, $CS8DB.constructFrom)(date, timestamp + amount);
}

});


parcelRegister("2s8DN", function(module, exports) {

$parcel$export(module.exports, "addHours", () => $1c94e62f7be0ccc7$export$4a4306ad4fa0e5e6, (v) => $1c94e62f7be0ccc7$export$4a4306ad4fa0e5e6 = v);
var $1c94e62f7be0ccc7$export$4a4306ad4fa0e5e6;
"use strict";
$1c94e62f7be0ccc7$export$4a4306ad4fa0e5e6 = $1c94e62f7be0ccc7$var$addHours;

var $90YsH = parcelRequire("90YsH");

var $4IrbU = parcelRequire("4IrbU");
/**
 * @name addHours
 * @category Hour Helpers
 * @summary Add the specified number of hours to the given date.
 *
 * @description
 * Add the specified number of hours to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of hours to be added.
 *
 * @returns The new date with the hours added
 *
 * @example
 * // Add 2 hours to 10 July 2014 23:00:00:
 * const result = addHours(new Date(2014, 6, 10, 23, 0), 2)
 * //=> Fri Jul 11 2014 01:00:00
 */ function $1c94e62f7be0ccc7$var$addHours(date, amount) {
    return (0, $90YsH.addMilliseconds)(date, amount * $4IrbU.millisecondsInHour);
}

});

parcelRegister("jKYo1", function(module, exports) {

$parcel$export(module.exports, "addDays", () => $e62127aff8910ea0$export$dd412b56f1e4d8aa, (v) => $e62127aff8910ea0$export$dd412b56f1e4d8aa = v);
var $e62127aff8910ea0$export$dd412b56f1e4d8aa;
"use strict";
$e62127aff8910ea0$export$dd412b56f1e4d8aa = $e62127aff8910ea0$var$addDays;

var $26OhI = parcelRequire("26OhI");

var $CS8DB = parcelRequire("CS8DB");
/**
 * @name addDays
 * @category Day Helpers
 * @summary Add the specified number of days to the given date.
 *
 * @description
 * Add the specified number of days to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of days to be added.
 *
 * @returns The new date with the days added
 *
 * @example
 * // Add 10 days to 1 September 2014:
 * const result = addDays(new Date(2014, 8, 1), 10)
 * //=> Thu Sep 11 2014 00:00:00
 */ function $e62127aff8910ea0$var$addDays(date, amount) {
    const _date = (0, $26OhI.toDate)(date);
    if (isNaN(amount)) return (0, $CS8DB.constructFrom)(date, NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return _date;
    _date.setDate(_date.getDate() + amount);
    return _date;
}

});

parcelRegister("41ovE", function(module, exports) {

$parcel$export(module.exports, "addWeeks", () => $2eda4484d7efa319$export$ef501a2bb4f3ee6b, (v) => $2eda4484d7efa319$export$ef501a2bb4f3ee6b = v);
var $2eda4484d7efa319$export$ef501a2bb4f3ee6b;
"use strict";
$2eda4484d7efa319$export$ef501a2bb4f3ee6b = $2eda4484d7efa319$var$addWeeks;

var $jKYo1 = parcelRequire("jKYo1");
/**
 * @name addWeeks
 * @category Week Helpers
 * @summary Add the specified number of weeks to the given date.
 *
 * @description
 * Add the specified number of week to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of weeks to be added.
 *
 * @returns The new date with the weeks added
 *
 * @example
 * // Add 4 weeks to 1 September 2014:
 * const result = addWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Sep 29 2014 00:00:00
 */ function $2eda4484d7efa319$var$addWeeks(date, amount) {
    const days = amount * 7;
    return (0, $jKYo1.addDays)(date, days);
}

});

parcelRegister("9qaFH", function(module, exports) {

$parcel$export(module.exports, "addMonths", () => $6dbed1e7db5001f4$export$17c93e242b2d3a22, (v) => $6dbed1e7db5001f4$export$17c93e242b2d3a22 = v);
var $6dbed1e7db5001f4$export$17c93e242b2d3a22;
"use strict";
$6dbed1e7db5001f4$export$17c93e242b2d3a22 = $6dbed1e7db5001f4$var$addMonths;

var $26OhI = parcelRequire("26OhI");

var $CS8DB = parcelRequire("CS8DB");
/**
 * @name addMonths
 * @category Month Helpers
 * @summary Add the specified number of months to the given date.
 *
 * @description
 * Add the specified number of months to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of months to be added.
 *
 * @returns The new date with the months added
 *
 * @example
 * // Add 5 months to 1 September 2014:
 * const result = addMonths(new Date(2014, 8, 1), 5)
 * //=> Sun Feb 01 2015 00:00:00
 *
 * // Add one month to 30 January 2023:
 * const result = addMonths(new Date(2023, 0, 30), 1)
 * //=> Tue Feb 28 2023 00:00:00
 */ function $6dbed1e7db5001f4$var$addMonths(date, amount) {
    const _date = (0, $26OhI.toDate)(date);
    if (isNaN(amount)) return (0, $CS8DB.constructFrom)(date, NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return _date;
    const dayOfMonth = _date.getDate();
    // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    const endOfDesiredMonth = (0, $CS8DB.constructFrom)(date, _date.getTime());
    endOfDesiredMonth.setMonth(_date.getMonth() + amount + 1, 0);
    const daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        _date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return _date;
    }
}

});

parcelRegister("53mjM", function(module, exports) {

$parcel$export(module.exports, "addQuarters", () => $3ade8b7a14a7cb00$export$c252a41d0fbed2ce, (v) => $3ade8b7a14a7cb00$export$c252a41d0fbed2ce = v);
var $3ade8b7a14a7cb00$export$c252a41d0fbed2ce;
"use strict";
$3ade8b7a14a7cb00$export$c252a41d0fbed2ce = $3ade8b7a14a7cb00$var$addQuarters;

var $9qaFH = parcelRequire("9qaFH");
/**
 * @name addQuarters
 * @category Quarter Helpers
 * @summary Add the specified number of year quarters to the given date.
 *
 * @description
 * Add the specified number of year quarters to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of quarters to be added.
 *
 * @returns The new date with the quarters added
 *
 * @example
 * // Add 1 quarter to 1 September 2014:
 * const result = addQuarters(new Date(2014, 8, 1), 1)
 * //=> Mon Dec 01 2014 00:00:00
 */ function $3ade8b7a14a7cb00$var$addQuarters(date, amount) {
    const months = amount * 3;
    return (0, $9qaFH.addMonths)(date, months);
}

});

parcelRegister("f17A2", function(module, exports) {

$parcel$export(module.exports, "addYears", () => $aeecd44f07fd6c83$export$3d83eec43f4ea476, (v) => $aeecd44f07fd6c83$export$3d83eec43f4ea476 = v);
var $aeecd44f07fd6c83$export$3d83eec43f4ea476;
"use strict";
$aeecd44f07fd6c83$export$3d83eec43f4ea476 = $aeecd44f07fd6c83$var$addYears;

var $9qaFH = parcelRequire("9qaFH");
/**
 * @name addYears
 * @category Year Helpers
 * @summary Add the specified number of years to the given date.
 *
 * @description
 * Add the specified number of years to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of years to be added.
 *
 * @returns The new date with the years added
 *
 * @example
 * // Add 5 years to 1 September 2014:
 * const result = addYears(new Date(2014, 8, 1), 5)
 * //=> Sun Sep 01 2019 00:00:00
 */ function $aeecd44f07fd6c83$var$addYears(date, amount) {
    return (0, $9qaFH.addMonths)(date, amount * 12);
}

});

parcelRegister("04GVu", function(module, exports) {

$parcel$export(module.exports, "subDays", () => $00e1ac183b4dcba2$export$70823084e2deb1ea, (v) => $00e1ac183b4dcba2$export$70823084e2deb1ea = v);
var $00e1ac183b4dcba2$export$70823084e2deb1ea;
"use strict";
$00e1ac183b4dcba2$export$70823084e2deb1ea = $00e1ac183b4dcba2$var$subDays;

var $jKYo1 = parcelRequire("jKYo1");
/**
 * @name subDays
 * @category Day Helpers
 * @summary Subtract the specified number of days from the given date.
 *
 * @description
 * Subtract the specified number of days from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of days to be subtracted.
 *
 * @returns The new date with the days subtracted
 *
 * @example
 * // Subtract 10 days from 1 September 2014:
 * const result = subDays(new Date(2014, 8, 1), 10)
 * //=> Fri Aug 22 2014 00:00:00
 */ function $00e1ac183b4dcba2$var$subDays(date, amount) {
    return (0, $jKYo1.addDays)(date, -amount);
}

});

parcelRegister("l05JD", function(module, exports) {

$parcel$export(module.exports, "subWeeks", () => $f49e0bea404465ec$export$b4d8ae6376193efb, (v) => $f49e0bea404465ec$export$b4d8ae6376193efb = v);
var $f49e0bea404465ec$export$b4d8ae6376193efb;
"use strict";
$f49e0bea404465ec$export$b4d8ae6376193efb = $f49e0bea404465ec$var$subWeeks;

var $41ovE = parcelRequire("41ovE");
/**
 * @name subWeeks
 * @category Week Helpers
 * @summary Subtract the specified number of weeks from the given date.
 *
 * @description
 * Subtract the specified number of weeks from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of weeks to be subtracted.
 *
 * @returns The new date with the weeks subtracted
 *
 * @example
 * // Subtract 4 weeks from 1 September 2014:
 * const result = subWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Aug 04 2014 00:00:00
 */ function $f49e0bea404465ec$var$subWeeks(date, amount) {
    return (0, $41ovE.addWeeks)(date, -amount);
}

});

parcelRegister("e04FR", function(module, exports) {

$parcel$export(module.exports, "subMonths", () => $a314b0fd4a4c31e3$export$73d1c15a21f9fae5, (v) => $a314b0fd4a4c31e3$export$73d1c15a21f9fae5 = v);
var $a314b0fd4a4c31e3$export$73d1c15a21f9fae5;
"use strict";
$a314b0fd4a4c31e3$export$73d1c15a21f9fae5 = $a314b0fd4a4c31e3$var$subMonths;

var $9qaFH = parcelRequire("9qaFH");
/**
 * @name subMonths
 * @category Month Helpers
 * @summary Subtract the specified number of months from the given date.
 *
 * @description
 * Subtract the specified number of months from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of months to be subtracted.
 *
 * @returns The new date with the months subtracted
 *
 * @example
 * // Subtract 5 months from 1 February 2015:
 * const result = subMonths(new Date(2015, 1, 1), 5)
 * //=> Mon Sep 01 2014 00:00:00
 */ function $a314b0fd4a4c31e3$var$subMonths(date, amount) {
    return (0, $9qaFH.addMonths)(date, -amount);
}

});

parcelRegister("gRtvC", function(module, exports) {

$parcel$export(module.exports, "subQuarters", () => $c4687c6da54e1196$export$a31bfeeeee80cce6, (v) => $c4687c6da54e1196$export$a31bfeeeee80cce6 = v);
var $c4687c6da54e1196$export$a31bfeeeee80cce6;
"use strict";
$c4687c6da54e1196$export$a31bfeeeee80cce6 = $c4687c6da54e1196$var$subQuarters;

var $53mjM = parcelRequire("53mjM");
/**
 * @name subQuarters
 * @category Quarter Helpers
 * @summary Subtract the specified number of year quarters from the given date.
 *
 * @description
 * Subtract the specified number of year quarters from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of quarters to be subtracted.
 *
 * @returns The new date with the quarters subtracted
 *
 * @example
 * // Subtract 3 quarters from 1 September 2014:
 * const result = subQuarters(new Date(2014, 8, 1), 3)
 * //=> Sun Dec 01 2013 00:00:00
 */ function $c4687c6da54e1196$var$subQuarters(date, amount) {
    return (0, $53mjM.addQuarters)(date, -amount);
}

});

parcelRegister("3kUAA", function(module, exports) {

$parcel$export(module.exports, "subYears", () => $26df22c3a9cb4fde$export$14867687ff6c92e2, (v) => $26df22c3a9cb4fde$export$14867687ff6c92e2 = v);
var $26df22c3a9cb4fde$export$14867687ff6c92e2;
"use strict";
$26df22c3a9cb4fde$export$14867687ff6c92e2 = $26df22c3a9cb4fde$var$subYears;

var $f17A2 = parcelRequire("f17A2");
/**
 * @name subYears
 * @category Year Helpers
 * @summary Subtract the specified number of years from the given date.
 *
 * @description
 * Subtract the specified number of years from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of years to be subtracted.
 *
 * @returns The new date with the years subtracted
 *
 * @example
 * // Subtract 5 years from 1 September 2014:
 * const result = subYears(new Date(2014, 8, 1), 5)
 * //=> Tue Sep 01 2009 00:00:00
 */ function $26df22c3a9cb4fde$var$subYears(date, amount) {
    return (0, $f17A2.addYears)(date, -amount);
}

});

parcelRegister("2zELa", function(module, exports) {

$parcel$export(module.exports, "getSeconds", () => $1dfe77b76f9e0d4a$export$5e9417507ff28427, (v) => $1dfe77b76f9e0d4a$export$5e9417507ff28427 = v);
var $1dfe77b76f9e0d4a$export$5e9417507ff28427;
"use strict";
$1dfe77b76f9e0d4a$export$5e9417507ff28427 = $1dfe77b76f9e0d4a$var$getSeconds;

var $26OhI = parcelRequire("26OhI");
/**
 * @name getSeconds
 * @category Second Helpers
 * @summary Get the seconds of the given date.
 *
 * @description
 * Get the seconds of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The seconds
 *
 * @example
 * // Get the seconds of 29 February 2012 11:45:05.123:
 * const result = getSeconds(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 5
 */ function $1dfe77b76f9e0d4a$var$getSeconds(date) {
    const _date = (0, $26OhI.toDate)(date);
    const seconds = _date.getSeconds();
    return seconds;
}

});

parcelRegister("gtzUl", function(module, exports) {

$parcel$export(module.exports, "getMinutes", () => $bfeb35507f158509$export$b7f1bc3ea3ac4145, (v) => $bfeb35507f158509$export$b7f1bc3ea3ac4145 = v);
var $bfeb35507f158509$export$b7f1bc3ea3ac4145;
"use strict";
$bfeb35507f158509$export$b7f1bc3ea3ac4145 = $bfeb35507f158509$var$getMinutes;

var $26OhI = parcelRequire("26OhI");
/**
 * @name getMinutes
 * @category Minute Helpers
 * @summary Get the minutes of the given date.
 *
 * @description
 * Get the minutes of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The minutes
 *
 * @example
 * // Get the minutes of 29 February 2012 11:45:05:
 * const result = getMinutes(new Date(2012, 1, 29, 11, 45, 5))
 * //=> 45
 */ function $bfeb35507f158509$var$getMinutes(date) {
    const _date = (0, $26OhI.toDate)(date);
    const minutes = _date.getMinutes();
    return minutes;
}

});

parcelRegister("l5B1g", function(module, exports) {

$parcel$export(module.exports, "getHours", () => $f5a6c7dc2b8d7dbe$export$257b40f71c07d58f, (v) => $f5a6c7dc2b8d7dbe$export$257b40f71c07d58f = v);
var $f5a6c7dc2b8d7dbe$export$257b40f71c07d58f;
"use strict";
$f5a6c7dc2b8d7dbe$export$257b40f71c07d58f = $f5a6c7dc2b8d7dbe$var$getHours;

var $26OhI = parcelRequire("26OhI");
/**
 * @name getHours
 * @category Hour Helpers
 * @summary Get the hours of the given date.
 *
 * @description
 * Get the hours of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The hours
 *
 * @example
 * // Get the hours of 29 February 2012 11:45:00:
 * const result = getHours(new Date(2012, 1, 29, 11, 45))
 * //=> 11
 */ function $f5a6c7dc2b8d7dbe$var$getHours(date) {
    const _date = (0, $26OhI.toDate)(date);
    const hours = _date.getHours();
    return hours;
}

});

parcelRegister("4uPa5", function(module, exports) {

$parcel$export(module.exports, "getDay", () => $3461a666a5556117$export$1b64bc9c5306ed54, (v) => $3461a666a5556117$export$1b64bc9c5306ed54 = v);
var $3461a666a5556117$export$1b64bc9c5306ed54;
"use strict";
$3461a666a5556117$export$1b64bc9c5306ed54 = $3461a666a5556117$var$getDay;

var $26OhI = parcelRequire("26OhI");
/**
 * @name getDay
 * @category Weekday Helpers
 * @summary Get the day of the week of the given date.
 *
 * @description
 * Get the day of the week of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The day of week, 0 represents Sunday
 *
 * @example
 * // Which day of the week is 29 February 2012?
 * const result = getDay(new Date(2012, 1, 29))
 * //=> 3
 */ function $3461a666a5556117$var$getDay(date) {
    const _date = (0, $26OhI.toDate)(date);
    const day = _date.getDay();
    return day;
}

});

parcelRegister("jBSa0", function(module, exports) {

$parcel$export(module.exports, "getDate", () => $e46b7c27ffc7aea2$export$aa350b96d91cd94, (v) => $e46b7c27ffc7aea2$export$aa350b96d91cd94 = v);
var $e46b7c27ffc7aea2$export$aa350b96d91cd94;
"use strict";
$e46b7c27ffc7aea2$export$aa350b96d91cd94 = $e46b7c27ffc7aea2$var$getDate;

var $26OhI = parcelRequire("26OhI");
/**
 * @name getDate
 * @category Day Helpers
 * @summary Get the day of the month of the given date.
 *
 * @description
 * Get the day of the month of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The day of month
 *
 * @example
 * // Which day of the month is 29 February 2012?
 * const result = getDate(new Date(2012, 1, 29))
 * //=> 29
 */ function $e46b7c27ffc7aea2$var$getDate(date) {
    const _date = (0, $26OhI.toDate)(date);
    const dayOfMonth = _date.getDate();
    return dayOfMonth;
}

});

parcelRegister("kTdkQ", function(module, exports) {

$parcel$export(module.exports, "getMonth", () => $f35349c8f1710b75$export$6ce1b5acc29cb53b, (v) => $f35349c8f1710b75$export$6ce1b5acc29cb53b = v);
var $f35349c8f1710b75$export$6ce1b5acc29cb53b;
"use strict";
$f35349c8f1710b75$export$6ce1b5acc29cb53b = $f35349c8f1710b75$var$getMonth;

var $26OhI = parcelRequire("26OhI");
/**
 * @name getMonth
 * @category Month Helpers
 * @summary Get the month of the given date.
 *
 * @description
 * Get the month of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The month
 *
 * @example
 * // Which month is 29 February 2012?
 * const result = getMonth(new Date(2012, 1, 29))
 * //=> 1
 */ function $f35349c8f1710b75$var$getMonth(date) {
    const _date = (0, $26OhI.toDate)(date);
    const month = _date.getMonth();
    return month;
}

});

parcelRegister("dQGvM", function(module, exports) {

$parcel$export(module.exports, "getQuarter", () => $a1511b9f160acd20$export$de90a4bb31c25221, (v) => $a1511b9f160acd20$export$de90a4bb31c25221 = v);
var $a1511b9f160acd20$export$de90a4bb31c25221;
"use strict";
$a1511b9f160acd20$export$de90a4bb31c25221 = $a1511b9f160acd20$var$getQuarter;

var $26OhI = parcelRequire("26OhI");
/**
 * @name getQuarter
 * @category Quarter Helpers
 * @summary Get the year quarter of the given date.
 *
 * @description
 * Get the year quarter of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The quarter
 *
 * @example
 * // Which quarter is 2 July 2014?
 * const result = getQuarter(new Date(2014, 6, 2))
 * //=> 3
 */ function $a1511b9f160acd20$var$getQuarter(date) {
    const _date = (0, $26OhI.toDate)(date);
    const quarter = Math.trunc(_date.getMonth() / 3) + 1;
    return quarter;
}

});

parcelRegister("dmBSy", function(module, exports) {

$parcel$export(module.exports, "getYear", () => $9baab668b499a02d$export$5846dc2d57a5c860, (v) => $9baab668b499a02d$export$5846dc2d57a5c860 = v);
var $9baab668b499a02d$export$5846dc2d57a5c860;
"use strict";
$9baab668b499a02d$export$5846dc2d57a5c860 = $9baab668b499a02d$var$getYear;

var $26OhI = parcelRequire("26OhI");
/**
 * @name getYear
 * @category Year Helpers
 * @summary Get the year of the given date.
 *
 * @description
 * Get the year of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The year
 *
 * @example
 * // Which year is 2 July 2014?
 * const result = getYear(new Date(2014, 6, 2))
 * //=> 2014
 */ function $9baab668b499a02d$var$getYear(date) {
    return (0, $26OhI.toDate)(date).getFullYear();
}

});

parcelRegister("3ynSJ", function(module, exports) {

$parcel$export(module.exports, "getTime", () => $2967127eb37a7eec$export$1428f42a7de81803, (v) => $2967127eb37a7eec$export$1428f42a7de81803 = v);
var $2967127eb37a7eec$export$1428f42a7de81803;
"use strict";
$2967127eb37a7eec$export$1428f42a7de81803 = $2967127eb37a7eec$var$getTime;

var $26OhI = parcelRequire("26OhI");
/**
 * @name getTime
 * @category Timestamp Helpers
 * @summary Get the milliseconds timestamp of the given date.
 *
 * @description
 * Get the milliseconds timestamp of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The timestamp
 *
 * @example
 * // Get the timestamp of 29 February 2012 11:45:05.123:
 * const result = getTime(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 1330515905123
 */ function $2967127eb37a7eec$var$getTime(date) {
    const _date = (0, $26OhI.toDate)(date);
    const timestamp = _date.getTime();
    return timestamp;
}

});

parcelRegister("aLgYk", function(module, exports) {

$parcel$export(module.exports, "setSeconds", () => $7d5b7573fc4ef59d$export$aec44746644cbf43, (v) => $7d5b7573fc4ef59d$export$aec44746644cbf43 = v);
var $7d5b7573fc4ef59d$export$aec44746644cbf43;
"use strict";
$7d5b7573fc4ef59d$export$aec44746644cbf43 = $7d5b7573fc4ef59d$var$setSeconds;

var $26OhI = parcelRequire("26OhI");
/**
 * @name setSeconds
 * @category Second Helpers
 * @summary Set the seconds to the given date.
 *
 * @description
 * Set the seconds to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param seconds - The seconds of the new date
 *
 * @returns The new date with the seconds set
 *
 * @example
 * // Set 45 seconds to 1 September 2014 11:30:40:
 * const result = setSeconds(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:30:45
 */ function $7d5b7573fc4ef59d$var$setSeconds(date, seconds) {
    const _date = (0, $26OhI.toDate)(date);
    _date.setSeconds(seconds);
    return _date;
}

});

parcelRegister("bNJqN", function(module, exports) {

$parcel$export(module.exports, "setMinutes", () => $897782fc65b99381$export$ad569bf1c79ea89d, (v) => $897782fc65b99381$export$ad569bf1c79ea89d = v);
var $897782fc65b99381$export$ad569bf1c79ea89d;
"use strict";
$897782fc65b99381$export$ad569bf1c79ea89d = $897782fc65b99381$var$setMinutes;

var $26OhI = parcelRequire("26OhI");
/**
 * @name setMinutes
 * @category Minute Helpers
 * @summary Set the minutes to the given date.
 *
 * @description
 * Set the minutes to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param minutes - The minutes of the new date
 *
 * @returns The new date with the minutes set
 *
 * @example
 * // Set 45 minutes to 1 September 2014 11:30:40:
 * const result = setMinutes(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:45:40
 */ function $897782fc65b99381$var$setMinutes(date, minutes) {
    const _date = (0, $26OhI.toDate)(date);
    _date.setMinutes(minutes);
    return _date;
}

});

parcelRegister("gnwRT", function(module, exports) {

$parcel$export(module.exports, "setHours", () => $bec84a474124ad1f$export$f86b797a4659b781, (v) => $bec84a474124ad1f$export$f86b797a4659b781 = v);
var $bec84a474124ad1f$export$f86b797a4659b781;
"use strict";
$bec84a474124ad1f$export$f86b797a4659b781 = $bec84a474124ad1f$var$setHours;

var $26OhI = parcelRequire("26OhI");
/**
 * @name setHours
 * @category Hour Helpers
 * @summary Set the hours to the given date.
 *
 * @description
 * Set the hours to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param hours - The hours of the new date
 *
 * @returns The new date with the hours set
 *
 * @example
 * // Set 4 hours to 1 September 2014 11:30:00:
 * const result = setHours(new Date(2014, 8, 1, 11, 30), 4)
 * //=> Mon Sep 01 2014 04:30:00
 */ function $bec84a474124ad1f$var$setHours(date, hours) {
    const _date = (0, $26OhI.toDate)(date);
    _date.setHours(hours);
    return _date;
}

});

parcelRegister("03Fkt", function(module, exports) {

$parcel$export(module.exports, "setMonth", () => $00b0570944ef0e0d$export$63264690f8e36790, (v) => $00b0570944ef0e0d$export$63264690f8e36790 = v);
var $00b0570944ef0e0d$export$63264690f8e36790;
"use strict";
$00b0570944ef0e0d$export$63264690f8e36790 = $00b0570944ef0e0d$var$setMonth;

var $CS8DB = parcelRequire("CS8DB");

var $1W5XB = parcelRequire("1W5XB");

var $26OhI = parcelRequire("26OhI");
/**
 * @name setMonth
 * @category Month Helpers
 * @summary Set the month to the given date.
 *
 * @description
 * Set the month to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param month - The month of the new date
 *
 * @returns The new date with the month set
 *
 * @example
 * // Set February to 1 September 2014:
 * const result = setMonth(new Date(2014, 8, 1), 1)
 * //=> Sat Feb 01 2014 00:00:00
 */ function $00b0570944ef0e0d$var$setMonth(date, month) {
    const _date = (0, $26OhI.toDate)(date);
    const year = _date.getFullYear();
    const day = _date.getDate();
    const dateWithDesiredMonth = (0, $CS8DB.constructFrom)(date, 0);
    dateWithDesiredMonth.setFullYear(year, month, 15);
    dateWithDesiredMonth.setHours(0, 0, 0, 0);
    const daysInMonth = (0, $1W5XB.getDaysInMonth)(dateWithDesiredMonth);
    // Set the last day of the new month
    // if the original date was the last day of the longer month
    _date.setMonth(month, Math.min(day, daysInMonth));
    return _date;
}

});
parcelRegister("1W5XB", function(module, exports) {

$parcel$export(module.exports, "getDaysInMonth", () => $168fd4ce13204535$export$f645ddd439eb259d, (v) => $168fd4ce13204535$export$f645ddd439eb259d = v);
var $168fd4ce13204535$export$f645ddd439eb259d;
"use strict";
$168fd4ce13204535$export$f645ddd439eb259d = $168fd4ce13204535$var$getDaysInMonth;

var $26OhI = parcelRequire("26OhI");

var $CS8DB = parcelRequire("CS8DB");
/**
 * @name getDaysInMonth
 * @category Month Helpers
 * @summary Get the number of days in a month of the given date.
 *
 * @description
 * Get the number of days in a month of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The number of days in a month
 *
 * @example
 * // How many days are in February 2000?
 * const result = getDaysInMonth(new Date(2000, 1))
 * //=> 29
 */ function $168fd4ce13204535$var$getDaysInMonth(date) {
    const _date = (0, $26OhI.toDate)(date);
    const year = _date.getFullYear();
    const monthIndex = _date.getMonth();
    const lastDayOfMonth = (0, $CS8DB.constructFrom)(date, 0);
    lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
    lastDayOfMonth.setHours(0, 0, 0, 0);
    return lastDayOfMonth.getDate();
}

});


parcelRegister("9N6zy", function(module, exports) {

$parcel$export(module.exports, "setQuarter", () => $720dc9cd007abe08$export$8924d1de7efe1755, (v) => $720dc9cd007abe08$export$8924d1de7efe1755 = v);
var $720dc9cd007abe08$export$8924d1de7efe1755;
"use strict";
$720dc9cd007abe08$export$8924d1de7efe1755 = $720dc9cd007abe08$var$setQuarter;

var $03Fkt = parcelRequire("03Fkt");

var $26OhI = parcelRequire("26OhI");
/**
 * @name setQuarter
 * @category Quarter Helpers
 * @summary Set the year quarter to the given date.
 *
 * @description
 * Set the year quarter to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param quarter - The quarter of the new date
 *
 * @returns The new date with the quarter set
 *
 * @example
 * // Set the 2nd quarter to 2 July 2014:
 * const result = setQuarter(new Date(2014, 6, 2), 2)
 * //=> Wed Apr 02 2014 00:00:00
 */ function $720dc9cd007abe08$var$setQuarter(date, quarter) {
    const _date = (0, $26OhI.toDate)(date);
    const oldQuarter = Math.trunc(_date.getMonth() / 3) + 1;
    const diff = quarter - oldQuarter;
    return (0, $03Fkt.setMonth)(_date, _date.getMonth() + diff * 3);
}

});

parcelRegister("h7pJ2", function(module, exports) {

$parcel$export(module.exports, "setYear", () => $c7670ba9617941bb$export$a8408b6c5639cab7, (v) => $c7670ba9617941bb$export$a8408b6c5639cab7 = v);
var $c7670ba9617941bb$export$a8408b6c5639cab7;
"use strict";
$c7670ba9617941bb$export$a8408b6c5639cab7 = $c7670ba9617941bb$var$setYear;

var $CS8DB = parcelRequire("CS8DB");

var $26OhI = parcelRequire("26OhI");
/**
 * @name setYear
 * @category Year Helpers
 * @summary Set the year to the given date.
 *
 * @description
 * Set the year to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param year - The year of the new date
 *
 * @returns The new date with the year set
 *
 * @example
 * // Set year 2013 to 1 September 2014:
 * const result = setYear(new Date(2014, 8, 1), 2013)
 * //=> Sun Sep 01 2013 00:00:00
 */ function $c7670ba9617941bb$var$setYear(date, year) {
    const _date = (0, $26OhI.toDate)(date);
    // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
    if (isNaN(+_date)) return (0, $CS8DB.constructFrom)(date, NaN);
    _date.setFullYear(year);
    return _date;
}

});

parcelRegister("hM1St", function(module, exports) {

$parcel$export(module.exports, "min", () => $cf08603905b46e77$export$96ec731ed4dcb222, (v) => $cf08603905b46e77$export$96ec731ed4dcb222 = v);
var $cf08603905b46e77$export$96ec731ed4dcb222;
"use strict";
$cf08603905b46e77$export$96ec731ed4dcb222 = $cf08603905b46e77$var$min;

var $26OhI = parcelRequire("26OhI");
/**
 * @name min
 * @category Common Helpers
 * @summary Returns the earliest of the given dates.
 *
 * @description
 * Returns the earliest of the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dates - The dates to compare
 *
 * @returns The earliest of the dates
 *
 * @example
 * // Which of these dates is the earliest?
 * const result = min([
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * ])
 * //=> Wed Feb 11 1987 00:00:00
 */ function $cf08603905b46e77$var$min(dates) {
    let result;
    dates.forEach((dirtyDate)=>{
        const date = (0, $26OhI.toDate)(dirtyDate);
        if (!result || result > date || isNaN(+date)) result = date;
    });
    return result || new Date(NaN);
}

});

parcelRegister("3Mprz", function(module, exports) {

$parcel$export(module.exports, "max", () => $2c099761b03e08fc$export$8960430cfd85939f, (v) => $2c099761b03e08fc$export$8960430cfd85939f = v);
var $2c099761b03e08fc$export$8960430cfd85939f;
"use strict";
$2c099761b03e08fc$export$8960430cfd85939f = $2c099761b03e08fc$var$max;

var $26OhI = parcelRequire("26OhI");
/**
 * @name max
 * @category Common Helpers
 * @summary Return the latest of the given dates.
 *
 * @description
 * Return the latest of the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dates - The dates to compare
 *
 * @returns The latest of the dates
 *
 * @example
 * // Which of these dates is the latest?
 * const result = max([
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * ])
 * //=> Sun Jul 02 1995 00:00:00
 */ function $2c099761b03e08fc$var$max(dates) {
    let result;
    dates.forEach(function(dirtyDate) {
        const currentDate = (0, $26OhI.toDate)(dirtyDate);
        if (result === undefined || result < currentDate || isNaN(Number(currentDate))) result = currentDate;
    });
    return result || new Date(NaN);
}

});

parcelRegister("lVxGX", function(module, exports) {

$parcel$export(module.exports, "differenceInCalendarMonths", () => $ff690e56fabbcc82$export$489984ac7c996389, (v) => $ff690e56fabbcc82$export$489984ac7c996389 = v);
var $ff690e56fabbcc82$export$489984ac7c996389;
"use strict";
$ff690e56fabbcc82$export$489984ac7c996389 = $ff690e56fabbcc82$var$differenceInCalendarMonths;

var $26OhI = parcelRequire("26OhI");
/**
 * @name differenceInCalendarMonths
 * @category Month Helpers
 * @summary Get the number of calendar months between the given dates.
 *
 * @description
 * Get the number of calendar months between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of calendar months
 *
 * @example
 * // How many calendar months are between 31 January 2014 and 1 September 2014?
 * const result = differenceInCalendarMonths(
 *   new Date(2014, 8, 1),
 *   new Date(2014, 0, 31)
 * )
 * //=> 8
 */ function $ff690e56fabbcc82$var$differenceInCalendarMonths(dateLeft, dateRight) {
    const _dateLeft = (0, $26OhI.toDate)(dateLeft);
    const _dateRight = (0, $26OhI.toDate)(dateRight);
    const yearDiff = _dateLeft.getFullYear() - _dateRight.getFullYear();
    const monthDiff = _dateLeft.getMonth() - _dateRight.getMonth();
    return yearDiff * 12 + monthDiff;
}

});

parcelRegister("4j185", function(module, exports) {

$parcel$export(module.exports, "differenceInCalendarYears", () => $3229d011d11613c3$export$c06dce8b38891685, (v) => $3229d011d11613c3$export$c06dce8b38891685 = v);
var $3229d011d11613c3$export$c06dce8b38891685;
"use strict";
$3229d011d11613c3$export$c06dce8b38891685 = $3229d011d11613c3$var$differenceInCalendarYears;

var $26OhI = parcelRequire("26OhI");
/**
 * @name differenceInCalendarYears
 * @category Year Helpers
 * @summary Get the number of calendar years between the given dates.
 *
 * @description
 * Get the number of calendar years between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date

 * @returns The number of calendar years
 *
 * @example
 * // How many calendar years are between 31 December 2013 and 11 February 2015?
 * const result = differenceInCalendarYears(
 *   new Date(2015, 1, 11),
 *   new Date(2013, 11, 31)
 * )
 * //=> 2
 */ function $3229d011d11613c3$var$differenceInCalendarYears(dateLeft, dateRight) {
    const _dateLeft = (0, $26OhI.toDate)(dateLeft);
    const _dateRight = (0, $26OhI.toDate)(dateRight);
    return _dateLeft.getFullYear() - _dateRight.getFullYear();
}

});

parcelRegister("2RSNs", function(module, exports) {

$parcel$export(module.exports, "differenceInCalendarQuarters", () => $216b097e2568e57e$export$f62ae9fb13958c7a, (v) => $216b097e2568e57e$export$f62ae9fb13958c7a = v);
var $216b097e2568e57e$export$f62ae9fb13958c7a;
"use strict";
$216b097e2568e57e$export$f62ae9fb13958c7a = $216b097e2568e57e$var$differenceInCalendarQuarters;

var $dQGvM = parcelRequire("dQGvM");

var $26OhI = parcelRequire("26OhI");
/**
 * @name differenceInCalendarQuarters
 * @category Quarter Helpers
 * @summary Get the number of calendar quarters between the given dates.
 *
 * @description
 * Get the number of calendar quarters between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date

 * @returns The number of calendar quarters
 *
 * @example
 * // How many calendar quarters are between 31 December 2013 and 2 July 2014?
 * const result = differenceInCalendarQuarters(
 *   new Date(2014, 6, 2),
 *   new Date(2013, 11, 31)
 * )
 * //=> 3
 */ function $216b097e2568e57e$var$differenceInCalendarQuarters(dateLeft, dateRight) {
    const _dateLeft = (0, $26OhI.toDate)(dateLeft);
    const _dateRight = (0, $26OhI.toDate)(dateRight);
    const yearDiff = _dateLeft.getFullYear() - _dateRight.getFullYear();
    const quarterDiff = (0, $dQGvM.getQuarter)(_dateLeft) - (0, $dQGvM.getQuarter)(_dateRight);
    return yearDiff * 4 + quarterDiff;
}

});

parcelRegister("biOJg", function(module, exports) {

$parcel$export(module.exports, "startOfMonth", () => $83a8b9e52f2b498e$export$a5a3b454ada2268e, (v) => $83a8b9e52f2b498e$export$a5a3b454ada2268e = v);
var $83a8b9e52f2b498e$export$a5a3b454ada2268e;
"use strict";
$83a8b9e52f2b498e$export$a5a3b454ada2268e = $83a8b9e52f2b498e$var$startOfMonth;

var $26OhI = parcelRequire("26OhI");
/**
 * @name startOfMonth
 * @category Month Helpers
 * @summary Return the start of a month for the given date.
 *
 * @description
 * Return the start of a month for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a month
 *
 * @example
 * // The start of a month for 2 September 2014 11:55:00:
 * const result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */ function $83a8b9e52f2b498e$var$startOfMonth(date) {
    const _date = (0, $26OhI.toDate)(date);
    _date.setDate(1);
    _date.setHours(0, 0, 0, 0);
    return _date;
}

});

parcelRegister("1c3d7", function(module, exports) {

$parcel$export(module.exports, "startOfQuarter", () => $0de966fd45fcd047$export$69be7267a042ecb3, (v) => $0de966fd45fcd047$export$69be7267a042ecb3 = v);
var $0de966fd45fcd047$export$69be7267a042ecb3;
"use strict";
$0de966fd45fcd047$export$69be7267a042ecb3 = $0de966fd45fcd047$var$startOfQuarter;

var $26OhI = parcelRequire("26OhI");
/**
 * @name startOfQuarter
 * @category Quarter Helpers
 * @summary Return the start of a year quarter for the given date.
 *
 * @description
 * Return the start of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a quarter
 *
 * @example
 * // The start of a quarter for 2 September 2014 11:55:00:
 * const result = startOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Jul 01 2014 00:00:00
 */ function $0de966fd45fcd047$var$startOfQuarter(date) {
    const _date = (0, $26OhI.toDate)(date);
    const currentMonth = _date.getMonth();
    const month = currentMonth - currentMonth % 3;
    _date.setMonth(month, 1);
    _date.setHours(0, 0, 0, 0);
    return _date;
}

});

parcelRegister("lU13w", function(module, exports) {

$parcel$export(module.exports, "endOfDay", () => $ff1fa59b68df2b88$export$eb9a03f0e9aa6cea, (v) => $ff1fa59b68df2b88$export$eb9a03f0e9aa6cea = v);
var $ff1fa59b68df2b88$export$eb9a03f0e9aa6cea;
"use strict";
$ff1fa59b68df2b88$export$eb9a03f0e9aa6cea = $ff1fa59b68df2b88$var$endOfDay;

var $26OhI = parcelRequire("26OhI");
/**
 * @name endOfDay
 * @category Day Helpers
 * @summary Return the end of a day for the given date.
 *
 * @description
 * Return the end of a day for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a day
 *
 * @example
 * // The end of a day for 2 September 2014 11:55:00:
 * const result = endOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 23:59:59.999
 */ function $ff1fa59b68df2b88$var$endOfDay(date) {
    const _date = (0, $26OhI.toDate)(date);
    _date.setHours(23, 59, 59, 999);
    return _date;
}

});

parcelRegister("eKR0J", function(module, exports) {

$parcel$export(module.exports, "endOfWeek", () => $abde7b657d9f02cf$export$ef8b6d9133084f4e, (v) => $abde7b657d9f02cf$export$ef8b6d9133084f4e = v);
var $abde7b657d9f02cf$export$ef8b6d9133084f4e;
"use strict";
$abde7b657d9f02cf$export$ef8b6d9133084f4e = $abde7b657d9f02cf$var$endOfWeek;

var $26OhI = parcelRequire("26OhI");

var $2Hkrd = parcelRequire("2Hkrd");
/**
 * The {@link endOfWeek} function options.
 */ /**
 * @name endOfWeek
 * @category Week Helpers
 * @summary Return the end of a week for the given date.
 *
 * @description
 * Return the end of a week for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The end of a week
 *
 * @example
 * // The end of a week for 2 September 2014 11:55:00:
 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sat Sep 06 2014 23:59:59.999
 *
 * @example
 * // If the week starts on Monday, the end of the week for 2 September 2014 11:55:00:
 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Sun Sep 07 2014 23:59:59.999
 */ function $abde7b657d9f02cf$var$endOfWeek(date, options) {
    const defaultOptions = (0, $2Hkrd.getDefaultOptions)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, $26OhI.toDate)(date);
    const day = _date.getDay();
    const diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
    _date.setDate(_date.getDate() + diff);
    _date.setHours(23, 59, 59, 999);
    return _date;
}

});

parcelRegister("3pk6v", function(module, exports) {

$parcel$export(module.exports, "endOfMonth", () => $27b34d1da7260f1f$export$a2258d9c4118825c, (v) => $27b34d1da7260f1f$export$a2258d9c4118825c = v);
var $27b34d1da7260f1f$export$a2258d9c4118825c;
"use strict";
$27b34d1da7260f1f$export$a2258d9c4118825c = $27b34d1da7260f1f$var$endOfMonth;

var $26OhI = parcelRequire("26OhI");
/**
 * @name endOfMonth
 * @category Month Helpers
 * @summary Return the end of a month for the given date.
 *
 * @description
 * Return the end of a month for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a month
 *
 * @example
 * // The end of a month for 2 September 2014 11:55:00:
 * const result = endOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */ function $27b34d1da7260f1f$var$endOfMonth(date) {
    const _date = (0, $26OhI.toDate)(date);
    const month = _date.getMonth();
    _date.setFullYear(_date.getFullYear(), month + 1, 0);
    _date.setHours(23, 59, 59, 999);
    return _date;
}

});

parcelRegister("igoTU", function(module, exports) {

$parcel$export(module.exports, "endOfYear", () => $d4bd0966f4f23b53$export$8b7aa55c66d5569e, (v) => $d4bd0966f4f23b53$export$8b7aa55c66d5569e = v);
var $d4bd0966f4f23b53$export$8b7aa55c66d5569e;
"use strict";
$d4bd0966f4f23b53$export$8b7aa55c66d5569e = $d4bd0966f4f23b53$var$endOfYear;

var $26OhI = parcelRequire("26OhI");
/**
 * @name endOfYear
 * @category Year Helpers
 * @summary Return the end of a year for the given date.
 *
 * @description
 * Return the end of a year for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a year
 *
 * @example
 * // The end of a year for 2 September 2014 11:55:00:
 * const result = endOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Dec 31 2014 23:59:59.999
 */ function $d4bd0966f4f23b53$var$endOfYear(date) {
    const _date = (0, $26OhI.toDate)(date);
    const year = _date.getFullYear();
    _date.setFullYear(year + 1, 0, 0);
    _date.setHours(23, 59, 59, 999);
    return _date;
}

});

parcelRegister("36H1l", function(module, exports) {

$parcel$export(module.exports, "isEqual", () => $24334da7cfa5c47c$export$248d38f6296296c5, (v) => $24334da7cfa5c47c$export$248d38f6296296c5 = v);
var $24334da7cfa5c47c$export$248d38f6296296c5;
"use strict";
$24334da7cfa5c47c$export$248d38f6296296c5 = $24334da7cfa5c47c$var$isEqual;

var $26OhI = parcelRequire("26OhI");
/**
 * @name isEqual
 * @category Common Helpers
 * @summary Are the given dates equal?
 *
 * @description
 * Are the given dates equal?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to compare
 * @param dateRight - The second date to compare
 *
 * @returns The dates are equal
 *
 * @example
 * // Are 2 July 2014 06:30:45.000 and 2 July 2014 06:30:45.500 equal?
 * const result = isEqual(
 *   new Date(2014, 6, 2, 6, 30, 45, 0),
 *   new Date(2014, 6, 2, 6, 30, 45, 500)
 * )
 * //=> false
 */ function $24334da7cfa5c47c$var$isEqual(leftDate, rightDate) {
    const _dateLeft = (0, $26OhI.toDate)(leftDate);
    const _dateRight = (0, $26OhI.toDate)(rightDate);
    return +_dateLeft === +_dateRight;
}

});

parcelRegister("iROfp", function(module, exports) {

$parcel$export(module.exports, "isSameDay", () => $dbc42759d51aedf6$export$ea39ec197993aef0, (v) => $dbc42759d51aedf6$export$ea39ec197993aef0 = v);
var $dbc42759d51aedf6$export$ea39ec197993aef0;
"use strict";
$dbc42759d51aedf6$export$ea39ec197993aef0 = $dbc42759d51aedf6$var$isSameDay;

var $lPouQ = parcelRequire("lPouQ");
/**
 * @name isSameDay
 * @category Day Helpers
 * @summary Are the given dates in the same day (and year and month)?
 *
 * @description
 * Are the given dates in the same day (and year and month)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check

 * @returns The dates are in the same day (and year and month)
 *
 * @example
 * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
 * const result = isSameDay(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 18, 0))
 * //=> true
 *
 * @example
 * // Are 4 September and 4 October in the same day?
 * const result = isSameDay(new Date(2014, 8, 4), new Date(2014, 9, 4))
 * //=> false
 *
 * @example
 * // Are 4 September, 2014 and 4 September, 2015 in the same day?
 * const result = isSameDay(new Date(2014, 8, 4), new Date(2015, 8, 4))
 * //=> false
 */ function $dbc42759d51aedf6$var$isSameDay(dateLeft, dateRight) {
    const dateLeftStartOfDay = (0, $lPouQ.startOfDay)(dateLeft);
    const dateRightStartOfDay = (0, $lPouQ.startOfDay)(dateRight);
    return +dateLeftStartOfDay === +dateRightStartOfDay;
}

});

parcelRegister("4q5v8", function(module, exports) {

$parcel$export(module.exports, "isSameMonth", () => $337ddb8af7a9c10e$export$a18c89cbd24170ff, (v) => $337ddb8af7a9c10e$export$a18c89cbd24170ff = v);
var $337ddb8af7a9c10e$export$a18c89cbd24170ff;
"use strict";
$337ddb8af7a9c10e$export$a18c89cbd24170ff = $337ddb8af7a9c10e$var$isSameMonth;

var $26OhI = parcelRequire("26OhI");
/**
 * @name isSameMonth
 * @category Month Helpers
 * @summary Are the given dates in the same month (and year)?
 *
 * @description
 * Are the given dates in the same month (and year)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same month (and year)
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same month?
 * const result = isSameMonth(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 *
 * @example
 * // Are 2 September 2014 and 25 September 2015 in the same month?
 * const result = isSameMonth(new Date(2014, 8, 2), new Date(2015, 8, 25))
 * //=> false
 */ function $337ddb8af7a9c10e$var$isSameMonth(dateLeft, dateRight) {
    const _dateLeft = (0, $26OhI.toDate)(dateLeft);
    const _dateRight = (0, $26OhI.toDate)(dateRight);
    return _dateLeft.getFullYear() === _dateRight.getFullYear() && _dateLeft.getMonth() === _dateRight.getMonth();
}

});

parcelRegister("jjrXQ", function(module, exports) {

$parcel$export(module.exports, "isSameYear", () => $e0f57bcc752425aa$export$5841f9eb9773f25f, (v) => $e0f57bcc752425aa$export$5841f9eb9773f25f = v);
var $e0f57bcc752425aa$export$5841f9eb9773f25f;
"use strict";
$e0f57bcc752425aa$export$5841f9eb9773f25f = $e0f57bcc752425aa$var$isSameYear;

var $26OhI = parcelRequire("26OhI");
/**
 * @name isSameYear
 * @category Year Helpers
 * @summary Are the given dates in the same year?
 *
 * @description
 * Are the given dates in the same year?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same year
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same year?
 * const result = isSameYear(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 */ function $e0f57bcc752425aa$var$isSameYear(dateLeft, dateRight) {
    const _dateLeft = (0, $26OhI.toDate)(dateLeft);
    const _dateRight = (0, $26OhI.toDate)(dateRight);
    return _dateLeft.getFullYear() === _dateRight.getFullYear();
}

});

parcelRegister("gjoJZ", function(module, exports) {

$parcel$export(module.exports, "isSameQuarter", () => $be019cb10ad2c111$export$5c60e4190867161c, (v) => $be019cb10ad2c111$export$5c60e4190867161c = v);
var $be019cb10ad2c111$export$5c60e4190867161c;
"use strict";
$be019cb10ad2c111$export$5c60e4190867161c = $be019cb10ad2c111$var$isSameQuarter;

var $1c3d7 = parcelRequire("1c3d7");
/**
 * @name isSameQuarter
 * @category Quarter Helpers
 * @summary Are the given dates in the same quarter (and year)?
 *
 * @description
 * Are the given dates in the same quarter (and year)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check

 * @returns The dates are in the same quarter (and year)
 *
 * @example
 * // Are 1 January 2014 and 8 March 2014 in the same quarter?
 * const result = isSameQuarter(new Date(2014, 0, 1), new Date(2014, 2, 8))
 * //=> true
 *
 * @example
 * // Are 1 January 2014 and 1 January 2015 in the same quarter?
 * const result = isSameQuarter(new Date(2014, 0, 1), new Date(2015, 0, 1))
 * //=> false
 */ function $be019cb10ad2c111$var$isSameQuarter(dateLeft, dateRight) {
    const dateLeftStartOfQuarter = (0, $1c3d7.startOfQuarter)(dateLeft);
    const dateRightStartOfQuarter = (0, $1c3d7.startOfQuarter)(dateRight);
    return +dateLeftStartOfQuarter === +dateRightStartOfQuarter;
}

});

parcelRegister("3MRYq", function(module, exports) {

$parcel$export(module.exports, "isAfter", () => $2c1fb8d2abbc28ca$export$e4de839670987035, (v) => $2c1fb8d2abbc28ca$export$e4de839670987035 = v);
var $2c1fb8d2abbc28ca$export$e4de839670987035;
"use strict";
$2c1fb8d2abbc28ca$export$e4de839670987035 = $2c1fb8d2abbc28ca$var$isAfter;

var $26OhI = parcelRequire("26OhI");
/**
 * @name isAfter
 * @category Common Helpers
 * @summary Is the first date after the second one?
 *
 * @description
 * Is the first date after the second one?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date that should be after the other one to return true
 * @param dateToCompare - The date to compare with
 *
 * @returns The first date is after the second date
 *
 * @example
 * // Is 10 July 1989 after 11 February 1987?
 * const result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> true
 */ function $2c1fb8d2abbc28ca$var$isAfter(date, dateToCompare) {
    const _date = (0, $26OhI.toDate)(date);
    const _dateToCompare = (0, $26OhI.toDate)(dateToCompare);
    return _date.getTime() > _dateToCompare.getTime();
}

});

parcelRegister("4t8V5", function(module, exports) {

$parcel$export(module.exports, "isBefore", () => $3410ca2735e20708$export$5c007e10c6929c95, (v) => $3410ca2735e20708$export$5c007e10c6929c95 = v);
var $3410ca2735e20708$export$5c007e10c6929c95;
"use strict";
$3410ca2735e20708$export$5c007e10c6929c95 = $3410ca2735e20708$var$isBefore;

var $26OhI = parcelRequire("26OhI");
/**
 * @name isBefore
 * @category Common Helpers
 * @summary Is the first date before the second one?
 *
 * @description
 * Is the first date before the second one?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date that should be before the other one to return true
 * @param dateToCompare - The date to compare with
 *
 * @returns The first date is before the second date
 *
 * @example
 * // Is 10 July 1989 before 11 February 1987?
 * const result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> false
 */ function $3410ca2735e20708$var$isBefore(date, dateToCompare) {
    const _date = (0, $26OhI.toDate)(date);
    const _dateToCompare = (0, $26OhI.toDate)(dateToCompare);
    return +_date < +_dateToCompare;
}

});

parcelRegister("1PA9H", function(module, exports) {

$parcel$export(module.exports, "isWithinInterval", () => $155699927cfedeff$export$d7deef7a3738e19d, (v) => $155699927cfedeff$export$d7deef7a3738e19d = v);
var $155699927cfedeff$export$d7deef7a3738e19d;
"use strict";
$155699927cfedeff$export$d7deef7a3738e19d = $155699927cfedeff$var$isWithinInterval;

var $26OhI = parcelRequire("26OhI");
/**
 * @name isWithinInterval
 * @category Interval Helpers
 * @summary Is the given date within the interval?
 *
 * @description
 * Is the given date within the interval? (Including start and end.)
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 * @param interval - The interval to check
 *
 * @returns The date is within the interval
 *
 * @example
 * // For the date within the interval:
 * isWithinInterval(new Date(2014, 0, 3), {
 *   start: new Date(2014, 0, 1),
 *   end: new Date(2014, 0, 7)
 * })
 * //=> true
 *
 * @example
 * // For the date outside of the interval:
 * isWithinInterval(new Date(2014, 0, 10), {
 *   start: new Date(2014, 0, 1),
 *   end: new Date(2014, 0, 7)
 * })
 * //=> false
 *
 * @example
 * // For date equal to interval start:
 * isWithinInterval(date, { start, end: date })
 * // => true
 *
 * @example
 * // For date equal to interval end:
 * isWithinInterval(date, { start: date, end })
 * // => true
 */ function $155699927cfedeff$var$isWithinInterval(date, interval) {
    const time = +(0, $26OhI.toDate)(date);
    const [startTime, endTime] = [
        +(0, $26OhI.toDate)(interval.start),
        +(0, $26OhI.toDate)(interval.end)
    ].sort((a, b)=>a - b);
    return time >= startTime && time <= endTime;
}

});

parcelRegister("foHqe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "longFormatters", {
    enumerable: true,
    get: function() {
        return $i59tm.longFormatters;
    }
});
module.exports.parse = $b35ac79d45034579$var$parse;
Object.defineProperty(module.exports, "parsers", {
    enumerable: true,
    get: function() {
        return $33vSp.parsers;
    }
});

var $CS8DB = parcelRequire("CS8DB");

var $eG9SL = parcelRequire("eG9SL");

var $7JvkD = parcelRequire("7JvkD");

var $26OhI = parcelRequire("26OhI");

var $i59tm = parcelRequire("i59tm");

var $eKdof = parcelRequire("eKdof");

var $33vSp = parcelRequire("33vSp");

var $i1FxJ = parcelRequire("i1FxJ");
// Rexports of internal for libraries to use.
// See: https://github.com/date-fns/date-fns/issues/3638#issuecomment-1877082874
/**
 * The {@link parse} function options.
 */ // This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const $b35ac79d45034579$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
const $b35ac79d45034579$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
const $b35ac79d45034579$var$escapedStringRegExp = /^'([^]*?)'?$/;
const $b35ac79d45034579$var$doubleQuoteRegExp = /''/g;
const $b35ac79d45034579$var$notWhitespaceRegExp = /\S/;
const $b35ac79d45034579$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @name parse
 * @category Common Helpers
 * @summary Parse the date.
 *
 * @description
 * Return the date parsed from string using the given format string.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters in the format string wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 *
 * Format of the format string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 5 below the table).
 *
 * Not all tokens are compatible. Combinations that don't make sense or could lead to bugs are prohibited
 * and will throw `RangeError`. For example usage of 24-hour format token with AM/PM token will throw an exception:
 *
 * ```javascript
 * parse('23 AM', 'HH a', new Date())
 * //=> RangeError: The format string mustn't contain `HH` and `a` at the same time
 * ```
 *
 * See the compatibility table: https://docs.google.com/spreadsheets/d/e/2PACX-1vQOPU3xUhplll6dyoMmVUXHKl_8CRDs6_ueLmex3SoqwhuolkuN3O05l4rqx5h1dKX8eb46Ul-CCSrq/pubhtml?gid=0&single=true
 *
 * Accepted format string patterns:
 * | Unit                            |Prior| Pattern | Result examples                   | Notes |
 * |---------------------------------|-----|---------|-----------------------------------|-------|
 * | Era                             | 140 | G..GGG  | AD, BC                            |       |
 * |                                 |     | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 |     | GGGGG   | A, B                              |       |
 * | Calendar year                   | 130 | y       | 44, 1, 1900, 2017, 9999           | 4     |
 * |                                 |     | yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | yy      | 44, 01, 00, 17                    | 4     |
 * |                                 |     | yyy     | 044, 001, 123, 999                | 4     |
 * |                                 |     | yyyy    | 0044, 0001, 1900, 2017            | 4     |
 * |                                 |     | yyyyy   | ...                               | 2,4   |
 * | Local week-numbering year       | 130 | Y       | 44, 1, 1900, 2017, 9000           | 4     |
 * |                                 |     | Yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | YY      | 44, 01, 00, 17                    | 4,6   |
 * |                                 |     | YYY     | 044, 001, 123, 999                | 4     |
 * |                                 |     | YYYY    | 0044, 0001, 1900, 2017            | 4,6   |
 * |                                 |     | YYYYY   | ...                               | 2,4   |
 * | ISO week-numbering year         | 130 | R       | -43, 1, 1900, 2017, 9999, -9999   | 4,5   |
 * |                                 |     | RR      | -43, 01, 00, 17                   | 4,5   |
 * |                                 |     | RRR     | -043, 001, 123, 999, -999         | 4,5   |
 * |                                 |     | RRRR    | -0043, 0001, 2017, 9999, -9999    | 4,5   |
 * |                                 |     | RRRRR   | ...                               | 2,4,5 |
 * | Extended year                   | 130 | u       | -43, 1, 1900, 2017, 9999, -999    | 4     |
 * |                                 |     | uu      | -43, 01, 99, -99                  | 4     |
 * |                                 |     | uuu     | -043, 001, 123, 999, -999         | 4     |
 * |                                 |     | uuuu    | -0043, 0001, 2017, 9999, -9999    | 4     |
 * |                                 |     | uuuuu   | ...                               | 2,4   |
 * | Quarter (formatting)            | 120 | Q       | 1, 2, 3, 4                        |       |
 * |                                 |     | Qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | QQ      | 01, 02, 03, 04                    |       |
 * |                                 |     | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | 120 | q       | 1, 2, 3, 4                        |       |
 * |                                 |     | qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | qq      | 01, 02, 03, 04                    |       |
 * |                                 |     | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | qqqqq   | 1, 2, 3, 4                        | 3     |
 * | Month (formatting)              | 110 | M       | 1, 2, ..., 12                     |       |
 * |                                 |     | Mo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | MM      | 01, 02, ..., 12                   |       |
 * |                                 |     | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | MMMM    | January, February, ..., December  | 2     |
 * |                                 |     | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | 110 | L       | 1, 2, ..., 12                     |       |
 * |                                 |     | Lo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | LL      | 01, 02, ..., 12                   |       |
 * |                                 |     | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | LLLL    | January, February, ..., December  | 2     |
 * |                                 |     | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | 100 | w       | 1, 2, ..., 53                     |       |
 * |                                 |     | wo      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | 100 | I       | 1, 2, ..., 53                     | 5     |
 * |                                 |     | Io      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | II      | 01, 02, ..., 53                   | 5     |
 * | Day of month                    |  90 | d       | 1, 2, ..., 31                     |       |
 * |                                 |     | do      | 1st, 2nd, ..., 31st               | 5     |
 * |                                 |     | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     |  90 | D       | 1, 2, ..., 365, 366               | 7     |
 * |                                 |     | Do      | 1st, 2nd, ..., 365th, 366th       | 5     |
 * |                                 |     | DD      | 01, 02, ..., 365, 366             | 7     |
 * |                                 |     | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 |     | DDDD    | ...                               | 2     |
 * | Day of week (formatting)        |  90 | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 |     | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    |  90 | i       | 1, 2, 3, ..., 7                   | 5     |
 * |                                 |     | io      | 1st, 2nd, ..., 7th                | 5     |
 * |                                 |     | ii      | 01, 02, ..., 07                   | 5     |
 * |                                 |     | iii     | Mon, Tue, Wed, ..., Sun           | 5     |
 * |                                 |     | iiii    | Monday, Tuesday, ..., Sunday      | 2,5   |
 * |                                 |     | iiiii   | M, T, W, T, F, S, S               | 5     |
 * |                                 |     | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 5     |
 * | Local day of week (formatting)  |  90 | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | eo      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | ee      | 02, 03, ..., 01                   |       |
 * |                                 |     | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 |     | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) |  90 | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | co      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | cc      | 02, 03, ..., 01                   |       |
 * |                                 |     | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 |     | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          |  80 | a..aaa  | AM, PM                            |       |
 * |                                 |     | aaaa    | a.m., p.m.                        | 2     |
 * |                                 |     | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          |  80 | b..bbb  | AM, PM, noon, midnight            |       |
 * |                                 |     | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 |     | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             |  80 | B..BBB  | at night, in the morning, ...     |       |
 * |                                 |     | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 |     | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     |  70 | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 |     | ho      | 1st, 2nd, ..., 11th, 12th         | 5     |
 * |                                 |     | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     |  70 | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 |     | Ho      | 0th, 1st, 2nd, ..., 23rd          | 5     |
 * |                                 |     | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     |  70 | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 |     | Ko      | 1st, 2nd, ..., 11th, 0th          | 5     |
 * |                                 |     | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     |  70 | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 |     | ko      | 24th, 1st, 2nd, ..., 23rd         | 5     |
 * |                                 |     | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          |  60 | m       | 0, 1, ..., 59                     |       |
 * |                                 |     | mo      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | mm      | 00, 01, ..., 59                   |       |
 * | Second                          |  50 | s       | 0, 1, ..., 59                     |       |
 * |                                 |     | so      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | ss      | 00, 01, ..., 59                   |       |
 * | Seconds timestamp               |  40 | t       | 512969520                         |       |
 * |                                 |     | tt      | ...                               | 2     |
 * | Fraction of second              |  30 | S       | 0, 1, ..., 9                      |       |
 * |                                 |     | SS      | 00, 01, ..., 99                   |       |
 * |                                 |     | SSS     | 000, 001, ..., 999                |       |
 * |                                 |     | SSSS    | ...                               | 2     |
 * | Milliseconds timestamp          |  20 | T       | 512969520900                      |       |
 * |                                 |     | TT      | ...                               | 2     |
 * | Timezone (ISO-8601 w/ Z)        |  10 | X       | -08, +0530, Z                     |       |
 * |                                 |     | XX      | -0800, +0530, Z                   |       |
 * |                                 |     | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 |     | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 |     | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       |  10 | x       | -08, +0530, +00                   |       |
 * |                                 |     | xx      | -0800, +0530, +0000               |       |
 * |                                 |     | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 |     | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 |     | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Long localized date             |  NA | P       | 05/29/1453                        | 5,8   |
 * |                                 |     | PP      | May 29, 1453                      |       |
 * |                                 |     | PPP     | May 29th, 1453                    |       |
 * |                                 |     | PPPP    | Sunday, May 29th, 1453            | 2,5,8 |
 * | Long localized time             |  NA | p       | 12:00 AM                          | 5,8   |
 * |                                 |     | pp      | 12:00:00 AM                       |       |
 * | Combination of date and time    |  NA | Pp      | 05/29/1453, 12:00 AM              |       |
 * |                                 |     | PPpp    | May 29, 1453, 12:00:00 AM         |       |
 * |                                 |     | PPPpp   | May 29th, 1453 at ...             |       |
 * |                                 |     | PPPPpp  | Sunday, May 29th, 1453 at ...     | 2,5,8 |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular.
 *    In `format` function, they will produce different result:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 *    `parse` will try to match both formatting and stand-alone units interchangably.
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table:
 *    - for numerical units (`yyyyyyyy`) `parse` will try to match a number
 *      as wide as the sequence
 *    - for text units (`MMMMMMMM`) `parse` will try to match the widest variation of the unit.
 *      These variations are marked with "2" in the last column of the table.
 *
 * 3. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 4. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` will try to guess the century of two digit year by proximity with `referenceDate`:
 *
 *    `parse('50', 'yy', new Date(2018, 0, 1)) //=> Sat Jan 01 2050 00:00:00`
 *
 *    `parse('75', 'yy', new Date(2018, 0, 1)) //=> Wed Jan 01 1975 00:00:00`
 *
 *    while `uu` will just assign the year as is:
 *
 *    `parse('50', 'uu', new Date(2018, 0, 1)) //=> Sat Jan 01 0050 00:00:00`
 *
 *    `parse('75', 'uu', new Date(2018, 0, 1)) //=> Tue Jan 01 0075 00:00:00`
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [setISOWeekYear](https://date-fns.org/docs/setISOWeekYear)
 *    and [setWeekYear](https://date-fns.org/docs/setWeekYear)).
 *
 * 5. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 6. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 7. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 8. `P+` tokens do not have a defined priority since they are merely aliases to other tokens based
 *    on the given locale.
 *
 *    using `en-US` locale: `P` => `MM/dd/yyyy`
 *    using `en-US` locale: `p` => `hh:mm a`
 *    using `pt-BR` locale: `P` => `dd/MM/yyyy`
 *    using `pt-BR` locale: `p` => `HH:mm`
 *
 * Values will be assigned to the date in the descending order of its unit's priority.
 * Units of an equal priority overwrite each other in the order of appearance.
 *
 * If no values of higher priority are parsed (e.g. when parsing string 'January 1st' without a year),
 * the values will be taken from 3rd argument `referenceDate` which works as a context of parsing.
 *
 * `referenceDate` must be passed for correct work of the function.
 * If you're not sure which `referenceDate` to supply, create a new instance of Date:
 * `parse('02/11/2014', 'MM/dd/yyyy', new Date())`
 * In this case parsing will be done in the context of the current date.
 * If `referenceDate` is `Invalid Date` or a value not convertible to valid `Date`,
 * then `Invalid Date` will be returned.
 *
 * The result may vary by locale.
 *
 * If `formatString` matches with `dateString` but does not provides tokens, `referenceDate` will be returned.
 *
 * If parsing failed, `Invalid Date` will be returned.
 * Invalid Date is a Date, whose time value is NaN.
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateStr - The string to parse
 * @param formatStr - The string of tokens
 * @param referenceDate - defines values missing from the parsed dateString
 * @param options - An object with options.
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @returns The parsed date
 *
 * @throws `options.locale` must contain `match` property
 * @throws use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws format string contains an unescaped latin alphabet character
 *
 * @example
 * // Parse 11 February 2014 from middle-endian format:
 * var result = parse('02/11/2014', 'MM/dd/yyyy', new Date())
 * //=> Tue Feb 11 2014 00:00:00
 *
 * @example
 * // Parse 28th of February in Esperanto locale in the context of 2010 year:
 * import eo from 'date-fns/locale/eo'
 * var result = parse('28-a de februaro', "do 'de' MMMM", new Date(2010, 0, 1), {
 *   locale: eo
 * })
 * //=> Sun Feb 28 2010 00:00:00
 */ function $b35ac79d45034579$var$parse(dateStr, formatStr, referenceDate, options) {
    const defaultOptions = (0, $eG9SL.getDefaultOptions)();
    const locale = options?.locale ?? defaultOptions.locale ?? $7JvkD.enUS;
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    if (formatStr === "") {
        if (dateStr === "") return (0, $26OhI.toDate)(referenceDate);
        else return (0, $CS8DB.constructFrom)(referenceDate, NaN);
    }
    const subFnOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    // If timezone isn't specified, it will be set to the system timezone
    const setters = [
        new $i1FxJ.DateToSystemTimezoneSetter()
    ];
    const tokens = formatStr.match($b35ac79d45034579$var$longFormattingTokensRegExp).map((substring)=>{
        const firstCharacter = substring[0];
        if (firstCharacter in $i59tm.longFormatters) {
            const longFormatter = $i59tm.longFormatters[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($b35ac79d45034579$var$formattingTokensRegExp);
    const usedTokens = [];
    for (let token of tokens){
        if (!options?.useAdditionalWeekYearTokens && (0, $eKdof.isProtectedWeekYearToken)(token)) (0, $eKdof.warnOrThrowProtectedError)(token, formatStr, dateStr);
        if (!options?.useAdditionalDayOfYearTokens && (0, $eKdof.isProtectedDayOfYearToken)(token)) (0, $eKdof.warnOrThrowProtectedError)(token, formatStr, dateStr);
        const firstCharacter = token[0];
        const parser = $33vSp.parsers[firstCharacter];
        if (parser) {
            const { incompatibleTokens: incompatibleTokens } = parser;
            if (Array.isArray(incompatibleTokens)) {
                const incompatibleToken = usedTokens.find((usedToken)=>incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter);
                if (incompatibleToken) throw new RangeError(`The format string mustn't contain \`${incompatibleToken.fullToken}\` and \`${token}\` at the same time`);
            } else if (parser.incompatibleTokens === "*" && usedTokens.length > 0) throw new RangeError(`The format string mustn't contain \`${token}\` and any other token at the same time`);
            usedTokens.push({
                token: firstCharacter,
                fullToken: token
            });
            const parseResult = parser.run(dateStr, token, locale.match, subFnOptions);
            if (!parseResult) return (0, $CS8DB.constructFrom)(referenceDate, NaN);
            setters.push(parseResult.setter);
            dateStr = parseResult.rest;
        } else {
            if (firstCharacter.match($b35ac79d45034579$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
            // Replace two single quote characters with one single quote character
            if (token === "''") token = "'";
            else if (firstCharacter === "'") token = $b35ac79d45034579$var$cleanEscapedString(token);
            // Cut token from string, or, if string doesn't match the token, return Invalid Date
            if (dateStr.indexOf(token) === 0) dateStr = dateStr.slice(token.length);
            else return (0, $CS8DB.constructFrom)(referenceDate, NaN);
        }
    }
    // Check if the remaining input contains something other than whitespace
    if (dateStr.length > 0 && $b35ac79d45034579$var$notWhitespaceRegExp.test(dateStr)) return (0, $CS8DB.constructFrom)(referenceDate, NaN);
    const uniquePrioritySetters = setters.map((setter)=>setter.priority).sort((a, b)=>b - a).filter((priority, index, array)=>array.indexOf(priority) === index).map((priority)=>setters.filter((setter)=>setter.priority === priority).sort((a, b)=>b.subPriority - a.subPriority)).map((setterArray)=>setterArray[0]);
    let date = (0, $26OhI.toDate)(referenceDate);
    if (isNaN(date.getTime())) return (0, $CS8DB.constructFrom)(referenceDate, NaN);
    const flags = {};
    for (const setter of uniquePrioritySetters){
        if (!setter.validate(date, subFnOptions)) return (0, $CS8DB.constructFrom)(referenceDate, NaN);
        const result = setter.set(date, flags, subFnOptions);
        // Result is tuple (date, flags)
        if (Array.isArray(result)) {
            date = result[0];
            Object.assign(flags, result[1]);
        // Result is date
        } else date = result;
    }
    return (0, $CS8DB.constructFrom)(referenceDate, date);
}
function $b35ac79d45034579$var$cleanEscapedString(input) {
    return input.match($b35ac79d45034579$var$escapedStringRegExp)[1].replace($b35ac79d45034579$var$doubleQuoteRegExp, "'");
}

});
parcelRegister("eG9SL", function(module, exports) {

$parcel$export(module.exports, "getDefaultOptions", () => $aafca755ad1ad352$export$430a3269e24b912e, (v) => $aafca755ad1ad352$export$430a3269e24b912e = v);
var $aafca755ad1ad352$export$430a3269e24b912e;
"use strict";
$aafca755ad1ad352$export$430a3269e24b912e = $aafca755ad1ad352$var$getDefaultOptions;

var $2Hkrd = parcelRequire("2Hkrd");
/**
 * @name getDefaultOptions
 * @category Common Helpers
 * @summary Get default options.
 * @pure false
 *
 * @description
 * Returns an object that contains defaults for
 * `options.locale`, `options.weekStartsOn` and `options.firstWeekContainsDate`
 * arguments for all functions.
 *
 * You can change these with [setDefaultOptions](https://date-fns.org/docs/setDefaultOptions).
 *
 * @returns The default options
 *
 * @example
 * const result = getDefaultOptions()
 * //=> {}
 *
 * @example
 * setDefaultOptions({ weekStarsOn: 1, firstWeekContainsDate: 4 })
 * const result = getDefaultOptions()
 * //=> { weekStarsOn: 1, firstWeekContainsDate: 4 }
 */ function $aafca755ad1ad352$var$getDefaultOptions() {
    return Object.assign({}, (0, $2Hkrd.getDefaultOptions)());
}

});

parcelRegister("33vSp", function(module, exports) {

$parcel$export(module.exports, "parsers", () => $239a60f2375e9b28$export$19131010e7fd8373, (v) => $239a60f2375e9b28$export$19131010e7fd8373 = v);
var $239a60f2375e9b28$export$19131010e7fd8373;
"use strict";
$239a60f2375e9b28$export$19131010e7fd8373 = void 0;

var $iTmio = parcelRequire("iTmio");

var $esPnD = parcelRequire("esPnD");

var $5QJtv = parcelRequire("5QJtv");

var $kVhtF = parcelRequire("kVhtF");

var $hCn2H = parcelRequire("hCn2H");

var $4wlhx = parcelRequire("4wlhx");

var $8kj1l = parcelRequire("8kj1l");

var $hv4V6 = parcelRequire("hv4V6");

var $dHuAC = parcelRequire("dHuAC");

var $2ZRWX = parcelRequire("2ZRWX");

var $loV88 = parcelRequire("loV88");

var $hFFWH = parcelRequire("hFFWH");

var $iuSAz = parcelRequire("iuSAz");

var $OVGmw = parcelRequire("OVGmw");

var $eQBWA = parcelRequire("eQBWA");

var $6uMdG = parcelRequire("6uMdG");

var $1qTW4 = parcelRequire("1qTW4");

var $apysC = parcelRequire("apysC");

var $e9kyt = parcelRequire("e9kyt");

var $c5rcE = parcelRequire("c5rcE");

var $1khXI = parcelRequire("1khXI");

var $hxUWF = parcelRequire("hxUWF");

var $2rm29 = parcelRequire("2rm29");

var $iFGxC = parcelRequire("iFGxC");

var $aXnGy = parcelRequire("aXnGy");

var $1Y8Y8 = parcelRequire("1Y8Y8");

var $ddQQF = parcelRequire("ddQQF");

var $9cgbN = parcelRequire("9cgbN");

var $aP8X6 = parcelRequire("aP8X6");

var $lQArz = parcelRequire("lQArz");

var $4QCDZ = parcelRequire("4QCDZ");
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O* | Timezone (GMT)                 |
 * |  p  |                                |  P  |                                |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z* | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `parse` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any -- It's ok, we want any here
const $239a60f2375e9b28$var$parsers = $239a60f2375e9b28$export$19131010e7fd8373 = {
    G: new $iTmio.EraParser(),
    y: new $esPnD.YearParser(),
    Y: new $5QJtv.LocalWeekYearParser(),
    R: new $kVhtF.ISOWeekYearParser(),
    u: new $hCn2H.ExtendedYearParser(),
    Q: new $4wlhx.QuarterParser(),
    q: new $8kj1l.StandAloneQuarterParser(),
    M: new $hv4V6.MonthParser(),
    L: new $dHuAC.StandAloneMonthParser(),
    w: new $2ZRWX.LocalWeekParser(),
    I: new $loV88.ISOWeekParser(),
    d: new $hFFWH.DateParser(),
    D: new $iuSAz.DayOfYearParser(),
    E: new $OVGmw.DayParser(),
    e: new $eQBWA.LocalDayParser(),
    c: new $6uMdG.StandAloneLocalDayParser(),
    i: new $1qTW4.ISODayParser(),
    a: new $apysC.AMPMParser(),
    b: new $e9kyt.AMPMMidnightParser(),
    B: new $c5rcE.DayPeriodParser(),
    h: new $1khXI.Hour1to12Parser(),
    H: new $hxUWF.Hour0to23Parser(),
    K: new $2rm29.Hour0To11Parser(),
    k: new $iFGxC.Hour1To24Parser(),
    m: new $aXnGy.MinuteParser(),
    s: new $1Y8Y8.SecondParser(),
    S: new $ddQQF.FractionOfSecondParser(),
    X: new $9cgbN.ISOTimezoneWithZParser(),
    x: new $aP8X6.ISOTimezoneParser(),
    t: new $lQArz.TimestampSecondsParser(),
    T: new $4QCDZ.TimestampMillisecondsParser()
};

});
parcelRegister("iTmio", function(module, exports) {

$parcel$export(module.exports, "EraParser", () => $dc0ea87eb5c5598a$export$8e5a1d3f85a9688, (v) => $dc0ea87eb5c5598a$export$8e5a1d3f85a9688 = v);
var $dc0ea87eb5c5598a$export$8e5a1d3f85a9688;
"use strict";
$dc0ea87eb5c5598a$export$8e5a1d3f85a9688 = void 0;

var $vxpiD = parcelRequire("vxpiD");
class $dc0ea87eb5c5598a$var$EraParser extends $vxpiD.Parser {
    priority = 140;
    parse(dateString, token, match) {
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return match.era(dateString, {
                    width: "abbreviated"
                }) || match.era(dateString, {
                    width: "narrow"
                });
            // A, B
            case "GGGGG":
                return match.era(dateString, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return match.era(dateString, {
                    width: "wide"
                }) || match.era(dateString, {
                    width: "abbreviated"
                }) || match.era(dateString, {
                    width: "narrow"
                });
        }
    }
    set(date, flags, value) {
        flags.era = value;
        date.setFullYear(value, 0, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "R",
        "u",
        "t",
        "T"
    ];
}
$dc0ea87eb5c5598a$export$8e5a1d3f85a9688 = $dc0ea87eb5c5598a$var$EraParser;

});
parcelRegister("vxpiD", function(module, exports) {

$parcel$export(module.exports, "Parser", () => $05eccf4f79932c79$export$7acfa6ed01010e37, (v) => $05eccf4f79932c79$export$7acfa6ed01010e37 = v);
var $05eccf4f79932c79$export$7acfa6ed01010e37;
"use strict";
$05eccf4f79932c79$export$7acfa6ed01010e37 = void 0;

var $i1FxJ = parcelRequire("i1FxJ");
class $05eccf4f79932c79$var$Parser {
    run(dateString, token, match, options) {
        const result = this.parse(dateString, token, match, options);
        if (!result) return null;
        return {
            setter: new $i1FxJ.ValueSetter(result.value, this.validate, this.set, this.priority, this.subPriority),
            rest: result.rest
        };
    }
    validate(_utcDate, _value, _options) {
        return true;
    }
}
$05eccf4f79932c79$export$7acfa6ed01010e37 = $05eccf4f79932c79$var$Parser;

});
parcelRegister("i1FxJ", function(module, exports) {

$parcel$export(module.exports, "ValueSetter", () => $d1f88b93f364ab9f$export$9a09e32dd4990fd5, (v) => $d1f88b93f364ab9f$export$9a09e32dd4990fd5 = v);
$parcel$export(module.exports, "DateToSystemTimezoneSetter", () => $d1f88b93f364ab9f$export$5aaf7ff7f09ea4ee, (v) => $d1f88b93f364ab9f$export$5aaf7ff7f09ea4ee = v);
var $d1f88b93f364ab9f$export$9a09e32dd4990fd5;
var $d1f88b93f364ab9f$export$81d53e3678089a6;
var $d1f88b93f364ab9f$export$5aaf7ff7f09ea4ee;
"use strict";
$d1f88b93f364ab9f$export$9a09e32dd4990fd5 = $d1f88b93f364ab9f$export$81d53e3678089a6 = $d1f88b93f364ab9f$export$5aaf7ff7f09ea4ee = void 0;

var $a8Jzr = parcelRequire("a8Jzr");

var $CS8DB = parcelRequire("CS8DB");
const $d1f88b93f364ab9f$var$TIMEZONE_UNIT_PRIORITY = 10;
class $d1f88b93f364ab9f$var$Setter {
    subPriority = 0;
    validate(_utcDate, _options) {
        return true;
    }
}
$d1f88b93f364ab9f$export$81d53e3678089a6 = $d1f88b93f364ab9f$var$Setter;
class $d1f88b93f364ab9f$var$ValueSetter extends $d1f88b93f364ab9f$var$Setter {
    constructor(value, validateValue, setValue, priority, subPriority){
        super();
        this.value = value;
        this.validateValue = validateValue;
        this.setValue = setValue;
        this.priority = priority;
        if (subPriority) this.subPriority = subPriority;
    }
    validate(date, options) {
        return this.validateValue(date, this.value, options);
    }
    set(date, flags, options) {
        return this.setValue(date, flags, this.value, options);
    }
}
$d1f88b93f364ab9f$export$9a09e32dd4990fd5 = $d1f88b93f364ab9f$var$ValueSetter;
class $d1f88b93f364ab9f$var$DateToSystemTimezoneSetter extends $d1f88b93f364ab9f$var$Setter {
    priority = $d1f88b93f364ab9f$var$TIMEZONE_UNIT_PRIORITY;
    subPriority = -1;
    set(date, flags) {
        if (flags.timestampIsSet) return date;
        return (0, $CS8DB.constructFrom)(date, (0, $a8Jzr.transpose)(date, Date));
    }
}
$d1f88b93f364ab9f$export$5aaf7ff7f09ea4ee = $d1f88b93f364ab9f$var$DateToSystemTimezoneSetter;

});
parcelRegister("a8Jzr", function(module, exports) {

$parcel$export(module.exports, "transpose", () => $761e001c258d05a1$export$9cb09a71b7d66923, (v) => $761e001c258d05a1$export$9cb09a71b7d66923 = v);
var $761e001c258d05a1$export$9cb09a71b7d66923;
"use strict";
$761e001c258d05a1$export$9cb09a71b7d66923 = $761e001c258d05a1$var$transpose;

var $CS8DB = parcelRequire("CS8DB");
/**
 * @name transpose
 * @category Generic Helpers
 * @summary Transpose the date to the given constructor.
 *
 * @description
 * The function transposes the date to the given constructor. It helps you
 * to transpose the date in the system time zone to say `UTCDate` or any other
 * date extension.
 *
 * @typeParam DateInputType - The input `Date` type derived from the passed argument.
 * @typeParam DateOutputType - The output `Date` type derived from the passed constructor.
 *
 * @param fromDate - The date to use values from
 * @param constructor - The date constructor to use
 *
 * @returns Date transposed to the given constructor
 *
 * @example
 * // Create July 10, 2022 00:00 in locale time zone
 * const date = new Date(2022, 6, 10)
 * //=> 'Sun Jul 10 2022 00:00:00 GMT+0800 (Singapore Standard Time)'
 *
 * @example
 * // Transpose the date to July 10, 2022 00:00 in UTC
 * transpose(date, UTCDate)
 * //=> 'Sun Jul 10 2022 00:00:00 GMT+0000 (Coordinated Universal Time)'
 */ function $761e001c258d05a1$var$transpose(fromDate, constructor) {
    const date = constructor instanceof Date ? (0, $CS8DB.constructFrom)(constructor, 0) : new constructor(0);
    date.setFullYear(fromDate.getFullYear(), fromDate.getMonth(), fromDate.getDate());
    date.setHours(fromDate.getHours(), fromDate.getMinutes(), fromDate.getSeconds(), fromDate.getMilliseconds());
    return date;
}

});




parcelRegister("esPnD", function(module, exports) {

$parcel$export(module.exports, "YearParser", () => $a87b89443db0f5ec$export$48d352de7cd4a988, (v) => $a87b89443db0f5ec$export$48d352de7cd4a988 = v);
var $a87b89443db0f5ec$export$48d352de7cd4a988;
"use strict";
$a87b89443db0f5ec$export$48d352de7cd4a988 = void 0;

var $vxpiD = parcelRequire("vxpiD");

var $51Y58 = parcelRequire("51Y58");
// From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_Patterns
// | Year     |     y | yy |   yyy |  yyyy | yyyyy |
// |----------|-------|----|-------|-------|-------|
// | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
// | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
// | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
// | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
// | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
class $a87b89443db0f5ec$var$YearParser extends $vxpiD.Parser {
    priority = 130;
    incompatibleTokens = [
        "Y",
        "R",
        "u",
        "w",
        "I",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
    parse(dateString, token, match) {
        const valueCallback = (year)=>({
                year: year,
                isTwoDigitYear: token === "yy"
            });
        switch(token){
            case "y":
                return (0, $51Y58.mapValue)((0, $51Y58.parseNDigits)(4, dateString), valueCallback);
            case "yo":
                return (0, $51Y58.mapValue)(match.ordinalNumber(dateString, {
                    unit: "year"
                }), valueCallback);
            default:
                return (0, $51Y58.mapValue)((0, $51Y58.parseNDigits)(token.length, dateString), valueCallback);
        }
    }
    validate(_date, value) {
        return value.isTwoDigitYear || value.year > 0;
    }
    set(date, flags, value) {
        const currentYear = date.getFullYear();
        if (value.isTwoDigitYear) {
            const normalizedTwoDigitYear = (0, $51Y58.normalizeTwoDigitYear)(value.year, currentYear);
            date.setFullYear(normalizedTwoDigitYear, 0, 1);
            date.setHours(0, 0, 0, 0);
            return date;
        }
        const year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
        date.setFullYear(year, 0, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
}
$a87b89443db0f5ec$export$48d352de7cd4a988 = $a87b89443db0f5ec$var$YearParser;

});
parcelRegister("51Y58", function(module, exports) {

$parcel$export(module.exports, "dayPeriodEnumToHours", () => $3a9ba6b8c3db1e04$export$fb506d2676e7f207, (v) => $3a9ba6b8c3db1e04$export$fb506d2676e7f207 = v);
$parcel$export(module.exports, "isLeapYearIndex", () => $3a9ba6b8c3db1e04$export$3d50627710b84d75, (v) => $3a9ba6b8c3db1e04$export$3d50627710b84d75 = v);
$parcel$export(module.exports, "mapValue", () => $3a9ba6b8c3db1e04$export$4f84e3a82c7b538, (v) => $3a9ba6b8c3db1e04$export$4f84e3a82c7b538 = v);
$parcel$export(module.exports, "normalizeTwoDigitYear", () => $3a9ba6b8c3db1e04$export$29126f735cbf69f7, (v) => $3a9ba6b8c3db1e04$export$29126f735cbf69f7 = v);
$parcel$export(module.exports, "parseAnyDigitsSigned", () => $3a9ba6b8c3db1e04$export$d931c43c4608a164, (v) => $3a9ba6b8c3db1e04$export$d931c43c4608a164 = v);
$parcel$export(module.exports, "parseNDigits", () => $3a9ba6b8c3db1e04$export$513bb01536146ab6, (v) => $3a9ba6b8c3db1e04$export$513bb01536146ab6 = v);
$parcel$export(module.exports, "parseNDigitsSigned", () => $3a9ba6b8c3db1e04$export$2c9307b2e29c533c, (v) => $3a9ba6b8c3db1e04$export$2c9307b2e29c533c = v);
$parcel$export(module.exports, "parseNumericPattern", () => $3a9ba6b8c3db1e04$export$cc7cc9e2a3ff9388, (v) => $3a9ba6b8c3db1e04$export$cc7cc9e2a3ff9388 = v);
$parcel$export(module.exports, "parseTimezonePattern", () => $3a9ba6b8c3db1e04$export$6497f4c0ecdfba8e, (v) => $3a9ba6b8c3db1e04$export$6497f4c0ecdfba8e = v);
var $3a9ba6b8c3db1e04$export$fb506d2676e7f207;
var $3a9ba6b8c3db1e04$export$3d50627710b84d75;
var $3a9ba6b8c3db1e04$export$4f84e3a82c7b538;
var $3a9ba6b8c3db1e04$export$29126f735cbf69f7;
var $3a9ba6b8c3db1e04$export$d931c43c4608a164;
var $3a9ba6b8c3db1e04$export$513bb01536146ab6;
var $3a9ba6b8c3db1e04$export$2c9307b2e29c533c;
var $3a9ba6b8c3db1e04$export$cc7cc9e2a3ff9388;
var $3a9ba6b8c3db1e04$export$6497f4c0ecdfba8e;
"use strict";
$3a9ba6b8c3db1e04$export$fb506d2676e7f207 = $3a9ba6b8c3db1e04$var$dayPeriodEnumToHours;
$3a9ba6b8c3db1e04$export$3d50627710b84d75 = $3a9ba6b8c3db1e04$var$isLeapYearIndex;
$3a9ba6b8c3db1e04$export$4f84e3a82c7b538 = $3a9ba6b8c3db1e04$var$mapValue;
$3a9ba6b8c3db1e04$export$29126f735cbf69f7 = $3a9ba6b8c3db1e04$var$normalizeTwoDigitYear;
$3a9ba6b8c3db1e04$export$d931c43c4608a164 = $3a9ba6b8c3db1e04$var$parseAnyDigitsSigned;
$3a9ba6b8c3db1e04$export$513bb01536146ab6 = $3a9ba6b8c3db1e04$var$parseNDigits;
$3a9ba6b8c3db1e04$export$2c9307b2e29c533c = $3a9ba6b8c3db1e04$var$parseNDigitsSigned;
$3a9ba6b8c3db1e04$export$cc7cc9e2a3ff9388 = $3a9ba6b8c3db1e04$var$parseNumericPattern;
$3a9ba6b8c3db1e04$export$6497f4c0ecdfba8e = $3a9ba6b8c3db1e04$var$parseTimezonePattern;

var $4IrbU = parcelRequire("4IrbU");

var $jZ25V = parcelRequire("jZ25V");
function $3a9ba6b8c3db1e04$var$mapValue(parseFnResult, mapFn) {
    if (!parseFnResult) return parseFnResult;
    return {
        value: mapFn(parseFnResult.value),
        rest: parseFnResult.rest
    };
}
function $3a9ba6b8c3db1e04$var$parseNumericPattern(pattern, dateString) {
    const matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    return {
        value: parseInt(matchResult[0], 10),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $3a9ba6b8c3db1e04$var$parseTimezonePattern(pattern, dateString) {
    const matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    // Input is 'Z'
    if (matchResult[0] === "Z") return {
        value: 0,
        rest: dateString.slice(1)
    };
    const sign = matchResult[1] === "+" ? 1 : -1;
    const hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
    const minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
    const seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
    return {
        value: sign * (hours * $4IrbU.millisecondsInHour + minutes * $4IrbU.millisecondsInMinute + seconds * $4IrbU.millisecondsInSecond),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $3a9ba6b8c3db1e04$var$parseAnyDigitsSigned(dateString) {
    return $3a9ba6b8c3db1e04$var$parseNumericPattern($jZ25V.numericPatterns.anyDigitsSigned, dateString);
}
function $3a9ba6b8c3db1e04$var$parseNDigits(n, dateString) {
    switch(n){
        case 1:
            return $3a9ba6b8c3db1e04$var$parseNumericPattern($jZ25V.numericPatterns.singleDigit, dateString);
        case 2:
            return $3a9ba6b8c3db1e04$var$parseNumericPattern($jZ25V.numericPatterns.twoDigits, dateString);
        case 3:
            return $3a9ba6b8c3db1e04$var$parseNumericPattern($jZ25V.numericPatterns.threeDigits, dateString);
        case 4:
            return $3a9ba6b8c3db1e04$var$parseNumericPattern($jZ25V.numericPatterns.fourDigits, dateString);
        default:
            return $3a9ba6b8c3db1e04$var$parseNumericPattern(new RegExp("^\\d{1," + n + "}"), dateString);
    }
}
function $3a9ba6b8c3db1e04$var$parseNDigitsSigned(n, dateString) {
    switch(n){
        case 1:
            return $3a9ba6b8c3db1e04$var$parseNumericPattern($jZ25V.numericPatterns.singleDigitSigned, dateString);
        case 2:
            return $3a9ba6b8c3db1e04$var$parseNumericPattern($jZ25V.numericPatterns.twoDigitsSigned, dateString);
        case 3:
            return $3a9ba6b8c3db1e04$var$parseNumericPattern($jZ25V.numericPatterns.threeDigitsSigned, dateString);
        case 4:
            return $3a9ba6b8c3db1e04$var$parseNumericPattern($jZ25V.numericPatterns.fourDigitsSigned, dateString);
        default:
            return $3a9ba6b8c3db1e04$var$parseNumericPattern(new RegExp("^-?\\d{1," + n + "}"), dateString);
    }
}
function $3a9ba6b8c3db1e04$var$dayPeriodEnumToHours(dayPeriod) {
    switch(dayPeriod){
        case "morning":
            return 4;
        case "evening":
            return 17;
        case "pm":
        case "noon":
        case "afternoon":
            return 12;
        case "am":
        case "midnight":
        case "night":
        default:
            return 0;
    }
}
function $3a9ba6b8c3db1e04$var$normalizeTwoDigitYear(twoDigitYear, currentYear) {
    const isCommonEra = currentYear > 0;
    // Absolute number of the current year:
    // 1 -> 1 AC
    // 0 -> 1 BC
    // -1 -> 2 BC
    const absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
    let result;
    if (absCurrentYear <= 50) result = twoDigitYear || 100;
    else {
        const rangeEnd = absCurrentYear + 50;
        const rangeEndCentury = Math.trunc(rangeEnd / 100) * 100;
        const isPreviousCentury = twoDigitYear >= rangeEnd % 100;
        result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
    }
    return isCommonEra ? result : 1 - result;
}
function $3a9ba6b8c3db1e04$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}

});
parcelRegister("jZ25V", function(module, exports) {

$parcel$export(module.exports, "timezonePatterns", () => $e8c556c2a4c8d8df$export$a7ee192b982af9c1, (v) => $e8c556c2a4c8d8df$export$a7ee192b982af9c1 = v);
$parcel$export(module.exports, "numericPatterns", () => $e8c556c2a4c8d8df$export$c123ee06d9da8480, (v) => $e8c556c2a4c8d8df$export$c123ee06d9da8480 = v);
var $e8c556c2a4c8d8df$export$a7ee192b982af9c1;
var $e8c556c2a4c8d8df$export$c123ee06d9da8480;
"use strict";
$e8c556c2a4c8d8df$export$a7ee192b982af9c1 = $e8c556c2a4c8d8df$export$c123ee06d9da8480 = void 0;
const $e8c556c2a4c8d8df$var$numericPatterns = $e8c556c2a4c8d8df$export$c123ee06d9da8480 = {
    month: /^(1[0-2]|0?\d)/,
    date: /^(3[0-1]|[0-2]?\d)/,
    dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
    week: /^(5[0-3]|[0-4]?\d)/,
    hour23h: /^(2[0-3]|[0-1]?\d)/,
    hour24h: /^(2[0-4]|[0-1]?\d)/,
    hour11h: /^(1[0-1]|0?\d)/,
    hour12h: /^(1[0-2]|0?\d)/,
    minute: /^[0-5]?\d/,
    second: /^[0-5]?\d/,
    singleDigit: /^\d/,
    twoDigits: /^\d{1,2}/,
    threeDigits: /^\d{1,3}/,
    fourDigits: /^\d{1,4}/,
    anyDigitsSigned: /^-?\d+/,
    singleDigitSigned: /^-?\d/,
    twoDigitsSigned: /^-?\d{1,2}/,
    threeDigitsSigned: /^-?\d{1,3}/,
    fourDigitsSigned: /^-?\d{1,4}/
};
const $e8c556c2a4c8d8df$var$timezonePatterns = $e8c556c2a4c8d8df$export$a7ee192b982af9c1 = {
    basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
    basic: /^([+-])(\d{2})(\d{2})|Z/,
    basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
    extended: /^([+-])(\d{2}):(\d{2})|Z/,
    extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};

});



parcelRegister("5QJtv", function(module, exports) {

$parcel$export(module.exports, "LocalWeekYearParser", () => $44251573a5de7ff9$export$b8ef38dfcf05d5db, (v) => $44251573a5de7ff9$export$b8ef38dfcf05d5db = v);
var $44251573a5de7ff9$export$b8ef38dfcf05d5db;
"use strict";
$44251573a5de7ff9$export$b8ef38dfcf05d5db = void 0;

var $51wqx = parcelRequire("51wqx");

var $aSLbu = parcelRequire("aSLbu");

var $vxpiD = parcelRequire("vxpiD");

var $51Y58 = parcelRequire("51Y58");
// Local week-numbering year
class $44251573a5de7ff9$var$LocalWeekYearParser extends $vxpiD.Parser {
    priority = 130;
    parse(dateString, token, match) {
        const valueCallback = (year)=>({
                year: year,
                isTwoDigitYear: token === "YY"
            });
        switch(token){
            case "Y":
                return (0, $51Y58.mapValue)((0, $51Y58.parseNDigits)(4, dateString), valueCallback);
            case "Yo":
                return (0, $51Y58.mapValue)(match.ordinalNumber(dateString, {
                    unit: "year"
                }), valueCallback);
            default:
                return (0, $51Y58.mapValue)((0, $51Y58.parseNDigits)(token.length, dateString), valueCallback);
        }
    }
    validate(_date, value) {
        return value.isTwoDigitYear || value.year > 0;
    }
    set(date, flags, value, options) {
        const currentYear = (0, $51wqx.getWeekYear)(date, options);
        if (value.isTwoDigitYear) {
            const normalizedTwoDigitYear = (0, $51Y58.normalizeTwoDigitYear)(value.year, currentYear);
            date.setFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
            date.setHours(0, 0, 0, 0);
            return (0, $aSLbu.startOfWeek)(date, options);
        }
        const year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
        date.setFullYear(year, 0, options.firstWeekContainsDate);
        date.setHours(0, 0, 0, 0);
        return (0, $aSLbu.startOfWeek)(date, options);
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "Q",
        "q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "i",
        "t",
        "T"
    ];
}
$44251573a5de7ff9$export$b8ef38dfcf05d5db = $44251573a5de7ff9$var$LocalWeekYearParser;

});

parcelRegister("kVhtF", function(module, exports) {

$parcel$export(module.exports, "ISOWeekYearParser", () => $f3b6b02c718554a3$export$951d1df011fde06f, (v) => $f3b6b02c718554a3$export$951d1df011fde06f = v);
var $f3b6b02c718554a3$export$951d1df011fde06f;
"use strict";
$f3b6b02c718554a3$export$951d1df011fde06f = void 0;

var $77HoA = parcelRequire("77HoA");

var $CS8DB = parcelRequire("CS8DB");

var $vxpiD = parcelRequire("vxpiD");

var $51Y58 = parcelRequire("51Y58");
// ISO week-numbering year
class $f3b6b02c718554a3$var$ISOWeekYearParser extends $vxpiD.Parser {
    priority = 130;
    parse(dateString, token) {
        if (token === "R") return (0, $51Y58.parseNDigitsSigned)(4, dateString);
        return (0, $51Y58.parseNDigitsSigned)(token.length, dateString);
    }
    set(date, _flags, value) {
        const firstWeekOfYear = (0, $CS8DB.constructFrom)(date, 0);
        firstWeekOfYear.setFullYear(value, 0, 4);
        firstWeekOfYear.setHours(0, 0, 0, 0);
        return (0, $77HoA.startOfISOWeek)(firstWeekOfYear);
    }
    incompatibleTokens = [
        "G",
        "y",
        "Y",
        "u",
        "Q",
        "q",
        "M",
        "L",
        "w",
        "d",
        "D",
        "e",
        "c",
        "t",
        "T"
    ];
}
$f3b6b02c718554a3$export$951d1df011fde06f = $f3b6b02c718554a3$var$ISOWeekYearParser;

});

parcelRegister("hCn2H", function(module, exports) {

$parcel$export(module.exports, "ExtendedYearParser", () => $cd37dc0fc74081da$export$bad9d2ea38e8f1a, (v) => $cd37dc0fc74081da$export$bad9d2ea38e8f1a = v);
var $cd37dc0fc74081da$export$bad9d2ea38e8f1a;
"use strict";
$cd37dc0fc74081da$export$bad9d2ea38e8f1a = void 0;

var $vxpiD = parcelRequire("vxpiD");

var $51Y58 = parcelRequire("51Y58");
class $cd37dc0fc74081da$var$ExtendedYearParser extends $vxpiD.Parser {
    priority = 130;
    parse(dateString, token) {
        if (token === "u") return (0, $51Y58.parseNDigitsSigned)(4, dateString);
        return (0, $51Y58.parseNDigitsSigned)(token.length, dateString);
    }
    set(date, _flags, value) {
        date.setFullYear(value, 0, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "G",
        "y",
        "Y",
        "R",
        "w",
        "I",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}
$cd37dc0fc74081da$export$bad9d2ea38e8f1a = $cd37dc0fc74081da$var$ExtendedYearParser;

});

parcelRegister("4wlhx", function(module, exports) {

$parcel$export(module.exports, "QuarterParser", () => $34aaa8b8d1e6a0cd$export$5cb0f701186dde1d, (v) => $34aaa8b8d1e6a0cd$export$5cb0f701186dde1d = v);
var $34aaa8b8d1e6a0cd$export$5cb0f701186dde1d;
"use strict";
$34aaa8b8d1e6a0cd$export$5cb0f701186dde1d = void 0;

var $vxpiD = parcelRequire("vxpiD");

var $51Y58 = parcelRequire("51Y58");
class $34aaa8b8d1e6a0cd$var$QuarterParser extends $vxpiD.Parser {
    priority = 120;
    parse(dateString, token, match) {
        switch(token){
            // 1, 2, 3, 4
            case "Q":
            case "QQ":
                return (0, $51Y58.parseNDigits)(token.length, dateString);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return match.ordinalNumber(dateString, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return match.quarter(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return match.quarter(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return match.quarter(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.quarter(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 4;
    }
    set(date, _flags, value) {
        date.setMonth((value - 1) * 3, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "M",
        "L",
        "w",
        "I",
        "d",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}
$34aaa8b8d1e6a0cd$export$5cb0f701186dde1d = $34aaa8b8d1e6a0cd$var$QuarterParser;

});

parcelRegister("8kj1l", function(module, exports) {

$parcel$export(module.exports, "StandAloneQuarterParser", () => $60fef21a5eb04de9$export$300c0c2990e20e6d, (v) => $60fef21a5eb04de9$export$300c0c2990e20e6d = v);
var $60fef21a5eb04de9$export$300c0c2990e20e6d;
"use strict";
$60fef21a5eb04de9$export$300c0c2990e20e6d = void 0;

var $vxpiD = parcelRequire("vxpiD");

var $51Y58 = parcelRequire("51Y58");
class $60fef21a5eb04de9$var$StandAloneQuarterParser extends $vxpiD.Parser {
    priority = 120;
    parse(dateString, token, match) {
        switch(token){
            // 1, 2, 3, 4
            case "q":
            case "qq":
                return (0, $51Y58.parseNDigits)(token.length, dateString);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return match.ordinalNumber(dateString, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return match.quarter(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return match.quarter(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return match.quarter(dateString, {
                    width: "wide",
                    context: "standalone"
                }) || match.quarter(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 4;
    }
    set(date, _flags, value) {
        date.setMonth((value - 1) * 3, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "Q",
        "M",
        "L",
        "w",
        "I",
        "d",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}
$60fef21a5eb04de9$export$300c0c2990e20e6d = $60fef21a5eb04de9$var$StandAloneQuarterParser;

});

parcelRegister("hv4V6", function(module, exports) {

$parcel$export(module.exports, "MonthParser", () => $cbd925ec36c20dfe$export$400dd8b40ef138a3, (v) => $cbd925ec36c20dfe$export$400dd8b40ef138a3 = v);
var $cbd925ec36c20dfe$export$400dd8b40ef138a3;
"use strict";
$cbd925ec36c20dfe$export$400dd8b40ef138a3 = void 0;

var $jZ25V = parcelRequire("jZ25V");

var $vxpiD = parcelRequire("vxpiD");

var $51Y58 = parcelRequire("51Y58");
class $cbd925ec36c20dfe$var$MonthParser extends $vxpiD.Parser {
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "L",
        "w",
        "I",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
    priority = 110;
    parse(dateString, token, match) {
        const valueCallback = (value)=>value - 1;
        switch(token){
            // 1, 2, ..., 12
            case "M":
                return (0, $51Y58.mapValue)((0, $51Y58.parseNumericPattern)($jZ25V.numericPatterns.month, dateString), valueCallback);
            // 01, 02, ..., 12
            case "MM":
                return (0, $51Y58.mapValue)((0, $51Y58.parseNDigits)(2, dateString), valueCallback);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return (0, $51Y58.mapValue)(match.ordinalNumber(dateString, {
                    unit: "month"
                }), valueCallback);
            // Jan, Feb, ..., Dec
            case "MMM":
                return match.month(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return match.month(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return match.month(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.month(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 11;
    }
    set(date, _flags, value) {
        date.setMonth(value, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
}
$cbd925ec36c20dfe$export$400dd8b40ef138a3 = $cbd925ec36c20dfe$var$MonthParser;

});

parcelRegister("dHuAC", function(module, exports) {

$parcel$export(module.exports, "StandAloneMonthParser", () => $9f9704fbf3800d58$export$1d7eaa53eaa5deba, (v) => $9f9704fbf3800d58$export$1d7eaa53eaa5deba = v);
var $9f9704fbf3800d58$export$1d7eaa53eaa5deba;
"use strict";
$9f9704fbf3800d58$export$1d7eaa53eaa5deba = void 0;

var $jZ25V = parcelRequire("jZ25V");

var $vxpiD = parcelRequire("vxpiD");

var $51Y58 = parcelRequire("51Y58");
class $9f9704fbf3800d58$var$StandAloneMonthParser extends $vxpiD.Parser {
    priority = 110;
    parse(dateString, token, match) {
        const valueCallback = (value)=>value - 1;
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return (0, $51Y58.mapValue)((0, $51Y58.parseNumericPattern)($jZ25V.numericPatterns.month, dateString), valueCallback);
            // 01, 02, ..., 12
            case "LL":
                return (0, $51Y58.mapValue)((0, $51Y58.parseNDigits)(2, dateString), valueCallback);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return (0, $51Y58.mapValue)(match.ordinalNumber(dateString, {
                    unit: "month"
                }), valueCallback);
            // Jan, Feb, ..., Dec
            case "LLL":
                return match.month(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return match.month(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return match.month(dateString, {
                    width: "wide",
                    context: "standalone"
                }) || match.month(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 11;
    }
    set(date, _flags, value) {
        date.setMonth(value, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "M",
        "w",
        "I",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}
$9f9704fbf3800d58$export$1d7eaa53eaa5deba = $9f9704fbf3800d58$var$StandAloneMonthParser;

});

parcelRegister("2ZRWX", function(module, exports) {

$parcel$export(module.exports, "LocalWeekParser", () => $22eb209eeed22418$export$c4005ffc174e07c0, (v) => $22eb209eeed22418$export$c4005ffc174e07c0 = v);
var $22eb209eeed22418$export$c4005ffc174e07c0;
"use strict";
$22eb209eeed22418$export$c4005ffc174e07c0 = void 0;

var $aWlxT = parcelRequire("aWlxT");

var $aSLbu = parcelRequire("aSLbu");

var $jZ25V = parcelRequire("jZ25V");

var $vxpiD = parcelRequire("vxpiD");

var $51Y58 = parcelRequire("51Y58");
// Local week of year
class $22eb209eeed22418$var$LocalWeekParser extends $vxpiD.Parser {
    priority = 100;
    parse(dateString, token, match) {
        switch(token){
            case "w":
                return (0, $51Y58.parseNumericPattern)($jZ25V.numericPatterns.week, dateString);
            case "wo":
                return match.ordinalNumber(dateString, {
                    unit: "week"
                });
            default:
                return (0, $51Y58.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 53;
    }
    set(date, _flags, value, options) {
        return (0, $aSLbu.startOfWeek)((0, $aWlxT.setWeek)(date, value, options), options);
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "i",
        "t",
        "T"
    ];
}
$22eb209eeed22418$export$c4005ffc174e07c0 = $22eb209eeed22418$var$LocalWeekParser;

});
parcelRegister("aWlxT", function(module, exports) {

$parcel$export(module.exports, "setWeek", () => $7f7008b0d73aee3b$export$4b3066ce4afafd88, (v) => $7f7008b0d73aee3b$export$4b3066ce4afafd88 = v);
var $7f7008b0d73aee3b$export$4b3066ce4afafd88;
"use strict";
$7f7008b0d73aee3b$export$4b3066ce4afafd88 = $7f7008b0d73aee3b$var$setWeek;

var $g2WV7 = parcelRequire("g2WV7");

var $26OhI = parcelRequire("26OhI");
/**
 * The {@link setWeek} function options.
 */ /**
 * @name setWeek
 * @category Week Helpers
 * @summary Set the local week to the given date.
 *
 * @description
 * Set the local week to the given date, saving the weekday number.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param week - The week of the new date
 * @param options - An object with options
 *
 * @returns The new date with the local week set
 *
 * @example
 * // Set the 1st week to 2 January 2005 with default options:
 * const result = setWeek(new Date(2005, 0, 2), 1)
 * //=> Sun Dec 26 2004 00:00:00
 *
 * @example
 * // Set the 1st week to 2 January 2005,
 * // if Monday is the first day of the week,
 * // and the first week of the year always contains 4 January:
 * const result = setWeek(new Date(2005, 0, 2), 1, {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> Sun Jan 4 2004 00:00:00
 */ function $7f7008b0d73aee3b$var$setWeek(date, week, options) {
    const _date = (0, $26OhI.toDate)(date);
    const diff = (0, $g2WV7.getWeek)(_date, options) - week;
    _date.setDate(_date.getDate() - diff * 7);
    return _date;
}

});


parcelRegister("loV88", function(module, exports) {

$parcel$export(module.exports, "ISOWeekParser", () => $f94827b72de3c921$export$6fc8dbedd560a6af, (v) => $f94827b72de3c921$export$6fc8dbedd560a6af = v);
var $f94827b72de3c921$export$6fc8dbedd560a6af;
"use strict";
$f94827b72de3c921$export$6fc8dbedd560a6af = void 0;

var $hqrZY = parcelRequire("hqrZY");

var $77HoA = parcelRequire("77HoA");

var $jZ25V = parcelRequire("jZ25V");

var $vxpiD = parcelRequire("vxpiD");

var $51Y58 = parcelRequire("51Y58");
// ISO week of year
class $f94827b72de3c921$var$ISOWeekParser extends $vxpiD.Parser {
    priority = 100;
    parse(dateString, token, match) {
        switch(token){
            case "I":
                return (0, $51Y58.parseNumericPattern)($jZ25V.numericPatterns.week, dateString);
            case "Io":
                return match.ordinalNumber(dateString, {
                    unit: "week"
                });
            default:
                return (0, $51Y58.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 53;
    }
    set(date, _flags, value) {
        return (0, $77HoA.startOfISOWeek)((0, $hqrZY.setISOWeek)(date, value));
    }
    incompatibleTokens = [
        "y",
        "Y",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "w",
        "d",
        "D",
        "e",
        "c",
        "t",
        "T"
    ];
}
$f94827b72de3c921$export$6fc8dbedd560a6af = $f94827b72de3c921$var$ISOWeekParser;

});
parcelRegister("hqrZY", function(module, exports) {

$parcel$export(module.exports, "setISOWeek", () => $cafa954f12ead1dd$export$6542bebf6be94082, (v) => $cafa954f12ead1dd$export$6542bebf6be94082 = v);
var $cafa954f12ead1dd$export$6542bebf6be94082;
"use strict";
$cafa954f12ead1dd$export$6542bebf6be94082 = $cafa954f12ead1dd$var$setISOWeek;

var $730vp = parcelRequire("730vp");

var $26OhI = parcelRequire("26OhI");
/**
 * @name setISOWeek
 * @category ISO Week Helpers
 * @summary Set the ISO week to the given date.
 *
 * @description
 * Set the ISO week to the given date, saving the weekday number.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param week - The ISO week of the new date
 *
 * @returns The new date with the ISO week set
 *
 * @example
 * // Set the 53rd ISO week to 7 August 2004:
 * const result = setISOWeek(new Date(2004, 7, 7), 53)
 * //=> Sat Jan 01 2005 00:00:00
 */ function $cafa954f12ead1dd$var$setISOWeek(date, week) {
    const _date = (0, $26OhI.toDate)(date);
    const diff = (0, $730vp.getISOWeek)(_date) - week;
    _date.setDate(_date.getDate() - diff * 7);
    return _date;
}

});


parcelRegister("hFFWH", function(module, exports) {

$parcel$export(module.exports, "DateParser", () => $cdd6cd9491ed2e52$export$e8d4b28a20981dd2, (v) => $cdd6cd9491ed2e52$export$e8d4b28a20981dd2 = v);
var $cdd6cd9491ed2e52$export$e8d4b28a20981dd2;
"use strict";
$cdd6cd9491ed2e52$export$e8d4b28a20981dd2 = void 0;

var $jZ25V = parcelRequire("jZ25V");

var $vxpiD = parcelRequire("vxpiD");

var $51Y58 = parcelRequire("51Y58");
const $cdd6cd9491ed2e52$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
const $cdd6cd9491ed2e52$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
// Day of the month
class $cdd6cd9491ed2e52$var$DateParser extends $vxpiD.Parser {
    priority = 90;
    subPriority = 1;
    parse(dateString, token, match) {
        switch(token){
            case "d":
                return (0, $51Y58.parseNumericPattern)($jZ25V.numericPatterns.date, dateString);
            case "do":
                return match.ordinalNumber(dateString, {
                    unit: "date"
                });
            default:
                return (0, $51Y58.parseNDigits)(token.length, dateString);
        }
    }
    validate(date, value) {
        const year = date.getFullYear();
        const isLeapYear = (0, $51Y58.isLeapYearIndex)(year);
        const month = date.getMonth();
        if (isLeapYear) return value >= 1 && value <= $cdd6cd9491ed2e52$var$DAYS_IN_MONTH_LEAP_YEAR[month];
        else return value >= 1 && value <= $cdd6cd9491ed2e52$var$DAYS_IN_MONTH[month];
    }
    set(date, _flags, value) {
        date.setDate(value);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "w",
        "I",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}
$cdd6cd9491ed2e52$export$e8d4b28a20981dd2 = $cdd6cd9491ed2e52$var$DateParser;

});

parcelRegister("iuSAz", function(module, exports) {

$parcel$export(module.exports, "DayOfYearParser", () => $d7755f8fc997f8e2$export$6cfe0d613455f615, (v) => $d7755f8fc997f8e2$export$6cfe0d613455f615 = v);
var $d7755f8fc997f8e2$export$6cfe0d613455f615;
"use strict";
$d7755f8fc997f8e2$export$6cfe0d613455f615 = void 0;

var $jZ25V = parcelRequire("jZ25V");

var $vxpiD = parcelRequire("vxpiD");

var $51Y58 = parcelRequire("51Y58");
class $d7755f8fc997f8e2$var$DayOfYearParser extends $vxpiD.Parser {
    priority = 90;
    subpriority = 1;
    parse(dateString, token, match) {
        switch(token){
            case "D":
            case "DD":
                return (0, $51Y58.parseNumericPattern)($jZ25V.numericPatterns.dayOfYear, dateString);
            case "Do":
                return match.ordinalNumber(dateString, {
                    unit: "date"
                });
            default:
                return (0, $51Y58.parseNDigits)(token.length, dateString);
        }
    }
    validate(date, value) {
        const year = date.getFullYear();
        const isLeapYear = (0, $51Y58.isLeapYearIndex)(year);
        if (isLeapYear) return value >= 1 && value <= 366;
        else return value >= 1 && value <= 365;
    }
    set(date, _flags, value) {
        date.setMonth(0, value);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "M",
        "L",
        "w",
        "I",
        "d",
        "E",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}
$d7755f8fc997f8e2$export$6cfe0d613455f615 = $d7755f8fc997f8e2$var$DayOfYearParser;

});

parcelRegister("OVGmw", function(module, exports) {

$parcel$export(module.exports, "DayParser", () => $09916a1f5aa640f8$export$1b03c8b76262f7bd, (v) => $09916a1f5aa640f8$export$1b03c8b76262f7bd = v);
var $09916a1f5aa640f8$export$1b03c8b76262f7bd;
"use strict";
$09916a1f5aa640f8$export$1b03c8b76262f7bd = void 0;

var $ipvzE = parcelRequire("ipvzE");

var $vxpiD = parcelRequire("vxpiD");
// Day of week
class $09916a1f5aa640f8$var$DayParser extends $vxpiD.Parser {
    priority = 90;
    parse(dateString, token, match) {
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return match.day(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 6;
    }
    set(date, _flags, value, options) {
        date = (0, $ipvzE.setDay)(date, value, options);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}
$09916a1f5aa640f8$export$1b03c8b76262f7bd = $09916a1f5aa640f8$var$DayParser;

});
parcelRegister("ipvzE", function(module, exports) {

$parcel$export(module.exports, "setDay", () => $d6730db979c9c2de$export$b04fdcda82decc6c, (v) => $d6730db979c9c2de$export$b04fdcda82decc6c = v);
var $d6730db979c9c2de$export$b04fdcda82decc6c;
"use strict";
$d6730db979c9c2de$export$b04fdcda82decc6c = $d6730db979c9c2de$var$setDay;

var $jKYo1 = parcelRequire("jKYo1");

var $26OhI = parcelRequire("26OhI");

var $2Hkrd = parcelRequire("2Hkrd");
/**
 * The {@link setDay} function options.
 */ /**
 * @name setDay
 * @category Weekday Helpers
 * @summary Set the day of the week to the given date.
 *
 * @description
 * Set the day of the week to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param day - The day of the week of the new date
 * @param options - An object with options.
 *
 * @returns The new date with the day of the week set
 *
 * @example
 * // Set week day to Sunday, with the default weekStartsOn of Sunday:
 * const result = setDay(new Date(2014, 8, 1), 0)
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // Set week day to Sunday, with a weekStartsOn of Monday:
 * const result = setDay(new Date(2014, 8, 1), 0, { weekStartsOn: 1 })
 * //=> Sun Sep 07 2014 00:00:00
 */ function $d6730db979c9c2de$var$setDay(date, day, options) {
    const defaultOptions = (0, $2Hkrd.getDefaultOptions)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, $26OhI.toDate)(date);
    const currentDay = _date.getDay();
    const remainder = day % 7;
    const dayIndex = (remainder + 7) % 7;
    const delta = 7 - weekStartsOn;
    const diff = day < 0 || day > 6 ? day - (currentDay + delta) % 7 : (dayIndex + delta) % 7 - (currentDay + delta) % 7;
    return (0, $jKYo1.addDays)(_date, diff);
}

});


parcelRegister("eQBWA", function(module, exports) {

$parcel$export(module.exports, "LocalDayParser", () => $acf35ae7875e5dbd$export$44d1c127ab42c480, (v) => $acf35ae7875e5dbd$export$44d1c127ab42c480 = v);
var $acf35ae7875e5dbd$export$44d1c127ab42c480;
"use strict";
$acf35ae7875e5dbd$export$44d1c127ab42c480 = void 0;

var $ipvzE = parcelRequire("ipvzE");

var $vxpiD = parcelRequire("vxpiD");

var $51Y58 = parcelRequire("51Y58");
// Local day of week
class $acf35ae7875e5dbd$var$LocalDayParser extends $vxpiD.Parser {
    priority = 90;
    parse(dateString, token, match, options) {
        const valueCallback = (value)=>{
            // We want here floor instead of trunc, so we get -7 for value 0 instead of 0
            const wholeWeekDays = Math.floor((value - 1) / 7) * 7;
            return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
        };
        switch(token){
            // 3
            case "e":
            case "ee":
                return (0, $51Y58.mapValue)((0, $51Y58.parseNDigits)(token.length, dateString), valueCallback);
            // 3rd
            case "eo":
                return (0, $51Y58.mapValue)(match.ordinalNumber(dateString, {
                    unit: "day"
                }), valueCallback);
            // Tue
            case "eee":
                return match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return match.day(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 6;
    }
    set(date, _flags, value, options) {
        date = (0, $ipvzE.setDay)(date, value, options);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "E",
        "i",
        "c",
        "t",
        "T"
    ];
}
$acf35ae7875e5dbd$export$44d1c127ab42c480 = $acf35ae7875e5dbd$var$LocalDayParser;

});

parcelRegister("6uMdG", function(module, exports) {

$parcel$export(module.exports, "StandAloneLocalDayParser", () => $4baaf2da02330d3e$export$e447a647caaaec1d, (v) => $4baaf2da02330d3e$export$e447a647caaaec1d = v);
var $4baaf2da02330d3e$export$e447a647caaaec1d;
"use strict";
$4baaf2da02330d3e$export$e447a647caaaec1d = void 0;

var $ipvzE = parcelRequire("ipvzE");

var $vxpiD = parcelRequire("vxpiD");

var $51Y58 = parcelRequire("51Y58");
// Stand-alone local day of week
class $4baaf2da02330d3e$var$StandAloneLocalDayParser extends $vxpiD.Parser {
    priority = 90;
    parse(dateString, token, match, options) {
        const valueCallback = (value)=>{
            // We want here floor instead of trunc, so we get -7 for value 0 instead of 0
            const wholeWeekDays = Math.floor((value - 1) / 7) * 7;
            return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
        };
        switch(token){
            // 3
            case "c":
            case "cc":
                return (0, $51Y58.mapValue)((0, $51Y58.parseNDigits)(token.length, dateString), valueCallback);
            // 3rd
            case "co":
                return (0, $51Y58.mapValue)(match.ordinalNumber(dateString, {
                    unit: "day"
                }), valueCallback);
            // Tue
            case "ccc":
                return match.day(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "short",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return match.day(dateString, {
                    width: "short",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return match.day(dateString, {
                    width: "wide",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "short",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 6;
    }
    set(date, _flags, value, options) {
        date = (0, $ipvzE.setDay)(date, value, options);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "E",
        "i",
        "e",
        "t",
        "T"
    ];
}
$4baaf2da02330d3e$export$e447a647caaaec1d = $4baaf2da02330d3e$var$StandAloneLocalDayParser;

});

parcelRegister("1qTW4", function(module, exports) {

$parcel$export(module.exports, "ISODayParser", () => $10b39bcb987299fc$export$693fb1e525095b2a, (v) => $10b39bcb987299fc$export$693fb1e525095b2a = v);
var $10b39bcb987299fc$export$693fb1e525095b2a;
"use strict";
$10b39bcb987299fc$export$693fb1e525095b2a = void 0;

var $awMyM = parcelRequire("awMyM");

var $vxpiD = parcelRequire("vxpiD");

var $51Y58 = parcelRequire("51Y58");
// ISO day of week
class $10b39bcb987299fc$var$ISODayParser extends $vxpiD.Parser {
    priority = 90;
    parse(dateString, token, match) {
        const valueCallback = (value)=>{
            if (value === 0) return 7;
            return value;
        };
        switch(token){
            // 2
            case "i":
            case "ii":
                return (0, $51Y58.parseNDigits)(token.length, dateString);
            // 2nd
            case "io":
                return match.ordinalNumber(dateString, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return (0, $51Y58.mapValue)(match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
            // T
            case "iiiii":
                return (0, $51Y58.mapValue)(match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
            // Tu
            case "iiiiii":
                return (0, $51Y58.mapValue)(match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
            // Tuesday
            case "iiii":
            default:
                return (0, $51Y58.mapValue)(match.day(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 7;
    }
    set(date, _flags, value) {
        date = (0, $awMyM.setISODay)(date, value);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "y",
        "Y",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "w",
        "d",
        "D",
        "E",
        "e",
        "c",
        "t",
        "T"
    ];
}
$10b39bcb987299fc$export$693fb1e525095b2a = $10b39bcb987299fc$var$ISODayParser;

});
parcelRegister("awMyM", function(module, exports) {

$parcel$export(module.exports, "setISODay", () => $7aa28f854d64293c$export$1fd9df65adb0d1aa, (v) => $7aa28f854d64293c$export$1fd9df65adb0d1aa = v);
var $7aa28f854d64293c$export$1fd9df65adb0d1aa;
"use strict";
$7aa28f854d64293c$export$1fd9df65adb0d1aa = $7aa28f854d64293c$var$setISODay;

var $jKYo1 = parcelRequire("jKYo1");

var $cQYi9 = parcelRequire("cQYi9");

var $26OhI = parcelRequire("26OhI");
/**
 * @name setISODay
 * @category Weekday Helpers
 * @summary Set the day of the ISO week to the given date.
 *
 * @description
 * Set the day of the ISO week to the given date.
 * ISO week starts with Monday.
 * 7 is the index of Sunday, 1 is the index of Monday etc.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param day - The day of the ISO week of the new date
 *
 * @returns The new date with the day of the ISO week set
 *
 * @example
 * // Set Sunday to 1 September 2014:
 * const result = setISODay(new Date(2014, 8, 1), 7)
 * //=> Sun Sep 07 2014 00:00:00
 */ function $7aa28f854d64293c$var$setISODay(date, day) {
    const _date = (0, $26OhI.toDate)(date);
    const currentDay = (0, $cQYi9.getISODay)(_date);
    const diff = day - currentDay;
    return (0, $jKYo1.addDays)(_date, diff);
}

});
parcelRegister("cQYi9", function(module, exports) {

$parcel$export(module.exports, "getISODay", () => $95b91c125012668f$export$c514f4c1a8ed5e9e, (v) => $95b91c125012668f$export$c514f4c1a8ed5e9e = v);
var $95b91c125012668f$export$c514f4c1a8ed5e9e;
"use strict";
$95b91c125012668f$export$c514f4c1a8ed5e9e = $95b91c125012668f$var$getISODay;

var $26OhI = parcelRequire("26OhI");
/**
 * @name getISODay
 * @category Weekday Helpers
 * @summary Get the day of the ISO week of the given date.
 *
 * @description
 * Get the day of the ISO week of the given date,
 * which is 7 for Sunday, 1 for Monday etc.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The day of ISO week
 *
 * @example
 * // Which day of the ISO week is 26 February 2012?
 * const result = getISODay(new Date(2012, 1, 26))
 * //=> 7
 */ function $95b91c125012668f$var$getISODay(date) {
    const _date = (0, $26OhI.toDate)(date);
    let day = _date.getDay();
    if (day === 0) day = 7;
    return day;
}

});



parcelRegister("apysC", function(module, exports) {

$parcel$export(module.exports, "AMPMParser", () => $7946f852fcf748d7$export$8d1e08492351df91, (v) => $7946f852fcf748d7$export$8d1e08492351df91 = v);
var $7946f852fcf748d7$export$8d1e08492351df91;
"use strict";
$7946f852fcf748d7$export$8d1e08492351df91 = void 0;

var $vxpiD = parcelRequire("vxpiD");

var $51Y58 = parcelRequire("51Y58");
class $7946f852fcf748d7$var$AMPMParser extends $vxpiD.Parser {
    priority = 80;
    parse(dateString, token, match) {
        switch(token){
            case "a":
            case "aa":
            case "aaa":
                return match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaaa":
                return match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return match.dayPeriod(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    set(date, _flags, value) {
        date.setHours((0, $51Y58.dayPeriodEnumToHours)(value), 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "b",
        "B",
        "H",
        "k",
        "t",
        "T"
    ];
}
$7946f852fcf748d7$export$8d1e08492351df91 = $7946f852fcf748d7$var$AMPMParser;

});

parcelRegister("e9kyt", function(module, exports) {

$parcel$export(module.exports, "AMPMMidnightParser", () => $a4d1d9c1641c80e1$export$73ca2bd0a17d273, (v) => $a4d1d9c1641c80e1$export$73ca2bd0a17d273 = v);
var $a4d1d9c1641c80e1$export$73ca2bd0a17d273;
"use strict";
$a4d1d9c1641c80e1$export$73ca2bd0a17d273 = void 0;

var $vxpiD = parcelRequire("vxpiD");

var $51Y58 = parcelRequire("51Y58");
class $a4d1d9c1641c80e1$var$AMPMMidnightParser extends $vxpiD.Parser {
    priority = 80;
    parse(dateString, token, match) {
        switch(token){
            case "b":
            case "bb":
            case "bbb":
                return match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbbb":
                return match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return match.dayPeriod(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    set(date, _flags, value) {
        date.setHours((0, $51Y58.dayPeriodEnumToHours)(value), 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "B",
        "H",
        "k",
        "t",
        "T"
    ];
}
$a4d1d9c1641c80e1$export$73ca2bd0a17d273 = $a4d1d9c1641c80e1$var$AMPMMidnightParser;

});

parcelRegister("c5rcE", function(module, exports) {

$parcel$export(module.exports, "DayPeriodParser", () => $8ccb0d9f842ff02c$export$bb9212adf05373db, (v) => $8ccb0d9f842ff02c$export$bb9212adf05373db = v);
var $8ccb0d9f842ff02c$export$bb9212adf05373db;
"use strict";
$8ccb0d9f842ff02c$export$bb9212adf05373db = void 0;

var $vxpiD = parcelRequire("vxpiD");

var $51Y58 = parcelRequire("51Y58");
// in the morning, in the afternoon, in the evening, at night
class $8ccb0d9f842ff02c$var$DayPeriodParser extends $vxpiD.Parser {
    priority = 80;
    parse(dateString, token, match) {
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBBB":
                return match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return match.dayPeriod(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    set(date, _flags, value) {
        date.setHours((0, $51Y58.dayPeriodEnumToHours)(value), 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "b",
        "t",
        "T"
    ];
}
$8ccb0d9f842ff02c$export$bb9212adf05373db = $8ccb0d9f842ff02c$var$DayPeriodParser;

});

parcelRegister("1khXI", function(module, exports) {

$parcel$export(module.exports, "Hour1to12Parser", () => $0f7597a21e9a0145$export$8a04050a727a1756, (v) => $0f7597a21e9a0145$export$8a04050a727a1756 = v);
var $0f7597a21e9a0145$export$8a04050a727a1756;
"use strict";
$0f7597a21e9a0145$export$8a04050a727a1756 = void 0;

var $jZ25V = parcelRequire("jZ25V");

var $vxpiD = parcelRequire("vxpiD");

var $51Y58 = parcelRequire("51Y58");
class $0f7597a21e9a0145$var$Hour1to12Parser extends $vxpiD.Parser {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "h":
                return (0, $51Y58.parseNumericPattern)($jZ25V.numericPatterns.hour12h, dateString);
            case "ho":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $51Y58.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 12;
    }
    set(date, _flags, value) {
        const isPM = date.getHours() >= 12;
        if (isPM && value < 12) date.setHours(value + 12, 0, 0, 0);
        else if (!isPM && value === 12) date.setHours(0, 0, 0, 0);
        else date.setHours(value, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "H",
        "K",
        "k",
        "t",
        "T"
    ];
}
$0f7597a21e9a0145$export$8a04050a727a1756 = $0f7597a21e9a0145$var$Hour1to12Parser;

});

parcelRegister("hxUWF", function(module, exports) {

$parcel$export(module.exports, "Hour0to23Parser", () => $cc61b0e425776a3c$export$e56f4dea2c3e56dd, (v) => $cc61b0e425776a3c$export$e56f4dea2c3e56dd = v);
var $cc61b0e425776a3c$export$e56f4dea2c3e56dd;
"use strict";
$cc61b0e425776a3c$export$e56f4dea2c3e56dd = void 0;

var $jZ25V = parcelRequire("jZ25V");

var $vxpiD = parcelRequire("vxpiD");

var $51Y58 = parcelRequire("51Y58");
class $cc61b0e425776a3c$var$Hour0to23Parser extends $vxpiD.Parser {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "H":
                return (0, $51Y58.parseNumericPattern)($jZ25V.numericPatterns.hour23h, dateString);
            case "Ho":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $51Y58.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 23;
    }
    set(date, _flags, value) {
        date.setHours(value, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "b",
        "h",
        "K",
        "k",
        "t",
        "T"
    ];
}
$cc61b0e425776a3c$export$e56f4dea2c3e56dd = $cc61b0e425776a3c$var$Hour0to23Parser;

});

parcelRegister("2rm29", function(module, exports) {

$parcel$export(module.exports, "Hour0To11Parser", () => $1c6f31d4bb5bf666$export$cbbe855312f87d77, (v) => $1c6f31d4bb5bf666$export$cbbe855312f87d77 = v);
var $1c6f31d4bb5bf666$export$cbbe855312f87d77;
"use strict";
$1c6f31d4bb5bf666$export$cbbe855312f87d77 = void 0;

var $jZ25V = parcelRequire("jZ25V");

var $vxpiD = parcelRequire("vxpiD");

var $51Y58 = parcelRequire("51Y58");
class $1c6f31d4bb5bf666$var$Hour0To11Parser extends $vxpiD.Parser {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "K":
                return (0, $51Y58.parseNumericPattern)($jZ25V.numericPatterns.hour11h, dateString);
            case "Ko":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $51Y58.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 11;
    }
    set(date, _flags, value) {
        const isPM = date.getHours() >= 12;
        if (isPM && value < 12) date.setHours(value + 12, 0, 0, 0);
        else date.setHours(value, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "h",
        "H",
        "k",
        "t",
        "T"
    ];
}
$1c6f31d4bb5bf666$export$cbbe855312f87d77 = $1c6f31d4bb5bf666$var$Hour0To11Parser;

});

parcelRegister("iFGxC", function(module, exports) {

$parcel$export(module.exports, "Hour1To24Parser", () => $d97d0e22af512744$export$6008046d2b34b6a5, (v) => $d97d0e22af512744$export$6008046d2b34b6a5 = v);
var $d97d0e22af512744$export$6008046d2b34b6a5;
"use strict";
$d97d0e22af512744$export$6008046d2b34b6a5 = void 0;

var $jZ25V = parcelRequire("jZ25V");

var $vxpiD = parcelRequire("vxpiD");

var $51Y58 = parcelRequire("51Y58");
class $d97d0e22af512744$var$Hour1To24Parser extends $vxpiD.Parser {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "k":
                return (0, $51Y58.parseNumericPattern)($jZ25V.numericPatterns.hour24h, dateString);
            case "ko":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $51Y58.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 24;
    }
    set(date, _flags, value) {
        const hours = value <= 24 ? value % 24 : value;
        date.setHours(hours, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "b",
        "h",
        "H",
        "K",
        "t",
        "T"
    ];
}
$d97d0e22af512744$export$6008046d2b34b6a5 = $d97d0e22af512744$var$Hour1To24Parser;

});

parcelRegister("aXnGy", function(module, exports) {

$parcel$export(module.exports, "MinuteParser", () => $7fa1c983b9016300$export$2b52670d9e2be53, (v) => $7fa1c983b9016300$export$2b52670d9e2be53 = v);
var $7fa1c983b9016300$export$2b52670d9e2be53;
"use strict";
$7fa1c983b9016300$export$2b52670d9e2be53 = void 0;

var $jZ25V = parcelRequire("jZ25V");

var $vxpiD = parcelRequire("vxpiD");

var $51Y58 = parcelRequire("51Y58");
class $7fa1c983b9016300$var$MinuteParser extends $vxpiD.Parser {
    priority = 60;
    parse(dateString, token, match) {
        switch(token){
            case "m":
                return (0, $51Y58.parseNumericPattern)($jZ25V.numericPatterns.minute, dateString);
            case "mo":
                return match.ordinalNumber(dateString, {
                    unit: "minute"
                });
            default:
                return (0, $51Y58.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 59;
    }
    set(date, _flags, value) {
        date.setMinutes(value, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "t",
        "T"
    ];
}
$7fa1c983b9016300$export$2b52670d9e2be53 = $7fa1c983b9016300$var$MinuteParser;

});

parcelRegister("1Y8Y8", function(module, exports) {

$parcel$export(module.exports, "SecondParser", () => $16f25a138b3c0e62$export$94d46d540cf1366a, (v) => $16f25a138b3c0e62$export$94d46d540cf1366a = v);
var $16f25a138b3c0e62$export$94d46d540cf1366a;
"use strict";
$16f25a138b3c0e62$export$94d46d540cf1366a = void 0;

var $jZ25V = parcelRequire("jZ25V");

var $vxpiD = parcelRequire("vxpiD");

var $51Y58 = parcelRequire("51Y58");
class $16f25a138b3c0e62$var$SecondParser extends $vxpiD.Parser {
    priority = 50;
    parse(dateString, token, match) {
        switch(token){
            case "s":
                return (0, $51Y58.parseNumericPattern)($jZ25V.numericPatterns.second, dateString);
            case "so":
                return match.ordinalNumber(dateString, {
                    unit: "second"
                });
            default:
                return (0, $51Y58.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 59;
    }
    set(date, _flags, value) {
        date.setSeconds(value, 0);
        return date;
    }
    incompatibleTokens = [
        "t",
        "T"
    ];
}
$16f25a138b3c0e62$export$94d46d540cf1366a = $16f25a138b3c0e62$var$SecondParser;

});

parcelRegister("ddQQF", function(module, exports) {

$parcel$export(module.exports, "FractionOfSecondParser", () => $9a057be2792dbd75$export$b8e6f8b2d70893b1, (v) => $9a057be2792dbd75$export$b8e6f8b2d70893b1 = v);
var $9a057be2792dbd75$export$b8e6f8b2d70893b1;
"use strict";
$9a057be2792dbd75$export$b8e6f8b2d70893b1 = void 0;

var $vxpiD = parcelRequire("vxpiD");

var $51Y58 = parcelRequire("51Y58");
class $9a057be2792dbd75$var$FractionOfSecondParser extends $vxpiD.Parser {
    priority = 30;
    parse(dateString, token) {
        const valueCallback = (value)=>Math.trunc(value * Math.pow(10, -token.length + 3));
        return (0, $51Y58.mapValue)((0, $51Y58.parseNDigits)(token.length, dateString), valueCallback);
    }
    set(date, _flags, value) {
        date.setMilliseconds(value);
        return date;
    }
    incompatibleTokens = [
        "t",
        "T"
    ];
}
$9a057be2792dbd75$export$b8e6f8b2d70893b1 = $9a057be2792dbd75$var$FractionOfSecondParser;

});

parcelRegister("9cgbN", function(module, exports) {

$parcel$export(module.exports, "ISOTimezoneWithZParser", () => $6b21cae23f80336f$export$104d901d49fea29b, (v) => $6b21cae23f80336f$export$104d901d49fea29b = v);
var $6b21cae23f80336f$export$104d901d49fea29b;
"use strict";
$6b21cae23f80336f$export$104d901d49fea29b = void 0;

var $CS8DB = parcelRequire("CS8DB");

var $6f1d3 = parcelRequire("6f1d3");

var $jZ25V = parcelRequire("jZ25V");

var $vxpiD = parcelRequire("vxpiD");

var $51Y58 = parcelRequire("51Y58");
// Timezone (ISO-8601. +00:00 is `'Z'`)
class $6b21cae23f80336f$var$ISOTimezoneWithZParser extends $vxpiD.Parser {
    priority = 10;
    parse(dateString, token) {
        switch(token){
            case "X":
                return (0, $51Y58.parseTimezonePattern)($jZ25V.timezonePatterns.basicOptionalMinutes, dateString);
            case "XX":
                return (0, $51Y58.parseTimezonePattern)($jZ25V.timezonePatterns.basic, dateString);
            case "XXXX":
                return (0, $51Y58.parseTimezonePattern)($jZ25V.timezonePatterns.basicOptionalSeconds, dateString);
            case "XXXXX":
                return (0, $51Y58.parseTimezonePattern)($jZ25V.timezonePatterns.extendedOptionalSeconds, dateString);
            case "XXX":
            default:
                return (0, $51Y58.parseTimezonePattern)($jZ25V.timezonePatterns.extended, dateString);
        }
    }
    set(date, flags, value) {
        if (flags.timestampIsSet) return date;
        return (0, $CS8DB.constructFrom)(date, date.getTime() - (0, $6f1d3.getTimezoneOffsetInMilliseconds)(date) - value);
    }
    incompatibleTokens = [
        "t",
        "T",
        "x"
    ];
}
$6b21cae23f80336f$export$104d901d49fea29b = $6b21cae23f80336f$var$ISOTimezoneWithZParser;

});

parcelRegister("aP8X6", function(module, exports) {

$parcel$export(module.exports, "ISOTimezoneParser", () => $7e159c899c2e4459$export$12910e5204b52b9, (v) => $7e159c899c2e4459$export$12910e5204b52b9 = v);
var $7e159c899c2e4459$export$12910e5204b52b9;
"use strict";
$7e159c899c2e4459$export$12910e5204b52b9 = void 0;

var $CS8DB = parcelRequire("CS8DB");

var $6f1d3 = parcelRequire("6f1d3");

var $jZ25V = parcelRequire("jZ25V");

var $vxpiD = parcelRequire("vxpiD");

var $51Y58 = parcelRequire("51Y58");
// Timezone (ISO-8601)
class $7e159c899c2e4459$var$ISOTimezoneParser extends $vxpiD.Parser {
    priority = 10;
    parse(dateString, token) {
        switch(token){
            case "x":
                return (0, $51Y58.parseTimezonePattern)($jZ25V.timezonePatterns.basicOptionalMinutes, dateString);
            case "xx":
                return (0, $51Y58.parseTimezonePattern)($jZ25V.timezonePatterns.basic, dateString);
            case "xxxx":
                return (0, $51Y58.parseTimezonePattern)($jZ25V.timezonePatterns.basicOptionalSeconds, dateString);
            case "xxxxx":
                return (0, $51Y58.parseTimezonePattern)($jZ25V.timezonePatterns.extendedOptionalSeconds, dateString);
            case "xxx":
            default:
                return (0, $51Y58.parseTimezonePattern)($jZ25V.timezonePatterns.extended, dateString);
        }
    }
    set(date, flags, value) {
        if (flags.timestampIsSet) return date;
        return (0, $CS8DB.constructFrom)(date, date.getTime() - (0, $6f1d3.getTimezoneOffsetInMilliseconds)(date) - value);
    }
    incompatibleTokens = [
        "t",
        "T",
        "X"
    ];
}
$7e159c899c2e4459$export$12910e5204b52b9 = $7e159c899c2e4459$var$ISOTimezoneParser;

});

parcelRegister("lQArz", function(module, exports) {

$parcel$export(module.exports, "TimestampSecondsParser", () => $fe7ab946c0c39610$export$2cd8bf877a05e96, (v) => $fe7ab946c0c39610$export$2cd8bf877a05e96 = v);
var $fe7ab946c0c39610$export$2cd8bf877a05e96;
"use strict";
$fe7ab946c0c39610$export$2cd8bf877a05e96 = void 0;

var $CS8DB = parcelRequire("CS8DB");

var $vxpiD = parcelRequire("vxpiD");

var $51Y58 = parcelRequire("51Y58");
class $fe7ab946c0c39610$var$TimestampSecondsParser extends $vxpiD.Parser {
    priority = 40;
    parse(dateString) {
        return (0, $51Y58.parseAnyDigitsSigned)(dateString);
    }
    set(date, _flags, value) {
        return [
            (0, $CS8DB.constructFrom)(date, value * 1000),
            {
                timestampIsSet: true
            }
        ];
    }
    incompatibleTokens = "*";
}
$fe7ab946c0c39610$export$2cd8bf877a05e96 = $fe7ab946c0c39610$var$TimestampSecondsParser;

});

parcelRegister("4QCDZ", function(module, exports) {

$parcel$export(module.exports, "TimestampMillisecondsParser", () => $3879fea873ebb1c1$export$6d8f69c6906d6368, (v) => $3879fea873ebb1c1$export$6d8f69c6906d6368 = v);
var $3879fea873ebb1c1$export$6d8f69c6906d6368;
"use strict";
$3879fea873ebb1c1$export$6d8f69c6906d6368 = void 0;

var $CS8DB = parcelRequire("CS8DB");

var $vxpiD = parcelRequire("vxpiD");

var $51Y58 = parcelRequire("51Y58");
class $3879fea873ebb1c1$var$TimestampMillisecondsParser extends $vxpiD.Parser {
    priority = 20;
    parse(dateString) {
        return (0, $51Y58.parseAnyDigitsSigned)(dateString);
    }
    set(date, _flags, value) {
        return [
            (0, $CS8DB.constructFrom)(date, value),
            {
                timestampIsSet: true
            }
        ];
    }
    incompatibleTokens = "*";
}
$3879fea873ebb1c1$export$6d8f69c6906d6368 = $3879fea873ebb1c1$var$TimestampMillisecondsParser;

});



parcelRegister("lu2oh", function(module, exports) {

$parcel$export(module.exports, "parseISO", () => $fa3e410abd05cb1d$export$4393d2ccbbedb219, (v) => $fa3e410abd05cb1d$export$4393d2ccbbedb219 = v);
var $fa3e410abd05cb1d$export$4393d2ccbbedb219;
"use strict";
$fa3e410abd05cb1d$export$4393d2ccbbedb219 = $fa3e410abd05cb1d$var$parseISO;

var $4IrbU = parcelRequire("4IrbU");
/**
 * The {@link parseISO} function options.
 */ /**
 * @name parseISO
 * @category Common Helpers
 * @summary Parse ISO string
 *
 * @description
 * Parse the given string in ISO 8601 format and return an instance of Date.
 *
 * Function accepts complete ISO 8601 formats as well as partial implementations.
 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
 *
 * If the argument isn't a string, the function cannot parse the string or
 * the values are invalid, it returns Invalid Date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param argument - The value to convert
 * @param options - An object with options
 *
 * @returns The parsed date in the local time zone
 *
 * @example
 * // Convert string '2014-02-11T11:30:30' to date:
 * const result = parseISO('2014-02-11T11:30:30')
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert string '+02014101' to date,
 * // if the additional number of digits in the extended year format is 1:
 * const result = parseISO('+02014101', { additionalDigits: 1 })
 * //=> Fri Apr 11 2014 00:00:00
 */ function $fa3e410abd05cb1d$var$parseISO(argument, options) {
    const additionalDigits = options?.additionalDigits ?? 2;
    const dateStrings = $fa3e410abd05cb1d$var$splitDateString(argument);
    let date;
    if (dateStrings.date) {
        const parseYearResult = $fa3e410abd05cb1d$var$parseYear(dateStrings.date, additionalDigits);
        date = $fa3e410abd05cb1d$var$parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (!date || isNaN(date.getTime())) return new Date(NaN);
    const timestamp = date.getTime();
    let time = 0;
    let offset;
    if (dateStrings.time) {
        time = $fa3e410abd05cb1d$var$parseTime(dateStrings.time);
        if (isNaN(time)) return new Date(NaN);
    }
    if (dateStrings.timezone) {
        offset = $fa3e410abd05cb1d$var$parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return new Date(NaN);
    } else {
        const dirtyDate = new Date(timestamp + time);
        // JS parsed string assuming it's in UTC timezone
        // but we need it to be parsed in our timezone
        // so we use utc values to build date in our timezone.
        // Year values from 0 to 99 map to the years 1900 to 1999
        // so set year explicitly with setFullYear.
        const result = new Date(0);
        result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
        result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
        return result;
    }
    return new Date(timestamp + time + offset);
}
const $fa3e410abd05cb1d$var$patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
const $fa3e410abd05cb1d$var$dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
const $fa3e410abd05cb1d$var$timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
const $fa3e410abd05cb1d$var$timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function $fa3e410abd05cb1d$var$splitDateString(dateString) {
    const dateStrings = {};
    const array = dateString.split($fa3e410abd05cb1d$var$patterns.dateTimeDelimiter);
    let timeString;
    // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) timeString = array[0];
    else {
        dateStrings.date = array[0];
        timeString = array[1];
        if ($fa3e410abd05cb1d$var$patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split($fa3e410abd05cb1d$var$patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        const token = $fa3e410abd05cb1d$var$patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], "");
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $fa3e410abd05cb1d$var$parseYear(dateString, additionalDigits) {
    const regex = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + additionalDigits) + "})|(\\d{2}|[+-]\\d{" + (2 + additionalDigits) + "})$)");
    const captures = dateString.match(regex);
    // Invalid ISO-formatted year
    if (!captures) return {
        year: NaN,
        restDateString: ""
    };
    const year = captures[1] ? parseInt(captures[1]) : null;
    const century = captures[2] ? parseInt(captures[2]) : null;
    // either year or century is null, not both
    return {
        year: century === null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function $fa3e410abd05cb1d$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return new Date(NaN);
    const captures = dateString.match($fa3e410abd05cb1d$var$dateRegex);
    // Invalid ISO-formatted string
    if (!captures) return new Date(NaN);
    const isWeekDate = !!captures[4];
    const dayOfYear = $fa3e410abd05cb1d$var$parseDateUnit(captures[1]);
    const month = $fa3e410abd05cb1d$var$parseDateUnit(captures[2]) - 1;
    const day = $fa3e410abd05cb1d$var$parseDateUnit(captures[3]);
    const week = $fa3e410abd05cb1d$var$parseDateUnit(captures[4]);
    const dayOfWeek = $fa3e410abd05cb1d$var$parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!$fa3e410abd05cb1d$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $fa3e410abd05cb1d$var$dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        const date = new Date(0);
        if (!$fa3e410abd05cb1d$var$validateDate(year, month, day) || !$fa3e410abd05cb1d$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function $fa3e410abd05cb1d$var$parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function $fa3e410abd05cb1d$var$parseTime(timeString) {
    const captures = timeString.match($fa3e410abd05cb1d$var$timeRegex);
    if (!captures) return NaN; // Invalid ISO-formatted time
    const hours = $fa3e410abd05cb1d$var$parseTimeUnit(captures[1]);
    const minutes = $fa3e410abd05cb1d$var$parseTimeUnit(captures[2]);
    const seconds = $fa3e410abd05cb1d$var$parseTimeUnit(captures[3]);
    if (!$fa3e410abd05cb1d$var$validateTime(hours, minutes, seconds)) return NaN;
    return hours * $4IrbU.millisecondsInHour + minutes * $4IrbU.millisecondsInMinute + seconds * 1000;
}
function $fa3e410abd05cb1d$var$parseTimeUnit(value) {
    return value && parseFloat(value.replace(",", ".")) || 0;
}
function $fa3e410abd05cb1d$var$parseTimezone(timezoneString) {
    if (timezoneString === "Z") return 0;
    const captures = timezoneString.match($fa3e410abd05cb1d$var$timezoneRegex);
    if (!captures) return 0;
    const sign = captures[1] === "+" ? -1 : 1;
    const hours = parseInt(captures[2]);
    const minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!$fa3e410abd05cb1d$var$validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * $4IrbU.millisecondsInHour + minutes * $4IrbU.millisecondsInMinute);
}
function $fa3e410abd05cb1d$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    const date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    const fourthOfJanuaryDay = date.getUTCDay() || 7;
    const diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
// February is null to handle the leap year (using ||)
const $fa3e410abd05cb1d$var$daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $fa3e410abd05cb1d$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $fa3e410abd05cb1d$var$validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= ($fa3e410abd05cb1d$var$daysInMonths[month] || ($fa3e410abd05cb1d$var$isLeapYearIndex(year) ? 29 : 28));
}
function $fa3e410abd05cb1d$var$validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= ($fa3e410abd05cb1d$var$isLeapYearIndex(year) ? 366 : 365);
}
function $fa3e410abd05cb1d$var$validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function $fa3e410abd05cb1d$var$validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function $fa3e410abd05cb1d$var$validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}

});

parcelRegister("iJNol", function(module, exports) {
"use strict";

var $5H9je = parcelRequire("5H9je");
Object.keys($5H9je).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $5H9je[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $5H9je[key];
        }
    });
});

var $gWLtc = parcelRequire("gWLtc");
Object.keys($gWLtc).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $gWLtc[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $gWLtc[key];
        }
    });
});

var $jKYo1 = parcelRequire("jKYo1");
Object.keys($jKYo1).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $jKYo1[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $jKYo1[key];
        }
    });
});

var $2s8DN = parcelRequire("2s8DN");
Object.keys($2s8DN).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $2s8DN[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $2s8DN[key];
        }
    });
});

var $dE5gZ = parcelRequire("dE5gZ");
Object.keys($dE5gZ).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $dE5gZ[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $dE5gZ[key];
        }
    });
});

var $90YsH = parcelRequire("90YsH");
Object.keys($90YsH).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $90YsH[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $90YsH[key];
        }
    });
});

var $hB2gy = parcelRequire("hB2gy");
Object.keys($hB2gy).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $hB2gy[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $hB2gy[key];
        }
    });
});

var $9qaFH = parcelRequire("9qaFH");
Object.keys($9qaFH).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $9qaFH[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $9qaFH[key];
        }
    });
});

var $53mjM = parcelRequire("53mjM");
Object.keys($53mjM).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $53mjM[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $53mjM[key];
        }
    });
});

var $inkHK = parcelRequire("inkHK");
Object.keys($inkHK).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $inkHK[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $inkHK[key];
        }
    });
});

var $41ovE = parcelRequire("41ovE");
Object.keys($41ovE).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $41ovE[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $41ovE[key];
        }
    });
});

var $f17A2 = parcelRequire("f17A2");
Object.keys($f17A2).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $f17A2[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $f17A2[key];
        }
    });
});

var $bkASt = parcelRequire("bkASt");
Object.keys($bkASt).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $bkASt[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $bkASt[key];
        }
    });
});

var $aJphH = parcelRequire("aJphH");
Object.keys($aJphH).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $aJphH[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $aJphH[key];
        }
    });
});

var $3VKcY = parcelRequire("3VKcY");
Object.keys($3VKcY).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $3VKcY[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $3VKcY[key];
        }
    });
});

var $3KBzR = parcelRequire("3KBzR");
Object.keys($3KBzR).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $3KBzR[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $3KBzR[key];
        }
    });
});

var $4CmQQ = parcelRequire("4CmQQ");
Object.keys($4CmQQ).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $4CmQQ[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4CmQQ[key];
        }
    });
});

var $6Itan = parcelRequire("6Itan");
Object.keys($6Itan).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $6Itan[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $6Itan[key];
        }
    });
});

var $CS8DB = parcelRequire("CS8DB");
Object.keys($CS8DB).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $CS8DB[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $CS8DB[key];
        }
    });
});

var $kZMTz = parcelRequire("kZMTz");
Object.keys($kZMTz).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $kZMTz[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $kZMTz[key];
        }
    });
});

var $dpW6v = parcelRequire("dpW6v");
Object.keys($dpW6v).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $dpW6v[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $dpW6v[key];
        }
    });
});

var $hzJYa = parcelRequire("hzJYa");
Object.keys($hzJYa).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $hzJYa[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $hzJYa[key];
        }
    });
});

var $iQfqc = parcelRequire("iQfqc");
Object.keys($iQfqc).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $iQfqc[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $iQfqc[key];
        }
    });
});

var $eiwyY = parcelRequire("eiwyY");
Object.keys($eiwyY).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $eiwyY[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $eiwyY[key];
        }
    });
});

var $lVxGX = parcelRequire("lVxGX");
Object.keys($lVxGX).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $lVxGX[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $lVxGX[key];
        }
    });
});

var $2RSNs = parcelRequire("2RSNs");
Object.keys($2RSNs).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $2RSNs[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $2RSNs[key];
        }
    });
});

var $7gxy6 = parcelRequire("7gxy6");
Object.keys($7gxy6).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $7gxy6[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7gxy6[key];
        }
    });
});

var $4j185 = parcelRequire("4j185");
Object.keys($4j185).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $4j185[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4j185[key];
        }
    });
});

var $lS4EH = parcelRequire("lS4EH");
Object.keys($lS4EH).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $lS4EH[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $lS4EH[key];
        }
    });
});

var $fLrsl = parcelRequire("fLrsl");
Object.keys($fLrsl).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $fLrsl[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $fLrsl[key];
        }
    });
});

var $6QIhv = parcelRequire("6QIhv");
Object.keys($6QIhv).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $6QIhv[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $6QIhv[key];
        }
    });
});

var $iQ4JX = parcelRequire("iQ4JX");
Object.keys($iQ4JX).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $iQ4JX[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $iQ4JX[key];
        }
    });
});

var $4LIFj = parcelRequire("4LIFj");
Object.keys($4LIFj).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $4LIFj[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4LIFj[key];
        }
    });
});

var $aBQYs = parcelRequire("aBQYs");
Object.keys($aBQYs).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $aBQYs[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $aBQYs[key];
        }
    });
});

var $9xdYC = parcelRequire("9xdYC");
Object.keys($9xdYC).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $9xdYC[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $9xdYC[key];
        }
    });
});

var $1i6Jz = parcelRequire("1i6Jz");
Object.keys($1i6Jz).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $1i6Jz[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $1i6Jz[key];
        }
    });
});

var $7fmSP = parcelRequire("7fmSP");
Object.keys($7fmSP).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $7fmSP[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7fmSP[key];
        }
    });
});

var $f1Tmv = parcelRequire("f1Tmv");
Object.keys($f1Tmv).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $f1Tmv[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $f1Tmv[key];
        }
    });
});

var $5GGYt = parcelRequire("5GGYt");
Object.keys($5GGYt).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $5GGYt[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $5GGYt[key];
        }
    });
});

var $eAZln = parcelRequire("eAZln");
Object.keys($eAZln).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $eAZln[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $eAZln[key];
        }
    });
});

var $jkm0U = parcelRequire("jkm0U");
Object.keys($jkm0U).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $jkm0U[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $jkm0U[key];
        }
    });
});

var $3jaLo = parcelRequire("3jaLo");
Object.keys($3jaLo).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $3jaLo[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $3jaLo[key];
        }
    });
});

var $gxpBU = parcelRequire("gxpBU");
Object.keys($gxpBU).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $gxpBU[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $gxpBU[key];
        }
    });
});

var $9aMwB = parcelRequire("9aMwB");
Object.keys($9aMwB).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $9aMwB[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $9aMwB[key];
        }
    });
});

var $70lyU = parcelRequire("70lyU");
Object.keys($70lyU).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $70lyU[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $70lyU[key];
        }
    });
});

var $4BwgI = parcelRequire("4BwgI");
Object.keys($4BwgI).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $4BwgI[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4BwgI[key];
        }
    });
});

var $7WWht = parcelRequire("7WWht");
Object.keys($7WWht).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $7WWht[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7WWht[key];
        }
    });
});

var $gGnfk = parcelRequire("gGnfk");
Object.keys($gGnfk).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $gGnfk[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $gGnfk[key];
        }
    });
});

var $lU13w = parcelRequire("lU13w");
Object.keys($lU13w).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $lU13w[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $lU13w[key];
        }
    });
});

var $2Rm6o = parcelRequire("2Rm6o");
Object.keys($2Rm6o).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $2Rm6o[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $2Rm6o[key];
        }
    });
});

var $gQTSx = parcelRequire("gQTSx");
Object.keys($gQTSx).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $gQTSx[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $gQTSx[key];
        }
    });
});

var $khPe0 = parcelRequire("khPe0");
Object.keys($khPe0).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $khPe0[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $khPe0[key];
        }
    });
});

var $kqT2V = parcelRequire("kqT2V");
Object.keys($kqT2V).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $kqT2V[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $kqT2V[key];
        }
    });
});

var $7FIXx = parcelRequire("7FIXx");
Object.keys($7FIXx).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $7FIXx[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7FIXx[key];
        }
    });
});

var $3pk6v = parcelRequire("3pk6v");
Object.keys($3pk6v).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $3pk6v[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $3pk6v[key];
        }
    });
});

var $ktpEa = parcelRequire("ktpEa");
Object.keys($ktpEa).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $ktpEa[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $ktpEa[key];
        }
    });
});

var $2EhLl = parcelRequire("2EhLl");
Object.keys($2EhLl).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $2EhLl[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $2EhLl[key];
        }
    });
});

var $cudbj = parcelRequire("cudbj");
Object.keys($cudbj).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $cudbj[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $cudbj[key];
        }
    });
});

var $j3Wja = parcelRequire("j3Wja");
Object.keys($j3Wja).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $j3Wja[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $j3Wja[key];
        }
    });
});

var $eKR0J = parcelRequire("eKR0J");
Object.keys($eKR0J).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $eKR0J[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $eKR0J[key];
        }
    });
});

var $igoTU = parcelRequire("igoTU");
Object.keys($igoTU).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $igoTU[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $igoTU[key];
        }
    });
});

var $6qI86 = parcelRequire("6qI86");
Object.keys($6qI86).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $6qI86[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $6qI86[key];
        }
    });
});

var $dmAUx = parcelRequire("dmAUx");
Object.keys($dmAUx).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $dmAUx[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $dmAUx[key];
        }
    });
});

var $4BZg7 = parcelRequire("4BZg7");
Object.keys($4BZg7).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $4BZg7[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4BZg7[key];
        }
    });
});

var $ikvfh = parcelRequire("ikvfh");
Object.keys($ikvfh).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $ikvfh[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $ikvfh[key];
        }
    });
});

var $hyD7d = parcelRequire("hyD7d");
Object.keys($hyD7d).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $hyD7d[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $hyD7d[key];
        }
    });
});

var $fmNnT = parcelRequire("fmNnT");
Object.keys($fmNnT).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $fmNnT[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $fmNnT[key];
        }
    });
});

var $dE2v5 = parcelRequire("dE2v5");
Object.keys($dE2v5).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $dE2v5[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $dE2v5[key];
        }
    });
});

var $keVRV = parcelRequire("keVRV");
Object.keys($keVRV).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $keVRV[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $keVRV[key];
        }
    });
});

var $7fJI0 = parcelRequire("7fJI0");
Object.keys($7fJI0).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $7fJI0[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7fJI0[key];
        }
    });
});

var $fmQhw = parcelRequire("fmQhw");
Object.keys($fmQhw).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $fmQhw[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $fmQhw[key];
        }
    });
});

var $ldJLN = parcelRequire("ldJLN");
Object.keys($ldJLN).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $ldJLN[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $ldJLN[key];
        }
    });
});

var $drbnY = parcelRequire("drbnY");
Object.keys($drbnY).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $drbnY[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $drbnY[key];
        }
    });
});

var $3wSHK = parcelRequire("3wSHK");
Object.keys($3wSHK).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $3wSHK[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $3wSHK[key];
        }
    });
});

var $iDMeT = parcelRequire("iDMeT");
Object.keys($iDMeT).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $iDMeT[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $iDMeT[key];
        }
    });
});

var $jBSa0 = parcelRequire("jBSa0");
Object.keys($jBSa0).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $jBSa0[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $jBSa0[key];
        }
    });
});

var $4uPa5 = parcelRequire("4uPa5");
Object.keys($4uPa5).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $4uPa5[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4uPa5[key];
        }
    });
});

var $gnX0t = parcelRequire("gnX0t");
Object.keys($gnX0t).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $gnX0t[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $gnX0t[key];
        }
    });
});

var $1W5XB = parcelRequire("1W5XB");
Object.keys($1W5XB).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $1W5XB[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $1W5XB[key];
        }
    });
});

var $a8C6h = parcelRequire("a8C6h");
Object.keys($a8C6h).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $a8C6h[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $a8C6h[key];
        }
    });
});

var $0Bn9L = parcelRequire("0Bn9L");
Object.keys($0Bn9L).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $0Bn9L[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $0Bn9L[key];
        }
    });
});

var $eG9SL = parcelRequire("eG9SL");
Object.keys($eG9SL).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $eG9SL[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $eG9SL[key];
        }
    });
});

var $l5B1g = parcelRequire("l5B1g");
Object.keys($l5B1g).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $l5B1g[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $l5B1g[key];
        }
    });
});

var $cQYi9 = parcelRequire("cQYi9");
Object.keys($cQYi9).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $cQYi9[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $cQYi9[key];
        }
    });
});

var $730vp = parcelRequire("730vp");
Object.keys($730vp).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $730vp[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $730vp[key];
        }
    });
});

var $lepTe = parcelRequire("lepTe");
Object.keys($lepTe).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $lepTe[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $lepTe[key];
        }
    });
});

var $4n2mh = parcelRequire("4n2mh");
Object.keys($4n2mh).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $4n2mh[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4n2mh[key];
        }
    });
});

var $cMxE5 = parcelRequire("cMxE5");
Object.keys($cMxE5).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $cMxE5[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $cMxE5[key];
        }
    });
});

var $gtzUl = parcelRequire("gtzUl");
Object.keys($gtzUl).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $gtzUl[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $gtzUl[key];
        }
    });
});

var $kTdkQ = parcelRequire("kTdkQ");
Object.keys($kTdkQ).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $kTdkQ[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $kTdkQ[key];
        }
    });
});

var $cagPs = parcelRequire("cagPs");
Object.keys($cagPs).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $cagPs[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $cagPs[key];
        }
    });
});

var $dQGvM = parcelRequire("dQGvM");
Object.keys($dQGvM).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $dQGvM[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $dQGvM[key];
        }
    });
});

var $2zELa = parcelRequire("2zELa");
Object.keys($2zELa).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $2zELa[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $2zELa[key];
        }
    });
});

var $3ynSJ = parcelRequire("3ynSJ");
Object.keys($3ynSJ).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $3ynSJ[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $3ynSJ[key];
        }
    });
});

var $a54jn = parcelRequire("a54jn");
Object.keys($a54jn).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $a54jn[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $a54jn[key];
        }
    });
});

var $g2WV7 = parcelRequire("g2WV7");
Object.keys($g2WV7).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $g2WV7[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $g2WV7[key];
        }
    });
});

var $b4dlZ = parcelRequire("b4dlZ");
Object.keys($b4dlZ).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $b4dlZ[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $b4dlZ[key];
        }
    });
});

var $51wqx = parcelRequire("51wqx");
Object.keys($51wqx).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $51wqx[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $51wqx[key];
        }
    });
});

var $6MFqj = parcelRequire("6MFqj");
Object.keys($6MFqj).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $6MFqj[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $6MFqj[key];
        }
    });
});

var $dmBSy = parcelRequire("dmBSy");
Object.keys($dmBSy).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $dmBSy[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $dmBSy[key];
        }
    });
});

var $eHbPA = parcelRequire("eHbPA");
Object.keys($eHbPA).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $eHbPA[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $eHbPA[key];
        }
    });
});

var $7Sfl2 = parcelRequire("7Sfl2");
Object.keys($7Sfl2).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $7Sfl2[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7Sfl2[key];
        }
    });
});

var $htdEK = parcelRequire("htdEK");
Object.keys($htdEK).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $htdEK[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $htdEK[key];
        }
    });
});

var $6WMVp = parcelRequire("6WMVp");
Object.keys($6WMVp).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $6WMVp[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $6WMVp[key];
        }
    });
});

var $iaBR8 = parcelRequire("iaBR8");
Object.keys($iaBR8).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $iaBR8[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $iaBR8[key];
        }
    });
});

var $kMqKN = parcelRequire("kMqKN");
Object.keys($kMqKN).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $kMqKN[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $kMqKN[key];
        }
    });
});

var $bCsNV = parcelRequire("bCsNV");
Object.keys($bCsNV).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $bCsNV[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $bCsNV[key];
        }
    });
});

var $3MRYq = parcelRequire("3MRYq");
Object.keys($3MRYq).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $3MRYq[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $3MRYq[key];
        }
    });
});

var $4t8V5 = parcelRequire("4t8V5");
Object.keys($4t8V5).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $4t8V5[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4t8V5[key];
        }
    });
});

var $lXTbz = parcelRequire("lXTbz");
Object.keys($lXTbz).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $lXTbz[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $lXTbz[key];
        }
    });
});

var $36H1l = parcelRequire("36H1l");
Object.keys($36H1l).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $36H1l[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $36H1l[key];
        }
    });
});

var $ewPRS = parcelRequire("ewPRS");
Object.keys($ewPRS).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $ewPRS[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $ewPRS[key];
        }
    });
});

var $l4WOR = parcelRequire("l4WOR");
Object.keys($l4WOR).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $l4WOR[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $l4WOR[key];
        }
    });
});

var $dwsbe = parcelRequire("dwsbe");
Object.keys($dwsbe).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $dwsbe[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $dwsbe[key];
        }
    });
});

var $gWCQM = parcelRequire("gWCQM");
Object.keys($gWCQM).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $gWCQM[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $gWCQM[key];
        }
    });
});

var $jhVjc = parcelRequire("jhVjc");
Object.keys($jhVjc).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $jhVjc[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $jhVjc[key];
        }
    });
});

var $8HFKm = parcelRequire("8HFKm");
Object.keys($8HFKm).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $8HFKm[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $8HFKm[key];
        }
    });
});

var $2iDDY = parcelRequire("2iDDY");
Object.keys($2iDDY).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $2iDDY[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $2iDDY[key];
        }
    });
});

var $8rFE2 = parcelRequire("8rFE2");
Object.keys($8rFE2).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $8rFE2[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $8rFE2[key];
        }
    });
});

var $aibDo = parcelRequire("aibDo");
Object.keys($aibDo).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $aibDo[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $aibDo[key];
        }
    });
});

var $iROfp = parcelRequire("iROfp");
Object.keys($iROfp).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $iROfp[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $iROfp[key];
        }
    });
});

var $cuP5N = parcelRequire("cuP5N");
Object.keys($cuP5N).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $cuP5N[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $cuP5N[key];
        }
    });
});

var $dHmZ5 = parcelRequire("dHmZ5");
Object.keys($dHmZ5).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $dHmZ5[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $dHmZ5[key];
        }
    });
});

var $NHiOX = parcelRequire("NHiOX");
Object.keys($NHiOX).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $NHiOX[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $NHiOX[key];
        }
    });
});

var $7O4IC = parcelRequire("7O4IC");
Object.keys($7O4IC).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $7O4IC[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7O4IC[key];
        }
    });
});

var $4q5v8 = parcelRequire("4q5v8");
Object.keys($4q5v8).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $4q5v8[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4q5v8[key];
        }
    });
});

var $gjoJZ = parcelRequire("gjoJZ");
Object.keys($gjoJZ).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $gjoJZ[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $gjoJZ[key];
        }
    });
});

var $8EXtq = parcelRequire("8EXtq");
Object.keys($8EXtq).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $8EXtq[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $8EXtq[key];
        }
    });
});

var $iJiE0 = parcelRequire("iJiE0");
Object.keys($iJiE0).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $iJiE0[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $iJiE0[key];
        }
    });
});

var $jjrXQ = parcelRequire("jjrXQ");
Object.keys($jjrXQ).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $jjrXQ[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $jjrXQ[key];
        }
    });
});

var $gjgBL = parcelRequire("gjgBL");
Object.keys($gjgBL).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $gjgBL[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $gjgBL[key];
        }
    });
});

var $eHe6N = parcelRequire("eHe6N");
Object.keys($eHe6N).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $eHe6N[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $eHe6N[key];
        }
    });
});

var $cJwvd = parcelRequire("cJwvd");
Object.keys($cJwvd).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $cJwvd[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $cJwvd[key];
        }
    });
});

var $5Haas = parcelRequire("5Haas");
Object.keys($5Haas).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $5Haas[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $5Haas[key];
        }
    });
});

var $iAh6L = parcelRequire("iAh6L");
Object.keys($iAh6L).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $iAh6L[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $iAh6L[key];
        }
    });
});

var $35hFz = parcelRequire("35hFz");
Object.keys($35hFz).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $35hFz[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $35hFz[key];
        }
    });
});

var $2Sf4D = parcelRequire("2Sf4D");
Object.keys($2Sf4D).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $2Sf4D[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $2Sf4D[key];
        }
    });
});

var $5dpcS = parcelRequire("5dpcS");
Object.keys($5dpcS).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $5dpcS[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $5dpcS[key];
        }
    });
});

var $dNnRo = parcelRequire("dNnRo");
Object.keys($dNnRo).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $dNnRo[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $dNnRo[key];
        }
    });
});

var $jPr8s = parcelRequire("jPr8s");
Object.keys($jPr8s).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $jPr8s[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $jPr8s[key];
        }
    });
});

var $5u5yL = parcelRequire("5u5yL");
Object.keys($5u5yL).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $5u5yL[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $5u5yL[key];
        }
    });
});

var $43Rra = parcelRequire("43Rra");
Object.keys($43Rra).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $43Rra[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $43Rra[key];
        }
    });
});

var $690TI = parcelRequire("690TI");
Object.keys($690TI).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $690TI[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $690TI[key];
        }
    });
});

var $Ln4ir = parcelRequire("Ln4ir");
Object.keys($Ln4ir).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $Ln4ir[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $Ln4ir[key];
        }
    });
});

var $gwJip = parcelRequire("gwJip");
Object.keys($gwJip).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $gwJip[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $gwJip[key];
        }
    });
});

var $4qjZG = parcelRequire("4qjZG");
Object.keys($4qjZG).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $4qjZG[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4qjZG[key];
        }
    });
});

var $l0zvm = parcelRequire("l0zvm");
Object.keys($l0zvm).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $l0zvm[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $l0zvm[key];
        }
    });
});

var $1PA9H = parcelRequire("1PA9H");
Object.keys($1PA9H).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $1PA9H[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $1PA9H[key];
        }
    });
});

var $9I5Lz = parcelRequire("9I5Lz");
Object.keys($9I5Lz).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $9I5Lz[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $9I5Lz[key];
        }
    });
});

var $dPXSp = parcelRequire("dPXSp");
Object.keys($dPXSp).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $dPXSp[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $dPXSp[key];
        }
    });
});

var $lAtNI = parcelRequire("lAtNI");
Object.keys($lAtNI).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $lAtNI[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $lAtNI[key];
        }
    });
});

var $bFmPP = parcelRequire("bFmPP");
Object.keys($bFmPP).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $bFmPP[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $bFmPP[key];
        }
    });
});

var $b4jHE = parcelRequire("b4jHE");
Object.keys($b4jHE).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $b4jHE[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $b4jHE[key];
        }
    });
});

var $8pPIp = parcelRequire("8pPIp");
Object.keys($8pPIp).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $8pPIp[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $8pPIp[key];
        }
    });
});

var $fJ6mH = parcelRequire("fJ6mH");
Object.keys($fJ6mH).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $fJ6mH[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $fJ6mH[key];
        }
    });
});

var $2j9aG = parcelRequire("2j9aG");
Object.keys($2j9aG).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $2j9aG[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $2j9aG[key];
        }
    });
});

var $hqqDU = parcelRequire("hqqDU");
Object.keys($hqqDU).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $hqqDU[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $hqqDU[key];
        }
    });
});

var $3Mprz = parcelRequire("3Mprz");
Object.keys($3Mprz).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $3Mprz[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $3Mprz[key];
        }
    });
});

var $7klGw = parcelRequire("7klGw");
Object.keys($7klGw).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $7klGw[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7klGw[key];
        }
    });
});

var $9IDw2 = parcelRequire("9IDw2");
Object.keys($9IDw2).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $9IDw2[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $9IDw2[key];
        }
    });
});

var $QvL3S = parcelRequire("QvL3S");
Object.keys($QvL3S).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $QvL3S[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $QvL3S[key];
        }
    });
});

var $azoGl = parcelRequire("azoGl");
Object.keys($azoGl).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $azoGl[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $azoGl[key];
        }
    });
});

var $hM1St = parcelRequire("hM1St");
Object.keys($hM1St).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $hM1St[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $hM1St[key];
        }
    });
});

var $iwf8x = parcelRequire("iwf8x");
Object.keys($iwf8x).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $iwf8x[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $iwf8x[key];
        }
    });
});

var $5QceI = parcelRequire("5QceI");
Object.keys($5QceI).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $5QceI[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $5QceI[key];
        }
    });
});

var $gyyqC = parcelRequire("gyyqC");
Object.keys($gyyqC).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $gyyqC[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $gyyqC[key];
        }
    });
});

var $5mNbv = parcelRequire("5mNbv");
Object.keys($5mNbv).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $5mNbv[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $5mNbv[key];
        }
    });
});

var $7YgUq = parcelRequire("7YgUq");
Object.keys($7YgUq).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $7YgUq[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7YgUq[key];
        }
    });
});

var $dTYI9 = parcelRequire("dTYI9");
Object.keys($dTYI9).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $dTYI9[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $dTYI9[key];
        }
    });
});

var $gYfAQ = parcelRequire("gYfAQ");
Object.keys($gYfAQ).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $gYfAQ[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $gYfAQ[key];
        }
    });
});

var $ktVHI = parcelRequire("ktVHI");
Object.keys($ktVHI).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $ktVHI[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $ktVHI[key];
        }
    });
});

var $e9kDc = parcelRequire("e9kDc");
Object.keys($e9kDc).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $e9kDc[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $e9kDc[key];
        }
    });
});

var $4AUE7 = parcelRequire("4AUE7");
Object.keys($4AUE7).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $4AUE7[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4AUE7[key];
        }
    });
});

var $l7Fyu = parcelRequire("l7Fyu");
Object.keys($l7Fyu).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $l7Fyu[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $l7Fyu[key];
        }
    });
});

var $ci9cb = parcelRequire("ci9cb");
Object.keys($ci9cb).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $ci9cb[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $ci9cb[key];
        }
    });
});

var $4zRzS = parcelRequire("4zRzS");
Object.keys($4zRzS).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $4zRzS[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4zRzS[key];
        }
    });
});

var $foHqe = parcelRequire("foHqe");
Object.keys($foHqe).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $foHqe[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $foHqe[key];
        }
    });
});

var $lu2oh = parcelRequire("lu2oh");
Object.keys($lu2oh).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $lu2oh[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $lu2oh[key];
        }
    });
});

var $hfXeo = parcelRequire("hfXeo");
Object.keys($hfXeo).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $hfXeo[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $hfXeo[key];
        }
    });
});

var $b6Z7T = parcelRequire("b6Z7T");
Object.keys($b6Z7T).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $b6Z7T[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $b6Z7T[key];
        }
    });
});

var $bK0nt = parcelRequire("bK0nt");
Object.keys($bK0nt).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $bK0nt[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $bK0nt[key];
        }
    });
});

var $k7ZeP = parcelRequire("k7ZeP");
Object.keys($k7ZeP).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $k7ZeP[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $k7ZeP[key];
        }
    });
});

var $996Bm = parcelRequire("996Bm");
Object.keys($996Bm).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $996Bm[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $996Bm[key];
        }
    });
});

var $6nx0Q = parcelRequire("6nx0Q");
Object.keys($6nx0Q).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $6nx0Q[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $6nx0Q[key];
        }
    });
});

var $1aIGH = parcelRequire("1aIGH");
Object.keys($1aIGH).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $1aIGH[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $1aIGH[key];
        }
    });
});

var $uxAEt = parcelRequire("uxAEt");
Object.keys($uxAEt).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $uxAEt[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $uxAEt[key];
        }
    });
});

var $b96Ks = parcelRequire("b96Ks");
Object.keys($b96Ks).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $b96Ks[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $b96Ks[key];
        }
    });
});

var $5pYe9 = parcelRequire("5pYe9");
Object.keys($5pYe9).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $5pYe9[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $5pYe9[key];
        }
    });
});

var $ch9m7 = parcelRequire("ch9m7");
Object.keys($ch9m7).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $ch9m7[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $ch9m7[key];
        }
    });
});

var $8Fm00 = parcelRequire("8Fm00");
Object.keys($8Fm00).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $8Fm00[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $8Fm00[key];
        }
    });
});

var $iMnpE = parcelRequire("iMnpE");
Object.keys($iMnpE).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $iMnpE[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $iMnpE[key];
        }
    });
});

var $896n2 = parcelRequire("896n2");
Object.keys($896n2).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $896n2[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $896n2[key];
        }
    });
});

var $4wX3S = parcelRequire("4wX3S");
Object.keys($4wX3S).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $4wX3S[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4wX3S[key];
        }
    });
});

var $4YV2O = parcelRequire("4YV2O");
Object.keys($4YV2O).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $4YV2O[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4YV2O[key];
        }
    });
});

var $2erB6 = parcelRequire("2erB6");
Object.keys($2erB6).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $2erB6[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $2erB6[key];
        }
    });
});

var $ipvzE = parcelRequire("ipvzE");
Object.keys($ipvzE).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $ipvzE[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $ipvzE[key];
        }
    });
});

var $ktDTG = parcelRequire("ktDTG");
Object.keys($ktDTG).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $ktDTG[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $ktDTG[key];
        }
    });
});

var $7WH2x = parcelRequire("7WH2x");
Object.keys($7WH2x).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $7WH2x[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7WH2x[key];
        }
    });
});

var $gnwRT = parcelRequire("gnwRT");
Object.keys($gnwRT).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $gnwRT[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $gnwRT[key];
        }
    });
});

var $awMyM = parcelRequire("awMyM");
Object.keys($awMyM).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $awMyM[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $awMyM[key];
        }
    });
});

var $hqrZY = parcelRequire("hqrZY");
Object.keys($hqrZY).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $hqrZY[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $hqrZY[key];
        }
    });
});

var $2ztQv = parcelRequire("2ztQv");
Object.keys($2ztQv).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $2ztQv[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $2ztQv[key];
        }
    });
});

var $gGt9b = parcelRequire("gGt9b");
Object.keys($gGt9b).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $gGt9b[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $gGt9b[key];
        }
    });
});

var $bNJqN = parcelRequire("bNJqN");
Object.keys($bNJqN).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $bNJqN[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $bNJqN[key];
        }
    });
});

var $03Fkt = parcelRequire("03Fkt");
Object.keys($03Fkt).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $03Fkt[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $03Fkt[key];
        }
    });
});

var $9N6zy = parcelRequire("9N6zy");
Object.keys($9N6zy).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $9N6zy[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $9N6zy[key];
        }
    });
});

var $aLgYk = parcelRequire("aLgYk");
Object.keys($aLgYk).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $aLgYk[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $aLgYk[key];
        }
    });
});

var $aWlxT = parcelRequire("aWlxT");
Object.keys($aWlxT).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $aWlxT[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $aWlxT[key];
        }
    });
});

var $8l1Su = parcelRequire("8l1Su");
Object.keys($8l1Su).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $8l1Su[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $8l1Su[key];
        }
    });
});

var $h7pJ2 = parcelRequire("h7pJ2");
Object.keys($h7pJ2).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $h7pJ2[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $h7pJ2[key];
        }
    });
});

var $lPouQ = parcelRequire("lPouQ");
Object.keys($lPouQ).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $lPouQ[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $lPouQ[key];
        }
    });
});

var $jqA9A = parcelRequire("jqA9A");
Object.keys($jqA9A).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $jqA9A[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $jqA9A[key];
        }
    });
});

var $8ZHBC = parcelRequire("8ZHBC");
Object.keys($8ZHBC).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $8ZHBC[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $8ZHBC[key];
        }
    });
});

var $77HoA = parcelRequire("77HoA");
Object.keys($77HoA).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $77HoA[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $77HoA[key];
        }
    });
});

var $hxisM = parcelRequire("hxisM");
Object.keys($hxisM).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $hxisM[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $hxisM[key];
        }
    });
});

var $kouFc = parcelRequire("kouFc");
Object.keys($kouFc).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $kouFc[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $kouFc[key];
        }
    });
});

var $biOJg = parcelRequire("biOJg");
Object.keys($biOJg).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $biOJg[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $biOJg[key];
        }
    });
});

var $1c3d7 = parcelRequire("1c3d7");
Object.keys($1c3d7).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $1c3d7[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $1c3d7[key];
        }
    });
});

var $dtQAX = parcelRequire("dtQAX");
Object.keys($dtQAX).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $dtQAX[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $dtQAX[key];
        }
    });
});

var $bvNjp = parcelRequire("bvNjp");
Object.keys($bvNjp).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $bvNjp[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $bvNjp[key];
        }
    });
});

var $d88ys = parcelRequire("d88ys");
Object.keys($d88ys).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $d88ys[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $d88ys[key];
        }
    });
});

var $aSLbu = parcelRequire("aSLbu");
Object.keys($aSLbu).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $aSLbu[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $aSLbu[key];
        }
    });
});

var $fjV92 = parcelRequire("fjV92");
Object.keys($fjV92).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $fjV92[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $fjV92[key];
        }
    });
});

var $icgCh = parcelRequire("icgCh");
Object.keys($icgCh).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $icgCh[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $icgCh[key];
        }
    });
});

var $fya0t = parcelRequire("fya0t");
Object.keys($fya0t).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $fya0t[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $fya0t[key];
        }
    });
});

var $fPXh1 = parcelRequire("fPXh1");
Object.keys($fPXh1).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $fPXh1[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $fPXh1[key];
        }
    });
});

var $6Axmn = parcelRequire("6Axmn");
Object.keys($6Axmn).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $6Axmn[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $6Axmn[key];
        }
    });
});

var $04GVu = parcelRequire("04GVu");
Object.keys($04GVu).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $04GVu[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $04GVu[key];
        }
    });
});

var $6ADMM = parcelRequire("6ADMM");
Object.keys($6ADMM).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $6ADMM[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $6ADMM[key];
        }
    });
});

var $aD97O = parcelRequire("aD97O");
Object.keys($aD97O).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $aD97O[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $aD97O[key];
        }
    });
});

var $7Xcum = parcelRequire("7Xcum");
Object.keys($7Xcum).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $7Xcum[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7Xcum[key];
        }
    });
});

var $7U986 = parcelRequire("7U986");
Object.keys($7U986).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $7U986[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7U986[key];
        }
    });
});

var $e04FR = parcelRequire("e04FR");
Object.keys($e04FR).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $e04FR[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $e04FR[key];
        }
    });
});

var $gRtvC = parcelRequire("gRtvC");
Object.keys($gRtvC).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $gRtvC[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $gRtvC[key];
        }
    });
});

var $4uTtN = parcelRequire("4uTtN");
Object.keys($4uTtN).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $4uTtN[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4uTtN[key];
        }
    });
});

var $l05JD = parcelRequire("l05JD");
Object.keys($l05JD).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $l05JD[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $l05JD[key];
        }
    });
});

var $3kUAA = parcelRequire("3kUAA");
Object.keys($3kUAA).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $3kUAA[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $3kUAA[key];
        }
    });
});

var $26OhI = parcelRequire("26OhI");
Object.keys($26OhI).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $26OhI[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $26OhI[key];
        }
    });
});

var $a8Jzr = parcelRequire("a8Jzr");
Object.keys($a8Jzr).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $a8Jzr[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $a8Jzr[key];
        }
    });
});

var $6g8FL = parcelRequire("6g8FL");
Object.keys($6g8FL).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $6g8FL[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $6g8FL[key];
        }
    });
});

var $b9CkE = parcelRequire("b9CkE");
Object.keys($b9CkE).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $b9CkE[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $b9CkE[key];
        }
    });
});

var $4CpR3 = parcelRequire("4CpR3");
Object.keys($4CpR3).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $4CpR3[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4CpR3[key];
        }
    });
});

var $eS3Uu = parcelRequire("eS3Uu");
Object.keys($eS3Uu).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $eS3Uu[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $eS3Uu[key];
        }
    });
});

});
parcelRegister("5H9je", function(module, exports) {

$parcel$export(module.exports, "add", () => $42583088f11d86bd$export$e16d8520af44a096, (v) => $42583088f11d86bd$export$e16d8520af44a096 = v);
var $42583088f11d86bd$export$e16d8520af44a096;
"use strict";
$42583088f11d86bd$export$e16d8520af44a096 = $42583088f11d86bd$var$add;

var $jKYo1 = parcelRequire("jKYo1");

var $9qaFH = parcelRequire("9qaFH");

var $CS8DB = parcelRequire("CS8DB");

var $26OhI = parcelRequire("26OhI");
/**
 * @name add
 * @category Common Helpers
 * @summary Add the specified years, months, weeks, days, hours, minutes and seconds to the given date.
 *
 * @description
 * Add the specified years, months, weeks, days, hours, minutes and seconds to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param duration - The object with years, months, weeks, days, hours, minutes and seconds to be added.
 *
 * | Key            | Description                        |
 * |----------------|------------------------------------|
 * | years          | Amount of years to be added        |
 * | months         | Amount of months to be added       |
 * | weeks          | Amount of weeks to be added        |
 * | days           | Amount of days to be added         |
 * | hours          | Amount of hours to be added        |
 * | minutes        | Amount of minutes to be added      |
 * | seconds        | Amount of seconds to be added      |
 *
 * All values default to 0
 *
 * @returns The new date with the seconds added
 *
 * @example
 * // Add the following duration to 1 September 2014, 10:19:50
 * const result = add(new Date(2014, 8, 1, 10, 19, 50), {
 *   years: 2,
 *   months: 9,
 *   weeks: 1,
 *   days: 7,
 *   hours: 5,\\-7
 *   minutes: 9,
 *   seconds: 30,
 * })
 * //=> Thu Jun 15 2017 15:29:20
 */ function $42583088f11d86bd$var$add(date, duration) {
    const { years: years = 0, months: months = 0, weeks: weeks = 0, days: days = 0, hours: hours = 0, minutes: minutes = 0, seconds: seconds = 0 } = duration;
    // Add years and months
    const _date = (0, $26OhI.toDate)(date);
    const dateWithMonths = months || years ? (0, $9qaFH.addMonths)(_date, months + years * 12) : _date;
    // Add weeks and days
    const dateWithDays = days || weeks ? (0, $jKYo1.addDays)(dateWithMonths, days + weeks * 7) : dateWithMonths;
    // Add days, hours, minutes and seconds
    const minutesToAdd = minutes + hours * 60;
    const secondsToAdd = seconds + minutesToAdd * 60;
    const msToAdd = secondsToAdd * 1000;
    const finalDate = (0, $CS8DB.constructFrom)(date, dateWithDays.getTime() + msToAdd);
    return finalDate;
}

});

parcelRegister("gWLtc", function(module, exports) {

$parcel$export(module.exports, "addBusinessDays", () => $c566e2adc6b61d98$export$f087b9ada3136ae9, (v) => $c566e2adc6b61d98$export$f087b9ada3136ae9 = v);
var $c566e2adc6b61d98$export$f087b9ada3136ae9;
"use strict";
$c566e2adc6b61d98$export$f087b9ada3136ae9 = $c566e2adc6b61d98$var$addBusinessDays;

var $CS8DB = parcelRequire("CS8DB");

var $gjgBL = parcelRequire("gjgBL");

var $eHe6N = parcelRequire("eHe6N");

var $l0zvm = parcelRequire("l0zvm");

var $26OhI = parcelRequire("26OhI");
/**
 * @name addBusinessDays
 * @category Date Extension Helpers
 * @summary Add the specified number of business days (mon - fri) to the given date.
 *
 * @description
 * Add the specified number of business days (mon - fri) to the given date, ignoring weekends.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of business days to be added.
 *
 * @returns The new date with the business days added
 *
 * @example
 * // Add 10 business days to 1 September 2014:
 * const result = addBusinessDays(new Date(2014, 8, 1), 10)
 * //=> Mon Sep 15 2014 00:00:00 (skipped weekend days)
 */ function $c566e2adc6b61d98$var$addBusinessDays(date, amount) {
    const _date = (0, $26OhI.toDate)(date);
    const startedOnWeekend = (0, $l0zvm.isWeekend)(_date);
    if (isNaN(amount)) return (0, $CS8DB.constructFrom)(date, NaN);
    const hours = _date.getHours();
    const sign = amount < 0 ? -1 : 1;
    const fullWeeks = Math.trunc(amount / 5);
    _date.setDate(_date.getDate() + fullWeeks * 7);
    // Get remaining days not part of a full week
    let restDays = Math.abs(amount % 5);
    // Loops over remaining days
    while(restDays > 0){
        _date.setDate(_date.getDate() + sign);
        if (!(0, $l0zvm.isWeekend)(_date)) restDays -= 1;
    }
    // If the date is a weekend day and we reduce a dividable of
    // 5 from it, we land on a weekend date.
    // To counter this, we add days accordingly to land on the next business day
    if (startedOnWeekend && (0, $l0zvm.isWeekend)(_date) && amount !== 0) {
        // If we're reducing days, we want to add days until we land on a weekday
        // If we're adding days we want to reduce days until we land on a weekday
        if ((0, $gjgBL.isSaturday)(_date)) _date.setDate(_date.getDate() + (sign < 0 ? 2 : -1));
        if ((0, $eHe6N.isSunday)(_date)) _date.setDate(_date.getDate() + (sign < 0 ? 1 : -2));
    }
    // Restore hours to avoid DST lag
    _date.setHours(hours);
    return _date;
}

});
parcelRegister("gjgBL", function(module, exports) {

$parcel$export(module.exports, "isSaturday", () => $bdfb4dbcc3b6d49f$export$def9f260655b3a76, (v) => $bdfb4dbcc3b6d49f$export$def9f260655b3a76 = v);
var $bdfb4dbcc3b6d49f$export$def9f260655b3a76;
"use strict";
$bdfb4dbcc3b6d49f$export$def9f260655b3a76 = $bdfb4dbcc3b6d49f$var$isSaturday;

var $26OhI = parcelRequire("26OhI");
/**
 * @name isSaturday
 * @category Weekday Helpers
 * @summary Is the given date Saturday?
 *
 * @description
 * Is the given date Saturday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Saturday
 *
 * @example
 * // Is 27 September 2014 Saturday?
 * const result = isSaturday(new Date(2014, 8, 27))
 * //=> true
 */ function $bdfb4dbcc3b6d49f$var$isSaturday(date) {
    return (0, $26OhI.toDate)(date).getDay() === 6;
}

});

parcelRegister("eHe6N", function(module, exports) {

$parcel$export(module.exports, "isSunday", () => $ab300685818852ff$export$70f720dfc6028987, (v) => $ab300685818852ff$export$70f720dfc6028987 = v);
var $ab300685818852ff$export$70f720dfc6028987;
"use strict";
$ab300685818852ff$export$70f720dfc6028987 = $ab300685818852ff$var$isSunday;

var $26OhI = parcelRequire("26OhI");
/**
 * @name isSunday
 * @category Weekday Helpers
 * @summary Is the given date Sunday?
 *
 * @description
 * Is the given date Sunday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Sunday
 *
 * @example
 * // Is 21 September 2014 Sunday?
 * const result = isSunday(new Date(2014, 8, 21))
 * //=> true
 */ function $ab300685818852ff$var$isSunday(date) {
    return (0, $26OhI.toDate)(date).getDay() === 0;
}

});

parcelRegister("l0zvm", function(module, exports) {

$parcel$export(module.exports, "isWeekend", () => $f4b5239959c8614f$export$618d60ea299da42, (v) => $f4b5239959c8614f$export$618d60ea299da42 = v);
var $f4b5239959c8614f$export$618d60ea299da42;
"use strict";
$f4b5239959c8614f$export$618d60ea299da42 = $f4b5239959c8614f$var$isWeekend;

var $26OhI = parcelRequire("26OhI");
/**
 * @name isWeekend
 * @category Weekday Helpers
 * @summary Does the given date fall on a weekend?
 *
 * @description
 * Does the given date fall on a weekend?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date falls on a weekend
 *
 * @example
 * // Does 5 October 2014 fall on a weekend?
 * const result = isWeekend(new Date(2014, 9, 5))
 * //=> true
 */ function $f4b5239959c8614f$var$isWeekend(date) {
    const day = (0, $26OhI.toDate)(date).getDay();
    return day === 0 || day === 6;
}

});


parcelRegister("dE5gZ", function(module, exports) {

$parcel$export(module.exports, "addISOWeekYears", () => $9ef319e24d892e77$export$c8240694da10d5f, (v) => $9ef319e24d892e77$export$c8240694da10d5f = v);
var $9ef319e24d892e77$export$c8240694da10d5f;
"use strict";
$9ef319e24d892e77$export$c8240694da10d5f = $9ef319e24d892e77$var$addISOWeekYears;

var $lepTe = parcelRequire("lepTe");

var $2ztQv = parcelRequire("2ztQv");
/**
 * @name addISOWeekYears
 * @category ISO Week-Numbering Year Helpers
 * @summary Add the specified number of ISO week-numbering years to the given date.
 *
 * @description
 * Add the specified number of ISO week-numbering years to the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of ISO week-numbering years to be added.
 *
 * @returns The new date with the ISO week-numbering years added
 *
 * @example
 * // Add 5 ISO week-numbering years to 2 July 2010:
 * const result = addISOWeekYears(new Date(2010, 6, 2), 5)
 * //=> Fri Jn 26 2015 00:00:00
 */ function $9ef319e24d892e77$var$addISOWeekYears(date, amount) {
    return (0, $2ztQv.setISOWeekYear)(date, (0, $lepTe.getISOWeekYear)(date) + amount);
}

});
parcelRegister("2ztQv", function(module, exports) {

$parcel$export(module.exports, "setISOWeekYear", () => $1df6006e9dcdfd39$export$814397aabf10ab77, (v) => $1df6006e9dcdfd39$export$814397aabf10ab77 = v);
var $1df6006e9dcdfd39$export$814397aabf10ab77;
"use strict";
$1df6006e9dcdfd39$export$814397aabf10ab77 = $1df6006e9dcdfd39$var$setISOWeekYear;

var $CS8DB = parcelRequire("CS8DB");

var $hzJYa = parcelRequire("hzJYa");

var $hxisM = parcelRequire("hxisM");

var $26OhI = parcelRequire("26OhI");
/**
 * @name setISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Set the ISO week-numbering year to the given date.
 *
 * @description
 * Set the ISO week-numbering year to the given date,
 * saving the week number and the weekday number.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param weekYear - The ISO week-numbering year of the new date
 *
 * @returns The new date with the ISO week-numbering year set
 *
 * @example
 * // Set ISO week-numbering year 2007 to 29 December 2008:
 * const result = setISOWeekYear(new Date(2008, 11, 29), 2007)
 * //=> Mon Jan 01 2007 00:00:00
 */ function $1df6006e9dcdfd39$var$setISOWeekYear(date, weekYear) {
    let _date = (0, $26OhI.toDate)(date);
    const diff = (0, $hzJYa.differenceInCalendarDays)(_date, (0, $hxisM.startOfISOWeekYear)(_date));
    const fourthOfJanuary = (0, $CS8DB.constructFrom)(date, 0);
    fourthOfJanuary.setFullYear(weekYear, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    _date = (0, $hxisM.startOfISOWeekYear)(fourthOfJanuary);
    _date.setDate(_date.getDate() + diff);
    return _date;
}

});


parcelRegister("inkHK", function(module, exports) {

$parcel$export(module.exports, "addSeconds", () => $d60a6f8160a85fef$export$3cb31b0df13be68, (v) => $d60a6f8160a85fef$export$3cb31b0df13be68 = v);
var $d60a6f8160a85fef$export$3cb31b0df13be68;
"use strict";
$d60a6f8160a85fef$export$3cb31b0df13be68 = $d60a6f8160a85fef$var$addSeconds;

var $90YsH = parcelRequire("90YsH");
/**
 * @name addSeconds
 * @category Second Helpers
 * @summary Add the specified number of seconds to the given date.
 *
 * @description
 * Add the specified number of seconds to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of seconds to be added.
 *
 * @returns The new date with the seconds added
 *
 * @example
 * // Add 30 seconds to 10 July 2014 12:45:00:
 * const result = addSeconds(new Date(2014, 6, 10, 12, 45, 0), 30)
 * //=> Thu Jul 10 2014 12:45:30
 */ function $d60a6f8160a85fef$var$addSeconds(date, amount) {
    return (0, $90YsH.addMilliseconds)(date, amount * 1000);
}

});

parcelRegister("bkASt", function(module, exports) {

$parcel$export(module.exports, "areIntervalsOverlapping", () => $83fe2b179496b33c$export$2bf3385645436101, (v) => $83fe2b179496b33c$export$2bf3385645436101 = v);
var $83fe2b179496b33c$export$2bf3385645436101;
"use strict";
$83fe2b179496b33c$export$2bf3385645436101 = $83fe2b179496b33c$var$areIntervalsOverlapping;

var $26OhI = parcelRequire("26OhI");
/**
 * The {@link areIntervalsOverlapping} function options.
 */ /**
 * @name areIntervalsOverlapping
 * @category Interval Helpers
 * @summary Is the given time interval overlapping with another time interval?
 *
 * @description
 * Is the given time interval overlapping with another time interval? Adjacent intervals do not count as overlapping unless `inclusive` is set to `true`.
 *
 * @param intervalLeft - The first interval to compare.
 * @param intervalRight - The second interval to compare.
 * @param options - The object with options
 *
 * @returns Whether the time intervals are overlapping
 *
 * @example
 * // For overlapping time intervals:
 * areIntervalsOverlapping(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 17), end: new Date(2014, 0, 21) }
 * )
 * //=> true
 *
 * @example
 * // For non-overlapping time intervals:
 * areIntervalsOverlapping(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 21), end: new Date(2014, 0, 22) }
 * )
 * //=> false
 *
 * @example
 * // For adjacent time intervals:
 * areIntervalsOverlapping(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 20), end: new Date(2014, 0, 30) }
 * )
 * //=> false
 *
 * @example
 * // Using the inclusive option:
 * areIntervalsOverlapping(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 20), end: new Date(2014, 0, 24) }
 * )
 * //=> false
 *
 * @example
 * areIntervalsOverlapping(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 20), end: new Date(2014, 0, 24) },
 *   { inclusive: true }
 * )
 * //=> true
 */ function $83fe2b179496b33c$var$areIntervalsOverlapping(intervalLeft, intervalRight, options) {
    const [leftStartTime, leftEndTime] = [
        +(0, $26OhI.toDate)(intervalLeft.start),
        +(0, $26OhI.toDate)(intervalLeft.end)
    ].sort((a, b)=>a - b);
    const [rightStartTime, rightEndTime] = [
        +(0, $26OhI.toDate)(intervalRight.start),
        +(0, $26OhI.toDate)(intervalRight.end)
    ].sort((a, b)=>a - b);
    if (options?.inclusive) return leftStartTime <= rightEndTime && rightStartTime <= leftEndTime;
    return leftStartTime < rightEndTime && rightStartTime < leftEndTime;
}

});

parcelRegister("aJphH", function(module, exports) {

$parcel$export(module.exports, "clamp", () => $7d01b85761d3a89e$export$7d15b64cf5a3a4c4, (v) => $7d01b85761d3a89e$export$7d15b64cf5a3a4c4 = v);
var $7d01b85761d3a89e$export$7d15b64cf5a3a4c4;
"use strict";
$7d01b85761d3a89e$export$7d15b64cf5a3a4c4 = $7d01b85761d3a89e$var$clamp;

var $3Mprz = parcelRequire("3Mprz");

var $hM1St = parcelRequire("hM1St");
/**
 * @name clamp
 * @category Interval Helpers
 * @summary Return a date bounded by the start and the end of the given interval
 *
 * @description
 * Clamps a date to the lower bound with the start of the interval and the upper
 * bound with the end of the interval.
 *
 * - When the date is less than the start of the interval, the start is returned.
 * - When the date is greater than the end of the interval, the end is returned.
 * - Otherwise the date is returned.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be bounded
 * @param interval - The interval to bound to
 *
 * @returns The date bounded by the start and the end of the interval
 *
 * @example
 * // What is Mar, 21, 2021 bounded to an interval starting at Mar, 22, 2021 and ending at Apr, 01, 2021
 * const result = clamp(new Date(2021, 2, 21), {
 *   start: new Date(2021, 2, 22),
 *   end: new Date(2021, 3, 1),
 * })
 * //=> Mon Mar 22 2021 00:00:00
 */ function $7d01b85761d3a89e$var$clamp(date, interval) {
    return (0, $hM1St.min)([
        (0, $3Mprz.max)([
            date,
            interval.start
        ]),
        interval.end
    ]);
}

});

parcelRegister("3VKcY", function(module, exports) {

$parcel$export(module.exports, "closestIndexTo", () => $2dca89f58a9c4bec$export$42127b72a9d091c7, (v) => $2dca89f58a9c4bec$export$42127b72a9d091c7 = v);
var $2dca89f58a9c4bec$export$42127b72a9d091c7;
"use strict";
$2dca89f58a9c4bec$export$42127b72a9d091c7 = $2dca89f58a9c4bec$var$closestIndexTo;

var $26OhI = parcelRequire("26OhI");
/**
 * @name closestIndexTo
 * @category Common Helpers
 * @summary Return an index of the closest date from the array comparing to the given date.
 *
 * @description
 * Return an index of the closest date from the array comparing to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateToCompare - The date to compare with
 * @param dates - The array to search
 *
 * @returns An index of the date closest to the given date or undefined if no valid value is given
 *
 * @example
 * // Which date is closer to 6 September 2015?
 * const dateToCompare = new Date(2015, 8, 6)
 * const datesArray = [
 *   new Date(2015, 0, 1),
 *   new Date(2016, 0, 1),
 *   new Date(2017, 0, 1)
 * ]
 * const result = closestIndexTo(dateToCompare, datesArray)
 * //=> 1
 */ function $2dca89f58a9c4bec$var$closestIndexTo(dateToCompare, dates) {
    const date = (0, $26OhI.toDate)(dateToCompare);
    if (isNaN(Number(date))) return NaN;
    const timeToCompare = date.getTime();
    let result;
    let minDistance;
    dates.forEach(function(dirtyDate, index) {
        const currentDate = (0, $26OhI.toDate)(dirtyDate);
        if (isNaN(Number(currentDate))) {
            result = NaN;
            minDistance = NaN;
            return;
        }
        const distance = Math.abs(timeToCompare - currentDate.getTime());
        if (result == null || distance < minDistance) {
            result = index;
            minDistance = distance;
        }
    });
    return result;
}

});

parcelRegister("3KBzR", function(module, exports) {

$parcel$export(module.exports, "closestTo", () => $2bb2d10f36242c86$export$73858b464497125a, (v) => $2bb2d10f36242c86$export$73858b464497125a = v);
var $2bb2d10f36242c86$export$73858b464497125a;
"use strict";
$2bb2d10f36242c86$export$73858b464497125a = $2bb2d10f36242c86$var$closestTo;

var $CS8DB = parcelRequire("CS8DB");

var $26OhI = parcelRequire("26OhI");
/**
 * @name closestTo
 * @category Common Helpers
 * @summary Return a date from the array closest to the given date.
 *
 * @description
 * Return a date from the array closest to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateToCompare - The date to compare with
 * @param dates - The array to search
 *
 * @returns The date from the array closest to the given date or undefined if no valid value is given
 *
 * @example
 * // Which date is closer to 6 September 2015: 1 January 2000 or 1 January 2030?
 * const dateToCompare = new Date(2015, 8, 6)
 * const result = closestTo(dateToCompare, [
 *   new Date(2000, 0, 1),
 *   new Date(2030, 0, 1)
 * ])
 * //=> Tue Jan 01 2030 00:00:00
 */ function $2bb2d10f36242c86$var$closestTo(dateToCompare, dates) {
    const date = (0, $26OhI.toDate)(dateToCompare);
    if (isNaN(Number(date))) return (0, $CS8DB.constructFrom)(dateToCompare, NaN);
    const timeToCompare = date.getTime();
    let result;
    let minDistance;
    dates.forEach((dirtyDate)=>{
        const currentDate = (0, $26OhI.toDate)(dirtyDate);
        if (isNaN(Number(currentDate))) {
            result = (0, $CS8DB.constructFrom)(dateToCompare, NaN);
            minDistance = NaN;
            return;
        }
        const distance = Math.abs(timeToCompare - currentDate.getTime());
        if (result == null || distance < minDistance) {
            result = currentDate;
            minDistance = distance;
        }
    });
    return result;
}

});

parcelRegister("4CmQQ", function(module, exports) {

$parcel$export(module.exports, "compareAsc", () => $35cc6fd845fe381e$export$fe114145ae75d197, (v) => $35cc6fd845fe381e$export$fe114145ae75d197 = v);
var $35cc6fd845fe381e$export$fe114145ae75d197;
"use strict";
$35cc6fd845fe381e$export$fe114145ae75d197 = $35cc6fd845fe381e$var$compareAsc;

var $26OhI = parcelRequire("26OhI");
/**
 * @name compareAsc
 * @category Common Helpers
 * @summary Compare the two dates and return -1, 0 or 1.
 *
 * @description
 * Compare the two dates and return 1 if the first date is after the second,
 * -1 if the first date is before the second or 0 if dates are equal.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to compare
 * @param dateRight - The second date to compare
 *
 * @returns The result of the comparison
 *
 * @example
 * // Compare 11 February 1987 and 10 July 1989:
 * const result = compareAsc(new Date(1987, 1, 11), new Date(1989, 6, 10))
 * //=> -1
 *
 * @example
 * // Sort the array of dates:
 * const result = [
 *   new Date(1995, 6, 2),
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * ].sort(compareAsc)
 * //=> [
 * //   Wed Feb 11 1987 00:00:00,
 * //   Mon Jul 10 1989 00:00:00,
 * //   Sun Jul 02 1995 00:00:00
 * // ]
 */ function $35cc6fd845fe381e$var$compareAsc(dateLeft, dateRight) {
    const _dateLeft = (0, $26OhI.toDate)(dateLeft);
    const _dateRight = (0, $26OhI.toDate)(dateRight);
    const diff = _dateLeft.getTime() - _dateRight.getTime();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}

});

parcelRegister("6Itan", function(module, exports) {

$parcel$export(module.exports, "compareDesc", () => $4e3d79f4e7d7ab80$export$ed84005ac9356f7a, (v) => $4e3d79f4e7d7ab80$export$ed84005ac9356f7a = v);
var $4e3d79f4e7d7ab80$export$ed84005ac9356f7a;
"use strict";
$4e3d79f4e7d7ab80$export$ed84005ac9356f7a = $4e3d79f4e7d7ab80$var$compareDesc;

var $26OhI = parcelRequire("26OhI");
/**
 * @name compareDesc
 * @category Common Helpers
 * @summary Compare the two dates reverse chronologically and return -1, 0 or 1.
 *
 * @description
 * Compare the two dates and return -1 if the first date is after the second,
 * 1 if the first date is before the second or 0 if dates are equal.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to compare
 * @param dateRight - The second date to compare
 *
 * @returns The result of the comparison
 *
 * @example
 * // Compare 11 February 1987 and 10 July 1989 reverse chronologically:
 * const result = compareDesc(new Date(1987, 1, 11), new Date(1989, 6, 10))
 * //=> 1
 *
 * @example
 * // Sort the array of dates in reverse chronological order:
 * const result = [
 *   new Date(1995, 6, 2),
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * ].sort(compareDesc)
 * //=> [
 * //   Sun Jul 02 1995 00:00:00,
 * //   Mon Jul 10 1989 00:00:00,
 * //   Wed Feb 11 1987 00:00:00
 * // ]
 */ function $4e3d79f4e7d7ab80$var$compareDesc(dateLeft, dateRight) {
    const _dateLeft = (0, $26OhI.toDate)(dateLeft);
    const _dateRight = (0, $26OhI.toDate)(dateRight);
    const diff = _dateLeft.getTime() - _dateRight.getTime();
    if (diff > 0) return -1;
    else if (diff < 0) return 1;
    else return diff;
}

});

parcelRegister("kZMTz", function(module, exports) {

$parcel$export(module.exports, "daysToWeeks", () => $f48f6ebb82ffa066$export$66d8b66cbb6006a8, (v) => $f48f6ebb82ffa066$export$66d8b66cbb6006a8 = v);
var $f48f6ebb82ffa066$export$66d8b66cbb6006a8;
"use strict";
$f48f6ebb82ffa066$export$66d8b66cbb6006a8 = $f48f6ebb82ffa066$var$daysToWeeks;

var $4IrbU = parcelRequire("4IrbU");
/**
 * @name daysToWeeks
 * @category Conversion Helpers
 * @summary Convert days to weeks.
 *
 * @description
 * Convert a number of days to a full number of weeks.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param days - The number of days to be converted
 *
 * @returns The number of days converted in weeks
 *
 * @example
 * // Convert 14 days to weeks:
 * const result = daysToWeeks(14)
 * //=> 2
 *
 * @example
 * // It uses trunc rounding:
 * const result = daysToWeeks(13)
 * //=> 1
 */ function $f48f6ebb82ffa066$var$daysToWeeks(days) {
    const weeks = days / $4IrbU.daysInWeek;
    return Math.trunc(weeks);
}

});

parcelRegister("dpW6v", function(module, exports) {

$parcel$export(module.exports, "differenceInBusinessDays", () => $9c4aae618fd4ba5a$export$f30d3269a6c53cb9, (v) => $9c4aae618fd4ba5a$export$f30d3269a6c53cb9 = v);
var $9c4aae618fd4ba5a$export$f30d3269a6c53cb9;
"use strict";
$9c4aae618fd4ba5a$export$f30d3269a6c53cb9 = $9c4aae618fd4ba5a$var$differenceInBusinessDays;

var $jKYo1 = parcelRequire("jKYo1");

var $hzJYa = parcelRequire("hzJYa");

var $iROfp = parcelRequire("iROfp");

var $gwJip = parcelRequire("gwJip");

var $l0zvm = parcelRequire("l0zvm");

var $26OhI = parcelRequire("26OhI");
/**
 * @name differenceInBusinessDays
 * @category Day Helpers
 * @summary Get the number of business days between the given dates.
 *
 * @description
 * Get the number of business day periods between the given dates.
 * Business days being days that arent in the weekend.
 * Like `differenceInCalendarDays`, the function removes the times from
 * the dates before calculating the difference.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of business days
 *
 * @example
 * // How many business days are between
 * // 10 January 2014 and 20 July 2014?
 * const result = differenceInBusinessDays(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 0, 10)
 * )
 * //=> 136
 *
 * // How many business days are between
 * // 30 November 2021 and 1 November 2021?
 * const result = differenceInBusinessDays(
 *   new Date(2021, 10, 30),
 *   new Date(2021, 10, 1)
 * )
 * //=> 21
 *
 * // How many business days are between
 * // 1 November 2021 and 1 December 2021?
 * const result = differenceInBusinessDays(
 *   new Date(2021, 10, 1),
 *   new Date(2021, 11, 1)
 * )
 * //=> -22
 *
 * // How many business days are between
 * // 1 November 2021 and 1 November 2021 ?
 * const result = differenceInBusinessDays(
 *   new Date(2021, 10, 1),
 *   new Date(2021, 10, 1)
 * )
 * //=> 0
 */ function $9c4aae618fd4ba5a$var$differenceInBusinessDays(dateLeft, dateRight) {
    const _dateLeft = (0, $26OhI.toDate)(dateLeft);
    let _dateRight = (0, $26OhI.toDate)(dateRight);
    if (!(0, $gwJip.isValid)(_dateLeft) || !(0, $gwJip.isValid)(_dateRight)) return NaN;
    const calendarDifference = (0, $hzJYa.differenceInCalendarDays)(_dateLeft, _dateRight);
    const sign = calendarDifference < 0 ? -1 : 1;
    const weeks = Math.trunc(calendarDifference / 7);
    let result = weeks * 5;
    _dateRight = (0, $jKYo1.addDays)(_dateRight, weeks * 7);
    // the loop below will run at most 6 times to account for the remaining days that don't makeup a full week
    while(!(0, $iROfp.isSameDay)(_dateLeft, _dateRight)){
        // sign is used to account for both negative and positive differences
        result += (0, $l0zvm.isWeekend)(_dateRight) ? 0 : sign;
        _dateRight = (0, $jKYo1.addDays)(_dateRight, sign);
    }
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

});

parcelRegister("iQfqc", function(module, exports) {

$parcel$export(module.exports, "differenceInCalendarISOWeekYears", () => $038a35ddc2bc6c16$export$7f8a73dc2e50a070, (v) => $038a35ddc2bc6c16$export$7f8a73dc2e50a070 = v);
var $038a35ddc2bc6c16$export$7f8a73dc2e50a070;
"use strict";
$038a35ddc2bc6c16$export$7f8a73dc2e50a070 = $038a35ddc2bc6c16$var$differenceInCalendarISOWeekYears;

var $lepTe = parcelRequire("lepTe");
/**
 * @name differenceInCalendarISOWeekYears
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the number of calendar ISO week-numbering years between the given dates.
 *
 * @description
 * Get the number of calendar ISO week-numbering years between the given dates.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of calendar ISO week-numbering years
 *
 * @example
 * // How many calendar ISO week-numbering years are 1 January 2010 and 1 January 2012?
 * const result = differenceInCalendarISOWeekYears(
 *   new Date(2012, 0, 1),
 *   new Date(2010, 0, 1)
 * )
 * //=> 2
 */ function $038a35ddc2bc6c16$var$differenceInCalendarISOWeekYears(dateLeft, dateRight) {
    return (0, $lepTe.getISOWeekYear)(dateLeft) - (0, $lepTe.getISOWeekYear)(dateRight);
}

});

parcelRegister("eiwyY", function(module, exports) {

$parcel$export(module.exports, "differenceInCalendarISOWeeks", () => $a68c017cea4f33c8$export$28df1cb58b17e450, (v) => $a68c017cea4f33c8$export$28df1cb58b17e450 = v);
var $a68c017cea4f33c8$export$28df1cb58b17e450;
"use strict";
$a68c017cea4f33c8$export$28df1cb58b17e450 = $a68c017cea4f33c8$var$differenceInCalendarISOWeeks;

var $4IrbU = parcelRequire("4IrbU");

var $77HoA = parcelRequire("77HoA");

var $6f1d3 = parcelRequire("6f1d3");
/**
 * @name differenceInCalendarISOWeeks
 * @category ISO Week Helpers
 * @summary Get the number of calendar ISO weeks between the given dates.
 *
 * @description
 * Get the number of calendar ISO weeks between the given dates.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of calendar ISO weeks
 *
 * @example
 * // How many calendar ISO weeks are between 6 July 2014 and 21 July 2014?
 * const result = differenceInCalendarISOWeeks(
 *   new Date(2014, 6, 21),
 *   new Date(2014, 6, 6)
 * )
 * //=> 3
 */ function $a68c017cea4f33c8$var$differenceInCalendarISOWeeks(dateLeft, dateRight) {
    const startOfISOWeekLeft = (0, $77HoA.startOfISOWeek)(dateLeft);
    const startOfISOWeekRight = (0, $77HoA.startOfISOWeek)(dateRight);
    const timestampLeft = +startOfISOWeekLeft - (0, $6f1d3.getTimezoneOffsetInMilliseconds)(startOfISOWeekLeft);
    const timestampRight = +startOfISOWeekRight - (0, $6f1d3.getTimezoneOffsetInMilliseconds)(startOfISOWeekRight);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round((timestampLeft - timestampRight) / $4IrbU.millisecondsInWeek);
}

});

parcelRegister("7gxy6", function(module, exports) {

$parcel$export(module.exports, "differenceInCalendarWeeks", () => $54a40d25e3581a4b$export$6ed034ce62348e4, (v) => $54a40d25e3581a4b$export$6ed034ce62348e4 = v);
var $54a40d25e3581a4b$export$6ed034ce62348e4;
"use strict";
$54a40d25e3581a4b$export$6ed034ce62348e4 = $54a40d25e3581a4b$var$differenceInCalendarWeeks;

var $4IrbU = parcelRequire("4IrbU");

var $aSLbu = parcelRequire("aSLbu");

var $6f1d3 = parcelRequire("6f1d3");
/**
 * The {@link differenceInCalendarWeeks} function options.
 */ /**
 * @name differenceInCalendarWeeks
 * @category Week Helpers
 * @summary Get the number of calendar weeks between the given dates.
 *
 * @description
 * Get the number of calendar weeks between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 * @param options - An object with options.
 *
 * @returns The number of calendar weeks
 *
 * @example
 * // How many calendar weeks are between 5 July 2014 and 20 July 2014?
 * const result = differenceInCalendarWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5)
 * )
 * //=> 3
 *
 * @example
 * // If the week starts on Monday,
 * // how many calendar weeks are between 5 July 2014 and 20 July 2014?
 * const result = differenceInCalendarWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5),
 *   { weekStartsOn: 1 }
 * )
 * //=> 2
 */ function $54a40d25e3581a4b$var$differenceInCalendarWeeks(dateLeft, dateRight, options) {
    const startOfWeekLeft = (0, $aSLbu.startOfWeek)(dateLeft, options);
    const startOfWeekRight = (0, $aSLbu.startOfWeek)(dateRight, options);
    const timestampLeft = +startOfWeekLeft - (0, $6f1d3.getTimezoneOffsetInMilliseconds)(startOfWeekLeft);
    const timestampRight = +startOfWeekRight - (0, $6f1d3.getTimezoneOffsetInMilliseconds)(startOfWeekRight);
    // Round the number of days to the nearest integer because the number of
    // milliseconds in a days is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round((timestampLeft - timestampRight) / $4IrbU.millisecondsInWeek);
}

});

parcelRegister("lS4EH", function(module, exports) {

$parcel$export(module.exports, "differenceInDays", () => $fec24099506cd35a$export$86415ebf4eb36b8c, (v) => $fec24099506cd35a$export$86415ebf4eb36b8c = v);
var $fec24099506cd35a$export$86415ebf4eb36b8c;
"use strict";
$fec24099506cd35a$export$86415ebf4eb36b8c = $fec24099506cd35a$var$differenceInDays;

var $hzJYa = parcelRequire("hzJYa");

var $26OhI = parcelRequire("26OhI");
/**
 * @name differenceInDays
 * @category Day Helpers
 * @summary Get the number of full days between the given dates.
 *
 * @description
 * Get the number of full day periods between two dates. Fractional days are
 * truncated towards zero.
 *
 * One "full day" is the distance between a local time in one day to the same
 * local time on the next or previous day. A full day can sometimes be less than
 * or more than 24 hours if a daylight savings change happens between two dates.
 *
 * To ignore DST and only measure exact 24-hour periods, use this instead:
 * `Math.trunc(differenceInHours(dateLeft, dateRight)/24)|0`.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of full days according to the local timezone
 *
 * @example
 * // How many full days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * const result = differenceInDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 365
 *
 * @example
 * // How many full days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * const result = differenceInDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 0
 *
 * @example
 * // How many full days are between
 * // 1 March 2020 0:00 and 1 June 2020 0:00 ?
 * // Note: because local time is used, the
 * // result will always be 92 days, even in
 * // time zones where DST starts and the
 * // period has only 92*24-1 hours.
 * const result = differenceInDays(
 *   new Date(2020, 5, 1),
 *   new Date(2020, 2, 1)
 * )
 * //=> 92
 */ function $fec24099506cd35a$var$differenceInDays(dateLeft, dateRight) {
    const _dateLeft = (0, $26OhI.toDate)(dateLeft);
    const _dateRight = (0, $26OhI.toDate)(dateRight);
    const sign = $fec24099506cd35a$var$compareLocalAsc(_dateLeft, _dateRight);
    const difference = Math.abs((0, $hzJYa.differenceInCalendarDays)(_dateLeft, _dateRight));
    _dateLeft.setDate(_dateLeft.getDate() - sign * difference);
    // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
    // If so, result must be decreased by 1 in absolute value
    const isLastDayNotFull = Number($fec24099506cd35a$var$compareLocalAsc(_dateLeft, _dateRight) === -sign);
    const result = sign * (difference - isLastDayNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}
// Like `compareAsc` but uses local time not UTC, which is needed
// for accurate equality comparisons of UTC timestamps that end up
// having the same representation in local time, e.g. one hour before
// DST ends vs. the instant that DST ends.
function $fec24099506cd35a$var$compareLocalAsc(dateLeft, dateRight) {
    const diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}

});

parcelRegister("fLrsl", function(module, exports) {

$parcel$export(module.exports, "differenceInHours", () => $b7a08affd3a35cbd$export$5436ca250d4d6872, (v) => $b7a08affd3a35cbd$export$5436ca250d4d6872 = v);
var $b7a08affd3a35cbd$export$5436ca250d4d6872;
"use strict";
$b7a08affd3a35cbd$export$5436ca250d4d6872 = $b7a08affd3a35cbd$var$differenceInHours;

var $60GiW = parcelRequire("60GiW");

var $4IrbU = parcelRequire("4IrbU");

var $iQ4JX = parcelRequire("iQ4JX");
/**
 * The {@link differenceInHours} function options.
 */ /**
 * @name differenceInHours
 * @category Hour Helpers
 * @summary Get the number of hours between the given dates.
 *
 * @description
 * Get the number of hours between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 * @param options - An object with options.
 *
 * @returns The number of hours
 *
 * @example
 * // How many hours are between 2 July 2014 06:50:00 and 2 July 2014 19:00:00?
 * const result = differenceInHours(
 *   new Date(2014, 6, 2, 19, 0),
 *   new Date(2014, 6, 2, 6, 50)
 * )
 * //=> 12
 */ function $b7a08affd3a35cbd$var$differenceInHours(dateLeft, dateRight, options) {
    const diff = (0, $iQ4JX.differenceInMilliseconds)(dateLeft, dateRight) / $4IrbU.millisecondsInHour;
    return (0, $60GiW.getRoundingMethod)(options?.roundingMethod)(diff);
}

});
parcelRegister("60GiW", function(module, exports) {

$parcel$export(module.exports, "getRoundingMethod", () => $46038ef3369fa98f$export$b6474a47258c1211, (v) => $46038ef3369fa98f$export$b6474a47258c1211 = v);
var $46038ef3369fa98f$export$b6474a47258c1211;
"use strict";
$46038ef3369fa98f$export$b6474a47258c1211 = $46038ef3369fa98f$var$getRoundingMethod;
function $46038ef3369fa98f$var$getRoundingMethod(method) {
    return (number)=>{
        const round = method ? Math[method] : Math.trunc;
        const result = round(number);
        // Prevent negative zero
        return result === 0 ? 0 : result;
    };
}

});

parcelRegister("iQ4JX", function(module, exports) {

$parcel$export(module.exports, "differenceInMilliseconds", () => $db70c2a3dfa11bf0$export$7be94d13716b4bf6, (v) => $db70c2a3dfa11bf0$export$7be94d13716b4bf6 = v);
var $db70c2a3dfa11bf0$export$7be94d13716b4bf6;
"use strict";
$db70c2a3dfa11bf0$export$7be94d13716b4bf6 = $db70c2a3dfa11bf0$var$differenceInMilliseconds;

var $26OhI = parcelRequire("26OhI");
/**
 * @name differenceInMilliseconds
 * @category Millisecond Helpers
 * @summary Get the number of milliseconds between the given dates.
 *
 * @description
 * Get the number of milliseconds between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of milliseconds
 *
 * @example
 * // How many milliseconds are between
 * // 2 July 2014 12:30:20.600 and 2 July 2014 12:30:21.700?
 * const result = differenceInMilliseconds(
 *   new Date(2014, 6, 2, 12, 30, 21, 700),
 *   new Date(2014, 6, 2, 12, 30, 20, 600)
 * )
 * //=> 1100
 */ function $db70c2a3dfa11bf0$var$differenceInMilliseconds(dateLeft, dateRight) {
    return +(0, $26OhI.toDate)(dateLeft) - +(0, $26OhI.toDate)(dateRight);
}

});


parcelRegister("6QIhv", function(module, exports) {

$parcel$export(module.exports, "differenceInISOWeekYears", () => $4fc9f2c7a23ad7eb$export$bf7bde0b3bf8913a, (v) => $4fc9f2c7a23ad7eb$export$bf7bde0b3bf8913a = v);
var $4fc9f2c7a23ad7eb$export$bf7bde0b3bf8913a;
"use strict";
$4fc9f2c7a23ad7eb$export$bf7bde0b3bf8913a = $4fc9f2c7a23ad7eb$var$differenceInISOWeekYears;

var $4CmQQ = parcelRequire("4CmQQ");

var $iQfqc = parcelRequire("iQfqc");

var $aD97O = parcelRequire("aD97O");

var $26OhI = parcelRequire("26OhI");
/**
 * @name differenceInISOWeekYears
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the number of full ISO week-numbering years between the given dates.
 *
 * @description
 * Get the number of full ISO week-numbering years between the given dates.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of full ISO week-numbering years
 *
 * @example
 * // How many full ISO week-numbering years are between 1 January 2010 and 1 January 2012?
 * const result = differenceInISOWeekYears(
 *   new Date(2012, 0, 1),
 *   new Date(2010, 0, 1)
 * )
 * //=> 1
 */ function $4fc9f2c7a23ad7eb$var$differenceInISOWeekYears(dateLeft, dateRight) {
    let _dateLeft = (0, $26OhI.toDate)(dateLeft);
    const _dateRight = (0, $26OhI.toDate)(dateRight);
    const sign = (0, $4CmQQ.compareAsc)(_dateLeft, _dateRight);
    const difference = Math.abs((0, $iQfqc.differenceInCalendarISOWeekYears)(_dateLeft, _dateRight));
    _dateLeft = (0, $aD97O.subISOWeekYears)(_dateLeft, sign * difference);
    // Math.abs(diff in full ISO years - diff in calendar ISO years) === 1
    // if last calendar ISO year is not full
    // If so, result must be decreased by 1 in absolute value
    const isLastISOWeekYearNotFull = Number((0, $4CmQQ.compareAsc)(_dateLeft, _dateRight) === -sign);
    const result = sign * (difference - isLastISOWeekYearNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

});
parcelRegister("aD97O", function(module, exports) {

$parcel$export(module.exports, "subISOWeekYears", () => $7bd49fef98ff44c1$export$4f7d47b952f4a0aa, (v) => $7bd49fef98ff44c1$export$4f7d47b952f4a0aa = v);
var $7bd49fef98ff44c1$export$4f7d47b952f4a0aa;
"use strict";
$7bd49fef98ff44c1$export$4f7d47b952f4a0aa = $7bd49fef98ff44c1$var$subISOWeekYears;

var $dE5gZ = parcelRequire("dE5gZ");
/**
 * @name subISOWeekYears
 * @category ISO Week-Numbering Year Helpers
 * @summary Subtract the specified number of ISO week-numbering years from the given date.
 *
 * @description
 * Subtract the specified number of ISO week-numbering years from the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of ISO week-numbering years to be subtracted.
 *
 * @returns The new date with the ISO week-numbering years subtracted
 *
 * @example
 * // Subtract 5 ISO week-numbering years from 1 September 2014:
 * const result = subISOWeekYears(new Date(2014, 8, 1), 5)
 * //=> Mon Aug 31 2009 00:00:00
 */ function $7bd49fef98ff44c1$var$subISOWeekYears(date, amount) {
    return (0, $dE5gZ.addISOWeekYears)(date, -amount);
}

});


parcelRegister("4LIFj", function(module, exports) {

$parcel$export(module.exports, "differenceInMinutes", () => $378e32d0b155f666$export$d904251335be481a, (v) => $378e32d0b155f666$export$d904251335be481a = v);
var $378e32d0b155f666$export$d904251335be481a;
"use strict";
$378e32d0b155f666$export$d904251335be481a = $378e32d0b155f666$var$differenceInMinutes;

var $60GiW = parcelRequire("60GiW");

var $4IrbU = parcelRequire("4IrbU");

var $iQ4JX = parcelRequire("iQ4JX");
/**
 * The {@link differenceInMinutes} function options.
 */ /**
 * @name differenceInMinutes
 * @category Minute Helpers
 * @summary Get the number of minutes between the given dates.
 *
 * @description
 * Get the signed number of full (rounded towards 0) minutes between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 * @param options - An object with options.
 *
 * @returns The number of minutes
 *
 * @example
 * // How many minutes are between 2 July 2014 12:07:59 and 2 July 2014 12:20:00?
 * const result = differenceInMinutes(
 *   new Date(2014, 6, 2, 12, 20, 0),
 *   new Date(2014, 6, 2, 12, 7, 59)
 * )
 * //=> 12
 *
 * @example
 * // How many minutes are between 10:01:59 and 10:00:00
 * const result = differenceInMinutes(
 *   new Date(2000, 0, 1, 10, 0, 0),
 *   new Date(2000, 0, 1, 10, 1, 59)
 * )
 * //=> -1
 */ function $378e32d0b155f666$var$differenceInMinutes(dateLeft, dateRight, options) {
    const diff = (0, $iQ4JX.differenceInMilliseconds)(dateLeft, dateRight) / $4IrbU.millisecondsInMinute;
    return (0, $60GiW.getRoundingMethod)(options?.roundingMethod)(diff);
}

});

parcelRegister("aBQYs", function(module, exports) {

$parcel$export(module.exports, "differenceInMonths", () => $7b9673a8a84ecc8d$export$fc1ed482c2861792, (v) => $7b9673a8a84ecc8d$export$fc1ed482c2861792 = v);
var $7b9673a8a84ecc8d$export$fc1ed482c2861792;
"use strict";
$7b9673a8a84ecc8d$export$fc1ed482c2861792 = $7b9673a8a84ecc8d$var$differenceInMonths;

var $4CmQQ = parcelRequire("4CmQQ");

var $lVxGX = parcelRequire("lVxGX");

var $jhVjc = parcelRequire("jhVjc");

var $26OhI = parcelRequire("26OhI");
/**
 * @name differenceInMonths
 * @category Month Helpers
 * @summary Get the number of full months between the given dates.
 *
 * @description
 * Get the number of full months between the given dates using trunc as a default rounding method.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of full months
 *
 * @example
 * // How many full months are between 31 January 2014 and 1 September 2014?
 * const result = differenceInMonths(new Date(2014, 8, 1), new Date(2014, 0, 31))
 * //=> 7
 */ function $7b9673a8a84ecc8d$var$differenceInMonths(dateLeft, dateRight) {
    const _dateLeft = (0, $26OhI.toDate)(dateLeft);
    const _dateRight = (0, $26OhI.toDate)(dateRight);
    const sign = (0, $4CmQQ.compareAsc)(_dateLeft, _dateRight);
    const difference = Math.abs((0, $lVxGX.differenceInCalendarMonths)(_dateLeft, _dateRight));
    let result;
    // Check for the difference of less than month
    if (difference < 1) result = 0;
    else {
        if (_dateLeft.getMonth() === 1 && _dateLeft.getDate() > 27) // This will check if the date is end of Feb and assign a higher end of month date
        // to compare it with Jan
        _dateLeft.setDate(30);
        _dateLeft.setMonth(_dateLeft.getMonth() - sign * difference);
        // Math.abs(diff in full months - diff in calendar months) === 1 if last calendar month is not full
        // If so, result must be decreased by 1 in absolute value
        let isLastMonthNotFull = (0, $4CmQQ.compareAsc)(_dateLeft, _dateRight) === -sign;
        // Check for cases of one full calendar month
        if ((0, $jhVjc.isLastDayOfMonth)((0, $26OhI.toDate)(dateLeft)) && difference === 1 && (0, $4CmQQ.compareAsc)(dateLeft, _dateRight) === 1) isLastMonthNotFull = false;
        result = sign * (difference - Number(isLastMonthNotFull));
    }
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

});
parcelRegister("jhVjc", function(module, exports) {

$parcel$export(module.exports, "isLastDayOfMonth", () => $e0ac0f26ba7c64a5$export$c817d0312007ea5e, (v) => $e0ac0f26ba7c64a5$export$c817d0312007ea5e = v);
var $e0ac0f26ba7c64a5$export$c817d0312007ea5e;
"use strict";
$e0ac0f26ba7c64a5$export$c817d0312007ea5e = $e0ac0f26ba7c64a5$var$isLastDayOfMonth;

var $lU13w = parcelRequire("lU13w");

var $3pk6v = parcelRequire("3pk6v");

var $26OhI = parcelRequire("26OhI");
/**
 * @name isLastDayOfMonth
 * @category Month Helpers
 * @summary Is the given date the last day of a month?
 *
 * @description
 * Is the given date the last day of a month?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check

 * @returns The date is the last day of a month
 *
 * @example
 * // Is 28 February 2014 the last day of a month?
 * const result = isLastDayOfMonth(new Date(2014, 1, 28))
 * //=> true
 */ function $e0ac0f26ba7c64a5$var$isLastDayOfMonth(date) {
    const _date = (0, $26OhI.toDate)(date);
    return +(0, $lU13w.endOfDay)(_date) === +(0, $3pk6v.endOfMonth)(_date);
}

});


parcelRegister("9xdYC", function(module, exports) {

$parcel$export(module.exports, "differenceInQuarters", () => $6f120998b73e9b71$export$74b5c4055a405552, (v) => $6f120998b73e9b71$export$74b5c4055a405552 = v);
var $6f120998b73e9b71$export$74b5c4055a405552;
"use strict";
$6f120998b73e9b71$export$74b5c4055a405552 = $6f120998b73e9b71$var$differenceInQuarters;

var $60GiW = parcelRequire("60GiW");

var $aBQYs = parcelRequire("aBQYs");
/**
 * The {@link differenceInQuarters} function options.
 */ /**
 * @name differenceInQuarters
 * @category Quarter Helpers
 * @summary Get the number of quarters between the given dates.
 *
 * @description
 * Get the number of quarters between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 * @param options - An object with options.
 *
 * @returns The number of full quarters
 *
 * @example
 * // How many full quarters are between 31 December 2013 and 2 July 2014?
 * const result = differenceInQuarters(new Date(2014, 6, 2), new Date(2013, 11, 31))
 * //=> 2
 */ function $6f120998b73e9b71$var$differenceInQuarters(dateLeft, dateRight, options) {
    const diff = (0, $aBQYs.differenceInMonths)(dateLeft, dateRight) / 3;
    return (0, $60GiW.getRoundingMethod)(options?.roundingMethod)(diff);
}

});

parcelRegister("1i6Jz", function(module, exports) {

$parcel$export(module.exports, "differenceInSeconds", () => $0f0cb22361fe565b$export$c1889aec51783710, (v) => $0f0cb22361fe565b$export$c1889aec51783710 = v);
var $0f0cb22361fe565b$export$c1889aec51783710;
"use strict";
$0f0cb22361fe565b$export$c1889aec51783710 = $0f0cb22361fe565b$var$differenceInSeconds;

var $60GiW = parcelRequire("60GiW");

var $iQ4JX = parcelRequire("iQ4JX");
/**
 * The {@link differenceInSeconds} function options.
 */ /**
 * @name differenceInSeconds
 * @category Second Helpers
 * @summary Get the number of seconds between the given dates.
 *
 * @description
 * Get the number of seconds between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 * @param options - An object with options.
 *
 * @returns The number of seconds
 *
 * @example
 * // How many seconds are between
 * // 2 July 2014 12:30:07.999 and 2 July 2014 12:30:20.000?
 * const result = differenceInSeconds(
 *   new Date(2014, 6, 2, 12, 30, 20, 0),
 *   new Date(2014, 6, 2, 12, 30, 7, 999)
 * )
 * //=> 12
 */ function $0f0cb22361fe565b$var$differenceInSeconds(dateLeft, dateRight, options) {
    const diff = (0, $iQ4JX.differenceInMilliseconds)(dateLeft, dateRight) / 1000;
    return (0, $60GiW.getRoundingMethod)(options?.roundingMethod)(diff);
}

});

parcelRegister("7fmSP", function(module, exports) {

$parcel$export(module.exports, "differenceInWeeks", () => $546baf49e6da28b3$export$b5147a91dc40ddb7, (v) => $546baf49e6da28b3$export$b5147a91dc40ddb7 = v);
var $546baf49e6da28b3$export$b5147a91dc40ddb7;
"use strict";
$546baf49e6da28b3$export$b5147a91dc40ddb7 = $546baf49e6da28b3$var$differenceInWeeks;

var $60GiW = parcelRequire("60GiW");

var $lS4EH = parcelRequire("lS4EH");
/**
 * The {@link differenceInWeeks} function options.
 */ /**
 * @name differenceInWeeks
 * @category Week Helpers
 * @summary Get the number of full weeks between the given dates.
 *
 * @description
 * Get the number of full weeks between two dates. Fractional weeks are
 * truncated towards zero by default.
 *
 * One "full week" is the distance between a local time in one day to the same
 * local time 7 days earlier or later. A full week can sometimes be less than
 * or more than 7*24 hours if a daylight savings change happens between two dates.
 *
 * To ignore DST and only measure exact 7*24-hour periods, use this instead:
 * `Math.trunc(differenceInHours(dateLeft, dateRight)/(7*24))|0`.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 * @param options - An object with options
 *
 * @returns The number of full weeks
 *
 * @example
 * // How many full weeks are between 5 July 2014 and 20 July 2014?
 * const result = differenceInWeeks(new Date(2014, 6, 20), new Date(2014, 6, 5))
 * //=> 2
 *
 * @example
 * // How many full weeks are between
 * // 1 March 2020 0:00 and 6 June 2020 0:00 ?
 * // Note: because local time is used, the
 * // result will always be 8 weeks (54 days),
 * // even if DST starts and the period has
 * // only 54*24-1 hours.
 * const result = differenceInWeeks(
 *   new Date(2020, 5, 1),
 *   new Date(2020, 2, 6)
 * )
 * //=> 8
 */ function $546baf49e6da28b3$var$differenceInWeeks(dateLeft, dateRight, options) {
    const diff = (0, $lS4EH.differenceInDays)(dateLeft, dateRight) / 7;
    return (0, $60GiW.getRoundingMethod)(options?.roundingMethod)(diff);
}

});

parcelRegister("f1Tmv", function(module, exports) {

$parcel$export(module.exports, "differenceInYears", () => $af11e4c3502d5e3b$export$ed6bf486f68899ca, (v) => $af11e4c3502d5e3b$export$ed6bf486f68899ca = v);
var $af11e4c3502d5e3b$export$ed6bf486f68899ca;
"use strict";
$af11e4c3502d5e3b$export$ed6bf486f68899ca = $af11e4c3502d5e3b$var$differenceInYears;

var $4CmQQ = parcelRequire("4CmQQ");

var $4j185 = parcelRequire("4j185");

var $26OhI = parcelRequire("26OhI");
/**
 * @name differenceInYears
 * @category Year Helpers
 * @summary Get the number of full years between the given dates.
 *
 * @description
 * Get the number of full years between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of full years
 *
 * @example
 * // How many full years are between 31 December 2013 and 11 February 2015?
 * const result = differenceInYears(new Date(2015, 1, 11), new Date(2013, 11, 31))
 * //=> 1
 */ function $af11e4c3502d5e3b$var$differenceInYears(dateLeft, dateRight) {
    const _dateLeft = (0, $26OhI.toDate)(dateLeft);
    const _dateRight = (0, $26OhI.toDate)(dateRight);
    const sign = (0, $4CmQQ.compareAsc)(_dateLeft, _dateRight);
    const difference = Math.abs((0, $4j185.differenceInCalendarYears)(_dateLeft, _dateRight));
    // Set both dates to a valid leap year for accurate comparison when dealing
    // with leap days
    _dateLeft.setFullYear(1584);
    _dateRight.setFullYear(1584);
    // Math.abs(diff in full years - diff in calendar years) === 1 if last calendar year is not full
    // If so, result must be decreased by 1 in absolute value
    const isLastYearNotFull = (0, $4CmQQ.compareAsc)(_dateLeft, _dateRight) === -sign;
    const result = sign * (difference - +isLastYearNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

});

parcelRegister("5GGYt", function(module, exports) {

$parcel$export(module.exports, "eachDayOfInterval", () => $424235d16263a373$export$7a337e5923c7ceb5, (v) => $424235d16263a373$export$7a337e5923c7ceb5 = v);
var $424235d16263a373$export$7a337e5923c7ceb5;
"use strict";
$424235d16263a373$export$7a337e5923c7ceb5 = $424235d16263a373$var$eachDayOfInterval;

var $26OhI = parcelRequire("26OhI");
/**
 * The {@link eachDayOfInterval} function options.
 */ /**
 * @name eachDayOfInterval
 * @category Interval Helpers
 * @summary Return the array of dates within the specified time interval.
 *
 * @description
 * Return the array of dates within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval.
 * @param options - An object with options.
 *
 * @returns The array with starts of days from the day of the interval start to the day of the interval end
 *
 * @example
 * // Each day between 6 October 2014 and 10 October 2014:
 * const result = eachDayOfInterval({
 *   start: new Date(2014, 9, 6),
 *   end: new Date(2014, 9, 10)
 * })
 * //=> [
 * //   Mon Oct 06 2014 00:00:00,
 * //   Tue Oct 07 2014 00:00:00,
 * //   Wed Oct 08 2014 00:00:00,
 * //   Thu Oct 09 2014 00:00:00,
 * //   Fri Oct 10 2014 00:00:00
 * // ]
 */ function $424235d16263a373$var$eachDayOfInterval(interval, options) {
    const startDate = (0, $26OhI.toDate)(interval.start);
    const endDate = (0, $26OhI.toDate)(interval.end);
    let reversed = +startDate > +endDate;
    const endTime = reversed ? +startDate : +endDate;
    const currentDate = reversed ? endDate : startDate;
    currentDate.setHours(0, 0, 0, 0);
    let step = options?.step ?? 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    const dates = [];
    while(+currentDate <= endTime){
        dates.push((0, $26OhI.toDate)(currentDate));
        currentDate.setDate(currentDate.getDate() + step);
        currentDate.setHours(0, 0, 0, 0);
    }
    return reversed ? dates.reverse() : dates;
}

});

parcelRegister("eAZln", function(module, exports) {

$parcel$export(module.exports, "eachHourOfInterval", () => $aa04031576a65e1c$export$bb4f48fee90ea86e, (v) => $aa04031576a65e1c$export$bb4f48fee90ea86e = v);
var $aa04031576a65e1c$export$bb4f48fee90ea86e;
"use strict";
$aa04031576a65e1c$export$bb4f48fee90ea86e = $aa04031576a65e1c$var$eachHourOfInterval;

var $2s8DN = parcelRequire("2s8DN");

var $26OhI = parcelRequire("26OhI");
/**
 * The {@link eachHourOfInterval} function options.
 */ /**
 * @name eachHourOfInterval
 * @category Interval Helpers
 * @summary Return the array of hours within the specified time interval.
 *
 * @description
 * Return the array of hours within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval.
 * @param options - An object with options.
 *
 * @returns The array with starts of hours from the hour of the interval start to the hour of the interval end
 *
 * @example
 * // Each hour between 6 October 2014, 12:00 and 6 October 2014, 15:00
 * const result = eachHourOfInterval({
 *   start: new Date(2014, 9, 6, 12),
 *   end: new Date(2014, 9, 6, 15)
 * })
 * //=> [
 * //   Mon Oct 06 2014 12:00:00,
 * //   Mon Oct 06 2014 13:00:00,
 * //   Mon Oct 06 2014 14:00:00,
 * //   Mon Oct 06 2014 15:00:00
 * // ]
 */ function $aa04031576a65e1c$var$eachHourOfInterval(interval, options) {
    const startDate = (0, $26OhI.toDate)(interval.start);
    const endDate = (0, $26OhI.toDate)(interval.end);
    let reversed = +startDate > +endDate;
    const endTime = reversed ? +startDate : +endDate;
    let currentDate = reversed ? endDate : startDate;
    currentDate.setMinutes(0, 0, 0);
    let step = options?.step ?? 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    const dates = [];
    while(+currentDate <= endTime){
        dates.push((0, $26OhI.toDate)(currentDate));
        currentDate = (0, $2s8DN.addHours)(currentDate, step);
    }
    return reversed ? dates.reverse() : dates;
}

});

parcelRegister("jkm0U", function(module, exports) {

$parcel$export(module.exports, "eachMinuteOfInterval", () => $e120f603ad8cb79f$export$82e17d693ce9eb6c, (v) => $e120f603ad8cb79f$export$82e17d693ce9eb6c = v);
var $e120f603ad8cb79f$export$82e17d693ce9eb6c;
"use strict";
$e120f603ad8cb79f$export$82e17d693ce9eb6c = $e120f603ad8cb79f$var$eachMinuteOfInterval;

var $hB2gy = parcelRequire("hB2gy");

var $kouFc = parcelRequire("kouFc");

var $26OhI = parcelRequire("26OhI");
/**
 * The {@link eachMinuteOfInterval} function options.
 */ /**
 * @name eachMinuteOfInterval
 * @category Interval Helpers
 * @summary Return the array of minutes within the specified time interval.
 *
 * @description
 * Returns the array of minutes within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval.
 * @param options - An object with options.
 *
 * @returns The array with starts of minutes from the minute of the interval start to the minute of the interval end
 *
 * @example
 * // Each minute between 14 October 2020, 13:00 and 14 October 2020, 13:03
 * const result = eachMinuteOfInterval({
 *   start: new Date(2014, 9, 14, 13),
 *   end: new Date(2014, 9, 14, 13, 3)
 * })
 * //=> [
 * //   Wed Oct 14 2014 13:00:00,
 * //   Wed Oct 14 2014 13:01:00,
 * //   Wed Oct 14 2014 13:02:00,
 * //   Wed Oct 14 2014 13:03:00
 * // ]
 */ function $e120f603ad8cb79f$var$eachMinuteOfInterval(interval, options) {
    const startDate = (0, $kouFc.startOfMinute)((0, $26OhI.toDate)(interval.start));
    const endDate = (0, $26OhI.toDate)(interval.end);
    let reversed = +startDate > +endDate;
    const endTime = reversed ? +startDate : +endDate;
    let currentDate = reversed ? endDate : startDate;
    let step = options?.step ?? 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    const dates = [];
    while(+currentDate <= endTime){
        dates.push((0, $26OhI.toDate)(currentDate));
        currentDate = (0, $hB2gy.addMinutes)(currentDate, step);
    }
    return reversed ? dates.reverse() : dates;
}

});
parcelRegister("kouFc", function(module, exports) {

$parcel$export(module.exports, "startOfMinute", () => $ed8dd5a677e31def$export$c66440458c6aa793, (v) => $ed8dd5a677e31def$export$c66440458c6aa793 = v);
var $ed8dd5a677e31def$export$c66440458c6aa793;
"use strict";
$ed8dd5a677e31def$export$c66440458c6aa793 = $ed8dd5a677e31def$var$startOfMinute;

var $26OhI = parcelRequire("26OhI");
/**
 * @name startOfMinute
 * @category Minute Helpers
 * @summary Return the start of a minute for the given date.
 *
 * @description
 * Return the start of a minute for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a minute
 *
 * @example
 * // The start of a minute for 1 December 2014 22:15:45.400:
 * const result = startOfMinute(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:00
 */ function $ed8dd5a677e31def$var$startOfMinute(date) {
    const _date = (0, $26OhI.toDate)(date);
    _date.setSeconds(0, 0);
    return _date;
}

});


parcelRegister("3jaLo", function(module, exports) {

$parcel$export(module.exports, "eachMonthOfInterval", () => $268b7ed03f961262$export$1c9322f2d2a5eed3, (v) => $268b7ed03f961262$export$1c9322f2d2a5eed3 = v);
var $268b7ed03f961262$export$1c9322f2d2a5eed3;
"use strict";
$268b7ed03f961262$export$1c9322f2d2a5eed3 = $268b7ed03f961262$var$eachMonthOfInterval;

var $26OhI = parcelRequire("26OhI");
/**
 * The {@link eachMonthOfInterval} function options.
 */ /**
 * @name eachMonthOfInterval
 * @category Interval Helpers
 * @summary Return the array of months within the specified time interval.
 *
 * @description
 * Return the array of months within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval
 *
 * @returns The array with starts of months from the month of the interval start to the month of the interval end
 *
 * @example
 * // Each month between 6 February 2014 and 10 August 2014:
 * const result = eachMonthOfInterval({
 *   start: new Date(2014, 1, 6),
 *   end: new Date(2014, 7, 10)
 * })
 * //=> [
 * //   Sat Feb 01 2014 00:00:00,
 * //   Sat Mar 01 2014 00:00:00,
 * //   Tue Apr 01 2014 00:00:00,
 * //   Thu May 01 2014 00:00:00,
 * //   Sun Jun 01 2014 00:00:00,
 * //   Tue Jul 01 2014 00:00:00,
 * //   Fri Aug 01 2014 00:00:00
 * // ]
 */ function $268b7ed03f961262$var$eachMonthOfInterval(interval, options) {
    const startDate = (0, $26OhI.toDate)(interval.start);
    const endDate = (0, $26OhI.toDate)(interval.end);
    let reversed = +startDate > +endDate;
    const endTime = reversed ? +startDate : +endDate;
    const currentDate = reversed ? endDate : startDate;
    currentDate.setHours(0, 0, 0, 0);
    currentDate.setDate(1);
    let step = options?.step ?? 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    const dates = [];
    while(+currentDate <= endTime){
        dates.push((0, $26OhI.toDate)(currentDate));
        currentDate.setMonth(currentDate.getMonth() + step);
    }
    return reversed ? dates.reverse() : dates;
}

});

parcelRegister("gxpBU", function(module, exports) {

$parcel$export(module.exports, "eachQuarterOfInterval", () => $c0a3981b965563e3$export$96790a0abfab0078, (v) => $c0a3981b965563e3$export$96790a0abfab0078 = v);
var $c0a3981b965563e3$export$96790a0abfab0078;
"use strict";
$c0a3981b965563e3$export$96790a0abfab0078 = $c0a3981b965563e3$var$eachQuarterOfInterval;

var $53mjM = parcelRequire("53mjM");

var $1c3d7 = parcelRequire("1c3d7");

var $26OhI = parcelRequire("26OhI");
/**
 * The {@link eachQuarterOfInterval} function options.
 */ /**
 * @name eachQuarterOfInterval
 * @category Interval Helpers
 * @summary Return the array of quarters within the specified time interval.
 *
 * @description
 * Return the array of quarters within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval
 *
 * @returns The array with starts of quarters from the quarter of the interval start to the quarter of the interval end
 *
 * @example
 * // Each quarter within interval 6 February 2014 - 10 August 2014:
 * const result = eachQuarterOfInterval({
 *   start: new Date(2014, 1, 6),
 *   end: new Date(2014, 7, 10)
 * })
 * //=> [
 * //   Wed Jan 01 2014 00:00:00,
 * //   Tue Apr 01 2014 00:00:00,
 * //   Tue Jul 01 2014 00:00:00,
 * // ]
 */ function $c0a3981b965563e3$var$eachQuarterOfInterval(interval, options) {
    const startDate = (0, $26OhI.toDate)(interval.start);
    const endDate = (0, $26OhI.toDate)(interval.end);
    let reversed = +startDate > +endDate;
    const endTime = reversed ? +(0, $1c3d7.startOfQuarter)(startDate) : +(0, $1c3d7.startOfQuarter)(endDate);
    let currentDate = reversed ? (0, $1c3d7.startOfQuarter)(endDate) : (0, $1c3d7.startOfQuarter)(startDate);
    let step = options?.step ?? 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    const dates = [];
    while(+currentDate <= endTime){
        dates.push((0, $26OhI.toDate)(currentDate));
        currentDate = (0, $53mjM.addQuarters)(currentDate, step);
    }
    return reversed ? dates.reverse() : dates;
}

});

parcelRegister("9aMwB", function(module, exports) {

$parcel$export(module.exports, "eachWeekOfInterval", () => $6adab043fd1f992e$export$d31a8caec75fa456, (v) => $6adab043fd1f992e$export$d31a8caec75fa456 = v);
var $6adab043fd1f992e$export$d31a8caec75fa456;
"use strict";
$6adab043fd1f992e$export$d31a8caec75fa456 = $6adab043fd1f992e$var$eachWeekOfInterval;

var $41ovE = parcelRequire("41ovE");

var $aSLbu = parcelRequire("aSLbu");

var $26OhI = parcelRequire("26OhI");
/**
 * The {@link eachWeekOfInterval} function options.
 */ /**
 * @name eachWeekOfInterval
 * @category Interval Helpers
 * @summary Return the array of weeks within the specified time interval.
 *
 * @description
 * Return the array of weeks within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval.
 * @param options - An object with options.
 *
 * @returns The array with starts of weeks from the week of the interval start to the week of the interval end
 *
 * @example
 * // Each week within interval 6 October 2014 - 23 November 2014:
 * const result = eachWeekOfInterval({
 *   start: new Date(2014, 9, 6),
 *   end: new Date(2014, 10, 23)
 * })
 * //=> [
 * //   Sun Oct 05 2014 00:00:00,
 * //   Sun Oct 12 2014 00:00:00,
 * //   Sun Oct 19 2014 00:00:00,
 * //   Sun Oct 26 2014 00:00:00,
 * //   Sun Nov 02 2014 00:00:00,
 * //   Sun Nov 09 2014 00:00:00,
 * //   Sun Nov 16 2014 00:00:00,
 * //   Sun Nov 23 2014 00:00:00
 * // ]
 */ function $6adab043fd1f992e$var$eachWeekOfInterval(interval, options) {
    const startDate = (0, $26OhI.toDate)(interval.start);
    const endDate = (0, $26OhI.toDate)(interval.end);
    let reversed = +startDate > +endDate;
    const startDateWeek = reversed ? (0, $aSLbu.startOfWeek)(endDate, options) : (0, $aSLbu.startOfWeek)(startDate, options);
    const endDateWeek = reversed ? (0, $aSLbu.startOfWeek)(startDate, options) : (0, $aSLbu.startOfWeek)(endDate, options);
    // Some timezones switch DST at midnight, making start of day unreliable in these timezones, 3pm is a safe bet
    startDateWeek.setHours(15);
    endDateWeek.setHours(15);
    const endTime = +endDateWeek.getTime();
    let currentDate = startDateWeek;
    let step = options?.step ?? 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    const dates = [];
    while(+currentDate <= endTime){
        currentDate.setHours(0);
        dates.push((0, $26OhI.toDate)(currentDate));
        currentDate = (0, $41ovE.addWeeks)(currentDate, step);
        currentDate.setHours(15);
    }
    return reversed ? dates.reverse() : dates;
}

});

parcelRegister("70lyU", function(module, exports) {

$parcel$export(module.exports, "eachWeekendOfInterval", () => $0150ec6c80937602$export$a2ae85dd849354a8, (v) => $0150ec6c80937602$export$a2ae85dd849354a8 = v);
var $0150ec6c80937602$export$a2ae85dd849354a8;
"use strict";
$0150ec6c80937602$export$a2ae85dd849354a8 = $0150ec6c80937602$var$eachWeekendOfInterval;

var $5GGYt = parcelRequire("5GGYt");

var $l0zvm = parcelRequire("l0zvm");
/**
 * @name eachWeekendOfInterval
 * @category Interval Helpers
 * @summary List all the Saturdays and Sundays in the given date interval.
 *
 * @description
 * Get all the Saturdays and Sundays in the given date interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The given interval
 *
 * @returns An array containing all the Saturdays and Sundays
 *
 * @example
 * // Lists all Saturdays and Sundays in the given date interval
 * const result = eachWeekendOfInterval({
 *   start: new Date(2018, 8, 17),
 *   end: new Date(2018, 8, 30)
 * })
 * //=> [
 * //   Sat Sep 22 2018 00:00:00,
 * //   Sun Sep 23 2018 00:00:00,
 * //   Sat Sep 29 2018 00:00:00,
 * //   Sun Sep 30 2018 00:00:00
 * // ]
 */ function $0150ec6c80937602$var$eachWeekendOfInterval(interval) {
    const dateInterval = (0, $5GGYt.eachDayOfInterval)(interval);
    const weekends = [];
    let index = 0;
    while(index < dateInterval.length){
        const date = dateInterval[index++];
        if ((0, $l0zvm.isWeekend)(date)) weekends.push(date);
    }
    return weekends;
}

});

parcelRegister("4BwgI", function(module, exports) {

$parcel$export(module.exports, "eachWeekendOfMonth", () => $35a3a5fe8bec4a38$export$f9a185d0ad232d17, (v) => $35a3a5fe8bec4a38$export$f9a185d0ad232d17 = v);
var $35a3a5fe8bec4a38$export$f9a185d0ad232d17;
"use strict";
$35a3a5fe8bec4a38$export$f9a185d0ad232d17 = $35a3a5fe8bec4a38$var$eachWeekendOfMonth;

var $70lyU = parcelRequire("70lyU");

var $3pk6v = parcelRequire("3pk6v");

var $biOJg = parcelRequire("biOJg");
/**
 * @name eachWeekendOfMonth
 * @category Month Helpers
 * @summary List all the Saturdays and Sundays in the given month.
 *
 * @description
 * Get all the Saturdays and Sundays in the given month.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given month
 *
 * @returns An array containing all the Saturdays and Sundays
 *
 * @example
 * // Lists all Saturdays and Sundays in the given month
 * const result = eachWeekendOfMonth(new Date(2022, 1, 1))
 * //=> [
 * //   Sat Feb 05 2022 00:00:00,
 * //   Sun Feb 06 2022 00:00:00,
 * //   Sat Feb 12 2022 00:00:00,
 * //   Sun Feb 13 2022 00:00:00,
 * //   Sat Feb 19 2022 00:00:00,
 * //   Sun Feb 20 2022 00:00:00,
 * //   Sat Feb 26 2022 00:00:00,
 * //   Sun Feb 27 2022 00:00:00
 * // ]
 */ function $35a3a5fe8bec4a38$var$eachWeekendOfMonth(date) {
    const start = (0, $biOJg.startOfMonth)(date);
    const end = (0, $3pk6v.endOfMonth)(date);
    return (0, $70lyU.eachWeekendOfInterval)({
        start: start,
        end: end
    });
}

});

parcelRegister("7WWht", function(module, exports) {

$parcel$export(module.exports, "eachWeekendOfYear", () => $5c9b28861209d8fa$export$d4a9e5efc1ddceb9, (v) => $5c9b28861209d8fa$export$d4a9e5efc1ddceb9 = v);
var $5c9b28861209d8fa$export$d4a9e5efc1ddceb9;
"use strict";
$5c9b28861209d8fa$export$d4a9e5efc1ddceb9 = $5c9b28861209d8fa$var$eachWeekendOfYear;

var $70lyU = parcelRequire("70lyU");

var $igoTU = parcelRequire("igoTU");

var $icgCh = parcelRequire("icgCh");
/**
 * @name eachWeekendOfYear
 * @category Year Helpers
 * @summary List all the Saturdays and Sundays in the year.
 *
 * @description
 * Get all the Saturdays and Sundays in the year.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given year
 *
 * @returns An array containing all the Saturdays and Sundays
 *
 * @example
 * // Lists all Saturdays and Sundays in the year
 * const result = eachWeekendOfYear(new Date(2020, 1, 1))
 * //=> [
 * //   Sat Jan 03 2020 00:00:00,
 * //   Sun Jan 04 2020 00:00:00,
 * //   ...
 * //   Sun Dec 27 2020 00:00:00
 * // ]
 * ]
 */ function $5c9b28861209d8fa$var$eachWeekendOfYear(date) {
    const start = (0, $icgCh.startOfYear)(date);
    const end = (0, $igoTU.endOfYear)(date);
    return (0, $70lyU.eachWeekendOfInterval)({
        start: start,
        end: end
    });
}

});

parcelRegister("gGnfk", function(module, exports) {

$parcel$export(module.exports, "eachYearOfInterval", () => $c25299cd9cf477c6$export$9b7f165f0a71d2a5, (v) => $c25299cd9cf477c6$export$9b7f165f0a71d2a5 = v);
var $c25299cd9cf477c6$export$9b7f165f0a71d2a5;
"use strict";
$c25299cd9cf477c6$export$9b7f165f0a71d2a5 = $c25299cd9cf477c6$var$eachYearOfInterval;

var $26OhI = parcelRequire("26OhI");
/**
 * The {@link eachYearOfInterval} function options.
 */ /**
 * @name eachYearOfInterval
 * @category Interval Helpers
 * @summary Return the array of yearly timestamps within the specified time interval.
 *
 * @description
 * Return the array of yearly timestamps within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval.
 *
 * @returns The array with starts of yearly timestamps from the month of the interval start to the month of the interval end
 *
 * @example
 * // Each year between 6 February 2014 and 10 August 2017:
 * const result = eachYearOfInterval({
 *   start: new Date(2014, 1, 6),
 *   end: new Date(2017, 7, 10)
 * })
 * //=> [
 * //   Wed Jan 01 2014 00:00:00,
 * //   Thu Jan 01 2015 00:00:00,
 * //   Fri Jan 01 2016 00:00:00,
 * //   Sun Jan 01 2017 00:00:00
 * // ]
 */ function $c25299cd9cf477c6$var$eachYearOfInterval(interval, options) {
    const startDate = (0, $26OhI.toDate)(interval.start);
    const endDate = (0, $26OhI.toDate)(interval.end);
    let reversed = +startDate > +endDate;
    const endTime = reversed ? +startDate : +endDate;
    const currentDate = reversed ? endDate : startDate;
    currentDate.setHours(0, 0, 0, 0);
    currentDate.setMonth(0, 1);
    let step = options?.step ?? 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    const dates = [];
    while(+currentDate <= endTime){
        dates.push((0, $26OhI.toDate)(currentDate));
        currentDate.setFullYear(currentDate.getFullYear() + step);
    }
    return reversed ? dates.reverse() : dates;
}

});

parcelRegister("2Rm6o", function(module, exports) {

$parcel$export(module.exports, "endOfDecade", () => $2151ad00e94e45f9$export$b922ac31d5bbe7a6, (v) => $2151ad00e94e45f9$export$b922ac31d5bbe7a6 = v);
var $2151ad00e94e45f9$export$b922ac31d5bbe7a6;
"use strict";
$2151ad00e94e45f9$export$b922ac31d5bbe7a6 = $2151ad00e94e45f9$var$endOfDecade;

var $26OhI = parcelRequire("26OhI");
/**
 * @name endOfDecade
 * @category Decade Helpers
 * @summary Return the end of a decade for the given date.
 *
 * @description
 * Return the end of a decade for the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a decade
 *
 * @example
 * // The end of a decade for 12 May 1984 00:00:00:
 * const result = endOfDecade(new Date(1984, 4, 12, 00, 00, 00))
 * //=> Dec 31 1989 23:59:59.999
 */ function $2151ad00e94e45f9$var$endOfDecade(date) {
    // TODO: Switch to more technical definition in of decades that start with 1
    // end with 0. I.e. 2001-2010 instead of current 2000-2009. It's a breaking
    // change, so it can only be done in 4.0.
    const _date = (0, $26OhI.toDate)(date);
    const year = _date.getFullYear();
    const decade = 9 + Math.floor(year / 10) * 10;
    _date.setFullYear(decade, 11, 31);
    _date.setHours(23, 59, 59, 999);
    return _date;
}

});

parcelRegister("gQTSx", function(module, exports) {

$parcel$export(module.exports, "endOfHour", () => $c44cd8fdb98b3283$export$95ae95d2176c5f0, (v) => $c44cd8fdb98b3283$export$95ae95d2176c5f0 = v);
var $c44cd8fdb98b3283$export$95ae95d2176c5f0;
"use strict";
$c44cd8fdb98b3283$export$95ae95d2176c5f0 = $c44cd8fdb98b3283$var$endOfHour;

var $26OhI = parcelRequire("26OhI");
/**
 * @name endOfHour
 * @category Hour Helpers
 * @summary Return the end of an hour for the given date.
 *
 * @description
 * Return the end of an hour for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of an hour
 *
 * @example
 * // The end of an hour for 2 September 2014 11:55:00:
 * const result = endOfHour(new Date(2014, 8, 2, 11, 55))
 * //=> Tue Sep 02 2014 11:59:59.999
 */ function $c44cd8fdb98b3283$var$endOfHour(date) {
    const _date = (0, $26OhI.toDate)(date);
    _date.setMinutes(59, 59, 999);
    return _date;
}

});

parcelRegister("khPe0", function(module, exports) {

$parcel$export(module.exports, "endOfISOWeek", () => $03cfb2162cdbac60$export$186cd934f32084be, (v) => $03cfb2162cdbac60$export$186cd934f32084be = v);
var $03cfb2162cdbac60$export$186cd934f32084be;
"use strict";
$03cfb2162cdbac60$export$186cd934f32084be = $03cfb2162cdbac60$var$endOfISOWeek;

var $eKR0J = parcelRequire("eKR0J");
/**
 * @name endOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the end of an ISO week for the given date.
 *
 * @description
 * Return the end of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of an ISO week
 *
 * @example
 * // The end of an ISO week for 2 September 2014 11:55:00:
 * const result = endOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Sep 07 2014 23:59:59.999
 */ function $03cfb2162cdbac60$var$endOfISOWeek(date) {
    return (0, $eKR0J.endOfWeek)(date, {
        weekStartsOn: 1
    });
}

});

parcelRegister("kqT2V", function(module, exports) {

$parcel$export(module.exports, "endOfISOWeekYear", () => $ee00ef5d1dcd8997$export$73068f3824c9c1d, (v) => $ee00ef5d1dcd8997$export$73068f3824c9c1d = v);
var $ee00ef5d1dcd8997$export$73068f3824c9c1d;
"use strict";
$ee00ef5d1dcd8997$export$73068f3824c9c1d = $ee00ef5d1dcd8997$var$endOfISOWeekYear;

var $lepTe = parcelRequire("lepTe");

var $77HoA = parcelRequire("77HoA");

var $CS8DB = parcelRequire("CS8DB");
/**
 * @name endOfISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the end of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the end of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of an ISO week-numbering year
 *
 * @example
 * // The end of an ISO week-numbering year for 2 July 2005:
 * const result = endOfISOWeekYear(new Date(2005, 6, 2))
 * //=> Sun Jan 01 2006 23:59:59.999
 */ function $ee00ef5d1dcd8997$var$endOfISOWeekYear(date) {
    const year = (0, $lepTe.getISOWeekYear)(date);
    const fourthOfJanuaryOfNextYear = (0, $CS8DB.constructFrom)(date, 0);
    fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
    const _date = (0, $77HoA.startOfISOWeek)(fourthOfJanuaryOfNextYear);
    _date.setMilliseconds(_date.getMilliseconds() - 1);
    return _date;
}

});

parcelRegister("7FIXx", function(module, exports) {

$parcel$export(module.exports, "endOfMinute", () => $595f3cb3386ed2b0$export$a06a772fc63bff07, (v) => $595f3cb3386ed2b0$export$a06a772fc63bff07 = v);
var $595f3cb3386ed2b0$export$a06a772fc63bff07;
"use strict";
$595f3cb3386ed2b0$export$a06a772fc63bff07 = $595f3cb3386ed2b0$var$endOfMinute;

var $26OhI = parcelRequire("26OhI");
/**
 * @name endOfMinute
 * @category Minute Helpers
 * @summary Return the end of a minute for the given date.
 *
 * @description
 * Return the end of a minute for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a minute
 *
 * @example
 * // The end of a minute for 1 December 2014 22:15:45.400:
 * const result = endOfMinute(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:59.999
 */ function $595f3cb3386ed2b0$var$endOfMinute(date) {
    const _date = (0, $26OhI.toDate)(date);
    _date.setSeconds(59, 999);
    return _date;
}

});

parcelRegister("ktpEa", function(module, exports) {

$parcel$export(module.exports, "endOfQuarter", () => $ee7a6903a3827e70$export$5f53493861eef879, (v) => $ee7a6903a3827e70$export$5f53493861eef879 = v);
var $ee7a6903a3827e70$export$5f53493861eef879;
"use strict";
$ee7a6903a3827e70$export$5f53493861eef879 = $ee7a6903a3827e70$var$endOfQuarter;

var $26OhI = parcelRequire("26OhI");
/**
 * @name endOfQuarter
 * @category Quarter Helpers
 * @summary Return the end of a year quarter for the given date.
 *
 * @description
 * Return the end of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a quarter
 *
 * @example
 * // The end of a quarter for 2 September 2014 11:55:00:
 * const result = endOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */ function $ee7a6903a3827e70$var$endOfQuarter(date) {
    const _date = (0, $26OhI.toDate)(date);
    const currentMonth = _date.getMonth();
    const month = currentMonth - currentMonth % 3 + 3;
    _date.setMonth(month, 0);
    _date.setHours(23, 59, 59, 999);
    return _date;
}

});

parcelRegister("2EhLl", function(module, exports) {

$parcel$export(module.exports, "endOfSecond", () => $1edd187c0a826e4a$export$ef560ab2fa7b52a2, (v) => $1edd187c0a826e4a$export$ef560ab2fa7b52a2 = v);
var $1edd187c0a826e4a$export$ef560ab2fa7b52a2;
"use strict";
$1edd187c0a826e4a$export$ef560ab2fa7b52a2 = $1edd187c0a826e4a$var$endOfSecond;

var $26OhI = parcelRequire("26OhI");
/**
 * @name endOfSecond
 * @category Second Helpers
 * @summary Return the end of a second for the given date.
 *
 * @description
 * Return the end of a second for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a second
 *
 * @example
 * // The end of a second for 1 December 2014 22:15:45.400:
 * const result = endOfSecond(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:45.999
 */ function $1edd187c0a826e4a$var$endOfSecond(date) {
    const _date = (0, $26OhI.toDate)(date);
    _date.setMilliseconds(999);
    return _date;
}

});

parcelRegister("cudbj", function(module, exports) {

$parcel$export(module.exports, "endOfToday", () => $917282ef4748abd0$export$1b7031a80bd92a6e, (v) => $917282ef4748abd0$export$1b7031a80bd92a6e = v);
var $917282ef4748abd0$export$1b7031a80bd92a6e;
"use strict";
$917282ef4748abd0$export$1b7031a80bd92a6e = $917282ef4748abd0$var$endOfToday;

var $lU13w = parcelRequire("lU13w");
/**
 * @name endOfToday
 * @category Day Helpers
 * @summary Return the end of today.
 * @pure false
 *
 * @description
 * Return the end of today.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @returns The end of today
 *
 * @example
 * // If today is 6 October 2014:
 * const result = endOfToday()
 * //=> Mon Oct 6 2014 23:59:59.999
 */ function $917282ef4748abd0$var$endOfToday() {
    return (0, $lU13w.endOfDay)(Date.now());
}

});

parcelRegister("j3Wja", function(module, exports) {

$parcel$export(module.exports, "endOfTomorrow", () => $de0b86e655670f4c$export$d788ac27ae2a54ea, (v) => $de0b86e655670f4c$export$d788ac27ae2a54ea = v);
var $de0b86e655670f4c$export$d788ac27ae2a54ea;
"use strict";
$de0b86e655670f4c$export$d788ac27ae2a54ea = $de0b86e655670f4c$var$endOfTomorrow; /**
 * @name endOfTomorrow
 * @category Day Helpers
 * @summary Return the end of tomorrow.
 * @pure false
 *
 * @description
 * Return the end of tomorrow.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @returns The end of tomorrow
 *
 * @example
 * // If today is 6 October 2014:
 * const result = endOfTomorrow()
 * //=> Tue Oct 7 2014 23:59:59.999
 */ 
function $de0b86e655670f4c$var$endOfTomorrow() {
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth();
    const day = now.getDate();
    const date = new Date(0);
    date.setFullYear(year, month, day + 1);
    date.setHours(23, 59, 59, 999);
    return date;
}

});

parcelRegister("6qI86", function(module, exports) {

$parcel$export(module.exports, "endOfYesterday", () => $4ae7670af260777f$export$45190faf1024f97a, (v) => $4ae7670af260777f$export$45190faf1024f97a = v);
var $4ae7670af260777f$export$45190faf1024f97a;
"use strict";
$4ae7670af260777f$export$45190faf1024f97a = $4ae7670af260777f$var$endOfYesterday; /**
 * @name endOfYesterday
 * @category Day Helpers
 * @summary Return the end of yesterday.
 * @pure false
 *
 * @description
 * Return the end of yesterday.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @returns The end of yesterday
 *
 * @example
 * // If today is 6 October 2014:
 * const result = endOfYesterday()
 * //=> Sun Oct 5 2014 23:59:59.999
 */ 
function $4ae7670af260777f$var$endOfYesterday() {
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth();
    const day = now.getDate();
    const date = new Date(0);
    date.setFullYear(year, month, day - 1);
    date.setHours(23, 59, 59, 999);
    return date;
}

});

parcelRegister("4BZg7", function(module, exports) {

$parcel$export(module.exports, "formatDistance", () => $35ba22db9858b66d$export$2c14ff85d6318973, (v) => $35ba22db9858b66d$export$2c14ff85d6318973 = v);
var $35ba22db9858b66d$export$2c14ff85d6318973;
"use strict";
$35ba22db9858b66d$export$2c14ff85d6318973 = $35ba22db9858b66d$var$formatDistance;

var $4CmQQ = parcelRequire("4CmQQ");

var $4IrbU = parcelRequire("4IrbU");

var $aBQYs = parcelRequire("aBQYs");

var $1i6Jz = parcelRequire("1i6Jz");

var $26OhI = parcelRequire("26OhI");

var $5hxJz = parcelRequire("5hxJz");

var $2Hkrd = parcelRequire("2Hkrd");

var $6f1d3 = parcelRequire("6f1d3");
/**
 * The {@link formatDistance} function options.
 */ /**
 * @name formatDistance
 * @category Common Helpers
 * @summary Return the distance between the given dates in words.
 *
 * @description
 * Return the distance between the given dates in words.
 *
 * | Distance between dates                                            | Result              |
 * |-------------------------------------------------------------------|---------------------|
 * | 0 ... 30 secs                                                     | less than a minute  |
 * | 30 secs ... 1 min 30 secs                                         | 1 minute            |
 * | 1 min 30 secs ... 44 mins 30 secs                                 | [2..44] minutes     |
 * | 44 mins ... 30 secs ... 89 mins 30 secs                           | about 1 hour        |
 * | 89 mins 30 secs ... 23 hrs 59 mins 30 secs                        | about [2..24] hours |
 * | 23 hrs 59 mins 30 secs ... 41 hrs 59 mins 30 secs                 | 1 day               |
 * | 41 hrs 59 mins 30 secs ... 29 days 23 hrs 59 mins 30 secs         | [2..30] days        |
 * | 29 days 23 hrs 59 mins 30 secs ... 44 days 23 hrs 59 mins 30 secs | about 1 month       |
 * | 44 days 23 hrs 59 mins 30 secs ... 59 days 23 hrs 59 mins 30 secs | about 2 months      |
 * | 59 days 23 hrs 59 mins 30 secs ... 1 yr                           | [2..12] months      |
 * | 1 yr ... 1 yr 3 months                                            | about 1 year        |
 * | 1 yr 3 months ... 1 yr 9 month s                                  | over 1 year         |
 * | 1 yr 9 months ... 2 yrs                                           | almost 2 years      |
 * | N yrs ... N yrs 3 months                                          | about N years       |
 * | N yrs 3 months ... N yrs 9 months                                 | over N years        |
 * | N yrs 9 months ... N+1 yrs                                        | almost N+1 years    |
 *
 * With `options.includeSeconds == true`:
 * | Distance between dates | Result               |
 * |------------------------|----------------------|
 * | 0 secs ... 5 secs      | less than 5 seconds  |
 * | 5 secs ... 10 secs     | less than 10 seconds |
 * | 10 secs ... 20 secs    | less than 20 seconds |
 * | 20 secs ... 40 secs    | half a minute        |
 * | 40 secs ... 60 secs    | less than a minute   |
 * | 60 secs ... 90 secs    | 1 minute             |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date
 * @param baseDate - The date to compare with
 * @param options - An object with options
 *
 * @returns The distance in words
 *
 * @throws `date` must not be Invalid Date
 * @throws `baseDate` must not be Invalid Date
 * @throws `options.locale` must contain `formatDistance` property
 *
 * @example
 * // What is the distance between 2 July 2014 and 1 January 2015?
 * const result = formatDistance(new Date(2014, 6, 2), new Date(2015, 0, 1))
 * //=> '6 months'
 *
 * @example
 * // What is the distance between 1 January 2015 00:00:15
 * // and 1 January 2015 00:00:00, including seconds?
 * const result = formatDistance(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   new Date(2015, 0, 1, 0, 0, 0),
 *   { includeSeconds: true }
 * )
 * //=> 'less than 20 seconds'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, with a suffix?
 * const result = formatDistance(new Date(2015, 0, 1), new Date(2016, 0, 1), {
 *   addSuffix: true
 * })
 * //=> 'about 1 year ago'
 *
 * @example
 * // What is the distance between 1 August 2016 and 1 January 2015 in Esperanto?
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = formatDistance(new Date(2016, 7, 1), new Date(2015, 0, 1), {
 *   locale: eoLocale
 * })
 * //=> 'pli ol 1 jaro'
 */ function $35ba22db9858b66d$var$formatDistance(date, baseDate, options) {
    const defaultOptions = (0, $2Hkrd.getDefaultOptions)();
    const locale = options?.locale ?? defaultOptions.locale ?? $5hxJz.defaultLocale;
    const minutesInAlmostTwoDays = 2520;
    const comparison = (0, $4CmQQ.compareAsc)(date, baseDate);
    if (isNaN(comparison)) throw new RangeError("Invalid time value");
    const localizeOptions = Object.assign({}, options, {
        addSuffix: options?.addSuffix,
        comparison: comparison
    });
    let dateLeft;
    let dateRight;
    if (comparison > 0) {
        dateLeft = (0, $26OhI.toDate)(baseDate);
        dateRight = (0, $26OhI.toDate)(date);
    } else {
        dateLeft = (0, $26OhI.toDate)(date);
        dateRight = (0, $26OhI.toDate)(baseDate);
    }
    const seconds = (0, $1i6Jz.differenceInSeconds)(dateRight, dateLeft);
    const offsetInSeconds = ((0, $6f1d3.getTimezoneOffsetInMilliseconds)(dateRight) - (0, $6f1d3.getTimezoneOffsetInMilliseconds)(dateLeft)) / 1000;
    const minutes = Math.round((seconds - offsetInSeconds) / 60);
    let months;
    // 0 up to 2 mins
    if (minutes < 2) {
        if (options?.includeSeconds) {
            if (seconds < 5) return locale.formatDistance("lessThanXSeconds", 5, localizeOptions);
            else if (seconds < 10) return locale.formatDistance("lessThanXSeconds", 10, localizeOptions);
            else if (seconds < 20) return locale.formatDistance("lessThanXSeconds", 20, localizeOptions);
            else if (seconds < 40) return locale.formatDistance("halfAMinute", 0, localizeOptions);
            else if (seconds < 60) return locale.formatDistance("lessThanXMinutes", 1, localizeOptions);
            else return locale.formatDistance("xMinutes", 1, localizeOptions);
        } else {
            if (minutes === 0) return locale.formatDistance("lessThanXMinutes", 1, localizeOptions);
            else return locale.formatDistance("xMinutes", minutes, localizeOptions);
        }
    } else if (minutes < 45) return locale.formatDistance("xMinutes", minutes, localizeOptions);
    else if (minutes < 90) return locale.formatDistance("aboutXHours", 1, localizeOptions);
    else if (minutes < $4IrbU.minutesInDay) {
        const hours = Math.round(minutes / 60);
        return locale.formatDistance("aboutXHours", hours, localizeOptions);
    // 1 day up to 1.75 days
    } else if (minutes < minutesInAlmostTwoDays) return locale.formatDistance("xDays", 1, localizeOptions);
    else if (minutes < $4IrbU.minutesInMonth) {
        const days = Math.round(minutes / $4IrbU.minutesInDay);
        return locale.formatDistance("xDays", days, localizeOptions);
    // 1 month up to 2 months
    } else if (minutes < $4IrbU.minutesInMonth * 2) {
        months = Math.round(minutes / $4IrbU.minutesInMonth);
        return locale.formatDistance("aboutXMonths", months, localizeOptions);
    }
    months = (0, $aBQYs.differenceInMonths)(dateRight, dateLeft);
    // 2 months up to 12 months
    if (months < 12) {
        const nearestMonth = Math.round(minutes / $4IrbU.minutesInMonth);
        return locale.formatDistance("xMonths", nearestMonth, localizeOptions);
    // 1 year up to max Date
    } else {
        const monthsSinceStartOfYear = months % 12;
        const years = Math.trunc(months / 12);
        // N years up to 1 years 3 months
        if (monthsSinceStartOfYear < 3) return locale.formatDistance("aboutXYears", years, localizeOptions);
        else if (monthsSinceStartOfYear < 9) return locale.formatDistance("overXYears", years, localizeOptions);
        else return locale.formatDistance("almostXYears", years + 1, localizeOptions);
    }
}

});

parcelRegister("ikvfh", function(module, exports) {

$parcel$export(module.exports, "formatDistanceStrict", () => $d58254ee63a5b49d$export$e4be225b8ee0a759, (v) => $d58254ee63a5b49d$export$e4be225b8ee0a759 = v);
var $d58254ee63a5b49d$export$e4be225b8ee0a759;
"use strict";
$d58254ee63a5b49d$export$e4be225b8ee0a759 = $d58254ee63a5b49d$var$formatDistanceStrict;

var $5hxJz = parcelRequire("5hxJz");

var $2Hkrd = parcelRequire("2Hkrd");

var $60GiW = parcelRequire("60GiW");

var $6f1d3 = parcelRequire("6f1d3");

var $4CmQQ = parcelRequire("4CmQQ");

var $4IrbU = parcelRequire("4IrbU");

var $26OhI = parcelRequire("26OhI");
/**
 * The {@link formatDistanceStrict} function options.
 */ /**
 * The unit used to format the distance in {@link formatDistanceStrict}.
 */ /**
 * @name formatDistanceStrict
 * @category Common Helpers
 * @summary Return the distance between the given dates in words.
 *
 * @description
 * Return the distance between the given dates in words, using strict units.
 * This is like `formatDistance`, but does not use helpers like 'almost', 'over',
 * 'less than' and the like.
 *
 * | Distance between dates | Result              |
 * |------------------------|---------------------|
 * | 0 ... 59 secs          | [0..59] seconds     |
 * | 1 ... 59 mins          | [1..59] minutes     |
 * | 1 ... 23 hrs           | [1..23] hours       |
 * | 1 ... 29 days          | [1..29] days        |
 * | 1 ... 11 months        | [1..11] months      |
 * | 1 ... N years          | [1..N]  years       |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date
 * @param baseDate - The date to compare with
 * @param options - An object with options
 *
 * @returns The distance in words
 *
 * @throws `date` must not be Invalid Date
 * @throws `baseDate` must not be Invalid Date
 * @throws `options.unit` must be 'second', 'minute', 'hour', 'day', 'month' or 'year'
 * @throws `options.locale` must contain `formatDistance` property
 *
 * @example
 * // What is the distance between 2 July 2014 and 1 January 2015?
 * const result = formatDistanceStrict(new Date(2014, 6, 2), new Date(2015, 0, 2))
 * //=> '6 months'
 *
 * @example
 * // What is the distance between 1 January 2015 00:00:15
 * // and 1 January 2015 00:00:00?
 * const result = formatDistanceStrict(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   new Date(2015, 0, 1, 0, 0, 0)
 * )
 * //=> '15 seconds'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, with a suffix?
 * const result = formatDistanceStrict(new Date(2015, 0, 1), new Date(2016, 0, 1), {
 *   addSuffix: true
 * })
 * //=> '1 year ago'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, in minutes?
 * const result = formatDistanceStrict(new Date(2016, 0, 1), new Date(2015, 0, 1), {
 *   unit: 'minute'
 * })
 * //=> '525600 minutes'
 *
 * @example
 * // What is the distance from 1 January 2015
 * // to 28 January 2015, in months, rounded up?
 * const result = formatDistanceStrict(new Date(2015, 0, 28), new Date(2015, 0, 1), {
 *   unit: 'month',
 *   roundingMethod: 'ceil'
 * })
 * //=> '1 month'
 *
 * @example
 * // What is the distance between 1 August 2016 and 1 January 2015 in Esperanto?
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = formatDistanceStrict(new Date(2016, 7, 1), new Date(2015, 0, 1), {
 *   locale: eoLocale
 * })
 * //=> '1 jaro'
 */ function $d58254ee63a5b49d$var$formatDistanceStrict(date, baseDate, options) {
    const defaultOptions = (0, $2Hkrd.getDefaultOptions)();
    const locale = options?.locale ?? defaultOptions.locale ?? $5hxJz.defaultLocale;
    const comparison = (0, $4CmQQ.compareAsc)(date, baseDate);
    if (isNaN(comparison)) throw new RangeError("Invalid time value");
    const localizeOptions = Object.assign({}, options, {
        addSuffix: options?.addSuffix,
        comparison: comparison
    });
    let dateLeft;
    let dateRight;
    if (comparison > 0) {
        dateLeft = (0, $26OhI.toDate)(baseDate);
        dateRight = (0, $26OhI.toDate)(date);
    } else {
        dateLeft = (0, $26OhI.toDate)(date);
        dateRight = (0, $26OhI.toDate)(baseDate);
    }
    const roundingMethod = (0, $60GiW.getRoundingMethod)(options?.roundingMethod ?? "round");
    const milliseconds = dateRight.getTime() - dateLeft.getTime();
    const minutes = milliseconds / $4IrbU.millisecondsInMinute;
    const timezoneOffset = (0, $6f1d3.getTimezoneOffsetInMilliseconds)(dateRight) - (0, $6f1d3.getTimezoneOffsetInMilliseconds)(dateLeft);
    // Use DST-normalized difference in minutes for years, months and days;
    // use regular difference in minutes for hours, minutes and seconds.
    const dstNormalizedMinutes = (milliseconds - timezoneOffset) / $4IrbU.millisecondsInMinute;
    const defaultUnit = options?.unit;
    let unit;
    if (!defaultUnit) {
        if (minutes < 1) unit = "second";
        else if (minutes < 60) unit = "minute";
        else if (minutes < $4IrbU.minutesInDay) unit = "hour";
        else if (dstNormalizedMinutes < $4IrbU.minutesInMonth) unit = "day";
        else if (dstNormalizedMinutes < $4IrbU.minutesInYear) unit = "month";
        else unit = "year";
    } else unit = defaultUnit;
    // 0 up to 60 seconds
    if (unit === "second") {
        const seconds = roundingMethod(milliseconds / 1000);
        return locale.formatDistance("xSeconds", seconds, localizeOptions);
    // 1 up to 60 mins
    } else if (unit === "minute") {
        const roundedMinutes = roundingMethod(minutes);
        return locale.formatDistance("xMinutes", roundedMinutes, localizeOptions);
    // 1 up to 24 hours
    } else if (unit === "hour") {
        const hours = roundingMethod(minutes / 60);
        return locale.formatDistance("xHours", hours, localizeOptions);
    // 1 up to 30 days
    } else if (unit === "day") {
        const days = roundingMethod(dstNormalizedMinutes / $4IrbU.minutesInDay);
        return locale.formatDistance("xDays", days, localizeOptions);
    // 1 up to 12 months
    } else if (unit === "month") {
        const months = roundingMethod(dstNormalizedMinutes / $4IrbU.minutesInMonth);
        return months === 12 && defaultUnit !== "month" ? locale.formatDistance("xYears", 1, localizeOptions) : locale.formatDistance("xMonths", months, localizeOptions);
    // 1 year up to max Date
    } else {
        const years = roundingMethod(dstNormalizedMinutes / $4IrbU.minutesInYear);
        return locale.formatDistance("xYears", years, localizeOptions);
    }
}

});

parcelRegister("hyD7d", function(module, exports) {

$parcel$export(module.exports, "formatDistanceToNow", () => $cc83f4248b301404$export$d130c20a256f8817, (v) => $cc83f4248b301404$export$d130c20a256f8817 = v);
var $cc83f4248b301404$export$d130c20a256f8817;
"use strict";
$cc83f4248b301404$export$d130c20a256f8817 = $cc83f4248b301404$var$formatDistanceToNow;

var $4BZg7 = parcelRequire("4BZg7");
/**
 * The {@link formatDistanceToNow} function options.
 */ /**
 * @name formatDistanceToNow
 * @category Common Helpers
 * @summary Return the distance between the given date and now in words.
 * @pure false
 *
 * @description
 * Return the distance between the given date and now in words.
 *
 * | Distance to now                                                   | Result              |
 * |-------------------------------------------------------------------|---------------------|
 * | 0 ... 30 secs                                                     | less than a minute  |
 * | 30 secs ... 1 min 30 secs                                         | 1 minute            |
 * | 1 min 30 secs ... 44 mins 30 secs                                 | [2..44] minutes     |
 * | 44 mins ... 30 secs ... 89 mins 30 secs                           | about 1 hour        |
 * | 89 mins 30 secs ... 23 hrs 59 mins 30 secs                        | about [2..24] hours |
 * | 23 hrs 59 mins 30 secs ... 41 hrs 59 mins 30 secs                 | 1 day               |
 * | 41 hrs 59 mins 30 secs ... 29 days 23 hrs 59 mins 30 secs         | [2..30] days        |
 * | 29 days 23 hrs 59 mins 30 secs ... 44 days 23 hrs 59 mins 30 secs | about 1 month       |
 * | 44 days 23 hrs 59 mins 30 secs ... 59 days 23 hrs 59 mins 30 secs | about 2 months      |
 * | 59 days 23 hrs 59 mins 30 secs ... 1 yr                           | [2..12] months      |
 * | 1 yr ... 1 yr 3 months                                            | about 1 year        |
 * | 1 yr 3 months ... 1 yr 9 month s                                  | over 1 year         |
 * | 1 yr 9 months ... 2 yrs                                           | almost 2 years      |
 * | N yrs ... N yrs 3 months                                          | about N years       |
 * | N yrs 3 months ... N yrs 9 months                                 | over N years        |
 * | N yrs 9 months ... N+1 yrs                                        | almost N+1 years    |
 *
 * With `options.includeSeconds == true`:
 * | Distance to now     | Result               |
 * |---------------------|----------------------|
 * | 0 secs ... 5 secs   | less than 5 seconds  |
 * | 5 secs ... 10 secs  | less than 10 seconds |
 * | 10 secs ... 20 secs | less than 20 seconds |
 * | 20 secs ... 40 secs | half a minute        |
 * | 40 secs ... 60 secs | less than a minute   |
 * | 60 secs ... 90 secs | 1 minute             |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - The object with options
 *
 * @returns The distance in words
 *
 * @throws `date` must not be Invalid Date
 * @throws `options.locale` must contain `formatDistance` property
 *
 * @example
 * // If today is 1 January 2015, what is the distance to 2 July 2014?
 * const result = formatDistanceToNow(
 *   new Date(2014, 6, 2)
 * )
 * //=> '6 months'
 *
 * @example
 * // If now is 1 January 2015 00:00:00,
 * // what is the distance to 1 January 2015 00:00:15, including seconds?
 * const result = formatDistanceToNow(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   {includeSeconds: true}
 * )
 * //=> 'less than 20 seconds'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 January 2016, with a suffix?
 * const result = formatDistanceToNow(
 *   new Date(2016, 0, 1),
 *   {addSuffix: true}
 * )
 * //=> 'in about 1 year'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 August 2016 in Esperanto?
 * const eoLocale = require('date-fns/locale/eo')
 * const result = formatDistanceToNow(
 *   new Date(2016, 7, 1),
 *   {locale: eoLocale}
 * )
 * //=> 'pli ol 1 jaro'
 */ function $cc83f4248b301404$var$formatDistanceToNow(date, options) {
    return (0, $4BZg7.formatDistance)(date, Date.now(), options);
}

});

parcelRegister("fmNnT", function(module, exports) {

$parcel$export(module.exports, "formatDistanceToNowStrict", () => $b2ff37cc94bb5ea5$export$d0e02d4eb1ad1e32, (v) => $b2ff37cc94bb5ea5$export$d0e02d4eb1ad1e32 = v);
var $b2ff37cc94bb5ea5$export$d0e02d4eb1ad1e32;
"use strict";
$b2ff37cc94bb5ea5$export$d0e02d4eb1ad1e32 = $b2ff37cc94bb5ea5$var$formatDistanceToNowStrict;

var $ikvfh = parcelRequire("ikvfh");
/**
 * The {@link formatDistanceToNowStrict} function options.
 */ /**
 * @name formatDistanceToNowStrict
 * @category Common Helpers
 * @summary Return the distance between the given date and now in words.
 * @pure false
 *
 * @description
 * Return the distance between the given dates in words, using strict units.
 * This is like `formatDistance`, but does not use helpers like 'almost', 'over',
 * 'less than' and the like.
 *
 * | Distance between dates | Result              |
 * |------------------------|---------------------|
 * | 0 ... 59 secs          | [0..59] seconds     |
 * | 1 ... 59 mins          | [1..59] minutes     |
 * | 1 ... 23 hrs           | [1..23] hours       |
 * | 1 ... 29 days          | [1..29] days        |
 * | 1 ... 11 months        | [1..11] months      |
 * | 1 ... N years          | [1..N]  years       |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options.
 *
 * @returns The distance in words
 *
 * @throws `date` must not be Invalid Date
 * @throws `options.locale` must contain `formatDistance` property
 *
 * @example
 * // If today is 1 January 2015, what is the distance to 2 July 2014?
 * const result = formatDistanceToNowStrict(
 *   new Date(2014, 6, 2)
 * )
 * //=> '6 months'
 *
 * @example
 * // If now is 1 January 2015 00:00:00,
 * // what is the distance to 1 January 2015 00:00:15, including seconds?
 * const result = formatDistanceToNowStrict(
 *   new Date(2015, 0, 1, 0, 0, 15)
 * )
 * //=> '15 seconds'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 January 2016, with a suffix?
 * const result = formatDistanceToNowStrict(
 *   new Date(2016, 0, 1),
 *   {addSuffix: true}
 * )
 * //=> 'in 1 year'
 *
 * @example
 * // If today is 28 January 2015,
 * // what is the distance to 1 January 2015, in months, rounded up??
 * const result = formatDistanceToNowStrict(new Date(2015, 0, 1), {
 *   unit: 'month',
 *   roundingMethod: 'ceil'
 * })
 * //=> '1 month'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 January 2016 in Esperanto?
 * const eoLocale = require('date-fns/locale/eo')
 * const result = formatDistanceToNowStrict(
 *   new Date(2016, 0, 1),
 *   {locale: eoLocale}
 * )
 * //=> '1 jaro'
 */ function $b2ff37cc94bb5ea5$var$formatDistanceToNowStrict(date, options) {
    return (0, $ikvfh.formatDistanceStrict)(date, Date.now(), options);
}

});

parcelRegister("dE2v5", function(module, exports) {

$parcel$export(module.exports, "formatDuration", () => $9ef0f35624bbfc2a$export$bc733b0c5cbb3e8a, (v) => $9ef0f35624bbfc2a$export$bc733b0c5cbb3e8a = v);
var $9ef0f35624bbfc2a$export$bc733b0c5cbb3e8a;
"use strict";
$9ef0f35624bbfc2a$export$bc733b0c5cbb3e8a = $9ef0f35624bbfc2a$var$formatDuration;

var $5hxJz = parcelRequire("5hxJz");

var $2Hkrd = parcelRequire("2Hkrd");
/**
 * The {@link formatDuration} function options.
 */ const $9ef0f35624bbfc2a$var$defaultFormat = [
    "years",
    "months",
    "weeks",
    "days",
    "hours",
    "minutes",
    "seconds"
];
/**
 * @name formatDuration
 * @category Common Helpers
 * @summary Formats a duration in human-readable format
 *
 * @description
 * Return human-readable duration string i.e. "9 months 2 days"
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param duration - The duration to format
 * @param options - An object with options.
 *
 * @returns The formatted date string
 *
 * @example
 * // Format full duration
 * formatDuration({
 *   years: 2,
 *   months: 9,
 *   weeks: 1,
 *   days: 7,
 *   hours: 5,
 *   minutes: 9,
 *   seconds: 30
 * })
 * //=> '2 years 9 months 1 week 7 days 5 hours 9 minutes 30 seconds'
 *
 * @example
 * // Format partial duration
 * formatDuration({ months: 9, days: 2 })
 * //=> '9 months 2 days'
 *
 * @example
 * // Customize the format
 * formatDuration(
 *   {
 *     years: 2,
 *     months: 9,
 *     weeks: 1,
 *     days: 7,
 *     hours: 5,
 *     minutes: 9,
 *     seconds: 30
 *   },
 *   { format: ['months', 'weeks'] }
 * ) === '9 months 1 week'
 *
 * @example
 * // Customize the zeros presence
 * formatDuration({ years: 0, months: 9 })
 * //=> '9 months'
 * formatDuration({ years: 0, months: 9 }, { zero: true })
 * //=> '0 years 9 months'
 *
 * @example
 * // Customize the delimiter
 * formatDuration({ years: 2, months: 9, weeks: 3 }, { delimiter: ', ' })
 * //=> '2 years, 9 months, 3 weeks'
 */ function $9ef0f35624bbfc2a$var$formatDuration(duration, options) {
    const defaultOptions = (0, $2Hkrd.getDefaultOptions)();
    const locale = options?.locale ?? defaultOptions.locale ?? $5hxJz.defaultLocale;
    const format = options?.format ?? $9ef0f35624bbfc2a$var$defaultFormat;
    const zero = options?.zero ?? false;
    const delimiter = options?.delimiter ?? " ";
    if (!locale.formatDistance) return "";
    const result = format.reduce((acc, unit)=>{
        const token = `x${unit.replace(/(^.)/, (m)=>m.toUpperCase())}`;
        const value = duration[unit];
        if (value !== undefined && (zero || duration[unit])) return acc.concat(locale.formatDistance(token, value));
        return acc;
    }, []).join(delimiter);
    return result;
}

});

parcelRegister("keVRV", function(module, exports) {

$parcel$export(module.exports, "formatISO", () => $ebc200fe77598d80$export$3c826ac3ab9da76c, (v) => $ebc200fe77598d80$export$3c826ac3ab9da76c = v);
var $ebc200fe77598d80$export$3c826ac3ab9da76c;
"use strict";
$ebc200fe77598d80$export$3c826ac3ab9da76c = $ebc200fe77598d80$var$formatISO;

var $26OhI = parcelRequire("26OhI");

var $cPWeo = parcelRequire("cPWeo");
/**
 * The {@link formatISO} function options.
 */ /**
 * @name formatISO
 * @category Common Helpers
 * @summary Format the date according to the ISO 8601 standard (https://support.sas.com/documentation/cdl/en/lrdict/64316/HTML/default/viewer.htm#a003169814.htm).
 *
 * @description
 * Return the formatted date string in ISO 8601 format. Options may be passed to control the parts and notations of the date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options.
 *
 * @returns The formatted date string (in loca.l time zone)
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 18 September 2019 in ISO 8601 format (local time zone is UTC):
 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52))
 * //=> '2019-09-18T19:00:52Z'
 *
 * @example
 * // Represent 18 September 2019 in ISO 8601, short format (local time zone is UTC):
 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { format: 'basic' })
 * //=> '20190918T190052'
 *
 * @example
 * // Represent 18 September 2019 in ISO 8601 format, date only:
 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { representation: 'date' })
 * //=> '2019-09-18'
 *
 * @example
 * // Represent 18 September 2019 in ISO 8601 format, time only (local time zone is UTC):
 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { representation: 'time' })
 * //=> '19:00:52Z'
 */ function $ebc200fe77598d80$var$formatISO(date, options) {
    const _date = (0, $26OhI.toDate)(date);
    if (isNaN(_date.getTime())) throw new RangeError("Invalid time value");
    const format = options?.format ?? "extended";
    const representation = options?.representation ?? "complete";
    let result = "";
    let tzOffset = "";
    const dateDelimiter = format === "extended" ? "-" : "";
    const timeDelimiter = format === "extended" ? ":" : "";
    // Representation is either 'date' or 'complete'
    if (representation !== "time") {
        const day = (0, $cPWeo.addLeadingZeros)(_date.getDate(), 2);
        const month = (0, $cPWeo.addLeadingZeros)(_date.getMonth() + 1, 2);
        const year = (0, $cPWeo.addLeadingZeros)(_date.getFullYear(), 4);
        // yyyyMMdd or yyyy-MM-dd.
        result = `${year}${dateDelimiter}${month}${dateDelimiter}${day}`;
    }
    // Representation is either 'time' or 'complete'
    if (representation !== "date") {
        // Add the timezone.
        const offset = _date.getTimezoneOffset();
        if (offset !== 0) {
            const absoluteOffset = Math.abs(offset);
            const hourOffset = (0, $cPWeo.addLeadingZeros)(Math.trunc(absoluteOffset / 60), 2);
            const minuteOffset = (0, $cPWeo.addLeadingZeros)(absoluteOffset % 60, 2);
            // If less than 0, the sign is +, because it is ahead of time.
            const sign = offset < 0 ? "+" : "-";
            tzOffset = `${sign}${hourOffset}:${minuteOffset}`;
        } else tzOffset = "Z";
        const hour = (0, $cPWeo.addLeadingZeros)(_date.getHours(), 2);
        const minute = (0, $cPWeo.addLeadingZeros)(_date.getMinutes(), 2);
        const second = (0, $cPWeo.addLeadingZeros)(_date.getSeconds(), 2);
        // If there's also date, separate it with time with 'T'
        const separator = result === "" ? "" : "T";
        // Creates a time string consisting of hour, minute, and second, separated by delimiters, if defined.
        const time = [
            hour,
            minute,
            second
        ].join(timeDelimiter);
        // HHmmss or HH:mm:ss.
        result = `${result}${separator}${time}${tzOffset}`;
    }
    return result;
}

});

parcelRegister("7fJI0", function(module, exports) {

$parcel$export(module.exports, "formatISO9075", () => $547d63eb59aa1f07$export$a673944250043fa4, (v) => $547d63eb59aa1f07$export$a673944250043fa4 = v);
var $547d63eb59aa1f07$export$a673944250043fa4;
"use strict";
$547d63eb59aa1f07$export$a673944250043fa4 = $547d63eb59aa1f07$var$formatISO9075;

var $gwJip = parcelRequire("gwJip");

var $26OhI = parcelRequire("26OhI");

var $cPWeo = parcelRequire("cPWeo");
/**
 * The {@link formatISO9075} function options.
 */ /**
 * @name formatISO9075
 * @category Common Helpers
 * @summary Format the date according to the ISO 9075 standard (https://dev.mysql.com/doc/refman/5.7/en/date-and-time-functions.html#function_get-format).
 *
 * @description
 * Return the formatted date string in ISO 9075 format. Options may be passed to control the parts and notations of the date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options.
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 18 September 2019 in ISO 9075 format:
 * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52))
 * //=> '2019-09-18 19:00:52'
 *
 * @example
 * // Represent 18 September 2019 in ISO 9075, short format:
 * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52), { format: 'basic' })
 * //=> '20190918 190052'
 *
 * @example
 * // Represent 18 September 2019 in ISO 9075 format, date only:
 * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52), { representation: 'date' })
 * //=> '2019-09-18'
 *
 * @example
 * // Represent 18 September 2019 in ISO 9075 format, time only:
 * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52), { representation: 'time' })
 * //=> '19:00:52'
 */ function $547d63eb59aa1f07$var$formatISO9075(date, options) {
    const _date = (0, $26OhI.toDate)(date);
    if (!(0, $gwJip.isValid)(_date)) throw new RangeError("Invalid time value");
    const format = options?.format ?? "extended";
    const representation = options?.representation ?? "complete";
    let result = "";
    const dateDelimiter = format === "extended" ? "-" : "";
    const timeDelimiter = format === "extended" ? ":" : "";
    // Representation is either 'date' or 'complete'
    if (representation !== "time") {
        const day = (0, $cPWeo.addLeadingZeros)(_date.getDate(), 2);
        const month = (0, $cPWeo.addLeadingZeros)(_date.getMonth() + 1, 2);
        const year = (0, $cPWeo.addLeadingZeros)(_date.getFullYear(), 4);
        // yyyyMMdd or yyyy-MM-dd.
        result = `${year}${dateDelimiter}${month}${dateDelimiter}${day}`;
    }
    // Representation is either 'time' or 'complete'
    if (representation !== "date") {
        const hour = (0, $cPWeo.addLeadingZeros)(_date.getHours(), 2);
        const minute = (0, $cPWeo.addLeadingZeros)(_date.getMinutes(), 2);
        const second = (0, $cPWeo.addLeadingZeros)(_date.getSeconds(), 2);
        // If there's also date, separate it with time with a space
        const separator = result === "" ? "" : " ";
        // HHmmss or HH:mm:ss.
        result = `${result}${separator}${hour}${timeDelimiter}${minute}${timeDelimiter}${second}`;
    }
    return result;
}

});

parcelRegister("fmQhw", function(module, exports) {

$parcel$export(module.exports, "formatISODuration", () => $b301771ff439a5ef$export$437c31ab743f6b26, (v) => $b301771ff439a5ef$export$437c31ab743f6b26 = v);
var $b301771ff439a5ef$export$437c31ab743f6b26;
"use strict";
$b301771ff439a5ef$export$437c31ab743f6b26 = $b301771ff439a5ef$var$formatISODuration;
/**
 * @name formatISODuration
 * @category Common Helpers
 * @summary Format a duration object according as ISO 8601 duration string
 *
 * @description
 * Format a duration object according to the ISO 8601 duration standard (https://www.digi.com/resources/documentation/digidocs//90001488-13/reference/r_iso_8601_duration_format.htm)
 *
 * @param duration - The duration to format
 *
 * @returns The ISO 8601 duration string
 *
 * @example
 * // Format the given duration as ISO 8601 string
 * const result = formatISODuration({
 *   years: 39,
 *   months: 2,
 *   days: 20,
 *   hours: 7,
 *   minutes: 5,
 *   seconds: 0
 * })
 * //=> 'P39Y2M20DT0H0M0S'
 */ function $b301771ff439a5ef$var$formatISODuration(duration) {
    const { years: years = 0, months: months = 0, days: days = 0, hours: hours = 0, minutes: minutes = 0, seconds: seconds = 0 } = duration;
    return `P${years}Y${months}M${days}DT${hours}H${minutes}M${seconds}S`;
}

});

parcelRegister("ldJLN", function(module, exports) {

$parcel$export(module.exports, "formatRFC3339", () => $f72e50d4bc6dd5f3$export$6d441bffeec6bd6c, (v) => $f72e50d4bc6dd5f3$export$6d441bffeec6bd6c = v);
var $f72e50d4bc6dd5f3$export$6d441bffeec6bd6c;
"use strict";
$f72e50d4bc6dd5f3$export$6d441bffeec6bd6c = $f72e50d4bc6dd5f3$var$formatRFC3339;

var $gwJip = parcelRequire("gwJip");

var $26OhI = parcelRequire("26OhI");

var $cPWeo = parcelRequire("cPWeo");
/**
 * The {@link formatRFC3339} function options.
 */ /**
 * @name formatRFC3339
 * @category Common Helpers
 * @summary Format the date according to the RFC 3339 standard (https://tools.ietf.org/html/rfc3339#section-5.6).
 *
 * @description
 * Return the formatted date string in RFC 3339 format. Options may be passed to control the parts and notations of the date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options.
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 18 September 2019 in RFC 3339 format:
 * formatRFC3339(new Date(2019, 8, 18, 19, 0, 52))
 * //=> '2019-09-18T19:00:52Z'
 *
 * @example
 * // Represent 18 September 2019 in RFC 3339 format, 3 digits of second fraction
 * formatRFC3339(new Date(2019, 8, 18, 19, 0, 52, 234), {
 *   fractionDigits: 3
 * })
 * //=> '2019-09-18T19:00:52.234Z'
 */ function $f72e50d4bc6dd5f3$var$formatRFC3339(date, options) {
    const _date = (0, $26OhI.toDate)(date);
    if (!(0, $gwJip.isValid)(_date)) throw new RangeError("Invalid time value");
    const fractionDigits = options?.fractionDigits ?? 0;
    const day = (0, $cPWeo.addLeadingZeros)(_date.getDate(), 2);
    const month = (0, $cPWeo.addLeadingZeros)(_date.getMonth() + 1, 2);
    const year = _date.getFullYear();
    const hour = (0, $cPWeo.addLeadingZeros)(_date.getHours(), 2);
    const minute = (0, $cPWeo.addLeadingZeros)(_date.getMinutes(), 2);
    const second = (0, $cPWeo.addLeadingZeros)(_date.getSeconds(), 2);
    let fractionalSecond = "";
    if (fractionDigits > 0) {
        const milliseconds = _date.getMilliseconds();
        const fractionalSeconds = Math.trunc(milliseconds * Math.pow(10, fractionDigits - 3));
        fractionalSecond = "." + (0, $cPWeo.addLeadingZeros)(fractionalSeconds, fractionDigits);
    }
    let offset = "";
    const tzOffset = _date.getTimezoneOffset();
    if (tzOffset !== 0) {
        const absoluteOffset = Math.abs(tzOffset);
        const hourOffset = (0, $cPWeo.addLeadingZeros)(Math.trunc(absoluteOffset / 60), 2);
        const minuteOffset = (0, $cPWeo.addLeadingZeros)(absoluteOffset % 60, 2);
        // If less than 0, the sign is +, because it is ahead of time.
        const sign = tzOffset < 0 ? "+" : "-";
        offset = `${sign}${hourOffset}:${minuteOffset}`;
    } else offset = "Z";
    return `${year}-${month}-${day}T${hour}:${minute}:${second}${fractionalSecond}${offset}`;
}

});

parcelRegister("drbnY", function(module, exports) {

$parcel$export(module.exports, "formatRFC7231", () => $9c86a0ec71f1951d$export$7add2e4539ce658a, (v) => $9c86a0ec71f1951d$export$7add2e4539ce658a = v);
var $9c86a0ec71f1951d$export$7add2e4539ce658a;
"use strict";
$9c86a0ec71f1951d$export$7add2e4539ce658a = $9c86a0ec71f1951d$var$formatRFC7231;

var $gwJip = parcelRequire("gwJip");

var $26OhI = parcelRequire("26OhI");

var $cPWeo = parcelRequire("cPWeo");
const $9c86a0ec71f1951d$var$days = [
    "Sun",
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat"
];
const $9c86a0ec71f1951d$var$months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
/**
 * @name formatRFC7231
 * @category Common Helpers
 * @summary Format the date according to the RFC 7231 standard (https://tools.ietf.org/html/rfc7231#section-7.1.1.1).
 *
 * @description
 * Return the formatted date string in RFC 7231 format.
 * The result will always be in UTC timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 18 September 2019 in RFC 7231 format:
 * const result = formatRFC7231(new Date(2019, 8, 18, 19, 0, 52))
 * //=> 'Wed, 18 Sep 2019 19:00:52 GMT'
 */ function $9c86a0ec71f1951d$var$formatRFC7231(date) {
    const _date = (0, $26OhI.toDate)(date);
    if (!(0, $gwJip.isValid)(_date)) throw new RangeError("Invalid time value");
    const dayName = $9c86a0ec71f1951d$var$days[_date.getUTCDay()];
    const dayOfMonth = (0, $cPWeo.addLeadingZeros)(_date.getUTCDate(), 2);
    const monthName = $9c86a0ec71f1951d$var$months[_date.getUTCMonth()];
    const year = _date.getUTCFullYear();
    const hour = (0, $cPWeo.addLeadingZeros)(_date.getUTCHours(), 2);
    const minute = (0, $cPWeo.addLeadingZeros)(_date.getUTCMinutes(), 2);
    const second = (0, $cPWeo.addLeadingZeros)(_date.getUTCSeconds(), 2);
    // Result variables.
    return `${dayName}, ${dayOfMonth} ${monthName} ${year} ${hour}:${minute}:${second} GMT`;
}

});

parcelRegister("3wSHK", function(module, exports) {

$parcel$export(module.exports, "formatRelative", () => $291ecb79f44fe7b1$export$8fbbfd65594f46a0, (v) => $291ecb79f44fe7b1$export$8fbbfd65594f46a0 = v);
var $291ecb79f44fe7b1$export$8fbbfd65594f46a0;
"use strict";
$291ecb79f44fe7b1$export$8fbbfd65594f46a0 = $291ecb79f44fe7b1$var$formatRelative;

var $hzJYa = parcelRequire("hzJYa");

var $dmAUx = parcelRequire("dmAUx");

var $26OhI = parcelRequire("26OhI");

var $5hxJz = parcelRequire("5hxJz");

var $2Hkrd = parcelRequire("2Hkrd");
/**
 * The {@link formatRelative} function options.
 */ /**
 * @name formatRelative
 * @category Common Helpers
 * @summary Represent the date in words relative to the given base date.
 *
 * @description
 * Represent the date in words relative to the given base date.
 *
 * | Distance to the base date | Result                    |
 * |---------------------------|---------------------------|
 * | Previous 6 days           | last Sunday at 04:30 AM   |
 * | Last day                  | yesterday at 04:30 AM     |
 * | Same day                  | today at 04:30 AM         |
 * | Next day                  | tomorrow at 04:30 AM      |
 * | Next 6 days               | Sunday at 04:30 AM        |
 * | Other                     | 12/31/2017                |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to format
 * @param baseDate - The date to compare with
 * @param options - An object with options
 *
 * @returns The date in words
 *
 * @throws `date` must not be Invalid Date
 * @throws `baseDate` must not be Invalid Date
 * @throws `options.locale` must contain `localize` property
 * @throws `options.locale` must contain `formatLong` property
 * @throws `options.locale` must contain `formatRelative` property
 *
 * @example
 * // Represent the date of 6 days ago in words relative to the given base date. In this example, today is Wednesday
 * const result = formatRelative(subDays(new Date(), 6), new Date())
 * //=> "last Thursday at 12:45 AM"
 */ function $291ecb79f44fe7b1$var$formatRelative(date, baseDate, options) {
    const _date = (0, $26OhI.toDate)(date);
    const _baseDate = (0, $26OhI.toDate)(baseDate);
    const defaultOptions = (0, $2Hkrd.getDefaultOptions)();
    const locale = options?.locale ?? defaultOptions.locale ?? $5hxJz.defaultLocale;
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const diff = (0, $hzJYa.differenceInCalendarDays)(_date, _baseDate);
    if (isNaN(diff)) throw new RangeError("Invalid time value");
    let token;
    if (diff < -6) token = "other";
    else if (diff < -1) token = "lastWeek";
    else if (diff < 0) token = "yesterday";
    else if (diff < 1) token = "today";
    else if (diff < 2) token = "tomorrow";
    else if (diff < 7) token = "nextWeek";
    else token = "other";
    const formatStr = locale.formatRelative(token, _date, _baseDate, {
        locale: locale,
        weekStartsOn: weekStartsOn
    });
    return (0, $dmAUx.format)(_date, formatStr, {
        locale: locale,
        weekStartsOn: weekStartsOn
    });
}

});

parcelRegister("iDMeT", function(module, exports) {

$parcel$export(module.exports, "fromUnixTime", () => $d92149d3ef21696e$export$3664df8597731ed4, (v) => $d92149d3ef21696e$export$3664df8597731ed4 = v);
var $d92149d3ef21696e$export$3664df8597731ed4;
"use strict";
$d92149d3ef21696e$export$3664df8597731ed4 = $d92149d3ef21696e$var$fromUnixTime;

var $26OhI = parcelRequire("26OhI");
/**
 * @name fromUnixTime
 * @category Timestamp Helpers
 * @summary Create a date from a Unix timestamp.
 *
 * @description
 * Create a date from a Unix timestamp (in seconds). Decimal values will be discarded.
 *
 * @param unixTime - The given Unix timestamp (in seconds)
 *
 * @returns The date
 *
 * @example
 * // Create the date 29 February 2012 11:45:05:
 * const result = fromUnixTime(1330515905)
 * //=> Wed Feb 29 2012 11:45:05
 */ function $d92149d3ef21696e$var$fromUnixTime(unixTime) {
    return (0, $26OhI.toDate)(unixTime * 1000);
}

});

parcelRegister("a8C6h", function(module, exports) {

$parcel$export(module.exports, "getDaysInYear", () => $761834a592dd4396$export$63a4a9fc49e3550e, (v) => $761834a592dd4396$export$63a4a9fc49e3550e = v);
var $761834a592dd4396$export$63a4a9fc49e3550e;
"use strict";
$761834a592dd4396$export$63a4a9fc49e3550e = $761834a592dd4396$var$getDaysInYear;

var $8HFKm = parcelRequire("8HFKm");

var $26OhI = parcelRequire("26OhI");
/**
 * @name getDaysInYear
 * @category Year Helpers
 * @summary Get the number of days in a year of the given date.
 *
 * @description
 * Get the number of days in a year of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The number of days in a year
 *
 * @example
 * // How many days are in 2012?
 * const result = getDaysInYear(new Date(2012, 0, 1))
 * //=> 366
 */ function $761834a592dd4396$var$getDaysInYear(date) {
    const _date = (0, $26OhI.toDate)(date);
    if (String(new Date(_date)) === "Invalid Date") return NaN;
    return (0, $8HFKm.isLeapYear)(_date) ? 366 : 365;
}

});
parcelRegister("8HFKm", function(module, exports) {

$parcel$export(module.exports, "isLeapYear", () => $6562b8e842362089$export$553d7fa8e3805fc0, (v) => $6562b8e842362089$export$553d7fa8e3805fc0 = v);
var $6562b8e842362089$export$553d7fa8e3805fc0;
"use strict";
$6562b8e842362089$export$553d7fa8e3805fc0 = $6562b8e842362089$var$isLeapYear;

var $26OhI = parcelRequire("26OhI");
/**
 * @name isLeapYear
 * @category Year Helpers
 * @summary Is the given date in the leap year?
 *
 * @description
 * Is the given date in the leap year?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in the leap year
 *
 * @example
 * // Is 1 September 2012 in the leap year?
 * const result = isLeapYear(new Date(2012, 8, 1))
 * //=> true
 */ function $6562b8e842362089$var$isLeapYear(date) {
    const _date = (0, $26OhI.toDate)(date);
    const year = _date.getFullYear();
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}

});


parcelRegister("0Bn9L", function(module, exports) {

$parcel$export(module.exports, "getDecade", () => $001cfd99b1f8d11d$export$5bc0f4decfc52b64, (v) => $001cfd99b1f8d11d$export$5bc0f4decfc52b64 = v);
var $001cfd99b1f8d11d$export$5bc0f4decfc52b64;
"use strict";
$001cfd99b1f8d11d$export$5bc0f4decfc52b64 = $001cfd99b1f8d11d$var$getDecade;

var $26OhI = parcelRequire("26OhI");
/**
 * @name getDecade
 * @category Decade Helpers
 * @summary Get the decade of the given date.
 *
 * @description
 * Get the decade of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The year of decade
 *
 * @example
 * // Which decade belongs 27 November 1942?
 * const result = getDecade(new Date(1942, 10, 27))
 * //=> 1940
 */ function $001cfd99b1f8d11d$var$getDecade(date) {
    // TODO: Switch to more technical definition in of decades that start with 1
    // end with 0. I.e. 2001-2010 instead of current 2000-2009. It's a breaking
    // change, so it can only be done in 4.0.
    const _date = (0, $26OhI.toDate)(date);
    const year = _date.getFullYear();
    const decade = Math.floor(year / 10) * 10;
    return decade;
}

});

parcelRegister("4n2mh", function(module, exports) {

$parcel$export(module.exports, "getISOWeeksInYear", () => $32eb23bd57310d3c$export$822983242a16750f, (v) => $32eb23bd57310d3c$export$822983242a16750f = v);
var $32eb23bd57310d3c$export$822983242a16750f;
"use strict";
$32eb23bd57310d3c$export$822983242a16750f = $32eb23bd57310d3c$var$getISOWeeksInYear;

var $41ovE = parcelRequire("41ovE");

var $4IrbU = parcelRequire("4IrbU");

var $hxisM = parcelRequire("hxisM");
/**
 * @name getISOWeeksInYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the number of weeks in an ISO week-numbering year of the given date.
 *
 * @description
 * Get the number of weeks in an ISO week-numbering year of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The number of ISO weeks in a year
 *
 * @example
 * // How many weeks are in ISO week-numbering year 2015?
 * const result = getISOWeeksInYear(new Date(2015, 1, 11))
 * //=> 53
 */ function $32eb23bd57310d3c$var$getISOWeeksInYear(date) {
    const thisYear = (0, $hxisM.startOfISOWeekYear)(date);
    const nextYear = (0, $hxisM.startOfISOWeekYear)((0, $41ovE.addWeeks)(thisYear, 60));
    const diff = +nextYear - +thisYear;
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / $4IrbU.millisecondsInWeek);
}

});

parcelRegister("cMxE5", function(module, exports) {

$parcel$export(module.exports, "getMilliseconds", () => $94e4110ec7f65d24$export$b8e4380f312797af, (v) => $94e4110ec7f65d24$export$b8e4380f312797af = v);
var $94e4110ec7f65d24$export$b8e4380f312797af;
"use strict";
$94e4110ec7f65d24$export$b8e4380f312797af = $94e4110ec7f65d24$var$getMilliseconds;

var $26OhI = parcelRequire("26OhI");
/**
 * @name getMilliseconds
 * @category Millisecond Helpers
 * @summary Get the milliseconds of the given date.
 *
 * @description
 * Get the milliseconds of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The milliseconds
 *
 * @example
 * // Get the milliseconds of 29 February 2012 11:45:05.123:
 * const result = getMilliseconds(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 123
 */ function $94e4110ec7f65d24$var$getMilliseconds(date) {
    const _date = (0, $26OhI.toDate)(date);
    const milliseconds = _date.getMilliseconds();
    return milliseconds;
}

});

parcelRegister("cagPs", function(module, exports) {

$parcel$export(module.exports, "getOverlappingDaysInIntervals", () => $8db37919f07bba8d$export$baae148532bd1d46, (v) => $8db37919f07bba8d$export$baae148532bd1d46 = v);
var $8db37919f07bba8d$export$baae148532bd1d46;
"use strict";
$8db37919f07bba8d$export$baae148532bd1d46 = $8db37919f07bba8d$var$getOverlappingDaysInIntervals;

var $6f1d3 = parcelRequire("6f1d3");

var $4IrbU = parcelRequire("4IrbU");

var $26OhI = parcelRequire("26OhI");
/**
 * @name getOverlappingDaysInIntervals
 * @category Interval Helpers
 * @summary Get the number of days that overlap in two time intervals
 *
 * @description
 * Get the number of days that overlap in two time intervals. It uses the time
 * between dates to calculate the number of days, rounding it up to include
 * partial days.
 *
 * Two equal 0-length intervals will result in 0. Two equal 1ms intervals will
 * result in 1.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param intervalLeft - The first interval to compare.
 * @param intervalRight - The second interval to compare.
 *
 * @returns The number of days that overlap in two time intervals
 *
 * @example
 * // For overlapping time intervals adds 1 for each started overlapping day:
 * getOverlappingDaysInIntervals(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 17), end: new Date(2014, 0, 21) }
 * )
 * //=> 3
 *
 * @example
 * // For non-overlapping time intervals returns 0:
 * getOverlappingDaysInIntervals(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 21), end: new Date(2014, 0, 22) }
 * )
 * //=> 0
 */ function $8db37919f07bba8d$var$getOverlappingDaysInIntervals(intervalLeft, intervalRight) {
    const [leftStart, leftEnd] = [
        +(0, $26OhI.toDate)(intervalLeft.start),
        +(0, $26OhI.toDate)(intervalLeft.end)
    ].sort((a, b)=>a - b);
    const [rightStart, rightEnd] = [
        +(0, $26OhI.toDate)(intervalRight.start),
        +(0, $26OhI.toDate)(intervalRight.end)
    ].sort((a, b)=>a - b);
    // Prevent NaN result if intervals don't overlap at all.
    const isOverlapping = leftStart < rightEnd && rightStart < leftEnd;
    if (!isOverlapping) return 0;
    // Remove the timezone offset to negate the DST effect on calculations.
    const overlapLeft = rightStart < leftStart ? leftStart : rightStart;
    const left = overlapLeft - (0, $6f1d3.getTimezoneOffsetInMilliseconds)(overlapLeft);
    const overlapRight = rightEnd > leftEnd ? leftEnd : rightEnd;
    const right = overlapRight - (0, $6f1d3.getTimezoneOffsetInMilliseconds)(overlapRight);
    // Ceil the number to include partial days too.
    return Math.ceil((right - left) / $4IrbU.millisecondsInDay);
}

});

parcelRegister("a54jn", function(module, exports) {

$parcel$export(module.exports, "getUnixTime", () => $756db73708638f29$export$1f77c0008d16313, (v) => $756db73708638f29$export$1f77c0008d16313 = v);
var $756db73708638f29$export$1f77c0008d16313;
"use strict";
$756db73708638f29$export$1f77c0008d16313 = $756db73708638f29$var$getUnixTime;

var $26OhI = parcelRequire("26OhI");
/**
 * @name getUnixTime
 * @category Timestamp Helpers
 * @summary Get the seconds timestamp of the given date.
 *
 * @description
 * Get the seconds timestamp of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The timestamp
 *
 * @example
 * // Get the timestamp of 29 February 2012 11:45:05 CET:
 * const result = getUnixTime(new Date(2012, 1, 29, 11, 45, 5))
 * //=> 1330512305
 */ function $756db73708638f29$var$getUnixTime(date) {
    return Math.trunc(+(0, $26OhI.toDate)(date) / 1000);
}

});

parcelRegister("b4dlZ", function(module, exports) {

$parcel$export(module.exports, "getWeekOfMonth", () => $80ea6d307b907d6f$export$59fb9b85a4d8d027, (v) => $80ea6d307b907d6f$export$59fb9b85a4d8d027 = v);
var $80ea6d307b907d6f$export$59fb9b85a4d8d027;
"use strict";
$80ea6d307b907d6f$export$59fb9b85a4d8d027 = $80ea6d307b907d6f$var$getWeekOfMonth;

var $jBSa0 = parcelRequire("jBSa0");

var $4uPa5 = parcelRequire("4uPa5");

var $biOJg = parcelRequire("biOJg");

var $2Hkrd = parcelRequire("2Hkrd");
/**
 * The {@link getWeekOfMonth} function options.
 */ /**
 * @name getWeekOfMonth
 * @category Week Helpers
 * @summary Get the week of the month of the given date.
 *
 * @description
 * Get the week of the month of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options.
 *
 * @returns The week of month
 *
 * @example
 * // Which week of the month is 9 November 2017?
 * const result = getWeekOfMonth(new Date(2017, 10, 9))
 * //=> 2
 */ function $80ea6d307b907d6f$var$getWeekOfMonth(date, options) {
    const defaultOptions = (0, $2Hkrd.getDefaultOptions)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const currentDayOfMonth = (0, $jBSa0.getDate)(date);
    if (isNaN(currentDayOfMonth)) return NaN;
    const startWeekDay = (0, $4uPa5.getDay)((0, $biOJg.startOfMonth)(date));
    let lastDayOfFirstWeek = weekStartsOn - startWeekDay;
    if (lastDayOfFirstWeek <= 0) lastDayOfFirstWeek += 7;
    const remainingDaysAfterFirstWeek = currentDayOfMonth - lastDayOfFirstWeek;
    return Math.ceil(remainingDaysAfterFirstWeek / 7) + 1;
}

});

parcelRegister("6MFqj", function(module, exports) {

$parcel$export(module.exports, "getWeeksInMonth", () => $4f075b9443efaaa7$export$ccc1b2479e7dd654, (v) => $4f075b9443efaaa7$export$ccc1b2479e7dd654 = v);
var $4f075b9443efaaa7$export$ccc1b2479e7dd654;
"use strict";
$4f075b9443efaaa7$export$ccc1b2479e7dd654 = $4f075b9443efaaa7$var$getWeeksInMonth;

var $7gxy6 = parcelRequire("7gxy6");

var $b4jHE = parcelRequire("b4jHE");

var $biOJg = parcelRequire("biOJg");
/**
 * The {@link getWeeksInMonth} function options.
 */ /**
 * @name getWeeksInMonth
 * @category Week Helpers
 * @summary Get the number of calendar weeks a month spans.
 *
 * @description
 * Get the number of calendar weeks the month in the given date spans.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options.
 *
 * @returns The number of calendar weeks
 *
 * @example
 * // How many calendar weeks does February 2015 span?
 * const result = getWeeksInMonth(new Date(2015, 1, 8))
 * //=> 4
 *
 * @example
 * // If the week starts on Monday,
 * // how many calendar weeks does July 2017 span?
 * const result = getWeeksInMonth(new Date(2017, 6, 5), { weekStartsOn: 1 })
 * //=> 6
 */ function $4f075b9443efaaa7$var$getWeeksInMonth(date, options) {
    return (0, $7gxy6.differenceInCalendarWeeks)((0, $b4jHE.lastDayOfMonth)(date), (0, $biOJg.startOfMonth)(date), options) + 1;
}

});
parcelRegister("b4jHE", function(module, exports) {

$parcel$export(module.exports, "lastDayOfMonth", () => $80ef5a0cadee92df$export$36818250d6c87922, (v) => $80ef5a0cadee92df$export$36818250d6c87922 = v);
var $80ef5a0cadee92df$export$36818250d6c87922;
"use strict";
$80ef5a0cadee92df$export$36818250d6c87922 = $80ef5a0cadee92df$var$lastDayOfMonth;

var $26OhI = parcelRequire("26OhI");
/**
 * @name lastDayOfMonth
 * @category Month Helpers
 * @summary Return the last day of a month for the given date.
 *
 * @description
 * Return the last day of a month for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The last day of a month
 *
 * @example
 * // The last day of a month for 2 September 2014 11:55:00:
 * const result = lastDayOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 00:00:00
 */ function $80ef5a0cadee92df$var$lastDayOfMonth(date) {
    const _date = (0, $26OhI.toDate)(date);
    const month = _date.getMonth();
    _date.setFullYear(_date.getFullYear(), month + 1, 0);
    _date.setHours(0, 0, 0, 0);
    return _date;
}

});


parcelRegister("eHbPA", function(module, exports) {

$parcel$export(module.exports, "hoursToMilliseconds", () => $ab2e423875340816$export$5b42ab7a22898b69, (v) => $ab2e423875340816$export$5b42ab7a22898b69 = v);
var $ab2e423875340816$export$5b42ab7a22898b69;
"use strict";
$ab2e423875340816$export$5b42ab7a22898b69 = $ab2e423875340816$var$hoursToMilliseconds;

var $4IrbU = parcelRequire("4IrbU");
/**
 * @name hoursToMilliseconds
 * @category  Conversion Helpers
 * @summary Convert hours to milliseconds.
 *
 * @description
 * Convert a number of hours to a full number of milliseconds.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param hours - number of hours to be converted
 *
 * @returns The number of hours converted to milliseconds
 *
 * @example
 * // Convert 2 hours to milliseconds:
 * const result = hoursToMilliseconds(2)
 * //=> 7200000
 */ function $ab2e423875340816$var$hoursToMilliseconds(hours) {
    return Math.trunc(hours * $4IrbU.millisecondsInHour);
}

});

parcelRegister("7Sfl2", function(module, exports) {

$parcel$export(module.exports, "hoursToMinutes", () => $5bb9797048c56780$export$83bfc73cdf89a4d8, (v) => $5bb9797048c56780$export$83bfc73cdf89a4d8 = v);
var $5bb9797048c56780$export$83bfc73cdf89a4d8;
"use strict";
$5bb9797048c56780$export$83bfc73cdf89a4d8 = $5bb9797048c56780$var$hoursToMinutes;

var $4IrbU = parcelRequire("4IrbU");
/**
 * @name hoursToMinutes
 * @category Conversion Helpers
 * @summary Convert hours to minutes.
 *
 * @description
 * Convert a number of hours to a full number of minutes.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param hours - number of hours to be converted
 *
 * @returns The number of hours converted in minutes
 *
 * @example
 * // Convert 2 hours to minutes:
 * const result = hoursToMinutes(2)
 * //=> 120
 */ function $5bb9797048c56780$var$hoursToMinutes(hours) {
    return Math.trunc(hours * $4IrbU.minutesInHour);
}

});

parcelRegister("htdEK", function(module, exports) {

$parcel$export(module.exports, "hoursToSeconds", () => $cb7fbcf08b6af1d7$export$59b1396ccbd5a4e1, (v) => $cb7fbcf08b6af1d7$export$59b1396ccbd5a4e1 = v);
var $cb7fbcf08b6af1d7$export$59b1396ccbd5a4e1;
"use strict";
$cb7fbcf08b6af1d7$export$59b1396ccbd5a4e1 = $cb7fbcf08b6af1d7$var$hoursToSeconds;

var $4IrbU = parcelRequire("4IrbU");
/**
 * @name hoursToSeconds
 * @category Conversion Helpers
 * @summary Convert hours to seconds.
 *
 * @description
 * Convert a number of hours to a full number of seconds.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param hours - The number of hours to be converted
 *
 * @returns The number of hours converted in seconds
 *
 * @example
 * // Convert 2 hours to seconds:
 * const result = hoursToSeconds(2)
 * //=> 7200
 */ function $cb7fbcf08b6af1d7$var$hoursToSeconds(hours) {
    return Math.trunc(hours * $4IrbU.secondsInHour);
}

});

parcelRegister("6WMVp", function(module, exports) {

$parcel$export(module.exports, "interval", () => $50ee1c50ce7a854b$export$3174cdbf0a0cbc84, (v) => $50ee1c50ce7a854b$export$3174cdbf0a0cbc84 = v);
var $50ee1c50ce7a854b$export$3174cdbf0a0cbc84;
"use strict";
$50ee1c50ce7a854b$export$3174cdbf0a0cbc84 = $50ee1c50ce7a854b$var$interval;

var $26OhI = parcelRequire("26OhI");
/**
 * The {@link interval} function options.
 */ /**
 * @name interval
 * @category Interval Helpers
 * @summary Creates an interval object and validates its values.
 *
 * @description
 * Creates a normalized interval object and validates its values. If the interval is invalid, an exception is thrown.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param start - The start of the interval.
 * @param end - The end of the interval.
 * @param options - The options object.
 *
 * @throws `Start date is invalid` when `start` is invalid.
 * @throws `End date is invalid` when `end` is invalid.
 * @throws `End date must be after start date` when end is before `start` and `options.assertPositive` is true.
 *
 * @returns The normalized and validated interval object.
 */ function $50ee1c50ce7a854b$var$interval(start, end, options) {
    const _start = (0, $26OhI.toDate)(start);
    if (isNaN(+_start)) throw new TypeError("Start date is invalid");
    const _end = (0, $26OhI.toDate)(end);
    if (isNaN(+_end)) throw new TypeError("End date is invalid");
    if (options?.assertPositive && +_start > +_end) throw new TypeError("End date must be after start date");
    return {
        start: _start,
        end: _end
    };
}

});

parcelRegister("iaBR8", function(module, exports) {

$parcel$export(module.exports, "intervalToDuration", () => $d3a6869211fc4d85$export$7b6c9a626316863, (v) => $d3a6869211fc4d85$export$7b6c9a626316863 = v);
var $d3a6869211fc4d85$export$7b6c9a626316863;
"use strict";
$d3a6869211fc4d85$export$7b6c9a626316863 = $d3a6869211fc4d85$var$intervalToDuration;

var $5H9je = parcelRequire("5H9je");

var $lS4EH = parcelRequire("lS4EH");

var $fLrsl = parcelRequire("fLrsl");

var $4LIFj = parcelRequire("4LIFj");

var $aBQYs = parcelRequire("aBQYs");

var $1i6Jz = parcelRequire("1i6Jz");

var $f1Tmv = parcelRequire("f1Tmv");

var $26OhI = parcelRequire("26OhI");
/**
 * @name intervalToDuration
 * @category Common Helpers
 * @summary Convert interval to duration
 *
 * @description
 * Convert a interval object to a duration object.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval to convert to duration
 *
 * @returns The duration object
 *
 * @example
 * // Get the duration between January 15, 1929 and April 4, 1968.
 * intervalToDuration({
 *   start: new Date(1929, 0, 15, 12, 0, 0),
 *   end: new Date(1968, 3, 4, 19, 5, 0)
 * })
 * // => { years: 39, months: 2, days: 20, hours: 7, minutes: 5, seconds: 0 }
 */ function $d3a6869211fc4d85$var$intervalToDuration(interval) {
    const start = (0, $26OhI.toDate)(interval.start);
    const end = (0, $26OhI.toDate)(interval.end);
    const duration = {};
    const years = (0, $f1Tmv.differenceInYears)(end, start);
    if (years) duration.years = years;
    const remainingMonths = (0, $5H9je.add)(start, {
        years: duration.years
    });
    const months = (0, $aBQYs.differenceInMonths)(end, remainingMonths);
    if (months) duration.months = months;
    const remainingDays = (0, $5H9je.add)(remainingMonths, {
        months: duration.months
    });
    const days = (0, $lS4EH.differenceInDays)(end, remainingDays);
    if (days) duration.days = days;
    const remainingHours = (0, $5H9je.add)(remainingDays, {
        days: duration.days
    });
    const hours = (0, $fLrsl.differenceInHours)(end, remainingHours);
    if (hours) duration.hours = hours;
    const remainingMinutes = (0, $5H9je.add)(remainingHours, {
        hours: duration.hours
    });
    const minutes = (0, $4LIFj.differenceInMinutes)(end, remainingMinutes);
    if (minutes) duration.minutes = minutes;
    const remainingSeconds = (0, $5H9je.add)(remainingMinutes, {
        minutes: duration.minutes
    });
    const seconds = (0, $1i6Jz.differenceInSeconds)(end, remainingSeconds);
    if (seconds) duration.seconds = seconds;
    return duration;
}

});

parcelRegister("kMqKN", function(module, exports) {

$parcel$export(module.exports, "intlFormat", () => $f20d0b13510a1faa$export$f58f1234eed71f82, (v) => $f20d0b13510a1faa$export$f58f1234eed71f82 = v);
var $f20d0b13510a1faa$export$f58f1234eed71f82;
"use strict";
$f20d0b13510a1faa$export$f58f1234eed71f82 = $f20d0b13510a1faa$var$intlFormat;

var $26OhI = parcelRequire("26OhI");
/**
 * The locale string (see: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl#locales_argument).
 */ /**
 * The format options (see: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat#options)
 */ /**
 * The locale options.
 */ /**
 * @name intlFormat
 * @category Common Helpers
 * @summary Format the date with Intl.DateTimeFormat (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat).
 *
 * @description
 * Return the formatted date string in the given format.
 * The method uses [`Intl.DateTimeFormat`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat) inside.
 * formatOptions are the same as [`Intl.DateTimeFormat` options](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat#using_options)
 *
 * > ⚠️ Please note that before Node version 13.0.0, only the locale data for en-US is available by default.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to format
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 10 October 2019 in middle-endian format:
 * const result = intlFormat(new Date(2019, 9, 4, 12, 30, 13, 456))
 * //=> 10/4/2019
 */ /**
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to format
 * @param localeOptions - An object with locale
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 10 October 2019 in Korean.
 * // Convert the date with locale's options.
 * const result = intlFormat(new Date(2019, 9, 4, 12, 30, 13, 456), {
 *   locale: 'ko-KR',
 * })
 * //=> 2019. 10. 4.
 */ /**
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to format
 * @param formatOptions - The format options
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 10 October 2019.
 * // Convert the date with format's options.
 * const result = intlFormat.default(new Date(2019, 9, 4, 12, 30, 13, 456), {
 *   year: 'numeric',
 *   month: 'numeric',
 *   day: 'numeric',
 *   hour: 'numeric',
 * })
 * //=> 10/4/2019, 12 PM
 */ /**
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to format
 * @param formatOptions - The format options
 * @param localeOptions - An object with locale
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 10 October 2019 in German.
 * // Convert the date with format's options and locale's options.
 * const result = intlFormat(new Date(2019, 9, 4, 12, 30, 13, 456), {
 *   weekday: 'long',
 *   year: 'numeric',
 *   month: 'long',
 *   day: 'numeric',
 * }, {
 *   locale: 'de-DE',
 * })
 * //=> Freitag, 4. Oktober 2019
 */ function $f20d0b13510a1faa$var$intlFormat(date, formatOrLocale, localeOptions) {
    let formatOptions;
    if ($f20d0b13510a1faa$var$isFormatOptions(formatOrLocale)) formatOptions = formatOrLocale;
    else localeOptions = formatOrLocale;
    return new Intl.DateTimeFormat(localeOptions?.locale, formatOptions).format((0, $26OhI.toDate)(date));
}
function $f20d0b13510a1faa$var$isFormatOptions(opts) {
    return opts !== undefined && !("locale" in opts);
}

});

parcelRegister("bCsNV", function(module, exports) {

$parcel$export(module.exports, "intlFormatDistance", () => $875996431cdee9f2$export$a110a4020280fd5, (v) => $875996431cdee9f2$export$a110a4020280fd5 = v);
var $875996431cdee9f2$export$a110a4020280fd5;
"use strict";
$875996431cdee9f2$export$a110a4020280fd5 = $875996431cdee9f2$var$intlFormatDistance;

var $4IrbU = parcelRequire("4IrbU");

var $hzJYa = parcelRequire("hzJYa");

var $lVxGX = parcelRequire("lVxGX");

var $2RSNs = parcelRequire("2RSNs");

var $7gxy6 = parcelRequire("7gxy6");

var $4j185 = parcelRequire("4j185");

var $fLrsl = parcelRequire("fLrsl");

var $4LIFj = parcelRequire("4LIFj");

var $1i6Jz = parcelRequire("1i6Jz");

var $26OhI = parcelRequire("26OhI");
/**
 * The {@link intlFormatDistance} function options.
 */ /**
 * The unit used to format the distance in {@link intlFormatDistance}.
 */ /**
 * @name intlFormatDistance
 * @category Common Helpers
 * @summary Formats distance between two dates in a human-readable format
 * @description
 * The function calculates the difference between two dates and formats it as a human-readable string.
 *
 * The function will pick the most appropriate unit depending on the distance between dates. For example, if the distance is a few hours, it might return `x hours`. If the distance is a few months, it might return `x months`.
 *
 * You can also specify a unit to force using it regardless of the distance to get a result like `123456 hours`.
 *
 * See the table below for the unit picking logic:
 *
 * | Distance between dates | Result (past)  | Result (future) |
 * | ---------------------- | -------------- | --------------- |
 * | 0 seconds              | now            | now             |
 * | 1-59 seconds           | X seconds ago  | in X seconds    |
 * | 1-59 minutes           | X minutes ago  | in X minutes    |
 * | 1-23 hours             | X hours ago    | in X hours      |
 * | 1 day                  | yesterday      | tomorrow        |
 * | 2-6 days               | X days ago     | in X days       |
 * | 7 days                 | last week      | next week       |
 * | 8 days-1 month         | X weeks ago    | in X weeks      |
 * | 1 month                | last month     | next month      |
 * | 2-3 months             | X months ago   | in X months     |
 * | 1 quarter              | last quarter   | next quarter    |
 * | 2-3 quarters           | X quarters ago | in X quarters   |
 * | 1 year                 | last year      | next year       |
 * | 2+ years               | X years ago    | in X years      |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date
 * @param baseDate - The date to compare with.
 * @param options - An object with options.
 * See MDN for details [Locale identification and negotiation](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl#locale_identification_and_negotiation)
 * The narrow one could be similar to the short one for some locales.
 *
 * @returns The distance in words according to language-sensitive relative time formatting.
 *
 * @throws `date` must not be Invalid Date
 * @throws `baseDate` must not be Invalid Date
 * @throws `options.unit` must not be invalid Unit
 * @throws `options.locale` must not be invalid locale
 * @throws `options.localeMatcher` must not be invalid localeMatcher
 * @throws `options.numeric` must not be invalid numeric
 * @throws `options.style` must not be invalid style
 *
 * @example
 * // What is the distance between the dates when the fist date is after the second?
 * intlFormatDistance(
 *   new Date(1986, 3, 4, 11, 30, 0),
 *   new Date(1986, 3, 4, 10, 30, 0)
 * )
 * //=> 'in 1 hour'
 *
 * // What is the distance between the dates when the fist date is before the second?
 * intlFormatDistance(
 *   new Date(1986, 3, 4, 10, 30, 0),
 *   new Date(1986, 3, 4, 11, 30, 0)
 * )
 * //=> '1 hour ago'
 *
 * @example
 * // Use the unit option to force the function to output the result in quarters. Without setting it, the example would return "next year"
 * intlFormatDistance(
 *   new Date(1987, 6, 4, 10, 30, 0),
 *   new Date(1986, 3, 4, 10, 30, 0),
 *   { unit: 'quarter' }
 * )
 * //=> 'in 5 quarters'
 *
 * @example
 * // Use the locale option to get the result in Spanish. Without setting it, the example would return "in 1 hour".
 * intlFormatDistance(
 *   new Date(1986, 3, 4, 11, 30, 0),
 *   new Date(1986, 3, 4, 10, 30, 0),
 *   { locale: 'es' }
 * )
 * //=> 'dentro de 1 hora'
 *
 * @example
 * // Use the numeric option to force the function to use numeric values. Without setting it, the example would return "tomorrow".
 * intlFormatDistance(
 *   new Date(1986, 3, 5, 11, 30, 0),
 *   new Date(1986, 3, 4, 11, 30, 0),
 *   { numeric: 'always' }
 * )
 * //=> 'in 1 day'
 *
 * @example
 * // Use the style option to force the function to use short values. Without setting it, the example would return "in 2 years".
 * intlFormatDistance(
 *   new Date(1988, 3, 4, 11, 30, 0),
 *   new Date(1986, 3, 4, 11, 30, 0),
 *   { style: 'short' }
 * )
 * //=> 'in 2 yr'
 */ function $875996431cdee9f2$var$intlFormatDistance(date, baseDate, options) {
    let value = 0;
    let unit;
    const dateLeft = (0, $26OhI.toDate)(date);
    const dateRight = (0, $26OhI.toDate)(baseDate);
    if (!options?.unit) {
        // Get the unit based on diffInSeconds calculations if no unit is specified
        const diffInSeconds = (0, $1i6Jz.differenceInSeconds)(dateLeft, dateRight); // The smallest unit
        if (Math.abs(diffInSeconds) < $4IrbU.secondsInMinute) {
            value = (0, $1i6Jz.differenceInSeconds)(dateLeft, dateRight);
            unit = "second";
        } else if (Math.abs(diffInSeconds) < $4IrbU.secondsInHour) {
            value = (0, $4LIFj.differenceInMinutes)(dateLeft, dateRight);
            unit = "minute";
        } else if (Math.abs(diffInSeconds) < $4IrbU.secondsInDay && Math.abs((0, $hzJYa.differenceInCalendarDays)(dateLeft, dateRight)) < 1) {
            value = (0, $fLrsl.differenceInHours)(dateLeft, dateRight);
            unit = "hour";
        } else if (Math.abs(diffInSeconds) < $4IrbU.secondsInWeek && (value = (0, $hzJYa.differenceInCalendarDays)(dateLeft, dateRight)) && Math.abs(value) < 7) unit = "day";
        else if (Math.abs(diffInSeconds) < $4IrbU.secondsInMonth) {
            value = (0, $7gxy6.differenceInCalendarWeeks)(dateLeft, dateRight);
            unit = "week";
        } else if (Math.abs(diffInSeconds) < $4IrbU.secondsInQuarter) {
            value = (0, $lVxGX.differenceInCalendarMonths)(dateLeft, dateRight);
            unit = "month";
        } else if (Math.abs(diffInSeconds) < $4IrbU.secondsInYear) {
            if ((0, $2RSNs.differenceInCalendarQuarters)(dateLeft, dateRight) < 4) {
                // To filter out cases that are less than a year but match 4 quarters
                value = (0, $2RSNs.differenceInCalendarQuarters)(dateLeft, dateRight);
                unit = "quarter";
            } else {
                value = (0, $4j185.differenceInCalendarYears)(dateLeft, dateRight);
                unit = "year";
            }
        } else {
            value = (0, $4j185.differenceInCalendarYears)(dateLeft, dateRight);
            unit = "year";
        }
    } else {
        // Get the value if unit is specified
        unit = options?.unit;
        if (unit === "second") value = (0, $1i6Jz.differenceInSeconds)(dateLeft, dateRight);
        else if (unit === "minute") value = (0, $4LIFj.differenceInMinutes)(dateLeft, dateRight);
        else if (unit === "hour") value = (0, $fLrsl.differenceInHours)(dateLeft, dateRight);
        else if (unit === "day") value = (0, $hzJYa.differenceInCalendarDays)(dateLeft, dateRight);
        else if (unit === "week") value = (0, $7gxy6.differenceInCalendarWeeks)(dateLeft, dateRight);
        else if (unit === "month") value = (0, $lVxGX.differenceInCalendarMonths)(dateLeft, dateRight);
        else if (unit === "quarter") value = (0, $2RSNs.differenceInCalendarQuarters)(dateLeft, dateRight);
        else if (unit === "year") value = (0, $4j185.differenceInCalendarYears)(dateLeft, dateRight);
    }
    const rtf = new Intl.RelativeTimeFormat(options?.locale, {
        localeMatcher: options?.localeMatcher,
        numeric: options?.numeric || "auto",
        style: options?.style
    });
    return rtf.format(value, unit);
}

});

parcelRegister("ewPRS", function(module, exports) {

$parcel$export(module.exports, "isExists", () => $a93c49bd59ce64b7$export$127519e0edcdc58b, (v) => $a93c49bd59ce64b7$export$127519e0edcdc58b = v);
var $a93c49bd59ce64b7$export$127519e0edcdc58b;
"use strict";
$a93c49bd59ce64b7$export$127519e0edcdc58b = $a93c49bd59ce64b7$var$isExists; /**
 * @name isExists
 * @category Common Helpers
 * @summary Is the given date exists?
 *
 * @description
 * Checks if the given arguments convert to an existing date.
 *
 * @param year - The year of the date to check
 * @param month - The month of the date to check
 * @param day - The day of the date to check
 *
 * @returns `true` if the date exists
 *
 * @example
 * // For the valid date:
 * const result = isExists(2018, 0, 31)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isExists(2018, 1, 31)
 * //=> false
 */ 
function $a93c49bd59ce64b7$var$isExists(year, month, day) {
    const date = new Date(year, month, day);
    return date.getFullYear() === year && date.getMonth() === month && date.getDate() === day;
}

});

parcelRegister("l4WOR", function(module, exports) {

$parcel$export(module.exports, "isFirstDayOfMonth", () => $f58798fe117dbf67$export$2716a425049f51dd, (v) => $f58798fe117dbf67$export$2716a425049f51dd = v);
var $f58798fe117dbf67$export$2716a425049f51dd;
"use strict";
$f58798fe117dbf67$export$2716a425049f51dd = $f58798fe117dbf67$var$isFirstDayOfMonth;

var $26OhI = parcelRequire("26OhI");
/**
 * @name isFirstDayOfMonth
 * @category Month Helpers
 * @summary Is the given date the first day of a month?
 *
 * @description
 * Is the given date the first day of a month?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check

 * @returns The date is the first day of a month
 *
 * @example
 * // Is 1 September 2014 the first day of a month?
 * const result = isFirstDayOfMonth(new Date(2014, 8, 1))
 * //=> true
 */ function $f58798fe117dbf67$var$isFirstDayOfMonth(date) {
    return (0, $26OhI.toDate)(date).getDate() === 1;
}

});

parcelRegister("dwsbe", function(module, exports) {

$parcel$export(module.exports, "isFriday", () => $9d841f8517e6ec2d$export$3b7d89f127884993, (v) => $9d841f8517e6ec2d$export$3b7d89f127884993 = v);
var $9d841f8517e6ec2d$export$3b7d89f127884993;
"use strict";
$9d841f8517e6ec2d$export$3b7d89f127884993 = $9d841f8517e6ec2d$var$isFriday;

var $26OhI = parcelRequire("26OhI");
/**
 * @name isFriday
 * @category Weekday Helpers
 * @summary Is the given date Friday?
 *
 * @description
 * Is the given date Friday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Friday
 *
 * @example
 * // Is 26 September 2014 Friday?
 * const result = isFriday(new Date(2014, 8, 26))
 * //=> true
 */ function $9d841f8517e6ec2d$var$isFriday(date) {
    return (0, $26OhI.toDate)(date).getDay() === 5;
}

});

parcelRegister("gWCQM", function(module, exports) {

$parcel$export(module.exports, "isFuture", () => $c56032fdb12d2a28$export$2baac2df6018cd7, (v) => $c56032fdb12d2a28$export$2baac2df6018cd7 = v);
var $c56032fdb12d2a28$export$2baac2df6018cd7;
"use strict";
$c56032fdb12d2a28$export$2baac2df6018cd7 = $c56032fdb12d2a28$var$isFuture;

var $26OhI = parcelRequire("26OhI");
/**
 * @name isFuture
 * @category Common Helpers
 * @summary Is the given date in the future?
 * @pure false
 *
 * @description
 * Is the given date in the future?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in the future
 *
 * @example
 * // If today is 6 October 2014, is 31 December 2014 in the future?
 * const result = isFuture(new Date(2014, 11, 31))
 * //=> true
 */ function $c56032fdb12d2a28$var$isFuture(date) {
    return +(0, $26OhI.toDate)(date) > Date.now();
}

});

parcelRegister("2iDDY", function(module, exports) {

$parcel$export(module.exports, "isMatch", () => $1acc039e16cde7c4$export$b74c33566721f70f, (v) => $1acc039e16cde7c4$export$b74c33566721f70f = v);
var $1acc039e16cde7c4$export$b74c33566721f70f;
"use strict";
$1acc039e16cde7c4$export$b74c33566721f70f = $1acc039e16cde7c4$var$isMatch;

var $gwJip = parcelRequire("gwJip");

var $foHqe = parcelRequire("foHqe");
/**
 * The {@link isMatch} function options.
 */ /**
 * @name isMatch
 * @category Common Helpers
 * @summary validates the date string against given formats
 *
 * @description
 * Return the true if given date is string correct against the given format else
 * will return false.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters in the format string wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 *
 * Format of the format string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 5 below the table).
 *
 * Not all tokens are compatible. Combinations that don't make sense or could lead to bugs are prohibited
 * and will throw `RangeError`. For example usage of 24-hour format token with AM/PM token will throw an exception:
 *
 * ```javascript
 * isMatch('23 AM', 'HH a')
 * //=> RangeError: The format string mustn't contain `HH` and `a` at the same time
 * ```
 *
 * See the compatibility table: https://docs.google.com/spreadsheets/d/e/2PACX-1vQOPU3xUhplll6dyoMmVUXHKl_8CRDs6_ueLmex3SoqwhuolkuN3O05l4rqx5h1dKX8eb46Ul-CCSrq/pubhtml?gid=0&single=true
 *
 * Accepted format string patterns:
 * | Unit                            |Prior| Pattern | Result examples                   | Notes |
 * |---------------------------------|-----|---------|-----------------------------------|-------|
 * | Era                             | 140 | G..GGG  | AD, BC                            |       |
 * |                                 |     | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 |     | GGGGG   | A, B                              |       |
 * | Calendar year                   | 130 | y       | 44, 1, 1900, 2017, 9999           | 4     |
 * |                                 |     | yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | yy      | 44, 01, 00, 17                    | 4     |
 * |                                 |     | yyy     | 044, 001, 123, 999                | 4     |
 * |                                 |     | yyyy    | 0044, 0001, 1900, 2017            | 4     |
 * |                                 |     | yyyyy   | ...                               | 2,4   |
 * | Local week-numbering year       | 130 | Y       | 44, 1, 1900, 2017, 9000           | 4     |
 * |                                 |     | Yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | YY      | 44, 01, 00, 17                    | 4,6   |
 * |                                 |     | YYY     | 044, 001, 123, 999                | 4     |
 * |                                 |     | YYYY    | 0044, 0001, 1900, 2017            | 4,6   |
 * |                                 |     | YYYYY   | ...                               | 2,4   |
 * | ISO week-numbering year         | 130 | R       | -43, 1, 1900, 2017, 9999, -9999   | 4,5   |
 * |                                 |     | RR      | -43, 01, 00, 17                   | 4,5   |
 * |                                 |     | RRR     | -043, 001, 123, 999, -999         | 4,5   |
 * |                                 |     | RRRR    | -0043, 0001, 2017, 9999, -9999    | 4,5   |
 * |                                 |     | RRRRR   | ...                               | 2,4,5 |
 * | Extended year                   | 130 | u       | -43, 1, 1900, 2017, 9999, -999    | 4     |
 * |                                 |     | uu      | -43, 01, 99, -99                  | 4     |
 * |                                 |     | uuu     | -043, 001, 123, 999, -999         | 4     |
 * |                                 |     | uuuu    | -0043, 0001, 2017, 9999, -9999    | 4     |
 * |                                 |     | uuuuu   | ...                               | 2,4   |
 * | Quarter (formatting)            | 120 | Q       | 1, 2, 3, 4                        |       |
 * |                                 |     | Qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | QQ      | 01, 02, 03, 04                    |       |
 * |                                 |     | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | 120 | q       | 1, 2, 3, 4                        |       |
 * |                                 |     | qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | qq      | 01, 02, 03, 04                    |       |
 * |                                 |     | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | qqqqq   | 1, 2, 3, 4                        | 3     |
 * | Month (formatting)              | 110 | M       | 1, 2, ..., 12                     |       |
 * |                                 |     | Mo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | MM      | 01, 02, ..., 12                   |       |
 * |                                 |     | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | MMMM    | January, February, ..., December  | 2     |
 * |                                 |     | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | 110 | L       | 1, 2, ..., 12                     |       |
 * |                                 |     | Lo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | LL      | 01, 02, ..., 12                   |       |
 * |                                 |     | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | LLLL    | January, February, ..., December  | 2     |
 * |                                 |     | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | 100 | w       | 1, 2, ..., 53                     |       |
 * |                                 |     | wo      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | 100 | I       | 1, 2, ..., 53                     | 5     |
 * |                                 |     | Io      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | II      | 01, 02, ..., 53                   | 5     |
 * | Day of month                    |  90 | d       | 1, 2, ..., 31                     |       |
 * |                                 |     | do      | 1st, 2nd, ..., 31st               | 5     |
 * |                                 |     | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     |  90 | D       | 1, 2, ..., 365, 366               | 7     |
 * |                                 |     | Do      | 1st, 2nd, ..., 365th, 366th       | 5     |
 * |                                 |     | DD      | 01, 02, ..., 365, 366             | 7     |
 * |                                 |     | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 |     | DDDD    | ...                               | 2     |
 * | Day of week (formatting)        |  90 | E..EEE  | Mon, Tue, Wed, ..., Su            |       |
 * |                                 |     | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 |     | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    |  90 | i       | 1, 2, 3, ..., 7                   | 5     |
 * |                                 |     | io      | 1st, 2nd, ..., 7th                | 5     |
 * |                                 |     | ii      | 01, 02, ..., 07                   | 5     |
 * |                                 |     | iii     | Mon, Tue, Wed, ..., Su            | 5     |
 * |                                 |     | iiii    | Monday, Tuesday, ..., Sunday      | 2,5   |
 * |                                 |     | iiiii   | M, T, W, T, F, S, S               | 5     |
 * |                                 |     | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 5     |
 * | Local day of week (formatting)  |  90 | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | eo      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | ee      | 02, 03, ..., 01                   |       |
 * |                                 |     | eee     | Mon, Tue, Wed, ..., Su            |       |
 * |                                 |     | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 |     | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) |  90 | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | co      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | cc      | 02, 03, ..., 01                   |       |
 * |                                 |     | ccc     | Mon, Tue, Wed, ..., Su            |       |
 * |                                 |     | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 |     | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          |  80 | a..aaa  | AM, PM                            |       |
 * |                                 |     | aaaa    | a.m., p.m.                        | 2     |
 * |                                 |     | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          |  80 | b..bbb  | AM, PM, noon, midnight            |       |
 * |                                 |     | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 |     | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             |  80 | B..BBB  | at night, in the morning, ...     |       |
 * |                                 |     | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 |     | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     |  70 | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 |     | ho      | 1st, 2nd, ..., 11th, 12th         | 5     |
 * |                                 |     | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     |  70 | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 |     | Ho      | 0th, 1st, 2nd, ..., 23rd          | 5     |
 * |                                 |     | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     |  70 | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 |     | Ko      | 1st, 2nd, ..., 11th, 0th          | 5     |
 * |                                 |     | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     |  70 | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 |     | ko      | 24th, 1st, 2nd, ..., 23rd         | 5     |
 * |                                 |     | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          |  60 | m       | 0, 1, ..., 59                     |       |
 * |                                 |     | mo      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | mm      | 00, 01, ..., 59                   |       |
 * | Second                          |  50 | s       | 0, 1, ..., 59                     |       |
 * |                                 |     | so      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | ss      | 00, 01, ..., 59                   |       |
 * | Seconds timestamp               |  40 | t       | 512969520                         |       |
 * |                                 |     | tt      | ...                               | 2     |
 * | Fraction of second              |  30 | S       | 0, 1, ..., 9                      |       |
 * |                                 |     | SS      | 00, 01, ..., 99                   |       |
 * |                                 |     | SSS     | 000, 001, ..., 999                |       |
 * |                                 |     | SSSS    | ...                               | 2     |
 * | Milliseconds timestamp          |  20 | T       | 512969520900                      |       |
 * |                                 |     | TT      | ...                               | 2     |
 * | Timezone (ISO-8601 w/ Z)        |  10 | X       | -08, +0530, Z                     |       |
 * |                                 |     | XX      | -0800, +0530, Z                   |       |
 * |                                 |     | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 |     | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 |     | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       |  10 | x       | -08, +0530, +00                   |       |
 * |                                 |     | xx      | -0800, +0530, +0000               |       |
 * |                                 |     | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 |     | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 |     | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Long localized date             |  NA | P       | 05/29/1453                        | 5,8   |
 * |                                 |     | PP      | May 29, 1453                      |       |
 * |                                 |     | PPP     | May 29th, 1453                    |       |
 * |                                 |     | PPPP    | Sunday, May 29th, 1453            | 2,5,8 |
 * | Long localized time             |  NA | p       | 12:00 AM                          | 5,8   |
 * |                                 |     | pp      | 12:00:00 AM                       |       |
 * | Combination of date and time    |  NA | Pp      | 05/29/1453, 12:00 AM              |       |
 * |                                 |     | PPpp    | May 29, 1453, 12:00:00 AM         |       |
 * |                                 |     | PPPpp   | May 29th, 1453 at ...             |       |
 * |                                 |     | PPPPpp  | Sunday, May 29th, 1453 at ...     | 2,5,8 |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular.
 *    In `format` function, they will produce different result:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 *    `isMatch` will try to match both formatting and stand-alone units interchangably.
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table:
 *    - for numerical units (`yyyyyyyy`) `isMatch` will try to match a number
 *      as wide as the sequence
 *    - for text units (`MMMMMMMM`) `isMatch` will try to match the widest variation of the unit.
 *      These variations are marked with "2" in the last column of the table.
 *
 * 3. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 4. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` will try to guess the century of two digit year by proximity with `referenceDate`:
 *
 *    `isMatch('50', 'yy') //=> true`
 *
 *    `isMatch('75', 'yy') //=> true`
 *
 *    while `uu` will use the year as is:
 *
 *    `isMatch('50', 'uu') //=> true`
 *
 *    `isMatch('75', 'uu') //=> true`
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [setISOWeekYear](https://date-fns.org/docs/setISOWeekYear)
 *    and [setWeekYear](https://date-fns.org/docs/setWeekYear)).
 *
 * 5. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 6. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 7. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 8. `P+` tokens do not have a defined priority since they are merely aliases to other tokens based
 *    on the given locale.
 *
 *    using `en-US` locale: `P` => `MM/dd/yyyy`
 *    using `en-US` locale: `p` => `hh:mm a`
 *    using `pt-BR` locale: `P` => `dd/MM/yyyy`
 *    using `pt-BR` locale: `p` => `HH:mm`
 *
 * Values will be checked in the descending order of its unit's priority.
 * Units of an equal priority overwrite each other in the order of appearance.
 *
 * If no values of higher priority are matched (e.g. when matching string 'January 1st' without a year),
 * the values will be taken from today's using `new Date()` date which works as a context of parsing.
 *
 * The result may vary by locale.
 *
 * If `formatString` matches with `dateString` but does not provides tokens, `referenceDate` will be returned.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateStr - The date string to verify
 * @param format - The string of tokens
 * @param options - An object with options.
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @returns Is format string a match for date string?
 *
 * @throws `options.locale` must contain `match` property
 * @throws use `yyyy` instead of `YYYY` for formatting years; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `yy` instead of `YY` for formatting years; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `d` instead of `D` for formatting days of the month; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `dd` instead of `DD` for formatting days of the month; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws format string contains an unescaped latin alphabet character
 *
 * @example
 * // Match 11 February 2014 from middle-endian format:
 * const result = isMatch('02/11/2014', 'MM/dd/yyyy')
 * //=> true
 *
 * @example
 * // Match 28th of February in Esperanto locale in the context of 2010 year:
 * import eo from 'date-fns/locale/eo'
 * const result = isMatch('28-a de februaro', "do 'de' MMMM", {
 *   locale: eo
 * })
 * //=> true
 */ function $1acc039e16cde7c4$var$isMatch(dateStr, formatStr, options) {
    return (0, $gwJip.isValid)((0, $foHqe.parse)(dateStr, formatStr, new Date(), options));
}

});

parcelRegister("8rFE2", function(module, exports) {

$parcel$export(module.exports, "isMonday", () => $62612623c678a28e$export$9573fe9b7c9ac3f5, (v) => $62612623c678a28e$export$9573fe9b7c9ac3f5 = v);
var $62612623c678a28e$export$9573fe9b7c9ac3f5;
"use strict";
$62612623c678a28e$export$9573fe9b7c9ac3f5 = $62612623c678a28e$var$isMonday;

var $26OhI = parcelRequire("26OhI");
/**
 * @name isMonday
 * @category Weekday Helpers
 * @summary Is the given date Monday?
 *
 * @description
 * Is the given date Monday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Monday
 *
 * @example
 * // Is 22 September 2014 Monday?
 * const result = isMonday(new Date(2014, 8, 22))
 * //=> true
 */ function $62612623c678a28e$var$isMonday(date) {
    return (0, $26OhI.toDate)(date).getDay() === 1;
}

});

parcelRegister("aibDo", function(module, exports) {

$parcel$export(module.exports, "isPast", () => $77e49c303fdb03f7$export$fc5014aa3db48558, (v) => $77e49c303fdb03f7$export$fc5014aa3db48558 = v);
var $77e49c303fdb03f7$export$fc5014aa3db48558;
"use strict";
$77e49c303fdb03f7$export$fc5014aa3db48558 = $77e49c303fdb03f7$var$isPast;

var $26OhI = parcelRequire("26OhI");
/**
 * @name isPast
 * @category Common Helpers
 * @summary Is the given date in the past?
 * @pure false
 *
 * @description
 * Is the given date in the past?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in the past
 *
 * @example
 * // If today is 6 October 2014, is 2 July 2014 in the past?
 * const result = isPast(new Date(2014, 6, 2))
 * //=> true
 */ function $77e49c303fdb03f7$var$isPast(date) {
    return +(0, $26OhI.toDate)(date) < Date.now();
}

});

parcelRegister("cuP5N", function(module, exports) {

$parcel$export(module.exports, "isSameHour", () => $918feb46f7d8a1a4$export$f9f3a94a0371013, (v) => $918feb46f7d8a1a4$export$f9f3a94a0371013 = v);
var $918feb46f7d8a1a4$export$f9f3a94a0371013;
"use strict";
$918feb46f7d8a1a4$export$f9f3a94a0371013 = $918feb46f7d8a1a4$var$isSameHour;

var $8ZHBC = parcelRequire("8ZHBC");
/**
 * @name isSameHour
 * @category Hour Helpers
 * @summary Are the given dates in the same hour (and same day)?
 *
 * @description
 * Are the given dates in the same hour (and same day)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same hour (and same day)
 *
 * @example
 * // Are 4 September 2014 06:00:00 and 4 September 06:30:00 in the same hour?
 * const result = isSameHour(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 6, 30))
 * //=> true
 *
 * @example
 * // Are 4 September 2014 06:00:00 and 5 September 06:00:00 in the same hour?
 * const result = isSameHour(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 5, 6, 0))
 * //=> false
 */ function $918feb46f7d8a1a4$var$isSameHour(dateLeft, dateRight) {
    const dateLeftStartOfHour = (0, $8ZHBC.startOfHour)(dateLeft);
    const dateRightStartOfHour = (0, $8ZHBC.startOfHour)(dateRight);
    return +dateLeftStartOfHour === +dateRightStartOfHour;
}

});
parcelRegister("8ZHBC", function(module, exports) {

$parcel$export(module.exports, "startOfHour", () => $68c5d87103e5f029$export$24f91f68e7c9d9d5, (v) => $68c5d87103e5f029$export$24f91f68e7c9d9d5 = v);
var $68c5d87103e5f029$export$24f91f68e7c9d9d5;
"use strict";
$68c5d87103e5f029$export$24f91f68e7c9d9d5 = $68c5d87103e5f029$var$startOfHour;

var $26OhI = parcelRequire("26OhI");
/**
 * @name startOfHour
 * @category Hour Helpers
 * @summary Return the start of an hour for the given date.
 *
 * @description
 * Return the start of an hour for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of an hour
 *
 * @example
 * // The start of an hour for 2 September 2014 11:55:00:
 * const result = startOfHour(new Date(2014, 8, 2, 11, 55))
 * //=> Tue Sep 02 2014 11:00:00
 */ function $68c5d87103e5f029$var$startOfHour(date) {
    const _date = (0, $26OhI.toDate)(date);
    _date.setMinutes(0, 0, 0);
    return _date;
}

});


parcelRegister("dHmZ5", function(module, exports) {

$parcel$export(module.exports, "isSameISOWeek", () => $9f911eaffb3d9877$export$1c6e74e3c7b27764, (v) => $9f911eaffb3d9877$export$1c6e74e3c7b27764 = v);
var $9f911eaffb3d9877$export$1c6e74e3c7b27764;
"use strict";
$9f911eaffb3d9877$export$1c6e74e3c7b27764 = $9f911eaffb3d9877$var$isSameISOWeek;

var $iJiE0 = parcelRequire("iJiE0");
/**
 * @name isSameISOWeek
 * @category ISO Week Helpers
 * @summary Are the given dates in the same ISO week (and year)?
 *
 * @description
 * Are the given dates in the same ISO week (and year)?
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same ISO week (and year)
 *
 * @example
 * // Are 1 September 2014 and 7 September 2014 in the same ISO week?
 * const result = isSameISOWeek(new Date(2014, 8, 1), new Date(2014, 8, 7))
 * //=> true
 *
 * @example
 * // Are 1 September 2014 and 1 September 2015 in the same ISO week?
 * const result = isSameISOWeek(new Date(2014, 8, 1), new Date(2015, 8, 1))
 * //=> false
 */ function $9f911eaffb3d9877$var$isSameISOWeek(dateLeft, dateRight) {
    return (0, $iJiE0.isSameWeek)(dateLeft, dateRight, {
        weekStartsOn: 1
    });
}

});
parcelRegister("iJiE0", function(module, exports) {

$parcel$export(module.exports, "isSameWeek", () => $da2ae4574bd2c0ba$export$6ea683876c36b8d2, (v) => $da2ae4574bd2c0ba$export$6ea683876c36b8d2 = v);
var $da2ae4574bd2c0ba$export$6ea683876c36b8d2;
"use strict";
$da2ae4574bd2c0ba$export$6ea683876c36b8d2 = $da2ae4574bd2c0ba$var$isSameWeek;

var $aSLbu = parcelRequire("aSLbu");
/**
 * The {@link isSameWeek} function options.
 */ /**
 * @name isSameWeek
 * @category Week Helpers
 * @summary Are the given dates in the same week (and month and year)?
 *
 * @description
 * Are the given dates in the same week (and month and year)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 * @param options - An object with options
 *
 * @returns The dates are in the same week (and month and year)
 *
 * @example
 * // Are 31 August 2014 and 4 September 2014 in the same week?
 * const result = isSameWeek(new Date(2014, 7, 31), new Date(2014, 8, 4))
 * //=> true
 *
 * @example
 * // If week starts with Monday,
 * // are 31 August 2014 and 4 September 2014 in the same week?
 * const result = isSameWeek(new Date(2014, 7, 31), new Date(2014, 8, 4), {
 *   weekStartsOn: 1
 * })
 * //=> false
 *
 * @example
 * // Are 1 January 2014 and 1 January 2015 in the same week?
 * const result = isSameWeek(new Date(2014, 0, 1), new Date(2015, 0, 1))
 * //=> false
 */ function $da2ae4574bd2c0ba$var$isSameWeek(dateLeft, dateRight, options) {
    const dateLeftStartOfWeek = (0, $aSLbu.startOfWeek)(dateLeft, options);
    const dateRightStartOfWeek = (0, $aSLbu.startOfWeek)(dateRight, options);
    return +dateLeftStartOfWeek === +dateRightStartOfWeek;
}

});


parcelRegister("NHiOX", function(module, exports) {

$parcel$export(module.exports, "isSameISOWeekYear", () => $09562ab47778c434$export$5f55dbf38a1aee81, (v) => $09562ab47778c434$export$5f55dbf38a1aee81 = v);
var $09562ab47778c434$export$5f55dbf38a1aee81;
"use strict";
$09562ab47778c434$export$5f55dbf38a1aee81 = $09562ab47778c434$var$isSameISOWeekYear;

var $hxisM = parcelRequire("hxisM");
/**
 * @name isSameISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Are the given dates in the same ISO week-numbering year?
 *
 * @description
 * Are the given dates in the same ISO week-numbering year?
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same ISO week-numbering year
 *
 * @example
 * // Are 29 December 2003 and 2 January 2005 in the same ISO week-numbering year?
 * const result = isSameISOWeekYear(new Date(2003, 11, 29), new Date(2005, 0, 2))
 * //=> true
 */ function $09562ab47778c434$var$isSameISOWeekYear(dateLeft, dateRight) {
    const dateLeftStartOfYear = (0, $hxisM.startOfISOWeekYear)(dateLeft);
    const dateRightStartOfYear = (0, $hxisM.startOfISOWeekYear)(dateRight);
    return +dateLeftStartOfYear === +dateRightStartOfYear;
}

});

parcelRegister("7O4IC", function(module, exports) {

$parcel$export(module.exports, "isSameMinute", () => $5af0dceac20078fd$export$5d274bf63c8705cb, (v) => $5af0dceac20078fd$export$5d274bf63c8705cb = v);
var $5af0dceac20078fd$export$5d274bf63c8705cb;
"use strict";
$5af0dceac20078fd$export$5d274bf63c8705cb = $5af0dceac20078fd$var$isSameMinute;

var $kouFc = parcelRequire("kouFc");
/**
 * @name isSameMinute
 * @category Minute Helpers
 * @summary Are the given dates in the same minute (and hour and day)?
 *
 * @description
 * Are the given dates in the same minute (and hour and day)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same minute (and hour and day)
 *
 * @example
 * // Are 4 September 2014 06:30:00 and 4 September 2014 06:30:15 in the same minute?
 * const result = isSameMinute(
 *   new Date(2014, 8, 4, 6, 30),
 *   new Date(2014, 8, 4, 6, 30, 15)
 * )
 * //=> true
 *
 * @example
 * // Are 4 September 2014 06:30:00 and 5 September 2014 06:30:00 in the same minute?
 * const result = isSameMinute(
 *   new Date(2014, 8, 4, 6, 30),
 *   new Date(2014, 8, 5, 6, 30)
 * )
 * //=> false
 */ function $5af0dceac20078fd$var$isSameMinute(dateLeft, dateRight) {
    const dateLeftStartOfMinute = (0, $kouFc.startOfMinute)(dateLeft);
    const dateRightStartOfMinute = (0, $kouFc.startOfMinute)(dateRight);
    return +dateLeftStartOfMinute === +dateRightStartOfMinute;
}

});

parcelRegister("8EXtq", function(module, exports) {

$parcel$export(module.exports, "isSameSecond", () => $64e03163e74c9e7c$export$b88fbcfe038f3498, (v) => $64e03163e74c9e7c$export$b88fbcfe038f3498 = v);
var $64e03163e74c9e7c$export$b88fbcfe038f3498;
"use strict";
$64e03163e74c9e7c$export$b88fbcfe038f3498 = $64e03163e74c9e7c$var$isSameSecond;

var $dtQAX = parcelRequire("dtQAX");
/**
 * @name isSameSecond
 * @category Second Helpers
 * @summary Are the given dates in the same second (and hour and day)?
 *
 * @description
 * Are the given dates in the same second (and hour and day)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same second (and hour and day)
 *
 * @example
 * // Are 4 September 2014 06:30:15.000 and 4 September 2014 06:30.15.500 in the same second?
 * const result = isSameSecond(
 *   new Date(2014, 8, 4, 6, 30, 15),
 *   new Date(2014, 8, 4, 6, 30, 15, 500)
 * )
 * //=> true
 *
 * @example
 * // Are 4 September 2014 06:00:15.000 and 4 September 2014 06:01.15.000 in the same second?
 * const result = isSameSecond(
 *   new Date(2014, 8, 4, 6, 0, 15),
 *   new Date(2014, 8, 4, 6, 1, 15)
 * )
 * //=> false
 *
 * @example
 * // Are 4 September 2014 06:00:15.000 and 5 September 2014 06:00.15.000 in the same second?
 * const result = isSameSecond(
 *   new Date(2014, 8, 4, 6, 0, 15),
 *   new Date(2014, 8, 5, 6, 0, 15)
 * )
 * //=> false
 */ function $64e03163e74c9e7c$var$isSameSecond(dateLeft, dateRight) {
    const dateLeftStartOfSecond = (0, $dtQAX.startOfSecond)(dateLeft);
    const dateRightStartOfSecond = (0, $dtQAX.startOfSecond)(dateRight);
    return +dateLeftStartOfSecond === +dateRightStartOfSecond;
}

});
parcelRegister("dtQAX", function(module, exports) {

$parcel$export(module.exports, "startOfSecond", () => $9d06c81596f41c55$export$66c51f9715fdbff5, (v) => $9d06c81596f41c55$export$66c51f9715fdbff5 = v);
var $9d06c81596f41c55$export$66c51f9715fdbff5;
"use strict";
$9d06c81596f41c55$export$66c51f9715fdbff5 = $9d06c81596f41c55$var$startOfSecond;

var $26OhI = parcelRequire("26OhI");
/**
 * @name startOfSecond
 * @category Second Helpers
 * @summary Return the start of a second for the given date.
 *
 * @description
 * Return the start of a second for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a second
 *
 * @example
 * // The start of a second for 1 December 2014 22:15:45.400:
 * const result = startOfSecond(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:45.000
 */ function $9d06c81596f41c55$var$startOfSecond(date) {
    const _date = (0, $26OhI.toDate)(date);
    _date.setMilliseconds(0);
    return _date;
}

});


parcelRegister("cJwvd", function(module, exports) {

$parcel$export(module.exports, "isThisHour", () => $9452e64d0e81ce40$export$5d41bdc7172839b9, (v) => $9452e64d0e81ce40$export$5d41bdc7172839b9 = v);
var $9452e64d0e81ce40$export$5d41bdc7172839b9;
"use strict";
$9452e64d0e81ce40$export$5d41bdc7172839b9 = $9452e64d0e81ce40$var$isThisHour;

var $cuP5N = parcelRequire("cuP5N");
/**
 * @name isThisHour
 * @category Hour Helpers
 * @summary Is the given date in the same hour as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same hour as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this hour
 *
 * @example
 * // If now is 25 September 2014 18:30:15.500,
 * // is 25 September 2014 18:00:00 in this hour?
 * const result = isThisHour(new Date(2014, 8, 25, 18))
 * //=> true
 */ function $9452e64d0e81ce40$var$isThisHour(date) {
    return (0, $cuP5N.isSameHour)(Date.now(), date);
}

});

parcelRegister("5Haas", function(module, exports) {

$parcel$export(module.exports, "isThisISOWeek", () => $4258db02060f4233$export$4e987896c721f753, (v) => $4258db02060f4233$export$4e987896c721f753 = v);
var $4258db02060f4233$export$4e987896c721f753;
"use strict";
$4258db02060f4233$export$4e987896c721f753 = $4258db02060f4233$var$isThisISOWeek;

var $dHmZ5 = parcelRequire("dHmZ5");
/**
 * @name isThisISOWeek
 * @category ISO Week Helpers
 * @summary Is the given date in the same ISO week as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same ISO week as the current date?
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this ISO week
 *
 * @example
 * // If today is 25 September 2014, is 22 September 2014 in this ISO week?
 * const result = isThisISOWeek(new Date(2014, 8, 22))
 * //=> true
 */ function $4258db02060f4233$var$isThisISOWeek(date) {
    return (0, $dHmZ5.isSameISOWeek)(date, Date.now());
}

});

parcelRegister("iAh6L", function(module, exports) {

$parcel$export(module.exports, "isThisMinute", () => $d878dc1cd1b912d6$export$fa55b7d29d8d957a, (v) => $d878dc1cd1b912d6$export$fa55b7d29d8d957a = v);
var $d878dc1cd1b912d6$export$fa55b7d29d8d957a;
"use strict";
$d878dc1cd1b912d6$export$fa55b7d29d8d957a = $d878dc1cd1b912d6$var$isThisMinute;

var $7O4IC = parcelRequire("7O4IC");
/**
 * @name isThisMinute
 * @category Minute Helpers
 * @summary Is the given date in the same minute as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same minute as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this minute
 *
 * @example
 * // If now is 25 September 2014 18:30:15.500,
 * // is 25 September 2014 18:30:00 in this minute?
 * const result = isThisMinute(new Date(2014, 8, 25, 18, 30))
 * //=> true
 */ function $d878dc1cd1b912d6$var$isThisMinute(date) {
    return (0, $7O4IC.isSameMinute)(Date.now(), date);
}

});

parcelRegister("35hFz", function(module, exports) {

$parcel$export(module.exports, "isThisMonth", () => $23ef8b88a0e55260$export$173f1e1d92847276, (v) => $23ef8b88a0e55260$export$173f1e1d92847276 = v);
var $23ef8b88a0e55260$export$173f1e1d92847276;
"use strict";
$23ef8b88a0e55260$export$173f1e1d92847276 = $23ef8b88a0e55260$var$isThisMonth;

var $4q5v8 = parcelRequire("4q5v8");
/**
 * @name isThisMonth
 * @category Month Helpers
 * @summary Is the given date in the same month as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same month as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this month
 *
 * @example
 * // If today is 25 September 2014, is 15 September 2014 in this month?
 * const result = isThisMonth(new Date(2014, 8, 15))
 * //=> true
 */ function $23ef8b88a0e55260$var$isThisMonth(date) {
    return (0, $4q5v8.isSameMonth)(Date.now(), date);
}

});

parcelRegister("2Sf4D", function(module, exports) {

$parcel$export(module.exports, "isThisQuarter", () => $217c513bf302a769$export$3d88fd18ab599ccc, (v) => $217c513bf302a769$export$3d88fd18ab599ccc = v);
var $217c513bf302a769$export$3d88fd18ab599ccc;
"use strict";
$217c513bf302a769$export$3d88fd18ab599ccc = $217c513bf302a769$var$isThisQuarter;

var $gjoJZ = parcelRequire("gjoJZ");
/**
 * @name isThisQuarter
 * @category Quarter Helpers
 * @summary Is the given date in the same quarter as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same quarter as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this quarter
 *
 * @example
 * // If today is 25 September 2014, is 2 July 2014 in this quarter?
 * const result = isThisQuarter(new Date(2014, 6, 2))
 * //=> true
 */ function $217c513bf302a769$var$isThisQuarter(date) {
    return (0, $gjoJZ.isSameQuarter)(Date.now(), date);
}

});

parcelRegister("5dpcS", function(module, exports) {

$parcel$export(module.exports, "isThisSecond", () => $3cc1b82e5976be19$export$8d7059b5bca087e6, (v) => $3cc1b82e5976be19$export$8d7059b5bca087e6 = v);
var $3cc1b82e5976be19$export$8d7059b5bca087e6;
"use strict";
$3cc1b82e5976be19$export$8d7059b5bca087e6 = $3cc1b82e5976be19$var$isThisSecond;

var $8EXtq = parcelRequire("8EXtq");
/**
 * @name isThisSecond
 * @category Second Helpers
 * @summary Is the given date in the same second as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same second as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this second
 *
 * @example
 * // If now is 25 September 2014 18:30:15.500,
 * // is 25 September 2014 18:30:15.000 in this second?
 * const result = isThisSecond(new Date(2014, 8, 25, 18, 30, 15))
 * //=> true
 */ function $3cc1b82e5976be19$var$isThisSecond(date) {
    return (0, $8EXtq.isSameSecond)(Date.now(), date);
}

});

parcelRegister("dNnRo", function(module, exports) {

$parcel$export(module.exports, "isThisWeek", () => $a0b25c17581bb46e$export$cfe4b66a69cdd8a, (v) => $a0b25c17581bb46e$export$cfe4b66a69cdd8a = v);
var $a0b25c17581bb46e$export$cfe4b66a69cdd8a;
"use strict";
$a0b25c17581bb46e$export$cfe4b66a69cdd8a = $a0b25c17581bb46e$var$isThisWeek;

var $iJiE0 = parcelRequire("iJiE0");
/**
 * The {@link isThisWeek} function options.
 */ /**
 * @name isThisWeek
 * @category Week Helpers
 * @summary Is the given date in the same week as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same week as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 * @param options - The object with options
 *
 * @returns The date is in this week
 *
 * @example
 * // If today is 25 September 2014, is 21 September 2014 in this week?
 * const result = isThisWeek(new Date(2014, 8, 21))
 * //=> true
 *
 * @example
 * // If today is 25 September 2014 and week starts with Monday
 * // is 21 September 2014 in this week?
 * const result = isThisWeek(new Date(2014, 8, 21), { weekStartsOn: 1 })
 * //=> false
 */ function $a0b25c17581bb46e$var$isThisWeek(date, options) {
    return (0, $iJiE0.isSameWeek)(date, Date.now(), options);
}

});

parcelRegister("jPr8s", function(module, exports) {

$parcel$export(module.exports, "isThisYear", () => $e6f7d4445df119b5$export$a28c94941893a5ac, (v) => $e6f7d4445df119b5$export$a28c94941893a5ac = v);
var $e6f7d4445df119b5$export$a28c94941893a5ac;
"use strict";
$e6f7d4445df119b5$export$a28c94941893a5ac = $e6f7d4445df119b5$var$isThisYear;

var $jjrXQ = parcelRequire("jjrXQ");
/**
 * @name isThisYear
 * @category Year Helpers
 * @summary Is the given date in the same year as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same year as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this year
 *
 * @example
 * // If today is 25 September 2014, is 2 July 2014 in this year?
 * const result = isThisYear(new Date(2014, 6, 2))
 * //=> true
 */ function $e6f7d4445df119b5$var$isThisYear(date) {
    return (0, $jjrXQ.isSameYear)(date, Date.now());
}

});

parcelRegister("5u5yL", function(module, exports) {

$parcel$export(module.exports, "isThursday", () => $3fe41120c85874f9$export$c8e7c906983ea347, (v) => $3fe41120c85874f9$export$c8e7c906983ea347 = v);
var $3fe41120c85874f9$export$c8e7c906983ea347;
"use strict";
$3fe41120c85874f9$export$c8e7c906983ea347 = $3fe41120c85874f9$var$isThursday;

var $26OhI = parcelRequire("26OhI");
/**
 * @name isThursday
 * @category Weekday Helpers
 * @summary Is the given date Thursday?
 *
 * @description
 * Is the given date Thursday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Thursday
 *
 * @example
 * // Is 25 September 2014 Thursday?
 * const result = isThursday(new Date(2014, 8, 25))
 * //=> true
 */ function $3fe41120c85874f9$var$isThursday(date) {
    return (0, $26OhI.toDate)(date).getDay() === 4;
}

});

parcelRegister("43Rra", function(module, exports) {

$parcel$export(module.exports, "isToday", () => $2f50e4c3d8ae169f$export$629b0a497aa65267, (v) => $2f50e4c3d8ae169f$export$629b0a497aa65267 = v);
var $2f50e4c3d8ae169f$export$629b0a497aa65267;
"use strict";
$2f50e4c3d8ae169f$export$629b0a497aa65267 = $2f50e4c3d8ae169f$var$isToday;

var $iROfp = parcelRequire("iROfp");
/**
 * @name isToday
 * @category Day Helpers
 * @summary Is the given date today?
 * @pure false
 *
 * @description
 * Is the given date today?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is today
 *
 * @example
 * // If today is 6 October 2014, is 6 October 14:00:00 today?
 * const result = isToday(new Date(2014, 9, 6, 14, 0))
 * //=> true
 */ function $2f50e4c3d8ae169f$var$isToday(date) {
    return (0, $iROfp.isSameDay)(date, Date.now());
}

});

parcelRegister("690TI", function(module, exports) {

$parcel$export(module.exports, "isTomorrow", () => $479447954901c1de$export$d6365ba92f0647f1, (v) => $479447954901c1de$export$d6365ba92f0647f1 = v);
var $479447954901c1de$export$d6365ba92f0647f1;
"use strict";
$479447954901c1de$export$d6365ba92f0647f1 = $479447954901c1de$var$isTomorrow;

var $jKYo1 = parcelRequire("jKYo1");

var $iROfp = parcelRequire("iROfp");
/**
 * @name isTomorrow
 * @category Day Helpers
 * @summary Is the given date tomorrow?
 * @pure false
 *
 * @description
 * Is the given date tomorrow?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is tomorrow
 *
 * @example
 * // If today is 6 October 2014, is 7 October 14:00:00 tomorrow?
 * const result = isTomorrow(new Date(2014, 9, 7, 14, 0))
 * //=> true
 */ function $479447954901c1de$var$isTomorrow(date) {
    return (0, $iROfp.isSameDay)(date, (0, $jKYo1.addDays)(Date.now(), 1));
}

});

parcelRegister("Ln4ir", function(module, exports) {

$parcel$export(module.exports, "isTuesday", () => $08e648c8c7b90b9a$export$90d50b8f209f5ac3, (v) => $08e648c8c7b90b9a$export$90d50b8f209f5ac3 = v);
var $08e648c8c7b90b9a$export$90d50b8f209f5ac3;
"use strict";
$08e648c8c7b90b9a$export$90d50b8f209f5ac3 = $08e648c8c7b90b9a$var$isTuesday;

var $26OhI = parcelRequire("26OhI");
/**
 * @name isTuesday
 * @category Weekday Helpers
 * @summary Is the given date Tuesday?
 *
 * @description
 * Is the given date Tuesday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Tuesday
 *
 * @example
 * // Is 23 September 2014 Tuesday?
 * const result = isTuesday(new Date(2014, 8, 23))
 * //=> true
 */ function $08e648c8c7b90b9a$var$isTuesday(date) {
    return (0, $26OhI.toDate)(date).getDay() === 2;
}

});

parcelRegister("4qjZG", function(module, exports) {

$parcel$export(module.exports, "isWednesday", () => $3389198061d83d8d$export$ec9de642cdd62944, (v) => $3389198061d83d8d$export$ec9de642cdd62944 = v);
var $3389198061d83d8d$export$ec9de642cdd62944;
"use strict";
$3389198061d83d8d$export$ec9de642cdd62944 = $3389198061d83d8d$var$isWednesday;

var $26OhI = parcelRequire("26OhI");
/**
 * @name isWednesday
 * @category Weekday Helpers
 * @summary Is the given date Wednesday?
 *
 * @description
 * Is the given date Wednesday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Wednesday
 *
 * @example
 * // Is 24 September 2014 Wednesday?
 * const result = isWednesday(new Date(2014, 8, 24))
 * //=> true
 */ function $3389198061d83d8d$var$isWednesday(date) {
    return (0, $26OhI.toDate)(date).getDay() === 3;
}

});

parcelRegister("9I5Lz", function(module, exports) {

$parcel$export(module.exports, "isYesterday", () => $711cb2329090ed70$export$221990270ebfe867, (v) => $711cb2329090ed70$export$221990270ebfe867 = v);
var $711cb2329090ed70$export$221990270ebfe867;
"use strict";
$711cb2329090ed70$export$221990270ebfe867 = $711cb2329090ed70$var$isYesterday;

var $iROfp = parcelRequire("iROfp");

var $04GVu = parcelRequire("04GVu");
/**
 * @name isYesterday
 * @category Day Helpers
 * @summary Is the given date yesterday?
 * @pure false
 *
 * @description
 * Is the given date yesterday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is yesterday
 *
 * @example
 * // If today is 6 October 2014, is 5 October 14:00:00 yesterday?
 * const result = isYesterday(new Date(2014, 9, 5, 14, 0))
 * //=> true
 */ function $711cb2329090ed70$var$isYesterday(date) {
    return (0, $iROfp.isSameDay)(date, (0, $04GVu.subDays)(Date.now(), 1));
}

});

parcelRegister("dPXSp", function(module, exports) {

$parcel$export(module.exports, "lastDayOfDecade", () => $a12e7c0b0ba079da$export$2aaf6241f57dd605, (v) => $a12e7c0b0ba079da$export$2aaf6241f57dd605 = v);
var $a12e7c0b0ba079da$export$2aaf6241f57dd605;
"use strict";
$a12e7c0b0ba079da$export$2aaf6241f57dd605 = $a12e7c0b0ba079da$var$lastDayOfDecade;

var $26OhI = parcelRequire("26OhI");
/**
 * @name lastDayOfDecade
 * @category Decade Helpers
 * @summary Return the last day of a decade for the given date.
 *
 * @description
 * Return the last day of a decade for the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The last day of a decade
 *
 * @example
 * // The last day of a decade for 21 December 2012 21:12:00:
 * const result = lastDayOfDecade(new Date(2012, 11, 21, 21, 12, 00))
 * //=> Wed Dec 31 2019 00:00:00
 */ function $a12e7c0b0ba079da$var$lastDayOfDecade(date) {
    // TODO: Switch to more technical definition in of decades that start with 1
    // end with 0. I.e. 2001-2010 instead of current 2000-2009. It's a breaking
    // change, so it can only be done in 4.0.
    const _date = (0, $26OhI.toDate)(date);
    const year = _date.getFullYear();
    const decade = 9 + Math.floor(year / 10) * 10;
    _date.setFullYear(decade + 1, 0, 0);
    _date.setHours(0, 0, 0, 0);
    return _date;
}

});

parcelRegister("lAtNI", function(module, exports) {

$parcel$export(module.exports, "lastDayOfISOWeek", () => $fb74139cd4afff30$export$b08a8fc26ae6d94b, (v) => $fb74139cd4afff30$export$b08a8fc26ae6d94b = v);
var $fb74139cd4afff30$export$b08a8fc26ae6d94b;
"use strict";
$fb74139cd4afff30$export$b08a8fc26ae6d94b = $fb74139cd4afff30$var$lastDayOfISOWeek;

var $fJ6mH = parcelRequire("fJ6mH");
/**
 * @name lastDayOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the last day of an ISO week for the given date.
 *
 * @description
 * Return the last day of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The last day of an ISO week
 *
 * @example
 * // The last day of an ISO week for 2 September 2014 11:55:00:
 * const result = lastDayOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Sep 07 2014 00:00:00
 */ function $fb74139cd4afff30$var$lastDayOfISOWeek(date) {
    return (0, $fJ6mH.lastDayOfWeek)(date, {
        weekStartsOn: 1
    });
}

});
parcelRegister("fJ6mH", function(module, exports) {

$parcel$export(module.exports, "lastDayOfWeek", () => $b72ffef2fec941c7$export$b73502c35a293b0a, (v) => $b72ffef2fec941c7$export$b73502c35a293b0a = v);
var $b72ffef2fec941c7$export$b73502c35a293b0a;
"use strict";
$b72ffef2fec941c7$export$b73502c35a293b0a = $b72ffef2fec941c7$var$lastDayOfWeek;

var $26OhI = parcelRequire("26OhI");

var $2Hkrd = parcelRequire("2Hkrd");
/**
 * The {@link lastDayOfWeek} function options.
 */ /**
 * @name lastDayOfWeek
 * @category Week Helpers
 * @summary Return the last day of a week for the given date.
 *
 * @description
 * Return the last day of a week for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The last day of a week
 *
 * @example
 * // The last day of a week for 2 September 2014 11:55:00:
 * const result = lastDayOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sat Sep 06 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the last day of the week for 2 September 2014 11:55:00:
 * const result = lastDayOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Sun Sep 07 2014 00:00:00
 */ function $b72ffef2fec941c7$var$lastDayOfWeek(date, options) {
    const defaultOptions = (0, $2Hkrd.getDefaultOptions)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, $26OhI.toDate)(date);
    const day = _date.getDay();
    const diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
    _date.setHours(0, 0, 0, 0);
    _date.setDate(_date.getDate() + diff);
    return _date;
}

});


parcelRegister("bFmPP", function(module, exports) {

$parcel$export(module.exports, "lastDayOfISOWeekYear", () => $87e53c9c23bad295$export$1810bada8cd02ee1, (v) => $87e53c9c23bad295$export$1810bada8cd02ee1 = v);
var $87e53c9c23bad295$export$1810bada8cd02ee1;
"use strict";
$87e53c9c23bad295$export$1810bada8cd02ee1 = $87e53c9c23bad295$var$lastDayOfISOWeekYear;

var $lepTe = parcelRequire("lepTe");

var $77HoA = parcelRequire("77HoA");

var $CS8DB = parcelRequire("CS8DB");
/**
 * @name lastDayOfISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the last day of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the last day of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of an ISO week-numbering year
 *
 * @example
 * // The last day of an ISO week-numbering year for 2 July 2005:
 * const result = lastDayOfISOWeekYear(new Date(2005, 6, 2))
 * //=> Sun Jan 01 2006 00:00:00
 */ function $87e53c9c23bad295$var$lastDayOfISOWeekYear(date) {
    const year = (0, $lepTe.getISOWeekYear)(date);
    const fourthOfJanuary = (0, $CS8DB.constructFrom)(date, 0);
    fourthOfJanuary.setFullYear(year + 1, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    const _date = (0, $77HoA.startOfISOWeek)(fourthOfJanuary);
    _date.setDate(_date.getDate() - 1);
    return _date;
}

});

parcelRegister("8pPIp", function(module, exports) {

$parcel$export(module.exports, "lastDayOfQuarter", () => $6208c61975e211c9$export$8693c04228304c7, (v) => $6208c61975e211c9$export$8693c04228304c7 = v);
var $6208c61975e211c9$export$8693c04228304c7;
"use strict";
$6208c61975e211c9$export$8693c04228304c7 = $6208c61975e211c9$var$lastDayOfQuarter;

var $26OhI = parcelRequire("26OhI");
/**
 * @name lastDayOfQuarter
 * @category Quarter Helpers
 * @summary Return the last day of a year quarter for the given date.
 *
 * @description
 * Return the last day of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The last day of a quarter
 *
 * @example
 * // The last day of a quarter for 2 September 2014 11:55:00:
 * const result = lastDayOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 00:00:00
 */ function $6208c61975e211c9$var$lastDayOfQuarter(date) {
    const _date = (0, $26OhI.toDate)(date);
    const currentMonth = _date.getMonth();
    const month = currentMonth - currentMonth % 3 + 3;
    _date.setMonth(month, 0);
    _date.setHours(0, 0, 0, 0);
    return _date;
}

});

parcelRegister("2j9aG", function(module, exports) {

$parcel$export(module.exports, "lastDayOfYear", () => $1ae4785903285dba$export$323f7bc07b828bed, (v) => $1ae4785903285dba$export$323f7bc07b828bed = v);
var $1ae4785903285dba$export$323f7bc07b828bed;
"use strict";
$1ae4785903285dba$export$323f7bc07b828bed = $1ae4785903285dba$var$lastDayOfYear;

var $26OhI = parcelRequire("26OhI");
/**
 * @name lastDayOfYear
 * @category Year Helpers
 * @summary Return the last day of a year for the given date.
 *
 * @description
 * Return the last day of a year for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The last day of a year
 *
 * @example
 * // The last day of a year for 2 September 2014 11:55:00:
 * const result = lastDayOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Dec 31 2014 00:00:00
 */ function $1ae4785903285dba$var$lastDayOfYear(date) {
    const _date = (0, $26OhI.toDate)(date);
    const year = _date.getFullYear();
    _date.setFullYear(year + 1, 0, 0);
    _date.setHours(0, 0, 0, 0);
    return _date;
}

});

parcelRegister("hqqDU", function(module, exports) {
"use strict";
module.exports.lightFormat = $caf9880d79d70892$var$lightFormat;
Object.defineProperty(module.exports, "lightFormatters", {
    enumerable: true,
    get: function() {
        return $lhoHr.lightFormatters;
    }
});

var $gwJip = parcelRequire("gwJip");

var $26OhI = parcelRequire("26OhI");

var $lhoHr = parcelRequire("lhoHr");
// Rexports of internal for libraries to use.
// See: https://github.com/date-fns/date-fns/issues/3638#issuecomment-1877082874
// This RegExp consists of three parts separated by `|`:
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const $caf9880d79d70892$var$formattingTokensRegExp = /(\w)\1*|''|'(''|[^'])+('|$)|./g;
const $caf9880d79d70892$var$escapedStringRegExp = /^'([^]*?)'?$/;
const $caf9880d79d70892$var$doubleQuoteRegExp = /''/g;
const $caf9880d79d70892$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @private
 */ /**
 * @name lightFormat
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. Unlike `format`,
 * `lightFormat` doesn't use locales and outputs date using the most popular tokens.
 *
 * > ⚠️ Please note that the `lightFormat` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   |
 * |---------------------------------|---------|-----------------------------------|
 * | AM, PM                          | a..aaa  | AM, PM                            |
 * |                                 | aaaa    | a.m., p.m.                        |
 * |                                 | aaaaa   | a, p                              |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 |
 * |                                 | yy      | 44, 01, 00, 17                    |
 * |                                 | yyy     | 044, 001, 000, 017                |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |
 * |                                 | MM      | 01, 02, ..., 12                   |
 * | Day of month                    | d       | 1, 2, ..., 31                     |
 * |                                 | dd      | 01, 02, ..., 31                   |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |
 * |                                 | hh      | 01, 02, ..., 11, 12               |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |
 * |                                 | HH      | 00, 01, 02, ..., 23               |
 * | Minute                          | m       | 0, 1, ..., 59                     |
 * |                                 | mm      | 00, 01, ..., 59                   |
 * | Second                          | s       | 0, 1, ..., 59                     |
 * |                                 | ss      | 00, 01, ..., 59                   |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |
 * |                                 | SS      | 00, 01, ..., 99                   |
 * |                                 | SSS     | 000, 001, ..., 999                |
 * |                                 | SSSS    | ...                               |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param format - The string of tokens
 *
 * @returns The formatted date string
 *
 * @throws `Invalid time value` if the date is invalid
 * @throws format string contains an unescaped latin alphabet character
 *
 * @example
 * const result = lightFormat(new Date(2014, 1, 11), 'yyyy-MM-dd')
 * //=> '2014-02-11'
 */ function $caf9880d79d70892$var$lightFormat(date, formatStr) {
    const _date = (0, $26OhI.toDate)(date);
    if (!(0, $gwJip.isValid)(_date)) throw new RangeError("Invalid time value");
    const tokens = formatStr.match($caf9880d79d70892$var$formattingTokensRegExp);
    // The only case when formattingTokensRegExp doesn't match the string is when it's empty
    if (!tokens) return "";
    const result = tokens.map((substring)=>{
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        const firstCharacter = substring[0];
        if (firstCharacter === "'") return $caf9880d79d70892$var$cleanEscapedString(substring);
        const formatter = $lhoHr.lightFormatters[firstCharacter];
        if (formatter) return formatter(_date, substring);
        if (firstCharacter.match($caf9880d79d70892$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return substring;
    }).join("");
    return result;
}
function $caf9880d79d70892$var$cleanEscapedString(input) {
    const matches = input.match($caf9880d79d70892$var$escapedStringRegExp);
    if (!matches) return input;
    return matches[1].replace($caf9880d79d70892$var$doubleQuoteRegExp, "'");
}

});

parcelRegister("7klGw", function(module, exports) {

$parcel$export(module.exports, "milliseconds", () => $555b38cb76aefda9$export$9a27fac83d67afd3, (v) => $555b38cb76aefda9$export$9a27fac83d67afd3 = v);
var $555b38cb76aefda9$export$9a27fac83d67afd3;
"use strict";
$555b38cb76aefda9$export$9a27fac83d67afd3 = $555b38cb76aefda9$var$milliseconds;

var $4IrbU = parcelRequire("4IrbU");
/**
 * @name milliseconds
 * @category Millisecond Helpers
 * @summary
 * Returns the number of milliseconds in the specified, years, months, weeks, days, hours, minutes and seconds.
 *
 * @description
 * Returns the number of milliseconds in the specified, years, months, weeks, days, hours, minutes and seconds.
 *
 * One years equals 365.2425 days according to the formula:
 *
 * > Leap year occures every 4 years, except for years that are divisable by 100 and not divisable by 400.
 * > 1 mean year = (365+1/4-1/100+1/400) days = 365.2425 days
 *
 * One month is a year divided by 12.
 *
 * @param duration - The object with years, months, weeks, days, hours, minutes and seconds to be added.
 *
 * @returns The milliseconds
 *
 * @example
 * // 1 year in milliseconds
 * milliseconds({ years: 1 })
 * //=> 31556952000
 *
 * // 3 months in milliseconds
 * milliseconds({ months: 3 })
 * //=> 7889238000
 */ function $555b38cb76aefda9$var$milliseconds({ years: years, months: months, weeks: weeks, days: days, hours: hours, minutes: minutes, seconds: seconds }) {
    let totalDays = 0;
    if (years) totalDays += years * $4IrbU.daysInYear;
    if (months) totalDays += months * ($4IrbU.daysInYear / 12);
    if (weeks) totalDays += weeks * 7;
    if (days) totalDays += days;
    let totalSeconds = totalDays * 86400;
    if (hours) totalSeconds += hours * 3600;
    if (minutes) totalSeconds += minutes * 60;
    if (seconds) totalSeconds += seconds;
    return Math.trunc(totalSeconds * 1000);
}

});

parcelRegister("9IDw2", function(module, exports) {

$parcel$export(module.exports, "millisecondsToHours", () => $7136e01acc08b38c$export$689a412b29fa9ed5, (v) => $7136e01acc08b38c$export$689a412b29fa9ed5 = v);
var $7136e01acc08b38c$export$689a412b29fa9ed5;
"use strict";
$7136e01acc08b38c$export$689a412b29fa9ed5 = $7136e01acc08b38c$var$millisecondsToHours;

var $4IrbU = parcelRequire("4IrbU");
/**
 * @name millisecondsToHours
 * @category Conversion Helpers
 * @summary Convert milliseconds to hours.
 *
 * @description
 * Convert a number of milliseconds to a full number of hours.
 *
 * @param milliseconds - The number of milliseconds to be converted
 *
 * @returns The number of milliseconds converted in hours
 *
 * @example
 * // Convert 7200000 milliseconds to hours:
 * const result = millisecondsToHours(7200000)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = millisecondsToHours(7199999)
 * //=> 1
 */ function $7136e01acc08b38c$var$millisecondsToHours(milliseconds) {
    const hours = milliseconds / $4IrbU.millisecondsInHour;
    return Math.trunc(hours);
}

});

parcelRegister("QvL3S", function(module, exports) {

$parcel$export(module.exports, "millisecondsToMinutes", () => $09dd7dee923ae514$export$a5f974e81e48cfc0, (v) => $09dd7dee923ae514$export$a5f974e81e48cfc0 = v);
var $09dd7dee923ae514$export$a5f974e81e48cfc0;
"use strict";
$09dd7dee923ae514$export$a5f974e81e48cfc0 = $09dd7dee923ae514$var$millisecondsToMinutes;

var $4IrbU = parcelRequire("4IrbU");
/**
 * @name millisecondsToMinutes
 * @category Conversion Helpers
 * @summary Convert milliseconds to minutes.
 *
 * @description
 * Convert a number of milliseconds to a full number of minutes.
 *
 * @param milliseconds - The number of milliseconds to be converted
 *
 * @returns The number of milliseconds converted in minutes
 *
 * @example
 * // Convert 60000 milliseconds to minutes:
 * const result = millisecondsToMinutes(60000)
 * //=> 1
 *
 * @example
 * // It uses floor rounding:
 * const result = millisecondsToMinutes(119999)
 * //=> 1
 */ function $09dd7dee923ae514$var$millisecondsToMinutes(milliseconds) {
    const minutes = milliseconds / $4IrbU.millisecondsInMinute;
    return Math.trunc(minutes);
}

});

parcelRegister("azoGl", function(module, exports) {

$parcel$export(module.exports, "millisecondsToSeconds", () => $7b2051965c3c30cb$export$f64c3bfbc58eec0f, (v) => $7b2051965c3c30cb$export$f64c3bfbc58eec0f = v);
var $7b2051965c3c30cb$export$f64c3bfbc58eec0f;
"use strict";
$7b2051965c3c30cb$export$f64c3bfbc58eec0f = $7b2051965c3c30cb$var$millisecondsToSeconds;

var $4IrbU = parcelRequire("4IrbU");
/**
 * @name millisecondsToSeconds
 * @category Conversion Helpers
 * @summary Convert milliseconds to seconds.
 *
 * @description
 * Convert a number of milliseconds to a full number of seconds.
 *
 * @param milliseconds - The number of milliseconds to be converted
 *
 * @returns The number of milliseconds converted in seconds
 *
 * @example
 * // Convert 1000 miliseconds to seconds:
 * const result = millisecondsToSeconds(1000)
 * //=> 1
 *
 * @example
 * // It uses floor rounding:
 * const result = millisecondsToSeconds(1999)
 * //=> 1
 */ function $7b2051965c3c30cb$var$millisecondsToSeconds(milliseconds) {
    const seconds = milliseconds / $4IrbU.millisecondsInSecond;
    return Math.trunc(seconds);
}

});

parcelRegister("iwf8x", function(module, exports) {

$parcel$export(module.exports, "minutesToHours", () => $d7b6f4f7c042dfef$export$815164eb42530ae7, (v) => $d7b6f4f7c042dfef$export$815164eb42530ae7 = v);
var $d7b6f4f7c042dfef$export$815164eb42530ae7;
"use strict";
$d7b6f4f7c042dfef$export$815164eb42530ae7 = $d7b6f4f7c042dfef$var$minutesToHours;

var $4IrbU = parcelRequire("4IrbU");
/**
 * @name minutesToHours
 * @category Conversion Helpers
 * @summary Convert minutes to hours.
 *
 * @description
 * Convert a number of minutes to a full number of hours.
 *
 * @param minutes - The number of minutes to be converted
 *
 * @returns The number of minutes converted in hours
 *
 * @example
 * // Convert 140 minutes to hours:
 * const result = minutesToHours(120)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = minutesToHours(179)
 * //=> 2
 */ function $d7b6f4f7c042dfef$var$minutesToHours(minutes) {
    const hours = minutes / $4IrbU.minutesInHour;
    return Math.trunc(hours);
}

});

parcelRegister("5QceI", function(module, exports) {

$parcel$export(module.exports, "minutesToMilliseconds", () => $440b4cf8599b5556$export$f6b9795ef9056e3d, (v) => $440b4cf8599b5556$export$f6b9795ef9056e3d = v);
var $440b4cf8599b5556$export$f6b9795ef9056e3d;
"use strict";
$440b4cf8599b5556$export$f6b9795ef9056e3d = $440b4cf8599b5556$var$minutesToMilliseconds;

var $4IrbU = parcelRequire("4IrbU");
/**
 * @name minutesToMilliseconds
 * @category Conversion Helpers
 * @summary Convert minutes to milliseconds.
 *
 * @description
 * Convert a number of minutes to a full number of milliseconds.
 *
 * @param minutes - The number of minutes to be converted
 *
 * @returns The number of minutes converted in milliseconds
 *
 * @example
 * // Convert 2 minutes to milliseconds
 * const result = minutesToMilliseconds(2)
 * //=> 120000
 */ function $440b4cf8599b5556$var$minutesToMilliseconds(minutes) {
    return Math.trunc(minutes * $4IrbU.millisecondsInMinute);
}

});

parcelRegister("gyyqC", function(module, exports) {

$parcel$export(module.exports, "minutesToSeconds", () => $c0da870edc77aeb2$export$81ded4628c655103, (v) => $c0da870edc77aeb2$export$81ded4628c655103 = v);
var $c0da870edc77aeb2$export$81ded4628c655103;
"use strict";
$c0da870edc77aeb2$export$81ded4628c655103 = $c0da870edc77aeb2$var$minutesToSeconds;

var $4IrbU = parcelRequire("4IrbU");
/**
 * @name minutesToSeconds
 * @category Conversion Helpers
 * @summary Convert minutes to seconds.
 *
 * @description
 * Convert a number of minutes to a full number of seconds.
 *
 * @param minutes - The number of minutes to be converted
 *
 * @returns The number of minutes converted in seconds
 *
 * @example
 * // Convert 2 minutes to seconds
 * const result = minutesToSeconds(2)
 * //=> 120
 */ function $c0da870edc77aeb2$var$minutesToSeconds(minutes) {
    return Math.trunc(minutes * $4IrbU.secondsInMinute);
}

});

parcelRegister("5mNbv", function(module, exports) {

$parcel$export(module.exports, "monthsToQuarters", () => $3e8528ddb8b151c3$export$1932fa2a2068c849, (v) => $3e8528ddb8b151c3$export$1932fa2a2068c849 = v);
var $3e8528ddb8b151c3$export$1932fa2a2068c849;
"use strict";
$3e8528ddb8b151c3$export$1932fa2a2068c849 = $3e8528ddb8b151c3$var$monthsToQuarters;

var $4IrbU = parcelRequire("4IrbU");
/**
 * @name monthsToQuarters
 * @category Conversion Helpers
 * @summary Convert number of months to quarters.
 *
 * @description
 * Convert a number of months to a full number of quarters.
 *
 * @param months - The number of months to be converted.
 *
 * @returns The number of months converted in quarters
 *
 * @example
 * // Convert 6 months to quarters:
 * const result = monthsToQuarters(6)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = monthsToQuarters(7)
 * //=> 2
 */ function $3e8528ddb8b151c3$var$monthsToQuarters(months) {
    const quarters = months / $4IrbU.monthsInQuarter;
    return Math.trunc(quarters);
}

});

parcelRegister("7YgUq", function(module, exports) {

$parcel$export(module.exports, "monthsToYears", () => $5cdb40c862f445be$export$7489026ed27fc925, (v) => $5cdb40c862f445be$export$7489026ed27fc925 = v);
var $5cdb40c862f445be$export$7489026ed27fc925;
"use strict";
$5cdb40c862f445be$export$7489026ed27fc925 = $5cdb40c862f445be$var$monthsToYears;

var $4IrbU = parcelRequire("4IrbU");
/**
 * @name monthsToYears
 * @category Conversion Helpers
 * @summary Convert number of months to years.
 *
 * @description
 * Convert a number of months to a full number of years.
 *
 * @param months - The number of months to be converted
 *
 * @returns The number of months converted in years
 *
 * @example
 * // Convert 36 months to years:
 * const result = monthsToYears(36)
 * //=> 3
 *
 * // It uses floor rounding:
 * const result = monthsToYears(40)
 * //=> 3
 */ function $5cdb40c862f445be$var$monthsToYears(months) {
    const years = months / $4IrbU.monthsInYear;
    return Math.trunc(years);
}

});

parcelRegister("dTYI9", function(module, exports) {

$parcel$export(module.exports, "nextDay", () => $a1ef815da15a3b9a$export$992728922317ffc8, (v) => $a1ef815da15a3b9a$export$992728922317ffc8 = v);
var $a1ef815da15a3b9a$export$992728922317ffc8;
"use strict";
$a1ef815da15a3b9a$export$992728922317ffc8 = $a1ef815da15a3b9a$var$nextDay;

var $jKYo1 = parcelRequire("jKYo1");

var $4uPa5 = parcelRequire("4uPa5");
/**
 * @name nextDay
 * @category Weekday Helpers
 * @summary When is the next day of the week?
 *
 * @description
 * When is the next day of the week? 0-6 the day of the week, 0 represents Sunday.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 * @param day - day of the week
 *
 * @returns The date is the next day of week
 *
 * @example
 * // When is the next Monday after Mar, 20, 2020?
 * const result = nextDay(new Date(2020, 2, 20), 1)
 * //=> Mon Mar 23 2020 00:00:00
 *
 * @example
 * // When is the next Tuesday after Mar, 21, 2020?
 * const result = nextDay(new Date(2020, 2, 21), 2)
 * //=> Tue Mar 24 2020 00:00:00
 */ function $a1ef815da15a3b9a$var$nextDay(date, day) {
    let delta = day - (0, $4uPa5.getDay)(date);
    if (delta <= 0) delta += 7;
    return (0, $jKYo1.addDays)(date, delta);
}

});

parcelRegister("gYfAQ", function(module, exports) {

$parcel$export(module.exports, "nextFriday", () => $c5ae5869a70c4e3f$export$21d76934fce76327, (v) => $c5ae5869a70c4e3f$export$21d76934fce76327 = v);
var $c5ae5869a70c4e3f$export$21d76934fce76327;
"use strict";
$c5ae5869a70c4e3f$export$21d76934fce76327 = $c5ae5869a70c4e3f$var$nextFriday;

var $dTYI9 = parcelRequire("dTYI9");
/**
 * @name nextFriday
 * @category Weekday Helpers
 * @summary When is the next Friday?
 *
 * @description
 * When is the next Friday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Friday
 *
 * @example
 * // When is the next Friday after Mar, 22, 2020?
 * const result = nextFriday(new Date(2020, 2, 22))
 * //=> Fri Mar 27 2020 00:00:00
 */ function $c5ae5869a70c4e3f$var$nextFriday(date) {
    return (0, $dTYI9.nextDay)(date, 5);
}

});

parcelRegister("ktVHI", function(module, exports) {

$parcel$export(module.exports, "nextMonday", () => $ee9346e8a33643c9$export$a20373bb0df6efdd, (v) => $ee9346e8a33643c9$export$a20373bb0df6efdd = v);
var $ee9346e8a33643c9$export$a20373bb0df6efdd;
"use strict";
$ee9346e8a33643c9$export$a20373bb0df6efdd = $ee9346e8a33643c9$var$nextMonday;

var $dTYI9 = parcelRequire("dTYI9");
/**
 * @name nextMonday
 * @category Weekday Helpers
 * @summary When is the next Monday?
 *
 * @description
 * When is the next Monday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Monday
 *
 * @example
 * // When is the next Monday after Mar, 22, 2020?
 * const result = nextMonday(new Date(2020, 2, 22))
 * //=> Mon Mar 23 2020 00:00:00
 */ function $ee9346e8a33643c9$var$nextMonday(date) {
    return (0, $dTYI9.nextDay)(date, 1);
}

});

parcelRegister("e9kDc", function(module, exports) {

$parcel$export(module.exports, "nextSaturday", () => $a4d1e8e2f29ca15c$export$c52f069246f7b032, (v) => $a4d1e8e2f29ca15c$export$c52f069246f7b032 = v);
var $a4d1e8e2f29ca15c$export$c52f069246f7b032;
"use strict";
$a4d1e8e2f29ca15c$export$c52f069246f7b032 = $a4d1e8e2f29ca15c$var$nextSaturday;

var $dTYI9 = parcelRequire("dTYI9");
/**
 * @name nextSaturday
 * @category Weekday Helpers
 * @summary When is the next Saturday?
 *
 * @description
 * When is the next Saturday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Saturday
 *
 * @example
 * // When is the next Saturday after Mar, 22, 2020?
 * const result = nextSaturday(new Date(2020, 2, 22))
 * //=> Sat Mar 28 2020 00:00:00
 */ function $a4d1e8e2f29ca15c$var$nextSaturday(date) {
    return (0, $dTYI9.nextDay)(date, 6);
}

});

parcelRegister("4AUE7", function(module, exports) {

$parcel$export(module.exports, "nextSunday", () => $358676f8e3880750$export$a30adaa3ef47f854, (v) => $358676f8e3880750$export$a30adaa3ef47f854 = v);
var $358676f8e3880750$export$a30adaa3ef47f854;
"use strict";
$358676f8e3880750$export$a30adaa3ef47f854 = $358676f8e3880750$var$nextSunday;

var $dTYI9 = parcelRequire("dTYI9");
/**
 * @name nextSunday
 * @category Weekday Helpers
 * @summary When is the next Sunday?
 *
 * @description
 * When is the next Sunday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Sunday
 *
 * @example
 * // When is the next Sunday after Mar, 22, 2020?
 * const result = nextSunday(new Date(2020, 2, 22))
 * //=> Sun Mar 29 2020 00:00:00
 */ function $358676f8e3880750$var$nextSunday(date) {
    return (0, $dTYI9.nextDay)(date, 0);
}

});

parcelRegister("l7Fyu", function(module, exports) {

$parcel$export(module.exports, "nextThursday", () => $f60a7c6abedf497d$export$36d9a8523a98d5a4, (v) => $f60a7c6abedf497d$export$36d9a8523a98d5a4 = v);
var $f60a7c6abedf497d$export$36d9a8523a98d5a4;
"use strict";
$f60a7c6abedf497d$export$36d9a8523a98d5a4 = $f60a7c6abedf497d$var$nextThursday;

var $dTYI9 = parcelRequire("dTYI9");
/**
 * @name nextThursday
 * @category Weekday Helpers
 * @summary When is the next Thursday?
 *
 * @description
 * When is the next Thursday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Thursday
 *
 * @example
 * // When is the next Thursday after Mar, 22, 2020?
 * const result = nextThursday(new Date(2020, 2, 22))
 * //=> Thur Mar 26 2020 00:00:00
 */ function $f60a7c6abedf497d$var$nextThursday(date) {
    return (0, $dTYI9.nextDay)(date, 4);
}

});

parcelRegister("ci9cb", function(module, exports) {

$parcel$export(module.exports, "nextTuesday", () => $8f2e4c81e61d1bb4$export$391d63ff7dc2f668, (v) => $8f2e4c81e61d1bb4$export$391d63ff7dc2f668 = v);
var $8f2e4c81e61d1bb4$export$391d63ff7dc2f668;
"use strict";
$8f2e4c81e61d1bb4$export$391d63ff7dc2f668 = $8f2e4c81e61d1bb4$var$nextTuesday;

var $dTYI9 = parcelRequire("dTYI9");
/**
 * @name nextTuesday
 * @category Weekday Helpers
 * @summary When is the next Tuesday?
 *
 * @description
 * When is the next Tuesday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Tuesday
 *
 * @example
 * // When is the next Tuesday after Mar, 22, 2020?
 * const result = nextTuesday(new Date(2020, 2, 22))
 * //=> Tue Mar 24 2020 00:00:00
 */ function $8f2e4c81e61d1bb4$var$nextTuesday(date) {
    return (0, $dTYI9.nextDay)(date, 2);
}

});

parcelRegister("4zRzS", function(module, exports) {

$parcel$export(module.exports, "nextWednesday", () => $3553fdba3afee21d$export$7a895c1ff204304e, (v) => $3553fdba3afee21d$export$7a895c1ff204304e = v);
var $3553fdba3afee21d$export$7a895c1ff204304e;
"use strict";
$3553fdba3afee21d$export$7a895c1ff204304e = $3553fdba3afee21d$var$nextWednesday;

var $dTYI9 = parcelRequire("dTYI9");
/**
 * @name nextWednesday
 * @category Weekday Helpers
 * @summary When is the next Wednesday?
 *
 * @description
 * When is the next Wednesday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Wednesday
 *
 * @example
 * // When is the next Wednesday after Mar, 22, 2020?
 * const result = nextWednesday(new Date(2020, 2, 22))
 * //=> Wed Mar 25 2020 00:00:00
 */ function $3553fdba3afee21d$var$nextWednesday(date) {
    return (0, $dTYI9.nextDay)(date, 3);
}

});

parcelRegister("hfXeo", function(module, exports) {

$parcel$export(module.exports, "parseJSON", () => $c901c86f8367efe5$export$27924e57e9afff7f, (v) => $c901c86f8367efe5$export$27924e57e9afff7f = v);
var $c901c86f8367efe5$export$27924e57e9afff7f;
"use strict";
$c901c86f8367efe5$export$27924e57e9afff7f = $c901c86f8367efe5$var$parseJSON; /**
 * @name parseJSON
 * @category Common Helpers
 * @summary Parse a JSON date string
 *
 * @description
 * Converts a complete ISO date string in UTC time, the typical format for transmitting
 * a date in JSON, to a JavaScript `Date` instance.
 *
 * This is a minimal implementation for converting dates retrieved from a JSON API to
 * a `Date` instance which can be used with other functions in the `date-fns` library.
 * The following formats are supported:
 *
 * - `2000-03-15T05:20:10.123Z`: The output of `.toISOString()` and `JSON.stringify(new Date())`
 * - `2000-03-15T05:20:10Z`: Without milliseconds
 * - `2000-03-15T05:20:10+00:00`: With a zero offset, the default JSON encoded format in some other languages
 * - `2000-03-15T05:20:10+05:45`: With a positive or negative offset, the default JSON encoded format in some other languages
 * - `2000-03-15T05:20:10+0000`: With a zero offset without a colon
 * - `2000-03-15T05:20:10`: Without a trailing 'Z' symbol
 * - `2000-03-15T05:20:10.1234567`: Up to 7 digits in milliseconds field. Only first 3 are taken into account since JS does not allow fractional milliseconds
 * - `2000-03-15 05:20:10`: With a space instead of a 'T' separator for APIs returning a SQL date without reformatting
 *
 * For convenience and ease of use these other input types are also supported
 * via [toDate](https://date-fns.org/docs/toDate):
 *
 * - A `Date` instance will be cloned
 * - A `number` will be treated as a timestamp
 *
 * Any other input type or invalid date strings will return an `Invalid Date`.
 *
 * @param dateStr - A fully formed ISO8601 date string to convert
 *
 * @returns The parsed date in the local time zone
 */ 
function $c901c86f8367efe5$var$parseJSON(dateStr) {
    const parts = dateStr.match(/(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2}):(\d{2})(?:\.(\d{0,7}))?(?:Z|(.)(\d{2}):?(\d{2})?)?/);
    if (parts) // Group 8 matches the sign
    return new Date(Date.UTC(+parts[1], +parts[2] - 1, +parts[3], +parts[4] - (+parts[9] || 0) * (parts[8] == "-" ? -1 : 1), +parts[5] - (+parts[10] || 0) * (parts[8] == "-" ? -1 : 1), +parts[6], +((parts[7] || "0") + "00").substring(0, 3)));
    return new Date(NaN);
}

});

parcelRegister("b6Z7T", function(module, exports) {

$parcel$export(module.exports, "previousDay", () => $816fabaed164c623$export$4caccb62df4eacc0, (v) => $816fabaed164c623$export$4caccb62df4eacc0 = v);
var $816fabaed164c623$export$4caccb62df4eacc0;
"use strict";
$816fabaed164c623$export$4caccb62df4eacc0 = $816fabaed164c623$var$previousDay;

var $4uPa5 = parcelRequire("4uPa5");

var $04GVu = parcelRequire("04GVu");
/**
 * @name previousDay
 * @category Weekday Helpers
 * @summary When is the previous day of the week?
 *
 * @description
 * When is the previous day of the week? 0-6 the day of the week, 0 represents Sunday.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 * @param day - The day of the week
 *
 * @returns The date is the previous day of week
 *
 * @example
 * // When is the previous Monday before Mar, 20, 2020?
 * const result = previousDay(new Date(2020, 2, 20), 1)
 * //=> Mon Mar 16 2020 00:00:00
 *
 * @example
 * // When is the previous Tuesday before Mar, 21, 2020?
 * const result = previousDay(new Date(2020, 2, 21), 2)
 * //=> Tue Mar 17 2020 00:00:00
 */ function $816fabaed164c623$var$previousDay(date, day) {
    let delta = (0, $4uPa5.getDay)(date) - day;
    if (delta <= 0) delta += 7;
    return (0, $04GVu.subDays)(date, delta);
}

});

parcelRegister("bK0nt", function(module, exports) {

$parcel$export(module.exports, "previousFriday", () => $88c44895892ceb7b$export$32d52646c338c11d, (v) => $88c44895892ceb7b$export$32d52646c338c11d = v);
var $88c44895892ceb7b$export$32d52646c338c11d;
"use strict";
$88c44895892ceb7b$export$32d52646c338c11d = $88c44895892ceb7b$var$previousFriday;

var $b6Z7T = parcelRequire("b6Z7T");
/**
 * @name previousFriday
 * @category Weekday Helpers
 * @summary When is the previous Friday?
 *
 * @description
 * When is the previous Friday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Friday
 *
 * @example
 * // When is the previous Friday before Jun, 19, 2021?
 * const result = previousFriday(new Date(2021, 5, 19))
 * //=> Fri June 18 2021 00:00:00
 */ function $88c44895892ceb7b$var$previousFriday(date) {
    return (0, $b6Z7T.previousDay)(date, 5);
}

});

parcelRegister("k7ZeP", function(module, exports) {

$parcel$export(module.exports, "previousMonday", () => $ea73f6b8bb5b6774$export$398437ab6f45c582, (v) => $ea73f6b8bb5b6774$export$398437ab6f45c582 = v);
var $ea73f6b8bb5b6774$export$398437ab6f45c582;
"use strict";
$ea73f6b8bb5b6774$export$398437ab6f45c582 = $ea73f6b8bb5b6774$var$previousMonday;

var $b6Z7T = parcelRequire("b6Z7T");
/**
 * @name previousMonday
 * @category Weekday Helpers
 * @summary When is the previous Monday?
 *
 * @description
 * When is the previous Monday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Monday
 *
 * @example
 * // When is the previous Monday before Jun, 18, 2021?
 * const result = previousMonday(new Date(2021, 5, 18))
 * //=> Mon June 14 2021 00:00:00
 */ function $ea73f6b8bb5b6774$var$previousMonday(date) {
    return (0, $b6Z7T.previousDay)(date, 1);
}

});

parcelRegister("996Bm", function(module, exports) {

$parcel$export(module.exports, "previousSaturday", () => $6a8a13485808abc3$export$36767a7e6101ecb0, (v) => $6a8a13485808abc3$export$36767a7e6101ecb0 = v);
var $6a8a13485808abc3$export$36767a7e6101ecb0;
"use strict";
$6a8a13485808abc3$export$36767a7e6101ecb0 = $6a8a13485808abc3$var$previousSaturday;

var $b6Z7T = parcelRequire("b6Z7T");
/**
 * @name previousSaturday
 * @category Weekday Helpers
 * @summary When is the previous Saturday?
 *
 * @description
 * When is the previous Saturday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Saturday
 *
 * @example
 * // When is the previous Saturday before Jun, 20, 2021?
 * const result = previousSaturday(new Date(2021, 5, 20))
 * //=> Sat June 19 2021 00:00:00
 */ function $6a8a13485808abc3$var$previousSaturday(date) {
    return (0, $b6Z7T.previousDay)(date, 6);
}

});

parcelRegister("6nx0Q", function(module, exports) {

$parcel$export(module.exports, "previousSunday", () => $4a4e7fb221a2e617$export$7d3d7d8fc5e81fd4, (v) => $4a4e7fb221a2e617$export$7d3d7d8fc5e81fd4 = v);
var $4a4e7fb221a2e617$export$7d3d7d8fc5e81fd4;
"use strict";
$4a4e7fb221a2e617$export$7d3d7d8fc5e81fd4 = $4a4e7fb221a2e617$var$previousSunday;

var $b6Z7T = parcelRequire("b6Z7T");
/**
 * @name previousSunday
 * @category Weekday Helpers
 * @summary When is the previous Sunday?
 *
 * @description
 * When is the previous Sunday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Sunday
 *
 * @example
 * // When is the previous Sunday before Jun, 21, 2021?
 * const result = previousSunday(new Date(2021, 5, 21))
 * //=> Sun June 20 2021 00:00:00
 */ function $4a4e7fb221a2e617$var$previousSunday(date) {
    return (0, $b6Z7T.previousDay)(date, 0);
}

});

parcelRegister("1aIGH", function(module, exports) {

$parcel$export(module.exports, "previousThursday", () => $0da963a57f0c5883$export$1975b5b1f6b0e34e, (v) => $0da963a57f0c5883$export$1975b5b1f6b0e34e = v);
var $0da963a57f0c5883$export$1975b5b1f6b0e34e;
"use strict";
$0da963a57f0c5883$export$1975b5b1f6b0e34e = $0da963a57f0c5883$var$previousThursday;

var $b6Z7T = parcelRequire("b6Z7T");
/**
 * @name previousThursday
 * @category Weekday Helpers
 * @summary When is the previous Thursday?
 *
 * @description
 * When is the previous Thursday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Thursday
 *
 * @example
 * // When is the previous Thursday before Jun, 18, 2021?
 * const result = previousThursday(new Date(2021, 5, 18))
 * //=> Thu June 17 2021 00:00:00
 */ function $0da963a57f0c5883$var$previousThursday(date) {
    return (0, $b6Z7T.previousDay)(date, 4);
}

});

parcelRegister("uxAEt", function(module, exports) {

$parcel$export(module.exports, "previousTuesday", () => $05bcdbc3310d61ae$export$a034a75f093bcfaf, (v) => $05bcdbc3310d61ae$export$a034a75f093bcfaf = v);
var $05bcdbc3310d61ae$export$a034a75f093bcfaf;
"use strict";
$05bcdbc3310d61ae$export$a034a75f093bcfaf = $05bcdbc3310d61ae$var$previousTuesday;

var $b6Z7T = parcelRequire("b6Z7T");
/**
 * @name previousTuesday
 * @category Weekday Helpers
 * @summary When is the previous Tuesday?
 *
 * @description
 * When is the previous Tuesday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Tuesday
 *
 * @example
 * // When is the previous Tuesday before Jun, 18, 2021?
 * const result = previousTuesday(new Date(2021, 5, 18))
 * //=> Tue June 15 2021 00:00:00
 */ function $05bcdbc3310d61ae$var$previousTuesday(date) {
    return (0, $b6Z7T.previousDay)(date, 2);
}

});

parcelRegister("b96Ks", function(module, exports) {

$parcel$export(module.exports, "previousWednesday", () => $81d5c50ae5fb95fc$export$26334f591e4ce672, (v) => $81d5c50ae5fb95fc$export$26334f591e4ce672 = v);
var $81d5c50ae5fb95fc$export$26334f591e4ce672;
"use strict";
$81d5c50ae5fb95fc$export$26334f591e4ce672 = $81d5c50ae5fb95fc$var$previousWednesday;

var $b6Z7T = parcelRequire("b6Z7T");
/**
 * @name previousWednesday
 * @category Weekday Helpers
 * @summary When is the previous Wednesday?
 *
 * @description
 * When is the previous Wednesday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Wednesday
 *
 * @example
 * // When is the previous Wednesday before Jun, 18, 2021?
 * const result = previousWednesday(new Date(2021, 5, 18))
 * //=> Wed June 16 2021 00:00:00
 */ function $81d5c50ae5fb95fc$var$previousWednesday(date) {
    return (0, $b6Z7T.previousDay)(date, 3);
}

});

parcelRegister("5pYe9", function(module, exports) {

$parcel$export(module.exports, "quartersToMonths", () => $3f1e0170d6f8b113$export$a29d19ce21d74c57, (v) => $3f1e0170d6f8b113$export$a29d19ce21d74c57 = v);
var $3f1e0170d6f8b113$export$a29d19ce21d74c57;
"use strict";
$3f1e0170d6f8b113$export$a29d19ce21d74c57 = $3f1e0170d6f8b113$var$quartersToMonths;

var $4IrbU = parcelRequire("4IrbU");
/**
 * @name quartersToMonths
 * @category Conversion Helpers
 * @summary Convert number of quarters to months.
 *
 * @description
 * Convert a number of quarters to a full number of months.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param quarters - The number of quarters to be converted
 *
 * @returns The number of quarters converted in months
 *
 * @example
 * // Convert 2 quarters to months
 * const result = quartersToMonths(2)
 * //=> 6
 */ function $3f1e0170d6f8b113$var$quartersToMonths(quarters) {
    return Math.trunc(quarters * $4IrbU.monthsInQuarter);
}

});

parcelRegister("ch9m7", function(module, exports) {

$parcel$export(module.exports, "quartersToYears", () => $8efe5471918bbebd$export$c309fa8f184b4648, (v) => $8efe5471918bbebd$export$c309fa8f184b4648 = v);
var $8efe5471918bbebd$export$c309fa8f184b4648;
"use strict";
$8efe5471918bbebd$export$c309fa8f184b4648 = $8efe5471918bbebd$var$quartersToYears;

var $4IrbU = parcelRequire("4IrbU");
/**
 * @name quartersToYears
 * @category Conversion Helpers
 * @summary Convert number of quarters to years.
 *
 * @description
 * Convert a number of quarters to a full number of years.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param quarters - The number of quarters to be converted
 *
 * @returns The number of quarters converted in years
 *
 * @example
 * // Convert 8 quarters to years
 * const result = quartersToYears(8)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = quartersToYears(11)
 * //=> 2
 */ function $8efe5471918bbebd$var$quartersToYears(quarters) {
    const years = quarters / $4IrbU.quartersInYear;
    return Math.trunc(years);
}

});

parcelRegister("8Fm00", function(module, exports) {

$parcel$export(module.exports, "roundToNearestMinutes", () => $64f3379c33269709$export$d97410bb8cd0dff, (v) => $64f3379c33269709$export$d97410bb8cd0dff = v);
var $64f3379c33269709$export$d97410bb8cd0dff;
"use strict";
$64f3379c33269709$export$d97410bb8cd0dff = $64f3379c33269709$var$roundToNearestMinutes;

var $60GiW = parcelRequire("60GiW");

var $CS8DB = parcelRequire("CS8DB");

var $26OhI = parcelRequire("26OhI");
/**
 * The {@link roundToNearestMinutes} function options.
 */ /**
 * @name roundToNearestMinutes
 * @category Minute Helpers
 * @summary Rounds the given date to the nearest minute
 *
 * @description
 * Rounds the given date to the nearest minute (or number of minutes).
 * Rounds up when the given date is exactly between the nearest round minutes.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to round
 * @param options - An object with options.
 *
 * @returns The new date rounded to the closest minute
 *
 * @example
 * // Round 10 July 2014 12:12:34 to nearest minute:
 * const result = roundToNearestMinutes(new Date(2014, 6, 10, 12, 12, 34))
 * //=> Thu Jul 10 2014 12:13:00
 *
 * @example
 * // Round 10 July 2014 12:12:34 to nearest quarter hour:
 * const result = roundToNearestMinutes(new Date(2014, 6, 10, 12, 12, 34), { nearestTo: 15 })
 * //=> Thu Jul 10 2014 12:15:00
 *
 * @example
 * // Floor (rounds down) 10 July 2014 12:12:34 to nearest minute:
 * const result = roundToNearestMinutes(new Date(2014, 6, 10, 12, 12, 34), { roundingMethod: 'floor' })
 * //=> Thu Jul 10 2014 12:12:00
 *
 * @example
 * // Ceil (rounds up) 10 July 2014 12:12:34 to nearest half hour:
 * const result = roundToNearestMinutes(new Date(2014, 6, 10, 12, 12, 34), { roundingMethod: 'ceil', nearestTo: 30 })
 * //=> Thu Jul 10 2014 12:30:00
 */ function $64f3379c33269709$var$roundToNearestMinutes(date, options) {
    const nearestTo = options?.nearestTo ?? 1;
    if (nearestTo < 1 || nearestTo > 30) return (0, $CS8DB.constructFrom)(date, NaN);
    const _date = (0, $26OhI.toDate)(date);
    const fractionalSeconds = _date.getSeconds() / 60;
    const fractionalMilliseconds = _date.getMilliseconds() / 1000 / 60;
    const minutes = _date.getMinutes() + fractionalSeconds + fractionalMilliseconds;
    // Unlike the `differenceIn*` functions, the default rounding behavior is `round` and not 'trunc'
    const method = options?.roundingMethod ?? "round";
    const roundingMethod = (0, $60GiW.getRoundingMethod)(method);
    const roundedMinutes = roundingMethod(minutes / nearestTo) * nearestTo;
    const result = (0, $CS8DB.constructFrom)(date, _date);
    result.setMinutes(roundedMinutes, 0, 0);
    return result;
}

});

parcelRegister("iMnpE", function(module, exports) {

$parcel$export(module.exports, "secondsToHours", () => $dabedef9b61ae15f$export$47d555ff5354096f, (v) => $dabedef9b61ae15f$export$47d555ff5354096f = v);
var $dabedef9b61ae15f$export$47d555ff5354096f;
"use strict";
$dabedef9b61ae15f$export$47d555ff5354096f = $dabedef9b61ae15f$var$secondsToHours;

var $4IrbU = parcelRequire("4IrbU");
/**
 * @name secondsToHours
 * @category Conversion Helpers
 * @summary Convert seconds to hours.
 *
 * @description
 * Convert a number of seconds to a full number of hours.
 *
 * @param seconds - The number of seconds to be converted
 *
 * @returns The number of seconds converted in hours
 *
 * @example
 * // Convert 7200 seconds into hours
 * const result = secondsToHours(7200)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = secondsToHours(7199)
 * //=> 1
 */ function $dabedef9b61ae15f$var$secondsToHours(seconds) {
    const hours = seconds / $4IrbU.secondsInHour;
    return Math.trunc(hours);
}

});

parcelRegister("896n2", function(module, exports) {

$parcel$export(module.exports, "secondsToMilliseconds", () => $5ee41b1517440630$export$fc3e7e8557f8c8c7, (v) => $5ee41b1517440630$export$fc3e7e8557f8c8c7 = v);
var $5ee41b1517440630$export$fc3e7e8557f8c8c7;
"use strict";
$5ee41b1517440630$export$fc3e7e8557f8c8c7 = $5ee41b1517440630$var$secondsToMilliseconds;

var $4IrbU = parcelRequire("4IrbU");
/**
 * @name secondsToMilliseconds
 * @category Conversion Helpers
 * @summary Convert seconds to milliseconds.
 *
 * @description
 * Convert a number of seconds to a full number of milliseconds.
 *
 * @param seconds - The number of seconds to be converted
 *
 * @returns The number of seconds converted in milliseconds
 *
 * @example
 * // Convert 2 seconds into milliseconds
 * const result = secondsToMilliseconds(2)
 * //=> 2000
 */ function $5ee41b1517440630$var$secondsToMilliseconds(seconds) {
    return seconds * $4IrbU.millisecondsInSecond;
}

});

parcelRegister("4wX3S", function(module, exports) {

$parcel$export(module.exports, "secondsToMinutes", () => $34c7f6f549ded8b3$export$ed657adb62398e99, (v) => $34c7f6f549ded8b3$export$ed657adb62398e99 = v);
var $34c7f6f549ded8b3$export$ed657adb62398e99;
"use strict";
$34c7f6f549ded8b3$export$ed657adb62398e99 = $34c7f6f549ded8b3$var$secondsToMinutes;

var $4IrbU = parcelRequire("4IrbU");
/**
 * @name secondsToMinutes
 * @category Conversion Helpers
 * @summary Convert seconds to minutes.
 *
 * @description
 * Convert a number of seconds to a full number of minutes.
 *
 * @param seconds - The number of seconds to be converted
 *
 * @returns The number of seconds converted in minutes
 *
 * @example
 * // Convert 120 seconds into minutes
 * const result = secondsToMinutes(120)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = secondsToMinutes(119)
 * //=> 1
 */ function $34c7f6f549ded8b3$var$secondsToMinutes(seconds) {
    const minutes = seconds / $4IrbU.secondsInMinute;
    return Math.trunc(minutes);
}

});

parcelRegister("4YV2O", function(module, exports) {

$parcel$export(module.exports, "set", () => $3a0903d3a3ad3dbc$export$adaa4cf7ef1b65be, (v) => $3a0903d3a3ad3dbc$export$adaa4cf7ef1b65be = v);
var $3a0903d3a3ad3dbc$export$adaa4cf7ef1b65be;
"use strict";
$3a0903d3a3ad3dbc$export$adaa4cf7ef1b65be = $3a0903d3a3ad3dbc$var$set;

var $CS8DB = parcelRequire("CS8DB");

var $03Fkt = parcelRequire("03Fkt");

var $26OhI = parcelRequire("26OhI");
/**
 * @name set
 * @category Common Helpers
 * @summary Set date values to a given date.
 *
 * @description
 * Set date values to a given date.
 *
 * Sets time values to date from object `values`.
 * A value is not set if it is undefined or null or doesn't exist in `values`.
 *
 * Note about bundle size: `set` does not internally use `setX` functions from date-fns but instead opts
 * to use native `Date#setX` methods. If you use this function, you may not want to include the
 * other `setX` functions that date-fns provides if you are concerned about the bundle size.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param values - The date values to be set
 *
 * @returns The new date with options set
 *
 * @example
 * // Transform 1 September 2014 into 20 October 2015 in a single line:
 * const result = set(new Date(2014, 8, 20), { year: 2015, month: 9, date: 20 })
 * //=> Tue Oct 20 2015 00:00:00
 *
 * @example
 * // Set 12 PM to 1 September 2014 01:23:45 to 1 September 2014 12:00:00:
 * const result = set(new Date(2014, 8, 1, 1, 23, 45), { hours: 12 })
 * //=> Mon Sep 01 2014 12:23:45
 */ function $3a0903d3a3ad3dbc$var$set(date, values) {
    let _date = (0, $26OhI.toDate)(date);
    // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
    if (isNaN(+_date)) return (0, $CS8DB.constructFrom)(date, NaN);
    if (values.year != null) _date.setFullYear(values.year);
    if (values.month != null) _date = (0, $03Fkt.setMonth)(_date, values.month);
    if (values.date != null) _date.setDate(values.date);
    if (values.hours != null) _date.setHours(values.hours);
    if (values.minutes != null) _date.setMinutes(values.minutes);
    if (values.seconds != null) _date.setSeconds(values.seconds);
    if (values.milliseconds != null) _date.setMilliseconds(values.milliseconds);
    return _date;
}

});

parcelRegister("2erB6", function(module, exports) {

$parcel$export(module.exports, "setDate", () => $1a024bdf9ef4f3c3$export$566174fa40823587, (v) => $1a024bdf9ef4f3c3$export$566174fa40823587 = v);
var $1a024bdf9ef4f3c3$export$566174fa40823587;
"use strict";
$1a024bdf9ef4f3c3$export$566174fa40823587 = $1a024bdf9ef4f3c3$var$setDate;

var $26OhI = parcelRequire("26OhI");
/**
 * @name setDate
 * @category Day Helpers
 * @summary Set the day of the month to the given date.
 *
 * @description
 * Set the day of the month to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param dayOfMonth - The day of the month of the new date
 *
 * @returns The new date with the day of the month set
 *
 * @example
 * // Set the 30th day of the month to 1 September 2014:
 * const result = setDate(new Date(2014, 8, 1), 30)
 * //=> Tue Sep 30 2014 00:00:00
 */ function $1a024bdf9ef4f3c3$var$setDate(date, dayOfMonth) {
    const _date = (0, $26OhI.toDate)(date);
    _date.setDate(dayOfMonth);
    return _date;
}

});

parcelRegister("ktDTG", function(module, exports) {

$parcel$export(module.exports, "setDayOfYear", () => $ee8576cc10c6490e$export$2af590ffc7e7d7c5, (v) => $ee8576cc10c6490e$export$2af590ffc7e7d7c5 = v);
var $ee8576cc10c6490e$export$2af590ffc7e7d7c5;
"use strict";
$ee8576cc10c6490e$export$2af590ffc7e7d7c5 = $ee8576cc10c6490e$var$setDayOfYear;

var $26OhI = parcelRequire("26OhI");
/**
 * @name setDayOfYear
 * @category Day Helpers
 * @summary Set the day of the year to the given date.
 *
 * @description
 * Set the day of the year to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param dayOfYear - The day of the year of the new date
 *
 * @returns The new date with the day of the year set
 *
 * @example
 * // Set the 2nd day of the year to 2 July 2014:
 * const result = setDayOfYear(new Date(2014, 6, 2), 2)
 * //=> Thu Jan 02 2014 00:00:00
 */ function $ee8576cc10c6490e$var$setDayOfYear(date, dayOfYear) {
    const _date = (0, $26OhI.toDate)(date);
    _date.setMonth(0);
    _date.setDate(dayOfYear);
    return _date;
}

});

parcelRegister("7WH2x", function(module, exports) {

$parcel$export(module.exports, "setDefaultOptions", () => $017e2ece95c00353$export$95365be1b0704abc, (v) => $017e2ece95c00353$export$95365be1b0704abc = v);
var $017e2ece95c00353$export$95365be1b0704abc;
"use strict";
$017e2ece95c00353$export$95365be1b0704abc = $017e2ece95c00353$var$setDefaultOptions;

var $2Hkrd = parcelRequire("2Hkrd");
/**
 * @name setDefaultOptions
 * @category Common Helpers
 * @summary Set default options including locale.
 * @pure false
 *
 * @description
 * Sets the defaults for
 * `options.locale`, `options.weekStartsOn` and `options.firstWeekContainsDate`
 * arguments for all functions.
 *
 * @param options - An object with options
 *
 * @example
 * // Set global locale:
 * import { es } from 'date-fns/locale'
 * setDefaultOptions({ locale: es })
 * const result = format(new Date(2014, 8, 2), 'PPPP')
 * //=> 'martes, 2 de septiembre de 2014'
 *
 * @example
 * // Start of the week for 2 September 2014:
 * const result = startOfWeek(new Date(2014, 8, 2))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // Start of the week for 2 September 2014,
 * // when we set that week starts on Monday by default:
 * setDefaultOptions({ weekStartsOn: 1 })
 * const result = startOfWeek(new Date(2014, 8, 2))
 * //=> Mon Sep 01 2014 00:00:00
 *
 * @example
 * // Manually set options take priority over default options:
 * setDefaultOptions({ weekStartsOn: 1 })
 * const result = startOfWeek(new Date(2014, 8, 2), { weekStartsOn: 0 })
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // Remove the option by setting it to `undefined`:
 * setDefaultOptions({ weekStartsOn: 1 })
 * setDefaultOptions({ weekStartsOn: undefined })
 * const result = startOfWeek(new Date(2014, 8, 2))
 * //=> Sun Aug 31 2014 00:00:00
 */ function $017e2ece95c00353$var$setDefaultOptions(options) {
    const result = {};
    const defaultOptions = (0, $2Hkrd.getDefaultOptions)();
    for(const property in defaultOptions)if (Object.prototype.hasOwnProperty.call(defaultOptions, property)) // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
    result[property] = defaultOptions[property];
    for(const property in options)if (Object.prototype.hasOwnProperty.call(options, property)) {
        if (options[property] === undefined) // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
        delete result[property];
        else // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
        result[property] = options[property];
    }
    (0, $2Hkrd.setDefaultOptions)(result);
}

});

parcelRegister("gGt9b", function(module, exports) {

$parcel$export(module.exports, "setMilliseconds", () => $c2572d998ee31fcd$export$de5664029b35e06d, (v) => $c2572d998ee31fcd$export$de5664029b35e06d = v);
var $c2572d998ee31fcd$export$de5664029b35e06d;
"use strict";
$c2572d998ee31fcd$export$de5664029b35e06d = $c2572d998ee31fcd$var$setMilliseconds;

var $26OhI = parcelRequire("26OhI");
/**
 * @name setMilliseconds
 * @category Millisecond Helpers
 * @summary Set the milliseconds to the given date.
 *
 * @description
 * Set the milliseconds to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param milliseconds - The milliseconds of the new date
 *
 * @returns The new date with the milliseconds set
 *
 * @example
 * // Set 300 milliseconds to 1 September 2014 11:30:40.500:
 * const result = setMilliseconds(new Date(2014, 8, 1, 11, 30, 40, 500), 300)
 * //=> Mon Sep 01 2014 11:30:40.300
 */ function $c2572d998ee31fcd$var$setMilliseconds(date, milliseconds) {
    const _date = (0, $26OhI.toDate)(date);
    _date.setMilliseconds(milliseconds);
    return _date;
}

});

parcelRegister("8l1Su", function(module, exports) {

$parcel$export(module.exports, "setWeekYear", () => $6121bdcb04ea238d$export$4340968d5939835e, (v) => $6121bdcb04ea238d$export$4340968d5939835e = v);
var $6121bdcb04ea238d$export$4340968d5939835e;
"use strict";
$6121bdcb04ea238d$export$4340968d5939835e = $6121bdcb04ea238d$var$setWeekYear;

var $CS8DB = parcelRequire("CS8DB");

var $hzJYa = parcelRequire("hzJYa");

var $fjV92 = parcelRequire("fjV92");

var $26OhI = parcelRequire("26OhI");

var $2Hkrd = parcelRequire("2Hkrd");
/**
 * The {@link setWeekYear} function options.
 */ /**
 * @name setWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Set the local week-numbering year to the given date.
 *
 * @description
 * Set the local week-numbering year to the given date,
 * saving the week number and the weekday number.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param weekYear - The local week-numbering year of the new date
 * @param options - An object with options
 *
 * @returns The new date with the local week-numbering year set
 *
 * @example
 * // Set the local week-numbering year 2004 to 2 January 2010 with default options:
 * const result = setWeekYear(new Date(2010, 0, 2), 2004)
 * //=> Sat Jan 03 2004 00:00:00
 *
 * @example
 * // Set the local week-numbering year 2004 to 2 January 2010,
 * // if Monday is the first day of week
 * // and 4 January is always in the first week of the year:
 * const result = setWeekYear(new Date(2010, 0, 2), 2004, {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> Sat Jan 01 2005 00:00:00
 */ function $6121bdcb04ea238d$var$setWeekYear(date, weekYear, options) {
    const defaultOptions = (0, $2Hkrd.getDefaultOptions)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    let _date = (0, $26OhI.toDate)(date);
    const diff = (0, $hzJYa.differenceInCalendarDays)(_date, (0, $fjV92.startOfWeekYear)(_date, options));
    const firstWeek = (0, $CS8DB.constructFrom)(date, 0);
    firstWeek.setFullYear(weekYear, 0, firstWeekContainsDate);
    firstWeek.setHours(0, 0, 0, 0);
    _date = (0, $fjV92.startOfWeekYear)(firstWeek, options);
    _date.setDate(_date.getDate() + diff);
    return _date;
}

});

parcelRegister("jqA9A", function(module, exports) {

$parcel$export(module.exports, "startOfDecade", () => $e24c7d5e3aa41783$export$730492981c634308, (v) => $e24c7d5e3aa41783$export$730492981c634308 = v);
var $e24c7d5e3aa41783$export$730492981c634308;
"use strict";
$e24c7d5e3aa41783$export$730492981c634308 = $e24c7d5e3aa41783$var$startOfDecade;

var $26OhI = parcelRequire("26OhI");
/**
 * @name startOfDecade
 * @category Decade Helpers
 * @summary Return the start of a decade for the given date.
 *
 * @description
 * Return the start of a decade for the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a decade
 *
 * @example
 * // The start of a decade for 21 October 2015 00:00:00:
 * const result = startOfDecade(new Date(2015, 9, 21, 00, 00, 00))
 * //=> Jan 01 2010 00:00:00
 */ function $e24c7d5e3aa41783$var$startOfDecade(date) {
    // TODO: Switch to more technical definition in of decades that start with 1
    // end with 0. I.e. 2001-2010 instead of current 2000-2009. It's a breaking
    // change, so it can only be done in 4.0.
    const _date = (0, $26OhI.toDate)(date);
    const year = _date.getFullYear();
    const decade = Math.floor(year / 10) * 10;
    _date.setFullYear(decade, 0, 1);
    _date.setHours(0, 0, 0, 0);
    return _date;
}

});

parcelRegister("bvNjp", function(module, exports) {

$parcel$export(module.exports, "startOfToday", () => $8618d747db5e878c$export$444d742fd5a45a57, (v) => $8618d747db5e878c$export$444d742fd5a45a57 = v);
var $8618d747db5e878c$export$444d742fd5a45a57;
"use strict";
$8618d747db5e878c$export$444d742fd5a45a57 = $8618d747db5e878c$var$startOfToday;

var $lPouQ = parcelRequire("lPouQ");
/**
 * @name startOfToday
 * @category Day Helpers
 * @summary Return the start of today.
 * @pure false
 *
 * @description
 * Return the start of today.
 *
 * @returns The start of today
 *
 * @example
 * // If today is 6 October 2014:
 * const result = startOfToday()
 * //=> Mon Oct 6 2014 00:00:00
 */ function $8618d747db5e878c$var$startOfToday() {
    return (0, $lPouQ.startOfDay)(Date.now());
}

});

parcelRegister("d88ys", function(module, exports) {

$parcel$export(module.exports, "startOfTomorrow", () => $98f2a888f8ef395b$export$7e8566c79d5bee07, (v) => $98f2a888f8ef395b$export$7e8566c79d5bee07 = v);
var $98f2a888f8ef395b$export$7e8566c79d5bee07;
"use strict";
$98f2a888f8ef395b$export$7e8566c79d5bee07 = $98f2a888f8ef395b$var$startOfTomorrow; /**
 * @name startOfTomorrow
 * @category Day Helpers
 * @summary Return the start of tomorrow.
 * @pure false
 *
 * @description
 * Return the start of tomorrow.
 *
 * @returns The start of tomorrow
 *
 * @example
 * // If today is 6 October 2014:
 * const result = startOfTomorrow()
 * //=> Tue Oct 7 2014 00:00:00
 */ 
function $98f2a888f8ef395b$var$startOfTomorrow() {
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth();
    const day = now.getDate();
    const date = new Date(0);
    date.setFullYear(year, month, day + 1);
    date.setHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("fya0t", function(module, exports) {

$parcel$export(module.exports, "startOfYesterday", () => $b521cb177921047d$export$23a16f3c6d143ce9, (v) => $b521cb177921047d$export$23a16f3c6d143ce9 = v);
var $b521cb177921047d$export$23a16f3c6d143ce9;
"use strict";
$b521cb177921047d$export$23a16f3c6d143ce9 = $b521cb177921047d$var$startOfYesterday; /**
 * @name startOfYesterday
 * @category Day Helpers
 * @summary Return the start of yesterday.
 * @pure false
 *
 * @description
 * Return the start of yesterday.
 *
 * @returns The start of yesterday
 *
 * @example
 * // If today is 6 October 2014:
 * const result = startOfYesterday()
 * //=> Sun Oct 5 2014 00:00:00
 */ 
function $b521cb177921047d$var$startOfYesterday() {
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth();
    const day = now.getDate();
    const date = new Date(0);
    date.setFullYear(year, month, day - 1);
    date.setHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("fPXh1", function(module, exports) {

$parcel$export(module.exports, "sub", () => $b87998ecf9ea89c2$export$f93b5905241a7cca, (v) => $b87998ecf9ea89c2$export$f93b5905241a7cca = v);
var $b87998ecf9ea89c2$export$f93b5905241a7cca;
"use strict";
$b87998ecf9ea89c2$export$f93b5905241a7cca = $b87998ecf9ea89c2$var$sub;

var $04GVu = parcelRequire("04GVu");

var $e04FR = parcelRequire("e04FR");

var $CS8DB = parcelRequire("CS8DB");
/**
 * @name sub
 * @category Common Helpers
 * @summary Subtract the specified years, months, weeks, days, hours, minutes and seconds from the given date.
 *
 * @description
 * Subtract the specified years, months, weeks, days, hours, minutes and seconds from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param duration - The object with years, months, weeks, days, hours, minutes and seconds to be subtracted
 *
 * | Key     | Description                        |
 * |---------|------------------------------------|
 * | years   | Amount of years to be subtracted   |
 * | months  | Amount of months to be subtracted  |
 * | weeks   | Amount of weeks to be subtracted   |
 * | days    | Amount of days to be subtracted    |
 * | hours   | Amount of hours to be subtracted   |
 * | minutes | Amount of minutes to be subtracted |
 * | seconds | Amount of seconds to be subtracted |
 *
 * All values default to 0
 *
 * @returns The new date with the seconds subtracted
 *
 * @example
 * // Subtract the following duration from 15 June 2017 15:29:20
 * const result = sub(new Date(2017, 5, 15, 15, 29, 20), {
 *   years: 2,
 *   months: 9,
 *   weeks: 1,
 *   days: 7,
 *   hours: 5,
 *   minutes: 9,
 *   seconds: 30
 * })
 * //=> Mon Sep 1 2014 10:19:50
 */ function $b87998ecf9ea89c2$var$sub(date, duration) {
    const { years: years = 0, months: months = 0, weeks: weeks = 0, days: days = 0, hours: hours = 0, minutes: minutes = 0, seconds: seconds = 0 } = duration;
    // Subtract years and months
    const dateWithoutMonths = (0, $e04FR.subMonths)(date, months + years * 12);
    // Subtract weeks and days
    const dateWithoutDays = (0, $04GVu.subDays)(dateWithoutMonths, days + weeks * 7);
    // Subtract hours, minutes and seconds
    const minutestoSub = minutes + hours * 60;
    const secondstoSub = seconds + minutestoSub * 60;
    const mstoSub = secondstoSub * 1000;
    const finalDate = (0, $CS8DB.constructFrom)(date, dateWithoutDays.getTime() - mstoSub);
    return finalDate;
}

});

parcelRegister("6Axmn", function(module, exports) {

$parcel$export(module.exports, "subBusinessDays", () => $4cbffb764854f23a$export$e5cc51ae28664a93, (v) => $4cbffb764854f23a$export$e5cc51ae28664a93 = v);
var $4cbffb764854f23a$export$e5cc51ae28664a93;
"use strict";
$4cbffb764854f23a$export$e5cc51ae28664a93 = $4cbffb764854f23a$var$subBusinessDays;

var $gWLtc = parcelRequire("gWLtc");
/**
 * @name subBusinessDays
 * @category Day Helpers
 * @summary Substract the specified number of business days (mon - fri) to the given date.
 *
 * @description
 * Substract the specified number of business days (mon - fri) to the given date, ignoring weekends.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of business days to be subtracted.
 *
 * @returns The new date with the business days subtracted
 *
 * @example
 * // Substract 10 business days from 1 September 2014:
 * const result = subBusinessDays(new Date(2014, 8, 1), 10)
 * //=> Mon Aug 18 2014 00:00:00 (skipped weekend days)
 */ function $4cbffb764854f23a$var$subBusinessDays(date, amount) {
    return (0, $gWLtc.addBusinessDays)(date, -amount);
}

});

parcelRegister("6ADMM", function(module, exports) {

$parcel$export(module.exports, "subHours", () => $4cc4f77cee55f7a5$export$5e9fa51cd5bb1e71, (v) => $4cc4f77cee55f7a5$export$5e9fa51cd5bb1e71 = v);
var $4cc4f77cee55f7a5$export$5e9fa51cd5bb1e71;
"use strict";
$4cc4f77cee55f7a5$export$5e9fa51cd5bb1e71 = $4cc4f77cee55f7a5$var$subHours;

var $2s8DN = parcelRequire("2s8DN");
/**
 * @name subHours
 * @category Hour Helpers
 * @summary Subtract the specified number of hours from the given date.
 *
 * @description
 * Subtract the specified number of hours from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of hours to be subtracted.
 *
 * @returns The new date with the hours subtracted
 *
 * @example
 * // Subtract 2 hours from 11 July 2014 01:00:00:
 * const result = subHours(new Date(2014, 6, 11, 1, 0), 2)
 * //=> Thu Jul 10 2014 23:00:00
 */ function $4cc4f77cee55f7a5$var$subHours(date, amount) {
    return (0, $2s8DN.addHours)(date, -amount);
}

});

parcelRegister("7Xcum", function(module, exports) {

$parcel$export(module.exports, "subMilliseconds", () => $5ca7bb18550fd8cb$export$5abaf57ab8e91640, (v) => $5ca7bb18550fd8cb$export$5abaf57ab8e91640 = v);
var $5ca7bb18550fd8cb$export$5abaf57ab8e91640;
"use strict";
$5ca7bb18550fd8cb$export$5abaf57ab8e91640 = $5ca7bb18550fd8cb$var$subMilliseconds;

var $90YsH = parcelRequire("90YsH");
/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of milliseconds to be subtracted.
 *
 * @returns The new date with the milliseconds subtracted
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */ function $5ca7bb18550fd8cb$var$subMilliseconds(date, amount) {
    return (0, $90YsH.addMilliseconds)(date, -amount);
}

});

parcelRegister("7U986", function(module, exports) {

$parcel$export(module.exports, "subMinutes", () => $5c14d852452bd0ce$export$e12a970efb73fce5, (v) => $5c14d852452bd0ce$export$e12a970efb73fce5 = v);
var $5c14d852452bd0ce$export$e12a970efb73fce5;
"use strict";
$5c14d852452bd0ce$export$e12a970efb73fce5 = $5c14d852452bd0ce$var$subMinutes;

var $hB2gy = parcelRequire("hB2gy");
/**
 * @name subMinutes
 * @category Minute Helpers
 * @summary Subtract the specified number of minutes from the given date.
 *
 * @description
 * Subtract the specified number of minutes from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of minutes to be subtracted.
 *
 * @returns The new date with the minutes subtracted
 *
 * @example
 * // Subtract 30 minutes from 10 July 2014 12:00:00:
 * const result = subMinutes(new Date(2014, 6, 10, 12, 0), 30)
 * //=> Thu Jul 10 2014 11:30:00
 */ function $5c14d852452bd0ce$var$subMinutes(date, amount) {
    return (0, $hB2gy.addMinutes)(date, -amount);
}

});

parcelRegister("4uTtN", function(module, exports) {

$parcel$export(module.exports, "subSeconds", () => $3464ffe0c500b53f$export$e95d8ad9981db689, (v) => $3464ffe0c500b53f$export$e95d8ad9981db689 = v);
var $3464ffe0c500b53f$export$e95d8ad9981db689;
"use strict";
$3464ffe0c500b53f$export$e95d8ad9981db689 = $3464ffe0c500b53f$var$subSeconds;

var $inkHK = parcelRequire("inkHK");
/**
 * @name subSeconds
 * @category Second Helpers
 * @summary Subtract the specified number of seconds from the given date.
 *
 * @description
 * Subtract the specified number of seconds from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of seconds to be subtracted.
 *
 * @returns The new date with the seconds subtracted
 *
 * @example
 * // Subtract 30 seconds from 10 July 2014 12:45:00:
 * const result = subSeconds(new Date(2014, 6, 10, 12, 45, 0), 30)
 * //=> Thu Jul 10 2014 12:44:30
 */ function $3464ffe0c500b53f$var$subSeconds(date, amount) {
    return (0, $inkHK.addSeconds)(date, -amount);
}

});

parcelRegister("6g8FL", function(module, exports) {

$parcel$export(module.exports, "weeksToDays", () => $48eaf6e74805924f$export$b696b6eeb89501ad, (v) => $48eaf6e74805924f$export$b696b6eeb89501ad = v);
var $48eaf6e74805924f$export$b696b6eeb89501ad;
"use strict";
$48eaf6e74805924f$export$b696b6eeb89501ad = $48eaf6e74805924f$var$weeksToDays;

var $4IrbU = parcelRequire("4IrbU");
/**
 * @name weeksToDays
 * @category Conversion Helpers
 * @summary Convert weeks to days.
 *
 * @description
 * Convert a number of weeks to a full number of days.
 *
 * @param weeks - The number of weeks to be converted
 *
 * @returns The number of weeks converted in days
 *
 * @example
 * // Convert 2 weeks into days
 * const result = weeksToDays(2)
 * //=> 14
 */ function $48eaf6e74805924f$var$weeksToDays(weeks) {
    return Math.trunc(weeks * $4IrbU.daysInWeek);
}

});

parcelRegister("b9CkE", function(module, exports) {

$parcel$export(module.exports, "yearsToDays", () => $81ee44f386261a74$export$862cb7b6e45c3b17, (v) => $81ee44f386261a74$export$862cb7b6e45c3b17 = v);
var $81ee44f386261a74$export$862cb7b6e45c3b17;
"use strict";
$81ee44f386261a74$export$862cb7b6e45c3b17 = $81ee44f386261a74$var$yearsToDays;

var $4IrbU = parcelRequire("4IrbU");
/**
 * @name yearsToDays
 * @category Conversion Helpers
 * @summary Convert years to days.
 *
 * @description
 * Convert a number of years to a full number of days.
 *
 * @param years - The number of years to be converted
 *
 * @returns The number of years converted in days
 *
 * @example
 * // Convert 2 years into days
 * const result = yearsToDays(2)
 * //=> 24
 */ function $81ee44f386261a74$var$yearsToDays(years) {
    return Math.trunc(years * $4IrbU.daysInYear);
}

});

parcelRegister("4CpR3", function(module, exports) {

$parcel$export(module.exports, "yearsToMonths", () => $35cec439f73d03b0$export$894abb0747b9a00, (v) => $35cec439f73d03b0$export$894abb0747b9a00 = v);
var $35cec439f73d03b0$export$894abb0747b9a00;
"use strict";
$35cec439f73d03b0$export$894abb0747b9a00 = $35cec439f73d03b0$var$yearsToMonths;

var $4IrbU = parcelRequire("4IrbU");
/**
 * @name yearsToMonths
 * @category Conversion Helpers
 * @summary Convert years to months.
 *
 * @description
 * Convert a number of years to a full number of months.
 *
 * @param years - The number of years to be converted
 *
 * @returns The number of years converted in months
 *
 * @example
 * // Convert 2 years into months
 * const result = yearsToMonths(2)
 * //=> 24
 */ function $35cec439f73d03b0$var$yearsToMonths(years) {
    return Math.trunc(years * $4IrbU.monthsInYear);
}

});

parcelRegister("eS3Uu", function(module, exports) {

$parcel$export(module.exports, "yearsToQuarters", () => $ad39244d4592c16b$export$ab26576e5e7379d7, (v) => $ad39244d4592c16b$export$ab26576e5e7379d7 = v);
var $ad39244d4592c16b$export$ab26576e5e7379d7;
"use strict";
$ad39244d4592c16b$export$ab26576e5e7379d7 = $ad39244d4592c16b$var$yearsToQuarters;

var $4IrbU = parcelRequire("4IrbU");
/**
 * @name yearsToQuarters
 * @category Conversion Helpers
 * @summary Convert years to quarters.
 *
 * @description
 * Convert a number of years to a full number of quarters.
 *
 * @param years - The number of years to be converted
 *
 * @returns The number of years converted in quarters
 *
 * @example
 * // Convert 2 years to quarters
 * const result = yearsToQuarters(2)
 * //=> 8
 */ function $ad39244d4592c16b$var$yearsToQuarters(years) {
    return Math.trunc(years * $4IrbU.quartersInYear);
}

});


parcelRegister("8mGSD", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "IGNORE_CLASS_NAME", () => $6171a3ee3f0cfb8d$export$e2911fc69bd3195e);
$parcel$export(module.exports, "default", () => $6171a3ee3f0cfb8d$export$2e2bcd8739ae039);

var $kc00y = parcelRequire("kc00y");

var $cn1Kz = parcelRequire("cn1Kz");
function $6171a3ee3f0cfb8d$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $6171a3ee3f0cfb8d$var$_setPrototypeOf(subClass, superClass);
}
function $6171a3ee3f0cfb8d$var$_setPrototypeOf(o, p) {
    $6171a3ee3f0cfb8d$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $6171a3ee3f0cfb8d$var$_setPrototypeOf(o, p);
}
function $6171a3ee3f0cfb8d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $6171a3ee3f0cfb8d$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
} /**
 * Check whether some DOM node is our Component's node.
 */ 
function $6171a3ee3f0cfb8d$var$isNodeFound(current, componentNode, ignoreClass) {
    if (current === componentNode) return true;
     // SVG <use/> elements do not technically reside in the rendered DOM, so
    // they do not have classList directly, but they offer a link to their
    // corresponding element, which can have classList. This extra check is for
    // that case.
    // See: http://www.w3.org/TR/SVG11/struct.html#InterfaceSVGUseElement
    // Discussion: https://github.com/Pomax/react-onclickoutside/pull/17
    if (current.correspondingElement) return current.correspondingElement.classList.contains(ignoreClass);
    return current.classList.contains(ignoreClass);
}
/**
 * Try to find our node in a hierarchy of nodes, returning the document
 * node as highest node if our node is not found in the path up.
 */ function $6171a3ee3f0cfb8d$var$findHighest(current, componentNode, ignoreClass) {
    if (current === componentNode) return true;
     // If source=local then this event came from 'somewhere'
    // inside and should be ignored. We could handle this with
    // a layered approach, too, but that requires going back to
    // thinking in terms of Dom node nesting, running counter
    // to React's 'you shouldn't care about the DOM' philosophy.
    // Also cover shadowRoot node by checking current.host
    while(current.parentNode || current.host){
        // Only check normal node without shadowRoot
        if (current.parentNode && $6171a3ee3f0cfb8d$var$isNodeFound(current, componentNode, ignoreClass)) return true;
        current = current.parentNode || current.host;
    }
    return current;
}
/**
 * Check if the browser scrollbar was clicked
 */ function $6171a3ee3f0cfb8d$var$clickedScrollbar(evt) {
    return document.documentElement.clientWidth <= evt.clientX || document.documentElement.clientHeight <= evt.clientY;
} // ideally will get replaced with external dep
// when rafrex/detect-passive-events#4 and rafrex/detect-passive-events#5 get merged in
var $6171a3ee3f0cfb8d$var$testPassiveEventSupport = function testPassiveEventSupport() {
    if (typeof window === "undefined" || typeof window.addEventListener !== "function") return;
    var passive = false;
    var options = Object.defineProperty({}, "passive", {
        get: function get() {
            passive = true;
        }
    });
    var noop = function noop() {};
    window.addEventListener("testPassiveEventSupport", noop, options);
    window.removeEventListener("testPassiveEventSupport", noop, options);
    return passive;
};
function $6171a3ee3f0cfb8d$var$autoInc(seed) {
    if (seed === void 0) seed = 0;
    return function() {
        return ++seed;
    };
}
var $6171a3ee3f0cfb8d$var$uid = $6171a3ee3f0cfb8d$var$autoInc();
var $6171a3ee3f0cfb8d$var$passiveEventSupport;
var $6171a3ee3f0cfb8d$var$handlersMap = {};
var $6171a3ee3f0cfb8d$var$enabledInstances = {};
var $6171a3ee3f0cfb8d$var$touchEvents = [
    "touchstart",
    "touchmove"
];
var $6171a3ee3f0cfb8d$export$e2911fc69bd3195e = "ignore-react-onclickoutside";
/**
 * Options for addEventHandler and removeEventHandler
 */ function $6171a3ee3f0cfb8d$var$getEventHandlerOptions(instance, eventName) {
    var handlerOptions = {};
    var isTouchEvent = $6171a3ee3f0cfb8d$var$touchEvents.indexOf(eventName) !== -1;
    if (isTouchEvent && $6171a3ee3f0cfb8d$var$passiveEventSupport) handlerOptions.passive = !instance.props.preventDefault;
    return handlerOptions;
}
/**
 * This function generates the HOC function that you'll use
 * in order to impart onOutsideClick listening to an
 * arbitrary component. It gets called at the end of the
 * bootstrapping code to yield an instance of the
 * onClickOutsideHOC function defined inside setupHOC().
 */ function $6171a3ee3f0cfb8d$var$onClickOutsideHOC(WrappedComponent, config) {
    var _class, _temp;
    var componentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
    return _temp = _class = /*#__PURE__*/ function(_Component) {
        $6171a3ee3f0cfb8d$var$_inheritsLoose(onClickOutside, _Component);
        function onClickOutside(props) {
            var _this;
            _this = _Component.call(this, props) || this;
            _this.__outsideClickHandler = function(event) {
                if (typeof _this.__clickOutsideHandlerProp === "function") {
                    _this.__clickOutsideHandlerProp(event);
                    return;
                }
                var instance = _this.getInstance();
                if (typeof instance.props.handleClickOutside === "function") {
                    instance.props.handleClickOutside(event);
                    return;
                }
                if (typeof instance.handleClickOutside === "function") {
                    instance.handleClickOutside(event);
                    return;
                }
                throw new Error("WrappedComponent: " + componentName + " lacks a handleClickOutside(event) function for processing outside click events.");
            };
            _this.__getComponentNode = function() {
                var instance = _this.getInstance();
                if (config && typeof config.setClickOutsideRef === "function") return config.setClickOutsideRef()(instance);
                if (typeof instance.setClickOutsideRef === "function") return instance.setClickOutsideRef();
                return (0, $cn1Kz.findDOMNode)(instance);
            };
            _this.enableOnClickOutside = function() {
                if (typeof document === "undefined" || $6171a3ee3f0cfb8d$var$enabledInstances[_this._uid]) return;
                if (typeof $6171a3ee3f0cfb8d$var$passiveEventSupport === "undefined") $6171a3ee3f0cfb8d$var$passiveEventSupport = $6171a3ee3f0cfb8d$var$testPassiveEventSupport();
                $6171a3ee3f0cfb8d$var$enabledInstances[_this._uid] = true;
                var events = _this.props.eventTypes;
                if (!events.forEach) events = [
                    events
                ];
                $6171a3ee3f0cfb8d$var$handlersMap[_this._uid] = function(event) {
                    if (_this.componentNode === null) return;
                    if (_this.initTimeStamp > event.timeStamp) return;
                    if (_this.props.preventDefault) event.preventDefault();
                    if (_this.props.stopPropagation) event.stopPropagation();
                    if (_this.props.excludeScrollbar && $6171a3ee3f0cfb8d$var$clickedScrollbar(event)) return;
                    var current = event.composed && event.composedPath && event.composedPath().shift() || event.target;
                    if ($6171a3ee3f0cfb8d$var$findHighest(current, _this.componentNode, _this.props.outsideClickIgnoreClass) !== document) return;
                    _this.__outsideClickHandler(event);
                };
                events.forEach(function(eventName) {
                    document.addEventListener(eventName, $6171a3ee3f0cfb8d$var$handlersMap[_this._uid], $6171a3ee3f0cfb8d$var$getEventHandlerOptions($6171a3ee3f0cfb8d$var$_assertThisInitialized(_this), eventName));
                });
            };
            _this.disableOnClickOutside = function() {
                delete $6171a3ee3f0cfb8d$var$enabledInstances[_this._uid];
                var fn = $6171a3ee3f0cfb8d$var$handlersMap[_this._uid];
                if (fn && typeof document !== "undefined") {
                    var events = _this.props.eventTypes;
                    if (!events.forEach) events = [
                        events
                    ];
                    events.forEach(function(eventName) {
                        return document.removeEventListener(eventName, fn, $6171a3ee3f0cfb8d$var$getEventHandlerOptions($6171a3ee3f0cfb8d$var$_assertThisInitialized(_this), eventName));
                    });
                    delete $6171a3ee3f0cfb8d$var$handlersMap[_this._uid];
                }
            };
            _this.getRef = function(ref) {
                return _this.instanceRef = ref;
            };
            _this._uid = $6171a3ee3f0cfb8d$var$uid();
            _this.initTimeStamp = performance.now();
            return _this;
        }
        /**
     * Access the WrappedComponent's instance.
     */ var _proto = onClickOutside.prototype;
        _proto.getInstance = function getInstance() {
            if (WrappedComponent.prototype && !WrappedComponent.prototype.isReactComponent) return this;
            var ref = this.instanceRef;
            return ref.getInstance ? ref.getInstance() : ref;
        };
        /**
     * Add click listeners to the current document,
     * linked to this component's state.
     */ _proto.componentDidMount = function componentDidMount() {
            // If we are in an environment without a DOM such
            // as shallow rendering or snapshots then we exit
            // early to prevent any unhandled errors being thrown.
            if (typeof document === "undefined" || !document.createElement) return;
            var instance = this.getInstance();
            if (config && typeof config.handleClickOutside === "function") {
                this.__clickOutsideHandlerProp = config.handleClickOutside(instance);
                if (typeof this.__clickOutsideHandlerProp !== "function") throw new Error("WrappedComponent: " + componentName + " lacks a function for processing outside click events specified by the handleClickOutside config option.");
            }
            this.componentNode = this.__getComponentNode(); // return early so we dont initiate onClickOutside
            if (this.props.disableOnClickOutside) return;
            this.enableOnClickOutside();
        };
        _proto.componentDidUpdate = function componentDidUpdate() {
            this.componentNode = this.__getComponentNode();
        } /**
     * Remove all document's event listeners for this component
     */ ;
        _proto.componentWillUnmount = function componentWillUnmount() {
            this.disableOnClickOutside();
        } /**
     * Can be called to explicitly enable event listening
     * for clicks and touches outside of this element.
     */ ;
        /**
     * Pass-through render
     */ _proto.render = function render() {
            // eslint-disable-next-line no-unused-vars
            var _this$props = this.props;
            _this$props.excludeScrollbar;
            var props = $6171a3ee3f0cfb8d$var$_objectWithoutPropertiesLoose(_this$props, [
                "excludeScrollbar"
            ]);
            if (WrappedComponent.prototype && WrappedComponent.prototype.isReactComponent) props.ref = this.getRef;
            else props.wrappedRef = this.getRef;
            props.disableOnClickOutside = this.disableOnClickOutside;
            props.enableOnClickOutside = this.enableOnClickOutside;
            return (0, $kc00y.createElement)(WrappedComponent, props);
        };
        return onClickOutside;
    }((0, $kc00y.Component)), _class.displayName = "OnClickOutside(" + componentName + ")", _class.defaultProps = {
        eventTypes: [
            "mousedown",
            "touchstart"
        ],
        excludeScrollbar: config && config.excludeScrollbar || false,
        outsideClickIgnoreClass: $6171a3ee3f0cfb8d$export$e2911fc69bd3195e,
        preventDefault: false,
        stopPropagation: false
    }, _class.getClass = function() {
        return WrappedComponent.getClass ? WrappedComponent.getClass() : WrappedComponent;
    }, _temp;
}
var $6171a3ee3f0cfb8d$export$2e2bcd8739ae039 = $6171a3ee3f0cfb8d$var$onClickOutsideHOC;

});

parcelRegister("cfq7u", function(module, exports) {

$parcel$export(module.exports, "useMergeRefs", () => $8eab25943f557f5c$export$74665b213cb5c4cf);
$parcel$export(module.exports, "FloatingList", () => $8eab25943f557f5c$export$ffe15b0e64951704);
$parcel$export(module.exports, "useListItem", () => $8eab25943f557f5c$export$dcdc7ff5149f7d1a);
$parcel$export(module.exports, "Composite", () => $8eab25943f557f5c$export$43586241d9db0c6d);
$parcel$export(module.exports, "CompositeItem", () => $8eab25943f557f5c$export$ef1ef7a3a43ace8e);
$parcel$export(module.exports, "useId", () => $8eab25943f557f5c$export$f680877a34711e37);
$parcel$export(module.exports, "FloatingArrow", () => $8eab25943f557f5c$export$33511391554732bc);
$parcel$export(module.exports, "useFloatingParentNodeId", () => $8eab25943f557f5c$export$165209eae06d3488);
$parcel$export(module.exports, "useFloatingTree", () => $8eab25943f557f5c$export$db0c2a7c7a2a4f69);
$parcel$export(module.exports, "useFloatingNodeId", () => $8eab25943f557f5c$export$9b136e0e758a42f4);
$parcel$export(module.exports, "FloatingNode", () => $8eab25943f557f5c$export$ca00a83b5b253862);
$parcel$export(module.exports, "FloatingTree", () => $8eab25943f557f5c$export$587b60129641c4c8);
$parcel$export(module.exports, "useHover", () => $8eab25943f557f5c$export$ae780daf29e6d456);
$parcel$export(module.exports, "useDelayGroupContext", () => $8eab25943f557f5c$export$e2411914b150383d);
$parcel$export(module.exports, "FloatingDelayGroup", () => $8eab25943f557f5c$export$718279509ff1e241);
$parcel$export(module.exports, "useDelayGroup", () => $8eab25943f557f5c$export$560fc8be89c8b4a8);
$parcel$export(module.exports, "useFloatingPortalNode", () => $8eab25943f557f5c$export$ac107512f3c5cca6);
$parcel$export(module.exports, "FloatingPortal", () => $8eab25943f557f5c$export$31fa5d718fa2ac09);
$parcel$export(module.exports, "FloatingFocusManager", () => $8eab25943f557f5c$export$8aeee49171ded61a);
$parcel$export(module.exports, "FloatingOverlay", () => $8eab25943f557f5c$export$a35954495955337b);
$parcel$export(module.exports, "useClick", () => $8eab25943f557f5c$export$98524f11226063fc);
$parcel$export(module.exports, "useClientPoint", () => $8eab25943f557f5c$export$7fe170a73a621816);
$parcel$export(module.exports, "useDismiss", () => $8eab25943f557f5c$export$fcdf1ba5fafc089b);
$parcel$export(module.exports, "useFloatingRootContext", () => $8eab25943f557f5c$export$1df81146f8ad8e4c);
$parcel$export(module.exports, "useFloating", () => $8eab25943f557f5c$export$4e02a5c1d08bac65);
$parcel$export(module.exports, "useFocus", () => $8eab25943f557f5c$export$f8168d8dd8fd66e6);
$parcel$export(module.exports, "useInteractions", () => $8eab25943f557f5c$export$a519f7794e446ddd);
$parcel$export(module.exports, "useListNavigation", () => $8eab25943f557f5c$export$b5d22cac4ad33f40);
$parcel$export(module.exports, "useRole", () => $8eab25943f557f5c$export$f66572793fa256a1);
$parcel$export(module.exports, "useTransitionStatus", () => $8eab25943f557f5c$export$b2ef21706733f7e5);
$parcel$export(module.exports, "useTransitionStyles", () => $8eab25943f557f5c$export$769fba13884bc2f4);
$parcel$export(module.exports, "useTypeahead", () => $8eab25943f557f5c$export$d8d674d50b73ba93);
$parcel$export(module.exports, "inner", () => $8eab25943f557f5c$export$4ae363f1d88fb658);
$parcel$export(module.exports, "useInnerOffset", () => $8eab25943f557f5c$export$3d74b0dda7cc82ff);
$parcel$export(module.exports, "safePolygon", () => $8eab25943f557f5c$export$7484214ab62358d2);
$parcel$export(module.exports, "arrow", () => (parcelRequire("jJYM0")).arrow);
$parcel$export(module.exports, "autoPlacement", () => (parcelRequire("jJYM0")).autoPlacement);
$parcel$export(module.exports, "autoUpdate", () => (parcelRequire("jRiwg")).autoUpdate);
$parcel$export(module.exports, "computePosition", () => (parcelRequire("jRiwg")).computePosition);
$parcel$export(module.exports, "detectOverflow", () => (parcelRequire("jRiwg")).detectOverflow);
$parcel$export(module.exports, "flip", () => (parcelRequire("jJYM0")).flip);
$parcel$export(module.exports, "getOverflowAncestors", () => (parcelRequire("gmW3q")).getOverflowAncestors);
$parcel$export(module.exports, "hide", () => (parcelRequire("jJYM0")).hide);
$parcel$export(module.exports, "inline", () => (parcelRequire("jJYM0")).inline);
$parcel$export(module.exports, "limitShift", () => (parcelRequire("jJYM0")).limitShift);
$parcel$export(module.exports, "offset", () => (parcelRequire("jJYM0")).offset);
$parcel$export(module.exports, "platform", () => (parcelRequire("jRiwg")).platform);
$parcel$export(module.exports, "shift", () => (parcelRequire("jJYM0")).shift);
$parcel$export(module.exports, "size", () => (parcelRequire("jJYM0")).size);

var $kc00y = parcelRequire("kc00y");

var $4vEIG = parcelRequire("4vEIG");

var $d9oMY = parcelRequire("d9oMY");

var $gmW3q = parcelRequire("gmW3q");

var $6uiEn = parcelRequire("6uiEn");

var $cn1Kz = parcelRequire("cn1Kz");

var $jJYM0 = parcelRequire("jJYM0");
var $jRiwg = parcelRequire("jRiwg");
var $jRiwg = parcelRequire("jRiwg");
var $gmW3q = parcelRequire("gmW3q");
/**
 * Merges an array of refs into a single memoized callback ref or `null`.
 * @see https://floating-ui.com/docs/react-utils#usemergerefs
 */ function $8eab25943f557f5c$export$74665b213cb5c4cf(refs) {
    return $kc00y.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (value)=>{
            refs.forEach((ref)=>{
                if (typeof ref === "function") ref(value);
                else if (ref != null) ref.current = value;
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}
// https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379
const $8eab25943f557f5c$var$SafeReact = {
    ...$kc00y
};
const $8eab25943f557f5c$var$useInsertionEffect = $8eab25943f557f5c$var$SafeReact.useInsertionEffect;
const $8eab25943f557f5c$var$useSafeInsertionEffect = $8eab25943f557f5c$var$useInsertionEffect || ((fn)=>fn());
function $8eab25943f557f5c$var$useEffectEvent(callback) {
    const ref = $kc00y.useRef(()=>{});
    $8eab25943f557f5c$var$useSafeInsertionEffect(()=>{
        ref.current = callback;
    });
    return $kc00y.useCallback(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return ref.current == null ? void 0 : ref.current(...args);
    }, []);
}
const $8eab25943f557f5c$var$ARROW_UP = "ArrowUp";
const $8eab25943f557f5c$var$ARROW_DOWN = "ArrowDown";
const $8eab25943f557f5c$var$ARROW_LEFT = "ArrowLeft";
const $8eab25943f557f5c$var$ARROW_RIGHT = "ArrowRight";
function $8eab25943f557f5c$var$isDifferentRow(index, cols, prevRow) {
    return Math.floor(index / cols) !== prevRow;
}
function $8eab25943f557f5c$var$isIndexOutOfBounds(listRef, index) {
    return index < 0 || index >= listRef.current.length;
}
function $8eab25943f557f5c$var$getMinIndex(listRef, disabledIndices) {
    return $8eab25943f557f5c$var$findNonDisabledIndex(listRef, {
        disabledIndices: disabledIndices
    });
}
function $8eab25943f557f5c$var$getMaxIndex(listRef, disabledIndices) {
    return $8eab25943f557f5c$var$findNonDisabledIndex(listRef, {
        decrement: true,
        startingIndex: listRef.current.length,
        disabledIndices: disabledIndices
    });
}
function $8eab25943f557f5c$var$findNonDisabledIndex(listRef, _temp) {
    let { startingIndex: startingIndex = -1, decrement: decrement = false, disabledIndices: disabledIndices, amount: amount = 1 } = _temp === void 0 ? {} : _temp;
    const list = listRef.current;
    let index = startingIndex;
    do index += decrement ? -amount : amount;
    while (index >= 0 && index <= list.length - 1 && $8eab25943f557f5c$var$isDisabled(list, index, disabledIndices));
    return index;
}
function $8eab25943f557f5c$var$getGridNavigatedIndex(elementsRef, _ref) {
    let { event: event, orientation: orientation, loop: loop, cols: cols, disabledIndices: disabledIndices, minIndex: minIndex, maxIndex: maxIndex, prevIndex: prevIndex, stopEvent: stop = false } = _ref;
    let nextIndex = prevIndex;
    if (event.key === $8eab25943f557f5c$var$ARROW_UP) {
        stop && (0, $4vEIG.stopEvent)(event);
        if (prevIndex === -1) nextIndex = maxIndex;
        else {
            nextIndex = $8eab25943f557f5c$var$findNonDisabledIndex(elementsRef, {
                startingIndex: nextIndex,
                amount: cols,
                decrement: true,
                disabledIndices: disabledIndices
            });
            if (loop && (prevIndex - cols < minIndex || nextIndex < 0)) {
                const col = prevIndex % cols;
                const maxCol = maxIndex % cols;
                const offset = maxIndex - (maxCol - col);
                if (maxCol === col) nextIndex = maxIndex;
                else nextIndex = maxCol > col ? offset : offset - cols;
            }
        }
        if ($8eab25943f557f5c$var$isIndexOutOfBounds(elementsRef, nextIndex)) nextIndex = prevIndex;
    }
    if (event.key === $8eab25943f557f5c$var$ARROW_DOWN) {
        stop && (0, $4vEIG.stopEvent)(event);
        if (prevIndex === -1) nextIndex = minIndex;
        else {
            nextIndex = $8eab25943f557f5c$var$findNonDisabledIndex(elementsRef, {
                startingIndex: prevIndex,
                amount: cols,
                disabledIndices: disabledIndices
            });
            if (loop && prevIndex + cols > maxIndex) nextIndex = $8eab25943f557f5c$var$findNonDisabledIndex(elementsRef, {
                startingIndex: prevIndex % cols - cols,
                amount: cols,
                disabledIndices: disabledIndices
            });
        }
        if ($8eab25943f557f5c$var$isIndexOutOfBounds(elementsRef, nextIndex)) nextIndex = prevIndex;
    }
    // Remains on the same row/column.
    if (orientation === "both") {
        const prevRow = (0, $d9oMY.floor)(prevIndex / cols);
        if (event.key === $8eab25943f557f5c$var$ARROW_RIGHT) {
            stop && (0, $4vEIG.stopEvent)(event);
            if (prevIndex % cols !== cols - 1) {
                nextIndex = $8eab25943f557f5c$var$findNonDisabledIndex(elementsRef, {
                    startingIndex: prevIndex,
                    disabledIndices: disabledIndices
                });
                if (loop && $8eab25943f557f5c$var$isDifferentRow(nextIndex, cols, prevRow)) nextIndex = $8eab25943f557f5c$var$findNonDisabledIndex(elementsRef, {
                    startingIndex: prevIndex - prevIndex % cols - 1,
                    disabledIndices: disabledIndices
                });
            } else if (loop) nextIndex = $8eab25943f557f5c$var$findNonDisabledIndex(elementsRef, {
                startingIndex: prevIndex - prevIndex % cols - 1,
                disabledIndices: disabledIndices
            });
            if ($8eab25943f557f5c$var$isDifferentRow(nextIndex, cols, prevRow)) nextIndex = prevIndex;
        }
        if (event.key === $8eab25943f557f5c$var$ARROW_LEFT) {
            stop && (0, $4vEIG.stopEvent)(event);
            if (prevIndex % cols !== 0) {
                nextIndex = $8eab25943f557f5c$var$findNonDisabledIndex(elementsRef, {
                    startingIndex: prevIndex,
                    decrement: true,
                    disabledIndices: disabledIndices
                });
                if (loop && $8eab25943f557f5c$var$isDifferentRow(nextIndex, cols, prevRow)) nextIndex = $8eab25943f557f5c$var$findNonDisabledIndex(elementsRef, {
                    startingIndex: prevIndex + (cols - prevIndex % cols),
                    decrement: true,
                    disabledIndices: disabledIndices
                });
            } else if (loop) nextIndex = $8eab25943f557f5c$var$findNonDisabledIndex(elementsRef, {
                startingIndex: prevIndex + (cols - prevIndex % cols),
                decrement: true,
                disabledIndices: disabledIndices
            });
            if ($8eab25943f557f5c$var$isDifferentRow(nextIndex, cols, prevRow)) nextIndex = prevIndex;
        }
        const lastRow = (0, $d9oMY.floor)(maxIndex / cols) === prevRow;
        if ($8eab25943f557f5c$var$isIndexOutOfBounds(elementsRef, nextIndex)) {
            if (loop && lastRow) nextIndex = event.key === $8eab25943f557f5c$var$ARROW_LEFT ? maxIndex : $8eab25943f557f5c$var$findNonDisabledIndex(elementsRef, {
                startingIndex: prevIndex - prevIndex % cols - 1,
                disabledIndices: disabledIndices
            });
            else nextIndex = prevIndex;
        }
    }
    return nextIndex;
}
/** For each cell index, gets the item index that occupies that cell */ function $8eab25943f557f5c$var$buildCellMap(sizes, cols, dense) {
    const cellMap = [];
    let startIndex = 0;
    sizes.forEach((_ref2, index)=>{
        let { width: width, height: height } = _ref2;
        let itemPlaced = false;
        if (dense) startIndex = 0;
        while(!itemPlaced){
            const targetCells = [];
            for(let i = 0; i < width; i++)for(let j = 0; j < height; j++)targetCells.push(startIndex + i + j * cols);
            if (startIndex % cols + width <= cols && targetCells.every((cell)=>cellMap[cell] == null)) {
                targetCells.forEach((cell)=>{
                    cellMap[cell] = index;
                });
                itemPlaced = true;
            } else startIndex++;
        }
    });
    // convert into a non-sparse array
    return [
        ...cellMap
    ];
}
/** Gets cell index of an item's corner or -1 when index is -1. */ function $8eab25943f557f5c$var$getCellIndexOfCorner(index, sizes, cellMap, cols, corner) {
    if (index === -1) return -1;
    const firstCellIndex = cellMap.indexOf(index);
    const sizeItem = sizes[index];
    switch(corner){
        case "tl":
            return firstCellIndex;
        case "tr":
            if (!sizeItem) return firstCellIndex;
            return firstCellIndex + sizeItem.width - 1;
        case "bl":
            if (!sizeItem) return firstCellIndex;
            return firstCellIndex + (sizeItem.height - 1) * cols;
        case "br":
            return cellMap.lastIndexOf(index);
    }
}
/** Gets all cell indices that correspond to the specified indices */ function $8eab25943f557f5c$var$getCellIndices(indices, cellMap) {
    return cellMap.flatMap((index, cellIndex)=>indices.includes(index) ? [
            cellIndex
        ] : []);
}
function $8eab25943f557f5c$var$isDisabled(list, index, disabledIndices) {
    if (disabledIndices) return disabledIndices.includes(index);
    const element = list[index];
    return element == null || element.hasAttribute("disabled") || element.getAttribute("aria-disabled") === "true";
}
let $8eab25943f557f5c$var$rafId = 0;
function $8eab25943f557f5c$var$enqueueFocus(el, options) {
    if (options === void 0) options = {};
    const { preventScroll: preventScroll = false, cancelPrevious: cancelPrevious = true, sync: sync = false } = options;
    cancelPrevious && cancelAnimationFrame($8eab25943f557f5c$var$rafId);
    const exec = ()=>el == null ? void 0 : el.focus({
            preventScroll: preventScroll
        });
    if (sync) exec();
    else $8eab25943f557f5c$var$rafId = requestAnimationFrame(exec);
}
var $8eab25943f557f5c$var$index = typeof document !== "undefined" ? (0, $kc00y.useLayoutEffect) : (0, $kc00y.useEffect);
function $8eab25943f557f5c$var$sortByDocumentPosition(a, b) {
    const position = a.compareDocumentPosition(b);
    if (position & Node.DOCUMENT_POSITION_FOLLOWING || position & Node.DOCUMENT_POSITION_CONTAINED_BY) return -1;
    if (position & Node.DOCUMENT_POSITION_PRECEDING || position & Node.DOCUMENT_POSITION_CONTAINS) return 1;
    return 0;
}
function $8eab25943f557f5c$var$areMapsEqual(map1, map2) {
    if (map1.size !== map2.size) return false;
    for (const [key, value] of map1.entries()){
        if (value !== map2.get(key)) return false;
    }
    return true;
}
const $8eab25943f557f5c$var$FloatingListContext = /*#__PURE__*/ $kc00y.createContext({
    register: ()=>{},
    unregister: ()=>{},
    map: /*#__PURE__*/ new Map(),
    elementsRef: {
        current: []
    }
});
/**
 * Provides context for a list of items within the floating element.
 * @see https://floating-ui.com/docs/FloatingList
 */ function $8eab25943f557f5c$export$ffe15b0e64951704(props) {
    const { children: children, elementsRef: elementsRef, labelsRef: labelsRef } = props;
    const [map, setMap] = $kc00y.useState(()=>new Map());
    const register = $kc00y.useCallback((node)=>{
        setMap((prevMap)=>new Map(prevMap).set(node, null));
    }, []);
    const unregister = $kc00y.useCallback((node)=>{
        setMap((prevMap)=>{
            const map = new Map(prevMap);
            map.delete(node);
            return map;
        });
    }, []);
    $8eab25943f557f5c$var$index(()=>{
        const newMap = new Map(map);
        const nodes = Array.from(newMap.keys()).sort($8eab25943f557f5c$var$sortByDocumentPosition);
        nodes.forEach((node, index)=>{
            newMap.set(node, index);
        });
        if (!$8eab25943f557f5c$var$areMapsEqual(map, newMap)) setMap(newMap);
    }, [
        map
    ]);
    return /*#__PURE__*/ $kc00y.createElement($8eab25943f557f5c$var$FloatingListContext.Provider, {
        value: $kc00y.useMemo(()=>({
                register: register,
                unregister: unregister,
                map: map,
                elementsRef: elementsRef,
                labelsRef: labelsRef
            }), [
            register,
            unregister,
            map,
            elementsRef,
            labelsRef
        ])
    }, children);
}
/**
 * Used to register a list item and its index (DOM position) in the
 * `FloatingList`.
 * @see https://floating-ui.com/docs/FloatingList#uselistitem
 */ function $8eab25943f557f5c$export$dcdc7ff5149f7d1a(props) {
    if (props === void 0) props = {};
    const { label: label } = props;
    const { register: register, unregister: unregister, map: map, elementsRef: elementsRef, labelsRef: labelsRef } = $kc00y.useContext($8eab25943f557f5c$var$FloatingListContext);
    const [index$1, setIndex] = $kc00y.useState(null);
    const componentRef = $kc00y.useRef(null);
    const ref = $kc00y.useCallback((node)=>{
        componentRef.current = node;
        if (index$1 !== null) {
            elementsRef.current[index$1] = node;
            if (labelsRef) {
                var _node$textContent;
                const isLabelDefined = label !== undefined;
                labelsRef.current[index$1] = isLabelDefined ? label : (_node$textContent = node == null ? void 0 : node.textContent) != null ? _node$textContent : null;
            }
        }
    }, [
        index$1,
        elementsRef,
        labelsRef,
        label
    ]);
    $8eab25943f557f5c$var$index(()=>{
        const node = componentRef.current;
        if (node) {
            register(node);
            return ()=>{
                unregister(node);
            };
        }
    }, [
        register,
        unregister
    ]);
    $8eab25943f557f5c$var$index(()=>{
        const index = componentRef.current ? map.get(componentRef.current) : null;
        if (index != null) setIndex(index);
    }, [
        map
    ]);
    return $kc00y.useMemo(()=>({
            ref: ref,
            index: index$1 == null ? -1 : index$1
        }), [
        index$1,
        ref
    ]);
}
function $8eab25943f557f5c$var$renderJsx(render, computedProps) {
    if (typeof render === "function") return render(computedProps);
    if (render) return /*#__PURE__*/ $kc00y.cloneElement(render, computedProps);
    return /*#__PURE__*/ $kc00y.createElement("div", computedProps);
}
const $8eab25943f557f5c$var$CompositeContext = /*#__PURE__*/ $kc00y.createContext({
    activeIndex: 0,
    onNavigate: ()=>{}
});
const $8eab25943f557f5c$var$horizontalKeys = [
    $8eab25943f557f5c$var$ARROW_LEFT,
    $8eab25943f557f5c$var$ARROW_RIGHT
];
const $8eab25943f557f5c$var$verticalKeys = [
    $8eab25943f557f5c$var$ARROW_UP,
    $8eab25943f557f5c$var$ARROW_DOWN
];
const $8eab25943f557f5c$var$allKeys = [
    ...$8eab25943f557f5c$var$horizontalKeys,
    ...$8eab25943f557f5c$var$verticalKeys
];
/**
 * Creates a single tab stop whose items are navigated by arrow keys, which
 * provides list navigation outside of floating element contexts.
 *
 * This is useful to enable navigation of a list of items that aren’t part of a
 * floating element. A menubar is an example of a composite, with each reference
 * element being an item.
 * @see https://floating-ui.com/docs/Composite
 */ const $8eab25943f557f5c$export$43586241d9db0c6d = /*#__PURE__*/ $kc00y.forwardRef(function Composite(props, forwardedRef) {
    const { render: render, orientation: orientation = "both", loop: loop = true, cols: cols = 1, disabledIndices: disabledIndices, activeIndex: externalActiveIndex, onNavigate: externalSetActiveIndex, itemSizes: itemSizes, dense: dense = false, ...domProps } = props;
    const [internalActiveIndex, internalSetActiveIndex] = $kc00y.useState(0);
    const activeIndex = externalActiveIndex != null ? externalActiveIndex : internalActiveIndex;
    const onNavigate = $8eab25943f557f5c$var$useEffectEvent(externalSetActiveIndex != null ? externalSetActiveIndex : internalSetActiveIndex);
    const elementsRef = $kc00y.useRef([]);
    const renderElementProps = render && typeof render !== "function" ? render.props : {};
    const contextValue = $kc00y.useMemo(()=>({
            activeIndex: activeIndex,
            onNavigate: onNavigate
        }), [
        activeIndex,
        onNavigate
    ]);
    const isGrid = cols > 1;
    function handleKeyDown(event) {
        if (!$8eab25943f557f5c$var$allKeys.includes(event.key)) return;
        let nextIndex = activeIndex;
        const minIndex = $8eab25943f557f5c$var$getMinIndex(elementsRef, disabledIndices);
        const maxIndex = $8eab25943f557f5c$var$getMaxIndex(elementsRef, disabledIndices);
        if (isGrid) {
            const sizes = itemSizes || Array.from({
                length: elementsRef.current.length
            }, ()=>({
                    width: 1,
                    height: 1
                }));
            // To calculate movements on the grid, we use hypothetical cell indices
            // as if every item was 1x1, then convert back to real indices.
            const cellMap = $8eab25943f557f5c$var$buildCellMap(sizes, cols, dense);
            const minGridIndex = cellMap.findIndex((index)=>index != null && !$8eab25943f557f5c$var$isDisabled(elementsRef.current, index, disabledIndices));
            // last enabled index
            const maxGridIndex = cellMap.reduce((foundIndex, index, cellIndex)=>index != null && !$8eab25943f557f5c$var$isDisabled(elementsRef.current, index, disabledIndices) ? cellIndex : foundIndex, -1);
            const maybeNextIndex = cellMap[$8eab25943f557f5c$var$getGridNavigatedIndex({
                current: cellMap.map((itemIndex)=>itemIndex ? elementsRef.current[itemIndex] : null)
            }, {
                event: event,
                orientation: orientation,
                loop: loop,
                cols: cols,
                // treat undefined (empty grid spaces) as disabled indices so we
                // don't end up in them
                disabledIndices: $8eab25943f557f5c$var$getCellIndices([
                    ...disabledIndices || elementsRef.current.map((_, index)=>$8eab25943f557f5c$var$isDisabled(elementsRef.current, index) ? index : undefined),
                    undefined
                ], cellMap),
                minIndex: minGridIndex,
                maxIndex: maxGridIndex,
                prevIndex: $8eab25943f557f5c$var$getCellIndexOfCorner(activeIndex > maxIndex ? minIndex : activeIndex, sizes, cellMap, cols, // use a corner matching the edge closest to the direction we're
                // moving in so we don't end up in the same item. Prefer
                // top/left over bottom/right.
                event.key === $8eab25943f557f5c$var$ARROW_DOWN ? "bl" : event.key === $8eab25943f557f5c$var$ARROW_RIGHT ? "tr" : "tl")
            })];
            if (maybeNextIndex != null) nextIndex = maybeNextIndex;
        }
        const toEndKeys = {
            horizontal: [
                $8eab25943f557f5c$var$ARROW_RIGHT
            ],
            vertical: [
                $8eab25943f557f5c$var$ARROW_DOWN
            ],
            both: [
                $8eab25943f557f5c$var$ARROW_RIGHT,
                $8eab25943f557f5c$var$ARROW_DOWN
            ]
        }[orientation];
        const toStartKeys = {
            horizontal: [
                $8eab25943f557f5c$var$ARROW_LEFT
            ],
            vertical: [
                $8eab25943f557f5c$var$ARROW_UP
            ],
            both: [
                $8eab25943f557f5c$var$ARROW_LEFT,
                $8eab25943f557f5c$var$ARROW_UP
            ]
        }[orientation];
        const preventedKeys = isGrid ? $8eab25943f557f5c$var$allKeys : ({
            horizontal: $8eab25943f557f5c$var$horizontalKeys,
            vertical: $8eab25943f557f5c$var$verticalKeys,
            both: $8eab25943f557f5c$var$allKeys
        })[orientation];
        if (nextIndex === activeIndex && [
            ...toEndKeys,
            ...toStartKeys
        ].includes(event.key)) {
            if (loop && nextIndex === maxIndex && toEndKeys.includes(event.key)) nextIndex = minIndex;
            else if (loop && nextIndex === minIndex && toStartKeys.includes(event.key)) nextIndex = maxIndex;
            else nextIndex = $8eab25943f557f5c$var$findNonDisabledIndex(elementsRef, {
                startingIndex: nextIndex,
                decrement: toStartKeys.includes(event.key),
                disabledIndices: disabledIndices
            });
        }
        if (nextIndex !== activeIndex && !$8eab25943f557f5c$var$isIndexOutOfBounds(elementsRef, nextIndex)) {
            event.stopPropagation();
            if (preventedKeys.includes(event.key)) event.preventDefault();
            onNavigate(nextIndex);
            // Wait for FocusManager `returnFocus` to execute.
            queueMicrotask(()=>{
                $8eab25943f557f5c$var$enqueueFocus(elementsRef.current[nextIndex]);
            });
        }
    }
    const computedProps = {
        ...domProps,
        ...renderElementProps,
        ref: forwardedRef,
        "aria-orientation": orientation === "both" ? undefined : orientation,
        onKeyDown (e) {
            domProps.onKeyDown == null || domProps.onKeyDown(e);
            renderElementProps.onKeyDown == null || renderElementProps.onKeyDown(e);
            handleKeyDown(e);
        }
    };
    return /*#__PURE__*/ $kc00y.createElement($8eab25943f557f5c$var$CompositeContext.Provider, {
        value: contextValue
    }, /*#__PURE__*/ $kc00y.createElement($8eab25943f557f5c$export$ffe15b0e64951704, {
        elementsRef: elementsRef
    }, $8eab25943f557f5c$var$renderJsx(render, computedProps)));
});
/**
 * @see https://floating-ui.com/docs/Composite
 */ const $8eab25943f557f5c$export$ef1ef7a3a43ace8e = /*#__PURE__*/ $kc00y.forwardRef(function CompositeItem(props, forwardedRef) {
    const { render: render, ...domProps } = props;
    const renderElementProps = render && typeof render !== "function" ? render.props : {};
    const { activeIndex: activeIndex, onNavigate: onNavigate } = $kc00y.useContext($8eab25943f557f5c$var$CompositeContext);
    const { ref: ref, index: index } = $8eab25943f557f5c$export$dcdc7ff5149f7d1a();
    const mergedRef = $8eab25943f557f5c$export$74665b213cb5c4cf([
        ref,
        forwardedRef,
        renderElementProps.ref
    ]);
    const isActive = activeIndex === index;
    const computedProps = {
        ...domProps,
        ...renderElementProps,
        ref: mergedRef,
        tabIndex: isActive ? 0 : -1,
        "data-active": isActive ? "" : undefined,
        onFocus (e) {
            domProps.onFocus == null || domProps.onFocus(e);
            renderElementProps.onFocus == null || renderElementProps.onFocus(e);
            onNavigate(index);
        }
    };
    return $8eab25943f557f5c$var$renderJsx(render, computedProps);
});
function $8eab25943f557f5c$var$_extends() {
    $8eab25943f557f5c$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $8eab25943f557f5c$var$_extends.apply(this, arguments);
}
let $8eab25943f557f5c$var$serverHandoffComplete = false;
let $8eab25943f557f5c$var$count = 0;
const $8eab25943f557f5c$var$genId = ()=>// on <React 18
    "floating-ui-" + Math.random().toString(36).slice(2, 6) + $8eab25943f557f5c$var$count++;
function $8eab25943f557f5c$var$useFloatingId() {
    const [id, setId] = $kc00y.useState(()=>$8eab25943f557f5c$var$serverHandoffComplete ? $8eab25943f557f5c$var$genId() : undefined);
    $8eab25943f557f5c$var$index(()=>{
        if (id == null) setId($8eab25943f557f5c$var$genId());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    $kc00y.useEffect(()=>{
        $8eab25943f557f5c$var$serverHandoffComplete = true;
    }, []);
    return id;
}
const $8eab25943f557f5c$var$useReactId = $8eab25943f557f5c$var$SafeReact.useId;
/**
 * Uses React 18's built-in `useId()` when available, or falls back to a
 * slightly less performant (requiring a double render) implementation for
 * earlier React versions.
 * @see https://floating-ui.com/docs/react-utils#useid
 */ const $8eab25943f557f5c$export$f680877a34711e37 = $8eab25943f557f5c$var$useReactId || $8eab25943f557f5c$var$useFloatingId;
let $8eab25943f557f5c$var$devMessageSet;
function $8eab25943f557f5c$var$warn() {
    var _devMessageSet;
    for(var _len = arguments.length, messages = new Array(_len), _key = 0; _key < _len; _key++)messages[_key] = arguments[_key];
    const message = "Floating UI: " + messages.join(" ");
    if (!((_devMessageSet = $8eab25943f557f5c$var$devMessageSet) != null && _devMessageSet.has(message))) {
        var _devMessageSet2;
        (_devMessageSet2 = $8eab25943f557f5c$var$devMessageSet) == null || _devMessageSet2.add(message);
        console.warn(message);
    }
}
function $8eab25943f557f5c$var$error() {
    var _devMessageSet3;
    for(var _len2 = arguments.length, messages = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)messages[_key2] = arguments[_key2];
    const message = "Floating UI: " + messages.join(" ");
    if (!((_devMessageSet3 = $8eab25943f557f5c$var$devMessageSet) != null && _devMessageSet3.has(message))) {
        var _devMessageSet4;
        (_devMessageSet4 = $8eab25943f557f5c$var$devMessageSet) == null || _devMessageSet4.add(message);
        console.error(message);
    }
}
/**
 * Renders a pointing arrow triangle.
 * @see https://floating-ui.com/docs/FloatingArrow
 */ const $8eab25943f557f5c$export$33511391554732bc = /*#__PURE__*/ $kc00y.forwardRef(function FloatingArrow(props, ref) {
    const { context: { placement: placement, elements: { floating: floating }, middlewareData: { arrow: arrow, shift: shift } }, width: width = 14, height: height = 7, tipRadius: tipRadius = 0, strokeWidth: strokeWidth = 0, staticOffset: staticOffset, stroke: stroke, d: d, style: { transform: transform, ...restStyle } = {}, ...rest } = props;
    const clipPathId = $8eab25943f557f5c$export$f680877a34711e37();
    const [isRTL, setIsRTL] = $kc00y.useState(false);
    // https://github.com/floating-ui/floating-ui/issues/2932
    $8eab25943f557f5c$var$index(()=>{
        if (!floating) return;
        const isRTL = (0, $gmW3q.getComputedStyle)(floating).direction === "rtl";
        if (isRTL) setIsRTL(true);
    }, [
        floating
    ]);
    if (!floating) return null;
    const [side, alignment] = placement.split("-");
    const isVerticalSide = side === "top" || side === "bottom";
    let computedStaticOffset = staticOffset;
    if (isVerticalSide && shift != null && shift.x || !isVerticalSide && shift != null && shift.y) computedStaticOffset = null;
    // Strokes must be double the border width, this ensures the stroke's width
    // works as you'd expect.
    const computedStrokeWidth = strokeWidth * 2;
    const halfStrokeWidth = computedStrokeWidth / 2;
    const svgX = width / 2 * (tipRadius / -8 + 1);
    const svgY = height / 2 * tipRadius / 4;
    const isCustomShape = !!d;
    const yOffsetProp = computedStaticOffset && alignment === "end" ? "bottom" : "top";
    let xOffsetProp = computedStaticOffset && alignment === "end" ? "right" : "left";
    if (computedStaticOffset && isRTL) xOffsetProp = alignment === "end" ? "left" : "right";
    const arrowX = (arrow == null ? void 0 : arrow.x) != null ? computedStaticOffset || arrow.x : "";
    const arrowY = (arrow == null ? void 0 : arrow.y) != null ? computedStaticOffset || arrow.y : "";
    const dValue = d || "M0,0" + (" H" + width) + (" L" + (width - svgX) + "," + (height - svgY)) + (" Q" + width / 2 + "," + height + " " + svgX + "," + (height - svgY)) + " Z";
    const rotation = {
        top: isCustomShape ? "rotate(180deg)" : "",
        left: isCustomShape ? "rotate(90deg)" : "rotate(-90deg)",
        bottom: isCustomShape ? "" : "rotate(180deg)",
        right: isCustomShape ? "rotate(-90deg)" : "rotate(90deg)"
    }[side];
    return /*#__PURE__*/ $kc00y.createElement("svg", $8eab25943f557f5c$var$_extends({}, rest, {
        "aria-hidden": true,
        ref: ref,
        width: isCustomShape ? width : width + computedStrokeWidth,
        height: width,
        viewBox: "0 0 " + width + " " + (height > width ? height : width),
        style: {
            position: "absolute",
            pointerEvents: "none",
            [xOffsetProp]: arrowX,
            [yOffsetProp]: arrowY,
            [side]: isVerticalSide || isCustomShape ? "100%" : "calc(100% - " + computedStrokeWidth / 2 + "px)",
            transform: [
                rotation,
                transform
            ].filter((t)=>!!t).join(" "),
            ...restStyle
        }
    }), computedStrokeWidth > 0 && /*#__PURE__*/ $kc00y.createElement("path", {
        clipPath: "url(#" + clipPathId + ")",
        fill: "none",
        stroke: stroke,
        strokeWidth: computedStrokeWidth + (d ? 0 : 1),
        d: dValue
    }), /*#__PURE__*/ $kc00y.createElement("path", {
        stroke: computedStrokeWidth && !d ? rest.fill : "none",
        d: dValue
    }), /*#__PURE__*/ $kc00y.createElement("clipPath", {
        id: clipPathId
    }, /*#__PURE__*/ $kc00y.createElement("rect", {
        x: -halfStrokeWidth,
        y: halfStrokeWidth * (isCustomShape ? -1 : 1),
        width: width + computedStrokeWidth,
        height: width
    })));
});
function $8eab25943f557f5c$var$createPubSub() {
    const map = new Map();
    return {
        emit (event, data) {
            var _map$get;
            (_map$get = map.get(event)) == null || _map$get.forEach((handler)=>handler(data));
        },
        on (event, listener) {
            map.set(event, [
                ...map.get(event) || [],
                listener
            ]);
        },
        off (event, listener) {
            var _map$get2;
            map.set(event, ((_map$get2 = map.get(event)) == null ? void 0 : _map$get2.filter((l)=>l !== listener)) || []);
        }
    };
}
const $8eab25943f557f5c$var$FloatingNodeContext = /*#__PURE__*/ $kc00y.createContext(null);
const $8eab25943f557f5c$var$FloatingTreeContext = /*#__PURE__*/ $kc00y.createContext(null);
/**
 * Returns the parent node id for nested floating elements, if available.
 * Returns `null` for top-level floating elements.
 */ const $8eab25943f557f5c$export$165209eae06d3488 = ()=>{
    var _React$useContext;
    return ((_React$useContext = $kc00y.useContext($8eab25943f557f5c$var$FloatingNodeContext)) == null ? void 0 : _React$useContext.id) || null;
};
/**
 * Returns the nearest floating tree context, if available.
 */ const $8eab25943f557f5c$export$db0c2a7c7a2a4f69 = ()=>$kc00y.useContext($8eab25943f557f5c$var$FloatingTreeContext);
/**
 * Registers a node into the `FloatingTree`, returning its id.
 * @see https://floating-ui.com/docs/FloatingTree
 */ function $8eab25943f557f5c$export$9b136e0e758a42f4(customParentId) {
    const id = $8eab25943f557f5c$export$f680877a34711e37();
    const tree = $8eab25943f557f5c$export$db0c2a7c7a2a4f69();
    const reactParentId = $8eab25943f557f5c$export$165209eae06d3488();
    const parentId = customParentId || reactParentId;
    $8eab25943f557f5c$var$index(()=>{
        const node = {
            id: id,
            parentId: parentId
        };
        tree == null || tree.addNode(node);
        return ()=>{
            tree == null || tree.removeNode(node);
        };
    }, [
        tree,
        id,
        parentId
    ]);
    return id;
}
/**
 * Provides parent node context for nested floating elements.
 * @see https://floating-ui.com/docs/FloatingTree
 */ function $8eab25943f557f5c$export$ca00a83b5b253862(props) {
    const { children: children, id: id } = props;
    const parentId = $8eab25943f557f5c$export$165209eae06d3488();
    return /*#__PURE__*/ $kc00y.createElement($8eab25943f557f5c$var$FloatingNodeContext.Provider, {
        value: $kc00y.useMemo(()=>({
                id: id,
                parentId: parentId
            }), [
            id,
            parentId
        ])
    }, children);
}
/**
 * Provides context for nested floating elements when they are not children of
 * each other on the DOM.
 * This is not necessary in all cases, except when there must be explicit communication between parent and child floating elements. It is necessary for:
 * - The `bubbles` option in the `useDismiss()` Hook
 * - Nested virtual list navigation
 * - Nested floating elements that each open on hover
 * - Custom communication between parent and child floating elements
 * @see https://floating-ui.com/docs/FloatingTree
 */ function $8eab25943f557f5c$export$587b60129641c4c8(props) {
    const { children: children } = props;
    const nodesRef = $kc00y.useRef([]);
    const addNode = $kc00y.useCallback((node)=>{
        nodesRef.current = [
            ...nodesRef.current,
            node
        ];
    }, []);
    const removeNode = $kc00y.useCallback((node)=>{
        nodesRef.current = nodesRef.current.filter((n)=>n !== node);
    }, []);
    const events = $kc00y.useState(()=>$8eab25943f557f5c$var$createPubSub())[0];
    return /*#__PURE__*/ $kc00y.createElement($8eab25943f557f5c$var$FloatingTreeContext.Provider, {
        value: $kc00y.useMemo(()=>({
                nodesRef: nodesRef,
                addNode: addNode,
                removeNode: removeNode,
                events: events
            }), [
            addNode,
            removeNode,
            events
        ])
    }, children);
}
function $8eab25943f557f5c$var$createAttribute(name) {
    return "data-floating-ui-" + name;
}
function $8eab25943f557f5c$var$useLatestRef(value) {
    const ref = (0, $kc00y.useRef)(value);
    $8eab25943f557f5c$var$index(()=>{
        ref.current = value;
    });
    return ref;
}
const $8eab25943f557f5c$var$safePolygonIdentifier = /*#__PURE__*/ $8eab25943f557f5c$var$createAttribute("safe-polygon");
function $8eab25943f557f5c$var$getDelay(value, prop, pointerType) {
    if (pointerType && !(0, $4vEIG.isMouseLikePointerType)(pointerType)) return 0;
    if (typeof value === "number") return value;
    return value == null ? void 0 : value[prop];
}
/**
 * Opens the floating element while hovering over the reference element, like
 * CSS `:hover`.
 * @see https://floating-ui.com/docs/useHover
 */ function $8eab25943f557f5c$export$ae780daf29e6d456(context, props) {
    if (props === void 0) props = {};
    const { open: open, onOpenChange: onOpenChange, dataRef: dataRef, events: events, elements: elements } = context;
    const { enabled: enabled = true, delay: delay = 0, handleClose: handleClose = null, mouseOnly: mouseOnly = false, restMs: restMs = 0, move: move = true } = props;
    const tree = $8eab25943f557f5c$export$db0c2a7c7a2a4f69();
    const parentId = $8eab25943f557f5c$export$165209eae06d3488();
    const handleCloseRef = $8eab25943f557f5c$var$useLatestRef(handleClose);
    const delayRef = $8eab25943f557f5c$var$useLatestRef(delay);
    const openRef = $8eab25943f557f5c$var$useLatestRef(open);
    const pointerTypeRef = $kc00y.useRef();
    const timeoutRef = $kc00y.useRef(-1);
    const handlerRef = $kc00y.useRef();
    const restTimeoutRef = $kc00y.useRef(-1);
    const blockMouseMoveRef = $kc00y.useRef(true);
    const performedPointerEventsMutationRef = $kc00y.useRef(false);
    const unbindMouseMoveRef = $kc00y.useRef(()=>{});
    const restTimeoutPendingRef = $kc00y.useRef(false);
    const isHoverOpen = $kc00y.useCallback(()=>{
        var _dataRef$current$open;
        const type = (_dataRef$current$open = dataRef.current.openEvent) == null ? void 0 : _dataRef$current$open.type;
        return (type == null ? void 0 : type.includes("mouse")) && type !== "mousedown";
    }, [
        dataRef
    ]);
    // When closing before opening, clear the delay timeouts to cancel it
    // from showing.
    $kc00y.useEffect(()=>{
        if (!enabled) return;
        function onOpenChange(_ref) {
            let { open: open } = _ref;
            if (!open) {
                clearTimeout(timeoutRef.current);
                clearTimeout(restTimeoutRef.current);
                blockMouseMoveRef.current = true;
                restTimeoutPendingRef.current = false;
            }
        }
        events.on("openchange", onOpenChange);
        return ()=>{
            events.off("openchange", onOpenChange);
        };
    }, [
        enabled,
        events
    ]);
    $kc00y.useEffect(()=>{
        if (!enabled) return;
        if (!handleCloseRef.current) return;
        if (!open) return;
        function onLeave(event) {
            if (isHoverOpen()) onOpenChange(false, event, "hover");
        }
        const html = (0, $4vEIG.getDocument)(elements.floating).documentElement;
        html.addEventListener("mouseleave", onLeave);
        return ()=>{
            html.removeEventListener("mouseleave", onLeave);
        };
    }, [
        elements.floating,
        open,
        onOpenChange,
        enabled,
        handleCloseRef,
        isHoverOpen
    ]);
    const closeWithDelay = $kc00y.useCallback(function(event, runElseBranch, reason) {
        if (runElseBranch === void 0) runElseBranch = true;
        if (reason === void 0) reason = "hover";
        const closeDelay = $8eab25943f557f5c$var$getDelay(delayRef.current, "close", pointerTypeRef.current);
        if (closeDelay && !handlerRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = window.setTimeout(()=>onOpenChange(false, event, reason), closeDelay);
        } else if (runElseBranch) {
            clearTimeout(timeoutRef.current);
            onOpenChange(false, event, reason);
        }
    }, [
        delayRef,
        onOpenChange
    ]);
    const cleanupMouseMoveHandler = $8eab25943f557f5c$var$useEffectEvent(()=>{
        unbindMouseMoveRef.current();
        handlerRef.current = undefined;
    });
    const clearPointerEvents = $8eab25943f557f5c$var$useEffectEvent(()=>{
        if (performedPointerEventsMutationRef.current) {
            const body = (0, $4vEIG.getDocument)(elements.floating).body;
            body.style.pointerEvents = "";
            body.removeAttribute($8eab25943f557f5c$var$safePolygonIdentifier);
            performedPointerEventsMutationRef.current = false;
        }
    });
    // Registering the mouse events on the reference directly to bypass React's
    // delegation system. If the cursor was on a disabled element and then entered
    // the reference (no gap), `mouseenter` doesn't fire in the delegation system.
    $kc00y.useEffect(()=>{
        if (!enabled) return;
        function isClickLikeOpenEvent() {
            return dataRef.current.openEvent ? [
                "click",
                "mousedown"
            ].includes(dataRef.current.openEvent.type) : false;
        }
        function onMouseEnter(event) {
            clearTimeout(timeoutRef.current);
            blockMouseMoveRef.current = false;
            if (mouseOnly && !(0, $4vEIG.isMouseLikePointerType)(pointerTypeRef.current) || restMs > 0 && !$8eab25943f557f5c$var$getDelay(delayRef.current, "open")) return;
            const openDelay = $8eab25943f557f5c$var$getDelay(delayRef.current, "open", pointerTypeRef.current);
            if (openDelay) timeoutRef.current = window.setTimeout(()=>{
                if (!openRef.current) onOpenChange(true, event, "hover");
            }, openDelay);
            else onOpenChange(true, event, "hover");
        }
        function onMouseLeave(event) {
            if (isClickLikeOpenEvent()) return;
            unbindMouseMoveRef.current();
            const doc = (0, $4vEIG.getDocument)(elements.floating);
            clearTimeout(restTimeoutRef.current);
            restTimeoutPendingRef.current = false;
            if (handleCloseRef.current && dataRef.current.floatingContext) {
                // Prevent clearing `onScrollMouseLeave` timeout.
                if (!open) clearTimeout(timeoutRef.current);
                handlerRef.current = handleCloseRef.current({
                    ...dataRef.current.floatingContext,
                    tree: tree,
                    x: event.clientX,
                    y: event.clientY,
                    onClose () {
                        clearPointerEvents();
                        cleanupMouseMoveHandler();
                        closeWithDelay(event, true, "safe-polygon");
                    }
                });
                const handler = handlerRef.current;
                doc.addEventListener("mousemove", handler);
                unbindMouseMoveRef.current = ()=>{
                    doc.removeEventListener("mousemove", handler);
                };
                return;
            }
            // Allow interactivity without `safePolygon` on touch devices. With a
            // pointer, a short close delay is an alternative, so it should work
            // consistently.
            const shouldClose = pointerTypeRef.current === "touch" ? !(0, $4vEIG.contains)(elements.floating, event.relatedTarget) : true;
            if (shouldClose) closeWithDelay(event);
        }
        // Ensure the floating element closes after scrolling even if the pointer
        // did not move.
        // https://github.com/floating-ui/floating-ui/discussions/1692
        function onScrollMouseLeave(event) {
            if (isClickLikeOpenEvent()) return;
            if (!dataRef.current.floatingContext) return;
            handleCloseRef.current == null || handleCloseRef.current({
                ...dataRef.current.floatingContext,
                tree: tree,
                x: event.clientX,
                y: event.clientY,
                onClose () {
                    clearPointerEvents();
                    cleanupMouseMoveHandler();
                    closeWithDelay(event);
                }
            })(event);
        }
        if ((0, $gmW3q.isElement)(elements.domReference)) {
            var _elements$floating;
            const ref = elements.domReference;
            open && ref.addEventListener("mouseleave", onScrollMouseLeave);
            (_elements$floating = elements.floating) == null || _elements$floating.addEventListener("mouseleave", onScrollMouseLeave);
            move && ref.addEventListener("mousemove", onMouseEnter, {
                once: true
            });
            ref.addEventListener("mouseenter", onMouseEnter);
            ref.addEventListener("mouseleave", onMouseLeave);
            return ()=>{
                var _elements$floating2;
                open && ref.removeEventListener("mouseleave", onScrollMouseLeave);
                (_elements$floating2 = elements.floating) == null || _elements$floating2.removeEventListener("mouseleave", onScrollMouseLeave);
                move && ref.removeEventListener("mousemove", onMouseEnter);
                ref.removeEventListener("mouseenter", onMouseEnter);
                ref.removeEventListener("mouseleave", onMouseLeave);
            };
        }
    }, [
        elements,
        enabled,
        context,
        mouseOnly,
        restMs,
        move,
        closeWithDelay,
        cleanupMouseMoveHandler,
        clearPointerEvents,
        onOpenChange,
        open,
        openRef,
        tree,
        delayRef,
        handleCloseRef,
        dataRef
    ]);
    // Block pointer-events of every element other than the reference and floating
    // while the floating element is open and has a `handleClose` handler. Also
    // handles nested floating elements.
    // https://github.com/floating-ui/floating-ui/issues/1722
    $8eab25943f557f5c$var$index(()=>{
        var _handleCloseRef$curre;
        if (!enabled) return;
        if (open && (_handleCloseRef$curre = handleCloseRef.current) != null && _handleCloseRef$curre.__options.blockPointerEvents && isHoverOpen()) {
            performedPointerEventsMutationRef.current = true;
            const floatingEl = elements.floating;
            if ((0, $gmW3q.isElement)(elements.domReference) && floatingEl) {
                var _tree$nodesRef$curren;
                const body = (0, $4vEIG.getDocument)(elements.floating).body;
                body.setAttribute($8eab25943f557f5c$var$safePolygonIdentifier, "");
                const ref = elements.domReference;
                const parentFloating = tree == null || (_tree$nodesRef$curren = tree.nodesRef.current.find((node)=>node.id === parentId)) == null || (_tree$nodesRef$curren = _tree$nodesRef$curren.context) == null ? void 0 : _tree$nodesRef$curren.elements.floating;
                if (parentFloating) parentFloating.style.pointerEvents = "";
                body.style.pointerEvents = "none";
                ref.style.pointerEvents = "auto";
                floatingEl.style.pointerEvents = "auto";
                return ()=>{
                    body.style.pointerEvents = "";
                    ref.style.pointerEvents = "";
                    floatingEl.style.pointerEvents = "";
                };
            }
        }
    }, [
        enabled,
        open,
        parentId,
        elements,
        tree,
        handleCloseRef,
        isHoverOpen
    ]);
    $8eab25943f557f5c$var$index(()=>{
        if (!open) {
            pointerTypeRef.current = undefined;
            restTimeoutPendingRef.current = false;
            cleanupMouseMoveHandler();
            clearPointerEvents();
        }
    }, [
        open,
        cleanupMouseMoveHandler,
        clearPointerEvents
    ]);
    $kc00y.useEffect(()=>{
        return ()=>{
            cleanupMouseMoveHandler();
            clearTimeout(timeoutRef.current);
            clearTimeout(restTimeoutRef.current);
            clearPointerEvents();
        };
    }, [
        enabled,
        elements.domReference,
        cleanupMouseMoveHandler,
        clearPointerEvents
    ]);
    const reference = $kc00y.useMemo(()=>{
        function setPointerRef(event) {
            pointerTypeRef.current = event.pointerType;
        }
        return {
            onPointerDown: setPointerRef,
            onPointerEnter: setPointerRef,
            onMouseMove (event) {
                const { nativeEvent: nativeEvent } = event;
                function handleMouseMove() {
                    if (!blockMouseMoveRef.current && !openRef.current) onOpenChange(true, nativeEvent, "hover");
                }
                if (mouseOnly && !(0, $4vEIG.isMouseLikePointerType)(pointerTypeRef.current)) return;
                if (open || restMs === 0) return;
                // Ignore insignificant movements to account for tremors.
                if (restTimeoutPendingRef.current && event.movementX ** 2 + event.movementY ** 2 < 2) return;
                clearTimeout(restTimeoutRef.current);
                if (pointerTypeRef.current === "touch") handleMouseMove();
                else {
                    restTimeoutPendingRef.current = true;
                    restTimeoutRef.current = window.setTimeout(handleMouseMove, restMs);
                }
            }
        };
    }, [
        mouseOnly,
        onOpenChange,
        open,
        openRef,
        restMs
    ]);
    const floating = $kc00y.useMemo(()=>({
            onMouseEnter () {
                clearTimeout(timeoutRef.current);
            },
            onMouseLeave (event) {
                closeWithDelay(event.nativeEvent, false);
            }
        }), [
        closeWithDelay
    ]);
    return $kc00y.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating
        } : {}, [
        enabled,
        reference,
        floating
    ]);
}
const $8eab25943f557f5c$var$NOOP = ()=>{};
const $8eab25943f557f5c$var$FloatingDelayGroupContext = /*#__PURE__*/ $kc00y.createContext({
    delay: 0,
    initialDelay: 0,
    timeoutMs: 0,
    currentId: null,
    setCurrentId: $8eab25943f557f5c$var$NOOP,
    setState: $8eab25943f557f5c$var$NOOP,
    isInstantPhase: false
});
/**
 * @deprecated
 * Use the return value of `useDelayGroup()` instead.
 */ const $8eab25943f557f5c$export$e2411914b150383d = ()=>$kc00y.useContext($8eab25943f557f5c$var$FloatingDelayGroupContext);
/**
 * Provides context for a group of floating elements that should share a
 * `delay`.
 * @see https://floating-ui.com/docs/FloatingDelayGroup
 */ function $8eab25943f557f5c$export$718279509ff1e241(props) {
    const { children: children, delay: delay, timeoutMs: timeoutMs = 0 } = props;
    const [state, setState] = $kc00y.useReducer((prev, next)=>({
            ...prev,
            ...next
        }), {
        delay: delay,
        timeoutMs: timeoutMs,
        initialDelay: delay,
        currentId: null,
        isInstantPhase: false
    });
    const initialCurrentIdRef = $kc00y.useRef(null);
    const setCurrentId = $kc00y.useCallback((currentId)=>{
        setState({
            currentId: currentId
        });
    }, []);
    $8eab25943f557f5c$var$index(()=>{
        if (state.currentId) {
            if (initialCurrentIdRef.current === null) initialCurrentIdRef.current = state.currentId;
            else if (!state.isInstantPhase) setState({
                isInstantPhase: true
            });
        } else {
            if (state.isInstantPhase) setState({
                isInstantPhase: false
            });
            initialCurrentIdRef.current = null;
        }
    }, [
        state.currentId,
        state.isInstantPhase
    ]);
    return /*#__PURE__*/ $kc00y.createElement($8eab25943f557f5c$var$FloatingDelayGroupContext.Provider, {
        value: $kc00y.useMemo(()=>({
                ...state,
                setState: setState,
                setCurrentId: setCurrentId
            }), [
            state,
            setCurrentId
        ])
    }, children);
}
/**
 * Enables grouping when called inside a component that's a child of a
 * `FloatingDelayGroup`.
 * @see https://floating-ui.com/docs/FloatingDelayGroup
 */ function $8eab25943f557f5c$export$560fc8be89c8b4a8(context, options) {
    if (options === void 0) options = {};
    const { open: open, onOpenChange: onOpenChange, floatingId: floatingId } = context;
    const { id: optionId, enabled: enabled = true } = options;
    const id = optionId != null ? optionId : floatingId;
    const groupContext = $8eab25943f557f5c$export$e2411914b150383d();
    const { currentId: currentId, setCurrentId: setCurrentId, initialDelay: initialDelay, setState: setState, timeoutMs: timeoutMs } = groupContext;
    $8eab25943f557f5c$var$index(()=>{
        if (!enabled) return;
        if (!currentId) return;
        setState({
            delay: {
                open: 1,
                close: $8eab25943f557f5c$var$getDelay(initialDelay, "close")
            }
        });
        if (currentId !== id) onOpenChange(false);
    }, [
        enabled,
        id,
        onOpenChange,
        setState,
        currentId,
        initialDelay
    ]);
    $8eab25943f557f5c$var$index(()=>{
        function unset() {
            onOpenChange(false);
            setState({
                delay: initialDelay,
                currentId: null
            });
        }
        if (!enabled) return;
        if (!currentId) return;
        if (!open && currentId === id) {
            if (timeoutMs) {
                const timeout = window.setTimeout(unset, timeoutMs);
                return ()=>{
                    clearTimeout(timeout);
                };
            }
            unset();
        }
    }, [
        enabled,
        open,
        setState,
        currentId,
        id,
        onOpenChange,
        initialDelay,
        timeoutMs
    ]);
    $8eab25943f557f5c$var$index(()=>{
        if (!enabled) return;
        if (setCurrentId === $8eab25943f557f5c$var$NOOP || !open) return;
        setCurrentId(id);
    }, [
        enabled,
        open,
        setCurrentId,
        id
    ]);
    return groupContext;
}
function $8eab25943f557f5c$var$getAncestors(nodes, id) {
    var _nodes$find;
    let allAncestors = [];
    let currentParentId = (_nodes$find = nodes.find((node)=>node.id === id)) == null ? void 0 : _nodes$find.parentId;
    while(currentParentId){
        const currentNode = nodes.find((node)=>node.id === currentParentId);
        currentParentId = currentNode == null ? void 0 : currentNode.parentId;
        if (currentNode) allAncestors = allAncestors.concat(currentNode);
    }
    return allAncestors;
}
function $8eab25943f557f5c$var$getChildren(nodes, id) {
    let allChildren = nodes.filter((node)=>{
        var _node$context;
        return node.parentId === id && ((_node$context = node.context) == null ? void 0 : _node$context.open);
    });
    let currentChildren = allChildren;
    while(currentChildren.length){
        currentChildren = nodes.filter((node)=>{
            var _currentChildren;
            return (_currentChildren = currentChildren) == null ? void 0 : _currentChildren.some((n)=>{
                var _node$context2;
                return node.parentId === n.id && ((_node$context2 = node.context) == null ? void 0 : _node$context2.open);
            });
        });
        allChildren = allChildren.concat(currentChildren);
    }
    return allChildren;
}
function $8eab25943f557f5c$var$getDeepestNode(nodes, id) {
    let deepestNodeId;
    let maxDepth = -1;
    function findDeepest(nodeId, depth) {
        if (depth > maxDepth) {
            deepestNodeId = nodeId;
            maxDepth = depth;
        }
        const children = $8eab25943f557f5c$var$getChildren(nodes, nodeId);
        children.forEach((child)=>{
            findDeepest(child.id, depth + 1);
        });
    }
    findDeepest(id, 0);
    return nodes.find((node)=>node.id === deepestNodeId);
}
// Modified to add conditional `aria-hidden` support:
// https://github.com/theKashey/aria-hidden/blob/9220c8f4a4fd35f63bee5510a9f41a37264382d4/src/index.ts
let $8eab25943f557f5c$var$counterMap = /*#__PURE__*/ new WeakMap();
let $8eab25943f557f5c$var$uncontrolledElementsSet = /*#__PURE__*/ new WeakSet();
let $8eab25943f557f5c$var$markerMap = {};
let $8eab25943f557f5c$var$lockCount$1 = 0;
const $8eab25943f557f5c$var$supportsInert = ()=>typeof HTMLElement !== "undefined" && "inert" in HTMLElement.prototype;
const $8eab25943f557f5c$var$unwrapHost = (node)=>node && (node.host || $8eab25943f557f5c$var$unwrapHost(node.parentNode));
const $8eab25943f557f5c$var$correctElements = (parent, targets)=>targets.map((target)=>{
        if (parent.contains(target)) return target;
        const correctedTarget = $8eab25943f557f5c$var$unwrapHost(target);
        if (parent.contains(correctedTarget)) return correctedTarget;
        return null;
    }).filter((x)=>x != null);
function $8eab25943f557f5c$var$applyAttributeToOthers(uncorrectedAvoidElements, body, ariaHidden, inert) {
    const markerName = "data-floating-ui-inert";
    const controlAttribute = inert ? "inert" : ariaHidden ? "aria-hidden" : null;
    const avoidElements = $8eab25943f557f5c$var$correctElements(body, uncorrectedAvoidElements);
    const elementsToKeep = new Set();
    const elementsToStop = new Set(avoidElements);
    const hiddenElements = [];
    if (!$8eab25943f557f5c$var$markerMap[markerName]) $8eab25943f557f5c$var$markerMap[markerName] = new WeakMap();
    const markerCounter = $8eab25943f557f5c$var$markerMap[markerName];
    avoidElements.forEach(keep);
    deep(body);
    elementsToKeep.clear();
    function keep(el) {
        if (!el || elementsToKeep.has(el)) return;
        elementsToKeep.add(el);
        el.parentNode && keep(el.parentNode);
    }
    function deep(parent) {
        if (!parent || elementsToStop.has(parent)) return;
        [].forEach.call(parent.children, (node)=>{
            if ((0, $gmW3q.getNodeName)(node) === "script") return;
            if (elementsToKeep.has(node)) deep(node);
            else {
                const attr = controlAttribute ? node.getAttribute(controlAttribute) : null;
                const alreadyHidden = attr !== null && attr !== "false";
                const counterValue = ($8eab25943f557f5c$var$counterMap.get(node) || 0) + 1;
                const markerValue = (markerCounter.get(node) || 0) + 1;
                $8eab25943f557f5c$var$counterMap.set(node, counterValue);
                markerCounter.set(node, markerValue);
                hiddenElements.push(node);
                if (counterValue === 1 && alreadyHidden) $8eab25943f557f5c$var$uncontrolledElementsSet.add(node);
                if (markerValue === 1) node.setAttribute(markerName, "");
                if (!alreadyHidden && controlAttribute) node.setAttribute(controlAttribute, "true");
            }
        });
    }
    $8eab25943f557f5c$var$lockCount$1++;
    return ()=>{
        hiddenElements.forEach((element)=>{
            const counterValue = ($8eab25943f557f5c$var$counterMap.get(element) || 0) - 1;
            const markerValue = (markerCounter.get(element) || 0) - 1;
            $8eab25943f557f5c$var$counterMap.set(element, counterValue);
            markerCounter.set(element, markerValue);
            if (!counterValue) {
                if (!$8eab25943f557f5c$var$uncontrolledElementsSet.has(element) && controlAttribute) element.removeAttribute(controlAttribute);
                $8eab25943f557f5c$var$uncontrolledElementsSet.delete(element);
            }
            if (!markerValue) element.removeAttribute(markerName);
        });
        $8eab25943f557f5c$var$lockCount$1--;
        if (!$8eab25943f557f5c$var$lockCount$1) {
            $8eab25943f557f5c$var$counterMap = new WeakMap();
            $8eab25943f557f5c$var$counterMap = new WeakMap();
            $8eab25943f557f5c$var$uncontrolledElementsSet = new WeakSet();
            $8eab25943f557f5c$var$markerMap = {};
        }
    };
}
function $8eab25943f557f5c$var$markOthers(avoidElements, ariaHidden, inert) {
    if (ariaHidden === void 0) ariaHidden = false;
    if (inert === void 0) inert = false;
    const body = (0, $4vEIG.getDocument)(avoidElements[0]).body;
    return $8eab25943f557f5c$var$applyAttributeToOthers(avoidElements.concat(Array.from(body.querySelectorAll("[aria-live]"))), body, ariaHidden, inert);
}
const $8eab25943f557f5c$var$getTabbableOptions = ()=>({
        getShadowRoot: true,
        displayCheck: // JSDOM does not support the `tabbable` library. To solve this we can
        // check if `ResizeObserver` is a real function (not polyfilled), which
        // determines if the current environment is JSDOM-like.
        typeof ResizeObserver === "function" && ResizeObserver.toString().includes("[native code]") ? "full" : "none"
    });
function $8eab25943f557f5c$var$getTabbableIn(container, direction) {
    const allTabbable = (0, $6uiEn.tabbable)(container, $8eab25943f557f5c$var$getTabbableOptions());
    if (direction === "prev") allTabbable.reverse();
    const activeIndex = allTabbable.indexOf((0, $4vEIG.activeElement)((0, $4vEIG.getDocument)(container)));
    const nextTabbableElements = allTabbable.slice(activeIndex + 1);
    return nextTabbableElements[0];
}
function $8eab25943f557f5c$var$getNextTabbable() {
    return $8eab25943f557f5c$var$getTabbableIn(document.body, "next");
}
function $8eab25943f557f5c$var$getPreviousTabbable() {
    return $8eab25943f557f5c$var$getTabbableIn(document.body, "prev");
}
function $8eab25943f557f5c$var$isOutsideEvent(event, container) {
    const containerElement = container || event.currentTarget;
    const relatedTarget = event.relatedTarget;
    return !relatedTarget || !(0, $4vEIG.contains)(containerElement, relatedTarget);
}
function $8eab25943f557f5c$var$disableFocusInside(container) {
    const tabbableElements = (0, $6uiEn.tabbable)(container, $8eab25943f557f5c$var$getTabbableOptions());
    tabbableElements.forEach((element)=>{
        element.dataset.tabindex = element.getAttribute("tabindex") || "";
        element.setAttribute("tabindex", "-1");
    });
}
function $8eab25943f557f5c$var$enableFocusInside(container) {
    const elements = container.querySelectorAll("[data-tabindex]");
    elements.forEach((element)=>{
        const tabindex = element.dataset.tabindex;
        delete element.dataset.tabindex;
        if (tabindex) element.setAttribute("tabindex", tabindex);
        else element.removeAttribute("tabindex");
    });
}
// See Diego Haz's Sandbox for making this logic work well on Safari/iOS:
// https://codesandbox.io/s/tabbable-portal-f4tng?file=/src/FocusTrap.tsx
const $8eab25943f557f5c$var$HIDDEN_STYLES = {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: "1px",
    margin: "-1px",
    overflow: "hidden",
    padding: 0,
    position: "fixed",
    whiteSpace: "nowrap",
    width: "1px",
    top: 0,
    left: 0
};
let $8eab25943f557f5c$var$timeoutId;
function $8eab25943f557f5c$var$setActiveElementOnTab(event) {
    if (event.key === "Tab") {
        event.target;
        clearTimeout($8eab25943f557f5c$var$timeoutId);
    }
}
const $8eab25943f557f5c$var$FocusGuard = /*#__PURE__*/ $kc00y.forwardRef(function FocusGuard(props, ref) {
    const [role, setRole] = $kc00y.useState();
    $8eab25943f557f5c$var$index(()=>{
        if ((0, $4vEIG.isSafari)()) // Unlike other screen readers such as NVDA and JAWS, the virtual cursor
        // on VoiceOver does trigger the onFocus event, so we can use the focus
        // trap element. On Safari, only buttons trigger the onFocus event.
        // NB: "group" role in the Sandbox no longer appears to work, must be a
        // button role.
        setRole("button");
        document.addEventListener("keydown", $8eab25943f557f5c$var$setActiveElementOnTab);
        return ()=>{
            document.removeEventListener("keydown", $8eab25943f557f5c$var$setActiveElementOnTab);
        };
    }, []);
    const restProps = {
        ref: ref,
        tabIndex: 0,
        role: // Role is only for VoiceOver
        role,
        "aria-hidden": role ? undefined : true,
        [$8eab25943f557f5c$var$createAttribute("focus-guard")]: "",
        style: $8eab25943f557f5c$var$HIDDEN_STYLES
    };
    return /*#__PURE__*/ $kc00y.createElement("span", $8eab25943f557f5c$var$_extends({}, props, restProps));
});
const $8eab25943f557f5c$var$PortalContext = /*#__PURE__*/ $kc00y.createContext(null);
const $8eab25943f557f5c$var$attr = /*#__PURE__*/ $8eab25943f557f5c$var$createAttribute("portal");
/**
 * @see https://floating-ui.com/docs/FloatingPortal#usefloatingportalnode
 */ function $8eab25943f557f5c$export$ac107512f3c5cca6(props) {
    if (props === void 0) props = {};
    const { id: id, root: root } = props;
    const uniqueId = $8eab25943f557f5c$export$f680877a34711e37();
    const portalContext = $8eab25943f557f5c$var$usePortalContext();
    const [portalNode, setPortalNode] = $kc00y.useState(null);
    const portalNodeRef = $kc00y.useRef(null);
    $8eab25943f557f5c$var$index(()=>{
        return ()=>{
            portalNode == null || portalNode.remove();
            // Allow the subsequent layout effects to create a new node on updates.
            // The portal node will still be cleaned up on unmount.
            // https://github.com/floating-ui/floating-ui/issues/2454
            queueMicrotask(()=>{
                portalNodeRef.current = null;
            });
        };
    }, [
        portalNode
    ]);
    $8eab25943f557f5c$var$index(()=>{
        // Wait for the uniqueId to be generated before creating the portal node in
        // React <18 (using `useFloatingId` instead of the native `useId`).
        // https://github.com/floating-ui/floating-ui/issues/2778
        if (!uniqueId) return;
        if (portalNodeRef.current) return;
        const existingIdRoot = id ? document.getElementById(id) : null;
        if (!existingIdRoot) return;
        const subRoot = document.createElement("div");
        subRoot.id = uniqueId;
        subRoot.setAttribute($8eab25943f557f5c$var$attr, "");
        existingIdRoot.appendChild(subRoot);
        portalNodeRef.current = subRoot;
        setPortalNode(subRoot);
    }, [
        id,
        uniqueId
    ]);
    $8eab25943f557f5c$var$index(()=>{
        if (!uniqueId) return;
        if (portalNodeRef.current) return;
        let container = root || (portalContext == null ? void 0 : portalContext.portalNode);
        if (container && !(0, $gmW3q.isElement)(container)) container = container.current;
        container = container || document.body;
        let idWrapper = null;
        if (id) {
            idWrapper = document.createElement("div");
            idWrapper.id = id;
            container.appendChild(idWrapper);
        }
        const subRoot = document.createElement("div");
        subRoot.id = uniqueId;
        subRoot.setAttribute($8eab25943f557f5c$var$attr, "");
        container = idWrapper || container;
        container.appendChild(subRoot);
        portalNodeRef.current = subRoot;
        setPortalNode(subRoot);
    }, [
        id,
        root,
        uniqueId,
        portalContext
    ]);
    return portalNode;
}
/**
 * Portals the floating element into a given container element — by default,
 * outside of the app root and into the body.
 * This is necessary to ensure the floating element can appear outside any
 * potential parent containers that cause clipping (such as `overflow: hidden`),
 * while retaining its location in the React tree.
 * @see https://floating-ui.com/docs/FloatingPortal
 */ function $8eab25943f557f5c$export$31fa5d718fa2ac09(props) {
    const { children: children, id: id, root: root = null, preserveTabOrder: preserveTabOrder = true } = props;
    const portalNode = $8eab25943f557f5c$export$ac107512f3c5cca6({
        id: id,
        root: root
    });
    const [focusManagerState, setFocusManagerState] = $kc00y.useState(null);
    const beforeOutsideRef = $kc00y.useRef(null);
    const afterOutsideRef = $kc00y.useRef(null);
    const beforeInsideRef = $kc00y.useRef(null);
    const afterInsideRef = $kc00y.useRef(null);
    const modal = focusManagerState == null ? void 0 : focusManagerState.modal;
    const open = focusManagerState == null ? void 0 : focusManagerState.open;
    const shouldRenderGuards = // The FocusManager and therefore floating element are currently open/
    // rendered.
    !!focusManagerState && // Guards are only for non-modal focus management.
    !focusManagerState.modal && // Don't render if unmount is transitioning.
    focusManagerState.open && preserveTabOrder && !!(root || portalNode);
    // https://codesandbox.io/s/tabbable-portal-f4tng?file=/src/TabbablePortal.tsx
    $kc00y.useEffect(()=>{
        if (!portalNode || !preserveTabOrder || modal) return;
        // Make sure elements inside the portal element are tabbable only when the
        // portal has already been focused, either by tabbing into a focus trap
        // element outside or using the mouse.
        function onFocus(event) {
            if (portalNode && $8eab25943f557f5c$var$isOutsideEvent(event)) {
                const focusing = event.type === "focusin";
                const manageFocus = focusing ? $8eab25943f557f5c$var$enableFocusInside : $8eab25943f557f5c$var$disableFocusInside;
                manageFocus(portalNode);
            }
        }
        // Listen to the event on the capture phase so they run before the focus
        // trap elements onFocus prop is called.
        portalNode.addEventListener("focusin", onFocus, true);
        portalNode.addEventListener("focusout", onFocus, true);
        return ()=>{
            portalNode.removeEventListener("focusin", onFocus, true);
            portalNode.removeEventListener("focusout", onFocus, true);
        };
    }, [
        portalNode,
        preserveTabOrder,
        modal
    ]);
    $kc00y.useEffect(()=>{
        if (!portalNode) return;
        if (open) return;
        $8eab25943f557f5c$var$enableFocusInside(portalNode);
    }, [
        open,
        portalNode
    ]);
    return /*#__PURE__*/ $kc00y.createElement($8eab25943f557f5c$var$PortalContext.Provider, {
        value: $kc00y.useMemo(()=>({
                preserveTabOrder: preserveTabOrder,
                beforeOutsideRef: beforeOutsideRef,
                afterOutsideRef: afterOutsideRef,
                beforeInsideRef: beforeInsideRef,
                afterInsideRef: afterInsideRef,
                portalNode: portalNode,
                setFocusManagerState: setFocusManagerState
            }), [
            preserveTabOrder,
            portalNode
        ])
    }, shouldRenderGuards && portalNode && /*#__PURE__*/ $kc00y.createElement($8eab25943f557f5c$var$FocusGuard, {
        "data-type": "outside",
        ref: beforeOutsideRef,
        onFocus: (event)=>{
            if ($8eab25943f557f5c$var$isOutsideEvent(event, portalNode)) {
                var _beforeInsideRef$curr;
                (_beforeInsideRef$curr = beforeInsideRef.current) == null || _beforeInsideRef$curr.focus();
            } else {
                const prevTabbable = $8eab25943f557f5c$var$getPreviousTabbable() || (focusManagerState == null ? void 0 : focusManagerState.refs.domReference.current);
                prevTabbable == null || prevTabbable.focus();
            }
        }
    }), shouldRenderGuards && portalNode && /*#__PURE__*/ $kc00y.createElement("span", {
        "aria-owns": portalNode.id,
        style: $8eab25943f557f5c$var$HIDDEN_STYLES
    }), portalNode && /*#__PURE__*/ $cn1Kz.createPortal(children, portalNode), shouldRenderGuards && portalNode && /*#__PURE__*/ $kc00y.createElement($8eab25943f557f5c$var$FocusGuard, {
        "data-type": "outside",
        ref: afterOutsideRef,
        onFocus: (event)=>{
            if ($8eab25943f557f5c$var$isOutsideEvent(event, portalNode)) {
                var _afterInsideRef$curre;
                (_afterInsideRef$curre = afterInsideRef.current) == null || _afterInsideRef$curre.focus();
            } else {
                const nextTabbable = $8eab25943f557f5c$var$getNextTabbable() || (focusManagerState == null ? void 0 : focusManagerState.refs.domReference.current);
                nextTabbable == null || nextTabbable.focus();
                (focusManagerState == null ? void 0 : focusManagerState.closeOnFocusOut) && (focusManagerState == null || focusManagerState.onOpenChange(false, event.nativeEvent, "focus-out"));
            }
        }
    }));
}
const $8eab25943f557f5c$var$usePortalContext = ()=>$kc00y.useContext($8eab25943f557f5c$var$PortalContext);
const $8eab25943f557f5c$var$FOCUSABLE_ATTRIBUTE = "data-floating-ui-focusable";
function $8eab25943f557f5c$var$getFloatingFocusElement(floatingElement) {
    if (!floatingElement) return null;
    // Try to find the element that has `{...getFloatingProps()}` spread on it.
    // This indicates the floating element is acting as a positioning wrapper, and
    // so focus should be managed on the child element with the event handlers and
    // aria props.
    return floatingElement.hasAttribute($8eab25943f557f5c$var$FOCUSABLE_ATTRIBUTE) ? floatingElement : floatingElement.querySelector("[" + $8eab25943f557f5c$var$FOCUSABLE_ATTRIBUTE + "]") || floatingElement;
}
const $8eab25943f557f5c$var$LIST_LIMIT = 20;
let $8eab25943f557f5c$var$previouslyFocusedElements = [];
function $8eab25943f557f5c$var$addPreviouslyFocusedElement(element) {
    $8eab25943f557f5c$var$previouslyFocusedElements = $8eab25943f557f5c$var$previouslyFocusedElements.filter((el)=>el.isConnected);
    let tabbableEl = element;
    if (!tabbableEl || (0, $gmW3q.getNodeName)(tabbableEl) === "body") return;
    if (!(0, $6uiEn.isTabbable)(tabbableEl, $8eab25943f557f5c$var$getTabbableOptions())) {
        const tabbableChild = (0, $6uiEn.tabbable)(tabbableEl, $8eab25943f557f5c$var$getTabbableOptions())[0];
        if (tabbableChild) tabbableEl = tabbableChild;
    }
    $8eab25943f557f5c$var$previouslyFocusedElements.push(tabbableEl);
    if ($8eab25943f557f5c$var$previouslyFocusedElements.length > $8eab25943f557f5c$var$LIST_LIMIT) $8eab25943f557f5c$var$previouslyFocusedElements = $8eab25943f557f5c$var$previouslyFocusedElements.slice(-$8eab25943f557f5c$var$LIST_LIMIT);
}
function $8eab25943f557f5c$var$getPreviouslyFocusedElement() {
    return $8eab25943f557f5c$var$previouslyFocusedElements.slice().reverse().find((el)=>el.isConnected);
}
const $8eab25943f557f5c$var$VisuallyHiddenDismiss = /*#__PURE__*/ $kc00y.forwardRef(function VisuallyHiddenDismiss(props, ref) {
    return /*#__PURE__*/ $kc00y.createElement("button", $8eab25943f557f5c$var$_extends({}, props, {
        type: "button",
        ref: ref,
        tabIndex: -1,
        style: $8eab25943f557f5c$var$HIDDEN_STYLES
    }));
});
/**
 * Provides focus management for the floating element.
 * @see https://floating-ui.com/docs/FloatingFocusManager
 */ function $8eab25943f557f5c$export$8aeee49171ded61a(props) {
    const { context: context, children: children, disabled: disabled = false, order: order = [
        "content"
    ], guards: _guards = true, initialFocus: initialFocus = 0, returnFocus: returnFocus = true, restoreFocus: restoreFocus = false, modal: modal = true, visuallyHiddenDismiss: visuallyHiddenDismiss = false, closeOnFocusOut: closeOnFocusOut = true } = props;
    const { open: open, refs: refs, nodeId: nodeId, onOpenChange: onOpenChange, events: events, dataRef: dataRef, floatingId: floatingId, elements: { domReference: domReference, floating: floating } } = context;
    const ignoreInitialFocus = typeof initialFocus === "number" && initialFocus < 0;
    // If the reference is a combobox and is typeable (e.g. input/textarea),
    // there are different focus semantics. The guards should not be rendered, but
    // aria-hidden should be applied to all nodes still. Further, the visually
    // hidden dismiss button should only appear at the end of the list, not the
    // start.
    const isUntrappedTypeableCombobox = (0, $4vEIG.isTypeableCombobox)(domReference) && ignoreInitialFocus;
    // Force the guards to be rendered if the `inert` attribute is not supported.
    const guards = $8eab25943f557f5c$var$supportsInert() ? _guards : true;
    const orderRef = $8eab25943f557f5c$var$useLatestRef(order);
    const initialFocusRef = $8eab25943f557f5c$var$useLatestRef(initialFocus);
    const returnFocusRef = $8eab25943f557f5c$var$useLatestRef(returnFocus);
    const tree = $8eab25943f557f5c$export$db0c2a7c7a2a4f69();
    const portalContext = $8eab25943f557f5c$var$usePortalContext();
    const startDismissButtonRef = $kc00y.useRef(null);
    const endDismissButtonRef = $kc00y.useRef(null);
    const preventReturnFocusRef = $kc00y.useRef(false);
    const isPointerDownRef = $kc00y.useRef(false);
    const tabbableIndexRef = $kc00y.useRef(-1);
    const isInsidePortal = portalContext != null;
    const floatingFocusElement = $8eab25943f557f5c$var$getFloatingFocusElement(floating);
    const getTabbableContent = $8eab25943f557f5c$var$useEffectEvent(function(container) {
        if (container === void 0) container = floatingFocusElement;
        return container ? (0, $6uiEn.tabbable)(container, $8eab25943f557f5c$var$getTabbableOptions()) : [];
    });
    const getTabbableElements = $8eab25943f557f5c$var$useEffectEvent((container)=>{
        const content = getTabbableContent(container);
        return orderRef.current.map((type)=>{
            if (domReference && type === "reference") return domReference;
            if (floatingFocusElement && type === "floating") return floatingFocusElement;
            return content;
        }).filter(Boolean).flat();
    });
    $kc00y.useEffect(()=>{
        preventReturnFocusRef.current = false;
    }, [
        disabled
    ]);
    $kc00y.useEffect(()=>{
        if (disabled) return;
        if (!modal) return;
        function onKeyDown(event) {
            if (event.key === "Tab") {
                // The focus guards have nothing to focus, so we need to stop the event.
                if ((0, $4vEIG.contains)(floatingFocusElement, (0, $4vEIG.activeElement)((0, $4vEIG.getDocument)(floatingFocusElement))) && getTabbableContent().length === 0 && !isUntrappedTypeableCombobox) (0, $4vEIG.stopEvent)(event);
                const els = getTabbableElements();
                const target = (0, $4vEIG.getTarget)(event);
                if (orderRef.current[0] === "reference" && target === domReference) {
                    (0, $4vEIG.stopEvent)(event);
                    if (event.shiftKey) $8eab25943f557f5c$var$enqueueFocus(els[els.length - 1]);
                    else $8eab25943f557f5c$var$enqueueFocus(els[1]);
                }
                if (orderRef.current[1] === "floating" && target === floatingFocusElement && event.shiftKey) {
                    (0, $4vEIG.stopEvent)(event);
                    $8eab25943f557f5c$var$enqueueFocus(els[0]);
                }
            }
        }
        const doc = (0, $4vEIG.getDocument)(floatingFocusElement);
        doc.addEventListener("keydown", onKeyDown);
        return ()=>{
            doc.removeEventListener("keydown", onKeyDown);
        };
    }, [
        disabled,
        domReference,
        floatingFocusElement,
        modal,
        orderRef,
        isUntrappedTypeableCombobox,
        getTabbableContent,
        getTabbableElements
    ]);
    $kc00y.useEffect(()=>{
        if (disabled) return;
        if (!floating) return;
        function handleFocusIn(event) {
            const target = (0, $4vEIG.getTarget)(event);
            const tabbableContent = getTabbableContent();
            const tabbableIndex = tabbableContent.indexOf(target);
            if (tabbableIndex !== -1) tabbableIndexRef.current = tabbableIndex;
        }
        floating.addEventListener("focusin", handleFocusIn);
        return ()=>{
            floating.removeEventListener("focusin", handleFocusIn);
        };
    }, [
        disabled,
        floating,
        getTabbableContent
    ]);
    $kc00y.useEffect(()=>{
        if (disabled) return;
        if (!closeOnFocusOut) return;
        // In Safari, buttons lose focus when pressing them.
        function handlePointerDown() {
            isPointerDownRef.current = true;
            setTimeout(()=>{
                isPointerDownRef.current = false;
            });
        }
        function handleFocusOutside(event) {
            const relatedTarget = event.relatedTarget;
            queueMicrotask(()=>{
                const movedToUnrelatedNode = !((0, $4vEIG.contains)(domReference, relatedTarget) || (0, $4vEIG.contains)(floating, relatedTarget) || (0, $4vEIG.contains)(relatedTarget, floating) || (0, $4vEIG.contains)(portalContext == null ? void 0 : portalContext.portalNode, relatedTarget) || relatedTarget != null && relatedTarget.hasAttribute($8eab25943f557f5c$var$createAttribute("focus-guard")) || tree && ($8eab25943f557f5c$var$getChildren(tree.nodesRef.current, nodeId).find((node)=>{
                    var _node$context, _node$context2;
                    return (0, $4vEIG.contains)((_node$context = node.context) == null ? void 0 : _node$context.elements.floating, relatedTarget) || (0, $4vEIG.contains)((_node$context2 = node.context) == null ? void 0 : _node$context2.elements.domReference, relatedTarget);
                }) || $8eab25943f557f5c$var$getAncestors(tree.nodesRef.current, nodeId).find((node)=>{
                    var _node$context3, _node$context4;
                    return ((_node$context3 = node.context) == null ? void 0 : _node$context3.elements.floating) === relatedTarget || ((_node$context4 = node.context) == null ? void 0 : _node$context4.elements.domReference) === relatedTarget;
                })));
                // Restore focus to the previous tabbable element index to prevent
                // focus from being lost outside the floating tree.
                if (restoreFocus && movedToUnrelatedNode && (0, $4vEIG.activeElement)((0, $4vEIG.getDocument)(floatingFocusElement)) === (0, $4vEIG.getDocument)(floatingFocusElement).body) {
                    // Let `FloatingPortal` effect knows that focus is still inside the
                    // floating tree.
                    if ((0, $gmW3q.isHTMLElement)(floatingFocusElement)) floatingFocusElement.focus();
                    const prevTabbableIndex = tabbableIndexRef.current;
                    const tabbableContent = getTabbableContent();
                    const nodeToFocus = tabbableContent[prevTabbableIndex] || tabbableContent[tabbableContent.length - 1] || floatingFocusElement;
                    if ((0, $gmW3q.isHTMLElement)(nodeToFocus)) nodeToFocus.focus();
                }
                // Focus did not move inside the floating tree, and there are no tabbable
                // portal guards to handle closing.
                if ((isUntrappedTypeableCombobox ? true : !modal) && relatedTarget && movedToUnrelatedNode && !isPointerDownRef.current && // Fix React 18 Strict Mode returnFocus due to double rendering.
                relatedTarget !== $8eab25943f557f5c$var$getPreviouslyFocusedElement()) {
                    preventReturnFocusRef.current = true;
                    onOpenChange(false, event, "focus-out");
                }
            });
        }
        if (floating && (0, $gmW3q.isHTMLElement)(domReference)) {
            domReference.addEventListener("focusout", handleFocusOutside);
            domReference.addEventListener("pointerdown", handlePointerDown);
            floating.addEventListener("focusout", handleFocusOutside);
            return ()=>{
                domReference.removeEventListener("focusout", handleFocusOutside);
                domReference.removeEventListener("pointerdown", handlePointerDown);
                floating.removeEventListener("focusout", handleFocusOutside);
            };
        }
    }, [
        disabled,
        domReference,
        floating,
        floatingFocusElement,
        modal,
        nodeId,
        tree,
        portalContext,
        onOpenChange,
        closeOnFocusOut,
        restoreFocus,
        getTabbableContent,
        isUntrappedTypeableCombobox
    ]);
    $kc00y.useEffect(()=>{
        var _portalContext$portal;
        if (disabled) return;
        // Don't hide portals nested within the parent portal.
        const portalNodes = Array.from((portalContext == null || (_portalContext$portal = portalContext.portalNode) == null ? void 0 : _portalContext$portal.querySelectorAll("[" + $8eab25943f557f5c$var$createAttribute("portal") + "]")) || []);
        if (floating) {
            const insideElements = [
                floating,
                ...portalNodes,
                startDismissButtonRef.current,
                endDismissButtonRef.current,
                orderRef.current.includes("reference") || isUntrappedTypeableCombobox ? domReference : null
            ].filter((x)=>x != null);
            const cleanup = modal || isUntrappedTypeableCombobox ? $8eab25943f557f5c$var$markOthers(insideElements, guards, !guards) : $8eab25943f557f5c$var$markOthers(insideElements);
            return ()=>{
                cleanup();
            };
        }
    }, [
        disabled,
        domReference,
        floating,
        modal,
        orderRef,
        portalContext,
        isUntrappedTypeableCombobox,
        guards
    ]);
    $8eab25943f557f5c$var$index(()=>{
        if (disabled || !(0, $gmW3q.isHTMLElement)(floatingFocusElement)) return;
        const doc = (0, $4vEIG.getDocument)(floatingFocusElement);
        const previouslyFocusedElement = (0, $4vEIG.activeElement)(doc);
        // Wait for any layout effect state setters to execute to set `tabIndex`.
        queueMicrotask(()=>{
            const focusableElements = getTabbableElements(floatingFocusElement);
            const initialFocusValue = initialFocusRef.current;
            const elToFocus = (typeof initialFocusValue === "number" ? focusableElements[initialFocusValue] : initialFocusValue.current) || floatingFocusElement;
            const focusAlreadyInsideFloatingEl = (0, $4vEIG.contains)(floatingFocusElement, previouslyFocusedElement);
            if (!ignoreInitialFocus && !focusAlreadyInsideFloatingEl && open) $8eab25943f557f5c$var$enqueueFocus(elToFocus, {
                preventScroll: elToFocus === floatingFocusElement
            });
        });
    }, [
        disabled,
        open,
        floatingFocusElement,
        ignoreInitialFocus,
        getTabbableElements,
        initialFocusRef
    ]);
    $8eab25943f557f5c$var$index(()=>{
        if (disabled || !floatingFocusElement) return;
        let preventReturnFocusScroll = false;
        const doc = (0, $4vEIG.getDocument)(floatingFocusElement);
        const previouslyFocusedElement = (0, $4vEIG.activeElement)(doc);
        const contextData = dataRef.current;
        let openEvent = contextData.openEvent;
        $8eab25943f557f5c$var$addPreviouslyFocusedElement(previouslyFocusedElement);
        // Dismissing via outside press should always ignore `returnFocus` to
        // prevent unwanted scrolling.
        function onOpenChange(_ref) {
            let { open: open, reason: reason, event: event, nested: nested } = _ref;
            if (open) openEvent = event;
            if (reason === "escape-key" && refs.domReference.current) $8eab25943f557f5c$var$addPreviouslyFocusedElement(refs.domReference.current);
            if (reason === "hover" && event.type === "mouseleave") preventReturnFocusRef.current = true;
            if (reason !== "outside-press") return;
            if (nested) {
                preventReturnFocusRef.current = false;
                preventReturnFocusScroll = true;
            } else preventReturnFocusRef.current = !((0, $4vEIG.isVirtualClick)(event) || (0, $4vEIG.isVirtualPointerEvent)(event));
        }
        events.on("openchange", onOpenChange);
        const fallbackEl = doc.createElement("span");
        fallbackEl.setAttribute("tabindex", "-1");
        fallbackEl.setAttribute("aria-hidden", "true");
        Object.assign(fallbackEl.style, $8eab25943f557f5c$var$HIDDEN_STYLES);
        if (isInsidePortal && domReference) domReference.insertAdjacentElement("afterend", fallbackEl);
        return ()=>{
            events.off("openchange", onOpenChange);
            const activeEl = (0, $4vEIG.activeElement)(doc);
            const isFocusInsideFloatingTree = (0, $4vEIG.contains)(floating, activeEl) || tree && $8eab25943f557f5c$var$getChildren(tree.nodesRef.current, nodeId).some((node)=>{
                var _node$context5;
                return (0, $4vEIG.contains)((_node$context5 = node.context) == null ? void 0 : _node$context5.elements.floating, activeEl);
            });
            const shouldFocusReference = isFocusInsideFloatingTree || openEvent && [
                "click",
                "mousedown"
            ].includes(openEvent.type);
            if (shouldFocusReference && refs.domReference.current) $8eab25943f557f5c$var$addPreviouslyFocusedElement(refs.domReference.current);
            const returnElement = $8eab25943f557f5c$var$getPreviouslyFocusedElement() || fallbackEl;
            queueMicrotask(()=>{
                if (// eslint-disable-next-line react-hooks/exhaustive-deps
                returnFocusRef.current && !preventReturnFocusRef.current && (0, $gmW3q.isHTMLElement)(returnElement) && // If the focus moved somewhere else after mount, avoid returning focus
                // since it likely entered a different element which should be
                // respected: https://github.com/floating-ui/floating-ui/issues/2607
                (returnElement !== activeEl && activeEl !== doc.body ? isFocusInsideFloatingTree : true)) returnElement.focus({
                    preventScroll: preventReturnFocusScroll
                });
                fallbackEl.remove();
            });
        };
    }, [
        disabled,
        floating,
        floatingFocusElement,
        returnFocusRef,
        dataRef,
        refs,
        events,
        tree,
        nodeId,
        isInsidePortal,
        domReference
    ]);
    // Synchronize the `context` & `modal` value to the FloatingPortal context.
    // It will decide whether or not it needs to render its own guards.
    $8eab25943f557f5c$var$index(()=>{
        if (disabled) return;
        if (!portalContext) return;
        portalContext.setFocusManagerState({
            modal: modal,
            closeOnFocusOut: closeOnFocusOut,
            open: open,
            onOpenChange: onOpenChange,
            refs: refs
        });
        return ()=>{
            portalContext.setFocusManagerState(null);
        };
    }, [
        disabled,
        portalContext,
        modal,
        open,
        onOpenChange,
        refs,
        closeOnFocusOut
    ]);
    $8eab25943f557f5c$var$index(()=>{
        if (disabled) return;
        if (!floatingFocusElement) return;
        if (typeof MutationObserver !== "function") return;
        if (ignoreInitialFocus) return;
        const handleMutation = ()=>{
            const tabIndex = floatingFocusElement.getAttribute("tabindex");
            const tabbableContent = getTabbableContent();
            const activeEl = (0, $4vEIG.activeElement)((0, $4vEIG.getDocument)(floating));
            const tabbableIndex = tabbableContent.indexOf(activeEl);
            if (tabbableIndex !== -1) tabbableIndexRef.current = tabbableIndex;
            if (orderRef.current.includes("floating") || activeEl !== refs.domReference.current && tabbableContent.length === 0) {
                if (tabIndex !== "0") floatingFocusElement.setAttribute("tabindex", "0");
            } else if (tabIndex !== "-1") floatingFocusElement.setAttribute("tabindex", "-1");
        };
        handleMutation();
        const observer = new MutationObserver(handleMutation);
        observer.observe(floatingFocusElement, {
            childList: true,
            subtree: true,
            attributes: true
        });
        return ()=>{
            observer.disconnect();
        };
    }, [
        disabled,
        floating,
        floatingFocusElement,
        refs,
        orderRef,
        getTabbableContent,
        ignoreInitialFocus
    ]);
    function renderDismissButton(location) {
        if (disabled || !visuallyHiddenDismiss || !modal) return null;
        return /*#__PURE__*/ $kc00y.createElement($8eab25943f557f5c$var$VisuallyHiddenDismiss, {
            ref: location === "start" ? startDismissButtonRef : endDismissButtonRef,
            onClick: (event)=>onOpenChange(false, event.nativeEvent)
        }, typeof visuallyHiddenDismiss === "string" ? visuallyHiddenDismiss : "Dismiss");
    }
    const shouldRenderGuards = !disabled && guards && (modal ? !isUntrappedTypeableCombobox : true) && (isInsidePortal || modal);
    return /*#__PURE__*/ $kc00y.createElement($kc00y.Fragment, null, shouldRenderGuards && /*#__PURE__*/ $kc00y.createElement($8eab25943f557f5c$var$FocusGuard, {
        "data-type": "inside",
        ref: portalContext == null ? void 0 : portalContext.beforeInsideRef,
        onFocus: (event)=>{
            if (modal) {
                const els = getTabbableElements();
                $8eab25943f557f5c$var$enqueueFocus(order[0] === "reference" ? els[0] : els[els.length - 1]);
            } else if (portalContext != null && portalContext.preserveTabOrder && portalContext.portalNode) {
                preventReturnFocusRef.current = false;
                if ($8eab25943f557f5c$var$isOutsideEvent(event, portalContext.portalNode)) {
                    const nextTabbable = $8eab25943f557f5c$var$getNextTabbable() || domReference;
                    nextTabbable == null || nextTabbable.focus();
                } else {
                    var _portalContext$before;
                    (_portalContext$before = portalContext.beforeOutsideRef.current) == null || _portalContext$before.focus();
                }
            }
        }
    }), !isUntrappedTypeableCombobox && renderDismissButton("start"), children, renderDismissButton("end"), shouldRenderGuards && /*#__PURE__*/ $kc00y.createElement($8eab25943f557f5c$var$FocusGuard, {
        "data-type": "inside",
        ref: portalContext == null ? void 0 : portalContext.afterInsideRef,
        onFocus: (event)=>{
            if (modal) $8eab25943f557f5c$var$enqueueFocus(getTabbableElements()[0]);
            else if (portalContext != null && portalContext.preserveTabOrder && portalContext.portalNode) {
                if (closeOnFocusOut) preventReturnFocusRef.current = true;
                if ($8eab25943f557f5c$var$isOutsideEvent(event, portalContext.portalNode)) {
                    const prevTabbable = $8eab25943f557f5c$var$getPreviousTabbable() || domReference;
                    prevTabbable == null || prevTabbable.focus();
                } else {
                    var _portalContext$afterO;
                    (_portalContext$afterO = portalContext.afterOutsideRef.current) == null || _portalContext$afterO.focus();
                }
            }
        }
    }));
}
let $8eab25943f557f5c$var$lockCount = 0;
function $8eab25943f557f5c$var$enableScrollLock() {
    const isIOS = /iP(hone|ad|od)|iOS/.test((0, $4vEIG.getPlatform)());
    const bodyStyle = document.body.style;
    // RTL <body> scrollbar
    const scrollbarX = Math.round(document.documentElement.getBoundingClientRect().left) + document.documentElement.scrollLeft;
    const paddingProp = scrollbarX ? "paddingLeft" : "paddingRight";
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    const scrollX = bodyStyle.left ? parseFloat(bodyStyle.left) : window.scrollX;
    const scrollY = bodyStyle.top ? parseFloat(bodyStyle.top) : window.scrollY;
    bodyStyle.overflow = "hidden";
    if (scrollbarWidth) bodyStyle[paddingProp] = scrollbarWidth + "px";
    // Only iOS doesn't respect `overflow: hidden` on document.body, and this
    // technique has fewer side effects.
    if (isIOS) {
        var _window$visualViewpor, _window$visualViewpor2;
        // iOS 12 does not support `visualViewport`.
        const offsetLeft = ((_window$visualViewpor = window.visualViewport) == null ? void 0 : _window$visualViewpor.offsetLeft) || 0;
        const offsetTop = ((_window$visualViewpor2 = window.visualViewport) == null ? void 0 : _window$visualViewpor2.offsetTop) || 0;
        Object.assign(bodyStyle, {
            position: "fixed",
            top: -(scrollY - Math.floor(offsetTop)) + "px",
            left: -(scrollX - Math.floor(offsetLeft)) + "px",
            right: "0"
        });
    }
    return ()=>{
        Object.assign(bodyStyle, {
            overflow: "",
            [paddingProp]: ""
        });
        if (isIOS) {
            Object.assign(bodyStyle, {
                position: "",
                top: "",
                left: "",
                right: ""
            });
            window.scrollTo(scrollX, scrollY);
        }
    };
}
let $8eab25943f557f5c$var$cleanup = ()=>{};
/**
 * Provides base styling for a fixed overlay element to dim content or block
 * pointer events behind a floating element.
 * It's a regular `<div>`, so it can be styled via any CSS solution you prefer.
 * @see https://floating-ui.com/docs/FloatingOverlay
 */ const $8eab25943f557f5c$export$a35954495955337b = /*#__PURE__*/ $kc00y.forwardRef(function FloatingOverlay(props, ref) {
    const { lockScroll: lockScroll = false, ...rest } = props;
    $8eab25943f557f5c$var$index(()=>{
        if (!lockScroll) return;
        $8eab25943f557f5c$var$lockCount++;
        if ($8eab25943f557f5c$var$lockCount === 1) $8eab25943f557f5c$var$cleanup = $8eab25943f557f5c$var$enableScrollLock();
        return ()=>{
            $8eab25943f557f5c$var$lockCount--;
            if ($8eab25943f557f5c$var$lockCount === 0) $8eab25943f557f5c$var$cleanup();
        };
    }, [
        lockScroll
    ]);
    return /*#__PURE__*/ $kc00y.createElement("div", $8eab25943f557f5c$var$_extends({
        ref: ref
    }, rest, {
        style: {
            position: "fixed",
            overflow: "auto",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            ...rest.style
        }
    }));
});
function $8eab25943f557f5c$var$isButtonTarget(event) {
    return (0, $gmW3q.isHTMLElement)(event.target) && event.target.tagName === "BUTTON";
}
function $8eab25943f557f5c$var$isSpaceIgnored(element) {
    return (0, $4vEIG.isTypeableElement)(element);
}
/**
 * Opens or closes the floating element when clicking the reference element.
 * @see https://floating-ui.com/docs/useClick
 */ function $8eab25943f557f5c$export$98524f11226063fc(context, props) {
    if (props === void 0) props = {};
    const { open: open, onOpenChange: onOpenChange, dataRef: dataRef, elements: { domReference: domReference } } = context;
    const { enabled: enabled = true, event: eventOption = "click", toggle: toggle = true, ignoreMouse: ignoreMouse = false, keyboardHandlers: keyboardHandlers = true } = props;
    const pointerTypeRef = $kc00y.useRef();
    const didKeyDownRef = $kc00y.useRef(false);
    const reference = $kc00y.useMemo(()=>({
            onPointerDown (event) {
                pointerTypeRef.current = event.pointerType;
            },
            onMouseDown (event) {
                const pointerType = pointerTypeRef.current;
                // Ignore all buttons except for the "main" button.
                // https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/button
                if (event.button !== 0) return;
                if (eventOption === "click") return;
                if ((0, $4vEIG.isMouseLikePointerType)(pointerType, true) && ignoreMouse) return;
                if (open && toggle && (dataRef.current.openEvent ? dataRef.current.openEvent.type === "mousedown" : true)) onOpenChange(false, event.nativeEvent, "click");
                else {
                    // Prevent stealing focus from the floating element
                    event.preventDefault();
                    onOpenChange(true, event.nativeEvent, "click");
                }
            },
            onClick (event) {
                const pointerType = pointerTypeRef.current;
                if (eventOption === "mousedown" && pointerTypeRef.current) {
                    pointerTypeRef.current = undefined;
                    return;
                }
                if ((0, $4vEIG.isMouseLikePointerType)(pointerType, true) && ignoreMouse) return;
                if (open && toggle && (dataRef.current.openEvent ? dataRef.current.openEvent.type === "click" : true)) onOpenChange(false, event.nativeEvent, "click");
                else onOpenChange(true, event.nativeEvent, "click");
            },
            onKeyDown (event) {
                pointerTypeRef.current = undefined;
                if (event.defaultPrevented || !keyboardHandlers || $8eab25943f557f5c$var$isButtonTarget(event)) return;
                if (event.key === " " && !$8eab25943f557f5c$var$isSpaceIgnored(domReference)) {
                    // Prevent scrolling
                    event.preventDefault();
                    didKeyDownRef.current = true;
                }
                if (event.key === "Enter") {
                    if (open && toggle) onOpenChange(false, event.nativeEvent, "click");
                    else onOpenChange(true, event.nativeEvent, "click");
                }
            },
            onKeyUp (event) {
                if (event.defaultPrevented || !keyboardHandlers || $8eab25943f557f5c$var$isButtonTarget(event) || $8eab25943f557f5c$var$isSpaceIgnored(domReference)) return;
                if (event.key === " " && didKeyDownRef.current) {
                    didKeyDownRef.current = false;
                    if (open && toggle) onOpenChange(false, event.nativeEvent, "click");
                    else onOpenChange(true, event.nativeEvent, "click");
                }
            }
        }), [
        dataRef,
        domReference,
        eventOption,
        ignoreMouse,
        keyboardHandlers,
        onOpenChange,
        open,
        toggle
    ]);
    return $kc00y.useMemo(()=>enabled ? {
            reference: reference
        } : {}, [
        enabled,
        reference
    ]);
}
function $8eab25943f557f5c$var$createVirtualElement(domElement, data) {
    let offsetX = null;
    let offsetY = null;
    let isAutoUpdateEvent = false;
    return {
        contextElement: domElement || undefined,
        getBoundingClientRect () {
            var _data$dataRef$current;
            const domRect = (domElement == null ? void 0 : domElement.getBoundingClientRect()) || {
                width: 0,
                height: 0,
                x: 0,
                y: 0
            };
            const isXAxis = data.axis === "x" || data.axis === "both";
            const isYAxis = data.axis === "y" || data.axis === "both";
            const canTrackCursorOnAutoUpdate = [
                "mouseenter",
                "mousemove"
            ].includes(((_data$dataRef$current = data.dataRef.current.openEvent) == null ? void 0 : _data$dataRef$current.type) || "") && data.pointerType !== "touch";
            let width = domRect.width;
            let height = domRect.height;
            let x = domRect.x;
            let y = domRect.y;
            if (offsetX == null && data.x && isXAxis) offsetX = domRect.x - data.x;
            if (offsetY == null && data.y && isYAxis) offsetY = domRect.y - data.y;
            x -= offsetX || 0;
            y -= offsetY || 0;
            width = 0;
            height = 0;
            if (!isAutoUpdateEvent || canTrackCursorOnAutoUpdate) {
                width = data.axis === "y" ? domRect.width : 0;
                height = data.axis === "x" ? domRect.height : 0;
                x = isXAxis && data.x != null ? data.x : x;
                y = isYAxis && data.y != null ? data.y : y;
            } else if (isAutoUpdateEvent && !canTrackCursorOnAutoUpdate) {
                height = data.axis === "x" ? domRect.height : height;
                width = data.axis === "y" ? domRect.width : width;
            }
            isAutoUpdateEvent = true;
            return {
                width: width,
                height: height,
                x: x,
                y: y,
                top: y,
                right: x + width,
                bottom: y + height,
                left: x
            };
        }
    };
}
function $8eab25943f557f5c$var$isMouseBasedEvent(event) {
    return event != null && event.clientX != null;
}
/**
 * Positions the floating element relative to a client point (in the viewport),
 * such as the mouse position. By default, it follows the mouse cursor.
 * @see https://floating-ui.com/docs/useClientPoint
 */ function $8eab25943f557f5c$export$7fe170a73a621816(context, props) {
    if (props === void 0) props = {};
    const { open: open, dataRef: dataRef, elements: { floating: floating, domReference: domReference }, refs: refs } = context;
    const { enabled: enabled = true, axis: axis = "both", x: x = null, y: y = null } = props;
    const initialRef = $kc00y.useRef(false);
    const cleanupListenerRef = $kc00y.useRef(null);
    const [pointerType, setPointerType] = $kc00y.useState();
    const [reactive, setReactive] = $kc00y.useState([]);
    const setReference = $8eab25943f557f5c$var$useEffectEvent((x, y)=>{
        if (initialRef.current) return;
        // Prevent setting if the open event was not a mouse-like one
        // (e.g. focus to open, then hover over the reference element).
        // Only apply if the event exists.
        if (dataRef.current.openEvent && !$8eab25943f557f5c$var$isMouseBasedEvent(dataRef.current.openEvent)) return;
        refs.setPositionReference($8eab25943f557f5c$var$createVirtualElement(domReference, {
            x: x,
            y: y,
            axis: axis,
            dataRef: dataRef,
            pointerType: pointerType
        }));
    });
    const handleReferenceEnterOrMove = $8eab25943f557f5c$var$useEffectEvent((event)=>{
        if (x != null || y != null) return;
        if (!open) setReference(event.clientX, event.clientY);
        else if (!cleanupListenerRef.current) // If there's no cleanup, there's no listener, but we want to ensure
        // we add the listener if the cursor landed on the floating element and
        // then back on the reference (i.e. it's interactive).
        setReactive([]);
    });
    // If the pointer is a mouse-like pointer, we want to continue following the
    // mouse even if the floating element is transitioning out. On touch
    // devices, this is undesirable because the floating element will move to
    // the dismissal touch point.
    const openCheck = (0, $4vEIG.isMouseLikePointerType)(pointerType) ? floating : open;
    const addListener = $kc00y.useCallback(()=>{
        // Explicitly specified `x`/`y` coordinates shouldn't add a listener.
        if (!openCheck || !enabled || x != null || y != null) return;
        const win = (0, $gmW3q.getWindow)(floating);
        function handleMouseMove(event) {
            const target = (0, $4vEIG.getTarget)(event);
            if (!(0, $4vEIG.contains)(floating, target)) setReference(event.clientX, event.clientY);
            else {
                win.removeEventListener("mousemove", handleMouseMove);
                cleanupListenerRef.current = null;
            }
        }
        if (!dataRef.current.openEvent || $8eab25943f557f5c$var$isMouseBasedEvent(dataRef.current.openEvent)) {
            win.addEventListener("mousemove", handleMouseMove);
            const cleanup = ()=>{
                win.removeEventListener("mousemove", handleMouseMove);
                cleanupListenerRef.current = null;
            };
            cleanupListenerRef.current = cleanup;
            return cleanup;
        }
        refs.setPositionReference(domReference);
    }, [
        openCheck,
        enabled,
        x,
        y,
        floating,
        dataRef,
        refs,
        domReference,
        setReference
    ]);
    $kc00y.useEffect(()=>{
        return addListener();
    }, [
        addListener,
        reactive
    ]);
    $kc00y.useEffect(()=>{
        if (enabled && !floating) initialRef.current = false;
    }, [
        enabled,
        floating
    ]);
    $kc00y.useEffect(()=>{
        if (!enabled && open) initialRef.current = true;
    }, [
        enabled,
        open
    ]);
    $8eab25943f557f5c$var$index(()=>{
        if (enabled && (x != null || y != null)) {
            initialRef.current = false;
            setReference(x, y);
        }
    }, [
        enabled,
        x,
        y,
        setReference
    ]);
    const reference = $kc00y.useMemo(()=>{
        function setPointerTypeRef(_ref) {
            let { pointerType: pointerType } = _ref;
            setPointerType(pointerType);
        }
        return {
            onPointerDown: setPointerTypeRef,
            onPointerEnter: setPointerTypeRef,
            onMouseMove: handleReferenceEnterOrMove,
            onMouseEnter: handleReferenceEnterOrMove
        };
    }, [
        handleReferenceEnterOrMove
    ]);
    return $kc00y.useMemo(()=>enabled ? {
            reference: reference
        } : {}, [
        enabled,
        reference
    ]);
}
const $8eab25943f557f5c$var$bubbleHandlerKeys = {
    pointerdown: "onPointerDown",
    mousedown: "onMouseDown",
    click: "onClick"
};
const $8eab25943f557f5c$var$captureHandlerKeys = {
    pointerdown: "onPointerDownCapture",
    mousedown: "onMouseDownCapture",
    click: "onClickCapture"
};
const $8eab25943f557f5c$var$normalizeProp = (normalizable)=>{
    var _normalizable$escapeK, _normalizable$outside;
    return {
        escapeKey: typeof normalizable === "boolean" ? normalizable : (_normalizable$escapeK = normalizable == null ? void 0 : normalizable.escapeKey) != null ? _normalizable$escapeK : false,
        outsidePress: typeof normalizable === "boolean" ? normalizable : (_normalizable$outside = normalizable == null ? void 0 : normalizable.outsidePress) != null ? _normalizable$outside : true
    };
};
/**
 * Closes the floating element when a dismissal is requested — by default, when
 * the user presses the `escape` key or outside of the floating element.
 * @see https://floating-ui.com/docs/useDismiss
 */ function $8eab25943f557f5c$export$fcdf1ba5fafc089b(context, props) {
    if (props === void 0) props = {};
    const { open: open, onOpenChange: onOpenChange, elements: elements, dataRef: dataRef } = context;
    const { enabled: enabled = true, escapeKey: escapeKey = true, outsidePress: unstable_outsidePress = true, outsidePressEvent: outsidePressEvent = "pointerdown", referencePress: referencePress = false, referencePressEvent: referencePressEvent = "pointerdown", ancestorScroll: ancestorScroll = false, bubbles: bubbles, capture: capture } = props;
    const tree = $8eab25943f557f5c$export$db0c2a7c7a2a4f69();
    const outsidePressFn = $8eab25943f557f5c$var$useEffectEvent(typeof unstable_outsidePress === "function" ? unstable_outsidePress : ()=>false);
    const outsidePress = typeof unstable_outsidePress === "function" ? outsidePressFn : unstable_outsidePress;
    const insideReactTreeRef = $kc00y.useRef(false);
    const endedOrStartedInsideRef = $kc00y.useRef(false);
    const { escapeKey: escapeKeyBubbles, outsidePress: outsidePressBubbles } = $8eab25943f557f5c$var$normalizeProp(bubbles);
    const { escapeKey: escapeKeyCapture, outsidePress: outsidePressCapture } = $8eab25943f557f5c$var$normalizeProp(capture);
    const isComposingRef = $kc00y.useRef(false);
    const closeOnEscapeKeyDown = $8eab25943f557f5c$var$useEffectEvent((event)=>{
        var _dataRef$current$floa;
        if (!open || !enabled || !escapeKey || event.key !== "Escape") return;
        // Wait until IME is settled. Pressing `Escape` while composing should
        // close the compose menu, but not the floating element.
        if (isComposingRef.current) return;
        const nodeId = (_dataRef$current$floa = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa.nodeId;
        const children = tree ? $8eab25943f557f5c$var$getChildren(tree.nodesRef.current, nodeId) : [];
        if (!escapeKeyBubbles) {
            event.stopPropagation();
            if (children.length > 0) {
                let shouldDismiss = true;
                children.forEach((child)=>{
                    var _child$context;
                    if ((_child$context = child.context) != null && _child$context.open && !child.context.dataRef.current.__escapeKeyBubbles) {
                        shouldDismiss = false;
                        return;
                    }
                });
                if (!shouldDismiss) return;
            }
        }
        onOpenChange(false, (0, $4vEIG.isReactEvent)(event) ? event.nativeEvent : event, "escape-key");
    });
    const closeOnEscapeKeyDownCapture = $8eab25943f557f5c$var$useEffectEvent((event)=>{
        var _getTarget2;
        const callback = ()=>{
            var _getTarget;
            closeOnEscapeKeyDown(event);
            (_getTarget = (0, $4vEIG.getTarget)(event)) == null || _getTarget.removeEventListener("keydown", callback);
        };
        (_getTarget2 = (0, $4vEIG.getTarget)(event)) == null || _getTarget2.addEventListener("keydown", callback);
    });
    const closeOnPressOutside = $8eab25943f557f5c$var$useEffectEvent((event)=>{
        var _dataRef$current$floa2;
        // Given developers can stop the propagation of the synthetic event,
        // we can only be confident with a positive value.
        const insideReactTree = insideReactTreeRef.current;
        insideReactTreeRef.current = false;
        // When click outside is lazy (`click` event), handle dragging.
        // Don't close if:
        // - The click started inside the floating element.
        // - The click ended inside the floating element.
        const endedOrStartedInside = endedOrStartedInsideRef.current;
        endedOrStartedInsideRef.current = false;
        if (outsidePressEvent === "click" && endedOrStartedInside) return;
        if (insideReactTree) return;
        if (typeof outsidePress === "function" && !outsidePress(event)) return;
        const target = (0, $4vEIG.getTarget)(event);
        const inertSelector = "[" + $8eab25943f557f5c$var$createAttribute("inert") + "]";
        const markers = (0, $4vEIG.getDocument)(elements.floating).querySelectorAll(inertSelector);
        let targetRootAncestor = (0, $gmW3q.isElement)(target) ? target : null;
        while(targetRootAncestor && !(0, $gmW3q.isLastTraversableNode)(targetRootAncestor)){
            const nextParent = (0, $gmW3q.getParentNode)(targetRootAncestor);
            if ((0, $gmW3q.isLastTraversableNode)(nextParent) || !(0, $gmW3q.isElement)(nextParent)) break;
            targetRootAncestor = nextParent;
        }
        // Check if the click occurred on a third-party element injected after the
        // floating element rendered.
        if (markers.length && (0, $gmW3q.isElement)(target) && !(0, $4vEIG.isRootElement)(target) && // Clicked on a direct ancestor (e.g. FloatingOverlay).
        !(0, $4vEIG.contains)(target, elements.floating) && // If the target root element contains none of the markers, then the
        // element was injected after the floating element rendered.
        Array.from(markers).every((marker)=>!(0, $4vEIG.contains)(targetRootAncestor, marker))) return;
        // Check if the click occurred on the scrollbar
        if ((0, $gmW3q.isHTMLElement)(target) && floating) {
            // In Firefox, `target.scrollWidth > target.clientWidth` for inline
            // elements.
            const canScrollX = target.clientWidth > 0 && target.scrollWidth > target.clientWidth;
            const canScrollY = target.clientHeight > 0 && target.scrollHeight > target.clientHeight;
            let xCond = canScrollY && event.offsetX > target.clientWidth;
            // In some browsers it is possible to change the <body> (or window)
            // scrollbar to the left side, but is very rare and is difficult to
            // check for. Plus, for modal dialogs with backdrops, it is more
            // important that the backdrop is checked but not so much the window.
            if (canScrollY) {
                const isRTL = (0, $gmW3q.getComputedStyle)(target).direction === "rtl";
                if (isRTL) xCond = event.offsetX <= target.offsetWidth - target.clientWidth;
            }
            if (xCond || canScrollX && event.offsetY > target.clientHeight) return;
        }
        const nodeId = (_dataRef$current$floa2 = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa2.nodeId;
        const targetIsInsideChildren = tree && $8eab25943f557f5c$var$getChildren(tree.nodesRef.current, nodeId).some((node)=>{
            var _node$context;
            return (0, $4vEIG.isEventTargetWithin)(event, (_node$context = node.context) == null ? void 0 : _node$context.elements.floating);
        });
        if ((0, $4vEIG.isEventTargetWithin)(event, elements.floating) || (0, $4vEIG.isEventTargetWithin)(event, elements.domReference) || targetIsInsideChildren) return;
        const children = tree ? $8eab25943f557f5c$var$getChildren(tree.nodesRef.current, nodeId) : [];
        if (children.length > 0) {
            let shouldDismiss = true;
            children.forEach((child)=>{
                var _child$context2;
                if ((_child$context2 = child.context) != null && _child$context2.open && !child.context.dataRef.current.__outsidePressBubbles) {
                    shouldDismiss = false;
                    return;
                }
            });
            if (!shouldDismiss) return;
        }
        onOpenChange(false, event, "outside-press");
    });
    const closeOnPressOutsideCapture = $8eab25943f557f5c$var$useEffectEvent((event)=>{
        var _getTarget4;
        const callback = ()=>{
            var _getTarget3;
            closeOnPressOutside(event);
            (_getTarget3 = (0, $4vEIG.getTarget)(event)) == null || _getTarget3.removeEventListener(outsidePressEvent, callback);
        };
        (_getTarget4 = (0, $4vEIG.getTarget)(event)) == null || _getTarget4.addEventListener(outsidePressEvent, callback);
    });
    $kc00y.useEffect(()=>{
        if (!open || !enabled) return;
        dataRef.current.__escapeKeyBubbles = escapeKeyBubbles;
        dataRef.current.__outsidePressBubbles = outsidePressBubbles;
        let compositionTimeout = -1;
        function onScroll(event) {
            onOpenChange(false, event, "ancestor-scroll");
        }
        function handleCompositionStart() {
            window.clearTimeout(compositionTimeout);
            isComposingRef.current = true;
        }
        function handleCompositionEnd() {
            // Safari fires `compositionend` before `keydown`, so we need to wait
            // until the next tick to set `isComposing` to `false`.
            // https://bugs.webkit.org/show_bug.cgi?id=165004
            compositionTimeout = window.setTimeout(()=>{
                isComposingRef.current = false;
            }, // 0ms or 1ms don't work in Safari. 5ms appears to consistently work.
            // Only apply to WebKit for the test to remain 0ms.
            (0, $gmW3q.isWebKit)() ? 5 : 0);
        }
        const doc = (0, $4vEIG.getDocument)(elements.floating);
        if (escapeKey) {
            doc.addEventListener("keydown", escapeKeyCapture ? closeOnEscapeKeyDownCapture : closeOnEscapeKeyDown, escapeKeyCapture);
            doc.addEventListener("compositionstart", handleCompositionStart);
            doc.addEventListener("compositionend", handleCompositionEnd);
        }
        outsidePress && doc.addEventListener(outsidePressEvent, outsidePressCapture ? closeOnPressOutsideCapture : closeOnPressOutside, outsidePressCapture);
        let ancestors = [];
        if (ancestorScroll) {
            if ((0, $gmW3q.isElement)(elements.domReference)) ancestors = (0, $gmW3q.getOverflowAncestors)(elements.domReference);
            if ((0, $gmW3q.isElement)(elements.floating)) ancestors = ancestors.concat((0, $gmW3q.getOverflowAncestors)(elements.floating));
            if (!(0, $gmW3q.isElement)(elements.reference) && elements.reference && elements.reference.contextElement) ancestors = ancestors.concat((0, $gmW3q.getOverflowAncestors)(elements.reference.contextElement));
        }
        // Ignore the visual viewport for scrolling dismissal (allow pinch-zoom)
        ancestors = ancestors.filter((ancestor)=>{
            var _doc$defaultView;
            return ancestor !== ((_doc$defaultView = doc.defaultView) == null ? void 0 : _doc$defaultView.visualViewport);
        });
        ancestors.forEach((ancestor)=>{
            ancestor.addEventListener("scroll", onScroll, {
                passive: true
            });
        });
        return ()=>{
            if (escapeKey) {
                doc.removeEventListener("keydown", escapeKeyCapture ? closeOnEscapeKeyDownCapture : closeOnEscapeKeyDown, escapeKeyCapture);
                doc.removeEventListener("compositionstart", handleCompositionStart);
                doc.removeEventListener("compositionend", handleCompositionEnd);
            }
            outsidePress && doc.removeEventListener(outsidePressEvent, outsidePressCapture ? closeOnPressOutsideCapture : closeOnPressOutside, outsidePressCapture);
            ancestors.forEach((ancestor)=>{
                ancestor.removeEventListener("scroll", onScroll);
            });
            window.clearTimeout(compositionTimeout);
        };
    }, [
        dataRef,
        elements,
        escapeKey,
        outsidePress,
        outsidePressEvent,
        open,
        onOpenChange,
        ancestorScroll,
        enabled,
        escapeKeyBubbles,
        outsidePressBubbles,
        closeOnEscapeKeyDown,
        escapeKeyCapture,
        closeOnEscapeKeyDownCapture,
        closeOnPressOutside,
        outsidePressCapture,
        closeOnPressOutsideCapture
    ]);
    $kc00y.useEffect(()=>{
        insideReactTreeRef.current = false;
    }, [
        outsidePress,
        outsidePressEvent
    ]);
    const reference = $kc00y.useMemo(()=>({
            onKeyDown: closeOnEscapeKeyDown,
            [$8eab25943f557f5c$var$bubbleHandlerKeys[referencePressEvent]]: (event)=>{
                if (referencePress) onOpenChange(false, event.nativeEvent, "reference-press");
            }
        }), [
        closeOnEscapeKeyDown,
        onOpenChange,
        referencePress,
        referencePressEvent
    ]);
    const floating = $kc00y.useMemo(()=>({
            onKeyDown: closeOnEscapeKeyDown,
            onMouseDown () {
                endedOrStartedInsideRef.current = true;
            },
            onMouseUp () {
                endedOrStartedInsideRef.current = true;
            },
            [$8eab25943f557f5c$var$captureHandlerKeys[outsidePressEvent]]: ()=>{
                insideReactTreeRef.current = true;
            }
        }), [
        closeOnEscapeKeyDown,
        outsidePressEvent
    ]);
    return $kc00y.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating
        } : {}, [
        enabled,
        reference,
        floating
    ]);
}
function $8eab25943f557f5c$export$1df81146f8ad8e4c(options) {
    const { open: open = false, onOpenChange: onOpenChangeProp, elements: elementsProp } = options;
    const floatingId = $8eab25943f557f5c$export$f680877a34711e37();
    const dataRef = $kc00y.useRef({});
    const [events] = $kc00y.useState(()=>$8eab25943f557f5c$var$createPubSub());
    const nested = $8eab25943f557f5c$export$165209eae06d3488() != null;
    const [positionReference, setPositionReference] = $kc00y.useState(elementsProp.reference);
    const onOpenChange = $8eab25943f557f5c$var$useEffectEvent((open, event, reason)=>{
        dataRef.current.openEvent = open ? event : undefined;
        events.emit("openchange", {
            open: open,
            event: event,
            reason: reason,
            nested: nested
        });
        onOpenChangeProp == null || onOpenChangeProp(open, event, reason);
    });
    const refs = $kc00y.useMemo(()=>({
            setPositionReference: setPositionReference
        }), []);
    const elements = $kc00y.useMemo(()=>({
            reference: positionReference || elementsProp.reference || null,
            floating: elementsProp.floating || null,
            domReference: elementsProp.reference
        }), [
        positionReference,
        elementsProp.reference,
        elementsProp.floating
    ]);
    return $kc00y.useMemo(()=>({
            dataRef: dataRef,
            open: open,
            onOpenChange: onOpenChange,
            elements: elements,
            events: events,
            floatingId: floatingId,
            refs: refs
        }), [
        open,
        onOpenChange,
        elements,
        events,
        floatingId,
        refs
    ]);
}
/**
 * Provides data to position a floating element and context to add interactions.
 * @see https://floating-ui.com/docs/useFloating
 */ function $8eab25943f557f5c$export$4e02a5c1d08bac65(options) {
    if (options === void 0) options = {};
    const { nodeId: nodeId } = options;
    const internalRootContext = $8eab25943f557f5c$export$1df81146f8ad8e4c({
        ...options,
        elements: {
            reference: null,
            floating: null,
            ...options.elements
        }
    });
    const rootContext = options.rootContext || internalRootContext;
    const computedElements = rootContext.elements;
    const [_domReference, setDomReference] = $kc00y.useState(null);
    const [positionReference, _setPositionReference] = $kc00y.useState(null);
    const optionDomReference = computedElements == null ? void 0 : computedElements.reference;
    const domReference = optionDomReference || _domReference;
    const domReferenceRef = $kc00y.useRef(null);
    const tree = $8eab25943f557f5c$export$db0c2a7c7a2a4f69();
    $8eab25943f557f5c$var$index(()=>{
        if (domReference) domReferenceRef.current = domReference;
    }, [
        domReference
    ]);
    const position = (0, $jJYM0.useFloating)({
        ...options,
        elements: {
            ...computedElements,
            ...positionReference && {
                reference: positionReference
            }
        }
    });
    const setPositionReference = $kc00y.useCallback((node)=>{
        const computedPositionReference = (0, $gmW3q.isElement)(node) ? {
            getBoundingClientRect: ()=>node.getBoundingClientRect(),
            contextElement: node
        } : node;
        // Store the positionReference in state if the DOM reference is specified externally via the
        // `elements.reference` option. This ensures that it won't be overridden on future renders.
        _setPositionReference(computedPositionReference);
        position.refs.setReference(computedPositionReference);
    }, [
        position.refs
    ]);
    const setReference = $kc00y.useCallback((node)=>{
        if ((0, $gmW3q.isElement)(node) || node === null) {
            domReferenceRef.current = node;
            setDomReference(node);
        }
        // Backwards-compatibility for passing a virtual element to `reference`
        // after it has set the DOM reference.
        if ((0, $gmW3q.isElement)(position.refs.reference.current) || position.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
        // `null` to support `positionReference` + an unstable `reference`
        // callback ref.
        node !== null && !(0, $gmW3q.isElement)(node)) position.refs.setReference(node);
    }, [
        position.refs
    ]);
    const refs = $kc00y.useMemo(()=>({
            ...position.refs,
            setReference: setReference,
            setPositionReference: setPositionReference,
            domReference: domReferenceRef
        }), [
        position.refs,
        setReference,
        setPositionReference
    ]);
    const elements = $kc00y.useMemo(()=>({
            ...position.elements,
            domReference: domReference
        }), [
        position.elements,
        domReference
    ]);
    const context = $kc00y.useMemo(()=>({
            ...position,
            ...rootContext,
            refs: refs,
            elements: elements,
            nodeId: nodeId
        }), [
        position,
        refs,
        elements,
        nodeId,
        rootContext
    ]);
    $8eab25943f557f5c$var$index(()=>{
        rootContext.dataRef.current.floatingContext = context;
        const node = tree == null ? void 0 : tree.nodesRef.current.find((node)=>node.id === nodeId);
        if (node) node.context = context;
    });
    return $kc00y.useMemo(()=>({
            ...position,
            context: context,
            refs: refs,
            elements: elements
        }), [
        position,
        refs,
        elements,
        context
    ]);
}
/**
 * Opens the floating element while the reference element has focus, like CSS
 * `:focus`.
 * @see https://floating-ui.com/docs/useFocus
 */ function $8eab25943f557f5c$export$f8168d8dd8fd66e6(context, props) {
    if (props === void 0) props = {};
    const { open: open, onOpenChange: onOpenChange, events: events, dataRef: dataRef, elements: elements } = context;
    const { enabled: enabled = true, visibleOnly: visibleOnly = true } = props;
    const blockFocusRef = $kc00y.useRef(false);
    const timeoutRef = $kc00y.useRef();
    const keyboardModalityRef = $kc00y.useRef(true);
    $kc00y.useEffect(()=>{
        if (!enabled) return;
        const win = (0, $gmW3q.getWindow)(elements.domReference);
        // If the reference was focused and the user left the tab/window, and the
        // floating element was not open, the focus should be blocked when they
        // return to the tab/window.
        function onBlur() {
            if (!open && (0, $gmW3q.isHTMLElement)(elements.domReference) && elements.domReference === (0, $4vEIG.activeElement)((0, $4vEIG.getDocument)(elements.domReference))) blockFocusRef.current = true;
        }
        function onKeyDown() {
            keyboardModalityRef.current = true;
        }
        win.addEventListener("blur", onBlur);
        win.addEventListener("keydown", onKeyDown, true);
        return ()=>{
            win.removeEventListener("blur", onBlur);
            win.removeEventListener("keydown", onKeyDown, true);
        };
    }, [
        elements.domReference,
        open,
        enabled
    ]);
    $kc00y.useEffect(()=>{
        if (!enabled) return;
        function onOpenChange(_ref) {
            let { reason: reason } = _ref;
            if (reason === "reference-press" || reason === "escape-key") blockFocusRef.current = true;
        }
        events.on("openchange", onOpenChange);
        return ()=>{
            events.off("openchange", onOpenChange);
        };
    }, [
        events,
        enabled
    ]);
    $kc00y.useEffect(()=>{
        return ()=>{
            clearTimeout(timeoutRef.current);
        };
    }, []);
    const reference = $kc00y.useMemo(()=>({
            onPointerDown (event) {
                if ((0, $4vEIG.isVirtualPointerEvent)(event.nativeEvent)) return;
                keyboardModalityRef.current = false;
            },
            onMouseLeave () {
                blockFocusRef.current = false;
            },
            onFocus (event) {
                if (blockFocusRef.current) return;
                const target = (0, $4vEIG.getTarget)(event.nativeEvent);
                if (visibleOnly && (0, $gmW3q.isElement)(target)) try {
                    // Mac Safari unreliably matches `:focus-visible` on the reference
                    // if focus was outside the page initially - use the fallback
                    // instead.
                    if ((0, $4vEIG.isSafari)() && (0, $4vEIG.isMac)()) throw Error();
                    if (!target.matches(":focus-visible")) return;
                } catch (e) {
                    // Old browsers will throw an error when using `:focus-visible`.
                    if (!keyboardModalityRef.current && !(0, $4vEIG.isTypeableElement)(target)) return;
                }
                onOpenChange(true, event.nativeEvent, "focus");
            },
            onBlur (event) {
                blockFocusRef.current = false;
                const relatedTarget = event.relatedTarget;
                const nativeEvent = event.nativeEvent;
                // Hit the non-modal focus management portal guard. Focus will be
                // moved into the floating element immediately after.
                const movedToFocusGuard = (0, $gmW3q.isElement)(relatedTarget) && relatedTarget.hasAttribute($8eab25943f557f5c$var$createAttribute("focus-guard")) && relatedTarget.getAttribute("data-type") === "outside";
                // Wait for the window blur listener to fire.
                timeoutRef.current = window.setTimeout(()=>{
                    var _dataRef$current$floa;
                    const activeEl = (0, $4vEIG.activeElement)(elements.domReference ? elements.domReference.ownerDocument : document);
                    // Focus left the page, keep it open.
                    if (!relatedTarget && activeEl === elements.domReference) return;
                    // When focusing the reference element (e.g. regular click), then
                    // clicking into the floating element, prevent it from hiding.
                    // Note: it must be focusable, e.g. `tabindex="-1"`.
                    // We can not rely on relatedTarget to point to the correct element
                    // as it will only point to the shadow host of the newly focused element
                    // and not the element that actually has received focus if it is located
                    // inside a shadow root.
                    if ((0, $4vEIG.contains)((_dataRef$current$floa = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa.refs.floating.current, activeEl) || (0, $4vEIG.contains)(elements.domReference, activeEl) || movedToFocusGuard) return;
                    onOpenChange(false, nativeEvent, "focus");
                });
            }
        }), [
        dataRef,
        elements.domReference,
        onOpenChange,
        visibleOnly
    ]);
    return $kc00y.useMemo(()=>enabled ? {
            reference: reference
        } : {}, [
        enabled,
        reference
    ]);
}
const $8eab25943f557f5c$var$ACTIVE_KEY = "active";
const $8eab25943f557f5c$var$SELECTED_KEY = "selected";
function $8eab25943f557f5c$var$mergeProps(userProps, propsList, elementKey) {
    const map = new Map();
    const isItem = elementKey === "item";
    let domUserProps = userProps;
    if (isItem && userProps) {
        const { [$8eab25943f557f5c$var$ACTIVE_KEY]: _, [$8eab25943f557f5c$var$SELECTED_KEY]: __, ...validProps } = userProps;
        domUserProps = validProps;
    }
    return {
        ...elementKey === "floating" && {
            tabIndex: -1,
            [$8eab25943f557f5c$var$FOCUSABLE_ATTRIBUTE]: ""
        },
        ...domUserProps,
        ...propsList.map((value)=>{
            const propsOrGetProps = value ? value[elementKey] : null;
            if (typeof propsOrGetProps === "function") return userProps ? propsOrGetProps(userProps) : null;
            return propsOrGetProps;
        }).concat(userProps).reduce((acc, props)=>{
            if (!props) return acc;
            Object.entries(props).forEach((_ref)=>{
                let [key, value] = _ref;
                if (isItem && [
                    $8eab25943f557f5c$var$ACTIVE_KEY,
                    $8eab25943f557f5c$var$SELECTED_KEY
                ].includes(key)) return;
                if (key.indexOf("on") === 0) {
                    if (!map.has(key)) map.set(key, []);
                    if (typeof value === "function") {
                        var _map$get;
                        (_map$get = map.get(key)) == null || _map$get.push(value);
                        acc[key] = function() {
                            var _map$get2;
                            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                            return (_map$get2 = map.get(key)) == null ? void 0 : _map$get2.map((fn)=>fn(...args)).find((val)=>val !== undefined);
                        };
                    }
                } else acc[key] = value;
            });
            return acc;
        }, {})
    };
}
/**
 * Merges an array of interaction hooks' props into prop getters, allowing
 * event handler functions to be composed together without overwriting one
 * another.
 * @see https://floating-ui.com/docs/useInteractions
 */ function $8eab25943f557f5c$export$a519f7794e446ddd(propsList) {
    if (propsList === void 0) propsList = [];
    const referenceDeps = propsList.map((key)=>key == null ? void 0 : key.reference);
    const floatingDeps = propsList.map((key)=>key == null ? void 0 : key.floating);
    const itemDeps = propsList.map((key)=>key == null ? void 0 : key.item);
    const getReferenceProps = $kc00y.useCallback((userProps)=>$8eab25943f557f5c$var$mergeProps(userProps, propsList, "reference"), // eslint-disable-next-line react-hooks/exhaustive-deps
    referenceDeps);
    const getFloatingProps = $kc00y.useCallback((userProps)=>$8eab25943f557f5c$var$mergeProps(userProps, propsList, "floating"), // eslint-disable-next-line react-hooks/exhaustive-deps
    floatingDeps);
    const getItemProps = $kc00y.useCallback((userProps)=>$8eab25943f557f5c$var$mergeProps(userProps, propsList, "item"), // eslint-disable-next-line react-hooks/exhaustive-deps
    itemDeps);
    return $kc00y.useMemo(()=>({
            getReferenceProps: getReferenceProps,
            getFloatingProps: getFloatingProps,
            getItemProps: getItemProps
        }), [
        getReferenceProps,
        getFloatingProps,
        getItemProps
    ]);
}
let $8eab25943f557f5c$var$isPreventScrollSupported = false;
function $8eab25943f557f5c$var$doSwitch(orientation, vertical, horizontal) {
    switch(orientation){
        case "vertical":
            return vertical;
        case "horizontal":
            return horizontal;
        default:
            return vertical || horizontal;
    }
}
function $8eab25943f557f5c$var$isMainOrientationKey(key, orientation) {
    const vertical = key === $8eab25943f557f5c$var$ARROW_UP || key === $8eab25943f557f5c$var$ARROW_DOWN;
    const horizontal = key === $8eab25943f557f5c$var$ARROW_LEFT || key === $8eab25943f557f5c$var$ARROW_RIGHT;
    return $8eab25943f557f5c$var$doSwitch(orientation, vertical, horizontal);
}
function $8eab25943f557f5c$var$isMainOrientationToEndKey(key, orientation, rtl) {
    const vertical = key === $8eab25943f557f5c$var$ARROW_DOWN;
    const horizontal = rtl ? key === $8eab25943f557f5c$var$ARROW_LEFT : key === $8eab25943f557f5c$var$ARROW_RIGHT;
    return $8eab25943f557f5c$var$doSwitch(orientation, vertical, horizontal) || key === "Enter" || key === " " || key === "";
}
function $8eab25943f557f5c$var$isCrossOrientationOpenKey(key, orientation, rtl) {
    const vertical = rtl ? key === $8eab25943f557f5c$var$ARROW_LEFT : key === $8eab25943f557f5c$var$ARROW_RIGHT;
    const horizontal = key === $8eab25943f557f5c$var$ARROW_DOWN;
    return $8eab25943f557f5c$var$doSwitch(orientation, vertical, horizontal);
}
function $8eab25943f557f5c$var$isCrossOrientationCloseKey(key, orientation, rtl) {
    const vertical = rtl ? key === $8eab25943f557f5c$var$ARROW_RIGHT : key === $8eab25943f557f5c$var$ARROW_LEFT;
    const horizontal = key === $8eab25943f557f5c$var$ARROW_UP;
    return $8eab25943f557f5c$var$doSwitch(orientation, vertical, horizontal);
}
/**
 * Adds arrow key-based navigation of a list of items, either using real DOM
 * focus or virtual focus.
 * @see https://floating-ui.com/docs/useListNavigation
 */ function $8eab25943f557f5c$export$b5d22cac4ad33f40(context, props) {
    const { open: open, onOpenChange: onOpenChange, elements: elements } = context;
    const { listRef: listRef, activeIndex: activeIndex, onNavigate: unstable_onNavigate = ()=>{}, enabled: enabled = true, selectedIndex: selectedIndex = null, allowEscape: allowEscape = false, loop: loop = false, nested: nested = false, rtl: rtl = false, virtual: virtual = false, focusItemOnOpen: focusItemOnOpen = "auto", focusItemOnHover: focusItemOnHover = true, openOnArrowKeyDown: openOnArrowKeyDown = true, disabledIndices: disabledIndices, orientation: orientation = "vertical", cols: cols = 1, scrollItemIntoView: scrollItemIntoView = true, virtualItemRef: virtualItemRef, itemSizes: itemSizes, dense: dense = false } = props;
    const floatingFocusElement = $8eab25943f557f5c$var$getFloatingFocusElement(elements.floating);
    const floatingFocusElementRef = $8eab25943f557f5c$var$useLatestRef(floatingFocusElement);
    const parentId = $8eab25943f557f5c$export$165209eae06d3488();
    const tree = $8eab25943f557f5c$export$db0c2a7c7a2a4f69();
    const onNavigate = $8eab25943f557f5c$var$useEffectEvent(unstable_onNavigate);
    const focusItemOnOpenRef = $kc00y.useRef(focusItemOnOpen);
    const indexRef = $kc00y.useRef(selectedIndex != null ? selectedIndex : -1);
    const keyRef = $kc00y.useRef(null);
    const isPointerModalityRef = $kc00y.useRef(true);
    const previousOnNavigateRef = $kc00y.useRef(onNavigate);
    const previousMountedRef = $kc00y.useRef(!!elements.floating);
    const previousOpenRef = $kc00y.useRef(open);
    const forceSyncFocus = $kc00y.useRef(false);
    const forceScrollIntoViewRef = $kc00y.useRef(false);
    const disabledIndicesRef = $8eab25943f557f5c$var$useLatestRef(disabledIndices);
    const latestOpenRef = $8eab25943f557f5c$var$useLatestRef(open);
    const scrollItemIntoViewRef = $8eab25943f557f5c$var$useLatestRef(scrollItemIntoView);
    const selectedIndexRef = $8eab25943f557f5c$var$useLatestRef(selectedIndex);
    const [activeId, setActiveId] = $kc00y.useState();
    const [virtualId, setVirtualId] = $kc00y.useState();
    const focusItem = $8eab25943f557f5c$var$useEffectEvent(function(listRef, indexRef, forceScrollIntoView) {
        if (forceScrollIntoView === void 0) forceScrollIntoView = false;
        function runFocus(item) {
            if (virtual) {
                setActiveId(item.id);
                tree == null || tree.events.emit("virtualfocus", item);
                if (virtualItemRef) virtualItemRef.current = item;
            } else $8eab25943f557f5c$var$enqueueFocus(item, {
                preventScroll: true,
                // Mac Safari does not move the virtual cursor unless the focus call
                // is sync. However, for the very first focus call, we need to wait
                // for the position to be ready in order to prevent unwanted
                // scrolling. This means the virtual cursor will not move to the first
                // item when first opening the floating element, but will on
                // subsequent calls. `preventScroll` is supported in modern Safari,
                // so we can use that instead.
                // iOS Safari must be async or the first item will not be focused.
                sync: (0, $4vEIG.isMac)() && (0, $4vEIG.isSafari)() ? $8eab25943f557f5c$var$isPreventScrollSupported || forceSyncFocus.current : false
            });
        }
        const initialItem = listRef.current[indexRef.current];
        if (initialItem) runFocus(initialItem);
        requestAnimationFrame(()=>{
            const waitedItem = listRef.current[indexRef.current] || initialItem;
            if (!waitedItem) return;
            if (!initialItem) runFocus(waitedItem);
            const scrollIntoViewOptions = scrollItemIntoViewRef.current;
            const shouldScrollIntoView = scrollIntoViewOptions && item && (forceScrollIntoView || !isPointerModalityRef.current);
            if (shouldScrollIntoView) // JSDOM doesn't support `.scrollIntoView()` but it's widely supported
            // by all browsers.
            waitedItem.scrollIntoView == null || waitedItem.scrollIntoView(typeof scrollIntoViewOptions === "boolean" ? {
                block: "nearest",
                inline: "nearest"
            } : scrollIntoViewOptions);
        });
    });
    $8eab25943f557f5c$var$index(()=>{
        document.createElement("div").focus({
            get preventScroll () {
                $8eab25943f557f5c$var$isPreventScrollSupported = true;
                return false;
            }
        });
    }, []);
    // Sync `selectedIndex` to be the `activeIndex` upon opening the floating
    // element. Also, reset `activeIndex` upon closing the floating element.
    $8eab25943f557f5c$var$index(()=>{
        if (!enabled) return;
        if (open && elements.floating) {
            if (focusItemOnOpenRef.current && selectedIndex != null) {
                // Regardless of the pointer modality, we want to ensure the selected
                // item comes into view when the floating element is opened.
                forceScrollIntoViewRef.current = true;
                indexRef.current = selectedIndex;
                onNavigate(selectedIndex);
            }
        } else if (previousMountedRef.current) {
            // Since the user can specify `onNavigate` conditionally
            // (onNavigate: open ? setActiveIndex : setSelectedIndex),
            // we store and call the previous function.
            indexRef.current = -1;
            previousOnNavigateRef.current(null);
        }
    }, [
        enabled,
        open,
        elements.floating,
        selectedIndex,
        onNavigate
    ]);
    // Sync `activeIndex` to be the focused item while the floating element is
    // open.
    $8eab25943f557f5c$var$index(()=>{
        if (!enabled) return;
        if (open && elements.floating) {
            if (activeIndex == null) {
                forceSyncFocus.current = false;
                if (selectedIndexRef.current != null) return;
                // Reset while the floating element was open (e.g. the list changed).
                if (previousMountedRef.current) {
                    indexRef.current = -1;
                    focusItem(listRef, indexRef);
                }
                // Initial sync.
                if ((!previousOpenRef.current || !previousMountedRef.current) && focusItemOnOpenRef.current && (keyRef.current != null || focusItemOnOpenRef.current === true && keyRef.current == null)) {
                    let runs = 0;
                    const waitForListPopulated = ()=>{
                        if (listRef.current[0] == null) {
                            // Avoid letting the browser paint if possible on the first try,
                            // otherwise use rAF. Don't try more than twice, since something
                            // is wrong otherwise.
                            if (runs < 2) {
                                const scheduler = runs ? requestAnimationFrame : queueMicrotask;
                                scheduler(waitForListPopulated);
                            }
                            runs++;
                        } else {
                            indexRef.current = keyRef.current == null || $8eab25943f557f5c$var$isMainOrientationToEndKey(keyRef.current, orientation, rtl) || nested ? $8eab25943f557f5c$var$getMinIndex(listRef, disabledIndicesRef.current) : $8eab25943f557f5c$var$getMaxIndex(listRef, disabledIndicesRef.current);
                            keyRef.current = null;
                            onNavigate(indexRef.current);
                        }
                    };
                    waitForListPopulated();
                }
            } else if (!$8eab25943f557f5c$var$isIndexOutOfBounds(listRef, activeIndex)) {
                indexRef.current = activeIndex;
                focusItem(listRef, indexRef, forceScrollIntoViewRef.current);
                forceScrollIntoViewRef.current = false;
            }
        }
    }, [
        enabled,
        open,
        elements.floating,
        activeIndex,
        selectedIndexRef,
        nested,
        listRef,
        orientation,
        rtl,
        onNavigate,
        focusItem,
        disabledIndicesRef
    ]);
    // Ensure the parent floating element has focus when a nested child closes
    // to allow arrow key navigation to work after the pointer leaves the child.
    $8eab25943f557f5c$var$index(()=>{
        var _nodes$find;
        if (!enabled || elements.floating || !tree || virtual || !previousMountedRef.current) return;
        const nodes = tree.nodesRef.current;
        const parent = (_nodes$find = nodes.find((node)=>node.id === parentId)) == null || (_nodes$find = _nodes$find.context) == null ? void 0 : _nodes$find.elements.floating;
        const activeEl = (0, $4vEIG.activeElement)((0, $4vEIG.getDocument)(elements.floating));
        const treeContainsActiveEl = nodes.some((node)=>node.context && (0, $4vEIG.contains)(node.context.elements.floating, activeEl));
        if (parent && !treeContainsActiveEl && isPointerModalityRef.current) parent.focus({
            preventScroll: true
        });
    }, [
        enabled,
        elements.floating,
        tree,
        parentId,
        virtual
    ]);
    $8eab25943f557f5c$var$index(()=>{
        if (!enabled) return;
        if (!tree) return;
        if (!virtual) return;
        if (parentId) return;
        function handleVirtualFocus(item) {
            setVirtualId(item.id);
            if (virtualItemRef) virtualItemRef.current = item;
        }
        tree.events.on("virtualfocus", handleVirtualFocus);
        return ()=>{
            tree.events.off("virtualfocus", handleVirtualFocus);
        };
    }, [
        enabled,
        tree,
        virtual,
        parentId,
        virtualItemRef
    ]);
    $8eab25943f557f5c$var$index(()=>{
        previousOnNavigateRef.current = onNavigate;
        previousMountedRef.current = !!elements.floating;
    });
    $8eab25943f557f5c$var$index(()=>{
        if (!open) keyRef.current = null;
    }, [
        open
    ]);
    $8eab25943f557f5c$var$index(()=>{
        previousOpenRef.current = open;
    }, [
        open
    ]);
    const hasActiveIndex = activeIndex != null;
    const item = $kc00y.useMemo(()=>{
        function syncCurrentTarget(currentTarget) {
            if (!open) return;
            const index = listRef.current.indexOf(currentTarget);
            if (index !== -1) onNavigate(index);
        }
        const props = {
            onFocus (_ref) {
                let { currentTarget: currentTarget } = _ref;
                syncCurrentTarget(currentTarget);
            },
            onClick: (_ref2)=>{
                let { currentTarget: currentTarget } = _ref2;
                return currentTarget.focus({
                    preventScroll: true
                });
            },
            // Safari
            ...focusItemOnHover && {
                onMouseMove (_ref3) {
                    let { currentTarget: currentTarget } = _ref3;
                    syncCurrentTarget(currentTarget);
                },
                onPointerLeave (_ref4) {
                    let { pointerType: pointerType } = _ref4;
                    if (!isPointerModalityRef.current || pointerType === "touch") return;
                    indexRef.current = -1;
                    focusItem(listRef, indexRef);
                    onNavigate(null);
                    if (!virtual) $8eab25943f557f5c$var$enqueueFocus(floatingFocusElementRef.current, {
                        preventScroll: true
                    });
                }
            }
        };
        return props;
    }, [
        open,
        floatingFocusElementRef,
        focusItem,
        focusItemOnHover,
        listRef,
        onNavigate,
        virtual
    ]);
    const commonOnKeyDown = $8eab25943f557f5c$var$useEffectEvent((event)=>{
        isPointerModalityRef.current = false;
        forceSyncFocus.current = true;
        // When composing a character, Chrome fires ArrowDown twice. Firefox/Safari
        // don't appear to suffer from this. `event.isComposing` is avoided due to
        // Safari not supporting it properly (although it's not needed in the first
        // place for Safari, just avoiding any possible issues).
        if (event.which === 229) return;
        // If the floating element is animating out, ignore navigation. Otherwise,
        // the `activeIndex` gets set to 0 despite not being open so the next time
        // the user ArrowDowns, the first item won't be focused.
        if (!latestOpenRef.current && event.currentTarget === floatingFocusElementRef.current) return;
        if (nested && $8eab25943f557f5c$var$isCrossOrientationCloseKey(event.key, orientation, rtl)) {
            (0, $4vEIG.stopEvent)(event);
            onOpenChange(false, event.nativeEvent, "list-navigation");
            if ((0, $gmW3q.isHTMLElement)(elements.domReference) && !virtual) elements.domReference.focus();
            return;
        }
        const currentIndex = indexRef.current;
        const minIndex = $8eab25943f557f5c$var$getMinIndex(listRef, disabledIndices);
        const maxIndex = $8eab25943f557f5c$var$getMaxIndex(listRef, disabledIndices);
        if (event.key === "Home") {
            (0, $4vEIG.stopEvent)(event);
            indexRef.current = minIndex;
            onNavigate(indexRef.current);
        }
        if (event.key === "End") {
            (0, $4vEIG.stopEvent)(event);
            indexRef.current = maxIndex;
            onNavigate(indexRef.current);
        }
        // Grid navigation.
        if (cols > 1) {
            const sizes = itemSizes || Array.from({
                length: listRef.current.length
            }, ()=>({
                    width: 1,
                    height: 1
                }));
            // To calculate movements on the grid, we use hypothetical cell indices
            // as if every item was 1x1, then convert back to real indices.
            const cellMap = $8eab25943f557f5c$var$buildCellMap(sizes, cols, dense);
            const minGridIndex = cellMap.findIndex((index)=>index != null && !$8eab25943f557f5c$var$isDisabled(listRef.current, index, disabledIndices));
            // last enabled index
            const maxGridIndex = cellMap.reduce((foundIndex, index, cellIndex)=>index != null && !$8eab25943f557f5c$var$isDisabled(listRef.current, index, disabledIndices) ? cellIndex : foundIndex, -1);
            const index = cellMap[$8eab25943f557f5c$var$getGridNavigatedIndex({
                current: cellMap.map((itemIndex)=>itemIndex != null ? listRef.current[itemIndex] : null)
            }, {
                event: event,
                orientation: orientation,
                loop: loop,
                cols: cols,
                // treat undefined (empty grid spaces) as disabled indices so we
                // don't end up in them
                disabledIndices: $8eab25943f557f5c$var$getCellIndices([
                    ...disabledIndices || listRef.current.map((_, index)=>$8eab25943f557f5c$var$isDisabled(listRef.current, index) ? index : undefined),
                    undefined
                ], cellMap),
                minIndex: minGridIndex,
                maxIndex: maxGridIndex,
                prevIndex: $8eab25943f557f5c$var$getCellIndexOfCorner(indexRef.current > maxIndex ? minIndex : indexRef.current, sizes, cellMap, cols, // use a corner matching the edge closest to the direction
                // we're moving in so we don't end up in the same item. Prefer
                // top/left over bottom/right.
                event.key === $8eab25943f557f5c$var$ARROW_DOWN ? "bl" : event.key === $8eab25943f557f5c$var$ARROW_RIGHT ? "tr" : "tl"),
                stopEvent: true
            })];
            if (index != null) {
                indexRef.current = index;
                onNavigate(indexRef.current);
            }
            if (orientation === "both") return;
        }
        if ($8eab25943f557f5c$var$isMainOrientationKey(event.key, orientation)) {
            (0, $4vEIG.stopEvent)(event);
            // Reset the index if no item is focused.
            if (open && !virtual && (0, $4vEIG.activeElement)(event.currentTarget.ownerDocument) === event.currentTarget) {
                indexRef.current = $8eab25943f557f5c$var$isMainOrientationToEndKey(event.key, orientation, rtl) ? minIndex : maxIndex;
                onNavigate(indexRef.current);
                return;
            }
            if ($8eab25943f557f5c$var$isMainOrientationToEndKey(event.key, orientation, rtl)) {
                if (loop) indexRef.current = currentIndex >= maxIndex ? allowEscape && currentIndex !== listRef.current.length ? -1 : minIndex : $8eab25943f557f5c$var$findNonDisabledIndex(listRef, {
                    startingIndex: currentIndex,
                    disabledIndices: disabledIndices
                });
                else indexRef.current = Math.min(maxIndex, $8eab25943f557f5c$var$findNonDisabledIndex(listRef, {
                    startingIndex: currentIndex,
                    disabledIndices: disabledIndices
                }));
            } else if (loop) indexRef.current = currentIndex <= minIndex ? allowEscape && currentIndex !== -1 ? listRef.current.length : maxIndex : $8eab25943f557f5c$var$findNonDisabledIndex(listRef, {
                startingIndex: currentIndex,
                decrement: true,
                disabledIndices: disabledIndices
            });
            else indexRef.current = Math.max(minIndex, $8eab25943f557f5c$var$findNonDisabledIndex(listRef, {
                startingIndex: currentIndex,
                decrement: true,
                disabledIndices: disabledIndices
            }));
            if ($8eab25943f557f5c$var$isIndexOutOfBounds(listRef, indexRef.current)) onNavigate(null);
            else onNavigate(indexRef.current);
        }
    });
    const ariaActiveDescendantProp = $kc00y.useMemo(()=>{
        return virtual && open && hasActiveIndex && {
            "aria-activedescendant": virtualId || activeId
        };
    }, [
        virtual,
        open,
        hasActiveIndex,
        virtualId,
        activeId
    ]);
    const floating = $kc00y.useMemo(()=>{
        return {
            "aria-orientation": orientation === "both" ? undefined : orientation,
            ...!(0, $4vEIG.isTypeableCombobox)(elements.domReference) && ariaActiveDescendantProp,
            onKeyDown: commonOnKeyDown,
            onPointerMove () {
                isPointerModalityRef.current = true;
            }
        };
    }, [
        ariaActiveDescendantProp,
        commonOnKeyDown,
        elements.domReference,
        orientation
    ]);
    const reference = $kc00y.useMemo(()=>{
        function checkVirtualMouse(event) {
            if (focusItemOnOpen === "auto" && (0, $4vEIG.isVirtualClick)(event.nativeEvent)) focusItemOnOpenRef.current = true;
        }
        function checkVirtualPointer(event) {
            // `pointerdown` fires first, reset the state then perform the checks.
            focusItemOnOpenRef.current = focusItemOnOpen;
            if (focusItemOnOpen === "auto" && (0, $4vEIG.isVirtualPointerEvent)(event.nativeEvent)) focusItemOnOpenRef.current = true;
        }
        return {
            ...ariaActiveDescendantProp,
            onKeyDown (event) {
                isPointerModalityRef.current = false;
                const isArrowKey = event.key.startsWith("Arrow");
                const isHomeOrEndKey = [
                    "Home",
                    "End"
                ].includes(event.key);
                const isMoveKey = isArrowKey || isHomeOrEndKey;
                const isCrossOpenKey = $8eab25943f557f5c$var$isCrossOrientationOpenKey(event.key, orientation, rtl);
                const isCrossCloseKey = $8eab25943f557f5c$var$isCrossOrientationCloseKey(event.key, orientation, rtl);
                const isMainKey = $8eab25943f557f5c$var$isMainOrientationKey(event.key, orientation);
                const isNavigationKey = (nested ? isCrossOpenKey : isMainKey) || event.key === "Enter" || event.key.trim() === "";
                if (virtual && open) {
                    const rootNode = tree == null ? void 0 : tree.nodesRef.current.find((node)=>node.parentId == null);
                    const deepestNode = tree && rootNode ? $8eab25943f557f5c$var$getDeepestNode(tree.nodesRef.current, rootNode.id) : null;
                    if (isMoveKey && deepestNode && virtualItemRef) {
                        const eventObject = new KeyboardEvent("keydown", {
                            key: event.key,
                            bubbles: true
                        });
                        if (isCrossOpenKey || isCrossCloseKey) {
                            var _deepestNode$context, _deepestNode$context2;
                            const isCurrentTarget = ((_deepestNode$context = deepestNode.context) == null ? void 0 : _deepestNode$context.elements.domReference) === event.currentTarget;
                            const dispatchItem = isCrossCloseKey && !isCurrentTarget ? (_deepestNode$context2 = deepestNode.context) == null ? void 0 : _deepestNode$context2.elements.domReference : isCrossOpenKey ? listRef.current.find((item)=>(item == null ? void 0 : item.id) === activeId) : null;
                            if (dispatchItem) {
                                (0, $4vEIG.stopEvent)(event);
                                dispatchItem.dispatchEvent(eventObject);
                                setVirtualId(undefined);
                            }
                        }
                        if ((isMainKey || isHomeOrEndKey) && deepestNode.context) {
                            if (deepestNode.context.open && deepestNode.parentId && event.currentTarget !== deepestNode.context.elements.domReference) {
                                var _deepestNode$context$;
                                (0, $4vEIG.stopEvent)(event);
                                (_deepestNode$context$ = deepestNode.context.elements.domReference) == null || _deepestNode$context$.dispatchEvent(eventObject);
                                return;
                            }
                        }
                    }
                    return commonOnKeyDown(event);
                }
                // If a floating element should not open on arrow key down, avoid
                // setting `activeIndex` while it's closed.
                if (!open && !openOnArrowKeyDown && isArrowKey) return;
                if (isNavigationKey) keyRef.current = nested && isMainKey ? null : event.key;
                if (nested) {
                    if (isCrossOpenKey) {
                        (0, $4vEIG.stopEvent)(event);
                        if (open) {
                            indexRef.current = $8eab25943f557f5c$var$getMinIndex(listRef, disabledIndicesRef.current);
                            onNavigate(indexRef.current);
                        } else onOpenChange(true, event.nativeEvent, "list-navigation");
                    }
                    return;
                }
                if (isMainKey) {
                    if (selectedIndex != null) indexRef.current = selectedIndex;
                    (0, $4vEIG.stopEvent)(event);
                    if (!open && openOnArrowKeyDown) onOpenChange(true, event.nativeEvent, "list-navigation");
                    else commonOnKeyDown(event);
                    if (open) onNavigate(indexRef.current);
                }
            },
            onFocus () {
                if (open && !virtual) onNavigate(null);
            },
            onPointerDown: checkVirtualPointer,
            onMouseDown: checkVirtualMouse,
            onClick: checkVirtualMouse
        };
    }, [
        activeId,
        ariaActiveDescendantProp,
        commonOnKeyDown,
        disabledIndicesRef,
        focusItemOnOpen,
        listRef,
        nested,
        onNavigate,
        onOpenChange,
        open,
        openOnArrowKeyDown,
        orientation,
        rtl,
        selectedIndex,
        tree,
        virtual,
        virtualItemRef
    ]);
    return $kc00y.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating,
            item: item
        } : {}, [
        enabled,
        reference,
        floating,
        item
    ]);
}
const $8eab25943f557f5c$var$componentRoleToAriaRoleMap = /*#__PURE__*/ new Map([
    [
        "select",
        "listbox"
    ],
    [
        "combobox",
        "listbox"
    ],
    [
        "label",
        false
    ]
]);
/**
 * Adds base screen reader props to the reference and floating elements for a
 * given floating element `role`.
 * @see https://floating-ui.com/docs/useRole
 */ function $8eab25943f557f5c$export$f66572793fa256a1(context, props) {
    var _componentRoleToAriaR;
    if (props === void 0) props = {};
    const { open: open, floatingId: floatingId } = context;
    const { enabled: enabled = true, role: role = "dialog" } = props;
    const ariaRole = (_componentRoleToAriaR = $8eab25943f557f5c$var$componentRoleToAriaRoleMap.get(role)) != null ? _componentRoleToAriaR : role;
    const referenceId = $8eab25943f557f5c$export$f680877a34711e37();
    const parentId = $8eab25943f557f5c$export$165209eae06d3488();
    const isNested = parentId != null;
    const reference = $kc00y.useMemo(()=>{
        if (ariaRole === "tooltip" || role === "label") return {
            ["aria-" + (role === "label" ? "labelledby" : "describedby")]: open ? floatingId : undefined
        };
        return {
            "aria-expanded": open ? "true" : "false",
            "aria-haspopup": ariaRole === "alertdialog" ? "dialog" : ariaRole,
            "aria-controls": open ? floatingId : undefined,
            ...ariaRole === "listbox" && {
                role: "combobox"
            },
            ...ariaRole === "menu" && {
                id: referenceId
            },
            ...ariaRole === "menu" && isNested && {
                role: "menuitem"
            },
            ...role === "select" && {
                "aria-autocomplete": "none"
            },
            ...role === "combobox" && {
                "aria-autocomplete": "list"
            }
        };
    }, [
        ariaRole,
        floatingId,
        isNested,
        open,
        referenceId,
        role
    ]);
    const floating = $kc00y.useMemo(()=>{
        const floatingProps = {
            id: floatingId,
            ...ariaRole && {
                role: ariaRole
            }
        };
        if (ariaRole === "tooltip" || role === "label") return floatingProps;
        return {
            ...floatingProps,
            ...ariaRole === "menu" && {
                "aria-labelledby": referenceId
            }
        };
    }, [
        ariaRole,
        floatingId,
        referenceId,
        role
    ]);
    const item = $kc00y.useCallback((_ref)=>{
        let { active: active, selected: selected } = _ref;
        const commonProps = {
            role: "option",
            ...active && {
                id: floatingId + "-option"
            }
        };
        // For `menu`, we are unable to tell if the item is a `menuitemradio`
        // or `menuitemcheckbox`. For backwards-compatibility reasons, also
        // avoid defaulting to `menuitem` as it may overwrite custom role props.
        switch(role){
            case "select":
                return {
                    ...commonProps,
                    "aria-selected": active && selected
                };
            case "combobox":
                return {
                    ...commonProps,
                    ...active && {
                        "aria-selected": true
                    }
                };
        }
        return {};
    }, [
        floatingId,
        role
    ]);
    return $kc00y.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating,
            item: item
        } : {}, [
        enabled,
        reference,
        floating,
        item
    ]);
}
// Converts a JS style key like `backgroundColor` to a CSS transition-property
// like `background-color`.
const $8eab25943f557f5c$var$camelCaseToKebabCase = (str)=>str.replace(/[A-Z]+(?![a-z])|[A-Z]/g, ($, ofs)=>(ofs ? "-" : "") + $.toLowerCase());
function $8eab25943f557f5c$var$execWithArgsOrReturn(valueOrFn, args) {
    return typeof valueOrFn === "function" ? valueOrFn(args) : valueOrFn;
}
function $8eab25943f557f5c$var$useDelayUnmount(open, durationMs) {
    const [isMounted, setIsMounted] = $kc00y.useState(open);
    if (open && !isMounted) setIsMounted(true);
    $kc00y.useEffect(()=>{
        if (!open && isMounted) {
            const timeout = setTimeout(()=>setIsMounted(false), durationMs);
            return ()=>clearTimeout(timeout);
        }
    }, [
        open,
        isMounted,
        durationMs
    ]);
    return isMounted;
}
/**
 * Provides a status string to apply CSS transitions to a floating element,
 * correctly handling placement-aware transitions.
 * @see https://floating-ui.com/docs/useTransition#usetransitionstatus
 */ function $8eab25943f557f5c$export$b2ef21706733f7e5(context, props) {
    if (props === void 0) props = {};
    const { open: open, elements: { floating: floating } } = context;
    const { duration: duration = 250 } = props;
    const isNumberDuration = typeof duration === "number";
    const closeDuration = (isNumberDuration ? duration : duration.close) || 0;
    const [status, setStatus] = $kc00y.useState("unmounted");
    const isMounted = $8eab25943f557f5c$var$useDelayUnmount(open, closeDuration);
    if (!isMounted && status === "close") setStatus("unmounted");
    $8eab25943f557f5c$var$index(()=>{
        if (!floating) return;
        if (open) {
            setStatus("initial");
            const frame = requestAnimationFrame(()=>{
                setStatus("open");
            });
            return ()=>{
                cancelAnimationFrame(frame);
            };
        }
        setStatus("close");
    }, [
        open,
        floating
    ]);
    return {
        isMounted: isMounted,
        status: status
    };
}
/**
 * Provides styles to apply CSS transitions to a floating element, correctly
 * handling placement-aware transitions. Wrapper around `useTransitionStatus`.
 * @see https://floating-ui.com/docs/useTransition#usetransitionstyles
 */ function $8eab25943f557f5c$export$769fba13884bc2f4(context, props) {
    if (props === void 0) props = {};
    const { initial: unstable_initial = {
        opacity: 0
    }, open: unstable_open, close: unstable_close, common: unstable_common, duration: duration = 250 } = props;
    const placement = context.placement;
    const side = placement.split("-")[0];
    const fnArgs = $kc00y.useMemo(()=>({
            side: side,
            placement: placement
        }), [
        side,
        placement
    ]);
    const isNumberDuration = typeof duration === "number";
    const openDuration = (isNumberDuration ? duration : duration.open) || 0;
    const closeDuration = (isNumberDuration ? duration : duration.close) || 0;
    const [styles, setStyles] = $kc00y.useState(()=>({
            ...$8eab25943f557f5c$var$execWithArgsOrReturn(unstable_common, fnArgs),
            ...$8eab25943f557f5c$var$execWithArgsOrReturn(unstable_initial, fnArgs)
        }));
    const { isMounted: isMounted, status: status } = $8eab25943f557f5c$export$b2ef21706733f7e5(context, {
        duration: duration
    });
    const initialRef = $8eab25943f557f5c$var$useLatestRef(unstable_initial);
    const openRef = $8eab25943f557f5c$var$useLatestRef(unstable_open);
    const closeRef = $8eab25943f557f5c$var$useLatestRef(unstable_close);
    const commonRef = $8eab25943f557f5c$var$useLatestRef(unstable_common);
    $8eab25943f557f5c$var$index(()=>{
        const initialStyles = $8eab25943f557f5c$var$execWithArgsOrReturn(initialRef.current, fnArgs);
        const closeStyles = $8eab25943f557f5c$var$execWithArgsOrReturn(closeRef.current, fnArgs);
        const commonStyles = $8eab25943f557f5c$var$execWithArgsOrReturn(commonRef.current, fnArgs);
        const openStyles = $8eab25943f557f5c$var$execWithArgsOrReturn(openRef.current, fnArgs) || Object.keys(initialStyles).reduce((acc, key)=>{
            acc[key] = "";
            return acc;
        }, {});
        if (status === "initial") setStyles((styles)=>({
                transitionProperty: styles.transitionProperty,
                ...commonStyles,
                ...initialStyles
            }));
        if (status === "open") setStyles({
            transitionProperty: Object.keys(openStyles).map($8eab25943f557f5c$var$camelCaseToKebabCase).join(","),
            transitionDuration: openDuration + "ms",
            ...commonStyles,
            ...openStyles
        });
        if (status === "close") {
            const styles = closeStyles || initialStyles;
            setStyles({
                transitionProperty: Object.keys(styles).map($8eab25943f557f5c$var$camelCaseToKebabCase).join(","),
                transitionDuration: closeDuration + "ms",
                ...commonStyles,
                ...styles
            });
        }
    }, [
        closeDuration,
        closeRef,
        initialRef,
        openRef,
        commonRef,
        openDuration,
        status,
        fnArgs
    ]);
    return {
        isMounted: isMounted,
        styles: styles
    };
}
/**
 * Provides a matching callback that can be used to focus an item as the user
 * types, often used in tandem with `useListNavigation()`.
 * @see https://floating-ui.com/docs/useTypeahead
 */ function $8eab25943f557f5c$export$d8d674d50b73ba93(context, props) {
    var _ref;
    const { open: open, dataRef: dataRef } = context;
    const { listRef: listRef, activeIndex: activeIndex, onMatch: unstable_onMatch, onTypingChange: unstable_onTypingChange, enabled: enabled = true, findMatch: findMatch = null, resetMs: resetMs = 750, ignoreKeys: ignoreKeys = [], selectedIndex: selectedIndex = null } = props;
    const timeoutIdRef = $kc00y.useRef();
    const stringRef = $kc00y.useRef("");
    const prevIndexRef = $kc00y.useRef((_ref = selectedIndex != null ? selectedIndex : activeIndex) != null ? _ref : -1);
    const matchIndexRef = $kc00y.useRef(null);
    const onMatch = $8eab25943f557f5c$var$useEffectEvent(unstable_onMatch);
    const onTypingChange = $8eab25943f557f5c$var$useEffectEvent(unstable_onTypingChange);
    const findMatchRef = $8eab25943f557f5c$var$useLatestRef(findMatch);
    const ignoreKeysRef = $8eab25943f557f5c$var$useLatestRef(ignoreKeys);
    $8eab25943f557f5c$var$index(()=>{
        if (open) {
            clearTimeout(timeoutIdRef.current);
            matchIndexRef.current = null;
            stringRef.current = "";
        }
    }, [
        open
    ]);
    $8eab25943f557f5c$var$index(()=>{
        // Sync arrow key navigation but not typeahead navigation.
        if (open && stringRef.current === "") {
            var _ref2;
            prevIndexRef.current = (_ref2 = selectedIndex != null ? selectedIndex : activeIndex) != null ? _ref2 : -1;
        }
    }, [
        open,
        selectedIndex,
        activeIndex
    ]);
    const setTypingChange = $8eab25943f557f5c$var$useEffectEvent((value)=>{
        if (value) {
            if (!dataRef.current.typing) {
                dataRef.current.typing = value;
                onTypingChange(value);
            }
        } else if (dataRef.current.typing) {
            dataRef.current.typing = value;
            onTypingChange(value);
        }
    });
    const onKeyDown = $8eab25943f557f5c$var$useEffectEvent((event)=>{
        function getMatchingIndex(list, orderedList, string) {
            const str = findMatchRef.current ? findMatchRef.current(orderedList, string) : orderedList.find((text)=>(text == null ? void 0 : text.toLocaleLowerCase().indexOf(string.toLocaleLowerCase())) === 0);
            return str ? list.indexOf(str) : -1;
        }
        const listContent = listRef.current;
        if (stringRef.current.length > 0 && stringRef.current[0] !== " ") {
            if (getMatchingIndex(listContent, listContent, stringRef.current) === -1) setTypingChange(false);
            else if (event.key === " ") (0, $4vEIG.stopEvent)(event);
        }
        if (listContent == null || ignoreKeysRef.current.includes(event.key) || // Character key.
        event.key.length !== 1 || // Modifier key.
        event.ctrlKey || event.metaKey || event.altKey) return;
        if (open && event.key !== " ") {
            (0, $4vEIG.stopEvent)(event);
            setTypingChange(true);
        }
        // Bail out if the list contains a word like "llama" or "aaron". TODO:
        // allow it in this case, too.
        const allowRapidSuccessionOfFirstLetter = listContent.every((text)=>{
            var _text$, _text$2;
            return text ? ((_text$ = text[0]) == null ? void 0 : _text$.toLocaleLowerCase()) !== ((_text$2 = text[1]) == null ? void 0 : _text$2.toLocaleLowerCase()) : true;
        });
        // Allows the user to cycle through items that start with the same letter
        // in rapid succession.
        if (allowRapidSuccessionOfFirstLetter && stringRef.current === event.key) {
            stringRef.current = "";
            prevIndexRef.current = matchIndexRef.current;
        }
        stringRef.current += event.key;
        clearTimeout(timeoutIdRef.current);
        timeoutIdRef.current = setTimeout(()=>{
            stringRef.current = "";
            prevIndexRef.current = matchIndexRef.current;
            setTypingChange(false);
        }, resetMs);
        const prevIndex = prevIndexRef.current;
        const index = getMatchingIndex(listContent, [
            ...listContent.slice((prevIndex || 0) + 1),
            ...listContent.slice(0, (prevIndex || 0) + 1)
        ], stringRef.current);
        if (index !== -1) {
            onMatch(index);
            matchIndexRef.current = index;
        } else if (event.key !== " ") {
            stringRef.current = "";
            setTypingChange(false);
        }
    });
    const reference = $kc00y.useMemo(()=>({
            onKeyDown: onKeyDown
        }), [
        onKeyDown
    ]);
    const floating = $kc00y.useMemo(()=>{
        return {
            onKeyDown: onKeyDown,
            onKeyUp (event) {
                if (event.key === " ") setTypingChange(false);
            }
        };
    }, [
        onKeyDown,
        setTypingChange
    ]);
    return $kc00y.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating
        } : {}, [
        enabled,
        reference,
        floating
    ]);
}
function $8eab25943f557f5c$var$getArgsWithCustomFloatingHeight(state, height) {
    return {
        ...state,
        rects: {
            ...state.rects,
            floating: {
                ...state.rects.floating,
                height: height
            }
        }
    };
}
/**
 * Positions the floating element such that an inner element inside of it is
 * anchored to the reference element.
 * @see https://floating-ui.com/docs/inner
 */ const $8eab25943f557f5c$export$4ae363f1d88fb658 = (props)=>({
        name: "inner",
        options: props,
        async fn (state) {
            const { listRef: listRef, overflowRef: overflowRef, onFallbackChange: onFallbackChange, offset: innerOffset = 0, index: index = 0, minItemsVisible: minItemsVisible = 4, referenceOverflowThreshold: referenceOverflowThreshold = 0, scrollRef: scrollRef, ...detectOverflowOptions } = (0, $d9oMY.evaluate)(props, state);
            const { rects: rects, elements: { floating: floating } } = state;
            const item = listRef.current[index];
            const scrollEl = (scrollRef == null ? void 0 : scrollRef.current) || floating;
            // Valid combinations:
            // 1. Floating element is the scrollRef and has a border (default)
            // 2. Floating element is not the scrollRef, floating element has a border
            // 3. Floating element is not the scrollRef, scrollRef has a border
            // Floating > {...getFloatingProps()} wrapper > scrollRef > items is not
            // allowed as VoiceOver doesn't work.
            const clientTop = floating.clientTop || scrollEl.clientTop;
            const floatingIsBordered = floating.clientTop !== 0;
            const scrollElIsBordered = scrollEl.clientTop !== 0;
            const floatingIsScrollEl = floating === scrollEl;
            if (!item) return {};
            const nextArgs = {
                ...state,
                ...await (0, $jJYM0.offset)(-item.offsetTop - floating.clientTop - rects.reference.height / 2 - item.offsetHeight / 2 - innerOffset).fn(state)
            };
            const overflow = await (0, $jRiwg.detectOverflow)($8eab25943f557f5c$var$getArgsWithCustomFloatingHeight(nextArgs, scrollEl.scrollHeight + clientTop + floating.clientTop), detectOverflowOptions);
            const refOverflow = await (0, $jRiwg.detectOverflow)(nextArgs, {
                ...detectOverflowOptions,
                elementContext: "reference"
            });
            const diffY = (0, $d9oMY.max)(0, overflow.top);
            const nextY = nextArgs.y + diffY;
            const isScrollable = scrollEl.scrollHeight > scrollEl.clientHeight;
            const rounder = isScrollable ? (v)=>v : (0, $d9oMY.round);
            const maxHeight = rounder((0, $d9oMY.max)(0, scrollEl.scrollHeight + (floatingIsBordered && floatingIsScrollEl || scrollElIsBordered ? clientTop * 2 : 0) - diffY - (0, $d9oMY.max)(0, overflow.bottom)));
            scrollEl.style.maxHeight = maxHeight + "px";
            scrollEl.scrollTop = diffY;
            // There is not enough space, fallback to standard anchored positioning
            if (onFallbackChange) {
                const shouldFallback = isScrollable && scrollEl.offsetHeight < item.offsetHeight * minItemsVisible - 1 || refOverflow.top >= -referenceOverflowThreshold || refOverflow.bottom >= -referenceOverflowThreshold;
                $cn1Kz.flushSync(()=>onFallbackChange(shouldFallback));
            }
            if (overflowRef) overflowRef.current = await (0, $jRiwg.detectOverflow)($8eab25943f557f5c$var$getArgsWithCustomFloatingHeight({
                ...nextArgs,
                y: nextY
            }, scrollEl.offsetHeight + clientTop + floating.clientTop), detectOverflowOptions);
            return {
                y: nextY
            };
        }
    });
/**
 * Changes the `inner` middleware's `offset` upon a `wheel` event to
 * expand the floating element's height, revealing more list items.
 * @see https://floating-ui.com/docs/inner
 */ function $8eab25943f557f5c$export$3d74b0dda7cc82ff(context, props) {
    const { open: open, elements: elements } = context;
    const { enabled: enabled = true, overflowRef: overflowRef, scrollRef: scrollRef, onChange: unstable_onChange } = props;
    const onChange = $8eab25943f557f5c$var$useEffectEvent(unstable_onChange);
    const controlledScrollingRef = $kc00y.useRef(false);
    const prevScrollTopRef = $kc00y.useRef(null);
    const initialOverflowRef = $kc00y.useRef(null);
    $kc00y.useEffect(()=>{
        if (!enabled) return;
        function onWheel(e) {
            if (e.ctrlKey || !el || overflowRef.current == null) return;
            const dY = e.deltaY;
            const isAtTop = overflowRef.current.top >= -0.5;
            const isAtBottom = overflowRef.current.bottom >= -0.5;
            const remainingScroll = el.scrollHeight - el.clientHeight;
            const sign = dY < 0 ? -1 : 1;
            const method = dY < 0 ? "max" : "min";
            if (el.scrollHeight <= el.clientHeight) return;
            if (!isAtTop && dY > 0 || !isAtBottom && dY < 0) {
                e.preventDefault();
                $cn1Kz.flushSync(()=>{
                    onChange((d)=>d + Math[method](dY, remainingScroll * sign));
                });
            } else if (/firefox/i.test((0, $4vEIG.getUserAgent)())) // Needed to propagate scrolling during momentum scrolling phase once
            // it gets limited by the boundary. UX improvement, not critical.
            el.scrollTop += dY;
        }
        const el = (scrollRef == null ? void 0 : scrollRef.current) || elements.floating;
        if (open && el) {
            el.addEventListener("wheel", onWheel);
            // Wait for the position to be ready.
            requestAnimationFrame(()=>{
                prevScrollTopRef.current = el.scrollTop;
                if (overflowRef.current != null) initialOverflowRef.current = {
                    ...overflowRef.current
                };
            });
            return ()=>{
                prevScrollTopRef.current = null;
                initialOverflowRef.current = null;
                el.removeEventListener("wheel", onWheel);
            };
        }
    }, [
        enabled,
        open,
        elements.floating,
        overflowRef,
        scrollRef,
        onChange
    ]);
    const floating = $kc00y.useMemo(()=>({
            onKeyDown () {
                controlledScrollingRef.current = true;
            },
            onWheel () {
                controlledScrollingRef.current = false;
            },
            onPointerMove () {
                controlledScrollingRef.current = false;
            },
            onScroll () {
                const el = (scrollRef == null ? void 0 : scrollRef.current) || elements.floating;
                if (!overflowRef.current || !el || !controlledScrollingRef.current) return;
                if (prevScrollTopRef.current !== null) {
                    const scrollDiff = el.scrollTop - prevScrollTopRef.current;
                    if (overflowRef.current.bottom < -0.5 && scrollDiff < -1 || overflowRef.current.top < -0.5 && scrollDiff > 1) $cn1Kz.flushSync(()=>onChange((d)=>d + scrollDiff));
                }
                // [Firefox] Wait for the height change to have been applied.
                requestAnimationFrame(()=>{
                    prevScrollTopRef.current = el.scrollTop;
                });
            }
        }), [
        elements.floating,
        onChange,
        overflowRef,
        scrollRef
    ]);
    return $kc00y.useMemo(()=>enabled ? {
            floating: floating
        } : {}, [
        enabled,
        floating
    ]);
}
function $8eab25943f557f5c$var$isPointInPolygon(point, polygon) {
    const [x, y] = point;
    let isInside = false;
    const length = polygon.length;
    for(let i = 0, j = length - 1; i < length; j = i++){
        const [xi, yi] = polygon[i] || [
            0,
            0
        ];
        const [xj, yj] = polygon[j] || [
            0,
            0
        ];
        const intersect = yi >= y !== yj >= y && x <= (xj - xi) * (y - yi) / (yj - yi) + xi;
        if (intersect) isInside = !isInside;
    }
    return isInside;
}
function $8eab25943f557f5c$var$isInside(point, rect) {
    return point[0] >= rect.x && point[0] <= rect.x + rect.width && point[1] >= rect.y && point[1] <= rect.y + rect.height;
}
/**
 * Generates a safe polygon area that the user can traverse without closing the
 * floating element once leaving the reference element.
 * @see https://floating-ui.com/docs/useHover#safepolygon
 */ function $8eab25943f557f5c$export$7484214ab62358d2(options) {
    if (options === void 0) options = {};
    const { buffer: buffer = 0.5, blockPointerEvents: blockPointerEvents = false, requireIntent: requireIntent = true } = options;
    let timeoutId;
    let hasLanded = false;
    let lastX = null;
    let lastY = null;
    let lastCursorTime = performance.now();
    function getCursorSpeed(x, y) {
        const currentTime = performance.now();
        const elapsedTime = currentTime - lastCursorTime;
        if (lastX === null || lastY === null || elapsedTime === 0) {
            lastX = x;
            lastY = y;
            lastCursorTime = currentTime;
            return null;
        }
        const deltaX = x - lastX;
        const deltaY = y - lastY;
        const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
        const speed = distance / elapsedTime; // px / ms
        lastX = x;
        lastY = y;
        lastCursorTime = currentTime;
        return speed;
    }
    const fn = (_ref)=>{
        let { x: x, y: y, placement: placement, elements: elements, onClose: onClose, nodeId: nodeId, tree: tree } = _ref;
        return function onMouseMove(event) {
            function close() {
                clearTimeout(timeoutId);
                onClose();
            }
            clearTimeout(timeoutId);
            if (!elements.domReference || !elements.floating || placement == null || x == null || y == null) return;
            const { clientX: clientX, clientY: clientY } = event;
            const clientPoint = [
                clientX,
                clientY
            ];
            const target = (0, $4vEIG.getTarget)(event);
            const isLeave = event.type === "mouseleave";
            const isOverFloatingEl = (0, $4vEIG.contains)(elements.floating, target);
            const isOverReferenceEl = (0, $4vEIG.contains)(elements.domReference, target);
            const refRect = elements.domReference.getBoundingClientRect();
            const rect = elements.floating.getBoundingClientRect();
            const side = placement.split("-")[0];
            const cursorLeaveFromRight = x > rect.right - rect.width / 2;
            const cursorLeaveFromBottom = y > rect.bottom - rect.height / 2;
            const isOverReferenceRect = $8eab25943f557f5c$var$isInside(clientPoint, refRect);
            const isFloatingWider = rect.width > refRect.width;
            const isFloatingTaller = rect.height > refRect.height;
            const left = (isFloatingWider ? refRect : rect).left;
            const right = (isFloatingWider ? refRect : rect).right;
            const top = (isFloatingTaller ? refRect : rect).top;
            const bottom = (isFloatingTaller ? refRect : rect).bottom;
            if (isOverFloatingEl) {
                hasLanded = true;
                if (!isLeave) return;
            }
            if (isOverReferenceEl) hasLanded = false;
            if (isOverReferenceEl && !isLeave) {
                hasLanded = true;
                return;
            }
            // Prevent overlapping floating element from being stuck in an open-close
            // loop: https://github.com/floating-ui/floating-ui/issues/1910
            if (isLeave && (0, $gmW3q.isElement)(event.relatedTarget) && (0, $4vEIG.contains)(elements.floating, event.relatedTarget)) return;
            // If any nested child is open, abort.
            if (tree && $8eab25943f557f5c$var$getChildren(tree.nodesRef.current, nodeId).some((_ref2)=>{
                let { context: context } = _ref2;
                return context == null ? void 0 : context.open;
            })) return;
            // If the pointer is leaving from the opposite side, the "buffer" logic
            // creates a point where the floating element remains open, but should be
            // ignored.
            // A constant of 1 handles floating point rounding errors.
            if (side === "top" && y >= refRect.bottom - 1 || side === "bottom" && y <= refRect.top + 1 || side === "left" && x >= refRect.right - 1 || side === "right" && x <= refRect.left + 1) return close();
            // Ignore when the cursor is within the rectangular trough between the
            // two elements. Since the triangle is created from the cursor point,
            // which can start beyond the ref element's edge, traversing back and
            // forth from the ref to the floating element can cause it to close. This
            // ensures it always remains open in that case.
            let rectPoly = [];
            switch(side){
                case "top":
                    rectPoly = [
                        [
                            left,
                            refRect.top + 1
                        ],
                        [
                            left,
                            rect.bottom - 1
                        ],
                        [
                            right,
                            rect.bottom - 1
                        ],
                        [
                            right,
                            refRect.top + 1
                        ]
                    ];
                    break;
                case "bottom":
                    rectPoly = [
                        [
                            left,
                            rect.top + 1
                        ],
                        [
                            left,
                            refRect.bottom - 1
                        ],
                        [
                            right,
                            refRect.bottom - 1
                        ],
                        [
                            right,
                            rect.top + 1
                        ]
                    ];
                    break;
                case "left":
                    rectPoly = [
                        [
                            rect.right - 1,
                            bottom
                        ],
                        [
                            rect.right - 1,
                            top
                        ],
                        [
                            refRect.left + 1,
                            top
                        ],
                        [
                            refRect.left + 1,
                            bottom
                        ]
                    ];
                    break;
                case "right":
                    rectPoly = [
                        [
                            refRect.right - 1,
                            bottom
                        ],
                        [
                            refRect.right - 1,
                            top
                        ],
                        [
                            rect.left + 1,
                            top
                        ],
                        [
                            rect.left + 1,
                            bottom
                        ]
                    ];
                    break;
            }
            function getPolygon(_ref3) {
                let [x, y] = _ref3;
                switch(side){
                    case "top":
                        {
                            const cursorPointOne = [
                                isFloatingWider ? x + buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y + buffer + 1
                            ];
                            const cursorPointTwo = [
                                isFloatingWider ? x - buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y + buffer + 1
                            ];
                            const commonPoints = [
                                [
                                    rect.left,
                                    cursorLeaveFromRight ? rect.bottom - buffer : isFloatingWider ? rect.bottom - buffer : rect.top
                                ],
                                [
                                    rect.right,
                                    cursorLeaveFromRight ? isFloatingWider ? rect.bottom - buffer : rect.top : rect.bottom - buffer
                                ]
                            ];
                            return [
                                cursorPointOne,
                                cursorPointTwo,
                                ...commonPoints
                            ];
                        }
                    case "bottom":
                        {
                            const cursorPointOne = [
                                isFloatingWider ? x + buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y - buffer
                            ];
                            const cursorPointTwo = [
                                isFloatingWider ? x - buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y - buffer
                            ];
                            const commonPoints = [
                                [
                                    rect.left,
                                    cursorLeaveFromRight ? rect.top + buffer : isFloatingWider ? rect.top + buffer : rect.bottom
                                ],
                                [
                                    rect.right,
                                    cursorLeaveFromRight ? isFloatingWider ? rect.top + buffer : rect.bottom : rect.top + buffer
                                ]
                            ];
                            return [
                                cursorPointOne,
                                cursorPointTwo,
                                ...commonPoints
                            ];
                        }
                    case "left":
                        {
                            const cursorPointOne = [
                                x + buffer + 1,
                                isFloatingTaller ? y + buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const cursorPointTwo = [
                                x + buffer + 1,
                                isFloatingTaller ? y - buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const commonPoints = [
                                [
                                    cursorLeaveFromBottom ? rect.right - buffer : isFloatingTaller ? rect.right - buffer : rect.left,
                                    rect.top
                                ],
                                [
                                    cursorLeaveFromBottom ? isFloatingTaller ? rect.right - buffer : rect.left : rect.right - buffer,
                                    rect.bottom
                                ]
                            ];
                            return [
                                ...commonPoints,
                                cursorPointOne,
                                cursorPointTwo
                            ];
                        }
                    case "right":
                        {
                            const cursorPointOne = [
                                x - buffer,
                                isFloatingTaller ? y + buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const cursorPointTwo = [
                                x - buffer,
                                isFloatingTaller ? y - buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const commonPoints = [
                                [
                                    cursorLeaveFromBottom ? rect.left + buffer : isFloatingTaller ? rect.left + buffer : rect.right,
                                    rect.top
                                ],
                                [
                                    cursorLeaveFromBottom ? isFloatingTaller ? rect.left + buffer : rect.right : rect.left + buffer,
                                    rect.bottom
                                ]
                            ];
                            return [
                                cursorPointOne,
                                cursorPointTwo,
                                ...commonPoints
                            ];
                        }
                }
            }
            if ($8eab25943f557f5c$var$isPointInPolygon([
                clientX,
                clientY
            ], rectPoly)) return;
            if (hasLanded && !isOverReferenceRect) return close();
            if (!isLeave && requireIntent) {
                const cursorSpeed = getCursorSpeed(event.clientX, event.clientY);
                const cursorSpeedThreshold = 0.1;
                if (cursorSpeed !== null && cursorSpeed < cursorSpeedThreshold) return close();
            }
            if (!$8eab25943f557f5c$var$isPointInPolygon([
                clientX,
                clientY
            ], getPolygon([
                x,
                y
            ]))) close();
            else if (!hasLanded && requireIntent) timeoutId = window.setTimeout(close, 40);
        };
    };
    fn.__options = {
        blockPointerEvents: blockPointerEvents
    };
    return fn;
}

});
parcelRegister("4vEIG", function(module, exports) {

$parcel$export(module.exports, "activeElement", () => $3489a4c68d030955$export$da980962bd2147a4);
$parcel$export(module.exports, "contains", () => $3489a4c68d030955$export$2344b14b097df817);
$parcel$export(module.exports, "getPlatform", () => $3489a4c68d030955$export$867a782338812cb4);
$parcel$export(module.exports, "getUserAgent", () => $3489a4c68d030955$export$7935961ef7719cb0);
$parcel$export(module.exports, "isVirtualClick", () => $3489a4c68d030955$export$60278871457622de);
$parcel$export(module.exports, "isVirtualPointerEvent", () => $3489a4c68d030955$export$29bf1b5f2c56cf63);
$parcel$export(module.exports, "isSafari", () => $3489a4c68d030955$export$95df08bae54cb4df);
$parcel$export(module.exports, "isMac", () => $3489a4c68d030955$export$9ac100e40613ea10);
$parcel$export(module.exports, "isMouseLikePointerType", () => $3489a4c68d030955$export$81cf264172d31e51);
$parcel$export(module.exports, "isReactEvent", () => $3489a4c68d030955$export$94781ce41a161222);
$parcel$export(module.exports, "isRootElement", () => $3489a4c68d030955$export$7b296c28e0fa3aed);
$parcel$export(module.exports, "getDocument", () => $3489a4c68d030955$export$f65ca476c09acec0);
$parcel$export(module.exports, "isEventTargetWithin", () => $3489a4c68d030955$export$43c3154d5bf2c6c2);
$parcel$export(module.exports, "getTarget", () => $3489a4c68d030955$export$c22522a4dfa48e9c);
$parcel$export(module.exports, "isTypeableElement", () => $3489a4c68d030955$export$42ad131c32f0fb8d);
$parcel$export(module.exports, "stopEvent", () => $3489a4c68d030955$export$7ae4cd3a66c1e050);
$parcel$export(module.exports, "isTypeableCombobox", () => $3489a4c68d030955$export$259ba5ae38188551);

var $gmW3q = parcelRequire("gmW3q");
function $3489a4c68d030955$export$da980962bd2147a4(doc) {
    let activeElement = doc.activeElement;
    while(((_activeElement = activeElement) == null || (_activeElement = _activeElement.shadowRoot) == null ? void 0 : _activeElement.activeElement) != null){
        var _activeElement;
        activeElement = activeElement.shadowRoot.activeElement;
    }
    return activeElement;
}
function $3489a4c68d030955$export$2344b14b097df817(parent, child) {
    if (!parent || !child) return false;
    const rootNode = child.getRootNode == null ? void 0 : child.getRootNode();
    // First, attempt with faster native method
    if (parent.contains(child)) return true;
    // then fallback to custom implementation with Shadow DOM support
    if (rootNode && (0, $gmW3q.isShadowRoot)(rootNode)) {
        let next = child;
        while(next){
            if (parent === next) return true;
            // @ts-ignore
            next = next.parentNode || next.host;
        }
    }
    // Give up, the result is false
    return false;
}
// Avoid Chrome DevTools blue warning.
function $3489a4c68d030955$export$867a782338812cb4() {
    const uaData = navigator.userAgentData;
    if (uaData != null && uaData.platform) return uaData.platform;
    return navigator.platform;
}
function $3489a4c68d030955$export$7935961ef7719cb0() {
    const uaData = navigator.userAgentData;
    if (uaData && Array.isArray(uaData.brands)) return uaData.brands.map((_ref)=>{
        let { brand: brand, version: version } = _ref;
        return brand + "/" + version;
    }).join(" ");
    return navigator.userAgent;
}
// License: https://github.com/adobe/react-spectrum/blob/b35d5c02fe900badccd0cf1a8f23bb593419f238/packages/@react-aria/utils/src/isVirtualEvent.ts
function $3489a4c68d030955$export$60278871457622de(event) {
    // FIXME: Firefox is now emitting a deprecation warning for `mozInputSource`.
    // Try to find a workaround for this. `react-aria` source still has the check.
    if (event.mozInputSource === 0 && event.isTrusted) return true;
    if ($3489a4c68d030955$export$a11b0059900ceec8() && event.pointerType) return event.type === "click" && event.buttons === 1;
    return event.detail === 0 && !event.pointerType;
}
function $3489a4c68d030955$export$29bf1b5f2c56cf63(event) {
    if ($3489a4c68d030955$export$c8f880a2d81914c4()) return false;
    return !$3489a4c68d030955$export$a11b0059900ceec8() && event.width === 0 && event.height === 0 || $3489a4c68d030955$export$a11b0059900ceec8() && event.width === 1 && event.height === 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === "mouse" || // iOS VoiceOver returns 0.333• for width/height.
    event.width < 1 && event.height < 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === "touch";
}
function $3489a4c68d030955$export$95df08bae54cb4df() {
    // Chrome DevTools does not complain about navigator.vendor
    return /apple/i.test(navigator.vendor);
}
function $3489a4c68d030955$export$a11b0059900ceec8() {
    const re = /android/i;
    return re.test($3489a4c68d030955$export$867a782338812cb4()) || re.test($3489a4c68d030955$export$7935961ef7719cb0());
}
function $3489a4c68d030955$export$9ac100e40613ea10() {
    return $3489a4c68d030955$export$867a782338812cb4().toLowerCase().startsWith("mac") && !navigator.maxTouchPoints;
}
function $3489a4c68d030955$export$c8f880a2d81914c4() {
    return $3489a4c68d030955$export$7935961ef7719cb0().includes("jsdom/");
}
function $3489a4c68d030955$export$81cf264172d31e51(pointerType, strict) {
    // On some Linux machines with Chromium, mouse inputs return a `pointerType`
    // of "pen": https://github.com/floating-ui/floating-ui/issues/2015
    const values = [
        "mouse",
        "pen"
    ];
    if (!strict) values.push("", undefined);
    return values.includes(pointerType);
}
function $3489a4c68d030955$export$94781ce41a161222(event) {
    return "nativeEvent" in event;
}
function $3489a4c68d030955$export$7b296c28e0fa3aed(element) {
    return element.matches("html,body");
}
function $3489a4c68d030955$export$f65ca476c09acec0(node) {
    return (node == null ? void 0 : node.ownerDocument) || document;
}
function $3489a4c68d030955$export$43c3154d5bf2c6c2(event, node) {
    if (node == null) return false;
    if ("composedPath" in event) return event.composedPath().includes(node);
    // TS thinks `event` is of type never as it assumes all browsers support composedPath, but browsers without shadow dom don't
    const e = event;
    return e.target != null && node.contains(e.target);
}
function $3489a4c68d030955$export$c22522a4dfa48e9c(event) {
    if ("composedPath" in event) return event.composedPath()[0];
    // TS thinks `event` is of type never as it assumes all browsers support
    // `composedPath()`, but browsers without shadow DOM don't.
    return event.target;
}
const $3489a4c68d030955$export$78b3d091ff376bc = "input:not([type='hidden']):not([disabled]),[contenteditable]:not([contenteditable='false']),textarea:not([disabled])";
function $3489a4c68d030955$export$42ad131c32f0fb8d(element) {
    return (0, $gmW3q.isHTMLElement)(element) && element.matches($3489a4c68d030955$export$78b3d091ff376bc);
}
function $3489a4c68d030955$export$7ae4cd3a66c1e050(event) {
    event.preventDefault();
    event.stopPropagation();
}
function $3489a4c68d030955$export$259ba5ae38188551(element) {
    if (!element) return false;
    return element.getAttribute("role") === "combobox" && $3489a4c68d030955$export$42ad131c32f0fb8d(element);
}

});

parcelRegister("6uiEn", function(module, exports) {

$parcel$export(module.exports, "tabbable", () => $4b9402f7537e5040$export$17100aea90429aa7);
$parcel$export(module.exports, "isTabbable", () => $4b9402f7537e5040$export$bebd5a1431fec25d);
/*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/ // NOTE: separate `:not()` selectors has broader browser support than the newer
//  `:not([inert], [inert] *)` (Feb 2023)
// CAREFUL: JSDom does not support `:not([inert] *)` as a selector; using it causes
//  the entire query to fail, resulting in no nodes found, which will break a lot
//  of things... so we have to rely on JS to identify nodes inside an inert container
var $4b9402f7537e5040$var$candidateSelectors = [
    "input:not([inert])",
    "select:not([inert])",
    "textarea:not([inert])",
    "a[href]:not([inert])",
    "button:not([inert])",
    "[tabindex]:not(slot):not([inert])",
    "audio[controls]:not([inert])",
    "video[controls]:not([inert])",
    '[contenteditable]:not([contenteditable="false"]):not([inert])',
    "details>summary:first-of-type:not([inert])",
    "details:not([inert])"
];
var $4b9402f7537e5040$var$candidateSelector = /* #__PURE__ */ $4b9402f7537e5040$var$candidateSelectors.join(",");
var $4b9402f7537e5040$var$NoElement = typeof Element === "undefined";
var $4b9402f7537e5040$var$matches = $4b9402f7537e5040$var$NoElement ? function() {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
var $4b9402f7537e5040$var$getRootNode = !$4b9402f7537e5040$var$NoElement && Element.prototype.getRootNode ? function(element) {
    var _element$getRootNode;
    return element === null || element === void 0 ? void 0 : (_element$getRootNode = element.getRootNode) === null || _element$getRootNode === void 0 ? void 0 : _element$getRootNode.call(element);
} : function(element) {
    return element === null || element === void 0 ? void 0 : element.ownerDocument;
};
/**
 * Determines if a node is inert or in an inert ancestor.
 * @param {Element} [node]
 * @param {boolean} [lookUp] If true and `node` is not inert, looks up at ancestors to
 *  see if any of them are inert. If false, only `node` itself is considered.
 * @returns {boolean} True if inert itself or by way of being in an inert ancestor.
 *  False if `node` is falsy.
 */ var $4b9402f7537e5040$var$isInert = function isInert(node, lookUp) {
    var _node$getAttribute;
    if (lookUp === void 0) lookUp = true;
    // CAREFUL: JSDom does not support inert at all, so we can't use the `HTMLElement.inert`
    //  JS API property; we have to check the attribute, which can either be empty or 'true';
    //  if it's `null` (not specified) or 'false', it's an active element
    var inertAtt = node === null || node === void 0 ? void 0 : (_node$getAttribute = node.getAttribute) === null || _node$getAttribute === void 0 ? void 0 : _node$getAttribute.call(node, "inert");
    var inert = inertAtt === "" || inertAtt === "true";
    // NOTE: this could also be handled with `node.matches('[inert], :is([inert] *)')`
    //  if it weren't for `matches()` not being a function on shadow roots; the following
    //  code works for any kind of node
    // CAREFUL: JSDom does not appear to support certain selectors like `:not([inert] *)`
    //  so it likely would not support `:is([inert] *)` either...
    var result = inert || lookUp && node && isInert(node.parentNode); // recursive
    return result;
};
/**
 * Determines if a node's content is editable.
 * @param {Element} [node]
 * @returns True if it's content-editable; false if it's not or `node` is falsy.
 */ var $4b9402f7537e5040$var$isContentEditable = function isContentEditable(node) {
    var _node$getAttribute2;
    // CAREFUL: JSDom does not support the `HTMLElement.isContentEditable` API so we have
    //  to use the attribute directly to check for this, which can either be empty or 'true';
    //  if it's `null` (not specified) or 'false', it's a non-editable element
    var attValue = node === null || node === void 0 ? void 0 : (_node$getAttribute2 = node.getAttribute) === null || _node$getAttribute2 === void 0 ? void 0 : _node$getAttribute2.call(node, "contenteditable");
    return attValue === "" || attValue === "true";
};
/**
 * @param {Element} el container to check in
 * @param {boolean} includeContainer add container to check
 * @param {(node: Element) => boolean} filter filter candidates
 * @returns {Element[]}
 */ var $4b9402f7537e5040$var$getCandidates = function getCandidates(el, includeContainer, filter) {
    // even if `includeContainer=false`, we still have to check it for inertness because
    //  if it's inert, all its children are inert
    if ($4b9402f7537e5040$var$isInert(el)) return [];
    var candidates = Array.prototype.slice.apply(el.querySelectorAll($4b9402f7537e5040$var$candidateSelector));
    if (includeContainer && $4b9402f7537e5040$var$matches.call(el, $4b9402f7537e5040$var$candidateSelector)) candidates.unshift(el);
    candidates = candidates.filter(filter);
    return candidates;
};
/**
 * @callback GetShadowRoot
 * @param {Element} element to check for shadow root
 * @returns {ShadowRoot|boolean} ShadowRoot if available or boolean indicating if a shadowRoot is attached but not available.
 */ /**
 * @callback ShadowRootFilter
 * @param {Element} shadowHostNode the element which contains shadow content
 * @returns {boolean} true if a shadow root could potentially contain valid candidates.
 */ /**
 * @typedef {Object} CandidateScope
 * @property {Element} scopeParent contains inner candidates
 * @property {Element[]} candidates list of candidates found in the scope parent
 */ /**
 * @typedef {Object} IterativeOptions
 * @property {GetShadowRoot|boolean} getShadowRoot true if shadow support is enabled; falsy if not;
 *  if a function, implies shadow support is enabled and either returns the shadow root of an element
 *  or a boolean stating if it has an undisclosed shadow root
 * @property {(node: Element) => boolean} filter filter candidates
 * @property {boolean} flatten if true then result will flatten any CandidateScope into the returned list
 * @property {ShadowRootFilter} shadowRootFilter filter shadow roots;
 */ /**
 * @param {Element[]} elements list of element containers to match candidates from
 * @param {boolean} includeContainer add container list to check
 * @param {IterativeOptions} options
 * @returns {Array.<Element|CandidateScope>}
 */ var $4b9402f7537e5040$var$getCandidatesIteratively = function getCandidatesIteratively(elements, includeContainer, options) {
    var candidates = [];
    var elementsToCheck = Array.from(elements);
    while(elementsToCheck.length){
        var element = elementsToCheck.shift();
        if ($4b9402f7537e5040$var$isInert(element, false)) continue;
        if (element.tagName === "SLOT") {
            // add shadow dom slot scope (slot itself cannot be focusable)
            var assigned = element.assignedElements();
            var content = assigned.length ? assigned : element.children;
            var nestedCandidates = getCandidatesIteratively(content, true, options);
            if (options.flatten) candidates.push.apply(candidates, nestedCandidates);
            else candidates.push({
                scopeParent: element,
                candidates: nestedCandidates
            });
        } else {
            // check candidate element
            var validCandidate = $4b9402f7537e5040$var$matches.call(element, $4b9402f7537e5040$var$candidateSelector);
            if (validCandidate && options.filter(element) && (includeContainer || !elements.includes(element))) candidates.push(element);
            // iterate over shadow content if possible
            var shadowRoot = element.shadowRoot || // check for an undisclosed shadow
            typeof options.getShadowRoot === "function" && options.getShadowRoot(element);
            // no inert look up because we're already drilling down and checking for inertness
            //  on the way down, so all containers to this root node should have already been
            //  vetted as non-inert
            var validShadowRoot = !$4b9402f7537e5040$var$isInert(shadowRoot, false) && (!options.shadowRootFilter || options.shadowRootFilter(element));
            if (shadowRoot && validShadowRoot) {
                // add shadow dom scope IIF a shadow root node was given; otherwise, an undisclosed
                //  shadow exists, so look at light dom children as fallback BUT create a scope for any
                //  child candidates found because they're likely slotted elements (elements that are
                //  children of the web component element (which has the shadow), in the light dom, but
                //  slotted somewhere _inside_ the undisclosed shadow) -- the scope is created below,
                //  _after_ we return from this recursive call
                var _nestedCandidates = getCandidatesIteratively(shadowRoot === true ? element.children : shadowRoot.children, true, options);
                if (options.flatten) candidates.push.apply(candidates, _nestedCandidates);
                else candidates.push({
                    scopeParent: element,
                    candidates: _nestedCandidates
                });
            } else // there's not shadow so just dig into the element's (light dom) children
            //  __without__ giving the element special scope treatment
            elementsToCheck.unshift.apply(elementsToCheck, element.children);
        }
    }
    return candidates;
};
/**
 * @private
 * Determines if the node has an explicitly specified `tabindex` attribute.
 * @param {HTMLElement} node
 * @returns {boolean} True if so; false if not.
 */ var $4b9402f7537e5040$var$hasTabIndex = function hasTabIndex(node) {
    return !isNaN(parseInt(node.getAttribute("tabindex"), 10));
};
/**
 * Determine the tab index of a given node.
 * @param {HTMLElement} node
 * @returns {number} Tab order (negative, 0, or positive number).
 * @throws {Error} If `node` is falsy.
 */ var $4b9402f7537e5040$export$a4672efddb4181b8 = function getTabIndex(node) {
    if (!node) throw new Error("No node provided");
    if (node.tabIndex < 0) {
        // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
        // `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
        // yet they are still part of the regular tab order; in FF, they get a default
        // `tabIndex` of 0; since Chrome still puts those elements in the regular tab
        // order, consider their tab index to be 0.
        // Also browsers do not return `tabIndex` correctly for contentEditable nodes;
        // so if they don't have a tabindex attribute specifically set, assume it's 0.
        if ((/^(AUDIO|VIDEO|DETAILS)$/.test(node.tagName) || $4b9402f7537e5040$var$isContentEditable(node)) && !$4b9402f7537e5040$var$hasTabIndex(node)) return 0;
    }
    return node.tabIndex;
};
/**
 * Determine the tab index of a given node __for sort order purposes__.
 * @param {HTMLElement} node
 * @param {boolean} [isScope] True for a custom element with shadow root or slot that, by default,
 *  has tabIndex -1, but needs to be sorted by document order in order for its content to be
 *  inserted into the correct sort position.
 * @returns {number} Tab order (negative, 0, or positive number).
 */ var $4b9402f7537e5040$var$getSortOrderTabIndex = function getSortOrderTabIndex(node, isScope) {
    var tabIndex = $4b9402f7537e5040$export$a4672efddb4181b8(node);
    if (tabIndex < 0 && isScope && !$4b9402f7537e5040$var$hasTabIndex(node)) return 0;
    return tabIndex;
};
var $4b9402f7537e5040$var$sortOrderedTabbables = function sortOrderedTabbables(a, b) {
    return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
};
var $4b9402f7537e5040$var$isInput = function isInput(node) {
    return node.tagName === "INPUT";
};
var $4b9402f7537e5040$var$isHiddenInput = function isHiddenInput(node) {
    return $4b9402f7537e5040$var$isInput(node) && node.type === "hidden";
};
var $4b9402f7537e5040$var$isDetailsWithSummary = function isDetailsWithSummary(node) {
    var r = node.tagName === "DETAILS" && Array.prototype.slice.apply(node.children).some(function(child) {
        return child.tagName === "SUMMARY";
    });
    return r;
};
var $4b9402f7537e5040$var$getCheckedRadio = function getCheckedRadio(nodes, form) {
    for(var i = 0; i < nodes.length; i++){
        if (nodes[i].checked && nodes[i].form === form) return nodes[i];
    }
};
var $4b9402f7537e5040$var$isTabbableRadio = function isTabbableRadio(node) {
    if (!node.name) return true;
    var radioScope = node.form || $4b9402f7537e5040$var$getRootNode(node);
    var queryRadios = function queryRadios(name) {
        return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]');
    };
    var radioSet;
    if (typeof window !== "undefined" && typeof window.CSS !== "undefined" && typeof window.CSS.escape === "function") radioSet = queryRadios(window.CSS.escape(node.name));
    else try {
        radioSet = queryRadios(node.name);
    } catch (err) {
        // eslint-disable-next-line no-console
        console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", err.message);
        return false;
    }
    var checked = $4b9402f7537e5040$var$getCheckedRadio(radioSet, node.form);
    return !checked || checked === node;
};
var $4b9402f7537e5040$var$isRadio = function isRadio(node) {
    return $4b9402f7537e5040$var$isInput(node) && node.type === "radio";
};
var $4b9402f7537e5040$var$isNonTabbableRadio = function isNonTabbableRadio(node) {
    return $4b9402f7537e5040$var$isRadio(node) && !$4b9402f7537e5040$var$isTabbableRadio(node);
};
// determines if a node is ultimately attached to the window's document
var $4b9402f7537e5040$var$isNodeAttached = function isNodeAttached(node) {
    var _nodeRoot;
    // The root node is the shadow root if the node is in a shadow DOM; some document otherwise
    //  (but NOT _the_ document; see second 'If' comment below for more).
    // If rootNode is shadow root, it'll have a host, which is the element to which the shadow
    //  is attached, and the one we need to check if it's in the document or not (because the
    //  shadow, and all nodes it contains, is never considered in the document since shadows
    //  behave like self-contained DOMs; but if the shadow's HOST, which is part of the document,
    //  is hidden, or is not in the document itself but is detached, it will affect the shadow's
    //  visibility, including all the nodes it contains). The host could be any normal node,
    //  or a custom element (i.e. web component). Either way, that's the one that is considered
    //  part of the document, not the shadow root, nor any of its children (i.e. the node being
    //  tested).
    // To further complicate things, we have to look all the way up until we find a shadow HOST
    //  that is attached (or find none) because the node might be in nested shadows...
    // If rootNode is not a shadow root, it won't have a host, and so rootNode should be the
    //  document (per the docs) and while it's a Document-type object, that document does not
    //  appear to be the same as the node's `ownerDocument` for some reason, so it's safer
    //  to ignore the rootNode at this point, and use `node.ownerDocument`. Otherwise,
    //  using `rootNode.contains(node)` will _always_ be true we'll get false-positives when
    //  node is actually detached.
    // NOTE: If `nodeRootHost` or `node` happens to be the `document` itself (which is possible
    //  if a tabbable/focusable node was quickly added to the DOM, focused, and then removed
    //  from the DOM as in https://github.com/focus-trap/focus-trap-react/issues/905), then
    //  `ownerDocument` will be `null`, hence the optional chaining on it.
    var nodeRoot = node && $4b9402f7537e5040$var$getRootNode(node);
    var nodeRootHost = (_nodeRoot = nodeRoot) === null || _nodeRoot === void 0 ? void 0 : _nodeRoot.host;
    // in some cases, a detached node will return itself as the root instead of a document or
    //  shadow root object, in which case, we shouldn't try to look further up the host chain
    var attached = false;
    if (nodeRoot && nodeRoot !== node) {
        var _nodeRootHost, _nodeRootHost$ownerDo, _node$ownerDocument;
        attached = !!((_nodeRootHost = nodeRootHost) !== null && _nodeRootHost !== void 0 && (_nodeRootHost$ownerDo = _nodeRootHost.ownerDocument) !== null && _nodeRootHost$ownerDo !== void 0 && _nodeRootHost$ownerDo.contains(nodeRootHost) || node !== null && node !== void 0 && (_node$ownerDocument = node.ownerDocument) !== null && _node$ownerDocument !== void 0 && _node$ownerDocument.contains(node));
        while(!attached && nodeRootHost){
            var _nodeRoot2, _nodeRootHost2, _nodeRootHost2$ownerD;
            // since it's not attached and we have a root host, the node MUST be in a nested shadow DOM,
            //  which means we need to get the host's host and check if that parent host is contained
            //  in (i.e. attached to) the document
            nodeRoot = $4b9402f7537e5040$var$getRootNode(nodeRootHost);
            nodeRootHost = (_nodeRoot2 = nodeRoot) === null || _nodeRoot2 === void 0 ? void 0 : _nodeRoot2.host;
            attached = !!((_nodeRootHost2 = nodeRootHost) !== null && _nodeRootHost2 !== void 0 && (_nodeRootHost2$ownerD = _nodeRootHost2.ownerDocument) !== null && _nodeRootHost2$ownerD !== void 0 && _nodeRootHost2$ownerD.contains(nodeRootHost));
        }
    }
    return attached;
};
var $4b9402f7537e5040$var$isZeroArea = function isZeroArea(node) {
    var _node$getBoundingClie = node.getBoundingClientRect(), width = _node$getBoundingClie.width, height = _node$getBoundingClie.height;
    return width === 0 && height === 0;
};
var $4b9402f7537e5040$var$isHidden = function isHidden(node, _ref) {
    var displayCheck = _ref.displayCheck, getShadowRoot = _ref.getShadowRoot;
    // NOTE: visibility will be `undefined` if node is detached from the document
    //  (see notes about this further down), which means we will consider it visible
    //  (this is legacy behavior from a very long way back)
    // NOTE: we check this regardless of `displayCheck="none"` because this is a
    //  _visibility_ check, not a _display_ check
    if (getComputedStyle(node).visibility === "hidden") return true;
    var isDirectSummary = $4b9402f7537e5040$var$matches.call(node, "details>summary:first-of-type");
    var nodeUnderDetails = isDirectSummary ? node.parentElement : node;
    if ($4b9402f7537e5040$var$matches.call(nodeUnderDetails, "details:not([open]) *")) return true;
    if (!displayCheck || displayCheck === "full" || displayCheck === "legacy-full") {
        if (typeof getShadowRoot === "function") {
            // figure out if we should consider the node to be in an undisclosed shadow and use the
            //  'non-zero-area' fallback
            var originalNode = node;
            while(node){
                var parentElement = node.parentElement;
                var rootNode = $4b9402f7537e5040$var$getRootNode(node);
                if (parentElement && !parentElement.shadowRoot && getShadowRoot(parentElement) === true // check if there's an undisclosed shadow
                ) // node has an undisclosed shadow which means we can only treat it as a black box, so we
                //  fall back to a non-zero-area test
                return $4b9402f7537e5040$var$isZeroArea(node);
                else if (node.assignedSlot) // iterate up slot
                node = node.assignedSlot;
                else if (!parentElement && rootNode !== node.ownerDocument) // cross shadow boundary
                node = rootNode.host;
                else // iterate up normal dom
                node = parentElement;
            }
            node = originalNode;
        }
        // else, `getShadowRoot` might be true, but all that does is enable shadow DOM support
        //  (i.e. it does not also presume that all nodes might have undisclosed shadows); or
        //  it might be a falsy value, which means shadow DOM support is disabled
        // Since we didn't find it sitting in an undisclosed shadow (or shadows are disabled)
        //  now we can just test to see if it would normally be visible or not, provided it's
        //  attached to the main document.
        // NOTE: We must consider case where node is inside a shadow DOM and given directly to
        //  `isTabbable()` or `isFocusable()` -- regardless of `getShadowRoot` option setting.
        if ($4b9402f7537e5040$var$isNodeAttached(node)) // this works wherever the node is: if there's at least one client rect, it's
        //  somehow displayed; it also covers the CSS 'display: contents' case where the
        //  node itself is hidden in place of its contents; and there's no need to search
        //  up the hierarchy either
        return !node.getClientRects().length;
        // Else, the node isn't attached to the document, which means the `getClientRects()`
        //  API will __always__ return zero rects (this can happen, for example, if React
        //  is used to render nodes onto a detached tree, as confirmed in this thread:
        //  https://github.com/facebook/react/issues/9117#issuecomment-284228870)
        //
        // It also means that even window.getComputedStyle(node).display will return `undefined`
        //  because styles are only computed for nodes that are in the document.
        //
        // NOTE: THIS HAS BEEN THE CASE FOR YEARS. It is not new, nor is it caused by tabbable
        //  somehow. Though it was never stated officially, anyone who has ever used tabbable
        //  APIs on nodes in detached containers has actually implicitly used tabbable in what
        //  was later (as of v5.2.0 on Apr 9, 2021) called `displayCheck="none"` mode -- essentially
        //  considering __everything__ to be visible because of the innability to determine styles.
        //
        // v6.0.0: As of this major release, the default 'full' option __no longer treats detached
        //  nodes as visible with the 'none' fallback.__
        if (displayCheck !== "legacy-full") return true; // hidden
    // else, fallback to 'none' mode and consider the node visible
    } else if (displayCheck === "non-zero-area") // NOTE: Even though this tests that the node's client rect is non-zero to determine
    //  whether it's displayed, and that a detached node will __always__ have a zero-area
    //  client rect, we don't special-case for whether the node is attached or not. In
    //  this mode, we do want to consider nodes that have a zero area to be hidden at all
    //  times, and that includes attached or not.
    return $4b9402f7537e5040$var$isZeroArea(node);
    // visible, as far as we can tell, or per current `displayCheck=none` mode, we assume
    //  it's visible
    return false;
};
// form fields (nested) inside a disabled fieldset are not focusable/tabbable
//  unless they are in the _first_ <legend> element of the top-most disabled
//  fieldset
var $4b9402f7537e5040$var$isDisabledFromFieldset = function isDisabledFromFieldset(node) {
    if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(node.tagName)) {
        var parentNode = node.parentElement;
        // check if `node` is contained in a disabled <fieldset>
        while(parentNode){
            if (parentNode.tagName === "FIELDSET" && parentNode.disabled) {
                // look for the first <legend> among the children of the disabled <fieldset>
                for(var i = 0; i < parentNode.children.length; i++){
                    var child = parentNode.children.item(i);
                    // when the first <legend> (in document order) is found
                    if (child.tagName === "LEGEND") // if its parent <fieldset> is not nested in another disabled <fieldset>,
                    // return whether `node` is a descendant of its first <legend>
                    return $4b9402f7537e5040$var$matches.call(parentNode, "fieldset[disabled] *") ? true : !child.contains(node);
                }
                // the disabled <fieldset> containing `node` has no <legend>
                return true;
            }
            parentNode = parentNode.parentElement;
        }
    }
    // else, node's tabbable/focusable state should not be affected by a fieldset's
    //  enabled/disabled state
    return false;
};
var $4b9402f7537e5040$var$isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable(options, node) {
    if (node.disabled || // we must do an inert look up to filter out any elements inside an inert ancestor
    //  because we're limited in the type of selectors we can use in JSDom (see related
    //  note related to `candidateSelectors`)
    $4b9402f7537e5040$var$isInert(node) || $4b9402f7537e5040$var$isHiddenInput(node) || $4b9402f7537e5040$var$isHidden(node, options) || // For a details element with a summary, the summary element gets the focus
    $4b9402f7537e5040$var$isDetailsWithSummary(node) || $4b9402f7537e5040$var$isDisabledFromFieldset(node)) return false;
    return true;
};
var $4b9402f7537e5040$var$isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable(options, node) {
    if ($4b9402f7537e5040$var$isNonTabbableRadio(node) || $4b9402f7537e5040$export$a4672efddb4181b8(node) < 0 || !$4b9402f7537e5040$var$isNodeMatchingSelectorFocusable(options, node)) return false;
    return true;
};
var $4b9402f7537e5040$var$isValidShadowRootTabbable = function isValidShadowRootTabbable(shadowHostNode) {
    var tabIndex = parseInt(shadowHostNode.getAttribute("tabindex"), 10);
    if (isNaN(tabIndex) || tabIndex >= 0) return true;
    // If a custom element has an explicit negative tabindex,
    // browsers will not allow tab targeting said element's children.
    return false;
};
/**
 * @param {Array.<Element|CandidateScope>} candidates
 * @returns Element[]
 */ var $4b9402f7537e5040$var$sortByOrder = function sortByOrder(candidates) {
    var regularTabbables = [];
    var orderedTabbables = [];
    candidates.forEach(function(item, i) {
        var isScope = !!item.scopeParent;
        var element = isScope ? item.scopeParent : item;
        var candidateTabindex = $4b9402f7537e5040$var$getSortOrderTabIndex(element, isScope);
        var elements = isScope ? sortByOrder(item.candidates) : element;
        if (candidateTabindex === 0) isScope ? regularTabbables.push.apply(regularTabbables, elements) : regularTabbables.push(element);
        else orderedTabbables.push({
            documentOrder: i,
            tabIndex: candidateTabindex,
            item: item,
            isScope: isScope,
            content: elements
        });
    });
    return orderedTabbables.sort($4b9402f7537e5040$var$sortOrderedTabbables).reduce(function(acc, sortable) {
        sortable.isScope ? acc.push.apply(acc, sortable.content) : acc.push(sortable.content);
        return acc;
    }, []).concat(regularTabbables);
};
var $4b9402f7537e5040$export$17100aea90429aa7 = function tabbable(container, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = $4b9402f7537e5040$var$getCandidatesIteratively([
        container
    ], options.includeContainer, {
        filter: $4b9402f7537e5040$var$isNodeMatchingSelectorTabbable.bind(null, options),
        flatten: false,
        getShadowRoot: options.getShadowRoot,
        shadowRootFilter: $4b9402f7537e5040$var$isValidShadowRootTabbable
    });
    else candidates = $4b9402f7537e5040$var$getCandidates(container, options.includeContainer, $4b9402f7537e5040$var$isNodeMatchingSelectorTabbable.bind(null, options));
    return $4b9402f7537e5040$var$sortByOrder(candidates);
};
var $4b9402f7537e5040$export$ecc6d1fcdff4f700 = function focusable(container, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = $4b9402f7537e5040$var$getCandidatesIteratively([
        container
    ], options.includeContainer, {
        filter: $4b9402f7537e5040$var$isNodeMatchingSelectorFocusable.bind(null, options),
        flatten: true,
        getShadowRoot: options.getShadowRoot
    });
    else candidates = $4b9402f7537e5040$var$getCandidates(container, options.includeContainer, $4b9402f7537e5040$var$isNodeMatchingSelectorFocusable.bind(null, options));
    return candidates;
};
var $4b9402f7537e5040$export$bebd5a1431fec25d = function isTabbable(node, options) {
    options = options || {};
    if (!node) throw new Error("No node provided");
    if ($4b9402f7537e5040$var$matches.call(node, $4b9402f7537e5040$var$candidateSelector) === false) return false;
    return $4b9402f7537e5040$var$isNodeMatchingSelectorTabbable(options, node);
};
var $4b9402f7537e5040$var$focusableCandidateSelector = /* #__PURE__ */ $4b9402f7537e5040$var$candidateSelectors.concat("iframe").join(",");
var $4b9402f7537e5040$export$4c063cf1350e6fed = function isFocusable(node, options) {
    options = options || {};
    if (!node) throw new Error("No node provided");
    if ($4b9402f7537e5040$var$matches.call(node, $4b9402f7537e5040$var$focusableCandidateSelector) === false) return false;
    return $4b9402f7537e5040$var$isNodeMatchingSelectorFocusable(options, node);
};

});

parcelRegister("jJYM0", function(module, exports) {

$parcel$export(module.exports, "useFloating", () => $e5f15c9e32d12717$export$4e02a5c1d08bac65);
$parcel$export(module.exports, "offset", () => $e5f15c9e32d12717$export$cc800923e997bb8);
$parcel$export(module.exports, "shift", () => $e5f15c9e32d12717$export$fba63a578e423eb);
$parcel$export(module.exports, "limitShift", () => $e5f15c9e32d12717$export$7bf07e38f3dc4b69);
$parcel$export(module.exports, "flip", () => $e5f15c9e32d12717$export$8a83211c878a3f1f);
$parcel$export(module.exports, "size", () => $e5f15c9e32d12717$export$346677f925de839c);
$parcel$export(module.exports, "autoPlacement", () => $e5f15c9e32d12717$export$91fb6ecbd551914);
$parcel$export(module.exports, "hide", () => $e5f15c9e32d12717$export$fe8985bb6374093c);
$parcel$export(module.exports, "inline", () => $e5f15c9e32d12717$export$18c8ad048e32c7d5);
$parcel$export(module.exports, "arrow", () => $e5f15c9e32d12717$export$f2120bbfa5450bd2);
$parcel$export(module.exports, "computePosition", () => (parcelRequire("jRiwg")).computePosition);

var $jRiwg = parcelRequire("jRiwg");
var $gmW3q = parcelRequire("gmW3q");

var $kc00y = parcelRequire("kc00y");

var $cn1Kz = parcelRequire("cn1Kz");
var $e5f15c9e32d12717$var$index = typeof document !== "undefined" ? (0, $kc00y.useLayoutEffect) : (0, $kc00y.useEffect);
// Fork of `fast-deep-equal` that only does the comparisons we need and compares
// functions
function $e5f15c9e32d12717$var$deepEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (typeof a === "function" && a.toString() === b.toString()) return true;
    let length;
    let i;
    let keys;
    if (a && b && typeof a === "object") {
        if (Array.isArray(a)) {
            length = a.length;
            if (length !== b.length) return false;
            for(i = length; i-- !== 0;){
                if (!$e5f15c9e32d12717$var$deepEqual(a[i], b[i])) return false;
            }
            return true;
        }
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;){
            if (!({}).hasOwnProperty.call(b, keys[i])) return false;
        }
        for(i = length; i-- !== 0;){
            const key = keys[i];
            if (key === "_owner" && a.$$typeof) continue;
            if (!$e5f15c9e32d12717$var$deepEqual(a[key], b[key])) return false;
        }
        return true;
    }
    return a !== a && b !== b;
}
function $e5f15c9e32d12717$var$getDPR(element) {
    if (typeof window === "undefined") return 1;
    const win = element.ownerDocument.defaultView || window;
    return win.devicePixelRatio || 1;
}
function $e5f15c9e32d12717$var$roundByDPR(element, value) {
    const dpr = $e5f15c9e32d12717$var$getDPR(element);
    return Math.round(value * dpr) / dpr;
}
function $e5f15c9e32d12717$var$useLatestRef(value) {
    const ref = $kc00y.useRef(value);
    $e5f15c9e32d12717$var$index(()=>{
        ref.current = value;
    });
    return ref;
}
/**
 * Provides data to position a floating element.
 * @see https://floating-ui.com/docs/useFloating
 */ function $e5f15c9e32d12717$export$4e02a5c1d08bac65(options) {
    if (options === void 0) options = {};
    const { placement: placement = "bottom", strategy: strategy = "absolute", middleware: middleware = [], platform: platform, elements: { reference: externalReference, floating: externalFloating } = {}, transform: transform = true, whileElementsMounted: whileElementsMounted, open: open } = options;
    const [data, setData] = $kc00y.useState({
        x: 0,
        y: 0,
        strategy: strategy,
        placement: placement,
        middlewareData: {},
        isPositioned: false
    });
    const [latestMiddleware, setLatestMiddleware] = $kc00y.useState(middleware);
    if (!$e5f15c9e32d12717$var$deepEqual(latestMiddleware, middleware)) setLatestMiddleware(middleware);
    const [_reference, _setReference] = $kc00y.useState(null);
    const [_floating, _setFloating] = $kc00y.useState(null);
    const setReference = $kc00y.useCallback((node)=>{
        if (node !== referenceRef.current) {
            referenceRef.current = node;
            _setReference(node);
        }
    }, []);
    const setFloating = $kc00y.useCallback((node)=>{
        if (node !== floatingRef.current) {
            floatingRef.current = node;
            _setFloating(node);
        }
    }, []);
    const referenceEl = externalReference || _reference;
    const floatingEl = externalFloating || _floating;
    const referenceRef = $kc00y.useRef(null);
    const floatingRef = $kc00y.useRef(null);
    const dataRef = $kc00y.useRef(data);
    const hasWhileElementsMounted = whileElementsMounted != null;
    const whileElementsMountedRef = $e5f15c9e32d12717$var$useLatestRef(whileElementsMounted);
    const platformRef = $e5f15c9e32d12717$var$useLatestRef(platform);
    const openRef = $e5f15c9e32d12717$var$useLatestRef(open);
    const update = $kc00y.useCallback(()=>{
        if (!referenceRef.current || !floatingRef.current) return;
        const config = {
            placement: placement,
            strategy: strategy,
            middleware: latestMiddleware
        };
        if (platformRef.current) config.platform = platformRef.current;
        (0, $jRiwg.computePosition)(referenceRef.current, floatingRef.current, config).then((data)=>{
            const fullData = {
                ...data,
                // The floating element's position may be recomputed while it's closed
                // but still mounted (such as when transitioning out). To ensure
                // `isPositioned` will be `false` initially on the next open, avoid
                // setting it to `true` when `open === false` (must be specified).
                isPositioned: openRef.current !== false
            };
            if (isMountedRef.current && !$e5f15c9e32d12717$var$deepEqual(dataRef.current, fullData)) {
                dataRef.current = fullData;
                $cn1Kz.flushSync(()=>{
                    setData(fullData);
                });
            }
        });
    }, [
        latestMiddleware,
        placement,
        strategy,
        platformRef,
        openRef
    ]);
    $e5f15c9e32d12717$var$index(()=>{
        if (open === false && dataRef.current.isPositioned) {
            dataRef.current.isPositioned = false;
            setData((data)=>({
                    ...data,
                    isPositioned: false
                }));
        }
    }, [
        open
    ]);
    const isMountedRef = $kc00y.useRef(false);
    $e5f15c9e32d12717$var$index(()=>{
        isMountedRef.current = true;
        return ()=>{
            isMountedRef.current = false;
        };
    }, []);
    $e5f15c9e32d12717$var$index(()=>{
        if (referenceEl) referenceRef.current = referenceEl;
        if (floatingEl) floatingRef.current = floatingEl;
        if (referenceEl && floatingEl) {
            if (whileElementsMountedRef.current) return whileElementsMountedRef.current(referenceEl, floatingEl, update);
            update();
        }
    }, [
        referenceEl,
        floatingEl,
        update,
        whileElementsMountedRef,
        hasWhileElementsMounted
    ]);
    const refs = $kc00y.useMemo(()=>({
            reference: referenceRef,
            floating: floatingRef,
            setReference: setReference,
            setFloating: setFloating
        }), [
        setReference,
        setFloating
    ]);
    const elements = $kc00y.useMemo(()=>({
            reference: referenceEl,
            floating: floatingEl
        }), [
        referenceEl,
        floatingEl
    ]);
    const floatingStyles = $kc00y.useMemo(()=>{
        const initialStyles = {
            position: strategy,
            left: 0,
            top: 0
        };
        if (!elements.floating) return initialStyles;
        const x = $e5f15c9e32d12717$var$roundByDPR(elements.floating, data.x);
        const y = $e5f15c9e32d12717$var$roundByDPR(elements.floating, data.y);
        if (transform) return {
            ...initialStyles,
            transform: "translate(" + x + "px, " + y + "px)",
            ...$e5f15c9e32d12717$var$getDPR(elements.floating) >= 1.5 && {
                willChange: "transform"
            }
        };
        return {
            position: strategy,
            left: x,
            top: y
        };
    }, [
        strategy,
        transform,
        elements.floating,
        data.x,
        data.y
    ]);
    return $kc00y.useMemo(()=>({
            ...data,
            update: update,
            refs: refs,
            elements: elements,
            floatingStyles: floatingStyles
        }), [
        data,
        update,
        refs,
        elements,
        floatingStyles
    ]);
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const $e5f15c9e32d12717$var$arrow$1 = (options)=>{
    function isRef(value) {
        return ({}).hasOwnProperty.call(value, "current");
    }
    return {
        name: "arrow",
        options: options,
        fn (state) {
            const { element: element, padding: padding } = typeof options === "function" ? options(state) : options;
            if (element && isRef(element)) {
                if (element.current != null) return (0, $jRiwg.arrow)({
                    element: element.current,
                    padding: padding
                }).fn(state);
                return {};
            }
            if (element) return (0, $jRiwg.arrow)({
                element: element,
                padding: padding
            }).fn(state);
            return {};
        }
    };
};
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $e5f15c9e32d12717$export$cc800923e997bb8 = (options, deps)=>({
        ...(0, $jRiwg.offset)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $e5f15c9e32d12717$export$fba63a578e423eb = (options, deps)=>({
        ...(0, $jRiwg.shift)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $e5f15c9e32d12717$export$7bf07e38f3dc4b69 = (options, deps)=>({
        ...(0, $jRiwg.limitShift)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $e5f15c9e32d12717$export$8a83211c878a3f1f = (options, deps)=>({
        ...(0, $jRiwg.flip)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $e5f15c9e32d12717$export$346677f925de839c = (options, deps)=>({
        ...(0, $jRiwg.size)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $e5f15c9e32d12717$export$91fb6ecbd551914 = (options, deps)=>({
        ...(0, $jRiwg.autoPlacement)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $e5f15c9e32d12717$export$fe8985bb6374093c = (options, deps)=>({
        ...(0, $jRiwg.hide)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $e5f15c9e32d12717$export$18c8ad048e32c7d5 = (options, deps)=>({
        ...(0, $jRiwg.inline)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const $e5f15c9e32d12717$export$f2120bbfa5450bd2 = (options, deps)=>({
        ...$e5f15c9e32d12717$var$arrow$1(options),
        options: [
            options,
            deps
        ]
    });

});



parcelRegister("dcbq4", function(module, exports) {

$parcel$export(module.exports, "DateRange", () => $fd76ed291282ed18$export$829bd850c745b6e);

var $cKvYK = parcelRequire("cKvYK");
const $fd76ed291282ed18$var$dateTimeFormat = new Intl.DateTimeFormat("fr-FR", {
    hour: "numeric",
    minute: "numeric",
    year: "numeric",
    month: "long",
    day: "numeric"
});
const $fd76ed291282ed18$var$dateFormat = new Intl.DateTimeFormat("fr-FR", {
    year: "numeric",
    month: "numeric",
    day: "numeric"
});
const $fd76ed291282ed18$var$shortDateFormat = new Intl.DateTimeFormat("fr-FR", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit"
});
const $fd76ed291282ed18$var$shortDateWithMonthLetter = new Intl.DateTimeFormat("fr-FR", {
    year: "numeric",
    month: "short",
    day: "2-digit"
});
const $fd76ed291282ed18$var$dateWithDayFormat = new Intl.DateTimeFormat("fr-FR", {
    year: "numeric",
    month: "long",
    day: "numeric",
    weekday: "long"
});
const $fd76ed291282ed18$var$dateWithoutDayFormat = new Intl.DateTimeFormat("fr-FR", {
    year: "numeric",
    month: "long",
    day: "numeric"
});
const $fd76ed291282ed18$var$shortDateWithDayFormat = new Intl.DateTimeFormat("fr-FR", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    weekday: "short"
});
const $fd76ed291282ed18$var$timeFormat = new Intl.DateTimeFormat("fr-FR", {
    hour: "numeric",
    minute: "numeric"
});
const $fd76ed291282ed18$var$Label = ({ date: date, format: format })=>{
    if (!date) return "-";
    const _date = new Date(date);
    return /*#__PURE__*/ (0, $cKvYK.jsx)("time", {
        dateTime: _date.toISOString(),
        children: format.format(_date)
    });
};
const $fd76ed291282ed18$export$9d5e84740f68a744 = ({ date: date })=>/*#__PURE__*/ (0, $cKvYK.jsx)($fd76ed291282ed18$var$Label, {
        date: date,
        format: $fd76ed291282ed18$var$dateFormat
    });
const $fd76ed291282ed18$export$41575fb0bb847773 = ({ date: date })=>/*#__PURE__*/ (0, $cKvYK.jsx)($fd76ed291282ed18$var$Label, {
        date: date,
        format: $fd76ed291282ed18$var$shortDateFormat
    });
const $fd76ed291282ed18$export$27acd963022582d4 = ({ date: date })=>/*#__PURE__*/ (0, $cKvYK.jsx)($fd76ed291282ed18$var$Label, {
        date: date,
        format: $fd76ed291282ed18$var$shortDateWithMonthLetter
    });
const $fd76ed291282ed18$export$5b15ea4630d79028 = ({ date: date })=>/*#__PURE__*/ (0, $cKvYK.jsx)($fd76ed291282ed18$var$Label, {
        date: date,
        format: $fd76ed291282ed18$var$dateWithDayFormat
    });
const $fd76ed291282ed18$export$87f38ea421a628aa = ({ date: date })=>/*#__PURE__*/ (0, $cKvYK.jsx)($fd76ed291282ed18$var$Label, {
        date: date,
        format: $fd76ed291282ed18$var$dateWithoutDayFormat
    });
const $fd76ed291282ed18$export$b66eb21e3d655e09 = ({ date: date })=>/*#__PURE__*/ (0, $cKvYK.jsx)($fd76ed291282ed18$var$Label, {
        date: date,
        format: $fd76ed291282ed18$var$shortDateWithDayFormat
    });
const $fd76ed291282ed18$export$85cb8d6da4ebf2f2 = ({ date: date })=>/*#__PURE__*/ (0, $cKvYK.jsx)($fd76ed291282ed18$var$Label, {
        date: date,
        format: $fd76ed291282ed18$var$timeFormat
    });
const $fd76ed291282ed18$export$629cd4300dfe1836 = ({ date: date })=>/*#__PURE__*/ (0, $cKvYK.jsx)($fd76ed291282ed18$var$Label, {
        date: date,
        format: $fd76ed291282ed18$var$dateTimeFormat
    });
var $fd76ed291282ed18$export$2e2bcd8739ae039 = $fd76ed291282ed18$export$629cd4300dfe1836;
const $fd76ed291282ed18$export$829bd850c745b6e = ({ defaultMessage: defaultMessage, start: start, end: end = null })=>{
    const today = new Date();
    if (!start && !end) return defaultMessage ?? "Choisir une p\xe9riode";
    if (!end || $fd76ed291282ed18$var$isSameDay(start, end)) return $fd76ed291282ed18$var$isSameDay(today, start) ? "Aujourd'hui" : /*#__PURE__*/ (0, $cKvYK.jsx)($fd76ed291282ed18$var$Label, {
        date: start,
        format: $fd76ed291282ed18$var$shortDateFormat
    });
    return /*#__PURE__*/ (0, $cKvYK.jsxs)((0, $cKvYK.Fragment), {
        children: [
            $fd76ed291282ed18$var$isSameDay(today, start) ? "Aujourd'hui" : /*#__PURE__*/ (0, $cKvYK.jsx)($fd76ed291282ed18$var$Label, {
                date: start,
                format: $fd76ed291282ed18$var$shortDateFormat
            }),
            "\xa0-\xa0",
            $fd76ed291282ed18$var$isSameDay(today, end) ? "Aujourd'hui" : /*#__PURE__*/ (0, $cKvYK.jsx)($fd76ed291282ed18$var$Label, {
                date: end,
                format: $fd76ed291282ed18$var$shortDateFormat
            })
        ]
    });
};
function $fd76ed291282ed18$var$isSameDay(d1, d2) {
    return d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth() && d1.getDate() === d2.getDate();
}

});




parcelRegister("bZlx0", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb7e13b014796eb7$export$2e2bcd8739ae039);

var $cKvYK = parcelRequire("cKvYK");

var $469X3 = parcelRequire("469X3");

var $lgiU2 = parcelRequire("lgiU2");

var $eqMOn = parcelRequire("eqMOn");

var $hpOSz = parcelRequire("hpOSz");

var $66yY2 = parcelRequire("66yY2");

var $IWcTD = parcelRequire("IWcTD");

var $5xXVa = parcelRequire("5xXVa");
const $eb7e13b014796eb7$var$AccueilAuth = ()=>{
    const { user: user } = (0, $eqMOn.useAppContext)();
    return /*#__PURE__*/ (0, $cKvYK.jsxs)((0, $469X3.default), {
        className: "px-0 px-lg-5",
        children: [
            /*#__PURE__*/ (0, $cKvYK.jsx)((0, $469X3.default), {
                children: /*#__PURE__*/ (0, $cKvYK.jsxs)("h1", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($lgiU2)))((0, (/*@__PURE__*/$parcel$interopDefault($5xXVa))).title, "text-primary-100 mb-4"),
                    children: [
                        /*#__PURE__*/ (0, $cKvYK.jsx)("span", {
                            className: "me-2 text-primary",
                            children: /*#__PURE__*/ (0, $cKvYK.jsx)((0, $hpOSz.IconCoucou), {})
                        }),
                        /*#__PURE__*/ (0, $cKvYK.jsx)("b", {
                            children: "Bienvenue"
                        }),
                        " sur votre espace FAME"
                    ]
                })
            }),
            /*#__PURE__*/ (0, $cKvYK.jsx)((0, $469X3.default), {
                className: "px-0 px-lg-5",
                children: /*#__PURE__*/ (0, $cKvYK.jsx)("main", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($5xXVa))).authContent,
                    children: user.isAdministrateur ? /*#__PURE__*/ (0, $cKvYK.jsx)((0, $IWcTD.default), {}) : user.isProche && /*#__PURE__*/ (0, $cKvYK.jsx)((0, $66yY2.default), {})
                })
            })
        ]
    });
};
var $eb7e13b014796eb7$export$2e2bcd8739ae039 = $eb7e13b014796eb7$var$AccueilAuth;

});
parcelRegister("66yY2", function(module, exports) {

$parcel$export(module.exports, "default", () => $457885443fbb5d05$export$2e2bcd8739ae039);

var $cKvYK = parcelRequire("cKvYK");
parcelRequire("kc00y");

var $4DyxQ = parcelRequire("4DyxQ");
var $469X3 = parcelRequire("469X3");

var $lgiU2 = parcelRequire("lgiU2");

var $4VCRM = parcelRequire("4VCRM");

var $hpOSz = parcelRequire("hpOSz");

var $bNJBP = parcelRequire("bNJBP");

var $dt75J = parcelRequire("dt75J");

var $j0AMk = parcelRequire("j0AMk");

var $eVTM9 = parcelRequire("eVTM9");

var $eqMOn = parcelRequire("eqMOn");

var $5TbRy = parcelRequire("5TbRy");

var $c99Pn = parcelRequire("c99Pn");

var $5JDDZ = parcelRequire("5JDDZ");
const $457885443fbb5d05$var$RessourcesProche = ()=>{
    const { user: user } = (0, $eqMOn.useAppContext)();
    const { isProcheFinDeVie: isProcheFinDeVie } = user;
    return /*#__PURE__*/ (0, $cKvYK.jsxs)((0, $bNJBP.PageContentFluid), {
        children: [
            /*#__PURE__*/ (0, $cKvYK.jsx)((0, $469X3.default), {
                children: /*#__PURE__*/ (0, $cKvYK.jsx)((0, $4VCRM.default), {
                    title: (0, $dt75J.default)(),
                    icon: /*#__PURE__*/ (0, $cKvYK.jsx)((0, $hpOSz.IconGraduationCap), {})
                })
            }),
            /*#__PURE__*/ (0, $cKvYK.jsxs)((0, $469X3.default), {
                className: "m-0 p-0",
                children: [
                    /*#__PURE__*/ (0, $cKvYK.jsxs)((0, $4DyxQ.default), {
                        xs: 12,
                        xl: 5,
                        xxl: 4,
                        className: "order-2 order-xl-1",
                        children: [
                            /*#__PURE__*/ (0, $cKvYK.jsx)("h2", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($lgiU2)))((0, (/*@__PURE__*/$parcel$interopDefault($5JDDZ))).subtitle, "text-secondary-100 my-3 mx-0"),
                                children: "Ligne d'\xe9coute Famir\xe9a"
                            }),
                            /*#__PURE__*/ (0, $cKvYK.jsx)("p", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($lgiU2)))((0, (/*@__PURE__*/$parcel$interopDefault($5JDDZ))).text, "mx-2 text-text-color"),
                                children: "Vous avez une question sur la r\xe9animation, vous souhaitez \xeatre orient\xe9 ou \xeatre soutenu ? N'h\xe9sitez pas \xe0 appeler la ligne d'\xe9coute Famir\xe9a."
                            }),
                            /*#__PURE__*/ (0, $cKvYK.jsx)((0, $eVTM9.default), {}),
                            isProcheFinDeVie && /*#__PURE__*/ (0, $cKvYK.jsxs)("p", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($lgiU2)))((0, (/*@__PURE__*/$parcel$interopDefault($5JDDZ))).subline, "text-text-color m-2"),
                                children: [
                                    "Avez-vous t\xe9l\xe9charg\xe9",
                                    " ",
                                    /*#__PURE__*/ (0, $cKvYK.jsx)("a", {
                                        href: (0, $5TbRy.default)`/api/public/ressource/telecharger-ressource/` + (0, $c99Pn.default),
                                        children: "le livret d\u2019accueil ?"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cKvYK.jsx)((0, $4DyxQ.default), {
                        xs: 12,
                        xl: 7,
                        xxl: 8,
                        className: "order-1 order-xl-2",
                        children: /*#__PURE__*/ (0, $cKvYK.jsx)((0, $469X3.default), {
                            children: /*#__PURE__*/ (0, $cKvYK.jsx)((0, $4DyxQ.default), {
                                xs: 12,
                                className: "m-0 p-0",
                                children: /*#__PURE__*/ (0, $cKvYK.jsx)((0, $j0AMk.default), {})
                            })
                        })
                    })
                ]
            })
        ]
    });
};
var $457885443fbb5d05$export$2e2bcd8739ae039 = $457885443fbb5d05$var$RessourcesProche;

});
parcelRegister("dt75J", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c488bb34f6a8063$export$2e2bcd8739ae039);

var $eqMOn = parcelRequire("eqMOn");
function $4c488bb34f6a8063$export$2e2bcd8739ae039() {
    const { user: user } = (0, $eqMOn.useAppContext)();
    const { isProcheBd: isProcheBd, isProcheCapsulesVideo: isProcheCapsulesVideo, isProcheRealiteVirtuelle: isProcheRealiteVirtuelle, isProcheFinDeVie: isProcheFinDeVie } = user;
    if (isProcheBd) return "Mes bandes dessin\xe9es";
    else if (isProcheCapsulesVideo) return "Mes vid\xe9os";
    else if (isProcheRealiteVirtuelle) return "R\xe9alit\xe9 virtuelle";
    else if (isProcheFinDeVie) return "Mes ressources";
    else //TODO pour la prod mettre un vrai message
    return "Par d\xe9faut";
}

});

parcelRegister("j0AMk", function(module, exports) {

$parcel$export(module.exports, "default", () => $2151a1470261371c$export$2e2bcd8739ae039);

var $cKvYK = parcelRequire("cKvYK");

var $kc00y = parcelRequire("kc00y");

var $4DyxQ = parcelRequire("4DyxQ");
var $ccw59 = parcelRequire("ccw59");
var $469X3 = parcelRequire("469X3");

var $ZmPdA = parcelRequire("ZmPdA");

var $dZjxw = parcelRequire("dZjxw");

var $l1428 = parcelRequire("l1428");

var $26Ddr = parcelRequire("26Ddr");

var $5TbRy = parcelRequire("5TbRy");

var $hkaOh = parcelRequire("hkaOh");

var $hL7qO = parcelRequire("hL7qO");
const $2151a1470261371c$var$ListeRessourcesProche = ({ excerpt: excerpt = false })=>{
    const ressources = (0, $26Ddr.useGet)((0, $5TbRy.default)`/api/ressources`, {});
    const { visible: visible, close: close } = (0, $dZjxw.useModal)();
    const [codeRessource, setCodeRessource] = (0, $kc00y.useState)(null);
    const [typeCodeRessource, setTypeCodeRessource] = (0, $kc00y.useState)(null);
    const [show, setshow] = (0, $kc00y.useState)(false);
    const handleClose = ()=>setshow(false);
    const handleShow = ()=>setshow(true);
    return /*#__PURE__*/ (0, $cKvYK.jsxs)((0, $469X3.default), {
        className: "me-0 p-0",
        children: [
            ressources?.data?.map((e)=>e.typeRessourceCode === (0, $l1428.default).LINK ? /*#__PURE__*/ (0, $cKvYK.jsx)((0, $4DyxQ.default), {
                    xs: 12,
                    xxl: 6,
                    onClick: ()=>window.open(e.ressourceCheminFichier, "_blank"),
                    className: "mb-3 me-0 pe-0",
                    children: /*#__PURE__*/ (0, $cKvYK.jsx)((0, $ZmPdA.CardWithPicture), {
                        excerpt: excerpt,
                        title: e.ressourceLibelle,
                        picture: e.ressourceVignette,
                        content: e.ressourceDescription,
                        link: e.ressourceNomFichier
                    })
                }, e.ressourceCode) : /*#__PURE__*/ (0, $cKvYK.jsx)((0, $4DyxQ.default), {
                    xs: 12,
                    xxl: 6,
                    onClick: ()=>{
                        setCodeRessource(e.ressourceCode);
                        setTypeCodeRessource(e.typeRessourceCode);
                        handleShow();
                    },
                    className: "mb-3 me-0 pe-0",
                    children: /*#__PURE__*/ (0, $cKvYK.jsx)((0, $ZmPdA.CardWithPicture), {
                        title: e.ressourceLibelle,
                        picture: e.ressourceVignette,
                        content: e.ressourceDescription,
                        link: e.typeRessourceLibelle
                    })
                }, e.ressourceCode)),
            codeRessource && typeCodeRessource && /*#__PURE__*/ (0, $cKvYK.jsxs)((0, $cKvYK.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $cKvYK.jsxs)((0, $ccw59.default), {
                        show: show,
                        onHide: handleClose,
                        size: "xl",
                        centered: true,
                        children: [
                            /*#__PURE__*/ (0, $cKvYK.jsx)((0, $ccw59.default).Header, {
                                closeButton: true,
                                children: /*#__PURE__*/ (0, $cKvYK.jsx)((0, $ccw59.default).Title, {})
                            }),
                            /*#__PURE__*/ (0, $cKvYK.jsx)((0, $ccw59.default).Body, {
                                children: /*#__PURE__*/ (0, $cKvYK.jsx)((0, $hkaOh.default), {
                                    code: codeRessource,
                                    type: typeCodeRessource
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cKvYK.jsx)((0, $ccw59.default), {
                        closeModal: close,
                        visible: visible,
                        children: /*#__PURE__*/ (0, $cKvYK.jsx)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($hL7qO))).modalpdf,
                            children: /*#__PURE__*/ (0, $cKvYK.jsx)((0, $hkaOh.default), {
                                code: codeRessource,
                                type: typeCodeRessource
                            })
                        })
                    })
                ]
            })
        ]
    });
};
var $2151a1470261371c$export$2e2bcd8739ae039 = $2151a1470261371c$var$ListeRessourcesProche;

});
parcelRegister("ccw59", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e1f7dde30da3bf6$export$2e2bcd8739ae039);

var $lgiU2 = parcelRequire("lgiU2");

var $gPJJq = parcelRequire("gPJJq");

var $eCSxQ = parcelRequire("eCSxQ");

var $55u0M = parcelRequire("55u0M");

var $2TAvQ = parcelRequire("2TAvQ");

var $lWhU6 = parcelRequire("lWhU6");

var $98Wqq = parcelRequire("98Wqq");

var $62odg = parcelRequire("62odg");

var $cNjN5 = parcelRequire("cNjN5");

var $7yD3J = parcelRequire("7yD3J");

var $cHhYb = parcelRequire("cHhYb");

var $kc00y = parcelRequire("kc00y");

var $4SZfs = parcelRequire("4SZfs");

var $71jBM = parcelRequire("71jBM");

var $3fsmI = parcelRequire("3fsmI");

var $9ntx7 = parcelRequire("9ntx7");

var $6Z7dp = parcelRequire("6Z7dp");

var $dTMkk = parcelRequire("dTMkk");

var $8qsmX = parcelRequire("8qsmX");

var $3WAOl = parcelRequire("3WAOl");

var $bog0z = parcelRequire("bog0z");

var $9i3wr = parcelRequire("9i3wr");

var $cKvYK = parcelRequire("cKvYK");
"use client";
/* eslint-disable no-use-before-define, react/no-multi-comp */ function $8e1f7dde30da3bf6$var$DialogTransition(props) {
    return /*#__PURE__*/ (0, $cKvYK.jsx)((0, $3fsmI.default), {
        ...props,
        timeout: null
    });
}
function $8e1f7dde30da3bf6$var$BackdropTransition(props) {
    return /*#__PURE__*/ (0, $cKvYK.jsx)((0, $3fsmI.default), {
        ...props,
        timeout: null
    });
}
/* eslint-enable no-use-before-define */ const $8e1f7dde30da3bf6$var$Modal = /*#__PURE__*/ $kc00y.forwardRef(({ bsPrefix: bsPrefix, className: className, style: style, dialogClassName: dialogClassName, contentClassName: contentClassName, children: children, dialogAs: Dialog = (0, $dTMkk.default), "data-bs-theme": dataBsTheme, "aria-labelledby": ariaLabelledby, "aria-describedby": ariaDescribedby, "aria-label": ariaLabel, show: /* BaseModal props */ show = false, animation: animation = true, backdrop: backdrop = true, keyboard: keyboard = true, onEscapeKeyDown: onEscapeKeyDown, onShow: onShow, onHide: onHide, container: container, autoFocus: autoFocus = true, enforceFocus: enforceFocus = true, restoreFocus: restoreFocus = true, restoreFocusOptions: restoreFocusOptions, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onEnter: onEnter, onEntering: onEntering, onExited: onExited, backdropClassName: backdropClassName, manager: propsManager, ...props }, ref)=>{
    const [modalStyle, setStyle] = (0, $kc00y.useState)({});
    const [animateStaticModal, setAnimateStaticModal] = (0, $kc00y.useState)(false);
    const waitingForMouseUpRef = (0, $kc00y.useRef)(false);
    const ignoreBackdropClickRef = (0, $kc00y.useRef)(false);
    const removeStaticModalAnimationRef = (0, $kc00y.useRef)(null);
    const [modal, setModalRef] = (0, $98Wqq.default)();
    const mergedRef = (0, $cNjN5.default)(ref, setModalRef);
    const handleHide = (0, $62odg.default)(onHide);
    const isRTL = (0, $9i3wr.useIsRTL)();
    bsPrefix = (0, $9i3wr.useBootstrapPrefix)(bsPrefix, "modal");
    const modalContext = (0, $kc00y.useMemo)(()=>({
            onHide: handleHide
        }), [
        handleHide
    ]);
    function getModalManager() {
        if (propsManager) return propsManager;
        return (0, $71jBM.getSharedManager)({
            isRTL: isRTL
        });
    }
    function updateDialogStyle(node) {
        if (!(0, $eCSxQ.default)) return;
        const containerIsOverflowing = getModalManager().getScrollbarWidth() > 0;
        const modalIsOverflowing = node.scrollHeight > (0, $55u0M.default)(node).documentElement.clientHeight;
        setStyle({
            paddingRight: containerIsOverflowing && !modalIsOverflowing ? (0, $lWhU6.default)() : undefined,
            paddingLeft: !containerIsOverflowing && modalIsOverflowing ? (0, $lWhU6.default)() : undefined
        });
    }
    const handleWindowResize = (0, $62odg.default)(()=>{
        if (modal) updateDialogStyle(modal.dialog);
    });
    (0, $7yD3J.default)(()=>{
        (0, $2TAvQ.default)(window, "resize", handleWindowResize);
        removeStaticModalAnimationRef.current == null || removeStaticModalAnimationRef.current();
    });
    // We prevent the modal from closing during a drag by detecting where the
    // click originates from. If it starts in the modal and then ends outside
    // don't close.
    const handleDialogMouseDown = ()=>{
        waitingForMouseUpRef.current = true;
    };
    const handleMouseUp = (e)=>{
        if (waitingForMouseUpRef.current && modal && e.target === modal.dialog) ignoreBackdropClickRef.current = true;
        waitingForMouseUpRef.current = false;
    };
    const handleStaticModalAnimation = ()=>{
        setAnimateStaticModal(true);
        removeStaticModalAnimationRef.current = (0, $cHhYb.default)(modal.dialog, ()=>{
            setAnimateStaticModal(false);
        });
    };
    const handleStaticBackdropClick = (e)=>{
        if (e.target !== e.currentTarget) return;
        handleStaticModalAnimation();
    };
    const handleClick = (e)=>{
        if (backdrop === "static") {
            handleStaticBackdropClick(e);
            return;
        }
        if (ignoreBackdropClickRef.current || e.target !== e.currentTarget) {
            ignoreBackdropClickRef.current = false;
            return;
        }
        onHide == null || onHide();
    };
    const handleEscapeKeyDown = (e)=>{
        if (keyboard) onEscapeKeyDown == null || onEscapeKeyDown(e);
        else {
            // Call preventDefault to stop modal from closing in @restart/ui.
            e.preventDefault();
            if (backdrop === "static") // Play static modal animation.
            handleStaticModalAnimation();
        }
    };
    const handleEnter = (node, isAppearing)=>{
        if (node) updateDialogStyle(node);
        onEnter == null || onEnter(node, isAppearing);
    };
    const handleExit = (node)=>{
        removeStaticModalAnimationRef.current == null || removeStaticModalAnimationRef.current();
        onExit == null || onExit(node);
    };
    const handleEntering = (node, isAppearing)=>{
        onEntering == null || onEntering(node, isAppearing);
        // FIXME: This should work even when animation is disabled.
        (0, $gPJJq.default)(window, "resize", handleWindowResize);
    };
    const handleExited = (node)=>{
        if (node) node.style.display = ""; // RHL removes it sometimes
        onExited == null || onExited(node);
        // FIXME: This should work even when animation is disabled.
        (0, $2TAvQ.default)(window, "resize", handleWindowResize);
    };
    const renderBackdrop = (0, $kc00y.useCallback)((backdropProps)=>/*#__PURE__*/ (0, $cKvYK.jsx)("div", {
            ...backdropProps,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($lgiU2)))(`${bsPrefix}-backdrop`, backdropClassName, !animation && "show")
        }), [
        animation,
        backdropClassName,
        bsPrefix
    ]);
    const baseModalStyle = {
        ...style,
        ...modalStyle
    };
    // If `display` is not set to block, autoFocus inside the modal fails
    // https://github.com/react-bootstrap/react-bootstrap/issues/5102
    baseModalStyle.display = "block";
    const renderDialog = (dialogProps)=>/*#__PURE__*/ (0, $cKvYK.jsx)("div", {
            role: "dialog",
            ...dialogProps,
            style: baseModalStyle,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($lgiU2)))(className, bsPrefix, animateStaticModal && `${bsPrefix}-static`, !animation && "show"),
            onClick: backdrop ? handleClick : undefined,
            onMouseUp: handleMouseUp,
            "data-bs-theme": dataBsTheme,
            "aria-label": ariaLabel,
            "aria-labelledby": ariaLabelledby,
            "aria-describedby": ariaDescribedby,
            children: /*#__PURE__*/ (0, $cKvYK.jsx)(Dialog, {
                ...props,
                onMouseDown: handleDialogMouseDown,
                className: dialogClassName,
                contentClassName: contentClassName,
                children: children
            })
        });
    return /*#__PURE__*/ (0, $cKvYK.jsx)((0, $6Z7dp.default).Provider, {
        value: modalContext,
        children: /*#__PURE__*/ (0, $cKvYK.jsx)((0, $4SZfs.default), {
            show: show,
            ref: mergedRef,
            backdrop: backdrop,
            container: container,
            keyboard: true // Always set true - see handleEscapeKeyDown
            ,
            autoFocus: autoFocus,
            enforceFocus: enforceFocus,
            restoreFocus: restoreFocus,
            restoreFocusOptions: restoreFocusOptions,
            onEscapeKeyDown: handleEscapeKeyDown,
            onShow: onShow,
            onHide: onHide,
            onEnter: handleEnter,
            onEntering: handleEntering,
            onEntered: onEntered,
            onExit: handleExit,
            onExiting: onExiting,
            onExited: handleExited,
            manager: getModalManager(),
            transition: animation ? $8e1f7dde30da3bf6$var$DialogTransition : undefined,
            backdropTransition: animation ? $8e1f7dde30da3bf6$var$BackdropTransition : undefined,
            renderBackdrop: renderBackdrop,
            renderDialog: renderDialog
        })
    });
});
$8e1f7dde30da3bf6$var$Modal.displayName = "Modal";
var $8e1f7dde30da3bf6$export$2e2bcd8739ae039 = Object.assign($8e1f7dde30da3bf6$var$Modal, {
    Body: (0, $9ntx7.default),
    Header: (0, $3WAOl.default),
    Title: (0, $bog0z.default),
    Footer: (0, $8qsmX.default),
    Dialog: (0, $dTMkk.default),
    TRANSITION_DURATION: 300,
    BACKDROP_TRANSITION_DURATION: 150
});

});
parcelRegister("gPJJq", function(module, exports) {

$parcel$export(module.exports, "default", () => $c414e224cd570c88$export$2e2bcd8739ae039);
/* eslint-disable no-return-assign */ 
var $eCSxQ = parcelRequire("eCSxQ");
var $c414e224cd570c88$export$63fefd044b2bc624 = false;
var $c414e224cd570c88$export$a614c6b395900f69 = false;
try {
    var $c414e224cd570c88$var$options = {
        get passive () {
            return $c414e224cd570c88$export$63fefd044b2bc624 = true;
        },
        get once () {
            // eslint-disable-next-line no-multi-assign
            return $c414e224cd570c88$export$a614c6b395900f69 = $c414e224cd570c88$export$63fefd044b2bc624 = true;
        }
    };
    if (0, $eCSxQ.default) {
        window.addEventListener("test", $c414e224cd570c88$var$options, $c414e224cd570c88$var$options);
        window.removeEventListener("test", $c414e224cd570c88$var$options, true);
    }
} catch (e) {
/* */ }
/**
 * An `addEventListener` ponyfill, supports the `once` option
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */ function $c414e224cd570c88$var$addEventListener(node, eventName, handler, options) {
    if (options && typeof options !== "boolean" && !$c414e224cd570c88$export$a614c6b395900f69) {
        var once = options.once, capture = options.capture;
        var wrappedHandler = handler;
        if (!$c414e224cd570c88$export$a614c6b395900f69 && once) {
            wrappedHandler = handler.__once || function onceHandler(event) {
                this.removeEventListener(eventName, onceHandler, capture);
                handler.call(this, event);
            };
            handler.__once = wrappedHandler;
        }
        node.addEventListener(eventName, wrappedHandler, $c414e224cd570c88$export$63fefd044b2bc624 ? options : capture);
    }
    node.addEventListener(eventName, handler, options);
}
var $c414e224cd570c88$export$2e2bcd8739ae039 = $c414e224cd570c88$var$addEventListener;

});
parcelRegister("eCSxQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa5eecc52b084e6f$export$2e2bcd8739ae039);
var $aa5eecc52b084e6f$export$2e2bcd8739ae039 = !!(typeof window !== "undefined" && window.document && window.document.createElement);

});


parcelRegister("55u0M", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b44b30b48869541$export$2e2bcd8739ae039);
/**
 * Returns the owner document of a given element.
 * 
 * @param node the element
 */ function $3b44b30b48869541$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}

});

parcelRegister("2TAvQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $21bd0a760d3f2599$export$2e2bcd8739ae039);
/**
 * A `removeEventListener` ponyfill
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */ function $21bd0a760d3f2599$var$removeEventListener(node, eventName, handler, options) {
    var capture = options && typeof options !== "boolean" ? options.capture : options;
    node.removeEventListener(eventName, handler, capture);
    if (handler.__once) node.removeEventListener(eventName, handler.__once, capture);
}
var $21bd0a760d3f2599$export$2e2bcd8739ae039 = $21bd0a760d3f2599$var$removeEventListener;

});

parcelRegister("lWhU6", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff8ce7114f51a84b$export$2e2bcd8739ae039);

var $eCSxQ = parcelRequire("eCSxQ");
var $ff8ce7114f51a84b$var$size;
function $ff8ce7114f51a84b$export$2e2bcd8739ae039(recalc) {
    if (!$ff8ce7114f51a84b$var$size && $ff8ce7114f51a84b$var$size !== 0 || recalc) {
        if (0, $eCSxQ.default) {
            var scrollDiv = document.createElement("div");
            scrollDiv.style.position = "absolute";
            scrollDiv.style.top = "-9999px";
            scrollDiv.style.width = "50px";
            scrollDiv.style.height = "50px";
            scrollDiv.style.overflow = "scroll";
            document.body.appendChild(scrollDiv);
            $ff8ce7114f51a84b$var$size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
            document.body.removeChild(scrollDiv);
        }
    }
    return $ff8ce7114f51a84b$var$size;
}

});

parcelRegister("98Wqq", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a822e76c29b5649$export$2e2bcd8739ae039);

var $kc00y = parcelRequire("kc00y");
function $6a822e76c29b5649$export$2e2bcd8739ae039() {
    return (0, $kc00y.useState)(null);
}

});

parcelRegister("62odg", function(module, exports) {

$parcel$export(module.exports, "default", () => $4655b62db0931f1e$export$2e2bcd8739ae039);

var $kc00y = parcelRequire("kc00y");

var $dv60m = parcelRequire("dv60m");
function $4655b62db0931f1e$export$2e2bcd8739ae039(fn) {
    const ref = (0, $dv60m.default)(fn);
    return (0, $kc00y.useCallback)(function(...args) {
        return ref.current && ref.current(...args);
    }, [
        ref
    ]);
}

});
parcelRegister("dv60m", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d42d40627beb5c6$export$2e2bcd8739ae039);

var $kc00y = parcelRequire("kc00y");
/**
 * Creates a `Ref` whose value is updated in an effect, ensuring the most recent
 * value is the one rendered with. Generally only required for Concurrent mode usage
 * where previous work in `render()` may be discarded before being used.
 *
 * This is safe to access in an event handler.
 *
 * @param value The `Ref` value
 */ function $9d42d40627beb5c6$var$useCommittedRef(value) {
    const ref = (0, $kc00y.useRef)(value);
    (0, $kc00y.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}
var $9d42d40627beb5c6$export$2e2bcd8739ae039 = $9d42d40627beb5c6$var$useCommittedRef;

});


parcelRegister("cNjN5", function(module, exports) {

$parcel$export(module.exports, "default", () => $950969aa8a9dbb93$export$2e2bcd8739ae039);

var $kc00y = parcelRequire("kc00y");
const $950969aa8a9dbb93$var$toFnRef = (ref)=>!ref || typeof ref === "function" ? ref : (value)=>{
        ref.current = value;
    };
function $950969aa8a9dbb93$export$c9058316764c140e(refA, refB) {
    const a = $950969aa8a9dbb93$var$toFnRef(refA);
    const b = $950969aa8a9dbb93$var$toFnRef(refB);
    return (value)=>{
        if (a) a(value);
        if (b) b(value);
    };
}
/**
 * Create and returns a single callback ref composed from two other Refs.
 *
 * ```tsx
 * const Button = React.forwardRef((props, ref) => {
 *   const [element, attachRef] = useCallbackRef<HTMLButtonElement>();
 *   const mergedRef = useMergedRefs(ref, attachRef);
 *
 *   return <button ref={mergedRef} {...props}/>
 * })
 * ```
 *
 * @param refA A Callback or mutable Ref
 * @param refB A Callback or mutable Ref
 * @category refs
 */ function $950969aa8a9dbb93$var$useMergedRefs(refA, refB) {
    return (0, $kc00y.useMemo)(()=>$950969aa8a9dbb93$export$c9058316764c140e(refA, refB), [
        refA,
        refB
    ]);
}
var $950969aa8a9dbb93$export$2e2bcd8739ae039 = $950969aa8a9dbb93$var$useMergedRefs;

});

parcelRegister("7yD3J", function(module, exports) {

$parcel$export(module.exports, "default", () => $580a01bf10c105ab$export$2e2bcd8739ae039);

var $iQSOM = parcelRequire("iQSOM");

var $kc00y = parcelRequire("kc00y");
function $580a01bf10c105ab$export$2e2bcd8739ae039(fn) {
    const onUnmount = (0, $iQSOM.default)(fn);
    (0, $kc00y.useEffect)(()=>()=>onUnmount.current(), []);
}

});
parcelRegister("iQSOM", function(module, exports) {

$parcel$export(module.exports, "default", () => $db979b0b72de6377$export$2e2bcd8739ae039);

var $kc00y = parcelRequire("kc00y");
function $db979b0b72de6377$export$2e2bcd8739ae039(value) {
    const valueRef = (0, $kc00y.useRef)(value);
    valueRef.current = value;
    return valueRef;
}

});


parcelRegister("cHhYb", function(module, exports) {

$parcel$export(module.exports, "default", () => $93e7709a8ffaec4e$export$2e2bcd8739ae039);

var $cjXNV = parcelRequire("cjXNV");

var $kTN4s = parcelRequire("kTN4s");

var $lphr3 = parcelRequire("lphr3");
function $93e7709a8ffaec4e$var$parseDuration(node) {
    var str = (0, $cjXNV.default)(node, "transitionDuration") || "";
    var mult = str.indexOf("ms") === -1 ? 1000 : 1;
    return parseFloat(str) * mult;
}
function $93e7709a8ffaec4e$var$emulateTransitionEnd(element, duration, padding) {
    if (padding === void 0) padding = 5;
    var called = false;
    var handle = setTimeout(function() {
        if (!called) (0, $lphr3.default)(element, "transitionend", true);
    }, duration + padding);
    var remove = (0, $kTN4s.default)(element, "transitionend", function() {
        called = true;
    }, {
        once: true
    });
    return function() {
        clearTimeout(handle);
        remove();
    };
}
function $93e7709a8ffaec4e$export$2e2bcd8739ae039(element, handler, duration, padding) {
    if (duration == null) duration = $93e7709a8ffaec4e$var$parseDuration(element) || 0;
    var removeEmulate = $93e7709a8ffaec4e$var$emulateTransitionEnd(element, duration, padding);
    var remove = (0, $kTN4s.default)(element, "transitionend", handler);
    return function() {
        removeEmulate();
        remove();
    };
}

});
parcelRegister("cjXNV", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f85a640dc294d7f$export$2e2bcd8739ae039);

var $iZQFc = parcelRequire("iZQFc");

var $jRFfZ = parcelRequire("jRFfZ");

var $keR34 = parcelRequire("keR34");
function $8f85a640dc294d7f$var$style(node, property) {
    var css = "";
    var transforms = "";
    if (typeof property === "string") return node.style.getPropertyValue((0, $jRFfZ.default)(property)) || (0, $iZQFc.default)(node).getPropertyValue((0, $jRFfZ.default)(property));
    Object.keys(property).forEach(function(key) {
        var value = property[key];
        if (!value && value !== 0) node.style.removeProperty((0, $jRFfZ.default)(key));
        else if ((0, $keR34.default)(key)) transforms += key + "(" + value + ") ";
        else css += (0, $jRFfZ.default)(key) + ": " + value + ";";
    });
    if (transforms) css += "transform: " + transforms + ";";
    node.style.cssText += ";" + css;
}
var $8f85a640dc294d7f$export$2e2bcd8739ae039 = $8f85a640dc294d7f$var$style;

});
parcelRegister("iZQFc", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd46c661049de2d8$export$2e2bcd8739ae039);

var $jTbRS = parcelRequire("jTbRS");
function $dd46c661049de2d8$export$2e2bcd8739ae039(node, psuedoElement) {
    return (0, $jTbRS.default)(node).getComputedStyle(node, psuedoElement);
}

});
parcelRegister("jTbRS", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7ac5c17fb23e752$export$2e2bcd8739ae039);

var $55u0M = parcelRequire("55u0M");
function $e7ac5c17fb23e752$export$2e2bcd8739ae039(node) {
    var doc = (0, $55u0M.default)(node);
    return doc && doc.defaultView || window;
}

});


parcelRegister("jRFfZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $e762f84c74a0ba6d$export$2e2bcd8739ae039);
/**
 * Copyright 2013-2014, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
 */ 
var $2h3ju = parcelRequire("2h3ju");
var $e762f84c74a0ba6d$var$msPattern = /^ms-/;
function $e762f84c74a0ba6d$export$2e2bcd8739ae039(string) {
    return (0, $2h3ju.default)(string).replace($e762f84c74a0ba6d$var$msPattern, "-ms-");
}

});
parcelRegister("2h3ju", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a7fbd44a031175e$export$2e2bcd8739ae039);
var $1a7fbd44a031175e$var$rUpper = /([A-Z])/g;
function $1a7fbd44a031175e$export$2e2bcd8739ae039(string) {
    return string.replace($1a7fbd44a031175e$var$rUpper, "-$1").toLowerCase();
}

});


parcelRegister("keR34", function(module, exports) {

$parcel$export(module.exports, "default", () => $ebbe43ccd468b44c$export$2e2bcd8739ae039);
var $ebbe43ccd468b44c$var$supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;
function $ebbe43ccd468b44c$export$2e2bcd8739ae039(value) {
    return !!(value && $ebbe43ccd468b44c$var$supportedTransforms.test(value));
}

});


parcelRegister("kTN4s", function(module, exports) {

$parcel$export(module.exports, "default", () => $f36f0227633f632b$export$2e2bcd8739ae039);

var $gPJJq = parcelRequire("gPJJq");

var $2TAvQ = parcelRequire("2TAvQ");
function $f36f0227633f632b$var$listen(node, eventName, handler, options) {
    (0, $gPJJq.default)(node, eventName, handler, options);
    return function() {
        (0, $2TAvQ.default)(node, eventName, handler, options);
    };
}
var $f36f0227633f632b$export$2e2bcd8739ae039 = $f36f0227633f632b$var$listen;

});

parcelRegister("lphr3", function(module, exports) {

$parcel$export(module.exports, "default", () => $f959750c44d603a2$export$2e2bcd8739ae039);
/**
 * Triggers an event on a given element.
 * 
 * @param node the element
 * @param eventName the event name to trigger
 * @param bubbles whether the event should bubble up
 * @param cancelable whether the event should be cancelable
 */ function $f959750c44d603a2$export$2e2bcd8739ae039(node, eventName, bubbles, cancelable) {
    if (bubbles === void 0) bubbles = false;
    if (cancelable === void 0) cancelable = true;
    if (node) {
        var event = document.createEvent("HTMLEvents");
        event.initEvent(eventName, bubbles, cancelable);
        node.dispatchEvent(event);
    }
}

});


parcelRegister("4SZfs", function(module, exports) {

$parcel$export(module.exports, "default", () => $38ebb733d4e3053f$export$2e2bcd8739ae039);

var $6yUho = parcelRequire("6yUho");

var $1IVpR = parcelRequire("1IVpR");

var $eCSxQ = parcelRequire("eCSxQ");

var $kTN4s = parcelRequire("kTN4s");

var $kc00y = parcelRequire("kc00y");

var $cn1Kz = parcelRequire("cn1Kz");

var $fdp2Y = parcelRequire("fdp2Y");

var $7yD3J = parcelRequire("7yD3J");

var $6fv0X = parcelRequire("6fv0X");

var $62odg = parcelRequire("62odg");

var $jBiHS = parcelRequire("jBiHS");

var $9PYdc = parcelRequire("9PYdc");

var $6Ar19 = parcelRequire("6Ar19");

var $lgFcP = parcelRequire("lgFcP");

var $cwgAT = parcelRequire("cwgAT");

var $cKvYK = parcelRequire("cKvYK");
const $38ebb733d4e3053f$var$_excluded = [
    "show",
    "role",
    "className",
    "style",
    "children",
    "backdrop",
    "keyboard",
    "onBackdropClick",
    "onEscapeKeyDown",
    "transition",
    "runTransition",
    "backdropTransition",
    "runBackdropTransition",
    "autoFocus",
    "enforceFocus",
    "restoreFocus",
    "restoreFocusOptions",
    "renderDialog",
    "renderBackdrop",
    "manager",
    "container",
    "onShow",
    "onHide",
    "onExit",
    "onExited",
    "onExiting",
    "onEnter",
    "onEntering",
    "onEntered"
];
function $38ebb733d4e3053f$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
let $38ebb733d4e3053f$var$manager;
/*
  Modal props are split into a version with and without index signature so that you can fully use them in another projects
  This is due to Typescript not playing well with index signatures e.g. when using Omit
*/ function $38ebb733d4e3053f$var$getManager(window) {
    if (!$38ebb733d4e3053f$var$manager) $38ebb733d4e3053f$var$manager = new (0, $jBiHS.default)({
        ownerDocument: window == null ? void 0 : window.document
    });
    return $38ebb733d4e3053f$var$manager;
}
function $38ebb733d4e3053f$var$useModalManager(provided) {
    const window = (0, $6Ar19.default)();
    const modalManager = provided || $38ebb733d4e3053f$var$getManager(window);
    const modal = (0, $kc00y.useRef)({
        dialog: null,
        backdrop: null
    });
    return Object.assign(modal.current, {
        add: ()=>modalManager.add(modal.current),
        remove: ()=>modalManager.remove(modal.current),
        isTopModal: ()=>modalManager.isTopModal(modal.current),
        setDialogRef: (0, $kc00y.useCallback)((ref)=>{
            modal.current.dialog = ref;
        }, []),
        setBackdropRef: (0, $kc00y.useCallback)((ref)=>{
            modal.current.backdrop = ref;
        }, [])
    });
}
const $38ebb733d4e3053f$var$Modal = /*#__PURE__*/ (0, $kc00y.forwardRef)((_ref, ref)=>{
    let { show: show = false, role: role = "dialog", className: className, style: style, children: children, backdrop: backdrop = true, keyboard: keyboard = true, onBackdropClick: onBackdropClick, onEscapeKeyDown: onEscapeKeyDown, transition: transition, runTransition: runTransition, backdropTransition: backdropTransition, runBackdropTransition: runBackdropTransition, autoFocus: autoFocus = true, enforceFocus: enforceFocus = true, restoreFocus: restoreFocus = true, restoreFocusOptions: restoreFocusOptions, renderDialog: renderDialog, renderBackdrop: renderBackdrop = (props)=>/*#__PURE__*/ (0, $cKvYK.jsx)("div", Object.assign({}, props)), manager: providedManager, container: containerRef, onShow: onShow, onHide: onHide = ()=>{}, onExit: onExit, onExited: onExited, onExiting: onExiting, onEnter: onEnter, onEntering: onEntering, onEntered: onEntered } = _ref, rest = $38ebb733d4e3053f$var$_objectWithoutPropertiesLoose(_ref, $38ebb733d4e3053f$var$_excluded);
    const ownerWindow = (0, $6Ar19.default)();
    const container = (0, $9PYdc.default)(containerRef);
    const modal = $38ebb733d4e3053f$var$useModalManager(providedManager);
    const isMounted = (0, $fdp2Y.default)();
    const prevShow = (0, $6fv0X.default)(show);
    const [exited, setExited] = (0, $kc00y.useState)(!show);
    const lastFocusRef = (0, $kc00y.useRef)(null);
    (0, $kc00y.useImperativeHandle)(ref, ()=>modal, [
        modal
    ]);
    if ((0, $eCSxQ.default) && !prevShow && show) lastFocusRef.current = (0, $6yUho.default)(ownerWindow == null ? void 0 : ownerWindow.document);
    // TODO: I think this needs to be in an effect
    if (show && exited) setExited(false);
    const handleShow = (0, $62odg.default)(()=>{
        modal.add();
        removeKeydownListenerRef.current = (0, $kTN4s.default)(document, "keydown", handleDocumentKeyDown);
        removeFocusListenerRef.current = (0, $kTN4s.default)(document, "focus", // the timeout is necessary b/c this will run before the new modal is mounted
        // and so steals focus from it
        ()=>setTimeout(handleEnforceFocus), true);
        if (onShow) onShow();
        // autofocus after onShow to not trigger a focus event for previous
        // modals before this one is shown.
        if (autoFocus) {
            var _modal$dialog$ownerDo, _modal$dialog;
            const currentActiveElement = (0, $6yUho.default)((_modal$dialog$ownerDo = (_modal$dialog = modal.dialog) == null ? void 0 : _modal$dialog.ownerDocument) != null ? _modal$dialog$ownerDo : ownerWindow == null ? void 0 : ownerWindow.document);
            if (modal.dialog && currentActiveElement && !(0, $1IVpR.default)(modal.dialog, currentActiveElement)) {
                lastFocusRef.current = currentActiveElement;
                modal.dialog.focus();
            }
        }
    });
    const handleHide = (0, $62odg.default)(()=>{
        modal.remove();
        removeKeydownListenerRef.current == null || removeKeydownListenerRef.current();
        removeFocusListenerRef.current == null || removeFocusListenerRef.current();
        if (restoreFocus) {
            var _lastFocusRef$current;
            // Support: <=IE11 doesn't support `focus()` on svg elements (RB: #917)
            (_lastFocusRef$current = lastFocusRef.current) == null || _lastFocusRef$current.focus == null || _lastFocusRef$current.focus(restoreFocusOptions);
            lastFocusRef.current = null;
        }
    });
    // TODO: try and combine these effects: https://github.com/react-bootstrap/react-overlays/pull/794#discussion_r409954120
    // Show logic when:
    //  - show is `true` _and_ `container` has resolved
    (0, $kc00y.useEffect)(()=>{
        if (!show || !container) return;
        handleShow();
    }, [
        show,
        container,
        /* should never change: */ handleShow
    ]);
    // Hide cleanup logic when:
    //  - `exited` switches to true
    //  - component unmounts;
    (0, $kc00y.useEffect)(()=>{
        if (!exited) return;
        handleHide();
    }, [
        exited,
        handleHide
    ]);
    (0, $7yD3J.default)(()=>{
        handleHide();
    });
    // --------------------------------
    const handleEnforceFocus = (0, $62odg.default)(()=>{
        if (!enforceFocus || !isMounted() || !modal.isTopModal()) return;
        const currentActiveElement = (0, $6yUho.default)(ownerWindow == null ? void 0 : ownerWindow.document);
        if (modal.dialog && currentActiveElement && !(0, $1IVpR.default)(modal.dialog, currentActiveElement)) modal.dialog.focus();
    });
    const handleBackdropClick = (0, $62odg.default)((e)=>{
        if (e.target !== e.currentTarget) return;
        onBackdropClick == null || onBackdropClick(e);
        if (backdrop === true) onHide();
    });
    const handleDocumentKeyDown = (0, $62odg.default)((e)=>{
        if (keyboard && (0, $cwgAT.isEscKey)(e) && modal.isTopModal()) {
            onEscapeKeyDown == null || onEscapeKeyDown(e);
            if (!e.defaultPrevented) onHide();
        }
    });
    const removeFocusListenerRef = (0, $kc00y.useRef)();
    const removeKeydownListenerRef = (0, $kc00y.useRef)();
    const handleHidden = (...args)=>{
        setExited(true);
        onExited == null || onExited(...args);
    };
    if (!container) return null;
    const dialogProps = Object.assign({
        role: role,
        ref: modal.setDialogRef,
        // apparently only works on the dialog role element
        "aria-modal": role === "dialog" ? true : undefined
    }, rest, {
        style: style,
        className: className,
        tabIndex: -1
    });
    let dialog = renderDialog ? renderDialog(dialogProps) : /*#__PURE__*/ (0, $cKvYK.jsx)("div", Object.assign({}, dialogProps, {
        children: /*#__PURE__*/ $kc00y.cloneElement(children, {
            role: "document"
        })
    }));
    dialog = (0, $lgFcP.renderTransition)(transition, runTransition, {
        unmountOnExit: true,
        mountOnEnter: true,
        appear: true,
        in: !!show,
        onExit: onExit,
        onExiting: onExiting,
        onExited: handleHidden,
        onEnter: onEnter,
        onEntering: onEntering,
        onEntered: onEntered,
        children: dialog
    });
    let backdropElement = null;
    if (backdrop) {
        backdropElement = renderBackdrop({
            ref: modal.setBackdropRef,
            onClick: handleBackdropClick
        });
        backdropElement = (0, $lgFcP.renderTransition)(backdropTransition, runBackdropTransition, {
            in: !!show,
            appear: true,
            mountOnEnter: true,
            unmountOnExit: true,
            children: backdropElement
        });
    }
    return /*#__PURE__*/ (0, $cKvYK.jsx)((0, $cKvYK.Fragment), {
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cn1Kz))).createPortal(/*#__PURE__*/ (0, $cKvYK.jsxs)((0, $cKvYK.Fragment), {
            children: [
                backdropElement,
                dialog
            ]
        }), container)
    });
});
$38ebb733d4e3053f$var$Modal.displayName = "Modal";
var $38ebb733d4e3053f$export$2e2bcd8739ae039 = Object.assign($38ebb733d4e3053f$var$Modal, {
    Manager: (0, $jBiHS.default)
});

});
parcelRegister("6yUho", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c7192fc72d10e28$export$2e2bcd8739ae039);

var $55u0M = parcelRequire("55u0M");
function $4c7192fc72d10e28$export$2e2bcd8739ae039(doc) {
    if (doc === void 0) doc = (0, $55u0M.default)();
    // Support: IE 9 only
    // IE9 throws an "Unspecified error" accessing document.activeElement from an <iframe>
    try {
        var active = doc.activeElement; // IE11 returns a seemingly empty object in some cases when accessing
        // document.activeElement from an <iframe>
        if (!active || !active.nodeName) return null;
        return active;
    } catch (e) {
        /* ie throws if no active element */ return doc.body;
    }
}

});

parcelRegister("1IVpR", function(module, exports) {

$parcel$export(module.exports, "default", () => $1416702938ee6af3$export$2e2bcd8739ae039);
/* eslint-disable no-bitwise, no-cond-assign */ /**
 * Checks if an element contains another given element.
 * 
 * @param context the context element
 * @param node the element to check
 */ function $1416702938ee6af3$export$2e2bcd8739ae039(context, node) {
    // HTML DOM and SVG DOM may have different support levels,
    // so we need to check on context instead of a document root element.
    if (context.contains) return context.contains(node);
    if (context.compareDocumentPosition) return context === node || !!(context.compareDocumentPosition(node) & 16);
}

});

parcelRegister("fdp2Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $b13b7fb73f273d5d$export$2e2bcd8739ae039);

var $kc00y = parcelRequire("kc00y");
function $b13b7fb73f273d5d$export$2e2bcd8739ae039() {
    const mounted = (0, $kc00y.useRef)(true);
    const isMounted = (0, $kc00y.useRef)(()=>mounted.current);
    (0, $kc00y.useEffect)(()=>{
        mounted.current = true;
        return ()=>{
            mounted.current = false;
        };
    }, []);
    return isMounted.current;
}

});

parcelRegister("6fv0X", function(module, exports) {

$parcel$export(module.exports, "default", () => $48cc33a11e6b1421$export$2e2bcd8739ae039);

var $kc00y = parcelRequire("kc00y");
function $48cc33a11e6b1421$export$2e2bcd8739ae039(value) {
    const ref = (0, $kc00y.useRef)(null);
    (0, $kc00y.useEffect)(()=>{
        ref.current = value;
    });
    return ref.current;
}

});

parcelRegister("jBiHS", function(module, exports) {

$parcel$export(module.exports, "default", () => $e44ffbce266e7c34$export$2e2bcd8739ae039);

var $cjXNV = parcelRequire("cjXNV");

var $7aE8F = parcelRequire("7aE8F");

var $6rtRT = parcelRequire("6rtRT");
const $e44ffbce266e7c34$export$1a88c12b8b979fa0 = (0, $7aE8F.dataAttr)("modal-open");
/**
 * Manages a stack of Modals as well as ensuring
 * body scrolling is is disabled and padding accounted for
 */ class $e44ffbce266e7c34$var$ModalManager {
    constructor({ ownerDocument: ownerDocument, handleContainerOverflow: handleContainerOverflow = true, isRTL: isRTL = false } = {}){
        this.handleContainerOverflow = handleContainerOverflow;
        this.isRTL = isRTL;
        this.modals = [];
        this.ownerDocument = ownerDocument;
    }
    getScrollbarWidth() {
        return (0, $6rtRT.default)(this.ownerDocument);
    }
    getElement() {
        return (this.ownerDocument || document).body;
    }
    setModalAttributes(_modal) {
    // For overriding
    }
    removeModalAttributes(_modal) {
    // For overriding
    }
    setContainerStyle(containerState) {
        const style = {
            overflow: "hidden"
        };
        // we are only interested in the actual `style` here
        // because we will override it
        const paddingProp = this.isRTL ? "paddingLeft" : "paddingRight";
        const container = this.getElement();
        containerState.style = {
            overflow: container.style.overflow,
            [paddingProp]: container.style[paddingProp]
        };
        if (containerState.scrollBarWidth) // use computed style, here to get the real padding
        // to add our scrollbar width
        style[paddingProp] = `${parseInt((0, $cjXNV.default)(container, paddingProp) || "0", 10) + containerState.scrollBarWidth}px`;
        container.setAttribute($e44ffbce266e7c34$export$1a88c12b8b979fa0, "");
        (0, $cjXNV.default)(container, style);
    }
    reset() {
        [
            ...this.modals
        ].forEach((m)=>this.remove(m));
    }
    removeContainerStyle(containerState) {
        const container = this.getElement();
        container.removeAttribute($e44ffbce266e7c34$export$1a88c12b8b979fa0);
        Object.assign(container.style, containerState.style);
    }
    add(modal) {
        let modalIdx = this.modals.indexOf(modal);
        if (modalIdx !== -1) return modalIdx;
        modalIdx = this.modals.length;
        this.modals.push(modal);
        this.setModalAttributes(modal);
        if (modalIdx !== 0) return modalIdx;
        this.state = {
            scrollBarWidth: this.getScrollbarWidth(),
            style: {}
        };
        if (this.handleContainerOverflow) this.setContainerStyle(this.state);
        return modalIdx;
    }
    remove(modal) {
        const modalIdx = this.modals.indexOf(modal);
        if (modalIdx === -1) return;
        this.modals.splice(modalIdx, 1);
        // if that was the last modal in a container,
        // clean up the container
        if (!this.modals.length && this.handleContainerOverflow) this.removeContainerStyle(this.state);
        this.removeModalAttributes(modal);
    }
    isTopModal(modal) {
        return !!this.modals.length && this.modals[this.modals.length - 1] === modal;
    }
}
var $e44ffbce266e7c34$export$2e2bcd8739ae039 = $e44ffbce266e7c34$var$ModalManager;

});
parcelRegister("7aE8F", function(module, exports) {

$parcel$export(module.exports, "dataAttr", () => $53889a51b2c4b977$export$5cc3b7b83e34ade7);
$parcel$export(module.exports, "dataProp", () => $53889a51b2c4b977$export$7776c0a7cd2eb3e0);
const $53889a51b2c4b977$export$fd7bcb7e9bef4e8a = `data-rr-ui-`;
const $53889a51b2c4b977$export$635202801f9383a0 = `rrUi`;
function $53889a51b2c4b977$export$5cc3b7b83e34ade7(property) {
    return `${$53889a51b2c4b977$export$fd7bcb7e9bef4e8a}${property}`;
}
function $53889a51b2c4b977$export$7776c0a7cd2eb3e0(property) {
    return `${$53889a51b2c4b977$export$635202801f9383a0}${property}`;
}

});

parcelRegister("6rtRT", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b0c6ee675688784$export$2e2bcd8739ae039);
/**
 * Get the width of the vertical window scrollbar if it's visible
 */ function $4b0c6ee675688784$export$2e2bcd8739ae039(ownerDocument = document) {
    const window = ownerDocument.defaultView;
    return Math.abs(window.innerWidth - ownerDocument.documentElement.clientWidth);
}

});


parcelRegister("9PYdc", function(module, exports) {

$parcel$export(module.exports, "default", () => $7297954784ff1701$export$2e2bcd8739ae039);

var $55u0M = parcelRequire("55u0M");

var $eCSxQ = parcelRequire("eCSxQ");

var $kc00y = parcelRequire("kc00y");

var $6Ar19 = parcelRequire("6Ar19");
const $7297954784ff1701$export$c91fd81e6d65f84a = (ref, document)=>{
    if (!(0, $eCSxQ.default)) return null;
    if (ref == null) return (document || (0, $55u0M.default)()).body;
    if (typeof ref === "function") ref = ref();
    if (ref && "current" in ref) ref = ref.current;
    if (ref && ("nodeType" in ref || ref.getBoundingClientRect)) return ref;
    return null;
};
function $7297954784ff1701$export$2e2bcd8739ae039(ref, onResolved) {
    const window = (0, $6Ar19.default)();
    const [resolvedRef, setRef] = (0, $kc00y.useState)(()=>$7297954784ff1701$export$c91fd81e6d65f84a(ref, window == null ? void 0 : window.document));
    if (!resolvedRef) {
        const earlyRef = $7297954784ff1701$export$c91fd81e6d65f84a(ref);
        if (earlyRef) setRef(earlyRef);
    }
    (0, $kc00y.useEffect)(()=>{
        if (onResolved && resolvedRef) onResolved(resolvedRef);
    }, [
        onResolved,
        resolvedRef
    ]);
    (0, $kc00y.useEffect)(()=>{
        const nextRef = $7297954784ff1701$export$c91fd81e6d65f84a(ref);
        if (nextRef !== resolvedRef) setRef(nextRef);
    }, [
        ref,
        resolvedRef
    ]);
    return resolvedRef;
}

});
parcelRegister("6Ar19", function(module, exports) {

$parcel$export(module.exports, "default", () => $4cbb0ff85b062c6d$export$2e2bcd8739ae039);

var $kc00y = parcelRequire("kc00y");

var $eCSxQ = parcelRequire("eCSxQ");
const $4cbb0ff85b062c6d$var$Context = /*#__PURE__*/ (0, $kc00y.createContext)((0, $eCSxQ.default) ? window : undefined);
const $4cbb0ff85b062c6d$export$f7d306aeb1cf5fbc = $4cbb0ff85b062c6d$var$Context.Provider;
function $4cbb0ff85b062c6d$export$2e2bcd8739ae039() {
    return (0, $kc00y.useContext)($4cbb0ff85b062c6d$var$Context);
}

});


parcelRegister("lgFcP", function(module, exports) {

$parcel$export(module.exports, "renderTransition", () => $f7bb0e3ef4a0f95f$export$f41d64aae6d6dba5);

var $cNjN5 = parcelRequire("cNjN5");

var $62odg = parcelRequire("62odg");

var $elVBm = parcelRequire("elVBm");

var $kc00y = parcelRequire("kc00y");

var $5YUeB = parcelRequire("5YUeB");

var $bNSCA = parcelRequire("bNSCA");

var $cKvYK = parcelRequire("cKvYK");
function $f7bb0e3ef4a0f95f$export$7b286972b8d8ccbf({ in: inProp, onTransition: onTransition }) {
    const ref = (0, $kc00y.useRef)(null);
    const isInitialRef = (0, $kc00y.useRef)(true);
    const handleTransition = (0, $62odg.default)(onTransition);
    (0, $elVBm.default)(()=>{
        if (!ref.current) return undefined;
        let stale = false;
        handleTransition({
            in: inProp,
            element: ref.current,
            initial: isInitialRef.current,
            isStale: ()=>stale
        });
        return ()=>{
            stale = true;
        };
    }, [
        inProp,
        handleTransition
    ]);
    (0, $elVBm.default)(()=>{
        isInitialRef.current = false;
        // this is for strict mode
        return ()=>{
            isInitialRef.current = true;
        };
    }, []);
    return ref;
}
function $f7bb0e3ef4a0f95f$export$2e2bcd8739ae039({ children: children, in: inProp, onExited: onExited, onEntered: onEntered, transition: transition }) {
    const [exited, setExited] = (0, $kc00y.useState)(!inProp);
    // TODO: I think this needs to be in an effect
    if (inProp && exited) setExited(false);
    const ref = $f7bb0e3ef4a0f95f$export$7b286972b8d8ccbf({
        in: !!inProp,
        onTransition: (options)=>{
            const onFinish = ()=>{
                if (options.isStale()) return;
                if (options.in) onEntered == null || onEntered(options.element, options.initial);
                else {
                    setExited(true);
                    onExited == null || onExited(options.element);
                }
            };
            Promise.resolve(transition(options)).then(onFinish, (error)=>{
                if (!options.in) setExited(true);
                throw error;
            });
        }
    });
    const combinedRef = (0, $cNjN5.default)(ref, children.ref);
    return exited && !inProp ? null : /*#__PURE__*/ (0, $kc00y.cloneElement)(children, {
        ref: combinedRef
    });
}
function $f7bb0e3ef4a0f95f$export$f41d64aae6d6dba5(component, runTransition, props) {
    if (component) return /*#__PURE__*/ (0, $cKvYK.jsx)((0, $bNSCA.default), Object.assign({}, props, {
        component: component
    }));
    if (runTransition) return /*#__PURE__*/ (0, $cKvYK.jsx)($f7bb0e3ef4a0f95f$export$2e2bcd8739ae039, Object.assign({}, props, {
        transition: runTransition
    }));
    return /*#__PURE__*/ (0, $cKvYK.jsx)((0, $5YUeB.default), Object.assign({}, props));
}

});
parcelRegister("elVBm", function(module, exports) {

$parcel$export(module.exports, "default", () => $a72fb555b4b57bff$export$2e2bcd8739ae039);

var $kc00y = parcelRequire("kc00y");
const $a72fb555b4b57bff$var$isReactNative = typeof $parcel$global !== "undefined" && // @ts-ignore
$parcel$global.navigator && // @ts-ignore
$parcel$global.navigator.product === "ReactNative";
const $a72fb555b4b57bff$var$isDOM = typeof document !== "undefined";
var /**
 * Is `useLayoutEffect` in a DOM or React Native environment, otherwise resolves to useEffect
 * Only useful to avoid the console warning.
 *
 * PREFER `useEffect` UNLESS YOU KNOW WHAT YOU ARE DOING.
 *
 * @category effects
 */ $a72fb555b4b57bff$export$2e2bcd8739ae039 = $a72fb555b4b57bff$var$isDOM || $a72fb555b4b57bff$var$isReactNative ? (0, $kc00y.useLayoutEffect) : (0, $kc00y.useEffect);

});

parcelRegister("5YUeB", function(module, exports) {

$parcel$export(module.exports, "default", () => $45ae2d5550567d5b$export$2e2bcd8739ae039);

var $62odg = parcelRequire("62odg");

var $cNjN5 = parcelRequire("cNjN5");

var $kc00y = parcelRequire("kc00y");
function $45ae2d5550567d5b$var$NoopTransition({ children: children, in: inProp, onExited: onExited, mountOnEnter: mountOnEnter, unmountOnExit: unmountOnExit }) {
    const ref = (0, $kc00y.useRef)(null);
    const hasEnteredRef = (0, $kc00y.useRef)(inProp);
    const handleExited = (0, $62odg.default)(onExited);
    (0, $kc00y.useEffect)(()=>{
        if (inProp) hasEnteredRef.current = true;
        else handleExited(ref.current);
    }, [
        inProp,
        handleExited
    ]);
    const combinedRef = (0, $cNjN5.default)(ref, children.ref);
    const child = /*#__PURE__*/ (0, $kc00y.cloneElement)(children, {
        ref: combinedRef
    });
    if (inProp) return child;
    if (unmountOnExit) return null;
    if (!hasEnteredRef.current && mountOnEnter) return null;
    return child;
}
var $45ae2d5550567d5b$export$2e2bcd8739ae039 = $45ae2d5550567d5b$var$NoopTransition;

});

parcelRegister("bNSCA", function(module, exports) {

$parcel$export(module.exports, "default", () => $897ea3fa6afa4456$export$2e2bcd8739ae039);

var $kc00y = parcelRequire("kc00y");

var $enHBN = parcelRequire("enHBN");

var $cKvYK = parcelRequire("cKvYK");
const $897ea3fa6afa4456$var$_excluded = [
    "component"
];
function $897ea3fa6afa4456$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
// Normalizes Transition callbacks when nodeRef is used.
const $897ea3fa6afa4456$var$RTGTransition = /*#__PURE__*/ $kc00y.forwardRef((_ref, ref)=>{
    let { component: Component } = _ref, props = $897ea3fa6afa4456$var$_objectWithoutPropertiesLoose(_ref, $897ea3fa6afa4456$var$_excluded);
    const transitionProps = (0, $enHBN.default)(props);
    return /*#__PURE__*/ (0, $cKvYK.jsx)(Component, Object.assign({
        ref: ref
    }, transitionProps));
});
var $897ea3fa6afa4456$export$2e2bcd8739ae039 = $897ea3fa6afa4456$var$RTGTransition;

});
parcelRegister("enHBN", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7850a69bb625769$export$2e2bcd8739ae039);

var $kc00y = parcelRequire("kc00y");

var $cNjN5 = parcelRequire("cNjN5");

var $cwgAT = parcelRequire("cwgAT");
const $a7850a69bb625769$var$_excluded = [
    "onEnter",
    "onEntering",
    "onEntered",
    "onExit",
    "onExiting",
    "onExited",
    "addEndListener",
    "children"
];
function $a7850a69bb625769$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $a7850a69bb625769$export$2e2bcd8739ae039(_ref) {
    let { onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onExited: onExited, addEndListener: addEndListener, children: children } = _ref, props = $a7850a69bb625769$var$_objectWithoutPropertiesLoose(_ref, $a7850a69bb625769$var$_excluded);
    const { major: major } = (0, $cwgAT.getReactVersion)();
    const childRef = major >= 19 ? children.props.ref : children.ref;
    const nodeRef = (0, $kc00y.useRef)(null);
    const mergedRef = (0, $cNjN5.default)(nodeRef, typeof children === "function" ? null : childRef);
    const normalize = (callback)=>(param)=>{
            if (callback && nodeRef.current) callback(nodeRef.current, param);
        };
    /* eslint-disable react-hooks/exhaustive-deps */ const handleEnter = (0, $kc00y.useCallback)(normalize(onEnter), [
        onEnter
    ]);
    const handleEntering = (0, $kc00y.useCallback)(normalize(onEntering), [
        onEntering
    ]);
    const handleEntered = (0, $kc00y.useCallback)(normalize(onEntered), [
        onEntered
    ]);
    const handleExit = (0, $kc00y.useCallback)(normalize(onExit), [
        onExit
    ]);
    const handleExiting = (0, $kc00y.useCallback)(normalize(onExiting), [
        onExiting
    ]);
    const handleExited = (0, $kc00y.useCallback)(normalize(onExited), [
        onExited
    ]);
    const handleAddEndListener = (0, $kc00y.useCallback)(normalize(addEndListener), [
        addEndListener
    ]);
    /* eslint-enable react-hooks/exhaustive-deps */ return Object.assign({}, props, {
        nodeRef: nodeRef
    }, onEnter && {
        onEnter: handleEnter
    }, onEntering && {
        onEntering: handleEntering
    }, onEntered && {
        onEntered: handleEntered
    }, onExit && {
        onExit: handleExit
    }, onExiting && {
        onExiting: handleExiting
    }, onExited && {
        onExited: handleExited
    }, addEndListener && {
        addEndListener: handleAddEndListener
    }, {
        children: typeof children === "function" ? (status, innerProps)=>// TODO: Types for RTG missing innerProps, so need to cast.
            children(status, Object.assign({}, innerProps, {
                ref: mergedRef
            })) : /*#__PURE__*/ (0, $kc00y.cloneElement)(children, {
            ref: mergedRef
        })
    });
}

});
parcelRegister("cwgAT", function(module, exports) {

$parcel$export(module.exports, "isEscKey", () => $91d5586e687d56e1$export$806fcc22e55e107d);
$parcel$export(module.exports, "getReactVersion", () => $91d5586e687d56e1$export$13e065f3a74cfe36);

var $kc00y = parcelRequire("kc00y");
function $91d5586e687d56e1$export$806fcc22e55e107d(e) {
    return e.code === "Escape" || e.keyCode === 27;
}
function $91d5586e687d56e1$export$13e065f3a74cfe36() {
    const parts = $kc00y.version.split(".");
    return {
        major: +parts[0],
        minor: +parts[1],
        patch: +parts[2]
    };
}

});





parcelRegister("71jBM", function(module, exports) {

$parcel$export(module.exports, "getSharedManager", () => $51c7d6344e391079$export$a03641438014b436);
$parcel$export(module.exports, "default", () => $51c7d6344e391079$export$2e2bcd8739ae039);

var $equjx = parcelRequire("equjx");

var $cjXNV = parcelRequire("cjXNV");

var $l9zWI = parcelRequire("l9zWI");

var $2nUtY = parcelRequire("2nUtY");

var $jBiHS = parcelRequire("jBiHS");
const $51c7d6344e391079$var$Selector = {
    FIXED_CONTENT: ".fixed-top, .fixed-bottom, .is-fixed, .sticky-top",
    STICKY_CONTENT: ".sticky-top",
    NAVBAR_TOGGLER: ".navbar-toggler"
};
class $51c7d6344e391079$var$BootstrapModalManager extends (0, $jBiHS.default) {
    adjustAndStore(prop, element, adjust) {
        const actual = element.style[prop];
        // TODO: DOMStringMap and CSSStyleDeclaration aren't strictly compatible
        // @ts-ignore
        element.dataset[prop] = actual;
        (0, $cjXNV.default)(element, {
            [prop]: `${parseFloat((0, $cjXNV.default)(element, prop)) + adjust}px`
        });
    }
    restore(prop, element) {
        const value = element.dataset[prop];
        if (value !== undefined) {
            delete element.dataset[prop];
            (0, $cjXNV.default)(element, {
                [prop]: value
            });
        }
    }
    setContainerStyle(containerState) {
        super.setContainerStyle(containerState);
        const container = this.getElement();
        (0, $equjx.default)(container, "modal-open");
        if (!containerState.scrollBarWidth) return;
        const paddingProp = this.isRTL ? "paddingLeft" : "paddingRight";
        const marginProp = this.isRTL ? "marginLeft" : "marginRight";
        (0, $l9zWI.default)(container, $51c7d6344e391079$var$Selector.FIXED_CONTENT).forEach((el)=>this.adjustAndStore(paddingProp, el, containerState.scrollBarWidth));
        (0, $l9zWI.default)(container, $51c7d6344e391079$var$Selector.STICKY_CONTENT).forEach((el)=>this.adjustAndStore(marginProp, el, -containerState.scrollBarWidth));
        (0, $l9zWI.default)(container, $51c7d6344e391079$var$Selector.NAVBAR_TOGGLER).forEach((el)=>this.adjustAndStore(marginProp, el, containerState.scrollBarWidth));
    }
    removeContainerStyle(containerState) {
        super.removeContainerStyle(containerState);
        const container = this.getElement();
        (0, $2nUtY.default)(container, "modal-open");
        const paddingProp = this.isRTL ? "paddingLeft" : "paddingRight";
        const marginProp = this.isRTL ? "marginLeft" : "marginRight";
        (0, $l9zWI.default)(container, $51c7d6344e391079$var$Selector.FIXED_CONTENT).forEach((el)=>this.restore(paddingProp, el));
        (0, $l9zWI.default)(container, $51c7d6344e391079$var$Selector.STICKY_CONTENT).forEach((el)=>this.restore(marginProp, el));
        (0, $l9zWI.default)(container, $51c7d6344e391079$var$Selector.NAVBAR_TOGGLER).forEach((el)=>this.restore(marginProp, el));
    }
}
let $51c7d6344e391079$var$sharedManager;
function $51c7d6344e391079$export$a03641438014b436(options) {
    if (!$51c7d6344e391079$var$sharedManager) $51c7d6344e391079$var$sharedManager = new $51c7d6344e391079$var$BootstrapModalManager(options);
    return $51c7d6344e391079$var$sharedManager;
}
var $51c7d6344e391079$export$2e2bcd8739ae039 = $51c7d6344e391079$var$BootstrapModalManager;

});
parcelRegister("equjx", function(module, exports) {

$parcel$export(module.exports, "default", () => $a80b022aa5789286$export$2e2bcd8739ae039);

var $h522r = parcelRequire("h522r");
function $a80b022aa5789286$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, $h522r.default)(element, className)) {
        if (typeof element.className === "string") element.className = element.className + " " + className;
        else element.setAttribute("class", (element.className && element.className.baseVal || "") + " " + className);
    }
}

});
parcelRegister("h522r", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6f47c13d4796d39$export$2e2bcd8739ae039);
/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */ function $c6f47c13d4796d39$export$2e2bcd8739ae039(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

});


parcelRegister("l9zWI", function(module, exports) {

$parcel$export(module.exports, "default", () => $f666525aadfce5dc$export$2e2bcd8739ae039);
var $f666525aadfce5dc$var$toArray = Function.prototype.bind.call(Function.prototype.call, [].slice);
function $f666525aadfce5dc$export$2e2bcd8739ae039(element, selector) {
    return $f666525aadfce5dc$var$toArray(element.querySelectorAll(selector));
}

});

parcelRegister("2nUtY", function(module, exports) {

$parcel$export(module.exports, "default", () => $1bc98b03a1c48f7b$export$2e2bcd8739ae039);
function $1bc98b03a1c48f7b$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", "g"), "$1").replace(/\s+/g, " ").replace(/^\s*|\s*$/g, "");
}
function $1bc98b03a1c48f7b$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === "string") element.className = $1bc98b03a1c48f7b$var$replaceClassName(element.className, className);
    else element.setAttribute("class", $1bc98b03a1c48f7b$var$replaceClassName(element.className && element.className.baseVal || "", className));
}

});


parcelRegister("3fsmI", function(module, exports) {

$parcel$export(module.exports, "default", () => $25d8c693c355530c$export$2e2bcd8739ae039);

var $lgiU2 = parcelRequire("lgiU2");

var $kc00y = parcelRequire("kc00y");

var $cBHIW = parcelRequire("cBHIW");

var $cwgAT = parcelRequire("cwgAT");

var $iyk2g = parcelRequire("iyk2g");

var $1RuXx = parcelRequire("1RuXx");

var $5vfux = parcelRequire("5vfux");

var $cKvYK = parcelRequire("cKvYK");
const $25d8c693c355530c$var$fadeStyles = {
    [(0, $cBHIW.ENTERING)]: "show",
    [(0, $cBHIW.ENTERED)]: "show"
};
const $25d8c693c355530c$var$Fade = /*#__PURE__*/ $kc00y.forwardRef(({ className: className, children: children, transitionClasses: transitionClasses = {}, onEnter: onEnter, ...rest }, ref)=>{
    const props = {
        in: false,
        timeout: 300,
        mountOnEnter: false,
        unmountOnExit: false,
        appear: false,
        ...rest
    };
    const handleEnter = (0, $kc00y.useCallback)((node, isAppearing)=>{
        (0, $1RuXx.default)(node);
        onEnter == null || onEnter(node, isAppearing);
    }, [
        onEnter
    ]);
    const { major: major } = (0, $cwgAT.getReactVersion)();
    const childRef = major >= 19 ? children.props.ref : children.ref;
    return /*#__PURE__*/ (0, $cKvYK.jsx)((0, $5vfux.default), {
        ref: ref,
        addEndListener: (0, $iyk2g.default),
        ...props,
        onEnter: handleEnter,
        childRef: childRef,
        children: (status, innerProps)=>/*#__PURE__*/ $kc00y.cloneElement(children, {
                ...innerProps,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($lgiU2)))("fade", className, children.props.className, $25d8c693c355530c$var$fadeStyles[status], transitionClasses[status])
            })
    });
});
$25d8c693c355530c$var$Fade.displayName = "Fade";
var $25d8c693c355530c$export$2e2bcd8739ae039 = $25d8c693c355530c$var$Fade;

});
parcelRegister("cBHIW", function(module, exports) {

$parcel$export(module.exports, "EXITED", () => $92dadb5ebc6bf1cd$export$84cbff306f539230);
$parcel$export(module.exports, "ENTERING", () => $92dadb5ebc6bf1cd$export$df38205c966be359);
$parcel$export(module.exports, "ENTERED", () => $92dadb5ebc6bf1cd$export$78e9e6e3e014d60a);
$parcel$export(module.exports, "EXITING", () => $92dadb5ebc6bf1cd$export$4aacc83d4d59139f);
$parcel$export(module.exports, "default", () => $92dadb5ebc6bf1cd$export$2e2bcd8739ae039);

var $7pbxe = parcelRequire("7pbxe");

var $dDBDB = parcelRequire("dDBDB");


var $kc00y = parcelRequire("kc00y");

var $cn1Kz = parcelRequire("cn1Kz");

var $03AGk = parcelRequire("03AGk");


var $iTtBE = parcelRequire("iTtBE");

var $7XqUa = parcelRequire("7XqUa");
var $92dadb5ebc6bf1cd$export$bb38bb9a1161268 = "unmounted";
var $92dadb5ebc6bf1cd$export$84cbff306f539230 = "exited";
var $92dadb5ebc6bf1cd$export$df38205c966be359 = "entering";
var $92dadb5ebc6bf1cd$export$78e9e6e3e014d60a = "entered";
var $92dadb5ebc6bf1cd$export$4aacc83d4d59139f = "exiting";
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $92dadb5ebc6bf1cd$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $dDBDB.default)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $92dadb5ebc6bf1cd$export$84cbff306f539230;
                _this.appearStatus = $92dadb5ebc6bf1cd$export$df38205c966be359;
            } else initialStatus = $92dadb5ebc6bf1cd$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $92dadb5ebc6bf1cd$export$bb38bb9a1161268;
        else initialStatus = $92dadb5ebc6bf1cd$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $92dadb5ebc6bf1cd$export$bb38bb9a1161268) return {
            status: $92dadb5ebc6bf1cd$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $92dadb5ebc6bf1cd$export$df38205c966be359 && status !== $92dadb5ebc6bf1cd$export$78e9e6e3e014d60a) nextStatus = $92dadb5ebc6bf1cd$export$df38205c966be359;
            } else if (status === $92dadb5ebc6bf1cd$export$df38205c966be359 || status === $92dadb5ebc6bf1cd$export$78e9e6e3e014d60a) nextStatus = $92dadb5ebc6bf1cd$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== "number") {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $92dadb5ebc6bf1cd$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($cn1Kz))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $7XqUa.forceReflow)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $92dadb5ebc6bf1cd$export$84cbff306f539230) this.setState({
            status: $92dadb5ebc6bf1cd$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($cn1Kz))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $03AGk.default).disabled) {
            this.safeSetState({
                status: $92dadb5ebc6bf1cd$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $92dadb5ebc6bf1cd$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $92dadb5ebc6bf1cd$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($cn1Kz))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $03AGk.default).disabled) {
            this.safeSetState({
                status: $92dadb5ebc6bf1cd$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $92dadb5ebc6bf1cd$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $92dadb5ebc6bf1cd$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($cn1Kz))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $92dadb5ebc6bf1cd$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $7pbxe.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement((0, $iTtBE.default).Provider, {
            value: null
        }, typeof children === "function" ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).Component);
$92dadb5ebc6bf1cd$var$Transition.contextType = (0, $iTtBE.default);
$92dadb5ebc6bf1cd$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $92dadb5ebc6bf1cd$var$noop() {}
$92dadb5ebc6bf1cd$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $92dadb5ebc6bf1cd$var$noop,
    onEntering: $92dadb5ebc6bf1cd$var$noop,
    onEntered: $92dadb5ebc6bf1cd$var$noop,
    onExit: $92dadb5ebc6bf1cd$var$noop,
    onExiting: $92dadb5ebc6bf1cd$var$noop,
    onExited: $92dadb5ebc6bf1cd$var$noop
};
$92dadb5ebc6bf1cd$var$Transition.UNMOUNTED = $92dadb5ebc6bf1cd$export$bb38bb9a1161268;
$92dadb5ebc6bf1cd$var$Transition.EXITED = $92dadb5ebc6bf1cd$export$84cbff306f539230;
$92dadb5ebc6bf1cd$var$Transition.ENTERING = $92dadb5ebc6bf1cd$export$df38205c966be359;
$92dadb5ebc6bf1cd$var$Transition.ENTERED = $92dadb5ebc6bf1cd$export$78e9e6e3e014d60a;
$92dadb5ebc6bf1cd$var$Transition.EXITING = $92dadb5ebc6bf1cd$export$4aacc83d4d59139f;
var $92dadb5ebc6bf1cd$export$2e2bcd8739ae039 = $92dadb5ebc6bf1cd$var$Transition;

});
parcelRegister("dDBDB", function(module, exports) {

$parcel$export(module.exports, "default", () => $9edc1cf2bf13fb9a$export$2e2bcd8739ae039);

var $ltfqF = parcelRequire("ltfqF");
function $9edc1cf2bf13fb9a$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $ltfqF.default)(t, o);
}

});

parcelRegister("03AGk", function(module, exports) {

$parcel$export(module.exports, "default", () => $00acbc264eaf1494$export$2e2bcd8739ae039);
var $00acbc264eaf1494$export$2e2bcd8739ae039 = {
    disabled: false
};

});

parcelRegister("iTtBE", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc14543d3e286a0d$export$2e2bcd8739ae039);

var $kc00y = parcelRequire("kc00y");
var $dc14543d3e286a0d$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createContext(null);

});

parcelRegister("7XqUa", function(module, exports) {

$parcel$export(module.exports, "forceReflow", () => $5cb2e9dd64739893$export$7d26bbb1236dafd6);
var $5cb2e9dd64739893$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};

});


parcelRegister("iyk2g", function(module, exports) {

$parcel$export(module.exports, "default", () => $d81af195f4d05992$export$2e2bcd8739ae039);

var $cjXNV = parcelRequire("cjXNV");

var $cHhYb = parcelRequire("cHhYb");
function $d81af195f4d05992$var$parseDuration(node, property) {
    const str = (0, $cjXNV.default)(node, property) || "";
    const mult = str.indexOf("ms") === -1 ? 1000 : 1;
    return parseFloat(str) * mult;
}
function $d81af195f4d05992$export$2e2bcd8739ae039(element, handler) {
    const duration = $d81af195f4d05992$var$parseDuration(element, "transitionDuration");
    const delay = $d81af195f4d05992$var$parseDuration(element, "transitionDelay");
    const remove = (0, $cHhYb.default)(element, (e)=>{
        if (e.target === element) {
            remove();
            handler(e);
        }
    }, duration + delay);
}

});

parcelRegister("1RuXx", function(module, exports) {

$parcel$export(module.exports, "default", () => $15b2c193227448e6$export$2e2bcd8739ae039);
// reading a dimension prop will cause the browser to recalculate,
// which will let our animations work
function $15b2c193227448e6$export$2e2bcd8739ae039(node) {
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    node.offsetHeight;
}

});

parcelRegister("5vfux", function(module, exports) {

$parcel$export(module.exports, "default", () => $401bdd4c2cc04a2e$export$2e2bcd8739ae039);

var $kc00y = parcelRequire("kc00y");

var $cBHIW = parcelRequire("cBHIW");

var $cNjN5 = parcelRequire("cNjN5");

var $66nZK = parcelRequire("66nZK");

var $cKvYK = parcelRequire("cKvYK");
"use client";
// Normalizes Transition callbacks when nodeRef is used.
const $401bdd4c2cc04a2e$var$TransitionWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).forwardRef(({ onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onExited: onExited, addEndListener: addEndListener, children: children, childRef: childRef, ...props }, ref)=>{
    const nodeRef = (0, $kc00y.useRef)(null);
    const mergedRef = (0, $cNjN5.default)(nodeRef, childRef);
    const attachRef = (r)=>{
        mergedRef((0, $66nZK.default)(r));
    };
    const normalize = (callback)=>(param)=>{
            if (callback && nodeRef.current) callback(nodeRef.current, param);
        };
    /* eslint-disable react-hooks/exhaustive-deps */ const handleEnter = (0, $kc00y.useCallback)(normalize(onEnter), [
        onEnter
    ]);
    const handleEntering = (0, $kc00y.useCallback)(normalize(onEntering), [
        onEntering
    ]);
    const handleEntered = (0, $kc00y.useCallback)(normalize(onEntered), [
        onEntered
    ]);
    const handleExit = (0, $kc00y.useCallback)(normalize(onExit), [
        onExit
    ]);
    const handleExiting = (0, $kc00y.useCallback)(normalize(onExiting), [
        onExiting
    ]);
    const handleExited = (0, $kc00y.useCallback)(normalize(onExited), [
        onExited
    ]);
    const handleAddEndListener = (0, $kc00y.useCallback)(normalize(addEndListener), [
        addEndListener
    ]);
    /* eslint-enable react-hooks/exhaustive-deps */ return /*#__PURE__*/ (0, $cKvYK.jsx)((0, $cBHIW.default), {
        ref: ref,
        ...props,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        nodeRef: nodeRef,
        children: typeof children === "function" ? (status, innerProps)=>// TODO: Types for RTG missing innerProps, so need to cast.
            children(status, {
                ...innerProps,
                ref: attachRef
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).cloneElement(children, {
            ref: attachRef
        })
    });
});
var $401bdd4c2cc04a2e$export$2e2bcd8739ae039 = $401bdd4c2cc04a2e$var$TransitionWrapper;

});
parcelRegister("66nZK", function(module, exports) {

$parcel$export(module.exports, "default", () => $4715ea7dc6e2917f$export$2e2bcd8739ae039);

var $cn1Kz = parcelRequire("cn1Kz");
function $4715ea7dc6e2917f$export$2e2bcd8739ae039(componentOrElement) {
    if (componentOrElement && "setState" in componentOrElement) return (0, (/*@__PURE__*/$parcel$interopDefault($cn1Kz))).findDOMNode(componentOrElement);
    return componentOrElement != null ? componentOrElement : null;
}

});



parcelRegister("9ntx7", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d3d2bbc78468a94$export$2e2bcd8739ae039);

var $kc00y = parcelRequire("kc00y");

var $lgiU2 = parcelRequire("lgiU2");

var $9i3wr = parcelRequire("9i3wr");

var $cKvYK = parcelRequire("cKvYK");
"use client";
const $6d3d2bbc78468a94$var$ModalBody = /*#__PURE__*/ $kc00y.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = "div", ...props }, ref)=>{
    bsPrefix = (0, $9i3wr.useBootstrapPrefix)(bsPrefix, "modal-body");
    return /*#__PURE__*/ (0, $cKvYK.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($lgiU2)))(className, bsPrefix),
        ...props
    });
});
$6d3d2bbc78468a94$var$ModalBody.displayName = "ModalBody";
var $6d3d2bbc78468a94$export$2e2bcd8739ae039 = $6d3d2bbc78468a94$var$ModalBody;

});

parcelRegister("6Z7dp", function(module, exports) {

$parcel$export(module.exports, "default", () => $515e095cb5609dfa$export$2e2bcd8739ae039);

var $kc00y = parcelRequire("kc00y");
"use client";
const $515e095cb5609dfa$var$ModalContext = /*#__PURE__*/ $kc00y.createContext({
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onHide () {}
});
var $515e095cb5609dfa$export$2e2bcd8739ae039 = $515e095cb5609dfa$var$ModalContext;

});

parcelRegister("dTMkk", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1e5e61b09d62dd1$export$2e2bcd8739ae039);

var $lgiU2 = parcelRequire("lgiU2");

var $kc00y = parcelRequire("kc00y");

var $9i3wr = parcelRequire("9i3wr");

var $cKvYK = parcelRequire("cKvYK");
"use client";
const $a1e5e61b09d62dd1$var$ModalDialog = /*#__PURE__*/ $kc00y.forwardRef(({ bsPrefix: bsPrefix, className: className, contentClassName: contentClassName, centered: centered, size: size, fullscreen: fullscreen, children: children, scrollable: scrollable, ...props }, ref)=>{
    bsPrefix = (0, $9i3wr.useBootstrapPrefix)(bsPrefix, "modal");
    const dialogClass = `${bsPrefix}-dialog`;
    const fullScreenClass = typeof fullscreen === "string" ? `${bsPrefix}-fullscreen-${fullscreen}` : `${bsPrefix}-fullscreen`;
    return /*#__PURE__*/ (0, $cKvYK.jsx)("div", {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($lgiU2)))(dialogClass, className, size && `${bsPrefix}-${size}`, centered && `${dialogClass}-centered`, scrollable && `${dialogClass}-scrollable`, fullscreen && fullScreenClass),
        children: /*#__PURE__*/ (0, $cKvYK.jsx)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($lgiU2)))(`${bsPrefix}-content`, contentClassName),
            children: children
        })
    });
});
$a1e5e61b09d62dd1$var$ModalDialog.displayName = "ModalDialog";
var $a1e5e61b09d62dd1$export$2e2bcd8739ae039 = $a1e5e61b09d62dd1$var$ModalDialog;

});

parcelRegister("8qsmX", function(module, exports) {

$parcel$export(module.exports, "default", () => $6226c1f8626352b5$export$2e2bcd8739ae039);

var $kc00y = parcelRequire("kc00y");

var $lgiU2 = parcelRequire("lgiU2");

var $9i3wr = parcelRequire("9i3wr");

var $cKvYK = parcelRequire("cKvYK");
"use client";
const $6226c1f8626352b5$var$ModalFooter = /*#__PURE__*/ $kc00y.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = "div", ...props }, ref)=>{
    bsPrefix = (0, $9i3wr.useBootstrapPrefix)(bsPrefix, "modal-footer");
    return /*#__PURE__*/ (0, $cKvYK.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($lgiU2)))(className, bsPrefix),
        ...props
    });
});
$6226c1f8626352b5$var$ModalFooter.displayName = "ModalFooter";
var $6226c1f8626352b5$export$2e2bcd8739ae039 = $6226c1f8626352b5$var$ModalFooter;

});

parcelRegister("3WAOl", function(module, exports) {

$parcel$export(module.exports, "default", () => $2df357c71d197c51$export$2e2bcd8739ae039);

var $lgiU2 = parcelRequire("lgiU2");

var $kc00y = parcelRequire("kc00y");

var $9i3wr = parcelRequire("9i3wr");

var $8zVyC = parcelRequire("8zVyC");

var $cKvYK = parcelRequire("cKvYK");
"use client";
const $2df357c71d197c51$var$ModalHeader = /*#__PURE__*/ $kc00y.forwardRef(({ bsPrefix: bsPrefix, className: className, closeLabel: closeLabel = "Close", closeButton: closeButton = false, ...props }, ref)=>{
    bsPrefix = (0, $9i3wr.useBootstrapPrefix)(bsPrefix, "modal-header");
    return /*#__PURE__*/ (0, $cKvYK.jsx)((0, $8zVyC.default), {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($lgiU2)))(className, bsPrefix),
        closeLabel: closeLabel,
        closeButton: closeButton
    });
});
$2df357c71d197c51$var$ModalHeader.displayName = "ModalHeader";
var $2df357c71d197c51$export$2e2bcd8739ae039 = $2df357c71d197c51$var$ModalHeader;

});
parcelRegister("8zVyC", function(module, exports) {

$parcel$export(module.exports, "default", () => $63ee3d51f3ee506e$export$2e2bcd8739ae039);

var $kc00y = parcelRequire("kc00y");

var $62odg = parcelRequire("62odg");

var $b3jl5 = parcelRequire("b3jl5");

var $6Z7dp = parcelRequire("6Z7dp");

var $cKvYK = parcelRequire("cKvYK");
"use client";
const $63ee3d51f3ee506e$var$AbstractModalHeader = /*#__PURE__*/ $kc00y.forwardRef(({ closeLabel: closeLabel = "Close", closeVariant: closeVariant, closeButton: closeButton = false, onHide: onHide, children: children, ...props }, ref)=>{
    const context = (0, $kc00y.useContext)((0, $6Z7dp.default));
    const handleClick = (0, $62odg.default)(()=>{
        context == null || context.onHide();
        onHide == null || onHide();
    });
    return /*#__PURE__*/ (0, $cKvYK.jsxs)("div", {
        ref: ref,
        ...props,
        children: [
            children,
            closeButton && /*#__PURE__*/ (0, $cKvYK.jsx)((0, $b3jl5.default), {
                "aria-label": closeLabel,
                variant: closeVariant,
                onClick: handleClick
            })
        ]
    });
});
var $63ee3d51f3ee506e$export$2e2bcd8739ae039 = $63ee3d51f3ee506e$var$AbstractModalHeader;

});
parcelRegister("b3jl5", function(module, exports) {

$parcel$export(module.exports, "default", () => $80bef9dfc5e82bc1$export$2e2bcd8739ae039);

var $lCkAA = parcelRequire("lCkAA");

var $kc00y = parcelRequire("kc00y");

var $lgiU2 = parcelRequire("lgiU2");

var $cKvYK = parcelRequire("cKvYK");
const $80bef9dfc5e82bc1$var$propTypes = {
    /** An accessible label indicating the relevant information about the Close Button. */ "aria-label": (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).string,
    /** A callback fired after the Close Button is clicked. */ onClick: (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).func,
    /**
   * Render different color variant for the button.
   *
   * Omitting this will render the default dark color.
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).oneOf([
        "white"
    ])
};
const $80bef9dfc5e82bc1$var$CloseButton = /*#__PURE__*/ $kc00y.forwardRef(({ className: className, variant: variant, "aria-label": ariaLabel = "Close", ...props }, ref)=>/*#__PURE__*/ (0, $cKvYK.jsx)("button", {
        ref: ref,
        type: "button",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($lgiU2)))("btn-close", variant && `btn-close-${variant}`, className),
        "aria-label": ariaLabel,
        ...props
    }));
$80bef9dfc5e82bc1$var$CloseButton.displayName = "CloseButton";
$80bef9dfc5e82bc1$var$CloseButton.propTypes = $80bef9dfc5e82bc1$var$propTypes;
var $80bef9dfc5e82bc1$export$2e2bcd8739ae039 = $80bef9dfc5e82bc1$var$CloseButton;

});



parcelRegister("bog0z", function(module, exports) {

$parcel$export(module.exports, "default", () => $84ae5a7da8af1722$export$2e2bcd8739ae039);

var $kc00y = parcelRequire("kc00y");

var $lgiU2 = parcelRequire("lgiU2");

var $fBmp7 = parcelRequire("fBmp7");

var $9i3wr = parcelRequire("9i3wr");

var $cKvYK = parcelRequire("cKvYK");
"use client";
const $84ae5a7da8af1722$var$DivStyledAsH4 = (0, $fBmp7.default)("h4");
const $84ae5a7da8af1722$var$ModalTitle = /*#__PURE__*/ $kc00y.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = $84ae5a7da8af1722$var$DivStyledAsH4, ...props }, ref)=>{
    bsPrefix = (0, $9i3wr.useBootstrapPrefix)(bsPrefix, "modal-title");
    return /*#__PURE__*/ (0, $cKvYK.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($lgiU2)))(className, bsPrefix),
        ...props
    });
});
$84ae5a7da8af1722$var$ModalTitle.displayName = "ModalTitle";
var $84ae5a7da8af1722$export$2e2bcd8739ae039 = $84ae5a7da8af1722$var$ModalTitle;

});
parcelRegister("fBmp7", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5bbb0b2ce1c31b6$export$2e2bcd8739ae039);

var $kc00y = parcelRequire("kc00y");

var $lgiU2 = parcelRequire("lgiU2");

var $cKvYK = parcelRequire("cKvYK");
var $b5bbb0b2ce1c31b6$export$2e2bcd8739ae039 = (className)=>/*#__PURE__*/ $kc00y.forwardRef((p, ref)=>/*#__PURE__*/ (0, $cKvYK.jsx)("div", {
            ...p,
            ref: ref,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($lgiU2)))(p.className, className)
        }));

});



parcelRegister("ZmPdA", function(module, exports) {

$parcel$export(module.exports, "CardWithPicture", () => $6274f7610b266e96$export$54858c0debcbdf80);

var $cKvYK = parcelRequire("cKvYK");
parcelRequire("kc00y");

var $lgiU2 = parcelRequire("lgiU2");

var $2bUV8 = parcelRequire("2bUV8");

var $d8c1V = parcelRequire("d8c1V");
var $4DyxQ = parcelRequire("4DyxQ");
var $469X3 = parcelRequire("469X3");

var $hpOSz = parcelRequire("hpOSz");
const $6274f7610b266e96$var$Card = ({ title: title, content: content })=>{
    return /*#__PURE__*/ (0, $cKvYK.jsxs)("section", {
        children: [
            /*#__PURE__*/ (0, $cKvYK.jsx)("h2", {
                children: title
            }),
            /*#__PURE__*/ (0, $cKvYK.jsx)("div", {
                children: content
            })
        ]
    });
};
const $6274f7610b266e96$export$54858c0debcbdf80 = ({ picture: picture, title: title, content: content = "Aucune description", link: link, className: className })=>{
    return /*#__PURE__*/ (0, $cKvYK.jsx)((0, $2bUV8.default), {
        bg: "light",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($lgiU2)))(className, "p-1 p-lg-4 rounded-4 border-0 h-100 pointer"),
        children: /*#__PURE__*/ (0, $cKvYK.jsx)((0, $2bUV8.default).Body, {
            className: className,
            children: /*#__PURE__*/ (0, $cKvYK.jsxs)((0, $469X3.default), {
                children: [
                    picture ? /*#__PURE__*/ (0, $cKvYK.jsxs)((0, $4DyxQ.default), {
                        xs: 3,
                        children: [
                            /*#__PURE__*/ (0, $cKvYK.jsx)((0, $2bUV8.default).Img, {
                                src: picture,
                                className: "rounded-5"
                            }),
                            /*#__PURE__*/ (0, $cKvYK.jsx)((0, $469X3.default), {
                                className: "p-3",
                                children: /*#__PURE__*/ (0, $cKvYK.jsxs)((0, $4DyxQ.default), {
                                    xs: "auto",
                                    className: "text-primary d-flex flex-row justify-content-center link",
                                    children: [
                                        /*#__PURE__*/ (0, $cKvYK.jsx)((0, $d8c1V.default), {
                                            bg: "primary-30",
                                            pill: true,
                                            className: "me-1 text-text-color text-lowercase fw-bold",
                                            children: link
                                        }),
                                        " ",
                                        /*#__PURE__*/ (0, $cKvYK.jsx)("span", {
                                            className: "d-none d-md-inline",
                                            children: /*#__PURE__*/ (0, $cKvYK.jsx)((0, $hpOSz.IconPlay), {})
                                        })
                                    ]
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $cKvYK.jsx)((0, $4DyxQ.default), {
                        xs: 3,
                        children: /*#__PURE__*/ (0, $cKvYK.jsx)((0, $469X3.default), {
                            className: "p-3",
                            children: /*#__PURE__*/ (0, $cKvYK.jsxs)((0, $4DyxQ.default), {
                                xs: "auto",
                                className: "text-primary d-flex flex-row justify-content-center link",
                                children: [
                                    /*#__PURE__*/ (0, $cKvYK.jsx)((0, $d8c1V.default), {
                                        bg: "primary-30",
                                        pill: true,
                                        className: "me-2 text-text-color text-lowercase",
                                        children: link
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0, $cKvYK.jsx)((0, $hpOSz.IconPlay), {})
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $cKvYK.jsxs)((0, $4DyxQ.default), {
                        xs: 9,
                        children: [
                            /*#__PURE__*/ (0, $cKvYK.jsxs)((0, $2bUV8.default).Title, {
                                className: "cardTitle",
                                children: [
                                    " ",
                                    title
                                ]
                            }),
                            /*#__PURE__*/ (0, $cKvYK.jsx)((0, $2bUV8.default).Text, {
                                className: "cardText",
                                children: content
                            })
                        ]
                    })
                ]
            })
        })
    });
};
var $6274f7610b266e96$export$2e2bcd8739ae039 = $6274f7610b266e96$var$Card;

});
parcelRegister("2bUV8", function(module, exports) {

$parcel$export(module.exports, "default", () => $1988c313b8430f65$export$2e2bcd8739ae039);

var $lgiU2 = parcelRequire("lgiU2");

var $kc00y = parcelRequire("kc00y");

var $9i3wr = parcelRequire("9i3wr");

var $1oydx = parcelRequire("1oydx");

var $eYpTn = parcelRequire("eYpTn");

var $l3F6R = parcelRequire("l3F6R");

var $38LxB = parcelRequire("38LxB");

var $3AH9R = parcelRequire("3AH9R");

var $kUxrg = parcelRequire("kUxrg");

var $i0zCW = parcelRequire("i0zCW");

var $gE10Y = parcelRequire("gE10Y");

var $04xIH = parcelRequire("04xIH");

var $cKvYK = parcelRequire("cKvYK");
"use client";
const $1988c313b8430f65$var$Card = /*#__PURE__*/ $kc00y.forwardRef(({ bsPrefix: bsPrefix, className: className, bg: bg, text: text, border: border, body: body = false, children: children, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = "div", ...props }, ref)=>{
    const prefix = (0, $9i3wr.useBootstrapPrefix)(bsPrefix, "card");
    return /*#__PURE__*/ (0, $cKvYK.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($lgiU2)))(className, prefix, bg && `bg-${bg}`, text && `text-${text}`, border && `border-${border}`),
        children: body ? /*#__PURE__*/ (0, $cKvYK.jsx)((0, $1oydx.default), {
            children: children
        }) : children
    });
});
$1988c313b8430f65$var$Card.displayName = "Card";
var $1988c313b8430f65$export$2e2bcd8739ae039 = Object.assign($1988c313b8430f65$var$Card, {
    Img: (0, $38LxB.default),
    Title: (0, $04xIH.default),
    Subtitle: (0, $i0zCW.default),
    Body: (0, $1oydx.default),
    Link: (0, $kUxrg.default),
    Text: (0, $gE10Y.default),
    Header: (0, $l3F6R.default),
    Footer: (0, $eYpTn.default),
    ImgOverlay: (0, $3AH9R.default)
});

});
parcelRegister("1oydx", function(module, exports) {

$parcel$export(module.exports, "default", () => $104293336995282e$export$2e2bcd8739ae039);

var $kc00y = parcelRequire("kc00y");

var $lgiU2 = parcelRequire("lgiU2");

var $9i3wr = parcelRequire("9i3wr");

var $cKvYK = parcelRequire("cKvYK");
"use client";
const $104293336995282e$var$CardBody = /*#__PURE__*/ $kc00y.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = "div", ...props }, ref)=>{
    bsPrefix = (0, $9i3wr.useBootstrapPrefix)(bsPrefix, "card-body");
    return /*#__PURE__*/ (0, $cKvYK.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($lgiU2)))(className, bsPrefix),
        ...props
    });
});
$104293336995282e$var$CardBody.displayName = "CardBody";
var $104293336995282e$export$2e2bcd8739ae039 = $104293336995282e$var$CardBody;

});

parcelRegister("eYpTn", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae6ac0f2edeae50f$export$2e2bcd8739ae039);

var $kc00y = parcelRequire("kc00y");

var $lgiU2 = parcelRequire("lgiU2");

var $9i3wr = parcelRequire("9i3wr");

var $cKvYK = parcelRequire("cKvYK");
"use client";
const $ae6ac0f2edeae50f$var$CardFooter = /*#__PURE__*/ $kc00y.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = "div", ...props }, ref)=>{
    bsPrefix = (0, $9i3wr.useBootstrapPrefix)(bsPrefix, "card-footer");
    return /*#__PURE__*/ (0, $cKvYK.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($lgiU2)))(className, bsPrefix),
        ...props
    });
});
$ae6ac0f2edeae50f$var$CardFooter.displayName = "CardFooter";
var $ae6ac0f2edeae50f$export$2e2bcd8739ae039 = $ae6ac0f2edeae50f$var$CardFooter;

});

parcelRegister("l3F6R", function(module, exports) {

$parcel$export(module.exports, "default", () => $f549c44bde8e5d86$export$2e2bcd8739ae039);

var $lgiU2 = parcelRequire("lgiU2");

var $kc00y = parcelRequire("kc00y");

var $9i3wr = parcelRequire("9i3wr");

var $jH8R1 = parcelRequire("jH8R1");

var $cKvYK = parcelRequire("cKvYK");
"use client";
const $f549c44bde8e5d86$var$CardHeader = /*#__PURE__*/ $kc00y.forwardRef(({ bsPrefix: bsPrefix, className: className, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = "div", ...props }, ref)=>{
    const prefix = (0, $9i3wr.useBootstrapPrefix)(bsPrefix, "card-header");
    const contextValue = (0, $kc00y.useMemo)(()=>({
            cardHeaderBsPrefix: prefix
        }), [
        prefix
    ]);
    return /*#__PURE__*/ (0, $cKvYK.jsx)((0, $jH8R1.default).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $cKvYK.jsx)(Component, {
            ref: ref,
            ...props,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($lgiU2)))(className, prefix)
        })
    });
});
$f549c44bde8e5d86$var$CardHeader.displayName = "CardHeader";
var $f549c44bde8e5d86$export$2e2bcd8739ae039 = $f549c44bde8e5d86$var$CardHeader;

});
parcelRegister("jH8R1", function(module, exports) {

$parcel$export(module.exports, "default", () => $e568e6bef19b3ebd$export$2e2bcd8739ae039);

var $kc00y = parcelRequire("kc00y");
"use client";
const $e568e6bef19b3ebd$var$context = /*#__PURE__*/ $kc00y.createContext(null);
$e568e6bef19b3ebd$var$context.displayName = "CardHeaderContext";
var $e568e6bef19b3ebd$export$2e2bcd8739ae039 = $e568e6bef19b3ebd$var$context;

});


parcelRegister("38LxB", function(module, exports) {

$parcel$export(module.exports, "default", () => $2496ff1a34190662$export$2e2bcd8739ae039);

var $lgiU2 = parcelRequire("lgiU2");

var $kc00y = parcelRequire("kc00y");

var $9i3wr = parcelRequire("9i3wr");

var $cKvYK = parcelRequire("cKvYK");
"use client";
const $2496ff1a34190662$var$CardImg = /*#__PURE__*/ $kc00y.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
({ bsPrefix: bsPrefix, className: className, variant: variant, as: Component = "img", ...props }, ref)=>{
    const prefix = (0, $9i3wr.useBootstrapPrefix)(bsPrefix, "card-img");
    return /*#__PURE__*/ (0, $cKvYK.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($lgiU2)))(variant ? `${prefix}-${variant}` : prefix, className),
        ...props
    });
});
$2496ff1a34190662$var$CardImg.displayName = "CardImg";
var $2496ff1a34190662$export$2e2bcd8739ae039 = $2496ff1a34190662$var$CardImg;

});

parcelRegister("3AH9R", function(module, exports) {

$parcel$export(module.exports, "default", () => $29d6362a703937a7$export$2e2bcd8739ae039);

var $kc00y = parcelRequire("kc00y");

var $lgiU2 = parcelRequire("lgiU2");

var $9i3wr = parcelRequire("9i3wr");

var $cKvYK = parcelRequire("cKvYK");
"use client";
const $29d6362a703937a7$var$CardImgOverlay = /*#__PURE__*/ $kc00y.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = "div", ...props }, ref)=>{
    bsPrefix = (0, $9i3wr.useBootstrapPrefix)(bsPrefix, "card-img-overlay");
    return /*#__PURE__*/ (0, $cKvYK.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($lgiU2)))(className, bsPrefix),
        ...props
    });
});
$29d6362a703937a7$var$CardImgOverlay.displayName = "CardImgOverlay";
var $29d6362a703937a7$export$2e2bcd8739ae039 = $29d6362a703937a7$var$CardImgOverlay;

});

parcelRegister("kUxrg", function(module, exports) {

$parcel$export(module.exports, "default", () => $f392f9d50505ef7f$export$2e2bcd8739ae039);

var $kc00y = parcelRequire("kc00y");

var $lgiU2 = parcelRequire("lgiU2");

var $9i3wr = parcelRequire("9i3wr");

var $cKvYK = parcelRequire("cKvYK");
"use client";
const $f392f9d50505ef7f$var$CardLink = /*#__PURE__*/ $kc00y.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = "a", ...props }, ref)=>{
    bsPrefix = (0, $9i3wr.useBootstrapPrefix)(bsPrefix, "card-link");
    return /*#__PURE__*/ (0, $cKvYK.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($lgiU2)))(className, bsPrefix),
        ...props
    });
});
$f392f9d50505ef7f$var$CardLink.displayName = "CardLink";
var $f392f9d50505ef7f$export$2e2bcd8739ae039 = $f392f9d50505ef7f$var$CardLink;

});

parcelRegister("i0zCW", function(module, exports) {

$parcel$export(module.exports, "default", () => $036220772594cba7$export$2e2bcd8739ae039);

var $kc00y = parcelRequire("kc00y");

var $lgiU2 = parcelRequire("lgiU2");

var $9i3wr = parcelRequire("9i3wr");

var $fBmp7 = parcelRequire("fBmp7");

var $cKvYK = parcelRequire("cKvYK");
"use client";
const $036220772594cba7$var$DivStyledAsH6 = (0, $fBmp7.default)("h6");
const $036220772594cba7$var$CardSubtitle = /*#__PURE__*/ $kc00y.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = $036220772594cba7$var$DivStyledAsH6, ...props }, ref)=>{
    bsPrefix = (0, $9i3wr.useBootstrapPrefix)(bsPrefix, "card-subtitle");
    return /*#__PURE__*/ (0, $cKvYK.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($lgiU2)))(className, bsPrefix),
        ...props
    });
});
$036220772594cba7$var$CardSubtitle.displayName = "CardSubtitle";
var $036220772594cba7$export$2e2bcd8739ae039 = $036220772594cba7$var$CardSubtitle;

});

parcelRegister("gE10Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1e12b416d07cc3a$export$2e2bcd8739ae039);

var $kc00y = parcelRequire("kc00y");

var $lgiU2 = parcelRequire("lgiU2");

var $9i3wr = parcelRequire("9i3wr");

var $cKvYK = parcelRequire("cKvYK");
"use client";
const $c1e12b416d07cc3a$var$CardText = /*#__PURE__*/ $kc00y.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = "p", ...props }, ref)=>{
    bsPrefix = (0, $9i3wr.useBootstrapPrefix)(bsPrefix, "card-text");
    return /*#__PURE__*/ (0, $cKvYK.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($lgiU2)))(className, bsPrefix),
        ...props
    });
});
$c1e12b416d07cc3a$var$CardText.displayName = "CardText";
var $c1e12b416d07cc3a$export$2e2bcd8739ae039 = $c1e12b416d07cc3a$var$CardText;

});

parcelRegister("04xIH", function(module, exports) {

$parcel$export(module.exports, "default", () => $00da87eaa7cf462b$export$2e2bcd8739ae039);

var $kc00y = parcelRequire("kc00y");

var $lgiU2 = parcelRequire("lgiU2");

var $9i3wr = parcelRequire("9i3wr");

var $fBmp7 = parcelRequire("fBmp7");

var $cKvYK = parcelRequire("cKvYK");
"use client";
const $00da87eaa7cf462b$var$DivStyledAsH5 = (0, $fBmp7.default)("h5");
const $00da87eaa7cf462b$var$CardTitle = /*#__PURE__*/ $kc00y.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = $00da87eaa7cf462b$var$DivStyledAsH5, ...props }, ref)=>{
    bsPrefix = (0, $9i3wr.useBootstrapPrefix)(bsPrefix, "card-title");
    return /*#__PURE__*/ (0, $cKvYK.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($lgiU2)))(className, bsPrefix),
        ...props
    });
});
$00da87eaa7cf462b$var$CardTitle.displayName = "CardTitle";
var $00da87eaa7cf462b$export$2e2bcd8739ae039 = $00da87eaa7cf462b$var$CardTitle;

});


parcelRegister("d8c1V", function(module, exports) {

$parcel$export(module.exports, "default", () => $98f55aa78fbaf278$export$2e2bcd8739ae039);

var $lgiU2 = parcelRequire("lgiU2");

var $kc00y = parcelRequire("kc00y");

var $9i3wr = parcelRequire("9i3wr");

var $cKvYK = parcelRequire("cKvYK");
"use client";
const $98f55aa78fbaf278$var$Badge = /*#__PURE__*/ $kc00y.forwardRef(({ bsPrefix: bsPrefix, bg: bg = "primary", pill: pill = false, text: text, className: className, as: Component = "span", ...props }, ref)=>{
    const prefix = (0, $9i3wr.useBootstrapPrefix)(bsPrefix, "badge");
    return /*#__PURE__*/ (0, $cKvYK.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($lgiU2)))(className, prefix, pill && `rounded-pill`, text && `text-${text}`, bg && `bg-${bg}`)
    });
});
$98f55aa78fbaf278$var$Badge.displayName = "Badge";
var $98f55aa78fbaf278$export$2e2bcd8739ae039 = $98f55aa78fbaf278$var$Badge;

});


parcelRegister("hL7qO", function(module, exports) {

$parcel$export(module.exports, "card", () => $cedc972dd59b93f7$export$aa3e815946b80764, (v) => $cedc972dd59b93f7$export$aa3e815946b80764 = v);
$parcel$export(module.exports, "cardLink", () => $cedc972dd59b93f7$export$c4387b32cb5d9d67, (v) => $cedc972dd59b93f7$export$c4387b32cb5d9d67 = v);
$parcel$export(module.exports, "content", () => $cedc972dd59b93f7$export$a7db06668cad9adb, (v) => $cedc972dd59b93f7$export$a7db06668cad9adb = v);
$parcel$export(module.exports, "descriptionRessource", () => $cedc972dd59b93f7$export$fd10e9e273161b08, (v) => $cedc972dd59b93f7$export$fd10e9e273161b08 = v);
$parcel$export(module.exports, "imageRessource", () => $cedc972dd59b93f7$export$39ccb620af8331ca, (v) => $cedc972dd59b93f7$export$39ccb620af8331ca = v);
$parcel$export(module.exports, "link", () => $cedc972dd59b93f7$export$9c30223ca0a664fb, (v) => $cedc972dd59b93f7$export$9c30223ca0a664fb = v);
$parcel$export(module.exports, "linkLibelle", () => $cedc972dd59b93f7$export$e199c9bb9acd9c2e, (v) => $cedc972dd59b93f7$export$e199c9bb9acd9c2e = v);
$parcel$export(module.exports, "modalpdf", () => $cedc972dd59b93f7$export$9cc7c32da75798c1, (v) => $cedc972dd59b93f7$export$9cc7c32da75798c1 = v);
var $cedc972dd59b93f7$export$aa3e815946b80764;
var $cedc972dd59b93f7$export$c4387b32cb5d9d67;
var $cedc972dd59b93f7$export$a7db06668cad9adb;
var $cedc972dd59b93f7$export$fd10e9e273161b08;
var $cedc972dd59b93f7$export$39ccb620af8331ca;
var $cedc972dd59b93f7$export$9c30223ca0a664fb;
var $cedc972dd59b93f7$export$e199c9bb9acd9c2e;
var $cedc972dd59b93f7$export$9cc7c32da75798c1;
$cedc972dd59b93f7$export$aa3e815946b80764 = `kRrL7W_card`;
$cedc972dd59b93f7$export$c4387b32cb5d9d67 = `kRrL7W_cardLink`;
$cedc972dd59b93f7$export$a7db06668cad9adb = `kRrL7W_content`;
$cedc972dd59b93f7$export$fd10e9e273161b08 = `kRrL7W_descriptionRessource`;
$cedc972dd59b93f7$export$39ccb620af8331ca = `kRrL7W_imageRessource`;
$cedc972dd59b93f7$export$9c30223ca0a664fb = `kRrL7W_link`;
$cedc972dd59b93f7$export$e199c9bb9acd9c2e = `kRrL7W_linkLibelle`;
$cedc972dd59b93f7$export$9cc7c32da75798c1 = `kRrL7W_modalpdf`;

});


parcelRegister("eVTM9", function(module, exports) {

$parcel$export(module.exports, "default", () => $25713c98dba2421b$export$2e2bcd8739ae039);

var $cKvYK = parcelRequire("cKvYK");

var $lgiU2 = parcelRequire("lgiU2");

var $hpOSz = parcelRequire("hpOSz");

var $h6TLB = parcelRequire("h6TLB");
const $25713c98dba2421b$var$LigneEcoute = ()=>{
    return /*#__PURE__*/ (0, $cKvYK.jsx)("address", {
        className: "col-12 text-center",
        children: /*#__PURE__*/ (0, $cKvYK.jsxs)("a", {
            href: "tel:+33187023144",
            className: "btn btn-primary fw-bold rounded-pill px-5 py-2 text-light m-0 fit-content",
            children: [
                /*#__PURE__*/ (0, $cKvYK.jsxs)("p", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($lgiU2)))("mx-2 m-0 h4", (0, (/*@__PURE__*/$parcel$interopDefault($h6TLB))).phoneNumber),
                    children: [
                        /*#__PURE__*/ (0, $cKvYK.jsx)("span", {
                            className: "ms-2",
                            children: "01 87 02 31 44"
                        }),
                        "\xa0",
                        /*#__PURE__*/ (0, $cKvYK.jsx)((0, $hpOSz.IconPhone), {})
                    ]
                }),
                /*#__PURE__*/ (0, $cKvYK.jsx)("p", {
                    className: "fw-light m-0",
                    children: "Appel anonyme et gratuit"
                })
            ]
        })
    });
};
var $25713c98dba2421b$export$2e2bcd8739ae039 = $25713c98dba2421b$var$LigneEcoute;

});
parcelRegister("h6TLB", function(module, exports) {

$parcel$export(module.exports, "phoneInfo", () => $c74e41541d2b6370$export$e27ae4bec186c794, (v) => $c74e41541d2b6370$export$e27ae4bec186c794 = v);
$parcel$export(module.exports, "phoneNumber", () => $c74e41541d2b6370$export$73d620cb2fed0c37, (v) => $c74e41541d2b6370$export$73d620cb2fed0c37 = v);
var $c74e41541d2b6370$export$e27ae4bec186c794;
var $c74e41541d2b6370$export$73d620cb2fed0c37;
$c74e41541d2b6370$export$e27ae4bec186c794 = `NwfvGa_phoneInfo`;
$c74e41541d2b6370$export$73d620cb2fed0c37 = `NwfvGa_phoneNumber`;

});


parcelRegister("c99Pn", function(module, exports) {

$parcel$export(module.exports, "CodeLivretAccueil", () => $a5f0bd34e7d37658$export$5018a18aaeea92b1);
$parcel$export(module.exports, "default", () => $a5f0bd34e7d37658$export$2e2bcd8739ae039);
// Code de la ressource 'Livret d'Accueil'
const $a5f0bd34e7d37658$export$5018a18aaeea92b1 = "1LIVRET_ACCUEIL";
var // Lint ne permet pas d'avoir un seul export non défini en default
// On est donc obligé de définir un default tant que l'on exporte qu'une constante
$a5f0bd34e7d37658$export$2e2bcd8739ae039 = $a5f0bd34e7d37658$export$5018a18aaeea92b1;

});

parcelRegister("5JDDZ", function(module, exports) {

$parcel$export(module.exports, "container", () => $42cfe835ff280da3$export$34e0f9847d4c02dd, (v) => $42cfe835ff280da3$export$34e0f9847d4c02dd = v);
$parcel$export(module.exports, "left", () => $42cfe835ff280da3$export$eabcd2c8791e7bf4, (v) => $42cfe835ff280da3$export$eabcd2c8791e7bf4 = v);
$parcel$export(module.exports, "right", () => $42cfe835ff280da3$export$79ffe56a765070d2, (v) => $42cfe835ff280da3$export$79ffe56a765070d2 = v);
$parcel$export(module.exports, "subline", () => $42cfe835ff280da3$export$2f56d4c1c6e30742, (v) => $42cfe835ff280da3$export$2f56d4c1c6e30742 = v);
$parcel$export(module.exports, "subtitle", () => $42cfe835ff280da3$export$c96745152eb2740f, (v) => $42cfe835ff280da3$export$c96745152eb2740f = v);
$parcel$export(module.exports, "text", () => $42cfe835ff280da3$export$6f093cfa640b7166, (v) => $42cfe835ff280da3$export$6f093cfa640b7166 = v);
var $42cfe835ff280da3$export$34e0f9847d4c02dd;
var $42cfe835ff280da3$export$eabcd2c8791e7bf4;
var $42cfe835ff280da3$export$79ffe56a765070d2;
var $42cfe835ff280da3$export$2f56d4c1c6e30742;
var $42cfe835ff280da3$export$c96745152eb2740f;
var $42cfe835ff280da3$export$6f093cfa640b7166;
$42cfe835ff280da3$export$34e0f9847d4c02dd = `j5CJJG_container`;
$42cfe835ff280da3$export$eabcd2c8791e7bf4 = `j5CJJG_left`;
$42cfe835ff280da3$export$79ffe56a765070d2 = `j5CJJG_right`;
$42cfe835ff280da3$export$2f56d4c1c6e30742 = `j5CJJG_subline`;
$42cfe835ff280da3$export$c96745152eb2740f = `j5CJJG_subtitle`;
$42cfe835ff280da3$export$6f093cfa640b7166 = `j5CJJG_text`;

});


parcelRegister("IWcTD", function(module, exports) {

$parcel$export(module.exports, "default", () => $1fb2056024a1a10c$export$2e2bcd8739ae039);

var $cKvYK = parcelRequire("cKvYK");

var $4DyxQ = parcelRequire("4DyxQ");
var $469X3 = parcelRequire("469X3");

var $lgiU2 = parcelRequire("lgiU2");

var $5TbRy = parcelRequire("5TbRy");

var $26Ddr = parcelRequire("26Ddr");

var $fLUMT = parcelRequire("fLUMT");
const $1fb2056024a1a10c$var$AccueilAdmin = ()=>{
    const stats = (0, $26Ddr.useGet)((0, $5TbRy.default)`/api/exportLogConnexion/adminStats`, {});
    return /*#__PURE__*/ (0, $cKvYK.jsxs)((0, $469X3.default), {
        children: [
            /*#__PURE__*/ (0, $cKvYK.jsxs)((0, $4DyxQ.default), {
                xs: "auto",
                className: (0, (/*@__PURE__*/$parcel$interopDefault($lgiU2)))("my-3 text-text-color bg-light text-center p-3 rounded-5 mx-5 d-flex flex-column justify-content-center align-items-center", (0, (/*@__PURE__*/$parcel$interopDefault($fLUMT))).mainCard),
                children: [
                    /*#__PURE__*/ (0, $cKvYK.jsx)("h3", {
                        className: "text-uppercase",
                        children: "Nombre d'utilisateurs"
                    }),
                    /*#__PURE__*/ (0, $cKvYK.jsx)("div", {
                        className: "text-primary mt-2",
                        children: stats?.data?.nbUtilisateur
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cKvYK.jsxs)((0, $4DyxQ.default), {
                sm: 12,
                lg: "auto",
                className: "p-3",
                children: [
                    /*#__PURE__*/ (0, $cKvYK.jsx)((0, $469X3.default), {
                        children: /*#__PURE__*/ (0, $cKvYK.jsx)("h2", {
                            className: "connexion-h2 text-uppercase",
                            children: "Dur\xe9es de connexion"
                        })
                    }),
                    /*#__PURE__*/ (0, $cKvYK.jsxs)((0, $469X3.default), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($lgiU2)))((0, (/*@__PURE__*/$parcel$interopDefault($fLUMT))).statsCard, "mt-2"),
                        children: [
                            /*#__PURE__*/ (0, $cKvYK.jsxs)((0, $4DyxQ.default), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($lgiU2)))((0, (/*@__PURE__*/$parcel$interopDefault($fLUMT))).backgroundWhite, "text-text-color rounded-5 mx-3 p-3 p-lg-4 bg-light"),
                                children: [
                                    /*#__PURE__*/ (0, $cKvYK.jsx)("h3", {
                                        className: "text-uppercase text-nowrap",
                                        children: "Moyenne mensuelle"
                                    }),
                                    /*#__PURE__*/ (0, $cKvYK.jsx)("div", {
                                        className: "text-secondary-100",
                                        children: stats?.data?.averageSession
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $cKvYK.jsxs)((0, $4DyxQ.default), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($lgiU2)))((0, (/*@__PURE__*/$parcel$interopDefault($fLUMT))).backgroundWhite, "text-text-color rounded-5 p-3 p-lg-4 mx-3 bg-light"),
                                children: [
                                    /*#__PURE__*/ (0, $cKvYK.jsx)("h3", {
                                        className: "text-uppercase text-nowrap",
                                        children: "La plus longue"
                                    }),
                                    /*#__PURE__*/ (0, $cKvYK.jsx)("div", {
                                        className: "text-secondary-100",
                                        children: stats?.data?.longestSession
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $cKvYK.jsxs)((0, $4DyxQ.default), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($lgiU2)))((0, (/*@__PURE__*/$parcel$interopDefault($fLUMT))).backgroundWhite, "text-text-color rounded-5 p-3 p-lg-4 mx-3 bg-light"),
                                children: [
                                    /*#__PURE__*/ (0, $cKvYK.jsx)("h3", {
                                        className: "text-uppercase text-nowrap",
                                        children: "La plus courte"
                                    }),
                                    /*#__PURE__*/ (0, $cKvYK.jsx)("div", {
                                        className: "text-secondary-100",
                                        children: stats?.data?.shortestSession
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
$1fb2056024a1a10c$var$AccueilAdmin.propTypes = {};
var $1fb2056024a1a10c$export$2e2bcd8739ae039 = $1fb2056024a1a10c$var$AccueilAdmin;

});
parcelRegister("fLUMT", function(module, exports) {

$parcel$export(module.exports, "mainCard", () => $b7b74ba4a61b8aaf$export$1f815cc0a0ee594c, (v) => $b7b74ba4a61b8aaf$export$1f815cc0a0ee594c = v);
$parcel$export(module.exports, "statsCard", () => $b7b74ba4a61b8aaf$export$3aac61c64f881784, (v) => $b7b74ba4a61b8aaf$export$3aac61c64f881784 = v);
var $b7b74ba4a61b8aaf$export$1f815cc0a0ee594c;
var $b7b74ba4a61b8aaf$export$3aac61c64f881784;
$b7b74ba4a61b8aaf$export$1f815cc0a0ee594c = `H9fwRW_mainCard`;
$b7b74ba4a61b8aaf$export$3aac61c64f881784 = `H9fwRW_statsCard`;

});


parcelRegister("5xXVa", function(module, exports) {

$parcel$export(module.exports, "authContent", () => $409e83e744f58278$export$b86fc00ef1734225, (v) => $409e83e744f58278$export$b86fc00ef1734225 = v);
$parcel$export(module.exports, "title", () => $409e83e744f58278$export$fb184b623420d9be, (v) => $409e83e744f58278$export$fb184b623420d9be = v);
var $409e83e744f58278$export$b86fc00ef1734225;
var $409e83e744f58278$export$fb184b623420d9be;
$409e83e744f58278$export$b86fc00ef1734225 = `_ONxPq_authContent`;
$409e83e744f58278$export$fb184b623420d9be = `_ONxPq_title`;

});



parcelRegister("34hg0", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f38633bee5a3065$export$2e2bcd8739ae039);

var $cKvYK = parcelRequire("cKvYK");
parcelRequire("kc00y");

var $eRoc1 = parcelRequire("eRoc1");

var $3UkQK = parcelRequire("3UkQK");

var $8NjjI = parcelRequire("8NjjI");
const $2f38633bee5a3065$var$Footer = ()=>{
    return /*#__PURE__*/ (0, $cKvYK.jsxs)("footer", {
        className: "row col-xs-12 col-lg-10 mx-auto mt-4",
        children: [
            /*#__PURE__*/ (0, $cKvYK.jsx)("div", {
                className: "col-12 col-md-5 text-center",
                children: /*#__PURE__*/ (0, $cKvYK.jsx)((0, $eRoc1.default), {
                    fluid: true,
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($3UkQK))),
                    alt: "Logos Fame et Famirea",
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($8NjjI))).logos
                })
            }),
            /*#__PURE__*/ (0, $cKvYK.jsx)("div", {
                className: "col-12 col-md-2 d-flex text-center align-items-center justify-content-center",
                children: "\xa9 2024 FAMIREA"
            })
        ]
    });
};
var $2f38633bee5a3065$export$2e2bcd8739ae039 = $2f38633bee5a3065$var$Footer;

});
parcelRegister("3UkQK", function(module, exports) {
module.exports = new URL("Fame_par_Famirea.b7313ad3.png", import.meta.url).toString();

});

parcelRegister("8NjjI", function(module, exports) {

$parcel$export(module.exports, "logos", () => $6671e24d616437a1$export$ad200f2ca1a7d990, (v) => $6671e24d616437a1$export$ad200f2ca1a7d990 = v);
var $6671e24d616437a1$export$ad200f2ca1a7d990;
$6671e24d616437a1$export$ad200f2ca1a7d990 = `AWqdvW_logos`;

});


parcelRegister("dKs99", function(module, exports) {
module.exports = new URL("Fame_par_Famirea_Financeur.b446155f.png", import.meta.url).toString();

});

parcelRegister("2rucp", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd1e5a26681ade85$export$2e2bcd8739ae039);

var $cKvYK = parcelRequire("cKvYK");

var $26Ddr = parcelRequire("26Ddr");

var $5TbRy = parcelRequire("5TbRy");

var $jeWlR = parcelRequire("jeWlR");

var $l1428 = parcelRequire("l1428");

var $c99Pn = parcelRequire("c99Pn");
const $dd1e5a26681ade85$var$LivretAccueilRessource = ()=>{
    const ressourcePDF = (0, $26Ddr.useGet)((0, $5TbRy.default)`/api/public/ressource/get-ressource/` + (0, $c99Pn.default), {});
    return /*#__PURE__*/ (0, $cKvYK.jsx)((0, $jeWlR.default), {
        ressource: {
            url: ressourcePDF.data?.url,
            telechargeable: ressourcePDF.data?.telechargeable
        },
        type: (0, $l1428.default).PDF
    });
};
var $dd1e5a26681ade85$export$2e2bcd8739ae039 = $dd1e5a26681ade85$var$LivretAccueilRessource;

});

parcelRegister("8SRog", function(module, exports) {
module.exports = new URL("ligne_ecoute.610a7d99.png", import.meta.url).toString();

});

parcelRegister("dyxDa", function(module, exports) {

$parcel$export(module.exports, "enteteAccueil", () => $9de889afb270c5ca$export$edc569d8354a4b4d, (v) => $9de889afb270c5ca$export$edc569d8354a4b4d = v);
$parcel$export(module.exports, "imgFameFamirea", () => $9de889afb270c5ca$export$7a7d7eb6c0f26241, (v) => $9de889afb270c5ca$export$7a7d7eb6c0f26241 = v);
$parcel$export(module.exports, "login", () => $9de889afb270c5ca$export$596d806903d1f59e, (v) => $9de889afb270c5ca$export$596d806903d1f59e = v);
$parcel$export(module.exports, "sousTitreAccueil", () => $9de889afb270c5ca$export$86f057bfed906573, (v) => $9de889afb270c5ca$export$86f057bfed906573 = v);
$parcel$export(module.exports, "titreAccueil", () => $9de889afb270c5ca$export$64dd14a3424f4498, (v) => $9de889afb270c5ca$export$64dd14a3424f4498 = v);
var $9de889afb270c5ca$export$edc569d8354a4b4d;
var $9de889afb270c5ca$export$7a7d7eb6c0f26241;
var $9de889afb270c5ca$export$596d806903d1f59e;
var $9de889afb270c5ca$export$86f057bfed906573;
var $9de889afb270c5ca$export$64dd14a3424f4498;
$9de889afb270c5ca$export$edc569d8354a4b4d = `fNeB8a_enteteAccueil`;
$9de889afb270c5ca$export$7a7d7eb6c0f26241 = `fNeB8a_imgFameFamirea`;
$9de889afb270c5ca$export$596d806903d1f59e = `fNeB8a_login`;
$9de889afb270c5ca$export$86f057bfed906573 = `fNeB8a_sousTitreAccueil`;
$9de889afb270c5ca$export$64dd14a3424f4498 = `fNeB8a_titreAccueil`;

});


parcelRegister("0ZkzX", function(module, exports) {

});

parcelRegister("b3CnJ", function(module, exports) {

});


//# sourceMappingURL=index.6ab21805.js.map
